/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(682);
	module.exports = __webpack_require__(660);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(135);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13);
	var core = __webpack_require__(55);
	var hide = __webpack_require__(42);
	var redefine = __webpack_require__(43);
	var ctx = __webpack_require__(56);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 4 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(685);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(684);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(239);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(239);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(361);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 8 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1488)();
	}


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports._curry = exports.bsSizes = exports.bsStyles = exports.bsClass = undefined;
	
	var _entries = __webpack_require__(362);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.prefix = prefix;
	exports.getClassSet = getClassSet;
	exports.splitBsProps = splitBsProps;
	exports.splitBsPropsAndOmit = splitBsPropsAndOmit;
	exports.addStyle = addStyle;
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StyleConfig = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function curry(fn) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var last = args[args.length - 1];
	    if (typeof last === 'function') {
	      return fn.apply(undefined, args);
	    }
	    return function (Component) {
	      return fn.apply(undefined, args.concat([Component]));
	    };
	  };
	} // TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.
	
	function prefix(props, variant) {
	  !(props.bsClass != null) ?  false ? (0, _invariant2['default'])(false, 'A `bsClass` prop is required for this component') : (0, _invariant2['default'])(false) : void 0;
	  return props.bsClass + (variant ? '-' + variant : '');
	}
	
	var bsClass = exports.bsClass = curry(function (defaultClass, Component) {
	  var propTypes = Component.propTypes || (Component.propTypes = {});
	  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	
	  propTypes.bsClass = _propTypes2['default'].string;
	  defaultProps.bsClass = defaultClass;
	
	  return Component;
	});
	
	var bsStyles = exports.bsStyles = curry(function (styles, defaultStyle, Component) {
	  if (typeof defaultStyle !== 'string') {
	    Component = defaultStyle;
	    defaultStyle = undefined;
	  }
	
	  var existing = Component.STYLES || [];
	  var propTypes = Component.propTypes || {};
	
	  styles.forEach(function (style) {
	    if (existing.indexOf(style) === -1) {
	      existing.push(style);
	    }
	  });
	
	  var propType = _propTypes2['default'].oneOf(existing);
	
	  // expose the values on the propType function for documentation
	  Component.STYLES = propType._values = existing;
	
	  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
	    bsStyle: propType
	  });
	
	  if (defaultStyle !== undefined) {
	    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	    defaultProps.bsStyle = defaultStyle;
	  }
	
	  return Component;
	});
	
	var bsSizes = exports.bsSizes = curry(function (sizes, defaultSize, Component) {
	  if (typeof defaultSize !== 'string') {
	    Component = defaultSize;
	    defaultSize = undefined;
	  }
	
	  var existing = Component.SIZES || [];
	  var propTypes = Component.propTypes || {};
	
	  sizes.forEach(function (size) {
	    if (existing.indexOf(size) === -1) {
	      existing.push(size);
	    }
	  });
	
	  var values = [];
	  existing.forEach(function (size) {
	    var mappedSize = _StyleConfig.SIZE_MAP[size];
	    if (mappedSize && mappedSize !== size) {
	      values.push(mappedSize);
	    }
	
	    values.push(size);
	  });
	
	  var propType = _propTypes2['default'].oneOf(values);
	  propType._values = values;
	
	  // expose the values on the propType function for documentation
	  Component.SIZES = existing;
	
	  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
	    bsSize: propType
	  });
	
	  if (defaultSize !== undefined) {
	    if (!Component.defaultProps) {
	      Component.defaultProps = {};
	    }
	    Component.defaultProps.bsSize = defaultSize;
	  }
	
	  return Component;
	});
	
	function getClassSet(props) {
	  var _classes;
	
	  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);
	
	  if (props.bsSize) {
	    var bsSize = _StyleConfig.SIZE_MAP[props.bsSize] || props.bsSize;
	    classes[prefix(props, bsSize)] = true;
	  }
	
	  if (props.bsStyle) {
	    classes[prefix(props, props.bsStyle)] = true;
	  }
	
	  return classes;
	}
	
	function getBsProps(props) {
	  return {
	    bsClass: props.bsClass,
	    bsSize: props.bsSize,
	    bsStyle: props.bsStyle,
	    bsRole: props.bsRole
	  };
	}
	
	function isBsProp(propName) {
	  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
	}
	
	function splitBsProps(props) {
	  var elementProps = {};
	  (0, _entries2['default'])(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (!isBsProp(propName)) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	function splitBsPropsAndOmit(props, omittedPropNames) {
	  var isOmittedProp = {};
	  omittedPropNames.forEach(function (propName) {
	    isOmittedProp[propName] = true;
	  });
	
	  var elementProps = {};
	  (0, _entries2['default'])(props).forEach(function (_ref2) {
	    var propName = _ref2[0],
	        propValue = _ref2[1];
	
	    if (!isBsProp(propName) && !isOmittedProp[propName]) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	/**
	 * Add a style variant to a Component. Mutates the propTypes of the component
	 * in order to validate the new variant.
	 */
	function addStyle(Component) {
	  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    styleVariant[_key2 - 1] = arguments[_key2];
	  }
	
	  bsStyles(styleVariant, Component);
	}
	
	var _curry = exports._curry = curry;

/***/ },
/* 11 */
[1728, 18],
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 13 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.viewCoordsType = exports.cityType = exports.cityProps = exports.playerType = exports.playerProps = exports.eventCardType = exports.cardType = exports.cardProps = exports.diseaseType = exports.pathType = exports.locationType = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _diseases = __webpack_require__(83);
	
	var _diseases2 = _interopRequireDefault(_diseases);
	
	var _roles = __webpack_require__(118);
	
	var _roles2 = _interopRequireDefault(_roles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var locationType = exports.locationType = _react.PropTypes.shape({
	  coords: _react.PropTypes.arrayOf(_react.PropTypes.number).isRequired,
	  yellow: _react.PropTypes.number.isRequired,
	  blue: _react.PropTypes.number.isRequired,
	  red: _react.PropTypes.number.isRequired,
	  black: _react.PropTypes.number.isRequired
	});
	
	var pathType = exports.pathType = _react.PropTypes.arrayOf(_react.PropTypes.arrayOf(_react.PropTypes.number.isRequired).isRequired);
	
	var diseaseType = exports.diseaseType = _react.PropTypes.oneOf(_diseases2.default);
	
	var cardProps = exports.cardProps = {
	  cardType: _react.PropTypes.oneOf(['city', 'event', 'epidemic']).isRequired,
	  id: _react.PropTypes.string.isRequired
	};
	
	var cardType = exports.cardType = _react.PropTypes.shape(cardProps);
	
	var eventCardType = exports.eventCardType = _react.PropTypes.shape(_extends({}, cardProps, {
	  name: _react.PropTypes.string.isRequired,
	  playerId: _react.PropTypes.string.isRequired
	}));
	
	var playerProps = exports.playerProps = {
	  id: _react.PropTypes.string.isRequired,
	  name: _react.PropTypes.string.isRequired,
	  role: _react.PropTypes.oneOf(Object.keys(_roles2.default)).isRequired
	};
	
	var playerType = exports.playerType = _react.PropTypes.shape(playerProps);
	
	var cityProps = exports.cityProps = {
	  id: _react.PropTypes.string.isRequired,
	  name: _react.PropTypes.string.isRequired,
	  color: diseaseType.isRequired
	};
	
	var cityType = exports.cityType = _react.PropTypes.shape(cityProps);
	
	var viewCoordsType = exports.viewCoordsType = _react.PropTypes.shape({
	  left: _react.PropTypes.number.isRequired,
	  top: _react.PropTypes.number.isRequired
	});

/***/ },
/* 15 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Browsers, Declaration, Prefixer, utils,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Prefixer = __webpack_require__(139);
	
	  Browsers = __webpack_require__(116);
	
	  utils = __webpack_require__(41);
	
	  Declaration = (function(superClass) {
	    extend(Declaration, superClass);
	
	    function Declaration() {
	      return Declaration.__super__.constructor.apply(this, arguments);
	    }
	
	    Declaration.prototype.check = function(decl) {
	      return true;
	    };
	
	    Declaration.prototype.prefixed = function(prop, prefix) {
	      return prefix + prop;
	    };
	
	    Declaration.prototype.normalize = function(prop) {
	      return prop;
	    };
	
	    Declaration.prototype.otherPrefixes = function(value, prefix) {
	      var j, len, other, ref;
	      ref = Browsers.prefixes();
	      for (j = 0, len = ref.length; j < len; j++) {
	        other = ref[j];
	        if (other === prefix) {
	          continue;
	        }
	        if (value.indexOf(other) !== -1) {
	          return true;
	        }
	      }
	      return false;
	    };
	
	    Declaration.prototype.set = function(decl, prefix) {
	      decl.prop = this.prefixed(decl.prop, prefix);
	      return decl;
	    };
	
	    Declaration.prototype.needCascade = function(decl) {
	      return decl._autoprefixerCascade || (decl._autoprefixerCascade = this.all.options.cascade !== false && decl.raw('before').indexOf('\n') !== -1);
	    };
	
	    Declaration.prototype.maxPrefixed = function(prefixes, decl) {
	      var j, len, max, prefix;
	      if (decl._autoprefixerMax) {
	        return decl._autoprefixerMax;
	      }
	      max = 0;
	      for (j = 0, len = prefixes.length; j < len; j++) {
	        prefix = prefixes[j];
	        prefix = utils.removeNote(prefix);
	        if (prefix.length > max) {
	          max = prefix.length;
	        }
	      }
	      return decl._autoprefixerMax = max;
	    };
	
	    Declaration.prototype.calcBefore = function(prefixes, decl, prefix) {
	      var before, diff, i, j, max, ref;
	      if (prefix == null) {
	        prefix = '';
	      }
	      before = decl.raw('before');
	      max = this.maxPrefixed(prefixes, decl);
	      diff = max - utils.removeNote(prefix).length;
	      for (i = j = 0, ref = diff; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        before += ' ';
	      }
	      return before;
	    };
	
	    Declaration.prototype.restoreBefore = function(decl) {
	      var lines, min;
	      lines = decl.raw('before').split("\n");
	      min = lines[lines.length - 1];
	      this.all.group(decl).up(function(prefixed) {
	        var array, last;
	        array = prefixed.raw('before').split("\n");
	        last = array[array.length - 1];
	        if (last.length < min.length) {
	          return min = last;
	        }
	      });
	      lines[lines.length - 1] = min;
	      return decl.raws.before = lines.join("\n");
	    };
	
	    Declaration.prototype.insert = function(decl, prefix, prefixes) {
	      var already, cloned;
	      cloned = this.set(this.clone(decl), prefix);
	      if (!cloned) {
	        return;
	      }
	      already = decl.parent.some(function(i) {
	        return i.prop === cloned.prop && i.value === cloned.value;
	      });
	      if (already) {
	        return;
	      }
	      if (this.needCascade(decl)) {
	        cloned.raws.before = this.calcBefore(prefixes, decl, prefix);
	      }
	      return decl.parent.insertBefore(decl, cloned);
	    };
	
	    Declaration.prototype.isAlready = function(decl, prefixed) {
	      var already;
	      already = this.all.group(decl).up(function(i) {
	        return i.prop === prefixed;
	      });
	      already || (already = this.all.group(decl).down(function(i) {
	        return i.prop === prefixed;
	      }));
	      return already;
	    };
	
	    Declaration.prototype.add = function(decl, prefix, prefixes) {
	      var prefixed;
	      prefixed = this.prefixed(decl.prop, prefix);
	      if (this.isAlready(decl, prefixed) || this.otherPrefixes(decl.value, prefix)) {
	        return;
	      }
	      return this.insert(decl, prefix, prefixes);
	    };
	
	    Declaration.prototype.process = function(decl) {
	      var prefixes;
	      if (this.needCascade(decl)) {
	        prefixes = Declaration.__super__.process.apply(this, arguments);
	        if (prefixes != null ? prefixes.length : void 0) {
	          this.restoreBefore(decl);
	          return decl.raws.before = this.calcBefore(prefixes, decl);
	        }
	      } else {
	        return Declaration.__super__.process.apply(this, arguments);
	      }
	    };
	
	    Declaration.prototype.old = function(prop, prefix) {
	      return [this.prefixed(prop, prefix)];
	    };
	
	    return Declaration;
	
	  })(Prefixer);
	
	  module.exports = Declaration;
	
	}).call(this);


/***/ },
/* 18 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 19 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(66);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.20';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }
	
	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }
	
	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(138)(module)))

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(228);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  if (propType !== 'function' && propType !== 'string') {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.utils = exports.Well = exports.Tooltip = exports.Thumbnail = exports.Tabs = exports.TabPane = exports.Table = exports.TabContent = exports.TabContainer = exports.Tab = exports.SplitButton = exports.SafeAnchor = exports.Row = exports.ResponsiveEmbed = exports.Radio = exports.ProgressBar = exports.Popover = exports.PanelGroup = exports.Panel = exports.PaginationButton = exports.Pagination = exports.Pager = exports.PageItem = exports.PageHeader = exports.OverlayTrigger = exports.Overlay = exports.NavItem = exports.NavDropdown = exports.NavbarBrand = exports.Navbar = exports.Nav = exports.ModalTitle = exports.ModalHeader = exports.ModalFooter = exports.ModalBody = exports.Modal = exports.MenuItem = exports.Media = exports.ListGroupItem = exports.ListGroup = exports.Label = exports.Jumbotron = exports.InputGroup = exports.Image = exports.HelpBlock = exports.Grid = exports.Glyphicon = exports.FormGroup = exports.FormControl = exports.Form = exports.Fade = exports.DropdownButton = exports.Dropdown = exports.Collapse = exports.Col = exports.ControlLabel = exports.Clearfix = exports.Checkbox = exports.CarouselItem = exports.Carousel = exports.ButtonToolbar = exports.ButtonGroup = exports.Button = exports.BreadcrumbItem = exports.Breadcrumb = exports.Badge = exports.Alert = exports.Accordion = undefined;
	
	var _Accordion2 = __webpack_require__(1492);
	
	var _Accordion3 = _interopRequireDefault(_Accordion2);
	
	var _Alert2 = __webpack_require__(1493);
	
	var _Alert3 = _interopRequireDefault(_Alert2);
	
	var _Badge2 = __webpack_require__(1494);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	var _Breadcrumb2 = __webpack_require__(1495);
	
	var _Breadcrumb3 = _interopRequireDefault(_Breadcrumb2);
	
	var _BreadcrumbItem2 = __webpack_require__(468);
	
	var _BreadcrumbItem3 = _interopRequireDefault(_BreadcrumbItem2);
	
	var _Button2 = __webpack_require__(170);
	
	var _Button3 = _interopRequireDefault(_Button2);
	
	var _ButtonGroup2 = __webpack_require__(469);
	
	var _ButtonGroup3 = _interopRequireDefault(_ButtonGroup2);
	
	var _ButtonToolbar2 = __webpack_require__(1496);
	
	var _ButtonToolbar3 = _interopRequireDefault(_ButtonToolbar2);
	
	var _Carousel2 = __webpack_require__(1497);
	
	var _Carousel3 = _interopRequireDefault(_Carousel2);
	
	var _CarouselItem2 = __webpack_require__(470);
	
	var _CarouselItem3 = _interopRequireDefault(_CarouselItem2);
	
	var _Checkbox2 = __webpack_require__(1499);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Clearfix2 = __webpack_require__(1500);
	
	var _Clearfix3 = _interopRequireDefault(_Clearfix2);
	
	var _ControlLabel2 = __webpack_require__(1502);
	
	var _ControlLabel3 = _interopRequireDefault(_ControlLabel2);
	
	var _Col2 = __webpack_require__(1501);
	
	var _Col3 = _interopRequireDefault(_Col2);
	
	var _Collapse2 = __webpack_require__(321);
	
	var _Collapse3 = _interopRequireDefault(_Collapse2);
	
	var _Dropdown2 = __webpack_require__(217);
	
	var _Dropdown3 = _interopRequireDefault(_Dropdown2);
	
	var _DropdownButton2 = __webpack_require__(1503);
	
	var _DropdownButton3 = _interopRequireDefault(_DropdownButton2);
	
	var _Fade2 = __webpack_require__(218);
	
	var _Fade3 = _interopRequireDefault(_Fade2);
	
	var _Form2 = __webpack_require__(1505);
	
	var _Form3 = _interopRequireDefault(_Form2);
	
	var _FormControl2 = __webpack_require__(1506);
	
	var _FormControl3 = _interopRequireDefault(_FormControl2);
	
	var _FormGroup2 = __webpack_require__(1509);
	
	var _FormGroup3 = _interopRequireDefault(_FormGroup2);
	
	var _Glyphicon2 = __webpack_require__(322);
	
	var _Glyphicon3 = _interopRequireDefault(_Glyphicon2);
	
	var _Grid2 = __webpack_require__(472);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _HelpBlock2 = __webpack_require__(1510);
	
	var _HelpBlock3 = _interopRequireDefault(_HelpBlock2);
	
	var _Image2 = __webpack_require__(1511);
	
	var _Image3 = _interopRequireDefault(_Image2);
	
	var _InputGroup2 = __webpack_require__(1512);
	
	var _InputGroup3 = _interopRequireDefault(_InputGroup2);
	
	var _Jumbotron2 = __webpack_require__(1515);
	
	var _Jumbotron3 = _interopRequireDefault(_Jumbotron2);
	
	var _Label2 = __webpack_require__(1516);
	
	var _Label3 = _interopRequireDefault(_Label2);
	
	var _ListGroup2 = __webpack_require__(1517);
	
	var _ListGroup3 = _interopRequireDefault(_ListGroup2);
	
	var _ListGroupItem2 = __webpack_require__(473);
	
	var _ListGroupItem3 = _interopRequireDefault(_ListGroupItem2);
	
	var _Media2 = __webpack_require__(323);
	
	var _Media3 = _interopRequireDefault(_Media2);
	
	var _MenuItem2 = __webpack_require__(1524);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	var _Modal2 = __webpack_require__(1525);
	
	var _Modal3 = _interopRequireDefault(_Modal2);
	
	var _ModalBody2 = __webpack_require__(474);
	
	var _ModalBody3 = _interopRequireDefault(_ModalBody2);
	
	var _ModalFooter2 = __webpack_require__(475);
	
	var _ModalFooter3 = _interopRequireDefault(_ModalFooter2);
	
	var _ModalHeader2 = __webpack_require__(476);
	
	var _ModalHeader3 = _interopRequireDefault(_ModalHeader2);
	
	var _ModalTitle2 = __webpack_require__(477);
	
	var _ModalTitle3 = _interopRequireDefault(_ModalTitle2);
	
	var _Nav2 = __webpack_require__(478);
	
	var _Nav3 = _interopRequireDefault(_Nav2);
	
	var _Navbar2 = __webpack_require__(1528);
	
	var _Navbar3 = _interopRequireDefault(_Navbar2);
	
	var _NavbarBrand2 = __webpack_require__(480);
	
	var _NavbarBrand3 = _interopRequireDefault(_NavbarBrand2);
	
	var _NavDropdown2 = __webpack_require__(1527);
	
	var _NavDropdown3 = _interopRequireDefault(_NavDropdown2);
	
	var _NavItem2 = __webpack_require__(479);
	
	var _NavItem3 = _interopRequireDefault(_NavItem2);
	
	var _Overlay2 = __webpack_require__(481);
	
	var _Overlay3 = _interopRequireDefault(_Overlay2);
	
	var _OverlayTrigger2 = __webpack_require__(1532);
	
	var _OverlayTrigger3 = _interopRequireDefault(_OverlayTrigger2);
	
	var _PageHeader2 = __webpack_require__(1533);
	
	var _PageHeader3 = _interopRequireDefault(_PageHeader2);
	
	var _PageItem2 = __webpack_require__(1534);
	
	var _PageItem3 = _interopRequireDefault(_PageItem2);
	
	var _Pager2 = __webpack_require__(1535);
	
	var _Pager3 = _interopRequireDefault(_Pager2);
	
	var _Pagination2 = __webpack_require__(1536);
	
	var _Pagination3 = _interopRequireDefault(_Pagination2);
	
	var _PaginationButton2 = __webpack_require__(483);
	
	var _PaginationButton3 = _interopRequireDefault(_PaginationButton2);
	
	var _Panel2 = __webpack_require__(1537);
	
	var _Panel3 = _interopRequireDefault(_Panel2);
	
	var _PanelGroup2 = __webpack_require__(484);
	
	var _PanelGroup3 = _interopRequireDefault(_PanelGroup2);
	
	var _Popover2 = __webpack_require__(1538);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _ProgressBar2 = __webpack_require__(1539);
	
	var _ProgressBar3 = _interopRequireDefault(_ProgressBar2);
	
	var _Radio2 = __webpack_require__(1540);
	
	var _Radio3 = _interopRequireDefault(_Radio2);
	
	var _ResponsiveEmbed2 = __webpack_require__(1541);
	
	var _ResponsiveEmbed3 = _interopRequireDefault(_ResponsiveEmbed2);
	
	var _Row2 = __webpack_require__(1542);
	
	var _Row3 = _interopRequireDefault(_Row2);
	
	var _SafeAnchor2 = __webpack_require__(69);
	
	var _SafeAnchor3 = _interopRequireDefault(_SafeAnchor2);
	
	var _SplitButton2 = __webpack_require__(1543);
	
	var _SplitButton3 = _interopRequireDefault(_SplitButton2);
	
	var _Tab2 = __webpack_require__(1545);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _TabContainer2 = __webpack_require__(324);
	
	var _TabContainer3 = _interopRequireDefault(_TabContainer2);
	
	var _TabContent2 = __webpack_require__(325);
	
	var _TabContent3 = _interopRequireDefault(_TabContent2);
	
	var _Table2 = __webpack_require__(1546);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TabPane2 = __webpack_require__(485);
	
	var _TabPane3 = _interopRequireDefault(_TabPane2);
	
	var _Tabs2 = __webpack_require__(1547);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Thumbnail2 = __webpack_require__(1548);
	
	var _Thumbnail3 = _interopRequireDefault(_Thumbnail2);
	
	var _Tooltip2 = __webpack_require__(1549);
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	var _Well2 = __webpack_require__(1550);
	
	var _Well3 = _interopRequireDefault(_Well2);
	
	var _utils2 = __webpack_require__(1554);
	
	var _utils = _interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.Accordion = _Accordion3['default'];
	exports.Alert = _Alert3['default'];
	exports.Badge = _Badge3['default'];
	exports.Breadcrumb = _Breadcrumb3['default'];
	exports.BreadcrumbItem = _BreadcrumbItem3['default'];
	exports.Button = _Button3['default'];
	exports.ButtonGroup = _ButtonGroup3['default'];
	exports.ButtonToolbar = _ButtonToolbar3['default'];
	exports.Carousel = _Carousel3['default'];
	exports.CarouselItem = _CarouselItem3['default'];
	exports.Checkbox = _Checkbox3['default'];
	exports.Clearfix = _Clearfix3['default'];
	exports.ControlLabel = _ControlLabel3['default'];
	exports.Col = _Col3['default'];
	exports.Collapse = _Collapse3['default'];
	exports.Dropdown = _Dropdown3['default'];
	exports.DropdownButton = _DropdownButton3['default'];
	exports.Fade = _Fade3['default'];
	exports.Form = _Form3['default'];
	exports.FormControl = _FormControl3['default'];
	exports.FormGroup = _FormGroup3['default'];
	exports.Glyphicon = _Glyphicon3['default'];
	exports.Grid = _Grid3['default'];
	exports.HelpBlock = _HelpBlock3['default'];
	exports.Image = _Image3['default'];
	exports.InputGroup = _InputGroup3['default'];
	exports.Jumbotron = _Jumbotron3['default'];
	exports.Label = _Label3['default'];
	exports.ListGroup = _ListGroup3['default'];
	exports.ListGroupItem = _ListGroupItem3['default'];
	exports.Media = _Media3['default'];
	exports.MenuItem = _MenuItem3['default'];
	exports.Modal = _Modal3['default'];
	exports.ModalBody = _ModalBody3['default'];
	exports.ModalFooter = _ModalFooter3['default'];
	exports.ModalHeader = _ModalHeader3['default'];
	exports.ModalTitle = _ModalTitle3['default'];
	exports.Nav = _Nav3['default'];
	exports.Navbar = _Navbar3['default'];
	exports.NavbarBrand = _NavbarBrand3['default'];
	exports.NavDropdown = _NavDropdown3['default'];
	exports.NavItem = _NavItem3['default'];
	exports.Overlay = _Overlay3['default'];
	exports.OverlayTrigger = _OverlayTrigger3['default'];
	exports.PageHeader = _PageHeader3['default'];
	exports.PageItem = _PageItem3['default'];
	exports.Pager = _Pager3['default'];
	exports.Pagination = _Pagination3['default'];
	exports.PaginationButton = _PaginationButton3['default'];
	exports.Panel = _Panel3['default'];
	exports.PanelGroup = _PanelGroup3['default'];
	exports.Popover = _Popover3['default'];
	exports.ProgressBar = _ProgressBar3['default'];
	exports.Radio = _Radio3['default'];
	exports.ResponsiveEmbed = _ResponsiveEmbed3['default'];
	exports.Row = _Row3['default'];
	exports.SafeAnchor = _SafeAnchor3['default'];
	exports.SplitButton = _SplitButton3['default'];
	exports.Tab = _Tab3['default'];
	exports.TabContainer = _TabContainer3['default'];
	exports.TabContent = _TabContent3['default'];
	exports.Table = _Table3['default'];
	exports.TabPane = _TabPane3['default'];
	exports.Tabs = _Tabs3['default'];
	exports.Thumbnail = _Thumbnail3['default'];
	exports.Tooltip = _Tooltip3['default'];
	exports.Well = _Well3['default'];
	exports.utils = _utils;

/***/ },
/* 24 */
[1770, 150, 107, 13],
/* 25 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PLAYER_MOVE_INIT = exports.PLAYER_MOVE_INIT = 'PLAYER_MOVE_INIT';
	var PLAYER_MOVE_SHOW_CITIES = exports.PLAYER_MOVE_SHOW_CITIES = 'PLAYER_MOVE_SHOW_CITIES';
	var PLAYER_MOVE_TO_CITY = exports.PLAYER_MOVE_TO_CITY = 'PLAYER_MOVE_TO_CITY';
	var PLAYER_MOVE_CANCEL = exports.PLAYER_MOVE_CANCEL = 'PLAYER_MOVE_CANCEL';
	var PLAYER_MOVE_COMPLETE = exports.PLAYER_MOVE_COMPLETE = 'PLAYER_MOVE_COMPLETE';
	
	var PLAYER_BUILD_STATION = exports.PLAYER_BUILD_STATION = 'PLAYER_BUILD_STATION';
	
	var PLAYER_TREAT_DISEASE = exports.PLAYER_TREAT_DISEASE = 'PLAYER_TREAT_DISEASE';
	var PLAYER_TREAT_ALL_DISEASE = exports.PLAYER_TREAT_ALL_DISEASE = 'PLAYER_TREAT_ALL_DISEASE';
	var PLAYER_CURE_DISEASE_INIT = exports.PLAYER_CURE_DISEASE_INIT = 'PLAYER_CURE_DISEASE_INIT';
	var PLAYER_CURE_DISEASE_SHOW_CARDS = exports.PLAYER_CURE_DISEASE_SHOW_CARDS = 'PLAYER_CURE_DISEASE_SHOW_CARDS';
	var PLAYER_CURE_DISEASE_CANCEL = exports.PLAYER_CURE_DISEASE_CANCEL = 'PLAYER_CURE_DISEASE_CANCEL';
	var PLAYER_CURE_DISEASE_COMPLETE = exports.PLAYER_CURE_DISEASE_COMPLETE = 'PLAYER_CURE_DISEASE_COMPLETE';
	var PLAYER_SHARE_INIT = exports.PLAYER_SHARE_INIT = 'PLAYER_SHARE_INIT';
	var PLAYER_SHARE_SHOW_CANDIDATES = exports.PLAYER_SHARE_SHOW_CANDIDATES = 'PLAYER_SHARE_SHOW_CANDIDATES';
	var PLAYER_SHARE_CARD = exports.PLAYER_SHARE_CARD = 'PLAYER_SHARE_CARD';
	var PLAYER_SHARE_CANCEL = exports.PLAYER_SHARE_CANCEL = 'PLAYER_SHARE_CANCEL';
	
	var PLAYER_PLAY_EVENT_INIT = exports.PLAYER_PLAY_EVENT_INIT = 'PLAYER_PLAY_EVENT_INIT';
	
	var EVENT_ONE_QUIET_NIGHT_SKIP = exports.EVENT_ONE_QUIET_NIGHT_SKIP = 'EVENT_ONE_QUIET_NIGHT_SKIP';
	var EVENT_GOV_GRANT_SHOW_CITIES = exports.EVENT_GOV_GRANT_SHOW_CITIES = 'EVENT_GOV_GRANT_SHOW_CITIES';
	var EVENT_GOV_GRANT_BUILD_STATION = exports.EVENT_GOV_GRANT_BUILD_STATION = 'EVENT_GOV_GRANT_BUILD_STATION';
	var EVENT_FORECAST_SHOW_CARDS = exports.EVENT_FORECAST_SHOW_CARDS = 'EVENT_FORECAST_SHOW_CARDS';
	var EVENT_FORECAST_SHUFFLE = exports.EVENT_FORECAST_SHUFFLE = 'EVENT_FORECAST_SHUFFLE';
	var EVENT_RES_POP_REMOVE_CARD = exports.EVENT_RES_POP_REMOVE_CARD = 'EVENT_RES_POP_REMOVE_CARD';
	var EVENT_RES_POP_SUGGEST = exports.EVENT_RES_POP_SUGGEST = 'EVENT_RES_POP_SUGGEST';
	var EVENT_AIRLIFT_CHOOSE_PLAYER = exports.EVENT_AIRLIFT_CHOOSE_PLAYER = 'EVENT_AIRLIFT_CHOOSE_PLAYER';
	var EVENT_AIRLIFT_SHOW_CITIES = exports.EVENT_AIRLIFT_SHOW_CITIES = 'EVENT_AIRLIFT_SHOW_CITIES';
	var EVENT_AIRLIFT_MOVE_TO_CITY = exports.EVENT_AIRLIFT_MOVE_TO_CITY = 'EVENT_AIRLIFT_MOVE_TO_CITY';
	
	var MEDIC_TREAT_CURED_DISEASES = exports.MEDIC_TREAT_CURED_DISEASES = 'MEDIC_TREAT_CURED_DISEASES';
	var MEDIC_PREVENT_INFECTION = exports.MEDIC_PREVENT_INFECTION = 'MEDIC_PREVENT_INFECTION';
	
	var OPS_SHOW_CARDS_TO_DISCARD = exports.OPS_SHOW_CARDS_TO_DISCARD = 'OPS_SHOW_CARDS_TO_DISCARD';
	var OPS_CHOOSE_CARD_TO_DISCARD = exports.OPS_CHOOSE_CARD_TO_DISCARD = 'OPS_CHOOSE_CARD_TO_DISCARD';
	
	var CONT_PLANNER_INIT = exports.CONT_PLANNER_INIT = 'CONT_PLANNER_INIT';
	var CONT_PLANNER_SHOW_EVENTS_FROM_DISCARD = exports.CONT_PLANNER_SHOW_EVENTS_FROM_DISCARD = 'CONT_PLANNER_SHOW_EVENTS_FROM_DISCARD';
	var CONT_PLANNER_CHOOSE_EVENT = exports.CONT_PLANNER_CHOOSE_EVENT = 'CONT_PLANNER_CHOOSE_EVENT';
	var CONT_PLANNER_EVENT_COMPLETE = exports.CONT_PLANNER_EVENT_COMPLETE = 'CONT_PLANNER_EVENT_COMPLETE';
	
	var QUAR_SPEC_PREVENT_INFECTION = exports.QUAR_SPEC_PREVENT_INFECTION = 'QUAR_SPEC_PREVENT_INFECTION';
	
	var DISPATCHER_CHOOSE_PLAYER = exports.DISPATCHER_CHOOSE_PLAYER = 'DISPATCHER_CHOOSE_PLAYER';
	var DISPATCHER_SHOW_CITIES = exports.DISPATCHER_SHOW_CITIES = 'DISPATCHER_SHOW_CITIES';
	
	var ERADICATE_DISEASE = exports.ERADICATE_DISEASE = 'ERADICATE_DISEASE';
	
	var CARD_DISCARD_FROM_HAND_INIT = exports.CARD_DISCARD_FROM_HAND_INIT = 'CARD_DISCARD_FROM_HAND_INIT';
	var CARD_DRAW_CARDS_INIT = exports.CARD_DRAW_CARDS_INIT = 'CARD_DRAW_CARDS_INIT';
	var CARD_DRAW_CARDS_HANDLE_INIT = exports.CARD_DRAW_CARDS_HANDLE_INIT = 'CARD_DRAW_CARDS_HANDLE_INIT';
	var CARD_DRAW_CARDS_HANDLE = exports.CARD_DRAW_CARDS_HANDLE = 'CARD_DRAW_CARDS_HANDLE';
	var CARD_DISCARD_FROM_INFECTION_DECK_BOTTOM = exports.CARD_DISCARD_FROM_INFECTION_DECK_BOTTOM = 'CARD_DISCARD_FROM_INFECTION_DECK_BOTTOM';
	var CARD_DISCARD_FROM_INFECTION_DECK_TOP = exports.CARD_DISCARD_FROM_INFECTION_DECK_TOP = 'CARD_DISCARD_FROM_INFECTION_DECK_TOP';
	var CARD_OVER_LIMIT_DISCARD_INIT = exports.CARD_OVER_LIMIT_DISCARD_INIT = 'CARD_OVER_LIMIT_DISCARD_INIT';
	var CARD_OVER_LIMIT_DISCARD_COMPLETE = exports.CARD_OVER_LIMIT_DISCARD_COMPLETE = 'CARD_OVER_LIMIT_DISCARD_COMPLETE';
	var CARD_DRAW_INFECTION_CARD = exports.CARD_DRAW_INFECTION_CARD = 'CARD_DRAW_INFECTION_CARD';
	
	var OUTBREAK_INIT = exports.OUTBREAK_INIT = 'OUTBREAK_INIT';
	var INFECT_CITY = exports.INFECT_CITY = 'INFECT_CITY';
	var INFECT_NEIGHBOR = exports.INFECT_NEIGHBOR = 'INFECT_NEIGHBOR';
	var OUTBREAK_COMPLETE = exports.OUTBREAK_COMPLETE = 'OUTBREAK_COMPLETE';
	var OUTBREAK_QUEUE = exports.OUTBREAK_QUEUE = 'OUTBREAK_QUEUE';
	var INFECT_CITIES = exports.INFECT_CITIES = 'INFECT_CITIES';
	
	var USE_DISEASE_CUBES = exports.USE_DISEASE_CUBES = 'USE_DISEASE_CUBES';
	
	var EPIDEMIC_INCREASE = exports.EPIDEMIC_INCREASE = 'EPIDEMIC_INCREASE';
	var EPIDEMIC_INFECT_INIT = exports.EPIDEMIC_INFECT_INIT = 'EPIDEMIC_INFECT_INIT';
	var EPIDEMIC_INTENSIFY_INIT = exports.EPIDEMIC_INTENSIFY_INIT = 'EPIDEMIC_INTENSIFY_INIT';
	var EPIDEMIC_INTENSIFY_CONTINUE = exports.EPIDEMIC_INTENSIFY_CONTINUE = 'EPIDEMIC_INTENSIFY_CONTINUE';
	var EPIDEMIC_INTENSIFY = exports.EPIDEMIC_INTENSIFY = 'EPIDEMIC_INTENSIFY';
	
	var ANIMATION_MOVE_COMPLETE = exports.ANIMATION_MOVE_COMPLETE = 'ANIMATION_MOVE_COMPLETE';
	var ANIMATION_DRAW_CARDS_INIT_COMPLETE = exports.ANIMATION_DRAW_CARDS_INIT_COMPLETE = 'ANIMATION_DRAW_CARDS_INIT_COMPLETE';
	var ANIMATION_DRAW_INFECTION_CARD_COMPLETE = exports.ANIMATION_DRAW_INFECTION_CARD_COMPLETE = 'ANIMATION_DRAW_INFECTION_CARD_COMPLETE';
	var ANIMATION_INFECT_NEIGHBOR_COMPLETE = exports.ANIMATION_INFECT_NEIGHBOR_COMPLETE = 'ANIMATION_INFECT_NEIGHBOR_COMPLETE';
	var ANIMATION_DEAL_CARDS_INIT_COMPLETE = exports.ANIMATION_DEAL_CARDS_INIT_COMPLETE = 'ANIMATION_DEAL_CARDS_INIT_COMPLETE';
	var ANIMATION_DEAL_CARDS_COMPLETE = exports.ANIMATION_DEAL_CARDS_COMPLETE = 'ANIMATION_DEAL_CARDS_COMPLETE';
	var ANIMATION_INSERT_EPIDEMIC_CARDS_COMPLETE = exports.ANIMATION_INSERT_EPIDEMIC_CARDS_COMPLETE = 'ANIMATION_INSERT_EPIDEMIC_CARDS_COMPLETE';
	var ANIMATION_CARD_DISCARD_FROM_HAND_COMPLETE = exports.ANIMATION_CARD_DISCARD_FROM_HAND_COMPLETE = 'ANIMATION_CARD_DISCARD_FROM_HAND_COMPLETE';
	var ANIMATION_EPIDEMIC_INFECT_COMPLETE = exports.ANIMATION_EPIDEMIC_INFECT_COMPLETE = 'ANIMATION_EPIDEMIC_INFECT_COMPLETE';
	var ANIMATION_CURE_DISEASE_COMPLETE = exports.ANIMATION_CURE_DISEASE_COMPLETE = 'ANIMATION_CURE_DISEASE_COMPLETE';
	
	var CREATE_QUICK_GAME_INIT = exports.CREATE_QUICK_GAME_INIT = 'CREATE_QUICK_GAME_INIT';
	var CREATE_CUSTOM_GAME_INIT = exports.CREATE_CUSTOM_GAME_INIT = 'CREATE_CUSTOM_GAME_INIT';
	var CREATE_GAME = exports.CREATE_GAME = 'CREATE_GAME';
	var DEAL_CARDS_INIT = exports.DEAL_CARDS_INIT = 'DEAL_CARDS_INIT';
	var DEAL_CARDS = exports.DEAL_CARDS = 'DEAL_CARDS';
	var INSERT_EPIDEMIC_CARDS_INIT = exports.INSERT_EPIDEMIC_CARDS_INIT = 'INSERT_EPIDEMIC_CARDS_INIT';
	var INSERT_PLAYER_CARD = exports.INSERT_PLAYER_CARD = 'INSERT_PLAYER_CARD';
	var START_GAME = exports.START_GAME = 'START_GAME';
	var PASS_TURN = exports.PASS_TURN = 'PASS_TURN';
	var VICTORY = exports.VICTORY = 'VICTORY';
	var DEFEAT = exports.DEFEAT = 'DEFEAT';
	var CONTINUE = exports.CONTINUE = 'CONTINUE';
	
	var ACTIONS = exports.ACTIONS = [PLAYER_MOVE_COMPLETE, PLAYER_BUILD_STATION, ANIMATION_CURE_DISEASE_COMPLETE, PLAYER_TREAT_DISEASE, PLAYER_TREAT_ALL_DISEASE, PLAYER_SHARE_CARD, CONT_PLANNER_CHOOSE_EVENT];

/***/ },
/* 26 */
[1765, 58],
/* 27 */
[1733, 15],
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1589);


/***/ },
/* 29 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ },
/* 30 */
[1749, 11, 384, 65, 27],
/* 31 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var DOMProperty = __webpack_require__(132);
	var ReactDOMComponentFlags = __webpack_require__(498);
	
	var invariant = __webpack_require__(12);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 33 */
[1766, 63],
/* 34 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (f) {
	    return f != null;
	  }).reduce(function (acc, f) {
	    if (typeof f !== 'function') {
	      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
	    }
	
	    if (acc === null) {
	      return f;
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      f.apply(this, args);
	    };
	  }, null);
	}
	
	exports['default'] = createChainedFunction;
	module.exports = exports['default'];

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 36 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var Size = exports.Size = {
	  LARGE: 'large',
	  SMALL: 'small',
	  XSMALL: 'xsmall'
	};
	
	var SIZE_MAP = exports.SIZE_MAP = {
	  large: 'lg',
	  medium: 'md',
	  small: 'sm',
	  xsmall: 'xs',
	  lg: 'lg',
	  md: 'md',
	  sm: 'sm',
	  xs: 'xs'
	};
	
	var DEVICE_SIZES = exports.DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
	
	var State = exports.State = {
	  SUCCESS: 'success',
	  WARNING: 'warning',
	  DANGER: 'danger',
	  INFO: 'info'
	};
	
	var Style = exports.Style = {
	  DEFAULT: 'default',
	  PRIMARY: 'primary',
	  LINK: 'link',
	  INVERSE: 'inverse'
	};

/***/ },
/* 37 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  status: 'prepare',
	  defeatMessage: null,
	  difficulty: null,
	
	  dealingCards: {},
	  initialInfectedCity: null,
	
	  playerCards: {
	    deck: [{ cardType: 'city', id: '30' }, { cardType: 'city', id: '36' }, { cardType: 'epidemic', id: 'epidemic' }],
	    discard: [{ cardType: 'event', id: 'one_quiet_night' }, { cardType: 'event', id: 'gov_grant' }, { cardType: 'epidemic', id: 'epidemic' }]
	  },
	
	  infectionCards: {
	    deck: ['0', '7', '8', '5', '6', '1', '3'],
	    discard: ['4', '2']
	  },
	
	  players: {
	    /*0: {
	      id: '0',
	      name: 'Stephen',
	      role: 'dispatcher',
	      specialEvent: null,
	      hand: [
	        { cardType: 'event', id: 'forecast' },
	        { cardType: 'city', id: '0' },
	        { cardType: 'city', id: '3' },
	        { cardType: 'city', id: '2' },
	        { cardType: 'city', id: '5' },
	        { cardType: 'city', id: '42' }
	      ]
	    },
	    1: {
	      id: '1',
	      name: 'Rima',
	      role: 'ops_expert',
	      hand: [
	        { cardType: 'event', id: 'res_pop' },
	        { cardType: 'city', id: '4' },
	        { cardType: 'city', id: '1' },
	        { cardType: 'city', id: '6' },
	        { cardType: 'city', id: '8' },
	        { cardType: 'city', id: '7' }
	      ]
	    },
	    2: {
	      id: '2',
	      name: 'Thomas',
	      role: 'researcher',
	      hand: [
	        { cardType: 'city', id: '11' },
	        { cardType: 'city', id: '10' },
	        { cardType: 'city', id: '13' },
	        { cardType: 'city', id: '12' },
	        { cardType: 'city', id: '15' }
	      ]
	    },
	    3: {
	      id: '3',
	      name: 'Paul',
	      role: 'cont_planner',
	      hand: [
	        { cardType: 'city', id: '24' },
	        { cardType: 'city', id: '20' },
	        { cardType: 'city', id: '23' },
	        { cardType: 'city', id: '22' },
	        { cardType: 'city', id: '25' }
	      ]
	    }*/
	  },
	
	  diseases: {
	    red: 'active',
	    blue: 'active',
	    yellow: 'active',
	    black: 'active'
	  },
	
	  currentMove: {
	    player: null,
	    availableCities: {},
	    shareCandidates: [],
	    actionsLeft: 4,
	    cardsDrawn: [],
	    infectionCardDrawn: {},
	    discardingCard: {},
	    epidemicStep: null,
	    epidemicInfectionCard: {},
	    outbreak: {
	      color: null,
	      complete: [],
	      pending: [],
	      infectingCube: {}
	    },
	    playerToDiscard: null,
	    playerToMove: null,
	    curingDisease: {},
	    skipInfectionsStep: false,
	    govGrantCities: [],
	    resPop: {},
	    forecastCards: [],
	    airlift: {},
	    opsMoveAbility: {
	      used: false,
	      cards: []
	    },
	    contPlannerEvents: [],
	    continueMessage: null
	  },
	
	  stationsLeft: 5,
	
	  cubesLeft: {
	    red: 24,
	    blue: 24,
	    yellow: 24,
	    black: 24
	  },
	
	  infectionRate: {
	    values: [2, 2, 2, 3, 3, 4, 4],
	    index: 0
	  },
	
	  outbreaks: 0,
	
	  map: {
	    matrix: [[0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0], [1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 1, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 1, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 1, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 1, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1], [0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 1, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 1, 0, 1, 0], [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 0, 0, 0, 1], [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 1, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0]],
	
	    playersLocations: {
	      /*0: '2',
	      1: '2',
	      2: '2',
	      3: '2'*/
	    },
	
	    locations: {
	      0: {
	        coords: [250, 205],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      1: {
	        coords: [200, 320],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      2: {
	        coords: [265, 350],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0,
	        station: true
	      },
	      3: {
	        coords: [185, 410],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      4: {
	        coords: [255, 445],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      5: {
	        coords: [205, 475],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      6: {
	        coords: [240, 660],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      7: {
	        coords: [175, 665],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      8: {
	        coords: [205, 720],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      9: {
	        coords: [155, 755],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      10: {
	        coords: [215, 780],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      11: {
	        coords: [140, 835],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      12: {
	        coords: [320, 215],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      13: {
	        coords: [345, 305],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      14: {
	        coords: [445, 370],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      15: {
	        coords: [510, 420],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      16: {
	        coords: [390, 420],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      17: {
	        coords: [310, 425],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      18: {
	        coords: [560, 485],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      19: {
	        coords: [510, 530],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      20: {
	        coords: [385, 695],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      21: {
	        coords: [435, 760],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      22: {
	        coords: [535, 815],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      23: {
	        coords: [390, 840],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      24: {
	        coords: [275, 710],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      25: {
	        coords: [300, 830],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      26: {
	        coords: [245, 845],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      27: {
	        coords: [270, 895],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      28: {
	        coords: [350, 920],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      29: {
	        coords: [200, 900],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      30: {
	        coords: [245, 955],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      31: {
	        coords: [310, 970],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      32: {
	        coords: [360, 990],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      33: {
	        coords: [285, 1030],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      34: {
	        coords: [375, 1040],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      35: {
	        coords: [315, 1085],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      36: {
	        coords: [440, 1095],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      37: {
	        coords: [365, 1115],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      38: {
	        coords: [220, 1145],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      39: {
	        coords: [285, 1170],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      40: {
	        coords: [345, 1175],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      41: {
	        coords: [425, 1185],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      42: {
	        coords: [205, 1220],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      43: {
	        coords: [320, 1230],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      44: {
	        coords: [405, 1255],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      45: {
	        coords: [225, 1270],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      46: {
	        coords: [280, 1285],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      },
	      47: {
	        coords: [555, 1320],
	        yellow: 0,
	        red: 0,
	        black: 0,
	        blue: 0
	      }
	    }
	  }
	};

/***/ },
/* 38 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 39 */
/***/ function(module, exports) {

	(function() {
	  module.exports = function(prefix) {
	    var spec;
	    spec = prefix === '-webkit- 2009' || prefix === '-moz-' ? 2009 : prefix === '-ms-' ? 2012 : prefix === '-webkit-' ? 'final' : void 0;
	    if (prefix === '-webkit- 2009') {
	      prefix = '-webkit-';
	    }
	    return [spec, prefix];
	  };
	
	}).call(this);


/***/ },
/* 40 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var list;
	
	  list = __webpack_require__(90);
	
	  module.exports = {
	    error: function(text) {
	      var err;
	      err = new Error(text);
	      err.autoprefixer = true;
	      throw err;
	    },
	    uniq: function(array) {
	      var filtered, i, j, len;
	      filtered = [];
	      for (j = 0, len = array.length; j < len; j++) {
	        i = array[j];
	        if (filtered.indexOf(i) === -1) {
	          filtered.push(i);
	        }
	      }
	      return filtered;
	    },
	    removeNote: function(string) {
	      if (string.indexOf(' ') === -1) {
	        return string;
	      } else {
	        return string.split(' ')[0];
	      }
	    },
	    escapeRegexp: function(string) {
	      return string.replace(/[.?*+\^\$\[\]\\(){}|\-]/g, '\\$&');
	    },
	    regexp: function(word, escape) {
	      if (escape == null) {
	        escape = true;
	      }
	      if (escape) {
	        word = this.escapeRegexp(word);
	      }
	      return RegExp("(^|[\\s,(])(" + word + "($|[\\s(,]))", "gi");
	    },
	    editList: function(value, callback) {
	      var changed, join, origin;
	      origin = list.comma(value);
	      changed = callback(origin, []);
	      if (origin === changed) {
	        return value;
	      } else {
	        join = value.match(/,\s*/);
	        join = join ? join[0] : ', ';
	        return changed.join(join);
	      }
	    }
	  };
	
	}).call(this);


/***/ },
/* 42 */
[1736, 30, 103, 27],
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13);
	var hide = __webpack_require__(42);
	var has = __webpack_require__(49);
	var SRC = __webpack_require__(107)('src');
	var $toString = __webpack_require__(742);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(55).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var fails = __webpack_require__(15);
	var defined = __webpack_require__(63);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Iterates through children that are typically specified as `props.children`,
	 * but only maps over children that are "valid components".
	 *
	 * The mapFunction provided index will be normalised to the components mapped,
	 * so an invalid component would not increase the index.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @return {object} Object containing the ordered map of results.
	 */
	function map(children, func, context) {
	  var index = 0;
	
	  return _react2['default'].Children.map(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return child;
	    }
	
	    return func.call(context, child, index++);
	  });
	}
	
	/**
	 * Iterates through children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for context.
	 */
	// TODO: This module should be ElementChildren, and should use named exports.
	
	function forEach(children, func, context) {
	  var index = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    func.call(context, child, index++);
	  });
	}
	
	/**
	 * Count the number of "valid components" in the Children container.
	 *
	 * @param {?*} children Children tree container.
	 * @returns {number}
	 */
	function count(children) {
	  var result = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    ++result;
	  });
	
	  return result;
	}
	
	/**
	 * Finds children that are typically specified as `props.children`,
	 * but only iterates over children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @returns {array} of children that meet the func return statement
	 */
	function filter(children, func, context) {
	  var index = 0;
	  var result = [];
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result.push(child);
	    }
	  });
	
	  return result;
	}
	
	function find(children, func, context) {
	  var index = 0;
	  var result = undefined;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = child;
	    }
	  });
	
	  return result;
	}
	
	function every(children, func, context) {
	  var index = 0;
	  var result = true;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (!func.call(context, child, index++)) {
	      result = false;
	    }
	  });
	
	  return result;
	}
	
	function some(children, func, context) {
	  var index = 0;
	  var result = false;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = true;
	    }
	  });
	
	  return result;
	}
	
	function toArray(children) {
	  var result = [];
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    result.push(child);
	  });
	
	  return result;
	}
	
	exports['default'] = {
	  map: map,
	  forEach: forEach,
	  count: count,
	  find: find,
	  filter: filter,
	  every: every,
	  some: some,
	  toArray: toArray
	};
	module.exports = exports['default'];

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var OldValue, Prefixer, Value, utils, vendor,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Prefixer = __webpack_require__(139);
	
	  OldValue = __webpack_require__(71);
	
	  utils = __webpack_require__(41);
	
	  vendor = __webpack_require__(130);
	
	  Value = (function(superClass) {
	    extend(Value, superClass);
	
	    function Value() {
	      return Value.__super__.constructor.apply(this, arguments);
	    }
	
	    Value.save = function(prefixes, decl) {
	      var already, cloned, prefix, prefixed, prop, propPrefix, ref, results, rule, trimmed, value;
	      prop = decl.prop;
	      ref = decl._autoprefixerValues;
	      results = [];
	      for (prefix in ref) {
	        value = ref[prefix];
	        if (value === decl.value) {
	          continue;
	        }
	        propPrefix = vendor.prefix(prop);
	        if (propPrefix === prefix) {
	          results.push(decl.value = value);
	        } else if (propPrefix === '-pie-') {
	          continue;
	        } else {
	          prefixed = prefixes.prefixed(prop, prefix);
	          rule = decl.parent;
	          if (rule.every(function(i) {
	            return i.prop !== prefixed;
	          })) {
	            trimmed = value.replace(/\s+/, ' ');
	            already = rule.some(function(i) {
	              return i.prop === decl.prop && i.value.replace(/\s+/, ' ') === trimmed;
	            });
	            if (!already) {
	              cloned = this.clone(decl, {
	                value: value
	              });
	              results.push(decl.parent.insertBefore(decl, cloned));
	            } else {
	              results.push(void 0);
	            }
	          } else {
	            results.push(void 0);
	          }
	        }
	      }
	      return results;
	    };
	
	    Value.prototype.check = function(decl) {
	      var value;
	      value = decl.value;
	      if (value.indexOf(this.name) !== -1) {
	        return !!value.match(this.regexp());
	      } else {
	        return false;
	      }
	    };
	
	    Value.prototype.regexp = function() {
	      return this.regexpCache || (this.regexpCache = utils.regexp(this.name));
	    };
	
	    Value.prototype.replace = function(string, prefix) {
	      return string.replace(this.regexp(), '$1' + prefix + '$2');
	    };
	
	    Value.prototype.value = function(decl) {
	      if (decl.raws.value && decl.raws.value.value === decl.value) {
	        return decl.raws.value.raw;
	      } else {
	        return decl.value;
	      }
	    };
	
	    Value.prototype.add = function(decl, prefix) {
	      var value;
	      decl._autoprefixerValues || (decl._autoprefixerValues = {});
	      value = decl._autoprefixerValues[prefix] || this.value(decl);
	      value = this.replace(value, prefix);
	      if (value) {
	        return decl._autoprefixerValues[prefix] = value;
	      }
	    };
	
	    Value.prototype.old = function(prefix) {
	      return new OldValue(this.name, prefix + this.name);
	    };
	
	    return Value;
	
	  })(Prefixer);
	
	  module.exports = Value;
	
	}).call(this);


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cities = __webpack_require__(141);
	
	Object.keys(_cities).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _cities[key];
	    }
	  });
	});
	
	var _decks = __webpack_require__(238);
	
	Object.keys(_decks).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _decks[key];
	    }
	  });
	});
	
	var _diseases = __webpack_require__(679);
	
	Object.keys(_diseases).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _diseases[key];
	    }
	  });
	});
	
	var _gameplay = __webpack_require__(179);
	
	Object.keys(_gameplay).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _gameplay[key];
	    }
	  });
	});
	
	var _hand = __webpack_require__(180);
	
	Object.keys(_hand).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _hand[key];
	    }
	  });
	});
	
	var _map = __webpack_require__(181);
	
	Object.keys(_map).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _map[key];
	    }
	  });
	});

/***/ },
/* 49 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 50 */
[1751, 149, 103, 52, 65, 49, 384, 27],
/* 51 */
[1754, 49, 33, 272],
/* 52 */
[1764, 148, 63],
/* 53 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 54 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 55 */
53,
/* 56 */
[1732, 38],
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(15);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ },
/* 58 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(1650);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(1651);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ },
/* 61 */
[1770, 249, 184, 86],
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(56);
	var IObject = __webpack_require__(148);
	var toObject = __webpack_require__(33);
	var toLength = __webpack_require__(26);
	var asc = __webpack_require__(256);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },
/* 63 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(2);
	var core = __webpack_require__(55);
	var fails = __webpack_require__(15);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 65 */
[1767, 18],
/* 66 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 67 */
46,
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.5.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2020-05-04T22:49Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var flat = arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};
	
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
	      // Support: Chrome <=57, Firefox <=52
	      // In some browsers, typeof returns "function" for HTML <object> elements
	      // (i.e., `typeof document.createElement( "object" ) === "function"`).
	      // We don't want to classify *any* DOM node as a function.
	      return typeof obj === "function" && typeof obj.nodeType !== "number";
	  };
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	var document = window.document;
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.5.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},
	
		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return flat( ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.5
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://js.foundation/
	 *
	 * Date: 2020-03-14
	 */
	( function( window ) {
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ( {} ).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		pushNative = arr.push,
		push = arr.push,
		slice = arr.slice,
	
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[ i ] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
			"ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
	
			// "Attribute values must be CSS identifiers [capture 5]
			// or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
	
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
			whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
			"*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
	
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rhtml = /HTML$/i,
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;
	
			return nonHex ?
	
				// Strip the backslash prefix from a non-hex escape sequence
				nonHex :
	
				// Replace a hexadecimal escape sequence with the encoded Unicode code point
				// Support: IE <=11+
				// For values outside the Basic Multilingual Plane (BMP), manually construct a
				// surrogate pair
				high < 0 ?
					String.fromCharCode( high + 0x10000 ) :
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" +
					ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);
	
		// Support: Android<4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
	
				// Can't trust NodeList.length
				while ( ( target[ j++ ] = els[ i++ ] ) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {
	
					// ID selector
					if ( ( m = match[ 1 ] ) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&
	
					// Support: IE 8 only
					// Exclude object elements
					( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
	
						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						if ( newContext !== context || !support.scope ) {
	
							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = nid.replace( rcssescape, fcssescape );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
	
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
	
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );
	
		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {
	
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
	
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split( "|" ),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[ i ] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( ( cur = cur.nextSibling ) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return ( name === "input" || name === "button" ) && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		var namespace = elem.namespaceURI,
			docElem = ( elem.ownerDocument || elem ).documentElement;
	
		// Support: IE <=8
		// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
		// https://bugs.jquery.com/ticket/4833
		return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
		// Safari 4 - 5 only, Opera <=11.6 - 12.x only
		// IE/Edge & older browsers don't support the :scope pseudo-class.
		// Support: Safari 6.0 only
		// Safari 6.0 supports :scope but it's an alias of :root there.
		support.scope = assert( function( el ) {
			docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
			return typeof el.querySelectorAll !== "undefined" &&
				!el.querySelectorAll( ":scope fieldset div" ).length;
		} );
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert( function( el ) {
			el.className = "i";
			return !el.getAttribute( "className" );
		} );
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert( function( el ) {
			el.appendChild( document.createComment( "" ) );
			return !el.getElementsByTagName( "*" ).length;
		} );
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		} );
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter[ "ID" ] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter[ "ID" ] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find[ "TAG" ] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
	
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( ( elem = results[ i++ ] ) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {
	
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert( function( el ) {
	
				var input;
	
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll( "[selected]" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push( "~=" );
				}
	
				// Support: IE 11+, Edge 15 - 18+
				// IE 11/Edge don't find elements on a `[name='']` query in some cases.
				// Adding a temporary attribute to the document before the selection works
				// around the issue.
				// Interestingly, IE 10 & older don't seem to have the issue.
				input = document.createElement( "input" );
				input.setAttribute( "name", "" );
				el.appendChild( input );
				if ( !el.querySelectorAll( "[name='']" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
						whitespace + "*(?:''|\"\")" );
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll( ":checked" ).length ) {
					rbuggyQSA.push( ":checked" );
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push( ".#.+[+~]" );
				}
	
				// Support: Firefox <=3.6 - 5 only
				// Old Firefox doesn't throw on a badly-escaped identifier.
				el.querySelectorAll( "\\\f" );
				rbuggyQSA.push( "[\\r\\n\\f]" );
			} );
	
			assert( function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement( "input" );
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll( "[name=d]" ).length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: Opera 10 - 11 only
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll( "*,:x" );
				rbuggyQSA.push( ",.*:" );
			} );
		}
	
		if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector ) ) ) ) {
	
			assert( function( el ) {
	
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			} );
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				) );
			} :
			function( a, b ) {
				if ( b ) {
					while ( ( b = b.parentNode ) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {
	
				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a == document || a.ownerDocument == preferredDoc &&
					contains( preferredDoc, a ) ) {
					return -1;
				}
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b == document || b.ownerDocument == preferredDoc &&
					contains( preferredDoc, b ) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
	
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				return a == document ? -1 :
					b == document ? 1 :
					/* eslint-enable eqeqeq */
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( ( cur = cur.parentNode ) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( ( cur = cur.parentNode ) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[ i ] === bp[ i ] ) {
				i++;
			}
	
			return i ?
	
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[ i ], bp[ i ] ) :
	
				// Otherwise nodes in our document sort first
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				ap[ i ] == preferredDoc ? -1 :
				bp[ i ] == preferredDoc ? 1 :
				/* eslint-enable eqeqeq */
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		setDocument( elem );
	
		if ( support.matchesSelector && documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
	
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
	
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
	
			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {
	
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
	
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
	
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
	
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
					match[ 5 ] || "" ).replace( runescape, funescape );
	
				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
	
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();
	
				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {
	
					// nth-* requires argument
					if ( !match[ 3 ] ) {
						Sizzle.error( match[ 0 ] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );
	
					// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];
	
				if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
	
					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&
	
					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {
	
					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace +
						")" + className + "(" + whitespace + "|$)" ) ) && classCache(
							className, function( elem ) {
								return pattern.test(
									typeof elem.className === "string" && elem.className ||
									typeof elem.getAttribute !== "undefined" &&
										elem.getAttribute( "class" ) ||
									""
								);
					} );
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					/* eslint-disable max-len */
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
					/* eslint-enable max-len */
	
				};
			},
	
			"CHILD": function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, _context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
	
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || ( node[ expando ] = {} );
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
	
								// Use previously-cached element index if available
								if ( useCache ) {
	
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || ( node[ expando ] = {} );
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										( outerCache[ node.uniqueID ] = {} );
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
	
									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													( outerCache[ node.uniqueID ] = {} );
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
	
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
	
			// Potentially complex pseudos
			"not": markFunction( function( selector ) {
	
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );
	
						// Don't keep the element (issue #299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),
	
			"has": markFunction( function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			} ),
	
			"contains": markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
				};
			} ),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
	
				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement &&
					( !document.hasFocus || document.hasFocus() ) &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
	
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return ( nodeName === "input" && !!elem.checked ) ||
					( nodeName === "option" && !!elem.selected );
			},
	
			"selected": function( elem ) {
	
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
	
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos[ "empty" ]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo( function() {
				return [ 0 ];
			} ),
	
			"last": createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),
	
			"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),
	
			"even": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"odd": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ?
					argument + length :
					argument > length ?
						length :
						argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};
	
	Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {
	
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}
	
			matched = false;
	
			// Combinators
			if ( ( match = rcombinators.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
	
					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrim, " " )
				} );
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
	
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
	
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] ||
								( outerCache[ elem.uniqueID ] = {} );
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = uniqueCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {
	
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[ i ], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts(
					selector || "*",
					context.nodeType ? [ context ] : context,
					[]
				),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
	
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
	
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {
	
								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {
	
							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
	
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
	
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
	
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens
							.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;
	
				if ( outermost ) {
	
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
	
						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
	
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
	
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache(
				selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers )
			);
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {
	
				context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
					.replace( runescape, funescape ), context ) || [] )[ 0 ];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {
	
					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
							context
					) ) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {
	
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert( function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute( "href" ) === "#";
	} ) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		} );
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert( function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	} ) ) {
		addHandle( "value", function( elem, _name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		} );
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert( function( el ) {
		return el.getAttribute( "disabled" ) == null;
	} ) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
					( val = elem.getAttributeNode( name ) ) && val.specified ?
						val.value :
						null;
			}
		} );
	}
	
	return Sizzle;
	
	} )( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	};
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&
	
				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {
	
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 - 11+
	// focus() and blur() are asynchronous, except when they are no-op.
	// So expect focus to be synchronous when the element is already active,
	// and blur to be synchronous when the element is not already active.
	// (focus and blur are always synchronous in other supported browsers,
	// this just defines when we can count on it).
	function expectSync( elem, type ) {
		return ( elem === safeActiveElement() ) === ( type === "focus" );
	}
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),
	
				handlers = (
						dataPriv.get( this, "events" ) || Object.create( null )
					)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", returnTrue );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, expectSync ) {
	
		// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
		if ( !expectSync ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var notAsync, result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					// Saved data should be false in such cases, but might be a leftover capture object
					// from an async native handler (gh-4350)
					if ( !saved.length ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						// Support: IE <=9 - 11+
						// focus() and blur() are asynchronous
						notAsync = expectSync( this, type );
						this[ type ]();
						result = dataPriv.get( this, type );
						if ( saved !== result || notAsync ) {
							dataPriv.set( this, type, false );
						} else {
							result = {};
						}
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
							return result.value;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering the
					// native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved.length ) {
	
					// ...and capture the result
					dataPriv.set( this, type, {
						value: jQuery.event.trigger(
	
							// Support: IE <=9 - 11+
							// Extend with the prototype to reset the above stopImmediatePropagation()
							jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
							saved.slice( 1 ),
							this
						)
					} );
	
					// Abort handling of the native event
					event.stopImmediatePropagation();
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, expectSync );
	
				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			delegateType: delegateType
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;
	
			if ( events ) {
				dataPriv.remove( dest, "handle events" );
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = flat( args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.call( elem );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},
	
			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );
	
					table.style.cssText = "position:absolute;left:-11111px";
					tr.style.height = "1px";
					trChild.style.height = "9px";
	
					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );
	
					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = parseInt( trStyle.height ) > 3;
	
					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( _elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||
	
			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||
	
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
	
			// Make sure the element is visible & connected
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"gridArea": true,
			"gridColumn": true,
			"gridColumnEnd": true,
			"gridColumnStart": true,
			"gridRow": true,
			"gridRowEnd": true,
			"gridRowStart": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, dimension, extra );
							} ) :
							getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
						jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( isValidValue ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	support.focusin = "onfocusin" in window;
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = (
						dataPriv.get( cur, "events" ) || Object.create( null )
					)[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
	
					// Handle: regular nodes (via `this.ownerDocument`), window
					// (via `this.document`) & document (via `this`).
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = { guid: Date.now() };
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( _i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Use a noop converter for missing script
				if ( !isSuccess && jQuery.inArray( "script", s.dataTypes ) > -1 ) {
					s.converters[ "text script" ] = function() {};
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );
	
	
	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				if ( typeof props.top === "number" ) {
					props.top += "px";
				}
				if ( typeof props.left === "number" ) {
					props.left += "px";
				}
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
	
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {
	
			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		} );
	
	
	
	
	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	};
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  href: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  disabled: _propTypes2['default'].bool,
	  role: _propTypes2['default'].string,
	  tabIndex: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * this is sort of silly but needed for Button
	   */
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'a'
	};
	
	function isTrivialHref(href) {
	  return !href || href.trim() === '#';
	}
	
	/**
	 * There are situations due to browser quirks or Bootstrap CSS where
	 * an anchor tag is needed, when semantically a button tag is the
	 * better choice. SafeAnchor ensures that when an anchor is used like a
	 * button its accessible. It also emulates input `disabled` behavior for
	 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
	 */
	
	var SafeAnchor = function (_React$Component) {
	  (0, _inherits3['default'])(SafeAnchor, _React$Component);
	
	  function SafeAnchor(props, context) {
	    (0, _classCallCheck3['default'])(this, SafeAnchor);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  SafeAnchor.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        href = _props.href,
	        onClick = _props.onClick;
	
	
	    if (disabled || isTrivialHref(href)) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  SafeAnchor.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        disabled = _props2.disabled,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'disabled']);
	
	
	    if (isTrivialHref(props.href)) {
	      props.role = props.role || 'button';
	      // we want to make sure there is a href attribute on the node
	      // otherwise, the cursor incorrectly styled (except with role='button')
	      props.href = props.href || '#';
	    }
	
	    if (disabled) {
	      props.tabIndex = -1;
	      props.style = (0, _extends3['default'])({ pointerEvents: 'none' }, props.style);
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
	      onClick: this.handleClick
	    }));
	  };
	
	  return SafeAnchor;
	}(_react2['default'].Component);
	
	SafeAnchor.propTypes = propTypes;
	SafeAnchor.defaultProps = defaultProps;
	
	exports['default'] = SafeAnchor;
	module.exports = exports['default'];

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19),
	    _assign = __webpack_require__(31);
	
	var CallbackQueue = __webpack_require__(496);
	var PooledClass = __webpack_require__(112);
	var ReactFeatureFlags = __webpack_require__(501);
	var ReactReconciler = __webpack_require__(133);
	var Transaction = __webpack_require__(223);
	
	var invariant = __webpack_require__(12);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var OldValue, utils;
	
	  utils = __webpack_require__(41);
	
	  OldValue = (function() {
	    function OldValue(unprefixed, prefixed, string, regexp) {
	      this.unprefixed = unprefixed;
	      this.prefixed = prefixed;
	      this.string = string;
	      this.regexp = regexp;
	      this.regexp || (this.regexp = utils.regexp(this.prefixed));
	      this.string || (this.string = this.prefixed);
	    }
	
	    OldValue.prototype.check = function(value) {
	      if (value.indexOf(this.string) !== -1) {
	        return !!value.match(this.regexp);
	      } else {
	        return false;
	      }
	    };
	
	    return OldValue;
	
	  })();
	
	  module.exports = OldValue;
	
	}).call(this);


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.discardFromHandInit = discardFromHandInit;
	exports.drawCardsInit = drawCardsInit;
	exports.drawCardsHandleInit = drawCardsHandleInit;
	exports.drawCardsHandle = drawCardsHandle;
	exports.discardBottomInfectionCard = discardBottomInfectionCard;
	exports.discardTopInfectionCard = discardTopInfectionCard;
	exports.drawInfectionCard = drawInfectionCard;
	exports.epidemicIncrease = epidemicIncrease;
	exports.epidemicInfectInit = epidemicInfectInit;
	exports.epidemicIntensifyInit = epidemicIntensifyInit;
	exports.epidemicIntensifyContinue = epidemicIntensifyContinue;
	exports.epidemicIntensify = epidemicIntensify;
	exports.chooseCardsToDiscard = chooseCardsToDiscard;
	exports.cardOverLimitComplete = cardOverLimitComplete;
	exports.shareCardsInit = shareCardsInit;
	exports.shareCardsShowCandidates = shareCardsShowCandidates;
	exports.shareCard = shareCard;
	exports.shareCardsCancel = shareCardsCancel;
	exports.playEventInit = playEventInit;
	exports.resPopRemoveCard = resPopRemoveCard;
	exports.resPopSuggest = resPopSuggest;
	exports.forecastShowCards = forecastShowCards;
	exports.forecastShuffle = forecastShuffle;
	exports.opsShowCardsToDiscard = opsShowCardsToDiscard;
	exports.contPlannerInit = contPlannerInit;
	exports.contPlannerShowEventsFromDiscard = contPlannerShowEventsFromDiscard;
	exports.contPlannerChooseEvent = contPlannerChooseEvent;
	exports.contPlannerEventComplete = contPlannerEventComplete;
	
	var _actionTypes = __webpack_require__(25);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function discardFromHandInit(cardType, playerId, id) {
	  return { type: types.CARD_DISCARD_FROM_HAND_INIT, cardType: cardType, id: id, playerId: playerId };
	}
	
	function drawCardsInit(cards) {
	  return { type: types.CARD_DRAW_CARDS_INIT, cards: cards };
	}
	
	function drawCardsHandleInit(card) {
	  return { type: types.CARD_DRAW_CARDS_HANDLE_INIT, card: card };
	}
	
	function drawCardsHandle(card, playerId) {
	  return { type: types.CARD_DRAW_CARDS_HANDLE, card: card, playerId: playerId };
	}
	
	function discardBottomInfectionCard() {
	  return { type: types.CARD_DISCARD_FROM_INFECTION_DECK_BOTTOM };
	}
	
	function discardTopInfectionCard() {
	  return { type: types.CARD_DISCARD_FROM_INFECTION_DECK_TOP };
	}
	
	function drawInfectionCard(cityId) {
	  return { type: types.CARD_DRAW_INFECTION_CARD, cityId: cityId };
	}
	
	function epidemicIncrease() {
	  return { type: types.EPIDEMIC_INCREASE };
	}
	
	function epidemicInfectInit(card) {
	  return { type: types.EPIDEMIC_INFECT_INIT, card: card };
	}
	
	function epidemicIntensifyInit() {
	  return { type: types.EPIDEMIC_INTENSIFY_INIT };
	}
	
	function epidemicIntensifyContinue() {
	  return { type: types.EPIDEMIC_INTENSIFY_CONTINUE };
	}
	
	function epidemicIntensify() {
	  return { type: types.EPIDEMIC_INTENSIFY };
	}
	
	function chooseCardsToDiscard(playerId) {
	  return { type: types.CARD_OVER_LIMIT_DISCARD_INIT, playerId: playerId };
	}
	
	function cardOverLimitComplete() {
	  return { type: types.CARD_OVER_LIMIT_DISCARD_COMPLETE };
	}
	
	function shareCardsInit() {
	  return { type: types.PLAYER_SHARE_INIT };
	}
	
	function shareCardsShowCandidates(players) {
	  return { type: types.PLAYER_SHARE_SHOW_CANDIDATES, players: players };
	}
	
	function shareCard(giverId, receiverId, cityId) {
	  return { type: types.PLAYER_SHARE_CARD, giverId: giverId, receiverId: receiverId, cityId: cityId };
	}
	
	function shareCardsCancel() {
	  return { type: types.PLAYER_SHARE_CANCEL };
	}
	
	function playEventInit(playerId, id) {
	  return { type: types.PLAYER_PLAY_EVENT_INIT, playerId: playerId, id: id };
	}
	
	function resPopRemoveCard(cityId) {
	  return { type: types.EVENT_RES_POP_REMOVE_CARD, cityId: cityId };
	}
	
	function resPopSuggest(playerId) {
	  return { type: types.EVENT_RES_POP_SUGGEST, playerId: playerId };
	}
	
	function forecastShowCards(cards) {
	  return { type: types.EVENT_FORECAST_SHOW_CARDS, cards: cards };
	}
	
	function forecastShuffle(cards) {
	  return { type: types.EVENT_FORECAST_SHUFFLE, cards: cards };
	}
	
	function opsShowCardsToDiscard(cards) {
	  return { type: types.OPS_SHOW_CARDS_TO_DISCARD, cards: cards };
	}
	
	function contPlannerInit() {
	  return { type: types.CONT_PLANNER_INIT };
	}
	
	function contPlannerShowEventsFromDiscard(cards) {
	  return { type: types.CONT_PLANNER_SHOW_EVENTS_FROM_DISCARD, cards: cards };
	}
	
	function contPlannerChooseEvent(playerId, eventId) {
	  return { type: types.CONT_PLANNER_CHOOSE_EVENT, playerId: playerId, eventId: eventId };
	}
	
	function contPlannerEventComplete(playerId) {
	  return { type: types.CONT_PLANNER_EVENT_COMPLETE, playerId: playerId };
	}

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createQuickGameInit = createQuickGameInit;
	exports.createCustomGameInit = createCustomGameInit;
	exports.createGame = createGame;
	exports.dealCardsInit = dealCardsInit;
	exports.dealCards = dealCards;
	exports.insertEpidemicCardsInit = insertEpidemicCardsInit;
	exports.insertPlayerCard = insertPlayerCard;
	exports.startGame = startGame;
	exports.victory = victory;
	exports.defeat = defeat;
	exports.continueTurn = continueTurn;
	exports.passTurn = passTurn;
	exports.animationMoveComplete = animationMoveComplete;
	exports.animationDrawCardsInitComplete = animationDrawCardsInitComplete;
	exports.animationDrawInfectionCardComplete = animationDrawInfectionCardComplete;
	exports.animationInfectNeighborComplete = animationInfectNeighborComplete;
	exports.animationDealCardsComplete = animationDealCardsComplete;
	exports.animationDealCardsInitComplete = animationDealCardsInitComplete;
	exports.animationInsertEpidemicCardsComplete = animationInsertEpidemicCardsComplete;
	exports.animationCardDiscardFromHandComplete = animationCardDiscardFromHandComplete;
	exports.animationEpidemicInfectComplete = animationEpidemicInfectComplete;
	exports.animationCureDiseaseComplete = animationCureDiseaseComplete;
	
	var _actionTypes = __webpack_require__(25);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function createQuickGameInit(numberOfPlayers) {
	  return { type: types.CREATE_QUICK_GAME_INIT, numberOfPlayers: numberOfPlayers };
	}
	
	function createCustomGameInit(players, difficulty) {
	  return { type: types.CREATE_CUSTOM_GAME_INIT, players: players, difficulty: difficulty };
	}
	
	function createGame(players, playerDeck, infectionDeck, difficulty) {
	  return { type: types.CREATE_GAME, players: players, playerDeck: playerDeck, infectionDeck: infectionDeck, difficulty: difficulty };
	}
	
	function dealCardsInit() {
	  return { type: types.DEAL_CARDS_INIT };
	}
	
	function dealCards(playerId, cards, playerIndex) {
	  return { type: types.DEAL_CARDS, playerId: playerId, cards: cards, playerIndex: playerIndex };
	}
	
	function insertEpidemicCardsInit() {
	  return { type: types.INSERT_EPIDEMIC_CARDS_INIT };
	}
	
	function insertPlayerCard(index, card) {
	  return { type: types.INSERT_PLAYER_CARD, index: index, card: card };
	}
	
	function startGame() {
	  return { type: types.START_GAME };
	}
	
	function victory() {
	  return { type: types.VICTORY };
	}
	
	function defeat(message) {
	  return { type: types.DEFEAT, message: message };
	}
	
	function continueTurn() {
	  return { type: types.CONTINUE };
	}
	
	function passTurn(playerId) {
	  return { type: types.PASS_TURN, playerId: playerId };
	}
	
	function animationMoveComplete() {
	  return { type: types.ANIMATION_MOVE_COMPLETE };
	}
	
	function animationDrawCardsInitComplete() {
	  return { type: types.ANIMATION_DRAW_CARDS_INIT_COMPLETE };
	}
	
	function animationDrawInfectionCardComplete() {
	  return { type: types.ANIMATION_DRAW_INFECTION_CARD_COMPLETE };
	}
	
	function animationInfectNeighborComplete(cityId, originId, color) {
	  return { type: types.ANIMATION_INFECT_NEIGHBOR_COMPLETE, cityId: cityId, originId: originId, color: color };
	}
	
	function animationDealCardsComplete() {
	  return { type: types.ANIMATION_DEAL_CARDS_COMPLETE };
	}
	
	function animationDealCardsInitComplete() {
	  return { type: types.ANIMATION_DEAL_CARDS_INIT_COMPLETE };
	}
	
	function animationInsertEpidemicCardsComplete() {
	  return { type: types.ANIMATION_INSERT_EPIDEMIC_CARDS_COMPLETE };
	}
	
	function animationCardDiscardFromHandComplete(cardType, playerId, id) {
	  return { type: types.ANIMATION_CARD_DISCARD_FROM_HAND_COMPLETE, cardType: cardType, id: id, playerId: playerId };
	}
	
	function animationEpidemicInfectComplete() {
	  return { type: types.ANIMATION_EPIDEMIC_INFECT_COMPLETE };
	}
	
	function animationCureDiseaseComplete() {
	  return { type: types.ANIMATION_CURE_DISEASE_COMPLETE };
	}

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(406);
	var $export = __webpack_require__(2);
	var shared = __webpack_require__(150)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(410))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(27)) {
	  var LIBRARY = __webpack_require__(88);
	  var global = __webpack_require__(13);
	  var fails = __webpack_require__(15);
	  var $export = __webpack_require__(2);
	  var $typed = __webpack_require__(197);
	  var $buffer = __webpack_require__(277);
	  var ctx = __webpack_require__(56);
	  var anInstance = __webpack_require__(98);
	  var propertyDesc = __webpack_require__(103);
	  var hide = __webpack_require__(42);
	  var redefineAll = __webpack_require__(104);
	  var toInteger = __webpack_require__(58);
	  var toLength = __webpack_require__(26);
	  var toIndex = __webpack_require__(404);
	  var toAbsoluteIndex = __webpack_require__(106);
	  var toPrimitive = __webpack_require__(65);
	  var has = __webpack_require__(49);
	  var classof = __webpack_require__(123);
	  var isObject = __webpack_require__(18);
	  var toObject = __webpack_require__(33);
	  var isArrayIter = __webpack_require__(263);
	  var create = __webpack_require__(100);
	  var getPrototypeOf = __webpack_require__(51);
	  var gOPN = __webpack_require__(101).f;
	  var getIterFn = __webpack_require__(279);
	  var uid = __webpack_require__(107);
	  var wks = __webpack_require__(24);
	  var createArrayMethod = __webpack_require__(62);
	  var createArrayIncludes = __webpack_require__(185);
	  var speciesConstructor = __webpack_require__(151);
	  var ArrayIterators = __webpack_require__(280);
	  var Iterators = __webpack_require__(124);
	  var $iterDetect = __webpack_require__(190);
	  var setSpecies = __webpack_require__(105);
	  var arrayFill = __webpack_require__(255);
	  var arrayCopyWithin = __webpack_require__(376);
	  var $DP = __webpack_require__(30);
	  var $GOPD = __webpack_require__(50);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ },
/* 76 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 77 */
/***/ function(module, exports) {

	var isArray = (typeof Array.isArray === 'function') ?
	  // use native function
	  Array.isArray :
	  // use instanceof operator
	  function(a) {
	    return a instanceof Array;
	  };
	
	var getObjectKeys = typeof Object.keys === 'function' ?
	  function(obj) {
	    return Object.keys(obj);
	  } : function(obj) {
	    var names = [];
	    for (var property in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, property)) {
	        names.push(property);
	      }
	    }
	    return names;
	  };
	
	var trimUnderscore = function(str) {
	  if (str.substr(0, 1) === '_') {
	    return str.slice(1);
	  }
	  return str;
	};
	
	var arrayKeyToSortNumber = function(key) {
	  if (key === '_t') {
	    return -1;
	  } else {
	    if (key.substr(0, 1) === '_') {
	      return parseInt(key.slice(1), 10);
	    } else {
	      return parseInt(key, 10) + 0.1;
	    }
	  }
	};
	
	var arrayKeyComparer = function(key1, key2) {
	  return arrayKeyToSortNumber(key1) - arrayKeyToSortNumber(key2);
	};
	
	var BaseFormatter = function BaseFormatter() {};
	
	BaseFormatter.prototype.format = function(delta, left) {
	  var context = {};
	  this.prepareContext(context);
	  this.recurse(context, delta, left);
	  return this.finalize(context);
	};
	
	BaseFormatter.prototype.prepareContext = function(context) {
	  context.buffer = [];
	  context.out = function() {
	    this.buffer.push.apply(this.buffer, arguments);
	  };
	};
	
	BaseFormatter.prototype.typeFormattterNotFound = function(context, deltaType) {
	  throw new Error('cannot format delta type: ' + deltaType);
	};
	
	BaseFormatter.prototype.typeFormattterErrorFormatter = function(context, err) {
	  return err.toString();
	};
	
	BaseFormatter.prototype.finalize = function(context) {
	  if (isArray(context.buffer)) {
	    return context.buffer.join('');
	  }
	};
	
	BaseFormatter.prototype.recurse = function(context, delta, left, key, leftKey, movedFrom, isLast) {
	
	  var useMoveOriginHere = delta && movedFrom;
	  var leftValue = useMoveOriginHere ? movedFrom.value : left;
	
	  if (typeof delta === 'undefined' && typeof key === 'undefined') {
	    return undefined;
	  }
	
	  var type = this.getDeltaType(delta, movedFrom);
	  var nodeType = type === 'node' ? (delta._t === 'a' ? 'array' : 'object') : '';
	
	  if (typeof key !== 'undefined') {
	    this.nodeBegin(context, key, leftKey, type, nodeType, isLast);
	  } else {
	    this.rootBegin(context, type, nodeType);
	  }
	
	  var typeFormattter;
	  try {
	    typeFormattter = this['format_' + type] || this.typeFormattterNotFound(context, type);
	    typeFormattter.call(this, context, delta, leftValue, key, leftKey, movedFrom);
	  } catch (err) {
	    this.typeFormattterErrorFormatter(context, err, delta, leftValue, key, leftKey, movedFrom);
	    if (typeof console !== 'undefined' && console.error) {
	      console.error(err.stack);
	    }
	  }
	
	  if (typeof key !== 'undefined') {
	    this.nodeEnd(context, key, leftKey, type, nodeType, isLast);
	  } else {
	    this.rootEnd(context, type, nodeType);
	  }
	};
	
	BaseFormatter.prototype.formatDeltaChildren = function(context, delta, left) {
	  var self = this;
	  this.forEachDeltaKey(delta, left, function(key, leftKey, movedFrom, isLast) {
	    self.recurse(context, delta[key], left ? left[leftKey] : undefined,
	      key, leftKey, movedFrom, isLast);
	  });
	};
	
	BaseFormatter.prototype.forEachDeltaKey = function(delta, left, fn) {
	  var keys = getObjectKeys(delta);
	  var arrayKeys = delta._t === 'a';
	  var moveDestinations = {};
	  var name;
	  if (typeof left !== 'undefined') {
	    for (name in left) {
	      if (typeof delta[name] === 'undefined' &&
	        ((!arrayKeys) || typeof delta['_' + name] === 'undefined')) {
	        keys.push(name);
	      }
	    }
	  }
	  // look for move destinations
	  for (name in delta) {
	    var value = delta[name];
	    if (isArray(value) && value[2] === 3) {
	      moveDestinations[value[1].toString()] = {
	        key: name,
	        value: left && left[parseInt(name.substr(1))]
	      };
	      if (this.includeMoveDestinations !== false) {
	        if ((typeof left === 'undefined') &&
	          (typeof delta[value[1]] === 'undefined')) {
	          keys.push(value[1].toString());
	        }
	      }
	    }
	  }
	  if (arrayKeys) {
	    keys.sort(arrayKeyComparer);
	  } else {
	    keys.sort();
	  }
	  for (var index = 0, length = keys.length; index < length; index++) {
	    var key = keys[index];
	    if (arrayKeys && key === '_t') {
	      continue;
	    }
	    var leftKey = arrayKeys ?
	      (typeof key === 'number' ? key : parseInt(trimUnderscore(key), 10)) :
	      key;
	    var isLast = (index === length - 1);
	    fn(key, leftKey, moveDestinations[leftKey], isLast);
	  }
	};
	
	BaseFormatter.prototype.getDeltaType = function(delta, movedFrom) {
	  if (typeof delta === 'undefined') {
	    if (typeof movedFrom !== 'undefined') {
	      return 'movedestination';
	    }
	    return 'unchanged';
	  }
	  if (isArray(delta)) {
	    if (delta.length === 1) {
	      return 'added';
	    }
	    if (delta.length === 2) {
	      return 'modified';
	    }
	    if (delta.length === 3 && delta[2] === 0) {
	      return 'deleted';
	    }
	    if (delta.length === 3 && delta[2] === 2) {
	      return 'textdiff';
	    }
	    if (delta.length === 3 && delta[2] === 3) {
	      return 'moved';
	    }
	  } else if (typeof delta === 'object') {
	    return 'node';
	  }
	  return 'unknown';
	};
	
	BaseFormatter.prototype.parseTextDiff = function(value) {
	  var output = [];
	  var lines = value.split('\n@@ ');
	  for (var i = 0, l = lines.length; i < l; i++) {
	    var line = lines[i];
	    var lineOutput = {
	      pieces: []
	    };
	    var location = /^(?:@@ )?[-+]?(\d+),(\d+)/.exec(line).slice(1);
	    lineOutput.location = {
	      line: location[0],
	      chr: location[1]
	    };
	    var pieces = line.split('\n').slice(1);
	    for (var pieceIndex = 0, piecesLength = pieces.length; pieceIndex < piecesLength; pieceIndex++) {
	      var piece = pieces[pieceIndex];
	      if (!piece.length) {
	        continue;
	      }
	      var pieceOutput = {
	        type: 'context'
	      };
	      if (piece.substr(0, 1) === '+') {
	        pieceOutput.type = 'added';
	      } else if (piece.substr(0, 1) === '-') {
	        pieceOutput.type = 'deleted';
	      }
	      pieceOutput.text = piece.slice(1);
	      lineOutput.pieces.push(pieceOutput);
	    }
	    output.push(lineOutput);
	  }
	  return output;
	};
	
	exports.BaseFormatter = BaseFormatter;


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(210),
	    getPrototype = __webpack_require__(1423),
	    isObjectLike = __webpack_require__(167);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 79 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warnOnce;
	var printed = {};
	
	function warnOnce(message) {
	    if (printed[message]) return;
	    printed[message] = true;
	
	    if (typeof console !== 'undefined' && console.warn) console.warn(message);
	}
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndhcm4tb25jZS5lczYiXSwibmFtZXMiOlsid2Fybk9uY2UiLCJwcmludGVkIiwibWVzc2FnZSIsImNvbnNvbGUiLCJ3YXJuIl0sIm1hcHBpbmdzIjoiOzs7a0JBRXdCQSxRO0FBRnhCLElBQUlDLFVBQVUsRUFBZDs7QUFFZSxTQUFTRCxRQUFULENBQWtCRSxPQUFsQixFQUEyQjtBQUN0QyxRQUFLRCxRQUFRQyxPQUFSLENBQUwsRUFBd0I7QUFDeEJELFlBQVFDLE9BQVIsSUFBbUIsSUFBbkI7O0FBRUEsUUFBSyxPQUFPQyxPQUFQLEtBQW1CLFdBQW5CLElBQWtDQSxRQUFRQyxJQUEvQyxFQUFzREQsUUFBUUMsSUFBUixDQUFhRixPQUFiO0FBQ3pEIiwiZmlsZSI6Indhcm4tb25jZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImxldCBwcmludGVkID0geyB9O1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB3YXJuT25jZShtZXNzYWdlKSB7XG4gICAgaWYgKCBwcmludGVkW21lc3NhZ2VdICkgcmV0dXJuO1xuICAgIHByaW50ZWRbbWVzc2FnZV0gPSB0cnVlO1xuXG4gICAgaWYgKCB0eXBlb2YgY29uc29sZSAhPT0gJ3VuZGVmaW5lZCcgJiYgY29uc29sZS53YXJuICkgY29uc29sZS53YXJuKG1lc3NhZ2UpO1xufVxuIl19


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(31);
	
	var PooledClass = __webpack_require__(112);
	
	var emptyFunction = __webpack_require__(66);
	var warning = __webpack_require__(20);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 81 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 82 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.check = check;
	exports.remove = remove;
	exports.deferred = deferred;
	exports.arrayOfDeffered = arrayOfDeffered;
	exports.delay = delay;
	exports.createMockTask = createMockTask;
	exports.autoInc = autoInc;
	exports.makeIterator = makeIterator;
	exports.log = log;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var sym = exports.sym = function sym(id) {
	  return '@@redux-saga/' + id;
	};
	var TASK = exports.TASK = sym('TASK');
	var MATCH = exports.MATCH = sym('MATCH');
	var CANCEL = exports.CANCEL = sym('cancelPromise');
	var konst = exports.konst = function konst(v) {
	  return function () {
	    return v;
	  };
	};
	var kTrue = exports.kTrue = konst(true);
	var kFalse = exports.kFalse = konst(false);
	var noop = exports.noop = function noop() {};
	var ident = exports.ident = function ident(v) {
	  return v;
	};
	
	function check(value, predicate, error) {
	  if (!predicate(value)) {
	    log('error', 'uncaught at check', error);
	    throw new Error(error);
	  }
	}
	
	var is = exports.is = {
	  undef: function undef(v) {
	    return v === null || v === undefined;
	  },
	  notUndef: function notUndef(v) {
	    return v !== null && v !== undefined;
	  },
	  func: function func(f) {
	    return typeof f === 'function';
	  },
	  number: function number(n) {
	    return typeof n === 'number';
	  },
	  array: Array.isArray,
	  promise: function promise(p) {
	    return p && is.func(p.then);
	  },
	  iterator: function iterator(it) {
	    return it && is.func(it.next) && is.func(it.throw);
	  },
	  task: function task(t) {
	    return t && t[TASK];
	  },
	  take: function take(ch) {
	    return ch && is.func(ch.take);
	  },
	  put: function put(ch) {
	    return ch && is.func(ch.put);
	  },
	  observable: function observable(ob) {
	    return ob && is.func(ob.subscribe);
	  },
	  buffer: function buffer(buf) {
	    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
	  },
	  pattern: function pattern(pat) {
	    return pat && (typeof pat === 'string' || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
	  }
	};
	
	function remove(array, item) {
	  var index = array.indexOf(item);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	}
	
	function deferred() {
	  var props = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  var def = _extends({}, props);
	  var promise = new Promise(function (resolve, reject) {
	    def.resolve = resolve;
	    def.reject = reject;
	  });
	  def.promise = promise;
	  return def;
	}
	
	function arrayOfDeffered(length) {
	  var arr = [];
	  for (var i = 0; i < length; i++) {
	    arr.push(deferred());
	  }
	  return arr;
	}
	
	function delay(ms) {
	  var val = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	  var timeoutId = void 0;
	  var promise = new Promise(function (resolve) {
	    timeoutId = setTimeout(function () {
	      return resolve(val);
	    }, ms);
	  });
	
	  promise[CANCEL] = function () {
	    return clearTimeout(timeoutId);
	  };
	
	  return promise;
	}
	
	function createMockTask() {
	  var _ref;
	
	  var running = true;
	  var _result = void 0,
	      _error = void 0;
	
	  return _ref = {}, _defineProperty(_ref, TASK, true), _defineProperty(_ref, 'isRunning', function isRunning() {
	    return running;
	  }), _defineProperty(_ref, 'result', function result() {
	    return _result;
	  }), _defineProperty(_ref, 'error', function error() {
	    return _error;
	  }), _defineProperty(_ref, 'setRunning', function setRunning(b) {
	    return running = b;
	  }), _defineProperty(_ref, 'setResult', function setResult(r) {
	    return _result = r;
	  }), _defineProperty(_ref, 'setError', function setError(e) {
	    return _error = e;
	  }), _ref;
	}
	
	function autoInc() {
	  var seed = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var kThrow = function kThrow(err) {
	  throw err;
	};
	function makeIterator(next) {
	  var thro = arguments.length <= 1 || arguments[1] === undefined ? kThrow : arguments[1];
	  var name = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
	
	  var iterator = { name: name, next: next, throw: thro };
	  if (typeof Symbol !== 'undefined') {
	    iterator[Symbol.iterator] = function () {
	      return iterator;
	    };
	  }
	  return iterator;
	}
	
	/**
	  Print error in a useful way whether in a browser environment
	  (with expandable error stack traces), or in a node.js environment
	  (text-only log output)
	 **/
	function log(level, message, error) {
	  /*eslint-disable no-console*/
	  if (typeof window === 'undefined') {
	    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
	  } else {
	    console[level].call(console, message, error);
	  }
	}
	
	var internalErr = exports.internalErr = function internalErr(err) {
	  return new Error('\n  redux-saga: Error checking hooks detected an inconsisten state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
	};

/***/ },
/* 83 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Object.freeze(['yellow', 'red', 'blue', 'black']);

/***/ },
/* 84 */
[1733, 142],
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(86);
	var core = __webpack_require__(53);
	var ctx = __webpack_require__(242);
	var hide = __webpack_require__(121);
	var has = __webpack_require__(95);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 86 */
13,
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(24)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(42)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ },
/* 88 */
/***/ function(module, exports) {

	module.exports = false;


/***/ },
/* 89 */
[1746, 107, 18, 49, 30, 15],
/* 90 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Contains helpers for safely splitting lists of CSS values,
	 * preserving parentheses and quotes.
	 *
	 * @example
	 * const list = postcss.list;
	 *
	 * @namespace list
	 */
	var list = {
	    split: function split(string, separators, last) {
	        var array = [];
	        var current = '';
	        var split = false;
	
	        var func = 0;
	        var quote = false;
	        var escape = false;
	
	        for (var i = 0; i < string.length; i++) {
	            var letter = string[i];
	
	            if (quote) {
	                if (escape) {
	                    escape = false;
	                } else if (letter === '\\') {
	                    escape = true;
	                } else if (letter === quote) {
	                    quote = false;
	                }
	            } else if (letter === '"' || letter === '\'') {
	                quote = letter;
	            } else if (letter === '(') {
	                func += 1;
	            } else if (letter === ')') {
	                if (func > 0) func -= 1;
	            } else if (func === 0) {
	                if (separators.indexOf(letter) !== -1) split = true;
	            }
	
	            if (split) {
	                if (current !== '') array.push(current.trim());
	                current = '';
	                split = false;
	            } else {
	                current += letter;
	            }
	        }
	
	        if (last || current !== '') array.push(current.trim());
	        return array;
	    },
	
	
	    /**
	     * Safely splits space-separated values (such as those for `background`,
	     * `border-radius`, and other shorthand properties).
	     *
	     * @param {string} string - space-separated values
	     *
	     * @return {string[]} split values
	     *
	     * @example
	     * postcss.list.space('1px calc(10% + 1px)') //=> ['1px', 'calc(10% + 1px)']
	     */
	    space: function space(string) {
	        var spaces = [' ', '\n', '\t'];
	        return list.split(string, spaces);
	    },
	
	
	    /**
	     * Safely splits comma-separated values (such as those for `transition-*`
	     * and `background` properties).
	     *
	     * @param {string} string - comma-separated values
	     *
	     * @return {string[]} split values
	     *
	     * @example
	     * postcss.list.comma('black, linear-gradient(white, black)')
	     * //=> ['black', 'linear-gradient(white, black)']
	     */
	    comma: function comma(string) {
	        var comma = ',';
	        return list.split(string, [comma], true);
	    }
	};
	
	exports.default = list;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.treatDisease = treatDisease;
	exports.treatAllDisease = treatAllDisease;
	exports.cureDiseaseInit = cureDiseaseInit;
	exports.cureDiseaseShowCards = cureDiseaseShowCards;
	exports.cureDiseaseComplete = cureDiseaseComplete;
	exports.cureDiseaseCancel = cureDiseaseCancel;
	exports.eradicateDisease = eradicateDisease;
	exports.initOutbreak = initOutbreak;
	exports.infectCity = infectCity;
	exports.infectNeighbor = infectNeighbor;
	exports.completeOutbreak = completeOutbreak;
	exports.queueOutbreak = queueOutbreak;
	exports.infectCities = infectCities;
	exports.useDiseaseCubes = useDiseaseCubes;
	exports.oneQuietNightSkip = oneQuietNightSkip;
	exports.medicTreatCuredDiseases = medicTreatCuredDiseases;
	exports.medicPreventInfection = medicPreventInfection;
	exports.quarSpecPreventInfection = quarSpecPreventInfection;
	
	var _actionTypes = __webpack_require__(25);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function treatDisease(cityId, color, count) {
	  return { type: types.PLAYER_TREAT_DISEASE, cityId: cityId, color: color, count: count };
	}
	
	function treatAllDisease(cityId, color, count) {
	  return { type: types.PLAYER_TREAT_ALL_DISEASE, cityId: cityId, color: color, count: count };
	}
	
	function cureDiseaseInit(color) {
	  return { type: types.PLAYER_CURE_DISEASE_INIT, color: color };
	}
	
	function cureDiseaseShowCards(cards, color) {
	  return { type: types.PLAYER_CURE_DISEASE_SHOW_CARDS, cards: cards, color: color };
	}
	
	function cureDiseaseComplete(cityIds, color) {
	  return { type: types.PLAYER_CURE_DISEASE_COMPLETE, cityIds: cityIds, color: color };
	}
	
	function cureDiseaseCancel() {
	  return { type: types.PLAYER_CURE_DISEASE_CANCEL };
	}
	
	function eradicateDisease(color) {
	  return { type: types.ERADICATE_DISEASE, color: color };
	}
	
	function initOutbreak(cityId, color) {
	  return { type: types.OUTBREAK_INIT, cityId: cityId, color: color };
	}
	
	function infectCity(cityId, color, count) {
	  var initial = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  return { type: types.INFECT_CITY, cityId: cityId, color: color, count: count, initial: initial };
	}
	
	function infectNeighbor(cityId, originId, color) {
	  return { type: types.INFECT_NEIGHBOR, cityId: cityId, originId: originId, color: color };
	}
	
	function completeOutbreak(cityId) {
	  return { type: types.OUTBREAK_COMPLETE, cityId: cityId };
	}
	
	function queueOutbreak(cityId, color) {
	  return { type: types.OUTBREAK_QUEUE, cityId: cityId, color: color };
	}
	
	function infectCities() {
	  return { type: types.INFECT_CITIES };
	}
	
	function useDiseaseCubes(color, count) {
	  return { type: types.USE_DISEASE_CUBES, count: count, color: color };
	}
	
	function oneQuietNightSkip() {
	  return { type: types.EVENT_ONE_QUIET_NIGHT_SKIP };
	}
	
	function medicTreatCuredDiseases(cityId, cubes) {
	  return { type: types.MEDIC_TREAT_CURED_DISEASES, cityId: cityId, cubes: cubes };
	}
	
	function medicPreventInfection(playerId, cityId, color, count) {
	  return { type: types.MEDIC_PREVENT_INFECTION, playerId: playerId, cityId: cityId, color: color, count: count };
	}
	
	function quarSpecPreventInfection(playerId, cityId, color, count) {
	  return { type: types.QUAR_SPEC_PREVENT_INFECTION, playerId: playerId, cityId: cityId, color: color, count: count };
	}

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card = function Card(_ref) {
	  var cardType = _ref.cardType,
	      id = _ref.id,
	      className = _ref.className;
	  return _react2.default.createElement('div', { className: 'card ' + cardType + ' ' + cardType + '-' + id + ' ' + className });
	};
	
	Card.propTypes = _extends({}, _propTypes.cardProps, {
	  className: _react.PropTypes.string
	});
	
	exports.default = Card;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IMAGES_TO_PRELOAD = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.mapCoords = mapCoords;
	exports.getPathCoords = getPathCoords;
	exports.getLocationOrigin = getLocationOrigin;
	exports.getCubeOrigin = getCubeOrigin;
	exports.getInfectionCardOrigin = getInfectionCardOrigin;
	exports.splitPath = splitPath;
	exports.getLength = getLength;
	exports.constrainCubeMovement = constrainCubeMovement;
	
	var _path = __webpack_require__(168);
	
	var _path2 = _interopRequireDefault(_path);
	
	var _styles = __webpack_require__(360);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getMapRatio(width, height) {
	  if (width / height > _styles.map.width / _styles.map.height) {
	    return height / _styles.map.height;
	  } else {
	    return width / _styles.map.width;
	  }
	}
	
	function mapCoords(coords) {
	  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _styles.map.width;
	  var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _styles.map.height;
	
	  var ratio = getMapRatio(width, height);
	  return [coords[0] * ratio, coords[1] * ratio];
	}
	
	function getPathCoords(loc) {
	  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _styles.map.width;
	  var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _styles.map.height;
	
	  return mapCoords(loc.coords, width, height);
	}
	
	function getLocationOrigin(loc) {
	  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _styles.map.width;
	  var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _styles.map.height;
	
	  var ratio = getMapRatio(width, height);
	  return { top: loc.coords[0] * ratio - 16, left: loc.coords[1] * ratio - 16 };
	}
	
	function getCubeOrigin(loc) {
	  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _styles.map.width;
	  var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _styles.map.height;
	
	  var ratio = getMapRatio(width, height);
	  return { top: loc.coords[0] * ratio - 12, left: loc.coords[1] * ratio - 12 };
	}
	
	function getInfectionCardOrigin(loc) {
	  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _styles.map.width;
	  var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _styles.map.height;
	
	  var ratio = getMapRatio(width, height);
	  return { top: loc.coords[0] * ratio - 16, left: loc.coords[1] * ratio + 10 };
	}
	
	function splitPath(_ref, _ref2, width) {
	  var _ref4 = _slicedToArray(_ref, 2),
	      x1 = _ref4[0],
	      y1 = _ref4[1];
	
	  var _ref3 = _slicedToArray(_ref2, 2),
	      x2 = _ref3[0],
	      y2 = _ref3[1];
	
	  var SPLIT_PATH_HEURISTIC = 0.25;
	
	  if (x1 < SPLIT_PATH_HEURISTIC * width && x2 > (1 - SPLIT_PATH_HEURISTIC) * width) {
	    return [[[x1, y1], [-(width - x2), y2]], [[width + x1, y1], [x2, y2]]];
	  } else if (x2 < SPLIT_PATH_HEURISTIC * width && x1 > (1 - SPLIT_PATH_HEURISTIC) * width) {
	    return [[[x1, y1], [width + x2, y2]], [[-(width - x1), y1], [x2, y2]]];
	  } else {
	    return null;
	  }
	}
	
	function getLength(_ref5, _ref6) {
	  var _ref8 = _slicedToArray(_ref5, 2),
	      x1 = _ref8[0],
	      y1 = _ref8[1];
	
	  var _ref7 = _slicedToArray(_ref6, 2),
	      x2 = _ref7[0],
	      y2 = _ref7[1];
	
	  return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
	}
	
	function constrainCubeMovement(_ref9, _ref10, width) {
	  var _ref12 = _slicedToArray(_ref9, 2),
	      xIn = _ref12[0],
	      yIn = _ref12[1];
	
	  var _ref11 = _slicedToArray(_ref10, 2),
	      xOut = _ref11[0],
	      yOut = _ref11[1];
	
	  var DELTA = 24;
	  var newX = void 0;
	  if (xOut < 0) {
	    newX = -DELTA;
	  } else if (xOut > width) {
	    newX = width + DELTA;
	  }
	  var newY = (yOut - yIn) / (xOut - xIn) * newX + yIn - xIn * (yOut - yIn) / (xOut - xIn);
	  return [newX, newY];
	}
	
	var IMAGES_TO_PRELOAD = exports.IMAGES_TO_PRELOAD = function () {
	  var context = __webpack_require__(1726);
	  return Object.freeze(context.keys().map(function (k) {
	    return _path2.default.basename(context(k));
	  }));
	}();

/***/ },
/* 95 */
49,
/* 96 */
[1749, 120, 365, 251, 84],
/* 97 */
[1764, 366, 243],
/* 98 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(56);
	var call = __webpack_require__(387);
	var isArrayIter = __webpack_require__(263);
	var anObject = __webpack_require__(11);
	var toLength = __webpack_require__(26);
	var getIterFn = __webpack_require__(279);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 100 */
[1748, 11, 393, 259, 272, 258, 261],
/* 101 */
[1753, 395, 259],
/* 102 */
[1756, 395, 259],
/* 103 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(43);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(13);
	var dP = __webpack_require__(30);
	var DESCRIPTORS = __webpack_require__(27);
	var SPECIES = __webpack_require__(24)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 106 */
[1763, 58],
/* 107 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}

/***/ },
/* 110 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 111 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 112 */
[1785, 19],
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(1);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(91);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes2 = __webpack_require__(348);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(134);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(1664);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(529);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(1658);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(1677);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(1659);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(1660);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(530);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(1662);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _History2 = __webpack_require__(1657);
	
	var _History3 = _interopRequireDefault(_History2);
	
	var _Lifecycle2 = __webpack_require__(1661);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	var _RouteContext2 = __webpack_require__(1663);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	var _useRoutes2 = __webpack_require__(1676);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	var _RouterContext2 = __webpack_require__(229);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _RoutingContext2 = __webpack_require__(1665);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	var _match2 = __webpack_require__(1674);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(535);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(1667);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(1668);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(1672);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(532);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* mixins */
	
	exports.History = _History3.default;
	exports.Lifecycle = _Lifecycle3.default;
	exports.RouteContext = _RouteContext3.default;
	
	/* utils */
	
	exports.useRoutes = _useRoutes3.default;
	exports.RouterContext = _RouterContext3.default;
	exports.RoutingContext = _RoutingContext3.default;
	exports.PropTypes = _PropTypes3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(351);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(1706);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(1705);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(1704);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(545);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(546);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Browsers, browserslist, utils;
	
	  browserslist = __webpack_require__(240);
	
	  utils = __webpack_require__(41);
	
	  Browsers = (function() {
	    Browsers.prefixes = function() {
	      var data, i, name;
	      if (this.prefixesCache) {
	        return this.prefixesCache;
	      }
	      data = __webpack_require__(292).agents;
	      return this.prefixesCache = utils.uniq((function() {
	        var results;
	        results = [];
	        for (name in data) {
	          i = data[name];
	          results.push("-" + i.prefix + "-");
	        }
	        return results;
	      })()).sort(function(a, b) {
	        return b.length - a.length;
	      });
	    };
	
	    Browsers.withPrefix = function(value) {
	      if (!this.prefixesRegexp) {
	        this.prefixesRegexp = RegExp("" + (this.prefixes().join('|')));
	      }
	      return this.prefixesRegexp.test(value);
	    };
	
	    function Browsers(data1, requirements, options, stats) {
	      this.data = data1;
	      this.options = options;
	      this.stats = stats;
	      this.selected = this.parse(requirements);
	    }
	
	    Browsers.prototype.parse = function(requirements) {
	      var ref, ref1;
	      return browserslist(requirements, {
	        stats: this.stats,
	        path: (ref = this.options) != null ? ref.from : void 0,
	        env: (ref1 = this.options) != null ? ref1.env : void 0
	      });
	    };
	
	    Browsers.prototype.browsers = function(criteria) {
	      var browser, data, ref, selected, versions;
	      selected = [];
	      ref = this.data;
	      for (browser in ref) {
	        data = ref[browser];
	        versions = criteria(data).map(function(version) {
	          return browser + " " + version;
	        });
	        selected = selected.concat(versions);
	      }
	      return selected;
	    };
	
	    Browsers.prototype.prefix = function(browser) {
	      var data, name, prefix, ref, version;
	      ref = browser.split(' '), name = ref[0], version = ref[1];
	      data = this.data[name];
	      if (data.prefix_exceptions) {
	        prefix = data.prefix_exceptions[version];
	      }
	      prefix || (prefix = data.prefix);
	      return '-' + prefix + '-';
	    };
	
	    Browsers.prototype.isSelected = function(browser) {
	      return this.selected.indexOf(browser) !== -1;
	    };
	
	    return Browsers;
	
	  })();
	
	  module.exports = Browsers;
	
	}).call(this);


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.moveInit = moveInit;
	exports.moveShowCities = moveShowCities;
	exports.moveToCity = moveToCity;
	exports.moveComplete = moveComplete;
	exports.moveCancel = moveCancel;
	exports.buildStation = buildStation;
	exports.govGrantShowCities = govGrantShowCities;
	exports.govGrantBuildStation = govGrantBuildStation;
	exports.airliftChoosePlayer = airliftChoosePlayer;
	exports.airliftShowCities = airliftShowCities;
	exports.airliftMoveToCity = airliftMoveToCity;
	exports.dispatcherChoosePlayer = dispatcherChoosePlayer;
	exports.dispatcherShowCities = dispatcherShowCities;
	
	var _actionTypes = __webpack_require__(25);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function moveInit(playerId) {
	  return { type: types.PLAYER_MOVE_INIT, playerId: playerId };
	}
	
	function moveShowCities(cities) {
	  return { type: types.PLAYER_MOVE_SHOW_CITIES, cities: cities };
	}
	
	function moveToCity(playerId, originId, destinationId, source) {
	  return { type: types.PLAYER_MOVE_TO_CITY, playerId: playerId, originId: originId, destinationId: destinationId, source: source };
	}
	
	function moveComplete() {
	  return { type: types.PLAYER_MOVE_COMPLETE };
	}
	
	function moveCancel() {
	  return { type: types.PLAYER_MOVE_CANCEL };
	}
	
	function buildStation(cityId) {
	  return { type: types.PLAYER_BUILD_STATION, cityId: cityId };
	}
	
	function govGrantShowCities(cities) {
	  return { type: types.EVENT_GOV_GRANT_SHOW_CITIES, cities: cities };
	}
	
	function govGrantBuildStation(cityId) {
	  return { type: types.EVENT_GOV_GRANT_BUILD_STATION, cityId: cityId };
	}
	
	function airliftChoosePlayer(playerId) {
	  return { type: types.EVENT_AIRLIFT_CHOOSE_PLAYER, playerId: playerId };
	}
	
	function airliftShowCities(cities) {
	  return { type: types.EVENT_AIRLIFT_SHOW_CITIES, cities: cities };
	}
	
	function airliftMoveToCity(playerId, destinationId) {
	  return { type: types.EVENT_AIRLIFT_MOVE_TO_CITY, playerId: playerId, destinationId: destinationId };
	}
	
	function dispatcherChoosePlayer(playerId) {
	  return { type: types.DISPATCHER_CHOOSE_PLAYER, playerId: playerId };
	}
	
	function dispatcherShowCities(cities) {
	  return { type: types.DISPATCHER_SHOW_CITIES, cities: cities };
	}

/***/ },
/* 118 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Object.freeze({
	  cont_planner: {
	    id: 'cont_planner',
	    name: 'Contingency Planner',
	    description: ['The Contingency Planner may, as an action, take an Event card from anywhere\n      in the Player Discard Pile and place it on his Role card. Only 1 Event card can be on his\n      role card at a time. It does not count against his hand limit.', 'When the Contingency Planner\n      plays the Event card on his role card, remove this Event card from the game (instead of discarding it).']
	  },
	
	  dispatcher: {
	    id: 'dispatcher',
	    name: 'Dispatcher',
	    description: ['The Dispatcher may, as an action, either:', '\u2022 move any pawn, if its owner agrees, to any city containing another pawn, or', '\u2022 move another player\u2019s pawn, if its owner agrees, as if it were his own.', 'The Dispatcher can only move other players\u2019 pawns; he may not direct them to do other actions,\n      such as Treat Disease.']
	  },
	
	  medic: {
	    id: 'medic',
	    name: 'Medic',
	    description: ['The Medic removes all cubes, not 1, of the same color when doing the Treat Disease action.', 'If a disease has been cured, he automatically removes all cubes of that color from a city,\n      simply by entering it or being there. This does not take an action.', 'The Medic also prevents placing disease cubes (and outbreaks) of cured diseases in his location.']
	  },
	
	  ops_expert: {
	    id: 'ops_expert',
	    name: 'Operations Expert',
	    description: ['The Operations Expert may, as an action, either:', '\u2022 build a research station in his current city without discarding (or using) a City card, or', '\u2022 once per turn, move from a research station to any city by discarding any City card.']
	  },
	
	  quar_spec: {
	    id: 'quar_spec',
	    name: 'Quarantine Specialist',
	    description: ['The Quarantine Specialist prevents both outbreaks and the placement of disease cubes\n      in the city she is in and all cities connected to that city. She does not affect cubes placed during setup.']
	  },
	
	  researcher: {
	    id: 'researcher',
	    name: 'Researcher',
	    description: ['As an action, the Researcher may give any City card from her hand to another player\n      in the same city as her, without this card having to match her city. The transfer must be from\n      her hand to the other player\u2019s hand, but it can occur on either player\u2019s turn.']
	  },
	
	  scientist: {
	    id: 'scientist',
	    name: 'Scientist',
	    description: ['The Scientist needs only 4 (not 5) City cards of the same disease color\n      to Discover a Cure for that disease.']
	  }
	});

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(701), __esModule: true };

/***/ },
/* 120 */
[1728, 122],
/* 121 */
[1736, 96, 146, 84],
/* 122 */
18,
/* 123 */
[1730, 54, 24],
/* 124 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 125 */
[1759, 30, 49, 24],
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var defined = __webpack_require__(63);
	var fails = __webpack_require__(15);
	var spaces = __webpack_require__(275);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ },
/* 127 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(29);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(76));
	
	var _default = function () {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  return _inDOM.default ? function (context, node) {
	    if (context.contains) {
	      return context.contains(node);
	    } else if (context.compareDocumentPosition) {
	      return context === node || !!(context.compareDocumentPosition(node) & 16);
	    } else {
	      return fallback(context, node);
	    }
	  } : fallback;
	}();
	
	exports.default = _default;
	
	function fallback(context, node) {
	  if (node) do {
	    if (node === context) return true;
	  } while (node = node.parentNode);
	  return false;
	}
	
	module.exports = exports["default"];

/***/ },
/* 129 */
/***/ function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ },
/* 130 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Contains helpers for working with vendor prefixes.
	 *
	 * @example
	 * const vendor = postcss.vendor;
	 *
	 * @namespace vendor
	 */
	var vendor = {
	
	    /**
	     * Returns the vendor prefix extracted from an input string.
	     *
	     * @param {string} prop - string with or without vendor prefix
	     *
	     * @return {string} vendor prefix or empty string
	     *
	     * @example
	     * postcss.vendor.prefix('-moz-tab-size') //=> '-moz-'
	     * postcss.vendor.prefix('tab-size')      //=> ''
	     */
	    prefix: function prefix(prop) {
	        var match = prop.match(/^(-\w+-)/);
	        if (match) {
	            return match[0];
	        } else {
	            return '';
	        }
	    },
	
	
	    /**
	     * Returns the input string stripped of its vendor prefix.
	     *
	     * @param {string} prop - string with or without vendor prefix
	     *
	     * @return {string} string name without vendor prefixes
	     *
	     * @example
	     * postcss.vendor.unprefixed('-moz-tab-size') //=> 'tab-size'
	     */
	    unprefixed: function unprefixed(prop) {
	        return prop.replace(/^-\w+-/, '');
	    }
	};
	
	exports.default = vendor;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(329);
	var setInnerHTML = __webpack_require__(225);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(337);
	var setTextContent = __webpack_require__(514);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var invariant = __webpack_require__(12);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(1612);
	var ReactInstrumentation = __webpack_require__(59);
	
	var warning = __webpack_require__(20);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames;
	  var paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(31);
	
	var ReactBaseClasses = __webpack_require__(537);
	var ReactChildren = __webpack_require__(1685);
	var ReactDOMFactories = __webpack_require__(1686);
	var ReactElement = __webpack_require__(136);
	var ReactPropTypes = __webpack_require__(1687);
	var ReactVersion = __webpack_require__(1688);
	
	var createReactClass = __webpack_require__(1689);
	var onlyChild = __webpack_require__(1693);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(31);
	
	var ReactCurrentOwner = __webpack_require__(81);
	
	var warning = __webpack_require__(20);
	var canDefineProperty = __webpack_require__(541);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(539);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.utils = exports.effects = exports.CANCEL = exports.delay = exports.takeLatest = exports.takeEvery = exports.buffers = exports.channel = exports.eventChannel = exports.END = exports.runSaga = undefined;
	
	var _runSaga = __webpack_require__(1697);
	
	Object.defineProperty(exports, 'runSaga', {
	  enumerable: true,
	  get: function get() {
	    return _runSaga.runSaga;
	  }
	});
	
	var _channel = __webpack_require__(231);
	
	Object.defineProperty(exports, 'END', {
	  enumerable: true,
	  get: function get() {
	    return _channel.END;
	  }
	});
	Object.defineProperty(exports, 'eventChannel', {
	  enumerable: true,
	  get: function get() {
	    return _channel.eventChannel;
	  }
	});
	Object.defineProperty(exports, 'channel', {
	  enumerable: true,
	  get: function get() {
	    return _channel.channel;
	  }
	});
	
	var _buffers = __webpack_require__(350);
	
	Object.defineProperty(exports, 'buffers', {
	  enumerable: true,
	  get: function get() {
	    return _buffers.buffers;
	  }
	});
	
	var _sagaHelpers = __webpack_require__(1698);
	
	Object.defineProperty(exports, 'takeEvery', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.takeEvery;
	  }
	});
	Object.defineProperty(exports, 'takeLatest', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.takeLatest;
	  }
	});
	
	var _utils = __webpack_require__(82);
	
	Object.defineProperty(exports, 'delay', {
	  enumerable: true,
	  get: function get() {
	    return _utils.delay;
	  }
	});
	Object.defineProperty(exports, 'CANCEL', {
	  enumerable: true,
	  get: function get() {
	    return _utils.CANCEL;
	  }
	});
	
	var _middleware = __webpack_require__(1696);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	var _effects = __webpack_require__(542);
	
	var effects = _interopRequireWildcard(_effects);
	
	var _utils2 = __webpack_require__(1699);
	
	var utils = _interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _middleware2.default;
	exports.effects = effects;
	exports.utils = utils;

/***/ },
/* 138 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Browsers, Prefixer, clone, utils, vendor,
	    hasProp = {}.hasOwnProperty;
	
	  Browsers = __webpack_require__(116);
	
	  utils = __webpack_require__(41);
	
	  vendor = __webpack_require__(130);
	
	  clone = function(obj, parent) {
	    var cloned, i, value;
	    cloned = new obj.constructor();
	    for (i in obj) {
	      if (!hasProp.call(obj, i)) continue;
	      value = obj[i];
	      if (i === 'parent' && typeof value === 'object') {
	        if (parent) {
	          cloned[i] = parent;
	        }
	      } else if (i === 'source') {
	        cloned[i] = value;
	      } else if (i === null) {
	        cloned[i] = value;
	      } else if (value instanceof Array) {
	        cloned[i] = value.map(function(i) {
	          return clone(i, cloned);
	        });
	      } else if (i !== '_autoprefixerPrefix' && i !== '_autoprefixerValues') {
	        if (typeof value === 'object' && value !== null) {
	          value = clone(value, cloned);
	        }
	        cloned[i] = value;
	      }
	    }
	    return cloned;
	  };
	
	  Prefixer = (function() {
	    Prefixer.hack = function(klass) {
	      var j, len, name, ref, results;
	      this.hacks || (this.hacks = {});
	      ref = klass.names;
	      results = [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        name = ref[j];
	        results.push(this.hacks[name] = klass);
	      }
	      return results;
	    };
	
	    Prefixer.load = function(name, prefixes, all) {
	      var klass, ref;
	      klass = (ref = this.hacks) != null ? ref[name] : void 0;
	      if (klass) {
	        return new klass(name, prefixes, all);
	      } else {
	        return new this(name, prefixes, all);
	      }
	    };
	
	    Prefixer.clone = function(node, overrides) {
	      var cloned, name;
	      cloned = clone(node);
	      for (name in overrides) {
	        cloned[name] = overrides[name];
	      }
	      return cloned;
	    };
	
	    function Prefixer(name1, prefixes1, all1) {
	      this.name = name1;
	      this.prefixes = prefixes1;
	      this.all = all1;
	    }
	
	    Prefixer.prototype.parentPrefix = function(node) {
	      var prefix;
	      prefix = node._autoprefixerPrefix != null ? node._autoprefixerPrefix : node.type === 'decl' && node.prop[0] === '-' ? vendor.prefix(node.prop) : node.type === 'root' ? false : node.type === 'rule' && node.selector.indexOf(':-') !== -1 && /:(-\w+-)/.test(node.selector) ? node.selector.match(/:(-\w+-)/)[1] : node.type === 'atrule' && node.name[0] === '-' ? vendor.prefix(node.name) : this.parentPrefix(node.parent);
	      if (Browsers.prefixes().indexOf(prefix) === -1) {
	        prefix = false;
	      }
	      return node._autoprefixerPrefix = prefix;
	    };
	
	    Prefixer.prototype.process = function(node) {
	      var added, j, k, len, len1, parent, prefix, prefixes, ref;
	      if (!this.check(node)) {
	        return;
	      }
	      parent = this.parentPrefix(node);
	      prefixes = [];
	      ref = this.prefixes;
	      for (j = 0, len = ref.length; j < len; j++) {
	        prefix = ref[j];
	        if (parent && parent !== utils.removeNote(prefix)) {
	          continue;
	        }
	        prefixes.push(prefix);
	      }
	      added = [];
	      for (k = 0, len1 = prefixes.length; k < len1; k++) {
	        prefix = prefixes[k];
	        if (this.add(node, prefix, added.concat([prefix]))) {
	          added.push(prefix);
	        }
	      }
	      return added;
	    };
	
	    Prefixer.prototype.clone = function(node, overrides) {
	      return Prefixer.clone(node, overrides);
	    };
	
	    return Prefixer;
	
	  })();
	
	  module.exports = Prefixer;
	
	}).call(this);


/***/ },
/* 140 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Object.freeze({
	  forecast: {
	    id: 'forecast',
	    name: 'Forecast',
	    description: 'Draw, look at, and rearrange the top 6 cars of the Infection Deck.\n      Put them back on top.'
	  },
	  one_quiet_night: {
	    id: 'one_quiet_night',
	    name: 'One Quiet Night',
	    description: 'Skip the next Infect Cities step (do not flip over any Infection cards).'
	  },
	  gov_grant: {
	    id: 'gov_grant',
	    name: 'Government Grant',
	    description: 'Add 1 research station to any city (no City card needed).'
	  },
	  res_pop: {
	    id: 'res_pop',
	    name: 'Resilient Population',
	    description: 'Remove any 1 card in the Infection Discard Pile from the game.\n      You may play this between the Infect and Intensify steps of an epidemic.'
	  },
	  airlift: {
	    id: 'airlift',
	    name: 'Airlift',
	    description: 'Move any 1 pawn to any city. Get permission before moving another player\'s pawn.'
	  }
	});

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.getCurrentCityId = getCurrentCityId;
	exports.getAvailableCities = getAvailableCities;
	exports.isDriveAvailable = isDriveAvailable;
	exports.getMedicInCity = getMedicInCity;
	exports.getMedicInTeam = getMedicInTeam;
	exports.getCitiesForGovGrant = getCitiesForGovGrant;
	exports.getCitiesForAirlift = getCitiesForAirlift;
	exports.getCitiesForDispatcher = getCitiesForDispatcher;
	exports.getCubesInCity = getCubesInCity;
	exports.getCityColor = getCityColor;
	exports.getNeighborCities = getNeighborCities;
	exports.getQuarSpecInProximity = getQuarSpecInProximity;
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _hand = __webpack_require__(180);
	
	var _map = __webpack_require__(181);
	
	var _gameplay = __webpack_require__(179);
	
	var _cities = __webpack_require__(235);
	
	var _cities2 = _interopRequireDefault(_cities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function getCurrentCityId(state) {
	  var currentPlayer = (0, _gameplay.getCurrentPlayer)(state);
	  return currentPlayer ? (0, _map.getPlayerCityId)(state, currentPlayer.id) : null;
	}
	
	function getAvailableCities(state) {
	  var cityId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
	  var player = (0, _gameplay.getCurrentPlayer)(state);
	  if (!cityId) {
	    cityId = getCurrentCityId(state);
	  }
	
	  var direct = reduceWithAttrs((0, _hand.getCitiesInPlayersHand)(state, player.id), { source: 'direct' });
	  var neighbors = reduceWithAttrs(getNeighborCities(state, cityId), { source: 'drive' });
	  var charters = (0, _hand.hasCityInHand)(state, cityId) ? reduceWithAttrs(_cities2.default, { source: 'charter' }) : {};
	  var stations = (0, _map.isStation)(state, cityId) ? reduceWithAttrs(getStationCities(state), { source: 'shuttle' }) : {};
	  var opsCities = (0, _map.isAtStation)(state) && (0, _gameplay.getCurrentRole)(state) === 'ops_expert' && !(0, _gameplay.hasOpsUsedMoveAbility)(state) ? reduceWithAttrs(_lodash2.default.values(_cities2.default), { source: 'ops' }) : {};
	  var result = _lodash2.default.assign({}, opsCities, charters, direct, neighbors, stations);
	  delete result[cityId];
	  return result;
	}
	
	function isDriveAvailable(state, destinationId) {
	  var cityId = getCurrentCityId(state);
	  return !!_lodash2.default.find(getNeighborCities(state, cityId), { id: destinationId });
	}
	
	function getMedicInCity(state, cityId) {
	  return getRoleInCity(state, cityId, 'medic');
	}
	
	function getMedicInTeam(state) {
	  return _lodash2.default.find(state.players, function (p) {
	    return (0, _gameplay.getPlayerRole)(state, p.id) === 'medic';
	  });
	}
	
	function getCitiesForGovGrant(state) {
	  return _lodash2.default.values(_cities2.default).filter(function (c) {
	    return !state.map.locations[c.id].station;
	  });
	}
	
	function getCitiesForAirlift(state, playerId) {
	  return _lodash2.default.values(_cities2.default).filter(function (c) {
	    return c.id !== (0, _map.getPlayerCityId)(state, playerId);
	  });
	}
	
	function getCitiesForDispatcher(state, playerId) {
	  var locs = state.map.playersLocations;
	  var otherLocs = _lodash2.default.omitBy(locs, function (loc, id) {
	    return id === playerId || loc === locs[playerId];
	  });
	  var otherPlayersCities = reduceWithAttrs(_lodash2.default.values(otherLocs).map(function (id) {
	    return _cities2.default[id];
	  }), { source: 'dispatcher' });
	  return _extends({}, getAvailableCities(state, locs[playerId]), otherPlayersCities);
	}
	
	function getCubesInCity(state, cityId, color) {
	  return state.map.locations[cityId][color];
	}
	
	function getCityColor(state, cityId) {
	  return _cities2.default[cityId].color;
	}
	
	function getNeighborCities(state, cityId) {
	  var result = [];
	  state.map.matrix[cityId].forEach(function (item, i) {
	    if (item === 1) {
	      result.push(_cities2.default[i]);
	    }
	  });
	  return result;
	}
	
	function getQuarSpecInProximity(state, cityId) {
	  var result = [_cities2.default[cityId]].concat(_toConsumableArray(getNeighborCities(state, cityId)));
	  return _lodash2.default.find(result, function (c) {
	    return getQuarSpecInCity(state, c.id);
	  });
	}
	
	function getQuarSpecInCity(state, cityId) {
	  return getRoleInCity(state, cityId, 'quar_spec');
	}
	
	function getRoleInCity(state, cityId, role) {
	  return _lodash2.default.findKey(state.map.playersLocations, function (loc, playerId) {
	    return loc === cityId && (0, _gameplay.getPlayerRole)(state, playerId) === role;
	  });
	}
	
	function getStationCities(state) {
	  var cityIds = _lodash2.default.chain(state.map.locations).map(function (loc, id) {
	    if (loc.station) {
	      return id;
	    }
	  }).compact().value();
	  return cityIds.map(function (c) {
	    return _cities2.default[c];
	  });
	}
	
	function reduceWithAttrs(array) {
	  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return _lodash2.default.reduce(array, function (acc, c) {
	    acc[c.id] = _extends({}, c, attrs);return acc;
	  }, {});
	}

/***/ },
/* 142 */
15,
/* 143 */
124,
/* 144 */
[1756, 370, 244],
/* 145 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 146 */
103,
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(11);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ },
/* 148 */
[1739, 54],
/* 149 */
145,
/* 150 */
[1761, 55, 13, 88],
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(11);
	var aFunction = __webpack_require__(38);
	var SPECIES = __webpack_require__(24)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(454);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
	
	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var origDefineProperty = Object.defineProperty;
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var arePropertyDescriptorsSupported = function () {
		var obj = {};
		try {
			origDefineProperty(obj, 'x', { enumerable: false, value: obj });
			// eslint-disable-next-line no-unused-vars, no-restricted-syntax
			for (var _ in obj) { // jscs:ignore disallowUnusedVariables
				return false;
			}
			return obj.x === obj;
		} catch (e) { /* this is IE 8. */
			return false;
		}
	};
	var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object && (!isFunction(predicate) || !predicate())) {
			return;
		}
		if (supportsDescriptors) {
			origDefineProperty(object, name, {
				configurable: true,
				enumerable: false,
				value: value,
				writable: true
			});
		} else {
			object[name] = value;
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(1083);
	
	module.exports = Function.prototype.bind || implementation;


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	
	var Pipe = __webpack_require__(208).Pipe;
	
	var Context = function Context(){
	};
	
	Context.prototype.setResult = function(result) {
		this.result = result;
		this.hasResult = true;
		return this;
	};
	
	Context.prototype.exit = function() {
		this.exiting = true;
		return this;
	};
	
	Context.prototype.switchTo = function(next, pipe) {
		if (typeof next === 'string' || next instanceof Pipe) {
			this.nextPipe = next;
		} else {
			this.next = next;
			if (pipe) {
				this.nextPipe = pipe;
			}
		}
		return this;
	};
	
	Context.prototype.push = function(child, name) {
		child.parent = this;
		if (typeof name !== 'undefined') {
			child.childName = name;
		}
		child.root = this.root || this;
		child.options = child.options || this.options;
		if (!this.children) {
			this.children = [child];
			this.nextAfterChildren = this.next || null;
			this.next = child;
		} else {
			this.children[this.children.length - 1].next = child;
			this.children.push(child);
		}
		child.next = this;
		return this;
	};
	
	exports.Context = Context;


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var Context = __webpack_require__(154).Context;
	var dateReviver = __webpack_require__(206);
	
	var DiffContext = function DiffContext(left, right) {
	  this.left = left;
	  this.right = right;
	  this.pipe = 'diff';
	};
	
	DiffContext.prototype = new Context();
	
	DiffContext.prototype.setResult = function(result) {
	  if (this.options.cloneDiffValues) {
	    var clone = typeof this.options.cloneDiffValues === 'function' ?
	      this.options.cloneDiffValues : function(value) {
	        return JSON.parse(JSON.stringify(value), dateReviver);
	      };
	    if (typeof result[0] === 'object') {
	      result[0] = clone(result[0]);
	    }
	    if (typeof result[1] === 'object') {
	      result[1] = clone(result[1]);
	    }
	  }
	  return Context.prototype.setResult.apply(this, arguments);
	};
	
	exports.DiffContext = DiffContext;


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	var Context = __webpack_require__(154).Context;
	
	var PatchContext = function PatchContext(left, delta) {
	  this.left = left;
	  this.delta = delta;
	  this.pipe = 'patch';
	};
	
	PatchContext.prototype = new Context();
	
	exports.PatchContext = PatchContext;


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var Context = __webpack_require__(154).Context;
	
	var ReverseContext = function ReverseContext(delta) {
	  this.delta = delta;
	  this.pipe = 'reverse';
	};
	
	ReverseContext.prototype = new Context();
	
	exports.ReverseContext = ReverseContext;


/***/ },
/* 158 */
/***/ function(module, exports) {

	
	exports.isBrowser = typeof window !== 'undefined';


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	var base = __webpack_require__(77);
	var BaseFormatter = base.BaseFormatter;
	
	var AnnotatedFormatter = function AnnotatedFormatter() {
	  this.includeMoveDestinations = false;
	};
	
	AnnotatedFormatter.prototype = new BaseFormatter();
	
	AnnotatedFormatter.prototype.prepareContext = function(context) {
	  BaseFormatter.prototype.prepareContext.call(this, context);
	  context.indent = function(levels) {
	    this.indentLevel = (this.indentLevel || 0) +
	      (typeof levels === 'undefined' ? 1 : levels);
	    this.indentPad = new Array(this.indentLevel + 1).join('&nbsp;&nbsp;');
	  };
	  context.row = function(json, htmlNote) {
	    context.out('<tr><td style="white-space: nowrap;">' +
	      '<pre class="jsondiffpatch-annotated-indent" style="display: inline-block">');
	    context.out(context.indentPad);
	    context.out('</pre><pre style="display: inline-block">');
	    context.out(json);
	    context.out('</pre></td><td class="jsondiffpatch-delta-note"><div>');
	    context.out(htmlNote);
	    context.out('</div></td></tr>');
	  };
	};
	
	AnnotatedFormatter.prototype.typeFormattterErrorFormatter = function(context, err) {
	  context.row('', '<pre class="jsondiffpatch-error">' + err + '</pre>');
	};
	
	AnnotatedFormatter.prototype.formatTextDiffString = function(context, value) {
	  var lines = this.parseTextDiff(value);
	  context.out('<ul class="jsondiffpatch-textdiff">');
	  for (var i = 0, l = lines.length; i < l; i++) {
	    var line = lines[i];
	    context.out('<li>' +
	      '<div class="jsondiffpatch-textdiff-location">' +
	      '<span class="jsondiffpatch-textdiff-line-number">' +
	      line.location.line +
	      '</span>' +
	      '<span class="jsondiffpatch-textdiff-char">' +
	      line.location.chr +
	      '</span>' +
	      '</div>' +
	      '<div class="jsondiffpatch-textdiff-line">');
	    var pieces = line.pieces;
	    for (var pieceIndex = 0, piecesLength = pieces.length; pieceIndex < piecesLength; pieceIndex++) {
	      var piece = pieces[pieceIndex];
	      context.out('<span class="jsondiffpatch-textdiff-' + piece.type + '">' +
	        piece.text + '</span>');
	    }
	    context.out('</div></li>');
	  }
	  context.out('</ul>');
	};
	
	AnnotatedFormatter.prototype.rootBegin = function(context, type, nodeType) {
	  context.out('<table class="jsondiffpatch-annotated-delta">');
	  if (type === 'node') {
	    context.row('{');
	    context.indent();
	  }
	  if (nodeType === 'array') {
	    context.row('"_t": "a",', 'Array delta (member names indicate array indices)');
	  }
	};
	
	AnnotatedFormatter.prototype.rootEnd = function(context, type) {
	  if (type === 'node') {
	    context.indent(-1);
	    context.row('}');
	  }
	  context.out('</table>');
	};
	
	AnnotatedFormatter.prototype.nodeBegin = function(context, key, leftKey, type, nodeType) {
	  context.row('&quot;' + key + '&quot;: {');
	  if (type === 'node') {
	    context.indent();
	  }
	  if (nodeType === 'array') {
	    context.row('"_t": "a",', 'Array delta (member names indicate array indices)');
	  }
	};
	
	AnnotatedFormatter.prototype.nodeEnd = function(context, key, leftKey, type, nodeType, isLast) {
	  if (type === 'node') {
	    context.indent(-1);
	  }
	  context.row('}' + (isLast ? '' : ','));
	};
	
	/* jshint camelcase: false */
	
	AnnotatedFormatter.prototype.format_unchanged = function() {
	  return;
	};
	
	AnnotatedFormatter.prototype.format_movedestination = function() {
	  return;
	};
	
	
	AnnotatedFormatter.prototype.format_node = function(context, delta, left) {
	  // recurse
	  this.formatDeltaChildren(context, delta, left);
	};
	
	var wrapPropertyName = function(name) {
	  return '<pre style="display:inline-block">&quot;' + name + '&quot;</pre>';
	};
	
	var deltaAnnotations = {
	  added: function(delta, left, key, leftKey) {
	    var formatLegend = ' <pre>([newValue])</pre>';
	    if (typeof leftKey === 'undefined') {
	      return 'new value' + formatLegend;
	    }
	    if (typeof leftKey === 'number') {
	      return 'insert at index ' + leftKey + formatLegend;
	    }
	    return 'add property ' + wrapPropertyName(leftKey) + formatLegend;
	  },
	  modified: function(delta, left, key, leftKey) {
	    var formatLegend = ' <pre>([previousValue, newValue])</pre>';
	    if (typeof leftKey === 'undefined') {
	      return 'modify value' + formatLegend;
	    }
	    if (typeof leftKey === 'number') {
	      return 'modify at index ' + leftKey + formatLegend;
	    }
	    return 'modify property ' + wrapPropertyName(leftKey) + formatLegend;
	  },
	  deleted: function(delta, left, key, leftKey) {
	    var formatLegend = ' <pre>([previousValue, 0, 0])</pre>';
	    if (typeof leftKey === 'undefined') {
	      return 'delete value' + formatLegend;
	    }
	    if (typeof leftKey === 'number') {
	      return 'remove index ' + leftKey + formatLegend;
	    }
	    return 'delete property ' + wrapPropertyName(leftKey) + formatLegend;
	  },
	  moved: function(delta, left, key, leftKey) {
	    return 'move from <span title="(position to remove at original state)">index ' +
	      leftKey + '</span> to ' +
	      '<span title="(position to insert at final state)">index ' +
	      delta[1] + '</span>';
	  },
	  textdiff: function(delta, left, key, leftKey) {
	    var location = (typeof leftKey === 'undefined') ?
	      '' : (
	        (typeof leftKey === 'number') ?
	        ' at index ' + leftKey :
	        ' at property ' + wrapPropertyName(leftKey)
	      );
	    return 'text diff' + location + ', format is ' +
	      '<a href="https://code.google.com/p/google-diff-match-patch/wiki/Unidiff">' +
	      'a variation of Unidiff</a>';
	  }
	};
	
	var formatAnyChange = function(context, delta) {
	  var deltaType = this.getDeltaType(delta);
	  var annotator = deltaAnnotations[deltaType];
	  var htmlNote = annotator && annotator.apply(annotator,
	    Array.prototype.slice.call(arguments, 1));
	  var json = JSON.stringify(delta, null, 2);
	  if (deltaType === 'textdiff') {
	    // split text diffs lines
	    json = json.split('\\n').join('\\n"+\n   "');
	  }
	  context.indent();
	  context.row(json, htmlNote);
	  context.indent(-1);
	};
	
	AnnotatedFormatter.prototype.format_added = formatAnyChange;
	AnnotatedFormatter.prototype.format_modified = formatAnyChange;
	AnnotatedFormatter.prototype.format_deleted = formatAnyChange;
	AnnotatedFormatter.prototype.format_moved = formatAnyChange;
	AnnotatedFormatter.prototype.format_textdiff = formatAnyChange;
	
	/* jshint camelcase: true */
	
	exports.AnnotatedFormatter = AnnotatedFormatter;
	
	var defaultInstance;
	
	exports.format = function(delta, left) {
	  if (!defaultInstance) {
	    defaultInstance = new AnnotatedFormatter();
	  }
	  return defaultInstance.format(delta, left);
	};


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	var base = __webpack_require__(77);
	var BaseFormatter = base.BaseFormatter;
	
	var HtmlFormatter = function HtmlFormatter() {};
	
	HtmlFormatter.prototype = new BaseFormatter();
	
	function htmlEscape(text) {
	  var html = text;
	  var replacements = [
	    [/&/g, '&amp;'],
	    [/</g, '&lt;'],
	    [/>/g, '&gt;'],
	    [/'/g, '&apos;'],
	    [/"/g, '&quot;']
	  ];
	  for (var i = 0; i < replacements.length; i++) {
	    html = html.replace(replacements[i][0], replacements[i][1]);
	  }
	  return html;
	}
	
	HtmlFormatter.prototype.typeFormattterErrorFormatter = function(context, err) {
	  context.out('<pre class="jsondiffpatch-error">' + err + '</pre>');
	};
	
	HtmlFormatter.prototype.formatValue = function(context, value) {
	  context.out('<pre>' + htmlEscape(JSON.stringify(value, null, 2)) + '</pre>');
	};
	
	HtmlFormatter.prototype.formatTextDiffString = function(context, value) {
	  var lines = this.parseTextDiff(value);
	  context.out('<ul class="jsondiffpatch-textdiff">');
	  for (var i = 0, l = lines.length; i < l; i++) {
	    var line = lines[i];
	    context.out('<li>' +
	      '<div class="jsondiffpatch-textdiff-location">' +
	      '<span class="jsondiffpatch-textdiff-line-number">' +
	      line.location.line +
	      '</span>' +
	      '<span class="jsondiffpatch-textdiff-char">' +
	      line.location.chr +
	      '</span>' +
	      '</div>' +
	      '<div class="jsondiffpatch-textdiff-line">');
	    var pieces = line.pieces;
	    for (var pieceIndex = 0, piecesLength = pieces.length; pieceIndex < piecesLength; pieceIndex++) {
	      /* global unescape */
	      var piece = pieces[pieceIndex];
	      context.out('<span class="jsondiffpatch-textdiff-' + piece.type + '">' +
	        htmlEscape(unescape(piece.text)) + '</span>');
	    }
	    context.out('</div></li>');
	  }
	  context.out('</ul>');
	};
	
	var adjustArrows = function jsondiffpatchHtmlFormatterAdjustArrows(node) {
	  node = node || document;
	  var getElementText = function(el) {
	    return el.textContent || el.innerText;
	  };
	  var eachByQuery = function(el, query, fn) {
	    var elems = el.querySelectorAll(query);
	    for (var i = 0, l = elems.length; i < l; i++) {
	      fn(elems[i]);
	    }
	  };
	  var eachChildren = function(el, fn) {
	    for (var i = 0, l = el.children.length; i < l; i++) {
	      fn(el.children[i], i);
	    }
	  };
	  eachByQuery(node, '.jsondiffpatch-arrow', function(arrow) {
	    var arrowParent = arrow.parentNode;
	    var svg = arrow.children[0],
	      path = svg.children[1];
	    svg.style.display = 'none';
	    var destination = getElementText(arrowParent.querySelector('.jsondiffpatch-moved-destination'));
	    var container = arrowParent.parentNode;
	    var destinationElem;
	    eachChildren(container, function(child) {
	      if (child.getAttribute('data-key') === destination) {
	        destinationElem = child;
	      }
	    });
	    if (!destinationElem) {
	      return;
	    }
	    try {
	      var distance = destinationElem.offsetTop - arrowParent.offsetTop;
	      svg.setAttribute('height', Math.abs(distance) + 6);
	      arrow.style.top = (-8 + (distance > 0 ? 0 : distance)) + 'px';
	      var curve = distance > 0 ?
	        'M30,0 Q-10,' + Math.round(distance / 2) + ' 26,' + (distance - 4) :
	        'M30,' + (-distance) + ' Q-10,' + Math.round(-distance / 2) + ' 26,4';
	      path.setAttribute('d', curve);
	      svg.style.display = '';
	    } catch (err) {
	      return;
	    }
	  });
	};
	
	HtmlFormatter.prototype.rootBegin = function(context, type, nodeType) {
	  var nodeClass = 'jsondiffpatch-' + type +
	    (nodeType ? ' jsondiffpatch-child-node-type-' + nodeType : '');
	  context.out('<div class="jsondiffpatch-delta ' + nodeClass + '">');
	};
	
	HtmlFormatter.prototype.rootEnd = function(context) {
	  context.out('</div>' + (context.hasArrows ?
	    ('<script type="text/javascript">setTimeout(' +
	      adjustArrows.toString() +
	      ',10);</script>') : ''));
	};
	
	HtmlFormatter.prototype.nodeBegin = function(context, key, leftKey, type, nodeType) {
	  var nodeClass = 'jsondiffpatch-' + type +
	    (nodeType ? ' jsondiffpatch-child-node-type-' + nodeType : '');
	  context.out('<li class="' + nodeClass + '" data-key="' + leftKey + '">' +
	    '<div class="jsondiffpatch-property-name">' + leftKey + '</div>');
	};
	
	
	HtmlFormatter.prototype.nodeEnd = function(context) {
	  context.out('</li>');
	};
	
	/* jshint camelcase: false */
	
	HtmlFormatter.prototype.format_unchanged = function(context, delta, left) {
	  if (typeof left === 'undefined') {
	    return;
	  }
	  context.out('<div class="jsondiffpatch-value">');
	  this.formatValue(context, left);
	  context.out('</div>');
	};
	
	HtmlFormatter.prototype.format_movedestination = function(context, delta, left) {
	  if (typeof left === 'undefined') {
	    return;
	  }
	  context.out('<div class="jsondiffpatch-value">');
	  this.formatValue(context, left);
	  context.out('</div>');
	};
	
	HtmlFormatter.prototype.format_node = function(context, delta, left) {
	  // recurse
	  var nodeType = (delta._t === 'a') ? 'array' : 'object';
	  context.out('<ul class="jsondiffpatch-node jsondiffpatch-node-type-' + nodeType + '">');
	  this.formatDeltaChildren(context, delta, left);
	  context.out('</ul>');
	};
	
	HtmlFormatter.prototype.format_added = function(context, delta) {
	  context.out('<div class="jsondiffpatch-value">');
	  this.formatValue(context, delta[0]);
	  context.out('</div>');
	};
	
	HtmlFormatter.prototype.format_modified = function(context, delta) {
	  context.out('<div class="jsondiffpatch-value jsondiffpatch-left-value">');
	  this.formatValue(context, delta[0]);
	  context.out('</div>' +
	    '<div class="jsondiffpatch-value jsondiffpatch-right-value">');
	  this.formatValue(context, delta[1]);
	  context.out('</div>');
	};
	
	HtmlFormatter.prototype.format_deleted = function(context, delta) {
	  context.out('<div class="jsondiffpatch-value">');
	  this.formatValue(context, delta[0]);
	  context.out('</div>');
	};
	
	HtmlFormatter.prototype.format_moved = function(context, delta) {
	  context.out('<div class="jsondiffpatch-value">');
	  this.formatValue(context, delta[0]);
	  context.out('</div><div class="jsondiffpatch-moved-destination">' + delta[1] + '</div>');
	
	  // draw an SVG arrow from here to move destination
	  context.out(
	    /*jshint multistr: true */
	    '<div class="jsondiffpatch-arrow" style="position: relative; left: -34px;">\
	        <svg width="30" height="60" style="position: absolute; display: none;">\
	        <defs>\
	            <marker id="markerArrow" markerWidth="8" markerHeight="8" refx="2" refy="4"\
	                   orient="auto" markerUnits="userSpaceOnUse">\
	                <path d="M1,1 L1,7 L7,4 L1,1" style="fill: #339;" />\
	            </marker>\
	        </defs>\
	        <path d="M30,0 Q-10,25 26,50" style="stroke: #88f; stroke-width: 2px; fill: none;\
	        stroke-opacity: 0.5; marker-end: url(#markerArrow);"></path>\
	        </svg>\
	        </div>');
	  context.hasArrows = true;
	};
	
	HtmlFormatter.prototype.format_textdiff = function(context, delta) {
	  context.out('<div class="jsondiffpatch-value">');
	  this.formatTextDiffString(context, delta[0]);
	  context.out('</div>');
	};
	
	/* jshint camelcase: true */
	
	var showUnchanged = function(show, node, delay) {
	  var el = node || document.body;
	  var prefix = 'jsondiffpatch-unchanged-';
	  var classes = {
	    showing: prefix + 'showing',
	    hiding: prefix + 'hiding',
	    visible: prefix + 'visible',
	    hidden: prefix + 'hidden',
	  };
	  var list = el.classList;
	  if (!list) {
	    return;
	  }
	  if (!delay) {
	    list.remove(classes.showing);
	    list.remove(classes.hiding);
	    list.remove(classes.visible);
	    list.remove(classes.hidden);
	    if (show === false) {
	      list.add(classes.hidden);
	    }
	    return;
	  }
	  if (show === false) {
	    list.remove(classes.showing);
	    list.add(classes.visible);
	    setTimeout(function() {
	      list.add(classes.hiding);
	    }, 10);
	  } else {
	    list.remove(classes.hiding);
	    list.add(classes.showing);
	    list.remove(classes.hidden);
	  }
	  var intervalId = setInterval(function() {
	    adjustArrows(el);
	  }, 100);
	  setTimeout(function() {
	    list.remove(classes.showing);
	    list.remove(classes.hiding);
	    if (show === false) {
	      list.add(classes.hidden);
	      list.remove(classes.visible);
	    } else {
	      list.add(classes.visible);
	      list.remove(classes.hidden);
	    }
	    setTimeout(function() {
	      list.remove(classes.visible);
	      clearInterval(intervalId);
	    }, delay + 400);
	  }, delay);
	};
	
	var hideUnchanged = function(node, delay) {
	  return showUnchanged(false, node, delay);
	};
	
	exports.HtmlFormatter = HtmlFormatter;
	
	exports.showUnchanged = showUnchanged;
	
	exports.hideUnchanged = hideUnchanged;
	
	var defaultInstance;
	
	exports.format = function(delta, left) {
	  if (!defaultInstance) {
	    defaultInstance = new HtmlFormatter();
	  }
	  return defaultInstance.format(delta, left);
	};


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	var environment = __webpack_require__(158);
	
	exports.base = __webpack_require__(77);
	exports.html = __webpack_require__(160);
	exports.annotated = __webpack_require__(159);
	exports.jsonpatch = __webpack_require__(162);
	
	if (!environment.isBrowser) {
	  var consoleModuleName = './console';
	  exports.console = __webpack_require__(1399)(consoleModuleName);
	}


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
	  var base = __webpack_require__(77);
	  var BaseFormatter = base.BaseFormatter;
	
	  var named = {
	    added: 'add',
	    deleted: 'remove',
	    modified: 'replace',
	    moved: 'moved',
	    movedestination: 'movedestination',
	    unchanged: 'unchanged',
	    error: 'error',
	    textDiffLine: 'textDiffLine'
	  };
	
	  function JSONFormatter() {
	    this.includeMoveDestinations = false;
	  }
	
	  JSONFormatter.prototype = new BaseFormatter();
	
	  JSONFormatter.prototype.prepareContext = function (context) {
	    BaseFormatter.prototype.prepareContext.call(this, context);
	    context.result = [];
	    context.path = [];
	    context.pushCurrentOp = function (op, value) {
	      var val = {
	        op: op,
	        path: this.currentPath()
	      };
	      if (typeof value !== 'undefined') {
	        val.value = value;
	      }
	      this.result.push(val);
	    };
	
	    context.currentPath = function () {
	      return '/' + this.path.join('/');
	    };
	  };
	
	  JSONFormatter.prototype.typeFormattterErrorFormatter = function (context, err) {
	    context.out('[ERROR]' + err);
	  };
	
	  JSONFormatter.prototype.rootBegin = function () {
	  };
	
	  JSONFormatter.prototype.rootEnd = function () {
	  };
	
	  JSONFormatter.prototype.nodeBegin = function (context, key, leftKey) {
	    context.path.push(leftKey);
	  };
	
	  JSONFormatter.prototype.nodeEnd = function (context) {
	    context.path.pop();
	  };
	
	  /* jshint camelcase: false */
	
	  JSONFormatter.prototype.format_unchanged = function (context, delta, left) {
	    if (typeof left === 'undefined') {
	      return;
	    }
	    context.pushCurrentOp(named.unchanged, left);
	  };
	
	  JSONFormatter.prototype.format_movedestination = function (context, delta, left) {
	    if (typeof left === 'undefined') {
	      return;
	    }
	    context.pushCurrentOp(named.movedestination, left);
	  };
	
	  JSONFormatter.prototype.format_node = function (context, delta, left) {
	    this.formatDeltaChildren(context, delta, left);
	  };
	
	  JSONFormatter.prototype.format_added = function (context, delta) {
	    context.pushCurrentOp(named.added, delta[0]);
	  };
	
	  JSONFormatter.prototype.format_modified = function (context, delta) {
	    context.pushCurrentOp(named.modified, delta[1]);
	  };
	
	  JSONFormatter.prototype.format_deleted = function (context) {
	    context.pushCurrentOp(named.deleted);
	  };
	
	  JSONFormatter.prototype.format_moved = function (context, delta) {
	    context.pushCurrentOp(named.moved, delta[1]);
	  };
	
	  JSONFormatter.prototype.format_textdiff = function () {
	    throw 'not implimented';
	  };
	
	  JSONFormatter.prototype.format = function (delta, left) {
	    var context = {};
	    this.prepareContext(context);
	    this.recurse(context, delta, left);
	    return context.result;
	  };
	  /* jshint camelcase: true */
	
	  exports.JSONFormatter = JSONFormatter;
	
	  var defaultInstance;
	
	  function last(arr) {
	    return arr[arr.length - 1];
	  }
	
	  function sortBy(arr, pred) {
	    arr.sort(pred);
	    return arr;
	  }
	
	  var compareByIndexDesc = function (indexA, indexB) {
	    var lastA = parseInt(indexA, 10);
	    var lastB = parseInt(indexB, 10);
	    if (!(isNaN(lastA) || isNaN(lastB))) {
	      return lastB - lastA;
	    } else {
	      return 0;
	    }
	  };
	
	  function opsByDescendingOrder(removeOps) {
	    return sortBy(removeOps, function (a, b) {
	      var splitA = a.path.split('/');
	      var splitB = b.path.split('/');
	      if (splitA.length !== splitB.length) {
	        return splitA.length - splitB.length;
	      } else {
	        return compareByIndexDesc(last(splitA), last(splitB));
	      }
	    });
	  }
	
	  function partition(arr, pred) {
	    var left = [];
	    var right = [];
	
	    arr.forEach(function (el) {
	      var coll = pred(el) ? left : right;
	      coll.push(el);
	    });
	    return [left, right];
	  }
	
	  function reorderOps(jsonFormattedDiff) {
	    var removeOpsOtherOps = partition(jsonFormattedDiff, function (operation) {
	      return operation.op === 'remove';
	    });
	    var removeOps = removeOpsOtherOps[0];
	    var otherOps = removeOpsOtherOps[1];
	
	    var removeOpsReverse = opsByDescendingOrder(removeOps);
	    return removeOpsReverse.concat(otherOps);
	  }
	
	
	  var format = function (delta, left) {
	    if (!defaultInstance) {
	      defaultInstance = new JSONFormatter();
	    }
	    return reorderOps(defaultInstance.format(delta, left));
	  };
	
	  exports.log = function (delta, left) {
	    console.log(format(delta, left));
	  };
	
	  exports.format = format;
	})();


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	
	var environment = __webpack_require__(158);
	
	var DiffPatcher = __webpack_require__(294).DiffPatcher;
	exports.DiffPatcher = DiffPatcher;
	
	exports.create = function(options){
	  return new DiffPatcher(options);
	};
	
	exports.dateReviver = __webpack_require__(206);
	
	var defaultInstance;
	
	exports.diff = function() {
	  if (!defaultInstance) {
	    defaultInstance = new DiffPatcher();
	  }
	  return defaultInstance.diff.apply(defaultInstance, arguments);
	};
	
	exports.patch = function() {
	  if (!defaultInstance) {
	    defaultInstance = new DiffPatcher();
	  }
	  return defaultInstance.patch.apply(defaultInstance, arguments);
	};
	
	exports.unpatch = function() {
	  if (!defaultInstance) {
	    defaultInstance = new DiffPatcher();
	  }
	  return defaultInstance.unpatch.apply(defaultInstance, arguments);
	};
	
	exports.reverse = function() {
	  if (!defaultInstance) {
	    defaultInstance = new DiffPatcher();
	  }
	  return defaultInstance.reverse.apply(defaultInstance, arguments);
	};
	
	if (environment.isBrowser) {
	  exports.homepage = '{{package-homepage}}';
	  exports.version = '{{package-version}}';
	} else {
	  var packageInfoModuleName = '../package.json';
	  var packageInfo = __webpack_require__(436)(packageInfoModuleName);
	  exports.homepage = packageInfo.homepage;
	  exports.version = packageInfo.version;
	
	  var formatterModuleName = './formatters';
	  var formatters = __webpack_require__(436)(formatterModuleName);
	  exports.formatters = formatters;
	  // shortcut for console
	  exports.console = formatters.console;
	}


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(446),
	    overRest = __webpack_require__(1450),
	    setToString = __webpack_require__(1453);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(443);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 166 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 167 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(111)))

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _declaration = __webpack_require__(316);
	
	var _declaration2 = _interopRequireDefault(_declaration);
	
	var _processor = __webpack_require__(462);
	
	var _processor2 = _interopRequireDefault(_processor);
	
	var _stringify = __webpack_require__(320);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _comment = __webpack_require__(314);
	
	var _comment2 = _interopRequireDefault(_comment);
	
	var _atRule = __webpack_require__(215);
	
	var _atRule2 = _interopRequireDefault(_atRule);
	
	var _vendor = __webpack_require__(130);
	
	var _vendor2 = _interopRequireDefault(_vendor);
	
	var _parse = __webpack_require__(318);
	
	var _parse2 = _interopRequireDefault(_parse);
	
	var _list = __webpack_require__(90);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _rule = __webpack_require__(216);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _root = __webpack_require__(319);
	
	var _root2 = _interopRequireDefault(_root);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Create a new {@link Processor} instance that will apply `plugins`
	 * as CSS processors.
	 *
	 * @param {Array.<Plugin|pluginFunction>|Processor} plugins - PostCSS
	 *        plugins. See {@link Processor#use} for plugin format.
	 *
	 * @return {Processor} Processor to process multiple CSS
	 *
	 * @example
	 * import postcss from 'postcss';
	 *
	 * postcss(plugins).process(css, { from, to }).then(result => {
	 *   console.log(result.css);
	 * });
	 *
	 * @namespace postcss
	 */
	function postcss() {
	  for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
	    plugins[_key] = arguments[_key];
	  }
	
	  if (plugins.length === 1 && Array.isArray(plugins[0])) {
	    plugins = plugins[0];
	  }
	  return new _processor2.default(plugins);
	}
	
	/**
	 * Creates a PostCSS plugin with a standard API.
	 *
	 * The newly-wrapped function will provide both the name and PostCSS
	 * version of the plugin.
	 *
	 * ```js
	 *  const processor = postcss([replace]);
	 *  processor.plugins[0].postcssPlugin  //=> 'postcss-replace'
	 *  processor.plugins[0].postcssVersion //=> '5.1.0'
	 * ```
	 *
	 * The plugin function receives 2 arguments: {@link Root}
	 * and {@link Result} instance. The function should mutate the provided
	 * `Root` node. Alternatively, you can create a new `Root` node
	 * and override the `result.root` property.
	 *
	 * ```js
	 * const cleaner = postcss.plugin('postcss-cleaner', () => {
	 *   return (root, result) => {
	 *     result.root = postcss.root();
	 *   };
	 * });
	 * ```
	 *
	 * As a convenience, plugins also expose a `process` method so that you can use
	 * them as standalone tools.
	 *
	 * ```js
	 * cleaner.process(css, options);
	 * // This is equivalent to:
	 * postcss([ cleaner(options) ]).process(css);
	 * ```
	 *
	 * Asynchronous plugins should return a `Promise` instance.
	 *
	 * ```js
	 * postcss.plugin('postcss-import', () => {
	 *   return (root, result) => {
	 *     return new Promise( (resolve, reject) => {
	 *       fs.readFile('base.css', (base) => {
	 *         root.prepend(base);
	 *         resolve();
	 *       });
	 *     });
	 *   };
	 * });
	 * ```
	 *
	 * Add warnings using the {@link Node#warn} method.
	 * Send data to other plugins using the {@link Result#messages} array.
	 *
	 * ```js
	 * postcss.plugin('postcss-caniuse-test', () => {
	 *   return (root, result) => {
	 *     css.walkDecls(decl => {
	 *       if ( !caniuse.support(decl.prop) ) {
	 *         decl.warn(result, 'Some browsers do not support ' + decl.prop);
	 *       }
	 *     });
	 *   };
	 * });
	 * ```
	 *
	 * @param {string} name          - PostCSS plugin name. Same as in `name`
	 *                                 property in `package.json`. It will be saved
	 *                                 in `plugin.postcssPlugin` property.
	 * @param {function} initializer - will receive plugin options
	 *                                 and should return {@link pluginFunction}
	 *
	 * @return {Plugin} PostCSS plugin
	 */
	postcss.plugin = function plugin(name, initializer) {
	  var creator = function creator() {
	    var transformer = initializer.apply(undefined, arguments);
	    transformer.postcssPlugin = name;
	    transformer.postcssVersion = new _processor2.default().version;
	    return transformer;
	  };
	
	  var cache = void 0;
	  Object.defineProperty(creator, 'postcss', {
	    get: function get() {
	      if (!cache) cache = creator();
	      return cache;
	    }
	  });
	
	  creator.process = function (root, opts) {
	    return postcss([creator(opts)]).process(root, opts);
	  };
	
	  return creator;
	};
	
	/**
	 * Default function to convert a node tree into a CSS string.
	 *
	 * @param {Node} node       - start node for stringifing. Usually {@link Root}.
	 * @param {builder} builder - function to concatenate CSS from node’s parts
	 *                            or generate string and source map
	 *
	 * @return {void}
	 *
	 * @function
	 */
	postcss.stringify = _stringify2.default;
	
	/**
	 * Parses source css and returns a new {@link Root} node,
	 * which contains the source CSS nodes.
	 *
	 * @param {string|toString} css   - string with input CSS or any object
	 *                                  with toString() method, like a Buffer
	 * @param {processOptions} [opts] - options with only `from` and `map` keys
	 *
	 * @return {Root} PostCSS AST
	 *
	 * @example
	 * // Simple CSS concatenation with source map support
	 * const root1 = postcss.parse(css1, { from: file1 });
	 * const root2 = postcss.parse(css2, { from: file2 });
	 * root1.append(root2).toResult().css;
	 *
	 * @function
	 */
	postcss.parse = _parse2.default;
	
	/**
	 * @member {vendor} - Contains the {@link vendor} module.
	 *
	 * @example
	 * postcss.vendor.unprefixed('-moz-tab') //=> ['tab']
	 */
	postcss.vendor = _vendor2.default;
	
	/**
	 * @member {list} - Contains the {@link list} module.
	 *
	 * @example
	 * postcss.list.space('5px calc(10% + 5px)') //=> ['5px', 'calc(10% + 5px)']
	 */
	postcss.list = _list2.default;
	
	/**
	 * Creates a new {@link Comment} node.
	 *
	 * @param {object} [defaults] - properties for the new node.
	 *
	 * @return {Comment} new Comment node
	 *
	 * @example
	 * postcss.comment({ text: 'test' })
	 */
	postcss.comment = function (defaults) {
	  return new _comment2.default(defaults);
	};
	
	/**
	 * Creates a new {@link AtRule} node.
	 *
	 * @param {object} [defaults] - properties for the new node.
	 *
	 * @return {AtRule} new AtRule node
	 *
	 * @example
	 * postcss.atRule({ name: 'charset' }).toString() //=> "@charset"
	 */
	postcss.atRule = function (defaults) {
	  return new _atRule2.default(defaults);
	};
	
	/**
	 * Creates a new {@link Declaration} node.
	 *
	 * @param {object} [defaults] - properties for the new node.
	 *
	 * @return {Declaration} new Declaration node
	 *
	 * @example
	 * postcss.decl({ prop: 'color', value: 'red' }).toString() //=> "color: red"
	 */
	postcss.decl = function (defaults) {
	  return new _declaration2.default(defaults);
	};
	
	/**
	 * Creates a new {@link Rule} node.
	 *
	 * @param {object} [defaults] - properties for the new node.
	 *
	 * @return {AtRule} new Rule node
	 *
	 * @example
	 * postcss.rule({ selector: 'a' }).toString() //=> "a {\n}"
	 */
	postcss.rule = function (defaults) {
	  return new _rule2.default(defaults);
	};
	
	/**
	 * Creates a new {@link Root} node.
	 *
	 * @param {object} [defaults] - properties for the new node.
	 *
	 * @return {Root} new Root node
	 *
	 * @example
	 * postcss.root({ after: '\n' }).toString() //=> "\n"
	 */
	postcss.root = function (defaults) {
	  return new _root2.default(defaults);
	};
	
	exports.default = postcss;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(119);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(36);
	
	var _SafeAnchor = __webpack_require__(69);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  block: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func,
	  componentClass: _elementType2['default'],
	  href: _propTypes2['default'].string,
	  /**
	   * Defines HTML button type attribute
	   * @defaultValue 'button'
	   */
	  type: _propTypes2['default'].oneOf(['button', 'reset', 'submit'])
	};
	
	var defaultProps = {
	  active: false,
	  block: false,
	  disabled: false
	};
	
	var Button = function (_React$Component) {
	  (0, _inherits3['default'])(Button, _React$Component);
	
	  function Button() {
	    (0, _classCallCheck3['default'])(this, Button);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Button.prototype.renderAnchor = function renderAnchor(elementProps, className) {
	    return _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, elementProps.disabled && 'disabled')
	    }));
	  };
	
	  Button.prototype.renderButton = function renderButton(_ref, className) {
	    var componentClass = _ref.componentClass,
	        elementProps = (0, _objectWithoutProperties3['default'])(_ref, ['componentClass']);
	
	    var Component = componentClass || 'button';
	
	    return _react2['default'].createElement(Component, (0, _extends4['default'])({}, elementProps, {
	      type: elementProps.type || 'button',
	      className: className
	    }));
	  };
	
	  Button.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        active = _props.active,
	        block = _props.block,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'block', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'block')] = block, _extends2));
	    var fullClassName = (0, _classnames2['default'])(className, classes);
	
	    if (elementProps.href) {
	      return this.renderAnchor(elementProps, fullClassName);
	    }
	
	    return this.renderButton(elementProps, fullClassName);
	  };
	
	  return Button;
	}(_react2['default'].Component);
	
	Button.propTypes = propTypes;
	Button.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL, _StyleConfig.Size.XSMALL], (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY, _StyleConfig.Style.LINK]), _StyleConfig.Style.DEFAULT, Button)));
	module.exports = exports['default'];

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var EventPluginRegistry = __webpack_require__(330);
	var EventPluginUtils = __webpack_require__(331);
	var ReactErrorUtils = __webpack_require__(335);
	
	var accumulateInto = __webpack_require__(507);
	var forEachAccumulated = __webpack_require__(508);
	var invariant = __webpack_require__(12);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(171);
	var EventPluginUtils = __webpack_require__(331);
	
	var accumulateInto = __webpack_require__(507);
	var forEachAccumulated = __webpack_require__(508);
	var warning = __webpack_require__(20);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 173 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(80);
	
	var getEventTarget = __webpack_require__(340);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (componentOrElement) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
	};
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ownerDocument = __webpack_require__(127);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 176 */
19,
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(542)

/***/ },
/* 178 */
/***/ function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	/**
	 * This is a helper function for getting values from parameter/options
	 * objects.
	 *
	 * @param args The object we are extracting values from
	 * @param name The name of the property we are getting.
	 * @param defaultValue An optional value to return if the property is missing
	 * from the object. If this is not specified and the property is missing, an
	 * error will be thrown.
	 */
	function getArg(aArgs, aName, aDefaultValue) {
	  if (aName in aArgs) {
	    return aArgs[aName];
	  } else if (arguments.length === 3) {
	    return aDefaultValue;
	  } else {
	    throw new Error('"' + aName + '" is a required argument.');
	  }
	}
	exports.getArg = getArg;
	
	var urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.]*)(?::(\d+))?(\S*)$/;
	var dataUrlRegexp = /^data:.+\,.+$/;
	
	function urlParse(aUrl) {
	  var match = aUrl.match(urlRegexp);
	  if (!match) {
	    return null;
	  }
	  return {
	    scheme: match[1],
	    auth: match[2],
	    host: match[3],
	    port: match[4],
	    path: match[5]
	  };
	}
	exports.urlParse = urlParse;
	
	function urlGenerate(aParsedUrl) {
	  var url = '';
	  if (aParsedUrl.scheme) {
	    url += aParsedUrl.scheme + ':';
	  }
	  url += '//';
	  if (aParsedUrl.auth) {
	    url += aParsedUrl.auth + '@';
	  }
	  if (aParsedUrl.host) {
	    url += aParsedUrl.host;
	  }
	  if (aParsedUrl.port) {
	    url += ":" + aParsedUrl.port
	  }
	  if (aParsedUrl.path) {
	    url += aParsedUrl.path;
	  }
	  return url;
	}
	exports.urlGenerate = urlGenerate;
	
	/**
	 * Normalizes a path, or the path portion of a URL:
	 *
	 * - Replaces consecutive slashes with one slash.
	 * - Removes unnecessary '.' parts.
	 * - Removes unnecessary '<dir>/..' parts.
	 *
	 * Based on code in the Node.js 'path' core module.
	 *
	 * @param aPath The path or url to normalize.
	 */
	function normalize(aPath) {
	  var path = aPath;
	  var url = urlParse(aPath);
	  if (url) {
	    if (!url.path) {
	      return aPath;
	    }
	    path = url.path;
	  }
	  var isAbsolute = exports.isAbsolute(path);
	
	  var parts = path.split(/\/+/);
	  for (var part, up = 0, i = parts.length - 1; i >= 0; i--) {
	    part = parts[i];
	    if (part === '.') {
	      parts.splice(i, 1);
	    } else if (part === '..') {
	      up++;
	    } else if (up > 0) {
	      if (part === '') {
	        // The first part is blank if the path is absolute. Trying to go
	        // above the root is a no-op. Therefore we can remove all '..' parts
	        // directly after the root.
	        parts.splice(i + 1, up);
	        up = 0;
	      } else {
	        parts.splice(i, 2);
	        up--;
	      }
	    }
	  }
	  path = parts.join('/');
	
	  if (path === '') {
	    path = isAbsolute ? '/' : '.';
	  }
	
	  if (url) {
	    url.path = path;
	    return urlGenerate(url);
	  }
	  return path;
	}
	exports.normalize = normalize;
	
	/**
	 * Joins two paths/URLs.
	 *
	 * @param aRoot The root path or URL.
	 * @param aPath The path or URL to be joined with the root.
	 *
	 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
	 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
	 *   first.
	 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
	 *   is updated with the result and aRoot is returned. Otherwise the result
	 *   is returned.
	 *   - If aPath is absolute, the result is aPath.
	 *   - Otherwise the two paths are joined with a slash.
	 * - Joining for example 'http://' and 'www.example.com' is also supported.
	 */
	function join(aRoot, aPath) {
	  if (aRoot === "") {
	    aRoot = ".";
	  }
	  if (aPath === "") {
	    aPath = ".";
	  }
	  var aPathUrl = urlParse(aPath);
	  var aRootUrl = urlParse(aRoot);
	  if (aRootUrl) {
	    aRoot = aRootUrl.path || '/';
	  }
	
	  // `join(foo, '//www.example.org')`
	  if (aPathUrl && !aPathUrl.scheme) {
	    if (aRootUrl) {
	      aPathUrl.scheme = aRootUrl.scheme;
	    }
	    return urlGenerate(aPathUrl);
	  }
	
	  if (aPathUrl || aPath.match(dataUrlRegexp)) {
	    return aPath;
	  }
	
	  // `join('http://', 'www.example.com')`
	  if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
	    aRootUrl.host = aPath;
	    return urlGenerate(aRootUrl);
	  }
	
	  var joined = aPath.charAt(0) === '/'
	    ? aPath
	    : normalize(aRoot.replace(/\/+$/, '') + '/' + aPath);
	
	  if (aRootUrl) {
	    aRootUrl.path = joined;
	    return urlGenerate(aRootUrl);
	  }
	  return joined;
	}
	exports.join = join;
	
	exports.isAbsolute = function (aPath) {
	  return aPath.charAt(0) === '/' || !!aPath.match(urlRegexp);
	};
	
	/**
	 * Make a path relative to a URL or another path.
	 *
	 * @param aRoot The root path or URL.
	 * @param aPath The path or URL to be made relative to aRoot.
	 */
	function relative(aRoot, aPath) {
	  if (aRoot === "") {
	    aRoot = ".";
	  }
	
	  aRoot = aRoot.replace(/\/$/, '');
	
	  // It is possible for the path to be above the root. In this case, simply
	  // checking whether the root is a prefix of the path won't work. Instead, we
	  // need to remove components from the root one by one, until either we find
	  // a prefix that fits, or we run out of components to remove.
	  var level = 0;
	  while (aPath.indexOf(aRoot + '/') !== 0) {
	    var index = aRoot.lastIndexOf("/");
	    if (index < 0) {
	      return aPath;
	    }
	
	    // If the only part of the root that is left is the scheme (i.e. http://,
	    // file:///, etc.), one or more slashes (/), or simply nothing at all, we
	    // have exhausted all components, so the path is not relative to the root.
	    aRoot = aRoot.slice(0, index);
	    if (aRoot.match(/^([^\/]+:\/)?\/*$/)) {
	      return aPath;
	    }
	
	    ++level;
	  }
	
	  // Make sure we add a "../" for each component we removed from the root.
	  return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
	}
	exports.relative = relative;
	
	var supportsNullProto = (function () {
	  var obj = Object.create(null);
	  return !('__proto__' in obj);
	}());
	
	function identity (s) {
	  return s;
	}
	
	/**
	 * Because behavior goes wacky when you set `__proto__` on objects, we
	 * have to prefix all the strings in our set with an arbitrary character.
	 *
	 * See https://github.com/mozilla/source-map/pull/31 and
	 * https://github.com/mozilla/source-map/issues/30
	 *
	 * @param String aStr
	 */
	function toSetString(aStr) {
	  if (isProtoString(aStr)) {
	    return '$' + aStr;
	  }
	
	  return aStr;
	}
	exports.toSetString = supportsNullProto ? identity : toSetString;
	
	function fromSetString(aStr) {
	  if (isProtoString(aStr)) {
	    return aStr.slice(1);
	  }
	
	  return aStr;
	}
	exports.fromSetString = supportsNullProto ? identity : fromSetString;
	
	function isProtoString(s) {
	  if (!s) {
	    return false;
	  }
	
	  var length = s.length;
	
	  if (length < 9 /* "__proto__".length */) {
	    return false;
	  }
	
	  if (s.charCodeAt(length - 1) !== 95  /* '_' */ ||
	      s.charCodeAt(length - 2) !== 95  /* '_' */ ||
	      s.charCodeAt(length - 3) !== 111 /* 'o' */ ||
	      s.charCodeAt(length - 4) !== 116 /* 't' */ ||
	      s.charCodeAt(length - 5) !== 111 /* 'o' */ ||
	      s.charCodeAt(length - 6) !== 114 /* 'r' */ ||
	      s.charCodeAt(length - 7) !== 112 /* 'p' */ ||
	      s.charCodeAt(length - 8) !== 95  /* '_' */ ||
	      s.charCodeAt(length - 9) !== 95  /* '_' */) {
	    return false;
	  }
	
	  for (var i = length - 10; i >= 0; i--) {
	    if (s.charCodeAt(i) !== 36 /* '$' */) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	/**
	 * Comparator between two mappings where the original positions are compared.
	 *
	 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
	 * mappings with the same original source/line/column, but different generated
	 * line and column the same. Useful when searching for a mapping with a
	 * stubbed out mapping.
	 */
	function compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
	  var cmp = mappingA.source - mappingB.source;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalLine - mappingB.originalLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalColumn - mappingB.originalColumn;
	  if (cmp !== 0 || onlyCompareOriginal) {
	    return cmp;
	  }
	
	  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.generatedLine - mappingB.generatedLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  return mappingA.name - mappingB.name;
	}
	exports.compareByOriginalPositions = compareByOriginalPositions;
	
	/**
	 * Comparator between two mappings with deflated source and name indices where
	 * the generated positions are compared.
	 *
	 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
	 * mappings with the same generated line and column, but different
	 * source/name/original line and column the same. Useful when searching for a
	 * mapping with a stubbed out mapping.
	 */
	function compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
	  var cmp = mappingA.generatedLine - mappingB.generatedLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
	  if (cmp !== 0 || onlyCompareGenerated) {
	    return cmp;
	  }
	
	  cmp = mappingA.source - mappingB.source;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalLine - mappingB.originalLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalColumn - mappingB.originalColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  return mappingA.name - mappingB.name;
	}
	exports.compareByGeneratedPositionsDeflated = compareByGeneratedPositionsDeflated;
	
	function strcmp(aStr1, aStr2) {
	  if (aStr1 === aStr2) {
	    return 0;
	  }
	
	  if (aStr1 > aStr2) {
	    return 1;
	  }
	
	  return -1;
	}
	
	/**
	 * Comparator between two mappings with inflated source and name strings where
	 * the generated positions are compared.
	 */
	function compareByGeneratedPositionsInflated(mappingA, mappingB) {
	  var cmp = mappingA.generatedLine - mappingB.generatedLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = strcmp(mappingA.source, mappingB.source);
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalLine - mappingB.originalLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalColumn - mappingB.originalColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  return strcmp(mappingA.name, mappingB.name);
	}
	exports.compareByGeneratedPositionsInflated = compareByGeneratedPositionsInflated;


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.getCurrentPlayer = getCurrentPlayer;
	exports.getCurrentRole = getCurrentRole;
	exports.getPlayerRole = getPlayerRole;
	exports.getPlayers = getPlayers;
	exports.getNextPlayer = getNextPlayer;
	exports.canBuildStation = canBuildStation;
	exports.getActionsLeft = getActionsLeft;
	exports.getInfectionRate = getInfectionRate;
	exports.getInfectionRateValues = getInfectionRateValues;
	exports.isOutbreaksCountOutOfBounds = isOutbreaksCountOutOfBounds;
	exports.getNextOutbreakCityId = getNextOutbreakCityId;
	exports.isOutOfCubes = isOutOfCubes;
	exports.getPlayerToDiscard = getPlayerToDiscard;
	exports.isPlaying = isPlaying;
	exports.getDifficulty = getDifficulty;
	exports.canShareCards = canShareCards;
	exports.getShareCandidates = getShareCandidates;
	exports.shouldSkipInfectionsStep = shouldSkipInfectionsStep;
	exports.hasOpsUsedMoveAbility = hasOpsUsedMoveAbility;
	exports.isContingencyPlanner = isContingencyPlanner;
	exports.isDispatcher = isDispatcher;
	exports.isContingencyPlannerAbilityAvailable = isContingencyPlannerAbilityAvailable;
	exports.getContPlannerEvent = getContPlannerEvent;
	exports.getCardsDrawn = getCardsDrawn;
	exports.getInfectionCardDrawn = getInfectionCardDrawn;
	exports.getEpidemicStep = getEpidemicStep;
	exports.isEpidemicInProgress = isEpidemicInProgress;
	exports.isDealingPlayerCards = isDealingPlayerCards;
	exports.isDealingEpidemicCards = isDealingEpidemicCards;
	exports.getPlayerDealtToIndex = getPlayerDealtToIndex;
	exports.getCardsDealtCount = getCardsDealtCount;
	exports.getInitialInfectedCity = getInitialInfectedCity;
	exports.getDiscardingCard = getDiscardingCard;
	exports.getDefeatMessage = getDefeatMessage;
	exports.getEpidemicInfectionCard = getEpidemicInfectionCard;
	exports.getContinueMessage = getContinueMessage;
	
	var _lodash = __webpack_require__(21);
	
	var _map = __webpack_require__(181);
	
	var _cities = __webpack_require__(141);
	
	var _hand = __webpack_require__(180);
	
	var _decks = __webpack_require__(238);
	
	var _events = __webpack_require__(140);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function getCurrentPlayer(state) {
	  return state.players[state.currentMove.player];
	}
	
	function getCurrentRole(state) {
	  return getCurrentPlayer(state).role;
	}
	
	function getPlayerRole(state, playerId) {
	  return state.players[playerId].role;
	}
	
	function getPlayers(state) {
	  return (0, _lodash.values)(state.players).map(function (p) {
	    return _extends({}, p, { cityId: (0, _map.getPlayerCityId)(state, p.id) });
	  });
	}
	
	function getNextPlayer(state) {
	  return state.currentMove.player === Object.keys(state.players).length - 1 + '' ? '0' : +state.currentMove.player + 1 + '';
	}
	
	function canBuildStation(state) {
	  return !(0, _map.isAtStation)(state) && ((0, _hand.hasCurrentCityInHand)(state) || getCurrentRole(state) === 'ops_expert' && !hasOpsUsedMoveAbility(state));
	}
	
	function getActionsLeft(state) {
	  return state.currentMove.actionsLeft;
	}
	
	function getInfectionRate(state) {
	  return state.infectionRate.values[state.infectionRate.index];
	}
	
	function getInfectionRateValues(state) {
	  return state.infectionRate;
	}
	
	function isOutbreaksCountOutOfBounds(state) {
	  return state.outbreaks >= 8;
	}
	
	function getNextOutbreakCityId(state) {
	  return state.currentMove.outbreak.pending[0];
	}
	
	function isOutOfCubes(state, countNeeded, color) {
	  return state.cubesLeft[color] < countNeeded;
	}
	
	function getPlayerToDiscard(state) {
	  return state.currentMove.playerToDiscard;
	}
	
	function isPlaying(state) {
	  return state.status === 'playing';
	}
	
	function getDifficulty(state) {
	  return state.difficulty;
	}
	
	function canShareCards(state) {
	  return getShareCandidates(state).length > 0;
	}
	
	function getShareCandidates(state) {
	  var currentPlayer = getCurrentPlayer(state);
	  var locs = state.map.playersLocations;
	  var sameCityPlayers = (0, _lodash.chain)(locs).keys().filter(function (id) {
	    return id !== currentPlayer.id && locs[id] === (0, _cities.getCurrentCityId)(state);
	  }).value();
	  var receivers = (0, _hand.hasCurrentCityInHand)(state) ? sameCityPlayers.map(function (id) {
	    return _extends({}, state.players[id], { share: 'receiver' });
	  }) : [];
	  var giver = (0, _lodash.chain)(sameCityPlayers).find(function (id) {
	    return (0, _hand.hasCurrentCityInHand)(state, id);
	  }).thru(function (id) {
	    return id && _extends({}, state.players[id], { share: 'giver' });
	  }).value();
	  return (0, _lodash.compact)([].concat(_toConsumableArray(receivers), [giver]));
	}
	
	function shouldSkipInfectionsStep(state) {
	  return state.currentMove.skipInfectionsStep;
	}
	
	function hasOpsUsedMoveAbility(state) {
	  return state.currentMove.opsMoveAbility.used;
	}
	
	function isContingencyPlanner(state) {
	  return getCurrentRole(state) === 'cont_planner';
	}
	
	function isDispatcher(state) {
	  return getCurrentRole(state) === 'dispatcher';
	}
	
	function isContingencyPlannerAbilityAvailable(state) {
	  return isContingencyPlanner(state) && !(0, _lodash.isEmpty)((0, _decks.getCardsForContPlanner)(state)) && !getContPlannerEvent(state);
	}
	
	function getContPlannerEvent(state) {
	  var id = getCurrentPlayer(state).specialEvent;
	  return _events2.default[id];
	}
	
	function getCardsDrawn(state) {
	  return state.currentMove.cardsDrawn;
	}
	
	function getInfectionCardDrawn(state) {
	  return state.currentMove.infectionCardDrawn;
	}
	
	function getEpidemicStep(state) {
	  return state.currentMove.epidemicStep;
	}
	
	function isEpidemicInProgress(state) {
	  return !!getEpidemicStep(state);
	}
	
	function isDealingPlayerCards(state) {
	  return state.dealingCards.dealing === 'player';
	}
	
	function isDealingEpidemicCards(state) {
	  return state.dealingCards.dealing === 'epidemic';
	}
	
	function getPlayerDealtToIndex(state) {
	  return typeof state.dealingCards.playerIndex === 'undefined' ? null : state.dealingCards.playerIndex;
	}
	
	function getCardsDealtCount(state) {
	  return state.dealingCards.cards && state.dealingCards.cards.length;
	}
	
	function getInitialInfectedCity(state) {
	  return state.initialInfectedCity;
	}
	
	function getDiscardingCard(state) {
	  return state.currentMove.discardingCard;
	}
	
	function getDefeatMessage(state) {
	  return state.defeatMessage;
	}
	
	function getEpidemicInfectionCard(state) {
	  return state.currentMove.epidemicInfectionCard;
	}
	
	function getContinueMessage(state) {
	  return state.currentMove.continueMessage;
	}

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.sortHand = sortHand;
	exports.getCitiesInPlayersHand = getCitiesInPlayersHand;
	exports.getCurrentPlayerHand = getCurrentPlayerHand;
	exports.getPlayerHand = getPlayerHand;
	exports.isOverHandLimit = isOverHandLimit;
	exports.hasCurrentCityInHand = hasCurrentCityInHand;
	exports.hasCityInHand = hasCityInHand;
	exports.getCardsOfColorInCurrentHand = getCardsOfColorInCurrentHand;
	exports.getEventsInHands = getEventsInHands;
	exports.getResPopOwner = getResPopOwner;
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _gameplay = __webpack_require__(179);
	
	var _cities = __webpack_require__(141);
	
	var _decks = __webpack_require__(238);
	
	var _events = __webpack_require__(140);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var HAND_LIMIT = 7;
	
	function sortHand(hand) {
	  return _lodash2.default.sortBy(hand, ['cardType', 'color', 'name']);
	}
	
	function getCitiesInPlayersHand(state, playerId) {
	  var hand = getPlayerHand(state, playerId);
	  return _lodash2.default.filter(hand, { cardType: 'city' });
	}
	
	function getCurrentPlayerHand(state) {
	  return getPlayerHand(state, (0, _gameplay.getCurrentPlayer)(state).id);
	}
	
	function getPlayerHand(state, playerId) {
	  return sortHand(state.players[playerId].hand.map(_lodash2.default.partialRight(_decks.enhanceCard, state)));
	}
	
	function isOverHandLimit(state, playerId) {
	  return state.players[playerId].hand.length > HAND_LIMIT;
	}
	
	function hasCurrentCityInHand(state) {
	  var playerId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  var cityId = (0, _cities.getCurrentCityId)(state);
	  return hasCityInHand(state, cityId, playerId);
	}
	
	function hasCityInHand(state) {
	  var cityId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  var playerId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var hand = playerId ? getPlayerHand(state, playerId) : getCurrentPlayerHand(state);
	  return !!_lodash2.default.find(hand, { cardType: 'city', id: cityId || (0, _cities.getCurrentCityId)(state) });
	}
	
	function getCardsOfColorInCurrentHand(state, color) {
	  var hand = getCurrentPlayerHand(state);
	  return hand.filter(function (c) {
	    return c.cardType === 'city' && (0, _cities.getCityColor)(state, c.id) === color;
	  });
	}
	
	function getEventsInHands(state) {
	  var result = [];
	  _lodash2.default.forOwn(state.players, function (player, id) {
	
	    result.push.apply(result, _toConsumableArray(_lodash2.default.filter(player.hand, { cardType: 'event' }).map(function (c) {
	      return _extends({}, c, { name: _events2.default[c.id].name, playerId: id });
	    })));
	  });
	  return result;
	}
	
	function getResPopOwner(state) {
	  var playerId = null;
	  _lodash2.default.forOwn(state.players, function (player, id) {
	    var hand = getPlayerHand(state, id);
	    if (_lodash2.default.find(hand, { cardType: 'event', id: 'res_pop' })) {
	      playerId = id;
	      return false;
	    }
	  });
	  return playerId;
	}

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isAtStation = isAtStation;
	exports.isStation = isStation;
	exports.getCurrentMapLocation = getCurrentMapLocation;
	exports.getPlayerCityId = getPlayerCityId;
	
	var _cities = __webpack_require__(141);
	
	function isAtStation(state) {
	  return !!getCurrentMapLocation(state).station;
	}
	
	function isStation(state, cityId) {
	  return !!state.map.locations[cityId].station;
	}
	
	function getCurrentMapLocation(state) {
	  var cityId = (0, _cities.getCurrentCityId)(state);
	  return state.map.locations[cityId];
	}
	
	function getPlayerCityId(state, playerId) {
	  return state.map.playersLocations[playerId];
	}

/***/ },
/* 182 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 183 */
[1766, 243],
/* 184 */
107,
/* 185 */
[1729, 52, 26, 106],
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(13);
	var $export = __webpack_require__(2);
	var redefine = __webpack_require__(43);
	var redefineAll = __webpack_require__(104);
	var meta = __webpack_require__(89);
	var forOf = __webpack_require__(99);
	var anInstance = __webpack_require__(98);
	var isObject = __webpack_require__(18);
	var fails = __webpack_require__(15);
	var $iterDetect = __webpack_require__(190);
	var setToStringTag = __webpack_require__(125);
	var inheritIfRequired = __webpack_require__(262);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(407);
	var redefine = __webpack_require__(43);
	var hide = __webpack_require__(42);
	var fails = __webpack_require__(15);
	var defined = __webpack_require__(63);
	var wks = __webpack_require__(24);
	var regexpExec = __webpack_require__(270);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ },
/* 188 */
[1741, 54],
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(18);
	var cof = __webpack_require__(54);
	var MATCH = __webpack_require__(24)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ },
/* 190 */
[1745, 24],
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(88) || !__webpack_require__(15)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(13)[K];
	});


/***/ },
/* 192 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(123);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(38);
	var ctx = __webpack_require__(56);
	var forOf = __webpack_require__(99);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(2);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ },
/* 196 */
[1762, 58, 63],
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13);
	var hide = __webpack_require__(42);
	var uid = __webpack_require__(107);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.END_DRAG = exports.DROP = exports.HOVER = exports.PUBLISH_DRAG_SOURCE = exports.BEGIN_DRAG = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.beginDrag = beginDrag;
	exports.publishDragSource = publishDragSource;
	exports.hover = hover;
	exports.drop = drop;
	exports.endDrag = endDrag;
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isArray = __webpack_require__(110);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isObject = __webpack_require__(166);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _matchesType = __webpack_require__(413);
	
	var _matchesType2 = _interopRequireDefault(_matchesType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BEGIN_DRAG = exports.BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
	var PUBLISH_DRAG_SOURCE = exports.PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
	var HOVER = exports.HOVER = 'dnd-core/HOVER';
	var DROP = exports.DROP = 'dnd-core/DROP';
	var END_DRAG = exports.END_DRAG = 'dnd-core/END_DRAG';
	
	function beginDrag(sourceIds) {
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { publishSource: true, clientOffset: null };
		var publishSource = options.publishSource,
		    clientOffset = options.clientOffset,
		    getSourceClientOffset = options.getSourceClientOffset;
	
		(0, _invariant2.default)((0, _isArray2.default)(sourceIds), 'Expected sourceIds to be an array.');
	
		var monitor = this.getMonitor();
		var registry = this.getRegistry();
		(0, _invariant2.default)(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
	
		for (var i = 0; i < sourceIds.length; i++) {
			(0, _invariant2.default)(registry.getSource(sourceIds[i]), 'Expected sourceIds to be registered.');
		}
	
		var sourceId = null;
		for (var _i = sourceIds.length - 1; _i >= 0; _i--) {
			if (monitor.canDragSource(sourceIds[_i])) {
				sourceId = sourceIds[_i];
				break;
			}
		}
		if (sourceId === null) {
			return;
		}
	
		var sourceClientOffset = null;
		if (clientOffset) {
			(0, _invariant2.default)(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
			sourceClientOffset = getSourceClientOffset(sourceId);
		}
	
		var source = registry.getSource(sourceId);
		var item = source.beginDrag(monitor, sourceId);
		(0, _invariant2.default)((0, _isObject2.default)(item), 'Item must be an object.');
	
		registry.pinSource(sourceId);
	
		var itemType = registry.getSourceType(sourceId);
		return {
			type: BEGIN_DRAG,
			itemType: itemType,
			item: item,
			sourceId: sourceId,
			clientOffset: clientOffset,
			sourceClientOffset: sourceClientOffset,
			isSourcePublic: publishSource
		};
	}
	
	function publishDragSource() {
		var monitor = this.getMonitor();
		if (!monitor.isDragging()) {
			return;
		}
	
		return { type: PUBLISH_DRAG_SOURCE };
	}
	
	function hover(targetIdsArg) {
		var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
		    _ref$clientOffset = _ref.clientOffset,
		    clientOffset = _ref$clientOffset === undefined ? null : _ref$clientOffset;
	
		(0, _invariant2.default)((0, _isArray2.default)(targetIdsArg), 'Expected targetIds to be an array.');
		var targetIds = targetIdsArg.slice(0);
	
		var monitor = this.getMonitor();
		var registry = this.getRegistry();
		(0, _invariant2.default)(monitor.isDragging(), 'Cannot call hover while not dragging.');
		(0, _invariant2.default)(!monitor.didDrop(), 'Cannot call hover after drop.');
	
		// First check invariants.
		for (var i = 0; i < targetIds.length; i++) {
			var targetId = targetIds[i];
			(0, _invariant2.default)(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
	
			var target = registry.getTarget(targetId);
			(0, _invariant2.default)(target, 'Expected targetIds to be registered.');
		}
	
		var draggedItemType = monitor.getItemType();
	
		// Remove those targetIds that don't match the targetType.  This
		// fixes shallow isOver which would only be non-shallow because of
		// non-matching targets.
		for (var _i2 = targetIds.length - 1; _i2 >= 0; _i2--) {
			var _targetId = targetIds[_i2];
			var targetType = registry.getTargetType(_targetId);
			if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
				targetIds.splice(_i2, 1);
			}
		}
	
		// Finally call hover on all matching targets.
		for (var _i3 = 0; _i3 < targetIds.length; _i3++) {
			var _targetId2 = targetIds[_i3];
			var _target = registry.getTarget(_targetId2);
			_target.hover(monitor, _targetId2);
		}
	
		return {
			type: HOVER,
			targetIds: targetIds,
			clientOffset: clientOffset
		};
	}
	
	function drop() {
		var _this = this;
	
		var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
		var monitor = this.getMonitor();
		var registry = this.getRegistry();
		(0, _invariant2.default)(monitor.isDragging(), 'Cannot call drop while not dragging.');
		(0, _invariant2.default)(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
	
		var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
	
		targetIds.reverse();
		targetIds.forEach(function (targetId, index) {
			var target = registry.getTarget(targetId);
	
			var dropResult = target.drop(monitor, targetId);
			(0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isObject2.default)(dropResult), 'Drop result must either be an object or undefined.');
			if (typeof dropResult === 'undefined') {
				dropResult = index === 0 ? {} : monitor.getDropResult();
			}
	
			_this.store.dispatch({
				type: DROP,
				dropResult: _extends({}, options, dropResult)
			});
		});
	}
	
	function endDrag() {
		var monitor = this.getMonitor();
		var registry = this.getRegistry();
		(0, _invariant2.default)(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
	
		var sourceId = monitor.getSourceId();
		var source = registry.getSource(sourceId, true);
		source.endDrag(monitor, sourceId);
	
		registry.unpinSource();
	
		return { type: END_DRAG };
	}

/***/ },
/* 200 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.addSource = addSource;
	exports.addTarget = addTarget;
	exports.removeSource = removeSource;
	exports.removeTarget = removeTarget;
	var ADD_SOURCE = exports.ADD_SOURCE = 'dnd-core/ADD_SOURCE';
	var ADD_TARGET = exports.ADD_TARGET = 'dnd-core/ADD_TARGET';
	var REMOVE_SOURCE = exports.REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
	var REMOVE_TARGET = exports.REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';
	
	function addSource(sourceId) {
		return {
			type: ADD_SOURCE,
			sourceId: sourceId
		};
	}
	
	function addTarget(targetId) {
		return {
			type: ADD_TARGET,
			targetId: targetId
		};
	}
	
	function removeSource(sourceId) {
		return {
			type: REMOVE_SOURCE,
			sourceId: sourceId
		};
	}
	
	function removeTarget(targetId) {
		return {
			type: REMOVE_TARGET,
			targetId: targetId
		};
	}

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(29);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(76));
	
	var on = function on() {};
	
	if (_inDOM.default) {
	  on = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	var _default = on;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 202 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getWindow;
	
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	
	module.exports = exports["default"];

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(29);
	
	exports.__esModule = true;
	exports.default = style;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(420));
	
	var _hyphenateStyle = _interopRequireDefault(__webpack_require__(971));
	
	var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(966));
	
	var _removeStyle = _interopRequireDefault(__webpack_require__(967));
	
	var _properties = __webpack_require__(283);
	
	var _isTransform = _interopRequireDefault(__webpack_require__(968));
	
	function style(node, property, value) {
	  var css = '';
	  var transforms = '';
	  var props = property;
	
	  if (typeof property === 'string') {
	    if (value === undefined) {
	      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
	    } else {
	      (props = {})[property] = value;
	    }
	  }
	
	  Object.keys(props).forEach(function (key) {
	    var value = props[key];
	
	    if (!value && value !== 0) {
	      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
	    } else if ((0, _isTransform.default)(key)) {
	      transforms += key + "(" + value + ") ";
	    } else {
	      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
	    }
	  });
	
	  if (transforms) {
	    css += _properties.transform + ": " + transforms + ";";
	  }
	
	  node.style.cssText += ';' + css;
	}
	
	module.exports = exports["default"];

/***/ },
/* 204 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(1491);
	
	var _runTransitionHook = __webpack_require__(290);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(109);
	
	var _deprecate = __webpack_require__(289);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ },
/* 206 */
/***/ function(module, exports) {

	// use as 2nd parameter for JSON.parse to revive Date instances
	module.exports = function dateReviver(key, value) {
	  var parts;
	  if (typeof value === 'string') {
	    parts = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d*))?(Z|([+\-])(\d{2}):(\d{2}))$/.exec(value);
	    if (parts) {
	      return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4], +parts[5], +parts[6], +(parts[7] || 0)));
	    }
	  }
	  return value;
	};


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	var chalk = __webpack_require__(1394);
	var base = __webpack_require__(77);
	var BaseFormatter = base.BaseFormatter;
	
	var colors = {
	  added: chalk.green,
	  deleted: chalk.red,
	  movedestination: chalk.gray,
	  moved: chalk.yellow,
	  unchanged: chalk.gray,
	  error: chalk.white.bgRed,
	  textDiffLine: chalk.gray
	};
	
	var ConsoleFormatter = function ConsoleFormatter() {
	  this.includeMoveDestinations = false;
	};
	
	ConsoleFormatter.prototype = new BaseFormatter();
	
	ConsoleFormatter.prototype.prepareContext = function(context) {
	  BaseFormatter.prototype.prepareContext.call(this, context);
	  context.indent = function(levels) {
	    this.indentLevel = (this.indentLevel || 0) +
	      (typeof levels === 'undefined' ? 1 : levels);
	    this.indentPad = new Array(this.indentLevel + 1).join('  ');
	    this.outLine();
	  };
	  context.outLine = function() {
	    this.buffer.push('\n' + (this.indentPad || ''));
	  };
	  context.out = function() {
	    for (var i = 0, l = arguments.length; i < l; i++) {
	      var lines = arguments[i].split('\n');
	      var text = lines.join('\n' + (this.indentPad || ''));
	      if (this.color && this.color[0]) {
	        text = this.color[0](text);
	      }
	      this.buffer.push(text);
	    }
	  };
	  context.pushColor = function(color) {
	    this.color = this.color || [];
	    this.color.unshift(color);
	  };
	  context.popColor = function() {
	    this.color = this.color || [];
	    this.color.shift();
	  };
	};
	
	ConsoleFormatter.prototype.typeFormattterErrorFormatter = function(context, err) {
	  context.pushColor(colors.error);
	  context.out('[ERROR]' + err);
	  context.popColor();
	};
	
	ConsoleFormatter.prototype.formatValue = function(context, value) {
	  context.out(JSON.stringify(value, null, 2));
	};
	
	ConsoleFormatter.prototype.formatTextDiffString = function(context, value) {
	  var lines = this.parseTextDiff(value);
	  context.indent();
	  for (var i = 0, l = lines.length; i < l; i++) {
	    var line = lines[i];
	    context.pushColor(colors.textDiffLine);
	    context.out(line.location.line + ',' + line.location.chr + ' ');
	    context.popColor();
	    var pieces = line.pieces;
	    for (var pieceIndex = 0, piecesLength = pieces.length; pieceIndex < piecesLength; pieceIndex++) {
	      var piece = pieces[pieceIndex];
	      context.pushColor(colors[piece.type]);
	      context.out(piece.text);
	      context.popColor();
	    }
	    if (i < l - 1) {
	      context.outLine();
	    }
	  }
	  context.indent(-1);
	};
	
	ConsoleFormatter.prototype.rootBegin = function(context, type, nodeType) {
	  context.pushColor(colors[type]);
	  if (type === 'node') {
	    context.out(nodeType === 'array' ? '[' : '{');
	    context.indent();
	  }
	};
	
	ConsoleFormatter.prototype.rootEnd = function(context, type, nodeType) {
	  if (type === 'node') {
	    context.indent(-1);
	    context.out(nodeType === 'array' ? ']' : '}');
	  }
	  context.popColor();
	};
	
	ConsoleFormatter.prototype.nodeBegin = function(context, key, leftKey, type, nodeType) {
	  context.pushColor(colors[type]);
	  context.out(leftKey + ': ');
	  if (type === 'node') {
	    context.out(nodeType === 'array' ? '[' : '{');
	    context.indent();
	  }
	};
	
	ConsoleFormatter.prototype.nodeEnd = function(context, key, leftKey, type, nodeType, isLast) {
	  if (type === 'node') {
	    context.indent(-1);
	    context.out(nodeType === 'array' ? ']' : '}' +
	      (isLast ? '' : ','));
	  }
	  if (!isLast) {
	    context.outLine();
	  }
	  context.popColor();
	};
	
	/* jshint camelcase: false */
	
	ConsoleFormatter.prototype.format_unchanged = function(context, delta, left) {
	  if (typeof left === 'undefined') {
	    return;
	  }
	  this.formatValue(context, left);
	};
	
	ConsoleFormatter.prototype.format_movedestination = function(context, delta, left) {
	  if (typeof left === 'undefined') {
	    return;
	  }
	  this.formatValue(context, left);
	};
	
	ConsoleFormatter.prototype.format_node = function(context, delta, left) {
	  // recurse
	  this.formatDeltaChildren(context, delta, left);
	};
	
	ConsoleFormatter.prototype.format_added = function(context, delta) {
	  this.formatValue(context, delta[0]);
	};
	
	ConsoleFormatter.prototype.format_modified = function(context, delta) {
	  context.pushColor(colors.deleted);
	  this.formatValue(context, delta[0]);
	  context.popColor();
	  context.out(' => ');
	  context.pushColor(colors.added);
	  this.formatValue(context, delta[1]);
	  context.popColor();
	};
	
	ConsoleFormatter.prototype.format_deleted = function(context, delta) {
	  this.formatValue(context, delta[0]);
	};
	
	ConsoleFormatter.prototype.format_moved = function(context, delta) {
	  context.out('==> ' + delta[1]);
	};
	
	ConsoleFormatter.prototype.format_textdiff = function(context, delta) {
	  this.formatTextDiffString(context, delta[0]);
	};
	
	/* jshint camelcase: true */
	
	exports.ConsoleFormatter = ConsoleFormatter;
	
	var defaultInstance;
	
	var format = function(delta, left) {
	  if (!defaultInstance) {
	    defaultInstance = new ConsoleFormatter();
	  }
	  return defaultInstance.format(delta, left);
	};
	
	exports.log = function(delta, left) {
	  console.log(format(delta, left));
	};
	
	exports.format = format;


/***/ },
/* 208 */
/***/ function(module, exports) {

	var Pipe = function Pipe(name) {
	  this.name = name;
	  this.filters = [];
	};
	
	Pipe.prototype.process = function(input) {
	  if (!this.processor) {
	    throw new Error('add this pipe to a processor before using it');
	  }
	  var debug = this.debug;
	  var length = this.filters.length;
	  var context = input;
	  for (var index = 0; index < length; index++) {
	    var filter = this.filters[index];
	    if (debug) {
	      this.log('filter: ' + filter.filterName);
	    }
	    filter(context);
	    if (typeof context === 'object' && context.exiting) {
	      context.exiting = false;
	      break;
	    }
	  }
	  if (!context.next && this.resultCheck) {
	    this.resultCheck(context);
	  }
	};
	
	Pipe.prototype.log = function(msg) {
	  console.log('[jsondiffpatch] ' + this.name + ' pipe, ' + msg);
	};
	
	Pipe.prototype.append = function() {
	  this.filters.push.apply(this.filters, arguments);
	  return this;
	};
	
	Pipe.prototype.prepend = function() {
	  this.filters.unshift.apply(this.filters, arguments);
	  return this;
	};
	
	Pipe.prototype.indexOf = function(filterName) {
	  if (!filterName) {
	    throw new Error('a filter name is required');
	  }
	  for (var index = 0; index < this.filters.length; index++) {
	    var filter = this.filters[index];
	    if (filter.filterName === filterName) {
	      return index;
	    }
	  }
	  throw new Error('filter not found: ' + filterName);
	};
	
	Pipe.prototype.list = function() {
	  var names = [];
	  for (var index = 0; index < this.filters.length; index++) {
	    var filter = this.filters[index];
	    names.push(filter.filterName);
	  }
	  return names;
	};
	
	Pipe.prototype.after = function(filterName) {
	  var index = this.indexOf(filterName);
	  var params = Array.prototype.slice.call(arguments, 1);
	  if (!params.length) {
	    throw new Error('a filter is required');
	  }
	  params.unshift(index + 1, 0);
	  Array.prototype.splice.apply(this.filters, params);
	  return this;
	};
	
	Pipe.prototype.before = function(filterName) {
	  var index = this.indexOf(filterName);
	  var params = Array.prototype.slice.call(arguments, 1);
	  if (!params.length) {
	    throw new Error('a filter is required');
	  }
	  params.unshift(index, 0);
	  Array.prototype.splice.apply(this.filters, params);
	  return this;
	};
	
	Pipe.prototype.clear = function() {
	  this.filters.length = 0;
	  return this;
	};
	
	Pipe.prototype.shouldHaveResult = function(should) {
	  if (should === false) {
	    this.resultCheck = null;
	    return;
	  }
	  if (this.resultCheck) {
	    return;
	  }
	  var pipe = this;
	  this.resultCheck = function(context) {
	    if (!context.hasResult) {
	      console.log(context);
	      var error = new Error(pipe.name + ' failed');
	      error.noResult = true;
	      throw error;
	    }
	  };
	  return this;
	};
	
	exports.Pipe = Pipe;


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(310);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(304),
	    getRawTag = __webpack_require__(1424),
	    objectToString = __webpack_require__(1448);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1433);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1413),
	    getValue = __webpack_require__(1425);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(212);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(311),
	    isObjectLike = __webpack_require__(167);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _container = __webpack_require__(315);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _warnOnce = __webpack_require__(79);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Represents an at-rule.
	 *
	 * If it’s followed in the CSS by a {} block, this node will have
	 * a nodes property representing its children.
	 *
	 * @extends Container
	 *
	 * @example
	 * const root = postcss.parse('@charset "UTF-8"; @media print {}');
	 *
	 * const charset = root.first;
	 * charset.type  //=> 'atrule'
	 * charset.nodes //=> undefined
	 *
	 * const media = root.last;
	 * media.nodes   //=> []
	 */
	var AtRule = function (_Container) {
	    _inherits(AtRule, _Container);
	
	    function AtRule(defaults) {
	        _classCallCheck(this, AtRule);
	
	        var _this = _possibleConstructorReturn(this, _Container.call(this, defaults));
	
	        _this.type = 'atrule';
	        return _this;
	    }
	
	    AtRule.prototype.append = function append() {
	        var _Container$prototype$;
	
	        if (!this.nodes) this.nodes = [];
	
	        for (var _len = arguments.length, children = Array(_len), _key = 0; _key < _len; _key++) {
	            children[_key] = arguments[_key];
	        }
	
	        return (_Container$prototype$ = _Container.prototype.append).call.apply(_Container$prototype$, [this].concat(children));
	    };
	
	    AtRule.prototype.prepend = function prepend() {
	        var _Container$prototype$2;
	
	        if (!this.nodes) this.nodes = [];
	
	        for (var _len2 = arguments.length, children = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            children[_key2] = arguments[_key2];
	        }
	
	        return (_Container$prototype$2 = _Container.prototype.prepend).call.apply(_Container$prototype$2, [this].concat(children));
	    };
	
	    _createClass(AtRule, [{
	        key: 'afterName',
	        get: function get() {
	            (0, _warnOnce2.default)('AtRule#afterName was deprecated. Use AtRule#raws.afterName');
	            return this.raws.afterName;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('AtRule#afterName was deprecated. Use AtRule#raws.afterName');
	            this.raws.afterName = val;
	        }
	    }, {
	        key: '_params',
	        get: function get() {
	            (0, _warnOnce2.default)('AtRule#_params was deprecated. Use AtRule#raws.params');
	            return this.raws.params;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('AtRule#_params was deprecated. Use AtRule#raws.params');
	            this.raws.params = val;
	        }
	
	        /**
	         * @memberof AtRule#
	         * @member {string} name - the at-rule’s name immediately follows the `@`
	         *
	         * @example
	         * const root  = postcss.parse('@media print {}');
	         * media.name //=> 'media'
	         * const media = root.first;
	         */
	
	        /**
	         * @memberof AtRule#
	         * @member {string} params - the at-rule’s parameters, the values
	         *                           that follow the at-rule’s name but precede
	         *                           any {} block
	         *
	         * @example
	         * const root  = postcss.parse('@media print, screen {}');
	         * const media = root.first;
	         * media.params //=> 'print, screen'
	         */
	
	        /**
	         * @memberof AtRule#
	         * @member {object} raws - Information to generate byte-to-byte equal
	         *                         node string as it was in the origin input.
	         *
	         * Every parser saves its own properties,
	         * but the default CSS parser uses:
	         *
	         * * `before`: the space symbols before the node. It also stores `*`
	         *   and `_` symbols before the declaration (IE hack).
	         * * `after`: the space symbols after the last child of the node
	         *   to the end of the node.
	         * * `between`: the symbols between the property and value
	         *   for declarations, selector and `{` for rules, or last parameter
	         *   and `{` for at-rules.
	         * * `semicolon`: contains true if the last child has
	         *   an (optional) semicolon.
	         * * `afterName`: the space between the at-rule name and its parameters.
	         *
	         * PostCSS cleans at-rule parameters from comments and extra spaces,
	         * but it stores origin content in raws properties.
	         * As such, if you don’t change a declaration’s value,
	         * PostCSS will use the raw value with comments.
	         *
	         * @example
	         * const root = postcss.parse('  @media\nprint {\n}')
	         * root.first.first.raws //=> { before: '  ',
	         *                       //     between: ' ',
	         *                       //     afterName: '\n',
	         *                       //     after: '\n' }
	         */
	
	    }]);
	
	    return AtRule;
	}(_container2.default);
	
	exports.default = AtRule;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _container = __webpack_require__(315);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _warnOnce = __webpack_require__(79);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	var _list = __webpack_require__(90);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Represents a CSS rule: a selector followed by a declaration block.
	 *
	 * @extends Container
	 *
	 * @example
	 * const root = postcss.parse('a{}');
	 * const rule = root.first;
	 * rule.type       //=> 'rule'
	 * rule.toString() //=> 'a{}'
	 */
	var Rule = function (_Container) {
	    _inherits(Rule, _Container);
	
	    function Rule(defaults) {
	        _classCallCheck(this, Rule);
	
	        var _this = _possibleConstructorReturn(this, _Container.call(this, defaults));
	
	        _this.type = 'rule';
	        if (!_this.nodes) _this.nodes = [];
	        return _this;
	    }
	
	    /**
	     * An array containing the rule’s individual selectors.
	     * Groups of selectors are split at commas.
	     *
	     * @type {string[]}
	     *
	     * @example
	     * const root = postcss.parse('a, b { }');
	     * const rule = root.first;
	     *
	     * rule.selector  //=> 'a, b'
	     * rule.selectors //=> ['a', 'b']
	     *
	     * rule.selectors = ['a', 'strong'];
	     * rule.selector //=> 'a, strong'
	     */
	
	
	    _createClass(Rule, [{
	        key: 'selectors',
	        get: function get() {
	            return _list2.default.comma(this.selector);
	        },
	        set: function set(values) {
	            var match = this.selector ? this.selector.match(/,\s*/) : null;
	            var sep = match ? match[0] : ',' + this.raw('between', 'beforeOpen');
	            this.selector = values.join(sep);
	        }
	    }, {
	        key: '_selector',
	        get: function get() {
	            (0, _warnOnce2.default)('Rule#_selector is deprecated. Use Rule#raws.selector');
	            return this.raws.selector;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Rule#_selector is deprecated. Use Rule#raws.selector');
	            this.raws.selector = val;
	        }
	
	        /**
	         * @memberof Rule#
	         * @member {string} selector - the rule’s full selector represented
	         *                             as a string
	         *
	         * @example
	         * const root = postcss.parse('a, b { }');
	         * const rule = root.first;
	         * rule.selector //=> 'a, b'
	         */
	
	        /**
	         * @memberof Rule#
	         * @member {object} raws - Information to generate byte-to-byte equal
	         *                         node string as it was in the origin input.
	         *
	         * Every parser saves its own properties,
	         * but the default CSS parser uses:
	         *
	         * * `before`: the space symbols before the node. It also stores `*`
	         *   and `_` symbols before the declaration (IE hack).
	         * * `after`: the space symbols after the last child of the node
	         *   to the end of the node.
	         * * `between`: the symbols between the property and value
	         *   for declarations, selector and `{` for rules, or last parameter
	         *   and `{` for at-rules.
	         * * `semicolon`: contains true if the last child has
	         *   an (optional) semicolon.
	         *
	         * PostCSS cleans selectors from comments and extra spaces,
	         * but it stores origin content in raws properties.
	         * As such, if you don’t change a declaration’s value,
	         * PostCSS will use the raw value with comments.
	         *
	         * @example
	         * const root = postcss.parse('a {\n  color:black\n}')
	         * root.first.first.raws //=> { before: '', between: ' ', after: '\n' }
	         */
	
	    }]);
	
	    return Rule;
	}(_container2.default);
	
	exports.default = Rule;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _activeElement = __webpack_require__(414);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(128);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _keycode = __webpack_require__(302);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(226);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _isRequiredForA11y = __webpack_require__(227);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(233);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ButtonGroup = __webpack_require__(469);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _DropdownMenu = __webpack_require__(1504);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	var _DropdownToggle = __webpack_require__(471);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _createChainedFunction = __webpack_require__(34);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _PropTypes = __webpack_require__(1551);
	
	var _ValidComponentChildren = __webpack_require__(45);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TOGGLE_ROLE = _DropdownToggle2['default'].defaultProps.bsRole;
	var MENU_ROLE = _DropdownMenu2['default'].defaultProps.bsRole;
	
	var propTypes = {
	  /**
	   * The menu will open above the dropdown button, instead of below it.
	   */
	  dropup: _propTypes2['default'].bool,
	
	  /**
	   * An html id attribute, necessary for assistive technologies, such as screen readers.
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  componentClass: _elementType2['default'],
	
	  /**
	   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
	   * @type {node}
	   */
	  children: (0, _all2['default'])((0, _PropTypes.requiredRoles)(TOGGLE_ROLE, MENU_ROLE), (0, _PropTypes.exclusiveRoles)(MENU_ROLE)),
	
	  /**
	   * Whether or not component is disabled.
	   */
	  disabled: _propTypes2['default'].bool,
	
	  /**
	   * Align the menu to the right side of the Dropdown toggle
	   */
	  pullRight: _propTypes2['default'].bool,
	
	  /**
	   * Whether or not the Dropdown is visible.
	   *
	   * @controllable onToggle
	   */
	  open: _propTypes2['default'].bool,
	
	  /**
	   * A callback fired when the Dropdown closes.
	   */
	  onClose: _propTypes2['default'].func,
	
	  /**
	   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
	   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
	   *
	   * ```js
	   * function(Boolean isOpen, Object event, { String source }) {}
	   * ```
	   * @controllable open
	   */
	  onToggle: _propTypes2['default'].func,
	
	  /**
	   * A callback fired when a menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
	   * a menu button.
	   */
	  role: _propTypes2['default'].string,
	
	  /**
	   * Which event when fired outside the component will cause it to be closed
	   */
	  rootCloseEvent: _propTypes2['default'].oneOf(['click', 'mousedown']),
	
	  /**
	   * @private
	   */
	  onMouseEnter: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onMouseLeave: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  componentClass: _ButtonGroup2['default']
	};
	
	var Dropdown = function (_React$Component) {
	  (0, _inherits3['default'])(Dropdown, _React$Component);
	
	  function Dropdown(props, context) {
	    (0, _classCallCheck3['default'])(this, Dropdown);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this.handleClose = _this.handleClose.bind(_this);
	
	    _this._focusInDropdown = false;
	    _this.lastOpenEventType = null;
	    return _this;
	  }
	
	  Dropdown.prototype.componentDidMount = function componentDidMount() {
	    this.focusNextOnOpen();
	  };
	
	  Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!nextProps.open && this.props.open) {
	      this._focusInDropdown = (0, _contains2['default'])(_reactDom2['default'].findDOMNode(this.menu), (0, _activeElement2['default'])(document));
	    }
	  };
	
	  Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var open = this.props.open;
	
	    var prevOpen = prevProps.open;
	
	    if (open && !prevOpen) {
	      this.focusNextOnOpen();
	    }
	
	    if (!open && prevOpen) {
	      // if focus hasn't already moved from the menu lets return it
	      // to the toggle
	      if (this._focusInDropdown) {
	        this._focusInDropdown = false;
	        this.focus();
	      }
	    }
	  };
	
	  Dropdown.prototype.handleClick = function handleClick(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    this.toggleOpen(event, { source: 'click' });
	  };
	
	  Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        if (!this.props.open) {
	          this.toggleOpen(event, { source: 'keydown' });
	        } else if (this.menu.focusNext) {
	          this.menu.focusNext();
	        }
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.handleClose(event, { source: 'keydown' });
	        break;
	      default:
	    }
	  };
	
	  Dropdown.prototype.toggleOpen = function toggleOpen(event, eventDetails) {
	    var open = !this.props.open;
	
	    if (open) {
	      this.lastOpenEventType = eventDetails.source;
	    }
	
	    if (this.props.onToggle) {
	      this.props.onToggle(open, event, eventDetails);
	    }
	  };
	
	  Dropdown.prototype.handleClose = function handleClose(event, eventDetails) {
	    if (!this.props.open) {
	      return;
	    }
	
	    this.toggleOpen(event, eventDetails);
	  };
	
	  Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
	    var menu = this.menu;
	
	    if (!menu.focusNext) {
	      return;
	    }
	
	    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
	      menu.focusNext();
	    }
	  };
	
	  Dropdown.prototype.focus = function focus() {
	    var toggle = _reactDom2['default'].findDOMNode(this.toggle);
	
	    if (toggle && toggle.focus) {
	      toggle.focus();
	    }
	  };
	
	  Dropdown.prototype.renderToggle = function renderToggle(child, props) {
	    var _this2 = this;
	
	    var ref = function ref(c) {
	      _this2.toggle = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2['default'])(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2['default'])(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3['default'])({}, props, {
	      ref: ref,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'toggle'),
	      onClick: (0, _createChainedFunction2['default'])(child.props.onClick, this.handleClick),
	      onKeyDown: (0, _createChainedFunction2['default'])(child.props.onKeyDown, this.handleKeyDown)
	    }));
	  };
	
	  Dropdown.prototype.renderMenu = function renderMenu(child, _ref) {
	    var _this3 = this;
	
	    var id = _ref.id,
	        onClose = _ref.onClose,
	        onSelect = _ref.onSelect,
	        rootCloseEvent = _ref.rootCloseEvent,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['id', 'onClose', 'onSelect', 'rootCloseEvent']);
	
	    var ref = function ref(c) {
	      _this3.menu = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2['default'])(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2['default'])(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3['default'])({}, props, {
	      ref: ref,
	      labelledBy: id,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'menu'),
	      onClose: (0, _createChainedFunction2['default'])(child.props.onClose, onClose, this.handleClose),
	      onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect, function (key, event) {
	        return _this3.handleClose(event, { source: 'select' });
	      }),
	      rootCloseEvent: rootCloseEvent
	    }));
	  };
	
	  Dropdown.prototype.render = function render() {
	    var _classes,
	        _this4 = this;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        id = _props.id,
	        dropup = _props.dropup,
	        disabled = _props.disabled,
	        pullRight = _props.pullRight,
	        open = _props.open,
	        onClose = _props.onClose,
	        onSelect = _props.onSelect,
	        role = _props.role,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'id', 'dropup', 'disabled', 'pullRight', 'open', 'onClose', 'onSelect', 'role', 'bsClass', 'className', 'rootCloseEvent', 'children']);
	
	
	    delete props.onToggle;
	
	    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);
	
	    if (dropup) {
	      classes[bsClass] = false;
	      classes.dropup = true;
	    }
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, props, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        switch (child.props.bsRole) {
	          case TOGGLE_ROLE:
	            return _this4.renderToggle(child, {
	              id: id, disabled: disabled, open: open, role: role, bsClass: bsClass
	            });
	          case MENU_ROLE:
	            return _this4.renderMenu(child, {
	              id: id, open: open, pullRight: pullRight, bsClass: bsClass, onClose: onClose, onSelect: onSelect, rootCloseEvent: rootCloseEvent
	            });
	          default:
	            return child;
	        }
	      })
	    );
	  };
	
	  return Dropdown;
	}(_react2['default'].Component);
	
	Dropdown.propTypes = propTypes;
	Dropdown.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('dropdown', Dropdown);
	
	var UncontrolledDropdown = (0, _uncontrollable2['default'])(Dropdown, { open: 'onToggle' });
	
	UncontrolledDropdown.Toggle = _DropdownToggle2['default'];
	UncontrolledDropdown.Menu = _DropdownMenu2['default'];
	
	exports['default'] = UncontrolledDropdown;
	module.exports = exports['default'];

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(520);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Show the component; triggers the fade in or fade out animation
	   */
	  'in': _propTypes2['default'].bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is faded out
	   */
	  unmountOnExit: _propTypes2['default'].bool,
	
	  /**
	   * Run the fade in animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2['default'].bool,
	
	  /**
	   * Duration of the fade animation in milliseconds, to ensure that finishing
	   * callbacks are fired even if the original browser transition end events are
	   * canceled
	   */
	  timeout: _propTypes2['default'].number,
	
	  /**
	   * Callback fired before the component fades in
	   */
	  onEnter: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to fade in
	   */
	  onEntering: _propTypes2['default'].func,
	  /**
	   * Callback fired after the has component faded in
	   */
	  onEntered: _propTypes2['default'].func,
	  /**
	   * Callback fired before the component fades out
	   */
	  onExit: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to fade out
	   */
	  onExiting: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component has faded out
	   */
	  onExited: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  'in': false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  transitionAppear: false
	};
	
	var Fade = function (_React$Component) {
	  (0, _inherits3['default'])(Fade, _React$Component);
	
	  function Fade() {
	    (0, _classCallCheck3['default'])(this, Fade);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Fade.prototype.render = function render() {
	    return _react2['default'].createElement(_Transition2['default'], (0, _extends3['default'])({}, this.props, {
	      className: (0, _classnames2['default'])(this.props.className, 'fade'),
	      enteredClassName: 'in',
	      enteringClassName: 'in'
	    }));
	  };
	
	  return Fade;
	}(_react2['default'].Component);
	
	Fade.propTypes = propTypes;
	Fade.defaultProps = defaultProps;
	
	exports['default'] = Fade;
	module.exports = exports['default'];

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _entries = __webpack_require__(362);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	exports["default"] = splitComponentProps;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function splitComponentProps(props, Component) {
	  var componentPropTypes = Component.propTypes;
	
	  var parentProps = {};
	  var childProps = {};
	
	  (0, _entries2["default"])(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (componentPropTypes[propName]) {
	      parentProps[propName] = propValue;
	    } else {
	      childProps[propName] = propValue;
	    }
	  });
	
	  return [parentProps, childProps];
	}
	module.exports = exports["default"];

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = checkDecoratorArguments;
	function checkDecoratorArguments(functionName, signature) {
		if (false) {
			for (var i = 0; i < (arguments.length <= 2 ? 0 : arguments.length - 2); i += 1) {
				var arg = arguments.length <= i + 2 ? undefined : arguments[i + 2];
				if (arg && arg.prototype && arg.prototype.render) {
					// eslint-disable-next-line no-console
					console.error('You seem to be applying the arguments in the wrong order. ' + ('It should be ' + functionName + '(' + signature + ')(Component), not the other way around. ') + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#you-seem-to-be-applying-the-arguments-in-the-wrong-order');
					return;
				}
			}
		}
	}

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(31);
	
	var EventPluginRegistry = __webpack_require__(330);
	var ReactEventEmitterMixin = __webpack_require__(1604);
	var ViewportMetrics = __webpack_require__(506);
	
	var getVendorPrefixedEventName = __webpack_require__(1636);
	var isEventSupported = __webpack_require__(341);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(174);
	var ViewportMetrics = __webpack_require__(506);
	
	var getEventModifierState = __webpack_require__(339);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var invariant = __webpack_require__(12);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 224 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(40);
	var DOMNamespaces = __webpack_require__(329);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(337);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = all;
	
	var _createChainableTypeChecker = __webpack_require__(228);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function all() {
	  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
	    validators[_key] = arguments[_key];
	  }
	
	  function allPropTypes() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var error = null;
	
	    validators.forEach(function (validator) {
	      if (error != null) {
	        return;
	      }
	
	      var result = validator.apply(undefined, args);
	      if (result != null) {
	        error = result;
	      }
	    });
	
	    return error;
	  }
	
	  return (0, _createChainableTypeChecker2.default)(allPropTypes);
	}

/***/ },
/* 227 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isRequiredForA11y;
	function isRequiredForA11y(validator) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}

/***/ },
/* 228 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(230);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(1671);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(91);
	
	var _routerWarning = __webpack_require__(35);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.canUseMembrane = undefined;
	
	var _routerWarning = __webpack_require__(35);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseMembrane = exports.canUseMembrane = false;
	
	// No-op by default.
	var deprecateObjectProperties = function deprecateObjectProperties(object) {
	  return object;
	};
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', {
	      get: function get() {
	        return true;
	      }
	    }).x) {
	      exports.canUseMembrane = canUseMembrane = true;
	    }
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	  if (canUseMembrane) {
	    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
	      // Wrap the deprecated object in a membrane to warn on property access.
	      var membrane = {};
	
	      var _loop = function _loop(prop) {
	        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
	          return 'continue';
	        }
	
	        if (typeof object[prop] === 'function') {
	          // Can't use fat arrow here because of use of arguments below.
	          membrane[prop] = function () {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop].apply(object, arguments);
	          };
	          return 'continue';
	        }
	
	        // These properties are non-enumerable to prevent React dev tools from
	        // seeing them and causing spurious warnings when accessing them. In
	        // principle this could be done with a proxy, but support for the
	        // ownKeys trap on proxies is not universal, even among browsers that
	        // otherwise support proxies.
	        Object.defineProperty(membrane, prop, {
	          get: function get() {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop];
	          }
	        });
	      };
	
	      for (var prop in object) {
	        var _ret = _loop(prop);
	
	        if (_ret === 'continue') continue;
	      }
	
	      return membrane;
	    };
	  }
	}
	
	exports.default = deprecateObjectProperties;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UNDEFINED_INPUT_ERROR = exports.INVALID_BUFFER = exports.isEnd = exports.END = undefined;
	exports.emitter = emitter;
	exports.channel = channel;
	exports.eventChannel = eventChannel;
	
	var _utils = __webpack_require__(82);
	
	var _buffers = __webpack_require__(350);
	
	var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
	var END = exports.END = { type: CHANNEL_END_TYPE };
	var isEnd = exports.isEnd = function isEnd(a) {
	  return a && a.type === CHANNEL_END_TYPE;
	};
	
	function emitter() {
	  var subscribers = [];
	
	  function subscribe(sub) {
	    subscribers.push(sub);
	    return function () {
	      return (0, _utils.remove)(subscribers, sub);
	    };
	  }
	
	  function emit(item) {
	    var arr = subscribers.slice();
	    for (var i = 0, len = arr.length; i < len; i++) {
	      arr[i](item);
	    }
	  }
	
	  return {
	    subscribe: subscribe,
	    emit: emit
	  };
	}
	
	var INVALID_BUFFER = exports.INVALID_BUFFER = 'invalid buffer passed to channel factory function';
	var UNDEFINED_INPUT_ERROR = exports.UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';
	
	if (false) {
	  exports.UNDEFINED_INPUT_ERROR = UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
	}
	
	function channel(buffer) {
	  var closed = false;
	  var takers = [];
	
	  if (arguments.length > 0) {
	    (0, _utils.check)(buffer, _utils.is.buffer, INVALID_BUFFER);
	  } else {
	    buffer = _buffers.buffers.fixed();
	  }
	
	  function checkForbiddenStates() {
	    if (closed && takers.length) {
	      throw (0, _utils.internalErr)('Cannot have a closed channel with pending takers');
	    }
	    if (takers.length && !buffer.isEmpty()) {
	      throw (0, _utils.internalErr)('Cannot have pending takers with non empty buffer');
	    }
	  }
	
	  function put(input) {
	    checkForbiddenStates();
	    (0, _utils.check)(input, _utils.is.notUndef, UNDEFINED_INPUT_ERROR);
	    if (!closed) {
	      if (takers.length) {
	        for (var i = 0; i < takers.length; i++) {
	          var cb = takers[i];
	          if (!cb[_utils.MATCH] || cb[_utils.MATCH](input)) {
	            takers.splice(i, 1);
	            return cb(input);
	          }
	        }
	      } else {
	        buffer.put(input);
	      }
	    }
	  }
	
	  function take(cb, matcher) {
	    checkForbiddenStates();
	    (0, _utils.check)(cb, _utils.is.func, 'channel.take\'s callback must be a function');
	    if (arguments.length > 1) {
	      (0, _utils.check)(matcher, _utils.is.func, 'channel.take\'s matcher argument must be a function');
	      cb[_utils.MATCH] = matcher;
	    }
	    if (closed && buffer.isEmpty()) {
	      cb(END);
	    } else if (!buffer.isEmpty()) {
	      cb(buffer.take());
	    } else {
	      takers.push(cb);
	      cb.cancel = function () {
	        return (0, _utils.remove)(takers, cb);
	      };
	    }
	  }
	
	  function close() {
	    checkForbiddenStates();
	    if (!closed) {
	      closed = true;
	      if (takers.length) {
	        var arr = takers;
	        takers = [];
	        for (var i = 0, len = arr.length; i < len; i++) {
	          arr[i](END);
	        }
	        takers = [];
	      }
	    }
	  }
	
	  return { take: take, put: put, close: close,
	    get __takers__() {
	      return takers;
	    },
	    get __closed__() {
	      return closed;
	    }
	  };
	}
	
	function eventChannel(subscribe) {
	  var buffer = arguments.length <= 1 || arguments[1] === undefined ? _buffers.buffers.none() : arguments[1];
	  var matcher = arguments[2];
	
	  /**
	    should be if(typeof matcher !== undefined) instead?
	    see PR #273 for a background discussion
	  **/
	  if (arguments.length > 2) {
	    (0, _utils.check)(matcher, _utils.is.func, 'Invalid match function passed to eventChannel');
	  }
	
	  var chan = channel(buffer);
	  var unsubscribe = subscribe(function (input) {
	    if (isEnd(input)) {
	      chan.close();
	    } else if (!matcher || matcher(input)) {
	      chan.put(input);
	    }
	  });
	
	  return {
	    take: chan.take,
	    close: function close() {
	      if (!chan.__closed__) {
	        chan.close();
	        unsubscribe();
	      }
	    }
	  };
	}

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.asEffect = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.take = take;
	exports.takem = takem;
	exports.put = put;
	exports.race = race;
	exports.call = call;
	exports.apply = apply;
	exports.cps = cps;
	exports.fork = fork;
	exports.spawn = spawn;
	exports.join = join;
	exports.cancel = cancel;
	exports.select = select;
	exports.actionChannel = actionChannel;
	exports.cancelled = cancelled;
	
	var _utils = __webpack_require__(82);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var IO = (0, _utils.sym)('IO');
	var TAKE = 'TAKE';
	var PUT = 'PUT';
	var RACE = 'RACE';
	var CALL = 'CALL';
	var CPS = 'CPS';
	var FORK = 'FORK';
	var JOIN = 'JOIN';
	var CANCEL = 'CANCEL';
	var SELECT = 'SELECT';
	var ACTION_CHANNEL = 'ACTION_CHANNEL';
	var CANCELLED = 'CANCELLED';
	
	var effect = function effect(type, payload) {
	  var _ref;
	
	  return _ref = {}, _defineProperty(_ref, IO, true), _defineProperty(_ref, type, payload), _ref;
	};
	
	function take(channel, pattern) {
	  if (arguments.length >= 2) {
	    (0, _utils.check)(channel, _utils.is.notUndef, 'take(channel, pattern): channel is undefined');
	    (0, _utils.check)(channel, _utils.is.take, 'take(channel, pattern): argument ' + String(channel) + ' is not a valid channel (channel argument must have a take method)');
	    (0, _utils.check)(pattern, _utils.is.notUndef, 'take(channel, pattern): pattern is undefined');
	    (0, _utils.check)(pattern, _utils.is.pattern, 'take(channel, pattern): argument ' + String(pattern) + ' is not a valid pattern (pattern must be String | Function: a => boolean | Array<String>)');
	  } else if (arguments.length === 1) {
	    (0, _utils.check)(channel, _utils.is.notUndef, 'take(patternOrChannel): undefined argument');
	    if (!_utils.is.take(channel)) {
	      if (_utils.is.pattern(channel)) {
	        pattern = channel;
	        channel = null;
	      } else {
	        throw new Error('take(patternOrChannel): argument ' + String(channel) + ' is not valid channel or a valid pattern');
	      }
	    } else {
	      pattern = '*';
	    }
	  } else {
	    pattern = '*';
	  }
	
	  return effect(TAKE, { channel: channel, pattern: pattern });
	}
	
	function takem() {
	  var eff = take.apply(undefined, arguments);
	  eff[TAKE].maybe = true;
	  return eff;
	}
	
	function put(channel, action) {
	  if (arguments.length > 1) {
	    (0, _utils.check)(channel, _utils.is.notUndef, 'put(channel, action): argument channel is undefined');
	    (0, _utils.check)(channel, _utils.is.put, 'put(channel, action): argument ' + channel + ' is not a valid channel (channel argument must have a put method)');
	    (0, _utils.check)(action, _utils.is.notUndef, 'put(channel, action): argument action is undefined');
	  } else {
	    (0, _utils.check)(channel, _utils.is.notUndef, 'put(action): argument action is undefined');
	    action = channel;
	    channel = null;
	  }
	  return effect(PUT, { channel: channel, action: action });
	}
	
	put.sync = function () {
	  var eff = put.apply(undefined, arguments);
	  eff[PUT].sync = true;
	  return eff;
	};
	
	function race(effects) {
	  return effect(RACE, effects);
	}
	
	function getFnCallDesc(meth, fn, args) {
	  (0, _utils.check)(fn, _utils.is.notUndef, meth + ': argument fn is undefined');
	
	  var context = null;
	  if (_utils.is.array(fn)) {
	    var _fn = fn;
	
	    var _fn2 = _slicedToArray(_fn, 2);
	
	    context = _fn2[0];
	    fn = _fn2[1];
	  } else if (fn.fn) {
	    var _fn3 = fn;
	    context = _fn3.context;
	    fn = _fn3.fn;
	  }
	  (0, _utils.check)(fn, _utils.is.func, meth + ': argument ' + fn + ' is not a function');
	
	  return { context: context, fn: fn, args: args };
	}
	
	function call(fn) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return effect(CALL, getFnCallDesc('call', fn, args));
	}
	
	function apply(context, fn) {
	  var args = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];
	
	  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
	}
	
	function cps(fn) {
	  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    args[_key2 - 1] = arguments[_key2];
	  }
	
	  return effect(CPS, getFnCallDesc('cps', fn, args));
	}
	
	function fork(fn) {
	  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    args[_key3 - 1] = arguments[_key3];
	  }
	
	  return effect(FORK, getFnCallDesc('fork', fn, args));
	}
	
	function spawn(fn) {
	  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    args[_key4 - 1] = arguments[_key4];
	  }
	
	  var eff = fork.apply(undefined, [fn].concat(args));
	  eff[FORK].detached = true;
	  return eff;
	}
	
	var isForkedTask = function isForkedTask(task) {
	  return task[_utils.TASK];
	};
	
	function join(task) {
	  (0, _utils.check)(task, _utils.is.notUndef, 'join(task): argument task is undefined');
	  if (!isForkedTask(task)) {
	    throw new Error('join(task): argument ' + task + ' is not a valid Task object \n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)');
	  }
	
	  return effect(JOIN, task);
	}
	
	function cancel(task) {
	  (0, _utils.check)(task, _utils.is.notUndef, 'cancel(task): argument task is undefined');
	  if (!isForkedTask(task)) {
	    throw new Error('cancel(task): argument ' + task + ' is not a valid Task object \n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)');
	  }
	
	  return effect(CANCEL, task);
	}
	
	function select(selector) {
	  for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	    args[_key5 - 1] = arguments[_key5];
	  }
	
	  if (arguments.length === 0) {
	    selector = _utils.ident;
	  } else {
	    (0, _utils.check)(select, _utils.is.notUndef, 'select(selector,[...]): argument selector is undefined');
	    (0, _utils.check)(selector, _utils.is.func, 'select(selector,[...]): argument ' + selector + ' is not a function');
	  }
	  return effect(SELECT, { selector: selector, args: args });
	}
	
	/**
	  channel(pattern, [buffer])    => creates an event channel for store actions
	**/
	function actionChannel(pattern, buffer) {
	  (0, _utils.check)(pattern, _utils.is.notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
	  if (arguments.length > 1) {
	    (0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
	    (0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
	  }
	  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
	}
	
	function cancelled() {
	  return effect(CANCELLED, {});
	}
	
	var asEffect = exports.asEffect = {
	  take: function take(effect) {
	    return effect && effect[IO] && effect[TAKE];
	  },
	  put: function put(effect) {
	    return effect && effect[IO] && effect[PUT];
	  },
	  race: function race(effect) {
	    return effect && effect[IO] && effect[RACE];
	  },
	  call: function call(effect) {
	    return effect && effect[IO] && effect[CALL];
	  },
	  cps: function cps(effect) {
	    return effect && effect[IO] && effect[CPS];
	  },
	  fork: function fork(effect) {
	    return effect && effect[IO] && effect[FORK];
	  },
	  join: function join(effect) {
	    return effect && effect[IO] && effect[JOIN];
	  },
	  cancel: function cancel(effect) {
	    return effect && effect[IO] && effect[CANCEL];
	  },
	  select: function select(effect) {
	    return effect && effect[IO] && effect[SELECT];
	  },
	  actionChannel: function actionChannel(effect) {
	    return effect && effect[IO] && effect[ACTION_CHANNEL];
	  },
	  cancelled: function cancelled(effect) {
	    return effect && effect[IO] && effect[CANCELLED];
	  }
	};

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createUncontrollable = __webpack_require__(1723);
	
	var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mixin = {
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    //let the forceUpdate trigger the update
	    return !this._notifying;
	  }
	};
	
	function set(component, propName, handler, value, args) {
	  if (handler) {
	    component._notifying = true;
	    handler.call.apply(handler, [component, value].concat(args));
	    component._notifying = false;
	  }
	
	  component._values[propName] = value;
	
	  if (!component.unmounted) component.forceUpdate();
	}
	
	exports.default = (0, _createUncontrollable2.default)(mixin, set);
	module.exports = exports['default'];

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Browsers, OldSelector, Prefixer, Selector, utils,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  OldSelector = __webpack_require__(601);
	
	  Prefixer = __webpack_require__(139);
	
	  Browsers = __webpack_require__(116);
	
	  utils = __webpack_require__(41);
	
	  Selector = (function(superClass) {
	    extend(Selector, superClass);
	
	    function Selector(name1, prefixes, all) {
	      this.name = name1;
	      this.prefixes = prefixes;
	      this.all = all;
	      this.regexpCache = {};
	    }
	
	    Selector.prototype.check = function(rule) {
	      if (rule.selector.indexOf(this.name) !== -1) {
	        return !!rule.selector.match(this.regexp());
	      } else {
	        return false;
	      }
	    };
	
	    Selector.prototype.prefixed = function(prefix) {
	      return this.name.replace(/^([^\w]*)/, '$1' + prefix);
	    };
	
	    Selector.prototype.regexp = function(prefix) {
	      var name;
	      if (this.regexpCache[prefix]) {
	        return this.regexpCache[prefix];
	      }
	      name = prefix ? this.prefixed(prefix) : this.name;
	      return this.regexpCache[prefix] = RegExp("(^|[^:\"'=])" + (utils.escapeRegexp(name)), "gi");
	    };
	
	    Selector.prototype.possible = function() {
	      return Browsers.prefixes();
	    };
	
	    Selector.prototype.prefixeds = function(rule) {
	      var i, len, prefix, prefixeds, ref;
	      if (rule._autoprefixerPrefixeds) {
	        return rule._autoprefixerPrefixeds;
	      }
	      prefixeds = {};
	      ref = this.possible();
	      for (i = 0, len = ref.length; i < len; i++) {
	        prefix = ref[i];
	        prefixeds[prefix] = this.replace(rule.selector, prefix);
	      }
	      return rule._autoprefixerPrefixeds = prefixeds;
	    };
	
	    Selector.prototype.already = function(rule, prefixeds, prefix) {
	      var before, index, key, prefixed, some;
	      index = rule.parent.index(rule) - 1;
	      while (index >= 0) {
	        before = rule.parent.nodes[index];
	        if (before.type !== 'rule') {
	          return false;
	        }
	        some = false;
	        for (key in prefixeds) {
	          prefixed = prefixeds[key];
	          if (before.selector === prefixed) {
	            if (prefix === key) {
	              return true;
	            } else {
	              some = true;
	              break;
	            }
	          }
	        }
	        if (!some) {
	          return false;
	        }
	        index -= 1;
	      }
	      return false;
	    };
	
	    Selector.prototype.replace = function(selector, prefix) {
	      return selector.replace(this.regexp(), '$1' + this.prefixed(prefix));
	    };
	
	    Selector.prototype.add = function(rule, prefix) {
	      var cloned, prefixeds;
	      prefixeds = this.prefixeds(rule);
	      if (this.already(rule, prefixeds, prefix)) {
	        return;
	      }
	      cloned = this.clone(rule, {
	        selector: prefixeds[prefix]
	      });
	      return rule.parent.insertBefore(rule, cloned);
	    };
	
	    Selector.prototype.old = function(prefix) {
	      return new OldSelector(this, prefix);
	    };
	
	    return Selector;
	
	  })(Prefixer);
	
	  module.exports = Selector;
	
	}).call(this);


/***/ },
/* 235 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Object.freeze({
	  0: {
	    id: '0',
	    name: 'San Francisco',
	    color: 'blue'
	  },
	  1: {
	    id: '1',
	    name: 'Chicago',
	    color: 'blue'
	  },
	  2: {
	    id: '2',
	    name: 'Atlanta',
	    color: 'blue'
	  },
	  3: {
	    id: '3',
	    name: 'Montreal',
	    color: 'blue'
	  },
	  4: {
	    id: '4',
	    name: 'Washington',
	    color: 'blue'
	  },
	  5: {
	    id: '5',
	    name: 'New York',
	    color: 'blue'
	  },
	  6: {
	    id: '6',
	    name: 'Madrid',
	    color: 'blue'
	  },
	  7: {
	    id: '7',
	    name: 'London',
	    color: 'blue'
	  },
	  8: {
	    id: '8',
	    name: 'Paris',
	    color: 'blue'
	  },
	  9: {
	    id: '9',
	    name: 'Essen',
	    color: 'blue'
	  },
	  10: {
	    id: '10',
	    name: 'Milan',
	    color: 'blue'
	  },
	  11: {
	    id: '11',
	    name: 'St. Petersburg',
	    color: 'blue'
	  },
	  12: {
	    id: '12',
	    name: 'Los Angeles',
	    color: 'yellow'
	  },
	  13: {
	    id: '13',
	    name: 'Mexico City',
	    color: 'yellow'
	  },
	  14: {
	    id: '14',
	    name: 'Lima',
	    color: 'yellow'
	  },
	  15: {
	    id: '15',
	    name: 'Santiago',
	    color: 'yellow'
	  },
	  16: {
	    id: '16',
	    name: 'Bogota',
	    color: 'yellow'
	  },
	  17: {
	    id: '17',
	    name: 'Miami',
	    color: 'yellow'
	  },
	  18: {
	    id: '18',
	    name: 'Buenos Aires',
	    color: 'yellow'
	  },
	  19: {
	    id: '19',
	    name: 'Sao Paulo',
	    color: 'yellow'
	  },
	  20: {
	    id: '20',
	    name: 'Lagos',
	    color: 'yellow'
	  },
	  21: {
	    id: '21',
	    name: 'Kinshasa',
	    color: 'yellow'
	  },
	  22: {
	    id: '22',
	    name: 'Johannesburg',
	    color: 'yellow'
	  },
	  23: {
	    id: '23',
	    name: 'Khartoum',
	    color: 'yellow'
	  },
	  24: {
	    id: '24',
	    name: 'Algiers',
	    color: 'black'
	  },
	  25: {
	    id: '25',
	    name: 'Cairo',
	    color: 'black'
	  },
	  26: {
	    id: '26',
	    name: 'Istanbul',
	    color: 'black'
	  },
	  27: {
	    id: '27',
	    name: 'Baghdad',
	    color: 'black'
	  },
	  28: {
	    id: '28',
	    name: 'Riyadh',
	    color: 'black'
	  },
	  29: {
	    id: '29',
	    name: 'Moscow',
	    color: 'black'
	  },
	  30: {
	    id: '30',
	    name: 'Tehran',
	    color: 'black'
	  },
	  31: {
	    id: '31',
	    name: 'Karachi',
	    color: 'black'
	  },
	  32: {
	    id: '32',
	    name: 'Mumbai',
	    color: 'black'
	  },
	  33: {
	    id: '33',
	    name: 'Delhi',
	    color: 'black'
	  },
	  34: {
	    id: '34',
	    name: 'Chennai',
	    color: 'black'
	  },
	  35: {
	    id: '35',
	    name: 'Kolkata',
	    color: 'black'
	  },
	  36: {
	    id: '36',
	    name: 'Jakarta',
	    color: 'red'
	  },
	  37: {
	    id: '37',
	    name: 'Bangkok',
	    color: 'red'
	  },
	  38: {
	    id: '38',
	    name: 'Beijing',
	    color: 'red'
	  },
	  39: {
	    id: '39',
	    name: 'Shanghai',
	    color: 'red'
	  },
	  40: {
	    id: '40',
	    name: 'Hong Kong',
	    color: 'red'
	  },
	  41: {
	    id: '41',
	    name: 'Ho Chi Minh City',
	    color: 'red'
	  },
	  42: {
	    id: '42',
	    name: 'Seoul',
	    color: 'red'
	  },
	  43: {
	    id: '43',
	    name: 'Taipei',
	    color: 'red'
	  },
	  44: {
	    id: '44',
	    name: 'Manila',
	    color: 'red'
	  },
	  45: {
	    id: '45',
	    name: 'Tokyo',
	    color: 'red'
	  },
	  46: {
	    id: '46',
	    name: 'Osaka',
	    color: 'red'
	  },
	  47: {
	    id: '47',
	    name: 'Sydney',
	    color: 'red'
	  }
	});

/***/ },
/* 236 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Object.freeze({
	  OUT_OF_PLAYER_CARDS: 'You have run out of player cards.',
	  OUT_OF_CUBES: function OUT_OF_CUBES(color) {
	    return 'You have run out of ' + color + ' disease cubes.';
	  },
	  OUTBREAKS: 'Eight outbreaks have occurred.'
	});

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createQuickGame = createQuickGame;
	exports.createCustomGame = createCustomGame;
	exports.dealCardsToPlayers = dealCardsToPlayers;
	exports.checkForVictory = checkForVictory;
	exports.checkForOutbreaksDefeat = checkForOutbreaksDefeat;
	exports.yieldDefeat = yieldDefeat;
	exports.yieldVictory = yieldVictory;
	exports.watchVictory = watchVictory;
	exports.watchOutbreaksDefeat = watchOutbreaksDefeat;
	exports.watchCreateQuickGame = watchCreateQuickGame;
	exports.watchCreateCustomGame = watchCreateCustomGame;
	exports.watchDealCards = watchDealCards;
	
	var _reduxSaga = __webpack_require__(137);
	
	var _effects = __webpack_require__(177);
	
	var _reactRouter = __webpack_require__(114);
	
	var _reactRouterRedux = __webpack_require__(346);
	
	var _lodash = __webpack_require__(21);
	
	var _actionTypes = __webpack_require__(25);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _roles = __webpack_require__(118);
	
	var _roles2 = _interopRequireDefault(_roles);
	
	var _names = __webpack_require__(356);
	
	var _names2 = _interopRequireDefault(_names);
	
	var _decks = __webpack_require__(648);
	
	var _defeatMessages = __webpack_require__(236);
	
	var _defeatMessages2 = _interopRequireDefault(_defeatMessages);
	
	var _globalActions = __webpack_require__(73);
	
	var _diseaseActions = __webpack_require__(92);
	
	var _cardActions = __webpack_require__(72);
	
	var _selectors = __webpack_require__(48);
	
	var sel = _interopRequireWildcard(_selectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _marked = /*#__PURE__*/regeneratorRuntime.mark(createQuickGame),
	    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(createCustomGame),
	    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(shuffleDecksAndCreateGame),
	    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(dealCardsToPlayers),
	    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(checkForVictory),
	    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(checkForOutbreaksDefeat),
	    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(yieldDefeat),
	    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(yieldVictory),
	    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(watchVictory),
	    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(watchOutbreaksDefeat),
	    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(watchCreateQuickGame),
	    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(watchCreateCustomGame),
	    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(watchDealCards),
	    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(cancelDealCards);
	
	var QUICK_GAME_DIFFICULTY = 5;
	
	function createQuickGame(action) {
	  var numberOfPlayers, availableRoles, rolesPicked, namesPicked, players, i;
	  return regeneratorRuntime.wrap(function createQuickGame$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          numberOfPlayers = action.numberOfPlayers;
	          availableRoles = Object.keys(_roles2.default);
	          rolesPicked = (0, _lodash.sampleSize)(availableRoles, numberOfPlayers);
	          namesPicked = (0, _lodash.sampleSize)(_names2.default, numberOfPlayers);
	          players = [];
	
	          for (i = 0; i < numberOfPlayers; i++) {
	            players.push({
	              name: namesPicked[i],
	              role: rolesPicked[i]
	            });
	          }
	
	          _context.next = 8;
	          return (0, _effects.call)(shuffleDecksAndCreateGame, players, QUICK_GAME_DIFFICULTY);
	
	        case 8:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function createCustomGame(action) {
	  var players, difficulty, availableRoles, playersToCreate;
	  return regeneratorRuntime.wrap(function createCustomGame$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          players = action.players, difficulty = action.difficulty;
	          availableRoles = (0, _lodash.difference)(Object.keys(_roles2.default), players.map(function (pl) {
	            return pl.role;
	          }));
	          playersToCreate = players.map(function (pl) {
	            var role = pl.role;
	            if (!role) {
	              role = (0, _lodash.sample)(availableRoles);
	              availableRoles.splice(availableRoles.indexOf(role), 1);
	            }
	            return { name: pl.name, role: role };
	          });
	          _context2.next = 5;
	          return (0, _effects.call)(shuffleDecksAndCreateGame, playersToCreate, difficulty);
	
	        case 5:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function shuffleDecksAndCreateGame(players, difficulty) {
	  var playerDeck, infectionDeck;
	  return regeneratorRuntime.wrap(function shuffleDecksAndCreateGame$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          playerDeck = (0, _lodash.shuffle)(_decks.PLAYER_DECK);
	          infectionDeck = (0, _lodash.shuffle)(_decks.INFECTION_DECK);
	          _context3.next = 4;
	          return (0, _effects.put)((0, _globalActions.createGame)(players, playerDeck, infectionDeck, difficulty));
	
	        case 4:
	
	          _reactRouter.browserHistory.push('/play');
	
	        case 5:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function dealCardsToPlayers() {
	  var cardCountMap, players, cardsToDeal, i, deck, cards, playerDeck, getRandomInt, deckLength, difficulty, _i, epidemicIndex, _i2, j, topInfectionCard, color;
	
	  return regeneratorRuntime.wrap(function dealCardsToPlayers$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          cardCountMap = {
	            1: 5,
	            2: 4,
	            3: 3,
	            4: 2,
	            5: 1
	          };
	          _context4.next = 3;
	          return (0, _effects.select)(sel.getPlayers);
	
	        case 3:
	          players = _context4.sent;
	          cardsToDeal = cardCountMap[players.length];
	          _context4.next = 7;
	          return (0, _effects.take)(types.ANIMATION_DEAL_CARDS_INIT_COMPLETE);
	
	        case 7:
	          i = 0;
	
	        case 8:
	          if (!(i < players.length)) {
	            _context4.next = 20;
	            break;
	          }
	
	          _context4.next = 11;
	          return (0, _effects.select)(sel.getPlayerDeck);
	
	        case 11:
	          deck = _context4.sent;
	          cards = (0, _lodash.sampleSize)(deck, cardsToDeal);
	          _context4.next = 15;
	          return (0, _effects.put)((0, _globalActions.dealCards)(players[i].id, cards, i));
	
	        case 15:
	          _context4.next = 17;
	          return (0, _effects.take)(types.ANIMATION_DEAL_CARDS_COMPLETE);
	
	        case 17:
	          i++;
	          _context4.next = 8;
	          break;
	
	        case 20:
	          _context4.next = 22;
	          return (0, _effects.select)(sel.getPlayerDeck);
	
	        case 22:
	          playerDeck = _context4.sent;
	
	          getRandomInt = function getRandomInt(min, max) {
	            return Math.floor(Math.random() * (max - min)) + min;
	          }; // max is not included
	
	
	          deckLength = playerDeck.length;
	          _context4.next = 27;
	          return (0, _effects.select)(sel.getDifficulty);
	
	        case 27:
	          difficulty = _context4.sent;
	          _context4.next = 30;
	          return (0, _effects.put)((0, _globalActions.insertEpidemicCardsInit)());
	
	        case 30:
	          _i = 0;
	
	        case 31:
	          if (!(_i < difficulty)) {
	            _context4.next = 38;
	            break;
	          }
	
	          epidemicIndex = getRandomInt(Math.floor(_i / difficulty * deckLength), Math.floor((_i + 1) / difficulty * deckLength));
	          _context4.next = 35;
	          return (0, _effects.put)((0, _globalActions.insertPlayerCard)(epidemicIndex, { cardType: 'epidemic', id: 'epidemic-' + _i }));
	
	        case 35:
	          _i++;
	          _context4.next = 31;
	          break;
	
	        case 38:
	          _context4.next = 40;
	          return (0, _effects.take)(types.ANIMATION_INSERT_EPIDEMIC_CARDS_COMPLETE);
	
	        case 40:
	          _context4.next = 42;
	          return (0, _effects.call)(_reduxSaga.delay, 1000);
	
	        case 42:
	          _i2 = 3;
	
	        case 43:
	          if (!(_i2 > 0)) {
	            _context4.next = 66;
	            break;
	          }
	
	          j = 0;
	
	        case 45:
	          if (!(j < 3)) {
	            _context4.next = 63;
	            break;
	          }
	
	          _context4.next = 48;
	          return (0, _effects.select)(sel.peekAtInfectionDeck);
	
	        case 48:
	          topInfectionCard = _context4.sent;
	          _context4.next = 51;
	          return (0, _effects.select)(sel.getCityColor, topInfectionCard);
	
	        case 51:
	          color = _context4.sent;
	          _context4.next = 54;
	          return (0, _effects.put)((0, _diseaseActions.useDiseaseCubes)(color, _i2));
	
	        case 54:
	          _context4.next = 56;
	          return (0, _effects.put)((0, _diseaseActions.infectCity)(topInfectionCard, color, _i2, true));
	
	        case 56:
	          _context4.next = 58;
	          return (0, _effects.take)(types.ANIMATION_DRAW_INFECTION_CARD_COMPLETE);
	
	        case 58:
	          _context4.next = 60;
	          return (0, _effects.put)((0, _cardActions.discardTopInfectionCard)());
	
	        case 60:
	          j++;
	          _context4.next = 45;
	          break;
	
	        case 63:
	          _i2--;
	          _context4.next = 43;
	          break;
	
	        case 66:
	          _context4.next = 68;
	          return (0, _effects.put)((0, _globalActions.startGame)());
	
	        case 68:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function checkForVictory() {
	  var allCured;
	  return regeneratorRuntime.wrap(function checkForVictory$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.select)(sel.areAllDiseasesCured);
	
	        case 2:
	          allCured = _context5.sent;
	
	          if (!allCured) {
	            _context5.next = 6;
	            break;
	          }
	
	          _context5.next = 6;
	          return (0, _effects.call)(yieldVictory);
	
	        case 6:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	
	function checkForOutbreaksDefeat() {
	  return regeneratorRuntime.wrap(function checkForOutbreaksDefeat$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return (0, _effects.select)(sel.isOutbreaksCountOutOfBounds);
	
	        case 2:
	          if (!_context6.sent) {
	            _context6.next = 5;
	            break;
	          }
	
	          _context6.next = 5;
	          return (0, _effects.call)(yieldDefeat, _defeatMessages2.default.OUTBREAKS);
	
	        case 5:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this);
	}
	
	function yieldDefeat(reason) {
	  return regeneratorRuntime.wrap(function yieldDefeat$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return (0, _effects.put)((0, _globalActions.defeat)(reason));
	
	        case 2:
	          _context7.next = 4;
	          return (0, _effects.put)(_reduxSaga.END);
	
	        case 4:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked7, this);
	}
	
	function yieldVictory() {
	  return regeneratorRuntime.wrap(function yieldVictory$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          _context8.next = 2;
	          return (0, _effects.put)((0, _globalActions.victory)());
	
	        case 2:
	          _context8.next = 4;
	          return (0, _effects.put)(_reduxSaga.END);
	
	        case 4:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked8, this);
	}
	
	function watchVictory() {
	  return regeneratorRuntime.wrap(function watchVictory$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          return _context9.delegateYield((0, _reduxSaga.takeEvery)(types.PLAYER_CURE_DISEASE_COMPLETE, checkForVictory), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked9, this);
	}
	
	function watchOutbreaksDefeat() {
	  return regeneratorRuntime.wrap(function watchOutbreaksDefeat$(_context10) {
	    while (1) {
	      switch (_context10.prev = _context10.next) {
	        case 0:
	          return _context10.delegateYield((0, _reduxSaga.takeEvery)(types.OUTBREAK_INIT, checkForOutbreaksDefeat), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context10.stop();
	      }
	    }
	  }, _marked10, this);
	}
	
	function watchCreateQuickGame() {
	  return regeneratorRuntime.wrap(function watchCreateQuickGame$(_context11) {
	    while (1) {
	      switch (_context11.prev = _context11.next) {
	        case 0:
	          return _context11.delegateYield((0, _reduxSaga.takeEvery)(types.CREATE_QUICK_GAME_INIT, createQuickGame), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context11.stop();
	      }
	    }
	  }, _marked11, this);
	}
	
	function watchCreateCustomGame() {
	  return regeneratorRuntime.wrap(function watchCreateCustomGame$(_context12) {
	    while (1) {
	      switch (_context12.prev = _context12.next) {
	        case 0:
	          return _context12.delegateYield((0, _reduxSaga.takeEvery)(types.CREATE_CUSTOM_GAME_INIT, createCustomGame), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context12.stop();
	      }
	    }
	  }, _marked12, this);
	}
	
	function watchDealCards() {
	  var action, task;
	  return regeneratorRuntime.wrap(function watchDealCards$(_context13) {
	    while (1) {
	      switch (_context13.prev = _context13.next) {
	        case 0:
	          if (false) {
	            _context13.next = 11;
	            break;
	          }
	
	          _context13.next = 3;
	          return (0, _effects.take)(types.DEAL_CARDS_INIT);
	
	        case 3:
	          action = _context13.sent;
	          _context13.next = 6;
	          return (0, _effects.fork)(dealCardsToPlayers, action);
	
	        case 6:
	          task = _context13.sent;
	          _context13.next = 9;
	          return (0, _effects.fork)(_reduxSaga.takeLatest, _reactRouterRedux.LOCATION_CHANGE, cancelDealCards, task);
	
	        case 9:
	          _context13.next = 0;
	          break;
	
	        case 11:
	        case 'end':
	          return _context13.stop();
	      }
	    }
	  }, _marked13, this);
	}
	
	function cancelDealCards(task, action) {
	  return regeneratorRuntime.wrap(function cancelDealCards$(_context14) {
	    while (1) {
	      switch (_context14.prev = _context14.next) {
	        case 0:
	          if (!(action.payload.pathname === '/')) {
	            _context14.next = 3;
	            break;
	          }
	
	          _context14.next = 3;
	          return (0, _effects.cancel)(task);
	
	        case 3:
	        case 'end':
	          return _context14.stop();
	      }
	    }
	  }, _marked14, this);
	}

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.enhanceCard = enhanceCard;
	exports.getPlayerCardsToDraw = getPlayerCardsToDraw;
	exports.getInfectionDeckBottom = getInfectionDeckBottom;
	exports.peekAtInfectionDeck = peekAtInfectionDeck;
	exports.getPlayerDeck = getPlayerDeck;
	exports.getPlayerDiscard = getPlayerDiscard;
	exports.getPlayerDiscardTop = getPlayerDiscardTop;
	exports.getInfectionDiscard = getInfectionDiscard;
	exports.getInfectionDiscardTop = getInfectionDiscardTop;
	exports.getCardsForForecast = getCardsForForecast;
	exports.getCardsForContPlanner = getCardsForContPlanner;
	exports.getPlayerDeckCount = getPlayerDeckCount;
	
	var _lodash = __webpack_require__(21);
	
	var _cities = __webpack_require__(235);
	
	var _cities2 = _interopRequireDefault(_cities);
	
	var _events = __webpack_require__(140);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _cities3 = __webpack_require__(141);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function enhanceCard(card, state) {
	  var res = _extends({}, card);
	  switch (card.cardType) {
	    case 'city':
	      res.color = (0, _cities3.getCityColor)(state, card.id);
	      res.name = _cities2.default[card.id].name;
	      break;
	    case 'event':
	      res.name = _events2.default[card.id].name;
	      break;
	  }
	
	  return res;
	}
	
	function getPlayerCardsToDraw(state) {
	  return state.playerCards.deck.slice(0, 2).map((0, _lodash.partialRight)(enhanceCard, state));
	}
	
	function getInfectionDeckBottom(state) {
	  var deck = getInfectionDeck(state);
	  return enhanceCard({ cardType: 'city', id: deck[deck.length - 1] }, state);
	}
	
	function peekAtInfectionDeck(state) {
	  return getInfectionDeck(state)[0];
	}
	
	function getPlayerDeck(state) {
	  return state.playerCards.deck;
	}
	
	function getPlayerDiscard(state) {
	  return state.playerCards.discard.map((0, _lodash.partialRight)(enhanceCard, state));
	}
	
	function getPlayerDiscardTop(state) {
	  return getPlayerDiscard(state)[0];
	}
	
	function getInfectionDeck(state) {
	  return state.infectionCards.deck;
	}
	
	function getInfectionDiscard(state) {
	  return state.infectionCards.discard.map(function (id) {
	    return enhanceCard({ cardType: 'city', id: id }, state);
	  });
	}
	
	function getInfectionDiscardTop(state) {
	  return getInfectionDiscard(state)[0];
	}
	
	function getCardsForForecast(state) {
	  return getInfectionDeck(state).slice(0, 6);
	}
	
	function getCardsForContPlanner(state) {
	  return state.playerCards.discard.filter(function (c) {
	    return c.cardType === 'event';
	  }).map(function (c) {
	    return _extends({}, c, { name: _events2.default[c.id].name });
	  });
	}
	
	function getPlayerDeckCount(state) {
	  return state.playerCards.deck.length;
	}

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(687);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(686);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {var path = __webpack_require__(168);
	var e2c  = __webpack_require__(973);
	var fs   = __webpack_require__(1467);
	
	var caniuse = __webpack_require__(292).agents;
	
	function normalize(versions) {
	    return versions.filter(function (version) {
	        return typeof version === 'string';
	    });
	}
	
	var FLOAT_RANGE = /^\d+(\.\d+)?(-\d+(\.\d+)?)*$/;
	var IS_SECTION = /^\s*\[(.+)\]\s*$/;
	
	function uniq(array) {
	    var filtered = [];
	    for ( var i = 0; i < array.length; i++ ) {
	        if ( filtered.indexOf(array[i]) === -1 ) filtered.push(array[i]);
	    }
	    return filtered;
	}
	
	function BrowserslistError(message) {
	    this.name = 'BrowserslistError';
	    this.message = message || '';
	    this.browserslist = true;
	    if ( Error.captureStackTrace ) {
	        Error.captureStackTrace(this, BrowserslistError);
	    }
	}
	BrowserslistError.prototype = Error.prototype;
	
	// Helpers
	
	function error(name) {
	    throw new BrowserslistError(name);
	}
	
	function fillUsage(result, name, data) {
	    for ( var i in data ) {
	        result[name + ' ' + i] = data[i];
	    }
	}
	
	function isFile(file) {
	    return fs.existsSync(file) && fs.statSync(file).isFile();
	}
	
	function eachParent(file, callback) {
	    if ( !fs.readFileSync || !fs.existsSync || !fs.statSync ) {
	        /* istanbul ignore next */
	        return undefined;
	    }
	
	    if ( file === false ) return undefined;
	    if ( typeof file === 'undefined' ) file = '.';
	    var loc = path.resolve(file);
	    do {
	        var result = callback(loc);
	        if (typeof result !== 'undefined') return result;
	    } while (loc !== (loc = path.dirname(loc)));
	    return undefined;
	}
	
	function getStat(opts) {
	    if ( opts.stats ) {
	        return opts.stats;
	    } else if ( process.env.BROWSERSLIST_STATS ) {
	        return process.env.BROWSERSLIST_STATS;
	    } else {
	        return eachParent(opts.path, function (dir) {
	            var file = path.join(dir, 'browserslist-stats.json');
	            if ( isFile(file) ) {
	                return file;
	            }
	        });
	    }
	}
	
	function parsePackage(file) {
	    var config = JSON.parse(fs.readFileSync(file)).browserslist;
	    if ( typeof config === 'object' && config.length ) {
	        config = { defaults: config };
	    }
	    return config;
	}
	
	function pickEnv(config, opts) {
	    if ( typeof config !== 'object' ) return config;
	
	    var env;
	    if ( typeof opts.env === 'string' ) {
	        env = opts.env;
	    } else if ( typeof process.env.BROWSERSLIST_ENV === 'string' ) {
	        env = process.env.BROWSERSLIST_ENV;
	    } else if ( true ) {
	        env = ("production");
	    } else {
	        env = 'development';
	    }
	
	    return config[env] || config.defaults;
	}
	
	function generateFilter(sign, version) {
	    version = parseFloat(version);
	    if ( sign === '>' ) {
	        return function (v) {
	            return parseFloat(v) > version;
	        };
	    } else if ( sign === '>=' ) {
	        return function (v) {
	            return parseFloat(v) >= version;
	        };
	    } else if ( sign === '<' ) {
	        return function (v) {
	            return parseFloat(v) < version;
	        };
	    } else if ( sign === '<=' ) {
	        return function (v) {
	            return parseFloat(v) <= version;
	        };
	    }
	}
	
	function compareStrings(a, b) {
	    if (a < b) return -1;
	    if (a > b) return +1;
	    return 0;
	}
	
	/**
	 * Return array of browsers by selection queries.
	 *
	 * @param {string[]} queries Browser queries.
	 * @param {object} opts Options.
	 * @param {string} [opts.path="."] Path to processed file.
	 *                                 It will be used to find config files.
	 * @param {string} [opts.env="development"] Processing environment.
	 *                                          It will be used to take right
	 *                                          queries from config file.
	 * @param {string} [opts.config] Path to config file with queries.
	 * @param {object} [opts.stats] Custom browser usage statistics
	 *                              for "> 1% in my stats" query.
	 * @return {string[]} Array with browser names in Can I Use.
	 *
	 * @example
	 * browserslist('IE >= 10, IE 8') //=> ['ie 11', 'ie 10', 'ie 8']
	 */
	var browserslist = function (queries, opts) {
	    if ( typeof opts === 'undefined' ) opts = { };
	
	    if ( typeof queries === 'undefined' || queries === null ) {
	        if ( process.env.BROWSERSLIST ) {
	            queries = process.env.BROWSERSLIST;
	        } else if ( opts.config || process.env.BROWSERSLIST_CONFIG ) {
	            var file = opts.config || process.env.BROWSERSLIST_CONFIG;
	            queries = pickEnv(browserslist.readConfig(file), opts);
	        } else {
	            queries = pickEnv(browserslist.findConfig(opts.path), opts);
	        }
	    }
	
	    if ( typeof queries === 'undefined' || queries === null ) {
	        queries = browserslist.defaults;
	    }
	
	    if ( typeof queries === 'string' ) {
	        queries = queries.split(/,\s*/);
	    }
	
	    var context = { };
	
	    var stats = getStat(opts);
	    if ( stats ) {
	        if ( typeof stats === 'string' ) {
	            try {
	                stats = JSON.parse(fs.readFileSync(stats));
	            } catch (e) {
	                error('Can\'t read ' + stats);
	            }
	        }
	        if ( 'dataByBrowser' in stats ) {
	            stats = stats.dataByBrowser;
	        }
	
	        context.customUsage = { };
	        for ( var browser in stats ) {
	            fillUsage(context.customUsage, browser, stats[browser]);
	        }
	    }
	
	    var result = [];
	
	    queries.forEach(function (selection) {
	        if ( selection.trim() === '' ) return;
	
	        var exclude = selection.indexOf('not ') === 0;
	        if ( exclude ) selection = selection.slice(4);
	
	        for ( var i in browserslist.queries ) {
	            var type  = browserslist.queries[i];
	            var match = selection.match(type.regexp);
	            if ( match ) {
	                var args = [context].concat(match.slice(1));
	                var array = type.select.apply(browserslist, args);
	                if ( exclude ) {
	                    array = array.concat(array.map(function (j) {
	                        return j.replace(/\s\d+/, ' 0');
	                    }));
	                    result = result.filter(function (j) {
	                        return array.indexOf(j) === -1;
	                    });
	                } else {
	                    result = result.concat(array);
	                }
	                return;
	            }
	        }
	
	        error('Unknown browser query `' + selection + '`');
	    });
	    result = result.map(function (i) {
	        var parts = i.split(' ');
	        var name = parts[0];
	        var version = parts[1];
	        if ( version === '0' ) {
	            return name + ' ' + browserslist.byName(name).versions[0];
	        } else {
	            return i;
	        }
	    }).sort(function (name1, name2) {
	        name1 = name1.split(' ');
	        name2 = name2.split(' ');
	        if ( name1[0] === name2[0] ) {
	            if ( FLOAT_RANGE.test(name1[1]) && FLOAT_RANGE.test(name2[1]) ) {
	                return parseFloat(name2[1]) - parseFloat(name1[1]);
	            } else {
	                return compareStrings(name2[1], name1[1]);
	            }
	        } else {
	            return compareStrings(name1[0], name2[0]);
	        }
	    });
	
	    return uniq(result);
	};
	
	var normalizeVersion = function (data, version) {
	    if ( data.versions.indexOf(version) !== -1 ) {
	        return version;
	    } else if ( browserslist.versionAliases[data.name][version] ) {
	        return browserslist.versionAliases[data.name][version];
	    } else if ( data.versions.length === 1 ) {
	        return data.versions[0];
	    }
	};
	
	var loadCountryStatistics = function (country) {
	    if ( !browserslist.usage[country] ) {
	        var usage = { };
	        var data = __webpack_require__(690)("./" + country + '.json');
	        for ( var i in data.data ) {
	            fillUsage(usage, i, data.data[i]);
	        }
	        browserslist.usage[country] = usage;
	    }
	};
	
	// Will be filled by Can I Use data below
	browserslist.data  = { };
	browserslist.usage = {
	    global: { },
	    custom: null
	};
	
	// Default browsers query
	browserslist.defaults = [
	    '> 1%',
	    'last 2 versions',
	    'Firefox ESR'
	];
	
	// What browsers will be used in `last n version` query
	browserslist.major = [
	    'safari', 'opera', 'ios_saf', 'ie_mob', 'ie', 'edge', 'firefox', 'chrome'
	];
	
	// Browser names aliases
	browserslist.aliases = {
	    fx:             'firefox',
	    ff:             'firefox',
	    ios:            'ios_saf',
	    explorer:       'ie',
	    blackberry:     'bb',
	    explorermobile: 'ie_mob',
	    operamini:      'op_mini',
	    operamobile:    'op_mob',
	    chromeandroid:  'and_chr',
	    firefoxandroid: 'and_ff',
	    ucandroid:      'and_uc'
	};
	
	// Aliases to work with joined versions like `ios_saf 7.0-7.1`
	browserslist.versionAliases = { };
	
	// Get browser data by alias or case insensitive name
	browserslist.byName = function (name) {
	    name = name.toLowerCase();
	    name = browserslist.aliases[name] || name;
	    return browserslist.data[name];
	};
	
	// Get browser data by alias or case insensitive name and throw error
	// on unknown browser
	browserslist.checkName = function (name) {
	    var data = browserslist.byName(name);
	    if ( !data ) error('Unknown browser ' + name);
	    return data;
	};
	
	// Read and parse config
	browserslist.readConfig = function (file) {
	    if ( !fs.existsSync(file) || !fs.statSync(file).isFile() ) {
	        error('Can\'t read ' + file + ' config');
	    }
	    return browserslist.parseConfig(fs.readFileSync(file));
	};
	
	// Find config, read file and parse it
	browserslist.findConfig = function (from) {
	    return eachParent(from, function (dir) {
	        var config = path.join(dir, 'browserslist');
	        var pkg = path.join(dir, 'package.json');
	
	        var pkgBrowserslist;
	        if ( isFile(pkg) ) {
	            try {
	                pkgBrowserslist = parsePackage(pkg);
	            } catch (e) {
	                console.warn(
	                    '[Browserslist] Could not parse ' + pkg + '. ' +
	                    'Ignoring it.');
	            }
	        }
	
	        if ( isFile(config) && pkgBrowserslist ) {
	            error(
	                dir + ' contains both browserslist ' +
	                'and package.json with browsers');
	        } else if ( isFile(config) ) {
	            return browserslist.readConfig(config);
	        } else if ( pkgBrowserslist ) {
	            return pkgBrowserslist;
	        }
	    });
	};
	
	/**
	 * Return browsers market coverage.
	 *
	 * @param {string[]} browsers Browsers names in Can I Use.
	 * @param {string} [country="global"] Which country statistics should be used.
	 *
	 * @return {number} Total market coverage for all selected browsers.
	 *
	 * @example
	 * browserslist.coverage(browserslist('> 1% in US'), 'US') //=> 83.1
	 */
	browserslist.coverage = function (browsers, country) {
	    if ( country && country !== 'global') {
	        country = country.toUpperCase();
	        loadCountryStatistics(country);
	    } else {
	        country = 'global';
	    }
	
	    return browsers.reduce(function (all, i) {
	        var usage = browserslist.usage[country][i];
	        if ( usage === undefined ) {
	            usage = browserslist.usage[country][i.replace(/ [\d.]+$/, ' 0')];
	        }
	        return all + (usage || 0);
	    }, 0);
	};
	
	// Return array of queries from config content
	browserslist.parseConfig = function (string) {
	    var result = { defaults: [] };
	    var section = 'defaults';
	
	    string.toString()
	        .replace(/#[^\n]*/g, '')
	        .split(/\n/)
	        .map(function (line) {
	            return line.trim();
	        })
	        .filter(function (line) {
	            return line !== '';
	        })
	        .forEach(function (line) {
	            if ( IS_SECTION.test(line) ) {
	                section = line.match(IS_SECTION)[1].trim();
	                result[section] = result[section] || [];
	            } else {
	                result[section].push(line);
	            }
	        });
	
	    return result;
	};
	
	browserslist.queries = {
	
	    lastVersions: {
	        regexp: /^last\s+(\d+)\s+versions?$/i,
	        select: function (context, versions) {
	            var selected = [];
	            browserslist.major.forEach(function (name) {
	                var data  = browserslist.byName(name);
	                if ( !data ) return;
	                var array = data.released.slice(-versions);
	
	                array = array.map(function (v) {
	                    return data.name + ' ' + v;
	                });
	                selected = selected.concat(array);
	            });
	            return selected;
	        }
	    },
	
	    lastByBrowser: {
	        regexp: /^last\s+(\d+)\s+(\w+)\s+versions?$/i,
	        select: function (context, versions, name) {
	            var data = browserslist.checkName(name);
	            return data.released.slice(-versions).map(function (v) {
	                return data.name + ' ' + v;
	            });
	        }
	    },
	
	    globalStatistics: {
	        regexp: /^>\s*(\d*\.?\d+)%$/,
	        select: function (context, popularity) {
	            popularity = parseFloat(popularity);
	            var result = [];
	
	            for ( var version in browserslist.usage.global ) {
	                if ( browserslist.usage.global[version] > popularity ) {
	                    result.push(version);
	                }
	            }
	
	            return result;
	        }
	    },
	
	    customStatistics: {
	        regexp: /^>\s*(\d*\.?\d+)%\s+in\s+my\s+stats$/,
	        select: function (context, popularity) {
	            popularity = parseFloat(popularity);
	            var result = [];
	
	            if ( !context.customUsage ) {
	                error('Custom usage statistics was not provided');
	            }
	
	            for ( var version in context.customUsage ) {
	                if ( context.customUsage[version] > popularity ) {
	                    result.push(version);
	                }
	            }
	
	            return result;
	        }
	    },
	
	    countryStatistics: {
	        regexp: /^>\s*(\d*\.?\d+)%\s+in\s+(\w\w)$/,
	        select: function (context, popularity, country) {
	            popularity = parseFloat(popularity);
	            country    = country.toUpperCase();
	            var result = [];
	
	            loadCountryStatistics(country);
	            var usage = browserslist.usage[country];
	
	            for ( var version in usage ) {
	                if ( usage[version] > popularity ) {
	                    result.push(version);
	                }
	            }
	
	            return result;
	        }
	    },
	
	    electronRange: {
	        regexp: /^electron\s+([\d\.]+)\s*-\s*([\d\.]+)$/i,
	        select: function (context, from, to) {
	            if ( !e2c[from] ) error('Unknown version ' + from + ' of electron');
	            if ( !e2c[to] ) error('Unknown version ' + to   + ' of electron');
	
	            from = parseFloat(from);
	            to = parseFloat(to);
	
	            return Object.keys(e2c).filter(function (i) {
	                var parsed = parseFloat(i);
	                return parsed >= from && parsed <= to;
	            }).map(function (i) {
	                return 'chrome ' + e2c[i];
	            });
	        }
	    },
	
	    range: {
	        regexp: /^(\w+)\s+([\d\.]+)\s*-\s*([\d\.]+)$/i,
	        select: function (context, name, from, to) {
	            var data = browserslist.checkName(name);
	            from = parseFloat(normalizeVersion(data, from) || from);
	            to = parseFloat(normalizeVersion(data, to) || to);
	
	            var filter = function (v) {
	                var parsed = parseFloat(v);
	                return parsed >= from && parsed <= to;
	            };
	
	            return data.released.filter(filter).map(function (v) {
	                return data.name + ' ' + v;
	            });
	        }
	    },
	
	    electronVersions: {
	        regexp: /^electron\s*(>=?|<=?)\s*([\d\.]+)$/i,
	        select: function (context, sign, version) {
	            return Object.keys(e2c)
	                .filter(generateFilter(sign, version))
	                .map(function (i) {
	                    return 'chrome ' + e2c[i];
	                });
	        }
	    },
	
	    versions: {
	        regexp: /^(\w+)\s*(>=?|<=?)\s*([\d\.]+)$/,
	        select: function (context, name, sign, version) {
	            var data = browserslist.checkName(name);
	            var alias = normalizeVersion(data, version);
	            if ( alias ) {
	                version = alias;
	            }
	            return data.released
	                .filter(generateFilter(sign, version))
	                .map(function (v) {
	                    return data.name + ' ' + v;
	                });
	        }
	    },
	
	    esr: {
	        regexp: /^(firefox|ff|fx)\s+esr$/i,
	        select: function () {
	            return ['firefox 52'];
	        }
	    },
	
	    opMini: {
	        regexp: /(operamini|op_mini)\s+all/i,
	        select: function () {
	            return ['op_mini all'];
	        }
	    },
	
	    electron: {
	        regexp: /^electron\s+([\d\.]+)$/i,
	        select: function (context, version) {
	            var chrome = e2c[version];
	            if ( !chrome ) error('Unknown version ' + version + ' of electron');
	            return ['chrome ' + chrome];
	        }
	    },
	
	    direct: {
	        regexp: /^(\w+)\s+(tp|[\d\.]+)$/i,
	        select: function (context, name, version) {
	            if ( /tp/i.test(version) ) version = 'TP';
	            var data  = browserslist.checkName(name);
	            var alias = normalizeVersion(data, version);
	            if ( alias ) {
	                version = alias;
	            } else {
	                if ( version.indexOf('.') === -1 ) {
	                    alias = version + '.0';
	                } else if ( /\.0$/.test(version) ) {
	                    alias = version.replace(/\.0$/, '');
	                }
	                alias = normalizeVersion(data, alias);
	                if ( alias ) {
	                    version = alias;
	                } else {
	                    error('Unknown version ' + version + ' of ' + name);
	                }
	            }
	            return [data.name + ' ' + version];
	        }
	    },
	
	    defaults: {
	        regexp: /^defaults$/i,
	        select: function () {
	            return browserslist(browserslist.defaults);
	        }
	    }
	
	};
	
	// Get and convert Can I Use data
	
	(function () {
	    for ( var name in caniuse ) {
	        var browser = caniuse[name];
	        browserslist.data[name] = {
	            name:     name,
	            versions: normalize(caniuse[name].versions),
	            released: normalize(caniuse[name].versions.slice(0, -3))
	        };
	        fillUsage(browserslist.usage.global, name, browser.usage_global);
	
	        browserslist.versionAliases[name] = { };
	        for ( var i = 0; i < browser.versions.length; i++ ) {
	            var full = browser.versions[i];
	            if (!full) continue;
	
	            if ( full.indexOf('-') !== -1 ) {
	                var interval = full.split('-');
	                for ( var j = 0; j < interval.length; j++ ) {
	                    browserslist.versionAliases[name][interval[j]] = full;
	                }
	            }
	        }
	    }
	}());
	
	module.exports = browserslist;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(111)))

/***/ },
/* 241 */
54,
/* 242 */
[1732, 704],
/* 243 */
63,
/* 244 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 245 */
[1748, 120, 719, 244, 248, 364, 710],
/* 246 */
192,
/* 247 */
[1759, 96, 95, 61],
/* 248 */
[1760, 249, 184],
/* 249 */
[1761, 53, 86, 182],
/* 250 */
58,
/* 251 */
[1767, 122],
/* 252 */
[1768, 86, 53, 182, 253, 96],
/* 253 */
[1769, 61],
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(196)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(33);
	var toAbsoluteIndex = __webpack_require__(106);
	var toLength = __webpack_require__(26);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(738);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ },
/* 257 */
[1731, 30, 103],
/* 258 */
[1734, 18, 13],
/* 259 */
244,
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(24)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ },
/* 261 */
[1737, 13],
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	var setPrototypeOf = __webpack_require__(271).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ },
/* 263 */
[1740, 124, 24],
/* 264 */
[1743, 100, 103, 125, 42, 24],
/* 265 */
[1744, 88, 2, 43, 42, 124, 264, 125, 51, 24],
/* 266 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ },
/* 267 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13);
	var macrotask = __webpack_require__(276).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(54)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(38);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(147);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ },
/* 271 */
[1758, 18, 11, 56, 50],
/* 272 */
[1760, 150, 107],
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(189);
	var defined = __webpack_require__(63);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(58);
	var defined = __webpack_require__(63);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ },
/* 275 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(56);
	var invoke = __webpack_require__(385);
	var html = __webpack_require__(261);
	var cel = __webpack_require__(258);
	var global = __webpack_require__(13);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(54)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(13);
	var DESCRIPTORS = __webpack_require__(27);
	var LIBRARY = __webpack_require__(88);
	var $typed = __webpack_require__(197);
	var hide = __webpack_require__(42);
	var redefineAll = __webpack_require__(104);
	var fails = __webpack_require__(15);
	var anInstance = __webpack_require__(98);
	var toInteger = __webpack_require__(58);
	var toLength = __webpack_require__(26);
	var toIndex = __webpack_require__(404);
	var gOPN = __webpack_require__(101).f;
	var dP = __webpack_require__(30).f;
	var arrayFill = __webpack_require__(255);
	var setToStringTag = __webpack_require__(125);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ },
/* 278 */
[1768, 13, 55, 88, 405, 30],
/* 279 */
[1771, 123, 24, 124, 55],
/* 280 */
[1773, 87, 388, 124, 52, 265],
/* 281 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = isDisposable;
	
	function isDisposable(obj) {
	  return Boolean(obj && typeof obj.dispose === 'function');
	}
	
	module.exports = exports['default'];

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(29);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(76));
	
	var off = function off() {};
	
	if (_inDOM.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	var _default = off;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(29);
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(76));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 285 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "681cc0c91c28e26d58e7f53fe6a91755.png";

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var origSymbol = global.Symbol;
	var hasSymbolSham = __webpack_require__(1088);
	
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 288 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ },
/* 291 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 292 */
/***/ function(module, exports) {

	module.exports = {"eras":{"e-83":"83 versions back","e-82":"82 versions back","e-81":"81 versions back","e-80":"80 versions back","e-79":"79 versions back","e-78":"78 versions back","e-77":"77 versions back","e-76":"76 versions back","e-75":"75 versions back","e-74":"74 versions back","e-73":"73 versions back","e-72":"72 versions back","e-71":"71 versions back","e-70":"70 versions back","e-69":"69 versions back","e-68":"68 versions back","e-67":"67 versions back","e-66":"66 versions back","e-65":"65 versions back","e-64":"64 versions back","e-63":"63 versions back","e-62":"62 versions back","e-61":"61 versions back","e-60":"60 versions back","e-59":"59 versions back","e-58":"58 versions back","e-57":"57 versions back","e-56":"56 versions back","e-55":"55 versions back","e-54":"54 versions back","e-53":"53 versions back","e-52":"52 versions back","e-51":"51 versions back","e-50":"50 versions back","e-49":"49 versions back","e-48":"48 versions back","e-47":"47 versions back","e-46":"46 versions back","e-45":"45 versions back","e-44":"44 versions back","e-43":"43 versions back","e-42":"42 versions back","e-41":"41 versions back","e-40":"40 versions back","e-39":"39 versions back","e-38":"38 versions back","e-37":"37 versions back","e-36":"36 versions back","e-35":"35 versions back","e-34":"34 versions back","e-33":"33 versions back","e-32":"32 versions back","e-31":"31 versions back","e-30":"30 versions back","e-29":"29 versions back","e-28":"28 versions back","e-27":"27 versions back","e-26":"26 versions back","e-25":"25 versions back","e-24":"24 versions back","e-23":"23 versions back","e-22":"22 versions back","e-21":"21 versions back","e-20":"20 versions back","e-19":"19 versions back","e-18":"18 versions back","e-17":"17 versions back","e-16":"16 versions back","e-15":"15 versions back","e-14":"14 versions back","e-13":"13 versions back","e-12":"12 versions back","e-11":"11 versions back","e-10":"10 versions back","e-9":"9 versions back","e-8":"8 versions back","e-7":"7 versions back","e-6":"6 versions back","e-5":"5 versions back","e-4":"4 versions back","e-3":"3 versions back","e-2":"2 versions back","e-1":"Previous version","e0":"Current","e1":"Near future","e2":"Farther future","e3":"3 versions ahead"},"agents":{"ie":{"browser":"IE","abbr":"IE","prefix":"ms","type":"desktop","usage_global":{"6":0.0130886,"7":0.00621152,"8":0.065443,"9":0.209417,"10":0.0196329,"11":1.08635,"5.5":0.009298},"versions":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,"5.5","6","7","8","9","10","11",null,null,null]},"edge":{"browser":"Edge","abbr":"Edge","prefix":"webkit","type":"desktop","usage_global":{"12":0.009782,"13":0.004891,"14":0.009782,"15":0.009782,"16":0.014673,"17":0.04891,"18":0.29346,"79":0,"80":0.009782,"81":0.00944,"83":0.004891,"84":0.019564,"85":0.973309,"86":1.82923,"87":0},"versions":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,"12","13","14","15","16","17","18","79","80","81","83","84","85","86","87",null,null,null],"prefix_exceptions":{"12":"ms","13":"ms","14":"ms","15":"ms","16":"ms","17":"ms","18":"ms"}},"firefox":{"browser":"Firefox","abbr":"FF","prefix":"moz","type":"desktop","usage_global":{"2":0.004827,"3":0.004538,"4":0.014673,"5":0.004879,"6":0.020136,"7":0.005725,"8":0.004525,"9":0.00533,"10":0.004283,"11":0.004711,"12":0.004471,"13":0.004486,"14":0.00453,"15":0.004465,"16":0.004417,"17":0.008922,"18":0.004393,"19":0.004443,"20":0.004283,"21":0.013596,"22":0.013698,"23":0.013614,"24":0.008786,"25":0.004403,"26":0.004317,"27":0.004393,"28":0.004418,"29":0.008834,"30":0.004403,"31":0.008928,"32":0.004471,"33":0.009284,"34":0.004707,"35":0.009076,"36":0.004891,"37":0.004783,"38":0.00472,"39":0.004783,"40":0.00487,"41":0.005029,"42":0.0047,"43":0.04891,"44":0.004891,"45":0.004891,"46":0.004525,"47":0.009782,"48":0.014673,"49":0.004538,"50":0.00472,"51":0.004642,"52":0.092929,"53":0.004335,"54":0.004891,"55":0.004891,"56":0.019564,"57":0.004891,"58":0.00944,"59":0.004891,"60":0.014673,"61":0.00472,"62":0.004891,"63":0.019564,"64":0.009782,"65":0.009782,"66":0.014673,"67":0.004891,"68":0.039128,"69":0.004891,"70":0.004891,"71":0.004891,"72":0.019564,"73":0.004891,"74":0.009782,"75":0.009782,"76":0.009782,"77":0.019564,"78":0.166294,"79":0.029346,"80":0.107602,"81":2.50908,"82":0.396171,"83":0.014673,"84":0,"85":0,"3.5":0.008786,"3.6":0.00487},"versions":["2","3","3.5","3.6","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59","60","61","62","63","64","65","66","67","68","69","70","71","72","73","74","75","76","77","78","79","80","81","82","83","84","85",null]},"chrome":{"browser":"Chrome","abbr":"Chr.","prefix":"webkit","type":"desktop","usage_global":{"4":0.004706,"5":0.004879,"6":0.004879,"7":0.005591,"8":0.005591,"9":0.005591,"10":0.004534,"11":0.004464,"12":0.010424,"13":0.009782,"14":0.004706,"15":0.015087,"16":0.004393,"17":0.004393,"18":0.008652,"19":0.004418,"20":0.004393,"21":0.004317,"22":0.009782,"23":0.008786,"24":0.004538,"25":0.004461,"26":0.004711,"27":0.004326,"28":0.0047,"29":0.004538,"30":0.004335,"31":0.009782,"32":0.004566,"33":0.009422,"34":0.009782,"35":0.004335,"36":0.004335,"37":0.004464,"38":0.024455,"39":0.004464,"40":0.009782,"41":0.0236,"42":0.004403,"43":0.009782,"44":0.004465,"45":0.004642,"46":0.004891,"47":0.009782,"48":0.019564,"49":0.24455,"50":0.004891,"51":0.004891,"52":0.004891,"53":0.039128,"54":0.014673,"55":0.009782,"56":0.029346,"57":0.019564,"58":0.014673,"59":0.009782,"60":0.014673,"61":0.039128,"62":0.014673,"63":0.034237,"64":0.014673,"65":0.034237,"66":0.024455,"67":0.039128,"68":0.029346,"69":0.088038,"70":0.088038,"71":0.107602,"72":0.088038,"73":0.063583,"74":0.092929,"75":0.078256,"76":0.092929,"77":0.068474,"78":0.107602,"79":0.161403,"80":0.224986,"81":0.151621,"83":0.303242,"84":0.503773,"85":12.1199,"86":17.9255,"87":0.034237,"88":0.019564,"89":0,"90":0},"versions":[null,"4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59","60","61","62","63","64","65","66","67","68","69","70","71","72","73","74","75","76","77","78","79","80","81","83","84","85","86","87","88","89","90"]},"safari":{"browser":"Safari","abbr":"Saf.","prefix":"webkit","type":"desktop","usage_global":{"4":0,"5":0.004566,"6":0.004656,"7":0.004465,"8":0.004891,"9":0.004891,"10":0.004891,"11":0.014673,"12":0.039128,"13":0.224986,"14":1.50154,"3.1":0,"3.2":0.008692,"5.1":0.136948,"6.1":0.00456,"7.1":0.004283,"9.1":0.029346,"10.1":0.039128,"11.1":0.102711,"12.1":0.180967,"13.1":2.0102,"TP":0},"versions":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,"3.1","3.2","4","5","5.1","6","6.1","7","7.1","8","9","9.1","10","10.1","11","11.1","12","12.1","13","13.1","14","TP",null,null]},"opera":{"browser":"Opera","abbr":"Op.","prefix":"webkit","type":"desktop","usage_global":{"9":0.0082,"11":0.016581,"12":0.004317,"15":0.00685,"16":0.00685,"17":0.00685,"18":0.005014,"19":0.006015,"20":0.004879,"21":0.006597,"22":0.006597,"23":0.013434,"24":0.006702,"25":0.006015,"26":0.005595,"27":0.004393,"28":0.008652,"29":0.004879,"30":0.004879,"31":0.004711,"32":0.005152,"33":0.005014,"34":0.009758,"35":0.004879,"36":0.009782,"37":0.004283,"38":0.004367,"39":0.004534,"40":0.004367,"41":0.004227,"42":0.004418,"43":0.009042,"44":0.004227,"45":0.004725,"46":0.004417,"47":0.008942,"48":0.004707,"49":0.004827,"50":0.004707,"51":0.004707,"52":0.004326,"53":0.008922,"54":0.014349,"55":0.004725,"56":0.00472,"57":0.00472,"58":0.00944,"60":0.00472,"62":0.004532,"63":0.004566,"64":0.02283,"65":0.00867,"66":0.004656,"67":0.004642,"68":0.009782,"69":0.00944,"70":0.122275,"71":0.92929,"72":0.019564,"9.5-9.6":0.00685,"10.0-10.1":0,"10.5":0.008392,"10.6":0.004706,"11.1":0.006229,"11.5":0.004879,"11.6":0.008786,"12.1":0.00472},"versions":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,"9","9.5-9.6","10.0-10.1","10.5","10.6","11","11.1","11.5","11.6","12","12.1","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","60","62","63","64","65","66","67","68","69","70","71","72",null,null,null],"prefix_exceptions":{"9":"o","11":"o","12":"o","9.5-9.6":"o","10.0-10.1":"o","10.5":"o","10.6":"o","11.1":"o","11.5":"o","11.6":"o","12.1":"o"}},"ios_saf":{"browser":"iOS Safari","abbr":"iOS","prefix":"webkit","type":"mobile","usage_global":{"8":0,"14":5.38701,"3.2":0.0129052,"4.0-4.1":0.0110616,"4.2-4.3":0.0018436,"5.0-5.1":0.00921801,"6.0-6.1":0.00553081,"7.0-7.1":0.0129052,"8.1-8.4":0.0424029,"9.0-9.2":0.0239668,"9.3":0.306038,"10.0-10.2":0.0516209,"10.3":0.283915,"11.0-11.2":0.106929,"11.3-11.4":0.182517,"12.0-12.1":0.186204,"12.2-12.4":1.85651,"13.0-13.1":0.153019,"13.2":0.0755877,"13.3":0.575204,"13.4-13.7":3.06407},"versions":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,"3.2","4.0-4.1","4.2-4.3","5.0-5.1","6.0-6.1","7.0-7.1","8","8.1-8.4","9.0-9.2","9.3","10.0-10.2","10.3","11.0-11.2","11.3-11.4","12.0-12.1","12.2-12.4","13.0-13.1","13.2","13.3","13.4-13.7","14",null,null,null]},"op_mini":{"browser":"Opera Mini","abbr":"O.Mini","prefix":"o","type":"mobile","usage_global":{"all":0.875474},"versions":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,"all",null,null,null]},"android":{"browser":"Android Browser","abbr":"And.","prefix":"webkit","type":"mobile","usage_global":{"3":0,"4":0.0373129,"81":0,"2.1":0,"2.2":0,"2.3":0.000298503,"4.1":0.0188057,"4.2-4.3":0.00835809,"4.4":0,"4.4.3-4.4.4":0.0680588},"versions":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,"2.1","2.2","2.3","3","4","4.1","4.2-4.3","4.4","4.4.3-4.4.4","81",null,null,null]},"bb":{"browser":"Blackberry Browser","abbr":"BB","prefix":"webkit","type":"mobile","usage_global":{"7":0,"10":0},"versions":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,"7","10",null,null,null]},"op_mob":{"browser":"Opera Mobile","abbr":"O.Mob","prefix":"o","type":"mobile","usage_global":{"10":0,"11":0,"12":0,"59":0.0111391,"11.1":0,"11.5":0,"12.1":0},"versions":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,"10","11","11.1","11.5","12","12.1","59",null,null,null],"prefix_exceptions":{"59":"webkit"}},"and_chr":{"browser":"Chrome for Android","abbr":"Chr/And.","prefix":"webkit","type":"mobile","usage_global":{"86":33.5525},"versions":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,"86",null,null,null]},"and_ff":{"browser":"Firefox for Android","abbr":"FF/And.","prefix":"moz","type":"mobile","usage_global":{"82":0.229905},"versions":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,"82",null,null,null]},"ie_mob":{"browser":"IE Mobile","abbr":"IE.Mob","prefix":"ms","type":"mobile","usage_global":{"10":0.0115934,"11":0.022664},"versions":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,"10","11",null,null,null]},"and_uc":{"browser":"UC Browser for Android","abbr":"UC","prefix":"webkit","type":"mobile","usage_global":{"12.12":1.21083},"versions":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,"12.12",null,null,null],"prefix_exceptions":{"12.12":"webkit"}},"samsung":{"browser":"Samsung Internet","abbr":"SS","prefix":"webkit","type":"mobile","usage_global":{"4":0.251766,"5.0-5.4":0.0104903,"6.2-6.4":0.010304,"7.2-7.4":0.0629416,"8.2":0.0209805,"9.2":0.115393,"10.1":0.0734319,"11.1-11.2":0.178335,"12.0":2.63306},"versions":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,"4","5.0-5.4","6.2-6.4","7.2-7.4","8.2","9.2","10.1","11.1-11.2","12.0",null,null,null]},"and_qq":{"browser":"QQ Browser","abbr":"QQ","prefix":"webkit","type":"mobile","usage_global":{"10.4":0.199251},"versions":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,"10.4",null,null,null]},"baidu":{"browser":"Baidu Browser","abbr":"baidu","prefix":"webkit","type":"mobile","usage_global":{"7.12":0},"versions":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,"7.12",null,null,null]},"kaios":{"browser":"KaiOS Browser","abbr":"Kai","prefix":"moz","type":"mobile","usage_global":{"2.5":0.035763},"versions":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,"2.5",null,null,null]}},"statuses":{"rec":"W3C Recommendation","pr":"W3C Proposed Recommendation","cr":"W3C Candidate Recommendation","wd":"W3C Working Draft","ls":"WHATWG Living Standard","other":"Other","unoff":"Unofficial / Note"},"cats":{"CSS":["CSS","CSS2","CSS3"],"HTML5":["Canvas","HTML5"],"JS":["JS"],"JS API":["JS API"],"Other":["PNG","Other","DOM"],"Security":["Security"],"SVG":["SVG"]},"updated":1606201118,"data":{"aac":{"title":"AAC audio file format","description":"Advanced Audio Coding format, designed to be the successor format to MP3, with generally better sound quality.","spec":"http://www.digitalpreservation.gov/formats/fdd/fdd000114.shtml","status":"other","links":[{"url":"https://en.wikipedia.org/wiki/Advanced_Audio_Coding","title":"Wikipedia article"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","59":"a #1","60":"a #1","61":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #1","66":"a #1","67":"a #1","68":"a #1","69":"a #1","70":"a #1","71":"a #1","72":"a #1","73":"a #1","74":"a #1","75":"a #1","76":"a #1","77":"a #1","78":"a #1","79":"a #1","80":"a #1","81":"a #1","82":"a #1","83":"a #1","84":"a #1","85":"a #1","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"u","11":"u","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"u","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"a #1"},"ie_mob":{"10":"y","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"a #1"}},"notes":"Support refers to this format's use in the `audio` element, not other conditions.","notes_by_num":{"1":"Partial support in Firefox refers to only supporting AAC in an MP4 container and only when the operating system already has the codecs installed."},"usage_perc_y":94.34,"usage_perc_a":4.08,"ucprefix":false,"parent":"audio","keywords":"audio/aac","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"abortcontroller":{"title":"AbortController & AbortSignal","description":"Controller object that allows you to abort one or more DOM requests made with the Fetch API.","spec":"https://dom.spec.whatwg.org/#abortsignal","status":"ls","links":[{"url":"https://developers.google.com/web/updates/2017/09/abortable-fetch","title":"Abortable Fetch - Google Developers article"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/AbortController","title":"AbortController - MDN Web Docs"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal","title":"AbortSignal - MDN Web Docs"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n #1","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n #1","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Safari has window.AbortController defined in the DOM but it's just a stub, it does not abort requests at all. The same issue also affects Chrome on IOS and Firefox on IOS because they use the same WebKit rendering engine as Safari."},"usage_perc_y":92.64,"usage_perc_a":0,"ucprefix":false,"parent":"fetch","keywords":"abort api","ie_id":"","chrome_id":"5631483679080448","firefox_id":"abort-api","webkit_id":""},"accelerometer":{"title":"Accelerometer","description":"Defines `Accelerometer`, `LinearAccelerationSensor` and `GravitySensor` interfaces for obtaining information about acceleration applied to the X, Y and Z axis of a device that hosts the sensor.","spec":"https://www.w3.org/TR/accelerometer/","status":"cr","links":[{"url":"https://intel.github.io/generic-sensor-demos/punchmeter/","title":"Demo"},{"url":"https://developers.google.com/web/updates/2017/09/sensors-for-the-web#acceleration-and-linear-accelerometer-sensor","title":"Article"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n d #1","59":"n d #1","60":"n d #1","61":"n d #1","62":"n d #1","63":"n d #1","64":"n d #1","65":"n d #1","66":"n d #1","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Available by enabling the \"Generic Sensor\" experimental flag in `about:flags`"},"usage_perc_y":69.97,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"5698781827825664","firefox_id":"","webkit_id":""},"addeventlistener":{"title":"EventTarget.addEventListener()","description":"The modern standard API for adding DOM event handlers. Introduced in the DOM Level 2 Events spec. Also implies support for `removeEventListener`, the [capture phase](https://dom.spec.whatwg.org/#dom-event-capturing_phase) of DOM event dispatch, as well as the `stopPropagation()` and `preventDefault()` event methods.","spec":"https://dom.spec.whatwg.org/#dom-eventtarget-addeventlistener","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener","title":"MDN Web Docs - addEventListener"},{"url":"https://github.com/Financial-Times/polyfill-service/blob/master/polyfills/Event/polyfill.js","title":"Financial Times IE8 polyfill"},{"url":"https://github.com/WebReflection/ie8","title":"WebReflection ie8 polyfill"}],"categories":["DOM"],"stats":{"ie":{"6":"n #1","7":"n #1","8":"n #1","9":"y","10":"y","11":"y","5.5":"n #1"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y #2","3":"y #2","4":"y #2","5":"y #2","6":"y #2","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y #2","3.6":"y #2"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"IE<=8 instead only supports the [proprietary `.attachEvent()` method](https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener). It also does not support the [capture phase](https://www.w3.org/TR/DOM-Level-3-Events/#event-flow) of DOM event dispatch; it only supports event bubbling.","2":"The `useCapture` parameter is non-optional and must be provided. Future versions made it optional, with a default value of `false`."},"usage_perc_y":99.61,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"event,target,add,remove,listener,capture,capturing,phase","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"ambient-light":{"title":"Ambient Light Sensor","description":"Defines a concrete sensor interface to monitor the ambient light level or illuminance of the device’s environment.","spec":"https://www.w3.org/TR/ambient-light/","status":"cr","links":[{"url":"https://intel.github.io/generic-sensor-demos/ambient-map/build/bundled/","title":"Demo"},{"url":"https://developers.google.com/web/updates/2017/09/sensors-for-the-web","title":"Article"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Ambient_Light_Sensor_API","title":"MDN Web Docs - Ambient Light Sensor"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Ambient_Light_Events","title":"MDN Web Docs - Ambient Light Events"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","79":"n d #2","80":"n d #2","81":"n d #2","83":"n d #2","84":"n d #2","85":"n d #2","86":"n d #2","87":"n d #2"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","59":"a #1","60":"n d #1","61":"n d #1","62":"n d #1","63":"n d #1","64":"n d #1","65":"n d #1","66":"n d #1","67":"n d #1","68":"n d #1","69":"n d #1","70":"n d #1","71":"n d #1","72":"n d #1","73":"n d #1","74":"n d #1","75":"n d #1","76":"n d #1","77":"n d #1","78":"n d #1","79":"n d #1","80":"n d #1","81":"n d #1","82":"n d #1","83":"n d #1","84":"n d #1","85":"n d #1","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n d #2","59":"n d #2","60":"n d #2","61":"n d #2","62":"n d #2","63":"n d #2","64":"n d #2","65":"n d #2","66":"n d #2","67":"n d #2","68":"n d #2","69":"n d #2","70":"n d #2","71":"n d #2","72":"n d #2","73":"n d #2","74":"n d #2","75":"n d #2","76":"n d #2","77":"n d #2","78":"n d #2","79":"n d #2","80":"n d #2","81":"n d #2","83":"n d #2","84":"n d #2","85":"n d #2","86":"n d #2","87":"n d #2","88":"n d #2","89":"n d #2","90":"n d #2"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"a #1"}},"notes":"","notes_by_num":{"1":"Implements an [outdated version of the spec](https://www.w3.org/TR/2015/WD-ambient-light-20150903/).","2":"Available by enabling the \"Generic Sensor Extra Classes\" experimental flag in `about:flags`"},"usage_perc_y":0.23,"usage_perc_a":0.8,"ucprefix":false,"parent":"","keywords":"","ie_id":"ambientlightsensorapi","chrome_id":"5298357018820608","firefox_id":"","webkit_id":""},"apng":{"title":"Animated PNG (APNG)","description":"Like animated GIFs, but allowing 24-bit colors and alpha transparency","spec":"https://wiki.mozilla.org/APNG_Specification","status":"unoff","links":[{"url":"https://en.wikipedia.org/wiki/APNG","title":"Wikipedia"},{"url":"https://github.com/davidmz/apng-canvas","title":"Polyfill using canvas"},{"url":"https://chrome.google.com/webstore/detail/ehkepjiconegkhpodgoaeamnpckdbblp","title":"Chrome extension providing support"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6513393-apng-animated-png-images-support-firefox-and-sa","title":"Microsoft Edge feature request on UserVoice (under review)"},{"url":"https://addons.opera.com/en/extensions/details/apng/?display=en","title":"Opera extension providing support"},{"url":"https://code.google.com/p/chromium/issues/detail?id=437662","title":"Chromium issue (fixed)"},{"url":"https://developer.mozilla.org/en-US/docs/Mozilla/Tech/APNG","title":"MDN Web Docs - APNG"}],"categories":["PNG"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"Where support for APNG is missing, only the first frame is displayed","notes_by_num":{},"usage_perc_y":94.04,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"6691520493125632","firefox_id":"","webkit_id":""},"array-find":{"title":"Array.prototype.find","description":"The `find()` method returns the value of the first item in the array based on the result of the provided testing function.","spec":"https://tc39.es/ecma262/#sec-array.prototype.find","status":"other","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find","title":"MDN article"},{"url":"https://github.com/zloirock/core-js#ecmascript-array","title":"Polyfill for this feature is available in the core-js library"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"u","13":"u","14":"u","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"u"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":96.1,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"array.find","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"array-find-index":{"title":"Array.prototype.findIndex","description":"The `findIndex()` method returns the index of the first element in the array that satisfies the provided testing function.","spec":"https://tc39.es/ecma262/#sec-array.prototype.findindex","status":"other","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex","title":"MDN article"},{"url":"https://github.com/zloirock/core-js#ecmascript-array","title":"Polyfill for this feature is available in the core-js library"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"u"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":96.13,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"array.findIndex","ie_id":"","chrome_id":"6732923508097024","firefox_id":"","webkit_id":""},"array-flat":{"title":"flat & flatMap array methods","description":"Methods to flatten any sub-arrays found in an array by concatenating their elements.","spec":"https://tc39.es/ecma262/#sec-array.prototype.flat","status":"other","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/flat","title":"MDN article on Array.prototype.flat"},{"url":"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/flatMap","title":"MDN article on Array.prototype.flatMap"},{"url":"https://developers.google.com/web/updates/2018/03/smooshgate","title":"Article on the history of the `flat` methods"},{"url":"https://github.com/jonathantneal/array-flat-polyfill","title":"Polyfill for flat & flatMap"},{"url":"https://github.com/zloirock/core-js#ecmascript-array","title":"Polyfill for this feature is available in the core-js library"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":91.68,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"array.prototype.flat,array.prototype.flatmap","ie_id":"","chrome_id":"6629507075145728","firefox_id":"","webkit_id":""},"array-includes":{"title":"Array.prototype.includes","description":"Determines whether or not an array includes the given value, returning a boolean value (unlike `indexOf`).","spec":"https://tc39.es/ecma262/#sec-array.prototype.includes","status":"other","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/includes#Browser_compatibility","title":"MDN Web Docs"},{"url":"https://github.com/zloirock/core-js#ecmascript-array","title":"Polyfill for this feature is available in the core-js library"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":95.94,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"array.includes","ie_id":"arrayprototypeincludeses2016","chrome_id":"5964420647747584","firefox_id":"","webkit_id":"feature-array.prototype.includes"},"arrow-functions":{"title":"Arrow functions","description":"Function shorthand using `=>` syntax and lexical `this` binding.","spec":"https://tc39.es/ecma262/#sec-arrow-function-definitions","status":"other","links":[{"url":"https://github.com/lukehoban/es6features#arrows","title":"ECMAScript 6 features: Arrows"},{"url":"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/Arrow_functions","title":"MDN Web Docs - Arrow functions"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":95.75,"usage_perc_a":0,"ucprefix":false,"parent":"es6","keywords":"ES6,JavaScript,fat,arrow,function,lexical,this","ie_id":"arrowfunctiones6","chrome_id":"5047308127305728","firefox_id":"","webkit_id":"feature-arrow-functions"},"asmjs":{"title":"asm.js","description":"An extraordinarily optimizable, low-level subset of JavaScript, intended to be a compile target from languages like C++.","spec":"http://asmjs.org/spec/latest/","status":"other","links":[{"url":"http://asmjs.org/","title":"Homepage"},{"url":"https://github.com/dherman/asm.js/","title":"Source for spec and tools"},{"url":"https://blogs.windows.com/msedgedev/2015/05/07/bringing-asm-js-to-chakra-microsoft-edge/","title":"Bringing Asm.js to Chakra and Microsoft Edge"},{"url":"https://dev.modern.ie/platform/changelog/10532-pc/","title":"Microsoft Edge support announcement"}],"categories":["JS","JS API","Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n d #2","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"a #1","80":"a #1","81":"a #1","83":"a #1","84":"a #1","85":"a #1","86":"a #1","87":"a #1"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","59":"a #1","60":"a #1","61":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #1","66":"a #1","67":"a #1","68":"a #1","69":"a #1","70":"a #1","71":"a #1","72":"a #1","73":"a #1","74":"a #1","75":"a #1","76":"a #1","77":"a #1","78":"a #1","79":"a #1","80":"a #1","81":"a #1","83":"a #1","84":"a #1","85":"a #1","86":"a #1","87":"a #1","88":"a #1","89":"a #1","90":"a #1"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","60":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #1","66":"a #1","67":"a #1","68":"a #1","69":"a #1","70":"a #1","71":"a #1","72":"a #1","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"a #1","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"a #1","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a #1"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"a #1","6.2-6.4":"a #1","7.2-7.4":"a #1","8.2":"a #1","9.2":"a #1","10.1":"a #1","11.1-11.2":"a #1","12.0":"a #1"},"and_qq":{"10.4":"a #1"},"baidu":{"7.12":"a #1"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Chrome does not support Ahead-Of-Time compilation but performance doubled in Chrome 28: https://en.wikipedia.org/wiki/Asm.js#Implementations","2":"Supported in MS Edge under the \"Enable experimental JavaScript features\" flag."},"usage_perc_y":4.46,"usage_perc_a":74.27,"ucprefix":false,"parent":"","keywords":"asm,asm.js,asmjs,WebAssembly","ie_id":"asmjs","chrome_id":"","firefox_id":"asmjs","webkit_id":"specification-webassembly"},"async-functions":{"title":"Async functions","description":"Async functions make it possible to treat functions returning Promise objects as if they were synchronous.","spec":"https://tc39.es/ecma262/#sec-async-function-definitions","status":"other","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/async_function","title":"MDN Web Docs - Async functions"},{"url":"https://developers.google.com/web/fundamentals/getting-started/primers/async-functions","title":"Async functions - making promises friendly"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n d #1","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n #3","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n #3","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Since build 14342 - disabled by default; can be enabled through about:flags","2":"Async functions are present in Firefox Nightly since 31th October 2016.","3":"Async arrow functions are [unsupported](https://github.com/kangax/compat-table/pull/1420)."},"usage_perc_y":94.65,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"ES2017,JavaScript,function,async,await,promises,asynchronous","ie_id":"asyncfunctions","chrome_id":"5643236399906816","firefox_id":"async-function","webkit_id":""},"atob-btoa":{"title":"Base64 encoding and decoding","description":"Utility functions for of encoding and decoding strings to and from base 64: window.atob() and window.btoa().","spec":"https://html.spec.whatwg.org/multipage/webappapis.html#atob","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Window.btoa","title":"MDN Web Docs - btoa()"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Window.atob","title":"MDN Web Docs - atob()"},{"url":"https://github.com/davidchambers/Base64.js","title":"Polyfill"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"u","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"u","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":99.37,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"atob,btoa","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"audio":{"title":"Audio element","description":"Method of playing sound on webpages (without requiring a plug-in). Includes support for the following media properties: `currentSrc`, `currentTime`, `paused`, `playbackRate`, `buffered`, `duration`, `played`, `seekable`, `ended`, `autoplay`, `loop`, `controls`, `volume` & `muted`","spec":"https://html.spec.whatwg.org/multipage/embedded-content.html#the-audio-element","status":"ls","links":[{"url":"https://html5doctor.com/native-audio-in-the-browser/","title":"HTML5 Doctor article"},{"url":"https://dev.opera.com/articles/view/everything-you-need-to-know-about-html5-video-and-audio/","title":"Detailed article on video/audio elements"},{"url":"https://www.jplayer.org/latest/demos/","title":"Demos of audio player that uses the audio element"},{"url":"https://24ways.org/2010/the-state-of-html5-audio","title":"Detailed article on support"},{"url":"http://textopia.org/androidsoundformats.html","title":"File format test page"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/audio.js#audio","title":"has.js test"},{"url":"https://www.webplatform.org/docs/html/elements/audio","title":"WebPlatform Docs"},{"url":"https://www.phoboslab.org/log/2011/03/the-state-of-html5-audio","title":"The State of HTML5 Audio"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a #1","3.6":"a #1"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"a","10.0-10.1":"a","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"n","2.2":"n","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Old Firefox versions were missing support for some properties: `loop` was added in v11, `played` in v15, `playbackRate` in v20."},"usage_perc_y":98.57,"usage_perc_a":0.12,"ucprefix":false,"parent":"","keywords":"<audio>","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"audio-api":{"title":"Web Audio API","description":"High-level JavaScript API for processing and synthesizing audio","spec":"https://www.w3.org/TR/webaudio/","status":"wd","links":[{"url":"https://github.com/corbanbrook/audionode.js","title":"Polyfill to support Web Audio API in Firefox"},{"url":"https://www.webplatform.org/docs/apis/webaudio","title":"WebPlatform Docs"},{"url":"http://www.doboism.com/projects/webaudio-compatibility/","title":"Additional browser compatibility tests for specific features"},{"url":"https://github.com/g200kg/WAAPISim","title":"Polyfill to enable Web Audio API through Firefox Audio Data api or flash"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Web_Audio_API","title":"MDN Web Docs - Web Audio API"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","3.1":"n","3.2":"n","5.1":"n","6.1":"y x","7.1":"y x","9.1":"y x","10.1":"y x","11.1":"y x","12.1":"y x","13.1":"y x","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y x","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y x","10.3":"y x","11.0-11.2":"y x","11.3-11.4":"y x","12.0-12.1":"y x","12.2-12.4":"y x","13.0-13.1":"y x","13.2":"y x","13.3":"y x","13.4-13.7":"y x"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Not all browsers with support for the Audio API also support media streams (e.g. microphone input). See the [getUserMedia/Streams API](/#feat=stream) data for support for that feature.\r\n\r\nFirefox versions < 25 support an alternative, deprecated audio API.\r\n\r\nChrome support [went through some changes](https://developers.google.com/web/updates/2014/07/Web-Audio-Changes-in-m36) as of version 36.","notes_by_num":{},"usage_perc_y":96.78,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"web-audio,webaudio,AudioContext,AudioBuffer,AudioNode","ie_id":"webaudioapi","chrome_id":"6261718720184320","firefox_id":"webaudio","webkit_id":"feature-web-audio"},"audiotracks":{"title":"Audio Tracks","description":"Method of specifying and selecting between multiple audio tracks. Useful for providing audio descriptions, director's commentary, additional languages, alternative takes, etc.","spec":"https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist-and-videotracklist-objects","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/audioTracks","title":"MDN Web Docs - HTMLMediaElement.audioTracks"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"n d #2","80":"n d #2","81":"n d #2","83":"n d #2","84":"n d #2","85":"n d #2","86":"n d #2","87":"n d #2"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n d #1","34":"n d #1","35":"n d #1","36":"n d #1","37":"n d #1","38":"n d #1","39":"n d #1","40":"n d #1","41":"n d #1","42":"n d #1","43":"n d #1","44":"n d #1","45":"n d #1","46":"n d #1","47":"n d #1","48":"n d #1","49":"n d #1","50":"n d #1","51":"n d #1","52":"n d #1","53":"n d #1","54":"n d #1","55":"n d #1","56":"n d #1","57":"n d #1","58":"n d #1","59":"n d #1","60":"n d #1","61":"n d #1","62":"n d #1","63":"n d #1","64":"n d #1","65":"n d #1","66":"n d #1","67":"n d #1","68":"n d #1","69":"n d #1","70":"n d #1","71":"n d #1","72":"n d #1","73":"n d #1","74":"n d #1","75":"n d #1","76":"n d #1","77":"n d #1","78":"n d #1","79":"n d #1","80":"n d #1","81":"n d #1","82":"n d #1","83":"n d #1","84":"n d #1","85":"n d #1","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n d #2","46":"n d #2","47":"n d #2","48":"n d #2","49":"n d #2","50":"n d #2","51":"n d #2","52":"n d #2","53":"n d #2","54":"n d #2","55":"n d #2","56":"n d #2","57":"n d #2","58":"n d #2","59":"n d #2","60":"n d #2","61":"n d #2","62":"n d #2","63":"n d #2","64":"n d #2","65":"n d #2","66":"n d #2","67":"n d #2","68":"n d #2","69":"n d #2","70":"n d #2","71":"n d #2","72":"n d #2","73":"n d #2","74":"n d #2","75":"n d #2","76":"n d #2","77":"n d #2","78":"n d #2","79":"n d #2","80":"n d #2","81":"n d #2","83":"n d #2","84":"n d #2","85":"n d #2","86":"n d #2","87":"n d #2","88":"n d #2","89":"n d #2","90":"n d #2"},"safari":{"4":"n","5":"n","6":"n","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n d #2","33":"n d #2","34":"n d #2","35":"n d #2","36":"n d #2","37":"n d #2","38":"n d #2","39":"n d #2","40":"n d #2","41":"n d #2","42":"n d #2","43":"n d #2","44":"n d #2","45":"n d #2","46":"n d #2","47":"n d #2","48":"n d #2","49":"n d #2","50":"n d #2","51":"n d #2","52":"n d #2","53":"n d #2","54":"n d #2","55":"n d #2","56":"n d #2","57":"n d #2","58":"n d #2","60":"n d #2","62":"n d #2","63":"n d #2","64":"n d #2","65":"n d #2","66":"n d #2","67":"n d #2","68":"n d #2","69":"n d #2","70":"n d #2","71":"n d #2","72":"n d #2","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n d #2","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n d #2"},"and_ff":{"82":"n"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n d #1"}},"notes":"","notes_by_num":{"1":"Supported in Firefox by enabling \"media.track.enabled\" in about:config","2":"Supported in Chrome and Opera by enabling \"enable-experimental-web-platform-features\" in chrome:flags"},"usage_perc_y":18.01,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"AudioTrack,AudioTrackList,media,multiple,selection","ie_id":"audiotracks","chrome_id":"5748496434987008","firefox_id":"","webkit_id":""},"autofocus":{"title":"Autofocus attribute","description":"Allows a form field to be immediately focused on page load.","spec":"https://html.spec.whatwg.org/multipage/forms.html#autofocusing-a-form-control:-the-autofocus-attribute","status":"ls","links":[{"url":"https://davidwalsh.name/autofocus","title":"Article on autofocus"},{"url":"https://developer.mozilla.org/en/docs/Web/HTML/Element/input#attr-autofocus","title":"MDN Web Docs - autofocus attribute"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"n"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"While not supported in iOS Safari, it does work in iOS WebViews.","notes_by_num":{},"usage_perc_y":84.88,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"auxclick":{"title":"Auxclick","description":"The click event for non-primary buttons of input devices","spec":"https://w3c.github.io/uievents/#event-type-auxclick","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/Events/auxclick","title":"MDN Web Docs - auxclick"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1304044","title":"Firefox implementation"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=22382","title":"WebKit bug"},{"url":"https://wicg.github.io/auxclick/","title":"Original Proposal"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/17997901-auxclick-event-for-non-primary-buttons","title":"Microsoft Edge feature request on UserVoice"}],"categories":["DOM","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"y #1","54":"y #1","55":"y #1","56":"y #1","57":"y #1","58":"y #1","59":"y #1","60":"y #1","61":"y #1","62":"y #1","63":"y #1","64":"y #1","65":"y #1","66":"y #1","67":"y #1","68":"y #1","69":"y #1","70":"y #1","71":"y #1","72":"y #1","73":"y #1","74":"y #1","75":"y #1","76":"y #1","77":"y #1","78":"y #1","79":"y #1","80":"y #1","81":"y #1","82":"y #1","83":"y #1","84":"y #1","85":"y #1","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"u","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"With introduction of this feature there will be no longer click event fired for non-primary buttons","notes_by_num":{"1":"As a compatibility measure, Firefox continues to fire the click event for document and window level event handlers."},"usage_perc_y":78.53,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"click,auxclick,non-primary button,middle click","ie_id":"","chrome_id":"5663174342737920","firefox_id":"","webkit_id":""},"av1":{"title":"AV1 video format","description":"AV1 (AOMedia Video 1) is a royalty-free video format by the Alliance for Open Media, meant to succeed its predecessor VP9 and compete with the HEVC/H.265 format.","spec":"https://github.com/AOMediaCodec/av1-spec","status":"other","links":[{"url":"https://en.wikipedia.org/wiki/AV1","title":"Wikipedia article"},{"url":"https://bitmovin.com/demos/av1","title":"Sample video from Bitmovin"},{"url":"https://www.facebook.com/330716120785217/videos/330723190784510/","title":"Sample video from Facebook"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1452683","title":"Firefox implementation bug"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=207547","title":"Safari implementation bug"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n d #1","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n d","56":"n d","57":"n d","58":"n d","59":"n d","60":"n d","61":"n d #4","62":"n d #4","63":"n d #4","64":"n d #4","65":"a #2 #4","66":"a #3 #4","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n d","68":"n d","69":"n d","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n d #4"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Can be enabled in Edge 18 by installing the AV1 Video Extension from the Microsoft Store","2":"Firefox 65 only supported Windows 64-bit users by default","3":"Firefox 66 only supported Windows and macOS users by default","4":"Can be enabled in older Firefox versions via the `media.av1.enabled` flag in `about:config`"},"usage_perc_y":39.59,"usage_perc_a":0.02,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"5729898442260480","firefox_id":"av1-codec","webkit_id":""},"avif":{"title":"AVIF image format","description":"A modern image format based on the AV1 video format. AVIF generally has better compression than [WebP](#feat=webp), JPEG, PNG and GIF and is designed to supersede them.","spec":"https://aomediacodec.github.io/av1-avif/","status":"other","links":[{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1443863","title":"Firefox support bug"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=960620","title":"Chrome support bug"},{"url":"https://github.com/Kagami/avif.js","title":"Polyfill"},{"url":"https://netflixtechblog.com/avif-for-next-generation-image-coding-b1d75675fe4","title":"AVIF for Next-Generation Image Coding - blog post"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=207750","title":"Safari support bug"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n d #1","78":"n d #1","79":"n d #1","80":"n d #1","81":"n d #1","82":"n d #1","83":"n d #1","84":"n d #1","85":"n d #1","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n d #1"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Can be enabled in Firefox via the `image.avif.enabled` flag in `about:config`"},"usage_perc_y":31.05,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"4905307790639104","firefox_id":"","webkit_id":""},"background-attachment":{"title":"CSS background-attachment","description":"Method of defining how a background image is attached to a scrollable element. Values include `scroll` (default), `fixed` and `local`.","spec":"https://www.w3.org/TR/css3-background/#the-background-attachment","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/background-attachment","title":"MDN Web Docs - background-attachment"}],"categories":["CSS"],"stats":{"ie":{"6":"a #1","7":"a #1","8":"a #1","9":"y","10":"y","11":"y","5.5":"a #1"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"a #1","3":"a #1","4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a #1","3.6":"a #1"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a #1","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a #1","3.2":"a #1","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"a #1","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"a #1","10.0-10.1":"a #1","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"a #2 #3","14":"a #2 #3","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"a #2 #3","6.0-6.1":"a #2 #3","7.0-7.1":"a #2 #3","8.1-8.4":"a #2 #3","9.0-9.2":"a #2 #3","9.3":"a #2 #3","10.0-10.2":"a #2 #3","10.3":"a #2 #3","11.0-11.2":"a #2 #3","11.3-11.4":"a #2 #3","12.0-12.1":"a #2 #3","12.2-12.4":"a #2 #3","13.0-13.1":"a #2 #3","13.2":"a #2 #3","13.3":"a #2 #3","13.4-13.7":"a #2 #3"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"a #1","4.2-4.3":"a #1","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"a #2","10":"a #2"},"op_mob":{"10":"a #1","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"a #4","6.2-6.4":"a #4","7.2-7.4":"a #4","8.2":"a #4","9.2":"a #4","10.1":"a #4","11.1-11.2":"a #4","12.0":"a #4"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"a #4"},"kaios":{"2.5":"y"}},"notes":"Most mobile devices have a delay in updating the background position after scrolling a page with `fixed` backgrounds.","notes_by_num":{"1":"Partial support refers to supporting `fixed` but not `local`","2":"Partial support refers to supporting `local` but not `fixed`","3":"Only supports `local` when `-webkit-overflow-scrolling: touch` is _not_ used","4":"Does not support `fixed`, and due [to a bug](https://bugs.chromium.org/p/chromium/issues/detail?id=627037) only supports `local` if a `border-radius` is set on the element."},"usage_perc_y":82.69,"usage_perc_a":15.75,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"background-img-opts":{"title":"CSS3 Background-image options","description":"New properties to affect background images, including background-clip, background-origin and background-size","spec":"https://www.w3.org/TR/css3-background/#backgrounds","status":"cr","links":[{"url":"http://www.standardista.com/css3/css3-background-properties","title":"Detailed compatibility tables and demos"},{"url":"https://github.com/louisremi/background-size-polyfill","title":"Polyfill for IE7-8"},{"url":"https://developer.mozilla.org/en/docs/Web/CSS/background-image","title":"MDN Web Docs - background-image"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"a x"},"chrome":{"4":"a #3","5":"a #3","6":"a #3","7":"a #3","8":"a #3","9":"a #3","10":"a #3","11":"a #3","12":"a #3","13":"a #3","14":"a #3","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a #2 #3","5":"a #2 #3","6":"a #2 #3","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a #2 #3","3.2":"a #2 #3","5.1":"a #2 #3","6.1":"a #2 #3","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"a x","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"a","4.0-4.1":"a","4.2-4.3":"a","5.0-5.1":"a #3","6.0-6.1":"a","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"a #1"},"android":{"3":"a #3","4":"a #3","81":"y","2.1":"a x","2.2":"a x #3","2.3":"a x #3","4.1":"a #3","4.2-4.3":"a #3","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Firefox, Chrome and Safari support the unofficial `-webkit-background-clip: text` (only with prefix). Safari does not support `-webkit-background-clip: text;` for `<button>` elements. But you can put `<span>` inside `<button>` to get the same result.","notes_by_num":{"1":"Partial support in Opera Mini refers to not supporting background sizing or background attachments. However Opera Mini 7.5 supports background sizing (including cover and contain values).","2":"Partial support in Safari 6 refers to not supporting background sizing offset from edges syntax.","3":"Does not support `background-size` values in the `background` shorthand"},"usage_perc_y":98.36,"usage_perc_a":1.21,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"background-position-x-y":{"title":"background-position-x & background-position-y","description":"CSS longhand properties to define x or y positions separately.","spec":"https://drafts.csswg.org/css-backgrounds-4/#background-position-longhands","status":"unoff","links":[{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=550426","title":"Firefox implementation bug"},{"url":"https://snook.ca/archives/html_and_css/background-position-x-y","title":"Blog post on background-position-x & y properties"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/background-position-x","title":"MDN Web Docs - background-position-x"},{"url":"https://developer.mozilla.org/en/docs/Web/CSS/background-position-y","title":"MDN Web Docs - background-position-y"}],"categories":["CSS"],"stats":{"ie":{"6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","5.5":"y"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"A workaround for the lack of support in Firefox 31 - Firefox 48 is to use [CSS variables](https://developer.mozilla.org/en-US/docs/Web/CSS/Using_CSS_variables). See [this Stack Overflow answer](https://stackoverflow.com/a/29282573/94197) for an example.","notes_by_num":{},"usage_perc_y":98.35,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"background-repeat-round-space":{"title":"CSS background-repeat round and space","description":"Allows CSS background images to be repeated without clipping.","spec":"https://www.w3.org/TR/css3-background/#the-background-repeat","status":"cr","links":[{"url":"https://developer.mozilla.org//docs/Web/CSS/background-repeat","title":"MDN Web Docs - background-repeat"},{"url":"https://css-tricks.com/almanac/properties/b/background-repeat/","title":"CSS-Tricks article on background-repeat"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"a #1","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"n","16":"n","17":"n","18":"n","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"IE9 does not appear to render \"background-repeat: round\" correctly."},"usage_perc_y":98.52,"usage_perc_a":0.21,"ucprefix":false,"parent":"","keywords":"4 value syntax,background-repeat: round,background-repeat: space","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"background-sync":{"title":"Background Sync API","description":"Provides one-off and periodic synchronization for Service Workers with an onsync event.","spec":"https://wicg.github.io/BackgroundSync/spec/","status":"unoff","links":[{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1217544","title":"Firefox support bug"},{"url":"https://developer.mozilla.org/docs/Web/API/SyncManager","title":"SyncManager on MDN Web Docs"},{"url":"https://developers.google.com/web/updates/2015/12/background-sync","title":"Google Developers blog: Introducing Background Sync"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"u","85":"u","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":75.14,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"syncmanager","ie_id":"backgroundsyncapi","chrome_id":"6170807885627392","firefox_id":"background-sync","webkit_id":""},"battery-status":{"title":"Battery Status API","description":"Method to provide information about the battery status of the hosting device.","spec":"https://www.w3.org/TR/battery-status/","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/WebAPI/Battery_Status","title":"MDN Web Docs - battery status"},{"url":"https://pazguille.github.io/demo-battery-api/","title":"Simple demo"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"a x #1","11":"a x #1","12":"a x #1","13":"a x #1","14":"a x #1","15":"a x #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n d","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Firefox 52+ [removed access to this API due to privacy concerns.](https://bugzilla.mozilla.org/show_bug.cgi?id=1313580)","notes_by_num":{"1":"Partial support refers to support for the older specification's `navigator.battery` rather than `navigator.getBattery()` to access the `BatteryManager`."},"usage_perc_y":75.97,"usage_perc_a":0.2,"ucprefix":false,"parent":"","keywords":"navigator.battery,navigator.getbattery,batterymanager","ie_id":"batterystatusapi","chrome_id":"4537134732017664","firefox_id":"","webkit_id":"specification-battery-status-api"},"beacon":{"title":"Beacon API","description":"Allows data to be sent asynchronously to a server with `navigator.sendBeacon`, even after a page was closed. Useful for posting analytics data the moment a user was finished using the page.","spec":"https://www.w3.org/TR/beacon/","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Navigator/sendBeacon","title":"MDN Web Docs - Beacon"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":95.51,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"beacon","chrome_id":"5517433905348608","firefox_id":"","webkit_id":"specification-beacon-api"},"beforeafterprint":{"title":"Printing Events","description":"Window fires `beforeprint` and `afterprint` events so the printed document can be annotated.","spec":"https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#printing","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/Guide/Printing#Detecting_print_requests","title":"MDN Web Docs - Detecting print requests"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=218205","title":"Chrome support bug"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=19937","title":"Safari support bug"}],"categories":["HTML5","JS API"],"stats":{"ie":{"6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","5.5":"u"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"u","10":"u"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"u","11":"u"},"and_uc":{"12.12":"u"},"samsung":{"4":"u","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"Due to its wider support, consider using `window.matchMedia('print')` where possible.","notes_by_num":{},"usage_perc_y":76.28,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"print,printer,printing,beforeprint,afterprint","ie_id":"","chrome_id":"5700595042222080","firefox_id":"","webkit_id":""},"bigint":{"title":"BigInt","description":"Arbitrary-precision integers in JavaScript.","spec":"https://tc39.es/ecma262/#sec-bigint-objects","status":"other","links":[{"url":"https://github.com/tc39/proposal-bigint","title":"GitHub repository"},{"url":"https://developers.google.com/web/updates/2018/05/bigint","title":"Blog article from Google Developer"},{"url":"https://2ality.com/2017/03/es-integer.html","title":"Blog article from Dr. Axel Rauschmayer"},{"url":"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt","title":"MDN Web Docs"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1366287","title":"Firefox implementation bug"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n d #1","66":"n d #1","67":"n d #1","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Can be enabled by setting `javascript.options.bigint` to \"True\" in `about:config`"},"usage_perc_y":83.45,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"int,integer,precision","ie_id":"","chrome_id":"5371603852460032","firefox_id":"","webkit_id":""},"blobbuilder":{"title":"Blob constructing","description":"Construct Blobs (binary large objects) either using the BlobBuilder API (deprecated) or the Blob constructor.","spec":"https://www.w3.org/TR/FileAPI/#constructorBlob","status":"wd","links":[{"url":"https://developer.mozilla.org/en/DOM/BlobBuilder","title":"MDN Web Docs - BlobBuilder"},{"url":"https://developer.mozilla.org/en-US/docs/DOM/Blob","title":"MDN Web Docs - Blobs"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"a x","7":"a x","8":"a x","9":"a x","10":"a x","11":"a x","12":"a x","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"a x","9":"a x","10":"a x","11":"a x","12":"a x","13":"a x","14":"a x","15":"a x","16":"a x","17":"a x","18":"a x","19":"a x","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"a x","4":"a x","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"a x","4.2-4.3":"a x","4.4":"a x","4.4.3-4.4.4":"a x"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Partial support refers to only supporting the now deprecated BlobBuilder to create blobs.","notes_by_num":{},"usage_perc_y":97.94,"usage_perc_a":0.26,"ucprefix":true,"parent":"fileapi","keywords":"","ie_id":"blob","chrome_id":"5328783104016384","firefox_id":"","webkit_id":""},"bloburls":{"title":"Blob URLs","description":"Method of creating URL handles to the specified File or Blob object.","spec":"https://www.w3.org/TR/FileAPI/#url","status":"wd","links":[{"url":"https://developer.mozilla.org/en/DOM/window.URL.createObjectURL","title":"MDN Web Docs - createObjectURL"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y #1","11":"y #1","5.5":"n"},"edge":{"12":"y #1","13":"y #1","14":"y #1","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y x","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"y x","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"y x","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y x","4.2-4.3":"y x","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Created blob url can't be used as object or iframe src"},"usage_perc_y":98.21,"usage_perc_a":0,"ucprefix":false,"parent":"fileapi","keywords":"createobjecturl,revokeobjecturl","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"border-image":{"title":"CSS3 Border images","description":"Method of using images for borders","spec":"https://www.w3.org/TR/css3-background/#border-images","status":"cr","links":[{"url":"https://www.webplatform.org/docs/css/properties/border-image","title":"WebPlatform Docs"},{"url":"https://developer.mozilla.org//docs/Web/CSS/border-image","title":"MDN Web Docs - Border image"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","5.5":"n"},"edge":{"12":"y #1","13":"y #1","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a x #2 #3","5":"a x #2 #3","6":"a x #2 #3","7":"a x #2 #3","8":"a x #2 #3","9":"a x #2 #3","10":"a x #2 #3","11":"a x #2 #3","12":"a x #2 #3","13":"a x #2 #3","14":"a x #2 #3","15":"a #2","16":"a #2","17":"a #2","18":"a #2","19":"a #2","20":"a #2","21":"a #2","22":"a #2","23":"a #2","24":"a #2","25":"a #2","26":"a #2","27":"a #2","28":"a #2","29":"a #2","30":"a #2","31":"a #2","32":"a #2","33":"a #2","34":"a #2","35":"a #2","36":"a #2","37":"a #2","38":"a #2","39":"a #2","40":"a #2","41":"a #2","42":"a #2","43":"a #2","44":"a #2","45":"a #2","46":"a #2","47":"a #2","48":"a #2","49":"a #2","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a x #2 #3","3.6":"a x #2 #3"},"chrome":{"4":"a x #1 #2 #3 #4","5":"a x #1 #2 #3 #4","6":"a x #1 #2 #3 #4","7":"a x #1 #2 #3 #4","8":"a x #1 #2 #3 #4","9":"a x #1 #2 #3 #4","10":"a x #1 #2 #3 #4","11":"a x #1 #2 #3 #4","12":"a x #1 #2 #3 #4","13":"a x #1 #2 #3 #4","14":"a x #1 #2 #3 #4","15":"a #1 #2 #4","16":"a #1 #2 #4","17":"a #1 #2 #4","18":"a #1 #2 #4","19":"a #1 #2 #4","20":"a #1 #2 #4","21":"a #1 #2 #4","22":"a #1 #2 #4","23":"a #1 #2 #4","24":"a #1 #2 #4","25":"a #1 #2 #4","26":"a #1 #2 #4","27":"a #1 #2 #4","28":"a #1 #2 #4","29":"a #1 #2 #4","30":"a #1 #2","31":"a #1 #2","32":"a #1 #2","33":"a #1 #2","34":"a #1 #2","35":"a #1 #2","36":"a #1 #2","37":"a #1 #2","38":"a #1 #2","39":"a #1 #2","40":"a #1 #2","41":"a #1 #2","42":"a #1 #2","43":"a #1 #2","44":"a #1 #2","45":"a #1 #2","46":"a #1 #2","47":"a #1 #2","48":"a #1 #2","49":"a #1 #2","50":"a #1 #2","51":"a #2","52":"a #2","53":"a #2","54":"a #2","55":"a #2","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a x #1 #2 #3 #4","5":"a x #1 #2 #3 #4","6":"a #1 #2 #4","7":"a #1 #2 #4","8":"a #1 #2 #4","9":"a #1 #2 #4","10":"y #1","11":"y #1","12":"y #1","13":"y #1","14":"y #1","3.1":"a x #1 #2 #3 #4","3.2":"a x #1 #2 #3 #4","5.1":"a x #1 #2 #3 #4","6.1":"a #1 #2 #4","7.1":"a #1 #2 #4","9.1":"y #1","10.1":"y #1","11.1":"y #1","12.1":"y #1","13.1":"y #1","TP":"y #1"},"opera":{"9":"n","11":"a x #2 #3 #4","12":"a x #2 #3 #4","15":"a #1 #2","16":"a #1 #2","17":"a #1 #2","18":"a #1 #2","19":"a #1 #2","20":"a #1 #2","21":"a #1 #2","22":"a #1 #2","23":"a #1 #2","24":"a #1 #2","25":"a #1 #2","26":"a #1 #2","27":"a #1 #2","28":"a #1 #2","29":"a #1 #2","30":"a #1 #2","31":"a #1 #2","32":"a #1 #2","33":"a #1 #2","34":"a #1 #2","35":"a #1 #2","36":"a #1 #2","37":"a #1 #2","38":"a #2","39":"a #2","40":"a #2","41":"a #2","42":"a #2","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"a #2 #3 #4","10.6":"a #2 #3 #4","11.1":"a x #2 #3 #4","11.5":"a x #2 #3 #4","11.6":"a x #2 #3 #4","12.1":"a x #2 #3 #4"},"ios_saf":{"8":"a #1 #2 #4","14":"y #1","3.2":"a x #1 #2 #3 #4","4.0-4.1":"a x #1 #2 #3 #4","4.2-4.3":"a x #1 #2 #3 #4","5.0-5.1":"a x #1 #2 #3 #4","6.0-6.1":"a #1 #2 #4","7.0-7.1":"a #1 #2 #4","8.1-8.4":"a #1 #2 #4","9.0-9.2":"a #1 #2 #4","9.3":"y #1","10.0-10.2":"y #1","10.3":"y #1","11.0-11.2":"y #1","11.3-11.4":"y #1","12.0-12.1":"y #1","12.2-12.4":"y #1","13.0-13.1":"y #1","13.2":"y #1","13.3":"y #1","13.4-13.7":"y #1"},"op_mini":{"all":"a x #2 #3 #4"},"android":{"3":"a x #1 #2 #3 #4","4":"a x #1 #2 #3 #4","81":"a #1 #2","2.1":"a x #1 #2 #3 #4","2.2":"a x #1 #2 #3 #4","2.3":"a x #1 #2 #3 #4","4.1":"a x #1 #2 #3 #4","4.2-4.3":"a x #1 #2 #3 #4","4.4":"a #1 #2","4.4.3-4.4.4":"a #1 #2"},"bb":{"7":"a #1 #2 #3 #4","10":"a #1 #2 #4"},"op_mob":{"10":"n","11":"a x #2 #3 #4","12":"a x #2 #3 #4","59":"y","11.1":"a x #2 #3 #4","11.5":"a x #2 #3 #4","12.1":"a x #2 #3 #4"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"y"},"and_uc":{"12.12":"a #1 #2"},"samsung":{"4":"a #1 #2","5.0-5.4":"a #2","6.2-6.4":"a #2","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"a #2"},"baidu":{"7.12":"a #2"},"kaios":{"2.5":"a #2"}},"notes":"Note that both the `border-style` and `border-width` must be specified (not set to `none` or 0) for border-images to work.","notes_by_num":{"1":"Has a bug where `border-image` incorrectly overrides `border-style`. See [test case](https://codepen.io/Savago/pen/yYrgyK), [WebKit bug](https://bugs.webkit.org/show_bug.cgi?id=99922), [discussion](https://github.com/whatwg/compat/issues/17)","2":"Partial support refers to not supporting `border-image-repeat: space`","3":"Partial support refers to supporting the shorthand syntax, but not the individual properties (`border-image-source`, `border-image-slice`, etc). ","4":"Partial support refers to not supporting `border-image-repeat: round`"},"usage_perc_y":95.07,"usage_perc_a":4.27,"ucprefix":false,"parent":"","keywords":"border-image-source,border-image-slice,border-image-repeat,border-image-width,,border-image-outset","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"border-radius":{"title":"CSS3 Border-radius (rounded corners)","description":"Method of making the border corners round. Covers support for the shorthand `border-radius` as well as the long-hand properties (e.g. `border-top-left-radius`)","spec":"https://www.w3.org/TR/css3-background/#the-border-radius","status":"cr","links":[{"url":"https://border-radius.com","title":"Border-radius CSS Generator"},{"url":"https://muddledramblings.com/table-of-css3-border-radius-compliance","title":"Detailed compliance table"},{"url":"http://css3pie.com/","title":"Polyfill which includes border-radius"},{"url":"https://www.webplatform.org/docs/css/properties/border-radius","title":"WebPlatform Docs"},{"url":"https://developer.mozilla.org/en/docs/Web/CSS/border-radius","title":"MDN Web Docs - CSS border-radius"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"a x #2","3":"y x #2","4":"y #2","5":"y #2","6":"y #2","7":"y #2","8":"y #2","9":"y #2","10":"y #2","11":"y #2","12":"y #2","13":"y #2","14":"y #2","15":"y #2","16":"y #2","17":"y #2","18":"y #2","19":"y #2","20":"y #2","21":"y #2","22":"y #2","23":"y #2","24":"y #2","25":"y #2","26":"y #2","27":"y #2","28":"y #2","29":"y #2","30":"y #2","31":"y #2","32":"y #2","33":"y #2","34":"y #2","35":"y #2","36":"y #2","37":"y #2","38":"y #2","39":"y #2","40":"y #2","41":"y #2","42":"y #2","43":"y #2","44":"y #2","45":"y #2","46":"y #2","47":"y #2","48":"y #2","49":"y #2","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y x #2","3.6":"y x #2"},"chrome":{"4":"y x","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y x","5":"y","6":"y #1","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y x","3.2":"y x","5.1":"y #1","6.1":"y #1","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y x","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"y x","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y #2"}},"notes":"","notes_by_num":{"1":"Safari 6.1 and earlier did not apply `border-radius` correctly to image borders: https://stackoverflow.com/q/17202128","2":"Dotted and dashed rounded border corners are rendered as solid in Firefox. [see bug](https://bugzilla.mozilla.org/show_bug.cgi?id=382721)"},"usage_perc_y":98.71,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"roundedcorners, border radius,-moz-border-radius","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"broadcastchannel":{"title":"BroadcastChannel","description":"BroadcastChannel allows scripts from the same origin but other browsing contexts (windows, workers) to send each other messages.","spec":"https://html.spec.whatwg.org/multipage/comms.html#broadcasting-to-other-browsing-contexts","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/BroadcastChannel","title":"MDN Web Docs - Broadcast Channel"},{"url":"https://github.com/pubkey/broadcast-channel","title":"Shim - Broadcast Channel based on Localstorage, Indexeddb or Sockets"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":78.79,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"broadcast,channel,messaging","ie_id":"","chrome_id":"4585496197988352","firefox_id":"","webkit_id":""},"brotli":{"title":"Brotli Accept-Encoding/Content-Encoding","description":"More effective lossless compression algorithm than gzip and deflate.","spec":"https://tools.ietf.org/html/rfc7932","status":"other","links":[{"url":"https://opensource.googleblog.com/2015/09/introducing-brotli-new-compression.html","title":"Introducing Brotli"},{"url":"https://groups.google.com/a/chromium.org/forum/m/#!msg/blink-dev/JufzX024oy0/WEOGbN43AwAJ","title":"Blink's intent to ship"},{"url":"https://github.com/google/brotli","title":"Official code repository"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=154859","title":"WebKit Bug 154859: Add support for format brotli for HTTP compression"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n d #1","50":"y #2","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y #3","12":"y #3","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"y #3","12.1":"y #3","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n d #1","37":"n d #1","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Supported in Chrome and Opera behind the 'Brotli Content-Encoding' flag","2":"Enabled since 27 May 2016","3":"Support starting with macOS 10.13 High Sierra"},"usage_perc_y":94.83,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"http,compression,accept,content,encoding","ie_id":"brotlicompresseddataformat","chrome_id":"5420797577396224","firefox_id":"","webkit_id":""},"calc":{"title":"calc() as CSS unit value","description":"Method of allowing calculated values for length units, i.e. `width: calc(100% - 3em)`","spec":"https://drafts.csswg.org/css-values-3/#calc-notation","status":"cr","links":[{"url":"https://hacks.mozilla.org/2010/06/css3-calc/","title":"Mozilla Hacks article"},{"url":"https://developer.mozilla.org/en/docs/Web/CSS/calc","title":"MDN Web Docs - calc"},{"url":"https://www.webplatform.org/docs/css/functions/calc","title":"WebPlatform Docs"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"a #2","10":"a #3","11":"a #3","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y x","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"y x","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"a #1","4.4.3-4.4.4":"a #1"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Support can be somewhat emulated in older versions of IE using the non-standard `expression()` syntax.\r\n\r\nDue to the way browsers handle [sub-pixel rounding](https://johnresig.com/blog/sub-pixel-problems-in-css/) differently, layouts using `calc()` expressions may have unexpected results.","notes_by_num":{"1":"Partial support in Android Browser 4.4 refers to the browser lacking the ability to multiply and divide values.","2":"Partial support in IE9 refers to the browser crashing when used as a `background-position` value.","3":"Partial support in IE10/IE11 refers to calc not working properly with various use cases mentioned in known issues"},"usage_perc_y":96.9,"usage_perc_a":1.38,"ucprefix":false,"parent":"","keywords":"","ie_id":"csscalc","chrome_id":"5765241438732288","firefox_id":"","webkit_id":""},"canvas":{"title":"Canvas (basic support)","description":"Method of generating fast, dynamic graphics using JavaScript.","spec":"https://html.spec.whatwg.org/multipage/scripting.html#the-canvas-element","status":"ls","links":[{"url":"https://developer.mozilla.org/en/Canvas_tutorial","title":"Tutorial by Mozilla"},{"url":"http://glimr.rubyforge.org/cake/canvas.html","title":"Animation kit"},{"url":"https://diveintohtml5.info/canvas.html","title":"Another tutorial"},{"url":"https://github.com/arv/ExplorerCanvas","title":"Implementation for Internet Explorer"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/graphics.js#canvas","title":"has.js test"},{"url":"https://skilled.co/html-canvas/","title":"Canvas Tutorial & Cheat Sheet"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API","title":"MDN Web Docs - Canvas API"}],"categories":["Canvas","HTML5"],"stats":{"ie":{"6":"p","7":"p","8":"p","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"a #1","3":"a #1","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a #1","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a #1","3.2":"a #1","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"a #2"},"android":{"3":"y","4":"y","81":"y","2.1":"a #1","2.2":"a #1","2.3":"a #1","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"For screen readers, IE, Chrome & Firefox support the [accessible canvas element sub-DOM](http://www.paciellogroup.com/blog/2012/06/html5-canvas-accessibility-in-firefox-13/).\r\nFirefox & Chrome also support the drawfocus ring.","notes_by_num":{"1":"Does not support `toDataURL()`","2":"Opera Mini supports the canvas element, but is unable to play animations or run other more complex applications."},"usage_perc_y":98.7,"usage_perc_a":0.9,"ucprefix":false,"parent":"","keywords":"toDataURL()","ie_id":"canvas","chrome_id":"5100084685438976","firefox_id":"","webkit_id":""},"canvas-blending":{"title":"Canvas blend modes","description":"Method of defining the effect resulting from overlaying two layers on a Canvas element.","spec":"https://www.w3.org/TR/compositing-1/#blending","status":"cr","links":[{"url":"https://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/","title":"Blog post"}],"categories":["Canvas"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":96.74,"usage_perc_a":0,"ucprefix":false,"parent":"canvas","keywords":"","ie_id":"compositingandblendingincanvas2d","chrome_id":"","firefox_id":"","webkit_id":""},"canvas-text":{"title":"Text API for Canvas","description":"Method of displaying text on Canvas elements","spec":"https://html.spec.whatwg.org/multipage/scripting.html#drawing-text-to-the-bitmap","status":"ls","links":[{"url":"https://developer.mozilla.org/en/Drawing_text_using_a_canvas#Additional_examples","title":"Examples by Mozilla"},{"url":"https://code.google.com/archive/p/canvas-text/","title":"Support library"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/graphics.js#canvas-text","title":"has.js test"},{"url":"https://www.webplatform.org/docs/apis/canvas/CanvasRenderingContext2D/fillText","title":"WebPlatform Docs"}],"categories":["Canvas","HTML5"],"stats":{"ie":{"6":"p","7":"p","8":"p","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"p","3":"p","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"p","3.2":"p","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"p","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"p","10.0-10.1":"p","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"p","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":98.7,"usage_perc_a":0,"ucprefix":false,"parent":"canvas","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"ch-unit":{"title":"ch (character) unit","description":"Unit representing the width of the character \"0\" in the current font, of particular use in combination with monospace fonts.","spec":"https://www.w3.org/TR/css3-values/#ch","status":"cr","links":[{"url":"https://johndjameson.com/blog/making-sense-of-ch-units/","title":"Blog post on using ch units"},{"url":"http://revoltpuppy.com/articles/89/using-ch-an-underappreciated-css-length","title":"Various uses for the ch unit"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"a #1","10":"a #1","11":"a #1","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"IE supports the `ch` unit, but unlike other browsers its width is that specifically of the \"0\" glyph, not its surrounding space. As a result, 3ch for example is shorter than the width of the string \"000\" in IE."},"usage_perc_y":96.93,"usage_perc_a":1.32,"ucprefix":false,"parent":"","keywords":"ch unit,character unit","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"chacha20-poly1305":{"title":"ChaCha20-Poly1305 cipher suites for TLS","description":"A set of cipher suites used in Transport Layer Security (TLS) protocol, using ChaCha20 for symmetric encryption and Poly1305 for authentication.","spec":"https://tools.ietf.org/html/rfc7905","status":"other","links":[{"url":"https://security.googleblog.com/2014/04/speeding-up-and-strengthening-https.html","title":"Chrome article"},{"url":"https://www.ssllabs.com/ssltest/viewMyClient.html","title":"SSL/TLS Capabilities of Your Browser by Qualys SSL Labs"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/12300414-support-chacha20-poly1305-cipher-suites-in-edge-sc","title":"Microsoft Edge feature request on UserVoice"}],"categories":["Security"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"y #1","34":"y #1","35":"y #1","36":"y #1","37":"y #1","38":"y #1","39":"y #1","40":"y #1","41":"y #1","42":"y #1","43":"y #1","44":"y #1","45":"y #1","46":"y #1","47":"y #1","48":"y #1","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"u"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Old versions of Chrome use non-standard code points for ChaCha20-Poly1305 cipher suites."},"usage_perc_y":95.1,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"chacha20,poly1305,tls,cipher","ie_id":"","chrome_id":"5355238106071040","firefox_id":"","webkit_id":""},"channel-messaging":{"title":"Channel messaging","description":"Method for having two-way communication between browsing contexts (using MessageChannel)","spec":"https://html.spec.whatwg.org/multipage/comms.html#channel-messaging","status":"ls","links":[{"url":"https://dev.opera.com/articles/view/window-postmessage-messagechannel/#channel","title":"An Introduction to HTML5 web messaging"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Channel_Messaging_API","title":"MDN Web Docs - Channel Messaging API"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n d #1","27":"n d #1","28":"n d #1","29":"n d #1","30":"n d #1","31":"n d #1","32":"n d #1","33":"n d #1","34":"n d #1","35":"n d #1","36":"n d #1","37":"n d #1","38":"n d #1","39":"n d #1","40":"n d #1","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"u","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Supported in Firefox behind the `dom.messageChannel.enabled` flag. Reported to not work in web workers before version 41."},"usage_perc_y":98.13,"usage_perc_a":0,"ucprefix":false,"parent":"x-doc-messaging","keywords":"","ie_id":"messagechannels","chrome_id":"6710044586409984","firefox_id":"","webkit_id":""},"childnode-remove":{"title":"ChildNode.remove()","description":"DOM node method to remove the node itself from the document.","spec":"https://dom.spec.whatwg.org/#dom-childnode-remove","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove","title":"MDN Web Docs - ChildNode.remove"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"u","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"u","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":96.75,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"ChildNode,remove,delete,node,DOM","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"classlist":{"title":"classList (DOMTokenList)","description":"Method of easily manipulating classes on elements, using the DOMTokenList object.","spec":"https://dom.spec.whatwg.org/#dom-element-classlist","status":"ls","links":[{"url":"https://hacks.mozilla.org/2010/01/classlist-in-firefox-3-6/","title":"Mozilla Hacks article"},{"url":"https://github.com/eligrey/classList.js","title":"Polyfill script"},{"url":"https://www.webplatform.org/docs/dom/Element/classList","title":"WebPlatform Docs"},{"url":"https://www.sitepoint.com/exploring-classlist-api/","title":"SitePoint article"},{"url":"https://www.audero.it/demo/classlist-api-demo.html","title":"Demo using classList"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Element.classList","title":"MDN Web Docs - Element.classList"}],"categories":["DOM","HTML5"],"stats":{"ie":{"6":"p","7":"p","8":"p","9":"p","10":"a #1 #2 #3 #4","11":"a #1 #2 #3 #4","5.5":"p"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"p","3":"p","4":"a #2 #3","5":"a #2 #3","6":"a #2 #3","7":"a #2 #3","8":"a #2 #3","9":"a #2 #3","10":"a #2 #3","11":"a #2 #3","12":"a #2 #3","13":"a #2 #3","14":"a #2 #3","15":"a #2 #3","16":"a #2 #3","17":"a #2 #3","18":"a #2 #3","19":"a #2 #3","20":"a #2 #3","21":"a #2 #3","22":"a #2 #3","23":"a #2 #3","24":"a #3","25":"a #3","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"p","3.6":"a #2 #3"},"chrome":{"4":"p","5":"p","6":"p","7":"p","8":"a #1 #2 #3","9":"a #1 #2 #3","10":"a #1 #2 #3","11":"a #1 #2 #3","12":"a #1 #2 #3","13":"a #1 #2 #3","14":"a #1 #2 #3","15":"a #1 #2 #3","16":"a #1 #2 #3","17":"a #1 #2 #3","18":"a #1 #2 #3","19":"a #1 #2 #3","20":"a #1 #2 #3","21":"a #1 #2 #3","22":"a #1 #2 #3","23":"a #2 #3","24":"a #3","25":"a #3","26":"a #3","27":"a #3","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"p","5":"p","6":"a #1 #2 #3","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"p","3.2":"p","5.1":"a #1 #2 #3","6.1":"a #1 #2 #3","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"p","11":"p","12":"a #1 #2 #3","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"p","10.0-10.1":"p","10.5":"p","10.6":"p","11.1":"p","11.5":"a #1 #2 #3","11.6":"a #1 #2 #3","12.1":"a #1 #2 #3"},"ios_saf":{"8":"y","14":"y","3.2":"p","4.0-4.1":"p","4.2-4.3":"p","5.0-5.1":"a #1 #2 #3","6.0-6.1":"a #1 #2 #3","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"a #1 #2 #3"},"android":{"3":"a #1 #2 #3","4":"a #1 #2 #3","81":"y","2.1":"p","2.2":"p","2.3":"p","4.1":"a #1 #2 #3","4.2-4.3":"a #1 #2 #3","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"a #1 #2 #3","10":"y"},"op_mob":{"10":"p","11":"p","12":"a #1 #2 #3","59":"y","11.1":"a #1 #2 #3","11.5":"a #1 #2 #3","12.1":"a #1 #2 #3"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #1 #2 #3","11":"a #1 #2 #3"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Does not have support for `classList` on SVG or MathML elements.","2":"Does not support the second parameter for the `toggle` method","3":"Does not support multiple parameters for the `add()` & `remove()` methods","4":"Does not support assign to `classList` or the `replace()` method"},"usage_perc_y":96.71,"usage_perc_a":2.56,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"client-hints-dpr-width-viewport":{"title":"Client Hints: DPR, Width, Viewport-Width","description":"DPR, Width, and Viewport-Width hints enable proactive content negotiation between client and server, enabling automated delivery of optimized assets - e.g. auto-negotiating image DPR resolution.","spec":"https://tools.ietf.org/html/draft-grigorik-http-client-hints","status":"other","links":[{"url":"https://developers.google.com/web/updates/2015/09/automating-resource-selection-with-client-hints","title":"Automating resource selection with Client Hints"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=935216","title":"Mozilla Bug 935216 - Implement Client-Hints HTTP header"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=145380","title":"WebKit Bug 145380 - Add Content-DPR header support"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6261321-http-client-hints","title":"Microsoft Edge feature request on UserVoice"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":75.02,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"client hints, client-hints, dpr, viewport, content-dpr","ie_id":"httpclienthints","chrome_id":"5504430086553600","firefox_id":"","webkit_id":""},"clipboard":{"title":"Synchronous Clipboard API","description":"API to provide copy, cut and paste events as well as provide access to the OS clipboard.","spec":"https://www.w3.org/TR/clipboard-apis/","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/ClipboardEvent","title":"MDN Web Docs - ClipboardEvent"},{"url":"https://www.lucidchart.com/techblog/2014/12/02/definitive-guide-copying-pasting-javascript/","title":"Guide on cross-platform clipboard access"}],"categories":["JS API"],"stats":{"ie":{"6":"a #1 #2 #5","7":"a #1 #2 #5","8":"a #1 #2 #5","9":"a #1 #2 #5","10":"a #1 #2 #5","11":"a #1 #2 #5","5.5":"a #1 #2 #5"},"edge":{"12":"a #1 #2 #5","13":"a #1 #2 #5","14":"a #1 #2 #5","15":"a #1 #2 #5","16":"a #1 #2 #5","17":"a #2","18":"a #2","79":"a #7","80":"a #7","81":"a #7","83":"a #7","84":"a #7","85":"a #7","86":"a #7","87":"a #7"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"a #2 #3","23":"a #2 #3","24":"a #2 #3","25":"a #2 #3","26":"a #2 #3","27":"a #2 #3","28":"a #2 #3","29":"a #2 #3","30":"a #2 #3","31":"a #2 #3","32":"a #2 #3","33":"a #2 #3","34":"a #2 #3","35":"a #2 #3","36":"a #2 #3","37":"a #2 #3","38":"a #2 #3","39":"a #2 #3","40":"a #2 #3","41":"a #6","42":"a #6","43":"a #6","44":"a #6","45":"a #6","46":"a #6","47":"a #6","48":"a #6","49":"a #6","50":"a #6","51":"a #6","52":"a #6","53":"a #6","54":"a #6","55":"a #6","56":"a #6","57":"a #6","58":"a #6","59":"a #6","60":"a #6","61":"a #6","62":"a #6","63":"a #6","64":"a #6","65":"a #6","66":"a #6","67":"a #6","68":"a #6","69":"a #6","70":"a #6","71":"a #6","72":"a #6","73":"a #6","74":"a #6","75":"a #6","76":"a #6","77":"a #6","78":"a #6","79":"a #6","80":"a #6","81":"a #6","82":"a #6","83":"a #6","84":"a #6","85":"a #6","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"a #3 #5","14":"a #3 #5","15":"a #3 #5","16":"a #3 #5","17":"a #3 #5","18":"a #3 #5","19":"a #3 #5","20":"a #3 #5","21":"a #3 #5","22":"a #3 #5","23":"a #3 #5","24":"a #3 #5","25":"a #3 #5","26":"a #3 #5","27":"a #3 #5","28":"a #3 #5","29":"a #3 #5","30":"a #3 #5","31":"a #3 #5","32":"a #3 #5","33":"a #3 #5","34":"a #3 #5","35":"a #3 #5","36":"a #3 #5","37":"a #3 #5","38":"a #3 #5","39":"a #3 #5","40":"a #3 #5","41":"a #3 #5","42":"a #3 #5","43":"a #5 #7","44":"a #5 #7","45":"a #5 #7","46":"a #5 #7","47":"a #5 #7","48":"a #5 #7","49":"a #5 #7","50":"a #5 #7","51":"a #5 #7","52":"a #5 #7","53":"a #5 #7","54":"a #5 #7","55":"a #5 #7","56":"a #5 #7","57":"a #5 #7","58":"a #7","59":"a #7","60":"a #7","61":"a #7","62":"a #7","63":"a #7","64":"a #7","65":"a #7","66":"a #7","67":"a #7","68":"a #7","69":"a #7","70":"a #7","71":"a #7","72":"a #7","73":"a #7","74":"a #7","75":"a #7","76":"a #7","77":"a #7","78":"a #7","79":"a #7","80":"a #7","81":"a #7","83":"a #7","84":"a #7","85":"a #7","86":"a #7","87":"a #7","88":"a #7","89":"a #7","90":"a #7"},"safari":{"4":"a #2 #3 #5","5":"a #2 #3 #5","6":"a #2 #3 #5","7":"a #2 #3 #5","8":"a #2 #3 #5","9":"a #2 #3 #5","10":"a #2 #5","11":"a #2 #5","12":"y","13":"y","14":"y","3.1":"u","3.2":"u","5.1":"a #2 #3 #5","6.1":"a #2 #3 #5","7.1":"a #2 #3 #5","9.1":"a #2 #3 #5","10.1":"a #2 #5","11.1":"a #2 #5","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"u","15":"a #3 #5","16":"a #3 #5","17":"a #3 #5","18":"a #3 #5","19":"a #3 #5","20":"a #3 #5","21":"a #3 #5","22":"a #3 #5","23":"a #3 #5","24":"a #3 #5","25":"a #3 #5","26":"a #3 #5","27":"a #3 #5","28":"a #3 #5","29":"a #3 #5","30":"a #5 #7","31":"a #5 #7","32":"a #5 #7","33":"a #5 #7","34":"a #5 #7","35":"a #5 #7","36":"a #5 #7","37":"a #5 #7","38":"a #5 #7","39":"a #5 #7","40":"a #5 #7","41":"a #5 #7","42":"a #5 #7","43":"a #5 #7","44":"a #5 #7","45":"a #7","46":"a #7","47":"a #7","48":"a #7","49":"a #7","50":"a #7","51":"a #7","52":"a #7","53":"a #7","54":"a #7","55":"a #7","56":"a #7","57":"a #7","58":"a #7","60":"a #7","62":"a #7","63":"a #7","64":"a #7","65":"a #7","66":"a #7","67":"a #7","68":"a #7","69":"a #7","70":"a #7","71":"a #7","72":"a #7","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"a #3"},"ios_saf":{"8":"a #2 #3 #5","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"a #2 #3 #5","6.0-6.1":"a #2 #3 #5","7.0-7.1":"a #2 #3 #5","8.1-8.4":"a #2 #3 #5","9.0-9.2":"a #2 #3 #5","9.3":"a #2 #3 #5","10.0-10.2":"a #2 #3 #5","10.3":"a #2 #3 #5","11.0-11.2":"a #2 #3 #5","11.3-11.4":"a #2 #3 #5","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"a #2","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"a #2 #5","4.4.3-4.4.4":"a #2 #5"},"bb":{"7":"n","10":"a #2 #5"},"op_mob":{"10":"n","11":"n","12":"n","59":"a #4","11.1":"n","11.5":"n","12.1":"u"},"and_chr":{"86":"a #7"},"and_ff":{"82":"a #4"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"a #2 #5","5.0-5.4":"a #5","6.2-6.4":"a #5","7.2-7.4":"a #7","8.2":"a #7","9.2":"a #7","10.1":"a #7","11.1-11.2":"a #7","12.0":"a #7"},"and_qq":{"10.4":"a #5 #7"},"baidu":{"7.12":"a #5"},"kaios":{"2.5":"a #6"}},"notes":"Internet Explorer will display a security prompt for access to the OS clipboard.\r\n\r\nChrome 42+, Opera 29+ and Firefox 41+ support clipboard reading/writing only when part of a user action (click, keydown, etc).","notes_by_num":{"1":"Only supports `Text` and `URL` data types and uses [a non-standard method](https://msdn.microsoft.com/en-us/library/ie/ms535220%28v=vs.85%29.aspx) of interacting with the clipboard.","2":"Only fires `copy` event on a valid selection and only `cut` and `paste` in focused editable fields.","3":"Only supports OS clipboard reading/writing via shortcut keys, not through `document.execCommand()`.","4":"Only supports `paste` event (on focused editable field).","5":"Does not support the `ClipboardEvent` constructor","6":"Supports `cut` & `copy` events without a focused editable field, but not `paste` (presumably for security reasons)","7":"Supports `cut` & `copy` events without a focused editable field, but does not fire `paste` with `document.execCommand('paste')`  "},"usage_perc_y":15.25,"usage_perc_a":81.96,"ucprefix":false,"parent":"","keywords":"cut,copy,paste,clipboarddata,clipboardevent","ie_id":"clipboardapi","chrome_id":"","firefox_id":"","webkit_id":""},"comparedocumentposition":{"title":"Node.compareDocumentPosition()","description":"Compares the relative position of two nodes to each other in the DOM tree.","spec":"https://dom.spec.whatwg.org/#dom-node-comparedocumentposition","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition","title":"MDN Web Docs - Node.compareDocumentPosition"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"u","3":"u","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"u","3.6":"u"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"u","5":"u","6":"u","7":"a #1","8":"a #1","9":"a #1","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"u","5.1":"a #2","6.1":"a #1","7.1":"a #1","9.1":"a #1","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"u","12":"y","15":"a #1","16":"a #1","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"u","10.0-10.1":"u","10.5":"u","10.6":"u","11.1":"u","11.5":"u","11.6":"y","12.1":"y"},"ios_saf":{"8":"a #1","14":"y","3.2":"u","4.0-4.1":"a #1","4.2-4.3":"a #1","5.0-5.1":"a #1","6.0-6.1":"a #1","7.0-7.1":"a #1","8.1-8.4":"a #1","9.0-9.2":"a #1","9.3":"a #1","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"a #1","4":"a #1","81":"y","2.1":"u","2.2":"u","2.3":"a #1","4.1":"a #1","4.2-4.3":"a #1","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"a #1","10":"a #1"},"op_mob":{"10":"u","11":"u","12":"y","59":"y","11.1":"u","11.5":"u","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"The spec requires that comparisons of nodes in different documents, and comparisons where at least one node is not in any document, must arbitrarily (but consistently) set either the `DOCUMENT_POSITION_PRECEDING` or `DOCUMENT_POSITION_FOLLOWING` bit in the result. These browser versions don't set either bit in some such cases.","2":"Sets neither the `DOCUMENT_POSITION_DISCONNECTED` bit nor the `DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC` bit in some cases when comparing nodes in different documents or when comparing a node which is not in any document."},"usage_perc_y":98.66,"usage_perc_a":0.77,"ucprefix":false,"parent":"","keywords":"Node,compareDocumentPosition,compare,document,position,preceding,following,disconnected,before,after,contains,contained,DOM","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"console-basic":{"title":"Basic console logging functions","description":"Method of outputting data to the browser's console, intended for development purposes.","spec":"https://console.spec.whatwg.org/","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Console","title":"MDN Web Docs - Console"},{"url":"https://developer.chrome.com/devtools/docs/console-api","title":"Chrome console reference"},{"url":"https://msdn.microsoft.com/en-us/library/hh772169","title":"Edge/Internet Explorer console reference"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"a #1","9":"a #1","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y #3","14":"y #3","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y #3","7.0-7.1":"y #3","8.1-8.4":"y #3","9.0-9.2":"y #3","9.3":"y #3","10.0-10.2":"y #3","10.3":"y #3","11.0-11.2":"y #3","11.3-11.4":"y #3","12.0-12.1":"y #3","12.2-12.4":"y #3","13.0-13.1":"y #3","13.2":"y #3","13.3":"y #3","13.4-13.7":"y #3"},"op_mini":{"all":"y #6"},"android":{"3":"y #4","4":"y #4","81":"y #4","2.1":"y #4","2.2":"y #4","2.3":"y #4","4.1":"y #4","4.2-4.3":"y #4","4.4":"y #4","4.4.3-4.4.4":"y #4"},"bb":{"7":"n #2","10":"n #2"},"op_mob":{"10":"n","11":"n #2","12":"n #2","59":"n #2","11.1":"n #2","11.5":"n #2","12.1":"n #2"},"and_chr":{"86":"y #4"},"and_ff":{"82":"y #5"},"ie_mob":{"10":"n #2","11":"n #2"},"and_uc":{"12.12":"n #2"},"samsung":{"4":"y #4","5.0-5.4":"y #4","6.2-6.4":"y #4","7.2-7.4":"y #4","8.2":"y #4","9.2":"y #4","10.1":"y #4","11.1-11.2":"y #4","12.0":"y #4"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y #4"},"kaios":{"2.5":"y"}},"notes":"The basic functions that this information refers to include `console.log`, `console.info`, `console.warn`, `console.error`.","notes_by_num":{"1":"Only supports console functions when developer tools are open, otherwise the `console` object is undefined and any calls will throw errors.","2":"Allows `console` functions to be used without throwing errors, but does not appear to output the data anywhere.","3":"Log output on iOS 6+ Safari can only be seen by connecting to a Mac and using the [Safari debugger](https://developer.apple.com/safari/tools/).","4":"Log output on older Android browsers can be retrieved via Android's `logcat` command or using Chrome Developer Tools in Android 4.4+/Chrome for Android [see details](https://developer.android.com/guide/webapps/debugging.html)","5":"Log output on Firefox for Android can be [accessed using WebIDE](https://developer.mozilla.org/en-US/docs/Tools/Remote_Debugging/Debugging_Firefox_for_Android_with_WebIDE)","6":"See [this article](https://dev.opera.com/articles/opera-mini-and-javascript/) for details on how to see console logging in Opera Mini"},"usage_perc_y":98.09,"usage_perc_a":0.27,"ucprefix":false,"parent":"","keywords":"console.log,console.info,console.warn,console.error,window.console","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"console-time":{"title":"console.time and console.timeEnd","description":"Functions for measuring performance","spec":"https://console.spec.whatwg.org/#time","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Console/time","title":"MDN Web Docs - Console.time"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"u","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"u","11":"u","12":"u","59":"y","11.1":"u","11.5":"u","12.1":"u"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"`console.time()` starts a timer you can use to track how long an operation takes. You give each timer a unique name, and may have up to 10,000 timers running on a given page. When you call `console.timeEnd()` with the same name, the browser will output the time, in milliseconds, that elapsed since the timer was started. These functions are not always available in `workers`. For example, in Firefox, they are available from version `38`. More on using the `console` on mobile devices, see [here](https://caniuse.com/#feat=console-basic). ","notes_by_num":{},"usage_perc_y":99.23,"usage_perc_a":0,"ucprefix":false,"parent":"console-basic","keywords":"console.time,console.timeEnd,window.console","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"const":{"title":"const","description":"Declares a constant with block level scope","spec":"https://tc39.es/ecma262/#sec-let-and-const-declarations","status":"other","links":[{"url":"https://generatedcontent.org/post/54444832868/variables-and-constants-in-es6","title":"Variables and Constants in ES6"},{"url":"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/const","title":"MDN Web Docs - const"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"a #5","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"a #1","3":"a #1","4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #2","14":"a #2","15":"a #2","16":"a #2","17":"a #2","18":"a #2","19":"a #2","20":"a #2","21":"a #2","22":"a #2","23":"a #2","24":"a #2","25":"a #2","26":"a #2","27":"a #2","28":"a #2","29":"a #2","30":"a #2","31":"a #2","32":"a #2","33":"a #2","34":"a #2","35":"a #2","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a #1","3.6":"a #1"},"chrome":{"4":"a #2","5":"a #2","6":"a #2","7":"a #2","8":"a #2","9":"a #2","10":"a #2","11":"a #2","12":"a #2","13":"a #2","14":"a #2","15":"a #2","16":"a #2","17":"a #2","18":"a #2","19":"a #2","20":"a #2","21":"a #2 #3","22":"a #2 #3","23":"a #2 #3","24":"a #2 #3","25":"a #2 #3","26":"a #2 #3","27":"a #2 #3","28":"a #2 #3","29":"a #2 #3","30":"a #2 #3","31":"a #2 #3","32":"a #2 #3","33":"a #2 #3","34":"a #2 #3","35":"a #2 #3","36":"a #2 #3","37":"a #2 #3","38":"a #2 #3","39":"a #2 #3","40":"a #2 #3","41":"a #4","42":"a #4","43":"a #4","44":"a #4","45":"a #4","46":"a #4","47":"a #4","48":"a #4","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a #2","5":"a #2","6":"a #2 #3","7":"a #2 #3","8":"a #2 #3","9":"a #2 #3","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a #2","3.2":"a #2","5.1":"a #2 #3","6.1":"a #2 #3","7.1":"a #2 #3","9.1":"a #2 #3","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"a #1","12":"a #1 #3","15":"a #2 #3","16":"a #2 #3","17":"a #2 #3","18":"a #2 #3","19":"a #2 #3","20":"a #2 #3","21":"a #2 #3","22":"a #2 #3","23":"a #2 #3","24":"a #2 #3","25":"a #2 #3","26":"a #2 #3","27":"a #2 #3","28":"a #4","29":"a #4","30":"a #4","31":"a #4","32":"a #4","33":"a #4","34":"a #4","35":"a #4","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"a #1","10.5":"a #1","10.6":"a #1","11.1":"a #1","11.5":"a #1","11.6":"a #1 #3","12.1":"a #1 #3"},"ios_saf":{"8":"a #2 #3","14":"y","3.2":"a #2","4.0-4.1":"a #2","4.2-4.3":"a #2","5.0-5.1":"a #2 #3","6.0-6.1":"a #2 #3","7.0-7.1":"a #2 #3","8.1-8.4":"a #2 #3","9.0-9.2":"a #2 #3","9.3":"a #2 #3","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"a #1 #3"},"android":{"3":"a #2 #3","4":"a #2 #3","81":"y","2.1":"u","2.2":"u","2.3":"a #2","4.1":"a #2 #3","4.2-4.3":"a #2 #3","4.4":"a #2 #3","4.4.3-4.4.4":"a #2 #3"},"bb":{"7":"a #2 #3","10":"a #2 #3"},"op_mob":{"10":"a #1","11":"a #1","12":"a #1 #3","59":"y","11.1":"a #1","11.5":"a #1","12.1":"a #1 #3"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"a #4","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"a #4"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"const is recognized, but treated like var (no block scope, can be overwritten)","2":"const does not have block scope","3":"Only recognized when NOT in strict mode","4":"Supported correctly in strict mode, otherwise supported without block scope","5":"Not supported in for-in and for-of loops"},"usage_perc_y":95.6,"usage_perc_a":3.75,"ucprefix":false,"parent":"","keywords":"ES6,constant,block,scope","ie_id":"","chrome_id":"4645595339816960","firefox_id":"","webkit_id":""},"constraint-validation":{"title":"Constraint Validation API","description":"API for better control over form field validation. Includes support for `checkValidity()`, `setCustomValidity()`, `reportValidity()` and validation states.","spec":"https://html.spec.whatwg.org/dev/form-control-infrastructure.html#the-constraint-validation-api","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/HTML5/Constraint_validation","title":"MDN article on constraint validation"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/14744163-support-htmlformelement-reportvalidity","title":"MS Edge UserVoice request for reportValidity"},{"url":"https://github.com/jelmerdemaat/report-validity","title":"`reportValidity()` ponyfill"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"a #1 #2 #3","11":"a #1 #2 #3","5.5":"n"},"edge":{"12":"a #1 #2 #3","13":"a #1 #2 #3","14":"a #1 #2","15":"a #1 #2","16":"a #1 #2","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a #1 #2 #3","5":"a #1 #2 #3","6":"a #1 #2 #3","7":"a #1 #2 #3","8":"a #1 #2 #3","9":"a #1 #2 #3","10":"a #1 #2 #3","11":"a #1 #2 #3","12":"a #1 #2 #3","13":"a #1 #2 #3","14":"a #1 #2 #3","15":"a #1 #2 #3","16":"a #1 #2 #3","17":"a #1 #2 #3","18":"a #1 #2 #3","19":"a #1 #2 #3","20":"a #1 #2 #3","21":"a #1 #2 #3","22":"a #1 #2 #3","23":"a #1 #2 #3","24":"a #1 #2 #3","25":"a #1 #2 #3","26":"a #1 #2 #3","27":"a #1 #2 #3","28":"a #1 #2 #3","29":"a #1 #2","30":"a #1 #2","31":"a #1 #2","32":"a #1 #2","33":"a #1 #2","34":"a #1 #2","35":"a #1 #2","36":"a #1 #2","37":"a #1 #2","38":"a #1 #2","39":"a #1 #2","40":"a #1 #2","41":"a #1 #2","42":"a #1 #2","43":"a #1 #2","44":"a #1 #2","45":"a #1 #2","46":"a #1 #2","47":"a #1 #2","48":"a #1 #2","49":"a #2","50":"a #2","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"a #1 #2 #3","16":"a #1 #2 #3","17":"a #1 #2 #3","18":"a #1 #2 #3","19":"a #1 #2 #3","20":"a #1 #2 #3","21":"a #1 #2 #3","22":"a #1 #2 #3","23":"a #1 #2 #3","24":"a #1 #2 #3","25":"a #1 #2","26":"a #1 #2","27":"a #1 #2","28":"a #1 #2","29":"a #1 #2","30":"a #1 #2","31":"a #1 #2","32":"a #1 #2","33":"a #1 #2","34":"a #1 #2","35":"a #1 #2","36":"a #1 #2","37":"a #1 #2","38":"a #1 #2","39":"a #1 #2","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"u","5":"u","6":"a #1 #2 #3","7":"a #1 #2 #3","8":"a #1 #2","9":"a #1 #2","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"u","5.1":"a #1 #2 #3","6.1":"a #1 #2 #3","7.1":"a #1 #2","9.1":"a #1 #2","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"u","12":"a #1 #2 #3","15":"a #1 #2","16":"a #1 #2","17":"a #1 #2","18":"a #1 #2","19":"a #1 #2","20":"a #1 #2","21":"a #1 #2","22":"a #1 #2","23":"a #1 #2","24":"a #1 #2","25":"a #1 #2","26":"a #1 #2","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"u","10.0-10.1":"u","10.5":"u","10.6":"u","11.1":"u","11.5":"u","11.6":"a #1 #2 #3","12.1":"a #1 #2 #3"},"ios_saf":{"8":"a #1 #2","14":"y","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"a #1 #2 #3","6.0-6.1":"a #1 #2 #3","7.0-7.1":"a #1 #2","8.1-8.4":"a #1 #2","9.0-9.2":"a #1 #2","9.3":"a #1 #2","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"u","4":"a #1 #2 #3","81":"y","2.1":"u","2.2":"u","2.3":"u","4.1":"a #1 #2 #3","4.2-4.3":"a #1 #2 #3","4.4":"a #1 #2","4.4.3-4.4.4":"a #1 #2"},"bb":{"7":"u","10":"a #1 #2"},"op_mob":{"10":"u","11":"u","12":"a #1 #2 #3","59":"y","11.1":"u","11.5":"u","12.1":"a #1 #2 #3"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #1 #2 #3","11":"a #1 #2 #3"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"a #1 #2"}},"notes":"","notes_by_num":{"1":"Does not support `reportValidity`","2":"Does not support `validity.tooShort`. See also [support for `minlength`.](https://caniuse.com/#feat=input-minlength)","3":"Does not support `validity.badInput`"},"usage_perc_y":95.76,"usage_perc_a":2.58,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"contenteditable":{"title":"contenteditable attribute (basic support)","description":"Method of making any HTML element editable.","spec":"https://html.spec.whatwg.org/multipage/interaction.html#contenteditable","status":"ls","links":[{"url":"https://blog.whatwg.org/the-road-to-html-5-contenteditable","title":"WHATWG blog post"},{"url":"https://accessgarage.wordpress.com/2009/05/08/how-to-hack-your-app-to-make-contenteditable-work/","title":"Blog post on usage problems"},{"url":"https://www.webplatform.org/docs/html/attributes/contentEditable","title":"WebPlatform Docs"},{"url":"https://developer.mozilla.org/en/docs/Web/API/HTMLElement/contentEditable","title":"MDN Web Docs - contentEditable attribute"}],"categories":["HTML5"],"stats":{"ie":{"6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","5.5":"y"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"a","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"This support only refers to very basic editing capability, implementations vary significantly on how certain elements can be edited.","notes_by_num":{},"usage_perc_y":98.79,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"iscontenteditable","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"contentsecuritypolicy":{"title":"Content Security Policy 1.0","description":"Mitigate cross-site scripting attacks by only allowing certain sources of script, style, and other resources.","spec":"https://www.w3.org/TR/2012/CR-CSP-20121115/","status":"cr","links":[{"url":"https://www.html5rocks.com/en/tutorials/security/content-security-policy/","title":"HTML5Rocks article"},{"url":"https://content-security-policy.com/","title":"CSP Examples & Quick Reference"},{"url":"https://developer.mozilla.org/en-US/docs/Web/HTTP/CSP","title":"MDN Web Docs - Content Security Policy"}],"categories":["Security"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"a #1","11":"a #1","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y #1","5":"y #1","6":"y #1","7":"y #1","8":"y #1","9":"y #1","10":"y #1","11":"y #1","12":"y #1","13":"y #1","14":"y #1","15":"y #1","16":"y #1","17":"y #1","18":"y #1","19":"y #1","20":"y #1","21":"y #1","22":"y #1","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"y #2","15":"y #2","16":"y #2","17":"y #2","18":"y #2","19":"y #2","20":"y #2","21":"y #2","22":"y #2","23":"y #2","24":"y #2","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y #2","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"a #2","6.1":"y #2","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"a #2","6.0-6.1":"y #2","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y #2"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #1","11":"a #1"},"and_uc":{"12.12":"y #2"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"The standard HTTP header is `Content-Security-Policy` which is used unless otherwise noted.","notes_by_num":{"1":"Supported through the `X-Content-Security-Policy` header","2":"Supported through the `X-WebKit-CSP` header"},"usage_perc_y":96.97,"usage_perc_a":1.29,"ucprefix":false,"parent":"","keywords":"csp,security,header","ie_id":"contentsecuritypolicy","chrome_id":"5205088045891584","firefox_id":"","webkit_id":""},"contentsecuritypolicy2":{"title":"Content Security Policy Level 2","description":"Mitigate cross-site scripting attacks by only allowing certain sources of script, style, and other resources. CSP 2 adds hash-source, nonce-source, and five new directives","spec":"https://www.w3.org/TR/CSP2/","status":"rec","links":[{"url":"https://www.html5rocks.com/en/tutorials/security/content-security-policy/","title":"HTML5Rocks article"},{"url":"https://developer.mozilla.org/en-US/docs/Web/HTTP/CSP","title":"MDN Web Docs - Content Security Policy"}],"categories":["Security"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"a #9","16":"a #9","17":"a #9","18":"a #9","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #2","36":"a #3","37":"a #3","38":"a #3","39":"a #3","40":"a #3","41":"a #3","42":"a #3","43":"a #3","44":"a #3","45":"a #7","46":"a #7","47":"a #7","48":"a #7","49":"a #7","50":"a #7","51":"a #7","52":"a #7","53":"a #7","54":"a #7","55":"a #7","56":"a #7","57":"a #7","58":"a #7","59":"a #7","60":"a #7","61":"a #7","62":"a #7","63":"a #7","64":"a #7","65":"a #7","66":"a #7","67":"a #7","68":"a #7","69":"a #7","70":"a #7","71":"a #7","72":"a #7","73":"a #7","74":"a #7","75":"a #7","76":"a #7","77":"a #7","78":"a #7","79":"a #7","80":"a #7","81":"a #7","82":"a #7","83":"a #7","84":"a #7","85":"a #7","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"a #4","37":"a #4","38":"a #4","39":"a #5","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"a #4","24":"a #4","25":"a #4","26":"a #5","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"a #6"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"a #7"}},"notes":"","notes_by_num":{"1":"Firefox 31-34 is missing the plugin-types, child-src, frame-ancestors, base-uri, and form-action directives.","2":"Firefox 35 is missing the plugin-types, child-src, frame-ancestors, and form-action directives.","3":"Firefox 36-44 is missing the plugin-types and child-src directives.","4":"Chrome 36-38 & Opera 23-25 are missing the plugin-types, child-src, frame-ancestors, base-uri, and form-action directives.","5":"Chrome 39 and Opera 26 are missing the plugin-types, child-src, base-uri, and form-action directives.","6":"Firefox 38 on Android is missing the child-src directive.","7":"Firefox 45+ is missing the plugin-types directive.","9":"Edge has broken nonce support as it ignores nonces on sourced scripts."},"usage_perc_y":90.39,"usage_perc_a":4.45,"ucprefix":false,"parent":"","keywords":"csp,header,nonce,hash","ie_id":"contentsecuritypolicylevel2","chrome_id":"4957003285790720","firefox_id":"","webkit_id":"specification-content-security-policy-level-2"},"cors":{"title":"Cross-Origin Resource Sharing","description":"Method of performing XMLHttpRequests across domains","spec":"https://fetch.spec.whatwg.org/#http-cors-protocol","status":"ls","links":[{"url":"https://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/","title":"Mozilla Hacks blog post"},{"url":"https://msdn.microsoft.com/en-us/library/cc288060(VS.85).aspx","title":"Alternative implementation by IE8"},{"url":"https://dev.opera.com/articles/view/dom-access-control-using-cross-origin-resource-sharing/","title":"DOM access using CORS"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/features.js#native-cors-xhr","title":"has.js test"},{"url":"https://developer.mozilla.org/en-US/docs/Web/HTTP/Access_control_CORS","title":"MDN Web Docs - Access control CORS"}],"categories":["JS API","Security"],"stats":{"ie":{"6":"n","7":"n","8":"a #2","9":"a #2","10":"a #1","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y #4","62":"y #4","63":"y #4","64":"y #4","65":"y #4","66":"y #4","67":"y #4","68":"y #4","69":"y #4","70":"y #4","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a #1 #3","5":"a #1 #3","6":"y #3","7":"y #3","8":"y #3","9":"y #3","10":"y #3","11":"y #3","12":"y #3","13":"y #3","14":"y #3","3.1":"n","3.2":"n","5.1":"a #1 #3","6.1":"y #3","7.1":"y #3","9.1":"y #3","10.1":"y #3","11.1":"y #3","12.1":"y #3","13.1":"y #3","TP":"y #3"},"opera":{"9":"n","11":"n","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"y"},"ios_saf":{"8":"y #3","14":"y #3","3.2":"a #1 #3","4.0-4.1":"a #1 #3","4.2-4.3":"a #1 #3","5.0-5.1":"a #1 #3","6.0-6.1":"y #3","7.0-7.1":"y #3","8.1-8.4":"y #3","9.0-9.2":"y #3","9.3":"y #3","10.0-10.2":"y #3","10.3":"y #3","11.0-11.2":"y #3","11.3-11.4":"y #3","12.0-12.1":"y #3","12.2-12.4":"y #3","13.0-13.1":"y #3","13.2":"y #3","13.3":"y #3","13.4-13.7":"y #3"},"op_mini":{"all":"n"},"android":{"3":"a #1","4":"a #1","81":"y","2.1":"a #1","2.2":"a #1","2.3":"a #1","4.1":"a #1","4.2-4.3":"a #1","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"a #1","10":"y"},"op_mob":{"10":"n","11":"n","12":"y","59":"y","11.1":"n","11.5":"n","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #1","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Does not support CORS for images in `<canvas>`","2":"Supported somewhat in IE8 and IE9 using the XDomainRequest object (but has [limitations](https://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx))","3":"Does not support CORS for `<video>` in `<canvas>`: https://bugs.webkit.org/show_bug.cgi?id=135379","4":"Does not support CORS for resources which redirect: https://bugzilla.mozilla.org/show_bug.cgi?id=1346749"},"usage_perc_y":98.12,"usage_perc_a":0.6,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"createimagebitmap":{"title":"createImageBitmap","description":"Create image bitmap with support for resizing and adjusting quality","spec":"https://html.spec.whatwg.org/multipage/imagebitmap-and-animations.html#dom-createimagebitmap","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/createImageBitmap","title":"self.createImageBitmap() - Web APIs | MDN"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"a #4 #5","43":"a #4 #5","44":"a #4 #5","45":"a #4 #5","46":"a #4 #5","47":"a #4 #5","48":"a #4 #5","49":"a #4 #5","50":"a #4 #5","51":"a #4 #5","52":"a #4 #5","53":"a #4 #5","54":"a #4 #5","55":"a #4 #5","56":"a #4 #5","57":"a #4 #5","58":"a #4 #5","59":"a #4 #5","60":"a #4 #5","61":"a #4 #5","62":"a #4 #5","63":"a #4 #5","64":"a #4 #5","65":"a #4 #5","66":"a #4 #5","67":"a #4 #5","68":"a #4 #5","69":"a #4 #5","70":"a #4 #5","71":"a #4 #5","72":"a #4 #5","73":"a #4 #5","74":"a #4 #5","75":"a #4 #5","76":"a #4 #5","77":"a #4 #5","78":"a #4 #5","79":"a #4 #5","80":"a #4 #5","81":"a #4 #5","82":"a #4 #5","83":"a #4 #5","84":"a #4 #5","85":"a #4 #5","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"a #1","51":"a #1","52":"a #2","53":"a #2","54":"a #3","55":"a #3","56":"a #3","57":"a #3","58":"a #3","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"u","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"u","TP":"u"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"a #1","38":"a #1","39":"a #2","40":"a #2","41":"a #3","42":"a #3","43":"a #3","44":"a #3","45":"a #3","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"a #4 #5"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"u","5.0-5.4":"u","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"a #4 #5"}},"notes":"","notes_by_num":{"1":"No support for options parameter, resizeWidth, resizeHeight, resizeQuality or SVGImageElement as Source Image","2":"No support for resizeWidth, resizeHeight, resizeQuality or SVGImageElement as Source Image","3":"No support for SVGImageElement as Source Image","4":"No support for resizeWidth, resizeHeight and resizeQuality. See [this bug](https://bugzilla.mozilla.org/show_bug.cgi?id=1363861)","5":"No support for `createImageBitmap(source, options)` interface. see [this bug](https://bugzilla.mozilla.org/show_bug.cgi?id=1335594)"},"usage_perc_y":74.72,"usage_perc_a":4.14,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"credential-management":{"title":"Credential Management API","description":"API that provides a programmatic interface to the browser's credential manager. In short, an origin can request a user's credentials to sign them in, or can ask the browser to save credentials on the user's behalf. Both of these requests are user-mediated.","spec":"https://www.w3.org/TR/credential-management-1/","status":"wd","links":[{"url":"https://developers.google.com/web/updates/2016/04/credential-management-api","title":"Tutorial by Google"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Credential_Management_API","title":"MDN Web Docs - Credential Management API"},{"url":"https://g.co/codelabs/cmapi","title":"Codelab"},{"url":"https://credential-management-sample.appspot.com/","title":"Live Demo"},{"url":"https://github.com/GoogleChrome/credential-management-sample","title":"Sample Code"},{"url":"https://github.com/w3c/webappsec-credential-management","title":"Spec discussion"}],"categories":["JS API","Security"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n d","49":"n d","50":"n d","51":"y #1","52":"y #1","53":"y #1","54":"y #1","55":"y #1","56":"y #1","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"In Chrome 51 ~ 56, PSL matched credentials are not supported. This means you cannot use credentials set on a.example.com in b.example.com. This is supported since Chrome 57."},"usage_perc_y":74.64,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"credential,navigator.credentials","ie_id":"credentialmanagementapi","chrome_id":"5026422640869376","firefox_id":"credential-management","webkit_id":""},"cryptography":{"title":"Web Cryptography","description":"JavaScript API for performing basic cryptographic operations in web applications","spec":"https://www.w3.org/TR/WebCryptoAPI/","status":"rec","links":[{"url":"https://www.slideshare.net/Channy/the-history-and-status-of-web-crypto-api","title":"The History and Status of Web Crypto API"},{"url":"https://github.com/microsoft/MSR-JavaScript-Crypto","title":"Microsoft Research JavaScript Cryptography Library"},{"url":"https://bitwiseshiftleft.github.io/sjcl/","title":"Cross-browser cryptography library"},{"url":"https://docs.google.com/spreadsheet/ccc?key=0AiAcidBZRLxndE9LWEs2R1oxZ0xidUVoU3FQbFFobkE#gid=1","title":"Support for recommended algorithms in Firefox"},{"url":"https://github.com/Netflix/NfWebCrypto","title":"Polyfill by Netflix with partial support"},{"url":"https://github.com/GlobalSign/PKI.js","title":"PKI.js - another crypto library for Public Key Infrastructure applications"},{"url":"https://diafygi.github.io/webcrypto-examples/","title":"Test suite for various algorithms/methods"},{"url":"https://github.com/vibornoff/webcrypto-shim","title":"Web Cryptography API shim for IE11 and Safari - set of bugfixes and workarounds of prefixed api implementations"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Web_Crypto_API","title":"MDN Web Docs - Web Crypto API"}],"categories":["JS API","Security"],"stats":{"ie":{"6":"p","7":"p","8":"p","9":"p","10":"p","11":"a x #1","5.5":"n"},"edge":{"12":"y #3","13":"y #3","14":"y #3","15":"y #3","16":"y #3","17":"y #3","18":"y #3","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"p","3":"p","4":"p","5":"p","6":"p","7":"p","8":"p","9":"p","10":"p","11":"p","12":"p","13":"p","14":"p","15":"p","16":"p","17":"p","18":"p","19":"p","20":"p","21":"p","22":"p","23":"p","24":"p","25":"p","26":"p","27":"p","28":"p","29":"p","30":"p","31":"p","32":"n d","33":"n d","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"p","3.6":"p"},"chrome":{"4":"p","5":"p","6":"p","7":"p","8":"p","9":"p","10":"p","11":"p","12":"p","13":"p","14":"p","15":"p","16":"p","17":"p","18":"p","19":"p","20":"p","21":"p","22":"p","23":"p","24":"p","25":"p","26":"p","27":"p","28":"p","29":"p","30":"p","31":"p","32":"p","33":"p","34":"p","35":"p","36":"p","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"p","5":"p","6":"p","7":"p","8":"y x #2","9":"y x #2","10":"y x #2","11":"y","12":"y","13":"y","14":"y","3.1":"p","3.2":"p","5.1":"p","6.1":"p","7.1":"y x #2","9.1":"y x #2","10.1":"y x #2","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"p","11":"p","12":"p","15":"p","16":"p","17":"p","18":"p","19":"p","20":"p","21":"p","22":"p","23":"p","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"p","10.0-10.1":"p","10.5":"p","10.6":"p","11.1":"p","11.5":"p","11.6":"p","12.1":"p"},"ios_saf":{"8":"y x #2","14":"y","3.2":"p","4.0-4.1":"p","4.2-4.3":"p","5.0-5.1":"p","6.0-6.1":"p","7.0-7.1":"p","8.1-8.4":"y x #2","9.0-9.2":"y x #2","9.3":"y x #2","10.0-10.2":"y x #2","10.3":"y x #2","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"p","4":"p","81":"y","2.1":"p","2.2":"p","2.3":"p","4.1":"p","4.2-4.3":"p","4.4":"p","4.4.3-4.4.4":"p"},"bb":{"7":"p","10":"p"},"op_mob":{"10":"p","11":"p","12":"p","59":"y","11.1":"p","11.5":"p","12.1":"p"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"p","11":"a x #1"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Many browsers support the `[crypto.getRandomValues()](#feat=getrandomvalues)` method, but not actual cryptography functionality under `crypto.subtle`.","notes_by_num":{"1":"Support in IE11 is based on an older version of the specification.","2":"Support in Safari before version 11 was using the `crypto.webkitSubtle` prefix.","3":"In Edge 12-18, Web Crypto was not supported in Web Workers and Service Workers."},"usage_perc_y":96.46,"usage_perc_a":1.11,"ucprefix":false,"parent":"","keywords":"subtle,subtlecrypto","ie_id":"webcryptoapi","chrome_id":"5030265697075200","firefox_id":"","webkit_id":"specification-web-cryptography-api"},"css-all":{"title":"CSS all property","description":"A shorthand property for resetting all CSS properties except for `direction` and `unicode-bidi`.","spec":"https://www.w3.org/TR/css-cascade-3/#all-shorthand","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/all","title":"MDN Web Docs - CSS all"},{"url":"https://mcc.id.au/blog/2013/10/all-unset","title":"Resetting styles using `all: unset`"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=116966","title":"WebKit bug 116966: [css3-cascade] Add support for `all` shorthand property"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6511510-all-initial","title":"Microsoft Edge feature request on UserVoice"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":96.1,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"CSS,all,property,shorthand,reset","ie_id":"cssallshorthand","chrome_id":"6178222542684160","firefox_id":"","webkit_id":""},"css-animation":{"title":"CSS Animation","description":"Complex method of animating certain properties of an element","spec":"https://www.w3.org/TR/css3-animations/","status":"wd","links":[{"url":"http://robertnyman.com/2010/05/06/css3-animations/","title":"Blog post on usage"},{"url":"https://www.webplatform.org/docs/css/properties/animations","title":"WebPlatform Docs"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a x #2","5":"a x #2","6":"y x","7":"y x","8":"y x","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y x","6.1":"y x","7.1":"y x","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"y"},"ios_saf":{"8":"y x","14":"y","3.2":"a x #1","4.0-4.1":"a x #1","4.2-4.3":"a x #1","5.0-5.1":"a x #1","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"a x #1","4":"y x","81":"y","2.1":"a x #1","2.2":"a x #1","2.3":"a x #1","4.1":"y x","4.2-4.3":"y x","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"y x","10":"y x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y x"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support in Android browser refers to buggy behavior in different scenarios.","2":"Does not support the `steps()`, `step-start` & `step-end` timing functions"},"usage_perc_y":98.37,"usage_perc_a":0.04,"ucprefix":false,"parent":"","keywords":"animations,css-animations,animation-name,animation-duration,animation-delay,animation-timing-function,animation-iteration-count,@keyframes,animationstart,animationend,animationiteration,css3 animation,steps,step-start,step-end,cubic-bezier","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-any-link":{"title":"CSS :any-link selector","description":"The `:any-link` CSS pseudo-class matches all elements that match `:link` or `:visited`","spec":"https://drafts.csswg.org/selectors-4/#the-any-link-pseudo","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/:any-link","title":"MDN Web Docs - CSS :any-link"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"u","3":"y x","4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y x","3.6":"y x"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","59":"y x","60":"y x","61":"y x","62":"y x","63":"y x","64":"y x","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"u","5":"u","6":"u","7":"y x","8":"y x","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"u","5.1":"u","6.1":"y x","7.1":"y x","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"u","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"u","4":"u","81":"y","2.1":"u","2.2":"u","2.3":"u","4.1":"u","4.2-4.3":"u","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"u","10":"u"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y x"},"samsung":{"4":"u","5.0-5.4":"y x","6.2-6.4":"y x","7.2-7.4":"y x","8.2":"y x","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y x"}},"notes":"","notes_by_num":{},"usage_perc_y":96.34,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"any-link,css4,selector,visited","ie_id":"","chrome_id":"5724922840088576","firefox_id":"","webkit_id":"feature-css-selector-:any-link"},"css-appearance":{"title":"CSS Appearance","description":"The `appearance` property defines how elements (particularly form controls) appear by default. By setting the value to `none` the default appearance can be entirely redefined using other CSS properties.","spec":"https://www.w3.org/TR/css-ui-4/#appearance-switching","status":"wd","links":[{"url":"https://css-tricks.com/almanac/properties/a/appearance/","title":"CSS Tricks article"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=143842","title":"Safari implementation bug for unprefixed `appearance`"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"a #1 #2","13":"a #1 #2","14":"a #1 #2","15":"a #1 #2","16":"a #1 #2","17":"a #1 #2","18":"a #1 #2","79":"a x #1","80":"a x #1","81":"a x #1","83":"y x","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"a x #1 #3","3":"a x #1 #3","4":"a x #1 #3","5":"a x #1 #3","6":"a x #1 #3","7":"a x #1 #3","8":"a x #1 #3","9":"a x #1 #3","10":"a x #1 #3","11":"a x #1 #3","12":"a x #1 #3","13":"a x #1 #3","14":"a x #1 #3","15":"a x #1 #3","16":"a x #1 #3","17":"a x #1 #3","18":"a x #1 #3","19":"a x #1 #3","20":"a x #1 #3","21":"a x #1 #3","22":"a x #1 #3","23":"a x #1 #3","24":"a x #1 #3","25":"a x #1 #3","26":"a x #1 #3","27":"a x #1 #3","28":"a x #1 #3","29":"a x #1 #3","30":"a x #1 #3","31":"a x #1 #3","32":"a x #1 #3","33":"a x #1 #3","34":"a x #1 #3","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"a x #1","52":"a x #1","53":"a x #1","54":"a x #1","55":"a x #1","56":"a x #1","57":"a x #1","58":"a x #1","59":"a x #1","60":"a x #1","61":"a x #1","62":"a x #1","63":"a x #1","64":"a x #1","65":"a x #1","66":"a x #1","67":"a x #1","68":"a x #1","69":"a x #1","70":"a x #1","71":"a x #1","72":"a x #1","73":"a x #1","74":"a x #1","75":"a x #1","76":"a x #1","77":"a x #1","78":"a x #1","79":"a x #1","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a x #1 #3","3.6":"a x #1 #3"},"chrome":{"4":"a x #1","5":"a x #1","6":"a x #1","7":"a x #1","8":"a x #1","9":"a x #1","10":"a x #1","11":"a x #1","12":"a x #1","13":"a x #1","14":"a x #1","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","19":"a x #1","20":"a x #1","21":"a x #1","22":"a x #1","23":"a x #1","24":"a x #1","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"a x #1","52":"a x #1","53":"a x #1","54":"a x #1","55":"a x #1","56":"a x #1","57":"a x #1","58":"a x #1","59":"a x #1","60":"a x #1","61":"a x #1","62":"a x #1","63":"a x #1","64":"a x #1","65":"a x #1","66":"a x #1","67":"a x #1","68":"a x #1","69":"a x #1","70":"a x #1","71":"a x #1","72":"a x #1","73":"a x #1","74":"a x #1","75":"a x #1","76":"a x #1","77":"a x #1","78":"a x #1","79":"a x #1","80":"a x #1","81":"a x #1","83":"y x","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a x #1","5":"a x #1","6":"a x #1","7":"a x #1","8":"a x #1","9":"a x #1","10":"a x #1","11":"a x #1","12":"a x #1","13":"a x #1","14":"a x #1","3.1":"a x #1","3.2":"a x #1","5.1":"a x #1","6.1":"a x #1","7.1":"a x #1","9.1":"a x #1","10.1":"a x #1","11.1":"a x #1","12.1":"a x #1","13.1":"a x #1","TP":"a x #1"},"opera":{"9":"n","11":"n","12":"n","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","19":"a x #1","20":"a x #1","21":"a x #1","22":"a x #1","23":"a x #1","24":"a x #1","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"a x #1","52":"a x #1","53":"a x #1","54":"a x #1","55":"a x #1","56":"a x #1","57":"a x #1","58":"a x #1","60":"a x #1","62":"a x #1","63":"a x #1","64":"a x #1","65":"a x #1","66":"a x #1","67":"a x #1","68":"a x #1","69":"a x #1","70":"y x","71":"y x","72":"y x","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a x #1","14":"a x #1","3.2":"a x #1","4.0-4.1":"a x #1","4.2-4.3":"a x #1","5.0-5.1":"a x #1","6.0-6.1":"a x #1","7.0-7.1":"a x #1","8.1-8.4":"a x #1","9.0-9.2":"a x #1","9.3":"a x #1","10.0-10.2":"a x #1","10.3":"a x #1","11.0-11.2":"a x #1","11.3-11.4":"a x #1","12.0-12.1":"a x #1","12.2-12.4":"a x #1","13.0-13.1":"a x #1","13.2":"a x #1","13.3":"a x #1","13.4-13.7":"a x #1"},"op_mini":{"all":"n"},"android":{"3":"a x #1","4":"a x #1","81":"a x #1","2.1":"a x #1","2.2":"a x #1","2.3":"a x #1","4.1":"a x #1","4.2-4.3":"a x #1","4.4":"a x #1","4.4.3-4.4.4":"a x #1"},"bb":{"7":"a x #1","10":"a x #1"},"op_mob":{"10":"n","11":"n","12":"n","59":"a x #1","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"a x #1"},"ie_mob":{"10":"n","11":"a #1 #2"},"and_uc":{"12.12":"a x #1"},"samsung":{"4":"a x #1","5.0-5.4":"a x #1","6.2-6.4":"a x #1","7.2-7.4":"a x #1","8.2":"a x #1","9.2":"a x #1","10.1":"a x #1","11.1-11.2":"a x #1","12.0":"a x #1"},"and_qq":{"10.4":"a x #1"},"baidu":{"7.12":"a x #1"},"kaios":{"2.5":"a x #1"}},"notes":"WebKit, Blink, and Gecko browsers also support additional vendor specific values.","notes_by_num":{"1":"The appearance property is supported with the `none` value, but not `auto`.","2":"Microsoft Edge and IE Mobile support this property with the `-webkit-` prefix, rather than `-ms-` for interop reasons.","3":"`-moz-appearance:none` did not remove the dropdown arrow in the select tag"},"usage_perc_y":71.38,"usage_perc_a":25.95,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-apply-rule":{"title":"CSS @apply rule","description":"Allows a set of CSS properties to be applied using a named variable","spec":"https://tabatkins.github.io/specs/css-apply-rule/","status":"unoff","links":[{"url":"http://zeke.sikelianos.com/css-from-the-future/","title":"Article on CSS @apply"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n d #1","80":"n d #1","81":"n d #1","83":"n d #1","84":"n d #1","85":"n d #1","86":"n d #1","87":"n d #1"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n d #1","52":"n d #1","53":"n d #1","54":"n d #1","55":"n d #1","56":"n d #1","57":"n d #1","58":"n d #1","59":"n d #1","60":"n d #1","61":"n d #1","62":"n d #1","63":"n d #1","64":"n d #1","65":"n d #1","66":"n d #1","67":"n d #1","68":"n d #1","69":"n d #1","70":"n d #1","71":"n d #1","72":"n d #1","73":"n d #1","74":"n d #1","75":"n d #1","76":"n d #1","77":"n d #1","78":"n d #1","79":"n d #1","80":"n d #1","81":"n d #1","83":"n d #1","84":"n d #1","85":"n d #1","86":"n d #1","87":"n d #1","88":"n d #1","89":"n d #1","90":"n d #1"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n d #1","39":"n d #1","40":"n d #1","41":"n d #1","42":"n d #1","43":"n d #1","44":"n d #1","45":"n d #1","46":"n d #1","47":"n d #1","48":"n d #1","49":"n d #1","50":"n d #1","51":"n d #1","52":"n d #1","53":"n d #1","54":"n d #1","55":"n d #1","56":"n d #1","57":"n d #1","58":"n d #1","60":"n d #1","62":"n d #1","63":"n d #1","64":"n d #1","65":"n d #1","66":"n d #1","67":"n d #1","68":"n d #1","69":"n d #1","70":"n d #1","71":"n d #1","72":"n d #1","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n d #1","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n d #1"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n d #1","6.2-6.4":"n d #1","7.2-7.4":"n d #1","8.2":"n d #1","9.2":"n d #1","10.1":"n d #1","11.1-11.2":"n d #1","12.0":"n d #1"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n d #1"},"kaios":{"2.5":"n"}},"notes":"See also support for [CSS Variables](#feat=css-variables)","notes_by_num":{"1":"Can be enabled via the \"Experimental web platform features\" flag under about:flags"},"usage_perc_y":0,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"5753701012602880","firefox_id":"","webkit_id":""},"css-at-counter-style":{"title":"CSS Counter Styles","description":"The @counter-style CSS at-rule allows custom counter styles to be defined. A @counter-style rule defines how to convert a counter value into a string representation.","spec":"https://drafts.csswg.org/css-counter-styles/","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/@counter-style","title":"MDN Web Docs - CSS counter style"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","59":"a #1","60":"a #1","61":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #1","66":"a #1","67":"a #1","68":"a #1","69":"a #1","70":"a #1","71":"a #1","72":"a #1","73":"a #1","74":"a #1","75":"a #1","76":"a #1","77":"a #1","78":"a #1","79":"a #1","80":"a #1","81":"a #1","82":"a #1","83":"a #1","84":"a #1","85":"a #1","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"a #1"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"a #1"}},"notes":"","notes_by_num":{"1":"Partial support in Firefox refers to lacking support for [image symbols](https://bugzilla.mozilla.org/show_bug.cgi?id=1024179)"},"usage_perc_y":0,"usage_perc_a":4,"ucprefix":false,"parent":"","keywords":"css @counter-style, list-style","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-backdrop-filter":{"title":"CSS Backdrop Filter","description":"Method of applying filter effects (like blur, grayscale or hue) to content/elements below the target element.","spec":"https://drafts.fxtf.org/filter-effects-2/#BackdropFilterProperty","status":"unoff","links":[{"url":"http://product.voxmedia.com/til/2015/2/17/8053347/css-ios-transparency-with-webkit-backdrop-filter","title":"Blog post"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/backdrop-filter","title":"MDN Web Docs - CSS backdrop filter"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/9160189-backdrop-filters","title":"Edge feature request"}],"categories":["CSS","CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"y #2","18":"y #2","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n d #3","71":"n d #3","72":"n d #3","73":"n d #3","74":"n d #3","75":"n d #3","76":"n d #3","77":"n d #3","78":"n d #3","79":"n d #3","80":"n d #3","81":"n d #3","82":"n d #3","83":"n d #3","84":"n d #3","85":"n d #3","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n d #1","48":"n d #1","49":"n d #1","50":"n d #1","51":"n d #1","52":"n d #1","53":"n d #1","54":"n d #1","55":"n d #1","56":"n d #1","57":"n d #1","58":"n d #1","59":"n d #1","60":"n d #1","61":"n d #1","62":"n d #1","63":"n d #1","64":"n d #1","65":"n d #1","66":"n d #1","67":"n d #1","68":"n d #1","69":"n d #1","70":"n d #1","71":"n d #1","72":"n d #1","73":"n d #1","74":"n d #1","75":"n d #1","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y x","10.1":"y x","11.1":"y x","12.1":"y x","13.1":"y x","TP":"y x"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n d #1","35":"n d #1","36":"n d #1","37":"n d #1","38":"n d #1","39":"n d #1","40":"n d #1","41":"n d #1","42":"n d #1","43":"n d #1","44":"n d #1","45":"n d #1","46":"n d #1","47":"n d #1","48":"n d #1","49":"n d #1","50":"n d #1","51":"n d #1","52":"n d #1","53":"n d #1","54":"n d #1","55":"n d #1","56":"n d #1","57":"n d #1","58":"n d #1","60":"n d #1","62":"n d #1","63":"n d #1","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y x","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y x","10.3":"y x","11.0-11.2":"y x","11.3-11.4":"y x","12.0-12.1":"y x","12.2-12.4":"y x","13.0-13.1":"y x","13.2":"y x","13.3":"y x","13.4-13.7":"y x"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n d #3"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n d #1","6.2-6.4":"n d #1","7.2-7.4":"n d #1","8.2":"n d #1","9.2":"n d #1","10.1":"n d #1","11.1-11.2":"n d #1","12.0":"y"},"and_qq":{"10.4":"n d #1"},"baidu":{"7.12":"n d #1"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Can be enabled via the \"Experimental Web Platform Features\" flag","2":"Currently only supported with the `-webkit-` prefix (not -ms-)","3":"Can be enabled by setting the `layout.css.backdrop-filter.enabled` and `gfx.webrender.all` preference to `true` in about:config."},"usage_perc_y":88.63,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"blue,hue-rotate,invert,saturate,filter","ie_id":"backdropfilter","chrome_id":"5679432723333120","firefox_id":"css-backdrop-filter","webkit_id":"feature-filter-effects-backdrop-filter-property"},"css-background-offsets":{"title":"CSS background-position edge offsets","description":"Allows CSS background images to be positioned relative to the specified edge using the 3 to 4 value syntax. For example: `background-position: right 5px bottom 5px;` for positioning 5px from the bottom-right corner.","spec":"https://www.w3.org/TR/css3-background/#background-position","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/background-position","title":"MDN Web Docs - background-position"},{"url":"http://briantree.se/quick-tip-06-use-four-value-syntax-properly-position-background-images/","title":"Basic information"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":99.1,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"4 value syntax","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-backgroundblendmode":{"title":"CSS background-blend-mode","description":"Allows blending between CSS background images, gradients, and colors.","spec":"https://www.w3.org/TR/compositing-1/#propdef-background-blend-mode","status":"cr","links":[{"url":"https://codepen.io/bennettfeely/pen/rxoAc","title":"codepen example"},{"url":"https://medium.com/web-design-technique/6b51bf53743a","title":"Blog post"},{"url":"http://bennettfeely.com/gradients","title":"Demo"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"a #2","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"a #1","9":"a #1","10":"a #1","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"a #1","9.1":"a #1","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"a #2","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a #1","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"a #1","9.0-9.2":"a #1","9.3":"a #1","10.0-10.2":"a #1","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial in Safari refers to not supporting the `hue`, `saturation`, `color`, and `luminosity` blend modes.","2":"Chrome 46 has some [serious bugs](https://code.google.com/p/chromium/issues/detail?id=543583) with multiply, difference, and exclusion blend modes"},"usage_perc_y":95.64,"usage_perc_a":0.48,"ucprefix":false,"parent":"","keywords":"css blend modes,css blending modes,blending,multiply,screen,background","ie_id":"","chrome_id":"5768037999312896","firefox_id":"","webkit_id":""},"css-boxdecorationbreak":{"title":"CSS box-decoration-break","description":"Controls whether the box's margins, borders, padding, and other decorations wrap the broken edges of the box fragments (when the box is split by a break (page/column/region/line).","spec":"https://www.w3.org/TR/css3-break/#break-decoration","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/box-decoration-break","title":"MDN Web Docs - CSS box-decoration-break"},{"url":"http://jsbin.com/xojoro/edit?css,output","title":"Demo of effect on box border"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6514472-box-decoration-break","title":"Microsoft Edge feature request on UserVoice"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"a x #1","80":"a x #1","81":"a x #1","83":"a x #1","84":"a x #1","85":"a x #1","86":"a x #1","87":"a x #1"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"a x #1","23":"a x #1","24":"a x #1","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"a x #1","52":"a x #1","53":"a x #1","54":"a x #1","55":"a x #1","56":"a x #1","57":"a x #1","58":"a x #1","59":"a x #1","60":"a x #1","61":"a x #1","62":"a x #1","63":"a x #1","64":"a x #1","65":"a x #1","66":"a x #1","67":"a x #1","68":"a x #1","69":"a x #1","70":"a x #1","71":"a x #1","72":"a x #1","73":"a x #1","74":"a x #1","75":"a x #1","76":"a x #1","77":"a x #1","78":"a x #1","79":"a x #1","80":"a x #1","81":"a x #1","83":"a x #1","84":"a x #1","85":"a x #1","86":"a x #1","87":"a x #1","88":"a x #1","89":"a x #1","90":"a x #1"},"safari":{"4":"n","5":"n","6":"n","7":"a x #1","8":"a x #1","9":"a x #1","10":"a x #1","11":"a x #1","12":"a x #1","13":"a x #1","14":"a x #1","3.1":"n","3.2":"n","5.1":"n","6.1":"a x #1","7.1":"a x #1","9.1":"a x #1","10.1":"a x #1","11.1":"a x #1","12.1":"a x #1","13.1":"a x #1","TP":"a x #1"},"opera":{"9":"n","11":"y #1","12":"y #1","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","19":"a x #1","20":"a x #1","21":"a x #1","22":"a x #1","23":"a x #1","24":"a x #1","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"a x #1","52":"a x #1","53":"a x #1","54":"a x #1","55":"a x #1","56":"a x #1","57":"a x #1","58":"a x #1","60":"a x #1","62":"a x #1","63":"a x #1","64":"a x #1","65":"a x #1","66":"a x #1","67":"a x #1","68":"a x #1","69":"a x #1","70":"a x #1","71":"a x #1","72":"a x #1","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"y #1","11.5":"y #1","11.6":"y #1","12.1":"y #1"},"ios_saf":{"8":"a x #1","14":"a x #1","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"a x #1","8.1-8.4":"a x #1","9.0-9.2":"a x #1","9.3":"a x #1","10.0-10.2":"a x #1","10.3":"a x #1","11.0-11.2":"a x #1","11.3-11.4":"a x #1","12.0-12.1":"a x #1","12.2-12.4":"a x #1","13.0-13.1":"a x #1","13.2":"a x #1","13.3":"a x #1","13.4-13.7":"a x #1"},"op_mini":{"all":"a #1"},"android":{"3":"n","4":"n","81":"a x #1","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"a x #1","4.4.3-4.4.4":"a x #1"},"bb":{"7":"n","10":"a x #1"},"op_mob":{"10":"n","11":"y #1","12":"y #1","59":"a x #1","11.1":"y #1","11.5":"y #1","12.1":"y #1"},"and_chr":{"86":"a x #1"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"a x #1","5.0-5.4":"a x #1","6.2-6.4":"a x #1","7.2-7.4":"a x #1","8.2":"a x #1","9.2":"a x #1","10.1":"a x #1","11.1-11.2":"a x #1","12.0":"a x #1"},"and_qq":{"10.4":"a x #1"},"baidu":{"7.12":"a x #1"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support refers to working for inline elements but not across column or page breaks."},"usage_perc_y":5.26,"usage_perc_a":91.98,"ucprefix":false,"parent":"","keywords":"box-decoration,box decoration,break","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-boxshadow":{"title":"CSS3 Box-shadow","description":"Method of displaying an inner or outer shadow effect to elements","spec":"https://www.w3.org/TR/css3-background/#box-shadow","status":"cr","links":[{"url":"https://developer.mozilla.org/En/CSS/-moz-box-shadow","title":"MDN Web Docs - box-shadow"},{"url":"http://westciv.com/tools/boxshadows/index.html","title":"Live editor"},{"url":"http://tests.themasta.com/blogstuff/boxshadowdemo.html","title":"Demo of various effects"},{"url":"https://www.webplatform.org/docs/css/properties/box-shadow","title":"WebPlatform Docs"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y x","3.6":"y x"},"chrome":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a x #1","5":"y x","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a x #1","3.2":"a x #1","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"a x #1","4.0-4.1":"y x","4.2-4.3":"y x","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"a x #1","4":"y","81":"y","2.1":"a x #1","2.2":"a x #1","2.3":"a x #1","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y x","10":"y"},"op_mob":{"10":"n","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Can be partially emulated in older IE versions using the non-standard \"shadow\" filter.","notes_by_num":{"1":"Partial support in Safari, iOS Safari and Android Browser refers to missing \"inset\", blur radius value, and multiple shadow support."},"usage_perc_y":98.68,"usage_perc_a":0.02,"ucprefix":false,"parent":"","keywords":"box-shadows,boxshadows,box shadow,shaow","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-canvas":{"title":"CSS Canvas Drawings","description":"Method of using HTML5 Canvas as a background image. Not currently part of any specification.","spec":"https://webkit.org/blog/176/css-canvas-drawing/","status":"unoff","links":[{"url":"https://webkit.org/blog/176/css-canvas-drawing/","title":"WebKit blog post"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"u","53":"u","54":"u","55":"u","56":"u","57":"u","58":"u","59":"u","60":"u","61":"u","62":"u","63":"u","64":"u","65":"u","66":"u","67":"u","68":"u","69":"u","70":"u","71":"u","72":"u","73":"u","74":"u","75":"u","76":"u","77":"u","78":"u","79":"u","80":"u","81":"u","82":"u","83":"u","84":"u","85":"u","3.5":"n","3.6":"n"},"chrome":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","3.1":"n","3.2":"n","5.1":"y x","6.1":"y x","7.1":"y x","9.1":"y x","10.1":"y x","11.1":"y x","12.1":"y x","13.1":"y x","TP":"y x"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y x","3.2":"y x","4.0-4.1":"y x","4.2-4.3":"y x","5.0-5.1":"y x","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y x","10.3":"y x","11.0-11.2":"y x","11.3-11.4":"y x","12.0-12.1":"y x","12.2-12.4":"y x","13.0-13.1":"y x","13.2":"y x","13.3":"y x","13.4-13.7":"y x"},"op_mini":{"all":"n"},"android":{"3":"y x","4":"y x","81":"n","2.1":"y x","2.2":"y x","2.3":"y x","4.1":"y x","4.2-4.3":"y x","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"y x","10":"y x"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"y x","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"A similar effect can be achieved in Firefox 4+ using the -moz-element() background property","notes_by_num":{},"usage_perc_y":17.49,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"5722125839106048","firefox_id":"","webkit_id":""},"css-caret-color":{"title":"CSS caret-color","description":"The `caret-color` property allows the color to be set of the caret (blinking text insertion pointer) in an editable text area.","spec":"https://www.w3.org/TR/css-ui-3/#caret-color","status":"cr","links":[{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/17595823-implement-caret-color-support","title":"Edge UserVoice request for caret-color"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=166572","title":"WebKit support bug"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/caret-color","title":"MDN article"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":94.01,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"5720917787279360","firefox_id":"","webkit_id":""},"css-case-insensitive":{"title":"Case-insensitive CSS attribute selectors","description":"Including an `i` before the `]` in a CSS attribute selector causes the attribute value to be matched in an ASCII-case-insensitive manner. For example, `[b=\"xyz\" i]` would match both `<a b=\"xyz\">` and `<a b=\"XYZ\">`.","spec":"https://www.w3.org/TR/selectors-4/#attribute-case","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/Attribute_selectors#case-insensitive","title":"MDN Web Docs - CSS case-insensitive"},{"url":"http://jsbin.com/zutuna/edit?html,css,output","title":"JS Bin testcase"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/16910512-case-insensitive-attribute-selector-i-flag","title":"MS Edge feature request on UserVoice"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":95.46,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"i,attribute,case,insensitive,sensitive,sensitivity,insensitivity","ie_id":"","chrome_id":"5610936115134464","firefox_id":"","webkit_id":"feature-case-insensitive-attribute-selectors"},"css-clip-path":{"title":"CSS clip-path property (for HTML)","description":"Method of defining the visible region of an HTML element using SVG or a shape definition.","spec":"https://www.w3.org/TR/css-masking-1/#the-clip-path","status":"cr","links":[{"url":"https://css-tricks.com/almanac/properties/c/clip/","title":"CSS Tricks article"},{"url":"https://codepen.io/dubrod/details/myNNyW/","title":"Codepen Example Clipping an Image with a Polygon"},{"url":"http://lab.iamvdo.me/css-svg-masks","title":"Visual test cases"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n d #4 #5","79":"a #2","80":"a #2","81":"a #2","83":"a #2","84":"a #2","85":"a #2","86":"a #2","87":"a #2"},"firefox":{"2":"n","3":"n","4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1 #3","48":"a #1 #3","49":"a #1 #3","50":"a #1 #3","51":"a #1 #3","52":"a #1 #3","53":"a #1 #3","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a #1","3.6":"a #1"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"a x #2","25":"a x #2","26":"a x #2","27":"a x #2","28":"a x #2","29":"a x #2","30":"a x #2","31":"a x #2","32":"a x #2","33":"a x #2","34":"a x #2","35":"a x #2","36":"a x #2","37":"a x #2","38":"a x #2","39":"a x #2","40":"a x #2","41":"a x #2","42":"a x #2","43":"a x #2","44":"a x #2","45":"a x #2","46":"a x #2","47":"a x #2","48":"a x #2","49":"a x #2","50":"a x #2","51":"a x #2","52":"a x #2","53":"a x #2","54":"a x #2","55":"a #2","56":"a #2","57":"a #2","58":"a #2","59":"a #2","60":"a #2","61":"a #2","62":"a #2","63":"a #2","64":"a #2","65":"a #2","66":"a #2","67":"a #2","68":"a #2","69":"a #2","70":"a #2","71":"a #2","72":"a #2","73":"a #2","74":"a #2","75":"a #2","76":"a #2","77":"a #2","78":"a #2","79":"a #2","80":"a #2","81":"a #2","83":"a #2","84":"a #2","85":"a #2","86":"a #2","87":"a #2","88":"a #2","89":"a #2","90":"a #2"},"safari":{"4":"n","5":"n","6":"n","7":"a x #2","8":"a x #2","9":"a x #2","10":"a x #2","11":"a x #2","12":"a x #2","13":"a x #2","14":"a x #2","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"a x #2","9.1":"a x #2","10.1":"a x #2","11.1":"a x #2","12.1":"a x #2","13.1":"a x #2","TP":"a x #2"},"opera":{"9":"n","11":"n","12":"n","15":"a x #2","16":"a x #2","17":"a x #2","18":"a x #2","19":"a x #2","20":"a x #2","21":"a x #2","22":"a x #2","23":"a x #2","24":"a x #2","25":"a x #2","26":"a x #2","27":"a x #2","28":"a x #2","29":"a x #2","30":"a x #2","31":"a x #2","32":"a x #2","33":"a x #2","34":"a x #2","35":"a x #2","36":"a x #2","37":"a x #2","38":"a x #2","39":"a x #2","40":"a x #2","41":"a x #2","42":"a #2","43":"a #2","44":"a #2","45":"a #2","46":"a #2","47":"a #2","48":"a #2","49":"a #2","50":"a #2","51":"a #2","52":"a #2","53":"a #2","54":"a #2","55":"a #2","56":"a #2","57":"a #2","58":"a #2","60":"a #2","62":"a #2","63":"a #2","64":"a #2","65":"a #2","66":"a #2","67":"a #2","68":"a #2","69":"a #2","70":"a #2","71":"a #2","72":"a #2","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a x #2","14":"a x #2","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"a x #2","8.1-8.4":"a x #2","9.0-9.2":"a x #2","9.3":"a x #2","10.0-10.2":"a x #2","10.3":"a x #2","11.0-11.2":"a x #2","11.3-11.4":"a x #2","12.0-12.1":"a x #2","12.2-12.4":"a x #2","13.0-13.1":"a x #2","13.2":"a x #2","13.3":"a x #2","13.4-13.7":"a x #2"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"a #2","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"a x #2","4.4.3-4.4.4":"a x #2"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"a #2","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a #2"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"a x #2"},"samsung":{"4":"a x #2","5.0-5.4":"a x #2","6.2-6.4":"a x #2","7.2-7.4":"a x #2","8.2":"a x #2","9.2":"a x #2","10.1":"a x #2","11.1-11.2":"a x #2","12.0":"a x #2"},"and_qq":{"10.4":"a x #2"},"baidu":{"7.12":"a #2"},"kaios":{"2.5":"a #1 #3"}},"notes":"Support refers to the `clip-path` CSS property on HTML elements specifically. Support for `clip-path` in SVG is supported in all browsers with [basic SVG](#feat=svg) support.","notes_by_num":{"1":"Partial support refers to only supporting the `url()` syntax.","2":"Partial support refers to supporting shapes and the `url(#foo)` syntax for inline SVG, but not shapes in external SVGs.","3":"Supports shapes behind the `layout.css.clip-path-shapes.enabled` flag","4":"Partial support can be enabled on MS Edge with the Enable CSS Clip-Path Flag","5":"While Edge doesn't seem to recognize any `<basic-shape>` function, it does allow you to use `polygon()` in HTML and SVG"},"usage_perc_y":3.71,"usage_perc_a":92.8,"ucprefix":false,"parent":"css-masks","keywords":"clippath","ie_id":"","chrome_id":"","firefox_id":"css-clip-path","webkit_id":""},"css-color-adjust":{"title":"CSS color-adjust","description":"The `color-adjust` (or `-webkit-print-color-adjust` as prefixed in WebKit/Blink browsers) property is a non-standard CSS extension that can be used to force printing of background colors and images.","spec":"https://drafts.csswg.org/css-color-adjust-1/#propdef-color-adjust","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/-webkit-print-color-adjust","title":"MDN web docs - -webkit-print-color-adjust"},{"url":"https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12399195/","title":"Edge issue with color-adjust"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=131054","title":"Chromium bug with color-adjust property"},{"url":"https://codepen.io/yuriyalekseyev/pen/XEpJLr","title":"Codepen demo of color-adjust usage"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y x","80":"y x","81":"y x","83":"y x","84":"y x","85":"y x","86":"y x","87":"y x"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"u","16":"u","17":"u","18":"u","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","59":"y x","60":"y x","61":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y x","70":"y x","71":"y x","72":"y x","73":"y x","74":"y x","75":"y x","76":"y x","77":"y x","78":"y x","79":"y x","80":"y x","81":"y x","83":"y x","84":"y x","85":"y x","86":"y x","87":"y x","88":"y x","89":"y x","90":"y x"},"safari":{"4":"n","5":"n","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","3.1":"n","3.2":"n","5.1":"n","6.1":"y x","7.1":"y x","9.1":"y x","10.1":"y x","11.1":"y x","12.1":"y x","13.1":"y x","TP":"y x"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","60":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y x","70":"y x","71":"y x","72":"y x","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"u","14":"u","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"u","6.0-6.1":"u","7.0-7.1":"u","8.1-8.4":"u","9.0-9.2":"u","9.3":"u","10.0-10.2":"u","10.3":"u","11.0-11.2":"u","11.3-11.4":"u","12.0-12.1":"u","12.2-12.4":"u","13.0-13.1":"u","13.2":"u","13.3":"u","13.4-13.7":"u"},"op_mini":{"all":"n"},"android":{"3":"u","4":"u","81":"u","2.1":"u","2.2":"u","2.3":"u","4.1":"u","4.2-4.3":"u","4.4":"u","4.4.3-4.4.4":"u"},"bb":{"7":"u","10":"u"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"u"},"and_ff":{"82":"y"},"ie_mob":{"10":"u","11":"u"},"and_uc":{"12.12":"u"},"samsung":{"4":"u","5.0-5.4":"u","6.2-6.4":"u","7.2-7.4":"u","8.2":"u","9.2":"u","10.1":"u","11.1-11.2":"u","12.0":"u"},"and_qq":{"10.4":"y x"},"baidu":{"7.12":"u"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":45.7,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"color-adjust,print-color-adjust,color adjust,print color adjust,coloradjust,printcoloradjust","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-color-function":{"title":"CSS color function","description":"The CSS `color()` function allows the browser to display colors in any color space, such as the P3 color space which can display colors outside of the default sRGB color space.","spec":"https://drafts.csswg.org/css-color/#color-function","status":"wd","links":[{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=1068610","title":"Chromium implementation bug"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1128204","title":"Firefox implementation bug"},{"url":"https://webkit.org/blog/10042/wide-gamut-color-in-css-with-display-p3/","title":"WebKit article on using color() with the P3 color space"},{"url":"https://p3colorpicker.cool/","title":"Color generator that uses color() with the P3 color space"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"For this function to work properly, the device screen and OS also needs to support the color space being used.","notes_by_num":{},"usage_perc_y":15.98,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"color(),Display-P3,A98-RGB,ProPhoto-RGB,REC-2020,Device-Dependent Colors,Profiled Colors,@color-profile,color space","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-conic-gradients":{"title":"CSS Conical Gradients","description":"Method of defining a conical or repeating conical color gradient as a CSS image.","spec":"https://www.w3.org/TR/css-images-4/#conic-gradients","status":"wd","links":[{"url":"https://leaverou.github.io/conic-gradient/","title":"Client-side polyfill"},{"url":"https://github.com/jonathantneal/postcss-conic-gradient","title":"Server-side polyfill (PostCSS)"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/8471413-implement-conic-gradients-from-css-image-values-le","title":"Microsoft Edge feature request on UserVoice"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1175958","title":"Mozilla bug #1175958: Implement conic gradients from CSS Image Values Level 4"},{"url":"https://developer.mozilla.org/docs/Web/CSS/conic-gradient","title":"MDN Web Docs - conic-gradient()"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n d #3","76":"n d #3","77":"n d #3","78":"n d #3","79":"n d #3","80":"n d #3","81":"n d #3","82":"n d #3","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n d #1","60":"n d #1","61":"n d #1","62":"n d #1","63":"n d #1","64":"n d #1","65":"n d #1","66":"n d #1","67":"n d #1","68":"n d #1","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n d #1","47":"n d #1","48":"n d #1","49":"n d #1","50":"n d #1","51":"n d #1","52":"n d #1","53":"n d #1","54":"n d #1","55":"n d #1","56":"n d #1","57":"n d #1","58":"n d #1","60":"n d #1","62":"n d #1","63":"n d #1","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n d #3"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Can be enabled via the \"Experimental Web Platform Features\" flag","2":"Does not support multi-position color stops","3":"Can be enabled with the `layout.css.conic-gradient.enabled` flag"},"usage_perc_y":87.79,"usage_perc_a":0,"ucprefix":false,"parent":"css-gradients","keywords":"conical-gradient,repeating-conical-gradient,gradient,conical","ie_id":"conicgradients","chrome_id":"5706155347148800","firefox_id":"","webkit_id":"feature-conic-gradients"},"css-containment":{"title":"CSS Containment","description":"The CSS `contain` property lets developers limit the scope of the browser's styles, layout and paint work for faster and more efficient rendering.","spec":"https://www.w3.org/TR/css-contain-1/#contain-property","status":"rec","links":[{"url":"https://developers.google.com/web/updates/2016/06/css-containment","title":"Google Developers article"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n d #1","42":"n d #1","43":"n d #1","44":"n d #1","45":"n d #1","46":"n d #1","47":"n d #1","48":"n d #1","49":"n d #1","50":"n d #1","51":"n d #1","52":"n d #1","53":"n d #1","54":"n d #1","55":"n d #1","56":"n d #1","57":"n d #1","58":"n d #1","59":"n d #1","60":"n d #1","61":"n d #1","62":"n d #1","63":"n d #1","64":"n d #1","65":"n d #1","66":"n d #1","67":"n d #1","68":"n d #1","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n d","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n d","39":"n d","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n d #1"}},"notes":"","notes_by_num":{"1":"Can be enabled in older Gecko engines with the `layout.css.contain.enabled` flag in about:config","2":"Partially supported in Firefox by enabling \"layout.css.contain.enabled\" in about:config"},"usage_perc_y":78.42,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"csscontainment","chrome_id":"6522186978295808","firefox_id":"","webkit_id":""},"css-content-visibility":{"title":"CSS content-visibility","description":"Provides control over when elements are rendered, so rendering can be skipped for elements not yet in the user's viewport. ","spec":"https://www.w3.org/TR/css-contain-2/#content-visibility","status":"wd","links":[{"url":"https://web.dev/content-visibility/","title":"content-visibility: the new CSS property that boosts your rendering performance"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1660384","title":"Firefox support bug"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"u"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":67.4,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"4613920211861504","firefox_id":"","webkit_id":""},"css-counters":{"title":"CSS Counters","description":"Method of controlling number values in generated content, using the `counter-reset` and `counter-increment` properties.","spec":"https://www.w3.org/TR/CSS21/generate.html#counters","status":"rec","links":[{"url":"http://onwebdev.blogspot.com/2012/02/css-counters-tutorial.html","title":"Tutorial and information"},{"url":"https://developer.mozilla.org/en/CSS_Counters","title":"MDN Web Docs - CSS Counters"},{"url":"https://www.webplatform.org/docs/css/properties/counter-reset","title":"WebPlatform Docs"}],"categories":["CSS2"],"stats":{"ie":{"6":"n","7":"n","8":"y","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":99.67,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-crisp-edges":{"title":"Crisp edges/pixelated images","description":"Scales images with an algorithm that preserves edges and contrast, without smoothing colors or introducing blur. This is intended for images such as pixel art. Official values that accomplish this for the `image-rendering` property are `crisp-edges` and `pixelated`.","spec":"https://drafts.csswg.org/css-images-3/#valdef-image-rendering-crisp-edges","status":"unoff","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/image-rendering","title":"MDN Web Docs - CSS Image rendering"},{"url":"http://updates.html5rocks.com/2015/01/pixelated","title":"HTML5Rocks article"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=856337","title":"Firefox bug #856337: Implement image-rendering: pixelated"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=317991","title":"Chrome bug #317991: Implement image-rendering:crisp-edges"}],"categories":["CSS","CSS3"],"stats":{"ie":{"6":"n","7":"a x #2 #5","8":"a x #2 #5","9":"a x #2 #5","10":"a x #2 #5","11":"a x #2 #5","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y #4","80":"y #4","81":"y #4","83":"y #4","84":"y #4","85":"y #4","86":"y #4","87":"y #4"},"firefox":{"2":"n","3":"n","4":"y x #3","5":"y x #3","6":"y x #3","7":"y x #3","8":"y x #3","9":"y x #3","10":"y x #3","11":"y x #3","12":"y x #3","13":"y x #3","14":"y x #3","15":"y x #3","16":"y x #3","17":"y x #3","18":"y x #3","19":"y x #3","20":"y x #3","21":"y x #3","22":"y x #3","23":"y x #3","24":"y x #3","25":"y x #3","26":"y x #3","27":"y x #3","28":"y x #3","29":"y x #3","30":"y x #3","31":"y x #3","32":"y x #3","33":"y x #3","34":"y x #3","35":"y x #3","36":"y x #3","37":"y x #3","38":"y x #3","39":"y x #3","40":"y x #3","41":"y x #3","42":"y x #3","43":"y x #3","44":"y x #3","45":"y x #3","46":"y x #3","47":"y x #3","48":"y x #3","49":"y x #3","50":"y x #3","51":"y x #3","52":"y x #3","53":"y x #3","54":"y x #3","55":"y x #3","56":"y x #3","57":"y x #3","58":"y x #3","59":"y x #3","60":"y x #3","61":"y x #3","62":"y x #3","63":"y x #3","64":"y x #3","65":"y #3","66":"y #3","67":"y #3","68":"y #3","69":"y #3","70":"y #3","71":"y #3","72":"y #3","73":"y #3","74":"y #3","75":"y #3","76":"y #3","77":"y #3","78":"y #3","79":"y #3","80":"y #3","81":"y #3","82":"y #3","83":"y #3","84":"y #3","85":"y #3","3.5":"n","3.6":"y x #3"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"y #4","42":"y #4","43":"y #4","44":"y #4","45":"y #4","46":"y #4","47":"y #4","48":"y #4","49":"y #4","50":"y #4","51":"y #4","52":"y #4","53":"y #4","54":"y #4","55":"y #4","56":"y #4","57":"y #4","58":"y #4","59":"y #4","60":"y #4","61":"y #4","62":"y #4","63":"y #4","64":"y #4","65":"y #4","66":"y #4","67":"y #4","68":"y #4","69":"y #4","70":"y #4","71":"y #4","72":"y #4","73":"y #4","74":"y #4","75":"y #4","76":"y #4","77":"y #4","78":"y #4","79":"y #4","80":"y #4","81":"y #4","83":"y #4","84":"y #4","85":"y #4","86":"y #4","87":"y #4","88":"y #4","89":"y #4","90":"y #4"},"safari":{"4":"n","5":"n","6":"a x #1","7":"a x #3 #6","8":"a x #3 #6","9":"a x #3 #6","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"a x #3 #6","7.1":"a x #3 #6","9.1":"a x #3 #6","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"y x #3","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"y #4","29":"y #4","30":"y #4","31":"y #4","32":"y #4","33":"y #4","34":"y #4","35":"y #4","36":"y #4","37":"y #4","38":"y #4","39":"y #4","40":"y #4","41":"y #4","42":"y #4","43":"y #4","44":"y #4","45":"y #4","46":"y #4","47":"y #4","48":"y #4","49":"y #4","50":"y #4","51":"y #4","52":"y #4","53":"y #4","54":"y #4","55":"y #4","56":"y #4","57":"y #4","58":"y #4","60":"y #4","62":"y #4","63":"y #4","64":"y #4","65":"y #4","66":"y #4","67":"y #4","68":"y #4","69":"y #4","70":"y #4","71":"y #4","72":"y #4","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"y x #3","12.1":"y x #3"},"ios_saf":{"8":"a x #3 #6","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"a x #1 #6","6.0-6.1":"a x #1 #6","7.0-7.1":"a x #3 #6","8.1-8.4":"a x #3 #6","9.0-9.2":"a x #3 #6","9.3":"a x #3 #6","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y #4","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"a x #1 #6"},"op_mob":{"10":"n","11":"n","12":"y x #3","59":"y #4","11.1":"n","11.5":"n","12.1":"y x #3"},"and_chr":{"86":"y #4"},"and_ff":{"82":"y x #3"},"ie_mob":{"10":"a x #2 #5","11":"a x #2 #5"},"and_uc":{"12.12":"y"},"samsung":{"4":"y #4","5.0-5.4":"y #4","6.2-6.4":"y #4","7.2-7.4":"y #4","8.2":"y #4","9.2":"y #4","10.1":"y #4","11.1-11.2":"y #4","12.0":"y #4"},"and_qq":{"10.4":"y #4"},"baidu":{"7.12":"y #4"},"kaios":{"2.5":"y #6"}},"notes":"Note that prefixes apply to the value (e.g. `-moz-crisp-edges`), not the `image-rendering` property.","notes_by_num":{"1":"Supported using the non-standard value `-webkit-optimize-contrast`","2":"Internet Explorer accomplishes support using the non-standard declaration `-ms-interpolation-mode: nearest-neighbor`","3":"Supports the `crisp-edges` value, but not `pixelated`.","4":"Supports the `pixelated` value, but not `crisp-edges`.","5":"Only works on `<img>`, not CSS backgrounds or `<canvas>`.","6":"Only works on `<img>` and CSS backgrounds, _not_ `<canvas>`. "},"usage_perc_y":95.82,"usage_perc_a":1.88,"ucprefix":false,"parent":"","keywords":"image-rendering,crisp-edges","ie_id":"imagerendering","chrome_id":"5118058116939776","firefox_id":"","webkit_id":""},"css-cross-fade":{"title":"CSS Cross-Fade Function","description":"Image function to create a \"crossfade\" between images. This allows one image to transition (fade) into another based on a percentage value.","spec":"https://drafts.csswg.org/css-images-4/#cross-fade-function","status":"cr","links":[{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=546052","title":"Firefox bug #546052: Implement cross-fade()"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y x","80":"y x","81":"y x","83":"y x","84":"y x","85":"y x","86":"y x","87":"y x"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","59":"y x","60":"y x","61":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y x","70":"y x","71":"y x","72":"y x","73":"y x","74":"y x","75":"y x","76":"y x","77":"y x","78":"y x","79":"y x","80":"y x","81":"y x","83":"y x","84":"y x","85":"y x","86":"y x","87":"y x","88":"y x","89":"y x","90":"y x"},"safari":{"4":"n","5":"n","6":"y x","7":"y x","8":"y x","9":"y x","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y x","6.1":"y x","7.1":"y x","9.1":"y x","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","60":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y x","70":"y x","71":"y x","72":"y x","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y x","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y x","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y x","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y x"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y x"},"samsung":{"4":"y x","5.0-5.4":"y x","6.2-6.4":"y x","7.2-7.4":"y x","8.2":"y x","9.2":"y x","10.1":"y x","11.1-11.2":"y x","12.0":"y x"},"and_qq":{"10.4":"y x"},"baidu":{"7.12":"y x"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":92.5,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"css,image,crossfade","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-default-pseudo":{"title":":default CSS pseudo-class","description":"The `:default` pseudo-class matches checkboxes and radio buttons which are checked by default, `<option>`s with the `selected` attribute, and the default submit button (if any) of a form.","spec":"https://drafts.csswg.org/selectors-4/#the-default-pseudo","status":"unoff","links":[{"url":"https://html.spec.whatwg.org/multipage/scripting.html#selector-default","title":"HTML specification for `:default`"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/:default","title":"MDN Web Docs - CSS :default"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/13311459--default-pseudo-class-from-selectors-level-4","title":"MS Edge feature request on UserVoice"},{"url":"http://jsbin.com/hiyada/edit?html,css,output","title":"JS Bin testcase"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=156230","title":"WebKit bug 156230 - `:default` CSS pseudo-class should match checkboxes+radios with a `checked` attribute"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"u","3":"u","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"u","3.6":"u"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"u","5":"u","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"u","5.1":"a #1","6.1":"a #1","7.1":"a #1","9.1":"a #1","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"u","12":"a #2","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"u","10.0-10.1":"u","10.5":"u","10.6":"u","11.1":"u","11.5":"u","11.6":"a #2","12.1":"a #2"},"ios_saf":{"8":"a #1","14":"y","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"u","6.0-6.1":"u","7.0-7.1":"a #1","8.1-8.4":"a #1","9.0-9.2":"a #1","9.3":"a #1","10.0-10.2":"a #1","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"a #2"},"android":{"3":"u","4":"a #1","81":"y","2.1":"u","2.2":"u","2.3":"u","4.1":"a #1","4.2-4.3":"a #1","4.4":"a #1","4.4.3-4.4.4":"a #1"},"bb":{"7":"u","10":"a #1"},"op_mob":{"10":"u","11":"u","12":"u","59":"y","11.1":"u","11.5":"u","12.1":"a #2"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"a #1"},"samsung":{"4":"a #1","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"Whether `<option selected>` matches `:default` (per the spec) was not tested since `<select>`s and `<option>`s are generally not styleable, which makes it hard to formulate a test for this.","notes_by_num":{"1":"Does not match `<input type=\"checkbox\" checked>` or `<input type=\"radio\" checked>`","2":"Does not match the default submit button of a form"},"usage_perc_y":93.88,"usage_perc_a":3.78,"ucprefix":false,"parent":"","keywords":":default,default","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-descendant-gtgt":{"title":"Explicit descendant combinator >>","description":"An explicit, non-whitespace spelling of the descendant combinator. `A >> B` is equivalent to `A B`.","spec":"https://drafts.csswg.org/selectors-4/#descendant-combinators","status":"unoff","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/Descendant_selectors","title":"MDN Web Docs - Descendant selectors"},{"url":"http://jsbin.com/qipekof/edit?html,css,output","title":"JS Bin testcase"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=446050","title":"Chrome issue #446050: Implement Descendant Combinator \">>\""},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1266283","title":"Mozilla bug #1266283 - Implement CSS4 descendant combinator `>>`"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"u","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"u","89":"u","90":"u"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":0.01,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-deviceadaptation":{"title":"CSS Device Adaptation","description":"A standard way to override the size of viewport in web page using the `@viewport` rule, standardizing and replacing Apple's own popular `<meta>` viewport implementation.","spec":"https://www.w3.org/TR/css-device-adapt/","status":"wd","links":[{"url":"https://dev.opera.com/articles/view/an-introduction-to-meta-viewport-and-viewport/","title":"Introduction to meta viewport and @viewport in Opera Mobile"},{"url":"http://msdn.microsoft.com/en-us/library/ie/hh708740(v=vs.85).aspx","title":"Device adaptation in Internet Explorer 10"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6777420-unprefix-and-support-all-viewport-properties","title":"Microsoft Edge feature request on UserVoice"},{"url":"https://code.google.com/p/chromium/issues/detail?id=155477","title":"Chrome tracking bug"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=95959","title":"WebKit tracking bug"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=747754","title":"Mozilla tracking bug"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"a x #1","11":"a x #1","5.5":"n"},"edge":{"12":"a x #1","13":"a x #1","14":"a x #1","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","79":"n d","80":"n d","81":"n d","83":"n d","84":"n d","85":"n d","86":"n d","87":"n d"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n d","30":"n d","31":"n d","32":"n d","33":"n d","34":"n d","35":"n d","36":"n d","37":"n d","38":"n d","39":"n d","40":"n d","41":"n d","42":"n d","43":"n d","44":"n d","45":"n d","46":"n d","47":"n d","48":"n d","49":"n d","50":"n d","51":"n d","52":"n d","53":"n d","54":"n d","55":"n d","56":"n d","57":"n d","58":"n d","59":"n d","60":"n d","61":"n d","62":"n d","63":"n d","64":"n d","65":"n d","66":"n d","67":"n d","68":"n d","69":"n d","70":"n d","71":"n d","72":"n d","73":"n d","74":"n d","75":"n d","76":"n d","77":"n d","78":"n d","79":"n d","80":"n d","81":"n d","83":"n d","84":"n d","85":"n d","86":"n d","87":"n d","88":"n d","89":"n d","90":"n d"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n d","41":"n d","42":"n d","43":"n d","44":"n d","45":"n d","46":"n d","47":"n d","48":"n d","49":"n d","50":"n d","51":"n d","52":"n d","53":"n d","54":"n d","55":"n d","56":"n d","57":"n d","58":"n d","60":"n d","62":"n d","63":"n d","64":"n d","65":"n d","66":"n d","67":"n d","68":"n d","69":"n d","70":"n d","71":"n d","72":"n d","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"a x #2"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"a x #2","12":"a x #2","59":"n","11.1":"a x #2","11.5":"a x #2","12.1":"a x #2"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"a x #1","11":"a x #1"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n d"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"IE only supports the 'width' and 'height' properties.","2":"Opera Mobile and Opera Mini only support the 'orientation' property."},"usage_perc_y":0,"usage_perc_a":2.41,"ucprefix":false,"parent":"","keywords":"viewport","ie_id":"cssdeviceadaptation","chrome_id":"4737164243894272","firefox_id":"","webkit_id":""},"css-dir-pseudo":{"title":":dir() CSS pseudo-class","description":"Matches elements based on their directionality. `:dir(ltr)` matches elements which are Left-to-Right. `:dir(rtl)` matches elements which are Right-to-Left.","spec":"https://www.w3.org/TR/selectors4/#the-dir-pseudo","status":"wd","links":[{"url":"https://html.spec.whatwg.org/multipage/scripting.html#selector-ltr","title":"HTML specification for `:dir()`"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/:dir","title":"MDN Web Docs - CSS :dir"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=576815","title":"Chrome issue #576815: CSS4 pseudo-class :dir()"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/12299532--dir","title":"Microsoft Edge feature request on UserVoice"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=64861","title":"WebKit bug #64861: Need support for :dir() pseudo-class"},{"url":"http://jsbin.com/celuye/edit?html,css,output","title":"JS Bin testcase"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y x"}},"notes":"","notes_by_num":{},"usage_perc_y":4.12,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":":dir,dir,direction,ltr,rtl,left,right","ie_id":"","chrome_id":"5751531651465216","firefox_id":"","webkit_id":""},"css-display-contents":{"title":"CSS display: contents","description":"`display: contents` causes an element's children to appear as if they were direct children of the element's parent, ignoring the element itself. This can be useful when a wrapper element should be ignored when using CSS grid or similar layout techniques.","spec":"https://drafts.csswg.org/css-display/","status":"wd","links":[{"url":"https://rachelandrew.co.uk/archives/2016/01/29/vanishing-boxes-with-display-contents/","title":"Vanishing boxes with display contents"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=657748","title":"Chrome support bug"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=157477","title":"WebKit support bug"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/10938981-implement-the-box-generation-keywords-from-css-dis","title":"Edge UserVoice support request"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"a #2","80":"a #2","81":"a #2","83":"a #2","84":"a #2","85":"a #2","86":"a #2","87":"a #2"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"a #2","38":"a #2","39":"a #2","40":"a #2","41":"a #2","42":"a #2","43":"a #2","44":"a #2","45":"a #2","46":"a #2","47":"a #2","48":"a #2","49":"a #2","50":"a #2","51":"a #2","52":"a #2","53":"a #2","54":"a #2","55":"a #2","56":"a #2","57":"a #2","58":"a #2","59":"a #2","60":"a #2","61":"a #2","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n d #1","59":"n d #1","60":"n d #1","61":"n d #1","62":"n d #1","63":"n d #1","64":"n d #1","65":"a #2","66":"a #2","67":"a #2","68":"a #2","69":"a #2","70":"a #2","71":"a #2","72":"a #2","73":"a #2","74":"a #2","75":"a #2","76":"a #2","77":"a #2","78":"a #2","79":"a #2","80":"a #2","81":"a #2","83":"a #2","84":"a #2","85":"a #2","86":"a #2","87":"a #2","88":"a #2","89":"a #2","90":"a #2"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"a #2 #3","13":"a #2","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"a #2 #3","12.1":"a #2 #3","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"a #2","53":"a #2","54":"a #2","55":"a #2","56":"a #2","57":"a #2","58":"a #2","60":"a #2","62":"a #2","63":"a #2","64":"a #2","65":"a #2","66":"a #2","67":"a #2","68":"a #2","69":"a #2","70":"a #2","71":"a #2","72":"a #2","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"a #2","12.0-12.1":"a #2","12.2-12.4":"a #2","13.0-13.1":"a #2","13.2":"a #2","13.3":"a #2","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"a #2","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"a #2","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a #2"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"a #2","10.1":"a #2","11.1-11.2":"a #2","12.0":"a #2"},"and_qq":{"10.4":"a #2"},"baidu":{"7.12":"n"},"kaios":{"2.5":"a #2"}},"notes":"","notes_by_num":{"1":"Enabled in Chrome through the \"experimental Web Platform features\" flag in chrome://flags","2":"Partial support refers to [severe implementation bug](https://hiddedevries.nl/en/blog/2018-04-21-more-accessible-markup-with-display-contents) that renders the content inaccessible.","3":"Safari support is buggy, see [WebKit bug 188259](https://bugs.webkit.org/show_bug.cgi?id=188259) & [WebKit bug 193567](https://bugs.webkit.org/show_bug.cgi?id=193567)"},"usage_perc_y":15.61,"usage_perc_a":77.16,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"5663606012116992","firefox_id":"","webkit_id":""},"css-element-function":{"title":"CSS element() function","description":"This function renders a live image generated from an arbitrary HTML element","spec":"https://www.w3.org/TR/css4-images/#element-notation","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/element","title":"MDN Web Docs - CSS element"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"a x #1","3":"a x #1","4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","59":"y x","60":"y x","61":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y x","70":"y x","71":"y x","72":"y x","73":"y x","74":"y x","75":"y x","76":"y x","77":"y x","78":"y x","79":"y x","80":"y x","81":"y x","82":"y x","83":"y x","84":"y x","85":"y x","3.5":"a x #1","3.6":"a x #1"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"y x"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y x"}},"notes":"","notes_by_num":{"1":"In Firefox < 4, usage limited to the background and background-image CSS properties"},"usage_perc_y":4.21,"usage_perc_a":0.02,"ucprefix":false,"parent":"","keywords":"element, function","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-env-function":{"title":"CSS Environment Variables env()","description":"Usage of environment variables like `safe-area-inset-top`.","spec":"https://drafts.csswg.org/css-env-1/#env-function","status":"unoff","links":[{"url":"https://jsfiddle.net/mrd3h90w/","title":"JSFiddle test case"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/env","title":"The env() CSS Function - MDN Web Docs"},{"url":"https://webkit.org/blog/7929/designing-websites-for-iphone-x/","title":"Designing Websites for iPhone X - WebKit Blog"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/34589707-css-environment-variables","title":"Microsoft Edge feature suggestion"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"a #1","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"a #1","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Supported as `constant()` instead of `env()`"},"usage_perc_y":91.92,"usage_perc_a":0.12,"ucprefix":false,"parent":"","keywords":"css env(),css constant(),css variables,safe-area-inset-top,safe-area-inset-right,safe-area-inset-bottom,safe-area-inset-left","ie_id":"","chrome_id":"5710044637167616","firefox_id":"","webkit_id":""},"css-exclusions":{"title":"CSS Exclusions Level 1","description":"Exclusions defines how inline content flows around elements. It extends the content wrapping ability of floats to any block-level element.","spec":"https://www.w3.org/TR/css3-exclusions/","status":"wd","links":[{"url":"https://msdn.microsoft.com/en-us/library/ie/hh673558(v=vs.85).aspx","title":"CSS Exclusions"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=674804","title":"Firefox tracking bug"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=57311","title":"WebKit tracking bug"},{"url":"https://crbug.com/700838","title":"Chromium tracking bug"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y x","11":"y x","5.5":"n"},"edge":{"12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"y x","11":"y x"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":1.53,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"floats,exclusions,wrap-flow,wrap-through","ie_id":"exclusions","chrome_id":"","firefox_id":"","webkit_id":""},"css-featurequeries":{"title":"CSS Feature Queries","description":"CSS Feature Queries allow authors to condition rules based on whether particular property declarations are supported in CSS using the @supports at rule.","spec":"https://www.w3.org/TR/css3-conditional/#at-supports","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/@supports","title":"MDN Web Docs - CSS @supports"},{"url":"https://mcc.id.au/blog/2012/08/supports","title":"@supports in Firefox"},{"url":"https://dabblet.com/gist/3895764","title":"Test case"},{"url":"https://www.webplatform.org/docs/css/atrules/@supports","title":"WebPlatform Docs"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"y"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"See also the [CSS.supports() DOM API](#feat=css-supports-api)","notes_by_num":{},"usage_perc_y":97.56,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"supports,conditional","ie_id":"conditionalrules","chrome_id":"4993981813358592","firefox_id":"","webkit_id":""},"css-filter-function":{"title":"CSS filter() function","description":"This function filters a CSS input image with a set of filter functions (like blur, grayscale or hue)","spec":"https://www.w3.org/TR/filter-effects/#FilterCSSImageValue","status":"wd","links":[{"url":"http://iamvdo.me/en/blog/advanced-css-filters#filter","title":"Blog post"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1191043","title":"Firefox support bug"},{"url":"https://crbug.com/541698","title":"Chromium support bug"}],"categories":["CSS","CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"y x","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":16.41,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"filter, function","ie_id":"cssfilterimagefunction","chrome_id":"5425136400334848","firefox_id":"","webkit_id":""},"css-filters":{"title":"CSS Filter Effects","description":"Method of applying filter effects using the `filter` property to elements, matching filters available in SVG. Filter functions include blur, brightness, contrast, drop-shadow, grayscale, hue-rotate, invert, opacity, sepia and saturate.","spec":"https://www.w3.org/TR/filter-effects-1/","status":"wd","links":[{"url":"http://html5-demos.appspot.com/static/css/filters/index.html","title":"Demo file for WebKit browsers"},{"url":"https://www.html5rocks.com/en/tutorials/filters/understanding-css/","title":"HTML5Rocks article"},{"url":"http://web.archive.org/web/20160219005748/https://dl.dropboxusercontent.com/u/3260327/angular/CSS3ImageManipulation.html","title":"Filter editor"},{"url":"http://web.archive.org/web/20160310041612/http://bennettfeely.com/filters/","title":"Filter Playground"}],"categories":["CSS","CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n d #2 #4","13":"a #4","14":"a #4","15":"a #4","16":"a #4","17":"a #4","18":"a #4","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a #3","5":"a #3","6":"a #3","7":"a #3","8":"a #3","9":"a #3","10":"a #3","11":"a #3","12":"a #3","13":"a #3","14":"a #3","15":"a #3","16":"a #3","17":"a #3","18":"a #3","19":"a #3","20":"a #3","21":"a #3","22":"a #3","23":"a #3","24":"a #3","25":"a #3","26":"a #3","27":"a #3","28":"a #3","29":"a #3","30":"a #3","31":"a #3","32":"a #3","33":"a #3","34":"a d #1","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"a #3"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y x","7":"y x","8":"y x","9":"y x","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y x","7.1":"y x","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"n","10":"y x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y x","5.0-5.4":"y x","6.2-6.4":"y x","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Note that this property is significantly different from and incompatible with Microsoft's [older \"filter\" property](http://msdn.microsoft.com/en-us/library/ie/ms530752%28v=vs.85%29.aspx).","notes_by_num":{"1":"Supported in Firefox under the `layout.css.filters.enabled` flag.","2":"Supported in MS Edge under the \"Enable CSS filter property\" flag.","3":"Partial support in Firefox before version 34 [only implemented the url() function of the filter property](https://developer.mozilla.org/en-US/docs/Web/CSS/filter#Browser_compatibility)","4":"Partial support refers to supporting filter functions, but not the `url` function."},"usage_perc_y":96.34,"usage_perc_a":0.6,"ucprefix":false,"parent":"","keywords":"filter:","ie_id":"filters","chrome_id":"5822463824887808","firefox_id":"","webkit_id":""},"css-first-letter":{"title":"::first-letter CSS pseudo-element selector","description":"CSS pseudo-element that allows styling only the first \"letter\" of text within an element. Useful for implementing initial caps or drop caps styling.","spec":"https://www.w3.org/TR/css3-selectors/#first-letter","status":"rec","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/::first-letter","title":"MDN Web Docs - :first-letter"}],"categories":["CSS"],"stats":{"ie":{"6":"a #3 #4","7":"a #3 #4","8":"a #3","9":"y","10":"y","11":"y","5.5":"u"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"a #2","3":"a #1","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"a #1","5":"u","6":"u","7":"u","8":"u","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a #1","5":"u","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"a #1","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"a #2","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"u","10.0-10.1":"a #2","10.5":"a #2","10.6":"a #2","11.1":"a #2","11.5":"a #2","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"u","2.2":"u","2.3":"a #1","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"a #2","11":"a #2","12":"y","59":"y","11.1":"a #2","11.5":"a #2","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"The spec says that both letters of digraphs which are always capitalized together (such as \"IJ\" in Dutch) should be matched by ::first-letter, but no browser has ever implemented this.","notes_by_num":{"1":"Excludes punctuation immediately after the first letter from the match. (The spec says it should be included in the match.)","2":"Acts like the first character is always a letter even when it's not. For example, given \"!,X;\", \"!,\" is matched instead of the entire string.","3":"Only recognizes the deprecated :first-letter pseudo-class, not the ::first-letter pseudo-element.","4":"Only matches the very first character. The spec says that surrounding punctuation should also match."},"usage_perc_y":99.48,"usage_perc_a":0.15,"ucprefix":false,"parent":"","keywords":"first,letter,pseudo,element,class,selector","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-first-line":{"title":"CSS first-line pseudo-element","description":"Allows styling specifically for the first line of text using the `::first-line` pseudo-element. Note that only a limited set of properties can be applied.","spec":"https://drafts.csswg.org/selectors-3/#first-line","status":"rec","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/::first-line","title":"MDN Web Docs - ::first-line"},{"url":"https://css-tricks.com/almanac/selectors/f/first-line/","title":"CSS tricks article"}],"categories":["CSS3"],"stats":{"ie":{"6":"a #1","7":"a #1","8":"a #1","9":"y","10":"y","11":"y","5.5":"a #1"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"IE8 only supports the single-colon CSS 2.1 syntax (i.e. `:first-line`). It does not support the double-colon CSS3 syntax (i.e. `::first-line`)."},"usage_perc_y":99.61,"usage_perc_a":0.09,"ucprefix":false,"parent":"css-sel3","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-fixed":{"title":"CSS position:fixed","description":"Method of keeping an element in a fixed location regardless of scroll position","spec":"https://www.w3.org/TR/CSS21/visuren.html#fixed-positioning","status":"rec","links":[{"url":"http://www.css-101.org/fixed-positioning/05.php","title":"Workaround for IE6"},{"url":"http://bradfrostweb.com/blog/mobile/fixed-position/","title":"Article on mobile support"},{"url":"https://www.webplatform.org/docs/css/properties/position","title":"WebPlatform Docs"}],"categories":["CSS"],"stats":{"ie":{"6":"p","7":"y","8":"y","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y #4","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"a #1","6.0-6.1":"a #1","7.0-7.1":"a #1","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y #3","81":"y","2.1":"a #2","2.2":"a #2","2.3":"a #2","4.1":"y #3","4.2-4.3":"y #3","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support in older iOS Safari refers to [buggy behavior](http://remysharp.com/2012/05/24/issues-with-position-fixed-scrolling-on-ios/).","2":"Only works in Android 2.1 thru 2.3 by using the following meta tag: <meta name=\"viewport\" content=\"width=device-width, user-scalable=no\">.","3":"Android 4.0-4.3 [ignore transforms and margin:auto on position:fixed elements](https://codepen.io/mattiacci/pen/mPRKZY).","4":"in Safari 9.1, having a `position:fixed`-element inside an animated element, [may cause the `position:fixed`-element to not appear](https://jsbin.com/fuxipax)."},"usage_perc_y":98.75,"usage_perc_a":0.03,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-focus-visible":{"title":":focus-visible CSS pseudo-class","description":"The `:focus-visible` pseudo-class applies while an element matches the `:focus` pseudo-class, and the UA determines via heuristics that the focus should be specially indicated on the element (typically via a “focus ring”).","spec":"https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo","status":"unoff","links":[{"url":"https://github.com/WICG/focus-visible","title":"Prototype for `:focus-visible`"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=817199","title":"Chrome does not support CSS Selectors 4 :focus-visible"},{"url":"https://groups.google.com/a/chromium.org/forum/#!topic/blink-dev/-wN72ESFsyo","title":"Blink: Intent to implement :focus-visible pseudo class."},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/:-moz-focusring","title":"Mozilla Developer Network (MDN) documentation - :-moz-focusring"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/19594159--focus-visible","title":"Microsoft Edge implementation suggestion"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1437901","title":"Bugzilla: Add :focus-visible (former :focus-ring)"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=30523","title":"WebKit bug #140144: Add support for `-webkit-focusring` CSS pseudo class"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1445482","title":"Bugzilla: implement :focus-visible pseudo-class (rename/alias :-moz-focusring)"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"p d #2","80":"p d #2","81":"p d #2","83":"p d #2","84":"p d #2","85":"p d #2","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y x #1","5":"y x #1","6":"y x #1","7":"y x #1","8":"y x #1","9":"y x #1","10":"y x #1","11":"y x #1","12":"y x #1","13":"y x #1","14":"y x #1","15":"y x #1","16":"y x #1","17":"y x #1","18":"y x #1","19":"y x #1","20":"y x #1","21":"y x #1","22":"y x #1","23":"y x #1","24":"y x #1","25":"y x #1","26":"y x #1","27":"y x #1","28":"y x #1","29":"y x #1","30":"y x #1","31":"y x #1","32":"y x #1","33":"y x #1","34":"y x #1","35":"y x #1","36":"y x #1","37":"y x #1","38":"y x #1","39":"y x #1","40":"y x #1","41":"y x #1","42":"y x #1","43":"y x #1","44":"y x #1","45":"y x #1","46":"y x #1","47":"y x #1","48":"y x #1","49":"y x #1","50":"y x #1","51":"y x #1","52":"y x #1","53":"y x #1","54":"y x #1","55":"y x #1","56":"y x #1","57":"y x #1","58":"y x #1","59":"y x #1","60":"y x #1","61":"y x #1","62":"y x #1","63":"y x #1","64":"y x #1","65":"y x #1","66":"y x #1","67":"y x #1","68":"y x #1","69":"y x #1","70":"y x #1","71":"y x #1","72":"y x #1","73":"y x #1","74":"y x #1","75":"y x #1","76":"y x #1","77":"y x #1","78":"y x #1","79":"y x #1","80":"y x #1","81":"y x #1","82":"y x #1","83":"y x #1","84":"y x #1","85":"y x #1","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"p d #2","68":"p d #2","69":"p d #2","70":"p d #2","71":"p d #2","72":"p d #2","73":"p d #2","74":"p d #2","75":"p d #2","76":"p d #2","77":"p d #2","78":"p d #2","79":"p d #2","80":"p d #2","81":"p d #2","83":"p d #2","84":"p d #2","85":"p d #2","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"p d #2","67":"p d #2","68":"p d #2","69":"p d #2","70":"p d #2","71":"p d #2","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y x #1"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y x #1"}},"notes":"Previously drafted as `:focus-ring`","notes_by_num":{"1":"As `:-moz-focusring`","2":"Enabled through the \"Experimental Web Platform features\" flag in chrome://flags"},"usage_perc_y":57.59,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"focus,ring,focusring,focus-ring,visible,focus-visible,pseudo","ie_id":"","chrome_id":"5823526732824576","firefox_id":"","webkit_id":""},"css-focus-within":{"title":":focus-within CSS pseudo-class","description":"The `:focus-within` pseudo-class matches elements that either themselves match `:focus` or that have descendants which match `:focus`.","spec":"https://drafts.csswg.org/selectors-4/#the-focus-within-pseudo","status":"unoff","links":[{"url":"https://www.sitepoint.com/future-generation-css-selectors-level-4/#generalized-input-focus-pseudo-class-focus-within","title":"The Future Generation of CSS Selectors: Level 4: Generalized Input Focus Pseudo-class"},{"url":"http://allyjs.io/api/style/focus-within.html","title":"ally.style.focusWithin Polyfill, part of ally.js"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/11725071-implement-focus-within-from-selectors-4","title":"Microsoft Edge feature request on UserVoice"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=140144","title":"WebKit bug #140144: Add support for CSS4 `:focus-within` pseudo"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=617371","title":"Chromium issue #617371: Implement `:focus-within` pseudo-class from Selectors Level 4"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1176997","title":"Mozilla bug #1176997: Add support for pseudo class `:focus-within`"},{"url":"http://jsbin.com/qevoqa/edit?html,css,output","title":"JS Bin testcase"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-within","title":"MDN Web Docs - :focus-within"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n d #1","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n d #1","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"u"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Can be enabled via the \"Experimental Web Platform Features\" flag"},"usage_perc_y":93.21,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"focus,within,focus-within,pseudo","ie_id":"","chrome_id":"5363834508279808","firefox_id":"","webkit_id":"feature-css-selector-:focus-within"},"css-font-rendering-controls":{"title":"CSS font-rendering controls","description":"`@font-face` descriptor (currently defined as `font-display`) that allows control over how a downloadable font renders before it is fully loaded.","spec":"https://www.w3.org/TR/css-fonts-4/#font-display-desc","status":"wd","links":[{"url":"https://developers.google.com/web/updates/2016/02/font-display","title":"Google Developers article"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display","title":"MDN Web Docs - font-display"},{"url":"https://css-tricks.com/font-display-masses/","title":"CSS tricks article"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n d #1","47":"n d #1","48":"n d #1","49":"n d #1","50":"n d #1","51":"n d #1","52":"n d #1","53":"n d #1","54":"n d #1","55":"n d #1","56":"n d #1","57":"n d #1","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n d","50":"n d","51":"n d","52":"n d","53":"n d","54":"n d","55":"n d","56":"n d","57":"n d","58":"n d","59":"n d","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n d","37":"n d","38":"n d","39":"n d","40":"n d","41":"n d","42":"n d","43":"n d","44":"n d","45":"n d","46":"n d","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n d","6.2-6.4":"n d","7.2-7.4":"n d","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n d #1"}},"notes":"","notes_by_num":{"1":"Can be enabled via the `layout.css.font-display.enabled` flag"},"usage_perc_y":92.64,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"4799947908055040","firefox_id":"css-font-display","webkit_id":"specification-css-font-display"},"css-font-stretch":{"title":"CSS font-stretch","description":"If a font has multiple types of variations based on the width of characters, the `font-stretch` property allows the appropriate one to be selected. The property in itself does not cause the browser to stretch to a font.","spec":"https://www.w3.org/TR/css-fonts-3/#font-stretch-prop","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/font-stretch","title":"MDN Web Docs - font-stretch"},{"url":"https://css-tricks.com/almanac/properties/f/font-stretch/","title":"CSS Tricks article"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":85.16,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"font stretch","ie_id":"cssfontstretch","chrome_id":"4598830058176512","firefox_id":"","webkit_id":""},"css-gencontent":{"title":"CSS Generated content for pseudo-elements","description":"Method of displaying text or images before or after the given element's contents using the ::before and ::after pseudo-elements. All browsers with support also support the `attr()` notation in the `content` property. ","spec":"https://www.w3.org/TR/CSS21/generate.html","status":"rec","links":[{"url":"http://www.westciv.com/style_master/academy/css_tutorial/advanced/generated_content.html","title":"Guide on usage"},{"url":"https://dev.opera.com/articles/view/css-generated-content-techniques/","title":"Dev.Opera article"},{"url":"https://www.webplatform.org/docs/css/generated_and_replaced_content","title":"WebPlatform Docs"}],"categories":["CSS2","CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"a #1","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"For content to appear in pseudo-elements, the `content` property must be set (but may be an empty string).","notes_by_num":{"1":"IE8 only supports the single-colon CSS 2.1 syntax (i.e. :pseudo-class). It does not support the double-colon CSS3 syntax (i.e. ::pseudo-element)."},"usage_perc_y":99.61,"usage_perc_a":0.07,"ucprefix":false,"parent":"","keywords":"before,after","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-gradients":{"title":"CSS Gradients","description":"Method of defining a linear or radial color gradient as a CSS image.","spec":"https://www.w3.org/TR/css3-images/","status":"cr","links":[{"url":"http://www.colorzilla.com/gradient-editor/","title":"Cross-browser editor"},{"url":"http://css3pie.com/","title":"Tool to emulate support in IE"},{"url":"https://www.webplatform.org/docs/css/functions/linear-gradient","title":"WebPlatform Docs"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a x #2","5":"a x #2","6":"a x #2","7":"a x #2","8":"a x #2","9":"a x #2","10":"a x #2","11":"a x #2","12":"a x #2","13":"a x #2","14":"a x #2","15":"a x #2","16":"a #2","17":"a #2","18":"a #2","19":"a #2","20":"a #2","21":"a #2","22":"a #2","23":"a #2","24":"a #2","25":"a #2","26":"a #2","27":"a #2","28":"a #2","29":"a #2","30":"a #2","31":"a #2","32":"a #2","33":"a #2","34":"a #2","35":"a #2","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"a x #2"},"chrome":{"4":"a x #3","5":"a x #3","6":"a x #3","7":"a x #3","8":"a x #3","9":"a x #3","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a x #2 #3","5":"a x #2 #3","6":"a x #2","7":"a #2","8":"a #2","9":"a #2","10":"a #2","11":"a #2","12":"a #2","13":"a #2","14":"a #2","3.1":"n","3.2":"n","5.1":"a x #2","6.1":"a #2","7.1":"a #2","9.1":"a #2","10.1":"a #2","11.1":"a #2","12.1":"a #2","13.1":"a #2","TP":"a #2"},"opera":{"9":"n","11":"n","12":"y x","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"a x #1","11.5":"a x #1","11.6":"y x","12.1":"y"},"ios_saf":{"8":"a #2","14":"a #2","3.2":"a x #2 #3","4.0-4.1":"a x #2 #3","4.2-4.3":"a x #2 #3","5.0-5.1":"a x #2","6.0-6.1":"a x #2","7.0-7.1":"a #2","8.1-8.4":"a #2","9.0-9.2":"a #2","9.3":"a #2","10.0-10.2":"a #2","10.3":"a #2","11.0-11.2":"a #2","11.3-11.4":"a #2","12.0-12.1":"a #2","12.2-12.4":"a #2","13.0-13.1":"a #2","13.2":"a #2","13.3":"a #2","13.4-13.7":"a #2"},"op_mini":{"all":"n"},"android":{"3":"a x #3","4":"y x","81":"y","2.1":"a x #3","2.2":"a x #3","2.3":"a x #3","4.1":"y x","4.2-4.3":"y x","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"a x #3","10":"y"},"op_mob":{"10":"n","11":"n","12":"y x","59":"y","11.1":"a x #1","11.5":"a x #1","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Syntax used by browsers with prefixed support may be incompatible with that for proper support.\r\n\r\nSupport can be somewhat emulated in older IE versions using the non-standard \"gradient\" filter. \r\n\r\nFirefox 10+, Opera 11.6+, Chrome 26+ and IE10+ also support the new \"to (side)\" syntax.","notes_by_num":{"1":"Partial support in Opera 11.10 and 11.50 also refers to only having support for linear gradients.","2":"Partial support in Safari and Older Firefox versions refers to not using premultiplied colors which results in unexpected behavior when using the transparent keyword as advised by the [spec](https://www.w3.org/TR/2012/CR-css3-images-20120417/#color-stop-syntax).","3":"Implements an earlier prefixed syntax as `-webkit-gradient`"},"usage_perc_y":81.51,"usage_perc_a":16.94,"ucprefix":false,"parent":"","keywords":"linear,linear-gradient,gradiant","ie_id":"gradients","chrome_id":"5785905063264256","firefox_id":"","webkit_id":""},"css-grid":{"title":"CSS Grid Layout (level 1)","description":"Method of using a grid concept to lay out content, providing a mechanism for authors to divide available space for layout into columns and rows using a set of predictable sizing behaviors. Includes support for all `grid-*` properties and the `fr` unit.","spec":"https://www.w3.org/TR/css-grid-1/","status":"cr","links":[{"url":"https://github.com/codler/Grid-Layout-Polyfill","title":"Polyfill based on old spec"},{"url":"https://github.com/FremyCompany/css-grid-polyfill/","title":"Polyfill based on new spec"},{"url":"https://webkit.org/blog/7434/css-grid-layout-a-new-layout-module-for-the-web/","title":"WebKit Blog post"},{"url":"https://gridbyexample.com/","title":"Css Grid By Example: Everything you need to learn CSS Grid Layout"},{"url":"https://mozilladevelopers.github.io/playground/css-grid","title":"Mozilla: Introduction to CSS Grid Layout"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"p","10":"a x #2","11":"a x #2","5.5":"n"},"edge":{"12":"a x #2","13":"a x #2","14":"a x #2","15":"a x #2","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"p","20":"p","21":"p","22":"p","23":"p","24":"p","25":"p","26":"p","27":"p","28":"p","29":"p","30":"p","31":"p","32":"p","33":"p","34":"p","35":"p","36":"p","37":"p","38":"p","39":"p","40":"p d #3","41":"p d #3","42":"p d #3","43":"p d #3","44":"p d #3","45":"p d #3","46":"p d #3","47":"p d #3","48":"p d #3","49":"p d #3","50":"p d #3","51":"p d #3","52":"y #4","53":"y #4","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"p","26":"p","27":"p","28":"p","29":"p d #1","30":"p d #1","31":"p d #1","32":"p d #1","33":"p d #1","34":"p d #1","35":"p d #1","36":"p d #1","37":"p d #1","38":"p d #1","39":"p d #1","40":"p d #1","41":"p d #1","42":"p d #1","43":"p d #1","44":"p d #1","45":"p d #1","46":"p d #1","47":"p d #1","48":"p d #1","49":"p d #1","50":"p d #1","51":"p d #1","52":"p d #1","53":"p d #1","54":"p d #1","55":"p d #1","56":"p d #1","57":"y #4","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"p","7":"p","8":"p","9":"p","10":"p","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"p","7.1":"p","9.1":"p","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"p d #1","29":"p d #1","30":"p d #1","31":"p d #1","32":"p d #1","33":"p d #1","34":"p d #1","35":"p d #1","36":"p d #1","37":"p d #1","38":"p d #1","39":"p d #1","40":"p d #1","41":"p d #1","42":"p d #1","43":"p d #1","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"p","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"p","7.0-7.1":"p","8.1-8.4":"p","9.0-9.2":"p","9.3":"p","10.0-10.2":"p","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"p","4.4":"p","4.4.3-4.4.4":"p"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a x #2","11":"a x #2"},"and_uc":{"12.12":"y"},"samsung":{"4":"p","5.0-5.4":"n","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"See also support for [subgrids](#feat=css-subgrid)","notes_by_num":{"1":"Enabled in Chrome through the \"experimental Web Platform features\" flag in chrome://flags","2":"Partial support in IE refers to supporting an [older version](https://www.w3.org/TR/2011/WD-css3-grid-layout-20110407/) of the specification.","3":"Enabled in Firefox through the `layout.css.grid.enabled ` flag","4":"There are some bugs with overflow ([1356820](https://bugzilla.mozilla.org/show_bug.cgi?id=1356820), [1348857](https://bugzilla.mozilla.org/show_bug.cgi?id=1348857), [1350925](https://bugzilla.mozilla.org/show_bug.cgi?id=1350925))"},"usage_perc_y":94.95,"usage_perc_a":1.17,"ucprefix":false,"parent":"","keywords":"grids,grid-row,grid-column,grid-template,display:grid,inline-grid,fr unit,fractional unit,cssgrid,justify-content:space-between,justify-content:space-around,align-content:space-between,align-content:space-around,space-between","ie_id":"cssgridlayout","chrome_id":"4589636412243968","firefox_id":"css-grid-layout","webkit_id":"specification-css-grid-layout-level-1"},"css-hanging-punctuation":{"title":"CSS hanging-punctuation","description":"Allows some punctuation characters from start (or the end) of text elements to be placed \"outside\" of the box in order to preserve the reading flow.","spec":"https://drafts.csswg.org/css-text-3/#hanging-punctuation-property","status":"wd","links":[{"url":"https://css-tricks.com/almanac/properties/h/hanging-punctuation/","title":"CSS tricks article"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1253615","title":"Firefox bug #1253615"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":16.04,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"hanging punctuation,force-end,allow-end","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-has":{"title":":has() CSS relational pseudo-class","description":"Only select elements containing specified content. For example, `a:has(>img)` selects all `<a>` elements that contain an `<img>` child.","spec":"https://drafts.csswg.org/selectors-4/#relational","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/:has","title":"MDN Web Docs - :has"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=418039","title":"Firefox support bug"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=669058","title":"Chrome bug to track implementation"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":0,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"children,parent,selector","ie_id":"cssrelationalpseudoclasshas","chrome_id":"","firefox_id":"","webkit_id":""},"css-hyphens":{"title":"CSS Hyphenation","description":"Method of controlling when words at the end of lines should be hyphenated using the \"hyphens\" property.","spec":"https://www.w3.org/TR/css3-text/#hyphenation","status":"wd","links":[{"url":"https://developer.mozilla.org/en/CSS/hyphens","title":"MDN Web Docs - CSS hyphens"},{"url":"http://clagnut.com/blog/2394","title":"Blog post"},{"url":"https://www.webplatform.org/docs/css/properties/hyphens","title":"WebPlatform Docs"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=652964","title":"Chromium bug for implementing hyphenation"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y x","11":"y x","5.5":"n"},"edge":{"12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","79":"a #1","80":"a #1","81":"a #1","83":"a #1","84":"a #1","85":"a #1","86":"a #1","87":"a #1"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"a #1","56":"a #1","57":"a #1","58":"a #1","59":"a #1","60":"a #1","61":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #1","66":"a #1","67":"a #1","68":"a #1","69":"a #1","70":"a #1","71":"a #1","72":"a #1","73":"a #1","74":"a #1","75":"a #1","76":"a #1","77":"a #1","78":"a #1","79":"a #1","80":"a #1","81":"a #1","83":"a #1","84":"a #1","85":"a #1","86":"a #1","87":"a #1","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","3.1":"n","3.2":"n","5.1":"y x","6.1":"y x","7.1":"y x","9.1":"y x","10.1":"y x","11.1":"y x","12.1":"y x","13.1":"y x","TP":"y x"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","60":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #1","66":"a #1","67":"a #1","68":"a #1","69":"a #1","70":"a #1","71":"a #1","72":"a #1","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y x","3.2":"n","4.0-4.1":"n","4.2-4.3":"y x","5.0-5.1":"y x","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y x","10.3":"y x","11.0-11.2":"y x","11.3-11.4":"y x","12.0-12.1":"y x","12.2-12.4":"y x","13.0-13.1":"y x","13.2":"y x","13.3":"y x","13.4-13.7":"y x"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"a"},"samsung":{"4":"n","5.0-5.4":"a #1","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"a #1"},"kaios":{"2.5":"y"}},"notes":"Chrome < 55 and Android 4.0 Browser support \"-webkit-hyphens: none\", but not the \"auto\" property. It is [advisable to set the @lang attribute](http://blog.adrianroselli.com/2015/01/on-use-of-lang-attribute.html) on the HTML element to enable hyphenation support and improve accessibility.","notes_by_num":{"1":"Only supported on Android & Mac platforms (and only the \"auto\" value) for now. [See commit](https://crrev.com/ed7e106e0e48b3afb160a5bdbb37649e307d2b05) & related [bug](https://bugs.chromium.org/p/chromium/issues/detail?id=652964)."},"usage_perc_y":59,"usage_perc_a":37.95,"ucprefix":false,"parent":"","keywords":"hyphen,shy","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-image-orientation":{"title":"CSS3 image-orientation","description":"CSS property used generally to fix the intended orientation of an image. This can be done using 90 degree increments or based on the image's EXIF data using the \"from-image\" value.","spec":"https://www.w3.org/TR/css-images-3/#the-image-orientation","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/image-orientation","title":"MDN Web Docs - CSS image-orientation"},{"url":"http://sethfowler.org/blog/2013/09/13/new-in-firefox-26-css-image-orientation/","title":"Blog post"},{"url":"http://jsbin.com/EXUTolo/4","title":"Demo (Chinese)"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=158753","title":"Chromium bug #158753: Support for the CSS image-orientation CSS property"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"y #2","83":"y #2","84":"y #2","85":"y #2","86":"y #2","87":"y #2"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"y #2","83":"y #2","84":"y #2","85":"y #2","86":"y #2","87":"y #2","88":"y #2","89":"y #2","90":"y #2"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a #1","14":"y","3.2":"a #1","4.0-4.1":"a #1","4.2-4.3":"a #1","5.0-5.1":"a #1","6.0-6.1":"a #1","7.0-7.1":"a #1","8.1-8.4":"a #1","9.0-9.2":"a #1","9.3":"a #1","10.0-10.2":"a #1","10.3":"a #1","11.0-11.2":"a #1","11.3-11.4":"a #1","12.0-12.1":"a #1","12.2-12.4":"a #1","13.0-13.1":"a #1","13.2":"a #1","13.3":"a #1","13.4-13.7":"a #1"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"Opening the image in a new tab in Chrome results in the image shown in the orientation according to the EXIF data.","notes_by_num":{"1":"Partial support in iOS refers to the browser using EXIF data by default, though it does not actually support the property.","2":"Chrome/Edge has [a bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1082669) where the browser is not maintaining the image’s aspect ratio when `object-fit: cover` and `image-orientation: from-image` are used together."},"usage_perc_y":81.48,"usage_perc_a":6.96,"ucprefix":false,"parent":"","keywords":"image-orientation,from-image,flip","ie_id":"","chrome_id":"6313474512650240","firefox_id":"","webkit_id":""},"css-image-set":{"title":"CSS image-set","description":"Method of letting the browser pick the most appropriate CSS background image from a given set, primarily for high PPI screens.","spec":"https://drafts.csswg.org/css-images-4/#image-set-notation","status":"wd","links":[{"url":"http://cloudfour.com/examples/image-set/","title":"Demo"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6606738-image-set","title":"Microsoft Edge feature request on UserVoice"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1107646","title":"Firefox feature request bug"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y x","80":"y x","81":"y x","83":"y x","84":"y x","85":"y x","86":"y x","87":"y x"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","59":"y x","60":"y x","61":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y x","70":"y x","71":"y x","72":"y x","73":"y x","74":"y x","75":"y x","76":"y x","77":"y x","78":"y x","79":"y x","80":"y x","81":"y x","83":"y x","84":"y x","85":"y x","86":"y x","87":"y x","88":"y x","89":"y x","90":"y x"},"safari":{"4":"n","5":"n","6":"y x","7":"y x","8":"y x","9":"y x","10":"y #1","11":"y #1","12":"y #1","13":"y #1","14":"y #1","3.1":"n","3.2":"n","5.1":"n","6.1":"y x","7.1":"y x","9.1":"y x","10.1":"y #1","11.1":"y #1","12.1":"y #1","13.1":"y #1","TP":"y #1"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","60":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y x","70":"y x","71":"y x","72":"y x","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y #1","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y #1","10.3":"y #1","11.0-11.2":"y #1","11.3-11.4":"y #1","12.0-12.1":"y #1","12.2-12.4":"y #1","13.0-13.1":"y #1","13.2":"y #1","13.3":"y #1","13.4-13.7":"y #1"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y x","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"n","10":"y x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y x","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y x"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y x"},"samsung":{"4":"y x","5.0-5.4":"y x","6.2-6.4":"y x","7.2-7.4":"y x","8.2":"y x","9.2":"y x","10.1":"y x","11.1-11.2":"y x","12.0":"y x"},"and_qq":{"10.4":"y x"},"baidu":{"7.12":"y x"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Safari's implementation does not completely match the spec, in that only URLs are accepted for the image value and only 'x' is accepted as a resolution. See https://bugs.webkit.org/show_bug.cgi?id=160934."},"usage_perc_y":92.33,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"cssimageset","chrome_id":"","firefox_id":"","webkit_id":""},"css-in-out-of-range":{"title":":in-range and :out-of-range CSS pseudo-classes","description":"If a temporal or number `<input>` has `max` and/or `min` attributes, then `:in-range` matches when the value is within the specified range and `:out-of-range` matches when the value is outside the specified range. If there are no range constraints, then neither pseudo-class matches.","spec":"https://www.w3.org/TR/selectors4/#range-pseudos","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/:out-of-range","title":"MDN Web Docs - CSS :out-of-range"},{"url":"https://html.spec.whatwg.org/multipage/scripting.html#selector-in-range","title":"WHATWG HTML specification for `:in-range` and `:out-of-range`"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"a #2","14":"a #2","15":"a #2","16":"a #2","17":"a #2","18":"a #2","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"a #3","30":"a #3","31":"a #3","32":"a #3","33":"a #3","34":"a #3","35":"a #3","36":"a #3","37":"a #3","38":"a #3","39":"a #3","40":"a #3","41":"a #3","42":"a #3","43":"a #3","44":"a #3","45":"a #3","46":"a #3","47":"a #3","48":"a #3","49":"a #3","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"a #2 #3","16":"a #2 #3","17":"a #2 #3","18":"a #2 #3","19":"a #2 #3","20":"a #2 #3","21":"a #2 #3","22":"a #2 #3","23":"a #2 #3","24":"a #2 #3","25":"a #2 #3","26":"a #2 #3","27":"a #2 #3","28":"a #2 #3","29":"a #2 #3","30":"a #2 #3","31":"a #2 #3","32":"a #2 #3","33":"a #2 #3","34":"a #2 #3","35":"a #2 #3","36":"a #2 #3","37":"a #2 #3","38":"a #2 #3","39":"a #2 #3","40":"a #2 #3","41":"a #2 #3","42":"a #2 #3","43":"a #2 #3","44":"a #2 #3","45":"a #2 #3","46":"a #2 #3","47":"a #2 #3","48":"a #2 #3","49":"a #2 #3","50":"a #2 #3","51":"a #2 #3","52":"a #2","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"u","6":"a #2 #3","7":"a #2 #3","8":"a #2 #3","9":"a #2 #3","10":"a #2 #3","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"a #2 #3","6.1":"a #2 #3","7.1":"a #2 #3","9.1":"a #2 #3","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"a #2","12":"a #2","15":"a #2 #3","16":"a #2 #3","17":"a #2 #3","18":"a #2 #3","19":"a #2 #3","20":"a #2 #3","21":"a #2 #3","22":"a #2 #3","23":"a #2 #3","24":"a #2 #3","25":"a #2 #3","26":"a #2 #3","27":"a #2 #3","28":"a #2 #3","29":"a #2 #3","30":"a #2 #3","31":"a #2 #3","32":"a #2 #3","33":"a #2 #3","34":"a #2 #3","35":"a #2 #3","36":"a #2 #3","37":"a #2 #3","38":"a #2 #3","39":"a #2","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"u","10.0-10.1":"a #2","10.5":"a #2","10.6":"a #2","11.1":"a #2","11.5":"a #2","11.6":"a #2","12.1":"a #2"},"ios_saf":{"8":"a #2 #3","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"a #2 #3","6.0-6.1":"a #2 #3","7.0-7.1":"a #2 #3","8.1-8.4":"a #2 #3","9.0-9.2":"a #2 #3","9.3":"a #2 #3","10.0-10.2":"a #2 #3","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"a #1"},"android":{"3":"n","4":"a #2","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"a #2","4.2-4.3":"a #2","4.4":"a #2","4.4.3-4.4.4":"a #2"},"bb":{"7":"n","10":"a #2"},"op_mob":{"10":"a #2","11":"a #2","12":"a #2","59":"y","11.1":"a #2","11.5":"a #2","12.1":"a #2"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"a #2","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"a #3"}},"notes":"Note that `<input type=\"range\">` can never match `:out-of-range` because the user cannot input such a value, and if the initial value is outside the range, the browser immediately clamps it to the minimum or maximum (as appropriate) bound of the range.","notes_by_num":{"1":"Opera Mini correctly applies style on initial load, but does not correctly update when value is changed.","2":"`:in-range` also incorrectly matches temporal and `number` inputs which don't have `min` or `max` attributes. See [Edge bug](https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/7200501/), [Chrome bug](https://bugs.chromium.org/p/chromium/issues/detail?id=603268), [WebKit bug](https://bugs.webkit.org/show_bug.cgi?id=156558).","3":"`:in-range` and `:out-of-range` incorrectly match inputs which are disabled or readonly. See [Edge bug](https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/7190958/), [Mozilla bug](https://bugzilla.mozilla.org/show_bug.cgi?id=1264157), [WebKit bug](https://bugs.webkit.org/show_bug.cgi?id=156530), [Chrome bug](https://bugs.chromium.org/p/chromium/issues/detail?id=602568)."},"usage_perc_y":94.69,"usage_perc_a":3.24,"ucprefix":false,"parent":"","keywords":"in,out,of,range,:in-range,:out-of-range","ie_id":"cssrangepseudoclasses","chrome_id":"","firefox_id":"","webkit_id":""},"css-indeterminate-pseudo":{"title":":indeterminate CSS pseudo-class","description":"The `:indeterminate` pseudo-class matches indeterminate checkboxes, indeterminate `<progress>` bars, and radio buttons with no checked button in their radio button group.","spec":"https://drafts.csswg.org/selectors-4/#indeterminate","status":"unoff","links":[{"url":"https://html.spec.whatwg.org/multipage/scripting.html#selector-indeterminate","title":"HTML specification for `:indeterminate`"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/:indeterminate","title":"MDN Web Docs - CSS :indeterminate"},{"url":"https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/7124038/","title":"EdgeHTML issue 7124038 - `:indeterminate` pseudo-class doesn't match radio buttons"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=885359","title":"Mozilla Bug 885359 - Radio groups without a selected radio button should have `:indeterminate` applying"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=156270","title":"WebKit Bug 156270 - `:indeterminate` pseudo-class should match radios whose group has no checked radio"},{"url":"http://jsbin.com/zumoqu/edit?html,css,js,output","title":"JS Bin testcase"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"a #1 #2","10":"a #1","11":"a #1","5.5":"n"},"edge":{"12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"u","3":"u","4":"a #1 #2","5":"a #1 #2","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"u","3.6":"u"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"u","5":"u","6":"u","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"u","5.1":"a #1 #2","6.1":"a #1","7.1":"a #1","9.1":"a #1","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"u","12":"a #3","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"u","10.0-10.1":"u","10.5":"u","10.6":"u","11.1":"u","11.5":"u","11.6":"a #3","12.1":"a #3"},"ios_saf":{"8":"a #1","14":"y","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"u","6.0-6.1":"u","7.0-7.1":"a #1","8.1-8.4":"a #1","9.0-9.2":"a #1","9.3":"a #1","10.0-10.2":"a #1","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"a #3"},"android":{"3":"u","4":"a #1 #2","81":"y","2.1":"u","2.2":"u","2.3":"u","4.1":"a #1 #2","4.2-4.3":"a #1 #2","4.4":"a #1","4.4.3-4.4.4":"u"},"bb":{"7":"u","10":"a #1"},"op_mob":{"10":"u","11":"u","12":"u","59":"y","11.1":"u","11.5":"u","12.1":"a #3"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #1","11":"a #1"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"a #1"}},"notes":"","notes_by_num":{"1":"Doesn't match radio buttons whose radio button group lacks a checked radio button","2":"Doesn't support the `<progress>` element","3":"Doesn't match indeterminate `<progress>` bars"},"usage_perc_y":95.37,"usage_perc_a":3.96,"ucprefix":false,"parent":"","keywords":":indeterminate,indeterminate","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-initial-letter":{"title":"CSS Initial Letter","description":"Method of creating an enlarged cap, including a drop or raised cap, in a robust way.","spec":"https://www.w3.org/TR/css-inline/#initial-letter-styling","status":"wd","links":[{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1223880","title":"Firefox Implementation Ticket"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/initial-letter","title":"MDN Web Docs - CSS initial-letter"},{"url":"https://webdesign.tutsplus.com/tutorials/better-css-drop-caps-with-initial-letter--cms-26350","title":"Blog post on Envato Tuts+, \"Better CSS Drop Caps With initial-letter\""},{"url":"http://labs.jensimmons.com/#initialletter","title":"Demos at Jen Simmons Labs"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"a","10":"a x #1","11":"a x #1","12":"a x #1","13":"a x #1","14":"a x #1","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"a x #1","10.1":"a x #1","11.1":"a x #1","12.1":"a x #1","13.1":"a x #1","TP":"a x #1"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"a x #1","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"a x #1","9.3":"a x #1","10.0-10.2":"a x #1","10.3":"a x #1","11.0-11.2":"a x #1","11.3-11.4":"a x #1","12.0-12.1":"a x #1","12.2-12.4":"a x #1","13.0-13.1":"a x #1","13.2":"a x #1","13.3":"a x #1","13.4-13.7":"a x #1"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Safari implementation is incomplete. Does not allow applying web fonts to the initial letter."},"usage_perc_y":0,"usage_perc_a":16.41,"ucprefix":false,"parent":"","keywords":"initial-letter,initial letter,letter,drop cap,dropcap","ie_id":"initialletter","chrome_id":"","firefox_id":"css-initial-letter","webkit_id":"feature-initial-letter"},"css-initial-value":{"title":"CSS initial value","description":"A CSS value that will apply a property's initial value as defined in the CSS specification that defines the property","spec":"https://www.w3.org/TR/css-values/#common-keywords","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/initial","title":"MDN Web Docs - CSS initial"},{"url":"https://css-tricks.com/getting-acquainted-with-initial/","title":"CSS Tricks article"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"a x #1","3":"a x #1","4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y x","3.6":"y x"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"u","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"u","2.2":"u","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Not supported on `quotes` property"},"usage_perc_y":97.29,"usage_perc_a":0.01,"ucprefix":false,"parent":"","keywords":"CSS,initial,value","ie_id":"cssinitialvalue","chrome_id":"","firefox_id":"","webkit_id":""},"css-letter-spacing":{"title":"letter-spacing CSS property","description":"Controls spacing between characters of text (i.e. \"tracking\" in typographical terms). Not to be confused with kerning.","spec":"https://www.w3.org/TR/CSS2/text.html#propdef-letter-spacing","status":"rec","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/letter-spacing","title":"MDN Web Docs - CSS letter-spacing"}],"categories":["CSS"],"stats":{"ie":{"6":"a #1","7":"a #1","8":"a #1","9":"y","10":"y","11":"y","5.5":"u"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a #1","5":"a #1","6":"a #1","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"a #1","5.1":"a #1","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"a #1","12":"a #1","15":"a #1","16":"a #1","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"u","10.0-10.1":"a #1","10.5":"a #1","10.6":"a #1","11.1":"a #1","11.5":"a #1","11.6":"a #1","12.1":"a #1"},"ios_saf":{"8":"y","14":"y","3.2":"u","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"a #1","4":"a #1","81":"y","2.1":"u","2.2":"u","2.3":"a #1","4.1":"a #1","4.2-4.3":"a #1","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"a #1","10":"a #1"},"op_mob":{"10":"a #1","11":"a #1","12":"a #1","59":"y","11.1":"a #1","11.5":"a #1","12.1":"a #1"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Truncates or rounds fractional portions of values"},"usage_perc_y":98.25,"usage_perc_a":0.53,"ucprefix":false,"parent":"","keywords":"CSS,letter,spacing,tracking","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-line-clamp":{"title":"CSS line-clamp","description":"Proprietary and undocumented CSS property that will contain text to a given amount of lines when used in combination with `display: -webkit-box`. It will end with ellipsis when `text-overflow: ellipsis` is included.","spec":"https://developer.apple.com/library/safari/documentation/AppleApplications/Reference/SafariCSSRef/Articles/StandardCSSProperties.html#//apple_ref/doc/uid/TP30001266-WebKit_SpecificUnsupportedProperties","status":"unoff","links":[{"url":"http://guerillalabs.co/blog/css-line-clamping.html","title":"Article on cross-browser CSS line clamping"},{"url":"https://css-tricks.com/line-clampin/","title":"CSS Tricks article"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"y #1","18":"y #1","79":"y x","80":"y x","81":"y x","83":"y x","84":"y x","85":"y x","86":"y x","87":"y x"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"y x","69":"y x","70":"y x","71":"y x","72":"y x","73":"y x","74":"y x","75":"y x","76":"y x","77":"y x","78":"y x","79":"y x","80":"y x","81":"y x","82":"y x","83":"y x","84":"y x","85":"y x","3.5":"n","3.6":"n"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","59":"y x","60":"y x","61":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y x","70":"y x","71":"y x","72":"y x","73":"y x","74":"y x","75":"y x","76":"y x","77":"y x","78":"y x","79":"y x","80":"y x","81":"y x","83":"y x","84":"y x","85":"y x","86":"y x","87":"y x","88":"y x","89":"y x","90":"y x"},"safari":{"4":"n","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","3.1":"n","3.2":"n","5.1":"y x","6.1":"y x","7.1":"y x","9.1":"y x","10.1":"y x","11.1":"y x","12.1":"y x","13.1":"y x","TP":"y x"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","60":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y x","70":"y x","71":"y x","72":"y x","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y x","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y x","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y x","10.3":"y x","11.0-11.2":"y x","11.3-11.4":"y x","12.0-12.1":"y x","12.2-12.4":"y x","13.0-13.1":"y x","13.2":"y x","13.3":"y x","13.4-13.7":"y x"},"op_mini":{"all":"n"},"android":{"3":"y x","4":"y x","81":"y x","2.1":"u","2.2":"u","2.3":"y x","4.1":"y x","4.2-4.3":"y x","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"y x","10":"y x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y x","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y x"},"and_ff":{"82":"y x"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y x"},"samsung":{"4":"y x","5.0-5.4":"y x","6.2-6.4":"y x","7.2-7.4":"y x","8.2":"y x","9.2":"y x","10.1":"y x","11.1-11.2":"y x","12.0":"y x"},"and_qq":{"10.4":"y x"},"baidu":{"7.12":"y x"},"kaios":{"2.5":"n"}},"notes":"As there is no specification and the property is dependent on an outdated implementation of flexbox (hence `display: -webkit-box`), an alternative solution may at some point replace it.\r\n\r\nOlder (presto-based) versions of the Opera browser have also supported the same effect using the proprietary `-o-ellipsis-lastline;` value for `text-overflow`.","notes_by_num":{"1":"Supported in MS Edge with `-webkit-` prefix only (not with `-ms-`)"},"usage_perc_y":96.52,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-logical-props":{"title":"CSS Logical Properties","description":"Logical properties and values provide control of layout through logical, rather than physical, direction and dimension mappings. These properties are `writing-mode` relative equivalents of their corresponding physical properties.","spec":"https://www.w3.org/TR/css-logical-1/","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/-moz-margin-start","title":"MDN Web Docs - CSS -moz-margin-start"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/-moz-padding-start","title":"MDN Web Docs - CSS -moz-padding-start"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/7438435-css-logical-properties","title":"Microsoft Edge feature request on UserVoice"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties/Basic_concepts","title":"MDN - Basic concepts of Logical Properties and Values"}],"categories":["CSS","CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"a #3 #4 #5","80":"a #3 #4 #5","81":"a #3 #4 #5","83":"a #3 #4 #5","84":"a #3 #4 #5","85":"a #3 #4 #5","86":"a #3 #4 #5","87":"a #3 #4 #5"},"firefox":{"2":"n","3":"a x #1","4":"a x #1","5":"a x #1","6":"a x #1","7":"a x #1","8":"a x #1","9":"a x #1","10":"a x #1","11":"a x #1","12":"a x #1","13":"a x #1","14":"a x #1","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","19":"a x #1","20":"a x #1","21":"a x #1","22":"a x #1","23":"a x #1","24":"a x #1","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a x #1","3.6":"a x #1"},"chrome":{"4":"a x #2","5":"a x #2","6":"a x #2","7":"a x #2","8":"a x #2","9":"a x #2","10":"a x #2","11":"a x #2","12":"a x #2","13":"a x #2","14":"a x #2","15":"a x #2","16":"a x #2","17":"a x #2","18":"a x #2","19":"a x #2","20":"a x #2","21":"a x #2","22":"a x #2","23":"a x #2","24":"a x #2","25":"a x #2","26":"a x #2","27":"a x #2","28":"a x #2","29":"a x #2","30":"a x #2","31":"a x #2","32":"a x #2","33":"a x #2","34":"a x #2","35":"a x #2","36":"a x #2","37":"a x #2","38":"a x #2","39":"a x #2","40":"a x #2","41":"a x #2","42":"a x #2","43":"a x #2","44":"a x #2","45":"a x #2","46":"a x #2","47":"a x #2","48":"a x #2","49":"a x #2","50":"a x #2","51":"a x #2","52":"a x #2","53":"a x #2","54":"a x #2","55":"a x #2","56":"a x #2","57":"a x #2","58":"a x #2","59":"a x #2","60":"a x #2","61":"a x #2","62":"a x #2","63":"a x #2","64":"a x #2","65":"a x #2","66":"a x #2","67":"a x #2","68":"a x #2","69":"a #3 #4 #5","70":"a #3 #4 #5","71":"a #3 #4 #5","72":"a #3 #4 #5","73":"a #3 #4 #5","74":"a #3 #4 #5","75":"a #3 #4 #5","76":"a #3 #4 #5","77":"a #3 #4 #5","78":"a #3 #4 #5","79":"a #3 #4 #5","80":"a #3 #4 #5","81":"a #3 #4 #5","83":"a #3 #4 #5","84":"a #3 #4 #5","85":"a #3 #4 #5","86":"a #3 #4 #5","87":"a #5","88":"a #5","89":"a #5","90":"a #5"},"safari":{"4":"a x #2","5":"a x #2","6":"a x #2","7":"a x #2","8":"a x #2","9":"a x #2","10":"a x #2","11":"a x #2","12":"a x #2","13":"a #3 #4 #5","14":"a #3 #4 #5","3.1":"a x #2","3.2":"a x #2","5.1":"a x #2","6.1":"a x #2","7.1":"a x #2","9.1":"a x #2","10.1":"a x #2","11.1":"a x #2","12.1":"a #3 #4 #5","13.1":"a #3 #4 #5","TP":"a #5"},"opera":{"9":"n","11":"n","12":"n","15":"a x #2","16":"a x #2","17":"a x #2","18":"a x #2","19":"a x #2","20":"a x #2","21":"a x #2","22":"a x #2","23":"a x #2","24":"a x #2","25":"a x #2","26":"a x #2","27":"a x #2","28":"a x #2","29":"a x #2","30":"a x #2","31":"a x #2","32":"a x #2","33":"a x #2","34":"a x #2","35":"a x #2","36":"a x #2","37":"a x #2","38":"a x #2","39":"a x #2","40":"a x #2","41":"a x #2","42":"a x #2","43":"a x #2","44":"a x #2","45":"a x #2","46":"a x #2","47":"a x #2","48":"a x #2","49":"a x #2","50":"a x #2","51":"a x #2","52":"a x #2","53":"a x #2","54":"a x #2","55":"a x #2","56":"a #3 #4 #5","57":"a #3 #4 #5","58":"a #3 #4 #5","60":"a #3 #4 #5","62":"a #3 #4 #5","63":"a #3 #4 #5","64":"a #3 #4 #5","65":"a #3 #4 #5","66":"a #3 #4 #5","67":"a #3 #4 #5","68":"a #3 #4 #5","69":"a #3 #4 #5","70":"a #3 #4 #5","71":"a #3 #4 #5","72":"a #3 #4 #5","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a x #2","14":"a #3 #4 #5","3.2":"a x #2","4.0-4.1":"a x #2","4.2-4.3":"a x #2","5.0-5.1":"a x #2","6.0-6.1":"a x #2","7.0-7.1":"a x #2","8.1-8.4":"a x #2","9.0-9.2":"a x #2","9.3":"a x #2","10.0-10.2":"a x #2","10.3":"a x #2","11.0-11.2":"a x #2","11.3-11.4":"a x #2","12.0-12.1":"a x #2","12.2-12.4":"a #3 #4 #5","13.0-13.1":"a #3 #4 #5","13.2":"a #3 #4 #5","13.3":"a #3 #4 #5","13.4-13.7":"a #3 #4 #5"},"op_mini":{"all":"n"},"android":{"3":"a x #2","4":"a x #2","81":"a #3 #4 #5","2.1":"a x #2","2.2":"a x #2","2.3":"a x #2","4.1":"a x #2","4.2-4.3":"a x #2","4.4":"a x #2","4.4.3-4.4.4":"a x #2"},"bb":{"7":"a x #2","10":"a x #2"},"op_mob":{"10":"n","11":"n","12":"n","59":"a #3 #4 #5","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a #3 #4 #5"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"a x #2"},"samsung":{"4":"a x #2","5.0-5.4":"a x #2","6.2-6.4":"a x #2","7.2-7.4":"a x #2","8.2":"a x #2","9.2":"a x #2","10.1":"a #3 #4 #5","11.1-11.2":"a #3 #4 #5","12.0":"a #3 #4 #5"},"and_qq":{"10.4":"a #3 #4 #5"},"baidu":{"7.12":"a #3 #4 #5"},"kaios":{"2.5":"a #3 #4 #5"}},"notes":"","notes_by_num":{"1":"Only supports the *-start, and *-end values for `margin`, `border` and `padding`, not the inline/block type values as defined in the spec.","2":"Like #1 but also supports `*-before` and `*-end` for `*-block-start` and `*-block-end` properties as well as `start` and `end` values for `text-align`","3":"Does not support the `margin-block`, `margin-inline`, `padding-inline`, or any of the `inset` shorthand properties. Supported in newer Chromium browsers behind the `#enable-experimental-web-platform-features` flag","4":"Does not support the `padding-block`, `padding-inline`, or any `inset` property. Supported in newer Chromium browsers behind the `#enable-experimental-web-platform-features` flag","5":"Does not support the `border-start-start-radius`, `border-start-end-radius`, `border-end-start-radius` and `border-end-end-radius` property."},"usage_perc_y":3.92,"usage_perc_a":92.99,"ucprefix":false,"parent":"","keywords":"block-size,border-block,border-block-color,border-block-end,border-block-end-color,border-block-end-style,border-block-end-width,border-block-start,border-block-start-color,border-block-start-style,border-block-start-width,border-block-style,border-block-width,border-end-end-radius,border-end-start-radius,border-inline,border-inline-color,border-inline-end,border-inline-end-color,border-inline-end-style,border-inline-end-width,border-inline-start,border-inline-start-color,border-inline-start-style,border-inline-start-width,border-inline-style,border-inline-width,border-start-end-radius,border-start-start-radius,inline-size,inset,inset-block,inset-block-end,inset-block-start,inset-inline,inset-inline-end,inset-inline-start,margin-block,margin-block-end,margin-block-start,margin-inline,margin-inline-end,margin-inline-start,max-block-size,max-inline-size,min-block-size,min-inline-size,padding-block,padding-block-end,padding-block-start,padding-inline,padding-inline-end,padding-inline-start,recto,verso","ie_id":"csslogicalpropertieslevel1","chrome_id":"","firefox_id":"","webkit_id":""},"css-marker-pseudo":{"title":"CSS ::marker pseudo-element","description":"The `::marker` pseudo-element allows list item markers to be styled or have their content value customized.","spec":"https://drafts.csswg.org/css-pseudo-4/#marker-pseudo","status":"wd","links":[{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=457718","title":"Chrome support bug"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=205202","title":"Firefox support bug"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=141477","title":"WebKit support bug"},{"url":"https://wpdev.uservoice.com/forums/257854-internet-explorer-platform/suggestions/7084750-css-3-marker-pseudo-element","title":"Edge UserVoice request"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/::marker","title":"MDN Web Docs - CSS ::marker"},{"url":"https://css-tricks.com/almanac/selectors/m/marker/","title":"CSS-Tricks article"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"y #1","13":"y #1","14":"y #1","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"y #1","12.1":"y #1","13.1":"y #1","TP":"y #1"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Safari supports [the definition in the CSS Pseudo-Elements Module Level 4](https://www.w3.org/TR/css-pseudo-4/#marker-pseudo) instead of one in the List module due to the flux definition in it."},"usage_perc_y":72.5,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-masks":{"title":"CSS Masks","description":"Method of displaying part of an element, using a selected image as a mask","spec":"https://www.w3.org/TR/css-masking-1/","status":"cr","links":[{"url":"https://www.webplatform.org/docs/css/properties/mask","title":"WebPlatform Docs"},{"url":"https://www.html5rocks.com/en/tutorials/masking/adobe/","title":"HTML5 Rocks article"},{"url":"http://thenittygritty.co/css-masking","title":"Detailed blog post"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1224422","title":"Firefox implementation bug"},{"url":"http://lab.iamvdo.me/css-svg-masks","title":"Visual test cases"},{"url":"https://web.archive.org/web/20160505054016/http://thenittygritty.co/css-masking","title":"Detailed blog post (via The Internet Archive)"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n d #4 #5","18":"a #6 #7","79":"a x #1","80":"a x #1","81":"a x #1","83":"a x #1","84":"a x #1","85":"a x #1","86":"a x #1","87":"a x #1"},"firefox":{"2":"n","3":"n","4":"a #2","5":"a #2","6":"a #2","7":"a #2","8":"a #2","9":"a #2","10":"a #2","11":"a #2","12":"a #2","13":"a #2","14":"a #2","15":"a #2","16":"a #2","17":"a #2","18":"a #2","19":"a #2","20":"a #2","21":"a #2","22":"a #2","23":"a #2","24":"a #2","25":"a #2","26":"a #2","27":"a #2","28":"a #2","29":"a #2","30":"a #2","31":"a #2","32":"a #2","33":"a #2","34":"a #2","35":"a #2","36":"a #2","37":"a #2","38":"a #2","39":"a #2","40":"a #2","41":"a #2","42":"a #2","43":"a #2","44":"a #2","45":"a #2","46":"a #2","47":"a #2","48":"a #2","49":"a #2","50":"a #2","51":"a #2","52":"a #2","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a #2","3.6":"a #2"},"chrome":{"4":"a x #1","5":"a x #1","6":"a x #1","7":"a x #1","8":"a x #1","9":"a x #1","10":"a x #1","11":"a x #1","12":"a x #1","13":"a x #1","14":"a x #1","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","19":"a x #1","20":"a x #1","21":"a x #1","22":"a x #1","23":"a x #1","24":"a x #1","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"a x #1","52":"a x #1","53":"a x #1","54":"a x #1","55":"a x #1","56":"a x #1","57":"a x #1","58":"a x #1","59":"a x #1","60":"a x #1","61":"a x #1","62":"a x #1","63":"a x #1","64":"a x #1","65":"a x #1","66":"a x #1","67":"a x #1","68":"a x #1","69":"a x #1","70":"a x #1","71":"a x #1","72":"a x #1","73":"a x #1","74":"a x #1","75":"a x #1","76":"a x #1","77":"a x #1","78":"a x #1","79":"a x #1","80":"a x #1","81":"a x #1","83":"a x #1","84":"a x #1","85":"a x #1","86":"a x #1","87":"a x #1","88":"a x #1","89":"a x #1","90":"a x #1"},"safari":{"4":"a x #1","5":"a x #1","6":"a x #1","7":"a x #1","8":"a x #1","9":"a x #1","10":"a x #1","11":"a x #1","12":"a x #1","13":"a x #1","14":"a x #1","3.1":"n","3.2":"n","5.1":"a x #1","6.1":"a x #1","7.1":"a x #1","9.1":"a x #1","10.1":"a x #1","11.1":"a x #1","12.1":"a x #1","13.1":"a x #1","TP":"a x #1"},"opera":{"9":"n","11":"n","12":"n","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","19":"a x #1","20":"a x #1","21":"a x #1","22":"a x #1","23":"a x #1","24":"a x #1","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"a x #1","52":"a x #1","53":"a x #1","54":"a x #1","55":"a x #1","56":"a x #1","57":"a x #1","58":"a x #1","60":"a x #1","62":"a x #1","63":"a x #1","64":"a x #1","65":"a x #1","66":"a x #1","67":"a x #1","68":"a x #1","69":"a x #1","70":"a x #1","71":"a x #1","72":"a x #1","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a x #1","14":"a x #1","3.2":"a x #1","4.0-4.1":"a x #1","4.2-4.3":"a x #1","5.0-5.1":"a x #1","6.0-6.1":"a x #1","7.0-7.1":"a x #1","8.1-8.4":"a x #1","9.0-9.2":"a x #1","9.3":"a x #1","10.0-10.2":"a x #1","10.3":"a x #1","11.0-11.2":"a x #1","11.3-11.4":"a x #1","12.0-12.1":"a x #1","12.2-12.4":"a x #1","13.0-13.1":"a x #1","13.2":"a x #1","13.3":"a x #1","13.4-13.7":"a x #1"},"op_mini":{"all":"n"},"android":{"3":"a x #1 #3","4":"a x #1 #3","81":"a x #1","2.1":"a x #1 #3","2.2":"a x #1 #3","2.3":"a x #1 #3","4.1":"a x #1 #3","4.2-4.3":"a x #1 #3","4.4":"a x #1","4.4.3-4.4.4":"a x #1"},"bb":{"7":"a x #1","10":"a x #1"},"op_mob":{"10":"n","11":"n","12":"n","59":"a x #1","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a x #1"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"a x #1"},"samsung":{"4":"a x #1","5.0-5.4":"a x #1","6.2-6.4":"a x #1","7.2-7.4":"a x #1","8.2":"a x #1","9.2":"a x #1","10.1":"a x #1","11.1-11.2":"a x #1","12.0":"a x #1"},"and_qq":{"10.4":"a x #1"},"baidu":{"7.12":"a x #1"},"kaios":{"2.5":"a #2"}},"notes":"","notes_by_num":{"1":"Partial support in WebKit/Blink browsers refers to supporting the mask-image and mask-box-image properties, but lacking support for other parts of the spec.","2":"Partial support in Firefox refers to only support for inline SVG mask elements i.e. mask: url(#foo).","3":"Partial support refers to supporting the mask-box-image shorthand but not the longhand properties","4":"Can be enabled in MS edge behind the \"Enable CSS Masking\" flag.","5":"Partial support refers to supporting mask-image and mask-size","6":"Partial support refers to supporting mask-image, mask-size, mask-position, mask-repeat and mask-composite","7":"Edge also recognizes and supports all the `-webkit-` prefixed equivalents of the unprefixed properties for site compatibility"},"usage_perc_y":3.72,"usage_perc_a":93.48,"ucprefix":false,"parent":"","keywords":"clip,clip-path,clip-rule,mask,mask-border,mask-clip,mask-image,mask-mode,mask-type,css masking","ie_id":"masks","chrome_id":"5381559662149632","firefox_id":"","webkit_id":""},"css-matches-pseudo":{"title":":is() CSS pseudo-class","description":"The `:is()` (formerly `:matches()`, formerly `:any()`) pseudo-class checks whether the element at its position in the outer selector matches any of the selectors in its selector list. It's useful syntactic sugar that allows you to avoid writing out all the combinations manually as separate selectors. The effect is similar to nesting in Sass and most other CSS preprocessors.","spec":"https://www.w3.org/TR/selectors4/#matches","status":"wd","links":[{"url":"https://webkit.org/blog/3615/css-selectors-inside-selectors-discover-matches-not-and-nth-child/","title":"WebKit blog post about adding `:matches()` and other Selectors Level 4 features"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=568705","title":"Chrome support bug for :is()"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/:is","title":"MDN Web Docs - CSS :is()"},{"url":"https://codepen.io/atjn/full/MWKErBe","title":"Codepen - Modern tests"},{"url":"http://output.jsbin.com/lehina","title":"JS Bin - Legacy tests"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"a d #1 #7","80":"a d #1 #7","81":"a d #1 #7","83":"a d #1 #7","84":"a d #1 #7","85":"a d #1 #7","86":"a d #1 #7","87":"a d #1 #7"},"firefox":{"2":"u","3":"u","4":"a x #3","5":"a x #3","6":"a x #3","7":"a x #3","8":"a x #3","9":"a x #3","10":"a x #3","11":"a x #3","12":"a x #3","13":"a x #3","14":"a x #3","15":"a x #3","16":"a x #3","17":"a x #3","18":"a x #3","19":"a x #3","20":"a x #3","21":"a x #3","22":"a x #3","23":"a x #3","24":"a x #3","25":"a x #3","26":"a x #3","27":"a x #3","28":"a x #3","29":"a x #3","30":"a x #3","31":"a x #3","32":"a x #3","33":"a x #3","34":"a x #3","35":"a x #3","36":"a x #3","37":"a x #3","38":"a x #3","39":"a x #3","40":"a x #3","41":"a x #3","42":"a x #3","43":"a x #3","44":"a x #3","45":"a x #3","46":"a x #3","47":"a x #3","48":"a x #3","49":"a x #3","50":"a x #3","51":"a x #3","52":"a x #3","53":"a x #3","54":"a x #3","55":"a x #3","56":"a x #3","57":"a x #3","58":"a x #3","59":"a x #3","60":"a x #3","61":"a x #3","62":"a x #3","63":"a x #3","64":"a x #3","65":"a x #3","66":"a x #3","67":"a x #3","68":"a x #3","69":"a x #3","70":"a x #3","71":"a x #3","72":"a x #3","73":"a x #3","74":"a x #3","75":"a x #3","76":"a x #3","77":"a x #3","78":"y #6","79":"y #6","80":"y #6","81":"y #6","82":"y #6","83":"y #6","84":"y #6","85":"y #6","3.5":"u","3.6":"u"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","19":"a x #1","20":"a x #1","21":"a x #1","22":"a x #1","23":"a x #1","24":"a x #1","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"a x #1","52":"a x #1","53":"a x #1","54":"a x #1","55":"a x #1","56":"a x #1","57":"a x #1","58":"a x #1","59":"a x #1","60":"a x #1","61":"a x #1","62":"a x #1","63":"a x #1","64":"a x #1","65":"a d #1","66":"a d #1","67":"a d #1","68":"a d #1 #7","69":"a d #1 #7","70":"a d #1 #7","71":"a d #1 #7","72":"a d #1 #7","73":"a d #1 #7","74":"a d #1 #7","75":"a d #1 #7","76":"a d #1 #7","77":"a d #1 #7","78":"a d #1 #7","79":"a d #1 #7","80":"a d #1 #7","81":"a d #1 #7","83":"a d #1 #7","84":"a d #1 #7","85":"a d #1 #7","86":"a d #1 #7","87":"a d #1 #7","88":"a d #1 #7","89":"a d #1 #7","90":"a d #1 #7"},"safari":{"4":"n","5":"u","6":"a x #1","7":"a x #1","8":"a x #1","9":"a #2","10":"a #2","11":"a #2","12":"a #2","13":"a #2","14":"y #4 #5","3.1":"n","3.2":"n","5.1":"a x #1","6.1":"a x #1","7.1":"a x #1","9.1":"a #2","10.1":"a #2","11.1":"a #2","12.1":"a #2","13.1":"a #2","TP":"y #4 #5"},"opera":{"9":"n","11":"n","12":"n","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","19":"a x #1","20":"a x #1","21":"a x #1","22":"a x #1","23":"a x #1","24":"a x #1","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"a x #1","52":"a d #1","53":"a d #1","54":"a d #1","55":"a d #1 #7","56":"a d #1 #7","57":"a d #1 #7","58":"a d #1 #7","60":"a d #1 #7","62":"a d #1 #7","63":"a d #1 #7","64":"a d #1 #7","65":"a d #1 #7","66":"a d #1 #7","67":"a d #1 #7","68":"a d #1 #7","69":"a d #1 #7","70":"a d #1 #7","71":"a d #1 #7","72":"a d #1 #7","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a x #1","14":"y #4 #5","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"u","6.0-6.1":"u","7.0-7.1":"a x #1","8.1-8.4":"a x #1","9.0-9.2":"a #2","9.3":"a #2","10.0-10.2":"a #2","10.3":"a #2","11.0-11.2":"a #2","11.3-11.4":"a #2","12.0-12.1":"a #2","12.2-12.4":"a #2","13.0-13.1":"a #2","13.2":"a #2","13.3":"a #2","13.4-13.7":"a #2"},"op_mini":{"all":"n"},"android":{"3":"u","4":"a x #1","81":"a x #1","2.1":"u","2.2":"u","2.3":"u","4.1":"a x #1","4.2-4.3":"a x #1","4.4":"a x #1","4.4.3-4.4.4":"a x #1"},"bb":{"7":"u","10":"a x #1"},"op_mob":{"10":"n","11":"n","12":"n","59":"a x #1","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a d #1 #7"},"and_ff":{"82":"y #6"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"a x #1"},"samsung":{"4":"a x #1","5.0-5.4":"a x #1","6.2-6.4":"a x #1","7.2-7.4":"a x #1","8.2":"a x #1","9.2":"a x #1","10.1":"a x #1","11.1-11.2":"a x #1","12.0":"a x #1"},"and_qq":{"10.4":"a d #1 #7"},"baidu":{"7.12":"a x #1"},"kaios":{"2.5":"a x #3"}},"notes":"","notes_by_num":{"1":"Only supports the deprecated `:-webkit-any()` pseudo-class","2":"Only supports the deprecated `:-webkit-any()` and `:-matches()` pseudo-classes","3":"Only supports the deprecated `:-moz-any()` pseudo-class.","4":"Also supports the deprecated `:-webkit-any()` pseudo-class","5":"Also supports the deprecated `:-matches()` pseudo-class","6":"Also supports the deprecated `:-moz-any()` pseudo-class.","7":"Support for `:is()` can be enabled with the `Experimental Web Platform features` flag"},"usage_perc_y":10.34,"usage_perc_a":86.43,"ucprefix":false,"parent":"","keywords":":is,is,:matches,matches,:any,any,:-moz-any,-moz-any,:-webkit-any,-webkit-any","ie_id":"","chrome_id":"5445716612743168","firefox_id":"","webkit_id":"feature-css-selector-:is()"},"css-math-functions":{"title":"CSS math functions min(), max() and clamp()","description":"More advanced mathematical expressions in addition to `calc()`","spec":"https://www.w3.org/TR/css-values-4/#math-function","status":"wd","links":[{"url":"https://jsfiddle.net/as9t4jek/","title":"Test case on JSFiddle"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=css-min-max","title":"Firefox support bug"},{"url":"https://crbug.com/825895","title":"Chrome support bug"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/min","title":"MDN Web Docs article for min()"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/max","title":"MDN Web Docs article for max()"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/clamp","title":"MDN Web Docs article for clamp()"},{"url":"https://webdesign.tutsplus.com/tutorials/mathematical-expressions-calc-min-and-max--cms-29735","title":"Getting Started With CSS Math Functions Level 4"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"a #1","13":"a #1","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"a #1","12.1":"a #1","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"a #1","12.0-12.1":"a #1","12.2-12.4":"a #1","13.0-13.1":"a #1","13.2":"a #1","13.3":"a #1","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Safari did not support `clamp()`"},"usage_perc_y":87.04,"usage_perc_a":3.58,"ucprefix":false,"parent":"","keywords":"min,min(),max,max(),clamp,clamp()","ie_id":"","chrome_id":"5714277878988800","firefox_id":"css-min-max-clamp","webkit_id":""},"css-media-interaction":{"title":"Media Queries: interaction media features","description":"Allows a media query to be set based on the presence and accuracy of the user's pointing device, and whether they have the ability to hover over elements on the page. This includes the `pointer`, `any-pointer`, `hover`, and `any-hover` media features.","spec":"https://www.w3.org/TR/mediaqueries-4/#mf-interaction","status":"wd","links":[{"url":"http://jordanm.co.uk/2013/11/11/potential-use-cases-for-script-hover-and-pointer.html","title":"Potential use cases for script, hover and pointer CSS Level 4 Media Features"},{"url":"https://dev.opera.com/articles/media-features/","title":"Interaction Media Features and their potential (for incorrect assumptions)"},{"url":"https://github.com/twbs/mq4-hover-shim","title":"Polyfill for the `hover` media feature"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":95.71,"usage_perc_a":0,"ucprefix":false,"parent":"css-mediaqueries","keywords":"@media,interaction,hover,any-hover,css pointer,any-pointer,pointer:coarse,pointer:fine","ie_id":"mediaquerieslevel4pointerandhover","chrome_id":"6460705494532096","firefox_id":"","webkit_id":""},"css-media-resolution":{"title":"Media Queries: resolution feature","description":"Allows a media query to be set based on the device pixels used per CSS unit. While the standard uses `min`/`max-resolution` for this, some browsers support the older non-standard `device-pixel-ratio` media query.","spec":"https://www.w3.org/TR/css3-mediaqueries/#resolution","status":"rec","links":[{"url":"https://www.w3.org/blog/CSS/2012/06/14/unprefix-webkit-device-pixel-ratio/","title":"How to unprefix -webkit-device-pixel-ratio"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=78087","title":"WebKit Bug 78087: Implement the 'resolution' media query"},{"url":"https://compat.spec.whatwg.org/#css-media-queries-webkit-device-pixel-ratio","title":"WHATWG Compatibility Standard: -webkit-device-pixel-ratio"}],"categories":["CSS","CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"a #1","10":"a #1","11":"a #1","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a #2","5":"a #2","6":"a #2","7":"a #2","8":"a #2","9":"a #2","10":"a #2","11":"a #2","12":"a #2","13":"a #2","14":"a #2","15":"a #2","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a #2","3.6":"a #2"},"chrome":{"4":"a x #3","5":"a x #3","6":"a x #3","7":"a x #3","8":"a x #3","9":"a x #3","10":"a x #3","11":"a x #3","12":"a x #3","13":"a x #3","14":"a x #3","15":"a x #3","16":"a x #3","17":"a x #3","18":"a x #3","19":"a x #3","20":"a x #3","21":"a x #3","22":"a x #3","23":"a x #3","24":"a x #3","25":"a x #3","26":"a x #3","27":"a x #3","28":"a x #3","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a x #3","5":"a x #3","6":"a x #3","7":"a x #3","8":"a x #3","9":"a x #3","10":"a x #3","11":"a x #3","12":"a x #3","13":"a x #3","14":"a x #3","3.1":"n","3.2":"n","5.1":"a x #3","6.1":"a x #3","7.1":"a x #3","9.1":"a x #3","10.1":"a x #3","11.1":"a x #3","12.1":"a x #3","13.1":"a x #3","TP":"a x #3"},"opera":{"9":"n","11":"a x #3","12":"a x #3","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"a x #3","10.0-10.1":"a x #3","10.5":"a x #3","10.6":"a x #3","11.1":"a x #3","11.5":"a x #3","11.6":"a x #3","12.1":"y"},"ios_saf":{"8":"a x #3","14":"a x #3","3.2":"u","4.0-4.1":"a x #3","4.2-4.3":"a x #3","5.0-5.1":"a x #3","6.0-6.1":"a x #3","7.0-7.1":"a x #3","8.1-8.4":"a x #3","9.0-9.2":"a x #3","9.3":"a x #3","10.0-10.2":"a x #3","10.3":"a x #3","11.0-11.2":"a x #3","11.3-11.4":"a x #3","12.0-12.1":"a x #3","12.2-12.4":"a x #3","13.0-13.1":"a x #3","13.2":"a x #3","13.3":"a x #3","13.4-13.7":"a x #3"},"op_mini":{"all":"a #1"},"android":{"3":"a x #3","4":"a x #3","81":"y","2.1":"u","2.2":"u","2.3":"a x #3","4.1":"a x #3","4.2-4.3":"a x #3","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"a x #3","10":"a x #3"},"op_mob":{"10":"a x #3","11":"a x #3","12":"a x #3","59":"y","11.1":"a x #3","11.5":"a x #3","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #1","11":"a #1"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Supports the `dpi` unit, but does not support `dppx` or `dpcm` units.","2":"Firefox before 16 supports only `dpi` unit, but you can set `2dppx` per `min--moz-device-pixel-ratio: 2`","3":"Supports the non-standard `min`/`max-device-pixel-ratio`"},"usage_perc_y":80.32,"usage_perc_a":19.25,"ucprefix":false,"parent":"css-mediaqueries","keywords":"@media,device-pixel-ratio,resolution,dppx,dpcm,dpi","ie_id":"mediaqueriesresolutionfeature,dppxunitfortheresolutionmediaquery","chrome_id":"5944509615570944","firefox_id":"","webkit_id":""},"css-mediaqueries":{"title":"CSS3 Media Queries","description":"Method of applying styles based on media information. Includes things like page and device dimensions","spec":"https://www.w3.org/TR/css3-mediaqueries/","status":"rec","links":[{"url":"http://ie.microsoft.com/testdrive/HTML5/85CSS3_MediaQueries/","title":"IE demo page with information"},{"url":"http://webdesignerwall.com/tutorials/responsive-design-with-css3-media-queries","title":"Media Queries tutorial"},{"url":"https://github.com/scottjehl/Respond","title":"Polyfill for IE"},{"url":"https://www.webplatform.org/docs/css/atrules/@media","title":"WebPlatform Docs"}],"categories":["CSS3"],"stats":{"ie":{"6":"p","7":"p","8":"p","9":"y #1","10":"y #1","11":"y #1","5.5":"p"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y #1","5":"y #1","6":"y #1","7":"y #1","8":"y #1","9":"y #1","10":"y #1","11":"y #1","12":"y #1","13":"y #1","14":"y #1","15":"y #1","16":"y #1","17":"y #1","18":"y #1","19":"y #1","20":"y #1","21":"y #1","22":"y #1","23":"y #1","24":"y #1","25":"y #1","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y #1","5":"y #1","6":"y #1","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a #1 #2","3.2":"a #1 #2","5.1":"y #1","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y #1","4.0-4.1":"y #1","4.2-4.3":"y #1","5.0-5.1":"y #1","6.0-6.1":"y #1","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y #1","4":"y #1","81":"y","2.1":"y #1","2.2":"y #1","2.3":"y #1","4.1":"y #1","4.2-4.3":"y #1","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y #1","11":"y #1"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Does not support nested media queries","2":"Partial support refers to only acknowledging different media rules on page reload"},"usage_perc_y":99.58,"usage_perc_a":0.01,"ucprefix":false,"parent":"","keywords":"@media","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-mixblendmode":{"title":"Blending of HTML/SVG elements","description":"Allows blending between arbitrary SVG and HTML elements","spec":"https://www.w3.org/TR/compositing-1/#mix-blend-mode","status":"cr","links":[{"url":"https://codepen.io/bennettfeely/pen/csjzd","title":"codepen example"},{"url":"https://css-tricks.com/basics-css-blend-modes/","title":"Blog post"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n d #1","30":"n d #1","31":"n d #1","32":"n d #1","33":"n d #1","34":"n d #1","35":"n d #1","36":"n d #1","37":"n d #1","38":"n d #1","39":"n d #1","40":"n d #1","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"a #2","9":"a #2","10":"a #2","11":"a #2","12":"a #2","13":"a #2","14":"a #2","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"a #2","9.1":"a #2","10.1":"a #2","11.1":"a #2","12.1":"a #2","13.1":"a #2","TP":"a #2"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a #2","14":"a #2","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"a #2","9.0-9.2":"a #2","9.3":"a #2","10.0-10.2":"a #2","10.3":"a #2","11.0-11.2":"a #2","11.3-11.4":"a #2","12.0-12.1":"a #2","12.2-12.4":"a #2","13.0-13.1":"a #2","13.2":"a #2","13.3":"a #2","13.4-13.7":"a #2"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Enabled in Chrome through the \"experimental Web Platform features\" flag in chrome://flags","2":"Partial in Safari refers to not supporting the `hue`, `saturation`, `color`, and `luminosity` blend modes."},"usage_perc_y":79.3,"usage_perc_a":16.46,"ucprefix":false,"parent":"","keywords":"mix-blend-mode,css blend modes,css blending modes","ie_id":"mixblendmode","chrome_id":"6362616360337408","firefox_id":"","webkit_id":""},"css-motion-paths":{"title":"CSS Motion Path","description":"Allows elements to be animated along SVG paths or shapes via the `offset-path` property. Originally defined as the `motion-path` property.","spec":"https://www.w3.org/TR/motion-1/","status":"wd","links":[{"url":"https://codepen.io/danwilson/post/css-motion-paths","title":"Blog post"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/motion-path","title":"MDN Web Docs - CSS motion-path"},{"url":"https://googlechrome.github.io/samples/css-motion-path/index.html","title":"Demo"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1186329","title":"Firefox tracking bug"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n d #1","44":"n d #1","45":"n d #1","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n d #1","31":"n d #1","32":"n d #1","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Requires the \"Experimental Web Platform features\" flag to be enabled"},"usage_perc_y":78.75,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"offset-position,offset-distance,offset-rotate","ie_id":"cssmotionpath","chrome_id":"6190642178818048","firefox_id":"css-motion-path","webkit_id":""},"css-namespaces":{"title":"CSS namespaces","description":"Using the `@namespace` at-rule, elements of other namespaces (e.g. SVG) can be targeted using the pipe (`|`) selector.","spec":"https://drafts.csswg.org/css-namespaces/","status":"rec","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/@namespace","title":"MDN Web Docs - CSS @namespace"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"u","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"u","4.0-4.1":"u","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":99.57,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-not-sel-list":{"title":"selector list argument of :not()","description":"Selectors Level 3 only allowed `:not()` pseudo-class to accept a single simple selector, which the element must not match any of. Thus, `:not(a, .b, [c])` or `:not(a.b[c])` did not work. Selectors Level 4 allows `:not()` to accept a list of selectors. Thus, `:not(a):not(.b):not([c])` can instead be written as `:not(a, .b, [c])` and `:not(a.b[c])` works as intended.","spec":"https://www.w3.org/TR/selectors4/#negation","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/:not","title":"MDN Web Docs - CSS :not"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=580628","title":"Chrome feature request issue"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=933562","title":"Firefox feature request bug"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"u","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"u","89":"u","90":"u"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":16.41,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"negation,not,pseudo,selector,selectors,list,multiple,argument,level,4","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":"feature-css-selector-:not()-level-4"},"css-nth-child-of":{"title":"selector list argument of :nth-child and :nth-last-child CSS pseudo-classes","description":"The newest versions of `:nth-child()` and `:nth-last-child()` accept an optional `of S` clause which filters the children to only those which match the selector list `S`. For example, `:nth-child(1 of .foo)` selects the first child among the children that have the `foo` class (ignoring any non-`foo` children which precede that child). Similar to `:nth-of-type`, but for arbitrary selectors instead of only type selectors.","spec":"https://drafts.csswg.org/selectors/#the-nth-child-pseudo","status":"unoff","links":[{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=854148","title":"Mozilla Bug 854148 - Support for :nth-child(An+B of sel), :nth-last-child(An+B of sel) pseudo-classes"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=304163","title":"Chromium Issue 304163: Implement :nth-child(an+b of S) and :nth-last-child(an+b of S) pseudo-classes"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/15944476","title":"MS Edge feature request on UserVoice"},{"url":"https://developer.microsoft.com/en-us/microsoft-edge/platform/status/cssselectorslevel4/","title":"MS Edge Platform Status: Under Consideration"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"For support information for just `:nth-child()` see [CSS3 selector support](#feat=css-sel3)","notes_by_num":{},"usage_perc_y":16.41,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"nth-child,nth-last-child,nth,child,an,b,of,s,sel,selector,list","ie_id":"cssselectorslevel4","chrome_id":"","firefox_id":"","webkit_id":"feature-css-selector-:nth-child(an+b-of-selector-list)-and-:nth-last-child(an+b-of-selector-list)"},"css-opacity":{"title":"CSS3 Opacity","description":"Method of setting the transparency level of an element","spec":"https://www.w3.org/TR/css3-color/","status":"rec","links":[{"url":"https://www.webplatform.org/docs/css/properties/opacity","title":"WebPlatform Docs"}],"categories":["CSS3"],"stats":{"ie":{"6":"a","7":"a","8":"a","9":"y","10":"y","11":"y","5.5":"a"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Transparency for elements in IE8 and older can be achieved using the proprietary \"filter\" property and does not work well with PNG images using alpha transparency.","notes_by_num":{},"usage_perc_y":99.61,"usage_perc_a":0.09,"ucprefix":false,"parent":"","keywords":"transparent,transparency,alpha","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-optional-pseudo":{"title":":optional CSS pseudo-class","description":"The `:optional` pseudo-class matches form inputs (`<input>`, `<textarea>`, `<select>`) which are not `:required`.","spec":"https://drafts.csswg.org/selectors-4/#optional-pseudo","status":"unoff","links":[{"url":"https://html.spec.whatwg.org/multipage/scripting.html#selector-optional","title":"HTML specification for `:optional`"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/:optional","title":"MDN Web Docs - CSS :optional"},{"url":"http://jsbin.com/fihudu/edit?html,css,output","title":"JS Bin testcase"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"a #1","12":"a #1","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"u","10.0-10.1":"a #1","10.5":"a #1","10.6":"a #1","11.1":"a #1","11.5":"a #1","11.6":"a #1","12.1":"a #1"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"a #1"},"android":{"3":"y","4":"y","81":"y","2.1":"u","2.2":"u","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"a #1","11":"a #1","12":"a #1","59":"y","11.1":"a #1","11.5":"a #1","12.1":"a #1"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Does not match non-required `<select>`s"},"usage_perc_y":98.33,"usage_perc_a":0.93,"ucprefix":false,"parent":"form-validation","keywords":":optional,optional,:required,required","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-overflow":{"title":"CSS overflow property","description":"Originally a single property for controlling overflowing content in both horizontal & vertical directions, the `overflow` property is now a shorthand for `overflow-x` & `overflow-y`. The latest version of the specification also introduces the `clip` value that blocks programmatic scrolling.","spec":"https://www.w3.org/TR/css-overflow-3/","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/overflow","title":"CSS overflow on MDN"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=184691","title":"WebKit bug on support for two values syntax"},{"url":"https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/16993428/","title":"Edge bug on support for two values syntax"}],"categories":["CSS"],"stats":{"ie":{"6":"a #1 #2","7":"a #1 #2","8":"a #1 #2","9":"a #1 #2","10":"a #1 #2","11":"a #1 #2","5.5":"a #1 #2"},"edge":{"12":"a #1 #2","13":"a #1 #2","14":"a #1 #2","15":"a #1 #2","16":"a #1 #2","17":"a #1 #2","18":"a #1 #2","79":"a #2","80":"a #2","81":"a #2","83":"a #2","84":"a #2","85":"a #2","86":"a #2","87":"a #2"},"firefox":{"2":"a #1 #2","3":"a #1 #2","4":"a #1 #2","5":"a #1 #2","6":"a #1 #2","7":"a #1 #2","8":"a #1 #2","9":"a #1 #2","10":"a #1 #2","11":"a #1 #2","12":"a #1 #2","13":"a #1 #2","14":"a #1 #2","15":"a #1 #2","16":"a #1 #2","17":"a #1 #2","18":"a #1 #2","19":"a #1 #2","20":"a #1 #2","21":"a #1 #2","22":"a #1 #2","23":"a #1 #2","24":"a #1 #2","25":"a #1 #2","26":"a #1 #2","27":"a #1 #2","28":"a #1 #2","29":"a #1 #2","30":"a #1 #2","31":"a #1 #2","32":"a #1 #2","33":"a #1 #2","34":"a #1 #2","35":"a #1 #2","36":"a #1 #2","37":"a #1 #2","38":"a #1 #2","39":"a #1 #2","40":"a #1 #2","41":"a #1 #2","42":"a #1 #2","43":"a #1 #2","44":"a #1 #2","45":"a #1 #2","46":"a #1 #2","47":"a #1 #2","48":"a #1 #2","49":"a #1 #2","50":"a #1 #2","51":"a #1 #2","52":"a #1 #2","53":"a #1 #2","54":"a #1 #2","55":"a #1 #2","56":"a #1 #2","57":"a #1 #2","58":"a #1 #2","59":"a #1 #2","60":"a #1 #2","61":"a #2","62":"a #2","63":"a #2","64":"a #2","65":"a #2","66":"a #2","67":"a #2","68":"a #2","69":"a #2","70":"a #2","71":"a #2","72":"a #2","73":"a #2","74":"a #2","75":"a #2","76":"a #2","77":"a #2","78":"a #2","79":"a #2","80":"a #2","81":"a #2","82":"a #2","83":"a #2","84":"a #2","85":"a #2","3.5":"a #1 #2","3.6":"a #1 #2"},"chrome":{"4":"a #1 #2","5":"a #1 #2","6":"a #1 #2","7":"a #1 #2","8":"a #1 #2","9":"a #1 #2","10":"a #1 #2","11":"a #1 #2","12":"a #1 #2","13":"a #1 #2","14":"a #1 #2","15":"a #1 #2","16":"a #1 #2","17":"a #1 #2","18":"a #1 #2","19":"a #1 #2","20":"a #1 #2","21":"a #1 #2","22":"a #1 #2","23":"a #1 #2","24":"a #1 #2","25":"a #1 #2","26":"a #1 #2","27":"a #1 #2","28":"a #1 #2","29":"a #1 #2","30":"a #1 #2","31":"a #1 #2","32":"a #1 #2","33":"a #1 #2","34":"a #1 #2","35":"a #1 #2","36":"a #1 #2","37":"a #1 #2","38":"a #1 #2","39":"a #1 #2","40":"a #1 #2","41":"a #1 #2","42":"a #1 #2","43":"a #1 #2","44":"a #1 #2","45":"a #1 #2","46":"a #1 #2","47":"a #1 #2","48":"a #1 #2","49":"a #1 #2","50":"a #1 #2","51":"a #1 #2","52":"a #1 #2","53":"a #1 #2","54":"a #1 #2","55":"a #1 #2","56":"a #1 #2","57":"a #1 #2","58":"a #1 #2","59":"a #1 #2","60":"a #1 #2","61":"a #1 #2","62":"a #1 #2","63":"a #1 #2","64":"a #1 #2","65":"a #1 #2","66":"a #1 #2","67":"a #1 #2","68":"a #2","69":"a #2","70":"a #2","71":"a #2","72":"a #2","73":"a #2","74":"a #2","75":"a #2","76":"a #2","77":"a #2","78":"a #2","79":"a #2","80":"a #2","81":"a #2","83":"a #2","84":"a #2","85":"a #2","86":"a #2","87":"a #2","88":"a #2","89":"a #2","90":"a #2"},"safari":{"4":"a #1 #2","5":"a #1 #2","6":"a #1 #2","7":"a #1 #2","8":"a #1 #2","9":"a #1 #2","10":"a #1 #2","11":"a #1 #2","12":"a #1 #2","13":"a #1 #2","14":"a #2","3.1":"a #1 #2","3.2":"a #1 #2","5.1":"a #1 #2","6.1":"a #1 #2","7.1":"a #1 #2","9.1":"a #1 #2","10.1":"a #1 #2","11.1":"a #1 #2","12.1":"a #1 #2","13.1":"a #2","TP":"a #2"},"opera":{"9":"a #1 #2","11":"a #1 #2","12":"a #1 #2","15":"a #1 #2","16":"a #1 #2","17":"a #1 #2","18":"a #1 #2","19":"a #1 #2","20":"a #1 #2","21":"a #1 #2","22":"a #1 #2","23":"a #1 #2","24":"a #1 #2","25":"a #1 #2","26":"a #1 #2","27":"a #1 #2","28":"a #1 #2","29":"a #1 #2","30":"a #1 #2","31":"a #1 #2","32":"a #1 #2","33":"a #1 #2","34":"a #1 #2","35":"a #1 #2","36":"a #1 #2","37":"a #1 #2","38":"a #1 #2","39":"a #1 #2","40":"a #1 #2","41":"a #1 #2","42":"a #1 #2","43":"a #1 #2","44":"a #1 #2","45":"a #1 #2","46":"a #1 #2","47":"a #1 #2","48":"a #1 #2","49":"a #1 #2","50":"a #1 #2","51":"a #1 #2","52":"a #1 #2","53":"a #1 #2","54":"a #1 #2","55":"a #2","56":"a #2","57":"a #2","58":"a #2","60":"a #2","62":"a #2","63":"a #2","64":"a #2","65":"a #2","66":"a #2","67":"a #2","68":"a #2","69":"a #2","70":"a #2","71":"a #2","72":"a #2","9.5-9.6":"a #1 #2","10.0-10.1":"a #1 #2","10.5":"a #1 #2","10.6":"a #1 #2","11.1":"a #1 #2","11.5":"a #1 #2","11.6":"a #1 #2","12.1":"a #1 #2"},"ios_saf":{"8":"a #1 #2","14":"a #2","3.2":"a #1 #2","4.0-4.1":"a #1 #2","4.2-4.3":"a #1 #2","5.0-5.1":"a #1 #2","6.0-6.1":"a #1 #2","7.0-7.1":"a #1 #2","8.1-8.4":"a #1 #2","9.0-9.2":"a #1 #2","9.3":"a #1 #2","10.0-10.2":"a #1 #2","10.3":"a #1 #2","11.0-11.2":"a #1 #2","11.3-11.4":"a #1 #2","12.0-12.1":"a #1 #2","12.2-12.4":"a #1 #2","13.0-13.1":"a #1 #2","13.2":"a #1 #2","13.3":"a #1 #2","13.4-13.7":"a #2"},"op_mini":{"all":"a #1 #2"},"android":{"3":"a #1 #2","4":"a #1 #2","81":"a #1 #2","2.1":"a #1 #2","2.2":"a #1 #2","2.3":"a #1 #2","4.1":"a #1 #2","4.2-4.3":"a #1 #2","4.4":"a #1 #2","4.4.3-4.4.4":"a #1 #2"},"bb":{"7":"a #1 #2","10":"a #1 #2"},"op_mob":{"10":"a #1 #2","11":"a #1 #2","12":"a #1 #2","59":"a #1 #2","11.1":"a #1 #2","11.5":"a #1 #2","12.1":"a #1 #2"},"and_chr":{"86":"a #2"},"and_ff":{"82":"a #2"},"ie_mob":{"10":"a #1 #2","11":"a #1 #2"},"and_uc":{"12.12":"a #1 #2"},"samsung":{"4":"a #1 #2","5.0-5.4":"a #1 #2","6.2-6.4":"a #1 #2","7.2-7.4":"a #1 #2","8.2":"a #1 #2","9.2":"a #1 #2","10.1":"a #1 #2","11.1-11.2":"a #1 #2","12.0":"a #1 #2"},"and_qq":{"10.4":"a #1 #2"},"baidu":{"7.12":"a #1 #2"},"kaios":{"2.5":"a #1 #2"}},"notes":"Effectively all browsers support the CSS 2.1 definition for single-value `overflow` as well as `overflow-x` & `overflow-y` and values `visible`, `hidden`, `scroll` & `auto`","notes_by_num":{"1":"Does not support the two value `overflow` shorthand","2":"Does not support the `clip` value"},"usage_perc_y":0,"usage_perc_a":99.7,"ucprefix":false,"parent":"","keywords":"overflow:hidden,overflow:scroll,overflow:clip","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-overflow-anchor":{"title":"CSS overflow-anchor (Scroll Anchoring)","description":"Changes in DOM elements above the visible region of a scrolling box can result in the page moving while the user is in the middle of consuming the content.\r\nBy default, the value of  `overflow-anchor` is `auto`, it can mitigate this jarring user experience by keeping track of the position of an anchor node and adjusting the scroll offset accordingly","spec":"https://wicg.github.io/ScrollAnchoring/","status":"wd","links":[{"url":"https://github.com/WICG/ScrollAnchoring/blob/master/explainer.md","title":"Explainer"},{"url":"https://developers.google.com/web/updates/2016/04/scroll-anchoring","title":"Google developers article"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":76.77,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"overflow-anchor,scroll anchoring","ie_id":"","chrome_id":"5700102471548928","firefox_id":"","webkit_id":""},"css-overscroll-behavior":{"title":"CSS overscroll-behavior","description":"CSS property to control the behavior when the scroll position of a scroll container reaches the edge of the scrollport.","spec":"https://drafts.csswg.org/css-overscroll-behavior-1/","status":"unoff","links":[{"url":"https://ebidel.github.io/demos/chatbox.html","title":"Demo"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/32172871-implement-css-overscroll-behavior","title":"UserVoice support request for Edge"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=951793#c11","title":"Firefox implementation bug"},{"url":"https://developers.google.com/web/updates/2017/11/overscroll-behavior","title":"Google Developers blog post on overflow-behavior"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=176454","title":"WebKit support bug"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"a #1","11":"a #1","5.5":"n"},"edge":{"12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #3","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"a #2","64":"a #2","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"a #2","51":"a #2","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"a #1","11":"a #1"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Supports the precursor version of the property: [`-ms-scroll-chaining`](https://msdn.microsoft.com/en-us/library/hh772034%28v=vs.85%29.aspx), which works similarly. IE support is limited to Windows 8 & above","2":"Does not support `overscroll-behavior: none;` on the body element to prevent the overscroll glow and rubberbanding effects.","3":"Incorrectly treats `none` as `contain` see [MDN](https://developer.mozilla.org/en-US/docs/Web/CSS/overscroll-behavior#Browser_compatibility) and [Edge 18 changelog](https://aka.ms/devguide_edgehtml_18)"},"usage_perc_y":76.7,"usage_perc_a":1.59,"ucprefix":false,"parent":"","keywords":"scroll-boundary-behavior,overscroll-behavior-x,overscroll-behavior-y,-ms-scroll-chaining","ie_id":"","chrome_id":"5734614437986304","firefox_id":"","webkit_id":""},"css-page-break":{"title":"CSS page-break properties","description":"Properties to control the way elements are broken across (printed) pages.","spec":"https://www.w3.org/TR/CSS2/page.html#page-breaks","status":"rec","links":[{"url":"https://css-tricks.com/almanac/properties/p/page-break/","title":"CSS Tricks article"},{"url":"https://drafts.csswg.org/css-break-3/#break-between","title":"Latest fragmentation specification (includes column & region breaks)"}],"categories":["CSS"],"stats":{"ie":{"6":"a #1 #2 #3","7":"a #1 #2 #3","8":"a #1 #2 #3","9":"a #1 #2 #3","10":"a #1 #2","11":"a #1 #2","5.5":"a #1 #2 #3"},"edge":{"12":"a #1 #2","13":"a #1 #2","14":"a #1 #2","15":"a #1 #2","16":"a #1 #2","17":"a #1 #2","18":"a #1 #2","79":"a #1 #2 #3","80":"a #1 #2 #3","81":"a #1 #2 #3","83":"a #1 #2 #3","84":"a #1 #2 #3","85":"a #1 #2 #3","86":"a #1 #2 #3","87":"a #1 #2 #3"},"firefox":{"2":"a #1 #2 #3","3":"a #1 #2 #3","4":"a #1 #2 #3","5":"a #1 #2 #3","6":"a #1 #2 #3","7":"a #1 #2 #3","8":"a #1 #2 #3","9":"a #1 #2 #3","10":"a #1 #2 #3","11":"a #1 #2 #3","12":"a #1 #2 #3","13":"a #1 #2 #3","14":"a #1 #2 #3","15":"a #1 #2 #3","16":"a #1 #2 #3","17":"a #1 #2 #3","18":"a #1 #2 #3","19":"a #1 #2 #3","20":"a #1 #2 #3","21":"a #1 #2 #3","22":"a #1 #2 #3","23":"a #1 #2 #3","24":"a #1 #2 #3","25":"a #1 #2 #3","26":"a #1 #2 #3","27":"a #1 #2 #3","28":"a #1 #2 #3","29":"a #1 #2 #3","30":"a #1 #2 #3","31":"a #1 #2 #3","32":"a #1 #2 #3","33":"a #1 #2 #3","34":"a #1 #2 #3","35":"a #1 #2 #3","36":"a #1 #2 #3","37":"a #1 #2 #3","38":"a #1 #2 #3","39":"a #1 #2 #3","40":"a #1 #2 #3","41":"a #1 #2 #3","42":"a #1 #2 #3","43":"a #1 #2 #3","44":"a #1 #2 #3","45":"a #1 #2 #3","46":"a #1 #2 #3","47":"a #1 #2 #3","48":"a #1 #2 #3","49":"a #1 #2 #3","50":"a #1 #2 #3","51":"a #1 #2 #3","52":"a #1 #2 #3","53":"a #1 #2 #3","54":"a #1 #2 #3","55":"a #1 #2 #3","56":"a #1 #2 #3","57":"a #1 #2 #3","58":"a #1 #2 #3","59":"a #1 #2 #3","60":"a #1 #2 #3","61":"a #1 #2 #3","62":"a #1 #2 #3","63":"a #1 #2 #3","64":"a #1 #2 #3","65":"a #2 #3","66":"a #2 #3","67":"a #2 #3","68":"a #2 #3","69":"a #2 #3","70":"a #2 #3","71":"a #2 #3","72":"a #2 #3","73":"a #2 #3","74":"a #2 #3","75":"a #2 #3","76":"a #2 #3","77":"a #2 #3","78":"a #2 #3","79":"a #2 #3","80":"a #2 #3","81":"a #2 #3","82":"a #2 #3","83":"a #2 #3","84":"a #2 #3","85":"a #2 #3","3.5":"a #1 #2 #3","3.6":"a #1 #2 #3"},"chrome":{"4":"a #1 #2 #3","5":"a #1 #2 #3","6":"a #1 #2 #3","7":"a #1 #2 #3","8":"a #1 #2 #3","9":"a #1 #2 #3","10":"a #1 #2 #3","11":"a #1 #2 #3","12":"a #1 #2 #3","13":"a #1 #2 #3","14":"a #1 #2 #3","15":"a #1 #2 #3","16":"a #1 #2 #3","17":"a #1 #2 #3","18":"a #1 #2 #3","19":"a #1 #2 #3","20":"a #1 #2 #3","21":"a #1 #2 #3","22":"a #1 #2 #3","23":"a #1 #2 #3","24":"a #1 #2 #3","25":"a #1 #2 #3","26":"a #1 #2 #3","27":"a #1 #2 #3","28":"a #1 #2 #3","29":"a #1 #2 #3","30":"a #1 #2 #3","31":"a #1 #2 #3","32":"a #1 #2 #3","33":"a #1 #2 #3","34":"a #1 #2 #3","35":"a #1 #2 #3","36":"a #1 #2 #3","37":"a #1 #2 #3","38":"a #1 #2 #3","39":"a #1 #2 #3","40":"a #1 #2 #3","41":"a #1 #2 #3","42":"a #1 #2 #3","43":"a #1 #2 #3","44":"a #1 #2 #3","45":"a #1 #2 #3","46":"a #1 #2 #3","47":"a #1 #2 #3","48":"a #1 #2 #3","49":"a #1 #2 #3","50":"a #1 #2 #3","51":"a #1 #2 #3","52":"a #1 #2 #3","53":"a #1 #2 #3","54":"a #1 #2 #3","55":"a #1 #2 #3","56":"a #1 #2 #3","57":"a #1 #2 #3","58":"a #1 #2 #3","59":"a #1 #2 #3","60":"a #1 #2 #3","61":"a #1 #2 #3","62":"a #1 #2 #3","63":"a #1 #2 #3","64":"a #1 #2 #3","65":"a #1 #2 #3","66":"a #1 #2 #3","67":"a #1 #2 #3","68":"a #1 #2 #3","69":"a #1 #2 #3","70":"a #1 #2 #3","71":"a #1 #2 #3","72":"a #1 #2 #3","73":"a #1 #2 #3","74":"a #1 #2 #3","75":"a #1 #2 #3","76":"a #1 #2 #3","77":"a #1 #2 #3","78":"a #1 #2 #3","79":"a #1 #2 #3","80":"a #1 #2 #3","81":"a #1 #2 #3","83":"a #1 #2 #3","84":"a #1 #2 #3","85":"a #1 #2 #3","86":"a #1 #2 #3","87":"a #1 #2 #3","88":"a #1 #2 #3","89":"a #1 #2 #3","90":"a #1 #2 #3"},"safari":{"4":"a #1 #2 #3","5":"a #1 #2 #3","6":"a #1 #2 #3","7":"a #1 #2 #3","8":"a #1 #2 #3","9":"a #1 #2 #3","10":"a #2 #3","11":"a #1 #2 #3","12":"a #1 #2 #3","13":"a #1 #2 #3","14":"a #1 #2 #3","3.1":"a #1 #2 #3","3.2":"a #1 #2 #3","5.1":"a #1 #2 #3","6.1":"a #1 #2 #3","7.1":"a #1 #2 #3","9.1":"a #1 #2 #3","10.1":"a #1 #2 #3","11.1":"a #1 #2 #3","12.1":"a #1 #2 #3","13.1":"a #1 #2 #3","TP":"a #1 #2 #3"},"opera":{"9":"u","11":"y #1","12":"y #1","15":"a #1 #2 #3","16":"a #1 #2 #3","17":"a #1 #2 #3","18":"a #1 #2 #3","19":"a #1 #2 #3","20":"a #1 #2 #3","21":"a #1 #2 #3","22":"a #1 #2 #3","23":"a #1 #2 #3","24":"a #1 #2 #3","25":"a #1 #2 #3","26":"a #1 #2 #3","27":"a #1 #2 #3","28":"a #1 #2 #3","29":"a #1 #2 #3","30":"a #1 #2 #3","31":"a #1 #2 #3","32":"a #1 #2 #3","33":"a #1 #2 #3","34":"a #1 #2 #3","35":"a #1 #2 #3","36":"a #1 #2 #3","37":"a #1 #2 #3","38":"a #1 #2 #3","39":"a #1 #2 #3","40":"a #1 #2 #3","41":"a #1 #2 #3","42":"a #1 #2 #3","43":"a #1 #2 #3","44":"a #1 #2 #3","45":"a #1 #2 #3","46":"a #1 #2 #3","47":"a #1 #2 #3","48":"a #1 #2 #3","49":"a #1 #2 #3","50":"a #1 #2 #3","51":"a #1 #2 #3","52":"a #1 #2 #3","53":"a #1 #2 #3","54":"a #1 #2 #3","55":"a #1 #2 #3","56":"a #1 #2 #3","57":"a #1 #2 #3","58":"a #1 #2 #3","60":"a #1 #2 #3","62":"a #1 #2 #3","63":"a #1 #2 #3","64":"a #1 #2 #3","65":"a #1 #2 #3","66":"a #1 #2 #3","67":"a #1 #2 #3","68":"a #1 #2 #3","69":"a #1 #2 #3","70":"a #1 #2 #3","71":"a #1 #2 #3","72":"a #1 #2 #3","9.5-9.6":"u","10.0-10.1":"y #1","10.5":"y #1","10.6":"y #1","11.1":"y #1","11.5":"y #1","11.6":"y #1","12.1":"y #1"},"ios_saf":{"8":"a #1 #2 #3","14":"a #1 #2 #3","3.2":"a #1 #2 #3","4.0-4.1":"a #1 #2 #3","4.2-4.3":"a #1 #2 #3","5.0-5.1":"a #1 #2 #3","6.0-6.1":"a #1 #2 #3","7.0-7.1":"a #1 #2 #3","8.1-8.4":"a #1 #2 #3","9.0-9.2":"a #1 #2 #3","9.3":"a #1 #2 #3","10.0-10.2":"a #1 #2 #3","10.3":"a #1 #2 #3","11.0-11.2":"a #1 #2 #3","11.3-11.4":"a #1 #2 #3","12.0-12.1":"a #1 #2 #3","12.2-12.4":"a #1 #2 #3","13.0-13.1":"a #1 #2 #3","13.2":"a #1 #2 #3","13.3":"a #1 #2 #3","13.4-13.7":"a #1 #2 #3"},"op_mini":{"all":"y #1"},"android":{"3":"a #1 #2 #3","4":"a #1 #2 #3","81":"a #1 #2 #3","2.1":"a #1 #2 #3","2.2":"a #1 #2 #3","2.3":"a #1 #2 #3","4.1":"a #1 #2 #3","4.2-4.3":"a #1 #2 #3","4.4":"a #1 #2 #3","4.4.3-4.4.4":"a #1 #2 #3"},"bb":{"7":"a #1 #2 #3","10":"a #1 #2 #3"},"op_mob":{"10":"y #1","11":"y #1","12":"y #1","59":"a #1 #2 #3","11.1":"y #1","11.5":"y #1","12.1":"y #1"},"and_chr":{"86":"a #1 #2 #3"},"and_ff":{"82":"a #1 #2 #3"},"ie_mob":{"10":"a #1 #2","11":"a #1 #2"},"and_uc":{"12.12":"a #1 #2 #3"},"samsung":{"4":"a #1 #2 #3","5.0-5.4":"a #1 #2 #3","6.2-6.4":"a #1 #2 #3","7.2-7.4":"a #1 #2 #3","8.2":"a #1 #2 #3","9.2":"a #1 #2 #3","10.1":"a #1 #2 #3","11.1-11.2":"a #1 #2 #3","12.0":"a #1 #2 #3"},"and_qq":{"10.4":"a #1 #2 #3"},"baidu":{"7.12":"a #1 #2 #3"},"kaios":{"2.5":"a #1 #2 #3"}},"notes":"Not all mobile browsers offer print support; support listed for these is based on browser engine capability.","notes_by_num":{"1":"Supports the `page-break-*` alias from the CSS 2.1 specification, but not the `break-*` properties from the latest spec.","2":"Does not support `avoid` for `page-break-before` & `page-break-after` (only `page-break-inside`).","3":"Treats the `left` and `right` values like `always`."},"usage_perc_y":0.93,"usage_perc_a":98.75,"ucprefix":false,"parent":"","keywords":"page-break-before,page-break-after,page-break-inside,always,avoid","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-paged-media":{"title":"CSS Paged Media (@page)","description":"CSS at-rule (`@page`) to define page-specific rules when printing web pages, such as margin per page and page dimensions.","spec":"https://drafts.csswg.org/css-page-3/","status":"wd","links":[{"url":"https://www.tutorialspoint.com/css/css_paged_media.htm","title":"CSS Paged media article"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/@page","title":"MDN Web Docs - CSS @page"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=85062","title":"WebKit support bug"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=286443","title":"Firefox support bug"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/12839052-css-paged-media-module-level-3","title":"Edge support request"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"a #1","9":"a #1","10":"a #1","11":"a #1","5.5":"n"},"edge":{"12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","59":"a #1","60":"a #1","61":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #1","66":"a #1","67":"a #1","68":"a #1","69":"a #1","70":"a #1","71":"a #1","72":"a #1","73":"a #1","74":"a #1","75":"a #1","76":"a #1","77":"a #1","78":"a #1","79":"a #1","80":"a #1","81":"a #1","82":"a #1","83":"a #1","84":"a #1","85":"a #1","3.5":"n","3.6":"n"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"a #1","11":"a #1","12":"a #1","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"a #1","10.0-10.1":"a #1","10.5":"a #1","10.6":"a #1","11.1":"a #1","11.5":"a #1","11.6":"a #1","12.1":"a #1"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"u"},"android":{"3":"u","4":"u","81":"u","2.1":"u","2.2":"u","2.3":"u","4.1":"u","4.2-4.3":"u","4.4":"u","4.4.3-4.4.4":"u"},"bb":{"7":"u","10":"u"},"op_mob":{"10":"u","11":"u","12":"u","59":"n #2","11.1":"u","11.5":"u","12.1":"u"},"and_chr":{"86":"y"},"and_ff":{"82":"a #1"},"ie_mob":{"10":"n #2","11":"n #2"},"and_uc":{"12.12":"n #2"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"a #1"}},"notes":"Currently no browsers appear to support the `marks` & `bleed` properties from the latest version of the specification.\r\n\r\n","notes_by_num":{"1":"Does not support the `size` property","2":"Does not appear to have a way to print web pages"},"usage_perc_y":74.59,"usage_perc_a":5.95,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-paint-api":{"title":"CSS Paint API","description":"Allows programmatic generation of images used by CSS","spec":"https://drafts.css-houdini.org/css-paint-api/","status":"wd","links":[{"url":"https://developers.google.com/web/updates/2018/01/paintapi","title":"Google CSS Paint API Introduction"},{"url":"https://ishoudinireadyyet.com/","title":"Is Houdini Ready Yet?"}],"categories":["CSS","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n d #1","14":"n d #1","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n d #1","13.1":"n d #1","TP":"n d #1"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Can be enabled using the Develop > Experimental Features menu."},"usage_perc_y":70.04,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"houdini","ie_id":"","chrome_id":"5685444318593024","firefox_id":"","webkit_id":"specification-css-painting-api-level-1"},"css-placeholder":{"title":"::placeholder CSS pseudo-element","description":"The ::placeholder pseudo-element represents placeholder text in an input field: text that represents the input and provides a hint to the user on how to fill out the form. For example, a date-input field might have the placeholder text `YYYY-MM-DD` to clarify that numeric dates are to be entered in year-month-day order.","spec":"https://drafts.csswg.org/css-pseudo-4/#placeholder-pseudo","status":"wd","links":[{"url":"https://css-tricks.com/snippets/css/style-placeholder-text/","title":"CSS-Tricks article with all prefixes"},{"url":"http://wiki.csswg.org/ideas/placeholder-styling","title":"CSSWG discussion"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/::-moz-placeholder","title":"MDN Web Docs - CSS ::-moz-placeholder"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1069012","title":"Mozilla Bug 1069012 - unprefix :placeholder-shown pseudo-class and ::placeholder pseudo-element"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/::placeholder","title":"MDN web docs - ::placeholder"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"a x","13":"a x","14":"a x","15":"a x","16":"a x","17":"a x","18":"a x","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"a x","5":"a x","6":"a x","7":"a x","8":"a x","9":"a x","10":"a x","11":"a x","12":"a x","13":"a x","14":"a x","15":"a x","16":"a x","17":"a x","18":"a x","19":"a x","20":"a x","21":"a x","22":"a x","23":"a x","24":"a x","25":"a x","26":"a x","27":"a x","28":"a x","29":"a x","30":"a x","31":"a x","32":"a x","33":"a x","34":"a x","35":"a x","36":"a x","37":"a x","38":"a x","39":"a x","40":"a x","41":"a x","42":"a x","43":"a x","44":"a x","45":"a x","46":"a x","47":"a x","48":"a x","49":"a x","50":"a x","51":"a x","52":"a x","53":"a x","54":"a x","55":"a x","56":"a x","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"a x","6":"a x","7":"a x","8":"a x","9":"a x","10":"a x","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"a x","6.1":"a x","7.1":"a x","9.1":"a x","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"a x","16":"a x","17":"a x","18":"a x","19":"a x","20":"a x","21":"a x","22":"a x","23":"a x","24":"a x","25":"a x","26":"a x","27":"a x","28":"a x","29":"a x","30":"a x","31":"a x","32":"a x","33":"a x","34":"a x","35":"a x","36":"a x","37":"a x","38":"a x","39":"a x","40":"a x","41":"a x","42":"a x","43":"a x","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a x","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"a x","5.0-5.1":"a x","6.0-6.1":"a x","7.0-7.1":"a x","8.1-8.4":"a x","9.0-9.2":"a x","9.3":"a x","10.0-10.2":"a x","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"a x","4":"a x","81":"y","2.1":"a x","2.2":"a x","2.3":"a x","4.1":"a x","4.2-4.3":"a x","4.4":"a x","4.4.3-4.4.4":"a x"},"bb":{"7":"a x","10":"a x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a x","11":"a x"},"and_uc":{"12.12":"y"},"samsung":{"4":"a x","5.0-5.4":"a x","6.2-6.4":"a x","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y x"}},"notes":"Partial support refers to using alternate names:\r\n`::-webkit-input-placeholder` for Chrome/Safari/Opera ([Chrome issue #623345](https://bugs.chromium.org/p/chromium/issues/detail?id=623345)) \r\n`::-ms-input-placeholder` for Edge (also supports webkit prefix)","notes_by_num":{"1":"Firefox 18 and below supported the `:-moz-placeholder` pseudo-class rather than the `::-moz-placeholder` pseudo-element."},"usage_perc_y":94.84,"usage_perc_a":2.35,"ucprefix":false,"parent":"","keywords":"::placeholder,placeholder","ie_id":"","chrome_id":"6715780926275584","firefox_id":"","webkit_id":""},"css-placeholder-shown":{"title":":placeholder-shown CSS pseudo-class","description":"Input elements can sometimes show placeholder text as a hint to the user on what to type in. See, for example, the placeholder attribute in HTML5. The :placeholder-shown pseudo-class matches an input element that is showing such placeholder text.","spec":"https://www.w3.org/TR/selectors4/#placeholder","status":"wd","links":[{"url":"http://trac.webkit.org/changeset/172826","title":"WebKit commit"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1069015","title":"Firefox bug"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/12435951--placeholder-shown-css-pseudo-class","title":"Microsoft Edge feature request on UserVoice"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"a x #2","11":"a x #2","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a x #1","5":"a x #1","6":"a x #1","7":"a x #1","8":"a x #1","9":"a x #1","10":"a x #1","11":"a x #1","12":"a x #1","13":"a x #1","14":"a x #1","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","19":"a x #1","20":"a x #1","21":"a x #1","22":"a x #1","23":"a x #1","24":"a x #1","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"a x #1"}},"notes":"For support of styling the actual placeholder text itself, see [CSS ::placeholder](https://caniuse.com/#feat=css-placeholder)","notes_by_num":{"1":"Partial support in Firefox refers to using the non-standard `:-moz-placeholder` name rather than `:placeholder-shown`.","2":"Partial support in IE refers to using the non-standard `:-ms-input-placeholder` name rather than `:placeholder-shown`."},"usage_perc_y":95.43,"usage_perc_a":1.5,"ucprefix":false,"parent":"","keywords":":placeholder-shown,placeholder-shown,placeholder","ie_id":"","chrome_id":"6404760559157248","firefox_id":"","webkit_id":"feature-css-selector-:placeholder-shown"},"css-read-only-write":{"title":"CSS :read-only and :read-write selectors","description":":read-only and :read-write pseudo-classes to match elements which are considered user-alterable","spec":"https://html.spec.whatwg.org/multipage/semantics-other.html#selector-read-only","status":"ls","links":[{"url":"https://css-tricks.com/almanac/selectors/r/read-write-read/","title":"CSS Tricks article"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/%3Aread-only","title":"MDN :read-only"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/:read-write","title":"MDN Web Docs - CSS :read-write"},{"url":"https://drafts.csswg.org/selectors-4/#rw-pseudos","title":"Selectors Level 4 § The Mutability Pseudo-classes: :read-only and :read-write"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=312971","title":"Firefox feature request bug"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"u","3":"y x","4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","59":"y x","60":"y x","61":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y x","70":"y x","71":"y x","72":"y x","73":"y x","74":"y x","75":"y x","76":"y x","77":"y x","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y x","3.6":"y x"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"u","5.1":"a #1","6.1":"a #1","7.1":"a #1","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"u","12":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"u","10.0-10.1":"u","10.5":"u","10.6":"u","11.1":"u","11.5":"a #1","11.6":"a #1","12.1":"a #1"},"ios_saf":{"8":"a #1","14":"y","3.2":"u","4.0-4.1":"u","4.2-4.3":"a #1","5.0-5.1":"a #1","6.0-6.1":"a #1","7.0-7.1":"a #1","8.1-8.4":"a #1","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"a #1","4":"a #1","81":"y","2.1":"u","2.2":"u","2.3":"a #1","4.1":"a #1","4.2-4.3":"a #1","4.4":"a #1","4.4.3-4.4.4":"a #1"},"bb":{"7":"a #1","10":"y"},"op_mob":{"10":"n","11":"n","12":"a #1","59":"y","11.1":"n","11.5":"a #1","12.1":"a #1"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y x"}},"notes":"","notes_by_num":{"1":"Supports selector only for input and textarea fields, but not for contenteditable"},"usage_perc_y":96.64,"usage_perc_a":0.58,"ucprefix":false,"parent":"","keywords":"css,selector,read-only,read-write","ie_id":"cssmutabilitypseudoclasses","chrome_id":"","firefox_id":"","webkit_id":""},"css-rebeccapurple":{"title":"Rebeccapurple color","description":"The new color added in CSS Color Module Level 4","spec":"https://www.w3.org/TR/css-color-4/#valdef-color-rebeccapurple","status":"wd","links":[{"url":"https://codepen.io/trezy/post/honoring-a-great-man","title":"Codepen blog post"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"a #1","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"u","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Only works in IE11 for Windows 10, not older versions of Windows"},"usage_perc_y":96.53,"usage_perc_a":1.09,"ucprefix":false,"parent":"","keywords":"rebeccapurple,beccapurple","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-reflections":{"title":"CSS Reflections","description":"Method of displaying a reflection of an element","spec":"http://webkit.org/blog/182/css-reflections/","status":"unoff","links":[{"url":"http://webkit.org/blog/182/css-reflections/","title":"WebKit blog post"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/7930470-support-css-reflections","title":"Microsoft Edge feature request on UserVoice"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y x","80":"y x","81":"y x","83":"y x","84":"y x","85":"y x","86":"y x","87":"y x"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","59":"y x","60":"y x","61":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y x","70":"y x","71":"y x","72":"y x","73":"y x","74":"y x","75":"y x","76":"y x","77":"y x","78":"y x","79":"y x","80":"y x","81":"y x","83":"y x","84":"y x","85":"y x","86":"y x","87":"y x","88":"y x","89":"y x","90":"y x"},"safari":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","3.1":"n","3.2":"n","5.1":"y x","6.1":"y x","7.1":"y x","9.1":"y x","10.1":"y x","11.1":"y x","12.1":"y x","13.1":"y x","TP":"y x"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","60":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y x","70":"y x","71":"y x","72":"y x","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y x","3.2":"y x","4.0-4.1":"y x","4.2-4.3":"y x","5.0-5.1":"y x","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y x","10.3":"y x","11.0-11.2":"y x","11.3-11.4":"y x","12.0-12.1":"y x","12.2-12.4":"y x","13.0-13.1":"y x","13.2":"y x","13.3":"y x","13.4-13.7":"y x"},"op_mini":{"all":"n"},"android":{"3":"y x","4":"y x","81":"y x","2.1":"y x","2.2":"y x","2.3":"y x","4.1":"y x","4.2-4.3":"y x","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"y x","10":"y x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y x","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y x"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"y x","5.0-5.4":"y x","6.2-6.4":"y x","7.2-7.4":"y x","8.2":"y x","9.2":"y x","10.1":"y x","11.1-11.2":"y x","12.0":"y x"},"and_qq":{"10.4":"y x"},"baidu":{"7.12":"y x"},"kaios":{"2.5":"n"}},"notes":"Similar effect can be achieved in Firefox 4+ using the -moz-element() background property","notes_by_num":{},"usage_perc_y":91.47,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"box-reflect","ie_id":"","chrome_id":"5627300510957568","firefox_id":"","webkit_id":""},"css-regions":{"title":"CSS Regions","description":"Method of flowing content into multiple elements.","spec":"https://www.w3.org/TR/css3-regions/","status":"wd","links":[{"url":"http://html.adobe.com/webstandards/cssregions/","title":"Adobe demos and samples"},{"url":"http://msdn.microsoft.com/en-us/ie/hh272902#_CSSConnected","title":"IE10 developer guide info"},{"url":"https://www.webplatform.org/docs/css/atrules/@region","title":"WebPlatform Docs"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=674802","title":"Firefox feature request bug"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"a x #1 #2","11":"a x #1 #2","5.5":"n"},"edge":{"12":"a x #1 #2","13":"a x #1 #2","14":"a x #1 #2","15":"a x #1 #2","16":"a x #1 #2","17":"a x #1 #2","18":"a x #1 #2","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"a x","16":"a x","17":"a x","18":"a x","19":"n d","20":"n d","21":"n d","22":"n d","23":"n d","24":"n d","25":"n d","26":"n d","27":"n d","28":"n d","29":"n d","30":"n d","31":"n d","32":"n d","33":"n d","34":"n d","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"y x","7.1":"y x","9.1":"y x","10.1":"y x","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y x","10.3":"y x","11.0-11.2":"y x","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"a x #1 #2","11":"a x #1 #2"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Support is limited to using an iframe as a content source with the `-ms-flow-into: flow_name;` and `-ms-flow-from: flow_name;` syntax.","2":"Partial support refers to not supporting the `region-fragment` property."},"usage_perc_y":0.94,"usage_perc_a":1.56,"ucprefix":false,"parent":"","keywords":"","ie_id":"regions","chrome_id":"5655612935372800","firefox_id":"","webkit_id":""},"css-repeating-gradients":{"title":"CSS Repeating Gradients","description":"Method of defining a repeating linear or radial color gradient as a CSS image.","spec":"https://www.w3.org/TR/css3-images/#repeating-gradients","status":"cr","links":[{"url":"https://developer.mozilla.org/en/CSS/repeating-linear-gradient","title":"MDN Web Docs - CSS repeating linear gradient"},{"url":"https://www.webplatform.org/docs/css/repeating-linear-gradient","title":"WebPlatform Docs"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"y x"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y x","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y x","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"y x","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"a x","11.5":"a x","11.6":"y x","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y x","6.0-6.1":"y x","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"y x","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y x","4.2-4.3":"y x","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"y x","59":"y","11.1":"a x","11.5":"a x","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Firefox 10+, Chrome 26+ and Opera 11.6+ also support the new \"to (side)\" syntax.","notes_by_num":{},"usage_perc_y":98.38,"usage_perc_a":0.01,"ucprefix":false,"parent":"css-gradients","keywords":"repeating-linear-gradient,repeating-radial-gradient","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-resize":{"title":"CSS resize property","description":"Method of allowing an element to be resized by the user, with options to limit to a given direction. ","spec":"https://www.w3.org/TR/css3-ui/#resize","status":"cr","links":[{"url":"https://css-tricks.com/almanac/properties/r/resize/","title":"CSS Tricks info"},{"url":"https://davidwalsh.name/textarea-resize","title":"On textarea resizing"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6513977-css-resize-property","title":"Microsoft Edge feature request on UserVoice"},{"url":"https://catalin.red/css-resize-none-is-bad-for-ux/","title":"CSS resize none on textarea is bad for UX"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y x","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"a #1"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Presto-based Opera 12.10+ currently only supports the resize property for textarea elements."},"usage_perc_y":84.12,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"horizontal,vertical","ie_id":"cssresize","chrome_id":"","firefox_id":"","webkit_id":""},"css-revert-value":{"title":"CSS revert value","description":"A CSS keyword value that resets a property's value to the default specified by the browser in its UA stylesheet, as if the webpage had not included any CSS. For example, `display:revert` on a `<div>` would result in `display:block`. This is in contrast to the `initial` value, which is simply defined on a per-property basis, and for `display` would be `inline`.","spec":"https://www.w3.org/TR/css-cascade-4/#valdef-all-revert","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/revert","title":"MDN Web Docs - CSS revert"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1215878","title":"Firefox feature request bug"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/10469316-the-css4-revert-value","title":"Microsoft Edge feature request on UserVoice"},{"url":"https://code.google.com/p/chromium/issues/detail?id=579788","title":"Chrome feature request issue"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":86.94,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"CSS,reset,value","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-rrggbbaa":{"title":"#rrggbbaa hex color notation","description":"The CSS Color Module Level 4 defines new 4 & 8 character hex notation for color to include the opacity level.","spec":"https://drafts.csswg.org/css-color/#hex-notation","status":"unoff","links":[{"url":"http://jsbin.com/ruyetahatu/edit?html,css,output","title":"JS Bin testcase"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/17366608--rrggbbaa-and-rgba-color-notation-support","title":"Edge support request for rrggbbaa"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n d #1","53":"n d #1","54":"n d #1","55":"n d #1","56":"n d #1","57":"n d #1","58":"n d #1","59":"n d #1","60":"n d #1","61":"n d #1","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n d #1","40":"n d #1","41":"n d #1","42":"n d #1","43":"n d #1","44":"n d #1","45":"n d #1","46":"n d #1","47":"n d #1","48":"n d #1","49":"n d #1","50":"n d #1","51":"n d #1","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n d #1","6.2-6.4":"n d #1","7.2-7.4":"n d #1","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n d #1"},"kaios":{"2.5":"n"}},"notes":"Only supported in Android WebViews in apps that target Android Pie, due to [this issue](https://bugs.chromium.org/p/chromium/issues/detail?id=618472)","notes_by_num":{"1":"Can be enabled via the \"Experimental web platform features\" flag."},"usage_perc_y":93,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"rgba, rrggbbaa, color","ie_id":"","chrome_id":"5685348285808640","firefox_id":"","webkit_id":""},"css-scroll-behavior":{"title":"CSSOM Scroll-behavior","description":"Method of specifying the scrolling behavior for a scrolling box, when scrolling happens due to navigation or CSSOM scrolling APIs.","spec":"https://drafts.csswg.org/cssom-view/#propdef-scroll-behavior","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/scroll-behavior","title":"MDN Web Docs - CSS scroll-behavior"},{"url":"https://code.google.com/p/chromium/issues/detail?id=243871","title":"Chrome launch bug "},{"url":"https://blog.gospodarets.com/native_smooth_scrolling","title":"Blog post with demo"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=188043","title":"iOS / WebKit bug report"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y #1","80":"y #1","81":"y #1","83":"y #1","84":"y #1","85":"y #1","86":"y #1","87":"y #1"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n d #1 #2","42":"n d #1 #2","43":"n d #1 #2","44":"n d #1 #2","45":"n d #1 #2","46":"n d #1 #2","47":"n d #1 #2","48":"n d #1 #2","49":"n d #1 #2","50":"n d #1 #2","51":"n d #1 #2","52":"n d #1 #2","53":"n d #1 #2","54":"n d #1 #2","55":"n d #1 #2","56":"n d #1 #2","57":"n d #1 #2","58":"n d #1 #2","59":"n d #1 #2","60":"n d #1 #2","61":"y #1","62":"y #1","63":"y #1","64":"y #1","65":"y #1","66":"y #1","67":"y #1","68":"y #1","69":"y #1","70":"y #1","71":"y #1","72":"y #1","73":"y #1","74":"y #1","75":"y #1","76":"y #1","77":"y #1","78":"y #1","79":"y #1","80":"y #1","81":"y #1","83":"y #1","84":"y #1","85":"y #1","86":"y #1","87":"y #1","88":"y #1","89":"y #1","90":"y #1"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n d #1 #2","29":"n d #1 #2","30":"n d #1 #2","31":"n d #1 #2","32":"n d #1 #2","33":"n d #1 #2","34":"n d #1 #2","35":"n d #1 #2","36":"n d #1 #2","37":"n d #1 #2","38":"n d #1 #2","39":"n d #1 #2","40":"n d #1 #2","41":"n d #1 #2","42":"n d #1 #2","43":"n d #1 #2","44":"n d #1 #2","45":"n d #1 #2","46":"n d #1 #2","47":"n d #1 #2","48":"y #1","49":"y #1","50":"y #1","51":"y #1","52":"y #1","53":"y #1","54":"y #1","55":"y #1","56":"y #1","57":"y #1","58":"y #1","60":"y #1","62":"y #1","63":"y #1","64":"y #1","65":"y #1","66":"y #1","67":"y #1","68":"y #1","69":"y #1","70":"y #1","71":"y #1","72":"y #1","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y #1"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y #1"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Partial support refers to support everything except of `Element.scrollIntoView()` and not together with pinch viewport.","2":"Supported in Chrome and Opera behind the 'Smooth Scrolling' and/or 'Enable experimental web platform features' flag"},"usage_perc_y":78.54,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"smooth,scroll,cssom,scroll-behavior","ie_id":"cssomviewsmoothscrollapi","chrome_id":"5812155903377408","firefox_id":"","webkit_id":""},"css-scrollbar":{"title":"CSS scrollbar styling","description":"Methods of styling scrollbars' color and width.","spec":"https://drafts.csswg.org/css-scrollbars-1/","status":"unoff","links":[{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1460109","title":"Firefox support bug"},{"url":"https://stackoverflow.com/questions/9251354/css-customized-scroll-bar-in-div/14150577#14150577","title":"Stackoverflow article discussiong cross-browser support"},{"url":"http://codemug.com/html/custom-scrollbars-using-css/","title":"Tutorial for IE & WebKit/Blink browsers"},{"url":"http://utatti.github.io/perfect-scrollbar/","title":"\"perfect-scrollbar\" - Minimal custom scrollbar plugin"},{"url":"http://manos.malihu.gr/jquery-custom-content-scroller/","title":"jQuery custom content scroller"},{"url":"https://webkit.org/blog/363/styling-scrollbars/","title":"Webkit blog post describing their non-standard support"}],"categories":["CSS"],"stats":{"ie":{"6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","5.5":"a #1"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"a x #2","80":"a x #2","81":"a x #2","83":"a x #2","84":"a x #2","85":"a x #2","86":"a x #2","87":"a x #2"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n #4 #5","64":"a #6","65":"a #6","66":"a #6","67":"a #6","68":"a #6","69":"a #6","70":"a #6","71":"a #6","72":"a #6","73":"a #6","74":"a #6","75":"a #6","76":"a #6","77":"a #6","78":"a #6","79":"a #6","80":"a #6","81":"a #6","82":"a #6","83":"a #6","84":"a #6","85":"a #6","3.5":"n","3.6":"n"},"chrome":{"4":"a x #2","5":"a x #2","6":"a x #2","7":"a x #2","8":"a x #2","9":"a x #2","10":"a x #2","11":"a x #2","12":"a x #2","13":"a x #2","14":"a x #2","15":"a x #2","16":"a x #2","17":"a x #2","18":"a x #2","19":"a x #2","20":"a x #2","21":"a x #2","22":"a x #2","23":"a x #2","24":"a x #2","25":"a x #2","26":"a x #2","27":"a x #2","28":"a x #2","29":"a x #2","30":"a x #2","31":"a x #2","32":"a x #2","33":"a x #2","34":"a x #2","35":"a x #2","36":"a x #2","37":"a x #2","38":"a x #2","39":"a x #2","40":"a x #2","41":"a x #2","42":"a x #2","43":"a x #2","44":"a x #2","45":"a x #2","46":"a x #2","47":"a x #2","48":"a x #2","49":"a x #2","50":"a x #2","51":"a x #2","52":"a x #2","53":"a x #2","54":"a x #2","55":"a x #2","56":"a x #2","57":"a x #2","58":"a x #2","59":"a x #2","60":"a x #2","61":"a x #2","62":"a x #2","63":"a x #2","64":"a x #2","65":"a x #2","66":"a x #2","67":"a x #2","68":"a x #2","69":"a x #2","70":"a x #2","71":"a x #2","72":"a x #2","73":"a x #2","74":"a x #2","75":"a x #2","76":"a x #2","77":"a x #2","78":"a x #2","79":"a x #2","80":"a x #2","81":"a x #2","83":"a x #2","84":"a x #2","85":"a x #2","86":"a x #2","87":"a x #2","88":"a x #2","89":"a x #2","90":"a x #2"},"safari":{"4":"u","5":"u","6":"a x #2","7":"a x #2","8":"a x #2","9":"a x #2","10":"a x #2","11":"a x #2","12":"a x #2","13":"a x #2","14":"a x #2","3.1":"u","3.2":"u","5.1":"a x #2","6.1":"a x #2","7.1":"a x #2","9.1":"a x #2","10.1":"a x #2","11.1":"a x #2","12.1":"a x #2","13.1":"a x #2","TP":"a x #2"},"opera":{"9":"n","11":"n","12":"n","15":"a x #2","16":"a x #2","17":"a x #2","18":"a x #2","19":"a x #2","20":"a x #2","21":"a x #2","22":"a x #2","23":"a x #2","24":"a x #2","25":"a x #2","26":"a x #2","27":"a x #2","28":"a x #2","29":"a x #2","30":"a x #2","31":"a x #2","32":"a x #2","33":"a x #2","34":"a x #2","35":"a x #2","36":"a x #2","37":"a x #2","38":"a x #2","39":"a x #2","40":"a x #2","41":"a x #2","42":"a x #2","43":"a x #2","44":"a x #2","45":"a x #2","46":"a x #2","47":"a x #2","48":"a x #2","49":"a x #2","50":"a x #2","51":"a x #2","52":"a x #2","53":"a x #2","54":"a x #2","55":"a x #2","56":"a x #2","57":"a x #2","58":"a x #2","60":"a x #2","62":"a x #2","63":"a x #2","64":"a x #2","65":"a x #2","66":"a x #2","67":"a x #2","68":"a x #2","69":"a x #2","70":"a x #2","71":"a x #2","72":"a x #2","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a x #2 #3","14":"a x #2 #3","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"u","6.0-6.1":"u","7.0-7.1":"a x #2","8.1-8.4":"a x #2 #3","9.0-9.2":"a x #2 #3","9.3":"a x #2 #3","10.0-10.2":"a x #2 #3","10.3":"a x #2 #3","11.0-11.2":"a x #2 #3","11.3-11.4":"a x #2 #3","12.0-12.1":"a x #2 #3","12.2-12.4":"a x #2 #3","13.0-13.1":"a x #2 #3","13.2":"a x #2 #3","13.3":"a x #2 #3","13.4-13.7":"a x #2 #3"},"op_mini":{"all":"n"},"android":{"3":"a x #2","4":"a x #2","81":"a x #2","2.1":"u","2.2":"u","2.3":"a x #2","4.1":"a x #2","4.2-4.3":"a x #2","4.4":"a x #2","4.4.3-4.4.4":"a x #2"},"bb":{"7":"a x #2","10":"a x #2"},"op_mob":{"10":"n","11":"n","12":"n","59":"a x #2","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a x #2"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"a x #2"},"samsung":{"4":"a x #2","5.0-5.4":"a x #2","6.2-6.4":"a x #2","7.2-7.4":"a x #2","8.2":"a x #2","9.2":"a x #2","10.1":"a x #2","11.1-11.2":"a x #2","12.0":"a x #2"},"and_qq":{"10.4":"a x #2"},"baidu":{"7.12":"a x #2"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Only supports styling scrollbar colors through proprietary prefixed properties, no other properties to define the scrollbar's appearance. (not on standards track)","2":"Supports scrollbar styling via CSS [pseudo-properties](https://webkit.org/blog/363/styling-scrollbars/). (not on standards track)","3":"Scrollbar styling doesn’t work in [WKWebView](https://issues.apache.org/jira/browse/CB-10123)","4":"Can be enabled by setting the layout.css.scrollbar-colors.enabled and layout.css.scrollbar-width.enabled flags to true.","5":"Firefox 63 supported scrollbar-face-color and scrollbar-track-color seperate properties (now dropped from the spec) instead of unified scrollbar-color property.","6":"Firefox neither supports `light` and `dark` values of scrollbar-color nor `<length>` values of scrollbar width"},"usage_perc_y":0,"usage_perc_a":97.43,"ucprefix":false,"parent":"","keywords":"scrollbar-button,scrollbar-track,scrollbar-thumb,scrollbar-base-color,scrollbar-face-color,scrollbar-color,scrollbar-width","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-sel2":{"title":"CSS 2.1 selectors","description":"Basic CSS selectors including: `*` (universal selector), `>` (child selector), `:first-child`, `:link`, `:visited`, `:active`, `:hover`, `:focus`, `:lang()`, `+` (adjacent sibling selector), `[attr]`, `[attr=\"val\"]`, `[attr~=\"val\"]`, `[attr|=\"bar\"]`, `.foo` (class selector), `#foo` (id selector)","spec":"https://www.w3.org/TR/CSS21/selector.html","status":"rec","links":[{"url":"https://www.quirksmode.org/css/contents.html","title":"Detailed support information"},{"url":"http://www.yourhtmlsource.com/stylesheets/advancedselectors.html","title":"Examples of advanced selectors"},{"url":"http://selectivizr.com","title":"Selectivizr: Polyfill for IE6-8"},{"url":"https://www.webplatform.org/docs/css/selectors","title":"WebPlatform Docs"}],"categories":["CSS2"],"stats":{"ie":{"6":"p","7":"y","8":"y","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Support for `:visited` styling [varies across browsers](http://sixrevisions.com/css/visited-pseudo-class-strange/) due to security concerns.","notes_by_num":{},"usage_perc_y":99.68,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"attribute selector","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-sel3":{"title":"CSS3 selectors","description":"Advanced element selection using selectors including: `[foo^=\"bar\"]`, `[foo$=\"bar\"]`, `[foo*=\"bar\"]`, `:root`, `:nth-child()`,  `:nth-last-child()`, `:nth-of-type()`, `:nth-last-of-type()`, `:last-child`, `:first-of-type`, `:last-of-type`, `:only-child`, `:only-of-type`, `:empty`, `:target`, `:enabled`, `:disabled`, `:checked`, `:not()`, `~` (general sibling)","spec":"https://www.w3.org/TR/css3-selectors/","status":"rec","links":[{"url":"https://www.quirksmode.org/css/selectors/","title":"Detailed support information"},{"url":"http://www.css3.info/selectors-test/","title":"Automated CSS3 selector test"},{"url":"http://selectivizr.com","title":"Selectivizr: Polyfill for IE6-8"},{"url":"https://www.webplatform.org/docs/css/selectors","title":"WebPlatform Docs"}],"categories":["CSS3"],"stats":{"ie":{"6":"p","7":"a #1","8":"a #1","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"IE7 and IE8 support only these CSS3 selectors: General siblings (`element1~element2`) and Attribute selectors `[attr^=val]`, `[attr$=val]`, and `[attr*=val]`"},"usage_perc_y":99.59,"usage_perc_a":0.07,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-selection":{"title":"::selection CSS pseudo-element","description":"The ::selection CSS pseudo-element applies rules to the portion of a document that has been highlighted (e.g., selected with the mouse or another pointing device) by the user.","spec":"https://www.w3.org/TR/css-pseudo-4/#selectordef-selection","status":"wd","links":[{"url":"http://quirksmode.org/css/selectors/selection.html","title":"::selection test"},{"url":"https://www.webplatform.org/docs/css/selectors/pseudo-elements/::selection","title":"WebPlatform Docs"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/::selection","title":"MDN web docs"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y x","3":"y x","4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","59":"y x","60":"y x","61":"y x","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y x","3.6":"y x"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"u","11":"u","12":"y","59":"y","11.1":"u","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y x"}},"notes":"","notes_by_num":{},"usage_perc_y":86.31,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"::selection,selection","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-shapes":{"title":"CSS Shapes Level 1","description":"Allows geometric shapes to be set in CSS to define an area for text to flow around. Includes properties `shape-outside`, `shape-margin` and `shape-image-threshold`","spec":"https://www.w3.org/TR/css-shapes/","status":"cr","links":[{"url":"http://alistapart.com/article/css-shapes-101","title":"A List Apart article"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1040714","title":"Firefox tracking bug"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n d #2","52":"n d #2","53":"n d #2","54":"n d #2","55":"n d #2","56":"n d #2","57":"n d #2","58":"n d #2","59":"n d #2","60":"n d #2","61":"n d #2","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n d #1","35":"n d #1","36":"n d #1","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"y x","9":"y x","10":"y x","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"y x","9.1":"y x","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y x","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Enabled in Chrome through the \"experimental Web Platform features\" flag in chrome://flags","2":"Partially supported in Firefox by enabling \"layout.css.shape-outside.enabled\" in about:config"},"usage_perc_y":95.71,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"circle,ellipse,polygon,inset,shape-outside,shape-margin,shape-image-threshold","ie_id":"shapes","chrome_id":"5163890719588352","firefox_id":"css-shapes","webkit_id":"feature-css-shapes-level-1"},"css-snappoints":{"title":"CSS Scroll Snap","description":"CSS technique that allows customizable scrolling experiences like pagination of carousels by setting defined snap positions.","spec":"https://www.w3.org/TR/css-scroll-snap-1/","status":"cr","links":[{"url":"http://generatedcontent.org/post/66817675443/setting-native-like-scrolling-offsets-in-css-with","title":"Blog post"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Scroll_Snap_Points","title":"MDN Web Docs - CSS Scroll snap points"},{"url":"https://github.com/ckrack/scrollsnap-polyfill","title":"Polyfill - based on an [older version](https://www.w3.org/TR/2015/WD-css-snappoints-1-20150326/) of the spec"},{"url":"https://www.npmjs.com/package/css-scroll-snap-polyfill","title":"Polyfill - based on the [current version](https://www.w3.org/TR/css-scroll-snap-1/) of the spec"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Scroll_Snap","title":"MDN Web Docs - CSS Scroll Snap"},{"url":"https://github.com/filamentgroup/snapper","title":"A CSS Snap Points based carousel (and lightweight polyfill) "}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"a x #1 #5 #6","11":"a x #2 #5 #6","5.5":"n"},"edge":{"12":"a x #2 #5 #6","13":"a x #2 #5 #6","14":"a x #2 #5 #6","15":"a x #2 #5 #6","16":"a x #2 #5 #6","17":"a x #2 #5 #6","18":"a x #2 #5 #6","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"a #5","40":"a #5","41":"a #5","42":"a #5","43":"a #5","44":"a #5","45":"a #5","46":"a #5","47":"a #5","48":"a #5","49":"a #5","50":"a #5","51":"a #5","52":"a #5","53":"a #5","54":"a #5","55":"a #5","56":"a #5","57":"a #5","58":"a #5","59":"a #5","60":"a #5","61":"a #5","62":"a #5","63":"a #5","64":"a #5","65":"a #5","66":"a #5","67":"a #5","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n d #7","67":"n d #7","68":"n d #7","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"a x #4 #5","10":"a x #4 #5","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"a x #4 #5","10.1":"a x #4 #5","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n d #7","55":"n d #7","56":"n d #7","57":"n d #7","58":"n d #7","60":"n d #7","62":"n d #7","63":"n d #7","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"a x #4 #5","9.3":"a x #4 #5","10.0-10.2":"a x #4 #5","10.3":"a x #4 #5","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"a #5"}},"notes":"Works in the iOS WKWebView, but not UIWebView.","notes_by_num":{"1":"Partial support in IE10 refers to support limited to touch screens.","2":"Partial support in IE11 [documented here](https://web.archive.org/web/20160616212557/https://dl.dropboxusercontent.com/u/444684/openwebref/CSS/scroll-snap-points/support.html)","4":"Partial support in Safari refers to not supporting the `none` keyword in `scroll-snap-points-x`, `scroll-snap-points-y` and `scroll-snap-coordinate`, and length keywords (`top`, `right`, etc.) in `scroll-snap-destination` and `scroll-snap-coordinate`.","5":"Supports properties from an [older version](https://www.w3.org/TR/2015/WD-css-snappoints-1-20150326/) of the spec.","6":"Partial support in IE & Edge refers to not supporting `scroll-snap-coordinate` and `scroll-snap-destination`.","7":"Available behind the \"Experimental Web Platform features\" feature flag"},"usage_perc_y":91.98,"usage_perc_a":2.63,"ucprefix":false,"parent":"","keywords":"scroll-margin,scroll-snap-points-x,scroll-snap-points-y,scroll-snap-type,scroll-snap-destination,scroll-snap-coordinate,scroll-snap-margin,scroll-snap-align","ie_id":"cssscrollsnappoints","chrome_id":"5721832506261504","firefox_id":"","webkit_id":"specification-css-scroll-snap-points-module-level-1"},"css-sticky":{"title":"CSS position:sticky","description":"Keeps elements positioned as \"fixed\" or \"relative\" depending on how it appears in the viewport. As a result the element is \"stuck\" when necessary while scrolling.","spec":"https://drafts.csswg.org/css-position/#sticky-pos","status":"wd","links":[{"url":"https://developers.google.com/web/updates/2012/08/Stick-your-landings-position-sticky-lands-in-WebKit","title":"HTML5Rocks"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/position","title":"MDN Web Docs - CSS position"},{"url":"https://www.webplatform.org/docs/css/properties/position","title":"WebPlatform Docs"},{"url":"https://github.com/dollarshaveclub/stickybits","title":"Polyfill"},{"url":"https://github.com/wilddeer/stickyfill","title":"Another polyfill"},{"url":"https://mastery.games/post/position-sticky/","title":"geddski article: Examples and Gotchas"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"a #6","17":"a #6","18":"a #6","79":"a #4","80":"a #4","81":"a #4","83":"a #4","84":"a #4","85":"a #4","86":"a #4","87":"a #4"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n d #1","27":"n d #1","28":"n d #1","29":"n d #1","30":"n d #1","31":"n d #1","32":"a #3","33":"a #3","34":"a #3","35":"a #3","36":"a #3","37":"a #3","38":"a #3","39":"a #3","40":"a #3","41":"a #3","42":"a #3","43":"a #3","44":"a #3","45":"a #3","46":"a #3","47":"a #3","48":"a #3","49":"a #3","50":"a #3","51":"a #3","52":"a #3","53":"a #3","54":"a #3","55":"a #3","56":"a #3","57":"a #3","58":"a #3","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n d #2","24":"n d #2","25":"n d #2","26":"n d #2","27":"n d #2","28":"n d #2","29":"n d #2","30":"n d #2","31":"n d #2","32":"n d #2","33":"n d #2","34":"n d #2","35":"n d #2","36":"n d #2","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n d #2","53":"n d #2","54":"n d #2","55":"n d #2","56":"a #4","57":"a #4","58":"a #4","59":"a #4","60":"a #4","61":"a #4","62":"a #4","63":"a #4","64":"a #4","65":"a #4","66":"a #4","67":"a #4","68":"a #4","69":"a #4","70":"a #4","71":"a #4","72":"a #4","73":"a #4","74":"a #4","75":"a #4","76":"a #4","77":"a #4","78":"a #4","79":"a #4","80":"a #4","81":"a #4","83":"a #4","84":"a #4","85":"a #4","86":"a #4","87":"a #4","88":"a #4","89":"a #4","90":"a #4"},"safari":{"4":"n","5":"n","6":"n","7":"a x #5","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"a x #5","7.1":"y x","9.1":"y x","10.1":"y x","11.1":"y x","12.1":"y x","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n d #2","40":"n d #2","41":"n d #2","42":"a #4","43":"a #4","44":"a #4","45":"a #4","46":"a #4","47":"a #4","48":"a #4","49":"a #4","50":"a #4","51":"a #4","52":"a #4","53":"a #4","54":"a #4","55":"a #4","56":"a #4","57":"a #4","58":"a #4","60":"a #4","62":"a #4","63":"a #4","64":"a #4","65":"a #4","66":"a #4","67":"a #4","68":"a #4","69":"a #4","70":"a #4","71":"a #4","72":"a #4","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"a x #5","7.0-7.1":"a x #5","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y x","10.3":"y x","11.0-11.2":"y x","11.3-11.4":"y x","12.0-12.1":"y x","12.2-12.4":"y x","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"a #4","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"a #4","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a #4"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"a #4"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"a #4"},"baidu":{"7.12":"n"},"kaios":{"2.5":"a #3"}},"notes":"Any ancestor between the sticky element and its user-scrollable container with overflow computed as anything but `visible`/`clip` will effectively prevent sticking behavior.","notes_by_num":{"1":"Can be enabled in Firefox by setting the about:config preference layout.css.sticky.enabled to true","2":"Enabled through the \"experimental Web Platform features\" flag","3":"Not supported on any `table` parts - See [Firefox bug](https://bugzilla.mozilla.org/show_bug.cgi?id=975644)","4":"Supported on `th` elements, but not `thead` or `tr` - See [Chrome bug](https://bugs.chromium.org/p/chromium/issues/detail?id=702927)","5":"Do not appear to support sticky table headers","6":"Supported on `th` elements, but not `thead` or `tr` - See [Edge bug](https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/16765952/)"},"usage_perc_y":23.22,"usage_perc_a":72.43,"ucprefix":false,"parent":"","keywords":"","ie_id":"positionsticky","chrome_id":"6190250464378880","firefox_id":"","webkit_id":"feature-position:-sticky"},"css-subgrid":{"title":"CSS Subgrid","description":"Feature of the CSS Grid Layout Module Level 2 that allows a grid-item with its own grid to align in one or both dimensions with its parent grid.","spec":"https://www.w3.org/TR/css-grid-2/#subgrids","status":"wd","links":[{"url":"https://www.smashingmagazine.com/2018/07/css-grid-2/","title":"CSS Grid Level 2: Here Comes Subgrid"},{"url":"https://dev.to/kenbellows/why-we-need-css-subgrid-53mh","title":" Why we need CSS subgrid "},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1240834","title":"Firefox support bug"},{"url":"https://crbug.com/618969","title":"Chromium support bug"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=202115","title":"Webkit support bug"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":3.53,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"grid-template-columns:subgrid,grid-template-rows:subgrid","ie_id":"","chrome_id":"","firefox_id":"css-subgrids","webkit_id":""},"css-supports-api":{"title":"CSS.supports() API","description":"The CSS.supports() static methods returns a Boolean value indicating if the browser supports a given CSS feature, or not.","spec":"https://drafts.csswg.org/css-conditional/#the-css-interface","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/CSS.supports","title":"MDN Web Docs - CSS supports()"},{"url":"http://jsbin.com/rimevilotari/1/edit","title":"Demo (Chinese)"},{"url":"https://dev.opera.com/articles/native-css-feature-detection/","title":"Native CSS Feature Detection via the @supports Rule"},{"url":"https://davidwalsh.name/css-supports","title":"CSS @supports"},{"url":"http://blog.csdn.net/hfahe/article/details/8619480","title":"Article (Chinese)"}],"categories":["DOM","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"a #2","13":"a #2","14":"a #2","15":"a #2","16":"a #2","17":"a #2","18":"a #2","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n d","21":"n d","22":"a #2","23":"a #2","24":"a #2","25":"a #2","26":"a #2","27":"a #2","28":"a #2","29":"a #2","30":"a #2","31":"a #2","32":"a #2","33":"a #2","34":"a #2","35":"a #2","36":"a #2","37":"a #2","38":"a #2","39":"a #2","40":"a #2","41":"a #2","42":"a #2","43":"a #2","44":"a #2","45":"a #2","46":"a #2","47":"a #2","48":"a #2","49":"a #2","50":"a #2","51":"a #2","52":"a #2","53":"a #2","54":"a #2","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"a #2","29":"a #2","30":"a #2","31":"a #2","32":"a #2","33":"a #2","34":"a #2","35":"a #2","36":"a #2","37":"a #2","38":"a #2","39":"a #2","40":"a #2","41":"a #2","42":"a #2","43":"a #2","44":"a #2","45":"a #2","46":"a #2","47":"a #2","48":"a #2","49":"a #2","50":"a #2","51":"a #2","52":"a #2","53":"a #2","54":"a #2","55":"a #2","56":"a #2","57":"a #2","58":"a #2","59":"a #2","60":"a #2","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"a #1"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"a #1"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"a #1"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"See also [@supports in CSS](#feat=css-featurequeries)","notes_by_num":{"1":"Partial support in Presto-based Opera browsers refers to using an older API (`window.supportsCSS`)","2":"Does not support parentheses-less one-argument version."},"usage_perc_y":95.36,"usage_perc_a":2.2,"ucprefix":false,"parent":"","keywords":"conditional","ie_id":"conditionalrules","chrome_id":"4993981813358592","firefox_id":"","webkit_id":""},"css-table":{"title":"CSS Table display","description":"Method of displaying elements as tables, rows, and cells. Includes support for all `display: table-*` properties as well as `display: inline-table`","spec":"https://www.w3.org/TR/CSS21/tables.html","status":"rec","links":[{"url":"http://www.onenaught.com/posts/201/use-css-displaytable-for-layout","title":"Blog post on usage"}],"categories":["CSS2"],"stats":{"ie":{"6":"n","7":"n","8":"y","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"a #1","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Firefox 2 does not support `inline-table`"},"usage_perc_y":99.67,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"display:table,table-cell,table-row,table-layout","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-text-align-last":{"title":"CSS3 text-align-last","description":"CSS property to describe how the last line of a block or a line right before a forced line break when `text-align` is `justify`.","spec":"https://www.w3.org/TR/css3-text/#text-align-last-property","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/text-align-last","title":"MDN Web Docs - CSS text-align-last"},{"url":"http://blogs.adobe.com/webplatform/2014/02/25/improving-your-sites-visual-details-css3-text-align-last/","title":"Adobe Web Platform Article"}],"categories":["CSS3"],"stats":{"ie":{"6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","5.5":"a #1"},"edge":{"12":"a","13":"a","14":"a","15":"a","16":"a","17":"a","18":"a","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n d #2","36":"n d #2","37":"n d #2","38":"n d #2","39":"n d #2","40":"n d #2","41":"n d #2","42":"n d #2","43":"n d #2","44":"n d #2","45":"n d #2","46":"n d #2","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n d #3","23":"n d #3","24":"n d #3","25":"n d #3","26":"n d #3","27":"n d #3","28":"n d #3","29":"n d #3","30":"n d #3","31":"n d #3","32":"n d #3","33":"n d #3","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #1","11":"a #1"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y x"}},"notes":"","notes_by_num":{"1":"In Internet Explorer, the start and end values are not supported.","2":"Enabled through the \"Enable Experimental Web Platform Features\" flag in chrome://flags","3":"Enabled through the \"Enable Experimental Web Platform Features\" flag in opera://flags"},"usage_perc_y":79.15,"usage_perc_a":1.83,"ucprefix":false,"parent":"","keywords":"text align last","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-text-indent":{"title":"CSS text-indent","description":"The `text-indent` property applies indentation to lines of inline content in a block.","spec":"https://drafts.csswg.org/css-text-3/#text-indent-property","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/text-indent","title":"MDN Web Docs - CSS text-indent"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=784648","title":"Firefox support bug"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=112755","title":"WebKit support bug"},{"url":"https://www.sitepoint.com/css-image-replacement-text-indent-negative-margins-and-more/","title":"Article on using text-indent for image replacement"}],"categories":["CSS"],"stats":{"ie":{"6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","5.5":"a #1"},"edge":{"12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","79":"a #1 #2","80":"a #1 #2","81":"a #1 #2","83":"a #1 #2","84":"a #1 #2","85":"a #1 #2","86":"a #1 #2","87":"a #1 #2"},"firefox":{"2":"a #1","3":"a #1","4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","59":"a #1","60":"a #1","61":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #1","66":"a #1","67":"a #1","68":"a #1","69":"a #1","70":"a #1","71":"a #1","72":"a #1","73":"a #1","74":"a #1","75":"a #1","76":"a #1","77":"a #1","78":"a #1","79":"a #1","80":"a #1","81":"a #1","82":"a #1","83":"a #1","84":"a #1","85":"a #1","3.5":"a #1","3.6":"a #1"},"chrome":{"4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1 #2","39":"a #1 #2","40":"a #1 #2","41":"a #1 #2","42":"a #1 #2","43":"a #1 #2","44":"a #1 #2","45":"a #1 #2","46":"a #1 #2","47":"a #1 #2","48":"a #1 #2","49":"a #1 #2","50":"a #1 #2","51":"a #1 #2","52":"a #1 #2","53":"a #1 #2","54":"a #1 #2","55":"a #1 #2","56":"a #1 #2","57":"a #1 #2","58":"a #1 #2","59":"a #1 #2","60":"a #1 #2","61":"a #1 #2","62":"a #1 #2","63":"a #1 #2","64":"a #1 #2","65":"a #1 #2","66":"a #1 #2","67":"a #1 #2","68":"a #1 #2","69":"a #1 #2","70":"a #1 #2","71":"a #1 #2","72":"a #1 #2","73":"a #1 #2","74":"a #1 #2","75":"a #1 #2","76":"a #1 #2","77":"a #1 #2","78":"a #1 #2","79":"a #1 #2","80":"a #1 #2","81":"a #1 #2","83":"a #1 #2","84":"a #1 #2","85":"a #1 #2","86":"a #1 #2","87":"a #1 #2","88":"a #1 #2","89":"a #1 #2","90":"a #1 #2"},"safari":{"4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","3.1":"a #1","3.2":"a #1","5.1":"a #1","6.1":"a #1","7.1":"a #1","9.1":"a #1","10.1":"a #1","11.1":"a #1","12.1":"a #1","13.1":"a #1","TP":"a #1"},"opera":{"9":"a #1","11":"a #1","12":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1 #2","26":"a #1 #2","27":"a #1 #2","28":"a #1 #2","29":"a #1 #2","30":"a #1 #2","31":"a #1 #2","32":"a #1 #2","33":"a #1 #2","34":"a #1 #2","35":"a #1 #2","36":"a #1 #2","37":"a #1 #2","38":"a #1 #2","39":"a #1 #2","40":"a #1 #2","41":"a #1 #2","42":"a #1 #2","43":"a #1 #2","44":"a #1 #2","45":"a #1 #2","46":"a #1 #2","47":"a #1 #2","48":"a #1 #2","49":"a #1 #2","50":"a #1 #2","51":"a #1 #2","52":"a #1 #2","53":"a #1 #2","54":"a #1 #2","55":"a #1 #2","56":"a #1 #2","57":"a #1 #2","58":"a #1 #2","60":"a #1 #2","62":"a #1 #2","63":"a #1 #2","64":"a #1 #2","65":"a #1 #2","66":"a #1 #2","67":"a #1 #2","68":"a #1 #2","69":"a #1 #2","70":"a #1 #2","71":"a #1 #2","72":"a #1 #2","9.5-9.6":"a #1","10.0-10.1":"a #1","10.5":"a #1","10.6":"a #1","11.1":"a #1","11.5":"a #1","11.6":"a #1","12.1":"a #1"},"ios_saf":{"8":"a #1","14":"a #1","3.2":"a #1","4.0-4.1":"a #1","4.2-4.3":"a #1","5.0-5.1":"a #1","6.0-6.1":"a #1","7.0-7.1":"a #1","8.1-8.4":"a #1","9.0-9.2":"a #1","9.3":"a #1","10.0-10.2":"a #1","10.3":"a #1","11.0-11.2":"a #1","11.3-11.4":"a #1","12.0-12.1":"a #1","12.2-12.4":"a #1","13.0-13.1":"a #1","13.2":"a #1","13.3":"a #1","13.4-13.7":"a #1"},"op_mini":{"all":"a #1"},"android":{"3":"a #1","4":"a #1","81":"a #1","2.1":"a #1","2.2":"a #1","2.3":"a #1","4.1":"a #1","4.2-4.3":"a #1","4.4":"a #1","4.4.3-4.4.4":"a #1"},"bb":{"7":"a #1","10":"a #1"},"op_mob":{"10":"a #1","11":"a #1","12":"a #1","59":"a #1 #2","11.1":"a #1","11.5":"a #1","12.1":"a #1"},"and_chr":{"86":"a #1 #2"},"and_ff":{"82":"a #1"},"ie_mob":{"10":"a #1","11":"a #1"},"and_uc":{"12.12":"a #1"},"samsung":{"4":"a #1","5.0-5.4":"a #1 #2","6.2-6.4":"a #1 #2","7.2-7.4":"a #1 #2","8.2":"a #1 #2","9.2":"a #1 #2","10.1":"a #1 #2","11.1-11.2":"a #1 #2","12.0":"a #1 #2"},"and_qq":{"10.4":"a #1 #2"},"baidu":{"7.12":"a #1 #2"},"kaios":{"2.5":"a #1"}},"notes":"","notes_by_num":{"1":"Partial support refers to supporting a `<length>` value, but not the `each-line` or `hanging` keywords.","2":"Support for `each-line` & `hanging` is available behind the Experimental Web Platform features flag"},"usage_perc_y":0,"usage_perc_a":99.7,"ucprefix":false,"parent":"","keywords":"each-line,hanging","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-text-justify":{"title":"CSS text-justify","description":"CSS property to define how text should be justified when `text-align: justify` is set.","spec":"https://drafts.csswg.org/css-text-3/#text-justify-property","status":"wd","links":[{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=248894","title":"Chrome support bug"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=99945","title":"WebKit support bug"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=276079","title":"Firefox support bug"}],"categories":["CSS"],"stats":{"ie":{"6":"u","7":"u","8":"a #1","9":"a #1","10":"a #1","11":"a #1","5.5":"u"},"edge":{"12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","79":"n d #2","80":"n d #2","81":"n d #2","83":"n d #2","84":"n d #2","85":"n d #2","86":"n d #2","87":"n d #2"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n d #3 #4","55":"y #4","56":"y #4","57":"y #4","58":"y #4","59":"y #4","60":"y #4","61":"y #4","62":"y #4","63":"y #4","64":"y #4","65":"y #4","66":"y #4","67":"y #4","68":"y #4","69":"y #4","70":"y #4","71":"y #4","72":"y #4","73":"y #4","74":"y #4","75":"y #4","76":"y #4","77":"y #4","78":"y #4","79":"y #4","80":"y #4","81":"y #4","82":"y #4","83":"y #4","84":"y #4","85":"y #4","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n d #2","44":"n d #2","45":"n d #2","46":"n d #2","47":"n d #2","48":"n d #2","49":"n d #2","50":"n d #2","51":"n d #2","52":"n d #2","53":"n d #2","54":"n d #2","55":"n d #2","56":"n d #2","57":"n d #2","58":"n d #2","59":"n d #2","60":"n d #2","61":"n d #2","62":"n d #2","63":"n d #2","64":"n d #2","65":"n d #2","66":"n d #2","67":"n d #2","68":"n d #2","69":"n d #2","70":"n d #2","71":"n d #2","72":"n d #2","73":"n d #2","74":"n d #2","75":"n d #2","76":"n d #2","77":"n d #2","78":"n d #2","79":"n d #2","80":"n d #2","81":"n d #2","83":"n d #2","84":"n d #2","85":"n d #2","86":"n d #2","87":"n d #2","88":"n d #2","89":"n d #2","90":"n d #2"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n d #2","31":"n d #2","32":"n d #2","33":"n d #2","34":"n d #2","35":"n d #2","36":"n d #2","37":"n d #2","38":"n d #2","39":"n d #2","40":"n d #2","41":"n d #2","42":"n d #2","43":"n d #2","44":"n d #2","45":"n d #2","46":"n d #2","47":"n d #2","48":"n d #2","49":"n d #2","50":"n d #2","51":"n d #2","52":"n d #2","53":"n d #2","54":"n d #2","55":"n d #2","56":"n d #2","57":"n d #2","58":"n d #2","60":"n d #2","62":"n d #2","63":"n d #2","64":"n d #2","65":"n d #2","66":"n d #2","67":"n d #2","68":"n d #2","69":"n d #2","70":"n d #2","71":"n d #2","72":"n d #2","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n d #2","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n d #2","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n d #2"},"and_ff":{"82":"y #4"},"ie_mob":{"10":"a #1","11":"a #1"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n d #2","6.2-6.4":"n d #2","7.2-7.4":"n d #2","8.2":"n d #2","9.2":"n d #2","10.1":"n d #2","11.1-11.2":"n d #2","12.0":"n d #2"},"and_qq":{"10.4":"n d #2"},"baidu":{"7.12":"n d #2"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Supports `inter-word`, but not `inter-character` or  `none`. Also supports the following unofficial values: `distribute` , `distribute-all-lines`, `distribute-center-last`, `inter-cluster`, `inter-ideograph`, `newspaper`. See [MDN](https://developer.mozilla.org/en-US/docs/Web/CSS/text-justify) for details.","2":"`inter-word` and `distribute` values supported behind the \"Experimental platform features\" flag but `distribute` support [is buggy](https://bugs.chromium.org/p/chromium/issues/detail?id=467406)","3":"Behind the \"layout.css.text-justify.enabled\" flag","4":"Supports `auto`, `none`, `inter-word`, `inter-character`, and `distribute` with the exact same meaning and behavior as `inter-character` for legacy reasons."},"usage_perc_y":3.71,"usage_perc_a":1.81,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-text-orientation":{"title":"CSS text-orientation","description":"The CSS `text-orientation` property specifies the orientation of text within a line. Current values only have an effect in vertical typographic modes (defined with the `writing-mode` property)","spec":"https://drafts.csswg.org/css-writing-modes-3/#text-orientation","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/text-orientation","title":"CSS text-orientation on MDN"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n d #1","39":"n d #1","40":"n d #1","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"u","11":"y x","12":"y x","13":"y x","14":"y x","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y x","11.1":"y x","12.1":"y x","13.1":"y x","TP":"y x"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Can be enabled on firefox via the 'layout.css.vertical-text.enabled' flag in about:config."},"usage_perc_y":95.18,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-textshadow":{"title":"CSS3 Text-shadow","description":"Method of applying one or more shadow or blur effects to text","spec":"https://www.w3.org/TR/css-text-decor-3/#text-shadow-property","status":"cr","links":[{"url":"https://hacks.mozilla.org/2009/06/text-shadow/","title":"Mozilla hacks article"},{"url":"https://testdrive-archive.azurewebsites.net/Graphics/hands-on-css3/hands-on_text-shadow.htm","title":"Live editor"},{"url":"https://www.webplatform.org/docs/css/properties/text-shadow","title":"WebPlatform Docs"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y #1","11":"y #1","5.5":"n"},"edge":{"12":"y #1","13":"y #1","14":"y #1","15":"y #1","16":"y #1","17":"y #1","18":"y #1","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a #2","3.2":"a #2","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"a"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"a","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y #1","11":"y #1"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Opera Mini ignores the blur-radius set, so no blur effect is visible. Text-shadow behavior can be somewhat emulated in older IE versions using the non-standard \"dropshadow\" or \"glow\" filters.","notes_by_num":{"1":"IE 10+ supports a fourth length value for the shadow's \"spread\". This is not (yet) part of the specification.","2":"Partial support in Safari 3.* refers to not supporting multiple shadows."},"usage_perc_y":98.5,"usage_perc_a":0.88,"ucprefix":false,"parent":"","keywords":"text shadow","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-touch-action":{"title":"CSS touch-action property","description":"touch-action is a CSS property that controls filtering of gesture events, providing developers with a declarative mechanism to selectively disable touch scrolling (in one or both axes) or double-tap-zooming.","spec":"https://www.w3.org/TR/pointerevents/#the-touch-action-css-property","status":"rec","links":[{"url":"http://msdn.microsoft.com/en-us/library/windows/apps/hh767313.aspx","title":"MSDN Docs"},{"url":"http://updates.html5rocks.com/2013/12/300ms-tap-delay-gone-away","title":"300ms tap delay, gone away"},{"url":"http://blogs.telerik.com/appbuilder/posts/13-11-21/what-exactly-is.....-the-300ms-click-delay","title":"What Exactly Is..... The 300ms Click Delay"},{"url":"http://thx.github.io/mobile/300ms-click-delay/","title":"What Exactly Is..... The 300ms Click Delay (Chinese)"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/touch-action","title":"MDN Web Docs - CSS touch-action"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=149854","title":"WebKit bug 149854: Implement touch-action: manipulation; for iOS"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=133112","title":"WebKit bug 133112: touch-action CSS property support"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y x #2","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n d #1","30":"n d #1","31":"n d #1","32":"n d #1","33":"n d #1","34":"n d #1","35":"n d #1","36":"n d #1","37":"n d #1","38":"n d #1","39":"n d #1","40":"n d #1","41":"n d #1","42":"n d #1","43":"n d #1","44":"n d #1","45":"n d #1","46":"n d #1","47":"n d #1","48":"n d #1","49":"n d #1","50":"n d #1","51":"n d #1","52":"y #4","53":"y #4","54":"y #4","55":"y #4","56":"y #4","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"a #3","10.0-10.2":"a #3","10.3":"a #3","11.0-11.2":"a #3","11.3-11.4":"a #3","12.0-12.1":"a #3","12.2-12.4":"a #3","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y x #2","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n d #1"}},"notes":"","notes_by_num":{"1":"Supported in Firefox behind the `layout.css.touch_action.enabled` flag, Firefox for Windows 8 Touch ('Metro') enabled by default.","2":"IE10+ has already supported these property which are not in standard at present such as `double-tap-zoom`, `cross-slide-x`, `cross-slide-y`.","3":"iOS Safari only supports `auto` and `manipulation`.","4":"Not applicable to Firefox platforms that support neither pointer nor touch events."},"usage_perc_y":90.23,"usage_perc_a":2.97,"ucprefix":false,"parent":"","keywords":"touch action","ie_id":"csstouchaction","chrome_id":"5912074022551552","firefox_id":"","webkit_id":""},"css-transitions":{"title":"CSS3 Transitions","description":"Simple method of animating certain properties of an element, with ability to define property, duration, delay and timing function. ","spec":"https://www.w3.org/TR/css3-transitions/","status":"wd","links":[{"url":"http://www.webdesignerdepot.com/2010/01/css-transitions-101/","title":"Article on usage"},{"url":"http://www.the-art-of-web.com/css/timing-function/","title":"Examples on timing functions"},{"url":"http://www.opera.com/docs/specs/presto2.12/css/transitions/","title":"Animation of property types support in Opera"},{"url":"https://www.webplatform.org/docs/css/properties/transition","title":"WebPlatform Docs"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a x #1","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a x #1","5":"a x #1","6":"y x","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a x #1","3.2":"a x #1","5.1":"y x","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"a x #1","12":"y x","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"a x #1","10.6":"a x #1","11.1":"a x #1","11.5":"a x #1","11.6":"a x #1","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"a x #1","4.0-4.1":"a x #1","4.2-4.3":"a x #1","5.0-5.1":"a x #1","6.0-6.1":"y x","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y x","4":"y x","81":"y","2.1":"y x","2.2":"y x","2.3":"y x","4.1":"y x","4.2-4.3":"y x","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y x","10":"y"},"op_mob":{"10":"a x #1","11":"a x #1","12":"y x","59":"y","11.1":"a x #1","11.5":"a x #1","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Support listed is for `transition` properties as well as the `transitionend` event.","notes_by_num":{"1":"Does not support the `steps()`, `step-start` & `step-end` timing functions"},"usage_perc_y":98.37,"usage_perc_a":0.11,"ucprefix":false,"parent":"","keywords":"css transition,transitionend,transition-property,transition-duration,transition-timing-function,transition-delay,steps,step-start,step-end,cubic-bezier","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-unset-value":{"title":"CSS unset value","description":"A CSS value that's the same as \"inherit\" if a property is inherited or \"initial\" if a property is not inherited.","spec":"https://www.w3.org/TR/css-cascade-3/#inherit-initial","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/unset","title":"MDN Web Docs - CSS unset"},{"url":"http://mcc.id.au/blog/2013/10/all-unset","title":"Resetting styles using `all: unset`"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=148614","title":"WebKit bug 148614: Add support for the `unset` CSS property value"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":96.33,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"CSS,unset,value","ie_id":"cssunsetvalue","chrome_id":"","firefox_id":"","webkit_id":""},"css-variables":{"title":"CSS Variables (Custom Properties)","description":"Permits the declaration and usage of cascading variables in stylesheets.","spec":"https://www.w3.org/TR/css-variables/","status":"cr","links":[{"url":"https://hacks.mozilla.org/2013/12/css-variables-in-firefox-nightly/","title":"Mozilla hacks article (older syntax)"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/Using_CSS_variables","title":"MDN Web Docs - Using CSS variables"},{"url":"https://blogs.windows.com/msedgedev/2017/03/24/css-custom-properties/","title":"Edge Dev Blog post"},{"url":"https://github.com/nuxodin/ie11CustomProperties","title":"Polyfill for IE11"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"a #2","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n d #1","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n d #1","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Enabled through the \"Experimental Web Platform features\" flag in `chrome://flags`","2":"Partial support is due to bugs present (see known issues)"},"usage_perc_y":95.72,"usage_perc_a":0.01,"ucprefix":false,"parent":"","keywords":"css variables,custom properties,var(),--var","ie_id":"csscustompropertiesakacssvariables","chrome_id":"6401356696911872","firefox_id":"css-variables","webkit_id":"specification-css-variables"},"css-widows-orphans":{"title":"CSS widows & orphans","description":"CSS properties to control when lines break across pages or columns by defining the amount of lines that must be left before or after the break.","spec":"https://drafts.csswg.org/css-break-3/#widows-orphans","status":"rec","links":[{"url":"http://thenewcode.com/946/CSS-last-line-Controlling-Widows-amp-Orphans","title":"CSS last-line: Controlling Widows & Orphans"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=137367","title":"Firefox support bug"},{"url":"http://tympanus.net/codrops/css_reference/orphans/","title":"codrops article on orphans"},{"url":"http://tympanus.net/codrops/css_reference/widows/","title":"codrops article on widows"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"y #1","9":"y #1","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y #1","11":"y #1","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y #1","10.0-10.1":"y #1","10.5":"y #1","10.6":"y #1","11.1":"y #1","11.5":"y #1","11.6":"y #1","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"Some older WebKit-based browsers recognize the properties, but do not appear to have actual support","notes_by_num":{"1":"Supports widows & orphans properties, but due to not supporting CSS multi-columns the support is only for page breaks (for print)"},"usage_perc_y":95.04,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-writing-mode":{"title":"CSS writing-mode property","description":"Property to define whether lines of text are laid out horizontally or vertically and the direction in which blocks progress.","spec":"https://drafts.csswg.org/css-writing-modes-3/#block-flow","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/writing-mode","title":"MDN Web Docs - CSS writing-mode"},{"url":"https://www.chromestatus.com/feature/5707470202732544","title":"Chrome Platform Status"}],"categories":["CSS"],"stats":{"ie":{"6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","5.5":"a #1"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n d #2","37":"n d #2","38":"n d #2","39":"n d #2","40":"n d #2","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"u","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"u","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y x","6.1":"y x","7.1":"y x","9.1":"y x","10.1":"y x","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"y x","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y x","10.3":"y x","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y x","4":"y x","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y x","4.2-4.3":"y x","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"y x","10":"y x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a x","11":"a x"},"and_uc":{"12.12":"y"},"samsung":{"4":"y x","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Internet Explorer supports different values from an [earlier version of the spec](https://www.w3.org/TR/2003/CR-css3-text-20030514/#Progression), which originated from SVG.","2":"Supported in Firefox under the `layout.css.vertical-text.enabled` flag"},"usage_perc_y":96.98,"usage_perc_a":1.44,"ucprefix":false,"parent":"","keywords":"css,writing,direction,i18n,vertical,ltr,rtl","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css-zoom":{"title":"CSS zoom","description":"Non-standard method of scaling content.","spec":"https://developer.mozilla.org/en-US/docs/Web/CSS/zoom","status":"unoff","links":[{"url":"https://css-tricks.com/almanac/properties/z/zoom/","title":"CSS Tricks"},{"url":"https://docs.webplatform.org/wiki/css/properties/zoom","title":"WebPlatform Docs"},{"url":"https://developer.apple.com/library/safari/documentation/AppleApplications/Reference/SafariCSSRef/Articles/StandardCSSProperties.html#//apple_ref/doc/uid/TP30001266-SW1","title":"Safari Developer Library"},{"url":"http://www.satzansatz.de/cssd/onhavinglayout.html","title":"Article explaining usage of zoom as the hack for fixing rendering bugs in IE6 and IE7."},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/zoom","title":"MDN Web Docs - CSS zoom"}],"categories":["CSS"],"stats":{"ie":{"6":"y","7":"y","8":"y #1","9":"y #1","10":"y #1","11":"y #1","5.5":"y"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"y #1","11":"y #1"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"Originally implemented only in Internet Explorer. Although several other browsers support the property, using `transform: scale()` is the recommended solution to scale content.","notes_by_num":{"1":"The `-ms-zoom` property is an extension to CSS, and can be used as a synonym for `zoom` in IE8 Standards mode."},"usage_perc_y":94.5,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"-ms-zoom,transform,-moz-transform,-ms-transform,-webkit-transform,-o-transform,scale,css-transforms","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css3-attr":{"title":"CSS3 attr() function for all properties","description":"While `attr()` is supported for effectively all browsers for the `content` property, CSS Values and Units Level 3 adds the ability to use `attr()` on **any** CSS property, and to use it for non-string values (e.g. numbers, colors).","spec":"https://www.w3.org/TR/css-values/#attr-notation","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/attr","title":"MDN Web Docs - CSS attr"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/7671960-css-attr-as-defined-in-css-values-level-3","title":"Microsoft Edge feature request on UserVoice"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=435426","title":"Mozilla Bug #435426: implement css3-values extensions to `attr()`"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=246571","title":"Chromium issue #246571: Implement CSS3 attribute / attr references"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=26609","title":"WebKit Bug #26609: Support CSS3 attr() function"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"See the [generated content](/#feat=css-gencontent) table for support for `attr()` for the `content` property.","notes_by_num":{},"usage_perc_y":0,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"attr,attribute,function","ie_id":"csslevel3attrfunction","chrome_id":"","firefox_id":"","webkit_id":""},"css3-boxsizing":{"title":"CSS3 Box-sizing","description":"Method of specifying whether or not an element's borders and padding should be included in size units","spec":"https://www.w3.org/TR/css-sizing/#box-sizing","status":"wd","links":[{"url":"https://developer.mozilla.org/En/CSS/Box-sizing","title":"MDN Web Docs - CSS box-sizing"},{"url":"http://www.456bereastreet.com/archive/201104/controlling_width_with_css3_box-sizing/","title":"Blog post"},{"url":"https://github.com/Schepp/box-sizing-polyfill","title":"Polyfill for IE"},{"url":"https://css-tricks.com/box-sizing/","title":"CSS Tricks"},{"url":"https://www.webplatform.org/docs/css/properties/box-sizing","title":"WebPlatform Docs"}],"categories":["CSS3"],"stats":{"ie":{"6":"p","7":"p","8":"y","9":"y","10":"y","11":"y","5.5":"p"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y x","3":"y x","4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y x","3.6":"y x"},"chrome":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y x","5":"y x","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y x","3.2":"y x","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y x","4.0-4.1":"y x","4.2-4.3":"y x","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y x","4":"y","81":"y","2.1":"y x","2.2":"y x","2.3":"y x","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y x","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Firefox versions before 57 also supported the `padding-box` value for `box-sizing`, though this value was been removed from the specification and later versions of the browser.","notes_by_num":{},"usage_perc_y":99.66,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"border-box,content-box","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css3-colors":{"title":"CSS3 Colors","description":"Method of describing colors using Hue, Saturation and Lightness (hsl()) rather than just RGB, as well as allowing alpha-transparency with rgba() and hsla().","spec":"https://www.w3.org/TR/css3-color/","status":"rec","links":[{"url":"https://dev.opera.com/articles/view/color-in-opera-10-hsl-rgb-and-alpha-transparency/","title":"Dev.Opera article"},{"url":"https://www.webplatform.org/docs/css/color#RGBA_Notation","title":"WebPlatform Docs"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"a","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"a","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":99.59,"usage_perc_a":0.01,"ucprefix":false,"parent":"","keywords":"rgb,hsl,rgba,hsla","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css3-cursors":{"title":"CSS3 Cursors (original values)","description":"CSS3 cursor values added in the 2004 spec, including none, context-menu, cell, vertical-text, alias, copy, no-drop, not-allowed, nesw-resize, nwse-resize, col-resize, row-resize and all-scroll. ","spec":"https://www.w3.org/TR/css3-ui/#cursor","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/cursor","title":"MDN Web Docs - CSS cursor"}],"categories":["CSS3"],"stats":{"ie":{"6":"a #1","7":"a #1","8":"a #1","9":"y","10":"y","11":"y","5.5":"a #1"},"edge":{"12":"a #2","13":"a #2","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"a","3":"a","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a","3.6":"a"},"chrome":{"4":"a","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a","3.2":"a","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"a #2","11":"a #2","12":"a #2","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"a #2","10.0-10.1":"a #2","10.5":"a #2","10.6":"a #2","11.1":"a #2","11.5":"a #2","11.6":"a #2","12.1":"a #2"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"u"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Partial support refers to no support for the alias, cell, copy, ew-resize, ns-resize, nesw-resize, nwse-resize or context-menu cursors.","2":"Partial support refers to not supporting 'none'."},"usage_perc_y":81.06,"usage_perc_a":0.22,"ucprefix":false,"parent":"","keywords":"cursors, pointers","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css3-cursors-grab":{"title":"CSS grab & grabbing cursors","description":"Support for the `grab` & `grabbing` values for the `cursor` property. Used to indicate that something can be grabbed (dragged to be moved).","spec":"https://www.w3.org/TR/css3-ui/#cursor","status":"pr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/cursor","title":"MDN Web Docs - CSS cursor"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y x","3":"y x","4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y x","3.6":"y x"},"chrome":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","59":"y x","60":"y x","61":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y","12":"y","13":"y","14":"y","3.1":"y x","3.2":"y x","5.1":"y x","6.1":"y x","7.1":"y x","9.1":"y x","10.1":"y x","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"y","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"y","12.1":"y"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"y x","10":"y x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y x","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"y x"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":79.99,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css3-cursors-newer":{"title":"CSS3 Cursors: zoom-in & zoom-out","description":"Support for `zoom-in`, `zoom-out` values for the CSS3 `cursor` property.","spec":"https://www.w3.org/TR/css3-ui/#cursor","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/cursor","title":"MDN Web Docs - CSS cursor"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y x","3":"y x","4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y x","3.6":"y x"},"chrome":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y x","3.2":"y x","5.1":"y x","6.1":"y x","7.1":"y x","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"y","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"y","12.1":"y"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"y x","10":"y x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":79.81,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"cursors, pointers","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"css3-tabsize":{"title":"CSS3 tab-size","description":"Method of customizing the width of the tab character. Only effective using 'white-space: pre' or 'white-space: pre-wrap'.","spec":"https://www.w3.org/TR/css3-text/#tab-size","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/tab-size","title":"MDN Web Docs - CSS tab-size"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6524689-tab-size-property","title":"Microsoft Edge feature request on UserVoice"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a x #1","5":"a x #1","6":"a x #1","7":"a x #1","8":"a x #1","9":"a x #1","10":"a x #1","11":"a x #1","12":"a x #1","13":"a x #1","14":"a x #1","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","19":"a x #1","20":"a x #1","21":"a x #1","22":"a x #1","23":"a x #1","24":"a x #1","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"a x #1","52":"a x #1","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","59":"y x","60":"y x","61":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y x","70":"y x","71":"y x","72":"y x","73":"y x","74":"y x","75":"y x","76":"y x","77":"y x","78":"y x","79":"y x","80":"y x","81":"y x","82":"y x","83":"y x","84":"y x","85":"y x","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"a #1","7.1":"a #1","9.1":"a #1","10.1":"a #1","11.1":"a #1","12.1":"a #1","13.1":"y","TP":"y"},"opera":{"9":"n","11":"a x #1","12":"a x #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"a x #1","11.1":"a x #1","11.5":"a x #1","11.6":"a x #1","12.1":"a x #1"},"ios_saf":{"8":"a #1","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"a #1","8.1-8.4":"a #1","9.0-9.2":"a #1","9.3":"a #1","10.0-10.2":"a #1","10.3":"a #1","11.0-11.2":"a #1","11.3-11.4":"a #1","12.0-12.1":"a #1","12.2-12.4":"a #1","13.0-13.1":"a #1","13.2":"a #1","13.3":"a #1","13.4-13.7":"y"},"op_mini":{"all":"a x #1"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"a #1","4.4.3-4.4.4":"a #1"},"bb":{"7":"a #1","10":"a #1"},"op_mob":{"10":"n","11":"a x #1","12":"a x #1","59":"y","11.1":"a x #1","11.5":"a x #1","12.1":"a x #1"},"and_chr":{"86":"y"},"and_ff":{"82":"y x"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"a x #1"}},"notes":"","notes_by_num":{"1":"Partial refers to supporting `<integer>` but not `<length>` values."},"usage_perc_y":91.2,"usage_perc_a":6.26,"ucprefix":false,"parent":"","keywords":"tab-size,tab-width","ie_id":"csstabsizeproperty","chrome_id":"","firefox_id":"","webkit_id":""},"currentcolor":{"title":"CSS currentColor value","description":"A CSS value that will apply the existing `color` value to other properties like `background-color`, etc. ","spec":"https://www.w3.org/TR/css3-color/#currentcolor","status":"rec","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#currentColor_keyword","title":"MDN Web Docs - CSS currentColor"},{"url":"https://css-tricks.com/currentcolor/","title":"CSS Tricks article"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"u","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":99.58,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"custom-elements":{"title":"Custom Elements (deprecated V0 spec)","description":"Original V0 version of the custom elements specification. See [Custom Elements V1](#feat=custom-elementsv1) for support for the latest version. ","spec":"https://www.w3.org/TR/custom-elements/","status":"unoff","links":[{"url":"https://www.polymer-project.org/platform/custom-elements.html","title":"Polymer project (polyfill & web components framework)"},{"url":"https://www.html5rocks.com/tutorials/webcomponents/customelements/","title":"HTML5Rocks - Custom Elements: defining new elements in HTML"},{"url":"https://github.com/WebReflection/document-register-element","title":"document.registerElement polyfill in 3KB minified & gzipped"},{"url":"https://developers.google.com/web/fundamentals/primers/customelements/","title":"Google Developers - Custom elements v1: reusable web components"}],"categories":["DOM","HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"p","11":"p","5.5":"n"},"edge":{"12":"p","13":"p","14":"p","15":"p","16":"p","17":"p","18":"p","79":"y","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n d","24":"n d","25":"n d","26":"n d","27":"n d","28":"n d","29":"n d","30":"p d","31":"p d","32":"p d","33":"p d","34":"p d","35":"p d","36":"p d","37":"p d","38":"p d","39":"p d","40":"p d","41":"p d","42":"p d","43":"p d","44":"p d","45":"p d","46":"p d","47":"p d","48":"p d","49":"p d","50":"p d","51":"p d","52":"p d","53":"p d","54":"p d","55":"p d","56":"p d","57":"p d","58":"p d","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n d","28":"n d","29":"n d","30":"n d","31":"n d","32":"n d","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"p","7":"p","8":"p","9":"p","10":"p","11":"p","12":"p","13":"p","14":"p","3.1":"n","3.2":"n","5.1":"n","6.1":"p","7.1":"p","9.1":"p","10.1":"p","11.1":"p","12.1":"p","13.1":"p","TP":"p"},"opera":{"9":"n","11":"n","12":"n","15":"n d","16":"n d","17":"n d","18":"n d","19":"n d","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"p","14":"p","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"p","8.1-8.4":"p","9.0-9.2":"p","9.3":"p","10.0-10.2":"p","10.3":"p","11.0-11.2":"p","11.3-11.4":"p","12.0-12.1":"p","12.2-12.4":"p","13.0-13.1":"p","13.2":"p","13.3":"p","13.4-13.7":"p"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"p d"}},"notes":"","notes_by_num":{"1":"Enabled through the \"dom.webcomponents.enabled\" preference in about:config","2":"Enabled through the \"dom.webcomponents.customelements.enabled\" preference in about:config"},"usage_perc_y":6.97,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"document.registerElement","ie_id":"","chrome_id":"4642138092470272","firefox_id":"","webkit_id":""},"custom-elementsv1":{"title":"Custom Elements (V1)","description":"Method of defining new HTML tags.","spec":"https://html.spec.whatwg.org/multipage/scripting.html#custom-elements","status":"ls","links":[{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=889230","title":"Firefox tracking bug: Implement Custom Elements (from Web Components)"},{"url":"http://status.modern.ie/customelements","title":"IE Web Platform Status and Roadmap: Custom Elements"},{"url":"https://developers.google.com/web/fundamentals/primers/customelements/","title":"Google Developers - Custom elements v1: reusable web components"},{"url":"https://github.com/webcomponents/polyfills/tree/master/packages/custom-elements","title":"customElements.define polyfill"},{"url":"https://webkit.org/blog/7027/introducing-custom-elements/","title":"WebKit Blog: Introducing Custom Elements"}],"categories":["DOM","HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"p","11":"p","5.5":"n"},"edge":{"12":"p","13":"p","14":"p","15":"p","16":"p","17":"p","18":"p","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"p","31":"p","32":"p","33":"p","34":"p","35":"p","36":"p","37":"p","38":"p","39":"p","40":"p","41":"p","42":"p","43":"p","44":"p","45":"p","46":"p","47":"p","48":"p","49":"p","50":"p d #2 #1","51":"p d #2 #1","52":"p d #2 #1","53":"p d #2 #1","54":"p d #2 #1","55":"p d #2 #1","56":"p d #2 #1","57":"p d #2 #1","58":"p d #2 #1","59":"p d #3 #1","60":"p d #3 #1","61":"p d #3 #1","62":"p d #3 #1","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"p","53":"p","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","59":"a #1","60":"a #1","61":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #1","66":"a #1","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"p","9":"p","10":"p","11":"a #1","12":"a #1","13":"a #1","14":"a #1","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"p","10.1":"a #1","11.1":"a #1","12.1":"a #1","13.1":"a #1","TP":"a #1"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","60":"a #1","62":"a #1","63":"a #1","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"a #1","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"a #1","11.0-11.2":"a #1","11.3-11.4":"a #1","12.0-12.1":"a #1","12.2-12.4":"a #1","13.0-13.1":"a #1","13.2":"a #1","13.3":"a #1","13.4-13.7":"a #1"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"a #1","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"a #1"},"baidu":{"7.12":"a #1"},"kaios":{"2.5":"p"}},"notes":"","notes_by_num":{"1":"Supports \"Autonomous custom elements\" but not \"Customized built-in elements\".","2":"Enabled through the `dom.webcomponents.enabled` preference in `about:config`.","3":"Enabled through the `dom.webcomponents.customelements.enabled` preference in `about:config`."},"usage_perc_y":77.87,"usage_perc_a":16.59,"ucprefix":false,"parent":"","keywords":"webcomponents,customelements","ie_id":"customelements","chrome_id":"4696261944934400,4670146924773376","firefox_id":"custom-elements","webkit_id":"feature-custom-elements"},"customevent":{"title":"CustomEvent","description":"A DOM event interface that can carry custom application-defined data.","spec":"https://dom.spec.whatwg.org/#interface-customevent","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent","title":"MDN Web Docs - CustomEvent"},{"url":"https://github.com/krambuhl/custom-event-polyfill","title":"Polyfill based on the MDN snippet"},{"url":"https://github.com/jonathantneal/EventListener","title":"EventListener polyfill which includes a CustomEvent polyfill"}],"categories":["DOM","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"a #1","10":"a #1","11":"a #1","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"u","6":"u","7":"u","8":"u","9":"a #1 #2","10":"a #1 #2","11":"a #1 #2","12":"a #1 #2","13":"u","14":"u","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"u","6":"u","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"a #1 #2","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"a #1","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"a #1","11.5":"a #1","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"u","4.0-4.1":"n","4.2-4.3":"u","5.0-5.1":"a #1 #2","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"a #1 #2","4":"a #1 #2","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"a #1 #2","4.2-4.3":"a #1 #2","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"a #1 #2","10":"y"},"op_mob":{"10":"n","11":"a #1","12":"y","59":"y","11.1":"a #1","11.5":"a #1","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #1","11":"a #1"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Not supported in some versions of Android's old WebKit-based WebView.","notes_by_num":{"1":"While a `window.CustomEvent` object exists, it cannot be called as a constructor. Instead of `new CustomEvent(...)`, you must use `e = document.createEvent('CustomEvent')` and then `e.initCustomEvent(...)`","2":"There is no `window.CustomEvent` object, but `document.createEvent('CustomEvent')` still works."},"usage_perc_y":97.8,"usage_perc_a":1.65,"ucprefix":false,"parent":"","keywords":"custom events,custom,event","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"datalist":{"title":"Datalist element","description":"Method of setting a list of options for a user to select in a text field, while leaving the ability to enter a custom value.","spec":"https://html.spec.whatwg.org/multipage/forms.html#the-datalist-element","status":"ls","links":[{"url":"https://hacks.mozilla.org/2010/11/firefox-4-html5-forms/","title":"Mozilla Hacks article"},{"url":"http://afarkas.github.com/webshim/demos/","title":"HTML5 Library including datalist support"},{"url":"https://developer.mozilla.org/en/HTML/Element/datalist","title":"MDN Web Docs - datalist"},{"url":"https://www.webplatform.org/docs/html/elements/datalist","title":"WebPlatform Docs"},{"url":"http://demo.agektmr.com/datalist/","title":"Eiji Kitamura's options demos & tests"},{"url":"https://github.com/thgreasi/datalist-polyfill","title":"Minimal Datalist polyfill w/tutorial"},{"url":"https://github.com/mfranzke/datalist-polyfill","title":"Minimal and library dependency-free vanilla JavaScript polyfill"}],"categories":["HTML5"],"stats":{"ie":{"6":"p","7":"p","8":"p","9":"p","10":"a #2","11":"a #2","5.5":"n"},"edge":{"12":"a #2","13":"a #2","14":"a #2","15":"a #2","16":"a #2 #4","17":"a #2 #4","18":"a #2 #4","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"p","3":"p","4":"a #3 #6","5":"a #3 #6","6":"a #3 #6","7":"a #3 #6","8":"a #3 #6","9":"a #3 #6","10":"a #3 #6","11":"a #3 #6","12":"a #3 #6","13":"a #3 #6","14":"a #3 #6","15":"a #3 #6","16":"a #3 #6","17":"a #3 #6","18":"a #3 #6","19":"a #3 #6","20":"a #3 #6","21":"a #3 #6","22":"a #3 #6","23":"a #3 #6","24":"a #3 #6","25":"a #3 #6","26":"a #3 #6","27":"a #3 #6","28":"a #3 #6","29":"a #3 #6","30":"a #3 #6","31":"a #3 #6","32":"a #3 #6","33":"a #3 #6","34":"a #3 #6","35":"a #3 #6","36":"a #3 #6","37":"a #3 #6","38":"a #3 #6","39":"a #3 #6","40":"a #3 #6","41":"a #3 #6","42":"a #3 #6","43":"a #3 #6","44":"a #3 #6","45":"a #3 #6","46":"a #3 #6","47":"a #3 #6","48":"a #3 #6","49":"a #3 #6","50":"a #3 #6","51":"a #3 #6","52":"a #3 #6","53":"a #3 #6","54":"a #3 #6","55":"a #3 #6","56":"a #3 #6","57":"a #3 #6","58":"a #3 #6","59":"a #3 #6","60":"a #3 #6","61":"a #3 #6","62":"a #3 #6","63":"a #3 #6","64":"a #3 #6","65":"a #3 #6","66":"a #3 #6","67":"a #3 #6","68":"a #3 #6","69":"a #3 #6","70":"a #3 #6","71":"a #3 #6","72":"a #3 #6","73":"a #3 #6","74":"a #3 #6","75":"a #3 #6","76":"a #3 #6","77":"a #3 #6","78":"a #3 #6","79":"a #3 #6","80":"a #3 #6","81":"a #3 #6","82":"a #3 #6","83":"a #3 #6","84":"a #3 #6","85":"a #3 #6","3.5":"p","3.6":"p"},"chrome":{"4":"p","5":"p","6":"p","7":"p","8":"p","9":"p","10":"p","11":"p","12":"p","13":"p","14":"p","15":"p","16":"p","17":"p","18":"p","19":"p","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","59":"a #1","60":"a #1","61":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #1","66":"a #1","67":"a #1","68":"a #1","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"p","5":"p","6":"p","7":"p","8":"p","9":"p","10":"p","11":"p","12":"p","13":"y","14":"y","3.1":"p","3.2":"p","5.1":"p","6.1":"p","7.1":"p","9.1":"p","10.1":"p","11.1":"p","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","60":"a #1","62":"a #1","63":"a #1","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"p","14":"y #5","3.2":"p","4.0-4.1":"p","4.2-4.3":"p","5.0-5.1":"p","6.0-6.1":"p","7.0-7.1":"p","8.1-8.4":"p","9.0-9.2":"p","9.3":"p","10.0-10.2":"p","10.3":"p","11.0-11.2":"p","11.3-11.4":"p","12.0-12.1":"p","12.2-12.4":"y #5","13.0-13.1":"y #5","13.2":"y #5","13.3":"y #5","13.4-13.7":"y #5"},"op_mini":{"all":"n"},"android":{"3":"p","4":"p","81":"a #1","2.1":"p","2.2":"p","2.3":"p","4.1":"p","4.2-4.3":"p","4.4":"p","4.4.3-4.4.4":"y"},"bb":{"7":"p","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"p","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"a #3"},"ie_mob":{"10":"p","11":"p"},"and_uc":{"12.12":"p"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"a #1"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"While most commonly used on text fields, datalists can also be used on other input types. IE11 supports the element on `range` fields. Chrome and Opera also support datalists to suggest given values on `range`, `color` and date/time fields. ","notes_by_num":{"1":"Partial support refers to [a bug](https://bugs.chromium.org/p/chromium/issues/detail?id=773041) where long lists of items are unscrollable resulting in unselectable options.","2":"Partial support in IE refers to [significantly buggy behavior](https://web.archive.org/web/20170121011936/http://playground.onereason.eu/2013/04/ie10s-lousy-support-for-datalists/) (IE11+ does send the input and change events upon selection). ","3":"Partial support refers to no support for datalists on non-text fields (e.g. number, [range](https://bugzilla.mozilla.org/show_bug.cgi?id=841942), [color](https://bugzilla.mozilla.org/show_bug.cgi?id=960984)).","4":"Partial support in Edge refers [to disappearing option elements on focusing the input element via tab](https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/20066595/).","5":"Supported through WKWebView and Safari but not through UIWebView","6":"In Firefox, autocomplete must be set to off to make dynamic datalist work due to [a bug](https://bugzilla.mozilla.org/show_bug.cgi?id=1474137)"},"usage_perc_y":88.38,"usage_perc_a":7.02,"ucprefix":false,"parent":"forms","keywords":"list attribute,input","ie_id":"datalistelement","chrome_id":"6090950820495360","firefox_id":"","webkit_id":""},"dataset":{"title":"dataset & data-* attributes","description":"Method of applying and accessing custom data to elements.","spec":"https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes","status":"ls","links":[{"url":"http://html5doctor.com/html5-custom-data-attributes/","title":"HTML5 Doctor article"},{"url":"http://html5demos.com/dataset","title":"Demo using dataset"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/dom.js#dom-dataset","title":"has.js test"},{"url":"https://www.webplatform.org/docs/html/attributes/data-*","title":"WebPlatform Docs"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement.dataset","title":"MDN Web Docs - dataset"},{"url":"https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/Using_data_attributes","title":"MDN Guide - Using data-* attributes"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/15885483-support-dataset-and-data-attributes-on-svg-element","title":"MS Edge UserVoice #15885483: Support dataset and data attributes on SVG elements"}],"categories":["HTML5"],"stats":{"ie":{"6":"a","7":"a","8":"a","9":"a","10":"a","11":"y","5.5":"a"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y #1","18":"y #1","79":"y #1","80":"y #1","81":"y #1","83":"y #1","84":"y #1","85":"y #1","86":"y #1","87":"y #1"},"firefox":{"2":"a","3":"a","4":"a","5":"a","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y #1","52":"y #1","53":"y #1","54":"y #1","55":"y #1","56":"y #1","57":"y #1","58":"y #1","59":"y #1","60":"y #1","61":"y #1","62":"y #1","63":"y #1","64":"y #1","65":"y #1","66":"y #1","67":"y #1","68":"y #1","69":"y #1","70":"y #1","71":"y #1","72":"y #1","73":"y #1","74":"y #1","75":"y #1","76":"y #1","77":"y #1","78":"y #1","79":"y #1","80":"y #1","81":"y #1","82":"y #1","83":"y #1","84":"y #1","85":"y #1","3.5":"a","3.6":"a"},"chrome":{"4":"a","5":"a","6":"a","7":"y #1","8":"y #1","9":"y #1","10":"y #1","11":"y #1","12":"y #1","13":"y #1","14":"y #1","15":"y #1","16":"y #1","17":"y #1","18":"y #1","19":"y #1","20":"y #1","21":"y #1","22":"y #1","23":"y #1","24":"y #1","25":"y #1","26":"y #1","27":"y #1","28":"y #1","29":"y #1","30":"y #1","31":"y #1","32":"y #1","33":"y #1","34":"y #1","35":"y #1","36":"y #1","37":"y #1","38":"y #1","39":"y #1","40":"y #1","41":"y #1","42":"y #1","43":"y #1","44":"y #1","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y #1","56":"y #1","57":"y #1","58":"y #1","59":"y #1","60":"y #1","61":"y #1","62":"y #1","63":"y #1","64":"y #1","65":"y #1","66":"y #1","67":"y #1","68":"y #1","69":"y #1","70":"y #1","71":"y #1","72":"y #1","73":"y #1","74":"y #1","75":"y #1","76":"y #1","77":"y #1","78":"y #1","79":"y #1","80":"y #1","81":"y #1","83":"y #1","84":"y #1","85":"y #1","86":"y #1","87":"y #1","88":"y #1","89":"y #1","90":"y #1"},"safari":{"4":"a","5":"a","6":"y #1","7":"y #1","8":"y #1","9":"y #1","10":"y #1","11":"y #1","12":"y #1","13":"y #1","14":"y #1","3.1":"a","3.2":"a","5.1":"y #1","6.1":"y #1","7.1":"y #1","9.1":"y #1","10.1":"y #1","11.1":"y #1","12.1":"y #1","13.1":"y #1","TP":"y #1"},"opera":{"9":"a","11":"a","12":"y","15":"y #1","16":"y #1","17":"y #1","18":"y #1","19":"y #1","20":"y #1","21":"y #1","22":"y #1","23":"y #1","24":"y #1","25":"y #1","26":"y #1","27":"y #1","28":"y #1","29":"y #1","30":"y #1","31":"y #1","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y #1","43":"y #1","44":"y #1","45":"y #1","46":"y #1","47":"y #1","48":"y #1","49":"y #1","50":"y #1","51":"y #1","52":"y #1","53":"y #1","54":"y #1","55":"y #1","56":"y #1","57":"y #1","58":"y #1","60":"y #1","62":"y #1","63":"y #1","64":"y #1","65":"y #1","66":"y #1","67":"y #1","68":"y #1","69":"y #1","70":"y #1","71":"y #1","72":"y #1","9.5-9.6":"a","10.0-10.1":"a","10.5":"a","10.6":"a","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y #1","14":"y #1","3.2":"a","4.0-4.1":"a","4.2-4.3":"a","5.0-5.1":"y #1","6.0-6.1":"y #1","7.0-7.1":"y #1","8.1-8.4":"y #1","9.0-9.2":"y #1","9.3":"y #1","10.0-10.2":"y #1","10.3":"y #1","11.0-11.2":"y #1","11.3-11.4":"y #1","12.0-12.1":"y #1","12.2-12.4":"y #1","13.0-13.1":"y #1","13.2":"y #1","13.3":"y #1","13.4-13.7":"y #1"},"op_mini":{"all":"a"},"android":{"3":"y #1","4":"y #1","81":"y #1","2.1":"a","2.2":"a","2.3":"a","4.1":"y #1","4.2-4.3":"y #1","4.4":"y #1","4.4.3-4.4.4":"y #1"},"bb":{"7":"y #1","10":"y #1"},"op_mob":{"10":"a","11":"a","12":"y","59":"y #1","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y #1"},"and_ff":{"82":"y #1"},"ie_mob":{"10":"a","11":"y"},"and_uc":{"12.12":"y #1"},"samsung":{"4":"y #1","5.0-5.4":"y #1","6.2-6.4":"y #1","7.2-7.4":"y #1","8.2":"y #1","9.2":"y #1","10.1":"y #1","11.1-11.2":"y #1","12.0":"y #1"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y #1"},"kaios":{"2.5":"y"}},"notes":"Partial support refers to being able to use `data-*` attributes and access them using `getAttribute`. \r\n\r\n\"Supported\" refers to accessing the values using the `dataset` property. Current spec only refers to support on HTML elements, only some browsers also have support for SVG/MathML elements.","notes_by_num":{"1":"While the HTML spec doesn't require it, these browsers also support `dataset` and `data-*` attributes on SVG elements, in compliance with [current plans for SVG2](https://www.w3.org/2015/01/15-svg-minutes.html#item03)"},"usage_perc_y":98.35,"usage_perc_a":1.35,"ucprefix":false,"parent":"","keywords":"DOMStringMap","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"datauri":{"title":"Data URIs","description":"Method of embedding images and other files in webpages as a string of text, generally using base64 encoding.","spec":"https://tools.ietf.org/html/rfc2397","status":"other","links":[{"url":"https://css-tricks.com/data-uris/","title":"Information page"},{"url":"https://en.wikipedia.org/wiki/data_URI_scheme","title":"Wikipedia"},{"url":"http://www.websiteoptimization.com/speed/tweak/inline-images/","title":"Data URL converter"},{"url":"http://klevjers.com/papers/phishing.pdf","title":"Information on security issues"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"a #1","9":"a #2","10":"a #2","11":"a #2","5.5":"n"},"edge":{"12":"a #2","13":"a #2","14":"a #2 #3","15":"a #2","16":"a #2","17":"a #2","18":"a #2","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #2","11":"a #2"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Support is limited to images and linked resources like CSS files, not HTML or JS files. Max URI length is 32KB.","2":"Support is limited to images and linked resources like CSS or JS, not HTML files. Maximum size limit is 4GB.","3":"SVGs with XML declarations are not displayed when used in data-urls"},"usage_perc_y":97.87,"usage_perc_a":1.81,"ucprefix":false,"parent":"","keywords":"data url,datauris,data uri,dataurl,dataurls,base64","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"date-tolocaledatestring":{"title":"Date.prototype.toLocaleDateString","description":"Date method to generate a language sensitive representation of a given date, formatted based on a specified locale and options.","spec":"https://tc39.es/ecma402/#sup-date.prototype.tolocaledatestring","status":"other","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleDateString","title":"MDN article on  Date​.prototype​.toLocale​Date​String()"}],"categories":["JS"],"stats":{"ie":{"6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","5.5":"u"},"edge":{"12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"a #1","3":"a #1","4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #2 #3","30":"a #2 #3","31":"a #2 #3","32":"a #2 #3","33":"a #2 #3","34":"a #2 #3","35":"a #2 #3","36":"a #2 #3","37":"a #2 #3","38":"a #2 #3","39":"a #2 #3","40":"a #2 #3","41":"a #2 #3","42":"a #2 #3","43":"a #2 #3","44":"a #2 #3","45":"a #2 #3","46":"a #2 #3","47":"a #2 #3","48":"a #2 #3","49":"a #2 #3","50":"a #2 #3","51":"a #2 #3","52":"a #2","53":"a #2","54":"a #2","55":"a #2","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a #1","3.6":"a #1"},"chrome":{"4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #2 #3","25":"a #2 #3","26":"a #2 #3","27":"a #2 #3","28":"a #2 #3","29":"a #2 #3","30":"a #2 #3","31":"a #2 #3","32":"a #2 #3","33":"a #2 #3","34":"a #2 #3","35":"a #2 #3","36":"a #2 #3","37":"a #2 #3","38":"a #2","39":"a #2","40":"a #2","41":"a #2","42":"a #2","43":"a #2","44":"a #2","45":"a #2","46":"a #2","47":"a #2","48":"a #2","49":"a #2","50":"a #2","51":"a #2","52":"a #2","53":"a #2","54":"a #2","55":"a #2","56":"a #2","57":"a #2","58":"a #2","59":"a #2","60":"a #2","61":"a #2","62":"a #2","63":"a #2","64":"a #2","65":"a #2","66":"a #2","67":"a #2","68":"a #2","69":"a #2","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"u","5":"u","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #2","12":"y","13":"y","14":"y","3.1":"u","3.2":"u","5.1":"a #1","6.1":"a #1","7.1":"a #1","9.1":"a #1","10.1":"a #2","11.1":"a #2","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"u","12":"u","15":"a #2 #3","16":"a #2 #3","17":"a #2 #3","18":"a #2 #3","19":"a #2 #3","20":"a #2 #3","21":"a #2 #3","22":"a #2 #3","23":"a #2 #3","24":"a #2 #3","25":"a #2","26":"a #2","27":"a #2","28":"a #2","29":"a #2","30":"a #2","31":"a #2","32":"a #2","33":"a #2","34":"a #2","35":"a #2","36":"a #2","37":"a #2","38":"a #2","39":"a #2","40":"a #2","41":"a #2","42":"a #2","43":"a #2","44":"a #2","45":"a #2","46":"a #2","47":"a #2","48":"a #2","49":"a #2","50":"a #2","51":"a #2","52":"a #2","53":"a #2","54":"a #2","55":"a #2","56":"a #2","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"u","10.0-10.1":"u","10.5":"u","10.6":"u","11.1":"u","11.5":"u","11.6":"u","12.1":"a #1"},"ios_saf":{"8":"a #1","14":"y","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"u","6.0-6.1":"a #1","7.0-7.1":"a #1","8.1-8.4":"a #1","9.0-9.2":"a #1","9.3":"a #1","10.0-10.2":"a #1","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"a #1"},"android":{"3":"u","4":"a #1","81":"y","2.1":"u","2.2":"u","2.3":"u","4.1":"a #1","4.2-4.3":"a #1","4.4":"a #2 #3","4.4.3-4.4.4":"a #2 #3"},"bb":{"7":"a #1","10":"a #1"},"op_mob":{"10":"u","11":"u","12":"u","59":"y","11.1":"u","11.5":"u","12.1":"a #1"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #1","11":"a #1"},"and_uc":{"12.12":"a #2"},"samsung":{"4":"a #2","5.0-5.4":"a #2","6.2-6.4":"a #2","7.2-7.4":"a #2","8.2":"a #2","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"a #2"},"baidu":{"7.12":"a #1"},"kaios":{"2.5":"a #1"}},"notes":"","notes_by_num":{"1":"Does not support the `locale` or `options` parameters","2":"Does not support all locales correctly","3":"Does not support the `timeZone` option "},"usage_perc_y":92.62,"usage_perc_a":6.95,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"details":{"title":"Details & Summary elements","description":"The <details> element generates a simple no-JavaScript widget to show/hide element contents, optionally by clicking on its child <summary> element.","spec":"https://html.spec.whatwg.org/multipage/forms.html#the-details-element","status":"ls","links":[{"url":"https://mathiasbynens.be/notes/html5-details-jquery","title":"jQuery fallback script"},{"url":"https://gist.github.com/370590","title":"Fallback script"},{"url":"http://html5doctor.com/summary-figcaption-element/","title":"HTML5 Doctor article"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/features.js#native-details","title":"has.js test"},{"url":"https://www.webplatform.org/docs/html/elements/details","title":"WebPlatform Docs"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=591737","title":"Bug on Firefox support"},{"url":"https://github.com/javan/details-element-polyfill","title":"Details Element Polyfill"}],"categories":["HTML5"],"stats":{"ie":{"6":"p","7":"p","8":"p","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"p","4":"p","5":"p","6":"p","7":"p","8":"p","9":"p","10":"p","11":"p","12":"p","13":"p","14":"p","15":"p","16":"p","17":"p","18":"p","19":"p","20":"p","21":"p","22":"p","23":"p","24":"p","25":"p","26":"p","27":"p","28":"p","29":"p","30":"p","31":"p","32":"p","33":"p","34":"p","35":"p","36":"p","37":"p","38":"p","39":"p","40":"p","41":"p","42":"p","43":"p","44":"p","45":"p","46":"p","47":"n d #1","48":"n d #1","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"p","3.6":"p"},"chrome":{"4":"p","5":"p","6":"p","7":"p","8":"p","9":"p","10":"p","11":"p","12":"y #2 #3","13":"y #2 #3","14":"y #2 #3","15":"y #2 #3","16":"y #2 #3","17":"y #2 #3","18":"y #2 #3","19":"y #2","20":"y #2","21":"y #2","22":"y #2","23":"y #2","24":"y #2","25":"y #2","26":"y #2","27":"y #2","28":"y #2","29":"y #2","30":"y #2","31":"y #2","32":"y #2","33":"y #2","34":"y #2","35":"y #2","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"p","5":"p","6":"y #2","7":"y #2","8":"y #2","9":"y #2","10":"y #2","11":"y #4","12":"y","13":"y","14":"y","3.1":"p","3.2":"p","5.1":"p","6.1":"y #2","7.1":"y #2","9.1":"y #2","10.1":"y #4","11.1":"y #4","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"p","11":"p","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"p","10.0-10.1":"p","10.5":"p","10.6":"p","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"p","4.0-4.1":"p","4.2-4.3":"p","5.0-5.1":"p","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y #4","10.3":"y #4","11.0-11.2":"y #4","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"p"},"android":{"3":"p","4":"y","81":"y","2.1":"p","2.2":"p","2.3":"p","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"p","10":"y"},"op_mob":{"10":"p","11":"p","12":"p","59":"y","11.1":"p","11.5":"p","12.1":"p"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y #2 #3"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Enabled in Firefox through the `dom.details_element.enabled` flag","2":"'toggle' event is not supported","3":"<summary> is not keyboard accessible","4":"Some versions of Safari display smaller font-size than intended when using `rem` units with system fonts. (See: https://colloq.io/blog/safaris-detailssummary-rem-font-size-issue)"},"usage_perc_y":96.32,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"detailssummary","chrome_id":"5348024557502464","firefox_id":"","webkit_id":""},"deviceorientation":{"title":"DeviceOrientation & DeviceMotion events","description":"API for detecting orientation and motion events from the device running the browser.","spec":"https://www.w3.org/TR/orientation-event/","status":"cr","links":[{"url":"https://www.html5rocks.com/en/tutorials/device/orientation/","title":"HTML5 Rocks tutorial"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/features.js#native-orientation","title":"has.js test"},{"url":"http://html5labs.interoperabilitybridges.com/prototypes/device-orientation-events/device-orientation-events/info","title":"DeviceOrientation implementation prototype for IE10"},{"url":"http://aurelio.audero.it/demo/device-orientation-api-demo.html","title":"Demo"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"a #1","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"a","80":"a","81":"a","83":"a","84":"a","85":"a","86":"a","87":"a"},"firefox":{"2":"n","3":"n","4":"p","5":"p","6":"a","7":"a","8":"a","9":"a","10":"a","11":"a","12":"a","13":"a","14":"a","15":"a","16":"a","17":"a","18":"a","19":"a","20":"a","21":"a","22":"a","23":"a","24":"a","25":"a","26":"a","27":"a","28":"a","29":"a","30":"a","31":"a","32":"a","33":"a","34":"a","35":"a","36":"a","37":"a","38":"a","39":"a","40":"a","41":"a","42":"a","43":"a","44":"a","45":"a","46":"a","47":"a","48":"a","49":"a","50":"a","51":"a","52":"a","53":"a","54":"a","55":"a","56":"a","57":"a","58":"a","59":"a","60":"a","61":"a","62":"a","63":"a","64":"a","65":"a","66":"a","67":"a","68":"a","69":"a","70":"a","71":"a","72":"a","73":"a","74":"a","75":"a","76":"a","77":"a","78":"a","79":"a","80":"a","81":"a","82":"a","83":"a","84":"a","85":"a","3.5":"n","3.6":"p"},"chrome":{"4":"n","5":"n","6":"n","7":"a","8":"a","9":"a","10":"a","11":"a","12":"a","13":"a","14":"a","15":"a","16":"a","17":"a","18":"a","19":"a","20":"a","21":"a","22":"a","23":"a","24":"a","25":"a","26":"a","27":"a","28":"a","29":"a","30":"a","31":"a","32":"a","33":"a","34":"a","35":"a","36":"a","37":"a","38":"a","39":"a","40":"a","41":"a","42":"a","43":"a","44":"a","45":"a","46":"a","47":"a","48":"a","49":"a","50":"a","51":"a","52":"a","53":"a","54":"a","55":"a","56":"a","57":"a","58":"a","59":"a","60":"a","61":"a","62":"a","63":"a","64":"a","65":"a","66":"a","67":"a","68":"a","69":"a","70":"a","71":"a","72":"a","73":"a","74":"a","75":"a","76":"a","77":"a","78":"a","79":"a","80":"a","81":"a","83":"a","84":"a","85":"a","86":"a","87":"a","88":"a","89":"a","90":"a"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"a","16":"a","17":"a","18":"a","19":"a","20":"a","21":"a","22":"a","23":"a","24":"a","25":"a","26":"a","27":"a","28":"a","29":"a","30":"a","31":"a","32":"a","33":"a","34":"a","35":"a","36":"a","37":"a","38":"a","39":"a","40":"a","41":"a","42":"a","43":"a","44":"a","45":"a","46":"a","47":"a","48":"a","49":"a","50":"a","51":"a","52":"a","53":"a","54":"a","55":"a","56":"a","57":"a","58":"a","60":"a","62":"a","63":"a","64":"a","65":"a","66":"a","67":"a","68":"a","69":"a","70":"a","71":"a","72":"a","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a","14":"a","3.2":"n","4.0-4.1":"n","4.2-4.3":"a","5.0-5.1":"a","6.0-6.1":"a","7.0-7.1":"a","8.1-8.4":"a","9.0-9.2":"a","9.3":"a","10.0-10.2":"a","10.3":"a","11.0-11.2":"a","11.3-11.4":"a","12.0-12.1":"a","12.2-12.4":"a","13.0-13.1":"a","13.2":"a","13.3":"a","13.4-13.7":"a"},"op_mini":{"all":"n"},"android":{"3":"a","4":"a","81":"a","2.1":"n","2.2":"n","2.3":"n","4.1":"a","4.2-4.3":"a","4.4":"a","4.4.3-4.4.4":"a"},"bb":{"7":"n","10":"a"},"op_mob":{"10":"n","11":"n","12":"y","59":"a","11.1":"n","11.5":"n","12.1":"y"},"and_chr":{"86":"a"},"and_ff":{"82":"a"},"ie_mob":{"10":"n","11":"y"},"and_uc":{"12.12":"a"},"samsung":{"4":"a","5.0-5.4":"a","6.2-6.4":"a","7.2-7.4":"a","8.2":"a","9.2":"a","10.1":"a","11.1-11.2":"a","12.0":"a"},"and_qq":{"10.4":"a"},"baidu":{"7.12":"a"},"kaios":{"2.5":"a"}},"notes":"Partial support refers to the lack of compassneedscalibration event. Partial support also refers to the lack of devicemotion event support for Chrome 30- and Opera. Opera Mobile 14 lost the ondevicemotion event support. Firefox 3.6, 4 and 5 support the non-standard [MozOrientation](https://developer.mozilla.org/en/DOM/MozOrientation) event.","notes_by_num":{"1":"`compassneedscalibration` supported in IE11 only for compatible devices with Windows 8.1+."},"usage_perc_y":0.41,"usage_perc_a":93.6,"ucprefix":false,"parent":"","keywords":"ondeviceorientation,ondevicemotion","ie_id":"deviceorientation,devicemotion","chrome_id":"5874690627207168,5556931766779904","firefox_id":"device-orientation","webkit_id":"specification-deviceorientation-events"},"devicepixelratio":{"title":"Window.devicePixelRatio","description":"Read-only property that returns the ratio of the (vertical) size of one physical pixel on the current display device to the size of one CSS pixel.","spec":"https://drafts.csswg.org/cssom-view/#dom-window-devicepixelratio","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Window/devicePixelRatio","title":"MDN Web Docs - devicePixelRatio"}],"categories":["CSS","DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"n","12":"y","59":"y","11.1":"n","11.5":"n","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"As the page is zoomed in the number of device pixels that one CSS pixel covers increases, and therefore the value of devicePixelRatio will also increase.","notes_by_num":{},"usage_perc_y":99.19,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"device,pixel,ratio,size","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"dialog":{"title":"Dialog element","description":"Method of easily creating custom dialog boxes to display to the user with modal or non-modal options. Also includes a `::backdrop` pseudo-element for behind the element.","spec":"https://html.spec.whatwg.org/multipage/forms.html#the-dialog-element","status":"ls","links":[{"url":"https://github.com/GoogleChrome/dialog-polyfill","title":"Polyfill"}],"categories":["DOM","HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n d #1","54":"n d #1","55":"n d #1","56":"n d #1","57":"n d #1","58":"n d #1","59":"n d #1","60":"n d #1","61":"n d #1","62":"n d #1","63":"n d #1","64":"n d #1","65":"n d #1","66":"n d #1","67":"n d #1","68":"n d #1","69":"n d #1","70":"n d #1","71":"n d #1","72":"n d #1","73":"n d #1","74":"n d #1","75":"n d #1","76":"n d #1","77":"n d #1","78":"n d #1","79":"n d #1","80":"n d #1 #4","81":"n d #1 #4","82":"n d #1 #4","83":"n d #1 #4","84":"n d #1 #4","85":"n d #1 #4","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n d #2","33":"n d #2","34":"n d #2","35":"n d #2","36":"n d #2","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n d #3","20":"n d #3","21":"n d #3","22":"n d #3","23":"n d #3","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n d #1"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Supported in Firefox by enabling \"dom.dialog_element.enabled\" in about:config","2":"Enabled through the \"Experimental Web Platform features\" flag in `chrome://flags`","3":"Enabled through the \"Experimental Web Platform features\" flag in `opera://flags`","4":"Enabled by default in Firefox Nightly only"},"usage_perc_y":75.61,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"HTMLDialogElement,showModal,backdrop","ie_id":"dialogelementformodals","chrome_id":"5770237022568448","firefox_id":"","webkit_id":""},"dispatchevent":{"title":"EventTarget.dispatchEvent","description":"Method to programmatically trigger a DOM event.","spec":"https://dom.spec.whatwg.org/#dom-eventtarget-dispatchevent","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/dispatchEvent","title":"MDN Web Docs - dispatchEvent"},{"url":"https://github.com/Financial-Times/polyfill-service/blob/master/polyfills/Event/polyfill-ie8.js","title":"Financial Times IE8 polyfill"},{"url":"https://github.com/WebReflection/ie8","title":"WebReflection ie8 polyfill"}],"categories":["DOM"],"stats":{"ie":{"6":"n #1","7":"n #1","8":"n #1","9":"y #1","10":"y #1","11":"y","5.5":"u"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"u","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"u","2.2":"u","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y #1","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Supports Microsoft's proprietary [`EventTarget.fireEvent() method`](https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/fireEvent)."},"usage_perc_y":99.59,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"dispatch,event,target,fire,trigger,dom","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"dnssec":{"title":"DNSSEC and DANE","description":"Method of validating a DNS response against a trusted root server. Mitigates various attacks that could reroute a user to a fake site while showing the real URL for the original site.","spec":"https://tools.ietf.org/html/rfc4033","status":"other","links":[{"url":"https://en.wikipedia.org/wiki/Domain_Name_System_Security_Extensions","title":"Wikipedia - DNSSEC"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=50874","title":"Chrome implementation bug"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=672600","title":"Firefox implementation bug"}],"categories":["Security"],"stats":{"ie":{"6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","5.5":"a #1"},"edge":{"12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","79":"a #1","80":"a #1","81":"a #1","83":"a #1","84":"a #1","85":"a #1","86":"a #1","87":"a #1"},"firefox":{"2":"a #1","3":"a #1","4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","59":"a #1","60":"a #1","61":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #1","66":"a #1","67":"a #1","68":"a #1","69":"a #1","70":"a #1","71":"a #1","72":"a #1","73":"a #1","74":"a #1","75":"a #1","76":"a #1","77":"a #1","78":"a #1","79":"a #1","80":"a #1","81":"a #1","82":"a #1","83":"a #1","84":"a #1","85":"a #1","3.5":"a #1","3.6":"a #1"},"chrome":{"4":"a #1","5":"a #1","6":"a #1 #2","7":"a #1 #2","8":"a #1 #2","9":"a #1 #2","10":"a #1 #2","11":"a #1 #2","12":"a #1 #2","13":"a #1 #2","14":"a #1 #2","15":"a #1 #2","16":"a #1 #2","17":"a #1 #2","18":"a #1 #2","19":"a #1 #2","20":"a #1 #2","21":"a #1 #2","22":"a #1 #2","23":"a #1 #2","24":"a #1 #2","25":"a #1 #2","26":"a #1 #2","27":"a #1 #2","28":"a #1 #2","29":"a #1 #2","30":"a #1 #2","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","59":"a #1","60":"a #1","61":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #1","66":"a #1","67":"a #1","68":"a #1","69":"a #1","70":"a #1","71":"a #1","72":"a #1","73":"a #1","74":"a #1","75":"a #1","76":"a #1","77":"a #1","78":"a #1","79":"a #1","80":"a #1","81":"a #1","83":"a #1","84":"a #1","85":"a #1","86":"a #1","87":"a #1","88":"a #1","89":"a #1","90":"a #1"},"safari":{"4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","3.1":"a #1","3.2":"a #1","5.1":"a #1","6.1":"a #1","7.1":"a #1","9.1":"a #1","10.1":"a #1","11.1":"a #1","12.1":"a #1","13.1":"a #1","TP":"a #1"},"opera":{"9":"a #1","11":"a #1","12":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","60":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #1","66":"a #1","67":"a #1","68":"a #1","69":"a #1","70":"a #1","71":"a #1","72":"a #1","9.5-9.6":"a #1","10.0-10.1":"a #1","10.5":"a #1","10.6":"a #1","11.1":"a #1","11.5":"a #1","11.6":"a #1","12.1":"a #1"},"ios_saf":{"8":"a #1","14":"a #1","3.2":"a #1","4.0-4.1":"a #1","4.2-4.3":"a #1","5.0-5.1":"a #1","6.0-6.1":"a #1","7.0-7.1":"a #1","8.1-8.4":"a #1","9.0-9.2":"a #1","9.3":"a #1","10.0-10.2":"a #1","10.3":"a #1","11.0-11.2":"a #1","11.3-11.4":"a #1","12.0-12.1":"a #1","12.2-12.4":"a #1","13.0-13.1":"a #1","13.2":"a #1","13.3":"a #1","13.4-13.7":"a #1"},"op_mini":{"all":"a #1"},"android":{"3":"a #1","4":"a #1","81":"a #1","2.1":"a #1","2.2":"a #1","2.3":"a #1","4.1":"a #1","4.2-4.3":"a #1","4.4":"a #1","4.4.3-4.4.4":"a #1"},"bb":{"7":"a #1","10":"a #1"},"op_mob":{"10":"a #1","11":"a #1","12":"a #1","59":"a #1","11.1":"a #1","11.5":"a #1","12.1":"a #1"},"and_chr":{"86":"a #1"},"and_ff":{"82":"a #1"},"ie_mob":{"10":"a #1","11":"a #1"},"and_uc":{"12.12":"a #1"},"samsung":{"4":"a #1","5.0-5.4":"a #1","6.2-6.4":"a #1","7.2-7.4":"a #1","8.2":"a #1","9.2":"a #1","10.1":"a #1","11.1-11.2":"a #1","12.0":"a #1"},"and_qq":{"10.4":"a #1"},"baidu":{"7.12":"a #1"},"kaios":{"2.5":"a #1"}},"notes":"Browsers have generally decided to not implement DNSSEC validation because the added complexity outweighs the improvements to the browser. DNSSEC is still useful as it is widely used to protect delivery of records between DNS servers, only failing to protect the delivery from the last DNS server to the browser.\r\n\r\n[Certificate transparency](https://developer.mozilla.org/en-US/docs/Web/Security/Certificate_Transparency) is widely used and tries to provide the same security as DNSSEC but by very different means.","notes_by_num":{"1":"Does not support DNSSEC but still benefits greatly from it, as most of the security improvements are gained in the DNS-network and not in the browser.","2":"Early versions of Chrome [experimented](https://www.imperialviolet.org/2011/06/16/dnssecchrome.html) with browser-level validation."},"usage_perc_y":0,"usage_perc_a":99.7,"ucprefix":false,"parent":"","keywords":"DNS Security Extensions,Domain Name System Security Extensions,DNS based Authentication of Named Entities","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"do-not-track":{"title":"Do Not Track API","description":"Allows the browser's Do Not Track setting to be queried via `navigator.doNotTrack`.","spec":"https://www.w3.org/TR/tracking-dnt/","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Navigator/doNotTrack","title":"MDN Web Docs - doNotTrack"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"a x #1","10":"a x #1","11":"a #2","5.5":"n"},"edge":{"12":"a #2","13":"a #2","14":"a #2","15":"a #2","16":"a #2","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"a #3","10":"a #3","11":"a #3","12":"a #3","13":"a #3","14":"a #3","15":"a #3","16":"a #3","17":"a #3","18":"a #3","19":"a #3","20":"a #3","21":"a #3","22":"a #3","23":"a #3","24":"a #3","25":"a #3","26":"a #3","27":"a #3","28":"a #3","29":"a #3","30":"a #3","31":"a #3","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y","7":"a #4","8":"a #4","9":"a #4","10":"y","11":"y","12":"y","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"y","6.1":"a #4","7.1":"a #4","9.1":"y","10.1":"y","11.1":"y","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"y"},"ios_saf":{"8":"a #4","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"a #4","8.1-8.4":"a #4","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"y"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"u","10":"a #4"},"op_mob":{"10":"u","11":"u","12":"u","59":"y","11.1":"u","11.5":"u","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a x #1","11":"a #2"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Partial support refers to the doNotTrack field being misnamed, or being attached to an object other than `navigator` (e.g. `window`).","notes_by_num":{"1":"IE 9 and 10 are vendor-prefixed as `navigator.msDoNotTrack`","2":"IE 11 and Edge 16- use `window.doNotTrack` instead of `navigator.doNotTrack`.","3":"Browsers based on Gecko versions prior to 32 used 'yes' and 'no' rather than '1' and '0'.","4":"Between versions 6.1.1 and 9.1.3, Safari supported an ultimately-rejected amendment to the spec, using `window.doNotTrack` rather than `navigator.doNotTrack`."},"usage_perc_y":82.58,"usage_perc_a":1.63,"ucprefix":false,"parent":"","keywords":"DNT","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"document-currentscript":{"title":"document.currentScript","description":"`document.currentScript` returns the `<script>` element whose script is currently being processed.","spec":"https://html.spec.whatwg.org/multipage/dom.html#dom-document-currentscript","status":"ls","links":[{"url":"https://github.com/JamesMGreene/document.currentScript","title":"Polyfill (IE 6-10 only)"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":96.84,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"document-evaluate-xpath":{"title":"document.evaluate & XPath","description":"Allow nodes in an XML/HTML document to be traversed using XPath expressions. ","spec":"https://www.w3.org/TR/DOM-Level-3-XPath/xpath.html#XPathEvaluator-evaluate","status":"unoff","links":[{"url":"https://timkadlec.com/2008/02/xpath-in-javascript-introduction/","title":"XPath in Javascript: Introduction"},{"url":"https://developer.mozilla.org/en-US/docs/Introduction_to_using_XPath_in_JavaScript","title":"MDN Web Docs - XPath introduction"},{"url":"https://blogs.windows.com/msedgedev/2015/03/19/improving-interoperability-with-dom-l3-xpath/","title":"Edge team article on implementation"},{"url":"https://wiki.whatwg.org/wiki/DOM_XPath","title":"DOM XPath - WHATWG Wiki"}],"categories":["DOM","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"u","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":98.24,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"dom l3 xpath,dom level 3","ie_id":"domlevel3xpath","chrome_id":"","firefox_id":"","webkit_id":""},"document-execcommand":{"title":"Document.execCommand()","description":"Allows running commands to manipulate the contents of an editable region in a document switched to designMode","spec":"https://w3c.github.io/editing/execCommand.html#execcommand()","status":"unoff","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Document/execCommand","title":"MDN Web Docs - execCommand"},{"url":"https://codepen.io/netsi1964/pen/QbLLGW","title":"execCommand and queryCommandSupported demo"}],"categories":["JS API"],"stats":{"ie":{"6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","5.5":"y"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"u","5":"u","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"u","5.1":"u","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"u","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"u","5.0-5.1":"u","6.0-6.1":"u","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"y"},"and_uc":{"12.12":"n"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"To determine what commands are supported, see `Document.queryCommandSupported()`","notes_by_num":{},"usage_perc_y":97.29,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"document,text,editor,commands,designMode","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"document-policy":{"title":"Document Policy","description":"A mechanism that allows developers to set certain rules and policies for a given site. The rules can change default browser behaviour, block certain features or set limits on resource usage. Document Policy is useful both for security and performance, and is similar to [Permissions Policy](#feat=permissions-policy).","spec":"https://w3c.github.io/webappsec-permissions-policy/document-policy.html","status":"unoff","links":[{"url":"https://github.com/w3c/webappsec-feature-policy/blob/master/document-policy-explainer.md","title":"W3C - Document Policy Explainer"},{"url":"https://mozilla.github.io/standards-positions/#document-policy","title":"Firefox position: non-harmful"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=993790","title":"Chromium tracking bug for new policies"}],"categories":["Other","Security"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"a #1","86":"a #1","87":"a #1"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"a #1","86":"a #1","87":"a #1","88":"a #1","89":"a #1","90":"a #1"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"a #1","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a #1"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"Standard support includes the HTTP `Document-Policy` header and `policy` attribute on iframes.","notes_by_num":{"1":"Chromium browsers only support the HTTP header"},"usage_perc_y":0,"usage_perc_a":66.45,"ucprefix":false,"parent":"","keywords":"feature,security,header,policy,attribute,policy attribute,attribute policy,feature-policy,feature policy,document-policy,force-load-at-top","ie_id":"","chrome_id":"5645593894453248,5756689661820928,5744681033924608","firefox_id":"","webkit_id":""},"document-scrollingelement":{"title":"document.scrollingElement","description":"`document.scrollingElement` refers to the element that scrolls the document.","spec":"https://drafts.csswg.org/cssom-view/#dom-document-scrollingelement","status":"wd","links":[{"url":"https://github.com/mathiasbynens/document.scrollingElement","title":"Polyfill"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Document/scrollingElement","title":"MDN on scrollingElement"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"u","13":"u","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":96.15,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"documenthead":{"title":"document.head","description":"Convenience property for accessing the `<head>` element","spec":"https://html.spec.whatwg.org/multipage/#dom-document-head","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Document/head","title":"MDN Web Docs - head"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"u","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"u","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"u","2.2":"u","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":99.53,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"document,head","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"dom-manip-convenience":{"title":"DOM manipulation convenience methods","description":"jQuery-like methods on DOM nodes to insert nodes around or within a node, or to replace one node with another. These methods accept any number of DOM nodes or HTML strings as arguments. Includes: `ChildNode.before`, `ChildNode.after`, `ChildNode.replaceWith`, `ParentNode.prepend`, and `ParentNode.append`.","spec":"https://dom.spec.whatwg.org/#interface-childnode","status":"ls","links":[{"url":"https://dom.spec.whatwg.org/#interface-childnode","title":"WHATWG DOM Specification for ChildNode"},{"url":"https://dom.spec.whatwg.org/#interface-parentnode","title":"WHATWG DOM Specification for ParentNode"},{"url":"http://jsbin.com/fiqacod/edit?html,js,output","title":"JS Bin testcase"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/ParentNode","title":"MDN Web Docs - ParentNode"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/ChildNode","title":"MDN Web Docs - ChildNode"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/16036408","title":"MS Edge feature request on UserVoice"},{"url":"https://github.com/WebReflection/dom4","title":"DOM4 polyfill"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n d #1","53":"n d #1","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n d #1","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n d #1"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Enabled through the \"Enable Experimental Web Platform Features\" flag in chrome://flags"},"usage_perc_y":94.84,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"dom,manipulation,convenience,convenient,before,after,replaceWith,prepend,append","ie_id":"domparentnodemethodsprependappendandchildnodemethodsbeforeafterandreplacewith","chrome_id":"5723067795898368","firefox_id":"","webkit_id":""},"dom-range":{"title":"Document Object Model Range","description":"A contiguous range of content in a Document, DocumentFragment or Attr","spec":"https://dom.spec.whatwg.org/#ranges","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Range","title":"MDN Web Docs - Range"},{"url":"https://www.quirksmode.org/dom/range_intro.html","title":"QuirksMode"},{"url":"https://github.com/timdown/rangy","title":"\"Rangy\" Range library with old IE support"}],"categories":["DOM","JS API"],"stats":{"ie":{"6":"p","7":"p","8":"p","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Range) for feature support details","notes_by_num":{},"usage_perc_y":99.61,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"DOM,range,selection","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"domcontentloaded":{"title":"DOMContentLoaded","description":"JavaScript event that fires when the DOM is loaded, but before all page assets are loaded (CSS, images, etc.).","spec":"https://html.spec.whatwg.org/multipage/syntax.html#stop-parsing","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/Reference/Events/DOMContentLoaded","title":"MDN Web Docs - DOMContentLoaded"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":99.61,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"dom,domready,onload,contentloaded,document","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"dommatrix":{"title":"DOMMatrix","description":"The `DOMMatrix` interface represents 4x4 matrices, suitable for 2D and 3D operations. Supersedes the `WebKitCSSMatrix` and `SVGMatrix` interfaces.","spec":"https://drafts.fxtf.org/geometry/#dommatrix","status":"cr","links":[{"url":"https://developer.apple.com/reference/webkitjs/webkitcssmatrix","title":"WebKitCSSMatrix API Reference"},{"url":"https://compat.spec.whatwg.org/#webkitcssmatrix-interface","title":"WebKitCSSMatrix in Compatibility Standard"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/DOMMatrix","title":"MDN Web Docs - DOMMatrix"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=581955","title":"Chrome implementation bug"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"a #1","11":"a #1","5.5":"n"},"edge":{"12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","79":"a #4","80":"a #4","81":"a #4","83":"a #4","84":"a #4","85":"a #4","86":"a #4","87":"a #4"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"a #3 #5","34":"a #3 #5","35":"a #3 #5","36":"a #3 #5","37":"a #3 #5","38":"a #3 #5","39":"a #3 #5","40":"a #3 #5","41":"a #3 #5","42":"a #3 #5","43":"a #3 #5","44":"a #3 #5","45":"a #3 #5","46":"a #3 #5","47":"a #3 #5","48":"a #3 #5","49":"a #4 #5","50":"a #4 #5","51":"a #4 #5","52":"a #4 #5","53":"a #4 #5","54":"a #4 #5","55":"a #4 #5","56":"a #4 #5","57":"a #4 #5","58":"a #4 #5","59":"a #4 #5","60":"a #4 #5","61":"a #4 #5","62":"a #4 #5","63":"a #4 #5","64":"a #4 #5","65":"a #4 #5","66":"a #4 #5","67":"a #4 #5","68":"a #4 #5","69":"a #4 #5","70":"a #4 #5","71":"a #4 #5","72":"a #4 #5","73":"a #4 #5","74":"a #4 #5","75":"a #4 #5","76":"a #4 #5","77":"a #4 #5","78":"a #4 #5","79":"a #4 #5","80":"a #4 #5","81":"a #4 #5","82":"a #4 #5","83":"a #4 #5","84":"a #4 #5","85":"a #4 #5","3.5":"n","3.6":"n"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"a #1 #2","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","59":"a #1","60":"a #1","61":"a #4","62":"a #4","63":"a #4","64":"a #4","65":"a #4","66":"a #4","67":"a #4","68":"a #4","69":"a #4","70":"a #4","71":"a #4","72":"a #4","73":"a #4","74":"a #4","75":"a #4","76":"a #4","77":"a #4","78":"a #4","79":"a #4","80":"a #4","81":"a #4","83":"a #4","84":"a #4","85":"a #4","86":"a #4","87":"a #4","88":"a #4","89":"a #4","90":"a #4"},"safari":{"4":"u","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #4","12":"a #4","13":"a #4","14":"a #4","3.1":"u","3.2":"u","5.1":"a #1","6.1":"a #1","7.1":"a #1","9.1":"a #1","10.1":"a #1","11.1":"a #4","12.1":"a #4","13.1":"a #4","TP":"a #4"},"opera":{"9":"n","11":"n","12":"n","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #4","49":"a #4","50":"a #4","51":"a #4","52":"a #4","53":"a #4","54":"a #4","55":"a #4","56":"a #4","57":"a #4","58":"a #4","60":"a #4","62":"a #4","63":"a #4","64":"a #4","65":"a #4","66":"a #4","67":"a #4","68":"a #4","69":"a #4","70":"a #4","71":"a #4","72":"a #4","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a #1","14":"a #1","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"a #1","6.0-6.1":"a #1","7.0-7.1":"a #1","8.1-8.4":"a #1","9.0-9.2":"a #1","9.3":"a #1","10.0-10.2":"a #1","10.3":"a #1","11.0-11.2":"a #1","11.3-11.4":"a #1","12.0-12.1":"a #1","12.2-12.4":"a #1","13.0-13.1":"a #1","13.2":"a #1","13.3":"a #1","13.4-13.7":"a #1"},"op_mini":{"all":"n"},"android":{"3":"a x #2","4":"a #1","81":"y","2.1":"a x #2","2.2":"a x #2","2.3":"a x #2","4.1":"a #1","4.2-4.3":"a #1","4.4":"a #1","4.4.3-4.4.4":"a #1"},"bb":{"7":"u","10":"a #1"},"op_mob":{"10":"n","11":"n","12":"n","59":"a #1","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a #4"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #1","11":"a #1"},"and_uc":{"12.12":"a #1"},"samsung":{"4":"a #1","5.0-5.4":"a #1","6.2-6.4":"a #1","7.2-7.4":"a #1","8.2":"a #1","9.2":"a #1","10.1":"a #1","11.1-11.2":"a #1","12.0":"a #1"},"and_qq":{"10.4":"a #1"},"baidu":{"7.12":"a #1"},"kaios":{"2.5":"a #3 #5"}},"notes":"","notes_by_num":{"1":"Only supports the `WebKitCSSMatrix` version of the interface, not `DOMMatrix`","2":"`WebKitCSSMatrix#skewX`, `WebKitCSSMatrix#skewY` are not supported","3":"Only supports the `DOMMatrix` version of the interface, not `WebKitCSSMatrix` (support required by spec for legacy reasons)","4":"Only replaces `WebkitCSSMatrix` and not `SVGMatrix`","5":"Does not support `fromMatrix()`, `fromFloat32Array()`, `fromFloat64Array()`, and `toJSON()` methods"},"usage_perc_y":0.23,"usage_perc_a":97.94,"ucprefix":false,"parent":"","keywords":"matrix,WebKitCSSMatrix,MSCSSMatrix,CSSMatrix,DOMMatrix,DOMMatrixReadOnly","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"download":{"title":"Download attribute","description":"When used on an anchor, this attribute signifies that the browser should download the resource the anchor points to rather than navigate to it.","spec":"https://html.spec.whatwg.org/multipage/semantics.html#downloading-resources","status":"ls","links":[{"url":"http://updates.html5rocks.com/2011/08/Downloading-resources-in-HTML5-a-download","title":"HTML5Rocks post"},{"url":"http://html5-demos.appspot.com/static/a.download.html","title":"Demo: creating a text file and downloading it."},{"url":"https://bugs.webkit.org/show_bug.cgi?id=102914","title":"WebKit feature request bug"},{"url":"https://github.com/jelmerdemaat/dwnld-attr-polyfill","title":"IE11 polyfill"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":93.74,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"download,a.download,a[download],download attribute","ie_id":"adownloadattribute","chrome_id":"6473924464345088","firefox_id":"","webkit_id":"feature-download-attribute"},"dragndrop":{"title":"Drag and Drop","description":"Method of easily dragging and dropping elements on a page, requiring minimal JavaScript.","spec":"https://html.spec.whatwg.org/multipage/interaction.html#dnd","status":"ls","links":[{"url":"http://html5doctor.com/native-drag-and-drop/","title":"HTML5 Doctor article"},{"url":"http://nettutsplus.s3.amazonaws.com/64_html5dragdrop/demo/index.html","title":"Shopping cart demo"},{"url":"http://html5demos.com/drag","title":"Demo with link blocks"},{"url":"https://www.webplatform.org/docs/dom/DragEvent","title":"WebPlatform Docs"},{"url":"https://github.com/MihaiValentin/setDragImage-IE","title":"Polyfill for setDragImage in IE"},{"url":"http://blog.teamtreehouse.com/implementing-native-drag-and-drop","title":"Implementing Native Drag and Drop"},{"url":"https://github.com/timruffles/ios-html5-drag-drop-shim","title":"iOS/Android shim for HTML 5 drag'n'drop"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6542268-setdragimage-on-datatransfer-of-dragevent","title":"Microsoft Edge setDragImage feature request on UserVoice"}],"categories":["HTML5"],"stats":{"ie":{"6":"a #1 #3","7":"a #1 #3","8":"a #1 #3","9":"a #1 #3","10":"a #2 #3","11":"a #2 #3","5.5":"a #1 #3"},"edge":{"12":"a #2","13":"a #2","14":"a #2","15":"a #2","16":"a #2","17":"a #2","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"p","3":"p","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"p","11":"p","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"p","10.0-10.1":"p","10.5":"p","10.6":"p","11.1":"p","11.5":"p","11.6":"p","12.1":"y"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y #4","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"p","11":"p","12":"p","59":"y #4","11.1":"p","11.5":"p","12.1":"y"},"and_chr":{"86":"y #4"},"and_ff":{"82":"n"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"`dataTransfer.items` only supported by Chrome.\r\n\r\nCurrently no browser supports the `dropzone` attribute.\r\n\r\nFirefox supports any kind of DOM elements for `.setDragImage`. Chrome must have either an `HTMLImageElement` or any kind of DOM Element attached to the DOM _and within the viewport_ of the browser for `.setDragImage`.","notes_by_num":{"1":"Partial support refers to no support for the `dataTransfer.files` or `.types` objects","2":"Partial support refers to not supporting `.setDragImage`","3":"Partial support refers to limited supported formats for `dataTransfer.setData`/`getData`.","4":"Not supported in Chromium browsers on Android 6 or older."},"usage_perc_y":79.93,"usage_perc_a":1.51,"ucprefix":false,"parent":"","keywords":"draganddrop, draggable","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"element-closest":{"title":"Element.closest()","description":"DOM method that returns the current element if it matches the given selector, or else the closest ancestor element that matches the given selector, or else null.","spec":"https://dom.spec.whatwg.org/#dom-element-closest","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Element/closest","title":"MDN Web Docs - closest"},{"url":"https://github.com/jonathantneal/closest","title":"Polyfill"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/10119510-element-closest","title":"Microsoft Edge feature request on UserVoice"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":95.86,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"element,closest,dom","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":"feature-element.closest()"},"element-from-point":{"title":"document.elementFromPoint()","description":"Given coordinates for a point relative to the viewport, returns the element that a click event would be dispatched at if the user were to click the point (in other words, the element that hit-testing would find).","spec":"https://www.w3.org/TR/cssom-view-1/#dom-document-elementfrompoint","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Document/elementFromPoint","title":"MDN Web Docs - elementFromPoint"}],"categories":["DOM"],"stats":{"ie":{"6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","5.5":"u"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"u","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"u","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"u","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"u","10.0-10.1":"u","10.5":"u","10.6":"u","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"u","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"u","2.2":"u","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"u","11":"u","12":"y","59":"y","11.1":"u","11.5":"u","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":99.57,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"document,elementFromPoint,element,from,point","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"element-scroll-methods":{"title":"Scroll methods on elements (scroll, scrollTo, scrollBy)","description":"Methods to change the scroll position of an element. Similar to setting `scrollTop` & `scrollLeft` properties, but also allows options to be passed to define the scroll behavior.","spec":"https://www.w3.org/TR/cssom-view-1/#extension-to-the-element-interface","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollTo","title":"MDN article on scrollTo"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollBy","title":"MDN article on scrollBy"}],"categories":["DOM","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"a #1","11.1":"a #1","12.1":"a #1","13.1":"a #1","TP":"a #1"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"a #1","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"a #1","10.3":"a #1","11.0-11.2":"a #1","11.3-11.4":"a #1","12.0-12.1":"a #1","12.2-12.4":"a #1","13.0-13.1":"a #1","13.2":"a #1","13.3":"a #1","13.4-13.7":"a #1"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"See also the support for the [`scrollIntoView` method](/#feat=scrollintoview).","notes_by_num":{"1":"Does not support the `smooth` behavior option."},"usage_perc_y":78.59,"usage_perc_a":16.04,"ucprefix":false,"parent":"","keywords":"element.prototype.scroll,element.prototype.scrollTo,element.prototype.scrollBy","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"eme":{"title":"Encrypted Media Extensions","description":"The EncryptedMediaExtenstions API provides interfaces for controlling the playback of content which is subject to a DRM scheme.","spec":"https://www.w3.org/TR/encrypted-media/","status":"rec","links":[{"url":"https://www.html5rocks.com/en/tutorials/eme/basics/","title":"HTML5rocks article"},{"url":"https://en.wikipedia.org/wiki/Encrypted_Media_Extensions","title":"Wikipedia article"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Encrypted_Media_Extensions_API","title":"Encrypted Media Extensions API on MDN"}],"categories":["JS API","Security"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"a x #1","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"a x #1","8":"a x #1","9":"a x #1","10":"a x #1","11":"a x #1","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"a x #1","9.1":"a x #1","10.1":"a x #1","11.1":"a x #1","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"u"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Only supports the older event-based specification"},"usage_perc_y":94.86,"usage_perc_a":1.42,"ucprefix":false,"parent":"","keywords":"requestMediaKeySystemAccess,createMediaKeys","ie_id":"encryptedmediaextensions","chrome_id":"6578378068983808","firefox_id":"","webkit_id":""},"eot":{"title":"EOT - Embedded OpenType fonts","description":"Type of font that can be derived from a regular font, allowing small files and legal use of high-quality fonts. Usage is restricted by the file being tied to the website","spec":"https://www.w3.org/Submission/EOT/","status":"unoff","links":[{"url":"https://en.wikipedia.org/wiki/Embedded_OpenType","title":"Wikipedia"},{"url":"https://www.microsoft.com/typography/web/embedding/default.aspx","title":"Example pages"}],"categories":["Other"],"stats":{"ie":{"6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"Proposal by Microsoft, being considered for W3C standardization.","notes_by_num":{},"usage_perc_y":1.4,"usage_perc_a":0,"ucprefix":false,"parent":"fontface","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"es5":{"title":"ECMAScript 5","description":"Full support for the ECMAScript 5 specification. Features include `Function.prototype.bind`, Array methods like `indexOf`, `forEach`, `map` & `filter`, Object methods like `defineProperty`, `create` & `keys`, the `trim` method on Strings and many more.","spec":"https://www.ecma-international.org/ecma-262/5.1/","status":"other","links":[{"url":"https://kangax.github.io/compat-table/es5/","title":"Detailed compatibility tables & tests"},{"url":"https://johnresig.com/blog/ecmascript-5-objects-and-properties/","title":"Overview of objects & properties"},{"url":"https://github.com/es-shims/es5-shim","title":"ES5 polyfill"},{"url":"https://github.com/zloirock/core-js#ecmascript","title":"Polyfill for all possible ES5 features is available in the core-js library"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n #4","9":"a #2","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"a","3":"a","4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a","3.6":"a"},"chrome":{"4":"a","5":"a","6":"a","7":"a","8":"a","9":"a","10":"a","11":"a","12":"a","13":"a","14":"a","15":"a","16":"a","17":"a","18":"a","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a","5":"a","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a","3.2":"a","5.1":"a","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"a","11":"a","12":"a","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"a","10.0-10.1":"a","10.5":"a","10.6":"a","11.1":"a","11.5":"a","11.6":"a","12.1":"a #1"},"ios_saf":{"8":"y","14":"y","3.2":"a","4.0-4.1":"a","4.2-4.3":"a","5.0-5.1":"a","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"a #1"},"android":{"3":"a","4":"a #1 #2 #3","81":"y","2.1":"a","2.2":"a","2.3":"a","4.1":"a #1","4.2-4.3":"a #1","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"a","10":"y"},"op_mob":{"10":"a","11":"a","12":"a","59":"y","11.1":"a","11.5":"a","12.1":"a #1"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"As the specification includes many JavaScript features, un-numbered partial support varies widely and is shown in detail on the [ECMAScript 5 compatibility tables](http://kangax.github.io/compat-table/es5/) by Kangax.","notes_by_num":{"1":"Does not support `parseInt()` ignoring leading zeros. ","2":"Does not support Strict mode","3":"Does not support zero-width chars in identifiers & Immutable `undefined`","4":"IE8 has virtually no ES5 support, but does support `Object.defineProperty`, `Object.getOwnPropertyDescriptor`, JSON parsing & Property access on strings"},"usage_perc_y":97.95,"usage_perc_a":1.66,"ucprefix":false,"parent":"","keywords":"es5,javascript,js,function.bind,array.foreach,array.indexof,array.map,object.keys,date.now,defineproperties,getprototypeof,keys,seal,freeze,preventextensions,issealed,isfrozen,isextensible,getownpropertydescriptorgetownpropertynames,toisostringc,isarray,lastindexof,every,some,reduce,reduceright,getter,setter","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"es6":{"title":"ECMAScript 2015 (ES6)","description":"Support for the ECMAScript 2015 specification. Features include Promises, Modules, Classes, Template Literals, Arrow Functions, Let and Const, Default Parameters, Generators, Destructuring Assignment, Rest & Spread, Map/Set & WeakMap/WeakSet and many more.","spec":"https://tc39.es/ecma262/","status":"other","links":[{"url":"http://es6-features.org","title":"ES6 New features: overview and comparisons"},{"url":"https://exploringjs.com/es6/","title":"Exploring ES6 (book)"},{"url":"https://github.com/zloirock/core-js#ecmascript","title":"Polyfill for all possible ES2015 features is available in the core-js library"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"a #1 #2","5.5":"n"},"edge":{"12":"a #2","13":"a #2","14":"a #2","15":"y #2 #3","16":"y #2 #3","17":"y #2 #3","18":"y #2 #3","79":"y #2","80":"y #2","81":"y #2","83":"y #2","84":"y #2","85":"y #2","86":"y #2","87":"y #2"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"a","7":"a","8":"a","9":"a","10":"a","11":"a","12":"a","13":"a","14":"a","15":"a","16":"a","17":"a","18":"a","19":"a","20":"a","21":"a","22":"a","23":"a","24":"a","25":"a","26":"a","27":"a","28":"a","29":"a","30":"a","31":"a","32":"a","33":"a","34":"a","35":"a","36":"a","37":"a","38":"a","39":"a","40":"a","41":"a","42":"a","43":"a","44":"a","45":"a","46":"a","47":"a","48":"a","49":"a","50":"a","51":"a","52":"a","53":"a","54":"y #2","55":"y #2","56":"y #2","57":"y #2","58":"y #2","59":"y #2","60":"y #2","61":"y #2","62":"y #2","63":"y #2","64":"y #2","65":"y #2","66":"y #2","67":"y #2","68":"y #2","69":"y #2","70":"y #2","71":"y #2","72":"y #2","73":"y #2","74":"y #2","75":"y #2","76":"y #2","77":"y #2","78":"y #2","79":"y #2","80":"y #2","81":"y #2","82":"y #2","83":"y #2","84":"y #2","85":"y #2","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"a","22":"a","23":"a","24":"a","25":"a","26":"a","27":"a","28":"a","29":"a","30":"a","31":"a","32":"a","33":"a","34":"a","35":"a","36":"a","37":"a","38":"a","39":"a","40":"a","41":"a","42":"a","43":"a","44":"a","45":"a","46":"a","47":"a","48":"a","49":"a","50":"a","51":"y #2","52":"y #2","53":"y #2","54":"y #2","55":"y #2","56":"y #2","57":"y #2","58":"y #2","59":"y #2","60":"y #2","61":"y #2","62":"y #2","63":"y #2","64":"y #2","65":"y #2","66":"y #2","67":"y #2","68":"y #2","69":"y #2","70":"y #2","71":"y #2","72":"y #2","73":"y #2","74":"y #2","75":"y #2","76":"y #2","77":"y #2","78":"y #2","79":"y #2","80":"y #2","81":"y #2","83":"y #2","84":"y #2","85":"y #2","86":"y #2","87":"y #2","88":"y #2","89":"y #2","90":"y #2"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"a","9":"a","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"a","9.1":"a","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"a","16":"a","17":"a","18":"a","19":"a","20":"a","21":"a","22":"a","23":"a","24":"a","25":"a","26":"a","27":"a","28":"a","29":"a","30":"a","31":"a","32":"a","33":"a","34":"a","35":"a","36":"a","37":"a","38":"y #2","39":"y #2","40":"y #2","41":"y #2","42":"y #2","43":"y #2","44":"y #2","45":"y #2","46":"y #2","47":"y #2","48":"y #2","49":"y #2","50":"y #2","51":"y #2","52":"y #2","53":"y #2","54":"y #2","55":"y #2","56":"y #2","57":"y #2","58":"y #2","60":"y #2","62":"y #2","63":"y #2","64":"y #2","65":"y #2","66":"y #2","67":"y #2","68":"y #2","69":"y #2","70":"y #2","71":"y #2","72":"y #2","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"a","8.1-8.4":"a","9.0-9.2":"a","9.3":"a","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y #2","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"a","4.4.3-4.4.4":"a"},"bb":{"7":"n","10":"a"},"op_mob":{"10":"n","11":"n","12":"n","59":"y #2","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y #2"},"and_ff":{"82":"y #2"},"ie_mob":{"10":"n","11":"a #1 #2"},"and_uc":{"12.12":"y #2"},"samsung":{"4":"a","5.0-5.4":"y #2","6.2-6.4":"y #2","7.2-7.4":"y #2","8.2":"y #2","9.2":"y #2","10.1":"y #2","11.1-11.2":"y #2","12.0":"y #2"},"and_qq":{"10.4":"y #2"},"baidu":{"7.12":"a"},"kaios":{"2.5":"a"}},"notes":"As ES6 refers to a huge specification and browsers have various levels of support, \"Supported\" means at least 95% of the spec is supported. \"Partial support\" refers to at least 10% of the spec being supported. For full details see the [Kangax ES6 support table](https://kangax.github.io/compat-table/es6/).","notes_by_num":{"1":"Notable partial support in IE11 includes (at least some) support for `const`, `let`, block-level function declaration, typed arrays, `Map`, `Set` and `WeakMap`.","2":"Does not support [tail call optimization](https://kangax.github.io/compat-table/es6/#test-proper_tail_calls_%28tail_call_optimisation%29)","3":"Only has partial Symbol support and partial support for `RegExp.prototype` properties"},"usage_perc_y":95.02,"usage_perc_a":2.97,"ucprefix":false,"parent":"","keywords":"javascript,block-scoped,string.prototype.includes,string.prototype.endswith,string.prototype.repeat,array.prototype.find,array.prototype.findindex,array.prototype.fill,object.assign","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"es6-class":{"title":"ES6 classes","description":"ES6 classes are syntactical sugar to provide a much simpler and clearer syntax to create objects and deal with inheritance.","spec":"https://tc39.es/ecma262/#sec-class-definitions","status":"other","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Classes","title":"MDN Web Docs - ES6 classes"},{"url":"https://www.sitepoint.com/object-oriented-javascript-deep-dive-es6-classes/","title":"Sitepoint deep dive on ES6 classes"},{"url":"https://github.com/joshburgess/not-awesome-es6-classes","title":"List of resources critical of ES6 classes"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Requires strict mode. Non-strict mode support is behind the flag 'Enable Experimental JavaScript', disabled by default."},"usage_perc_y":95.86,"usage_perc_a":0.1,"ucprefix":false,"parent":"es6","keywords":"ES6,JavaScript,class","ie_id":"classeses6","chrome_id":"4633745457938432","firefox_id":"","webkit_id":""},"es6-generators":{"title":"ES6 Generators","description":"ES6 Generators are special functions that can be used to control the iteration behavior of a loop. Generators are defined using a `function*` declaration.","spec":"https://tc39.es/ecma262/#sec-generator-function-definitions","status":"other","links":[{"url":"http://exploringjs.com/es6/ch_generators.html","title":"Exploring JS chapter on generators"},{"url":"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/function*","title":"MDN article on the `function*` declaration"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":96.04,"usage_perc_a":0,"ucprefix":false,"parent":"es6","keywords":"yield,iterators","ie_id":"generatorses6","chrome_id":"4959347197083648","firefox_id":"","webkit_id":"feature-generators"},"es6-module":{"title":"JavaScript modules via script tag","description":"Loading JavaScript module scripts using `<script type=\"module\">` Includes support for the `nomodule` attribute.","spec":"https://html.spec.whatwg.org/multipage/scripting.html#attr-script-type","status":"ls","links":[{"url":"https://strongloop.com/strongblog/an-introduction-to-javascript-es6-modules/","title":"Intro to ES6 modules"},{"url":"https://blogs.windows.com/msedgedev/2016/05/17/es6-modules-and-beyond/","title":"MS Edge blog post"},{"url":"https://hacks.mozilla.org/2015/08/es6-in-depth-modules/","title":"Mozilla hacks article"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=568953","title":"Firefox support bug"},{"url":"https://blog.hospodarets.com/native-ecmascript-modules-the-first-overview","title":"Blog post: Native ECMAScript modules - the first overview"},{"url":"https://tc39.es/ecma262/#sec-modules","title":"Counterpart ECMAScript specification for import/export syntax"},{"url":"https://html.spec.whatwg.org/multipage/scripting.html#attr-script-nomodule","title":"Specification for nomodule attribute"},{"url":"https://hospodarets.com/native-ecmascript-modules-nomodule","title":"Blog post on using nomodule"},{"url":"https://gist.github.com/jakub-g/5fc11af85a061ca29cc84892f1059fec","title":"Will it double-fetch? Browser behavior with `module` / `nomodule` scripts"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n d #1 #6","16":"y #6","17":"y #6","18":"y #6","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n d #2","55":"n d #2","56":"n d #2","57":"n d #2","58":"n d #2","59":"n d #2","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n d #1","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"a #4 #5","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n d #1","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"a #4 #5","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Support can be enabled via `about:flags`","2":"Support can be enabled via `about:config`","3":"Support can be enabled via the `experimental-web-platform-features` flag","4":"Does not support the `nomodule` attribute","5":"A [polyfill is available](https://gist.github.com/samthor/64b114e4a4f539915a95b91ffd340acc) for Safari 10.1/iOS Safari 10.3","6":"`nomodule` scripts are not executed, but they're still fetched"},"usage_perc_y":93.07,"usage_perc_a":0.32,"ucprefix":false,"parent":"","keywords":"es6,javascript,module,import,export,nomodule","ie_id":"moduleses6","chrome_id":"5365692190687232","firefox_id":"","webkit_id":"feature-modules"},"es6-module-dynamic-import":{"title":"JavaScript modules: dynamic import()","description":"Loading JavaScript modules dynamically using the import() syntax","spec":"https://tc39.es/ecma262/#sec-import-calls","status":"other","links":[{"url":"https://tc39.es/ecma262/#sec-import-calls","title":"Counterpart ECMAScript specification for import() syntax"},{"url":"https://blog.hospodarets.com/native-ecmascript-modules-dynamic-import","title":"Blog post: Native ECMAScript modules - dynamic import()"},{"url":"https://developers.google.com/web/updates/2017/11/dynamic-import","title":"Dynamic import()"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1342012","title":"Firefox implementation bug"},{"url":"https://html.spec.whatwg.org/multipage/webappapis.html#integration-with-the-javascript-module-system","title":"Integration with the HTML specification"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n d #1","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Support can be enabled via `javascript.options.dynamicImport` flag. See [bug 1517546](https://bugzil.la/1517546)."},"usage_perc_y":92.56,"usage_perc_a":0,"ucprefix":false,"parent":"es6-module","keywords":"es6,javascript,module,import,export","ie_id":"","chrome_id":"5684934484164608","firefox_id":"","webkit_id":""},"es6-number":{"title":"ES6 Number","description":"Extensions to the `Number` built-in object in ES6, including constant properties `EPSILON`, `MIN_SAFE_INTEGER`, and `MAX_SAFE_INTEGER`, and methods ` isFinite`, `isInteger`, `isSafeInteger`, and `isNaN`.","spec":"https://tc39.es/ecma262/#sec-number-objects","status":"other","links":[{"url":"http://www.2ality.com/2015/04/numbers-math-es6.html","title":"New number and Math features in ES6"},{"url":"https://github.com/zloirock/core-js#ecmascript-number","title":"Polyfill for those features is available in the core-js library"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #2","26":"a #2","27":"a #2","28":"a #2","29":"a #2","30":"a #2","31":"a #3","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"a #4","20":"a #4","21":"a #4","22":"a #4","23":"a #4","24":"a #4","25":"a #4","26":"a #4","27":"a #4","28":"a #4","29":"a #4","30":"a #4","31":"a #4","32":"a #4","33":"a #4","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"a #4","16":"a #4","17":"a #4","18":"a #4","19":"a #4","20":"a #4","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"a #4","4.2-4.3":"a #4","4.4":"a #4","4.4.3-4.4.4":"a #4"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial refers to only supporting the `isFinite`, `isInteger`, and `isNaN` methods.","2":"Partial refers to supporting the same as #1 and the addition of the `EPSILON` property.","3":"Partial refers to supporting all new features except the `isSafeInteger` method.","4":"Partial refers to only supporting the `isFinite` and `isNaN` methods."},"usage_perc_y":96.46,"usage_perc_a":0.33,"ucprefix":false,"parent":"es6","keywords":"ES6,JavaScript,number,built-in,EPSILON,MIN_SAFE_INTEGER,MAX_SAFE_INTEGER,isFinite,isInteger,isSafeInteger,isNaN","ie_id":"numberbuiltinses6","chrome_id":"","firefox_id":"","webkit_id":""},"es6-string-includes":{"title":"String.prototype.includes","description":"The includes() method determines whether one string may be found within another string, returning true or false as appropriate.","spec":"https://tc39.es/ecma262/#sec-string.prototype.includes","status":"other","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes","title":"MDN: String.prototype.includes()"},{"url":"https://github.com/zloirock/core-js#ecmascript-string-and-regexp","title":"Polyfill for this feature is available in the core-js library"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":96.31,"usage_perc_a":0,"ucprefix":false,"parent":"es6","keywords":"ES6,JavaScript,String,includes","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"eventsource":{"title":"Server-sent events","description":"Method of continuously sending data from a server to the browser, rather than repeatedly requesting it (EventSource interface, used to fall under HTML5)","spec":"https://html.spec.whatwg.org/multipage/comms.html#server-sent-events","status":"ls","links":[{"url":"https://www.html5rocks.com/tutorials/eventsource/basics/","title":"HTML5 Rocks tutorial"},{"url":"http://samshull.blogspot.com/2010/10/ajax-push-in-ios-safari-and-chrome-with.html","title":"Blog post with demo"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/features.js#native-eventsource","title":"has.js test"},{"url":"https://github.com/Yaffle/EventSource","title":"Polyfill"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"a","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"a","10.0-10.1":"a","10.5":"a","10.6":"a","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"a","11":"a","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":96.82,"usage_perc_a":0.03,"ucprefix":false,"parent":"","keywords":"serversent,s-sent-events,server sent events,server side events","ie_id":"serversenteventseventsource","chrome_id":"5311740673785856","firefox_id":"","webkit_id":""},"extended-system-fonts":{"title":"ui-serif, ui-sans-serif, ui-monospace and ui-rounded values for font-family","description":"Allows more control when choosing system interface fonts","spec":"https://drafts.csswg.org/css-fonts-4/#ui-serif-def","status":"wd","links":[{"url":"https://webkit.org/blog/10247/new-webkit-features-in-safari-13-1/","title":"WebKit Safari 13.1 announcement"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1598879","title":"ui-serif Firefox support bug"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1598880","title":"ui-sans-serif Firefox support bug"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1598881","title":"ui-monospace Firefox support bug"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1598883","title":"ui-rounded Firefox support bug"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":11.96,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"font-family,ui-serif,ui-sans-serif,ui-monospace,ui-rounded","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"feature-policy":{"title":"Feature Policy","description":"This specification defines a mechanism that allows developers to selectively enable and disable use of various browser features and APIs. Feature Policy is deprecated and has been replaced with [Permissions Policy](#feat=permissions-policy) and [Document Policy](#feat=document-policy).","spec":"https://www.w3.org/TR/2019/WD-feature-policy-1-20190416/","status":"wd","links":[{"url":"https://feature-policy-demos.appspot.com/","title":"Feature Policy Kitchen Sink Demos"},{"url":"https://developers.google.com/web/updates/2018/06/feature-policy","title":"Introduction to Feature Policy"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1390801","title":"Firefox implemention ticket"},{"url":"https://chrome.google.com/webstore/detail/feature-policy-tester-dev/pchamnkhkeokbpahnocjaeednpbpacop","title":"Feature Policy Tester (Chrome DevTools Extension)"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/33507907-support-feature-policy","title":"MS Edge feature suggestion"},{"url":"https://featurepolicy.info/","title":"featurepolicy.info (Feature-Policy Playground)"},{"url":"https://github.com/w3c/webappsec-feature-policy/blob/master/features.md","title":"List of known features"}],"categories":["JS API","Other","Security"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"a #2","75":"a #2","76":"a #2","77":"a #2","78":"a #2","79":"a #2","80":"a #2","81":"a #2","82":"a #2","83":"a #2","84":"a #2","85":"a #2","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"a #1","61":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #1","66":"a #1","67":"a #1","68":"a #1","69":"a #1","70":"a #1","71":"a #1","72":"a #1","73":"a #1","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y #4","87":"y #4","88":"y #4","89":"y #4","90":"y #4"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"a #2 #3","13":"a #2 #3","14":"a #2 #3","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"a #2 #3","12.1":"a #2 #3","13.1":"a #2 #3","TP":"a #2 #3"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","60":"a #1","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"a #2 #3","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"a #2 #3","12.0-12.1":"a #2 #3","12.2-12.4":"a #2 #3","13.0-13.1":"a #2 #3","13.2":"a #2 #3","13.3":"a #2 #3","13.4-13.7":"a #2 #3"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"a #2"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"a #1","9.2":"a #1","10.1":"a #1","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"a #1"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"Standard support includes the HTTP `Feature-Policy` header, `allow` attribute on iframes and the `document.featurePolicy` JS API.","notes_by_num":{"1":"Older Chromium browsers did not support the JS API.","2":"Safari and Firefox only supports the `allow` attribute on iframes.","3":"Safari doesn't support a [list of origins](https://bugs.webkit.org/show_bug.cgi?id=189901) or a [wildcard](https://bugs.webkit.org/show_bug.cgi?id=187816).","4":"Supports [Permissions Policy](#feat=permissions-policy), the main replacement for this spec."},"usage_perc_y":72.23,"usage_perc_a":20.21,"ucprefix":false,"parent":"","keywords":"feature,security,header,allow,attribute,allow attribute,attribute allow,feature-policy,document.featurePolicy,document.policy","ie_id":"","chrome_id":"5694225681219584,5190687460950016","firefox_id":"feature-policy","webkit_id":""},"fetch":{"title":"Fetch","description":"A modern replacement for XMLHttpRequest.","spec":"https://fetch.spec.whatwg.org/","status":"ls","links":[{"url":"https://github.com/github/fetch","title":"Polyfill"},{"url":"https://addyosmani.com/demos/fetch-api/","title":"Demo"},{"url":"https://github.com/developit/unfetch","title":"Polyfill (minimal, 500 bytes)"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n d #1 #4","35":"n d #1 #4","36":"n d #1 #4","37":"n d #1 #4","38":"n d #1 #4","39":"y #4","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"a #2","41":"a #2 #3","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"a #2","28":"a #2 #3","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support can be enabled in Firefox with the `dom.fetch.enabled` flag.","2":"Only available in Chrome and Opera within ServiceWorkers.","3":"Available in Chrome and Opera within Window and Workers by enabling the \"Experimental Web Platform Features\" flag in `chrome://flags`","4":"Firefox <40 is not completely conforming to the specs and does not respect the <base> tag for relative URIs in fetch requests. https://bugzilla.mozilla.org/show_bug.cgi?id=1161625","5":"Appears to exist in Safari Technology Preview but does not work in current build. Should work in [next preview build](https://twitter.com/xeenon/status/715379838081576960)","6":"Can be enabled in `about:flags`"},"usage_perc_y":95.84,"usage_perc_a":0.05,"ucprefix":false,"parent":"","keywords":"fetch,service,workers,xhr,xmlhttprequest","ie_id":"fetchapi","chrome_id":"6730533392351232","firefox_id":"fetch","webkit_id":"specification-fetch"},"fieldset-disabled":{"title":"disabled attribute of the fieldset element","description":"Allows disabling all of the form control descendants of a fieldset via a `disabled` attribute on the fieldset element itself.","spec":"https://html.spec.whatwg.org/multipage/forms.html#attr-fieldset-disabled","status":"ls","links":[{"url":"http://output.jsbin.com/bibiqi/1/edit","title":"JS Bin Testcase/Demo"}],"categories":["DOM","HTML5"],"stats":{"ie":{"6":"a #1 #2","7":"a #1 #2","8":"a #1","9":"a #1","10":"a #1 #2","11":"a #1 #2","5.5":"u"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"u","17":"u","18":"u","19":"u","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"u","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"a #1 #2"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"a #2"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Text inputs that are descendants of a disabled fieldset appear disabled but the user can still interact with them. [See IE bug #962368.](https://connect.microsoft.com/IE/feedbackdetail/view/962368/can-still-edit-input-type-text-within-fieldset-disabled)","2":"File inputs that are descendants of a disabled fieldset appear disabled but the user can still interact with them. [See IE bug #817488.](https://connect.microsoft.com/IE/feedbackdetail/view/817488)"},"usage_perc_y":97,"usage_perc_a":2.3,"ucprefix":false,"parent":"","keywords":"HTMLFieldSetElement,fieldset,disabled","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"fileapi":{"title":"File API","description":"Method of manipulating file objects in web applications client-side, as well as programmatically selecting them and accessing their data.","spec":"https://www.w3.org/TR/FileAPI/","status":"wd","links":[{"url":"https://developer.mozilla.org/en/Using_files_from_web_applications","title":"MDN Web Docs - Using Files"},{"url":"https://www.webplatform.org/docs/apis/file","title":"WebPlatform Docs"},{"url":"https://github.com/moxiecode/moxie","title":"Polyfill"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"a #2","11":"a #2","5.5":"n"},"edge":{"12":"a #2","13":"a #2","14":"a #2","15":"a #2","16":"a #2","17":"a #2","18":"a #2","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a #2","5":"a #2","6":"a #2","7":"a #2","8":"a #2","9":"a #2","10":"a #2","11":"a #2","12":"a #2","13":"a #2","14":"a #2","15":"a #2","16":"a #2","17":"a #2","18":"a #2","19":"a #2","20":"a #2","21":"a #2","22":"a #2","23":"a #2","24":"a #2","25":"a #2","26":"a #2","27":"a #2","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"a #2"},"chrome":{"4":"n","5":"n","6":"a #1 #2","7":"a #1 #2","8":"a #1 #2","9":"a #1 #2","10":"a #1 #2","11":"a #1 #2","12":"a #1 #2","13":"a #2","14":"a #2","15":"a #2","16":"a #2","17":"a #2","18":"a #2","19":"a #2","20":"a #2","21":"a #2","22":"a #2","23":"a #2","24":"a #2","25":"a #2","26":"a #2","27":"a #2","28":"a #2","29":"a #2","30":"a #2","31":"a #2","32":"a #2","33":"a #2","34":"a #2","35":"a #2","36":"a #2","37":"a #2","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"a #2","7":"a #2","8":"a #2","9":"a #2","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"a #1 #2","6.1":"a #2","7.1":"a #2","9.1":"a #2","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"a #2","15":"a #2","16":"a #2","17":"a #2","18":"a #2","19":"a #2","20":"a #2","21":"a #2","22":"a #2","23":"a #2","24":"a #2","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"a #2","11.5":"a #2","11.6":"a #2","12.1":"a #2"},"ios_saf":{"8":"a #2","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"a #2","7.0-7.1":"a #2","8.1-8.4":"a #2","9.0-9.2":"a #2","9.3":"a #2","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"a #1 #2","4":"a #1 #2","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"a #1 #2","4.2-4.3":"a #1 #2","4.4":"a #2","4.4.3-4.4.4":"y"},"bb":{"7":"a #1 #2","10":"a #2"},"op_mob":{"10":"n","11":"n","12":"a #2","59":"y","11.1":"a #2","11.5":"a #2","12.1":"a #2"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"a #2"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Does not have `FileReader` support. ","2":"Does not support the `File` constructor"},"usage_perc_y":95.75,"usage_perc_a":2.64,"ucprefix":false,"parent":"","keywords":"FileReader","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"filereader":{"title":"FileReader API","description":"Method of reading the contents of a File or Blob object into memory","spec":"https://www.w3.org/TR/FileAPI/#dfn-filereader","status":"wd","links":[{"url":"https://developer.mozilla.org/en/DOM/FileReader","title":"MDN Web Docs - FileReader"},{"url":"https://www.webplatform.org/docs/apis/file/FileReader","title":"WebPlatform Docs"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"a #1","11":"a #1","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"y"},"chrome":{"4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Does not support `readAsBinaryString`, but `readAsBinaryString` [can be polyfilled](https://stackoverflow.com/q/31391207)"},"usage_perc_y":97.16,"usage_perc_a":1.11,"ucprefix":false,"parent":"fileapi","keywords":"","ie_id":"filereader","chrome_id":"5171003185430528","firefox_id":"","webkit_id":""},"filereadersync":{"title":"FileReaderSync","description":"Allows files to be read synchronously in Web Workers","spec":"https://w3c.github.io/FileAPI/#FileReaderSync","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/FileReaderSync","title":"MDN Web Docs - FileReaderSync"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"u","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"u","10.6":"u","11.1":"u","11.5":"u","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"u","12":"y","59":"y","11.1":"u","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":98.08,"usage_perc_a":0,"ucprefix":false,"parent":"filereader","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"filesystem":{"title":"Filesystem & FileWriter API","description":"Method of reading and writing files to a sandboxed file system.","spec":"https://www.w3.org/TR/file-system-api/","status":"unoff","links":[{"url":"https://www.html5rocks.com/en/tutorials/file/filesystem/","title":"HTML5 Rocks tutorial"},{"url":"https://www.webplatform.org/docs/apis/filesystem","title":"WebPlatform Docs"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=997471","title":"Firefox tracking bug"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y x","80":"y x","81":"y x","83":"y x","84":"y x","85":"y x","86":"y x","87":"y x"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"a x","9":"a x","10":"a x","11":"a x","12":"a x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","59":"y x","60":"y x","61":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y x","70":"y x","71":"y x","72":"y x","73":"y x","74":"y x","75":"y x","76":"y x","77":"y x","78":"y x","79":"y x","80":"y x","81":"y x","83":"y x","84":"y x","85":"y x","86":"y x","87":"y x","88":"y x","89":"y x","90":"y x"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","60":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y x","70":"y x","71":"y x","72":"y x","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"y x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y x","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y x"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"y x","6.2-6.4":"y x","7.2-7.4":"y x","8.2":"y x","9.2":"y x","10.1":"y x","11.1-11.2":"y x","12.0":"y x"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"The File API: Directories and System specification is no longer being maintained and support may be dropped in future versions.","notes_by_num":{},"usage_perc_y":74.17,"usage_perc_a":0.03,"ucprefix":false,"parent":"","keywords":"filewriter,requestFileSystem","ie_id":"filewriter","chrome_id":"5452478162141184","firefox_id":"","webkit_id":""},"flac":{"title":"FLAC audio format","description":"Popular lossless audio compression format","spec":"https://xiph.org/flac/format.html","status":"other","links":[{"url":"https://en.wikipedia.org/wiki/FLAC","title":"Wikipedia"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=93887","title":"Chrome support bug"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/15601752-support-flac","title":"Edge UserVoice request"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"u","45":"u","46":"u","47":"a #1 #2","48":"a #1 #2","49":"a #1 #2","50":"a #1 #2","51":"a #1 #2","52":"a #1 #2","53":"a #1 #2","54":"a #1 #2","55":"a #1 #2","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"a #3","12":"a #3","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"a #3","12.1":"a #3","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"u","4":"u","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"u","4.2-4.3":"u","4.4":"u","4.4.3-4.4.4":"u"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"u","11":"u","12":"u","59":"y #1","11.1":"u","11.5":"u","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y #1","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"Support refers to this format's use in the `audio` element, not other conditions.","notes_by_num":{"1":"HTMLMediaElement.canPlayType('audio/flac') returns an empty string","2":"Only works on ChromeOS","3":"Supported only on macOS High Sierra or later"},"usage_perc_y":94.56,"usage_perc_a":0.69,"ucprefix":false,"parent":"audio","keywords":"flac,lossless,audio","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"flexbox":{"title":"CSS Flexible Box Layout Module","description":"Method of positioning elements in horizontal or vertical stacks. Support includes all properties prefixed with `flex`, as well as `display: flex`, `display: inline-flex`, `align-content`, `align-items`, `align-self`, `justify-content` and `order`.","spec":"https://www.w3.org/TR/css3-flexbox/","status":"cr","links":[{"url":"https://bennettfeely.com/flexplorer/","title":"Flexbox CSS generator"},{"url":"https://www.adobe.com/devnet/html5/articles/working-with-flexbox-the-new-spec.html","title":"Article on using the latest spec"},{"url":"https://dev.opera.com/articles/view/advanced-cross-browser-flexbox/","title":"Tutorial on cross-browser support"},{"url":"https://philipwalton.github.io/solved-by-flexbox/","title":"Examples on how to solve common layout problems with flexbox"},{"url":"https://css-tricks.com/snippets/css/a-guide-to-flexbox/","title":"A Complete Guide to Flexbox"},{"url":"https://the-echoplex.net/flexyboxes/","title":"Flexbox playground and code generator"},{"url":"https://github.com/philipwalton/flexbugs","title":"Flexbugs: Repo for flexbox bugs"},{"url":"https://github.com/10up/flexibility/","title":"10up Open Sources IE 8 and 9 Support for Flexbox"},{"url":"https://github.com/vadimyer/ecligrid","title":"Ecligrid - Mobile first flexbox grid system"},{"url":"https://mastery.games/post/the-difference-between-width-and-flex-basis/","title":"The Difference Between Width and Flex-Basis"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"a x #2 #4","11":"a #4","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"a x #1","3":"a x #1","4":"a x #1","5":"a x #1","6":"a x #1","7":"a x #1","8":"a x #1","9":"a x #1","10":"a x #1","11":"a x #1","12":"a x #1","13":"a x #1","14":"a x #1","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","19":"a x #1","20":"a x #1","21":"a x #1","22":"a #3","23":"a #3","24":"a #3","25":"a #3","26":"a #3","27":"a #3","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a x #1","3.6":"a x #1"},"chrome":{"4":"a x #1","5":"a x #1","6":"a x #1","7":"a x #1","8":"a x #1","9":"a x #1","10":"a x #1","11":"a x #1","12":"a x #1","13":"a x #1","14":"a x #1","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","19":"a x #1","20":"a x #1","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a x #1","5":"a x #1","6":"a x #1","7":"y x","8":"y x","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a x #1","3.2":"a x #1","5.1":"a x #1","6.1":"y x","7.1":"y x","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"y"},"ios_saf":{"8":"y x","14":"y","3.2":"a x #1","4.0-4.1":"a x #1","4.2-4.3":"a x #1","5.0-5.1":"a x #1","6.0-6.1":"a x #1","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"a x #1","4":"a x #1","81":"y","2.1":"a x #1","2.2":"a x #1","2.3":"a x #1","4.1":"a x #1","4.2-4.3":"a x #1","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"a x #1","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a x #2","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Most partial support refers to supporting an [older version](https://www.w3.org/TR/2009/WD-css3-flexbox-20090723/) of the specification or an [older syntax](https://www.w3.org/TR/2012/WD-css3-flexbox-20120322/).","notes_by_num":{"1":"Only supports the [old flexbox](https://www.w3.org/TR/2009/WD-css3-flexbox-20090723) specification and does not support wrapping.","2":"Only supports the [2012 syntax](https://www.w3.org/TR/2012/WD-css3-flexbox-20120322/)","3":"Does not support flex-wrap, flex-flow or align-content properties","4":"Partial support is due to large amount of bugs present (see known issues)"},"usage_perc_y":97.65,"usage_perc_a":1.68,"ucprefix":false,"parent":"","keywords":"flex-box,flex-direction,flex-wrap,flex-flow,flex-grow,flex-shrink,flex-basis,display:flex,justify-content:space-between,justify-content:space-around,align-content:space-between,align-content:space-around,space-between","ie_id":"flexbox","chrome_id":"4837301406400512","firefox_id":"","webkit_id":""},"flexbox-gap":{"title":"gap property for Flexbox","description":"`gap` for flexbox containers to create gaps/gutters between flex items","spec":"https://www.w3.org/TR/css-align-3/#gaps","status":"wd","links":[{"url":"https://github.com/w3c/csswg-drafts/issues/592","title":"Spec discussion"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=762679","title":"Chrome bug to track implementation"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/gap#Browser_compatibility","title":"MDN browser compatibility"},{"url":"https://gist.github.com/OliverJAsh/7f29d0fa1d35216ec681d2949c3fe8b7","title":"Workaround using negative margins"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=206767","title":"Webkit support bug"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Can be enabled in Chrome via the `#enable-experimental-web-platform-features` flag in `chrome://flags`"},"usage_perc_y":70.62,"usage_perc_a":0,"ucprefix":false,"parent":"flexbox","keywords":"flexbox,gaps,gutters,row-gap,column-gap","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"flow-root":{"title":"display: flow-root","description":"The element generates a block container box, and lays out its contents using flow layout. It always establishes a new block formatting context for its contents. It provides a better solution to the most use cases of the \"clearfix\" hack.","spec":"https://www.w3.org/TR/css-display-3/#valdef-display-flow-root","status":"wd","links":[{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1322191","title":"Mozilla bug report"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=672508","title":"Chromium bug report"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=165603","title":"WebKit bug report"},{"url":"https://wpdev.uservoice.com/forums/257854/suggestions/17420707","title":"Edge bug report"},{"url":"https://rachelandrew.co.uk/archives/2017/01/24/the-end-of-the-clearfix-hack/","title":"Blog post: \"The end of the clearfix hack?\""}],"categories":["CSS","CSS2"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":90.22,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"display,flow-root","ie_id":"","chrome_id":"5769454877147136","firefox_id":"css-display-flow-root","webkit_id":""},"focusin-focusout-events":{"title":"focusin & focusout events","description":"The `focusin` and `focusout` events fire just before the element gains or loses focus, and they bubble. By contrast, the `focus` and `blur` events fire after the focus has shifted, and don't bubble.","spec":"https://www.w3.org/TR/DOM-Level-3-Events/#event-type-focusin","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/Events/focusin","title":"MDN Web Docs - focusin"},{"url":"https://developer.mozilla.org/en-US/docs/Web/Events/focusout","title":"MDN Web Docs - focusout"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=687787","title":"Mozilla Bug 687787 - Add support for DOM3 focusin/focusout"}],"categories":["DOM"],"stats":{"ie":{"6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"u","5":"u","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"u","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"u","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"u","11.5":"u","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"u","4":"y","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"u","12":"y","59":"y","11.1":"u","11.5":"u","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"In browsers that don't support these events, one alternative is to use a capture phase event listener for the `focus` and/or `blur` events.","notes_by_num":{},"usage_perc_y":98.24,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"focusin,focusout,focus,event","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"font-family-system-ui":{"title":"system-ui value for font-family","description":"Value for `font-family` that represents the default user interface font.","spec":"https://drafts.csswg.org/css-fonts-4/#system-ui-def","status":"wd","links":[{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1226042","title":"Firefox support bug"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/font-family","title":"MDN on the font-family property"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","59":"a #1","60":"a #1","61":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #1","66":"a #1","67":"a #1","68":"a #1","69":"a #1","70":"a #1","71":"a #1","72":"a #1","73":"a #1","74":"a #1","75":"a #1","76":"a #1","77":"a #1","78":"a #1","79":"a #1","80":"a #1","81":"a #1","82":"a #1","83":"a #1","84":"a #1","85":"a #1","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"a #2","54":"a #2","55":"a #2","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"u","10":"a #1","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"a #1","10.1":"a #1","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"a #1","9.3":"a #1","10.0-10.2":"a #1","10.3":"a #1","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"a #1"}},"notes":"","notes_by_num":{"1":"Supported as the `-apple-system` value (only on macOS and iOS)","2":"Supported as the `BlinkMacSystemFont` value (only on macOS)"},"usage_perc_y":90.46,"usage_perc_a":4.52,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"5640395337760768","firefox_id":"","webkit_id":""},"font-feature":{"title":"CSS font-feature-settings","description":"Method of applying advanced typographic and language-specific font features to supported OpenType fonts.","spec":"https://w3.org/TR/css3-fonts/#font-rend-props","status":"cr","links":[{"url":"http://ie.microsoft.com/testdrive/Graphics/opentype/","title":"Demo pages (IE/Firefox only)"},{"url":"https://hacks.mozilla.org/2010/11/firefox-4-font-feature-support/","title":"Mozilla hacks article"},{"url":"http://html5accessibility.com/","title":"Detailed tables on accessability support"},{"url":"https://www.webplatform.org/docs/css/properties/font-feature-settings","title":"WebPlatform Docs"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/font-feature-settings","title":"MDN Web Docs - font-feature-settings"},{"url":"https://www.microsoft.com/typography/otspec/featuretags.htm","title":"OpenType layout feature tag registry"},{"url":"http://help.typekit.com/customer/portal/articles/1789736-syntax-for-opentype-features-in-css#salt","title":"Syntax for OpenType features in CSS (Adobe Typekit Help)"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a x #1","5":"a x #1","6":"a x #1","7":"a x #1","8":"a x #1","9":"a x #1","10":"a x #1","11":"a x #1","12":"a x #1","13":"a x #1","14":"a x #1","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"a x #2","17":"a x #2","18":"a x #2","19":"a x #2","20":"a x #2","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a","5":"a","6":"a","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"a","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"a","4.0-4.1":"a","4.2-4.3":"a","5.0-5.1":"a","6.0-6.1":"a","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"n","10":"y x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y x","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Whenever possible, font-variant shorthand property or an associated longhand property, font-variant-ligatures, font-variant-caps, font-variant-east-asian, font-variant-alternates, font-variant-numeric or font-variant-position should be used. This property is a low-level feature designed to handle special cases where no other way to enable or access an OpenType font feature exists. In particular, this CSS property shouldn't be used to enable small caps.","notes_by_num":{"1":"From Gecko 2.0 (Firefox 4.0) to Gecko 14.0 (Firefox 14.0) included, Gecko supported an older syntax, slightly different from the modern one: https://hacks.mozilla.org/2010/11/firefox-4-font-feature-support/","2":"Partial support in older Chrome versions refers to lacking support in Mac OS X."},"usage_perc_y":97.84,"usage_perc_a":0.29,"ucprefix":false,"parent":"","keywords":"font-feature,font-feature-settings,kern,kerning,font-variant-alternates,ligatures,font-variant-ligatures","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"font-kerning":{"title":"CSS3 font-kerning","description":"Controls the usage of the kerning information (spacing between letters) stored in the font. Note that this only affects OpenType fonts with kerning information, it has no effect on other fonts.","spec":"https://www.w3.org/TR/css3-fonts/#font-kerning-prop","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/font-kerning","title":"MDN Web Docs - CSS font-kerning"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n d #1","25":"n d #1","26":"n d #1","27":"n d #1","28":"n d #1","29":"n d #1","30":"n d #1","31":"n d #1","32":"n d #1","33":"n d #1","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"y x","30":"y x","31":"y x","32":"y x","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"y x","8":"y x","9":"y x","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"y x","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"y x","17":"y x","18":"y x","19":"y x","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y x","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y x","10.3":"y x","11.0-11.2":"y x","11.3-11.4":"y x","12.0-12.1":"y x","12.2-12.4":"y x","13.0-13.1":"y x","13.2":"y x","13.3":"y x","13.4-13.7":"y x"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y x","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Browsers with support for [font feature settings](https://caniuse.com/#feat=font-feature) can also set kerning value.","notes_by_num":{"1":"Disabled by default, can be enabled using preference layout.css.font-features.enabled - defaulting to true on Nightly and Aurora only."},"usage_perc_y":96.24,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"font-loading":{"title":"CSS Font Loading","description":"This CSS module defines a scripting interface to font faces in CSS, allowing font faces to be easily created and loaded from script. It also provides methods to track the loading status of an individual font, or of all the fonts on an entire page.","spec":"https://www.w3.org/TR/css-font-loading-3/","status":"wd","links":[{"url":"https://www.igvita.com/2014/01/31/optimizing-web-font-rendering-performance/#font-load-events","title":"Optimizing with font load events"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6509785-css-font-loading","title":"Microsoft Edge feature request on UserVoice"}],"categories":["CSS3","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n d #1","36":"n d #1","37":"n d #1","38":"n d #1","39":"n d #1","40":"n d #1","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Can be enabled in Firefox using the `layout.css.font-loading-api.enabled` flag. Enabled by default in Firefox 41. See [this bug](https://bugzilla.mozilla.org/show_bug.cgi?id=1149381)"},"usage_perc_y":95.64,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"fontface,fontfaceset,fontfacesource,document.fonts","ie_id":"","chrome_id":"6244676289953792","firefox_id":"","webkit_id":""},"font-size-adjust":{"title":"CSS font-size-adjust","description":"Method of adjusting the font size in a matter that relates to the height of lowercase vs. uppercase letters. This makes it easier to set the size of fallback fonts.","spec":"https://www.w3.org/TR/css-fonts-3/#font-size-adjust-prop","status":"cr","links":[{"url":"http://webdesignernotebook.com/css/the-little-known-font-size-adjust-css3-property/","title":"Article on font-size-adjust"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/font-size-adjust","title":"MDN Web Docs - CSS font-size-adjust"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6514821-font-size-adjust-other-font-properties","title":"Microsoft Edge feature request on UserVoice"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n d #1","80":"n d #1","81":"n d #1","83":"n d #1","84":"n d #1","85":"n d #1","86":"n d #1","87":"n d #1"},"firefox":{"2":"n","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n d #1","44":"n d #1","45":"n d #1","46":"n d #1","47":"n d #1","48":"n d #1","49":"n d #1","50":"n d #1","51":"n d #1","52":"n d #1","53":"n d #1","54":"n d #1","55":"n d #1","56":"n d #1","57":"n d #1","58":"n d #1","59":"n d #1","60":"n d #1","61":"n d #1","62":"n d #1","63":"n d #1","64":"n d #1","65":"n d #1","66":"n d #1","67":"n d #1","68":"n d #1","69":"n d #1","70":"n d #1","71":"n d #1","72":"n d #1","73":"n d #1","74":"n d #1","75":"n d #1","76":"n d #1","77":"n d #1","78":"n d #1","79":"n d #1","80":"n d #1","81":"n d #1","83":"n d #1","84":"n d #1","85":"n d #1","86":"n d #1","87":"n d #1","88":"n d #1","89":"n d #1","90":"n d #1"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n d #1","31":"n d #1","32":"n d #1","33":"n d #1","34":"n d #1","35":"n d #1","36":"n d #1","37":"n d #1","38":"n d #1","39":"n d #1","40":"n d #1","41":"n d #1","42":"n d #1","43":"n d #1","44":"n d #1","45":"n d #1","46":"n d #1","47":"n d #1","48":"n d #1","49":"n d #1","50":"n d #1","51":"n d #1","52":"n d #1","53":"n d #1","54":"n d #1","55":"n d #1","56":"n d #1","57":"n d #1","58":"n d #1","60":"n d #1","62":"n d #1","63":"n d #1","64":"n d #1","65":"n d #1","66":"n d #1","67":"n d #1","68":"n d #1","69":"n d #1","70":"n d #1","71":"n d #1","72":"n d #1","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n #2"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n d #1"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Enabled through the \"experimental Web Platform features\" flag in chrome://flags","2":"Does not appear to work on Firefox mobile, despite recognition of the property."},"usage_perc_y":3.96,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"5720910061371392","firefox_id":"","webkit_id":""},"font-smooth":{"title":"CSS font-smooth","description":"Controls the application of anti-aliasing when fonts are rendered.","spec":"https://www.w3.org/TR/WD-font/#font-smooth","status":"unoff","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/font-smooth","title":"MDN Web Docs - font-smooth"},{"url":"https://www.w3.org/TR/WD-font/#font-smooth","title":"Old version of W3C recommendation containing font-smooth"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"a x #1 #3","80":"a x #1 #3","81":"a x #1 #3","83":"a x #1 #3","84":"a x #1 #3","85":"a x #1 #3","86":"a x #1 #3","87":"a x #1 #3"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"a x #2 #3","26":"a x #2 #3","27":"a x #2 #3","28":"a x #2 #3","29":"a x #2 #3","30":"a x #2 #3","31":"a x #2 #3","32":"a x #2 #3","33":"a x #2 #3","34":"a x #2 #3","35":"a x #2 #3","36":"a x #2 #3","37":"a x #2 #3","38":"a x #2 #3","39":"a x #2 #3","40":"a x #2 #3","41":"a x #2 #3","42":"a x #2 #3","43":"a x #2 #3","44":"a x #2 #3","45":"a x #2 #3","46":"a x #2 #3","47":"a x #2 #3","48":"a x #2 #3","49":"a x #2 #3","50":"a x #2 #3","51":"a x #2 #3","52":"a x #2 #3","53":"a x #2 #3","54":"a x #2 #3","55":"a x #2 #3","56":"a x #2 #3","57":"a x #2 #3","58":"a x #2 #3","59":"a x #2 #3","60":"a x #2 #3","61":"a x #2 #3","62":"a x #2 #3","63":"a x #2 #3","64":"a x #2 #3","65":"a x #2 #3","66":"a x #2 #3","67":"a x #2 #3","68":"a x #2 #3","69":"a x #2 #3","70":"a x #2 #3","71":"a x #2 #3","72":"a x #2 #3","73":"a x #2 #3","74":"a x #2 #3","75":"a x #2 #3","76":"a x #2 #3","77":"a x #2 #3","78":"a x #2 #3","79":"a x #2 #3","80":"a x #2 #3","81":"a x #2 #3","82":"a x #2 #3","83":"a x #2 #3","84":"a x #2 #3","85":"a x #2 #3","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"a x #1 #3","6":"a x #1 #3","7":"a x #1 #3","8":"a x #1 #3","9":"a x #1 #3","10":"a x #1 #3","11":"a x #1 #3","12":"a x #1 #3","13":"a x #1 #3","14":"a x #1 #3","15":"a x #1 #3","16":"a x #1 #3","17":"a x #1 #3","18":"a x #1 #3","19":"a x #1 #3","20":"a x #1 #3","21":"a x #1 #3","22":"a x #1 #3","23":"a x #1 #3","24":"a x #1 #3","25":"a x #1 #3","26":"a x #1 #3","27":"a x #1 #3","28":"a x #1 #3","29":"a x #1 #3","30":"a x #1 #3","31":"a x #1 #3","32":"a x #1 #3","33":"a x #1 #3","34":"a x #1 #3","35":"a x #1 #3","36":"a x #1 #3","37":"a x #1 #3","38":"a x #1 #3","39":"a x #1 #3","40":"a x #1 #3","41":"a x #1 #3","42":"a x #1 #3","43":"a x #1 #3","44":"a x #1 #3","45":"a x #1 #3","46":"a x #1 #3","47":"a x #1 #3","48":"a x #1 #3","49":"a x #1 #3","50":"a x #1 #3","51":"a x #1 #3","52":"a x #1 #3","53":"a x #1 #3","54":"a x #1 #3","55":"a x #1 #3","56":"a x #1 #3","57":"a x #1 #3","58":"a x #1 #3","59":"a x #1 #3","60":"a x #1 #3","61":"a x #1 #3","62":"a x #1 #3","63":"a x #1 #3","64":"a x #1 #3","65":"a x #1 #3","66":"a x #1 #3","67":"a x #1 #3","68":"a x #1 #3","69":"a x #1 #3","70":"a x #1 #3","71":"a x #1 #3","72":"a x #1 #3","73":"a x #1 #3","74":"a x #1 #3","75":"a x #1 #3","76":"a x #1 #3","77":"a x #1 #3","78":"a x #1 #3","79":"a x #1 #3","80":"a x #1 #3","81":"a x #1 #3","83":"a x #1 #3","84":"a x #1 #3","85":"a x #1 #3","86":"a x #1 #3","87":"a x #1 #3","88":"a x #1 #3","89":"a x #1 #3","90":"a x #1 #3"},"safari":{"4":"a x #1 #3","5":"a x #1 #3","6":"a x #1 #3","7":"a x #1 #3","8":"a x #1 #3","9":"a x #1 #3","10":"a x #1 #3","11":"a x #1 #3","12":"a x #1 #3","13":"a x #1 #3","14":"a x #1 #3","3.1":"n","3.2":"n","5.1":"a x #1 #3","6.1":"a x #1 #3","7.1":"a x #1 #3","9.1":"a x #1 #3","10.1":"a x #1 #3","11.1":"a x #1 #3","12.1":"a x #1 #3","13.1":"a x #1 #3","TP":"a x #1 #3"},"opera":{"9":"n","11":"n","12":"n","15":"a x #1 #3","16":"a x #1 #3","17":"a x #1 #3","18":"a x #1 #3","19":"a x #1 #3","20":"a x #1 #3","21":"a x #1 #3","22":"a x #1 #3","23":"a x #1 #3","24":"a x #1 #3","25":"a x #1 #3","26":"a x #1 #3","27":"a x #1 #3","28":"a x #1 #3","29":"a x #1 #3","30":"a x #1 #3","31":"a x #1 #3","32":"a x #1 #3","33":"a x #1 #3","34":"a x #1 #3","35":"a x #1 #3","36":"a x #1 #3","37":"a x #1 #3","38":"a x #1 #3","39":"a x #1 #3","40":"a x #1 #3","41":"a x #1 #3","42":"a x #1 #3","43":"a x #1 #3","44":"a x #1 #3","45":"a x #1 #3","46":"a x #1 #3","47":"a x #1 #3","48":"a x #1 #3","49":"a x #1 #3","50":"a x #1 #3","51":"a x #1 #3","52":"a x #1 #3","53":"a x #1 #3","54":"a x #1 #3","55":"a x #1 #3","56":"a x #1 #3","57":"a x #1 #3","58":"a x #1 #3","60":"a x #1 #3","62":"a x #1 #3","63":"a x #1 #3","64":"a x #1 #3","65":"a x #1 #3","66":"a x #1 #3","67":"a x #1 #3","68":"a x #1 #3","69":"a x #1 #3","70":"a x #1 #3","71":"a x #1 #3","72":"a x #1 #3","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"a x #2 #3"}},"notes":"Though present in early (2002) drafts of CSS3 Fonts, `font-smooth` has been removed from this specification and is currently not on the standard track.","notes_by_num":{"1":"WebKit implements something similar with a different name `-webkit-font-smoothing` and different values: `none`, `antialiased` and `subpixel-antialiased`.","2":"Firefox implements something similar with a different name `-moz-osx-font-smoothing` and different values: `auto`, `inherit`, `unset`, `grayscale`.","3":"Works only on Mac OS X platform."},"usage_perc_y":0,"usage_perc_a":45.68,"ucprefix":false,"parent":"","keywords":"font smooth,font smoothing,-webkit-font-smoothing,-moz-osx-font-smoothing","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"font-unicode-range":{"title":"Font unicode-range subsetting","description":"This @font-face descriptor defines the set of Unicode codepoints that may be supported by the font face for which it is declared. The descriptor value is a comma-delimited list of Unicode range (<urange>) values. The union of these ranges defines the set of codepoints that serves as a hint for user agents when deciding whether or not to download a font resource for a given text run.","spec":"https://drafts.csswg.org/css-fonts/#unicode-range-desc","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/unicode-range","title":"MDN Web Docs - CSS unicode-range"},{"url":"https://developer.apple.com/library/safari/documentation/AppleApplications/Reference/SafariCSSRef/Articles/StandardCSSProperties.html#//apple_ref/css/property/unicode-range","title":"Safari CSS Reference: unicode-range"},{"url":"https://www.webplatform.org/docs/css/properties/unicode-range","title":"Web Platform Docs: unicode-range"},{"url":"http://jsbin.com/jeqoguzeye/1/edit?html,output","title":"Demo"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6510254-unicode-range","title":"Microsoft Edge feature request on UserVoice"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"a","10":"a","11":"a","5.5":"n"},"edge":{"12":"a","13":"a","14":"a","15":"a","16":"a","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n d #1","37":"n d #1","38":"n d #1","39":"n d #1","40":"n d #1","41":"n d #1","42":"n d #1","43":"n d #1","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"a","5":"a","6":"a","7":"a","8":"a","9":"a","10":"a","11":"a","12":"a","13":"a","14":"a","15":"a","16":"a","17":"a","18":"a","19":"a","20":"a","21":"a","22":"a","23":"a","24":"a","25":"a","26":"a","27":"a","28":"a","29":"a","30":"a","31":"a","32":"a","33":"a","34":"a","35":"a","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a","5":"a","6":"a","7":"a","8":"a","9":"a","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a","3.2":"a","5.1":"a","6.1":"a","7.1":"a","9.1":"a","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"a","16":"a","17":"a","18":"a","19":"a","20":"a","21":"a","22":"a","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a","14":"y","3.2":"a","4.0-4.1":"a","4.2-4.3":"a","5.0-5.1":"a","6.0-6.1":"a","7.0-7.1":"a","8.1-8.4":"a","9.0-9.2":"a","9.3":"a","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"a","4":"a","81":"y","2.1":"a","2.2":"a","2.3":"a","4.1":"a","4.2-4.3":"a","4.4":"a","4.4.3-4.4.4":"a"},"bb":{"7":"n","10":"a"},"op_mob":{"10":"n","11":"n","12":"n","59":"a","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a","11":"a"},"and_uc":{"12.12":"y"},"samsung":{"4":"a","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"Partial support indicates that unnecessary code-ranges are downloaded by the browser - see [browser test matrix](https://docs.google.com/a/chromium.org/spreadsheets/d/18h-1gaosu4-KYxH8JUNL6ZDuOsOKmWfauoai3CS3hPY/edit?pli=1#gid=0).","notes_by_num":{"1":"Can be enabled in Firefox using the `layout.css.unicode-range.enabled` flag"},"usage_perc_y":95.65,"usage_perc_a":2.68,"ucprefix":false,"parent":"","keywords":"font face,unicode,unicode-range","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"font-variant-alternates":{"title":"CSS font-variant-alternates","description":"Controls the usage of alternate glyphs associated to alternative names defined in @font-feature-values for certain types of OpenType fonts.","spec":"https://drafts.csswg.org/css-fonts-4/#propdef-font-variant-alternates","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/font-variant-alternates","title":"MDN Web Docs - font-variant-alternates"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n #1","11":"n #1","5.5":"n"},"edge":{"12":"n #1","13":"n #1","14":"n #1","15":"n #1","16":"n #1","17":"n #1","18":"n #1","79":"n #1","80":"n #1","81":"n #1","83":"n #1","84":"n #1","85":"n #1","86":"n #1","87":"n #1"},"firefox":{"2":"n","3":"n","4":"n #1","5":"n #1","6":"n #1","7":"n #1","8":"n #1","9":"n #1","10":"n #1","11":"n #1","12":"n #1","13":"n #1","14":"n #1","15":"n #1","16":"n #1","17":"n #1","18":"n #1","19":"n #1","20":"n #1","21":"n #1","22":"n #1","23":"n #1","24":"n d #2","25":"n d #2","26":"n d #2","27":"n d #2","28":"n d #2","29":"n d #2","30":"n d #2","31":"n d #2","32":"n d #2","33":"n d #2","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n #1","17":"n #1","18":"n #1","19":"n #1","20":"n #1","21":"n #1","22":"n #1","23":"n #1","24":"n #1","25":"n #1","26":"n #1","27":"n #1","28":"n #1","29":"n #1","30":"n #1","31":"n #1","32":"n #1","33":"n #1","34":"n #1","35":"n #1","36":"n #1","37":"n #1","38":"n #1","39":"n #1","40":"n #1","41":"n #1","42":"n #1","43":"n #1","44":"n #1","45":"n #1","46":"n #1","47":"n #1","48":"n #1","49":"n #1","50":"n #1","51":"n #1","52":"n #1","53":"n #1","54":"n #1","55":"n #1","56":"n #1","57":"n #1","58":"n #1","59":"n #1","60":"n #1","61":"n #1","62":"n #1","63":"n #1","64":"n #1","65":"n #1","66":"n #1","67":"n #1","68":"n #1","69":"n #1","70":"n #1","71":"n #1","72":"n #1","73":"n #1","74":"n #1","75":"n #1","76":"n #1","77":"n #1","78":"n #1","79":"n #1","80":"n #1","81":"n #1","83":"n #1","84":"n #1","85":"n #1","86":"n #1","87":"n #1","88":"n #1","89":"n #1","90":"n #1"},"safari":{"4":"n #1","5":"n #1","6":"n #1","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n #1","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n #1","16":"n #1","17":"n #1","18":"n #1","19":"n #1","20":"n #1","21":"n #1","22":"n #1","23":"n #1","24":"n #1","25":"n #1","26":"n #1","27":"n #1","28":"n #1","29":"n #1","30":"n #1","31":"n #1","32":"n #1","33":"n #1","34":"n #1","35":"n #1","36":"n #1","37":"n #1","38":"n #1","39":"n #1","40":"n #1","41":"n #1","42":"n #1","43":"n #1","44":"n #1","45":"n #1","46":"n #1","47":"n #1","48":"n #1","49":"n #1","50":"n #1","51":"n #1","52":"n #1","53":"n #1","54":"n #1","55":"n #1","56":"n #1","57":"n #1","58":"n #1","60":"n #1","62":"n #1","63":"n #1","64":"n #1","65":"n #1","66":"n #1","67":"n #1","68":"n #1","69":"n #1","70":"n #1","71":"n #1","72":"n #1","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n #1","4.2-4.3":"n #1","5.0-5.1":"n #1","6.0-6.1":"n #1","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n #1","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n #1","4.4.3-4.4.4":"n #1"},"bb":{"7":"n","10":"n #1"},"op_mob":{"10":"n","11":"n","12":"n","59":"n #1","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n #1"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n #1"},"samsung":{"4":"n #1","5.0-5.4":"n #1","6.2-6.4":"n #1","7.2-7.4":"n #1","8.2":"n #1","9.2":"n #1","10.1":"n #1","11.1-11.2":"n #1","12.0":"n #1"},"and_qq":{"10.4":"n #1"},"baidu":{"7.12":"n #1"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Low-level syntax available in [font-feature-settings](https://caniuse.com/#feat=font-feature) property equivalent to OpenType features: salt, ss01 through ss20, cv01 through cv99, swsh, cswh, ornm, nalt","2":"Experimental support available by enabling the layout.css.font-features.enabled flag"},"usage_perc_y":20.37,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"font-feature,font-feature-settings,font-variant","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"font-variant-numeric":{"title":"CSS font-variant-numeric","description":"CSS property that provides different ways of displaying numbers, fractions, and ordinal markers.","spec":"https://drafts.csswg.org/css-fonts-3/#propdef-font-variant-numeric","status":"rec","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/font-variant-numeric","title":"MDN Web Docs article"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"u"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":95.25,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"normal,ordinal,slashed-zero,lining-nums,oldstyle-nums,proportional-nums,tabular-nums,diagonal-fractions,stacked-fractions,oldstyle-nums,stacked-fractions","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"fontface":{"title":"@font-face Web fonts","description":"Method of displaying fonts downloaded from websites","spec":"https://www.w3.org/TR/css3-webfonts/","status":"cr","links":[{"url":"https://en.wikipedia.org/wiki/Web_typography","title":"Wikipedia"},{"url":"https://www.webplatform.org/docs/css/atrules/@font-face","title":"WebPlatform Docs"}],"categories":["CSS3"],"stats":{"ie":{"6":"a #1","7":"a #1","8":"a #1","9":"y","10":"y","11":"y","5.5":"a #1"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"a #2","4.0-4.1":"a #2","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"a","4":"y","81":"y","2.1":"n","2.2":"a","2.3":"a","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"a","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Not supported by IE Mobile 9 and below.","notes_by_num":{"1":"Partial support refers to only supporting EOT fonts.","2":"Partial support refers to only supporting SVG fonts."},"usage_perc_y":98.68,"usage_perc_a":0.12,"ucprefix":false,"parent":"","keywords":"font face","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"form-attribute":{"title":"Form attribute","description":"Attribute for associating input and submit buttons with a form.","spec":"https://html.spec.whatwg.org/multipage/forms.html#attr-fae-form","status":"ls","links":[{"url":"https://www.w3.org/TR/html5/forms.html#attr-fae-form","title":"Input attribute specification"},{"url":"http://www.impressivewebs.com/html5-form-attribute/","title":"Article on usage"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/7327649-add-support-for-the-form-attribute","title":"Microsoft Edge feature request on UserVoice"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"u","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":98.12,"usage_perc_a":0,"ucprefix":false,"parent":"forms","keywords":"form,attribute","ie_id":"formattribute","chrome_id":"","firefox_id":"","webkit_id":""},"form-submit-attributes":{"title":"Attributes for form submission","description":"Attributes for form submission that may be specified on submit buttons. The attributes are: `formaction`, `formenctype`, `formmethod`, `formnovalidate`, and `formtarget`","spec":"https://html.spec.whatwg.org/multipage/forms.html#attributes-for-form-submission","status":"ls","links":[{"url":"http://html5doctor.com/html5-forms-introduction-and-new-attributes/#formaction","title":"Article describing each attribute"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"u","10.5":"u","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"u","4":"y","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"u","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":99.25,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"form-validation":{"title":"Form validation","description":"Method of setting required fields and field types without requiring JavaScript. This includes preventing forms from being submitted when appropriate, the `checkValidity()` method as well as support for the `:invalid`, `:valid`, and `:required` CSS pseudo-classes.","spec":"https://html.spec.whatwg.org/multipage/forms.html#client-side-form-validation","status":"ls","links":[{"url":"https://www.webplatform.org/docs/html/attributes/required","title":"WebPlatform Docs"},{"url":"https://webkit.org/blog/7099/html-interactive-form-validation/","title":"WebKit Blog: HTML Interactive Form Validation"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"a #1","6.1":"a #1","7.1":"a #1","9.1":"a #1","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"a #1","14":"y","3.2":"n","4.0-4.1":"a #1","4.2-4.3":"a #1","5.0-5.1":"a #1","6.0-6.1":"a #1","7.0-7.1":"a #1","8.1-8.4":"a #1","9.0-9.2":"a #1","9.3":"a #1","10.0-10.2":"a #1","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"a #3"},"android":{"3":"n","4":"a #1","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"a #1","4.2-4.3":"a #1","4.4":"a #1","4.4.3-4.4.4":"y"},"bb":{"7":"a #1","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #2","11":"a #2"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"a #1"}},"notes":"","notes_by_num":{"1":"Partial support refers to lack of notice when form with required fields is attempted to be submitted.","2":"Partial support in IE10 mobile refers to lack of warning when blocking submission.","3":"Partial support in Opera Mini refers to only supporting the CSS pseudo classes."},"usage_perc_y":97.63,"usage_perc_a":1.68,"ucprefix":false,"parent":"forms","keywords":"","ie_id":"","chrome_id":"6091813840486400","firefox_id":"","webkit_id":"feature-html-interactive-form-validation"},"forms":{"title":"HTML5 form features","description":"Expanded form options, including things like date pickers, sliders, validation, placeholders and multiple file uploads. Previously known as \"Web forms 2.0\".","spec":"https://html.spec.whatwg.org/multipage/forms.html#forms","status":"ls","links":[{"url":"https://miketaylr.com/code/input-type-attr.html","title":"HTML5 inputs and attribute support page"},{"url":"https://github.com/westonruter/webforms2","title":"Cross-browser JS implementation (based on original spec)"}],"categories":["HTML5"],"stats":{"ie":{"6":"p","7":"p","8":"p","9":"p","10":"a","11":"a","5.5":"n"},"edge":{"12":"a","13":"a","14":"a","15":"a","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"p","3":"p","4":"a","5":"a","6":"a","7":"a","8":"a","9":"a","10":"a","11":"a","12":"a","13":"a","14":"a","15":"a","16":"a","17":"a","18":"a","19":"a","20":"a","21":"a","22":"a","23":"a","24":"a","25":"a","26":"a","27":"a","28":"a","29":"a","30":"a","31":"a","32":"a","33":"a","34":"a","35":"a","36":"a","37":"a","38":"a","39":"a","40":"a","41":"a","42":"a","43":"a","44":"a","45":"a","46":"a","47":"a","48":"a","49":"a","50":"a","51":"a","52":"a","53":"a","54":"a","55":"a","56":"a","57":"a","58":"a","59":"a","60":"a","61":"a","62":"a","63":"a","64":"a","65":"a","66":"a","67":"a","68":"a","69":"a","70":"a","71":"a","72":"a","73":"a","74":"a","75":"a","76":"a","77":"a","78":"a","79":"a","80":"a","81":"a","82":"a","83":"a","84":"a","85":"a","3.5":"p","3.6":"p"},"chrome":{"4":"a","5":"a","6":"a","7":"a","8":"a","9":"a","10":"a","11":"a","12":"a","13":"a","14":"a","15":"a","16":"a","17":"a","18":"a","19":"a","20":"a","21":"a","22":"a","23":"a","24":"a","25":"a","26":"a","27":"a","28":"a","29":"a","30":"a","31":"a","32":"a","33":"a","34":"a","35":"a","36":"a","37":"a","38":"a","39":"a","40":"a","41":"a","42":"a","43":"a","44":"a","45":"a","46":"a","47":"a","48":"a","49":"a","50":"a","51":"a","52":"a","53":"a","54":"a","55":"a","56":"a","57":"a","58":"a","59":"a","60":"a","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a","5":"a","6":"a","7":"a","8":"a","9":"a","10":"a","11":"a","12":"a","13":"a","14":"a","3.1":"p","3.2":"p","5.1":"a","6.1":"a","7.1":"a","9.1":"a","10.1":"a","11.1":"a","12.1":"a","13.1":"a","TP":"a"},"opera":{"9":"y","11":"y","12":"y","15":"a","16":"a","17":"a","18":"a","19":"a","20":"a","21":"a","22":"a","23":"a","24":"a","25":"a","26":"a","27":"a","28":"a","29":"a","30":"a","31":"a","32":"a","33":"a","34":"a","35":"a","36":"a","37":"a","38":"a","39":"a","40":"a","41":"a","42":"a","43":"a","44":"a","45":"a","46":"a","47":"a","48":"a","49":"a","50":"a","51":"a","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"a","14":"a","3.2":"n","4.0-4.1":"a","4.2-4.3":"a","5.0-5.1":"a","6.0-6.1":"a","7.0-7.1":"a","8.1-8.4":"a","9.0-9.2":"a","9.3":"a","10.0-10.2":"a","10.3":"a","11.0-11.2":"a","11.3-11.4":"a","12.0-12.1":"a","12.2-12.4":"a","13.0-13.1":"a","13.2":"a","13.3":"a","13.4-13.7":"a"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"a","4.4.3-4.4.4":"a"},"bb":{"7":"n","10":"a"},"op_mob":{"10":"y","11":"y","12":"y","59":"a","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"a"},"ie_mob":{"10":"a","11":"a"},"and_uc":{"12.12":"y"},"samsung":{"4":"a","5.0-5.4":"a","6.2-6.4":"a","7.2-7.4":"a","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"a"},"kaios":{"2.5":"a"}},"notes":"","notes_by_num":{},"usage_perc_y":75.01,"usage_perc_a":23.41,"ucprefix":false,"parent":"","keywords":"input,datepicker","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"fullscreen":{"title":"Full Screen API","description":"API for allowing content (like a video or canvas element) to take up the entire screen.","spec":"https://fullscreen.spec.whatwg.org/","status":"ls","links":[{"url":"https://developer.mozilla.org/en/DOM/Using_full-screen_mode","title":"MDN Web Docs - Using Full Screen"},{"url":"http://jlongster.com/2011/11/21/canvas.html","title":"Blog post"},{"url":"https://hacks.mozilla.org/2012/01/using-the-fullscreen-api-in-web-browsers/","title":"Mozilla hacks article"},{"url":"https://www.webplatform.org/docs/dom/Element/requestFullscreen","title":"WebPlatform Docs"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"a x #3","5.5":"n"},"edge":{"12":"a #3","13":"a #3","14":"a #3","15":"a #3","16":"a #3","17":"a #3","18":"a #3","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"a x #1 #3","11":"a x #1 #3","12":"a x #1 #3","13":"a x #1 #3","14":"a x #1 #3","15":"a x #1 #3","16":"a x #1 #3","17":"a x #1 #3","18":"a x #1 #3","19":"a x #1 #3","20":"a x #1 #3","21":"a x #1 #3","22":"a x #1 #3","23":"a x #1 #3","24":"a x #1 #3","25":"a x #1 #3","26":"a x #1 #3","27":"a x #1 #3","28":"a x #1 #3","29":"a x #1 #3","30":"a x #1 #3","31":"a x #1 #3","32":"a x #1 #3","33":"a x #1 #3","34":"a x #1 #3","35":"a x #1 #3","36":"a x #1 #3","37":"a x #1 #3","38":"a x #1 #3","39":"a x #1 #3","40":"a x #1 #3","41":"a x #1 #3","42":"a x #1 #3","43":"a x #1 #3","44":"a x #1 #3","45":"a x #1 #3","46":"a x #1 #3","47":"a x #1 #3 #4","48":"a x #1 #3 #4","49":"a x #1 #3 #4","50":"a x #1 #3 #4","51":"a x #1 #3 #4","52":"a x #1 #3 #4","53":"a x #1 #3 #4","54":"a x #1 #3 #4","55":"a x #1 #3 #4","56":"a x #1 #3 #4","57":"a x #1 #3 #4","58":"a x #1 #3 #4","59":"a x #1 #3 #4","60":"a x #1 #3 #4","61":"a x #1 #3 #4","62":"a x #1 #3 #4","63":"a x #1 #3 #4","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"a x #1 #3","16":"a x #1 #3","17":"a x #1 #3","18":"a x #1 #3","19":"a x #1 #3","20":"a x #2 #3","21":"a x #2 #3","22":"a x #2 #3","23":"a x #2 #3","24":"a x #2 #3","25":"a x #2 #3","26":"a x #2 #3","27":"a x #2 #3","28":"a x #2 #3","29":"a x #2 #3","30":"a x #2 #3","31":"a x #2 #3","32":"a x #2 #3","33":"a x #2 #3","34":"a x #2 #3","35":"a x #2 #3","36":"a x #2 #3","37":"a x #2 #3","38":"a x #2 #3","39":"a x #2 #3","40":"a x #2 #3","41":"a x #2 #3","42":"a x #2 #3","43":"a x #2 #3","44":"a x #2 #3","45":"a x #2 #3","46":"a x #2 #3","47":"a x #2 #3","48":"a x #2 #3","49":"a x #2 #3","50":"a x #2 #3","51":"a x #2 #3","52":"a x #2 #3","53":"a x #2 #3","54":"a x #2 #3","55":"a x #2 #3","56":"a x #2 #3","57":"a x #2 #3","58":"a x #2 #3","59":"a x #2 #3","60":"a x #2 #3","61":"a x #2 #3","62":"a x #2 #3","63":"a x #2 #3","64":"a x #2 #3","65":"a x #2 #3","66":"a x #2 #3","67":"a x #2 #3","68":"a x #2 #3","69":"a x #2 #3","70":"a x #2 #3","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"a x #2 #3","7":"a x #2 #3","8":"a x #2 #3","9":"a x #2 #3","10":"a x #2 #3","11":"a x #2 #3","12":"a x #2 #3","13":"a x #2 #3","14":"a x #2 #3","3.1":"n","3.2":"n","5.1":"a x #1 #3","6.1":"a x #2 #3","7.1":"a x #2 #3","9.1":"a x #2 #3","10.1":"a x #2 #3","11.1":"a x #2 #3","12.1":"a x #2 #3","13.1":"a x #2 #3","TP":"a x #2 #3"},"opera":{"9":"n","11":"n","12":"n","15":"a x #2 #3","16":"a x #2 #3","17":"a x #2 #3","18":"a x #2 #3","19":"a x #2 #3","20":"a x #2 #3","21":"a x #2 #3","22":"a x #2 #3","23":"a x #2 #3","24":"a x #2 #3","25":"a x #2 #3","26":"a x #2 #3","27":"a x #2 #3","28":"a x #2 #3","29":"a x #2 #3","30":"a x #2 #3","31":"a x #2 #3","32":"a x #2 #3","33":"a x #2 #3","34":"a x #2 #3","35":"a x #2 #3","36":"a x #2 #3","37":"a x #2 #3","38":"a x #2 #3","39":"a x #2 #3","40":"a x #2 #3","41":"a x #2 #3","42":"a x #2 #3","43":"a x #2 #3","44":"a x #2 #3","45":"a x #2 #3","46":"a x #2 #3","47":"a x #2 #3","48":"a x #2 #3","49":"a x #2 #3","50":"a x #2 #3","51":"a x #2 #3","52":"a x #2 #3","53":"a x #2 #3","54":"a x #2 #3","55":"a x #2 #3","56":"a x #2 #3","57":"a x #2 #3","58":"a x #2 #3","60":"a x #2 #3","62":"a x #2 #3","63":"a x #2 #3","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"y"},"ios_saf":{"8":"n","14":"a #5","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"a #5","12.2-12.4":"a #5","13.0-13.1":"a #5","13.2":"a #5","13.3":"a #5","13.4-13.7":"a #5"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"a x #2"},"op_mob":{"10":"n","11":"n","12":"n","59":"a x #2 #3","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a x #2 #3"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"a x #3"},"and_uc":{"12.12":"a x #2 #3"},"samsung":{"4":"a x #2 #3","5.0-5.4":"a x #2 #3","6.2-6.4":"a x #2 #3","7.2-7.4":"a x #2 #3","8.2":"a x #2 #3","9.2":"a x #2 #3","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"a x #2 #3"},"baidu":{"7.12":"a x #2 #3"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support refers to supporting an earlier draft of the spec.","2":"Partial support refers to not supporting `::backdrop`, and supporting the old `:full-screen` syntax rather than the standard `:fullscreen`.","3":"Partial support refers to not returning a Promise, as specified in the latest version of the spec.","4":"Unprefixed support is available behind the `full-screen-api.unprefix.enabled` flag","5":"Partial support refers to supporting only iPad, not iPhone. Shows an overlay button which can not be disabled."},"usage_perc_y":42.67,"usage_perc_a":54.42,"ucprefix":false,"parent":"","keywords":"full-screen,requestFullScreen,exitFullScreen","ie_id":"fullscreenapi","chrome_id":"5259513871466496","firefox_id":"fullscreen","webkit_id":""},"gamepad":{"title":"Gamepad API","description":"API to support input from USB gamepad controllers through JavaScript.","spec":"https://www.w3.org/TR/gamepad/","status":"wd","links":[{"url":"http://luser.github.io/gamepadtest/","title":"Controller demo"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Gamepad_API","title":"MDN Web Docs - Gamepad"},{"url":"https://www.html5rocks.com/en/tutorials/doodles/gamepad/","title":"HTML5Rocks article"},{"url":"https://gamedevelopment.tutsplus.com/tutorials/using-the-html5-gamepad-api-to-add-controller-support-to-browser-games--cms-21345","title":"Detailed tutorial"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"y x","22":"y x","23":"y x","24":"y x","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Can be enabled via the \"Experimental Features\" developer menu"},"usage_perc_y":96.07,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"gamepadapi","chrome_id":"5118776383111168","firefox_id":"gamepad","webkit_id":""},"geolocation":{"title":"Geolocation","description":"Method of informing a website of the user's geographical location","spec":"https://www.w3.org/TR/geolocation-API/","status":"rec","links":[{"url":"http://html5demos.com/geo","title":"Simple demo"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/features.js#native-geolocation","title":"has.js test"},{"url":"https://www.webplatform.org/docs/apis/geolocation","title":"WebPlatform Docs"}],"categories":["JS API"],"stats":{"ie":{"6":"p","7":"p","8":"p","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y #1","80":"y #1","81":"y #1","83":"y #1","84":"y #1","85":"y #1","86":"y #1","87":"y #1"},"firefox":{"2":"p","3":"p","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y #1","56":"y #1","57":"y #1","58":"y #1","59":"y #1","60":"y #1","61":"y #1","62":"y #1","63":"y #1","64":"y #1","65":"y #1","66":"y #1","67":"y #1","68":"y #1","69":"y #1","70":"y #1","71":"y #1","72":"y #1","73":"y #1","74":"y #1","75":"y #1","76":"y #1","77":"y #1","78":"y #1","79":"y #1","80":"y #1","81":"y #1","82":"y #1","83":"y #1","84":"y #1","85":"y #1","3.5":"y","3.6":"y"},"chrome":{"4":"a","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y #1","51":"y #1","52":"y #1","53":"y #1","54":"y #1","55":"y #1","56":"y #1","57":"y #1","58":"y #1","59":"y #1","60":"y #1","61":"y #1","62":"y #1","63":"y #1","64":"y #1","65":"y #1","66":"y #1","67":"y #1","68":"y #1","69":"y #1","70":"y #1","71":"y #1","72":"y #1","73":"y #1","74":"y #1","75":"y #1","76":"y #1","77":"y #1","78":"y #1","79":"y #1","80":"y #1","81":"y #1","83":"y #1","84":"y #1","85":"y #1","86":"y #1","87":"y #1","88":"y #1","89":"y #1","90":"y #1"},"safari":{"4":"p","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y #1","11":"y","12":"y","13":"y","14":"y","3.1":"p","3.2":"p","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"n","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y #1","40":"y #1","41":"y #1","42":"y #1","43":"y #1","44":"y #1","45":"y #1","46":"y #1","47":"y #1","48":"y #1","49":"y #1","50":"y #1","51":"y #1","52":"y #1","53":"y #1","54":"y #1","55":"y #1","56":"y #1","57":"y #1","58":"y #1","60":"y #1","62":"y #1","63":"y #1","64":"y #1","65":"y #1","66":"y #1","67":"y #1","68":"y #1","69":"y #1","70":"y #1","71":"y #1","72":"y #1","9.5-9.6":"n","10.0-10.1":"p","10.5":"p","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y #1","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y #1","10.3":"y #1","11.0-11.2":"y #1","11.3-11.4":"y #1","12.0-12.1":"y #1","12.2-12.4":"y #1","13.0-13.1":"y #1","13.2":"y #1","13.3":"y #1","13.4-13.7":"y #1"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y #1","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"p","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y #1"},"and_ff":{"82":"y #1"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y #1","6.2-6.4":"y #1","7.2-7.4":"y #1","8.2":"y #1","9.2":"y #1","10.1":"y #1","11.1-11.2":"y #1","12.0":"y #1"},"and_qq":{"10.4":"y #1"},"baidu":{"7.12":"y #1"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Only works on secure (https) servers"},"usage_perc_y":98.68,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"geolocation","chrome_id":"6348855016685568","firefox_id":"","webkit_id":""},"getboundingclientrect":{"title":"Element.getBoundingClientRect()","description":"Method to get the size and position of an element's bounding box, relative to the viewport.","spec":"https://www.w3.org/TR/cssom-view/#dom-element-getboundingclientrect","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect","title":"MDN Web Docs - getBoundingClientRect"},{"url":"https://msdn.microsoft.com/en-us/library/ms536433(VS.85).aspx","title":"Microsoft Developer Network"}],"categories":["JS API"],"stats":{"ie":{"6":"a #1 #3","7":"a #1 #3","8":"a #1 #3 #5","9":"y #5","10":"y #5","11":"y #5","5.5":"a #1 #3"},"edge":{"12":"y #5","13":"y #5","14":"y #5","15":"y #5","16":"y #5","17":"y #5","18":"y #5","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"a #1 #4","4":"a #2","5":"a #2","6":"a #2","7":"a #2","8":"a #2","9":"a #2","10":"a #2","11":"a #2","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a #2 #4","3.6":"a #2 #3 #4"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"u","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"u","10.0-10.1":"a #1","10.5":"a #1","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"u","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"u","2.2":"u","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"a #1","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y #5","11":"y #5"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"The returned object lacks `width` and `height` properties.","2":"Returns incorrect values for elements which have had CSS `transform`s applied to them.","3":"The returned object cannot have new properties added to it; it's not extensible.","4":"Existing properties of the returned object are immutable.","5":"The returned object lacks `x` & `y` values, though existing `top` & `left` values can be used instead."},"usage_perc_y":99.47,"usage_perc_a":0.18,"ucprefix":false,"parent":"","keywords":"getBoundingClientRect,bounding,client,rect,DOMRect,box,cssom","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"getcomputedstyle":{"title":"getComputedStyle","description":"API to get the current computed CSS styles applied to an element. This may be the current value applied by an animation or as set by a stylesheet.","spec":"https://www.w3.org/TR/cssom/#dom-window-getcomputedstyle","status":"rec","links":[{"url":"https://developer.mozilla.org/en/DOM/window.getComputedStyle","title":"MDN Web Docs - getComputedStyle"},{"url":"https://testdrive-archive.azurewebsites.net/HTML5/getComputedStyle/","title":"Demo"},{"url":"http://snipplr.com/view/13523/","title":"Polyfill for IE"},{"url":"https://www.webplatform.org/docs/css/cssom/methods/getComputedStyle","title":"WebPlatform Docs"}],"categories":["CSS3","DOM","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"a #1","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a #1","3.6":"a #1"},"chrome":{"4":"a #2","5":"a #2","6":"a #2","7":"a #2","8":"a #2","9":"a #2","10":"a #2","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a #2","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a #2","3.2":"a #2","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"a #2","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"a #2","10.0-10.1":"a #2","10.5":"a #2","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"a #2","4.0-4.1":"a #2","4.2-4.3":"a #2","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"a #2"},"android":{"3":"a #2","4":"y","81":"y","2.1":"a #2","2.2":"a #2","2.3":"a #2","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"a #2","10":"y"},"op_mob":{"10":"a #2","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support refers to requiring the second parameter to be included.","2":"Partial support refers to not supporting getComputedStyle on pseudo-elements."},"usage_perc_y":98.61,"usage_perc_a":0.99,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"getelementsbyclassname":{"title":"getElementsByClassName","description":"Method of accessing DOM elements by class name","spec":"https://dom.spec.whatwg.org/#dom-document-getelementsbyclassname","status":"ls","links":[{"url":"https://www.quirksmode.org/dom/tests/basics.html#getElementsByClassName","title":"Test page"},{"url":"https://www.webplatform.org/docs/dom/HTMLElement/getElementsByClassName","title":"WebPlatform Docs"}],"categories":["DOM","HTML5"],"stats":{"ie":{"6":"p","7":"p","8":"p","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"p","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":99.59,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"byclassname","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"getrandomvalues":{"title":"crypto.getRandomValues()","description":"Method of generating cryptographically random values.","spec":"https://www.w3.org/TR/WebCryptoAPI/#Crypto-method-getRandomValues","status":"rec","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues","title":"MDN Web Docs - crypto.getRandomValues"}],"categories":["JS API","Security"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"y x","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"y x"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":97.99,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"gyroscope":{"title":"Gyroscope","description":"Defines a concrete sensor interface to monitor the rate of rotation around the device’s local three primary axes.","spec":"https://www.w3.org/TR/gyroscope/","status":"cr","links":[{"url":"https://intel.github.io/generic-sensor-demos/","title":"Demo"},{"url":"https://developers.google.com/web/updates/2017/09/sensors-for-the-web#gyroscope-sensor","title":"Article"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n d #1","59":"n d #1","60":"n d #1","61":"n d #1","62":"n d #1","63":"n d #1","64":"n d #1","65":"n d #1","66":"n d #1","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Available by enabling the \"Generic Sensor\" experimental flag in `about:flags`"},"usage_perc_y":69.97,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"5698781827825664","firefox_id":"","webkit_id":""},"hardwareconcurrency":{"title":"navigator.hardwareConcurrency","description":"Returns the number of logical cores of the user's CPU. The value may be reduced to prevent device fingerprinting or because it exceeds the allowed number of simultaneous web workers.","spec":"https://html.spec.whatwg.org/multipage/workers.html#navigator.hardwareconcurrency","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/NavigatorConcurrentHardware/hardwareConcurrency","title":"MDN Web Docs - navigator.hardwareConcurrency"},{"url":"https://wiki.whatwg.org/wiki/Navigator_HW_Concurrency","title":"Original Proposal"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=132588","title":"WebKit implementation bug"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n d #1","9":"n d #1","10":"n d #1","11":"y #1","12":"y #1","13":"y #1","14":"y #1","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n d #1","10.1":"y #1","11.1":"y #1","12.1":"y #1","13.1":"y #1","TP":"y #1"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n d #1","14":"y #1","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n d #1","9.0-9.2":"n d #1","9.3":"n d #1","10.0-10.2":"n d #1","10.3":"y #1","11.0-11.2":"y #1","11.3-11.4":"y #1","12.0-12.1":"y #1","12.2-12.4":"y #1","13.0-13.1":"y #1","13.2":"y #1","13.3":"y #1","13.4-13.7":"y #1"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"WebKit browsers clamp the maximum value returned to 2 on iOS devices and 8 on all others. Disabled in Safari behind the ENABLE_NAVIGATOR_HWCONCURRENCY build option."},"usage_perc_y":95.84,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"navigator,cores,hardware,concurrency,hardwareConcurrency","ie_id":"hardwareconcurrency","chrome_id":"6248386202173440","firefox_id":"","webkit_id":""},"hashchange":{"title":"Hashchange event","description":"Event triggered in JavaScript when the URL's hash has changed (for example: page.html#foo to page.html#bar) ","spec":"https://html.spec.whatwg.org/multipage/browsers.html#the-hashchangeevent-interface","status":"ls","links":[{"url":"https://developer.mozilla.org/en/DOM/window.onhashchange","title":"MDN Web Docs - onhashchange"},{"url":"http://msdn.microsoft.com/en-us/library/cc288209(VS.85).aspx","title":"MSDN article"},{"url":"https://www.quirksmode.org/dom/events/tests/hashchange.html","title":"Simple demo"},{"url":"https://github.com/3nr1c/jUri.js","title":"Polyfill"},{"url":"https://www.webplatform.org/docs/dom/Element/hashchange","title":"WebPlatform Docs"}],"categories":["HTML5","JS API"],"stats":{"ie":{"6":"p","7":"p","8":"y","9":"y","10":"y","11":"y","5.5":"p"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"p","3":"p","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"p","3.6":"y"},"chrome":{"4":"p","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"p","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"p","3.2":"p","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"p","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"p","10.0-10.1":"p","10.5":"p","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"n","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"p","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":98.73,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"onhashchange,HashChangeEvent","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"heif":{"title":"HEIF/ISO Base Media File Format","description":"HEIF (High Efficiency Image File Format) is a standard developed by the Moving Picture Experts Group (MPEG) for storage and sharing of images and image sequences. Can use `.heif` or `.heic` file extensions.","spec":"https://nokiatech.github.io/heif/technical.html","status":"other","links":[{"url":"https://en.wikipedia.org/wiki/High_Efficiency_Image_File_Format","title":"Wikipedia article"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n #1","12":"n #1","13":"n #1","14":"n #1","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n #1","12.1":"n #1","13.1":"n #1","TP":"n #1"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n #1","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n #1","11.3-11.4":"n #1","12.0-12.1":"n #1","12.2-12.4":"n #1","13.0-13.1":"n #1","13.2":"n #1","13.3":"n #1","13.4-13.7":"n #1"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"While supported natively in macOS High Sierra and iOS 11, the file format does not appear to be supported in Safari."},"usage_perc_y":0,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"heic","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"hevc":{"title":"HEVC/H.265 video format","description":"The High Efficiency Video Coding (HEVC) compression standard is a video compression format intended to succeed H.264","spec":"https://www.itu.int/rec/T-REC-H.265","status":"other","links":[{"url":"https://bugzilla.mozilla.org/show_bug.cgi?format=default&id=1332136","title":"Firefox support bug (WONTFIX)"},{"url":"https://en.wikipedia.org/wiki/High_Efficiency_Video_Coding","title":"Wikipedia article"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/10311075-hevc-support","title":"UserVoice support request for Edge"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=684382","title":"Chrome support bug (WontFix)"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"a #1","5.5":"n"},"edge":{"12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"a #3","12":"a #3","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"a #3","12.1":"a #3","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n #2","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n #2"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n #2","6.2-6.4":"n #2","7.2-7.4":"n #2","8.2":"n #2","9.2":"n #2","10.1":"n #2","11.1-11.2":"n #2","12.0":"n #2"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Supported only for devices with [hardware support](https://answers.microsoft.com/en-us/insider/forum/insider_apps-insider_wmp/windows-10-hevc-playback-yes-or-no/3c1ab780-a6b2-4b77-ac0f-9faeefd4680d)","2":"Reported to work in certain Android devices with hardware support","3":"Supported only on macOS High Sierra or later"},"usage_perc_y":15.32,"usage_perc_a":1.82,"ucprefix":false,"parent":"video","keywords":"h265","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"hidden":{"title":"hidden attribute","description":"The `hidden` attribute may be applied to any element, and effectively hides elements similar to `display: none` in CSS.","spec":"https://html.spec.whatwg.org/multipage/interaction.html#the-hidden-attribute","status":"ls","links":[{"url":"https://davidwalsh.name/html5-hidden","title":"Article on hidden attribute"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"n","4":"y","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"The hidden state can be easily overridden with a CSS `display` property set to anything other than `none`.","notes_by_num":{},"usage_perc_y":99.25,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"high-resolution-time":{"title":"High Resolution Time API","description":"Method to provide the current time in sub-millisecond resolution and such that it is not subject to system clock skew or adjustments. Called using `performance.now()`","spec":"https://www.w3.org/TR/hr-time/","status":"rec","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Performance.now()","title":"MDN Web Docs - Performance.now"},{"url":"http://updates.html5rocks.com/2012/08/When-milliseconds-are-not-enough-performance-now","title":"HTML5Rocks article"},{"url":"https://www.sitepoint.com/discovering-the-high-resolution-time-api/","title":"SitePoint article"},{"url":"http://aurelio.audero.it/demo/high-resolution-time-api-demo.html","title":"Demo"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"y x","21":"y x","22":"y x","23":"y x","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"The timestamp is not actually high-resolution. To mitigate security threats such as Spectre, browsers currently round the result to varying degrees.","notes_by_num":{"1":"In Firefox, the \"privacy.reduceTimerPrecision\" preference is enabled by default and defaults to 20us in Firefox 59; in 60 it will be 2ms.","2":"In Firefox, the \"privacy.resistFingerprinting\" preference changes the precision to 100ms or the value of \"privacy.resistFingerprinting.reduceTimerPrecision.microseconds\", whichever is larger."},"usage_perc_y":97.92,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"performance,now,testing","ie_id":"highresolutiontime","chrome_id":"5349124069130240","firefox_id":"","webkit_id":""},"history":{"title":"Session history management","description":"Method of manipulating the user's browser's session history in JavaScript using `history.pushState`, `history.replaceState` and the `popstate` event.","spec":"https://html.spec.whatwg.org/multipage/browsers.html#dom-history-pushstate","status":"ls","links":[{"url":"http://www.adequatelygood.com/2010/7/Saner-HTML5-History-Management","title":"Introduction to history management"},{"url":"https://developer.mozilla.org/en/DOM/Manipulating_the_browser_history","title":"MDN Web Docs - Manipulating the browser history"},{"url":"http://html5demos.com/history","title":"Demo page"},{"url":"https://github.com/browserstate/history.js","title":"History.js polyfill"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/features.js#native-history-state","title":"has.js test"},{"url":"https://www.webplatform.org/docs/dom/History","title":"WebPlatform Docs"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"a","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"a","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"a","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"y","2.3":"y","4.1":"n","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"n","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Older iOS versions and Android 4.0.4 claim support, but implementation is too buggy to be useful.","notes_by_num":{},"usage_perc_y":98.21,"usage_perc_a":0.14,"ucprefix":false,"parent":"","keywords":"onpushstate,onreplacestate","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"html-media-capture":{"title":"HTML Media Capture","description":"Facilitates user access to a device's media capture mechanism, such as a camera, or microphone, from within a file upload control.","spec":"https://w3c.github.io/html-media-capture/","status":"cr","links":[{"url":"https://addpipe.com/blog/correct-syntax-html-media-capture/","title":"Correct Syntax for HTML Media Capture"},{"url":"https://books.google.com.au/books?id=gswdarRZVUoC&pg=PA263&dq=%22file+upload+compatibility+table%22","title":"Programming the Mobile Web: File upload compatibility table"},{"url":"https://addpipe.com/html-media-capture-demo/","title":"HTML Media Capture Test Bench"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y #1","14":"y #1","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"y #1","7.0-7.1":"y #1","8.1-8.4":"y #1","9.0-9.2":"y #1","9.3":"y #1","10.0-10.2":"y #1","10.3":"y #1","11.0-11.2":"y #1","11.3-11.4":"y #1","12.0-12.1":"y #1","12.2-12.4":"y #1","13.0-13.1":"y #1","13.2":"y #1","13.3":"y #1","13.4-13.7":"y #1"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"n","2.2":"y #2","2.3":"y #2","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"u","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"a #3"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"u"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"iOS6-10 do not support the capture attribute used to force capture straight from the device's camera or microphone. Also note that default video dimensions are 480x320 (4:3).","2":"Android 2.2-2.3 do not support the capture attribute","3":"Supports a \"capture\" button for any `<input type=\"file\"> field, regardless of the whether the capture attribute is used."},"usage_perc_y":49.37,"usage_perc_a":1.21,"ucprefix":false,"parent":"","keywords":"htmlmediacapture, html media capture, media capture, mediacapture","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"html5semantic":{"title":"HTML5 semantic elements","description":"HTML5 offers some new elements, primarily for semantic purposes. The elements include: `section`, `article`, `aside`, `header`, `footer`, `nav`, `figure`, `figcaption`, `time`, `mark` & `main`.","spec":"https://html.spec.whatwg.org/multipage/semantics.html#sections","status":"ls","links":[{"url":"https://blog.whatwg.org/supporting-new-elements-in-ie","title":"Workaround for IE"},{"url":"https://blog.whatwg.org/styling-ie-noscript","title":"Alternate workaround"},{"url":"http://oli.jp/2009/html5-structure3/","title":"Article on structural elements"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/dom.js#dom-html5-elements","title":"has.js test"},{"url":"https://www.chromestatus.com/feature/5633937149788160","title":"Chrome Platform Status: `<time>` element"}],"categories":["HTML5"],"stats":{"ie":{"6":"p","7":"p","8":"p","9":"a #2","10":"a #2","11":"a #2","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"a #1","4":"a #2","5":"a #2","6":"a #2","7":"a #2","8":"a #2","9":"a #2","10":"a #2","11":"a #2","12":"a #2","13":"a #2","14":"a #2","15":"a #2","16":"a #2","17":"a #2","18":"a #2","19":"a #2","20":"a #2","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a #1","3.6":"a #1"},"chrome":{"4":"a #1","5":"a #1","6":"a #2","7":"a #2","8":"a #2","9":"a #2","10":"a #2","11":"a #2","12":"a #2","13":"a #2","14":"a #2","15":"a #2","16":"a #2","17":"a #2","18":"a #2","19":"a #2","20":"a #2","21":"a #2","22":"a #2","23":"a #2","24":"a #2","25":"a #2","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a #1","5":"a #2","6":"a #2","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a #1","3.2":"a #1","5.1":"a #2","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"a #1","11":"a #1","12":"a #2","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"a #1","10.0-10.1":"a #1","10.5":"a #1","10.6":"a #1","11.1":"a #2","11.5":"a #2","11.6":"a #2","12.1":"a #2"},"ios_saf":{"8":"y","14":"y","3.2":"a #1","4.0-4.1":"a #2","4.2-4.3":"a #2","5.0-5.1":"a #2","6.0-6.1":"a #2","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"a #1"},"android":{"3":"a #2","4":"a #2","81":"y","2.1":"a #1","2.2":"a #2","2.3":"a #2","4.1":"a #2","4.2-4.3":"a #2","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"a #2","10":"a #2"},"op_mob":{"10":"a #1","11":"a #2","12":"a #2","59":"y","11.1":"a #2","11.5":"a #2","12.1":"a #2"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #2","11":"a #2"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support refers to missing the default styling, as technically the elements are considered \"[unknown](https://developer.mozilla.org/en-US/docs/Web/API/HTMLUnknownElement)\". This is easily taken care of by manually setting the default `display` value for each tag.","2":"Partial support refers to only the `<main>` element (added later to the spec) being \"unknown\", though it can still be used and styled."},"usage_perc_y":96.78,"usage_perc_a":2.82,"ucprefix":false,"parent":"","keywords":"section,article,aside,header,footer,nav,figure,figcaption,time,mark,main,<section>,<article>,<aside>,<header>,<footer>,<nav>,<figure>,<figcaption>,<time>,<mark>,<main>","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"http-live-streaming":{"title":"HTTP Live Streaming (HLS)","description":"HTTP-based media streaming communications protocol","spec":"https://tools.ietf.org/html/rfc8216","status":"unoff","links":[{"url":"https://en.wikipedia.org/wiki/HTTP_Live_Streaming","title":"Wikipedia article"},{"url":"https://developer.apple.com/streaming/","title":"Apple developer article"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":55.38,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"apple http live streaming,m3u8","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"http2":{"title":"HTTP/2 protocol","description":"Networking protocol for low-latency transport of content over the web. Originally started out from the SPDY protocol, now standardized as HTTP version 2.","spec":"https://tools.ietf.org/html/rfc7540","status":"other","links":[{"url":"https://en.wikipedia.org/wiki/HTTP/2","title":"Wikipedia article about HTTP/2"},{"url":"https://http2.akamai.com/demo","title":"Browser support test"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"a #1","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y #3","80":"y #3","81":"y #3","83":"y #3","84":"y #3","85":"y #3","86":"y #3","87":"y #3"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y #3","54":"y #3","55":"y #3","56":"y #3","57":"y #3","58":"y #3","59":"y #3","60":"y #3","61":"y #3","62":"y #3","63":"y #3","64":"y #3","65":"y #3","66":"y #3","67":"y #3","68":"y #3","69":"y #3","70":"y #3","71":"y #3","72":"y #3","73":"y #3","74":"y #3","75":"y #3","76":"y #3","77":"y #3","78":"y #3","79":"y #3","80":"y #3","81":"y #3","82":"y #3","83":"y #3","84":"y #3","85":"y #3","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y #3","52":"y #3","53":"y #3","54":"y #3","55":"y #3","56":"y #3","57":"y #3","58":"y #3","59":"y #3","60":"y #3","61":"y #3","62":"y #3","63":"y #3","64":"y #3","65":"y #3","66":"y #3","67":"y #3","68":"y #3","69":"y #3","70":"y #3","71":"y #3","72":"y #3","73":"y #3","74":"y #3","75":"y #3","76":"y #3","77":"y #3","78":"y #3","79":"y #3","80":"y #3","81":"y #3","83":"y #3","84":"y #3","85":"y #3","86":"y #3","87":"y #3","88":"y #3","89":"y #3","90":"y #3"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"a #2","10":"a #2","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"a #2","10.1":"a #2","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y #3","39":"y #3","40":"y #3","41":"y #3","42":"y #3","43":"y #3","44":"y #3","45":"y #3","46":"y #3","47":"y #3","48":"y #3","49":"y #3","50":"y #3","51":"y #3","52":"y #3","53":"y #3","54":"y #3","55":"y #3","56":"y #3","57":"y #3","58":"y #3","60":"y #3","62":"y #3","63":"y #3","64":"y #3","65":"y #3","66":"y #3","67":"y #3","68":"y #3","69":"y #3","70":"y #3","71":"y #3","72":"y #3","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y #3","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y #3"},"and_ff":{"82":"y #3"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y #3","6.2-6.4":"y #3","7.2-7.4":"y #3","8.2":"y #3","9.2":"y #3","10.1":"y #3","11.1-11.2":"y #3","12.0":"y #3"},"and_qq":{"10.4":"y #3"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"HTTP/2 is only supported over TLS (HTTPS). See also the precursor of HTTP/2, [the SPDY protocol](https://caniuse.com/#feat=spdy), which has been deprecated and removed from most browsers, in favor of HTTP/2.","notes_by_num":{"1":"Partial support in Internet Explorer refers to being limited to Windows 10.","2":"Partial support in Safari refers to being limited to OS X 10.11 El Capitan and newer.","3":"Only supports HTTP/2 if the server supports protocol negotiation via ALPN."},"usage_perc_y":96.25,"usage_perc_a":1.16,"ucprefix":false,"parent":"","keywords":"https/2","ie_id":"http2","chrome_id":"5152586365665280","firefox_id":"http2","webkit_id":""},"http3":{"title":"HTTP/3 protocol","description":"Upcoming version of the HTTP networking protocol, which is currently a draft. Previously known as HTTP-over-QUIC. Uses QUIC as its transport layer protocol.","spec":"https://tools.ietf.org/html/draft-ietf-quic-http-23","status":"other","links":[{"url":"https://en.wikipedia.org/wiki/HTTP/3","title":"Wikipedia article about HTTP/3"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n d #1","73":"n d #1","74":"n d #1","75":"n d #1","76":"n d #1","77":"n d #1","78":"n d #1","79":"n d #1","80":"n d #1","81":"n d #1","82":"n d #1","83":"n d #1","84":"n d #1","85":"n d #1","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n d #2","80":"n d #2","81":"n d #2","83":"n d #2","84":"n d #2","85":"n d #2","86":"n d #2","87":"n d #2","88":"n d #2","89":"n d #2","90":"n d #2"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"a #3","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"a #3"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n d","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n d #1"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Can be enabled in Firefox via the `network.http.http3.enabled` pref in `about:config`.","2":"Can be enabled in Chrome pre-release channels via the `--enable-quic` & `--quic-version=h3-23` command line arguments.","3":"Partial support in Safari refers to being limited to macOS 11 Big Sur and later."},"usage_perc_y":0,"usage_perc_a":1.5,"ucprefix":false,"parent":"","keywords":"https/3","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"iframe-sandbox":{"title":"sandbox attribute for iframes","description":"Method of running external site pages with reduced privileges (e.g. no JavaScript) in iframes.","spec":"https://html.spec.whatwg.org/multipage/embedded-content.html#attr-iframe-sandbox","status":"ls","links":[{"url":"https://blog.chromium.org/2010/05/security-in-depth-html5s-sandbox.html","title":"Chromium blog article"},{"url":"https://msdn.microsoft.com/en-us/hh563496","title":"MSDN article"},{"url":"https://www.webplatform.org/docs/html/attributes/sandbox","title":"WebPlatform Docs"}],"categories":["HTML5","Security"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"a","18":"a","19":"a","20":"a","21":"a","22":"a","23":"a","24":"a","25":"a","26":"a","27":"a","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"n","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":98.22,"usage_perc_a":0.08,"ucprefix":false,"parent":"","keywords":"","ie_id":"iframesandboxattribute","chrome_id":"5715536319086592","firefox_id":"","webkit_id":""},"iframe-seamless":{"title":"seamless attribute for iframes","description":"The seamless attribute makes an iframe's contents actually part of a page, and adopts the styles from its hosting page. The attribute has been removed from both [the WHATWG](https://github.com/whatwg/html/issues/331) and [the W3C](https://github.com/w3c/html/pull/325) HTML5 specifications.","spec":"https://www.w3.org/TR/2011/WD-html5-20110525/the-iframe-element.html#attr-iframe-seamless","status":"unoff","links":[{"url":"https://github.com/ornj/seamless-polyfill","title":"Experimental polyfill"},{"url":"http://labs.ft.com/2013/01/seamless-iframes-not-quite-seamless/","title":"Article"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=631218","title":"Bug on Firefox support: wontfix"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6261330-iframe-seamless-attribute","title":"Microsoft Edge Developer UserVoice: No plans"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n d","21":"n d","22":"n d","23":"n d","24":"n d","25":"n d","26":"n d","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n #1","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n #1","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n #1","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"Chrome 20-26 had partial support behind a flag, though this was [later removed](https://bugs.chromium.org/p/chromium/issues/detail?id=229421).","notes_by_num":{"1":"Hides the border of seamless iframes and recognizes the 'seamless' DOM property, but does not provide actual support."},"usage_perc_y":0,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"iframeseamlessattribute","chrome_id":"6630329993396224","firefox_id":"","webkit_id":""},"iframe-srcdoc":{"title":"srcdoc attribute for iframes","description":"Override the content specified in the `src` attribute (if present) with HTML content within the attribute.","spec":"https://html.spec.whatwg.org/multipage/embedded-content.html#attr-iframe-srcdoc","status":"ls","links":[{"url":"https://docs.webplatform.org/wiki/html/elements/iframe","title":"WebPlatform Docs"},{"url":"https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe","title":"MDN Web Docs - iframe"},{"url":"https://github.com/jugglinmike/srcdoc-polyfill","title":"Srcdoc Polyfill"},{"url":"https://bocoup.com/weblog/third-party-javascript-development-future/","title":"Article"}],"categories":["HTML5"],"stats":{"ie":{"6":"p","7":"p","8":"p","9":"p","10":"p","11":"p","5.5":"n"},"edge":{"12":"p","13":"p","14":"p","15":"p","16":"p","17":"p","18":"p","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"p","4":"p","5":"p","6":"p","7":"p","8":"p","9":"p","10":"p","11":"p","12":"p","13":"p","14":"p","15":"p","16":"p","17":"p","18":"p","19":"p","20":"p","21":"p","22":"p","23":"p","24":"p","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"p","3.6":"p"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"p","15":"p","16":"p","17":"p","18":"p","19":"p","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"p","5":"p","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"p","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"p","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"p","11.5":"p","11.6":"p","12.1":"p"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"p","4.2-4.3":"p","5.0-5.1":"p","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"p","4":"p","81":"y","2.1":"p","2.2":"p","2.3":"p","4.1":"p","4.2-4.3":"p","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"p","10":"y"},"op_mob":{"10":"n","11":"n","12":"p","59":"y","11.1":"p","11.5":"p","12.1":"p"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"p","11":"p"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":96.38,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"iframesrcdocattribute","chrome_id":"5222955109842944","firefox_id":"","webkit_id":""},"ime":{"title":"Input Method Editor API","description":"Provides scripted access to the Input Method Editor (IME). An IME is often used to input characters from East Asian languages by typing roman characters and selecting from the resulting suggestions.","spec":"https://www.w3.org/TR/ime-api/","status":"wd","links":[{"url":"http://blogs.msdn.com/b/ie/archive/2014/03/31/building-better-input-experience-for-east-asian-users-with-the-ime-api-in-ie11.aspx","title":"Building Better Input Experience for East Asian Users with the IME API in IE11"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"y x #1","5.5":"n"},"edge":{"12":"y x #1","13":"y x #1","14":"y x #1","15":"y x #1","16":"y x #1","17":"y x #1","18":"y x #1","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"y x #1"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Prefixed implementation uses `msGetInputContext()` method from an earlier version of the spec to get the `InputMethodContext`, rather than the `inputMethodContext` attribute. Also includes support for `getCompositionAlternatives()` from the latest Editor'"},"usage_perc_y":1.5,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"ime,cjk,input,internationalization,inputMethodContext,candidatewindow,composition","ie_id":"imeapi","chrome_id":"6366722080636928","firefox_id":"","webkit_id":""},"img-naturalwidth-naturalheight":{"title":"naturalWidth & naturalHeight image properties","description":"Properties defining the intrinsic width and height of the image, rather than the displayed width & height.","spec":"https://html.spec.whatwg.org/multipage/embedded-content.html#dom-img-naturalwidth","status":"ls","links":[{"url":"http://www.jacklmoore.com/notes/naturalwidth-and-naturalheight-in-ie/","title":"Blog post on support in IE"},{"url":"https://gist.github.com/jalbertbowden/5273983","title":"gist on getting natural width & height in older IE"}],"categories":["DOM","HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":99.61,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"imports":{"title":"HTML Imports","description":"Deprecated method of including and reusing HTML documents in other HTML documents. Superseded by ES modules.","spec":"https://www.w3.org/TR/html-imports/","status":"wd","links":[{"url":"https://www.polymer-project.org/platform/html-imports.html","title":"Polymer project (polyfill & web components framework)"},{"url":"https://www.html5rocks.com/tutorials/webcomponents/imports/","title":"HTML5Rocks - HTML Imports: #include for the web"},{"url":"https://code.google.com/p/chromium/issues/detail?id=240592","title":"Chromium tracking bug: Implement HTML Imports"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=877072","title":"Firefox tracking bug: Implement HTML Imports"},{"url":"http://status.modern.ie/htmlimports","title":"IE Web Platform Status and Roadmap: HTML Imports"}],"categories":["DOM","HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"p","11":"p","5.5":"n"},"edge":{"12":"p","13":"p","14":"p","15":"p","16":"p","17":"p","18":"p","79":"y","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"p","31":"p","32":"p d","33":"p d","34":"p d","35":"p d","36":"p d","37":"p d","38":"p d","39":"p d","40":"p d","41":"p d","42":"p d","43":"p d","44":"p d","45":"p d","46":"p d","47":"p d","48":"p d","49":"p d","50":"p d","51":"p d","52":"p d","53":"p d","54":"p d","55":"p d","56":"p","57":"p","58":"p","59":"p","60":"p","61":"p","62":"p","63":"p","64":"p","65":"p","66":"p","67":"p","68":"p","69":"p","70":"p","71":"p","72":"p","73":"p","74":"p","75":"p","76":"p","77":"p","78":"p","79":"p","80":"p","81":"p","82":"p","83":"p","84":"p","85":"p","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n d","31":"n d","32":"n d","33":"n d","34":"n d","35":"p d","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"p","7":"p","8":"p","9":"p","10":"p","11":"p","12":"p","13":"p","14":"p","3.1":"n","3.2":"n","5.1":"n","6.1":"p","7.1":"p","9.1":"p","10.1":"p","11.1":"p","12.1":"p","13.1":"p","TP":"p"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n d","18":"n d","19":"n d","20":"n d","21":"n d","22":"p d","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"p","14":"p","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"p","8.1-8.4":"p","9.0-9.2":"p","9.3":"p","10.0-10.2":"p","10.3":"p","11.0-11.2":"p","11.3-11.4":"p","12.0-12.1":"p","12.2-12.4":"p","13.0-13.1":"p","13.2":"p","13.3":"p","13.4-13.7":"p"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"p"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Firefox [has no plans to support HTML imports](https://hacks.mozilla.org/2014/12/mozilla-and-web-components/) though for now it can be enabled through the \"dom.webcomponents.enabled\" preference in about:config","2":"Enabled through the \"Enable HTML Imports\" flag in chrome://flags","3":"Enabled through the \"Experimental Web Platform features\" flag in chrome://flags","4":"Enabled through the \"Enable HTML Imports\" flag in opera://flags","5":"Enabled through the \"Experimental Web Platform features\" flag in opera://flags"},"usage_perc_y":6.89,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"webcomponents","ie_id":"htmlimports","chrome_id":"5144752345317376","firefox_id":"html-imports","webkit_id":"feature-html-imports"},"indeterminate-checkbox":{"title":"indeterminate checkbox","description":"Indeterminate checkboxes are displayed in a state which is distinct both from being checked or being unchecked. They are commonly used in hierarchical checkboxes to indicate that only some of the checkbox's descendants are checked.","spec":"https://html.spec.whatwg.org/#dom-input-indeterminate","status":"ls","links":[{"url":"https://css-tricks.com/indeterminate-checkboxes/","title":"CSS-Tricks article"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=160484","title":"iOS versions below 12 don't support indeterminate checkboxes (WebKit Bug 160484)"}],"categories":["DOM","HTML5"],"stats":{"ie":{"6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","5.5":"u"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"u","3.6":"y"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"y","12.1":"y"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"n"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Indeterminacy does not affect a checkbox's checkedness state. It merely affects how the checkbox is displayed.","notes_by_num":{},"usage_perc_y":95.93,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"indexeddb":{"title":"IndexedDB","description":"Method of storing data client-side, allows indexed database queries.","spec":"https://www.w3.org/TR/IndexedDB/","status":"rec","links":[{"url":"https://hacks.mozilla.org/2010/06/comparing-indexeddb-and-webdatabase/","title":"Mozilla Hacks article"},{"url":"https://github.com/axemclion/IndexedDBShim","title":"Polyfill for browsers supporting WebSQL"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/features.js#native-indexeddb","title":"has.js test"},{"url":"https://www.webplatform.org/docs/apis/indexedDB","title":"WebPlatform Docs"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"a #1","11":"a #1","5.5":"n"},"edge":{"12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a x","5":"a x","6":"a x","7":"a x","8":"a x","9":"a x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"p","5":"p","6":"p","7":"p","8":"p","9":"p","10":"n","11":"a x","12":"a x","13":"a x","14":"a x","15":"a x","16":"a x","17":"a x","18":"a x","19":"a x","20":"a x","21":"a x","22":"a x","23":"y x","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"p","5":"p","6":"p","7":"p","8":"a #2","9":"a #2","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"p","3.2":"p","5.1":"p","6.1":"p","7.1":"a #2","9.1":"a #2","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"p","12":"p","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"p","10.6":"p","11.1":"p","11.5":"p","11.6":"p","12.1":"p"},"ios_saf":{"8":"a #2","14":"y","3.2":"p","4.0-4.1":"p","4.2-4.3":"p","5.0-5.1":"p","6.0-6.1":"p","7.0-7.1":"p","8.1-8.4":"a #2","9.0-9.2":"a #2","9.3":"a #2","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"p","4":"p","81":"y","2.1":"p","2.2":"p","2.3":"p","4.1":"p","4.2-4.3":"p","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"p","10":"y"},"op_mob":{"10":"n","11":"p","12":"p","59":"y","11.1":"p","11.5":"p","12.1":"p"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #1","11":"a #1"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support in IE 10 & 11 refers to a number of subfeatures [not being supported](https://indexdb-support-test.glitch.me/). Edge does not support IndexedDB inside blob web workers. [See issue](https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/5942817/)","2":"Partial support in Safari & iOS 8 & 9 refers to [seriously buggy behavior](http://www.raymondcamden.com/2014/09/25/IndexedDB-on-iOS-8-Broken-Bad/) as well as complete lack of support in WebViews."},"usage_perc_y":96.02,"usage_perc_a":2.09,"ucprefix":false,"parent":"","keywords":"indexdb","ie_id":"indexeddb","chrome_id":"6507459568992256","firefox_id":"indexeddb","webkit_id":"specification-indexed-database"},"indexeddb2":{"title":"IndexedDB 2.0","description":"Improvements to Indexed DB, including getAll(), renaming stores and indexes, and binary keys.","spec":"https://www.w3.org/TR/IndexedDB-2/","status":"cr","links":[{"url":"https://hacks.mozilla.org/2016/10/whats-new-in-indexeddb-2-0/","title":"Mozilla Hacks: What's new in IndexedDB 2.0?"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API","title":"MDN Web Docs - IndexedDB API"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"a #1","45":"a #1","46":"a #1","47":"a #2","48":"a #2","49":"a #2","50":"a #2","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #2","53":"a #2","54":"a #2","55":"a #2","56":"a #2","57":"a #2","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #2","40":"a #2","41":"a #2","42":"a #2","43":"a #2","44":"a #2","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"u","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"a #2","6.2-6.4":"a #2","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"a #2"}},"notes":"","notes_by_num":{"1":"Missing: IDBKeyRange includes(), renaming stores/indexes, binary keys, IDBObjectStore getKey(), IDBCursor continuePrimaryKey()","2":"Missing: Renaming stores/indexes, binary keys, IDBObjectStore getKey(), IDBCursor continuePrimaryKey()"},"usage_perc_y":93.31,"usage_perc_a":0.55,"ucprefix":false,"parent":"","keywords":"indexdb,indexeddb,idb","ie_id":"","chrome_id":"5812621622116352,6571252802125824,6537756637396992","firefox_id":"","webkit_id":"specification-indexed-database-2.0"},"inline-block":{"title":"CSS inline-block","description":"Method of displaying an element as a block while flowing it with text. ","spec":"https://www.w3.org/TR/CSS21/visuren.html#fixed-positioning","status":"rec","links":[{"url":"http://robertnyman.com/2010/02/24/css-display-inline-block-why-it-rocks-and-why-it-sucks/","title":"Blog post w/info"},{"url":"http://blog.mozilla.com/webdev/2009/02/20/cross-browser-inline-block/","title":"Info on cross browser support"},{"url":"https://www.webplatform.org/docs/css/properties/display","title":"WebPlatform Docs"}],"categories":["CSS2"],"stats":{"ie":{"6":"a #1","7":"a #1","8":"y","9":"y","10":"y","11":"y","5.5":"a"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"a x","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Only supported in IE6 and IE7 on elements with a display of \"inline\" by default. [Alternative properties](http://blog.mozilla.com/webdev/2009/02/20/cross-browser-inline-block/) are available to provide complete cross-browser support."},"usage_perc_y":99.67,"usage_perc_a":0.03,"ucprefix":false,"parent":"","keywords":"inlineblock,display:inline-block","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"innertext":{"title":"HTMLElement.innerText","description":"A property representing the text within a DOM element and its descendants. As a getter, it approximates the text the user would get if they highlighted the contents of the element with the cursor and then copied to the clipboard.","spec":"https://html.spec.whatwg.org/multipage/dom.html#the-innertext-idl-attribute","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/innerText","title":"MDN Web Docs - innerText"},{"url":"https://github.com/whatwg/compat/issues/5","title":"WHATWG Compatibility Standard issue #5: spec innerText"},{"url":"https://github.com/timdown/rangy","title":"Rangy, a JS range and selection library which contains an innerText implementation"},{"url":"http://discourse.wicg.io/t/standardizing-innertext/799","title":"Standardizing innerText – Web Incubator Community Group (WICG) discussion"}],"categories":["DOM"],"stats":{"ie":{"6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","5.5":"u"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"u","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"u","2.2":"u","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"This test only checks that the property exists and works correctly in a very simple case.\r\n[This blog post by kangax](http://perfectionkills.com/the-poor-misunderstood-innerText/) explains the history of this property, gives much more detailed cross-browser compatibility information, and gives a detailed strawman specification for the property.\r\n`HTMLElement.innerText` is similar to, but has some important differences from, the standard [`Node.textContent`](https://caniuse.com/#feat=textcontent) property.","notes_by_num":{},"usage_perc_y":99.33,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"inner,text,content","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"input-autocomplete-onoff":{"title":"autocomplete attribute: on & off values","description":"The `autocomplete` attribute for `input` elements indicates to the browser whether a value should or should not be autofilled when appropriate.","spec":"https://html.spec.whatwg.org/multipage/forms.html#autofill","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-autocomplete","title":"MDN Web Docs - autocomplete attribute"}],"categories":["DOM"],"stats":{"ie":{"6":"y","7":"y","8":"y","9":"y","10":"y","11":"a #1","5.5":"y"},"edge":{"12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","79":"a #2","80":"a #2","81":"a #2","83":"a #2","84":"a #2","85":"a #2","86":"a #2","87":"a #2"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"a #3","31":"a #3","32":"a #3","33":"a #3","34":"a #3","35":"a #3","36":"a #3","37":"a #3","38":"a #3","39":"a #3","40":"a #3","41":"a #3","42":"a #3","43":"a #3","44":"a #3","45":"a #3","46":"a #3","47":"a #3","48":"a #3","49":"a #3","50":"a #3","51":"a #3","52":"a #3","53":"a #3","54":"a #3","55":"a #3","56":"a #3","57":"a #3","58":"a #3","59":"a #3","60":"a #3","61":"a #3","62":"a #3","63":"a #3","64":"a #3","65":"a #3","66":"a #3","67":"a #3","68":"a #3","69":"a #3","70":"a #3","71":"a #3","72":"a #3","73":"a #3","74":"a #3","75":"a #3","76":"a #3","77":"a #3","78":"a #3","79":"a #3","80":"a #3","81":"a #3","82":"a #3","83":"a #3","84":"a #3","85":"a #3","3.5":"y","3.6":"y"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #2","42":"a #2","43":"a #2","44":"a #2","45":"a #2","46":"a #2","47":"a #2","48":"a #2","49":"a #2","50":"a #2","51":"a #2","52":"a #2","53":"a #2","54":"a #2","55":"a #2","56":"a #2","57":"a #2","58":"a #2","59":"a #2","60":"a #2","61":"a #2","62":"a #2","63":"a #2","64":"a #2","65":"a #2","66":"a #2","67":"a #2","68":"a #2","69":"a #2","70":"a #2","71":"a #2","72":"a #2","73":"a #2","74":"a #2","75":"a #2","76":"a #2","77":"a #2","78":"a #2","79":"a #2","80":"a #2","81":"a #2","83":"a #2","84":"a #2","85":"a #2","86":"a #2","87":"a #2","88":"a #2","89":"a #2","90":"a #2"},"safari":{"4":"n","5":"n","6":"y","7":"a #5","8":"a #5","9":"a #5","10":"a #5","11":"a #5","12":"a #5","13":"a #5","14":"a #5","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"a #5","9.1":"a #5","10.1":"a #5","11.1":"a #5","12.1":"a #5","13.1":"a #5","TP":"a #5"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y #4","14":"y #4","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y #4","6.0-6.1":"y #4","7.0-7.1":"y #4","8.1-8.4":"y #4","9.0-9.2":"y #4","9.3":"y #4","10.0-10.2":"y #4","10.3":"y #4","11.0-11.2":"y #4","11.3-11.4":"y #4","12.0-12.1":"y #4","12.2-12.4":"y #4","13.0-13.1":"y #4","13.2":"y #4","13.3":"y #4","13.4-13.7":"y #4"},"op_mini":{"all":"y #4"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #5","11":"a #5"},"and_uc":{"12.12":"y #4"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"a #2"},"baidu":{"7.12":"y"},"kaios":{"2.5":"a #3"}},"notes":"This support information does not include support for other `autocomplete` values.\r\n\r\nAs described in detail below, many modern browsers ignore the `off` value on certain fields in certain cases intentionally in order to give the user more control over autofilling fields. One example is the use of password managers.","notes_by_num":{"1":"Partial support refers to ignoring the `off` value for password fields. [see related blog post](http://blogs.msdn.com/b/ieinternals/archive/2009/09/10/troubleshooting-stored-login-problems-in-ie.aspx)","2":"Partial support in Chrome refers to the browser intentionally ignoring `autocomplete=\"off\"` when the user uses the browser's autofill functionality. [see bug](https://code.google.com/p/chromium/issues/detail?id=468153#c29)","3":"Partial support in Firefox refers to ignoring `autocomplete=\"off\"` for login forms. [see bug](https://bugzilla.mozilla.org/show_bug.cgi?id=956906)","4":"Browser does not display previously submitted values as options with `on` value.","5":"Safari ignores the `off` value for [username, email and password fields](https://stackoverflow.com/questions/22661977/disabling-safari-autofill-on-usernames-and-passwords)"},"usage_perc_y":53.92,"usage_perc_a":45.66,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"input-color":{"title":"Color input type","description":"Form field allowing the user to select a color.","spec":"https://html.spec.whatwg.org/multipage/forms.html#color-state-(type=color)","status":"ls","links":[{"url":"http://www.html5tutorial.info/html5-color.php","title":"Tutorial"},{"url":"https://github.com/jonstipe/color-polyfill","title":"Polyfill"},{"url":"https://www.webplatform.org/docs/html/elements/input/type/color","title":"WebPlatform Docs"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6514216--input-type-color","title":"Microsoft Edge feature request on UserVoice"},{"url":"https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/color","title":"MDN web docs"},{"url":"https://www.html5tutorial.info/html5-color.php","title":"Tutorial"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"n","16":"n","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"n","14":"y #1","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"y #1","13.0-13.1":"y #1","13.2":"y #1","13.3":"y #1","13.4-13.7":"y #1"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Supported through WKWebView and Safari but not through UIWebView"},"usage_perc_y":95.28,"usage_perc_a":0,"ucprefix":false,"parent":"forms","keywords":"colour,input type=\"color\"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"input-datetime":{"title":"Date and time input types","description":"Form field widgets to easily allow users to enter a date, time or both, generally by using a calendar/time input widget. Refers to supporting the following input types: `date`, `time`, `datetime-local`, `month` & `week`.","spec":"https://html.spec.whatwg.org/multipage/forms.html#date-state-(type=date)","status":"ls","links":[{"url":"https://code.tutsplus.com/tutorials/quick-tip-create-cross-browser-datepickers-in-minutes--net-20236","title":"Datepicker tutorial w/polyfill"},{"url":"https://github.com/zoltan-dulac/html5Forms.js","title":"Polyfill for HTML5 forms"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/form.js#input-type-datetime-local","title":"has.js test"},{"url":"https://www.webplatform.org/docs/html/elements/input/type/date","title":"WebPlatform Docs"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=888320","title":"Bug on Firefox support"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=119175","title":"Bug for WebKit/Safari"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=214946","title":"Bug for WebKit/Safari"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"a #1","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n d #4","54":"n d #4","55":"n d #4","56":"n d #4","57":"a #5","58":"a #5","59":"a #5","60":"a #5","61":"a #5","62":"a #5","63":"a #5","64":"a #5","65":"a #5","66":"a #5","67":"a #5","68":"a #5","69":"a #5","70":"a #5","71":"a #5","72":"a #5","73":"a #5","74":"a #5","75":"a #5","76":"a #5","77":"a #5","78":"a #5","79":"a #5","80":"a #5","81":"a #5","82":"a #5","83":"a #5","84":"a #5","85":"a #5","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"a #5","21":"a #5","22":"a #5","23":"a #5","24":"a #5","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"a #6"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"a #2","14":"a #2","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"a #2","6.0-6.1":"a #2","7.0-7.1":"a #2","8.1-8.4":"a #2","9.0-9.2":"a #2","9.3":"a #2","10.0-10.2":"a #2","10.3":"a #2","11.0-11.2":"a #2","11.3-11.4":"a #2","12.0-12.1":"a #2","12.2-12.4":"a #2","13.0-13.1":"a #2","13.2":"a #2","13.3":"a #2","13.4-13.7":"a #2"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n #3","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n #3","4.2-4.3":"n #3","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"a #5"}},"notes":"There used to also be a `datetime` type, but it was [dropped from the HTML spec](https://github.com/whatwg/html/issues/336).","notes_by_num":{"1":"Partial support in Microsoft Edge refers to supporting `date`, `week`, and `month` input types, and not `time` and `datetime-local`.","2":"Partial support in iOS Safari refers to not supporting the `week` input type, nor the `min`, `max` or `step` attributes","3":"Some modified versions of the Android 4.x browser do have support for date/time fields.","4":"Can be enabled in Firefox using the `dom.forms.datetime` flag.","5":"Partial support refers to supporting `date` and `time` input types, but not `datetime-local`, `month` or `week`.","6":"Partial support in macOS Safari refers to not supporting the `week` and `month` input type"},"usage_perc_y":76.5,"usage_perc_a":15.85,"ucprefix":false,"parent":"forms","keywords":"datepicker,timepicker,input type=\"date\",input type=\"time\",input date,datetime-local","ie_id":"daterelatedinputtypes,timerelatedinputtypes","chrome_id":"6640933999214592","firefox_id":"","webkit_id":""},"input-email-tel-url":{"title":"Email, telephone & URL input types","description":"Text input fields intended for email addresses, telephone numbers or URLs. Particularly useful in combination with [form validation](https://caniuse.com/#feat=form-validation)","spec":"https://html.spec.whatwg.org/multipage/forms.html#telephone-state-(type=tel)","status":"ls","links":[{"url":"http://www.htmlgoodies.com/html5/tutorials/whats-new-in-html5-forms-email-url-and-telephone-input-types.html#fbid=c9PEy7_9RZb","title":"Article on usage"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"a #1","2.2":"a #1","2.3":"a #1","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"a #1","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Browsers without support for these types will fall back to using the \"text\" type.","notes_by_num":{"1":"Does not provide an email-specific keyboard for email addresses"},"usage_perc_y":98.48,"usage_perc_a":0,"ucprefix":false,"parent":"forms","keywords":"input[type=email],input[type=tel],input[type=url],input type=\"email\",input type=\"tel\",input type=\"url\"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"input-event":{"title":"input event","description":"The `input` event is fired when the user changes the value of an `<input>` element, `<select>` element, or `<textarea>` element. By contrast, the \"change\" event usually only fires after the form control has lost focus.","spec":"https://html.spec.whatwg.org/multipage/forms.html#event-input-input","status":"ls","links":[{"url":"https://html.spec.whatwg.org/multipage/forms.html#send-select-update-notifications","title":"Specification for `<select>` elements firing the `input` event"},{"url":"https://developer.mozilla.org/en-US/docs/Web/Events/input","title":"MDN Web Docs - input event"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/10182111--input-type-checkbox-type-radio-should-fire-in","title":"Microsoft Edge feature request on UserVoice"}],"categories":["DOM","HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"a #1 #3 #5","10":"y #3 #5","11":"y #3 #5","5.5":"n"},"edge":{"12":"y #3 #5","13":"y #3 #5","14":"y #3 #5","15":"y #3 #5","16":"y #3 #5","17":"y #3 #5","18":"y #3 #5","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"u","3":"a #2 #3 #4","4":"y #3 #4","5":"y #3 #4","6":"y #3 #4","7":"y #3 #4","8":"y #3 #4","9":"y #3 #4","10":"y #3 #4","11":"y #3 #4","12":"y #3 #4","13":"y #3 #4","14":"y #3 #4","15":"y #3 #4","16":"y #3 #4","17":"y #3 #4","18":"y #3 #4","19":"y #3 #4","20":"y #3 #4","21":"y #3 #4","22":"y #3 #4","23":"y #3 #4","24":"y #3 #4","25":"y #3 #4","26":"y #3 #4","27":"y #3 #4","28":"y #3 #4","29":"y #3 #4","30":"y #3 #4","31":"y #3 #4","32":"y #3 #4","33":"y #3 #4","34":"y #3 #4","35":"y #3 #4","36":"y #3 #4","37":"y #3 #4","38":"y #3 #4","39":"y #3 #4","40":"y #3 #4","41":"y #3 #4","42":"y #3 #4","43":"y #3 #4","44":"y #3 #4","45":"y #3 #4","46":"y #3 #4","47":"y #3 #4","48":"y #3 #4","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a #2 #3 #4","3.6":"y #3 #4"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"y #3 #4","16":"y #3 #4","17":"y #3 #4","18":"y #3 #4","19":"y #3 #4","20":"y #3 #4","21":"y #3 #4","22":"y #3 #4","23":"y #3 #4","24":"y #3 #4","25":"y #3 #4","26":"y #3 #4","27":"y #3 #4","28":"y #3 #4","29":"y #3 #4","30":"y #3 #4","31":"y #3 #4","32":"y #3 #4","33":"y #3 #4","34":"y #3 #4","35":"y #4","36":"y #4","37":"y #4","38":"y #4","39":"y #4","40":"y #4","41":"y #4","42":"y #4","43":"y #4","44":"y #4","45":"y #4","46":"y #4","47":"y #4","48":"y #4","49":"y #4","50":"y #4","51":"y #4","52":"y #4","53":"y #4","54":"y #4","55":"y #4","56":"y #4","57":"y #4","58":"y #4","59":"y #4","60":"y #4","61":"y #4","62":"y #4","63":"y #4","64":"y #4","65":"y #4","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"u","5":"u","6":"u","7":"y #4","8":"y #4","9":"y #4","10":"y #4","11":"y #4","12":"y #4","13":"y #6","14":"y","3.1":"u","3.2":"u","5.1":"y #3 #4","6.1":"y #4","7.1":"y #4","9.1":"y #4","10.1":"y #4","11.1":"y #4","12.1":"y #6","13.1":"y","TP":"y"},"opera":{"9":"u","11":"u","12":"u","15":"y #3 #4","16":"y #3 #4","17":"y #3 #4","18":"y #3 #4","19":"y #3 #4","20":"y #3 #4","21":"y #3 #4","22":"y #4","23":"y #4","24":"y #4","25":"y #4","26":"y #4","27":"y #4","28":"y #4","29":"y #4","30":"y #4","31":"y #4","32":"y #4","33":"y #4","34":"y #4","35":"y #4","36":"y #4","37":"y #4","38":"y #4","39":"y #4","40":"y #4","41":"y #4","42":"y #4","43":"y #4","44":"y #4","45":"y #4","46":"y #4","47":"y #4","48":"y #4","49":"y #4","50":"y #4","51":"y #4","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"u","10.0-10.1":"u","10.5":"u","10.6":"u","11.1":"u","11.5":"u","11.6":"a #2","12.1":"y"},"ios_saf":{"8":"y #4","14":"y #4","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"y #3 #4","6.0-6.1":"y #3 #4","7.0-7.1":"y #3 #4","8.1-8.4":"y #4","9.0-9.2":"y #4","9.3":"y #4","10.0-10.2":"y #4","10.3":"y #4","11.0-11.2":"y #4","11.3-11.4":"y #4","12.0-12.1":"y #4","12.2-12.4":"y #4","13.0-13.1":"y #4","13.2":"y #4","13.3":"y #4","13.4-13.7":"y #4"},"op_mini":{"all":"n"},"android":{"3":"y #3 #4","4":"y #3 #4","81":"y #4","2.1":"u","2.2":"u","2.3":"y #3 #4","4.1":"y #3 #4","4.2-4.3":"y #3 #4","4.4":"y #3 #4","4.4.3-4.4.4":"y #4"},"bb":{"7":"y #3 #4","10":"y #4"},"op_mob":{"10":"y","11":"y","12":"y","59":"y #4","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y #3 #4"},"ie_mob":{"10":"y #3 #5","11":"y #3 #5"},"and_uc":{"12.12":"y #3 #4"},"samsung":{"4":"y #4","5.0-5.4":"y #4","6.2-6.4":"y #4","7.2-7.4":"y #4","8.2":"y #4","9.2":"y #4","10.1":"y #4","11.1-11.2":"y #4","12.0":"y #4"},"and_qq":{"10.4":"y #4"},"baidu":{"7.12":"y #4"},"kaios":{"2.5":"y #3 #4"}},"notes":"","notes_by_num":{"1":"Doesn't fire an `input` event when deleting text (via Backspace, Delete, Cut, etc.).","2":"Doesn't fire an `input` event when drag-and-dropping text into an `<input>` or `<textarea>`.","3":"`<select>` doesn't fire `input` events. See [MS Edge bug](https://developer.microsoft.com/microsoft-edge/platform/issues/4660045/) and [Firefox bug](https://bugzilla.mozilla.org/show_bug.cgi?id=1024350).","4":"Doesn't fire an `input` event when (un)checking a checkbox or radio button, or when changing the selected file(s) of an `<input type=\"file\">`. See [Chrome bug](https://code.google.com/p/chromium/issues/detail?id=534245), [WebKit bug #149398](https://bugs.webkit.org/show_bug.cgi?id=149398), [WebKit bug #190223](https://bugs.webkit.org/show_bug.cgi?id=190223) and [Firefox bug](https://bugzilla.mozilla.org/show_bug.cgi?id=1206616).","5":"Doesn't fire an `input` event when (un)checking a checkbox or radio button. See [MS Edge bug](https://connect.microsoft.com/IE/feedback/details/1883692).","6":"Doesn't fire an `input` event when changing the selected file(s) of an `<input type=\"file\">`. See [WebKit bug #149398](https://bugs.webkit.org/show_bug.cgi?id=149398) and [WebKit bug #204292](https://bugs.webkit.org/show_bug.cgi?id=204292)."},"usage_perc_y":98.33,"usage_perc_a":0.23,"ucprefix":false,"parent":"","keywords":"oninput","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"input-file-accept":{"title":"accept attribute for file input","description":"Allows a filter to be defined for what type of files a user may pick with from an `<input type=\"file\">` dialog","spec":"https://html.spec.whatwg.org/multipage/forms.html#attr-input-accept","status":"ls","links":[{"url":"https://www.wufoo.com/html5/attributes/07-accept.html","title":"Demo & information"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/13661175-full-spec-support-for-accept-in-input-type-file","title":"Microsoft Edge feature request on UserVoice"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"u","6":"u","7":"u","8":"u","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"u","22":"u","23":"u","24":"u","25":"u","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"a #1","7.1":"a #1","9.1":"a #1","10.1":"a #1","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a #1","14":"a #1","3.2":"n #3","4.0-4.1":"n #3","4.2-4.3":"n #3","5.0-5.1":"n #3","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"a #1","9.0-9.2":"a #1","9.3":"a #1","10.0-10.2":"a #1","10.3":"a #1","11.0-11.2":"a #1","11.3-11.4":"a #1","12.0-12.1":"a #1","12.2-12.4":"a #1","13.0-13.1":"a #1","13.2":"a #1","13.3":"a #1","13.4-13.7":"a #1"},"op_mini":{"all":"n"},"android":{"3":"a #2","4":"a #2","81":"n #3","2.1":"n","2.2":"n","2.3":"n","4.1":"a #2","4.2-4.3":"a #2","4.4":"n #3","4.4.3-4.4.4":"n #3"},"bb":{"7":"a #2","10":"a #1"},"op_mob":{"10":"n","11":"n","12":"n","59":"a #2","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a #2"},"and_ff":{"82":"n"},"ie_mob":{"10":"n #3","11":"a #4"},"and_uc":{"12.12":"n"},"samsung":{"4":"a #2","5.0-5.4":"a #2","6.2-6.4":"a #2","7.2-7.4":"a #2","8.2":"a #2","9.2":"a #2","10.1":"a #2","11.1-11.2":"a #2","12.0":"a #2"},"and_qq":{"10.4":"a #2"},"baidu":{"7.12":"a #2"},"kaios":{"2.5":"y"}},"notes":"Not supported means any file can be picked as if the `accept` attribute was not set, unless otherwise noted.\r\n\r\nOn Windows, files that do not apply are hidden. On OSX they are grayed out and disabled.","notes_by_num":{"1":"Supports the type format (e.g. `image/*`) but not the extension format (e.g. `.png`)","2":"Offers appropriate file locations/input based on format type, but does not prevent other files from being selected.","3":"Does not allow any files to be picked at all","4":"Supports the type format but does not allow any file to be picked when using the extension format"},"usage_perc_y":46.32,"usage_perc_a":49.93,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"input-file-directory":{"title":"Directory selection from file input","description":"The `webkitdirectory` attribute on the `<input type=\"file\">` element allows entire directory with file contents (and any subdirectories) to be selected.","spec":"https://wicg.github.io/entries-api/#dom-htmlinputelement-webkitdirectory","status":"unoff","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory","title":"MDN article"}],"categories":["DOM","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"Lack of support in mobile browsers may be due to the OS file picker not having support for selecting a directory.","notes_by_num":{"1":"Can be enabled via the \"Experimental Features\" developer menu"},"usage_perc_y":45.6,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"mozdirectory,webkitRelativePath","ie_id":"webkitdirectoryandwebkitrelativepath","chrome_id":"","firefox_id":"","webkit_id":""},"input-file-multiple":{"title":"Multiple file selection","description":"Allows users to select multiple files in the file picker.","spec":"https://html.spec.whatwg.org/multipage/forms.html#attr-input-multiple","status":"ls","links":[{"url":"https://code.google.com/p/chromium/issues/detail?id=348912","title":"Chrome bug (for Android)"},{"url":"http://www.raymondcamden.com/2012/2/28/Working-with-HTML5s-multiple-file-upload-support","title":"Article"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"y"},"chrome":{"4":"n","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n #1"},"android":{"3":"n #1","4":"n #1","81":"n #1","2.1":"n #1","2.2":"n #1","2.3":"n #1","4.1":"n #1","4.2-4.3":"n #1","4.4":"n #1","4.4.3-4.4.4":"n #1"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n #1","11":"n #1","12":"n #1","59":"n #1","11.1":"n #1","11.5":"n #1","12.1":"n #1"},"and_chr":{"86":"a #1"},"and_ff":{"82":"n #1"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n #1"},"samsung":{"4":"n #1","5.0-5.4":"a #1","6.2-6.4":"a #1","7.2-7.4":"a #1","8.2":"a #1","9.2":"a #1","10.1":"a #1","11.1-11.2":"a #1","12.0":"a #1"},"and_qq":{"10.4":"a #1"},"baidu":{"7.12":"a #1"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Not supported on Android 4.x and below, presumably an OS limitation. Only seems to work in Android 5.x for the Chrome browser."},"usage_perc_y":59.67,"usage_perc_a":36.86,"ucprefix":false,"parent":"forms","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"input-inputmode":{"title":"inputmode attribute","description":"The `inputmode` attribute specifies what kind of input mechanism would be most helpful for users entering content into the form control.","spec":"https://html.spec.whatwg.org/multipage/forms.html#input-modalities:-the-inputmode-attribute","status":"ls","links":[{"url":"https://www.wufoo.com/html5/attributes/23-inputmode.html","title":"Demo on Wufoo (old)"},{"url":"https://css-tricks.com/everything-you-ever-wanted-to-know-about-inputmode/","title":"Everything You Ever Wanted to Know About inputmode (CSS Tricks)"}],"categories":["DOM","HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"a","18":"a","19":"a","20":"a","21":"n d #1","22":"n d #1","23":"n d #1","24":"n d #1","25":"n d #1","26":"n d #1","27":"n d #1","28":"n d #1","29":"n d #1","30":"n d #1","31":"n d #1","32":"n d #1","33":"n d #1","34":"n d #1","35":"n d #1","36":"n d #1","37":"n d #1","38":"n d #1","39":"n d #1","40":"n d #1","41":"n d #1","42":"n d #1","43":"n d #1","44":"n d #1","45":"n d #1","46":"n d #1","47":"n d #1","48":"n d #1","49":"n d #1","50":"n d #1","51":"n d #1","52":"n d #1","53":"n d #1","54":"n d #1","55":"n d #1","56":"n d #1","57":"n d #1","58":"n d #1","59":"n d #1","60":"n d #1","61":"n d #1","62":"n d #1","63":"n d #1","64":"n d #1","65":"n d #1","66":"n d #1","67":"n d #1","68":"n d #1","69":"n d #1","70":"n d #1","71":"n d #1","72":"n d #1","73":"n d #1","74":"n d #1","75":"n d #1","76":"n d #1","77":"n d #1","78":"n d #1","79":"n d #1","80":"n d #1","81":"n d #1","82":"n d #1","83":"n d #1","84":"n d #1","85":"n d #1","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n d","57":"n d","58":"n d","59":"n d","60":"n d","61":"n d","62":"n d","63":"n d","64":"n d","65":"n d","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n d","44":"n d","45":"n d","46":"n d","47":"n d","48":"n d","49":"n d","50":"n d","51":"n d","52":"n d","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n d #1"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n d #1"}},"notes":"","notes_by_num":{"1":"Support can be enabled via the `dom.forms.inputmode` flag"},"usage_perc_y":84.33,"usage_perc_a":0.02,"ucprefix":false,"parent":"","keywords":"","ie_id":"inputmode","chrome_id":"6225984592281600","firefox_id":"","webkit_id":""},"input-minlength":{"title":"Minimum length attribute for input fields","description":"Declares a lower bound on the number of characters a user can input.","spec":"https://html.spec.whatwg.org/multipage/forms.html#the-maxlength-and-minlength-attributes","status":"ls","links":[{"url":"https://www.w3.org/TR/html5/forms.html#setting-minimum-input-length-requirements:-the-minlength-attribute","title":"W3C usage example"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6565212-minlength-attribute","title":"Microsoft Edge feature request on UserVoice"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=932755","title":"Firefox tracking bug"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=149832","title":"WebKit feature request bug"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"The [`pattern` attribute](https://caniuse.com/#feat=input-pattern) can be used [as an alternative](https://stackoverflow.com/a/10294291) solution for browsers without support.","notes_by_num":{},"usage_perc_y":95.45,"usage_perc_a":0,"ucprefix":false,"parent":"form-validation","keywords":"","ie_id":"","chrome_id":"6023370181181440","firefox_id":"","webkit_id":""},"input-number":{"title":"Number input type","description":"Form field type for numbers.","spec":"https://html.spec.whatwg.org/multipage/forms.html#number-state-(type=number)","status":"ls","links":[{"url":"http://www.html5tutorial.info/html5-number.php","title":"Tutorial"},{"url":"https://github.com/jonstipe/number-polyfill","title":"Polyfill"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/form.js#input-type-number","title":"has.js test"},{"url":"https://www.webplatform.org/docs/html/elements/input/type/number","title":"WebPlatform Docs"},{"url":"https://www.ctrl.blog/entry/html5-input-number-localization.html","title":"Poor browser support for localized decimal marks, commas"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y #1","11":"y #1","5.5":"n"},"edge":{"12":"y #1","13":"y #1","14":"y #4","15":"y #4","16":"y #4","17":"y #4","18":"y #4","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"y #3","30":"y #3","31":"y #3","32":"y #3","33":"y #3","34":"y #3","35":"y #3","36":"y #3","37":"y #3","38":"y #3","39":"y #3","40":"y #3","41":"y #3","42":"y #3","43":"y #3","44":"y #3","45":"y #3","46":"y #3","47":"y #3","48":"y #3","49":"y #3","50":"y #3","51":"y #3","52":"y #3","53":"y #3","54":"y #3","55":"y #3","56":"y #3","57":"y #3","58":"y #3","59":"y #3","60":"y #3","61":"y #3","62":"y #3","63":"y #3","64":"y #3","65":"y #3","66":"y #3","67":"y #3","68":"y #3","69":"y #3","70":"y #3","71":"y #3","72":"y #3","73":"y #3","74":"y #3","75":"y #3","76":"y #3","77":"y #3","78":"y #3","79":"y #3","80":"y #3","81":"y #3","82":"y #3","83":"y #3","84":"y #3","85":"y #3","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"a #1 #2","14":"a #1 #2","3.2":"a #1 #2","4.0-4.1":"a #1 #2","4.2-4.3":"a #1 #2","5.0-5.1":"a #1 #2","6.0-6.1":"a #1 #2","7.0-7.1":"a #1 #2","8.1-8.4":"a #1 #2","9.0-9.2":"a #1 #2","9.3":"a #1 #2","10.0-10.2":"a #1 #2","10.3":"a #1 #2","11.0-11.2":"a #1 #2","11.3-11.4":"a #1 #2","12.0-12.1":"a #1 #2","12.2-12.4":"a #1 #2","13.0-13.1":"a #1 #2","13.2":"a #1 #2","13.3":"a #1 #2","13.4-13.7":"a #1 #2"},"op_mini":{"all":"n"},"android":{"3":"n","4":"a #1 #2","81":"a #1 #2","2.1":"n","2.2":"n","2.3":"n","4.1":"a #1 #2","4.2-4.3":"a #1 #2","4.4":"a #1 #2","4.4.3-4.4.4":"a #1 #2"},"bb":{"7":"n","10":"a #1 #2"},"op_mob":{"10":"y","11":"y","12":"y","59":"a #1 #2","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"a #1 #2"},"and_ff":{"82":"y #1 #3"},"ie_mob":{"10":"a #1 #2","11":"a #1 #2"},"and_uc":{"12.12":"a #1 #2"},"samsung":{"4":"a #1 #2","5.0-5.4":"a #1 #2","6.2-6.4":"a #1 #2","7.2-7.4":"a #1 #2","8.2":"a #1 #2","9.2":"a #1 #2","10.1":"a #1 #2","11.1-11.2":"a #1 #2","12.0":"a #1 #2"},"and_qq":{"10.4":"a #1 #2"},"baidu":{"7.12":"a #1 #2"},"kaios":{"2.5":"y #3"}},"notes":"","notes_by_num":{"1":"Does not support increment/decrement, either via buttons in UI or via arrow up & down keys.","2":"UI widget does not take the \"step\", \"min\" or \"max\" attributes into account.","3":"Firefox doesn't support [autocomplete content via datalist](https://codepen.io/graste/pen/bNoVKW) elements.","4":"Does not include increment/decrement buttons, but does support increment/decrement via arrow up & down keys."},"usage_perc_y":47.46,"usage_perc_a":50.85,"ucprefix":false,"parent":"forms","keywords":"spinner,input type=\"number\"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"input-pattern":{"title":"Pattern attribute for input fields","description":"Allows validation of an input field based on a given regular expression pattern.","spec":"https://html.spec.whatwg.org/multipage/forms.html#the-pattern-attribute","status":"ls","links":[{"url":"http://html5pattern.com","title":"Site with common sample patterns"},{"url":"https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-pattern","title":"MDN Web Docs - input element: pattern attribute"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"u","6":"a #1 #2","7":"a #1 #2","8":"a #1 #2","9":"a #1 #2","10":"a #1 #2","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"a #1 #2","6.1":"a #1 #2","7.1":"a #1 #2","9.1":"a #1 #2","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"a #1 #2","14":"y","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"a #1 #2","6.0-6.1":"a #1 #2","7.0-7.1":"a #1 #2","8.1-8.4":"a #1 #2","9.0-9.2":"a #1 #2","9.3":"a #1 #2","10.0-10.2":"a #1 #2","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"a #1","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #1","11":"a #1"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support refers to not displaying a message for invalid patterns","2":"Safari browsers support the `pattern` attribute but will still allow forms to be submitted if the pattern is incorrect. See the [form validation data](https://caniuse.com/#feat=form-validation) for details."},"usage_perc_y":97.66,"usage_perc_a":0.7,"ucprefix":false,"parent":"form-validation","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"input-placeholder":{"title":"input placeholder attribute","description":"Method of setting placeholder text for text-like input fields, to suggest the expected inserted information.","spec":"https://html.spec.whatwg.org/multipage/forms.html#attr-input-placeholder","status":"ls","links":[{"url":"http://www.zachleat.com/web/placeholder/","title":"Article on usage"},{"url":"https://github.com/mathiasbynens/jquery-placeholder","title":"Polyfill"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/form.js#input-attr-placeholder","title":"has.js test"},{"url":"https://www.webplatform.org/docs/html/attributes/placeholder","title":"WebPlatform Docs"},{"url":"https://code.google.com/p/android/issues/detail?id=24626","title":"Issue 24626: Placeholder text for an input type="}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a #1","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a #1","3.2":"a #1","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"a #1","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"a #1","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"a","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"a","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support refers to lacking placeholder support on textarea elements."},"usage_perc_y":99.26,"usage_perc_a":0.09,"ucprefix":false,"parent":"forms","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"input-range":{"title":"Range input type","description":"Form field type that allows the user to select a value using a slider widget.","spec":"https://html.spec.whatwg.org/multipage/forms.html#range-state-(type=range)","status":"ls","links":[{"url":"https://github.com/fryn/html5slider","title":"Polyfill for Firefox"},{"url":"https://github.com/freqdec/fd-slider","title":"Cross-browser polyfill"},{"url":"http://tutorialzine.com/2011/12/what-you-need-to-know-html5-range-input/","title":"Tutorial"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/form.js#input-type-range","title":"has.js test"},{"url":"https://www.webplatform.org/docs/html/elements/input/type/range","title":"WebPlatform Docs"},{"url":"https://github.com/andreruffert/rangeslider.js","title":"rangeslider.js polyfill"},{"url":"https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/range","title":"MDN web docs"},{"url":"https://tutorialzine.com/2011/12/what-you-need-to-know-html5-range-input","title":"Tutorial"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"a","4":"a","81":"y","2.1":"a","2.2":"a","2.3":"a","4.1":"a","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Currently all Android browsers with partial support hide the slider input field by default. However, the element [can be styled](http://tiffanybbrown.com/2012/02/07/input-typerange-and-androids-stock-browser/) to be made visible and usable.","notes_by_num":{},"usage_perc_y":98.28,"usage_perc_a":0.06,"ucprefix":false,"parent":"forms","keywords":"input type=\"range\"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"input-search":{"title":"Search input type","description":"Search field form input type. Intended to look like the underlying platform's native search field widget (if there is one). Other than its appearance, it's the same as an `<input type=\"text\">`.","spec":"https://html.spec.whatwg.org/multipage/forms.html#text-(type=text)-state-and-search-state-(type=search)","status":"ls","links":[{"url":"https://css-tricks.com/webkit-html5-search-inputs/","title":"CSS-Tricks article"},{"url":"https://www.wufoo.com/html5/types/5-search.html","title":"Wufoo's The Current State of HTML5 Forms: The search Type"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y #1","11":"y #1","5.5":"n"},"edge":{"12":"y #1","13":"y #1","14":"y #1","15":"y #1","16":"y #1","17":"y #1","18":"y #1","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y #1","5":"y #1","6":"y #1","7":"y #1","8":"y #1","9":"y #1","10":"y #1","11":"y #1","12":"y #1","13":"y #1","14":"y #1","15":"y #1","16":"y #1","17":"y #1","18":"y #1","19":"y #1","20":"y #1","21":"y #1","22":"y #1","23":"y #1","24":"y #1","25":"y #1","26":"y #1","27":"y #1","28":"y #1","29":"y #1","30":"y #1","31":"y #1","32":"y #1","33":"y #1","34":"y #1","35":"y #1","36":"y #1","37":"y #1","38":"y #1","39":"y #1","40":"y #1","41":"y #1","42":"y #1","43":"y #1","44":"y #1","45":"y #1","46":"y #1","47":"y #1","48":"y #1","49":"y #1","50":"y #1","51":"y #1","52":"y #1","53":"y #1","54":"y #1","55":"y #1","56":"y #1","57":"y #1","58":"y #1","59":"y #1","60":"y #1","61":"y #1","62":"y #1","63":"y #1","64":"y #1","65":"y #1","66":"y #1","67":"y #1","68":"y #1","69":"y #1","70":"y #1","71":"y #1","72":"y #1","73":"y #1","74":"y #1","75":"y #1","76":"y #1","77":"y #1","78":"y #1","79":"y #1","80":"y #1","81":"y #1","82":"y #1","83":"y #1","84":"y #1","85":"y #1","3.5":"n","3.6":"n"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"y #1","16":"y #1","17":"y #1","18":"y #1","19":"y #1","20":"y #1","21":"u","22":"u","23":"u","24":"u","25":"u","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"u","5":"u","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"u","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"u","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"u","11.5":"u","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y #1"},"android":{"3":"y #1","4":"y #1","81":"y","2.1":"u","2.2":"u","2.3":"y #1","4.1":"y #1","4.2-4.3":"y #1","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y #1"},"op_mob":{"10":"n","11":"u","12":"y","59":"y #1","11.1":"u","11.5":"u","12.1":"y #1"},"and_chr":{"86":"y"},"and_ff":{"82":"y #1"},"ie_mob":{"10":"y #1","11":"y #1"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y #1"}},"notes":"","notes_by_num":{"1":"Does not use a special search-specific UI for the field, just the same UI as a regular `<input type=\"text\">`."},"usage_perc_y":99.18,"usage_perc_a":0,"ucprefix":false,"parent":"forms","keywords":"input,type,search","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"input-selection":{"title":"Selection controls for input & textarea","description":"Controls for setting and getting text selection via `setSelectionRange()` and the `selectionStart` & `selectionEnd` properties.","spec":"https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#dom-textarea/input-setselectionrange","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange","title":"MDN artcile on setSelectionRange"}],"categories":["HTML5","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"u","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"u","10.0-10.1":"u","10.5":"u","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"u","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":98.69,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"insert-adjacent":{"title":"Element.insertAdjacentElement() & Element.insertAdjacentText()","description":"Methods for inserting an element or text before or after a given element, or appending or prepending an element or text to a given element's list of children.","spec":"https://dom.spec.whatwg.org/#dom-element-insertadjacentelement","status":"ls","links":[{"url":"https://dom.spec.whatwg.org/#dom-element-insertadjacenttext","title":"WHATWG DOM Specification for Element.insertAdjacentText()"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Element/insertAdjacentElement","title":"MDN Web Docs - Element.insertAdjacentElement()"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Element/insertAdjacentText","title":"MDN Web Docs - Element.insertAdjacentText()"},{"url":"http://jsbin.com/yanadu/edit?html,js,output","title":"JS Bin testcase"}],"categories":["DOM"],"stats":{"ie":{"6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","5.5":"u"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"u","2.2":"u","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":99.33,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"insertAdjacentElement,insertAdjacentText,insert,adjacent,element,text","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"insertadjacenthtml":{"title":"Element.insertAdjacentHTML()","description":"Inserts a string of HTML into a specified position in the DOM relative to the given element.","spec":"https://www.w3.org/TR/DOM-Parsing/#widl-Element-insertAdjacentHTML-void-DOMString-position-DOMString-text","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Element/insertAdjacentHTML","title":"MDN Web Docs - insertAdjacentHTML"},{"url":"https://gist.github.com/eligrey/1276030","title":"Polyfill"}],"categories":["JS API"],"stats":{"ie":{"6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"y","11":"y","5.5":"u"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"u","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"u","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"u","2.2":"u","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Throws an \"Invalid target element for this operation.\" error [when called on a table, tbody, thead, or tr element.](https://johnresig.com/blog/dom-insertadjacenthtml/)"},"usage_perc_y":99.29,"usage_perc_a":0.29,"ucprefix":false,"parent":"","keywords":"element,insert,adjacent,HTML","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"internationalization":{"title":"Internationalization API","description":"Locale-sensitive collation (string comparison), number formatting, and date and time formatting.","spec":"https://tc39.es/ecma402/","status":"other","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl","title":"MDN Web Docs - Internationalization"},{"url":"http://norbertlindenberg.com/2012/12/ecmascript-internationalization-api/","title":"The ECMAScript Internationalization API"},{"url":"https://code.tutsplus.com/tutorials/working-with-intl--cms-21082","title":"Working With Intl"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=90906","title":"WebKit tracking bug"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1344625","title":"Firefox for Android tracking bug"}],"categories":["JS","JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":97.16,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"Intl,Collator,NumberFormat,DateTimeFormat","ie_id":"ecmascriptinternationalizationapi","chrome_id":"","firefox_id":"","webkit_id":"specification-internationalization-api"},"intersectionobserver":{"title":"IntersectionObserver","description":"API that can be used to understand the visibility and position of DOM elements relative to a containing element or to the top-level viewport. The position is delivered asynchronously and is useful for understanding the visibility of elements and implementing pre-loading and deferred loading of DOM content.","spec":"https://www.w3.org/TR/intersection-observer/","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API","title":"MDN Web Docs - Intersection Observer"},{"url":"https://github.com/w3c/IntersectionObserver/tree/master/polyfill","title":"Polyfill"},{"url":"https://developers.google.com/web/updates/2016/04/intersectionobserver","title":"Google Developers article"}],"categories":["DOM","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"a #3","16":"y","17":"y","18":"y","79":"y #4","80":"y #4","81":"y #4","83":"y #4","84":"y #4","85":"y #4","86":"y #4","87":"y #4"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n d #1","53":"n d #1","54":"n d #1","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"a #3","52":"a #3","53":"a #3","54":"a #3","55":"a #3","56":"a #3","57":"a #3","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y #4","66":"y #4","67":"y #4","68":"y #4","69":"y #4","70":"y #4","71":"y #4","72":"y #4","73":"y #4","74":"y #4","75":"y #4","76":"y #4","77":"y #4","78":"y #4","79":"y #4","80":"y #4","81":"y #4","83":"y #4","84":"y #4","85":"y #4","86":"y #4","87":"y #4","88":"y #4","89":"y #4","90":"y #4"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"a #3","39":"a #3","40":"a #3","41":"a #3","42":"a #3","43":"a #3","44":"a #3","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y #4","65":"y #4","66":"y #4","67":"y #4","68":"y #4","69":"y #4","70":"y #4","71":"y #4","72":"y #4","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y #4","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"a #3"},"samsung":{"4":"n","5.0-5.4":"a #3","6.2-6.4":"a #3","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y #4"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Enabled in Firefox by setting the `about:config` preference `dom.IntersectionObserver.enabled` to true","2":"\"Preliminary\" support as feature is still in development","3":"`isIntersecting` property of `IntersectionObserverEntry` was not implemented, returning `undefined`","4":"IntersectionObserver does not trigger its callback in a Chrome background tab"},"usage_perc_y":92.61,"usage_perc_a":1.4,"ucprefix":false,"parent":"","keywords":"","ie_id":"intersectionobserver","chrome_id":"5695342691483648","firefox_id":"intersection-observer","webkit_id":"specification-intersection-observer"},"intersectionobserver-v2":{"title":"IntersectionObserver V2","description":"Iteration on the original API that also reports if the element is covered by another element or has filters applied to it. Useful for blocking clickjacking attempts or tracking ad exposure.","spec":"https://szager-chromium.github.io/IntersectionObserver/","status":"unoff","links":[{"url":"https://developers.google.com/web/updates/2019/02/intersectionobserver-v2","title":"Google Web Docs - Intersection Observer V2"}],"categories":["DOM","JS API","Security"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":72.23,"usage_perc_a":0,"ucprefix":false,"parent":"intersectionobserver","keywords":".isVisible,isVisible","ie_id":"","chrome_id":"5878481493688320","firefox_id":"","webkit_id":""},"intl-pluralrules":{"title":"Intl.PluralRules API","description":"API for plural sensitive formatting and plural language rules.","spec":"https://tc39.es/ecma402/#sec-intl-pluralrules-constructor","status":"other","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/PluralRules","title":"MDN Web Docs: Intl.PluralRules"},{"url":"https://developers.google.com/web/updates/2017/10/intl-pluralrules","title":"Google Developers blog: The Intl.PluralRules API"}],"categories":["JS","JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n #1","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Intl.PluralRules exists, but methods are not implemented."},"usage_perc_y":91.01,"usage_perc_a":0,"ucprefix":false,"parent":"internationalization","keywords":"Intl,PluralRules","ie_id":"","chrome_id":"5653874773852160","firefox_id":"","webkit_id":""},"intrinsic-width":{"title":"Intrinsic & Extrinsic Sizing","description":"Allows for the heights and widths to be specified in intrinsic values using the `max-content`, `min-content`, `fit-content` and `stretch` (formerly `fill`) properties.","spec":"https://www.w3.org/TR/css3-sizing/","status":"wd","links":[{"url":"http://thenewcode.com/662/Design-From-the-Inside-Out-With-CSS-Min-Content","title":"Min-Content tutorial"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y #3 #4","80":"y #3 #4","81":"y #3 #4","83":"y #3 #4","84":"y #3 #4","85":"y #3 #4","86":"y #3 #4","87":"y #3 #4"},"firefox":{"2":"n","3":"a x #1 #2 #3","4":"a x #1 #2 #3","5":"a x #1 #2 #3","6":"a x #1 #2 #3","7":"a x #1 #2 #3","8":"a x #1 #2 #3","9":"a x #1 #2 #3","10":"a x #1 #2 #3","11":"a x #1 #2 #3","12":"a x #1 #2 #3","13":"a x #1 #2 #3","14":"a x #1 #2 #3","15":"a x #1 #2 #3","16":"a x #1 #2 #3","17":"a x #1 #2 #3","18":"a x #1 #2 #3","19":"a x #1 #2 #3","20":"a x #1 #2 #3","21":"a x #1 #2 #3","22":"a x #1 #2 #3","23":"a x #1 #2 #3","24":"a x #1 #2 #3","25":"a x #1 #2 #3","26":"a x #1 #2 #3","27":"a x #1 #2 #3","28":"a x #1 #2 #3","29":"a x #1 #2 #3","30":"a x #1 #2 #3","31":"a x #1 #2 #3","32":"a x #1 #2 #3","33":"a x #1 #2 #3","34":"a x #1 #2 #3","35":"a x #1 #2 #3","36":"a x #1 #2 #3","37":"a x #1 #2 #3","38":"a x #1 #2 #3","39":"a x #1 #2 #3","40":"a x #1 #2 #3","41":"a x #1 #2 #3","42":"a x #1 #2 #3","43":"a x #1 #2 #3","44":"a x #1 #2 #3","45":"a x #1 #2 #3","46":"a x #1 #2 #3","47":"a x #1 #2 #3","48":"a x #1 #2 #3","49":"a x #1 #2 #3","50":"a x #1 #2 #3","51":"a x #1 #2 #3","52":"a x #1 #2 #3","53":"a x #1 #2 #3","54":"a x #1 #2 #3","55":"a x #1 #2 #3","56":"a x #1 #2 #3","57":"a x #1 #2 #3","58":"a x #1 #2 #3","59":"a x #1 #2 #3","60":"a x #1 #2 #3","61":"a x #1 #2 #3","62":"a x #1 #2 #3","63":"a x #1 #2 #3","64":"a x #1 #2 #3","65":"a x #1 #2 #3","66":"a #2 #5","67":"a #2 #5","68":"a #2 #5","69":"a #2 #5","70":"a #2 #5","71":"a #2 #5","72":"a #2 #5","73":"a #2 #5","74":"a #2 #5","75":"a #2 #5","76":"a #2 #5","77":"a #2 #5","78":"a #2 #5","79":"a #2 #5","80":"a #2 #5","81":"a #2 #5","82":"a #2 #5","83":"a #2 #5","84":"a #2 #5","85":"a #2 #5","3.5":"a x #1 #2 #3","3.6":"a x #1 #2 #3"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"y x #3","23":"y x #3","24":"y x #3","25":"y x #3","26":"y x #3","27":"y x #3","28":"y x #3","29":"y x #3","30":"y x #3","31":"y x #3","32":"y x #3","33":"y x #3","34":"y x #3","35":"y x #3","36":"y x #3","37":"y x #3","38":"y x #3","39":"y x #3","40":"y x #3","41":"y x #3","42":"y x #3","43":"y x #3","44":"y x #3","45":"y x #3","46":"y #3 #4","47":"y #3 #4","48":"y #3 #4","49":"y #3 #4","50":"y #3 #4","51":"y #3 #4","52":"y #3 #4","53":"y #3 #4","54":"y #3 #4","55":"y #3 #4","56":"y #3 #4","57":"y #3 #4","58":"y #3 #4","59":"y #3 #4","60":"y #3 #4","61":"y #3 #4","62":"y #3 #4","63":"y #3 #4","64":"y #3 #4","65":"y #3 #4","66":"y #3 #4","67":"y #3 #4","68":"y #3 #4","69":"y #3 #4","70":"y #3 #4","71":"y #3 #4","72":"y #3 #4","73":"y #3 #4","74":"y #3 #4","75":"y #3 #4","76":"y #3 #4","77":"y #3 #4","78":"y #3 #4","79":"y #3 #4","80":"y #3 #4","81":"y #3 #4","83":"y #3 #4","84":"y #3 #4","85":"y #3 #4","86":"y #3 #4","87":"y #3 #4","88":"y #3 #4","89":"y #3 #4","90":"y #3 #4"},"safari":{"4":"n","5":"n","6":"n","7":"a x #1 #3","8":"a x #1 #3","9":"a x #3","10":"a x #3","11":"a #3","12":"a #3","13":"a #3","14":"a #3","3.1":"n","3.2":"n","5.1":"n","6.1":"a x #1 #3","7.1":"a x #1 #3","9.1":"a x #3","10.1":"a x #3","11.1":"a #3","12.1":"a #3","13.1":"a #3","TP":"a #3"},"opera":{"9":"n","11":"n","12":"n","15":"y x #3","16":"y x #3","17":"y x #3","18":"y x #3","19":"y x #3","20":"y x #3","21":"y x #3","22":"y x #3","23":"y x #3","24":"y x #3","25":"y x #3","26":"y x #3","27":"y x #3","28":"y x #3","29":"y x #3","30":"y x #3","31":"y x #3","32":"y x #3","33":"y #3 #4","34":"y #3","35":"y #3 #4","36":"y #3 #4","37":"y #3 #4","38":"y #3 #4","39":"y #3 #4","40":"y #3 #4","41":"y #3 #4","42":"y #3 #4","43":"y #3 #4","44":"y #3 #4","45":"y #3 #4","46":"y #3 #4","47":"y #3 #4","48":"y #3 #4","49":"y #3 #4","50":"y #3 #4","51":"y #3 #4","52":"y #3 #4","53":"y #3 #4","54":"y #3 #4","55":"y #3 #4","56":"y #3 #4","57":"y #3 #4","58":"y #3 #4","60":"y #3 #4","62":"y #3 #4","63":"y #3 #4","64":"y #3 #4","65":"y #3 #4","66":"y #3 #4","67":"y #3 #4","68":"y #3 #4","69":"y #3 #4","70":"y #3 #4","71":"y #3 #4","72":"y #3 #4","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a x #1 #3","14":"a x #3","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"a x #1 #3","8.1-8.4":"a x #1 #3","9.0-9.2":"a x #3","9.3":"a x #3","10.0-10.2":"a x #3","10.3":"a x #3","11.0-11.2":"a x #3","11.3-11.4":"a x #3","12.0-12.1":"a x #3","12.2-12.4":"a x #3","13.0-13.1":"a x #3","13.2":"a x #3","13.3":"a x #3","13.4-13.7":"a x #3"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y #3 #4","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y x #3","4.4.3-4.4.4":"y x #3"},"bb":{"7":"n","10":"y x #3"},"op_mob":{"10":"n","11":"n","12":"n","59":"y #3 #4","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y #3 #4"},"and_ff":{"82":"a x #2 #5"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y x #3","5.0-5.4":"y #3 #4","6.2-6.4":"y #3 #4","7.2-7.4":"y #3 #4","8.2":"y #3 #4","9.2":"y #3 #4","10.1":"y #3 #4","11.1-11.2":"y #3 #4","12.0":"y #3 #4"},"and_qq":{"10.4":"y x #3"},"baidu":{"7.12":"y #3 #4"},"kaios":{"2.5":"a x #1 #2 #3"}},"notes":"Prefixes are on the values, not the property names (e.g. -webkit-min-content)\r\n\r\nOlder webkit browsers also support the unofficial `intrinsic` value which acts the same as `max-content`.","notes_by_num":{"1":"Firefox does not support the `height`/`min-height`/`max-height` properties, only `width`. See [test case](https://codepen.io/shshaw/pen/Kiwaz), [Firefox bug](https://bugzilla.mozilla.org/show_bug.cgi?id=567039).","2":"Firefox supports the `-moz-available` keyword rather than `stretch`. [Firefox bug](https://bugzilla.mozilla.org/show_bug.cgi?id=1495868).","3":"Does not support the `flex-basis` property. See [specs](https://www.w3.org/TR/2015/WD-css-flexbox-1-20150514/#flex-basis-property), [Blink bug](https://codereview.chromium.org/1304853002/), [Firefox bug](https://bugzilla.mozilla.org/show_bug.cgi?id=1055887).","4":"Chrome does not yet unprefix `stretch` (aka `fill`/`fill-available`), because the [CSSWG](https://lists.w3.org/Archives/Public/www-style/2015Aug/0127.html) is not ready for that yet. See [Chromium bug](https://chromium.googlesource.com/chromium/blink.git/+/bf119cdfece210e69c9a99af06f1b9981e2a1bc2).","5":"While still being affected by note 1, it is only for `-moz-fit-content` and `-moz-available`."},"usage_perc_y":75.84,"usage_perc_a":20.7,"ucprefix":false,"parent":"","keywords":"fill,fill-available,max-content,min-content,fit-content,contain-floats,intrinsic,extrinsic,sizing","ie_id":"cssintrinsicsizing","chrome_id":"5901353784180736","firefox_id":"","webkit_id":""},"jpeg2000":{"title":"JPEG 2000 image format","description":"JPEG 2000 (JP2) was created by the Joint Photographic Experts Group committee in 2000 with the intention of superseding their original discrete cosine transform-based JPEG standard (created in 1992) with a newly designed, wavelet-based method. It offers some advantages in image fidelity over standard JPEG.","spec":"https://www.itu.int/rec/T-REC-T.800-200208-I","status":"other","links":[{"url":"https://en.wikipedia.org/wiki/JPEG_2000","title":"Wikipedia article"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"y #1","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y #1","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Not supported by Safari for Windows"},"usage_perc_y":16.64,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"jp2,jpeg2000,jpeg 2000","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"jpegxr":{"title":"JPEG XR image format","description":"The latest JPEG image format of Joint Photographic Experts Group which boasts better compression and supports lossless compression, alpha channel, and 48-bit deep color over normal jpg format.","spec":"https://www.itu.int/rec/T-REC-T.832","status":"other","links":[{"url":"https://docs.microsoft.com/en-us/windows/win32/wic/jpeg-xr-codec","title":"Microsoft JPEG XR Codec Overview"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=500500","title":"Firefox support bug"},{"url":"https://code.google.com/p/chromium/issues/detail?id=56908","title":"Chrome support bug (marked as WONTFIX)"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":1.74,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"jpeg-xr","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"js-regexp-lookbehind":{"title":"Lookbehind in JS regular expressions","description":"Zero-width assertion that ensures a pattern is preceded by another pattern in a JavaScript regular expression.","spec":"https://tc39.es/ecma262/#sec-assertion","status":"other","links":[{"url":"https://2ality.com/2017/05/regexp-lookbehind-assertions.html","title":"Blog post on lookbehind assertions"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1225665","title":"Firefox implementation bug"},{"url":"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions/Assertions","title":"MDN: Regular Expressions Assertions"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":78.02,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"json":{"title":"JSON parsing","description":"Method of converting JavaScript objects to JSON strings and JSON back to objects using JSON.stringify() and JSON.parse()","spec":"https://www.ecma-international.org/ecma-262/5.1/#sec-15.12","status":"other","links":[{"url":"https://developer.mozilla.org/En/Using_native_JSON","title":"MDN Web Docs - Using JSON"},{"url":"http://www.json.org/js.html","title":"JSON in JS (includes script w/support)"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/json.js#json","title":"has.js test"},{"url":"https://www.webplatform.org/docs/apis/json","title":"WebPlatform Docs"},{"url":"https://www.json.org/","title":"JSON explainer"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"y #1","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Requires document to be in IE8+ [standards mode](http://msdn.microsoft.com/en-us/library/cc288325%28VS.85%29.aspx) to work in IE8."},"usage_perc_y":99.63,"usage_perc_a":0,"ucprefix":false,"parent":"es5","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"justify-content-space-evenly":{"title":"CSS justify-content: space-evenly","description":"The \"space-evenly\" value for the `justify-content` property distributes the space between items evenly. It is similar to space-around but provides equal instead of half-sized space on the edges. Can be used in both CSS flexbox & grid.","spec":"https://drafts.csswg.org/css-align-3/#valdef-align-content-space-evenly","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/justify-content","title":"MDN on justify-content property"},{"url":"https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/15947692/","title":"Edge support bug"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"a #1","17":"a #1","18":"a #1","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"a #1","58":"a #1","59":"a #1","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"a #1","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"a #1","45":"a #1","46":"a #1","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"a #1","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"a #1"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"a #1","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"a #1"}},"notes":"","notes_by_num":{"1":"Supported in CSS Grid, but not Flexbox"},"usage_perc_y":92.89,"usage_perc_a":2.05,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"kerning-pairs-ligatures":{"title":"High-quality kerning pairs & ligatures","description":"When used in HTML, the unofficial `text-rendering: optimizeLegibility` CSS property enables high-quality kerning and ligatures in certain browsers. Newer browsers have this behavior enabled by default.","spec":"https://www.w3.org/TR/SVG2/painting.html#TextRendering","status":"unoff","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/text-rendering","title":"MDN Web Docs - CSS text-rendering"},{"url":"https://css-tricks.com/almanac/properties/t/text-rendering/","title":"CSS Tricks article"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"u","4.0-4.1":"u","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"a #1","4":"a #1","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"a #1","4.2-4.3":"a #1","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"The `text-rendering` property is specified in SVG, though behavior there is not related to kerning pairs & ligatures.","notes_by_num":{"1":"Partial support in Android browser versions is due to a serious bug where `text-rendering: optimizeLegibility` causes custom web fonts to not render."},"usage_perc_y":97.11,"usage_perc_a":0.06,"ucprefix":false,"parent":"","keywords":"optimizeLegibility,optimizeSpeed,geometricPrecision","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"keyboardevent-charcode":{"title":"KeyboardEvent.charCode","description":"A legacy `KeyboardEvent` property that gives the Unicode codepoint number of a character key pressed during a `keypress` event.","spec":"https://w3c.github.io/uievents/#dom-keyboardevent-charcode","status":"unoff","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/charCode","title":"MDN Web Docs - charCode"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"u","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"u","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"u","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"u","2.2":"u","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"n","12":"u","59":"n #1","11.1":"n","11.5":"n","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"n #1"},"ie_mob":{"10":"n #1","11":"n #1"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"This property is legacy and deprecated.\n[\"Some key events, or their values, might be suppressed by the IME in use\"](https://www.w3.org/TR/2019/WD-uievents-20190530/#keys-IME). On mobile (virtual keyboard), all keys are reported as 0.","notes_by_num":{"1":"Does not appear to support the `keypress` event at all"},"usage_perc_y":98.35,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"keyboard,event,key,char,character,code,charCode","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"keyboardevent-code":{"title":"KeyboardEvent.code","description":"A `KeyboardEvent` property representing the physical key that was pressed, ignoring the keyboard layout and ignoring whether any modifier keys were active.","spec":"https://www.w3.org/TR/uievents/#dom-keyboardevent-code","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/code","title":"MDN Web Docs - code"},{"url":"https://code.google.com/p/chromium/issues/detail?id=227231","title":"Chrome tracking bug"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=149584","title":"WebKit feature request bug"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n d #1","43":"n d #1","44":"n d #1","45":"n d #1","46":"n d #1","47":"n d #1","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n d #1","30":"n d #1","31":"n d #1","32":"n d #1","33":"n d #1","34":"n d #1","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n d #1","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n d #1"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n d #1","6.2-6.4":"n d #1","7.2-7.4":"n d #1","8.2":"n d #1","9.2":"n d #1","10.1":"n d #1","11.1-11.2":"n d #1","12.0":"n d #1"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n d #1"},"kaios":{"2.5":"y"}},"notes":"[\"Some key events, or their values, might be suppressed by the IME in use\"](https://www.w3.org/TR/2019/WD-uievents-20190530/#keys-IME). On mobile (virtual keyboard), all keys are reported as empty (\"\").","notes_by_num":{"1":"Enabled in Chrome & Opera through the \"experimental Web Platform features\" flag"},"usage_perc_y":57.07,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"keyboard,event,code","ie_id":"uieventskeyboardqueryapis","chrome_id":"5228092293382144","firefox_id":"","webkit_id":""},"keyboardevent-getmodifierstate":{"title":"KeyboardEvent.getModifierState()","description":"`KeyboardEvent` method that returns the state (whether the key is pressed/locked or not) of the given modifier key.","spec":"https://www.w3.org/TR/uievents/#dom-keyboardevent-getmodifierstate","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/getModifierState","title":"MDN Web Docs - getModifierState"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=40999","title":"WebKit feature request bug"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"u","15":"n","16":"n","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"y"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"u","59":"y","11.1":"n","11.5":"n","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":97.64,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"keyboard,event,get,modifier,state","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"keyboardevent-key":{"title":"KeyboardEvent.key","description":"A `KeyboardEvent` property whose value is a string identifying the key that was pressed. Covers character keys, non-character keys (e.g. arrow keys), and dead keys.","spec":"https://www.w3.org/TR/uievents/#dom-keyboardevent-key","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key","title":"MDN Web Docs - key"},{"url":"https://code.google.com/p/chromium/issues/detail?id=227231","title":"Chrome tracking bug"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=69029","title":"WebKit feature request bug"},{"url":"https://www.w3.org/TR/DOM-Level-3-Events-key/","title":"Spec listing all key string values"},{"url":"https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/","title":"Edge bug report"},{"url":"https://github.com/shvaikalesh/shim-keyboard-event-key","title":"shim-keyboard-event-key: shim for non-standard key identifiers for IE & Edge"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"a #2","10":"a #2","11":"a #2","5.5":"n"},"edge":{"12":"a #2","13":"a #2","14":"a #2","15":"a #2","16":"a #2","17":"a #2","18":"a #2","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"u","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"y"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"u","59":"u","11.1":"n","11.5":"n","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #2","11":"a #2"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"[\"Some key events, or their values, might be suppressed by the IME in use\"](https://www.w3.org/TR/2019/WD-uievents-20190530/#keys-IME). On mobile (virtual keyboard), for every key Blink and WebKit based browsers report \"Unidentified\", Gecko reports \"Process\".","notes_by_num":{"1":"Partial support refers to these versions of Firefox returning `\"MozPrintableKey\"` for all character keys.","2":"Has non-standard key identifiers and incorrect behaviour with AltGraph."},"usage_perc_y":95.59,"usage_perc_a":1.78,"ucprefix":false,"parent":"","keywords":"keyboard,event,key","ie_id":"","chrome_id":"4748790720364544","firefox_id":"","webkit_id":""},"keyboardevent-location":{"title":"KeyboardEvent.location","description":"A `KeyboardEvent` property that indicates the location of the key on the input device. Useful when there are more than one physical key for the same logical key (e.g. left or right \"Control\" key; main or numpad \"1\" key).","spec":"https://www.w3.org/TR/uievents/#dom-keyboardevent-location","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/location","title":"MDN Web Docs - location"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a #1","5":"a #1","6":"u","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"u","5.1":"a #1","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"u","15":"a #1","16":"a #1","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"a #1","6.0-6.1":"a #1","7.0-7.1":"a #1","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"a #1","4":"a #1","81":"y","2.1":"u","2.2":"u","2.3":"a #1","4.1":"a #1","4.2-4.3":"a #1","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"a #1","10":"a #1"},"op_mob":{"10":"n","11":"n","12":"u","59":"y","11.1":"n","11.5":"n","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Only supports `KeyboardEvent.keyLocation` from an older draft of the DOM Level 3 Events spec instead."},"usage_perc_y":98.12,"usage_perc_a":0.4,"ucprefix":false,"parent":"","keywords":"keyboard,event,key,location,keyLocation,numpad","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"keyboardevent-which":{"title":"KeyboardEvent.which","description":"A legacy `KeyboardEvent` property that is equivalent to either `KeyboardEvent.keyCode` or `KeyboardEvent.charCode` depending on whether the key is alphanumeric.","spec":"https://w3c.github.io/uievents/#dom-uievent-which","status":"unoff","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/which","title":"MDN Web Docs - which"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"u","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"u","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"u","2.2":"u","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"a #1","4.4.3-4.4.4":"a #1"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"a #1","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"a #1"},"and_ff":{"82":"a #1"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"a #1","6.2-6.4":"a #1","7.2-7.4":"a #1","8.2":"a #1","9.2":"a #1","10.1":"a #1","11.1-11.2":"a #1","12.0":"a #1"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"a #1"},"kaios":{"2.5":"y"}},"notes":"This property is legacy and deprecated.\n[\"Some key events, or their values, might be suppressed by the IME in use\"](https://www.w3.org/TR/2019/WD-uievents-20190530/#keys-IME). On mobile (virtual keyboard), all keys are reported as 229.","notes_by_num":{"1":"`event.which` number for keys does not always match expected value (difference may be dependent on hardware vs. on-screen keyboard?). "},"usage_perc_y":61.46,"usage_perc_a":36.97,"ucprefix":false,"parent":"","keywords":"keyboard,event,which","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"lazyload":{"title":"Resource Hints: Lazyload","description":"Gives a hint to the browser to lower the loading priority of a resource. Please note that this is a legacy attribute, see the [`loading`](https://caniuse.com/#feat=loading-lazy-attr) attribute for the new standardized API.","spec":"https://w3c.github.io/web-performance/specs/ResourcePriorities/Overview.html","status":"unoff","links":[{"url":"https://msdn.microsoft.com/en-us/ie/dn369270(v=vs.94)","title":"lazyload attribute | lazyload property"},{"url":"https://github.com/whatwg/html/issues/2806","title":"Discussion on standardization"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"y"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":1.5,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"let":{"title":"let","description":"Declares a variable with block level scope","spec":"https://tc39.es/ecma262/#sec-let-and-const-declarations","status":"other","links":[{"url":"https://generatedcontent.org/post/54444832868/variables-and-constants-in-es6","title":"Variables and Constants in ES6"},{"url":"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/let","title":"MDN Web Docs - let"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"a #5","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n d #1","3":"n d #1","4":"n d #1","5":"n d #1","6":"n d #1","7":"n d #1","8":"n d #1","9":"n d #1","10":"n d #1","11":"n d #1","12":"n d #1","13":"n d #1","14":"n d #1","15":"n d #1","16":"n d #1","17":"n d #1","18":"n d #1","19":"n d #1","20":"n d #1","21":"n d #1","22":"n d #1","23":"n d #1","24":"n d #1","25":"n d #1","26":"n d #1","27":"n d #1","28":"n d #1","29":"n d #1","30":"n d #1","31":"n d #1","32":"n d #1","33":"n d #1","34":"n d #1","35":"n d #1","36":"n d #1","37":"n d #1","38":"n d #1","39":"n d #1","40":"n d #1","41":"n d #1","42":"n d #1","43":"n d #1","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n d #1","3.6":"n d #1"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n d #2","20":"n d #2","21":"n d #2","22":"n d #2","23":"n d #2","24":"n d #2","25":"n d #2","26":"n d #2","27":"n d #2","28":"n d #2","29":"n d #2","30":"n d #2","31":"n d #2","32":"n d #2","33":"n d #2","34":"n d #2","35":"n d #2","36":"n d #2","37":"n d #2","38":"n d #2","39":"n d #2","40":"n d #2","41":"a #3","42":"a #3","43":"a #3","44":"a #3","45":"a #3","46":"a #3","47":"a #3","48":"a #3","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"a #4","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"a #4","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n d #2","16":"n d #2","17":"n d #2","18":"n d #2","19":"n d #2","20":"n d #2","21":"n d #2","22":"n d #2","23":"n d #2","24":"n d #2","25":"n d #2","26":"n d #2","27":"n d #2","28":"a #3","29":"a #3","30":"a #3","31":"a #3","32":"a #3","33":"a #3","34":"a #3","35":"a #3","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"a #4","10.3":"a #4","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"a #3","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"a #3"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Supports a non-standard version that can only be used in script elements with a type attribute of `application/javascript;version=1.7`. As other browsers do not support these types of `script` tags this makes support useless for cross-browser support.","2":"Requires the ‘Experimental JavaScript features’ flag to be enabled","3":"Only supported in strict mode","4":"`let` bindings in for loops are incorrectly treated as function-scoped instead of block scoped.","5":"`let` variables are not bound separately to each iteration of `for` loops"},"usage_perc_y":95.14,"usage_perc_a":1.85,"ucprefix":false,"parent":"es6","keywords":"ES6,variable,block,scope","ie_id":"","chrome_id":"4645595339816960","firefox_id":"","webkit_id":""},"link-icon-png":{"title":"PNG favicons","description":"Icon used by browsers to identify a webpage or site. While all browsers support the `.ico` format, the PNG format can be preferable.","spec":"https://html.spec.whatwg.org/multipage/semantics.html#rel-icon","status":"ls","links":[{"url":"https://css-tricks.com/favicon-quiz/","title":"Detailed info on favicons for various uses"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y #1","80":"y #1","81":"y #1","83":"y #1","84":"y #1","85":"y #1","86":"y #1","87":"y #1"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y #1","5":"y #1","6":"y #1","7":"y #1","8":"y #1","9":"y #1","10":"y #1","11":"y #1","12":"y #1","13":"y #1","14":"y #1","15":"y #1","16":"y #1","17":"y #1","18":"y #1","19":"y #1","20":"y #1","21":"y #1","22":"y #1","23":"y #1","24":"y #1","25":"y #1","26":"y #1","27":"y #1","28":"y #1","29":"y #1","30":"y #1","31":"y #1","32":"y #1","33":"y #1","34":"y #1","35":"y #1","36":"y #1","37":"y #1","38":"y #1","39":"y #1","40":"y #1","41":"y #1","42":"y #1","43":"y #1","44":"y #1","45":"y #1","46":"y #1","47":"y #1","48":"y #1","49":"y #1","50":"y #1","51":"y #1","52":"y #1","53":"y #1","54":"y #1","55":"y #1","56":"y #1","57":"y #1","58":"y #1","59":"y #1","60":"y #1","61":"y #1","62":"y #1","63":"y #1","64":"y #1","65":"y #1","66":"y #1","67":"y #1","68":"y #1","69":"y #1","70":"y #1","71":"y #1","72":"y #1","73":"y #1","74":"y #1","75":"y #1","76":"y #1","77":"y #1","78":"y #1","79":"y #1","80":"y #1","81":"y #1","83":"y #1","84":"y #1","85":"y #1","86":"y #1","87":"y #1","88":"y #1","89":"y #1","90":"y #1"},"safari":{"4":"y #2","5":"y #2","6":"y #2","7":"y #2","8":"y #2","9":"y #2","10":"y #2","11":"y #2","12":"y #2","13":"y #2","14":"y #2","3.1":"y #2","3.2":"y #2","5.1":"y #2","6.1":"y #2","7.1":"y #2","9.1":"y #2","10.1":"y #2","11.1":"y #2","12.1":"y #2","13.1":"y #2","TP":"y #2"},"opera":{"9":"y #3","11":"y #3","12":"y #3","15":"y #1","16":"y #1","17":"y #1","18":"y #1","19":"y #1","20":"y #1","21":"y #1","22":"y #1","23":"y #1","24":"y #1","25":"y #1","26":"y #1","27":"y #1","28":"y #1","29":"y #1","30":"y #1","31":"y #1","32":"y #1","33":"y #1","34":"y #1","35":"y #1","36":"y #1","37":"y #1","38":"y #1","39":"y #1","40":"y #1","41":"y #1","42":"y #1","43":"y #1","44":"y #1","45":"y #1","46":"y #1","47":"y #1","48":"y #1","49":"y #1","50":"y #1","51":"y #1","52":"y #1","53":"y #1","54":"y #1","55":"y #1","56":"y #1","57":"y #1","58":"y #1","60":"y #1","62":"y #1","63":"y #1","64":"y #1","65":"y #1","66":"y #1","67":"y #1","68":"y #1","69":"y #1","70":"y #1","71":"y #1","72":"y #1","9.5-9.6":"y #3","10.0-10.1":"y #3","10.5":"y #3","10.6":"y #3","11.1":"y #3","11.5":"y #3","11.6":"y #3","12.1":"y #3"},"ios_saf":{"8":"n #4","14":"n #4","3.2":"n #4","4.0-4.1":"n #4","4.2-4.3":"n #4","5.0-5.1":"n #4","6.0-6.1":"n #4","7.0-7.1":"n #4","8.1-8.4":"n #4","9.0-9.2":"n #4","9.3":"n #4","10.0-10.2":"n #4","10.3":"n #4","11.0-11.2":"n #4","11.3-11.4":"n #4","12.0-12.1":"n #4","12.2-12.4":"n #4","13.0-13.1":"n #4","13.2":"n #4","13.3":"n #4","13.4-13.7":"n #4"},"op_mini":{"all":"n #4"},"android":{"3":"y","4":"y","81":"y #3","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y #3","4.4.3-4.4.4":"y #3"},"bb":{"7":"y","10":"n #4"},"op_mob":{"10":"n #4","11":"n #4","12":"n #4","59":"n #4","11.1":"n #4","11.5":"n #4","12.1":"n #4"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n #4","11":"n #4"},"and_uc":{"12.12":"y #2"},"samsung":{"4":"y #3","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y #1"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Win8/IE10+ and iOS Safari support other types of icons for webpages too, using alternate tags.\r\n\r\nSee also [SVG favicons](#feat=link-icon-svg).","notes_by_num":{"1":"If both ICO and PNG are available, will use ICO over PNG if ICO has better matching sizes set.","2":"If both ICO and PNG are available, will ALWAYS use ICO file, regardless of sizes set.","3":"If multiple formats are available, will use the last one loaded, regardless of sizes (effectively picks at random).","4":"Does not use favicons at all (but may have alternative for bookmarks, etc.)."},"usage_perc_y":86.11,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"link-icon-svg":{"title":"SVG favicons","description":"Icon used by browsers to identify a webpage or site. While all browsers support the `.ico` format, the SVG format can be preferable to more easily support higher resolutions or larger icons.","spec":"https://html.spec.whatwg.org/multipage/semantics.html#rel-icon","status":"ls","links":[{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=294179","title":"Chrome bug"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=366324#c50","title":"Firefox bug, highlights comment that confirms note #4"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6509196-svg-favicons","title":"Microsoft Edge feature request on UserVoice"},{"url":"https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/18357657/","title":"Microsoft EdgeHTML issue tracker: Issue #18357657: Support SVG favicons"}],"categories":["HTML5","SVG"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"y #4 #5","81":"y #4 #5","83":"y #4 #5","84":"y #4 #5","85":"y #4 #5","86":"y #4 #5","87":"y #4 #5"},"firefox":{"2":"n","3":"n","4":"a #2","5":"a #2","6":"a #2","7":"a #2","8":"a #2","9":"a #2","10":"a #2","11":"a #2","12":"a #2","13":"a #2","14":"a #2","15":"a #2","16":"a #2","17":"a #2","18":"a #2","19":"a #2","20":"a #2","21":"a #2","22":"a #2","23":"a #2","24":"a #2","25":"a #2","26":"a #2","27":"a #2","28":"a #2","29":"a #2","30":"a #2","31":"a #2","32":"a #2","33":"a #2","34":"a #2","35":"a #2","36":"a #2","37":"a #2","38":"a #2","39":"a #2","40":"a #2","41":"y #4","42":"y #4","43":"y #4","44":"y #4","45":"y #4","46":"y #4","47":"y #4","48":"y #4","49":"y #4","50":"y #4","51":"y #4","52":"y #4","53":"y #4","54":"y #4","55":"y #4","56":"y #4","57":"y #4","58":"y #4","59":"y #4","60":"y #4","61":"y #4","62":"y #4","63":"y #4","64":"y #4","65":"y #4","66":"y #4","67":"y #4","68":"y #4","69":"y #4","70":"y #4","71":"y #4","72":"y #4","73":"y #4","74":"y #4","75":"y #4","76":"y #4","77":"y #4","78":"y #4","79":"y #4","80":"y #4","81":"y #4","82":"y #4","83":"y #4","84":"y #4","85":"y #4","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"y #4 #5","81":"y #4 #5","83":"y #4 #5","84":"y #4 #5","85":"y #4 #5","86":"y #4 #5","87":"y #4 #5","88":"y #4 #5","89":"y #4 #5","90":"y #4 #5"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"a #3","10":"a #3","11":"a #3","12":"a #3","13":"a #3","14":"a #3","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"a #3","10.1":"a #3","11.1":"a #3","12.1":"a #3","13.1":"a #3","TP":"a #3"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"y #4 #5","68":"y #4 #5","69":"y #4 #5","70":"y #4 #5","71":"y #4 #5","72":"y #4 #5","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n #1","14":"a #3","3.2":"n #1","4.0-4.1":"n #1","4.2-4.3":"n #1","5.0-5.1":"n #1","6.0-6.1":"n #1","7.0-7.1":"n #1","8.1-8.4":"n #1","9.0-9.2":"a #3","9.3":"a #3","10.0-10.2":"a #3","10.3":"a #3","11.0-11.2":"a #3","11.3-11.4":"a #3","12.0-12.1":"a #3","12.2-12.4":"a #3","13.0-13.1":"a #3","13.2":"a #3","13.3":"a #3","13.4-13.7":"a #3"},"op_mini":{"all":"n #1"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n #1"},"op_mob":{"10":"n #1","11":"n #1","12":"n #1","59":"n #1","11.1":"n #1","11.5":"n #1","12.1":"n #1"},"and_chr":{"86":"y #4 #5"},"and_ff":{"82":"n"},"ie_mob":{"10":"n #1","11":"n #1"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y #4"}},"notes":"See also [PNG favicons](#feat=link-icon-png).","notes_by_num":{"1":"Does not use favicons at all","2":"Partial support in Firefox before version 41 refers to only loading the SVG favicon the first time, but not [on subsequent loads](https://bugzilla.mozilla.org/show_bug.cgi?id=366324#c14).","3":"Safari 9+ has support for \"[pinned tab](https://developer.apple.com/library/prerelease/content/releasenotes/General/WhatsNewInSafari/Articles/Safari_9_0.html#//apple_ref/doc/uid/TP40014305-CH9-SW20)\" SVG icons, but this requires an unofficial `rel=\"mask-icon\"` to be set and only works for all-black icons on Pinned Tabs.","4":"Requires the served mime-type to be 'image/svg+xml'.","5":"Chromium browsers serve the SVG in [secure static mode](https://svgwg.org/svg2-draft/conform.html#secure-static-mode), but apply SMIL animations using the document start time (0)."},"usage_perc_y":72.56,"usage_perc_a":16.65,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"5180316371124224","firefox_id":"","webkit_id":""},"link-rel-dns-prefetch":{"title":"Resource Hints: dns-prefetch","description":"Gives a hint to the browser to perform a DNS lookup in the background to improve performance. This is indicated using `<link rel=\"dns-prefetch\" href=\"https://example.com/\">`","spec":"https://www.w3.org/TR/resource-hints/#dns-prefetch","status":"wd","links":[{"url":"https://msdn.microsoft.com/en-us/library/dn265039(v=vs.85).aspx","title":"Prerender and prefetch support"},{"url":"https://developer.mozilla.org/en-US/docs/Web/HTTP/Controlling_DNS_prefetching","title":"Controlling DNS prefetching"},{"url":"https://www.ctrl.blog/entry/dns-prefetch-preconnect.html","title":"What to <link rel=dns-prefetch> and when to use `preconnect` instead"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"a #1","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a #2","5":"a #2","6":"a #2","7":"a #2","8":"a #2","9":"a #2","10":"a #2","11":"a #2","12":"a #2","13":"a #2","14":"a #2","15":"a #2","16":"a #2","17":"a #2","18":"a #2","19":"a #2","20":"a #2","21":"a #2","22":"a #2","23":"a #2","24":"a #2","25":"a #2","26":"a #2","27":"a #2","28":"a #2","29":"a #2","30":"a #2","31":"a #2","32":"a #2","33":"a #2","34":"a #2","35":"a #2","36":"a #2","37":"a #2","38":"a #2","39":"a #2","40":"a #2","41":"a #2","42":"a #2","43":"a #2","44":"a #2","45":"a #2","46":"a #2","47":"a #2","48":"a #2","49":"a #2","50":"a #2","51":"a #2","52":"a #2","53":"a #2","54":"a #2","55":"a #2","56":"a #2","57":"a #2","58":"a #2","59":"a #2","60":"a #2","61":"a #2","62":"a #2","63":"a #2","64":"a #2","65":"a #2","66":"a #2","67":"a #2","68":"a #2","69":"a #2","70":"a #2","71":"a #2","72":"a #2","73":"a #2","74":"a #2","75":"a #2","76":"a #2","77":"a #2","78":"a #2","79":"a #2","80":"a #2","81":"a #2","82":"a #2","83":"a #2","84":"a #2","85":"a #2","3.5":"a #2","3.6":"a #2"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"u","14":"u","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"u","6.0-6.1":"u","7.0-7.1":"u","8.1-8.4":"u","9.0-9.2":"u","9.3":"u","10.0-10.2":"u","10.3":"u","11.0-11.2":"u","11.3-11.4":"u","12.0-12.1":"u","12.2-12.4":"u","13.0-13.1":"u","13.2":"u","13.3":"u","13.4-13.7":"u"},"op_mini":{"all":"n"},"android":{"3":"u","4":"u","81":"u","2.1":"u","2.2":"u","2.3":"u","4.1":"u","4.2-4.3":"u","4.4":"u","4.4.3-4.4.4":"u"},"bb":{"7":"u","10":"u"},"op_mob":{"10":"u","11":"u","12":"u","59":"u","11.1":"u","11.5":"u","12.1":"u"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"y"},"and_uc":{"12.12":"u"},"samsung":{"4":"u","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"IE9 [supported `dns-prefetch` as `prefetch`](https://blogs.msdn.com/b/ieinternals/archive/2012/03/01/ie10-beta-consumer-preview-minor-changes-changelist.aspx) as the former wasn’t defined yet.","2":"Firefox only supports `dns-prefetch` on HTTP origins. HTTPS is unsupported."},"usage_perc_y":80.51,"usage_perc_a":4.16,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"link-rel-modulepreload":{"title":"Resource Hints: modulepreload","description":"Using `<link rel=\"modulepreload\">`, browsers can be informed to prefetch module scripts without having to execute them, allowing fine-grained control over when and how module resources are loaded.","spec":"https://html.spec.whatwg.org/multipage/links.html#link-type-modulepreload","status":"ls","links":[{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1425310","title":"Gecko implementation bug"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=180574","title":"WebKit implementation bug"},{"url":"https://developers.google.com/web/updates/2017/12/modulepreload","title":"Preloading modules"},{"url":"https://jasonformat.com/modern-script-loading/","title":"Modern Script Loading"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"u"},"baidu":{"7.12":"u"},"kaios":{"2.5":"n"}},"notes":"Unlike some other link relations, changing the relevant attributes (such as as, crossorigin, and referrerpolicy) of such a link does not trigger a new fetch. This is because the document's module map has already been populated by a previous fetch, and so re-fetching would be pointless.","notes_by_num":{},"usage_perc_y":73.01,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"5762805915451392","firefox_id":"","webkit_id":""},"link-rel-preconnect":{"title":"Resource Hints: preconnect","description":"Gives a hint to the browser to begin the connection handshake (DNS, TCP, TLS) in the background to improve performance. This is indicated using `<link rel=\"preconnect\" href=\"https://example-domain.com/\">`","spec":"https://www.w3.org/TR/resource-hints/#preconnect","status":"wd","links":[{"url":"https://www.igvita.com/2015/08/17/eliminating-roundtrips-with-preconnect/","title":"Eliminating Roundtrips with Preconnect"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"a #2","16":"a #2","17":"a #2","18":"a #2","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"y #1","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"u"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"u"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Firefox 39 did not support 'crossorigin' attribute and preconnects were not processed by the preload parser. Both of these features were enabled in Firefox 41.","2":"Partial support in Edge 15+ refers to support for only the HTTP header format, not the `<link rel>` format.","3":"Appears to have [stopped working](https://bugzilla.mozilla.org/show_bug.cgi?id=1543990) in Firefox at some point."},"usage_perc_y":89.98,"usage_perc_a":0.37,"ucprefix":false,"parent":"","keywords":"preconnect, resource hints","ie_id":"preconnectresourcehints","chrome_id":"5560623895150592","firefox_id":"","webkit_id":""},"link-rel-prefetch":{"title":"Resource Hints: prefetch","description":"Informs the browsers that a given resource should be prefetched so it can be loaded more quickly. This is indicated using `<link rel=\"prefetch\" href=\"(url)\">`","spec":"https://www.w3.org/TR/resource-hints/#dfn-prefetch","status":"wd","links":[{"url":"https://en.wikipedia.org/wiki/Link_prefetching","title":"Wikipedia article"},{"url":"https://medium.com/@luisvieira_gmr/html5-prefetch-1e54f6dda15d","title":"Article on prefetch and other hints"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n d #1","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n d #1","TP":"n d #1"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n d #1","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n d #1"},"op_mini":{"all":"n"},"android":{"3":"n","4":"y","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Can be enabled in Safari as `LinkPrefetch` in the developer menu"},"usage_perc_y":81.7,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"link-rel-preload":{"title":"Resource Hints: preload","description":"Using `<link rel=\"preload\">`, browsers can be informed to prefetch resources without having to execute them, allowing fine-grained control over when and how resources are loaded.","spec":"https://w3c.github.io/preload/","status":"cr","links":[{"url":"https://www.smashingmagazine.com/2016/02/preload-what-is-it-good-for/","title":"Preload: What Is It Good For?"},{"url":"https://developer.mozilla.org/en-US/docs/Web/HTML/Preloading_content","title":"MDN Web Docs - Preloading content with rel=\"preload\""},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=Rel%3Dpreload","title":"Firefox meta support bug"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"a #4","18":"a #4","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"a #1","57":"n d #3","58":"n d #3","59":"n d #3","60":"n d #3","61":"n d #3","62":"n d #3","63":"n d #3","64":"n d #3","65":"n d #3","66":"n d #3","67":"n d #3","68":"n d #3","69":"n d #3","70":"n d #3","71":"n d #3","72":"n d #3","73":"n d #3","74":"n d #3","75":"n d #3","76":"n d #3","77":"n d #3","78":"n d #3","79":"n d #3","80":"n d #3","81":"n d #3","82":"n d #3","83":"n d #3","84":"n d #3","85":"n d #3","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n d #2","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n d #2","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n d #3"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"Firefox has newly rewritten their implementation and plans to enable it by default in a version closely succeeding 78","notes_by_num":{"1":"Only cachable resources can be preloaded. This includes the following `as` values: script, style, image, video, audio, track, fetch, and font (note font/collection is not supported).","2":"Can be enabled via the \"Experimental Features\" developer menu","3":"Disabled by default behind the `network.preload` flag.","4":"Partial support in Edge 17+ refers to support for only the HTML `<link rel>` format, not the HTTP header format."},"usage_perc_y":89.03,"usage_perc_a":0.36,"ucprefix":false,"parent":"","keywords":"","ie_id":"preload","chrome_id":"5757468554559488","firefox_id":"link-rel-preload","webkit_id":"specification-preload"},"link-rel-prerender":{"title":"Resource Hints: prerender","description":"Gives a hint to the browser to render the specified page in the background, speeding up page load if the user navigates to it. This is indicated using `<link rel=\"prerender\" href=\"(url)\">`","spec":"https://www.w3.org/TR/resource-hints/#prerender","status":"wd","links":[{"url":"https://msdn.microsoft.com/en-us/library/dn265039(v=vs.85).aspx","title":"Prerender and prefetch support"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=730101","title":"Firefox implementation bug"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"y"},"and_uc":{"12.12":"n"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"Chrome treats the prerender hint as a [NoState Prefetch](https://developers.google.com/web/updates/2018/07/nostate-prefetch) instead, and unlike a full prerender it wont execute JavaScript or render any part of the page in advance.","notes_by_num":{},"usage_perc_y":75.52,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"loading-lazy-attr":{"title":"Lazy loading via attribute for images & iframes","description":"The `loading` attributing on images & iframes gives authors control over when the browser should start loading the resource. ","spec":"https://html.spec.whatwg.org/multipage/urls-and-fetching.html#lazy-loading-attributes","status":"ls","links":[{"url":"https://addyosmani.com/blog/lazy-loading/","title":"Blog post"},{"url":"https://github.com/scott-little/lazyload","title":"Explainer"},{"url":"https://webkit.org/b/196698","title":"WebKit support bug"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1622090","title":"Firefox support bug for lazy loading iframes"},{"url":"https://github.com/mfranzke/loading-attribute-polyfill","title":"Polyfill"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"a #1","76":"a #1","77":"a #1","78":"a #1","79":"a #1","80":"a #1","81":"a #1","82":"a #1","83":"a #1","84":"a #1","85":"a #1","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n d","76":"n d","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n d #2","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n d #2","TP":"n d #2"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n d","63":"n d","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n d #2","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n d #2"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"a #1"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Firefox only supports lazy loading for images","2":"Can be enabled in Settings under the Safari > Advanced > Experimental Features menu."},"usage_perc_y":71.78,"usage_perc_a":3.49,"ucprefix":false,"parent":"","keywords":"lazy-loading,lazyloading,loading=\"lazy\",loading=\"eager\",loading=\"auto\",loading,attribute,lazily,lazy image loading,lazy img loading,iframe loading,native lazyload","ie_id":"","chrome_id":"5645767347798016","firefox_id":"","webkit_id":""},"localecompare":{"title":"localeCompare()","description":"The `localeCompare()` method returns a number indicating whether a reference string comes before or after or is the same as the given string in sort order.","spec":"https://tc39.es/ecma402/#sup-String.prototype.localeCompare","status":"other","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare","title":"MDN article"}],"categories":["JS"],"stats":{"ie":{"6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"y","5.5":"u"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"a #1","3":"a #1","4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a #1","3.6":"a #1"},"chrome":{"4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a #1","3.2":"a #1","5.1":"a #1","6.1":"a #1","7.1":"a #1","9.1":"a #1","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"u","12":"u","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"u","10.0-10.1":"u","10.5":"u","10.6":"u","11.1":"u","11.5":"u","11.6":"u","12.1":"a #1"},"ios_saf":{"8":"a #1","14":"y","3.2":"a #1","4.0-4.1":"a #1","4.2-4.3":"a #1","5.0-5.1":"a #1","6.0-6.1":"a #1","7.0-7.1":"a #1","8.1-8.4":"a #1","9.0-9.2":"a #1","9.3":"a #1","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"a #1"},"android":{"3":"a #1","4":"a #1","81":"y","2.1":"a #1","2.2":"a #1","2.3":"a #1","4.1":"a #1","4.2-4.3":"a #1","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"a #1","10":"a #1"},"op_mob":{"10":"u","11":"u","12":"u","59":"y","11.1":"u","11.5":"u","12.1":"a #1"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #1","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"a #1","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"a"}},"notes":"","notes_by_num":{"1":"Only supports basic support without locale & options parameters."},"usage_perc_y":97.1,"usage_perc_a":2.52,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"magnetometer":{"title":"Magnetometer","description":"Defines a concrete sensor interface to measure magnetic field in the X, Y and Z axis.","spec":"https://www.w3.org/TR/magnetometer/","status":"cr","links":[{"url":"https://intel.github.io/generic-sensor-demos/vr-button/build/bundled/","title":"Demo"},{"url":"https://developers.google.com/web/updates/2017/09/sensors-for-the-web","title":"Article"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n d #1","59":"n d #1","60":"n d #1","61":"n d #1","62":"n d #1","63":"n d #1","64":"n d #1","65":"n d #1","66":"n d #1","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n d #1"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Available by enabling the \"Generic Sensor Extra Classes\" experimental flag in `about:flags`"},"usage_perc_y":36.42,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"5698781827825664","firefox_id":"","webkit_id":""},"matchesselector":{"title":"matches() DOM method","description":"Method of testing whether or not a DOM element matches a given selector. Formerly known (and largely supported with prefix) as matchesSelector.","spec":"https://dom.spec.whatwg.org/#dom-element-matches","status":"ls","links":[{"url":"https://developer.mozilla.org/en/docs/Web/API/Element/matches","title":"MDN Web Docs - Element matches"},{"url":"https://www.webplatform.org/docs/dom/HTMLElement/matches","title":"WebPlatform Docs"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6524858-unprefix-and-update-msmatchesselector-to-matches","title":"Microsoft Edge feature request on UserVoice"}],"categories":["DOM","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"a x","10":"a x","11":"a x","5.5":"n"},"edge":{"12":"a x","13":"a x","14":"a x","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a x","5":"a x","6":"a x","7":"a x","8":"a x","9":"a x","10":"a x","11":"a x","12":"a x","13":"a x","14":"a x","15":"a x","16":"a x","17":"a x","18":"a x","19":"a x","20":"a x","21":"a x","22":"a x","23":"a x","24":"a x","25":"a x","26":"a x","27":"a x","28":"a x","29":"a x","30":"a x","31":"a x","32":"a x","33":"a x","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"a x"},"chrome":{"4":"a x","5":"a x","6":"a x","7":"a x","8":"a x","9":"a x","10":"a x","11":"a x","12":"a x","13":"a x","14":"a x","15":"a x","16":"a x","17":"a x","18":"a x","19":"a x","20":"a x","21":"a x","22":"a x","23":"a x","24":"a x","25":"a x","26":"a x","27":"a x","28":"a x","29":"a x","30":"a x","31":"a x","32":"a x","33":"a x","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"a x","6":"a x","7":"a x","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"a x","6.1":"a x","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"a x","15":"a x","16":"a x","17":"a x","18":"a x","19":"a x","20":"a x","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"a x","11.6":"a x","12.1":"a x"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"a x","4.2-4.3":"a x","5.0-5.1":"a x","6.0-6.1":"a x","7.0-7.1":"a x","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"a x","4":"a x","81":"y","2.1":"n","2.2":"a x","2.3":"a x","4.1":"a x","4.2-4.3":"a x","4.4":"a x","4.4.3-4.4.4":"a x"},"bb":{"7":"a x","10":"a x"},"op_mob":{"10":"n","11":"n","12":"a x","59":"y","11.1":"a x","11.5":"a x","12.1":"a x"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a x","11":"a x"},"and_uc":{"12.12":"y"},"samsung":{"4":"a x","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Partial support refers to supporting the older specification's \"matchesSelector\" name rather than just \"matches\".","notes_by_num":{},"usage_perc_y":96.23,"usage_perc_a":2.42,"ucprefix":false,"parent":"","keywords":" matchesSelector","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"matchmedia":{"title":"matchMedia","description":"API for finding out whether or not a media query applies to the document.","spec":"https://www.w3.org/TR/cssom-view/#dom-window-matchmedia","status":"wd","links":[{"url":"https://github.com/paulirish/matchMedia.js/","title":"matchMedia.js polyfill"},{"url":"https://developer.mozilla.org/en/DOM/window.matchMedia","title":"MDN Web Docs - matchMedia"},{"url":"https://developer.mozilla.org/en/CSS/Using_media_queries_from_code","title":"MDN Web Docs - Using matchMedia"},{"url":"https://www.webplatform.org/docs/css/media_queries/apis/matchMedia","title":"WebPlatform Docs"}],"categories":["DOM","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":99.22,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"mediaquerylist","ie_id":"matchmedia","chrome_id":"4677872220372992","firefox_id":"","webkit_id":""},"mathml":{"title":"MathML","description":"Special tags that allow mathematical formulas and notations to be written on web pages.","spec":"https://www.w3.org/TR/MathML/","status":"rec","links":[{"url":"https://en.wikipedia.org/wiki/MathML","title":"Wikipedia"},{"url":"https://www.mozilla.org/projects/mathml/demo/","title":"MathML demos"},{"url":"https://www.mathjax.org","title":"Cross-browser support script"},{"url":"https://developer.mozilla.org/en/MathML/Element","title":"MDN Web Docs - MathML Element"},{"url":"https://developer.mozilla.org/en-US/docs/Mozilla/MathML_Project/MathML_Torture_Test","title":"MathML torture test"}],"categories":["Other"],"stats":{"ie":{"6":"p","7":"p","8":"p","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"p","80":"p","81":"p","83":"p","84":"p","85":"p","86":"p","87":"p"},"firefox":{"2":"y #1","3":"y #1","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y #1","3.6":"y #1"},"chrome":{"4":"p","5":"p","6":"p","7":"p","8":"p","9":"p","10":"p","11":"p","12":"p","13":"p","14":"p","15":"p","16":"p","17":"p","18":"p","19":"p","20":"p","21":"p","22":"p","23":"p","24":"y","25":"p","26":"p","27":"p","28":"p","29":"p","30":"p","31":"p","32":"p","33":"p","34":"p","35":"p","36":"p","37":"p","38":"p","39":"p","40":"p","41":"p","42":"p","43":"p","44":"p","45":"p","46":"p","47":"p","48":"p","49":"p","50":"p","51":"p","52":"p","53":"p","54":"p","55":"p","56":"p","57":"p","58":"p","59":"p","60":"p","61":"p","62":"p","63":"p","64":"p","65":"p","66":"p","67":"p","68":"p","69":"p","70":"p","71":"p","72":"p","73":"p","74":"p","75":"p","76":"p","77":"p","78":"p","79":"p","80":"p","81":"p","83":"p","84":"p","85":"p","86":"p","87":"p","88":"p","89":"p","90":"p"},"safari":{"4":"a #2","5":"a #2","6":"a #2","7":"a #2","8":"a #2","9":"a #2","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a #2","3.2":"a #2","5.1":"a #2","6.1":"a #2","7.1":"a #2","9.1":"a #2","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"a","12":"a","15":"p","16":"p","17":"p","18":"p","19":"p","20":"p","21":"p","22":"p","23":"p","24":"p","25":"p","26":"p","27":"p","28":"p","29":"p","30":"p","31":"p","32":"p","33":"p","34":"p","35":"p","36":"p","37":"p","38":"p","39":"p","40":"p","41":"p","42":"p","43":"p","44":"p","45":"p","46":"p","47":"p","48":"p","49":"p","50":"p","51":"p","52":"p","53":"p","54":"p","55":"p","56":"p","57":"p","58":"p","60":"p","62":"p","63":"p","64":"p","65":"p","66":"p","67":"p","68":"p","69":"p","70":"p","71":"p","72":"p","9.5-9.6":"a","10.0-10.1":"a","10.5":"a","10.6":"a","11.1":"a","11.5":"a","11.6":"a","12.1":"a"},"ios_saf":{"8":"y","14":"y","3.2":"p","4.0-4.1":"p","4.2-4.3":"p","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"p"},"android":{"3":"p","4":"p","81":"p","2.1":"p","2.2":"p","2.3":"p","4.1":"p","4.2-4.3":"p","4.4":"p","4.4.3-4.4.4":"p"},"bb":{"7":"p","10":"y"},"op_mob":{"10":"p","11":"p","12":"p","59":"p","11.1":"p","11.5":"p","12.1":"p"},"and_chr":{"86":"p"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"a"},"samsung":{"4":"p","5.0-5.4":"p","6.2-6.4":"p","7.2-7.4":"p","8.2":"p","9.2":"p","10.1":"p","11.1-11.2":"p","12.0":"p"},"and_qq":{"10.4":"p"},"baidu":{"7.12":"p"},"kaios":{"2.5":"y"}},"notes":"Opera's support is limited to a CSS profile of MathML. Support was added in Chrome 24, but removed afterwards due to instability.","notes_by_num":{"1":"Before version 4, Firefox only supports the XHTML notation","2":"Before version 10, Safari had issues rendering significant portions of the MathML torture test"},"usage_perc_y":20.67,"usage_perc_a":1.48,"ucprefix":false,"parent":"","keywords":"","ie_id":"mathml","chrome_id":"5240822173794304","firefox_id":"","webkit_id":""},"maxlength":{"title":"maxlength attribute for input and textarea elements","description":"Declares an upper bound on the number of characters the user can input. Normally the UI ignores attempts by the user to type in additional characters beyond this limit.","spec":"https://html.spec.whatwg.org/multipage/forms.html#attr-input-maxlength","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-maxlength","title":"MDN Web Docs - attribute maxlength"}],"categories":["DOM","HTML5","JS API"],"stats":{"ie":{"6":"a #1 #2 #3","7":"a #1 #2 #3","8":"a #1 #2 #3","9":"a #1 #2 #3","10":"y","11":"y","5.5":"u"},"edge":{"12":"y #4","13":"y #4","14":"y #4","15":"y #4","16":"y #4","17":"y #4","18":"y #4","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"a #1 #2 #3","3":"a #1 #2 #3","4":"y #4","5":"y #4","6":"y #4","7":"y #4","8":"y #4","9":"y #4","10":"y #4","11":"y #4","12":"y #4","13":"y #4","14":"y #4","15":"y #4","16":"y #4","17":"y #4","18":"y #4","19":"y #4","20":"y #4","21":"y #4","22":"y #4","23":"y #4","24":"y #4","25":"y #4","26":"y #4","27":"y #4","28":"y #4","29":"y #4","30":"y #4","31":"y #4","32":"y #4","33":"y #4","34":"y #4","35":"y #4","36":"y #4","37":"y #4","38":"y #4","39":"y #4","40":"y #4","41":"y #4","42":"y #4","43":"y #4","44":"y #4","45":"y #4","46":"y #4","47":"y #4","48":"y #4","49":"y #4","50":"y #4","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a #1 #2 #3","3.6":"a #1 #2 #3"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a #1 #2 #3","5":"u","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"a #1 #2 #3","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"a #1","12":"a #1","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"a #1","10.0-10.1":"a #1","10.5":"a #1","10.6":"a #1","11.1":"a #1","11.5":"a #1","11.6":"a #1","12.1":"a #1"},"ios_saf":{"8":"a #5","14":"y","3.2":"u","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"a #5","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"a #1"},"android":{"3":"y","4":"y","81":"y #6","2.1":"u","2.2":"u","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"a #1","11":"a #1","12":"a #1","59":"a #6","11.1":"a #1","11.5":"a #1","12.1":"a #1"},"and_chr":{"86":"y #6"},"and_ff":{"82":"y #6"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y #6","5.0-5.4":"y #6","6.2-6.4":"y #6","7.2-7.4":"y #6","8.2":"y #6","9.2":"y #6","10.1":"y #6","11.1-11.2":"y #6","12.0":"y #6"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y #4"}},"notes":"","notes_by_num":{"1":"`<textarea>`'s' UI does not prevent the user from typing additional characters beyond the `maxlength` limit.","2":"Does not support the `HTMLTextAreaElement.maxLength` DOM property.","3":"Does not support [`ValidityState.tooLong`](https://developer.mozilla.org/en-US/docs/Web/API/ValidityState/tooLong). In some cases, this is because `.validity` is not supported in the first place.","4":"Does not support `ValidityState.tooLong` correctly in the (unlikely) case of the value being initially set too long, then changed by the user to a still incorrect state. See [Firefox bug](https://bugzilla.mozilla.org/show_bug.cgi?id=1203844) and [MS Edge bug](https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/4678527/).","5":"`<input>`'s UI does not prevent the user from typing additional characters beyond the `maxlength` limit between two existing characters of the string.","6":"Allows text beyond maxlength to be entered at first, but removes all characters past the maxlength when focus is lost."},"usage_perc_y":98.35,"usage_perc_a":1.32,"ucprefix":false,"parent":"form-validation","keywords":"maximum,length,input,textarea,too,long,validity,state","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"media-fragments":{"title":"Media Fragments","description":"Allows only part of a resource to be shown, based on the fragment identifier in the URL. Currently support is primarily limited to video track ranges.","spec":"https://www.w3.org/TR/media-frags/","status":"rec","links":[{"url":"https://developer.mozilla.org/de/docs/Web/HTML/Using_HTML5_audio_and_video#Specifying_playback_range","title":"Media fragments on MDN"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"a #1","80":"a #1","81":"a #1","83":"a #1","84":"a #1","85":"a #1","86":"a #1","87":"a #1"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","59":"a #1","60":"a #1","61":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #1","66":"a #1","67":"a #1","68":"a #1","69":"a #1","70":"a #1","71":"a #1","72":"a #1","73":"a #1","74":"a #1","75":"a #1","76":"a #1","77":"a #1","78":"a #1","79":"a #1","80":"a #1","81":"a #1","82":"a #1","83":"a #1","84":"a #1","85":"a #1","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","59":"a #1","60":"a #1","61":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #1","66":"a #1","67":"a #1","68":"a #1","69":"a #1","70":"a #1","71":"a #1","72":"a #1","73":"a #1","74":"a #1","75":"a #1","76":"a #1","77":"a #1","78":"a #1","79":"a #1","80":"a #1","81":"a #1","83":"a #1","84":"a #1","85":"a #1","86":"a #1","87":"a #1","88":"a #1","89":"a #1","90":"a #1"},"safari":{"4":"n","5":"n","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","3.1":"n","3.2":"n","5.1":"n","6.1":"a #1","7.1":"a #1","9.1":"a #1","10.1":"a #1","11.1":"a #1","12.1":"a #1","13.1":"a #1","TP":"a #1"},"opera":{"9":"n","11":"n","12":"n","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","60":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #1","66":"a #1","67":"a #1","68":"a #1","69":"a #1","70":"a #1","71":"a #1","72":"a #1","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a #1","14":"a #1","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"a #1","9.0-9.2":"a #1","9.3":"a #1","10.0-10.2":"a #1","10.3":"a #1","11.0-11.2":"a #1","11.3-11.4":"a #1","12.0-12.1":"a #1","12.2-12.4":"a #1","13.0-13.1":"a #1","13.2":"a #1","13.3":"a #1","13.4-13.7":"a #1"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"a #1","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"a #1","4.4.3-4.4.4":"a #1"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a #1"},"and_ff":{"82":"a #1"},"ie_mob":{"10":"a #1","11":"a #1"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"a #1","7.2-7.4":"a #1","8.2":"a #1","9.2":"a #1","10.1":"a #1","11.1-11.2":"a #1","12.0":"a #1"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"a #1"}},"notes":"","notes_by_num":{"1":"Only appears to support the `#t=n,n` control for selecting a range of video, and possibly `track=(name)` & `id=(name)` (not yet tested)"},"usage_perc_y":0,"usage_perc_a":94.67,"ucprefix":false,"parent":"","keywords":"","ie_id":"mediafragments","chrome_id":"","firefox_id":"","webkit_id":""},"mediacapture-fromelement":{"title":"Media Capture from DOM Elements API","description":"API to capture Real-Time video and audio from a DOM element, such as a `<video>`, `<audio>`, or `<canvas>` element via the `captureStream` method, in the form of a `MediaStream`","spec":"https://w3c.github.io/mediacapture-fromelement/","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/captureStream","title":"MDN Web Docs - capture from <canvas>"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/captureStream","title":"MDN Web Docs - capture from <video>/<audio>"},{"url":"https://developers.google.com/web/updates/2016/10/capture-stream","title":"Google Developers article"}],"categories":["DOM","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"a #2","44":"a #2","45":"a #2","46":"a #2","47":"a #2","48":"a #2","49":"a #2","50":"a #2","51":"a #2","52":"a #2","53":"a #2","54":"a #2","55":"a #2","56":"a #2","57":"a #2","58":"a #2","59":"a #2","60":"a #2","61":"a #2","62":"a #2","63":"a #2","64":"a #2","65":"a #2","66":"a #2","67":"a #2","68":"a #2","69":"a #2","70":"a #2","71":"a #2","72":"a #2","73":"a #2","74":"a #2","75":"a #2","76":"a #2","77":"a #2","78":"a #2","79":"a #2","80":"a #2","81":"a #2","82":"a #2","83":"a #2","84":"a #2","85":"a #2","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"a d #2","52":"a d #2","53":"a d #2","54":"a d #2","55":"a d #2","56":"a d #2","57":"a d #2","58":"a d #2","59":"a d #2","60":"a d #2","61":"a d #2","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"a #1","12":"a #1","13":"a #1","14":"a #1","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"a #1","12.1":"a #1","13.1":"a #1","TP":"a #1"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"a d #2","37":"a d #2","38":"a d #2","39":"a d #2","40":"a d #2","41":"a d #2","42":"a d #2","43":"a d #2","44":"a d #2","45":"a d #2","46":"a d #2","47":"a d #2","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"a #2"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"a #1"},"samsung":{"4":"n","5.0-5.4":"a #1","6.2-6.4":"a #1","7.2-7.4":"a #1","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"a #2"}},"notes":"","notes_by_num":{"1":"Does not support capture from `<video>`/`<audio>`","2":"Capture from `<video>`/`<audio>` can be enabled via the Experimental Web Platform Features flag."},"usage_perc_y":73.36,"usage_perc_a":9.58,"ucprefix":false,"parent":"stream","keywords":"canvas,mediastream,capturestream,canvas.capturestream","ie_id":"","chrome_id":"5522768674160640,4817998447640576","firefox_id":"","webkit_id":""},"mediarecorder":{"title":"MediaRecorder API","description":"The MediaRecorder API (MediaStream Recording) aims to provide a really simple mechanism by which developers can record media streams from the user's input devices and instantly use them in web apps, rather than having to perform manual encoding operations on raw PCM data, etc.","spec":"https://w3c.github.io/mediacapture-record/MediaRecorder.html","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/MediaRecorder_API","title":"MDN Web Docs - MediaRecorder"}],"categories":["DOM","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n d #1","48":"n d #1","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n d #2","14":"n d #2","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n d #2","13.1":"n d #2","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n d #1","35":"n d #1","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n d #3","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n d #3","12.2-12.4":"n d #3","13.0-13.1":"n d #3","13.2":"n d #3","13.3":"n d #3","13.4-13.7":"n d #3"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Can be enabled via the experimental Web Platform features flag. Does not support audio recording, only video.","2":"Can be enabled using the Develop > Experimental Features menu.","3":"Can be enabled using the Advanced > Experimental Features menu."},"usage_perc_y":77.76,"usage_perc_a":0,"ucprefix":false,"parent":"stream","keywords":"","ie_id":"mediarecorder","chrome_id":"5929649028726784","firefox_id":"media-recorder","webkit_id":""},"mediasource":{"title":"Media Source Extensions","description":"API allowing media data to be accessed from HTML `video` and `audio` elements.","spec":"https://www.w3.org/TR/media-source/","status":"rec","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/MediaSource#Browser_compatibility","title":"MDN Web Docs - MediaSource"},{"url":"https://msdn.microsoft.com/en-us/library/dn594470%28v=vs.85%29.aspx","title":"MSDN article"},{"url":"http://html5-demos.appspot.com/static/media-source.html","title":"MediaSource demo"}],"categories":["DOM","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"a #1","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n d","26":"n d","27":"n d","28":"n d","29":"n d","30":"n d","31":"n d","32":"n d","33":"n d","34":"n d","35":"n d","36":"n d","37":"n d","38":"n d","39":"n d","40":"n d","41":"n d","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n d","18":"n d","19":"n d","20":"n d","21":"n d","22":"n d","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"a #2","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"a #2","13.2":"a #2","13.3":"a #2","13.4-13.7":"a #2"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support in IE11 refers to only working in Windows 8+","2":"Fully supported only in iPadOS 13 and later.","3":"Due to compatibility issues, MediaSource Extensions are currently disabled by default in Samsung Internet.","4":"Fully supported only in iPadOS 13 and later."},"usage_perc_y":83.99,"usage_perc_a":10.34,"ucprefix":false,"parent":"","keywords":"sourcebuffer,endofstream,mse","ie_id":"mediasourceextensions","chrome_id":"4563797888991232","firefox_id":"mse","webkit_id":""},"menu":{"title":"Context menu item (menuitem element)","description":"Method of defining a context menu item, now deprecated and [removed from the HTML specification](https://github.com/whatwg/html/issues/2730). ","spec":"https://www.w3.org/TR/2016/REC-html51-20161101/interactive-elements.html#context-menus","status":"unoff","links":[{"url":"https://bug617528.bugzilla.mozilla.org/attachment.cgi?id=554309","title":"Demo"},{"url":"https://github.com/swisnl/jQuery-contextMenu","title":"jQuery polyfill"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/events.js#event-contextmenu","title":"has.js test"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=746087","title":"Bug on Firefox support"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6508881-html5-menu-tag-contextmenu-attribute","title":"Microsoft Edge feature request on UserVoice"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=87553","title":"Chromium support bug"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","59":"a #1","60":"a #1","61":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #1","66":"a #1","67":"a #1","68":"a #1","69":"a #1","70":"a #1","71":"a #1","72":"a #1","73":"a #1","74":"a #1","75":"a #1","76":"a #1","77":"a #1","78":"a #1","79":"a #1","80":"a #1","81":"a #1","82":"a #1","83":"a #1","84":"a #1","85":"a #1","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n d","42":"n d","43":"n d","44":"n d","45":"n d","46":"n d","47":"n d","48":"n d","49":"n d","50":"n d","51":"n d","52":"n d","53":"n d","54":"n d","55":"n d","56":"n d","57":"n d","58":"n d","59":"n d","60":"n d","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n d","36":"n d","37":"n d","38":"n d","39":"n d","40":"n d","41":"n d","42":"n d","43":"n d","44":"n d","45":"n d","46":"n d","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"a #1 #2"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Partial support in Firefox refers to being limited to context menus, not toolbar menus.","2":"Nested menus are not supported"},"usage_perc_y":0,"usage_perc_a":4.12,"ucprefix":false,"parent":"","keywords":"contextmenu,<menuitem>,command","ie_id":"menuelement","chrome_id":"","firefox_id":"","webkit_id":""},"meta-theme-color":{"title":"theme-color Meta Tag","description":"Meta tag to define a suggested color that browsers should use to customize the display of the page or of the surrounding user interface. The meta tag overrides any theme-color set in the web app manifest.","spec":"https://html.spec.whatwg.org/multipage/semantics.html#meta-theme-color","status":"ls","links":[{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1098544","title":"Firefox for Android implementation bug"},{"url":"https://developers.google.com/web/updates/2014/11/Support-for-theme-color-in-Chrome-39-for-Android?hl=en","title":"Google Developers article"}],"categories":["DOM","Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n #2","40":"n #2","41":"n #2","42":"n #2","43":"n #2","44":"n #2","45":"n #2","46":"n #2","47":"n #2","48":"n #2","49":"n #2","50":"n #2","51":"n #2","52":"n #2","53":"n #2","54":"n #2","55":"n #2","56":"n #2","57":"n #2","58":"n #2","59":"n #2","60":"n #2","61":"n #2","62":"n #2","63":"n #2","64":"n #2","65":"n #2","66":"n #2","67":"n #2","68":"n #2","69":"n #2","70":"n #2","71":"n #2","72":"n #2","73":"a #1","74":"a #1","75":"a #1","76":"a #1","77":"a #1","78":"a #1","79":"a #1","80":"a #1","81":"a #1","83":"a #1","84":"a #1","85":"a #1","86":"a #1","87":"a #1","88":"a #1","89":"a #1","90":"a #1"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y #3"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"u","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"Vivaldi browser (Chromium based) supports this feature in both mobile and desktop version. Also supported in the (now discontinued) Firefox OS.","notes_by_num":{"1":"Desktop Chrome only uses the color on installed `progressive web apps`.","2":"Desktop Chrome 39-72 claimed to have support, but did not actually use the color anywhere. Chrome for Android did use the color in the toolbar.","3":"Chrome for Android does not use the color on devices with native `dark-mode` enabled."},"usage_perc_y":36.65,"usage_perc_a":31.95,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"5398016231997440","firefox_id":"","webkit_id":""},"meter":{"title":"meter element","description":"Method of indicating the current level of a gauge.","spec":"https://html.spec.whatwg.org/multipage/forms.html#the-meter-element","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meter","title":"MDN Web Docs - Element meter"},{"url":"http://html5doctor.com/measure-up-with-the-meter-tag/","title":"HTML5 Doctor on meter element"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6803893-meter","title":"Microsoft Edge feature request on UserVoice"},{"url":"https://dev.opera.com/articles/new-form-features-in-html5/#newoutput","title":"Dev.Opera article"},{"url":"http://peter.sh/examples/?/html/meter-progress.html","title":"Examples of progress and meter elements"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":97.4,"usage_perc_a":0,"ucprefix":false,"parent":"forms","keywords":"<meter>","ie_id":"meterelement","chrome_id":"","firefox_id":"","webkit_id":""},"midi":{"title":"Web MIDI API","description":"The Web MIDI API specification defines a means for web developers to enumerate, manipulate and access MIDI devices","spec":"https://webaudio.github.io/web-midi-api/","status":"wd","links":[{"url":"https://github.com/cwilso/WebMIDIAPIShim","title":"Polyfill"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=836897","title":"Firefox bug"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":75.31,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"webmidiapi","chrome_id":"4923613069180928","firefox_id":"","webkit_id":"feature-web-midi"},"minmaxwh":{"title":"CSS min/max-width/height","description":"Method of setting a minimum or maximum width or height to an element. ","spec":"https://www.w3.org/TR/CSS21/visudet.html#min-max-widths","status":"rec","links":[{"url":"https://code.google.com/archive/p/ie7-js/","title":"JS library with support"},{"url":"https://www.webplatform.org/docs/css/properties/min-width","title":"WebPlatform Docs"},{"url":"https://www.impressivewebs.com/min-max-width-height-css/","title":"CSS Basics post"}],"categories":["CSS2"],"stats":{"ie":{"6":"p","7":"y #1","8":"y #2","9":"y","10":"y","11":"y","5.5":"p"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"IE7 does not support `inherit` as a value on any of these properties.","2":"IE8 has some bugs with `max-width`/`height` combined with `overflow: auto`/`scroll`."},"usage_perc_y":99.68,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"min-width,min-height,max-width,max-height","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"mp3":{"title":"MP3 audio format","description":"Popular lossy audio compression format","spec":"http://mpgedit.org/mpgedit/mpeg_format/MP3Format.html","status":"other","links":[{"url":"https://en.wikipedia.org/wiki/MP3","title":"Wikipedia"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a #1","3.6":"a #1"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"n","2.2":"n","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Support refers to this format's use in the `audio` element, not other conditions.","notes_by_num":{"1":"Partial support in older Firefox refers to being limited to certain operating systems."},"usage_perc_y":98.49,"usage_perc_a":0.14,"ucprefix":false,"parent":"audio","keywords":"mpeg","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"mpeg-dash":{"title":"Dynamic Adaptive Streaming over HTTP (MPEG-DASH)","description":"HTTP-based media streaming communications protocol, an alternative to HTTP Live Streaming (HLS).","spec":"https://www.iso.org/standard/65274.html","status":"other","links":[{"url":"https://en.wikipedia.org/wiki/Dynamic_Adaptive_Streaming_over_HTTP","title":"Wikipedia article"},{"url":"https://github.com/Dash-Industry-Forum/dash.js/","title":"JavaScript implementation"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n #1 #2","22":"n #1 #2","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"DASH can be used with a JavaScript library in browsers that doesn't support it natively as long as they support [Media Source Extensions](/#feat=mediasource).","notes_by_num":{"1":"Can be enabled via the `media.dash.enabled` flag.","2":"Only WebM video is supported."},"usage_perc_y":0.39,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"mpeg4":{"title":"MPEG-4/H.264 video format","description":"Commonly used video compression format.","spec":"http://ip.hhi.de/imagecom_G1/assets/pdfs/csvt_overview_0305.pdf","status":"other","links":[{"url":"https://en.wikipedia.org/wiki/H.264/MPEG-4_AVC","title":"Wikipedia article"},{"url":"http://www.interoperabilitybridges.com/html5-extension-for-wmp-plugin","title":"Firefox extension allowing support in Win7"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"a","22":"a","23":"a","24":"a","25":"a","26":"a","27":"a","28":"a","29":"a","30":"a","31":"a","32":"a","33":"a","34":"a","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"a","4":"a","81":"y","2.1":"a","2.2":"a","2.3":"a #1","4.1":"a","4.2-4.3":"a","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"a #2"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"a"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Firefox supports H.264 on Windows 7 and later since version 21. Firefox supports H.264 on Linux since version 26 if the appropriate gstreamer plug-ins are installed.\r\n\r\nPartial support for older Firefox versions refers to the lack of support in OS X & some non-Android Linux platforms.","notes_by_num":{"1":"The Android 2.3 browser requires [specific handling](https://www.broken-links.com/2010/07/08/making-html5-video-work-on-android-phones/) to play videos.","2":"Partial supports refers to the lack of hardware acceleration."},"usage_perc_y":96.84,"usage_perc_a":1.61,"ucprefix":false,"parent":"video","keywords":"avc,mp4,mpv,mov,aac,h264","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"multibackgrounds":{"title":"CSS3 Multiple backgrounds","description":"Method of using multiple images as a background","spec":"https://www.w3.org/TR/css3-background/","status":"cr","links":[{"url":"http://www.css3.info/preview/multiple-backgrounds/","title":"Demo & information page"},{"url":"https://www.webplatform.org/docs/css/properties/background-image","title":"WebPlatform Docs"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":99.57,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"multicolumn":{"title":"CSS3 Multiple column layout","description":"Method of flowing information in multiple columns","spec":"https://www.w3.org/TR/css3-multicol/","status":"cr","links":[{"url":"https://dev.opera.com/articles/view/css3-multi-column-layout/","title":"Dev.Opera article"},{"url":"https://webdesign.tutsplus.com/articles/an-introduction-to-the-css3-multiple-column-layout-module--webdesign-4934","title":"Introduction page"},{"url":"https://www.webplatform.org/docs/css/properties/column-width","title":"WebPlatform Docs"},{"url":"https://github.com/hamsterbacke23/multicolumn-polyfill","title":"Polyfill"},{"url":"https://www.chromestatus.com/feature/6298909664083968","title":"Chrome platform status for CSS column-fill"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"a #3","80":"a #3","81":"a #3","83":"a #3","84":"a #3","85":"a #3","86":"a #3","87":"a #3"},"firefox":{"2":"a x #1","3":"a x #1","4":"a x #1","5":"a x #1","6":"a x #1","7":"a x #1","8":"a x #1","9":"a x #1","10":"a x #1","11":"a x #1","12":"a x #1","13":"a x #1","14":"a x #1","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","19":"a x #1","20":"a x #1","21":"a x #1","22":"a x #1","23":"a x #1","24":"a x #1","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"a x #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","59":"a #1","60":"a #1","61":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #3","66":"a #3","67":"a #3","68":"a #3","69":"a #3","70":"a #3","71":"a #3","72":"a #3","73":"a #3","74":"a #3","75":"a #3","76":"a #3","77":"a #3","78":"a #3","79":"a #3","80":"a #3","81":"a #3","82":"a #3","83":"a #3","84":"a #3","85":"a #3","3.5":"a x #1","3.6":"a x #1"},"chrome":{"4":"a x #1 #2","5":"a x #1 #2","6":"a x #1 #2","7":"a x #1 #2","8":"a x #1 #2","9":"a x #1 #2","10":"a x #1 #2","11":"a x #1 #2","12":"a x #1 #2","13":"a x #1 #2","14":"a x #1 #2","15":"a x #1 #2","16":"a x #1 #2","17":"a x #1 #2","18":"a x #1 #2","19":"a x #1 #2","20":"a x #1 #2","21":"a x #1 #2","22":"a x #1 #2","23":"a x #1 #2","24":"a x #1 #2","25":"a x #1 #2","26":"a x #1 #2","27":"a x #1 #2","28":"a x #1 #2","29":"a x #1 #2","30":"a x #1 #2","31":"a x #1 #2","32":"a x #1 #2","33":"a x #1 #2","34":"a x #1 #2","35":"a x #1 #2","36":"a x #1 #2","37":"a x #1 #2","38":"a x #1 #2","39":"a x #1 #2","40":"a x #1 #2","41":"a x #1 #2","42":"a x #1 #2","43":"a x #1 #2","44":"a x #1 #2","45":"a x #1 #2","46":"a x #1 #2","47":"a x #1 #2","48":"a x #1 #2","49":"a x #1 #2","50":"a #3","51":"a #3","52":"a #3","53":"a #3","54":"a #3","55":"a #3","56":"a #3","57":"a #3","58":"a #3","59":"a #3","60":"a #3","61":"a #3","62":"a #3","63":"a #3","64":"a #3","65":"a #3","66":"a #3","67":"a #3","68":"a #3","69":"a #3","70":"a #3","71":"a #3","72":"a #3","73":"a #3","74":"a #3","75":"a #3","76":"a #3","77":"a #3","78":"a #3","79":"a #3","80":"a #3","81":"a #3","83":"a #3","84":"a #3","85":"a #3","86":"a #3","87":"a #3","88":"a #3","89":"a #3","90":"a #3"},"safari":{"4":"a x #1 #2","5":"a x #1 #2","6":"a x #1 #2","7":"a x #1","8":"a x #1","9":"a #1","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a x #1 #2","3.2":"a x #1 #2","5.1":"a x #1 #2","6.1":"a x #1 #2","7.1":"a x #1","9.1":"a #1","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"y","15":"a x #1 #2","16":"a x #1 #2","17":"a x #1 #2","18":"a x #1 #2","19":"a x #1 #2","20":"a x #1 #2","21":"a x #1 #2","22":"a x #1 #2","23":"a x #1 #2","24":"a x #1 #2","25":"a x #1 #2","26":"a x #1 #2","27":"a x #1 #2","28":"a x #1 #2","29":"a x #1 #2","30":"a x #1 #2","31":"a x #1 #2","32":"a x #1 #2","33":"a x #1 #2","34":"a x #1 #2","35":"a x #1 #2","36":"a x #1 #2","37":"a #3","38":"a #3","39":"a #3","40":"a #3","41":"a #3","42":"a #3","43":"a #3","44":"a #3","45":"a #3","46":"a #3","47":"a #3","48":"a #3","49":"a #3","50":"a #3","51":"a #3","52":"a #3","53":"a #3","54":"a #3","55":"a #3","56":"a #3","57":"a #3","58":"a #3","60":"a #3","62":"a #3","63":"a #3","64":"a #3","65":"a #3","66":"a #3","67":"a #3","68":"a #3","69":"a #3","70":"a #3","71":"a #3","72":"a #3","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"a x #1","14":"y","3.2":"a x #1 #2","4.0-4.1":"a x #1 #2","4.2-4.3":"a x #1 #2","5.0-5.1":"a x #1 #2","6.0-6.1":"a x #1 #2","7.0-7.1":"a x #1","8.1-8.4":"a x #1","9.0-9.2":"a #1","9.3":"a #1","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"a x #1 #2","4":"a x #1 #2","81":"a #3","2.1":"a x #1 #2","2.2":"a x #1 #2","2.3":"a x #1 #2","4.1":"a x #1 #2","4.2-4.3":"a x #1 #2","4.4":"a x #1 #2","4.4.3-4.4.4":"a x #1 #2"},"bb":{"7":"a x #1 #2","10":"a x #1 #2"},"op_mob":{"10":"n","11":"n","12":"y","59":"a #3","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"a #3"},"and_ff":{"82":"a #1"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"a x #1 #2","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"a #1"},"baidu":{"7.12":"a #1"},"kaios":{"2.5":"a x #1"}},"notes":"","notes_by_num":{"1":"Partial support refers to not supporting the `break-before`, `break-after`, and `break-inside` properties. WebKit- and Blink-based browsers do have equivalent support for the non-standard `-webkit-column-break-*` properties to accomplish the same result (but only the `auto` and `always` values). Firefox does not support `break-*` but does support the now-obsolete `page-break-*` properties in the paging (printing) context.","2":"Partial support refers to not supporting the `column-fill` property.","3":"Partial support refers to not supporting the `avoid-column`, `column`, and `avoid` (in the column context) values for the properties `break-before`, `break-after`, and `break-inside`."},"usage_perc_y":22.79,"usage_perc_a":76.56,"ucprefix":false,"parent":"","keywords":"column-count,column-width,column-gap,column-rule,column-rule-type,column-span,column-fill,break-before,break-after,break-inside","ie_id":"multicolumnfullsupport","chrome_id":"6526151266664448,5630943616303104","firefox_id":"css-multicol","webkit_id":""},"mutation-events":{"title":"Mutation events","description":"Deprecated mechanism for listening to changes made to the DOM, replaced by Mutation Observers.","spec":"https://www.w3.org/TR/DOM-Level-3-Events/#legacy-mutationevent-events","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Mutation_events","title":"MDN Web Docs - Mutation events"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"a #2","10":"a #2","11":"a #2","5.5":"n"},"edge":{"12":"a #2","13":"a #2","14":"a #2","15":"a #2","16":"a #2","17":"a #2","18":"a #2","79":"a #1","80":"a #1","81":"a #1","83":"a #1","84":"a #1","85":"a #1","86":"a #1","87":"a #1"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"a #2","7":"a #2","8":"a #2","9":"a #2","10":"a #2","11":"a #2","12":"a #2","13":"a #2","14":"a #2","15":"a #2","16":"a #2","17":"a #2","18":"a #2","19":"a #2","20":"a #2","21":"a #2","22":"a #2","23":"a #2","24":"a #2","25":"a #2","26":"a #2","27":"a #2","28":"a #2","29":"a #2","30":"a #2","31":"a #2","32":"a #2","33":"a #2","34":"a #2","35":"a #2","36":"a #2","37":"a #2","38":"a #2","39":"a #2","40":"a #2","41":"a #2","42":"a #2","43":"a #2","44":"a #2","45":"a #2","46":"a #2","47":"a #2","48":"a #2","49":"a #2","50":"a #2","51":"a #2","52":"a #2","53":"a #2","54":"a #2","55":"a #2","56":"a #2","57":"a #2","58":"a #2","59":"a #2","60":"a #2","61":"a #2","62":"a #2","63":"a #2","64":"a #2","65":"a #2","66":"a #2","67":"a #2","68":"a #2","69":"a #2","70":"a #2","71":"a #2","72":"a #2","73":"a #2","74":"a #2","75":"a #2","76":"a #2","77":"a #2","78":"a #2","79":"a #2","80":"a #2","81":"a #2","82":"a #2","83":"a #2","84":"a #2","85":"a #2","3.5":"n","3.6":"n"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","59":"a #1","60":"a #1","61":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #1","66":"a #1","67":"a #1","68":"a #1","69":"a #1","70":"a #1","71":"a #1","72":"a #1","73":"a #1","74":"a #1","75":"a #1","76":"a #1","77":"a #1","78":"a #1","79":"a #1","80":"a #1","81":"a #1","83":"a #1","84":"a #1","85":"a #1","86":"a #1","87":"a #1","88":"a #1","89":"a #1","90":"a #1"},"safari":{"4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","3.1":"u","3.2":"u","5.1":"a #1","6.1":"a #1","7.1":"a #1","9.1":"a #1","10.1":"a #1","11.1":"a #1","12.1":"a #1","13.1":"a #1","TP":"a #1"},"opera":{"9":"n","11":"u","12":"y","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","60":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #1","66":"a #1","67":"a #1","68":"a #1","69":"a #1","70":"a #1","71":"a #1","72":"a #1","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"u","11.5":"u","11.6":"y","12.1":"y"},"ios_saf":{"8":"a #1","14":"a #1","3.2":"u","4.0-4.1":"u","4.2-4.3":"a #1","5.0-5.1":"a #1","6.0-6.1":"a #1","7.0-7.1":"a #1","8.1-8.4":"a #1","9.0-9.2":"a #1","9.3":"a #1","10.0-10.2":"a #1","10.3":"a #1","11.0-11.2":"a #1","11.3-11.4":"a #1","12.0-12.1":"a #1","12.2-12.4":"a #1","13.0-13.1":"a #1","13.2":"a #1","13.3":"a #1","13.4-13.7":"a #1"},"op_mini":{"all":"n"},"android":{"3":"a #1","4":"a #1","81":"a #1","2.1":"u","2.2":"u","2.3":"a #1","4.1":"a #1","4.2-4.3":"a #1","4.4":"a #1","4.4.3-4.4.4":"a #1"},"bb":{"7":"a #1","10":"a #1"},"op_mob":{"10":"n","11":"u","12":"y","59":"a #1","11.1":"u","11.5":"u","12.1":"y"},"and_chr":{"86":"a #1"},"and_ff":{"82":"a #2"},"ie_mob":{"10":"a #2","11":"a #2"},"and_uc":{"12.12":"a #1"},"samsung":{"4":"a #1","5.0-5.4":"a #1","6.2-6.4":"a #1","7.2-7.4":"a #1","8.2":"a #1","9.2":"a #1","10.1":"a #1","11.1-11.2":"a #1","12.0":"a #1"},"and_qq":{"10.4":"a #1"},"baidu":{"7.12":"a #1"},"kaios":{"2.5":"a #2"}},"notes":"See also support for [Mutation Observer](https://caniuse.com/#feat=mutationobserver), which replaces mutation events and does not have the same performance drawbacks.","notes_by_num":{"1":"Does not support `DOMAttrModified`","2":"Does not support `DOMNodeInsertedIntoDocument` & `DOMNodeRemovedFromDocument`"},"usage_perc_y":0.02,"usage_perc_a":98.52,"ucprefix":false,"parent":"","keywords":"DOMAttrModified,DOMCharacterDataModified,DOMNodeInserted,DOMNodeInsertedIntoDocument,DOMNodeRemoved,DOMNodeRemovedFromDocument,DOMSubtreeModified","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"mutationobserver":{"title":"Mutation Observer","description":"Method for observing and reacting to changes to the DOM. Replaces MutationEvents, which is deprecated.","spec":"https://dom.spec.whatwg.org/#mutation-observers","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver","title":"MutationObserver from MDN"},{"url":"https://github.com/webcomponents/webcomponentsjs","title":"Polyfill"}],"categories":["DOM","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"p","10":"p","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y x","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"y x","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"p","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"p","4.2-4.3":"p","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"p","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"When changing the `innerHTML` content of a node containing a single `CharacterData` node, resulting in a single-but-different `CharacterData` child node, WebKit browsers consider this a `characterData` mutation of the child `CharacterData` node, while other browsers consider it a `childList` mutation of the parent node.","notes_by_num":{},"usage_perc_y":97.98,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"MutationObserver","ie_id":"mutationobservers","chrome_id":"5021194726146048","firefox_id":"","webkit_id":""},"namevalue-storage":{"title":"Web Storage - name/value pairs","description":"Method of storing data locally like cookies, but for larger amounts of data (sessionStorage and localStorage, used to fall under HTML5).","spec":"https://html.spec.whatwg.org/multipage/webstorage.html#storage","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API","title":"MDN Web Docs - Web Storage"},{"url":"http://code.google.com/p/sessionstorage/","title":"Support library"},{"url":"http://html5demos.com/storage","title":"Simple demo"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/features.js#native-localstorage;native-sessionstorage","title":"has.js test"},{"url":"https://www.webplatform.org/docs/apis/web-storage/Storage/localStorage","title":"WebPlatform Docs"}],"categories":["JS API"],"stats":{"ie":{"6":"p","7":"p","8":"y","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"a","3":"a","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":98.76,"usage_perc_a":0.01,"ucprefix":false,"parent":"","keywords":"webstorage,local storage","ie_id":"webstorage","chrome_id":"5345825534246912","firefox_id":"","webkit_id":""},"native-filesystem-api":{"title":"File System Access API","description":"API for manipulating files in the device's local file system (not in a sandbox).","spec":"https://wicg.github.io/file-system-access/","status":"unoff","links":[{"url":"https://github.com/WICG/file-system-access/blob/master/EXPLAINER.md","title":"Explainer"},{"url":"https://web.dev/file-system-access/","title":"Web.dev blog post"},{"url":"https://mozilla.github.io/standards-positions/#file-system-access","title":"Firefox position: defer"},{"url":"https://developers.google.com/web/updates/2019/08/native-file-system","title":"Chrome blog post"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n d #1","80":"n d #1","81":"n d #1","83":"n d #1","84":"n d #1","85":"n d #1","86":"a #2","87":"a #2"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n d #1","75":"n d #1","76":"n d #1","77":"n d #1","78":"n d #1","79":"n d #1","80":"n d #1","81":"n d #1","83":"n d #1","84":"n d #1","85":"n d #1","86":"a #2","87":"a #2","88":"a #2","89":"a #2","90":"a #2"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n d #1","63":"n d #1","64":"n d #1","65":"n d #1","66":"n d #1","67":"n d #1","68":"n d #1","69":"n d #1","70":"n d #1","71":"n d #1","72":"a #2","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Can be enabled in desktop Chromium browsers with the `#native-file-system-api` flag.","2":"Desktop Chromium browsers currently support basic functionality and will be adding more of the API in the future."},"usage_perc_y":0,"usage_perc_a":19.83,"ucprefix":false,"parent":"","keywords":"File System,File System API,chooseFileSystemEntries,getFile","ie_id":"","chrome_id":"6284708426022912","firefox_id":"","webkit_id":""},"nav-timing":{"title":"Navigation Timing API","description":"API for accessing timing information related to navigation and elements.","spec":"https://www.w3.org/TR/navigation-timing/","status":"rec","links":[{"url":"https://developer.mozilla.org/en/API/navigationTiming","title":"MDN Web Docs - Navigation Timing"},{"url":"https://www.html5rocks.com/en/tutorials/webperformance/basics/","title":"HTML5 Rocks tutorial"},{"url":"https://www.webplatform.org/docs/apis/navigation_timing","title":"WebPlatform Docs"}],"categories":["DOM","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"y","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Removed in iOS 8.1 due to poor performance.","notes_by_num":{},"usage_perc_y":98.32,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"performance,performance.timing,performancenavigation","ie_id":"navigationtimingapi","chrome_id":"5584144679567360","firefox_id":"","webkit_id":"specification-navigation-timing-level-1"},"netinfo":{"title":"Network Information API","description":"The Network Information API enables web applications to access information about the network connection in use by the device. Accessed via `navigator.connection`","spec":"https://wicg.github.io/netinfo/","status":"unoff","links":[{"url":"https://www.igvita.com/2014/12/15/capability-reporting-with-service-worker/","title":"(NetInfo) Capability reporting with ServiceWorker"}],"categories":["DOM","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"a #4","80":"a #4","81":"a #4","83":"a #4","84":"a #4","85":"a #4","86":"a #4","87":"a #4"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"a #4","62":"a #4","63":"a #4","64":"a #4","65":"a #4","66":"a #4","67":"a #4","68":"a #4","69":"a #4","70":"a #4","71":"a #4","72":"a #4","73":"a #4","74":"a #4","75":"a #4","76":"a #4","77":"a #4","78":"a #4","79":"a #4","80":"a #4","81":"a #4","83":"a #4","84":"a #4","85":"a #4","86":"a #4","87":"a #4","88":"a #4","89":"a #4","90":"a #4"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"a #4","49":"a #4","50":"a #4","51":"a #4","52":"a #4","53":"a #4","54":"a #4","55":"a #4","56":"a #4","57":"a #4","58":"a #4","60":"a #4","62":"a #4","63":"a #4","64":"a #4","65":"a #4","66":"a #4","67":"a #4","68":"a #4","69":"a #4","70":"a #4","71":"a #4","72":"a #4","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"a #1","4":"a #1","81":"y","2.1":"n","2.2":"a #1","2.3":"a #1","4.1":"a #1","4.2-4.3":"a #1","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"a #3","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"a #1","5.0-5.4":"a #3","6.2-6.4":"a #3","7.2-7.4":"a #3","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"a #3"},"kaios":{"2.5":"a #2"}},"notes":"","notes_by_num":{"1":"Supports only the `navigator.connection.type` value which doesn't match the latest spec. [see details](https://www.davidbcalhoun.com/2010/optimizing-based-on-connection-speed-using-navigator.connection-on-android-2.2-/)","2":"Only supports the `type` value.","3":"Only supports the `type` and `downlinkMax` values.","4":"Only supports the `downlink`, `effectiveType` & `rtt` values."},"usage_perc_y":37,"usage_perc_a":37.06,"ucprefix":false,"parent":"","keywords":"performance,network,network information,netinfo","ie_id":"","chrome_id":"6338383617982464","firefox_id":"","webkit_id":""},"notifications":{"title":"Web Notifications","description":"Method of alerting the user outside of a web page by displaying notifications (that do not require interaction by the user).","spec":"https://notifications.spec.whatwg.org/","status":"ls","links":[{"url":"https://www.html5rocks.com/tutorials/notifications/quick/","title":"HTML5 Rocks tutorial"},{"url":"http://www.chromium.org/developers/design-documents/desktop-notifications/api-specification","title":"Chromium API"},{"url":"https://addons.mozilla.org/en-us/firefox/addon/221523/","title":"Add-on"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/notification","title":"MDN Web Docs - Notification"},{"url":"https://www.sitepoint.com/introduction-web-notifications-api/","title":"SitePoint article"},{"url":"http://aurelio.audero.it/demo/web-notifications-api-demo.html","title":"Demo"},{"url":"http://ukot.github.io/ie_web_notifications/","title":"Plug-in for support in IE"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"a x","6":"a x","7":"a x","8":"a x","9":"a x","10":"a x","11":"a x","12":"a x","13":"a x","14":"a x","15":"a x","16":"a x","17":"a x","18":"a x","19":"a x","20":"a x","21":"a x","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"a x","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"a x","4.4.3-4.4.4":"a x"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"a x","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y #3"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"a x","5.0-5.4":"n #2","6.2-6.4":"n #2","7.2-7.4":"n #2","8.2":"n #2","9.2":"n #2","10.1":"n #2","11.1-11.2":"n #2","12.0":"n #2"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n #2"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Can be enabled in `about:flags`","2":"Supports notifications via the [Push API](https://caniuse.com/#feat=push-api) but not the Web Notifications API.","3":"Chrome for Android requires the call to be made with a [service worker registration](https://developer.mozilla.org/en-US/docs/Web/API/Notifications_API#Service_worker_additions)"},"usage_perc_y":79.56,"usage_perc_a":0.44,"ucprefix":false,"parent":"","keywords":"","ie_id":"webnotifications","chrome_id":"5064350557536256","firefox_id":"","webkit_id":""},"object-entries":{"title":"Object.entries","description":"The `Object.entries()` method creates a multi-dimensional array of key value pairs from the given object.","spec":"https://tc39.es/ecma262/#sec-object.entries","status":"other","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/entries","title":"MDN article"},{"url":"https://github.com/es-shims/Object.entries","title":"ES2017 spec-compliant shim for Object.entries"},{"url":"https://github.com/zloirock/core-js#ecmascript-object","title":"Polyfill for this feature is available in the core-js library"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"u"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":95.08,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"ecmascript 2017,javascript","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"object-fit":{"title":"CSS3 object-fit/object-position","description":"Method of specifying how an object (image or video) should fit inside its box. object-fit options include \"contain\" (fit according to aspect ratio), \"fill\" (stretches object to fill) and \"cover\" (overflows box but maintains ratio), where object-position allows the object to be repositioned like background-image does.","spec":"https://www.w3.org/TR/css3-images/","status":"cr","links":[{"url":"https://dev.opera.com/articles/view/css3-object-fit-object-position/","title":"Dev.Opera article"},{"url":"https://www.webplatform.org/docs/css/properties/object-fit","title":"WebPlatform Docs"},{"url":"https://github.com/bfred-it/object-fit-images/","title":"object-fit-images Polyfill for IE & Edge"},{"url":"https://developer.mozilla.org//docs/Web/CSS/object-fit","title":"MDN"},{"url":"https://developer.mozilla.org/docs/Web/CSS/object-fit","title":"MDN (object-fit)"},{"url":"https://developer.mozilla.org/docs/Web/CSS/object-position","title":"MDN (object-position)"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"a #2","17":"a #2","18":"a #2","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"a #1","9":"a #1","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"a #1","9.1":"a #1","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y x","12":"y x","15":"n","16":"n","17":"n","18":"n","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"y x","11.1":"y x","11.5":"y x","11.6":"y x","12.1":"y x"},"ios_saf":{"8":"a #1","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"a #1","9.0-9.2":"a #1","9.3":"a #1","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y x"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"y x","12":"y x","59":"y","11.1":"y x","11.5":"y x","12.1":"y x"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support in Safari refers to support for `object-fit` but not `object-position`.","2":"Partial support in Edge refers to `object-fit` only supporting `<img>` ([see this comment](https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/13603873/#comment-0))"},"usage_perc_y":96.71,"usage_perc_a":0.77,"ucprefix":false,"parent":"","keywords":"objectfit,objectposition","ie_id":"objectfitandobjectpositionimages,objectfitandobjectpositionvideocanvasetc","chrome_id":"5302669702856704","firefox_id":"","webkit_id":""},"object-observe":{"title":"Object.observe data binding","description":"Method for data binding, a now-withdrawn ECMAScript 7 proposal","spec":"http://wiki.ecmascript.org/doku.php?id=harmony:observe","status":"unoff","links":[{"url":"https://www.html5rocks.com/en/tutorials/es7/observe/","title":"Data-binding Revolutions with Object.observe()"},{"url":"https://github.com/MaxArt2501/object-observe","title":"Polyfill"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=800355","title":"Firefox tracking bug"},{"url":"https://esdiscuss.org/topic/an-update-on-object-observe","title":"An update on Object.observe"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"y","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"Support in Blink-based browsers is expected to be removed in future versions.","notes_by_num":{},"usage_perc_y":0.72,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"objectobserve","chrome_id":"6147094632988672","firefox_id":"","webkit_id":""},"object-values":{"title":"Object.values method","description":"The `Object.values()` method returns an array of a given object's own enumerable property values.","spec":"https://tc39.es/ecma262/#sec-object.values","status":"other","links":[{"url":"https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_objects/Object/values","title":"Object.values() on MDN Web Docs"},{"url":"https://github.com/es-shims/Object.values","title":"Polyfill"},{"url":"https://github.com/zloirock/core-js#ecmascript-object","title":"Polyfill for this feature is available in the core-js library"}],"categories":["JS"],"stats":{"ie":{"6":"p","7":"p","8":"p","9":"p","10":"p","11":"p","5.5":"p"},"edge":{"12":"n","13":"n","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"p","3":"p","4":"p","5":"p","6":"p","7":"p","8":"p","9":"p","10":"p","11":"p","12":"p","13":"p","14":"p","15":"p","16":"p","17":"p","18":"p","19":"p","20":"p","21":"p","22":"p","23":"p","24":"p","25":"p","26":"p","27":"p","28":"p","29":"p","30":"p","31":"p","32":"p","33":"p","34":"p","35":"p","36":"p","37":"p","38":"p","39":"p","40":"p","41":"p","42":"p","43":"p","44":"p","45":"p","46":"p","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"p","3.6":"p"},"chrome":{"4":"p","5":"p","6":"p","7":"p","8":"p","9":"p","10":"p","11":"p","12":"p","13":"p","14":"p","15":"p","16":"p","17":"p","18":"p","19":"p","20":"p","21":"p","22":"p","23":"p","24":"p","25":"p","26":"p","27":"p","28":"p","29":"p","30":"p","31":"p","32":"p","33":"p","34":"p","35":"p","36":"p","37":"p","38":"p","39":"p","40":"p","41":"p","42":"p","43":"p","44":"p","45":"p","46":"p","47":"p","48":"p","49":"p","50":"p","51":"p","52":"p","53":"p","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"p","5":"p","6":"p","7":"p","8":"p","9":"p","10":"p","11":"y","12":"y","13":"y","14":"y","3.1":"p","3.2":"p","5.1":"p","6.1":"p","7.1":"p","9.1":"p","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"p","11":"p","12":"p","15":"p","16":"p","17":"p","18":"p","19":"p","20":"p","21":"p","22":"p","23":"p","24":"p","25":"p","26":"p","27":"p","28":"p","29":"p","30":"p","31":"p","32":"p","33":"p","34":"p","35":"p","36":"p","37":"p","38":"p","39":"p","40":"p","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"p","10.0-10.1":"p","10.5":"p","10.6":"p","11.1":"p","11.5":"p","11.6":"p","12.1":"p"},"ios_saf":{"8":"p","14":"y","3.2":"p","4.0-4.1":"p","4.2-4.3":"p","5.0-5.1":"p","6.0-6.1":"p","7.0-7.1":"p","8.1-8.4":"p","9.0-9.2":"p","9.3":"p","10.0-10.2":"p","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"p"},"android":{"3":"p","4":"p","81":"y","2.1":"p","2.2":"p","2.3":"p","4.1":"p","4.2-4.3":"p","4.4":"p","4.4.3-4.4.4":"p"},"bb":{"7":"p","10":"p"},"op_mob":{"10":"p","11":"p","12":"p","59":"y","11.1":"p","11.5":"p","12.1":"p"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"p","11":"p"},"and_uc":{"12.12":"y"},"samsung":{"4":"p","5.0-5.4":"p","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"p"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":95.08,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"object,values","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"objectrtc":{"title":"Object RTC (ORTC) API for WebRTC","description":"Enables mobile endpoints to talk to servers and web browsers with Real-Time Communications (RTC) capabilities via native and simple JavaScript APIs","spec":"https://www.w3.org/community/ortc/","status":"other","links":[{"url":"http://blogs.msdn.com/b/ie/archive/2014/10/27/bringing-interoperable-real-time-communications-to-the-web.aspx","title":"Bringing Interoperable Real-Time Communications to the Web"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n #1"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"ORTC is often dubbed WebRTC 1.1. It is possible to make ORTC communicate with WebRTC 1.0 endpoints. See [WebRTC 1.0](https://caniuse.com/#feat=rtcpeerconnection) for support details for that API.","notes_by_num":{},"usage_perc_y":0.38,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"RTC,WebRTC,ORTC,ObjectRTC,RTCIceTransport,RTCIceGatherer,RTCRtpSender,RTCRtpReceiver,Real Time,video,webcam","ie_id":"webrtcobjectrtcapi","chrome_id":"","firefox_id":"","webkit_id":""},"offline-apps":{"title":"Offline web applications","description":"Now deprecated method of defining web page files to be cached using a cache manifest file, allowing them to work offline on subsequent visits to the page. ","spec":"https://html.spec.whatwg.org/multipage/browsers.html#offline","status":"unoff","links":[{"url":"https://www.sitepoint.com/offline-web-application-tutorial/","title":"Sitepoint tutorial"},{"url":"http://diveintohtml5.info/offline.html","title":"Dive Into HTML5 article"},{"url":"https://hacks.mozilla.org/2010/01/offline-web-applications/","title":"Mozilla Hacks article/demo"},{"url":"https://www.webplatform.org/docs/apis/appcache/ApplicationCache","title":"WebPlatform Docs"}],"categories":["HTML5"],"stats":{"ie":{"6":"p","7":"p","8":"p","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"n","86":"n","87":"n"},"firefox":{"2":"p","3":"a","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"n","85":"n","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"p","3.2":"p","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"p","10.5":"p","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"n","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"n"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"This technology is being deprecated in favor of [Service Workers](https://caniuse.com/#feat=serviceworkers)","notes_by_num":{},"usage_perc_y":32.03,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"appcache,applicationcache,app cache,application cache,online","ie_id":"applicationcache","chrome_id":"6192449487634432","firefox_id":"","webkit_id":""},"offscreencanvas":{"title":"OffscreenCanvas","description":"OffscreenCanvas allows canvas drawing to occur with no connection to the DOM and can be used inside workers.","spec":"https://html.spec.whatwg.org/multipage/canvas.html#the-offscreencanvas-interface","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/OffscreenCanvas","title":"MDN article"},{"url":"https://hacks.mozilla.org/2016/01/webgl-off-the-main-thread/","title":"WebGL off the main thread - Mozilla Hacks article"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n d #1","45":"n d #1","46":"n d #1","47":"n d #1","48":"n d #1","49":"n d #1","50":"n d #1","51":"n d #1","52":"n d #1","53":"n d #1","54":"n d #1","55":"n d #1","56":"n d #1","57":"n d #1","58":"n d #1","59":"n d #1","60":"n d #1","61":"n d #1","62":"n d #1","63":"n d #1","64":"n d #1","65":"n d #1","66":"n d #1","67":"n d #1","68":"n d #1","69":"n d #1","70":"n d #1","71":"n d #1","72":"n d #1","73":"n d #1","74":"n d #1","75":"n d #1","76":"n d #1","77":"n d #1","78":"n d #1","79":"n d #1","80":"n d #1","81":"n d #1","82":"n d #1","83":"n d #1","84":"n d #1","85":"n d #1","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n d #2","59":"n d #2","60":"n d #2","61":"n d #2","62":"n d #2","63":"n d #2","64":"n d #2","65":"n d #2","66":"n d #2","67":"n d #2","68":"n d #2","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n d #2","46":"n d #2","47":"n d #2","48":"n d #2","49":"n d #2","50":"n d #2","51":"n d #2","52":"n d #2","53":"n d #2","54":"n d #2","55":"n d #2","56":"n d #2","57":"n d #2","58":"n d #2","60":"n d #2","62":"n d #2","63":"n d #2","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n d #1"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n d #1"}},"notes":"","notes_by_num":{"1":"Can be enabled via the `gfx.offscreencanvas.enabled` flag. Currently only supports WebGL contexts, not 2D.","2":"Can be enabled via the `Experimental canvas features` flag"},"usage_perc_y":72.75,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"5681560598609920","firefox_id":"","webkit_id":""},"ogg-vorbis":{"title":"Ogg Vorbis audio format","description":"Vorbis is a free and open source audio format, most commonly used with the Ogg container.","spec":"https://www.xiph.org/vorbis/doc/Vorbis_I_spec.html","status":"other","links":[{"url":"https://en.wikipedia.org/wiki/Vorbis","title":"Wikipedia article"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"u","2.2":"u","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Support refers to this format's use in the `audio` element, not other conditions.","notes_by_num":{},"usage_perc_y":80.63,"usage_perc_a":0,"ucprefix":false,"parent":"audio","keywords":".ogg,.oga,application/ogg,audio/ogg","ie_id":"vorbisaudiocodec,oggcontainer","chrome_id":"","firefox_id":"","webkit_id":""},"ogv":{"title":"Ogg/Theora video format","description":"Free lossy video compression format.","spec":"https://theora.org/doc/","status":"other","links":[{"url":"https://en.wikipedia.org/wiki/Theora","title":"Wikipedia article"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"p","10":"p","11":"p","5.5":"n"},"edge":{"12":"p","13":"p","14":"p","15":"p","16":"p","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"y"},"ie_mob":{"10":"p","11":"p"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":43.58,"usage_perc_a":0,"ucprefix":false,"parent":"video","keywords":"xiph","ie_id":"theoravideocodec,oggcontainer","chrome_id":"","firefox_id":"","webkit_id":""},"ol-reversed":{"title":"Reversed attribute of ordered lists","description":"This attribute makes an ordered list number its items in descending order (large to small), instead of ascending order (small to large; the default). The order that the list items are displayed in is not affected.","spec":"https://html.spec.whatwg.org/multipage/semantics.html#attr-ol-reversed","status":"ls","links":[{"url":"http://html5doctor.com/ol-element-attributes/","title":"HTML5 Doctor article on <ol> element attributes (including reversed)"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6514423-ol-reversed-attribute","title":"Microsoft Edge feature request on UserVoice"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"u","17":"u","18":"u","19":"u","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"u","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"u","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":97.32,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"reversed,list,ol,attribute","ie_id":"olreversedattribute","chrome_id":"","firefox_id":"","webkit_id":""},"once-event-listener":{"title":"\"once\" event listener option","description":"Causes an event listener to be automatically removed after it gets invoked, so that it only gets invoked once. Similar to jQuery's `$.one()` feature.","spec":"https://dom.spec.whatwg.org/#dom-addeventlisteneroptions-once","status":"ls","links":[{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=615384","title":"Chromium Issue 615384: Support \"once\" event listener option"},{"url":"http://jsbin.com/zigiru/edit?html,js,output","title":"JS Bin testcase"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/17702248-implement-once-event-listener-option","title":"MS Edge feature request on UserVoice"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":94.83,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"event,listener,options,once","ie_id":"eventlisteneronceoption","chrome_id":"5630331130478592","firefox_id":"","webkit_id":""},"online-status":{"title":"Online/offline status","description":"Events to indicate when the user's connected (`online` and `offline` events) and the `navigator.onLine` property to see current status.","spec":"https://html.spec.whatwg.org/multipage/browsers.html#browser-state","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/NavigatorOnLine.onLine#Specification","title":"MDN Web Docs - NavigatorOnLine.onLine"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"a #2","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a #3","5":"a #3","6":"a #3","7":"a #3","8":"a #3","9":"a #3","10":"a #3","11":"a #3","12":"a #3","13":"a #3","14":"a #3","15":"a #3","16":"a #3","17":"a #3","18":"a #3","19":"a #3","20":"a #3","21":"a #3","22":"a #3","23":"a #3","24":"a #3","25":"a #3","26":"a #3","27":"a #3","28":"a #3","29":"a #3","30":"a #3","31":"a #3","32":"a #3","33":"a #3","34":"a #3","35":"a #3","36":"a #3","37":"a #3","38":"a #3","39":"a #3","40":"a #3","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"a"},"ios_saf":{"8":"y","14":"y","3.2":"u","4.0-4.1":"u","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"u","2.2":"u","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"a #1","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"\"online\" does not always mean connection to the internet, it can also just mean connection to some network.\r\n\r\nEarly versions of Chrome and Safari always reported \"true\" for `navigator.onLine`","notes_by_num":{"0":"Safari 7.0 supports only the event listener on `window`, and not on `document.body`","1":"Seems to support `navigator.onLine` but not `online`/`offline` events.","2":"IE8 only supports the `online`/`offline` events on `document.body`, rather than `window`.","3":"Desktop Firefox responds to the status of its \"Work Offline\" mode. If not in that mode, `navigator.onLine` is always `true`, regardless of the actual network connectivity status. [See bug](https://bugzilla.mozilla.org/show_bug.cgi?id=654579) for details."},"usage_perc_y":98.31,"usage_perc_a":0.32,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"opus":{"title":"Opus","description":"Royalty-free open audio codec by IETF, which incorporated SILK from Skype and CELT from Xiph.org, to serve higher sound quality and lower latency at the same bitrate.","spec":"https://tools.ietf.org/html/rfc6716","status":"other","links":[{"url":"https://hacks.mozilla.org/2012/07/firefox-beta-15-supports-the-new-opus-audio-format/","title":"Introduction of Opus by Mozilla"},{"url":"http://www.ietf.org/mail-archive/web/rtcweb/current/msg04953.html","title":"Google's statement about the use of VP8 and Opus codec for WebRTC standard"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6513488-ogg-vorbis-and-opus-audio-formats-support-firefox","title":"Microsoft Edge feature request on UserVoice"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"a #1","12":"a #1","13":"a #1","14":"a #1","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"a #1","12.1":"a #1","13.1":"a #1","TP":"a #1"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"a #1","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"a #1","11.3-11.4":"a #1","12.0-12.1":"a #1","12.2-12.4":"a #1","13.0-13.1":"a #1","13.2":"a #1","13.3":"a #1","13.4-13.7":"a #1"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Support refers to this format's use in the `audio` element, not other conditions.\r\n\r\nFor Opera the Linux version may be able to play it when the GStreamer module is up to date and the served mime-type is 'audio/ogg'.","notes_by_num":{"1":"Supported only when packaged in a CAF file and on macOS High Sierra/iOS 11 or later."},"usage_perc_y":79.92,"usage_perc_a":15.66,"ucprefix":false,"parent":"audio","keywords":"","ie_id":"opusaudioplayback","chrome_id":"4891189287321600","firefox_id":"","webkit_id":""},"orientation-sensor":{"title":"Orientation Sensor","description":"Defines a base orientation sensor interface and concrete sensor subclasses to monitor the device’s physical orientation in relation to a stationary three dimensional Cartesian coordinate system.","spec":"https://www.w3.org/TR/orientation-sensor/","status":"cr","links":[{"url":"https://intel.github.io/generic-sensor-demos/orientation-phone/","title":"Demo"},{"url":"https://developers.google.com/web/updates/2017/09/sensors-for-the-web#orientation-sensors","title":"Article"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n d #1","59":"n d #1","60":"n d #1","61":"n d #1","62":"n d #1","63":"n d #1","64":"n d #1","65":"n d #1","66":"n d #1","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Available by enabling the \"Generic Sensor\" experimental flag in `about:flags`"},"usage_perc_y":69.97,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"5698781827825664","firefox_id":"","webkit_id":""},"outline":{"title":"CSS outline properties","description":"The CSS outline properties draw a border around an element that does not affect layout, making it ideal for highlighting. This covers the `outline` shorthand, as well as `outline-width`, `outline-style`, `outline-color` and `outline-offset`. ","spec":"https://drafts.csswg.org/css-ui/","status":"cr","links":[{"url":"https://drafts.csswg.org/css-ui-3/#outline","title":"CSS Basic User Interface Module Level 3"},{"url":"https://developer.mozilla.org/en-US/docs/CSS/outline","title":"MDN Web Docs - CSS outline"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"a #2","9":"a #1 #2","10":"a #1 #2","11":"a #1 #2","5.5":"n"},"edge":{"12":"a #1 #2","13":"a #1 #2","14":"a #1 #2","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"a #2","11":"a #2","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"a #2","10.0-10.1":"a #2","10.5":"a #2","10.6":"a #2","11.1":"a #2","11.5":"a #2","11.6":"y","12.1":"y #1"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"a #2","11":"a #2","12":"y","59":"y","11.1":"a #2","11.5":"a #2","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #1 #2","11":"a #1 #2"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Firefox also supports the non-standard `-moz-outline-radius` property that acts similar to `border-radius`.","notes_by_num":{"1":"Also supports the value of `invert` for `outline-color`. (support of this value is optional for browsers)","2":"Does not support `outline-offset`."},"usage_perc_y":97.3,"usage_perc_a":1.5,"ucprefix":false,"parent":"","keywords":"-moz-outline,outline-width,outline-style,outline-color,outline-radius","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"pad-start-end":{"title":"String.prototype.padStart(), String.prototype.padEnd()","description":"The `padStart()` and `padEnd()` methods pad the current string with a given string (eventually repeated) so that the resulting string reaches a given length. The pad is applied from the start (left) of the current string for `padStart()`, and applied from the end (right) of the current string for `padEnd()`.","spec":"https://tc39.es/ecma262/#sec-string.prototype.padend","status":"other","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart","title":"MDN Web Docs - padStart()"},{"url":"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padEnd","title":"MDN Web Docs - padEnd()"},{"url":"https://github.com/zloirock/core-js#ecmascript-string-and-regexp","title":"Polyfill for this feature is available in the core-js library"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":95.03,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"pad,pad start,pad end","ie_id":"","chrome_id":"5694172086403072","firefox_id":"","webkit_id":""},"page-transition-events":{"title":"PageTransitionEvent","description":"Fired at the Window when the page's entry in the session history stops being the current entry. Includes the `pageshow` and `pagehide` events.","spec":"https://html.spec.whatwg.org/multipage/indices.html#event-pageshow","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/Events/pageshow","title":"MDN Web Docs - pageshow"},{"url":"https://www.w3schools.com/tags/ev_onpageshow.asp","title":"HTML onpageshow Event Attribute"}],"categories":["HTML5","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"u","2.2":"u","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":98.38,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"history,page,transition,hide,show,bfcache,event,persisted","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"pagevisibility":{"title":"Page Visibility","description":"JavaScript API for determining whether a document is visible on the display","spec":"https://www.w3.org/TR/page-visibility/","status":"rec","links":[{"url":"https://developer.mozilla.org/en-US/docs/DOM/Using_the_Page_Visibility_API","title":"MDN Web Docs - Page Visibility"},{"url":"https://docs.webplatform.org/wiki/dom/Document/visibilityState","title":"WebPlatform Docs"},{"url":"https://www.sitepoint.com/introduction-to-page-visibility-api/","title":"SitePoint article"},{"url":"http://aurelio.audero.it/demo/page-visibility-api-demo.html","title":"Demo"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y x","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":98.05,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"visibilitystate,visibilitychange,onvisibilitychange","ie_id":"pagevisibilityapi","chrome_id":"5689697795833856","firefox_id":"page-visibility","webkit_id":""},"passive-event-listener":{"title":"Passive event listeners","description":"Event listeners created with the `passive: true` option cannot cancel (`preventDefault()`) the events they receive. Primarily intended to be used with touch events and `wheel` events. Since they cannot prevent scrolls, passive event listeners allow the browser to perform optimizations that result in smoother scrolling.","spec":"https://dom.spec.whatwg.org/#dom-addeventlisteneroptions-passive","status":"ls","links":[{"url":"https://developers.google.com/web/updates/2016/06/passive-event-listeners?hl=en","title":"Improving scroll performance with passive event listeners - Google Developers Updates"},{"url":"https://github.com/WICG/EventListenerOptions/blob/gh-pages/EventListenerOptions.polyfill.js","title":"Polyfill from the WICG"},{"url":"https://github.com/WICG/EventListenerOptions","title":"Original WICG EventListenerOptions repository"},{"url":"http://jsbin.com/jaqaku/edit?html,js,output","title":"JS Bin testcase"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":94.93,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"passive,event,listener,options","ie_id":"passiveeventlisteners","chrome_id":"5745543795965952","firefox_id":"passive-event-listeners","webkit_id":""},"path2d":{"title":"Path2D","description":"Allows path objects to be declared on 2D canvas surfaces","spec":"https://html.spec.whatwg.org/multipage/canvas.html#path2d-objects","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Path2D","title":"MDN article"}],"categories":["Canvas","HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","59":"a #1","60":"a #1","61":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #1","66":"a #1","67":"a #1","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"a #1","9":"a #1","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"a #1","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"u","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"a #1","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"a #1","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"a #1"},"samsung":{"4":"a #1","5.0-5.4":"a #1","6.2-6.4":"a #1","7.2-7.4":"a #1","8.2":"a #1","9.2":"a #1","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"a #1"},"baidu":{"7.12":"a #1"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Does not support the `addPath()` method"},"usage_perc_y":93.07,"usage_perc_a":3.41,"ucprefix":false,"parent":"canvas","keywords":"addpath","ie_id":"canvas2dpath2d","chrome_id":"","firefox_id":"","webkit_id":""},"payment-request":{"title":"Payment Request API","description":"Payment Request is a new API for the open web that makes checkout flows easier, faster and consistent on shopping sites.","spec":"https://www.w3.org/TR/payment-request/","status":"cr","links":[{"url":"https://github.com/w3c/browser-payment-api/","title":"Spec discussion"},{"url":"https://developers.google.com/web/updates/2016/07/payment-request","title":"Bringing easy and fast checkout with Payment Request API"},{"url":"https://developers.google.com/web/fundamentals/discovery-and-monetization/payment-request/","title":"Payment Request API Integration Guide"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Payment_Request_API","title":"MDN Web Docs - Payment Request API"},{"url":"https://emerald-eon.appspot.com/","title":"Demo"},{"url":"https://googlechrome.github.io/samples/paymentrequest/","title":"Simpler Demos and Codes"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n d #2","15":"a #7","16":"a #7","17":"a #7","18":"a #7","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n d #6","56":"n d #6","57":"n d #6","58":"n d #6","59":"n d #6","60":"n d #6","61":"n d #6","62":"n d #6","63":"n d #6","64":"n d #6","65":"n d #6","66":"a d #8","67":"a d #8","68":"a d #8","69":"a d #8","70":"a d #8","71":"a d #8","72":"a d #8","73":"a d #8","74":"a d #8","75":"a d #8","76":"a d #8","77":"a d #8","78":"a d #8","79":"a d #8","80":"a d #8","81":"a d #8","82":"a d #8","83":"a d #8","84":"a d #8","85":"a d #8","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n d #1","54":"n d #1","55":"n d #1","56":"n d #1","57":"n d #1","58":"n d #1","59":"n d #4","60":"n d #4","61":"a #7","62":"a #7","63":"a #7","64":"a #7","65":"a #7","66":"a #7","67":"a #7","68":"a #7","69":"a #7","70":"a #7","71":"a #7","72":"a #7","73":"a #7","74":"a #7","75":"a #7","76":"a #7","77":"a #7","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n #3","11":"n #3","12":"a #7","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n #3","11.1":"a #7","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n d #1","41":"n d #1","42":"n d #1","43":"n d #1","44":"n d #1","45":"n d #1","46":"n d #1","47":"n d #1","48":"a #7","49":"a #7","50":"a #7","51":"a #7","52":"a #7","53":"a #7","54":"a #7","55":"a #7","56":"a #7","57":"a #7","58":"a #7","60":"a #7","62":"a #7","63":"a #7","64":"a #7","65":"a #7","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n #3","10.3":"n #3","11.0-11.2":"n #3","11.3-11.4":"a #7","12.0-12.1":"a #7","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y #5"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"a #7","6.2-6.4":"a #7","7.2-7.4":"a #7","8.2":"a #7","9.2":"a #7","10.1":"a #7","11.1-11.2":"a #7","12.0":"y"},"and_qq":{"10.4":"a #7"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"Apple provides an equivalent proprietary API called [Apple Pay JS](https://developer.apple.com/reference/applepayjs/). Google provides a [PaymentRequest wrapper for Apple Pay JS](https://github.com/GoogleChrome/appr-wrapper).","notes_by_num":{"1":"Can be enabled via the \"Experimental Web Platform features\" flag","2":"Can be enabled via the \"Experimental Web Payments API\" flag","3":"Apple's proprietary implementation (see above)","4":"Can be enabled via the \"[Web Payments API](chrome://flags/#web-payments)\" flag","5":"Unlike Desktop Chrome, support has been in Chrome for Android since version 53.","6":"Can be enabled via the `dom.payments.request.enabled` flag in \"about:config\" flag since 55.","7":"Missing support for PaymentResponse.prototype.retry() method","8":"Disabled by default in Nightly. To enable, go to \"about:config\" and set \"dom.payments.request.enabled\" to true, and \"dom.payments.request.supportedRegions\" to \"US,CA\"."},"usage_perc_y":86.71,"usage_perc_a":6.03,"ucprefix":false,"parent":"","keywords":"PaymentRequest,Web Payments","ie_id":"paymentrequestapi","chrome_id":"5639348045217792","firefox_id":"payment-request","webkit_id":"feature-payment-request"},"pdf-viewer":{"title":"Built-in PDF viewer","description":"Support for an PDF viewer that is part of the browser, rather than requiring a PDF file to be opened in an external application.","spec":"https://www.adobe.com/content/dam/acom/en/devnet/pdf/pdfs/PDF32000_2008.pdf","status":"other","links":[{"url":"https://pdfobject.com","title":"PDFObject - JavaScript utility to embed PDF documents in HTML"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"a #1","5.5":"n"},"edge":{"12":"u","13":"u","14":"u","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"u","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"u","10":"u"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"u","11":"u"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"When displaying PDFs inline rather than separately, iOS Safari will only display the first page of the document.","notes_by_num":{"1":"Not supported in IE11 before Windows 10"},"usage_perc_y":58.57,"usage_perc_a":1.09,"ucprefix":false,"parent":"","keywords":"pdf reader","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"permissions-api":{"title":"Permissions API","description":"High-level JavaScript API for checking and requesting permissions","spec":"https://w3c.github.io/permissions/","status":"unoff","links":[{"url":"http://updates.html5rocks.com/2015/04/permissions-api-for-the-web","title":"Permission API samples and examples"},{"url":"https://github.com/jimmywarting/browser-su","title":"Extended \"polyfill\" version of permission API"}],"categories":["JS API","Security"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":77.97,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"web-permissions,navigator.permissions","ie_id":"","chrome_id":"6376494003650560","firefox_id":"permissions","webkit_id":""},"permissions-policy":{"title":"Permissions Policy","description":"A security mechanism that allows developers to explicitly enable or disable various powerful browser features for a given site. Similar to [Document Policy](#feat=document-policy).","spec":"https://w3c.github.io/webappsec-feature-policy/","status":"wd","links":[{"url":"https://github.com/w3c/webappsec-feature-policy/blob/master/permissions-policy-explainer.md","title":"W3C - Permissions Policy Explainer"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1531012","title":"Firefox implementation tracker"}],"categories":["JS API","Other","Security"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n #2","80":"n #2","81":"n #2","83":"n #2","84":"n #2","85":"n #2","86":"n #2","87":"n #2"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n #2","75":"n #2","76":"n #2","77":"n #2","78":"n #2","79":"n #2","80":"n #2","81":"n #2","82":"n #2","83":"n #2","84":"n #2","85":"n #2","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n #2","61":"n #2","62":"n #2","63":"n #2","64":"n #2","65":"n #2","66":"n #2","67":"n #2","68":"n #2","69":"n #2","70":"n #2","71":"n #2","72":"n #2","73":"n #2","74":"n #2","75":"n #2","76":"n #2","77":"n #2","78":"n #2","79":"n #2","80":"n #2","81":"n #2","83":"n #2","84":"n #2","85":"n #2","86":"n d #1 #2","87":"n d #1 #2","88":"n d #1 #2","89":"n d #1 #2","90":"n d #1 #2"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n #2","13":"n #2","14":"n #2","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n #2","12.1":"n #2","13.1":"n #2","TP":"n #2"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n #2","48":"n #2","49":"n #2","50":"n #2","51":"n #2","52":"n #2","53":"n #2","54":"n #2","55":"n #2","56":"n #2","57":"n #2","58":"n #2","60":"n #2","62":"n #2","63":"n #2","64":"n #2","65":"n #2","66":"n #2","67":"n #2","68":"n #2","69":"n #2","70":"n #2","71":"n #2","72":"n #2","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n #2","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n #2","12.0-12.1":"n #2","12.2-12.4":"n #2","13.0-13.1":"n #2","13.2":"n #2","13.3":"n #2","13.4-13.7":"n #2"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n #2","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n #2"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n #2","9.2":"n #2","10.1":"n #2","11.1-11.2":"n #2","12.0":"n #2"},"and_qq":{"10.4":"n #2"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"Standard support includes the HTTP `Permissions-Policy` header, `allow` attribute on iframes and the `document.permissionsPolicy` JS API.","notes_by_num":{"1":"Can be enabled in Chromium browsers with the `enable-experimental-web-platform-features` flag.","2":"At least partially supports [Feature Policy](#feat=feature-policy), the predecessor to this spec."},"usage_perc_y":0,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"feature,security,header,allow,attribute,allow attribute,attribute allow,feature policy,feature-policy,document.featurePolicy,document.policy,permissions-policy,document.permissionsPolicy","ie_id":"","chrome_id":"5745992911552512","firefox_id":"","webkit_id":""},"picture":{"title":"Picture element","description":"A responsive images method to control which image resource a user agent presents to a user, based on resolution, media query and/or support for a particular image format","spec":"https://html.spec.whatwg.org/multipage/embedded-content.html#the-picture-element","status":"ls","links":[{"url":"http://responsiveimages.org/demos/","title":"Demo"},{"url":"https://code.tutsplus.com/tutorials/better-responsive-images-with-the-picture-element--net-36583","title":"Tutorial"},{"url":"http://usecases.responsiveimages.org/","title":"Read about the use cases"},{"url":"http://responsiveimages.org/","title":"General information about Responsive Images"},{"url":"https://dev.opera.com/articles/responsive-images/","title":"Blog post on usage"},{"url":"https://www.html5rocks.com/tutorials/responsive/picture-element/","title":"HTML5 Rocks tutorial"},{"url":"https://github.com/scottjehl/picturefill","title":"Picturefill - polyfill for picture, srcset, sizes, and more"}],"categories":["DOM","HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n d #3","35":"n d #3","36":"n d #3","37":"n d #3","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n d #1","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n d #2","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Enabled in Chrome through the \"experimental Web Platform features\" flag in chrome://flags","2":"Enabled in Opera through the \"experimental Web Platform features\" flag in opera://flags","3":"Enabled in Firefox by setting the about:config preference dom.image.picture.enable to true"},"usage_perc_y":96.33,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"<picture>","ie_id":"pictureelement","chrome_id":"5910974510923776","firefox_id":"","webkit_id":"feature-picture-element"},"picture-in-picture":{"title":"Picture-in-Picture","description":"Allows websites to create a floating video window that is always on top of other windows so that users may continue consuming media while they interact with other sites or applications on their device.","spec":"https://wicg.github.io/picture-in-picture/","status":"unoff","links":[{"url":"https://googlechrome.github.io/samples/picture-in-picture/","title":"Sample video"},{"url":"https://developer.apple.com/documentation/webkitjs/adding_picture_in_picture_to_your_safari_media_controls","title":"Safari equivalent API"},{"url":"https://blogs.opera.com/desktop/2016/04/opera-beta-update-video-pop/","title":"Opera equivalent Video Pop Out feature"},{"url":"https://github.com/WICG/picture-in-picture/blob/master/implementation-status.md","title":"Implementation Status"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1519885","title":"Firefox implementation bug"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n d #4","68":"a #3 #1 #4","69":"a #3 #1 #4","70":"a #3 #1 #4","71":"a #2 #1 #4","72":"a #1","73":"a #1","74":"a #1","75":"a #1","76":"a #1","77":"a #1","78":"a #1","79":"a #1","80":"a #1","81":"a #1","82":"a #1","83":"a #1","84":"a #1","85":"a #1","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n d #5","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"a #6","11":"a #6","12":"a #6","13":"a #6","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"a #6","11.1":"a #6","12.1":"a #6","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"a #7","38":"a #7","39":"a #7","40":"a #7","41":"a #7","42":"a #7","43":"a #7","44":"a #7","45":"a #7","46":"a #7","47":"a #7","48":"a #7","49":"a #7","50":"a #7","51":"a #7","52":"a #7","53":"a #7","54":"a #7","55":"a #7","56":"a #7","57":"a #7","58":"a #7","60":"a #7","62":"a #7","63":"a #7","64":"a #7","65":"a #7","66":"a #7","67":"a #7","68":"a #7","69":"a #7","70":"a #7","71":"a #7","72":"a #7","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"a #6","9.3":"a #6","10.0-10.2":"a #6","10.3":"a #6","11.0-11.2":"a #6","11.3-11.4":"a #6","12.0-12.1":"a #6","12.2-12.4":"a #6","13.0-13.1":"a #6","13.2":"a #6","13.3":"a #6","13.4-13.7":"a #6"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a #8"},"and_ff":{"82":"a #8"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Partial support in Firefox refers to the fact that Mozilla provides an equivalent proprietary feature, which allows users to use Picture-in-Picture mode for all playing videos.","2":"Partial support in Firefox 71 refers to being enabled by default only for Windows users.","3":"Partial support in Firefox 68–70 refers to being enabled by default in Firefox pre-release channels for Windows users only.","4":"Can be enabled in Firefox via the `media.videocontrols.picture-in-picture.enabled` pref in `about:config`.","5":"Can be enabled in Chrome via the `#enable-picture-in-picture` & `#enable-surfaces-for-videos` flags in `chrome://flags`.","6":"Partial support in Safari refers to the fact that Apple provides an equivalent proprietary API for Picture-in-Picture, which is only supported by macOS 10.12 Sierra & iOS 9 and newer.","7":"Partial support in Opera refers to the fact that Opera provides an equivalent proprietary feature named Video Pop Out, which allows users to use Picture-in-Picture mode for all playing videos.","8":"Automatically plays fullscreen videos in Picture-in-Picture mode after user hits Home Screen button. Only Android 8.0 Oreo and newer provide appropriate API for Picture-in-Picture."},"usage_perc_y":43.98,"usage_perc_a":45.88,"ucprefix":false,"parent":"","keywords":"Picture-in-Picture,PictureInPicture,pip,pop-out,autoPictureInPicture,disablePictureInPicture,auto,disable,picture in picture,pseudo","ie_id":"pictureinpicture","chrome_id":"5729206566649856","firefox_id":"","webkit_id":""},"ping":{"title":"Ping attribute","description":"When used on an anchor, this attribute signifies that the browser should send a ping request the resource the attribute points to.","spec":"https://html.spec.whatwg.org/multipage/semantics.html#ping","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-ping","title":"MDN Web Docs - Element ping attribute"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6996308-implement-hyperlink-auditing-aka-the-ping-attribu","title":"UserVoice request for ping attribute"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n d #1","4":"n d #1","5":"n d #1","6":"n d #1","7":"n d #1","8":"n d #1","9":"n d #1","10":"n d #1","11":"n d #1","12":"n d #1","13":"n d #1","14":"n d #1","15":"n d #1","16":"n d #1","17":"n d #1","18":"n d #1","19":"n d #1","20":"n d #1","21":"n d #1","22":"n d #1","23":"n d #1","24":"n d #1","25":"n d #1","26":"n d #1","27":"n d #1","28":"n d #1","29":"n d #1","30":"n d #1","31":"n d #1","32":"n d #1","33":"n d #1","34":"n d #1","35":"n d #1","36":"n d #1","37":"n d #1","38":"n d #1","39":"n d #1","40":"n d #1","41":"n d #1","42":"n d #1","43":"n d #1","44":"n d #1","45":"n d #1","46":"n d #1","47":"n d #1","48":"n d #1","49":"n d #1","50":"n d #1","51":"n d #1","52":"n d #1","53":"n d #1","54":"n d #1","55":"n d #1","56":"n d #1","57":"n d #1","58":"n d #1","59":"n d #1","60":"n d #1","61":"n d #1","62":"n d #1","63":"n d #1","64":"n d #1","65":"n d #1","66":"n d #1","67":"n d #1","68":"n d #1","69":"n d #1","70":"n d #1","71":"n d #1","72":"n d #1","73":"n d #1","74":"n d #1","75":"n d #1","76":"n d #1","77":"n d #1","78":"n d #1","79":"n d #1","80":"n d #1","81":"n d #1","82":"n d #1","83":"n d #1","84":"n d #1","85":"n d #1","3.5":"n d #1","3.6":"n d #1"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n d #1"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n d #1"}},"notes":"While still in the WHATWG specification, this feature was removed from the W3C HTML5 specification in 2010.","notes_by_num":{"1":"Disabled by default for [privacy reasons](http://kb.mozillazine.org/Browser.send_pings). Can be enabled via the `browser.send_pings` flag."},"usage_perc_y":92.72,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"ping,a.ping,a[ping],ping attribute","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"png-alpha":{"title":"PNG alpha transparency","description":"Semi-transparent areas in PNG files","spec":"https://www.w3.org/TR/PNG/","status":"rec","links":[{"url":"https://en.wikipedia.org/wiki/Portable_Network_Graphics","title":"Wikipedia"},{"url":"http://dillerdesign.com/experiment/DD_belatedPNG/","title":"Workaround for IE6"}],"categories":["PNG"],"stats":{"ie":{"6":"p","7":"y","8":"y","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"IE6 does support full transparency in 8-bit PNGs, which can sometimes be an alternative to 24-bit PNGs.","notes_by_num":{},"usage_perc_y":99.68,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"pointer":{"title":"Pointer events","description":"This specification integrates various inputs from mice, touchscreens, and pens, making separate implementations no longer necessary and authoring for cross-device pointers easier. Not to be mistaken with the unrelated \"pointer-events\" CSS property.","spec":"https://www.w3.org/TR/pointerevents/","status":"rec","links":[{"url":"http://blogs.msdn.com/b/ie/archive/2011/09/20/touch-input-for-ie10-and-metro-style-apps.aspx","title":"Implementation of Pointer Events in IE10"},{"url":"http://blogs.msdn.com/b/eternalcoding/archive/2013/01/16/hand-js-a-polyfill-for-supporting-pointer-events-on-every-browser.aspx","title":"Hand.js, the polyfill for browsers only supporting Touch Events"},{"url":"http://blogs.msdn.com/b/davrous/archive/2013/02/20/handling-touch-in-your-html5-apps-thanks-to-the-pointer-events-of-ie10-and-windows-8.aspx","title":"Article & tutorial"},{"url":"http://deeptissuejs.com","title":"Abstraction library for pointer events"},{"url":"https://github.com/jquery/PEP","title":"PEP: Pointer Events Polyfill"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Pointer_events","title":"Pointer Event API on MDN"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=822898","title":"Bugzilla@Mozilla: Bug 822898 - Implement pointer events"}],"categories":["DOM","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"a x #1","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"p","7":"p","8":"p","9":"p","10":"p","11":"p","12":"p","13":"p","14":"p","15":"p","16":"p","17":"p","18":"p","19":"p","20":"p","21":"p","22":"p","23":"p","24":"p","25":"p","26":"p","27":"p","28":"p","29":"p","30":"p","31":"p","32":"p","33":"p","34":"p","35":"p","36":"p","37":"p","38":"p","39":"p","40":"p","41":"p d #2","42":"p d #2","43":"p d #2","44":"p d #2","45":"p d #2","46":"p d #2","47":"p d #2","48":"p d #2","49":"p d #2","50":"p d #2","51":"p d #2","52":"p d #2","53":"p d #2","54":"p d #2","55":"p d #2","56":"p d #2","57":"p d #2","58":"p d #2","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"p","23":"p","24":"p","25":"p","26":"p","27":"p","28":"p","29":"p","30":"p","31":"p","32":"p","33":"p","34":"p","35":"p","36":"p","37":"p","38":"p","39":"p","40":"p","41":"p","42":"p","43":"p","44":"p","45":"p","46":"p","47":"p","48":"p","49":"p","50":"p","51":"p","52":"p d #3","53":"p d #3","54":"p d #3","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"p","8":"p","9":"p","10":"p","11":"p","12":"p","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"p","7.1":"p","9.1":"p","10.1":"p","11.1":"p","12.1":"p d #4","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"p","16":"p","17":"p","18":"p","19":"p","20":"p","21":"p","22":"p","23":"p","24":"p","25":"p","26":"p","27":"p","28":"p","29":"p","30":"p","31":"p","32":"p","33":"p","34":"p","35":"p","36":"p","37":"p","38":"p","39":"p d #3","40":"p d #3","41":"p d #3","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"p","14":"y","3.2":"p","4.0-4.1":"p","4.2-4.3":"p","5.0-5.1":"p","6.0-6.1":"p","7.0-7.1":"p","8.1-8.4":"p","9.0-9.2":"p","9.3":"p","10.0-10.2":"p","10.3":"p","11.0-11.2":"p","11.3-11.4":"p","12.0-12.1":"p","12.2-12.4":"p","13.0-13.1":"a #5 #6","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"p","4":"p","81":"y","2.1":"p","2.2":"p","2.3":"p","4.1":"p","4.2-4.3":"p","4.4":"p","4.4.3-4.4.4":"p"},"bb":{"7":"p","10":"p"},"op_mob":{"10":"n","11":"p","12":"p","59":"y","11.1":"p","11.5":"p","12.1":"p"},"and_chr":{"86":"y"},"and_ff":{"82":"p d #2"},"ie_mob":{"10":"a x","11":"y"},"and_uc":{"12.12":"p"},"samsung":{"4":"p","5.0-5.4":"n","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"p d #2"}},"notes":"Firefox, starting with version 28, provides the 'dom.w3c_pointer_events.enabled' flag to support this specification.","notes_by_num":{"1":"Partial support in IE10 refers the lack of pointerenter and pointerleave events.","2":"Firefox support is disabled by default and [only supports mouse input](https://hacks.mozilla.org/2015/08/pointer-events-now-in-firefox-nightly/). On Windows only, touch can be enabled with the `layers.async-pan-zoom.enabled` and `dom.w3c_touch_events.enabled` flags","3":"Can be enabled with the `#enable-pointer-events` flag.","4":"Can be enabled under the `Experimental Features` menu.","5":"element.releasePointerCapture(pointerID) is only partially implemented. Calling it after pointerdown does not result in boundary events (pointerover pointerleave) being dispatched during pointer movements.","6":"Value of pointerevent.buttons is incorrect on pointermove events generated by touches. Is 0 but should be 1."},"usage_perc_y":91.38,"usage_perc_a":0.18,"ucprefix":false,"parent":"","keywords":"pointerdown,pointermove,pointerup,pointercancel,pointerover,pointerout,pointerenter,pointerleave","ie_id":"pointerevents","chrome_id":"4504699138998272","firefox_id":"pointer-events","webkit_id":"specification-pointer-events-level-2"},"pointer-events":{"title":"CSS pointer-events (for HTML)","description":"This CSS property, when set to \"none\" allows elements to not receive hover/click events, instead the event will occur on anything behind it. ","spec":"https://wiki.csswg.org/spec/css4-ui#pointer-events","status":"unoff","links":[{"url":"https://robertnyman.com/2010/03/22/css-pointer-events-to-allow-clicks-on-underlying-elements/","title":"Article & tutorial"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/css.js#css-pointerevents","title":"has.js test"},{"url":"https://github.com/kmewhort/pointer_events_polyfill","title":"Polyfill"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Already part of the SVG specification, and all SVG-supporting browsers appear to support the property on SVG elements.","notes_by_num":{},"usage_perc_y":98.39,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"pointerevents,pointer-events:none","ie_id":"csspointerevents","chrome_id":"","firefox_id":"","webkit_id":""},"pointerlock":{"title":"Pointer Lock API","description":"API that provides access to raw mouse movement data. This is done by ignoring boundaries resulting from screen edges where the cursor can't go beyond, providing proper control for first person or real time strategy games. ","spec":"https://www.w3.org/TR/pointerlock/","status":"rec","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Pointer_Lock_API","title":"MDN Web Docs - Pointer Lock"},{"url":"http://mdn.github.io/pointer-lock-demo","title":"Simple demo"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n d","17":"n d","18":"n d","19":"n d","20":"n d","21":"n d","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":57.91,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"mouselock,pointer lock,mouse lock,requestPointerLock,pointerLockElement,exitPointerLock,movementX,movementY","ie_id":"pointerlockmouselock","chrome_id":"6753200417800192","firefox_id":"pointerlock","webkit_id":"specification-pointer-lock"},"portals":{"title":"Portals","description":"Portals enable seamless navigation between sites or pages. A new page can be loaded as an inset using the `<portal>` element (similar to an iframe) which can then seamlessly transition to the new navigated state when \"activated\".","spec":"https://wicg.github.io/portals/","status":"unoff","links":[{"url":"https://web.dev/hands-on-portals/","title":"Hands-on with Portals: seamless navigation on the Web"}],"categories":["HTML5","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n d #1 #2","86":"n d #1 #2","87":"n d #1 #2"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n d #1","76":"n d #1","77":"n d #1","78":"n d #1","79":"n d #1","80":"n d #1","81":"n d #1","83":"n d #1","84":"n d #1","85":"n d #1 #2","86":"n d #2","87":"n d #2","88":"n d #2","89":"n d #2","90":"n d #2"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n d #1","63":"n d #1","64":"n d #1","65":"n d #1","66":"n d #1","67":"n d #1","68":"n d #1","69":"n d #1","70":"n d #1","71":"n d #1","72":"n d #1","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n d #1 #2"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Available when registered for [origin trial](https://web.dev/hands-on-portals/#register-for-ot)","2":"Available by enabling the `#enable-portals` flag at `chrome://flags/`"},"usage_perc_y":0,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"portal api,portals api,portal element,htmlportalelement,portal.activate,onportalactivate","ie_id":"","chrome_id":"4828882419056640","firefox_id":"","webkit_id":""},"prefers-color-scheme":{"title":"prefers-color-scheme media query","description":"Media query to detect if the user has set their system to use a light or dark color theme.","spec":"https://drafts.csswg.org/mediaqueries-5/#prefers-color-scheme","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-color-scheme","title":"MDN article"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1494034","title":"Firefox implementation bug"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=889087","title":"Chromium implementation issue"},{"url":"https://web.dev/prefers-color-scheme/","title":"Web.dev article"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"Support will also depend on whether or not the OS has support for a light/dark theme preference.","notes_by_num":{},"usage_perc_y":88.64,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"prefers-dark-interface","ie_id":"","chrome_id":"5109758977638400","firefox_id":"","webkit_id":""},"prefers-reduced-motion":{"title":"prefers-reduced-motion media query","description":"CSS media query based on a user preference for preferring reduced motion (animation, etc).","spec":"https://drafts.csswg.org/mediaqueries-5/#prefers-reduced-motion","status":"wd","links":[{"url":"https://webkit.org/blog/7551/responsive-design-for-motion/","title":"WebKit blog post"},{"url":"https://css-tricks.com/introduction-reduced-motion-media-query/","title":"CSS Tricks article"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Currently expected to land in Firefox for Windows and Linux in Firefox 63, for MacOS it might be delayed to Firefox 64."},"usage_perc_y":91.85,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"no-preference","ie_id":"","chrome_id":"5597964353404928","firefox_id":"","webkit_id":""},"progress":{"title":"progress element","description":"Method of indicating a progress state.","spec":"https://html.spec.whatwg.org/multipage/forms.html#the-progress-element","status":"ls","links":[{"url":"https://css-tricks.com/html5-progress-element/","title":"CSS-Tricks article"},{"url":"https://developer.mozilla.org/en-US/docs/Web/HTML/Element/progress","title":"MDN Web Docs - Element progress"},{"url":"https://dev.opera.com/articles/new-form-features-in-html5/#newoutput","title":"Dev.Opera article"},{"url":"http://peter.sh/examples/?/html/meter-progress.html","title":"Examples of progress and meter elements"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"a #1","14":"a #1","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"a #1","8.1-8.4":"a #1","9.0-9.2":"a #1","9.3":"a #1","10.0-10.2":"a #1","10.3":"a #1","11.0-11.2":"a #1","11.3-11.4":"a #1","12.0-12.1":"a #1","12.2-12.4":"a #1","13.0-13.1":"a #1","13.2":"a #1","13.3":"a #1","13.4-13.7":"a #1"},"op_mini":{"all":"y"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"iOS Safari does not support \"indeterminate\" <progress> elements."},"usage_perc_y":86.74,"usage_perc_a":12.31,"ucprefix":false,"parent":"forms","keywords":"#progressmeter,<progress>","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"promise-finally":{"title":"Promise.prototype.finally","description":"When the promise is settled, whether fulfilled or rejected, the specified callback function is executed.","spec":"https://tc39.es/ecma262/#sec-promise.prototype.finally","status":"other","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/finally","title":"MDN Web Docs"},{"url":"https://github.com/zloirock/core-js#ecmascript-promise","title":"Polyfill for this feature is available in the core-js library"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":94.05,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"promise.finally","ie_id":"promiseprototypefinally","chrome_id":"5704570235781120","firefox_id":"","webkit_id":""},"promises":{"title":"Promises","description":"A promise represents the eventual result of an asynchronous operation.","spec":"https://tc39.es/ecma262/#sec-promise-objects","status":"other","links":[{"url":"http://promises-aplus.github.io/promises-spec/","title":"Promises/A+ spec"},{"url":"http://www.chromestatus.com/features/5681726336532480","title":"Chromium dashboard - ES6 Promises"},{"url":"https://www.html5rocks.com/en/tutorials/es6/promises/","title":"JavaScript Promises: There and back again - HTML5 Rocks"},{"url":"https://github.com/jakearchibald/ES6-Promises","title":"A polyfill for ES6-style Promises"},{"url":"https://github.com/zloirock/core-js#ecmascript-promise","title":"Polyfill for this feature is available in the core-js library"}],"categories":["JS"],"stats":{"ie":{"6":"p","7":"p","8":"p","9":"p","10":"p","11":"p","5.5":"p"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"p","3":"p","4":"p","5":"p","6":"p","7":"p","8":"p","9":"p","10":"p","11":"p","12":"p","13":"p","14":"p","15":"p","16":"p","17":"p","18":"p","19":"p","20":"p","21":"p","22":"p","23":"p","24":"p","25":"p","26":"p","27":"a","28":"a","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"p","3.6":"p"},"chrome":{"4":"p","5":"p","6":"p","7":"p","8":"p","9":"p","10":"p","11":"p","12":"p","13":"p","14":"p","15":"p","16":"p","17":"p","18":"p","19":"p","20":"p","21":"p","22":"p","23":"p","24":"p","25":"p","26":"p","27":"p","28":"p","29":"p","30":"p","31":"p","32":"a","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"p","5":"p","6":"p","7":"p","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"p","3.2":"p","5.1":"p","6.1":"p","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"p","11":"p","12":"p","15":"p","16":"p","17":"p","18":"p","19":"a","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"p","10.0-10.1":"p","10.5":"p","10.6":"p","11.1":"p","11.5":"p","11.6":"p","12.1":"p"},"ios_saf":{"8":"y","14":"y","3.2":"p","4.0-4.1":"p","4.2-4.3":"p","5.0-5.1":"p","6.0-6.1":"p","7.0-7.1":"p","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"p"},"android":{"3":"p","4":"p","81":"y","2.1":"p","2.2":"p","2.3":"p","4.1":"p","4.2-4.3":"p","4.4":"p","4.4.3-4.4.4":"y"},"bb":{"7":"p","10":"p"},"op_mob":{"10":"p","11":"p","12":"p","59":"y","11.1":"p","11.5":"p","12.1":"p"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"p","11":"p"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":96.62,"usage_perc_a":0.02,"ucprefix":false,"parent":"","keywords":"futures","ie_id":"","chrome_id":"5681726336532480","firefox_id":"promise","webkit_id":"feature-promise-objects"},"proximity":{"title":"Proximity API","description":"Defines events that provide information about the distance between a device and an object, as measured by a proximity sensor.","spec":"https://www.w3.org/TR/proximity/","status":"cr","links":[{"url":"http://aurelio.audero.it/demo/proximity-api-demo.html","title":"Demo"},{"url":"https://www.sitepoint.com/introducing-proximity-api/","title":"SitePoint article"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":4.13,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"proxy":{"title":"Proxy object","description":"The Proxy object allows custom behavior to be defined for fundamental operations. Useful for logging, profiling, object visualization, etc.","spec":"https://tc39.es/ecma262/#sec-proxy-objects","status":"other","links":[{"url":"https://github.com/lukehoban/es6features#proxies","title":"ECMAScript 6 Proxies"},{"url":"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy","title":"MDN Web Docs - Proxy"},{"url":"http://www.nczonline.net/blog/2011/09/15/experimenting-with-ecmascript-6-proxies/","title":"Experimenting with ECMAScript 6 proxies"},{"url":"http://www.2ality.com/2014/12/es6-proxies.html","title":"Meta programming with ECMAScript 6 proxies"},{"url":"https://github.com/tvcutsem/harmony-reflect","title":"Polyfill for Proxies"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n d","20":"n d","21":"n d","22":"n d","23":"n d","24":"n d","25":"n d","26":"n d","27":"n d","28":"n d","29":"n d","30":"n d","31":"n d","32":"n d","33":"n d","34":"n d","35":"n d","36":"n d","37":"n d","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n d","16":"n d","17":"n d","18":"n d","19":"n d","20":"n d","21":"n d","22":"n d","23":"n d","24":"n d","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":95.71,"usage_perc_a":0,"ucprefix":false,"parent":"es6","keywords":"proxies,es6,es2015,traps,meta,virtual,logging,host","ie_id":"proxieses6","chrome_id":"4811188005240832","firefox_id":"","webkit_id":"feature-proxy-objects"},"publickeypinning":{"title":"Public Key Pinning","description":"Declare that a website's HTTPS certificate should only be treated as valid if the public key is contained in a specified list to prevent MITM attacks that use valid CA-issued certificates.","spec":"https://tools.ietf.org/html/rfc7469","status":"other","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/Security/Public_Key_Pinning","title":"MDN Web Docs - Public Key Pinning"},{"url":"https://scotthelme.co.uk/im-giving-up-on-hpkp/","title":"Scott Helme article on the issues of HPKP"}],"categories":["Security"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"u","21":"u","22":"u","23":"a","24":"u","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"All browsers have removed support. The header was too complicated to use, and when incorrectly implemented, could completely block websites for longer periods of time.\r\n\r\n[Certificate transparency](https://developer.mozilla.org/en-US/docs/Web/Security/Certificate_Transparency) is widely used and tries to provide the same security by very different means.","notes_by_num":{},"usage_perc_y":3.71,"usage_perc_a":0.01,"ucprefix":false,"parent":"","keywords":"pkp,hpkp,security,header","ie_id":"publickeypinningextensionforhttp","chrome_id":"5903385005916160","firefox_id":"","webkit_id":""},"push-api":{"title":"Push API","description":"API to allow messages to be pushed from a server to a browser, even when the site isn't focused or even open in the browser.","spec":"https://w3c.github.io/push-api/","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Push_API","title":"MDN Web Docs - Push API"},{"url":"https://developers.google.com/web/updates/2015/03/push-notifications-on-the-open-web","title":"Google Developers article"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"y","18":"y","79":"y #2","80":"y #2","81":"y #2","83":"y #2","84":"y #2","85":"y #2","86":"y #2","87":"y #2"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"y #2","45":"y #2 #4","46":"y #2","47":"y #2","48":"y #2","49":"y #2","50":"y #2","51":"y #2","52":"y #2 #4","53":"y #2","54":"y #2","55":"y #2","56":"y #2","57":"y #2","58":"y #2","59":"y #2","60":"y #2 #4","61":"y #2","62":"y #2","63":"y #2","64":"y #2","65":"y #2","66":"y #2","67":"y #2","68":"y #2","69":"y #2","70":"y #2","71":"y #2","72":"y #2","73":"y #2","74":"y #2","75":"y #2","76":"y #2","77":"y #2","78":"y #2","79":"y #2","80":"y #2","81":"y #2","82":"y #2","83":"y #2","84":"y #2","85":"y #2","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"a #1 #2","45":"a #1 #2","46":"a #1 #2","47":"a #1 #2","48":"a #1 #2","49":"a #1 #2","50":"y #2","51":"y #2","52":"y #2","53":"y #2","54":"y #2","55":"y #2","56":"y #2","57":"y #2","58":"y #2","59":"y #2","60":"y #2","61":"y #2","62":"y #2","63":"y #2","64":"y #2","65":"y #2","66":"y #2","67":"y #2","68":"y #2","69":"y #2","70":"y #2","71":"y #2","72":"y #2","73":"y #2","74":"y #2","75":"y #2","76":"y #2","77":"y #2","78":"y #2","79":"y #2","80":"y #2","81":"y #2","83":"y #2","84":"y #2","85":"y #2","86":"y #2","87":"y #2","88":"y #2","89":"y #2","90":"y #2"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n #3","11":"n #3","12":"n #3","13":"n #3","14":"n #3","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n #3","10.1":"n #3","11.1":"n #3","12.1":"n #3","13.1":"n #3","TP":"n #3"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"u","38":"u","39":"u","40":"u","41":"u","42":"y #2","43":"y #2","44":"y #2","45":"y #2","46":"y #2","47":"y #2","48":"y #2","49":"y #2","50":"y #2","51":"y #2","52":"y #2","53":"y #2","54":"y #2","55":"y #2","56":"y #2","57":"y #2","58":"y #2","60":"y #2","62":"y #2","63":"y #2","64":"y #2","65":"y #2","66":"y #2","67":"y #2","68":"y #2","69":"y #2","70":"y #2","71":"y #2","72":"y #2","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y #2"}},"notes":"","notes_by_num":{"1":"Partial support refers to not supporting `PushEvent.data` and `PushMessageData`","2":"Requires full browser to be running to receive messages","3":"Safari supports a custom implementation https://developer.apple.com/notifications/safari-push-notifications/. WWDC video by apple : https://developer.apple.com/videos/play/wwdc2013/614/ ","4":"Disabled on Firefox ESR, but can be re-enabled with the `dom.serviceWorkers.enabled` and `dom.push.enabled` flags"},"usage_perc_y":79.38,"usage_perc_a":0.29,"ucprefix":false,"parent":"","keywords":"push notifications","ie_id":"pushapi","chrome_id":"5416033485586432","firefox_id":"push","webkit_id":""},"queryselector":{"title":"querySelector/querySelectorAll","description":"Method of accessing DOM elements using CSS selectors","spec":"https://dom.spec.whatwg.org/#dom-parentnode-queryselector","status":"ls","links":[{"url":"https://developer.mozilla.org/en/DOM/element.querySelector","title":"MDN Web Docs - querySelector"},{"url":"https://developer.mozilla.org/en/DOM/Element.querySelectorAll","title":"MDN Web Docs - querySelectorAll"},{"url":"http://cjihrig.com/blog/javascripts-selectors-api/","title":"Blog post"},{"url":"https://www.webplatform.org/docs/css/selectors_api/querySelector","title":"WebPlatform Docs"}],"categories":["DOM"],"stats":{"ie":{"6":"p","7":"p","8":"a #1","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"p","3":"p","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"p","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"p","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support in IE8 is due to being limited to [CSS 2.1 selectors](/#feat=css-sel2) and a small subset of [CSS 3 selectors](/#feat=css-sel3) (see notes there). Additionally, it will have trouble with selectors including unrecognized tags (for example HTML5 ones)."},"usage_perc_y":99.58,"usage_perc_a":0.07,"ucprefix":false,"parent":"","keywords":"query,selectors,selectors api,document.queryselector","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"readonly-attr":{"title":"readonly attribute of input and textarea elements","description":"Makes the form control non-editable. Unlike the `disabled` attribute, `readonly` form controls are still included in form submissions and the user can still select (but not edit) their value text.","spec":"https://html.spec.whatwg.org/multipage/input.html#the-readonly-attribute","status":"ls","links":[{"url":"https://html.spec.whatwg.org/multipage/forms.html#attr-textarea-readonly","title":"WHATWG HTML specification for the readonly attribute of the `<textarea>` element"},{"url":"https://developer.mozilla.org/en-US/docs/Web/HTML/Element/Input#attr-readonly","title":"MDN Web Docs - readonly attribute"}],"categories":["DOM","HTML5"],"stats":{"ie":{"6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","5.5":"u"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"u","3":"u","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"u","3.6":"u"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"u","16":"u","17":"u","18":"u","19":"u","20":"u","21":"u","22":"u","23":"u","24":"u","25":"u","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"u","5":"u","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"u","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"a #1","12":"a #1","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"u","10.0-10.1":"a #1","10.5":"a #1","10.6":"a #1","11.1":"a #1","11.5":"a #1","11.6":"a #1","12.1":"a #1"},"ios_saf":{"8":"y","14":"y","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"u","6.0-6.1":"u","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"u","2.2":"u","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"a #1","11":"a #1","12":"a #1","59":"y","11.1":"a #1","11.5":"a #1","12.1":"a #1"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y #2","11":"y #2"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Readonly inputs of type `datetime-local`, `date`, `month`, and `week` can still be edited by pressing the Up or Down arrow keys on the keyboard while the input is focused.","2":"Text cannot be selected directly, but is possible by first selecting any text around the field. "},"usage_perc_y":99.4,"usage_perc_a":0.06,"ucprefix":false,"parent":"","keywords":"readonly,read,attribute,edit,editable","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"referrer-policy":{"title":"Referrer Policy","description":"A policy that controls how much information is shared through the HTTP referrer header. Helps to protect user privacy.","spec":"https://www.w3.org/TR/referrer-policy/","status":"cr","links":[{"url":"https://blog.mozilla.org/security/2015/01/21/meta-referrer/","title":"Mozilla security article"},{"url":"https://scotthelme.co.uk/a-new-security-header-referrer-policy/","title":"A new security header: Referrer Policy"}],"categories":["Security"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"a #1","5.5":"n"},"edge":{"12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","79":"y","80":"y","81":"y","83":"y","84":"y #3","85":"y #3","86":"y #3","87":"y #3"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"a #2","22":"a #2","23":"a #2","24":"a #2","25":"a #2","26":"a #2","27":"a #2","28":"a #2","29":"a #2","30":"a #2","31":"a #2","32":"a #2","33":"a #2","34":"a #2","35":"a #2","36":"a #2","37":"a #2","38":"a #2","39":"a #2","40":"a #2","41":"a #2","42":"a #2","43":"a #2","44":"a #2","45":"a #2","46":"a #2","47":"a #2","48":"a #2","49":"a #2","50":"a #2","51":"a #2","52":"a #2","53":"a #2","54":"a #2","55":"a #2","56":"a #2","57":"a #2","58":"a #2","59":"a #2","60":"a #2","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y #3","86":"y #3","87":"y #3","88":"y #3","89":"y #3","90":"y #3"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"y","13":"y #4","14":"y #4","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"a #1","9.1":"a #1","10.1":"a #1","11.1":"y","12.1":"y","13.1":"y #4","TP":"y #4"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a #1","14":"y #4","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"a #1","9.0-9.2":"a #1","9.3":"a #1","10.0-10.2":"a #1","10.3":"a #1","11.0-11.2":"a #1","11.3-11.4":"a #1","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y #4","13.4-13.7":"y #4"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y #3"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Browsers initially supported an [early draft](https://wiki.whatwg.org/wiki/Meta_referrer) of the specification which can only use a meta tag and is only compatible with the `origin` value from the new spec.","2":"Chrome 21-60 did not support the `same-origin`, `strict-origin` and `strict-origin-when-cross-origin` values. ([issue 627968](https://bugs.chromium.org/p/chromium/issues/detail?id=627968))","3":"The default policy has been changed from `no-referrer-when-downgrade` to `strict-origin-when-cross-origin.` See [the revised spec.](https://github.com/w3c/webappsec-referrer-policy/pull/142)","4":"[Safari's ITP](https://webkit.org/blog/9661/preventing-tracking-prevention-tracking/) (on by default) downgrades _all_ cross-site subresource request (not page navigation) referrer headers to the page's origin, ignoring the `unsafe-url` referrer policy."},"usage_perc_y":94.23,"usage_perc_a":3.21,"ucprefix":false,"parent":"","keywords":"meta,referrer,referer","ie_id":"metareferrer","chrome_id":"5639972996513792,6251880185331712","firefox_id":"","webkit_id":"201353"},"registerprotocolhandler":{"title":"Custom protocol handling","description":"Method of allowing a webpage to handle a given protocol using `navigator.registerProtocolHandler`. This allows certain URLs to be opened by a given web application, for example `mailto:` addresses can be opened by a webmail client.","spec":"https://html.spec.whatwg.org/multipage/webappapis.html#custom-handlers","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Navigator/registerProtocolHandler","title":"MDN Web Docs - Register protocol handler"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y #1","80":"y #1","81":"y #1","83":"y #1","84":"y #1","85":"y #1","86":"y #1","87":"y #1"},"firefox":{"2":"n","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"y #1","14":"y #1","15":"y #1","16":"y #1","17":"y #1","18":"y #1","19":"y #1","20":"y #1","21":"y #1","22":"y #1","23":"y #1","24":"y #1","25":"y #1","26":"y #1","27":"y #1","28":"y #1","29":"y #1","30":"y #1","31":"y #1","32":"y #1","33":"y #1","34":"y #1","35":"y #1","36":"y #1","37":"y #1","38":"y #1","39":"y #1","40":"y #1","41":"y #1","42":"y #1","43":"y #1","44":"y #1","45":"y #1","46":"y #1","47":"y #1","48":"y #1","49":"y #1","50":"y #1","51":"y #1","52":"y #1","53":"y #1","54":"y #1","55":"y #1","56":"y #1","57":"y #1","58":"y #1","59":"y #1","60":"y #1","61":"y #1","62":"y #1","63":"y #1","64":"y #1","65":"y #1","66":"y #1","67":"y #1","68":"y #1","69":"y #1","70":"y #1","71":"y #1","72":"y #1","73":"y #1","74":"y #1","75":"y #1","76":"y #1","77":"y #1","78":"y #1","79":"y #1","80":"y #1","81":"y #1","83":"y #1","84":"y #1","85":"y #1","86":"y #1","87":"y #1","88":"y #1","89":"y #1","90":"y #1"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"y #1","15":"y #1","16":"y #1","17":"y #1","18":"y #1","19":"y #1","20":"y #1","21":"y #1","22":"y #1","23":"y #1","24":"y #1","25":"y #1","26":"y #1","27":"y #1","28":"y #1","29":"y #1","30":"y #1","31":"y #1","32":"y #1","33":"y #1","34":"y #1","35":"y #1","36":"y #1","37":"y #1","38":"y #1","39":"y #1","40":"y #1","41":"y #1","42":"y #1","43":"y #1","44":"y #1","45":"y #1","46":"y #1","47":"y #1","48":"y #1","49":"y #1","50":"y #1","51":"y #1","52":"y #1","53":"y #1","54":"y #1","55":"y #1","56":"y #1","57":"y #1","58":"y #1","60":"y #1","62":"y #1","63":"y #1","64":"y #1","65":"y #1","66":"y #1","67":"y #1","68":"y #1","69":"y #1","70":"y #1","71":"y #1","72":"y #1","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"y #1","12.1":"y #1"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"y #1"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Supports protocols `mailto`, `mms`, `nntp`, `rtsp`, and `webcal` but requires custom protocols to start with `web+`"},"usage_perc_y":41.48,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"rel-noopener":{"title":"rel=noopener","description":"Ensure new browsing contexts are opened without a useful `window.opener`","spec":"https://html.spec.whatwg.org/multipage/semantics.html#link-type-noopener","status":"ls","links":[{"url":"https://mathiasbynens.github.io/rel-noopener/","title":"Explainer"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1222516","title":"Gecko/Firefox issue"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=155166","title":"WebKit/Safari issue"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/12942405-implement-rel-noopener","title":"Edge feature request"}],"categories":["DOM","HTML5","Security"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":94.96,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"rel,relation,link,security","ie_id":"","chrome_id":"5651874132787200","firefox_id":"","webkit_id":""},"rel-noreferrer":{"title":"Link type \"noreferrer\"","description":"Links with `rel=\"noreferrer\"` set do not send the request's \"referrer\" header. This prevents the destination site from seeing what URL the user came from.","spec":"https://html.spec.whatwg.org/multipage/semantics.html#link-type-noreferrer","status":"ls","links":[{"url":"https://www.lifewire.com/rel-noreferrer-3468002","title":"Blog post on rel=\"noreferrer\""}],"categories":["DOM","HTML5","Security"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"a #1","5.5":"n"},"edge":{"12":"u","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"u","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"u","2.2":"u","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Only supported in IE11 in later versions of Windows 10 (creators update)."},"usage_perc_y":96.97,"usage_perc_a":1.09,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"rellist":{"title":"relList (DOMTokenList)","description":"Method of easily manipulating rel attribute values on elements, using the DOMTokenList object (similar to classList).","spec":"https://html.spec.whatwg.org/multipage/semantics.html#dom-a-rellist","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/DOM/DOMTokenList","title":"MDN Web Docs - DOMTokenList"},{"url":"https://github.com/jwilsson/domtokenlist","title":"domtokenlist polyfill"}],"categories":["DOM","HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"a #1","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","59":"a #1","60":"a #1","61":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"a #1"},"samsung":{"4":"n","5.0-5.4":"a #1","6.2-6.4":"a #1","7.2-7.4":"a #1","8.2":"a #1","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Support for relList on link but not anchor elements"},"usage_perc_y":93.97,"usage_perc_a":1.71,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"rem":{"title":"rem (root em) units","description":"Type of unit similar to `em`, but relative only to the root element, not any parent element. Thus compounding does not occur as it does with `em` units.","spec":"https://www.w3.org/TR/css3-values/#font-relative-lengths","status":"cr","links":[{"url":"http://snook.ca/archives/html_and_css/font-size-with-rem","title":"Article on usage"},{"url":"https://github.com/chuckcarpenter/REM-unit-polyfill","title":"REM Polyfill"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"a #1","10":"a #1","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"a #2","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"n","12":"y","59":"y","11.1":"n","11.5":"n","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"IE 9 & IE 10 do not support `rem` units when used in the `font` shorthand property (the entire declaration is ignored) or when used on pseudo elements.","2":"iOS Safari 5.0-5.1 support `rem` but not in combination with media queries."},"usage_perc_y":99.27,"usage_perc_a":0.24,"ucprefix":false,"parent":"","keywords":"rems","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"requestanimationframe":{"title":"requestAnimationFrame","description":"API allowing a more efficient way of running script-based animation, compared to traditional methods using timeouts. Also covers support for `cancelAnimationFrame`","spec":"https://html.spec.whatwg.org/multipage/webappapis.html#animation-frames","status":"ls","links":[{"url":"http://paulirish.com/2011/requestanimationframe-for-smart-animating/","title":"Blog post"},{"url":"https://hacks.mozilla.org/2011/08/animating-with-javascript-from-setinterval-to-requestanimationframe/","title":"Mozilla Hacks article"},{"url":"https://www.webplatform.org/docs/dom/Window/requestAnimationFrame","title":"WebPlatform Docs"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame","title":"MDN Web Docs - requestAnimationFrame"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a x #1","5":"a x #1","6":"a x #1","7":"a x #1","8":"a x #1","9":"a x #1","10":"a x #1","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"a x #1 #2","11":"a x #1 #2","12":"a x #1 #2","13":"a x #1 #2","14":"a x #1 #2","15":"a x #1 #2","16":"a x #1 #2","17":"a x #1 #2","18":"a x #1","19":"a x #1","20":"a x #1","21":"a x #1","22":"y x","23":"y x","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y x","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"y x","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support refers to lacking `cancelAnimationFrame` support.","2":"Supports `webkitCancelRequestAnimationFrame` rather than `webkitCancelAnimationFrame`."},"usage_perc_y":98,"usage_perc_a":0.14,"ucprefix":false,"parent":"","keywords":"","ie_id":"requestanimationframe","chrome_id":"5233400470306816","firefox_id":"","webkit_id":""},"requestidlecallback":{"title":"requestIdleCallback","description":"API allowing the execution of JavaScript to be queued to run in idle browser time, either at the end of a frame or when the user is inactive. Also covers support for `cancelIdleCallback`. The API has similarities with `requestAnimationFrame`.","spec":"https://w3c.github.io/requestidlecallback/","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Window/requestIdleCallback","title":"MDN Web Docs - requestIdleCallback"},{"url":"https://developers.google.com/web/updates/2015/08/using-requestidlecallback","title":"Google Developers article"},{"url":"https://gist.github.com/paullewis/55efe5d6f05434a96c36","title":"Shim"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n d #1","54":"n d #1","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n d #2","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n d #2","TP":"n d #2"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n d #2","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n d #2"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Can be enabled via the `dom.requestIdleCallback.enabled` flag","2":"Can be enabled in Experimental (WebKit) Features"},"usage_perc_y":78.92,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"requestIdleCallback,request,idle","ie_id":"requestidlecallback","chrome_id":"5572795866021888","firefox_id":"request-idle-callback","webkit_id":"feature-requestidlecallback"},"resizeobserver":{"title":"Resize Observer","description":"Method for observing and reacting to changes to sizes of DOM elements.","spec":"https://wicg.github.io/ResizeObserver/","status":"unoff","links":[{"url":"https://developers.google.com/web/updates/2016/10/resizeobserver","title":"Google Developers Article"},{"url":"https://github.com/WICG/ResizeObserver/blob/master/explainer.md","title":"Explainer Doc"},{"url":"https://github.com/que-etc/resize-observer-polyfill","title":"Polyfill based on initial specification"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1272409","title":"Firefox implementation bug"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=157743","title":"WebKit implementation bug"},{"url":"https://github.com/juggle/resize-observer","title":"Polyfill based on latest specification which includes support for observer options"}],"categories":["DOM","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n d #1","55":"n d #1","56":"n d #1","57":"n d #1","58":"n d #1","59":"n d #1","60":"n d #1","61":"n d #1","62":"n d #1","63":"n d #1","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n d","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n d #1","42":"n d #1","43":"n d #1","44":"n d #1","45":"n d #1","46":"n d #1","47":"n d #1","48":"n d #1","49":"n d #1","50":"n d #1","51":"n d #1","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Can be enabled via the \"Experimental Web Platform Features\" flag"},"usage_perc_y":88.77,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"ResizeObserver,onresize,resize events","ie_id":"resizeobserver","chrome_id":"5705346022637568","firefox_id":"","webkit_id":""},"resource-timing":{"title":"Resource Timing","description":"Method to help web developers to collect complete timing information related to resources on a document.","spec":"https://www.w3.org/TR/resource-timing/","status":"cr","links":[{"url":"http://aurelio.audero.it/demo/resource-timing-api-demo.html","title":"Demo"},{"url":"http://googledevelopers.blogspot.com/2013/12/measuring-network-performance-with.html","title":"Blog post"},{"url":"https://www.sitepoint.com/introduction-resource-timing-api/","title":"SitePoint article"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n d #1","32":"n d #1","33":"n d #1","34":"n d #1","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"a #2","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Can be enabled in Firefox using the dom.enable_resource_timing flag","2":"Partial support in Safari refers to being limited to OSX 10.12+"},"usage_perc_y":96.98,"usage_perc_a":0.01,"ucprefix":false,"parent":"","keywords":"performance,testing,resource","ie_id":"resourcetimingapi","chrome_id":"5796350423728128","firefox_id":"","webkit_id":"specification-resource-timing-level-2"},"rest-parameters":{"title":"Rest parameters","description":"Allows representation of an indefinite number of arguments as an array.","spec":"https://tc39.es/ecma262/#sec-function-definitions","status":"other","links":[{"url":"https://hacks.mozilla.org/2015/05/es6-in-depth-rest-parameters-and-defaults/","title":"Rest parameters and defaults"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n d #1","45":"n d #1","46":"n d #1","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n d #1","32":"n d #1","33":"n d #1","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Requires the \"Experimental JavaScript features\" flag to be enabled"},"usage_perc_y":95.77,"usage_perc_a":0,"ucprefix":false,"parent":"es6","keywords":"ES6,JavaScript","ie_id":"restparameterses6","chrome_id":"5937087912083456","firefox_id":"","webkit_id":""},"rtcpeerconnection":{"title":"WebRTC Peer-to-peer connections","description":"Method of allowing two users to communicate directly, browser to browser using the RTCPeerConnection API.","spec":"https://w3c.github.io/webrtc-pc/","status":"wd","links":[{"url":"http://www.webrtc.org/","title":"WebRTC Project site"},{"url":"https://temasys.atlassian.net/wiki/display/TWPP/WebRTC+Plugins","title":"Plug-in for support in IE & Safari"},{"url":"http://www.html5labs.com/prototypes/object-rtc/object-rtc/info","title":"Prototype implementation for ORTC"},{"url":"https://blogs.windows.com/msedgedev/2017/01/31/introducing-webrtc-microsoft-edge/","title":"Introducing WebRTC 1.0 and interoperable real-time communications in Microsoft Edge"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"a #3","16":"a #3","17":"a #3","18":"a #3","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n #1"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"y x","5.0-5.4":"y x","6.2-6.4":"y x","7.2-7.4":"y x","8.2":"y x","9.2":"y x","10.1":"y x","11.1-11.2":"y x","12.0":"y x"},"and_qq":{"10.4":"y x"},"baidu":{"7.12":"y x"},"kaios":{"2.5":"y"}},"notes":"Microsoft also offers a compatible implementation known as [ObjectRTC](http://blogs.msdn.com/b/ie/archive/2014/10/27/bringing-interoperable-real-time-communications-to-the-web.aspx). See [Object RTC](https://caniuse.com/#feat=objectrtc) for support details for that API.","notes_by_num":{"1":"BlackBerry 10 recognizes RTCPeerConnection but real support is unconfirmed.","2":"Can be enabled via the \"Enable WebRTC 1.0\" flag","3":"Edge does not support RTCDataChannel. See [API Catalogue](https://developer.microsoft.com/en-us/microsoft-edge/platform/catalog/?q=specName%3Awebrtc)"},"usage_perc_y":94.27,"usage_perc_a":0.37,"ucprefix":false,"parent":"","keywords":"","ie_id":"webrtcwebrtcv10api","chrome_id":"6612462929444864","firefox_id":"webrtc","webkit_id":"specification-webrtc"},"ruby":{"title":"Ruby annotation","description":"Method of adding pronunciation or other annotations using ruby elements (primarily used in East Asian typography).","spec":"https://html.spec.whatwg.org/multipage/semantics.html#the-ruby-element","status":"ls","links":[{"url":"http://html5doctor.com/ruby-rt-rp-element/","title":"HTML5 Doctor article"},{"url":"https://www.webplatform.org/docs/html/elements/ruby","title":"WebPlatform Docs"},{"url":"https://addons.mozilla.org/firefox/addon/1935/","title":"Add-on \"XHTML Ruby Support\" for Firefox"},{"url":"https://addons.mozilla.org/firefox/addon/6812/","title":"Addon \"HTML Ruby\" for Firefox support"},{"url":"https://www.w3.org/TR/css-ruby-1/","title":"CSS specification"}],"categories":["HTML5"],"stats":{"ie":{"6":"a","7":"a","8":"a","9":"a","10":"a","11":"a","5.5":"a"},"edge":{"12":"a","13":"a","14":"a","15":"a","16":"a","17":"a","18":"a","79":"a","80":"a","81":"a","83":"a","84":"a","85":"a","86":"a","87":"a"},"firefox":{"2":"p","3":"p","4":"p","5":"p","6":"p","7":"p","8":"p","9":"p","10":"p","11":"p","12":"p","13":"p","14":"p","15":"p","16":"p","17":"p","18":"p","19":"p","20":"p","21":"p","22":"p","23":"p","24":"p","25":"p","26":"p","27":"p","28":"p","29":"p","30":"p","31":"p","32":"p","33":"p","34":"p","35":"p","36":"p","37":"p","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"p","3.6":"p"},"chrome":{"4":"p","5":"a","6":"a","7":"a","8":"a","9":"a","10":"a","11":"a","12":"a","13":"a","14":"a","15":"a","16":"a","17":"a","18":"a","19":"a","20":"a","21":"a","22":"a","23":"a","24":"a","25":"a","26":"a","27":"a","28":"a","29":"a","30":"a","31":"a","32":"a","33":"a","34":"a","35":"a","36":"a","37":"a","38":"a","39":"a","40":"a","41":"a","42":"a","43":"a","44":"a","45":"a","46":"a","47":"a","48":"a","49":"a","50":"a","51":"a","52":"a","53":"a","54":"a","55":"a","56":"a","57":"a","58":"a","59":"a","60":"a","61":"a","62":"a","63":"a","64":"a","65":"a","66":"a","67":"a","68":"a","69":"a","70":"a","71":"a","72":"a","73":"a","74":"a","75":"a","76":"a","77":"a","78":"a","79":"a","80":"a","81":"a","83":"a","84":"a","85":"a","86":"a","87":"a","88":"a","89":"a","90":"a"},"safari":{"4":"p","5":"a","6":"a","7":"a","8":"a","9":"a","10":"a","11":"a","12":"a","13":"a","14":"a","3.1":"p","3.2":"p","5.1":"a","6.1":"a","7.1":"a","9.1":"a","10.1":"a","11.1":"a","12.1":"a","13.1":"a","TP":"a"},"opera":{"9":"p","11":"p","12":"p","15":"a","16":"a","17":"a","18":"a","19":"a","20":"a","21":"a","22":"a","23":"a","24":"a","25":"a","26":"a","27":"a","28":"a","29":"a","30":"a","31":"a","32":"a","33":"a","34":"a","35":"a","36":"a","37":"a","38":"a","39":"a","40":"a","41":"a","42":"a","43":"a","44":"a","45":"a","46":"a","47":"a","48":"a","49":"a","50":"a","51":"a","52":"a","53":"a","54":"a","55":"a","56":"a","57":"a","58":"a","60":"a","62":"a","63":"a","64":"a","65":"a","66":"a","67":"a","68":"a","69":"a","70":"a","71":"a","72":"a","9.5-9.6":"p","10.0-10.1":"p","10.5":"p","10.6":"p","11.1":"p","11.5":"p","11.6":"p","12.1":"p"},"ios_saf":{"8":"a","14":"a","3.2":"p","4.0-4.1":"p","4.2-4.3":"p","5.0-5.1":"a","6.0-6.1":"a","7.0-7.1":"a","8.1-8.4":"a","9.0-9.2":"a","9.3":"a","10.0-10.2":"a","10.3":"a","11.0-11.2":"a","11.3-11.4":"a","12.0-12.1":"a","12.2-12.4":"a","13.0-13.1":"a","13.2":"a","13.3":"a","13.4-13.7":"a"},"op_mini":{"all":"p"},"android":{"3":"a","4":"a","81":"a","2.1":"p","2.2":"p","2.3":"p","4.1":"a","4.2-4.3":"a","4.4":"a","4.4.3-4.4.4":"a"},"bb":{"7":"p","10":"a"},"op_mob":{"10":"p","11":"p","12":"p","59":"a","11.1":"p","11.5":"p","12.1":"p"},"and_chr":{"86":"a"},"and_ff":{"82":"y"},"ie_mob":{"10":"a","11":"a"},"and_uc":{"12.12":"a"},"samsung":{"4":"a","5.0-5.4":"a","6.2-6.4":"a","7.2-7.4":"a","8.2":"a","9.2":"a","10.1":"a","11.1-11.2":"a","12.0":"a"},"and_qq":{"10.4":"a"},"baidu":{"7.12":"a"},"kaios":{"2.5":"y"}},"notes":"Browsers without native support can still simulate support using CSS. Partial support refers to only supporting basic ruby, may still be missing writing-mode, Complex ruby and CSS3 Ruby.","notes_by_num":{"1":"IE9+ supports [properties](https://developer.mozilla.org/en-US/docs/Web/CSS/Reference) of an older version of the CSS Ruby specification."},"usage_perc_y":3.97,"usage_perc_a":94.48,"ucprefix":false,"parent":"","keywords":"ruby-base,ruby-text,ruby-position,ruby-merge,ruby-align","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"run-in":{"title":"display: run-in","description":"If the run-in box contains a block box, same as block. If a block box follows the run-in box, the run-in box becomes the first inline box of the block box. If an inline box follows, the run-in box becomes a block box.","spec":"https://drafts.csswg.org/css-display/#valdef-display-run-in","status":"wd","links":[{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=2056","title":"Mozilla bug report"},{"url":"https://css-tricks.com/run-in/","title":"CSS Tricks article"}],"categories":["CSS","CSS2"],"stats":{"ie":{"6":"n","7":"n","8":"y","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"y #1","5":"y","6":"y","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"y #1","3.2":"y #1","5.1":"y","6.1":"u","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"n","14":"n","3.2":"y #1","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"n","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"n"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"n","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Not before inline-elements"},"usage_perc_y":2.83,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"display,run-in","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"same-site-cookie-attribute":{"title":"'SameSite' cookie attribute","description":"Same-site cookies (\"First-Party-Only\" or \"First-Party\") allow servers to mitigate the risk of CSRF and information leakage attacks by asserting that a particular cookie should only be sent with requests initiated from the same registrable domain.","spec":"https://tools.ietf.org/html/draft-west-first-party-cookies-06","status":"other","links":[{"url":"http://www.sjoerdlangkemper.nl/2016/04/14/preventing-csrf-with-samesite-cookie-attribute/","title":"Preventing CSRF with the same-site cookie attribute"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=795346","title":"Mozilla Bug #795346: Add SameSite support for cookies"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1286861","title":"Mozilla Bug #1286861, includes the patches that landed SameSite support in Firefox"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/17140412-support-samesite-cookie-option","title":"Microsoft Edge feature request on UserVoice"},{"url":"https://developer.microsoft.com/en-us/microsoft-edge/platform/status/samesitecookies/","title":"Microsoft Edge Browser Status"},{"url":"https://blogs.windows.com/msedgedev/2018/05/17/samesite-cookies-microsoft-edge-internet-explorer/","title":"MS Edge dev blog: \"Previewing support for same-site cookies in Microsoft Edge\""},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1551798","title":"Mozilla Bug #1551798: Prototype SameSite=Lax by default"},{"url":"https://peaceful-wing.glitch.me","title":"Same-site cookies demonstration by Rowan Merewood"}],"categories":["Security"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"a #1 #2","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"y #1","17":"y #1","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y #3","81":"y #3","83":"y #3","84":"y #3","85":"y #3","86":"y #3","87":"y #3","88":"y #3","89":"y #3","90":"y #3"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"a #4 #5","13":"a #4 #5","14":"a #5","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"a #4 #5","13.1":"a #4 #5","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"a #5","12.2-12.4":"a #5","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y #3"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"u"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"This feature is backwards compatible. Browsers not supporting this feature will simply use the cookie as a regular cookie. There is no need to deliver different cookies to clients.","notes_by_num":{"1":"Not shipped with the inital release but later with the 2018 June security update (Patch Tuesday) to Windows 10 RS3 (2017 Fall Creators Update) and newer. [More info](https://github.com/MicrosoftEdge/Status/issues/616).","2":"Partial support because only supported in IE 11 on Windows 10 RS3 (2017 Fall Creators Update) and newer, but not in IE 11 on other Windows versions (Windows 7, ...)","3":"Implemented [Incrementally Better Cookies](https://tools.ietf.org/html/draft-west-cookie-incrementalism-00) by default: Cookies without `SameSite` are treated as `Lax`, `SameSite=None` cookies without `Secure` are rejected.","4":"Partial due to the lack of support in macOS before 10.14 Mojave.","5":"Partial due to [the bug](https://bugs.webkit.org/show_bug.cgi?id=198181) that treats `SameSite=None` and invalid values as `Strict` in macOS before 10.15 Catalina and in iOS before 13."},"usage_perc_y":86.76,"usage_perc_a":7.09,"ucprefix":false,"parent":"","keywords":"security,cookies,cookie,csrf","ie_id":"","chrome_id":"4672634709082112,5088147346030592,5633521622188032","firefox_id":"","webkit_id":""},"screen-orientation":{"title":"Screen Orientation","description":"Provides the ability to read the screen orientation state, to be informed when this state changes, and to be able to lock the screen orientation to a specific state.","spec":"https://www.w3.org/TR/screen-orientation/","status":"wd","links":[{"url":"http://aurelio.audero.it/demo/screen-orientation-api-demo.html","title":"Demo"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Screen.orientation","title":"MDN Web Docs - Screen Orientation"},{"url":"https://www.sitepoint.com/introducing-screen-orientation-api/","title":"SitePoint article"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"a x #1","5.5":"n"},"edge":{"12":"a x","13":"a x","14":"a x","15":"a x","16":"a x","17":"a x","18":"a x","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"a x","19":"a x","20":"a x","21":"a x","22":"a x","23":"a x","24":"a x","25":"a x","26":"a x","27":"a x","28":"a x","29":"a x","30":"a x","31":"a x","32":"a x","33":"a x","34":"a x","35":"a x","36":"a x","37":"a x","38":"a x","39":"a x","40":"a x","41":"a x","42":"a x","43":"a x","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"a x"},"and_uc":{"12.12":"y"},"samsung":{"4":"u","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Partial support refers to an [older version](https://www.w3.org/TR/2014/WD-screen-orientation-20140220/) of the draft specification, and the spec has undergone significant changes since, for example renaming the `screen.lockOrientation` method to `screen.orientation.lock`.","notes_by_num":{"1":"Not supported on Windows 7."},"usage_perc_y":79.25,"usage_perc_a":1.71,"ucprefix":false,"parent":"","keywords":"lockorientation,unlockorientation","ie_id":"screenorientationapi","chrome_id":"6191285283061760","firefox_id":"screen-orientation","webkit_id":""},"script-async":{"title":"async attribute for external scripts","description":"The boolean async attribute on script elements allows the external JavaScript file to run when it's available, without delaying page load first.","spec":"https://html.spec.whatwg.org/multipage/scripting.html#attr-script-async","status":"ls","links":[{"url":"https://developer.mozilla.org/en/HTML/Element/script#Attributes","title":"MDN Web Docs - Script attributes"},{"url":"http://ie.microsoft.com/testdrive/Performance/AsyncScripts/Default.html","title":"Demo"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/script.js#script-async","title":"has.js test"},{"url":"http://www.growingwiththeweb.com/2014/02/async-vs-defer-attributes.html","title":"async vs defer attributes"}],"categories":["DOM","HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"y"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"a #1","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Using script.async = false; to maintain execution order for dynamically-added scripts isn't supported in Safari 5.0"},"usage_perc_y":98.37,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"script-defer":{"title":"defer attribute for external scripts","description":"The boolean defer attribute on script elements allows the external JavaScript file to run when the DOM is loaded, without delaying page load first.","spec":"https://html.spec.whatwg.org/multipage/scripting.html#attr-script-defer","status":"ls","links":[{"url":"https://developer.mozilla.org/en/HTML/Element/script#Attributes","title":"MDN Web Docs - Script Attributes"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/script.js#script-defer","title":"has.js test"},{"url":"https://www.webplatform.org/docs/html/attributes/defer","title":"WebPlatform Docs"},{"url":"http://www.growingwiththeweb.com/2014/02/async-vs-defer-attributes.html","title":"async vs defer attributes"}],"categories":["DOM","HTML5"],"stats":{"ie":{"6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"y","11":"y","5.5":"a #1"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y #2","5":"y #2","6":"y #2","7":"y #2","8":"y #2","9":"y #2","10":"y #2","11":"y #2","12":"y #2","13":"y #2","14":"y #2","15":"y #2","16":"y #2","17":"y #2","18":"y #2","19":"y #2","20":"y #2","21":"y #2","22":"y #2","23":"y #2","24":"y #2","25":"y #2","26":"y #2","27":"y #2","28":"y #2","29":"y #2","30":"y #2","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y #2","3.6":"y #2"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support in older IE refers to a buggy implementation (see issue).","2":"Deferred scripts may run after DOMContentLoaded - https://bugzilla.mozilla.org/show_bug.cgi?id=688580"},"usage_perc_y":98.38,"usage_perc_a":0.3,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"scrollintoview":{"title":"scrollIntoView","description":"The `Element.scrollIntoView()` method scrolls the current element into the visible area of the browser window. Parameters can be provided to set the position inside the visible area as well as whether scrolling should be instant or smooth.","spec":"https://drafts.csswg.org/cssom-view/#dom-element-scrollintoview","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView","title":"MDN Web Docs - scrollIntoView"},{"url":"http://iamdustan.com/smoothscroll/","title":"smooth scroll polyfill : polyfill for smooth behavior option"}],"categories":["DOM","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"a #1","9":"a #1","10":"a #1","11":"a #1","5.5":"n"},"edge":{"12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"a #1","3":"a #1","4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a #1","3.6":"a #1"},"chrome":{"4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","59":"a #1","60":"a #1","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","3.1":"n","3.2":"n","5.1":"a #1","6.1":"a #1","7.1":"a #1","9.1":"a #1","10.1":"a #1","11.1":"a #1","12.1":"a #1","13.1":"a #1","TP":"a #1"},"opera":{"9":"n","11":"u","12":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"u","11.5":"u","11.6":"a #1","12.1":"a #1"},"ios_saf":{"8":"a #1","14":"a #1","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"a #1","6.0-6.1":"a #1","7.0-7.1":"a #1","8.1-8.4":"a #1","9.0-9.2":"a #1","9.3":"a #1","10.0-10.2":"a #1","10.3":"a #1","11.0-11.2":"a #1","11.3-11.4":"a #1","12.0-12.1":"a #1","12.2-12.4":"a #1","13.0-13.1":"a #1","13.2":"a #1","13.3":"a #1","13.4-13.7":"a #1"},"op_mini":{"all":"n"},"android":{"3":"a #1","4":"a #1","81":"a #1","2.1":"u","2.2":"u","2.3":"a #1","4.1":"a #1","4.2-4.3":"a #1","4.4":"a #1","4.4.3-4.4.4":"a #1"},"bb":{"7":"a #1","10":"a #1"},"op_mob":{"10":"a #1","11":"a #1","12":"a #1","59":"a #1","11.1":"a #1","11.5":"a #1","12.1":"a #1"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #1","11":"a #1"},"and_uc":{"12.12":"a #1"},"samsung":{"4":"a #1","5.0-5.4":"a #1","6.2-6.4":"a #1","7.2-7.4":"a #1","8.2":"a #1","9.2":"a #1","10.1":"a #1","11.1-11.2":"a #1","12.0":"a #1"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"a #1"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Supports scrollIntoView with boolean parameter, but not `smooth` behavior option"},"usage_perc_y":74.34,"usage_perc_a":24.36,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"scrollintoviewifneeded":{"title":"Element.scrollIntoViewIfNeeded()","description":"If the element is fully within the visible area of the viewport, it does nothing. Otherwise, the element is scrolled into view. A proprietary variant of the standard `Element.scrollIntoView()` method.","spec":"https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded","status":"unoff","links":[{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=403510","title":"Mozilla Bug 403510 - Implement scrollIntoViewIfNeeded"},{"url":"https://www.w3.org/Bugs/Public/show_bug.cgi?id=17152","title":"W3C CSSOM View bug #17152: Support centering an element when scrolling into view."}],"categories":["DOM","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"u","5":"u","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"u","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"u","2.2":"u","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":92.58,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"scrollIntoViewIfNeeded,scroll","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"sdch":{"title":"SDCH Accept-Encoding/Content-Encoding","description":"Shared Dictionary Compression over HTTP","spec":"https://docs.google.com/viewer?a=v&pid=forums&srcid=MDIwOTgxNDMwMTgyMjkzMTI2ODcBMDQ2MzU5NDU2MDA0MTg5NDE1MTkBTDZmaENoSG9BZ0FKATAuMQEBdjI","status":"other","links":[{"url":"https://groups.google.com/forum/#!forum/sdch","title":"SDCH Google Group"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=641069","title":"Bugzilla Bug 641069 - Implement SDCH"},{"url":"https://en.wikipedia.org/wiki/SDCH","title":"Wikipedia - SDCH"},{"url":"https://engineering.linkedin.com/shared-dictionary-compression-http-linkedin","title":"Shared Dictionary Compression for HTTP at LinkedIn."}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":5.23,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"http,compression,accept,content,encoding,sdch","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"selection-api":{"title":"Selection API","description":"API for accessing selected content of a document, including the `window.getSelection()` method, as well as the `selectstart` & `selectionchange` events on `document`.","spec":"https://www.w3.org/TR/selection-api/","status":"wd","links":[{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1231923","title":"Firefox support bug"}],"categories":["JS API"],"stats":{"ie":{"6":"a #2","7":"a #2","8":"a #2","9":"y","10":"y","11":"y","5.5":"u"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"a #1","3":"a #1","4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1 #5","44":"a #1 #5","45":"a #1 #5","46":"a #1 #5","47":"a #1 #5","48":"a #1 #5","49":"a #1 #5","50":"a #1 #5","51":"a #1 #5","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a #1","3.6":"a #1"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"u","5":"u","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"u","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"a #1","11":"a #1","12":"a #1","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"a #1","10.0-10.1":"a #1","10.5":"a #1","10.6":"a #1","11.1":"a #1","11.5":"a #1","11.6":"a #1","12.1":"a #1"},"ios_saf":{"8":"a #3","14":"a #3","3.2":"a #1","4.0-4.1":"a #1","4.2-4.3":"u","5.0-5.1":"a #3","6.0-6.1":"a #3","7.0-7.1":"a #3","8.1-8.4":"a #3","9.0-9.2":"a #3","9.3":"a #3","10.0-10.2":"a #3","10.3":"a #3","11.0-11.2":"a #3","11.3-11.4":"a #3","12.0-12.1":"a #3","12.2-12.4":"a #3","13.0-13.1":"a #3","13.2":"a #3","13.3":"a #3","13.4-13.7":"a #3"},"op_mini":{"all":"n"},"android":{"3":"u","4":"u","81":"y","2.1":"u","2.2":"u","2.3":"u","4.1":"u","4.2-4.3":"y #4","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"u","10":"y"},"op_mob":{"10":"u","11":"u","12":"u","59":"y","11.1":"u","11.5":"u","12.1":"a #1"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"u","11":"y"},"and_uc":{"12.12":"y #4"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"a #1 #5"}},"notes":"See also support for the related [DOM range](https://caniuse.com/#feat=dom-range) ","notes_by_num":{"1":"Supports `window.getSelection()` but no selection events","2":"Supports selection events, but not `window.getSelection()`","3":"Does not support the `selectstart` event","4":"`window.getSelection()` may fail on tapping buttons, as the selection is lost right before the listener code runs.","5":"Selection events are supported behind the `dom.select_events.enabled` flag"},"usage_perc_y":85.74,"usage_perc_a":12.92,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"server-timing":{"title":"Server Timing","description":"Mechanism for web developers to annotate network requests with server timing information.","spec":"https://www.w3.org/TR/server-timing/","status":"wd","links":[{"url":"http://server-timing.netlify.com/","title":"Demo"},{"url":"https://developer.akamai.com/blog/2017/06/07/completing-performance-analysis-server-timing/","title":"Blog post"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/PerformanceServerTiming","title":"MDN article on PerformanceServerTiming"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"a d #1","61":"a d #1","62":"a d #1","63":"a d #1","64":"a d #2","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"a #3","14":"a #3","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"a #3","13.1":"a #3","TP":"a #3"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Chrome v60-63: An older version of the API is behind the [Experimental Web Platform features](chrome://flags/#enable-experimental-web-platform-features) flag.","2":"Chrome v64: The current API is behind the [Experimental Web Platform features](chrome://flags/#enable-experimental-web-platform-features) flag.","3":"Safari v12.1+: Supports the Server Timing reporting in the Web Inspector Network tab, but not the JavaScript API"},"usage_perc_y":73.66,"usage_perc_a":4.04,"ucprefix":false,"parent":"","keywords":"performance,performance.timing,resource,performancenavigation,PerformanceServerTiming","ie_id":"servertiming","chrome_id":"5695708376072192","firefox_id":"","webkit_id":""},"serviceworkers":{"title":"Service Workers","description":"Method that enables applications to take advantage of persistent background processing, including hooks to enable bootstrapping of web applications while offline.","spec":"https://w3c.github.io/ServiceWorker/","status":"cr","links":[{"url":"https://www.html5rocks.com/en/tutorials/service-worker/introduction/","title":"HTML5Rocks article (introduction)"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorker_API","title":"MDN Web Docs - Service Workers"},{"url":"https://jakearchibald.github.io/isserviceworkerready/resources.html","title":"List of various resources"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n d #2","16":"n d #2","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n d #1","34":"n d #1","35":"n d #1","36":"n d #1","37":"n d #1","38":"n d #1","39":"n d #1","40":"n d #1","41":"n d #1","42":"n d #1","43":"n d #1","44":"y","45":"y #3","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y #3","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y #3","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y #3","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"a","41":"a","42":"a","43":"a","44":"a","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"a","28":"a","29":"a","30":"a","31":"a","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"a","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"a","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"a"},"kaios":{"2.5":"n"}},"notes":"Details on partial support can be found on [is ServiceWorker Ready?](https://jakearchibald.github.io/isserviceworkerready/)","notes_by_num":{"1":"Partial support can be enabled in Firefox with the `dom.serviceWorkers.enabled` flag.","2":"Available behind the \"Enable service workers\" flag","3":"Disabled on Firefox ESR, but can be re-enabled with the `dom.serviceWorkers.enabled` flag","4":"Can be enabled via the \"Experimental Features\" developer menu"},"usage_perc_y":95.22,"usage_perc_a":0.09,"ucprefix":false,"parent":"","keywords":"","ie_id":"serviceworker","chrome_id":"6561526227927040","firefox_id":"service-worker","webkit_id":"specification-service-workers"},"setimmediate":{"title":"Efficient Script Yielding: setImmediate()","description":"Yields control flow without the minimum delays enforced by setTimeout","spec":"https://w3c.github.io/setImmediate/","status":"unoff","links":[{"url":"http://www.nczonline.net/blog/2013/07/09/the-case-for-setimmediate/","title":"The case for setImmediate()"},{"url":"http://www.nczonline.net/blog/2011/09/19/script-yielding-with-setimmediate/","title":"Script yielding with setImmediate"},{"url":"https://github.com/YuzuJS/setImmediate","title":"setImmediate polyfill"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=686201","title":"Firefox tracking bug"},{"url":"https://code.google.com/p/chromium/issues/detail?id=146172","title":"Chrome bug closed as WONTFIX"},{"url":"https://github.com/zloirock/core-js#setimmediate","title":"Polyfill for this feature is available in the core-js library"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":1.53,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"setImmediate,clearImmediate,setTimeout,performance","ie_id":"efficientscriptyieldingsetimmediate","chrome_id":"","firefox_id":"","webkit_id":""},"shadowdom":{"title":"Shadow DOM (deprecated V0 spec)","description":"Original V0 version of the Shadow DOM specification. See [Shadow DOM V1](#feat=shadowdomv1) for support for the latest version. ","spec":"https://www.w3.org/TR/shadow-dom/","status":"unoff","links":[{"url":"http://html5-demos.appspot.com/static/shadowdom-visualizer/index.html","title":"Shadow DOM Visualizer"},{"url":"https://www.html5rocks.com/tutorials/webcomponents/shadowdom/","title":"HTML5Rocks - Shadow DOM 101 article"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=148695","title":"Safari implementation bug"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1205323","title":"Firefox implementation bug"},{"url":"https://developers.google.com/web/fundamentals/getting-started/primers/shadowdom","title":"Google Developers - Shadow DOM v1: self-contained web components"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n d","30":"n d","31":"n d","32":"n d","33":"n d","34":"n d","35":"n d","36":"n d","37":"n d","38":"n d","39":"n d","40":"n d","41":"n d","42":"n d","43":"n d","44":"n d","45":"n d","46":"n d","47":"n d","48":"n d","49":"n d","50":"n d","51":"n d","52":"n d","53":"n d","54":"n d","55":"n d","56":"n d","57":"n d","58":"n d","59":"n d","60":"n d","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y x","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Supported in Firefox behind the `dom.webcomponents.enabled` flag.","2":"Supported in Firefox behind the `dom.webcomponents.shadowdom.enabled` flag."},"usage_perc_y":7.07,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"4507242028072960","firefox_id":"","webkit_id":""},"shadowdomv1":{"title":"Shadow DOM (V1)","description":"Method of establishing and maintaining functional boundaries between DOM trees and how these trees interact with each other within a document, thus enabling better functional encapsulation within the DOM & CSS.","spec":"https://www.w3.org/TR/shadow-dom/","status":"wd","links":[{"url":"https://bugs.webkit.org/show_bug.cgi?id=148695","title":"Safari implementation bug"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1205323","title":"Firefox implementation bug"},{"url":"https://developers.google.com/web/fundamentals/primers/shadowdom/?hl=en","title":"Google Developers - Shadow DOM v1: self-contained web components"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n d #2","59":"n d #3","60":"n d #3","61":"n d #3","62":"n d #3","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"a #1","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"a #1","10.3":"a #1","11.0-11.2":"a #1","11.3-11.4":"a #1","12.0-12.1":"a #1","12.2-12.4":"a #1","13.0-13.1":"a #1","13.2":"a #1","13.3":"a #1","13.4-13.7":"a #1"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"a","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Certain CSS selectors do not work (`:host > .local-child`) and styling slotted content (`::slotted`) is buggy.","2":"Enabled through the `dom.webcomponents.enabled` preference in `about:config`.","3":"Enabled through the `dom.webcomponents.shadowdom.enabled` preference in `about:config`."},"usage_perc_y":82.63,"usage_perc_a":11.93,"ucprefix":false,"parent":"","keywords":"webcomponents,shadow dom,attachShadow","ie_id":"shadowdom","chrome_id":"4667415417847808","firefox_id":"shadow-dom","webkit_id":"feature-shadow-dom"},"sharedarraybuffer":{"title":"Shared Array Buffer","description":"Type of ArrayBuffer that can be shared across Workers.","spec":"https://tc39.es/ecma262/#sec-sharedarraybuffer-objects","status":"other","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer","title":"MDN article"},{"url":"https://hacks.mozilla.org/2020/07/safely-reviving-shared-memory/","title":"Mozilla Hacks article on safely reviving shared memory"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n d #1","17":"n d #1","18":"n d #1","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n d #1","58":"n d #1","59":"n d #1","60":"n d #1","61":"n d #1","62":"n d #1","63":"n d #1","64":"n d #1","65":"n d #1","66":"n d #1","67":"n d #1","68":"n d #1","69":"n d #1","70":"n d #1","71":"n d #1","72":"n d #1","73":"n d #1","74":"n d #1 #2","75":"n d #1 #2","76":"n d #1 #2","77":"n d #1 #2","78":"n d #1 #2","79":"y #3","80":"y #3","81":"y #3","82":"y #3","83":"y #3","84":"y #3","85":"y #3","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n d #1","61":"n d #1","62":"n d #1","63":"n d #1","64":"n d #1","65":"n d #1","66":"n d #1","67":"n d #1","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n d #1","12":"n d #1","13":"n d #1","14":"n d #1","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n d #1","11.1":"n d #1","12.1":"n d #1","13.1":"n d #1","TP":"n d #1"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n d #1","48":"n d #1","49":"n d #1","50":"n d #1","51":"n d #1","52":"n d #1","53":"n d #1","54":"n d #1","55":"n d #1","56":"n d #1","57":"n d #1","58":"n d #1","60":"n d #1","62":"n d #1","63":"n d #1","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n d #1","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n d #1","11.0-11.2":"n d #1","11.3-11.4":"n d #1","12.0-12.1":"n d #1","12.2-12.4":"n d #1","13.0-13.1":"n d #1","13.2":"n d #1","13.3":"n d #1","13.4-13.7":"n d #1"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n d #1"},"and_ff":{"82":"y #3"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Has support, but was disabled across browsers in January 2018 due to Spectre & Meltdown vulnerabilities.","2":"Enabled by default in Nightly, but not in Beta/Developer/Release.","3":"Requires cross-origin isolation by having [Cross-Origin-Embedder-Policy (COEP)](#feat=mdn-http_headers_cross-origin-embedder-policy) and [Cross-Origin-Opener-Policy (COOP)](#feat=mdn-http_headers_cross-origin-opener-policy) headers set. [Mozilla Hacks article](https://hacks.mozilla.org/2020/07/safely-reviving-shared-memory/) for context."},"usage_perc_y":40.82,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"4570991992766464","firefox_id":"shared-array-buffer","webkit_id":""},"sharedworkers":{"title":"Shared Web Workers","description":"Method of allowing multiple scripts to communicate with a single web worker.","spec":"https://html.spec.whatwg.org/multipage/workers.html#shared-workers-introduction","status":"ls","links":[{"url":"https://www.sitepoint.com/javascript-shared-web-workers-html5/","title":"Sitepoint article"},{"url":"https://greenido.wordpress.com/2011/11/03/web-workers-part-3-out-of-3-shared-wrokers/","title":"Blog post"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"y","6":"y","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"y","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"u","11":"y","12":"y","59":"n","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"n"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"y","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":42.04,"usage_perc_a":0,"ucprefix":false,"parent":"webworkers","keywords":"shared worker","ie_id":"sharedwebworkers","chrome_id":"","firefox_id":"shared-worker","webkit_id":"feature-shared-web-workers"},"sni":{"title":"Server Name Indication","description":"An extension to the TLS computer networking protocol by which a client indicates which hostname it is attempting to connect to at the start of the handshaking process.","spec":"https://tools.ietf.org/html/rfc6066","status":"other","links":[{"url":"https://en.wikipedia.org/wiki/Server_Name_Indication","title":"Wikipedia"}],"categories":["Security"],"stats":{"ie":{"6":"n","7":"a #1","8":"a #1","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Only supported on Windows Vista or above (not Windows XP)"},"usage_perc_y":99.58,"usage_perc_a":0.07,"ucprefix":false,"parent":"","keywords":"sni","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"spdy":{"title":"SPDY protocol","description":"Networking protocol for low-latency transport of content over the web. Superseded by HTTP version 2.","spec":"https://http2.github.io/http2-spec/index.html","status":"unoff","links":[{"url":"https://en.wikipedia.org/wiki/HTTP/2","title":"Wikipedia"},{"url":"https://dev.chromium.org/spdy/spdy-whitepaper","title":"SPDY whitepaper"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y #1","14":"y #1","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y #1","13.1":"y #1","TP":"y #1"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"n","41":"n","42":"y","43":"n","44":"y","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"y"},"ios_saf":{"8":"y","14":"y #2","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y #2","13.0-13.1":"y #2","13.2":"y #2","13.3":"y #2","13.4-13.7":"y #2"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"y"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"y"},"and_uc":{"12.12":"n"},"samsung":{"4":"y","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"u"},"kaios":{"2.5":"y"}},"notes":"See also support for [HTTP2](https://caniuse.com/#feat=http2), successor of SPDY.\r\n\r\nChrome will be removing support in 2016 (in favor of HTTP2), other browsers likely to follow.","notes_by_num":{"1":"Deprecated as of macOS Mojave 10.4.4. To be completely removed in a future version of macOS.","2":"Deprecated as of iOS 12.2. To be completely removed in a future version of iOS."},"usage_perc_y":19.02,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"http2","chrome_id":"5152586365665280","firefox_id":"","webkit_id":""},"speech-recognition":{"title":"Speech Recognition API","description":"Method to provide speech input in a web browser.","spec":"https://w3c.github.io/speech-api/speechapi.html#speechreco-section","status":"unoff","links":[{"url":"http://updates.html5rocks.com/2013/01/Voice-Driven-Web-Apps-Introduction-to-the-Web-Speech-API","title":"HTML5Rocks article"},{"url":"https://www.sitepoint.com/introducing-web-speech-api/","title":"SitePoint article"},{"url":"http://aurelio.audero.it/demo/web-speech-api-demo.html","title":"Demo"},{"url":"http://zenorocha.github.io/voice-elements/#recognition-element","title":"Advanced demo and resource"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n #4","80":"n #4","81":"n #4","83":"n #4","84":"n #4","85":"n #4","86":"n #4","87":"n #4"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n d #2","23":"n d #2","24":"n d #2","25":"n d #2","26":"n d #2","27":"n d #2","28":"n d #2","29":"n d #2","30":"n d #2","31":"n d #2","32":"n d #2","33":"n d #2","34":"n d #2","35":"n d #2","36":"n d #2","37":"n d #2","38":"n d #2","39":"n d #2","40":"n d #2","41":"n d #2","42":"n d #2","43":"n d #2","44":"n d #2","45":"n d #2","46":"n d #2","47":"n d #2","48":"n d #2","49":"n d #2","50":"n d #2","51":"n d #2","52":"n d #2","53":"n d #2","54":"n d #2","55":"n d #2","56":"n d #2","57":"n d #2","58":"n d #2","59":"n d #2","60":"n d #2","61":"n d #2","62":"n d #2","63":"n d #2","64":"n d #2","65":"n d #2","66":"n d #2","67":"n d #2","68":"n d #2","69":"n d #2","70":"n d #2","71":"n d #2","72":"n d #2","73":"n d #2","74":"n d #2","75":"n d #2","76":"n d #2","77":"n d #2","78":"n d #2","79":"n d #2","80":"n d #2","81":"n d #2","82":"n d #2","83":"n d #2","84":"n d #2","85":"n d #2","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"a x #1","52":"a x #1","53":"a x #1","54":"a x #1","55":"a x #1","56":"a x #1","57":"a x #1","58":"a x #1","59":"a x #1","60":"a x #1","61":"a x #1","62":"a x #1","63":"a x #1","64":"a x #1","65":"a x #1","66":"a x #1","67":"a x #1","68":"a x #1","69":"a x #1","70":"a x #1","71":"a x #1","72":"a x #1","73":"a x #1","74":"a x #1","75":"a x #1","76":"a x #1","77":"a x #1","78":"a x #1","79":"a x #1","80":"a x #1","81":"a x #1","83":"a x #1","84":"a x #1","85":"a x #1","86":"a x #1","87":"a x #1","88":"a x #1","89":"a x #1","90":"a x #1"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n #4","28":"n #4","29":"n #4","30":"n #4","31":"n #4","32":"n #4","33":"n #4","34":"n #4","35":"n #4","36":"n #4","37":"n #4","38":"n #4","39":"n #4","40":"n #4","41":"n #4","42":"n #4","43":"n #4","44":"n #4","45":"n #4","46":"n #4","47":"n #4","48":"n #4","49":"n #4","50":"n #4","51":"n #4","52":"n #4","53":"n #4","54":"n #4","55":"n #4","56":"n #4","57":"n #4","58":"n #4","60":"n #4","62":"n #4","63":"n #4","64":"n #4","65":"n #4","66":"n #4","67":"n #4","68":"n #4","69":"n #4","70":"n #4","71":"n #4","72":"n #4","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a x #1"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"a x #1","5.0-5.4":"a x #1","6.2-6.4":"a x #1","7.2-7.4":"a x #1","8.2":"a x #1","9.2":"a x #1","10.1":"a x #1","11.1-11.2":"a x #1","12.0":"a x #1"},"and_qq":{"10.4":"a x #1"},"baidu":{"7.12":"a x #1"},"kaios":{"2.5":"n d #2"}},"notes":"","notes_by_num":{"1":"Partial support refers to some attributes missing.","2":"Firefox currently has a `media.webspeech.recognition.enable` flag in about:config for this, but actual support is waiting for permissions to be sorted out.","3":"Reported to be in development for Samsung Internet for GearVR, due Q1/2017","4":"Edge and Opera appear to have support for the `SpeechRecognition` API but no events for it appear to fire."},"usage_perc_y":0,"usage_perc_a":70.26,"ucprefix":false,"parent":"","keywords":"#web-speech,speechrecognition,ASR","ie_id":"webspeechapispeechrecognition","chrome_id":"5908775487668224","firefox_id":"webspeech-recognition","webkit_id":""},"speech-synthesis":{"title":"Speech Synthesis API","description":"A web API for controlling a text-to-speech output.","spec":"https://w3c.github.io/speech-api/speechapi.html#tts-section","status":"unoff","links":[{"url":"https://www.sitepoint.com/talking-web-pages-and-the-speech-synthesis-api/","title":"SitePoint article"},{"url":"https://www.audero.it/demo/speech-synthesis-api-demo.html","title":"Demo"},{"url":"https://zenorocha.github.io/voice-elements/","title":"Advanced demo and resource"},{"url":"https://developer.mozilla.org//docs/Web/API/SpeechSynthesis","title":"MDN article"},{"url":"https://developers.google.com/web/updates/2014/01/Web-apps-that-talk-Introduction-to-the-Speech-Synthesis-API","title":"Google Developers article"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y #2","80":"y #2","81":"y #2","83":"y #2","84":"y #2","85":"y #2","86":"y #2","87":"y #2"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n d #1","32":"n d #1","33":"n d #1","34":"n d #1","35":"n d #1","36":"n d #1","37":"n d #1","38":"n d #1","39":"n d #1","40":"n d #1","41":"n d #1","42":"n d #1","43":"n d #1","44":"n d #1","45":"n d #1","46":"n d #1","47":"n d #1","48":"n d #1","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y #2","56":"y #2","57":"y #2","58":"y #2","59":"y #2","60":"y #2","61":"y #2","62":"y #2","63":"y #2","64":"y #2","65":"y #2","66":"y #2","67":"y #2","68":"y #2","69":"y #2","70":"y #2","71":"y #2","72":"y #2","73":"y #2","74":"y #2","75":"y #2","76":"y #2","77":"y #2","78":"y #2","79":"y #2","80":"y #2","81":"y #2","83":"y #2","84":"y #2","85":"y #2","86":"y #2","87":"y #2","88":"y #2","89":"y #2","90":"y #2"},"safari":{"4":"n","5":"n","6":"n","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y #2","65":"y #2","66":"y #2","67":"y #2","68":"y #2","69":"y #2","70":"y #2","71":"y #2","72":"y #2","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"Samsung Internet for GearVR: In Development, release based on Chromium m53 due Q1/2017","notes_by_num":{"1":"Can be enabled in Firefox using the `media.webspeech.synth.enabled` about:config flag.","2":"Speech Synthesis in Chrome since version 55 stops playback after about 15 seconds on Windows 7 & 10, and Ubuntu 14.04, possibly other platforms"},"usage_perc_y":94.86,"usage_perc_a":0,"ucprefix":false,"parent":"web-speech","keywords":"speech,synthesis,speechSynthesis,TTS,SpeechSynthesisUtterance,","ie_id":"webspeechapisynthesis","chrome_id":"4782875580825600","firefox_id":"webspeech-synthesis","webkit_id":""},"spellcheck-attribute":{"title":"Spellcheck attribute","description":"Attribute for `input`/`textarea` fields to enable/disable the browser's spellchecker.","spec":"https://html.spec.whatwg.org/multipage/interaction.html#spelling-and-grammar-checking","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/HTML/Controlling_spell_checking_in_HTML_formsControlling_spell_checking_in_HTML_forms","title":"MDN Web Docs - Controlling spell checking"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"a","14":"a","3.2":"a","4.0-4.1":"a","4.2-4.3":"a","5.0-5.1":"a","6.0-6.1":"a","7.0-7.1":"a","8.1-8.4":"a","9.0-9.2":"a","9.3":"a","10.0-10.2":"a","10.3":"a","11.0-11.2":"a","11.3-11.4":"a","12.0-12.1":"a","12.2-12.4":"a","13.0-13.1":"a","13.2":"a","13.3":"a","13.4-13.7":"a"},"op_mini":{"all":"a"},"android":{"3":"a","4":"a","81":"a","2.1":"a","2.2":"a","2.3":"a","4.1":"a","4.2-4.3":"a","4.4":"a","4.4.3-4.4.4":"a"},"bb":{"7":"a","10":"y"},"op_mob":{"10":"a","11":"a","12":"a","59":"a","11.1":"a","11.5":"a","12.1":"a"},"and_chr":{"86":"a"},"and_ff":{"82":"a"},"ie_mob":{"10":"a","11":"a"},"and_uc":{"12.12":"a"},"samsung":{"4":"a","5.0-5.4":"a","6.2-6.4":"a","7.2-7.4":"a","8.2":"a","9.2":"a","10.1":"a","11.1-11.2":"a","12.0":"a"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"a"},"kaios":{"2.5":"n"}},"notes":"The partial support in mobile browsers results from their OS generally having built-in spell checking instead of using the wavy underline to indicate misspelled words. `spellcheck=\"false\"` does not seem to have any effect in these browsers.\r\n\r\nBrowsers have different behavior in how they deal with spellchecking in combination with the the `lang` attribute. Generally spelling is based on the browser's language, not the language of the document.","notes_by_num":{},"usage_perc_y":47.56,"usage_perc_a":51.75,"ucprefix":false,"parent":"","keywords":"spelling","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"sql-storage":{"title":"Web SQL Database","description":"Method of storing data client-side, allows SQLite database queries for access and manipulation","spec":"https://www.w3.org/TR/webdatabase/","status":"unoff","links":[{"url":"http://html5doctor.com/introducing-web-sql-databases/","title":"HTML5 Doctor article"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/features.js#native-sql-db","title":"has.js test"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"n","14":"n","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"n","TP":"n"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"n","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"The Web SQL Database specification is no longer being maintained and support may be dropped in future versions.","notes_by_num":{},"usage_perc_y":79.75,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"db-storage,websql","ie_id":"websqldatabase","chrome_id":"6330987952734208","firefox_id":"","webkit_id":""},"srcset":{"title":"Srcset and sizes attributes","description":"The `srcset` and `sizes` attributes on `img` (or `source`) elements allow authors to define various image resources and \"hints\" that assist a user agent to determine the most appropriate image source to display (e.g. high-resolution displays, small monitors, etc).","spec":"https://html.spec.whatwg.org/multipage/embedded-content.html#attr-img-srcset","status":"ls","links":[{"url":"https://www.webkit.org/blog/2910/improved-support-for-high-resolution-displays-with-the-srcset-image-attribute/","title":"Improved support for high-resolution displays with the srcset image attribute"},{"url":"https://ericportis.com/posts/2014/srcset-sizes/","title":"Blog post on srcset & sizes"},{"url":"https://developer.mozilla.org/en-US/docs/Learn/HTML/Multimedia_and_embedding/Responsive_images","title":"MDN: Responsive images"},{"url":"https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img","title":"MDN: <img> element"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"a #2","13":"n #3","14":"n #3","15":"n #3","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n d #1","33":"n d #1","34":"n d #1","35":"n d #1","36":"n d #1","37":"n d #1","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"a #2","35":"a #2","36":"a #2","37":"a #2","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"a #2","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"a #2","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"a #2","22":"a #2","23":"a #2","24":"a #2","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a #2","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"a #2","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Can be enabled in Firefox by setting the about:config preference dom.image.srcset.enabled to true","2":"Supports the subset of the syntax for resolution switching (using the `x` descriptor), but not the full syntax that can be used with `sizes` (using the `w` descriptor).","3":"Intermittently displays distorted images due to bug present (see known issues)"},"usage_perc_y":96.34,"usage_perc_a":0.12,"ucprefix":false,"parent":"","keywords":"srcset attribute","ie_id":"imgsrcset","chrome_id":"4644337115725824","firefox_id":"","webkit_id":"feature-srcset-w-descriptor-and-related-sizes-attribute,feature-srcset-x-descriptor"},"stream":{"title":"getUserMedia/Stream API","description":"Method of accessing external device data (such as a webcam video stream). Formerly this was envisioned as the <device> element.","spec":"https://www.w3.org/TR/mediacapture-streams/","status":"cr","links":[{"url":"https://dev.opera.com/blog/webcam-orientation-preview/","title":"Technology preview from Opera"},{"url":"https://www.webplatform.org/docs/dom/Navigator/getUserMedia","title":"WebPlatform Docs"},{"url":"https://blogs.windows.com/msedgedev/2015/05/13/announcing-media-capture-functionality-in-microsoft-edge/","title":"Media Capture functionality in Microsoft Edge"},{"url":"https://stackoverflow.com/questions/50800696/getusermedia-in-pwa-with-manifest-on-ios-11","title":"getUserMedia in PWA with manifest on iOS 11"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=185448#c84","title":"getUserMedia working again in PWA on iOS 13.4"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"a x #1 #2","18":"a x #1 #2","19":"a x #1 #2","20":"a x #1 #2","21":"a x #1 #2","22":"a x #1 #2","23":"a x #1 #2","24":"a x #1 #2","25":"a x #1 #2","26":"a x #1 #2","27":"a x #1 #2","28":"a x #1 #2","29":"a x #1 #2","30":"a x #1 #2","31":"a x #1 #2","32":"a x #1 #2","33":"a x #1 #2","34":"a x #1 #2","35":"a x #1 #2","36":"y #1","37":"y #1","38":"y #1","39":"y #1","40":"y #1","41":"y #1","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"a x #1 #2","22":"a x #1 #2","23":"a x #1 #2","24":"a x #1 #2","25":"a x #1 #2","26":"a x #1 #2","27":"a x #1 #2","28":"a x #1 #2","29":"a x #1 #2","30":"a x #1 #2","31":"a x #1 #2","32":"a x #1 #2","33":"a x #1 #2","34":"a x #1 #2","35":"a x #1 #2","36":"a x #1 #2","37":"a x #1 #2","38":"a x #1 #2","39":"a x #1 #2","40":"a x #1 #2","41":"a x #1 #2","42":"a x #1 #2","43":"a x #1 #2","44":"a x #1 #2","45":"a x #1 #2","46":"a x #1 #2","47":"a x #1 #2","48":"a x #1 #2","49":"a x #1 #2","50":"a x #1 #2","51":"a x #1 #2","52":"a x #1 #2","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"a x #1 #2","15":"n","16":"n","17":"n","18":"a x #1 #2","19":"a x #1 #2","20":"a x #1 #2","21":"a x #1 #2","22":"a x #1 #2","23":"a x #1 #2","24":"a x #1 #2","25":"a x #1 #2","26":"a x #1 #2","27":"a x #1 #2","28":"a x #1 #2","29":"a x #1 #2","30":"a x #1 #2","31":"a x #1 #2","32":"a x #1 #2","33":"a x #1 #2","34":"a x #1 #2","35":"a x #1 #2","36":"a x #1 #2","37":"a x #1 #2","38":"a x #1 #2","39":"a x #1 #2","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"a x #1 #2"},"ios_saf":{"8":"n","14":"y #3","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"y #3 #4","11.3-11.4":"y #3 #4","12.0-12.1":"y #3 #4","12.2-12.4":"y #3 #4","13.0-13.1":"y #3 #4","13.2":"y #3 #4","13.3":"y #3 #4","13.4-13.7":"y #3"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"a x #1 #2"},"op_mob":{"10":"n","11":"n","12":"a x #1 #2","59":"y","11.1":"n","11.5":"n","12.1":"a x #1 #2"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"a x #1 #2","5.0-5.4":"a x #1 #2","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"a x #1 #2"},"kaios":{"2.5":"n"}},"notes":"As of Chrome 47, the getUserMedia API cannot be called from insecure origins.","notes_by_num":{"1":"Blink-based (and some other) browsers support an older version of the spec that does not use `srcObject`. [See Chromium issue 387740](https://code.google.com/p/chromium/issues/detail?id=387740).","2":"Supports the older spec's `navigator.getUserMedia` API, not the newer `navigator.mediaDevices.getUserMedia` one.","3":"`getUserMedia` returns no video input devices in `UIWebView` or `WKWebView`, but only directly in Safari.","4":"Does not work in standalone running (\"installed\") PWAs."},"usage_perc_y":94.87,"usage_perc_a":1.03,"ucprefix":false,"parent":"","keywords":"camera,device,getUserMedia,media stream,mediastream,Media Capture API","ie_id":"mediacaptureandstreams","chrome_id":"6067380039974912,6605041225957376","firefox_id":"","webkit_id":""},"streams":{"title":"Streams","description":"Method of creating, composing, and consuming streams of data, that map efficiently to low-level I/O primitives, and allow easy composition with built-in backpressure and queuing.","spec":"https://streams.spec.whatwg.org/","status":"ls","links":[{"url":"https://github.com/whatwg/streams","title":"GitHub repository"},{"url":"https://developer.mozilla.org/en/docs/Web/API/ReadableStream","title":"ReadableStream on Mozilla Developer Network"},{"url":"https://jakearchibald.com/2016/streams-ftw/","title":"Blog article about streams"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n #1","5.5":"n"},"edge":{"12":"u","13":"u","14":"a #2","15":"a #2","16":"a #4 #6","17":"a #4 #6","18":"a #4 #6","79":"a #4","80":"a #4","81":"a #4","83":"a #4","84":"a #4","85":"a #4","86":"a #4","87":"a #4"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n d #3 #5 #6","58":"n d #3 #5 #6","59":"n d #3 #5 #6","60":"n d #3 #5 #6","61":"n d #3 #5 #6","62":"n d #3 #5 #6","63":"n d #3 #5 #6","64":"n d #3 #5 #6","65":"a #5 #6","66":"a #5 #6","67":"a #5 #6","68":"a #5 #6","69":"a #5 #6","70":"a #5 #6","71":"a #5 #6","72":"a #5 #6","73":"a #5 #6","74":"a #5 #6","75":"a #5 #6","76":"a #5 #6","77":"a #5 #6","78":"a #5 #6","79":"a #5 #6","80":"a #5 #6","81":"a #5 #6","82":"a #5 #6","83":"a #5 #6","84":"a #5 #6","85":"a #5 #6","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"a #2","53":"a #2","54":"a #2","55":"a #2","56":"a #2","57":"a #2","58":"a #2","59":"a #4","60":"a #4","61":"a #4","62":"a #4","63":"a #4","64":"a #4","65":"a #4","66":"a #4","67":"a #4","68":"a #4","69":"a #4","70":"a #4","71":"a #4","72":"a #4","73":"a #4","74":"a #4","75":"a #4","76":"a #4","77":"a #4","78":"a #4","79":"a #4","80":"a #4","81":"a #4","83":"a #4","84":"a #4","85":"a #4","86":"a #4","87":"a #4","88":"a #4","89":"a #4","90":"a #4"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"a #4 #5","11":"a #4 #5","12":"a #4 #5","13":"a #4 #5","14":"a #4 #5","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"a #4 #5","11.1":"a #4 #5","12.1":"a #4 #5","13.1":"a #4 #5","TP":"a #4 #5"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"a #2","40":"a #2","41":"a #2","42":"a #2","43":"a #2","44":"a #2","45":"a #2","46":"a #4","47":"a #4","48":"a #4","49":"a #4","50":"a #4","51":"a #4","52":"a #4","53":"a #4","54":"a #4","55":"a #4","56":"a #4","57":"a #4","58":"a #4","60":"a #4","62":"a #4","63":"a #4","64":"a #4","65":"a #4","66":"a #4","67":"a #4","68":"a #4","69":"a #4","70":"a #4","71":"a #4","72":"a #4","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"a #4","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"u","10.3":"a #4","11.0-11.2":"a #4","11.3-11.4":"a #4","12.0-12.1":"a #4","12.2-12.4":"a #4","13.0-13.1":"a #4","13.2":"a #4","13.3":"a #4","13.4-13.7":"a #4"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"a #2","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"a #4","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a #4"},"and_ff":{"82":"n d #3 #5"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"a #4","8.2":"a #4","9.2":"a #4","10.1":"a #4","11.1-11.2":"a #4","12.0":"a #4"},"and_qq":{"10.4":"a #4"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"IE implements a different API than the one from WHATWG.","2":"Only basic read support.","3":"Disabled by default behind the `javascript.options.streams` and `dom.streams.enabled` flags. ","4":"No support for BYOB (\"bring your own buffer\") stream readers.","5":"No support for `WritableStream`.","6":"No support for the `pipeTo` or `pipeThrough` methods"},"usage_perc_y":0,"usage_perc_a":93.41,"ucprefix":false,"parent":"","keywords":"streams,writablestream,readablestream","ie_id":"streamsapireadablestream,streamsapiwritablestream","chrome_id":"6605041225957376","firefox_id":"readable-steams,writable-streams","webkit_id":"specification-streams"},"stricttransportsecurity":{"title":"Strict Transport Security","description":"Declare that a website is only accessible over a secure connection (HTTPS).","spec":"https://tools.ietf.org/html/rfc6797","status":"other","links":[{"url":"https://www.chromium.org/hsts/","title":"Chromium article"},{"url":"https://developer.mozilla.org/en-US/docs/Security/HTTP_Strict_Transport_Security","title":"MDN Web Docs - Strict Transport Security"},{"url":"https://www.owasp.org/index.php/HTTP_Strict_Transport_Security","title":"OWASP article"}],"categories":["Security"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"y #1","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"The HTTP header is 'Strict-Transport-Security'.","notes_by_num":{"1":"IE 11 added support [in an update](https://blogs.windows.com/msedgedev/2015/06/09/http-strict-transport-security-comes-to-internet-explorer-11-on-windows-8-1-and-windows-7/) on June 9, 2015"},"usage_perc_y":98.12,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"sts,hsts,security,header","ie_id":"httpstricttransportsecurityhsts","chrome_id":"4941480133132288","firefox_id":"","webkit_id":""},"style-scoped":{"title":"Scoped CSS","description":"Allows CSS rules to be scoped to part of the document, based on the position of the style element. The attribute has been [removed from the current specification](https://github.com/whatwg/html/issues/552).","spec":"https://www.w3.org/TR/html51/document-metadata.html#element-attrdef-style-scoped","status":"unoff","links":[{"url":"https://github.com/PM5544/scoped-polyfill","title":"Polyfill"},{"url":"http://html5doctor.com/the-scoped-attribute/","title":"HTML5 Doctor article"},{"url":"http://updates.html5rocks.com/2012/03/A-New-Experimental-Feature-style-scoped","title":"HTML5Rocks article"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1291515","title":"Firefox bug #1291515: disable `<style scoped>` in content documents"}],"categories":["CSS","HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"n d #2","56":"n d #2","57":"n d #2","58":"n d #2","59":"n d #2","60":"n d #2","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n d #1","21":"n d #1","22":"n d #1","23":"n d #1","24":"n d #1","25":"n d #1","26":"n d #1","27":"n d #1","28":"n d #1","29":"n d #1","30":"n d #1","31":"n d #1","32":"n d #1","33":"n d #1","34":"n d #1","35":"n d #1","36":"n d #1","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n d #2"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Enabled in Chrome through the \"experimental Web Platform features\" flag in chrome://flags","2":"Enabled in Firefox through the about:config setting \"layout.css.scoped-style.enabled\""},"usage_perc_y":0.39,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"scope","ie_id":"scopedstyles","chrome_id":"5374137958662144","firefox_id":"","webkit_id":""},"subresource-integrity":{"title":"Subresource Integrity","description":"Subresource Integrity enables browsers to verify that file is delivered without unexpected manipulation.","spec":"https://www.w3.org/TR/SRI/","status":"rec","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/Security/Subresource_Integrity","title":"Subresource Integrity (MDN)"},{"url":"https://www.srihash.org/","title":"SRI generation and browser support test"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=148363","title":"WebKit feature request bug"}],"categories":["HTML5","Security"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n d #1","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Can be enabled via the \"Experimental Features\" developer menu"},"usage_perc_y":95.07,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"SRI, security, hash","ie_id":"subresourceintegrity","chrome_id":"6183089948590080","firefox_id":"subresource-integrity","webkit_id":"feature-subresource-integrity"},"svg":{"title":"SVG (basic support)","description":"Method of displaying basic Vector Graphics features using the embed or object elements. Refers to the SVG 1.1 spec.","spec":"https://www.w3.org/TR/SVG/","status":"cr","links":[{"url":"https://en.wikipedia.org/wiki/Scalable_Vector_Graphics","title":"Wikipedia"},{"url":"https://alistapart.com/article/using-svg-for-flexible-scalable-and-fun-backgrounds-part-i/","title":"A List Apart article"},{"url":"http://svg-wow.org/","title":"SVG showcase site"},{"url":"http://code.google.com/p/svgweb/","title":"SVG Web: Flash-based polyfill"},{"url":"https://github.com/SVG-Edit/svgedit","title":"Web-based SVG editor"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/graphics.js#svg","title":"has.js test"}],"categories":["SVG"],"stats":{"ie":{"6":"p","7":"p","8":"p","9":"a #2 #3","10":"a #2 #3","11":"a #2 #3","5.5":"n"},"edge":{"12":"y #3","13":"y #3","14":"y #3","15":"y #3","16":"y #3","17":"y #3","18":"y #3","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"a","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"a #1","4":"a #1","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"a #1","4.2-4.3":"a #1","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y #2","11":"y #2"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support in Android 3 & 4 refers to not supporting masking.","2":"Partial support in IE9-11 refers to not supporting animations.","3":"IE9-11 & Edge don't properly scale SVG files. [Adding height, width, viewBox, and CSS rules](https://codepen.io/tomByrer/pen/qEBbzw?editors=110) seems to be the best workaround."},"usage_perc_y":98.22,"usage_perc_a":1.38,"ucprefix":false,"parent":"","keywords":"rect,circle,ellipse,line,polyline,polygon,defs,symbol,use,tspan,tref,textpath,stroke-dasharray,stroke-dashoffset,stroke-opacity","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"svg-css":{"title":"SVG in CSS backgrounds","description":"Method of using SVG images as CSS backgrounds","spec":"https://www.w3.org/TR/css3-background/#background-image","status":"cr","links":[{"url":"https://www.sitepoint.com/a-farewell-to-css3-gradients/","title":"Tutorial for advanced effects"}],"categories":["CSS3","SVG"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"a #3","13":"a #3","14":"a #3","15":"a #3","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a #2","5":"a #2","6":"a #2","7":"a #2","8":"a #2","9":"a #2","10":"a #2","11":"a #2","12":"a #2","13":"a #2","14":"a #2","15":"a #2","16":"a #2","17":"a #2","18":"a #2","19":"a #2","20":"a #2","21":"a #2","22":"a #2","23":"a #2","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"a","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a #1","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"a #1","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"a #1","4.0-4.1":"a #1","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"a #2"},"android":{"3":"y","4":"y","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"a #2","11":"a #2","12":"a #2","59":"y","11.1":"a #2","11.5":"a #2","12.1":"a #2"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support in iOS Safari and older Safari versions refers to failing to support tiling or the background-position property.","2":"Partial support in older Firefox and Opera Mini/Mobile refers to SVG images being blurry when scaled.","3":"Partial support in Edge 15 and older refers to a lack of support for SVG data URIs. [see bug](https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6274479/)"},"usage_perc_y":98.48,"usage_perc_a":1.1,"ucprefix":false,"parent":"","keywords":"svg-in-css,svgincss,css-svg","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"svg-filters":{"title":"SVG filters","description":"Method of using Photoshop-like effects on SVG objects including blurring and color manipulation.","spec":"https://www.w3.org/TR/SVG11/filters.html","status":"rec","links":[{"url":"http://electricbeach.org/?p=950","title":"Experiments with filter effects"},{"url":"http://svg-wow.org/blog/category/filters/","title":"SVG filter demos"},{"url":"https://www.webplatform.org/docs/svg/elements/filter","title":"WebPlatform Docs"},{"url":"http://jorgeatgu.github.io/svg-filters/","title":"SVG Filter effects"}],"categories":["SVG"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"n","5":"a","6":"a","7":"a","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":99.12,"usage_perc_a":0.02,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"svg-fonts":{"title":"SVG fonts","description":"Method of using fonts defined as SVG shapes. Removed from [SVG 2.0](https://www.w3.org/TR/SVG2/changes.html#fonts) and considered as a deprecated feature with support being removed from browsers.","spec":"https://www.w3.org/TR/SVG11/fonts.html","status":"rec","links":[{"url":"http://jeremie.patonnier.net/post/2011/02/07/Why-are-SVG-Fonts-so-different","title":"Blog post"},{"url":"http://opentype.info/blog/2010/04/13/the-ipad-and-svg-fonts-in-mobile-safari/","title":"Blog post on usage for iPad"}],"categories":["SVG"],"stats":{"ie":{"6":"p","7":"p","8":"p","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"n #1","39":"n #1","40":"n #1","41":"n #1","42":"n #1","43":"n #1","44":"n #1","45":"n #1","46":"n #1","47":"n #1","48":"n #1","49":"n #1","50":"n #1","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"n #1","26":"n #1","27":"n #1","28":"n #1","29":"n #1","30":"n #1","31":"n #1","32":"n #1","33":"n #1","34":"n #1","35":"n #1","36":"n #1","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n #2"},"android":{"3":"y","4":"y","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"n #1"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"y","5.0-5.4":"n #1","6.2-6.4":"n #1","7.2-7.4":"n #1","8.2":"n #1","9.2":"n #1","10.1":"n #1","11.1-11.2":"n #1","12.0":"n #1"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n #1"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Chrome 38 and newer support SVG fonts only on Windows Vista and XP.","2":"Supported in Opera Mini in SVG images only, not in HTML."},"usage_perc_y":17.42,"usage_perc_a":0,"ucprefix":false,"parent":"fontface","keywords":"","ie_id":"","chrome_id":"5930075908210688","firefox_id":"","webkit_id":""},"svg-fragment":{"title":"SVG fragment identifiers","description":"Method of displaying only a part of an SVG image by defining a view ID or view box dimensions as the file's fragment identifier.","spec":"https://www.w3.org/TR/SVG/linking.html#SVGFragmentIdentifiers","status":"cr","links":[{"url":"http://www.broken-links.com/2012/08/14/better-svg-sprites-with-fragment-identifiers/","title":"Blog post"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=91791","title":"WebKit support bug"}],"categories":["SVG"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"a #2","10":"a #2","11":"a #2","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"a #1","9":"n","10":"n","11":"n","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"a #1","9.1":"n","10.1":"n","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"a","12":"a","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"u","10.0-10.1":"a","10.5":"a","10.6":"a","11.1":"a","11.5":"a","11.6":"a","12.1":"y"},"ios_saf":{"8":"a #1","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"a #1","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"a #1"},"op_mob":{"10":"a","11":"a","12":"a","59":"y","11.1":"a","11.5":"a","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"a #1","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"a #1"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support refers to support inside `<img>` but not as CSS `background-image`","2":"Partial support refers to lack of external fragments support"},"usage_perc_y":95.89,"usage_perc_a":2.14,"ucprefix":false,"parent":"","keywords":"fragments,sprite,svg,use","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"svg-html":{"title":"SVG effects for HTML","description":"Method of using SVG transforms, filters, etc on HTML elements using either CSS or the foreignObject element","spec":"https://www.w3.org/TR/SVG11/extend.html#ForeignObjectElement","status":"rec","links":[{"url":"https://developer.mozilla.org/en/SVG/Tutorial/Other_content_in_SVG","title":"MDN Web Docs - Other content in SVG"},{"url":"https://developer.mozilla.org/En/Applying_SVG_effects_to_HTML_content","title":"MDN Web Docs - Applying SVG effects"},{"url":"https://www.w3.org/TR/filter-effects/","title":"Filter Effects draft"}],"categories":["SVG"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"a #1 #2","10":"a #1 #2","11":"a #1 #2","5.5":"n"},"edge":{"12":"a #2","13":"a #2","14":"a #2","15":"a #2","16":"a #2","17":"a #2","18":"a #2","79":"a","80":"a","81":"a","83":"a","84":"a","85":"a","86":"a","87":"a"},"firefox":{"2":"n","3":"a","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"a","5":"a","6":"a","7":"a","8":"a","9":"a","10":"a","11":"a","12":"a","13":"a","14":"a","15":"a","16":"a","17":"a","18":"a","19":"a","20":"a","21":"a","22":"a","23":"a","24":"a","25":"a","26":"a","27":"a","28":"a","29":"a","30":"a","31":"a","32":"a","33":"a","34":"a","35":"a","36":"a","37":"a","38":"a","39":"a","40":"a","41":"a","42":"a","43":"a","44":"a","45":"a","46":"a","47":"a","48":"a","49":"a","50":"a","51":"a","52":"a","53":"a","54":"a","55":"a","56":"a","57":"a","58":"a","59":"a","60":"a","61":"a","62":"a","63":"a","64":"a","65":"a","66":"a","67":"a","68":"a","69":"a","70":"a","71":"a","72":"a","73":"a","74":"a","75":"a","76":"a","77":"a","78":"a","79":"a","80":"a","81":"a","83":"a","84":"a","85":"a","86":"a","87":"a","88":"a","89":"a","90":"a"},"safari":{"4":"a","5":"a","6":"a","7":"a","8":"a","9":"a","10":"a","11":"a","12":"a","13":"a","14":"a","3.1":"n","3.2":"n","5.1":"a","6.1":"a","7.1":"a","9.1":"a","10.1":"a","11.1":"a","12.1":"a","13.1":"a","TP":"a"},"opera":{"9":"a","11":"a","12":"a","15":"a","16":"a","17":"a","18":"a","19":"a","20":"a","21":"a","22":"a","23":"a","24":"a","25":"a","26":"a","27":"a","28":"a","29":"a","30":"a","31":"a","32":"a","33":"a","34":"a","35":"a","36":"a","37":"a","38":"a","39":"a","40":"a","41":"a","42":"a","43":"a","44":"a","45":"a","46":"a","47":"a","48":"a","49":"a","50":"a","51":"a","52":"a","53":"a","54":"a","55":"a","56":"a","57":"a","58":"a","60":"a","62":"a","63":"a","64":"a","65":"a","66":"a","67":"a","68":"a","69":"a","70":"a","71":"a","72":"a","9.5-9.6":"a","10.0-10.1":"a","10.5":"a","10.6":"a","11.1":"a","11.5":"a","11.6":"a","12.1":"a"},"ios_saf":{"8":"a","14":"a","3.2":"a","4.0-4.1":"a","4.2-4.3":"a","5.0-5.1":"a","6.0-6.1":"a","7.0-7.1":"a","8.1-8.4":"a","9.0-9.2":"a","9.3":"a","10.0-10.2":"a","10.3":"a","11.0-11.2":"a","11.3-11.4":"a","12.0-12.1":"a","12.2-12.4":"a","13.0-13.1":"a","13.2":"a","13.3":"a","13.4-13.7":"a"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"a","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"a","4.4.3-4.4.4":"a"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"a","11":"a","12":"a","59":"a","11.1":"a","11.5":"a","12.1":"a"},"and_chr":{"86":"a"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"a","5.0-5.4":"a","6.2-6.4":"a","7.2-7.4":"a","8.2":"a","9.2":"a","10.1":"a","11.1-11.2":"a","12.0":"a"},"and_qq":{"10.4":"a"},"baidu":{"7.12":"a"},"kaios":{"2.5":"y"}},"notes":"Partial support refers to lack of filter support or buggy result from effects. A [CSS Filter Effects](https://www.w3.org/TR/filter-effects/) specification is in the works that would replace this method.","notes_by_num":{"1":"IE11 and below do not support `<foreignObject>`.","2":"IE and Edge do not support applying SVG filter effects to HTML elements using CSS. [Bug Report](https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6618695/)"},"usage_perc_y":4.22,"usage_perc_a":93.19,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"svg-html5":{"title":"Inline SVG in HTML5","description":"Method of using SVG tags directly in HTML documents. Requires HTML5 parser.","spec":"https://html.spec.whatwg.org/multipage/embedded-content.html#svg-0","status":"ls","links":[{"url":"https://hacks.mozilla.org/2010/05/firefox-4-the-html5-parser-inline-svg-speed-and-more/","title":"Mozilla Hacks blog post"},{"url":"http://samples.msdn.microsoft.com/ietestcenter/html5/svghtml_harness.htm?url=SVG_HTML_Elements_001","title":"Test suite"}],"categories":["HTML5","SVG"],"stats":{"ie":{"6":"p","7":"p","8":"p","9":"y #1","10":"y #1","11":"y #1","5.5":"n"},"edge":{"12":"y #1","13":"y #1","14":"y #1","15":"y #1","16":"y #1","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"p","3":"p","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"p","3.6":"p"},"chrome":{"4":"p","5":"p","6":"p","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"p","5":"p","6":"y #1","7":"y #1","8":"y #1","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"p","3.2":"p","5.1":"y #1","6.1":"y #1","7.1":"y #1","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"p","11":"n","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"p","10.0-10.1":"p","10.5":"p","10.6":"n","11.1":"n","11.5":"n","11.6":"y","12.1":"y"},"ios_saf":{"8":"y #1","14":"y","3.2":"p","4.0-4.1":"p","4.2-4.3":"p","5.0-5.1":"y #1","6.0-6.1":"y #1","7.0-7.1":"y #1","8.1-8.4":"y #1","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y #1","4":"y #1","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y #1","4.2-4.3":"y #1","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y #1","10":"y"},"op_mob":{"10":"p","11":"p","12":"y","59":"y","11.1":"p","11.5":"p","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y #1","11":"y #1"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Does not support CSS transforms on SVG elements (transform attribute can be used instead)"},"usage_perc_y":99.47,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"svg-img":{"title":"SVG in HTML img element","description":"Method of displaying SVG images in HTML using <img>.","spec":"https://html.spec.whatwg.org/multipage/embedded-content.html","status":"ls","links":[{"url":"http://blog.dholbert.org/2010/10/svg-as-image.html","title":"Blog post with examples"},{"url":"http://www.codedread.com/blog/","title":"Blog with SVGs an images"}],"categories":["SVG"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"a","5.1":"a #1","6.1":"a #1","7.1":"a #1","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"a #1","14":"y","3.2":"a #1","4.0-4.1":"a #1","4.2-4.3":"a #1","5.0-5.1":"a #1","6.0-6.1":"a #1","7.0-7.1":"a #1","8.1-8.4":"a #1","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"a #1","4":"a #1","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"a #1","4.2-4.3":"a #1","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support refers to not supporting embedded images (data URIs) inside the SVG."},"usage_perc_y":99.1,"usage_perc_a":0.48,"ucprefix":false,"parent":"","keywords":"svg-as-img,svg-in-img","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"svg-smil":{"title":"SVG SMIL animation","description":"Method of using animation elements to animate SVG images","spec":"https://www.w3.org/TR/SVG11/animate.html","status":"rec","links":[{"url":"http://svg-wow.org/blog/category/animation/","title":"Examples on SVG WOW"},{"url":"https://developer.mozilla.org/en/SVG/SVG_animation_with_SMIL","title":"MDN Web Docs - animation with SMIL"},{"url":"http://leunen.me/fakesmile/","title":"JS library to support SMIL in SVG"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/graphics.js#svg-smil","title":"has.js test"},{"url":"https://github.com/madsgraphics/SVGEventListener","title":"Polyfill for SMIL animate events on SVG"}],"categories":["SVG"],"stats":{"ie":{"6":"p","7":"p","8":"p","9":"p","10":"p","11":"p","5.5":"n"},"edge":{"12":"p","13":"p","14":"p","15":"p","16":"p","17":"p","18":"p","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"p","3":"p","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"p","3.6":"p"},"chrome":{"4":"a","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a #1","5":"a #1","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"p","3.2":"p","5.1":"a #1","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"a #1","4.0-4.1":"a #1","4.2-4.3":"a #1","5.0-5.1":"a #1","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"p","11":"p"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support in older Safari versions refers to not working in HTML files or CSS background images."},"usage_perc_y":96.78,"usage_perc_a":0.18,"ucprefix":false,"parent":"","keywords":"svg animation","ie_id":"svgsmilanimation","chrome_id":"","firefox_id":"","webkit_id":""},"sxg":{"title":"Signed HTTP Exchanges (SXG)","description":"Part of the Web Packaging spec, Signed HTTP Exchanges allow a different origin server to provide a resource, and this will be treated as if it came from the original server. This can be use with AMP CDNs, for example, to allow the original URL to be displayed in the URL bar.","spec":"https://tools.ietf.org/html/draft-yasskin-http-origin-signed-responses","status":"other","links":[{"url":"https://www.chromestatus.com/feature/5745285984681984","title":"Chrome platform status - Shipped"},{"url":"https://developer.microsoft.com/en-us/microsoft-edge/status/originsignedhttpexchanges/","title":"Microsoft Edge Platform Status - Supported"},{"url":"https://developers.google.com/web/updates/2018/11/signed-exchanges","title":"Signed HTTP Exchanges on Google's Web Development site"},{"url":"https://blog.amp.dev/2018/11/13/developer-preview-of-better-amp-urls-in-google-search/","title":"Developer Preview of better AMP URLs in Google Search"},{"url":"https://medium.com/oyotech/implementing-signed-exchange-for-better-amp-urls-38abd64c6766","title":"Signed-Exchange: Solving the AMP URLs Display Problem"},{"url":"https://github.com/WICG/webpackage","title":"GitHub home page for Web Packaging"},{"url":"https://mozilla.github.io/standards-positions/#http-origin-signed-responses","title":"Mozilla's Position about Signed HTTP Exchanges (harmful)"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"a #1","72":"a #1","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"u"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"u","12.0":"u"},"and_qq":{"10.4":"u"},"baidu":{"7.12":"u"},"kaios":{"2.5":"n"}},"notes":"Note this requires the page to be delivered signed by a certificate with the CanSignHttpExchanges extension.","notes_by_num":{"1":"Partial support behind a feature flag (chrome://flags/#enable-signed-http-exchange)"},"usage_perc_y":69.48,"usage_perc_a":0.2,"ucprefix":false,"parent":"","keywords":"SXG, WebPackage, AMP","ie_id":"originsignedhttpexchanges","chrome_id":"5745285984681984","firefox_id":"","webkit_id":""},"tabindex-attr":{"title":"tabindex global attribute","description":"Specifies the focusability of the element and in what order (if any) it should become focused (relative to other elements) when \"tabbing\" through the document.","spec":"https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex","title":"MDN Web Docs - tabindex attribute"}],"categories":["HTML5"],"stats":{"ie":{"6":"u","7":"y","8":"y","9":"y","10":"y","11":"y","5.5":"u"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"u","3":"u","4":"y #1","5":"y #1","6":"y #1","7":"y #1","8":"y #1","9":"y #1","10":"y #1","11":"y #1","12":"y #1","13":"y #1","14":"y #1","15":"y #1","16":"y #1","17":"y #1","18":"y #1","19":"y #1","20":"y #1","21":"y #1","22":"y #1","23":"y #1","24":"y #1","25":"y #1","26":"y #1","27":"y #1","28":"y #1","29":"y #1","30":"y #1","31":"y #1","32":"y #1","33":"y #1","34":"y #1","35":"y #1","36":"y #1","37":"y #1","38":"y #1","39":"y #1","40":"y #1","41":"y #1","42":"y #1","43":"y #1","44":"y #1","45":"y #1","46":"y #1","47":"y #1","48":"y #1","49":"y #1","50":"y #1","51":"y #1","52":"y #1","53":"y #1","54":"y #1","55":"y #1","56":"y #1","57":"y #1","58":"y #1","59":"y #1","60":"y #1","61":"y #1","62":"y #1","63":"y #1","64":"y #1","65":"y #1","66":"y #1","67":"y #1","68":"y #1","69":"y #1","70":"y #1","71":"y #1","72":"y #1","73":"y #1","74":"y #1","75":"y #1","76":"y #1","77":"y #1","78":"y #1","79":"y #1","80":"y #1","81":"y #1","82":"y #1","83":"y #1","84":"y #1","85":"y #1","3.5":"u","3.6":"u"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"u","5":"u","6":"y #2","7":"y #2","8":"y #2","9":"y #2","10":"y #2","11":"y #2","12":"y #2","13":"y #2","14":"y #2","3.1":"u","3.2":"u","5.1":"y #2","6.1":"y #2","7.1":"y #2","9.1":"y #2","10.1":"y #2","11.1":"y #2","12.1":"y #2","13.1":"y #2","TP":"y #2"},"opera":{"9":"u","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y #2 #3","14":"y #2 #3","3.2":"y #2 #3","4.0-4.1":"y #2 #3","4.2-4.3":"y #2 #3","5.0-5.1":"y #2 #3","6.0-6.1":"y #2 #3","7.0-7.1":"y #2 #3","8.1-8.4":"y #2 #3","9.0-9.2":"y #2 #3","9.3":"y #2 #3","10.0-10.2":"y #2 #3","10.3":"y #2 #3","11.0-11.2":"y #2 #3","11.3-11.4":"y #2 #3","12.0-12.1":"y #2 #3","12.2-12.4":"y #2 #3","13.0-13.1":"y #2 #3","13.2":"y #2 #3","13.3":"y #2 #3","13.4-13.7":"y #2 #3"},"op_mini":{"all":"u"},"android":{"3":"u","4":"u","81":"u","2.1":"u","2.2":"u","2.3":"u","4.1":"u","4.2-4.3":"u","4.4":"u","4.4.3-4.4.4":"u"},"bb":{"7":"u","10":"u"},"op_mob":{"10":"u","11":"u","12":"u","59":"u","11.1":"u","11.5":"u","12.1":"u"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"u","11":"u"},"and_uc":{"12.12":"u"},"samsung":{"4":"u","5.0-5.4":"u","6.2-6.4":"u","7.2-7.4":"u","8.2":"u","9.2":"u","10.1":"u","11.1-11.2":"u","12.0":"u"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"u"},"kaios":{"2.5":"y #1"}},"notes":"Mac OS X \"Full Keyboard Access\" refers to setting Keyboard→Shortcuts→Full Keyboard Access to \"All controls\" in the System Preferences.\r\n\r\n\"Unknown\" support for mobile browsers is due to lacking a method of tabbing through fields.","notes_by_num":{"1":"On Mac OS X, unless Full Keyboard Access is enabled, `<a>` elements are not keyboard-focusable, even if they have `tabindex=\"0\"`.","2":"`<a>` elements are never keyboard-focusable, even if they have `tabindex=\"0\"`. Unless Full Keyboard Access is enabled, then `<button>`s, radio buttons, and checkboxes are also not keyboard-focusable, even if they have `tabindex=\"0\"`.","3":"Has \"previous\" and \"next\" virtual keyboard buttons that follow tabindex order."},"usage_perc_y":93.95,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"tabindex,tab,tabIndex","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"template":{"title":"HTML templates","description":"Method of declaring a portion of reusable markup that is parsed but not rendered until cloned.","spec":"https://html.spec.whatwg.org/multipage/scripting.html#the-template-element","status":"ls","links":[{"url":"https://www.html5rocks.com/en/tutorials/webcomponents/template/","title":"HTML5Rocks - HTML's New template Tag"},{"url":"http://polymer-project.org","title":"Polymer project (polyfill & web components framework)"},{"url":"https://github.com/manubb/template","title":"Polyfill script"}],"categories":["DOM","HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"a #1 #2","14":"a #1 #2","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"a #1 #2","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n #3","7.1":"a #1 #2","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a #1 #2","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"a #1 #2","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Does not support Document.importNode on templates, nested templates or elements that contain templates.","2":"Does not support Node.cloneNode on templates, nested templates or elements that contain templates.","3":"Safari 6.2 has the same partial support as Safari 7.1."},"usage_perc_y":96.57,"usage_perc_a":0.17,"ucprefix":false,"parent":"","keywords":"webcomponents, template","ie_id":"templateelement","chrome_id":"5207287069147136","firefox_id":"html-templates","webkit_id":"feature-template-element"},"template-literals":{"title":"ES6 Template Literals (Template Strings)","description":"Template literals are string literals allowing embedded expressions. You can use multi-line strings and string interpolation features with them. Formerly known as template strings.","spec":"https://tc39.es/ecma262/#sec-template-literals","status":"other","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals","title":"MDN Web Docs - Template literals"},{"url":"https://ponyfoo.com/articles/es6-template-strings-in-depth","title":"ES6 Template Literals in Depth"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"u","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y #1","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y #1","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Safari 12 [sometimes garbage collects](https://bugs.webkit.org/show_bug.cgi?id=190756) the cached TemplateStrings used by Tagged Template Literals"},"usage_perc_y":96.32,"usage_perc_a":0,"ucprefix":false,"parent":"es6","keywords":"``,multiline","ie_id":"templatestringses6","chrome_id":"4743002513735680","firefox_id":"","webkit_id":"feature-template-literals"},"text-decoration":{"title":"text-decoration styling","description":"Method of defining the type, style and color of lines in the text-decoration property. These can be defined as shorthand (e.g. `text-decoration: line-through dashed blue`) or as single properties (e.g. `text-decoration-color: blue`)","spec":"https://www.w3.org/TR/css-text-decor-3/#line-decoration","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration-style","title":"MDN Web Docs - text-decoration-style"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration-color","title":"MDN Web Docs - text-decoration-color"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration-line","title":"MDN Web Docs - text-decoration-line"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6514536-text-decoration-styling","title":"Microsoft Edge feature request on UserVoice"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration-skip","title":"MDN Web Docs - text-decoration-skip"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=812990","title":"Firefox implementation bug"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"a #5","80":"a #5","81":"a #5","83":"a #5","84":"a #5","85":"a #5","86":"a #5","87":"a #5"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"a x #4","7":"a x #4","8":"a x #4","9":"a x #4","10":"a x #4","11":"a x #4","12":"a x #4","13":"a x #4","14":"a x #4","15":"a x #4","16":"a x #4","17":"a x #4","18":"a x #4","19":"a x #4","20":"a x #4","21":"a x #4","22":"a x #4","23":"a x #4","24":"a x #4","25":"a x #4","26":"a x #4","27":"a x #4","28":"a x #4","29":"a x #4","30":"a x #4","31":"a x #4","32":"a x #4","33":"a x #4","34":"a x #4","35":"a x #4","36":"a #4","37":"a #4","38":"a #4","39":"a #4","40":"a #4","41":"a #4","42":"a #4","43":"a #4","44":"a #4","45":"a #4","46":"a #4","47":"a #4","48":"a #4","49":"a #4","50":"a #4","51":"a #4","52":"a #4","53":"a #4","54":"a #4","55":"a #4","56":"a #4","57":"a #4","58":"a #4","59":"a #4","60":"a #4","61":"a #4","62":"a #4","63":"a #4","64":"a #4","65":"a #4","66":"a #4","67":"a #4","68":"a #4","69":"a #4","70":"a #4","71":"a #4","72":"a #4","73":"a #4","74":"a #4","75":"a #4","76":"a #4","77":"a #4","78":"a #4","79":"a #4","80":"a #4","81":"a #4","82":"a #4","83":"a #4","84":"a #4","85":"a #4","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n x d #1","27":"n x d #1","28":"n x d #1","29":"n x d #1","30":"n x d #1","31":"n x d #1","32":"n x d #1","33":"n x d #1","34":"n x d #1","35":"n x d #1","36":"n x d #1","37":"n x d #1","38":"n x d #1","39":"n x d #1","40":"n x d #1","41":"n x d #1","42":"n x d #1","43":"n x d #1","44":"n x d #1","45":"n x d #1","46":"n x d #1","47":"n x d #1","48":"n x d #1","49":"n x d #1","50":"n x d #1","51":"n x d #1","52":"n x d #1","53":"n x d #1","54":"n x d #1","55":"n x d #1","56":"n x d #1","57":"a #5","58":"a #5","59":"a #5","60":"a #5","61":"a #5","62":"a #5","63":"a #5","64":"a #5","65":"a #5","66":"a #5","67":"a #5","68":"a #5","69":"a #5","70":"a #5","71":"a #5","72":"a #5","73":"a #5","74":"a #5","75":"a #5","76":"a #5","77":"a #5","78":"a #5","79":"a #5","80":"a #5","81":"a #5","83":"a #5","84":"a #5","85":"a #5","86":"a #5","87":"a #5","88":"a #5","89":"a #5","90":"a #5"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"a x #2 #3","9":"a x #2 #3","10":"a x #2 #3","11":"a x #2 #3","12":"a x #2 #3","13":"a #2 #3","14":"a #2 #3","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"a x #2 #4","9.1":"a x #2 #3","10.1":"a x #2 #3","11.1":"a x #2 #3","12.1":"a #2 #3","13.1":"a #2 #3","TP":"a #2 #3"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n x d #1","36":"n x d #1","37":"n x d #1","38":"n x d #1","39":"n x d #1","40":"n x d #1","41":"n x d #1","42":"n x d #1","43":"n x d #1","44":"a #5","45":"a #5","46":"a #5","47":"a #5","48":"a #5","49":"a #5","50":"a #5","51":"a #5","52":"a #5","53":"a #5","54":"a #5","55":"a #5","56":"a #5","57":"a #5","58":"a #5","60":"a #5","62":"a #5","63":"a #5","64":"a #5","65":"a #5","66":"a #5","67":"a #5","68":"a #5","69":"a #5","70":"a #5","71":"a #5","72":"a #5","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a x #2","14":"a x #2","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"a x #2","9.0-9.2":"a x #2","9.3":"a x #2","10.0-10.2":"a x #2","10.3":"a x #2","11.0-11.2":"a x #2","11.3-11.4":"a x #2","12.0-12.1":"a x #2","12.2-12.4":"a x #2","13.0-13.1":"a x #2","13.2":"a x #2","13.3":"a x #2","13.4-13.7":"a x #2"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"a #5","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a #5"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"a #5"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"a #5","8.2":"a #5","9.2":"a #5","10.1":"a #5","11.1-11.2":"a #5","12.0":"a #5"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"y"},"kaios":{"2.5":"a #4"}},"notes":"All browsers support the CSS2 version of `text-decoration`, which matches only the `text-decoration-line` values (`underline`, etc.)","notes_by_num":{"1":"Enabled in Chrome through the \"experimental Web Platform features\" flag in chrome://flags","2":"Partial support refers to not supporting the `text-decoration-style` property.","3":"Safari 8+ supports `-webkit-text-decoration-skip` with values `none` and `skip` (other values behave like `none` or `skip`)","4":"Partial support refers to not supporting the `text-decoration-skip` property.","5":"Partial support refers to `text-decoration-skip` only supporting value `objects` and `ink`."},"usage_perc_y":0.23,"usage_perc_a":94.96,"ucprefix":false,"parent":"","keywords":"text-decoration-line,text-decoration-style,text-decoration-color,text-decoration-skip","ie_id":"","chrome_id":"5766823203045376","firefox_id":"","webkit_id":"specification-css-text-decoration-level-4"},"text-emphasis":{"title":"text-emphasis styling","description":"Method of using small symbols next to each glyph to emphasize a run of text, commonly used in East Asian languages. The `text-emphasis` shorthand, and its `text-emphasis-style` and `text-emphasis-color` longhands, can be used to apply marks to the text. The `text-emphasis-position` property, which inherits separately, allows setting the emphasis marks' position with respect to the text.","spec":"https://drafts.csswg.org/css-text-decor-3/#text-emphasis-property","status":"cr","links":[{"url":"https://github.com/zmmbreeze/jquery.emphasis/","title":"A javascript fallback for CSS3 emphasis mark."},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6514536-text-decoration-styling","title":"Microsoft Edge feature request on UserVoice"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/text-emphasis","title":"MDN Web Docs - text-emphasis"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"a x #1","80":"a x #1","81":"a x #1","83":"a x #1","84":"a x #1","85":"a x #1","86":"a x #1","87":"a x #1"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n d #2","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"a x #1","52":"a x #1","53":"a x #1","54":"a x #1","55":"a x #1","56":"a x #1","57":"a x #1","58":"a x #1","59":"a x #1","60":"a x #1","61":"a x #1","62":"a x #1","63":"a x #1","64":"a x #1","65":"a x #1","66":"a x #1","67":"a x #1","68":"a x #1","69":"a x #1","70":"a x #1","71":"a x #1","72":"a x #1","73":"a x #1","74":"a x #1","75":"a x #1","76":"a x #1","77":"a x #1","78":"a x #1","79":"a x #1","80":"a x #1","81":"a x #1","83":"a x #1","84":"a x #1","85":"a x #1","86":"a x #1","87":"a x #1","88":"a x #1","89":"a x #1","90":"a x #1"},"safari":{"4":"n","5":"n","6":"n","7":"a x #1","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"a x #1","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","19":"a x #1","20":"a x #1","21":"a x #1","22":"a x #1","23":"a x #1","24":"a x #1","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"a x #1","52":"a x #1","53":"a x #1","54":"a x #1","55":"a x #1","56":"a x #1","57":"a x #1","58":"a x #1","60":"a x #1","62":"a x #1","63":"a x #1","64":"a x #1","65":"a x #1","66":"a x #1","67":"a x #1","68":"a x #1","69":"a x #1","70":"a x #1","71":"a x #1","72":"a x #1","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"a x #1","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"a x #1","4.4.3-4.4.4":"a x #1"},"bb":{"7":"n","10":"a x #1"},"op_mob":{"10":"n","11":"n","12":"n","59":"a x #1","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a x #1"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"a x #1"},"samsung":{"4":"a x #1","5.0-5.4":"a x #1","6.2-6.4":"a x #1","7.2-7.4":"a x #1","8.2":"a x #1","9.2":"a x #1","10.1":"a x #1","11.1-11.2":"a x #1","12.0":"a x #1"},"and_qq":{"10.4":"a x #1"},"baidu":{"7.12":"a x #1"},"kaios":{"2.5":"y"}},"notes":"Some old WebKit browsers (like Chrome 24) support `-webkit-text-emphasis`, but does not support CJK languages and is therefore considered unsupported.","notes_by_num":{"1":"Partial support refers to incorrect support for `-webkit-text-emphasis-position`. These browsers support `over` and `under` as values, but not the added `left` and `right` values required by the spec.","2":"Can be enabled in Firefox using the `layout.css.text-emphasis.enabled` flag"},"usage_perc_y":20.36,"usage_perc_a":75.82,"ucprefix":false,"parent":"","keywords":"text-emphasis,text-emphasis-position,text-emphasis-style,text-emphasis-color","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"text-overflow":{"title":"CSS3 Text-overflow","description":"Append ellipsis when text overflows its containing element","spec":"https://www.w3.org/TR/css3-ui/#text-overflow","status":"cr","links":[{"url":"https://github.com/rmorse/AutoEllipsis","title":"jQuery polyfill for Firefox"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/text-overflow","title":"MDN Web Docs - text-overflow"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/css.js#css-text-overflow","title":"has.js test"},{"url":"https://www.webplatform.org/docs/css/properties/text-overflow","title":"WebPlatform Docs"}],"categories":["CSS3"],"stats":{"ie":{"6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"p","3":"p","4":"p","5":"p","6":"p","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"p","3.6":"p"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y x","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y x","10.0-10.1":"y x","10.5":"y x","10.6":"y x","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y x","11":"y x","12":"y x","59":"y","11.1":"y x","11.5":"y x","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":99.63,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"textoverflow,ellipsis","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"text-size-adjust":{"title":"CSS text-size-adjust","description":"On mobile devices, the text-size-adjust CSS property allows Web authors to control if and how the text-inflating algorithm is applied to the textual content of the element it is applied to.","spec":"https://drafts.csswg.org/css-size-adjust/","status":"unoff","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/text-size-adjust","title":"MDN Web Docs - text-size-adjust"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1226116","title":"Mozilla Bug #1226116: Unprefix -moz-text-size-adjust"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n #2","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n #2","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"y","44":"n","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y x","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y x","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y x","10.3":"y x","11.0-11.2":"y x","11.3-11.4":"y x","12.0-12.1":"y x","12.2-12.4":"y x","13.0-13.1":"y x","13.2":"y x","13.3":"y x","13.4-13.7":"y x"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y x"},"ie_mob":{"10":"y x #1","11":"y x #1"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"If the viewport size is set using a `<meta>` element, the `-ms-text-size-adjust` property is ignored. See [MDN](https://developer.mozilla.org/en-US/docs/Web/CSS/text-size-adjust)","2":"Old versions of WebKit-based desktop browsers (Chrome<27, Safari<6) [suffer from a bug](https://bugs.webkit.org/show_bug.cgi?id=56543) where if `-webkit-text-size-adjust` is explicitly set to `none`, instead of ignoring the property, the browsers will prevent the user from zooming in or out on the webpage."},"usage_perc_y":87.61,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"5730156303876096","firefox_id":"","webkit_id":""},"text-stroke":{"title":"CSS text-stroke and text-fill","description":"Method of declaring the outline (stroke) width and color for text.","spec":"https://compat.spec.whatwg.org/#text-fill-and-stroking","status":"unoff","links":[{"url":"https://css-tricks.com/adding-stroke-to-web-text/","title":"Information & workarounds"},{"url":"http://www.westciv.com/tools/textStroke/","title":"Live editor"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/-webkit-text-stroke","title":"MDN Web Docs - text-stroke"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"y x #1","16":"y x #1","17":"y x #1","18":"y x #1","79":"y x","80":"y x","81":"y x","83":"y x","84":"y x","85":"y x","86":"y x","87":"y x"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n d #1 #2","49":"y x #1","50":"y x #1","51":"y x #1","52":"y x #1","53":"y x #1","54":"y x #1","55":"y x #1","56":"y x #1","57":"y x #1","58":"y x #1","59":"y x #1","60":"y x #1","61":"y x #1","62":"y x #1","63":"y x #1","64":"y x #1","65":"y x #1","66":"y x #1","67":"y x #1","68":"y x #1","69":"y x #1","70":"y x #1","71":"y x #1","72":"y x #1","73":"y x #1","74":"y x #1","75":"y x #1","76":"y x #1","77":"y x #1","78":"y x #1","79":"y x #1","80":"y x #1","81":"y x #1","82":"y x #1","83":"y x #1","84":"y x #1","85":"y x #1","3.5":"n","3.6":"n"},"chrome":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","59":"y x","60":"y x","61":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y x","70":"y x","71":"y x","72":"y x","73":"y x","74":"y x","75":"y x","76":"y x","77":"y x","78":"y x","79":"y x","80":"y x","81":"y x","83":"y x","84":"y x","85":"y x","86":"y x","87":"y x","88":"y x","89":"y x","90":"y x"},"safari":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","3.1":"y x","3.2":"y x","5.1":"y x","6.1":"y x","7.1":"y x","9.1":"y x","10.1":"y x","11.1":"y x","12.1":"y x","13.1":"y x","TP":"y x"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","60":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y x","70":"y x","71":"y x","72":"y x","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y x","3.2":"a x","4.0-4.1":"y x","4.2-4.3":"y x","5.0-5.1":"y x","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y x","10.3":"y x","11.0-11.2":"y x","11.3-11.4":"y x","12.0-12.1":"y x","12.2-12.4":"y x","13.0-13.1":"y x","13.2":"y x","13.3":"y x","13.4-13.7":"y x"},"op_mini":{"all":"n"},"android":{"3":"n","4":"y x","81":"y x","2.1":"y x","2.2":"y x","2.3":"y x","4.1":"y x","4.2-4.3":"y x","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"y x","10":"y x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y x","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y x"},"and_ff":{"82":"y x #1"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y x"},"samsung":{"4":"y x","5.0-5.4":"y x","6.2-6.4":"y x","7.2-7.4":"y x","8.2":"y x","9.2":"y x","10.1":"y x","11.1-11.2":"y x","12.0":"y x"},"and_qq":{"10.4":"y x"},"baidu":{"7.12":"y x"},"kaios":{"2.5":"y x #1"}},"notes":"Does not yet appear in any W3C specification. Was briefly included in a spec as the \"text-outline\" property, but this was removed.","notes_by_num":{"1":"Firefox & Edge specifically only support the `-webkit-text-stroke` property (not using `-moz-` or `-ms-` prefix)","2":"Requires the `layout.css.prefixes.webkit` flag to be enabled."},"usage_perc_y":96.9,"usage_perc_a":0.01,"ucprefix":false,"parent":"","keywords":"textstroke,stroke-color,stroke-width,text-fill-color,text-outline","ie_id":"webkittextstroke","chrome_id":"","firefox_id":"","webkit_id":""},"textcontent":{"title":"Node.textContent","description":"DOM Node property representing the text content of a node and its descendants","spec":"https://dom.spec.whatwg.org/#dom-node-textcontent","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Node/textContent","title":"MDN Web Docs - Node.textContent"}],"categories":["DOM"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"u","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"u","2.2":"u","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"`Node.textContent` is somewhat similar to, but has important differences from, [`HTMLElement.innerText`](https://caniuse.com/#feat=innertext).","notes_by_num":{},"usage_perc_y":99.59,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"textencoder":{"title":"TextEncoder & TextDecoder","description":"`TextEncoder` encodes a JavaScript string into bytes using the UTF-8 encoding and returns the resulting `Uint8Array` of those bytes. `TextDecoder` does the reverse.","spec":"https://encoding.spec.whatwg.org/#api","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/TextEncoder","title":"MDN Web Docs - TextEncoder"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6558040-support-the-encoding-api","title":"Microsoft Edge feature request on UserVoice"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=160653","title":"WebKit Bug 160653 - Support TextEncoder & TextDecoder APIs"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"a #1","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Not available in Web Workers in Firefox 19."},"usage_perc_y":95.69,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"encoding,text,encoder,decoding,decoder,utf,8","ie_id":"encodingstandard","chrome_id":"5714368087982080","firefox_id":"","webkit_id":"specification-encoding"},"tls1-1":{"title":"TLS 1.1","description":"Version 1.1 of the Transport Layer Security (TLS) protocol.","spec":"https://tools.ietf.org/html/rfc4346","status":"other","links":[{"url":"https://en.wikipedia.org/wiki/Transport_Layer_Security#TLS_1.1","title":"Wikipedia article about TLS 1.1"},{"url":"https://security.googleblog.com/2018/10/modernizing-transport-security.html","title":"Modernizing Transport Security - Google Security Blog"},{"url":"https://blogs.windows.com/msedgedev/2018/10/15/modernizing-tls-edge-ie11/","title":"Modernizing TLS connections in Microsoft Edge and Internet Explorer 11 - Microsoft Windows Blog"},{"url":"https://blog.mozilla.org/security/2018/10/15/removing-old-versions-of-tls/","title":"Removing Old Versions of TLS - Mozilla Security Blog"},{"url":"https://webkit.org/blog/8462/deprecation-of-legacy-tls-1-0-and-1-1-versions/","title":"Deprecation of Legacy TLS 1.0 and 1.1 Versions - WebKit Blog"}],"categories":["Security"],"stats":{"ie":{"6":"n","7":"n","8":"n d","9":"n d","10":"n d","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n d","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y #1","69":"y #1","70":"y #1","71":"y #1","72":"y #1","73":"y #1","74":"y #1","75":"y #1","76":"y #1","77":"y #1","78":"a #1 #2","79":"a #1 #2","80":"a #1 #2","81":"a #1 #2","82":"a #1 #2","83":"a #1 #2","84":"a #1 #2","85":"a #1 #2","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"a #3 #4","86":"a #3 #4","87":"a #3 #4","88":"a #3 #4","89":"a #3 #4","90":"a #3 #4"},"safari":{"4":"n","5":"n","6":"n","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y #3","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y #3","TP":"y #3"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y #1"},"ie_mob":{"10":"n d","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"TLS 1.0 & 1.1 are deprecated in Chrome, Edge, Firefox, Internet Explorer 11, & Safari.","notes_by_num":{"1":"Firefox 68+ displays a small warning icon in the address bar when connecting over TLS 1.1","2":"Firefox 78+ displays a full page dismissable warning the first time it connects over TLS 1.1","3":"Chrome 85+ and Safari for MacOS 13.1+ displays `Not secure` in the address bar when connecting over TLS 1.1","4":"Chrome 85+ displays a full page dismissable warning every time a new site connects over TLS 1.1"},"usage_perc_y":65.37,"usage_perc_a":33.32,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"5759116003770368","firefox_id":"","webkit_id":""},"tls1-2":{"title":"TLS 1.2","description":"Version 1.2 of the Transport Layer Security (TLS) protocol. Allows for data/message confidentiality, and message authentication codes for message integrity and as a by-product message authentication.","spec":"https://tools.ietf.org/html/rfc5246","status":"other","links":[{"url":"https://en.wikipedia.org/wiki/Transport_Layer_Security#TLS_1.2","title":"Wikipedia article about TLS 1.2"}],"categories":["Security"],"stats":{"ie":{"6":"n","7":"n","8":"n d","9":"n d","10":"n d","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n d","25":"n d","26":"n d","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n d","12":"n d","15":"n","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n d","10.5":"n d","10.6":"n d","11.1":"n d","11.5":"n d","11.6":"n d","12.1":"n d"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n d","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":98.62,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"tls12","chrome_id":"5197666342404096","firefox_id":"","webkit_id":""},"tls1-3":{"title":"TLS 1.3","description":"Version 1.3 (the latest one) of the Transport Layer Security (TLS) protocol. Removes weaker elliptic curves and hash functions.","spec":"https://tools.ietf.org/html/rfc8446","status":"other","links":[{"url":"https://en.wikipedia.org/wiki/Transport_Layer_Security#TLS_1.3","title":"Wikipedia article about TLS 1.3"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=630147","title":"Chrome support bug"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/17379247-support-tls-1-3-with-1-rtt","title":"UserVoice support request"}],"categories":["Security"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n d #2 #1","52":"n d #2 #1","53":"n d #2 #1","54":"n d #2 #1","55":"n d #2 #1","56":"n d #2 #1","57":"n d #2 #1","58":"n d #2 #1","59":"n d #2 #1","60":"a #1","61":"a #1","62":"a #1","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n d #3 #1","55":"n d #3 #1","56":"n d #3 #1","57":"n d #3 #1","58":"n d #3 #1","59":"n d #3 #1","60":"n d #3 #1","61":"n d #3 #1","62":"n d #3 #1","63":"n d #3 #1","64":"n d #3 #1","65":"n d #3 #1","66":"n d #3 #1","67":"n d #3 #1","68":"n d #3 #1","69":"n d #3 #1","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"a #4","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"a #4","13.1":"a #4","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n d #3 #1","55":"n d #3 #1","56":"n d #3 #1","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Supports a draft of the TLS 1.3 specification, not the final version.","2":"Can be enabled in Firefox by setting the `security.tls.version.max` pref to \"4\" in `about:config`.","3":"Can be enabled in Chrome and Opera via the `#tls13-variant` flag in `chrome://flags` or `opera://flags`.","4":"Partial support in Safari refers to being limited to macOS 10.14 Mojave and later.","5":"Partial support in Safari refers to being limited to macOS 10.14 Mojave and later."},"usage_perc_y":88.94,"usage_perc_a":2.44,"ucprefix":false,"parent":"","keywords":"","ie_id":"tls13","chrome_id":"5712755738804224","firefox_id":"","webkit_id":""},"touch":{"title":"Touch events","description":"Method of registering when, where and how the interface is touched, for devices with a touch screen. These DOM events are similar to mousedown, mousemove, etc.","spec":"https://www.w3.org/TR/touch-events/","status":"rec","links":[{"url":"https://www.quirksmode.org/mobile/tableTouch.html","title":"Detailed support tables"},{"url":"https://www.quirksmode.org/m/tests/drag2.html","title":"Multi-touch demo"},{"url":"http://schepers.cc/getintouch","title":"Information on the spec development"},{"url":"http://msdn.microsoft.com/en-us/library/ie/hh673557(v=vs.85).aspx","title":"Internet Explorer's gesture and touch implementation."},{"url":"https://github.com/CamHenlin/TouchPolyfill","title":"Touch polyfill for supporting touch events on Internet Explorer"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Touch_events","title":"MDN – Touch events"}],"categories":["DOM","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"p","11":"p","5.5":"n"},"edge":{"12":"n d #3","13":"n d #3","14":"n d #3","15":"n d #3","16":"n d #3","17":"n d #3","18":"n d #3","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a","5":"a","6":"a","7":"a","8":"a","9":"a","10":"a","11":"a","12":"a","13":"a","14":"a","15":"a","16":"a","17":"a","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"n d #1","26":"n d #1","27":"n d #1","28":"n d #1","29":"n d #1","30":"n d #1","31":"n d #1","32":"n d #1","33":"n d #1","34":"n d #1","35":"n d #1","36":"n d #1","37":"n d #1","38":"n d #1","39":"n d #1","40":"n d #1","41":"n d #1","42":"n d #1","43":"n d #1","44":"n d #1","45":"n d #1","46":"n d #1","47":"n d #1","48":"n d #1","49":"n d #1","50":"n d #1","51":"n d #1","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"p","11":"a #2"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"Internet Explorer implements Pointer Events specification which supports more input devices than Touch Events one.\r\n\r\nThere is a library on GitHub that is working toward bringing W3C touch events to IE 10 and 11: https://github.com/CamHenlin/TouchPolyfill \r\n\r\nRemoved support in Firefox refers to desktop Firefox only.","notes_by_num":{"1":"Can be enabled in Firefox using the dom.w3c_touch_events.enabled flag (disabled by default for site compatibility reasons)","2":"Supported on IE11 Mobile for phones with \"[Windows Phone 8.1 Update](http://blogs.msdn.com/b/ie/archive/2014/07/31/the-mobile-web-should-just-work-for-everyone.aspx)\"","3":"Can be enabled in Edge using the \"Enable touch events\" flag under `about:flags`"},"usage_perc_y":92.12,"usage_perc_a":0.12,"ucprefix":false,"parent":"","keywords":"touchstart,touchend,touchmove,touchenter,touchleave,touchcancel","ie_id":"touchevents","chrome_id":"6156165603917824","firefox_id":"","webkit_id":""},"transforms2d":{"title":"CSS3 2D Transforms","description":"Method of transforming an element including rotating, scaling, etc. Includes support for `transform` as well as `transform-origin` properties.","spec":"https://www.w3.org/TR/css3-2d-transforms/","status":"wd","links":[{"url":"http://www.westciv.com/tools/transforms/","title":"Live editor"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/transform","title":"MDN Web Docs - CSS transform"},{"url":"http://www.webresourcesdepot.com/cross-browser-css-transforms-csssandpaper/","title":"Workaround script for IE"},{"url":"http://www.useragentman.com/IETransformsTranslator/","title":"Converter for IE"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/css.js#css-transform","title":"has.js test"},{"url":"https://www.webplatform.org/docs/css/transforms/transform","title":"WebPlatform Docs"},{"url":"https://developer.microsoft.com/en-us/microsoft-edge/platform/status/supportcsstransformsonsvg/","title":"IE platform status (SVG)"}],"categories":["CSS3"],"stats":{"ie":{"6":"p","7":"p","8":"p","9":"y x #1","10":"y #1","11":"y #1","5.5":"n"},"edge":{"12":"y #1","13":"y #1","14":"y #1","15":"y #1","16":"y #1","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y x","3.6":"y x"},"chrome":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y x","3.2":"y x","5.1":"y x","6.1":"y x","7.1":"y x","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y x","12":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"y x","10.6":"y x","11.1":"y x","11.5":"y x","11.6":"y x","12.1":"y"},"ios_saf":{"8":"y x","14":"y","3.2":"y x","4.0-4.1":"y x","4.2-4.3":"y x","5.0-5.1":"y x","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y x","4":"y x","81":"y","2.1":"y x","2.2":"y x","2.3":"y x","4.1":"y x","4.2-4.3":"y x","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"y x","10":"y x"},"op_mob":{"10":"n","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"The scale transform can be emulated in IE < 9 using Microsoft's \"zoom\" extension, others are (not easily) possible using the MS Matrix filter","notes_by_num":{"1":"Does not support CSS transforms on SVG elements (transform attribute can be used instead)"},"usage_perc_y":98.71,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"transformation,translate,translatex,translatey,translatez,transform3d,rotation,rotate,scale,skew,css-transforms,transform-origin,transform:rotate,transform:scale,transform:skew","ie_id":"transforms","chrome_id":"6437640580628480","firefox_id":"","webkit_id":""},"transforms3d":{"title":"CSS3 3D Transforms","description":"Method of transforming an element in the third dimension using the `transform` property. Includes support for the `perspective` property to set the perspective in z-space and the `backface-visibility` property to toggle display of the reverse side of a 3D-transformed element.","spec":"https://www.w3.org/TR/css3-3d-transforms/","status":"wd","links":[{"url":"http://css3.bradshawenterprises.com/flip/","title":"Multi-browser demo"},{"url":"https://hacks.mozilla.org/2011/10/css-3d-transformations-in-firefox-nightly/","title":"Mozilla hacks article"},{"url":"http://thewebrocks.com/demos/3D-css-tester/","title":"3D CSS Tester"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/css.js#css-transform","title":"has.js test"},{"url":"https://www.webplatform.org/docs/css/transforms/transform","title":"WebPlatform Docs"},{"url":"http://desandro.github.io/3dtransforms/","title":"Intro to CSS 3D transforms"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"a #1","11":"a #1","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y #2","10":"y #2","11":"y #2","12":"y #2","13":"y #2","14":"y #2","3.1":"n","3.2":"n","5.1":"y x","6.1":"y x","7.1":"y x","9.1":"y #2","10.1":"y #2","11.1":"y #2","12.1":"y #2","13.1":"y #2","TP":"y #2"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y #2","3.2":"y x","4.0-4.1":"y x","4.2-4.3":"y x","5.0-5.1":"y x","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y #2","9.3":"y #2","10.0-10.2":"y #2","10.3":"y #2","11.0-11.2":"y #2","11.3-11.4":"y #2","12.0-12.1":"y #2","12.2-12.4":"y #2","13.0-13.1":"y #2","13.2":"y #2","13.3":"y #2","13.4-13.7":"y #2"},"op_mini":{"all":"n"},"android":{"3":"y x","4":"y x","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y x","4.2-4.3":"y x","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"y x","10":"y x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #1","11":"a #1"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support in IE refers to not supporting [the transform-style: preserve-3d property](http://msdn.microsoft.com/en-us/library/ie/hh673529%28v=vs.85%29.aspx#the_ms_transform_style_property). This prevents nesting 3D transformed elements.","2":"Safari 9 - 13 still require a prefix for the related `backface-visibility` property. [WebKit Bug 170983](https://bugs.webkit.org/show_bug.cgi?id=170983) requests prefix removal."},"usage_perc_y":97.18,"usage_perc_a":1.14,"ucprefix":false,"parent":"","keywords":"css 3d,3dtransforms,translate3d,backface visibility,perspective,transform-origin,transform-style","ie_id":"transforms,csstransformspreserve3d","chrome_id":"6437640580628480","firefox_id":"","webkit_id":""},"trusted-types":{"title":"Trusted Types for DOM manipulation","description":"An API that forces developers to be very explicit about their use of powerful DOM-injection APIs. Can greatly improve security against XSS attacks.","spec":"https://w3c.github.io/webappsec-trusted-types/dist/spec/","status":"unoff","links":[{"url":"https://web.dev/trusted-types/","title":"Web.dev article on using trusted types"},{"url":"https://mozilla.github.io/standards-positions/#trusted-types","title":"Firefox position: non-harmful"}],"categories":["DOM","JS API","Other","Security"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":68.37,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"trustedTypes,trustedHTML,trusted-types,require-trusted-types-for","ie_id":"","chrome_id":"5650088592408576","firefox_id":"","webkit_id":""},"ttf":{"title":"TTF/OTF - TrueType and OpenType font support","description":"Support for the TrueType (.ttf) and OpenType (.otf) outline font formats in @font-face. ","spec":"http://developer.apple.com/fonts/TTRefMan/index.html","status":"other","links":[{"url":"https://stackoverflow.com/questions/17694143/what-is-the-status-of-ttf-support-in-internet-explorer","title":"What is the status of TTF support in Internet Explorer?"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"a #1","10":"a #1","11":"a #1","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"n","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #1","11":"a #1"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support in IE9+ refers to the fonts only working [when set to be \"installable\"](http://blogs.msdn.com/b/ie/archive/2010/07/15/the-css-corner-better-web-typography-for-better-design.aspx). Support for this is tracked [here](https://status.modern.ie/crossdomainfontloading)."},"usage_perc_y":97.33,"usage_perc_a":1.35,"ucprefix":false,"parent":"fontface","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"typedarrays":{"title":"Typed Arrays","description":"JavaScript typed arrays provide a mechanism for accessing raw binary data much more efficiently. Includes: `Int8Array`, `Uint8Array`, `Uint8ClampedArray`, `Int16Array`, `Uint16Array`, `Int32Array`, `Uint32Array`, `Float32Array` & `Float64Array`\r\n","spec":"https://tc39.es/ecma262/#sec-typedarray-objects","status":"other","links":[{"url":"https://developer.mozilla.org/en/javascript_typed_arrays","title":"MDN Web Docs - Typed arrays"},{"url":"https://github.com/zloirock/core-js#ecmascript-typed-arrays","title":"Polyfill for this feature is available in the core-js library"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"a #1","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"a #2","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"a #2","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"n","4":"y","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"y","59":"y","11.1":"n","11.5":"n","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #1","11":"a #1"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Includes support for ArrayBuffer objects.","notes_by_num":{"1":"IE10 (and IE 10&11 mobile) does not support `Uint8ClampedArray`"},"usage_perc_y":99.07,"usage_perc_a":0.19,"ucprefix":false,"parent":"es6","keywords":"ES6,JavaScript,dataview,arraybuffer","ie_id":"typedarrayses6","chrome_id":"5135818813341696","firefox_id":"","webkit_id":""},"u2f":{"title":"FIDO U2F API","description":"JavaScript API to interact with Universal Second Factor (U2F) devices. This allows users to log into sites more securely using two-factor authentication with a USB dongle.","spec":"https://fidoalliance.org/specs/fido-u2f-v1.0-nfc-bt-amendment-20150514/fido-u2f-javascript-api.html","status":"other","links":[{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1065729","title":"Mozilla bug"},{"url":"https://security.googleblog.com/2014/10/strengthening-2-step-verification-with.html","title":"Google Security article"}],"categories":["JS API","Security"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y #3","80":"y #3","81":"y #3","83":"y #3","84":"y #3","85":"y #3","86":"y #3","87":"y #3"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n d #2","48":"n d #2","49":"n d #2","50":"n d #2","51":"n d #2","52":"n d #2","53":"n d #2","54":"n d #2","55":"n d #2","56":"n d #2","57":"n d #2","58":"n d #2","59":"n d #2","60":"n d #2","61":"n d #2","62":"n d #2","63":"n d #2","64":"n d #2","65":"n d #2","66":"n d #2","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n #1","39":"n #1","40":"n #1","41":"y #3","42":"y #3","43":"y #3","44":"y #3","45":"y #3","46":"y #3","47":"y #3","48":"y #3","49":"y #3","50":"y #3","51":"y #3","52":"y #3","53":"y #3","54":"y #3","55":"y #3","56":"y #3","57":"y #3","58":"y #3","59":"y #3","60":"y #3","61":"y #3","62":"y #3","63":"y #3","64":"y #3","65":"y #3","66":"y #3","67":"y #3","68":"y #3","69":"y #3","70":"y #3","71":"y #3","72":"y #3","73":"y #3","74":"y #3","75":"y #3","76":"y #3","77":"y #3","78":"y #3","79":"y #3","80":"y #3","81":"y #3","83":"y #3","84":"y #3","85":"y #3","86":"y #3","87":"y #3","88":"y #3","89":"y #3","90":"y #3"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"y #3","41":"n","42":"y #3","43":"y #3","44":"y #3","45":"y #3","46":"y #3","47":"y #3","48":"y #3","49":"y #3","50":"y #3","51":"y #3","52":"y #3","53":"y #3","54":"y #3","55":"y #3","56":"y #3","57":"y #3","58":"y #3","60":"y #3","62":"y #3","63":"y #3","64":"y #3","65":"y #3","66":"y #3","67":"y #3","68":"y #3","69":"y #3","70":"y #3","71":"y #3","72":"y #3","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n d #2"}},"notes":"","notes_by_num":{"1":"Requires the \"FIDO U2F (Universal 2nd Factor)\" Chrome extension","2":"Support can be enabled with the \"security.webauth.u2f\" flag","3":"Supported [via the internal CryptoTokenExtension.](https://github.com/google/u2f-ref-code/blob/master/u2f-gae-demo/war/js/u2f-api.js)"},"usage_perc_y":53.49,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"fido,u2f","ie_id":"fidou2f","chrome_id":"","firefox_id":"","webkit_id":""},"unhandledrejection":{"title":"unhandledrejection/rejectionhandled events","description":"The `unhandledrejection` event is fired when a Promise is rejected but there is no rejection handler to deal with the rejection. The `rejectionhandled` event is fired when a Promise is rejected, and after the rejection is handled by the promise's rejection handling code.","spec":"https://html.spec.whatwg.org/multipage/webappapis.html#unhandled-promise-rejections:event-unhandledrejection","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/Events/rejectionhandled","title":"MDN article on rejectionhandled"},{"url":"https://developer.mozilla.org/en-US/docs/Web/Events/unhandledrejection","title":"MDN article on unhandledrejection"},{"url":"https://googlechrome.github.io/samples/promise-rejection-events/","title":"Chrome sample code"},{"url":"https://github.com/zloirock/core-js#unhandled-rejection-tracking","title":"Polyfill for this feature is available in the core-js library"}],"categories":["JS","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"u","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":94.26,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"onunhandledrejection,onrejectionhandled,promiserejectionevent","ie_id":"","chrome_id":"4805872211460096","firefox_id":"","webkit_id":""},"upgradeinsecurerequests":{"title":"Upgrade Insecure Requests","description":"Declare that browsers should transparently upgrade HTTP resources on a website to HTTPS.","spec":"https://www.w3.org/TR/upgrade-insecure-requests/","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/Security/CSP/CSP_policy_directives#upgrade-insecure-requests","title":"MDN Web Docs - Upgrade Insecure Requests"},{"url":"https://googlechrome.github.io/samples/csp-upgrade-insecure-requests/index.html","title":"Demo Website"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=143653","title":"WebKit feature request bug"}],"categories":["Security"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"The HTTP header is `Content-Security-Policy: upgrade-insecure-requests`. Alternatively, the HTML tag is `<meta http-equiv=\"Content-Security-Policy\" content=\"upgrade-insecure-requests\">`.","notes_by_num":{},"usage_perc_y":94.57,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"security,header,uir,upgrade-insecure-requests","ie_id":"cspupgradeinsecurerequestsdirective","chrome_id":"6534575509471232","firefox_id":"","webkit_id":"feature-upgrade-insecure-requests"},"url":{"title":"URL API","description":"API to retrieve the various parts that make up a given URL from a given URL string.","spec":"https://url.spec.whatwg.org/#api","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/URL","title":"MDN Web Docs - URL interface"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/URL/URL","title":"MDN Web Docs - URL constructor"},{"url":"https://github.com/zloirock/core-js#url-and-urlsearchparams","title":"Polyfill for this feature is available in the core-js library"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n #1","24":"n #1","25":"n #1","26":"n #1","27":"n #1","28":"n #1","29":"n #1","30":"n #1","31":"n #1","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n #1","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n #1","16":"n #1","17":"n #1","18":"n #1","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n #1","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n #1","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"n #1"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"See also [URLSearchParams](#feat=urlsearchparams).","notes_by_num":{"1":"Allows objects to be created via `URL` constructor, but instances do not have the expected url properties."},"usage_perc_y":96.64,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"url constructor","ie_id":"urlapi","chrome_id":"5675829346435072","firefox_id":"","webkit_id":""},"url-scroll-to-text-fragment":{"title":"URL Scroll-To-Text Fragment","description":"URL fragment that defines a piece of text to be scrolled into view and highlighted.","spec":"https://wicg.github.io/ScrollToTextFragment/","status":"unoff","links":[{"url":"https://mozilla.github.io/standards-positions/#scroll-to-text-fragment","title":"Current Firefox position"},{"url":"https://lists.webkit.org/pipermail/webkit-dev/2019-December/030996.html","title":"Safari's position as of Jan 2020"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n d","80":"n d","81":"n d","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n d","75":"n d","76":"n d","77":"n d","78":"n d","79":"n d","80":"n d","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n d","67":"n d","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":68.53,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"#:~:text=,Scroll To Text,textTarget,search","ie_id":"","chrome_id":"4733392803332096","firefox_id":"","webkit_id":""},"urlsearchparams":{"title":"URLSearchParams","description":"The URLSearchParams interface defines utility methods to work with the query string of a URL.","spec":"https://url.spec.whatwg.org/#urlsearchparams","status":"ls","links":[{"url":"https://developers.google.com/web/updates/2016/01/urlsearchparams?hl=en","title":"Easy URL manipulation with URLSearchParams"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams","title":"MDN Web Docs - URLSearchParams"},{"url":"https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8993198/","title":"Edge implementation bug"},{"url":"https://github.com/zloirock/core-js#url-and-urlsearchparams","title":"Polyfill for this feature is available in the core-js library"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support refers to only supporting `entries()`, `keys()`, `values()`, and `for...of`."},"usage_perc_y":95.39,"usage_perc_a":0.13,"ucprefix":false,"parent":"","keywords":"url,search,params","ie_id":"","chrome_id":"5632984866619392","firefox_id":"","webkit_id":""},"use-strict":{"title":"ECMAScript 5 Strict Mode","description":"Method of placing code in a \"strict\" operating context.","spec":"https://www.ecma-international.org/ecma-262/5.1/#sec-14.1","status":"other","links":[{"url":"https://johnresig.com/blog/ecmascript-5-strict-mode-json-and-more/","title":"Information page"},{"url":"https://javascriptweblog.wordpress.com/2011/05/03/javascript-strict-mode/","title":"Article with test suite"}],"categories":["JS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"a #1","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"a #1","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"n","12":"y","59":"y","11.1":"n","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support in older Safari refers to strict mode still accepting a lot of JS that should be considered invalid."},"usage_perc_y":99.09,"usage_perc_a":0.14,"ucprefix":false,"parent":"es5","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"user-select-none":{"title":"CSS user-select: none","description":"Method of preventing text/element selection using CSS. ","spec":"https://drafts.csswg.org/css-ui-4/#valdef-user-select-none","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/CSS/user-select","title":"MDN Web Docs - CSS user-select"},{"url":"https://css-tricks.com/almanac/properties/u/user-select/","title":"CSS Tricks article"},{"url":"http://msdn.microsoft.com/en-us/library/ie/hh781492(v=vs.85).aspx","title":"MSDN Documentation"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y x","11":"y x","5.5":"n"},"edge":{"12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y x","3":"y x","4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","59":"y x","60":"y x","61":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y x","3.6":"y x"},"chrome":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","3.1":"y x","3.2":"y x","5.1":"y x","6.1":"y x","7.1":"y x","9.1":"y x","10.1":"y x","11.1":"y x","12.1":"y x","13.1":"y x","TP":"y x"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y x","3.2":"y x","4.0-4.1":"y x","4.2-4.3":"y x","5.0-5.1":"y x","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y x","10.3":"y x","11.0-11.2":"y x","11.3-11.4":"y x","12.0-12.1":"y x","12.2-12.4":"y x","13.0-13.1":"y x","13.2":"y x","13.3":"y x","13.4-13.7":"y x"},"op_mini":{"all":"n"},"android":{"3":"y x","4":"y x","81":"y","2.1":"y x","2.2":"y x","2.3":"y x","4.1":"y x","4.2-4.3":"y x","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"y x","10":"y x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y x","11":"y x"},"and_uc":{"12.12":"n"},"samsung":{"4":"y x","5.0-5.4":"y x","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y x"}},"notes":"","notes_by_num":{},"usage_perc_y":97.24,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"user-timing":{"title":"User Timing API","description":"Method to help web developers measure the performance of their applications by giving them access to high precision timestamps.","spec":"https://www.w3.org/TR/user-timing/","status":"rec","links":[{"url":"https://www.sitepoint.com/discovering-user-timing-api/","title":"SitePoint article"},{"url":"https://www.html5rocks.com/en/tutorials/webperformance/usertiming/","title":"HTML5Rocks article"},{"url":"https://gist.github.com/pmeenan/5902672","title":"Polyfill"},{"url":"http://aurelio.audero.it/demo/user-timing-api-demo.html","title":"Demo"},{"url":"https://github.com/nicjansma/usertiming.js","title":"UserTiming.js polyfill"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":96.98,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"performance,testing,mark,measure","ie_id":"usertimingapi","chrome_id":"5066549580791808","firefox_id":"","webkit_id":"specification-user-timing-level-2"},"variable-fonts":{"title":"Variable fonts","description":"OpenType font settings that allows a single font file to behave like multiple fonts: it can contain all the allowed variations in width, weight, slant, optical size, or any other exposed axes of variation as defined by the font designer. Variations can be applied via the `font-variation-settings` property.","spec":"https://drafts.csswg.org/css-fonts-4/#font-variation-settings-def","status":"wd","links":[{"url":"http://www.axis-praxis.org/about","title":"Axis-Praxs - Tool & info on variable fonts"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/font-variation-settings","title":"MDN Web docs article"},{"url":"https://medium.com/clear-left-thinking/how-to-use-variable-fonts-in-the-real-world-e6d73065a604","title":"How to use variable fonts in the real world"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n d #2 #4 #5 #6","54":"n d #2 #4 #5 #6","55":"n d #2 #4 #5 #6","56":"n d #2 #4 #5 #6","57":"n d #2 #4 #5 #6","58":"n d #3 #4 #5 #6","59":"n d #3 #4 #5 #6","60":"n d #3 #4 #6","61":"n d #3 #6","62":"y #3 #6","63":"y #3 #6","64":"y #3 #6","65":"y #3 #6","66":"y #3 #6","67":"y #3 #6","68":"y #3 #6","69":"y #3 #6","70":"y #3 #6","71":"y #3 #6","72":"y #3 #6","73":"y #3 #6","74":"y #3 #6","75":"y #3 #6","76":"y #3 #6","77":"y #3 #6","78":"y #3 #6","79":"y #3 #6","80":"y #3 #6","81":"y #3 #6","82":"y #3 #6","83":"y #3 #6","84":"y #3 #6","85":"y #3 #6","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n d #1 #6","60":"n d #1 #6","61":"n d #1 #6","62":"a #5 #6","63":"a #5 #6","64":"a #5 #6","65":"a #5 #6","66":"y #6","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y #3 #6","12":"y #3 #6","13":"y #7","14":"y #7","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"y #3 #6","12.1":"y #3 #6","13.1":"y #7","TP":"y #7"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"a #5 #6","50":"a #5 #6","51":"a #5 #6","52":"a #5 #6","53":"y #6","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"y #6","11.3-11.4":"y #6","12.0-12.1":"y #6","12.2-12.4":"y #6","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y #6"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"y #6","9.2":"y #6","10.1":"y #6","11.1-11.2":"y #6","12.0":"y #6"},"and_qq":{"10.4":"y #6"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Works with Experimental Web Platform features enabled","2":"Requires MacOS 10.12+ and the following about:config flags to be enabled:\r\n`layout.css.font-variations.enabled`,\r\n`gfx.downloadable_fonts.keep_variation_tables`","3":"Requires MacOS 10.13+","4":"Does not support the `font-weight` and `font-stretch` properties.","5":"Does not support `format('truetype-variations')`, `format('woff-variations')`, `format('woff2-variations')`","6":"Does not support OpenType-CFF2 fonts","7":"OpenType-CFF2 support requires MacOS 10.15+"},"usage_perc_y":92.88,"usage_perc_a":0.12,"ucprefix":false,"parent":"","keywords":"variable fonts, variation fonts, font variations","ie_id":"fontvariationpropertieswithopentypevariablefontsupport","chrome_id":"4708676673732608","firefox_id":"css-font-variation-settings","webkit_id":"feature-variation-fonts"},"vibration":{"title":"Vibration API","description":"Method to access the vibration mechanism of the hosting device.","spec":"https://www.w3.org/TR/vibration/","status":"rec","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/Guide/API/Vibration","title":"MDN Web Docs - Vibration"},{"url":"https://davidwalsh.name/vibration-api","title":"Vibration API sample code & demo"},{"url":"https://code.tutsplus.com/tutorials/html5-vibration-api--mobile-22585","title":"Tuts+ article"},{"url":"http://aurelio.audero.it/demo/vibration-api-demo.html","title":"Demo"},{"url":"http://www.illyism.com/journal/vibration-api","title":"Article and Usage Examples"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":79.92,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"vibration,mobile,device","ie_id":"vibrationapi","chrome_id":"5698768766763008","firefox_id":"vibration","webkit_id":"feature-vibration-api"},"video":{"title":"Video element","description":"Method of playing videos on webpages (without requiring a plug-in). Includes support for the following media properties: `currentSrc`, `currentTime`, `paused`, `playbackRate`, `buffered`, `duration`, `played`, `seekable`, `ended`, `autoplay`, `loop`, `controls`, `volume` & `muted`","spec":"https://html.spec.whatwg.org/multipage/embedded-content.html#the-video-element","status":"ls","links":[{"url":"https://dev.opera.com/articles/view/everything-you-need-to-know-about-html5-video-and-audio/","title":"Detailed article on video/audio elements"},{"url":"https://www.webmproject.org","title":"WebM format information"},{"url":"http://camendesign.co.uk/code/video_for_everybody","title":"Video for Everybody"},{"url":"http://diveintohtml5.info/video.html","title":"Video on the Web - includes info on Android support"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/video.js#video","title":"has.js test"},{"url":"https://www.webplatform.org/docs/html/elements/video","title":"WebPlatform Docs"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a #2","5":"a #2","6":"a #2","7":"a #2","8":"a #2","9":"a #2","10":"a #2","11":"a #2","12":"a #2","13":"a #2","14":"a #2","15":"a #2","16":"a #2","17":"a #2","18":"a #2","19":"a #2","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a #2","3.6":"a #2"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y #3","12":"y #3","13":"y #3","14":"y #3","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y #3","12.1":"y #3","13.1":"y #3","TP":"y #3"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y #3","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y #3","11.3-11.4":"y #3","12.0-12.1":"y #3","12.2-12.4":"y #3","13.0-13.1":"y #3","13.2":"y #3","13.3":"y #3","13.4-13.7":"y #3"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"a #1","2.2":"a #1","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Different browsers have support for different video formats, see sub-features for details.\r\n\r\n","notes_by_num":{"1":"The Android browser (before 2.3) requires [specific handling](http://www.broken-links.com/2010/07/08/making-html5-video-work-on-android-phones/) to run the video element.","2":"Old Firefox versions were missing support for some properties: `loop` was added in v11, `played` in v15, `playbackRate` in v20.","3":"Ignores the `autoplay` attribute by default, though autoplay behavior can be [enabled by users](https://webkit.org/blog/7734/auto-play-policy-changes-for-macos/)"},"usage_perc_y":98.58,"usage_perc_a":0.12,"ucprefix":false,"parent":"","keywords":"<video>,videoHeight,videoWidth,HTMLVideoElement.videoHeight,HTMLVideoElement.videoWidth","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"videotracks":{"title":"Video Tracks","description":"Method of specifying and selecting between multiple video tracks. Useful for providing sign language tracks, burnt-in captions or subtitles, alternative camera angles, etc.","spec":"https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist-and-videotracklist-objects","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement","title":"MDN Web Docs - HTMLMediaElement"}],"categories":["HTML5"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"n d #2","80":"n d #2","81":"n d #2","83":"n d #2","84":"n d #2","85":"n d #2","86":"n d #2","87":"n d #2"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n d #1","34":"n d #1","35":"n d #1","36":"n d #1","37":"n d #1","38":"n d #1","39":"n d #1","40":"n d #1","41":"n d #1","42":"n d #1","43":"n d #1","44":"n d #1","45":"n d #1","46":"n d #1","47":"n d #1","48":"n d #1","49":"n d #1","50":"n d #1","51":"n d #1","52":"n d #1","53":"n d #1","54":"n d #1","55":"n d #1","56":"n d #1","57":"n d #1","58":"n d #1","59":"n d #1","60":"n d #1","61":"n d #1","62":"n d #1","63":"n d #1","64":"n d #1","65":"n d #1","66":"n d #1","67":"n d #1","68":"n d #1","69":"n d #1","70":"n d #1","71":"n d #1","72":"n d #1","73":"n d #1","74":"n d #1","75":"n d #1","76":"n d #1","77":"n d #1","78":"n d #1","79":"n d #1","80":"n d #1","81":"n d #1","82":"n d #1","83":"n d #1","84":"n d #1","85":"n d #1","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n d #2","46":"n d #2","47":"n d #2","48":"n d #2","49":"n d #2","50":"n d #2","51":"n d #2","52":"n d #2","53":"n d #2","54":"n d #2","55":"n d #2","56":"n d #2","57":"n d #2","58":"n d #2","59":"n d #2","60":"n d #2","61":"n d #2","62":"n d #2","63":"n d #2","64":"n d #2","65":"n d #2","66":"n d #2","67":"n d #2","68":"n d #2","69":"n d #2","70":"n d #2","71":"n d #2","72":"n d #2","73":"n d #2","74":"n d #2","75":"n d #2","76":"n d #2","77":"n d #2","78":"n d #2","79":"n d #2","80":"n d #2","81":"n d #2","83":"n d #2","84":"n d #2","85":"n d #2","86":"n d #2","87":"n d #2","88":"n d #2","89":"n d #2","90":"n d #2"},"safari":{"4":"n","5":"n","6":"n","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n d #2","33":"n d #2","34":"n d #2","35":"n d #2","36":"n d #2","37":"n d #2","38":"n d #2","39":"n d #2","40":"n d #2","41":"n d #2","42":"n d #2","43":"n d #2","44":"n d #2","45":"n d #2","46":"n d #2","47":"n d #2","48":"n d #2","49":"n d #2","50":"n d #2","51":"n d #2","52":"n d #2","53":"n d #2","54":"n d #2","55":"n d #2","56":"n d #2","57":"n d #2","58":"n d #2","60":"n d #2","62":"n d #2","63":"n d #2","64":"n d #2","65":"n d #2","66":"n d #2","67":"n d #2","68":"n d #2","69":"n d #2","70":"n d #2","71":"n d #2","72":"n d #2","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n d #2","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n d #2"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n d #1"}},"notes":"","notes_by_num":{"1":"Supported in Firefox by enabling \"media.track.enabled\" in about:config","2":"Supported in Chrome and Opera by enabling \"enable-experimental-web-platform-features\" in chrome:flags"},"usage_perc_y":16.87,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"VideoTrack,VideoTrackList,media,multiple,selection","ie_id":"videotracks","chrome_id":"5748496434987008","firefox_id":"","webkit_id":""},"viewport-units":{"title":"Viewport units: vw, vh, vmin, vmax","description":"Length units representing a percentage of the current viewport dimensions: width (vw), height (vh), the smaller of the two (vmin), or the larger of the two (vmax).","spec":"https://www.w3.org/TR/css3-values/#viewport-relative-lengths","status":"cr","links":[{"url":"https://css-tricks.com/viewport-sized-typography/","title":"Blog post"},{"url":"https://github.com/saabi/vminpoly","title":"Polyfill"},{"url":"https://github.com/rodneyrehm/viewport-units-buggyfill","title":"Buggyfill - Polyfill that fixes buggy support"},{"url":"https://blog.rodneyrehm.de/archives/34-iOS7-Mobile-Safari-And-Viewport-Units.html","title":"Back-Forward issue blog post"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6514497-vmax-unit","title":"Microsoft Edge feature request on UserVoice"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"a #1","10":"a #2","11":"a #2","5.5":"n"},"edge":{"12":"a #2","13":"a #2","14":"a #2","15":"a #2","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"a #2","21":"a #2","22":"a #2","23":"a #2","24":"a #2","25":"a #2","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"a #2","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"a #2 #3","7.0-7.1":"a #3","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #2","11":"a #2"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support in IE9 refers to supporting \"vm\" instead of \"vmin\".","2":"Partial support refers to not supporting the \"vmax\" unit. ","3":"Partial support in iOS7 is due to buggy behavior of the \"vh\" unit (see workarounds: [1](https://gist.github.com/pburtchaell/e702f441ba9b3f76f587), [2](https://gist.github.com/BenMorel/e9e34c08360ebbbd0634))."},"usage_perc_y":96.74,"usage_perc_a":1.44,"ucprefix":false,"parent":"","keywords":"vm,viewport-percentage","ie_id":"cssvmaxunit","chrome_id":"","firefox_id":"","webkit_id":""},"wai-aria":{"title":"WAI-ARIA Accessibility features","description":"Method of providing ways for people with disabilities to use dynamic web content and web applications.","spec":"https://www.w3.org/TR/wai-aria/","status":"rec","links":[{"url":"https://en.wikipedia.org/wiki/WAI-ARIA","title":"Wikipedia"},{"url":"https://zufelt.ca/blog/are-you-confused-html5-and-wai-aria-yet","title":"HTML5/WAI-ARIA information"},{"url":"https://a11ysupport.io/","title":"a11ysupport.io - Accessibility Support data for various HTML, ARIA, CSS, and SVG features"},{"url":"https://www.w3.org/WAI/standards-guidelines/aria/","title":"WAI-ARIA Overview"},{"url":"https://developer.paciellogroup.com/blog/2011/10/browser-assistive-technology-tests-redux/","title":"Links to various test results"},{"url":"https://alistapart.com/article/the-accessibility-of-wai-aria/","title":"A List Apart - The Accessibility of WAI-ARIA"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"a","9":"a","10":"a","11":"a","5.5":"n"},"edge":{"12":"a","13":"a","14":"a","15":"a","16":"a","17":"a","18":"a","79":"a","80":"a","81":"a","83":"a","84":"a","85":"a","86":"a","87":"a"},"firefox":{"2":"a","3":"a","4":"a","5":"a","6":"a","7":"a","8":"a","9":"a","10":"a","11":"a","12":"a","13":"a","14":"a","15":"a","16":"a","17":"a","18":"a","19":"a","20":"a","21":"a","22":"a","23":"a","24":"a","25":"a","26":"a","27":"a","28":"a","29":"a","30":"a","31":"a","32":"a","33":"a","34":"a","35":"a","36":"a","37":"a","38":"a","39":"a","40":"a","41":"a","42":"a","43":"a","44":"a","45":"a","46":"a","47":"a","48":"a","49":"a","50":"a","51":"a","52":"a","53":"a","54":"a","55":"a","56":"a","57":"a","58":"a","59":"a","60":"a","61":"a","62":"a","63":"a","64":"a","65":"a","66":"a","67":"a","68":"a","69":"a","70":"a","71":"a","72":"a","73":"a","74":"a","75":"a","76":"a","77":"a","78":"a","79":"a","80":"a","81":"a","82":"a","83":"a","84":"a","85":"a","3.5":"a","3.6":"a"},"chrome":{"4":"a","5":"a","6":"a","7":"a","8":"a","9":"a","10":"a","11":"a","12":"a","13":"a","14":"a","15":"a","16":"a","17":"a","18":"a","19":"a","20":"a","21":"a","22":"a","23":"a","24":"a","25":"a","26":"a","27":"a","28":"a","29":"a","30":"a","31":"a","32":"a","33":"a","34":"a","35":"a","36":"a","37":"a","38":"a","39":"a","40":"a","41":"a","42":"a","43":"a","44":"a","45":"a","46":"a","47":"a","48":"a","49":"a","50":"a","51":"a","52":"a","53":"a","54":"a","55":"a","56":"a","57":"a","58":"a","59":"a","60":"a","61":"a","62":"a","63":"a","64":"a","65":"a","66":"a","67":"a","68":"a","69":"a","70":"a","71":"a","72":"a","73":"a","74":"a","75":"a","76":"a","77":"a","78":"a","79":"a","80":"a","81":"a","83":"a","84":"a","85":"a","86":"a","87":"a","88":"a","89":"a","90":"a"},"safari":{"4":"a","5":"a","6":"a","7":"a","8":"a","9":"a","10":"a","11":"a","12":"a","13":"a","14":"a","3.1":"n","3.2":"n","5.1":"a","6.1":"a","7.1":"a","9.1":"a","10.1":"a","11.1":"a","12.1":"a","13.1":"a","TP":"a"},"opera":{"9":"n","11":"a","12":"a","15":"a","16":"a","17":"a","18":"a","19":"a","20":"a","21":"a","22":"a","23":"a","24":"a","25":"a","26":"a","27":"a","28":"a","29":"a","30":"a","31":"a","32":"a","33":"a","34":"a","35":"a","36":"a","37":"a","38":"a","39":"a","40":"a","41":"a","42":"a","43":"a","44":"a","45":"a","46":"a","47":"a","48":"a","49":"a","50":"a","51":"a","52":"a","53":"a","54":"a","55":"a","56":"a","57":"a","58":"a","60":"a","62":"a","63":"a","64":"a","65":"a","66":"a","67":"a","68":"a","69":"a","70":"a","71":"a","72":"a","9.5-9.6":"a","10.0-10.1":"a","10.5":"a","10.6":"a","11.1":"a","11.5":"a","11.6":"a","12.1":"a"},"ios_saf":{"8":"a","14":"a","3.2":"a","4.0-4.1":"a","4.2-4.3":"a","5.0-5.1":"a","6.0-6.1":"a","7.0-7.1":"a","8.1-8.4":"a","9.0-9.2":"a","9.3":"a","10.0-10.2":"a","10.3":"a","11.0-11.2":"a","11.3-11.4":"a","12.0-12.1":"a","12.2-12.4":"a","13.0-13.1":"a","13.2":"a","13.3":"a","13.4-13.7":"a"},"op_mini":{"all":"a"},"android":{"3":"n","4":"n","81":"a","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"a","4.4.3-4.4.4":"a"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"a","11":"a","12":"a","59":"a","11.1":"a","11.5":"a","12.1":"a"},"and_chr":{"86":"a"},"and_ff":{"82":"a"},"ie_mob":{"10":"a","11":"a"},"and_uc":{"12.12":"n"},"samsung":{"4":"a","5.0-5.4":"a","6.2-6.4":"a","7.2-7.4":"a","8.2":"a","9.2":"a","10.1":"a","11.1-11.2":"a","12.0":"a"},"and_qq":{"10.4":"a"},"baidu":{"7.12":"a"},"kaios":{"2.5":"a"}},"notes":"Support for ARIA is rather complex and currently is not fully supported in any browser. For detailed information on partial support see the [ARIA 1.0 Implementation Report](https://www.w3.org/WAI/ARIA/1.0/CR/implementation-report)\r\n","notes_by_num":{},"usage_perc_y":0,"usage_perc_a":98.38,"ucprefix":false,"parent":"","keywords":"wai,aria,wai-aria,web accessibility initiative,accessible rich internet applications,html,a11y,accessible,aria-hidden,aria-labelledby,aria-haspopup,aria-expanded,aria-controls,roles","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"wake-lock":{"title":"Screen Wake Lock API","description":"API to prevent devices from dimming, locking or turning off the screen when the application needs to keep running.","spec":"https://www.w3.org/TR/wake-lock/","status":"cr","links":[{"url":"https://web.dev/wakelock/","title":"Stay awake with the Screen Wake Lock API"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1589554","title":"Firefox support bug"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=205104","title":"WebKit support bug"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n d #1","80":"n d #1","81":"n d #1","83":"n d #1","84":"n d #1","85":"n d #1","86":"n d #1","87":"n d #1"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n d #1","72":"n d #1","73":"n d #1","74":"n d #1","75":"n d #1","76":"n d #1","77":"n d #1","78":"n d #1","79":"n d #1","80":"n d #1","81":"n d #1","83":"n d #1","84":"n d #1","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n d #1","60":"n d #1","62":"n d #1","63":"n d #1","64":"n d #1","65":"n d #1","66":"n d #1","67":"n d #1","68":"n d #1","69":"n d #1","70":"n d #1","71":"n d #1","72":"n d #1","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"Firefox OS previously supported a [similar API](https://developer.mozilla.org/en-US/docs/Archive/B2G_OS/API/Wake_Lock_API)","notes_by_num":{"1":"Available behind the #experimental-web-platform-features feature flag"},"usage_perc_y":63.65,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"navigator.wakelock.request,wakelocksentinel,screen-wake-lock","ie_id":"","chrome_id":"4636879949398016","firefox_id":"","webkit_id":""},"wasm":{"title":"WebAssembly","description":"WebAssembly or \"wasm\" is a new portable, size- and load-time-efficient format suitable for compilation to the web.","spec":"https://github.com/WebAssembly/spec","status":"other","links":[{"url":"https://webassembly.github.io/","title":"Official site"},{"url":"https://developer.mozilla.org//docs/WebAssembly","title":"WebAssembly on MDN"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n d #3","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n d #1","48":"n d #1","49":"n d #1","50":"n d #1","51":"n d #1","52":"y #4","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n d #2","52":"n d #2","53":"n d #2","54":"n d #2","55":"n d #2","56":"n d #2","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n d #2","39":"n d #2","40":"n d #2","41":"n d #2","42":"n d #2","43":"n d #2","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n d #1"}},"notes":"","notes_by_num":{"1":"Can be enabled via the `javascript.options.wasm` in `about:config`","2":"Can be enabled via the `#enable-webassembly` flag","3":"Can be enabled via the Experimental JavaScript Features flag","4":"Disabled for Firefox 52 ESR","5":"Available in Samsung Internet 7 beta"},"usage_perc_y":93.37,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"web assembly","ie_id":"webassemblymvp","chrome_id":"5453022515691520","firefox_id":"web-assembly","webkit_id":"specification-webassembly"},"wav":{"title":"Wav audio format","description":"Waveform Audio File Format, aka WAV or WAVE, a typically uncompressed audio format. ","spec":"http://www-mmsp.ece.mcgill.ca/documents/AudioFormats/WAVE/WAVE.html","status":"other","links":[{"url":"https://en.wikipedia.org/wiki/WAV","title":"Wikipedia article"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"u","2.2":"u","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"u","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Support refers to this format's use in the `audio` element, not other conditions.","notes_by_num":{},"usage_perc_y":97.33,"usage_perc_a":0,"ucprefix":false,"parent":"audio","keywords":"","ie_id":"wavaudiosupport","chrome_id":"","firefox_id":"","webkit_id":""},"wbr-element":{"title":"wbr (word break opportunity) element","description":"Represents an extra place where a line of text may optionally be broken.","spec":"https://html.spec.whatwg.org/multipage/semantics.html#the-wbr-element","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/HTML/Element/wbr","title":"MDN Web Docs - Element wbr"}],"categories":["HTML5"],"stats":{"ie":{"6":"y","7":"y","8":"n","9":"n","10":"n","11":"n","5.5":"y"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"u","2.2":"u","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":98.25,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"wbr,element,word,break,opportunity","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"web-animation":{"title":"Web Animations API","description":"Lets you create animations that are run in the browser, as well as inspect and manipulate animations created through declarative means like CSS.","spec":"https://drafts.csswg.org/web-animations/","status":"wd","links":[{"url":"http://updates.html5rocks.com/2014/05/Web-Animations---element-animate-is-now-in-Chrome-36","title":"HTML5 Rocks"},{"url":"http://updates.html5rocks.com/2013/12/New-Web-Animations-engine-in-Blink-drives-CSS-Animations-Transitions","title":"HTML5 Rocks"},{"url":"https://birtles.github.io/areweanimatedyet/","title":"Current Firefox status"},{"url":"https://github.com/web-animations/web-animations-js","title":"Polyfill"}],"categories":["DOM","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"a #2","80":"a #2","81":"a #2","83":"a #2","84":"a #2","85":"a #2","86":"a #2","87":"a #2"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"a d #3","34":"a d #3","35":"a d #3","36":"a d #3","37":"a d #3","38":"a d #3","39":"a d #3","40":"a d #3","41":"a d #3","42":"a d #3","43":"a d #3","44":"a d #3","45":"a d #3","46":"a d #3","47":"a #3","48":"a #3","49":"a #3","50":"a #3","51":"a #3","52":"a #3","53":"a #3","54":"a #3","55":"a #3","56":"a #3","57":"a #3","58":"a #3","59":"a #2","60":"a #2","61":"a #2","62":"a #2","63":"a #2","64":"a #2","65":"a #2","66":"a #2","67":"a #2","68":"a #2","69":"a #2","70":"a #2","71":"a #2","72":"a #2","73":"a #2","74":"a #2","75":"a #2","76":"a #2","77":"a #2","78":"a #2","79":"a #2","80":"a #2","81":"a #2","82":"a #2","83":"a #2","84":"a #2","85":"a #2","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"a #1","37":"a #1","38":"a #1","39":"a #2","40":"a #2","41":"a #2","42":"a #2","43":"a #2","44":"a #2","45":"a #2","46":"a #2","47":"a #2","48":"a #2","49":"a #2","50":"a #2","51":"a #2","52":"a #2","53":"a #2","54":"a #2","55":"a #2","56":"a #2","57":"a #2","58":"a #2","59":"a #2","60":"a #2","61":"a #2","62":"a #2","63":"a #2","64":"a #2","65":"a #2","66":"a #2","67":"a #2","68":"a #2","69":"a #2","70":"a #2","71":"a #2","72":"a #2","73":"a #2","74":"a #2","75":"a #2","76":"a #2","77":"a #2","78":"a #2","79":"a #2","80":"a #2","81":"a #2","83":"a #2","84":"a #2","85":"a #2","86":"a #2","87":"a #2","88":"a #2","89":"a #2","90":"a #2"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n d #4","12":"n d #4","13":"n d #4","14":"y #5","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n d #4","12.1":"n d #4","13.1":"y #5","TP":"y #5"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"a #1","24":"a #1","25":"a #1","26":"a #2","27":"a #2","28":"a #2","29":"a #2","30":"a #2","31":"a #2","32":"a #2","33":"a #2","34":"a #2","35":"a #2","36":"a #2","37":"a #2","38":"a #2","39":"a #2","40":"a #2","41":"a #2","42":"a #2","43":"a #2","44":"a #2","45":"a #2","46":"a #2","47":"a #2","48":"a #2","49":"a #2","50":"a #2","51":"a #2","52":"a #2","53":"a #2","54":"a #2","55":"a #2","56":"a #2","57":"a #2","58":"a #2","60":"a #2","62":"a #2","63":"a #2","64":"a #2","65":"a #2","66":"a #2","67":"a #2","68":"a #2","69":"a #2","70":"a #2","71":"a #2","72":"a #2","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y #5","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n d #4","11.3-11.4":"n d #4","12.0-12.1":"n d #4","12.2-12.4":"n d #4","13.0-13.1":"n d #4","13.2":"n d #4","13.3":"n d #4","13.4-13.7":"y #5"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"a #2","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"a #2","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a #2"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"a #2"},"samsung":{"4":"a #2","5.0-5.4":"a #2","6.2-6.4":"a #2","7.2-7.4":"a #2","8.2":"a #2","9.2":"a #2","10.1":"a #2","11.1-11.2":"a #2","12.0":"a #2"},"and_qq":{"10.4":"a #2"},"baidu":{"7.12":"a #2"},"kaios":{"2.5":"a #3"}},"notes":"","notes_by_num":{"1":"Partial support refers to basic support of `element.animate()`","2":"Partial support refers to basic support of `element.animate()` and [playback control of AnimationPlayer](https://www.chromestatus.com/features/5633748733263872)","3":"Partial support in Firefox is detailed in [Are we animated yet?](https://birtles.github.io/areweanimatedyet/)","4":"Can be enabled via the \"Experimental Features\" developer menu","5":"Does not support [composite modes](https://drafts.csswg.org/web-animations-1/#effect-composition)"},"usage_perc_y":12.19,"usage_perc_a":79.41,"ucprefix":false,"parent":"","keywords":"animate,element.animate,play,pause,reverse,finish,currentTime,startTime,playbackRate,playState","ie_id":"webanimationsjavascriptapi","chrome_id":"4854343836631040,5633748733263872","firefox_id":"web-animations","webkit_id":"specification-web-animations"},"web-app-manifest":{"title":"Add to home screen (A2HS)","description":"The ability for a user to \"install\" a website and use it as if it was a natively installed app. To enable this behaviour, a website must serve a valid Web App Manifest and load it's assets through a [Service Worker](https://caniuse.com/#feat=serviceworkers).","spec":"https://www.w3.org/TR/appmanifest/","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/Manifest","title":"MDN Web Docs - Web App Manifest"},{"url":"https://github.com/GoogleChromeLabs/pwacompat","title":"PWACompat (polyfill) - A library that brings the Web App Manifest to non-compliant browsers"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1407202","title":"Firefox implementation bug for desktop"},{"url":"https://web.dev/install-criteria/","title":"Web.dev - What does it take to be installable?"},{"url":"https://developer.mozilla.org/en-US/docs/Web/Progressive_web_apps/Add_to_home_screen","title":"MDN Web Docs - Add to Home screen"}],"categories":["HTML5","Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n #1","18":"n #1","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n d #3","77":"n d #3","78":"n d #3","79":"n d #3","80":"n d #3","81":"n d #3","82":"n d #3","83":"n d #3","84":"n d #3","85":"n d #3","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"a #2","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"a #2","12.0-12.1":"a #2","12.2-12.4":"a #2","13.0-13.1":"a #2","13.2":"a #2","13.3":"a #2","13.4-13.7":"a #2"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"A manifest could be used to list apps in the Microsoft Store, which would use Edge as a back-end.","2":"Safari on iOS does not support A2HS in WebViews like Chrome and Firefox.","3":"Firefox is experimenting with desktop support behind the `browser.ssb.enabled` flag."},"usage_perc_y":74.46,"usage_perc_a":11.48,"ucprefix":false,"parent":"","keywords":"manifest,pwa,progressive web app,web app,wam,web app manifest,install,installable","ie_id":"webapplicationmanifest","chrome_id":"6488656873259008","firefox_id":"app-manifest","webkit_id":"specification-web-app-manifest"},"web-bluetooth":{"title":"Web Bluetooth","description":"Allows web sites to communicate over GATT with nearby user-selected Bluetooth devices in a secure and privacy-preserving way.","spec":"https://webbluetoothcg.github.io/web-bluetooth/","status":"unoff","links":[{"url":"https://developers.google.com/web/updates/2015/07/interact-with-ble-devices-on-the-web","title":"Intro"},{"url":"https://googlechrome.github.io/samples/web-bluetooth/","title":"Samples"},{"url":"https://github.com/WebBluetoothCG/demos","title":"Demos"},{"url":"https://github.com/WebBluetoothCG/web-bluetooth/blob/gh-pages/implementation-status.md","title":"Implementation Status"},{"url":"https://mozilla.github.io/standards-positions/#web-bluetooth","title":"Mozilla Specification Positions: Harmful"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y #4","80":"y #4","81":"y #4","83":"y #4","84":"y #4","85":"y #4","86":"y #4","87":"y #4"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n d #1","46":"n d #1","47":"n d #1","48":"n d #1","49":"n d #1","50":"n d #1","51":"n d #1","52":"n d #1","53":"n d #1 #3","54":"n d #1 #3","55":"n d #1 #3","56":"y #4","57":"y #4","58":"y #4","59":"y #4","60":"y #4","61":"y #4","62":"y #4","63":"y #4","64":"y #4","65":"y #4","66":"y #4","67":"y #4","68":"y #4","69":"y #4","70":"y #4","71":"y #4","72":"y #4","73":"y #4","74":"y #4","75":"y #4","76":"y #4","77":"y #4","78":"y #4","79":"y #4","80":"y #4","81":"y #4","83":"y #4","84":"y #4","85":"y #4","86":"y #4","87":"y #4","88":"y #4","89":"y #4","90":"y #4"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n d #1 #2","37":"n d #1 #2","38":"n d #1 #2","39":"n d #1 #2","40":"n d #1 #3","41":"n d #1 #3","42":"n d #1 #3","43":"y #4","44":"y #4","45":"y #4","46":"y #4","47":"y #4","48":"y #4","49":"y #4","50":"y #4","51":"y #4","52":"y #4","53":"y #4","54":"y #4","55":"y #4","56":"y #4","57":"y #4","58":"y #4","60":"y #4","62":"y #4","63":"y #4","64":"y #4","65":"y #4","66":"y #4","67":"y #4","68":"y #4","69":"y #4","70":"y #4","71":"y #4","72":"y #4","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y #4","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y #4"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Available by enabling the \"Web Bluetooth\" experimental flag in `about:flags`. Currently support [varies by OS](https://github.com/WebBluetoothCG/web-bluetooth/blob/gh-pages/implementation-status.md)","2":"Only in Opera Mobile","3":"Available in [Origin Trials](https://developers.google.com/web/updates/2015/07/interact-with-ble-devices-on-the-web#available-for-origin-trials) for Chrome OS, Android M, and Mac","4":"Currently support [varies by OS](https://github.com/WebBluetoothCG/web-bluetooth/blob/gh-pages/implementation-status.md)"},"usage_perc_y":73.38,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"bluetooth,ble,iot,physicalweb,webbluetooth","ie_id":"webbluetooth","chrome_id":"5264933985976320","firefox_id":"web-bluetooth","webkit_id":"feature-web-bluetooth"},"web-share":{"title":"Web Share API","description":"A way to allow websites to invoke the native sharing capabilities of the host platform","spec":"https://www.w3.org/TR/web-share/","status":"wd","links":[{"url":"https://developers.google.com/web/updates/2016/10/navigator-share","title":"Chrome post"},{"url":"https://blog.hospodarets.com/web-share-api","title":"Hospodarets - Web Share API brings the native sharing capabilities to the browser"},{"url":"https://philna.sh/blog/2017/03/14/the-web-share-api/","title":"Phil Nash - The Web Share API"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1312422","title":"Mozilla bug #1312422: Consider experimental support for Web Share API"},{"url":"https://love2dev.com/blog/webshare-api/","title":"How to Use the Web Share API to Trigger the Native Dialog to Share Content & Pull Quotes"},{"url":"https://web.dev/web-share/","title":"Web.dev - Share like a native app with the Web Share API"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"a #3","83":"a #3","84":"a #3","85":"a #3","86":"a #3","87":"a #3"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n #1","19":"n #1","20":"n #1","21":"n #1","22":"n #1","23":"n #1","24":"n #1","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"y #5","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"y #5","13.1":"y #5","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"y #5","13.0-13.1":"y #5","13.2":"y #5","13.3":"y #5","13.4-13.7":"y #5"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n #2","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n #2"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n #2","6.2-6.4":"n #2","7.2-7.4":"n #2","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"u"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Implemented old [Web Intents](https://dvcs.w3.org/hg/web-intents/raw-file/tip/spec/Overview-respec.html)","2":"[Android intent:// URLs](https://developer.chrome.com/multidevice/android/intents) can be used instead.","3":"Only supported on Windows","4":"support is only for Windows.","5":"Did not support share click that would trigger a [fetch call](https://bugs.webkit.org/show_bug.cgi?id=197779)."},"usage_perc_y":51.83,"usage_perc_a":2.84,"ucprefix":false,"parent":"","keywords":"web share,share,share api,intents api,navigator.share,navigator.canShare","ie_id":"webshareapi","chrome_id":"5668769141620736","firefox_id":"","webkit_id":"feature-web-share"},"webauthn":{"title":"Web Authentication API","description":"The Web Authentication API is an extension of the Credential Management API that enables strong authentication with public key cryptography, enabling password-less authentication and / or secure second-factor authentication without SMS texts.","spec":"https://www.w3.org/TR/webauthn/","status":"rec","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Web_Authentication_API","title":"Web Authentication on MDN Web Docs"},{"url":"https://docs.microsoft.com/en-us/microsoft-edge/dev-guide/device/web-authentication","title":"Web Authentication and Windows Hello"},{"url":"https://webauthn.guide","title":"Guide to Web Authentication"}],"categories":["Security"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n d x #1","14":"n d x #1","15":"n d x #1","16":"n d x #1","17":"n d x #1","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n d #2","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"a #5","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n d #3","13.3":"a #4 #5","13.4-13.7":"a #4 #5"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Can be enabled at `about:flags`\r\n\r\nEdge 13 used an earlier draft syntax. As of Edge 14 the implementation is prefixed and based on the FIDO 2.0 Web APIs.","2":"Can be enabled using the Develop > Experimental Features menu. Currently supports USB-based CTAP & CTAP2 HID devices.","3":"Can be enabled in Settings under the Safari > Advanced > Experimental Features menu.","4":"Partial support refers to FIDO2 devices not working if a PIN is set.","5":"Experimental feature not yet enabled in WKWebView-based browsers including Chrome for iOS."},"usage_perc_y":77.43,"usage_perc_a":9.03,"ucprefix":false,"parent":"","keywords":"","ie_id":"webauthenticationapi","chrome_id":"5669923372138496","firefox_id":"web-authentication","webkit_id":"feature-web-authentication"},"webgl":{"title":"WebGL - 3D Canvas graphics","description":"Method of generating dynamic 3D graphics using JavaScript, accelerated through hardware","spec":"https://www.khronos.org/registry/webgl/specs/1.0/","status":"other","links":[{"url":"http://khronos.org/webgl/wiki/Getting_a_WebGL_Implementation","title":"Instructions on enabling WebGL"},{"url":"http://www.khronos.org/webgl/wiki/Tutorial","title":"Tutorial"},{"url":"https://hacks.mozilla.org/2009/12/webgl-draft-released-today/","title":"Firefox blog post"},{"url":"http://webkit.org/blog/603/webgl-now-available-in-webkit-nightlies/","title":"WebKit blog post"},{"url":"https://github.com/iewebgl/iewebgl","title":"Polyfill for IE"}],"categories":["Canvas"],"stats":{"ie":{"6":"p","7":"p","8":"p","9":"p","10":"p","11":"y #1","5.5":"n"},"edge":{"12":"y #1","13":"y #1","14":"y #1","15":"y #1","16":"y #1","17":"y #1","18":"y #1","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y #1","5":"y #1","6":"y #1","7":"y #1","8":"y #1","9":"y #1","10":"y #1","11":"y #1","12":"y #1","13":"y #1","14":"y #1","15":"y #1","16":"y #1","17":"y #1","18":"y #1","19":"y #1","20":"y #1","21":"y #1","22":"y #1","23":"y #1","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"y #1","9":"y #1","10":"y #1","11":"y #1","12":"y #1","13":"y #1","14":"y #1","15":"y #1","16":"y #1","17":"y #1","18":"y #1","19":"y #1","20":"y #1","21":"y #1","22":"y #1","23":"y #1","24":"y #1","25":"y #1","26":"y #1","27":"y #1","28":"y #1","29":"y #1","30":"y #1","31":"y #1","32":"y #1","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y #1","7":"y #1","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y #1","6.1":"y #1","7.1":"y #1","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"y #1","15":"y #1","16":"y #1","17":"y #1","18":"y #1","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"y #1"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"y","59":"y","11.1":"n","11.5":"n","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"p","11":"y #1"},"and_uc":{"12.12":"y #1"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y #1"}},"notes":"WebGL support is dependent on GPU support and may not be available on older devices. This is due to the additional requirement for users to have [up to date video drivers](http://www.khronos.org/webgl/wiki/BlacklistsAndWhitelists).\r\n\r\nNote that WebGL is part of the [Khronos Group](http://www.khronos.org/webgl/), not the W3C.","notes_by_num":{"1":"WebGL context is accessed from \"experimental-webgl\" rather than \"webgl\""},"usage_perc_y":98.18,"usage_perc_a":0,"ucprefix":false,"parent":"canvas","keywords":"web gl","ie_id":"webglcanvas3d,webglinstancingextension","chrome_id":"6049512976023552","firefox_id":"webgl-1","webkit_id":"specification-webgl-1"},"webgl2":{"title":"WebGL 2.0","description":"Next version of WebGL. Based on OpenGL ES 3.0.","spec":"https://www.khronos.org/registry/webgl/specs/latest/2.0/","status":"other","links":[{"url":"https://blog.mozilla.org/futurereleases/2015/03/03/an-early-look-at-webgl-2/","title":"Firefox blog post"},{"url":"https://www.khronos.org/webgl/wiki/Getting_a_WebGL_Implementation","title":"Getting a WebGL Implementation"}],"categories":["Canvas"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n d #1 #2","26":"n d #1 #2","27":"n d #1 #2","28":"n d #1 #2","29":"n d #1 #2","30":"n d #1 #2","31":"n d #1 #2","32":"n d #1 #2","33":"n d #1 #2","34":"n d #1 #2","35":"n d #1 #2","36":"n d #1 #2","37":"n d #1 #2","38":"n d #1 #2","39":"n d #1 #2","40":"n d #1 #2","41":"n d #1 #2","42":"n d #1","43":"n d #1","44":"n d #1","45":"n d #1 #5","46":"n d #1 #5","47":"n d #1 #5","48":"n d #1 #5","49":"n d #1 #5","50":"n d #1 #5","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n d #3","44":"n d #3","45":"n d #3","46":"n d #3","47":"n d #3","48":"n d #3","49":"n d #3","50":"n d #3","51":"n d #3","52":"n d #3","53":"n d #3","54":"n d #3","55":"n d #3","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n d #4","12":"n d #4","13":"n d #4","14":"n d #4","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n d #4","11.1":"n d #4","12.1":"n d #4","13.1":"n d #4","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n d #4","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n d #4","12.2-12.4":"n d #4","13.0-13.1":"n d #4","13.2":"n d #4","13.3":"n d #4","13.4-13.7":"n d #4"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n d #3"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n d #1 #5"}},"notes":"","notes_by_num":{"1":"Can be enabled in Firefox by setting the about:config preference webgl.enable-prototype-webgl2 to true","2":"WebGL2 context is accessed from \"experimental-webgl2\" rather than \"webgl2\"","3":"Can be enabled in Chrome by passing the \"--enable-unsafe-es3-apis\" flag when starting the browser through the command line","4":"Can be enabled in the \"Experimental Features\" developer menu","5":"Enabled by default for Nightly and Dev Edition"},"usage_perc_y":78.4,"usage_perc_a":0,"ucprefix":false,"parent":"canvas","keywords":"web gl","ie_id":"webgl20","chrome_id":"6694359164518400","firefox_id":"webgl-2","webkit_id":"specification-webgl-2"},"webgpu":{"title":"WebGPU","description":"An API for complex rendering and compute, using hardware acceleration. Use cases include demanding 3D games and acceleration of scientific calculations. Meant to supersede WebGL.","spec":"https://gpuweb.github.io/gpuweb/","status":"unoff","links":[{"url":"https://github.com/gpuweb/gpuweb/wiki/Implementation-Status","title":"Implementation status"},{"url":"https://github.com/gpuweb/gpuweb/wiki","title":"Official Wiki"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n d #3","81":"n d #3","83":"n d #3","84":"n d #3","85":"n d #3","86":"n d #3","87":"n d #3"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n d #1","64":"n d #1","65":"n d #1","66":"n d #1","67":"n d #1","68":"n d #1","69":"n d #1","70":"n d #1","71":"n d #1","72":"n d #1","73":"n d #1","74":"n d #1","75":"n d #1","76":"n d #1","77":"n d #1","78":"n d #1","79":"n d #1","80":"n d #1","81":"n d #1","82":"n d #1","83":"n d #1","84":"n d #1","85":"n d #1","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n d #3","81":"n d #3","83":"n d #3","84":"n d #3","85":"n d #3","86":"n d #3","87":"n d #3","88":"n d #3","89":"n d #3","90":"n d #3"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n d #2","13":"n d #2","14":"n d #2","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n d #2","12.1":"n d #2","13.1":"n d #2","TP":"n d #2"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n d #1"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"All major browser engines are working on implementing this spec.","notes_by_num":{"1":"Can be enabled in Firefox with the `dom.webgpu.enabled` flag.","2":"Can be enabled in Safari on MacOS with the `WebGPU` experimental feature.","3":"Can be enabled in some Chromium browsers on Windows and MacOS with the `enable-unsafe-webgpu` flag."},"usage_perc_y":0,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"6213121689518080","firefox_id":"","webkit_id":""},"webhid":{"title":"WebHID API","description":"Enables raw access to HID (Human Interface Device) commands for all connected HIDs. Previously, an HID could only be accessed if the browser had implemented a custom API for the specific device.","spec":"https://wicg.github.io/webhid/","status":"unoff","links":[{"url":"https://web.dev/hid-examples/","title":"Human interface devices on the web: a few quick examples"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n d #1","80":"n d #1","81":"n d #1","83":"n d #1","84":"n d #1","85":"n d #1","86":"n d #1","87":"n d #1"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n d #1","79":"n d #1","80":"n d #1","81":"n d #1","83":"n d #1","84":"n d #1","85":"n d #1","86":"n d #1 #2","87":"n d #1 #2","88":"n d #1 #2","89":"n d #1 #2","90":"n d #1 #2"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n d #1","67":"n d #1","68":"n d #1","69":"n d #1","70":"n d #1","71":"n d #1","72":"n d #1","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Can be enabled with the #enable-experimental-web-platform-features flag","2":"Available via [origin trial](https://developers.chrome.com/origintrials/#/view_trial/1074108511127863297)"},"usage_perc_y":0,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"hid,navigator.hid","ie_id":"","chrome_id":"5172464636133376","firefox_id":"","webkit_id":""},"webm":{"title":"WebM video format","description":"Multimedia format designed to provide a royalty-free, high-quality open video compression format for use with HTML5 video. WebM supports the video codec VP8 and VP9.","spec":"https://www.webmproject.org","status":"other","links":[{"url":"https://www.webmproject.org","title":"Official website"},{"url":"https://en.wikipedia.org/wiki/WebM","title":"Wikipedia article"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"p #3","10":"p #3","11":"p #3","5.5":"n"},"edge":{"12":"p","13":"p","14":"a #1 #2","15":"a #1 #2","16":"a #1 #2","17":"a #1 #2","18":"a #1 #2","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"p","5":"p","6":"p #3","7":"p #3","8":"p #3","9":"p #3","10":"p #3","11":"p #3","12":"p #3","13":"a #4","14":"a #5","3.1":"n","3.2":"p","5.1":"p","6.1":"p #3","7.1":"p #3","9.1":"p #3","10.1":"p #3","11.1":"p #3","12.1":"a #4","13.1":"a #4","TP":"a #5"},"opera":{"9":"n","11":"a #1","12":"a #1","15":"a #1","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"a #1","11.1":"a #1","11.5":"a #1","11.6":"a #1","12.1":"a #1"},"ios_saf":{"8":"n","14":"a #4","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"a #4","13.0-13.1":"a #4","13.2":"a #4","13.3":"a #4","13.4-13.7":"a #4"},"op_mini":{"all":"n"},"android":{"3":"a #1","4":"a #1","81":"y","2.1":"n","2.2":"n","2.3":"a #1","4.1":"a #1","4.2-4.3":"a #1","4.4":"a #1","4.4.3-4.4.4":"a #1"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"a #1","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"p","11":"p"},"and_uc":{"12.12":"y"},"samsung":{"4":"a #1","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Older browser versions did not support all codecs.","2":"Older Edge versions did not support progressive sources.","3":"Can be enabled in Internet Explorer and Safari for MacOS by manually installing the codecs in the operating system.","4":"Safari only supports [VP8 used in WebRTC](https://webkit.org/blog/8672/on-the-road-to-webrtc-1-0-including-vp8/).","5":"Safari only supports [VP8 used in WebRTC](https://webkit.org/blog/8672/on-the-road-to-webrtc-1-0-including-vp8/) and [VP9 used in WebRTC](https://webkit.org/blog/10929/release-notes-for-safari-technology-preview-110/)."},"usage_perc_y":79.51,"usage_perc_a":16.15,"ucprefix":false,"parent":"video","keywords":"matroska","ie_id":"webmcontainer,vp9videoplayback","chrome_id":"6362186595172352","firefox_id":"","webkit_id":""},"webnfc":{"title":"Web NFC","description":"This API allows a website to communicate with NFC tags through a device's NFC reader.","spec":"https://w3c.github.io/web-nfc/","status":"unoff","links":[{"url":"https://lists.webkit.org/pipermail/webkit-dev/2020-January/031007.html","title":"Safari position: Opposed"},{"url":"https://mozilla.github.io/standards-positions/#web-nfc","title":"Firefox position: Harmful"},{"url":"https://web.dev/nfc/","title":"Web.dev article on using WebNFC"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n d #1 #2","81":"n d #1 #2","83":"n d #1 #2","84":"n d #1 #2","85":"n d #1 #2","86":"n d #1 #2","87":"n d #1 #2"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n d #1 #2","81":"n d #1 #2","83":"n d #1 #2","84":"n d #1 #2","85":"n d #1 #2","86":"n d #1 #2","87":"n d #1 #2","88":"n d #1 #2","89":"n d #1 #2","90":"n d #1 #2"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n d #1 #2","68":"n d #1 #2","69":"n d #1 #2","70":"n d #1 #2","71":"n d #1 #2","72":"n d #1 #2","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n d #1 #2"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"Many devices are not equipped with NFC readers. They won't return any data, even though an installed browser might support this API.","notes_by_num":{"1":"Can be enabled in Chromium browsers behind the `enable-experimental-web-platform-features` flag.","2":"Current implementations only allow communication through the NDEF protocol in order to minimize security and privacy issues."},"usage_perc_y":0,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"NDEF,NDEFReader,NDEFWriter","ie_id":"","chrome_id":"6261030015467520","firefox_id":"","webkit_id":""},"webp":{"title":"WebP image format","description":"Image format (based on the VP8 video format) that supports lossy and lossless compression, as well as animation and alpha transparency. WebP generally has better compression than JPEG, PNG and GIF and is designed to supersede them. [AVIF](#feat=avif) is designed to supersede WebP.","spec":"https://developers.google.com/speed/webp/","status":"unoff","links":[{"url":"https://developers.google.com/speed/webp/","title":"Official website"},{"url":"https://developers.google.com/speed/webp/faq#which_web_browsers_natively_support_webp","title":"Official website FAQ - Which web browsers natively support WebP?"},{"url":"https://bitsofco.de/why-and-how-to-use-webp-images-today/","title":"Bitsofcode - Why and how to use WebP images today"},{"url":"https://github.com/webmproject/libwebp","title":"WebP decoder and encoder"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"p","5":"p","6":"p","7":"p","8":"p","9":"p","10":"p","11":"p","12":"p","13":"p","14":"p","15":"p","16":"p","17":"p","18":"p","19":"p","20":"p","21":"p","22":"p","23":"p","24":"p","25":"p","26":"p","27":"p","28":"p","29":"p","30":"p","31":"p","32":"p","33":"p","34":"p","35":"p","36":"p","37":"p","38":"p","39":"p","40":"p","41":"p","42":"p","43":"p","44":"p","45":"p","46":"p","47":"p","48":"p","49":"p","50":"p","51":"p","52":"p","53":"p","54":"p","55":"p","56":"p","57":"p","58":"p","59":"p","60":"p","61":"p","62":"p","63":"p","64":"p","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"p","7":"p","8":"p","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #2","24":"a #2","25":"a #2","26":"a #2","27":"a #2","28":"a #2","29":"a #2","30":"a #2","31":"a #2","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"a #3","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"a #3"},"opera":{"9":"n","11":"p","12":"a #2","15":"a #2","16":"a #2","17":"a #2","18":"a #2","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"p","11.1":"a #1","11.5":"a #1","11.6":"a #1","12.1":"a #2"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"y"},"android":{"3":"n","4":"a #1","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"a #1","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"a #1","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"p"}},"notes":"","notes_by_num":{"1":"Partial support refers to not supporting lossless, alpha and animated WebP images.","2":"Partial support refers to not supporting animated WebP images.","3":"Partial support in Safari refers to being limited to macOS 11 Big Sur and later."},"usage_perc_y":85.93,"usage_perc_a":1.76,"ucprefix":false,"parent":"","keywords":"vp8,vp8l,libwebp","ie_id":"webpimageformat","chrome_id":"6471725441089536,4785074604081152","firefox_id":"web-p","webkit_id":""},"websockets":{"title":"Web Sockets","description":"Bidirectional communication technology for web apps","spec":"https://html.spec.whatwg.org/multipage/comms.html#network","status":"ls","links":[{"url":"http://websocket.org/aboutwebsocket.html","title":"WebSockets information"},{"url":"http://updates.html5rocks.com/2011/08/What-s-different-in-the-new-WebSocket-protocol","title":"Details on newer protocol"},{"url":"https://en.wikipedia.org/wiki/WebSocket","title":"Wikipedia"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/features.js#native-websockets","title":"has.js test"},{"url":"https://www.webplatform.org/docs/apis/websocket","title":"WebPlatform Docs"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API","title":"MDN Web Docs - WebSockets API"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a #1","5":"a #1","6":"a x #2","7":"a x #2","8":"a x #2","9":"a x #2","10":"a x #2","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #2","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"a #1","6":"a #2","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"a #1","6.1":"a #2","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"a #1","12":"a #1","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"a #1","11.5":"a #1","11.6":"a #1","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"a #1","5.0-5.1":"a #1","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y #1","10":"y"},"op_mob":{"10":"n","11":"a #1","12":"a #1","59":"y","11.1":"a #1","11.5":"a #1","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Reported to be supported in some Android 4.x browsers, including Sony Xperia S, Sony TX and HTC.","notes_by_num":{"1":"Partial support in older browsers refers to the websockets implementation using an older version of the protocol and/or the implementation being disabled by default (due to security issues with the older protocol).","2":"Partial support in older browsers refers to lacking support for binary data."},"usage_perc_y":98.03,"usage_perc_a":0.34,"ucprefix":true,"parent":"","keywords":"","ie_id":"websocket","chrome_id":"6555138000945152","firefox_id":"websocket","webkit_id":""},"webusb":{"title":"WebUSB","description":"Allows communication with devices via USB (Universal Serial Bus).","spec":"https://wicg.github.io/webusb/","status":"unoff","links":[{"url":"https://developers.google.com/web/updates/2016/03/access-usb-devices-on-the-web","title":"Google Developers article"},{"url":"https://mozilla.github.io/standards-positions/#webusb","title":"Mozilla Specification Positions: Harmful"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n d","55":"n d","56":"n d","57":"n d","58":"n d","59":"n d","60":"n d","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n d","42":"n d","43":"n d","44":"n d","45":"n d","46":"n d","47":"n d","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":73.38,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"5651917954875392","firefox_id":"","webkit_id":"feature-webusb"},"webvr":{"title":"WebVR API","description":"API for accessing virtual reality (VR) devices, including sensors and head-mounted displays. Replaced by the WebXR Device API.","spec":"https://w3c.github.io/webvr/","status":"unoff","links":[{"url":"https://webvr.rocks/","title":"Detailed device support information"},{"url":"https://github.com/googlevr/webvr-polyfill","title":"WebVR polyfill"},{"url":"https://aframe.io","title":"WebVR framework"},{"url":"https://webvr.info/","title":"WebVR info"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/WebVR_API","title":"MDN Web Docs - WebVR API"},{"url":"https://www.chromestatus.com/feature/5680169905815552","title":"Chrome Platform Status for WebXR Device API"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"y #2","16":"y #2","17":"y #2","18":"y #2","79":"n d","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n d #1","55":"y #1","56":"y #1","57":"y #1","58":"y #1","59":"y #1","60":"y #1","61":"y #1","62":"y #1","63":"y #1","64":"y #1","65":"y #1","66":"y #1","67":"y #1","68":"y #1","69":"y #1","70":"y #1","71":"y #1","72":"y #1","73":"y #1","74":"y #1","75":"y #1","76":"y #1","77":"y #1","78":"y #1","79":"y #1","80":"y #1","81":"y #1","82":"y #1","83":"y #1","84":"y #1","85":"y #1","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n d","58":"n d","59":"n d","60":"n d","61":"n d","62":"n d","63":"n d","64":"n d","65":"n d","66":"n d","67":"n d","68":"n d","69":"n d","70":"n d","71":"n d","72":"n d","73":"n d","74":"n d","75":"n d","76":"n d","77":"n d","78":"n d","79":"n d","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n d","45":"n d","46":"n d","47":"n d","48":"n d","49":"n d","50":"n d","51":"n d","52":"n d","53":"n d","54":"n d","55":"n d","56":"n d","57":"n d","58":"n d","60":"n d","62":"n d","63":"n d","64":"n d","65":"n d","66":"n d","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"y #3","5.0-5.4":"a #3","6.2-6.4":"a #3","7.2-7.4":"a #3","8.2":"a #3","9.2":"a #3","10.1":"a #3","11.1-11.2":"a #3","12.0":"a #3"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n d"},"kaios":{"2.5":"n"}},"notes":"For a WebVR experience a head mounted display (VR HMD) is required.","notes_by_num":{"1":"Available and enabled by default only in Firefox Windows. Enabled in Nightly for iOS. Firefox 73+ [requires a secure context using HTTPS](https://developer.mozilla.org/en-US/docs/Web/API/WebVR_API#API_availability)","2":"[Was in development](https://blogs.windows.com/msedgedev/2016/09/09/webvr-in-development-edge/#3lMW05DTZXbXcK46.97) in the latest Edge builds and supported only [Windows Mixed Reality](https://developer.microsoft.com/en-us/windows/mixed-reality).","3":"Supports only Samsung Galaxy devices with the Samsung Gear VR"},"usage_perc_y":4.1,"usage_perc_a":3.1,"ucprefix":false,"parent":"","keywords":"getvrdevices,getvrdisplays,getdisplays,navigator.vr","ie_id":"webvr","chrome_id":"4532810371039232","firefox_id":"","webkit_id":""},"webvtt":{"title":"WebVTT - Web Video Text Tracks","description":"Format for marking up text captions for multimedia resources.","spec":"https://w3c.github.io/webvtt/","status":"wd","links":[{"url":"https://www.html5rocks.com/en/tutorials/track/basics/","title":"Getting Started With the Track Element"},{"url":"https://dev.opera.com/articles/view/an-introduction-to-webvtt-and-track/","title":"An Introduction to WebVTT and track"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/WebVTT_API","title":"MDN Web Docs - WebVTT"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n d","25":"n d","26":"n d","27":"n d","28":"n d","29":"n d","30":"n d","31":"y #1","32":"y #1","33":"y #1","34":"y #1","35":"y #1","36":"y #1","37":"y #1","38":"y #1","39":"y #1","40":"y #1","41":"y #1","42":"y #1","43":"y #1","44":"y #1","45":"y #1","46":"y #1","47":"y #1","48":"y #1","49":"y #1","50":"y #1","51":"y #1","52":"y #1","53":"y #1","54":"y #1","55":"y #1","56":"y #1","57":"y #1","58":"y #1","59":"y #1","60":"y #1","61":"y #1","62":"y #1","63":"y #1","64":"y #1","65":"y #1","66":"y #1","67":"y #1","68":"y #1","69":"y #1","70":"y #1","71":"y #1","72":"y #1","73":"y #1","74":"y #1","75":"y #1","76":"y #1","77":"y #1","78":"y #1","79":"y #1","80":"y #1","81":"y #1","82":"y #1","83":"y #1","84":"y #1","85":"y #1","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"y"},"and_uc":{"12.12":"n"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y #1"}},"notes":"WebVTT must be used with the <track> element.","notes_by_num":{"1":"Firefox currently lacks support for the `::cue` pseudo-element. [See bug #865395.](https://bugzilla.mozilla.org/show_bug.cgi?id=865395)"},"usage_perc_y":96.67,"usage_perc_a":0,"ucprefix":false,"parent":"video","keywords":"captions,track,vtt,subtitles","ie_id":"","chrome_id":"6719115557339136","firefox_id":"","webkit_id":""},"webworkers":{"title":"Web Workers","description":"Method of running scripts in the background, isolated from the web page","spec":"https://html.spec.whatwg.org/multipage/workers.html","status":"ls","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Using_web_workers","title":"MDN Web Docs - Using Web Workers"},{"url":"https://nerget.com/rayjs-mt/rayjs.html","title":"Web Worker demo"},{"url":"https://code.google.com/archive/p/ie-web-worker/","title":"Polyfill for IE (single threaded)"},{"url":"https://code.tutsplus.com/tutorials/getting-started-with-web-workers--net-27667","title":"Tutorial"}],"categories":["JS API"],"stats":{"ie":{"6":"p","7":"p","8":"p","9":"p","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"p","3":"p","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"p","3.2":"p","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"p","10.5":"p","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"y","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"p","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":98.39,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"webxr":{"title":"WebXR Device API","description":"API for accessing virtual reality (VR) and augmented reality (AR) devices, including sensors and head-mounted displays.","spec":"https://www.w3.org/TR/webxr/","status":"wd","links":[{"url":"https://developer.mozilla.org/docs/Web/API/WebXR_Device_API","title":"MDN Web Docs - WebXR Device API"},{"url":"https://immersive-web.github.io/webxr-samples/","title":"Immersive Web - WebXR samples"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=208988","title":"Safari implementation bug"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"a #1","80":"a #1","81":"a #1","83":"a #1","84":"a #1","85":"a #1","86":"a #1","87":"a #1"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n d #2","78":"n d #2","79":"n d #2","80":"n d #2","81":"n d #2","82":"n d #2","83":"n d #2","84":"n d #2","85":"n d #2","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n d","66":"n d","67":"n d","68":"n d","69":"n d","70":"n d","71":"n d","72":"n d","73":"n d","74":"n d","75":"n d","76":"n d","77":"n d","78":"n d","79":"a #1","80":"a #1","81":"a #1","83":"a #1","84":"a #1","85":"a #1","86":"a #1","87":"a #1","88":"a #1","89":"a #1","90":"a #1"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n d","53":"n d","54":"n d","55":"n d","56":"n d","57":"n d","58":"n d","60":"n d","62":"n d","63":"n d","64":"n d","65":"n d","66":"a #1","67":"a #1","68":"a #1","69":"a #1","70":"a #1","71":"a #1","72":"a #1","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a #1"},"and_ff":{"82":"n d #2"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"a #1"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"This API is very extensive. Many of its features are still in development and/or don't have finalised specs yet.","2":"Can be enabled in Firefox behind the `dom.vr.webxr.enabled` flag."},"usage_perc_y":0,"usage_perc_a":71.58,"ucprefix":false,"parent":"","keywords":"navigator.xr","ie_id":"","chrome_id":"5680169905815552","firefox_id":"webxr","webkit_id":""},"will-change":{"title":"CSS will-change property","description":"Method of optimizing animations by informing the browser which elements will change and what properties will change.","spec":"https://drafts.csswg.org/css-will-change/","status":"wd","links":[{"url":"https://dev.opera.com/articles/css-will-change-property/","title":"Detailed article"},{"url":"https://aerotwist.com/blog/bye-bye-layer-hacks/","title":"Blog post"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/will-change","title":"MDN Web Docs - will-change"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n d #1","30":"n d #1","31":"n d #1","32":"n d #1","33":"n d #1","34":"n d #1","35":"n d #1","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Supported in Firefox behind the `layout.css.will-change.enabled` flag"},"usage_perc_y":95.98,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"scroll-position","ie_id":"csswillchange","chrome_id":"5954199330226176","firefox_id":"","webkit_id":"specification-css-will-change"},"woff":{"title":"WOFF - Web Open Font Format","description":"Compressed TrueType/OpenType font that contains information about the font's source.","spec":"https://www.w3.org/TR/WOFF/","status":"rec","links":[{"url":"https://hacks.mozilla.org/2009/10/woff/","title":"Mozilla hacks blog post"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"y"},"chrome":{"4":"n","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n #1","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Reported to be supported in some modified versions of the Android 4.0 browser."},"usage_perc_y":98.56,"usage_perc_a":0,"ucprefix":false,"parent":"fontface","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"woff2":{"title":"WOFF 2.0 - Web Open Font Format","description":"TrueType/OpenType font that provides better compression than WOFF 1.0.","spec":"https://www.w3.org/TR/WOFF2/","status":"cr","links":[{"url":"https://gist.github.com/sergejmueller/cf6b4f2133bcb3e2f64a","title":"Basics about WOFF 2.0"},{"url":"https://everythingfonts.com/ttf-to-woff2","title":"WOFF 2.0 converter"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"a #1","11":"a #1","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"a #1","11.1":"a #1","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Supported only on Safari for Mac OS Sierra, not El Capitan & older."},"usage_perc_y":95.85,"usage_perc_a":0.16,"ucprefix":false,"parent":"fontface","keywords":"woff, fontface, webfonts","ie_id":"wofffileformat20","chrome_id":"6718644721549312","firefox_id":"","webkit_id":"specification-woff-file-format-2.0"},"word-break":{"title":"CSS3 word-break","description":"Property to prevent or allow words to be broken over multiple lines between letters.","spec":"https://www.w3.org/TR/css3-text/#word-break","status":"wd","links":[{"url":"https://developer.mozilla.org/en/CSS/word-break","title":"MDN Web Docs - CSS word-break"},{"url":"https://www.webplatform.org/docs/css/properties/word-break","title":"WebPlatform Docs"}],"categories":["CSS3"],"stats":{"ie":{"6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","5.5":"y"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"a","5":"a","6":"a","7":"a","8":"a","9":"a","10":"a","11":"a","12":"a","13":"a","14":"a","15":"a","16":"a","17":"a","18":"a","19":"a","20":"a","21":"a","22":"a","23":"a","24":"a","25":"a","26":"a","27":"a","28":"a","29":"a","30":"a","31":"a","32":"a","33":"a","34":"a","35":"a","36":"a","37":"a","38":"a","39":"a","40":"a","41":"a","42":"a","43":"a","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a","5":"a","6":"a","7":"a","8":"a","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a","3.2":"a","5.1":"a","6.1":"a","7.1":"a","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"a","16":"a","17":"a","18":"a","19":"a","20":"a","21":"a","22":"a","23":"a","24":"a","25":"a","26":"a","27":"a","28":"a","29":"a","30":"a","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a","14":"y","3.2":"a","4.0-4.1":"a","4.2-4.3":"a","5.0-5.1":"a","6.0-6.1":"a","7.0-7.1":"a","8.1-8.4":"a","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"a","4":"a","81":"y","2.1":"a","2.2":"a","2.3":"a","4.1":"a","4.2-4.3":"a","4.4":"a","4.4.3-4.4.4":"a"},"bb":{"7":"a","10":"a"},"op_mob":{"10":"n","11":"n","12":"n","59":"a","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"a"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"a"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Partial support refers to supporting the `break-all` value, but not the `keep-all` value.\r\n\r\nChrome, Safari and other WebKit/Blink browsers also support the unofficial `break-word` value which is treated like `word-wrap: break-word`.","notes_by_num":{},"usage_perc_y":96.44,"usage_perc_a":2.21,"ucprefix":false,"parent":"","keywords":"break-all,keep-all","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"wordwrap":{"title":"CSS3 Overflow-wrap","description":"Allows lines to be broken within words if an otherwise unbreakable string is too long to fit. Currently mostly supported using the `word-wrap` property.","spec":"https://www.w3.org/TR/css3-text/#overflow-wrap","status":"wd","links":[{"url":"https://developer.mozilla.org/En/CSS/Word-wrap","title":"MDN Web Docs - CSS word-wrap"},{"url":"https://www.webplatform.org/docs/css/properties/word-wrap","title":"WebPlatform Docs"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=955857","title":"Bug on Firefox support"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6524680-update-word-wrap-to-overflow-wrap","title":"Microsoft Edge feature request on UserVoice"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/overflow-wrap","title":"MDN Web Docs - CSS overflow-wrap"}],"categories":["CSS3"],"stats":{"ie":{"6":"a","7":"a","8":"a","9":"a","10":"a","11":"a","5.5":"a"},"edge":{"12":"a","13":"a","14":"a","15":"a","16":"a","17":"a","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a","5":"a","6":"a","7":"a","8":"a","9":"a","10":"a","11":"a","12":"a","13":"a","14":"a","15":"a","16":"a","17":"a","18":"a","19":"a","20":"a","21":"a","22":"a","23":"a","24":"a","25":"a","26":"a","27":"a","28":"a","29":"a","30":"a","31":"a","32":"a","33":"a","34":"a","35":"a","36":"a","37":"a","38":"a","39":"a","40":"a","41":"a","42":"a","43":"a","44":"a","45":"a","46":"a","47":"a","48":"a","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a","3.6":"a"},"chrome":{"4":"a","5":"a","6":"a","7":"a","8":"a","9":"a","10":"a","11":"a","12":"a","13":"a","14":"a","15":"a","16":"a","17":"a","18":"a","19":"a","20":"a","21":"a","22":"a","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a","5":"a","6":"a","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a","3.2":"a","5.1":"a","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"a","12":"a","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"a","10.6":"a","11.1":"a","11.5":"a","11.6":"a","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"a","4.0-4.1":"a","4.2-4.3":"a","5.0-5.1":"a","6.0-6.1":"a","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"a"},"android":{"3":"a","4":"a","81":"y","2.1":"a","2.2":"a","2.3":"a","4.1":"a","4.2-4.3":"a","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"a","10":"y"},"op_mob":{"10":"a","11":"a","12":"a","59":"y","11.1":"a","11.5":"a","12.1":"a"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a","11":"a"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"a"}},"notes":"Partial support refers to requiring the legacy name \"word-wrap\" (rather than \"overflow-wrap\") to work.","notes_by_num":{},"usage_perc_y":96.43,"usage_perc_a":3.25,"ucprefix":false,"parent":"","keywords":"wordwrap,word-wrap,break-word","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"x-doc-messaging":{"title":"Cross-document messaging","description":"Method of sending information from a page on one domain to a page on a different one (using postMessage)","spec":"https://html.spec.whatwg.org/multipage/comms.html#crossDocumentMessages","status":"ls","links":[{"url":"https://developer.mozilla.org/en/DOM/window.postMessage","title":"MDN Web Docs - window.postMessage"},{"url":"http://html5demos.com/postmessage2","title":"Simple demo"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/features.js#native-crosswindowmessaging","title":"has.js test"},{"url":"https://www.webplatform.org/docs/apis/web-messaging/MessagePort/postMessage","title":"WebPlatform Docs"}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"a #1","9":"a #1","10":"a #2","11":"a #2","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a","11":"a"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support refers to only working in frames/iframes (not other tabs/windows). Also, objects cannot be sent using postMessage.","2":"Partial support refers to [limitations in certain conditions](https://stackoverflow.com/questions/16226924/is-cross-origin-postmessage-broken-in-ie10)."},"usage_perc_y":98.24,"usage_perc_a":1.42,"ucprefix":false,"parent":"","keywords":"","ie_id":"postmessage","chrome_id":"4786174115708928","firefox_id":"","webkit_id":""},"x-frame-options":{"title":"X-Frame-Options HTTP header","description":"An HTTP header which indicates whether the browser should allow the webpage to be displayed in a frame within another webpage. Used as a defense against clickjacking attacks.","spec":"https://tools.ietf.org/html/rfc7034","status":"other","links":[{"url":"http://erlend.oftedal.no/blog/tools/xframeoptions/","title":"X-Frame-Options Compatibility Test"},{"url":"https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/X-Frame-Options","title":"MDN Web Docs - X-Frame-Options"},{"url":"https://www.owasp.org/index.php/Clickjacking_Defense_Cheat_Sheet","title":"OWASP Clickjacking Defense Cheat Sheet"},{"url":"https://blogs.msdn.microsoft.com/ieinternals/2010/03/30/combating-clickjacking-with-x-frame-options/","title":"Combating ClickJacking With X-Frame-Options - IEInternals"},{"url":"https://blogs.msdn.microsoft.com/ie/2009/01/27/ie8-security-part-vii-clickjacking-defenses/","title":"IE8 Security Part VII: ClickJacking Defenses - IEBlog"}],"categories":["Security"],"stats":{"ie":{"6":"n","7":"n","8":"y","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"a","80":"a","81":"a","83":"a","84":"a","85":"a","86":"a","87":"a"},"firefox":{"2":"u","3":"u","4":"a","5":"a","6":"a","7":"a","8":"a","9":"a","10":"a","11":"a","12":"a","13":"a","14":"a","15":"a","16":"a","17":"a","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"a","71":"a","72":"a","73":"a","74":"a","75":"a","76":"a","77":"a","78":"a","79":"a","80":"a","81":"a","82":"a","83":"a","84":"a","85":"a","3.5":"u","3.6":"u"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"u","16":"u","17":"u","18":"u","19":"u","20":"u","21":"u","22":"u","23":"u","24":"u","25":"u","26":"a","27":"a","28":"a","29":"a","30":"a","31":"a","32":"a","33":"a","34":"a","35":"a","36":"a","37":"a","38":"a","39":"a","40":"a","41":"a","42":"a","43":"a","44":"a","45":"a","46":"a","47":"a","48":"a","49":"a","50":"a","51":"a","52":"a","53":"a","54":"a","55":"a","56":"a","57":"a","58":"a","59":"a","60":"a","61":"a","62":"a","63":"a","64":"a","65":"a","66":"a","67":"a","68":"a","69":"a","70":"a","71":"a","72":"a","73":"a","74":"a","75":"a","76":"a","77":"a","78":"a","79":"a","80":"a","81":"a","83":"a","84":"a","85":"a","86":"a","87":"a","88":"a","89":"a","90":"a"},"safari":{"4":"u","5":"u","6":"a","7":"a","8":"a","9":"a","10":"a","11":"a","12":"a","13":"a","14":"a","3.1":"u","3.2":"u","5.1":"a","6.1":"a","7.1":"a","9.1":"a","10.1":"a","11.1":"a","12.1":"a","13.1":"a","TP":"a"},"opera":{"9":"u","11":"u","12":"a","15":"a","16":"a","17":"a","18":"a","19":"a","20":"a","21":"a","22":"a","23":"a","24":"a","25":"a","26":"a","27":"a","28":"a","29":"a","30":"a","31":"a","32":"a","33":"a","34":"a","35":"a","36":"a","37":"a","38":"a","39":"a","40":"a","41":"a","42":"a","43":"a","44":"a","45":"a","46":"a","47":"a","48":"a","49":"a","50":"a","51":"a","52":"a","53":"a","54":"a","55":"a","56":"a","57":"a","58":"a","60":"a","62":"a","63":"a","64":"a","65":"a","66":"a","67":"a","68":"a","69":"a","70":"a","71":"a","72":"a","9.5-9.6":"u","10.0-10.1":"u","10.5":"u","10.6":"u","11.1":"u","11.5":"u","11.6":"a","12.1":"a"},"ios_saf":{"8":"a","14":"a","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"u","6.0-6.1":"u","7.0-7.1":"a","8.1-8.4":"a","9.0-9.2":"a","9.3":"a","10.0-10.2":"a","10.3":"a","11.0-11.2":"a","11.3-11.4":"a","12.0-12.1":"a","12.2-12.4":"a","13.0-13.1":"a","13.2":"a","13.3":"a","13.4-13.7":"a"},"op_mini":{"all":"n"},"android":{"3":"u","4":"a","81":"a","2.1":"u","2.2":"u","2.3":"u","4.1":"a","4.2-4.3":"a","4.4":"a","4.4.3-4.4.4":"a"},"bb":{"7":"a","10":"a"},"op_mob":{"10":"u","11":"u","12":"u","59":"a","11.1":"u","11.5":"u","12.1":"a"},"and_chr":{"86":"a"},"and_ff":{"82":"a"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"a"},"samsung":{"4":"a","5.0-5.4":"a","6.2-6.4":"a","7.2-7.4":"a","8.2":"a","9.2":"a","10.1":"a","11.1-11.2":"a","12.0":"a"},"and_qq":{"10.4":"a"},"baidu":{"7.12":"a"},"kaios":{"2.5":"y"}},"notes":"Partial support refers to not supporting the `ALLOW-FROM` option.\r\nThe `X-Frame-Options` header has been obsoleted by [the `frame-ancestors` directive](https://www.w3.org/TR/CSP2/#directive-frame-ancestors) from Content Security Policy Level 2.","notes_by_num":{},"usage_perc_y":2.38,"usage_perc_a":96.14,"ucprefix":false,"parent":"","keywords":"x-frame-options,frame,options,header,clickjacking","ie_id":"","chrome_id":"5760041927835648","firefox_id":"","webkit_id":""},"xhr2":{"title":"XMLHttpRequest advanced features","description":"Adds more functionality to XHR (aka AJAX) requests like file uploads, transfer progress information and the ability to send form data. Previously known as [XMLHttpRequest Level 2](https://www.w3.org/TR/2012/WD-XMLHttpRequest-20120117/), these features now appear simply in the XMLHttpRequest spec.","spec":"https://xhr.spec.whatwg.org/","status":"ls","links":[{"url":"https://developer.mozilla.org/en/XMLHttpRequest/FormData","title":"MDN Web Docs - FormData"},{"url":"https://github.com/jimmywarting/FormData","title":"Polyfill for FormData object"},{"url":"https://www.webplatform.org/docs/apis/xhr/XMLHttpRequest","title":"WebPlatform Docs"}],"categories":["DOM","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"a #1","11":"a #1","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a #1 #2 #3","5":"a #1 #2 #3","6":"a #1 #2","7":"a #1 #2","8":"a #1 #2","9":"a #1 #2","10":"a #2","11":"a #2","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a #1 #2 #3","3.6":"a #1 #2 #3"},"chrome":{"4":"u","5":"u","6":"u","7":"a #1 #2","8":"a #1 #2","9":"a #1 #2","10":"a #1 #2","11":"a #1 #2","12":"a #1 #2","13":"a #1 #2","14":"a #1 #2","15":"a #1 #2","16":"a #1 #2","17":"a #1 #2","18":"a #1 #2","19":"a #1 #2","20":"a #1 #2","21":"a #1 #2","22":"a #1 #2","23":"a #1 #2","24":"a #1 #2","25":"a #1 #2","26":"a #1 #2","27":"a #1 #2","28":"a #1 #2","29":"a #1","30":"a #1","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"a #1 #2","6":"a #1 #2","7":"a #1","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"a #1 #2","6.1":"a #1","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"y","15":"a #1","16":"a #1","17":"a #1","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"a #1 #2","6.0-6.1":"a #1 #2","7.0-7.1":"a #1","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"a #1 #2 #3","4":"a #1 #2 #3","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"a #1 #2 #3","4.2-4.3":"a #1 #2 #3","4.4":"a #1 #2","4.4.3-4.4.4":"y"},"bb":{"7":"a #1 #2","10":"a #1"},"op_mob":{"10":"n","11":"n","12":"y","59":"y","11.1":"n","11.5":"n","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #1","11":"a #1"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support refers to not supporting `json` as `responseType`","2":"Partial support refers to not supporting `.timeout` and `.ontimeout`","3":"Partial support refers to not supporting `blob` as `responseType`"},"usage_perc_y":96.77,"usage_perc_a":1.63,"ucprefix":false,"parent":"","keywords":"formdata,xhr level 2","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"xhtml":{"title":"XHTML served as application/xhtml+xml","description":"A strict form of HTML, and allows embedding of other XML languages","spec":"https://html.spec.whatwg.org/multipage/xhtml.html#the-xhtml-syntax","status":"ls","links":[{"url":"https://en.wikipedia.org/wiki/XHTML","title":"Wikipedia"},{"url":"http://www.xmlplease.com/xhtml/xhtml5polyglot/","title":"Information on XHTML5"},{"url":"https://www.webplatform.org/docs/concepts/internet_and_web/the_web_standards_model#What_is_XHTML.3F","title":"WebPlatform Docs"}],"categories":["Other"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y","3":"y","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y","3.6":"y"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"The XHTML syntax is very close to HTML, and thus is almost always ([incorrectly](https://developer.mozilla.org/en-US/docs/XHTML#MIME_type_versus_DOCTYPE)) served as text/html on the web.","notes_by_num":{},"usage_perc_y":99.61,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"xhtml+xml","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"xhtmlsmil":{"title":"XHTML+SMIL animation","description":"Method of using SMIL animation in web pages","spec":"https://www.w3.org/TR/XHTMLplusSMIL/","status":"unoff","links":[{"url":"https://en.wikipedia.org/wiki/XHTML%2BSMIL","title":"Wikipedia"},{"url":"http://leunen.me/fakesmile/","title":"JS library to support XHTML+SMIL"}],"categories":["Other"],"stats":{"ie":{"6":"a","7":"a","8":"a","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"p","80":"p","81":"p","83":"p","84":"p","85":"p","86":"p","87":"p"},"firefox":{"2":"p","3":"p","4":"p","5":"p","6":"p","7":"p","8":"p","9":"p","10":"p","11":"p","12":"p","13":"p","14":"p","15":"p","16":"p","17":"p","18":"p","19":"p","20":"p","21":"p","22":"p","23":"p","24":"p","25":"p","26":"p","27":"p","28":"p","29":"p","30":"p","31":"p","32":"p","33":"p","34":"p","35":"p","36":"p","37":"p","38":"p","39":"p","40":"p","41":"p","42":"p","43":"p","44":"p","45":"p","46":"p","47":"p","48":"p","49":"p","50":"p","51":"p","52":"p","53":"p","54":"p","55":"p","56":"p","57":"p","58":"p","59":"p","60":"p","61":"p","62":"p","63":"p","64":"p","65":"p","66":"p","67":"p","68":"p","69":"p","70":"p","71":"p","72":"p","73":"p","74":"p","75":"p","76":"p","77":"p","78":"p","79":"p","80":"p","81":"p","82":"p","83":"p","84":"p","85":"p","3.5":"p","3.6":"p"},"chrome":{"4":"p","5":"p","6":"p","7":"p","8":"p","9":"p","10":"p","11":"p","12":"p","13":"p","14":"p","15":"p","16":"p","17":"p","18":"p","19":"p","20":"p","21":"p","22":"p","23":"p","24":"p","25":"p","26":"p","27":"p","28":"p","29":"p","30":"p","31":"p","32":"p","33":"p","34":"p","35":"p","36":"p","37":"p","38":"p","39":"p","40":"p","41":"p","42":"p","43":"p","44":"p","45":"p","46":"p","47":"p","48":"p","49":"p","50":"p","51":"p","52":"p","53":"p","54":"p","55":"p","56":"p","57":"p","58":"p","59":"p","60":"p","61":"p","62":"p","63":"p","64":"p","65":"p","66":"p","67":"p","68":"p","69":"p","70":"p","71":"p","72":"p","73":"p","74":"p","75":"p","76":"p","77":"p","78":"p","79":"p","80":"p","81":"p","83":"p","84":"p","85":"p","86":"p","87":"p","88":"p","89":"p","90":"p"},"safari":{"4":"p","5":"p","6":"p","7":"p","8":"p","9":"p","10":"p","11":"p","12":"p","13":"p","14":"p","3.1":"p","3.2":"p","5.1":"p","6.1":"p","7.1":"p","9.1":"p","10.1":"p","11.1":"p","12.1":"p","13.1":"p","TP":"p"},"opera":{"9":"p","11":"p","12":"p","15":"p","16":"p","17":"p","18":"p","19":"p","20":"p","21":"p","22":"p","23":"p","24":"p","25":"p","26":"p","27":"p","28":"p","29":"p","30":"p","31":"p","32":"p","33":"p","34":"p","35":"p","36":"p","37":"p","38":"p","39":"p","40":"p","41":"p","42":"p","43":"p","44":"p","45":"p","46":"p","47":"p","48":"p","49":"p","50":"p","51":"p","52":"p","53":"p","54":"p","55":"p","56":"p","57":"p","58":"p","60":"p","62":"p","63":"p","64":"p","65":"p","66":"p","67":"p","68":"p","69":"p","70":"p","71":"p","72":"p","9.5-9.6":"p","10.0-10.1":"p","10.5":"p","10.6":"p","11.1":"p","11.5":"p","11.6":"p","12.1":"p"},"ios_saf":{"8":"p","14":"p","3.2":"p","4.0-4.1":"p","4.2-4.3":"p","5.0-5.1":"p","6.0-6.1":"p","7.0-7.1":"p","8.1-8.4":"p","9.0-9.2":"p","9.3":"p","10.0-10.2":"p","10.3":"p","11.0-11.2":"p","11.3-11.4":"p","12.0-12.1":"p","12.2-12.4":"p","13.0-13.1":"p","13.2":"p","13.3":"p","13.4-13.7":"p"},"op_mini":{"all":"p"},"android":{"3":"p","4":"p","81":"p","2.1":"p","2.2":"p","2.3":"p","4.1":"p","4.2-4.3":"p","4.4":"p","4.4.3-4.4.4":"p"},"bb":{"7":"p","10":"p"},"op_mob":{"10":"p","11":"p","12":"p","59":"p","11.1":"p","11.5":"p","12.1":"p"},"and_chr":{"86":"p"},"and_ff":{"82":"p"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"p"},"samsung":{"4":"p","5.0-5.4":"p","6.2-6.4":"p","7.2-7.4":"p","8.2":"p","9.2":"p","10.1":"p","11.1-11.2":"p","12.0":"p"},"and_qq":{"10.4":"p"},"baidu":{"7.12":"p"},"kaios":{"2.5":"p"}},"notes":"Internet Explorer supports the W3C proposal HTML+TIME, which is largely the same as XHTML+SMIL","notes_by_num":{},"usage_perc_y":0,"usage_perc_a":0.08,"ucprefix":false,"parent":"xhtml","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""},"xml-serializer":{"title":"DOM Parsing and Serialization","description":"Various DOM parsing and serializing functions, specifically `DOMParser`, `XMLSerializer`, `innerHTML`, `outerHTML` and `insertAdjacentHTML`.","spec":"https://www.w3.org/TR/DOM-Parsing/","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/XMLSerializer","title":"MDN Web Docs - XMLSerializer"},{"url":"https://johnresig.com/blog/dom-insertadjacenthtml/","title":"Comparing Document Position by John Resig"}],"categories":["DOM","JS API"],"stats":{"ie":{"6":"a #2","7":"a #2","8":"a #2","9":"a #2","10":"y","11":"y","5.5":"a #2"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"a #2","3":"a #2","4":"a #2","5":"a #2","6":"a #2","7":"a #2","8":"a #3","9":"a #3","10":"a #3","11":"a #1","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a #2","3.6":"a #2"},"chrome":{"4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a #1","3.2":"a #1","5.1":"a #1","6.1":"a #1","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"a #1","12":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"u","10.0-10.1":"a #1","10.5":"a #1","10.6":"a #1","11.1":"a #1","11.5":"a #1","11.6":"a #1","12.1":"a #1"},"ios_saf":{"8":"y","14":"y","3.2":"a #1","4.0-4.1":"a #1","4.2-4.3":"a #1","5.0-5.1":"a #1","6.0-6.1":"a #1","7.0-7.1":"a #1","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"a #1"},"android":{"3":"a #1","4":"a #1","81":"y","2.1":"a #1","2.2":"a #1","2.3":"a #1","4.1":"a #1","4.2-4.3":"a #1","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"a #1","10":"a #1"},"op_mob":{"10":"u","11":"a #1","12":"a #1","59":"y","11.1":"a #1","11.5":"a #1","12.1":"a #1"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support refers to lacking support for `parseFromString` on the DOMParser.","2":"Partial support refers to supporting only `innerHTML`.","3":"Partial support refers to supporting only `innerHTML` and `insertAdjacentHTML`."},"usage_perc_y":97.9,"usage_perc_a":1.79,"ucprefix":false,"parent":"","keywords":"parseFromString","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":""}}}

/***/ },
/* 293 */
/***/ function(module, exports) {

	/**
	 * Diff Match and Patch
	 *
	 * Copyright 2006 Google Inc.
	 * http://code.google.com/p/google-diff-match-patch/
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * @fileoverview Computes the difference between two texts to create a patch.
	 * Applies the patch onto another text, allowing for errors.
	 * @author fraser@google.com (Neil Fraser)
	 */
	
	/**
	 * Class containing the diff, match and patch methods.
	 * @constructor
	 */
	function diff_match_patch() {
	
	  // Defaults.
	  // Redefine these in your program to override the defaults.
	
	  // Number of seconds to map a diff before giving up (0 for infinity).
	  this.Diff_Timeout = 1.0;
	  // Cost of an empty edit operation in terms of edit characters.
	  this.Diff_EditCost = 4;
	  // At what point is no match declared (0.0 = perfection, 1.0 = very loose).
	  this.Match_Threshold = 0.5;
	  // How far to search for a match (0 = exact location, 1000+ = broad match).
	  // A match this many characters away from the expected location will add
	  // 1.0 to the score (0.0 is a perfect match).
	  this.Match_Distance = 1000;
	  // When deleting a large block of text (over ~64 characters), how close does
	  // the contents have to match the expected contents. (0.0 = perfection,
	  // 1.0 = very loose).  Note that Match_Threshold controls how closely the
	  // end points of a delete need to match.
	  this.Patch_DeleteThreshold = 0.5;
	  // Chunk size for context length.
	  this.Patch_Margin = 4;
	
	  // The number of bits in an int.
	  this.Match_MaxBits = 32;
	}
	
	
	//  DIFF FUNCTIONS
	
	
	/**
	 * The data structure representing a diff is an array of tuples:
	 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
	 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
	 */
	var DIFF_DELETE = -1;
	var DIFF_INSERT = 1;
	var DIFF_EQUAL = 0;
	
	/** @typedef {!Array.<number|string>} */
	diff_match_patch.Diff;
	
	
	/**
	 * Find the differences between two texts.  Simplifies the problem by stripping
	 * any common prefix or suffix off the texts before diffing.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {boolean=} opt_checklines Optional speedup flag. If present and false,
	 *     then don't run a line-level diff first to identify the changed areas.
	 *     Defaults to true, which does a faster, slightly less optimal diff.
	 * @param {number} opt_deadline Optional time when the diff should be complete
	 *     by.  Used internally for recursive calls.  Users should set DiffTimeout
	 *     instead.
	 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
	 */
	diff_match_patch.prototype.diff_main = function(text1, text2, opt_checklines,
	    opt_deadline) {
	  // Set a deadline by which time the diff must be complete.
	  if (typeof opt_deadline == 'undefined') {
	    if (this.Diff_Timeout <= 0) {
	      opt_deadline = Number.MAX_VALUE;
	    } else {
	      opt_deadline = (new Date).getTime() + this.Diff_Timeout * 1000;
	    }
	  }
	  var deadline = opt_deadline;
	
	  // Check for null inputs.
	  if (text1 == null || text2 == null) {
	    throw new Error('Null input. (diff_main)');
	  }
	
	  // Check for equality (speedup).
	  if (text1 == text2) {
	    if (text1) {
	      return [[DIFF_EQUAL, text1]];
	    }
	    return [];
	  }
	
	  if (typeof opt_checklines == 'undefined') {
	    opt_checklines = true;
	  }
	  var checklines = opt_checklines;
	
	  // Trim off common prefix (speedup).
	  var commonlength = this.diff_commonPrefix(text1, text2);
	  var commonprefix = text1.substring(0, commonlength);
	  text1 = text1.substring(commonlength);
	  text2 = text2.substring(commonlength);
	
	  // Trim off common suffix (speedup).
	  commonlength = this.diff_commonSuffix(text1, text2);
	  var commonsuffix = text1.substring(text1.length - commonlength);
	  text1 = text1.substring(0, text1.length - commonlength);
	  text2 = text2.substring(0, text2.length - commonlength);
	
	  // Compute the diff on the middle block.
	  var diffs = this.diff_compute_(text1, text2, checklines, deadline);
	
	  // Restore the prefix and suffix.
	  if (commonprefix) {
	    diffs.unshift([DIFF_EQUAL, commonprefix]);
	  }
	  if (commonsuffix) {
	    diffs.push([DIFF_EQUAL, commonsuffix]);
	  }
	  this.diff_cleanupMerge(diffs);
	  return diffs;
	};
	
	
	/**
	 * Find the differences between two texts.  Assumes that the texts do not
	 * have any common prefix or suffix.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {boolean} checklines Speedup flag.  If false, then don't run a
	 *     line-level diff first to identify the changed areas.
	 *     If true, then run a faster, slightly less optimal diff.
	 * @param {number} deadline Time when the diff should be complete by.
	 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
	 * @private
	 */
	diff_match_patch.prototype.diff_compute_ = function(text1, text2, checklines,
	    deadline) {
	  var diffs;
	
	  if (!text1) {
	    // Just add some text (speedup).
	    return [[DIFF_INSERT, text2]];
	  }
	
	  if (!text2) {
	    // Just delete some text (speedup).
	    return [[DIFF_DELETE, text1]];
	  }
	
	  var longtext = text1.length > text2.length ? text1 : text2;
	  var shorttext = text1.length > text2.length ? text2 : text1;
	  var i = longtext.indexOf(shorttext);
	  if (i != -1) {
	    // Shorter text is inside the longer text (speedup).
	    diffs = [[DIFF_INSERT, longtext.substring(0, i)],
	             [DIFF_EQUAL, shorttext],
	             [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
	    // Swap insertions for deletions if diff is reversed.
	    if (text1.length > text2.length) {
	      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
	    }
	    return diffs;
	  }
	
	  if (shorttext.length == 1) {
	    // Single character string.
	    // After the previous speedup, the character can't be an equality.
	    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
	  }
	  longtext = shorttext = null;  // Garbage collect.
	
	  // Check to see if the problem can be split in two.
	  var hm = this.diff_halfMatch_(text1, text2);
	  if (hm) {
	    // A half-match was found, sort out the return data.
	    var text1_a = hm[0];
	    var text1_b = hm[1];
	    var text2_a = hm[2];
	    var text2_b = hm[3];
	    var mid_common = hm[4];
	    // Send both pairs off for separate processing.
	    var diffs_a = this.diff_main(text1_a, text2_a, checklines, deadline);
	    var diffs_b = this.diff_main(text1_b, text2_b, checklines, deadline);
	    // Merge the results.
	    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
	  }
	
	  if (checklines && text1.length > 100 && text2.length > 100) {
	    return this.diff_lineMode_(text1, text2, deadline);
	  }
	
	  return this.diff_bisect_(text1, text2, deadline);
	};
	
	
	/**
	 * Do a quick line-level diff on both strings, then rediff the parts for
	 * greater accuracy.
	 * This speedup can produce non-minimal diffs.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {number} deadline Time when the diff should be complete by.
	 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
	 * @private
	 */
	diff_match_patch.prototype.diff_lineMode_ = function(text1, text2, deadline) {
	  // Scan the text on a line-by-line basis first.
	  var a = this.diff_linesToChars_(text1, text2);
	  text1 = /** @type {string} */(a[0]);
	  text2 = /** @type {string} */(a[1]);
	  var linearray = /** @type {!Array.<string>} */(a[2]);
	
	  var diffs = this.diff_bisect_(text1, text2, deadline);
	
	  // Convert the diff back to original text.
	  this.diff_charsToLines_(diffs, linearray);
	  // Eliminate freak matches (e.g. blank lines)
	  this.diff_cleanupSemantic(diffs);
	
	  // Rediff any replacement blocks, this time character-by-character.
	  // Add a dummy entry at the end.
	  diffs.push([DIFF_EQUAL, '']);
	  var pointer = 0;
	  var count_delete = 0;
	  var count_insert = 0;
	  var text_delete = '';
	  var text_insert = '';
	  while (pointer < diffs.length) {
	    switch (diffs[pointer][0]) {
	      case DIFF_INSERT:
	        count_insert++;
	        text_insert += diffs[pointer][1];
	        break;
	      case DIFF_DELETE:
	        count_delete++;
	        text_delete += diffs[pointer][1];
	        break;
	      case DIFF_EQUAL:
	        // Upon reaching an equality, check for prior redundancies.
	        if (count_delete >= 1 && count_insert >= 1) {
	          // Delete the offending records and add the merged ones.
	          var a = this.diff_main(text_delete, text_insert, false, deadline);
	          diffs.splice(pointer - count_delete - count_insert,
	                       count_delete + count_insert);
	          pointer = pointer - count_delete - count_insert;
	          for (var j = a.length - 1; j >= 0; j--) {
	            diffs.splice(pointer, 0, a[j]);
	          }
	          pointer = pointer + a.length;
	        }
	        count_insert = 0;
	        count_delete = 0;
	        text_delete = '';
	        text_insert = '';
	        break;
	    }
	    pointer++;
	  }
	  diffs.pop();  // Remove the dummy entry at the end.
	
	  return diffs;
	};
	
	
	/**
	 * Find the 'middle snake' of a diff, split the problem in two
	 * and return the recursively constructed diff.
	 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {number} deadline Time at which to bail if not yet complete.
	 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
	 * @private
	 */
	diff_match_patch.prototype.diff_bisect_ = function(text1, text2, deadline) {
	  // Cache the text lengths to prevent multiple calls.
	  var text1_length = text1.length;
	  var text2_length = text2.length;
	  var max_d = Math.ceil((text1_length + text2_length) / 2);
	  var v_offset = max_d;
	  var v_length = 2 * max_d;
	  var v1 = new Array(v_length);
	  var v2 = new Array(v_length);
	  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
	  // integers and undefined.
	  for (var x = 0; x < v_length; x++) {
	    v1[x] = -1;
	    v2[x] = -1;
	  }
	  v1[v_offset + 1] = 0;
	  v2[v_offset + 1] = 0;
	  var delta = text1_length - text2_length;
	  // If the total number of characters is odd, then the front path will collide
	  // with the reverse path.
	  var front = (delta % 2 != 0);
	  // Offsets for start and end of k loop.
	  // Prevents mapping of space beyond the grid.
	  var k1start = 0;
	  var k1end = 0;
	  var k2start = 0;
	  var k2end = 0;
	  for (var d = 0; d < max_d; d++) {
	    // Bail out if deadline is reached.
	    if ((new Date()).getTime() > deadline) {
	      break;
	    }
	
	    // Walk the front path one step.
	    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
	      var k1_offset = v_offset + k1;
	      var x1;
	      if (k1 == -d || k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1]) {
	        x1 = v1[k1_offset + 1];
	      } else {
	        x1 = v1[k1_offset - 1] + 1;
	      }
	      var y1 = x1 - k1;
	      while (x1 < text1_length && y1 < text2_length &&
	             text1.charAt(x1) == text2.charAt(y1)) {
	        x1++;
	        y1++;
	      }
	      v1[k1_offset] = x1;
	      if (x1 > text1_length) {
	        // Ran off the right of the graph.
	        k1end += 2;
	      } else if (y1 > text2_length) {
	        // Ran off the bottom of the graph.
	        k1start += 2;
	      } else if (front) {
	        var k2_offset = v_offset + delta - k1;
	        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
	          // Mirror x2 onto top-left coordinate system.
	          var x2 = text1_length - v2[k2_offset];
	          if (x1 >= x2) {
	            // Overlap detected.
	            return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
	          }
	        }
	      }
	    }
	
	    // Walk the reverse path one step.
	    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
	      var k2_offset = v_offset + k2;
	      var x2;
	      if (k2 == -d || k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1]) {
	        x2 = v2[k2_offset + 1];
	      } else {
	        x2 = v2[k2_offset - 1] + 1;
	      }
	      var y2 = x2 - k2;
	      while (x2 < text1_length && y2 < text2_length &&
	             text1.charAt(text1_length - x2 - 1) ==
	             text2.charAt(text2_length - y2 - 1)) {
	        x2++;
	        y2++;
	      }
	      v2[k2_offset] = x2;
	      if (x2 > text1_length) {
	        // Ran off the left of the graph.
	        k2end += 2;
	      } else if (y2 > text2_length) {
	        // Ran off the top of the graph.
	        k2start += 2;
	      } else if (!front) {
	        var k1_offset = v_offset + delta - k2;
	        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
	          var x1 = v1[k1_offset];
	          var y1 = v_offset + x1 - k1_offset;
	          // Mirror x2 onto top-left coordinate system.
	          x2 = text1_length - x2;
	          if (x1 >= x2) {
	            // Overlap detected.
	            return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
	          }
	        }
	      }
	    }
	  }
	  // Diff took too long and hit the deadline or
	  // number of diffs equals number of characters, no commonality at all.
	  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
	};
	
	
	/**
	 * Given the location of the 'middle snake', split the diff in two parts
	 * and recurse.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {number} x Index of split point in text1.
	 * @param {number} y Index of split point in text2.
	 * @param {number} deadline Time at which to bail if not yet complete.
	 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
	 * @private
	 */
	diff_match_patch.prototype.diff_bisectSplit_ = function(text1, text2, x, y,
	    deadline) {
	  var text1a = text1.substring(0, x);
	  var text2a = text2.substring(0, y);
	  var text1b = text1.substring(x);
	  var text2b = text2.substring(y);
	
	  // Compute both diffs serially.
	  var diffs = this.diff_main(text1a, text2a, false, deadline);
	  var diffsb = this.diff_main(text1b, text2b, false, deadline);
	
	  return diffs.concat(diffsb);
	};
	
	
	/**
	 * Split two texts into an array of strings.  Reduce the texts to a string of
	 * hashes where each Unicode character represents one line.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {!Array.<string|!Array.<string>>} Three element Array, containing the
	 *     encoded text1, the encoded text2 and the array of unique strings.  The
	 *     zeroth element of the array of unique strings is intentionally blank.
	 * @private
	 */
	diff_match_patch.prototype.diff_linesToChars_ = function(text1, text2) {
	  var lineArray = [];  // e.g. lineArray[4] == 'Hello\n'
	  var lineHash = {};   // e.g. lineHash['Hello\n'] == 4
	
	  // '\x00' is a valid character, but various debuggers don't like it.
	  // So we'll insert a junk entry to avoid generating a null character.
	  lineArray[0] = '';
	
	  /**
	   * Split a text into an array of strings.  Reduce the texts to a string of
	   * hashes where each Unicode character represents one line.
	   * Modifies linearray and linehash through being a closure.
	   * @param {string} text String to encode.
	   * @return {string} Encoded string.
	   * @private
	   */
	  function diff_linesToCharsMunge_(text) {
	    var chars = '';
	    // Walk the text, pulling out a substring for each line.
	    // text.split('\n') would would temporarily double our memory footprint.
	    // Modifying text would create many large strings to garbage collect.
	    var lineStart = 0;
	    var lineEnd = -1;
	    // Keeping our own length variable is faster than looking it up.
	    var lineArrayLength = lineArray.length;
	    while (lineEnd < text.length - 1) {
	      lineEnd = text.indexOf('\n', lineStart);
	      if (lineEnd == -1) {
	        lineEnd = text.length - 1;
	      }
	      var line = text.substring(lineStart, lineEnd + 1);
	      lineStart = lineEnd + 1;
	
	      if (lineHash.hasOwnProperty ? lineHash.hasOwnProperty(line) :
	          (lineHash[line] !== undefined)) {
	        chars += String.fromCharCode(lineHash[line]);
	      } else {
	        chars += String.fromCharCode(lineArrayLength);
	        lineHash[line] = lineArrayLength;
	        lineArray[lineArrayLength++] = line;
	      }
	    }
	    return chars;
	  }
	
	  var chars1 = diff_linesToCharsMunge_(text1);
	  var chars2 = diff_linesToCharsMunge_(text2);
	  return [chars1, chars2, lineArray];
	};
	
	
	/**
	 * Rehydrate the text in a diff from a string of line hashes to real lines of
	 * text.
	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
	 * @param {!Array.<string>} lineArray Array of unique strings.
	 * @private
	 */
	diff_match_patch.prototype.diff_charsToLines_ = function(diffs, lineArray) {
	  for (var x = 0; x < diffs.length; x++) {
	    var chars = diffs[x][1];
	    var text = [];
	    for (var y = 0; y < chars.length; y++) {
	      text[y] = lineArray[chars.charCodeAt(y)];
	    }
	    diffs[x][1] = text.join('');
	  }
	};
	
	
	/**
	 * Determine the common prefix of two strings.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the start of each
	 *     string.
	 */
	diff_match_patch.prototype.diff_commonPrefix = function(text1, text2) {
	  // Quick check for common null cases.
	  if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
	    return 0;
	  }
	  // Binary search.
	  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
	  var pointermin = 0;
	  var pointermax = Math.min(text1.length, text2.length);
	  var pointermid = pointermax;
	  var pointerstart = 0;
	  while (pointermin < pointermid) {
	    if (text1.substring(pointerstart, pointermid) ==
	        text2.substring(pointerstart, pointermid)) {
	      pointermin = pointermid;
	      pointerstart = pointermin;
	    } else {
	      pointermax = pointermid;
	    }
	    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
	  }
	  return pointermid;
	};
	
	
	/**
	 * Determine the common suffix of two strings.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the end of each string.
	 */
	diff_match_patch.prototype.diff_commonSuffix = function(text1, text2) {
	  // Quick check for common null cases.
	  if (!text1 || !text2 ||
	      text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
	    return 0;
	  }
	  // Binary search.
	  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
	  var pointermin = 0;
	  var pointermax = Math.min(text1.length, text2.length);
	  var pointermid = pointermax;
	  var pointerend = 0;
	  while (pointermin < pointermid) {
	    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
	        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
	      pointermin = pointermid;
	      pointerend = pointermin;
	    } else {
	      pointermax = pointermid;
	    }
	    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
	  }
	  return pointermid;
	};
	
	
	/**
	 * Determine if the suffix of one string is the prefix of another.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the end of the first
	 *     string and the start of the second string.
	 * @private
	 */
	diff_match_patch.prototype.diff_commonOverlap_ = function(text1, text2) {
	  // Cache the text lengths to prevent multiple calls.
	  var text1_length = text1.length;
	  var text2_length = text2.length;
	  // Eliminate the null case.
	  if (text1_length == 0 || text2_length == 0) {
	    return 0;
	  }
	  // Truncate the longer string.
	  if (text1_length > text2_length) {
	    text1 = text1.substring(text1_length - text2_length);
	  } else if (text1_length < text2_length) {
	    text2 = text2.substring(0, text1_length);
	  }
	  var text_length = Math.min(text1_length, text2_length);
	  // Quick check for the worst case.
	  if (text1 == text2) {
	    return text_length;
	  }
	
	  // Start by looking for a single character match
	  // and increase length until no match is found.
	  // Performance analysis: http://neil.fraser.name/news/2010/11/04/
	  var best = 0;
	  var length = 1;
	  while (true) {
	    var pattern = text1.substring(text_length - length);
	    var found = text2.indexOf(pattern);
	    if (found == -1) {
	      return best;
	    }
	    length += found;
	    if (found == 0 || text1.substring(text_length - length) ==
	        text2.substring(0, length)) {
	      best = length;
	      length++;
	    }
	  }
	};
	
	
	/**
	 * Do the two texts share a substring which is at least half the length of the
	 * longer text?
	 * This speedup can produce non-minimal diffs.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {Array.<string>} Five element Array, containing the prefix of
	 *     text1, the suffix of text1, the prefix of text2, the suffix of
	 *     text2 and the common middle.  Or null if there was no match.
	 * @private
	 */
	diff_match_patch.prototype.diff_halfMatch_ = function(text1, text2) {
	  if (this.Diff_Timeout <= 0) {
	    // Don't risk returning a non-optimal diff if we have unlimited time.
	    return null;
	  }
	  var longtext = text1.length > text2.length ? text1 : text2;
	  var shorttext = text1.length > text2.length ? text2 : text1;
	  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
	    return null;  // Pointless.
	  }
	  var dmp = this;  // 'this' becomes 'window' in a closure.
	
	  /**
	   * Does a substring of shorttext exist within longtext such that the substring
	   * is at least half the length of longtext?
	   * Closure, but does not reference any external variables.
	   * @param {string} longtext Longer string.
	   * @param {string} shorttext Shorter string.
	   * @param {number} i Start index of quarter length substring within longtext.
	   * @return {Array.<string>} Five element Array, containing the prefix of
	   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
	   *     of shorttext and the common middle.  Or null if there was no match.
	   * @private
	   */
	  function diff_halfMatchI_(longtext, shorttext, i) {
	    // Start with a 1/4 length substring at position i as a seed.
	    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
	    var j = -1;
	    var best_common = '';
	    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
	    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
	      var prefixLength = dmp.diff_commonPrefix(longtext.substring(i),
	                                               shorttext.substring(j));
	      var suffixLength = dmp.diff_commonSuffix(longtext.substring(0, i),
	                                               shorttext.substring(0, j));
	      if (best_common.length < suffixLength + prefixLength) {
	        best_common = shorttext.substring(j - suffixLength, j) +
	            shorttext.substring(j, j + prefixLength);
	        best_longtext_a = longtext.substring(0, i - suffixLength);
	        best_longtext_b = longtext.substring(i + prefixLength);
	        best_shorttext_a = shorttext.substring(0, j - suffixLength);
	        best_shorttext_b = shorttext.substring(j + prefixLength);
	      }
	    }
	    if (best_common.length * 2 >= longtext.length) {
	      return [best_longtext_a, best_longtext_b,
	              best_shorttext_a, best_shorttext_b, best_common];
	    } else {
	      return null;
	    }
	  }
	
	  // First check if the second quarter is the seed for a half-match.
	  var hm1 = diff_halfMatchI_(longtext, shorttext,
	                             Math.ceil(longtext.length / 4));
	  // Check again based on the third quarter.
	  var hm2 = diff_halfMatchI_(longtext, shorttext,
	                             Math.ceil(longtext.length / 2));
	  var hm;
	  if (!hm1 && !hm2) {
	    return null;
	  } else if (!hm2) {
	    hm = hm1;
	  } else if (!hm1) {
	    hm = hm2;
	  } else {
	    // Both matched.  Select the longest.
	    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
	  }
	
	  // A half-match was found, sort out the return data.
	  var text1_a, text1_b, text2_a, text2_b;
	  if (text1.length > text2.length) {
	    text1_a = hm[0];
	    text1_b = hm[1];
	    text2_a = hm[2];
	    text2_b = hm[3];
	  } else {
	    text2_a = hm[0];
	    text2_b = hm[1];
	    text1_a = hm[2];
	    text1_b = hm[3];
	  }
	  var mid_common = hm[4];
	  return [text1_a, text1_b, text2_a, text2_b, mid_common];
	};
	
	
	/**
	 * Reduce the number of edits by eliminating semantically trivial equalities.
	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
	 */
	diff_match_patch.prototype.diff_cleanupSemantic = function(diffs) {
	  var changes = false;
	  var equalities = [];  // Stack of indices where equalities are found.
	  var equalitiesLength = 0;  // Keeping our own length var is faster in JS.
	  /** @type {?string} */
	  var lastequality = null;  // Always equal to equalities[equalitiesLength-1][1]
	  var pointer = 0;  // Index of current position.
	  // Number of characters that changed prior to the equality.
	  var length_insertions1 = 0;
	  var length_deletions1 = 0;
	  // Number of characters that changed after the equality.
	  var length_insertions2 = 0;
	  var length_deletions2 = 0;
	  while (pointer < diffs.length) {
	    if (diffs[pointer][0] == DIFF_EQUAL) {  // Equality found.
	      equalities[equalitiesLength++] = pointer;
	      length_insertions1 = length_insertions2;
	      length_deletions1 = length_deletions2;
	      length_insertions2 = 0;
	      length_deletions2 = 0;
	      lastequality = /** @type {string} */(diffs[pointer][1]);
	    } else {  // An insertion or deletion.
	      if (diffs[pointer][0] == DIFF_INSERT) {
	        length_insertions2 += diffs[pointer][1].length;
	      } else {
	        length_deletions2 += diffs[pointer][1].length;
	      }
	      // Eliminate an equality that is smaller or equal to the edits on both
	      // sides of it.
	      if (lastequality !== null && (lastequality.length <=
	          Math.max(length_insertions1, length_deletions1)) &&
	          (lastequality.length <= Math.max(length_insertions2,
	                                           length_deletions2))) {
	        // Duplicate record.
	        diffs.splice(equalities[equalitiesLength - 1], 0,
	                     [DIFF_DELETE, lastequality]);
	        // Change second copy to insert.
	        diffs[equalities[equalitiesLength - 1] + 1][0] = DIFF_INSERT;
	        // Throw away the equality we just deleted.
	        equalitiesLength--;
	        // Throw away the previous equality (it needs to be reevaluated).
	        equalitiesLength--;
	        pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
	        length_insertions1 = 0;  // Reset the counters.
	        length_deletions1 = 0;
	        length_insertions2 = 0;
	        length_deletions2 = 0;
	        lastequality = null;
	        changes = true;
	      }
	    }
	    pointer++;
	  }
	
	  // Normalize the diff.
	  if (changes) {
	    this.diff_cleanupMerge(diffs);
	  }
	  this.diff_cleanupSemanticLossless(diffs);
	
	  // Find any overlaps between deletions and insertions.
	  // e.g: <del>abcxxx</del><ins>xxxdef</ins>
	  //   -> <del>abc</del>xxx<ins>def</ins>
	  // Only extract an overlap if it is as big as the edit ahead or behind it.
	  pointer = 1;
	  while (pointer < diffs.length) {
	    if (diffs[pointer - 1][0] == DIFF_DELETE &&
	        diffs[pointer][0] == DIFF_INSERT) {
	      var deletion = /** @type {string} */(diffs[pointer - 1][1]);
	      var insertion = /** @type {string} */(diffs[pointer][1]);
	      var overlap_length = this.diff_commonOverlap_(deletion, insertion);
	      if (overlap_length >= deletion.length / 2 ||
	          overlap_length >= insertion.length / 2) {
	        // Overlap found.  Insert an equality and trim the surrounding edits.
	        diffs.splice(pointer, 0,
	            [DIFF_EQUAL, insertion.substring(0, overlap_length)]);
	        diffs[pointer - 1][1] =
	            deletion.substring(0, deletion.length - overlap_length);
	        diffs[pointer + 1][1] = insertion.substring(overlap_length);
	        pointer++;
	      }
	      pointer++;
	    }
	    pointer++;
	  }
	};
	
	
	/**
	 * Look for single edits surrounded on both sides by equalities
	 * which can be shifted sideways to align the edit to a word boundary.
	 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
	 */
	diff_match_patch.prototype.diff_cleanupSemanticLossless = function(diffs) {
	  // Define some regex patterns for matching boundaries.
	  var punctuation = /[^a-zA-Z0-9]/;
	  var whitespace = /\s/;
	  var linebreak = /[\r\n]/;
	  var blanklineEnd = /\n\r?\n$/;
	  var blanklineStart = /^\r?\n\r?\n/;
	
	  /**
	   * Given two strings, compute a score representing whether the internal
	   * boundary falls on logical boundaries.
	   * Scores range from 5 (best) to 0 (worst).
	   * Closure, makes reference to regex patterns defined above.
	   * @param {string} one First string.
	   * @param {string} two Second string.
	   * @return {number} The score.
	   * @private
	   */
	  function diff_cleanupSemanticScore_(one, two) {
	    if (!one || !two) {
	      // Edges are the best.
	      return 5;
	    }
	
	    // Each port of this function behaves slightly differently due to
	    // subtle differences in each language's definition of things like
	    // 'whitespace'.  Since this function's purpose is largely cosmetic,
	    // the choice has been made to use each language's native features
	    // rather than force total conformity.
	    var score = 0;
	    // One point for non-alphanumeric.
	    if (one.charAt(one.length - 1).match(punctuation) ||
	        two.charAt(0).match(punctuation)) {
	      score++;
	      // Two points for whitespace.
	      if (one.charAt(one.length - 1).match(whitespace) ||
	          two.charAt(0).match(whitespace)) {
	        score++;
	        // Three points for line breaks.
	        if (one.charAt(one.length - 1).match(linebreak) ||
	            two.charAt(0).match(linebreak)) {
	          score++;
	          // Four points for blank lines.
	          if (one.match(blanklineEnd) || two.match(blanklineStart)) {
	            score++;
	          }
	        }
	      }
	    }
	    return score;
	  }
	
	  var pointer = 1;
	  // Intentionally ignore the first and last element (don't need checking).
	  while (pointer < diffs.length - 1) {
	    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
	        diffs[pointer + 1][0] == DIFF_EQUAL) {
	      // This is a single edit surrounded by equalities.
	      var equality1 = /** @type {string} */(diffs[pointer - 1][1]);
	      var edit = /** @type {string} */(diffs[pointer][1]);
	      var equality2 = /** @type {string} */(diffs[pointer + 1][1]);
	
	      // First, shift the edit as far left as possible.
	      var commonOffset = this.diff_commonSuffix(equality1, edit);
	      if (commonOffset) {
	        var commonString = edit.substring(edit.length - commonOffset);
	        equality1 = equality1.substring(0, equality1.length - commonOffset);
	        edit = commonString + edit.substring(0, edit.length - commonOffset);
	        equality2 = commonString + equality2;
	      }
	
	      // Second, step character by character right, looking for the best fit.
	      var bestEquality1 = equality1;
	      var bestEdit = edit;
	      var bestEquality2 = equality2;
	      var bestScore = diff_cleanupSemanticScore_(equality1, edit) +
	          diff_cleanupSemanticScore_(edit, equality2);
	      while (edit.charAt(0) === equality2.charAt(0)) {
	        equality1 += edit.charAt(0);
	        edit = edit.substring(1) + equality2.charAt(0);
	        equality2 = equality2.substring(1);
	        var score = diff_cleanupSemanticScore_(equality1, edit) +
	            diff_cleanupSemanticScore_(edit, equality2);
	        // The >= encourages trailing rather than leading whitespace on edits.
	        if (score >= bestScore) {
	          bestScore = score;
	          bestEquality1 = equality1;
	          bestEdit = edit;
	          bestEquality2 = equality2;
	        }
	      }
	
	      if (diffs[pointer - 1][1] != bestEquality1) {
	        // We have an improvement, save it back to the diff.
	        if (bestEquality1) {
	          diffs[pointer - 1][1] = bestEquality1;
	        } else {
	          diffs.splice(pointer - 1, 1);
	          pointer--;
	        }
	        diffs[pointer][1] = bestEdit;
	        if (bestEquality2) {
	          diffs[pointer + 1][1] = bestEquality2;
	        } else {
	          diffs.splice(pointer + 1, 1);
	          pointer--;
	        }
	      }
	    }
	    pointer++;
	  }
	};
	
	
	/**
	 * Reduce the number of edits by eliminating operationally trivial equalities.
	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
	 */
	diff_match_patch.prototype.diff_cleanupEfficiency = function(diffs) {
	  var changes = false;
	  var equalities = [];  // Stack of indices where equalities are found.
	  var equalitiesLength = 0;  // Keeping our own length var is faster in JS.
	  var lastequality = '';  // Always equal to equalities[equalitiesLength-1][1]
	  var pointer = 0;  // Index of current position.
	  // Is there an insertion operation before the last equality.
	  var pre_ins = false;
	  // Is there a deletion operation before the last equality.
	  var pre_del = false;
	  // Is there an insertion operation after the last equality.
	  var post_ins = false;
	  // Is there a deletion operation after the last equality.
	  var post_del = false;
	  while (pointer < diffs.length) {
	    if (diffs[pointer][0] == DIFF_EQUAL) {  // Equality found.
	      if (diffs[pointer][1].length < this.Diff_EditCost &&
	          (post_ins || post_del)) {
	        // Candidate found.
	        equalities[equalitiesLength++] = pointer;
	        pre_ins = post_ins;
	        pre_del = post_del;
	        lastequality = diffs[pointer][1];
	      } else {
	        // Not a candidate, and can never become one.
	        equalitiesLength = 0;
	        lastequality = '';
	      }
	      post_ins = post_del = false;
	    } else {  // An insertion or deletion.
	      if (diffs[pointer][0] == DIFF_DELETE) {
	        post_del = true;
	      } else {
	        post_ins = true;
	      }
	      /*
	       * Five types to be split:
	       * <ins>A</ins><del>B</del>XY<ins>C</ins><del>D</del>
	       * <ins>A</ins>X<ins>C</ins><del>D</del>
	       * <ins>A</ins><del>B</del>X<ins>C</ins>
	       * <ins>A</del>X<ins>C</ins><del>D</del>
	       * <ins>A</ins><del>B</del>X<del>C</del>
	       */
	      if (lastequality && ((pre_ins && pre_del && post_ins && post_del) ||
	                           ((lastequality.length < this.Diff_EditCost / 2) &&
	                            (pre_ins + pre_del + post_ins + post_del) == 3))) {
	        // Duplicate record.
	        diffs.splice(equalities[equalitiesLength - 1], 0,
	                     [DIFF_DELETE, lastequality]);
	        // Change second copy to insert.
	        diffs[equalities[equalitiesLength - 1] + 1][0] = DIFF_INSERT;
	        equalitiesLength--;  // Throw away the equality we just deleted;
	        lastequality = '';
	        if (pre_ins && pre_del) {
	          // No changes made which could affect previous entry, keep going.
	          post_ins = post_del = true;
	          equalitiesLength = 0;
	        } else {
	          equalitiesLength--;  // Throw away the previous equality.
	          pointer = equalitiesLength > 0 ?
	              equalities[equalitiesLength - 1] : -1;
	          post_ins = post_del = false;
	        }
	        changes = true;
	      }
	    }
	    pointer++;
	  }
	
	  if (changes) {
	    this.diff_cleanupMerge(diffs);
	  }
	};
	
	
	/**
	 * Reorder and merge like edit sections.  Merge equalities.
	 * Any edit section can move as long as it doesn't cross an equality.
	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
	 */
	diff_match_patch.prototype.diff_cleanupMerge = function(diffs) {
	  diffs.push([DIFF_EQUAL, '']);  // Add a dummy entry at the end.
	  var pointer = 0;
	  var count_delete = 0;
	  var count_insert = 0;
	  var text_delete = '';
	  var text_insert = '';
	  var commonlength;
	  while (pointer < diffs.length) {
	    switch (diffs[pointer][0]) {
	      case DIFF_INSERT:
	        count_insert++;
	        text_insert += diffs[pointer][1];
	        pointer++;
	        break;
	      case DIFF_DELETE:
	        count_delete++;
	        text_delete += diffs[pointer][1];
	        pointer++;
	        break;
	      case DIFF_EQUAL:
	        // Upon reaching an equality, check for prior redundancies.
	        if (count_delete + count_insert > 1) {
	          if (count_delete !== 0 && count_insert !== 0) {
	            // Factor out any common prefixies.
	            commonlength = this.diff_commonPrefix(text_insert, text_delete);
	            if (commonlength !== 0) {
	              if ((pointer - count_delete - count_insert) > 0 &&
	                  diffs[pointer - count_delete - count_insert - 1][0] ==
	                  DIFF_EQUAL) {
	                diffs[pointer - count_delete - count_insert - 1][1] +=
	                    text_insert.substring(0, commonlength);
	              } else {
	                diffs.splice(0, 0, [DIFF_EQUAL,
	                                    text_insert.substring(0, commonlength)]);
	                pointer++;
	              }
	              text_insert = text_insert.substring(commonlength);
	              text_delete = text_delete.substring(commonlength);
	            }
	            // Factor out any common suffixies.
	            commonlength = this.diff_commonSuffix(text_insert, text_delete);
	            if (commonlength !== 0) {
	              diffs[pointer][1] = text_insert.substring(text_insert.length -
	                  commonlength) + diffs[pointer][1];
	              text_insert = text_insert.substring(0, text_insert.length -
	                  commonlength);
	              text_delete = text_delete.substring(0, text_delete.length -
	                  commonlength);
	            }
	          }
	          // Delete the offending records and add the merged ones.
	          if (count_delete === 0) {
	            diffs.splice(pointer - count_delete - count_insert,
	                count_delete + count_insert, [DIFF_INSERT, text_insert]);
	          } else if (count_insert === 0) {
	            diffs.splice(pointer - count_delete - count_insert,
	                count_delete + count_insert, [DIFF_DELETE, text_delete]);
	          } else {
	            diffs.splice(pointer - count_delete - count_insert,
	                count_delete + count_insert, [DIFF_DELETE, text_delete],
	                [DIFF_INSERT, text_insert]);
	          }
	          pointer = pointer - count_delete - count_insert +
	                    (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
	        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
	          // Merge this equality with the previous one.
	          diffs[pointer - 1][1] += diffs[pointer][1];
	          diffs.splice(pointer, 1);
	        } else {
	          pointer++;
	        }
	        count_insert = 0;
	        count_delete = 0;
	        text_delete = '';
	        text_insert = '';
	        break;
	    }
	  }
	  if (diffs[diffs.length - 1][1] === '') {
	    diffs.pop();  // Remove the dummy entry at the end.
	  }
	
	  // Second pass: look for single edits surrounded on both sides by equalities
	  // which can be shifted sideways to eliminate an equality.
	  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
	  var changes = false;
	  pointer = 1;
	  // Intentionally ignore the first and last element (don't need checking).
	  while (pointer < diffs.length - 1) {
	    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
	        diffs[pointer + 1][0] == DIFF_EQUAL) {
	      // This is a single edit surrounded by equalities.
	      if (diffs[pointer][1].substring(diffs[pointer][1].length -
	          diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
	        // Shift the edit over the previous equality.
	        diffs[pointer][1] = diffs[pointer - 1][1] +
	            diffs[pointer][1].substring(0, diffs[pointer][1].length -
	                                        diffs[pointer - 1][1].length);
	        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
	        diffs.splice(pointer - 1, 1);
	        changes = true;
	      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
	          diffs[pointer + 1][1]) {
	        // Shift the edit over the next equality.
	        diffs[pointer - 1][1] += diffs[pointer + 1][1];
	        diffs[pointer][1] =
	            diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
	            diffs[pointer + 1][1];
	        diffs.splice(pointer + 1, 1);
	        changes = true;
	      }
	    }
	    pointer++;
	  }
	  // If shifts were made, the diff needs reordering and another shift sweep.
	  if (changes) {
	    this.diff_cleanupMerge(diffs);
	  }
	};
	
	
	/**
	 * loc is a location in text1, compute and return the equivalent location in
	 * text2.
	 * e.g. 'The cat' vs 'The big cat', 1->1, 5->8
	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
	 * @param {number} loc Location within text1.
	 * @return {number} Location within text2.
	 */
	diff_match_patch.prototype.diff_xIndex = function(diffs, loc) {
	  var chars1 = 0;
	  var chars2 = 0;
	  var last_chars1 = 0;
	  var last_chars2 = 0;
	  var x;
	  for (x = 0; x < diffs.length; x++) {
	    if (diffs[x][0] !== DIFF_INSERT) {  // Equality or deletion.
	      chars1 += diffs[x][1].length;
	    }
	    if (diffs[x][0] !== DIFF_DELETE) {  // Equality or insertion.
	      chars2 += diffs[x][1].length;
	    }
	    if (chars1 > loc) {  // Overshot the location.
	      break;
	    }
	    last_chars1 = chars1;
	    last_chars2 = chars2;
	  }
	  // Was the location was deleted?
	  if (diffs.length != x && diffs[x][0] === DIFF_DELETE) {
	    return last_chars2;
	  }
	  // Add the remaining character length.
	  return last_chars2 + (loc - last_chars1);
	};
	
	
	/**
	 * Convert a diff array into a pretty HTML report.
	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
	 * @return {string} HTML representation.
	 */
	diff_match_patch.prototype.diff_prettyHtml = function(diffs) {
	  var html = [];
	  var i = 0;
	  var pattern_amp = /&/g;
	  var pattern_lt = /</g;
	  var pattern_gt = />/g;
	  var pattern_para = /\n/g;
	  for (var x = 0; x < diffs.length; x++) {
	    var op = diffs[x][0];    // Operation (insert, delete, equal)
	    var data = diffs[x][1];  // Text of change.
	    var text = data.replace(pattern_amp, '&amp;').replace(pattern_lt, '&lt;')
	        .replace(pattern_gt, '&gt;').replace(pattern_para, '&para;<br>');
	    switch (op) {
	      case DIFF_INSERT:
	        html[x] = '<ins style="background:#e6ffe6;">' + text + '</ins>';
	        break;
	      case DIFF_DELETE:
	        html[x] = '<del style="background:#ffe6e6;">' + text + '</del>';
	        break;
	      case DIFF_EQUAL:
	        html[x] = '<span>' + text + '</span>';
	        break;
	    }
	    if (op !== DIFF_DELETE) {
	      i += data.length;
	    }
	  }
	  return html.join('');
	};
	
	
	/**
	 * Compute and return the source text (all equalities and deletions).
	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
	 * @return {string} Source text.
	 */
	diff_match_patch.prototype.diff_text1 = function(diffs) {
	  var text = [];
	  for (var x = 0; x < diffs.length; x++) {
	    if (diffs[x][0] !== DIFF_INSERT) {
	      text[x] = diffs[x][1];
	    }
	  }
	  return text.join('');
	};
	
	
	/**
	 * Compute and return the destination text (all equalities and insertions).
	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
	 * @return {string} Destination text.
	 */
	diff_match_patch.prototype.diff_text2 = function(diffs) {
	  var text = [];
	  for (var x = 0; x < diffs.length; x++) {
	    if (diffs[x][0] !== DIFF_DELETE) {
	      text[x] = diffs[x][1];
	    }
	  }
	  return text.join('');
	};
	
	
	/**
	 * Compute the Levenshtein distance; the number of inserted, deleted or
	 * substituted characters.
	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
	 * @return {number} Number of changes.
	 */
	diff_match_patch.prototype.diff_levenshtein = function(diffs) {
	  var levenshtein = 0;
	  var insertions = 0;
	  var deletions = 0;
	  for (var x = 0; x < diffs.length; x++) {
	    var op = diffs[x][0];
	    var data = diffs[x][1];
	    switch (op) {
	      case DIFF_INSERT:
	        insertions += data.length;
	        break;
	      case DIFF_DELETE:
	        deletions += data.length;
	        break;
	      case DIFF_EQUAL:
	        // A deletion and an insertion is one substitution.
	        levenshtein += Math.max(insertions, deletions);
	        insertions = 0;
	        deletions = 0;
	        break;
	    }
	  }
	  levenshtein += Math.max(insertions, deletions);
	  return levenshtein;
	};
	
	
	/**
	 * Crush the diff into an encoded string which describes the operations
	 * required to transform text1 into text2.
	 * E.g. =3\t-2\t+ing  -> Keep 3 chars, delete 2 chars, insert 'ing'.
	 * Operations are tab-separated.  Inserted text is escaped using %xx notation.
	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
	 * @return {string} Delta text.
	 */
	diff_match_patch.prototype.diff_toDelta = function(diffs) {
	  var text = [];
	  for (var x = 0; x < diffs.length; x++) {
	    switch (diffs[x][0]) {
	      case DIFF_INSERT:
	        text[x] = '+' + encodeURI(diffs[x][1]);
	        break;
	      case DIFF_DELETE:
	        text[x] = '-' + diffs[x][1].length;
	        break;
	      case DIFF_EQUAL:
	        text[x] = '=' + diffs[x][1].length;
	        break;
	    }
	  }
	  return text.join('\t').replace(/%20/g, ' ');
	};
	
	
	/**
	 * Given the original text1, and an encoded string which describes the
	 * operations required to transform text1 into text2, compute the full diff.
	 * @param {string} text1 Source string for the diff.
	 * @param {string} delta Delta text.
	 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
	 * @throws {!Error} If invalid input.
	 */
	diff_match_patch.prototype.diff_fromDelta = function(text1, delta) {
	  var diffs = [];
	  var diffsLength = 0;  // Keeping our own length var is faster in JS.
	  var pointer = 0;  // Cursor in text1
	  var tokens = delta.split(/\t/g);
	  for (var x = 0; x < tokens.length; x++) {
	    // Each token begins with a one character parameter which specifies the
	    // operation of this token (delete, insert, equality).
	    var param = tokens[x].substring(1);
	    switch (tokens[x].charAt(0)) {
	      case '+':
	        try {
	          diffs[diffsLength++] = [DIFF_INSERT, decodeURI(param)];
	        } catch (ex) {
	          // Malformed URI sequence.
	          throw new Error('Illegal escape in diff_fromDelta: ' + param);
	        }
	        break;
	      case '-':
	        // Fall through.
	      case '=':
	        var n = parseInt(param, 10);
	        if (isNaN(n) || n < 0) {
	          throw new Error('Invalid number in diff_fromDelta: ' + param);
	        }
	        var text = text1.substring(pointer, pointer += n);
	        if (tokens[x].charAt(0) == '=') {
	          diffs[diffsLength++] = [DIFF_EQUAL, text];
	        } else {
	          diffs[diffsLength++] = [DIFF_DELETE, text];
	        }
	        break;
	      default:
	        // Blank tokens are ok (from a trailing \t).
	        // Anything else is an error.
	        if (tokens[x]) {
	          throw new Error('Invalid diff operation in diff_fromDelta: ' +
	                          tokens[x]);
	        }
	    }
	  }
	  if (pointer != text1.length) {
	    throw new Error('Delta length (' + pointer +
	        ') does not equal source text length (' + text1.length + ').');
	  }
	  return diffs;
	};
	
	
	//  MATCH FUNCTIONS
	
	
	/**
	 * Locate the best instance of 'pattern' in 'text' near 'loc'.
	 * @param {string} text The text to search.
	 * @param {string} pattern The pattern to search for.
	 * @param {number} loc The location to search around.
	 * @return {number} Best match index or -1.
	 */
	diff_match_patch.prototype.match_main = function(text, pattern, loc) {
	  // Check for null inputs.
	  if (text == null || pattern == null || loc == null) {
	    throw new Error('Null input. (match_main)');
	  }
	
	  loc = Math.max(0, Math.min(loc, text.length));
	  if (text == pattern) {
	    // Shortcut (potentially not guaranteed by the algorithm)
	    return 0;
	  } else if (!text.length) {
	    // Nothing to match.
	    return -1;
	  } else if (text.substring(loc, loc + pattern.length) == pattern) {
	    // Perfect match at the perfect spot!  (Includes case of null pattern)
	    return loc;
	  } else {
	    // Do a fuzzy compare.
	    return this.match_bitap_(text, pattern, loc);
	  }
	};
	
	
	/**
	 * Locate the best instance of 'pattern' in 'text' near 'loc' using the
	 * Bitap algorithm.
	 * @param {string} text The text to search.
	 * @param {string} pattern The pattern to search for.
	 * @param {number} loc The location to search around.
	 * @return {number} Best match index or -1.
	 * @private
	 */
	diff_match_patch.prototype.match_bitap_ = function(text, pattern, loc) {
	  if (pattern.length > this.Match_MaxBits) {
	    throw new Error('Pattern too long for this browser.');
	  }
	
	  // Initialise the alphabet.
	  var s = this.match_alphabet_(pattern);
	
	  var dmp = this;  // 'this' becomes 'window' in a closure.
	
	  /**
	   * Compute and return the score for a match with e errors and x location.
	   * Accesses loc and pattern through being a closure.
	   * @param {number} e Number of errors in match.
	   * @param {number} x Location of match.
	   * @return {number} Overall score for match (0.0 = good, 1.0 = bad).
	   * @private
	   */
	  function match_bitapScore_(e, x) {
	    var accuracy = e / pattern.length;
	    var proximity = Math.abs(loc - x);
	    if (!dmp.Match_Distance) {
	      // Dodge divide by zero error.
	      return proximity ? 1.0 : accuracy;
	    }
	    return accuracy + (proximity / dmp.Match_Distance);
	  }
	
	  // Highest score beyond which we give up.
	  var score_threshold = this.Match_Threshold;
	  // Is there a nearby exact match? (speedup)
	  var best_loc = text.indexOf(pattern, loc);
	  if (best_loc != -1) {
	    score_threshold = Math.min(match_bitapScore_(0, best_loc), score_threshold);
	    // What about in the other direction? (speedup)
	    best_loc = text.lastIndexOf(pattern, loc + pattern.length);
	    if (best_loc != -1) {
	      score_threshold =
	          Math.min(match_bitapScore_(0, best_loc), score_threshold);
	    }
	  }
	
	  // Initialise the bit arrays.
	  var matchmask = 1 << (pattern.length - 1);
	  best_loc = -1;
	
	  var bin_min, bin_mid;
	  var bin_max = pattern.length + text.length;
	  var last_rd;
	  for (var d = 0; d < pattern.length; d++) {
	    // Scan for the best match; each iteration allows for one more error.
	    // Run a binary search to determine how far from 'loc' we can stray at this
	    // error level.
	    bin_min = 0;
	    bin_mid = bin_max;
	    while (bin_min < bin_mid) {
	      if (match_bitapScore_(d, loc + bin_mid) <= score_threshold) {
	        bin_min = bin_mid;
	      } else {
	        bin_max = bin_mid;
	      }
	      bin_mid = Math.floor((bin_max - bin_min) / 2 + bin_min);
	    }
	    // Use the result from this iteration as the maximum for the next.
	    bin_max = bin_mid;
	    var start = Math.max(1, loc - bin_mid + 1);
	    var finish = Math.min(loc + bin_mid, text.length) + pattern.length;
	
	    var rd = Array(finish + 2);
	    rd[finish + 1] = (1 << d) - 1;
	    for (var j = finish; j >= start; j--) {
	      // The alphabet (s) is a sparse hash, so the following line generates
	      // warnings.
	      var charMatch = s[text.charAt(j - 1)];
	      if (d === 0) {  // First pass: exact match.
	        rd[j] = ((rd[j + 1] << 1) | 1) & charMatch;
	      } else {  // Subsequent passes: fuzzy match.
	        rd[j] = ((rd[j + 1] << 1) | 1) & charMatch |
	                (((last_rd[j + 1] | last_rd[j]) << 1) | 1) |
	                last_rd[j + 1];
	      }
	      if (rd[j] & matchmask) {
	        var score = match_bitapScore_(d, j - 1);
	        // This match will almost certainly be better than any existing match.
	        // But check anyway.
	        if (score <= score_threshold) {
	          // Told you so.
	          score_threshold = score;
	          best_loc = j - 1;
	          if (best_loc > loc) {
	            // When passing loc, don't exceed our current distance from loc.
	            start = Math.max(1, 2 * loc - best_loc);
	          } else {
	            // Already passed loc, downhill from here on in.
	            break;
	          }
	        }
	      }
	    }
	    // No hope for a (better) match at greater error levels.
	    if (match_bitapScore_(d + 1, loc) > score_threshold) {
	      break;
	    }
	    last_rd = rd;
	  }
	  return best_loc;
	};
	
	
	/**
	 * Initialise the alphabet for the Bitap algorithm.
	 * @param {string} pattern The text to encode.
	 * @return {!Object} Hash of character locations.
	 * @private
	 */
	diff_match_patch.prototype.match_alphabet_ = function(pattern) {
	  var s = {};
	  for (var i = 0; i < pattern.length; i++) {
	    s[pattern.charAt(i)] = 0;
	  }
	  for (var i = 0; i < pattern.length; i++) {
	    s[pattern.charAt(i)] |= 1 << (pattern.length - i - 1);
	  }
	  return s;
	};
	
	
	//  PATCH FUNCTIONS
	
	
	/**
	 * Increase the context until it is unique,
	 * but don't let the pattern expand beyond Match_MaxBits.
	 * @param {!diff_match_patch.patch_obj} patch The patch to grow.
	 * @param {string} text Source text.
	 * @private
	 */
	diff_match_patch.prototype.patch_addContext_ = function(patch, text) {
	  if (text.length == 0) {
	    return;
	  }
	  var pattern = text.substring(patch.start2, patch.start2 + patch.length1);
	  var padding = 0;
	
	  // Look for the first and last matches of pattern in text.  If two different
	  // matches are found, increase the pattern length.
	  while (text.indexOf(pattern) != text.lastIndexOf(pattern) &&
	         pattern.length < this.Match_MaxBits - this.Patch_Margin -
	         this.Patch_Margin) {
	    padding += this.Patch_Margin;
	    pattern = text.substring(patch.start2 - padding,
	                             patch.start2 + patch.length1 + padding);
	  }
	  // Add one chunk for good luck.
	  padding += this.Patch_Margin;
	
	  // Add the prefix.
	  var prefix = text.substring(patch.start2 - padding, patch.start2);
	  if (prefix) {
	    patch.diffs.unshift([DIFF_EQUAL, prefix]);
	  }
	  // Add the suffix.
	  var suffix = text.substring(patch.start2 + patch.length1,
	                              patch.start2 + patch.length1 + padding);
	  if (suffix) {
	    patch.diffs.push([DIFF_EQUAL, suffix]);
	  }
	
	  // Roll back the start points.
	  patch.start1 -= prefix.length;
	  patch.start2 -= prefix.length;
	  // Extend the lengths.
	  patch.length1 += prefix.length + suffix.length;
	  patch.length2 += prefix.length + suffix.length;
	};
	
	
	/**
	 * Compute a list of patches to turn text1 into text2.
	 * Use diffs if provided, otherwise compute it ourselves.
	 * There are four ways to call this function, depending on what data is
	 * available to the caller:
	 * Method 1:
	 * a = text1, b = text2
	 * Method 2:
	 * a = diffs
	 * Method 3 (optimal):
	 * a = text1, b = diffs
	 * Method 4 (deprecated, use method 3):
	 * a = text1, b = text2, c = diffs
	 *
	 * @param {string|!Array.<!diff_match_patch.Diff>} a text1 (methods 1,3,4) or
	 * Array of diff tuples for text1 to text2 (method 2).
	 * @param {string|!Array.<!diff_match_patch.Diff>} opt_b text2 (methods 1,4) or
	 * Array of diff tuples for text1 to text2 (method 3) or undefined (method 2).
	 * @param {string|!Array.<!diff_match_patch.Diff>} opt_c Array of diff tuples
	 * for text1 to text2 (method 4) or undefined (methods 1,2,3).
	 * @return {!Array.<!diff_match_patch.patch_obj>} Array of patch objects.
	 */
	diff_match_patch.prototype.patch_make = function(a, opt_b, opt_c) {
	  var text1, diffs;
	  if (typeof a == 'string' && typeof opt_b == 'string' &&
	      typeof opt_c == 'undefined') {
	    // Method 1: text1, text2
	    // Compute diffs from text1 and text2.
	    text1 = /** @type {string} */(a);
	    diffs = this.diff_main(text1, /** @type {string} */(opt_b), true);
	    if (diffs.length > 2) {
	      this.diff_cleanupSemantic(diffs);
	      this.diff_cleanupEfficiency(diffs);
	    }
	  } else if (a && typeof a == 'object' && typeof opt_b == 'undefined' &&
	      typeof opt_c == 'undefined') {
	    // Method 2: diffs
	    // Compute text1 from diffs.
	    diffs = /** @type {!Array.<!diff_match_patch.Diff>} */(a);
	    text1 = this.diff_text1(diffs);
	  } else if (typeof a == 'string' && opt_b && typeof opt_b == 'object' &&
	      typeof opt_c == 'undefined') {
	    // Method 3: text1, diffs
	    text1 = /** @type {string} */(a);
	    diffs = /** @type {!Array.<!diff_match_patch.Diff>} */(opt_b);
	  } else if (typeof a == 'string' && typeof opt_b == 'string' &&
	      opt_c && typeof opt_c == 'object') {
	    // Method 4: text1, text2, diffs
	    // text2 is not used.
	    text1 = /** @type {string} */(a);
	    diffs = /** @type {!Array.<!diff_match_patch.Diff>} */(opt_c);
	  } else {
	    throw new Error('Unknown call format to patch_make.');
	  }
	
	  if (diffs.length === 0) {
	    return [];  // Get rid of the null case.
	  }
	  var patches = [];
	  var patch = new diff_match_patch.patch_obj();
	  var patchDiffLength = 0;  // Keeping our own length var is faster in JS.
	  var char_count1 = 0;  // Number of characters into the text1 string.
	  var char_count2 = 0;  // Number of characters into the text2 string.
	  // Start with text1 (prepatch_text) and apply the diffs until we arrive at
	  // text2 (postpatch_text).  We recreate the patches one by one to determine
	  // context info.
	  var prepatch_text = text1;
	  var postpatch_text = text1;
	  for (var x = 0; x < diffs.length; x++) {
	    var diff_type = diffs[x][0];
	    var diff_text = diffs[x][1];
	
	    if (!patchDiffLength && diff_type !== DIFF_EQUAL) {
	      // A new patch starts here.
	      patch.start1 = char_count1;
	      patch.start2 = char_count2;
	    }
	
	    switch (diff_type) {
	      case DIFF_INSERT:
	        patch.diffs[patchDiffLength++] = diffs[x];
	        patch.length2 += diff_text.length;
	        postpatch_text = postpatch_text.substring(0, char_count2) + diff_text +
	                         postpatch_text.substring(char_count2);
	        break;
	      case DIFF_DELETE:
	        patch.length1 += diff_text.length;
	        patch.diffs[patchDiffLength++] = diffs[x];
	        postpatch_text = postpatch_text.substring(0, char_count2) +
	                         postpatch_text.substring(char_count2 +
	                             diff_text.length);
	        break;
	      case DIFF_EQUAL:
	        if (diff_text.length <= 2 * this.Patch_Margin &&
	            patchDiffLength && diffs.length != x + 1) {
	          // Small equality inside a patch.
	          patch.diffs[patchDiffLength++] = diffs[x];
	          patch.length1 += diff_text.length;
	          patch.length2 += diff_text.length;
	        } else if (diff_text.length >= 2 * this.Patch_Margin) {
	          // Time for a new patch.
	          if (patchDiffLength) {
	            this.patch_addContext_(patch, prepatch_text);
	            patches.push(patch);
	            patch = new diff_match_patch.patch_obj();
	            patchDiffLength = 0;
	            // Unlike Unidiff, our patch lists have a rolling context.
	            // http://code.google.com/p/google-diff-match-patch/wiki/Unidiff
	            // Update prepatch text & pos to reflect the application of the
	            // just completed patch.
	            prepatch_text = postpatch_text;
	            char_count1 = char_count2;
	          }
	        }
	        break;
	    }
	
	    // Update the current character count.
	    if (diff_type !== DIFF_INSERT) {
	      char_count1 += diff_text.length;
	    }
	    if (diff_type !== DIFF_DELETE) {
	      char_count2 += diff_text.length;
	    }
	  }
	  // Pick up the leftover patch if not empty.
	  if (patchDiffLength) {
	    this.patch_addContext_(patch, prepatch_text);
	    patches.push(patch);
	  }
	
	  return patches;
	};
	
	
	/**
	 * Given an array of patches, return another array that is identical.
	 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of patch objects.
	 * @return {!Array.<!diff_match_patch.patch_obj>} Array of patch objects.
	 */
	diff_match_patch.prototype.patch_deepCopy = function(patches) {
	  // Making deep copies is hard in JavaScript.
	  var patchesCopy = [];
	  for (var x = 0; x < patches.length; x++) {
	    var patch = patches[x];
	    var patchCopy = new diff_match_patch.patch_obj();
	    patchCopy.diffs = [];
	    for (var y = 0; y < patch.diffs.length; y++) {
	      patchCopy.diffs[y] = patch.diffs[y].slice();
	    }
	    patchCopy.start1 = patch.start1;
	    patchCopy.start2 = patch.start2;
	    patchCopy.length1 = patch.length1;
	    patchCopy.length2 = patch.length2;
	    patchesCopy[x] = patchCopy;
	  }
	  return patchesCopy;
	};
	
	
	/**
	 * Merge a set of patches onto the text.  Return a patched text, as well
	 * as a list of true/false values indicating which patches were applied.
	 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of patch objects.
	 * @param {string} text Old text.
	 * @return {!Array.<string|!Array.<boolean>>} Two element Array, containing the
	 *      new text and an array of boolean values.
	 */
	diff_match_patch.prototype.patch_apply = function(patches, text) {
	  if (patches.length == 0) {
	    return [text, []];
	  }
	
	  // Deep copy the patches so that no changes are made to originals.
	  patches = this.patch_deepCopy(patches);
	
	  var nullPadding = this.patch_addPadding(patches);
	  text = nullPadding + text + nullPadding;
	
	  this.patch_splitMax(patches);
	  // delta keeps track of the offset between the expected and actual location
	  // of the previous patch.  If there are patches expected at positions 10 and
	  // 20, but the first patch was found at 12, delta is 2 and the second patch
	  // has an effective expected position of 22.
	  var delta = 0;
	  var results = [];
	  for (var x = 0; x < patches.length; x++) {
	    var expected_loc = patches[x].start2 + delta;
	    var text1 = this.diff_text1(patches[x].diffs);
	    var start_loc;
	    var end_loc = -1;
	    if (text1.length > this.Match_MaxBits) {
	      // patch_splitMax will only provide an oversized pattern in the case of
	      // a monster delete.
	      start_loc = this.match_main(text, text1.substring(0, this.Match_MaxBits),
	                                  expected_loc);
	      if (start_loc != -1) {
	        end_loc = this.match_main(text,
	            text1.substring(text1.length - this.Match_MaxBits),
	            expected_loc + text1.length - this.Match_MaxBits);
	        if (end_loc == -1 || start_loc >= end_loc) {
	          // Can't find valid trailing context.  Drop this patch.
	          start_loc = -1;
	        }
	      }
	    } else {
	      start_loc = this.match_main(text, text1, expected_loc);
	    }
	    if (start_loc == -1) {
	      // No match found.  :(
	      results[x] = false;
	      // Subtract the delta for this failed patch from subsequent patches.
	      delta -= patches[x].length2 - patches[x].length1;
	    } else {
	      // Found a match.  :)
	      results[x] = true;
	      delta = start_loc - expected_loc;
	      var text2;
	      if (end_loc == -1) {
	        text2 = text.substring(start_loc, start_loc + text1.length);
	      } else {
	        text2 = text.substring(start_loc, end_loc + this.Match_MaxBits);
	      }
	      if (text1 == text2) {
	        // Perfect match, just shove the replacement text in.
	        text = text.substring(0, start_loc) +
	               this.diff_text2(patches[x].diffs) +
	               text.substring(start_loc + text1.length);
	      } else {
	        // Imperfect match.  Run a diff to get a framework of equivalent
	        // indices.
	        var diffs = this.diff_main(text1, text2, false);
	        if (text1.length > this.Match_MaxBits &&
	            this.diff_levenshtein(diffs) / text1.length >
	            this.Patch_DeleteThreshold) {
	          // The end points match, but the content is unacceptably bad.
	          results[x] = false;
	        } else {
	          this.diff_cleanupSemanticLossless(diffs);
	          var index1 = 0;
	          var index2;
	          for (var y = 0; y < patches[x].diffs.length; y++) {
	            var mod = patches[x].diffs[y];
	            if (mod[0] !== DIFF_EQUAL) {
	              index2 = this.diff_xIndex(diffs, index1);
	            }
	            if (mod[0] === DIFF_INSERT) {  // Insertion
	              text = text.substring(0, start_loc + index2) + mod[1] +
	                     text.substring(start_loc + index2);
	            } else if (mod[0] === DIFF_DELETE) {  // Deletion
	              text = text.substring(0, start_loc + index2) +
	                     text.substring(start_loc + this.diff_xIndex(diffs,
	                         index1 + mod[1].length));
	            }
	            if (mod[0] !== DIFF_DELETE) {
	              index1 += mod[1].length;
	            }
	          }
	        }
	      }
	    }
	  }
	  // Strip the padding off.
	  text = text.substring(nullPadding.length, text.length - nullPadding.length);
	  return [text, results];
	};
	
	
	/**
	 * Add some padding on text start and end so that edges can match something.
	 * Intended to be called only from within patch_apply.
	 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of patch objects.
	 * @return {string} The padding string added to each side.
	 */
	diff_match_patch.prototype.patch_addPadding = function(patches) {
	  var paddingLength = this.Patch_Margin;
	  var nullPadding = '';
	  for (var x = 1; x <= paddingLength; x++) {
	    nullPadding += String.fromCharCode(x);
	  }
	
	  // Bump all the patches forward.
	  for (var x = 0; x < patches.length; x++) {
	    patches[x].start1 += paddingLength;
	    patches[x].start2 += paddingLength;
	  }
	
	  // Add some padding on start of first diff.
	  var patch = patches[0];
	  var diffs = patch.diffs;
	  if (diffs.length == 0 || diffs[0][0] != DIFF_EQUAL) {
	    // Add nullPadding equality.
	    diffs.unshift([DIFF_EQUAL, nullPadding]);
	    patch.start1 -= paddingLength;  // Should be 0.
	    patch.start2 -= paddingLength;  // Should be 0.
	    patch.length1 += paddingLength;
	    patch.length2 += paddingLength;
	  } else if (paddingLength > diffs[0][1].length) {
	    // Grow first equality.
	    var extraLength = paddingLength - diffs[0][1].length;
	    diffs[0][1] = nullPadding.substring(diffs[0][1].length) + diffs[0][1];
	    patch.start1 -= extraLength;
	    patch.start2 -= extraLength;
	    patch.length1 += extraLength;
	    patch.length2 += extraLength;
	  }
	
	  // Add some padding on end of last diff.
	  patch = patches[patches.length - 1];
	  diffs = patch.diffs;
	  if (diffs.length == 0 || diffs[diffs.length - 1][0] != DIFF_EQUAL) {
	    // Add nullPadding equality.
	    diffs.push([DIFF_EQUAL, nullPadding]);
	    patch.length1 += paddingLength;
	    patch.length2 += paddingLength;
	  } else if (paddingLength > diffs[diffs.length - 1][1].length) {
	    // Grow last equality.
	    var extraLength = paddingLength - diffs[diffs.length - 1][1].length;
	    diffs[diffs.length - 1][1] += nullPadding.substring(0, extraLength);
	    patch.length1 += extraLength;
	    patch.length2 += extraLength;
	  }
	
	  return nullPadding;
	};
	
	
	/**
	 * Look through the patches and break up any which are longer than the maximum
	 * limit of the match algorithm.
	 * Intended to be called only from within patch_apply.
	 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of patch objects.
	 */
	diff_match_patch.prototype.patch_splitMax = function(patches) {
	  var patch_size = this.Match_MaxBits;
	  for (var x = 0; x < patches.length; x++) {
	    if (patches[x].length1 > patch_size) {
	      var bigpatch = patches[x];
	      // Remove the big old patch.
	      patches.splice(x--, 1);
	      var start1 = bigpatch.start1;
	      var start2 = bigpatch.start2;
	      var precontext = '';
	      while (bigpatch.diffs.length !== 0) {
	        // Create one of several smaller patches.
	        var patch = new diff_match_patch.patch_obj();
	        var empty = true;
	        patch.start1 = start1 - precontext.length;
	        patch.start2 = start2 - precontext.length;
	        if (precontext !== '') {
	          patch.length1 = patch.length2 = precontext.length;
	          patch.diffs.push([DIFF_EQUAL, precontext]);
	        }
	        while (bigpatch.diffs.length !== 0 &&
	               patch.length1 < patch_size - this.Patch_Margin) {
	          var diff_type = bigpatch.diffs[0][0];
	          var diff_text = bigpatch.diffs[0][1];
	          if (diff_type === DIFF_INSERT) {
	            // Insertions are harmless.
	            patch.length2 += diff_text.length;
	            start2 += diff_text.length;
	            patch.diffs.push(bigpatch.diffs.shift());
	            empty = false;
	          } else if (diff_type === DIFF_DELETE && patch.diffs.length == 1 &&
	                     patch.diffs[0][0] == DIFF_EQUAL &&
	                     diff_text.length > 2 * patch_size) {
	            // This is a large deletion.  Let it pass in one chunk.
	            patch.length1 += diff_text.length;
	            start1 += diff_text.length;
	            empty = false;
	            patch.diffs.push([diff_type, diff_text]);
	            bigpatch.diffs.shift();
	          } else {
	            // Deletion or equality.  Only take as much as we can stomach.
	            diff_text = diff_text.substring(0,
	                patch_size - patch.length1 - this.Patch_Margin);
	            patch.length1 += diff_text.length;
	            start1 += diff_text.length;
	            if (diff_type === DIFF_EQUAL) {
	              patch.length2 += diff_text.length;
	              start2 += diff_text.length;
	            } else {
	              empty = false;
	            }
	            patch.diffs.push([diff_type, diff_text]);
	            if (diff_text == bigpatch.diffs[0][1]) {
	              bigpatch.diffs.shift();
	            } else {
	              bigpatch.diffs[0][1] =
	                  bigpatch.diffs[0][1].substring(diff_text.length);
	            }
	          }
	        }
	        // Compute the head context for the next patch.
	        precontext = this.diff_text2(patch.diffs);
	        precontext =
	            precontext.substring(precontext.length - this.Patch_Margin);
	        // Append the end context for this patch.
	        var postcontext = this.diff_text1(bigpatch.diffs)
	                              .substring(0, this.Patch_Margin);
	        if (postcontext !== '') {
	          patch.length1 += postcontext.length;
	          patch.length2 += postcontext.length;
	          if (patch.diffs.length !== 0 &&
	              patch.diffs[patch.diffs.length - 1][0] === DIFF_EQUAL) {
	            patch.diffs[patch.diffs.length - 1][1] += postcontext;
	          } else {
	            patch.diffs.push([DIFF_EQUAL, postcontext]);
	          }
	        }
	        if (!empty) {
	          patches.splice(++x, 0, patch);
	        }
	      }
	    }
	  }
	};
	
	
	/**
	 * Take a list of patches and return a textual representation.
	 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of patch objects.
	 * @return {string} Text representation of patches.
	 */
	diff_match_patch.prototype.patch_toText = function(patches) {
	  var text = [];
	  for (var x = 0; x < patches.length; x++) {
	    text[x] = patches[x];
	  }
	  return text.join('');
	};
	
	
	/**
	 * Parse a textual representation of patches and return a list of patch objects.
	 * @param {string} textline Text representation of patches.
	 * @return {!Array.<!diff_match_patch.patch_obj>} Array of patch objects.
	 * @throws {!Error} If invalid input.
	 */
	diff_match_patch.prototype.patch_fromText = function(textline) {
	  var patches = [];
	  if (!textline) {
	    return patches;
	  }
	  var text = textline.split('\n');
	  var textPointer = 0;
	  var patchHeader = /^@@ -(\d+),?(\d*) \+(\d+),?(\d*) @@$/;
	  while (textPointer < text.length) {
	    var m = text[textPointer].match(patchHeader);
	    if (!m) {
	      throw new Error('Invalid patch string: ' + text[textPointer]);
	    }
	    var patch = new diff_match_patch.patch_obj();
	    patches.push(patch);
	    patch.start1 = parseInt(m[1], 10);
	    if (m[2] === '') {
	      patch.start1--;
	      patch.length1 = 1;
	    } else if (m[2] == '0') {
	      patch.length1 = 0;
	    } else {
	      patch.start1--;
	      patch.length1 = parseInt(m[2], 10);
	    }
	
	    patch.start2 = parseInt(m[3], 10);
	    if (m[4] === '') {
	      patch.start2--;
	      patch.length2 = 1;
	    } else if (m[4] == '0') {
	      patch.length2 = 0;
	    } else {
	      patch.start2--;
	      patch.length2 = parseInt(m[4], 10);
	    }
	    textPointer++;
	
	    while (textPointer < text.length) {
	      var sign = text[textPointer].charAt(0);
	      try {
	        var line = decodeURI(text[textPointer].substring(1));
	      } catch (ex) {
	        // Malformed URI sequence.
	        throw new Error('Illegal escape in patch_fromText: ' + line);
	      }
	      if (sign == '-') {
	        // Deletion.
	        patch.diffs.push([DIFF_DELETE, line]);
	      } else if (sign == '+') {
	        // Insertion.
	        patch.diffs.push([DIFF_INSERT, line]);
	      } else if (sign == ' ') {
	        // Minor equality.
	        patch.diffs.push([DIFF_EQUAL, line]);
	      } else if (sign == '@') {
	        // Start of next patch.
	        break;
	      } else if (sign === '') {
	        // Blank line?  Whatever.
	      } else {
	        // WTF?
	        throw new Error('Invalid patch mode "' + sign + '" in: ' + line);
	      }
	      textPointer++;
	    }
	  }
	  return patches;
	};
	
	
	/**
	 * Class representing one patch operation.
	 * @constructor
	 */
	diff_match_patch.patch_obj = function() {
	  /** @type {!Array.<!diff_match_patch.Diff>} */
	  this.diffs = [];
	  /** @type {?number} */
	  this.start1 = null;
	  /** @type {?number} */
	  this.start2 = null;
	  /** @type {number} */
	  this.length1 = 0;
	  /** @type {number} */
	  this.length2 = 0;
	};
	
	
	/**
	 * Emmulate GNU diff's format.
	 * Header: @@ -382,8 +481,9 @@
	 * Indicies are printed as 1-based, not 0-based.
	 * @return {string} The GNU diff string.
	 */
	diff_match_patch.patch_obj.prototype.toString = function() {
	  var coords1, coords2;
	  if (this.length1 === 0) {
	    coords1 = this.start1 + ',0';
	  } else if (this.length1 == 1) {
	    coords1 = this.start1 + 1;
	  } else {
	    coords1 = (this.start1 + 1) + ',' + this.length1;
	  }
	  if (this.length2 === 0) {
	    coords2 = this.start2 + ',0';
	  } else if (this.length2 == 1) {
	    coords2 = this.start2 + 1;
	  } else {
	    coords2 = (this.start2 + 1) + ',' + this.length2;
	  }
	  var text = ['@@ -' + coords1 + ' +' + coords2 + ' @@\n'];
	  var op;
	  // Escape the body of the patch with %xx notation.
	  for (var x = 0; x < this.diffs.length; x++) {
	    switch (this.diffs[x][0]) {
	      case DIFF_INSERT:
	        op = '+';
	        break;
	      case DIFF_DELETE:
	        op = '-';
	        break;
	      case DIFF_EQUAL:
	        op = ' ';
	        break;
	    }
	    text[x + 1] = op + encodeURI(this.diffs[x][1]) + '\n';
	  }
	  return text.join('').replace(/%20/g, ' ');
	};
	
	
	// Export these global variables so that they survive Google's JS compiler.
	// In a browser, 'this' will be 'window'.
	// In node.js 'this' will be a global object.
	this['diff_match_patch'] = diff_match_patch;
	this['DIFF_DELETE'] = DIFF_DELETE;
	this['DIFF_INSERT'] = DIFF_INSERT;
	this['DIFF_EQUAL'] = DIFF_EQUAL;
	


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	var Processor = __webpack_require__(301).Processor;
	var Pipe = __webpack_require__(208).Pipe;
	var DiffContext = __webpack_require__(155).DiffContext;
	var PatchContext = __webpack_require__(156).PatchContext;
	var ReverseContext = __webpack_require__(157).ReverseContext;
	
	var trivial = __webpack_require__(300);
	var nested = __webpack_require__(298);
	var arrays = __webpack_require__(295);
	var dates = __webpack_require__(296);
	var texts = __webpack_require__(299);
	
	var DiffPatcher = function DiffPatcher(options) {
	  this.processor = new Processor(options);
	  this.processor.pipe(new Pipe('diff').append(
	    nested.collectChildrenDiffFilter,
	    trivial.diffFilter,
	    dates.diffFilter,
	    texts.diffFilter,
	    nested.objectsDiffFilter,
	    arrays.diffFilter
	  ).shouldHaveResult());
	  this.processor.pipe(new Pipe('patch').append(
	    nested.collectChildrenPatchFilter,
	    arrays.collectChildrenPatchFilter,
	    trivial.patchFilter,
	    texts.patchFilter,
	    nested.patchFilter,
	    arrays.patchFilter
	  ).shouldHaveResult());
	  this.processor.pipe(new Pipe('reverse').append(
	    nested.collectChildrenReverseFilter,
	    arrays.collectChildrenReverseFilter,
	    trivial.reverseFilter,
	    texts.reverseFilter,
	    nested.reverseFilter,
	    arrays.reverseFilter
	  ).shouldHaveResult());
	};
	
	DiffPatcher.prototype.options = function() {
	  return this.processor.options.apply(this.processor, arguments);
	};
	
	DiffPatcher.prototype.diff = function(left, right) {
	  return this.processor.process(new DiffContext(left, right));
	};
	
	DiffPatcher.prototype.patch = function(left, delta) {
	  return this.processor.process(new PatchContext(left, delta));
	};
	
	DiffPatcher.prototype.reverse = function(delta) {
	  return this.processor.process(new ReverseContext(delta));
	};
	
	DiffPatcher.prototype.unpatch = function(right, delta) {
	  return this.patch(right, this.reverse(delta));
	};
	
	exports.DiffPatcher = DiffPatcher;


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	var DiffContext = __webpack_require__(155).DiffContext;
	var PatchContext = __webpack_require__(156).PatchContext;
	var ReverseContext = __webpack_require__(157).ReverseContext;
	
	var lcs = __webpack_require__(297);
	
	var ARRAY_MOVE = 3;
	
	var isArray = (typeof Array.isArray === 'function') ?
	  // use native function
	  Array.isArray :
	  // use instanceof operator
	  function(a) {
	    return a instanceof Array;
	  };
	
	var arrayIndexOf = typeof Array.prototype.indexOf === 'function' ?
	  function(array, item) {
	    return array.indexOf(item);
	  } : function(array, item) {
	    var length = array.length;
	    for (var i = 0; i < length; i++) {
	      if (array[i] === item) {
	        return i;
	      }
	    }
	    return -1;
	  };
	
	function arraysHaveMatchByRef(array1, array2, len1, len2) {
	  for (var index1 = 0; index1 < len1; index1++) {
	    var val1 = array1[index1];
	    for (var index2 = 0; index2 < len2; index2++) {
	      var val2 = array2[index2];
	      if (val1 === val2) {
	        return true;
	      }
	    }
	  }
	}
	
	function matchItems(array1, array2, index1, index2, context) {
	  var value1 = array1[index1];
	  var value2 = array2[index2];
	  if (value1 === value2) {
	    return true;
	  }
	  if (typeof value1 !== 'object' || typeof value2 !== 'object') {
	    return false;
	  }
	  var objectHash = context.objectHash;
	  if (!objectHash) {
	    // no way to match objects was provided, try match by position
	    return context.matchByPosition && index1 === index2;
	  }
	  var hash1;
	  var hash2;
	  if (typeof index1 === 'number') {
	    context.hashCache1 = context.hashCache1 || [];
	    hash1 = context.hashCache1[index1];
	    if (typeof hash1 === 'undefined') {
	      context.hashCache1[index1] = hash1 = objectHash(value1, index1);
	    }
	  } else {
	    hash1 = objectHash(value1);
	  }
	  if (typeof hash1 === 'undefined') {
	    return false;
	  }
	  if (typeof index2 === 'number') {
	    context.hashCache2 = context.hashCache2 || [];
	    hash2 = context.hashCache2[index2];
	    if (typeof hash2 === 'undefined') {
	      context.hashCache2[index2] = hash2 = objectHash(value2, index2);
	    }
	  } else {
	    hash2 = objectHash(value2);
	  }
	  if (typeof hash2 === 'undefined') {
	    return false;
	  }
	  return hash1 === hash2;
	}
	
	var diffFilter = function arraysDiffFilter(context) {
	  if (!context.leftIsArray) {
	    return;
	  }
	
	  var matchContext = {
	    objectHash: context.options && context.options.objectHash,
	    matchByPosition: context.options && context.options.matchByPosition
	  };
	  var commonHead = 0;
	  var commonTail = 0;
	  var index;
	  var index1;
	  var index2;
	  var array1 = context.left;
	  var array2 = context.right;
	  var len1 = array1.length;
	  var len2 = array2.length;
	
	  var child;
	
	  if (len1 > 0 && len2 > 0 && !matchContext.objectHash &&
	    typeof matchContext.matchByPosition !== 'boolean') {
	    matchContext.matchByPosition = !arraysHaveMatchByRef(array1, array2, len1, len2);
	  }
	
	  // separate common head
	  while (commonHead < len1 && commonHead < len2 &&
	    matchItems(array1, array2, commonHead, commonHead, matchContext)) {
	    index = commonHead;
	    child = new DiffContext(context.left[index], context.right[index]);
	    context.push(child, index);
	    commonHead++;
	  }
	  // separate common tail
	  while (commonTail + commonHead < len1 && commonTail + commonHead < len2 &&
	    matchItems(array1, array2, len1 - 1 - commonTail, len2 - 1 - commonTail, matchContext)) {
	    index1 = len1 - 1 - commonTail;
	    index2 = len2 - 1 - commonTail;
	    child = new DiffContext(context.left[index1], context.right[index2]);
	    context.push(child, index2);
	    commonTail++;
	  }
	  var result;
	  if (commonHead + commonTail === len1) {
	    if (len1 === len2) {
	      // arrays are identical
	      context.setResult(undefined).exit();
	      return;
	    }
	    // trivial case, a block (1 or more consecutive items) was added
	    result = result || {
	      _t: 'a'
	    };
	    for (index = commonHead; index < len2 - commonTail; index++) {
	      result[index] = [array2[index]];
	    }
	    context.setResult(result).exit();
	    return;
	  }
	  if (commonHead + commonTail === len2) {
	    // trivial case, a block (1 or more consecutive items) was removed
	    result = result || {
	      _t: 'a'
	    };
	    for (index = commonHead; index < len1 - commonTail; index++) {
	      result['_' + index] = [array1[index], 0, 0];
	    }
	    context.setResult(result).exit();
	    return;
	  }
	  // reset hash cache
	  delete matchContext.hashCache1;
	  delete matchContext.hashCache2;
	
	  // diff is not trivial, find the LCS (Longest Common Subsequence)
	  var trimmed1 = array1.slice(commonHead, len1 - commonTail);
	  var trimmed2 = array2.slice(commonHead, len2 - commonTail);
	  var seq = lcs.get(
	    trimmed1, trimmed2,
	    matchItems,
	    matchContext
	  );
	  var removedItems = [];
	  result = result || {
	    _t: 'a'
	  };
	  for (index = commonHead; index < len1 - commonTail; index++) {
	    if (arrayIndexOf(seq.indices1, index - commonHead) < 0) {
	      // removed
	      result['_' + index] = [array1[index], 0, 0];
	      removedItems.push(index);
	    }
	  }
	
	  var detectMove = true;
	  if (context.options && context.options.arrays && context.options.arrays.detectMove === false) {
	    detectMove = false;
	  }
	  var includeValueOnMove = false;
	  if (context.options && context.options.arrays && context.options.arrays.includeValueOnMove) {
	    includeValueOnMove = true;
	  }
	
	  var removedItemsLength = removedItems.length;
	  for (index = commonHead; index < len2 - commonTail; index++) {
	    var indexOnArray2 = arrayIndexOf(seq.indices2, index - commonHead);
	    if (indexOnArray2 < 0) {
	      // added, try to match with a removed item and register as position move
	      var isMove = false;
	      if (detectMove && removedItemsLength > 0) {
	        for (var removeItemIndex1 = 0; removeItemIndex1 < removedItemsLength; removeItemIndex1++) {
	          index1 = removedItems[removeItemIndex1];
	          if (matchItems(trimmed1, trimmed2, index1 - commonHead,
	            index - commonHead, matchContext)) {
	            // store position move as: [originalValue, newPosition, ARRAY_MOVE]
	            result['_' + index1].splice(1, 2, index, ARRAY_MOVE);
	            if (!includeValueOnMove) {
	              // don't include moved value on diff, to save bytes
	              result['_' + index1][0] = '';
	            }
	
	            index2 = index;
	            child = new DiffContext(context.left[index1], context.right[index2]);
	            context.push(child, index2);
	            removedItems.splice(removeItemIndex1, 1);
	            isMove = true;
	            break;
	          }
	        }
	      }
	      if (!isMove) {
	        // added
	        result[index] = [array2[index]];
	      }
	    } else {
	      // match, do inner diff
	      index1 = seq.indices1[indexOnArray2] + commonHead;
	      index2 = seq.indices2[indexOnArray2] + commonHead;
	      child = new DiffContext(context.left[index1], context.right[index2]);
	      context.push(child, index2);
	    }
	  }
	
	  context.setResult(result).exit();
	
	};
	diffFilter.filterName = 'arrays';
	
	var compare = {
	  numerically: function(a, b) {
	    return a - b;
	  },
	  numericallyBy: function(name) {
	    return function(a, b) {
	      return a[name] - b[name];
	    };
	  }
	};
	
	var patchFilter = function nestedPatchFilter(context) {
	  if (!context.nested) {
	    return;
	  }
	  if (context.delta._t !== 'a') {
	    return;
	  }
	  var index, index1;
	
	  var delta = context.delta;
	  var array = context.left;
	
	  // first, separate removals, insertions and modifications
	  var toRemove = [];
	  var toInsert = [];
	  var toModify = [];
	  for (index in delta) {
	    if (index !== '_t') {
	      if (index[0] === '_') {
	        // removed item from original array
	        if (delta[index][2] === 0 || delta[index][2] === ARRAY_MOVE) {
	          toRemove.push(parseInt(index.slice(1), 10));
	        } else {
	          throw new Error('only removal or move can be applied at original array indices' +
	            ', invalid diff type: ' + delta[index][2]);
	        }
	      } else {
	        if (delta[index].length === 1) {
	          // added item at new array
	          toInsert.push({
	            index: parseInt(index, 10),
	            value: delta[index][0]
	          });
	        } else {
	          // modified item at new array
	          toModify.push({
	            index: parseInt(index, 10),
	            delta: delta[index]
	          });
	        }
	      }
	    }
	  }
	
	  // remove items, in reverse order to avoid sawing our own floor
	  toRemove = toRemove.sort(compare.numerically);
	  for (index = toRemove.length - 1; index >= 0; index--) {
	    index1 = toRemove[index];
	    var indexDiff = delta['_' + index1];
	    var removedValue = array.splice(index1, 1)[0];
	    if (indexDiff[2] === ARRAY_MOVE) {
	      // reinsert later
	      toInsert.push({
	        index: indexDiff[1],
	        value: removedValue
	      });
	    }
	  }
	
	  // insert items, in reverse order to avoid moving our own floor
	  toInsert = toInsert.sort(compare.numericallyBy('index'));
	  var toInsertLength = toInsert.length;
	  for (index = 0; index < toInsertLength; index++) {
	    var insertion = toInsert[index];
	    array.splice(insertion.index, 0, insertion.value);
	  }
	
	  // apply modifications
	  var toModifyLength = toModify.length;
	  var child;
	  if (toModifyLength > 0) {
	    for (index = 0; index < toModifyLength; index++) {
	      var modification = toModify[index];
	      child = new PatchContext(context.left[modification.index], modification.delta);
	      context.push(child, modification.index);
	    }
	  }
	
	  if (!context.children) {
	    context.setResult(context.left).exit();
	    return;
	  }
	  context.exit();
	};
	patchFilter.filterName = 'arrays';
	
	var collectChildrenPatchFilter = function collectChildrenPatchFilter(context) {
	  if (!context || !context.children) {
	    return;
	  }
	  if (context.delta._t !== 'a') {
	    return;
	  }
	  var length = context.children.length;
	  var child;
	  for (var index = 0; index < length; index++) {
	    child = context.children[index];
	    context.left[child.childName] = child.result;
	  }
	  context.setResult(context.left).exit();
	};
	collectChildrenPatchFilter.filterName = 'arraysCollectChildren';
	
	var reverseFilter = function arraysReverseFilter(context) {
	  if (!context.nested) {
	    if (context.delta[2] === ARRAY_MOVE) {
	      context.newName = '_' + context.delta[1];
	      context.setResult([context.delta[0], parseInt(context.childName.substr(1), 10), ARRAY_MOVE]).exit();
	    }
	    return;
	  }
	  if (context.delta._t !== 'a') {
	    return;
	  }
	  var name, child;
	  for (name in context.delta) {
	    if (name === '_t') {
	      continue;
	    }
	    child = new ReverseContext(context.delta[name]);
	    context.push(child, name);
	  }
	  context.exit();
	};
	reverseFilter.filterName = 'arrays';
	
	var reverseArrayDeltaIndex = function(delta, index, itemDelta) {
	  if (typeof index === 'string' && index[0] === '_') {
	    return parseInt(index.substr(1), 10);
	  } else if (isArray(itemDelta) && itemDelta[2] === 0) {
	    return '_' + index;
	  }
	
	  var reverseIndex = +index;
	  for (var deltaIndex in delta) {
	    var deltaItem = delta[deltaIndex];
	    if (isArray(deltaItem)) {
	      if (deltaItem[2] === ARRAY_MOVE) {
	        var moveFromIndex = parseInt(deltaIndex.substr(1), 10);
	        var moveToIndex = deltaItem[1];
	        if (moveToIndex === +index) {
	          return moveFromIndex;
	        }
	        if (moveFromIndex <= reverseIndex && moveToIndex > reverseIndex) {
	          reverseIndex++;
	        } else if (moveFromIndex >= reverseIndex && moveToIndex < reverseIndex) {
	          reverseIndex--;
	        }
	      } else if (deltaItem[2] === 0) {
	        var deleteIndex = parseInt(deltaIndex.substr(1), 10);
	        if (deleteIndex <= reverseIndex) {
	          reverseIndex++;
	        }
	      } else if (deltaItem.length === 1 && deltaIndex <= reverseIndex) {
	        reverseIndex--;
	      }
	    }
	  }
	
	  return reverseIndex;
	};
	
	var collectChildrenReverseFilter = function collectChildrenReverseFilter(context) {
	  if (!context || !context.children) {
	    return;
	  }
	  if (context.delta._t !== 'a') {
	    return;
	  }
	  var length = context.children.length;
	  var child;
	  var delta = {
	    _t: 'a'
	  };
	
	  for (var index = 0; index < length; index++) {
	    child = context.children[index];
	    var name = child.newName;
	    if (typeof name === 'undefined') {
	      name = reverseArrayDeltaIndex(context.delta, child.childName, child.result);
	    }
	    if (delta[name] !== child.result) {
	      delta[name] = child.result;
	    }
	  }
	  context.setResult(delta).exit();
	};
	collectChildrenReverseFilter.filterName = 'arraysCollectChildren';
	
	exports.diffFilter = diffFilter;
	exports.patchFilter = patchFilter;
	exports.collectChildrenPatchFilter = collectChildrenPatchFilter;
	exports.reverseFilter = reverseFilter;
	exports.collectChildrenReverseFilter = collectChildrenReverseFilter;


/***/ },
/* 296 */
/***/ function(module, exports) {

	var diffFilter = function datesDiffFilter(context) {
	  if (context.left instanceof Date) {
	    if (context.right instanceof Date) {
	      if (context.left.getTime() !== context.right.getTime()) {
	        context.setResult([context.left, context.right]);
	      } else {
	        context.setResult(undefined);
	      }
	    } else {
	      context.setResult([context.left, context.right]);
	    }
	    context.exit();
	  } else if (context.right instanceof Date) {
	    context.setResult([context.left, context.right]).exit();
	  }
	};
	diffFilter.filterName = 'dates';
	
	exports.diffFilter = diffFilter;


/***/ },
/* 297 */
/***/ function(module, exports) {

	/*
	
	LCS implementation that supports arrays or strings
	
	reference: http://en.wikipedia.org/wiki/Longest_common_subsequence_problem
	
	*/
	
	var defaultMatch = function(array1, array2, index1, index2) {
	  return array1[index1] === array2[index2];
	};
	
	var lengthMatrix = function(array1, array2, match, context) {
	  var len1 = array1.length;
	  var len2 = array2.length;
	  var x, y;
	
	  // initialize empty matrix of len1+1 x len2+1
	  var matrix = [len1 + 1];
	  for (x = 0; x < len1 + 1; x++) {
	    matrix[x] = [len2 + 1];
	    for (y = 0; y < len2 + 1; y++) {
	      matrix[x][y] = 0;
	    }
	  }
	  matrix.match = match;
	  // save sequence lengths for each coordinate
	  for (x = 1; x < len1 + 1; x++) {
	    for (y = 1; y < len2 + 1; y++) {
	      if (match(array1, array2, x - 1, y - 1, context)) {
	        matrix[x][y] = matrix[x - 1][y - 1] + 1;
	      } else {
	        matrix[x][y] = Math.max(matrix[x - 1][y], matrix[x][y - 1]);
	      }
	    }
	  }
	  return matrix;
	};
	
	var backtrack = function(matrix, array1, array2, index1, index2, context) {
	  if (index1 === 0 || index2 === 0) {
	    return {
	      sequence: [],
	      indices1: [],
	      indices2: []
	    };
	  }
	
	  if (matrix.match(array1, array2, index1 - 1, index2 - 1, context)) {
	    var subsequence = backtrack(matrix, array1, array2, index1 - 1, index2 - 1, context);
	    subsequence.sequence.push(array1[index1 - 1]);
	    subsequence.indices1.push(index1 - 1);
	    subsequence.indices2.push(index2 - 1);
	    return subsequence;
	  }
	
	  if (matrix[index1][index2 - 1] > matrix[index1 - 1][index2]) {
	    return backtrack(matrix, array1, array2, index1, index2 - 1, context);
	  } else {
	    return backtrack(matrix, array1, array2, index1 - 1, index2, context);
	  }
	};
	
	var get = function(array1, array2, match, context) {
	  context = context || {};
	  var matrix = lengthMatrix(array1, array2, match || defaultMatch, context);
	  var result = backtrack(matrix, array1, array2, array1.length, array2.length, context);
	  if (typeof array1 === 'string' && typeof array2 === 'string') {
	    result.sequence = result.sequence.join('');
	  }
	  return result;
	};
	
	exports.get = get;


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	var DiffContext = __webpack_require__(155).DiffContext;
	var PatchContext = __webpack_require__(156).PatchContext;
	var ReverseContext = __webpack_require__(157).ReverseContext;
	
	var collectChildrenDiffFilter = function collectChildrenDiffFilter(context) {
	  if (!context || !context.children) {
	    return;
	  }
	  var length = context.children.length;
	  var child;
	  var result = context.result;
	  for (var index = 0; index < length; index++) {
	    child = context.children[index];
	    if (typeof child.result === 'undefined') {
	      continue;
	    }
	    result = result || {};
	    result[child.childName] = child.result;
	  }
	  if (result && context.leftIsArray) {
	    result._t = 'a';
	  }
	  context.setResult(result).exit();
	};
	collectChildrenDiffFilter.filterName = 'collectChildren';
	
	var objectsDiffFilter = function objectsDiffFilter(context) {
	  if (context.leftIsArray || context.leftType !== 'object') {
	    return;
	  }
	
	  var name, child, propertyFilter = context.options.propertyFilter;
	  for (name in context.left) {
	    if (!Object.prototype.hasOwnProperty.call(context.left, name)) {
	      continue;
	    }
	    if (propertyFilter && !propertyFilter(name, context)) {
	      continue;
	    }
	    child = new DiffContext(context.left[name], context.right[name]);
	    context.push(child, name);
	  }
	  for (name in context.right) {
	    if (!Object.prototype.hasOwnProperty.call(context.right, name)) {
	      continue;
	    }
	    if (propertyFilter && !propertyFilter(name, context)) {
	      continue;
	    }
	    if (typeof context.left[name] === 'undefined') {
	      child = new DiffContext(undefined, context.right[name]);
	      context.push(child, name);
	    }
	  }
	
	  if (!context.children || context.children.length === 0) {
	    context.setResult(undefined).exit();
	    return;
	  }
	  context.exit();
	};
	objectsDiffFilter.filterName = 'objects';
	
	var patchFilter = function nestedPatchFilter(context) {
	  if (!context.nested) {
	    return;
	  }
	  if (context.delta._t) {
	    return;
	  }
	  var name, child;
	  for (name in context.delta) {
	    child = new PatchContext(context.left[name], context.delta[name]);
	    context.push(child, name);
	  }
	  context.exit();
	};
	patchFilter.filterName = 'objects';
	
	var collectChildrenPatchFilter = function collectChildrenPatchFilter(context) {
	  if (!context || !context.children) {
	    return;
	  }
	  if (context.delta._t) {
	    return;
	  }
	  var length = context.children.length;
	  var child;
	  for (var index = 0; index < length; index++) {
	    child = context.children[index];
	    if (Object.prototype.hasOwnProperty.call(context.left, child.childName) && child.result === undefined) {
	      delete context.left[child.childName];
	    } else if (context.left[child.childName] !== child.result) {
	      context.left[child.childName] = child.result;
	    }
	  }
	  context.setResult(context.left).exit();
	};
	collectChildrenPatchFilter.filterName = 'collectChildren';
	
	var reverseFilter = function nestedReverseFilter(context) {
	  if (!context.nested) {
	    return;
	  }
	  if (context.delta._t) {
	    return;
	  }
	  var name, child;
	  for (name in context.delta) {
	    child = new ReverseContext(context.delta[name]);
	    context.push(child, name);
	  }
	  context.exit();
	};
	reverseFilter.filterName = 'objects';
	
	var collectChildrenReverseFilter = function collectChildrenReverseFilter(context) {
	  if (!context || !context.children) {
	    return;
	  }
	  if (context.delta._t) {
	    return;
	  }
	  var length = context.children.length;
	  var child;
	  var delta = {};
	  for (var index = 0; index < length; index++) {
	    child = context.children[index];
	    if (delta[child.childName] !== child.result) {
	      delta[child.childName] = child.result;
	    }
	  }
	  context.setResult(delta).exit();
	};
	collectChildrenReverseFilter.filterName = 'collectChildren';
	
	exports.collectChildrenDiffFilter = collectChildrenDiffFilter;
	exports.objectsDiffFilter = objectsDiffFilter;
	exports.patchFilter = patchFilter;
	exports.collectChildrenPatchFilter = collectChildrenPatchFilter;
	exports.reverseFilter = reverseFilter;
	exports.collectChildrenReverseFilter = collectChildrenReverseFilter;


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	/* global diff_match_patch */
	var TEXT_DIFF = 2;
	var DEFAULT_MIN_LENGTH = 60;
	var cachedDiffPatch = null;
	
	var getDiffMatchPatch = function(required) {
	  /*jshint camelcase: false */
	
	  if (!cachedDiffPatch) {
	    var instance;
	    if (typeof diff_match_patch !== 'undefined') {
	      // already loaded, probably a browser
	      instance = typeof diff_match_patch === 'function' ?
	        new diff_match_patch() : new diff_match_patch.diff_match_patch();
	    } else if (true) {
	      try {
	        var dmpModuleName = 'diff_match_patch_uncompressed';
	        var dmp = __webpack_require__(1398)("./" + dmpModuleName);
	        instance = new dmp.diff_match_patch();
	      } catch (err) {
	        instance = null;
	      }
	    }
	    if (!instance) {
	      if (!required) {
	        return null;
	      }
	      var error = new Error('text diff_match_patch library not found');
	      error.diff_match_patch_not_found = true;
	      throw error;
	    }
	    cachedDiffPatch = {
	      diff: function(txt1, txt2) {
	        return instance.patch_toText(instance.patch_make(txt1, txt2));
	      },
	      patch: function(txt1, patch) {
	        var results = instance.patch_apply(instance.patch_fromText(patch), txt1);
	        for (var i = 0; i < results[1].length; i++) {
	          if (!results[1][i]) {
	            var error = new Error('text patch failed');
	            error.textPatchFailed = true;
	          }
	        }
	        return results[0];
	      }
	    };
	  }
	  return cachedDiffPatch;
	};
	
	var diffFilter = function textsDiffFilter(context) {
	  if (context.leftType !== 'string') {
	    return;
	  }
	  var minLength = (context.options && context.options.textDiff &&
	    context.options.textDiff.minLength) || DEFAULT_MIN_LENGTH;
	  if (context.left.length < minLength ||
	    context.right.length < minLength) {
	    context.setResult([context.left, context.right]).exit();
	    return;
	  }
	  // large text, try to use a text-diff algorithm
	  var diffMatchPatch = getDiffMatchPatch();
	  if (!diffMatchPatch) {
	    // diff-match-patch library not available, fallback to regular string replace
	    context.setResult([context.left, context.right]).exit();
	    return;
	  }
	  var diff = diffMatchPatch.diff;
	  context.setResult([diff(context.left, context.right), 0, TEXT_DIFF]).exit();
	};
	diffFilter.filterName = 'texts';
	
	var patchFilter = function textsPatchFilter(context) {
	  if (context.nested) {
	    return;
	  }
	  if (context.delta[2] !== TEXT_DIFF) {
	    return;
	  }
	
	  // text-diff, use a text-patch algorithm
	  var patch = getDiffMatchPatch(true).patch;
	  context.setResult(patch(context.left, context.delta[0])).exit();
	};
	patchFilter.filterName = 'texts';
	
	var textDeltaReverse = function(delta) {
	  var i, l, lines, line, lineTmp, header = null,
	    headerRegex = /^@@ +\-(\d+),(\d+) +\+(\d+),(\d+) +@@$/,
	    lineHeader, lineAdd, lineRemove;
	  lines = delta.split('\n');
	  for (i = 0, l = lines.length; i < l; i++) {
	    line = lines[i];
	    var lineStart = line.slice(0, 1);
	    if (lineStart === '@') {
	      header = headerRegex.exec(line);
	      lineHeader = i;
	      lineAdd = null;
	      lineRemove = null;
	
	      // fix header
	      lines[lineHeader] = '@@ -' + header[3] + ',' + header[4] + ' +' + header[1] + ',' + header[2] + ' @@';
	    } else if (lineStart === '+') {
	      lineAdd = i;
	      lines[i] = '-' + lines[i].slice(1);
	      if (lines[i - 1].slice(0, 1) === '+') {
	        // swap lines to keep default order (-+)
	        lineTmp = lines[i];
	        lines[i] = lines[i - 1];
	        lines[i - 1] = lineTmp;
	      }
	    } else if (lineStart === '-') {
	      lineRemove = i;
	      lines[i] = '+' + lines[i].slice(1);
	    }
	  }
	  return lines.join('\n');
	};
	
	var reverseFilter = function textsReverseFilter(context) {
	  if (context.nested) {
	    return;
	  }
	  if (context.delta[2] !== TEXT_DIFF) {
	    return;
	  }
	
	  // text-diff, use a text-diff algorithm
	  context.setResult([textDeltaReverse(context.delta[0]), 0, TEXT_DIFF]).exit();
	};
	reverseFilter.filterName = 'texts';
	
	exports.diffFilter = diffFilter;
	exports.patchFilter = patchFilter;
	exports.reverseFilter = reverseFilter;


/***/ },
/* 300 */
/***/ function(module, exports) {

	var isArray = (typeof Array.isArray === 'function') ?
	  // use native function
	  Array.isArray :
	  // use instanceof operator
	  function(a) {
	    return a instanceof Array;
	  };
	
	var diffFilter = function trivialMatchesDiffFilter(context) {
	  if (context.left === context.right) {
	    context.setResult(undefined).exit();
	    return;
	  }
	  if (typeof context.left === 'undefined') {
	    if (typeof context.right === 'function') {
	      throw new Error('functions are not supported');
	    }
	    context.setResult([context.right]).exit();
	    return;
	  }
	  if (typeof context.right === 'undefined') {
	    context.setResult([context.left, 0, 0]).exit();
	    return;
	  }
	  if (typeof context.left === 'function' || typeof context.right === 'function') {
	    throw new Error('functions are not supported');
	  }
	  context.leftType = context.left === null ? 'null' : typeof context.left;
	  context.rightType = context.right === null ? 'null' : typeof context.right;
	  if (context.leftType !== context.rightType) {
	    context.setResult([context.left, context.right]).exit();
	    return;
	  }
	  if (context.leftType === 'boolean' || context.leftType === 'number') {
	    context.setResult([context.left, context.right]).exit();
	    return;
	  }
	  if (context.leftType === 'object') {
	    context.leftIsArray = isArray(context.left);
	  }
	  if (context.rightType === 'object') {
	    context.rightIsArray = isArray(context.right);
	  }
	  if (context.leftIsArray !== context.rightIsArray) {
	    context.setResult([context.left, context.right]).exit();
	    return;
	  }
	};
	diffFilter.filterName = 'trivial';
	
	var patchFilter = function trivialMatchesPatchFilter(context) {
	  if (typeof context.delta === 'undefined') {
	    context.setResult(context.left).exit();
	    return;
	  }
	  context.nested = !isArray(context.delta);
	  if (context.nested) {
	    return;
	  }
	  if (context.delta.length === 1) {
	    context.setResult(context.delta[0]).exit();
	    return;
	  }
	  if (context.delta.length === 2) {
	    context.setResult(context.delta[1]).exit();
	    return;
	  }
	  if (context.delta.length === 3 && context.delta[2] === 0) {
	    context.setResult(undefined).exit();
	    return;
	  }
	};
	patchFilter.filterName = 'trivial';
	
	var reverseFilter = function trivialReferseFilter(context) {
	  if (typeof context.delta === 'undefined') {
	    context.setResult(context.delta).exit();
	    return;
	  }
	  context.nested = !isArray(context.delta);
	  if (context.nested) {
	    return;
	  }
	  if (context.delta.length === 1) {
	    context.setResult([context.delta[0], 0, 0]).exit();
	    return;
	  }
	  if (context.delta.length === 2) {
	    context.setResult([context.delta[1], context.delta[0]]).exit();
	    return;
	  }
	  if (context.delta.length === 3 && context.delta[2] === 0) {
	    context.setResult([context.delta[0]]).exit();
	    return;
	  }
	};
	reverseFilter.filterName = 'trivial';
	
	exports.diffFilter = diffFilter;
	exports.patchFilter = patchFilter;
	exports.reverseFilter = reverseFilter;


/***/ },
/* 301 */
/***/ function(module, exports) {

	
	var Processor = function Processor(options){
	  this.selfOptions = options || {};
	  this.pipes = {};
	};
	
	Processor.prototype.options = function(options) {
	  if (options) {
	    this.selfOptions = options;
	  }
	  return this.selfOptions;
	};
	
	Processor.prototype.pipe = function(name, pipe) {
	  if (typeof name === 'string') {
	    if (typeof pipe === 'undefined') {
	      return this.pipes[name];
	    } else {
	      this.pipes[name] = pipe;
	    }
	  }
	  if (name && name.name) {
	    pipe = name;
	    if (pipe.processor === this) { return pipe; }
	    this.pipes[pipe.name] = pipe;
	  }
	  pipe.processor = this;
	  return pipe;
	};
	
	Processor.prototype.process = function(input, pipe) {
	  var context = input;
	  context.options = this.options();
	  var nextPipe = pipe || input.pipe || 'default';
	  var lastPipe, lastContext;
	  while (nextPipe) {
	    if (typeof context.nextAfterChildren !== 'undefined') {
	      // children processed and coming back to parent
	      context.next = context.nextAfterChildren;
	      context.nextAfterChildren = null;
	    }
	
	    if (typeof nextPipe === 'string') {
	      nextPipe = this.pipe(nextPipe);
	    }
	    nextPipe.process(context);
	    lastContext = context;
	    lastPipe = nextPipe;
	    nextPipe = null;
	    if (context) {
	      if (context.next) {
	        context = context.next;
	        nextPipe = lastContext.nextPipe || context.pipe || lastPipe;
	      }
	    }
	  }
	  return context.hasResult ? context.result : undefined;
	};
	
	exports.Processor = Processor;


/***/ },
/* 302 */
/***/ function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	function keyCode(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Compares a keyboard event with a given keyCode or keyName.
	 *
	 * @param {Event} event Keyboard event that should be tested
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Boolean}
	 * @api public
	 */
	keyCode.isEventKey = function isEventKey(event, nameOrCode) {
	  if (event && 'object' === typeof event) {
	    var keyCode = event.which || event.keyCode || event.charCode
	    if (keyCode === null || keyCode === undefined) { return false; }
	    if (typeof nameOrCode === 'string') {
	      // check codes
	      var foundNamedKey = codes[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    
	      // check aliases
	      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    } else if (typeof nameOrCode === 'number') {
	      return nameOrCode === keyCode;
	    }
	    return false;
	  }
	}
	
	exports = module.exports = keyCode;
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'spacebar': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(439),
	    setCacheAdd = __webpack_require__(1451),
	    setCacheHas = __webpack_require__(1452);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(165);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(1409);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 306 */
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },
/* 307 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 308 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 309 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 310 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(448),
	    isLength = __webpack_require__(449);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	var postcss = __webpack_require__(169);
	
	var unitless = {
	    'box-flex':          true,
	    'box-flex-group':    true,
	    'column-count':      true,
	    'flex':              true,
	    'flex-grow':         true,
	    'flex-positive':     true,
	    'flex-shrink':       true,
	    'flex-negative':     true,
	    'font-weight':       true,
	    'line-clamp':        true,
	    'line-height':       true,
	    'opacity':           true,
	    'order':             true,
	    'orphans':           true,
	    'tab-size':          true,
	    'widows':            true,
	    'z-index':           true,
	    'zoom':              true,
	    'fill-opacity':      true,
	    'stroke-dashoffset': true,
	    'stroke-opacity':    true,
	    'stroke-width':      true
	};
	
	function dashify(str) {
	    return str.replace(/([A-Z])/g, '-$1')
	              .replace(/^ms-/, '-ms-')
	              .toLowerCase();
	}
	
	function decl(parent, name, value) {
	    if ( value === false || value === null ) return;
	
	    name = dashify(name);
	    if ( typeof value === 'number' ) {
	        if ( value === 0 || unitless[name] ) {
	            value = value.toString();
	        } else {
	            value += 'px';
	        }
	    }
	
	    if ( name === 'css-float' ) name = 'float';
	
	    parent.push(postcss.decl({ prop: name, value: value }));
	}
	
	function parse(obj, parent) {
	    var name, value, node;
	    for ( name in obj ) {
	        if ( obj.hasOwnProperty(name) ) {
	            value = obj[name];
	            if ( name[0] === '@' ) {
	                var part = name.match(/@([^\s]+)(\s+([\w\W]*)\s*)?/);
	                node = postcss.atRule({ name: part[1], params: part[3] || '' });
	                if ( typeof value === 'object' ) {
	                    node.nodes = [];
	                    parse(value, node);
	                }
	                parent.push(node);
	            } else if ( Array.isArray(value) ) {
	                for ( var i = 0; i < value.length; i++ ) {
	                    decl(parent, name, value[i]);
	                }
	            } else if ( typeof value === 'object' && value !== null ) {
	                node = postcss.rule({ selector: name });
	                parse(value, node);
	                parent.push(node);
	            } else {
	                decl(parent, name, value);
	            }
	        }
	    }
	}
	
	module.exports = function (obj) {
	    var root = postcss.root();
	    parse(obj, root);
	    return root;
	};


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(1477);
	var walk = __webpack_require__(1480);
	var stringify = __webpack_require__(1478);
	
	function ValueParser(value) {
	  if (this instanceof ValueParser) {
	    this.nodes = parse(value);
	    return this;
	  }
	  return new ValueParser(value);
	}
	
	ValueParser.prototype.toString = function() {
	  return Array.isArray(this.nodes) ? stringify(this.nodes) : "";
	};
	
	ValueParser.prototype.walk = function(cb, bubble) {
	  walk(this.nodes, cb, bubble);
	  return this;
	};
	
	ValueParser.unit = __webpack_require__(1479);
	
	ValueParser.walk = walk;
	
	ValueParser.stringify = stringify;
	
	module.exports = ValueParser;


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _warnOnce = __webpack_require__(79);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	var _node = __webpack_require__(317);
	
	var _node2 = _interopRequireDefault(_node);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Represents a comment between declarations or statements (rule and at-rules).
	 *
	 * Comments inside selectors, at-rule parameters, or declaration values
	 * will be stored in the `raws` properties explained above.
	 *
	 * @extends Node
	 */
	var Comment = function (_Node) {
	    _inherits(Comment, _Node);
	
	    function Comment(defaults) {
	        _classCallCheck(this, Comment);
	
	        var _this = _possibleConstructorReturn(this, _Node.call(this, defaults));
	
	        _this.type = 'comment';
	        return _this;
	    }
	
	    _createClass(Comment, [{
	        key: 'left',
	        get: function get() {
	            (0, _warnOnce2.default)('Comment#left was deprecated. Use Comment#raws.left');
	            return this.raws.left;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Comment#left was deprecated. Use Comment#raws.left');
	            this.raws.left = val;
	        }
	    }, {
	        key: 'right',
	        get: function get() {
	            (0, _warnOnce2.default)('Comment#right was deprecated. Use Comment#raws.right');
	            return this.raws.right;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Comment#right was deprecated. Use Comment#raws.right');
	            this.raws.right = val;
	        }
	
	        /**
	         * @memberof Comment#
	         * @member {string} text - the comment’s text
	         */
	
	        /**
	         * @memberof Comment#
	         * @member {object} raws - Information to generate byte-to-byte equal
	         *                         node string as it was in the origin input.
	         *
	         * Every parser saves its own properties,
	         * but the default CSS parser uses:
	         *
	         * * `before`: the space symbols before the node.
	         * * `left`: the space symbols between `/*` and the comment’s text.
	         * * `right`: the space symbols between the comment’s text.
	         */
	
	    }]);
	
	    return Comment;
	}(_node2.default);
	
	exports.default = Comment;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _declaration = __webpack_require__(316);
	
	var _declaration2 = _interopRequireDefault(_declaration);
	
	var _warnOnce = __webpack_require__(79);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	var _comment = __webpack_require__(314);
	
	var _comment2 = _interopRequireDefault(_comment);
	
	var _node = __webpack_require__(317);
	
	var _node2 = _interopRequireDefault(_node);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function cleanSource(nodes) {
	    return nodes.map(function (i) {
	        if (i.nodes) i.nodes = cleanSource(i.nodes);
	        delete i.source;
	        return i;
	    });
	}
	
	/**
	 * The {@link Root}, {@link AtRule}, and {@link Rule} container nodes
	 * inherit some common methods to help work with their children.
	 *
	 * Note that all containers can store any content. If you write a rule inside
	 * a rule, PostCSS will parse it.
	 *
	 * @extends Node
	 * @abstract
	 */
	
	var Container = function (_Node) {
	    _inherits(Container, _Node);
	
	    function Container() {
	        _classCallCheck(this, Container);
	
	        return _possibleConstructorReturn(this, _Node.apply(this, arguments));
	    }
	
	    Container.prototype.push = function push(child) {
	        child.parent = this;
	        this.nodes.push(child);
	        return this;
	    };
	
	    /**
	     * Iterates through the container’s immediate children,
	     * calling `callback` for each child.
	     *
	     * Returning `false` in the callback will break iteration.
	     *
	     * This method only iterates through the container’s immediate children.
	     * If you need to recursively iterate through all the container’s descendant
	     * nodes, use {@link Container#walk}.
	     *
	     * Unlike the for `{}`-cycle or `Array#forEach` this iterator is safe
	     * if you are mutating the array of child nodes during iteration.
	     * PostCSS will adjust the current index to match the mutations.
	     *
	     * @param {childIterator} callback - iterator receives each node and index
	     *
	     * @return {false|undefined} returns `false` if iteration was broke
	     *
	     * @example
	     * const root = postcss.parse('a { color: black; z-index: 1 }');
	     * const rule = root.first;
	     *
	     * for ( let decl of rule.nodes ) {
	     *     decl.cloneBefore({ prop: '-webkit-' + decl.prop });
	     *     // Cycle will be infinite, because cloneBefore moves the current node
	     *     // to the next index
	     * }
	     *
	     * rule.each(decl => {
	     *     decl.cloneBefore({ prop: '-webkit-' + decl.prop });
	     *     // Will be executed only for color and z-index
	     * });
	     */
	
	
	    Container.prototype.each = function each(callback) {
	        if (!this.lastEach) this.lastEach = 0;
	        if (!this.indexes) this.indexes = {};
	
	        this.lastEach += 1;
	        var id = this.lastEach;
	        this.indexes[id] = 0;
	
	        if (!this.nodes) return undefined;
	
	        var index = void 0,
	            result = void 0;
	        while (this.indexes[id] < this.nodes.length) {
	            index = this.indexes[id];
	            result = callback(this.nodes[index], index);
	            if (result === false) break;
	
	            this.indexes[id] += 1;
	        }
	
	        delete this.indexes[id];
	
	        return result;
	    };
	
	    /**
	     * Traverses the container’s descendant nodes, calling callback
	     * for each node.
	     *
	     * Like container.each(), this method is safe to use
	     * if you are mutating arrays during iteration.
	     *
	     * If you only need to iterate through the container’s immediate children,
	     * use {@link Container#each}.
	     *
	     * @param {childIterator} callback - iterator receives each node and index
	     *
	     * @return {false|undefined} returns `false` if iteration was broke
	     *
	     * @example
	     * root.walk(node => {
	     *   // Traverses all descendant nodes.
	     * });
	     */
	
	
	    Container.prototype.walk = function walk(callback) {
	        return this.each(function (child, i) {
	            var result = callback(child, i);
	            if (result !== false && child.walk) {
	                result = child.walk(callback);
	            }
	            return result;
	        });
	    };
	
	    /**
	     * Traverses the container’s descendant nodes, calling callback
	     * for each declaration node.
	     *
	     * If you pass a filter, iteration will only happen over declarations
	     * with matching properties.
	     *
	     * Like {@link Container#each}, this method is safe
	     * to use if you are mutating arrays during iteration.
	     *
	     * @param {string|RegExp} [prop]   - string or regular expression
	     *                                   to filter declarations by property name
	     * @param {childIterator} callback - iterator receives each node and index
	     *
	     * @return {false|undefined} returns `false` if iteration was broke
	     *
	     * @example
	     * root.walkDecls(decl => {
	     *   checkPropertySupport(decl.prop);
	     * });
	     *
	     * root.walkDecls('border-radius', decl => {
	     *   decl.remove();
	     * });
	     *
	     * root.walkDecls(/^background/, decl => {
	     *   decl.value = takeFirstColorFromGradient(decl.value);
	     * });
	     */
	
	
	    Container.prototype.walkDecls = function walkDecls(prop, callback) {
	        if (!callback) {
	            callback = prop;
	            return this.walk(function (child, i) {
	                if (child.type === 'decl') {
	                    return callback(child, i);
	                }
	            });
	        } else if (prop instanceof RegExp) {
	            return this.walk(function (child, i) {
	                if (child.type === 'decl' && prop.test(child.prop)) {
	                    return callback(child, i);
	                }
	            });
	        } else {
	            return this.walk(function (child, i) {
	                if (child.type === 'decl' && child.prop === prop) {
	                    return callback(child, i);
	                }
	            });
	        }
	    };
	
	    /**
	     * Traverses the container’s descendant nodes, calling callback
	     * for each rule node.
	     *
	     * If you pass a filter, iteration will only happen over rules
	     * with matching selectors.
	     *
	     * Like {@link Container#each}, this method is safe
	     * to use if you are mutating arrays during iteration.
	     *
	     * @param {string|RegExp} [selector] - string or regular expression
	     *                                     to filter rules by selector
	     * @param {childIterator} callback   - iterator receives each node and index
	     *
	     * @return {false|undefined} returns `false` if iteration was broke
	     *
	     * @example
	     * const selectors = [];
	     * root.walkRules(rule => {
	     *   selectors.push(rule.selector);
	     * });
	     * console.log(`Your CSS uses ${selectors.length} selectors`);
	     */
	
	
	    Container.prototype.walkRules = function walkRules(selector, callback) {
	        if (!callback) {
	            callback = selector;
	
	            return this.walk(function (child, i) {
	                if (child.type === 'rule') {
	                    return callback(child, i);
	                }
	            });
	        } else if (selector instanceof RegExp) {
	            return this.walk(function (child, i) {
	                if (child.type === 'rule' && selector.test(child.selector)) {
	                    return callback(child, i);
	                }
	            });
	        } else {
	            return this.walk(function (child, i) {
	                if (child.type === 'rule' && child.selector === selector) {
	                    return callback(child, i);
	                }
	            });
	        }
	    };
	
	    /**
	     * Traverses the container’s descendant nodes, calling callback
	     * for each at-rule node.
	     *
	     * If you pass a filter, iteration will only happen over at-rules
	     * that have matching names.
	     *
	     * Like {@link Container#each}, this method is safe
	     * to use if you are mutating arrays during iteration.
	     *
	     * @param {string|RegExp} [name]   - string or regular expression
	     *                                   to filter at-rules by name
	     * @param {childIterator} callback - iterator receives each node and index
	     *
	     * @return {false|undefined} returns `false` if iteration was broke
	     *
	     * @example
	     * root.walkAtRules(rule => {
	     *   if ( isOld(rule.name) ) rule.remove();
	     * });
	     *
	     * let first = false;
	     * root.walkAtRules('charset', rule => {
	     *   if ( !first ) {
	     *     first = true;
	     *   } else {
	     *     rule.remove();
	     *   }
	     * });
	     */
	
	
	    Container.prototype.walkAtRules = function walkAtRules(name, callback) {
	        if (!callback) {
	            callback = name;
	            return this.walk(function (child, i) {
	                if (child.type === 'atrule') {
	                    return callback(child, i);
	                }
	            });
	        } else if (name instanceof RegExp) {
	            return this.walk(function (child, i) {
	                if (child.type === 'atrule' && name.test(child.name)) {
	                    return callback(child, i);
	                }
	            });
	        } else {
	            return this.walk(function (child, i) {
	                if (child.type === 'atrule' && child.name === name) {
	                    return callback(child, i);
	                }
	            });
	        }
	    };
	
	    /**
	     * Traverses the container’s descendant nodes, calling callback
	     * for each comment node.
	     *
	     * Like {@link Container#each}, this method is safe
	     * to use if you are mutating arrays during iteration.
	     *
	     * @param {childIterator} callback - iterator receives each node and index
	     *
	     * @return {false|undefined} returns `false` if iteration was broke
	     *
	     * @example
	     * root.walkComments(comment => {
	     *   comment.remove();
	     * });
	     */
	
	
	    Container.prototype.walkComments = function walkComments(callback) {
	        return this.walk(function (child, i) {
	            if (child.type === 'comment') {
	                return callback(child, i);
	            }
	        });
	    };
	
	    /**
	     * Inserts new nodes to the end of the container.
	     *
	     * @param {...(Node|object|string|Node[])} children - new nodes
	     *
	     * @return {Node} this node for methods chain
	     *
	     * @example
	     * const decl1 = postcss.decl({ prop: 'color', value: 'black' });
	     * const decl2 = postcss.decl({ prop: 'background-color', value: 'white' });
	     * rule.append(decl1, decl2);
	     *
	     * root.append({ name: 'charset', params: '"UTF-8"' });  // at-rule
	     * root.append({ selector: 'a' });                       // rule
	     * rule.append({ prop: 'color', value: 'black' });       // declaration
	     * rule.append({ text: 'Comment' })                      // comment
	     *
	     * root.append('a {}');
	     * root.first.append('color: black; z-index: 1');
	     */
	
	
	    Container.prototype.append = function append() {
	        for (var _len = arguments.length, children = Array(_len), _key = 0; _key < _len; _key++) {
	            children[_key] = arguments[_key];
	        }
	
	        for (var _iterator = children, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	            }
	
	            var child = _ref;
	
	            var nodes = this.normalize(child, this.last);
	            for (var _iterator2 = nodes, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	                var _ref2;
	
	                if (_isArray2) {
	                    if (_i2 >= _iterator2.length) break;
	                    _ref2 = _iterator2[_i2++];
	                } else {
	                    _i2 = _iterator2.next();
	                    if (_i2.done) break;
	                    _ref2 = _i2.value;
	                }
	
	                var node = _ref2;
	                this.nodes.push(node);
	            }
	        }
	        return this;
	    };
	
	    /**
	     * Inserts new nodes to the start of the container.
	     *
	     * @param {...(Node|object|string|Node[])} children - new nodes
	     *
	     * @return {Node} this node for methods chain
	     *
	     * @example
	     * const decl1 = postcss.decl({ prop: 'color', value: 'black' });
	     * const decl2 = postcss.decl({ prop: 'background-color', value: 'white' });
	     * rule.prepend(decl1, decl2);
	     *
	     * root.append({ name: 'charset', params: '"UTF-8"' });  // at-rule
	     * root.append({ selector: 'a' });                       // rule
	     * rule.append({ prop: 'color', value: 'black' });       // declaration
	     * rule.append({ text: 'Comment' })                      // comment
	     *
	     * root.append('a {}');
	     * root.first.append('color: black; z-index: 1');
	     */
	
	
	    Container.prototype.prepend = function prepend() {
	        for (var _len2 = arguments.length, children = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            children[_key2] = arguments[_key2];
	        }
	
	        children = children.reverse();
	        for (var _iterator3 = children, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
	            var _ref3;
	
	            if (_isArray3) {
	                if (_i3 >= _iterator3.length) break;
	                _ref3 = _iterator3[_i3++];
	            } else {
	                _i3 = _iterator3.next();
	                if (_i3.done) break;
	                _ref3 = _i3.value;
	            }
	
	            var child = _ref3;
	
	            var nodes = this.normalize(child, this.first, 'prepend').reverse();
	            for (var _iterator4 = nodes, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
	                var _ref4;
	
	                if (_isArray4) {
	                    if (_i4 >= _iterator4.length) break;
	                    _ref4 = _iterator4[_i4++];
	                } else {
	                    _i4 = _iterator4.next();
	                    if (_i4.done) break;
	                    _ref4 = _i4.value;
	                }
	
	                var node = _ref4;
	                this.nodes.unshift(node);
	            }for (var id in this.indexes) {
	                this.indexes[id] = this.indexes[id] + nodes.length;
	            }
	        }
	        return this;
	    };
	
	    Container.prototype.cleanRaws = function cleanRaws(keepBetween) {
	        _Node.prototype.cleanRaws.call(this, keepBetween);
	        if (this.nodes) {
	            for (var _iterator5 = this.nodes, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
	                var _ref5;
	
	                if (_isArray5) {
	                    if (_i5 >= _iterator5.length) break;
	                    _ref5 = _iterator5[_i5++];
	                } else {
	                    _i5 = _iterator5.next();
	                    if (_i5.done) break;
	                    _ref5 = _i5.value;
	                }
	
	                var node = _ref5;
	                node.cleanRaws(keepBetween);
	            }
	        }
	    };
	
	    /**
	     * Insert new node before old node within the container.
	     *
	     * @param {Node|number} exist             - child or child’s index.
	     * @param {Node|object|string|Node[]} add - new node
	     *
	     * @return {Node} this node for methods chain
	     *
	     * @example
	     * rule.insertBefore(decl, decl.clone({ prop: '-webkit-' + decl.prop }));
	     */
	
	
	    Container.prototype.insertBefore = function insertBefore(exist, add) {
	        exist = this.index(exist);
	
	        var type = exist === 0 ? 'prepend' : false;
	        var nodes = this.normalize(add, this.nodes[exist], type).reverse();
	        for (var _iterator6 = nodes, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
	            var _ref6;
	
	            if (_isArray6) {
	                if (_i6 >= _iterator6.length) break;
	                _ref6 = _iterator6[_i6++];
	            } else {
	                _i6 = _iterator6.next();
	                if (_i6.done) break;
	                _ref6 = _i6.value;
	            }
	
	            var node = _ref6;
	            this.nodes.splice(exist, 0, node);
	        }var index = void 0;
	        for (var id in this.indexes) {
	            index = this.indexes[id];
	            if (exist <= index) {
	                this.indexes[id] = index + nodes.length;
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Insert new node after old node within the container.
	     *
	     * @param {Node|number} exist             - child or child’s index
	     * @param {Node|object|string|Node[]} add - new node
	     *
	     * @return {Node} this node for methods chain
	     */
	
	
	    Container.prototype.insertAfter = function insertAfter(exist, add) {
	        exist = this.index(exist);
	
	        var nodes = this.normalize(add, this.nodes[exist]).reverse();
	        for (var _iterator7 = nodes, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
	            var _ref7;
	
	            if (_isArray7) {
	                if (_i7 >= _iterator7.length) break;
	                _ref7 = _iterator7[_i7++];
	            } else {
	                _i7 = _iterator7.next();
	                if (_i7.done) break;
	                _ref7 = _i7.value;
	            }
	
	            var node = _ref7;
	            this.nodes.splice(exist + 1, 0, node);
	        }var index = void 0;
	        for (var id in this.indexes) {
	            index = this.indexes[id];
	            if (exist < index) {
	                this.indexes[id] = index + nodes.length;
	            }
	        }
	
	        return this;
	    };
	
	    Container.prototype.remove = function remove(child) {
	        if (typeof child !== 'undefined') {
	            (0, _warnOnce2.default)('Container#remove is deprecated. ' + 'Use Container#removeChild');
	            this.removeChild(child);
	        } else {
	            _Node.prototype.remove.call(this);
	        }
	        return this;
	    };
	
	    /**
	     * Removes node from the container and cleans the parent properties
	     * from the node and its children.
	     *
	     * @param {Node|number} child - child or child’s index
	     *
	     * @return {Node} this node for methods chain
	     *
	     * @example
	     * rule.nodes.length  //=> 5
	     * rule.removeChild(decl);
	     * rule.nodes.length  //=> 4
	     * decl.parent        //=> undefined
	     */
	
	
	    Container.prototype.removeChild = function removeChild(child) {
	        child = this.index(child);
	        this.nodes[child].parent = undefined;
	        this.nodes.splice(child, 1);
	
	        var index = void 0;
	        for (var id in this.indexes) {
	            index = this.indexes[id];
	            if (index >= child) {
	                this.indexes[id] = index - 1;
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Removes all children from the container
	     * and cleans their parent properties.
	     *
	     * @return {Node} this node for methods chain
	     *
	     * @example
	     * rule.removeAll();
	     * rule.nodes.length //=> 0
	     */
	
	
	    Container.prototype.removeAll = function removeAll() {
	        for (var _iterator8 = this.nodes, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
	            var _ref8;
	
	            if (_isArray8) {
	                if (_i8 >= _iterator8.length) break;
	                _ref8 = _iterator8[_i8++];
	            } else {
	                _i8 = _iterator8.next();
	                if (_i8.done) break;
	                _ref8 = _i8.value;
	            }
	
	            var node = _ref8;
	            node.parent = undefined;
	        }this.nodes = [];
	        return this;
	    };
	
	    /**
	     * Passes all declaration values within the container that match pattern
	     * through callback, replacing those values with the returned result
	     * of callback.
	     *
	     * This method is useful if you are using a custom unit or function
	     * and need to iterate through all values.
	     *
	     * @param {string|RegExp} pattern      - replace pattern
	     * @param {object} opts                - options to speed up the search
	     * @param {string|string[]} opts.props - an array of property names
	     * @param {string} opts.fast           - string that’s used
	     *                                       to narrow down values and speed up
	                                             the regexp search
	     * @param {function|string} callback   - string to replace pattern
	     *                                       or callback that returns a new
	     *                                       value.
	     *                                       The callback will receive
	     *                                       the same arguments as those
	     *                                       passed to a function parameter
	     *                                       of `String#replace`.
	     *
	     * @return {Node} this node for methods chain
	     *
	     * @example
	     * root.replaceValues(/\d+rem/, { fast: 'rem' }, string => {
	     *   return 15 * parseInt(string) + 'px';
	     * });
	     */
	
	
	    Container.prototype.replaceValues = function replaceValues(pattern, opts, callback) {
	        if (!callback) {
	            callback = opts;
	            opts = {};
	        }
	
	        this.walkDecls(function (decl) {
	            if (opts.props && opts.props.indexOf(decl.prop) === -1) return;
	            if (opts.fast && decl.value.indexOf(opts.fast) === -1) return;
	
	            decl.value = decl.value.replace(pattern, callback);
	        });
	
	        return this;
	    };
	
	    /**
	     * Returns `true` if callback returns `true`
	     * for all of the container’s children.
	     *
	     * @param {childCondition} condition - iterator returns true or false.
	     *
	     * @return {boolean} is every child pass condition
	     *
	     * @example
	     * const noPrefixes = rule.every(i => i.prop[0] !== '-');
	     */
	
	
	    Container.prototype.every = function every(condition) {
	        return this.nodes.every(condition);
	    };
	
	    /**
	     * Returns `true` if callback returns `true` for (at least) one
	     * of the container’s children.
	     *
	     * @param {childCondition} condition - iterator returns true or false.
	     *
	     * @return {boolean} is some child pass condition
	     *
	     * @example
	     * const hasPrefix = rule.some(i => i.prop[0] === '-');
	     */
	
	
	    Container.prototype.some = function some(condition) {
	        return this.nodes.some(condition);
	    };
	
	    /**
	     * Returns a `child`’s index within the {@link Container#nodes} array.
	     *
	     * @param {Node} child - child of the current container.
	     *
	     * @return {number} child index
	     *
	     * @example
	     * rule.index( rule.nodes[2] ) //=> 2
	     */
	
	
	    Container.prototype.index = function index(child) {
	        if (typeof child === 'number') {
	            return child;
	        } else {
	            return this.nodes.indexOf(child);
	        }
	    };
	
	    /**
	     * The container’s first child.
	     *
	     * @type {Node}
	     *
	     * @example
	     * rule.first == rules.nodes[0];
	     */
	
	
	    Container.prototype.normalize = function normalize(nodes, sample) {
	        var _this2 = this;
	
	        if (typeof nodes === 'string') {
	            var parse = __webpack_require__(318);
	            nodes = cleanSource(parse(nodes).nodes);
	        } else if (!Array.isArray(nodes)) {
	            if (nodes.type === 'root') {
	                nodes = nodes.nodes;
	            } else if (nodes.type) {
	                nodes = [nodes];
	            } else if (nodes.prop) {
	                if (typeof nodes.value === 'undefined') {
	                    throw new Error('Value field is missed in node creation');
	                } else if (typeof nodes.value !== 'string') {
	                    nodes.value = String(nodes.value);
	                }
	                nodes = [new _declaration2.default(nodes)];
	            } else if (nodes.selector) {
	                var Rule = __webpack_require__(216);
	                nodes = [new Rule(nodes)];
	            } else if (nodes.name) {
	                var AtRule = __webpack_require__(215);
	                nodes = [new AtRule(nodes)];
	            } else if (nodes.text) {
	                nodes = [new _comment2.default(nodes)];
	            } else {
	                throw new Error('Unknown node type in node creation');
	            }
	        }
	
	        var processed = nodes.map(function (i) {
	            if (typeof i.raws === 'undefined') i = _this2.rebuild(i);
	
	            if (i.parent) i = i.clone();
	            if (typeof i.raws.before === 'undefined') {
	                if (sample && typeof sample.raws.before !== 'undefined') {
	                    i.raws.before = sample.raws.before.replace(/[^\s]/g, '');
	                }
	            }
	            i.parent = _this2;
	            return i;
	        });
	
	        return processed;
	    };
	
	    Container.prototype.rebuild = function rebuild(node, parent) {
	        var _this3 = this;
	
	        var fix = void 0;
	        if (node.type === 'root') {
	            var Root = __webpack_require__(319);
	            fix = new Root();
	        } else if (node.type === 'atrule') {
	            var AtRule = __webpack_require__(215);
	            fix = new AtRule();
	        } else if (node.type === 'rule') {
	            var Rule = __webpack_require__(216);
	            fix = new Rule();
	        } else if (node.type === 'decl') {
	            fix = new _declaration2.default();
	        } else if (node.type === 'comment') {
	            fix = new _comment2.default();
	        }
	
	        for (var i in node) {
	            if (i === 'nodes') {
	                fix.nodes = node.nodes.map(function (j) {
	                    return _this3.rebuild(j, fix);
	                });
	            } else if (i === 'parent' && parent) {
	                fix.parent = parent;
	            } else if (node.hasOwnProperty(i)) {
	                fix[i] = node[i];
	            }
	        }
	
	        return fix;
	    };
	
	    Container.prototype.eachInside = function eachInside(callback) {
	        (0, _warnOnce2.default)('Container#eachInside is deprecated. ' + 'Use Container#walk instead.');
	        return this.walk(callback);
	    };
	
	    Container.prototype.eachDecl = function eachDecl(prop, callback) {
	        (0, _warnOnce2.default)('Container#eachDecl is deprecated. ' + 'Use Container#walkDecls instead.');
	        return this.walkDecls(prop, callback);
	    };
	
	    Container.prototype.eachRule = function eachRule(selector, callback) {
	        (0, _warnOnce2.default)('Container#eachRule is deprecated. ' + 'Use Container#walkRules instead.');
	        return this.walkRules(selector, callback);
	    };
	
	    Container.prototype.eachAtRule = function eachAtRule(name, callback) {
	        (0, _warnOnce2.default)('Container#eachAtRule is deprecated. ' + 'Use Container#walkAtRules instead.');
	        return this.walkAtRules(name, callback);
	    };
	
	    Container.prototype.eachComment = function eachComment(callback) {
	        (0, _warnOnce2.default)('Container#eachComment is deprecated. ' + 'Use Container#walkComments instead.');
	        return this.walkComments(callback);
	    };
	
	    _createClass(Container, [{
	        key: 'first',
	        get: function get() {
	            if (!this.nodes) return undefined;
	            return this.nodes[0];
	        }
	
	        /**
	         * The container’s last child.
	         *
	         * @type {Node}
	         *
	         * @example
	         * rule.last == rule.nodes[rule.nodes.length - 1];
	         */
	
	    }, {
	        key: 'last',
	        get: function get() {
	            if (!this.nodes) return undefined;
	            return this.nodes[this.nodes.length - 1];
	        }
	    }, {
	        key: 'semicolon',
	        get: function get() {
	            (0, _warnOnce2.default)('Node#semicolon is deprecated. Use Node#raws.semicolon');
	            return this.raws.semicolon;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Node#semicolon is deprecated. Use Node#raws.semicolon');
	            this.raws.semicolon = val;
	        }
	    }, {
	        key: 'after',
	        get: function get() {
	            (0, _warnOnce2.default)('Node#after is deprecated. Use Node#raws.after');
	            return this.raws.after;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Node#after is deprecated. Use Node#raws.after');
	            this.raws.after = val;
	        }
	
	        /**
	         * @memberof Container#
	         * @member {Node[]} nodes - an array containing the container’s children
	         *
	         * @example
	         * const root = postcss.parse('a { color: black }');
	         * root.nodes.length           //=> 1
	         * root.nodes[0].selector      //=> 'a'
	         * root.nodes[0].nodes[0].prop //=> 'color'
	         */
	
	    }]);
	
	    return Container;
	}(_node2.default);
	
	exports.default = Container;
	
	/**
	 * @callback childCondition
	 * @param {Node} node    - container child
	 * @param {number} index - child index
	 * @param {Node[]} nodes - all container children
	 * @return {boolean}
	 */
	
	/**
	 * @callback childIterator
	 * @param {Node} node    - container child
	 * @param {number} index - child index
	 * @return {false|undefined} returning `false` will break iteration
	 */
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _warnOnce = __webpack_require__(79);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	var _node = __webpack_require__(317);
	
	var _node2 = _interopRequireDefault(_node);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Represents a CSS declaration.
	 *
	 * @extends Node
	 *
	 * @example
	 * const root = postcss.parse('a { color: black }');
	 * const decl = root.first.first;
	 * decl.type       //=> 'decl'
	 * decl.toString() //=> ' color: black'
	 */
	var Declaration = function (_Node) {
	    _inherits(Declaration, _Node);
	
	    function Declaration(defaults) {
	        _classCallCheck(this, Declaration);
	
	        var _this = _possibleConstructorReturn(this, _Node.call(this, defaults));
	
	        _this.type = 'decl';
	        return _this;
	    }
	
	    _createClass(Declaration, [{
	        key: '_value',
	        get: function get() {
	            (0, _warnOnce2.default)('Node#_value was deprecated. Use Node#raws.value');
	            return this.raws.value;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Node#_value was deprecated. Use Node#raws.value');
	            this.raws.value = val;
	        }
	    }, {
	        key: '_important',
	        get: function get() {
	            (0, _warnOnce2.default)('Node#_important was deprecated. Use Node#raws.important');
	            return this.raws.important;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Node#_important was deprecated. Use Node#raws.important');
	            this.raws.important = val;
	        }
	
	        /**
	         * @memberof Declaration#
	         * @member {string} prop - the declaration’s property name
	         *
	         * @example
	         * const root = postcss.parse('a { color: black }');
	         * const decl = root.first.first;
	         * decl.prop //=> 'color'
	         */
	
	        /**
	         * @memberof Declaration#
	         * @member {string} value - the declaration’s value
	         *
	         * @example
	         * const root = postcss.parse('a { color: black }');
	         * const decl = root.first.first;
	         * decl.value //=> 'black'
	         */
	
	        /**
	         * @memberof Declaration#
	         * @member {boolean} important - `true` if the declaration
	         *                               has an !important annotation.
	         *
	         * @example
	         * const root = postcss.parse('a { color: black !important; color: red }');
	         * root.first.first.important //=> true
	         * root.first.last.important  //=> undefined
	         */
	
	        /**
	         * @memberof Declaration#
	         * @member {object} raws - Information to generate byte-to-byte equal
	         *                         node string as it was in the origin input.
	         *
	         * Every parser saves its own properties,
	         * but the default CSS parser uses:
	         *
	         * * `before`: the space symbols before the node. It also stores `*`
	         *   and `_` symbols before the declaration (IE hack).
	         * * `between`: the symbols between the property and value
	         *   for declarations.
	         * * `important`: the content of the important statement,
	         *   if it is not just `!important`.
	         *
	         * PostCSS cleans declaration from comments and extra spaces,
	         * but it stores origin content in raws properties.
	         * As such, if you don’t change a declaration’s value,
	         * PostCSS will use the raw value with comments.
	         *
	         * @example
	         * const root = postcss.parse('a {\n  color:black\n}')
	         * root.first.first.raws //=> { before: '\n  ', between: ':' }
	         */
	
	    }]);
	
	    return Declaration;
	}(_node2.default);
	
	exports.default = Declaration;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _cssSyntaxError = __webpack_require__(459);
	
	var _cssSyntaxError2 = _interopRequireDefault(_cssSyntaxError);
	
	var _stringifier = __webpack_require__(463);
	
	var _stringifier2 = _interopRequireDefault(_stringifier);
	
	var _stringify = __webpack_require__(320);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _warnOnce = __webpack_require__(79);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var cloneNode = function cloneNode(obj, parent) {
	    var cloned = new obj.constructor();
	
	    for (var i in obj) {
	        if (!obj.hasOwnProperty(i)) continue;
	        var value = obj[i];
	        var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	
	        if (i === 'parent' && type === 'object') {
	            if (parent) cloned[i] = parent;
	        } else if (i === 'source') {
	            cloned[i] = value;
	        } else if (value instanceof Array) {
	            cloned[i] = value.map(function (j) {
	                return cloneNode(j, cloned);
	            });
	        } else if (i !== 'before' && i !== 'after' && i !== 'between' && i !== 'semicolon') {
	            if (type === 'object' && value !== null) value = cloneNode(value);
	            cloned[i] = value;
	        }
	    }
	
	    return cloned;
	};
	
	/**
	 * All node classes inherit the following common methods.
	 *
	 * @abstract
	 */
	
	var Node = function () {
	
	    /**
	     * @param {object} [defaults] - value for node properties
	     */
	    function Node() {
	        var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _classCallCheck(this, Node);
	
	        this.raws = {};
	        if ((typeof defaults === 'undefined' ? 'undefined' : _typeof(defaults)) !== 'object' && typeof defaults !== 'undefined') {
	            throw new Error('PostCSS nodes constructor accepts object, not ' + JSON.stringify(defaults));
	        }
	        for (var name in defaults) {
	            this[name] = defaults[name];
	        }
	    }
	
	    /**
	     * Returns a CssSyntaxError instance containing the original position
	     * of the node in the source, showing line and column numbers and also
	     * a small excerpt to facilitate debugging.
	     *
	     * If present, an input source map will be used to get the original position
	     * of the source, even from a previous compilation step
	     * (e.g., from Sass compilation).
	     *
	     * This method produces very useful error messages.
	     *
	     * @param {string} message     - error description
	     * @param {object} [opts]      - options
	     * @param {string} opts.plugin - plugin name that created this error.
	     *                               PostCSS will set it automatically.
	     * @param {string} opts.word   - a word inside a node’s string that should
	     *                               be highlighted as the source of the error
	     * @param {number} opts.index  - an index inside a node’s string that should
	     *                               be highlighted as the source of the error
	     *
	     * @return {CssSyntaxError} error object to throw it
	     *
	     * @example
	     * if ( !variables[name] ) {
	     *   throw decl.error('Unknown variable ' + name, { word: name });
	     *   // CssSyntaxError: postcss-vars:a.sass:4:3: Unknown variable $black
	     *   //   color: $black
	     *   // a
	     *   //          ^
	     *   //   background: white
	     * }
	     */
	
	
	    Node.prototype.error = function error(message) {
	        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (this.source) {
	            var pos = this.positionBy(opts);
	            return this.source.input.error(message, pos.line, pos.column, opts);
	        } else {
	            return new _cssSyntaxError2.default(message);
	        }
	    };
	
	    /**
	     * This method is provided as a convenience wrapper for {@link Result#warn}.
	     *
	     * @param {Result} result      - the {@link Result} instance
	     *                               that will receive the warning
	     * @param {string} text        - warning message
	     * @param {object} [opts]      - options
	     * @param {string} opts.plugin - plugin name that created this warning.
	     *                               PostCSS will set it automatically.
	     * @param {string} opts.word   - a word inside a node’s string that should
	     *                               be highlighted as the source of the warning
	     * @param {number} opts.index  - an index inside a node’s string that should
	     *                               be highlighted as the source of the warning
	     *
	     * @return {Warning} created warning object
	     *
	     * @example
	     * const plugin = postcss.plugin('postcss-deprecated', () => {
	     *   return (root, result) => {
	     *     root.walkDecls('bad', decl => {
	     *       decl.warn(result, 'Deprecated property bad');
	     *     });
	     *   };
	     * });
	     */
	
	
	    Node.prototype.warn = function warn(result, text, opts) {
	        var data = { node: this };
	        for (var i in opts) {
	            data[i] = opts[i];
	        }return result.warn(text, data);
	    };
	
	    /**
	     * Removes the node from its parent and cleans the parent properties
	     * from the node and its children.
	     *
	     * @example
	     * if ( decl.prop.match(/^-webkit-/) ) {
	     *   decl.remove();
	     * }
	     *
	     * @return {Node} node to make calls chain
	     */
	
	
	    Node.prototype.remove = function remove() {
	        if (this.parent) {
	            this.parent.removeChild(this);
	        }
	        this.parent = undefined;
	        return this;
	    };
	
	    /**
	     * Returns a CSS string representing the node.
	     *
	     * @param {stringifier|syntax} [stringifier] - a syntax to use
	     *                                             in string generation
	     *
	     * @return {string} CSS string of this node
	     *
	     * @example
	     * postcss.rule({ selector: 'a' }).toString() //=> "a {}"
	     */
	
	
	    Node.prototype.toString = function toString() {
	        var stringifier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _stringify2.default;
	
	        if (stringifier.stringify) stringifier = stringifier.stringify;
	        var result = '';
	        stringifier(this, function (i) {
	            result += i;
	        });
	        return result;
	    };
	
	    /**
	     * Returns a clone of the node.
	     *
	     * The resulting cloned node and its (cloned) children will have
	     * a clean parent and code style properties.
	     *
	     * @param {object} [overrides] - new properties to override in the clone.
	     *
	     * @example
	     * const cloned = decl.clone({ prop: '-moz-' + decl.prop });
	     * cloned.raws.before  //=> undefined
	     * cloned.parent       //=> undefined
	     * cloned.toString()   //=> -moz-transform: scale(0)
	     *
	     * @return {Node} clone of the node
	     */
	
	
	    Node.prototype.clone = function clone() {
	        var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        var cloned = cloneNode(this);
	        for (var name in overrides) {
	            cloned[name] = overrides[name];
	        }
	        return cloned;
	    };
	
	    /**
	     * Shortcut to clone the node and insert the resulting cloned node
	     * before the current node.
	     *
	     * @param {object} [overrides] - new properties to override in the clone.
	     *
	     * @example
	     * decl.cloneBefore({ prop: '-moz-' + decl.prop });
	     *
	     * @return {Node} - new node
	     */
	
	
	    Node.prototype.cloneBefore = function cloneBefore() {
	        var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        var cloned = this.clone(overrides);
	        this.parent.insertBefore(this, cloned);
	        return cloned;
	    };
	
	    /**
	     * Shortcut to clone the node and insert the resulting cloned node
	     * after the current node.
	     *
	     * @param {object} [overrides] - new properties to override in the clone.
	     *
	     * @return {Node} - new node
	     */
	
	
	    Node.prototype.cloneAfter = function cloneAfter() {
	        var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        var cloned = this.clone(overrides);
	        this.parent.insertAfter(this, cloned);
	        return cloned;
	    };
	
	    /**
	     * Inserts node(s) before the current node and removes the current node.
	     *
	     * @param {...Node} nodes - node(s) to replace current one
	     *
	     * @example
	     * if ( atrule.name == 'mixin' ) {
	     *   atrule.replaceWith(mixinRules[atrule.params]);
	     * }
	     *
	     * @return {Node} current node to methods chain
	     */
	
	
	    Node.prototype.replaceWith = function replaceWith() {
	        if (this.parent) {
	            for (var _len = arguments.length, nodes = Array(_len), _key = 0; _key < _len; _key++) {
	                nodes[_key] = arguments[_key];
	            }
	
	            for (var _iterator = nodes, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	                var _ref;
	
	                if (_isArray) {
	                    if (_i >= _iterator.length) break;
	                    _ref = _iterator[_i++];
	                } else {
	                    _i = _iterator.next();
	                    if (_i.done) break;
	                    _ref = _i.value;
	                }
	
	                var node = _ref;
	
	                this.parent.insertBefore(this, node);
	            }
	
	            this.remove();
	        }
	
	        return this;
	    };
	
	    /**
	     * Removes the node from its current parent and inserts it
	     * at the end of `newParent`.
	     *
	     * This will clean the `before` and `after` code {@link Node#raws} data
	     * from the node and replace them with the indentation style of `newParent`.
	     * It will also clean the `between` property
	     * if `newParent` is in another {@link Root}.
	     *
	     * @param {Container} newParent - container node where the current node
	     *                                will be moved
	     *
	     * @example
	     * atrule.moveTo(atrule.root());
	     *
	     * @return {Node} current node to methods chain
	     */
	
	
	    Node.prototype.moveTo = function moveTo(newParent) {
	        this.cleanRaws(this.root() === newParent.root());
	        this.remove();
	        newParent.append(this);
	        return this;
	    };
	
	    /**
	     * Removes the node from its current parent and inserts it into
	     * a new parent before `otherNode`.
	     *
	     * This will also clean the node’s code style properties just as it would
	     * in {@link Node#moveTo}.
	     *
	     * @param {Node} otherNode - node that will be before current node
	     *
	     * @return {Node} current node to methods chain
	     */
	
	
	    Node.prototype.moveBefore = function moveBefore(otherNode) {
	        this.cleanRaws(this.root() === otherNode.root());
	        this.remove();
	        otherNode.parent.insertBefore(otherNode, this);
	        return this;
	    };
	
	    /**
	     * Removes the node from its current parent and inserts it into
	     * a new parent after `otherNode`.
	     *
	     * This will also clean the node’s code style properties just as it would
	     * in {@link Node#moveTo}.
	     *
	     * @param {Node} otherNode - node that will be after current node
	     *
	     * @return {Node} current node to methods chain
	     */
	
	
	    Node.prototype.moveAfter = function moveAfter(otherNode) {
	        this.cleanRaws(this.root() === otherNode.root());
	        this.remove();
	        otherNode.parent.insertAfter(otherNode, this);
	        return this;
	    };
	
	    /**
	     * Returns the next child of the node’s parent.
	     * Returns `undefined` if the current node is the last child.
	     *
	     * @return {Node|undefined} next node
	     *
	     * @example
	     * if ( comment.text === 'delete next' ) {
	     *   const next = comment.next();
	     *   if ( next ) {
	     *     next.remove();
	     *   }
	     * }
	     */
	
	
	    Node.prototype.next = function next() {
	        var index = this.parent.index(this);
	        return this.parent.nodes[index + 1];
	    };
	
	    /**
	     * Returns the previous child of the node’s parent.
	     * Returns `undefined` if the current node is the first child.
	     *
	     * @return {Node|undefined} previous node
	     *
	     * @example
	     * const annotation = decl.prev();
	     * if ( annotation.type == 'comment' ) {
	     *  readAnnotation(annotation.text);
	     * }
	     */
	
	
	    Node.prototype.prev = function prev() {
	        var index = this.parent.index(this);
	        return this.parent.nodes[index - 1];
	    };
	
	    Node.prototype.toJSON = function toJSON() {
	        var fixed = {};
	
	        for (var name in this) {
	            if (!this.hasOwnProperty(name)) continue;
	            if (name === 'parent') continue;
	            var value = this[name];
	
	            if (value instanceof Array) {
	                fixed[name] = value.map(function (i) {
	                    if ((typeof i === 'undefined' ? 'undefined' : _typeof(i)) === 'object' && i.toJSON) {
	                        return i.toJSON();
	                    } else {
	                        return i;
	                    }
	                });
	            } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value.toJSON) {
	                fixed[name] = value.toJSON();
	            } else {
	                fixed[name] = value;
	            }
	        }
	
	        return fixed;
	    };
	
	    /**
	     * Returns a {@link Node#raws} value. If the node is missing
	     * the code style property (because the node was manually built or cloned),
	     * PostCSS will try to autodetect the code style property by looking
	     * at other nodes in the tree.
	     *
	     * @param {string} prop          - name of code style property
	     * @param {string} [defaultType] - name of default value, it can be missed
	     *                                 if the value is the same as prop
	     *
	     * @example
	     * const root = postcss.parse('a { background: white }');
	     * root.nodes[0].append({ prop: 'color', value: 'black' });
	     * root.nodes[0].nodes[1].raws.before   //=> undefined
	     * root.nodes[0].nodes[1].raw('before') //=> ' '
	     *
	     * @return {string} code style value
	     */
	
	
	    Node.prototype.raw = function raw(prop, defaultType) {
	        var str = new _stringifier2.default();
	        return str.raw(this, prop, defaultType);
	    };
	
	    /**
	     * Finds the Root instance of the node’s tree.
	     *
	     * @example
	     * root.nodes[0].nodes[0].root() === root
	     *
	     * @return {Root} root parent
	     */
	
	
	    Node.prototype.root = function root() {
	        var result = this;
	        while (result.parent) {
	            result = result.parent;
	        }return result;
	    };
	
	    Node.prototype.cleanRaws = function cleanRaws(keepBetween) {
	        delete this.raws.before;
	        delete this.raws.after;
	        if (!keepBetween) delete this.raws.between;
	    };
	
	    Node.prototype.positionInside = function positionInside(index) {
	        var string = this.toString();
	        var column = this.source.start.column;
	        var line = this.source.start.line;
	
	        for (var i = 0; i < index; i++) {
	            if (string[i] === '\n') {
	                column = 1;
	                line += 1;
	            } else {
	                column += 1;
	            }
	        }
	
	        return { line: line, column: column };
	    };
	
	    Node.prototype.positionBy = function positionBy(opts) {
	        var pos = this.source.start;
	        if (opts.index) {
	            pos = this.positionInside(opts.index);
	        } else if (opts.word) {
	            var index = this.toString().indexOf(opts.word);
	            if (index !== -1) pos = this.positionInside(index);
	        }
	        return pos;
	    };
	
	    Node.prototype.removeSelf = function removeSelf() {
	        (0, _warnOnce2.default)('Node#removeSelf is deprecated. Use Node#remove.');
	        return this.remove();
	    };
	
	    Node.prototype.replace = function replace(nodes) {
	        (0, _warnOnce2.default)('Node#replace is deprecated. Use Node#replaceWith');
	        return this.replaceWith(nodes);
	    };
	
	    Node.prototype.style = function style(own, detect) {
	        (0, _warnOnce2.default)('Node#style() is deprecated. Use Node#raw()');
	        return this.raw(own, detect);
	    };
	
	    Node.prototype.cleanStyles = function cleanStyles(keepBetween) {
	        (0, _warnOnce2.default)('Node#cleanStyles() is deprecated. Use Node#cleanRaws()');
	        return this.cleanRaws(keepBetween);
	    };
	
	    _createClass(Node, [{
	        key: 'before',
	        get: function get() {
	            (0, _warnOnce2.default)('Node#before is deprecated. Use Node#raws.before');
	            return this.raws.before;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Node#before is deprecated. Use Node#raws.before');
	            this.raws.before = val;
	        }
	    }, {
	        key: 'between',
	        get: function get() {
	            (0, _warnOnce2.default)('Node#between is deprecated. Use Node#raws.between');
	            return this.raws.between;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Node#between is deprecated. Use Node#raws.between');
	            this.raws.between = val;
	        }
	
	        /**
	         * @memberof Node#
	         * @member {string} type - String representing the node’s type.
	         *                         Possible values are `root`, `atrule`, `rule`,
	         *                         `decl`, or `comment`.
	         *
	         * @example
	         * postcss.decl({ prop: 'color', value: 'black' }).type //=> 'decl'
	         */
	
	        /**
	         * @memberof Node#
	         * @member {Container} parent - the node’s parent node.
	         *
	         * @example
	         * root.nodes[0].parent == root;
	         */
	
	        /**
	         * @memberof Node#
	         * @member {source} source - the input source of the node
	         *
	         * The property is used in source map generation.
	         *
	         * If you create a node manually (e.g., with `postcss.decl()`),
	         * that node will not have a `source` property and will be absent
	         * from the source map. For this reason, the plugin developer should
	         * consider cloning nodes to create new ones (in which case the new node’s
	         * source will reference the original, cloned node) or setting
	         * the `source` property manually.
	         *
	         * ```js
	         * // Bad
	         * const prefixed = postcss.decl({
	         *   prop: '-moz-' + decl.prop,
	         *   value: decl.value
	         * });
	         *
	         * // Good
	         * const prefixed = decl.clone({ prop: '-moz-' + decl.prop });
	         * ```
	         *
	         * ```js
	         * if ( atrule.name == 'add-link' ) {
	         *   const rule = postcss.rule({ selector: 'a', source: atrule.source });
	         *   atrule.parent.insertBefore(atrule, rule);
	         * }
	         * ```
	         *
	         * @example
	         * decl.source.input.from //=> '/home/ai/a.sass'
	         * decl.source.start      //=> { line: 10, column: 2 }
	         * decl.source.end        //=> { line: 10, column: 12 }
	         */
	
	        /**
	         * @memberof Node#
	         * @member {object} raws - Information to generate byte-to-byte equal
	         *                         node string as it was in the origin input.
	         *
	         * Every parser saves its own properties,
	         * but the default CSS parser uses:
	         *
	         * * `before`: the space symbols before the node. It also stores `*`
	         *   and `_` symbols before the declaration (IE hack).
	         * * `after`: the space symbols after the last child of the node
	         *   to the end of the node.
	         * * `between`: the symbols between the property and value
	         *   for declarations, selector and `{` for rules, or last parameter
	         *   and `{` for at-rules.
	         * * `semicolon`: contains true if the last child has
	         *   an (optional) semicolon.
	         * * `afterName`: the space between the at-rule name and its parameters.
	         * * `left`: the space symbols between `/*` and the comment’s text.
	         * * `right`: the space symbols between the comment’s text
	         *   and <code>*&#47;</code>.
	         * * `important`: the content of the important statement,
	         *   if it is not just `!important`.
	         *
	         * PostCSS cleans selectors, declaration values and at-rule parameters
	         * from comments and extra spaces, but it stores origin content in raws
	         * properties. As such, if you don’t change a declaration’s value,
	         * PostCSS will use the raw value with comments.
	         *
	         * @example
	         * const root = postcss.parse('a {\n  color:black\n}')
	         * root.first.first.raws //=> { before: '\n  ', between: ':' }
	         */
	
	    }]);
	
	    return Node;
	}();
	
	exports.default = Node;
	
	/**
	 * @typedef {object} position
	 * @property {number} line   - source line in file
	 * @property {number} column - source column in file
	 */
	
	/**
	 * @typedef {object} source
	 * @property {Input} input    - {@link Input} with input file
	 * @property {position} start - The starting position of the node’s source
	 * @property {position} end   - The ending position of the node’s source
	 */
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = parse;
	
	var _parser = __webpack_require__(1482);
	
	var _parser2 = _interopRequireDefault(_parser);
	
	var _input = __webpack_require__(460);
	
	var _input2 = _interopRequireDefault(_input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function parse(css, opts) {
	    if (opts && opts.safe) {
	        throw new Error('Option safe was removed. ' + 'Use parser: require("postcss-safe-parser")');
	    }
	
	    var input = new _input2.default(css, opts);
	
	    var parser = new _parser2.default(input);
	    try {
	        parser.tokenize();
	        parser.loop();
	    } catch (e) {
	        if (e.name === 'CssSyntaxError' && opts && opts.from) {
	            if (/\.scss$/i.test(opts.from)) {
	                e.message += '\nYou tried to parse SCSS with ' + 'the standard CSS parser; ' + 'try again with the postcss-scss parser';
	            } else if (/\.sass/i.test(opts.from)) {
	                e.message += '\nYou tried to parse Sass with ' + 'the standard CSS parser; ' + 'try again with the postcss-sass parser';
	            } else if (/\.less$/i.test(opts.from)) {
	                e.message += '\nYou tried to parse Less with ' + 'the standard CSS parser; ' + 'try again with the postcss-less parser';
	            }
	        }
	        throw e;
	    }
	
	    return parser.root;
	}
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _container = __webpack_require__(315);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _warnOnce = __webpack_require__(79);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Represents a CSS file and contains all its parsed nodes.
	 *
	 * @extends Container
	 *
	 * @example
	 * const root = postcss.parse('a{color:black} b{z-index:2}');
	 * root.type         //=> 'root'
	 * root.nodes.length //=> 2
	 */
	var Root = function (_Container) {
	    _inherits(Root, _Container);
	
	    function Root(defaults) {
	        _classCallCheck(this, Root);
	
	        var _this = _possibleConstructorReturn(this, _Container.call(this, defaults));
	
	        _this.type = 'root';
	        if (!_this.nodes) _this.nodes = [];
	        return _this;
	    }
	
	    Root.prototype.removeChild = function removeChild(child) {
	        child = this.index(child);
	
	        if (child === 0 && this.nodes.length > 1) {
	            this.nodes[1].raws.before = this.nodes[child].raws.before;
	        }
	
	        return _Container.prototype.removeChild.call(this, child);
	    };
	
	    Root.prototype.normalize = function normalize(child, sample, type) {
	        var nodes = _Container.prototype.normalize.call(this, child);
	
	        if (sample) {
	            if (type === 'prepend') {
	                if (this.nodes.length > 1) {
	                    sample.raws.before = this.nodes[1].raws.before;
	                } else {
	                    delete sample.raws.before;
	                }
	            } else if (this.first !== sample) {
	                for (var _iterator = nodes, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	                    var _ref;
	
	                    if (_isArray) {
	                        if (_i >= _iterator.length) break;
	                        _ref = _iterator[_i++];
	                    } else {
	                        _i = _iterator.next();
	                        if (_i.done) break;
	                        _ref = _i.value;
	                    }
	
	                    var node = _ref;
	
	                    node.raws.before = sample.raws.before;
	                }
	            }
	        }
	
	        return nodes;
	    };
	
	    /**
	     * Returns a {@link Result} instance representing the root’s CSS.
	     *
	     * @param {processOptions} [opts] - options with only `to` and `map` keys
	     *
	     * @return {Result} result with current root’s CSS
	     *
	     * @example
	     * const root1 = postcss.parse(css1, { from: 'a.css' });
	     * const root2 = postcss.parse(css2, { from: 'b.css' });
	     * root1.append(root2);
	     * const result = root1.toResult({ to: 'all.css', map: true });
	     */
	
	
	    Root.prototype.toResult = function toResult() {
	        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        var LazyResult = __webpack_require__(461);
	        var Processor = __webpack_require__(462);
	
	        var lazy = new LazyResult(new Processor(), this, opts);
	        return lazy.stringify();
	    };
	
	    Root.prototype.remove = function remove(child) {
	        (0, _warnOnce2.default)('Root#remove is deprecated. Use Root#removeChild');
	        this.removeChild(child);
	    };
	
	    Root.prototype.prevMap = function prevMap() {
	        (0, _warnOnce2.default)('Root#prevMap is deprecated. Use Root#source.input.map');
	        return this.source.input.map;
	    };
	
	    /**
	     * @memberof Root#
	     * @member {object} raws - Information to generate byte-to-byte equal
	     *                         node string as it was in the origin input.
	     *
	     * Every parser saves its own properties,
	     * but the default CSS parser uses:
	     *
	     * * `after`: the space symbols after the last child to the end of file.
	     * * `semicolon`: is the last child has an (optional) semicolon.
	     *
	     * @example
	     * postcss.parse('a {}\n').raws //=> { after: '\n' }
	     * postcss.parse('a {}').raws   //=> { after: '' }
	     */
	
	    return Root;
	}(_container2.default);
	
	exports.default = Root;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = stringify;
	
	var _stringifier = __webpack_require__(463);
	
	var _stringifier2 = _interopRequireDefault(_stringifier);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function stringify(node, builder) {
	    var str = new _stringifier2.default(builder);
	    str.stringify(node);
	}
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0cmluZ2lmeS5lczYiXSwibmFtZXMiOlsic3RyaW5naWZ5Iiwibm9kZSIsImJ1aWxkZXIiLCJzdHIiXSwibWFwcGluZ3MiOiI7OztrQkFFd0JBLFM7O0FBRnhCOzs7Ozs7QUFFZSxTQUFTQSxTQUFULENBQW1CQyxJQUFuQixFQUF5QkMsT0FBekIsRUFBa0M7QUFDN0MsUUFBSUMsTUFBTSwwQkFBZ0JELE9BQWhCLENBQVY7QUFDQUMsUUFBSUgsU0FBSixDQUFjQyxJQUFkO0FBQ0giLCJmaWxlIjoic3RyaW5naWZ5LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFN0cmluZ2lmaWVyIGZyb20gJy4vc3RyaW5naWZpZXInO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBzdHJpbmdpZnkobm9kZSwgYnVpbGRlcikge1xuICAgIGxldCBzdHIgPSBuZXcgU3RyaW5naWZpZXIoYnVpbGRlcik7XG4gICAgc3RyLnN0cmluZ2lmeShub2RlKTtcbn1cbiJdfQ==


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _style = __webpack_require__(203);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(520);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _capitalize = __webpack_require__(486);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _createChainedFunction = __webpack_require__(34);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MARGINS = {
	  height: ['marginTop', 'marginBottom'],
	  width: ['marginLeft', 'marginRight']
	};
	
	// reading a dimension prop will cause the browser to recalculate,
	// which will let our animations work
	function triggerBrowserReflow(node) {
	  node.offsetHeight; // eslint-disable-line no-unused-expressions
	}
	
	function getDimensionValue(dimension, elem) {
	  var value = elem['offset' + (0, _capitalize2['default'])(dimension)];
	  var margins = MARGINS[dimension];
	
	  return value + parseInt((0, _style2['default'])(elem, margins[0]), 10) + parseInt((0, _style2['default'])(elem, margins[1]), 10);
	}
	
	var propTypes = {
	  /**
	   * Show the component; triggers the expand or collapse animation
	   */
	  'in': _propTypes2['default'].bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is collapsed
	   */
	  unmountOnExit: _propTypes2['default'].bool,
	
	  /**
	   * Run the expand animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2['default'].bool,
	
	  /**
	   * Duration of the collapse animation in milliseconds, to ensure that
	   * finishing callbacks are fired even if the original browser transition end
	   * events are canceled
	   */
	  timeout: _propTypes2['default'].number,
	
	  /**
	   * Callback fired before the component expands
	   */
	  onEnter: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to expand
	   */
	  onEntering: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component has expanded
	   */
	  onEntered: _propTypes2['default'].func,
	  /**
	   * Callback fired before the component collapses
	   */
	  onExit: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to collapse
	   */
	  onExiting: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component has collapsed
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * The dimension used when collapsing, or a function that returns the
	   * dimension
	   *
	   * _Note: Bootstrap only partially supports 'width'!
	   * You will need to supply your own CSS animation for the `.width` CSS class._
	   */
	  dimension: _propTypes2['default'].oneOfType([_propTypes2['default'].oneOf(['height', 'width']), _propTypes2['default'].func]),
	
	  /**
	   * Function that returns the height or width of the animating DOM node
	   *
	   * Allows for providing some custom logic for how much the Collapse component
	   * should animate in its specified dimension. Called with the current
	   * dimension prop value and the DOM node.
	   */
	  getDimensionValue: _propTypes2['default'].func,
	
	  /**
	   * ARIA role of collapsible element
	   */
	  role: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  'in': false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  dimension: 'height',
	  getDimensionValue: getDimensionValue
	};
	
	var Collapse = function (_React$Component) {
	  (0, _inherits3['default'])(Collapse, _React$Component);
	
	  function Collapse(props, context) {
	    (0, _classCallCheck3['default'])(this, Collapse);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleEntered = _this.handleEntered.bind(_this);
	    _this.handleExit = _this.handleExit.bind(_this);
	    _this.handleExiting = _this.handleExiting.bind(_this);
	    return _this;
	  }
	
	  /* -- Expanding -- */
	
	
	  Collapse.prototype.handleEnter = function handleEnter(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype.handleEntering = function handleEntering(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this._getScrollDimensionValue(elem, dimension);
	  };
	
	  Collapse.prototype.handleEntered = function handleEntered(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = null;
	  };
	
	  /* -- Collapsing -- */
	
	
	  Collapse.prototype.handleExit = function handleExit(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this.props.getDimensionValue(dimension, elem) + 'px';
	    triggerBrowserReflow(elem);
	  };
	
	  Collapse.prototype.handleExiting = function handleExiting(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype._dimension = function _dimension() {
	    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
	  };
	
	  // for testing
	
	
	  Collapse.prototype._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
	    return elem['scroll' + (0, _capitalize2['default'])(dimension)] + 'px';
	  };
	
	  Collapse.prototype.render = function render() {
	    var _props = this.props,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'className']);
	
	
	    delete props.dimension;
	    delete props.getDimensionValue;
	
	    var handleEnter = (0, _createChainedFunction2['default'])(this.handleEnter, onEnter);
	    var handleEntering = (0, _createChainedFunction2['default'])(this.handleEntering, onEntering);
	    var handleEntered = (0, _createChainedFunction2['default'])(this.handleEntered, onEntered);
	    var handleExit = (0, _createChainedFunction2['default'])(this.handleExit, onExit);
	    var handleExiting = (0, _createChainedFunction2['default'])(this.handleExiting, onExiting);
	
	    var classes = {
	      width: this._dimension() === 'width'
	    };
	
	    return _react2['default'].createElement(_Transition2['default'], (0, _extends3['default'])({}, props, {
	      'aria-expanded': props.role ? props['in'] : null,
	      className: (0, _classnames2['default'])(className, classes),
	      exitedClassName: 'collapse',
	      exitingClassName: 'collapsing',
	      enteredClassName: 'collapse in',
	      enteringClassName: 'collapsing',
	      onEnter: handleEnter,
	      onEntering: handleEntering,
	      onEntered: handleEntered,
	      onExit: handleExit,
	      onExiting: handleExiting
	    }));
	  };
	
	  return Collapse;
	}(_react2['default'].Component);
	
	Collapse.propTypes = propTypes;
	Collapse.defaultProps = defaultProps;
	
	exports['default'] = Collapse;
	module.exports = exports['default'];

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
	   */
	  glyph: _propTypes2['default'].string.isRequired
	};
	
	var Glyphicon = function (_React$Component) {
	  (0, _inherits3['default'])(Glyphicon, _React$Component);
	
	  function Glyphicon() {
	    (0, _classCallCheck3['default'])(this, Glyphicon);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Glyphicon.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        glyph = _props.glyph,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['glyph', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, glyph)] = true, _extends2));
	
	    return _react2['default'].createElement('span', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Glyphicon;
	}(_react2['default'].Component);
	
	Glyphicon.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('glyphicon', Glyphicon);
	module.exports = exports['default'];

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _MediaBody = __webpack_require__(1518);
	
	var _MediaBody2 = _interopRequireDefault(_MediaBody);
	
	var _MediaHeading = __webpack_require__(1519);
	
	var _MediaHeading2 = _interopRequireDefault(_MediaHeading);
	
	var _MediaLeft = __webpack_require__(1520);
	
	var _MediaLeft2 = _interopRequireDefault(_MediaLeft);
	
	var _MediaList = __webpack_require__(1521);
	
	var _MediaList2 = _interopRequireDefault(_MediaList);
	
	var _MediaListItem = __webpack_require__(1522);
	
	var _MediaListItem2 = _interopRequireDefault(_MediaListItem);
	
	var _MediaRight = __webpack_require__(1523);
	
	var _MediaRight2 = _interopRequireDefault(_MediaRight);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Media = function (_React$Component) {
	  (0, _inherits3['default'])(Media, _React$Component);
	
	  function Media() {
	    (0, _classCallCheck3['default'])(this, Media);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Media.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Media;
	}(_react2['default'].Component);
	
	Media.propTypes = propTypes;
	Media.defaultProps = defaultProps;
	
	Media.Heading = _MediaHeading2['default'];
	Media.Body = _MediaBody2['default'];
	Media.Left = _MediaLeft2['default'];
	Media.Right = _MediaRight2['default'];
	Media.List = _MediaList2['default'];
	Media.ListItem = _MediaListItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media', Media);
	module.exports = exports['default'];

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uncontrollable = __webpack_require__(233);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TAB = 'tab';
	var PANE = 'pane';
	
	var idPropType = _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]);
	
	var propTypes = {
	  /**
	   * HTML id attribute, required if no `generateChildId` prop
	   * is specified.
	   */
	  id: function id(props) {
	    var error = null;
	
	    if (!props.generateChildId) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      error = idPropType.apply(undefined, [props].concat(args));
	
	      if (!error && !props.id) {
	        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
	      }
	    }
	
	    return error;
	  },
	
	
	  /**
	   * A function that takes an `eventKey` and `type` and returns a unique id for
	   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
	   * function, meaning it should always return the _same_ id for the same set
	   * of inputs. The default value requires that an `id` to be set for the
	   * `<TabContainer>`.
	   *
	   * The `type` argument will either be `"tab"` or `"pane"`.
	   *
	   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
	   */
	  generateChildId: _propTypes2['default'].func,
	
	  /**
	   * A callback fired when a tab is selected.
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * The `eventKey` of the currently active tab.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2['default'].any
	};
	
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2['default'].shape({
	    activeKey: _propTypes2['default'].any,
	    onSelect: _propTypes2['default'].func.isRequired,
	    getTabId: _propTypes2['default'].func.isRequired,
	    getPaneId: _propTypes2['default'].func.isRequired
	  })
	};
	
	var TabContainer = function (_React$Component) {
	  (0, _inherits3['default'])(TabContainer, _React$Component);
	
	  function TabContainer() {
	    (0, _classCallCheck3['default'])(this, TabContainer);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  TabContainer.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        activeKey = _props.activeKey,
	        onSelect = _props.onSelect,
	        generateChildId = _props.generateChildId,
	        id = _props.id;
	
	
	    var getId = generateChildId || function (key, type) {
	      return id ? id + '-' + type + '-' + key : null;
	    };
	
	    return {
	      $bs_tabContainer: {
	        activeKey: activeKey,
	        onSelect: onSelect,
	        getTabId: function getTabId(key) {
	          return getId(key, TAB);
	        },
	        getPaneId: function getPaneId(key) {
	          return getId(key, PANE);
	        }
	      }
	    };
	  };
	
	  TabContainer.prototype.render = function render() {
	    var _props2 = this.props,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['children']);
	
	
	    delete props.generateChildId;
	    delete props.onSelect;
	    delete props.activeKey;
	
	    return _react2['default'].cloneElement(_react2['default'].Children.only(children), props);
	  };
	
	  return TabContainer;
	}(_react2['default'].Component);
	
	TabContainer.propTypes = propTypes;
	TabContainer.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _uncontrollable2['default'])(TabContainer, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * Sets a default animation strategy for all children `<TabPane>`s. Use
	   * `false` to disable, `true` to enable the default `<Fade>` animation or any
	   * `<Transition>` component.
	   */
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when they are no longer visible
	   */
	  unmountOnExit: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2['default'].shape({
	    activeKey: _propTypes2['default'].any
	  })
	};
	
	var childContextTypes = {
	  $bs_tabContent: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	    activeKey: _propTypes2['default'].any,
	    mountOnEnter: _propTypes2['default'].bool,
	    unmountOnExit: _propTypes2['default'].bool,
	    onPaneEnter: _propTypes2['default'].func.isRequired,
	    onPaneExited: _propTypes2['default'].func.isRequired,
	    exiting: _propTypes2['default'].bool.isRequired
	  })
	};
	
	var TabContent = function (_React$Component) {
	  (0, _inherits3['default'])(TabContent, _React$Component);
	
	  function TabContent(props, context) {
	    (0, _classCallCheck3['default'])(this, TabContent);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handlePaneEnter = _this.handlePaneEnter.bind(_this);
	    _this.handlePaneExited = _this.handlePaneExited.bind(_this);
	
	    // Active entries in state will be `null` unless `animation` is set. Need
	    // to track active child in case keys swap and the active child changes
	    // but the active key does not.
	    _this.state = {
	      activeKey: null,
	      activeChild: null
	    };
	    return _this;
	  }
	
	  TabContent.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit;
	
	
	    var stateActiveKey = this.state.activeKey;
	    var containerActiveKey = this.getContainerActiveKey();
	
	    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
	    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;
	
	    return {
	      $bs_tabContent: {
	        bsClass: bsClass,
	        animation: animation,
	        activeKey: activeKey,
	        mountOnEnter: mountOnEnter,
	        unmountOnExit: unmountOnExit,
	        onPaneEnter: this.handlePaneEnter,
	        onPaneExited: this.handlePaneExited,
	        exiting: exiting
	      }
	    };
	  };
	
	  TabContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (!nextProps.animation && this.state.activeChild) {
	      this.setState({ activeKey: null, activeChild: null });
	    }
	  };
	
	  TabContent.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  TabContent.prototype.handlePaneEnter = function handlePaneEnter(child, childKey) {
	    if (!this.props.animation) {
	      return false;
	    }
	
	    // It's possible that this child should be transitioning out.
	    if (childKey !== this.getContainerActiveKey()) {
	      return false;
	    }
	
	    this.setState({
	      activeKey: childKey,
	      activeChild: child
	    });
	
	    return true;
	  };
	
	  TabContent.prototype.handlePaneExited = function handlePaneExited(child) {
	    // This might happen as everything is unmounting.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState(function (_ref) {
	      var activeChild = _ref.activeChild;
	
	      if (activeChild !== child) {
	        return null;
	      }
	
	      return {
	        activeKey: null,
	        activeChild: null
	      };
	    });
	  };
	
	  TabContent.prototype.getContainerActiveKey = function getContainerActiveKey() {
	    var tabContainer = this.context.$bs_tabContainer;
	    return tabContainer && tabContainer.activeKey;
	  };
	
	  TabContent.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        className = _props2.className,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'className']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'content'))
	    }));
	  };
	
	  return TabContent;
	}(_react2['default'].Component);
	
	TabContent.propTypes = propTypes;
	TabContent.defaultProps = defaultProps;
	TabContent.contextTypes = contextTypes;
	TabContent.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tab', TabContent);
	module.exports = exports['default'];

/***/ },
/* 326 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FILE = exports.FILE = '__NATIVE_FILE__';
	var URL = exports.URL = '__NATIVE_URL__';
	var TEXT = exports.TEXT = '__NATIVE_TEXT__';

/***/ },
/* 327 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = shallowEqual;
	function shallowEqual(objA, objB) {
		if (objA === objB) {
			return true;
		}
	
		var keysA = Object.keys(objA);
		var keysB = Object.keys(objB);
	
		if (keysA.length !== keysB.length) {
			return false;
		}
	
		// Test for A's keys different from B.
		var hasOwn = Object.prototype.hasOwnProperty;
		for (var i = 0; i < keysA.length; i += 1) {
			if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
				return false;
			}
	
			var valA = objA[keysA[i]];
			var valB = objB[keysA[i]];
	
			if (valA !== valB) {
				return false;
			}
		}
	
		return true;
	}

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(131);
	var Danger = __webpack_require__(1581);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactInstrumentation = __webpack_require__(59);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(337);
	var setInnerHTML = __webpack_require__(225);
	var setTextContent = __webpack_require__(514);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 329 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var ReactErrorUtils = __webpack_require__(335);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(20);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 332 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var ReactPropTypesSecret = __webpack_require__(1610);
	var propTypesFactory = __webpack_require__(465);
	
	var React = __webpack_require__(135);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(20);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var invariant = __webpack_require__(12);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var ReactCurrentOwner = __webpack_require__(81);
	var ReactInstanceMap = __webpack_require__(173);
	var ReactInstrumentation = __webpack_require__(59);
	var ReactUpdates = __webpack_require__(70);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(20);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 337 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 338 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 339 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 340 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(40);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 342 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(31);
	
	var emptyFunction = __webpack_require__(66);
	var warning = __webpack_require__(20);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getContainer;
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	module.exports = exports['default'];

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(228);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;
	
	var _reducer = __webpack_require__(528);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(527);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _sync = __webpack_require__(1656);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _middleware = __webpack_require__(1655);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.syncHistoryWithStore = _sync2['default'];
	exports.routerMiddleware = _middleware2['default'];

/***/ },
/* 347 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(1);
	
	var _deprecateObjectProperties = __webpack_require__(230);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _InternalPropTypes = __webpack_require__(113);
	
	var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);
	
	var _routerWarning = __webpack_require__(35);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	// Deprecated stuff below:
	
	var falsy = exports.falsy = InternalPropTypes.falsy;
	var history = exports.history = InternalPropTypes.history;
	var location = exports.location = locationShape;
	var component = exports.component = InternalPropTypes.component;
	var components = exports.components = InternalPropTypes.components;
	var route = exports.route = InternalPropTypes.route;
	var routes = exports.routes = InternalPropTypes.routes;
	var router = exports.router = routerShape;
	
	if (false) {
	  (function () {
	    var deprecatePropType = function deprecatePropType(propType, message) {
	      return function () {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	        return propType.apply(undefined, arguments);
	      };
	    };
	
	    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
	      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
	    };
	
	    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
	      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
	    };
	
	    exports.falsy = falsy = deprecateInternalPropType(falsy);
	    exports.history = history = deprecateInternalPropType(history);
	    exports.component = component = deprecateInternalPropType(component);
	    exports.components = components = deprecateInternalPropType(components);
	    exports.route = route = deprecateInternalPropType(route);
	    exports.routes = routes = deprecateInternalPropType(routes);
	
	    exports.location = location = deprecateRenamedPropType(location, 'location');
	    exports.router = router = deprecateRenamedPropType(router, 'router');
	  })();
	}
	
	var defaultExport = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route,
	  // For some reason, routes was never here.
	  router: router
	};
	
	if (false) {
	  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
	}
	
	exports.default = defaultExport;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(35);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(1669);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(1666);
	
	var _isActive2 = __webpack_require__(1673);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(1670);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(1675);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = void 0;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var changeRoutes = _computeChangedRoutes.changeRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	
	module.exports = exports['default'];

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buffers = exports.BUFFER_OVERFLOW = undefined;
	
	var _utils = __webpack_require__(82);
	
	var BUFFER_OVERFLOW = exports.BUFFER_OVERFLOW = 'Channel\'s Buffer overflow!';
	
	var ON_OVERFLOW_THROW = 1;
	var ON_OVERFLOW_DROP = 2;
	var ON_OVERFLOW_SLIDE = 3;
	
	var zeroBuffer = { isEmpty: _utils.kTrue, put: _utils.noop, take: _utils.noop };
	
	/**
	  TODO: Need to make a more optimized implementation: e.g. Ring buffers, linked lists with Node Object pooling...
	**/
	function arrBuffer() {
	  var limit = arguments.length <= 0 || arguments[0] === undefined ? Infinity : arguments[0];
	  var overflowAction = arguments[1];
	
	  var arr = [];
	  return {
	    isEmpty: function isEmpty() {
	      return !arr.length;
	    },
	    put: function put(it) {
	      if (arr.length < limit) {
	        arr.push(it);
	      } else {
	        switch (overflowAction) {
	          case ON_OVERFLOW_THROW:
	            throw new Error(BUFFER_OVERFLOW);
	          case ON_OVERFLOW_SLIDE:
	            arr.shift();
	            arr.push(it);
	            break;
	          default:
	          // DROP
	        }
	      }
	    },
	    take: function take() {
	      return arr.shift();
	    }
	  };
	}
	
	var buffers = exports.buffers = {
	  none: function none() {
	    return zeroBuffer;
	  },
	  fixed: function fixed(limit) {
	    return arrBuffer(limit, ON_OVERFLOW_THROW);
	  },
	  dropping: function dropping(limit) {
	    return arrBuffer(limit, ON_OVERFLOW_DROP);
	  },
	  sliding: function sliding(limit) {
	    return arrBuffer(limit, ON_OVERFLOW_SLIDE);
	  }
	};

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(78);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(1720);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 352 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function () {
		return /[\u001b\u009b][[()#;?]*(?:[0-9]{1,4}(?:;[0-9]{0,4})*)?[0-9A-PRZcf-nqry=><]/g;
	};


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Browsers, Prefixes, browserslist, cache, isPlainObject, postcss, timeCapsule,
	    slice = [].slice;
	
	  browserslist = __webpack_require__(240);
	
	  postcss = __webpack_require__(169);
	
	  Browsers = __webpack_require__(116);
	
	  Prefixes = __webpack_require__(602);
	
	  isPlainObject = function(obj) {
	    return Object.prototype.toString.apply(obj) === '[object Object]';
	  };
	
	  cache = {};
	
	  timeCapsule = function(result, prefixes) {
	    if (prefixes.browsers.selected.length === 0) {
	      return;
	    }
	    if (prefixes.add.selectors.length > 0) {
	      return;
	    }
	    if (Object.keys(prefixes.add).length > 2) {
	      return;
	    }
	    return result.warn('Greetings, time traveller. ' + 'We are in the golden age of prefix-less CSS, ' + 'where Autoprefixer is no longer needed for your stylesheet.');
	  };
	
	  module.exports = postcss.plugin('autoprefixer', function() {
	    var loadPrefixes, options, plugin, reqs;
	    reqs = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    if (reqs.length === 1 && isPlainObject(reqs[0])) {
	      options = reqs[0];
	      reqs = void 0;
	    } else if (reqs.length === 0 || (reqs.length === 1 && (reqs[0] == null))) {
	      reqs = void 0;
	    } else if (reqs.length <= 2 && (reqs[0] instanceof Array || (reqs[0] == null))) {
	      options = reqs[1];
	      reqs = reqs[0];
	    } else if (typeof reqs[reqs.length - 1] === 'object') {
	      options = reqs.pop();
	    }
	    options || (options = {});
	    if (options.browser) {
	      throw new Error('Change `browser` option to `browsers` in Autoprefixer');
	    }
	    if (options.browsers != null) {
	      reqs = options.browsers;
	    }
	    loadPrefixes = function(opts) {
	      var browsers, key, stats;
	      stats = options.stats;
	      browsers = new Browsers(module.exports.data.browsers, reqs, opts, stats);
	      key = browsers.selected.join(', ') + JSON.stringify(options);
	      return cache[key] || (cache[key] = new Prefixes(module.exports.data.prefixes, browsers, options));
	    };
	    plugin = function(css, result) {
	      var prefixes, ref;
	      prefixes = loadPrefixes({
	        from: (ref = css.source) != null ? ref.input.file : void 0,
	        env: options.env
	      });
	      timeCapsule(result, prefixes);
	      if (options.remove !== false) {
	        prefixes.processor.remove(css);
	      }
	      if (options.add !== false) {
	        return prefixes.processor.add(css, result);
	      }
	    };
	    plugin.options = options;
	    plugin.info = function(opts) {
	      return __webpack_require__(600)(loadPrefixes(opts));
	    };
	    return plugin;
	  });
	
	  module.exports.data = {
	    browsers: __webpack_require__(292).agents,
	    prefixes: __webpack_require__(557)
	  };
	
	  module.exports.defaults = browserslist.defaults;
	
	  module.exports.info = function() {
	    return module.exports().info();
	  };
	
	}).call(this);


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Card = __webpack_require__(93);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CardWrapper = (_temp = _class = function (_React$Component) {
	  _inherits(CardWrapper, _React$Component);
	
	  function CardWrapper() {
	    _classCallCheck(this, CardWrapper);
	
	    return _possibleConstructorReturn(this, (CardWrapper.__proto__ || Object.getPrototypeOf(CardWrapper)).apply(this, arguments));
	  }
	
	  _createClass(CardWrapper, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.onAnimationStart) {
	        var el = _reactDom2.default.findDOMNode(this);
	        $(el).on('webkitAnimationStart animationstart', function (e) {
	          _this2.props.onAnimationStart(_this2.props.cardType, _this2.props.id, e.originalEvent);
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onAnimationStart = _props.onAnimationStart,
	          rest = _objectWithoutProperties(_props, ['onAnimationStart']); // eslint-disable-line no-unused-vars
	
	
	      return _react2.default.createElement(_Card2.default, rest);
	    }
	  }]);
	
	  return CardWrapper;
	}(_react2.default.Component), _class.propTypes = _extends({}, _propTypes.cardProps, {
	  onAnimationStart: _react.PropTypes.func
	}), _temp);
	exports.default = CardWrapper;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(23);
	
	var _PlayerCardCity = __webpack_require__(642);
	
	var _PlayerCardCity2 = _interopRequireDefault(_PlayerCardCity);
	
	var _PlayerCardEvent = __webpack_require__(644);
	
	var _PlayerCardEvent2 = _interopRequireDefault(_PlayerCardEvent);
	
	var _PlayerCardEpidemic = __webpack_require__(643);
	
	var _PlayerCardEpidemic2 = _interopRequireDefault(_PlayerCardEpidemic);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlayerCard = function PlayerCard(_ref) {
	  var card = _ref.card,
	      popoverPlacement = _ref.popoverPlacement;
	
	  var CardView = void 0;
	  switch (card.cardType) {
	    case 'city':
	      CardView = _PlayerCardCity2.default;
	      break;
	    case 'event':
	      CardView = _PlayerCardEvent2.default;
	      break;
	    default:
	      CardView = _PlayerCardEpidemic2.default;
	      break;
	  }
	  var viewProps = card.cardType === 'event' ? { popoverPlacement: popoverPlacement } : {};
	  return _react2.default.createElement(
	    _reactBootstrap.ListGroupItem,
	    { key: card.cardType + '-' + card.id },
	    _react2.default.createElement(
	      'span',
	      { className: card.cardType },
	      _react2.default.createElement(CardView, _extends({ card: card }, viewProps))
	    )
	  );
	};
	
	PlayerCard.propTypes = {
	  card: _propTypes.cardType.isRequired,
	  popoverPlacement: _react.PropTypes.string
	};
	
	exports.default = PlayerCard;

/***/ },
/* 356 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Object.freeze(['Charlie', 'Oscar', 'Mike', 'Victor', 'Romeo']);

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.showCitiesAndMove = showCitiesAndMove;
	exports.showAvailableCities = showAvailableCities;
	exports.movedToCity = movedToCity;
	exports.showShareCandidates = showShareCandidates;
	exports.drawIfNoActionsLeft = drawIfNoActionsLeft;
	exports.waitToDiscardIfOverLimit = waitToDiscardIfOverLimit;
	exports.drawPlayerCards = drawPlayerCards;
	exports.showCardsToCure = showCardsToCure;
	exports.maybeDiscardStationCity = maybeDiscardStationCity;
	exports.watchMoveInit = watchMoveInit;
	exports.watchMoveToCity = watchMoveToCity;
	exports.watchShareInit = watchShareInit;
	exports.watchActionsLeft = watchActionsLeft;
	exports.watchBuildStation = watchBuildStation;
	exports.watchCureInit = watchCureInit;
	exports.watchForMoveComplete = watchForMoveComplete;
	
	var _reduxSaga = __webpack_require__(137);
	
	var _effects = __webpack_require__(177);
	
	var _mapActions = __webpack_require__(117);
	
	var _diseaseActions = __webpack_require__(92);
	
	var _cardActions = __webpack_require__(72);
	
	var _globalActions = __webpack_require__(73);
	
	var _selectors = __webpack_require__(48);
	
	var sel = _interopRequireWildcard(_selectors);
	
	var _actionTypes = __webpack_require__(25);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _defeatMessages = __webpack_require__(236);
	
	var _defeatMessages2 = _interopRequireDefault(_defeatMessages);
	
	var _diseaseSagas = __webpack_require__(358);
	
	var _globalSagas = __webpack_require__(237);
	
	var _roleSagas = __webpack_require__(359);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _marked = /*#__PURE__*/regeneratorRuntime.mark(showCitiesAndMove),
	    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(showAvailableCities),
	    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(movedToCity),
	    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(showShareCandidates),
	    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(drawIfNoActionsLeft),
	    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(checkIfHandWentUnderLimit),
	    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(waitToDiscardIfOverLimit),
	    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(drawPlayerCards),
	    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(showCardsToCure),
	    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(maybeDiscardStationCity),
	    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(watchMoveInit),
	    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(watchMoveToCity),
	    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(watchShareInit),
	    _marked16 = /*#__PURE__*/regeneratorRuntime.mark(watchActionsLeft),
	    _marked17 = /*#__PURE__*/regeneratorRuntime.mark(watchBuildStation),
	    _marked18 = /*#__PURE__*/regeneratorRuntime.mark(watchCureInit),
	    _marked19 = /*#__PURE__*/regeneratorRuntime.mark(watchForMoveComplete);
	
	var MAX_PLAYER_CARDS_LEFT = 2;
	
	function showCitiesAndMove(cities) {
	  return regeneratorRuntime.wrap(function showCitiesAndMove$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)((0, _mapActions.moveShowCities)(cities));
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.take)([types.PLAYER_MOVE_TO_CITY, types.PLAYER_MOVE_CANCEL]);
	
	        case 4:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function showAvailableCities() {
	  var cities;
	  return regeneratorRuntime.wrap(function showAvailableCities$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.select)(sel.getAvailableCities);
	
	        case 2:
	          cities = _context2.sent;
	          _context2.next = 5;
	          return (0, _effects.call)(showCitiesAndMove, cities);
	
	        case 5:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function movedToCity(action) {
	  var currentPlayer;
	  return regeneratorRuntime.wrap(function movedToCity$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.take)(types.ANIMATION_MOVE_COMPLETE);
	
	        case 2:
	          _context3.next = 4;
	          return (0, _effects.select)(sel.getCurrentPlayer);
	
	        case 4:
	          currentPlayer = _context3.sent;
	          _context3.t0 = action.source;
	          _context3.next = _context3.t0 === 'direct' ? 8 : _context3.t0 === 'charter' ? 13 : _context3.t0 === 'ops' ? 18 : 21;
	          break;
	
	        case 8:
	          _context3.next = 10;
	          return (0, _effects.put)((0, _cardActions.discardFromHandInit)('city', currentPlayer.id, action.destinationId));
	
	        case 10:
	          _context3.next = 12;
	          return (0, _effects.take)(types.ANIMATION_CARD_DISCARD_FROM_HAND_COMPLETE);
	
	        case 12:
	          return _context3.abrupt('break', 21);
	
	        case 13:
	          _context3.next = 15;
	          return (0, _effects.put)((0, _cardActions.discardFromHandInit)('city', currentPlayer.id, action.originId));
	
	        case 15:
	          _context3.next = 17;
	          return (0, _effects.take)(types.ANIMATION_CARD_DISCARD_FROM_HAND_COMPLETE);
	
	        case 17:
	          return _context3.abrupt('break', 21);
	
	        case 18:
	          _context3.next = 20;
	          return (0, _effects.call)(_roleSagas.opsChooseCardToDiscard, currentPlayer.id);
	
	        case 20:
	          return _context3.abrupt('break', 21);
	
	        case 21:
	          _context3.next = 23;
	          return (0, _effects.call)(_roleSagas.treatCuredDiseasesOnMedicMove, action);
	
	        case 23:
	          _context3.next = 25;
	          return (0, _effects.put)((0, _mapActions.moveComplete)());
	
	        case 25:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function showShareCandidates() {
	  var players, action;
	  return regeneratorRuntime.wrap(function showShareCandidates$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.select)(sel.getShareCandidates);
	
	        case 2:
	          players = _context4.sent;
	          _context4.next = 5;
	          return (0, _effects.put)((0, _cardActions.shareCardsShowCandidates)(players));
	
	        case 5:
	          _context4.next = 7;
	          return (0, _effects.take)([types.PLAYER_SHARE_CARD, types.PLAYER_SHARE_CANCEL]);
	
	        case 7:
	          action = _context4.sent;
	
	          if (!(action.type === types.PLAYER_SHARE_CARD)) {
	            _context4.next = 11;
	            break;
	          }
	
	          _context4.next = 11;
	          return (0, _effects.call)(waitToDiscardIfOverLimit, action.receiverId);
	
	        case 11:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function drawIfNoActionsLeft() {
	  var _marked5, continueTurn, actionsLeft, currentPlayer;
	
	  return regeneratorRuntime.wrap(function drawIfNoActionsLeft$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          continueTurn = function continueTurn() {
	            var nextPlayer;
	            return regeneratorRuntime.wrap(function continueTurn$(_context5) {
	              while (1) {
	                switch (_context5.prev = _context5.next) {
	                  case 0:
	                    _context5.next = 2;
	                    return (0, _effects.select)(sel.shouldSkipInfectionsStep);
	
	                  case 2:
	                    if (_context5.sent) {
	                      _context5.next = 9;
	                      break;
	                    }
	
	                    _context5.next = 5;
	                    return (0, _effects.call)(_diseaseSagas.infections);
	
	                  case 5:
	                    _context5.next = 7;
	                    return (0, _effects.select)(sel.isPlaying);
	
	                  case 7:
	                    if (_context5.sent) {
	                      _context5.next = 9;
	                      break;
	                    }
	
	                    return _context5.abrupt('return');
	
	                  case 9:
	                    _context5.next = 11;
	                    return (0, _effects.select)(sel.getNextPlayer);
	
	                  case 11:
	                    nextPlayer = _context5.sent;
	                    _context5.next = 14;
	                    return (0, _effects.put)((0, _globalActions.passTurn)(nextPlayer));
	
	                  case 14:
	                  case 'end':
	                    return _context5.stop();
	                }
	              }
	            }, _marked5, this);
	          };
	
	          _marked5 = /*#__PURE__*/regeneratorRuntime.mark(continueTurn);
	          _context6.next = 4;
	          return (0, _effects.select)(sel.isPlaying);
	
	        case 4:
	          if (_context6.sent) {
	            _context6.next = 6;
	            break;
	          }
	
	          return _context6.abrupt('return');
	
	        case 6:
	          _context6.next = 8;
	          return (0, _effects.select)(sel.getActionsLeft);
	
	        case 8:
	          actionsLeft = _context6.sent;
	
	          if (!(actionsLeft === 0)) {
	            _context6.next = 23;
	            break;
	          }
	
	          _context6.next = 12;
	          return (0, _effects.call)(drawPlayerCards);
	
	        case 12:
	          _context6.next = 14;
	          return (0, _effects.select)(sel.isPlaying);
	
	        case 14:
	          if (_context6.sent) {
	            _context6.next = 16;
	            break;
	          }
	
	          return _context6.abrupt('return');
	
	        case 16:
	          _context6.next = 18;
	          return (0, _effects.select)(sel.getCurrentPlayer);
	
	        case 18:
	          currentPlayer = _context6.sent;
	          _context6.next = 21;
	          return (0, _effects.call)(waitToDiscardIfOverLimit, currentPlayer.id);
	
	        case 21:
	          _context6.next = 23;
	          return (0, _effects.call)(continueTurn);
	
	        case 23:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this);
	}
	
	function checkIfHandWentUnderLimit() {
	  var player;
	  return regeneratorRuntime.wrap(function checkIfHandWentUnderLimit$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return (0, _effects.select)(sel.getPlayerToDiscard);
	
	        case 2:
	          player = _context7.sent;
	          _context7.t0 = player;
	
	          if (!_context7.t0) {
	            _context7.next = 8;
	            break;
	          }
	
	          _context7.next = 7;
	          return (0, _effects.select)(sel.isOverHandLimit, player);
	
	        case 7:
	          _context7.t0 = !_context7.sent;
	
	        case 8:
	          if (!_context7.t0) {
	            _context7.next = 11;
	            break;
	          }
	
	          _context7.next = 11;
	          return (0, _effects.put)((0, _cardActions.cardOverLimitComplete)());
	
	        case 11:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked7, this);
	}
	
	function waitToDiscardIfOverLimit(playerId) {
	  var _marked8, watchOverLimitDiscardComplete, task;
	
	  return regeneratorRuntime.wrap(function waitToDiscardIfOverLimit$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          watchOverLimitDiscardComplete = function watchOverLimitDiscardComplete() {
	            return regeneratorRuntime.wrap(function watchOverLimitDiscardComplete$(_context8) {
	              while (1) {
	                switch (_context8.prev = _context8.next) {
	                  case 0:
	                    return _context8.delegateYield((0, _reduxSaga.takeEvery)(types.ANIMATION_CARD_DISCARD_FROM_HAND_COMPLETE, checkIfHandWentUnderLimit), 't0', 1);
	
	                  case 1:
	                  case 'end':
	                    return _context8.stop();
	                }
	              }
	            }, _marked8, this);
	          };
	
	          _marked8 = /*#__PURE__*/regeneratorRuntime.mark(watchOverLimitDiscardComplete);
	          _context9.next = 4;
	          return (0, _effects.select)(sel.isOverHandLimit, playerId);
	
	        case 4:
	          if (!_context9.sent) {
	            _context9.next = 14;
	            break;
	          }
	
	          _context9.next = 7;
	          return (0, _effects.put)((0, _cardActions.chooseCardsToDiscard)(playerId));
	
	        case 7:
	          _context9.next = 9;
	          return (0, _effects.fork)(watchOverLimitDiscardComplete);
	
	        case 9:
	          task = _context9.sent;
	          _context9.next = 12;
	          return (0, _effects.take)(types.CARD_OVER_LIMIT_DISCARD_COMPLETE);
	
	        case 12:
	          _context9.next = 14;
	          return (0, _effects.cancel)(task);
	
	        case 14:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked9, this);
	}
	
	function drawPlayerCards() {
	  var cards, bothEpidemics, currentPlayer, i;
	  return regeneratorRuntime.wrap(function drawPlayerCards$(_context10) {
	    while (1) {
	      switch (_context10.prev = _context10.next) {
	        case 0:
	          _context10.next = 2;
	          return (0, _effects.select)(sel.getPlayerCardsToDraw);
	
	        case 2:
	          cards = _context10.sent;
	
	          if (!(cards.length < MAX_PLAYER_CARDS_LEFT)) {
	            _context10.next = 8;
	            break;
	          }
	
	          _context10.next = 6;
	          return (0, _effects.call)(_globalSagas.yieldDefeat, _defeatMessages2.default.OUT_OF_PLAYER_CARDS);
	
	        case 6:
	          _context10.next = 42;
	          break;
	
	        case 8:
	          bothEpidemics = false;
	
	          if (cards[0].cardType === 'epidemic') {
	            if (cards[1].cardType === 'epidemic') {
	              bothEpidemics = true;
	            } else {
	              cards.reverse();
	            }
	          }
	          _context10.next = 12;
	          return (0, _effects.put)((0, _cardActions.drawCardsInit)(cards));
	
	        case 12:
	          _context10.next = 14;
	          return (0, _effects.take)(types.ANIMATION_DRAW_CARDS_INIT_COMPLETE);
	
	        case 14:
	          if (!bothEpidemics) {
	            _context10.next = 30;
	            break;
	          }
	
	          _context10.next = 17;
	          return (0, _effects.select)(sel.getCurrentPlayer);
	
	        case 17:
	          currentPlayer = _context10.sent;
	          _context10.next = 20;
	          return (0, _effects.call)(_reduxSaga.delay, 3000);
	
	        case 20:
	          _context10.next = 22;
	          return (0, _effects.put)((0, _cardActions.drawCardsHandle)(cards[0], currentPlayer.id));
	
	        case 22:
	          _context10.next = 24;
	          return (0, _effects.put)((0, _cardActions.drawCardsHandle)(cards[1], currentPlayer.id));
	
	        case 24:
	          _context10.next = 26;
	          return (0, _effects.call)(_diseaseSagas.yieldEpidemic);
	
	        case 26:
	          _context10.next = 28;
	          return (0, _effects.call)(_diseaseSagas.yieldEpidemic);
	
	        case 28:
	          _context10.next = 42;
	          break;
	
	        case 30:
	          i = 0;
	
	        case 31:
	          if (!(i < 2)) {
	            _context10.next = 42;
	            break;
	          }
	
	          _context10.next = 34;
	          return (0, _effects.put)((0, _cardActions.drawCardsHandleInit)(cards[i]));
	
	        case 34:
	          _context10.next = 36;
	          return (0, _effects.take)(types.CARD_DRAW_CARDS_HANDLE);
	
	        case 36:
	          if (!(cards[i].cardType === 'epidemic')) {
	            _context10.next = 39;
	            break;
	          }
	
	          _context10.next = 39;
	          return (0, _effects.call)(_diseaseSagas.yieldEpidemic);
	
	        case 39:
	          i++;
	          _context10.next = 31;
	          break;
	
	        case 42:
	        case 'end':
	          return _context10.stop();
	      }
	    }
	  }, _marked10, this);
	}
	
	function showCardsToCure(_ref) {
	  var color = _ref.color;
	  var cards, action, cityIds, currentPlayer, i;
	  return regeneratorRuntime.wrap(function showCardsToCure$(_context11) {
	    while (1) {
	      switch (_context11.prev = _context11.next) {
	        case 0:
	          _context11.next = 2;
	          return (0, _effects.select)(sel.getCardsOfColorInCurrentHand, color);
	
	        case 2:
	          cards = _context11.sent;
	          _context11.next = 5;
	          return (0, _effects.put)((0, _diseaseActions.cureDiseaseShowCards)(cards, color));
	
	        case 5:
	          _context11.next = 7;
	          return (0, _effects.take)([types.PLAYER_CURE_DISEASE_COMPLETE, types.PLAYER_CURE_DISEASE_CANCEL]);
	
	        case 7:
	          action = _context11.sent;
	
	          if (!(action.type === types.PLAYER_CURE_DISEASE_COMPLETE)) {
	            _context11.next = 24;
	            break;
	          }
	
	          cityIds = action.cityIds;
	          _context11.next = 12;
	          return (0, _effects.take)(types.ANIMATION_CURE_DISEASE_COMPLETE);
	
	        case 12:
	          _context11.next = 14;
	          return (0, _effects.select)(sel.getCurrentPlayer);
	
	        case 14:
	          currentPlayer = _context11.sent;
	          i = 0;
	
	        case 16:
	          if (!(i < cityIds.length)) {
	            _context11.next = 24;
	            break;
	          }
	
	          _context11.next = 19;
	          return (0, _effects.put)((0, _cardActions.discardFromHandInit)('city', currentPlayer.id, cityIds[i]));
	
	        case 19:
	          _context11.next = 21;
	          return (0, _effects.take)(types.ANIMATION_CARD_DISCARD_FROM_HAND_COMPLETE);
	
	        case 21:
	          i++;
	          _context11.next = 16;
	          break;
	
	        case 24:
	        case 'end':
	          return _context11.stop();
	      }
	    }
	  }, _marked11, this);
	}
	
	function maybeDiscardStationCity(action) {
	  var currentPlayer;
	  return regeneratorRuntime.wrap(function maybeDiscardStationCity$(_context12) {
	    while (1) {
	      switch (_context12.prev = _context12.next) {
	        case 0:
	          _context12.next = 2;
	          return (0, _effects.select)(sel.getCurrentRole);
	
	        case 2:
	          _context12.t0 = _context12.sent;
	
	          if (!(_context12.t0 !== 'ops_expert')) {
	            _context12.next = 9;
	            break;
	          }
	
	          _context12.next = 6;
	          return (0, _effects.select)(sel.getCurrentPlayer);
	
	        case 6:
	          currentPlayer = _context12.sent;
	          _context12.next = 9;
	          return (0, _effects.put)((0, _cardActions.discardFromHandInit)('city', currentPlayer.id, action.cityId));
	
	        case 9:
	        case 'end':
	          return _context12.stop();
	      }
	    }
	  }, _marked12, this);
	}
	
	function watchMoveInit() {
	  return regeneratorRuntime.wrap(function watchMoveInit$(_context13) {
	    while (1) {
	      switch (_context13.prev = _context13.next) {
	        case 0:
	          return _context13.delegateYield((0, _reduxSaga.takeEvery)(types.PLAYER_MOVE_INIT, showAvailableCities), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context13.stop();
	      }
	    }
	  }, _marked13, this);
	}
	
	function watchMoveToCity() {
	  return regeneratorRuntime.wrap(function watchMoveToCity$(_context14) {
	    while (1) {
	      switch (_context14.prev = _context14.next) {
	        case 0:
	          return _context14.delegateYield((0, _reduxSaga.takeEvery)(types.PLAYER_MOVE_TO_CITY, movedToCity), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context14.stop();
	      }
	    }
	  }, _marked14, this);
	}
	
	function watchShareInit() {
	  return regeneratorRuntime.wrap(function watchShareInit$(_context15) {
	    while (1) {
	      switch (_context15.prev = _context15.next) {
	        case 0:
	          return _context15.delegateYield((0, _reduxSaga.takeEvery)(types.PLAYER_SHARE_INIT, showShareCandidates), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context15.stop();
	      }
	    }
	  }, _marked15, this);
	}
	
	function watchActionsLeft() {
	  return regeneratorRuntime.wrap(function watchActionsLeft$(_context16) {
	    while (1) {
	      switch (_context16.prev = _context16.next) {
	        case 0:
	          return _context16.delegateYield((0, _reduxSaga.takeEvery)(types.ACTIONS, drawIfNoActionsLeft), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context16.stop();
	      }
	    }
	  }, _marked16, this);
	}
	
	function watchBuildStation() {
	  return regeneratorRuntime.wrap(function watchBuildStation$(_context17) {
	    while (1) {
	      switch (_context17.prev = _context17.next) {
	        case 0:
	          return _context17.delegateYield((0, _reduxSaga.takeEvery)(types.PLAYER_BUILD_STATION, maybeDiscardStationCity), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context17.stop();
	      }
	    }
	  }, _marked17, this);
	}
	
	function watchCureInit() {
	  return regeneratorRuntime.wrap(function watchCureInit$(_context18) {
	    while (1) {
	      switch (_context18.prev = _context18.next) {
	        case 0:
	          return _context18.delegateYield((0, _reduxSaga.takeEvery)(types.PLAYER_CURE_DISEASE_INIT, showCardsToCure), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context18.stop();
	      }
	    }
	  }, _marked18, this);
	}
	
	function watchForMoveComplete() {
	  return regeneratorRuntime.wrap(function watchForMoveComplete$(_context19) {
	    while (1) {
	      switch (_context19.prev = _context19.next) {
	        case 0:
	          return _context19.delegateYield((0, _reduxSaga.takeEvery)(types.PLAYER_MOVE_TO_CITY, movedToCity), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context19.stop();
	      }
	    }
	  }, _marked19, this);
	}

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.yieldOutbreak = yieldOutbreak;
	exports.infectOrOutbreak = infectOrOutbreak;
	exports.useCubes = useCubes;
	exports.checkForEradication = checkForEradication;
	exports.yieldEpidemic = yieldEpidemic;
	exports.infections = infections;
	exports.watchTreatEradication = watchTreatEradication;
	exports.watchCureEradication = watchCureEradication;
	
	var _reduxSaga = __webpack_require__(137);
	
	var _effects = __webpack_require__(177);
	
	var _diseaseActions = __webpack_require__(92);
	
	var _cardActions = __webpack_require__(72);
	
	var _selectors = __webpack_require__(48);
	
	var sel = _interopRequireWildcard(_selectors);
	
	var _actionTypes = __webpack_require__(25);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _defeatMessages = __webpack_require__(236);
	
	var _defeatMessages2 = _interopRequireDefault(_defeatMessages);
	
	var _globalSagas = __webpack_require__(237);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _marked = /*#__PURE__*/regeneratorRuntime.mark(yieldOutbreak),
	    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(discardInfectionCard),
	    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getActualCubesToUse),
	    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(infectOrOutbreak),
	    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(useCubes),
	    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(checkForEradication),
	    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(yieldEpidemic),
	    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(infections),
	    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(watchTreatEradication),
	    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(watchCureEradication);
	
	function yieldOutbreak(cityId, color) {
	  var neighbors, i, id, medic, actualCubesToUse, quarSpec, cubesInNeighbor, nextOutbreakCityId;
	  return regeneratorRuntime.wrap(function yieldOutbreak$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)((0, _diseaseActions.initOutbreak)(cityId, color));
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.select)(sel.isPlaying);
	
	        case 4:
	          if (_context.sent) {
	            _context.next = 6;
	            break;
	          }
	
	          return _context.abrupt('return');
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.take)(types.CONTINUE);
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.select)(sel.getNeighborCities, cityId);
	
	        case 10:
	          neighbors = _context.sent;
	          i = 0;
	
	        case 12:
	          if (!(i < neighbors.length)) {
	            _context.next = 54;
	            break;
	          }
	
	          id = neighbors[i].id;
	          _context.next = 16;
	          return (0, _effects.select)(sel.getMedicInCity, id);
	
	        case 16:
	          medic = _context.sent;
	          _context.next = 19;
	          return (0, _effects.call)(getActualCubesToUse, id, color, 1);
	
	        case 19:
	          actualCubesToUse = _context.sent;
	          _context.t0 = medic;
	
	          if (!_context.t0) {
	            _context.next = 26;
	            break;
	          }
	
	          _context.next = 24;
	          return (0, _effects.select)(sel.getDiseaseStatus, color);
	
	        case 24:
	          _context.t1 = _context.sent;
	          _context.t0 = _context.t1 === 'cured';
	
	        case 26:
	          if (!_context.t0) {
	            _context.next = 31;
	            break;
	          }
	
	          _context.next = 29;
	          return (0, _effects.put)((0, _diseaseActions.medicPreventInfection)(medic, id, color, actualCubesToUse));
	
	        case 29:
	          _context.next = 51;
	          break;
	
	        case 31:
	          _context.next = 33;
	          return (0, _effects.select)(sel.getQuarSpecInProximity, id);
	
	        case 33:
	          quarSpec = _context.sent;
	
	          if (!quarSpec) {
	            _context.next = 39;
	            break;
	          }
	
	          _context.next = 37;
	          return (0, _effects.put)((0, _diseaseActions.quarSpecPreventInfection)(quarSpec, id, color, actualCubesToUse));
	
	        case 37:
	          _context.next = 51;
	          break;
	
	        case 39:
	          _context.next = 41;
	          return (0, _effects.select)(sel.getCubesInCity, id, color);
	
	        case 41:
	          cubesInNeighbor = _context.sent;
	          _context.next = 44;
	          return (0, _effects.call)(useCubes, id, color, 1);
	
	        case 44:
	          _context.next = 46;
	          return (0, _effects.put)((0, _diseaseActions.infectNeighbor)(id, cityId, color));
	
	        case 46:
	          _context.next = 48;
	          return (0, _effects.take)(types.ANIMATION_INFECT_NEIGHBOR_COMPLETE);
	
	        case 48:
	          if (!(cubesInNeighbor === 3)) {
	            _context.next = 51;
	            break;
	          }
	
	          _context.next = 51;
	          return (0, _effects.put)((0, _diseaseActions.queueOutbreak)(id, color));
	
	        case 51:
	          i++;
	          _context.next = 12;
	          break;
	
	        case 54:
	          _context.next = 56;
	          return (0, _effects.put)((0, _diseaseActions.completeOutbreak)(cityId));
	
	        case 56:
	          _context.next = 58;
	          return (0, _effects.select)(sel.getNextOutbreakCityId);
	
	        case 58:
	          nextOutbreakCityId = _context.sent;
	
	          if (!nextOutbreakCityId) {
	            _context.next = 62;
	            break;
	          }
	
	          _context.next = 62;
	          return (0, _effects.call)(yieldOutbreak, nextOutbreakCityId, color);
	
	        case 62:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function discardInfectionCard() {
	  return regeneratorRuntime.wrap(function discardInfectionCard$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.take)(types.ANIMATION_DRAW_INFECTION_CARD_COMPLETE);
	
	        case 2:
	          _context2.next = 4;
	          return (0, _effects.put)((0, _cardActions.discardTopInfectionCard)());
	
	        case 4:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function getActualCubesToUse(cityId, color, count) {
	  var cubesInCity;
	  return regeneratorRuntime.wrap(function getActualCubesToUse$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.select)(sel.getCubesInCity, cityId, color);
	
	        case 2:
	          cubesInCity = _context3.sent;
	          return _context3.abrupt('return', Math.min(3 - cubesInCity, count));
	
	        case 4:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function infectOrOutbreak(cityId, color, count, isDiscarding) {
	  var cubesInCity, medic, actualCubesToUse, quarSpec;
	  return regeneratorRuntime.wrap(function infectOrOutbreak$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.select)(sel.getCubesInCity, cityId, color);
	
	        case 2:
	          cubesInCity = _context4.sent;
	          _context4.next = 5;
	          return (0, _effects.select)(sel.getMedicInCity, cityId);
	
	        case 5:
	          medic = _context4.sent;
	          _context4.next = 8;
	          return (0, _effects.call)(getActualCubesToUse, cityId, color, count);
	
	        case 8:
	          actualCubesToUse = _context4.sent;
	          _context4.t0 = medic;
	
	          if (!_context4.t0) {
	            _context4.next = 15;
	            break;
	          }
	
	          _context4.next = 13;
	          return (0, _effects.select)(sel.getDiseaseStatus, color);
	
	        case 13:
	          _context4.t1 = _context4.sent;
	          _context4.t0 = _context4.t1 === 'cured';
	
	        case 15:
	          if (!_context4.t0) {
	            _context4.next = 24;
	            break;
	          }
	
	          if (!isDiscarding) {
	            _context4.next = 19;
	            break;
	          }
	
	          _context4.next = 19;
	          return (0, _effects.call)(discardInfectionCard);
	
	        case 19:
	          _context4.next = 21;
	          return (0, _effects.put)((0, _diseaseActions.medicPreventInfection)(medic, cityId, color, actualCubesToUse));
	
	        case 21:
	          return _context4.abrupt('return');
	
	        case 24:
	          _context4.next = 26;
	          return (0, _effects.select)(sel.getQuarSpecInProximity, cityId);
	
	        case 26:
	          quarSpec = _context4.sent;
	
	          if (!quarSpec) {
	            _context4.next = 35;
	            break;
	          }
	
	          if (!isDiscarding) {
	            _context4.next = 31;
	            break;
	          }
	
	          _context4.next = 31;
	          return (0, _effects.call)(discardInfectionCard);
	
	        case 31:
	          _context4.next = 33;
	          return (0, _effects.put)((0, _diseaseActions.quarSpecPreventInfection)(quarSpec, cityId, color, actualCubesToUse));
	
	        case 33:
	          _context4.next = 45;
	          break;
	
	        case 35:
	          _context4.next = 37;
	          return (0, _effects.call)(useCubes, cityId, color, count);
	
	        case 37:
	          _context4.next = 39;
	          return (0, _effects.put)((0, _diseaseActions.infectCity)(cityId, color, count));
	
	        case 39:
	          if (!isDiscarding) {
	            _context4.next = 42;
	            break;
	          }
	
	          _context4.next = 42;
	          return (0, _effects.call)(discardInfectionCard);
	
	        case 42:
	          if (!(cubesInCity + count > 3)) {
	            _context4.next = 45;
	            break;
	          }
	
	          _context4.next = 45;
	          return (0, _effects.call)(yieldOutbreak, cityId, color);
	
	        case 45:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function useCubes(cityId, color, count) {
	  var actualCubesToUse;
	  return regeneratorRuntime.wrap(function useCubes$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.call)(getActualCubesToUse, cityId, color, count);
	
	        case 2:
	          actualCubesToUse = _context5.sent;
	          _context5.next = 5;
	          return (0, _effects.select)(sel.isOutOfCubes, actualCubesToUse, color);
	
	        case 5:
	          if (!_context5.sent) {
	            _context5.next = 10;
	            break;
	          }
	
	          _context5.next = 8;
	          return (0, _effects.call)(_globalSagas.yieldDefeat, _defeatMessages2.default.OUT_OF_CUBES(color));
	
	        case 8:
	          _context5.next = 12;
	          break;
	
	        case 10:
	          _context5.next = 12;
	          return (0, _effects.put)((0, _diseaseActions.useDiseaseCubes)(color, actualCubesToUse));
	
	        case 12:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	
	function checkForEradication(_ref) {
	  var color = _ref.color;
	  var treatedAll, status;
	  return regeneratorRuntime.wrap(function checkForEradication$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return (0, _effects.select)(sel.treatedAllOfColor, color);
	
	        case 2:
	          treatedAll = _context6.sent;
	          _context6.next = 5;
	          return (0, _effects.select)(sel.getDiseaseStatus, color);
	
	        case 5:
	          status = _context6.sent;
	
	          if (!(treatedAll && status === 'cured')) {
	            _context6.next = 9;
	            break;
	          }
	
	          _context6.next = 9;
	          return (0, _effects.put)((0, _diseaseActions.eradicateDisease)(color));
	
	        case 9:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this);
	}
	
	function yieldEpidemic() {
	  var infectionCity, color, status, resPopOwner;
	  return regeneratorRuntime.wrap(function yieldEpidemic$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return (0, _effects.put)((0, _cardActions.epidemicIncrease)());
	
	        case 2:
	          _context7.next = 4;
	          return (0, _effects.take)(types.CONTINUE);
	
	        case 4:
	          _context7.next = 6;
	          return (0, _effects.select)(sel.getInfectionDeckBottom);
	
	        case 6:
	          infectionCity = _context7.sent;
	          _context7.next = 9;
	          return (0, _effects.select)(sel.getCityColor, infectionCity.id);
	
	        case 9:
	          color = _context7.sent;
	          _context7.next = 12;
	          return (0, _effects.select)(sel.getDiseaseStatus, color);
	
	        case 12:
	          status = _context7.sent;
	
	          if (!(status !== 'eradicated')) {
	            _context7.next = 22;
	            break;
	          }
	
	          _context7.next = 16;
	          return (0, _effects.put)((0, _cardActions.epidemicInfectInit)(infectionCity));
	
	        case 16:
	          _context7.next = 18;
	          return (0, _effects.take)(types.CONTINUE);
	
	        case 18:
	          _context7.next = 20;
	          return (0, _effects.put)((0, _cardActions.discardBottomInfectionCard)());
	
	        case 20:
	          _context7.next = 22;
	          return (0, _effects.call)(infectOrOutbreak, infectionCity.id, color, 3);
	
	        case 22:
	          _context7.next = 24;
	          return (0, _effects.select)(sel.getResPopOwner);
	
	        case 24:
	          resPopOwner = _context7.sent;
	
	          if (!resPopOwner) {
	            _context7.next = 30;
	            break;
	          }
	
	          _context7.next = 28;
	          return (0, _effects.put)((0, _cardActions.resPopSuggest)(resPopOwner));
	
	        case 28:
	          _context7.next = 30;
	          return (0, _effects.take)([types.ANIMATION_CARD_DISCARD_FROM_HAND_COMPLETE, types.CONTINUE]);
	
	        case 30:
	          _context7.next = 32;
	          return (0, _effects.put)((0, _cardActions.epidemicIntensifyInit)());
	
	        case 32:
	          _context7.next = 34;
	          return (0, _effects.take)(types.EPIDEMIC_INTENSIFY);
	
	        case 34:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked7, this);
	}
	
	function infections() {
	  var infectionRate, i, city, color, status;
	  return regeneratorRuntime.wrap(function infections$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          _context8.next = 2;
	          return (0, _effects.put)((0, _diseaseActions.infectCities)());
	
	        case 2:
	          _context8.next = 4;
	          return (0, _effects.select)(sel.getInfectionRate);
	
	        case 4:
	          infectionRate = _context8.sent;
	          i = 0;
	
	        case 6:
	          if (!(i < infectionRate)) {
	            _context8.next = 28;
	            break;
	          }
	
	          _context8.next = 9;
	          return (0, _effects.select)(sel.peekAtInfectionDeck);
	
	        case 9:
	          city = _context8.sent;
	          _context8.next = 12;
	          return (0, _effects.select)(sel.getCityColor, city);
	
	        case 12:
	          color = _context8.sent;
	          _context8.next = 15;
	          return (0, _effects.select)(sel.getDiseaseStatus, color);
	
	        case 15:
	          status = _context8.sent;
	          _context8.next = 18;
	          return (0, _effects.put)((0, _cardActions.drawInfectionCard)(city));
	
	        case 18:
	          if (!(status !== 'eradicated')) {
	            _context8.next = 23;
	            break;
	          }
	
	          _context8.next = 21;
	          return (0, _effects.call)(infectOrOutbreak, city, color, 1, true);
	
	        case 21:
	          _context8.next = 25;
	          break;
	
	        case 23:
	          _context8.next = 25;
	          return (0, _effects.call)(discardInfectionCard);
	
	        case 25:
	          i++;
	          _context8.next = 6;
	          break;
	
	        case 28:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked8, this);
	}
	
	function watchTreatEradication() {
	  return regeneratorRuntime.wrap(function watchTreatEradication$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          return _context9.delegateYield((0, _reduxSaga.takeEvery)([types.PLAYER_TREAT_DISEASE, types.PLAYER_TREAT_ALL_DISEASE], checkForEradication), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked9, this);
	}
	
	function watchCureEradication() {
	  return regeneratorRuntime.wrap(function watchCureEradication$(_context10) {
	    while (1) {
	      switch (_context10.prev = _context10.next) {
	        case 0:
	          return _context10.delegateYield((0, _reduxSaga.takeEvery)(types.PLAYER_CURE_DISEASE_COMPLETE, checkForEradication), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context10.stop();
	      }
	    }
	  }, _marked10, this);
	}

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.treatCuredDiseasesOnMedicMove = treatCuredDiseasesOnMedicMove;
	exports.opsChooseCardToDiscard = opsChooseCardToDiscard;
	exports.contPlannerSpecial = contPlannerSpecial;
	exports.clearCubesNearMedic = clearCubesNearMedic;
	exports.dispatcherMove = dispatcherMove;
	exports.watchMedicAirlift = watchMedicAirlift;
	exports.watchContPlannerInit = watchContPlannerInit;
	exports.watchDispatcherMove = watchDispatcherMove;
	exports.watchCureDisease = watchCureDisease;
	
	var _reduxSaga = __webpack_require__(137);
	
	var _effects = __webpack_require__(177);
	
	var _diseaseActions = __webpack_require__(92);
	
	var _cardActions = __webpack_require__(72);
	
	var _actionSagas = __webpack_require__(357);
	
	var _actionTypes = __webpack_require__(25);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _selectors = __webpack_require__(48);
	
	var sel = _interopRequireWildcard(_selectors);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _marked = /*#__PURE__*/regeneratorRuntime.mark(treatCuredDiseasesOnMedicMove),
	    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(opsChooseCardToDiscard),
	    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(contPlannerSpecial),
	    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(clearCubesNearMedic),
	    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(dispatcherMove),
	    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(watchMedicAirlift),
	    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(watchContPlannerInit),
	    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(watchDispatcherMove),
	    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(watchCureDisease);
	
	function treatCuredDiseasesOnMedicMove(action) {
	  var curedDiseaseCubes;
	  return regeneratorRuntime.wrap(function treatCuredDiseasesOnMedicMove$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(sel.getPlayerRole, action.playerId);
	
	        case 2:
	          _context.t0 = _context.sent;
	
	          if (!(_context.t0 === 'medic')) {
	            _context.next = 9;
	            break;
	          }
	
	          _context.next = 6;
	          return (0, _effects.select)(sel.getCuredDiseaseCubes);
	
	        case 6:
	          curedDiseaseCubes = _context.sent;
	          _context.next = 9;
	          return (0, _effects.put)((0, _diseaseActions.medicTreatCuredDiseases)(action.destinationId, curedDiseaseCubes));
	
	        case 9:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function opsChooseCardToDiscard(playerId) {
	  var cards;
	  return regeneratorRuntime.wrap(function opsChooseCardToDiscard$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.select)(sel.getCitiesInPlayersHand, playerId);
	
	        case 2:
	          cards = _context2.sent;
	          _context2.next = 5;
	          return (0, _effects.put)((0, _cardActions.opsShowCardsToDiscard)(cards));
	
	        case 5:
	          _context2.next = 7;
	          return (0, _effects.take)(types.ANIMATION_CARD_DISCARD_FROM_HAND_COMPLETE);
	
	        case 7:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function contPlannerSpecial() {
	  var cards;
	  return regeneratorRuntime.wrap(function contPlannerSpecial$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.select)(sel.getCardsForContPlanner);
	
	        case 2:
	          cards = _context3.sent;
	          _context3.next = 5;
	          return (0, _effects.put)((0, _cardActions.contPlannerShowEventsFromDiscard)(cards));
	
	        case 5:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function clearCubesNearMedic(action) {
	  var medic, cityId, cubes;
	  return regeneratorRuntime.wrap(function clearCubesNearMedic$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.select)(sel.getMedicInTeam);
	
	        case 2:
	          medic = _context4.sent;
	
	          if (!medic) {
	            _context4.next = 12;
	            break;
	          }
	
	          _context4.next = 6;
	          return (0, _effects.select)(sel.getPlayerCityId, medic.id);
	
	        case 6:
	          cityId = _context4.sent;
	          _context4.next = 9;
	          return (0, _effects.select)(sel.getCubesInCity, cityId, action.color);
	
	        case 9:
	          cubes = _context4.sent;
	          _context4.next = 12;
	          return (0, _effects.put)((0, _diseaseActions.medicTreatCuredDiseases)(cityId, _defineProperty({}, action.color, cubes)));
	
	        case 12:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function dispatcherMove(action) {
	  var cities;
	  return regeneratorRuntime.wrap(function dispatcherMove$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.select)(sel.getCitiesForDispatcher, action.playerId);
	
	        case 2:
	          cities = _context5.sent;
	          _context5.next = 5;
	          return (0, _effects.call)(_actionSagas.showCitiesAndMove, cities);
	
	        case 5:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	
	function watchMedicAirlift() {
	  return regeneratorRuntime.wrap(function watchMedicAirlift$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          return _context6.delegateYield((0, _reduxSaga.takeEvery)(types.EVENT_AIRLIFT_MOVE_TO_CITY, treatCuredDiseasesOnMedicMove), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this);
	}
	
	function watchContPlannerInit() {
	  return regeneratorRuntime.wrap(function watchContPlannerInit$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          return _context7.delegateYield((0, _reduxSaga.takeEvery)(types.CONT_PLANNER_INIT, contPlannerSpecial), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked7, this);
	}
	
	function watchDispatcherMove() {
	  return regeneratorRuntime.wrap(function watchDispatcherMove$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          return _context8.delegateYield((0, _reduxSaga.takeEvery)(types.DISPATCHER_CHOOSE_PLAYER, dispatcherMove), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked8, this);
	}
	
	function watchCureDisease() {
	  return regeneratorRuntime.wrap(function watchCureDisease$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          return _context9.delegateYield((0, _reduxSaga.takeEvery)(types.PLAYER_CURE_DISEASE_COMPLETE, clearCubesNearMedic), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked9, this);
	}

/***/ },
/* 360 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var map = exports.map = {
	  width: 1506,
	  height: 703
	};

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(697), __esModule: true };

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(699), __esModule: true };

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	var escapeStringRegexp = __webpack_require__(422);
	var ansiStyles = __webpack_require__(554);
	var stripAnsi = __webpack_require__(1718);
	var hasAnsi = __webpack_require__(1087);
	var supportsColor = __webpack_require__(692);
	var defineProps = Object.defineProperties;
	var isSimpleWindowsTerm = process.platform === 'win32' && !/^xterm/i.test(process.env.TERM);
	
	function Chalk(options) {
		// detect mode if not set manually
		this.enabled = !options || options.enabled === undefined ? supportsColor : options.enabled;
	}
	
	// use bright blue on Windows as the normal blue color is illegible
	if (isSimpleWindowsTerm) {
		ansiStyles.blue.open = '\u001b[94m';
	}
	
	var styles = (function () {
		var ret = {};
	
		Object.keys(ansiStyles).forEach(function (key) {
			ansiStyles[key].closeRe = new RegExp(escapeStringRegexp(ansiStyles[key].close), 'g');
	
			ret[key] = {
				get: function () {
					return build.call(this, this._styles.concat(key));
				}
			};
		});
	
		return ret;
	})();
	
	var proto = defineProps(function chalk() {}, styles);
	
	function build(_styles) {
		var builder = function () {
			return applyStyle.apply(builder, arguments);
		};
	
		builder._styles = _styles;
		builder.enabled = this.enabled;
		// __proto__ is used because we must return a function, but there is
		// no way to create a function with a different prototype.
		/* eslint-disable no-proto */
		builder.__proto__ = proto;
	
		return builder;
	}
	
	function applyStyle() {
		// support varags, but simply cast to string in case there's only one arg
		var args = arguments;
		var argsLen = args.length;
		var str = argsLen !== 0 && String(arguments[0]);
	
		if (argsLen > 1) {
			// don't slice `arguments`, it prevents v8 optimizations
			for (var a = 1; a < argsLen; a++) {
				str += ' ' + args[a];
			}
		}
	
		if (!this.enabled || !str) {
			return str;
		}
	
		var nestedStyles = this._styles;
		var i = nestedStyles.length;
	
		// Turns out that on Windows dimmed gray text becomes invisible in cmd.exe,
		// see https://github.com/chalk/chalk/issues/58
		// If we're on Windows and we're dealing with a gray color, temporarily make 'dim' a noop.
		var originalDim = ansiStyles.dim.open;
		if (isSimpleWindowsTerm && (nestedStyles.indexOf('gray') !== -1 || nestedStyles.indexOf('grey') !== -1)) {
			ansiStyles.dim.open = '';
		}
	
		while (i--) {
			var code = ansiStyles[nestedStyles[i]];
	
			// Replace any instances already present with a re-opening code
			// otherwise only the part of the string until said closing code
			// will be colored, and the rest will simply be 'plain'.
			str = code.open + str.replace(code.closeRe, code.open) + code.close;
		}
	
		// Reset the original 'dim' if we changed it to work around the Windows dimmed gray issue.
		ansiStyles.dim.open = originalDim;
	
		return str;
	}
	
	function init() {
		var ret = {};
	
		Object.keys(styles).forEach(function (name) {
			ret[name] = {
				get: function () {
					return build.call(this, [name]);
				}
			};
		});
	
		return ret;
	}
	
	defineProps(Chalk.prototype, init());
	
	module.exports = new Chalk();
	module.exports.styles = ansiStyles;
	module.exports.hasColor = hasAnsi;
	module.exports.stripColor = stripAnsi;
	module.exports.supportsColor = supportsColor;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(111)))

/***/ },
/* 364 */
[1734, 122, 86],
/* 365 */
[1738, 84, 142, 364],
/* 366 */
[1739, 241],
/* 367 */
[1744, 182, 85, 372, 121, 143, 714, 247, 721, 61],
/* 368 */
[1751, 145, 146, 97, 251, 95, 365, 84],
/* 369 */
[1753, 370, 244],
/* 370 */
[1755, 95, 97, 706, 248],
/* 371 */
[1757, 84, 144, 97, 145],
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(121);


/***/ },
/* 373 */
[1765, 250],
/* 374 */
[1777, 723, 367],
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(54);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(33);
	var toAbsoluteIndex = __webpack_require__(106);
	var toLength = __webpack_require__(26);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(99);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(38);
	var toObject = __webpack_require__(33);
	var IObject = __webpack_require__(148);
	var toLength = __webpack_require__(26);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(38);
	var isObject = __webpack_require__(18);
	var invoke = __webpack_require__(385);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(30).f;
	var create = __webpack_require__(100);
	var redefineAll = __webpack_require__(104);
	var ctx = __webpack_require__(56);
	var anInstance = __webpack_require__(98);
	var forOf = __webpack_require__(99);
	var $iterDefine = __webpack_require__(265);
	var step = __webpack_require__(388);
	var setSpecies = __webpack_require__(105);
	var DESCRIPTORS = __webpack_require__(27);
	var fastKey = __webpack_require__(89).fastKey;
	var validate = __webpack_require__(108);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(123);
	var from = __webpack_require__(377);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(104);
	var getWeak = __webpack_require__(89).getWeak;
	var anObject = __webpack_require__(11);
	var isObject = __webpack_require__(18);
	var anInstance = __webpack_require__(98);
	var forOf = __webpack_require__(99);
	var createArrayMethod = __webpack_require__(62);
	var $has = __webpack_require__(49);
	var validate = __webpack_require__(108);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(188);
	var isObject = __webpack_require__(18);
	var toLength = __webpack_require__(26);
	var ctx = __webpack_require__(56);
	var IS_CONCAT_SPREADABLE = __webpack_require__(24)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ },
/* 384 */
[1738, 27, 15, 258],
/* 385 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(18);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ },
/* 387 */
[1742, 11],
/* 388 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(267);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ },
/* 390 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ },
/* 391 */
/***/ function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ },
/* 392 */
[1747, 27, 102, 192, 149, 33, 148, 15],
/* 393 */
[1750, 30, 11, 102, 27],
/* 394 */
[1752, 52, 101],
/* 395 */
[1755, 49, 52, 185, 272],
/* 396 */
[1757, 27, 102, 52, 149],
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(101);
	var gOPS = __webpack_require__(192);
	var anObject = __webpack_require__(11);
	var Reflect = __webpack_require__(13).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(13).parseFloat;
	var $trim = __webpack_require__(126).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(275) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(13).parseInt;
	var $trim = __webpack_require__(126).trim;
	var ws = __webpack_require__(275);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ },
/* 400 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(11);
	var isObject = __webpack_require__(18);
	var newPromiseCapability = __webpack_require__(269);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ },
/* 402 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(26);
	var repeat = __webpack_require__(274);
	var defined = __webpack_require__(63);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(58);
	var toLength = __webpack_require__(26);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ },
/* 405 */
[1769, 24],
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(380);
	var validate = __webpack_require__(108);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(186)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(270);
	__webpack_require__(2)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(27) && /./g.flags != 'g') __webpack_require__(30).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(147)
	});


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(380);
	var validate = __webpack_require__(108);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(186)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(13);
	var each = __webpack_require__(62)(0);
	var redefine = __webpack_require__(43);
	var meta = __webpack_require__(89);
	var assign = __webpack_require__(392);
	var weak = __webpack_require__(382);
	var isObject = __webpack_require__(18);
	var validate = __webpack_require__(108);
	var NATIVE_WEAK_MAP = __webpack_require__(108);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(186)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = dirtyHandlerIds;
	exports.areDirty = areDirty;
	
	var _xor = __webpack_require__(1466);
	
	var _xor2 = _interopRequireDefault(_xor);
	
	var _intersection = __webpack_require__(1459);
	
	var _intersection2 = _interopRequireDefault(_intersection);
	
	var _dragDrop = __webpack_require__(199);
	
	var _registry = __webpack_require__(200);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NONE = [];
	var ALL = [];
	
	function dirtyHandlerIds() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NONE;
		var action = arguments[1];
		var dragOperation = arguments[2];
	
		switch (action.type) {
			case _dragDrop.HOVER:
				break;
			case _registry.ADD_SOURCE:
			case _registry.ADD_TARGET:
			case _registry.REMOVE_TARGET:
			case _registry.REMOVE_SOURCE:
				return NONE;
			case _dragDrop.BEGIN_DRAG:
			case _dragDrop.PUBLISH_DRAG_SOURCE:
			case _dragDrop.END_DRAG:
			case _dragDrop.DROP:
			default:
				return ALL;
		}
	
		var targetIds = action.targetIds;
		var prevTargetIds = dragOperation.targetIds;
	
		var result = (0, _xor2.default)(targetIds, prevTargetIds);
	
		var didChange = false;
		if (result.length === 0) {
			for (var i = 0; i < targetIds.length; i++) {
				if (targetIds[i] !== prevTargetIds[i]) {
					didChange = true;
					break;
				}
			}
		} else {
			didChange = true;
		}
	
		if (!didChange) {
			return NONE;
		}
	
		var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
		var innermostTargetId = targetIds[targetIds.length - 1];
	
		if (prevInnermostTargetId !== innermostTargetId) {
			if (prevInnermostTargetId) {
				result.push(prevInnermostTargetId);
			}
			if (innermostTargetId) {
				result.push(innermostTargetId);
			}
		}
	
		return result;
	}
	
	function areDirty(state, handlerIds) {
		if (state === NONE) {
			return false;
		}
	
		if (state === ALL || typeof handlerIds === 'undefined') {
			return true;
		}
	
		return (0, _intersection2.default)(handlerIds, state).length > 0;
	}

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = dragOffset;
	exports.getSourceClientOffset = getSourceClientOffset;
	exports.getDifferenceFromInitialOffset = getDifferenceFromInitialOffset;
	
	var _dragDrop = __webpack_require__(199);
	
	var initialState = {
		initialSourceClientOffset: null,
		initialClientOffset: null,
		clientOffset: null
	};
	
	function areOffsetsEqual(offsetA, offsetB) {
		if (offsetA === offsetB) {
			return true;
		}
		return offsetA && offsetB && offsetA.x === offsetB.x && offsetA.y === offsetB.y;
	}
	
	function dragOffset() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
		var action = arguments[1];
	
		switch (action.type) {
			case _dragDrop.BEGIN_DRAG:
				return {
					initialSourceClientOffset: action.sourceClientOffset,
					initialClientOffset: action.clientOffset,
					clientOffset: action.clientOffset
				};
			case _dragDrop.HOVER:
				if (areOffsetsEqual(state.clientOffset, action.clientOffset)) {
					return state;
				}
				return _extends({}, state, {
					clientOffset: action.clientOffset
				});
			case _dragDrop.END_DRAG:
			case _dragDrop.DROP:
				return initialState;
			default:
				return state;
		}
	}
	
	function getSourceClientOffset(state) {
		var clientOffset = state.clientOffset,
		    initialClientOffset = state.initialClientOffset,
		    initialSourceClientOffset = state.initialSourceClientOffset;
	
		if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
			return null;
		}
		return {
			x: clientOffset.x + initialSourceClientOffset.x - initialClientOffset.x,
			y: clientOffset.y + initialSourceClientOffset.y - initialClientOffset.y
		};
	}
	
	function getDifferenceFromInitialOffset(state) {
		var clientOffset = state.clientOffset,
		    initialClientOffset = state.initialClientOffset;
	
		if (!clientOffset || !initialClientOffset) {
			return null;
		}
		return {
			x: clientOffset.x - initialClientOffset.x,
			y: clientOffset.y - initialClientOffset.y
		};
	}

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = matchesType;
	
	var _isArray = __webpack_require__(110);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function matchesType(targetType, draggedItemType) {
		if ((0, _isArray2.default)(targetType)) {
			return targetType.some(function (t) {
				return t === draggedItemType;
			});
		} else {
			return targetType === draggedItemType;
		}
	}

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(29);
	
	exports.__esModule = true;
	exports.default = activeElement;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(127));
	
	function activeElement(doc) {
	  if (doc === void 0) {
	    doc = (0, _ownerDocument.default)();
	  }
	
	  try {
	    return doc.activeElement;
	  } catch (e) {
	    /* ie throws if no active element */
	  }
	}
	
	module.exports = exports["default"];

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(29);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(416));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 416 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 417 */
/***/ function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(29);
	
	exports.__esModule = true;
	exports.default = offset;
	
	var _contains = _interopRequireDefault(__webpack_require__(128));
	
	var _isWindow = _interopRequireDefault(__webpack_require__(202));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(127));
	
	function offset(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      win = (0, _isWindow.default)(doc),
	      docElem = doc && doc.documentElement,
	      box = {
	    top: 0,
	    left: 0,
	    height: 0,
	    width: 0
	  };
	  if (!doc) return; // Make sure it's not a disconnected DOM node
	
	  if (!(0, _contains.default)(docElem, node)) return box;
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height
	
	  box = {
	    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	    width: (box.width == null ? node.offsetWidth : box.width) || 0,
	    height: (box.height == null ? node.offsetHeight : box.height) || 0
	  };
	  return box;
	}
	
	module.exports = exports["default"];

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(29);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(202));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	
	module.exports = exports["default"];

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(29);
	
	exports.__esModule = true;
	exports.default = camelizeStyleName;
	
	var _camelize = _interopRequireDefault(__webpack_require__(969));
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	var msPattern = /^-ms-/;
	
	function camelizeStyleName(string) {
	  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = exports["default"];

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(29);
	
	exports.__esModule = true;
	exports.default = scrollbarSize;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(76));
	
	var size;
	
	function scrollbarSize(recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_inDOM.default) {
	      var scrollDiv = document.createElement('div');
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	}
	
	module.exports = exports["default"];

/***/ },
/* 422 */
/***/ function(module, exports) {

	'use strict';
	
	var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
	
	module.exports = function (str) {
		if (typeof str !== 'string') {
			throw new TypeError('Expected a string');
		}
	
		return str.replace(matchOperatorsRe, '\\$&');
	};


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(66);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 424 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 425 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d56df49a807a9fd06eb1667a84d3810e.png";

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e254cd67aab086c9a6350509c95772de.png";

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1f75d678b5526b783b2918b76f3262e7.png";

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(204);
	
	var _DOMUtils = __webpack_require__(288);
	
	var _createHistory = __webpack_require__(432);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(129);
	
	var _PathUtils = __webpack_require__(109);
	
	var _ExecutionEnvironment = __webpack_require__(204);
	
	var _DOMUtils = __webpack_require__(288);
	
	var _DOMStateStorage = __webpack_require__(429);
	
	var _createDOMHistory = __webpack_require__(430);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(939);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(109);
	
	var _AsyncUtils = __webpack_require__(1090);
	
	var _Actions = __webpack_require__(129);
	
	var _createLocation2 = __webpack_require__(1092);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(290);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(289);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(204);
	
	var _PathUtils = __webpack_require__(109);
	
	var _runTransitionHook = __webpack_require__(290);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(289);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*
	 *  base64.js
	 *
	 *  Licensed under the BSD 3-Clause License.
	 *    http://opensource.org/licenses/BSD-3-Clause
	 *
	 *  References:
	 *    http://en.wikipedia.org/wiki/Base64
	 */
	;(function (global, factory) {
	     true
	        ? module.exports = factory(global)
	        : typeof define === 'function' && define.amd
	        ? define(factory) : factory(global)
	}((
	    typeof self !== 'undefined' ? self
	        : typeof window !== 'undefined' ? window
	        : typeof global !== 'undefined' ? global
	: this
	), function(global) {
	    'use strict';
	    // existing version for noConflict()
	    global = global || {};
	    var _Base64 = global.Base64;
	    var version = "2.6.4";
	    // constants
	    var b64chars
	        = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	    var b64tab = function(bin) {
	        var t = {};
	        for (var i = 0, l = bin.length; i < l; i++) t[bin.charAt(i)] = i;
	        return t;
	    }(b64chars);
	    var fromCharCode = String.fromCharCode;
	    // encoder stuff
	    var cb_utob = function(c) {
	        if (c.length < 2) {
	            var cc = c.charCodeAt(0);
	            return cc < 0x80 ? c
	                : cc < 0x800 ? (fromCharCode(0xc0 | (cc >>> 6))
	                                + fromCharCode(0x80 | (cc & 0x3f)))
	                : (fromCharCode(0xe0 | ((cc >>> 12) & 0x0f))
	                    + fromCharCode(0x80 | ((cc >>>  6) & 0x3f))
	                    + fromCharCode(0x80 | ( cc         & 0x3f)));
	        } else {
	            var cc = 0x10000
	                + (c.charCodeAt(0) - 0xD800) * 0x400
	                + (c.charCodeAt(1) - 0xDC00);
	            return (fromCharCode(0xf0 | ((cc >>> 18) & 0x07))
	                    + fromCharCode(0x80 | ((cc >>> 12) & 0x3f))
	                    + fromCharCode(0x80 | ((cc >>>  6) & 0x3f))
	                    + fromCharCode(0x80 | ( cc         & 0x3f)));
	        }
	    };
	    var re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
	    var utob = function(u) {
	        return u.replace(re_utob, cb_utob);
	    };
	    var cb_encode = function(ccc) {
	        var padlen = [0, 2, 1][ccc.length % 3],
	        ord = ccc.charCodeAt(0) << 16
	            | ((ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8)
	            | ((ccc.length > 2 ? ccc.charCodeAt(2) : 0)),
	        chars = [
	            b64chars.charAt( ord >>> 18),
	            b64chars.charAt((ord >>> 12) & 63),
	            padlen >= 2 ? '=' : b64chars.charAt((ord >>> 6) & 63),
	            padlen >= 1 ? '=' : b64chars.charAt(ord & 63)
	        ];
	        return chars.join('');
	    };
	    var btoa = global.btoa && typeof global.btoa == 'function'
	        ? function(b){ return global.btoa(b) } : function(b) {
	        if (b.match(/[^\x00-\xFF]/)) throw new RangeError(
	            'The string contains invalid characters.'
	        );
	        return b.replace(/[\s\S]{1,3}/g, cb_encode);
	    };
	    var _encode = function(u) {
	        return btoa(utob(String(u)));
	    };
	    var mkUriSafe = function (b64) {
	        return b64.replace(/[+\/]/g, function(m0) {
	            return m0 == '+' ? '-' : '_';
	        }).replace(/=/g, '');
	    };
	    var encode = function(u, urisafe) {
	        return urisafe ? mkUriSafe(_encode(u)) : _encode(u);
	    };
	    var encodeURI = function(u) { return encode(u, true) };
	    var fromUint8Array;
	    if (global.Uint8Array) fromUint8Array = function(a, urisafe) {
	        // return btoa(fromCharCode.apply(null, a));
	        var b64 = '';
	        for (var i = 0, l = a.length; i < l; i += 3) {
	            var a0 = a[i], a1 = a[i+1], a2 = a[i+2];
	            var ord = a0 << 16 | a1 << 8 | a2;
	            b64 +=    b64chars.charAt( ord >>> 18)
	                +     b64chars.charAt((ord >>> 12) & 63)
	                + ( typeof a1 != 'undefined'
	                    ? b64chars.charAt((ord >>>  6) & 63) : '=')
	                + ( typeof a2 != 'undefined'
	                    ? b64chars.charAt( ord         & 63) : '=');
	        }
	        return urisafe ? mkUriSafe(b64) : b64;
	    };
	    // decoder stuff
	    var re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
	    var cb_btou = function(cccc) {
	        switch(cccc.length) {
	        case 4:
	            var cp = ((0x07 & cccc.charCodeAt(0)) << 18)
	                |    ((0x3f & cccc.charCodeAt(1)) << 12)
	                |    ((0x3f & cccc.charCodeAt(2)) <<  6)
	                |     (0x3f & cccc.charCodeAt(3)),
	            offset = cp - 0x10000;
	            return (fromCharCode((offset  >>> 10) + 0xD800)
	                    + fromCharCode((offset & 0x3FF) + 0xDC00));
	        case 3:
	            return fromCharCode(
	                ((0x0f & cccc.charCodeAt(0)) << 12)
	                    | ((0x3f & cccc.charCodeAt(1)) << 6)
	                    |  (0x3f & cccc.charCodeAt(2))
	            );
	        default:
	            return  fromCharCode(
	                ((0x1f & cccc.charCodeAt(0)) << 6)
	                    |  (0x3f & cccc.charCodeAt(1))
	            );
	        }
	    };
	    var btou = function(b) {
	        return b.replace(re_btou, cb_btou);
	    };
	    var cb_decode = function(cccc) {
	        var len = cccc.length,
	        padlen = len % 4,
	        n = (len > 0 ? b64tab[cccc.charAt(0)] << 18 : 0)
	            | (len > 1 ? b64tab[cccc.charAt(1)] << 12 : 0)
	            | (len > 2 ? b64tab[cccc.charAt(2)] <<  6 : 0)
	            | (len > 3 ? b64tab[cccc.charAt(3)]       : 0),
	        chars = [
	            fromCharCode( n >>> 16),
	            fromCharCode((n >>>  8) & 0xff),
	            fromCharCode( n         & 0xff)
	        ];
	        chars.length -= [0, 0, 2, 1][padlen];
	        return chars.join('');
	    };
	    var _atob = global.atob && typeof global.atob == 'function'
	        ? function(a){ return global.atob(a) } : function(a){
	        return a.replace(/\S{1,4}/g, cb_decode);
	    };
	    var atob = function(a) {
	        return _atob(String(a).replace(/[^A-Za-z0-9\+\/]/g, ''));
	    };
	    var _decode = function(a) { return btou(_atob(a)) };
	    var _fromURI = function(a) {
	        return String(a).replace(/[-_]/g, function(m0) {
	            return m0 == '-' ? '+' : '/'
	        }).replace(/[^A-Za-z0-9\+\/]/g, '');
	    };
	    var decode = function(a){
	        return _decode(_fromURI(a));
	    };
	    var toUint8Array;
	    if (global.Uint8Array) toUint8Array = function(a) {
	        return Uint8Array.from(atob(_fromURI(a)), function(c) {
	            return c.charCodeAt(0);
	        });
	    };
	    var noConflict = function() {
	        var Base64 = global.Base64;
	        global.Base64 = _Base64;
	        return Base64;
	    };
	    // export Base64
	    global.Base64 = {
	        VERSION: version,
	        atob: atob,
	        btoa: btoa,
	        fromBase64: decode,
	        toBase64: encode,
	        utob: utob,
	        encode: encode,
	        encodeURI: encodeURI,
	        btou: btou,
	        decode: decode,
	        noConflict: noConflict,
	        fromUint8Array: fromUint8Array,
	        toUint8Array: toUint8Array
	    };
	    // if ES5 is available, make Base64.extendString() available
	    if (typeof Object.defineProperty === 'function') {
	        var noEnum = function(v){
	            return {value:v,enumerable:false,writable:true,configurable:true};
	        };
	        global.Base64.extendString = function () {
	            Object.defineProperty(
	                String.prototype, 'fromBase64', noEnum(function () {
	                    return decode(this)
	                }));
	            Object.defineProperty(
	                String.prototype, 'toBase64', noEnum(function (urisafe) {
	                    return encode(this, urisafe)
	                }));
	            Object.defineProperty(
	                String.prototype, 'toBase64URI', noEnum(function () {
	                    return encode(this, true)
	                }));
	        };
	    }
	    //
	    // export Base64 to the namespace
	    //
	    if (global['Meteor']) { // Meteor.js
	        Base64 = global.Base64;
	    }
	    // module.exports and AMD are mutually exclusive.
	    // module.exports has precedence.
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports.Base64 = global.Base64;
	    }
	    else if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){ return global.Base64 }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    // that's it!
	    return {Base64: global.Base64}
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 435 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function () {
		return /\u001b\[(?:[0-9]{1,3}(?:;[0-9]{1,3})*)?[m|K]/g;
	};


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./contexts/context": 154,
		"./contexts/context.js": 154,
		"./contexts/diff": 155,
		"./contexts/diff.js": 155,
		"./contexts/patch": 156,
		"./contexts/patch.js": 156,
		"./contexts/reverse": 157,
		"./contexts/reverse.js": 157,
		"./date-reviver": 206,
		"./date-reviver.js": 206,
		"./diffpatcher": 294,
		"./diffpatcher.js": 294,
		"./environment": 158,
		"./environment.js": 158,
		"./filters/arrays": 295,
		"./filters/arrays.js": 295,
		"./filters/dates": 296,
		"./filters/dates.js": 296,
		"./filters/lcs": 297,
		"./filters/lcs.js": 297,
		"./filters/nested": 298,
		"./filters/nested.js": 298,
		"./filters/texts": 299,
		"./filters/texts.js": 299,
		"./filters/trivial": 300,
		"./filters/trivial.js": 300,
		"./formatters/annotated": 159,
		"./formatters/annotated.js": 159,
		"./formatters/base": 77,
		"./formatters/base.js": 77,
		"./formatters/console": 207,
		"./formatters/console.js": 207,
		"./formatters/html": 160,
		"./formatters/html.js": 160,
		"./formatters/index": 161,
		"./formatters/index.js": 161,
		"./formatters/jsonpatch": 162,
		"./formatters/jsonpatch.js": 162,
		"./main": 163,
		"./main-formatters": 437,
		"./main-formatters.js": 437,
		"./main-full": 438,
		"./main-full.js": 438,
		"./main.js": 163,
		"./pipe": 208,
		"./pipe.js": 208,
		"./processor": 301,
		"./processor.js": 301
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 436;


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(161);


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	var environment = __webpack_require__(158);
	
	if (environment.isBrowser) {
	  /* global window */
	  /* jshint camelcase: false */
	  window.diff_match_patch = __webpack_require__(293);
	  /* jshint camelcase: true */
	}
	
	module.exports = __webpack_require__(163);


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1441),
	    mapCacheDelete = __webpack_require__(1442),
	    mapCacheGet = __webpack_require__(1443),
	    mapCacheHas = __webpack_require__(1444),
	    mapCacheSet = __webpack_require__(1445);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(303),
	    arrayIncludes = __webpack_require__(305),
	    arrayIncludesWith = __webpack_require__(306),
	    arrayMap = __webpack_require__(307),
	    baseUnary = __webpack_require__(308),
	    cacheHas = __webpack_require__(309);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(1407),
	    isFlattenable = __webpack_require__(1431);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(303),
	    arrayIncludes = __webpack_require__(305),
	    arrayIncludesWith = __webpack_require__(306),
	    cacheHas = __webpack_require__(309),
	    createSet = __webpack_require__(1421),
	    setToArray = __webpack_require__(445);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ },
/* 443 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 444 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 445 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 446 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1411),
	    isObjectLike = __webpack_require__(167);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(210),
	    isObject = __webpack_require__(166);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 449 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 450 */
/***/ function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(440),
	    baseRest = __webpack_require__(164),
	    isArrayLikeObject = __webpack_require__(214);
	
	/**
	 * Creates an array excluding all given values using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * **Note:** Unlike `_.pull`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...*} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.difference, _.xor
	 * @example
	 *
	 * _.without([2, 1, 2, 3], 1, 2);
	 * // => [3]
	 */
	var without = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, values)
	    : [];
	});
	
	module.exports = without;


/***/ },
/* 452 */
/***/ function(module, exports) {

	'use strict';
	
	var numberIsNaN = function (value) {
		return value !== value;
	};
	
	module.exports = function is(a, b) {
		if (a === 0 && b === 0) {
			return 1 / a === 1 / b;
		}
		if (a === b) {
			return true;
		}
		if (numberIsNaN(a) && numberIsNaN(b)) {
			return true;
		}
		return false;
	};
	


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(452);
	
	module.exports = function getPolyfill() {
		return typeof Object.is === 'function' ? Object.is : implementation;
	};


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(455);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(1472);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ },
/* 455 */
/***/ function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	var postcssJs = {
	    objectify: __webpack_require__(457),
	    parse:     __webpack_require__(312),
	    async:     __webpack_require__(1475),
	    sync:      __webpack_require__(1476)
	};
	module.exports = postcssJs;


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	var camelcase = __webpack_require__(689);
	
	function process(node) {
	    var name;
	    var result = { };
	    node.each(function (child) {
	        var rules = {};
	
	        node.each(function (rule) {
	            if ( rule.type !== 'rule' ) {
	                return;
	            } else if ( rules[rule.selector] ) {
	                if ( rules[rule.selector].append ) {
	                    rules[rule.selector].append(rule.nodes);
	                    rule.remove();
	                }
	            } else {
	                rules[rule.selector] = rule;
	            }
	        });
	
	        if ( child.type === 'atrule' ) {
	            name = '@' + child.name;
	            if ( child.params ) name += ' ' + child.params;
	            if ( typeof child.nodes === 'undefined' ) {
	                result[name] = true;
	            } else {
	                result[name] = process(child);
	            }
	
	        } else if ( child.type === 'rule' ) {
	            result[child.selector] = process(child);
	
	        } else if ( child.type === 'decl' ) {
	            name = camelcase(child.prop);
	            if ( typeof result[name] === 'undefined' ) {
	                result[name] = child.value;
	            } else if ( Array.isArray(result[name]) ) {
	                result[name].push(child.value);
	            } else {
	                result[name] = [result[name], child.value];
	            }
	        }
	
	    });
	    return result;
	}
	
	module.exports = process;


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	var objectify = __webpack_require__(457);
	
	module.exports = function (result) {
	    if ( console && console.warn ) {
	        result.warnings().forEach(function (warn) {
	            var source = warn.plugin || 'PostCSS';
	            console.warn(source + ': ' + warn.text);
	        });
	    }
	    return objectify(result.root);
	};


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _supportsColor = __webpack_require__(1719);
	
	var _supportsColor2 = _interopRequireDefault(_supportsColor);
	
	var _chalk = __webpack_require__(363);
	
	var _chalk2 = _interopRequireDefault(_chalk);
	
	var _terminalHighlight = __webpack_require__(1485);
	
	var _terminalHighlight2 = _interopRequireDefault(_terminalHighlight);
	
	var _warnOnce = __webpack_require__(79);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * The CSS parser throws this error for broken CSS.
	 *
	 * Custom parsers can throw this error for broken custom syntax using
	 * the {@link Node#error} method.
	 *
	 * PostCSS will use the input source map to detect the original error location.
	 * If you wrote a Sass file, compiled it to CSS and then parsed it with PostCSS,
	 * PostCSS will show the original position in the Sass file.
	 *
	 * If you need the position in the PostCSS input
	 * (e.g., to debug the previous compiler), use `error.input.file`.
	 *
	 * @example
	 * // Catching and checking syntax error
	 * try {
	 *   postcss.parse('a{')
	 * } catch (error) {
	 *   if ( error.name === 'CssSyntaxError' ) {
	 *     error //=> CssSyntaxError
	 *   }
	 * }
	 *
	 * @example
	 * // Raising error from plugin
	 * throw node.error('Unknown variable', { plugin: 'postcss-vars' });
	 */
	var CssSyntaxError = function () {
	
	    /**
	     * @param {string} message  - error message
	     * @param {number} [line]   - source line of the error
	     * @param {number} [column] - source column of the error
	     * @param {string} [source] - source code of the broken file
	     * @param {string} [file]   - absolute path to the broken file
	     * @param {string} [plugin] - PostCSS plugin name, if error came from plugin
	     */
	    function CssSyntaxError(message, line, column, source, file, plugin) {
	        _classCallCheck(this, CssSyntaxError);
	
	        /**
	         * @member {string} - Always equal to `'CssSyntaxError'`. You should
	         *                    always check error type
	         *                    by `error.name === 'CssSyntaxError'` instead of
	         *                    `error instanceof CssSyntaxError`, because
	         *                    npm could have several PostCSS versions.
	         *
	         * @example
	         * if ( error.name === 'CssSyntaxError' ) {
	         *   error //=> CssSyntaxError
	         * }
	         */
	        this.name = 'CssSyntaxError';
	        /**
	         * @member {string} - Error message.
	         *
	         * @example
	         * error.message //=> 'Unclosed block'
	         */
	        this.reason = message;
	
	        if (file) {
	            /**
	             * @member {string} - Absolute path to the broken file.
	             *
	             * @example
	             * error.file       //=> 'a.sass'
	             * error.input.file //=> 'a.css'
	             */
	            this.file = file;
	        }
	        if (source) {
	            /**
	             * @member {string} - Source code of the broken file.
	             *
	             * @example
	             * error.source       //=> 'a { b {} }'
	             * error.input.column //=> 'a b { }'
	             */
	            this.source = source;
	        }
	        if (plugin) {
	            /**
	             * @member {string} - Plugin name, if error came from plugin.
	             *
	             * @example
	             * error.plugin //=> 'postcss-vars'
	             */
	            this.plugin = plugin;
	        }
	        if (typeof line !== 'undefined' && typeof column !== 'undefined') {
	            /**
	             * @member {number} - Source line of the error.
	             *
	             * @example
	             * error.line       //=> 2
	             * error.input.line //=> 4
	             */
	            this.line = line;
	            /**
	             * @member {number} - Source column of the error.
	             *
	             * @example
	             * error.column       //=> 1
	             * error.input.column //=> 4
	             */
	            this.column = column;
	        }
	
	        this.setMessage();
	
	        if (Error.captureStackTrace) {
	            Error.captureStackTrace(this, CssSyntaxError);
	        }
	    }
	
	    CssSyntaxError.prototype.setMessage = function setMessage() {
	        /**
	         * @member {string} - Full error text in the GNU error format
	         *                    with plugin, file, line and column.
	         *
	         * @example
	         * error.message //=> 'a.css:1:1: Unclosed block'
	         */
	        this.message = this.plugin ? this.plugin + ': ' : '';
	        this.message += this.file ? this.file : '<css input>';
	        if (typeof this.line !== 'undefined') {
	            this.message += ':' + this.line + ':' + this.column;
	        }
	        this.message += ': ' + this.reason;
	    };
	
	    /**
	     * Returns a few lines of CSS source that caused the error.
	     *
	     * If the CSS has an input source map without `sourceContent`,
	     * this method will return an empty string.
	     *
	     * @param {boolean} [color] whether arrow will be colored red by terminal
	     *                          color codes. By default, PostCSS will detect
	     *                          color support by `process.stdout.isTTY`
	     *                          and `process.env.NODE_DISABLE_COLORS`.
	     *
	     * @example
	     * error.showSourceCode() //=> "  4 | }
	     *                        //      5 | a {
	     *                        //    > 6 |   bad
	     *                        //        |   ^
	     *                        //      7 | }
	     *                        //      8 | b {"
	     *
	     * @return {string} few lines of CSS source that caused the error
	     */
	
	
	    CssSyntaxError.prototype.showSourceCode = function showSourceCode(color) {
	        var _this = this;
	
	        if (!this.source) return '';
	
	        var css = this.source;
	        if (typeof color === 'undefined') color = _supportsColor2.default;
	        if (color) css = (0, _terminalHighlight2.default)(css);
	
	        var lines = css.split(/\r?\n/);
	        var start = Math.max(this.line - 3, 0);
	        var end = Math.min(this.line + 2, lines.length);
	
	        var maxWidth = String(end).length;
	        var colors = new _chalk2.default.constructor({ enabled: true });
	
	        function mark(text) {
	            if (color) {
	                return colors.red.bold(text);
	            } else {
	                return text;
	            }
	        }
	        function aside(text) {
	            if (color) {
	                return colors.gray(text);
	            } else {
	                return text;
	            }
	        }
	
	        return lines.slice(start, end).map(function (line, index) {
	            var number = start + 1 + index;
	            var gutter = ' ' + (' ' + number).slice(-maxWidth) + ' | ';
	            if (number === _this.line) {
	                var spacing = aside(gutter.replace(/\d/g, ' ')) + line.slice(0, _this.column - 1).replace(/[^\t]/g, ' ');
	                return mark('>') + aside(gutter) + line + '\n ' + spacing + mark('^');
	            } else {
	                return ' ' + aside(gutter) + line;
	            }
	        }).join('\n');
	    };
	
	    /**
	     * Returns error position, message and source code of the broken part.
	     *
	     * @example
	     * error.toString() //=> "CssSyntaxError: app.css:1:1: Unclosed block
	     *                  //    > 1 | a {
	     *                  //        | ^"
	     *
	     * @return {string} error position, message and source code
	     */
	
	
	    CssSyntaxError.prototype.toString = function toString() {
	        var code = this.showSourceCode();
	        if (code) {
	            code = '\n\n' + code + '\n';
	        }
	        return this.name + ': ' + this.message + code;
	    };
	
	    _createClass(CssSyntaxError, [{
	        key: 'generated',
	        get: function get() {
	            (0, _warnOnce2.default)('CssSyntaxError#generated is deprecated. Use input instead.');
	            return this.input;
	        }
	
	        /**
	         * @memberof CssSyntaxError#
	         * @member {Input} input - Input object with PostCSS internal information
	         *                         about input file. If input has source map
	         *                         from previous tool, PostCSS will use origin
	         *                         (for example, Sass) source. You can use this
	         *                         object to get PostCSS input source.
	         *
	         * @example
	         * error.input.file //=> 'a.css'
	         * error.file       //=> 'a.sass'
	         */
	
	    }]);
	
	    return CssSyntaxError;
	}();
	
	exports.default = CssSyntaxError;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _cssSyntaxError = __webpack_require__(459);
	
	var _cssSyntaxError2 = _interopRequireDefault(_cssSyntaxError);
	
	var _previousMap = __webpack_require__(1483);
	
	var _previousMap2 = _interopRequireDefault(_previousMap);
	
	var _path = __webpack_require__(168);
	
	var _path2 = _interopRequireDefault(_path);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var sequence = 0;
	
	/**
	 * Represents the source CSS.
	 *
	 * @example
	 * const root  = postcss.parse(css, { from: file });
	 * const input = root.source.input;
	 */
	
	var Input = function () {
	
	    /**
	     * @param {string} css    - input CSS source
	     * @param {object} [opts] - {@link Processor#process} options
	     */
	    function Input(css) {
	        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        _classCallCheck(this, Input);
	
	        /**
	         * @member {string} - input CSS source
	         *
	         * @example
	         * const input = postcss.parse('a{}', { from: file }).input;
	         * input.css //=> "a{}";
	         */
	        this.css = css.toString();
	
	        if (this.css[0] === '\uFEFF' || this.css[0] === '\uFFFE') {
	            this.css = this.css.slice(1);
	        }
	
	        if (opts.from) {
	            if (/^\w+:\/\//.test(opts.from)) {
	                /**
	                 * @member {string} - The absolute path to the CSS source file
	                 *                    defined with the `from` option.
	                 *
	                 * @example
	                 * const root = postcss.parse(css, { from: 'a.css' });
	                 * root.source.input.file //=> '/home/ai/a.css'
	                 */
	                this.file = opts.from;
	            } else {
	                this.file = _path2.default.resolve(opts.from);
	            }
	        }
	
	        var map = new _previousMap2.default(this.css, opts);
	        if (map.text) {
	            /**
	             * @member {PreviousMap} - The input source map passed from
	             *                         a compilation step before PostCSS
	             *                         (for example, from Sass compiler).
	             *
	             * @example
	             * root.source.input.map.consumer().sources //=> ['a.sass']
	             */
	            this.map = map;
	            var file = map.consumer().file;
	            if (!this.file && file) this.file = this.mapResolve(file);
	        }
	
	        if (!this.file) {
	            sequence += 1;
	            /**
	             * @member {string} - The unique ID of the CSS source. It will be
	             *                    created if `from` option is not provided
	             *                    (because PostCSS does not know the file path).
	             *
	             * @example
	             * const root = postcss.parse(css);
	             * root.source.input.file //=> undefined
	             * root.source.input.id   //=> "<input css 1>"
	             */
	            this.id = '<input css ' + sequence + '>';
	        }
	        if (this.map) this.map.file = this.from;
	    }
	
	    Input.prototype.error = function error(message, line, column) {
	        var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	        var result = void 0;
	        var origin = this.origin(line, column);
	        if (origin) {
	            result = new _cssSyntaxError2.default(message, origin.line, origin.column, origin.source, origin.file, opts.plugin);
	        } else {
	            result = new _cssSyntaxError2.default(message, line, column, this.css, this.file, opts.plugin);
	        }
	
	        result.input = { line: line, column: column, source: this.css };
	        if (this.file) result.input.file = this.file;
	
	        return result;
	    };
	
	    /**
	     * Reads the input source map and returns a symbol position
	     * in the input source (e.g., in a Sass file that was compiled
	     * to CSS before being passed to PostCSS).
	     *
	     * @param {number} line   - line in input CSS
	     * @param {number} column - column in input CSS
	     *
	     * @return {filePosition} position in input source
	     *
	     * @example
	     * root.source.input.origin(1, 1) //=> { file: 'a.css', line: 3, column: 1 }
	     */
	
	
	    Input.prototype.origin = function origin(line, column) {
	        if (!this.map) return false;
	        var consumer = this.map.consumer();
	
	        var from = consumer.originalPositionFor({ line: line, column: column });
	        if (!from.source) return false;
	
	        var result = {
	            file: this.mapResolve(from.source),
	            line: from.line,
	            column: from.column
	        };
	
	        var source = consumer.sourceContentFor(from.source);
	        if (source) result.source = source;
	
	        return result;
	    };
	
	    Input.prototype.mapResolve = function mapResolve(file) {
	        if (/^\w+:\/\//.test(file)) {
	            return file;
	        } else {
	            return _path2.default.resolve(this.map.consumer().sourceRoot || '.', file);
	        }
	    };
	
	    /**
	     * The CSS source identifier. Contains {@link Input#file} if the user
	     * set the `from` option, or {@link Input#id} if they did not.
	     * @type {string}
	     *
	     * @example
	     * const root = postcss.parse(css, { from: 'a.css' });
	     * root.source.input.from //=> "/home/ai/a.css"
	     *
	     * const root = postcss.parse(css);
	     * root.source.input.from //=> "<input css 1>"
	     */
	
	
	    _createClass(Input, [{
	        key: 'from',
	        get: function get() {
	            return this.file || this.id;
	        }
	    }]);
	
	    return Input;
	}();
	
	exports.default = Input;
	
	/**
	 * @typedef  {object} filePosition
	 * @property {string} file   - path to file
	 * @property {number} line   - source line in file
	 * @property {number} column - source column in file
	 */
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _mapGenerator = __webpack_require__(1481);
	
	var _mapGenerator2 = _interopRequireDefault(_mapGenerator);
	
	var _stringify2 = __webpack_require__(320);
	
	var _stringify3 = _interopRequireDefault(_stringify2);
	
	var _warnOnce = __webpack_require__(79);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	var _result = __webpack_require__(1484);
	
	var _result2 = _interopRequireDefault(_result);
	
	var _parse = __webpack_require__(318);
	
	var _parse2 = _interopRequireDefault(_parse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function isPromise(obj) {
	    return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && typeof obj.then === 'function';
	}
	
	/**
	 * A Promise proxy for the result of PostCSS transformations.
	 *
	 * A `LazyResult` instance is returned by {@link Processor#process}.
	 *
	 * @example
	 * const lazy = postcss([cssnext]).process(css);
	 */
	
	var LazyResult = function () {
	    function LazyResult(processor, css, opts) {
	        _classCallCheck(this, LazyResult);
	
	        this.stringified = false;
	        this.processed = false;
	
	        var root = void 0;
	        if ((typeof css === 'undefined' ? 'undefined' : _typeof(css)) === 'object' && css.type === 'root') {
	            root = css;
	        } else if (css instanceof LazyResult || css instanceof _result2.default) {
	            root = css.root;
	            if (css.map) {
	                if (typeof opts.map === 'undefined') opts.map = {};
	                if (!opts.map.inline) opts.map.inline = false;
	                opts.map.prev = css.map;
	            }
	        } else {
	            var parser = _parse2.default;
	            if (opts.syntax) parser = opts.syntax.parse;
	            if (opts.parser) parser = opts.parser;
	            if (parser.parse) parser = parser.parse;
	
	            try {
	                root = parser(css, opts);
	            } catch (error) {
	                this.error = error;
	            }
	        }
	
	        this.result = new _result2.default(processor, root, opts);
	    }
	
	    /**
	     * Returns a {@link Processor} instance, which will be used
	     * for CSS transformations.
	     * @type {Processor}
	     */
	
	
	    /**
	     * Processes input CSS through synchronous plugins
	     * and calls {@link Result#warnings()}.
	     *
	     * @return {Warning[]} warnings from plugins
	     */
	    LazyResult.prototype.warnings = function warnings() {
	        return this.sync().warnings();
	    };
	
	    /**
	     * Alias for the {@link LazyResult#css} property.
	     *
	     * @example
	     * lazy + '' === lazy.css;
	     *
	     * @return {string} output CSS
	     */
	
	
	    LazyResult.prototype.toString = function toString() {
	        return this.css;
	    };
	
	    /**
	     * Processes input CSS through synchronous and asynchronous plugins
	     * and calls `onFulfilled` with a Result instance. If a plugin throws
	     * an error, the `onRejected` callback will be executed.
	     *
	     * It implements standard Promise API.
	     *
	     * @param {onFulfilled} onFulfilled - callback will be executed
	     *                                    when all plugins will finish work
	     * @param {onRejected}  onRejected  - callback will be executed on any error
	     *
	     * @return {Promise} Promise API to make queue
	     *
	     * @example
	     * postcss([cssnext]).process(css).then(result => {
	     *   console.log(result.css);
	     * });
	     */
	
	
	    LazyResult.prototype.then = function then(onFulfilled, onRejected) {
	        return this.async().then(onFulfilled, onRejected);
	    };
	
	    /**
	     * Processes input CSS through synchronous and asynchronous plugins
	     * and calls onRejected for each error thrown in any plugin.
	     *
	     * It implements standard Promise API.
	     *
	     * @param {onRejected} onRejected - callback will be executed on any error
	     *
	     * @return {Promise} Promise API to make queue
	     *
	     * @example
	     * postcss([cssnext]).process(css).then(result => {
	     *   console.log(result.css);
	     * }).catch(error => {
	     *   console.error(error);
	     * });
	     */
	
	
	    LazyResult.prototype.catch = function _catch(onRejected) {
	        return this.async().catch(onRejected);
	    };
	
	    LazyResult.prototype.handleError = function handleError(error, plugin) {
	        try {
	            this.error = error;
	            if (error.name === 'CssSyntaxError' && !error.plugin) {
	                error.plugin = plugin.postcssPlugin;
	                error.setMessage();
	            } else if (plugin.postcssVersion) {
	                var pluginName = plugin.postcssPlugin;
	                var pluginVer = plugin.postcssVersion;
	                var runtimeVer = this.result.processor.version;
	                var a = pluginVer.split('.');
	                var b = runtimeVer.split('.');
	
	                if (a[0] !== b[0] || parseInt(a[1]) > parseInt(b[1])) {
	                    (0, _warnOnce2.default)('Your current PostCSS version ' + 'is ' + runtimeVer + ', but ' + pluginName + ' ' + 'uses ' + pluginVer + '. Perhaps this is ' + 'the source of the error below.');
	                }
	            }
	        } catch (err) {
	            if (console && console.error) console.error(err);
	        }
	    };
	
	    LazyResult.prototype.asyncTick = function asyncTick(resolve, reject) {
	        var _this = this;
	
	        if (this.plugin >= this.processor.plugins.length) {
	            this.processed = true;
	            return resolve();
	        }
	
	        try {
	            var plugin = this.processor.plugins[this.plugin];
	            var promise = this.run(plugin);
	            this.plugin += 1;
	
	            if (isPromise(promise)) {
	                promise.then(function () {
	                    _this.asyncTick(resolve, reject);
	                }).catch(function (error) {
	                    _this.handleError(error, plugin);
	                    _this.processed = true;
	                    reject(error);
	                });
	            } else {
	                this.asyncTick(resolve, reject);
	            }
	        } catch (error) {
	            this.processed = true;
	            reject(error);
	        }
	    };
	
	    LazyResult.prototype.async = function async() {
	        var _this2 = this;
	
	        if (this.processed) {
	            return new Promise(function (resolve, reject) {
	                if (_this2.error) {
	                    reject(_this2.error);
	                } else {
	                    resolve(_this2.stringify());
	                }
	            });
	        }
	        if (this.processing) {
	            return this.processing;
	        }
	
	        this.processing = new Promise(function (resolve, reject) {
	            if (_this2.error) return reject(_this2.error);
	            _this2.plugin = 0;
	            _this2.asyncTick(resolve, reject);
	        }).then(function () {
	            _this2.processed = true;
	            return _this2.stringify();
	        });
	
	        return this.processing;
	    };
	
	    LazyResult.prototype.sync = function sync() {
	        if (this.processed) return this.result;
	        this.processed = true;
	
	        if (this.processing) {
	            throw new Error('Use process(css).then(cb) to work with async plugins');
	        }
	
	        if (this.error) throw this.error;
	
	        for (var _iterator = this.result.processor.plugins, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	            }
	
	            var plugin = _ref;
	
	            var promise = this.run(plugin);
	            if (isPromise(promise)) {
	                throw new Error('Use process(css).then(cb) to work with async plugins');
	            }
	        }
	
	        return this.result;
	    };
	
	    LazyResult.prototype.run = function run(plugin) {
	        this.result.lastPlugin = plugin;
	
	        try {
	            return plugin(this.result.root, this.result);
	        } catch (error) {
	            this.handleError(error, plugin);
	            throw error;
	        }
	    };
	
	    LazyResult.prototype.stringify = function stringify() {
	        if (this.stringified) return this.result;
	        this.stringified = true;
	
	        this.sync();
	
	        var opts = this.result.opts;
	        var str = _stringify3.default;
	        if (opts.syntax) str = opts.syntax.stringify;
	        if (opts.stringifier) str = opts.stringifier;
	        if (str.stringify) str = str.stringify;
	
	        var map = new _mapGenerator2.default(str, this.result.root, this.result.opts);
	        var data = map.generate();
	        this.result.css = data[0];
	        this.result.map = data[1];
	
	        return this.result;
	    };
	
	    _createClass(LazyResult, [{
	        key: 'processor',
	        get: function get() {
	            return this.result.processor;
	        }
	
	        /**
	         * Options from the {@link Processor#process} call.
	         * @type {processOptions}
	         */
	
	    }, {
	        key: 'opts',
	        get: function get() {
	            return this.result.opts;
	        }
	
	        /**
	         * Processes input CSS through synchronous plugins, converts `Root`
	         * to a CSS string and returns {@link Result#css}.
	         *
	         * This property will only work with synchronous plugins.
	         * If the processor contains any asynchronous plugins
	         * it will throw an error. This is why this method is only
	         * for debug purpose, you should always use {@link LazyResult#then}.
	         *
	         * @type {string}
	         * @see Result#css
	         */
	
	    }, {
	        key: 'css',
	        get: function get() {
	            return this.stringify().css;
	        }
	
	        /**
	         * An alias for the `css` property. Use it with syntaxes
	         * that generate non-CSS output.
	         *
	         * This property will only work with synchronous plugins.
	         * If the processor contains any asynchronous plugins
	         * it will throw an error. This is why this method is only
	         * for debug purpose, you should always use {@link LazyResult#then}.
	         *
	         * @type {string}
	         * @see Result#content
	         */
	
	    }, {
	        key: 'content',
	        get: function get() {
	            return this.stringify().content;
	        }
	
	        /**
	         * Processes input CSS through synchronous plugins
	         * and returns {@link Result#map}.
	         *
	         * This property will only work with synchronous plugins.
	         * If the processor contains any asynchronous plugins
	         * it will throw an error. This is why this method is only
	         * for debug purpose, you should always use {@link LazyResult#then}.
	         *
	         * @type {SourceMapGenerator}
	         * @see Result#map
	         */
	
	    }, {
	        key: 'map',
	        get: function get() {
	            return this.stringify().map;
	        }
	
	        /**
	         * Processes input CSS through synchronous plugins
	         * and returns {@link Result#root}.
	         *
	         * This property will only work with synchronous plugins. If the processor
	         * contains any asynchronous plugins it will throw an error.
	         *
	         * This is why this method is only for debug purpose,
	         * you should always use {@link LazyResult#then}.
	         *
	         * @type {Root}
	         * @see Result#root
	         */
	
	    }, {
	        key: 'root',
	        get: function get() {
	            return this.sync().root;
	        }
	
	        /**
	         * Processes input CSS through synchronous plugins
	         * and returns {@link Result#messages}.
	         *
	         * This property will only work with synchronous plugins. If the processor
	         * contains any asynchronous plugins it will throw an error.
	         *
	         * This is why this method is only for debug purpose,
	         * you should always use {@link LazyResult#then}.
	         *
	         * @type {Message[]}
	         * @see Result#messages
	         */
	
	    }, {
	        key: 'messages',
	        get: function get() {
	            return this.sync().messages;
	        }
	    }]);
	
	    return LazyResult;
	}();
	
	exports.default = LazyResult;
	
	/**
	 * @callback onFulfilled
	 * @param {Result} result
	 */
	
	/**
	 * @callback onRejected
	 * @param {Error} error
	 */
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImxhenktcmVzdWx0LmVzNiJdLCJuYW1lcyI6WyJpc1Byb21pc2UiLCJvYmoiLCJ0aGVuIiwiTGF6eVJlc3VsdCIsInByb2Nlc3NvciIsImNzcyIsIm9wdHMiLCJzdHJpbmdpZmllZCIsInByb2Nlc3NlZCIsInJvb3QiLCJ0eXBlIiwibWFwIiwiaW5saW5lIiwicHJldiIsInBhcnNlciIsInN5bnRheCIsInBhcnNlIiwiZXJyb3IiLCJyZXN1bHQiLCJ3YXJuaW5ncyIsInN5bmMiLCJ0b1N0cmluZyIsIm9uRnVsZmlsbGVkIiwib25SZWplY3RlZCIsImFzeW5jIiwiY2F0Y2giLCJoYW5kbGVFcnJvciIsInBsdWdpbiIsIm5hbWUiLCJwb3N0Y3NzUGx1Z2luIiwic2V0TWVzc2FnZSIsInBvc3Rjc3NWZXJzaW9uIiwicGx1Z2luTmFtZSIsInBsdWdpblZlciIsInJ1bnRpbWVWZXIiLCJ2ZXJzaW9uIiwiYSIsInNwbGl0IiwiYiIsInBhcnNlSW50IiwiZXJyIiwiY29uc29sZSIsImFzeW5jVGljayIsInJlc29sdmUiLCJyZWplY3QiLCJwbHVnaW5zIiwibGVuZ3RoIiwicHJvbWlzZSIsInJ1biIsIlByb21pc2UiLCJzdHJpbmdpZnkiLCJwcm9jZXNzaW5nIiwiRXJyb3IiLCJsYXN0UGx1Z2luIiwic3RyIiwic3RyaW5naWZpZXIiLCJkYXRhIiwiZ2VuZXJhdGUiLCJjb250ZW50IiwibWVzc2FnZXMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7Ozs7Ozs7QUFFQSxTQUFTQSxTQUFULENBQW1CQyxHQUFuQixFQUF3QjtBQUNwQixXQUFPLFFBQU9BLEdBQVAseUNBQU9BLEdBQVAsT0FBZSxRQUFmLElBQTJCLE9BQU9BLElBQUlDLElBQVgsS0FBb0IsVUFBdEQ7QUFDSDs7QUFFRDs7Ozs7Ozs7O0lBUU1DLFU7QUFFRix3QkFBWUMsU0FBWixFQUF1QkMsR0FBdkIsRUFBNEJDLElBQTVCLEVBQWtDO0FBQUE7O0FBQzlCLGFBQUtDLFdBQUwsR0FBbUIsS0FBbkI7QUFDQSxhQUFLQyxTQUFMLEdBQW1CLEtBQW5COztBQUVBLFlBQUlDLGFBQUo7QUFDQSxZQUFLLFFBQU9KLEdBQVAseUNBQU9BLEdBQVAsT0FBZSxRQUFmLElBQTJCQSxJQUFJSyxJQUFKLEtBQWEsTUFBN0MsRUFBc0Q7QUFDbERELG1CQUFPSixHQUFQO0FBQ0gsU0FGRCxNQUVPLElBQUtBLGVBQWVGLFVBQWYsSUFBNkJFLCtCQUFsQyxFQUEwRDtBQUM3REksbUJBQU9KLElBQUlJLElBQVg7QUFDQSxnQkFBS0osSUFBSU0sR0FBVCxFQUFlO0FBQ1gsb0JBQUssT0FBT0wsS0FBS0ssR0FBWixLQUFvQixXQUF6QixFQUF1Q0wsS0FBS0ssR0FBTCxHQUFXLEVBQVg7QUFDdkMsb0JBQUssQ0FBQ0wsS0FBS0ssR0FBTCxDQUFTQyxNQUFmLEVBQXdCTixLQUFLSyxHQUFMLENBQVNDLE1BQVQsR0FBa0IsS0FBbEI7QUFDeEJOLHFCQUFLSyxHQUFMLENBQVNFLElBQVQsR0FBZ0JSLElBQUlNLEdBQXBCO0FBQ0g7QUFDSixTQVBNLE1BT0E7QUFDSCxnQkFBSUcsd0JBQUo7QUFDQSxnQkFBS1IsS0FBS1MsTUFBVixFQUFvQkQsU0FBU1IsS0FBS1MsTUFBTCxDQUFZQyxLQUFyQjtBQUNwQixnQkFBS1YsS0FBS1EsTUFBVixFQUFvQkEsU0FBU1IsS0FBS1EsTUFBZDtBQUNwQixnQkFBS0EsT0FBT0UsS0FBWixFQUFvQkYsU0FBU0EsT0FBT0UsS0FBaEI7O0FBRXBCLGdCQUFJO0FBQ0FQLHVCQUFPSyxPQUFPVCxHQUFQLEVBQVlDLElBQVosQ0FBUDtBQUNILGFBRkQsQ0FFRSxPQUFPVyxLQUFQLEVBQWM7QUFDWixxQkFBS0EsS0FBTCxHQUFhQSxLQUFiO0FBQ0g7QUFDSjs7QUFFRCxhQUFLQyxNQUFMLEdBQWMscUJBQVdkLFNBQVgsRUFBc0JLLElBQXRCLEVBQTRCSCxJQUE1QixDQUFkO0FBQ0g7O0FBRUQ7Ozs7Ozs7QUFtR0E7Ozs7Ozt5QkFNQWEsUSx1QkFBVztBQUNQLGVBQU8sS0FBS0MsSUFBTCxHQUFZRCxRQUFaLEVBQVA7QUFDSCxLOztBQUVEOzs7Ozs7Ozs7O3lCQVFBRSxRLHVCQUFXO0FBQ1AsZUFBTyxLQUFLaEIsR0FBWjtBQUNILEs7O0FBRUQ7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O3lCQWtCQUgsSSxpQkFBS29CLFcsRUFBYUMsVSxFQUFZO0FBQzFCLGVBQU8sS0FBS0MsS0FBTCxHQUFhdEIsSUFBYixDQUFrQm9CLFdBQWxCLEVBQStCQyxVQUEvQixDQUFQO0FBQ0gsSzs7QUFFRDs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozt5QkFpQkFFLEssbUJBQU1GLFUsRUFBWTtBQUNkLGVBQU8sS0FBS0MsS0FBTCxHQUFhQyxLQUFiLENBQW1CRixVQUFuQixDQUFQO0FBQ0gsSzs7eUJBRURHLFcsd0JBQVlULEssRUFBT1UsTSxFQUFRO0FBQ3ZCLFlBQUk7QUFDQSxpQkFBS1YsS0FBTCxHQUFhQSxLQUFiO0FBQ0EsZ0JBQUtBLE1BQU1XLElBQU4sS0FBZSxnQkFBZixJQUFtQyxDQUFDWCxNQUFNVSxNQUEvQyxFQUF3RDtBQUNwRFYsc0JBQU1VLE1BQU4sR0FBZUEsT0FBT0UsYUFBdEI7QUFDQVosc0JBQU1hLFVBQU47QUFDSCxhQUhELE1BR08sSUFBS0gsT0FBT0ksY0FBWixFQUE2QjtBQUNoQyxvQkFBSUMsYUFBYUwsT0FBT0UsYUFBeEI7QUFDQSxvQkFBSUksWUFBYU4sT0FBT0ksY0FBeEI7QUFDQSxvQkFBSUcsYUFBYSxLQUFLaEIsTUFBTCxDQUFZZCxTQUFaLENBQXNCK0IsT0FBdkM7QUFDQSxvQkFBSUMsSUFBSUgsVUFBVUksS0FBVixDQUFnQixHQUFoQixDQUFSO0FBQ0Esb0JBQUlDLElBQUlKLFdBQVdHLEtBQVgsQ0FBaUIsR0FBakIsQ0FBUjs7QUFFQSxvQkFBS0QsRUFBRSxDQUFGLE1BQVNFLEVBQUUsQ0FBRixDQUFULElBQWlCQyxTQUFTSCxFQUFFLENBQUYsQ0FBVCxJQUFpQkcsU0FBU0QsRUFBRSxDQUFGLENBQVQsQ0FBdkMsRUFBd0Q7QUFDcEQsNENBQVMsa0NBQ0EsS0FEQSxHQUNRSixVQURSLEdBQ3FCLFFBRHJCLEdBQ2dDRixVQURoQyxHQUM2QyxHQUQ3QyxHQUVBLE9BRkEsR0FFVUMsU0FGVixHQUVzQixvQkFGdEIsR0FHQSxnQ0FIVDtBQUlIO0FBQ0o7QUFDSixTQW5CRCxDQW1CRSxPQUFPTyxHQUFQLEVBQVk7QUFDVixnQkFBS0MsV0FBV0EsUUFBUXhCLEtBQXhCLEVBQWdDd0IsUUFBUXhCLEtBQVIsQ0FBY3VCLEdBQWQ7QUFDbkM7QUFDSixLOzt5QkFFREUsUyxzQkFBVUMsTyxFQUFTQyxNLEVBQVE7QUFBQTs7QUFDdkIsWUFBSyxLQUFLakIsTUFBTCxJQUFlLEtBQUt2QixTQUFMLENBQWV5QyxPQUFmLENBQXVCQyxNQUEzQyxFQUFvRDtBQUNoRCxpQkFBS3RDLFNBQUwsR0FBaUIsSUFBakI7QUFDQSxtQkFBT21DLFNBQVA7QUFDSDs7QUFFRCxZQUFJO0FBQ0EsZ0JBQUloQixTQUFVLEtBQUt2QixTQUFMLENBQWV5QyxPQUFmLENBQXVCLEtBQUtsQixNQUE1QixDQUFkO0FBQ0EsZ0JBQUlvQixVQUFVLEtBQUtDLEdBQUwsQ0FBU3JCLE1BQVQsQ0FBZDtBQUNBLGlCQUFLQSxNQUFMLElBQWUsQ0FBZjs7QUFFQSxnQkFBSzNCLFVBQVUrQyxPQUFWLENBQUwsRUFBMEI7QUFDdEJBLHdCQUFRN0MsSUFBUixDQUFjLFlBQU07QUFDaEIsMEJBQUt3QyxTQUFMLENBQWVDLE9BQWYsRUFBd0JDLE1BQXhCO0FBQ0gsaUJBRkQsRUFFR25CLEtBRkgsQ0FFVSxpQkFBUztBQUNmLDBCQUFLQyxXQUFMLENBQWlCVCxLQUFqQixFQUF3QlUsTUFBeEI7QUFDQSwwQkFBS25CLFNBQUwsR0FBaUIsSUFBakI7QUFDQW9DLDJCQUFPM0IsS0FBUDtBQUNILGlCQU5EO0FBT0gsYUFSRCxNQVFPO0FBQ0gscUJBQUt5QixTQUFMLENBQWVDLE9BQWYsRUFBd0JDLE1BQXhCO0FBQ0g7QUFFSixTQWpCRCxDQWlCRSxPQUFPM0IsS0FBUCxFQUFjO0FBQ1osaUJBQUtULFNBQUwsR0FBaUIsSUFBakI7QUFDQW9DLG1CQUFPM0IsS0FBUDtBQUNIO0FBQ0osSzs7eUJBRURPLEssb0JBQVE7QUFBQTs7QUFDSixZQUFLLEtBQUtoQixTQUFWLEVBQXNCO0FBQ2xCLG1CQUFPLElBQUl5QyxPQUFKLENBQWEsVUFBQ04sT0FBRCxFQUFVQyxNQUFWLEVBQXFCO0FBQ3JDLG9CQUFLLE9BQUszQixLQUFWLEVBQWtCO0FBQ2QyQiwyQkFBTyxPQUFLM0IsS0FBWjtBQUNILGlCQUZELE1BRU87QUFDSDBCLDRCQUFRLE9BQUtPLFNBQUwsRUFBUjtBQUNIO0FBQ0osYUFOTSxDQUFQO0FBT0g7QUFDRCxZQUFLLEtBQUtDLFVBQVYsRUFBdUI7QUFDbkIsbUJBQU8sS0FBS0EsVUFBWjtBQUNIOztBQUVELGFBQUtBLFVBQUwsR0FBa0IsSUFBSUYsT0FBSixDQUFhLFVBQUNOLE9BQUQsRUFBVUMsTUFBVixFQUFxQjtBQUNoRCxnQkFBSyxPQUFLM0IsS0FBVixFQUFrQixPQUFPMkIsT0FBTyxPQUFLM0IsS0FBWixDQUFQO0FBQ2xCLG1CQUFLVSxNQUFMLEdBQWMsQ0FBZDtBQUNBLG1CQUFLZSxTQUFMLENBQWVDLE9BQWYsRUFBd0JDLE1BQXhCO0FBQ0gsU0FKaUIsRUFJZjFDLElBSmUsQ0FJVCxZQUFNO0FBQ1gsbUJBQUtNLFNBQUwsR0FBaUIsSUFBakI7QUFDQSxtQkFBTyxPQUFLMEMsU0FBTCxFQUFQO0FBQ0gsU0FQaUIsQ0FBbEI7O0FBU0EsZUFBTyxLQUFLQyxVQUFaO0FBQ0gsSzs7eUJBRUQvQixJLG1CQUFPO0FBQ0gsWUFBSyxLQUFLWixTQUFWLEVBQXNCLE9BQU8sS0FBS1UsTUFBWjtBQUN0QixhQUFLVixTQUFMLEdBQWlCLElBQWpCOztBQUVBLFlBQUssS0FBSzJDLFVBQVYsRUFBdUI7QUFDbkIsa0JBQU0sSUFBSUMsS0FBSixDQUNGLHNEQURFLENBQU47QUFFSDs7QUFFRCxZQUFLLEtBQUtuQyxLQUFWLEVBQWtCLE1BQU0sS0FBS0EsS0FBWDs7QUFFbEIsNkJBQW9CLEtBQUtDLE1BQUwsQ0FBWWQsU0FBWixDQUFzQnlDLE9BQTFDLGtIQUFvRDtBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBQUEsZ0JBQTFDbEIsTUFBMEM7O0FBQ2hELGdCQUFJb0IsVUFBVSxLQUFLQyxHQUFMLENBQVNyQixNQUFULENBQWQ7QUFDQSxnQkFBSzNCLFVBQVUrQyxPQUFWLENBQUwsRUFBMEI7QUFDdEIsc0JBQU0sSUFBSUssS0FBSixDQUNGLHNEQURFLENBQU47QUFFSDtBQUNKOztBQUVELGVBQU8sS0FBS2xDLE1BQVo7QUFDSCxLOzt5QkFFRDhCLEcsZ0JBQUlyQixNLEVBQVE7QUFDUixhQUFLVCxNQUFMLENBQVltQyxVQUFaLEdBQXlCMUIsTUFBekI7O0FBRUEsWUFBSTtBQUNBLG1CQUFPQSxPQUFPLEtBQUtULE1BQUwsQ0FBWVQsSUFBbkIsRUFBeUIsS0FBS1MsTUFBOUIsQ0FBUDtBQUNILFNBRkQsQ0FFRSxPQUFPRCxLQUFQLEVBQWM7QUFDWixpQkFBS1MsV0FBTCxDQUFpQlQsS0FBakIsRUFBd0JVLE1BQXhCO0FBQ0Esa0JBQU1WLEtBQU47QUFDSDtBQUNKLEs7O3lCQUVEaUMsUyx3QkFBWTtBQUNSLFlBQUssS0FBSzNDLFdBQVYsRUFBd0IsT0FBTyxLQUFLVyxNQUFaO0FBQ3hCLGFBQUtYLFdBQUwsR0FBbUIsSUFBbkI7O0FBRUEsYUFBS2EsSUFBTDs7QUFFQSxZQUFJZCxPQUFPLEtBQUtZLE1BQUwsQ0FBWVosSUFBdkI7QUFDQSxZQUFJZ0QseUJBQUo7QUFDQSxZQUFLaEQsS0FBS1MsTUFBVixFQUF3QnVDLE1BQU1oRCxLQUFLUyxNQUFMLENBQVltQyxTQUFsQjtBQUN4QixZQUFLNUMsS0FBS2lELFdBQVYsRUFBd0JELE1BQU1oRCxLQUFLaUQsV0FBWDtBQUN4QixZQUFLRCxJQUFJSixTQUFULEVBQXdCSSxNQUFNQSxJQUFJSixTQUFWOztBQUV4QixZQUFJdkMsTUFBTywyQkFBaUIyQyxHQUFqQixFQUFzQixLQUFLcEMsTUFBTCxDQUFZVCxJQUFsQyxFQUF3QyxLQUFLUyxNQUFMLENBQVlaLElBQXBELENBQVg7QUFDQSxZQUFJa0QsT0FBTzdDLElBQUk4QyxRQUFKLEVBQVg7QUFDQSxhQUFLdkMsTUFBTCxDQUFZYixHQUFaLEdBQWtCbUQsS0FBSyxDQUFMLENBQWxCO0FBQ0EsYUFBS3RDLE1BQUwsQ0FBWVAsR0FBWixHQUFrQjZDLEtBQUssQ0FBTCxDQUFsQjs7QUFFQSxlQUFPLEtBQUt0QyxNQUFaO0FBQ0gsSzs7Ozs0QkFsU2U7QUFDWixtQkFBTyxLQUFLQSxNQUFMLENBQVlkLFNBQW5CO0FBQ0g7O0FBRUQ7Ozs7Ozs7NEJBSVc7QUFDUCxtQkFBTyxLQUFLYyxNQUFMLENBQVlaLElBQW5CO0FBQ0g7O0FBRUQ7Ozs7Ozs7Ozs7Ozs7Ozs0QkFZVTtBQUNOLG1CQUFPLEtBQUs0QyxTQUFMLEdBQWlCN0MsR0FBeEI7QUFDSDs7QUFFRDs7Ozs7Ozs7Ozs7Ozs7OzRCQVljO0FBQ1YsbUJBQU8sS0FBSzZDLFNBQUwsR0FBaUJRLE9BQXhCO0FBQ0g7O0FBRUQ7Ozs7Ozs7Ozs7Ozs7Ozs0QkFZVTtBQUNOLG1CQUFPLEtBQUtSLFNBQUwsR0FBaUJ2QyxHQUF4QjtBQUNIOztBQUVEOzs7Ozs7Ozs7Ozs7Ozs7OzRCQWFXO0FBQ1AsbUJBQU8sS0FBS1MsSUFBTCxHQUFZWCxJQUFuQjtBQUNIOztBQUVEOzs7Ozs7Ozs7Ozs7Ozs7OzRCQWFlO0FBQ1gsbUJBQU8sS0FBS1csSUFBTCxHQUFZdUMsUUFBbkI7QUFDSDs7Ozs7O2tCQTBNVXhELFU7O0FBRWY7Ozs7O0FBS0EiLCJmaWxlIjoibGF6eS1yZXN1bHQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgTWFwR2VuZXJhdG9yIGZyb20gJy4vbWFwLWdlbmVyYXRvcic7XG5pbXBvcnQgc3RyaW5naWZ5ICAgIGZyb20gJy4vc3RyaW5naWZ5JztcbmltcG9ydCB3YXJuT25jZSAgICAgZnJvbSAnLi93YXJuLW9uY2UnO1xuaW1wb3J0IFJlc3VsdCAgICAgICBmcm9tICcuL3Jlc3VsdCc7XG5pbXBvcnQgcGFyc2UgICAgICAgIGZyb20gJy4vcGFyc2UnO1xuXG5mdW5jdGlvbiBpc1Byb21pc2Uob2JqKSB7XG4gICAgcmV0dXJuIHR5cGVvZiBvYmogPT09ICdvYmplY3QnICYmIHR5cGVvZiBvYmoudGhlbiA9PT0gJ2Z1bmN0aW9uJztcbn1cblxuLyoqXG4gKiBBIFByb21pc2UgcHJveHkgZm9yIHRoZSByZXN1bHQgb2YgUG9zdENTUyB0cmFuc2Zvcm1hdGlvbnMuXG4gKlxuICogQSBgTGF6eVJlc3VsdGAgaW5zdGFuY2UgaXMgcmV0dXJuZWQgYnkge0BsaW5rIFByb2Nlc3NvciNwcm9jZXNzfS5cbiAqXG4gKiBAZXhhbXBsZVxuICogY29uc3QgbGF6eSA9IHBvc3Rjc3MoW2Nzc25leHRdKS5wcm9jZXNzKGNzcyk7XG4gKi9cbmNsYXNzIExhenlSZXN1bHQge1xuXG4gICAgY29uc3RydWN0b3IocHJvY2Vzc29yLCBjc3MsIG9wdHMpIHtcbiAgICAgICAgdGhpcy5zdHJpbmdpZmllZCA9IGZhbHNlO1xuICAgICAgICB0aGlzLnByb2Nlc3NlZCAgID0gZmFsc2U7XG5cbiAgICAgICAgbGV0IHJvb3Q7XG4gICAgICAgIGlmICggdHlwZW9mIGNzcyA9PT0gJ29iamVjdCcgJiYgY3NzLnR5cGUgPT09ICdyb290JyApIHtcbiAgICAgICAgICAgIHJvb3QgPSBjc3M7XG4gICAgICAgIH0gZWxzZSBpZiAoIGNzcyBpbnN0YW5jZW9mIExhenlSZXN1bHQgfHwgY3NzIGluc3RhbmNlb2YgUmVzdWx0ICkge1xuICAgICAgICAgICAgcm9vdCA9IGNzcy5yb290O1xuICAgICAgICAgICAgaWYgKCBjc3MubWFwICkge1xuICAgICAgICAgICAgICAgIGlmICggdHlwZW9mIG9wdHMubWFwID09PSAndW5kZWZpbmVkJyApIG9wdHMubWFwID0geyB9O1xuICAgICAgICAgICAgICAgIGlmICggIW9wdHMubWFwLmlubGluZSApIG9wdHMubWFwLmlubGluZSA9IGZhbHNlO1xuICAgICAgICAgICAgICAgIG9wdHMubWFwLnByZXYgPSBjc3MubWFwO1xuICAgICAgICAgICAgfVxuICAgICAgICB9IGVsc2Uge1xuICAgICAgICAgICAgbGV0IHBhcnNlciA9IHBhcnNlO1xuICAgICAgICAgICAgaWYgKCBvcHRzLnN5bnRheCApICBwYXJzZXIgPSBvcHRzLnN5bnRheC5wYXJzZTtcbiAgICAgICAgICAgIGlmICggb3B0cy5wYXJzZXIgKSAgcGFyc2VyID0gb3B0cy5wYXJzZXI7XG4gICAgICAgICAgICBpZiAoIHBhcnNlci5wYXJzZSApIHBhcnNlciA9IHBhcnNlci5wYXJzZTtcblxuICAgICAgICAgICAgdHJ5IHtcbiAgICAgICAgICAgICAgICByb290ID0gcGFyc2VyKGNzcywgb3B0cyk7XG4gICAgICAgICAgICB9IGNhdGNoIChlcnJvcikge1xuICAgICAgICAgICAgICAgIHRoaXMuZXJyb3IgPSBlcnJvcjtcbiAgICAgICAgICAgIH1cbiAgICAgICAgfVxuXG4gICAgICAgIHRoaXMucmVzdWx0ID0gbmV3IFJlc3VsdChwcm9jZXNzb3IsIHJvb3QsIG9wdHMpO1xuICAgIH1cblxuICAgIC8qKlxuICAgICAqIFJldHVybnMgYSB7QGxpbmsgUHJvY2Vzc29yfSBpbnN0YW5jZSwgd2hpY2ggd2lsbCBiZSB1c2VkXG4gICAgICogZm9yIENTUyB0cmFuc2Zvcm1hdGlvbnMuXG4gICAgICogQHR5cGUge1Byb2Nlc3Nvcn1cbiAgICAgKi9cbiAgICBnZXQgcHJvY2Vzc29yKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5yZXN1bHQucHJvY2Vzc29yO1xuICAgIH1cblxuICAgIC8qKlxuICAgICAqIE9wdGlvbnMgZnJvbSB0aGUge0BsaW5rIFByb2Nlc3NvciNwcm9jZXNzfSBjYWxsLlxuICAgICAqIEB0eXBlIHtwcm9jZXNzT3B0aW9uc31cbiAgICAgKi9cbiAgICBnZXQgb3B0cygpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMucmVzdWx0Lm9wdHM7XG4gICAgfVxuXG4gICAgLyoqXG4gICAgICogUHJvY2Vzc2VzIGlucHV0IENTUyB0aHJvdWdoIHN5bmNocm9ub3VzIHBsdWdpbnMsIGNvbnZlcnRzIGBSb290YFxuICAgICAqIHRvIGEgQ1NTIHN0cmluZyBhbmQgcmV0dXJucyB7QGxpbmsgUmVzdWx0I2Nzc30uXG4gICAgICpcbiAgICAgKiBUaGlzIHByb3BlcnR5IHdpbGwgb25seSB3b3JrIHdpdGggc3luY2hyb25vdXMgcGx1Z2lucy5cbiAgICAgKiBJZiB0aGUgcHJvY2Vzc29yIGNvbnRhaW5zIGFueSBhc3luY2hyb25vdXMgcGx1Z2luc1xuICAgICAqIGl0IHdpbGwgdGhyb3cgYW4gZXJyb3IuIFRoaXMgaXMgd2h5IHRoaXMgbWV0aG9kIGlzIG9ubHlcbiAgICAgKiBmb3IgZGVidWcgcHVycG9zZSwgeW91IHNob3VsZCBhbHdheXMgdXNlIHtAbGluayBMYXp5UmVzdWx0I3RoZW59LlxuICAgICAqXG4gICAgICogQHR5cGUge3N0cmluZ31cbiAgICAgKiBAc2VlIFJlc3VsdCNjc3NcbiAgICAgKi9cbiAgICBnZXQgY3NzKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5zdHJpbmdpZnkoKS5jc3M7XG4gICAgfVxuXG4gICAgLyoqXG4gICAgICogQW4gYWxpYXMgZm9yIHRoZSBgY3NzYCBwcm9wZXJ0eS4gVXNlIGl0IHdpdGggc3ludGF4ZXNcbiAgICAgKiB0aGF0IGdlbmVyYXRlIG5vbi1DU1Mgb3V0cHV0LlxuICAgICAqXG4gICAgICogVGhpcyBwcm9wZXJ0eSB3aWxsIG9ubHkgd29yayB3aXRoIHN5bmNocm9ub3VzIHBsdWdpbnMuXG4gICAgICogSWYgdGhlIHByb2Nlc3NvciBjb250YWlucyBhbnkgYXN5bmNocm9ub3VzIHBsdWdpbnNcbiAgICAgKiBpdCB3aWxsIHRocm93IGFuIGVycm9yLiBUaGlzIGlzIHdoeSB0aGlzIG1ldGhvZCBpcyBvbmx5XG4gICAgICogZm9yIGRlYnVnIHB1cnBvc2UsIHlvdSBzaG91bGQgYWx3YXlzIHVzZSB7QGxpbmsgTGF6eVJlc3VsdCN0aGVufS5cbiAgICAgKlxuICAgICAqIEB0eXBlIHtzdHJpbmd9XG4gICAgICogQHNlZSBSZXN1bHQjY29udGVudFxuICAgICAqL1xuICAgIGdldCBjb250ZW50KCkge1xuICAgICAgICByZXR1cm4gdGhpcy5zdHJpbmdpZnkoKS5jb250ZW50O1xuICAgIH1cblxuICAgIC8qKlxuICAgICAqIFByb2Nlc3NlcyBpbnB1dCBDU1MgdGhyb3VnaCBzeW5jaHJvbm91cyBwbHVnaW5zXG4gICAgICogYW5kIHJldHVybnMge0BsaW5rIFJlc3VsdCNtYXB9LlxuICAgICAqXG4gICAgICogVGhpcyBwcm9wZXJ0eSB3aWxsIG9ubHkgd29yayB3aXRoIHN5bmNocm9ub3VzIHBsdWdpbnMuXG4gICAgICogSWYgdGhlIHByb2Nlc3NvciBjb250YWlucyBhbnkgYXN5bmNocm9ub3VzIHBsdWdpbnNcbiAgICAgKiBpdCB3aWxsIHRocm93IGFuIGVycm9yLiBUaGlzIGlzIHdoeSB0aGlzIG1ldGhvZCBpcyBvbmx5XG4gICAgICogZm9yIGRlYnVnIHB1cnBvc2UsIHlvdSBzaG91bGQgYWx3YXlzIHVzZSB7QGxpbmsgTGF6eVJlc3VsdCN0aGVufS5cbiAgICAgKlxuICAgICAqIEB0eXBlIHtTb3VyY2VNYXBHZW5lcmF0b3J9XG4gICAgICogQHNlZSBSZXN1bHQjbWFwXG4gICAgICovXG4gICAgZ2V0IG1hcCgpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMuc3RyaW5naWZ5KCkubWFwO1xuICAgIH1cblxuICAgIC8qKlxuICAgICAqIFByb2Nlc3NlcyBpbnB1dCBDU1MgdGhyb3VnaCBzeW5jaHJvbm91cyBwbHVnaW5zXG4gICAgICogYW5kIHJldHVybnMge0BsaW5rIFJlc3VsdCNyb290fS5cbiAgICAgKlxuICAgICAqIFRoaXMgcHJvcGVydHkgd2lsbCBvbmx5IHdvcmsgd2l0aCBzeW5jaHJvbm91cyBwbHVnaW5zLiBJZiB0aGUgcHJvY2Vzc29yXG4gICAgICogY29udGFpbnMgYW55IGFzeW5jaHJvbm91cyBwbHVnaW5zIGl0IHdpbGwgdGhyb3cgYW4gZXJyb3IuXG4gICAgICpcbiAgICAgKiBUaGlzIGlzIHdoeSB0aGlzIG1ldGhvZCBpcyBvbmx5IGZvciBkZWJ1ZyBwdXJwb3NlLFxuICAgICAqIHlvdSBzaG91bGQgYWx3YXlzIHVzZSB7QGxpbmsgTGF6eVJlc3VsdCN0aGVufS5cbiAgICAgKlxuICAgICAqIEB0eXBlIHtSb290fVxuICAgICAqIEBzZWUgUmVzdWx0I3Jvb3RcbiAgICAgKi9cbiAgICBnZXQgcm9vdCgpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMuc3luYygpLnJvb3Q7XG4gICAgfVxuXG4gICAgLyoqXG4gICAgICogUHJvY2Vzc2VzIGlucHV0IENTUyB0aHJvdWdoIHN5bmNocm9ub3VzIHBsdWdpbnNcbiAgICAgKiBhbmQgcmV0dXJucyB7QGxpbmsgUmVzdWx0I21lc3NhZ2VzfS5cbiAgICAgKlxuICAgICAqIFRoaXMgcHJvcGVydHkgd2lsbCBvbmx5IHdvcmsgd2l0aCBzeW5jaHJvbm91cyBwbHVnaW5zLiBJZiB0aGUgcHJvY2Vzc29yXG4gICAgICogY29udGFpbnMgYW55IGFzeW5jaHJvbm91cyBwbHVnaW5zIGl0IHdpbGwgdGhyb3cgYW4gZXJyb3IuXG4gICAgICpcbiAgICAgKiBUaGlzIGlzIHdoeSB0aGlzIG1ldGhvZCBpcyBvbmx5IGZvciBkZWJ1ZyBwdXJwb3NlLFxuICAgICAqIHlvdSBzaG91bGQgYWx3YXlzIHVzZSB7QGxpbmsgTGF6eVJlc3VsdCN0aGVufS5cbiAgICAgKlxuICAgICAqIEB0eXBlIHtNZXNzYWdlW119XG4gICAgICogQHNlZSBSZXN1bHQjbWVzc2FnZXNcbiAgICAgKi9cbiAgICBnZXQgbWVzc2FnZXMoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLnN5bmMoKS5tZXNzYWdlcztcbiAgICB9XG5cbiAgICAvKipcbiAgICAgKiBQcm9jZXNzZXMgaW5wdXQgQ1NTIHRocm91Z2ggc3luY2hyb25vdXMgcGx1Z2luc1xuICAgICAqIGFuZCBjYWxscyB7QGxpbmsgUmVzdWx0I3dhcm5pbmdzKCl9LlxuICAgICAqXG4gICAgICogQHJldHVybiB7V2FybmluZ1tdfSB3YXJuaW5ncyBmcm9tIHBsdWdpbnNcbiAgICAgKi9cbiAgICB3YXJuaW5ncygpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMuc3luYygpLndhcm5pbmdzKCk7XG4gICAgfVxuXG4gICAgLyoqXG4gICAgICogQWxpYXMgZm9yIHRoZSB7QGxpbmsgTGF6eVJlc3VsdCNjc3N9IHByb3BlcnR5LlxuICAgICAqXG4gICAgICogQGV4YW1wbGVcbiAgICAgKiBsYXp5ICsgJycgPT09IGxhenkuY3NzO1xuICAgICAqXG4gICAgICogQHJldHVybiB7c3RyaW5nfSBvdXRwdXQgQ1NTXG4gICAgICovXG4gICAgdG9TdHJpbmcoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLmNzcztcbiAgICB9XG5cbiAgICAvKipcbiAgICAgKiBQcm9jZXNzZXMgaW5wdXQgQ1NTIHRocm91Z2ggc3luY2hyb25vdXMgYW5kIGFzeW5jaHJvbm91cyBwbHVnaW5zXG4gICAgICogYW5kIGNhbGxzIGBvbkZ1bGZpbGxlZGAgd2l0aCBhIFJlc3VsdCBpbnN0YW5jZS4gSWYgYSBwbHVnaW4gdGhyb3dzXG4gICAgICogYW4gZXJyb3IsIHRoZSBgb25SZWplY3RlZGAgY2FsbGJhY2sgd2lsbCBiZSBleGVjdXRlZC5cbiAgICAgKlxuICAgICAqIEl0IGltcGxlbWVudHMgc3RhbmRhcmQgUHJvbWlzZSBBUEkuXG4gICAgICpcbiAgICAgKiBAcGFyYW0ge29uRnVsZmlsbGVkfSBvbkZ1bGZpbGxlZCAtIGNhbGxiYWNrIHdpbGwgYmUgZXhlY3V0ZWRcbiAgICAgKiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHdoZW4gYWxsIHBsdWdpbnMgd2lsbCBmaW5pc2ggd29ya1xuICAgICAqIEBwYXJhbSB7b25SZWplY3RlZH0gIG9uUmVqZWN0ZWQgIC0gY2FsbGJhY2sgd2lsbCBiZSBleGVjdXRlZCBvbiBhbnkgZXJyb3JcbiAgICAgKlxuICAgICAqIEByZXR1cm4ge1Byb21pc2V9IFByb21pc2UgQVBJIHRvIG1ha2UgcXVldWVcbiAgICAgKlxuICAgICAqIEBleGFtcGxlXG4gICAgICogcG9zdGNzcyhbY3NzbmV4dF0pLnByb2Nlc3MoY3NzKS50aGVuKHJlc3VsdCA9PiB7XG4gICAgICogICBjb25zb2xlLmxvZyhyZXN1bHQuY3NzKTtcbiAgICAgKiB9KTtcbiAgICAgKi9cbiAgICB0aGVuKG9uRnVsZmlsbGVkLCBvblJlamVjdGVkKSB7XG4gICAgICAgIHJldHVybiB0aGlzLmFzeW5jKCkudGhlbihvbkZ1bGZpbGxlZCwgb25SZWplY3RlZCk7XG4gICAgfVxuXG4gICAgLyoqXG4gICAgICogUHJvY2Vzc2VzIGlucHV0IENTUyB0aHJvdWdoIHN5bmNocm9ub3VzIGFuZCBhc3luY2hyb25vdXMgcGx1Z2luc1xuICAgICAqIGFuZCBjYWxscyBvblJlamVjdGVkIGZvciBlYWNoIGVycm9yIHRocm93biBpbiBhbnkgcGx1Z2luLlxuICAgICAqXG4gICAgICogSXQgaW1wbGVtZW50cyBzdGFuZGFyZCBQcm9taXNlIEFQSS5cbiAgICAgKlxuICAgICAqIEBwYXJhbSB7b25SZWplY3RlZH0gb25SZWplY3RlZCAtIGNhbGxiYWNrIHdpbGwgYmUgZXhlY3V0ZWQgb24gYW55IGVycm9yXG4gICAgICpcbiAgICAgKiBAcmV0dXJuIHtQcm9taXNlfSBQcm9taXNlIEFQSSB0byBtYWtlIHF1ZXVlXG4gICAgICpcbiAgICAgKiBAZXhhbXBsZVxuICAgICAqIHBvc3Rjc3MoW2Nzc25leHRdKS5wcm9jZXNzKGNzcykudGhlbihyZXN1bHQgPT4ge1xuICAgICAqICAgY29uc29sZS5sb2cocmVzdWx0LmNzcyk7XG4gICAgICogfSkuY2F0Y2goZXJyb3IgPT4ge1xuICAgICAqICAgY29uc29sZS5lcnJvcihlcnJvcik7XG4gICAgICogfSk7XG4gICAgICovXG4gICAgY2F0Y2gob25SZWplY3RlZCkge1xuICAgICAgICByZXR1cm4gdGhpcy5hc3luYygpLmNhdGNoKG9uUmVqZWN0ZWQpO1xuICAgIH1cblxuICAgIGhhbmRsZUVycm9yKGVycm9yLCBwbHVnaW4pIHtcbiAgICAgICAgdHJ5IHtcbiAgICAgICAgICAgIHRoaXMuZXJyb3IgPSBlcnJvcjtcbiAgICAgICAgICAgIGlmICggZXJyb3IubmFtZSA9PT0gJ0Nzc1N5bnRheEVycm9yJyAmJiAhZXJyb3IucGx1Z2luICkge1xuICAgICAgICAgICAgICAgIGVycm9yLnBsdWdpbiA9IHBsdWdpbi5wb3N0Y3NzUGx1Z2luO1xuICAgICAgICAgICAgICAgIGVycm9yLnNldE1lc3NhZ2UoKTtcbiAgICAgICAgICAgIH0gZWxzZSBpZiAoIHBsdWdpbi5wb3N0Y3NzVmVyc2lvbiApIHtcbiAgICAgICAgICAgICAgICBsZXQgcGx1Z2luTmFtZSA9IHBsdWdpbi5wb3N0Y3NzUGx1Z2luO1xuICAgICAgICAgICAgICAgIGxldCBwbHVnaW5WZXIgID0gcGx1Z2luLnBvc3Rjc3NWZXJzaW9uO1xuICAgICAgICAgICAgICAgIGxldCBydW50aW1lVmVyID0gdGhpcy5yZXN1bHQucHJvY2Vzc29yLnZlcnNpb247XG4gICAgICAgICAgICAgICAgbGV0IGEgPSBwbHVnaW5WZXIuc3BsaXQoJy4nKTtcbiAgICAgICAgICAgICAgICBsZXQgYiA9IHJ1bnRpbWVWZXIuc3BsaXQoJy4nKTtcblxuICAgICAgICAgICAgICAgIGlmICggYVswXSAhPT0gYlswXSB8fCBwYXJzZUludChhWzFdKSA+IHBhcnNlSW50KGJbMV0pICkge1xuICAgICAgICAgICAgICAgICAgICB3YXJuT25jZSgnWW91ciBjdXJyZW50IFBvc3RDU1MgdmVyc2lvbiAnICtcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgJ2lzICcgKyBydW50aW1lVmVyICsgJywgYnV0ICcgKyBwbHVnaW5OYW1lICsgJyAnICtcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgJ3VzZXMgJyArIHBsdWdpblZlciArICcuIFBlcmhhcHMgdGhpcyBpcyAnICtcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgJ3RoZSBzb3VyY2Ugb2YgdGhlIGVycm9yIGJlbG93LicpO1xuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgIH1cbiAgICAgICAgfSBjYXRjaCAoZXJyKSB7XG4gICAgICAgICAgICBpZiAoIGNvbnNvbGUgJiYgY29uc29sZS5lcnJvciApIGNvbnNvbGUuZXJyb3IoZXJyKTtcbiAgICAgICAgfVxuICAgIH1cblxuICAgIGFzeW5jVGljayhyZXNvbHZlLCByZWplY3QpIHtcbiAgICAgICAgaWYgKCB0aGlzLnBsdWdpbiA+PSB0aGlzLnByb2Nlc3Nvci5wbHVnaW5zLmxlbmd0aCApIHtcbiAgICAgICAgICAgIHRoaXMucHJvY2Vzc2VkID0gdHJ1ZTtcbiAgICAgICAgICAgIHJldHVybiByZXNvbHZlKCk7XG4gICAgICAgIH1cblxuICAgICAgICB0cnkge1xuICAgICAgICAgICAgbGV0IHBsdWdpbiAgPSB0aGlzLnByb2Nlc3Nvci5wbHVnaW5zW3RoaXMucGx1Z2luXTtcbiAgICAgICAgICAgIGxldCBwcm9taXNlID0gdGhpcy5ydW4ocGx1Z2luKTtcbiAgICAgICAgICAgIHRoaXMucGx1Z2luICs9IDE7XG5cbiAgICAgICAgICAgIGlmICggaXNQcm9taXNlKHByb21pc2UpICkge1xuICAgICAgICAgICAgICAgIHByb21pc2UudGhlbiggKCkgPT4ge1xuICAgICAgICAgICAgICAgICAgICB0aGlzLmFzeW5jVGljayhyZXNvbHZlLCByZWplY3QpO1xuICAgICAgICAgICAgICAgIH0pLmNhdGNoKCBlcnJvciA9PiB7XG4gICAgICAgICAgICAgICAgICAgIHRoaXMuaGFuZGxlRXJyb3IoZXJyb3IsIHBsdWdpbik7XG4gICAgICAgICAgICAgICAgICAgIHRoaXMucHJvY2Vzc2VkID0gdHJ1ZTtcbiAgICAgICAgICAgICAgICAgICAgcmVqZWN0KGVycm9yKTtcbiAgICAgICAgICAgICAgICB9KTtcbiAgICAgICAgICAgIH0gZWxzZSB7XG4gICAgICAgICAgICAgICAgdGhpcy5hc3luY1RpY2socmVzb2x2ZSwgcmVqZWN0KTtcbiAgICAgICAgICAgIH1cblxuICAgICAgICB9IGNhdGNoIChlcnJvcikge1xuICAgICAgICAgICAgdGhpcy5wcm9jZXNzZWQgPSB0cnVlO1xuICAgICAgICAgICAgcmVqZWN0KGVycm9yKTtcbiAgICAgICAgfVxuICAgIH1cblxuICAgIGFzeW5jKCkge1xuICAgICAgICBpZiAoIHRoaXMucHJvY2Vzc2VkICkge1xuICAgICAgICAgICAgcmV0dXJuIG5ldyBQcm9taXNlKCAocmVzb2x2ZSwgcmVqZWN0KSA9PiB7XG4gICAgICAgICAgICAgICAgaWYgKCB0aGlzLmVycm9yICkge1xuICAgICAgICAgICAgICAgICAgICByZWplY3QodGhpcy5lcnJvcik7XG4gICAgICAgICAgICAgICAgfSBlbHNlIHtcbiAgICAgICAgICAgICAgICAgICAgcmVzb2x2ZSh0aGlzLnN0cmluZ2lmeSgpKTtcbiAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICB9KTtcbiAgICAgICAgfVxuICAgICAgICBpZiAoIHRoaXMucHJvY2Vzc2luZyApIHtcbiAgICAgICAgICAgIHJldHVybiB0aGlzLnByb2Nlc3Npbmc7XG4gICAgICAgIH1cblxuICAgICAgICB0aGlzLnByb2Nlc3NpbmcgPSBuZXcgUHJvbWlzZSggKHJlc29sdmUsIHJlamVjdCkgPT4ge1xuICAgICAgICAgICAgaWYgKCB0aGlzLmVycm9yICkgcmV0dXJuIHJlamVjdCh0aGlzLmVycm9yKTtcbiAgICAgICAgICAgIHRoaXMucGx1Z2luID0gMDtcbiAgICAgICAgICAgIHRoaXMuYXN5bmNUaWNrKHJlc29sdmUsIHJlamVjdCk7XG4gICAgICAgIH0pLnRoZW4oICgpID0+IHtcbiAgICAgICAgICAgIHRoaXMucHJvY2Vzc2VkID0gdHJ1ZTtcbiAgICAgICAgICAgIHJldHVybiB0aGlzLnN0cmluZ2lmeSgpO1xuICAgICAgICB9KTtcblxuICAgICAgICByZXR1cm4gdGhpcy5wcm9jZXNzaW5nO1xuICAgIH1cblxuICAgIHN5bmMoKSB7XG4gICAgICAgIGlmICggdGhpcy5wcm9jZXNzZWQgKSByZXR1cm4gdGhpcy5yZXN1bHQ7XG4gICAgICAgIHRoaXMucHJvY2Vzc2VkID0gdHJ1ZTtcblxuICAgICAgICBpZiAoIHRoaXMucHJvY2Vzc2luZyApIHtcbiAgICAgICAgICAgIHRocm93IG5ldyBFcnJvcihcbiAgICAgICAgICAgICAgICAnVXNlIHByb2Nlc3MoY3NzKS50aGVuKGNiKSB0byB3b3JrIHdpdGggYXN5bmMgcGx1Z2lucycpO1xuICAgICAgICB9XG5cbiAgICAgICAgaWYgKCB0aGlzLmVycm9yICkgdGhyb3cgdGhpcy5lcnJvcjtcblxuICAgICAgICBmb3IgKCBsZXQgcGx1Z2luIG9mIHRoaXMucmVzdWx0LnByb2Nlc3Nvci5wbHVnaW5zICkge1xuICAgICAgICAgICAgbGV0IHByb21pc2UgPSB0aGlzLnJ1bihwbHVnaW4pO1xuICAgICAgICAgICAgaWYgKCBpc1Byb21pc2UocHJvbWlzZSkgKSB7XG4gICAgICAgICAgICAgICAgdGhyb3cgbmV3IEVycm9yKFxuICAgICAgICAgICAgICAgICAgICAnVXNlIHByb2Nlc3MoY3NzKS50aGVuKGNiKSB0byB3b3JrIHdpdGggYXN5bmMgcGx1Z2lucycpO1xuICAgICAgICAgICAgfVxuICAgICAgICB9XG5cbiAgICAgICAgcmV0dXJuIHRoaXMucmVzdWx0O1xuICAgIH1cblxuICAgIHJ1bihwbHVnaW4pIHtcbiAgICAgICAgdGhpcy5yZXN1bHQubGFzdFBsdWdpbiA9IHBsdWdpbjtcblxuICAgICAgICB0cnkge1xuICAgICAgICAgICAgcmV0dXJuIHBsdWdpbih0aGlzLnJlc3VsdC5yb290LCB0aGlzLnJlc3VsdCk7XG4gICAgICAgIH0gY2F0Y2ggKGVycm9yKSB7XG4gICAgICAgICAgICB0aGlzLmhhbmRsZUVycm9yKGVycm9yLCBwbHVnaW4pO1xuICAgICAgICAgICAgdGhyb3cgZXJyb3I7XG4gICAgICAgIH1cbiAgICB9XG5cbiAgICBzdHJpbmdpZnkoKSB7XG4gICAgICAgIGlmICggdGhpcy5zdHJpbmdpZmllZCApIHJldHVybiB0aGlzLnJlc3VsdDtcbiAgICAgICAgdGhpcy5zdHJpbmdpZmllZCA9IHRydWU7XG5cbiAgICAgICAgdGhpcy5zeW5jKCk7XG5cbiAgICAgICAgbGV0IG9wdHMgPSB0aGlzLnJlc3VsdC5vcHRzO1xuICAgICAgICBsZXQgc3RyICA9IHN0cmluZ2lmeTtcbiAgICAgICAgaWYgKCBvcHRzLnN5bnRheCApICAgICAgc3RyID0gb3B0cy5zeW50YXguc3RyaW5naWZ5O1xuICAgICAgICBpZiAoIG9wdHMuc3RyaW5naWZpZXIgKSBzdHIgPSBvcHRzLnN0cmluZ2lmaWVyO1xuICAgICAgICBpZiAoIHN0ci5zdHJpbmdpZnkgKSAgICBzdHIgPSBzdHIuc3RyaW5naWZ5O1xuXG4gICAgICAgIGxldCBtYXAgID0gbmV3IE1hcEdlbmVyYXRvcihzdHIsIHRoaXMucmVzdWx0LnJvb3QsIHRoaXMucmVzdWx0Lm9wdHMpO1xuICAgICAgICBsZXQgZGF0YSA9IG1hcC5nZW5lcmF0ZSgpO1xuICAgICAgICB0aGlzLnJlc3VsdC5jc3MgPSBkYXRhWzBdO1xuICAgICAgICB0aGlzLnJlc3VsdC5tYXAgPSBkYXRhWzFdO1xuXG4gICAgICAgIHJldHVybiB0aGlzLnJlc3VsdDtcbiAgICB9XG5cbn1cblxuZXhwb3J0IGRlZmF1bHQgTGF6eVJlc3VsdDtcblxuLyoqXG4gKiBAY2FsbGJhY2sgb25GdWxmaWxsZWRcbiAqIEBwYXJhbSB7UmVzdWx0fSByZXN1bHRcbiAqL1xuXG4vKipcbiAqIEBjYWxsYmFjayBvblJlamVjdGVkXG4gKiBAcGFyYW0ge0Vycm9yfSBlcnJvclxuICovXG4iXX0=


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _lazyResult = __webpack_require__(461);
	
	var _lazyResult2 = _interopRequireDefault(_lazyResult);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Contains plugins to process CSS. Create one `Processor` instance,
	 * initialize its plugins, and then use that instance on numerous CSS files.
	 *
	 * @example
	 * const processor = postcss([autoprefixer, precss]);
	 * processor.process(css1).then(result => console.log(result.css));
	 * processor.process(css2).then(result => console.log(result.css));
	 */
	var Processor = function () {
	
	  /**
	   * @param {Array.<Plugin|pluginFunction>|Processor} plugins - PostCSS
	   *        plugins. See {@link Processor#use} for plugin format.
	   */
	  function Processor() {
	    var plugins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    _classCallCheck(this, Processor);
	
	    /**
	     * @member {string} - Current PostCSS version.
	     *
	     * @example
	     * if ( result.processor.version.split('.')[0] !== '5' ) {
	     *   throw new Error('This plugin works only with PostCSS 5');
	     * }
	     */
	    this.version = '5.2.18';
	    /**
	     * @member {pluginFunction[]} - Plugins added to this processor.
	     *
	     * @example
	     * const processor = postcss([autoprefixer, precss]);
	     * processor.plugins.length //=> 2
	     */
	    this.plugins = this.normalize(plugins);
	  }
	
	  /**
	   * Adds a plugin to be used as a CSS processor.
	   *
	   * PostCSS plugin can be in 4 formats:
	   * * A plugin created by {@link postcss.plugin} method.
	   * * A function. PostCSS will pass the function a @{link Root}
	   *   as the first argument and current {@link Result} instance
	   *   as the second.
	   * * An object with a `postcss` method. PostCSS will use that method
	   *   as described in #2.
	   * * Another {@link Processor} instance. PostCSS will copy plugins
	   *   from that instance into this one.
	   *
	   * Plugins can also be added by passing them as arguments when creating
	   * a `postcss` instance (see [`postcss(plugins)`]).
	   *
	   * Asynchronous plugins should return a `Promise` instance.
	   *
	   * @param {Plugin|pluginFunction|Processor} plugin - PostCSS plugin
	   *                                                   or {@link Processor}
	   *                                                   with plugins
	   *
	   * @example
	   * const processor = postcss()
	   *   .use(autoprefixer)
	   *   .use(precss);
	   *
	   * @return {Processes} current processor to make methods chain
	   */
	
	
	  Processor.prototype.use = function use(plugin) {
	    this.plugins = this.plugins.concat(this.normalize([plugin]));
	    return this;
	  };
	
	  /**
	   * Parses source CSS and returns a {@link LazyResult} Promise proxy.
	   * Because some plugins can be asynchronous it doesn’t make
	   * any transformations. Transformations will be applied
	   * in the {@link LazyResult} methods.
	   *
	   * @param {string|toString|Result} css - String with input CSS or
	   *                                       any object with a `toString()`
	   *                                       method, like a Buffer.
	   *                                       Optionally, send a {@link Result}
	   *                                       instance and the processor will
	   *                                       take the {@link Root} from it.
	   * @param {processOptions} [opts]      - options
	   *
	   * @return {LazyResult} Promise proxy
	   *
	   * @example
	   * processor.process(css, { from: 'a.css', to: 'a.out.css' })
	   *   .then(result => {
	   *      console.log(result.css);
	   *   });
	   */
	
	
	  Processor.prototype.process = function process(css) {
	    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return new _lazyResult2.default(this, css, opts);
	  };
	
	  Processor.prototype.normalize = function normalize(plugins) {
	    var normalized = [];
	    for (var _iterator = plugins, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var i = _ref;
	
	      if (i.postcss) i = i.postcss;
	
	      if ((typeof i === 'undefined' ? 'undefined' : _typeof(i)) === 'object' && Array.isArray(i.plugins)) {
	        normalized = normalized.concat(i.plugins);
	      } else if (typeof i === 'function') {
	        normalized.push(i);
	      } else if ((typeof i === 'undefined' ? 'undefined' : _typeof(i)) === 'object' && (i.parse || i.stringify)) {
	        throw new Error('PostCSS syntaxes cannot be used as plugins. ' + 'Instead, please use one of the ' + 'syntax/parser/stringifier options as ' + 'outlined in your PostCSS ' + 'runner documentation.');
	      } else {
	        throw new Error(i + ' is not a PostCSS plugin');
	      }
	    }
	    return normalized;
	  };
	
	  return Processor;
	}();
	
	exports.default = Processor;
	
	/**
	 * @callback builder
	 * @param {string} part          - part of generated CSS connected to this node
	 * @param {Node}   node          - AST node
	 * @param {"start"|"end"} [type] - node’s part type
	 */
	
	/**
	 * @callback parser
	 *
	 * @param {string|toString} css   - string with input CSS or any object
	 *                                  with toString() method, like a Buffer
	 * @param {processOptions} [opts] - options with only `from` and `map` keys
	 *
	 * @return {Root} PostCSS AST
	 */
	
	/**
	 * @callback stringifier
	 *
	 * @param {Node} node       - start node for stringifing. Usually {@link Root}.
	 * @param {builder} builder - function to concatenate CSS from node’s parts
	 *                            or generate string and source map
	 *
	 * @return {void}
	 */
	
	/**
	 * @typedef {object} syntax
	 * @property {parser} parse          - function to generate AST by string
	 * @property {stringifier} stringify - function to generate string by AST
	 */
	
	/**
	 * @typedef {object} toString
	 * @property {function} toString
	 */
	
	/**
	 * @callback pluginFunction
	 * @param {Root} root     - parsed input CSS
	 * @param {Result} result - result to set warnings or check other plugins
	 */
	
	/**
	 * @typedef {object} Plugin
	 * @property {function} postcss - PostCSS plugin function
	 */
	
	/**
	 * @typedef {object} processOptions
	 * @property {string} from             - the path of the CSS source file.
	 *                                       You should always set `from`,
	 *                                       because it is used in source map
	 *                                       generation and syntax error messages.
	 * @property {string} to               - the path where you’ll put the output
	 *                                       CSS file. You should always set `to`
	 *                                       to generate correct source maps.
	 * @property {parser} parser           - function to generate AST by string
	 * @property {stringifier} stringifier - class to generate string by AST
	 * @property {syntax} syntax           - object with `parse` and `stringify`
	 * @property {object} map              - source map options
	 * @property {boolean} map.inline                    - does source map should
	 *                                                     be embedded in the output
	 *                                                     CSS as a base64-encoded
	 *                                                     comment
	 * @property {string|object|false|function} map.prev - source map content
	 *                                                     from a previous
	 *                                                     processing step
	 *                                                     (for example, Sass).
	 *                                                     PostCSS will try to find
	 *                                                     previous map
	 *                                                     automatically, so you
	 *                                                     could disable it by
	 *                                                     `false` value.
	 * @property {boolean} map.sourcesContent            - does PostCSS should set
	 *                                                     the origin content to map
	 * @property {string|false} map.annotation           - does PostCSS should set
	 *                                                     annotation comment to map
	 * @property {string} map.from                       - override `from` in map’s
	 *                                                     `sources`
	 */
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 463 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var defaultRaw = {
	    colon: ': ',
	    indent: '    ',
	    beforeDecl: '\n',
	    beforeRule: '\n',
	    beforeOpen: ' ',
	    beforeClose: '\n',
	    beforeComment: '\n',
	    after: '\n',
	    emptyBody: '',
	    commentLeft: ' ',
	    commentRight: ' '
	};
	
	function capitalize(str) {
	    return str[0].toUpperCase() + str.slice(1);
	}
	
	var Stringifier = function () {
	    function Stringifier(builder) {
	        _classCallCheck(this, Stringifier);
	
	        this.builder = builder;
	    }
	
	    Stringifier.prototype.stringify = function stringify(node, semicolon) {
	        this[node.type](node, semicolon);
	    };
	
	    Stringifier.prototype.root = function root(node) {
	        this.body(node);
	        if (node.raws.after) this.builder(node.raws.after);
	    };
	
	    Stringifier.prototype.comment = function comment(node) {
	        var left = this.raw(node, 'left', 'commentLeft');
	        var right = this.raw(node, 'right', 'commentRight');
	        this.builder('/*' + left + node.text + right + '*/', node);
	    };
	
	    Stringifier.prototype.decl = function decl(node, semicolon) {
	        var between = this.raw(node, 'between', 'colon');
	        var string = node.prop + between + this.rawValue(node, 'value');
	
	        if (node.important) {
	            string += node.raws.important || ' !important';
	        }
	
	        if (semicolon) string += ';';
	        this.builder(string, node);
	    };
	
	    Stringifier.prototype.rule = function rule(node) {
	        this.block(node, this.rawValue(node, 'selector'));
	    };
	
	    Stringifier.prototype.atrule = function atrule(node, semicolon) {
	        var name = '@' + node.name;
	        var params = node.params ? this.rawValue(node, 'params') : '';
	
	        if (typeof node.raws.afterName !== 'undefined') {
	            name += node.raws.afterName;
	        } else if (params) {
	            name += ' ';
	        }
	
	        if (node.nodes) {
	            this.block(node, name + params);
	        } else {
	            var end = (node.raws.between || '') + (semicolon ? ';' : '');
	            this.builder(name + params + end, node);
	        }
	    };
	
	    Stringifier.prototype.body = function body(node) {
	        var last = node.nodes.length - 1;
	        while (last > 0) {
	            if (node.nodes[last].type !== 'comment') break;
	            last -= 1;
	        }
	
	        var semicolon = this.raw(node, 'semicolon');
	        for (var i = 0; i < node.nodes.length; i++) {
	            var child = node.nodes[i];
	            var before = this.raw(child, 'before');
	            if (before) this.builder(before);
	            this.stringify(child, last !== i || semicolon);
	        }
	    };
	
	    Stringifier.prototype.block = function block(node, start) {
	        var between = this.raw(node, 'between', 'beforeOpen');
	        this.builder(start + between + '{', node, 'start');
	
	        var after = void 0;
	        if (node.nodes && node.nodes.length) {
	            this.body(node);
	            after = this.raw(node, 'after');
	        } else {
	            after = this.raw(node, 'after', 'emptyBody');
	        }
	
	        if (after) this.builder(after);
	        this.builder('}', node, 'end');
	    };
	
	    Stringifier.prototype.raw = function raw(node, own, detect) {
	        var value = void 0;
	        if (!detect) detect = own;
	
	        // Already had
	        if (own) {
	            value = node.raws[own];
	            if (typeof value !== 'undefined') return value;
	        }
	
	        var parent = node.parent;
	
	        // Hack for first rule in CSS
	        if (detect === 'before') {
	            if (!parent || parent.type === 'root' && parent.first === node) {
	                return '';
	            }
	        }
	
	        // Floating child without parent
	        if (!parent) return defaultRaw[detect];
	
	        // Detect style by other nodes
	        var root = node.root();
	        if (!root.rawCache) root.rawCache = {};
	        if (typeof root.rawCache[detect] !== 'undefined') {
	            return root.rawCache[detect];
	        }
	
	        if (detect === 'before' || detect === 'after') {
	            return this.beforeAfter(node, detect);
	        } else {
	            var method = 'raw' + capitalize(detect);
	            if (this[method]) {
	                value = this[method](root, node);
	            } else {
	                root.walk(function (i) {
	                    value = i.raws[own];
	                    if (typeof value !== 'undefined') return false;
	                });
	            }
	        }
	
	        if (typeof value === 'undefined') value = defaultRaw[detect];
	
	        root.rawCache[detect] = value;
	        return value;
	    };
	
	    Stringifier.prototype.rawSemicolon = function rawSemicolon(root) {
	        var value = void 0;
	        root.walk(function (i) {
	            if (i.nodes && i.nodes.length && i.last.type === 'decl') {
	                value = i.raws.semicolon;
	                if (typeof value !== 'undefined') return false;
	            }
	        });
	        return value;
	    };
	
	    Stringifier.prototype.rawEmptyBody = function rawEmptyBody(root) {
	        var value = void 0;
	        root.walk(function (i) {
	            if (i.nodes && i.nodes.length === 0) {
	                value = i.raws.after;
	                if (typeof value !== 'undefined') return false;
	            }
	        });
	        return value;
	    };
	
	    Stringifier.prototype.rawIndent = function rawIndent(root) {
	        if (root.raws.indent) return root.raws.indent;
	        var value = void 0;
	        root.walk(function (i) {
	            var p = i.parent;
	            if (p && p !== root && p.parent && p.parent === root) {
	                if (typeof i.raws.before !== 'undefined') {
	                    var parts = i.raws.before.split('\n');
	                    value = parts[parts.length - 1];
	                    value = value.replace(/[^\s]/g, '');
	                    return false;
	                }
	            }
	        });
	        return value;
	    };
	
	    Stringifier.prototype.rawBeforeComment = function rawBeforeComment(root, node) {
	        var value = void 0;
	        root.walkComments(function (i) {
	            if (typeof i.raws.before !== 'undefined') {
	                value = i.raws.before;
	                if (value.indexOf('\n') !== -1) {
	                    value = value.replace(/[^\n]+$/, '');
	                }
	                return false;
	            }
	        });
	        if (typeof value === 'undefined') {
	            value = this.raw(node, null, 'beforeDecl');
	        }
	        return value;
	    };
	
	    Stringifier.prototype.rawBeforeDecl = function rawBeforeDecl(root, node) {
	        var value = void 0;
	        root.walkDecls(function (i) {
	            if (typeof i.raws.before !== 'undefined') {
	                value = i.raws.before;
	                if (value.indexOf('\n') !== -1) {
	                    value = value.replace(/[^\n]+$/, '');
	                }
	                return false;
	            }
	        });
	        if (typeof value === 'undefined') {
	            value = this.raw(node, null, 'beforeRule');
	        }
	        return value;
	    };
	
	    Stringifier.prototype.rawBeforeRule = function rawBeforeRule(root) {
	        var value = void 0;
	        root.walk(function (i) {
	            if (i.nodes && (i.parent !== root || root.first !== i)) {
	                if (typeof i.raws.before !== 'undefined') {
	                    value = i.raws.before;
	                    if (value.indexOf('\n') !== -1) {
	                        value = value.replace(/[^\n]+$/, '');
	                    }
	                    return false;
	                }
	            }
	        });
	        return value;
	    };
	
	    Stringifier.prototype.rawBeforeClose = function rawBeforeClose(root) {
	        var value = void 0;
	        root.walk(function (i) {
	            if (i.nodes && i.nodes.length > 0) {
	                if (typeof i.raws.after !== 'undefined') {
	                    value = i.raws.after;
	                    if (value.indexOf('\n') !== -1) {
	                        value = value.replace(/[^\n]+$/, '');
	                    }
	                    return false;
	                }
	            }
	        });
	        return value;
	    };
	
	    Stringifier.prototype.rawBeforeOpen = function rawBeforeOpen(root) {
	        var value = void 0;
	        root.walk(function (i) {
	            if (i.type !== 'decl') {
	                value = i.raws.between;
	                if (typeof value !== 'undefined') return false;
	            }
	        });
	        return value;
	    };
	
	    Stringifier.prototype.rawColon = function rawColon(root) {
	        var value = void 0;
	        root.walkDecls(function (i) {
	            if (typeof i.raws.between !== 'undefined') {
	                value = i.raws.between.replace(/[^\s:]/g, '');
	                return false;
	            }
	        });
	        return value;
	    };
	
	    Stringifier.prototype.beforeAfter = function beforeAfter(node, detect) {
	        var value = void 0;
	        if (node.type === 'decl') {
	            value = this.raw(node, null, 'beforeDecl');
	        } else if (node.type === 'comment') {
	            value = this.raw(node, null, 'beforeComment');
	        } else if (detect === 'before') {
	            value = this.raw(node, null, 'beforeRule');
	        } else {
	            value = this.raw(node, null, 'beforeClose');
	        }
	
	        var buf = node.parent;
	        var depth = 0;
	        while (buf && buf.type !== 'root') {
	            depth += 1;
	            buf = buf.parent;
	        }
	
	        if (value.indexOf('\n') !== -1) {
	            var indent = this.raw(node, null, 'indent');
	            if (indent.length) {
	                for (var step = 0; step < depth; step++) {
	                    value += indent;
	                }
	            }
	        }
	
	        return value;
	    };
	
	    Stringifier.prototype.rawValue = function rawValue(node, prop) {
	        var value = node[prop];
	        var raw = node.raws[prop];
	        if (raw && raw.value === value) {
	            return raw.raw;
	        } else {
	            return value;
	        }
	    };
	
	    return Stringifier;
	}();
	
	exports.default = Stringifier;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 464 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = tokenize;
	var SINGLE_QUOTE = 39;
	var DOUBLE_QUOTE = 34;
	var BACKSLASH = 92;
	var SLASH = 47;
	var NEWLINE = 10;
	var SPACE = 32;
	var FEED = 12;
	var TAB = 9;
	var CR = 13;
	var OPEN_SQUARE = 91;
	var CLOSE_SQUARE = 93;
	var OPEN_PARENTHESES = 40;
	var CLOSE_PARENTHESES = 41;
	var OPEN_CURLY = 123;
	var CLOSE_CURLY = 125;
	var SEMICOLON = 59;
	var ASTERISK = 42;
	var COLON = 58;
	var AT = 64;
	
	var RE_AT_END = /[ \n\t\r\f\{\(\)'"\\;/\[\]#]/g;
	var RE_WORD_END = /[ \n\t\r\f\(\)\{\}:;@!'"\\\]\[#]|\/(?=\*)/g;
	var RE_BAD_BRACKET = /.[\\\/\("'\n]/;
	
	function tokenize(input) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var tokens = [];
	    var css = input.css.valueOf();
	
	    var ignore = options.ignoreErrors;
	
	    var code = void 0,
	        next = void 0,
	        quote = void 0,
	        lines = void 0,
	        last = void 0,
	        content = void 0,
	        escape = void 0,
	        nextLine = void 0,
	        nextOffset = void 0,
	        escaped = void 0,
	        escapePos = void 0,
	        prev = void 0,
	        n = void 0;
	
	    var length = css.length;
	    var offset = -1;
	    var line = 1;
	    var pos = 0;
	
	    function unclosed(what) {
	        throw input.error('Unclosed ' + what, line, pos - offset);
	    }
	
	    while (pos < length) {
	        code = css.charCodeAt(pos);
	
	        if (code === NEWLINE || code === FEED || code === CR && css.charCodeAt(pos + 1) !== NEWLINE) {
	            offset = pos;
	            line += 1;
	        }
	
	        switch (code) {
	            case NEWLINE:
	            case SPACE:
	            case TAB:
	            case CR:
	            case FEED:
	                next = pos;
	                do {
	                    next += 1;
	                    code = css.charCodeAt(next);
	                    if (code === NEWLINE) {
	                        offset = next;
	                        line += 1;
	                    }
	                } while (code === SPACE || code === NEWLINE || code === TAB || code === CR || code === FEED);
	
	                tokens.push(['space', css.slice(pos, next)]);
	                pos = next - 1;
	                break;
	
	            case OPEN_SQUARE:
	                tokens.push(['[', '[', line, pos - offset]);
	                break;
	
	            case CLOSE_SQUARE:
	                tokens.push([']', ']', line, pos - offset]);
	                break;
	
	            case OPEN_CURLY:
	                tokens.push(['{', '{', line, pos - offset]);
	                break;
	
	            case CLOSE_CURLY:
	                tokens.push(['}', '}', line, pos - offset]);
	                break;
	
	            case COLON:
	                tokens.push([':', ':', line, pos - offset]);
	                break;
	
	            case SEMICOLON:
	                tokens.push([';', ';', line, pos - offset]);
	                break;
	
	            case OPEN_PARENTHESES:
	                prev = tokens.length ? tokens[tokens.length - 1][1] : '';
	                n = css.charCodeAt(pos + 1);
	                if (prev === 'url' && n !== SINGLE_QUOTE && n !== DOUBLE_QUOTE && n !== SPACE && n !== NEWLINE && n !== TAB && n !== FEED && n !== CR) {
	                    next = pos;
	                    do {
	                        escaped = false;
	                        next = css.indexOf(')', next + 1);
	                        if (next === -1) {
	                            if (ignore) {
	                                next = pos;
	                                break;
	                            } else {
	                                unclosed('bracket');
	                            }
	                        }
	                        escapePos = next;
	                        while (css.charCodeAt(escapePos - 1) === BACKSLASH) {
	                            escapePos -= 1;
	                            escaped = !escaped;
	                        }
	                    } while (escaped);
	
	                    tokens.push(['brackets', css.slice(pos, next + 1), line, pos - offset, line, next - offset]);
	                    pos = next;
	                } else {
	                    next = css.indexOf(')', pos + 1);
	                    content = css.slice(pos, next + 1);
	
	                    if (next === -1 || RE_BAD_BRACKET.test(content)) {
	                        tokens.push(['(', '(', line, pos - offset]);
	                    } else {
	                        tokens.push(['brackets', content, line, pos - offset, line, next - offset]);
	                        pos = next;
	                    }
	                }
	
	                break;
	
	            case CLOSE_PARENTHESES:
	                tokens.push([')', ')', line, pos - offset]);
	                break;
	
	            case SINGLE_QUOTE:
	            case DOUBLE_QUOTE:
	                quote = code === SINGLE_QUOTE ? '\'' : '"';
	                next = pos;
	                do {
	                    escaped = false;
	                    next = css.indexOf(quote, next + 1);
	                    if (next === -1) {
	                        if (ignore) {
	                            next = pos + 1;
	                            break;
	                        } else {
	                            unclosed('string');
	                        }
	                    }
	                    escapePos = next;
	                    while (css.charCodeAt(escapePos - 1) === BACKSLASH) {
	                        escapePos -= 1;
	                        escaped = !escaped;
	                    }
	                } while (escaped);
	
	                content = css.slice(pos, next + 1);
	                lines = content.split('\n');
	                last = lines.length - 1;
	
	                if (last > 0) {
	                    nextLine = line + last;
	                    nextOffset = next - lines[last].length;
	                } else {
	                    nextLine = line;
	                    nextOffset = offset;
	                }
	
	                tokens.push(['string', css.slice(pos, next + 1), line, pos - offset, nextLine, next - nextOffset]);
	
	                offset = nextOffset;
	                line = nextLine;
	                pos = next;
	                break;
	
	            case AT:
	                RE_AT_END.lastIndex = pos + 1;
	                RE_AT_END.test(css);
	                if (RE_AT_END.lastIndex === 0) {
	                    next = css.length - 1;
	                } else {
	                    next = RE_AT_END.lastIndex - 2;
	                }
	                tokens.push(['at-word', css.slice(pos, next + 1), line, pos - offset, line, next - offset]);
	                pos = next;
	                break;
	
	            case BACKSLASH:
	                next = pos;
	                escape = true;
	                while (css.charCodeAt(next + 1) === BACKSLASH) {
	                    next += 1;
	                    escape = !escape;
	                }
	                code = css.charCodeAt(next + 1);
	                if (escape && code !== SLASH && code !== SPACE && code !== NEWLINE && code !== TAB && code !== CR && code !== FEED) {
	                    next += 1;
	                }
	                tokens.push(['word', css.slice(pos, next + 1), line, pos - offset, line, next - offset]);
	                pos = next;
	                break;
	
	            default:
	                if (code === SLASH && css.charCodeAt(pos + 1) === ASTERISK) {
	                    next = css.indexOf('*/', pos + 2) + 1;
	                    if (next === 0) {
	                        if (ignore) {
	                            next = css.length;
	                        } else {
	                            unclosed('comment');
	                        }
	                    }
	
	                    content = css.slice(pos, next + 1);
	                    lines = content.split('\n');
	                    last = lines.length - 1;
	
	                    if (last > 0) {
	                        nextLine = line + last;
	                        nextOffset = next - lines[last].length;
	                    } else {
	                        nextLine = line;
	                        nextOffset = offset;
	                    }
	
	                    tokens.push(['comment', content, line, pos - offset, nextLine, next - nextOffset]);
	
	                    offset = nextOffset;
	                    line = nextLine;
	                    pos = next;
	                } else {
	                    RE_WORD_END.lastIndex = pos + 1;
	                    RE_WORD_END.test(css);
	                    if (RE_WORD_END.lastIndex === 0) {
	                        next = css.length - 1;
	                    } else {
	                        next = RE_WORD_END.lastIndex - 2;
	                    }
	
	                    tokens.push(['word', css.slice(pos, next + 1), line, pos - offset, line, next - offset]);
	                    pos = next;
	                }
	
	                break;
	        }
	
	        pos++;
	    }
	
	    return tokens;
	}
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(1489);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 466 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	module.exports = __webpack_require__(1679);


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(69);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * If set to true, renders `span` instead of `a`
	   */
	  active: _propTypes2['default'].bool,
	  /**
	   * `href` attribute for the inner `a` element
	   */
	  href: _propTypes2['default'].string,
	  /**
	   * `title` attribute for the inner `a` element
	   */
	  title: _propTypes2['default'].node,
	  /**
	   * `target` attribute for the inner `a` element
	   */
	  target: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  active: false
	};
	
	var BreadcrumbItem = function (_React$Component) {
	  (0, _inherits3['default'])(BreadcrumbItem, _React$Component);
	
	  function BreadcrumbItem() {
	    (0, _classCallCheck3['default'])(this, BreadcrumbItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  BreadcrumbItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        href = _props.href,
	        title = _props.title,
	        target = _props.target,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'href', 'title', 'target', 'className']);
	
	    // Don't try to render these props on non-active <span>.
	
	    var linkProps = { href: href, title: title, target: target };
	
	    return _react2['default'].createElement(
	      'li',
	      { className: (0, _classnames2['default'])(className, { active: active }) },
	      active ? _react2['default'].createElement('span', props) : _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, linkProps))
	    );
	  };
	
	  return BreadcrumbItem;
	}(_react2['default'].Component);
	
	BreadcrumbItem.propTypes = propTypes;
	BreadcrumbItem.defaultProps = defaultProps;
	
	exports['default'] = BreadcrumbItem;
	module.exports = exports['default'];

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _all = __webpack_require__(226);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _Button = __webpack_require__(170);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  vertical: _propTypes2['default'].bool,
	  justified: _propTypes2['default'].bool,
	
	  /**
	   * Display block buttons; only useful when used with the "vertical" prop.
	   * @type {bool}
	   */
	  block: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
	    var block = _ref.block,
	        vertical = _ref.vertical;
	    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
	  })
	};
	
	var defaultProps = {
	  block: false,
	  justified: false,
	  vertical: false
	};
	
	var ButtonGroup = function (_React$Component) {
	  (0, _inherits3['default'])(ButtonGroup, _React$Component);
	
	  function ButtonGroup() {
	    (0, _classCallCheck3['default'])(this, ButtonGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonGroup.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        block = _props.block,
	        justified = _props.justified,
	        vertical = _props.vertical,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['block', 'justified', 'vertical', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps)] = !vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'vertical')] = vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2[(0, _bootstrapUtils.prefix)(_Button2['default'].defaultProps, 'block')] = block, _extends2));
	
	    return _react2['default'].createElement('div', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ButtonGroup;
	}(_react2['default'].Component);
	
	ButtonGroup.propTypes = propTypes;
	ButtonGroup.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn-group', ButtonGroup);
	module.exports = exports['default'];

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TransitionEvents = __webpack_require__(1552);
	
	var _TransitionEvents2 = _interopRequireDefault(_TransitionEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should use a timeout instead of TransitionEvents, or else just
	// not wait until transition end to trigger continuing animations.
	
	var propTypes = {
	  direction: _propTypes2['default'].oneOf(['prev', 'next']),
	  onAnimateOutEnd: _propTypes2['default'].func,
	  active: _propTypes2['default'].bool,
	  animateIn: _propTypes2['default'].bool,
	  animateOut: _propTypes2['default'].bool,
	  index: _propTypes2['default'].number
	};
	
	var defaultProps = {
	  active: false,
	  animateIn: false,
	  animateOut: false
	};
	
	var CarouselItem = function (_React$Component) {
	  (0, _inherits3['default'])(CarouselItem, _React$Component);
	
	  function CarouselItem(props, context) {
	    (0, _classCallCheck3['default'])(this, CarouselItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(_this);
	
	    _this.state = {
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  CarouselItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.active !== nextProps.active) {
	      this.setState({ direction: null });
	    }
	  };
	
	  CarouselItem.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _this2 = this;
	
	    var active = this.props.active;
	
	    var prevActive = prevProps.active;
	
	    if (!active && prevActive) {
	      _TransitionEvents2['default'].addEndEventListener(_reactDom2['default'].findDOMNode(this), this.handleAnimateOutEnd);
	    }
	
	    if (active !== prevActive) {
	      setTimeout(function () {
	        return _this2.startAnimation();
	      }, 20);
	    }
	  };
	
	  CarouselItem.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  CarouselItem.prototype.handleAnimateOutEnd = function handleAnimateOutEnd() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    if (this.props.onAnimateOutEnd) {
	      this.props.onAnimateOutEnd(this.props.index);
	    }
	  };
	
	  CarouselItem.prototype.startAnimation = function startAnimation() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState({
	      direction: this.props.direction === 'prev' ? 'right' : 'left'
	    });
	  };
	
	  CarouselItem.prototype.render = function render() {
	    var _props = this.props,
	        direction = _props.direction,
	        active = _props.active,
	        animateIn = _props.animateIn,
	        animateOut = _props.animateOut,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['direction', 'active', 'animateIn', 'animateOut', 'className']);
	
	
	    delete props.onAnimateOutEnd;
	    delete props.index;
	
	    var classes = {
	      item: true,
	      active: active && !animateIn || animateOut
	    };
	    if (direction && active && animateIn) {
	      classes[direction] = true;
	    }
	    if (this.state.direction && (animateIn || animateOut)) {
	      classes[this.state.direction] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, props, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return CarouselItem;
	}(_react2['default'].Component);
	
	CarouselItem.propTypes = propTypes;
	CarouselItem.defaultProps = defaultProps;
	
	exports['default'] = CarouselItem;
	module.exports = exports['default'];

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(170);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SafeAnchor = __webpack_require__(69);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  noCaret: _propTypes2['default'].bool,
	  open: _propTypes2['default'].bool,
	  title: _propTypes2['default'].string,
	  useAnchor: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  open: false,
	  useAnchor: false,
	  bsRole: 'toggle'
	};
	
	var DropdownToggle = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownToggle, _React$Component);
	
	  function DropdownToggle() {
	    (0, _classCallCheck3['default'])(this, DropdownToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownToggle.prototype.render = function render() {
	    var _props = this.props,
	        noCaret = _props.noCaret,
	        open = _props.open,
	        useAnchor = _props.useAnchor,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['noCaret', 'open', 'useAnchor', 'bsClass', 'className', 'children']);
	
	
	    delete props.bsRole;
	
	    var Component = useAnchor ? _SafeAnchor2['default'] : _Button2['default'];
	    var useCaret = !noCaret;
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    // FIXME: Should this really fall back to `title` as children?
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, props, {
	        role: 'button',
	        className: (0, _classnames2['default'])(className, bsClass),
	        'aria-haspopup': true,
	        'aria-expanded': open
	      }),
	      children || props.title,
	      useCaret && ' ',
	      useCaret && _react2['default'].createElement('span', { className: 'caret' })
	    );
	  };
	
	  return DropdownToggle;
	}(_react2['default'].Component);
	
	DropdownToggle.propTypes = propTypes;
	DropdownToggle.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown-toggle', DropdownToggle);
	module.exports = exports['default'];

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Turn any fixed-width grid layout into a full-width layout by this property.
	   *
	   * Adds `container-fluid` class.
	   */
	  fluid: _propTypes2['default'].bool,
	  /**
	   * You can use a custom element for this component
	   */
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  fluid: false
	};
	
	var Grid = function (_React$Component) {
	  (0, _inherits3['default'])(Grid, _React$Component);
	
	  function Grid() {
	    (0, _classCallCheck3['default'])(this, Grid);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Grid.prototype.render = function render() {
	    var _props = this.props,
	        fluid = _props.fluid,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['fluid', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.prefix)(bsProps, fluid && 'fluid');
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Grid;
	}(_react2['default'].Component);
	
	Grid.propTypes = propTypes;
	Grid.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('container', Grid);
	module.exports = exports['default'];

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(119);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _propTypes2['default'].any,
	  disabled: _propTypes2['default'].any,
	  header: _propTypes2['default'].node,
	  listItem: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func,
	  href: _propTypes2['default'].string,
	  type: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  listItem: false
	};
	
	var ListGroupItem = function (_React$Component) {
	  (0, _inherits3['default'])(ListGroupItem, _React$Component);
	
	  function ListGroupItem() {
	    (0, _classCallCheck3['default'])(this, ListGroupItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroupItem.prototype.renderHeader = function renderHeader(header, headingClassName) {
	    if (_react2['default'].isValidElement(header)) {
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2['default'])(header.props.className, headingClassName)
	      });
	    }
	
	    return _react2['default'].createElement(
	      'h4',
	      { className: headingClassName },
	      header
	    );
	  };
	
	  ListGroupItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        className = _props.className,
	        header = _props.header,
	        listItem = _props.listItem,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'disabled', 'className', 'header', 'listItem', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active,
	      disabled: disabled
	    });
	
	    var Component = void 0;
	
	    if (elementProps.href) {
	      Component = 'a';
	    } else if (elementProps.onClick) {
	      Component = 'button';
	      elementProps.type = elementProps.type || 'button';
	    } else if (listItem) {
	      Component = 'li';
	    } else {
	      Component = 'span';
	    }
	
	    elementProps.className = (0, _classnames2['default'])(className, classes);
	
	    // TODO: Deprecate `header` prop.
	    if (header) {
	      return _react2['default'].createElement(
	        Component,
	        elementProps,
	        this.renderHeader(header, (0, _bootstrapUtils.prefix)(bsProps, 'heading')),
	        _react2['default'].createElement(
	          'p',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'text') },
	          children
	        )
	      );
	    }
	
	    return _react2['default'].createElement(
	      Component,
	      elementProps,
	      children
	    );
	  };
	
	  return ListGroupItem;
	}(_react2['default'].Component);
	
	ListGroupItem.propTypes = propTypes;
	ListGroupItem.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('list-group-item', (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), ListGroupItem));
	module.exports = exports['default'];

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalBody = function (_React$Component) {
	  (0, _inherits3['default'])(ModalBody, _React$Component);
	
	  function ModalBody() {
	    (0, _classCallCheck3['default'])(this, ModalBody);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalBody;
	}(_react2['default'].Component);
	
	ModalBody.propTypes = propTypes;
	ModalBody.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-body', ModalBody);
	module.exports = exports['default'];

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalFooter = function (_React$Component) {
	  (0, _inherits3['default'])(ModalFooter, _React$Component);
	
	  function ModalFooter() {
	    (0, _classCallCheck3['default'])(this, ModalFooter);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalFooter.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalFooter;
	}(_react2['default'].Component);
	
	ModalFooter.propTypes = propTypes;
	ModalFooter.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-footer', ModalFooter);
	module.exports = exports['default'];

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _createChainedFunction = __webpack_require__(34);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `aria-label` should be `closeLabel`.
	
	var propTypes = {
	  /**
	   * The 'aria-label' attribute provides an accessible label for the close
	   * button. It is used for Assistive Technology when the label text is not
	   * readable.
	   */
	  'aria-label': _propTypes2['default'].string,
	
	  /**
	   * Specify whether the Component should contain a close button
	   */
	  closeButton: _propTypes2['default'].bool,
	
	  /**
	   * A Callback fired when the close button is clicked. If used directly inside
	   * a Modal component, the onHide will automatically be propagated up to the
	   * parent Modal `onHide`.
	   */
	  onHide: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  'aria-label': 'Close',
	  closeButton: false
	};
	
	var contextTypes = {
	  $bs_modal: _propTypes2['default'].shape({
	    onHide: _propTypes2['default'].func
	  })
	};
	
	var ModalHeader = function (_React$Component) {
	  (0, _inherits3['default'])(ModalHeader, _React$Component);
	
	  function ModalHeader() {
	    (0, _classCallCheck3['default'])(this, ModalHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalHeader.prototype.render = function render() {
	    var _props = this.props,
	        label = _props['aria-label'],
	        closeButton = _props.closeButton,
	        onHide = _props.onHide,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['aria-label', 'closeButton', 'onHide', 'className', 'children']);
	
	
	    var modal = this.context.$bs_modal;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      closeButton && _react2['default'].createElement(
	        'button',
	        {
	          type: 'button',
	          className: 'close',
	          'aria-label': label,
	          onClick: (0, _createChainedFunction2['default'])(modal && modal.onHide, onHide)
	        },
	        _react2['default'].createElement(
	          'span',
	          { 'aria-hidden': 'true' },
	          '\xD7'
	        )
	      ),
	      children
	    );
	  };
	
	  return ModalHeader;
	}(_react2['default'].Component);
	
	ModalHeader.propTypes = propTypes;
	ModalHeader.defaultProps = defaultProps;
	ModalHeader.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-header', ModalHeader);
	module.exports = exports['default'];

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var ModalTitle = function (_React$Component) {
	  (0, _inherits3['default'])(ModalTitle, _React$Component);
	
	  function ModalTitle() {
	    (0, _classCallCheck3['default'])(this, ModalTitle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalTitle.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalTitle;
	}(_react2['default'].Component);
	
	ModalTitle.propTypes = propTypes;
	ModalTitle.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-title', ModalTitle);
	module.exports = exports['default'];

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(302);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(226);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _createChainedFunction = __webpack_require__(34);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(45);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?
	
	// TODO: This `bsStyle` is very unlike the others. Should we rename it?
	
	// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
	// Consider renaming or replacing them.
	
	var propTypes = {
	  /**
	   * Marks the NavItem with a matching `eventKey` as active. Has a
	   * higher precedence over `activeHref`.
	   */
	  activeKey: _propTypes2['default'].any,
	
	  /**
	   * Marks the child NavItem with a matching `href` prop as active.
	   */
	  activeHref: _propTypes2['default'].string,
	
	  /**
	   * NavItems are be positioned vertically.
	   */
	  stacked: _propTypes2['default'].bool,
	
	  justified: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
	    var justified = _ref.justified,
	        navbar = _ref.navbar;
	    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
	  }),
	
	  /**
	   * A callback fired when a NavItem is selected.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * ARIA role for the Nav, in the context of a TabContainer, the default will
	   * be set to "tablist", but can be overridden by the Nav when set explicitly.
	   *
	   * When the role is set to "tablist" NavItem focus is managed according to
	   * the ARIA authoring practices for tabs:
	   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
	   */
	  role: _propTypes2['default'].string,
	
	  /**
	   * Apply styling an alignment for use in a Navbar. This prop will be set
	   * automatically when the Nav is used inside a Navbar.
	   */
	  navbar: _propTypes2['default'].bool,
	
	  /**
	   * Float the Nav to the right. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullRight: _propTypes2['default'].bool,
	
	  /**
	   * Float the Nav to the left. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullLeft: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  justified: false,
	  pullRight: false,
	  pullLeft: false,
	  stacked: false
	};
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    onSelect: _propTypes2['default'].func
	  }),
	
	  $bs_tabContainer: _propTypes2['default'].shape({
	    activeKey: _propTypes2['default'].any,
	    onSelect: _propTypes2['default'].func.isRequired,
	    getTabId: _propTypes2['default'].func.isRequired,
	    getPaneId: _propTypes2['default'].func.isRequired
	  })
	};
	
	var Nav = function (_React$Component) {
	  (0, _inherits3['default'])(Nav, _React$Component);
	
	  function Nav() {
	    (0, _classCallCheck3['default'])(this, Nav);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Nav.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    if (!this._needsRefocus) {
	      return;
	    }
	
	    this._needsRefocus = false;
	
	    var children = this.props.children;
	
	    var _getActiveProps = this.getActiveProps(),
	        activeKey = _getActiveProps.activeKey,
	        activeHref = _getActiveProps.activeHref;
	
	    var activeChild = _ValidComponentChildren2['default'].find(children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    });
	
	    var childrenArray = _ValidComponentChildren2['default'].toArray(children);
	    var activeChildIndex = childrenArray.indexOf(activeChild);
	
	    var childNodes = _reactDom2['default'].findDOMNode(this).children;
	    var activeNode = childNodes && childNodes[activeChildIndex];
	
	    if (!activeNode || !activeNode.firstChild) {
	      return;
	    }
	
	    activeNode.firstChild.focus();
	  };
	
	  Nav.prototype.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
	    var nextActiveChild = void 0;
	
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.left:
	      case _keycode2['default'].codes.up:
	        nextActiveChild = this.getNextActiveChild(-1);
	        break;
	      case _keycode2['default'].codes.right:
	      case _keycode2['default'].codes.down:
	        nextActiveChild = this.getNextActiveChild(1);
	        break;
	      default:
	        // It was a different key; don't handle this keypress.
	        return;
	    }
	
	    event.preventDefault();
	
	    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
	      onSelect(nextActiveChild.props.eventKey);
	    }
	
	    this._needsRefocus = true;
	  };
	
	  Nav.prototype.getNextActiveChild = function getNextActiveChild(offset) {
	    var _this3 = this;
	
	    var children = this.props.children;
	
	    var validChildren = children.filter(function (child) {
	      return child.props.eventKey != null && !child.props.disabled;
	    });
	
	    var _getActiveProps2 = this.getActiveProps(),
	        activeKey = _getActiveProps2.activeKey,
	        activeHref = _getActiveProps2.activeHref;
	
	    var activeChild = _ValidComponentChildren2['default'].find(children, function (child) {
	      return _this3.isActive(child, activeKey, activeHref);
	    });
	
	    // This assumes the active child is not disabled.
	    var activeChildIndex = validChildren.indexOf(activeChild);
	    if (activeChildIndex === -1) {
	      // Something has gone wrong. Select the first valid child we can find.
	      return validChildren[0];
	    }
	
	    var nextIndex = activeChildIndex + offset;
	    var numValidChildren = validChildren.length;
	
	    if (nextIndex >= numValidChildren) {
	      nextIndex = 0;
	    } else if (nextIndex < 0) {
	      nextIndex = numValidChildren - 1;
	    }
	
	    return validChildren[nextIndex];
	  };
	
	  Nav.prototype.getActiveProps = function getActiveProps() {
	    var tabContainer = this.context.$bs_tabContainer;
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ('activeKey={' + this.props.activeKey + '} />`.')) : void 0;
	
	      return tabContainer;
	    }
	
	    return this.props;
	  };
	
	  Nav.prototype.isActive = function isActive(_ref2, activeKey, activeHref) {
	    var props = _ref2.props;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  Nav.prototype.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
	    var _this4 = this;
	
	    if (!tabContainer && navRole !== 'tablist') {
	      // No tab props here.
	      return null;
	    }
	
	    var _child$props = child.props,
	        id = _child$props.id,
	        controls = _child$props['aria-controls'],
	        eventKey = _child$props.eventKey,
	        role = _child$props.role,
	        onKeyDown = _child$props.onKeyDown,
	        tabIndex = _child$props.tabIndex;
	
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      id = tabContainer.getTabId(eventKey);
	      controls = tabContainer.getPaneId(eventKey);
	    }
	
	    if (navRole === 'tablist') {
	      role = role || 'tab';
	      onKeyDown = (0, _createChainedFunction2['default'])(function (event) {
	        return _this4.handleTabKeyDown(onSelect, event);
	      }, onKeyDown);
	      tabIndex = active ? tabIndex : -1;
	    }
	
	    return {
	      id: id,
	      role: role,
	      onKeyDown: onKeyDown,
	      'aria-controls': controls,
	      tabIndex: tabIndex
	    };
	  };
	
	  Nav.prototype.render = function render() {
	    var _extends2,
	        _this5 = this;
	
	    var _props = this.props,
	        stacked = _props.stacked,
	        justified = _props.justified,
	        onSelect = _props.onSelect,
	        propsRole = _props.role,
	        propsNavbar = _props.navbar,
	        pullRight = _props.pullRight,
	        pullLeft = _props.pullLeft,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['stacked', 'justified', 'onSelect', 'role', 'navbar', 'pullRight', 'pullLeft', 'className', 'children']);
	
	
	    var tabContainer = this.context.$bs_tabContainer;
	    var role = propsRole || (tabContainer ? 'tablist' : null);
	
	    var _getActiveProps3 = this.getActiveProps(),
	        activeKey = _getActiveProps3.activeKey,
	        activeHref = _getActiveProps3.activeHref;
	
	    delete props.activeKey; // Accessed via this.getActiveProps().
	    delete props.activeHref; // Accessed via this.getActiveProps().
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'stacked')] = stacked, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2));
	
	    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
	    var pullLeftClassName = void 0;
	    var pullRightClassName = void 0;
	
	    if (navbar) {
	      var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	      classes[(0, _bootstrapUtils.prefix)(navbarProps, 'nav')] = true;
	
	      pullRightClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'right');
	      pullLeftClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'left');
	    } else {
	      pullRightClassName = 'pull-right';
	      pullLeftClassName = 'pull-left';
	    }
	
	    classes[pullRightClassName] = pullRight;
	    classes[pullLeftClassName] = pullLeft;
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends4['default'])({}, elementProps, {
	        role: role,
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        var active = _this5.isActive(child, activeKey, activeHref);
	        var childOnSelect = (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);
	
	        return (0, _react.cloneElement)(child, (0, _extends4['default'])({}, _this5.getTabProps(child, tabContainer, role, active, childOnSelect), {
	          active: active,
	          activeKey: activeKey,
	          activeHref: activeHref,
	          onSelect: childOnSelect
	        }));
	      })
	    );
	  };
	
	  return Nav;
	}(_react2['default'].Component);
	
	Nav.propTypes = propTypes;
	Nav.defaultProps = defaultProps;
	Nav.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('nav', (0, _bootstrapUtils.bsStyles)(['tabs', 'pills'], Nav));
	module.exports = exports['default'];

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(69);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(34);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  role: _propTypes2['default'].string,
	  href: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  onSelect: _propTypes2['default'].func,
	  eventKey: _propTypes2['default'].any
	};
	
	var defaultProps = {
	  active: false,
	  disabled: false
	};
	
	var NavItem = function (_React$Component) {
	  (0, _inherits3['default'])(NavItem, _React$Component);
	
	  function NavItem(props, context) {
	    (0, _classCallCheck3['default'])(this, NavItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  NavItem.prototype.handleClick = function handleClick(e) {
	    if (this.props.onSelect) {
	      e.preventDefault();
	
	      if (!this.props.disabled) {
	        this.props.onSelect(this.props.eventKey, e);
	      }
	    }
	  };
	
	  NavItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        onClick = _props.onClick,
	        className = _props.className,
	        style = _props.style,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    // These are injected down by `<Nav>` for building `<SubNav>`s.
	    delete props.activeKey;
	    delete props.activeHref;
	
	    if (!props.role) {
	      if (props.href === '#') {
	        props.role = 'button';
	      }
	    } else if (props.role === 'tab') {
	      props['aria-selected'] = active;
	    }
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return NavItem;
	}(_react2['default'].Component);
	
	NavItem.propTypes = propTypes;
	NavItem.defaultProps = defaultProps;
	
	exports['default'] = NavItem;
	module.exports = exports['default'];

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string
	  })
	};
	
	var NavbarBrand = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarBrand, _React$Component);
	
	  function NavbarBrand() {
	    (0, _classCallCheck3['default'])(this, NavbarBrand);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarBrand.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'brand');
	
	    if (_react2['default'].isValidElement(children)) {
	      return _react2['default'].cloneElement(children, {
	        className: (0, _classnames2['default'])(children.props.className, className, bsClassName)
	      });
	    }
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, props, { className: (0, _classnames2['default'])(className, bsClassName) }),
	      children
	    );
	  };
	
	  return NavbarBrand;
	}(_react2['default'].Component);
	
	NavbarBrand.contextTypes = contextTypes;
	
	exports['default'] = NavbarBrand;
	module.exports = exports['default'];

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Overlay = __webpack_require__(1643);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(218);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _propTypes2['default'].bool,
	  /**
	   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
	   */
	  rootClose: _propTypes2['default'].bool,
	  /**
	   * A callback invoked by the overlay when it wishes to be hidden. Required if
	   * `rootClose` is specified.
	   */
	  onHide: _propTypes2['default'].func,
	
	  /**
	   * Use animation
	   */
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _propTypes2['default'].func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * Sets the direction of the Overlay.
	   */
	  placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left'])
	});
	
	var defaultProps = {
	  animation: _Fade2['default'],
	  rootClose: false,
	  show: false,
	  placement: 'right'
	};
	
	var Overlay = function (_React$Component) {
	  (0, _inherits3['default'])(Overlay, _React$Component);
	
	  function Overlay() {
	    (0, _classCallCheck3['default'])(this, Overlay);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props,
	        animation = _props.animation,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['animation', 'children']);
	
	
	    var transition = animation === true ? _Fade2['default'] : animation || null;
	
	    var child = void 0;
	
	    if (!transition) {
	      child = (0, _react.cloneElement)(children, {
	        className: (0, _classnames2['default'])(children.props.className, 'in')
	      });
	    } else {
	      child = children;
	    }
	
	    return _react2['default'].createElement(
	      _Overlay2['default'],
	      (0, _extends3['default'])({}, props, {
	        transition: transition
	      }),
	      child
	    );
	  };
	
	  return Overlay;
	}(_react2['default'].Component);
	
	Overlay.propTypes = propTypes;
	Overlay.defaultProps = defaultProps;
	
	exports['default'] = Overlay;
	module.exports = exports['default'];

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(69);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(34);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  disabled: _propTypes2['default'].bool,
	  previous: _propTypes2['default'].bool,
	  next: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func,
	  onSelect: _propTypes2['default'].func,
	  eventKey: _propTypes2['default'].any
	};
	
	var defaultProps = {
	  disabled: false,
	  previous: false,
	  next: false
	};
	
	var PagerItem = function (_React$Component) {
	  (0, _inherits3['default'])(PagerItem, _React$Component);
	
	  function PagerItem(props, context) {
	    (0, _classCallCheck3['default'])(this, PagerItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  PagerItem.prototype.handleSelect = function handleSelect(e) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (onSelect || disabled) {
	      e.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, e);
	    }
	  };
	
	  PagerItem.prototype.render = function render() {
	    var _props2 = this.props,
	        disabled = _props2.disabled,
	        previous = _props2.previous,
	        next = _props2.next,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['disabled', 'previous', 'next', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        className: (0, _classnames2['default'])(className, { disabled: disabled, previous: previous, next: next }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleSelect)
	      }))
	    );
	  };
	
	  return PagerItem;
	}(_react2['default'].Component);
	
	PagerItem.propTypes = propTypes;
	PagerItem.defaultProps = defaultProps;
	
	exports['default'] = PagerItem;
	module.exports = exports['default'];

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _SafeAnchor = __webpack_require__(69);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(34);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should be `<Pagination.Item>`.
	
	// TODO: This should use `componentClass` like other components.
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	  className: _propTypes2['default'].string,
	  eventKey: _propTypes2['default'].any,
	  onSelect: _propTypes2['default'].func,
	  disabled: _propTypes2['default'].bool,
	  active: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  componentClass: _SafeAnchor2['default'],
	  active: false,
	  disabled: false
	};
	
	var PaginationButton = function (_React$Component) {
	  (0, _inherits3['default'])(PaginationButton, _React$Component);
	
	  function PaginationButton(props, context) {
	    (0, _classCallCheck3['default'])(this, PaginationButton);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  PaginationButton.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  PaginationButton.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    if (Component === _SafeAnchor2['default']) {
	      // Assume that custom components want `eventKey`.
	      delete props.eventKey;
	    }
	
	    delete props.onSelect;
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return PaginationButton;
	}(_react2['default'].Component);
	
	PaginationButton.propTypes = propTypes;
	PaginationButton.defaultProps = defaultProps;
	
	exports['default'] = PaginationButton;
	module.exports = exports['default'];

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(361);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _createChainedFunction = __webpack_require__(34);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(45);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  accordion: _propTypes2['default'].bool,
	  activeKey: _propTypes2['default'].any,
	  defaultActiveKey: _propTypes2['default'].any,
	  onSelect: _propTypes2['default'].func,
	  role: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  accordion: false
	};
	
	// TODO: Use uncontrollable.
	
	var PanelGroup = function (_React$Component) {
	  (0, _inherits3['default'])(PanelGroup, _React$Component);
	
	  function PanelGroup(props, context) {
	    (0, _classCallCheck3['default'])(this, PanelGroup);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	
	    _this.state = {
	      activeKey: props.defaultActiveKey
	    };
	    return _this;
	  }
	
	  PanelGroup.prototype.handleSelect = function handleSelect(key, e) {
	    e.preventDefault();
	
	    if (this.props.onSelect) {
	      this.props.onSelect(key, e);
	    }
	
	    if (this.state.activeKey === key) {
	      key = null;
	    }
	
	    this.setState({ activeKey: key });
	  };
	
	  PanelGroup.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        accordion = _props.accordion,
	        propsActiveKey = _props.activeKey,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['accordion', 'activeKey', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultActiveKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeKey = void 0;
	    if (accordion) {
	      activeKey = propsActiveKey != null ? propsActiveKey : this.state.activeKey;
	      elementProps.role = elementProps.role || 'tablist';
	    }
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        var childProps = {
	          bsStyle: child.props.bsStyle || bsProps.bsStyle
	        };
	
	        if (accordion) {
	          (0, _assign2['default'])(childProps, {
	            headerRole: 'tab',
	            panelRole: 'tabpanel',
	            collapsible: true,
	            expanded: child.props.eventKey === activeKey,
	            onSelect: (0, _createChainedFunction2['default'])(_this2.handleSelect, child.props.onSelect)
	          });
	        }
	
	        return (0, _react.cloneElement)(child, childProps);
	      })
	    );
	  };
	
	  return PanelGroup;
	}(_react2['default'].Component);
	
	PanelGroup.propTypes = propTypes;
	PanelGroup.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('panel-group', PanelGroup);
	module.exports = exports['default'];

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _createChainedFunction = __webpack_require__(34);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _Fade = __webpack_require__(218);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Uniquely identify the `<TabPane>` among its siblings.
	   */
	  eventKey: _propTypes2['default'].any,
	
	  /**
	   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
	   * `true` to enable the default `<Fade>` animation or any `<Transition>`
	   * component.
	   */
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	
	  /** @private **/
	  id: _propTypes2['default'].string,
	
	  /** @private **/
	  'aria-labelledby': _propTypes2['default'].string,
	
	  /**
	   * If not explicitly specified and rendered in the context of a
	   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
	   * If otherwise not explicitly specified, `tab-pane`.
	   */
	  bsClass: _propTypes2['default'].string,
	
	  /**
	   * Transition onEnter callback when animation is not `false`
	   */
	  onEnter: _propTypes2['default'].func,
	
	  /**
	   * Transition onEntering callback when animation is not `false`
	   */
	  onEntering: _propTypes2['default'].func,
	
	  /**
	   * Transition onEntered callback when animation is not `false`
	   */
	  onEntered: _propTypes2['default'].func,
	
	  /**
	   * Transition onExit callback when animation is not `false`
	   */
	  onExit: _propTypes2['default'].func,
	
	  /**
	   * Transition onExiting callback when animation is not `false`
	   */
	  onExiting: _propTypes2['default'].func,
	
	  /**
	   * Transition onExited callback when animation is not `false`
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount the tab (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2['default'].bool
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2['default'].shape({
	    getTabId: _propTypes2['default'].func,
	    getPaneId: _propTypes2['default'].func
	  }),
	  $bs_tabContent: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	    activeKey: _propTypes2['default'].any,
	    mountOnEnter: _propTypes2['default'].bool,
	    unmountOnExit: _propTypes2['default'].bool,
	    onPaneEnter: _propTypes2['default'].func.isRequired,
	    onPaneExited: _propTypes2['default'].func.isRequired,
	    exiting: _propTypes2['default'].bool.isRequired
	  })
	};
	
	/**
	 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
	 * conflict with the top level one.
	 */
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2['default'].oneOf([null])
	};
	
	var TabPane = function (_React$Component) {
	  (0, _inherits3['default'])(TabPane, _React$Component);
	
	  function TabPane(props, context) {
	    (0, _classCallCheck3['default'])(this, TabPane);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	
	    _this['in'] = false;
	    return _this;
	  }
	
	  TabPane.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_tabContainer: null
	    };
	  };
	
	  TabPane.prototype.componentDidMount = function componentDidMount() {
	    if (this.shouldBeIn()) {
	      // In lieu of the action event firing.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this['in']) {
	      if (!this.shouldBeIn()) {
	        // We shouldn't be active any more. Notify the parent.
	        this.handleExited();
	      }
	    } else if (this.shouldBeIn()) {
	      // We are the active child. Notify the parent.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this['in']) {
	      // In lieu of the action event firing.
	      this.handleExited();
	    }
	  };
	
	  TabPane.prototype.handleEnter = function handleEnter() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    this['in'] = tabContent.onPaneEnter(this, this.props.eventKey);
	  };
	
	  TabPane.prototype.handleExited = function handleExited() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    tabContent.onPaneExited(this);
	    this['in'] = false;
	  };
	
	  TabPane.prototype.getAnimation = function getAnimation() {
	    if (this.props.animation != null) {
	      return this.props.animation;
	    }
	
	    var tabContent = this.context.$bs_tabContent;
	    return tabContent && tabContent.animation;
	  };
	
	  TabPane.prototype.isActive = function isActive() {
	    var tabContent = this.context.$bs_tabContent;
	    var activeKey = tabContent && tabContent.activeKey;
	
	    return this.props.eventKey === activeKey;
	  };
	
	  TabPane.prototype.shouldBeIn = function shouldBeIn() {
	    return this.getAnimation() && this.isActive();
	  };
	
	  TabPane.prototype.render = function render() {
	    var _props = this.props,
	        eventKey = _props.eventKey,
	        className = _props.className,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        propsMountOnEnter = _props.mountOnEnter,
	        propsUnmountOnExit = _props.unmountOnExit,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['eventKey', 'className', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'mountOnEnter', 'unmountOnExit']);
	    var _context = this.context,
	        tabContent = _context.$bs_tabContent,
	        tabContainer = _context.$bs_tabContainer;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var active = this.isActive();
	    var animation = this.getAnimation();
	
	    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
	    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;
	
	    if (!active && !animation && unmountOnExit) {
	      return null;
	    }
	
	    var Transition = animation === true ? _Fade2['default'] : animation || null;
	
	    if (tabContent) {
	      bsProps.bsClass = (0, _bootstrapUtils.prefix)(tabContent, 'pane');
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active
	    });
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      elementProps.id = tabContainer.getPaneId(eventKey);
	      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
	    }
	
	    var pane = _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      role: 'tabpanel',
	      'aria-hidden': !active,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	
	    if (Transition) {
	      var exiting = tabContent && tabContent.exiting;
	
	      return _react2['default'].createElement(
	        Transition,
	        {
	          'in': active && !exiting,
	          onEnter: (0, _createChainedFunction2['default'])(this.handleEnter, onEnter),
	          onEntering: onEntering,
	          onEntered: onEntered,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: (0, _createChainedFunction2['default'])(this.handleExited, onExited),
	          mountOnEnter: mountOnEnter,
	          unmountOnExit: unmountOnExit
	        },
	        pane
	      );
	    }
	
	    return pane;
	  };
	
	  return TabPane;
	}(_react2['default'].Component);
	
	TabPane.propTypes = propTypes;
	TabPane.contextTypes = contextTypes;
	TabPane.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tab-pane', TabPane);
	module.exports = exports['default'];

/***/ },
/* 486 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = capitalize;
	function capitalize(string) {
	  return "" + string.charAt(0).toUpperCase() + string.slice(1);
	}
	module.exports = exports["default"];

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isSafari = exports.isFirefox = undefined;
	
	var _memoize = __webpack_require__(1463);
	
	var _memoize2 = _interopRequireDefault(_memoize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isFirefox = exports.isFirefox = (0, _memoize2.default)(function () {
	  return (/firefox/i.test(navigator.userAgent)
	  );
	});
	var isSafari = exports.isSafari = (0, _memoize2.default)(function () {
	  return Boolean(window.safari);
	});

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.unpackBackendForEs5Users = exports.createChildContext = exports.CHILD_CONTEXT_TYPES = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = DragDropContext;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dndCore = __webpack_require__(952);
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _hoistNonReactStatics = __webpack_require__(291);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _checkDecoratorArguments = __webpack_require__(220);
	
	var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CHILD_CONTEXT_TYPES = exports.CHILD_CONTEXT_TYPES = {
		dragDropManager: _propTypes2.default.object.isRequired
	};
	
	var createChildContext = exports.createChildContext = function createChildContext(backend, context) {
		return {
			dragDropManager: new _dndCore.DragDropManager(backend, context)
		};
	};
	
	var unpackBackendForEs5Users = exports.unpackBackendForEs5Users = function unpackBackendForEs5Users(backendOrModule) {
		// Auto-detect ES6 default export for people still using ES5
		var backend = backendOrModule;
		if ((typeof backend === 'undefined' ? 'undefined' : _typeof(backend)) === 'object' && typeof backend.default === 'function') {
			backend = backend.default;
		}
		(0, _invariant2.default)(typeof backend === 'function', 'Expected the backend to be a function or an ES6 module exporting a default function. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-drop-context.html');
		return backend;
	};
	
	function DragDropContext(backendOrModule) {
		_checkDecoratorArguments2.default.apply(undefined, ['DragDropContext', 'backend'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
	
		var backend = unpackBackendForEs5Users(backendOrModule);
		var childContext = createChildContext(backend);
	
		return function decorateContext(DecoratedComponent) {
			var _class, _temp;
	
			var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
			var DragDropContextContainer = (_temp = _class = function (_Component) {
				_inherits(DragDropContextContainer, _Component);
	
				function DragDropContextContainer() {
					_classCallCheck(this, DragDropContextContainer);
	
					return _possibleConstructorReturn(this, (DragDropContextContainer.__proto__ || Object.getPrototypeOf(DragDropContextContainer)).apply(this, arguments));
				}
	
				_createClass(DragDropContextContainer, [{
					key: 'getDecoratedComponentInstance',
					value: function getDecoratedComponentInstance() {
						(0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can not be a stateless component.');
						return this.child;
					}
				}, {
					key: 'getManager',
					value: function getManager() {
						return childContext.dragDropManager;
					}
				}, {
					key: 'getChildContext',
					value: function getChildContext() {
						return childContext;
					}
				}, {
					key: 'render',
					value: function render() {
						var _this2 = this;
	
						return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, {
							ref: function ref(child) {
								_this2.child = child;
							}
						}));
					}
				}]);
	
				return DragDropContextContainer;
			}(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragDropContext(' + displayName + ')', _class.childContextTypes = CHILD_CONTEXT_TYPES, _temp);
	
	
			return (0, _hoistNonReactStatics2.default)(DragDropContextContainer, DecoratedComponent);
		};
	}

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = areOptionsEqual;
	
	var _shallowEqual = __webpack_require__(327);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function areOptionsEqual(nextOptions, currentOptions) {
		if (currentOptions === nextOptions) {
			return true;
		}
	
		return currentOptions !== null && nextOptions !== null && (0, _shallowEqual2.default)(currentOptions, nextOptions);
	}

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = decorateHandler;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _disposables = __webpack_require__(945);
	
	var _isPlainObject = __webpack_require__(78);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _hoistNonReactStatics = __webpack_require__(291);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _shallowEqual = __webpack_require__(327);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _shallowEqualScalar = __webpack_require__(493);
	
	var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isClassComponent = function isClassComponent(Comp) {
		return Boolean(Comp && Comp.prototype && typeof Comp.prototype.render === 'function');
	};
	
	function decorateHandler(_ref) {
		var _class, _temp;
	
		var DecoratedComponent = _ref.DecoratedComponent,
		    createHandler = _ref.createHandler,
		    createMonitor = _ref.createMonitor,
		    createConnector = _ref.createConnector,
		    registerHandler = _ref.registerHandler,
		    containerDisplayName = _ref.containerDisplayName,
		    getType = _ref.getType,
		    collect = _ref.collect,
		    options = _ref.options;
		var _options$arePropsEqua = options.arePropsEqual,
		    arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;
	
		var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
		var DragDropContainer = (_temp = _class = function (_Component) {
			_inherits(DragDropContainer, _Component);
	
			_createClass(DragDropContainer, [{
				key: 'getHandlerId',
				value: function getHandlerId() {
					return this.handlerId;
				}
			}, {
				key: 'getDecoratedComponentInstance',
				value: function getDecoratedComponentInstance() {
					return this.decoratedComponentInstance;
				}
			}, {
				key: 'shouldComponentUpdate',
				value: function shouldComponentUpdate(nextProps, nextState) {
					return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
				}
			}]);
	
			function DragDropContainer(props, context) {
				_classCallCheck(this, DragDropContainer);
	
				var _this = _possibleConstructorReturn(this, (DragDropContainer.__proto__ || Object.getPrototypeOf(DragDropContainer)).call(this, props, context));
	
				_this.handleChange = _this.handleChange.bind(_this);
				_this.handleChildRef = _this.handleChildRef.bind(_this);
	
				(0, _invariant2.default)(_typeof(_this.context.dragDropManager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
	
				_this.manager = _this.context.dragDropManager;
				_this.handlerMonitor = createMonitor(_this.manager);
				_this.handlerConnector = createConnector(_this.manager.getBackend());
				_this.handler = createHandler(_this.handlerMonitor);
	
				_this.disposable = new _disposables.SerialDisposable();
				_this.receiveProps(props);
				_this.state = _this.getCurrentState();
				_this.dispose();
				return _this;
			}
	
			_createClass(DragDropContainer, [{
				key: 'componentDidMount',
				value: function componentDidMount() {
					this.isCurrentlyMounted = true;
					this.disposable = new _disposables.SerialDisposable();
					this.currentType = null;
					this.receiveProps(this.props);
					this.handleChange();
				}
			}, {
				key: 'componentWillReceiveProps',
				value: function componentWillReceiveProps(nextProps) {
					if (!arePropsEqual(nextProps, this.props)) {
						this.receiveProps(nextProps);
						this.handleChange();
					}
				}
			}, {
				key: 'componentWillUnmount',
				value: function componentWillUnmount() {
					this.dispose();
					this.isCurrentlyMounted = false;
				}
			}, {
				key: 'receiveProps',
				value: function receiveProps(props) {
					this.handler.receiveProps(props);
					this.receiveType(getType(props));
				}
			}, {
				key: 'receiveType',
				value: function receiveType(type) {
					if (type === this.currentType) {
						return;
					}
	
					this.currentType = type;
	
					var _registerHandler = registerHandler(type, this.handler, this.manager),
					    handlerId = _registerHandler.handlerId,
					    unregister = _registerHandler.unregister;
	
					this.handlerId = handlerId;
					this.handlerMonitor.receiveHandlerId(handlerId);
					this.handlerConnector.receiveHandlerId(handlerId);
	
					var globalMonitor = this.manager.getMonitor();
					var unsubscribe = globalMonitor.subscribeToStateChange(this.handleChange, { handlerIds: [handlerId] });
	
					this.disposable.setDisposable(new _disposables.CompositeDisposable(new _disposables.Disposable(unsubscribe), new _disposables.Disposable(unregister)));
				}
			}, {
				key: 'handleChange',
				value: function handleChange() {
					if (!this.isCurrentlyMounted) {
						return;
					}
	
					var nextState = this.getCurrentState();
					if (!(0, _shallowEqual2.default)(nextState, this.state)) {
						this.setState(nextState);
					}
				}
			}, {
				key: 'dispose',
				value: function dispose() {
					this.disposable.dispose();
					this.handlerConnector.receiveHandlerId(null);
				}
			}, {
				key: 'handleChildRef',
				value: function handleChildRef(component) {
					this.decoratedComponentInstance = component;
					this.handler.receiveComponent(component);
				}
			}, {
				key: 'getCurrentState',
				value: function getCurrentState() {
					var nextState = collect(this.handlerConnector.hooks, this.handlerMonitor);
	
					if (false) {
						(0, _invariant2.default)((0, _isPlainObject2.default)(nextState), 'Expected `collect` specified as the second argument to ' + '%s for %s to return a plain object of props to inject. ' + 'Instead, received %s.', containerDisplayName, displayName, nextState);
					}
	
					return nextState;
				}
			}, {
				key: 'render',
				value: function render() {
					return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
						ref: isClassComponent(DecoratedComponent) ? this.handleChildRef : null
					}));
				}
			}]);
	
			return DragDropContainer;
		}(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = containerDisplayName + '(' + displayName + ')', _class.contextTypes = {
			dragDropManager: _propTypes2.default.object.isRequired
		}, _temp);
	
	
		return (0, _hoistNonReactStatics2.default)(DragDropContainer, DecoratedComponent);
	}

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DragDropContext = __webpack_require__(488);
	
	Object.defineProperty(exports, 'DragDropContext', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragDropContext).default;
	  }
	});
	
	var _DragDropContextProvider = __webpack_require__(1563);
	
	Object.defineProperty(exports, 'DragDropContextProvider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragDropContextProvider).default;
	  }
	});
	
	var _DragLayer = __webpack_require__(1564);
	
	Object.defineProperty(exports, 'DragLayer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragLayer).default;
	  }
	});
	
	var _DragSource = __webpack_require__(1565);
	
	Object.defineProperty(exports, 'DragSource', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragSource).default;
	  }
	});
	
	var _DropTarget = __webpack_require__(1566);
	
	Object.defineProperty(exports, 'DropTarget', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropTarget).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isValidType;
	
	var _isArray = __webpack_require__(110);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidType(type, allowArray) {
		return typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol' || allowArray && (0, _isArray2.default)(type) && type.every(function (t) {
			return isValidType(t, false);
		});
	}

/***/ },
/* 493 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = shallowEqualScalar;
	function shallowEqualScalar(objA, objB) {
		if (objA === objB) {
			return true;
		}
	
		if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
			return false;
		}
	
		var keysA = Object.keys(objA);
		var keysB = Object.keys(objB);
	
		if (keysA.length !== keysB.length) {
			return false;
		}
	
		// Test for A's keys different from B.
		var hasOwn = Object.prototype.hasOwnProperty;
		for (var i = 0; i < keysA.length; i += 1) {
			if (!hasOwn.call(objB, keysA[i])) {
				return false;
			}
	
			var valA = objA[keysA[i]];
			var valB = objB[keysA[i]];
	
			if (valA !== valB || (typeof valA === 'undefined' ? 'undefined' : _typeof(valA)) === 'object' || (typeof valB === 'undefined' ? 'undefined' : _typeof(valB)) === 'object') {
				return false;
			}
		}
	
		return true;
	}

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = wrapConnectorHooks;
	
	var _react = __webpack_require__(1);
	
	var _cloneWithRef = __webpack_require__(1575);
	
	var _cloneWithRef2 = _interopRequireDefault(_cloneWithRef);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function throwIfCompositeComponentElement(element) {
		// Custom components can no longer be wrapped directly in React DnD 2.0
		// so that we don't need to depend on findDOMNode() from react-dom.
		if (typeof element.type === 'string') {
			return;
		}
	
		var displayName = element.type.displayName || element.type.name || 'the component';
	
		throw new Error('Only native element nodes can now be passed to React DnD connectors.' + ('You can either wrap ' + displayName + ' into a <div>, or turn it into a ') + 'drag source or a drop target itself.');
	}
	
	function wrapHookToRecognizeElement(hook) {
		return function () {
			var elementOrNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
			// When passed a node, call the hook straight away.
			if (!(0, _react.isValidElement)(elementOrNode)) {
				var node = elementOrNode;
				hook(node, options);
				return undefined;
			}
	
			// If passed a ReactElement, clone it and attach this function as a ref.
			// This helps us achieve a neat API where user doesn't even know that refs
			// are being used under the hood.
			var element = elementOrNode;
			throwIfCompositeComponentElement(element);
	
			// When no options are passed, use the hook directly
			var ref = options ? function (node) {
				return hook(node, options);
			} : hook;
	
			return (0, _cloneWithRef2.default)(element, ref);
		};
	}
	
	function wrapConnectorHooks(hooks) {
		var wrappedHooks = {};
	
		Object.keys(hooks).forEach(function (key) {
			var hook = hooks[key];
			var wrappedHook = wrapHookToRecognizeElement(hook);
			wrappedHooks[key] = function () {
				return wrappedHook;
			};
		});
	
		return wrappedHooks;
	}

/***/ },
/* 495 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(112);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(132);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactInstrumentation = __webpack_require__(59);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1637);
	var warning = __webpack_require__(20);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 498 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(31);
	
	var LinkedValueUtils = __webpack_require__(333);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactUpdates = __webpack_require__(70);
	
	var warning = __webpack_require__(20);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 500 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 501 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var invariant = __webpack_require__(12);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1597);
	
	var containsNode = __webpack_require__(984);
	var focusNode = __webpack_require__(424);
	var getActiveElement = __webpack_require__(425);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var DOMLazyTree = __webpack_require__(131);
	var DOMProperty = __webpack_require__(132);
	var React = __webpack_require__(135);
	var ReactBrowserEventEmitter = __webpack_require__(221);
	var ReactCurrentOwner = __webpack_require__(81);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactDOMContainerInfo = __webpack_require__(1591);
	var ReactDOMFeatureFlags = __webpack_require__(1593);
	var ReactFeatureFlags = __webpack_require__(501);
	var ReactInstanceMap = __webpack_require__(173);
	var ReactInstrumentation = __webpack_require__(59);
	var ReactMarkupChecksum = __webpack_require__(1607);
	var ReactReconciler = __webpack_require__(133);
	var ReactUpdateQueue = __webpack_require__(336);
	var ReactUpdates = __webpack_require__(70);
	
	var emptyObject = __webpack_require__(284);
	var instantiateReactComponent = __webpack_require__(512);
	var invariant = __webpack_require__(12);
	var setInnerHTML = __webpack_require__(225);
	var shouldUpdateReactComponent = __webpack_require__(342);
	var warning = __webpack_require__(20);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var React = __webpack_require__(135);
	
	var invariant = __webpack_require__(12);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 506 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 508 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(505);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(40);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(32);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19),
	    _assign = __webpack_require__(31);
	
	var ReactCompositeComponent = __webpack_require__(1588);
	var ReactEmptyComponent = __webpack_require__(500);
	var ReactHostComponent = __webpack_require__(502);
	
	var getNextDebugID = __webpack_require__(1691);
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(20);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 513 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(40);
	var escapeTextContentForBrowser = __webpack_require__(224);
	var setInnerHTML = __webpack_require__(225);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var ReactCurrentOwner = __webpack_require__(81);
	var REACT_ELEMENT_TYPE = __webpack_require__(1603);
	
	var getIteratorFn = __webpack_require__(1634);
	var invariant = __webpack_require__(12);
	var KeyEscapeUtils = __webpack_require__(332);
	var warning = __webpack_require__(20);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1), __webpack_require__(9));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types"], factory);
		else {
			var a = typeof exports === 'object' ? factory(require("react"), require("prop-types")) : factory(root["react"], root["prop-types"]);
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__12__, __WEBPACK_EXTERNAL_MODULE__13__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 10);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = warn;
	
	function warn(s) {
	  console.warn('[react-ga]', s);
	}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = trim;
	
	// GA strings need to have leading/trailing whitespace trimmed, and not all
	// browsers have String.prototoype.trim().
	function trim(s) {
	  return s.replace(/^\s+|\s+$/g, '');
	}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialize = initialize;
	exports.ga = ga;
	exports.set = set;
	exports.send = send;
	exports.pageview = pageview;
	exports.modalview = modalview;
	exports.timing = timing;
	exports.event = event;
	exports.exception = exception;
	exports.outboundLink = outboundLink;
	exports["default"] = exports.testModeAPI = exports.plugin = void 0;
	
	var _format2 = _interopRequireDefault(__webpack_require__(3));
	
	var _removeLeadingSlash = _interopRequireDefault(__webpack_require__(6));
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	var _loadGA = _interopRequireDefault(__webpack_require__(7));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	var _log = _interopRequireDefault(__webpack_require__(8));
	
	var _testModeAPI = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';
	
	var _debug = false;
	var _titleCase = true;
	var _testMode = false;
	var _alwaysSendToDefaultTracker = true;
	
	var internalGa = function internalGa() {
	  var _window;
	
	  if (_testMode) return _testModeAPI["default"].ga.apply(_testModeAPI["default"], arguments);
	  if (_isNotBrowser) return false;
	  if (!window.ga) return (0, _warn["default"])('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
	  return (_window = window).ga.apply(_window, arguments);
	};
	
	function _format(s) {
	  return (0, _format2["default"])(s, _titleCase);
	}
	
	function _gaCommand(trackerNames) {
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  var command = args[0];
	
	  if (typeof internalGa === 'function') {
	    if (typeof command !== 'string') {
	      (0, _warn["default"])('ga command must be a string');
	      return;
	    }
	
	    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);
	
	    if (Array.isArray(trackerNames)) {
	      trackerNames.forEach(function (name) {
	        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
	      });
	    }
	  }
	}
	
	function _initialize(gaTrackingID, options) {
	  if (!gaTrackingID) {
	    (0, _warn["default"])('gaTrackingID is required in initialize()');
	    return;
	  }
	
	  if (options) {
	    if (options.debug && options.debug === true) {
	      _debug = true;
	    }
	
	    if (options.titleCase === false) {
	      _titleCase = false;
	    }
	
	    if (options.useExistingGa) {
	      return;
	    }
	  }
	
	  if (options && options.gaOptions) {
	    internalGa('create', gaTrackingID, options.gaOptions);
	  } else {
	    internalGa('create', gaTrackingID, 'auto');
	  }
	}
	
	function initialize(configsOrTrackingId, options) {
	  if (options && options.testMode === true) {
	    _testMode = true;
	  } else {
	    if (_isNotBrowser) {
	      return false;
	    }
	
	    if (!options || options.standardImplementation !== true) (0, _loadGA["default"])(options);
	  }
	
	  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;
	
	  if (Array.isArray(configsOrTrackingId)) {
	    configsOrTrackingId.forEach(function (config) {
	      if (_typeof(config) !== 'object') {
	        (0, _warn["default"])('All configs must be an object');
	        return;
	      }
	
	      _initialize(config.trackingId, config);
	    });
	  } else {
	    _initialize(configsOrTrackingId, options);
	  }
	
	  return true;
	}
	/**
	 * ga:
	 * Returns the original GA object.
	 */
	
	
	function ga() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (args.length > 0) {
	    internalGa.apply(void 0, args);
	
	    if (_debug) {
	      (0, _log["default"])('called ga(\'arguments\');');
	      (0, _log["default"])("with arguments: ".concat(JSON.stringify(args)));
	    }
	  }
	
	  return window.ga;
	}
	/**
	 * set:
	 * GA tracker set method
	 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function set(fieldsObject, trackerNames) {
	  if (!fieldsObject) {
	    (0, _warn["default"])('`fieldsObject` is required in .set()');
	    return;
	  }
	
	  if (_typeof(fieldsObject) !== 'object') {
	    (0, _warn["default"])('Expected `fieldsObject` arg to be an Object');
	    return;
	  }
	
	  if (Object.keys(fieldsObject).length === 0) {
	    (0, _warn["default"])('empty `fieldsObject` given to .set()');
	  }
	
	  _gaCommand(trackerNames, 'set', fieldsObject);
	
	  if (_debug) {
	    (0, _log["default"])('called ga(\'set\', fieldsObject);');
	    (0, _log["default"])("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
	  }
	}
	/**
	 * send:
	 * Clone of the low level `ga.send` method
	 * WARNING: No validations will be applied to this
	 * @param  {Object} fieldObject - field object for tracking different analytics
	 * @param  {Array} trackerNames - trackers to send the command to
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function send(fieldObject, trackerNames) {
	  _gaCommand(trackerNames, 'send', fieldObject);
	
	  if (_debug) {
	    (0, _log["default"])('called ga(\'send\', fieldObject);');
	    (0, _log["default"])("with fieldObject: ".concat(JSON.stringify(fieldObject)));
	    (0, _log["default"])("with trackers: ".concat(JSON.stringify(trackerNames)));
	  }
	}
	/**
	 * pageview:
	 * Basic GA pageview tracking
	 * @param  {String} path - the current page page e.g. '/about'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 * @param {String} title - (optional) the page title e. g. 'My Website'
	 */
	
	
	function pageview(rawPath, trackerNames, title) {
	  if (!rawPath) {
	    (0, _warn["default"])('path is required in .pageview()');
	    return;
	  }
	
	  var path = (0, _trim["default"])(rawPath);
	
	  if (path === '') {
	    (0, _warn["default"])('path cannot be an empty string in .pageview()');
	    return;
	  }
	
	  var extraFields = {};
	
	  if (title) {
	    extraFields.title = title;
	  }
	
	  if (typeof ga === 'function') {
	    _gaCommand(trackerNames, 'send', _objectSpread({
	      hitType: 'pageview',
	      page: path
	    }, extraFields));
	
	    if (_debug) {
	      (0, _log["default"])('called ga(\'send\', \'pageview\', path);');
	      var extraLog = '';
	
	      if (title) {
	        extraLog = " and title: ".concat(title);
	      }
	
	      (0, _log["default"])("with path: ".concat(path).concat(extraLog));
	    }
	  }
	}
	/**
	 * modalview:
	 * a proxy to basic GA pageview tracking to consistently track
	 * modal views that are an equivalent UX to a traditional pageview
	 * @param  {String} modalName e.g. 'add-or-edit-club'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function modalview(rawModalName, trackerNames) {
	  if (!rawModalName) {
	    (0, _warn["default"])('modalName is required in .modalview(modalName)');
	    return;
	  }
	
	  var modalName = (0, _removeLeadingSlash["default"])((0, _trim["default"])(rawModalName));
	
	  if (modalName === '') {
	    (0, _warn["default"])('modalName cannot be an empty string or a single / in .modalview()');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    var path = "/modal/".concat(modalName);
	
	    _gaCommand(trackerNames, 'send', 'pageview', path);
	
	    if (_debug) {
	      (0, _log["default"])('called ga(\'send\', \'pageview\', path);');
	      (0, _log["default"])("with path: ".concat(path));
	    }
	  }
	}
	/**
	 * timing:
	 * GA timing
	 * @param args.category {String} required
	 * @param args.variable {String} required
	 * @param args.value  {Int}  required
	 * @param args.label  {String} required
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function timing() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref.category,
	      variable = _ref.variable,
	      value = _ref.value,
	      label = _ref.label;
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    if (!category || !variable || !value || typeof value !== 'number') {
	      (0, _warn["default"])('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'timing',
	      timingCategory: _format(category),
	      timingVar: _format(variable),
	      timingValue: value
	    };
	
	    if (label) {
	      fieldObject.timingLabel = _format(label);
	    }
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * event:
	 * GA event tracking
	 * @param args.category {String} required
	 * @param args.action {String} required
	 * @param args.label {String} optional
	 * @param args.value {Int} optional
	 * @param args.nonInteraction {boolean} optional
	 * @param args.transport {string} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function event() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref2.category,
	      action = _ref2.action,
	      label = _ref2.label,
	      value = _ref2.value,
	      nonInteraction = _ref2.nonInteraction,
	      transport = _ref2.transport,
	      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!category || !action) {
	      (0, _warn["default"])('args.category AND args.action are required in event()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: _format(category),
	      eventAction: _format(action)
	    }; // Optional Fields
	
	    if (label) {
	      fieldObject.eventLabel = _format(label);
	    }
	
	    if (typeof value !== 'undefined') {
	      if (typeof value !== 'number') {
	        (0, _warn["default"])('Expected `args.value` arg to be a Number.');
	      } else {
	        fieldObject.eventValue = value;
	      }
	    }
	
	    if (typeof nonInteraction !== 'undefined') {
	      if (typeof nonInteraction !== 'boolean') {
	        (0, _warn["default"])('`args.nonInteraction` must be a boolean.');
	      } else {
	        fieldObject.nonInteraction = nonInteraction;
	      }
	    }
	
	    if (typeof transport !== 'undefined') {
	      if (typeof transport !== 'string') {
	        (0, _warn["default"])('`args.transport` must be a string.');
	      } else {
	        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
	          (0, _warn["default"])('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
	        }
	
	        fieldObject.transport = transport;
	      }
	    }
	
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'dimension'.length) === 'dimension';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    });
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'metric'.length) === 'metric';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    }); // Send to GA
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * exception:
	 * GA exception tracking
	 * @param args.description {String} optional
	 * @param args.fatal {boolean} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function exception(_ref3, trackerNames) {
	  var description = _ref3.description,
	      fatal = _ref3.fatal;
	
	  if (typeof ga === 'function') {
	    // Required Fields
	    var fieldObject = {
	      hitType: 'exception'
	    }; // Optional Fields
	
	    if (description) {
	      fieldObject.exDescription = _format(description);
	    }
	
	    if (typeof fatal !== 'undefined') {
	      if (typeof fatal !== 'boolean') {
	        (0, _warn["default"])('`args.fatal` must be a boolean.');
	      } else {
	        fieldObject.exFatal = fatal;
	      }
	    } // Send to GA
	
	
	    send(fieldObject, trackerNames);
	  }
	}
	
	var plugin = {
	  /**
	   * require:
	   * GA requires a plugin
	   * @param name {String} e.g. 'ecommerce' or 'myplugin'
	   * @param options {Object} optional e.g {path: '/log', debug: true}
	   * @param trackerName {String} optional e.g 'trackerName'
	   */
	  require: function require(rawName, options, trackerName) {
	    if (typeof ga === 'function') {
	      // Required Fields
	      if (!rawName) {
	        (0, _warn["default"])('`name` is required in .require()');
	        return;
	      }
	
	      var name = (0, _trim["default"])(rawName);
	
	      if (name === '') {
	        (0, _warn["default"])('`name` cannot be an empty string in .require()');
	        return;
	      }
	
	      var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields
	
	      if (options) {
	        if (_typeof(options) !== 'object') {
	          (0, _warn["default"])('Expected `options` arg to be an Object');
	          return;
	        }
	
	        if (Object.keys(options).length === 0) {
	          (0, _warn["default"])('Empty `options` given to .require()');
	        }
	
	        ga(requireString, name, options);
	
	        if (_debug) {
	          (0, _log["default"])("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
	        }
	      } else {
	        ga(requireString, name);
	
	        if (_debug) {
	          (0, _log["default"])("called ga('require', '".concat(name, "');"));
	        }
	      }
	    }
	  },
	
	  /**
	   * execute:
	   * GA execute action for plugin
	   * Takes variable number of arguments
	   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
	   * @param action {String} e.g. 'addItem' or 'myCustomAction'
	   * @param actionType {String} optional e.g. 'detail'
	   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
	   */
	  execute: function execute(pluginName, action) {
	    var payload;
	    var actionType;
	
	    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
	      payload = arguments.length <= 2 ? undefined : arguments[2];
	    } else {
	      actionType = arguments.length <= 2 ? undefined : arguments[2];
	      payload = arguments.length <= 3 ? undefined : arguments[3];
	    }
	
	    if (typeof ga === 'function') {
	      if (typeof pluginName !== 'string') {
	        (0, _warn["default"])('Expected `pluginName` arg to be a String.');
	      } else if (typeof action !== 'string') {
	        (0, _warn["default"])('Expected `action` arg to be a String.');
	      } else {
	        var command = "".concat(pluginName, ":").concat(action);
	        payload = payload || null;
	
	        if (actionType && payload) {
	          ga(command, actionType, payload);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	            (0, _log["default"])("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
	          }
	        } else if (payload) {
	          ga(command, payload);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	            (0, _log["default"])("with payload: ".concat(JSON.stringify(payload)));
	          }
	        } else {
	          ga(command);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	          }
	        }
	      }
	    }
	  }
	};
	/**
	 * outboundLink:
	 * GA outboundLink tracking
	 * @param args.label {String} e.g. url, or 'Create an Account'
	 * @param {function} hitCallback - Called after processing a hit.
	 */
	
	exports.plugin = plugin;
	
	function outboundLink(args, hitCallback, trackerNames) {
	  if (typeof hitCallback !== 'function') {
	    (0, _warn["default"])('hitCallback function is required');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!args || !args.label) {
	      (0, _warn["default"])('args.label is required in outboundLink()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: 'Outbound',
	      eventAction: 'Click',
	      eventLabel: _format(args.label)
	    };
	    var safetyCallbackCalled = false;
	
	    var safetyCallback = function safetyCallback() {
	      // This prevents a delayed response from GA
	      // causing hitCallback from being fired twice
	      safetyCallbackCalled = true;
	      hitCallback();
	    }; // Using a timeout to ensure the execution of critical application code
	    // in the case when the GA server might be down
	    // or an ad blocker prevents sending the data
	    // register safety net timeout:
	
	
	    var t = setTimeout(safetyCallback, 250);
	
	    var clearableCallbackForGA = function clearableCallbackForGA() {
	      clearTimeout(t);
	
	      if (!safetyCallbackCalled) {
	        hitCallback();
	      }
	    };
	
	    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA
	
	    send(fieldObject, trackerNames);
	  } else {
	    // if ga is not defined, return the callback so the application
	    // continues to work as expected
	    setTimeout(hitCallback, 0);
	  }
	}
	
	var testModeAPI = _testModeAPI["default"];
	exports.testModeAPI = testModeAPI;
	var _default = {
	  initialize: initialize,
	  ga: ga,
	  set: set,
	  send: send,
	  pageview: pageview,
	  modalview: modalview,
	  timing: timing,
	  event: event,
	  exception: exception,
	  plugin: plugin,
	  outboundLink: outboundLink,
	  testModeAPI: _testModeAPI["default"]
	};
	exports["default"] = _default;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = format;
	
	var _mightBeEmail = _interopRequireDefault(__webpack_require__(4));
	
	var _toTitleCase = _interopRequireDefault(__webpack_require__(5));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var redacted = 'REDACTED (Potential Email Address)';
	
	function format(s, titleCase) {
	  if ((0, _mightBeEmail["default"])(s)) {
	    (0, _warn["default"])('This arg looks like an email address, redacting.');
	    return redacted;
	  }
	
	  if (titleCase) {
	    return (0, _toTitleCase["default"])(s);
	  }
	
	  return s;
	}
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = mightBeEmail;
	
	// See if s could be an email address. We don't want to send personal data like email.
	// https://support.google.com/analytics/answer/2795983?hl=en
	function mightBeEmail(s) {
	  // There's no point trying to validate rfc822 fully, just look for ...@...
	  return typeof s === 'string' && s.indexOf('@') !== -1;
	}
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = toTitleCase;
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * To Title Case 2.1 - http://individed.com/code/to-title-case/
	 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
	 * https://github.com/gouch/to-title-case
	 */
	var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
	
	function toTitleCase(string) {
	  return (0, _trim["default"])(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
	    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
	      return match.toLowerCase();
	    }
	
	    if (match.substr(1).search(/[A-Z]|\../) > -1) {
	      return match;
	    }
	
	    return match.charAt(0).toUpperCase() + match.substr(1);
	  });
	}
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = removeLeadingSlash;
	
	function removeLeadingSlash(string) {
	  if (string.substring(0, 1) === '/') {
	    return string.substring(1);
	  }
	
	  return string;
	}
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = _default;
	
	function _default(options) {
	  var gaAddress = 'https://www.google-analytics.com/analytics.js';
	
	  if (options && options.gaAddress) {
	    gaAddress = options.gaAddress;
	  } else if (options && options.debug) {
	    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
	  } // https://developers.google.com/analytics/devguides/collection/analyticsjs/
	
	  /* eslint-disable */
	
	
	  (function (i, s, o, g, r, a, m) {
	    i['GoogleAnalyticsObject'] = r;
	    i[r] = i[r] || function () {
	      (i[r].q = i[r].q || []).push(arguments);
	    }, i[r].l = 1 * new Date();
	    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
	    a.async = 1;
	    a.src = g;
	    m.parentNode.insertBefore(a, m);
	  })(window, document, 'script', gaAddress, 'ga');
	  /* eslint-enable */
	
	}
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = log;
	
	function log(s) {
	  console.info('[react-ga]', s);
	}
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.gaCalls = void 0;
	var gaCalls = [];
	exports.gaCalls = gaCalls;
	var _default = {
	  calls: gaCalls,
	  ga: function ga() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    gaCalls.push([].concat(args));
	  },
	  resetCalls: function resetCalls() {
	    gaCalls.length = 0;
	  }
	};
	exports["default"] = _default;
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.OutboundLink = exports.testModeAPI = exports.outboundLink = exports.plugin = exports.exception = exports.event = exports.timing = exports.modalview = exports.pageview = exports.send = exports.set = exports.ga = exports.initialize = void 0;
	
	var _OutboundLink = _interopRequireDefault(__webpack_require__(11));
	
	var Defaults = _interopRequireWildcard(__webpack_require__(2));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialize = Defaults.initialize;
	exports.initialize = initialize;
	var ga = Defaults.ga;
	exports.ga = ga;
	var set = Defaults.set;
	exports.set = set;
	var send = Defaults.send;
	exports.send = send;
	var pageview = Defaults.pageview;
	exports.pageview = pageview;
	var modalview = Defaults.modalview;
	exports.modalview = modalview;
	var timing = Defaults.timing;
	exports.timing = timing;
	var event = Defaults.event;
	exports.event = event;
	var exception = Defaults.exception;
	exports.exception = exception;
	var plugin = Defaults.plugin;
	exports.plugin = plugin;
	var outboundLink = Defaults.outboundLink;
	exports.outboundLink = outboundLink;
	var testModeAPI = Defaults.testModeAPI;
	exports.testModeAPI = testModeAPI;
	_OutboundLink["default"].origTrackLink = _OutboundLink["default"].trackLink;
	_OutboundLink["default"].trackLink = Defaults.outboundLink;
	var OutboundLink = _OutboundLink["default"];
	exports.OutboundLink = OutboundLink;
	
	var _default = _objectSpread({}, Defaults, {
	  OutboundLink: OutboundLink
	});
	
	exports["default"] = _default;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(12));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NEWTAB = '_blank';
	var MIDDLECLICK = 1;
	
	var OutboundLink =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(OutboundLink, _Component);
	
	  function OutboundLink() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, OutboundLink);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OutboundLink)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
	      var _this$props = _this.props,
	          target = _this$props.target,
	          eventLabel = _this$props.eventLabel,
	          to = _this$props.to,
	          onClick = _this$props.onClick,
	          trackerNames = _this$props.trackerNames;
	      var eventMeta = {
	        label: eventLabel
	      };
	      var sameTarget = target !== NEWTAB;
	      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);
	
	      if (sameTarget && normalClick) {
	        event.preventDefault();
	        OutboundLink.trackLink(eventMeta, function () {
	          window.location.href = to;
	        }, trackerNames);
	      } else {
	        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
	      }
	
	      if (onClick) {
	        onClick(event);
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(OutboundLink, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          href = _this$props2.to,
	          oldProps = _objectWithoutProperties(_this$props2, ["to"]);
	
	      var props = _objectSpread({}, oldProps, {
	        href: href,
	        onClick: this.handleClick
	      });
	
	      if (this.props.target === NEWTAB) {
	        props.rel = 'noopener noreferrer';
	      }
	
	      delete props.eventLabel;
	      delete props.trackerNames;
	      return _react["default"].createElement('a', props);
	    }
	  }]);
	
	  return OutboundLink;
	}(_react.Component);
	
	exports["default"] = OutboundLink;
	
	_defineProperty(OutboundLink, "trackLink", function () {
	  (0, _warn["default"])('ga tracking not enabled');
	});
	
	_defineProperty(OutboundLink, "propTypes", {
	  eventLabel: _propTypes["default"].string.isRequired,
	  target: _propTypes["default"].string,
	  to: _propTypes["default"].string,
	  onClick: _propTypes["default"].func,
	  trackerNames: _propTypes["default"].arrayOf(_propTypes["default"].string)
	});
	
	_defineProperty(OutboundLink, "defaultProps", {
	  target: null,
	  to: null,
	  onClick: null,
	  trackerNames: null
	});
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__12__;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__13__;
	
	/***/ })
	/******/ ]);
	});

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1640);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentOrElement = __webpack_require__(345);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _ownerDocument = __webpack_require__(175);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _getContainer = __webpack_require__(344);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = _react2.default.createClass({
	
	  displayName: 'Portal',
	
	  propTypes: {
	    /**
	     * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	     * appended to it.
	     */
	    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func])
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._renderOverlay();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this._renderOverlay();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this._overlayTarget && nextProps.container !== this.props.container) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this._unrenderOverlay();
	    this._unmountOverlayTarget();
	  },
	  _mountOverlayTarget: function _mountOverlayTarget() {
	    if (!this._overlayTarget) {
	      this._overlayTarget = document.createElement('div');
	      this._portalContainerNode = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  _unmountOverlayTarget: function _unmountOverlayTarget() {
	    if (this._overlayTarget) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._overlayTarget = null;
	    }
	    this._portalContainerNode = null;
	  },
	  _renderOverlay: function _renderOverlay() {
	
	    var overlay = !this.props.children ? null : _react2.default.Children.only(this.props.children);
	
	    // Save reference for future access.
	    if (overlay !== null) {
	      this._mountOverlayTarget();
	      this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, overlay, this._overlayTarget);
	    } else {
	      // Unrender if the component is null for transitions to null
	      this._unrenderOverlay();
	      this._unmountOverlayTarget();
	    }
	  },
	  _unrenderOverlay: function _unrenderOverlay() {
	    if (this._overlayTarget) {
	      _reactDom2.default.unmountComponentAtNode(this._overlayTarget);
	      this._overlayInstance = null;
	    }
	  },
	  render: function render() {
	    return null;
	  },
	  getMountNode: function getMountNode() {
	    return this._overlayTarget;
	  },
	  getOverlayDOMNode: function getOverlayDOMNode() {
	    if (!this.isMounted()) {
	      throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
	    }
	
	    if (this._overlayInstance) {
	      return _reactDom2.default.findDOMNode(this._overlayInstance);
	    }
	
	    return null;
	  }
	});
	
	exports.default = Portal;
	module.exports = exports['default'];

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _contains = __webpack_require__(128);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _addEventListener = __webpack_require__(521);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ownerDocument = __webpack_require__(175);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var escapeKeyCode = 27;
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * The `<RootCloseWrapper/>` component registers your callback on the document
	 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
	 * style behavior where your callback is triggered when the user tries to
	 * interact with the rest of the document or hits the `esc` key.
	 */
	
	var RootCloseWrapper = function (_React$Component) {
	  _inherits(RootCloseWrapper, _React$Component);
	
	  function RootCloseWrapper(props, context) {
	    _classCallCheck(this, RootCloseWrapper);
	
	    var _this = _possibleConstructorReturn(this, (RootCloseWrapper.__proto__ || Object.getPrototypeOf(RootCloseWrapper)).call(this, props, context));
	
	    _this.handleMouseCapture = function (e) {
	      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
	    };
	
	    _this.handleMouse = function (e) {
	      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.handleKeyUp = function (e) {
	      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.preventMouseRootClose = false;
	    return _this;
	  }
	
	  _createClass(RootCloseWrapper, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.disabled) {
	        this.addEventListeners();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!this.props.disabled && prevProps.disabled) {
	        this.addEventListeners();
	      } else if (this.props.disabled && !prevProps.disabled) {
	        this.removeEventListeners();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!this.props.disabled) {
	        this.removeEventListeners();
	      }
	    }
	  }, {
	    key: 'addEventListeners',
	    value: function addEventListeners() {
	      var event = this.props.event;
	
	      var doc = (0, _ownerDocument2.default)(this);
	
	      // Use capture for this listener so it fires before React's listener, to
	      // avoid false positives in the contains() check below if the target DOM
	      // element is removed in the React mouse callback.
	      this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, this.handleMouseCapture, true);
	
	      this.documentMouseListener = (0, _addEventListener2.default)(doc, event, this.handleMouse);
	
	      this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleKeyUp);
	    }
	  }, {
	    key: 'removeEventListeners',
	    value: function removeEventListeners() {
	      if (this.documentMouseCaptureListener) {
	        this.documentMouseCaptureListener.remove();
	      }
	
	      if (this.documentMouseListener) {
	        this.documentMouseListener.remove();
	      }
	
	      if (this.documentKeyupListener) {
	        this.documentKeyupListener.remove();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return RootCloseWrapper;
	}(_react2.default.Component);
	
	RootCloseWrapper.displayName = 'RootCloseWrapper';
	
	RootCloseWrapper.propTypes = {
	  /**
	   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
	   */
	  onRootClose: _react2.default.PropTypes.func,
	  /**
	   * Children to render.
	   */
	  children: _react2.default.PropTypes.element,
	  /**
	   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
	   */
	  disabled: _react2.default.PropTypes.bool,
	  /**
	   * Choose which document mouse event to bind to.
	   */
	  event: _react2.default.PropTypes.oneOf(['click', 'mousedown'])
	};
	
	RootCloseWrapper.defaultProps = {
	  event: 'click'
	};
	
	exports.default = RootCloseWrapper;
	module.exports = exports['default'];

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _on = __webpack_require__(201);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _properties = __webpack_require__(283);
	
	var _properties2 = _interopRequireDefault(_properties);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var transitionEndEvent = _properties2.default.end;
	
	var UNMOUNTED = exports.UNMOUNTED = 0;
	var EXITED = exports.EXITED = 1;
	var ENTERING = exports.ENTERING = 2;
	var ENTERED = exports.ENTERED = 3;
	var EXITING = exports.EXITING = 4;
	
	/**
	 * The Transition component lets you define and run css transitions with a simple declarative api.
	 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
	 * but is specifically optimized for transitioning a single child "in" or "out".
	 *
	 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
	 * The extensive set of lifecycle callbacks means you have control over
	 * the transitioning now at each step of the way.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, (Transition.__proto__ || Object.getPrototypeOf(Transition)).call(this, props, context));
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (props.transitionAppear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  _createClass(Transition, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var status = this.state.status;
	
	
	      if (nextProps.in) {
	        if (status === UNMOUNTED) {
	          this.setState({ status: EXITED });
	        }
	        if (status !== ENTERING && status !== ENTERED) {
	          this.nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          this.nextStatus = EXITING;
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.cancelNextCallback();
	    }
	  }, {
	    key: 'updateStatus',
	    value: function updateStatus() {
	      var _this2 = this;
	
	      if (this.nextStatus !== null) {
	        // nextStatus will always be ENTERING or EXITING.
	        this.cancelNextCallback();
	        var node = _reactDom2.default.findDOMNode(this);
	
	        if (this.nextStatus === ENTERING) {
	          this.props.onEnter(node);
	
	          this.safeSetState({ status: ENTERING }, function () {
	            _this2.props.onEntering(node);
	
	            _this2.onTransitionEnd(node, function () {
	              _this2.safeSetState({ status: ENTERED }, function () {
	                _this2.props.onEntered(node);
	              });
	            });
	          });
	        } else {
	          this.props.onExit(node);
	
	          this.safeSetState({ status: EXITING }, function () {
	            _this2.props.onExiting(node);
	
	            _this2.onTransitionEnd(node, function () {
	              _this2.safeSetState({ status: EXITED }, function () {
	                _this2.props.onExited(node);
	              });
	            });
	          });
	        }
	
	        this.nextStatus = null;
	      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	        this.setState({ status: UNMOUNTED });
	      }
	    }
	  }, {
	    key: 'cancelNextCallback',
	    value: function cancelNextCallback() {
	      if (this.nextCallback !== null) {
	        this.nextCallback.cancel();
	        this.nextCallback = null;
	      }
	    }
	  }, {
	    key: 'safeSetState',
	    value: function safeSetState(nextState, callback) {
	      // This shouldn't be necessary, but there are weird race conditions with
	      // setState callbacks and unmounting in testing, so always make sure that
	      // we can cancel any pending setState callbacks after we unmount.
	      this.setState(nextState, this.setNextCallback(callback));
	    }
	  }, {
	    key: 'setNextCallback',
	    value: function setNextCallback(callback) {
	      var _this3 = this;
	
	      var active = true;
	
	      this.nextCallback = function (event) {
	        if (active) {
	          active = false;
	          _this3.nextCallback = null;
	
	          callback(event);
	        }
	      };
	
	      this.nextCallback.cancel = function () {
	        active = false;
	      };
	
	      return this.nextCallback;
	    }
	  }, {
	    key: 'onTransitionEnd',
	    value: function onTransitionEnd(node, handler) {
	      this.setNextCallback(handler);
	
	      if (node) {
	        (0, _on2.default)(node, transitionEndEvent, this.nextCallback);
	        setTimeout(this.nextCallback, this.props.timeout);
	      } else {
	        setTimeout(this.nextCallback, 0);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var status = this.state.status;
	      if (status === UNMOUNTED) {
	        return null;
	      }
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          childProps = _objectWithoutProperties(_props, ['children', 'className']);
	
	      Object.keys(Transition.propTypes).forEach(function (key) {
	        return delete childProps[key];
	      });
	
	      var transitionClassName = void 0;
	      if (status === EXITED) {
	        transitionClassName = this.props.exitedClassName;
	      } else if (status === ENTERING) {
	        transitionClassName = this.props.enteringClassName;
	      } else if (status === ENTERED) {
	        transitionClassName = this.props.enteredClassName;
	      } else if (status === EXITING) {
	        transitionClassName = this.props.exitingClassName;
	      }
	
	      var child = _react2.default.Children.only(children);
	      return _react2.default.cloneElement(child, _extends({}, childProps, {
	        className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
	      }));
	    }
	  }]);
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.propTypes = {
	  /**
	   * Show the component; triggers the enter or exit animation
	   */
	  in: _react2.default.PropTypes.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _react2.default.PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is not shown
	   */
	  unmountOnExit: _react2.default.PropTypes.bool,
	
	  /**
	   * Run the enter animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2.default.PropTypes.bool,
	
	  /**
	   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
	   * transition indefinately if the browser transitionEnd events are
	   * canceled or interrupted.
	   *
	   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
	   * setting this to the duration of your animation (or a bit above it).
	   */
	  timeout: _react2.default.PropTypes.number,
	
	  /**
	   * CSS class or classes applied when the component is exited
	   */
	  exitedClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is exiting
	   */
	  exitingClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied when the component is entered
	   */
	  enteredClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is entering
	   */
	  enteringClassName: _react2.default.PropTypes.string,
	
	  /**
	   * Callback fired before the "entering" classes are applied
	   */
	  onEnter: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "entering" classes are applied
	   */
	  onEntering: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "enter" classes are applied
	   */
	  onEntered: _react2.default.PropTypes.func,
	  /**
	   * Callback fired before the "exiting" classes are applied
	   */
	  onExit: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exiting" classes are applied
	   */
	  onExiting: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exited" classes are applied
	   */
	  onExited: _react2.default.PropTypes.func
	};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.displayName = 'Transition';
	
	Transition.defaultProps = {
	  in: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  timeout: 5000,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	exports.default = Transition;

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (node, event, handler, capture) {
	  (0, _on2.default)(node, event, handler, capture);
	
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, capture);
	    }
	  };
	};
	
	var _on = __webpack_require__(201);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(282);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isOverflowing;
	
	var _isWindow = __webpack_require__(202);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(127);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = (0, _ownerDocument2.default)(node);
	  var win = (0, _isWindow2.default)(doc);
	  var fullWidth = win.innerWidth;
	
	  // Support: ie8, no innerWidth
	  if (!fullWidth) {
	    var documentElementRect = doc.documentElement.getBoundingClientRect();
	    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	  }
	
	  return doc.body.clientWidth < fullWidth;
	}
	
	function isOverflowing(container) {
	  var win = (0, _isWindow2.default)(container);
	
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	module.exports = exports['default'];

/***/ },
/* 523 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var hash = {};
	var cache = [];
	
	var add = function add(url) {
	    if (!hash[url]) {
	        hash[url] = new Image();
	        hash[url].src = url;
	
	        cache.push(hash[url]);
	    }
	    return hash[url];
	};
	
	var get = function get(url) {
	    return add(url);
	};
	
	var stuff = function stuff(urls) {
	    if (urls.length > 0) {
	        urls.map(add);
	    }
	};
	
	var ImageCache = {
	    add: add,
	    stuff: stuff,
	    get: get,
	    hash: hash,
	    cache: cache
	};
	
	exports["default"] = ImageCache;
	module.exports = exports["default"];

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _ImageCache = __webpack_require__(523);
	
	var _ImageCache2 = _interopRequireDefault(_ImageCache);
	
	var ImageHelper = {
	    loadImage: function loadImage(url) {
	        var image = _ImageCache2['default'].get(url);
	
	        return new Promise(function (resolve, reject) {
	            var handleSuccess = function handleSuccess() {
	                resolve(image);
	            };
	            var handleError = function handleError() {
	                console.error('IMAGE FAIL', image);
	                reject(image);
	            };
	
	            if (image.naturalWidth && image.naturalHeight) {
	                // image is loaded, go ahead and change the state
	                handleSuccess();
	            } else {
	                image.addEventListener('load', handleSuccess, false);
	                image.addEventListener('error', handleError, false);
	            }
	        });
	    },
	
	    loadImages: function loadImages(urls) {
	        var promises = urls.map(this.loadImage.bind(this));
	        return Promise.all(promises);
	    },
	
	    // preload without caring about the result
	    stuffImages: function stuffImages(urls) {
	        _ImageCache2['default'].stuff(urls);
	    }
	};
	
	exports['default'] = ImageHelper;
	module.exports = exports['default'];

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _propTypes2["default"].shape({
	  subscribe: _propTypes2["default"].func.isRequired,
	  dispatch: _propTypes2["default"].func.isRequired,
	  getState: _propTypes2["default"].func.isRequired
	});

/***/ },
/* 526 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 527 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ },
/* 528 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  locationBeforeTransitions: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { locationBeforeTransitions: payload });
	  }
	
	  return state;
	}

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(35);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(348);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]),
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    var _props = this.props;
	    var to = _props.to;
	    var query = _props.query;
	    var hash = _props.hash;
	    var state = _props.state;
	
	    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	    this.context.router.push(location);
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (to == null) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(location);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(location, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(91);
	
	var _PatternUtils = __webpack_require__(134);
	
	var _InternalPropTypes = __webpack_require__(113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	var _deprecateObjectProperties = __webpack_require__(230);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(205);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(433);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(1093);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(535);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makeStateWithLocation;
	
	var _deprecateObjectProperties = __webpack_require__(230);
	
	var _routerWarning = __webpack_require__(35);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeStateWithLocation(state, location) {
	  if (false) {
	    var stateWithLocation = _extends({}, state);
	
	    // I don't use deprecateObjectProperties here because I want to keep the
	    // same code path between development and production, in that we just
	    // assign extra properties to the copy of the state object in both cases.
	
	    var _loop = function _loop(prop) {
	      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
	        return 'continue';
	      }
	
	      Object.defineProperty(stateWithLocation, prop, {
	        get: function get() {
	          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
	          return location[prop];
	        }
	      });
	    };
	
	    for (var prop in location) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return stateWithLocation;
	  }
	
	  return _extends({}, state, location);
	}
	module.exports = exports['default'];

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(205);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(433);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.nameShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  leaveActive: _propTypes2.default.string,
	  appear: _propTypes2.default.string,
	  appearActive: _propTypes2.default.string
	})]);

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(176),
	    _assign = __webpack_require__(31);
	
	var ReactNoopUpdateQueue = __webpack_require__(540);
	
	var canDefineProperty = __webpack_require__(541);
	var emptyObject = __webpack_require__(284);
	var invariant = __webpack_require__(12);
	var lowPriorityWarning = __webpack_require__(1692);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(176);
	
	var ReactCurrentOwner = __webpack_require__(81);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(20);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 539 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(20);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _io = __webpack_require__(232);
	
	Object.defineProperty(exports, 'take', {
	  enumerable: true,
	  get: function get() {
	    return _io.take;
	  }
	});
	Object.defineProperty(exports, 'takem', {
	  enumerable: true,
	  get: function get() {
	    return _io.takem;
	  }
	});
	Object.defineProperty(exports, 'put', {
	  enumerable: true,
	  get: function get() {
	    return _io.put;
	  }
	});
	Object.defineProperty(exports, 'race', {
	  enumerable: true,
	  get: function get() {
	    return _io.race;
	  }
	});
	Object.defineProperty(exports, 'call', {
	  enumerable: true,
	  get: function get() {
	    return _io.call;
	  }
	});
	Object.defineProperty(exports, 'apply', {
	  enumerable: true,
	  get: function get() {
	    return _io.apply;
	  }
	});
	Object.defineProperty(exports, 'cps', {
	  enumerable: true,
	  get: function get() {
	    return _io.cps;
	  }
	});
	Object.defineProperty(exports, 'fork', {
	  enumerable: true,
	  get: function get() {
	    return _io.fork;
	  }
	});
	Object.defineProperty(exports, 'spawn', {
	  enumerable: true,
	  get: function get() {
	    return _io.spawn;
	  }
	});
	Object.defineProperty(exports, 'join', {
	  enumerable: true,
	  get: function get() {
	    return _io.join;
	  }
	});
	Object.defineProperty(exports, 'cancel', {
	  enumerable: true,
	  get: function get() {
	    return _io.cancel;
	  }
	});
	Object.defineProperty(exports, 'select', {
	  enumerable: true,
	  get: function get() {
	    return _io.select;
	  }
	});
	Object.defineProperty(exports, 'actionChannel', {
	  enumerable: true,
	  get: function get() {
	    return _io.actionChannel;
	  }
	});
	Object.defineProperty(exports, 'cancelled', {
	  enumerable: true,
	  get: function get() {
	    return _io.cancelled;
	  }
	});

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TASK_CANCEL = exports.CHANNEL_END = exports.NOT_ITERATOR_ERROR = undefined;
	exports.default = proc;
	
	var _utils = __webpack_require__(82);
	
	var _asap = __webpack_require__(1695);
	
	var _asap2 = _interopRequireDefault(_asap);
	
	var _io = __webpack_require__(232);
	
	var _channel = __webpack_require__(231);
	
	var _buffers = __webpack_require__(350);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var isDev = ("production") === 'development';
	
	var NOT_ITERATOR_ERROR = exports.NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';
	
	var nextEffectId = (0, _utils.autoInc)();
	var CHANNEL_END = exports.CHANNEL_END = {
	  toString: function toString() {
	    return '@@redux-saga/CHANNEL_END';
	  }
	};
	var TASK_CANCEL = exports.TASK_CANCEL = {
	  toString: function toString() {
	    return '@@redux-saga/TASK_CANCEL';
	  }
	};
	
	var matchers = {
	  wildcard: function wildcard() {
	    return _utils.kTrue;
	  },
	  default: function _default(pattern) {
	    return function (input) {
	      return input.type === pattern;
	    };
	  },
	  array: function array(patterns) {
	    return function (input) {
	      return patterns.some(function (p) {
	        return p === input.type;
	      });
	    };
	  },
	  predicate: function predicate(_predicate) {
	    return function (input) {
	      return _predicate(input);
	    };
	  }
	};
	
	function matcher(pattern) {
	  return (pattern === '*' ? matchers.wildcard : _utils.is.array(pattern) ? matchers.array : _utils.is.func(pattern) ? matchers.predicate : matchers.default)(pattern);
	}
	
	/**
	  Used to track a parent task and its forks
	  In the new fork model, forked tasks are attached by default to their parent
	  We model this using the concept of Parent task && main Task
	  main task is the main flow of the current Generator, the parent tasks is the
	  aggregation of the main tasks + all its forked tasks.
	  Thus the whole model represents an execution tree with multiple branches (vs the
	  linear execution tree in sequential (non parallel) programming)
	
	  A parent tasks has the following semantics
	  - It completes iff all its forks either complete or all cancelled
	  - If it's cancelled, all forks are cancelled as well
	  - It aborts if any uncaught error bubbles up from forks
	  - If it completes, the return value is the one returned by the main task
	**/
	function forkQueue(name, mainTask, cb) {
	  var tasks = [],
	      result = void 0,
	      completed = false;
	  addTask(mainTask);
	
	  function addTask(task) {
	    tasks.push(task);
	    task.cont = function (res, isErr) {
	      if (completed) {
	        return;
	      }
	
	      (0, _utils.remove)(tasks, task);
	      task.cont = _utils.noop;
	      if (isErr) {
	        cancelAll();
	        cb(res, true);
	      } else {
	        if (task === mainTask) {
	          result = res;
	        }
	        if (!tasks.length) {
	          completed = true;
	          cb(result);
	        }
	      }
	    };
	    // task.cont.cancel = task.cancel
	  }
	
	  function cancelAll() {
	    if (completed) {
	      return;
	    }
	    completed = true;
	    tasks.forEach(function (t) {
	      t.cont = _utils.noop;
	      t.cancel();
	    });
	    tasks = [];
	  }
	
	  return {
	    addTask: addTask,
	    cancelAll: cancelAll,
	    getTasks: function getTasks() {
	      return tasks;
	    },
	    taskNames: function taskNames() {
	      return tasks.map(function (t) {
	        return t.name;
	      });
	    }
	  };
	}
	
	function proc(iterator) {
	  var subscribe = arguments.length <= 1 || arguments[1] === undefined ? function () {
	    return _utils.noop;
	  } : arguments[1];
	  var dispatch = arguments.length <= 2 || arguments[2] === undefined ? _utils.noop : arguments[2];
	  var getState = arguments.length <= 3 || arguments[3] === undefined ? _utils.noop : arguments[3];
	  var monitor = arguments[4];
	  var parentEffectId = arguments.length <= 5 || arguments[5] === undefined ? 0 : arguments[5];
	  var name = arguments.length <= 6 || arguments[6] === undefined ? 'anonymous' : arguments[6];
	  var cont = arguments[7];
	
	  (0, _utils.check)(iterator, _utils.is.iterator, NOT_ITERATOR_ERROR);
	
	  var stdChannel = (0, _channel.eventChannel)(subscribe);
	  /**
	    Tracks the current effect cancellation
	    Each time the generator progresses. calling runEffect will set a new value
	    on it. It allows propagating cancellation to child effects
	  **/
	  next.cancel = _utils.noop;
	
	  /**
	    Creates a new task descriptor for this generator, We'll also create a main task
	    to track the main flow (besides other forked tasks)
	  **/
	  var task = newTask(parentEffectId, name, iterator, cont);
	  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
	  var taskQueue = forkQueue(name, mainTask, end);
	
	  /**
	    cancellation of the main task. We'll simply resume the Generator with a Cancel
	  **/
	  function cancelMain() {
	    if (mainTask.isRunning && !mainTask.isCancelled) {
	      mainTask.isCancelled = true;
	      next(TASK_CANCEL);
	    }
	  }
	
	  /**
	    This may be called by a parent generator to trigger/propagate cancellation
	    cancel all pending tasks (including the main task), then end the current task.
	      Cancellation propagates down to the whole execution tree holded by this Parent task
	    It's also propagated to all joiners of this task and their execution tree/joiners
	      Cancellation is noop for terminated/Cancelled tasks tasks
	  **/
	  function cancel() {
	    /**
	      We need to check both Running and Cancelled status
	      Tasks can be Cancelled but still Running
	    **/
	    if (iterator._isRunning && !iterator._isCancelled) {
	      iterator._isCancelled = true;
	      taskQueue.cancelAll();
	      /**
	        Ending with a Never result will propagate the Cancellation to all joiners
	      **/
	      end(TASK_CANCEL);
	    }
	  }
	  /**
	    attaches cancellation logic to this task's continuation
	    this will permit cancellation to propagate down the call chain
	  **/
	  cont && (cont.cancel = cancel);
	
	  // tracks the running status
	  iterator._isRunning = true;
	
	  // kicks up the generator
	  next();
	
	  // then return the task descriptor to the caller
	  return task;
	
	  /**
	    This is the generator driver
	    It's a recursive async/continuation function which calls itself
	    until the generator terminates or throws
	  **/
	  function next(arg, isErr) {
	    // Preventive measure. If we end up here, then there is really something wrong
	    if (!mainTask.isRunning) {
	      throw new Error('Trying to resume an already finished generator');
	    }
	
	    try {
	      var result = void 0;
	      if (isErr) {
	        result = iterator.throw(arg);
	      } else if (arg === TASK_CANCEL) {
	        /**
	          getting TASK_CANCEL autoamtically cancels the main task
	          We can get this value here
	            - By cancelling the parent task manually
	          - By joining a Cancelled task
	        **/
	        mainTask.isCancelled = true;
	        /**
	          Cancels the current effect; this will propagate the cancellation down to any called tasks
	        **/
	        next.cancel();
	        /**
	          If this Generator has a `return` method then invokes it
	          Thill will jump to the finally block
	        **/
	        result = _utils.is.func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
	      } else if (arg === CHANNEL_END) {
	        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
	        result = _utils.is.func(iterator.return) ? iterator.return() : { done: true };
	      } else {
	        result = iterator.next(arg);
	      }
	
	      if (!result.done) {
	        runEffect(result.value, parentEffectId, '', next);
	      } else {
	        /**
	          This Generator has ended, terminate the main task and notify the fork queue
	        **/
	        mainTask.isMainRunning = false;
	        mainTask.cont && mainTask.cont(result.value);
	      }
	    } catch (error) {
	      if (mainTask.isCancelled) {
	        (0, _utils.log)('error', 'uncaught at ' + name, error.message);
	      }
	      mainTask.isMainRunning = false;
	      mainTask.cont(error, true);
	    }
	  }
	
	  function end(result, isErr) {
	    iterator._isRunning = false;
	    stdChannel.close();
	    if (!isErr) {
	      if (result === TASK_CANCEL && isDev) {
	        (0, _utils.log)('info', name + ' has been cancelled', '');
	      }
	      iterator._result = result;
	      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
	    } else {
	      if (result instanceof Error) {
	        result.sagaStack = 'at ' + name + ' \n ' + (result.sagaStack || result.stack);
	      }
	      if (!task.cont) {
	        (0, _utils.log)('error', 'uncaught', result.sagaStack || result.stack);
	      }
	      iterator._error = result;
	      iterator._isAborted = true;
	      iterator._deferredEnd && iterator._deferredEnd.reject(result);
	    }
	    task.cont && task.cont(result, isErr);
	    task.joiners.forEach(function (j) {
	      return j.cb(result, isErr);
	    });
	    task.joiners = null;
	  }
	
	  function runEffect(effect, parentEffectId) {
	    var label = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
	    var cb = arguments[3];
	
	    var effectId = nextEffectId();
	    monitor && monitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });
	
	    /**
	      completion callback and cancel callback are mutually exclusive
	      We can't cancel an already completed effect
	      And We can't complete an already cancelled effectId
	    **/
	    var effectSettled = void 0;
	
	    // Completion callback passed to the appropriate effect runner
	    function currCb(res, isErr) {
	      if (effectSettled) {
	        return;
	      }
	
	      effectSettled = true;
	      cb.cancel = _utils.noop; // defensive measure
	      if (monitor) {
	        isErr ? monitor.effectRejected(effectId, res) : monitor.effectResolved(effectId, res);
	      }
	
	      cb(res, isErr);
	    }
	    // tracks down the current cancel
	    currCb.cancel = _utils.noop;
	
	    // setup cancellation logic on the parent cb
	    cb.cancel = function () {
	      // prevents cancelling an already completed effect
	      if (effectSettled) {
	        return;
	      }
	
	      effectSettled = true;
	      /**
	        propagates cancel downward
	        catch uncaught cancellations errors; since we can no longer call the completion
	        callback, log errors raised during cancellations into the console
	      **/
	      try {
	        currCb.cancel();
	      } catch (err) {
	        (0, _utils.log)('error', 'uncaught at ' + name, err.message);
	      }
	      currCb.cancel = _utils.noop; // defensive measure
	
	      monitor && monitor.effectCancelled(effectId);
	    };
	
	    /**
	      each effect runner must attach its own logic of cancellation to the provided callback
	      it allows this generator to propagate cancellation downward.
	        ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
	      And the setup must occur before calling the callback
	        This is a sort of inversion of control: called async functions are responsible
	      of completing the flow by calling the provided continuation; while caller functions
	      are responsible for aborting the current flow by calling the attached cancel function
	        Library users can attach their own cancellation logic to promises by defining a
	      promise[CANCEL] method in their returned promises
	      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
	    **/
	    var data = void 0;
	    return(
	      // Non declarative effect
	      _utils.is.promise(effect) ? resolvePromise(effect, currCb) : _utils.is.iterator(effect) ? resolveIterator(effect, effectId, name, currCb)
	
	      // declarative effects
	      : _utils.is.array(effect) ? runParallelEffect(effect, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.take(effect)) ? runTakeEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.put(effect)) ? runPutEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.race(effect)) ? runRaceEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.call(effect)) ? runCallEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.cps(effect)) ? runCPSEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.fork(effect)) ? runForkEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.join(effect)) ? runJoinEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.cancel(effect)) ? runCancelEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.select(effect)) ? runSelectEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.actionChannel(effect)) ? runChannelEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.cancelled(effect)) ? runCancelledEffect(data, currCb) : /* anything else returned as is        */currCb(effect)
	    );
	  }
	
	  function resolvePromise(promise, cb) {
	    var cancelPromise = promise[_utils.CANCEL];
	    if (typeof cancelPromise === 'function') {
	      cb.cancel = cancelPromise;
	    }
	    promise.then(cb, function (error) {
	      return cb(error, true);
	    });
	  }
	
	  function resolveIterator(iterator, effectId, name, cb) {
	    proc(iterator, subscribe, dispatch, getState, monitor, effectId, name, cb);
	  }
	
	  function runTakeEffect(_ref, cb) {
	    var channel = _ref.channel;
	    var pattern = _ref.pattern;
	    var maybe = _ref.maybe;
	
	    channel = channel || stdChannel;
	    var takeCb = function takeCb(inp) {
	      return inp instanceof Error ? cb(inp, true) : (0, _channel.isEnd)(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
	    };
	    try {
	      channel.take(takeCb, matcher(pattern));
	    } catch (err) {
	      return cb(err, true);
	    }
	    cb.cancel = takeCb.cancel;
	  }
	
	  function runPutEffect(_ref2, cb) {
	    var channel = _ref2.channel;
	    var action = _ref2.action;
	    var sync = _ref2.sync;
	
	    /*
	      Use a reentrant lock `asap` to flatten all nested dispatches
	      If this put cause another Saga to take this action an then immediately
	      put an action that will be taken by this Saga. Then the outer Saga will miss
	      the action from the inner Saga b/c this put has not yet returned.
	    */
	    (0, _asap2.default)(function () {
	      var result = void 0;
	      try {
	        result = (channel ? channel.put : dispatch)(action);
	      } catch (error) {
	        return cb(error, true);
	      }
	
	      if (sync && _utils.is.promise(result)) {
	        resolvePromise(result, cb);
	      } else {
	        return cb(result);
	      }
	    });
	    // Put effects are non cancellables
	  }
	
	  function runCallEffect(_ref3, effectId, cb) {
	    var context = _ref3.context;
	    var fn = _ref3.fn;
	    var args = _ref3.args;
	
	    var result = void 0;
	    // catch synchronous failures; see #152
	    try {
	      result = fn.apply(context, args);
	    } catch (error) {
	      return cb(error, true);
	    }
	    return _utils.is.promise(result) ? resolvePromise(result, cb) : _utils.is.iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
	  }
	
	  function runCPSEffect(_ref4, cb) {
	    var context = _ref4.context;
	    var fn = _ref4.fn;
	    var args = _ref4.args;
	
	    // CPS (ie node style functions) can define their own cancellation logic
	    // by setting cancel field on the cb
	
	    // catch synchronous failures; see #152
	    try {
	      fn.apply(context, args.concat(function (err, res) {
	        return _utils.is.undef(err) ? cb(res) : cb(err, true);
	      }));
	    } catch (error) {
	      return cb(error, true);
	    }
	  }
	
	  function runForkEffect(_ref5, effectId, cb) {
	    var context = _ref5.context;
	    var fn = _ref5.fn;
	    var args = _ref5.args;
	    var detached = _ref5.detached;
	
	    var result = void 0,
	        error = void 0,
	        _iterator = void 0;
	
	    // we run the function, next we'll check if this is a generator function
	    // (generator is a function that returns an iterator)
	
	    // catch synchronous failures; see #152
	    try {
	      result = fn.apply(context, args);
	    } catch (err) {
	      if (!detached) {
	        return cb(err);
	      } else {
	        error = err;
	      }
	    }
	
	    // A generator function: i.e. returns an iterator
	    if (_utils.is.iterator(result)) {
	      _iterator = result;
	    }
	
	    // simple effect: wrap in a generator
	    // do not bubble up synchronous failures for detached forks, instead create a failed task. See #152
	    else {
	        _iterator = error ? (0, _utils.makeIterator)(function () {
	          throw error;
	        }) : (0, _utils.makeIterator)(function () {
	          var pc = void 0;
	          var eff = { done: false, value: result };
	          var ret = function ret(value) {
	            return { done: true, value: value };
	          };
	          return function (arg) {
	            if (!pc) {
	              pc = true;
	              return eff;
	            } else {
	              return ret(arg);
	            }
	          };
	        }());
	      }
	
	    _asap2.default.suspend();
	    var task = proc(_iterator, subscribe, dispatch, getState, monitor, effectId, fn.name, detached ? null : _utils.noop);
	    if (!detached) {
	      if (_iterator._isRunning) {
	        taskQueue.addTask(task);
	      } else if (_iterator._error) {
	        return cb(_iterator._error, true);
	      }
	    }
	    cb(task);
	    _asap2.default.flush();
	    // Fork effects are non cancellables
	  }
	
	  function runJoinEffect(t, cb) {
	    if (t.isRunning()) {
	      (function () {
	        var joiner = { task: task, cb: cb };
	        cb.cancel = function () {
	          return (0, _utils.remove)(t.joiners, joiner);
	        };
	        t.joiners.push(joiner);
	      })();
	    } else {
	      t.isAborted() ? cb(t.error(), true) : cb(t.result());
	    }
	  }
	
	  function runCancelEffect(task, cb) {
	    if (task.isRunning()) {
	      task.cancel();
	    }
	    cb();
	    // cancel effects are non cancellables
	  }
	
	  function runParallelEffect(effects, effectId, cb) {
	    if (!effects.length) {
	      return cb([]);
	    }
	
	    var completedCount = 0;
	    var completed = void 0;
	    var results = Array(effects.length);
	
	    function checkEffectEnd() {
	      if (completedCount === results.length) {
	        completed = true;
	        cb(results);
	      }
	    }
	
	    var childCbs = effects.map(function (eff, idx) {
	      var chCbAtIdx = function chCbAtIdx(res, isErr) {
	        if (completed) {
	          return;
	        }
	        if (isErr || (0, _channel.isEnd)(res) || res === CHANNEL_END || res === TASK_CANCEL) {
	          cb.cancel();
	          cb(res, isErr);
	        } else {
	          results[idx] = res;
	          completedCount++;
	          checkEffectEnd();
	        }
	      };
	      chCbAtIdx.cancel = _utils.noop;
	      return chCbAtIdx;
	    });
	
	    cb.cancel = function () {
	      if (!completed) {
	        completed = true;
	        childCbs.forEach(function (chCb) {
	          return chCb.cancel();
	        });
	      }
	    };
	
	    effects.forEach(function (eff, idx) {
	      return runEffect(eff, effectId, idx, childCbs[idx]);
	    });
	  }
	
	  function runRaceEffect(effects, effectId, cb) {
	    var completed = void 0;
	    var keys = Object.keys(effects);
	    var childCbs = {};
	
	    keys.forEach(function (key) {
	      var chCbAtKey = function chCbAtKey(res, isErr) {
	        if (completed) {
	          return;
	        }
	
	        if (isErr) {
	          // Race Auto cancellation
	          cb.cancel();
	          cb(res, true);
	        } else if (!(0, _channel.isEnd)(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
	          cb.cancel();
	          completed = true;
	          cb(_defineProperty({}, key, res));
	        }
	      };
	      chCbAtKey.cancel = _utils.noop;
	      childCbs[key] = chCbAtKey;
	    });
	
	    cb.cancel = function () {
	      // prevents unnecessary cancellation
	      if (!completed) {
	        completed = true;
	        keys.forEach(function (key) {
	          return childCbs[key].cancel();
	        });
	      }
	    };
	    keys.forEach(function (key) {
	      return runEffect(effects[key], effectId, key, childCbs[key]);
	    });
	  }
	
	  function runSelectEffect(_ref6, cb) {
	    var selector = _ref6.selector;
	    var args = _ref6.args;
	
	    try {
	      var state = selector.apply(undefined, [getState()].concat(_toConsumableArray(args)));
	      cb(state);
	    } catch (error) {
	      cb(error, true);
	    }
	  }
	
	  function runChannelEffect(_ref7, cb) {
	    var pattern = _ref7.pattern;
	    var buffer = _ref7.buffer;
	
	    var match = matcher(pattern);
	    match.pattern = pattern;
	    cb((0, _channel.eventChannel)(subscribe, buffer || _buffers.buffers.fixed(), match));
	  }
	
	  function runCancelledEffect(data, cb) {
	    cb(!!mainTask.isCancelled);
	  }
	
	  function newTask(id, name, iterator, cont) {
	    var _done, _ref8, _mutatorMap;
	
	    iterator._deferredEnd = null;
	    return _ref8 = {}, _defineProperty(_ref8, _utils.TASK, true), _defineProperty(_ref8, 'id', id), _defineProperty(_ref8, 'name', name), _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
	      if (iterator._deferredEnd) {
	        return iterator._deferredEnd.promise;
	      } else {
	        var def = (0, _utils.deferred)();
	        iterator._deferredEnd = def;
	        if (!iterator._isRunning) {
	          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
	        }
	        return def.promise;
	      }
	    }, _defineProperty(_ref8, 'cont', cont), _defineProperty(_ref8, 'joiners', []), _defineProperty(_ref8, 'cancel', cancel), _defineProperty(_ref8, 'isRunning', function isRunning() {
	      return iterator._isRunning;
	    }), _defineProperty(_ref8, 'isCancelled', function isCancelled() {
	      return iterator._isCancelled;
	    }), _defineProperty(_ref8, 'isAborted', function isAborted() {
	      return iterator._isAborted;
	    }), _defineProperty(_ref8, 'result', function result() {
	      return iterator._result;
	    }), _defineProperty(_ref8, 'error', function error() {
	      return iterator._error;
	    }), _defineEnumerableProperties(_ref8, _mutatorMap), _ref8;
	  }
	}

/***/ },
/* 544 */
/***/ function(module, exports) {

	'use strict';
	
	exports.SELECT_HISTORY = 'SELECT_HISTORY';
	exports.UPLOAD_HISTORY = 'UPLOAD_HISTORY';
	function selectHistory(number) {
	    return {
	        type: exports.SELECT_HISTORY,
	        payload: number,
	        meta: 'SKIP_HISTORY_TRACKING'
	    };
	}
	exports.selectHistory = selectHistory;
	;
	function uploadHistory(history) {
	    return {
	        type: exports.UPLOAD_HISTORY,
	        payload: history,
	        meta: 'SKIP_HISTORY_TRACKING'
	    };
	}
	exports.uploadHistory = uploadHistory;
	;

/***/ },
/* 545 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 546 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 547 */
/***/ function(module, exports) {

	'use strict';
	
	var $Object = Object;
	var $TypeError = TypeError;
	
	module.exports = function flags() {
		if (this != null && this !== $Object(this)) {
			throw new $TypeError('RegExp.prototype.flags getter called on non-object');
		}
		var result = '';
		if (this.global) {
			result += 'g';
		}
		if (this.ignoreCase) {
			result += 'i';
		}
		if (this.multiline) {
			result += 'm';
		}
		if (this.dotAll) {
			result += 's';
		}
		if (this.unicode) {
			result += 'u';
		}
		if (this.sticky) {
			result += 'y';
		}
		return result;
	};


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(547);
	
	var supportsDescriptors = __webpack_require__(152).supportsDescriptors;
	var $gOPD = Object.getOwnPropertyDescriptor;
	var $TypeError = TypeError;
	
	module.exports = function getPolyfill() {
		if (!supportsDescriptors) {
			throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		if ((/a/mig).flags === 'gim') {
			var descriptor = $gOPD(RegExp.prototype, 'flags');
			if (descriptor && typeof descriptor.get === 'function' && typeof (/a/).dotAll === 'boolean') {
				return descriptor.get;
			}
		}
		return implementation;
	};


/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var util = __webpack_require__(178);
	var has = Object.prototype.hasOwnProperty;
	var hasNativeMap = typeof Map !== "undefined";
	
	/**
	 * A data structure which is a combination of an array and a set. Adding a new
	 * member is O(1), testing for membership is O(1), and finding the index of an
	 * element is O(1). Removing elements from the set is not supported. Only
	 * strings are supported for membership.
	 */
	function ArraySet() {
	  this._array = [];
	  this._set = hasNativeMap ? new Map() : Object.create(null);
	}
	
	/**
	 * Static method for creating ArraySet instances from an existing array.
	 */
	ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
	  var set = new ArraySet();
	  for (var i = 0, len = aArray.length; i < len; i++) {
	    set.add(aArray[i], aAllowDuplicates);
	  }
	  return set;
	};
	
	/**
	 * Return how many unique items are in this ArraySet. If duplicates have been
	 * added, than those do not count towards the size.
	 *
	 * @returns Number
	 */
	ArraySet.prototype.size = function ArraySet_size() {
	  return hasNativeMap ? this._set.size : Object.getOwnPropertyNames(this._set).length;
	};
	
	/**
	 * Add the given string to this set.
	 *
	 * @param String aStr
	 */
	ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
	  var sStr = hasNativeMap ? aStr : util.toSetString(aStr);
	  var isDuplicate = hasNativeMap ? this.has(aStr) : has.call(this._set, sStr);
	  var idx = this._array.length;
	  if (!isDuplicate || aAllowDuplicates) {
	    this._array.push(aStr);
	  }
	  if (!isDuplicate) {
	    if (hasNativeMap) {
	      this._set.set(aStr, idx);
	    } else {
	      this._set[sStr] = idx;
	    }
	  }
	};
	
	/**
	 * Is the given string a member of this set?
	 *
	 * @param String aStr
	 */
	ArraySet.prototype.has = function ArraySet_has(aStr) {
	  if (hasNativeMap) {
	    return this._set.has(aStr);
	  } else {
	    var sStr = util.toSetString(aStr);
	    return has.call(this._set, sStr);
	  }
	};
	
	/**
	 * What is the index of the given string in the array?
	 *
	 * @param String aStr
	 */
	ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
	  if (hasNativeMap) {
	    var idx = this._set.get(aStr);
	    if (idx >= 0) {
	        return idx;
	    }
	  } else {
	    var sStr = util.toSetString(aStr);
	    if (has.call(this._set, sStr)) {
	      return this._set[sStr];
	    }
	  }
	
	  throw new Error('"' + aStr + '" is not in the set.');
	};
	
	/**
	 * What is the element at the given index?
	 *
	 * @param Number aIdx
	 */
	ArraySet.prototype.at = function ArraySet_at(aIdx) {
	  if (aIdx >= 0 && aIdx < this._array.length) {
	    return this._array[aIdx];
	  }
	  throw new Error('No element indexed by ' + aIdx);
	};
	
	/**
	 * Returns the array representation of this set (which has the proper indices
	 * indicated by indexOf). Note that this is a copy of the internal array used
	 * for storing the members so that no one can mess with internal state.
	 */
	ArraySet.prototype.toArray = function ArraySet_toArray() {
	  return this._array.slice();
	};
	
	exports.ArraySet = ArraySet;


/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 *
	 * Based on the Base 64 VLQ implementation in Closure Compiler:
	 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
	 *
	 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 *  * Redistributions of source code must retain the above copyright
	 *    notice, this list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above
	 *    copyright notice, this list of conditions and the following
	 *    disclaimer in the documentation and/or other materials provided
	 *    with the distribution.
	 *  * Neither the name of Google Inc. nor the names of its
	 *    contributors may be used to endorse or promote products derived
	 *    from this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
	 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
	 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
	 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
	 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	var base64 = __webpack_require__(1711);
	
	// A single base 64 digit can contain 6 bits of data. For the base 64 variable
	// length quantities we use in the source map spec, the first bit is the sign,
	// the next four bits are the actual value, and the 6th bit is the
	// continuation bit. The continuation bit tells us whether there are more
	// digits in this value following this digit.
	//
	//   Continuation
	//   |    Sign
	//   |    |
	//   V    V
	//   101011
	
	var VLQ_BASE_SHIFT = 5;
	
	// binary: 100000
	var VLQ_BASE = 1 << VLQ_BASE_SHIFT;
	
	// binary: 011111
	var VLQ_BASE_MASK = VLQ_BASE - 1;
	
	// binary: 100000
	var VLQ_CONTINUATION_BIT = VLQ_BASE;
	
	/**
	 * Converts from a two-complement value to a value where the sign bit is
	 * placed in the least significant bit.  For example, as decimals:
	 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
	 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
	 */
	function toVLQSigned(aValue) {
	  return aValue < 0
	    ? ((-aValue) << 1) + 1
	    : (aValue << 1) + 0;
	}
	
	/**
	 * Converts to a two-complement value from a value where the sign bit is
	 * placed in the least significant bit.  For example, as decimals:
	 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
	 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
	 */
	function fromVLQSigned(aValue) {
	  var isNegative = (aValue & 1) === 1;
	  var shifted = aValue >> 1;
	  return isNegative
	    ? -shifted
	    : shifted;
	}
	
	/**
	 * Returns the base 64 VLQ encoded value.
	 */
	exports.encode = function base64VLQ_encode(aValue) {
	  var encoded = "";
	  var digit;
	
	  var vlq = toVLQSigned(aValue);
	
	  do {
	    digit = vlq & VLQ_BASE_MASK;
	    vlq >>>= VLQ_BASE_SHIFT;
	    if (vlq > 0) {
	      // There are still more digits in this value, so we must make sure the
	      // continuation bit is marked.
	      digit |= VLQ_CONTINUATION_BIT;
	    }
	    encoded += base64.encode(digit);
	  } while (vlq > 0);
	
	  return encoded;
	};
	
	/**
	 * Decodes the next base 64 VLQ value from the given string and returns the
	 * value and the rest of the string via the out parameter.
	 */
	exports.decode = function base64VLQ_decode(aStr, aIndex, aOutParam) {
	  var strLen = aStr.length;
	  var result = 0;
	  var shift = 0;
	  var continuation, digit;
	
	  do {
	    if (aIndex >= strLen) {
	      throw new Error("Expected more digits in base 64 VLQ value.");
	    }
	
	    digit = base64.decode(aStr.charCodeAt(aIndex++));
	    if (digit === -1) {
	      throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
	    }
	
	    continuation = !!(digit & VLQ_CONTINUATION_BIT);
	    digit &= VLQ_BASE_MASK;
	    result = result + (digit << shift);
	    shift += VLQ_BASE_SHIFT;
	  } while (continuation);
	
	  aOutParam.value = fromVLQSigned(result);
	  aOutParam.rest = aIndex;
	};


/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var base64VLQ = __webpack_require__(550);
	var util = __webpack_require__(178);
	var ArraySet = __webpack_require__(549).ArraySet;
	var MappingList = __webpack_require__(1713).MappingList;
	
	/**
	 * An instance of the SourceMapGenerator represents a source map which is
	 * being built incrementally. You may pass an object with the following
	 * properties:
	 *
	 *   - file: The filename of the generated source.
	 *   - sourceRoot: A root for all relative URLs in this source map.
	 */
	function SourceMapGenerator(aArgs) {
	  if (!aArgs) {
	    aArgs = {};
	  }
	  this._file = util.getArg(aArgs, 'file', null);
	  this._sourceRoot = util.getArg(aArgs, 'sourceRoot', null);
	  this._skipValidation = util.getArg(aArgs, 'skipValidation', false);
	  this._sources = new ArraySet();
	  this._names = new ArraySet();
	  this._mappings = new MappingList();
	  this._sourcesContents = null;
	}
	
	SourceMapGenerator.prototype._version = 3;
	
	/**
	 * Creates a new SourceMapGenerator based on a SourceMapConsumer
	 *
	 * @param aSourceMapConsumer The SourceMap.
	 */
	SourceMapGenerator.fromSourceMap =
	  function SourceMapGenerator_fromSourceMap(aSourceMapConsumer) {
	    var sourceRoot = aSourceMapConsumer.sourceRoot;
	    var generator = new SourceMapGenerator({
	      file: aSourceMapConsumer.file,
	      sourceRoot: sourceRoot
	    });
	    aSourceMapConsumer.eachMapping(function (mapping) {
	      var newMapping = {
	        generated: {
	          line: mapping.generatedLine,
	          column: mapping.generatedColumn
	        }
	      };
	
	      if (mapping.source != null) {
	        newMapping.source = mapping.source;
	        if (sourceRoot != null) {
	          newMapping.source = util.relative(sourceRoot, newMapping.source);
	        }
	
	        newMapping.original = {
	          line: mapping.originalLine,
	          column: mapping.originalColumn
	        };
	
	        if (mapping.name != null) {
	          newMapping.name = mapping.name;
	        }
	      }
	
	      generator.addMapping(newMapping);
	    });
	    aSourceMapConsumer.sources.forEach(function (sourceFile) {
	      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
	      if (content != null) {
	        generator.setSourceContent(sourceFile, content);
	      }
	    });
	    return generator;
	  };
	
	/**
	 * Add a single mapping from original source line and column to the generated
	 * source's line and column for this source map being created. The mapping
	 * object should have the following properties:
	 *
	 *   - generated: An object with the generated line and column positions.
	 *   - original: An object with the original line and column positions.
	 *   - source: The original source file (relative to the sourceRoot).
	 *   - name: An optional original token name for this mapping.
	 */
	SourceMapGenerator.prototype.addMapping =
	  function SourceMapGenerator_addMapping(aArgs) {
	    var generated = util.getArg(aArgs, 'generated');
	    var original = util.getArg(aArgs, 'original', null);
	    var source = util.getArg(aArgs, 'source', null);
	    var name = util.getArg(aArgs, 'name', null);
	
	    if (!this._skipValidation) {
	      this._validateMapping(generated, original, source, name);
	    }
	
	    if (source != null) {
	      source = String(source);
	      if (!this._sources.has(source)) {
	        this._sources.add(source);
	      }
	    }
	
	    if (name != null) {
	      name = String(name);
	      if (!this._names.has(name)) {
	        this._names.add(name);
	      }
	    }
	
	    this._mappings.add({
	      generatedLine: generated.line,
	      generatedColumn: generated.column,
	      originalLine: original != null && original.line,
	      originalColumn: original != null && original.column,
	      source: source,
	      name: name
	    });
	  };
	
	/**
	 * Set the source content for a source file.
	 */
	SourceMapGenerator.prototype.setSourceContent =
	  function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
	    var source = aSourceFile;
	    if (this._sourceRoot != null) {
	      source = util.relative(this._sourceRoot, source);
	    }
	
	    if (aSourceContent != null) {
	      // Add the source content to the _sourcesContents map.
	      // Create a new _sourcesContents map if the property is null.
	      if (!this._sourcesContents) {
	        this._sourcesContents = Object.create(null);
	      }
	      this._sourcesContents[util.toSetString(source)] = aSourceContent;
	    } else if (this._sourcesContents) {
	      // Remove the source file from the _sourcesContents map.
	      // If the _sourcesContents map is empty, set the property to null.
	      delete this._sourcesContents[util.toSetString(source)];
	      if (Object.keys(this._sourcesContents).length === 0) {
	        this._sourcesContents = null;
	      }
	    }
	  };
	
	/**
	 * Applies the mappings of a sub-source-map for a specific source file to the
	 * source map being generated. Each mapping to the supplied source file is
	 * rewritten using the supplied source map. Note: The resolution for the
	 * resulting mappings is the minimium of this map and the supplied map.
	 *
	 * @param aSourceMapConsumer The source map to be applied.
	 * @param aSourceFile Optional. The filename of the source file.
	 *        If omitted, SourceMapConsumer's file property will be used.
	 * @param aSourceMapPath Optional. The dirname of the path to the source map
	 *        to be applied. If relative, it is relative to the SourceMapConsumer.
	 *        This parameter is needed when the two source maps aren't in the same
	 *        directory, and the source map to be applied contains relative source
	 *        paths. If so, those relative source paths need to be rewritten
	 *        relative to the SourceMapGenerator.
	 */
	SourceMapGenerator.prototype.applySourceMap =
	  function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
	    var sourceFile = aSourceFile;
	    // If aSourceFile is omitted, we will use the file property of the SourceMap
	    if (aSourceFile == null) {
	      if (aSourceMapConsumer.file == null) {
	        throw new Error(
	          'SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, ' +
	          'or the source map\'s "file" property. Both were omitted.'
	        );
	      }
	      sourceFile = aSourceMapConsumer.file;
	    }
	    var sourceRoot = this._sourceRoot;
	    // Make "sourceFile" relative if an absolute Url is passed.
	    if (sourceRoot != null) {
	      sourceFile = util.relative(sourceRoot, sourceFile);
	    }
	    // Applying the SourceMap can add and remove items from the sources and
	    // the names array.
	    var newSources = new ArraySet();
	    var newNames = new ArraySet();
	
	    // Find mappings for the "sourceFile"
	    this._mappings.unsortedForEach(function (mapping) {
	      if (mapping.source === sourceFile && mapping.originalLine != null) {
	        // Check if it can be mapped by the source map, then update the mapping.
	        var original = aSourceMapConsumer.originalPositionFor({
	          line: mapping.originalLine,
	          column: mapping.originalColumn
	        });
	        if (original.source != null) {
	          // Copy mapping
	          mapping.source = original.source;
	          if (aSourceMapPath != null) {
	            mapping.source = util.join(aSourceMapPath, mapping.source)
	          }
	          if (sourceRoot != null) {
	            mapping.source = util.relative(sourceRoot, mapping.source);
	          }
	          mapping.originalLine = original.line;
	          mapping.originalColumn = original.column;
	          if (original.name != null) {
	            mapping.name = original.name;
	          }
	        }
	      }
	
	      var source = mapping.source;
	      if (source != null && !newSources.has(source)) {
	        newSources.add(source);
	      }
	
	      var name = mapping.name;
	      if (name != null && !newNames.has(name)) {
	        newNames.add(name);
	      }
	
	    }, this);
	    this._sources = newSources;
	    this._names = newNames;
	
	    // Copy sourcesContents of applied map.
	    aSourceMapConsumer.sources.forEach(function (sourceFile) {
	      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
	      if (content != null) {
	        if (aSourceMapPath != null) {
	          sourceFile = util.join(aSourceMapPath, sourceFile);
	        }
	        if (sourceRoot != null) {
	          sourceFile = util.relative(sourceRoot, sourceFile);
	        }
	        this.setSourceContent(sourceFile, content);
	      }
	    }, this);
	  };
	
	/**
	 * A mapping can have one of the three levels of data:
	 *
	 *   1. Just the generated position.
	 *   2. The Generated position, original position, and original source.
	 *   3. Generated and original position, original source, as well as a name
	 *      token.
	 *
	 * To maintain consistency, we validate that any new mapping being added falls
	 * in to one of these categories.
	 */
	SourceMapGenerator.prototype._validateMapping =
	  function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource,
	                                              aName) {
	    // When aOriginal is truthy but has empty values for .line and .column,
	    // it is most likely a programmer error. In this case we throw a very
	    // specific error message to try to guide them the right way.
	    // For example: https://github.com/Polymer/polymer-bundler/pull/519
	    if (aOriginal && typeof aOriginal.line !== 'number' && typeof aOriginal.column !== 'number') {
	        throw new Error(
	            'original.line and original.column are not numbers -- you probably meant to omit ' +
	            'the original mapping entirely and only map the generated position. If so, pass ' +
	            'null for the original mapping instead of an object with empty or null values.'
	        );
	    }
	
	    if (aGenerated && 'line' in aGenerated && 'column' in aGenerated
	        && aGenerated.line > 0 && aGenerated.column >= 0
	        && !aOriginal && !aSource && !aName) {
	      // Case 1.
	      return;
	    }
	    else if (aGenerated && 'line' in aGenerated && 'column' in aGenerated
	             && aOriginal && 'line' in aOriginal && 'column' in aOriginal
	             && aGenerated.line > 0 && aGenerated.column >= 0
	             && aOriginal.line > 0 && aOriginal.column >= 0
	             && aSource) {
	      // Cases 2 and 3.
	      return;
	    }
	    else {
	      throw new Error('Invalid mapping: ' + JSON.stringify({
	        generated: aGenerated,
	        source: aSource,
	        original: aOriginal,
	        name: aName
	      }));
	    }
	  };
	
	/**
	 * Serialize the accumulated mappings in to the stream of base 64 VLQs
	 * specified by the source map format.
	 */
	SourceMapGenerator.prototype._serializeMappings =
	  function SourceMapGenerator_serializeMappings() {
	    var previousGeneratedColumn = 0;
	    var previousGeneratedLine = 1;
	    var previousOriginalColumn = 0;
	    var previousOriginalLine = 0;
	    var previousName = 0;
	    var previousSource = 0;
	    var result = '';
	    var next;
	    var mapping;
	    var nameIdx;
	    var sourceIdx;
	
	    var mappings = this._mappings.toArray();
	    for (var i = 0, len = mappings.length; i < len; i++) {
	      mapping = mappings[i];
	      next = ''
	
	      if (mapping.generatedLine !== previousGeneratedLine) {
	        previousGeneratedColumn = 0;
	        while (mapping.generatedLine !== previousGeneratedLine) {
	          next += ';';
	          previousGeneratedLine++;
	        }
	      }
	      else {
	        if (i > 0) {
	          if (!util.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) {
	            continue;
	          }
	          next += ',';
	        }
	      }
	
	      next += base64VLQ.encode(mapping.generatedColumn
	                                 - previousGeneratedColumn);
	      previousGeneratedColumn = mapping.generatedColumn;
	
	      if (mapping.source != null) {
	        sourceIdx = this._sources.indexOf(mapping.source);
	        next += base64VLQ.encode(sourceIdx - previousSource);
	        previousSource = sourceIdx;
	
	        // lines are stored 0-based in SourceMap spec version 3
	        next += base64VLQ.encode(mapping.originalLine - 1
	                                   - previousOriginalLine);
	        previousOriginalLine = mapping.originalLine - 1;
	
	        next += base64VLQ.encode(mapping.originalColumn
	                                   - previousOriginalColumn);
	        previousOriginalColumn = mapping.originalColumn;
	
	        if (mapping.name != null) {
	          nameIdx = this._names.indexOf(mapping.name);
	          next += base64VLQ.encode(nameIdx - previousName);
	          previousName = nameIdx;
	        }
	      }
	
	      result += next;
	    }
	
	    return result;
	  };
	
	SourceMapGenerator.prototype._generateSourcesContent =
	  function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
	    return aSources.map(function (source) {
	      if (!this._sourcesContents) {
	        return null;
	      }
	      if (aSourceRoot != null) {
	        source = util.relative(aSourceRoot, source);
	      }
	      var key = util.toSetString(source);
	      return Object.prototype.hasOwnProperty.call(this._sourcesContents, key)
	        ? this._sourcesContents[key]
	        : null;
	    }, this);
	  };
	
	/**
	 * Externalize the source map.
	 */
	SourceMapGenerator.prototype.toJSON =
	  function SourceMapGenerator_toJSON() {
	    var map = {
	      version: this._version,
	      sources: this._sources.toArray(),
	      names: this._names.toArray(),
	      mappings: this._serializeMappings()
	    };
	    if (this._file != null) {
	      map.file = this._file;
	    }
	    if (this._sourceRoot != null) {
	      map.sourceRoot = this._sourceRoot;
	    }
	    if (this._sourcesContents) {
	      map.sourcesContent = this._generateSourcesContent(map.sources, map.sourceRoot);
	    }
	
	    return map;
	  };
	
	/**
	 * Render the source map being generated to a string.
	 */
	SourceMapGenerator.prototype.toString =
	  function SourceMapGenerator_toString() {
	    return JSON.stringify(this.toJSON());
	  };
	
	exports.SourceMapGenerator = SourceMapGenerator;


/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2009-2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE.txt or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	exports.SourceMapGenerator = __webpack_require__(551).SourceMapGenerator;
	exports.SourceMapConsumer = __webpack_require__(1715).SourceMapConsumer;
	exports.SourceNode = __webpack_require__(1716).SourceNode;


/***/ },
/* 553 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	function assembleStyles () {
		var styles = {
			modifiers: {
				reset: [0, 0],
				bold: [1, 22], // 21 isn't widely supported and 22 does the same thing
				dim: [2, 22],
				italic: [3, 23],
				underline: [4, 24],
				inverse: [7, 27],
				hidden: [8, 28],
				strikethrough: [9, 29]
			},
			colors: {
				black: [30, 39],
				red: [31, 39],
				green: [32, 39],
				yellow: [33, 39],
				blue: [34, 39],
				magenta: [35, 39],
				cyan: [36, 39],
				white: [37, 39],
				gray: [90, 39]
			},
			bgColors: {
				bgBlack: [40, 49],
				bgRed: [41, 49],
				bgGreen: [42, 49],
				bgYellow: [43, 49],
				bgBlue: [44, 49],
				bgMagenta: [45, 49],
				bgCyan: [46, 49],
				bgWhite: [47, 49]
			}
		};
	
		// fix humans
		styles.colors.grey = styles.colors.gray;
	
		Object.keys(styles).forEach(function (groupName) {
			var group = styles[groupName];
	
			Object.keys(group).forEach(function (styleName) {
				var style = group[styleName];
	
				styles[styleName] = group[styleName] = {
					open: '\u001b[' + style[0] + 'm',
					close: '\u001b[' + style[1] + 'm'
				};
			});
	
			Object.defineProperty(styles, groupName, {
				value: group,
				enumerable: false
			});
		});
	
		return styles;
	}
	
	Object.defineProperty(module, 'exports', {
		enumerable: true,
		get: assembleStyles
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(138)(module)))

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	// rawAsap provides everything we need except exception management.
	var rawAsap = __webpack_require__(556);
	// RawTasks are recycled to reduce GC churn.
	var freeTasks = [];
	// We queue errors to ensure they are thrown in right order (FIFO).
	// Array-as-queue is good enough here, since we are just dealing with exceptions.
	var pendingErrors = [];
	var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);
	
	function throwFirstError() {
	    if (pendingErrors.length) {
	        throw pendingErrors.shift();
	    }
	}
	
	/**
	 * Calls a task as soon as possible after returning, in its own event, with priority
	 * over other events like animation, reflow, and repaint. An error thrown from an
	 * event will not interrupt, nor even substantially slow down the processing of
	 * other events, but will be rather postponed to a lower priority event.
	 * @param {{call}} task A callable object, typically a function that takes no
	 * arguments.
	 */
	module.exports = asap;
	function asap(task) {
	    var rawTask;
	    if (freeTasks.length) {
	        rawTask = freeTasks.pop();
	    } else {
	        rawTask = new RawTask();
	    }
	    rawTask.task = task;
	    rawAsap(rawTask);
	}
	
	// We wrap tasks with recyclable task objects.  A task object implements
	// `call`, just like a function.
	function RawTask() {
	    this.task = null;
	}
	
	// The sole purpose of wrapping the task is to catch the exception and recycle
	// the task object after its single use.
	RawTask.prototype.call = function () {
	    try {
	        this.task.call();
	    } catch (error) {
	        if (asap.onerror) {
	            // This hook exists purely for testing purposes.
	            // Its name will be periodically randomized to break any code that
	            // depends on its existence.
	            asap.onerror(error);
	        } else {
	            // In a web browser, exceptions are not fatal. However, to avoid
	            // slowing down the queue of pending tasks, we rethrow the error in a
	            // lower priority turn.
	            pendingErrors.push(error);
	            requestErrorThrow();
	        }
	    } finally {
	        this.task = null;
	        freeTasks[freeTasks.length] = this;
	    }
	};


/***/ },
/* 556 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var add, backdropFilter, bckgrndImgOpts, boxdecorbreak, crispedges, cursorsGrab, cursorsNewer, decoration, devdaptation, elementFunction, feature, filterFunction, flexbox, fullscreen, gradients, grid, logicalProps, prefix, readOnly, resolution, result, sort, textAlignLast, textSizeAdjust, textSpacing, transforms3d, userSelectNone, writingMode,
	    slice = [].slice;
	
	  sort = function(array) {
	    return array.sort(function(a, b) {
	      var d;
	      a = a.split(' ');
	      b = b.split(' ');
	      if (a[0] > b[0]) {
	        return 1;
	      } else if (a[0] < b[0]) {
	        return -1;
	      } else {
	        d = parseFloat(a[1]) - parseFloat(b[1]);
	        if (d > 0) {
	          return 1;
	        } else if (d < 0) {
	          return -1;
	        } else {
	          return 0;
	        }
	      }
	    });
	  };
	
	  feature = function(data, opts, callback) {
	    var browser, match, need, ref, ref1, support, version, versions;
	    if (!callback) {
	      ref = [opts, {}], callback = ref[0], opts = ref[1];
	    }
	    match = opts.match || /\sx($|\s)/;
	    need = [];
	    ref1 = data.stats;
	    for (browser in ref1) {
	      versions = ref1[browser];
	      for (version in versions) {
	        support = versions[version];
	        if (support.match(match)) {
	          need.push(browser + ' ' + version);
	        }
	      }
	    }
	    return callback(sort(need));
	  };
	
	  result = {};
	
	  prefix = function() {
	    var data, i, j, k, len, name, names, results;
	    names = 2 <= arguments.length ? slice.call(arguments, 0, j = arguments.length - 1) : (j = 0, []), data = arguments[j++];
	    results = [];
	    for (k = 0, len = names.length; k < len; k++) {
	      name = names[k];
	      result[name] = {};
	      results.push((function() {
	        var results1;
	        results1 = [];
	        for (i in data) {
	          results1.push(result[name][i] = data[i]);
	        }
	        return results1;
	      })());
	    }
	    return results;
	  };
	
	  add = function() {
	    var data, j, k, len, name, names, results;
	    names = 2 <= arguments.length ? slice.call(arguments, 0, j = arguments.length - 1) : (j = 0, []), data = arguments[j++];
	    results = [];
	    for (k = 0, len = names.length; k < len; k++) {
	      name = names[k];
	      results.push(result[name].browsers = sort(result[name].browsers.concat(data.browsers)));
	    }
	    return results;
	  };
	
	  module.exports = result;
	
	  feature(__webpack_require__(1099), function(browsers) {
	    return prefix('border-radius', 'border-top-left-radius', 'border-top-right-radius', 'border-bottom-right-radius', 'border-bottom-left-radius', {
	      mistakes: ['-khtml-', '-ms-', '-o-'],
	      browsers: browsers,
	      feature: 'border-radius'
	    });
	  });
	
	  feature(__webpack_require__(1106), function(browsers) {
	    return prefix('box-shadow', {
	      mistakes: ['-khtml-'],
	      browsers: browsers,
	      feature: 'css-boxshadow'
	    });
	  });
	
	  feature(__webpack_require__(1101), function(browsers) {
	    return prefix('animation', 'animation-name', 'animation-duration', 'animation-delay', 'animation-direction', 'animation-fill-mode', 'animation-iteration-count', 'animation-play-state', 'animation-timing-function', '@keyframes', {
	      mistakes: ['-khtml-', '-ms-'],
	      browsers: browsers,
	      feature: 'css-animation'
	    });
	  });
	
	  feature(__webpack_require__(1131), function(browsers) {
	    return prefix('transition', 'transition-property', 'transition-duration', 'transition-delay', 'transition-timing-function', {
	      mistakes: ['-khtml-', '-ms-'],
	      browsers: browsers,
	      feature: 'css-transitions'
	    });
	  });
	
	  feature(__webpack_require__(1149), function(browsers) {
	    return prefix('transform', 'transform-origin', {
	      browsers: browsers,
	      feature: 'transforms2d'
	    });
	  });
	
	  transforms3d = __webpack_require__(1150);
	
	  feature(transforms3d, function(browsers) {
	    prefix('perspective', 'perspective-origin', {
	      browsers: browsers,
	      feature: 'transforms3d'
	    });
	    return prefix('transform-style', {
	      mistakes: ['-ms-', '-o-'],
	      browsers: browsers,
	      feature: 'transforms3d'
	    });
	  });
	
	  feature(transforms3d, {
	    match: /y\sx|y\s#2/
	  }, function(browsers) {
	    return prefix('backface-visibility', {
	      mistakes: ['-ms-', '-o-'],
	      browsers: browsers,
	      feature: 'transforms3d'
	    });
	  });
	
	  gradients = __webpack_require__(1115);
	
	  feature(gradients, {
	    match: /y\sx/
	  }, function(browsers) {
	    return prefix('linear-gradient', 'repeating-linear-gradient', 'radial-gradient', 'repeating-radial-gradient', {
	      props: ['background', 'background-image', 'border-image', 'mask', 'list-style', 'list-style-image', 'content', 'mask-image'],
	      mistakes: ['-ms-'],
	      browsers: browsers,
	      feature: 'css-gradients'
	    });
	  });
	
	  feature(gradients, {
	    match: /a\sx/
	  }, function(browsers) {
	    browsers = browsers.map(function(i) {
	      if (/op/.test(i)) {
	        return i;
	      } else {
	        return i + " old";
	      }
	    });
	    return add('linear-gradient', 'repeating-linear-gradient', 'radial-gradient', 'repeating-radial-gradient', {
	      browsers: browsers,
	      feature: 'css-gradients'
	    });
	  });
	
	  feature(__webpack_require__(1133), function(browsers) {
	    return prefix('box-sizing', {
	      browsers: browsers,
	      feature: 'css3-boxsizing'
	    });
	  });
	
	  feature(__webpack_require__(1114), function(browsers) {
	    return prefix('filter', {
	      browsers: browsers,
	      feature: 'css-filters'
	    });
	  });
	
	  filterFunction = __webpack_require__(1113);
	
	  feature(filterFunction, function(browsers) {
	    return prefix('filter-function', {
	      props: ['background', 'background-image', 'border-image', 'mask', 'list-style', 'list-style-image', 'content', 'mask-image'],
	      browsers: browsers,
	      feature: 'css-filter-function'
	    });
	  });
	
	  backdropFilter = __webpack_require__(1104);
	
	  feature(backdropFilter, function(browsers) {
	    return prefix('backdrop-filter', {
	      browsers: browsers,
	      feature: 'css-backdrop-filter'
	    });
	  });
	
	  elementFunction = __webpack_require__(1111);
	
	  feature(elementFunction, function(browsers) {
	    return prefix('element', {
	      props: ['background', 'background-image', 'border-image', 'mask', 'list-style', 'list-style-image', 'content', 'mask-image'],
	      browsers: browsers,
	      feature: 'css-element-function'
	    });
	  });
	
	  feature(__webpack_require__(1142), function(browsers) {
	    prefix('columns', 'column-width', 'column-gap', 'column-rule', 'column-rule-color', 'column-rule-width', {
	      browsers: browsers,
	      feature: 'multicolumn'
	    });
	    return prefix('column-count', 'column-rule-style', 'column-span', 'column-fill', 'break-before', 'break-after', 'break-inside', {
	      browsers: browsers,
	      feature: 'multicolumn'
	    });
	  });
	
	  userSelectNone = __webpack_require__(1151);
	
	  feature(userSelectNone, function(browsers) {
	    return prefix('user-select', {
	      mistakes: ['-khtml-'],
	      browsers: browsers,
	      feature: 'user-select-none'
	    });
	  });
	
	  flexbox = __webpack_require__(1137);
	
	  feature(flexbox, {
	    match: /a\sx/
	  }, function(browsers) {
	    browsers = browsers.map(function(i) {
	      if (/ie|firefox/.test(i)) {
	        return i;
	      } else {
	        return i + " 2009";
	      }
	    });
	    prefix('display-flex', 'inline-flex', {
	      props: ['display'],
	      browsers: browsers,
	      feature: 'flexbox'
	    });
	    prefix('flex', 'flex-grow', 'flex-shrink', 'flex-basis', {
	      browsers: browsers,
	      feature: 'flexbox'
	    });
	    return prefix('flex-direction', 'flex-wrap', 'flex-flow', 'justify-content', 'order', 'align-items', 'align-self', 'align-content', {
	      browsers: browsers,
	      feature: 'flexbox'
	    });
	  });
	
	  feature(flexbox, {
	    match: /y\sx/
	  }, function(browsers) {
	    add('display-flex', 'inline-flex', {
	      browsers: browsers,
	      feature: 'flexbox'
	    });
	    add('flex', 'flex-grow', 'flex-shrink', 'flex-basis', {
	      browsers: browsers,
	      feature: 'flexbox'
	    });
	    return add('flex-direction', 'flex-wrap', 'flex-flow', 'justify-content', 'order', 'align-items', 'align-self', 'align-content', {
	      browsers: browsers,
	      feature: 'flexbox'
	    });
	  });
	
	  feature(__webpack_require__(1100), function(browsers) {
	    return prefix('calc', {
	      props: ['*'],
	      browsers: browsers,
	      feature: 'calc'
	    });
	  });
	
	  bckgrndImgOpts = __webpack_require__(1097);
	
	  feature(bckgrndImgOpts, function(browsers) {
	    return prefix('background-clip', 'background-origin', 'background-size', {
	      browsers: browsers,
	      feature: 'background-img-opts'
	    });
	  });
	
	  feature(__webpack_require__(1138), function(browsers) {
	    return prefix('font-feature-settings', 'font-variant-ligatures', 'font-language-override', {
	      browsers: browsers,
	      feature: 'font-feature'
	    });
	  });
	
	  feature(__webpack_require__(1139), function(browsers) {
	    return prefix('font-kerning', {
	      browsers: browsers,
	      feature: 'font-kerning'
	    });
	  });
	
	  feature(__webpack_require__(1098), function(browsers) {
	    return prefix('border-image', {
	      browsers: browsers,
	      feature: 'border-image'
	    });
	  });
	
	  feature(__webpack_require__(1125), function(browsers) {
	    return prefix('::selection', {
	      selector: true,
	      browsers: browsers,
	      feature: 'css-selection'
	    });
	  });
	
	  feature(__webpack_require__(1122), function(browsers) {
	    browsers = browsers.map(function(i) {
	      var name, ref, version;
	      ref = i.split(' '), name = ref[0], version = ref[1];
	      if (name === 'firefox' && parseFloat(version) <= 18) {
	        return i + ' old';
	      } else {
	        return i;
	      }
	    });
	    return prefix('::placeholder', {
	      selector: true,
	      browsers: browsers,
	      feature: 'css-placeholder'
	    });
	  });
	
	  feature(__webpack_require__(1117), function(browsers) {
	    return prefix('hyphens', {
	      browsers: browsers,
	      feature: 'css-hyphens'
	    });
	  });
	
	  fullscreen = __webpack_require__(1140);
	
	  feature(fullscreen, function(browsers) {
	    return prefix(':fullscreen', {
	      selector: true,
	      browsers: browsers,
	      feature: 'fullscreen'
	    });
	  });
	
	  feature(fullscreen, {
	    match: /x(\s#2|$)/
	  }, function(browsers) {
	    return prefix('::backdrop', {
	      selector: true,
	      browsers: browsers,
	      feature: 'fullscreen'
	    });
	  });
	
	  feature(__webpack_require__(1136), function(browsers) {
	    return prefix('tab-size', {
	      browsers: browsers,
	      feature: 'css3-tabsize'
	    });
	  });
	
	  feature(__webpack_require__(1141), function(browsers) {
	    return prefix('max-content', 'min-content', 'fit-content', 'fill', 'fill-available', 'stretch', {
	      props: ['width', 'min-width', 'max-width', 'height', 'min-height', 'max-height', 'inline-size', 'min-inline-size', 'max-inline-size', 'block-size', 'min-block-size', 'max-block-size'],
	      browsers: browsers,
	      feature: 'intrinsic-width'
	    });
	  });
	
	  cursorsNewer = __webpack_require__(1135);
	
	  feature(cursorsNewer, function(browsers) {
	    return prefix('zoom-in', 'zoom-out', {
	      props: ['cursor'],
	      browsers: browsers,
	      feature: 'css3-cursors-newer'
	    });
	  });
	
	  cursorsGrab = __webpack_require__(1134);
	
	  feature(cursorsGrab, function(browsers) {
	    return prefix('grab', 'grabbing', {
	      props: ['cursor'],
	      browsers: browsers,
	      feature: 'css3-cursors-grab'
	    });
	  });
	
	  feature(__webpack_require__(1128), function(browsers) {
	    return prefix('sticky', {
	      props: ['position'],
	      browsers: browsers,
	      feature: 'css-sticky'
	    });
	  });
	
	  feature(__webpack_require__(1144), function(browsers) {
	    return prefix('touch-action', {
	      browsers: browsers,
	      feature: 'pointer'
	    });
	  });
	
	  decoration = __webpack_require__(1145);
	
	  feature(decoration, function(browsers) {
	    return prefix('text-decoration-style', 'text-decoration-color', 'text-decoration-line', {
	      browsers: browsers,
	      feature: 'text-decoration'
	    });
	  });
	
	  feature(decoration, {
	    match: /x.*#[23]/
	  }, function(browsers) {
	    return prefix('text-decoration-skip', {
	      browsers: browsers,
	      feature: 'text-decoration'
	    });
	  });
	
	  textSizeAdjust = __webpack_require__(1148);
	
	  feature(textSizeAdjust, function(browsers) {
	    return prefix('text-size-adjust', {
	      browsers: browsers,
	      feature: 'text-size-adjust'
	    });
	  });
	
	  feature(__webpack_require__(1120), function(browsers) {
	    prefix('mask-clip', 'mask-composite', 'mask-image', 'mask-origin', 'mask-repeat', 'mask-border-repeat', 'mask-border-source', {
	      browsers: browsers,
	      feature: 'css-masks'
	    });
	    return prefix('mask', 'mask-position', 'mask-size', 'mask-border', 'mask-border-outset', 'mask-border-width', 'mask-border-slice', {
	      browsers: browsers,
	      feature: 'css-masks'
	    });
	  });
	
	  feature(__webpack_require__(1107), function(browsers) {
	    return prefix('clip-path', {
	      browsers: browsers,
	      feature: 'css-clip-path'
	    });
	  });
	
	  boxdecorbreak = __webpack_require__(1105);
	
	  feature(boxdecorbreak, function(browsers) {
	    return prefix('box-decoration-break', {
	      browsers: browsers,
	      feature: 'css-boxdecorationbreak'
	    });
	  });
	
	  feature(__webpack_require__(1143), function(browsers) {
	    return prefix('object-fit', 'object-position', {
	      browsers: browsers,
	      feature: 'object-fit'
	    });
	  });
	
	  feature(__webpack_require__(1126), function(browsers) {
	    return prefix('shape-margin', 'shape-outside', 'shape-image-threshold', {
	      browsers: browsers,
	      feature: 'css-shapes'
	    });
	  });
	
	  feature(__webpack_require__(1147), function(browsers) {
	    return prefix('text-overflow', {
	      browsers: browsers,
	      feature: 'text-overflow'
	    });
	  });
	
	  devdaptation = __webpack_require__(1110);
	
	  feature(devdaptation, function(browsers) {
	    return prefix('@viewport', {
	      browsers: browsers,
	      feature: 'css-deviceadaptation'
	    });
	  });
	
	  resolution = __webpack_require__(1121);
	
	  feature(resolution, {
	    match: /( x($| )|a #3)/
	  }, function(browsers) {
	    return prefix('@resolution', {
	      browsers: browsers,
	      feature: 'css-media-resolution'
	    });
	  });
	
	  textAlignLast = __webpack_require__(1129);
	
	  feature(textAlignLast, function(browsers) {
	    return prefix('text-align-last', {
	      browsers: browsers,
	      feature: 'css-text-align-last'
	    });
	  });
	
	  crispedges = __webpack_require__(1108);
	
	  feature(crispedges, {
	    match: /y x|a x #1/
	  }, function(browsers) {
	    return prefix('pixelated', {
	      props: ['image-rendering'],
	      browsers: browsers,
	      feature: 'css-crisp-edges'
	    });
	  });
	
	  feature(crispedges, {
	    match: /a x #2/
	  }, function(browsers) {
	    return prefix('image-rendering', {
	      browsers: browsers,
	      feature: 'css-crisp-edges'
	    });
	  });
	
	  logicalProps = __webpack_require__(1119);
	
	  feature(logicalProps, function(browsers) {
	    return prefix('border-inline-start', 'border-inline-end', 'margin-inline-start', 'margin-inline-end', 'padding-inline-start', 'padding-inline-end', {
	      browsers: browsers,
	      feature: 'css-logical-props'
	    });
	  });
	
	  feature(logicalProps, {
	    match: /x\s#2/
	  }, function(browsers) {
	    return prefix('border-block-start', 'border-block-end', 'margin-block-start', 'margin-block-end', 'padding-block-start', 'padding-block-end', {
	      browsers: browsers,
	      feature: 'css-logical-props'
	    });
	  });
	
	  feature(__webpack_require__(1103), function(browsers) {
	    return prefix('appearance', {
	      browsers: browsers,
	      feature: 'css-appearance'
	    });
	  });
	
	  feature(__webpack_require__(1127), function(browsers) {
	    return prefix('scroll-snap-type', 'scroll-snap-coordinate', 'scroll-snap-destination', 'scroll-snap-points-x', 'scroll-snap-points-y', {
	      browsers: browsers,
	      feature: 'css-snappoints'
	    });
	  });
	
	  feature(__webpack_require__(1124), function(browsers) {
	    return prefix('flow-into', 'flow-from', 'region-fragment', {
	      browsers: browsers,
	      feature: 'css-regions'
	    });
	  });
	
	  feature(__webpack_require__(1118), function(browsers) {
	    return prefix('image-set', {
	      props: ['background', 'background-image', 'border-image', 'mask', 'list-style', 'list-style-image', 'content', 'mask-image'],
	      browsers: browsers,
	      feature: 'css-image-set'
	    });
	  });
	
	  writingMode = __webpack_require__(1132);
	
	  feature(writingMode, {
	    match: /a|x/
	  }, function(browsers) {
	    return prefix('writing-mode', {
	      browsers: browsers,
	      feature: 'css-writing-mode'
	    });
	  });
	
	  feature(__webpack_require__(1109), function(browsers) {
	    return prefix('cross-fade', {
	      props: ['background', 'background-image', 'border-image', 'mask', 'list-style', 'list-style-image', 'content', 'mask-image'],
	      browsers: browsers,
	      feature: 'css-cross-fade'
	    });
	  });
	
	  readOnly = __webpack_require__(1123);
	
	  feature(readOnly, function(browsers) {
	    return prefix(':read-only', ':read-write', {
	      selector: true,
	      browsers: browsers,
	      feature: 'css-read-only-write'
	    });
	  });
	
	  feature(__webpack_require__(1146), function(browsers) {
	    return prefix('text-emphasis', 'text-emphasis-position', 'text-emphasis-style', 'text-emphasis-color', {
	      browsers: browsers,
	      feature: 'text-emphasis'
	    });
	  });
	
	  grid = __webpack_require__(1116);
	
	  feature(grid, function(browsers) {
	    prefix('display-grid', 'inline-grid', {
	      props: ['display'],
	      browsers: browsers,
	      feature: 'css-grid'
	    });
	    return prefix('grid-template-columns', 'grid-template-rows', 'grid-row-start', 'grid-column-start', 'grid-row-end', 'grid-column-end', 'grid-row', 'grid-column', {
	      browsers: browsers,
	      feature: 'css-grid'
	    });
	  });
	
	  feature(grid, {
	    match: /a x/
	  }, function(browsers) {
	    return prefix('justify-items', 'grid-row-align', {
	      browsers: browsers,
	      feature: 'css-grid'
	    });
	  });
	
	  textSpacing = __webpack_require__(1130);
	
	  feature(textSpacing, function(browsers) {
	    return prefix('text-spacing', {
	      browsers: browsers,
	      feature: 'css-text-spacing'
	    });
	  });
	
	  feature(__webpack_require__(1102), function(browsers) {
	    return prefix(':any-link', {
	      selector: true,
	      browsers: browsers,
	      feature: 'css-any-link'
	    });
	  });
	
	}).call(this);


/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var AtRule, Prefixer,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Prefixer = __webpack_require__(139);
	
	  AtRule = (function(superClass) {
	    extend(AtRule, superClass);
	
	    function AtRule() {
	      return AtRule.__super__.constructor.apply(this, arguments);
	    }
	
	    AtRule.prototype.add = function(rule, prefix) {
	      var already, cloned, prefixed;
	      prefixed = prefix + rule.name;
	      already = rule.parent.some(function(i) {
	        return i.name === prefixed && i.params === rule.params;
	      });
	      if (already) {
	        return;
	      }
	      cloned = this.clone(rule, {
	        name: prefixed
	      });
	      return rule.parent.insertBefore(rule, cloned);
	    };
	
	    AtRule.prototype.process = function(node) {
	      var j, len, parent, prefix, ref, results;
	      parent = this.parentPrefix(node);
	      ref = this.prefixes;
	      results = [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        prefix = ref[j];
	        if (parent && parent !== prefix) {
	          continue;
	        }
	        results.push(this.add(node, prefix));
	      }
	      return results;
	    };
	
	    return AtRule;
	
	  })(Prefixer);
	
	  module.exports = AtRule;
	
	}).call(this);


/***/ },
/* 559 */
/***/ function(module, exports) {

	(function() {
	  var brackets, last;
	
	  last = function(array) {
	    return array[array.length - 1];
	  };
	
	  brackets = {
	    parse: function(str) {
	      var current, j, len, stack, sym;
	      current = [''];
	      stack = [current];
	      for (j = 0, len = str.length; j < len; j++) {
	        sym = str[j];
	        if (sym === '(') {
	          current = [''];
	          last(stack).push(current);
	          stack.push(current);
	        } else if (sym === ')') {
	          stack.pop();
	          current = last(stack);
	          current.push('');
	        } else {
	          current[current.length - 1] += sym;
	        }
	      }
	      return stack[0];
	    },
	    stringify: function(ast) {
	      var i, j, len, result;
	      result = '';
	      for (j = 0, len = ast.length; j < len; j++) {
	        i = ast[j];
	        if (typeof i === 'object') {
	          result += '(' + brackets.stringify(i) + ')';
	        } else {
	          result += i;
	        }
	      }
	      return result;
	    }
	  };
	
	  module.exports = brackets;
	
	}).call(this);


/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var AlignContent, Declaration, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(39);
	
	  Declaration = __webpack_require__(17);
	
	  AlignContent = (function(superClass) {
	    extend(AlignContent, superClass);
	
	    function AlignContent() {
	      return AlignContent.__super__.constructor.apply(this, arguments);
	    }
	
	    AlignContent.names = ['align-content', 'flex-line-pack'];
	
	    AlignContent.oldValues = {
	      'flex-end': 'end',
	      'flex-start': 'start',
	      'space-between': 'justify',
	      'space-around': 'distribute'
	    };
	
	    AlignContent.prototype.prefixed = function(prop, prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2012) {
	        return prefix + 'flex-line-pack';
	      } else {
	        return AlignContent.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    AlignContent.prototype.normalize = function(prop) {
	      return 'align-content';
	    };
	
	    AlignContent.prototype.set = function(decl, prefix) {
	      var spec;
	      spec = flexSpec(prefix)[0];
	      if (spec === 2012) {
	        decl.value = AlignContent.oldValues[decl.value] || decl.value;
	        return AlignContent.__super__.set.call(this, decl, prefix);
	      } else if (spec === 'final') {
	        return AlignContent.__super__.set.apply(this, arguments);
	      }
	    };
	
	    return AlignContent;
	
	  })(Declaration);
	
	  module.exports = AlignContent;
	
	}).call(this);


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var AlignItems, Declaration, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(39);
	
	  Declaration = __webpack_require__(17);
	
	  AlignItems = (function(superClass) {
	    extend(AlignItems, superClass);
	
	    function AlignItems() {
	      return AlignItems.__super__.constructor.apply(this, arguments);
	    }
	
	    AlignItems.names = ['align-items', 'flex-align', 'box-align'];
	
	    AlignItems.oldValues = {
	      'flex-end': 'end',
	      'flex-start': 'start'
	    };
	
	    AlignItems.prototype.prefixed = function(prop, prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2009) {
	        return prefix + 'box-align';
	      } else if (spec === 2012) {
	        return prefix + 'flex-align';
	      } else {
	        return AlignItems.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    AlignItems.prototype.normalize = function(prop) {
	      return 'align-items';
	    };
	
	    AlignItems.prototype.set = function(decl, prefix) {
	      var spec;
	      spec = flexSpec(prefix)[0];
	      if (spec === 2009 || spec === 2012) {
	        decl.value = AlignItems.oldValues[decl.value] || decl.value;
	        return AlignItems.__super__.set.call(this, decl, prefix);
	      } else {
	        return AlignItems.__super__.set.apply(this, arguments);
	      }
	    };
	
	    return AlignItems;
	
	  })(Declaration);
	
	  module.exports = AlignItems;
	
	}).call(this);


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var AlignSelf, Declaration, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(39);
	
	  Declaration = __webpack_require__(17);
	
	  AlignSelf = (function(superClass) {
	    extend(AlignSelf, superClass);
	
	    function AlignSelf() {
	      return AlignSelf.__super__.constructor.apply(this, arguments);
	    }
	
	    AlignSelf.names = ['align-self', 'flex-item-align'];
	
	    AlignSelf.oldValues = {
	      'flex-end': 'end',
	      'flex-start': 'start'
	    };
	
	    AlignSelf.prototype.prefixed = function(prop, prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2012) {
	        return prefix + 'flex-item-align';
	      } else {
	        return AlignSelf.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    AlignSelf.prototype.normalize = function(prop) {
	      return 'align-self';
	    };
	
	    AlignSelf.prototype.set = function(decl, prefix) {
	      var spec;
	      spec = flexSpec(prefix)[0];
	      if (spec === 2012) {
	        decl.value = AlignSelf.oldValues[decl.value] || decl.value;
	        return AlignSelf.__super__.set.call(this, decl, prefix);
	      } else if (spec === 'final') {
	        return AlignSelf.__super__.set.apply(this, arguments);
	      }
	    };
	
	    return AlignSelf;
	
	  })(Declaration);
	
	  module.exports = AlignSelf;
	
	}).call(this);


/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var BackgroundSize, Declaration,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(17);
	
	  BackgroundSize = (function(superClass) {
	    extend(BackgroundSize, superClass);
	
	    function BackgroundSize() {
	      return BackgroundSize.__super__.constructor.apply(this, arguments);
	    }
	
	    BackgroundSize.names = ['background-size'];
	
	    BackgroundSize.prototype.set = function(decl, prefix) {
	      var value;
	      value = decl.value.toLowerCase();
	      if (prefix === '-webkit-' && value.indexOf(' ') === -1 && value !== 'contain' && value !== 'cover') {
	        decl.value = decl.value + ' ' + decl.value;
	      }
	      return BackgroundSize.__super__.set.call(this, decl, prefix);
	    };
	
	    return BackgroundSize;
	
	  })(Declaration);
	
	  module.exports = BackgroundSize;
	
	}).call(this);


/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var BlockLogical, Declaration,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(17);
	
	  BlockLogical = (function(superClass) {
	    extend(BlockLogical, superClass);
	
	    function BlockLogical() {
	      return BlockLogical.__super__.constructor.apply(this, arguments);
	    }
	
	    BlockLogical.names = ['border-block-start', 'border-block-end', 'margin-block-start', 'margin-block-end', 'padding-block-start', 'padding-block-end', 'border-before', 'border-after', 'margin-before', 'margin-after', 'padding-before', 'padding-after'];
	
	    BlockLogical.prototype.prefixed = function(prop, prefix) {
	      return prefix + (prop.indexOf('-start') !== -1 ? prop.replace('-block-start', '-before') : prop.replace('-block-end', '-after'));
	    };
	
	    BlockLogical.prototype.normalize = function(prop) {
	      if (prop.indexOf('-before') !== -1) {
	        return prop.replace('-before', '-block-start');
	      } else {
	        return prop.replace('-after', '-block-end');
	      }
	    };
	
	    return BlockLogical;
	
	  })(Declaration);
	
	  module.exports = BlockLogical;
	
	}).call(this);


/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var BorderImage, Declaration,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(17);
	
	  BorderImage = (function(superClass) {
	    extend(BorderImage, superClass);
	
	    function BorderImage() {
	      return BorderImage.__super__.constructor.apply(this, arguments);
	    }
	
	    BorderImage.names = ['border-image'];
	
	    BorderImage.prototype.set = function(decl, prefix) {
	      decl.value = decl.value.replace(/\s+fill(\s)/, '$1');
	      return BorderImage.__super__.set.call(this, decl, prefix);
	    };
	
	    return BorderImage;
	
	  })(Declaration);
	
	  module.exports = BorderImage;
	
	}).call(this);


/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var BorderRadius, Declaration,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(17);
	
	  BorderRadius = (function(superClass) {
	    var hor, i, j, len, len1, mozilla, normal, ref, ref1, ver;
	
	    extend(BorderRadius, superClass);
	
	    function BorderRadius() {
	      return BorderRadius.__super__.constructor.apply(this, arguments);
	    }
	
	    BorderRadius.names = ['border-radius'];
	
	    BorderRadius.toMozilla = {};
	
	    BorderRadius.toNormal = {};
	
	    ref = ['top', 'bottom'];
	    for (i = 0, len = ref.length; i < len; i++) {
	      ver = ref[i];
	      ref1 = ['left', 'right'];
	      for (j = 0, len1 = ref1.length; j < len1; j++) {
	        hor = ref1[j];
	        normal = "border-" + ver + "-" + hor + "-radius";
	        mozilla = "border-radius-" + ver + hor;
	        BorderRadius.names.push(normal);
	        BorderRadius.names.push(mozilla);
	        BorderRadius.toMozilla[normal] = mozilla;
	        BorderRadius.toNormal[mozilla] = normal;
	      }
	    }
	
	    BorderRadius.prototype.prefixed = function(prop, prefix) {
	      if (prefix === '-moz-') {
	        return prefix + (BorderRadius.toMozilla[prop] || prop);
	      } else {
	        return BorderRadius.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    BorderRadius.prototype.normalize = function(prop) {
	      return BorderRadius.toNormal[prop] || prop;
	    };
	
	    return BorderRadius;
	
	  })(Declaration);
	
	  module.exports = BorderRadius;
	
	}).call(this);


/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var BreakProps, Declaration,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(17);
	
	  BreakProps = (function(superClass) {
	    extend(BreakProps, superClass);
	
	    function BreakProps() {
	      return BreakProps.__super__.constructor.apply(this, arguments);
	    }
	
	    BreakProps.names = ['break-inside', 'page-break-inside', 'column-break-inside', 'break-before', 'page-break-before', 'column-break-before', 'break-after', 'page-break-after', 'column-break-after'];
	
	    BreakProps.prototype.prefixed = function(prop, prefix) {
	      if (prefix === '-webkit-') {
	        return '-webkit-column-' + prop;
	      } else if (prefix === '-moz-') {
	        return 'page-' + prop;
	      } else {
	        return BreakProps.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    BreakProps.prototype.normalize = function(prop) {
	      if (prop.indexOf('inside') !== -1) {
	        return 'break-inside';
	      } else if (prop.indexOf('before') !== -1) {
	        return 'break-before';
	      } else if (prop.indexOf('after') !== -1) {
	        return 'break-after';
	      }
	    };
	
	    BreakProps.prototype.set = function(decl, prefix) {
	      var v;
	      v = decl.value;
	      if (decl.prop === 'break-inside' && v === 'avoid-column' || v === 'avoid-page') {
	        decl.value = 'avoid';
	      }
	      return BreakProps.__super__.set.apply(this, arguments);
	    };
	
	    BreakProps.prototype.insert = function(decl, prefix, prefixes) {
	      if (decl.prop !== 'break-inside') {
	        return BreakProps.__super__.insert.apply(this, arguments);
	      } else if (decl.value === 'avoid-region') {
	
	      } else if (decl.value === 'avoid-page' && prefix === '-webkit-') {
	
	      } else {
	        return BreakProps.__super__.insert.apply(this, arguments);
	      }
	    };
	
	    return BreakProps;
	
	  })(Declaration);
	
	  module.exports = BreakProps;
	
	}).call(this);


/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var CrossFade, OldValue, Value, list, utils,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  OldValue = __webpack_require__(71);
	
	  Value = __webpack_require__(47);
	
	  utils = __webpack_require__(41);
	
	  list = __webpack_require__(90);
	
	  CrossFade = (function(superClass) {
	    extend(CrossFade, superClass);
	
	    function CrossFade() {
	      return CrossFade.__super__.constructor.apply(this, arguments);
	    }
	
	    CrossFade.names = ['cross-fade'];
	
	    CrossFade.prototype.replace = function(string, prefix) {
	      return list.space(string).map((function(_this) {
	        return function(value) {
	          var after, args, close, match;
	          if (value.slice(0, +_this.name.length + 1 || 9e9) !== _this.name + '(') {
	            return value;
	          }
	          close = value.lastIndexOf(')');
	          after = value.slice(close + 1);
	          args = value.slice(_this.name.length + 1, +(close - 1) + 1 || 9e9);
	          if (prefix === '-webkit-') {
	            match = args.match(/\d*.?\d+%?/);
	            if (match) {
	              args = args.slice(match[0].length).trim();
	              args += ', ' + match[0];
	            } else {
	              args += ', 0.5';
	            }
	          }
	          return prefix + _this.name + '(' + args + ')' + after;
	        };
	      })(this)).join(' ');
	    };
	
	    return CrossFade;
	
	  })(Value);
	
	  module.exports = CrossFade;
	
	}).call(this);


/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var DisplayFlex, OldValue, Value, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(39);
	
	  OldValue = __webpack_require__(71);
	
	  Value = __webpack_require__(47);
	
	  DisplayFlex = (function(superClass) {
	    extend(DisplayFlex, superClass);
	
	    DisplayFlex.names = ['display-flex', 'inline-flex'];
	
	    function DisplayFlex(name, prefixes) {
	      DisplayFlex.__super__.constructor.apply(this, arguments);
	      if (name === 'display-flex') {
	        this.name = 'flex';
	      }
	    }
	
	    DisplayFlex.prototype.check = function(decl) {
	      return decl.prop === 'display' && decl.value === this.name;
	    };
	
	    DisplayFlex.prototype.prefixed = function(prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      return prefix + (spec === 2009 ? this.name === 'flex' ? 'box' : 'inline-box' : spec === 2012 ? this.name === 'flex' ? 'flexbox' : 'inline-flexbox' : spec === 'final' ? this.name : void 0);
	    };
	
	    DisplayFlex.prototype.replace = function(string, prefix) {
	      return this.prefixed(prefix);
	    };
	
	    DisplayFlex.prototype.old = function(prefix) {
	      var prefixed;
	      prefixed = this.prefixed(prefix);
	      if (prefixed) {
	        return new OldValue(this.name, prefixed);
	      }
	    };
	
	    return DisplayFlex;
	
	  })(Value);
	
	  module.exports = DisplayFlex;
	
	}).call(this);


/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var DisplayGrid, OldValue, Value, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(39);
	
	  OldValue = __webpack_require__(71);
	
	  Value = __webpack_require__(47);
	
	  DisplayGrid = (function(superClass) {
	    extend(DisplayGrid, superClass);
	
	    DisplayGrid.names = ['display-grid', 'inline-grid'];
	
	    function DisplayGrid(name, prefixes) {
	      DisplayGrid.__super__.constructor.apply(this, arguments);
	      if (name === 'display-grid') {
	        this.name = 'grid';
	      }
	    }
	
	    DisplayGrid.prototype.check = function(decl) {
	      return decl.prop === 'display' && decl.value === this.name;
	    };
	
	    return DisplayGrid;
	
	  })(Value);
	
	  module.exports = DisplayGrid;
	
	}).call(this);


/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var FilterValue, OldFilterValue, OldValue, Value, utils,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  OldValue = __webpack_require__(71);
	
	  Value = __webpack_require__(47);
	
	  utils = __webpack_require__(41);
	
	  OldFilterValue = (function(superClass) {
	    extend(OldFilterValue, superClass);
	
	    function OldFilterValue() {
	      return OldFilterValue.__super__.constructor.apply(this, arguments);
	    }
	
	    OldFilterValue.prototype.clean = function(decl) {
	      return decl.value = utils.editList(decl.value, (function(_this) {
	        return function(props) {
	          if (props.every(function(i) {
	            return i.indexOf(_this.unprefixed) !== 0;
	          })) {
	            return props;
	          }
	          return props.filter(function(i) {
	            return i.indexOf(_this.prefixed) === -1;
	          });
	        };
	      })(this));
	    };
	
	    return OldFilterValue;
	
	  })(OldValue);
	
	  FilterValue = (function(superClass) {
	    extend(FilterValue, superClass);
	
	    FilterValue.names = ['filter', 'filter-function'];
	
	    function FilterValue(name, prefixes) {
	      FilterValue.__super__.constructor.apply(this, arguments);
	      if (name === 'filter-function') {
	        this.name = 'filter';
	      }
	    }
	
	    FilterValue.prototype.replace = function(value, prefix) {
	      if (prefix === '-webkit-' && value.indexOf('filter(') === -1) {
	        if (value.indexOf('-webkit-filter') === -1) {
	          return FilterValue.__super__.replace.apply(this, arguments) + ', ' + value;
	        } else {
	          return value;
	        }
	      } else {
	        return FilterValue.__super__.replace.apply(this, arguments);
	      }
	    };
	
	    FilterValue.prototype.old = function(prefix) {
	      return new OldFilterValue(this.name, prefix + this.name);
	    };
	
	    return FilterValue;
	
	  })(Value);
	
	  module.exports = FilterValue;
	
	}).call(this);


/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, Filter,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(17);
	
	  Filter = (function(superClass) {
	    extend(Filter, superClass);
	
	    function Filter() {
	      return Filter.__super__.constructor.apply(this, arguments);
	    }
	
	    Filter.names = ['filter'];
	
	    Filter.prototype.check = function(decl) {
	      var v;
	      v = decl.value;
	      return v.toLowerCase().indexOf('alpha(') === -1 && v.indexOf('DXImageTransform.Microsoft') === -1 && v.indexOf('data:image/svg+xml') === -1;
	    };
	
	    return Filter;
	
	  })(Declaration);
	
	  module.exports = Filter;
	
	}).call(this);


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, FlexBasis, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(39);
	
	  Declaration = __webpack_require__(17);
	
	  FlexBasis = (function(superClass) {
	    extend(FlexBasis, superClass);
	
	    function FlexBasis() {
	      return FlexBasis.__super__.constructor.apply(this, arguments);
	    }
	
	    FlexBasis.names = ['flex-basis', 'flex-preferred-size'];
	
	    FlexBasis.prototype.normalize = function() {
	      return 'flex-basis';
	    };
	
	    FlexBasis.prototype.prefixed = function(prop, prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2012) {
	        return prefix + 'flex-preferred-size';
	      } else {
	        return FlexBasis.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    FlexBasis.prototype.set = function(decl, prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2012 || spec === 'final') {
	        return FlexBasis.__super__.set.apply(this, arguments);
	      }
	    };
	
	    return FlexBasis;
	
	  })(Declaration);
	
	  module.exports = FlexBasis;
	
	}).call(this);


/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, FlexDirection, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(39);
	
	  Declaration = __webpack_require__(17);
	
	  FlexDirection = (function(superClass) {
	    extend(FlexDirection, superClass);
	
	    function FlexDirection() {
	      return FlexDirection.__super__.constructor.apply(this, arguments);
	    }
	
	    FlexDirection.names = ['flex-direction', 'box-direction', 'box-orient'];
	
	    FlexDirection.prototype.normalize = function(prop) {
	      return 'flex-direction';
	    };
	
	    FlexDirection.prototype.insert = function(decl, prefix, prefixes) {
	      var already, cloned, dir, orient, ref, spec, value;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec !== 2009) {
	        return FlexDirection.__super__.insert.apply(this, arguments);
	      } else {
	        already = decl.parent.some(function(i) {
	          return i.prop === prefix + 'box-orient' || i.prop === prefix + 'box-direction';
	        });
	        if (already) {
	          return;
	        }
	        value = decl.value;
	        orient = value.indexOf('row') !== -1 ? 'horizontal' : 'vertical';
	        dir = value.indexOf('reverse') !== -1 ? 'reverse' : 'normal';
	        cloned = this.clone(decl);
	        cloned.prop = prefix + 'box-orient';
	        cloned.value = orient;
	        if (this.needCascade(decl)) {
	          cloned.raws.before = this.calcBefore(prefixes, decl, prefix);
	        }
	        decl.parent.insertBefore(decl, cloned);
	        cloned = this.clone(decl);
	        cloned.prop = prefix + 'box-direction';
	        cloned.value = dir;
	        if (this.needCascade(decl)) {
	          cloned.raws.before = this.calcBefore(prefixes, decl, prefix);
	        }
	        return decl.parent.insertBefore(decl, cloned);
	      }
	    };
	
	    FlexDirection.prototype.old = function(prop, prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2009) {
	        return [prefix + 'box-orient', prefix + 'box-direction'];
	      } else {
	        return FlexDirection.__super__.old.apply(this, arguments);
	      }
	    };
	
	    return FlexDirection;
	
	  })(Declaration);
	
	  module.exports = FlexDirection;
	
	}).call(this);


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, FlexFlow, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(39);
	
	  Declaration = __webpack_require__(17);
	
	  FlexFlow = (function(superClass) {
	    extend(FlexFlow, superClass);
	
	    function FlexFlow() {
	      return FlexFlow.__super__.constructor.apply(this, arguments);
	    }
	
	    FlexFlow.names = ['flex-flow', 'box-direction', 'box-orient'];
	
	    FlexFlow.prototype.insert = function(decl, prefix, prefixes) {
	      var already, cloned, dir, orient, ref, spec, value, values;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec !== 2009) {
	        return FlexFlow.__super__.insert.apply(this, arguments);
	      } else {
	        values = decl.value.split(/\s+/).filter(function(i) {
	          return i !== 'wrap' && i !== 'nowrap' && 'wrap-reverse';
	        });
	        if (values.length === 0) {
	          return;
	        }
	        already = decl.parent.some(function(i) {
	          return i.prop === prefix + 'box-orient' || i.prop === prefix + 'box-direction';
	        });
	        if (already) {
	          return;
	        }
	        value = values[0];
	        orient = value.indexOf('row') !== -1 ? 'horizontal' : 'vertical';
	        dir = value.indexOf('reverse') !== -1 ? 'reverse' : 'normal';
	        cloned = this.clone(decl);
	        cloned.prop = prefix + 'box-orient';
	        cloned.value = orient;
	        if (this.needCascade(decl)) {
	          cloned.raws.before = this.calcBefore(prefixes, decl, prefix);
	        }
	        decl.parent.insertBefore(decl, cloned);
	        cloned = this.clone(decl);
	        cloned.prop = prefix + 'box-direction';
	        cloned.value = dir;
	        if (this.needCascade(decl)) {
	          cloned.raws.before = this.calcBefore(prefixes, decl, prefix);
	        }
	        return decl.parent.insertBefore(decl, cloned);
	      }
	    };
	
	    return FlexFlow;
	
	  })(Declaration);
	
	  module.exports = FlexFlow;
	
	}).call(this);


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, Flex, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(39);
	
	  Declaration = __webpack_require__(17);
	
	  Flex = (function(superClass) {
	    extend(Flex, superClass);
	
	    function Flex() {
	      return Flex.__super__.constructor.apply(this, arguments);
	    }
	
	    Flex.names = ['flex-grow', 'flex-positive'];
	
	    Flex.prototype.normalize = function() {
	      return 'flex';
	    };
	
	    Flex.prototype.prefixed = function(prop, prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2009) {
	        return prefix + 'box-flex';
	      } else if (spec === 2012) {
	        return prefix + 'flex-positive';
	      } else {
	        return Flex.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    return Flex;
	
	  })(Declaration);
	
	  module.exports = Flex;
	
	}).call(this);


/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, FlexShrink, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(39);
	
	  Declaration = __webpack_require__(17);
	
	  FlexShrink = (function(superClass) {
	    extend(FlexShrink, superClass);
	
	    function FlexShrink() {
	      return FlexShrink.__super__.constructor.apply(this, arguments);
	    }
	
	    FlexShrink.names = ['flex-shrink', 'flex-negative'];
	
	    FlexShrink.prototype.normalize = function() {
	      return 'flex-shrink';
	    };
	
	    FlexShrink.prototype.prefixed = function(prop, prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2012) {
	        return prefix + 'flex-negative';
	      } else {
	        return FlexShrink.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    FlexShrink.prototype.set = function(decl, prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2012 || spec === 'final') {
	        return FlexShrink.__super__.set.apply(this, arguments);
	      }
	    };
	
	    return FlexShrink;
	
	  })(Declaration);
	
	  module.exports = FlexShrink;
	
	}).call(this);


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var FlexValues, OldValue, Value,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  OldValue = __webpack_require__(71);
	
	  Value = __webpack_require__(47);
	
	  FlexValues = (function(superClass) {
	    extend(FlexValues, superClass);
	
	    function FlexValues() {
	      return FlexValues.__super__.constructor.apply(this, arguments);
	    }
	
	    FlexValues.names = ['flex', 'flex-grow', 'flex-shrink', 'flex-basis'];
	
	    FlexValues.prototype.prefixed = function(prefix) {
	      return this.all.prefixed(this.name, prefix);
	    };
	
	    FlexValues.prototype.replace = function(string, prefix) {
	      return string.replace(this.regexp(), '$1' + this.prefixed(prefix) + '$3');
	    };
	
	    FlexValues.prototype.old = function(prefix) {
	      return new OldValue(this.name, this.prefixed(prefix));
	    };
	
	    return FlexValues;
	
	  })(Value);
	
	  module.exports = FlexValues;
	
	}).call(this);


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, FlexWrap, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(39);
	
	  Declaration = __webpack_require__(17);
	
	  FlexWrap = (function(superClass) {
	    extend(FlexWrap, superClass);
	
	    function FlexWrap() {
	      return FlexWrap.__super__.constructor.apply(this, arguments);
	    }
	
	    FlexWrap.names = ['flex-wrap'];
	
	    FlexWrap.prototype.set = function(decl, prefix) {
	      var spec;
	      spec = flexSpec(prefix)[0];
	      if (spec !== 2009) {
	        return FlexWrap.__super__.set.apply(this, arguments);
	      }
	    };
	
	    return FlexWrap;
	
	  })(Declaration);
	
	  module.exports = FlexWrap;
	
	}).call(this);


/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, Flex, flexSpec, list,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(39);
	
	  Declaration = __webpack_require__(17);
	
	  list = __webpack_require__(90);
	
	  Flex = (function(superClass) {
	    extend(Flex, superClass);
	
	    function Flex() {
	      return Flex.__super__.constructor.apply(this, arguments);
	    }
	
	    Flex.names = ['flex', 'box-flex'];
	
	    Flex.oldValues = {
	      'auto': '1',
	      'none': '0'
	    };
	
	    Flex.prototype.prefixed = function(prop, prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2009) {
	        return prefix + 'box-flex';
	      } else {
	        return Flex.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    Flex.prototype.normalize = function() {
	      return 'flex';
	    };
	
	    Flex.prototype.set = function(decl, prefix) {
	      var components, spec;
	      spec = flexSpec(prefix)[0];
	      if (spec === 2009) {
	        decl.value = list.space(decl.value)[0];
	        decl.value = Flex.oldValues[decl.value] || decl.value;
	        return Flex.__super__.set.call(this, decl, prefix);
	      } else if (spec === 2012) {
	        components = list.space(decl.value);
	        if (components.length === 3 && components[2] === '0') {
	          decl.value = components.slice(0, 2).concat('0px').join(' ');
	        }
	        return Flex.__super__.set.call(this, decl, prefix);
	      } else {
	        return Flex.__super__.set.apply(this, arguments);
	      }
	    };
	
	    return Flex;
	
	  })(Declaration);
	
	  module.exports = Flex;
	
	}).call(this);


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Fullscreen, Selector,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Selector = __webpack_require__(234);
	
	  Fullscreen = (function(superClass) {
	    extend(Fullscreen, superClass);
	
	    function Fullscreen() {
	      return Fullscreen.__super__.constructor.apply(this, arguments);
	    }
	
	    Fullscreen.names = [':fullscreen'];
	
	    Fullscreen.prototype.prefixed = function(prefix) {
	      if ('-webkit-' === prefix) {
	        return ':-webkit-full-screen';
	      } else if ('-moz-' === prefix) {
	        return ':-moz-full-screen';
	      } else {
	        return ":" + prefix + "fullscreen";
	      }
	    };
	
	    return Fullscreen;
	
	  })(Selector);
	
	  module.exports = Fullscreen;
	
	}).call(this);


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Gradient, OldValue, Value, isDirection, list, parser, range, utils,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty,
	    slice = [].slice;
	
	  OldValue = __webpack_require__(71);
	
	  Value = __webpack_require__(47);
	
	  utils = __webpack_require__(41);
	
	  parser = __webpack_require__(313);
	
	  range = __webpack_require__(1468);
	
	  list = __webpack_require__(90);
	
	  isDirection = /top|left|right|bottom/gi;
	
	  Gradient = (function(superClass) {
	    extend(Gradient, superClass);
	
	    function Gradient() {
	      return Gradient.__super__.constructor.apply(this, arguments);
	    }
	
	    Gradient.names = ['linear-gradient', 'repeating-linear-gradient', 'radial-gradient', 'repeating-radial-gradient'];
	
	    Gradient.prototype.replace = function(string, prefix) {
	      var ast, changes, j, len, node, ref;
	      ast = parser(string);
	      ref = ast.nodes;
	      for (j = 0, len = ref.length; j < len; j++) {
	        node = ref[j];
	        if (node.type === 'function' && node.value === this.name) {
	          node.nodes = this.newDirection(node.nodes);
	          node.nodes = this.normalize(node.nodes);
	          if (prefix === '-webkit- old') {
	            changes = this.oldWebkit(node);
	            if (!changes) {
	              return;
	            }
	          } else {
	            node.nodes = this.convertDirection(node.nodes);
	            node.value = prefix + node.value;
	          }
	        }
	      }
	      return ast.toString();
	    };
	
	    Gradient.prototype.directions = {
	      top: 'bottom',
	      left: 'right',
	      bottom: 'top',
	      right: 'left'
	    };
	
	    Gradient.prototype.oldDirections = {
	      'top': 'left bottom, left top',
	      'left': 'right top, left top',
	      'bottom': 'left top, left bottom',
	      'right': 'left top, right top',
	      'top right': 'left bottom, right top',
	      'top left': 'right bottom, left top',
	      'right top': 'left bottom, right top',
	      'right bottom': 'left top, right bottom',
	      'bottom right': 'left top, right bottom',
	      'bottom left': 'right top, left bottom',
	      'left top': 'right bottom, left top',
	      'left bottom': 'right top, left bottom'
	    };
	
	    Gradient.prototype.replaceFirst = function() {
	      var params, prefix, words;
	      params = arguments[0], words = 2 <= arguments.length ? slice.call(arguments, 1) : [];
	      prefix = words.map(function(i) {
	        if (i === ' ') {
	          return {
	            type: 'space',
	            value: i
	          };
	        } else {
	          return {
	            type: 'word',
	            value: i
	          };
	        }
	      });
	      return prefix.concat(params.slice(1));
	    };
	
	    Gradient.prototype.normalizeUnit = function(str, full) {
	      var deg, num;
	      num = parseFloat(str);
	      deg = (num / full) * 360;
	      return deg + "deg";
	    };
	
	    Gradient.prototype.normalize = function(nodes) {
	      var num;
	      if (!nodes[0]) {
	        return nodes;
	      }
	      if (/-?\d+(.\d+)?grad/.test(nodes[0].value)) {
	        nodes[0].value = this.normalizeUnit(nodes[0].value, 400);
	      } else if (/-?\d+(.\d+)?rad/.test(nodes[0].value)) {
	        nodes[0].value = this.normalizeUnit(nodes[0].value, 2 * Math.PI);
	      } else if (/-?\d+(.\d+)?turn/.test(nodes[0].value)) {
	        nodes[0].value = this.normalizeUnit(nodes[0].value, 1);
	      } else if (nodes[0].value.indexOf('deg') !== -1) {
	        num = parseFloat(nodes[0].value);
	        num = range.wrap(0, 360, num);
	        nodes[0].value = num + "deg";
	      }
	      if (nodes[0].value === '0deg') {
	        nodes = this.replaceFirst(nodes, 'to', ' ', 'top');
	      } else if (nodes[0].value === '90deg') {
	        nodes = this.replaceFirst(nodes, 'to', ' ', 'right');
	      } else if (nodes[0].value === '180deg') {
	        nodes = this.replaceFirst(nodes, 'to', ' ', 'bottom');
	      } else if (nodes[0].value === '270deg') {
	        nodes = this.replaceFirst(nodes, 'to', ' ', 'left');
	      }
	      return nodes;
	    };
	
	    Gradient.prototype.newDirection = function(params) {
	      var i, j, ref;
	      if (params[0].value === 'to') {
	        return params;
	      }
	      if (!isDirection.test(params[0].value)) {
	        return params;
	      }
	      params.unshift({
	        type: 'word',
	        value: 'to'
	      }, {
	        type: 'space',
	        value: ' '
	      });
	      for (i = j = 2, ref = params.length; 2 <= ref ? j < ref : j > ref; i = 2 <= ref ? ++j : --j) {
	        if (params[i].type === 'div') {
	          break;
	        }
	        if (params[i].type === 'word') {
	          params[i].value = this.revertDirection(params[i].value);
	        }
	      }
	      return params;
	    };
	
	    Gradient.prototype.convertDirection = function(params) {
	      if (params.length > 0) {
	        if (params[0].value === 'to') {
	          this.fixDirection(params);
	        } else if (params[0].value.indexOf('deg') !== -1) {
	          this.fixAngle(params);
	        } else if (params[2].value === 'at') {
	          this.fixRadial(params);
	        }
	      }
	      return params;
	    };
	
	    Gradient.prototype.fixDirection = function(params) {
	      var i, j, ref, results;
	      params.splice(0, 2);
	      results = [];
	      for (i = j = 0, ref = params.length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        if (params[i].type === 'div') {
	          break;
	        }
	        if (params[i].type === 'word') {
	          results.push(params[i].value = this.revertDirection(params[i].value));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    };
	
	    Gradient.prototype.fixAngle = function(params) {
	      var first;
	      first = params[0].value;
	      first = parseFloat(first);
	      first = Math.abs(450 - first) % 360;
	      first = this.roundFloat(first, 3);
	      return params[0].value = first + "deg";
	    };
	
	    Gradient.prototype.fixRadial = function(params) {
	      var first, i, j, ref, second;
	      first = params[0];
	      second = [];
	      for (i = j = 4, ref = params.length; 4 <= ref ? j < ref : j > ref; i = 4 <= ref ? ++j : --j) {
	        if (params[i].type === 'div') {
	          break;
	        } else {
	          second.push(params[i]);
	        }
	      }
	      return params.splice.apply(params, [0, i].concat(slice.call(second), [params[i + 2]], [first]));
	    };
	
	    Gradient.prototype.revertDirection = function(word) {
	      return this.directions[word.toLowerCase()] || word;
	    };
	
	    Gradient.prototype.roundFloat = function(float, digits) {
	      return parseFloat(float.toFixed(digits));
	    };
	
	    Gradient.prototype.oldWebkit = function(node) {
	      var i, j, k, len, len1, nodes, param, params, string;
	      nodes = node.nodes;
	      string = parser.stringify(node.nodes);
	      if (this.name !== 'linear-gradient') {
	        return false;
	      }
	      if (nodes[0] && nodes[0].value.indexOf('deg') !== -1) {
	        return false;
	      }
	      if (string.indexOf('px') !== -1) {
	        return false;
	      }
	      if (string.indexOf('-corner') !== -1) {
	        return false;
	      }
	      if (string.indexOf('-side') !== -1) {
	        return false;
	      }
	      params = [[]];
	      for (j = 0, len = nodes.length; j < len; j++) {
	        i = nodes[j];
	        params[params.length - 1].push(i);
	        if (i.type === 'div' && i.value === ',') {
	          params.push([]);
	        }
	      }
	      this.oldDirection(params);
	      this.colorStops(params);
	      node.nodes = [];
	      for (k = 0, len1 = params.length; k < len1; k++) {
	        param = params[k];
	        node.nodes = node.nodes.concat(param);
	      }
	      node.nodes.unshift({
	        type: 'word',
	        value: 'linear'
	      }, this.cloneDiv(node.nodes));
	      node.value = '-webkit-gradient';
	      return true;
	    };
	
	    Gradient.prototype.oldDirection = function(params) {
	      var div, j, len, node, old, ref, words;
	      div = this.cloneDiv(params[0]);
	      if (params[0][0].value !== 'to') {
	        return params.unshift([
	          {
	            type: 'word',
	            value: this.oldDirections.bottom
	          }, div
	        ]);
	      } else {
	        words = [];
	        ref = params[0].slice(2);
	        for (j = 0, len = ref.length; j < len; j++) {
	          node = ref[j];
	          if (node.type === 'word') {
	            words.push(node.value.toLowerCase());
	          }
	        }
	        words = words.join(' ');
	        old = this.oldDirections[words] || words;
	        return params[0] = [
	          {
	            type: 'word',
	            value: old
	          }, div
	        ];
	      }
	    };
	
	    Gradient.prototype.cloneDiv = function(params) {
	      var i, j, len;
	      for (j = 0, len = params.length; j < len; j++) {
	        i = params[j];
	        if (i.type === 'div' && i.value === ',') {
	          return i;
	        }
	      }
	      return {
	        type: 'div',
	        value: ',',
	        after: ' '
	      };
	    };
	
	    Gradient.prototype.colorStops = function(params) {
	      var color, div, i, j, len, param, pos, results, stop;
	      results = [];
	      for (i = j = 0, len = params.length; j < len; i = ++j) {
	        param = params[i];
	        if (i === 0) {
	          continue;
	        }
	        color = parser.stringify(param[0]);
	        if (param[1] && param[1].type === 'word') {
	          pos = param[1].value;
	        } else if (param[2] && param[2].type === 'word') {
	          pos = param[2].value;
	        }
	        stop = i === 1 && (!pos || pos === '0%') ? "from(" + color + ")" : i === params.length - 1 && (!pos || pos === '100%') ? "to(" + color + ")" : pos ? "color-stop(" + pos + ", " + color + ")" : "color-stop(" + color + ")";
	        div = param[param.length - 1];
	        params[i] = [
	          {
	            type: 'word',
	            value: stop
	          }
	        ];
	        if (div.type === 'div' && div.value === ',') {
	          results.push(params[i].push(div));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    };
	
	    Gradient.prototype.old = function(prefix) {
	      var regexp, string, type;
	      if (prefix === '-webkit-') {
	        type = this.name === 'linear-gradient' ? 'linear' : 'radial';
	        string = '-gradient';
	        regexp = utils.regexp("-webkit-(" + type + "-gradient|gradient\\(\\s*" + type + ")", false);
	        return new OldValue(this.name, prefix + this.name, string, regexp);
	      } else {
	        return Gradient.__super__.old.apply(this, arguments);
	      }
	    };
	
	    Gradient.prototype.add = function(decl, prefix) {
	      var p;
	      p = decl.prop;
	      if (p.indexOf('mask') !== -1) {
	        if (prefix === '-webkit-' || prefix === '-webkit- old') {
	          return Gradient.__super__.add.apply(this, arguments);
	        }
	      } else if (p === 'list-style' || p === 'list-style-image' || p === 'content') {
	        if (prefix === '-webkit-' || prefix === '-webkit- old') {
	          return Gradient.__super__.add.apply(this, arguments);
	        }
	      } else {
	        return Gradient.__super__.add.apply(this, arguments);
	      }
	    };
	
	    return Gradient;
	
	  })(Value);
	
	  module.exports = Gradient;
	
	}).call(this);


/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, GridEnd,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(17);
	
	  GridEnd = (function(superClass) {
	    extend(GridEnd, superClass);
	
	    function GridEnd() {
	      return GridEnd.__super__.constructor.apply(this, arguments);
	    }
	
	    GridEnd.names = ['grid-row-end', 'grid-column-end', 'grid-row-span', 'grid-column-span'];
	
	    GridEnd.prototype.check = function(decl) {
	      return decl.value.indexOf('span') !== -1;
	    };
	
	    GridEnd.prototype.normalize = function(prop) {
	      return prop.replace(/(-span|-end)/, '');
	    };
	
	    GridEnd.prototype.prefixed = function(prop, prefix) {
	      if (prefix === '-ms-') {
	        return prefix + prop.replace('-end', '-span');
	      } else {
	        return GridEnd.__super__.prefixed.call(this, prop, prefix);
	      }
	    };
	
	    GridEnd.prototype.set = function(decl, prefix) {
	      if (prefix === '-ms-') {
	        decl.value = decl.value.replace(/span\s/i, '');
	      }
	      return GridEnd.__super__.set.call(this, decl, prefix);
	    };
	
	    return GridEnd;
	
	  })(Declaration);
	
	  module.exports = GridEnd;
	
	}).call(this);


/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, GridRowAlign,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(17);
	
	  GridRowAlign = (function(superClass) {
	    extend(GridRowAlign, superClass);
	
	    function GridRowAlign() {
	      return GridRowAlign.__super__.constructor.apply(this, arguments);
	    }
	
	    GridRowAlign.names = ['grid-row-align'];
	
	    GridRowAlign.prototype.check = function(decl) {
	      return decl.value.indexOf('flex-') === -1 && decl.value !== 'baseline';
	    };
	
	    GridRowAlign.prototype.prefixed = function(prop, prefix) {
	      return prefix + 'grid-row-align';
	    };
	
	    GridRowAlign.prototype.normalize = function(prop) {
	      return 'align-self';
	    };
	
	    return GridRowAlign;
	
	  })(Declaration);
	
	  module.exports = GridRowAlign;
	
	}).call(this);


/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, GridStart,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(17);
	
	  GridStart = (function(superClass) {
	    extend(GridStart, superClass);
	
	    function GridStart() {
	      return GridStart.__super__.constructor.apply(this, arguments);
	    }
	
	    GridStart.names = ['grid-row-start', 'grid-column-start', 'grid-row', 'grid-column'];
	
	    GridStart.prototype.check = function(decl) {
	      return decl.value.indexOf('/') === -1 || decl.value.indexOf('span') !== -1;
	    };
	
	    GridStart.prototype.normalize = function(prop) {
	      return prop.replace('-start', '');
	    };
	
	    GridStart.prototype.prefixed = function(prop, prefix) {
	      if (prefix === '-ms-') {
	        return prefix + prop.replace('-start', '');
	      } else {
	        return GridStart.__super__.prefixed.call(this, prop, prefix);
	      }
	    };
	
	    GridStart.prototype.insert = function(decl, prefix, prefixes) {
	      var parts;
	      parts = this.splitValue(decl, prefix);
	      if (parts.length === 2) {
	        decl.cloneBefore({
	          prop: '-ms-' + decl.prop + '-span',
	          value: parts[1]
	        });
	      }
	      return GridStart.__super__.insert.call(this, decl, prefix, prefixes);
	    };
	
	    GridStart.prototype.set = function(decl, prefix) {
	      var parts;
	      parts = this.splitValue(decl, prefix);
	      if (parts.length === 2) {
	        decl.value = parts[0];
	      }
	      return GridStart.__super__.set.call(this, decl, prefix);
	    };
	
	    GridStart.prototype.splitValue = function(decl, prefix) {
	      var parts;
	      if (prefix === '-ms-' && decl.prop.indexOf('-start') === -1) {
	        parts = decl.value.split(/\s*\/\s*span\s+/);
	        if (parts.length === 2) {
	          return parts;
	        }
	      }
	      return false;
	    };
	
	    return GridStart;
	
	  })(Declaration);
	
	  module.exports = GridStart;
	
	}).call(this);


/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, GridTemplate, parser,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  parser = __webpack_require__(313);
	
	  Declaration = __webpack_require__(17);
	
	  GridTemplate = (function(superClass) {
	    extend(GridTemplate, superClass);
	
	    function GridTemplate() {
	      return GridTemplate.__super__.constructor.apply(this, arguments);
	    }
	
	    GridTemplate.names = ['grid-template-rows', 'grid-template-columns', 'grid-rows', 'grid-columns'];
	
	    GridTemplate.prototype.prefixed = function(prop, prefix) {
	      if (prefix === '-ms-') {
	        return prefix + prop.replace('template-', '');
	      } else {
	        return GridTemplate.__super__.prefixed.call(this, prop, prefix);
	      }
	    };
	
	    GridTemplate.prototype.normalize = function(prop) {
	      return prop.replace(/^grid-(rows|columns)/, 'grid-template-$1');
	    };
	
	    GridTemplate.prototype.walkRepeat = function(node) {
	      var count, first, fixed, i, j, len, ref;
	      fixed = [];
	      ref = node.nodes;
	      for (j = 0, len = ref.length; j < len; j++) {
	        i = ref[j];
	        if (i.nodes) {
	          this.walkRepeat(i);
	        }
	        fixed.push(i);
	        if (i.type === 'function' && i.value === 'repeat') {
	          first = i.nodes.shift();
	          if (first) {
	            count = first.value;
	            i.nodes.shift();
	            i.value = '';
	            fixed.push({
	              type: 'word',
	              value: "[" + count + "]"
	            });
	          }
	        }
	      }
	      return node.nodes = fixed;
	    };
	
	    GridTemplate.prototype.changeRepeat = function(value) {
	      var ast;
	      ast = parser(value);
	      this.walkRepeat(ast);
	      return ast.toString();
	    };
	
	    GridTemplate.prototype.set = function(decl, prefix) {
	      if (prefix === '-ms-' && decl.value.indexOf('repeat(') !== -1) {
	        decl.value = this.changeRepeat(decl.value);
	      }
	      return GridTemplate.__super__.set.call(this, decl, prefix);
	    };
	
	    return GridTemplate;
	
	  })(Declaration);
	
	  module.exports = GridTemplate;
	
	}).call(this);


/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, ImageRendering,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(17);
	
	  ImageRendering = (function(superClass) {
	    extend(ImageRendering, superClass);
	
	    function ImageRendering() {
	      return ImageRendering.__super__.constructor.apply(this, arguments);
	    }
	
	    ImageRendering.names = ['image-rendering', 'interpolation-mode'];
	
	    ImageRendering.prototype.check = function(decl) {
	      return decl.value === 'pixelated';
	    };
	
	    ImageRendering.prototype.prefixed = function(prop, prefix) {
	      if (prefix === '-ms-') {
	        return '-ms-interpolation-mode';
	      } else {
	        return ImageRendering.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    ImageRendering.prototype.set = function(decl, prefix) {
	      if (prefix === '-ms-') {
	        decl.prop = '-ms-interpolation-mode';
	        decl.value = 'nearest-neighbor';
	        return decl;
	      } else {
	        return ImageRendering.__super__.set.apply(this, arguments);
	      }
	    };
	
	    ImageRendering.prototype.normalize = function(prop) {
	      return 'image-rendering';
	    };
	
	    ImageRendering.prototype.process = function(node, result) {
	      return ImageRendering.__super__.process.apply(this, arguments);
	    };
	
	    return ImageRendering;
	
	  })(Declaration);
	
	  module.exports = ImageRendering;
	
	}).call(this);


/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var ImageSet, Value, list,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  list = __webpack_require__(90);
	
	  Value = __webpack_require__(47);
	
	  ImageSet = (function(superClass) {
	    extend(ImageSet, superClass);
	
	    function ImageSet() {
	      return ImageSet.__super__.constructor.apply(this, arguments);
	    }
	
	    ImageSet.names = ['image-set'];
	
	    ImageSet.prototype.replace = function(string, prefix) {
	      if (prefix === '-webkit-') {
	        return ImageSet.__super__.replace.apply(this, arguments).replace(/("[^"]+"|'[^']+')(\s+\d+\w)/gi, 'url($1)$2');
	      } else {
	        return ImageSet.__super__.replace.apply(this, arguments);
	      }
	    };
	
	    return ImageSet;
	
	  })(Value);
	
	  module.exports = ImageSet;
	
	}).call(this);


/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, InlineLogical,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(17);
	
	  InlineLogical = (function(superClass) {
	    extend(InlineLogical, superClass);
	
	    function InlineLogical() {
	      return InlineLogical.__super__.constructor.apply(this, arguments);
	    }
	
	    InlineLogical.names = ['border-inline-start', 'border-inline-end', 'margin-inline-start', 'margin-inline-end', 'padding-inline-start', 'padding-inline-end', 'border-start', 'border-end', 'margin-start', 'margin-end', 'padding-start', 'padding-end'];
	
	    InlineLogical.prototype.prefixed = function(prop, prefix) {
	      return prefix + prop.replace('-inline', '');
	    };
	
	    InlineLogical.prototype.normalize = function(prop) {
	      return prop.replace(/(margin|padding|border)-(start|end)/, '$1-inline-$2');
	    };
	
	    return InlineLogical;
	
	  })(Declaration);
	
	  module.exports = InlineLogical;
	
	}).call(this);


/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, JustifyContent, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(39);
	
	  Declaration = __webpack_require__(17);
	
	  JustifyContent = (function(superClass) {
	    extend(JustifyContent, superClass);
	
	    function JustifyContent() {
	      return JustifyContent.__super__.constructor.apply(this, arguments);
	    }
	
	    JustifyContent.names = ['justify-content', 'flex-pack', 'box-pack'];
	
	    JustifyContent.oldValues = {
	      'flex-end': 'end',
	      'flex-start': 'start',
	      'space-between': 'justify',
	      'space-around': 'distribute'
	    };
	
	    JustifyContent.prototype.prefixed = function(prop, prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2009) {
	        return prefix + 'box-pack';
	      } else if (spec === 2012) {
	        return prefix + 'flex-pack';
	      } else {
	        return JustifyContent.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    JustifyContent.prototype.normalize = function(prop) {
	      return 'justify-content';
	    };
	
	    JustifyContent.prototype.set = function(decl, prefix) {
	      var spec, value;
	      spec = flexSpec(prefix)[0];
	      if (spec === 2009 || spec === 2012) {
	        value = JustifyContent.oldValues[decl.value] || decl.value;
	        decl.value = value;
	        if (spec !== 2009 || value !== 'distribute') {
	          return JustifyContent.__super__.set.call(this, decl, prefix);
	        }
	      } else if (spec === 'final') {
	        return JustifyContent.__super__.set.apply(this, arguments);
	      }
	    };
	
	    return JustifyContent;
	
	  })(Declaration);
	
	  module.exports = JustifyContent;
	
	}).call(this);


/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, JustifyItems,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(17);
	
	  JustifyItems = (function(superClass) {
	    extend(JustifyItems, superClass);
	
	    function JustifyItems() {
	      return JustifyItems.__super__.constructor.apply(this, arguments);
	    }
	
	    JustifyItems.names = ['justify-items', 'grid-column-align'];
	
	    JustifyItems.prototype.prefixed = function(prop, prefix) {
	      return prefix + (prefix === '-ms-' ? 'grid-column-align' : prop);
	    };
	
	    JustifyItems.prototype.normalize = function(prop) {
	      return 'justify-items';
	    };
	
	    return JustifyItems;
	
	  })(Declaration);
	
	  module.exports = JustifyItems;
	
	}).call(this);


/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, MaskBorder,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(17);
	
	  MaskBorder = (function(superClass) {
	    extend(MaskBorder, superClass);
	
	    function MaskBorder() {
	      return MaskBorder.__super__.constructor.apply(this, arguments);
	    }
	
	    MaskBorder.names = ['mask-border', 'mask-border-source', 'mask-border-slice', 'mask-border-width', 'mask-border-outset', 'mask-border-repeat', 'mask-box-image', 'mask-box-image-source', 'mask-box-image-slice', 'mask-box-image-width', 'mask-box-image-outset', 'mask-box-image-repeat'];
	
	    MaskBorder.prototype.normalize = function() {
	      return this.name.replace('box-image', 'border');
	    };
	
	    MaskBorder.prototype.prefixed = function(prop, prefix) {
	      if (prefix === '-webkit-') {
	        return MaskBorder.__super__.prefixed.apply(this, arguments).replace('border', 'box-image');
	      } else {
	        return MaskBorder.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    return MaskBorder;
	
	  })(Declaration);
	
	  module.exports = MaskBorder;
	
	}).call(this);


/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, Order, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(39);
	
	  Declaration = __webpack_require__(17);
	
	  Order = (function(superClass) {
	    extend(Order, superClass);
	
	    function Order() {
	      return Order.__super__.constructor.apply(this, arguments);
	    }
	
	    Order.names = ['order', 'flex-order', 'box-ordinal-group'];
	
	    Order.prototype.prefixed = function(prop, prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2009) {
	        return prefix + 'box-ordinal-group';
	      } else if (spec === 2012) {
	        return prefix + 'flex-order';
	      } else {
	        return Order.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    Order.prototype.normalize = function(prop) {
	      return 'order';
	    };
	
	    Order.prototype.set = function(decl, prefix) {
	      var spec;
	      spec = flexSpec(prefix)[0];
	      if (spec === 2009 && /\d/.test(decl.value)) {
	        decl.value = (parseInt(decl.value) + 1).toString();
	        return Order.__super__.set.call(this, decl, prefix);
	      } else {
	        return Order.__super__.set.apply(this, arguments);
	      }
	    };
	
	    return Order;
	
	  })(Declaration);
	
	  module.exports = Order;
	
	}).call(this);


/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var OldValue, Pixelated, Value,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  OldValue = __webpack_require__(71);
	
	  Value = __webpack_require__(47);
	
	  Pixelated = (function(superClass) {
	    extend(Pixelated, superClass);
	
	    function Pixelated() {
	      return Pixelated.__super__.constructor.apply(this, arguments);
	    }
	
	    Pixelated.names = ['pixelated'];
	
	    Pixelated.prototype.replace = function(string, prefix) {
	      if (prefix === '-webkit-') {
	        return string.replace(this.regexp(), '$1-webkit-optimize-contrast');
	      } else if (prefix === '-moz-') {
	        return string.replace(this.regexp(), '$1-moz-crisp-edges');
	      } else {
	        return Pixelated.__super__.replace.apply(this, arguments);
	      }
	    };
	
	    Pixelated.prototype.old = function(prefix) {
	      if (prefix === '-webkit-') {
	        return new OldValue(this.name, '-webkit-optimize-contrast');
	      } else if (prefix === '-moz-') {
	        return new OldValue(this.name, '-moz-crisp-edges');
	      } else {
	        return Pixelated.__super__.old.apply(this, arguments);
	      }
	    };
	
	    return Pixelated;
	
	  })(Value);
	
	  module.exports = Pixelated;
	
	}).call(this);


/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Placeholder, Selector,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Selector = __webpack_require__(234);
	
	  Placeholder = (function(superClass) {
	    extend(Placeholder, superClass);
	
	    function Placeholder() {
	      return Placeholder.__super__.constructor.apply(this, arguments);
	    }
	
	    Placeholder.names = [':placeholder-shown', '::placeholder'];
	
	    Placeholder.prototype.possible = function() {
	      return Placeholder.__super__.possible.apply(this, arguments).concat('-moz- old');
	    };
	
	    Placeholder.prototype.prefixed = function(prefix) {
	      if ('-webkit-' === prefix) {
	        return '::-webkit-input-placeholder';
	      } else if ('-ms-' === prefix) {
	        return ':-ms-input-placeholder';
	      } else if ('-moz- old' === prefix) {
	        return ':-moz-placeholder';
	      } else {
	        return "::" + prefix + "placeholder";
	      }
	    };
	
	    return Placeholder;
	
	  })(Selector);
	
	  module.exports = Placeholder;
	
	}).call(this);


/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var OldValue, Stretch, Value,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  OldValue = __webpack_require__(71);
	
	  Value = __webpack_require__(47);
	
	  Stretch = (function(superClass) {
	    extend(Stretch, superClass);
	
	    function Stretch() {
	      return Stretch.__super__.constructor.apply(this, arguments);
	    }
	
	    Stretch.names = ['stretch', 'fill', 'fill-available'];
	
	    Stretch.prototype.replace = function(string, prefix) {
	      if (prefix === '-moz-') {
	        return string.replace(this.regexp(), '$1-moz-available$3');
	      } else if (prefix === '-webkit-') {
	        return string.replace(this.regexp(), '$1-webkit-fill-available$3');
	      } else {
	        return Stretch.__super__.replace.apply(this, arguments);
	      }
	    };
	
	    Stretch.prototype.old = function(prefix) {
	      if (prefix === '-moz-') {
	        return new OldValue(this.name, '-moz-available');
	      } else if (prefix === '-webkit-') {
	        return new OldValue(this.name, '-webkit-fill-available');
	      } else {
	        return Stretch.__super__.old.apply(this, arguments);
	      }
	    };
	
	    return Stretch;
	
	  })(Value);
	
	  module.exports = Stretch;
	
	}).call(this);


/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, TextEmphasisPosition,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(17);
	
	  TextEmphasisPosition = (function(superClass) {
	    extend(TextEmphasisPosition, superClass);
	
	    function TextEmphasisPosition() {
	      return TextEmphasisPosition.__super__.constructor.apply(this, arguments);
	    }
	
	    TextEmphasisPosition.names = ['text-emphasis-position'];
	
	    TextEmphasisPosition.prototype.set = function(decl, prefix) {
	      if (prefix === '-webkit-') {
	        decl.value = decl.value.replace(/\s*(right|left)\s*/i, '');
	        return TextEmphasisPosition.__super__.set.call(this, decl, prefix);
	      } else {
	        return TextEmphasisPosition.__super__.set.apply(this, arguments);
	      }
	    };
	
	    return TextEmphasisPosition;
	
	  })(Declaration);
	
	  module.exports = TextEmphasisPosition;
	
	}).call(this);


/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, TransformDecl,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(17);
	
	  TransformDecl = (function(superClass) {
	    extend(TransformDecl, superClass);
	
	    function TransformDecl() {
	      return TransformDecl.__super__.constructor.apply(this, arguments);
	    }
	
	    TransformDecl.names = ['transform', 'transform-origin'];
	
	    TransformDecl.functions3d = ['matrix3d', 'translate3d', 'translateZ', 'scale3d', 'scaleZ', 'rotate3d', 'rotateX', 'rotateY', 'perspective'];
	
	    TransformDecl.prototype.keyframeParents = function(decl) {
	      var parent;
	      parent = decl.parent;
	      while (parent) {
	        if (parent.type === 'atrule' && parent.name === 'keyframes') {
	          return true;
	        }
	        parent = parent.parent;
	      }
	      return false;
	    };
	
	    TransformDecl.prototype.contain3d = function(decl) {
	      var func, i, len, ref;
	      if (decl.prop === 'transform-origin') {
	        return false;
	      }
	      ref = TransformDecl.functions3d;
	      for (i = 0, len = ref.length; i < len; i++) {
	        func = ref[i];
	        if (decl.value.indexOf(func + "(") !== -1) {
	          return true;
	        }
	      }
	      return false;
	    };
	
	    TransformDecl.prototype.set = function(decl, prefix) {
	      decl = TransformDecl.__super__.set.apply(this, arguments);
	      if (prefix === '-ms-') {
	        decl.value = decl.value.replace(/rotateZ/gi, 'rotate');
	      }
	      return decl;
	    };
	
	    TransformDecl.prototype.insert = function(decl, prefix, prefixes) {
	      if (prefix === '-ms-') {
	        if (!this.contain3d(decl) && !this.keyframeParents(decl)) {
	          return TransformDecl.__super__.insert.apply(this, arguments);
	        }
	      } else if (prefix === '-o-') {
	        if (!this.contain3d(decl)) {
	          return TransformDecl.__super__.insert.apply(this, arguments);
	        }
	      } else {
	        return TransformDecl.__super__.insert.apply(this, arguments);
	      }
	    };
	
	    return TransformDecl;
	
	  })(Declaration);
	
	  module.exports = TransformDecl;
	
	}).call(this);


/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, WritingMode,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(17);
	
	  WritingMode = (function(superClass) {
	    extend(WritingMode, superClass);
	
	    function WritingMode() {
	      return WritingMode.__super__.constructor.apply(this, arguments);
	    }
	
	    WritingMode.names = ['writing-mode'];
	
	    WritingMode.msValues = {
	      'horizontal-tb': 'lr-tb',
	      'vertical-rl': 'tb-rl',
	      'vertical-lr': 'tb-lr'
	    };
	
	    WritingMode.prototype.set = function(decl, prefix) {
	      if (prefix === '-ms-') {
	        decl.value = WritingMode.msValues[decl.value] || decl.value;
	        return WritingMode.__super__.set.call(this, decl, prefix);
	      } else {
	        return WritingMode.__super__.set.apply(this, arguments);
	      }
	    };
	
	    return WritingMode;
	
	  })(Declaration);
	
	  module.exports = WritingMode;
	
	}).call(this);


/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var browserslist, capitalize, names, prefix;
	
	  browserslist = __webpack_require__(240);
	
	  capitalize = function(str) {
	    return str.slice(0, 1).toUpperCase() + str.slice(1);
	  };
	
	  names = {
	    ie: 'IE',
	    ie_mob: 'IE Mobile',
	    ios_saf: 'iOS',
	    op_mini: 'Opera Mini',
	    op_mob: 'Opera Mobile',
	    and_chr: 'Chrome for Android',
	    and_ff: 'Firefox for Android',
	    and_uc: 'UC for Android'
	  };
	
	  prefix = function(name, prefixes) {
	    var out;
	    out = '  ' + name + ': ';
	    out += prefixes.map(function(i) {
	      return i.replace(/^-(.*)-$/g, '$1');
	    }).join(', ');
	    out += "\n";
	    return out;
	  };
	
	  module.exports = function(prefixes) {
	    var atrules, browser, coverage, data, j, k, l, len, len1, len2, list, name, out, props, ref, ref1, ref2, ref3, ref4, ref5, round, selector, selectors, string, value, values, version, versions;
	    if (prefixes.browsers.selected.length === 0) {
	      return "No browsers selected";
	    }
	    versions = [];
	    ref = prefixes.browsers.selected;
	    for (j = 0, len = ref.length; j < len; j++) {
	      browser = ref[j];
	      ref1 = browser.split(' '), name = ref1[0], version = ref1[1];
	      name = names[name] || capitalize(name);
	      if (versions[name]) {
	        versions[name].push(version);
	      } else {
	        versions[name] = [version];
	      }
	    }
	    out = "Browsers:\n";
	    for (browser in versions) {
	      list = versions[browser];
	      list = list.sort(function(a, b) {
	        return parseFloat(b) - parseFloat(a);
	      });
	      out += '  ' + browser + ': ' + list.join(', ') + "\n";
	    }
	    coverage = browserslist.coverage(prefixes.browsers.selected);
	    round = Math.round(coverage * 100) / 100.0;
	    out += "\nThese browsers account for " + round + "% of all users globally\n";
	    atrules = '';
	    ref2 = prefixes.add;
	    for (name in ref2) {
	      data = ref2[name];
	      if (name[0] === '@' && data.prefixes) {
	        atrules += prefix(name, data.prefixes);
	      }
	    }
	    if (atrules !== '') {
	      out += "\nAt-Rules:\n" + atrules;
	    }
	    selectors = '';
	    ref3 = prefixes.add.selectors;
	    for (k = 0, len1 = ref3.length; k < len1; k++) {
	      selector = ref3[k];
	      if (selector.prefixes) {
	        selectors += prefix(selector.name, selector.prefixes);
	      }
	    }
	    if (selectors !== '') {
	      out += "\nSelectors:\n" + selectors;
	    }
	    values = '';
	    props = '';
	    ref4 = prefixes.add;
	    for (name in ref4) {
	      data = ref4[name];
	      if (name[0] !== '@' && data.prefixes) {
	        props += prefix(name, data.prefixes);
	      }
	      if (!data.values) {
	        continue;
	      }
	      ref5 = data.values;
	      for (l = 0, len2 = ref5.length; l < len2; l++) {
	        value = ref5[l];
	        string = prefix(value.name, value.prefixes);
	        if (values.indexOf(string) === -1) {
	          values += string;
	        }
	      }
	    }
	    if (props !== '') {
	      out += "\nProperties:\n" + props;
	    }
	    if (values !== '') {
	      out += "\nValues:\n" + values;
	    }
	    if (atrules === '' && selectors === '' && props === '' && values === '') {
	      out += '\nAwesome! Your browsers don\'t require any vendor prefixes.' + '\nNow you can remove Autoprefixer from build steps.';
	    }
	    return out;
	  };
	
	}).call(this);


/***/ },
/* 601 */
/***/ function(module, exports) {

	(function() {
	  var OldSelector;
	
	  OldSelector = (function() {
	    function OldSelector(selector, prefix1) {
	      var i, len, prefix, ref;
	      this.prefix = prefix1;
	      this.prefixed = selector.prefixed(this.prefix);
	      this.regexp = selector.regexp(this.prefix);
	      this.prefixeds = [];
	      ref = selector.possible();
	      for (i = 0, len = ref.length; i < len; i++) {
	        prefix = ref[i];
	        this.prefixeds.push([selector.prefixed(prefix), selector.regexp(prefix)]);
	      }
	      this.unprefixed = selector.name;
	      this.nameRegexp = selector.regexp();
	    }
	
	    OldSelector.prototype.isHack = function(rule) {
	      var before, i, index, len, ref, ref1, regexp, rules, some, string;
	      index = rule.parent.index(rule) + 1;
	      rules = rule.parent.nodes;
	      while (index < rules.length) {
	        before = rules[index].selector;
	        if (!before) {
	          return true;
	        }
	        if (before.indexOf(this.unprefixed) !== -1 && before.match(this.nameRegexp)) {
	          return false;
	        }
	        some = false;
	        ref = this.prefixeds;
	        for (i = 0, len = ref.length; i < len; i++) {
	          ref1 = ref[i], string = ref1[0], regexp = ref1[1];
	          if (before.indexOf(string) !== -1 && before.match(regexp)) {
	            some = true;
	            break;
	          }
	        }
	        if (!some) {
	          return true;
	        }
	        index += 1;
	      }
	      return true;
	    };
	
	    OldSelector.prototype.check = function(rule) {
	      if (rule.selector.indexOf(this.prefixed) === -1) {
	        return false;
	      }
	      if (!rule.selector.match(this.regexp)) {
	        return false;
	      }
	      if (this.isHack(rule)) {
	        return false;
	      }
	      return true;
	    };
	
	    return OldSelector;
	
	  })();
	
	  module.exports = OldSelector;
	
	}).call(this);


/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var AtRule, Browsers, Declaration, Prefixes, Processor, Resolution, Selector, Supports, Transition, Value, declsCache, utils, vendor;
	
	  Declaration = __webpack_require__(17);
	
	  Resolution = __webpack_require__(604);
	
	  Transition = __webpack_require__(606);
	
	  Processor = __webpack_require__(603);
	
	  Supports = __webpack_require__(605);
	
	  Browsers = __webpack_require__(116);
	
	  Selector = __webpack_require__(234);
	
	  AtRule = __webpack_require__(558);
	
	  Value = __webpack_require__(47);
	
	  utils = __webpack_require__(41);
	
	  vendor = __webpack_require__(130);
	
	  Selector.hack(__webpack_require__(581));
	
	  Selector.hack(__webpack_require__(595));
	
	  Declaration.hack(__webpack_require__(580));
	
	  Declaration.hack(__webpack_require__(593));
	
	  Declaration.hack(__webpack_require__(572));
	
	  Declaration.hack(__webpack_require__(583));
	
	  Declaration.hack(__webpack_require__(575));
	
	  Declaration.hack(__webpack_require__(576));
	
	  Declaration.hack(__webpack_require__(579));
	
	  Declaration.hack(__webpack_require__(585));
	
	  Declaration.hack(__webpack_require__(562));
	
	  Declaration.hack(__webpack_require__(573));
	
	  Declaration.hack(__webpack_require__(592));
	
	  Declaration.hack(__webpack_require__(561));
	
	  Declaration.hack(__webpack_require__(577));
	
	  Declaration.hack(__webpack_require__(567));
	
	  Declaration.hack(__webpack_require__(599));
	
	  Declaration.hack(__webpack_require__(565));
	
	  Declaration.hack(__webpack_require__(591));
	
	  Declaration.hack(__webpack_require__(560));
	
	  Declaration.hack(__webpack_require__(566));
	
	  Declaration.hack(__webpack_require__(564));
	
	  Declaration.hack(__webpack_require__(586));
	
	  Declaration.hack(__webpack_require__(589));
	
	  Declaration.hack(__webpack_require__(584));
	
	  Declaration.hack(__webpack_require__(598));
	
	  Declaration.hack(__webpack_require__(574));
	
	  Declaration.hack(__webpack_require__(587));
	
	  Declaration.hack(__webpack_require__(590));
	
	  Declaration.hack(__webpack_require__(563));
	
	  Declaration.hack(__webpack_require__(597));
	
	  Value.hack(__webpack_require__(596));
	
	  Value.hack(__webpack_require__(582));
	
	  Value.hack(__webpack_require__(594));
	
	  Value.hack(__webpack_require__(588));
	
	  Value.hack(__webpack_require__(568));
	
	  Value.hack(__webpack_require__(578));
	
	  Value.hack(__webpack_require__(569));
	
	  Value.hack(__webpack_require__(570));
	
	  Value.hack(__webpack_require__(571));
	
	  declsCache = {};
	
	  Prefixes = (function() {
	    function Prefixes(data1, browsers, options) {
	      var ref;
	      this.data = data1;
	      this.browsers = browsers;
	      this.options = options != null ? options : {};
	      ref = this.preprocess(this.select(this.data)), this.add = ref[0], this.remove = ref[1];
	      this.transition = new Transition(this);
	      this.processor = new Processor(this);
	    }
	
	    Prefixes.prototype.cleaner = function() {
	      var empty;
	      if (!this.cleanerCache) {
	        if (this.browsers.selected.length) {
	          empty = new Browsers(this.browsers.data, []);
	          this.cleanerCache = new Prefixes(this.data, empty, this.options);
	        } else {
	          return this;
	        }
	      }
	      return this.cleanerCache;
	    };
	
	    Prefixes.prototype.select = function(list) {
	      var add, all, data, name, notes, selected;
	      selected = {
	        add: {},
	        remove: {}
	      };
	      for (name in list) {
	        data = list[name];
	        add = data.browsers.map(function(i) {
	          var params;
	          params = i.split(' ');
	          return {
	            browser: params[0] + ' ' + params[1],
	            note: params[2]
	          };
	        });
	        notes = add.filter(function(i) {
	          return i.note;
	        }).map((function(_this) {
	          return function(i) {
	            return _this.browsers.prefix(i.browser) + ' ' + i.note;
	          };
	        })(this));
	        notes = utils.uniq(notes);
	        add = add.filter((function(_this) {
	          return function(i) {
	            return _this.browsers.isSelected(i.browser);
	          };
	        })(this)).map((function(_this) {
	          return function(i) {
	            var prefix;
	            prefix = _this.browsers.prefix(i.browser);
	            if (i.note) {
	              return prefix + ' ' + i.note;
	            } else {
	              return prefix;
	            }
	          };
	        })(this));
	        add = this.sort(utils.uniq(add));
	        if (this.options.flexbox === 'no-2009') {
	          add = add.filter(function(i) {
	            return i.indexOf('2009') === -1;
	          });
	        }
	        all = data.browsers.map((function(_this) {
	          return function(i) {
	            return _this.browsers.prefix(i);
	          };
	        })(this));
	        if (data.mistakes) {
	          all = all.concat(data.mistakes);
	        }
	        all = all.concat(notes);
	        all = utils.uniq(all);
	        if (add.length) {
	          selected.add[name] = add;
	          if (add.length < all.length) {
	            selected.remove[name] = all.filter(function(i) {
	              return add.indexOf(i) === -1;
	            });
	          }
	        } else {
	          selected.remove[name] = all;
	        }
	      }
	      return selected;
	    };
	
	    Prefixes.prototype.sort = function(prefixes) {
	      return prefixes.sort(function(a, b) {
	        var aLength, bLength;
	        aLength = utils.removeNote(a).length;
	        bLength = utils.removeNote(b).length;
	        if (aLength === bLength) {
	          return b.length - a.length;
	        } else {
	          return bLength - aLength;
	        }
	      });
	    };
	
	    Prefixes.prototype.preprocess = function(selected) {
	      var a, add, j, k, l, len, len1, len2, len3, len4, len5, len6, m, n, name, o, old, olds, p, prefix, prefixed, prefixes, prop, props, ref, ref1, ref2, ref3, remove, selector, value, values;
	      add = {
	        selectors: [],
	        '@supports': new Supports(Prefixes, this)
	      };
	      ref = selected.add;
	      for (name in ref) {
	        prefixes = ref[name];
	        if (name === '@keyframes' || name === '@viewport') {
	          add[name] = new AtRule(name, prefixes, this);
	        } else if (name === '@resolution') {
	          add[name] = new Resolution(name, prefixes, this);
	        } else if (this.data[name].selector) {
	          add.selectors.push(Selector.load(name, prefixes, this));
	        } else {
	          props = this.data[name].props;
	          if (props) {
	            value = Value.load(name, prefixes, this);
	            for (j = 0, len = props.length; j < len; j++) {
	              prop = props[j];
	              if (!add[prop]) {
	                add[prop] = {
	                  values: []
	                };
	              }
	              add[prop].values.push(value);
	            }
	          } else {
	            values = ((ref1 = add[name]) != null ? ref1.values : void 0) || [];
	            add[name] = Declaration.load(name, prefixes, this);
	            add[name].values = values;
	          }
	        }
	      }
	      remove = {
	        selectors: []
	      };
	      ref2 = selected.remove;
	      for (name in ref2) {
	        prefixes = ref2[name];
	        if (this.data[name].selector) {
	          selector = Selector.load(name, prefixes);
	          for (k = 0, len1 = prefixes.length; k < len1; k++) {
	            prefix = prefixes[k];
	            remove.selectors.push(selector.old(prefix));
	          }
	        } else if (name === '@keyframes' || name === '@viewport') {
	          for (l = 0, len2 = prefixes.length; l < len2; l++) {
	            prefix = prefixes[l];
	            prefixed = '@' + prefix + name.slice(1);
	            remove[prefixed] = {
	              remove: true
	            };
	          }
	        } else if (name === '@resolution') {
	          remove[name] = new Resolution(name, prefixes, this);
	        } else {
	          props = this.data[name].props;
	          if (props) {
	            value = Value.load(name, [], this);
	            for (m = 0, len3 = prefixes.length; m < len3; m++) {
	              prefix = prefixes[m];
	              old = value.old(prefix);
	              if (old) {
	                for (n = 0, len4 = props.length; n < len4; n++) {
	                  prop = props[n];
	                  if (!remove[prop]) {
	                    remove[prop] = {};
	                  }
	                  if (!remove[prop].values) {
	                    remove[prop].values = [];
	                  }
	                  remove[prop].values.push(old);
	                }
	              }
	            }
	          } else {
	            for (o = 0, len5 = prefixes.length; o < len5; o++) {
	              prefix = prefixes[o];
	              prop = vendor.unprefixed(name);
	              olds = this.decl(name).old(name, prefix);
	              if (name === 'align-self') {
	                a = (ref3 = add[name]) != null ? ref3.prefixes : void 0;
	                if (a) {
	                  if (prefix === '-webkit- 2009' && a.indexOf('-webkit-') !== -1) {
	                    continue;
	                  } else if (prefix === '-webkit-' && a.indexOf('-webkit- 2009') !== -1) {
	                    continue;
	                  }
	                }
	              }
	              for (p = 0, len6 = olds.length; p < len6; p++) {
	                prefixed = olds[p];
	                if (!remove[prefixed]) {
	                  remove[prefixed] = {};
	                }
	                remove[prefixed].remove = true;
	              }
	            }
	          }
	        }
	      }
	      return [add, remove];
	    };
	
	    Prefixes.prototype.decl = function(prop) {
	      var decl;
	      decl = declsCache[prop];
	      if (decl) {
	        return decl;
	      } else {
	        return declsCache[prop] = Declaration.load(prop);
	      }
	    };
	
	    Prefixes.prototype.unprefixed = function(prop) {
	      var value;
	      value = this.normalize(vendor.unprefixed(prop));
	      if (value === 'flex-direction') {
	        value = 'flex-flow';
	      }
	      return value;
	    };
	
	    Prefixes.prototype.normalize = function(prop) {
	      return this.decl(prop).normalize(prop);
	    };
	
	    Prefixes.prototype.prefixed = function(prop, prefix) {
	      prop = vendor.unprefixed(prop);
	      return this.decl(prop).prefixed(prop, prefix);
	    };
	
	    Prefixes.prototype.values = function(type, prop) {
	      var data, global, ref, ref1, values;
	      data = this[type];
	      global = (ref = data['*']) != null ? ref.values : void 0;
	      values = (ref1 = data[prop]) != null ? ref1.values : void 0;
	      if (global && values) {
	        return utils.uniq(global.concat(values));
	      } else {
	        return global || values || [];
	      }
	    };
	
	    Prefixes.prototype.group = function(decl) {
	      var checker, index, length, rule, unprefixed;
	      rule = decl.parent;
	      index = rule.index(decl);
	      length = rule.nodes.length;
	      unprefixed = this.unprefixed(decl.prop);
	      checker = (function(_this) {
	        return function(step, callback) {
	          var other;
	          index += step;
	          while (index >= 0 && index < length) {
	            other = rule.nodes[index];
	            if (other.type === 'decl') {
	              if (step === -1 && other.prop === unprefixed) {
	                if (!Browsers.withPrefix(other.value)) {
	                  break;
	                }
	              }
	              if (_this.unprefixed(other.prop) !== unprefixed) {
	                break;
	              } else if (callback(other) === true) {
	                return true;
	              }
	              if (step === +1 && other.prop === unprefixed) {
	                if (!Browsers.withPrefix(other.value)) {
	                  break;
	                }
	              }
	            }
	            index += step;
	          }
	          return false;
	        };
	      })(this);
	      return {
	        up: function(callback) {
	          return checker(-1, callback);
	        },
	        down: function(callback) {
	          return checker(+1, callback);
	        }
	      };
	    };
	
	    return Prefixes;
	
	  })();
	
	  module.exports = Prefixes;
	
	}).call(this);


/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var OLD_DIRECTION, Processor, SIZES, Value, utils, vendor;
	
	  vendor = __webpack_require__(130);
	
	  Value = __webpack_require__(47);
	
	  utils = __webpack_require__(41);
	
	  OLD_DIRECTION = /(^|[^-])(linear|radial)-gradient\(\s*(top|left|right|bottom)/i;
	
	  SIZES = ['width', 'height', 'min-width', 'max-width', 'min-height', 'max-height', 'inline-size', 'min-inline-size', 'max-inline-size', 'block-size', 'min-block-size', 'max-block-size'];
	
	  Processor = (function() {
	    function Processor(prefixes) {
	      this.prefixes = prefixes;
	    }
	
	    Processor.prototype.add = function(css, result) {
	      var keyframes, resolution, supports, viewport;
	      resolution = this.prefixes.add['@resolution'];
	      keyframes = this.prefixes.add['@keyframes'];
	      viewport = this.prefixes.add['@viewport'];
	      supports = this.prefixes.add['@supports'];
	      css.walkAtRules((function(_this) {
	        return function(rule) {
	          if (rule.name === 'keyframes') {
	            if (!_this.disabled(rule)) {
	              return keyframes != null ? keyframes.process(rule) : void 0;
	            }
	          } else if (rule.name === 'viewport') {
	            if (!_this.disabled(rule)) {
	              return viewport != null ? viewport.process(rule) : void 0;
	            }
	          } else if (rule.name === 'supports') {
	            if (_this.prefixes.options.supports !== false && !_this.disabled(rule)) {
	              return supports.process(rule);
	            }
	          } else if (rule.name === 'media' && rule.params.indexOf('-resolution') !== -1) {
	            if (!_this.disabled(rule)) {
	              return resolution != null ? resolution.process(rule) : void 0;
	            }
	          }
	        };
	      })(this));
	      css.walkRules((function(_this) {
	        return function(rule) {
	          var j, len, ref, results, selector;
	          if (_this.disabled(rule)) {
	            return;
	          }
	          ref = _this.prefixes.add.selectors;
	          results = [];
	          for (j = 0, len = ref.length; j < len; j++) {
	            selector = ref[j];
	            results.push(selector.process(rule, result));
	          }
	          return results;
	        };
	      })(this));
	      css.walkDecls((function(_this) {
	        return function(decl) {
	          var display, prefixer;
	          if (_this.disabled(decl)) {
	            return;
	          }
	          if (decl.prop === 'display' && decl.value === 'box') {
	            result.warn('You should write display: flex by final spec ' + 'instead of display: box', {
	              node: decl
	            });
	            return;
	          }
	          if (decl.value.indexOf('linear-gradient') !== -1) {
	            if (OLD_DIRECTION.test(decl.value)) {
	              result.warn('Gradient has outdated direction syntax. ' + 'New syntax is like `to left` instead of `right`.', {
	                node: decl
	              });
	            }
	          }
	          if (decl.prop === 'text-emphasis-position') {
	            if (decl.value === 'under' || decl.value === 'over') {
	              result.warn('You should use 2 values for text-emphasis-position ' + 'For example, `under left` instead of just `under`.', {
	                node: decl
	              });
	            }
	          }
	          if (SIZES.indexOf(decl.prop) !== -1) {
	            if (decl.value.indexOf('fill-available') !== -1) {
	              result.warn('Replace fill-available to stretch, ' + 'because spec had been changed', {
	                node: decl
	              });
	            } else if (decl.value.indexOf('fill') !== -1) {
	              result.warn('Replace fill to stretch, because spec had been changed', {
	                node: decl
	              });
	            }
	          }
	          if (_this.prefixes.options.flexbox !== false) {
	            if (decl.prop === 'grid-row-end' && decl.value.indexOf('span') === -1) {
	              result.warn('IE supports only grid-row-end with span. ' + 'You should add grid: false option to Autoprefixer ' + 'and use some JS grid polyfill for full spec support', {
	                node: decl
	              });
	            }
	            if (decl.prop === 'grid-row') {
	              if (decl.value.indexOf('/') !== -1 && decl.value.indexOf('span') === -1) {
	                result.warn('IE supports only grid-row with / and span. ' + 'You should add grid: false option to Autoprefixer ' + 'and use some JS grid polyfill for full spec support', {
	                  node: decl
	                });
	              }
	            }
	          }
	          if (decl.prop === 'transition' || decl.prop === 'transition-property') {
	            return _this.prefixes.transition.add(decl, result);
	          } else if (decl.prop === 'align-self') {
	            display = _this.displayType(decl);
	            if (display !== 'grid' && _this.prefixes.options.flexbox !== false) {
	              prefixer = _this.prefixes.add['align-self'];
	              if (prefixer && prefixer.prefixes) {
	                prefixer.process(decl);
	              }
	            }
	            if (display !== 'flex' && _this.prefixes.options.grid !== false) {
	              prefixer = _this.prefixes.add['grid-row-align'];
	              if (prefixer && prefixer.prefixes) {
	                return prefixer.process(decl);
	              }
	            }
	          } else {
	            prefixer = _this.prefixes.add[decl.prop];
	            if (prefixer && prefixer.prefixes) {
	              return prefixer.process(decl);
	            }
	          }
	        };
	      })(this));
	      return css.walkDecls((function(_this) {
	        return function(decl) {
	          var j, len, ref, unprefixed, value;
	          if (_this.disabled(decl)) {
	            return;
	          }
	          unprefixed = _this.prefixes.unprefixed(decl.prop);
	          ref = _this.prefixes.values('add', unprefixed);
	          for (j = 0, len = ref.length; j < len; j++) {
	            value = ref[j];
	            value.process(decl, result);
	          }
	          return Value.save(_this.prefixes, decl);
	        };
	      })(this));
	    };
	
	    Processor.prototype.remove = function(css) {
	      var checker, j, len, ref, resolution;
	      resolution = this.prefixes.remove['@resolution'];
	      css.walkAtRules((function(_this) {
	        return function(rule, i) {
	          if (_this.prefixes.remove['@' + rule.name]) {
	            if (!_this.disabled(rule)) {
	              return rule.parent.removeChild(i);
	            }
	          } else if (rule.name === 'media' && rule.params.indexOf('-resolution') !== -1) {
	            return resolution != null ? resolution.clean(rule) : void 0;
	          }
	        };
	      })(this));
	      ref = this.prefixes.remove.selectors;
	      for (j = 0, len = ref.length; j < len; j++) {
	        checker = ref[j];
	        css.walkRules((function(_this) {
	          return function(rule, i) {
	            if (checker.check(rule)) {
	              if (!_this.disabled(rule)) {
	                return rule.parent.removeChild(i);
	              }
	            }
	          };
	        })(this));
	      }
	      return css.walkDecls((function(_this) {
	        return function(decl, i) {
	          var k, len1, notHack, ref1, ref2, rule, unprefixed;
	          if (_this.disabled(decl)) {
	            return;
	          }
	          rule = decl.parent;
	          unprefixed = _this.prefixes.unprefixed(decl.prop);
	          if (decl.prop === 'transition' || decl.prop === 'transition-property') {
	            _this.prefixes.transition.remove(decl);
	          }
	          if ((ref1 = _this.prefixes.remove[decl.prop]) != null ? ref1.remove : void 0) {
	            notHack = _this.prefixes.group(decl).down(function(other) {
	              return _this.prefixes.normalize(other.prop) === unprefixed;
	            });
	            if (unprefixed === 'flex-flow') {
	              notHack = true;
	            }
	            if (notHack && !_this.withHackValue(decl)) {
	              if (decl.raw('before').indexOf("\n") > -1) {
	                _this.reduceSpaces(decl);
	              }
	              rule.removeChild(i);
	              return;
	            }
	          }
	          ref2 = _this.prefixes.values('remove', unprefixed);
	          for (k = 0, len1 = ref2.length; k < len1; k++) {
	            checker = ref2[k];
	            if (checker.check(decl.value)) {
	              unprefixed = checker.unprefixed;
	              notHack = _this.prefixes.group(decl).down(function(other) {
	                return other.value.indexOf(unprefixed) !== -1;
	              });
	              if (notHack) {
	                rule.removeChild(i);
	                return;
	              } else if (checker.clean) {
	                checker.clean(decl);
	                return;
	              }
	            }
	          }
	        };
	      })(this));
	    };
	
	    Processor.prototype.withHackValue = function(decl) {
	      return decl.prop === '-webkit-background-clip' && decl.value === 'text';
	    };
	
	    Processor.prototype.disabled = function(node) {
	      var other, status;
	      if (this.prefixes.options.grid === false && node.type === 'decl') {
	        if (node.prop === 'display' && node.value.indexOf('grid') !== -1) {
	          return true;
	        }
	        if (node.prop.indexOf('grid') !== -1 || node.prop === 'justify-items') {
	          return true;
	        }
	      }
	      if (this.prefixes.options.flexbox === false && node.type === 'decl') {
	        if (node.prop === 'display' && node.value.indexOf('flex') !== -1) {
	          return true;
	        }
	        other = ['order', 'justify-content', 'align-items', 'align-content'];
	        if (node.prop.indexOf('flex') !== -1 || other.indexOf(node.prop) !== -1) {
	          return true;
	        }
	      }
	      if (node._autoprefixerDisabled != null) {
	        return node._autoprefixerDisabled;
	      } else if (node.nodes) {
	        status = void 0;
	        node.each(function(i) {
	          if (i.type !== 'comment') {
	            return;
	          }
	          if (/(!\s*)?autoprefixer:\s*off/i.test(i.text)) {
	            status = false;
	            return false;
	          } else if (/(!\s*)?autoprefixer:\s*on/i.test(i.text)) {
	            status = true;
	            return false;
	          }
	        });
	        return node._autoprefixerDisabled = status != null ? !status : node.parent ? this.disabled(node.parent) : false;
	      } else if (node.parent) {
	        return node._autoprefixerDisabled = this.disabled(node.parent);
	      } else {
	        return false;
	      }
	    };
	
	    Processor.prototype.reduceSpaces = function(decl) {
	      var diff, parts, prevMin, stop;
	      stop = false;
	      this.prefixes.group(decl).up(function(other) {
	        return stop = true;
	      });
	      if (stop) {
	        return;
	      }
	      parts = decl.raw('before').split("\n");
	      prevMin = parts[parts.length - 1].length;
	      diff = false;
	      return this.prefixes.group(decl).down(function(other) {
	        var last;
	        parts = other.raw('before').split("\n");
	        last = parts.length - 1;
	        if (parts[last].length > prevMin) {
	          if (diff === false) {
	            diff = parts[last].length - prevMin;
	          }
	          parts[last] = parts[last].slice(0, -diff);
	          return other.raws.before = parts.join("\n");
	        }
	      });
	    };
	
	    Processor.prototype.displayType = function(decl) {
	      var i, j, len, ref;
	      ref = decl.parent.nodes;
	      for (j = 0, len = ref.length; j < len; j++) {
	        i = ref[j];
	        if (i.prop === 'display') {
	          if (i.value.indexOf('flex') !== -1) {
	            return 'flex';
	          } else if (i.value.indexOf('grid') !== -1) {
	            return 'grid';
	          }
	        }
	      }
	      return false;
	    };
	
	    return Processor;
	
	  })();
	
	  module.exports = Processor;
	
	}).call(this);


/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Prefixer, Resolution, n2f, regexp, split, utils,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Prefixer = __webpack_require__(139);
	
	  utils = __webpack_require__(41);
	
	  n2f = __webpack_require__(1469);
	
	  regexp = /(min|max)-resolution\s*:\s*\d*\.?\d+(dppx|dpi)/gi;
	
	  split = /(min|max)-resolution(\s*:\s*)(\d*\.?\d+)(dppx|dpi)/i;
	
	  Resolution = (function(superClass) {
	    extend(Resolution, superClass);
	
	    function Resolution() {
	      return Resolution.__super__.constructor.apply(this, arguments);
	    }
	
	    Resolution.prototype.prefixName = function(prefix, name) {
	      return name = prefix === '-moz-' ? name + '--moz-device-pixel-ratio' : prefix + name + '-device-pixel-ratio';
	    };
	
	    Resolution.prototype.prefixQuery = function(prefix, name, colon, value, units) {
	      if (units === 'dpi') {
	        value = Number(value / 96);
	      }
	      if (prefix === '-o-') {
	        value = n2f(value);
	      }
	      return this.prefixName(prefix, name) + colon + value;
	    };
	
	    Resolution.prototype.clean = function(rule) {
	      var j, len, prefix, ref;
	      if (!this.bad) {
	        this.bad = [];
	        ref = this.prefixes;
	        for (j = 0, len = ref.length; j < len; j++) {
	          prefix = ref[j];
	          this.bad.push(this.prefixName(prefix, 'min'));
	          this.bad.push(this.prefixName(prefix, 'max'));
	        }
	      }
	      return rule.params = utils.editList(rule.params, (function(_this) {
	        return function(queries) {
	          return queries.filter(function(query) {
	            return _this.bad.every(function(i) {
	              return query.indexOf(i) === -1;
	            });
	          });
	        };
	      })(this));
	    };
	
	    Resolution.prototype.process = function(rule) {
	      var parent, prefixes;
	      parent = this.parentPrefix(rule);
	      prefixes = parent ? [parent] : this.prefixes;
	      return rule.params = utils.editList(rule.params, (function(_this) {
	        return function(origin, prefixed) {
	          var j, k, len, len1, prefix, processed, query;
	          for (j = 0, len = origin.length; j < len; j++) {
	            query = origin[j];
	            if (query.indexOf('min-resolution') === -1 && query.indexOf('max-resolution') === -1) {
	              prefixed.push(query);
	              continue;
	            }
	            for (k = 0, len1 = prefixes.length; k < len1; k++) {
	              prefix = prefixes[k];
	              if (prefix === '-moz-' && rule.params.indexOf('dpi') !== -1) {
	                continue;
	              } else {
	                processed = query.replace(regexp, function(str) {
	                  var parts;
	                  parts = str.match(split);
	                  return _this.prefixQuery(prefix, parts[1], parts[2], parts[3], parts[4]);
	                });
	                prefixed.push(processed);
	              }
	            }
	            prefixed.push(query);
	          }
	          return utils.uniq(prefixed);
	        };
	      })(this));
	    };
	
	    return Resolution;
	
	  })(Prefixer);
	
	  module.exports = Resolution;
	
	}).call(this);


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Browsers, Supports, Value, brackets, browser, data, postcss, ref, support, supported, utils, version, versions;
	
	  Browsers = __webpack_require__(116);
	
	  brackets = __webpack_require__(559);
	
	  Value = __webpack_require__(47);
	
	  utils = __webpack_require__(41);
	
	  postcss = __webpack_require__(169);
	
	  supported = [];
	
	  data = __webpack_require__(1112);
	
	  ref = data.stats;
	  for (browser in ref) {
	    versions = ref[browser];
	    for (version in versions) {
	      support = versions[version];
	      if (/y/.test(support)) {
	        supported.push(browser + ' ' + version);
	      }
	    }
	  }
	
	  Supports = (function() {
	    function Supports(Prefixes, all1) {
	      this.Prefixes = Prefixes;
	      this.all = all1;
	    }
	
	    Supports.prototype.prefixer = function() {
	      var browsers, filtered;
	      if (this.prefixerCache) {
	        return this.prefixerCache;
	      }
	      filtered = this.all.browsers.selected.filter((function(_this) {
	        return function(i) {
	          return supported.indexOf(i) !== -1;
	        };
	      })(this));
	      browsers = new Browsers(this.all.browsers.data, filtered, this.all.options);
	      return this.prefixerCache = new this.Prefixes(this.all.data, browsers, this.all.options);
	    };
	
	    Supports.prototype.parse = function(str) {
	      var prop, ref1, value;
	      ref1 = str.split(':'), prop = ref1[0], value = ref1[1];
	      value || (value = '');
	      return [prop.trim(), value.trim()];
	    };
	
	    Supports.prototype.virtual = function(str) {
	      var prop, ref1, rule, value;
	      ref1 = this.parse(str), prop = ref1[0], value = ref1[1];
	      rule = postcss.parse('a{}').first;
	      rule.append({
	        prop: prop,
	        value: value,
	        raws: {
	          before: ''
	        }
	      });
	      return rule;
	    };
	
	    Supports.prototype.prefixed = function(str) {
	      var decl, j, k, len, len1, prefixer, ref1, ref2, rule, value;
	      rule = this.virtual(str);
	      if (this.disabled(rule.first)) {
	        return rule.nodes;
	      }
	      prefixer = this.prefixer().add[rule.first.prop];
	      if (prefixer != null) {
	        if (typeof prefixer.process === "function") {
	          prefixer.process(rule.first);
	        }
	      }
	      ref1 = rule.nodes;
	      for (j = 0, len = ref1.length; j < len; j++) {
	        decl = ref1[j];
	        ref2 = this.prefixer().values('add', rule.first.prop);
	        for (k = 0, len1 = ref2.length; k < len1; k++) {
	          value = ref2[k];
	          value.process(decl);
	        }
	        Value.save(this.all, decl);
	      }
	      return rule.nodes;
	    };
	
	    Supports.prototype.isNot = function(node) {
	      return typeof node === 'string' && /not\s*/i.test(node);
	    };
	
	    Supports.prototype.isOr = function(node) {
	      return typeof node === 'string' && /\s*or\s*/i.test(node);
	    };
	
	    Supports.prototype.isProp = function(node) {
	      return typeof node === 'object' && node.length === 1 && typeof node[0] === 'string';
	    };
	
	    Supports.prototype.isHack = function(all, unprefixed) {
	      var check;
	      check = new RegExp('(\\(|\\s)' + utils.escapeRegexp(unprefixed) + ':');
	      return !check.test(all);
	    };
	
	    Supports.prototype.toRemove = function(str, all) {
	      var checker, j, len, prop, ref1, ref2, ref3, unprefixed, value;
	      ref1 = this.parse(str), prop = ref1[0], value = ref1[1];
	      unprefixed = this.all.unprefixed(prop);
	      if (((ref2 = this.all.cleaner().remove[prop]) != null ? ref2.remove : void 0) && !this.isHack(all, unprefixed)) {
	        return true;
	      }
	      ref3 = this.all.cleaner().values('remove', unprefixed);
	      for (j = 0, len = ref3.length; j < len; j++) {
	        checker = ref3[j];
	        if (checker.check(value)) {
	          return true;
	        }
	      }
	      return false;
	    };
	
	    Supports.prototype.remove = function(nodes, all) {
	      var i;
	      i = 0;
	      while (i < nodes.length) {
	        if (!this.isNot(nodes[i - 1]) && this.isProp(nodes[i]) && this.isOr(nodes[i + 1])) {
	          if (this.toRemove(nodes[i][0], all)) {
	            nodes.splice(i, 2);
	          } else {
	            i += 2;
	          }
	        } else {
	          if (typeof nodes[i] === 'object') {
	            nodes[i] = this.remove(nodes[i], all);
	          }
	          i += 1;
	        }
	      }
	      return nodes;
	    };
	
	    Supports.prototype.cleanBrackets = function(nodes) {
	      return nodes.map((function(_this) {
	        return function(i) {
	          if (typeof i === 'object') {
	            if (i.length === 1 && typeof i[0] === 'object') {
	              return _this.cleanBrackets(i[0]);
	            } else {
	              return _this.cleanBrackets(i);
	            }
	          } else {
	            return i;
	          }
	        };
	      })(this));
	    };
	
	    Supports.prototype.convert = function(progress) {
	      var i, j, len, result;
	      result = [''];
	      for (j = 0, len = progress.length; j < len; j++) {
	        i = progress[j];
	        result.push([i.prop + ": " + i.value]);
	        result.push(' or ');
	      }
	      result[result.length - 1] = '';
	      return result;
	    };
	
	    Supports.prototype.normalize = function(nodes) {
	      if (typeof nodes === 'object') {
	        nodes = nodes.filter(function(i) {
	          return i !== '';
	        });
	        if (typeof nodes[0] === 'string' && nodes[0].indexOf(':') !== -1) {
	          return [brackets.stringify(nodes)];
	        } else {
	          return nodes.map((function(_this) {
	            return function(i) {
	              return _this.normalize(i);
	            };
	          })(this));
	        }
	      } else {
	        return nodes;
	      }
	    };
	
	    Supports.prototype.add = function(nodes, all) {
	      return nodes.map((function(_this) {
	        return function(i) {
	          var prefixed;
	          if (_this.isProp(i)) {
	            prefixed = _this.prefixed(i[0]);
	            if (prefixed.length > 1) {
	              return _this.convert(prefixed);
	            } else {
	              return i;
	            }
	          } else if (typeof i === 'object') {
	            return _this.add(i, all);
	          } else {
	            return i;
	          }
	        };
	      })(this));
	    };
	
	    Supports.prototype.process = function(rule) {
	      var ast;
	      ast = brackets.parse(rule.params);
	      ast = this.normalize(ast);
	      ast = this.remove(ast, rule.params);
	      ast = this.add(ast, rule.params);
	      ast = this.cleanBrackets(ast);
	      return rule.params = brackets.stringify(ast);
	    };
	
	    Supports.prototype.disabled = function(node) {
	      var other;
	      if (this.all.options.grid === false) {
	        if (node.prop === 'display' && node.value.indexOf('grid') !== -1) {
	          return true;
	        }
	        if (node.prop.indexOf('grid') !== -1 || node.prop === 'justify-items') {
	          return true;
	        }
	      }
	      if (this.all.options.flexbox === false) {
	        if (node.prop === 'display' && node.value.indexOf('flex') !== -1) {
	          return true;
	        }
	        other = ['order', 'justify-content', 'align-items', 'align-content'];
	        if (node.prop.indexOf('flex') !== -1 || other.indexOf(node.prop) !== -1) {
	          return true;
	        }
	      }
	      return false;
	    };
	
	    return Supports;
	
	  })();
	
	  module.exports = Supports;
	
	}).call(this);


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Transition, list, parser, vendor;
	
	  parser = __webpack_require__(313);
	
	  vendor = __webpack_require__(130);
	
	  list = __webpack_require__(90);
	
	  Transition = (function() {
	    function Transition(prefixes) {
	      this.prefixes = prefixes;
	    }
	
	    Transition.prototype.props = ['transition', 'transition-property'];
	
	    Transition.prototype.add = function(decl, result) {
	      var added, declPrefixes, j, k, l, len, len1, len2, names, operaClean, param, params, prefix, prefixValue, prefixed, prefixer, prop, ref, ref1, value, webkitClean;
	      declPrefixes = ((ref = this.prefixes.add[decl.prop]) != null ? ref.prefixes : void 0) || [];
	      params = this.parse(decl.value);
	      names = params.map((function(_this) {
	        return function(i) {
	          return _this.findProp(i);
	        };
	      })(this));
	      added = [];
	      if (names.some(function(i) {
	        return i[0] === '-';
	      })) {
	        return;
	      }
	      for (j = 0, len = params.length; j < len; j++) {
	        param = params[j];
	        prop = this.findProp(param);
	        if (prop[0] === '-') {
	          continue;
	        }
	        prefixer = this.prefixes.add[prop];
	        if (!(prefixer != null ? prefixer.prefixes : void 0)) {
	          continue;
	        }
	        ref1 = prefixer.prefixes;
	        for (k = 0, len1 = ref1.length; k < len1; k++) {
	          prefix = ref1[k];
	          prefixed = this.prefixes.prefixed(prop, prefix);
	          if (prefixed !== '-ms-transform' && names.indexOf(prefixed) === -1) {
	            if (!this.disabled(prop, prefix)) {
	              added.push(this.clone(prop, prefixed, param));
	            }
	          }
	        }
	      }
	      params = params.concat(added);
	      value = this.stringify(params);
	      webkitClean = this.stringify(this.cleanFromUnprefixed(params, '-webkit-'));
	      if (declPrefixes.indexOf('-webkit-') !== -1) {
	        this.cloneBefore(decl, '-webkit-' + decl.prop, webkitClean);
	      }
	      this.cloneBefore(decl, decl.prop, webkitClean);
	      if (declPrefixes.indexOf('-o-') !== -1) {
	        operaClean = this.stringify(this.cleanFromUnprefixed(params, '-o-'));
	        this.cloneBefore(decl, '-o-' + decl.prop, operaClean);
	      }
	      for (l = 0, len2 = declPrefixes.length; l < len2; l++) {
	        prefix = declPrefixes[l];
	        if (prefix !== '-webkit-' && prefix !== '-o-') {
	          prefixValue = this.stringify(this.cleanOtherPrefixes(params, prefix));
	          this.cloneBefore(decl, prefix + decl.prop, prefixValue);
	        }
	      }
	      if (value !== decl.value && !this.already(decl, decl.prop, value)) {
	        this.checkForWarning(result, decl);
	        decl.cloneBefore();
	        return decl.value = value;
	      }
	    };
	
	    Transition.prototype.findProp = function(param) {
	      var i, j, len, prop, token;
	      prop = param[0].value;
	      if (/^\d/.test(prop)) {
	        for (i = j = 0, len = param.length; j < len; i = ++j) {
	          token = param[i];
	          if (i !== 0 && token.type === 'word') {
	            return token.value;
	          }
	        }
	      }
	      return prop;
	    };
	
	    Transition.prototype.already = function(decl, prop, value) {
	      return decl.parent.some(function(i) {
	        return i.prop === prop && i.value === value;
	      });
	    };
	
	    Transition.prototype.cloneBefore = function(decl, prop, value) {
	      if (!this.already(decl, prop, value)) {
	        return decl.cloneBefore({
	          prop: prop,
	          value: value
	        });
	      }
	    };
	
	    Transition.prototype.checkForWarning = function(result, decl) {
	      if (decl.prop === 'transition-property') {
	        return decl.parent.each(function(i) {
	          if (i.type !== 'decl') {
	            return;
	          }
	          if (i.prop.indexOf('transition-') !== 0) {
	            return;
	          }
	          if (i.prop === 'transition-property') {
	            return;
	          }
	          if (list.comma(i.value).length > 1) {
	            decl.warn(result, 'Replace transition-property to transition, ' + 'because Autoprefixer could not support ' + 'any cases of transition-property ' + 'and other transition-*');
	          }
	          return false;
	        });
	      }
	    };
	
	    Transition.prototype.remove = function(decl) {
	      var double, params, smaller, value;
	      params = this.parse(decl.value);
	      params = params.filter((function(_this) {
	        return function(i) {
	          var ref;
	          return !((ref = _this.prefixes.remove[_this.findProp(i)]) != null ? ref.remove : void 0);
	        };
	      })(this));
	      value = this.stringify(params);
	      if (decl.value === value) {
	        return;
	      }
	      if (params.length === 0) {
	        decl.remove();
	        return;
	      }
	      double = decl.parent.some(function(i) {
	        return i.prop === decl.prop && i.value === value;
	      });
	      smaller = decl.parent.some(function(i) {
	        return i !== decl && i.prop === decl.prop && i.value.length > value.length;
	      });
	      if (double || smaller) {
	        return decl.remove();
	      } else {
	        return decl.value = value;
	      }
	    };
	
	    Transition.prototype.parse = function(value) {
	      var ast, j, len, node, param, ref, result;
	      ast = parser(value);
	      result = [];
	      param = [];
	      ref = ast.nodes;
	      for (j = 0, len = ref.length; j < len; j++) {
	        node = ref[j];
	        param.push(node);
	        if (node.type === 'div' && node.value === ',') {
	          result.push(param);
	          param = [];
	        }
	      }
	      result.push(param);
	      return result.filter(function(i) {
	        return i.length > 0;
	      });
	    };
	
	    Transition.prototype.stringify = function(params) {
	      var j, len, nodes, param;
	      if (params.length === 0) {
	        return '';
	      }
	      nodes = [];
	      for (j = 0, len = params.length; j < len; j++) {
	        param = params[j];
	        if (param[param.length - 1].type !== 'div') {
	          param.push(this.div(params));
	        }
	        nodes = nodes.concat(param);
	      }
	      if (nodes[0].type === 'div') {
	        nodes = nodes.slice(1);
	      }
	      if (nodes[nodes.length - 1].type === 'div') {
	        nodes = nodes.slice(0, -1);
	      }
	      return parser.stringify({
	        nodes: nodes
	      });
	    };
	
	    Transition.prototype.clone = function(origin, name, param) {
	      var changed, i, j, len, result;
	      result = [];
	      changed = false;
	      for (j = 0, len = param.length; j < len; j++) {
	        i = param[j];
	        if (!changed && i.type === 'word' && i.value === origin) {
	          result.push({
	            type: 'word',
	            value: name
	          });
	          changed = true;
	        } else {
	          result.push(i);
	        }
	      }
	      return result;
	    };
	
	    Transition.prototype.div = function(params) {
	      var j, k, len, len1, node, param;
	      for (j = 0, len = params.length; j < len; j++) {
	        param = params[j];
	        for (k = 0, len1 = param.length; k < len1; k++) {
	          node = param[k];
	          if (node.type === 'div' && node.value === ',') {
	            return node;
	          }
	        }
	      }
	      return {
	        type: 'div',
	        value: ',',
	        after: ' '
	      };
	    };
	
	    Transition.prototype.cleanOtherPrefixes = function(params, prefix) {
	      return params.filter((function(_this) {
	        return function(param) {
	          var current;
	          current = vendor.prefix(_this.findProp(param));
	          return current === '' || current === prefix;
	        };
	      })(this));
	    };
	
	    Transition.prototype.cleanFromUnprefixed = function(params, prefix) {
	      var j, len, p, param, prop, remove, result;
	      result = [];
	      remove = params.map((function(_this) {
	        return function(i) {
	          return _this.findProp(i);
	        };
	      })(this)).filter(function(i) {
	        return i.slice(0, prefix.length) === prefix;
	      }).map((function(_this) {
	        return function(i) {
	          return _this.prefixes.unprefixed(i);
	        };
	      })(this));
	      for (j = 0, len = params.length; j < len; j++) {
	        param = params[j];
	        prop = this.findProp(param);
	        p = vendor.prefix(prop);
	        if (remove.indexOf(prop) === -1 && (p === prefix || p === '')) {
	          result.push(param);
	        }
	      }
	      return result;
	    };
	
	    Transition.prototype.disabled = function(prop, prefix) {
	      var other;
	      other = ['order', 'justify-content', 'align-self', 'align-content'];
	      if (prop.indexOf('flex') !== -1 || other.indexOf(prop) !== -1) {
	        if (this.prefixes.options.flexbox === false) {
	          return true;
	        } else if (this.prefixes.options.flexbox === 'no-2009') {
	          return prefix.indexOf('2009') !== -1;
	        }
	      }
	    };
	
	    return Transition;
	
	  })();
	
	  module.exports = Transition;
	
	}).call(this);


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(467);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var App = function App(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactAddonsCssTransitionGroup2.default,
	      {
	        component: 'div',
	        transitionName: 'fade',
	        transitionEnterTimeout: 500,
	        transitionLeaveTimeout: 500 },
	      _react2.default.cloneElement(props.children, {
	        key: props.location.pathname
	      })
	    )
	  );
	};
	
	App.propTypes = {
	  children: _react.PropTypes.element.isRequired
	};
	
	exports.default = App;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(23);
	
	var _PlayerCard = __webpack_require__(355);
	
	var _PlayerCard2 = _interopRequireDefault(_PlayerCard);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardList = function CardList(_ref) {
	  var cards = _ref.cards;
	  return _react2.default.createElement(
	    _reactBootstrap.ListGroup,
	    { fill: true, className: 'card-list' },
	    cards.map(function (c, i) {
	      return _react2.default.createElement(_PlayerCard2.default, {
	        key: i,
	        card: c,
	        popoverPlacement: 'right' });
	    })
	  );
	};
	
	CardList.propTypes = {
	  cards: _react.PropTypes.arrayOf(_propTypes.cardType.isRequired).isRequired
	};
	
	exports.default = CardList;

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DiscardPile = (_temp = _class = function (_React$Component) {
	  _inherits(DiscardPile, _React$Component);
	
	  function DiscardPile() {
	    _classCallCheck(this, DiscardPile);
	
	    return _possibleConstructorReturn(this, (DiscardPile.__proto__ || Object.getPrototypeOf(DiscardPile)).apply(this, arguments));
	  }
	
	  _createClass(DiscardPile, [{
	    key: 'render',
	    value: function render() {
	      var card = this.props.discardTop;
	      var classes = ['card', 'deck-icon', this.props.className, { 'empty': !card }];
	      if (card) {
	        classes.push(card.cardType + ' ' + card.cardType + '-' + card.id);
	      }
	      return _react2.default.createElement('span', {
	        className: (0, _classnames2.default)(classes) });
	    }
	  }]);
	
	  return DiscardPile;
	}(_react2.default.Component), _class.propTypes = {
	  discardTop: _propTypes.cardType,
	  className: _react.PropTypes.string
	}, _temp);
	exports.default = DiscardPile;

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(23);
	
	var _lodash = __webpack_require__(21);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DiseasePicker = function DiseasePicker(_ref) {
	  var title = _ref.title,
	      diseases = _ref.diseases,
	      onDiseasePicked = _ref.onDiseasePicked;
	
	  return _react2.default.createElement(
	    _reactBootstrap.Panel,
	    {
	      className: 'disease-picker',
	      header: title },
	    diseases.map(function (c) {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          id: 'disease-picker-' + c,
	          key: c,
	          onClick: (0, _lodash.partial)(onDiseasePicked, c) },
	        _react2.default.createElement('img', { className: 'disease-' + c })
	      );
	    })
	  );
	};
	
	DiseasePicker.propTypes = {
	  diseases: _react.PropTypes.arrayOf(_propTypes.diseaseType.isRequired).isRequired,
	  onDiseasePicked: _react.PropTypes.func.isRequired,
	  title: _react.PropTypes.string
	};
	
	exports.default = DiseasePicker;

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDnd = __webpack_require__(491);
	
	var _reactDom = __webpack_require__(28);
	
	var _Card = __webpack_require__(93);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cardSource = {
	  beginDrag: function beginDrag(props) {
	    return {
	      id: props.id,
	      index: props.index
	    };
	  }
	};
	
	var cardTarget = {
	  hover: function hover(props, monitor, component) {
	    var dragIndex = monitor.getItem().index;
	    var hoverIndex = props.index;
	
	    if (dragIndex === hoverIndex) {
	      return;
	    }
	
	    var hoverBoundingRect = (0, _reactDom.findDOMNode)(component).getBoundingClientRect();
	    var hoverMiddleX = (hoverBoundingRect.right - hoverBoundingRect.left) / 2;
	
	    var clientOffset = monitor.getClientOffset();
	    var hoverClientX = clientOffset.x - hoverBoundingRect.left;
	
	    if (dragIndex < hoverIndex && hoverClientX < hoverMiddleX) {
	      return;
	    }
	
	    if (dragIndex > hoverIndex && hoverClientX > hoverMiddleX) {
	      return;
	    }
	
	    props.moveCard(dragIndex, hoverIndex);
	    monitor.getItem().index = hoverIndex;
	  }
	};
	
	var DraggableCard = (_dec = (0, _reactDnd.DropTarget)('card', cardTarget, function (connect) {
	  return {
	    connectDropTarget: connect.dropTarget()
	  };
	}), _dec2 = (0, _reactDnd.DragSource)('card', cardSource, function (connect, monitor) {
	  return {
	    connectDragSource: connect.dragSource(),
	    isDragging: monitor.isDragging()
	  };
	}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(DraggableCard, _React$Component);
	
	  function DraggableCard() {
	    _classCallCheck(this, DraggableCard);
	
	    return _possibleConstructorReturn(this, (DraggableCard.__proto__ || Object.getPrototypeOf(DraggableCard)).apply(this, arguments));
	  }
	
	  _createClass(DraggableCard, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isDragging = _props.isDragging,
	          connectDragSource = _props.connectDragSource,
	          connectDropTarget = _props.connectDropTarget,
	          rest = _objectWithoutProperties(_props, ['isDragging', 'connectDragSource', 'connectDropTarget']);
	
	      var opacity = isDragging ? 0 : 1;
	      return connectDragSource(connectDropTarget(_react2.default.createElement(
	        'div',
	        { style: { opacity: opacity } },
	        _react2.default.createElement(_Card2.default, rest)
	      )));
	    }
	  }]);
	
	  return DraggableCard;
	}(_react2.default.Component), _class2.propTypes = {
	  isDragging: _react.PropTypes.bool.isRequired,
	  connectDragSource: _react.PropTypes.func.isRequired,
	  connectDropTarget: _react.PropTypes.func.isRequired
	}, _temp)) || _class) || _class);
	exports.default = DraggableCard;

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Card = __webpack_require__(93);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hand = function Hand(_ref) {
	  var hand = _ref.hand;
	
	  var items = hand.map(function (card) {
	    return _react2.default.createElement(_Card2.default, {
	      key: card.id,
	      cardType: card.cardType,
	      id: card.id,
	      className: (0, _classnames2.default)({ 'invisible': card.handling }) });
	  });
	  return _react2.default.createElement(
	    'div',
	    { className: 'hand' },
	    items
	  );
	};
	
	Hand.propTypes = {
	  hand: _react.PropTypes.arrayOf(_react.PropTypes.shape(_extends({}, _propTypes.cardProps, {
	    name: _react.PropTypes.string,
	    color: _propTypes.diseaseType
	  })).isRequired).isRequired
	};
	
	exports.default = Hand;

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(23);
	
	var _roles = __webpack_require__(118);
	
	var _roles2 = _interopRequireDefault(_roles);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IntroDialog = function IntroDialog(_ref) {
	  var players = _ref.players,
	      onClosed = _ref.onClosed,
	      container = _ref.container;
	  return _react2.default.createElement(
	    _reactBootstrap.Modal.Dialog,
	    {
	      bsSize: players.length > 4 ? 'large' : undefined,
	      container: container,
	      className: 'intro-dialog' },
	    _react2.default.createElement(
	      _reactBootstrap.Modal.Header,
	      null,
	      'Fighting to save the humanity today:'
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Modal.Body,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'intro-players' },
	        players.map(function (pl) {
	          return _react2.default.createElement(
	            'div',
	            { key: pl.id },
	            _react2.default.createElement(
	              'div',
	              { className: 'player-name' },
	              pl.name
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _roles2.default[pl.role].name
	            )
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Modal.Footer,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          bsStyle: 'primary',
	          onClick: onClosed },
	        'Start'
	      )
	    )
	  );
	};
	
	IntroDialog.propTypes = {
	  players: _react.PropTypes.arrayOf(_propTypes.playerType.isRequired).isRequired,
	  onClosed: _react.PropTypes.func.isRequired
	};
	
	exports.default = IntroDialog;

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoadingScreen = function LoadingScreen() {
	  return _react2.default.createElement(
	    "div",
	    { className: "loading-screen" },
	    _react2.default.createElement(
	      "h1",
	      { className: "text-danger" },
	      "Loading..."
	    ),
	    _react2.default.createElement("img", { src: __webpack_require__(286) })
	  );
	};
	
	exports.default = LoadingScreen;

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(23);
	
	var _lodash = __webpack_require__(21);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MultiCardPicker = (_temp = _class = function (_React$Component) {
	  _inherits(MultiCardPicker, _React$Component);
	
	  function MultiCardPicker(props) {
	    _classCallCheck(this, MultiCardPicker);
	
	    var _this = _possibleConstructorReturn(this, (MultiCardPicker.__proto__ || Object.getPrototypeOf(MultiCardPicker)).call(this, props));
	
	    _this.state = {};
	    _this.onCardToggle = _this.onCardToggle.bind(_this);
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(MultiCardPicker, [{
	    key: 'onCardToggle',
	    value: function onCardToggle(id) {
	      this.setState(_defineProperty({}, id, !this.state[id]));
	    }
	  }, {
	    key: 'onSubmit',
	    value: function onSubmit() {
	      this.props.onSubmit(this.getSelectedIds());
	    }
	  }, {
	    key: 'getSelectedIds',
	    value: function getSelectedIds() {
	      var _this2 = this;
	
	      return this.props.cards.filter(function (c) {
	        return !!_this2.state[c.id];
	      }).map(function (c) {
	        return c.id;
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          cards = _props.cards,
	          countNeeded = _props.countNeeded,
	          title = _props.title,
	          onCancel = _props.onCancel;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Panel,
	        {
	          header: title,
	          footer: _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { onClick: this.onSubmit, disabled: this.getSelectedIds().length !== countNeeded },
	              'OK'
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { onClick: onCancel },
	              'Cancel'
	            )
	          ),
	          className: 'card-picker multi-card-picker' },
	        cards.map(function (c) {
	          return _react2.default.createElement(_reactBootstrap.Button, {
	            key: c.id,
	            className: 'card ' + c.cardType + '-' + c.id + ' ' + (!!_this3.state[c.id] && 'selected'),
	            onClick: (0, _lodash.partial)(_this3.onCardToggle, c.id) });
	        })
	      );
	    }
	  }]);
	
	  return MultiCardPicker;
	}(_react2.default.Component), _class.propTypes = {
	  cards: _react.PropTypes.arrayOf(_propTypes.cardType.isRequired).isRequired,
	  countNeeded: _react.PropTypes.number.isRequired,
	  onSubmit: _react.PropTypes.func.isRequired,
	  onCancel: _react.PropTypes.func.isRequired,
	  title: _react.PropTypes.string
	}, _temp);
	exports.default = MultiCardPicker;

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(23);
	
	var _lodash = __webpack_require__(21);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlayerPicker = function PlayerPicker(_ref) {
	  var title = _ref.title,
	      players = _ref.players,
	      onPlayerPicked = _ref.onPlayerPicked,
	      onCancel = _ref.onCancel;
	  return _react2.default.createElement(
	    _reactBootstrap.Panel,
	    {
	      header: title,
	      className: 'player-picker' },
	    players.map(function (o) {
	      return _react2.default.createElement(
	        _reactBootstrap.Button,
	        { id: o.id, key: o.id, onClick: (0, _lodash.partial)(onPlayerPicked, o.id, o.share) },
	        o.name
	      );
	    }),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      { onClick: onCancel },
	      'Cancel'
	    )
	  );
	};
	
	PlayerPicker.propTypes = {
	  players: _react.PropTypes.arrayOf(_react.PropTypes.shape(_extends({}, _propTypes.playerProps, {
	    share: _react.PropTypes.string
	  })).isRequired).isRequired,
	  onPlayerPicked: _react.PropTypes.func.isRequired,
	  onCancel: _react.PropTypes.func.isRequired,
	  title: _react.PropTypes.string
	};
	
	exports.default = PlayerPicker;

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(23);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RatesPopover = (_temp = _class = function (_React$Component) {
	  _inherits(RatesPopover, _React$Component);
	
	  function RatesPopover() {
	    _classCallCheck(this, RatesPopover);
	
	    return _possibleConstructorReturn(this, (RatesPopover.__proto__ || Object.getPrototypeOf(RatesPopover)).apply(this, arguments));
	  }
	
	  _createClass(RatesPopover, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setFlashListener();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.setFlashListener();
	    }
	  }, {
	    key: 'setFlashListener',
	    value: function setFlashListener() {
	      var _this2 = this;
	
	      if (this.flashingEl) {
	        this.flashingEl.addEventListener('animationend', function () {
	          return _this2.props.onAnimationEnd();
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          infectionRateValues = _props.infectionRateValues,
	          outbreaks = _props.outbreaks,
	          showNewInfectionRate = _props.showNewInfectionRate,
	          showNewOutbreaks = _props.showNewOutbreaks;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'infection-rate' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'text-center' },
	            _react2.default.createElement(
	              _reactBootstrap.Label,
	              { bsStyle: 'success' },
	              'Infection Rate'
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'list-inline' },
	            infectionRateValues.values.map(function (val, i) {
	              if (i < infectionRateValues.index) {
	                return _react2.default.createElement(
	                  'li',
	                  {
	                    key: i,
	                    className: 'past' },
	                  val
	                );
	              } else if (i === infectionRateValues.index) {
	                return _react2.default.createElement(
	                  'li',
	                  {
	                    ref: function ref(el) {
	                      if (showNewInfectionRate) {
	                        _this3.flashingEl = el;
	                      }
	                    },
	                    key: i,
	                    className: (0, _classnames2.default)(['current', 'bg-success', { 'animated flash': showNewInfectionRate }]) },
	                  val
	                );
	              } else {
	                return _react2.default.createElement(
	                  'li',
	                  { key: i },
	                  val
	                );
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'outbreaks' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'text-center' },
	            _react2.default.createElement(
	              _reactBootstrap.Label,
	              { bsStyle: 'danger' },
	              'Outbreaks'
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'list-inline' },
	            Array(8).fill().map(function (val, i) {
	              if (i < outbreaks - 1) {
	                return _react2.default.createElement('li', {
	                  key: i,
	                  className: 'past' });
	              } else if (i === outbreaks - 1) {
	                return _react2.default.createElement('li', {
	                  ref: function ref(el) {
	                    if (showNewOutbreaks) {
	                      _this3.flashingEl = el;
	                    }
	                  },
	                  key: i,
	                  className: (0, _classnames2.default)(['past', { 'animated flash': showNewOutbreaks }]) });
	              } else {
	                return _react2.default.createElement('li', { key: i });
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return RatesPopover;
	}(_react2.default.Component), _class.propTypes = {
	  infectionRateValues: _react.PropTypes.shape({
	    index: _react.PropTypes.number.isRequired,
	    values: _react.PropTypes.arrayOf(_react.PropTypes.number.isRequired).isRequired
	  }),
	  outbreaks: _react.PropTypes.number.isRequired,
	  showNewOutbreaks: _react.PropTypes.bool.isRequired,
	  showNewInfectionRate: _react.PropTypes.bool.isRequired,
	  onAnimationEnd: _react.PropTypes.func.isRequired
	}, _temp);
	exports.default = RatesPopover;

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(23);
	
	var _lodash = __webpack_require__(21);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SingleCardPicker = function SingleCardPicker(_ref) {
	  var title = _ref.title,
	      hand = _ref.hand,
	      onCardPicked = _ref.onCardPicked;
	  return _react2.default.createElement(
	    _reactBootstrap.Panel,
	    { header: title, className: 'card-picker single-card-picker' },
	    hand.map(function (o) {
	      return _react2.default.createElement(_reactBootstrap.Button, {
	        className: 'card ' + o.cardType + '-' + o.id,
	        id: o.id,
	        key: o.id,
	        onClick: (0, _lodash.partial)(onCardPicked, o.cardType, o.id, o.playerId) });
	    })
	  );
	};
	
	SingleCardPicker.propTypes = {
	  hand: _react.PropTypes.arrayOf(_react.PropTypes.shape(Object.assign({
	    playerId: _react.PropTypes.string
	  }, _propTypes.cardProps)).isRequired).isRequired,
	  onCardPicked: _react.PropTypes.func.isRequired,
	  title: _react.PropTypes.string
	};
	
	exports.default = SingleCardPicker;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(23);
	
	var _TeamPlayerHand = __webpack_require__(645);
	
	var _TeamPlayerHand2 = _interopRequireDefault(_TeamPlayerHand);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamPanel = function TeamPanel(_ref) {
	  var players = _ref.players,
	      getPlayerHand = _ref.getPlayerHand,
	      currentPlayerId = _ref.currentPlayerId;
	  return _react2.default.createElement(
	    _reactBootstrap.Panel,
	    { className: 'team-panel' },
	    players.map(function (p) {
	      return _react2.default.createElement(_TeamPlayerHand2.default, {
	        key: p.id,
	        player: p,
	        hand: getPlayerHand(p.id),
	        isCurrent: currentPlayerId === p.id });
	    })
	  );
	};
	
	TeamPanel.propTypes = {
	  players: _react.PropTypes.arrayOf(_propTypes.playerType.isRequired).isRequired,
	  getPlayerHand: _react.PropTypes.func.isRequired,
	  currentPlayerId: _react.PropTypes.string.isRequired
	};
	
	exports.default = TeamPanel;

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CardDrawerDealing = (_temp = _class = function (_React$Component) {
	  _inherits(CardDrawerDealing, _React$Component);
	
	  function CardDrawerDealing() {
	    _classCallCheck(this, CardDrawerDealing);
	
	    return _possibleConstructorReturn(this, (CardDrawerDealing.__proto__ || Object.getPrototypeOf(CardDrawerDealing)).apply(this, arguments));
	  }
	
	  _createClass(CardDrawerDealing, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var dealDeck = this.refs.dealDeck;
	
	      var playerDeck = this.props.getPlayerDeck();
	      var playerDeckOffset = $(playerDeck).offset();
	      var src = $(dealDeck).offset();
	      var anim = dealDeck.animate([{ transform: 'translate(' + (playerDeckOffset.left - src.left) + 'px,\n        ' + (playerDeckOffset.top - src.top) + 'px) scale(0.2)' }, { transform: 'translate(0, 0) scale(1)' }], {
	        duration: 500,
	        fill: 'forwards'
	      });
	      $(playerDeck).addClass('empty');
	      $(dealDeck).removeClass('invisible');
	      anim.onfinish = this.props.onDealCardsInitComplete;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _this2 = this;
	
	      var _refs = this.refs,
	          dealDeck = _refs.dealDeck,
	          dealCard = _refs.dealCard;
	      var _props = this.props,
	          playerIndex = _props.playerIndex,
	          newPlayerDealing = _props.newPlayerDealing;
	
	      var deckOffset = $(dealDeck).offset();
	
	      if (newPlayerDealing && playerIndex !== null) {
	        var _props2 = this.props,
	            cardsDealtCount = _props2.cardsDealtCount,
	            players = _props2.players;
	
	
	        $(dealCard).offset(deckOffset).removeClass('hide');
	
	        var cardsLeftToDeal = cardsDealtCount;
	
	        var animateFn = function animateFn() {
	          var animation = dealCard.animate([{ transform: 'translate(0, 0)' }, { transform: 'translate(' + (window.innerWidth - deckOffset.left) + 'px,\n            ' + (playerIndex / players.length * window.innerHeight - deckOffset.top) + 'px)' }], {
	            duration: 200
	          });
	          cardsLeftToDeal--;
	          animation.onfinish = cardsLeftToDeal > 0 ? animateFn : _this2.props.onDealCardsComplete;
	        };
	        animateFn();
	      } else if (this.props.startingEpidemicInsertion) {
	        this.epidemics.forEach(function (el, i) {
	          var offset = $(el).offset();
	          var animation = el.animate([{ transform: 'translate(0, 0)', opacity: 0, offset: 0 }, { transform: 'translate(0, 0)', opacity: 1, offset: 0.4 }, { transform: 'translate(' + (deckOffset.left - offset.left) + 'px,\n            ' + (deckOffset.top - offset.top) + 'px)', opacity: 0, offset: 1 }], {
	            duration: 800,
	            delay: 100 * i,
	            fill: 'forwards'
	          });
	
	          if (i === _this2.epidemics.length - 1) {
	            animation.onfinish = function () {
	              setTimeout(function () {
	                var playerDeck = _this2.props.getPlayerDeck();
	                var playerDeckOffset = $(playerDeck).offset();
	                var src = $(_this2.refs.dealDeck).offset();
	                var anim = _this2.refs.dealDeck.animate([{ transform: 'translate(0, 0) scale(1)' }, { transform: 'translate(' + (playerDeckOffset.left - src.left) + 'px, ' + (playerDeckOffset.top - src.top) + 'px) scale(0.2)' }], {
	                  duration: 500,
	                  fill: 'forwards'
	                });
	                anim.onfinish = function () {
	                  $(playerDeck).removeClass('empty');
	                  _this2.props.onInsertEpidemicCardsComplete();
	                };
	              }, 500);
	            };
	          }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      this.epidemics = [];
	      var _props3 = this.props,
	          isDealingEpidemicCards = _props3.isDealingEpidemicCards,
	          difficulty = _props3.difficulty,
	          playerIndex = _props3.playerIndex;
	
	      var items = isDealingEpidemicCards ? [_react2.default.createElement(
	        'div',
	        {
	          key: 'dealDeck',
	          ref: 'dealDeck',
	          className: 'card dealing-deck-container' },
	        _react2.default.createElement('div', { className: 'card player-deck dealing-deck high-7' })
	      ), _react2.default.createElement(
	        'div',
	        {
	          key: 'epidemics',
	          className: 'epidemics' },
	        Array(difficulty).fill().map(function (_, i) {
	          return _react2.default.createElement('div', {
	            key: i,
	            ref: function ref(el) {
	              return el !== null && _this3.epidemics.push(el);
	            },
	            className: 'card epidemic',
	            style: { opacity: 0 } });
	        })
	      )] : [_react2.default.createElement(
	        'div',
	        {
	          key: 'dealDeck',
	          ref: 'dealDeck',
	          className: (0, _classnames2.default)(['card', 'dealing-deck-container', { 'invisible': playerIndex === null }]) },
	        _react2.default.createElement('div', { className: 'card player-deck dealing-deck high-7' })
	      ), playerIndex !== null && _react2.default.createElement('div', {
	        key: 'dealCard',
	        ref: 'dealCard',
	        className: 'card player-deck dealing hide' })];
	      return _react2.default.createElement(
	        'div',
	        { className: 'card-drawer' },
	        items
	      );
	    }
	  }]);
	
	  return CardDrawerDealing;
	}(_react2.default.Component), _class.propTypes = {
	  isDealingEpidemicCards: _react.PropTypes.bool.isRequired,
	  difficulty: _react.PropTypes.number.isRequired,
	  playerIndex: _react.PropTypes.number,
	  newPlayerDealing: _react.PropTypes.bool,
	  cardsDealtCount: _react.PropTypes.number,
	  getPlayerDeck: _react.PropTypes.func,
	  players: _react.PropTypes.arrayOf(_propTypes.playerType.isRequired).isRequired,
	  startingEpidemicInsertion: _react.PropTypes.bool,
	  onDealCardsInitComplete: _react.PropTypes.func,
	  onDealCardsComplete: _react.PropTypes.func,
	  onInsertEpidemicCardsComplete: _react.PropTypes.func
	}, _temp);
	exports.default = CardDrawerDealing;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _CardWrapper = __webpack_require__(354);
	
	var _CardWrapper2 = _interopRequireDefault(_CardWrapper);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CardDrawerDiscardingPlayerCard = (_temp = _class = function (_React$Component) {
	  _inherits(CardDrawerDiscardingPlayerCard, _React$Component);
	
	  function CardDrawerDiscardingPlayerCard() {
	    _classCallCheck(this, CardDrawerDiscardingPlayerCard);
	
	    return _possibleConstructorReturn(this, (CardDrawerDiscardingPlayerCard.__proto__ || Object.getPrototypeOf(CardDrawerDiscardingPlayerCard)).apply(this, arguments));
	  }
	
	  _createClass(CardDrawerDiscardingPlayerCard, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var card = (0, _reactDom.findDOMNode)(this.refs.card);
	      card.addEventListener('animationend', function (e) {
	        if (e.animationName === _this2.getAnimationName()) {
	          var playerDiscard = (0, _reactDom.findDOMNode)(_this2.props.getPlayerDiscard());
	          var src = $(card).offset();
	          var discardOffset = $(playerDiscard).offset();
	
	          var animation = card.animate([{ transform: 'translate(0, 0) scale(1)' }, { transform: 'translate(' + (discardOffset.left - src.left) + 'px, ' + (discardOffset.top - src.top) + 'px) scale(0.2)' }], {
	            duration: 500,
	            fill: 'forwards'
	          });
	          animation.onfinish = _this2.props.onAnimationComplete;
	        }
	      });
	    }
	  }, {
	    key: 'getAnimationName',
	    value: function getAnimationName() {
	      return this.props.isCurrentPlayerDiscarding ? 'fadeInUp' : 'fadeInRightBig';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'card-drawer' },
	        _react2.default.createElement(_CardWrapper2.default, _extends({
	          ref: 'card',
	          className: 'animated ' + this.getAnimationName()
	        }, this.props.card))
	      );
	    }
	  }]);
	
	  return CardDrawerDiscardingPlayerCard;
	}(_react2.default.Component), _class.propTypes = {
	  card: _propTypes.cardType.isRequired,
	  getPlayerDiscard: _react.PropTypes.func.isRequired,
	  isCurrentPlayerDiscarding: _react.PropTypes.bool.isRequired,
	  onAnimationComplete: _react.PropTypes.func.isRequired
	}, _temp);
	exports.default = CardDrawerDiscardingPlayerCard;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(21);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Card = __webpack_require__(93);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _CardWrapper = __webpack_require__(354);
	
	var _CardWrapper2 = _interopRequireDefault(_CardWrapper);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CardDrawerDrawingPlayerCards = (_temp = _class = function (_React$Component) {
	  _inherits(CardDrawerDrawingPlayerCards, _React$Component);
	
	  function CardDrawerDrawingPlayerCards(props) {
	    _classCallCheck(this, CardDrawerDrawingPlayerCards);
	
	    var _this = _possibleConstructorReturn(this, (CardDrawerDrawingPlayerCards.__proto__ || Object.getPrototypeOf(CardDrawerDrawingPlayerCards)).call(this, props));
	
	    _this.onAnimationStart = _this.onAnimationStart.bind(_this);
	    return _this;
	  }
	
	  _createClass(CardDrawerDrawingPlayerCards, [{
	    key: 'onAnimationStart',
	    value: function onAnimationStart(cardType, id, e) {
	      var _this2 = this;
	
	      if (e.animationName === 'flash') {
	        // special case for two epidemics drawn at once
	        setTimeout(function () {
	          _this2.props.onEpidemicHandle(cardType, id);
	        }, 3000);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          cards = _props.cards,
	          startingDraw = _props.startingDraw;
	
	      var bothEpidemics = (0, _lodash.every)(cards, { cardType: 'epidemic' });
	      var items = (0, _lodash.flatten)(cards.map(function (c, i) {
	        if (c.handling || !startingDraw) {
	          return _react2.default.createElement(_CardWrapper2.default, _extends({
	            key: c.id
	          }, c, {
	            className: (0, _classnames2.default)({
	              'move-to-hand': c.handling && c.cardType !== 'epidemic',
	              'animated flash': c.cardType === 'epidemic'
	            }),
	            onAnimationStart: bothEpidemics ? undefined : _this3.onAnimationStart }));
	        } else {
	          return _react2.default.createElement(
	            'div',
	            { className: 'card invisible', key: 'flip-' + c.id + '-' + i },
	            _react2.default.createElement('div', { className: 'card front player-deck' }),
	            _react2.default.createElement(_Card2.default, _extends({}, c, {
	              className: 'back' }))
	          );
	        }
	      }));
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'card-drawer' },
	        items
	      );
	    }
	  }]);
	
	  return CardDrawerDrawingPlayerCards;
	}(_react2.default.Component), _class.propTypes = {
	  cards: _react.PropTypes.arrayOf(_propTypes.cardType).isRequired,
	  startingDraw: _react.PropTypes.bool.isRequired,
	  onEpidemicHandle: _react.PropTypes.func.isRequired
	}, _temp);
	exports.default = CardDrawerDrawingPlayerCards;

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _Card = __webpack_require__(93);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CardDrawerEpidemicInfection = (_temp = _class = function (_React$Component) {
	  _inherits(CardDrawerEpidemicInfection, _React$Component);
	
	  function CardDrawerEpidemicInfection() {
	    _classCallCheck(this, CardDrawerEpidemicInfection);
	
	    return _possibleConstructorReturn(this, (CardDrawerEpidemicInfection.__proto__ || Object.getPrototypeOf(CardDrawerEpidemicInfection)).apply(this, arguments));
	  }
	
	  _createClass(CardDrawerEpidemicInfection, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var infectionDeck = this.props.getInfectionDeck();
	      $(infectionDeck).addClass('empty');
	      var deckCopy = this.refs.deckCopy;
	
	      var src = $(deckCopy).offset();
	      var deckOffset = $(infectionDeck).offset();
	      var animation = deckCopy.animate([{ transform: 'translate(' + (deckOffset.left - src.left) + 'px, ' + (deckOffset.top - src.top) + 'px) scale(0.2)' }, { transform: 'translate(0, 0) scale(1)' }], {
	        duration: 500,
	        fill: 'forwards'
	      });
	      animation.onfinish = function () {
	        var front = _this2.refs.front;
	        var bottomCard = _this2.refs.bottomCard;
	
	        $(bottomCard).offset($(front).offset()).removeClass('hide');
	        var frontSlide = front.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(150px)' }], {
	          duration: 500,
	          fill: 'forwards'
	        });
	        frontSlide.onfinish = function () {
	          var cardFlip = bottomCard.animate([{ transform: 'rotateY(0deg)' }, { transform: 'rotateY(180deg)' }], {
	            duration: 500,
	            fill: 'forwards'
	          });
	          cardFlip.onfinish = function () {
	            var infectionDiscard = _this2.props.getInfectionDiscard();
	            var discardOffset = $((0, _reactDom.findDOMNode)(infectionDiscard)).offset();
	            var cardSrc = $(bottomCard).offset();
	            var returnCard = bottomCard.animate([{ transform: 'translate(0, 0) scale(1) rotateY(180deg)' }, { transform: 'translate(' + (discardOffset.left - cardSrc.left - bottomCard.offsetWidth) + 'px, ' + (discardOffset.top - cardSrc.top) + 'px) scale(0.2) rotateY(180deg)' }], {
	              delay: 500,
	              duration: 500,
	              fill: 'forwards'
	            });
	            returnCard.onfinish = function () {
	              _this2.props.onAnimationComplete();
	              $(infectionDeck).removeClass('empty');
	            };
	            var frontOffset = $(front).offset();
	            var slideLength = 150;
	            front.animate([{ transform: 'translate(' + slideLength + 'px, 0) scale(1)' }, { transform: 'translate(' + (deckOffset.left - frontOffset.left + slideLength) + 'px, ' + (deckOffset.top - frontOffset.top) + 'px) scale(0.2)' }], {
	              delay: 500,
	              duration: 500,
	              fill: 'forwards'
	            });
	          };
	        };
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'card-drawer' },
	        _react2.default.createElement(
	          'div',
	          {
	            ref: 'bottomCard',
	            className: 'card flipper hide absolute' },
	          _react2.default.createElement('div', {
	            className: 'card infection-deck front' }),
	          _react2.default.createElement(_Card2.default, _extends({}, this.props.infectionCard, { className: 'back' }))
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            ref: 'deckCopy',
	            className: 'card deck-copy' },
	          _react2.default.createElement('div', {
	            ref: 'front',
	            className: 'card infection-deck' })
	        )
	      );
	    }
	  }]);
	
	  return CardDrawerEpidemicInfection;
	}(_react2.default.Component), _class.propTypes = {
	  infectionCard: _propTypes.cardType.isRequired,
	  getInfectionDeck: _react.PropTypes.func.isRequired,
	  getInfectionDiscard: _react.PropTypes.func.isRequired,
	  onAnimationComplete: _react.PropTypes.func.isRequired
	}, _temp);
	exports.default = CardDrawerEpidemicInfection;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CardDrawerEpidemicIntensify = (_temp = _class = function (_React$Component) {
	  _inherits(CardDrawerEpidemicIntensify, _React$Component);
	
	  function CardDrawerEpidemicIntensify() {
	    _classCallCheck(this, CardDrawerEpidemicIntensify);
	
	    return _possibleConstructorReturn(this, (CardDrawerEpidemicIntensify.__proto__ || Object.getPrototypeOf(CardDrawerEpidemicIntensify)).apply(this, arguments));
	  }
	
	  _createClass(CardDrawerEpidemicIntensify, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var discard = (0, _reactDom.findDOMNode)(this.props.getInfectionDiscard());
	      var discardOffset = $(discard).offset();
	      var _refs = this.refs,
	          innerDiscard = _refs.innerDiscard,
	          discardCopy = _refs.discardCopy,
	          highDeckLeft = _refs.highDeckLeft,
	          highDeckRight = _refs.highDeckRight;
	
	      $((0, _reactDom.findDOMNode)(innerDiscard)).removeClass('deck-icon').addClass('front');
	      var src = $(discardCopy).offset();
	      $(discard).addClass('empty');
	
	      var zoomDiscard = discardCopy.animate([{ transform: 'translate(' + (discardOffset.left - src.left) + 'px, ' + (discardOffset.top - src.top) + 'px) scale(0.2)' }, { transform: 'translate(0px, 0) scale(1)' }], {
	        duration: 500,
	        fill: 'forwards'
	      });
	      zoomDiscard.onfinish = function () {
	        var flip = discardCopy.animate([{ transform: 'translate(0px, 0) rotateY(0deg)' }, { transform: 'translate(0px, 0) rotateY(180deg)' }], {
	          delay: 300,
	          duration: 500,
	          fill: 'forwards'
	        });
	
	        flip.onfinish = function () {
	          setTimeout(function () {
	            var resultDeck = _this2.refs.resultDeck;
	
	            $(discardCopy).addClass('hide');
	            $(highDeckLeft).removeClass('hide');
	            $(highDeckRight).removeClass('hide');
	
	            $(resultDeck).removeClass('hide').addClass('invisible');
	            var resultOffset = $(resultDeck).find('.high-deck-container').offset();
	
	            var leftDeckDest = $(highDeckLeft).offset();
	            var rightDeckDest = $(highDeckRight).offset();
	            $(highDeckLeft).find('.high-deck').removeClass('high-deck');
	            var leftAnim = highDeckLeft.animate([{ transform: 'translate(' + (resultOffset.left - leftDeckDest.left) + 'px, ' + (resultOffset.top - leftDeckDest.top) + 'px)' }, { transform: 'translate(0, 0)' }], {
	              duration: 500,
	              fill: 'forwards'
	            });
	            leftAnim.onfinish = function () {
	              $(highDeckLeft).find('.card div').addClass('high-deck high-3');
	            };
	            $(highDeckRight).find('.high-deck').removeClass('high-deck');
	            var rightAnim = highDeckRight.animate([{ transform: 'translate(' + (resultOffset.left - rightDeckDest.left) + 'px, ' + (resultOffset.top - rightDeckDest.top) + 'px)' }, { transform: 'translate(0, 0)' }], {
	              duration: 500,
	              fill: 'forwards'
	            });
	
	            rightAnim.onfinish = function () {
	              $(highDeckRight).find('.card div').addClass('high-deck high-3');
	              setTimeout(function () {
	                _this2.shuffle();
	              }, 500);
	            };
	          }, 500);
	        };
	      };
	    }
	  }, {
	    key: 'shuffle',
	    value: function shuffle() {
	      var _this3 = this;
	
	      var _refs2 = this.refs,
	          shuffleCard = _refs2.shuffleCard,
	          resultDeck = _refs2.resultDeck,
	          highDeckLeft = _refs2.highDeckLeft,
	          highDeckRight = _refs2.highDeckRight;
	
	      var infectionDeck = this.props.getInfectionDeck();
	      var CARDS_TO_SHUFFLE = 40;
	      var animationsLeft = CARDS_TO_SHUFFLE;
	      $(shuffleCard).removeClass('hide');
	      $(resultDeck).removeClass('hide').addClass('invisible');
	      var animateFn = function animateFn() {
	        var deck = animationsLeft % 2 === 0 ? highDeckLeft : highDeckRight;
	        var deckOffset = $(deck).find('.high-deck-container').offset();
	        var resultOffset = $(resultDeck).find('.high-deck-container').offset();
	        $(shuffleCard).offset(deckOffset);
	        var shuffle = shuffleCard.animate([{ transform: 'translate(0, 0)' }, { transform: 'translate(' + (resultOffset.left - deckOffset.left) + 'px, ' + (resultOffset.top - deckOffset.top) + 'px)' }], {
	          duration: 50,
	          fill: 'none'
	        });
	        var currentEmptyingIndex = Math.floor(animationsLeft / CARDS_TO_SHUFFLE * 3.0);
	        $(deck).find('.high-deck, .high-deck-container').removeClass('high-' + (currentEmptyingIndex + 1)).addClass('high-' + currentEmptyingIndex);
	
	        var currentFillingIndex = Math.floor((CARDS_TO_SHUFFLE - animationsLeft) / CARDS_TO_SHUFFLE * 7.0);
	        $(resultDeck).find('.high-deck, .high-deck-container').removeClass('high-' + (currentFillingIndex - 1)).addClass('high-' + currentFillingIndex);
	
	        animationsLeft--;
	        shuffle.onfinish = animationsLeft ? function () {
	          $(resultDeck).removeClass('invisible').find('.high-deck').addClass('high-1');
	          animateFn();
	        } : function () {
	          $(highDeckLeft).addClass('invisible');
	          $(highDeckRight).addClass('invisible');
	          $(shuffleCard).addClass('invisible');
	          var infectionDeckOffset = $((0, _reactDom.findDOMNode)(infectionDeck)).offset();
	          resultOffset = $(resultDeck).offset();
	          setTimeout(function () {
	            $(resultDeck).find('.high-deck').removeClass('high-deck');
	            var returnToDiscard = resultDeck.animate([{ transform: 'translate(0, 0) scale(1)' }, { transform: 'translate(' + (infectionDeckOffset.left - resultOffset.left) + 'px, ' + (infectionDeckOffset.top - resultOffset.top) + 'px) scale(0.2)' }], {
	              duration: 500,
	              fill: 'forwards'
	            });
	            returnToDiscard.onfinish = _this3.props.onAnimationComplete;
	          }, 500);
	        };
	      };
	      animateFn();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'card-drawer' },
	        _react2.default.createElement(
	          'div',
	          {
	            ref: 'discardCopy',
	            className: 'card flipper' },
	          _react2.default.cloneElement(this.props.infectionDiscard, { ref: 'innerDiscard' }),
	          _react2.default.createElement('div', { className: 'card infection-deck back' })
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            ref: 'highDeckLeft',
	            className: 'card hide' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card infection-deck high-deck-container high-3' },
	            _react2.default.createElement('div', { className: 'high-deck high-3' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            ref: 'resultDeck',
	            className: 'card result-deck hide' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card infection-deck high-deck-container' },
	            _react2.default.createElement('div', { className: 'high-deck' })
	          )
	        ),
	        _react2.default.createElement('div', {
	          ref: 'shuffleCard',
	          className: 'card infection-deck hide shuffle-card' }),
	        _react2.default.createElement(
	          'div',
	          {
	            ref: 'highDeckRight',
	            className: 'card hide' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card infection-deck high-deck-container high-3' },
	            _react2.default.createElement('div', { className: 'high-deck high-3' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CardDrawerEpidemicIntensify;
	}(_react2.default.Component), _class.propTypes = {
	  getInfectionDiscard: _react.PropTypes.func.isRequired,
	  getInfectionDeck: _react.PropTypes.func.isRequired,
	  onAnimationComplete: _react.PropTypes.func.isRequired,
	  infectionDiscard: _react.PropTypes.node
	}, _temp);
	exports.default = CardDrawerEpidemicIntensify;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _Card = __webpack_require__(93);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _utils = __webpack_require__(94);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CardDrawerInfection = (_temp = _class = function (_React$Component) {
	  _inherits(CardDrawerInfection, _React$Component);
	
	  function CardDrawerInfection() {
	    _classCallCheck(this, CardDrawerInfection);
	
	    return _possibleConstructorReturn(this, (CardDrawerInfection.__proto__ || Object.getPrototypeOf(CardDrawerInfection)).apply(this, arguments));
	  }
	
	  _createClass(CardDrawerInfection, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.animateInfection();
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return nextProps.infectedCity !== this.props.infectedCity;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.animateInfection();
	    }
	  }, {
	    key: 'animateInfection',
	    value: function animateInfection() {
	      var _this2 = this;
	
	      var _props = this.props,
	          map = _props.map,
	          infectedLocation = _props.infectedLocation;
	
	      var mapNode = (0, _reactDom.findDOMNode)(map);
	      var origin = (0, _utils.getInfectionCardOrigin)(infectedLocation, map.getWidth(), map.getHeight());
	      var mapOffset = $(mapNode).offset();
	      var infectedCity = this.refs.infectedCity;
	
	      infectedCity.style.top = mapOffset.top + origin.top + 'px';
	      infectedCity.style.left = mapOffset.left + origin.left + 50 + 'px';
	      var src = { top: mapOffset.top + origin.top, left: mapOffset.left + origin.left + 50 };
	      var deckOffset = $(this.props.getInfectionDeck()).offset();
	      var discardOffset = $((0, _reactDom.findDOMNode)(this.props.getInfectionDiscard())).offset();
	
	      $(infectedCity).addClass('flipper').removeClass('invisible');
	      var animation = infectedCity.animate([{ transform: 'translate(' + (deckOffset.left - src.left) + 'px, ' + (deckOffset.top - src.top) + 'px) scale(0.2) rotateY(0deg)', offset: 0 }, { transform: 'translate(' + (deckOffset.left - src.left) + 'px, ' + (deckOffset.top - src.top) + 'px) scale(0.2) rotateY(180deg)', offset: 0.2 }, { transform: 'translate(0, 0) scale(1) rotateY(180deg)', offset: 0.4 }, { transform: 'translate(0, 0) scale(1) rotateY(180deg)', offset: 0.8 }, { transform: 'translate(' + (discardOffset.left - src.left) + 'px, ' + (discardOffset.top - src.top) + 'px)\n        scale(0.2) rotateY(180deg)', offset: 1 }], {
	        duration: 2000,
	        fill: 'forwards'
	      });
	      animation.onfinish = function () {
	        return setTimeout(_this2.props.onAnimationComplete, 500);
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var infectedCity = this.props.infectedCity;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'card-drawer infection-drawer' },
	        _react2.default.createElement(
	          'div',
	          {
	            ref: 'infectedCity',
	            className: 'card invisible' },
	          _react2.default.createElement('div', { className: 'card front infection-deck' }),
	          _react2.default.createElement(_Card2.default, {
	            cardType: 'city',
	            id: infectedCity,
	            className: 'back' })
	        )
	      );
	    }
	  }]);
	
	  return CardDrawerInfection;
	}(_react2.default.Component), _class.propTypes = {
	  infectedCity: _react.PropTypes.string,
	  infectedLocation: _propTypes.locationType,
	  map: _react.PropTypes.object,
	  getInfectionDeck: _react.PropTypes.func.isRequired,
	  getInfectionDiscard: _react.PropTypes.func.isRequired,
	  onAnimationComplete: _react.PropTypes.func
	}, _temp);
	exports.default = CardDrawerInfection;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(21);
	
	var _autoprefixer = __webpack_require__(353);
	
	var _autoprefixer2 = _interopRequireDefault(_autoprefixer);
	
	var _postcssJs = __webpack_require__(456);
	
	var _postcssJs2 = _interopRequireDefault(_postcssJs);
	
	var _utils = __webpack_require__(94);
	
	var _diseases = __webpack_require__(83);
	
	var _diseases2 = _interopRequireDefault(_diseases);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var prefixer = _postcssJs2.default.sync([_autoprefixer2.default]);
	
	var Cubes = (_temp = _class = function (_React$Component) {
	  _inherits(Cubes, _React$Component);
	
	  function Cubes() {
	    _classCallCheck(this, Cubes);
	
	    return _possibleConstructorReturn(this, (Cubes.__proto__ || Object.getPrototypeOf(Cubes)).apply(this, arguments));
	  }
	
	  _createClass(Cubes, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _lodash.isEqual)((0, _lodash.pick)(nextProps.location, _diseases2.default), (0, _lodash.pick)(this.props.location, _diseases2.default)) || nextProps.width !== this.props.width || nextProps.height !== this.props.height;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var $el = $(_reactDom2.default.findDOMNode(this));
	      var $cubes = $el.find('.cube');
	      $cubes.removeClass('cube');
	      $cubes.outerHeight();
	      $cubes.addClass('cube');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          location = _props.location,
	          width = _props.width,
	          height = _props.height;
	
	      var counts = (0, _lodash.values)((0, _lodash.pick)(location, _diseases2.default));
	      var maxCount = Math.max.apply(Math, _toConsumableArray(counts));
	      var totalCubes = counts.reduce(function (sum, c) {
	        return sum + c;
	      }, 0);
	      var cubesSoFar = 0;
	      var cubes = [];
	      _diseases2.default.forEach(function (c) {
	        for (var i = 0; i < location[c]; i++, cubesSoFar++) {
	          cubes.push(_react2.default.createElement('div', {
	            key: 'cube-' + location.coords.join('') + '-' + c + '-' + i,
	            className: 'cube cubes-' + maxCount + ' cube-' + location[c] + '-' + (i + 1) + ' ' + c,
	            style: prefixer({
	              animationDelay: '-' + cubesSoFar / totalCubes * (-maxCount * 3 + 12) + 's'
	            }) }));
	        }
	      });
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'cube-group',
	          style: (0, _utils.getCubeOrigin)(location, width, height) },
	        cubes
	      );
	    }
	  }]);
	
	  return Cubes;
	}(_react2.default.Component), _class.propTypes = {
	  location: _propTypes.locationType.isRequired,
	  width: _react.PropTypes.number,
	  height: _react.PropTypes.number
	}, _temp);
	exports.default = Cubes;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(21);
	
	var _Cubes = __webpack_require__(626);
	
	var _Cubes2 = _interopRequireDefault(_Cubes);
	
	var _utils = __webpack_require__(94);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var INFECTING_CUBE_SPEED = 8;
	
	var CubesLayer = (_temp = _class = function (_React$Component) {
	  _inherits(CubesLayer, _React$Component);
	
	  function CubesLayer() {
	    _classCallCheck(this, CubesLayer);
	
	    return _possibleConstructorReturn(this, (CubesLayer.__proto__ || Object.getPrototypeOf(CubesLayer)).apply(this, arguments));
	  }
	
	  _createClass(CubesLayer, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _lodash.isEqual)((0, _lodash.pick)(nextProps, ['locations', 'infectingCube']), (0, _lodash.pick)(this.props, ['locations', 'infectingCube'])) || nextProps.width !== this.props.width || nextProps.height !== this.props.height;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var infectingCube = this.props.infectingCube;
	
	      if (!(0, _lodash.isEmpty)(infectingCube)) {
	        this.transitionNeighborInfection();
	      }
	    }
	  }, {
	    key: 'animateMovement',
	    value: function animateMovement(cubeEl, _ref, _ref2, length) {
	      var _ref4 = _slicedToArray(_ref, 2),
	          x1 = _ref4[0],
	          y1 = _ref4[1];
	
	      var _ref3 = _slicedToArray(_ref2, 2),
	          x2 = _ref3[0],
	          y2 = _ref3[1];
	
	      return cubeEl.animate([{ left: x1 + 'px', top: y1 + 'px', offset: 0 }, { left: x2 + 'px', top: y2 + 'px', offset: 1 }], {
	        duration: length * INFECTING_CUBE_SPEED,
	        fill: 'forwards'
	      });
	    }
	  }, {
	    key: 'transitionNeighborInfection',
	    value: function transitionNeighborInfection() {
	      var _this2 = this;
	
	      var _props$infectingCube = this.props.infectingCube,
	          origin = _props$infectingCube.origin,
	          destination = _props$infectingCube.destination;
	
	      var cubeEl = document.getElementById('infect-neighbor-cube');
	      var split = (0, _utils.splitPath)([origin.left, origin.top], [destination.left, destination.top], this.props.width);
	      var length = (0, _lodash.isEmpty)(split) ? (0, _utils.getLength)([origin.left, origin.top], [destination.left, destination.top]) : _utils.getLength.apply(undefined, _toConsumableArray(split[0])) + _utils.getLength.apply(undefined, _toConsumableArray(split[1]));
	
	      var anim = void 0;
	      var $cube = $(cubeEl);
	      var onfinish = function onfinish() {
	        $cube.removeClass('cube-neighbor');
	        $cube.on('animationend', function (e) {
	          _this2.props.infectNeighborCallback();
	          if (e.originalEvent.animationName === 'cube-flash') {
	            $cube.removeClass('cube-flash');
	          }
	        });
	        $cube.addClass('cube-flash');
	      };
	
	      if ((0, _lodash.isEmpty)(split)) {
	        anim = this.animateMovement(cubeEl, [origin.left, origin.top], [destination.left, destination.top], length);
	        anim.onfinish = onfinish;
	      } else {
	        var trueSplit1 = [split[0][0], _utils.constrainCubeMovement.apply(undefined, _toConsumableArray(split[0]).concat([this.props.width]))];
	        var length1 = _utils.getLength.apply(undefined, trueSplit1);
	        anim = this.animateMovement.apply(this, [cubeEl].concat(trueSplit1, [length1]));
	        anim.onfinish = function () {
	          var trueSplit2 = [_utils.constrainCubeMovement.apply(undefined, _toConsumableArray(split[1].slice().reverse()).concat([_this2.props.width])), split[1][1]];
	          var length2 = _utils.getLength.apply(undefined, trueSplit2);
	          var secondAnim = _this2.animateMovement.apply(_this2, [cubeEl].concat(trueSplit2, [length2]));
	          secondAnim.onfinish = onfinish;
	        };
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          locations = _props.locations,
	          infectingCube = _props.infectingCube,
	          width = _props.width,
	          height = _props.height;
	
	      var cubes = [];
	
	      (0, _lodash.forOwn)(locations, function (loc, id) {
	        cubes.push(_react2.default.createElement(_Cubes2.default, {
	          key: id,
	          location: loc,
	          width: width,
	          height: height }));
	      });
	      if (!(0, _lodash.isEmpty)(infectingCube)) {
	        cubes.push(_react2.default.createElement('div', {
	          key: 'infect-neighbor-cube',
	          id: 'infect-neighbor-cube',
	          className: 'cube ' + infectingCube.color + ' cube-neighbor' }));
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        cubes
	      );
	    }
	  }]);
	
	  return CubesLayer;
	}(_react2.default.Component), _class.propTypes = {
	  locations: _react.PropTypes.objectOf(_propTypes.locationType.isRequired).isRequired,
	  infectNeighborCallback: _react.PropTypes.func.isRequired,
	  width: _react.PropTypes.number,
	  height: _react.PropTypes.number,
	  infectingCube: _react.PropTypes.shape({
	    origin: _propTypes.viewCoordsType.isRequired,
	    destination: _propTypes.viewCoordsType.isRequired,
	    color: _propTypes.diseaseType.isRequired
	  })
	}, _temp);
	exports.default = CubesLayer;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(21);
	
	var _utils = __webpack_require__(94);
	
	var _propTypes = __webpack_require__(14);
	
	var _diseases = __webpack_require__(83);
	
	var _diseases2 = _interopRequireDefault(_diseases);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var nonPropagatingHandler = function nonPropagatingHandler(callback, id) {
	  return function (e) {
	    e.stopPropagation();
	    callback(id);
	  };
	};
	
	var LocationsLayer = function LocationsLayer(_ref) {
	  var cities = _ref.cities,
	      locations = _ref.locations,
	      availableCities = _ref.availableCities,
	      onCityClicked = _ref.onCityClicked,
	      onCityDoubleClicked = _ref.onCityDoubleClicked,
	      isDriveAvailable = _ref.isDriveAvailable,
	      infectedCity = _ref.infectedCity,
	      width = _ref.width,
	      height = _ref.height;
	
	  var items = [];
	  (0, _lodash.forOwn)(cities, function (c, id) {
	    var isAvailable = !!(0, _lodash.find)(availableCities, { id: id });
	    var loc = locations[id];
	    var coords = (0, _utils.getLocationOrigin)(loc, width, height);
	
	    var onClick = !(0, _lodash.isEmpty)(availableCities) && nonPropagatingHandler(onCityClicked, id);
	    var onDoubleClick = (0, _lodash.isEmpty)(availableCities) && isDriveAvailable(id) && nonPropagatingHandler(onCityDoubleClicked, id);
	    var counts = (0, _lodash.values)((0, _lodash.pick)(loc, _diseases2.default));
	    var maxCount = Math.max.apply(Math, _toConsumableArray(counts));
	    items.push(_react2.default.createElement(
	      'span',
	      {
	        className: 'city',
	        key: id,
	        style: coords,
	        onClick: onClick,
	        onDoubleClick: onDoubleClick },
	      _react2.default.createElement('span', { className: 'icon ' + c.color }),
	      isAvailable && _react2.default.createElement(
	        'span',
	        { className: 'selection-container' },
	        _react2.default.createElement('span', { className: 'selection' }),
	        _react2.default.createElement('span', { className: 'selection-bg' })
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'name' },
	        c.name
	      ),
	      loc.station && _react2.default.createElement('span', {
	        className: 'station',
	        onClick: onClick,
	        onDoubleClick: onDoubleClick }),
	      maxCount === 3 && _react2.default.createElement('span', { className: 'outbreak-warning' }),
	      id === infectedCity && _react2.default.createElement('span', { className: 'crosshair' })
	    ));
	  });
	  return _react2.default.createElement(
	    'div',
	    { className: 'locations-layer' },
	    items
	  );
	};
	
	LocationsLayer.propTypes = {
	  cities: _react.PropTypes.objectOf(_propTypes.cityType.isRequired).isRequired,
	  locations: _react.PropTypes.objectOf(_propTypes.locationType.isRequired).isRequired,
	  onCityClicked: _react.PropTypes.func.isRequired,
	  onCityDoubleClicked: _react.PropTypes.func.isRequired,
	  isDriveAvailable: _react.PropTypes.func.isRequired,
	  availableCities: _react.PropTypes.objectOf(_propTypes.cityType.isRequired),
	  infectedCity: _react.PropTypes.string,
	  width: _react.PropTypes.number,
	  height: _react.PropTypes.number
	};
	
	exports.default = LocationsLayer;

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _postcssJs = __webpack_require__(456);
	
	var _postcssJs2 = _interopRequireDefault(_postcssJs);
	
	var _autoprefixer = __webpack_require__(353);
	
	var _autoprefixer2 = _interopRequireDefault(_autoprefixer);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixer = _postcssJs2.default.sync([_autoprefixer2.default]);
	
	var Path = function Path(_ref) {
	  var _ref$path = _slicedToArray(_ref.path, 2),
	      _ref$path$ = _slicedToArray(_ref$path[0], 2),
	      x1 = _ref$path$[0],
	      y1 = _ref$path$[1],
	      _ref$path$2 = _slicedToArray(_ref$path[1], 2),
	      x2 = _ref$path$2[0],
	      y2 = _ref$path$2[1];
	
	  var length = Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
	  var angle = Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI;
	  var transform = 'rotate(' + angle + 'deg)';
	  return _react2.default.createElement('div', {
	    key: 'path-' + x1 + x2 + y1 + y2,
	    className: 'path',
	    style: prefixer({ left: x1, top: y1, width: length, transform: transform }) });
	};
	
	Path.propTypes = {
	  path: _propTypes.pathType.isRequired
	};
	
	exports.default = Path;

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(21);
	
	var _Path = __webpack_require__(629);
	
	var _Path2 = _interopRequireDefault(_Path);
	
	var _utils = __webpack_require__(94);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PathsLayer = function PathsLayer(_ref) {
	  var paths = _ref.paths,
	      width = _ref.width;
	
	  function getPaths(path, index) {
	    var split = _utils.splitPath.apply(undefined, [path[0], path[1]].concat([width]));
	    if ((0, _lodash.isEmpty)(split)) {
	      return _react2.default.createElement(_Path2.default, { key: index, path: path });
	    } else {
	      return [_react2.default.createElement(_Path2.default, { key: index + '-1', path: split[0] }), _react2.default.createElement(_Path2.default, { key: index + '-2', path: split[1] })];
	    }
	  }
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    (0, _lodash.flatten)(paths.map(getPaths))
	  );
	};
	
	PathsLayer.propTypes = {
	  paths: _react.PropTypes.arrayOf(_propTypes.pathType.isRequired).isRequired,
	  width: _react.PropTypes.number
	};
	
	exports.default = PathsLayer;

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PlayersLayer = (_temp = _class = function (_React$Component) {
	  _inherits(PlayersLayer, _React$Component);
	
	  function PlayersLayer() {
	    _classCallCheck(this, PlayersLayer);
	
	    return _possibleConstructorReturn(this, (PlayersLayer.__proto__ || Object.getPrototypeOf(PlayersLayer)).apply(this, arguments));
	  }
	
	  _createClass(PlayersLayer, [{
	    key: 'transitionPlayerMove',
	    value: function transitionPlayerMove(playerId, coords, callback) {
	      var playerEl = document.getElementById('player-' + playerId);
	      var anim = playerEl.animate([{ left: playerEl.style.left, top: playerEl.style.top, opacity: 1 }, { left: playerEl.style.left, top: playerEl.style.top, opacity: .01, offset: .49 }, { left: coords[1] + 'px', top: coords[0] + 'px', opacity: .01, offset: .5 }, { left: coords[1] + 'px', top: coords[0] + 'px', opacity: 1 }], 500);
	      anim.onfinish = callback;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          players = _props.players,
	          playersPositions = _props.playersPositions,
	          currentPlayerId = _props.currentPlayerId;
	
	      var items = [];
	
	      playersPositions.forEach(function (pos) {
	        var loc = pos.coords;
	        items.push(_react2.default.createElement(
	          'span',
	          {
	            id: 'player-' + pos.id,
	            key: pos.id,
	            className: 'player ' + players[pos.id].role,
	            style: { top: loc[0], left: loc[1] } },
	          pos.id === currentPlayerId && _react2.default.createElement('span', { className: 'cur-player glyphicon glyphicon-triangle-bottom' })
	        ));
	      });
	      return _react2.default.createElement(
	        'div',
	        null,
	        items
	      );
	    }
	  }]);
	
	  return PlayersLayer;
	}(_react2.default.Component), _class.propTypes = {
	  players: _react.PropTypes.objectOf(_propTypes.playerType.isRequired).isRequired,
	  playersPositions: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    id: _react.PropTypes.string.isRequired,
	    coords: _react.PropTypes.arrayOf(_react.PropTypes.number.isRequired).isRequired
	  })).isRequired,
	  currentPlayerId: _react.PropTypes.string
	}, _temp);
	exports.default = PlayersLayer;

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContinueOverlay = function ContinueOverlay(_ref) {
	  var message = _ref.message,
	      onContinue = _ref.onContinue;
	  return _react2.default.createElement(
	    'div',
	    { className: 'overlay continue-overlay' },
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      {
	        bsStyle: 'primary',
	        onClick: onContinue },
	      message
	    )
	  );
	};
	
	ContinueOverlay.propTypes = {
	  message: _react.PropTypes.string.isRequired,
	  onContinue: _react.PropTypes.func.isRequired
	};
	
	exports.default = ContinueOverlay;

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefeatMessage = function DefeatMessage(_ref) {
	  var message = _ref.message;
	  return _react2.default.createElement(
	    'div',
	    { className: 'overlay defeat-message' },
	    _react2.default.createElement(
	      'div',
	      { className: 'header-container' },
	      _react2.default.createElement('div', { className: 'shadow' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'header' },
	        'Defeat'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'message' },
	      _react2.default.createElement(
	        'span',
	        null,
	        message
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      {
	        onClick: function onClick() {
	          window.location.href = '/';
	        },
	        bsStyle: 'primary',
	        bsSize: 'large' },
	      'Back to Menu'
	    )
	  );
	};
	
	DefeatMessage.propTypes = {
	  message: _react.PropTypes.string.isRequired
	};
	
	exports.default = DefeatMessage;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _diseases = __webpack_require__(83);
	
	var _diseases2 = _interopRequireDefault(_diseases);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DiseaseStatus = (_temp = _class = function (_React$Component) {
	  _inherits(DiseaseStatus, _React$Component);
	
	  function DiseaseStatus() {
	    _classCallCheck(this, DiseaseStatus);
	
	    return _possibleConstructorReturn(this, (DiseaseStatus.__proto__ || Object.getPrototypeOf(DiseaseStatus)).apply(this, arguments));
	  }
	
	  _createClass(DiseaseStatus, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var image = this.refs.image;
	
	      image.addEventListener('animationend', function () {
	        setTimeout(_this2.props.onAnimationComplete, 500);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          color = _props.color,
	          status = _props.status;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'overlay disease-status-overlay' },
	        _react2.default.createElement(
	          'div',
	          { className: 'banner' },
	          _react2.default.createElement(
	            'div',
	            { className: 'text' },
	            status
	          )
	        ),
	        _react2.default.createElement('div', {
	          ref: 'image',
	          className: 'disease-image disease-' + color })
	      );
	    }
	  }]);
	
	  return DiseaseStatus;
	}(_react2.default.Component), _class.propTypes = {
	  status: _react.PropTypes.string.isRequired,
	  color: _react.PropTypes.oneOf(_diseases2.default),
	  onAnimationComplete: _react.PropTypes.func.isRequired
	}, _temp);
	exports.default = DiseaseStatus;

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EpidemicOverlay = function EpidemicOverlay() {
	  return _react2.default.createElement(
	    "div",
	    { className: "overlay epidemic-overlay" },
	    _react2.default.createElement(
	      "div",
	      { className: "banner" },
	      _react2.default.createElement(
	        "div",
	        { className: "text" },
	        "Epidemic"
	      )
	    )
	  );
	};
	
	exports.default = EpidemicOverlay;

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewTurnOverlay = function NewTurnOverlay(_ref) {
	  var player = _ref.player;
	  return _react2.default.createElement(
	    'div',
	    { className: 'overlay new-turn-overlay' },
	    _react2.default.createElement(
	      'div',
	      { className: 'banner banner-' + player.role },
	      _react2.default.createElement(
	        'div',
	        { className: 'text' },
	        player.name,
	        '\'s turn'
	      )
	    )
	  );
	};
	
	NewTurnOverlay.propTypes = {
	  player: _propTypes.playerType.isRequired
	};
	
	exports.default = NewTurnOverlay;

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VictoryMessage = function VictoryMessage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'overlay victory-message' },
	    _react2.default.createElement(
	      'div',
	      { className: 'header-container' },
	      _react2.default.createElement('div', { className: 'shadow' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'header' },
	        'Victory'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'message' },
	      _react2.default.createElement(
	        'span',
	        null,
	        'Congratulations, you saved the world!'
	      )
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      {
	        onClick: function onClick() {
	          window.location.href = '/';
	        },
	        bsStyle: 'primary',
	        bsSize: 'large' },
	      'Back to Menu'
	    )
	  );
	};
	
	VictoryMessage.propTypes = {
	  message: _react.PropTypes.string.isRequired
	};
	
	exports.default = VictoryMessage;

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Credits = function Credits() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'setup credits' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Credits'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Redux library by ',
	          _react2.default.createElement(
	            'a',
	            { target: 'blank', href: 'https://twitter.com/dan_abramov' },
	            'Dan Abramov'
	          ),
	          ' and ',
	          _react2.default.createElement(
	            'a',
	            { target: 'blank', href: 'https://twitter.com/acdlite' },
	            'Andrew Clark'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'React-dnd library by Dan Abramov'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'React-slingshot boilerplate project by ',
	          _react2.default.createElement(
	            'a',
	            { target: 'blank', href: 'https://twitter.com/housecor' },
	            'Cory House'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Bootstrap Superhero theme by ',
	          _react2.default.createElement(
	            'a',
	            { target: 'blank', href: 'http://thomaspark.co/' },
	            'Thomas Park'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Phage font by ',
	          _react2.default.createElement(
	            'a',
	            { target: 'blank', href: 'http://tugcu.co/' },
	            'Mehmet Reha Tugcu'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Font Awesome by ',
	          _react2.default.createElement(
	            'a',
	            { target: 'blank', href: 'http://fontawesome.io' },
	            'Dave Gandy'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Animate.css by ',
	          _react2.default.createElement(
	            'a',
	            { target: 'blank', href: 'https://daneden.me/' },
	            'Daniel Eden'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Meeple icons and station icon by ',
	          _react2.default.createElement(
	            'a',
	            { target: 'blank', href: 'http://kenney.nl/' },
	            'kenney.nl'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Virus by Monty Martin-Weber from ',
	          _react2.default.createElement(
	            'a',
	            { target: 'blank', href: 'https://thenounproject.com' },
	            'the Noun Project'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Bacteria by Boris Belov from the Noun Project'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Bacteria Icon made by Freepik from ',
	          _react2.default.createElement(
	            'a',
	            { target: 'blank', href: 'http://www.flaticon.com' },
	            'www.flaticon.com'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Bacteria by Maurizio Fusillo from the Noun Project'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Night Icon made by Freepik from www.flaticon.com'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Bacteria Icon made by Freepik from www.flaticon.com'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Building Icon by freepik'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'People crowd silhouette by ',
	          _react2.default.createElement(
	            'a',
	            { target: 'blank', href: 'http://all-silhouettes.com/' },
	            'all-silhouettes.com'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'footer',
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/' },
	        'Back'
	      )
	    )
	  );
	};
	
	exports.default = Credits;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactBootstrap = __webpack_require__(23);
	
	var _roles = __webpack_require__(118);
	
	var _roles2 = _interopRequireDefault(_roles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CustomGamePlayer = (_temp = _class = function (_React$Component) {
	  _inherits(CustomGamePlayer, _React$Component);
	
	  function CustomGamePlayer() {
	    _classCallCheck(this, CustomGamePlayer);
	
	    return _possibleConstructorReturn(this, (CustomGamePlayer.__proto__ || Object.getPrototypeOf(CustomGamePlayer)).apply(this, arguments));
	  }
	
	  _createClass(CustomGamePlayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var node = _reactDom2.default.findDOMNode(this.refs.input);
	      node.select();
	      node.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          name = _props.name,
	          role = _props.role,
	          roles = _props.roles,
	          removeEnabled = _props.removeEnabled,
	          onNameChanged = _props.onNameChanged,
	          onRoleSelected = _props.onRoleSelected,
	          onRemoveClicked = _props.onRemoveClicked;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Well,
	        { className: 'player' },
	        _react2.default.createElement(_reactBootstrap.FormControl, {
	          ref: 'input',
	          type: 'text',
	          value: name,
	          onChange: onNameChanged }),
	        _react2.default.createElement(
	          _reactBootstrap.DropdownButton,
	          {
	            id: 'player-role',
	            title: role ? _roles2.default[role].name : 'Random',
	            onSelect: onRoleSelected },
	          _react2.default.createElement(
	            _reactBootstrap.MenuItem,
	            { eventKey: '' },
	            'Random'
	          ),
	          roles.reduce(function (acc, id) {
	            acc.push(_react2.default.createElement(
	              _reactBootstrap.MenuItem,
	              { key: id, eventKey: id },
	              _roles2.default[id].name
	            ));
	            return acc;
	          }, [])
	        ),
	        _react2.default.createElement('div', { className: 'spacer' }),
	        removeEnabled && _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            bsStyle: 'link',
	            onClick: onRemoveClicked },
	          'Remove'
	        )
	      );
	    }
	  }]);
	
	  return CustomGamePlayer;
	}(_react2.default.Component), _class.propTypes = {
	  name: _react.PropTypes.string.isRequired,
	  role: _react.PropTypes.string,
	  roles: _react.PropTypes.arrayOf(_react.PropTypes.string.isRequired).isRequired,
	  removeEnabled: _react.PropTypes.bool.isRequired,
	  onNameChanged: _react.PropTypes.func.isRequired,
	  onRoleSelected: _react.PropTypes.func.isRequired,
	  onRemoveClicked: _react.PropTypes.func.isRequired
	}, _temp);
	exports.default = CustomGamePlayer;

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(114);
	
	var _reactGa = __webpack_require__(516);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    'footer',
	    null,
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'small',
	        null,
	        'Made by Alex Zherdev in 2016.'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactGa.OutboundLink,
	        {
	          eventLabel: 'outboundGithub',
	          to: 'https://github.com/alexzherdev/pandemic',
	          className: 'github',
	          target: '_blank' },
	        _react2.default.createElement('img', { src: __webpack_require__(426) })
	      ),
	      _react2.default.createElement(
	        _reactGa.OutboundLink,
	        {
	          eventLabel: 'outboundTwitter',
	          to: 'https://twitter.com/endymion_r',
	          className: 'twitter',
	          target: '_blank' },
	        _react2.default.createElement('img', { src: __webpack_require__(428) })
	      ),
	      _react2.default.createElement(
	        _reactGa.OutboundLink,
	        {
	          eventLabel: 'outboundLinkedin',
	          to: 'https://www.linkedin.com/in/alex-zherdev',
	          target: '_blank' },
	        _react2.default.createElement('img', { src: __webpack_require__(427) })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        {
	          to: 'credits',
	          className: 'credits' },
	        _react2.default.createElement(
	          'small',
	          null,
	          'Credits'
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(23);
	
	var _lodash = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuickGame = function QuickGame(_ref) {
	  var onNumberOfPlayersPicked = _ref.onNumberOfPlayersPicked,
	      onBackClicked = _ref.onBackClicked;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'quick-game' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Quick Start'
	    ),
	    _react2.default.createElement(
	      'h5',
	      null,
	      'Play a game of standard difficulty with roles chosen at random.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Choose the number of players:'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'number-container' },
	      [2, 3, 4, 5].map(function (n) {
	        return _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            key: n,
	            bsSize: 'large',
	            bsStyle: 'primary',
	            onClick: (0, _lodash.partial)(onNumberOfPlayersPicked, n) },
	          n
	        );
	      })
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.Button,
	      {
	        bsStyle: 'link',
	        onClick: onBackClicked },
	      'Back'
	    )
	  );
	};
	
	QuickGame.propTypes = {
	  onNumberOfPlayersPicked: _react.PropTypes.func.isRequired,
	  onBackClicked: _react.PropTypes.func.isRequired
	};
	
	exports.default = QuickGame;

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(23);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlayerCardCity = function PlayerCardCity(_ref) {
	  var card = _ref.card;
	  return _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'stop', style: { color: card.color } }),
	    '\xA0',
	    card.name
	  );
	};
	
	PlayerCardCity.propTypes = {
	  card: _propTypes.cardType.isRequired
	};
	
	exports.default = PlayerCardCity;

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlayerCardEpidemic = function PlayerCardEpidemic() {
	  return _react2.default.createElement(
	    "span",
	    null,
	    _react2.default.createElement(
	      "span",
	      { className: "e" },
	      "E"
	    ),
	    "\xA0 Epidemic"
	  );
	};
	
	exports.default = PlayerCardEpidemic;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(23);
	
	var _events = __webpack_require__(140);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlayerCardEvent = function PlayerCardEvent(_ref) {
	  var card = _ref.card,
	      popoverPlacement = _ref.popoverPlacement;
	  return _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'gift' }),
	    '\xA0',
	    _react2.default.createElement(
	      _reactBootstrap.OverlayTrigger,
	      {
	        id: 'event-' + card.id,
	        trigger: ['hover', 'focus'],
	        placement: popoverPlacement,
	        overlay: _react2.default.createElement(
	          _reactBootstrap.Popover,
	          { id: 'event-desc-' + card.id },
	          _events2.default[card.id].description || 'bar'
	        ) },
	      _react2.default.createElement(
	        'span',
	        { className: 'event-name' },
	        card.name
	      )
	    )
	  );
	};
	
	PlayerCardEvent.propTypes = {
	  card: _propTypes.cardType.isRequired,
	  popoverPlacement: _react.PropTypes.string.isRequired
	};
	
	exports.default = PlayerCardEvent;

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(23);
	
	var _TeamPlayerHandHeader = __webpack_require__(646);
	
	var _TeamPlayerHandHeader2 = _interopRequireDefault(_TeamPlayerHandHeader);
	
	var _PlayerCard = __webpack_require__(355);
	
	var _PlayerCard2 = _interopRequireDefault(_PlayerCard);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamPlayerHand = function TeamPlayerHand(_ref) {
	  var player = _ref.player,
	      hand = _ref.hand,
	      isCurrent = _ref.isCurrent;
	
	  return _react2.default.createElement(
	    _reactBootstrap.Panel,
	    {
	      header: _react2.default.createElement(_TeamPlayerHandHeader2.default, {
	        player: player,
	        isCurrent: isCurrent }),
	      className: 'team-player team-player-' + player.role },
	    _react2.default.createElement(
	      _reactBootstrap.ListGroup,
	      { fill: true, className: 'card-list' },
	      hand.map(function (c, i) {
	        return _react2.default.createElement(_PlayerCard2.default, {
	          key: i,
	          card: c,
	          popoverPlacement: 'left' });
	      })
	    )
	  );
	};
	
	TeamPlayerHand.propTypes = {
	  player: _propTypes.playerType.isRequired,
	  hand: _react.PropTypes.arrayOf(_propTypes.cardType.isRequired).isRequired,
	  isCurrent: _react.PropTypes.bool.isRequired
	};
	
	exports.default = TeamPlayerHand;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(23);
	
	var _roles = __webpack_require__(118);
	
	var _roles2 = _interopRequireDefault(_roles);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamPlayerHandHeader = function TeamPlayerHandHeader(_ref) {
	  var player = _ref.player,
	      isCurrent = _ref.isCurrent;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h5',
	      null,
	      isCurrent && _react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'triangle-right' }),
	      player.name
	    ),
	    _react2.default.createElement(
	      _reactBootstrap.OverlayTrigger,
	      {
	        id: 'role-' + player.role,
	        trigger: ['hover', 'focus'],
	        placement: 'left',
	        overlay: _react2.default.createElement(
	          _reactBootstrap.Popover,
	          { id: 'role-desc-' + player.role },
	          _roles2.default[player.role].description.map(function (str) {
	            return [str, _react2.default.createElement('br', { key: player.role })];
	          })
	        ) },
	      _react2.default.createElement(
	        'h6',
	        null,
	        _roles2.default[player.role].name
	      )
	    )
	  );
	};
	
	TeamPlayerHandHeader.propTypes = {
	  player: _propTypes.playerType.isRequired,
	  isCurrent: _react.PropTypes.bool.isRequired
	};
	
	exports.default = TeamPlayerHandHeader;

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cardActions = __webpack_require__(72);
	
	exports.default = Object.freeze({
	  TO_INTENSIFY_STEP: {
	    message: 'Continue to Epidemic Intensify step',
	    action: (0, _cardActions.epidemicIntensifyContinue)()
	  }
	});

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.INFECTION_DECK = exports.PLAYER_DECK = undefined;
	
	var _events = __webpack_require__(140);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var PLAYER_DECK = exports.PLAYER_DECK = Object.freeze([].concat(_toConsumableArray(Array(48).fill().map(function (_, i) {
	  return {
	    cardType: 'city',
	    id: i + ''
	  };
	})), _toConsumableArray(Object.keys(_events2.default).map(function (ev) {
	  return {
	    cardType: 'event',
	    id: ev
	  };
	}))));
	
	var INFECTION_DECK = exports.INFECTION_DECK = Object.freeze(Array(48).fill().map(function (_, i) {
	  return i + '';
	}));

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(60);
	
	var _redux = __webpack_require__(115);
	
	var _lodash = __webpack_require__(21);
	
	var _reactBootstrap = __webpack_require__(23);
	
	var _pluralize = __webpack_require__(1474);
	
	var _pluralize2 = _interopRequireDefault(_pluralize);
	
	var _mapActions = __webpack_require__(117);
	
	var mapActions = _interopRequireWildcard(_mapActions);
	
	var _diseaseActions = __webpack_require__(92);
	
	var diseaseActions = _interopRequireWildcard(_diseaseActions);
	
	var _cardActions = __webpack_require__(72);
	
	var cardActions = _interopRequireWildcard(_cardActions);
	
	var _globalActions = __webpack_require__(73);
	
	var globalActions = _interopRequireWildcard(_globalActions);
	
	var _selectors = __webpack_require__(48);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Actions = (_temp = _class = function (_React$Component) {
	  _inherits(Actions, _React$Component);
	
	  function Actions(props) {
	    _classCallCheck(this, Actions);
	
	    var _this = _possibleConstructorReturn(this, (Actions.__proto__ || Object.getPrototypeOf(Actions)).call(this, props));
	
	    _this.onTreatClicked = _this.onTreatClicked.bind(_this);
	    return _this;
	  }
	
	  _createClass(Actions, [{
	    key: 'onTreatClicked',
	    value: function onTreatClicked() {
	      var treatableDiseases = this.props.treatableDiseases;
	
	      if (Object.keys(treatableDiseases).length > 1) {
	        this.props.onShowTreatColors();
	      } else {
	        var color = Object.keys(treatableDiseases)[0];
	        this.props.onTreatColorPicked(color);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props$currentMove = this.props.currentMove,
	          shareCandidates = _props$currentMove.shareCandidates,
	          actionsLeft = _props$currentMove.actionsLeft;
	      var _props = this.props,
	          isContingencyPlannerAbilityAvailable = _props.isContingencyPlannerAbilityAvailable,
	          contPlannerEvent = _props.contPlannerEvent,
	          treatableDiseases = _props.treatableDiseases,
	          canTreatAll = _props.canTreatAll,
	          currentPlayer = _props.currentPlayer,
	          events = _props.events;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Panel,
	        {
	          className: 'actions',
	          footer: currentPlayer.name + '\'s turn, ' + (0, _pluralize2.default)('action', actionsLeft, true) + ' left' },
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            onClick: this.props.onMoveInit,
	            disabled: actionsLeft === 0 },
	          _react2.default.createElement('i', { className: 'fa fa-car' }),
	          ' / ',
	          _react2.default.createElement('i', { className: 'fa fa-plane' }),
	          _react2.default.createElement(
	            'div',
	            null,
	            'Move'
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            onClick: (0, _lodash.partial)(this.props.actions.buildStation, this.props.currentCityId),
	            disabled: !this.props.canBuildStation || actionsLeft === 0 },
	          _react2.default.createElement('i', { className: 'fa fa-building' }),
	          _react2.default.createElement(
	            'div',
	            null,
	            'Build'
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            onClick: this.props.actions.shareCardsInit,
	            disabled: !this.props.canShareCards || !(0, _lodash.isEmpty)(shareCandidates) || actionsLeft === 0 },
	          _react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'book' }),
	          _react2.default.createElement(
	            'div',
	            null,
	            'Share'
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            onClick: this.onTreatClicked,
	            disabled: (0, _lodash.isEmpty)(treatableDiseases) || actionsLeft === 0 },
	          _react2.default.createElement('i', { className: 'fa fa-medkit' }),
	          _react2.default.createElement(
	            'div',
	            null,
	            canTreatAll ? 'Treat All' : 'Treat'
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            onClick: (0, _lodash.partial)(this.props.actions.cureDiseaseInit, this.props.curableDisease),
	            disabled: !this.props.curableDisease || actionsLeft === 0 },
	          _react2.default.createElement('i', { className: 'fa fa-flask' }),
	          _react2.default.createElement(
	            'div',
	            null,
	            'Cure'
	          )
	        ),
	        isContingencyPlannerAbilityAvailable && _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            onClick: (0, _lodash.partial)(this.props.actions.contPlannerInit, this.props.currentPlayer.id),
	            disabled: actionsLeft === 0 },
	          _react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'open' }),
	          _react2.default.createElement(
	            'div',
	            null,
	            'Retrieve'
	          )
	        ),
	        !(0, _lodash.isEmpty)(contPlannerEvent) && _react2.default.createElement(_reactBootstrap.Button, {
	          className: 'card event-icon event-' + contPlannerEvent.id,
	          onClick: (0, _lodash.partial)(this.props.actions.playEventInit, this.props.currentPlayer.id, contPlannerEvent.id),
	          disabled: actionsLeft === 0 }),
	        !(0, _lodash.isEmpty)(events) && _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            onClick: this.props.onPlayEventClicked,
	            disabled: actionsLeft === 0,
	            title: 'Play an event',
	            className: 'play-event' },
	          _react2.default.createElement('img', null)
	        )
	      );
	    }
	  }]);
	
	  return Actions;
	}(_react2.default.Component), _class.propTypes = {
	  onShowTreatColors: _react.PropTypes.func.isRequired,
	  onTreatColorPicked: _react.PropTypes.func.isRequired,
	  onMoveInit: _react.PropTypes.func.isRequired,
	  onPlayEventClicked: _react.PropTypes.func.isRequired,
	
	  currentMove: _react.PropTypes.object.isRequired,
	  currentCityId: _react.PropTypes.string.isRequired,
	  canBuildStation: _react.PropTypes.bool.isRequired,
	  canTreatAll: _react.PropTypes.bool.isRequired,
	  curableDisease: _propTypes.diseaseType,
	  treatableDiseases: _react.PropTypes.objectOf(_react.PropTypes.number.isRequired),
	  currentPlayer: _propTypes.playerType.isRequired,
	  canShareCards: _react.PropTypes.bool.isRequired,
	  contPlannerEvent: _react.PropTypes.object,
	  isContingencyPlannerAbilityAvailable: _react.PropTypes.bool.isRequired,
	  events: _react.PropTypes.arrayOf(_propTypes.eventCardType.isRequired).isRequired,
	  actions: _react.PropTypes.object.isRequired
	}, _temp);
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return { currentMove: state.currentMove, currentCityId: (0, _selectors.getCurrentCityId)(state),
	    canBuildStation: (0, _selectors.canBuildStation)(state), canTreatAll: (0, _selectors.canTreatAll)(state),
	    curableDisease: (0, _selectors.getCurableDisease)(state), treatableDiseases: (0, _selectors.getTreatableDiseases)(state),
	    currentPlayer: (0, _selectors.getCurrentPlayer)(state), canShareCards: (0, _selectors.canShareCards)(state),
	    contPlannerEvent: (0, _selectors.getContPlannerEvent)(state),
	    isContingencyPlannerAbilityAvailable: (0, _selectors.isContingencyPlannerAbilityAvailable)(state),
	    events: (0, _selectors.getEventsInHands)(state)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)(_extends({}, mapActions, diseaseActions, cardActions, globalActions), dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Actions);

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(60);
	
	var _redux = __webpack_require__(115);
	
	var _reactBootstrap = __webpack_require__(23);
	
	var _lodash = __webpack_require__(21);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Actions = __webpack_require__(649);
	
	var _Actions2 = _interopRequireDefault(_Actions);
	
	var _SingleCardPicker = __webpack_require__(618);
	
	var _SingleCardPicker2 = _interopRequireDefault(_SingleCardPicker);
	
	var _MultiCardPicker = __webpack_require__(615);
	
	var _MultiCardPicker2 = _interopRequireDefault(_MultiCardPicker);
	
	var _PlayerPicker = __webpack_require__(616);
	
	var _PlayerPicker2 = _interopRequireDefault(_PlayerPicker);
	
	var _DiseasePicker = __webpack_require__(610);
	
	var _DiseasePicker2 = _interopRequireDefault(_DiseasePicker);
	
	var _Card = __webpack_require__(93);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _ForecastBar = __webpack_require__(654);
	
	var _ForecastBar2 = _interopRequireDefault(_ForecastBar);
	
	var _selectors = __webpack_require__(48);
	
	var _mapActions = __webpack_require__(117);
	
	var mapActions = _interopRequireWildcard(_mapActions);
	
	var _cardActions = __webpack_require__(72);
	
	var cardActions = _interopRequireWildcard(_cardActions);
	
	var _diseaseActions = __webpack_require__(92);
	
	var diseaseActions = _interopRequireWildcard(_diseaseActions);
	
	var _globalActions = __webpack_require__(73);
	
	var globalActions = _interopRequireWildcard(_globalActions);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BottomBar = (_temp = _class = function (_React$Component) {
	  _inherits(BottomBar, _React$Component);
	
	  function BottomBar(props) {
	    _classCallCheck(this, BottomBar);
	
	    var _this = _possibleConstructorReturn(this, (BottomBar.__proto__ || Object.getPrototypeOf(BottomBar)).call(this, props));
	
	    ['onShowTreatColors', 'onTreatColorPicked', 'onDiscardCardPicked', 'onShareCandidatePicked', 'onCureCardsPicked', 'onAirliftPlayerPicked', 'onOpsCardPicked', 'onContPlannerCardPicked', 'onMoveInit', 'onDispatcherPlayerPicked', 'onDispatcherCancel', 'chooseEvent', 'onEventPicked', 'onResPopCardPicked', 'onResPopUsed', 'onContinueTurn'].forEach(function (meth) {
	      _this[meth] = _this[meth].bind(_this);
	    });
	
	    _this.state = {
	      showTreatColors: false,
	      dispatcherPlayers: [],
	      events: []
	    };
	    return _this;
	  }
	
	  _createClass(BottomBar, [{
	    key: 'onMoveInit',
	    value: function onMoveInit() {
	      if (this.props.isDispatcher) {
	        this.setState({ dispatcherPlayers: this.props.players });
	      } else {
	        this.props.actions.moveInit(this.props.currentPlayer.id);
	      }
	    }
	  }, {
	    key: 'onShowTreatColors',
	    value: function onShowTreatColors() {
	      this.setState({ showTreatColors: true });
	    }
	  }, {
	    key: 'onTreatColorPicked',
	    value: function onTreatColorPicked(color) {
	      this.doTreat(color);
	      this.setState({ showTreatColors: false });
	    }
	  }, {
	    key: 'doTreat',
	    value: function doTreat(color) {
	      var _props = this.props,
	          treatableDiseases = _props.treatableDiseases,
	          canTreatAll = _props.canTreatAll,
	          canTreatAllOfColor = _props.canTreatAllOfColor,
	          currentCityId = _props.currentCityId;
	
	      var shouldTreatAll = canTreatAll || canTreatAllOfColor(color);
	      var count = shouldTreatAll ? treatableDiseases[color] : 1;
	      this.props.actions[shouldTreatAll ? 'treatAllDisease' : 'treatDisease'](currentCityId, color, count);
	    }
	  }, {
	    key: 'onDiscardCardPicked',
	    value: function onDiscardCardPicked(cardType, id) {
	      if (cardType === 'city') {
	        this.props.actions.discardFromHandInit('city', this.props.playerToDiscard, id);
	      } else {
	        this.props.actions.playEventInit(this.props.playerToDiscard, id);
	      }
	    }
	  }, {
	    key: 'onShareCandidatePicked',
	    value: function onShareCandidatePicked(id, share) {
	      var currentPlayer = this.props.currentPlayer;
	
	      var _ref = share === 'giver' ? [id, currentPlayer.id] : [currentPlayer.id, id],
	          _ref2 = _slicedToArray(_ref, 2),
	          giver = _ref2[0],
	          receiver = _ref2[1];
	
	      this.props.actions.shareCard(giver, receiver, this.props.currentCityId);
	    }
	  }, {
	    key: 'onCureCardsPicked',
	    value: function onCureCardsPicked(ids) {
	      this.props.actions.cureDiseaseComplete(ids, this.props.currentMove.curingDisease.color);
	    }
	  }, {
	    key: 'onAirliftPlayerPicked',
	    value: function onAirliftPlayerPicked(id) {
	      this.props.actions.airliftChoosePlayer(id);
	    }
	  }, {
	    key: 'onOpsCardPicked',
	    value: function onOpsCardPicked(cardType, id) {
	      this.props.actions.discardFromHandInit('city', this.props.currentPlayer.id, id);
	    }
	  }, {
	    key: 'onContPlannerCardPicked',
	    value: function onContPlannerCardPicked(cardType, id) {
	      this.props.actions.contPlannerChooseEvent(this.props.currentPlayer.id, id);
	    }
	  }, {
	    key: 'onDispatcherPlayerPicked',
	    value: function onDispatcherPlayerPicked(id) {
	      if (id === this.props.currentPlayer.id) {
	        this.props.actions.moveInit(this.props.currentPlayer.id);
	      } else {
	        this.props.actions.dispatcherChoosePlayer(id);
	      }
	      this.setState({ dispatcherPlayers: [] });
	    }
	  }, {
	    key: 'onDispatcherCancel',
	    value: function onDispatcherCancel() {
	      this.setState({ dispatcherPlayers: [] });
	    }
	  }, {
	    key: 'chooseEvent',
	    value: function chooseEvent() {
	      this.setState({ events: this.props.events });
	    }
	  }, {
	    key: 'onEventPicked',
	    value: function onEventPicked(cardType, id, playerId) {
	      this.setState({ events: [] });
	      this.props.actions.playEventInit(playerId, id);
	    }
	  }, {
	    key: 'onResPopCardPicked',
	    value: function onResPopCardPicked(cardType, id) {
	      this.props.actions.resPopRemoveCard(id);
	    }
	  }, {
	    key: 'onResPopUsed',
	    value: function onResPopUsed() {
	      this.props.actions.playEventInit(this.props.currentMove.resPop.suggestOwner, 'res_pop');
	    }
	  }, {
	    key: 'onContinueTurn',
	    value: function onContinueTurn() {
	      this.props.actions.continueTurn();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          playerToDiscard = _props2.playerToDiscard,
	          players = _props2.players,
	          treatableDiseases = _props2.treatableDiseases,
	          infectionDiscard = _props2.infectionDiscard,
	          cardsNeededToCure = _props2.cardsNeededToCure,
	          discardingCard = _props2.discardingCard;
	      var _props$currentMove = this.props.currentMove,
	          shareCandidates = _props$currentMove.shareCandidates,
	          curingDisease = _props$currentMove.curingDisease,
	          airlift = _props$currentMove.airlift,
	          opsMoveAbility = _props$currentMove.opsMoveAbility,
	          contPlannerEvents = _props$currentMove.contPlannerEvents,
	          availableCities = _props$currentMove.availableCities,
	          govGrantCities = _props$currentMove.govGrantCities,
	          resPop = _props$currentMove.resPop,
	          forecastCards = _props$currentMove.forecastCards;
	
	      var content = void 0;
	      if (playerToDiscard !== null) {
	        if ((0, _lodash.isEmpty)(discardingCard)) {
	          content = _react2.default.createElement(_SingleCardPicker2.default, {
	            title: 'Discard a city card or play an event:',
	            hand: this.props.getPlayerHand(playerToDiscard),
	            onCardPicked: this.onDiscardCardPicked });
	        } else {
	          content = null;
	        }
	      } else if (!(0, _lodash.isEmpty)(shareCandidates)) {
	        content = _react2.default.createElement(_PlayerPicker2.default, {
	          title: 'Pick a player to share with:',
	          players: shareCandidates,
	          onPlayerPicked: this.onShareCandidatePicked,
	          onCancel: this.props.actions.shareCardsCancel });
	      } else if (!(0, _lodash.isEmpty)(curingDisease)) {
	        content = _react2.default.createElement(_MultiCardPicker2.default, {
	          title: 'Pick ' + cardsNeededToCure + ' cards to cure the ' + curingDisease.color + ' disease:',
	          cards: curingDisease.cards,
	          countNeeded: cardsNeededToCure,
	          onSubmit: this.onCureCardsPicked,
	          onCancel: this.props.actions.cureDiseaseCancel });
	      } else if (!(0, _lodash.isEmpty)(airlift) && !airlift.playerId) {
	        content = _react2.default.createElement(_PlayerPicker2.default, {
	          title: 'Pick a player to move:',
	          players: players,
	          onPlayerPicked: this.onAirliftPlayerPicked });
	      } else if (!(0, _lodash.isEmpty)(opsMoveAbility.cards)) {
	        content = _react2.default.createElement(_SingleCardPicker2.default, {
	          hand: opsMoveAbility.cards,
	          onCardPicked: this.onOpsCardPicked });
	      } else if (!(0, _lodash.isEmpty)(contPlannerEvents)) {
	        content = _react2.default.createElement(_SingleCardPicker2.default, {
	          hand: contPlannerEvents,
	          onCardPicked: this.onContPlannerCardPicked });
	      } else if (this.state.showTreatColors) {
	        content = _react2.default.createElement(_DiseasePicker2.default, {
	          title: 'Pick a disease to treat:',
	          diseases: Object.keys(treatableDiseases),
	          onDiseasePicked: this.onTreatColorPicked });
	      } else if (!(0, _lodash.isEmpty)(this.state.dispatcherPlayers)) {
	        content = _react2.default.createElement(_PlayerPicker2.default, {
	          title: 'Pick a player to move:',
	          players: this.state.dispatcherPlayers,
	          onPlayerPicked: this.onDispatcherPlayerPicked,
	          onCancel: this.onDispatcherCancel });
	      } else if (!(0, _lodash.isEmpty)(this.state.events)) {
	        content = _react2.default.createElement(_SingleCardPicker2.default, {
	          hand: this.state.events,
	          onCardPicked: this.onEventPicked });
	      } else if (resPop.chooseCard) {
	        content = _react2.default.createElement(_SingleCardPicker2.default, {
	          title: 'Pick a card to remove from the infection discard pile:',
	          hand: infectionDiscard,
	          onCardPicked: this.onResPopCardPicked });
	      } else if (resPop.suggestOwner) {
	        content = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { onClick: this.onResPopUsed },
	            _react2.default.createElement(_Card2.default, {
	              cardType: 'event',
	              id: 'res_pop' }),
	            ' ',
	            _react2.default.createElement('br', null),
	            'Play'
	          ),
	          'or ',
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'link',
	              onClick: this.onContinueTurn },
	            'Continue'
	          )
	        );
	      } else if (!(0, _lodash.isEmpty)(forecastCards)) {
	        content = _react2.default.createElement(_ForecastBar2.default, {
	          cards: forecastCards,
	          onSubmit: this.props.actions.forecastShuffle });
	      } else {
	        content = _react2.default.createElement(_Actions2.default, {
	          key: 'actions',
	          onShowTreatColors: this.onShowTreatColors,
	          onTreatColorPicked: this.onTreatColorPicked,
	          onMoveInit: this.onMoveInit,
	          onPlayEventClicked: this.chooseEvent });
	      }
	
	      var classes = (0, _classnames2.default)(['bottom-bar', { 'hide': !(0, _lodash.isEmpty)(availableCities) || !(0, _lodash.isEmpty)(govGrantCities) }]);
	      return _react2.default.createElement(
	        _reactBootstrap.Panel,
	        { className: classes },
	        content
	      );
	    }
	  }]);
	
	  return BottomBar;
	}(_react2.default.Component), _class.propTypes = {
	  currentCityId: _react.PropTypes.string.isRequired,
	  currentPlayer: _propTypes.playerType.isRequired,
	  currentMove: _react.PropTypes.object.isRequired,
	  playerToDiscard: _react.PropTypes.string,
	  discardingCard: _propTypes.cardType,
	  getPlayerHand: _react.PropTypes.func.isRequired,
	  treatableDiseases: _react.PropTypes.objectOf(_react.PropTypes.number.isRequired),
	  canTreatAll: _react.PropTypes.bool.isRequired,
	  canTreatAllOfColor: _react.PropTypes.func.isRequired,
	  isDispatcher: _react.PropTypes.bool.isRequired,
	  players: _react.PropTypes.arrayOf(_react.PropTypes.shape(_extends({}, _propTypes.playerProps, {
	    cityId: _react.PropTypes.string.isRequired
	  })).isRequired).isRequired,
	  events: _react.PropTypes.arrayOf(_propTypes.eventCardType.isRequired).isRequired,
	  infectionDiscard: _react.PropTypes.arrayOf(_react.PropTypes.shape(_extends({}, _propTypes.cardProps, {
	    name: _react.PropTypes.string.isRequired
	  })).isRequired).isRequired,
	  cardsNeededToCure: _react.PropTypes.number.isRequired,
	  actions: _react.PropTypes.object.isRequired
	}, _temp);
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    currentCityId: (0, _selectors.getCurrentCityId)(state),
	    currentPlayer: (0, _selectors.getCurrentPlayer)(state),
	    currentMove: state.currentMove,
	    playerToDiscard: (0, _selectors.getPlayerToDiscard)(state),
	    discardingCard: (0, _selectors.getDiscardingCard)(state),
	    getPlayerHand: (0, _lodash.partial)(_selectors.getPlayerHand, state),
	    treatableDiseases: (0, _selectors.getTreatableDiseases)(state),
	    canTreatAll: (0, _selectors.canTreatAll)(state),
	    canTreatAllOfColor: (0, _lodash.partial)(_selectors.canTreatAllOfColor, state),
	    isDispatcher: (0, _selectors.isDispatcher)(state),
	    players: (0, _selectors.getPlayers)(state),
	    events: (0, _selectors.getEventsInHands)(state),
	    infectionDiscard: (0, _selectors.getInfectionDiscard)(state),
	    cardsNeededToCure: (0, _selectors.cardsNeededToCure)(state)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)(_extends({}, mapActions, cardActions, diseaseActions, globalActions), dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BottomBar);

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(60);
	
	var _lodash = __webpack_require__(21);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Hand = __webpack_require__(612);
	
	var _Hand2 = _interopRequireDefault(_Hand);
	
	var _CardDrawerDealing = __webpack_require__(620);
	
	var _CardDrawerDealing2 = _interopRequireDefault(_CardDrawerDealing);
	
	var _CardDrawerInfection = __webpack_require__(625);
	
	var _CardDrawerInfection2 = _interopRequireDefault(_CardDrawerInfection);
	
	var _CardDrawerEpidemicInfection = __webpack_require__(623);
	
	var _CardDrawerEpidemicInfection2 = _interopRequireDefault(_CardDrawerEpidemicInfection);
	
	var _CardDrawerEpidemicIntensify = __webpack_require__(624);
	
	var _CardDrawerEpidemicIntensify2 = _interopRequireDefault(_CardDrawerEpidemicIntensify);
	
	var _CardDrawerDiscardingPlayerCard = __webpack_require__(621);
	
	var _CardDrawerDiscardingPlayerCard2 = _interopRequireDefault(_CardDrawerDiscardingPlayerCard);
	
	var _CardDrawerDrawingPlayerCards = __webpack_require__(622);
	
	var _CardDrawerDrawingPlayerCards2 = _interopRequireDefault(_CardDrawerDrawingPlayerCards);
	
	var _DiscardPile = __webpack_require__(609);
	
	var _DiscardPile2 = _interopRequireDefault(_DiscardPile);
	
	var _cardActions = __webpack_require__(72);
	
	var _globalActions = __webpack_require__(73);
	
	var _selectors = __webpack_require__(48);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CardLayer = (_temp = _class = function (_React$Component) {
	  _inherits(CardLayer, _React$Component);
	
	  function CardLayer(props) {
	    _classCallCheck(this, CardLayer);
	
	    var _this = _possibleConstructorReturn(this, (CardLayer.__proto__ || Object.getPrototypeOf(CardLayer)).call(this, props));
	
	    _this.onEpidemicHandle = _this.onEpidemicHandle.bind(_this);
	    _this.getPlayerDeck = _this.getPlayerDeck.bind(_this);
	    _this.getInfectionDeck = _this.getInfectionDeck.bind(_this);
	    _this.getPlayerDiscard = _this.getPlayerDiscard.bind(_this);
	    _this.getInfectionDiscard = _this.getInfectionDiscard.bind(_this);
	    _this.state = { startingDraw: false, newPlayerDealing: false, cardsDrawnAnimated: false };
	    return _this;
	  }
	
	  _createClass(CardLayer, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var startingInfectionDraw = this.props.infectionCardDrawn !== nextProps.infectionCardDrawn;
	      this.setState({
	        startingDraw: this.props.cardsDrawn.length < nextProps.cardsDrawn.length || startingInfectionDraw,
	        newPlayerDealing: this.props.playerIndex !== nextProps.playerIndex,
	        startingEpidemicInsertion: !this.props.isDealingEpidemicCards && nextProps.isDealingEpidemicCards
	      });
	      if (this.state.cardsDrawnAnimated && this.props.currentPlayerId !== nextProps.currentPlayerId) {
	        this.setState({ cardsDrawnAnimated: false });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _this2 = this;
	
	      if (!(0, _lodash.isEmpty)(this.props.cardsDrawn)) {
	        if (!this.state.cardsDrawnAnimated) {
	          var cardEls = document.querySelectorAll('.card-drawer .card.invisible');
	          var offsets = $(cardEls).map(function () {
	            return $(this).offset();
	          });
	          var playerDeckOffset = $(this.refs.playerDeck).offset();
	          $(cardEls).addClass('flipper').removeClass('invisible');
	
	          var animationCompleteCounter = 2;
	          Array.from(cardEls).forEach(function (c, i) {
	            var anim = c.animate([{ transform: 'translate(' + (playerDeckOffset.left - offsets[i].left) + 'px, ' + (playerDeckOffset.top - offsets[i].top) + 'px) scale(0.2)' }, { transform: 'translate(0, 0) scale(1) rotateY(180deg)' }], {
	              duration: 500,
	              fill: 'forwards'
	            });
	
	            anim.onfinish = function () {
	              animationCompleteCounter--;
	              if (animationCompleteCounter === 0) {
	                _this2.setState({ cardsDrawnAnimated: true });
	                _this2.props.dispatch((0, _globalActions.animationDrawCardsInitComplete)());
	              }
	            };
	          });
	        } else {
	          var movedInHand = document.querySelector('.hand .card.invisible');
	          var movedInDrawer = document.querySelector('.card-drawer .move-to-hand');
	          if (movedInHand && movedInDrawer) {
	            var src = $(movedInDrawer).offset();
	            var dest = $(movedInHand).offset();
	            var anim = movedInHand.animate([{ transform: 'translate(' + (src.left - dest.left) + 'px, ' + (src.top - dest.top) + 'px)' }, { transform: 'translate(0, 0)' }], {
	              duration: 500,
	              fill: 'forwards'
	            });
	            $(movedInHand).removeClass('invisible');
	            $(movedInDrawer).addClass('invisible');
	            anim.onfinish = function () {
	              var card = (0, _lodash.find)(_this2.props.cardsDrawn, { handling: true });
	              _this2.props.dispatch((0, _cardActions.drawCardsHandle)({ cardType: card.cardType, id: card.id }, _this2.props.currentPlayerId));
	            };
	          }
	        }
	      }
	    }
	  }, {
	    key: 'getPlayerDeck',
	    value: function getPlayerDeck() {
	      return this.refs.playerDeck;
	    }
	  }, {
	    key: 'getInfectionDeck',
	    value: function getInfectionDeck() {
	      return this.refs.infectionDeck;
	    }
	  }, {
	    key: 'getPlayerDiscard',
	    value: function getPlayerDiscard() {
	      return this.refs.playerDiscard;
	    }
	  }, {
	    key: 'getInfectionDiscard',
	    value: function getInfectionDiscard() {
	      return this.refs.infectionDiscard;
	    }
	  }, {
	    key: 'onEpidemicHandle',
	    value: function onEpidemicHandle(cardType, id) {
	      this.props.dispatch((0, _cardActions.drawCardsHandle)({ cardType: cardType, id: id }, this.props.currentPlayerId));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cardsDrawn = _props.cardsDrawn,
	          infectionCardDrawn = _props.infectionCardDrawn,
	          isDealingPlayerCards = _props.isDealingPlayerCards,
	          playerIndex = _props.playerIndex,
	          isDealingEpidemicCards = _props.isDealingEpidemicCards,
	          difficulty = _props.difficulty,
	          initialInfectedCity = _props.initialInfectedCity,
	          isPlaying = _props.isPlaying,
	          discardingCard = _props.discardingCard,
	          playerDiscardTop = _props.playerDiscardTop,
	          infectionDiscardTop = _props.infectionDiscardTop,
	          epidemicInfectionCard = _props.epidemicInfectionCard,
	          epidemicStep = _props.epidemicStep,
	          currentPlayerId = _props.currentPlayerId;
	
	      var isDrawingInfectionCard = !(0, _lodash.isEmpty)(infectionCardDrawn);
	
	      var hand = this.props.hand;
	
	      var drawer = void 0;
	
	      var infectionDiscard = _react2.default.createElement(_DiscardPile2.default, {
	        ref: 'infectionDiscard',
	        className: 'infection-discard',
	        discardTop: infectionDiscardTop });
	      if (isDealingPlayerCards || isDealingEpidemicCards) {
	        drawer = _react2.default.createElement(_CardDrawerDealing2.default, {
	          isDealingEpidemicCards: isDealingEpidemicCards,
	          difficulty: difficulty,
	          playerIndex: playerIndex,
	          newPlayerDealing: this.state.newPlayerDealing,
	          cardsDealtCount: this.props.cardsDealtCount,
	          getPlayerDeck: this.getPlayerDeck,
	          players: this.props.players,
	          startingEpidemicInsertion: this.state.startingEpidemicInsertion,
	          onDealCardsInitComplete: (0, _lodash.partial)(this.props.dispatch, (0, _globalActions.animationDealCardsInitComplete)()),
	          onDealCardsComplete: (0, _lodash.partial)(this.props.dispatch, (0, _globalActions.animationDealCardsComplete)()),
	          onInsertEpidemicCardsComplete: (0, _lodash.partial)(this.props.dispatch, (0, _globalActions.animationInsertEpidemicCardsComplete)())
	        });
	      } else if (initialInfectedCity !== null || isDrawingInfectionCard) {
	        drawer = _react2.default.createElement(_CardDrawerInfection2.default, {
	          infectedCity: initialInfectedCity || infectionCardDrawn.id,
	          infectedLocation: this.props.infectingLocation,
	          map: this.props.map,
	          getInfectionDeck: this.getInfectionDeck,
	          getInfectionDiscard: this.getInfectionDiscard,
	          onAnimationComplete: (0, _lodash.partial)(this.props.dispatch, (0, _globalActions.animationDrawInfectionCardComplete)()) });
	      } else if (!(0, _lodash.isEmpty)(discardingCard)) {
	        drawer = _react2.default.createElement(_CardDrawerDiscardingPlayerCard2.default, {
	          card: discardingCard,
	          getPlayerDiscard: this.getPlayerDiscard,
	          isCurrentPlayerDiscarding: discardingCard.playerId === currentPlayerId,
	          onAnimationComplete: (0, _lodash.partial)(this.props.dispatch, (0, _globalActions.animationCardDiscardFromHandComplete)(discardingCard.cardType, discardingCard.playerId, discardingCard.id)) });
	      } else if (!(0, _lodash.isEmpty)(epidemicInfectionCard)) {
	        drawer = _react2.default.createElement(_CardDrawerEpidemicInfection2.default, {
	          getInfectionDeck: this.getInfectionDeck,
	          getInfectionDiscard: this.getInfectionDiscard,
	          infectionCard: epidemicInfectionCard,
	          onAnimationComplete: (0, _lodash.partial)(this.props.dispatch, (0, _globalActions.continueTurn)()) });
	      } else if (epidemicStep === 'intensify') {
	        drawer = _react2.default.createElement(_CardDrawerEpidemicIntensify2.default, {
	          getInfectionDeck: this.getInfectionDeck,
	          infectionDiscard: infectionDiscard,
	          getInfectionDiscard: this.getInfectionDiscard,
	          onAnimationComplete: (0, _lodash.partial)(this.props.dispatch, (0, _cardActions.epidemicIntensify)()) });
	      } else if (!(0, _lodash.isEmpty)(cardsDrawn)) {
	        drawer = _react2.default.createElement(_CardDrawerDrawingPlayerCards2.default, {
	          cards: cardsDrawn,
	          startingDraw: this.state.startingDraw,
	          onEpidemicHandle: this.onEpidemicHandle });
	      }
	
	      var empty = !drawer;
	      if (empty) {
	        drawer = _react2.default.createElement('div', { className: 'card-drawer' });
	      }
	
	      if (!(0, _lodash.isEmpty)(cardsDrawn)) {
	        for (var i = 0; i < cardsDrawn.length; i++) {
	          var c = cardsDrawn[i];
	          if (c.handling && c.cardType !== 'epidemic') {
	            hand = (0, _selectors.sortHand)([].concat(_toConsumableArray(hand), [c]));
	            break;
	          }
	        }
	      }
	      if (!(0, _lodash.isEmpty)(discardingCard)) {
	        hand = hand.filter(function (c) {
	          return c.id !== discardingCard.id || c.cardType !== discardingCard.cardType;
	        });
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(['card-layer', {
	            'empty': empty
	          }]) },
	        _react2.default.createElement(_DiscardPile2.default, {
	          ref: 'playerDiscard',
	          className: 'player-discard',
	          discardTop: playerDiscardTop }),
	        _react2.default.createElement('span', {
	          ref: 'playerDeck',
	          className: 'card player-deck deck-icon' }),
	        _react2.default.createElement('span', {
	          ref: 'infectionDeck',
	          className: 'card infection-deck deck-icon' }),
	        infectionDiscard,
	        drawer,
	        isPlaying && _react2.default.createElement(_Hand2.default, { hand: hand })
	      );
	    }
	  }]);
	
	  return CardLayer;
	}(_react2.default.Component), _class.propTypes = {
	  map: _react.PropTypes.object,
	  cardsDrawn: _react.PropTypes.arrayOf(_react.PropTypes.shape(_extends({}, _propTypes.cardProps, {
	    handling: _react.PropTypes.bool
	  }))).isRequired,
	  difficulty: _react.PropTypes.number.isRequired,
	  currentPlayerId: _react.PropTypes.string.isRequired,
	  initialInfectedCity: _react.PropTypes.string,
	  infectingLocation: _react.PropTypes.object,
	  isDealingPlayerCards: _react.PropTypes.bool,
	  isDealingEpidemicCards: _react.PropTypes.bool,
	  cardsDealtCount: _react.PropTypes.number,
	  playerIndex: _react.PropTypes.number,
	  infectionCardDrawn: _react.PropTypes.shape({
	    id: _react.PropTypes.string,
	    handling: _react.PropTypes.bool
	  }),
	  epidemicInfectionCard: _react.PropTypes.shape({
	    id: _react.PropTypes.string
	  }),
	  epidemicStep: _react.PropTypes.string,
	  players: _react.PropTypes.arrayOf(_propTypes.playerType.isRequired).isRequired,
	  isPlaying: _react.PropTypes.bool.isRequired,
	  hand: _react.PropTypes.arrayOf(_propTypes.cardType.isRequired),
	  discardingCard: _propTypes.cardType,
	  playerDiscardTop: _propTypes.cardType,
	  infectionDiscardTop: _propTypes.cardType,
	  dispatch: _react.PropTypes.func.isRequired
	}, _temp);
	
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var infectionCardDrawn = (0, _selectors.getInfectionCardDrawn)(state);
	
	  var props = {
	    cardsDrawn: (0, _selectors.getCardsDrawn)(state),
	    infectionCardDrawn: infectionCardDrawn,
	    discardingCard: (0, _selectors.getDiscardingCard)(state),
	    currentPlayerId: state.currentMove.player,
	    isDealingPlayerCards: (0, _selectors.isDealingPlayerCards)(state),
	    isDealingEpidemicCards: (0, _selectors.isDealingEpidemicCards)(state),
	    playerIndex: (0, _selectors.getPlayerDealtToIndex)(state),
	    cardsDealtCount: (0, _selectors.getCardsDealtCount)(state),
	    players: (0, _selectors.getPlayers)(state),
	    difficulty: (0, _selectors.getDifficulty)(state),
	    infectingLocation: state.map.locations[ownProps.initialInfectedCity || infectionCardDrawn.id],
	    isPlaying: (0, _selectors.isPlaying)(state),
	    playerDiscardTop: (0, _selectors.getPlayerDiscardTop)(state),
	    infectionDiscardTop: (0, _selectors.getInfectionDiscardTop)(state),
	    epidemicInfectionCard: (0, _selectors.getEpidemicInfectionCard)(state),
	    epidemicStep: (0, _selectors.getEpidemicStep)(state)
	  };
	  if (props.isPlaying) {
	    props = _extends({}, props, {
	      hand: (0, _selectors.getCurrentPlayerHand)(state)
	    });
	  }
	  return props;
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(CardLayer);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(23);
	
	var _lodash = __webpack_require__(21);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CustomGamePlayer = __webpack_require__(639);
	
	var _CustomGamePlayer2 = _interopRequireDefault(_CustomGamePlayer);
	
	var _names = __webpack_require__(356);
	
	var _names2 = _interopRequireDefault(_names);
	
	var _roles = __webpack_require__(118);
	
	var _roles2 = _interopRequireDefault(_roles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DIFFICULTIES = {
	  4: 'Introductory',
	  5: 'Standard',
	  6: 'Heroic'
	};
	
	var STORAGE_KEY = 'CUSTOM_GAME_SETTINGS';
	
	var CustomGame = (_temp = _class = function (_React$Component) {
	  _inherits(CustomGame, _React$Component);
	
	  function CustomGame(props) {
	    _classCallCheck(this, CustomGame);
	
	    var _this = _possibleConstructorReturn(this, (CustomGame.__proto__ || Object.getPrototypeOf(CustomGame)).call(this, props));
	
	    _this.onAddPlayerClicked = _this.onAddPlayerClicked.bind(_this);
	    _this.onRemovePlayerClicked = _this.onRemovePlayerClicked.bind(_this);
	    _this.onPlayerNameChanged = _this.onPlayerNameChanged.bind(_this);
	    _this.onPlayerRoleSelected = _this.onPlayerRoleSelected.bind(_this);
	    _this.onDifficultySelected = _this.onDifficultySelected.bind(_this);
	    _this.onPlayButtonClicked = _this.onPlayButtonClicked.bind(_this);
	
	    var storedState = localStorage.getItem(STORAGE_KEY);
	    var randomNames = (0, _lodash.sampleSize)(_names2.default, 2);
	    _this.state = storedState ? JSON.parse(storedState) : {
	      difficulty: 5,
	      players: [{
	        name: randomNames[0],
	        role: null // random
	      }, {
	        name: randomNames[1],
	        role: null // random
	      }]
	    };
	    return _this;
	  }
	
	  _createClass(CustomGame, [{
	    key: 'onAddPlayerClicked',
	    value: function onAddPlayerClicked() {
	      var _this2 = this;
	
	      var availableNames = _names2.default.filter(function (name) {
	        return !(0, _lodash.find)(_this2.state.players, { name: name });
	      });
	      var name = (0, _lodash.sample)(availableNames);
	      this.setState({ players: [].concat(_toConsumableArray(this.state.players), [{ name: name, role: null }]) });
	    }
	  }, {
	    key: 'onRemovePlayerClicked',
	    value: function onRemovePlayerClicked(index) {
	      this.setState({ players: [].concat(_toConsumableArray(this.state.players.slice(0, index)), _toConsumableArray(this.state.players.slice(index + 1))) });
	    }
	  }, {
	    key: 'onPlayerNameChanged',
	    value: function onPlayerNameChanged(event, index) {
	      var _this3 = this;
	
	      var name = event.target.value;
	      this.setState({ players: this.state.players.map(function (pl, i) {
	          return i === index ? _extends({}, _this3.state.players[index], { name: name }) : pl;
	        }) });
	    }
	  }, {
	    key: 'onPlayerRoleSelected',
	    value: function onPlayerRoleSelected(role, event, index) {
	      var _this4 = this;
	
	      this.setState({ players: this.state.players.map(function (pl, i) {
	          return i === index ? _extends({}, _this4.state.players[index], { role: role }) : pl;
	        }) });
	    }
	  }, {
	    key: 'getAvailableRoles',
	    value: function getAvailableRoles() {
	      return (0, _lodash.difference)(Object.keys(_roles2.default), this.state.players.map(function (pl) {
	        return pl.role;
	      }));
	    }
	  }, {
	    key: 'onDifficultySelected',
	    value: function onDifficultySelected(difficulty) {
	      this.setState({ difficulty: difficulty });
	    }
	  }, {
	    key: 'onPlayButtonClicked',
	    value: function onPlayButtonClicked() {
	      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.state));
	      this.props.onComplete(this.state.players, +this.state.difficulty);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'custom-game' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Custom Game'
	        ),
	        _react2.default.createElement(
	          'h5',
	          null,
	          'Your settings will be saved in the browser for future sessions.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'difficulty' },
	          _react2.default.createElement(
	            'span',
	            null,
	            'Difficulty Level:'
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.DropdownButton,
	            {
	              id: 'difficulty',
	              title: DIFFICULTIES[this.state.difficulty],
	              onSelect: this.onDifficultySelected },
	            (0, _lodash.map)(DIFFICULTIES, function (text, level) {
	              return _react2.default.createElement(
	                _reactBootstrap.MenuItem,
	                {
	                  key: level,
	                  eventKey: level },
	                text
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'player-container' },
	          this.state.players.map(function (pl, i) {
	            return _react2.default.createElement(_CustomGamePlayer2.default, {
	              key: i,
	              name: pl.name,
	              role: pl.role,
	              roles: _this5.getAvailableRoles(),
	              removeEnabled: _this5.state.players.length > 2,
	              onNameChanged: (0, _lodash.partialRight)(_this5.onPlayerNameChanged, i),
	              onRoleSelected: (0, _lodash.partialRight)(_this5.onPlayerRoleSelected, i),
	              onRemoveClicked: (0, _lodash.partial)(_this5.onRemovePlayerClicked, i) });
	          })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            className: (0, _classnames2.default)(["add-player", { 'invisible': this.state.players.length === 5 }]),
	            bsStyle: 'link',
	            onClick: this.onAddPlayerClicked },
	          'Add Player'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'button-container' },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              bsStyle: 'primary',
	              bsSize: 'large',
	              onClick: this.onPlayButtonClicked },
	            'Play'
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              onClick: this.props.onBackClicked,
	              bsStyle: 'link' },
	            'Back'
	          )
	        )
	      );
	    }
	  }]);
	
	  return CustomGame;
	}(_react2.default.Component), _class.propTypes = {
	  onComplete: _react.PropTypes.func.isRequired,
	  onBackClicked: _react.PropTypes.func.isRequired
	}, _temp);
	exports.default = CustomGame;

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(60);
	
	var _reactBootstrap = __webpack_require__(23);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(467);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CardList = __webpack_require__(608);
	
	var _CardList2 = _interopRequireDefault(_CardList);
	
	var _selectors = __webpack_require__(48);
	
	var _propTypes = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DiscardPanel = (_temp = _class = function (_React$Component) {
	  _inherits(DiscardPanel, _React$Component);
	
	  function DiscardPanel(props) {
	    _classCallCheck(this, DiscardPanel);
	
	    var _this = _possibleConstructorReturn(this, (DiscardPanel.__proto__ || Object.getPrototypeOf(DiscardPanel)).call(this, props));
	
	    _this.state = {
	      showDrawer: false
	    };
	
	    _this.toggleDrawer = _this.toggleDrawer.bind(_this);
	    return _this;
	  }
	
	  _createClass(DiscardPanel, [{
	    key: 'toggleDrawer',
	    value: function toggleDrawer() {
	      this.setState({ showDrawer: !this.state.showDrawer });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          playerDiscard = _props.playerDiscard,
	          infectionDiscard = _props.infectionDiscard;
	
	      var items = void 0;
	      if (this.state.showDrawer) {
	        items = [_react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            key: 'button',
	            onClick: this.toggleDrawer,
	            bsStyle: 'warning' },
	          _react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'chevron-up' })
	        ), _react2.default.createElement(
	          _reactBootstrap.Tabs,
	          {
	            key: 'tabs',
	            defaultActiveKey: 2,
	            id: 'discard-tabs',
	            className: 'discard-tabs' },
	          _react2.default.createElement(
	            _reactBootstrap.Tab,
	            {
	              eventKey: 1,
	              title: _react2.default.createElement('span', { className: 'player-discard' }) },
	            !!playerDiscard.length && _react2.default.createElement(_CardList2.default, { cards: playerDiscard }),
	            !playerDiscard.length && _react2.default.createElement(
	              'div',
	              { className: 'empty' },
	              'Player Discard is empty.'
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Tab,
	            {
	              eventKey: 2,
	              title: _react2.default.createElement('span', { className: 'infection-discard' }) },
	            !!infectionDiscard.length && _react2.default.createElement(_CardList2.default, { cards: infectionDiscard }),
	            !infectionDiscard.length && _react2.default.createElement(
	              'div',
	              { className: 'empty' },
	              'Infection Discard is empty.'
	            )
	          )
	        )];
	      } else {
	        items = _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            onClick: this.toggleDrawer,
	            bsStyle: 'warning' },
	          'Discard',
	          _react2.default.createElement('br', null),
	          ' ',
	          _react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'chevron-down' })
	        );
	      }
	      return _react2.default.createElement(
	        _reactAddonsCssTransitionGroup2.default,
	        {
	          transitionName: 'fade',
	          transitionEnterTimeout: 500,
	          transitionLeaveTimeout: 300,
	          className: (0, _classnames2.default)(['discard-drawer', { 'open': this.state.showDrawer }]) },
	        items
	      );
	    }
	  }]);
	
	  return DiscardPanel;
	}(_react2.default.Component), _class.propTypes = {
	  playerDiscard: _react.PropTypes.arrayOf(_propTypes.cardType.isRequired).isRequired,
	  infectionDiscard: _react.PropTypes.arrayOf(_propTypes.cardType.isRequired).isRequired
	}, _temp);
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    playerDiscard: (0, _selectors.getPlayerDiscard)(state),
	    infectionDiscard: (0, _selectors.getInfectionDiscard)(state)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(DiscardPanel);

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(23);
	
	var _reactDnd = __webpack_require__(491);
	
	var _reactDndHtml5Backend = __webpack_require__(1561);
	
	var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);
	
	var _lodash = __webpack_require__(21);
	
	var _DraggableCard = __webpack_require__(611);
	
	var _DraggableCard2 = _interopRequireDefault(_DraggableCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ForecastBar = (_dec = (0, _reactDnd.DragDropContext)(_reactDndHtml5Backend2.default), _dec(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(ForecastBar, _React$Component);
	
	  function ForecastBar(props) {
	    _classCallCheck(this, ForecastBar);
	
	    var _this = _possibleConstructorReturn(this, (ForecastBar.__proto__ || Object.getPrototypeOf(ForecastBar)).call(this, props));
	
	    _this.moveCard = _this.moveCard.bind(_this);
	    _this.state = { cards: _this.props.cards.slice() };
	    return _this;
	  }
	
	  _createClass(ForecastBar, [{
	    key: 'moveCard',
	    value: function moveCard(dragIndex, hoverIndex) {
	      var cards = this.state.cards;
	
	      var dragCard = cards[dragIndex];
	      var newCards = cards.slice();
	      newCards.splice(dragIndex, 1);
	      newCards.splice(hoverIndex, 0, dragCard);
	      this.setState({ cards: newCards });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Panel,
	        {
	          header: 'Specify the order (left to right -> top to bottom):',
	          className: 'forecast-bar card-picker',
	          footer: _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                onClick: (0, _lodash.partial)(this.props.onSubmit, this.state.cards) },
	              'OK'
	            )
	          ) },
	        this.state.cards.map(function (c, i) {
	          return _react2.default.createElement(_DraggableCard2.default, {
	            key: c,
	            cardType: 'city',
	            id: c,
	            index: i,
	            moveCard: _this2.moveCard });
	        })
	      );
	    }
	  }]);
	
	  return ForecastBar;
	}(_react2.default.Component), _class2.propTypes = {
	  cards: _react.PropTypes.arrayOf(_react.PropTypes.string.isRequired).isRequired,
	  onSubmit: _react.PropTypes.func.isRequired
	}, _temp)) || _class);
	exports.default = ForecastBar;

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(23);
	
	var _reactRouter = __webpack_require__(114);
	
	var _reactRedux = __webpack_require__(60);
	
	var _redux = __webpack_require__(115);
	
	var _lodash = __webpack_require__(21);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _TopBar = __webpack_require__(659);
	
	var _TopBar2 = _interopRequireDefault(_TopBar);
	
	var _Map = __webpack_require__(656);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _TeamPanel = __webpack_require__(619);
	
	var _TeamPanel2 = _interopRequireDefault(_TeamPanel);
	
	var _LoadingScreen = __webpack_require__(614);
	
	var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);
	
	var _BottomBar = __webpack_require__(650);
	
	var _BottomBar2 = _interopRequireDefault(_BottomBar);
	
	var _CardLayer = __webpack_require__(651);
	
	var _CardLayer2 = _interopRequireDefault(_CardLayer);
	
	var _DiscardPanel = __webpack_require__(653);
	
	var _DiscardPanel2 = _interopRequireDefault(_DiscardPanel);
	
	var _ContinueOverlay = __webpack_require__(632);
	
	var _ContinueOverlay2 = _interopRequireDefault(_ContinueOverlay);
	
	var _EpidemicOverlay = __webpack_require__(635);
	
	var _EpidemicOverlay2 = _interopRequireDefault(_EpidemicOverlay);
	
	var _NewTurnOverlay = __webpack_require__(636);
	
	var _NewTurnOverlay2 = _interopRequireDefault(_NewTurnOverlay);
	
	var _DefeatMessage = __webpack_require__(633);
	
	var _DefeatMessage2 = _interopRequireDefault(_DefeatMessage);
	
	var _VictoryMessage = __webpack_require__(637);
	
	var _VictoryMessage2 = _interopRequireDefault(_VictoryMessage);
	
	var _DiseaseStatus = __webpack_require__(634);
	
	var _DiseaseStatus2 = _interopRequireDefault(_DiseaseStatus);
	
	var _IntroDialog = __webpack_require__(613);
	
	var _IntroDialog2 = _interopRequireDefault(_IntroDialog);
	
	var _StateReporter = __webpack_require__(658);
	
	var _StateReporter2 = _interopRequireDefault(_StateReporter);
	
	var _mapActions = __webpack_require__(117);
	
	var mapActions = _interopRequireWildcard(_mapActions);
	
	var _globalActions = __webpack_require__(73);
	
	var globalActions = _interopRequireWildcard(_globalActions);
	
	var _selectors = __webpack_require__(48);
	
	var _propTypes = __webpack_require__(14);
	
	var _utils = __webpack_require__(94);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Preload = __webpack_require__(1649).Preload;
	
	var HINT_STORAGE_KEY = 'DOUBLE_CLICK_HINT_DISMISSED';
	
	var Game = (_temp = _class = function (_React$Component) {
	  _inherits(Game, _React$Component);
	
	  function Game(props) {
	    _classCallCheck(this, Game);
	
	    var _this = _possibleConstructorReturn(this, (Game.__proto__ || Object.getPrototypeOf(Game)).call(this, props));
	
	    _this.state = {
	      showIntro: true,
	      initialInfectedCity: null,
	      isNewTurn: false,
	      doubleClickHintDismissed: !!localStorage.getItem(HINT_STORAGE_KEY)
	    };
	
	
	    ['onCityClicked', 'onCityDoubleClicked', 'onIntroClosed', 'onDoubleClickHintClosed'].forEach(function (meth) {
	      _this[meth] = _this[meth].bind(_this);
	    });
	    return _this;
	  }
	
	  _createClass(Game, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.router.setRouteLeaveHook(this.props.route, function () {
	        return 'Do you want to leave the game?';
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.initialInfectedCity !== nextProps.initialInfectedCity) {
	        this.setState({ initialInfectedCity: nextProps.initialInfectedCity });
	      }
	      this.setState({ isNewTurn: this.props.currentPlayerId !== nextProps.currentPlayerId });
	    }
	  }, {
	    key: 'doMovePlayer',
	    value: function doMovePlayer(destinationId, source) {
	      var playerToMove = this.props.currentMove.playerToMove;
	
	      var playerId = void 0,
	          originId = void 0;
	      if (playerToMove) {
	        playerId = playerToMove;
	        originId = this.props.getPlayerCityId(playerId);
	      } else {
	        playerId = this.props.currentPlayerId;
	        originId = this.props.currentCityId;
	      }
	
	      this.refs.map.getWrappedInstance().transitionPlayerMove(playerId, destinationId, true);
	      this.props.actions.moveToCity(playerId, originId, destinationId, source);
	    }
	  }, {
	    key: 'onIntroClosed',
	    value: function onIntroClosed() {
	      this.setState({ showIntro: false });
	      this.props.actions.dealCardsInit();
	    }
	  }, {
	    key: 'onCityClicked',
	    value: function onCityClicked(id) {
	      var _props$currentMove = this.props.currentMove,
	          availableCities = _props$currentMove.availableCities,
	          airlift = _props$currentMove.airlift,
	          govGrantCities = _props$currentMove.govGrantCities;
	
	      if (!(0, _lodash.isEmpty)(availableCities)) {
	        var source = availableCities[id].source;
	
	        this.doMovePlayer(id, source);
	      } else if (!(0, _lodash.isEmpty)(govGrantCities)) {
	        this.props.actions.govGrantBuildStation(id);
	      } else if (!(0, _lodash.isEmpty)(airlift) && !(0, _lodash.isEmpty)(airlift.cities)) {
	        this.refs.map.getWrappedInstance().transitionPlayerMove(airlift.playerId, id);
	        this.props.actions.airliftMoveToCity(airlift.playerId, id);
	      }
	    }
	  }, {
	    key: 'onCityDoubleClicked',
	    value: function onCityDoubleClicked(id) {
	      this.doMovePlayer(id, 'drive');
	    }
	  }, {
	    key: 'onDoubleClickHintClosed',
	    value: function onDoubleClickHintClosed() {
	      localStorage.setItem(HINT_STORAGE_KEY, 'true');
	      this.setState({ doubleClickHintDismissed: true });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          status = _props.status,
	          defeatMessage = _props.defeatMessage,
	          isEpidemicInProgress = _props.isEpidemicInProgress,
	          players = _props.players,
	          getPlayerHand = _props.getPlayerHand,
	          currentPlayerId = _props.currentPlayerId,
	          continueMessage = _props.continueMessage,
	          cureInProgress = _props.cureInProgress;
	
	      return _react2.default.createElement(
	        Preload,
	        {
	          loadingIndicator: _react2.default.createElement(_LoadingScreen2.default, null),
	          images: _utils.IMAGES_TO_PRELOAD,
	          autoResolveDelay: 30000,
	          resolveOnError: true,
	          mountChildren: true },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(['game modal-container animated fadeIn', { 'epidemic': isEpidemicInProgress }]) },
	          _react2.default.createElement(_StateReporter2.default, null),
	          status === 'playing' && !this.state.doubleClickHintDismissed && _react2.default.createElement(
	            _reactBootstrap.Popover,
	            {
	              className: 'double-click-hint',
	              placement: 'bottom',
	              positionLeft: 10,
	              positionTop: 0,
	              title: _react2.default.createElement(
	                'div',
	                null,
	                'Hint',
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  {
	                    bsStyle: 'link',
	                    onClick: this.onDoubleClickHintClosed },
	                  '\xD7'
	                )
	              ) },
	            'You can double-click on a neighbor city to drive to it.'
	          ),
	          _react2.default.createElement(_DiscardPanel2.default, null),
	          _react2.default.createElement(_TopBar2.default, null),
	          status !== 'prepare' && _react2.default.createElement(_BottomBar2.default, null),
	          _react2.default.createElement(_Map2.default, {
	            ref: 'map',
	            onCityClicked: this.onCityClicked,
	            onCityDoubleClicked: this.onCityDoubleClicked,
	            initialInfectedCity: this.state.initialInfectedCity }),
	          status !== 'prepare' && _react2.default.createElement(_TeamPanel2.default, {
	            players: players,
	            getPlayerHand: getPlayerHand,
	            currentPlayerId: currentPlayerId }),
	          _react2.default.createElement(_CardLayer2.default, {
	            map: this.refs.map && this.refs.map.getWrappedInstance(),
	            initialInfectedCity: this.state.initialInfectedCity }),
	          status === 'prepare' && this.state.showIntro && _react2.default.createElement(_IntroDialog2.default, {
	            players: players,
	            container: this,
	            onClosed: this.onIntroClosed }),
	          continueMessage && _react2.default.createElement(_ContinueOverlay2.default, {
	            message: continueMessage.message,
	            onContinue: (0, _lodash.partial)(this.props.dispatch, continueMessage.action) }),
	          status === 'defeat' && _react2.default.createElement('div', { className: 'overlay defeat-overlay' }),
	          status === 'defeat' && _react2.default.createElement(_DefeatMessage2.default, { message: defeatMessage }),
	          status === 'victory' && _react2.default.createElement(_VictoryMessage2.default, null),
	          cureInProgress && _react2.default.createElement(_DiseaseStatus2.default, {
	            color: cureInProgress,
	            status: 'cured',
	            onAnimationComplete: this.props.actions.animationCureDiseaseComplete }),
	          isEpidemicInProgress && _react2.default.createElement(_EpidemicOverlay2.default, { onAnimationComplete: this.props.actions.continueTurn }),
	          this.state.isNewTurn && _react2.default.createElement(_NewTurnOverlay2.default, { player: this.props.currentPlayer })
	        )
	      );
	    }
	  }]);
	
	  return Game;
	}(_react2.default.Component), _class.propTypes = {
	  currentMove: _react.PropTypes.object.isRequired,
	  players: _react.PropTypes.arrayOf(_react.PropTypes.shape(_extends({}, _propTypes.playerProps, {
	    cityId: _react.PropTypes.string.isRequired
	  }))),
	  currentPlayerId: _react.PropTypes.string,
	  currentPlayer: _propTypes.playerType,
	  currentCityId: _react.PropTypes.string,
	  getPlayerCityId: _react.PropTypes.func.isRequired,
	  getPlayerHand: _react.PropTypes.func.isRequired,
	  status: _react.PropTypes.oneOf(['prepare', 'playing', 'defeat', 'victory']).isRequired,
	  initialInfectedCity: _react.PropTypes.string,
	  defeatMessage: _react.PropTypes.string,
	  continueMessage: _react.PropTypes.object,
	  isEpidemicInProgress: _react.PropTypes.bool.isRequired,
	  cureInProgress: _react.PropTypes.bool.isRequired,
	  actions: _react.PropTypes.object.isRequired,
	  route: _react.PropTypes.object.isRequired,
	  router: _react.PropTypes.object.isRequired,
	  dispatch: _react.PropTypes.func.isRequired
	}, _temp);
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    currentMove: state.currentMove,
	    players: (0, _selectors.getPlayers)(state),
	    currentPlayerId: state.currentMove.player,
	    currentCityId: (0, _selectors.getCurrentCityId)(state),
	    getPlayerCityId: (0, _lodash.partial)(_selectors.getPlayerCityId, state),
	    getPlayerHand: (0, _lodash.partial)(_selectors.getPlayerHand, state),
	    status: state.status,
	    initialInfectedCity: (0, _selectors.getInitialInfectedCity)(state),
	    defeatMessage: (0, _selectors.getDefeatMessage)(state),
	    continueMessage: (0, _selectors.getContinueMessage)(state),
	    isEpidemicInProgress: (0, _selectors.isEpidemicInProgress)(state),
	    cureInProgress: (0, _selectors.getCureInProgress)(state),
	    currentPlayer: (0, _selectors.getCurrentPlayer)(state)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)(_extends({}, mapActions, globalActions), dispatch),
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Game));

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(60);
	
	var _redux = __webpack_require__(115);
	
	var _lodash = __webpack_require__(21);
	
	var _cities = __webpack_require__(235);
	
	var _cities2 = _interopRequireDefault(_cities);
	
	var _propTypes = __webpack_require__(14);
	
	var _PlayersLayer = __webpack_require__(631);
	
	var _PlayersLayer2 = _interopRequireDefault(_PlayersLayer);
	
	var _LocationsLayer = __webpack_require__(628);
	
	var _LocationsLayer2 = _interopRequireDefault(_LocationsLayer);
	
	var _PathsLayer = __webpack_require__(630);
	
	var _PathsLayer2 = _interopRequireDefault(_PathsLayer);
	
	var _CubesLayer = __webpack_require__(627);
	
	var _CubesLayer2 = _interopRequireDefault(_CubesLayer);
	
	var _mapActions = __webpack_require__(117);
	
	var mapActions = _interopRequireWildcard(_mapActions);
	
	var _globalActions = __webpack_require__(73);
	
	var globalActions = _interopRequireWildcard(_globalActions);
	
	var _selectors = __webpack_require__(48);
	
	var _utils = __webpack_require__(94);
	
	var _styles = __webpack_require__(360);
	
	var styles = _interopRequireWildcard(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Map = (_temp = _class = function (_React$Component) {
	  _inherits(Map, _React$Component);
	
	  function Map(props) {
	    _classCallCheck(this, Map);
	
	    var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));
	
	    _this.state = {
	      width: styles.map.width,
	      height: styles.map.height
	    };
	
	
	    _this.onWindowResize = _this.onWindowResize.bind(_this);
	    return _this;
	  }
	
	  _createClass(Map, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.onWindowResize);
	      this.onWindowResize();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.isPlaying !== this.props.isPlaying) {
	        setTimeout(this.onWindowResize, 0); // seems like we need to wait until dimensions are up-to-date
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.onWindowResize);
	    }
	  }, {
	    key: 'getWidth',
	    value: function getWidth() {
	      return this.state.width;
	    }
	  }, {
	    key: 'getHeight',
	    value: function getHeight() {
	      return this.state.height;
	    }
	  }, {
	    key: 'onWindowResize',
	    value: function onWindowResize() {
	      var map = this.refs.map;
	
	      this.setState({ width: map.offsetWidth, height: map.offsetHeight });
	    }
	  }, {
	    key: 'transitionPlayerMove',
	    value: function transitionPlayerMove(playerId, destinationId) {
	      var fireCompleteAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      var origin = (0, _utils.getLocationOrigin)(this.props.map.locations[destinationId], this.state.width, this.state.height);
	      this.refs.players.transitionPlayerMove(playerId, [origin.top, origin.left], fireCompleteAction && this.props.actions.animationMoveComplete);
	    }
	  }, {
	    key: 'calculatePaths',
	    value: function calculatePaths() {
	      var paths = [];
	      var _props$map = this.props.map,
	          matrix = _props$map.matrix,
	          locations = _props$map.locations;
	
	      for (var i = 0; i < matrix.length; i++) {
	        for (var j = 0; j < i; j++) {
	          if (matrix[i][j] === 1) {
	            var begin = (0, _utils.getPathCoords)(locations[i], this.state.width, this.state.height);
	            var end = (0, _utils.getPathCoords)(locations[j], this.state.width, this.state.height);
	            paths.push([begin.slice().reverse(), end.slice().reverse()]);
	          }
	        }
	      }
	
	      return paths;
	    }
	  }, {
	    key: 'calculatePlayersPositions',
	    value: function calculatePlayersPositions() {
	      var _this2 = this;
	
	      var playersByCity = (0, _lodash.invertBy)(this.props.map.playersLocations);
	      return (0, _lodash.reduce)(playersByCity, function (acc, players, cityId) {
	        var playersToIterate = [].concat(_toConsumableArray(players));
	        var currentPlayerIndex = players.indexOf(_this2.props.currentPlayerId);
	        if (currentPlayerIndex >= 0) {
	          playersToIterate.splice(currentPlayerIndex, 1);
	          playersToIterate.unshift(_this2.props.currentPlayerId);
	        }
	        var cityCoords = (0, _utils.getLocationOrigin)(_this2.props.map.locations[cityId], _this2.state.width, _this2.state.height);
	        var playerCoords = playersToIterate.map(function (id, i) {
	          return { id: id, coords: [cityCoords.top, cityCoords.left + i * 4] };
	        });
	        playerCoords.reverse();
	        return acc.concat(playerCoords);
	      }, []);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          map = _props.map,
	          availableCities = _props.availableCities,
	          players = _props.players,
	          currentPlayerId = _props.currentPlayerId,
	          isDriveAvailable = _props.isDriveAvailable,
	          isPlaying = _props.isPlaying;
	      var _props$currentMove = this.props.currentMove,
	          govGrantCities = _props$currentMove.govGrantCities,
	          airlift = _props$currentMove.airlift,
	          infectingCube = _props$currentMove.outbreak.infectingCube,
	          actionsLeft = _props$currentMove.actionsLeft;
	
	      var playersPositions = this.calculatePlayersPositions();
	      var paths = this.calculatePaths();
	      var citiesToSelect = (0, _lodash.find)([availableCities, govGrantCities, airlift && airlift.cities], function (c) {
	        return !(0, _lodash.isEmpty)(c);
	      });
	
	      var origin = void 0,
	          destination = void 0,
	          color = void 0;
	      if (!(0, _lodash.isEmpty)(infectingCube)) {
	        origin = (0, _utils.getCubeOrigin)(map.locations[infectingCube.originId], this.state.width, this.state.height), destination = (0, _utils.getCubeOrigin)(map.locations[infectingCube.cityId], this.state.width, this.state.height), color = infectingCube.color;
	      }
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'map',
	          ref: 'map' },
	        _react2.default.createElement(_PathsLayer2.default, {
	          width: this.state.width,
	          paths: paths }),
	        _react2.default.createElement(_LocationsLayer2.default, {
	          locations: map.locations,
	          cities: _cities2.default,
	          availableCities: citiesToSelect,
	          onCityClicked: this.props.onCityClicked,
	          onCityDoubleClicked: this.props.onCityDoubleClicked,
	          isDriveAvailable: isPlaying ? isDriveAvailable : function () {
	            return false;
	          },
	          infectedCity: this.props.initialInfectedCity || this.props.infectionCardDrawn.id || this.props.epidemicInfectionCard.id,
	          width: this.state.width,
	          height: this.state.height }),
	        _react2.default.createElement(_PlayersLayer2.default, {
	          ref: 'players',
	          players: players,
	          playersPositions: playersPositions,
	          currentPlayerId: isPlaying && actionsLeft > 0 ? currentPlayerId : undefined }),
	        _react2.default.createElement(_CubesLayer2.default, {
	          locations: map.locations,
	          width: this.state.width,
	          height: this.state.height,
	          infectingCube: (0, _lodash.isEmpty)(infectingCube) ? undefined : { origin: origin, destination: destination, color: color },
	          infectNeighborCallback: (0, _lodash.partial)(this.props.actions.animationInfectNeighborComplete, infectingCube.cityId, infectingCube.originId, infectingCube.color) }),
	        actionsLeft === 0 && _react2.default.createElement('div', { className: 'mask' })
	      );
	    }
	  }]);
	
	  return Map;
	}(_react2.default.Component), _class.propTypes = {
	  onCityClicked: _react.PropTypes.func.isRequired,
	  onCityDoubleClicked: _react.PropTypes.func.isRequired,
	
	  map: _react.PropTypes.object.isRequired,
	  players: _react.PropTypes.objectOf(_propTypes.playerType.isRequired).isRequired,
	  currentMove: _react.PropTypes.object.isRequired,
	  availableCities: _react.PropTypes.objectOf(_propTypes.cityType).isRequired,
	  currentPlayerId: _react.PropTypes.string.isRequired,
	  isDriveAvailable: _react.PropTypes.func.isRequired,
	  initialInfectedCity: _react.PropTypes.string,
	  infectionCardDrawn: _react.PropTypes.shape({
	    id: _react.PropTypes.string
	  }),
	  epidemicInfectionCard: _react.PropTypes.shape({
	    id: _react.PropTypes.string
	  }),
	  isPlaying: _react.PropTypes.bool.isRequired,
	  actions: _react.PropTypes.object.isRequired
	}, _temp);
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    map: state.map,
	    players: state.players,
	    currentMove: state.currentMove,
	    availableCities: state.currentMove.availableCities,
	    currentPlayerId: state.currentMove.player,
	    isDriveAvailable: (0, _lodash.partial)(_selectors.isDriveAvailable, state),
	    infectionCardDrawn: (0, _selectors.getInfectionCardDrawn)(state),
	    epidemicInfectionCard: (0, _selectors.getEpidemicInfectionCard)(state),
	    isPlaying: (0, _selectors.isPlaying)(state)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)(_extends({}, mapActions, globalActions), dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Map);

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(60);
	
	var _reactRouter = __webpack_require__(114);
	
	var _reactBootstrap = __webpack_require__(23);
	
	var _globalActions = __webpack_require__(73);
	
	var _QuickGame = __webpack_require__(641);
	
	var _QuickGame2 = _interopRequireDefault(_QuickGame);
	
	var _CustomGame = __webpack_require__(652);
	
	var _CustomGame2 = _interopRequireDefault(_CustomGame);
	
	var _Footer = __webpack_require__(640);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Setup = (_temp = _class = function (_React$Component) {
	  _inherits(Setup, _React$Component);
	
	  function Setup(props) {
	    _classCallCheck(this, Setup);
	
	    var _this = _possibleConstructorReturn(this, (Setup.__proto__ || Object.getPrototypeOf(Setup)).call(this, props));
	
	    _this.state = {
	      mode: null
	    };
	
	    _this.onQuickGameClicked = _this.onQuickGameClicked.bind(_this);
	    _this.onQuickNumberOfPlayersPicked = _this.onQuickNumberOfPlayersPicked.bind(_this);
	    _this.onCustomGameClicked = _this.onCustomGameClicked.bind(_this);
	    _this.onCustomGameComplete = _this.onCustomGameComplete.bind(_this);
	    _this.showMenu = _this.showMenu.bind(_this);
	    return _this;
	  }
	
	  _createClass(Setup, [{
	    key: 'onQuickGameClicked',
	    value: function onQuickGameClicked() {
	      this.setState({ mode: 'quick' });
	    }
	  }, {
	    key: 'onCustomGameClicked',
	    value: function onCustomGameClicked() {
	      this.setState({ mode: 'custom' });
	    }
	  }, {
	    key: 'onQuickNumberOfPlayersPicked',
	    value: function onQuickNumberOfPlayersPicked(n) {
	      this.props.dispatch((0, _globalActions.createQuickGameInit)(n));
	    }
	  }, {
	    key: 'onCustomGameComplete',
	    value: function onCustomGameComplete(players, difficulty) {
	      this.props.dispatch((0, _globalActions.createCustomGameInit)(players, difficulty));
	    }
	  }, {
	    key: 'showMenu',
	    value: function showMenu() {
	      this.setState({ mode: null });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'setup' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'text-danger' },
	            'Epidemic'
	          ),
	          this.state.mode === null && _react2.default.createElement(
	            'div',
	            { className: 'menu' },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsSize: 'large', onClick: this.onQuickGameClicked },
	              'Quick Start'
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { bsSize: 'large', onClick: this.onCustomGameClicked },
	              'Custom Game'
	            )
	          ),
	          this.state.mode === 'quick' && _react2.default.createElement(_QuickGame2.default, {
	            onNumberOfPlayersPicked: this.onQuickNumberOfPlayersPicked,
	            onBackClicked: this.showMenu }),
	          this.state.mode === 'custom' && _react2.default.createElement(_CustomGame2.default, {
	            onComplete: this.onCustomGameComplete,
	            onBackClicked: this.showMenu })
	        ),
	        _react2.default.createElement(_Footer2.default, null),
	        _react2.default.createElement('img', {
	          /*
	            Prefetch the loading image for the loading screen
	          */
	          src: __webpack_require__(286),
	          className: 'hide' })
	      );
	    }
	  }]);
	
	  return Setup;
	}(_react2.default.Component), _class.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired
	}, _temp);
	exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)()(Setup));

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(60);
	
	var _reactBootstrap = __webpack_require__(23);
	
	var _clipboard = __webpack_require__(694);
	
	var _clipboard2 = _interopRequireDefault(_clipboard);
	
	var _platform = __webpack_require__(1473);
	
	var _platform2 = _interopRequireDefault(_platform);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StateReporter = (_temp = _class = function (_React$Component) {
	  _inherits(StateReporter, _React$Component);
	
	  function StateReporter(props) {
	    _classCallCheck(this, StateReporter);
	
	    var _this = _possibleConstructorReturn(this, (StateReporter.__proto__ || Object.getPrototypeOf(StateReporter)).call(this, props));
	
	    _this.state = { showModal: false };
	
	
	    _this.onModalClosed = _this.onModalClosed.bind(_this);
	    return _this;
	  }
	
	  _createClass(StateReporter, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.clipboard = new _clipboard2.default('.reporter-button', {
	        text: function text() {
	          return JSON.stringify({
	            revision: (undefined),
	            platform: _platform2.default,
	            history: _this2.props.history
	          });
	        }
	      });
	      this.clipboard.on('success', function () {
	        _this2.setState({ showModal: true });
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.clipboard.destroy();
	    }
	  }, {
	    key: 'onModalClosed',
	    value: function onModalClosed() {
	      this.setState({ showModal: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'state-reporter' },
	        _react2.default.createElement(
	          _reactBootstrap.OverlayTrigger,
	          {
	            id: 'reporter-trigger',
	            trigger: ['hover', 'focus'],
	            placement: 'top',
	            defaultOverlayShown: false,
	            overlay: _react2.default.createElement(
	              _reactBootstrap.Popover,
	              {
	                className: 'reporter-popover',
	                id: 'reporter-popover' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Epidemic'
	              ),
	              ' is currently in beta.',
	              _react2.default.createElement('br', null),
	              'If you think you saw a bug, click here.'
	            ) },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	              className: 'reporter-button',
	              bsSize: 'small',
	              bsStyle: 'primary' },
	            _react2.default.createElement('i', { className: 'fa fa-bug' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal,
	          {
	            show: this.state.showModal,
	            onHide: this.onModalClosed },
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Title,
	              null,
	              'Debugging data copied!'
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            'Please send the clipboard contents to ',
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:epidemic.redux@gmail.com' },
	              'epidemic.redux@gmail.com'
	            ),
	            '.',
	            _react2.default.createElement('br', null),
	            'It would help a lot if you include a short textual description of the unexpected behavior you observed.'
	          )
	        )
	      );
	    }
	  }]);
	
	  return StateReporter;
	}(_react2.default.Component), _class.propTypes = {
	  history: _react.PropTypes.object.isRequired
	}, _temp);
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    history: state.stateHistory
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(StateReporter);

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(60);
	
	var _reactBootstrap = __webpack_require__(23);
	
	var _lodash = __webpack_require__(21);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _RatesPopover = __webpack_require__(617);
	
	var _RatesPopover2 = _interopRequireDefault(_RatesPopover);
	
	var _selectors = __webpack_require__(48);
	
	var _diseases = __webpack_require__(83);
	
	var _diseases2 = _interopRequireDefault(_diseases);
	
	var _globalActions = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TopBar = (_temp = _class = function (_React$Component) {
	  _inherits(TopBar, _React$Component);
	
	  function TopBar(props) {
	    _classCallCheck(this, TopBar);
	
	    var _this = _possibleConstructorReturn(this, (TopBar.__proto__ || Object.getPrototypeOf(TopBar)).call(this, props));
	
	    _this.state = {
	      showNewInfectionRate: false,
	      showNewOutbreaks: false
	    };
	
	    _this.onPopoverAnimationEnd = _this.onPopoverAnimationEnd.bind(_this);
	    return _this;
	  }
	
	  _createClass(TopBar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({ showNewInfectionRate: nextProps.infectionRateValues.index !== this.props.infectionRateValues.index,
	        showNewOutbreaks: nextProps.outbreaks !== this.props.outbreaks });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.state.showNewInfectionRate || this.state.showNewOutbreaks) {
	        this.refs.popoverTrigger.show();
	      } else {
	        this.refs.popoverTrigger.hide();
	      }
	    }
	  }, {
	    key: 'onPopoverAnimationEnd',
	    value: function onPopoverAnimationEnd() {
	      this.setState({ showNewInfectionRate: false, showNewOutbreaks: false });
	      this.props.dispatch((0, _globalActions.continueTurn)());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          infectionRateValues = _props.infectionRateValues,
	          getDiseaseStatus = _props.getDiseaseStatus;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Panel,
	        { className: 'top-bar' },
	        _react2.default.createElement(
	          'span',
	          { className: 'player-deck' },
	          _react2.default.createElement(
	            'span',
	            null,
	            this.props.playerDeckCount
	          )
	        ),
	        _diseases2.default.map(function (c) {
	          return _react2.default.createElement(
	            'span',
	            { key: c },
	            _react2.default.createElement('span', { className: (0, _classnames2.default)(['top-icon', _defineProperty({}, 'cube-icon-' + c, getDiseaseStatus(c) === 'active'), _defineProperty({}, 'cured-icon-' + c, getDiseaseStatus(c) === 'cured'), _defineProperty({}, 'eradicated-icon-' + c, getDiseaseStatus(c) === 'eradicated')]) }),
	            _react2.default.createElement(
	              'span',
	              null,
	              _this2.props.cubesLeft[c]
	            )
	          );
	        }),
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement('span', { className: 'top-icon stations-icon' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            this.props.stationsLeft
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.OverlayTrigger,
	          {
	            id: 'rates-trigger',
	            ref: 'popoverTrigger',
	            trigger: ['hover', 'focus'],
	            placement: 'bottom',
	            overlay: _react2.default.createElement(
	              _reactBootstrap.Popover,
	              {
	                id: 'rates-popover',
	                className: 'rates-popover' },
	              _react2.default.createElement(_RatesPopover2.default, {
	                infectionRateValues: infectionRateValues,
	                outbreaks: this.props.outbreaks,
	                showNewInfectionRate: this.state.showNewInfectionRate,
	                showNewOutbreaks: this.state.showNewOutbreaks,
	                onAnimationEnd: this.onPopoverAnimationEnd })
	            ) },
	          _react2.default.createElement(
	            'span',
	            { className: 'rates' },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement('span', { className: 'top-icon infection-rate-icon' }),
	              _react2.default.createElement(
	                'span',
	                null,
	                this.props.infectionRate
	              )
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement('span', { className: 'top-icon outbreaks-icon' }),
	              _react2.default.createElement(
	                'span',
	                null,
	                this.props.outbreaks
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TopBar;
	}(_react2.default.Component), _class.propTypes = {
	  cubesLeft: _react.PropTypes.objectOf(_react.PropTypes.number.isRequired).isRequired,
	  stationsLeft: _react.PropTypes.number.isRequired,
	  playerDeckCount: _react.PropTypes.number.isRequired,
	  infectionRate: _react.PropTypes.number.isRequired,
	  infectionRateValues: _react.PropTypes.shape({
	    index: _react.PropTypes.number.isRequired,
	    values: _react.PropTypes.arrayOf(_react.PropTypes.number.isRequired).isRequired
	  }),
	  outbreaks: _react.PropTypes.number.isRequired,
	  getDiseaseStatus: _react.PropTypes.func.isRequired,
	  dispatch: _react.PropTypes.func.isRequired
	}, _temp);
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    cubesLeft: state.cubesLeft, stationsLeft: state.stationsLeft, playerDeckCount: (0, _selectors.getPlayerDeckCount)(state),
	    infectionRate: (0, _selectors.getInfectionRate)(state), outbreaks: state.outbreaks,
	    infectionRateValues: (0, _selectors.getInfectionRateValues)(state),
	    getDiseaseStatus: (0, _lodash.partial)(_selectors.getDiseaseStatus, state)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(TopBar);

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactRedux = __webpack_require__(60);
	
	var _reactRouter = __webpack_require__(114);
	
	var _reactRouterRedux = __webpack_require__(346);
	
	var _reactGa = __webpack_require__(516);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _routes = __webpack_require__(676);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _configureStore = __webpack_require__(680);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	__webpack_require__(978);
	
	__webpack_require__(979);
	
	__webpack_require__(977);
	
	__webpack_require__(980);
	
	__webpack_require__(981);
	
	__webpack_require__(68);
	
	__webpack_require__(1725);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable import/default */
	
	__webpack_require__(1082);
	
	
	var store = (0, _configureStore2.default)();
	var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);
	
	function logPageView() {
	  _reactGa2.default.set({ page: window.location.pathname });
	  _reactGa2.default.pageview(window.location.pathname);
	}
	
	_reactGa2.default.initialize('UA-82047208-2');
	
	(0, _reactDom.render)(_react2.default.createElement(
	  _reactRedux.Provider,
	  { store: store },
	  _react2.default.createElement(_reactRouter.Router, {
	    history: history,
	    routes: _routes2.default,
	    onUpdate: logPageView })
	), document.getElementById('app'));

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = cubesLeftReducer;
	
	var _lodash = __webpack_require__(21);
	
	var _initialState = __webpack_require__(37);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _actionTypes = __webpack_require__(25);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _diseases = __webpack_require__(83);
	
	var _diseases2 = _interopRequireDefault(_diseases);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function cubesLeftReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.cubesLeft;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.CREATE_GAME:
	      return _diseases2.default.reduce(function (acc, c) {
	        acc[c] = 24;
	        return acc;
	      }, {});
	    case types.USE_DISEASE_CUBES:
	      return _extends({}, state, _defineProperty({}, action.color, state[action.color] - action.count));
	    case types.PLAYER_TREAT_DISEASE:
	    case types.PLAYER_TREAT_ALL_DISEASE:
	      return _extends({}, state, _defineProperty({}, action.color, state[action.color] + action.count));
	    case types.MEDIC_TREAT_CURED_DISEASES:
	      return (0, _lodash.assignWith)({}, state, action.cubes, function (obj, src) {
	        return (obj || 0) + src;
	      });
	    default:
	      return state;
	  }
	}

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = currentMoveReducer;
	
	var _initialState = __webpack_require__(37);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _actionTypes = __webpack_require__(25);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _continueMessages = __webpack_require__(647);
	
	var _continueMessages2 = _interopRequireDefault(_continueMessages);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function actionsLeft(state, action) {
	  if (types.ACTIONS.includes(action.type)) {
	    return state - 1;
	  } else if (action.type === types.PASS_TURN || action.type === types.CREATE_GAME) {
	    return 4;
	  } else {
	    return state;
	  }
	}
	
	function availableCities(state, action) {
	  switch (action.type) {
	    case types.PLAYER_MOVE_SHOW_CITIES:
	      return action.cities;
	    case types.CREATE_GAME:
	    case types.PLAYER_MOVE_TO_CITY:
	    case types.PLAYER_MOVE_CANCEL:
	      return {};
	    default:
	      return state;
	  }
	}
	
	function shareCandidates(state, action) {
	  switch (action.type) {
	    case types.PLAYER_SHARE_SHOW_CANDIDATES:
	      return action.players;
	    case types.CREATE_GAME:
	    case types.PLAYER_SHARE_CARD:
	    case types.PLAYER_SHARE_CANCEL:
	      return [];
	    default:
	      return state;
	  }
	}
	
	function cardsDrawn(state, action) {
	  switch (action.type) {
	    case types.CREATE_GAME:
	      return [];
	    case types.CARD_DRAW_CARDS_INIT:
	      return action.cards;
	    case types.CARD_DRAW_CARDS_HANDLE_INIT:
	      return state.map(function (c) {
	        if (c.cardType === action.card.cardType && c.id === action.card.id) {
	          return _extends({}, c, { handling: true });
	        } else {
	          return c;
	        }
	      });
	    case types.CARD_DRAW_CARDS_HANDLE:
	      return state.filter(function (c) {
	        return c.id !== action.card.id || c.cardType !== action.card.cardType;
	      });
	    default:
	      return state;
	  }
	}
	
	function infectionCardDrawn(state, action) {
	  switch (action.type) {
	    case types.CARD_DRAW_INFECTION_CARD:
	      return { id: action.cityId };
	    case types.ANIMATION_DRAW_INFECTION_CARD_COMPLETE:
	      return {};
	    default:
	      return state;
	  }
	}
	
	function discardingCard(state, action) {
	  switch (action.type) {
	    case types.CARD_DISCARD_FROM_HAND_INIT:
	      return { cardType: action.cardType, id: action.id, playerId: action.playerId };
	    case types.ANIMATION_CARD_DISCARD_FROM_HAND_COMPLETE:
	      return {};
	    default:
	      return state;
	  }
	}
	
	function outbreak(state, action) {
	  switch (action.type) {
	    case types.CREATE_GAME:
	    case types.OUTBREAK_INIT:
	      return _extends({}, state, {
	        color: action.color,
	        pending: state.pending.filter(function (id) {
	          return id !== action.cityId;
	        })
	      });
	    case types.OUTBREAK_COMPLETE:
	      return _extends({}, state, {
	        color: state.pending.length > 0 ? state.color : null,
	        complete: state.pending.length > 0 ? [].concat(_toConsumableArray(state.complete), [action.cityId]) : []
	      });
	    case types.OUTBREAK_QUEUE:
	      return _extends({}, state, {
	        pending: state.pending.includes(action.cityId) || state.complete.includes(action.cityId) ? state.pending : [].concat(_toConsumableArray(state.pending), [action.cityId])
	      });
	    case types.INFECT_NEIGHBOR:
	      return _extends({}, state, {
	        infectingCube: {
	          cityId: action.cityId,
	          originId: action.originId,
	          color: action.color
	        }
	      });
	    case types.ANIMATION_INFECT_NEIGHBOR_COMPLETE:
	      return _extends({}, state, {
	        infectingCube: {}
	      });
	    default:
	      return state;
	  }
	}
	
	function playerToDiscard(state, action) {
	  switch (action.type) {
	    case types.CARD_OVER_LIMIT_DISCARD_INIT:
	      return action.playerId;
	    case types.CARD_OVER_LIMIT_DISCARD_COMPLETE:
	      return null;
	    default:
	      return state;
	  }
	}
	
	function playerToMove(state, action) {
	  switch (action.type) {
	    case types.DISPATCHER_CHOOSE_PLAYER:
	      return action.playerId;
	    case types.PLAYER_MOVE_TO_CITY:
	      return null;
	    default:
	      return state;
	  }
	}
	
	function player(state, action) {
	  switch (action.type) {
	    case types.START_GAME:
	      return '0';
	    case types.PASS_TURN:
	      return action.playerId;
	    default:
	      return state;
	  }
	}
	
	function curingDisease(state, action) {
	  switch (action.type) {
	    case types.PLAYER_CURE_DISEASE_SHOW_CARDS:
	      return { cards: action.cards, color: action.color };
	    case types.PLAYER_CURE_DISEASE_COMPLETE:
	      return { cureInProgress: action.color };
	    case types.ANIMATION_CURE_DISEASE_COMPLETE:
	    case types.PLAYER_CURE_DISEASE_CANCEL:
	      return {};
	    default:
	      return state;
	  }
	}
	
	function skipInfectionsStep(state, action) {
	  switch (action.type) {
	    case types.EVENT_ONE_QUIET_NIGHT_SKIP:
	      return true;
	    case types.PASS_TURN:
	      return false;
	    default:
	      return state;
	  }
	}
	
	function govGrantCities(state, action) {
	  switch (action.type) {
	    case types.EVENT_GOV_GRANT_SHOW_CITIES:
	      return action.cities;
	    case types.EVENT_GOV_GRANT_BUILD_STATION:
	      return [];
	    default:
	      return state;
	  }
	}
	
	function resPop(state, action) {
	  switch (action.type) {
	    case types.PLAYER_PLAY_EVENT_INIT:
	      if (action.id === 'res_pop') {
	        return _extends({}, state, {
	          chooseCard: true
	        });
	      }
	      return state;
	    case types.EVENT_RES_POP_REMOVE_CARD:
	    case types.CONTINUE:
	      return {};
	    case types.EVENT_RES_POP_SUGGEST:
	      return _extends({}, state, {
	        suggestOwner: action.playerId
	      });
	    default:
	      return state;
	  }
	}
	
	function forecastCards(state, action) {
	  switch (action.type) {
	    case types.EVENT_FORECAST_SHOW_CARDS:
	      return action.cards;
	    case types.EVENT_FORECAST_SHUFFLE:
	      return [];
	    default:
	      return state;
	  }
	}
	
	function airlift(state, action) {
	  switch (action.type) {
	    case types.PLAYER_PLAY_EVENT_INIT:
	      if (action.id === 'airlift') {
	        return { playerId: null, cities: [] };
	      }
	      return state;
	    case types.EVENT_AIRLIFT_CHOOSE_PLAYER:
	      return _extends({}, state, { playerId: action.playerId });
	    case types.EVENT_AIRLIFT_SHOW_CITIES:
	      return _extends({}, state, { cities: action.cities });
	    case types.EVENT_AIRLIFT_MOVE_TO_CITY:
	      return {};
	    default:
	      return state;
	  }
	}
	
	function opsMoveAbility(state, action) {
	  switch (action.type) {
	    case types.OPS_SHOW_CARDS_TO_DISCARD:
	      return _extends({}, state, {
	        cards: action.cards
	      });
	    case types.ANIMATION_CARD_DISCARD_FROM_HAND_COMPLETE:
	      if (state.cards.length > 0) {
	        return _extends({}, state, {
	          cards: [],
	          used: true
	        });
	      } else {
	        return state;
	      }
	    case types.PASS_TURN:
	      return _extends({}, state, {
	        used: false
	      });
	    default:
	      return state;
	  }
	}
	
	function contPlannerEvents(state, action) {
	  switch (action.type) {
	    case types.CONT_PLANNER_SHOW_EVENTS_FROM_DISCARD:
	      return action.cards;
	    case types.CONT_PLANNER_CHOOSE_EVENT:
	      return [];
	    default:
	      return state;
	  }
	}
	
	function epidemicStep(state, action) {
	  switch (action.type) {
	    case types.EPIDEMIC_INCREASE:
	      return 'increase';
	    case types.EPIDEMIC_INFECT_INIT:
	      return 'infect';
	    case types.EPIDEMIC_INTENSIFY_CONTINUE:
	      return 'intensify';
	    case types.EPIDEMIC_INTENSIFY:
	      return null;
	    default:
	      return state;
	  }
	}
	
	function epidemicInfectionCard(state, action) {
	  switch (action.type) {
	    case types.EPIDEMIC_INFECT_INIT:
	      return action.card;
	    case types.CONTINUE:
	      return {};
	    default:
	      return state;
	  }
	}
	
	function continueMessage(state, action) {
	  switch (action.type) {
	    case types.EPIDEMIC_INTENSIFY_INIT:
	      return _continueMessages2.default.TO_INTENSIFY_STEP;
	    case types.CONTINUE:
	    case types.EPIDEMIC_INTENSIFY_CONTINUE:
	      return null;
	    default:
	      return state;
	  }
	}
	
	function currentMoveReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.currentMove;
	  var action = arguments[1];
	
	  return _extends({}, state, {
	    availableCities: availableCities(state.availableCities, action),
	    shareCandidates: shareCandidates(state.shareCandidates, action),
	    actionsLeft: actionsLeft(state.actionsLeft, action),
	    cardsDrawn: cardsDrawn(state.cardsDrawn, action),
	    infectionCardDrawn: infectionCardDrawn(state.infectionCardDrawn, action),
	    discardingCard: discardingCard(state.discardingCard, action),
	    outbreak: outbreak(state.outbreak, action),
	    playerToDiscard: playerToDiscard(state.playerToDiscard, action),
	    playerToMove: playerToMove(state.playerToMove, action),
	    player: player(state.player, action),
	    curingDisease: curingDisease(state.curingDisease, action),
	    skipInfectionsStep: skipInfectionsStep(state.skipInfectionsStep, action),
	    govGrantCities: govGrantCities(state.govGrantCities, action),
	    resPop: resPop(state.resPop, action),
	    forecastCards: forecastCards(state.forecastCards, action),
	    airlift: airlift(state.airlift, action),
	    opsMoveAbility: opsMoveAbility(state.opsMoveAbility, action),
	    contPlannerEvents: contPlannerEvents(state.contPlannerEvents, action),
	    epidemicStep: epidemicStep(state.epidemicStep, action),
	    epidemicInfectionCard: epidemicInfectionCard(state.epidemicInfectionCard, action),
	    continueMessage: continueMessage(state.continueMessage, action)
	  });
	}

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = dealingCardsReducer;
	
	var _initialState = __webpack_require__(37);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _actionTypes = __webpack_require__(25);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function dealingCardsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.dealingCards;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.DEAL_CARDS_INIT:
	      return {
	        dealing: 'player'
	      };
	    case types.DEAL_CARDS:
	      return _extends({}, state, {
	        playerIndex: action.playerIndex,
	        cards: action.cards
	      });
	    case types.INSERT_EPIDEMIC_CARDS_INIT:
	      return {
	        dealing: 'epidemic'
	      };
	    case types.ANIMATION_INSERT_EPIDEMIC_CARDS_COMPLETE:
	      return {};
	    default:
	      return state;
	  }
	}

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defeatMessageReducer;
	
	var _initialState = __webpack_require__(37);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _actionTypes = __webpack_require__(25);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defeatMessageReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.defeatMessage;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.DEFEAT:
	      return action.message;
	    case types.CREATE_GAME:
	      return null;
	    default:
	      return state;
	  }
	}

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = diseasesReducer;
	
	var _initialState = __webpack_require__(37);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _actionTypes = __webpack_require__(25);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _diseases = __webpack_require__(83);
	
	var _diseases2 = _interopRequireDefault(_diseases);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function diseasesReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.diseases;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.CREATE_GAME:
	      return _diseases2.default.reduce(function (acc, c) {
	        acc[c] = 'active';
	        return acc;
	      }, {});
	    case types.PLAYER_CURE_DISEASE_COMPLETE:
	      return _extends({}, state, _defineProperty({}, action.color, 'cured'));
	    case types.ERADICATE_DISEASE:
	      return _extends({}, state, _defineProperty({}, action.color, 'eradicated'));
	    default:
	      return state;
	  }
	}

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(115);
	
	var _reactRouterRedux = __webpack_require__(346);
	
	var _mapReducer = __webpack_require__(670);
	
	var _mapReducer2 = _interopRequireDefault(_mapReducer);
	
	var _playersReducer = __webpack_require__(673);
	
	var _playersReducer2 = _interopRequireDefault(_playersReducer);
	
	var _currentMoveReducer = __webpack_require__(662);
	
	var _currentMoveReducer2 = _interopRequireDefault(_currentMoveReducer);
	
	var _stationsLeftReducer = __webpack_require__(674);
	
	var _stationsLeftReducer2 = _interopRequireDefault(_stationsLeftReducer);
	
	var _cubesLeftReducer = __webpack_require__(661);
	
	var _cubesLeftReducer2 = _interopRequireDefault(_cubesLeftReducer);
	
	var _infectionRateReducer = __webpack_require__(668);
	
	var _infectionRateReducer2 = _interopRequireDefault(_infectionRateReducer);
	
	var _outbreaksReducer = __webpack_require__(671);
	
	var _outbreaksReducer2 = _interopRequireDefault(_outbreaksReducer);
	
	var _diseasesReducer = __webpack_require__(665);
	
	var _diseasesReducer2 = _interopRequireDefault(_diseasesReducer);
	
	var _statusReducer = __webpack_require__(675);
	
	var _statusReducer2 = _interopRequireDefault(_statusReducer);
	
	var _playerCardsReducer = __webpack_require__(672);
	
	var _playerCardsReducer2 = _interopRequireDefault(_playerCardsReducer);
	
	var _infectionCardsReducer = __webpack_require__(667);
	
	var _infectionCardsReducer2 = _interopRequireDefault(_infectionCardsReducer);
	
	var _dealingCardsReducer = __webpack_require__(663);
	
	var _dealingCardsReducer2 = _interopRequireDefault(_dealingCardsReducer);
	
	var _initialInfectedCityReducer = __webpack_require__(669);
	
	var _initialInfectedCityReducer2 = _interopRequireDefault(_initialInfectedCityReducer);
	
	var _defeatMessageReducer = __webpack_require__(664);
	
	var _defeatMessageReducer2 = _interopRequireDefault(_defeatMessageReducer);
	
	var _actionTypes = __webpack_require__(25);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _initialState = __webpack_require__(37);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var combinedReducer = (0, _redux.combineReducers)({
	  status: _statusReducer2.default,
	  difficulty: function difficulty(state) {
	    return state || _initialState2.default.difficulty;
	  },
	  defeatMessage: _defeatMessageReducer2.default,
	  initialInfectedCity: _initialInfectedCityReducer2.default,
	  dealingCards: _dealingCardsReducer2.default,
	  playerCards: _playerCardsReducer2.default,
	  infectionCards: _infectionCardsReducer2.default,
	  map: _mapReducer2.default,
	  players: _playersReducer2.default,
	  diseases: _diseasesReducer2.default,
	  outbreaks: _outbreaksReducer2.default,
	  currentMove: _currentMoveReducer2.default,
	  stationsLeft: _stationsLeftReducer2.default,
	  cubesLeft: _cubesLeftReducer2.default,
	  infectionRate: _infectionRateReducer2.default,
	  routing: _reactRouterRedux.routerReducer,
	  stateHistory: function stateHistory() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return state;
	  }
	});
	
	exports.default = function (state, action) {
	  if (action.type === types.CREATE_GAME) {
	    return _extends({}, _initialState2.default, {
	      difficulty: action.difficulty,
	      playerCards: {
	        deck: action.playerDeck,
	        discard: []
	      },
	      infectionCards: {
	        deck: action.infectionDeck,
	        discard: []
	      },
	      players: action.players.reduce(function (acc, pl, id) {
	        acc[id] = _extends({}, pl, { id: id + '', hand: [] });
	        return acc;
	      }, {}),
	      map: _extends({}, _initialState2.default.map, {
	        playersLocations: action.players.reduce(function (acc, pl, id) {
	          acc[id] = '2';
	          return acc;
	        }, {})
	      }),
	      routing: (0, _reactRouterRedux.routerReducer)(state, action),
	      stateHistory: function stateHistory(state) {
	        return state;
	      }
	    });
	  } else {
	    return combinedReducer(state, action);
	  }
	};

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = infectionCardsReducer;
	
	var _lodash = __webpack_require__(21);
	
	var _initialState = __webpack_require__(37);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _actionTypes = __webpack_require__(25);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function infectionCardsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.infectionCards;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.CARD_DISCARD_FROM_INFECTION_DECK_TOP:
	      {
	        var card = state.deck[0];
	        return _extends({}, state, {
	          deck: state.deck.slice(1),
	          discard: [card].concat(_toConsumableArray(state.discard))
	        });
	      }
	    case types.CARD_DISCARD_FROM_INFECTION_DECK_BOTTOM:
	      {
	        var _card = state.deck[state.deck.length - 1];
	        return _extends({}, state, {
	          deck: state.deck.slice(0, state.deck.length - 1),
	          discard: [_card].concat(_toConsumableArray(state.discard))
	        });
	      }
	    case types.EPIDEMIC_INTENSIFY:
	      {
	        var shuffled = (0, _lodash.shuffle)(state.discard);
	        return _extends({}, state, {
	          deck: [].concat(_toConsumableArray(shuffled), _toConsumableArray(state.deck)),
	          discard: []
	        });
	      }
	    case types.EVENT_RES_POP_REMOVE_CARD:
	      return _extends({}, state, {
	        discard: state.discard.filter(function (c) {
	          return c !== action.cityId;
	        })
	      });
	    case types.EVENT_FORECAST_SHUFFLE:
	      return _extends({}, state, {
	        deck: [].concat(_toConsumableArray(action.cards), _toConsumableArray(state.deck.slice(6)))
	      });
	    default:
	      return state;
	  }
	}

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = infectionRateReducer;
	
	var _initialState = __webpack_require__(37);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _actionTypes = __webpack_require__(25);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function infectionRateReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.infectionRate;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.EPIDEMIC_INCREASE:
	      return _extends({}, state, {
	        index: Math.min(state.index + 1, state.values.length - 1)
	      });
	    default:
	      return state;
	  }
	}

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = initialInfectedCityReducer;
	
	var _initialState = __webpack_require__(37);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _actionTypes = __webpack_require__(25);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function initialInfectedCityReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.initialInfectedCity;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.INFECT_CITY:
	      if (action.initial) {
	        return action.cityId;
	      } else {
	        return state;
	      }
	    case types.START_GAME:
	      return null;
	    default:
	      return state;
	  }
	}

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = mapReducer;
	
	var _initialState = __webpack_require__(37);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _actionTypes = __webpack_require__(25);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function cityReducer(state, action) {
	  switch (action.type) {
	    case types.PLAYER_BUILD_STATION:
	    case types.EVENT_GOV_GRANT_BUILD_STATION:
	      // TODO move station from another city
	      return _extends({}, state, {
	        station: true
	      });
	    case types.PLAYER_TREAT_DISEASE:
	      return _extends({}, state, _defineProperty({}, action.color, state[action.color] - 1));
	    case types.PLAYER_TREAT_ALL_DISEASE:
	      return _extends({}, state, _defineProperty({}, action.color, 0));
	    case types.MEDIC_TREAT_CURED_DISEASES:
	      {
	        var colors = Object.keys(action.cubes).reduce(function (acc, c) {
	          acc[c] = 0;return acc;
	        }, {});
	        return _extends({}, state, colors);
	      }
	    case types.INFECT_CITY:
	      return _extends({}, state, _defineProperty({}, action.color, Math.min(3, state[action.color] + action.count)));
	    case types.ANIMATION_INFECT_NEIGHBOR_COMPLETE:
	      return _extends({}, state, _defineProperty({}, action.color, Math.min(3, state[action.color] + 1)));
	    default:
	      return state;
	  }
	}
	
	function locationsReducer(state, action) {
	  switch (action.type) {
	    case types.PLAYER_BUILD_STATION:
	    case types.EVENT_GOV_GRANT_BUILD_STATION:
	    case types.PLAYER_TREAT_DISEASE:
	    case types.PLAYER_TREAT_ALL_DISEASE:
	    case types.MEDIC_TREAT_CURED_DISEASES:
	    case types.INFECT_CITY:
	    case types.ANIMATION_INFECT_NEIGHBOR_COMPLETE:
	      return _extends({}, state, _defineProperty({}, action.cityId, cityReducer(state[action.cityId], action)));
	    default:
	      return state;
	  }
	}
	
	function mapReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.map;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.PLAYER_MOVE_TO_CITY:
	    case types.EVENT_AIRLIFT_MOVE_TO_CITY:
	      return _extends({}, state, {
	        playersLocations: _extends({}, state.playersLocations, _defineProperty({}, action.playerId, action.destinationId))
	      });
	    case types.PLAYER_BUILD_STATION:
	    case types.EVENT_GOV_GRANT_BUILD_STATION:
	    case types.PLAYER_TREAT_DISEASE:
	    case types.PLAYER_TREAT_ALL_DISEASE:
	    case types.MEDIC_TREAT_CURED_DISEASES:
	    case types.INFECT_CITY:
	    case types.ANIMATION_INFECT_NEIGHBOR_COMPLETE:
	      return _extends({}, state, {
	        locations: locationsReducer(state.locations, action)
	      });
	    default:
	      return state;
	  }
	}

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = outbreaksReducer;
	
	var _initialState = __webpack_require__(37);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _actionTypes = __webpack_require__(25);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function outbreaksReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.outbreaks;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.OUTBREAK_INIT:
	      return state + 1;
	    default:
	      return state;
	  }
	}

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = playerCardsReducer;
	
	var _lodash = __webpack_require__(21);
	
	var _initialState = __webpack_require__(37);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _actionTypes = __webpack_require__(25);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function playerCardsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.playerCards;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.DEAL_CARDS:
	      return _extends({}, state, {
	        deck: state.deck.filter(function (c) {
	          return !(0, _lodash.find)(action.cards, { cardType: c.cardType, id: c.id });
	        })
	      });
	    case types.INSERT_PLAYER_CARD:
	      return _extends({}, state, {
	        deck: [].concat(_toConsumableArray(state.deck.slice(0, action.index)), [action.card], _toConsumableArray(state.deck.slice(action.index)))
	      });
	    case types.CARD_DRAW_CARDS_INIT:
	      return _extends({}, state, {
	        deck: state.deck.slice(2)
	      });
	    case types.ANIMATION_CARD_DISCARD_FROM_HAND_COMPLETE:
	      return _extends({}, state, {
	        discard: [{ cardType: action.cardType, id: action.id }].concat(_toConsumableArray(state.discard))
	      });
	    case types.CONT_PLANNER_CHOOSE_EVENT:
	      return _extends({}, state, {
	        discard: state.discard.filter(function (c) {
	          return !(c.cardType == 'event' && c.id === action.eventId);
	        })
	      });
	    default:
	      return state;
	  }
	}

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = playersReducer;
	
	var _lodash = __webpack_require__(21);
	
	var _initialState = __webpack_require__(37);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _actionTypes = __webpack_require__(25);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function hand() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.DEAL_CARDS:
	      return action.cards;
	    case types.ANIMATION_CARD_DISCARD_FROM_HAND_COMPLETE:
	      return state.filter(function (c) {
	        return !(c.cardType === action.cardType && c.id === action.id);
	      });
	    case types.CARD_DRAW_CARDS_HANDLE:
	      return action.card.cardType !== 'epidemic' ? [].concat(_toConsumableArray(state), [action.card]) : state;
	    case types.PLAYER_SHARE_CARD:
	      return (0, _lodash.find)(state, { cardType: 'city', id: action.cityId }) ? state.filter(function (c) {
	        return !(c.cardType === 'city' && c.id === action.cityId);
	      }) : [].concat(_toConsumableArray(state), [{ cardType: 'city', id: action.cityId }]);
	    default:
	      return state;
	  }
	}
	
	function playersReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.players;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.DEAL_CARDS:
	    case types.ANIMATION_CARD_DISCARD_FROM_HAND_COMPLETE:
	    case types.CARD_DRAW_CARDS_HANDLE:
	      {
	        var playerId = action.playerId;
	
	        var newHand = hand(state[playerId].hand, action);
	        return _extends({}, state, _defineProperty({}, playerId, _extends({}, state[playerId], {
	          hand: newHand
	        })));
	      }
	    case types.PLAYER_SHARE_CARD:
	      {
	        var _extends3;
	
	        var giverId = action.giverId,
	            receiverId = action.receiverId;
	
	        return _extends({}, state, (_extends3 = {}, _defineProperty(_extends3, giverId, _extends({}, state[giverId], {
	          hand: hand(state[giverId].hand, action)
	        })), _defineProperty(_extends3, receiverId, _extends({}, state[receiverId], {
	          hand: hand(state[receiverId].hand, action)
	        })), _extends3));
	      }
	    case types.CONT_PLANNER_CHOOSE_EVENT:
	      {
	        var _playerId = action.playerId,
	            eventId = action.eventId;
	
	        return _extends({}, state, _defineProperty({}, _playerId, _extends({}, state[_playerId], {
	          specialEvent: eventId
	        })));
	      }
	    case types.CONT_PLANNER_EVENT_COMPLETE:
	      {
	        var _playerId2 = action.playerId;
	
	        return _extends({}, state, _defineProperty({}, _playerId2, _extends({}, state[_playerId2], {
	          specialEvent: null
	        })));
	      }
	    default:
	      return state;
	  }
	}

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stationsLeftReducer;
	
	var _initialState = __webpack_require__(37);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _actionTypes = __webpack_require__(25);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function stationsLeftReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.stationsLeft;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.PLAYER_BUILD_STATION:
	    case types.EVENT_GOV_GRANT_BUILD_STATION:
	      return state - 1;
	    default:
	      return state;
	  }
	}

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = statusReducer;
	
	var _initialState = __webpack_require__(37);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _actionTypes = __webpack_require__(25);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function statusReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.status;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case types.CREATE_GAME:
	      return 'prepare';
	    case types.START_GAME:
	      return 'playing';
	    case types.VICTORY:
	      return 'victory';
	    case types.DEFEAT:
	      return 'defeat';
	    default:
	      return state;
	  }
	}

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(114);
	
	var _App = __webpack_require__(607);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Game = __webpack_require__(655);
	
	var _Game2 = _interopRequireDefault(_Game);
	
	var _Setup = __webpack_require__(657);
	
	var _Setup2 = _interopRequireDefault(_Setup);
	
	var _Credits = __webpack_require__(638);
	
	var _Credits2 = _interopRequireDefault(_Credits);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createElement(
	  _reactRouter.Route,
	  { path: '/', component: _App2.default },
	  _react2.default.createElement(_reactRouter.IndexRoute, { component: _Setup2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: 'play', component: _Game2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: 'credits', component: _Credits2.default }),
	  _react2.default.createElement(_reactRouter.Redirect, { from: 'setup', to: '/' })
	);

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.processEvent = processEvent;
	exports.watchEvents = watchEvents;
	
	var _reduxSaga = __webpack_require__(137);
	
	var _effects = __webpack_require__(177);
	
	var _cardActions = __webpack_require__(72);
	
	var _mapActions = __webpack_require__(117);
	
	var _diseaseActions = __webpack_require__(92);
	
	var _selectors = __webpack_require__(48);
	
	var sel = _interopRequireWildcard(_selectors);
	
	var _actionTypes = __webpack_require__(25);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _marked = /*#__PURE__*/regeneratorRuntime.mark(processEvent),
	    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchEvents);
	
	function processEvent(action) {
	  var plannerEvent, needToDiscard, cities, cards, playerAction, _cities;
	
	  return regeneratorRuntime.wrap(function processEvent$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(sel.getContPlannerEvent);
	
	        case 2:
	          plannerEvent = _context.sent;
	          needToDiscard = !(plannerEvent && action.id === plannerEvent.id);
	          _context.t0 = action.id;
	          _context.next = _context.t0 === 'one_quiet_night' ? 7 : _context.t0 === 'gov_grant' ? 10 : _context.t0 === 'forecast' ? 18 : _context.t0 === 'res_pop' ? 26 : _context.t0 === 'airlift' ? 29 : 40;
	          break;
	
	        case 7:
	          _context.next = 9;
	          return (0, _effects.put)((0, _diseaseActions.oneQuietNightSkip)());
	
	        case 9:
	          return _context.abrupt('break', 40);
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.select)(sel.getCitiesForGovGrant);
	
	        case 12:
	          cities = _context.sent;
	          _context.next = 15;
	          return (0, _effects.put)((0, _mapActions.govGrantShowCities)(cities));
	
	        case 15:
	          _context.next = 17;
	          return (0, _effects.take)(types.EVENT_GOV_GRANT_BUILD_STATION);
	
	        case 17:
	          return _context.abrupt('break', 40);
	
	        case 18:
	          _context.next = 20;
	          return (0, _effects.select)(sel.getCardsForForecast);
	
	        case 20:
	          cards = _context.sent;
	          _context.next = 23;
	          return (0, _effects.put)((0, _cardActions.forecastShowCards)(cards));
	
	        case 23:
	          _context.next = 25;
	          return (0, _effects.take)(types.EVENT_FORECAST_SHUFFLE);
	
	        case 25:
	          return _context.abrupt('break', 40);
	
	        case 26:
	          _context.next = 28;
	          return (0, _effects.take)(types.EVENT_RES_POP_REMOVE_CARD);
	
	        case 28:
	          return _context.abrupt('break', 40);
	
	        case 29:
	          _context.next = 31;
	          return (0, _effects.take)(types.EVENT_AIRLIFT_CHOOSE_PLAYER);
	
	        case 31:
	          playerAction = _context.sent;
	          _context.next = 34;
	          return (0, _effects.select)(sel.getCitiesForAirlift, playerAction.playerId);
	
	        case 34:
	          _cities = _context.sent;
	          _context.next = 37;
	          return (0, _effects.put)((0, _mapActions.airliftShowCities)(_cities));
	
	        case 37:
	          _context.next = 39;
	          return (0, _effects.take)(types.EVENT_AIRLIFT_MOVE_TO_CITY);
	
	        case 39:
	          return _context.abrupt('break', 40);
	
	        case 40:
	          if (!needToDiscard) {
	            _context.next = 47;
	            break;
	          }
	
	          _context.next = 43;
	          return (0, _effects.put)((0, _cardActions.discardFromHandInit)('event', action.playerId, action.id));
	
	        case 43:
	          _context.next = 45;
	          return (0, _effects.take)(types.ANIMATION_CARD_DISCARD_FROM_HAND_COMPLETE);
	
	        case 45:
	          _context.next = 49;
	          break;
	
	        case 47:
	          _context.next = 49;
	          return (0, _effects.put)((0, _cardActions.contPlannerEventComplete)(action.playerId));
	
	        case 49:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function watchEvents() {
	  return regeneratorRuntime.wrap(function watchEvents$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          return _context2.delegateYield((0, _reduxSaga.takeEvery)(types.PLAYER_PLAY_EVENT_INIT, processEvent), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = rootSaga;
	
	var _actionSagas = __webpack_require__(357);
	
	var _diseaseSagas = __webpack_require__(358);
	
	var _globalSagas = __webpack_require__(237);
	
	var _eventSagas = __webpack_require__(677);
	
	var _roleSagas = __webpack_require__(359);
	
	var _marked = /*#__PURE__*/regeneratorRuntime.mark(rootSaga);
	
	function rootSaga() {
	  return regeneratorRuntime.wrap(function rootSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return [(0, _globalSagas.watchCreateQuickGame)(), (0, _globalSagas.watchCreateCustomGame)(), (0, _globalSagas.watchDealCards)(), (0, _actionSagas.watchMoveInit)(), (0, _actionSagas.watchMoveToCity)(), (0, _actionSagas.watchShareInit)(), (0, _actionSagas.watchActionsLeft)(), (0, _actionSagas.watchCureInit)(), (0, _actionSagas.watchBuildStation)(), (0, _diseaseSagas.watchTreatEradication)(), (0, _diseaseSagas.watchCureEradication)(), (0, _globalSagas.watchVictory)(), (0, _globalSagas.watchOutbreaksDefeat)(), (0, _eventSagas.watchEvents)(), (0, _roleSagas.watchMedicAirlift)(), (0, _roleSagas.watchContPlannerInit)(), (0, _roleSagas.watchDispatcherMove)(), (0, _roleSagas.watchCureDisease)()];
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canTreatAll = canTreatAll;
	exports.canTreatAllOfColor = canTreatAllOfColor;
	exports.getDiseaseStatus = getDiseaseStatus;
	exports.areAllDiseasesCured = areAllDiseasesCured;
	exports.cardsNeededToCure = cardsNeededToCure;
	exports.getCurableDisease = getCurableDisease;
	exports.getTreatableDiseases = getTreatableDiseases;
	exports.canCureDisease = canCureDisease;
	exports.treatedAllOfColor = treatedAllOfColor;
	exports.getCuredDiseaseCubes = getCuredDiseaseCubes;
	exports.getCureInProgress = getCureInProgress;
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _map = __webpack_require__(181);
	
	var _hand = __webpack_require__(180);
	
	var _gameplay = __webpack_require__(179);
	
	var _diseases = __webpack_require__(83);
	
	var _diseases2 = _interopRequireDefault(_diseases);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function canTreatAll(state) {
	  return (0, _gameplay.getCurrentRole)(state) === 'medic';
	}
	
	function canTreatAllOfColor(state, color) {
	  return getDiseaseStatus(state, color) === 'cured';
	}
	
	function getDiseaseStatus(state, color) {
	  return state.diseases[color];
	}
	
	function areAllDiseasesCured(state) {
	  return _lodash2.default.every(_diseases2.default, function (c) {
	    return getDiseaseStatus(state, c) !== 'active';
	  });
	}
	
	function cardsNeededToCure(state) {
	  return (0, _gameplay.getCurrentRole)(state) === 'scientist' ? 4 : 5;
	}
	
	function getCurableDisease(state) {
	  return _lodash2.default.find(_diseases2.default, function (c) {
	    return canCureDisease(state, c);
	  });
	}
	
	function getTreatableDiseases(state) {
	  var loc = (0, _map.getCurrentMapLocation)(state);
	  return _diseases2.default.reduce(function (acc, c) {
	    if (loc[c] > 0) {
	      acc[c] = loc[c];
	    }
	    return acc;
	  }, {});
	}
	
	function canCureDisease(state, color) {
	  return cardsNeededToCure(state) <= _lodash2.default.filter((0, _hand.getCitiesInPlayersHand)(state, (0, _gameplay.getCurrentPlayer)(state).id), { color: color }).length && getDiseaseStatus(state, color) === 'active' && (0, _map.isAtStation)(state);
	}
	
	function treatedAllOfColor(state, color) {
	  return _lodash2.default.chain(state.map.locations).values().every(_defineProperty({}, color, 0)).value();
	}
	
	function getCuredDiseaseCubes(state) {
	  var loc = (0, _map.getCurrentMapLocation)(state);
	  return _diseases2.default.reduce(function (acc, c) {
	    if (getDiseaseStatus(state, c) === 'cured') {
	      acc[c] = loc[c];
	    }
	    return acc;
	  }, {});
	}
	
	function getCureInProgress(state) {
	  return state.currentMove.curingDisease.cureInProgress;
	}

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable global-require */
	if (true) {
	  module.exports = __webpack_require__(681);
	} else {
	  module.exports = require('./configureStore.dev');
	}

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = configureStore;
	
	var _redux = __webpack_require__(115);
	
	var _reduxSaga = __webpack_require__(137);
	
	var _reduxSaga2 = _interopRequireDefault(_reduxSaga);
	
	var _reduxStateHistory = __webpack_require__(1703);
	
	var _reducers = __webpack_require__(666);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _sagas = __webpack_require__(678);
	
	var _sagas2 = _interopRequireDefault(_sagas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function configureStore(initialState) {
	  var sagaMiddleware = (0, _reduxSaga2.default)();
	  var store = (0, _redux.createStore)(_reducers2.default, initialState, (0, _redux.compose)((0, _redux.applyMiddleware)(sagaMiddleware), (0, _reduxStateHistory.stateHistoryTracker)()));
	  sagaMiddleware.run(_sagas2.default);
	  return store;
	}

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(936);
	
	__webpack_require__(1707);
	
	__webpack_require__(695);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(696), __esModule: true };

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(698), __esModule: true };

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(700), __esModule: true };

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(702), __esModule: true };

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(703), __esModule: true };

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(153);
	var GetIntrinsic = __webpack_require__(1084);
	
	var $apply = GetIntrinsic('%Function.prototype.apply%');
	var $call = GetIntrinsic('%Function.prototype.call%');
	var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);
	
	var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
	
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = null;
		}
	}
	
	module.exports = function callBind() {
		return $reflectApply(bind, $call, arguments);
	};
	
	var applyBind = function applyBind() {
		return $reflectApply(bind, $apply, arguments);
	};
	
	if ($defineProperty) {
		$defineProperty(module.exports, 'apply', { value: applyBind });
	} else {
		module.exports.apply = applyBind;
	}


/***/ },
/* 689 */
/***/ function(module, exports) {

	"use strict";
	var pattern = /-(\w|$)/g;
	
	
	
	function callback(dashChar, char)
	{
		return char.toUpperCase();
	}
	
	
	
	function camelCaseCSS(property)
	{
		// NOTE :: IE8's "styleFloat" is intentionally not supported
		if (property === "float") return "cssFloat";
		
		/*
			Microsoft vendor-prefixed properties are camel cased
			differently than other browsers:
			
			-webkit-something => WebkitSomething
			-moz-something => MozSomething
			-ms-something => msSomething
		*/
		if (property.indexOf("-ms-") === 0)
		{
			property = property.substr(1);
		}
		
		return property.replace(pattern, callback);
	}
	
	
	
	module.exports = camelCaseCSS;


/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./AD.json": 1152,
		"./AE.json": 1153,
		"./AF.json": 1154,
		"./AG.json": 1155,
		"./AI.json": 1156,
		"./AL.json": 1157,
		"./AM.json": 1158,
		"./AO.json": 1159,
		"./AR.json": 1160,
		"./AS.json": 1161,
		"./AT.json": 1162,
		"./AU.json": 1163,
		"./AW.json": 1164,
		"./AX.json": 1165,
		"./AZ.json": 1166,
		"./BA.json": 1167,
		"./BB.json": 1168,
		"./BD.json": 1169,
		"./BE.json": 1170,
		"./BF.json": 1171,
		"./BG.json": 1172,
		"./BH.json": 1173,
		"./BI.json": 1174,
		"./BJ.json": 1175,
		"./BM.json": 1176,
		"./BN.json": 1177,
		"./BO.json": 1178,
		"./BR.json": 1179,
		"./BS.json": 1180,
		"./BT.json": 1181,
		"./BW.json": 1182,
		"./BY.json": 1183,
		"./BZ.json": 1184,
		"./CA.json": 1185,
		"./CD.json": 1186,
		"./CF.json": 1187,
		"./CG.json": 1188,
		"./CH.json": 1189,
		"./CI.json": 1190,
		"./CK.json": 1191,
		"./CL.json": 1192,
		"./CM.json": 1193,
		"./CN.json": 1194,
		"./CO.json": 1195,
		"./CR.json": 1196,
		"./CU.json": 1197,
		"./CV.json": 1198,
		"./CX.json": 1199,
		"./CY.json": 1200,
		"./CZ.json": 1201,
		"./DE.json": 1202,
		"./DJ.json": 1203,
		"./DK.json": 1204,
		"./DM.json": 1205,
		"./DO.json": 1206,
		"./DZ.json": 1207,
		"./EC.json": 1208,
		"./EE.json": 1209,
		"./EG.json": 1210,
		"./ER.json": 1211,
		"./ES.json": 1212,
		"./ET.json": 1213,
		"./FI.json": 1214,
		"./FJ.json": 1215,
		"./FK.json": 1216,
		"./FM.json": 1217,
		"./FO.json": 1218,
		"./FR.json": 1219,
		"./GA.json": 1220,
		"./GB.json": 1221,
		"./GD.json": 1222,
		"./GE.json": 1223,
		"./GF.json": 1224,
		"./GG.json": 1225,
		"./GH.json": 1226,
		"./GI.json": 1227,
		"./GL.json": 1228,
		"./GM.json": 1229,
		"./GN.json": 1230,
		"./GP.json": 1231,
		"./GQ.json": 1232,
		"./GR.json": 1233,
		"./GT.json": 1234,
		"./GU.json": 1235,
		"./GW.json": 1236,
		"./GY.json": 1237,
		"./HK.json": 1238,
		"./HN.json": 1239,
		"./HR.json": 1240,
		"./HT.json": 1241,
		"./HU.json": 1242,
		"./ID.json": 1243,
		"./IE.json": 1244,
		"./IL.json": 1245,
		"./IM.json": 1246,
		"./IN.json": 1247,
		"./IQ.json": 1248,
		"./IR.json": 1249,
		"./IS.json": 1250,
		"./IT.json": 1251,
		"./JE.json": 1252,
		"./JM.json": 1253,
		"./JO.json": 1254,
		"./JP.json": 1255,
		"./KE.json": 1256,
		"./KG.json": 1257,
		"./KH.json": 1258,
		"./KI.json": 1259,
		"./KM.json": 1260,
		"./KN.json": 1261,
		"./KP.json": 1262,
		"./KR.json": 1263,
		"./KW.json": 1264,
		"./KY.json": 1265,
		"./KZ.json": 1266,
		"./LA.json": 1267,
		"./LB.json": 1268,
		"./LC.json": 1269,
		"./LI.json": 1270,
		"./LK.json": 1271,
		"./LR.json": 1272,
		"./LS.json": 1273,
		"./LT.json": 1274,
		"./LU.json": 1275,
		"./LV.json": 1276,
		"./LY.json": 1277,
		"./MA.json": 1278,
		"./MC.json": 1279,
		"./MD.json": 1280,
		"./ME.json": 1281,
		"./MG.json": 1282,
		"./MH.json": 1283,
		"./MK.json": 1284,
		"./ML.json": 1285,
		"./MM.json": 1286,
		"./MN.json": 1287,
		"./MO.json": 1288,
		"./MP.json": 1289,
		"./MQ.json": 1290,
		"./MR.json": 1291,
		"./MS.json": 1292,
		"./MT.json": 1293,
		"./MU.json": 1294,
		"./MV.json": 1295,
		"./MW.json": 1296,
		"./MX.json": 1297,
		"./MY.json": 1298,
		"./MZ.json": 1299,
		"./NA.json": 1300,
		"./NC.json": 1301,
		"./NE.json": 1302,
		"./NF.json": 1303,
		"./NG.json": 1304,
		"./NI.json": 1305,
		"./NL.json": 1306,
		"./NO.json": 1307,
		"./NP.json": 1308,
		"./NR.json": 1309,
		"./NU.json": 1310,
		"./NZ.json": 1311,
		"./OM.json": 1312,
		"./PA.json": 1313,
		"./PE.json": 1314,
		"./PF.json": 1315,
		"./PG.json": 1316,
		"./PH.json": 1317,
		"./PK.json": 1318,
		"./PL.json": 1319,
		"./PM.json": 1320,
		"./PN.json": 1321,
		"./PR.json": 1322,
		"./PS.json": 1323,
		"./PT.json": 1324,
		"./PW.json": 1325,
		"./PY.json": 1326,
		"./QA.json": 1327,
		"./RE.json": 1328,
		"./RO.json": 1329,
		"./RS.json": 1330,
		"./RU.json": 1331,
		"./RW.json": 1332,
		"./SA.json": 1333,
		"./SB.json": 1334,
		"./SC.json": 1335,
		"./SD.json": 1336,
		"./SE.json": 1337,
		"./SG.json": 1338,
		"./SH.json": 1339,
		"./SI.json": 1340,
		"./SK.json": 1341,
		"./SL.json": 1342,
		"./SM.json": 1343,
		"./SN.json": 1344,
		"./SO.json": 1345,
		"./SR.json": 1346,
		"./ST.json": 1347,
		"./SV.json": 1348,
		"./SY.json": 1349,
		"./SZ.json": 1350,
		"./TC.json": 1351,
		"./TD.json": 1352,
		"./TG.json": 1353,
		"./TH.json": 1354,
		"./TJ.json": 1355,
		"./TK.json": 1356,
		"./TL.json": 1357,
		"./TM.json": 1358,
		"./TN.json": 1359,
		"./TO.json": 1360,
		"./TR.json": 1361,
		"./TT.json": 1362,
		"./TV.json": 1363,
		"./TW.json": 1364,
		"./TZ.json": 1365,
		"./UA.json": 1366,
		"./UG.json": 1367,
		"./US.json": 1368,
		"./UY.json": 1369,
		"./UZ.json": 1370,
		"./VA.json": 1371,
		"./VC.json": 1372,
		"./VE.json": 1373,
		"./VG.json": 1374,
		"./VI.json": 1375,
		"./VN.json": 1376,
		"./VU.json": 1377,
		"./WF.json": 1378,
		"./WS.json": 1379,
		"./YE.json": 1380,
		"./YT.json": 1381,
		"./ZA.json": 1382,
		"./ZM.json": 1383,
		"./ZW.json": 1384,
		"./alt-af.json": 1385,
		"./alt-an.json": 1386,
		"./alt-as.json": 1387,
		"./alt-eu.json": 1388,
		"./alt-na.json": 1389,
		"./alt-oc.json": 1390,
		"./alt-sa.json": 1391,
		"./alt-ww.json": 1392
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 690;


/***/ },
/* 691 */
/***/ function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	var argv = process.argv;
	
	var terminator = argv.indexOf('--');
	var hasFlag = function (flag) {
		flag = '--' + flag;
		var pos = argv.indexOf(flag);
		return pos !== -1 && (terminator !== -1 ? pos < terminator : true);
	};
	
	module.exports = (function () {
		if ('FORCE_COLOR' in process.env) {
			return true;
		}
	
		if (hasFlag('no-color') ||
			hasFlag('no-colors') ||
			hasFlag('color=false')) {
			return false;
		}
	
		if (hasFlag('color') ||
			hasFlag('colors') ||
			hasFlag('color=true') ||
			hasFlag('color=always')) {
			return true;
		}
	
		if (process.stdout && !process.stdout.isTTY) {
			return false;
		}
	
		if (process.platform === 'win32') {
			return true;
		}
	
		if ('COLORTERM' in process.env) {
			return true;
		}
	
		if (process.env.TERM === 'dumb') {
			return false;
		}
	
		if (/^screen|^xterm|^vt100|color|ansi|cygwin|linux/i.test(process.env.TERM)) {
			return true;
		}
	
		return false;
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(111)))

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(1710)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(module, require('select'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod, global.select);
	        global.clipboardAction = mod.exports;
	    }
	})(this, function (module, _select) {
	    'use strict';
	
	    var _select2 = _interopRequireDefault(_select);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	        return typeof obj;
	    } : function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    var ClipboardAction = function () {
	        /**
	         * @param {Object} options
	         */
	        function ClipboardAction(options) {
	            _classCallCheck(this, ClipboardAction);
	
	            this.resolveOptions(options);
	            this.initSelection();
	        }
	
	        /**
	         * Defines base properties passed from constructor.
	         * @param {Object} options
	         */
	
	
	        _createClass(ClipboardAction, [{
	            key: 'resolveOptions',
	            value: function resolveOptions() {
	                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                this.action = options.action;
	                this.container = options.container;
	                this.emitter = options.emitter;
	                this.target = options.target;
	                this.text = options.text;
	                this.trigger = options.trigger;
	
	                this.selectedText = '';
	            }
	        }, {
	            key: 'initSelection',
	            value: function initSelection() {
	                if (this.text) {
	                    this.selectFake();
	                } else if (this.target) {
	                    this.selectTarget();
	                }
	            }
	        }, {
	            key: 'selectFake',
	            value: function selectFake() {
	                var _this = this;
	
	                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';
	
	                this.removeFake();
	
	                this.fakeHandlerCallback = function () {
	                    return _this.removeFake();
	                };
	                this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;
	
	                this.fakeElem = document.createElement('textarea');
	                // Prevent zooming on iOS
	                this.fakeElem.style.fontSize = '12pt';
	                // Reset box model
	                this.fakeElem.style.border = '0';
	                this.fakeElem.style.padding = '0';
	                this.fakeElem.style.margin = '0';
	                // Move element out of screen horizontally
	                this.fakeElem.style.position = 'absolute';
	                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
	                // Move element to the same position vertically
	                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
	                this.fakeElem.style.top = yPosition + 'px';
	
	                this.fakeElem.setAttribute('readonly', '');
	                this.fakeElem.value = this.text;
	
	                this.container.appendChild(this.fakeElem);
	
	                this.selectedText = (0, _select2.default)(this.fakeElem);
	                this.copyText();
	            }
	        }, {
	            key: 'removeFake',
	            value: function removeFake() {
	                if (this.fakeHandler) {
	                    this.container.removeEventListener('click', this.fakeHandlerCallback);
	                    this.fakeHandler = null;
	                    this.fakeHandlerCallback = null;
	                }
	
	                if (this.fakeElem) {
	                    this.container.removeChild(this.fakeElem);
	                    this.fakeElem = null;
	                }
	            }
	        }, {
	            key: 'selectTarget',
	            value: function selectTarget() {
	                this.selectedText = (0, _select2.default)(this.target);
	                this.copyText();
	            }
	        }, {
	            key: 'copyText',
	            value: function copyText() {
	                var succeeded = void 0;
	
	                try {
	                    succeeded = document.execCommand(this.action);
	                } catch (err) {
	                    succeeded = false;
	                }
	
	                this.handleResult(succeeded);
	            }
	        }, {
	            key: 'handleResult',
	            value: function handleResult(succeeded) {
	                this.emitter.emit(succeeded ? 'success' : 'error', {
	                    action: this.action,
	                    text: this.selectedText,
	                    trigger: this.trigger,
	                    clearSelection: this.clearSelection.bind(this)
	                });
	            }
	        }, {
	            key: 'clearSelection',
	            value: function clearSelection() {
	                if (this.trigger) {
	                    this.trigger.focus();
	                }
	
	                window.getSelection().removeAllRanges();
	            }
	        }, {
	            key: 'destroy',
	            value: function destroy() {
	                this.removeFake();
	            }
	        }, {
	            key: 'action',
	            set: function set() {
	                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';
	
	                this._action = action;
	
	                if (this._action !== 'copy' && this._action !== 'cut') {
	                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
	                }
	            },
	            get: function get() {
	                return this._action;
	            }
	        }, {
	            key: 'target',
	            set: function set(target) {
	                if (target !== undefined) {
	                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
	                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
	                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
	                        }
	
	                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
	                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
	                        }
	
	                        this._target = target;
	                    } else {
	                        throw new Error('Invalid "target" value, use a valid Element');
	                    }
	                }
	            },
	            get: function get() {
	                return this._target;
	            }
	        }]);
	
	        return ClipboardAction;
	    }();
	
	    module.exports = ClipboardAction;
	});

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(693), __webpack_require__(1722), __webpack_require__(1086)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
	        global.clipboard = mod.exports;
	    }
	})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
	    'use strict';
	
	    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);
	
	    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);
	
	    var _goodListener2 = _interopRequireDefault(_goodListener);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	        return typeof obj;
	    } : function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    function _possibleConstructorReturn(self, call) {
	        if (!self) {
	            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	        }
	
	        return call && (typeof call === "object" || typeof call === "function") ? call : self;
	    }
	
	    function _inherits(subClass, superClass) {
	        if (typeof superClass !== "function" && superClass !== null) {
	            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	        }
	
	        subClass.prototype = Object.create(superClass && superClass.prototype, {
	            constructor: {
	                value: subClass,
	                enumerable: false,
	                writable: true,
	                configurable: true
	            }
	        });
	        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	    }
	
	    var Clipboard = function (_Emitter) {
	        _inherits(Clipboard, _Emitter);
	
	        /**
	         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
	         * @param {Object} options
	         */
	        function Clipboard(trigger, options) {
	            _classCallCheck(this, Clipboard);
	
	            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));
	
	            _this.resolveOptions(options);
	            _this.listenClick(trigger);
	            return _this;
	        }
	
	        /**
	         * Defines if attributes would be resolved using internal setter functions
	         * or custom functions that were passed in the constructor.
	         * @param {Object} options
	         */
	
	
	        _createClass(Clipboard, [{
	            key: 'resolveOptions',
	            value: function resolveOptions() {
	                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
	                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
	                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
	                this.container = _typeof(options.container) === 'object' ? options.container : document.body;
	            }
	        }, {
	            key: 'listenClick',
	            value: function listenClick(trigger) {
	                var _this2 = this;
	
	                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
	                    return _this2.onClick(e);
	                });
	            }
	        }, {
	            key: 'onClick',
	            value: function onClick(e) {
	                var trigger = e.delegateTarget || e.currentTarget;
	
	                if (this.clipboardAction) {
	                    this.clipboardAction = null;
	                }
	
	                this.clipboardAction = new _clipboardAction2.default({
	                    action: this.action(trigger),
	                    target: this.target(trigger),
	                    text: this.text(trigger),
	                    container: this.container,
	                    trigger: trigger,
	                    emitter: this
	                });
	            }
	        }, {
	            key: 'defaultAction',
	            value: function defaultAction(trigger) {
	                return getAttributeValue('action', trigger);
	            }
	        }, {
	            key: 'defaultTarget',
	            value: function defaultTarget(trigger) {
	                var selector = getAttributeValue('target', trigger);
	
	                if (selector) {
	                    return document.querySelector(selector);
	                }
	            }
	        }, {
	            key: 'defaultText',
	            value: function defaultText(trigger) {
	                return getAttributeValue('text', trigger);
	            }
	        }, {
	            key: 'destroy',
	            value: function destroy() {
	                this.listener.destroy();
	
	                if (this.clipboardAction) {
	                    this.clipboardAction.destroy();
	                    this.clipboardAction = null;
	                }
	            }
	        }], [{
	            key: 'isSupported',
	            value: function isSupported() {
	                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];
	
	                var actions = typeof action === 'string' ? [action] : action;
	                var support = !!document.queryCommandSupported;
	
	                actions.forEach(function (action) {
	                    support = support && !!document.queryCommandSupported(action);
	                });
	
	                return support;
	            }
	        }]);
	
	        return Clipboard;
	    }(_tinyEmitter2.default);
	
	    /**
	     * Helper function to retrieve attribute value.
	     * @param {String} suffix
	     * @param {Element} element
	     */
	    function getAttributeValue(suffix, element) {
	        var attribute = 'data-clipboard-' + suffix;
	
	        if (!element.hasAttribute(attribute)) {
	            return;
	        }
	
	        return element.getAttribute(attribute);
	    }
	
	    module.exports = Clipboard;
	});

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(744);
	module.exports = __webpack_require__(55).RegExp.escape;


/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(374);
	__webpack_require__(726);
	module.exports = __webpack_require__(53).Array.from;


/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(728);
	module.exports = __webpack_require__(53).Object.assign;


/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(729);
	var $Object = __webpack_require__(53).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(733);
	module.exports = __webpack_require__(53).Object.entries;


/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(730);
	module.exports = __webpack_require__(53).Object.setPrototypeOf;


/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(734);
	module.exports = __webpack_require__(53).Object.values;


/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(732);
	__webpack_require__(731);
	__webpack_require__(735);
	__webpack_require__(736);
	module.exports = __webpack_require__(53).Symbol;


/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(374);
	__webpack_require__(737);
	module.exports = __webpack_require__(253).f('iterator');


/***/ },
/* 704 */
38,
/* 705 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 706 */
[1729, 97, 373, 724],
/* 707 */
[1730, 241, 61],
/* 708 */
[1731, 96, 146],
/* 709 */
[1735, 144, 246, 145],
/* 710 */
[1737, 86],
/* 711 */
[1740, 143, 61],
/* 712 */
[1741, 241],
/* 713 */
[1742, 120],
/* 714 */
[1743, 245, 146, 247, 121, 61],
/* 715 */
[1745, 61],
/* 716 */
388,
/* 717 */
[1746, 184, 122, 95, 96, 142],
/* 718 */
[1747, 84, 144, 246, 145, 183, 366, 142],
/* 719 */
[1750, 96, 120, 144, 84],
/* 720 */
[1752, 97, 369],
/* 721 */
[1754, 95, 183, 248],
/* 722 */
[1758, 122, 120, 242, 368],
/* 723 */
[1762, 250, 243],
/* 724 */
[1763, 250],
/* 725 */
[1771, 707, 61, 143, 53],
/* 726 */
[1772, 242, 85, 183, 713, 711, 373, 708, 725, 715],
/* 727 */
[1773, 705, 716, 143, 97, 367],
/* 728 */
[1774, 85, 718],
/* 729 */
[1775, 85, 245],
/* 730 */
[1776, 85, 722],
/* 731 */
/***/ function(module, exports) {



/***/ },
/* 732 */
[1778, 86, 95, 84, 85, 372, 717, 142, 249, 247, 184, 61, 253, 252, 709, 712, 120, 122, 183, 97, 251, 146, 245, 720, 368, 246, 96, 144, 369, 145, 182, 121],
/* 733 */
[1779, 85, 371],
/* 734 */
[1780, 85, 371],
/* 735 */
[1781, 252],
/* 736 */
[1782, 252],
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(727);
	var global = __webpack_require__(86);
	var hide = __webpack_require__(121);
	var Iterators = __webpack_require__(143);
	var TO_STRING_TAG = __webpack_require__(61)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	var isArray = __webpack_require__(188);
	var SPECIES = __webpack_require__(24)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(15);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(11);
	var toPrimitive = __webpack_require__(65);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ },
/* 741 */
[1735, 102, 192, 149],
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(150)('native-function-to-string', Function.toString);


/***/ },
/* 743 */
/***/ function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(2);
	var $re = __webpack_require__(743)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(376) });
	
	__webpack_require__(87)('copyWithin');


/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $every = __webpack_require__(62)(4);
	
	$export($export.P + $export.F * !__webpack_require__(57)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Array', { fill: __webpack_require__(255) });
	
	__webpack_require__(87)('fill');


/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $filter = __webpack_require__(62)(2);
	
	$export($export.P + $export.F * !__webpack_require__(57)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(2);
	var $find = __webpack_require__(62)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(87)(KEY);


/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(2);
	var $find = __webpack_require__(62)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(87)(KEY);


/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $forEach = __webpack_require__(62)(0);
	var STRICT = __webpack_require__(57)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 752 */
[1772, 56, 2, 33, 387, 263, 26, 257, 279, 190],
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $indexOf = __webpack_require__(185)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(57)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(188) });


/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(52);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(148) != Object || !__webpack_require__(57)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(52);
	var toInteger = __webpack_require__(58);
	var toLength = __webpack_require__(26);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(57)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $map = __webpack_require__(62)(1);
	
	$export($export.P + $export.F * !__webpack_require__(57)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var createProperty = __webpack_require__(257);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(15)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $reduce = __webpack_require__(378);
	
	$export($export.P + $export.F * !__webpack_require__(57)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $reduce = __webpack_require__(378);
	
	$export($export.P + $export.F * !__webpack_require__(57)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var html = __webpack_require__(261);
	var cof = __webpack_require__(54);
	var toAbsoluteIndex = __webpack_require__(106);
	var toLength = __webpack_require__(26);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(15)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $some = __webpack_require__(62)(3);
	
	$export($export.P + $export.F * !__webpack_require__(57)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(38);
	var toObject = __webpack_require__(33);
	var fails = __webpack_require__(15);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(57)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(105)('Array');


/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(2);
	var toISOString = __webpack_require__(739);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(33);
	var toPrimitive = __webpack_require__(65);
	
	$export($export.P + $export.F * __webpack_require__(15)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(24)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(42)(proto, TO_PRIMITIVE, __webpack_require__(740));


/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(43)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Function', { bind: __webpack_require__(379) });


/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(18);
	var getPrototypeOf = __webpack_require__(51);
	var HAS_INSTANCE = __webpack_require__(24)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(30).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(30).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(27) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(2);
	var log1p = __webpack_require__(390);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(2);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(2);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(2);
	var sign = __webpack_require__(267);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(2);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(2);
	var $expm1 = __webpack_require__(266);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { fround: __webpack_require__(389) });


/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(2);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(2);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(15)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(390) });


/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { sign: __webpack_require__(267) });


/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(2);
	var expm1 = __webpack_require__(266);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(15)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(2);
	var expm1 = __webpack_require__(266);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(13);
	var has = __webpack_require__(49);
	var cof = __webpack_require__(54);
	var inheritIfRequired = __webpack_require__(262);
	var toPrimitive = __webpack_require__(65);
	var fails = __webpack_require__(15);
	var gOPN = __webpack_require__(101).f;
	var gOPD = __webpack_require__(50).f;
	var dP = __webpack_require__(30).f;
	var $trim = __webpack_require__(126).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(100)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(27) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(43)(global, NUMBER, $Number);
	}


/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(2);
	var _isFinite = __webpack_require__(13).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(386) });


/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(2);
	var isInteger = __webpack_require__(386);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseFloat = __webpack_require__(398);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseInt = __webpack_require__(399);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toInteger = __webpack_require__(58);
	var aNumberValue = __webpack_require__(375);
	var repeat = __webpack_require__(274);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(15)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $fails = __webpack_require__(15);
	var aNumberValue = __webpack_require__(375);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ },
/* 802 */
[1774, 2, 392],
/* 803 */
[1775, 2, 100],
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(27), 'Object', { defineProperties: __webpack_require__(393) });


/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(27), 'Object', { defineProperty: __webpack_require__(30).f });


/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(18);
	var meta = __webpack_require__(89).onFreeze;
	
	__webpack_require__(64)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(52);
	var $getOwnPropertyDescriptor = __webpack_require__(50).f;
	
	__webpack_require__(64)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(64)('getOwnPropertyNames', function () {
	  return __webpack_require__(394).f;
	});


/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(33);
	var $getPrototypeOf = __webpack_require__(51);
	
	__webpack_require__(64)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(18);
	
	__webpack_require__(64)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(18);
	
	__webpack_require__(64)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(18);
	
	__webpack_require__(64)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(2);
	$export($export.S, 'Object', { is: __webpack_require__(402) });


/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(33);
	var $keys = __webpack_require__(102);
	
	__webpack_require__(64)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(18);
	var meta = __webpack_require__(89).onFreeze;
	
	__webpack_require__(64)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(18);
	var meta = __webpack_require__(89).onFreeze;
	
	__webpack_require__(64)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ },
/* 817 */
[1776, 2, 271],
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(123);
	var test = {};
	test[__webpack_require__(24)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(43)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseFloat = __webpack_require__(398);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseInt = __webpack_require__(399);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(88);
	var global = __webpack_require__(13);
	var ctx = __webpack_require__(56);
	var classof = __webpack_require__(123);
	var $export = __webpack_require__(2);
	var isObject = __webpack_require__(18);
	var aFunction = __webpack_require__(38);
	var anInstance = __webpack_require__(98);
	var forOf = __webpack_require__(99);
	var speciesConstructor = __webpack_require__(151);
	var task = __webpack_require__(276).set;
	var microtask = __webpack_require__(268)();
	var newPromiseCapabilityModule = __webpack_require__(269);
	var perform = __webpack_require__(400);
	var userAgent = __webpack_require__(198);
	var promiseResolve = __webpack_require__(401);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(24)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(104)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(125)($Promise, PROMISE);
	__webpack_require__(105)(PROMISE);
	Wrapper = __webpack_require__(55)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(190)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(38);
	var anObject = __webpack_require__(11);
	var rApply = (__webpack_require__(13).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(15)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(2);
	var create = __webpack_require__(100);
	var aFunction = __webpack_require__(38);
	var anObject = __webpack_require__(11);
	var isObject = __webpack_require__(18);
	var fails = __webpack_require__(15);
	var bind = __webpack_require__(379);
	var rConstruct = (__webpack_require__(13).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(30);
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(11);
	var toPrimitive = __webpack_require__(65);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(15)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(2);
	var gOPD = __webpack_require__(50).f;
	var anObject = __webpack_require__(11);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(11);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(264)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(50);
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(11);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(2);
	var getProto = __webpack_require__(51);
	var anObject = __webpack_require__(11);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(50);
	var getPrototypeOf = __webpack_require__(51);
	var has = __webpack_require__(49);
	var $export = __webpack_require__(2);
	var isObject = __webpack_require__(18);
	var anObject = __webpack_require__(11);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(11);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(397) });


/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(11);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(2);
	var setProto = __webpack_require__(271);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(30);
	var gOPD = __webpack_require__(50);
	var getPrototypeOf = __webpack_require__(51);
	var has = __webpack_require__(49);
	var $export = __webpack_require__(2);
	var createDesc = __webpack_require__(103);
	var anObject = __webpack_require__(11);
	var isObject = __webpack_require__(18);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13);
	var inheritIfRequired = __webpack_require__(262);
	var dP = __webpack_require__(30).f;
	var gOPN = __webpack_require__(101).f;
	var isRegExp = __webpack_require__(189);
	var $flags = __webpack_require__(147);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(27) && (!CORRECT_NEW || __webpack_require__(15)(function () {
	  re2[__webpack_require__(24)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(43)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(105)('RegExp');


/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(11);
	var toLength = __webpack_require__(26);
	var advanceStringIndex = __webpack_require__(254);
	var regExpExec = __webpack_require__(193);
	
	// @@match logic
	__webpack_require__(187)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(11);
	var toObject = __webpack_require__(33);
	var toLength = __webpack_require__(26);
	var toInteger = __webpack_require__(58);
	var advanceStringIndex = __webpack_require__(254);
	var regExpExec = __webpack_require__(193);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(187)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(11);
	var sameValue = __webpack_require__(402);
	var regExpExec = __webpack_require__(193);
	
	// @@search logic
	__webpack_require__(187)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(189);
	var anObject = __webpack_require__(11);
	var speciesConstructor = __webpack_require__(151);
	var advanceStringIndex = __webpack_require__(254);
	var toLength = __webpack_require__(26);
	var callRegExpExec = __webpack_require__(193);
	var regexpExec = __webpack_require__(270);
	var fails = __webpack_require__(15);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(187)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(408);
	var anObject = __webpack_require__(11);
	var $flags = __webpack_require__(147);
	var DESCRIPTORS = __webpack_require__(27);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(43)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(15)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(44)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(44)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(44)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(44)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $at = __webpack_require__(196)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(2);
	var toLength = __webpack_require__(26);
	var context = __webpack_require__(273);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(260)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(44)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(44)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(44)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var toAbsoluteIndex = __webpack_require__(106);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(2);
	var context = __webpack_require__(273);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(260)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(44)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ },
/* 854 */
[1777, 196, 265],
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(44)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(52);
	var toLength = __webpack_require__(26);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(274)
	});


/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(44)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(2);
	var toLength = __webpack_require__(26);
	var context = __webpack_require__(273);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(260)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(44)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(44)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(44)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(126)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ },
/* 864 */
[1778, 13, 49, 27, 2, 43, 89, 15, 150, 125, 107, 24, 405, 278, 741, 188, 11, 18, 33, 52, 65, 103, 100, 394, 50, 192, 30, 102, 101, 149, 88, 42],
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $typed = __webpack_require__(197);
	var buffer = __webpack_require__(277);
	var anObject = __webpack_require__(11);
	var toAbsoluteIndex = __webpack_require__(106);
	var toLength = __webpack_require__(26);
	var isObject = __webpack_require__(18);
	var ArrayBuffer = __webpack_require__(13).ArrayBuffer;
	var speciesConstructor = __webpack_require__(151);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(15)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(105)(ARRAY_BUFFER);


/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	$export($export.G + $export.W + $export.F * !__webpack_require__(197).ABV, {
	  DataView: __webpack_require__(277).DataView
	});


/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(75)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(75)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(75)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(75)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(75)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(75)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(75)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(75)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(75)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(382);
	var validate = __webpack_require__(108);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(186)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(2);
	var flattenIntoArray = __webpack_require__(383);
	var toObject = __webpack_require__(33);
	var toLength = __webpack_require__(26);
	var aFunction = __webpack_require__(38);
	var arraySpeciesCreate = __webpack_require__(256);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(87)('flatMap');


/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(2);
	var flattenIntoArray = __webpack_require__(383);
	var toObject = __webpack_require__(33);
	var toLength = __webpack_require__(26);
	var toInteger = __webpack_require__(58);
	var arraySpeciesCreate = __webpack_require__(256);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(87)('flatten');


/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(2);
	var $includes = __webpack_require__(185)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(87)('includes');


/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(2);
	var microtask = __webpack_require__(268)();
	var process = __webpack_require__(13).process;
	var isNode = __webpack_require__(54)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(2);
	var cof = __webpack_require__(54);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(2);
	
	$export($export.G, { global: __webpack_require__(13) });


/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(194)('Map');


/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(195)('Map');


/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(2);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(381)('Map') });


/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var scale = __webpack_require__(391);
	var fround = __webpack_require__(389);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { scale: __webpack_require__(391) });


/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(33);
	var aFunction = __webpack_require__(38);
	var $defineProperty = __webpack_require__(30);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(27) && $export($export.P + __webpack_require__(191), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(33);
	var aFunction = __webpack_require__(38);
	var $defineProperty = __webpack_require__(30);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(27) && $export($export.P + __webpack_require__(191), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 900 */
[1779, 2, 396],
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(2);
	var ownKeys = __webpack_require__(397);
	var toIObject = __webpack_require__(52);
	var gOPD = __webpack_require__(50);
	var createProperty = __webpack_require__(257);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(33);
	var toPrimitive = __webpack_require__(65);
	var getPrototypeOf = __webpack_require__(51);
	var getOwnPropertyDescriptor = __webpack_require__(50).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(27) && $export($export.P + __webpack_require__(191), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(33);
	var toPrimitive = __webpack_require__(65);
	var getPrototypeOf = __webpack_require__(51);
	var getOwnPropertyDescriptor = __webpack_require__(50).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(27) && $export($export.P + __webpack_require__(191), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 904 */
[1780, 2, 396],
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(2);
	var global = __webpack_require__(13);
	var core = __webpack_require__(55);
	var microtask = __webpack_require__(268)();
	var OBSERVABLE = __webpack_require__(24)('observable');
	var aFunction = __webpack_require__(38);
	var anObject = __webpack_require__(11);
	var anInstance = __webpack_require__(98);
	var redefineAll = __webpack_require__(104);
	var hide = __webpack_require__(42);
	var forOf = __webpack_require__(99);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(105)('Observable');


/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(2);
	var core = __webpack_require__(55);
	var global = __webpack_require__(13);
	var speciesConstructor = __webpack_require__(151);
	var promiseResolve = __webpack_require__(401);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(2);
	var newPromiseCapability = __webpack_require__(269);
	var perform = __webpack_require__(400);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(74);
	var anObject = __webpack_require__(11);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(74);
	var anObject = __webpack_require__(11);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(409);
	var from = __webpack_require__(377);
	var metadata = __webpack_require__(74);
	var anObject = __webpack_require__(11);
	var getPrototypeOf = __webpack_require__(51);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(74);
	var anObject = __webpack_require__(11);
	var getPrototypeOf = __webpack_require__(51);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(74);
	var anObject = __webpack_require__(11);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(74);
	var anObject = __webpack_require__(11);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(74);
	var anObject = __webpack_require__(11);
	var getPrototypeOf = __webpack_require__(51);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(74);
	var anObject = __webpack_require__(11);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(74);
	var anObject = __webpack_require__(11);
	var aFunction = __webpack_require__(38);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(194)('Set');


/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(195)('Set');


/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(2);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(381)('Set') });


/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(2);
	var $at = __webpack_require__(196)(true);
	var $fails = __webpack_require__(15);
	
	var FORCED = $fails(function () {
	  return '𠮷'.at(0) !== '𠮷';
	});
	
	$export($export.P + $export.F * FORCED, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(2);
	var defined = __webpack_require__(63);
	var toLength = __webpack_require__(26);
	var isRegExp = __webpack_require__(189);
	var getFlags = __webpack_require__(147);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(264)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(2);
	var $pad = __webpack_require__(403);
	var userAgent = __webpack_require__(198);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(2);
	var $pad = __webpack_require__(403);
	var userAgent = __webpack_require__(198);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(126)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(126)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ },
/* 926 */
[1781, 278],
/* 927 */
[1782, 278],
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(2);
	
	$export($export.S, 'System', { global: __webpack_require__(13) });


/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(194)('WeakMap');


/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(195)('WeakMap');


/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(194)('WeakSet');


/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(195)('WeakSet');


/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(280);
	var getKeys = __webpack_require__(102);
	var redefine = __webpack_require__(43);
	var global = __webpack_require__(13);
	var hide = __webpack_require__(42);
	var Iterators = __webpack_require__(124);
	var wks = __webpack_require__(24);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $task = __webpack_require__(276);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(13);
	var $export = __webpack_require__(2);
	var userAgent = __webpack_require__(198);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(864);
	__webpack_require__(803);
	__webpack_require__(805);
	__webpack_require__(804);
	__webpack_require__(807);
	__webpack_require__(809);
	__webpack_require__(814);
	__webpack_require__(808);
	__webpack_require__(806);
	__webpack_require__(816);
	__webpack_require__(815);
	__webpack_require__(811);
	__webpack_require__(812);
	__webpack_require__(810);
	__webpack_require__(802);
	__webpack_require__(813);
	__webpack_require__(817);
	__webpack_require__(818);
	__webpack_require__(770);
	__webpack_require__(772);
	__webpack_require__(771);
	__webpack_require__(820);
	__webpack_require__(819);
	__webpack_require__(790);
	__webpack_require__(800);
	__webpack_require__(801);
	__webpack_require__(791);
	__webpack_require__(792);
	__webpack_require__(793);
	__webpack_require__(794);
	__webpack_require__(795);
	__webpack_require__(796);
	__webpack_require__(797);
	__webpack_require__(798);
	__webpack_require__(799);
	__webpack_require__(773);
	__webpack_require__(774);
	__webpack_require__(775);
	__webpack_require__(776);
	__webpack_require__(777);
	__webpack_require__(778);
	__webpack_require__(779);
	__webpack_require__(780);
	__webpack_require__(781);
	__webpack_require__(782);
	__webpack_require__(783);
	__webpack_require__(784);
	__webpack_require__(785);
	__webpack_require__(786);
	__webpack_require__(787);
	__webpack_require__(788);
	__webpack_require__(789);
	__webpack_require__(851);
	__webpack_require__(856);
	__webpack_require__(863);
	__webpack_require__(854);
	__webpack_require__(846);
	__webpack_require__(847);
	__webpack_require__(852);
	__webpack_require__(857);
	__webpack_require__(859);
	__webpack_require__(842);
	__webpack_require__(843);
	__webpack_require__(844);
	__webpack_require__(845);
	__webpack_require__(848);
	__webpack_require__(849);
	__webpack_require__(850);
	__webpack_require__(853);
	__webpack_require__(855);
	__webpack_require__(858);
	__webpack_require__(860);
	__webpack_require__(861);
	__webpack_require__(862);
	__webpack_require__(765);
	__webpack_require__(767);
	__webpack_require__(766);
	__webpack_require__(769);
	__webpack_require__(768);
	__webpack_require__(754);
	__webpack_require__(752);
	__webpack_require__(758);
	__webpack_require__(755);
	__webpack_require__(761);
	__webpack_require__(763);
	__webpack_require__(751);
	__webpack_require__(757);
	__webpack_require__(748);
	__webpack_require__(762);
	__webpack_require__(746);
	__webpack_require__(760);
	__webpack_require__(759);
	__webpack_require__(753);
	__webpack_require__(756);
	__webpack_require__(745);
	__webpack_require__(747);
	__webpack_require__(750);
	__webpack_require__(749);
	__webpack_require__(764);
	__webpack_require__(280);
	__webpack_require__(836);
	__webpack_require__(407);
	__webpack_require__(841);
	__webpack_require__(408);
	__webpack_require__(837);
	__webpack_require__(838);
	__webpack_require__(839);
	__webpack_require__(840);
	__webpack_require__(821);
	__webpack_require__(406);
	__webpack_require__(409);
	__webpack_require__(410);
	__webpack_require__(876);
	__webpack_require__(865);
	__webpack_require__(866);
	__webpack_require__(871);
	__webpack_require__(874);
	__webpack_require__(875);
	__webpack_require__(869);
	__webpack_require__(872);
	__webpack_require__(870);
	__webpack_require__(873);
	__webpack_require__(867);
	__webpack_require__(868);
	__webpack_require__(822);
	__webpack_require__(823);
	__webpack_require__(824);
	__webpack_require__(825);
	__webpack_require__(826);
	__webpack_require__(829);
	__webpack_require__(827);
	__webpack_require__(828);
	__webpack_require__(830);
	__webpack_require__(831);
	__webpack_require__(832);
	__webpack_require__(833);
	__webpack_require__(835);
	__webpack_require__(834);
	__webpack_require__(879);
	__webpack_require__(877);
	__webpack_require__(878);
	__webpack_require__(920);
	__webpack_require__(923);
	__webpack_require__(922);
	__webpack_require__(924);
	__webpack_require__(925);
	__webpack_require__(921);
	__webpack_require__(926);
	__webpack_require__(927);
	__webpack_require__(901);
	__webpack_require__(904);
	__webpack_require__(900);
	__webpack_require__(898);
	__webpack_require__(899);
	__webpack_require__(902);
	__webpack_require__(903);
	__webpack_require__(885);
	__webpack_require__(919);
	__webpack_require__(884);
	__webpack_require__(918);
	__webpack_require__(930);
	__webpack_require__(932);
	__webpack_require__(883);
	__webpack_require__(917);
	__webpack_require__(929);
	__webpack_require__(931);
	__webpack_require__(882);
	__webpack_require__(928);
	__webpack_require__(881);
	__webpack_require__(886);
	__webpack_require__(887);
	__webpack_require__(888);
	__webpack_require__(889);
	__webpack_require__(890);
	__webpack_require__(892);
	__webpack_require__(891);
	__webpack_require__(893);
	__webpack_require__(894);
	__webpack_require__(895);
	__webpack_require__(897);
	__webpack_require__(896);
	__webpack_require__(906);
	__webpack_require__(907);
	__webpack_require__(908);
	__webpack_require__(909);
	__webpack_require__(911);
	__webpack_require__(910);
	__webpack_require__(913);
	__webpack_require__(912);
	__webpack_require__(914);
	__webpack_require__(915);
	__webpack_require__(916);
	__webpack_require__(880);
	__webpack_require__(905);
	__webpack_require__(935);
	__webpack_require__(934);
	__webpack_require__(933);
	module.exports = __webpack_require__(55);


/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(938);
	
	// -- Inlined from fbjs --
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function _invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var warning = function(){};
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	// /-- Inlined from fbjs --
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 938 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	var objectKeys = __webpack_require__(454);
	var isArguments = __webpack_require__(1094);
	var is = __webpack_require__(1470);
	var isRegex = __webpack_require__(1096);
	var flags = __webpack_require__(1708);
	var isDate = __webpack_require__(1095);
	
	var getTime = Date.prototype.getTime;
	
	function deepEqual(actual, expected, options) {
	  var opts = options || {};
	
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (opts.strict ? is(actual, expected) : actual === expected) {
	    return true;
	  }
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
	  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
	    return opts.strict ? is(actual, expected) : actual == expected;
	  }
	
	  /*
	   * 7.4. For all other Object pairs, including Array objects, equivalence is
	   * determined by having the same number of owned properties (as verified
	   * with Object.prototype.hasOwnProperty.call), the same set of keys
	   * (although not necessarily the same order), equivalent values for every
	   * corresponding key, and an identical 'prototype' property. Note: this
	   * accounts for both named and indexed properties on Arrays.
	   */
	  // eslint-disable-next-line no-use-before-define
	  return objEquiv(actual, expected, opts);
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer(x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
	    return false;
	  }
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') {
	    return false;
	  }
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  /* eslint max-statements: [2, 50] */
	  var i, key;
	  if (typeof a !== typeof b) { return false; }
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }
	
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) { return false; }
	
	  if (isArguments(a) !== isArguments(b)) { return false; }
	
	  var aIsRegex = isRegex(a);
	  var bIsRegex = isRegex(b);
	  if (aIsRegex !== bIsRegex) { return false; }
	  if (aIsRegex || bIsRegex) {
	    return a.source === b.source && flags(a) === flags(b);
	  }
	
	  if (isDate(a) && isDate(b)) {
	    return getTime.call(a) === getTime.call(b);
	  }
	
	  var aIsBuffer = isBuffer(a);
	  var bIsBuffer = isBuffer(b);
	  if (aIsBuffer !== bIsBuffer) { return false; }
	  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
	    if (a.length !== b.length) { return false; }
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) { return false; }
	    }
	    return true;
	  }
	
	  if (typeof a !== typeof b) { return false; }
	
	  try {
	    var ka = objectKeys(a);
	    var kb = objectKeys(b);
	  } catch (e) { // happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates hasOwnProperty)
	  if (ka.length !== kb.length) { return false; }
	
	  // the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  // ~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i]) { return false; }
	  }
	  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) { return false; }
	  }
	
	  return true;
	}
	
	module.exports = deepEqual;


/***/ },
/* 940 */
/***/ function(module, exports) {

	var DOCUMENT_NODE_TYPE = 9;
	
	/**
	 * A polyfill for Element.matches()
	 */
	if (typeof Element !== 'undefined' && !Element.prototype.matches) {
	    var proto = Element.prototype;
	
	    proto.matches = proto.matchesSelector ||
	                    proto.mozMatchesSelector ||
	                    proto.msMatchesSelector ||
	                    proto.oMatchesSelector ||
	                    proto.webkitMatchesSelector;
	}
	
	/**
	 * Finds the closest parent that matches a selector.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @return {Function}
	 */
	function closest (element, selector) {
	    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
	        if (typeof element.matches === 'function' &&
	            element.matches(selector)) {
	          return element;
	        }
	        element = element.parentNode;
	    }
	}
	
	module.exports = closest;


/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	var closest = __webpack_require__(940);
	
	/**
	 * Delegates event to a selector.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @param {Boolean} useCapture
	 * @return {Object}
	 */
	function _delegate(element, selector, type, callback, useCapture) {
	    var listenerFn = listener.apply(this, arguments);
	
	    element.addEventListener(type, listenerFn, useCapture);
	
	    return {
	        destroy: function() {
	            element.removeEventListener(type, listenerFn, useCapture);
	        }
	    }
	}
	
	/**
	 * Delegates event to a selector.
	 *
	 * @param {Element|String|Array} [elements]
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @param {Boolean} useCapture
	 * @return {Object}
	 */
	function delegate(elements, selector, type, callback, useCapture) {
	    // Handle the regular Element usage
	    if (typeof elements.addEventListener === 'function') {
	        return _delegate.apply(null, arguments);
	    }
	
	    // Handle Element-less usage, it defaults to global delegation
	    if (typeof type === 'function') {
	        // Use `document` as the first parameter, then apply arguments
	        // This is a short way to .unshift `arguments` without running into deoptimizations
	        return _delegate.bind(null, document).apply(null, arguments);
	    }
	
	    // Handle Selector-based usage
	    if (typeof elements === 'string') {
	        elements = document.querySelectorAll(elements);
	    }
	
	    // Handle Array-like based usage
	    return Array.prototype.map.call(elements, function (element) {
	        return _delegate(element, selector, type, callback, useCapture);
	    });
	}
	
	/**
	 * Finds closest match and invokes callback.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Function}
	 */
	function listener(element, selector, type, callback) {
	    return function(e) {
	        e.delegateTarget = closest(e.target, selector);
	
	        if (e.delegateTarget) {
	            callback.call(element, e);
	        }
	    }
	}
	
	module.exports = delegate;


/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _isDisposable = __webpack_require__(281);
	
	var _isDisposable2 = _interopRequireDefault(_isDisposable);
	
	/**
	 * Represents a group of disposable resources that are disposed together.
	 */
	
	var CompositeDisposable = (function () {
	  function CompositeDisposable() {
	    for (var _len = arguments.length, disposables = Array(_len), _key = 0; _key < _len; _key++) {
	      disposables[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, CompositeDisposable);
	
	    if (Array.isArray(disposables[0]) && disposables.length === 1) {
	      disposables = disposables[0];
	    }
	
	    for (var i = 0; i < disposables.length; i++) {
	      if (!_isDisposable2['default'](disposables[i])) {
	        throw new Error('Expected a disposable');
	      }
	    }
	
	    this.disposables = disposables;
	    this.isDisposed = false;
	  }
	
	  /**
	   * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
	   * @param {Disposable} item Disposable to add.
	   */
	
	  CompositeDisposable.prototype.add = function add(item) {
	    if (this.isDisposed) {
	      item.dispose();
	    } else {
	      this.disposables.push(item);
	    }
	  };
	
	  /**
	   * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
	   * @param {Disposable} item Disposable to remove.
	   * @returns {Boolean} true if found; false otherwise.
	   */
	
	  CompositeDisposable.prototype.remove = function remove(item) {
	    if (this.isDisposed) {
	      return false;
	    }
	
	    var index = this.disposables.indexOf(item);
	    if (index === -1) {
	      return false;
	    }
	
	    this.disposables.splice(index, 1);
	    item.dispose();
	    return true;
	  };
	
	  /**
	   * Disposes all disposables in the group and removes them from the group.
	   */
	
	  CompositeDisposable.prototype.dispose = function dispose() {
	    if (this.isDisposed) {
	      return;
	    }
	
	    var len = this.disposables.length;
	    var currentDisposables = new Array(len);
	    for (var i = 0; i < len; i++) {
	      currentDisposables[i] = this.disposables[i];
	    }
	
	    this.isDisposed = true;
	    this.disposables = [];
	    this.length = 0;
	
	    for (var i = 0; i < len; i++) {
	      currentDisposables[i].dispose();
	    }
	  };
	
	  return CompositeDisposable;
	})();
	
	exports['default'] = CompositeDisposable;
	module.exports = exports['default'];

/***/ },
/* 943 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var noop = function noop() {};
	
	/**
	 * The basic disposable.
	 */
	
	var Disposable = (function () {
	  _createClass(Disposable, null, [{
	    key: "empty",
	    value: { dispose: noop },
	    enumerable: true
	  }]);
	
	  function Disposable(action) {
	    _classCallCheck(this, Disposable);
	
	    this.isDisposed = false;
	    this.action = action || noop;
	  }
	
	  Disposable.prototype.dispose = function dispose() {
	    if (!this.isDisposed) {
	      this.action.call(null);
	      this.isDisposed = true;
	    }
	  };
	
	  return Disposable;
	})();
	
	exports["default"] = Disposable;
	module.exports = exports["default"];

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _isDisposable = __webpack_require__(281);
	
	var _isDisposable2 = _interopRequireDefault(_isDisposable);
	
	var SerialDisposable = (function () {
	  function SerialDisposable() {
	    _classCallCheck(this, SerialDisposable);
	
	    this.isDisposed = false;
	    this.current = null;
	  }
	
	  /**
	   * Gets the underlying disposable.
	   * @return The underlying disposable.
	   */
	
	  SerialDisposable.prototype.getDisposable = function getDisposable() {
	    return this.current;
	  };
	
	  /**
	   * Sets the underlying disposable.
	   * @param {Disposable} value The new underlying disposable.
	   */
	
	  SerialDisposable.prototype.setDisposable = function setDisposable() {
	    var value = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
	
	    if (value != null && !_isDisposable2['default'](value)) {
	      throw new Error('Expected either an empty value or a valid disposable');
	    }
	
	    var isDisposed = this.isDisposed;
	    var previous = undefined;
	
	    if (!isDisposed) {
	      previous = this.current;
	      this.current = value;
	    }
	
	    if (previous) {
	      previous.dispose();
	    }
	
	    if (isDisposed && value) {
	      value.dispose();
	    }
	  };
	
	  /**
	   * Disposes the underlying disposable as well as all future replacements.
	   */
	
	  SerialDisposable.prototype.dispose = function dispose() {
	    if (this.isDisposed) {
	      return;
	    }
	
	    this.isDisposed = true;
	    var previous = this.current;
	    this.current = null;
	
	    if (previous) {
	      previous.dispose();
	    }
	  };
	
	  return SerialDisposable;
	})();
	
	exports['default'] = SerialDisposable;
	module.exports = exports['default'];

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _isDisposable2 = __webpack_require__(281);
	
	var _isDisposable3 = _interopRequireDefault(_isDisposable2);
	
	exports.isDisposable = _isDisposable3['default'];
	
	var _Disposable2 = __webpack_require__(943);
	
	var _Disposable3 = _interopRequireDefault(_Disposable2);
	
	exports.Disposable = _Disposable3['default'];
	
	var _CompositeDisposable2 = __webpack_require__(942);
	
	var _CompositeDisposable3 = _interopRequireDefault(_CompositeDisposable2);
	
	exports.CompositeDisposable = _CompositeDisposable3['default'];
	
	var _SerialDisposable2 = __webpack_require__(944);
	
	var _SerialDisposable3 = _interopRequireDefault(_SerialDisposable2);
	
	exports.SerialDisposable = _SerialDisposable3['default'];

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _createStore = __webpack_require__(351);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _reducers = __webpack_require__(954);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _dragDrop = __webpack_require__(199);
	
	var dragDropActions = _interopRequireWildcard(_dragDrop);
	
	var _DragDropMonitor = __webpack_require__(947);
	
	var _DragDropMonitor2 = _interopRequireDefault(_DragDropMonitor);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DragDropManager = function () {
		function DragDropManager(createBackend) {
			var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
			_classCallCheck(this, DragDropManager);
	
			var store = (0, _createStore2.default)(_reducers2.default);
			this.context = context;
			this.store = store;
			this.monitor = new _DragDropMonitor2.default(store);
			this.registry = this.monitor.registry;
			this.backend = createBackend(this);
	
			store.subscribe(this.handleRefCountChange.bind(this));
		}
	
		_createClass(DragDropManager, [{
			key: 'handleRefCountChange',
			value: function handleRefCountChange() {
				var shouldSetUp = this.store.getState().refCount > 0;
				if (shouldSetUp && !this.isSetUp) {
					this.backend.setup();
					this.isSetUp = true;
				} else if (!shouldSetUp && this.isSetUp) {
					this.backend.teardown();
					this.isSetUp = false;
				}
			}
		}, {
			key: 'getContext',
			value: function getContext() {
				return this.context;
			}
		}, {
			key: 'getMonitor',
			value: function getMonitor() {
				return this.monitor;
			}
		}, {
			key: 'getBackend',
			value: function getBackend() {
				return this.backend;
			}
		}, {
			key: 'getRegistry',
			value: function getRegistry() {
				return this.registry;
			}
		}, {
			key: 'getActions',
			value: function getActions() {
				var manager = this;
				var dispatch = this.store.dispatch;
	
	
				function bindActionCreator(actionCreator) {
					return function () {
						for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
							args[_key] = arguments[_key];
						}
	
						var action = actionCreator.apply(manager, args);
						if (typeof action !== 'undefined') {
							dispatch(action);
						}
					};
				}
	
				return Object.keys(dragDropActions).filter(function (key) {
					return typeof dragDropActions[key] === 'function';
				}).reduce(function (boundActions, key) {
					var action = dragDropActions[key];
					boundActions[key] = bindActionCreator(action); // eslint-disable-line no-param-reassign
					return boundActions;
				}, {});
			}
		}]);
	
		return DragDropManager;
	}();
	
	exports.default = DragDropManager;

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isArray = __webpack_require__(110);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _matchesType = __webpack_require__(413);
	
	var _matchesType2 = _interopRequireDefault(_matchesType);
	
	var _HandlerRegistry = __webpack_require__(950);
	
	var _HandlerRegistry2 = _interopRequireDefault(_HandlerRegistry);
	
	var _dragOffset = __webpack_require__(412);
	
	var _dirtyHandlerIds = __webpack_require__(411);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DragDropMonitor = function () {
		function DragDropMonitor(store) {
			_classCallCheck(this, DragDropMonitor);
	
			this.store = store;
			this.registry = new _HandlerRegistry2.default(store);
		}
	
		_createClass(DragDropMonitor, [{
			key: 'subscribeToStateChange',
			value: function subscribeToStateChange(listener) {
				var _this = this;
	
				var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
				var handlerIds = options.handlerIds;
	
				(0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');
				(0, _invariant2.default)(typeof handlerIds === 'undefined' || (0, _isArray2.default)(handlerIds), 'handlerIds, when specified, must be an array of strings.');
	
				var prevStateId = this.store.getState().stateId;
				var handleChange = function handleChange() {
					var state = _this.store.getState();
					var currentStateId = state.stateId;
					try {
						var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, _dirtyHandlerIds.areDirty)(state.dirtyHandlerIds, handlerIds);
	
						if (!canSkipListener) {
							listener();
						}
					} finally {
						prevStateId = currentStateId;
					}
				};
	
				return this.store.subscribe(handleChange);
			}
		}, {
			key: 'subscribeToOffsetChange',
			value: function subscribeToOffsetChange(listener) {
				var _this2 = this;
	
				(0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');
	
				var previousState = this.store.getState().dragOffset;
				var handleChange = function handleChange() {
					var nextState = _this2.store.getState().dragOffset;
					if (nextState === previousState) {
						return;
					}
	
					previousState = nextState;
					listener();
				};
	
				return this.store.subscribe(handleChange);
			}
		}, {
			key: 'canDragSource',
			value: function canDragSource(sourceId) {
				var source = this.registry.getSource(sourceId);
				(0, _invariant2.default)(source, 'Expected to find a valid source.');
	
				if (this.isDragging()) {
					return false;
				}
	
				return source.canDrag(this, sourceId);
			}
		}, {
			key: 'canDropOnTarget',
			value: function canDropOnTarget(targetId) {
				var target = this.registry.getTarget(targetId);
				(0, _invariant2.default)(target, 'Expected to find a valid target.');
	
				if (!this.isDragging() || this.didDrop()) {
					return false;
				}
	
				var targetType = this.registry.getTargetType(targetId);
				var draggedItemType = this.getItemType();
				return (0, _matchesType2.default)(targetType, draggedItemType) && target.canDrop(this, targetId);
			}
		}, {
			key: 'isDragging',
			value: function isDragging() {
				return Boolean(this.getItemType());
			}
		}, {
			key: 'isDraggingSource',
			value: function isDraggingSource(sourceId) {
				var source = this.registry.getSource(sourceId, true);
				(0, _invariant2.default)(source, 'Expected to find a valid source.');
	
				if (!this.isDragging() || !this.isSourcePublic()) {
					return false;
				}
	
				var sourceType = this.registry.getSourceType(sourceId);
				var draggedItemType = this.getItemType();
				if (sourceType !== draggedItemType) {
					return false;
				}
	
				return source.isDragging(this, sourceId);
			}
		}, {
			key: 'isOverTarget',
			value: function isOverTarget(targetId) {
				var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { shallow: false };
				var shallow = options.shallow;
	
				if (!this.isDragging()) {
					return false;
				}
	
				var targetType = this.registry.getTargetType(targetId);
				var draggedItemType = this.getItemType();
				if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
					return false;
				}
	
				var targetIds = this.getTargetIds();
				if (!targetIds.length) {
					return false;
				}
	
				var index = targetIds.indexOf(targetId);
				if (shallow) {
					return index === targetIds.length - 1;
				} else {
					return index > -1;
				}
			}
		}, {
			key: 'getItemType',
			value: function getItemType() {
				return this.store.getState().dragOperation.itemType;
			}
		}, {
			key: 'getItem',
			value: function getItem() {
				return this.store.getState().dragOperation.item;
			}
		}, {
			key: 'getSourceId',
			value: function getSourceId() {
				return this.store.getState().dragOperation.sourceId;
			}
		}, {
			key: 'getTargetIds',
			value: function getTargetIds() {
				return this.store.getState().dragOperation.targetIds;
			}
		}, {
			key: 'getDropResult',
			value: function getDropResult() {
				return this.store.getState().dragOperation.dropResult;
			}
		}, {
			key: 'didDrop',
			value: function didDrop() {
				return this.store.getState().dragOperation.didDrop;
			}
		}, {
			key: 'isSourcePublic',
			value: function isSourcePublic() {
				return this.store.getState().dragOperation.isSourcePublic;
			}
		}, {
			key: 'getInitialClientOffset',
			value: function getInitialClientOffset() {
				return this.store.getState().dragOffset.initialClientOffset;
			}
		}, {
			key: 'getInitialSourceClientOffset',
			value: function getInitialSourceClientOffset() {
				return this.store.getState().dragOffset.initialSourceClientOffset;
			}
		}, {
			key: 'getClientOffset',
			value: function getClientOffset() {
				return this.store.getState().dragOffset.clientOffset;
			}
		}, {
			key: 'getSourceClientOffset',
			value: function getSourceClientOffset() {
				return (0, _dragOffset.getSourceClientOffset)(this.store.getState().dragOffset);
			}
		}, {
			key: 'getDifferenceFromInitialOffset',
			value: function getDifferenceFromInitialOffset() {
				return (0, _dragOffset.getDifferenceFromInitialOffset)(this.store.getState().dragOffset);
			}
		}]);
	
		return DragDropMonitor;
	}();
	
	exports.default = DragDropMonitor;

/***/ },
/* 948 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DragSource = function () {
		function DragSource() {
			_classCallCheck(this, DragSource);
		}
	
		_createClass(DragSource, [{
			key: "canDrag",
			value: function canDrag() {
				return true;
			}
		}, {
			key: "isDragging",
			value: function isDragging(monitor, handle) {
				return handle === monitor.getSourceId();
			}
		}, {
			key: "endDrag",
			value: function endDrag() {}
		}]);
	
		return DragSource;
	}();
	
	exports.default = DragSource;

/***/ },
/* 949 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DropTarget = function () {
		function DropTarget() {
			_classCallCheck(this, DropTarget);
		}
	
		_createClass(DropTarget, [{
			key: "canDrop",
			value: function canDrop() {
				return true;
			}
		}, {
			key: "hover",
			value: function hover() {}
		}, {
			key: "drop",
			value: function drop() {}
		}]);
	
		return DropTarget;
	}();
	
	exports.default = DropTarget;

/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isArray = __webpack_require__(110);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _asap = __webpack_require__(555);
	
	var _asap2 = _interopRequireDefault(_asap);
	
	var _registry = __webpack_require__(200);
	
	var _getNextUniqueId = __webpack_require__(957);
	
	var _getNextUniqueId2 = _interopRequireDefault(_getNextUniqueId);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HandlerRoles = {
		SOURCE: 'SOURCE',
		TARGET: 'TARGET'
	};
	
	function validateSourceContract(source) {
		(0, _invariant2.default)(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
		(0, _invariant2.default)(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
		(0, _invariant2.default)(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
	}
	
	function validateTargetContract(target) {
		(0, _invariant2.default)(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
		(0, _invariant2.default)(typeof target.hover === 'function', 'Expected hover to be a function.');
		(0, _invariant2.default)(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
	}
	
	function validateType(type, allowArray) {
		if (allowArray && (0, _isArray2.default)(type)) {
			type.forEach(function (t) {
				return validateType(t, false);
			});
			return;
		}
	
		(0, _invariant2.default)(typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
	}
	
	function getNextHandlerId(role) {
		var id = (0, _getNextUniqueId2.default)().toString();
		switch (role) {
			case HandlerRoles.SOURCE:
				return 'S' + id;
			case HandlerRoles.TARGET:
				return 'T' + id;
			default:
				(0, _invariant2.default)(false, 'Unknown role: ' + role);
		}
	}
	
	function parseRoleFromHandlerId(handlerId) {
		switch (handlerId[0]) {
			case 'S':
				return HandlerRoles.SOURCE;
			case 'T':
				return HandlerRoles.TARGET;
			default:
				(0, _invariant2.default)(false, 'Cannot parse handler ID: ' + handlerId);
		}
	}
	
	var HandlerRegistry = function () {
		function HandlerRegistry(store) {
			_classCallCheck(this, HandlerRegistry);
	
			this.store = store;
	
			this.types = {};
			this.handlers = {};
	
			this.pinnedSourceId = null;
			this.pinnedSource = null;
		}
	
		_createClass(HandlerRegistry, [{
			key: 'addSource',
			value: function addSource(type, source) {
				validateType(type);
				validateSourceContract(source);
	
				var sourceId = this.addHandler(HandlerRoles.SOURCE, type, source);
				this.store.dispatch((0, _registry.addSource)(sourceId));
				return sourceId;
			}
		}, {
			key: 'addTarget',
			value: function addTarget(type, target) {
				validateType(type, true);
				validateTargetContract(target);
	
				var targetId = this.addHandler(HandlerRoles.TARGET, type, target);
				this.store.dispatch((0, _registry.addTarget)(targetId));
				return targetId;
			}
		}, {
			key: 'addHandler',
			value: function addHandler(role, type, handler) {
				var id = getNextHandlerId(role);
				this.types[id] = type;
				this.handlers[id] = handler;
	
				return id;
			}
		}, {
			key: 'containsHandler',
			value: function containsHandler(handler) {
				var _this = this;
	
				return Object.keys(this.handlers).some(function (key) {
					return _this.handlers[key] === handler;
				});
			}
		}, {
			key: 'getSource',
			value: function getSource(sourceId, includePinned) {
				(0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');
	
				var isPinned = includePinned && sourceId === this.pinnedSourceId;
				var source = isPinned ? this.pinnedSource : this.handlers[sourceId];
	
				return source;
			}
		}, {
			key: 'getTarget',
			value: function getTarget(targetId) {
				(0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
				return this.handlers[targetId];
			}
		}, {
			key: 'getSourceType',
			value: function getSourceType(sourceId) {
				(0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');
				return this.types[sourceId];
			}
		}, {
			key: 'getTargetType',
			value: function getTargetType(targetId) {
				(0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
				return this.types[targetId];
			}
		}, {
			key: 'isSourceId',
			value: function isSourceId(handlerId) {
				var role = parseRoleFromHandlerId(handlerId);
				return role === HandlerRoles.SOURCE;
			}
		}, {
			key: 'isTargetId',
			value: function isTargetId(handlerId) {
				var role = parseRoleFromHandlerId(handlerId);
				return role === HandlerRoles.TARGET;
			}
		}, {
			key: 'removeSource',
			value: function removeSource(sourceId) {
				var _this2 = this;
	
				(0, _invariant2.default)(this.getSource(sourceId), 'Expected an existing source.');
				this.store.dispatch((0, _registry.removeSource)(sourceId));
	
				(0, _asap2.default)(function () {
					delete _this2.handlers[sourceId];
					delete _this2.types[sourceId];
				});
			}
		}, {
			key: 'removeTarget',
			value: function removeTarget(targetId) {
				var _this3 = this;
	
				(0, _invariant2.default)(this.getTarget(targetId), 'Expected an existing target.');
				this.store.dispatch((0, _registry.removeTarget)(targetId));
	
				(0, _asap2.default)(function () {
					delete _this3.handlers[targetId];
					delete _this3.types[targetId];
				});
			}
		}, {
			key: 'pinSource',
			value: function pinSource(sourceId) {
				var source = this.getSource(sourceId);
				(0, _invariant2.default)(source, 'Expected an existing source.');
	
				this.pinnedSourceId = sourceId;
				this.pinnedSource = source;
			}
		}, {
			key: 'unpinSource',
			value: function unpinSource() {
				(0, _invariant2.default)(this.pinnedSource, 'No source is pinned at the time.');
	
				this.pinnedSourceId = null;
				this.pinnedSource = null;
			}
		}]);
	
		return HandlerRegistry;
	}();
	
	exports.default = HandlerRegistry;

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createBackend;
	
	var _noop = __webpack_require__(450);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TestBackend = function () {
		function TestBackend(manager) {
			_classCallCheck(this, TestBackend);
	
			this.actions = manager.getActions();
		}
	
		_createClass(TestBackend, [{
			key: 'setup',
			value: function setup() {
				this.didCallSetup = true;
			}
		}, {
			key: 'teardown',
			value: function teardown() {
				this.didCallTeardown = true;
			}
		}, {
			key: 'connectDragSource',
			value: function connectDragSource() {
				return _noop2.default;
			}
		}, {
			key: 'connectDragPreview',
			value: function connectDragPreview() {
				return _noop2.default;
			}
		}, {
			key: 'connectDropTarget',
			value: function connectDropTarget() {
				return _noop2.default;
			}
		}, {
			key: 'simulateBeginDrag',
			value: function simulateBeginDrag(sourceIds, options) {
				this.actions.beginDrag(sourceIds, options);
			}
		}, {
			key: 'simulatePublishDragSource',
			value: function simulatePublishDragSource() {
				this.actions.publishDragSource();
			}
		}, {
			key: 'simulateHover',
			value: function simulateHover(targetIds, options) {
				this.actions.hover(targetIds, options);
			}
		}, {
			key: 'simulateDrop',
			value: function simulateDrop() {
				this.actions.drop();
			}
		}, {
			key: 'simulateEndDrag',
			value: function simulateEndDrag() {
				this.actions.endDrag();
			}
		}]);
	
		return TestBackend;
	}();
	
	function createBackend(manager) {
		return new TestBackend(manager);
	}

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DragDropManager = __webpack_require__(946);
	
	Object.defineProperty(exports, 'DragDropManager', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragDropManager).default;
	  }
	});
	
	var _DragSource = __webpack_require__(948);
	
	Object.defineProperty(exports, 'DragSource', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DragSource).default;
	  }
	});
	
	var _DropTarget = __webpack_require__(949);
	
	Object.defineProperty(exports, 'DropTarget', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropTarget).default;
	  }
	});
	
	var _createTestBackend = __webpack_require__(951);
	
	Object.defineProperty(exports, 'createTestBackend', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_createTestBackend).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = dragOperation;
	
	var _without = __webpack_require__(451);
	
	var _without2 = _interopRequireDefault(_without);
	
	var _dragDrop = __webpack_require__(199);
	
	var _registry = __webpack_require__(200);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
		itemType: null,
		item: null,
		sourceId: null,
		targetIds: [],
		dropResult: null,
		didDrop: false,
		isSourcePublic: null
	};
	
	function dragOperation() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
		var action = arguments[1];
	
		switch (action.type) {
			case _dragDrop.BEGIN_DRAG:
				return _extends({}, state, {
					itemType: action.itemType,
					item: action.item,
					sourceId: action.sourceId,
					isSourcePublic: action.isSourcePublic,
					dropResult: null,
					didDrop: false
				});
			case _dragDrop.PUBLISH_DRAG_SOURCE:
				return _extends({}, state, {
					isSourcePublic: true
				});
			case _dragDrop.HOVER:
				return _extends({}, state, {
					targetIds: action.targetIds
				});
			case _registry.REMOVE_TARGET:
				if (state.targetIds.indexOf(action.targetId) === -1) {
					return state;
				}
				return _extends({}, state, {
					targetIds: (0, _without2.default)(state.targetIds, action.targetId)
				});
			case _dragDrop.DROP:
				return _extends({}, state, {
					dropResult: action.dropResult,
					didDrop: true,
					targetIds: []
				});
			case _dragDrop.END_DRAG:
				return _extends({}, state, {
					itemType: null,
					item: null,
					sourceId: null,
					dropResult: null,
					didDrop: false,
					isSourcePublic: null,
					targetIds: []
				});
			default:
				return state;
		}
	}

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = reduce;
	
	var _dragOffset = __webpack_require__(412);
	
	var _dragOffset2 = _interopRequireDefault(_dragOffset);
	
	var _dragOperation = __webpack_require__(953);
	
	var _dragOperation2 = _interopRequireDefault(_dragOperation);
	
	var _refCount = __webpack_require__(955);
	
	var _refCount2 = _interopRequireDefault(_refCount);
	
	var _dirtyHandlerIds = __webpack_require__(411);
	
	var _dirtyHandlerIds2 = _interopRequireDefault(_dirtyHandlerIds);
	
	var _stateId = __webpack_require__(956);
	
	var _stateId2 = _interopRequireDefault(_stateId);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function reduce() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var action = arguments[1];
	
		return {
			dirtyHandlerIds: (0, _dirtyHandlerIds2.default)(state.dirtyHandlerIds, action, state.dragOperation),
			dragOffset: (0, _dragOffset2.default)(state.dragOffset, action),
			refCount: (0, _refCount2.default)(state.refCount, action),
			dragOperation: (0, _dragOperation2.default)(state.dragOperation, action),
			stateId: (0, _stateId2.default)(state.stateId)
		};
	}

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = refCount;
	
	var _registry = __webpack_require__(200);
	
	function refCount() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
		var action = arguments[1];
	
		switch (action.type) {
			case _registry.ADD_SOURCE:
			case _registry.ADD_TARGET:
				return state + 1;
			case _registry.REMOVE_SOURCE:
			case _registry.REMOVE_TARGET:
				return state - 1;
			default:
				return state;
		}
	}

/***/ },
/* 956 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = stateId;
	function stateId() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
		return state + 1;
	}

/***/ },
/* 957 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = getNextUniqueId;
	var nextUniqueId = 0;
	
	function getNextUniqueId() {
		return nextUniqueId++;
	}

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(29);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _addClass = _interopRequireDefault(__webpack_require__(415));
	
	exports.addClass = _addClass.default;
	
	var _removeClass = _interopRequireDefault(__webpack_require__(417));
	
	exports.removeClass = _removeClass.default;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(416));
	
	exports.hasClass = _hasClass.default;
	var _default = {
	  addClass: _addClass.default,
	  removeClass: _removeClass.default,
	  hasClass: _hasClass.default
	};
	exports.default = _default;

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(29);
	
	exports.__esModule = true;
	exports.default = filterEvents;
	
	var _contains = _interopRequireDefault(__webpack_require__(128));
	
	var _querySelectorAll = _interopRequireDefault(__webpack_require__(964));
	
	function filterEvents(selector, handler) {
	  return function filterHandler(e) {
	    var top = e.currentTarget,
	        target = e.target,
	        matches = (0, _querySelectorAll.default)(top, selector);
	    if (matches.some(function (match) {
	      return (0, _contains.default)(match, target);
	    })) handler.call(this, e);
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(29);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _on = _interopRequireDefault(__webpack_require__(201));
	
	exports.on = _on.default;
	
	var _off = _interopRequireDefault(__webpack_require__(282));
	
	exports.off = _off.default;
	
	var _filter = _interopRequireDefault(__webpack_require__(959));
	
	exports.filter = _filter.default;
	
	var _listen = _interopRequireDefault(__webpack_require__(961));
	
	exports.listen = _listen.default;
	var _default = {
	  on: _on.default,
	  off: _off.default,
	  filter: _filter.default,
	  listen: _listen.default
	};
	exports.default = _default;

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(29);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(76));
	
	var _on = _interopRequireDefault(__webpack_require__(201));
	
	var _off = _interopRequireDefault(__webpack_require__(282));
	
	var listen = function listen() {};
	
	if (_inDOM.default) {
	  listen = function listen(node, eventName, handler, capture) {
	    (0, _on.default)(node, eventName, handler, capture);
	    return function () {
	      (0, _off.default)(node, eventName, handler, capture);
	    };
	  };
	}
	
	var _default = listen;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(29);
	
	exports.__esModule = true;
	exports.default = offsetParent;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(127));
	
	var _style = _interopRequireDefault(__webpack_require__(203));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function offsetParent(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      offsetParent = node && node.offsetParent;
	
	  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
	    offsetParent = offsetParent.offsetParent;
	  }
	
	  return offsetParent || doc.documentElement;
	}
	
	module.exports = exports["default"];

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(29);
	
	exports.__esModule = true;
	exports.default = position;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(553));
	
	var _offset = _interopRequireDefault(__webpack_require__(418));
	
	var _offsetParent = _interopRequireDefault(__webpack_require__(962));
	
	var _scrollTop = _interopRequireDefault(__webpack_require__(419));
	
	var _scrollLeft = _interopRequireDefault(__webpack_require__(965));
	
	var _style = _interopRequireDefault(__webpack_require__(203));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function position(node, offsetParent) {
	  var parentOffset = {
	    top: 0,
	    left: 0
	  },
	      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
	  // because it is its only offset parent
	
	  if ((0, _style.default)(node, 'position') === 'fixed') {
	    offset = node.getBoundingClientRect();
	  } else {
	    offsetParent = offsetParent || (0, _offsetParent.default)(node);
	    offset = (0, _offset.default)(node);
	    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
	    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
	    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
	  } // Subtract parent offsets and node margins
	
	
	  return (0, _extends2.default)({}, offset, {
	    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
	    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
	  });
	}
	
	module.exports = exports["default"];

/***/ },
/* 964 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = qsa;
	// Zepto.js
	// (c) 2010-2015 Thomas Fuchs
	// Zepto.js may be freely distributed under the MIT license.
	var simpleSelectorRE = /^[\w-]*$/;
	var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
	
	function qsa(element, selector) {
	  var maybeID = selector[0] === '#',
	      maybeClass = selector[0] === '.',
	      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
	      isSimple = simpleSelectorRE.test(nameOnly),
	      found;
	
	  if (isSimple) {
	    if (maybeID) {
	      element = element.getElementById ? element : document;
	      return (found = element.getElementById(nameOnly)) ? [found] : [];
	    }
	
	    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
	    return toArray(element.getElementsByTagName(selector));
	  }
	
	  return toArray(element.querySelectorAll(selector));
	}
	
	module.exports = exports["default"];

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(29);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(202));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	
	module.exports = exports["default"];

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(29);
	
	exports.__esModule = true;
	exports.default = _getComputedStyle;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(420));
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
	    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	      prop = (0, _camelizeStyle.default)(prop);
	      if (prop == 'float') prop = 'styleFloat';
	      var current = node.currentStyle[prop] || null;
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out
	
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px'; // Revert the changed values
	
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 967 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeStyle;
	
	function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	}
	
	module.exports = exports["default"];

/***/ },
/* 968 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(property) {
	  return !!(property && supportedTransforms.test(property));
	}
	
	module.exports = exports["default"];

/***/ },
/* 969 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	
	module.exports = exports["default"];

/***/ },
/* 970 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hyphenate;
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	
	module.exports = exports["default"];

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(29);
	
	exports.__esModule = true;
	exports.default = hyphenateStyleName;
	
	var _hyphenate = _interopRequireDefault(__webpack_require__(970));
	
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	var msPattern = /^ms-/;
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
	}
	
	module.exports = exports["default"];

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(29);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(76));
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
	var cancel = 'clearTimeout';
	var raf = fallback;
	var compatRaf;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (_inDOM.default) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function raf(cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	/* https://github.com/component/raf */
	
	
	var prev = new Date().getTime();
	
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	  prev = curr;
	  return req;
	}
	
	compatRaf = function compatRaf(cb) {
	  return raf(cb);
	};
	
	compatRaf.cancel = function (id) {
	  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
	};
	
	var _default = compatRaf;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 973 */
/***/ function(module, exports) {

	module.exports = {
		"0.20": "39",
		"0.21": "41",
		"0.22": "41",
		"0.23": "41",
		"0.24": "41",
		"0.25": "42",
		"0.26": "42",
		"0.27": "43",
		"0.28": "43",
		"0.29": "43",
		"0.30": "44",
		"0.31": "45",
		"0.32": "45",
		"0.33": "45",
		"0.34": "45",
		"0.35": "45",
		"0.36": "47",
		"0.37": "49",
		"1.0": "49",
		"1.1": "50",
		"1.2": "51",
		"1.3": "52",
		"1.4": "53",
		"1.5": "54",
		"1.6": "56",
		"1.7": "58",
		"1.8": "59",
		"2.0": "61",
		"2.1": "61",
		"3.0": "66",
		"3.1": "66",
		"4.0": "69",
		"4.1": "69",
		"4.2": "69",
		"5.0": "73",
		"6.0": "76",
		"6.1": "76",
		"7.0": "78",
		"7.1": "78",
		"7.2": "78",
		"7.3": "78",
		"8.0": "80",
		"8.1": "80",
		"8.2": "80",
		"8.3": "80",
		"8.4": "80",
		"8.5": "80",
		"9.0": "83",
		"9.1": "83",
		"9.2": "83",
		"9.3": "83",
		"10.0": "85",
		"10.1": "85",
		"11.0": "87",
		"12.0": "89"
	};

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* globals
		Atomics,
		SharedArrayBuffer,
	*/
	
	var undefined;
	
	var $TypeError = TypeError;
	
	var $gOPD = Object.getOwnPropertyDescriptor;
	if ($gOPD) {
		try {
			$gOPD({}, '');
		} catch (e) {
			$gOPD = null; // this is IE 8, which has a broken gOPD
		}
	}
	
	var throwTypeError = function () { throw new $TypeError(); };
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(287)();
	
	var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto
	
	var generator; // = function * () {};
	var generatorFunction = generator ? getProto(generator) : undefined;
	var asyncFn; // async function() {};
	var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
	var asyncGen; // async function * () {};
	var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
	var asyncGenIterator = asyncGen ? asyncGen() : undefined;
	
	var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
		'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
		'%ArrayPrototype%': Array.prototype,
		'%ArrayProto_entries%': Array.prototype.entries,
		'%ArrayProto_forEach%': Array.prototype.forEach,
		'%ArrayProto_keys%': Array.prototype.keys,
		'%ArrayProto_values%': Array.prototype.values,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': asyncFunction,
		'%AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
		'%AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
		'%AsyncGeneratorFunction%': asyncGenFunction,
		'%AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
		'%AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%Boolean%': Boolean,
		'%BooleanPrototype%': Boolean.prototype,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
		'%Date%': Date,
		'%DatePrototype%': Date.prototype,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': Error,
		'%ErrorPrototype%': Error.prototype,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': EvalError,
		'%EvalErrorPrototype%': EvalError.prototype,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
		'%Function%': Function,
		'%FunctionPrototype%': Function.prototype,
		'%Generator%': generator ? getProto(generator()) : undefined,
		'%GeneratorFunction%': generatorFunction,
		'%GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%JSONParse%': typeof JSON === 'object' ? JSON.parse : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
		'%Math%': Math,
		'%Number%': Number,
		'%NumberPrototype%': Number.prototype,
		'%Object%': Object,
		'%ObjectPrototype%': Object.prototype,
		'%ObjProto_toString%': Object.prototype.toString,
		'%ObjProto_valueOf%': Object.prototype.valueOf,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
		'%PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
		'%Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
		'%Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
		'%Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': RangeError,
		'%RangeErrorPrototype%': RangeError.prototype,
		'%ReferenceError%': ReferenceError,
		'%ReferenceErrorPrototype%': ReferenceError.prototype,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%RegExpPrototype%': RegExp.prototype,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
		'%StringPrototype%': String.prototype,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
		'%SyntaxError%': SyntaxError,
		'%SyntaxErrorPrototype%': SyntaxError.prototype,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
		'%TypeError%': $TypeError,
		'%TypeErrorPrototype%': $TypeError.prototype,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
		'%URIError%': URIError,
		'%URIErrorPrototype%': URIError.prototype,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
		'%WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
	};
	
	var bind = __webpack_require__(153);
	var $replace = bind.call(Function.call, String.prototype.replace);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : (number || match);
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		if (!(name in INTRINSICS)) {
			throw new SyntaxError('intrinsic ' + name + ' does not exist!');
		}
	
		// istanbul ignore if // hopefully this is impossible to test :-)
		if (typeof INTRINSICS[name] === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}
	
		return INTRINSICS[name];
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new TypeError('"allowMissing" argument must be a boolean');
		}
	
		var parts = stringToPath(name);
	
		var value = getBaseIntrinsic('%' + (parts.length > 0 ? parts[0] : '') + '%', allowMissing);
		for (var i = 1; i < parts.length; i += 1) {
			if (value != null) {
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, parts[i]);
					if (!allowMissing && !(parts[i] in value)) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					// By convention, when a data property is converted to an accessor
					// property to emulate a data property that does not suffer from
					// the override mistake, that accessor's getter is marked with
					// an `originalValue` property. Here, when we detect this, we
					// uphold the illusion by pretending to see that original data
					// property, i.e., returning the value rather than the getter
					// itself.
					value = desc && 'get' in desc && !('originalValue' in desc.get) ? desc.get : value[parts[i]];
				} else {
					value = value[parts[i]];
				}
			}
		}
		return value;
	};


/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(153);
	
	var GetIntrinsic = __webpack_require__(974);
	
	var $apply = GetIntrinsic('%Function.prototype.apply%');
	var $call = GetIntrinsic('%Function.prototype.call%');
	var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);
	
	var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
	
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = null;
		}
	}
	
	module.exports = function callBind() {
		return $reflectApply(bind, $call, arguments);
	};
	
	var applyBind = function applyBind() {
		return $reflectApply(bind, $apply, arguments);
	};
	
	if ($defineProperty) {
		$defineProperty(module.exports, 'apply', { value: applyBind });
	} else {
		module.exports.apply = applyBind;
	}


/***/ },
/* 976 */
/***/ function(module, exports) {

	'use strict';
	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var defineProperty = Object.defineProperty;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var isArray = function isArray(arr) {
		if (typeof Array.isArray === 'function') {
			return Array.isArray(arr);
		}
	
		return toStr.call(arr) === '[object Array]';
	};
	
	var isPlainObject = function isPlainObject(obj) {
		if (!obj || toStr.call(obj) !== '[object Object]') {
			return false;
		}
	
		var hasOwnConstructor = hasOwn.call(obj, 'constructor');
		var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
		// Not own constructor property must be Object
		if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
			return false;
		}
	
		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		var key;
		for (key in obj) { /**/ }
	
		return typeof key === 'undefined' || hasOwn.call(obj, key);
	};
	
	// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
	var setProperty = function setProperty(target, options) {
		if (defineProperty && options.name === '__proto__') {
			defineProperty(target, options.name, {
				enumerable: true,
				configurable: true,
				value: options.newValue,
				writable: true
			});
		} else {
			target[options.name] = options.newValue;
		}
	};
	
	// Return undefined instead of __proto__ if '__proto__' is not an own property
	var getProperty = function getProperty(obj, name) {
		if (name === '__proto__') {
			if (!hasOwn.call(obj, name)) {
				return void 0;
			} else if (gOPD) {
				// In early versions of node, obj['__proto__'] is buggy when obj has
				// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
				return gOPD(obj, name).value;
			}
		}
	
		return obj[name];
	};
	
	module.exports = function extend() {
		var options, name, src, copy, copyIsArray, clone;
		var target = arguments[0];
		var i = 1;
		var length = arguments.length;
		var deep = false;
	
		// Handle a deep copy situation
		if (typeof target === 'boolean') {
			deep = target;
			target = arguments[1] || {};
			// skip the boolean and the target
			i = 2;
		}
		if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
			target = {};
		}
	
		for (; i < length; ++i) {
			options = arguments[i];
			// Only deal with non-null/undefined values
			if (options != null) {
				// Extend the base object
				for (name in options) {
					src = getProperty(target, name);
					copy = getProperty(options, name);
	
					// Prevent never-ending loop
					if (target !== copy) {
						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && isArray(src) ? src : [];
							} else {
								clone = src && isPlainObject(src) ? src : {};
							}
	
							// Never move original objects, clone them
							setProperty(target, { name: name, newValue: extend(deep, clone, copy) });
	
						// Don't bring in undefined values
						} else if (typeof copy !== 'undefined') {
							setProperty(target, { name: name, newValue: copy });
						}
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};


/***/ },
/* 977 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 978 */
977,
/* 979 */
977,
/* 980 */
977,
/* 981 */
977,
/* 982 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(982);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(992);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(40);
	
	var createArrayFromMixed = __webpack_require__(985);
	var getMarkupWrap = __webpack_require__(987);
	var invariant = __webpack_require__(12);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(40);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 988 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 989 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(989);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 991 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(991);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 993 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9020e3747a4f730fcbb7868c35fba83b.png";

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a561f1a2a02a9310add2a4da0322f112.png";

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b721b6c642a54612f1debfe4b041c2cd.png";

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6c1b37c5db261085b5b0b74d00eb80c3.png";

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f43513852d90375b5f3aabaff1fac223.png";

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1973a4ce029a3a3372b8620b5b1deef7.png";

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "36f224fe9e880f118d97c1431d8cb19a.png";

/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5ad5e5ce3689bd381d07f9c6fb988bda.png";

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "782d75bcbd252777f1837a4a163e9d06.png";

/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5af77c2257c5072934fa3c1bc8695165.png";

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6750a8b5b6fe9c828e5743efdce52f56.png";

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "beac6ae945c1a172d6970821c2d67517.png";

/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cbd0ac7753a4f95b52524e22f321eb70.png";

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f7a1d125d24c3cfe43ead26820e5fb68.png";

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "714f3e50cdb0f90d7b990a43bc9d421a.png";

/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0396ab2bedb2d56c8bb320d5f485be6f.png";

/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6cba88684b43ca192044f54e4e27fdc7.png";

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f453ab0ddf3ec9f375cae76427351d1c.png";

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5a9bd7225822886f3b844d911ca7abdb.png";

/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4e09c00f3c09f604598cfad9d642d264.png";

/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9143453213e20cfb5f05cf2c63dcac26.png";

/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "221df3c66dc8819e4750cf642db7a913.png";

/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1f211fe9cc3b7dbea9dcfcdccb2e3c52.png";

/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ceb731c9f19cfaadce7b4728e50bd90f.png";

/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bbdf61fe43cf81a76a5245dde3825829.png";

/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "090122987c8164dbbc6329f9a9c73e33.png";

/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "055b82e38d22882b9fc3f2344c45f5f2.png";

/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "55a6bc3d53edcf0eaeb41944566d1cc2.png";

/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a461ce8b7ecc488ae60025be6eba411e.png";

/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0e37ce0a90b64a149a5d3174a70df42a.png";

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1781d363627527a29a18812a7d092ccd.png";

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b4a8a110e388eda8bf4885d2bece30a3.png";

/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a63d7779f796b9f137df9678a5fffbad.png";

/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d8e19ef675efa9bbf565ee712107deec.png";

/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2ce04ce201cdc8be65b2e7ac0ab15846.png";

/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4a65e94a80488a8b0a93f28a4b0eaa31.png";

/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9e58f613a7f49bb3d372ddcb1b74a6a8.png";

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7223dfa91b41a15a51c3c604586fcc96.png";

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7e50081c56e6c100ec4b4fbb7fc399aa.png";

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5517aecc28f1e3ee18a48682f1d44768.png";

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a85ca58e12b0ab9c0297f5a91fe7b4c7.png";

/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3ef6675933e847c992131c12c9d7e5ec.png";

/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0df7fe2fc65b4d6e01c2ee2166af7bd6.png";

/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "157bd76b64bbc8c14f7ca3271bbb1d19.png";

/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0f15507a14e3e87aa40ada52ed57f354.png";

/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6c80c67eb397680f97b9b827e151901e.png";

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a3af5c17784eef6985a9f20d89db7053.png";

/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e2ca25b6e2dab66946b2c05bde9aa3ba.png";

/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bdb1e7c2561e9318a8a6c4b3c5a1e888.png";

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e86eb476ff170666c8310e9a66f5c023.png";

/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b3f0fbaadca2d5ffcef63b71e1c8e911.png";

/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "61104ca9215eb2839de3b997ae926b6c.png";

/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5d365088a1305dd0ba1fad7cc5b3dda3.png";

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "48c25e77c092e878e67ba332c413e062.png";

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "98cf20c72a0d44b699c0949a8854f982.png";

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fce4733727399dc78fbe54c8a74e69e2.png";

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ac817053884cde48c9c0f8cc5574fb39.png";

/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "be95b02bd6a5771bd8d2961c7dc38b6c.png";

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "12279ffbcfd135cceebdf911b61aa259.png";

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4f1f57f6d4bf50934ab9404436ba9073.png";

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3c555902dd16ed6b0d31aa4fae917029.png";

/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7fc03569e7745663951bbc2eccbd14f0.png";

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8b5c0cdb8e54ebe41d46cb63e0470377.png";

/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8656c26f6504e88d486866e59799493a.png";

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "85e590783b2abdccbdb26b573a6506e9.png";

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3fac4b659d4f5ddb9fef3ff76604113e.png";

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "353519fc6e9234cacd520b017e24f284.png";

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b51a1634be80587a757263694a3e5628.png";

/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7d02bb2f93454246eee5d3a56b35959a.png";

/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f3dbc9c18838322b5e7ecabc4f62f8e1.png";

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4f2fa09e243dce4bdb11727fccd60f5f.png";

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b27656122ea5770f46472703823e58ca.png";

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8ae18d07f2f7e8bc73852961412ef79b.png";

/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7520c2281d676fd483778b939e8aff35.png";

/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3cdc86d1f6aea391ac799c14f62bfe9d.png";

/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "054490c753e963c724bad67855921f90.png";

/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c7a62d7a11f9084f13919452f6852348.png";

/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "438e3424436bba764e0012551f8fd87e.png";

/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3bcd6f2ba3b73e8d6a6869a0241af331.png";

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6faf90f111fae9676c8c53a59f8b28b8.png";

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e469f536b40c087012270651987f5d1d.png";

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1a8101023e1c44147cb7f6be6673ab2a.png";

/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "78e7608e89bc29186360c4b79e91a171.png";

/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "673c57f5cfaf1fea688d852cca50e982.png";

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "34a905e93abed9700b33395e099cde27.png";

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a1f0e9b610d498eb080f4a1a0f7f82ac.png";

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "42bdc8917851490eadba6586e53bf312.png";

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d320c338119d67f417ffa3139cee4573.png";

/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "favicon.ico";

/***/ },
/* 1083 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* globals
		AggregateError,
		Atomics,
		FinalizationRegistry,
		SharedArrayBuffer,
		WeakRef,
	*/
	
	var undefined;
	
	var $SyntaxError = SyntaxError;
	var $Function = Function;
	var $TypeError = TypeError;
	
	// eslint-disable-next-line consistent-return
	var getEvalledConstructor = function (expressionSyntax) {
		try {
			// eslint-disable-next-line no-new-func
			return Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
		} catch (e) {}
	};
	
	var $gOPD = Object.getOwnPropertyDescriptor;
	if ($gOPD) {
		try {
			$gOPD({}, '');
		} catch (e) {
			$gOPD = null; // this is IE 8, which has a broken gOPD
		}
	}
	
	var throwTypeError = function () {
		throw new $TypeError();
	};
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(287)();
	
	var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto
	
	var asyncGenFunction = getEvalledConstructor('async function* () {}');
	var asyncGenFunctionPrototype = asyncGenFunction ? asyncGenFunction.prototype : undefined;
	var asyncGenPrototype = asyncGenFunctionPrototype ? asyncGenFunctionPrototype.prototype : undefined;
	
	var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': getEvalledConstructor('async function () {}'),
		'%AsyncGenerator%': asyncGenFunctionPrototype,
		'%AsyncGeneratorFunction%': asyncGenFunction,
		'%AsyncIteratorPrototype%': asyncGenPrototype ? getProto(asyncGenPrototype) : undefined,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
		'%Boolean%': Boolean,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%Date%': Date,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': Error,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': EvalError,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
		'%Function%': $Function,
		'%GeneratorFunction%': getEvalledConstructor('function* () {}'),
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%Math%': Math,
		'%Number%': Number,
		'%Object%': Object,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': RangeError,
		'%ReferenceError%': ReferenceError,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SyntaxError%': $SyntaxError,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypeError%': $TypeError,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%URIError%': URIError,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
	};
	
	var LEGACY_ALIASES = {
		'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
		'%ArrayPrototype%': ['Array', 'prototype'],
		'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
		'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
		'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
		'%ArrayProto_values%': ['Array', 'prototype', 'values'],
		'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
		'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
		'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
		'%BooleanPrototype%': ['Boolean', 'prototype'],
		'%DataViewPrototype%': ['DataView', 'prototype'],
		'%DatePrototype%': ['Date', 'prototype'],
		'%ErrorPrototype%': ['Error', 'prototype'],
		'%EvalErrorPrototype%': ['EvalError', 'prototype'],
		'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
		'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
		'%FunctionPrototype%': ['Function', 'prototype'],
		'%Generator%': ['GeneratorFunction', 'prototype'],
		'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
		'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
		'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
		'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
		'%JSONParse%': ['JSON', 'parse'],
		'%JSONStringify%': ['JSON', 'stringify'],
		'%MapPrototype%': ['Map', 'prototype'],
		'%NumberPrototype%': ['Number', 'prototype'],
		'%ObjectPrototype%': ['Object', 'prototype'],
		'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
		'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
		'%PromisePrototype%': ['Promise', 'prototype'],
		'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
		'%Promise_all%': ['Promise', 'all'],
		'%Promise_reject%': ['Promise', 'reject'],
		'%Promise_resolve%': ['Promise', 'resolve'],
		'%RangeErrorPrototype%': ['RangeError', 'prototype'],
		'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
		'%RegExpPrototype%': ['RegExp', 'prototype'],
		'%SetPrototype%': ['Set', 'prototype'],
		'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
		'%StringPrototype%': ['String', 'prototype'],
		'%SymbolPrototype%': ['Symbol', 'prototype'],
		'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
		'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
		'%TypeErrorPrototype%': ['TypeError', 'prototype'],
		'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
		'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
		'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
		'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
		'%URIErrorPrototype%': ['URIError', 'prototype'],
		'%WeakMapPrototype%': ['WeakMap', 'prototype'],
		'%WeakSetPrototype%': ['WeakSet', 'prototype']
	};
	
	var bind = __webpack_require__(153);
	var hasOwn = __webpack_require__(1089);
	var $concat = bind.call(Function.call, Array.prototype.concat);
	var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
	var $replace = bind.call(Function.call, String.prototype.replace);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		var intrinsicName = name;
		var alias;
		if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
			alias = LEGACY_ALIASES[intrinsicName];
			intrinsicName = '%' + alias[0] + '%';
		}
	
		if (hasOwn(INTRINSICS, intrinsicName)) {
			var value = INTRINSICS[intrinsicName];
			if (typeof value === 'undefined' && !allowMissing) {
				throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
			}
	
			return {
				alias: alias,
				name: intrinsicName,
				value: value
			};
		}
	
		throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new $TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new $TypeError('"allowMissing" argument must be a boolean');
		}
	
		var parts = stringToPath(name);
		var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
	
		var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
		var intrinsicRealName = intrinsic.name;
		var value = intrinsic.value;
		var skipFurtherCaching = false;
	
		var alias = intrinsic.alias;
		if (alias) {
			intrinsicBaseName = alias[0];
			$spliceApply(parts, $concat([0, 1], alias));
		}
	
		for (var i = 1, isOwn = true; i < parts.length; i += 1) {
			var part = parts[i];
			if (part === 'constructor' || !isOwn) {
				skipFurtherCaching = true;
			}
	
			intrinsicBaseName += '.' + part;
			intrinsicRealName = '%' + intrinsicBaseName + '%';
	
			if (hasOwn(INTRINSICS, intrinsicRealName)) {
				value = INTRINSICS[intrinsicRealName];
			} else if (value != null) {
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, part);
					isOwn = !!desc;
	
					if (!allowMissing && !(part in value)) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					// By convention, when a data property is converted to an accessor
					// property to emulate a data property that does not suffer from
					// the override mistake, that accessor's getter is marked with
					// an `originalValue` property. Here, when we detect this, we
					// uphold the illusion by pretending to see that original data
					// property, i.e., returning the value rather than the getter
					// itself.
					if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
						value = desc.get;
					} else {
						value = value[part];
					}
				} else {
					isOwn = hasOwn(value, part);
					value = value[part];
				}
	
				if (isOwn && !skipFurtherCaching) {
					INTRINSICS[intrinsicRealName] = value;
				}
			}
		}
		return value;
	};


/***/ },
/* 1085 */
/***/ function(module, exports) {

	/**
	 * Check if argument is a HTML element.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.node = function(value) {
	    return value !== undefined
	        && value instanceof HTMLElement
	        && value.nodeType === 1;
	};
	
	/**
	 * Check if argument is a list of HTML elements.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.nodeList = function(value) {
	    var type = Object.prototype.toString.call(value);
	
	    return value !== undefined
	        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
	        && ('length' in value)
	        && (value.length === 0 || exports.node(value[0]));
	};
	
	/**
	 * Check if argument is a string.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.string = function(value) {
	    return typeof value === 'string'
	        || value instanceof String;
	};
	
	/**
	 * Check if argument is a function.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.fn = function(value) {
	    var type = Object.prototype.toString.call(value);
	
	    return type === '[object Function]';
	};


/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	var is = __webpack_require__(1085);
	var delegate = __webpack_require__(941);
	
	/**
	 * Validates all params and calls the right
	 * listener function based on its target type.
	 *
	 * @param {String|HTMLElement|HTMLCollection|NodeList} target
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listen(target, type, callback) {
	    if (!target && !type && !callback) {
	        throw new Error('Missing required arguments');
	    }
	
	    if (!is.string(type)) {
	        throw new TypeError('Second argument must be a String');
	    }
	
	    if (!is.fn(callback)) {
	        throw new TypeError('Third argument must be a Function');
	    }
	
	    if (is.node(target)) {
	        return listenNode(target, type, callback);
	    }
	    else if (is.nodeList(target)) {
	        return listenNodeList(target, type, callback);
	    }
	    else if (is.string(target)) {
	        return listenSelector(target, type, callback);
	    }
	    else {
	        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
	    }
	}
	
	/**
	 * Adds an event listener to a HTML element
	 * and returns a remove listener function.
	 *
	 * @param {HTMLElement} node
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenNode(node, type, callback) {
	    node.addEventListener(type, callback);
	
	    return {
	        destroy: function() {
	            node.removeEventListener(type, callback);
	        }
	    }
	}
	
	/**
	 * Add an event listener to a list of HTML elements
	 * and returns a remove listener function.
	 *
	 * @param {NodeList|HTMLCollection} nodeList
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenNodeList(nodeList, type, callback) {
	    Array.prototype.forEach.call(nodeList, function(node) {
	        node.addEventListener(type, callback);
	    });
	
	    return {
	        destroy: function() {
	            Array.prototype.forEach.call(nodeList, function(node) {
	                node.removeEventListener(type, callback);
	            });
	        }
	    }
	}
	
	/**
	 * Add an event listener to a selector
	 * and returns a remove listener function.
	 *
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenSelector(selector, type, callback) {
	    return delegate(document.body, selector, type, callback);
	}
	
	module.exports = listen;


/***/ },
/* 1087 */
[1783, 352],
/* 1088 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(153);
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ },
/* 1090 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(129);
	
	var _PathUtils = __webpack_require__(109);
	
	var _ExecutionEnvironment = __webpack_require__(204);
	
	var _DOMUtils = __webpack_require__(288);
	
	var _DOMStateStorage = __webpack_require__(429);
	
	var _createDOMHistory = __webpack_require__(430);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    try {
	      historyState = historyState || window.history.state || {};
	    } catch (e) {
	      historyState = {};
	    }
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(129);
	
	var _PathUtils = __webpack_require__(109);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(109);
	
	var _Actions = __webpack_require__(129);
	
	var _createHistory = __webpack_require__(432);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ },
/* 1094 */
/***/ function(module, exports) {

	'use strict';
	
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	var toStr = Object.prototype.toString;
	
	var isStandardArguments = function isArguments(value) {
		if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
			return false;
		}
		return toStr.call(value) === '[object Arguments]';
	};
	
	var isLegacyArguments = function isArguments(value) {
		if (isStandardArguments(value)) {
			return true;
		}
		return value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value) !== '[object Array]' &&
			toStr.call(value.callee) === '[object Function]';
	};
	
	var supportsStandardArguments = (function () {
		return isStandardArguments(arguments);
	}());
	
	isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
	
	module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ },
/* 1095 */
/***/ function(module, exports) {

	'use strict';
	
	var getDay = Date.prototype.getDay;
	var tryDateObject = function tryDateGetDayCall(value) {
		try {
			getDay.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	var toStr = Object.prototype.toString;
	var dateClass = '[object Date]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) {
			return false;
		}
		return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
	};


/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasSymbols = __webpack_require__(287)();
	var hasToStringTag = hasSymbols && typeof Symbol.toStringTag === 'symbol';
	var hasOwnProperty;
	var regexExec;
	var isRegexMarker;
	var badStringifier;
	
	if (hasToStringTag) {
		hasOwnProperty = Function.call.bind(Object.prototype.hasOwnProperty);
		regexExec = Function.call.bind(RegExp.prototype.exec);
		isRegexMarker = {};
	
		var throwRegexMarker = function () {
			throw isRegexMarker;
		};
		badStringifier = {
			toString: throwRegexMarker,
			valueOf: throwRegexMarker
		};
	
		if (typeof Symbol.toPrimitive === 'symbol') {
			badStringifier[Symbol.toPrimitive] = throwRegexMarker;
		}
	}
	
	var toStr = Object.prototype.toString;
	var gOPD = Object.getOwnPropertyDescriptor;
	var regexClass = '[object RegExp]';
	
	module.exports = hasToStringTag
		// eslint-disable-next-line consistent-return
		? function isRegex(value) {
			if (!value || typeof value !== 'object') {
				return false;
			}
	
			var descriptor = gOPD(value, 'lastIndex');
			var hasLastIndexDataProperty = descriptor && hasOwnProperty(descriptor, 'value');
			if (!hasLastIndexDataProperty) {
				return false;
			}
	
			try {
				regexExec(value, badStringifier);
			} catch (e) {
				return e === isRegexMarker;
			}
		}
		: function isRegex(value) {
			// In older browsers, typeof regex incorrectly returns 'function'
			if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
				return false;
			}
	
			return toStr.call(value) === regexClass;
		};


/***/ },
/* 1097 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS3 Background-image options","description":"New properties to affect background images, including background-clip, background-origin and background-size","spec":"https://www.w3.org/TR/css3-background/#backgrounds","status":"cr","links":[{"url":"http://www.standardista.com/css3/css3-background-properties","title":"Detailed compatibility tables and demos"},{"url":"https://github.com/louisremi/background-size-polyfill","title":"Polyfill for IE7-8"},{"url":"https://developer.mozilla.org/en/docs/Web/CSS/background-image","title":"MDN Web Docs - background-image"}],"bugs":[{"description":"iOS Safari has buggy behavior with `background-size: cover;` on a page's body."},{"description":"iOS Safari has buggy behavior with `background-size: cover;` + `background-attachment: fixed;`"},{"description":"Safari (OS X and iOS) and Chrome do not support background-size: 100% <height>px; in combination with SVG images, it leaves them at the original size while other browsers stretch the vector image correctly while leaving the height at the specified number of pixels."},{"description":"Android 4.3 browser and below are reported to not support percentages in `background-size`"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"a x"},"chrome":{"4":"a #3","5":"a #3","6":"a #3","7":"a #3","8":"a #3","9":"a #3","10":"a #3","11":"a #3","12":"a #3","13":"a #3","14":"a #3","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a #2 #3","5":"a #2 #3","6":"a #2 #3","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a #2 #3","3.2":"a #2 #3","5.1":"a #2 #3","6.1":"a #2 #3","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"a x","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"a","4.0-4.1":"a","4.2-4.3":"a","5.0-5.1":"a #3","6.0-6.1":"a","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"a #1"},"android":{"3":"a #3","4":"a #3","81":"y","2.1":"a x","2.2":"a x #3","2.3":"a x #3","4.1":"a #3","4.2-4.3":"a #3","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Firefox, Chrome and Safari support the unofficial `-webkit-background-clip: text` (only with prefix). Safari does not support `-webkit-background-clip: text;` for `<button>` elements. But you can put `<span>` inside `<button>` to get the same result.","notes_by_num":{"1":"Partial support in Opera Mini refers to not supporting background sizing or background attachments. However Opera Mini 7.5 supports background sizing (including cover and contain values).","2":"Partial support in Safari 6 refers to not supporting background sizing offset from edges syntax.","3":"Does not support `background-size` values in the `background` shorthand"},"usage_perc_y":98.36,"usage_perc_a":1.21,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1098 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS3 Border images","description":"Method of using images for borders","spec":"https://www.w3.org/TR/css3-background/#border-images","status":"cr","links":[{"url":"https://www.webplatform.org/docs/css/properties/border-image","title":"WebPlatform Docs"},{"url":"https://developer.mozilla.org//docs/Web/CSS/border-image","title":"MDN Web Docs - Border image"}],"bugs":[{"description":"Firefox is not able to stretch svg images across an element - [bug report](https://bugzilla.mozilla.org/show_bug.cgi?id=619500)."},{"description":"WebKit browsers have a different rendering with the `round` value from other browsers, stretching the border rather than repeating it in certain cases [see bug](https://bugs.webkit.org/show_bug.cgi?id=155955)."}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"y","5.5":"n"},"edge":{"12":"y #1","13":"y #1","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a x #2 #3","5":"a x #2 #3","6":"a x #2 #3","7":"a x #2 #3","8":"a x #2 #3","9":"a x #2 #3","10":"a x #2 #3","11":"a x #2 #3","12":"a x #2 #3","13":"a x #2 #3","14":"a x #2 #3","15":"a #2","16":"a #2","17":"a #2","18":"a #2","19":"a #2","20":"a #2","21":"a #2","22":"a #2","23":"a #2","24":"a #2","25":"a #2","26":"a #2","27":"a #2","28":"a #2","29":"a #2","30":"a #2","31":"a #2","32":"a #2","33":"a #2","34":"a #2","35":"a #2","36":"a #2","37":"a #2","38":"a #2","39":"a #2","40":"a #2","41":"a #2","42":"a #2","43":"a #2","44":"a #2","45":"a #2","46":"a #2","47":"a #2","48":"a #2","49":"a #2","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a x #2 #3","3.6":"a x #2 #3"},"chrome":{"4":"a x #1 #2 #3 #4","5":"a x #1 #2 #3 #4","6":"a x #1 #2 #3 #4","7":"a x #1 #2 #3 #4","8":"a x #1 #2 #3 #4","9":"a x #1 #2 #3 #4","10":"a x #1 #2 #3 #4","11":"a x #1 #2 #3 #4","12":"a x #1 #2 #3 #4","13":"a x #1 #2 #3 #4","14":"a x #1 #2 #3 #4","15":"a #1 #2 #4","16":"a #1 #2 #4","17":"a #1 #2 #4","18":"a #1 #2 #4","19":"a #1 #2 #4","20":"a #1 #2 #4","21":"a #1 #2 #4","22":"a #1 #2 #4","23":"a #1 #2 #4","24":"a #1 #2 #4","25":"a #1 #2 #4","26":"a #1 #2 #4","27":"a #1 #2 #4","28":"a #1 #2 #4","29":"a #1 #2 #4","30":"a #1 #2","31":"a #1 #2","32":"a #1 #2","33":"a #1 #2","34":"a #1 #2","35":"a #1 #2","36":"a #1 #2","37":"a #1 #2","38":"a #1 #2","39":"a #1 #2","40":"a #1 #2","41":"a #1 #2","42":"a #1 #2","43":"a #1 #2","44":"a #1 #2","45":"a #1 #2","46":"a #1 #2","47":"a #1 #2","48":"a #1 #2","49":"a #1 #2","50":"a #1 #2","51":"a #2","52":"a #2","53":"a #2","54":"a #2","55":"a #2","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a x #1 #2 #3 #4","5":"a x #1 #2 #3 #4","6":"a #1 #2 #4","7":"a #1 #2 #4","8":"a #1 #2 #4","9":"a #1 #2 #4","10":"y #1","11":"y #1","12":"y #1","13":"y #1","14":"y #1","3.1":"a x #1 #2 #3 #4","3.2":"a x #1 #2 #3 #4","5.1":"a x #1 #2 #3 #4","6.1":"a #1 #2 #4","7.1":"a #1 #2 #4","9.1":"y #1","10.1":"y #1","11.1":"y #1","12.1":"y #1","13.1":"y #1","TP":"y #1"},"opera":{"9":"n","11":"a x #2 #3 #4","12":"a x #2 #3 #4","15":"a #1 #2","16":"a #1 #2","17":"a #1 #2","18":"a #1 #2","19":"a #1 #2","20":"a #1 #2","21":"a #1 #2","22":"a #1 #2","23":"a #1 #2","24":"a #1 #2","25":"a #1 #2","26":"a #1 #2","27":"a #1 #2","28":"a #1 #2","29":"a #1 #2","30":"a #1 #2","31":"a #1 #2","32":"a #1 #2","33":"a #1 #2","34":"a #1 #2","35":"a #1 #2","36":"a #1 #2","37":"a #1 #2","38":"a #2","39":"a #2","40":"a #2","41":"a #2","42":"a #2","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"a #2 #3 #4","10.6":"a #2 #3 #4","11.1":"a x #2 #3 #4","11.5":"a x #2 #3 #4","11.6":"a x #2 #3 #4","12.1":"a x #2 #3 #4"},"ios_saf":{"8":"a #1 #2 #4","14":"y #1","3.2":"a x #1 #2 #3 #4","4.0-4.1":"a x #1 #2 #3 #4","4.2-4.3":"a x #1 #2 #3 #4","5.0-5.1":"a x #1 #2 #3 #4","6.0-6.1":"a #1 #2 #4","7.0-7.1":"a #1 #2 #4","8.1-8.4":"a #1 #2 #4","9.0-9.2":"a #1 #2 #4","9.3":"y #1","10.0-10.2":"y #1","10.3":"y #1","11.0-11.2":"y #1","11.3-11.4":"y #1","12.0-12.1":"y #1","12.2-12.4":"y #1","13.0-13.1":"y #1","13.2":"y #1","13.3":"y #1","13.4-13.7":"y #1"},"op_mini":{"all":"a x #2 #3 #4"},"android":{"3":"a x #1 #2 #3 #4","4":"a x #1 #2 #3 #4","81":"a #1 #2","2.1":"a x #1 #2 #3 #4","2.2":"a x #1 #2 #3 #4","2.3":"a x #1 #2 #3 #4","4.1":"a x #1 #2 #3 #4","4.2-4.3":"a x #1 #2 #3 #4","4.4":"a #1 #2","4.4.3-4.4.4":"a #1 #2"},"bb":{"7":"a #1 #2 #3 #4","10":"a #1 #2 #4"},"op_mob":{"10":"n","11":"a x #2 #3 #4","12":"a x #2 #3 #4","59":"y","11.1":"a x #2 #3 #4","11.5":"a x #2 #3 #4","12.1":"a x #2 #3 #4"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"y"},"and_uc":{"12.12":"a #1 #2"},"samsung":{"4":"a #1 #2","5.0-5.4":"a #2","6.2-6.4":"a #2","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"a #2"},"baidu":{"7.12":"a #2"},"kaios":{"2.5":"a #2"}},"notes":"Note that both the `border-style` and `border-width` must be specified (not set to `none` or 0) for border-images to work.","notes_by_num":{"1":"Has a bug where `border-image` incorrectly overrides `border-style`. See [test case](https://codepen.io/Savago/pen/yYrgyK), [WebKit bug](https://bugs.webkit.org/show_bug.cgi?id=99922), [discussion](https://github.com/whatwg/compat/issues/17)","2":"Partial support refers to not supporting `border-image-repeat: space`","3":"Partial support refers to supporting the shorthand syntax, but not the individual properties (`border-image-source`, `border-image-slice`, etc). ","4":"Partial support refers to not supporting `border-image-repeat: round`"},"usage_perc_y":95.07,"usage_perc_a":4.27,"ucprefix":false,"parent":"","keywords":"border-image-source,border-image-slice,border-image-repeat,border-image-width,,border-image-outset","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1099 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS3 Border-radius (rounded corners)","description":"Method of making the border corners round. Covers support for the shorthand `border-radius` as well as the long-hand properties (e.g. `border-top-left-radius`)","spec":"https://www.w3.org/TR/css3-background/#the-border-radius","status":"cr","links":[{"url":"https://border-radius.com","title":"Border-radius CSS Generator"},{"url":"https://muddledramblings.com/table-of-css3-border-radius-compliance","title":"Detailed compliance table"},{"url":"http://css3pie.com/","title":"Polyfill which includes border-radius"},{"url":"https://www.webplatform.org/docs/css/properties/border-radius","title":"WebPlatform Docs"},{"url":"https://developer.mozilla.org/en/docs/Web/CSS/border-radius","title":"MDN Web Docs - CSS border-radius"}],"bugs":[{"description":"Android Browser 2.3 does not support % value for `border-radius`."},{"description":"Border-radius does not work on fieldset elements in IE9."},{"description":"The stock browser on the Samsung Galaxy S4 with Android 4.2 does not support the `border-radius` shorthand property but does support the long-hand properties for each corner like `border-top-left-radius`."},{"description":"Dotted and dashed rounded border corners are rendered as solid in Firefox. Fixed since Firefox 50. [see bug](https://bugzilla.mozilla.org/show_bug.cgi?id=382721)"},{"description":"Border-radius does not work on iframe elements in Safari"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"a x #2","3":"y x #2","4":"y #2","5":"y #2","6":"y #2","7":"y #2","8":"y #2","9":"y #2","10":"y #2","11":"y #2","12":"y #2","13":"y #2","14":"y #2","15":"y #2","16":"y #2","17":"y #2","18":"y #2","19":"y #2","20":"y #2","21":"y #2","22":"y #2","23":"y #2","24":"y #2","25":"y #2","26":"y #2","27":"y #2","28":"y #2","29":"y #2","30":"y #2","31":"y #2","32":"y #2","33":"y #2","34":"y #2","35":"y #2","36":"y #2","37":"y #2","38":"y #2","39":"y #2","40":"y #2","41":"y #2","42":"y #2","43":"y #2","44":"y #2","45":"y #2","46":"y #2","47":"y #2","48":"y #2","49":"y #2","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y x #2","3.6":"y x #2"},"chrome":{"4":"y x","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y x","5":"y","6":"y #1","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y x","3.2":"y x","5.1":"y #1","6.1":"y #1","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y x","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y","4":"y","81":"y","2.1":"y x","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"n","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y #2"}},"notes":"","notes_by_num":{"1":"Safari 6.1 and earlier did not apply `border-radius` correctly to image borders: https://stackoverflow.com/q/17202128","2":"Dotted and dashed rounded border corners are rendered as solid in Firefox. [see bug](https://bugzilla.mozilla.org/show_bug.cgi?id=382721)"},"usage_perc_y":98.71,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"roundedcorners, border radius,-moz-border-radius","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1100 */
/***/ function(module, exports) {

	module.exports = {"title":"calc() as CSS unit value","description":"Method of allowing calculated values for length units, i.e. `width: calc(100% - 3em)`","spec":"https://drafts.csswg.org/css-values-3/#calc-notation","status":"cr","links":[{"url":"https://hacks.mozilla.org/2010/06/css3-calc/","title":"Mozilla Hacks article"},{"url":"https://developer.mozilla.org/en/docs/Web/CSS/calc","title":"MDN Web Docs - calc"},{"url":"https://www.webplatform.org/docs/css/functions/calc","title":"WebPlatform Docs"}],"bugs":[{"description":"IE 9 - 11 and Edge do not support `width: calc()` on table cells. [Bug Report](https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10982196/)"},{"description":"IE 9 - 11 don't render `box-shadow` when `calc()` is used for any of the values"},{"description":"IE10 crashes when a div with a property using `calc()` has a child with [same property with inherit](https://stackoverflow.com/questions/19423384/css-less-calc-method-is-crashing-my-ie10)."},{"description":"IE10, IE11, and Edge < 14 don't support using `calc()` inside a `transform`. [Bug report](https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/104773/)"},{"description":"IE11 is reported to have trouble with `calc()` with nested expressions, e.g. `width: calc((100% - 10px) / 3);` (i.e. it rounds differently)"},{"description":"IE11 is reported to not support `calc()` correctly in [generated content](https://stackoverflow.com/questions/31323915/internet-explorer-incorrectly-calculates-percentage-height-for-generated-content)"},{"description":"IE11 does not support transitioning values set with `calc()`"},{"description":"Safari & iOS Safari (both 6 and 7) does not support viewport units (`vw`, `vh`, etc) in `calc()`."},{"description":"IE & Edge are reported to not support calc inside a 'flex'. (Not tested on older versions)\r\nThis example does not work: `flex: 1 1 calc(50% - 20px);`"},{"description":"IE does not support `calc()` on color functions. Example: `color: hsl(calc(60 * 2), 100%, 50%)`."},{"description":"Firefox <48 does not support `calc()` inside the `line-height`, `stroke-width`, `stroke-dashoffset`, and `stroke-dasharray` properties. [Bug report](https://bugzilla.mozilla.org/show_bug.cgi?id=594933)"},{"description":"Firefox <59 does not support `calc()` on color functions. Example: `color: hsl(calc(60 * 2), 100%, 50%)`. [Bug Report](https://bugzilla.mozilla.org/show_bug.cgi?id=984021)"},{"description":"Firefox <66 does not support `width: calc()` on table cells. [Bug Report](https://bugzilla.mozilla.org/show_bug.cgi?id=957915)"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"a #2","10":"a #3","11":"a #3","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y x","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"y x","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"a #1","4.4.3-4.4.4":"a #1"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Support can be somewhat emulated in older versions of IE using the non-standard `expression()` syntax.\r\n\r\nDue to the way browsers handle [sub-pixel rounding](https://johnresig.com/blog/sub-pixel-problems-in-css/) differently, layouts using `calc()` expressions may have unexpected results.","notes_by_num":{"1":"Partial support in Android Browser 4.4 refers to the browser lacking the ability to multiply and divide values.","2":"Partial support in IE9 refers to the browser crashing when used as a `background-position` value.","3":"Partial support in IE10/IE11 refers to calc not working properly with various use cases mentioned in known issues"},"usage_perc_y":96.9,"usage_perc_a":1.38,"ucprefix":false,"parent":"","keywords":"","ie_id":"csscalc","chrome_id":"5765241438732288","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1101 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS Animation","description":"Complex method of animating certain properties of an element","spec":"https://www.w3.org/TR/css3-animations/","status":"wd","links":[{"url":"http://robertnyman.com/2010/05/06/css3-animations/","title":"Blog post on usage"},{"url":"https://www.webplatform.org/docs/css/properties/animations","title":"WebPlatform Docs"}],"bugs":[{"description":"'animation-fill-mode' property is not supported in Android browser below 2.3."},{"description":"iOS 6.1 and below do not support animation on pseudo-elements. iOS 7 and higher are reported to have buggy behavior with animating pseudo-elements."},{"description":"@keyframes not supported in an inline or scoped stylesheet in Firefox ([bug 830056](https://bugzilla.mozilla.org/show_bug.cgi?id=830056))"},{"description":"In Chrome `animation-fill-mode backwards` is wrong if `steps(x, start)` is used [see example](https://codepen.io/Fyrd/pen/jPPKpX)."},{"description":"IE10 and IE11 do not support CSS keyframe blocks inside media queries. Must be defined outside of media query definitions. [example](https://codepen.io/anon/pen/ZOodVd)"},{"description":"IE10 and IE11 on Windows 7 have a bug where translate transform values are always interpreted as pixels when used in animations [test case](https://codepen.io/flxsource/pen/jPYWoE)"},{"description":"IE10 and IE11 will not fire Animation events for pseudo element animations. See [example here](https://codepen.io/dogoku/pen/JRwbmL)"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a x #2","5":"a x #2","6":"y x","7":"y x","8":"y x","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y x","6.1":"y x","7.1":"y x","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"y"},"ios_saf":{"8":"y x","14":"y","3.2":"a x #1","4.0-4.1":"a x #1","4.2-4.3":"a x #1","5.0-5.1":"a x #1","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"a x #1","4":"y x","81":"y","2.1":"a x #1","2.2":"a x #1","2.3":"a x #1","4.1":"y x","4.2-4.3":"y x","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"y x","10":"y x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y x"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support in Android browser refers to buggy behavior in different scenarios.","2":"Does not support the `steps()`, `step-start` & `step-end` timing functions"},"usage_perc_y":98.37,"usage_perc_a":0.04,"ucprefix":false,"parent":"","keywords":"animations,css-animations,animation-name,animation-duration,animation-delay,animation-timing-function,animation-iteration-count,@keyframes,animationstart,animationend,animationiteration,css3 animation,steps,step-start,step-end,cubic-bezier","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1102 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS :any-link selector","description":"The `:any-link` CSS pseudo-class matches all elements that match `:link` or `:visited`","spec":"https://drafts.csswg.org/selectors-4/#the-any-link-pseudo","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/:any-link","title":"MDN Web Docs - CSS :any-link"}],"bugs":[],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"u","3":"y x","4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y x","3.6":"y x"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","59":"y x","60":"y x","61":"y x","62":"y x","63":"y x","64":"y x","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"u","5":"u","6":"u","7":"y x","8":"y x","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"u","5.1":"u","6.1":"y x","7.1":"y x","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"u","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"u","4":"u","81":"y","2.1":"u","2.2":"u","2.3":"u","4.1":"u","4.2-4.3":"u","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"u","10":"u"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y x"},"samsung":{"4":"u","5.0-5.4":"y x","6.2-6.4":"y x","7.2-7.4":"y x","8.2":"y x","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y x"}},"notes":"","notes_by_num":{},"usage_perc_y":96.34,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"any-link,css4,selector,visited","ie_id":"","chrome_id":"5724922840088576","firefox_id":"","webkit_id":"feature-css-selector-:any-link","shown":true}

/***/ },
/* 1103 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS Appearance","description":"The `appearance` property defines how elements (particularly form controls) appear by default. By setting the value to `none` the default appearance can be entirely redefined using other CSS properties.","spec":"https://www.w3.org/TR/css-ui-4/#appearance-switching","status":"wd","links":[{"url":"https://css-tricks.com/almanac/properties/a/appearance/","title":"CSS Tricks article"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=143842","title":"Safari implementation bug for unprefixed `appearance`"}],"bugs":[],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"a #1 #2","13":"a #1 #2","14":"a #1 #2","15":"a #1 #2","16":"a #1 #2","17":"a #1 #2","18":"a #1 #2","79":"a x #1","80":"a x #1","81":"a x #1","83":"y x","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"a x #1 #3","3":"a x #1 #3","4":"a x #1 #3","5":"a x #1 #3","6":"a x #1 #3","7":"a x #1 #3","8":"a x #1 #3","9":"a x #1 #3","10":"a x #1 #3","11":"a x #1 #3","12":"a x #1 #3","13":"a x #1 #3","14":"a x #1 #3","15":"a x #1 #3","16":"a x #1 #3","17":"a x #1 #3","18":"a x #1 #3","19":"a x #1 #3","20":"a x #1 #3","21":"a x #1 #3","22":"a x #1 #3","23":"a x #1 #3","24":"a x #1 #3","25":"a x #1 #3","26":"a x #1 #3","27":"a x #1 #3","28":"a x #1 #3","29":"a x #1 #3","30":"a x #1 #3","31":"a x #1 #3","32":"a x #1 #3","33":"a x #1 #3","34":"a x #1 #3","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"a x #1","52":"a x #1","53":"a x #1","54":"a x #1","55":"a x #1","56":"a x #1","57":"a x #1","58":"a x #1","59":"a x #1","60":"a x #1","61":"a x #1","62":"a x #1","63":"a x #1","64":"a x #1","65":"a x #1","66":"a x #1","67":"a x #1","68":"a x #1","69":"a x #1","70":"a x #1","71":"a x #1","72":"a x #1","73":"a x #1","74":"a x #1","75":"a x #1","76":"a x #1","77":"a x #1","78":"a x #1","79":"a x #1","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a x #1 #3","3.6":"a x #1 #3"},"chrome":{"4":"a x #1","5":"a x #1","6":"a x #1","7":"a x #1","8":"a x #1","9":"a x #1","10":"a x #1","11":"a x #1","12":"a x #1","13":"a x #1","14":"a x #1","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","19":"a x #1","20":"a x #1","21":"a x #1","22":"a x #1","23":"a x #1","24":"a x #1","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"a x #1","52":"a x #1","53":"a x #1","54":"a x #1","55":"a x #1","56":"a x #1","57":"a x #1","58":"a x #1","59":"a x #1","60":"a x #1","61":"a x #1","62":"a x #1","63":"a x #1","64":"a x #1","65":"a x #1","66":"a x #1","67":"a x #1","68":"a x #1","69":"a x #1","70":"a x #1","71":"a x #1","72":"a x #1","73":"a x #1","74":"a x #1","75":"a x #1","76":"a x #1","77":"a x #1","78":"a x #1","79":"a x #1","80":"a x #1","81":"a x #1","83":"y x","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a x #1","5":"a x #1","6":"a x #1","7":"a x #1","8":"a x #1","9":"a x #1","10":"a x #1","11":"a x #1","12":"a x #1","13":"a x #1","14":"a x #1","3.1":"a x #1","3.2":"a x #1","5.1":"a x #1","6.1":"a x #1","7.1":"a x #1","9.1":"a x #1","10.1":"a x #1","11.1":"a x #1","12.1":"a x #1","13.1":"a x #1","TP":"a x #1"},"opera":{"9":"n","11":"n","12":"n","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","19":"a x #1","20":"a x #1","21":"a x #1","22":"a x #1","23":"a x #1","24":"a x #1","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"a x #1","52":"a x #1","53":"a x #1","54":"a x #1","55":"a x #1","56":"a x #1","57":"a x #1","58":"a x #1","60":"a x #1","62":"a x #1","63":"a x #1","64":"a x #1","65":"a x #1","66":"a x #1","67":"a x #1","68":"a x #1","69":"a x #1","70":"y x","71":"y x","72":"y x","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a x #1","14":"a x #1","3.2":"a x #1","4.0-4.1":"a x #1","4.2-4.3":"a x #1","5.0-5.1":"a x #1","6.0-6.1":"a x #1","7.0-7.1":"a x #1","8.1-8.4":"a x #1","9.0-9.2":"a x #1","9.3":"a x #1","10.0-10.2":"a x #1","10.3":"a x #1","11.0-11.2":"a x #1","11.3-11.4":"a x #1","12.0-12.1":"a x #1","12.2-12.4":"a x #1","13.0-13.1":"a x #1","13.2":"a x #1","13.3":"a x #1","13.4-13.7":"a x #1"},"op_mini":{"all":"n"},"android":{"3":"a x #1","4":"a x #1","81":"a x #1","2.1":"a x #1","2.2":"a x #1","2.3":"a x #1","4.1":"a x #1","4.2-4.3":"a x #1","4.4":"a x #1","4.4.3-4.4.4":"a x #1"},"bb":{"7":"a x #1","10":"a x #1"},"op_mob":{"10":"n","11":"n","12":"n","59":"a x #1","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"a x #1"},"ie_mob":{"10":"n","11":"a #1 #2"},"and_uc":{"12.12":"a x #1"},"samsung":{"4":"a x #1","5.0-5.4":"a x #1","6.2-6.4":"a x #1","7.2-7.4":"a x #1","8.2":"a x #1","9.2":"a x #1","10.1":"a x #1","11.1-11.2":"a x #1","12.0":"a x #1"},"and_qq":{"10.4":"a x #1"},"baidu":{"7.12":"a x #1"},"kaios":{"2.5":"a x #1"}},"notes":"WebKit, Blink, and Gecko browsers also support additional vendor specific values.","notes_by_num":{"1":"The appearance property is supported with the `none` value, but not `auto`.","2":"Microsoft Edge and IE Mobile support this property with the `-webkit-` prefix, rather than `-ms-` for interop reasons.","3":"`-moz-appearance:none` did not remove the dropdown arrow in the select tag"},"usage_perc_y":71.38,"usage_perc_a":25.95,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1104 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS Backdrop Filter","description":"Method of applying filter effects (like blur, grayscale or hue) to content/elements below the target element.","spec":"https://drafts.fxtf.org/filter-effects-2/#BackdropFilterProperty","status":"unoff","links":[{"url":"http://product.voxmedia.com/til/2015/2/17/8053347/css-ios-transparency-with-webkit-backdrop-filter","title":"Blog post"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/backdrop-filter","title":"MDN Web Docs - CSS backdrop filter"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/9160189-backdrop-filters","title":"Edge feature request"}],"bugs":[{"description":"Chrome feature request: [Chromium issue #497522](https://code.google.com/p/chromium/issues/detail?id=497522)"},{"description":"Firefox feature request: [Mozilla bug #1178765](https://bugzilla.mozilla.org/show_bug.cgi?id=1178765)"}],"categories":["CSS","CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"y #2","18":"y #2","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n d #3","71":"n d #3","72":"n d #3","73":"n d #3","74":"n d #3","75":"n d #3","76":"n d #3","77":"n d #3","78":"n d #3","79":"n d #3","80":"n d #3","81":"n d #3","82":"n d #3","83":"n d #3","84":"n d #3","85":"n d #3","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n d #1","48":"n d #1","49":"n d #1","50":"n d #1","51":"n d #1","52":"n d #1","53":"n d #1","54":"n d #1","55":"n d #1","56":"n d #1","57":"n d #1","58":"n d #1","59":"n d #1","60":"n d #1","61":"n d #1","62":"n d #1","63":"n d #1","64":"n d #1","65":"n d #1","66":"n d #1","67":"n d #1","68":"n d #1","69":"n d #1","70":"n d #1","71":"n d #1","72":"n d #1","73":"n d #1","74":"n d #1","75":"n d #1","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y x","10.1":"y x","11.1":"y x","12.1":"y x","13.1":"y x","TP":"y x"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n d #1","35":"n d #1","36":"n d #1","37":"n d #1","38":"n d #1","39":"n d #1","40":"n d #1","41":"n d #1","42":"n d #1","43":"n d #1","44":"n d #1","45":"n d #1","46":"n d #1","47":"n d #1","48":"n d #1","49":"n d #1","50":"n d #1","51":"n d #1","52":"n d #1","53":"n d #1","54":"n d #1","55":"n d #1","56":"n d #1","57":"n d #1","58":"n d #1","60":"n d #1","62":"n d #1","63":"n d #1","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y x","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y x","10.3":"y x","11.0-11.2":"y x","11.3-11.4":"y x","12.0-12.1":"y x","12.2-12.4":"y x","13.0-13.1":"y x","13.2":"y x","13.3":"y x","13.4-13.7":"y x"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n d #3"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n d #1","6.2-6.4":"n d #1","7.2-7.4":"n d #1","8.2":"n d #1","9.2":"n d #1","10.1":"n d #1","11.1-11.2":"n d #1","12.0":"y"},"and_qq":{"10.4":"n d #1"},"baidu":{"7.12":"n d #1"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Can be enabled via the \"Experimental Web Platform Features\" flag","2":"Currently only supported with the `-webkit-` prefix (not -ms-)","3":"Can be enabled by setting the `layout.css.backdrop-filter.enabled` and `gfx.webrender.all` preference to `true` in about:config."},"usage_perc_y":88.63,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"blue,hue-rotate,invert,saturate,filter","ie_id":"backdropfilter","chrome_id":"5679432723333120","firefox_id":"css-backdrop-filter","webkit_id":"feature-filter-effects-backdrop-filter-property","shown":true}

/***/ },
/* 1105 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS box-decoration-break","description":"Controls whether the box's margins, borders, padding, and other decorations wrap the broken edges of the box fragments (when the box is split by a break (page/column/region/line).","spec":"https://www.w3.org/TR/css3-break/#break-decoration","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/box-decoration-break","title":"MDN Web Docs - CSS box-decoration-break"},{"url":"http://jsbin.com/xojoro/edit?css,output","title":"Demo of effect on box border"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6514472-box-decoration-break","title":"Microsoft Edge feature request on UserVoice"}],"bugs":[],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"a x #1","80":"a x #1","81":"a x #1","83":"a x #1","84":"a x #1","85":"a x #1","86":"a x #1","87":"a x #1"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"a x #1","23":"a x #1","24":"a x #1","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"a x #1","52":"a x #1","53":"a x #1","54":"a x #1","55":"a x #1","56":"a x #1","57":"a x #1","58":"a x #1","59":"a x #1","60":"a x #1","61":"a x #1","62":"a x #1","63":"a x #1","64":"a x #1","65":"a x #1","66":"a x #1","67":"a x #1","68":"a x #1","69":"a x #1","70":"a x #1","71":"a x #1","72":"a x #1","73":"a x #1","74":"a x #1","75":"a x #1","76":"a x #1","77":"a x #1","78":"a x #1","79":"a x #1","80":"a x #1","81":"a x #1","83":"a x #1","84":"a x #1","85":"a x #1","86":"a x #1","87":"a x #1","88":"a x #1","89":"a x #1","90":"a x #1"},"safari":{"4":"n","5":"n","6":"n","7":"a x #1","8":"a x #1","9":"a x #1","10":"a x #1","11":"a x #1","12":"a x #1","13":"a x #1","14":"a x #1","3.1":"n","3.2":"n","5.1":"n","6.1":"a x #1","7.1":"a x #1","9.1":"a x #1","10.1":"a x #1","11.1":"a x #1","12.1":"a x #1","13.1":"a x #1","TP":"a x #1"},"opera":{"9":"n","11":"y #1","12":"y #1","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","19":"a x #1","20":"a x #1","21":"a x #1","22":"a x #1","23":"a x #1","24":"a x #1","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"a x #1","52":"a x #1","53":"a x #1","54":"a x #1","55":"a x #1","56":"a x #1","57":"a x #1","58":"a x #1","60":"a x #1","62":"a x #1","63":"a x #1","64":"a x #1","65":"a x #1","66":"a x #1","67":"a x #1","68":"a x #1","69":"a x #1","70":"a x #1","71":"a x #1","72":"a x #1","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"y #1","11.5":"y #1","11.6":"y #1","12.1":"y #1"},"ios_saf":{"8":"a x #1","14":"a x #1","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"a x #1","8.1-8.4":"a x #1","9.0-9.2":"a x #1","9.3":"a x #1","10.0-10.2":"a x #1","10.3":"a x #1","11.0-11.2":"a x #1","11.3-11.4":"a x #1","12.0-12.1":"a x #1","12.2-12.4":"a x #1","13.0-13.1":"a x #1","13.2":"a x #1","13.3":"a x #1","13.4-13.7":"a x #1"},"op_mini":{"all":"a #1"},"android":{"3":"n","4":"n","81":"a x #1","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"a x #1","4.4.3-4.4.4":"a x #1"},"bb":{"7":"n","10":"a x #1"},"op_mob":{"10":"n","11":"y #1","12":"y #1","59":"a x #1","11.1":"y #1","11.5":"y #1","12.1":"y #1"},"and_chr":{"86":"a x #1"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"a x #1","5.0-5.4":"a x #1","6.2-6.4":"a x #1","7.2-7.4":"a x #1","8.2":"a x #1","9.2":"a x #1","10.1":"a x #1","11.1-11.2":"a x #1","12.0":"a x #1"},"and_qq":{"10.4":"a x #1"},"baidu":{"7.12":"a x #1"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support refers to working for inline elements but not across column or page breaks."},"usage_perc_y":5.26,"usage_perc_a":91.98,"ucprefix":false,"parent":"","keywords":"box-decoration,box decoration,break","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1106 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS3 Box-shadow","description":"Method of displaying an inner or outer shadow effect to elements","spec":"https://www.w3.org/TR/css3-background/#box-shadow","status":"cr","links":[{"url":"https://developer.mozilla.org/En/CSS/-moz-box-shadow","title":"MDN Web Docs - box-shadow"},{"url":"http://westciv.com/tools/boxshadows/index.html","title":"Live editor"},{"url":"http://tests.themasta.com/blogstuff/boxshadowdemo.html","title":"Demo of various effects"},{"url":"https://www.webplatform.org/docs/css/properties/box-shadow","title":"WebPlatform Docs"}],"bugs":[{"description":"Edge and IE up to 11 suppress box-shadow in tables with border-collapse:collapse. [test case](https://codepen.io/Fyrd/pen/oXVYyq)"},{"description":"Safari 6, iOS 6 and Android 2.3 default browser don't work with a 0px value for \"blur-radius\".\r\ne.g. `-webkit-box-shadow: 5px 1px 0px 1px #f04e29;`\r\ndoesn't work, but\r\n`-webkit-box-shadow: 5px 1px 1px 1px #f04e29`\r\ndoes."},{"description":"iOS 8 has a bug where the box shadow disappears when zooming in a certain amount. [test case](https://jsfiddle.net/b6aaq57z/4/)"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y x","3.6":"y x"},"chrome":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a x #1","5":"y x","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a x #1","3.2":"a x #1","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"a x #1","4.0-4.1":"y x","4.2-4.3":"y x","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"a x #1","4":"y","81":"y","2.1":"a x #1","2.2":"a x #1","2.3":"a x #1","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y x","10":"y"},"op_mob":{"10":"n","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Can be partially emulated in older IE versions using the non-standard \"shadow\" filter.","notes_by_num":{"1":"Partial support in Safari, iOS Safari and Android Browser refers to missing \"inset\", blur radius value, and multiple shadow support."},"usage_perc_y":98.68,"usage_perc_a":0.02,"ucprefix":false,"parent":"","keywords":"box-shadows,boxshadows,box shadow,shaow","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1107 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS clip-path property (for HTML)","description":"Method of defining the visible region of an HTML element using SVG or a shape definition.","spec":"https://www.w3.org/TR/css-masking-1/#the-clip-path","status":"cr","links":[{"url":"https://css-tricks.com/almanac/properties/c/clip/","title":"CSS Tricks article"},{"url":"https://codepen.io/dubrod/details/myNNyW/","title":"Codepen Example Clipping an Image with a Polygon"},{"url":"http://lab.iamvdo.me/css-svg-masks","title":"Visual test cases"}],"bugs":[],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n d #4 #5","79":"a #2","80":"a #2","81":"a #2","83":"a #2","84":"a #2","85":"a #2","86":"a #2","87":"a #2"},"firefox":{"2":"n","3":"n","4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1 #3","48":"a #1 #3","49":"a #1 #3","50":"a #1 #3","51":"a #1 #3","52":"a #1 #3","53":"a #1 #3","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a #1","3.6":"a #1"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"a x #2","25":"a x #2","26":"a x #2","27":"a x #2","28":"a x #2","29":"a x #2","30":"a x #2","31":"a x #2","32":"a x #2","33":"a x #2","34":"a x #2","35":"a x #2","36":"a x #2","37":"a x #2","38":"a x #2","39":"a x #2","40":"a x #2","41":"a x #2","42":"a x #2","43":"a x #2","44":"a x #2","45":"a x #2","46":"a x #2","47":"a x #2","48":"a x #2","49":"a x #2","50":"a x #2","51":"a x #2","52":"a x #2","53":"a x #2","54":"a x #2","55":"a #2","56":"a #2","57":"a #2","58":"a #2","59":"a #2","60":"a #2","61":"a #2","62":"a #2","63":"a #2","64":"a #2","65":"a #2","66":"a #2","67":"a #2","68":"a #2","69":"a #2","70":"a #2","71":"a #2","72":"a #2","73":"a #2","74":"a #2","75":"a #2","76":"a #2","77":"a #2","78":"a #2","79":"a #2","80":"a #2","81":"a #2","83":"a #2","84":"a #2","85":"a #2","86":"a #2","87":"a #2","88":"a #2","89":"a #2","90":"a #2"},"safari":{"4":"n","5":"n","6":"n","7":"a x #2","8":"a x #2","9":"a x #2","10":"a x #2","11":"a x #2","12":"a x #2","13":"a x #2","14":"a x #2","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"a x #2","9.1":"a x #2","10.1":"a x #2","11.1":"a x #2","12.1":"a x #2","13.1":"a x #2","TP":"a x #2"},"opera":{"9":"n","11":"n","12":"n","15":"a x #2","16":"a x #2","17":"a x #2","18":"a x #2","19":"a x #2","20":"a x #2","21":"a x #2","22":"a x #2","23":"a x #2","24":"a x #2","25":"a x #2","26":"a x #2","27":"a x #2","28":"a x #2","29":"a x #2","30":"a x #2","31":"a x #2","32":"a x #2","33":"a x #2","34":"a x #2","35":"a x #2","36":"a x #2","37":"a x #2","38":"a x #2","39":"a x #2","40":"a x #2","41":"a x #2","42":"a #2","43":"a #2","44":"a #2","45":"a #2","46":"a #2","47":"a #2","48":"a #2","49":"a #2","50":"a #2","51":"a #2","52":"a #2","53":"a #2","54":"a #2","55":"a #2","56":"a #2","57":"a #2","58":"a #2","60":"a #2","62":"a #2","63":"a #2","64":"a #2","65":"a #2","66":"a #2","67":"a #2","68":"a #2","69":"a #2","70":"a #2","71":"a #2","72":"a #2","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a x #2","14":"a x #2","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"a x #2","8.1-8.4":"a x #2","9.0-9.2":"a x #2","9.3":"a x #2","10.0-10.2":"a x #2","10.3":"a x #2","11.0-11.2":"a x #2","11.3-11.4":"a x #2","12.0-12.1":"a x #2","12.2-12.4":"a x #2","13.0-13.1":"a x #2","13.2":"a x #2","13.3":"a x #2","13.4-13.7":"a x #2"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"a #2","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"a x #2","4.4.3-4.4.4":"a x #2"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"a #2","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a #2"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"a x #2"},"samsung":{"4":"a x #2","5.0-5.4":"a x #2","6.2-6.4":"a x #2","7.2-7.4":"a x #2","8.2":"a x #2","9.2":"a x #2","10.1":"a x #2","11.1-11.2":"a x #2","12.0":"a x #2"},"and_qq":{"10.4":"a x #2"},"baidu":{"7.12":"a #2"},"kaios":{"2.5":"a #1 #3"}},"notes":"Support refers to the `clip-path` CSS property on HTML elements specifically. Support for `clip-path` in SVG is supported in all browsers with [basic SVG](#feat=svg) support.","notes_by_num":{"1":"Partial support refers to only supporting the `url()` syntax.","2":"Partial support refers to supporting shapes and the `url(#foo)` syntax for inline SVG, but not shapes in external SVGs.","3":"Supports shapes behind the `layout.css.clip-path-shapes.enabled` flag","4":"Partial support can be enabled on MS Edge with the Enable CSS Clip-Path Flag","5":"While Edge doesn't seem to recognize any `<basic-shape>` function, it does allow you to use `polygon()` in HTML and SVG"},"usage_perc_y":3.71,"usage_perc_a":92.8,"ucprefix":false,"parent":"css-masks","keywords":"clippath","ie_id":"","chrome_id":"","firefox_id":"css-clip-path","webkit_id":"","shown":true}

/***/ },
/* 1108 */
/***/ function(module, exports) {

	module.exports = {"title":"Crisp edges/pixelated images","description":"Scales images with an algorithm that preserves edges and contrast, without smoothing colors or introducing blur. This is intended for images such as pixel art. Official values that accomplish this for the `image-rendering` property are `crisp-edges` and `pixelated`.","spec":"https://drafts.csswg.org/css-images-3/#valdef-image-rendering-crisp-edges","status":"unoff","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/image-rendering","title":"MDN Web Docs - CSS Image rendering"},{"url":"http://updates.html5rocks.com/2015/01/pixelated","title":"HTML5Rocks article"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=856337","title":"Firefox bug #856337: Implement image-rendering: pixelated"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=317991","title":"Chrome bug #317991: Implement image-rendering:crisp-edges"}],"bugs":[{"description":"`image-rendering:-webkit-optimize-contrast;` and `-ms-interpolation-mode:nearest-neighbor` do not affect CSS images."},{"description":"Safari [has a bug](https://bugs.webkit.org/show_bug.cgi?id=193895) where `image-rendering: pixelated` is not supported for WebGL contexts."}],"categories":["CSS","CSS3"],"stats":{"ie":{"6":"n","7":"a x #2 #5","8":"a x #2 #5","9":"a x #2 #5","10":"a x #2 #5","11":"a x #2 #5","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y #4","80":"y #4","81":"y #4","83":"y #4","84":"y #4","85":"y #4","86":"y #4","87":"y #4"},"firefox":{"2":"n","3":"n","4":"y x #3","5":"y x #3","6":"y x #3","7":"y x #3","8":"y x #3","9":"y x #3","10":"y x #3","11":"y x #3","12":"y x #3","13":"y x #3","14":"y x #3","15":"y x #3","16":"y x #3","17":"y x #3","18":"y x #3","19":"y x #3","20":"y x #3","21":"y x #3","22":"y x #3","23":"y x #3","24":"y x #3","25":"y x #3","26":"y x #3","27":"y x #3","28":"y x #3","29":"y x #3","30":"y x #3","31":"y x #3","32":"y x #3","33":"y x #3","34":"y x #3","35":"y x #3","36":"y x #3","37":"y x #3","38":"y x #3","39":"y x #3","40":"y x #3","41":"y x #3","42":"y x #3","43":"y x #3","44":"y x #3","45":"y x #3","46":"y x #3","47":"y x #3","48":"y x #3","49":"y x #3","50":"y x #3","51":"y x #3","52":"y x #3","53":"y x #3","54":"y x #3","55":"y x #3","56":"y x #3","57":"y x #3","58":"y x #3","59":"y x #3","60":"y x #3","61":"y x #3","62":"y x #3","63":"y x #3","64":"y x #3","65":"y #3","66":"y #3","67":"y #3","68":"y #3","69":"y #3","70":"y #3","71":"y #3","72":"y #3","73":"y #3","74":"y #3","75":"y #3","76":"y #3","77":"y #3","78":"y #3","79":"y #3","80":"y #3","81":"y #3","82":"y #3","83":"y #3","84":"y #3","85":"y #3","3.5":"n","3.6":"y x #3"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"y #4","42":"y #4","43":"y #4","44":"y #4","45":"y #4","46":"y #4","47":"y #4","48":"y #4","49":"y #4","50":"y #4","51":"y #4","52":"y #4","53":"y #4","54":"y #4","55":"y #4","56":"y #4","57":"y #4","58":"y #4","59":"y #4","60":"y #4","61":"y #4","62":"y #4","63":"y #4","64":"y #4","65":"y #4","66":"y #4","67":"y #4","68":"y #4","69":"y #4","70":"y #4","71":"y #4","72":"y #4","73":"y #4","74":"y #4","75":"y #4","76":"y #4","77":"y #4","78":"y #4","79":"y #4","80":"y #4","81":"y #4","83":"y #4","84":"y #4","85":"y #4","86":"y #4","87":"y #4","88":"y #4","89":"y #4","90":"y #4"},"safari":{"4":"n","5":"n","6":"a x #1","7":"a x #3 #6","8":"a x #3 #6","9":"a x #3 #6","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"a x #3 #6","7.1":"a x #3 #6","9.1":"a x #3 #6","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"y x #3","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"y #4","29":"y #4","30":"y #4","31":"y #4","32":"y #4","33":"y #4","34":"y #4","35":"y #4","36":"y #4","37":"y #4","38":"y #4","39":"y #4","40":"y #4","41":"y #4","42":"y #4","43":"y #4","44":"y #4","45":"y #4","46":"y #4","47":"y #4","48":"y #4","49":"y #4","50":"y #4","51":"y #4","52":"y #4","53":"y #4","54":"y #4","55":"y #4","56":"y #4","57":"y #4","58":"y #4","60":"y #4","62":"y #4","63":"y #4","64":"y #4","65":"y #4","66":"y #4","67":"y #4","68":"y #4","69":"y #4","70":"y #4","71":"y #4","72":"y #4","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"y x #3","12.1":"y x #3"},"ios_saf":{"8":"a x #3 #6","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"a x #1 #6","6.0-6.1":"a x #1 #6","7.0-7.1":"a x #3 #6","8.1-8.4":"a x #3 #6","9.0-9.2":"a x #3 #6","9.3":"a x #3 #6","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y #4","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"a x #1 #6"},"op_mob":{"10":"n","11":"n","12":"y x #3","59":"y #4","11.1":"n","11.5":"n","12.1":"y x #3"},"and_chr":{"86":"y #4"},"and_ff":{"82":"y x #3"},"ie_mob":{"10":"a x #2 #5","11":"a x #2 #5"},"and_uc":{"12.12":"y"},"samsung":{"4":"y #4","5.0-5.4":"y #4","6.2-6.4":"y #4","7.2-7.4":"y #4","8.2":"y #4","9.2":"y #4","10.1":"y #4","11.1-11.2":"y #4","12.0":"y #4"},"and_qq":{"10.4":"y #4"},"baidu":{"7.12":"y #4"},"kaios":{"2.5":"y #6"}},"notes":"Note that prefixes apply to the value (e.g. `-moz-crisp-edges`), not the `image-rendering` property.","notes_by_num":{"1":"Supported using the non-standard value `-webkit-optimize-contrast`","2":"Internet Explorer accomplishes support using the non-standard declaration `-ms-interpolation-mode: nearest-neighbor`","3":"Supports the `crisp-edges` value, but not `pixelated`.","4":"Supports the `pixelated` value, but not `crisp-edges`.","5":"Only works on `<img>`, not CSS backgrounds or `<canvas>`.","6":"Only works on `<img>` and CSS backgrounds, _not_ `<canvas>`. "},"usage_perc_y":95.82,"usage_perc_a":1.88,"ucprefix":false,"parent":"","keywords":"image-rendering,crisp-edges","ie_id":"imagerendering","chrome_id":"5118058116939776","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1109 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS Cross-Fade Function","description":"Image function to create a \"crossfade\" between images. This allows one image to transition (fade) into another based on a percentage value.","spec":"https://drafts.csswg.org/css-images-4/#cross-fade-function","status":"cr","links":[{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=546052","title":"Firefox bug #546052: Implement cross-fade()"}],"bugs":[],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y x","80":"y x","81":"y x","83":"y x","84":"y x","85":"y x","86":"y x","87":"y x"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","59":"y x","60":"y x","61":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y x","70":"y x","71":"y x","72":"y x","73":"y x","74":"y x","75":"y x","76":"y x","77":"y x","78":"y x","79":"y x","80":"y x","81":"y x","83":"y x","84":"y x","85":"y x","86":"y x","87":"y x","88":"y x","89":"y x","90":"y x"},"safari":{"4":"n","5":"n","6":"y x","7":"y x","8":"y x","9":"y x","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y x","6.1":"y x","7.1":"y x","9.1":"y x","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","60":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y x","70":"y x","71":"y x","72":"y x","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y x","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y x","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y x","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y x"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y x"},"samsung":{"4":"y x","5.0-5.4":"y x","6.2-6.4":"y x","7.2-7.4":"y x","8.2":"y x","9.2":"y x","10.1":"y x","11.1-11.2":"y x","12.0":"y x"},"and_qq":{"10.4":"y x"},"baidu":{"7.12":"y x"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":92.5,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"css,image,crossfade","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1110 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS Device Adaptation","description":"A standard way to override the size of viewport in web page using the `@viewport` rule, standardizing and replacing Apple's own popular `<meta>` viewport implementation.","spec":"https://www.w3.org/TR/css-device-adapt/","status":"wd","links":[{"url":"https://dev.opera.com/articles/view/an-introduction-to-meta-viewport-and-viewport/","title":"Introduction to meta viewport and @viewport in Opera Mobile"},{"url":"http://msdn.microsoft.com/en-us/library/ie/hh708740(v=vs.85).aspx","title":"Device adaptation in Internet Explorer 10"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6777420-unprefix-and-support-all-viewport-properties","title":"Microsoft Edge feature request on UserVoice"},{"url":"https://code.google.com/p/chromium/issues/detail?id=155477","title":"Chrome tracking bug"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=95959","title":"WebKit tracking bug"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=747754","title":"Mozilla tracking bug"}],"bugs":[],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"a x #1","11":"a x #1","5.5":"n"},"edge":{"12":"a x #1","13":"a x #1","14":"a x #1","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","79":"n d","80":"n d","81":"n d","83":"n d","84":"n d","85":"n d","86":"n d","87":"n d"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n d","30":"n d","31":"n d","32":"n d","33":"n d","34":"n d","35":"n d","36":"n d","37":"n d","38":"n d","39":"n d","40":"n d","41":"n d","42":"n d","43":"n d","44":"n d","45":"n d","46":"n d","47":"n d","48":"n d","49":"n d","50":"n d","51":"n d","52":"n d","53":"n d","54":"n d","55":"n d","56":"n d","57":"n d","58":"n d","59":"n d","60":"n d","61":"n d","62":"n d","63":"n d","64":"n d","65":"n d","66":"n d","67":"n d","68":"n d","69":"n d","70":"n d","71":"n d","72":"n d","73":"n d","74":"n d","75":"n d","76":"n d","77":"n d","78":"n d","79":"n d","80":"n d","81":"n d","83":"n d","84":"n d","85":"n d","86":"n d","87":"n d","88":"n d","89":"n d","90":"n d"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n d","41":"n d","42":"n d","43":"n d","44":"n d","45":"n d","46":"n d","47":"n d","48":"n d","49":"n d","50":"n d","51":"n d","52":"n d","53":"n d","54":"n d","55":"n d","56":"n d","57":"n d","58":"n d","60":"n d","62":"n d","63":"n d","64":"n d","65":"n d","66":"n d","67":"n d","68":"n d","69":"n d","70":"n d","71":"n d","72":"n d","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"a x #2"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"a x #2","12":"a x #2","59":"n","11.1":"a x #2","11.5":"a x #2","12.1":"a x #2"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"a x #1","11":"a x #1"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n d"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"IE only supports the 'width' and 'height' properties.","2":"Opera Mobile and Opera Mini only support the 'orientation' property."},"usage_perc_y":0,"usage_perc_a":2.41,"ucprefix":false,"parent":"","keywords":"viewport","ie_id":"cssdeviceadaptation","chrome_id":"4737164243894272","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1111 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS element() function","description":"This function renders a live image generated from an arbitrary HTML element","spec":"https://www.w3.org/TR/css4-images/#element-notation","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/element","title":"MDN Web Docs - CSS element"}],"bugs":[{"description":"Chromium [bug #108972](https://code.google.com/p/chromium/issues/detail?id=108972)"},{"description":"WebKit [bug #44650](https://bugs.webkit.org/show_bug.cgi?id=44650)"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"a x #1","3":"a x #1","4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","59":"y x","60":"y x","61":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y x","70":"y x","71":"y x","72":"y x","73":"y x","74":"y x","75":"y x","76":"y x","77":"y x","78":"y x","79":"y x","80":"y x","81":"y x","82":"y x","83":"y x","84":"y x","85":"y x","3.5":"a x #1","3.6":"a x #1"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"y x"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y x"}},"notes":"","notes_by_num":{"1":"In Firefox < 4, usage limited to the background and background-image CSS properties"},"usage_perc_y":4.21,"usage_perc_a":0.02,"ucprefix":false,"parent":"","keywords":"element, function","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1112 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS Feature Queries","description":"CSS Feature Queries allow authors to condition rules based on whether particular property declarations are supported in CSS using the @supports at rule.","spec":"https://www.w3.org/TR/css3-conditional/#at-supports","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/@supports","title":"MDN Web Docs - CSS @supports"},{"url":"https://mcc.id.au/blog/2012/08/supports","title":"@supports in Firefox"},{"url":"https://dabblet.com/gist/3895764","title":"Test case"},{"url":"https://www.webplatform.org/docs/css/atrules/@supports","title":"WebPlatform Docs"}],"bugs":[{"description":"Using @supports on Chrome 28-29 and Opera 15-16 breaks following :not selectors. [crbug.com/257695](https://bugs.chromium.org/p/chromium/issues/detail?id=257695)"},{"description":"Safari claims to support certain font-feature-settings it actually does not. [This JS module](https://github.com/kennethormandy/font-feature-fibbing) helps to provide accurate support for this."}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"y"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"See also the [CSS.supports() DOM API](#feat=css-supports-api)","notes_by_num":{},"usage_perc_y":97.56,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"supports,conditional","ie_id":"conditionalrules","chrome_id":"4993981813358592","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1113 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS filter() function","description":"This function filters a CSS input image with a set of filter functions (like blur, grayscale or hue)","spec":"https://www.w3.org/TR/filter-effects/#FilterCSSImageValue","status":"wd","links":[{"url":"http://iamvdo.me/en/blog/advanced-css-filters#filter","title":"Blog post"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1191043","title":"Firefox support bug"},{"url":"https://crbug.com/541698","title":"Chromium support bug"}],"bugs":[{"description":"Firefox feature request: [Mozilla bug #1191043](https://bugzilla.mozilla.org/show_bug.cgi?id=1191043)"}],"categories":["CSS","CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"y x","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":16.41,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"filter, function","ie_id":"cssfilterimagefunction","chrome_id":"5425136400334848","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1114 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS Filter Effects","description":"Method of applying filter effects using the `filter` property to elements, matching filters available in SVG. Filter functions include blur, brightness, contrast, drop-shadow, grayscale, hue-rotate, invert, opacity, sepia and saturate.","spec":"https://www.w3.org/TR/filter-effects-1/","status":"wd","links":[{"url":"http://html5-demos.appspot.com/static/css/filters/index.html","title":"Demo file for WebKit browsers"},{"url":"https://www.html5rocks.com/en/tutorials/filters/understanding-css/","title":"HTML5Rocks article"},{"url":"http://web.archive.org/web/20160219005748/https://dl.dropboxusercontent.com/u/3260327/angular/CSS3ImageManipulation.html","title":"Filter editor"},{"url":"http://web.archive.org/web/20160310041612/http://bennettfeely.com/filters/","title":"Filter Playground"}],"bugs":[{"description":"In Edge filter won't apply if the element or it's parent has negative z-index. [See bug](https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/9318580/)."},{"description":"Currently there are no browsers with support for spread-radius in the drop-shadow filter. [See comment on MDN](https://developer.mozilla.org/en-US/docs/Web/CSS/filter-function/drop-shadow#Parameters)."}],"categories":["CSS","CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n d #2 #4","13":"a #4","14":"a #4","15":"a #4","16":"a #4","17":"a #4","18":"a #4","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a #3","5":"a #3","6":"a #3","7":"a #3","8":"a #3","9":"a #3","10":"a #3","11":"a #3","12":"a #3","13":"a #3","14":"a #3","15":"a #3","16":"a #3","17":"a #3","18":"a #3","19":"a #3","20":"a #3","21":"a #3","22":"a #3","23":"a #3","24":"a #3","25":"a #3","26":"a #3","27":"a #3","28":"a #3","29":"a #3","30":"a #3","31":"a #3","32":"a #3","33":"a #3","34":"a d #1","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"a #3"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y x","7":"y x","8":"y x","9":"y x","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"y x","7.1":"y x","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"n","10":"y x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y x","5.0-5.4":"y x","6.2-6.4":"y x","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Note that this property is significantly different from and incompatible with Microsoft's [older \"filter\" property](http://msdn.microsoft.com/en-us/library/ie/ms530752%28v=vs.85%29.aspx).","notes_by_num":{"1":"Supported in Firefox under the `layout.css.filters.enabled` flag.","2":"Supported in MS Edge under the \"Enable CSS filter property\" flag.","3":"Partial support in Firefox before version 34 [only implemented the url() function of the filter property](https://developer.mozilla.org/en-US/docs/Web/CSS/filter#Browser_compatibility)","4":"Partial support refers to supporting filter functions, but not the `url` function."},"usage_perc_y":96.34,"usage_perc_a":0.6,"ucprefix":false,"parent":"","keywords":"filter:","ie_id":"filters","chrome_id":"5822463824887808","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1115 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS Gradients","description":"Method of defining a linear or radial color gradient as a CSS image.","spec":"https://www.w3.org/TR/css3-images/","status":"cr","links":[{"url":"http://www.colorzilla.com/gradient-editor/","title":"Cross-browser editor"},{"url":"http://css3pie.com/","title":"Tool to emulate support in IE"},{"url":"https://www.webplatform.org/docs/css/functions/linear-gradient","title":"WebPlatform Docs"}],"bugs":[],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a x #2","5":"a x #2","6":"a x #2","7":"a x #2","8":"a x #2","9":"a x #2","10":"a x #2","11":"a x #2","12":"a x #2","13":"a x #2","14":"a x #2","15":"a x #2","16":"a #2","17":"a #2","18":"a #2","19":"a #2","20":"a #2","21":"a #2","22":"a #2","23":"a #2","24":"a #2","25":"a #2","26":"a #2","27":"a #2","28":"a #2","29":"a #2","30":"a #2","31":"a #2","32":"a #2","33":"a #2","34":"a #2","35":"a #2","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"a x #2"},"chrome":{"4":"a x #3","5":"a x #3","6":"a x #3","7":"a x #3","8":"a x #3","9":"a x #3","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a x #2 #3","5":"a x #2 #3","6":"a x #2","7":"a #2","8":"a #2","9":"a #2","10":"a #2","11":"a #2","12":"a #2","13":"a #2","14":"a #2","3.1":"n","3.2":"n","5.1":"a x #2","6.1":"a #2","7.1":"a #2","9.1":"a #2","10.1":"a #2","11.1":"a #2","12.1":"a #2","13.1":"a #2","TP":"a #2"},"opera":{"9":"n","11":"n","12":"y x","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"a x #1","11.5":"a x #1","11.6":"y x","12.1":"y"},"ios_saf":{"8":"a #2","14":"a #2","3.2":"a x #2 #3","4.0-4.1":"a x #2 #3","4.2-4.3":"a x #2 #3","5.0-5.1":"a x #2","6.0-6.1":"a x #2","7.0-7.1":"a #2","8.1-8.4":"a #2","9.0-9.2":"a #2","9.3":"a #2","10.0-10.2":"a #2","10.3":"a #2","11.0-11.2":"a #2","11.3-11.4":"a #2","12.0-12.1":"a #2","12.2-12.4":"a #2","13.0-13.1":"a #2","13.2":"a #2","13.3":"a #2","13.4-13.7":"a #2"},"op_mini":{"all":"n"},"android":{"3":"a x #3","4":"y x","81":"y","2.1":"a x #3","2.2":"a x #3","2.3":"a x #3","4.1":"y x","4.2-4.3":"y x","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"a x #3","10":"y"},"op_mob":{"10":"n","11":"n","12":"y x","59":"y","11.1":"a x #1","11.5":"a x #1","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Syntax used by browsers with prefixed support may be incompatible with that for proper support.\r\n\r\nSupport can be somewhat emulated in older IE versions using the non-standard \"gradient\" filter. \r\n\r\nFirefox 10+, Opera 11.6+, Chrome 26+ and IE10+ also support the new \"to (side)\" syntax.","notes_by_num":{"1":"Partial support in Opera 11.10 and 11.50 also refers to only having support for linear gradients.","2":"Partial support in Safari and Older Firefox versions refers to not using premultiplied colors which results in unexpected behavior when using the transparent keyword as advised by the [spec](https://www.w3.org/TR/2012/CR-css3-images-20120417/#color-stop-syntax).","3":"Implements an earlier prefixed syntax as `-webkit-gradient`"},"usage_perc_y":81.51,"usage_perc_a":16.94,"ucprefix":false,"parent":"","keywords":"linear,linear-gradient,gradiant","ie_id":"gradients","chrome_id":"5785905063264256","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1116 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS Grid Layout (level 1)","description":"Method of using a grid concept to lay out content, providing a mechanism for authors to divide available space for layout into columns and rows using a set of predictable sizing behaviors. Includes support for all `grid-*` properties and the `fr` unit.","spec":"https://www.w3.org/TR/css-grid-1/","status":"cr","links":[{"url":"https://github.com/codler/Grid-Layout-Polyfill","title":"Polyfill based on old spec"},{"url":"https://github.com/FremyCompany/css-grid-polyfill/","title":"Polyfill based on new spec"},{"url":"https://webkit.org/blog/7434/css-grid-layout-a-new-layout-module-for-the-web/","title":"WebKit Blog post"},{"url":"https://gridbyexample.com/","title":"Css Grid By Example: Everything you need to learn CSS Grid Layout"},{"url":"https://mozilladevelopers.github.io/playground/css-grid","title":"Mozilla: Introduction to CSS Grid Layout"}],"bugs":[{"description":"[GridBugs](https://github.com/rachelandrew/gridbugs): aims to be a community curated list of CSS Grid Layout bugs"},{"description":"Safari does not yet support intrinsic and extrinsic sizing with grid properties such as `grid-template-rows`"},{"description":"Edge 18 and below has various problems supporting `calc()` within grid properties ([18676405](https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/18676405/), [18675657](https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/18675657/))"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"p","10":"a x #2","11":"a x #2","5.5":"n"},"edge":{"12":"a x #2","13":"a x #2","14":"a x #2","15":"a x #2","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"p","20":"p","21":"p","22":"p","23":"p","24":"p","25":"p","26":"p","27":"p","28":"p","29":"p","30":"p","31":"p","32":"p","33":"p","34":"p","35":"p","36":"p","37":"p","38":"p","39":"p","40":"p d #3","41":"p d #3","42":"p d #3","43":"p d #3","44":"p d #3","45":"p d #3","46":"p d #3","47":"p d #3","48":"p d #3","49":"p d #3","50":"p d #3","51":"p d #3","52":"y #4","53":"y #4","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"p","26":"p","27":"p","28":"p","29":"p d #1","30":"p d #1","31":"p d #1","32":"p d #1","33":"p d #1","34":"p d #1","35":"p d #1","36":"p d #1","37":"p d #1","38":"p d #1","39":"p d #1","40":"p d #1","41":"p d #1","42":"p d #1","43":"p d #1","44":"p d #1","45":"p d #1","46":"p d #1","47":"p d #1","48":"p d #1","49":"p d #1","50":"p d #1","51":"p d #1","52":"p d #1","53":"p d #1","54":"p d #1","55":"p d #1","56":"p d #1","57":"y #4","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"p","7":"p","8":"p","9":"p","10":"p","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"p","7.1":"p","9.1":"p","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"p d #1","29":"p d #1","30":"p d #1","31":"p d #1","32":"p d #1","33":"p d #1","34":"p d #1","35":"p d #1","36":"p d #1","37":"p d #1","38":"p d #1","39":"p d #1","40":"p d #1","41":"p d #1","42":"p d #1","43":"p d #1","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"p","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"p","7.0-7.1":"p","8.1-8.4":"p","9.0-9.2":"p","9.3":"p","10.0-10.2":"p","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"p","4.4":"p","4.4.3-4.4.4":"p"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a x #2","11":"a x #2"},"and_uc":{"12.12":"y"},"samsung":{"4":"p","5.0-5.4":"n","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y"}},"notes":"See also support for [subgrids](#feat=css-subgrid)","notes_by_num":{"1":"Enabled in Chrome through the \"experimental Web Platform features\" flag in chrome://flags","2":"Partial support in IE refers to supporting an [older version](https://www.w3.org/TR/2011/WD-css3-grid-layout-20110407/) of the specification.","3":"Enabled in Firefox through the `layout.css.grid.enabled ` flag","4":"There are some bugs with overflow ([1356820](https://bugzilla.mozilla.org/show_bug.cgi?id=1356820), [1348857](https://bugzilla.mozilla.org/show_bug.cgi?id=1348857), [1350925](https://bugzilla.mozilla.org/show_bug.cgi?id=1350925))"},"usage_perc_y":94.95,"usage_perc_a":1.17,"ucprefix":false,"parent":"","keywords":"grids,grid-row,grid-column,grid-template,display:grid,inline-grid,fr unit,fractional unit,cssgrid,justify-content:space-between,justify-content:space-around,align-content:space-between,align-content:space-around,space-between","ie_id":"cssgridlayout","chrome_id":"4589636412243968","firefox_id":"css-grid-layout","webkit_id":"specification-css-grid-layout-level-1","shown":true}

/***/ },
/* 1117 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS Hyphenation","description":"Method of controlling when words at the end of lines should be hyphenated using the \"hyphens\" property.","spec":"https://www.w3.org/TR/css3-text/#hyphenation","status":"wd","links":[{"url":"https://developer.mozilla.org/en/CSS/hyphens","title":"MDN Web Docs - CSS hyphens"},{"url":"http://clagnut.com/blog/2394","title":"Blog post"},{"url":"https://www.webplatform.org/docs/css/properties/hyphens","title":"WebPlatform Docs"},{"url":"https://bugs.chromium.org/p/chromium/issues/detail?id=652964","title":"Chromium bug for implementing hyphenation"}],"bugs":[],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y x","11":"y x","5.5":"n"},"edge":{"12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","79":"a #1","80":"a #1","81":"a #1","83":"a #1","84":"a #1","85":"a #1","86":"a #1","87":"a #1"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"a #1","56":"a #1","57":"a #1","58":"a #1","59":"a #1","60":"a #1","61":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #1","66":"a #1","67":"a #1","68":"a #1","69":"a #1","70":"a #1","71":"a #1","72":"a #1","73":"a #1","74":"a #1","75":"a #1","76":"a #1","77":"a #1","78":"a #1","79":"a #1","80":"a #1","81":"a #1","83":"a #1","84":"a #1","85":"a #1","86":"a #1","87":"a #1","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","3.1":"n","3.2":"n","5.1":"y x","6.1":"y x","7.1":"y x","9.1":"y x","10.1":"y x","11.1":"y x","12.1":"y x","13.1":"y x","TP":"y x"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"a #1","43":"a #1","44":"a #1","45":"a #1","46":"a #1","47":"a #1","48":"a #1","49":"a #1","50":"a #1","51":"a #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","60":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #1","66":"a #1","67":"a #1","68":"a #1","69":"a #1","70":"a #1","71":"a #1","72":"a #1","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y x","3.2":"n","4.0-4.1":"n","4.2-4.3":"y x","5.0-5.1":"y x","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y x","10.3":"y x","11.0-11.2":"y x","11.3-11.4":"y x","12.0-12.1":"y x","12.2-12.4":"y x","13.0-13.1":"y x","13.2":"y x","13.3":"y x","13.4-13.7":"y x"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"a"},"samsung":{"4":"n","5.0-5.4":"a #1","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"a #1"},"kaios":{"2.5":"y"}},"notes":"Chrome < 55 and Android 4.0 Browser support \"-webkit-hyphens: none\", but not the \"auto\" property. It is [advisable to set the @lang attribute](http://blog.adrianroselli.com/2015/01/on-use-of-lang-attribute.html) on the HTML element to enable hyphenation support and improve accessibility.","notes_by_num":{"1":"Only supported on Android & Mac platforms (and only the \"auto\" value) for now. [See commit](https://crrev.com/ed7e106e0e48b3afb160a5bdbb37649e307d2b05) & related [bug](https://bugs.chromium.org/p/chromium/issues/detail?id=652964)."},"usage_perc_y":59,"usage_perc_a":37.95,"ucprefix":false,"parent":"","keywords":"hyphen,shy","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1118 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS image-set","description":"Method of letting the browser pick the most appropriate CSS background image from a given set, primarily for high PPI screens.","spec":"https://drafts.csswg.org/css-images-4/#image-set-notation","status":"wd","links":[{"url":"http://cloudfour.com/examples/image-set/","title":"Demo"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6606738-image-set","title":"Microsoft Edge feature request on UserVoice"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1107646","title":"Firefox feature request bug"}],"bugs":[],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y x","80":"y x","81":"y x","83":"y x","84":"y x","85":"y x","86":"y x","87":"y x"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","59":"y x","60":"y x","61":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y x","70":"y x","71":"y x","72":"y x","73":"y x","74":"y x","75":"y x","76":"y x","77":"y x","78":"y x","79":"y x","80":"y x","81":"y x","83":"y x","84":"y x","85":"y x","86":"y x","87":"y x","88":"y x","89":"y x","90":"y x"},"safari":{"4":"n","5":"n","6":"y x","7":"y x","8":"y x","9":"y x","10":"y #1","11":"y #1","12":"y #1","13":"y #1","14":"y #1","3.1":"n","3.2":"n","5.1":"n","6.1":"y x","7.1":"y x","9.1":"y x","10.1":"y #1","11.1":"y #1","12.1":"y #1","13.1":"y #1","TP":"y #1"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","60":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y x","70":"y x","71":"y x","72":"y x","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y #1","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y #1","10.3":"y #1","11.0-11.2":"y #1","11.3-11.4":"y #1","12.0-12.1":"y #1","12.2-12.4":"y #1","13.0-13.1":"y #1","13.2":"y #1","13.3":"y #1","13.4-13.7":"y #1"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y x","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"n","10":"y x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y x","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y x"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y x"},"samsung":{"4":"y x","5.0-5.4":"y x","6.2-6.4":"y x","7.2-7.4":"y x","8.2":"y x","9.2":"y x","10.1":"y x","11.1-11.2":"y x","12.0":"y x"},"and_qq":{"10.4":"y x"},"baidu":{"7.12":"y x"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Safari's implementation does not completely match the spec, in that only URLs are accepted for the image value and only 'x' is accepted as a resolution. See https://bugs.webkit.org/show_bug.cgi?id=160934."},"usage_perc_y":92.33,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"cssimageset","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1119 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS Logical Properties","description":"Logical properties and values provide control of layout through logical, rather than physical, direction and dimension mappings. These properties are `writing-mode` relative equivalents of their corresponding physical properties.","spec":"https://www.w3.org/TR/css-logical-1/","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/-moz-margin-start","title":"MDN Web Docs - CSS -moz-margin-start"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/-moz-padding-start","title":"MDN Web Docs - CSS -moz-padding-start"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/7438435-css-logical-properties","title":"Microsoft Edge feature request on UserVoice"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties/Basic_concepts","title":"MDN - Basic concepts of Logical Properties and Values"}],"bugs":[],"categories":["CSS","CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"a #3 #4 #5","80":"a #3 #4 #5","81":"a #3 #4 #5","83":"a #3 #4 #5","84":"a #3 #4 #5","85":"a #3 #4 #5","86":"a #3 #4 #5","87":"a #3 #4 #5"},"firefox":{"2":"n","3":"a x #1","4":"a x #1","5":"a x #1","6":"a x #1","7":"a x #1","8":"a x #1","9":"a x #1","10":"a x #1","11":"a x #1","12":"a x #1","13":"a x #1","14":"a x #1","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","19":"a x #1","20":"a x #1","21":"a x #1","22":"a x #1","23":"a x #1","24":"a x #1","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a x #1","3.6":"a x #1"},"chrome":{"4":"a x #2","5":"a x #2","6":"a x #2","7":"a x #2","8":"a x #2","9":"a x #2","10":"a x #2","11":"a x #2","12":"a x #2","13":"a x #2","14":"a x #2","15":"a x #2","16":"a x #2","17":"a x #2","18":"a x #2","19":"a x #2","20":"a x #2","21":"a x #2","22":"a x #2","23":"a x #2","24":"a x #2","25":"a x #2","26":"a x #2","27":"a x #2","28":"a x #2","29":"a x #2","30":"a x #2","31":"a x #2","32":"a x #2","33":"a x #2","34":"a x #2","35":"a x #2","36":"a x #2","37":"a x #2","38":"a x #2","39":"a x #2","40":"a x #2","41":"a x #2","42":"a x #2","43":"a x #2","44":"a x #2","45":"a x #2","46":"a x #2","47":"a x #2","48":"a x #2","49":"a x #2","50":"a x #2","51":"a x #2","52":"a x #2","53":"a x #2","54":"a x #2","55":"a x #2","56":"a x #2","57":"a x #2","58":"a x #2","59":"a x #2","60":"a x #2","61":"a x #2","62":"a x #2","63":"a x #2","64":"a x #2","65":"a x #2","66":"a x #2","67":"a x #2","68":"a x #2","69":"a #3 #4 #5","70":"a #3 #4 #5","71":"a #3 #4 #5","72":"a #3 #4 #5","73":"a #3 #4 #5","74":"a #3 #4 #5","75":"a #3 #4 #5","76":"a #3 #4 #5","77":"a #3 #4 #5","78":"a #3 #4 #5","79":"a #3 #4 #5","80":"a #3 #4 #5","81":"a #3 #4 #5","83":"a #3 #4 #5","84":"a #3 #4 #5","85":"a #3 #4 #5","86":"a #3 #4 #5","87":"a #5","88":"a #5","89":"a #5","90":"a #5"},"safari":{"4":"a x #2","5":"a x #2","6":"a x #2","7":"a x #2","8":"a x #2","9":"a x #2","10":"a x #2","11":"a x #2","12":"a x #2","13":"a #3 #4 #5","14":"a #3 #4 #5","3.1":"a x #2","3.2":"a x #2","5.1":"a x #2","6.1":"a x #2","7.1":"a x #2","9.1":"a x #2","10.1":"a x #2","11.1":"a x #2","12.1":"a #3 #4 #5","13.1":"a #3 #4 #5","TP":"a #5"},"opera":{"9":"n","11":"n","12":"n","15":"a x #2","16":"a x #2","17":"a x #2","18":"a x #2","19":"a x #2","20":"a x #2","21":"a x #2","22":"a x #2","23":"a x #2","24":"a x #2","25":"a x #2","26":"a x #2","27":"a x #2","28":"a x #2","29":"a x #2","30":"a x #2","31":"a x #2","32":"a x #2","33":"a x #2","34":"a x #2","35":"a x #2","36":"a x #2","37":"a x #2","38":"a x #2","39":"a x #2","40":"a x #2","41":"a x #2","42":"a x #2","43":"a x #2","44":"a x #2","45":"a x #2","46":"a x #2","47":"a x #2","48":"a x #2","49":"a x #2","50":"a x #2","51":"a x #2","52":"a x #2","53":"a x #2","54":"a x #2","55":"a x #2","56":"a #3 #4 #5","57":"a #3 #4 #5","58":"a #3 #4 #5","60":"a #3 #4 #5","62":"a #3 #4 #5","63":"a #3 #4 #5","64":"a #3 #4 #5","65":"a #3 #4 #5","66":"a #3 #4 #5","67":"a #3 #4 #5","68":"a #3 #4 #5","69":"a #3 #4 #5","70":"a #3 #4 #5","71":"a #3 #4 #5","72":"a #3 #4 #5","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a x #2","14":"a #3 #4 #5","3.2":"a x #2","4.0-4.1":"a x #2","4.2-4.3":"a x #2","5.0-5.1":"a x #2","6.0-6.1":"a x #2","7.0-7.1":"a x #2","8.1-8.4":"a x #2","9.0-9.2":"a x #2","9.3":"a x #2","10.0-10.2":"a x #2","10.3":"a x #2","11.0-11.2":"a x #2","11.3-11.4":"a x #2","12.0-12.1":"a x #2","12.2-12.4":"a #3 #4 #5","13.0-13.1":"a #3 #4 #5","13.2":"a #3 #4 #5","13.3":"a #3 #4 #5","13.4-13.7":"a #3 #4 #5"},"op_mini":{"all":"n"},"android":{"3":"a x #2","4":"a x #2","81":"a #3 #4 #5","2.1":"a x #2","2.2":"a x #2","2.3":"a x #2","4.1":"a x #2","4.2-4.3":"a x #2","4.4":"a x #2","4.4.3-4.4.4":"a x #2"},"bb":{"7":"a x #2","10":"a x #2"},"op_mob":{"10":"n","11":"n","12":"n","59":"a #3 #4 #5","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a #3 #4 #5"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"a x #2"},"samsung":{"4":"a x #2","5.0-5.4":"a x #2","6.2-6.4":"a x #2","7.2-7.4":"a x #2","8.2":"a x #2","9.2":"a x #2","10.1":"a #3 #4 #5","11.1-11.2":"a #3 #4 #5","12.0":"a #3 #4 #5"},"and_qq":{"10.4":"a #3 #4 #5"},"baidu":{"7.12":"a #3 #4 #5"},"kaios":{"2.5":"a #3 #4 #5"}},"notes":"","notes_by_num":{"1":"Only supports the *-start, and *-end values for `margin`, `border` and `padding`, not the inline/block type values as defined in the spec.","2":"Like #1 but also supports `*-before` and `*-end` for `*-block-start` and `*-block-end` properties as well as `start` and `end` values for `text-align`","3":"Does not support the `margin-block`, `margin-inline`, `padding-inline`, or any of the `inset` shorthand properties. Supported in newer Chromium browsers behind the `#enable-experimental-web-platform-features` flag","4":"Does not support the `padding-block`, `padding-inline`, or any `inset` property. Supported in newer Chromium browsers behind the `#enable-experimental-web-platform-features` flag","5":"Does not support the `border-start-start-radius`, `border-start-end-radius`, `border-end-start-radius` and `border-end-end-radius` property."},"usage_perc_y":3.92,"usage_perc_a":92.99,"ucprefix":false,"parent":"","keywords":"block-size,border-block,border-block-color,border-block-end,border-block-end-color,border-block-end-style,border-block-end-width,border-block-start,border-block-start-color,border-block-start-style,border-block-start-width,border-block-style,border-block-width,border-end-end-radius,border-end-start-radius,border-inline,border-inline-color,border-inline-end,border-inline-end-color,border-inline-end-style,border-inline-end-width,border-inline-start,border-inline-start-color,border-inline-start-style,border-inline-start-width,border-inline-style,border-inline-width,border-start-end-radius,border-start-start-radius,inline-size,inset,inset-block,inset-block-end,inset-block-start,inset-inline,inset-inline-end,inset-inline-start,margin-block,margin-block-end,margin-block-start,margin-inline,margin-inline-end,margin-inline-start,max-block-size,max-inline-size,min-block-size,min-inline-size,padding-block,padding-block-end,padding-block-start,padding-inline,padding-inline-end,padding-inline-start,recto,verso","ie_id":"csslogicalpropertieslevel1","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1120 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS Masks","description":"Method of displaying part of an element, using a selected image as a mask","spec":"https://www.w3.org/TR/css-masking-1/","status":"cr","links":[{"url":"https://www.webplatform.org/docs/css/properties/mask","title":"WebPlatform Docs"},{"url":"https://www.html5rocks.com/en/tutorials/masking/adobe/","title":"HTML5 Rocks article"},{"url":"http://thenittygritty.co/css-masking","title":"Detailed blog post"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1224422","title":"Firefox implementation bug"},{"url":"http://lab.iamvdo.me/css-svg-masks","title":"Visual test cases"},{"url":"https://web.archive.org/web/20160505054016/http://thenittygritty.co/css-masking","title":"Detailed blog post (via The Internet Archive)"}],"bugs":[],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n d #4 #5","18":"a #6 #7","79":"a x #1","80":"a x #1","81":"a x #1","83":"a x #1","84":"a x #1","85":"a x #1","86":"a x #1","87":"a x #1"},"firefox":{"2":"n","3":"n","4":"a #2","5":"a #2","6":"a #2","7":"a #2","8":"a #2","9":"a #2","10":"a #2","11":"a #2","12":"a #2","13":"a #2","14":"a #2","15":"a #2","16":"a #2","17":"a #2","18":"a #2","19":"a #2","20":"a #2","21":"a #2","22":"a #2","23":"a #2","24":"a #2","25":"a #2","26":"a #2","27":"a #2","28":"a #2","29":"a #2","30":"a #2","31":"a #2","32":"a #2","33":"a #2","34":"a #2","35":"a #2","36":"a #2","37":"a #2","38":"a #2","39":"a #2","40":"a #2","41":"a #2","42":"a #2","43":"a #2","44":"a #2","45":"a #2","46":"a #2","47":"a #2","48":"a #2","49":"a #2","50":"a #2","51":"a #2","52":"a #2","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a #2","3.6":"a #2"},"chrome":{"4":"a x #1","5":"a x #1","6":"a x #1","7":"a x #1","8":"a x #1","9":"a x #1","10":"a x #1","11":"a x #1","12":"a x #1","13":"a x #1","14":"a x #1","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","19":"a x #1","20":"a x #1","21":"a x #1","22":"a x #1","23":"a x #1","24":"a x #1","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"a x #1","52":"a x #1","53":"a x #1","54":"a x #1","55":"a x #1","56":"a x #1","57":"a x #1","58":"a x #1","59":"a x #1","60":"a x #1","61":"a x #1","62":"a x #1","63":"a x #1","64":"a x #1","65":"a x #1","66":"a x #1","67":"a x #1","68":"a x #1","69":"a x #1","70":"a x #1","71":"a x #1","72":"a x #1","73":"a x #1","74":"a x #1","75":"a x #1","76":"a x #1","77":"a x #1","78":"a x #1","79":"a x #1","80":"a x #1","81":"a x #1","83":"a x #1","84":"a x #1","85":"a x #1","86":"a x #1","87":"a x #1","88":"a x #1","89":"a x #1","90":"a x #1"},"safari":{"4":"a x #1","5":"a x #1","6":"a x #1","7":"a x #1","8":"a x #1","9":"a x #1","10":"a x #1","11":"a x #1","12":"a x #1","13":"a x #1","14":"a x #1","3.1":"n","3.2":"n","5.1":"a x #1","6.1":"a x #1","7.1":"a x #1","9.1":"a x #1","10.1":"a x #1","11.1":"a x #1","12.1":"a x #1","13.1":"a x #1","TP":"a x #1"},"opera":{"9":"n","11":"n","12":"n","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","19":"a x #1","20":"a x #1","21":"a x #1","22":"a x #1","23":"a x #1","24":"a x #1","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"a x #1","52":"a x #1","53":"a x #1","54":"a x #1","55":"a x #1","56":"a x #1","57":"a x #1","58":"a x #1","60":"a x #1","62":"a x #1","63":"a x #1","64":"a x #1","65":"a x #1","66":"a x #1","67":"a x #1","68":"a x #1","69":"a x #1","70":"a x #1","71":"a x #1","72":"a x #1","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a x #1","14":"a x #1","3.2":"a x #1","4.0-4.1":"a x #1","4.2-4.3":"a x #1","5.0-5.1":"a x #1","6.0-6.1":"a x #1","7.0-7.1":"a x #1","8.1-8.4":"a x #1","9.0-9.2":"a x #1","9.3":"a x #1","10.0-10.2":"a x #1","10.3":"a x #1","11.0-11.2":"a x #1","11.3-11.4":"a x #1","12.0-12.1":"a x #1","12.2-12.4":"a x #1","13.0-13.1":"a x #1","13.2":"a x #1","13.3":"a x #1","13.4-13.7":"a x #1"},"op_mini":{"all":"n"},"android":{"3":"a x #1 #3","4":"a x #1 #3","81":"a x #1","2.1":"a x #1 #3","2.2":"a x #1 #3","2.3":"a x #1 #3","4.1":"a x #1 #3","4.2-4.3":"a x #1 #3","4.4":"a x #1","4.4.3-4.4.4":"a x #1"},"bb":{"7":"a x #1","10":"a x #1"},"op_mob":{"10":"n","11":"n","12":"n","59":"a x #1","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a x #1"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"a x #1"},"samsung":{"4":"a x #1","5.0-5.4":"a x #1","6.2-6.4":"a x #1","7.2-7.4":"a x #1","8.2":"a x #1","9.2":"a x #1","10.1":"a x #1","11.1-11.2":"a x #1","12.0":"a x #1"},"and_qq":{"10.4":"a x #1"},"baidu":{"7.12":"a x #1"},"kaios":{"2.5":"a #2"}},"notes":"","notes_by_num":{"1":"Partial support in WebKit/Blink browsers refers to supporting the mask-image and mask-box-image properties, but lacking support for other parts of the spec.","2":"Partial support in Firefox refers to only support for inline SVG mask elements i.e. mask: url(#foo).","3":"Partial support refers to supporting the mask-box-image shorthand but not the longhand properties","4":"Can be enabled in MS edge behind the \"Enable CSS Masking\" flag.","5":"Partial support refers to supporting mask-image and mask-size","6":"Partial support refers to supporting mask-image, mask-size, mask-position, mask-repeat and mask-composite","7":"Edge also recognizes and supports all the `-webkit-` prefixed equivalents of the unprefixed properties for site compatibility"},"usage_perc_y":3.72,"usage_perc_a":93.48,"ucprefix":false,"parent":"","keywords":"clip,clip-path,clip-rule,mask,mask-border,mask-clip,mask-image,mask-mode,mask-type,css masking","ie_id":"masks","chrome_id":"5381559662149632","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1121 */
/***/ function(module, exports) {

	module.exports = {"title":"Media Queries: resolution feature","description":"Allows a media query to be set based on the device pixels used per CSS unit. While the standard uses `min`/`max-resolution` for this, some browsers support the older non-standard `device-pixel-ratio` media query.","spec":"https://www.w3.org/TR/css3-mediaqueries/#resolution","status":"rec","links":[{"url":"https://www.w3.org/blog/CSS/2012/06/14/unprefix-webkit-device-pixel-ratio/","title":"How to unprefix -webkit-device-pixel-ratio"},{"url":"https://bugs.webkit.org/show_bug.cgi?id=78087","title":"WebKit Bug 78087: Implement the 'resolution' media query"},{"url":"https://compat.spec.whatwg.org/#css-media-queries-webkit-device-pixel-ratio","title":"WHATWG Compatibility Standard: -webkit-device-pixel-ratio"}],"bugs":[{"description":"Microsoft Edge has a bug where `min-resolution` less than `1dpcm` [is ignored](https://jsfiddle.net/behmjd5t/)."}],"categories":["CSS","CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"a #1","10":"a #1","11":"a #1","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a #2","5":"a #2","6":"a #2","7":"a #2","8":"a #2","9":"a #2","10":"a #2","11":"a #2","12":"a #2","13":"a #2","14":"a #2","15":"a #2","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a #2","3.6":"a #2"},"chrome":{"4":"a x #3","5":"a x #3","6":"a x #3","7":"a x #3","8":"a x #3","9":"a x #3","10":"a x #3","11":"a x #3","12":"a x #3","13":"a x #3","14":"a x #3","15":"a x #3","16":"a x #3","17":"a x #3","18":"a x #3","19":"a x #3","20":"a x #3","21":"a x #3","22":"a x #3","23":"a x #3","24":"a x #3","25":"a x #3","26":"a x #3","27":"a x #3","28":"a x #3","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a x #3","5":"a x #3","6":"a x #3","7":"a x #3","8":"a x #3","9":"a x #3","10":"a x #3","11":"a x #3","12":"a x #3","13":"a x #3","14":"a x #3","3.1":"n","3.2":"n","5.1":"a x #3","6.1":"a x #3","7.1":"a x #3","9.1":"a x #3","10.1":"a x #3","11.1":"a x #3","12.1":"a x #3","13.1":"a x #3","TP":"a x #3"},"opera":{"9":"n","11":"a x #3","12":"a x #3","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"a x #3","10.0-10.1":"a x #3","10.5":"a x #3","10.6":"a x #3","11.1":"a x #3","11.5":"a x #3","11.6":"a x #3","12.1":"y"},"ios_saf":{"8":"a x #3","14":"a x #3","3.2":"u","4.0-4.1":"a x #3","4.2-4.3":"a x #3","5.0-5.1":"a x #3","6.0-6.1":"a x #3","7.0-7.1":"a x #3","8.1-8.4":"a x #3","9.0-9.2":"a x #3","9.3":"a x #3","10.0-10.2":"a x #3","10.3":"a x #3","11.0-11.2":"a x #3","11.3-11.4":"a x #3","12.0-12.1":"a x #3","12.2-12.4":"a x #3","13.0-13.1":"a x #3","13.2":"a x #3","13.3":"a x #3","13.4-13.7":"a x #3"},"op_mini":{"all":"a #1"},"android":{"3":"a x #3","4":"a x #3","81":"y","2.1":"u","2.2":"u","2.3":"a x #3","4.1":"a x #3","4.2-4.3":"a x #3","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"a x #3","10":"a x #3"},"op_mob":{"10":"a x #3","11":"a x #3","12":"a x #3","59":"y","11.1":"a x #3","11.5":"a x #3","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #1","11":"a #1"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Supports the `dpi` unit, but does not support `dppx` or `dpcm` units.","2":"Firefox before 16 supports only `dpi` unit, but you can set `2dppx` per `min--moz-device-pixel-ratio: 2`","3":"Supports the non-standard `min`/`max-device-pixel-ratio`"},"usage_perc_y":80.32,"usage_perc_a":19.25,"ucprefix":false,"parent":"css-mediaqueries","keywords":"@media,device-pixel-ratio,resolution,dppx,dpcm,dpi","ie_id":"mediaqueriesresolutionfeature,dppxunitfortheresolutionmediaquery","chrome_id":"5944509615570944","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1122 */
/***/ function(module, exports) {

	module.exports = {"title":"::placeholder CSS pseudo-element","description":"The ::placeholder pseudo-element represents placeholder text in an input field: text that represents the input and provides a hint to the user on how to fill out the form. For example, a date-input field might have the placeholder text `YYYY-MM-DD` to clarify that numeric dates are to be entered in year-month-day order.","spec":"https://drafts.csswg.org/css-pseudo-4/#placeholder-pseudo","status":"wd","links":[{"url":"https://css-tricks.com/snippets/css/style-placeholder-text/","title":"CSS-Tricks article with all prefixes"},{"url":"http://wiki.csswg.org/ideas/placeholder-styling","title":"CSSWG discussion"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/::-moz-placeholder","title":"MDN Web Docs - CSS ::-moz-placeholder"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1069012","title":"Mozilla Bug 1069012 - unprefix :placeholder-shown pseudo-class and ::placeholder pseudo-element"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/::placeholder","title":"MDN web docs - ::placeholder"}],"bugs":[],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"a x","13":"a x","14":"a x","15":"a x","16":"a x","17":"a x","18":"a x","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"a x","5":"a x","6":"a x","7":"a x","8":"a x","9":"a x","10":"a x","11":"a x","12":"a x","13":"a x","14":"a x","15":"a x","16":"a x","17":"a x","18":"a x","19":"a x","20":"a x","21":"a x","22":"a x","23":"a x","24":"a x","25":"a x","26":"a x","27":"a x","28":"a x","29":"a x","30":"a x","31":"a x","32":"a x","33":"a x","34":"a x","35":"a x","36":"a x","37":"a x","38":"a x","39":"a x","40":"a x","41":"a x","42":"a x","43":"a x","44":"a x","45":"a x","46":"a x","47":"a x","48":"a x","49":"a x","50":"a x","51":"a x","52":"a x","53":"a x","54":"a x","55":"a x","56":"a x","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"a x","6":"a x","7":"a x","8":"a x","9":"a x","10":"a x","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"a x","6.1":"a x","7.1":"a x","9.1":"a x","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"a x","16":"a x","17":"a x","18":"a x","19":"a x","20":"a x","21":"a x","22":"a x","23":"a x","24":"a x","25":"a x","26":"a x","27":"a x","28":"a x","29":"a x","30":"a x","31":"a x","32":"a x","33":"a x","34":"a x","35":"a x","36":"a x","37":"a x","38":"a x","39":"a x","40":"a x","41":"a x","42":"a x","43":"a x","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a x","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"a x","5.0-5.1":"a x","6.0-6.1":"a x","7.0-7.1":"a x","8.1-8.4":"a x","9.0-9.2":"a x","9.3":"a x","10.0-10.2":"a x","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"a x","4":"a x","81":"y","2.1":"a x","2.2":"a x","2.3":"a x","4.1":"a x","4.2-4.3":"a x","4.4":"a x","4.4.3-4.4.4":"a x"},"bb":{"7":"a x","10":"a x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a x","11":"a x"},"and_uc":{"12.12":"y"},"samsung":{"4":"a x","5.0-5.4":"a x","6.2-6.4":"a x","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y x"}},"notes":"Partial support refers to using alternate names:\r\n`::-webkit-input-placeholder` for Chrome/Safari/Opera ([Chrome issue #623345](https://bugs.chromium.org/p/chromium/issues/detail?id=623345)) \r\n`::-ms-input-placeholder` for Edge (also supports webkit prefix)","notes_by_num":{"1":"Firefox 18 and below supported the `:-moz-placeholder` pseudo-class rather than the `::-moz-placeholder` pseudo-element."},"usage_perc_y":94.84,"usage_perc_a":2.35,"ucprefix":false,"parent":"","keywords":"::placeholder,placeholder","ie_id":"","chrome_id":"6715780926275584","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1123 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS :read-only and :read-write selectors","description":":read-only and :read-write pseudo-classes to match elements which are considered user-alterable","spec":"https://html.spec.whatwg.org/multipage/semantics-other.html#selector-read-only","status":"ls","links":[{"url":"https://css-tricks.com/almanac/selectors/r/read-write-read/","title":"CSS Tricks article"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/%3Aread-only","title":"MDN :read-only"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/:read-write","title":"MDN Web Docs - CSS :read-write"},{"url":"https://drafts.csswg.org/selectors-4/#rw-pseudos","title":"Selectors Level 4 § The Mutability Pseudo-classes: :read-only and :read-write"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=312971","title":"Firefox feature request bug"}],"bugs":[],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"u","3":"y x","4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","59":"y x","60":"y x","61":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y x","70":"y x","71":"y x","72":"y x","73":"y x","74":"y x","75":"y x","76":"y x","77":"y x","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y x","3.6":"y x"},"chrome":{"4":"u","5":"u","6":"u","7":"u","8":"u","9":"u","10":"u","11":"u","12":"u","13":"u","14":"u","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a #1","5":"a #1","6":"a #1","7":"a #1","8":"a #1","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"u","3.2":"u","5.1":"a #1","6.1":"a #1","7.1":"a #1","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"u","11":"u","12":"a #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"u","10.0-10.1":"u","10.5":"u","10.6":"u","11.1":"u","11.5":"a #1","11.6":"a #1","12.1":"a #1"},"ios_saf":{"8":"a #1","14":"y","3.2":"u","4.0-4.1":"u","4.2-4.3":"a #1","5.0-5.1":"a #1","6.0-6.1":"a #1","7.0-7.1":"a #1","8.1-8.4":"a #1","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"a #1","4":"a #1","81":"y","2.1":"u","2.2":"u","2.3":"a #1","4.1":"a #1","4.2-4.3":"a #1","4.4":"a #1","4.4.3-4.4.4":"a #1"},"bb":{"7":"a #1","10":"y"},"op_mob":{"10":"n","11":"n","12":"a #1","59":"y","11.1":"n","11.5":"a #1","12.1":"a #1"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y x"}},"notes":"","notes_by_num":{"1":"Supports selector only for input and textarea fields, but not for contenteditable"},"usage_perc_y":96.64,"usage_perc_a":0.58,"ucprefix":false,"parent":"","keywords":"css,selector,read-only,read-write","ie_id":"cssmutabilitypseudoclasses","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1124 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS Regions","description":"Method of flowing content into multiple elements.","spec":"https://www.w3.org/TR/css3-regions/","status":"wd","links":[{"url":"http://html.adobe.com/webstandards/cssregions/","title":"Adobe demos and samples"},{"url":"http://msdn.microsoft.com/en-us/ie/hh272902#_CSSConnected","title":"IE10 developer guide info"},{"url":"https://www.webplatform.org/docs/css/atrules/@region","title":"WebPlatform Docs"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=674802","title":"Firefox feature request bug"}],"bugs":[],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"a x #1 #2","11":"a x #1 #2","5.5":"n"},"edge":{"12":"a x #1 #2","13":"a x #1 #2","14":"a x #1 #2","15":"a x #1 #2","16":"a x #1 #2","17":"a x #1 #2","18":"a x #1 #2","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"a x","16":"a x","17":"a x","18":"a x","19":"n d","20":"n d","21":"n d","22":"n d","23":"n d","24":"n d","25":"n d","26":"n d","27":"n d","28":"n d","29":"n d","30":"n d","31":"n d","32":"n d","33":"n d","34":"n d","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"y x","7.1":"y x","9.1":"y x","10.1":"y x","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y x","10.3":"y x","11.0-11.2":"y x","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"a x #1 #2","11":"a x #1 #2"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Support is limited to using an iframe as a content source with the `-ms-flow-into: flow_name;` and `-ms-flow-from: flow_name;` syntax.","2":"Partial support refers to not supporting the `region-fragment` property."},"usage_perc_y":0.94,"usage_perc_a":1.56,"ucprefix":false,"parent":"","keywords":"","ie_id":"regions","chrome_id":"5655612935372800","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1125 */
/***/ function(module, exports) {

	module.exports = {"title":"::selection CSS pseudo-element","description":"The ::selection CSS pseudo-element applies rules to the portion of a document that has been highlighted (e.g., selected with the mouse or another pointing device) by the user.","spec":"https://www.w3.org/TR/css-pseudo-4/#selectordef-selection","status":"wd","links":[{"url":"http://quirksmode.org/css/selectors/selection.html","title":"::selection test"},{"url":"https://www.webplatform.org/docs/css/selectors/pseudo-elements/::selection","title":"WebPlatform Docs"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/::selection","title":"MDN web docs"}],"bugs":[{"description":"In Safari `::selection` styles do not work in combination with CSS multi-column."}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y x","3":"y x","4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","59":"y x","60":"y x","61":"y x","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y x","3.6":"y x"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y"},"op_mob":{"10":"u","11":"u","12":"y","59":"y","11.1":"u","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y x"}},"notes":"","notes_by_num":{},"usage_perc_y":86.31,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"::selection,selection","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1126 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS Shapes Level 1","description":"Allows geometric shapes to be set in CSS to define an area for text to flow around. Includes properties `shape-outside`, `shape-margin` and `shape-image-threshold`","spec":"https://www.w3.org/TR/css-shapes/","status":"cr","links":[{"url":"http://alistapart.com/article/css-shapes-101","title":"A List Apart article"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1040714","title":"Firefox tracking bug"}],"bugs":[],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n d #2","52":"n d #2","53":"n d #2","54":"n d #2","55":"n d #2","56":"n d #2","57":"n d #2","58":"n d #2","59":"n d #2","60":"n d #2","61":"n d #2","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n d #1","35":"n d #1","36":"n d #1","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"y x","9":"y x","10":"y x","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"y x","9.1":"y x","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y x","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"Enabled in Chrome through the \"experimental Web Platform features\" flag in chrome://flags","2":"Partially supported in Firefox by enabling \"layout.css.shape-outside.enabled\" in about:config"},"usage_perc_y":95.71,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"circle,ellipse,polygon,inset,shape-outside,shape-margin,shape-image-threshold","ie_id":"shapes","chrome_id":"5163890719588352","firefox_id":"css-shapes","webkit_id":"feature-css-shapes-level-1","shown":true}

/***/ },
/* 1127 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS Scroll Snap","description":"CSS technique that allows customizable scrolling experiences like pagination of carousels by setting defined snap positions.","spec":"https://www.w3.org/TR/css-scroll-snap-1/","status":"cr","links":[{"url":"http://generatedcontent.org/post/66817675443/setting-native-like-scrolling-offsets-in-css-with","title":"Blog post"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Scroll_Snap_Points","title":"MDN Web Docs - CSS Scroll snap points"},{"url":"https://github.com/ckrack/scrollsnap-polyfill","title":"Polyfill - based on an [older version](https://www.w3.org/TR/2015/WD-css-snappoints-1-20150326/) of the spec"},{"url":"https://www.npmjs.com/package/css-scroll-snap-polyfill","title":"Polyfill - based on the [current version](https://www.w3.org/TR/css-scroll-snap-1/) of the spec"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Scroll_Snap","title":"MDN Web Docs - CSS Scroll Snap"},{"url":"https://github.com/filamentgroup/snapper","title":"A CSS Snap Points based carousel (and lightweight polyfill) "}],"bugs":[],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"a x #1 #5 #6","11":"a x #2 #5 #6","5.5":"n"},"edge":{"12":"a x #2 #5 #6","13":"a x #2 #5 #6","14":"a x #2 #5 #6","15":"a x #2 #5 #6","16":"a x #2 #5 #6","17":"a x #2 #5 #6","18":"a x #2 #5 #6","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"a #5","40":"a #5","41":"a #5","42":"a #5","43":"a #5","44":"a #5","45":"a #5","46":"a #5","47":"a #5","48":"a #5","49":"a #5","50":"a #5","51":"a #5","52":"a #5","53":"a #5","54":"a #5","55":"a #5","56":"a #5","57":"a #5","58":"a #5","59":"a #5","60":"a #5","61":"a #5","62":"a #5","63":"a #5","64":"a #5","65":"a #5","66":"a #5","67":"a #5","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n d #7","67":"n d #7","68":"n d #7","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"a x #4 #5","10":"a x #4 #5","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"a x #4 #5","10.1":"a x #4 #5","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n d #7","55":"n d #7","56":"n d #7","57":"n d #7","58":"n d #7","60":"n d #7","62":"n d #7","63":"n d #7","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"a x #4 #5","9.3":"a x #4 #5","10.0-10.2":"a x #4 #5","10.3":"a x #4 #5","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"a #5"}},"notes":"Works in the iOS WKWebView, but not UIWebView.","notes_by_num":{"1":"Partial support in IE10 refers to support limited to touch screens.","2":"Partial support in IE11 [documented here](https://web.archive.org/web/20160616212557/https://dl.dropboxusercontent.com/u/444684/openwebref/CSS/scroll-snap-points/support.html)","4":"Partial support in Safari refers to not supporting the `none` keyword in `scroll-snap-points-x`, `scroll-snap-points-y` and `scroll-snap-coordinate`, and length keywords (`top`, `right`, etc.) in `scroll-snap-destination` and `scroll-snap-coordinate`.","5":"Supports properties from an [older version](https://www.w3.org/TR/2015/WD-css-snappoints-1-20150326/) of the spec.","6":"Partial support in IE & Edge refers to not supporting `scroll-snap-coordinate` and `scroll-snap-destination`.","7":"Available behind the \"Experimental Web Platform features\" feature flag"},"usage_perc_y":91.98,"usage_perc_a":2.63,"ucprefix":false,"parent":"","keywords":"scroll-margin,scroll-snap-points-x,scroll-snap-points-y,scroll-snap-type,scroll-snap-destination,scroll-snap-coordinate,scroll-snap-margin,scroll-snap-align","ie_id":"cssscrollsnappoints","chrome_id":"5721832506261504","firefox_id":"","webkit_id":"specification-css-scroll-snap-points-module-level-1","shown":true}

/***/ },
/* 1128 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS position:sticky","description":"Keeps elements positioned as \"fixed\" or \"relative\" depending on how it appears in the viewport. As a result the element is \"stuck\" when necessary while scrolling.","spec":"https://drafts.csswg.org/css-position/#sticky-pos","status":"wd","links":[{"url":"https://developers.google.com/web/updates/2012/08/Stick-your-landings-position-sticky-lands-in-WebKit","title":"HTML5Rocks"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/position","title":"MDN Web Docs - CSS position"},{"url":"https://www.webplatform.org/docs/css/properties/position","title":"WebPlatform Docs"},{"url":"https://github.com/dollarshaveclub/stickybits","title":"Polyfill"},{"url":"https://github.com/wilddeer/stickyfill","title":"Another polyfill"},{"url":"https://mastery.games/post/position-sticky/","title":"geddski article: Examples and Gotchas"}],"bugs":[{"description":"Firefox 58 & below, Chrome 63 & below and Safari 7 & below do not appear to support [sticky table headers](https://jsfiddle.net/Mf4YT/2/)."},{"description":"A parent with overflow set to `auto` will prevent `position: sticky` from working in Safari"}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"a #6","17":"a #6","18":"a #6","79":"a #4","80":"a #4","81":"a #4","83":"a #4","84":"a #4","85":"a #4","86":"a #4","87":"a #4"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n d #1","27":"n d #1","28":"n d #1","29":"n d #1","30":"n d #1","31":"n d #1","32":"a #3","33":"a #3","34":"a #3","35":"a #3","36":"a #3","37":"a #3","38":"a #3","39":"a #3","40":"a #3","41":"a #3","42":"a #3","43":"a #3","44":"a #3","45":"a #3","46":"a #3","47":"a #3","48":"a #3","49":"a #3","50":"a #3","51":"a #3","52":"a #3","53":"a #3","54":"a #3","55":"a #3","56":"a #3","57":"a #3","58":"a #3","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n d #2","24":"n d #2","25":"n d #2","26":"n d #2","27":"n d #2","28":"n d #2","29":"n d #2","30":"n d #2","31":"n d #2","32":"n d #2","33":"n d #2","34":"n d #2","35":"n d #2","36":"n d #2","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n d #2","53":"n d #2","54":"n d #2","55":"n d #2","56":"a #4","57":"a #4","58":"a #4","59":"a #4","60":"a #4","61":"a #4","62":"a #4","63":"a #4","64":"a #4","65":"a #4","66":"a #4","67":"a #4","68":"a #4","69":"a #4","70":"a #4","71":"a #4","72":"a #4","73":"a #4","74":"a #4","75":"a #4","76":"a #4","77":"a #4","78":"a #4","79":"a #4","80":"a #4","81":"a #4","83":"a #4","84":"a #4","85":"a #4","86":"a #4","87":"a #4","88":"a #4","89":"a #4","90":"a #4"},"safari":{"4":"n","5":"n","6":"n","7":"a x #5","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"a x #5","7.1":"y x","9.1":"y x","10.1":"y x","11.1":"y x","12.1":"y x","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n d #2","40":"n d #2","41":"n d #2","42":"a #4","43":"a #4","44":"a #4","45":"a #4","46":"a #4","47":"a #4","48":"a #4","49":"a #4","50":"a #4","51":"a #4","52":"a #4","53":"a #4","54":"a #4","55":"a #4","56":"a #4","57":"a #4","58":"a #4","60":"a #4","62":"a #4","63":"a #4","64":"a #4","65":"a #4","66":"a #4","67":"a #4","68":"a #4","69":"a #4","70":"a #4","71":"a #4","72":"a #4","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"a x #5","7.0-7.1":"a x #5","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y x","10.3":"y x","11.0-11.2":"y x","11.3-11.4":"y x","12.0-12.1":"y x","12.2-12.4":"y x","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"a #4","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"a #4","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a #4"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"a #4"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"a #4"},"baidu":{"7.12":"n"},"kaios":{"2.5":"a #3"}},"notes":"Any ancestor between the sticky element and its user-scrollable container with overflow computed as anything but `visible`/`clip` will effectively prevent sticking behavior.","notes_by_num":{"1":"Can be enabled in Firefox by setting the about:config preference layout.css.sticky.enabled to true","2":"Enabled through the \"experimental Web Platform features\" flag","3":"Not supported on any `table` parts - See [Firefox bug](https://bugzilla.mozilla.org/show_bug.cgi?id=975644)","4":"Supported on `th` elements, but not `thead` or `tr` - See [Chrome bug](https://bugs.chromium.org/p/chromium/issues/detail?id=702927)","5":"Do not appear to support sticky table headers","6":"Supported on `th` elements, but not `thead` or `tr` - See [Edge bug](https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/16765952/)"},"usage_perc_y":23.22,"usage_perc_a":72.43,"ucprefix":false,"parent":"","keywords":"","ie_id":"positionsticky","chrome_id":"6190250464378880","firefox_id":"","webkit_id":"feature-position:-sticky","shown":true}

/***/ },
/* 1129 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS3 text-align-last","description":"CSS property to describe how the last line of a block or a line right before a forced line break when `text-align` is `justify`.","spec":"https://www.w3.org/TR/css3-text/#text-align-last-property","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/text-align-last","title":"MDN Web Docs - CSS text-align-last"},{"url":"http://blogs.adobe.com/webplatform/2014/02/25/improving-your-sites-visual-details-css3-text-align-last/","title":"Adobe Web Platform Article"}],"bugs":[],"categories":["CSS3"],"stats":{"ie":{"6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","5.5":"a #1"},"edge":{"12":"a","13":"a","14":"a","15":"a","16":"a","17":"a","18":"a","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n d #2","36":"n d #2","37":"n d #2","38":"n d #2","39":"n d #2","40":"n d #2","41":"n d #2","42":"n d #2","43":"n d #2","44":"n d #2","45":"n d #2","46":"n d #2","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n d #3","23":"n d #3","24":"n d #3","25":"n d #3","26":"n d #3","27":"n d #3","28":"n d #3","29":"n d #3","30":"n d #3","31":"n d #3","32":"n d #3","33":"n d #3","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #1","11":"a #1"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y x"}},"notes":"","notes_by_num":{"1":"In Internet Explorer, the start and end values are not supported.","2":"Enabled through the \"Enable Experimental Web Platform Features\" flag in chrome://flags","3":"Enabled through the \"Enable Experimental Web Platform Features\" flag in opera://flags"},"usage_perc_y":79.15,"usage_perc_a":1.83,"ucprefix":false,"parent":"","keywords":"text align last","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1130 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS Text 4 text-spacing","description":"This property controls spacing between adjacent characters on the same line within the same inline formatting context using a set of character-class-based rules.","spec":"https://drafts.csswg.org/css-text-4/#text-spacing-property","status":"wd","links":[{"url":"https://msdn.microsoft.com/library/ms531164(v=vs.85).aspx","title":"MSDN page"}],"bugs":[],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"y x #1","9":"y x #1","10":"y x #1","11":"y x #1","5.5":"n"},"edge":{"12":"y x #1","13":"y x #1","14":"y x #1","15":"y x #1","16":"y x #1","17":"y x #1","18":"y x #1","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","83":"n","84":"n","85":"n","86":"n","87":"n","88":"n","89":"n","90":"n"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","60":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"n","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"n"},"and_ff":{"82":"n"},"ie_mob":{"10":"u","11":"u"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"IE accepts -ms-text-autospace property"},"usage_perc_y":1.77,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":"","shown":false}

/***/ },
/* 1131 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS3 Transitions","description":"Simple method of animating certain properties of an element, with ability to define property, duration, delay and timing function. ","spec":"https://www.w3.org/TR/css3-transitions/","status":"wd","links":[{"url":"http://www.webdesignerdepot.com/2010/01/css-transitions-101/","title":"Article on usage"},{"url":"http://www.the-art-of-web.com/css/timing-function/","title":"Examples on timing functions"},{"url":"http://www.opera.com/docs/specs/presto2.12/css/transitions/","title":"Animation of property types support in Opera"},{"url":"https://www.webplatform.org/docs/css/properties/transition","title":"WebPlatform Docs"}],"bugs":[{"description":"Not supported on any pseudo-elements besides ::before and ::after for Firefox, Chrome 26+, Opera 16+ and IE10+."},{"description":"Transitionable properties with calc() derived values are not supported below and including IE11 (http://connect.microsoft.com/IE/feedback/details/762719/css3-calc-bug-inside-transition-or-transform)"},{"description":"Internet Explorer does not support transitions of the 'background-size' property."},{"description":"IE11 [does not support](https://connect.microsoft.com/IE/feedbackdetail/view/920928/ie-11-css-transition-property-not-working-for-svg-elements) CSS transitions on the SVG `fill` property."},{"description":"In Chrome (up to 43.0), for transition-delay property, either explicitly specified or written within transition property, the unit cannot be ommitted even if the value is 0."},{"description":"IE10 & IE11 are reported to not support transitioning the `column-count` property."},{"description":"Safari 11 [does not support](https://bugs.webkit.org/show_bug.cgi?id=180435) CSS transitions on the `flex-basis` property."}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a x #1","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a x #1","5":"a x #1","6":"y x","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a x #1","3.2":"a x #1","5.1":"y x","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"a x #1","12":"y x","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"a x #1","10.6":"a x #1","11.1":"a x #1","11.5":"a x #1","11.6":"a x #1","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"a x #1","4.0-4.1":"a x #1","4.2-4.3":"a x #1","5.0-5.1":"a x #1","6.0-6.1":"y x","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y x","4":"y x","81":"y","2.1":"y x","2.2":"y x","2.3":"y x","4.1":"y x","4.2-4.3":"y x","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y x","10":"y"},"op_mob":{"10":"a x #1","11":"a x #1","12":"y x","59":"y","11.1":"a x #1","11.5":"a x #1","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Support listed is for `transition` properties as well as the `transitionend` event.","notes_by_num":{"1":"Does not support the `steps()`, `step-start` & `step-end` timing functions"},"usage_perc_y":98.37,"usage_perc_a":0.11,"ucprefix":false,"parent":"","keywords":"css transition,transitionend,transition-property,transition-duration,transition-timing-function,transition-delay,steps,step-start,step-end,cubic-bezier","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1132 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS writing-mode property","description":"Property to define whether lines of text are laid out horizontally or vertically and the direction in which blocks progress.","spec":"https://drafts.csswg.org/css-writing-modes-3/#block-flow","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/writing-mode","title":"MDN Web Docs - CSS writing-mode"},{"url":"https://www.chromestatus.com/feature/5707470202732544","title":"Chrome Platform Status"}],"bugs":[],"categories":["CSS"],"stats":{"ie":{"6":"a #1","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","5.5":"a #1"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n d #2","37":"n d #2","38":"n d #2","39":"n d #2","40":"n d #2","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"u","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"u","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"y x","6.1":"y x","7.1":"y x","9.1":"y x","10.1":"y x","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y","3.2":"u","4.0-4.1":"u","4.2-4.3":"u","5.0-5.1":"y x","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y x","10.3":"y x","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y x","4":"y x","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y x","4.2-4.3":"y x","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"y x","10":"y x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a x","11":"a x"},"and_uc":{"12.12":"y"},"samsung":{"4":"y x","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Internet Explorer supports different values from an [earlier version of the spec](https://www.w3.org/TR/2003/CR-css3-text-20030514/#Progression), which originated from SVG.","2":"Supported in Firefox under the `layout.css.vertical-text.enabled` flag"},"usage_perc_y":96.98,"usage_perc_a":1.44,"ucprefix":false,"parent":"","keywords":"css,writing,direction,i18n,vertical,ltr,rtl","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1133 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS3 Box-sizing","description":"Method of specifying whether or not an element's borders and padding should be included in size units","spec":"https://www.w3.org/TR/css-sizing/#box-sizing","status":"wd","links":[{"url":"https://developer.mozilla.org/En/CSS/Box-sizing","title":"MDN Web Docs - CSS box-sizing"},{"url":"http://www.456bereastreet.com/archive/201104/controlling_width_with_css3_box-sizing/","title":"Blog post"},{"url":"https://github.com/Schepp/box-sizing-polyfill","title":"Polyfill for IE"},{"url":"https://css-tricks.com/box-sizing/","title":"CSS Tricks"},{"url":"https://www.webplatform.org/docs/css/properties/box-sizing","title":"WebPlatform Docs"}],"bugs":[{"description":"Android browsers do not calculate correctly the dimensions (width and height) of the HTML select element."},{"description":"Safari 6.0.x does not use box-sizing on elements with display: table;"},{"description":"IE9 will subtract the width of the scrollbar to the width of the element when set to position: absolute / fixed , overflow: auto / overflow-y: scroll"},{"description":"IE 8 ignores `box-sizing: border-box` if min/max-width/height is used."},{"description":"Chrome has problems selecting options from the `select` element when using `box-sizing: border-box` and browser zoom level is less than 100%."},{"description":"In IE8, the min-width property applies to `content-box` even if `box-sizing` is set to `border-box`."},{"description":"In Chrome, the `inherit` value doesn't work on elements inside `details`, this could lead to unexpected behaviour when `box-sizing: inherit` is used in an universal selector, see https://bugs.chromium.org/p/chromium/issues/detail?id=589475"}],"categories":["CSS3"],"stats":{"ie":{"6":"p","7":"p","8":"y","9":"y","10":"y","11":"y","5.5":"p"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y x","3":"y x","4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y x","3.6":"y x"},"chrome":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y x","5":"y x","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y x","3.2":"y x","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y","10.0-10.1":"y","10.5":"y","10.6":"y","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y x","4.0-4.1":"y x","4.2-4.3":"y x","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y x","4":"y","81":"y","2.1":"y x","2.2":"y x","2.3":"y x","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y x","10":"y"},"op_mob":{"10":"y","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Firefox versions before 57 also supported the `padding-box` value for `box-sizing`, though this value was been removed from the specification and later versions of the browser.","notes_by_num":{},"usage_perc_y":99.66,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"border-box,content-box","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1134 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS grab & grabbing cursors","description":"Support for the `grab` & `grabbing` values for the `cursor` property. Used to indicate that something can be grabbed (dragged to be moved).","spec":"https://www.w3.org/TR/css3-ui/#cursor","status":"pr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/cursor","title":"MDN Web Docs - CSS cursor"}],"bugs":[],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y x","3":"y x","4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y x","3.6":"y x"},"chrome":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","59":"y x","60":"y x","61":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y","12":"y","13":"y","14":"y","3.1":"y x","3.2":"y x","5.1":"y x","6.1":"y x","7.1":"y x","9.1":"y x","10.1":"y x","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"y","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"y","12.1":"y"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"y x","10":"y x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y x","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"y x"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":79.99,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1135 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS3 Cursors: zoom-in & zoom-out","description":"Support for `zoom-in`, `zoom-out` values for the CSS3 `cursor` property.","spec":"https://www.w3.org/TR/css3-ui/#cursor","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/cursor","title":"MDN Web Docs - CSS cursor"}],"bugs":[],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y x","3":"y x","4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y x","3.6":"y x"},"chrome":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y x","3.2":"y x","5.1":"y x","6.1":"y x","7.1":"y x","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"y","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"y","12.1":"y"},"ios_saf":{"8":"n","14":"n","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"n","12.2-12.4":"n","13.0-13.1":"n","13.2":"n","13.3":"n","13.4-13.7":"n"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"y x","10":"y x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"n"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"n"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"n","8.2":"n","9.2":"n","10.1":"n","11.1-11.2":"n","12.0":"n"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{},"usage_perc_y":79.81,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"cursors, pointers","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1136 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS3 tab-size","description":"Method of customizing the width of the tab character. Only effective using 'white-space: pre' or 'white-space: pre-wrap'.","spec":"https://www.w3.org/TR/css3-text/#tab-size","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/tab-size","title":"MDN Web Docs - CSS tab-size"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6524689-tab-size-property","title":"Microsoft Edge feature request on UserVoice"}],"bugs":[{"description":"Firefox up to and including 52 [did not](https://bugzilla.mozilla.org/show_bug.cgi?id=943918) support `<length>` values"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a x #1","5":"a x #1","6":"a x #1","7":"a x #1","8":"a x #1","9":"a x #1","10":"a x #1","11":"a x #1","12":"a x #1","13":"a x #1","14":"a x #1","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","19":"a x #1","20":"a x #1","21":"a x #1","22":"a x #1","23":"a x #1","24":"a x #1","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"a x #1","52":"a x #1","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","59":"y x","60":"y x","61":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y x","70":"y x","71":"y x","72":"y x","73":"y x","74":"y x","75":"y x","76":"y x","77":"y x","78":"y x","79":"y x","80":"y x","81":"y x","82":"y x","83":"y x","84":"y x","85":"y x","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"a #1","30":"a #1","31":"a #1","32":"a #1","33":"a #1","34":"a #1","35":"a #1","36":"a #1","37":"a #1","38":"a #1","39":"a #1","40":"a #1","41":"a #1","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"a #1","8":"a #1","9":"a #1","10":"a #1","11":"a #1","12":"a #1","13":"a #1","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"a #1","7.1":"a #1","9.1":"a #1","10.1":"a #1","11.1":"a #1","12.1":"a #1","13.1":"y","TP":"y"},"opera":{"9":"n","11":"a x #1","12":"a x #1","15":"a #1","16":"a #1","17":"a #1","18":"a #1","19":"a #1","20":"a #1","21":"a #1","22":"a #1","23":"a #1","24":"a #1","25":"a #1","26":"a #1","27":"a #1","28":"a #1","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"a x #1","11.1":"a x #1","11.5":"a x #1","11.6":"a x #1","12.1":"a x #1"},"ios_saf":{"8":"a #1","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"a #1","8.1-8.4":"a #1","9.0-9.2":"a #1","9.3":"a #1","10.0-10.2":"a #1","10.3":"a #1","11.0-11.2":"a #1","11.3-11.4":"a #1","12.0-12.1":"a #1","12.2-12.4":"a #1","13.0-13.1":"a #1","13.2":"a #1","13.3":"a #1","13.4-13.7":"y"},"op_mini":{"all":"a x #1"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"a #1","4.4.3-4.4.4":"a #1"},"bb":{"7":"a #1","10":"a #1"},"op_mob":{"10":"n","11":"a x #1","12":"a x #1","59":"y","11.1":"a x #1","11.5":"a x #1","12.1":"a x #1"},"and_chr":{"86":"y"},"and_ff":{"82":"y x"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"a x #1"}},"notes":"","notes_by_num":{"1":"Partial refers to supporting `<integer>` but not `<length>` values."},"usage_perc_y":91.2,"usage_perc_a":6.26,"ucprefix":false,"parent":"","keywords":"tab-size,tab-width","ie_id":"csstabsizeproperty","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1137 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS Flexible Box Layout Module","description":"Method of positioning elements in horizontal or vertical stacks. Support includes all properties prefixed with `flex`, as well as `display: flex`, `display: inline-flex`, `align-content`, `align-items`, `align-self`, `justify-content` and `order`.","spec":"https://www.w3.org/TR/css3-flexbox/","status":"cr","links":[{"url":"https://bennettfeely.com/flexplorer/","title":"Flexbox CSS generator"},{"url":"https://www.adobe.com/devnet/html5/articles/working-with-flexbox-the-new-spec.html","title":"Article on using the latest spec"},{"url":"https://dev.opera.com/articles/view/advanced-cross-browser-flexbox/","title":"Tutorial on cross-browser support"},{"url":"https://philipwalton.github.io/solved-by-flexbox/","title":"Examples on how to solve common layout problems with flexbox"},{"url":"https://css-tricks.com/snippets/css/a-guide-to-flexbox/","title":"A Complete Guide to Flexbox"},{"url":"https://the-echoplex.net/flexyboxes/","title":"Flexbox playground and code generator"},{"url":"https://github.com/philipwalton/flexbugs","title":"Flexbugs: Repo for flexbox bugs"},{"url":"https://github.com/10up/flexibility/","title":"10up Open Sources IE 8 and 9 Support for Flexbox"},{"url":"https://github.com/vadimyer/ecligrid","title":"Ecligrid - Mobile first flexbox grid system"},{"url":"https://mastery.games/post/the-difference-between-width-and-flex-basis/","title":"The Difference Between Width and Flex-Basis"}],"bugs":[{"description":"[Flexbugs](https://github.com/philipwalton/flexbugs): community-curated list of flexbox issues and cross-browser workarounds for them"},{"description":"In IE10 the default value for `flex` is `0 0 auto` rather than `0 1 auto` as defined in the latest spec."},{"description":"In Safari 10.1 and below, the height of (non flex) children are not recognized in percentages. However other browsers recognize and scale the children based on percentage heights. Fixed in all versions > 10.1 ([See bug](https://bugs.webkit.org/show_bug.cgi?id=137730)) The bug also appeared in Chrome but was fixed in [Chrome 51](https://bugs.chromium.org/p/chromium/issues/detail?id=341310)"},{"description":"Firefox 51 and below does not support [Flexbox in button elements](https://bugzilla.mozilla.org/show_bug.cgi?id=984869#c2). Fixed in version 52."},{"description":"IE 11 does not vertically align items correctly when `min-height` is used [see bug](https://connect.microsoft.com/IE/feedback/details/816293/ie11-flexbox-with-min-height-not-vertically-aligning-with-align-items-center)"},{"description":"In IE10 and IE11, containers with `display: flex` and `flex-direction: column` will not properly calculate their flexed childrens' sizes if the container has `min-height` but no explicit `height` property. [See bug](https://connect.microsoft.com/IE/feedback/details/802625/min-height-and-flexbox-flex-direction-column-dont-work-together-in-ie-10-11-preview)."},{"description":"IE 11 requires a unit to be added to the third argument, the flex-basis property [see MSFT documentation](https://docs.microsoft.com/en-us/previous-versions/windows/internet-explorer/ie-developer/dev-guides/hh673531%28v%3dvs.85%29#setting-the-flexibility-of-a-child-element)"},{"description":"Safari 10 and below uses min/max width/height declarations for actually rendering the size of flex items, but it ignores those values when calculating how many items should be on a single line of a multi-line flex container. Instead, it simply uses the item's flex-basis value, or its width if the flex basis is set to auto. [see bug](https://bugs.webkit.org/show_bug.cgi?id=136041). Fixed in all versions > 10."},{"description":"The space-evenly value of the justify-content property, as described in the [CSS Box Alignment Module Level 3](https://www.w3.org/TR/css-align-3/#distribution-values) is only supported by some browsers."}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"a x #2 #4","11":"a #4","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"a x #1","3":"a x #1","4":"a x #1","5":"a x #1","6":"a x #1","7":"a x #1","8":"a x #1","9":"a x #1","10":"a x #1","11":"a x #1","12":"a x #1","13":"a x #1","14":"a x #1","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","19":"a x #1","20":"a x #1","21":"a x #1","22":"a #3","23":"a #3","24":"a #3","25":"a #3","26":"a #3","27":"a #3","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"a x #1","3.6":"a x #1"},"chrome":{"4":"a x #1","5":"a x #1","6":"a x #1","7":"a x #1","8":"a x #1","9":"a x #1","10":"a x #1","11":"a x #1","12":"a x #1","13":"a x #1","14":"a x #1","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","19":"a x #1","20":"a x #1","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a x #1","5":"a x #1","6":"a x #1","7":"y x","8":"y x","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a x #1","3.2":"a x #1","5.1":"a x #1","6.1":"y x","7.1":"y x","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"y"},"ios_saf":{"8":"y x","14":"y","3.2":"a x #1","4.0-4.1":"a x #1","4.2-4.3":"a x #1","5.0-5.1":"a x #1","6.0-6.1":"a x #1","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"a x #1","4":"a x #1","81":"y","2.1":"a x #1","2.2":"a x #1","2.3":"a x #1","4.1":"a x #1","4.2-4.3":"a x #1","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"a x #1","10":"y"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a x #2","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Most partial support refers to supporting an [older version](https://www.w3.org/TR/2009/WD-css3-flexbox-20090723/) of the specification or an [older syntax](https://www.w3.org/TR/2012/WD-css3-flexbox-20120322/).","notes_by_num":{"1":"Only supports the [old flexbox](https://www.w3.org/TR/2009/WD-css3-flexbox-20090723) specification and does not support wrapping.","2":"Only supports the [2012 syntax](https://www.w3.org/TR/2012/WD-css3-flexbox-20120322/)","3":"Does not support flex-wrap, flex-flow or align-content properties","4":"Partial support is due to large amount of bugs present (see known issues)"},"usage_perc_y":97.65,"usage_perc_a":1.68,"ucprefix":false,"parent":"","keywords":"flex-box,flex-direction,flex-wrap,flex-flow,flex-grow,flex-shrink,flex-basis,display:flex,justify-content:space-between,justify-content:space-around,align-content:space-between,align-content:space-around,space-between","ie_id":"flexbox","chrome_id":"4837301406400512","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1138 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS font-feature-settings","description":"Method of applying advanced typographic and language-specific font features to supported OpenType fonts.","spec":"https://w3.org/TR/css3-fonts/#font-rend-props","status":"cr","links":[{"url":"http://ie.microsoft.com/testdrive/Graphics/opentype/","title":"Demo pages (IE/Firefox only)"},{"url":"https://hacks.mozilla.org/2010/11/firefox-4-font-feature-support/","title":"Mozilla hacks article"},{"url":"http://html5accessibility.com/","title":"Detailed tables on accessability support"},{"url":"https://www.webplatform.org/docs/css/properties/font-feature-settings","title":"WebPlatform Docs"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/font-feature-settings","title":"MDN Web Docs - font-feature-settings"},{"url":"https://www.microsoft.com/typography/otspec/featuretags.htm","title":"OpenType layout feature tag registry"},{"url":"http://help.typekit.com/customer/portal/articles/1789736-syntax-for-opentype-features-in-css#salt","title":"Syntax for OpenType features in CSS (Adobe Typekit Help)"}],"bugs":[{"description":"IE10 and 11 do not always appear to support the `ss01` value correctly."},{"description":"IE10 and 11 on Windows 7 [can hide the text](https://stackoverflow.com/questions/22151835/msie-10-web-font-and-font-feature-settings-causes-invisible-text) under certain circumstances."}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"a x #1","5":"a x #1","6":"a x #1","7":"a x #1","8":"a x #1","9":"a x #1","10":"a x #1","11":"a x #1","12":"a x #1","13":"a x #1","14":"a x #1","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"a x #2","17":"a x #2","18":"a x #2","19":"a x #2","20":"a x #2","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"a","5":"a","6":"a","7":"n","8":"n","9":"n","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"a","6.1":"n","7.1":"n","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"n","14":"y","3.2":"a","4.0-4.1":"a","4.2-4.3":"a","5.0-5.1":"a","6.0-6.1":"a","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"n","10":"y x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y x","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Whenever possible, font-variant shorthand property or an associated longhand property, font-variant-ligatures, font-variant-caps, font-variant-east-asian, font-variant-alternates, font-variant-numeric or font-variant-position should be used. This property is a low-level feature designed to handle special cases where no other way to enable or access an OpenType font feature exists. In particular, this CSS property shouldn't be used to enable small caps.","notes_by_num":{"1":"From Gecko 2.0 (Firefox 4.0) to Gecko 14.0 (Firefox 14.0) included, Gecko supported an older syntax, slightly different from the modern one: https://hacks.mozilla.org/2010/11/firefox-4-font-feature-support/","2":"Partial support in older Chrome versions refers to lacking support in Mac OS X."},"usage_perc_y":97.84,"usage_perc_a":0.29,"ucprefix":false,"parent":"","keywords":"font-feature,font-feature-settings,kern,kerning,font-variant-alternates,ligatures,font-variant-ligatures","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1139 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS3 font-kerning","description":"Controls the usage of the kerning information (spacing between letters) stored in the font. Note that this only affects OpenType fonts with kerning information, it has no effect on other fonts.","spec":"https://www.w3.org/TR/css3-fonts/#font-kerning-prop","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/font-kerning","title":"MDN Web Docs - CSS font-kerning"}],"bugs":[],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n d #1","25":"n d #1","26":"n d #1","27":"n d #1","28":"n d #1","29":"n d #1","30":"n d #1","31":"n d #1","32":"n d #1","33":"n d #1","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"y x","30":"y x","31":"y x","32":"y x","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"y x","8":"y x","9":"y x","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"y x","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"y x","17":"y x","18":"y x","19":"y x","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y x","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y x","10.3":"y x","11.0-11.2":"y x","11.3-11.4":"y x","12.0-12.1":"y x","12.2-12.4":"y x","13.0-13.1":"y x","13.2":"y x","13.3":"y x","13.4-13.7":"y x"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y x","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"y x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"Browsers with support for [font feature settings](https://caniuse.com/#feat=font-feature) can also set kerning value.","notes_by_num":{"1":"Disabled by default, can be enabled using preference layout.css.font-features.enabled - defaulting to true on Nightly and Aurora only."},"usage_perc_y":96.24,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1140 */
/***/ function(module, exports) {

	module.exports = {"title":"Full Screen API","description":"API for allowing content (like a video or canvas element) to take up the entire screen.","spec":"https://fullscreen.spec.whatwg.org/","status":"ls","links":[{"url":"https://developer.mozilla.org/en/DOM/Using_full-screen_mode","title":"MDN Web Docs - Using Full Screen"},{"url":"http://jlongster.com/2011/11/21/canvas.html","title":"Blog post"},{"url":"https://hacks.mozilla.org/2012/01/using-the-fullscreen-api-in-web-browsers/","title":"Mozilla hacks article"},{"url":"https://www.webplatform.org/docs/dom/Element/requestFullscreen","title":"WebPlatform Docs"}],"bugs":[{"description":"IE 11 doesn't allow going to fullscreen mode when the event that triggers `msRequestFullscreen()` is a `keydown` or `pointerdown` event (`keypress` and `click` do work)"},{"description":"Safari blocks access to keyboard events in fullscreen mode (as a security measure)."},{"description":"Safari doesn't support stacking, meaning only one element can be set to full screen. `webkitRequestFullScreen()` is ignored for other elements and no error event is dispatched."},{"description":"IE 11 does not allow scrolling when document.documentElement is set to full screen."},{"description":"IE 11 does not properly support fullscreen when opening from an iframe."},{"description":"Opera 12.1 uses the older specificaton's `:fullscreen-ancestor` pseudo-class instead of the  the `::backdrop` pseudo-element."}],"categories":["JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"a x #3","5.5":"n"},"edge":{"12":"a #3","13":"a #3","14":"a #3","15":"a #3","16":"a #3","17":"a #3","18":"a #3","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"a x #1 #3","11":"a x #1 #3","12":"a x #1 #3","13":"a x #1 #3","14":"a x #1 #3","15":"a x #1 #3","16":"a x #1 #3","17":"a x #1 #3","18":"a x #1 #3","19":"a x #1 #3","20":"a x #1 #3","21":"a x #1 #3","22":"a x #1 #3","23":"a x #1 #3","24":"a x #1 #3","25":"a x #1 #3","26":"a x #1 #3","27":"a x #1 #3","28":"a x #1 #3","29":"a x #1 #3","30":"a x #1 #3","31":"a x #1 #3","32":"a x #1 #3","33":"a x #1 #3","34":"a x #1 #3","35":"a x #1 #3","36":"a x #1 #3","37":"a x #1 #3","38":"a x #1 #3","39":"a x #1 #3","40":"a x #1 #3","41":"a x #1 #3","42":"a x #1 #3","43":"a x #1 #3","44":"a x #1 #3","45":"a x #1 #3","46":"a x #1 #3","47":"a x #1 #3 #4","48":"a x #1 #3 #4","49":"a x #1 #3 #4","50":"a x #1 #3 #4","51":"a x #1 #3 #4","52":"a x #1 #3 #4","53":"a x #1 #3 #4","54":"a x #1 #3 #4","55":"a x #1 #3 #4","56":"a x #1 #3 #4","57":"a x #1 #3 #4","58":"a x #1 #3 #4","59":"a x #1 #3 #4","60":"a x #1 #3 #4","61":"a x #1 #3 #4","62":"a x #1 #3 #4","63":"a x #1 #3 #4","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"a x #1 #3","16":"a x #1 #3","17":"a x #1 #3","18":"a x #1 #3","19":"a x #1 #3","20":"a x #2 #3","21":"a x #2 #3","22":"a x #2 #3","23":"a x #2 #3","24":"a x #2 #3","25":"a x #2 #3","26":"a x #2 #3","27":"a x #2 #3","28":"a x #2 #3","29":"a x #2 #3","30":"a x #2 #3","31":"a x #2 #3","32":"a x #2 #3","33":"a x #2 #3","34":"a x #2 #3","35":"a x #2 #3","36":"a x #2 #3","37":"a x #2 #3","38":"a x #2 #3","39":"a x #2 #3","40":"a x #2 #3","41":"a x #2 #3","42":"a x #2 #3","43":"a x #2 #3","44":"a x #2 #3","45":"a x #2 #3","46":"a x #2 #3","47":"a x #2 #3","48":"a x #2 #3","49":"a x #2 #3","50":"a x #2 #3","51":"a x #2 #3","52":"a x #2 #3","53":"a x #2 #3","54":"a x #2 #3","55":"a x #2 #3","56":"a x #2 #3","57":"a x #2 #3","58":"a x #2 #3","59":"a x #2 #3","60":"a x #2 #3","61":"a x #2 #3","62":"a x #2 #3","63":"a x #2 #3","64":"a x #2 #3","65":"a x #2 #3","66":"a x #2 #3","67":"a x #2 #3","68":"a x #2 #3","69":"a x #2 #3","70":"a x #2 #3","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"a x #2 #3","7":"a x #2 #3","8":"a x #2 #3","9":"a x #2 #3","10":"a x #2 #3","11":"a x #2 #3","12":"a x #2 #3","13":"a x #2 #3","14":"a x #2 #3","3.1":"n","3.2":"n","5.1":"a x #1 #3","6.1":"a x #2 #3","7.1":"a x #2 #3","9.1":"a x #2 #3","10.1":"a x #2 #3","11.1":"a x #2 #3","12.1":"a x #2 #3","13.1":"a x #2 #3","TP":"a x #2 #3"},"opera":{"9":"n","11":"n","12":"n","15":"a x #2 #3","16":"a x #2 #3","17":"a x #2 #3","18":"a x #2 #3","19":"a x #2 #3","20":"a x #2 #3","21":"a x #2 #3","22":"a x #2 #3","23":"a x #2 #3","24":"a x #2 #3","25":"a x #2 #3","26":"a x #2 #3","27":"a x #2 #3","28":"a x #2 #3","29":"a x #2 #3","30":"a x #2 #3","31":"a x #2 #3","32":"a x #2 #3","33":"a x #2 #3","34":"a x #2 #3","35":"a x #2 #3","36":"a x #2 #3","37":"a x #2 #3","38":"a x #2 #3","39":"a x #2 #3","40":"a x #2 #3","41":"a x #2 #3","42":"a x #2 #3","43":"a x #2 #3","44":"a x #2 #3","45":"a x #2 #3","46":"a x #2 #3","47":"a x #2 #3","48":"a x #2 #3","49":"a x #2 #3","50":"a x #2 #3","51":"a x #2 #3","52":"a x #2 #3","53":"a x #2 #3","54":"a x #2 #3","55":"a x #2 #3","56":"a x #2 #3","57":"a x #2 #3","58":"a x #2 #3","60":"a x #2 #3","62":"a x #2 #3","63":"a x #2 #3","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"y"},"ios_saf":{"8":"n","14":"a #5","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"n","9.0-9.2":"n","9.3":"n","10.0-10.2":"n","10.3":"n","11.0-11.2":"n","11.3-11.4":"n","12.0-12.1":"a #5","12.2-12.4":"a #5","13.0-13.1":"a #5","13.2":"a #5","13.3":"a #5","13.4-13.7":"a #5"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"n","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"a x #2"},"op_mob":{"10":"n","11":"n","12":"n","59":"a x #2 #3","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a x #2 #3"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"a x #3"},"and_uc":{"12.12":"a x #2 #3"},"samsung":{"4":"a x #2 #3","5.0-5.4":"a x #2 #3","6.2-6.4":"a x #2 #3","7.2-7.4":"a x #2 #3","8.2":"a x #2 #3","9.2":"a x #2 #3","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"a x #2 #3"},"baidu":{"7.12":"a x #2 #3"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support refers to supporting an earlier draft of the spec.","2":"Partial support refers to not supporting `::backdrop`, and supporting the old `:full-screen` syntax rather than the standard `:fullscreen`.","3":"Partial support refers to not returning a Promise, as specified in the latest version of the spec.","4":"Unprefixed support is available behind the `full-screen-api.unprefix.enabled` flag","5":"Partial support refers to supporting only iPad, not iPhone. Shows an overlay button which can not be disabled."},"usage_perc_y":42.67,"usage_perc_a":54.42,"ucprefix":false,"parent":"","keywords":"full-screen,requestFullScreen,exitFullScreen","ie_id":"fullscreenapi","chrome_id":"5259513871466496","firefox_id":"fullscreen","webkit_id":"","shown":true}

/***/ },
/* 1141 */
/***/ function(module, exports) {

	module.exports = {"title":"Intrinsic & Extrinsic Sizing","description":"Allows for the heights and widths to be specified in intrinsic values using the `max-content`, `min-content`, `fit-content` and `stretch` (formerly `fill`) properties.","spec":"https://www.w3.org/TR/css3-sizing/","status":"wd","links":[{"url":"http://thenewcode.com/662/Design-From-the-Inside-Out-With-CSS-Min-Content","title":"Min-Content tutorial"}],"bugs":[{"description":"Safari does not yet support usage with CSS Grid Layout properties such as `grid-template-rows`."}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"y #3 #4","80":"y #3 #4","81":"y #3 #4","83":"y #3 #4","84":"y #3 #4","85":"y #3 #4","86":"y #3 #4","87":"y #3 #4"},"firefox":{"2":"n","3":"a x #1 #2 #3","4":"a x #1 #2 #3","5":"a x #1 #2 #3","6":"a x #1 #2 #3","7":"a x #1 #2 #3","8":"a x #1 #2 #3","9":"a x #1 #2 #3","10":"a x #1 #2 #3","11":"a x #1 #2 #3","12":"a x #1 #2 #3","13":"a x #1 #2 #3","14":"a x #1 #2 #3","15":"a x #1 #2 #3","16":"a x #1 #2 #3","17":"a x #1 #2 #3","18":"a x #1 #2 #3","19":"a x #1 #2 #3","20":"a x #1 #2 #3","21":"a x #1 #2 #3","22":"a x #1 #2 #3","23":"a x #1 #2 #3","24":"a x #1 #2 #3","25":"a x #1 #2 #3","26":"a x #1 #2 #3","27":"a x #1 #2 #3","28":"a x #1 #2 #3","29":"a x #1 #2 #3","30":"a x #1 #2 #3","31":"a x #1 #2 #3","32":"a x #1 #2 #3","33":"a x #1 #2 #3","34":"a x #1 #2 #3","35":"a x #1 #2 #3","36":"a x #1 #2 #3","37":"a x #1 #2 #3","38":"a x #1 #2 #3","39":"a x #1 #2 #3","40":"a x #1 #2 #3","41":"a x #1 #2 #3","42":"a x #1 #2 #3","43":"a x #1 #2 #3","44":"a x #1 #2 #3","45":"a x #1 #2 #3","46":"a x #1 #2 #3","47":"a x #1 #2 #3","48":"a x #1 #2 #3","49":"a x #1 #2 #3","50":"a x #1 #2 #3","51":"a x #1 #2 #3","52":"a x #1 #2 #3","53":"a x #1 #2 #3","54":"a x #1 #2 #3","55":"a x #1 #2 #3","56":"a x #1 #2 #3","57":"a x #1 #2 #3","58":"a x #1 #2 #3","59":"a x #1 #2 #3","60":"a x #1 #2 #3","61":"a x #1 #2 #3","62":"a x #1 #2 #3","63":"a x #1 #2 #3","64":"a x #1 #2 #3","65":"a x #1 #2 #3","66":"a #2 #5","67":"a #2 #5","68":"a #2 #5","69":"a #2 #5","70":"a #2 #5","71":"a #2 #5","72":"a #2 #5","73":"a #2 #5","74":"a #2 #5","75":"a #2 #5","76":"a #2 #5","77":"a #2 #5","78":"a #2 #5","79":"a #2 #5","80":"a #2 #5","81":"a #2 #5","82":"a #2 #5","83":"a #2 #5","84":"a #2 #5","85":"a #2 #5","3.5":"a x #1 #2 #3","3.6":"a x #1 #2 #3"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"y x #3","23":"y x #3","24":"y x #3","25":"y x #3","26":"y x #3","27":"y x #3","28":"y x #3","29":"y x #3","30":"y x #3","31":"y x #3","32":"y x #3","33":"y x #3","34":"y x #3","35":"y x #3","36":"y x #3","37":"y x #3","38":"y x #3","39":"y x #3","40":"y x #3","41":"y x #3","42":"y x #3","43":"y x #3","44":"y x #3","45":"y x #3","46":"y #3 #4","47":"y #3 #4","48":"y #3 #4","49":"y #3 #4","50":"y #3 #4","51":"y #3 #4","52":"y #3 #4","53":"y #3 #4","54":"y #3 #4","55":"y #3 #4","56":"y #3 #4","57":"y #3 #4","58":"y #3 #4","59":"y #3 #4","60":"y #3 #4","61":"y #3 #4","62":"y #3 #4","63":"y #3 #4","64":"y #3 #4","65":"y #3 #4","66":"y #3 #4","67":"y #3 #4","68":"y #3 #4","69":"y #3 #4","70":"y #3 #4","71":"y #3 #4","72":"y #3 #4","73":"y #3 #4","74":"y #3 #4","75":"y #3 #4","76":"y #3 #4","77":"y #3 #4","78":"y #3 #4","79":"y #3 #4","80":"y #3 #4","81":"y #3 #4","83":"y #3 #4","84":"y #3 #4","85":"y #3 #4","86":"y #3 #4","87":"y #3 #4","88":"y #3 #4","89":"y #3 #4","90":"y #3 #4"},"safari":{"4":"n","5":"n","6":"n","7":"a x #1 #3","8":"a x #1 #3","9":"a x #3","10":"a x #3","11":"a #3","12":"a #3","13":"a #3","14":"a #3","3.1":"n","3.2":"n","5.1":"n","6.1":"a x #1 #3","7.1":"a x #1 #3","9.1":"a x #3","10.1":"a x #3","11.1":"a #3","12.1":"a #3","13.1":"a #3","TP":"a #3"},"opera":{"9":"n","11":"n","12":"n","15":"y x #3","16":"y x #3","17":"y x #3","18":"y x #3","19":"y x #3","20":"y x #3","21":"y x #3","22":"y x #3","23":"y x #3","24":"y x #3","25":"y x #3","26":"y x #3","27":"y x #3","28":"y x #3","29":"y x #3","30":"y x #3","31":"y x #3","32":"y x #3","33":"y #3 #4","34":"y #3","35":"y #3 #4","36":"y #3 #4","37":"y #3 #4","38":"y #3 #4","39":"y #3 #4","40":"y #3 #4","41":"y #3 #4","42":"y #3 #4","43":"y #3 #4","44":"y #3 #4","45":"y #3 #4","46":"y #3 #4","47":"y #3 #4","48":"y #3 #4","49":"y #3 #4","50":"y #3 #4","51":"y #3 #4","52":"y #3 #4","53":"y #3 #4","54":"y #3 #4","55":"y #3 #4","56":"y #3 #4","57":"y #3 #4","58":"y #3 #4","60":"y #3 #4","62":"y #3 #4","63":"y #3 #4","64":"y #3 #4","65":"y #3 #4","66":"y #3 #4","67":"y #3 #4","68":"y #3 #4","69":"y #3 #4","70":"y #3 #4","71":"y #3 #4","72":"y #3 #4","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a x #1 #3","14":"a x #3","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"a x #1 #3","8.1-8.4":"a x #1 #3","9.0-9.2":"a x #3","9.3":"a x #3","10.0-10.2":"a x #3","10.3":"a x #3","11.0-11.2":"a x #3","11.3-11.4":"a x #3","12.0-12.1":"a x #3","12.2-12.4":"a x #3","13.0-13.1":"a x #3","13.2":"a x #3","13.3":"a x #3","13.4-13.7":"a x #3"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y #3 #4","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"y x #3","4.4.3-4.4.4":"y x #3"},"bb":{"7":"n","10":"y x #3"},"op_mob":{"10":"n","11":"n","12":"n","59":"y #3 #4","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y #3 #4"},"and_ff":{"82":"a x #2 #5"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y x #3","5.0-5.4":"y #3 #4","6.2-6.4":"y #3 #4","7.2-7.4":"y #3 #4","8.2":"y #3 #4","9.2":"y #3 #4","10.1":"y #3 #4","11.1-11.2":"y #3 #4","12.0":"y #3 #4"},"and_qq":{"10.4":"y x #3"},"baidu":{"7.12":"y #3 #4"},"kaios":{"2.5":"a x #1 #2 #3"}},"notes":"Prefixes are on the values, not the property names (e.g. -webkit-min-content)\r\n\r\nOlder webkit browsers also support the unofficial `intrinsic` value which acts the same as `max-content`.","notes_by_num":{"1":"Firefox does not support the `height`/`min-height`/`max-height` properties, only `width`. See [test case](https://codepen.io/shshaw/pen/Kiwaz), [Firefox bug](https://bugzilla.mozilla.org/show_bug.cgi?id=567039).","2":"Firefox supports the `-moz-available` keyword rather than `stretch`. [Firefox bug](https://bugzilla.mozilla.org/show_bug.cgi?id=1495868).","3":"Does not support the `flex-basis` property. See [specs](https://www.w3.org/TR/2015/WD-css-flexbox-1-20150514/#flex-basis-property), [Blink bug](https://codereview.chromium.org/1304853002/), [Firefox bug](https://bugzilla.mozilla.org/show_bug.cgi?id=1055887).","4":"Chrome does not yet unprefix `stretch` (aka `fill`/`fill-available`), because the [CSSWG](https://lists.w3.org/Archives/Public/www-style/2015Aug/0127.html) is not ready for that yet. See [Chromium bug](https://chromium.googlesource.com/chromium/blink.git/+/bf119cdfece210e69c9a99af06f1b9981e2a1bc2).","5":"While still being affected by note 1, it is only for `-moz-fit-content` and `-moz-available`."},"usage_perc_y":75.84,"usage_perc_a":20.7,"ucprefix":false,"parent":"","keywords":"fill,fill-available,max-content,min-content,fit-content,contain-floats,intrinsic,extrinsic,sizing","ie_id":"cssintrinsicsizing","chrome_id":"5901353784180736","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1142 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS3 Multiple column layout","description":"Method of flowing information in multiple columns","spec":"https://www.w3.org/TR/css3-multicol/","status":"cr","links":[{"url":"https://dev.opera.com/articles/view/css3-multi-column-layout/","title":"Dev.Opera article"},{"url":"https://webdesign.tutsplus.com/articles/an-introduction-to-the-css3-multiple-column-layout-module--webdesign-4934","title":"Introduction page"},{"url":"https://www.webplatform.org/docs/css/properties/column-width","title":"WebPlatform Docs"},{"url":"https://github.com/hamsterbacke23/multicolumn-polyfill","title":"Polyfill"},{"url":"https://www.chromestatus.com/feature/6298909664083968","title":"Chrome platform status for CSS column-fill"}],"bugs":[{"description":"Firefox 1-64 does not support the `break-before`, `break-after` and `break-inside` properties. Firefox 65+ does not support the `avoid-column`, `column`, and `avoid` (in the column context) values for these properties. See [the bug](https://bugzilla.mozilla.org/show_bug.cgi?id=775628)."},{"description":"In Firefox, the property `column-span` (or `-moz-column-span`) does not yet work. See [the bug](https://bugzilla.mozilla.org/show_bug.cgi?id=616436)."},{"description":"Chrome is reported to incorrectly calculate the container height, and often breaks on margins, padding, and can display 1px of the next column at the bottom of the previous column. Part of these issues can be solved by adding `-webkit-perspective:1;` to the column container. This creates a new stacking context for the container, and apparently causes chrome to (re)calculate column layout.\r\n"},{"description":"Browsers behave differently when flowing `ol` list numbers in columns: IE and Safari only show numbers for the first column. Chrome does not show any numbers. Only Firefox behaves as expected with numbers showing for all items."},{"description":"IE has been reported to incorrectly break on elements across columns when having more than 3 columns.\r\n"},{"description":"IE 10 has a bug where text-shadow doesn't work when used inside columns. See [a testcase](https://jsfiddle.net/0bwwrtda/).\r\n"},{"description":"Firefox does not split tables into columns."},{"description":"Firefox and Chrome do not support columns on the <fieldset> element. See [bug](https://bugzilla.mozilla.org/show_bug.cgi?id=727164)."},{"description":"Safari 5-8 is known to render columns [less evenly](https://stackoverflow.com/questions/14148078/safari-column-count-differs-from-firefox-and-chrome) than other browsers."},{"description":"Safari 5.1-10+ does not work as expected with `min-height`. See [a testcase](https://codepen.io/herrschuessler/pen/LNVWJE) See [bug](https://bugs.webkit.org/show_bug.cgi?id=65691)."}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"a #3","80":"a #3","81":"a #3","83":"a #3","84":"a #3","85":"a #3","86":"a #3","87":"a #3"},"firefox":{"2":"a x #1","3":"a x #1","4":"a x #1","5":"a x #1","6":"a x #1","7":"a x #1","8":"a x #1","9":"a x #1","10":"a x #1","11":"a x #1","12":"a x #1","13":"a x #1","14":"a x #1","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","19":"a x #1","20":"a x #1","21":"a x #1","22":"a x #1","23":"a x #1","24":"a x #1","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"a x #1","52":"a #1","53":"a #1","54":"a #1","55":"a #1","56":"a #1","57":"a #1","58":"a #1","59":"a #1","60":"a #1","61":"a #1","62":"a #1","63":"a #1","64":"a #1","65":"a #3","66":"a #3","67":"a #3","68":"a #3","69":"a #3","70":"a #3","71":"a #3","72":"a #3","73":"a #3","74":"a #3","75":"a #3","76":"a #3","77":"a #3","78":"a #3","79":"a #3","80":"a #3","81":"a #3","82":"a #3","83":"a #3","84":"a #3","85":"a #3","3.5":"a x #1","3.6":"a x #1"},"chrome":{"4":"a x #1 #2","5":"a x #1 #2","6":"a x #1 #2","7":"a x #1 #2","8":"a x #1 #2","9":"a x #1 #2","10":"a x #1 #2","11":"a x #1 #2","12":"a x #1 #2","13":"a x #1 #2","14":"a x #1 #2","15":"a x #1 #2","16":"a x #1 #2","17":"a x #1 #2","18":"a x #1 #2","19":"a x #1 #2","20":"a x #1 #2","21":"a x #1 #2","22":"a x #1 #2","23":"a x #1 #2","24":"a x #1 #2","25":"a x #1 #2","26":"a x #1 #2","27":"a x #1 #2","28":"a x #1 #2","29":"a x #1 #2","30":"a x #1 #2","31":"a x #1 #2","32":"a x #1 #2","33":"a x #1 #2","34":"a x #1 #2","35":"a x #1 #2","36":"a x #1 #2","37":"a x #1 #2","38":"a x #1 #2","39":"a x #1 #2","40":"a x #1 #2","41":"a x #1 #2","42":"a x #1 #2","43":"a x #1 #2","44":"a x #1 #2","45":"a x #1 #2","46":"a x #1 #2","47":"a x #1 #2","48":"a x #1 #2","49":"a x #1 #2","50":"a #3","51":"a #3","52":"a #3","53":"a #3","54":"a #3","55":"a #3","56":"a #3","57":"a #3","58":"a #3","59":"a #3","60":"a #3","61":"a #3","62":"a #3","63":"a #3","64":"a #3","65":"a #3","66":"a #3","67":"a #3","68":"a #3","69":"a #3","70":"a #3","71":"a #3","72":"a #3","73":"a #3","74":"a #3","75":"a #3","76":"a #3","77":"a #3","78":"a #3","79":"a #3","80":"a #3","81":"a #3","83":"a #3","84":"a #3","85":"a #3","86":"a #3","87":"a #3","88":"a #3","89":"a #3","90":"a #3"},"safari":{"4":"a x #1 #2","5":"a x #1 #2","6":"a x #1 #2","7":"a x #1","8":"a x #1","9":"a #1","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"a x #1 #2","3.2":"a x #1 #2","5.1":"a x #1 #2","6.1":"a x #1 #2","7.1":"a x #1","9.1":"a #1","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"y","15":"a x #1 #2","16":"a x #1 #2","17":"a x #1 #2","18":"a x #1 #2","19":"a x #1 #2","20":"a x #1 #2","21":"a x #1 #2","22":"a x #1 #2","23":"a x #1 #2","24":"a x #1 #2","25":"a x #1 #2","26":"a x #1 #2","27":"a x #1 #2","28":"a x #1 #2","29":"a x #1 #2","30":"a x #1 #2","31":"a x #1 #2","32":"a x #1 #2","33":"a x #1 #2","34":"a x #1 #2","35":"a x #1 #2","36":"a x #1 #2","37":"a #3","38":"a #3","39":"a #3","40":"a #3","41":"a #3","42":"a #3","43":"a #3","44":"a #3","45":"a #3","46":"a #3","47":"a #3","48":"a #3","49":"a #3","50":"a #3","51":"a #3","52":"a #3","53":"a #3","54":"a #3","55":"a #3","56":"a #3","57":"a #3","58":"a #3","60":"a #3","62":"a #3","63":"a #3","64":"a #3","65":"a #3","66":"a #3","67":"a #3","68":"a #3","69":"a #3","70":"a #3","71":"a #3","72":"a #3","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"a x #1","14":"y","3.2":"a x #1 #2","4.0-4.1":"a x #1 #2","4.2-4.3":"a x #1 #2","5.0-5.1":"a x #1 #2","6.0-6.1":"a x #1 #2","7.0-7.1":"a x #1","8.1-8.4":"a x #1","9.0-9.2":"a #1","9.3":"a #1","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"a x #1 #2","4":"a x #1 #2","81":"a #3","2.1":"a x #1 #2","2.2":"a x #1 #2","2.3":"a x #1 #2","4.1":"a x #1 #2","4.2-4.3":"a x #1 #2","4.4":"a x #1 #2","4.4.3-4.4.4":"a x #1 #2"},"bb":{"7":"a x #1 #2","10":"a x #1 #2"},"op_mob":{"10":"n","11":"n","12":"y","59":"a #3","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"a #3"},"and_ff":{"82":"a #1"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"a x #1 #2","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"a #1"},"baidu":{"7.12":"a #1"},"kaios":{"2.5":"a x #1"}},"notes":"","notes_by_num":{"1":"Partial support refers to not supporting the `break-before`, `break-after`, and `break-inside` properties. WebKit- and Blink-based browsers do have equivalent support for the non-standard `-webkit-column-break-*` properties to accomplish the same result (but only the `auto` and `always` values). Firefox does not support `break-*` but does support the now-obsolete `page-break-*` properties in the paging (printing) context.","2":"Partial support refers to not supporting the `column-fill` property.","3":"Partial support refers to not supporting the `avoid-column`, `column`, and `avoid` (in the column context) values for the properties `break-before`, `break-after`, and `break-inside`."},"usage_perc_y":22.79,"usage_perc_a":76.56,"ucprefix":false,"parent":"","keywords":"column-count,column-width,column-gap,column-rule,column-rule-type,column-span,column-fill,break-before,break-after,break-inside","ie_id":"multicolumnfullsupport","chrome_id":"6526151266664448,5630943616303104","firefox_id":"css-multicol","webkit_id":"","shown":true}

/***/ },
/* 1143 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS3 object-fit/object-position","description":"Method of specifying how an object (image or video) should fit inside its box. object-fit options include \"contain\" (fit according to aspect ratio), \"fill\" (stretches object to fill) and \"cover\" (overflows box but maintains ratio), where object-position allows the object to be repositioned like background-image does.","spec":"https://www.w3.org/TR/css3-images/","status":"cr","links":[{"url":"https://dev.opera.com/articles/view/css3-object-fit-object-position/","title":"Dev.Opera article"},{"url":"https://www.webplatform.org/docs/css/properties/object-fit","title":"WebPlatform Docs"},{"url":"https://github.com/bfred-it/object-fit-images/","title":"object-fit-images Polyfill for IE & Edge"},{"url":"https://developer.mozilla.org//docs/Web/CSS/object-fit","title":"MDN"},{"url":"https://developer.mozilla.org/docs/Web/CSS/object-fit","title":"MDN (object-fit)"},{"url":"https://developer.mozilla.org/docs/Web/CSS/object-position","title":"MDN (object-position)"}],"bugs":[],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"a #2","17":"a #2","18":"a #2","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"a #1","9":"a #1","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"a #1","9.1":"a #1","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y x","12":"y x","15":"n","16":"n","17":"n","18":"n","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"y x","11.1":"y x","11.5":"y x","11.6":"y x","12.1":"y x"},"ios_saf":{"8":"a #1","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"a #1","9.0-9.2":"a #1","9.3":"a #1","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y x"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"y"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"y x","12":"y x","59":"y","11.1":"y x","11.5":"y x","12.1":"y x"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support in Safari refers to support for `object-fit` but not `object-position`.","2":"Partial support in Edge refers to `object-fit` only supporting `<img>` ([see this comment](https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/13603873/#comment-0))"},"usage_perc_y":96.71,"usage_perc_a":0.77,"ucprefix":false,"parent":"","keywords":"objectfit,objectposition","ie_id":"objectfitandobjectpositionimages,objectfitandobjectpositionvideocanvasetc","chrome_id":"5302669702856704","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1144 */
/***/ function(module, exports) {

	module.exports = {"title":"Pointer events","description":"This specification integrates various inputs from mice, touchscreens, and pens, making separate implementations no longer necessary and authoring for cross-device pointers easier. Not to be mistaken with the unrelated \"pointer-events\" CSS property.","spec":"https://www.w3.org/TR/pointerevents/","status":"rec","links":[{"url":"http://blogs.msdn.com/b/ie/archive/2011/09/20/touch-input-for-ie10-and-metro-style-apps.aspx","title":"Implementation of Pointer Events in IE10"},{"url":"http://blogs.msdn.com/b/eternalcoding/archive/2013/01/16/hand-js-a-polyfill-for-supporting-pointer-events-on-every-browser.aspx","title":"Hand.js, the polyfill for browsers only supporting Touch Events"},{"url":"http://blogs.msdn.com/b/davrous/archive/2013/02/20/handling-touch-in-your-html5-apps-thanks-to-the-pointer-events-of-ie10-and-windows-8.aspx","title":"Article & tutorial"},{"url":"http://deeptissuejs.com","title":"Abstraction library for pointer events"},{"url":"https://github.com/jquery/PEP","title":"PEP: Pointer Events Polyfill"},{"url":"https://developer.mozilla.org/en-US/docs/Web/API/Pointer_events","title":"Pointer Event API on MDN"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=822898","title":"Bugzilla@Mozilla: Bug 822898 - Implement pointer events"}],"bugs":[],"categories":["DOM","JS API"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"a x #1","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"p","7":"p","8":"p","9":"p","10":"p","11":"p","12":"p","13":"p","14":"p","15":"p","16":"p","17":"p","18":"p","19":"p","20":"p","21":"p","22":"p","23":"p","24":"p","25":"p","26":"p","27":"p","28":"p","29":"p","30":"p","31":"p","32":"p","33":"p","34":"p","35":"p","36":"p","37":"p","38":"p","39":"p","40":"p","41":"p d #2","42":"p d #2","43":"p d #2","44":"p d #2","45":"p d #2","46":"p d #2","47":"p d #2","48":"p d #2","49":"p d #2","50":"p d #2","51":"p d #2","52":"p d #2","53":"p d #2","54":"p d #2","55":"p d #2","56":"p d #2","57":"p d #2","58":"p d #2","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"p","23":"p","24":"p","25":"p","26":"p","27":"p","28":"p","29":"p","30":"p","31":"p","32":"p","33":"p","34":"p","35":"p","36":"p","37":"p","38":"p","39":"p","40":"p","41":"p","42":"p","43":"p","44":"p","45":"p","46":"p","47":"p","48":"p","49":"p","50":"p","51":"p","52":"p d #3","53":"p d #3","54":"p d #3","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"p","8":"p","9":"p","10":"p","11":"p","12":"p","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"p","7.1":"p","9.1":"p","10.1":"p","11.1":"p","12.1":"p d #4","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"p","16":"p","17":"p","18":"p","19":"p","20":"p","21":"p","22":"p","23":"p","24":"p","25":"p","26":"p","27":"p","28":"p","29":"p","30":"p","31":"p","32":"p","33":"p","34":"p","35":"p","36":"p","37":"p","38":"p","39":"p d #3","40":"p d #3","41":"p d #3","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"p","14":"y","3.2":"p","4.0-4.1":"p","4.2-4.3":"p","5.0-5.1":"p","6.0-6.1":"p","7.0-7.1":"p","8.1-8.4":"p","9.0-9.2":"p","9.3":"p","10.0-10.2":"p","10.3":"p","11.0-11.2":"p","11.3-11.4":"p","12.0-12.1":"p","12.2-12.4":"p","13.0-13.1":"a #5 #6","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"p","4":"p","81":"y","2.1":"p","2.2":"p","2.3":"p","4.1":"p","4.2-4.3":"p","4.4":"p","4.4.3-4.4.4":"p"},"bb":{"7":"p","10":"p"},"op_mob":{"10":"n","11":"p","12":"p","59":"y","11.1":"p","11.5":"p","12.1":"p"},"and_chr":{"86":"y"},"and_ff":{"82":"p d #2"},"ie_mob":{"10":"a x","11":"y"},"and_uc":{"12.12":"p"},"samsung":{"4":"p","5.0-5.4":"n","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"p d #2"}},"notes":"Firefox, starting with version 28, provides the 'dom.w3c_pointer_events.enabled' flag to support this specification.","notes_by_num":{"1":"Partial support in IE10 refers the lack of pointerenter and pointerleave events.","2":"Firefox support is disabled by default and [only supports mouse input](https://hacks.mozilla.org/2015/08/pointer-events-now-in-firefox-nightly/). On Windows only, touch can be enabled with the `layers.async-pan-zoom.enabled` and `dom.w3c_touch_events.enabled` flags","3":"Can be enabled with the `#enable-pointer-events` flag.","4":"Can be enabled under the `Experimental Features` menu.","5":"element.releasePointerCapture(pointerID) is only partially implemented. Calling it after pointerdown does not result in boundary events (pointerover pointerleave) being dispatched during pointer movements.","6":"Value of pointerevent.buttons is incorrect on pointermove events generated by touches. Is 0 but should be 1."},"usage_perc_y":91.38,"usage_perc_a":0.18,"ucprefix":false,"parent":"","keywords":"pointerdown,pointermove,pointerup,pointercancel,pointerover,pointerout,pointerenter,pointerleave","ie_id":"pointerevents","chrome_id":"4504699138998272","firefox_id":"pointer-events","webkit_id":"specification-pointer-events-level-2","shown":true}

/***/ },
/* 1145 */
/***/ function(module, exports) {

	module.exports = {"title":"text-decoration styling","description":"Method of defining the type, style and color of lines in the text-decoration property. These can be defined as shorthand (e.g. `text-decoration: line-through dashed blue`) or as single properties (e.g. `text-decoration-color: blue`)","spec":"https://www.w3.org/TR/css-text-decor-3/#line-decoration","status":"cr","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration-style","title":"MDN Web Docs - text-decoration-style"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration-color","title":"MDN Web Docs - text-decoration-color"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration-line","title":"MDN Web Docs - text-decoration-line"},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6514536-text-decoration-styling","title":"Microsoft Edge feature request on UserVoice"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration-skip","title":"MDN Web Docs - text-decoration-skip"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=812990","title":"Firefox implementation bug"}],"bugs":[],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"a #5","80":"a #5","81":"a #5","83":"a #5","84":"a #5","85":"a #5","86":"a #5","87":"a #5"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"a x #4","7":"a x #4","8":"a x #4","9":"a x #4","10":"a x #4","11":"a x #4","12":"a x #4","13":"a x #4","14":"a x #4","15":"a x #4","16":"a x #4","17":"a x #4","18":"a x #4","19":"a x #4","20":"a x #4","21":"a x #4","22":"a x #4","23":"a x #4","24":"a x #4","25":"a x #4","26":"a x #4","27":"a x #4","28":"a x #4","29":"a x #4","30":"a x #4","31":"a x #4","32":"a x #4","33":"a x #4","34":"a x #4","35":"a x #4","36":"a #4","37":"a #4","38":"a #4","39":"a #4","40":"a #4","41":"a #4","42":"a #4","43":"a #4","44":"a #4","45":"a #4","46":"a #4","47":"a #4","48":"a #4","49":"a #4","50":"a #4","51":"a #4","52":"a #4","53":"a #4","54":"a #4","55":"a #4","56":"a #4","57":"a #4","58":"a #4","59":"a #4","60":"a #4","61":"a #4","62":"a #4","63":"a #4","64":"a #4","65":"a #4","66":"a #4","67":"a #4","68":"a #4","69":"a #4","70":"a #4","71":"a #4","72":"a #4","73":"a #4","74":"a #4","75":"a #4","76":"a #4","77":"a #4","78":"a #4","79":"a #4","80":"a #4","81":"a #4","82":"a #4","83":"a #4","84":"a #4","85":"a #4","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n x d #1","27":"n x d #1","28":"n x d #1","29":"n x d #1","30":"n x d #1","31":"n x d #1","32":"n x d #1","33":"n x d #1","34":"n x d #1","35":"n x d #1","36":"n x d #1","37":"n x d #1","38":"n x d #1","39":"n x d #1","40":"n x d #1","41":"n x d #1","42":"n x d #1","43":"n x d #1","44":"n x d #1","45":"n x d #1","46":"n x d #1","47":"n x d #1","48":"n x d #1","49":"n x d #1","50":"n x d #1","51":"n x d #1","52":"n x d #1","53":"n x d #1","54":"n x d #1","55":"n x d #1","56":"n x d #1","57":"a #5","58":"a #5","59":"a #5","60":"a #5","61":"a #5","62":"a #5","63":"a #5","64":"a #5","65":"a #5","66":"a #5","67":"a #5","68":"a #5","69":"a #5","70":"a #5","71":"a #5","72":"a #5","73":"a #5","74":"a #5","75":"a #5","76":"a #5","77":"a #5","78":"a #5","79":"a #5","80":"a #5","81":"a #5","83":"a #5","84":"a #5","85":"a #5","86":"a #5","87":"a #5","88":"a #5","89":"a #5","90":"a #5"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"a x #2 #3","9":"a x #2 #3","10":"a x #2 #3","11":"a x #2 #3","12":"a x #2 #3","13":"a #2 #3","14":"a #2 #3","3.1":"n","3.2":"n","5.1":"n","6.1":"n","7.1":"a x #2 #4","9.1":"a x #2 #3","10.1":"a x #2 #3","11.1":"a x #2 #3","12.1":"a #2 #3","13.1":"a #2 #3","TP":"a #2 #3"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n x d #1","36":"n x d #1","37":"n x d #1","38":"n x d #1","39":"n x d #1","40":"n x d #1","41":"n x d #1","42":"n x d #1","43":"n x d #1","44":"a #5","45":"a #5","46":"a #5","47":"a #5","48":"a #5","49":"a #5","50":"a #5","51":"a #5","52":"a #5","53":"a #5","54":"a #5","55":"a #5","56":"a #5","57":"a #5","58":"a #5","60":"a #5","62":"a #5","63":"a #5","64":"a #5","65":"a #5","66":"a #5","67":"a #5","68":"a #5","69":"a #5","70":"a #5","71":"a #5","72":"a #5","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"a x #2","14":"a x #2","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"n","8.1-8.4":"a x #2","9.0-9.2":"a x #2","9.3":"a x #2","10.0-10.2":"a x #2","10.3":"a x #2","11.0-11.2":"a x #2","11.3-11.4":"a x #2","12.0-12.1":"a x #2","12.2-12.4":"a x #2","13.0-13.1":"a x #2","13.2":"a x #2","13.3":"a x #2","13.4-13.7":"a x #2"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"a #5","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a #5"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"a #5"},"samsung":{"4":"n","5.0-5.4":"n","6.2-6.4":"n","7.2-7.4":"a #5","8.2":"a #5","9.2":"a #5","10.1":"a #5","11.1-11.2":"a #5","12.0":"a #5"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"y"},"kaios":{"2.5":"a #4"}},"notes":"All browsers support the CSS2 version of `text-decoration`, which matches only the `text-decoration-line` values (`underline`, etc.)","notes_by_num":{"1":"Enabled in Chrome through the \"experimental Web Platform features\" flag in chrome://flags","2":"Partial support refers to not supporting the `text-decoration-style` property.","3":"Safari 8+ supports `-webkit-text-decoration-skip` with values `none` and `skip` (other values behave like `none` or `skip`)","4":"Partial support refers to not supporting the `text-decoration-skip` property.","5":"Partial support refers to `text-decoration-skip` only supporting value `objects` and `ink`."},"usage_perc_y":0.23,"usage_perc_a":94.96,"ucprefix":false,"parent":"","keywords":"text-decoration-line,text-decoration-style,text-decoration-color,text-decoration-skip","ie_id":"","chrome_id":"5766823203045376","firefox_id":"","webkit_id":"specification-css-text-decoration-level-4","shown":true}

/***/ },
/* 1146 */
/***/ function(module, exports) {

	module.exports = {"title":"text-emphasis styling","description":"Method of using small symbols next to each glyph to emphasize a run of text, commonly used in East Asian languages. The `text-emphasis` shorthand, and its `text-emphasis-style` and `text-emphasis-color` longhands, can be used to apply marks to the text. The `text-emphasis-position` property, which inherits separately, allows setting the emphasis marks' position with respect to the text.","spec":"https://drafts.csswg.org/css-text-decor-3/#text-emphasis-property","status":"cr","links":[{"url":"https://github.com/zmmbreeze/jquery.emphasis/","title":"A javascript fallback for CSS3 emphasis mark."},{"url":"https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6514536-text-decoration-styling","title":"Microsoft Edge feature request on UserVoice"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/text-emphasis","title":"MDN Web Docs - text-emphasis"}],"bugs":[{"description":"Chrome on Android occasionally has issues rendering emphasis glyphs correctly."}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","79":"a x #1","80":"a x #1","81":"a x #1","83":"a x #1","84":"a x #1","85":"a x #1","86":"a x #1","87":"a x #1"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n d #2","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"a x #1","52":"a x #1","53":"a x #1","54":"a x #1","55":"a x #1","56":"a x #1","57":"a x #1","58":"a x #1","59":"a x #1","60":"a x #1","61":"a x #1","62":"a x #1","63":"a x #1","64":"a x #1","65":"a x #1","66":"a x #1","67":"a x #1","68":"a x #1","69":"a x #1","70":"a x #1","71":"a x #1","72":"a x #1","73":"a x #1","74":"a x #1","75":"a x #1","76":"a x #1","77":"a x #1","78":"a x #1","79":"a x #1","80":"a x #1","81":"a x #1","83":"a x #1","84":"a x #1","85":"a x #1","86":"a x #1","87":"a x #1","88":"a x #1","89":"a x #1","90":"a x #1"},"safari":{"4":"n","5":"n","6":"n","7":"a x #1","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"n","3.2":"n","5.1":"n","6.1":"a x #1","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"n","12":"n","15":"a x #1","16":"a x #1","17":"a x #1","18":"a x #1","19":"a x #1","20":"a x #1","21":"a x #1","22":"a x #1","23":"a x #1","24":"a x #1","25":"a x #1","26":"a x #1","27":"a x #1","28":"a x #1","29":"a x #1","30":"a x #1","31":"a x #1","32":"a x #1","33":"a x #1","34":"a x #1","35":"a x #1","36":"a x #1","37":"a x #1","38":"a x #1","39":"a x #1","40":"a x #1","41":"a x #1","42":"a x #1","43":"a x #1","44":"a x #1","45":"a x #1","46":"a x #1","47":"a x #1","48":"a x #1","49":"a x #1","50":"a x #1","51":"a x #1","52":"a x #1","53":"a x #1","54":"a x #1","55":"a x #1","56":"a x #1","57":"a x #1","58":"a x #1","60":"a x #1","62":"a x #1","63":"a x #1","64":"a x #1","65":"a x #1","66":"a x #1","67":"a x #1","68":"a x #1","69":"a x #1","70":"a x #1","71":"a x #1","72":"a x #1","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y","14":"y","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"n","6.0-6.1":"n","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"a x #1","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"a x #1","4.4.3-4.4.4":"a x #1"},"bb":{"7":"n","10":"a x #1"},"op_mob":{"10":"n","11":"n","12":"n","59":"a x #1","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"a x #1"},"and_ff":{"82":"y"},"ie_mob":{"10":"n","11":"n"},"and_uc":{"12.12":"a x #1"},"samsung":{"4":"a x #1","5.0-5.4":"a x #1","6.2-6.4":"a x #1","7.2-7.4":"a x #1","8.2":"a x #1","9.2":"a x #1","10.1":"a x #1","11.1-11.2":"a x #1","12.0":"a x #1"},"and_qq":{"10.4":"a x #1"},"baidu":{"7.12":"a x #1"},"kaios":{"2.5":"y"}},"notes":"Some old WebKit browsers (like Chrome 24) support `-webkit-text-emphasis`, but does not support CJK languages and is therefore considered unsupported.","notes_by_num":{"1":"Partial support refers to incorrect support for `-webkit-text-emphasis-position`. These browsers support `over` and `under` as values, but not the added `left` and `right` values required by the spec.","2":"Can be enabled in Firefox using the `layout.css.text-emphasis.enabled` flag"},"usage_perc_y":20.36,"usage_perc_a":75.82,"ucprefix":false,"parent":"","keywords":"text-emphasis,text-emphasis-position,text-emphasis-style,text-emphasis-color","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1147 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS3 Text-overflow","description":"Append ellipsis when text overflows its containing element","spec":"https://www.w3.org/TR/css3-ui/#text-overflow","status":"cr","links":[{"url":"https://github.com/rmorse/AutoEllipsis","title":"jQuery polyfill for Firefox"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/text-overflow","title":"MDN Web Docs - text-overflow"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/css.js#css-text-overflow","title":"has.js test"},{"url":"https://www.webplatform.org/docs/css/properties/text-overflow","title":"WebPlatform Docs"}],"bugs":[{"description":"Does not work on `select` elements in Chrome and IE, only Firefox."},{"description":"Some Samsung-based browsers, have a bug with overflowing text when ellipsis is set and if `text-rendering` is not `auto`."},{"description":"Does not work in IE8 and IE9 on `<input type=\"text\">`"}],"categories":["CSS3"],"stats":{"ie":{"6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"p","3":"p","4":"p","5":"p","6":"p","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"p","3.6":"p"},"chrome":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y","5":"y","6":"y","7":"y","8":"y","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y","3.2":"y","5.1":"y","6.1":"y","7.1":"y","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"y x","11":"y","12":"y","15":"y","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"y x","10.0-10.1":"y x","10.5":"y x","10.6":"y x","11.1":"y","11.5":"y","11.6":"y","12.1":"y"},"ios_saf":{"8":"y","14":"y","3.2":"y","4.0-4.1":"y","4.2-4.3":"y","5.0-5.1":"y","6.0-6.1":"y","7.0-7.1":"y","8.1-8.4":"y","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"y"},"android":{"3":"y","4":"y","81":"y","2.1":"y","2.2":"y","2.3":"y","4.1":"y","4.2-4.3":"y","4.4":"y","4.4.3-4.4.4":"y"},"bb":{"7":"y","10":"y"},"op_mob":{"10":"y x","11":"y x","12":"y x","59":"y","11.1":"y x","11.5":"y x","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{},"usage_perc_y":99.63,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"textoverflow,ellipsis","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1148 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS text-size-adjust","description":"On mobile devices, the text-size-adjust CSS property allows Web authors to control if and how the text-inflating algorithm is applied to the textual content of the element it is applied to.","spec":"https://drafts.csswg.org/css-size-adjust/","status":"unoff","links":[{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/text-size-adjust","title":"MDN Web Docs - text-size-adjust"},{"url":"https://bugzilla.mozilla.org/show_bug.cgi?id=1226116","title":"Mozilla Bug #1226116: Unprefix -moz-text-size-adjust"}],"bugs":[],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","5.5":"n"},"edge":{"12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"n","55":"n","56":"n","57":"n","58":"n","59":"n","60":"n","61":"n","62":"n","63":"n","64":"n","65":"n","66":"n","67":"n","68":"n","69":"n","70":"n","71":"n","72":"n","73":"n","74":"n","75":"n","76":"n","77":"n","78":"n","79":"n","80":"n","81":"n","82":"n","83":"n","84":"n","85":"n","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n #2","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"n","44":"n","45":"n","46":"n","47":"n","48":"n","49":"n","50":"n","51":"n","52":"n","53":"n","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"n","13":"n","14":"n","3.1":"n","3.2":"n","5.1":"n #2","6.1":"n","7.1":"n","9.1":"n","10.1":"n","11.1":"n","12.1":"n","13.1":"n","TP":"n"},"opera":{"9":"n","11":"n","12":"n","15":"n","16":"n","17":"n","18":"n","19":"n","20":"n","21":"n","22":"n","23":"n","24":"n","25":"n","26":"n","27":"n","28":"n","29":"n","30":"n","31":"n","32":"n","33":"n","34":"n","35":"n","36":"n","37":"n","38":"n","39":"n","40":"n","41":"n","42":"n","43":"y","44":"n","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y x","3.2":"n","4.0-4.1":"n","4.2-4.3":"n","5.0-5.1":"y x","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y x","10.3":"y x","11.0-11.2":"y x","11.3-11.4":"y x","12.0-12.1":"y x","12.2-12.4":"y x","13.0-13.1":"y x","13.2":"y x","13.3":"y x","13.4-13.7":"y x"},"op_mini":{"all":"n"},"android":{"3":"n","4":"n","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"n","4.2-4.3":"n","4.4":"n","4.4.3-4.4.4":"n"},"bb":{"7":"n","10":"n"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y x"},"ie_mob":{"10":"y x #1","11":"y x #1"},"and_uc":{"12.12":"y"},"samsung":{"4":"n","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"n"},"baidu":{"7.12":"n"},"kaios":{"2.5":"n"}},"notes":"","notes_by_num":{"1":"If the viewport size is set using a `<meta>` element, the `-ms-text-size-adjust` property is ignored. See [MDN](https://developer.mozilla.org/en-US/docs/Web/CSS/text-size-adjust)","2":"Old versions of WebKit-based desktop browsers (Chrome<27, Safari<6) [suffer from a bug](https://bugs.webkit.org/show_bug.cgi?id=56543) where if `-webkit-text-size-adjust` is explicitly set to `none`, instead of ignoring the property, the browsers will prevent the user from zooming in or out on the webpage."},"usage_perc_y":87.61,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"5730156303876096","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1149 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS3 2D Transforms","description":"Method of transforming an element including rotating, scaling, etc. Includes support for `transform` as well as `transform-origin` properties.","spec":"https://www.w3.org/TR/css3-2d-transforms/","status":"wd","links":[{"url":"http://www.westciv.com/tools/transforms/","title":"Live editor"},{"url":"https://developer.mozilla.org/en-US/docs/Web/CSS/transform","title":"MDN Web Docs - CSS transform"},{"url":"http://www.webresourcesdepot.com/cross-browser-css-transforms-csssandpaper/","title":"Workaround script for IE"},{"url":"http://www.useragentman.com/IETransformsTranslator/","title":"Converter for IE"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/css.js#css-transform","title":"has.js test"},{"url":"https://www.webplatform.org/docs/css/transforms/transform","title":"WebPlatform Docs"},{"url":"https://developer.microsoft.com/en-us/microsoft-edge/platform/status/supportcsstransformsonsvg/","title":"IE platform status (SVG)"}],"bugs":[{"description":"Scaling transforms in Android 2.3 fails to scale element background images."},{"description":"In IE9 the caret of a `textarea` disappears when you use translate."},{"description":"Firefox 42 and below do not support [`transform-origin` on SVG elements](https://bugzilla.mozilla.org/show_bug.cgi?id=923193). "}],"categories":["CSS3"],"stats":{"ie":{"6":"p","7":"p","8":"p","9":"y x #1","10":"y #1","11":"y #1","5.5":"n"},"edge":{"12":"y #1","13":"y #1","14":"y #1","15":"y #1","16":"y #1","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y x","3.6":"y x"},"chrome":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y","10":"y","11":"y","12":"y","13":"y","14":"y","3.1":"y x","3.2":"y x","5.1":"y x","6.1":"y x","7.1":"y x","9.1":"y","10.1":"y","11.1":"y","12.1":"y","13.1":"y","TP":"y"},"opera":{"9":"n","11":"y x","12":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"y x","10.6":"y x","11.1":"y x","11.5":"y x","11.6":"y x","12.1":"y"},"ios_saf":{"8":"y x","14":"y","3.2":"y x","4.0-4.1":"y x","4.2-4.3":"y x","5.0-5.1":"y x","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y","9.3":"y","10.0-10.2":"y","10.3":"y","11.0-11.2":"y","11.3-11.4":"y","12.0-12.1":"y","12.2-12.4":"y","13.0-13.1":"y","13.2":"y","13.3":"y","13.4-13.7":"y"},"op_mini":{"all":"n"},"android":{"3":"y x","4":"y x","81":"y","2.1":"y x","2.2":"y x","2.3":"y x","4.1":"y x","4.2-4.3":"y x","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"y x","10":"y x"},"op_mob":{"10":"n","11":"y","12":"y","59":"y","11.1":"y","11.5":"y","12.1":"y"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y","11":"y"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"The scale transform can be emulated in IE < 9 using Microsoft's \"zoom\" extension, others are (not easily) possible using the MS Matrix filter","notes_by_num":{"1":"Does not support CSS transforms on SVG elements (transform attribute can be used instead)"},"usage_perc_y":98.71,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"transformation,translate,translatex,translatey,translatez,transform3d,rotation,rotate,scale,skew,css-transforms,transform-origin,transform:rotate,transform:scale,transform:skew","ie_id":"transforms","chrome_id":"6437640580628480","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1150 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS3 3D Transforms","description":"Method of transforming an element in the third dimension using the `transform` property. Includes support for the `perspective` property to set the perspective in z-space and the `backface-visibility` property to toggle display of the reverse side of a 3D-transformed element.","spec":"https://www.w3.org/TR/css3-3d-transforms/","status":"wd","links":[{"url":"http://css3.bradshawenterprises.com/flip/","title":"Multi-browser demo"},{"url":"https://hacks.mozilla.org/2011/10/css-3d-transformations-in-firefox-nightly/","title":"Mozilla hacks article"},{"url":"http://thewebrocks.com/demos/3D-css-tester/","title":"3D CSS Tester"},{"url":"https://raw.github.com/phiggins42/has.js/master/detect/css.js#css-transform","title":"has.js test"},{"url":"https://www.webplatform.org/docs/css/transforms/transform","title":"WebPlatform Docs"},{"url":"http://desandro.github.io/3dtransforms/","title":"Intro to CSS 3D transforms"}],"bugs":[{"description":"Some configurations of Linux and older Windows machines (those without WebGL support) have trouble with 3D transforms and will treat them as if `perspective` was set as `none`."},{"description":"Firefox on Windows [incorrectly renders plugin content within no-op 3D transforms](https://bugzilla.mozilla.org/show_bug.cgi?id=1048279)."},{"description":"The `perspective` property doesn't work on the `body` element in Firefox, it must be used on an inner element."},{"description":"Chrome has a (recently fixed) bug where combining `clip-path` and `backface-visibility` produces [visible noise](https://code.google.com/p/chromium/issues/detail?id=350724)."},{"description":"Transforms may break position:fixed styles of contained elements"}],"categories":["CSS3"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"a #1","11":"a #1","5.5":"n"},"edge":{"12":"y","13":"y","14":"y","15":"y","16":"y","17":"y","18":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"n","3":"n","4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y","17":"y","18":"y","19":"y","20":"y","21":"y","22":"y","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"n","3.6":"n"},"chrome":{"4":"n","5":"n","6":"n","7":"n","8":"n","9":"n","10":"n","11":"n","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y #2","10":"y #2","11":"y #2","12":"y #2","13":"y #2","14":"y #2","3.1":"n","3.2":"n","5.1":"y x","6.1":"y x","7.1":"y x","9.1":"y #2","10.1":"y #2","11.1":"y #2","12.1":"y #2","13.1":"y #2","TP":"y #2"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y","24":"y","25":"y","26":"y","27":"y","28":"y","29":"y","30":"y","31":"y","32":"y","33":"y","34":"y","35":"y","36":"y","37":"y","38":"y","39":"y","40":"y","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y #2","3.2":"y x","4.0-4.1":"y x","4.2-4.3":"y x","5.0-5.1":"y x","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y #2","9.3":"y #2","10.0-10.2":"y #2","10.3":"y #2","11.0-11.2":"y #2","11.3-11.4":"y #2","12.0-12.1":"y #2","12.2-12.4":"y #2","13.0-13.1":"y #2","13.2":"y #2","13.3":"y #2","13.4-13.7":"y #2"},"op_mini":{"all":"n"},"android":{"3":"y x","4":"y x","81":"y","2.1":"n","2.2":"n","2.3":"n","4.1":"y x","4.2-4.3":"y x","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"y x","10":"y x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"a #1","11":"a #1"},"and_uc":{"12.12":"y"},"samsung":{"4":"y","5.0-5.4":"y","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"y"},"kaios":{"2.5":"y"}},"notes":"","notes_by_num":{"1":"Partial support in IE refers to not supporting [the transform-style: preserve-3d property](http://msdn.microsoft.com/en-us/library/ie/hh673529%28v=vs.85%29.aspx#the_ms_transform_style_property). This prevents nesting 3D transformed elements.","2":"Safari 9 - 13 still require a prefix for the related `backface-visibility` property. [WebKit Bug 170983](https://bugs.webkit.org/show_bug.cgi?id=170983) requests prefix removal."},"usage_perc_y":97.18,"usage_perc_a":1.14,"ucprefix":false,"parent":"","keywords":"css 3d,3dtransforms,translate3d,backface visibility,perspective,transform-origin,transform-style","ie_id":"transforms,csstransformspreserve3d","chrome_id":"6437640580628480","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1151 */
/***/ function(module, exports) {

	module.exports = {"title":"CSS user-select: none","description":"Method of preventing text/element selection using CSS. ","spec":"https://drafts.csswg.org/css-ui-4/#valdef-user-select-none","status":"wd","links":[{"url":"https://developer.mozilla.org/en-US/docs/CSS/user-select","title":"MDN Web Docs - CSS user-select"},{"url":"https://css-tricks.com/almanac/properties/u/user-select/","title":"CSS Tricks article"},{"url":"http://msdn.microsoft.com/en-us/library/ie/hh781492(v=vs.85).aspx","title":"MSDN Documentation"}],"bugs":[{"description":"iOS does not allow input elements to be focused (and thus prevents text input) when the element has `-webkit-user-select: none` set"},{"description":"Reported to not work in some manufacturer's versions of Android 4.0 and below, though confirmed to work in others."}],"categories":["CSS"],"stats":{"ie":{"6":"n","7":"n","8":"n","9":"n","10":"y x","11":"y x","5.5":"n"},"edge":{"12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y"},"firefox":{"2":"y x","3":"y x","4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y x","55":"y x","56":"y x","57":"y x","58":"y x","59":"y x","60":"y x","61":"y x","62":"y x","63":"y x","64":"y x","65":"y x","66":"y x","67":"y x","68":"y x","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","82":"y","83":"y","84":"y","85":"y","3.5":"y x","3.6":"y x"},"chrome":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y x","42":"y x","43":"y x","44":"y x","45":"y x","46":"y x","47":"y x","48":"y x","49":"y x","50":"y x","51":"y x","52":"y x","53":"y x","54":"y","55":"y","56":"y","57":"y","58":"y","59":"y","60":"y","61":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","73":"y","74":"y","75":"y","76":"y","77":"y","78":"y","79":"y","80":"y","81":"y","83":"y","84":"y","85":"y","86":"y","87":"y","88":"y","89":"y","90":"y"},"safari":{"4":"y x","5":"y x","6":"y x","7":"y x","8":"y x","9":"y x","10":"y x","11":"y x","12":"y x","13":"y x","14":"y x","3.1":"y x","3.2":"y x","5.1":"y x","6.1":"y x","7.1":"y x","9.1":"y x","10.1":"y x","11.1":"y x","12.1":"y x","13.1":"y x","TP":"y x"},"opera":{"9":"n","11":"n","12":"n","15":"y x","16":"y x","17":"y x","18":"y x","19":"y x","20":"y x","21":"y x","22":"y x","23":"y x","24":"y x","25":"y x","26":"y x","27":"y x","28":"y x","29":"y x","30":"y x","31":"y x","32":"y x","33":"y x","34":"y x","35":"y x","36":"y x","37":"y x","38":"y x","39":"y x","40":"y x","41":"y","42":"y","43":"y","44":"y","45":"y","46":"y","47":"y","48":"y","49":"y","50":"y","51":"y","52":"y","53":"y","54":"y","55":"y","56":"y","57":"y","58":"y","60":"y","62":"y","63":"y","64":"y","65":"y","66":"y","67":"y","68":"y","69":"y","70":"y","71":"y","72":"y","9.5-9.6":"n","10.0-10.1":"n","10.5":"n","10.6":"n","11.1":"n","11.5":"n","11.6":"n","12.1":"n"},"ios_saf":{"8":"y x","14":"y x","3.2":"y x","4.0-4.1":"y x","4.2-4.3":"y x","5.0-5.1":"y x","6.0-6.1":"y x","7.0-7.1":"y x","8.1-8.4":"y x","9.0-9.2":"y x","9.3":"y x","10.0-10.2":"y x","10.3":"y x","11.0-11.2":"y x","11.3-11.4":"y x","12.0-12.1":"y x","12.2-12.4":"y x","13.0-13.1":"y x","13.2":"y x","13.3":"y x","13.4-13.7":"y x"},"op_mini":{"all":"n"},"android":{"3":"y x","4":"y x","81":"y","2.1":"y x","2.2":"y x","2.3":"y x","4.1":"y x","4.2-4.3":"y x","4.4":"y x","4.4.3-4.4.4":"y x"},"bb":{"7":"y x","10":"y x"},"op_mob":{"10":"n","11":"n","12":"n","59":"y","11.1":"n","11.5":"n","12.1":"n"},"and_chr":{"86":"y"},"and_ff":{"82":"y"},"ie_mob":{"10":"y x","11":"y x"},"and_uc":{"12.12":"n"},"samsung":{"4":"y x","5.0-5.4":"y x","6.2-6.4":"y","7.2-7.4":"y","8.2":"y","9.2":"y","10.1":"y","11.1-11.2":"y","12.0":"y"},"and_qq":{"10.4":"y"},"baidu":{"7.12":"n"},"kaios":{"2.5":"y x"}},"notes":"","notes_by_num":{},"usage_perc_y":97.24,"usage_perc_a":0,"ucprefix":false,"parent":"","keywords":"","ie_id":"","chrome_id":"","firefox_id":"","webkit_id":"","shown":true}

/***/ },
/* 1152 */
/***/ function(module, exports) {

	module.exports = {"id":"AD","name":"Andorra","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0.00625,"36":0,"37":0,"38":0.00625,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.0125,"49":0,"50":0,"51":0,"52":0.03124,"53":0.00625,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00625,"69":0,"70":0,"71":0,"72":0.0125,"73":0,"74":0,"75":0,"76":0,"77":0.00625,"78":0.17494,"79":0.00625,"80":0.11246,"81":3.96123,"82":0.56857,"83":0.0125,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00625,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00625,"48":0,"49":0.33114,"50":0,"51":0,"52":0,"53":0.00625,"54":0,"55":0,"56":0.00625,"57":0,"58":0.03124,"59":0,"60":0.00625,"61":0.00625,"62":0.00625,"63":0.01874,"64":0,"65":0.64354,"66":0,"67":0.00625,"68":0,"69":0.00625,"70":0.09997,"71":0.12496,"72":0.14995,"73":0.06873,"74":0.02499,"75":0.02499,"76":0.00625,"77":0.12496,"78":0.02499,"79":0.0125,"80":0.11871,"81":0.13746,"83":0.38738,"84":0.35614,"85":7.42262,"86":12.8209,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0.00625,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.08747,"38":0,"39":0,"40":0.00625,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0.0125,"66":0,"67":0,"68":0.00625,"69":0,"70":0.03124,"71":0.36238,"72":0.00625,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":9.59423,"3.2":0.02298,"4.0-4.1":0.0197,"4.2-4.3":0.00328,"5.0-5.1":0.01642,"6.0-6.1":0.00985,"7.0-7.1":0.02298,"8.1-8.4":0.07552,"9.0-9.2":0.04268,"9.3":0.54505,"10.0-10.2":0.09194,"10.3":0.50565,"11.0-11.2":0.19044,"11.3-11.4":0.32506,"12.0-12.1":0.33163,"12.2-12.4":3.30643,"13.0-13.1":0.27253,"13.2":0.13462,"13.3":1.02444,"13.4-13.7":5.45709},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.03749,"12":0.04374,"13":0.25617,"14":2.97405,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.02499,"10.1":0.03124,"11.1":0.12496,"12.1":0.28741,"13.1":3.49263},"edge":{"12":0.00625,"13":0,"14":0,"15":0.01874,"16":0.03124,"17":0.0125,"18":0.07498,"79":0,"80":0,"81":0,"83":0,"84":0.00625,"85":0.4811,"86":1.0934},"android":{"3":0,"4":0.05302,"81":null,"2.1":0,"2.2":0,"2.3":0.00042,"4.1":0.02672,"4.2-4.3":0.01188,"4.4":0,"4.4.3-4.4.4":0.09671},"samsung":{"4":0.12524,"5.0-5.4":0.01044,"6.2-6.4":0,"7.2-7.4":0,"8.2":0,"9.2":0,"10.1":0,"11.1-11.2":0.05218,"12.0":1.29418},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.27491,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.31142},"and_qq":{"10.4":0},"and_uc":{"0":0.00375},"op_mini":{"0":0.19892},"and_chr":{"0":36.85258}},"total":98.73047}

/***/ },
/* 1153 */
/***/ function(module, exports) {

	module.exports = {"id":"AE","name":"United Arab Emirates","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00521,"48":0.00521,"49":0,"50":0,"51":0,"52":0.01043,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0.00521,"65":0.00521,"66":0,"67":0,"68":0.01564,"69":0,"70":0,"71":0,"72":0.00521,"73":0,"74":0,"75":0,"76":0.00521,"77":0.00521,"78":0.03649,"79":0.01043,"80":0.03649,"81":0.68812,"82":0.08341,"83":0.00521,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00521,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0.03649,"36":0,"37":0,"38":0.01564,"39":0,"40":0.00521,"41":0,"42":0,"43":0.00521,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.08341,"50":0,"51":0,"52":0,"53":0.00521,"54":0,"55":0,"56":0.00521,"57":0,"58":0.00521,"59":0,"60":0.00521,"61":0,"62":0,"63":0.01043,"64":0.00521,"65":0.01564,"66":0.00521,"67":0.01564,"68":0.00521,"69":0.02085,"70":0.02607,"71":0.03128,"72":0.03128,"73":0.02085,"74":0.02607,"75":0.02607,"76":0.02607,"77":0.03128,"78":0.0417,"79":0.05213,"80":0.06256,"81":0.07298,"83":0.11469,"84":0.18246,"85":7.67354,"86":10.87953,"87":0.03128,"88":0.01043,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00521,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.00521,"47":0,"48":0,"49":0,"50":0.00521,"51":0.06256,"52":0.00521,"53":0,"54":0.00521,"55":0,"56":0,"57":0,"58":0,"60":0.01043,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00521,"69":0,"70":0.06777,"71":0.33363,"72":0.01564,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":8.10309,"3.2":0.01941,"4.0-4.1":0.01664,"4.2-4.3":0.00277,"5.0-5.1":0.01387,"6.0-6.1":0.00832,"7.0-7.1":0.01941,"8.1-8.4":0.06378,"9.0-9.2":0.03605,"9.3":0.46034,"10.0-10.2":0.07765,"10.3":0.42706,"11.0-11.2":0.16084,"11.3-11.4":0.27454,"12.0-12.1":0.28009,"12.2-12.4":2.79254,"13.0-13.1":0.23017,"13.2":0.1137,"13.3":0.86522,"13.4-13.7":4.60895},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00521,"11":0.01043,"12":0.03128,"13":0.15118,"14":1.09473,"3.1":0,"3.2":0,"5.1":0.02085,"6.1":0,"7.1":0,"9.1":0,"10.1":0.01564,"11.1":0.05734,"12.1":0.13033,"13.1":1.0426},"edge":{"12":0,"13":0.00521,"14":0.00521,"15":0.00521,"16":0.00521,"17":0.02607,"18":0.14075,"79":0,"80":0,"81":0,"83":0,"84":0.01043,"85":0.43268,"86":0.80802},"android":{"3":0,"4":0.03933,"81":null,"2.1":0,"2.2":0,"2.3":0.00031,"4.1":0.01982,"4.2-4.3":0.00881,"4.4":0,"4.4.3-4.4.4":0.07173},"samsung":{"4":0.12231,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.03058,"8.2":0.01019,"9.2":0.06116,"10.1":0.08154,"11.1-11.2":0.1427,"12.0":2.54818},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00555,"9":0.00555,"10":0,"11":1.19832,"5.5":0},"bb":{"7":0,"10":0.00957},"ie_mob":{"10":0,"11":0.01436},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.09095},"and_qq":{"10.4":0.03351},"and_uc":{"0":4.80615},"op_mini":{"0":1.25084},"and_chr":{"0":40.79408}},"total":94.95281}

/***/ },
/* 1154 */
/***/ function(module, exports) {

	module.exports = {"id":"AF","name":"Afghanistan","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0.00334,"5":0.00334,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0.01672,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00334,"30":0,"31":0.00334,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.05349,"39":0,"40":0,"41":0.00334,"42":0,"43":0.00334,"44":0.00334,"45":0,"46":0,"47":0.00669,"48":0.00334,"49":0,"50":0,"51":0,"52":0.00669,"53":0,"54":0,"55":0,"56":0.00334,"57":0.00334,"58":0,"59":0,"60":0.00334,"61":0,"62":0,"63":0,"64":0.02674,"65":0,"66":0,"67":0,"68":0.01337,"69":0.00334,"70":0.00669,"71":0.00334,"72":0.01672,"73":0,"74":0.00334,"75":0,"76":0.00334,"77":0.00334,"78":0.0234,"79":0.01003,"80":0.02006,"81":0.66526,"82":0.10698,"83":0.00334,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0.01003,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0.00334,"25":0.00669,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0.00334,"32":0,"33":0,"34":0.00334,"35":0,"36":0.00334,"37":0.00334,"38":0,"39":0.00334,"40":0.00334,"41":0,"42":0,"43":0.02006,"44":0.00334,"45":0.00334,"46":0.00669,"47":0.00334,"48":0,"49":0.02006,"50":0,"51":0.00334,"52":0.00334,"53":0,"54":0,"55":0.00334,"56":0.00334,"57":0.01337,"58":0.00669,"59":0.00334,"60":0,"61":0.00334,"62":0.01003,"63":0.01672,"64":0.00669,"65":0,"66":0.00334,"67":0.00334,"68":0,"69":0.01003,"70":0.02674,"71":0.01337,"72":0.01003,"73":0.01337,"74":0.01672,"75":0.00334,"76":0.01337,"77":0.01003,"78":0.02006,"79":0.05349,"80":0.07355,"81":0.02674,"83":0.0468,"84":0.14709,"85":2.98196,"86":4.68354,"87":0.01003,"88":0.00334,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.00669,"51":0.03009,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.01003,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.03677,"71":0.29753,"72":0.01003,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00334},"ios_saf":{"8":0,"14":3.30159,"3.2":0.00791,"4.0-4.1":0.00678,"4.2-4.3":0.00113,"5.0-5.1":0.00565,"6.0-6.1":0.00339,"7.0-7.1":0.00791,"8.1-8.4":0.02599,"9.0-9.2":0.01469,"9.3":0.18756,"10.0-10.2":0.03164,"10.3":0.17401,"11.0-11.2":0.06553,"11.3-11.4":0.11186,"12.0-12.1":0.11412,"12.2-12.4":1.13782,"13.0-13.1":0.09378,"13.2":0.04633,"13.3":0.35253,"13.4-13.7":1.8779},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.01337,"13":0.04012,"14":0.10698,"3.1":0,"3.2":0,"5.1":0.01672,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0.00334,"12.1":0.00669,"13.1":0.05349},"edge":{"12":0.00669,"13":0.01337,"14":0.00334,"15":0.00669,"16":0.01337,"17":0.02006,"18":0.14041,"79":0,"80":0,"81":0,"83":0.00334,"84":0.00669,"85":0.11032,"86":0.19055},"android":{"3":0,"4":0.18447,"81":null,"2.1":0,"2.2":0,"2.3":0.00148,"4.1":0.09297,"4.2-4.3":0.04132,"4.4":0,"4.4.3-4.4.4":0.33647},"samsung":{"4":1.52519,"5.0-5.4":0.67674,"6.2-6.4":0.46463,"7.2-7.4":0.64644,"8.2":0.33332,"9.2":0.49493,"10.1":0.21211,"11.1-11.2":0.75754,"12.0":2.18173},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.02365,"9":0.01689,"10":0.00338,"11":0.27032,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.00666},"baidu":{"0":null},"and_ff":{"0":0.0932},"and_qq":{"10.4":0.00666},"and_uc":{"0":2.36989},"op_mini":{"0":1.02099},"and_chr":{"0":66.33238}},"total":96.18187}

/***/ },
/* 1155 */
/***/ function(module, exports) {

	module.exports = {"id":"AG","name":"Antigua and Barbuda","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0.00499,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00499,"30":0,"31":0.01496,"32":0,"33":0,"34":0,"35":0,"36":0.00499,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00499,"48":0.00499,"49":0,"50":0.00499,"51":0,"52":0.04487,"53":0,"54":0.00499,"55":0.00499,"56":0,"57":0,"58":0.01994,"59":0,"60":0,"61":0,"62":0.01994,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0.00997,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0.00499,"78":0.18448,"79":0.00499,"80":0.07479,"81":1.1767,"82":0.09473,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0.01994,"32":0,"33":0,"34":0,"35":0.00997,"36":0.00499,"37":0,"38":0.00997,"39":0,"40":0,"41":0.00499,"42":0.00499,"43":0,"44":0,"45":0,"46":0.00997,"47":0.00997,"48":0,"49":0.07479,"50":0,"51":0,"52":0.01496,"53":0.03989,"54":0,"55":0,"56":0.01994,"57":0.00997,"58":0.00499,"59":0,"60":0,"61":0.00499,"62":0.00499,"63":0.02493,"64":0.00997,"65":0.00499,"66":0,"67":0.01994,"68":0,"69":0.00499,"70":0.0349,"71":0.00499,"72":0,"73":0.00499,"74":0.11468,"75":0.00499,"76":0.01496,"77":0.00997,"78":0.01496,"79":0.01994,"80":0.99221,"81":0.09473,"83":0.05983,"84":0.13961,"85":5.22034,"86":8.14712,"87":0.03989,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.02992,"71":0.10969,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":7.118,"3.2":0.01705,"4.0-4.1":0.01462,"4.2-4.3":0.00244,"5.0-5.1":0.01218,"6.0-6.1":0.00731,"7.0-7.1":0.01705,"8.1-8.4":0.05603,"9.0-9.2":0.03167,"9.3":0.40438,"10.0-10.2":0.06821,"10.3":0.37514,"11.0-11.2":0.14129,"11.3-11.4":0.24116,"12.0-12.1":0.24604,"12.2-12.4":2.45306,"13.0-13.1":0.20219,"13.2":0.09988,"13.3":0.76003,"13.4-13.7":4.04864},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00499,"12":0.00499,"13":0.0698,"14":0.69305,"3.1":0,"3.2":0,"5.1":0.00499,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00499,"11.1":0.01994,"12.1":0.02992,"13.1":1.73513},"edge":{"12":0,"13":0.00997,"14":0.01994,"15":0.00499,"16":0.02493,"17":0.03989,"18":0.34902,"79":0,"80":0,"81":0.00499,"83":0,"84":0.03989,"85":0.81272,"86":1.26146},"android":{"3":0,"4":0.28294,"81":null,"2.1":0,"2.2":0,"2.3":0.00226,"4.1":0.1426,"4.2-4.3":0.06338,"4.4":0,"4.4.3-4.4.4":0.51609},"samsung":{"4":0.0734,"5.0-5.4":0.01049,"6.2-6.4":0.01049,"7.2-7.4":0.10486,"8.2":0.01049,"9.2":0.10486,"10.1":0.10486,"11.1-11.2":0.30408,"12.0":4.7919},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.39389,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.16045},"and_qq":{"10.4":0},"and_uc":{"0":0.14541},"op_mini":{"0":0.06646},"and_chr":{"0":50.91684}},"total":96.71985}

/***/ },
/* 1156 */
/***/ function(module, exports) {

	module.exports = {"id":"AI","name":"Anguilla","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.01354,"69":0,"70":0,"71":0.00902,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0.00451,"78":0.01805,"79":0,"80":0.02256,"81":0.78509,"82":0.01354,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00451,"37":0,"38":0.00902,"39":0,"40":0,"41":0,"42":0.00451,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.00902,"50":0,"51":0,"52":0,"53":0.00902,"54":0,"55":0,"56":0,"57":0,"58":0.05414,"59":0,"60":0,"61":0,"62":0,"63":0.00451,"64":0,"65":0.00451,"66":0.00902,"67":0.00902,"68":0,"69":0,"70":0.00451,"71":0.00451,"72":0,"73":0.16243,"74":0,"75":0.02707,"76":0.00902,"77":0.01354,"78":0,"79":0.01805,"80":0.01354,"81":0.18048,"83":0.00902,"84":0.09926,"85":4.66541,"86":6.16339,"87":0.00902,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.04512,"71":0.20755,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":7.62698,"3.2":0.01827,"4.0-4.1":0.01566,"4.2-4.3":0.00261,"5.0-5.1":0.01305,"6.0-6.1":0.00783,"7.0-7.1":0.01827,"8.1-8.4":0.06003,"9.0-9.2":0.03393,"9.3":0.43329,"10.0-10.2":0.07309,"10.3":0.40197,"11.0-11.2":0.15139,"11.3-11.4":0.25841,"12.0-12.1":0.26363,"12.2-12.4":2.62846,"13.0-13.1":0.21665,"13.2":0.10702,"13.3":0.81438,"13.4-13.7":4.33814},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.00902,"13":0.06317,"14":0.64973,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.20304,"10.1":0,"11.1":0.01354,"12.1":0.10378,"13.1":0.87984},"edge":{"12":0.00902,"13":0.01354,"14":0.00902,"15":0.00451,"16":0.01354,"17":0.01354,"18":0.21206,"79":0,"80":0,"81":0.00451,"83":0,"84":0.01354,"85":1.04678,"86":1.39872},"android":{"3":0,"4":0.18713,"81":null,"2.1":0,"2.2":0,"2.3":0.0015,"4.1":0.09431,"4.2-4.3":0.04192,"4.4":0,"4.4.3-4.4.4":0.34133},"samsung":{"4":0.11396,"5.0-5.4":0,"6.2-6.4":0.01036,"7.2-7.4":1.35718,"8.2":0,"9.2":0.37297,"10.1":0.21756,"11.1-11.2":0.29009,"12.0":3.90579},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.28426,"5.5":0},"bb":{"7":0,"10":0.72442},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.06586},"and_qq":{"10.4":0},"and_uc":{"0":0.03842},"op_mini":{"0":0.10911},"and_chr":{"0":53.81883}},"total":96.73447}

/***/ },
/* 1157 */
/***/ function(module, exports) {

	module.exports = {"id":"AL","name":"Albania","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.01263,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.00947,"53":0,"54":0,"55":0,"56":0.00316,"57":0.00316,"58":0,"59":0,"60":0.00316,"61":0,"62":0,"63":0,"64":0.00316,"65":0,"66":0.00316,"67":0.00316,"68":0.00316,"69":0,"70":0,"71":0.00316,"72":0.00316,"73":0,"74":0,"75":0,"76":0,"77":0.00316,"78":0.01263,"79":0.00316,"80":0.01263,"81":0.38831,"82":0.04736,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00631,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.00316,"46":0.00316,"47":0,"48":0,"49":0.14838,"50":0,"51":0,"52":0,"53":0.01579,"54":0,"55":0.00316,"56":0.00316,"57":0,"58":0.00316,"59":0,"60":0,"61":0.0221,"62":0.00631,"63":0.00631,"64":0,"65":0.00631,"66":0.00316,"67":0.00947,"68":0.00316,"69":0.00316,"70":0.04736,"71":0.0221,"72":0.0442,"73":0.03157,"74":0.0221,"75":0.00947,"76":0.01263,"77":0.01579,"78":0.03157,"79":0.01894,"80":0.02841,"81":0.04104,"83":0.04104,"84":0.1105,"85":2.89181,"86":4.65342,"87":0.00947,"88":0.00631,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.00316,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00631,"52":0,"53":0,"54":0,"55":0,"56":0.00316,"57":0.00316,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0.00316,"67":0,"68":0,"69":0,"70":0.0221,"71":0.18311,"72":0.00316,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":13.33464,"3.2":0.03194,"4.0-4.1":0.02738,"4.2-4.3":0.00456,"5.0-5.1":0.02282,"6.0-6.1":0.01369,"7.0-7.1":0.03194,"8.1-8.4":0.10496,"9.0-9.2":0.05933,"9.3":0.75755,"10.0-10.2":0.12778,"10.3":0.70278,"11.0-11.2":0.26468,"11.3-11.4":0.45179,"12.0-12.1":0.46092,"12.2-12.4":4.59548,"13.0-13.1":0.37877,"13.2":0.1871,"13.3":1.42382,"13.4-13.7":7.58459},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0.00316,"8":0,"9":0,"10":0,"11":0,"12":0.00316,"13":0.02841,"14":0.10102,"3.1":0,"3.2":0,"5.1":0.00631,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00631,"11.1":0.00947,"12.1":0.01579,"13.1":0.10418},"edge":{"12":0,"13":0,"14":0.00316,"15":0.00631,"16":0.00631,"17":0.00631,"18":0.0221,"79":0,"80":0,"81":0,"83":0,"84":0.00316,"85":0.11365,"86":0.17995},"android":{"3":0,"4":0.03696,"81":null,"2.1":0,"2.2":0,"2.3":0.0003,"4.1":0.01863,"4.2-4.3":0.00828,"4.4":0,"4.4.3-4.4.4":0.06741},"samsung":{"4":0.26243,"5.0-5.4":0.01009,"6.2-6.4":0.02019,"7.2-7.4":0.13121,"8.2":0.03028,"9.2":0.1514,"10.1":0.12112,"11.1-11.2":0.3028,"12.0":4.20896},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0.00316,"8":0.00631,"9":0,"10":0,"11":0.03157,"5.5":0},"bb":{"7":0,"10":0.00684},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.17108},"and_qq":{"10.4":0},"and_uc":{"0":0.03422},"op_mini":{"0":0.11013},"and_chr":{"0":52.10126}},"total":98.04901}

/***/ },
/* 1158 */
/***/ function(module, exports) {

	module.exports = {"id":"AM","name":"Armenia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0.00821,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0.02463,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":31.30913,"53":0,"54":0,"55":0,"56":0.00821,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0.00821,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0,"72":0.00821,"73":0,"74":0,"75":0,"76":0.00821,"77":0,"78":0.01642,"79":0.00821,"80":0.02463,"81":0.9112,"82":0.10672,"83":0.00821,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00821,"23":0,"24":0.00821,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00821,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.87015,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0.02463,"57":0.00821,"58":0.04925,"59":0,"60":0.00821,"61":0,"62":0,"63":0.00821,"64":0.00821,"65":0,"66":0,"67":0.00821,"68":0,"69":0.00821,"70":0.01642,"71":0.04925,"72":0.06567,"73":0.02463,"74":0.02463,"75":0.03284,"76":0.02463,"77":0.02463,"78":0.05746,"79":0.0903,"80":0.12314,"81":0.06567,"83":0.18881,"84":0.22985,"85":10.77842,"86":17.27174,"87":0.00821,"88":0.01642,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.0903,"71":0.77165,"72":0.03284,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":3.51087,"3.2":0.00841,"4.0-4.1":0.00721,"4.2-4.3":0.0012,"5.0-5.1":0.00601,"6.0-6.1":0.0036,"7.0-7.1":0.00841,"8.1-8.4":0.02764,"9.0-9.2":0.01562,"9.3":0.19945,"10.0-10.2":0.03364,"10.3":0.18504,"11.0-11.2":0.06969,"11.3-11.4":0.11895,"12.0-12.1":0.12135,"12.2-12.4":1.20994,"13.0-13.1":0.09973,"13.2":0.04926,"13.3":0.37488,"13.4-13.7":1.99694},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00821,"12":0.00821,"13":0.04105,"14":0.49254,"3.1":0,"3.2":0,"5.1":0.60747,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0.00821,"12.1":0.02463,"13.1":0.50075},"edge":{"12":0,"13":0,"14":0.00821,"15":0.00821,"16":0,"17":0.00821,"18":0.03284,"79":0,"80":0,"81":0,"83":0,"84":0.00821,"85":0.23806,"86":0.47612},"android":{"3":0,"4":0.01606,"81":null,"2.1":0,"2.2":0,"2.3":0.00013,"4.1":0.00809,"4.2-4.3":0.0036,"4.4":0,"4.4.3-4.4.4":0.02929},"samsung":{"4":0.03035,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.03035,"8.2":0.01012,"9.2":0.03035,"10.1":0.03035,"11.1-11.2":0.08092,"12.0":1.05202},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01642,"9":0,"10":0,"11":0.06567,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.01791},"and_qq":{"10.4":0.00179},"and_uc":{"0":0.13612},"op_mini":{"0":0.11869},"and_chr":{"0":21.81557}},"total":97.4682}

/***/ },
/* 1159 */
/***/ function(module, exports) {

	module.exports = {"id":"AO","name":"Angola","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0.00588,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00588,"30":0,"31":0.00588,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00588,"39":0,"40":0.00588,"41":0.01764,"42":0,"43":0.00588,"44":0.00588,"45":0.00588,"46":0,"47":0.01176,"48":0.00588,"49":0,"50":0,"51":0,"52":0.02352,"53":0,"54":0,"55":0,"56":0,"57":0.01176,"58":0,"59":0.00588,"60":0.01176,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0.00588,"67":0,"68":0.04705,"69":0,"70":0,"71":0.00588,"72":0.02352,"73":0,"74":0.00588,"75":0,"76":0,"77":0.00588,"78":0.0941,"79":0.01764,"80":0.10586,"81":1.26442,"82":0.16467,"83":0.00588,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00588,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0.00588,"26":0.02352,"27":0,"28":0.00588,"29":0,"30":0,"31":0.00588,"32":0,"33":0.00588,"34":0,"35":0.01176,"36":0.01176,"37":0,"38":0.00588,"39":0,"40":0.05293,"41":0,"42":0.02352,"43":0.11174,"44":0,"45":0,"46":0.03529,"47":0.01764,"48":0,"49":0.05293,"50":0.00588,"51":0,"52":0,"53":0.01176,"54":0.00588,"55":0.01176,"56":0.01176,"57":0.01764,"58":0.01176,"59":0.01176,"60":0.00588,"61":0.00588,"62":0.01176,"63":0.15879,"64":0.01176,"65":0.03529,"66":0.04117,"67":0.01764,"68":0.00588,"69":0.02941,"70":0.02352,"71":0.04705,"72":0.03529,"73":0.04117,"74":0.05293,"75":0.04705,"76":0.04117,"77":0.04705,"78":0.02352,"79":0.18231,"80":0.27641,"81":0.08822,"83":0.14114,"84":0.27053,"85":7.42182,"86":11.72083,"87":0.01764,"88":0.00588,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0.00588,"32":0,"33":0,"34":0.00588,"35":0.00588,"36":0.00588,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0.01176,"43":0,"44":0,"45":0,"46":0,"47":0.00588,"48":0.00588,"49":0,"50":0.01176,"51":0.03529,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00588,"62":0,"63":0,"64":0,"65":0,"66":0.00588,"67":0.00588,"68":0.01176,"69":0.00588,"70":0.18231,"71":1.41144,"72":0.04117,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.02352},"ios_saf":{"8":0,"14":4.16274,"3.2":0.00997,"4.0-4.1":0.00855,"4.2-4.3":0.00142,"5.0-5.1":0.00712,"6.0-6.1":0.00427,"7.0-7.1":0.00997,"8.1-8.4":0.03277,"9.0-9.2":0.01852,"9.3":0.23649,"10.0-10.2":0.03989,"10.3":0.21939,"11.0-11.2":0.08263,"11.3-11.4":0.14104,"12.0-12.1":0.14389,"12.2-12.4":1.43459,"13.0-13.1":0.11824,"13.2":0.05841,"13.3":0.44448,"13.4-13.7":2.36772},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0.07645,"9":0,"10":0.00588,"11":0.00588,"12":0.01176,"13":0.12938,"14":0.7116,"3.1":0,"3.2":0,"5.1":0.01764,"6.1":0,"7.1":0,"9.1":0.01176,"10.1":0.06469,"11.1":0.04117,"12.1":0.15879,"13.1":0.82334},"edge":{"12":0.05293,"13":0.03529,"14":0.04705,"15":0.02352,"16":0.01764,"17":0.05293,"18":0.69396,"79":0,"80":0,"81":0.00588,"83":0.01176,"84":0.02352,"85":1.23501,"86":1.79371},"android":{"3":0,"4":0.2872,"81":null,"2.1":0,"2.2":0,"2.3":0.0023,"4.1":0.14475,"4.2-4.3":0.06433,"4.4":0,"4.4.3-4.4.4":0.52386},"samsung":{"4":0.62295,"5.0-5.4":0.04085,"6.2-6.4":0.04085,"7.2-7.4":0.1634,"8.2":0.03064,"9.2":0.19403,"10.1":0.15318,"11.1-11.2":0.1634,"12.0":1.55227},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.06821,"9":0.02274,"10":0.00758,"11":0.6366,"5.5":0},"bb":{"7":0,"10":0.01648},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.14417},"and_qq":{"10.4":0.07002},"and_uc":{"0":0.39542},"op_mini":{"0":2.9715},"and_chr":{"0":46.33977}},"total":95.19141}

/***/ },
/* 1160 */
/***/ function(module, exports) {

	module.exports = {"id":"AR","name":"Argentina","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00543,"49":0,"50":0,"51":0,"52":0.04342,"53":0,"54":0.00543,"55":0,"56":0,"57":0,"58":0,"59":0.00543,"60":0.00543,"61":0,"62":0,"63":0.00543,"64":0,"65":0.00543,"66":0.01085,"67":0,"68":0.01628,"69":0.00543,"70":0.00543,"71":0,"72":0.00543,"73":0.00543,"74":0,"75":0.00543,"76":0.00543,"77":0.00543,"78":0.04342,"79":0.01085,"80":0.02714,"81":0.96601,"82":0.15738,"83":0.00543,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00543,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0.00543,"33":0,"34":0.00543,"35":0,"36":0,"37":0,"38":0.01085,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.25507,"50":0,"51":0,"52":0,"53":0.00543,"54":0,"55":0,"56":0.04342,"57":0,"58":0.01085,"59":0,"60":0.00543,"61":0.01628,"62":0,"63":0.01085,"64":0,"65":0.01628,"66":0.02171,"67":0.01628,"68":0.00543,"69":0.01085,"70":0.02171,"71":0.02714,"72":0.02171,"73":0.02171,"74":0.02171,"75":0.02171,"76":0.02171,"77":0.02714,"78":0.03799,"79":0.07598,"80":0.09769,"81":0.09226,"83":0.11397,"84":0.22251,"85":8.98711,"86":14.24588,"87":0.01628,"88":0.00543,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00543,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00543,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.04884,"71":0.56441,"72":0.01085,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":2.50628,"3.2":0.006,"4.0-4.1":0.00515,"4.2-4.3":0.00086,"5.0-5.1":0.00429,"6.0-6.1":0.00257,"7.0-7.1":0.006,"8.1-8.4":0.01973,"9.0-9.2":0.01115,"9.3":0.14238,"10.0-10.2":0.02402,"10.3":0.13209,"11.0-11.2":0.04975,"11.3-11.4":0.08492,"12.0-12.1":0.08663,"12.2-12.4":0.86373,"13.0-13.1":0.07119,"13.2":0.03517,"13.3":0.26761,"13.4-13.7":1.42555},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00543,"12":0.01628,"13":0.04342,"14":0.29849,"3.1":0,"3.2":0,"5.1":0.45587,"6.1":0,"7.1":0,"9.1":0,"10.1":0.01085,"11.1":0.03256,"12.1":0.04884,"13.1":0.27678},"edge":{"12":0,"13":0.00543,"14":0.00543,"15":0.01628,"16":0.00543,"17":0.01085,"18":0.04884,"79":0,"80":0,"81":0,"83":0,"84":0.00543,"85":0.30391,"86":0.56984},"android":{"3":0,"4":0.03186,"81":null,"2.1":0,"2.2":0,"2.3":0.00025,"4.1":0.01606,"4.2-4.3":0.00714,"4.4":0,"4.4.3-4.4.4":0.05811},"samsung":{"4":0.18288,"5.0-5.4":0.01016,"6.2-6.4":0,"7.2-7.4":0.1016,"8.2":0.02032,"9.2":0.09144,"10.1":0.0508,"11.1-11.2":0.13208,"12.0":1.93043},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.02221,"9":0.00555,"10":0.00555,"11":0.20547,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.09146},"and_qq":{"10.4":0.00915},"and_uc":{"0":0.03201},"op_mini":{"0":0.15153},"and_chr":{"0":60.6928}},"total":98.26488}

/***/ },
/* 1161 */
/***/ function(module, exports) {

	module.exports = {"id":"AS","name":"American Samoa","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00646,"49":0,"50":0,"51":0,"52":0.00646,"53":0,"54":0,"55":0,"56":0.00646,"57":0.01939,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0.01292,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0.07108,"79":0,"80":0.00646,"81":0.56866,"82":0.09047,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.00646,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.01292,"47":0,"48":0,"49":0.53635,"50":0,"51":0,"52":0,"53":0.00646,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0.01292,"62":0,"63":0,"64":0,"65":0.00646,"66":0.01292,"67":0,"68":0.00646,"69":0.01292,"70":0,"71":0,"72":0.03231,"73":0,"74":0.00646,"75":0.29079,"76":0.88529,"77":0.01292,"78":0,"79":0.06462,"80":0.10985,"81":0.05816,"83":0.04523,"84":0.11632,"85":11.32789,"86":17.70588,"87":0.01939,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.02585,"71":0.20032,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":8.47435,"3.2":0.0203,"4.0-4.1":0.0174,"4.2-4.3":0.0029,"5.0-5.1":0.0145,"6.0-6.1":0.0087,"7.0-7.1":0.0203,"8.1-8.4":0.0667,"9.0-9.2":0.0377,"9.3":0.48143,"10.0-10.2":0.08121,"10.3":0.44663,"11.0-11.2":0.16821,"11.3-11.4":0.28712,"12.0-12.1":0.29292,"12.2-12.4":2.92049,"13.0-13.1":0.24072,"13.2":0.11891,"13.3":0.90486,"13.4-13.7":4.82011},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.01292,"11":0.00646,"12":0.01292,"13":0.06462,"14":1.105,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.01939,"11.1":0.05816,"12.1":0.30371,"13.1":1.05977},"edge":{"12":0,"13":0,"14":0.00646,"15":0.01292,"16":0.01292,"17":0,"18":0.25848,"79":0,"80":0,"81":0.01292,"83":0,"84":0,"85":1.7512,"86":1.86106},"android":{"3":0,"4":0.07822,"81":null,"2.1":0,"2.2":0,"2.3":0.00063,"4.1":0.03943,"4.2-4.3":0.01752,"4.4":0,"4.4.3-4.4.4":0.14268},"samsung":{"4":0,"5.0-5.4":0,"6.2-6.4":0.02071,"7.2-7.4":0.04143,"8.2":0,"9.2":0.1657,"10.1":0,"11.1-11.2":0.20713,"12.0":1.12883},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0.05928,"11":0.28321,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.11322},"and_qq":{"10.4":0.12029},"and_uc":{"0":0.15921},"op_mini":{"0":0.32491},"and_chr":{"0":37.01606}},"total":98.20634}

/***/ },
/* 1162 */
/***/ function(module, exports) {

	module.exports = {"id":"AT","name":"Austria","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00604,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0.00604,"45":0,"46":0,"47":0,"48":0.01812,"49":0,"50":0,"51":0.00604,"52":0.07249,"53":0,"54":0,"55":0,"56":0.00604,"57":0.00604,"58":0.00604,"59":0.00604,"60":0.04833,"61":0.01208,"62":0.01812,"63":0.00604,"64":0.00604,"65":0.00604,"66":0.03625,"67":0.00604,"68":0.15103,"69":0.01208,"70":0.01208,"71":0.00604,"72":0.02416,"73":0.01208,"74":0.01208,"75":0.01208,"76":0.01812,"77":0.03021,"78":0.35642,"79":0.04833,"80":0.16311,"81":4.34348,"82":0.61014,"83":0.00604,"84":0.00604,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00604,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.00604,"35":0,"36":0,"37":0,"38":0.01812,"39":0,"40":0.00604,"41":0,"42":0.00604,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.18123,"50":0,"51":0.00604,"52":0,"53":0.02416,"54":0,"55":0,"56":0,"57":0,"58":0.00604,"59":0.00604,"60":0.00604,"61":0.00604,"62":0,"63":0.02416,"64":0.07249,"65":0.00604,"66":0,"67":0.01812,"68":0.01208,"69":0.02416,"70":0.1027,"71":0.02416,"72":0.10874,"73":0.01812,"74":0.01812,"75":0.01812,"76":0.01812,"77":0.02416,"78":0.03625,"79":0.21748,"80":0.15707,"81":0.1027,"83":0.12686,"84":0.27789,"85":7.31565,"86":10.24554,"87":0.01208,"88":0.00604,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.01208,"52":0,"53":0.00604,"54":0,"55":0,"56":0,"57":0.00604,"58":0,"60":0,"62":0,"63":0.00604,"64":0,"65":0,"66":0,"67":0.00604,"68":0.03625,"69":0,"70":0.12082,"71":1.15383,"72":0.02416,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":9.84853,"3.2":0.02359,"4.0-4.1":0.02022,"4.2-4.3":0.00337,"5.0-5.1":0.01685,"6.0-6.1":0.01011,"7.0-7.1":0.02359,"8.1-8.4":0.07752,"9.0-9.2":0.04382,"9.3":0.5595,"10.0-10.2":0.09437,"10.3":0.51905,"11.0-11.2":0.19549,"11.3-11.4":0.33368,"12.0-12.1":0.34042,"12.2-12.4":3.39407,"13.0-13.1":0.27975,"13.2":0.13819,"13.3":1.05159,"13.4-13.7":5.60173},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0.00604,"9":0,"10":0.00604,"11":0.03021,"12":0.05437,"13":0.25372,"14":1.72169,"3.1":0,"3.2":0,"5.1":0.00604,"6.1":0.00604,"7.1":0,"9.1":0.01812,"10.1":0.03021,"11.1":0.14498,"12.1":0.18727,"13.1":1.75189},"edge":{"12":0,"13":0,"14":0.00604,"15":0.00604,"16":0.01812,"17":0.09062,"18":0.39267,"79":0,"80":0.00604,"81":0.00604,"83":0.00604,"84":0.03021,"85":1.01489,"86":1.915},"android":{"3":0,"4":0.06642,"81":null,"2.1":0,"2.2":0,"2.3":0.00053,"4.1":0.03348,"4.2-4.3":0.01488,"4.4":0,"4.4.3-4.4.4":0.12115},"samsung":{"4":0.18559,"5.0-5.4":0,"6.2-6.4":0.01031,"7.2-7.4":0.03093,"8.2":0.01031,"9.2":0.06186,"10.1":0.05155,"11.1-11.2":0.15465,"12.0":3.83543},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00631,"9":0.01262,"10":0,"11":0.97179,"5.5":0},"bb":{"7":0,"10":0.00396},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.47904},"and_qq":{"10.4":0.00396},"and_uc":{"0":0.05939},"op_mini":{"0":0.22489},"and_chr":{"0":33.34836}},"total":96.70255}

/***/ },
/* 1163 */
/***/ function(module, exports) {

	module.exports = {"id":"AU","name":"Australia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.01161,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.0058,"49":0,"50":0,"51":0,"52":0.02902,"53":0,"54":0,"55":0,"56":0.0058,"57":0,"58":0,"59":0,"60":0.0058,"61":0,"62":0,"63":0.0058,"64":0.0058,"65":0.0058,"66":0.01161,"67":0.0058,"68":0.03482,"69":0,"70":0.0058,"71":0,"72":0.01161,"73":0.0058,"74":0.0058,"75":0.0058,"76":0.0058,"77":0.01161,"78":0.07545,"79":0.01741,"80":0.08126,"81":1.31751,"82":0.20894,"83":0.0058,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0.0058,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.0058,"35":0,"36":0,"37":0,"38":0.02902,"39":0,"40":0.01161,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.0058,"48":0.0058,"49":0.16832,"50":0,"51":0,"52":0,"53":0.02902,"54":0,"55":0.0058,"56":0.0058,"57":0.0058,"58":0.0058,"59":0.01161,"60":0.0058,"61":0.0058,"62":0.0058,"63":0.01161,"64":0.01161,"65":0.03482,"66":0.01161,"67":0.03482,"68":0.02322,"69":0.03482,"70":0.04063,"71":0.04063,"72":0.04643,"73":0.06965,"74":0.06384,"75":0.05224,"76":0.04643,"77":0.05804,"78":0.06965,"79":0.10447,"80":0.20314,"81":0.1451,"83":0.36565,"84":0.60362,"85":8.1256,"86":10.08735,"87":0.01161,"88":0.0058,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.01741,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.0058,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.02902,"71":0.16251,"72":0.0058,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":15.66248,"3.2":0.03752,"4.0-4.1":0.03216,"4.2-4.3":0.00536,"5.0-5.1":0.0268,"6.0-6.1":0.01608,"7.0-7.1":0.03752,"8.1-8.4":0.12328,"9.0-9.2":0.06968,"9.3":0.88979,"10.0-10.2":0.15009,"10.3":0.82547,"11.0-11.2":0.31089,"11.3-11.4":0.53066,"12.0-12.1":0.54138,"12.2-12.4":5.39771,"13.0-13.1":0.4449,"13.2":0.21977,"13.3":1.67238,"13.4-13.7":8.90864},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0.0058,"9":0,"10":0.0058,"11":0.02322,"12":0.04643,"13":0.26698,"14":1.64834,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.01741,"10.1":0.05224,"11.1":0.11608,"12.1":0.22055,"13.1":2.7627},"edge":{"12":0,"13":0,"14":0.0058,"15":0.01161,"16":0.01161,"17":0.02902,"18":0.25538,"79":0,"80":0.0058,"81":0.0058,"83":0.0058,"84":0.01741,"85":0.75452,"86":1.41037},"android":{"3":0,"4":0.06696,"81":null,"2.1":0,"2.2":0,"2.3":0.00054,"4.1":0.03375,"4.2-4.3":0.015,"4.4":0,"4.4.3-4.4.4":0.12214},"samsung":{"4":0.14896,"5.0-5.4":0,"6.2-6.4":0.01064,"7.2-7.4":0.02128,"8.2":0.01064,"9.2":0.06384,"10.1":0.0532,"11.1-11.2":0.11704,"12.0":2.84084},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0.00917,"10":0,"11":0.90786,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.30631},"and_qq":{"10.4":0.1049},"and_uc":{"0":0.16784},"op_mini":{"0":0.21849},"and_chr":{"0":25.81859}},"total":97.34178}

/***/ },
/* 1164 */
/***/ function(module, exports) {

	module.exports = {"id":"AW","name":"Aruba","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.01119,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00373,"49":0,"50":0,"51":0,"52":0.00373,"53":0,"54":0,"55":0,"56":0.00373,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.01492,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0.00373,"77":0.00746,"78":0.02237,"79":0.00373,"80":0.01119,"81":0.47731,"82":0.06339,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00746,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.01865,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.01865,"50":0,"51":0,"52":0,"53":0.01492,"54":0.01119,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0.00373,"64":0,"65":0.00373,"66":0,"67":0.00746,"68":0.00746,"69":0,"70":0.01492,"71":0.00746,"72":0.00373,"73":0.00373,"74":0.00746,"75":0.00373,"76":0.02237,"77":0.00373,"78":0.01492,"79":0.00373,"80":0.03356,"81":0.01492,"83":0.07085,"84":0.11933,"85":2.79302,"86":4.58667,"87":0.01119,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.00373,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.01865,"71":0.0895,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":9.26633,"3.2":0.0222,"4.0-4.1":0.01903,"4.2-4.3":0.00317,"5.0-5.1":0.01586,"6.0-6.1":0.00951,"7.0-7.1":0.0222,"8.1-8.4":0.07294,"9.0-9.2":0.04123,"9.3":0.52642,"10.0-10.2":0.08879,"10.3":0.48837,"11.0-11.2":0.18393,"11.3-11.4":0.31395,"12.0-12.1":0.32029,"12.2-12.4":3.19343,"13.0-13.1":0.26321,"13.2":0.13002,"13.3":0.98942,"13.4-13.7":5.27058},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.01865,"11":0.00373,"12":0.00746,"13":0.04102,"14":0.54443,"3.1":0,"3.2":0,"5.1":0.00746,"6.1":0,"7.1":0,"9.1":0,"10.1":0.0261,"11.1":0.05966,"12.1":0.09323,"13.1":0.89496},"edge":{"12":0,"13":0,"14":0.01119,"15":0.00373,"16":0.01492,"17":0.01865,"18":0.33188,"79":0,"80":0,"81":0,"83":0,"84":0.01492,"85":0.52952,"86":0.99937},"android":{"3":0,"4":0.07375,"81":null,"2.1":0,"2.2":0,"2.3":0.00059,"4.1":0.03717,"4.2-4.3":0.01652,"4.4":0,"4.4.3-4.4.4":0.13452},"samsung":{"4":0.21974,"5.0-5.4":0,"6.2-6.4":0.03139,"7.2-7.4":0.10464,"8.2":0.05232,"9.2":0.41856,"10.1":0.1151,"11.1-11.2":0.72201,"12.0":10.86151},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.79801,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.22576},"and_qq":{"10.4":0.00627},"and_uc":{"0":0.00627},"op_mini":{"0":0.0475},"and_chr":{"0":48.00351}},"total":95.28383}

/***/ },
/* 1165 */
/***/ function(module, exports) {

	module.exports = {"id":"AX","name":"Aland Islands","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.03364,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.04037,"49":0,"50":0,"51":0,"52":0.01346,"53":0,"54":0,"55":0,"56":0,"57":0.00673,"58":0,"59":0,"60":0,"61":0.01346,"62":0,"63":0,"64":0,"65":0.00673,"66":0,"67":0,"68":0.00673,"69":0,"70":0,"71":0,"72":0.00673,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0.01346,"79":0.00673,"80":0.01346,"81":1.76274,"82":0.99574,"83":0.01346,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00673,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.11438,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0.02018,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00673,"69":0,"70":0,"71":0,"72":0.00673,"73":0,"74":0.00673,"75":0,"76":0.0471,"77":0,"78":0.01346,"79":0,"80":0.02018,"81":0.04037,"83":0.02018,"84":0.16147,"85":3.71386,"86":24.35536,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0.12783,"72":0.00673,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":10.41212,"3.2":0.02494,"4.0-4.1":0.02138,"4.2-4.3":0.00356,"5.0-5.1":0.01782,"6.0-6.1":0.01069,"7.0-7.1":0.02494,"8.1-8.4":0.08196,"9.0-9.2":0.04632,"9.3":0.59152,"10.0-10.2":0.09977,"10.3":0.54876,"11.0-11.2":0.20667,"11.3-11.4":0.35277,"12.0-12.1":0.3599,"12.2-12.4":3.5883,"13.0-13.1":0.29576,"13.2":0.1461,"13.3":1.11177,"13.4-13.7":5.92229},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0.00673,"9":0,"10":0.00673,"11":0.01346,"12":0.0471,"13":0.27585,"14":2.38844,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.04037,"10.1":0.08074,"11.1":0.02018,"12.1":0.05382,"13.1":3.27654},"edge":{"12":0,"13":0,"14":0,"15":0,"16":0,"17":0.0471,"18":0.16147,"79":0,"80":0,"81":0,"83":0,"84":0.01346,"85":0.06055,"86":2.91995},"android":{"3":0,"4":0.02906,"81":null,"2.1":0,"2.2":0,"2.3":0.00023,"4.1":0.01465,"4.2-4.3":0.00651,"4.4":0,"4.4.3-4.4.4":0.05301},"samsung":{"4":0,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.14269,"8.2":0.05488,"9.2":0.02195,"10.1":0.03293,"11.1-11.2":0.02195,"12.0":2.14033},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0.09419,"10":0,"11":0.3835,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.16033},"and_qq":{"10.4":0},"and_uc":{"0":0.28139},"op_mini":{"0":0.32216},"and_chr":{"0":28.73542}},"total":97.37647}

/***/ },
/* 1166 */
/***/ function(module, exports) {

	module.exports = {"id":"AZ","name":"Azerbaijan","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00535,"48":0.09088,"49":0,"50":0,"51":0,"52":0.01604,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00535,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0.00535,"77":0.00535,"78":0.01069,"79":0,"80":0.02673,"81":0.34214,"82":0.06415,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0.00535,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.02138,"23":0,"24":0,"25":0,"26":0.00535,"27":0,"28":0,"29":0.00535,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.01069,"39":0.00535,"40":0.00535,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.10157,"50":0,"51":0.00535,"52":0.00535,"53":0.04277,"54":0,"55":0.00535,"56":0.00535,"57":0.01069,"58":0.00535,"59":0.00535,"60":0,"61":0,"62":0,"63":0.02673,"64":0.00535,"65":0.01069,"66":0.01069,"67":0.00535,"68":0.01069,"69":0.01069,"70":0.02138,"71":0.03742,"72":0.02673,"73":0.01604,"74":0.07484,"75":0.03742,"76":0.05346,"77":0.0695,"78":0.03208,"79":0.08554,"80":0.19246,"81":0.11227,"83":0.10692,"84":0.24057,"85":8.00831,"86":12.93197,"87":0.01604,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00535,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00535,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00535,"44":0,"45":0.00535,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.01604,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0.02673,"60":0.03742,"62":0.02138,"63":0.00535,"64":0,"65":0,"66":0,"67":0.00535,"68":0.02673,"69":0.00535,"70":1.14939,"71":0.79655,"72":0.03208,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00535},"ios_saf":{"8":0,"14":5.84081,"3.2":0.01399,"4.0-4.1":0.01199,"4.2-4.3":0.002,"5.0-5.1":0.00999,"6.0-6.1":0.006,"7.0-7.1":0.01399,"8.1-8.4":0.04597,"9.0-9.2":0.02599,"9.3":0.33182,"10.0-10.2":0.05597,"10.3":0.30783,"11.0-11.2":0.11594,"11.3-11.4":0.19789,"12.0-12.1":0.20189,"12.2-12.4":2.0129,"13.0-13.1":0.16591,"13.2":0.08196,"13.3":0.62366,"13.4-13.7":3.32218},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.01069,"13":0.14434,"14":0.24057,"3.1":0,"3.2":0,"5.1":0.08019,"6.1":0,"7.1":0,"9.1":0.03742,"10.1":0.00535,"11.1":0.02138,"12.1":0.05881,"13.1":0.37957},"edge":{"12":0.00535,"13":0,"14":0.00535,"15":0.00535,"16":0.00535,"17":0.00535,"18":0.10692,"79":0,"80":0,"81":0,"83":0,"84":0.00535,"85":0.13365,"86":0.35284},"android":{"3":0,"4":0.06775,"81":null,"2.1":0,"2.2":0,"2.3":0.00054,"4.1":0.03415,"4.2-4.3":0.01518,"4.4":0,"4.4.3-4.4.4":0.12358},"samsung":{"4":0.54049,"5.0-5.4":0.0102,"6.2-6.4":0.03059,"7.2-7.4":0.09178,"8.2":0.0102,"9.2":0.11218,"10.1":0.09178,"11.1-11.2":0.24475,"12.0":2.80443},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.04594,"9":0.02297,"10":0.00574,"11":0.08039,"5.5":0},"bb":{"7":0,"10":0.00465},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.00465},"baidu":{"0":null},"and_ff":{"0":0.04189},"and_qq":{"10.4":0.00931},"and_uc":{"0":0.37232},"op_mini":{"0":0.52873},"and_chr":{"0":50.49934}},"total":95.89628}

/***/ },
/* 1167 */
/***/ function(module, exports) {

	module.exports = {"id":"BA","name":"Bosnia and Herzegovina","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0.00297,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00297,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.02374,"46":0,"47":0,"48":0,"49":0,"50":0.0089,"51":0.00297,"52":0.05044,"53":0,"54":0,"55":0,"56":0.00297,"57":0.00297,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0.00297,"67":0,"68":0.0089,"69":0,"70":0,"71":0,"72":0.00297,"73":0,"74":0.00297,"75":0,"76":0.00297,"77":0.00297,"78":0.0178,"79":0.00297,"80":0.02077,"81":0.68538,"82":0.09494,"83":0.00297,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00297,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0.00297,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00297,"39":0,"40":0,"41":0,"42":0,"43":0.00297,"44":0,"45":0,"46":0,"47":0.00297,"48":0,"49":0.03857,"50":0.00297,"51":0,"52":0,"53":0.00297,"54":0,"55":0,"56":0,"57":0,"58":0.00297,"59":0,"60":0,"61":0.0178,"62":0,"63":0.00297,"64":0,"65":0.00297,"66":0.00297,"67":0.0089,"68":0.00297,"69":0.00297,"70":0.0089,"71":0.0089,"72":0.0089,"73":0.00297,"74":0.00297,"75":0.00297,"76":0.00593,"77":0.00593,"78":0.01187,"79":0.0178,"80":0.42428,"81":0.03857,"83":0.0267,"84":0.05637,"85":2.16591,"86":3.45062,"87":0.00297,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00297,"37":0,"38":0,"39":0,"40":0.00297,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0.00297,"54":0,"55":0,"56":0.01187,"57":0,"58":0,"60":0.00297,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.0267,"71":0.15725,"72":0.00297,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":3.43458,"3.2":0.00823,"4.0-4.1":0.00705,"4.2-4.3":0.00118,"5.0-5.1":0.00588,"6.0-6.1":0.00353,"7.0-7.1":0.00823,"8.1-8.4":0.02703,"9.0-9.2":0.01528,"9.3":0.19512,"10.0-10.2":0.03291,"10.3":0.18101,"11.0-11.2":0.06817,"11.3-11.4":0.11637,"12.0-12.1":0.11872,"12.2-12.4":1.18365,"13.0-13.1":0.09756,"13.2":0.04819,"13.3":0.36673,"13.4-13.7":1.95355},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.00297,"13":0.01187,"14":0.10088,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00297,"11.1":0.01187,"12.1":0.0089,"13.1":0.09791},"edge":{"12":0,"13":0.00297,"14":0.00297,"15":0.01484,"16":0.00297,"17":0.00593,"18":0.06231,"79":0,"80":0,"81":0,"83":0.00297,"84":0.00297,"85":0.15428,"86":0.19582},"android":{"3":0,"4":0.08013,"81":null,"2.1":0,"2.2":0,"2.3":0.00064,"4.1":0.04039,"4.2-4.3":0.01795,"4.4":0,"4.4.3-4.4.4":0.14616},"samsung":{"4":0.11116,"5.0-5.4":0,"6.2-6.4":0.02021,"7.2-7.4":0.03032,"8.2":0.03032,"9.2":0.13137,"10.1":0.11116,"11.1-11.2":0.1718,"12.0":4.59808},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.18099,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.14769},"and_qq":{"10.4":0},"and_uc":{"0":0.01407},"op_mini":{"0":0.23304},"and_chr":{"0":76.0347}},"total":98.16217}

/***/ },
/* 1168 */
/***/ function(module, exports) {

	module.exports = {"id":"BB","name":"Barbados","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00584,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00584,"49":0,"50":0,"51":0,"52":0.00584,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0.00584,"65":0,"66":0,"67":0,"68":0.01168,"69":0.00584,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0.00584,"77":0.00584,"78":0.07595,"79":0.00584,"80":0.06426,"81":1.36119,"82":0.1811,"83":0.00584,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.05842,"50":0,"51":0,"52":0,"53":0.02337,"54":0,"55":0.01168,"56":0.00584,"57":0,"58":0.00584,"59":0.00584,"60":0,"61":0,"62":0,"63":0.00584,"64":0,"65":0.07595,"66":0.00584,"67":0.00584,"68":0.02337,"69":0.00584,"70":0.01168,"71":0.00584,"72":0.00584,"73":0.00584,"74":0.05258,"75":0.01753,"76":0.03505,"77":0.00584,"78":0.00584,"79":0.05258,"80":0.08179,"81":0.04674,"83":0.05258,"84":0.11684,"85":7.83412,"86":11.70153,"87":0.02921,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.08763,"71":0.42062,"72":0.01168,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":6.47812,"3.2":0.01552,"4.0-4.1":0.0133,"4.2-4.3":0.00222,"5.0-5.1":0.01109,"6.0-6.1":0.00665,"7.0-7.1":0.01552,"8.1-8.4":0.05099,"9.0-9.2":0.02882,"9.3":0.36802,"10.0-10.2":0.06208,"10.3":0.34142,"11.0-11.2":0.12859,"11.3-11.4":0.21948,"12.0-12.1":0.22392,"12.2-12.4":2.23254,"13.0-13.1":0.18401,"13.2":0.0909,"13.3":0.69171,"13.4-13.7":3.68468},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.01753,"12":0.02337,"13":0.09347,"14":1.53645,"3.1":0,"3.2":0,"5.1":0.01753,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00584,"11.1":0.08179,"12.1":0.05258,"13.1":1.33782},"edge":{"12":0.01168,"13":0.00584,"14":0.00584,"15":0.02921,"16":0.04674,"17":0.04089,"18":0.222,"79":0,"80":0,"81":0.00584,"83":0,"84":0.01753,"85":1.48387,"86":2.7399},"android":{"3":0,"4":0.48312,"81":null,"2.1":0,"2.2":0,"2.3":0.00386,"4.1":0.24349,"4.2-4.3":0.10822,"4.4":0,"4.4.3-4.4.4":0.88122},"samsung":{"4":0.22693,"5.0-5.4":0,"6.2-6.4":0.02161,"7.2-7.4":0.21612,"8.2":0.01081,"9.2":0.07564,"10.1":0.04322,"11.1-11.2":0.28096,"12.0":5.0249},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0.00603,"11":0.36786,"5.5":0},"bb":{"7":0,"10":0.02495},"ie_mob":{"10":0,"11":0.00832},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.17048},"and_qq":{"10.4":0},"and_uc":{"0":0.10811},"op_mini":{"0":0.12597},"and_chr":{"0":42.50344}},"total":96.12233}

/***/ },
/* 1169 */
/***/ function(module, exports) {

	module.exports = {"id":"BD","name":"Bangladesh","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0.00451,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00451,"30":0,"31":0,"32":0,"33":0.00451,"34":0,"35":0,"36":0,"37":0.00451,"38":0,"39":0,"40":0.00451,"41":0,"42":0,"43":0.00902,"44":0.00451,"45":0.00451,"46":0.00451,"47":0.01804,"48":0.00902,"49":0.00451,"50":0.00451,"51":0.00451,"52":0.07214,"53":0.00451,"54":0,"55":0,"56":0.01804,"57":0.00451,"58":0.00451,"59":0.00451,"60":0.00902,"61":0,"62":0.00451,"63":0.00451,"64":0.00451,"65":0.00451,"66":0.00451,"67":0.00451,"68":0.03156,"69":0.00451,"70":0.00451,"71":0.00451,"72":0.02255,"73":0.00451,"74":0.00451,"75":0.00902,"76":0.00451,"77":0.00902,"78":0.04058,"79":0.01353,"80":0.03607,"81":1.95691,"82":0.52304,"83":0.09018,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00451,"30":0,"31":0.00451,"32":0,"33":0.00451,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.00451,"41":0,"42":0.00451,"43":0.00451,"44":0,"45":0,"46":0,"47":0,"48":0.00451,"49":0.04509,"50":0.00451,"51":0,"52":0,"53":0.00451,"54":0,"55":0,"56":0.00451,"57":0,"58":0.00451,"59":0,"60":0,"61":0.02255,"62":0,"63":0.00902,"64":0.00451,"65":0.00451,"66":0,"67":0.00451,"68":0.00451,"69":0.00902,"70":0.01804,"71":0.04509,"72":0.02255,"73":0.02255,"74":0.04509,"75":0.01804,"76":0.01804,"77":0.00902,"78":0.01804,"79":0.04058,"80":0.07214,"81":0.08116,"83":0.05411,"84":0.12625,"85":4.75249,"86":8.25598,"87":0.04509,"88":0.01804,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0.01804,"29":0.00451,"30":0.00451,"31":0,"32":0.00451,"33":0,"34":0,"35":0,"36":0,"37":0.02705,"38":0.00902,"39":0,"40":0,"41":0,"42":0.00451,"43":0,"44":0,"45":0.00451,"46":0.02255,"47":0.02255,"48":0,"49":0,"50":0.13978,"51":0.88376,"52":0.01804,"53":0.00451,"54":0.00902,"55":0.01353,"56":0.00451,"57":0.00902,"58":0,"60":0.04058,"62":0,"63":0,"64":0.00902,"65":0,"66":0.00451,"67":0.02255,"68":0.13978,"69":0.01804,"70":0.05862,"71":0.07214,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":0.94968,"3.2":0.00228,"4.0-4.1":0.00195,"4.2-4.3":0.00033,"5.0-5.1":0.00163,"6.0-6.1":0.00098,"7.0-7.1":0.00228,"8.1-8.4":0.00748,"9.0-9.2":0.00423,"9.3":0.05395,"10.0-10.2":0.0091,"10.3":0.05005,"11.0-11.2":0.01885,"11.3-11.4":0.03218,"12.0-12.1":0.03283,"12.2-12.4":0.32728,"13.0-13.1":0.02698,"13.2":0.01333,"13.3":0.1014,"13.4-13.7":0.54017},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0.00902,"14":0.0496,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0.00451,"12.1":0.00902,"13.1":0.03607},"edge":{"12":0.03607,"13":0.00902,"14":0.00902,"15":0.00451,"16":0.00902,"17":0.04509,"18":0.05862,"79":0,"80":0,"81":0,"83":0,"84":0.00451,"85":0.21643,"86":0.43286},"android":{"3":0,"4":0.1323,"81":null,"2.1":0,"2.2":0,"2.3":0.00106,"4.1":0.06668,"4.2-4.3":0.02963,"4.4":0,"4.4.3-4.4.4":0.24131},"samsung":{"4":0.36628,"5.0-5.4":0.03052,"6.2-6.4":0.03052,"7.2-7.4":0.0814,"8.2":0.0407,"9.2":0.10175,"10.1":0.06105,"11.1-11.2":0.17297,"12.0":1.19042},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.03661,"9":0.00523,"10":0.00523,"11":0.08369,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.19768},"and_qq":{"10.4":0.00549},"and_uc":{"0":4.34887},"op_mini":{"0":4.216},"and_chr":{"0":62.66505}},"total":95.59508}

/***/ },
/* 1170 */
/***/ function(module, exports) {

	module.exports = {"id":"BE","name":"Belgium","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00638,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.01277,"49":0,"50":0,"51":0,"52":0.0383,"53":0,"54":0,"55":0,"56":0.0383,"57":0,"58":0,"59":0,"60":0.01915,"61":0,"62":0,"63":0.00638,"64":0.00638,"65":0.00638,"66":0.00638,"67":0.00638,"68":0.06383,"69":0.00638,"70":0.00638,"71":0,"72":0.01277,"73":0.00638,"74":0.00638,"75":0.00638,"76":0.01277,"77":0.01277,"78":0.16596,"79":0.02553,"80":0.10851,"81":2.5149,"82":0.3766,"83":0.00638,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00638,"39":0,"40":0.00638,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.17872,"50":0,"51":0,"52":0,"53":0.01277,"54":0,"55":0,"56":0,"57":0.00638,"58":0,"59":0.00638,"60":0.00638,"61":0.00638,"62":0.00638,"63":0.01277,"64":0.00638,"65":0.02553,"66":0.02553,"67":0.01277,"68":0.00638,"69":0.02553,"70":0.01915,"71":0.0383,"72":0.03192,"73":0.01915,"74":0.04468,"75":0.0383,"76":0.0383,"77":0.02553,"78":0.15319,"79":0.17872,"80":0.11489,"81":0.07021,"83":0.17234,"84":0.27447,"85":9.85535,"86":14.25962,"87":0.01277,"88":0.00638,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00638,"52":0,"53":0,"54":0,"55":0,"56":0.00638,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00638,"69":0,"70":0.05745,"71":0.47234,"72":0.00638,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.01277},"ios_saf":{"8":0,"14":9.78042,"3.2":0.02343,"4.0-4.1":0.02008,"4.2-4.3":0.00335,"5.0-5.1":0.01674,"6.0-6.1":0.01004,"7.0-7.1":0.02343,"8.1-8.4":0.07698,"9.0-9.2":0.04351,"9.3":0.55563,"10.0-10.2":0.09372,"10.3":0.51546,"11.0-11.2":0.19414,"11.3-11.4":0.33137,"12.0-12.1":0.33806,"12.2-12.4":3.3706,"13.0-13.1":0.27781,"13.2":0.13723,"13.3":1.04432,"13.4-13.7":5.56299},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0.00638,"9":0,"10":0.00638,"11":0.02553,"12":0.05106,"13":0.25532,"14":1.98511,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.00638,"10.1":0.05106,"11.1":0.11489,"12.1":0.22979,"13.1":2.13192},"edge":{"12":0,"13":0,"14":0.00638,"15":0.01277,"16":0.03192,"17":0.05745,"18":0.29362,"79":0,"80":0,"81":0.01277,"83":0.00638,"84":0.02553,"85":1.11064,"86":2.1766},"android":{"3":0,"4":0.06389,"81":null,"2.1":0,"2.2":0,"2.3":0.00051,"4.1":0.0322,"4.2-4.3":0.01431,"4.4":0,"4.4.3-4.4.4":0.11653},"samsung":{"4":0.09292,"5.0-5.4":0.01032,"6.2-6.4":0,"7.2-7.4":0.01032,"8.2":0.01032,"9.2":0.0413,"10.1":0.03097,"11.1-11.2":0.07227,"12.0":3.69631},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00653,"9":0.00653,"10":0,"11":0.85503,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.24234},"and_qq":{"10.4":0.00723},"and_uc":{"0":0.02894},"op_mini":{"0":0.10273},"and_chr":{"0":30.82397}},"total":97.03377}

/***/ },
/* 1171 */
/***/ function(module, exports) {

	module.exports = {"id":"BF","name":"Burkina Faso","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0.00323,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0.01936,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0.00323,"40":0.00323,"41":0.00323,"42":0,"43":0.00323,"44":0,"45":0,"46":0,"47":0.00968,"48":0.00645,"49":0,"50":0.00323,"51":0,"52":0.0129,"53":0,"54":0,"55":0,"56":0.00323,"57":0.00323,"58":0,"59":0,"60":0.00645,"61":0.00323,"62":0,"63":0,"64":0,"65":0.00968,"66":0.00323,"67":0,"68":0.02903,"69":0.00323,"70":0.00323,"71":0,"72":0.0129,"73":0,"74":0.00323,"75":0.00645,"76":0.00645,"77":0.03226,"78":0.19679,"79":0.01613,"80":0.08065,"81":1.75172,"82":0.1742,"83":0.00645,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00323,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0.00323,"27":0,"28":0.02258,"29":0.00323,"30":0,"31":0.00968,"32":0.00645,"33":0,"34":0,"35":0,"36":0,"37":0.00323,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.06129,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0.00323,"59":0,"60":0,"61":0,"62":0,"63":0.00323,"64":0.00323,"65":0.01936,"66":0,"67":0.08065,"68":0,"69":0.00323,"70":0.00645,"71":0,"72":0,"73":0.00323,"74":0.00645,"75":0.01936,"76":0.00323,"77":0.03226,"78":0.00323,"79":0.04839,"80":0.06775,"81":0.06452,"83":0.02903,"84":0.03549,"85":1.64203,"86":2.57757,"87":0.00323,"88":0.00323,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0.00323,"24":0.00645,"25":0,"26":0.0129,"27":0.00968,"28":0.02258,"29":0,"30":0.00968,"31":0.00323,"32":0.00645,"33":0.00323,"34":0,"35":0,"36":0,"37":0,"38":0.0129,"39":0,"40":0,"41":0,"42":0.0129,"43":0,"44":0,"45":0.00645,"46":0.01613,"47":0.02581,"48":0,"49":0,"50":0.09355,"51":0.36776,"52":0,"53":0.00968,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00323,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00645,"69":0,"70":0.10646,"71":0.46132,"72":0.0129,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.01936},"ios_saf":{"8":0,"14":2.25737,"3.2":0.00541,"4.0-4.1":0.00464,"4.2-4.3":0.00077,"5.0-5.1":0.00386,"6.0-6.1":0.00232,"7.0-7.1":0.00541,"8.1-8.4":0.01777,"9.0-9.2":0.01004,"9.3":0.12824,"10.0-10.2":0.02163,"10.3":0.11897,"11.0-11.2":0.04481,"11.3-11.4":0.07648,"12.0-12.1":0.07803,"12.2-12.4":0.77795,"13.0-13.1":0.06412,"13.2":0.03167,"13.3":0.24103,"13.4-13.7":1.28397},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00645,"11":0.00645,"12":0.03871,"13":0.13227,"14":0.13549,"3.1":0,"3.2":0,"5.1":0.0129,"6.1":0,"7.1":0.00323,"9.1":0.00323,"10.1":0.0129,"11.1":0.06129,"12.1":0.02258,"13.1":0.15485},"edge":{"12":0.01936,"13":0.00968,"14":0.00323,"15":0.00645,"16":0.0129,"17":0.01936,"18":0.11291,"79":0,"80":0,"81":0.00323,"83":0,"84":0.00968,"85":0.23872,"86":0.38389},"android":{"3":0,"4":0.09678,"81":null,"2.1":0,"2.2":0,"2.3":0.00077,"4.1":0.04877,"4.2-4.3":0.02168,"4.4":0,"4.4.3-4.4.4":0.17652},"samsung":{"4":0.10138,"5.0-5.4":0.01014,"6.2-6.4":0,"7.2-7.4":0.07097,"8.2":0.05069,"9.2":0.28386,"10.1":0.06083,"11.1-11.2":0.11152,"12.0":0.8009},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.0129,"9":0,"10":0,"11":0.1613,"5.5":0},"bb":{"7":0,"10":0.04064},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.01355},"baidu":{"0":null},"and_ff":{"0":0.13548},"and_qq":{"10.4":0.06774},"and_uc":{"0":1.07029},"op_mini":{"0":7.00961},"and_chr":{"0":71.416}},"total":96.76974}

/***/ },
/* 1172 */
/***/ function(module, exports) {

	module.exports = {"id":"BG","name":"Bulgaria","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0.00519,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00519,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00519,"39":0,"40":0,"41":0,"42":0,"43":0.00519,"44":0,"45":0.00519,"46":0,"47":0.00519,"48":0.00519,"49":0.00519,"50":0.00519,"51":0.00519,"52":0.1868,"53":0,"54":0,"55":0,"56":0.02076,"57":0.00519,"58":0.00519,"59":0.00519,"60":0.03632,"61":0.00519,"62":0.00519,"63":0.01038,"64":0.00519,"65":0.00519,"66":0.01038,"67":0.01038,"68":0.12973,"69":0.00519,"70":0.01038,"71":0.00519,"72":0.02076,"73":0.01038,"74":0.01038,"75":0.01038,"76":0.01557,"77":0.01557,"78":0.15567,"79":0.03113,"80":0.11416,"81":3.17048,"82":0.51371,"83":0.01038,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00519,"23":0,"24":0,"25":0,"26":0.00519,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.00519,"35":0,"36":0,"37":0,"38":0.01038,"39":0,"40":0.00519,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00519,"49":0.35285,"50":0.00519,"51":0,"52":0,"53":0.01557,"54":0.00519,"55":0.00519,"56":0.01038,"57":0.00519,"58":0.01557,"59":0,"60":0,"61":0.07784,"62":0.00519,"63":0.02595,"64":0.00519,"65":0.01038,"66":0.00519,"67":0.01038,"68":0.03113,"69":0.04151,"70":0.12973,"71":0.03632,"72":0.02076,"73":0.04151,"74":0.02076,"75":0.02076,"76":0.01557,"77":0.02595,"78":0.03113,"79":0.05708,"80":0.0934,"81":0.08302,"83":0.08302,"84":0.16605,"85":6.61079,"86":10.10298,"87":0.03113,"88":0.00519,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.01038,"37":0,"38":0,"39":0,"40":0.00519,"41":0,"42":0,"43":0,"44":0,"45":0.00519,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.02076,"52":0,"53":0.00519,"54":0,"55":0,"56":0,"57":0,"58":0.01038,"60":0.00519,"62":0,"63":0.00519,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0.00519,"70":0.1401,"71":0.79911,"72":0.02076,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":4.28525,"3.2":0.01027,"4.0-4.1":0.0088,"4.2-4.3":0.00147,"5.0-5.1":0.00733,"6.0-6.1":0.0044,"7.0-7.1":0.01027,"8.1-8.4":0.03373,"9.0-9.2":0.01907,"9.3":0.24345,"10.0-10.2":0.04106,"10.3":0.22585,"11.0-11.2":0.08506,"11.3-11.4":0.14519,"12.0-12.1":0.14812,"12.2-12.4":1.47681,"13.0-13.1":0.12172,"13.2":0.06013,"13.3":0.45756,"13.4-13.7":2.4374},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00519,"11":0.01038,"12":0.01038,"13":0.04151,"14":0.24388,"3.1":0,"3.2":0,"5.1":0.00519,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00519,"11.1":0.01557,"12.1":0.03113,"13.1":0.23351},"edge":{"12":0,"13":0,"14":0.00519,"15":0.01038,"16":0.00519,"17":0.01557,"18":0.11416,"79":0,"80":0,"81":0,"83":0,"84":0.00519,"85":0.3321,"86":0.66938},"android":{"3":0,"4":0.09998,"81":null,"2.1":0,"2.2":0,"2.3":0.0008,"4.1":0.05039,"4.2-4.3":0.0224,"4.4":0,"4.4.3-4.4.4":0.18237},"samsung":{"4":0.16127,"5.0-5.4":0.01008,"6.2-6.4":0.01008,"7.2-7.4":0.03024,"8.2":0.01008,"9.2":0.07056,"10.1":0.06048,"11.1-11.2":0.13103,"12.0":2.59042},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01602,"9":0.01068,"10":0.00534,"11":0.69441,"5.5":0},"bb":{"7":0,"10":0.00481},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.19244},"and_qq":{"10.4":0.00481},"and_uc":{"0":0.07217},"op_mini":{"0":0.23229},"and_chr":{"0":57.68359}},"total":97.79308}

/***/ },
/* 1173 */
/***/ function(module, exports) {

	module.exports = {"id":"BH","name":"Bahrain","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.00531,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.01062,"69":0,"70":0,"71":0,"72":0.00531,"73":0,"74":0,"75":0.00531,"76":0,"77":0,"78":0.04777,"79":0.00531,"80":0.04777,"81":0.90767,"82":0.12739,"83":0.00531,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00531,"39":0,"40":0,"41":0,"42":0,"43":0.01062,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.11678,"50":0,"51":0,"52":0.00531,"53":0.01592,"54":0,"55":0,"56":0.00531,"57":0,"58":0,"59":0.00531,"60":0,"61":0,"62":0.00531,"63":0.00531,"64":0,"65":0.02654,"66":0,"67":0.02654,"68":0,"69":0.00531,"70":0.01592,"71":0.00531,"72":0.00531,"73":0.05308,"74":0.03716,"75":0.01062,"76":0.02654,"77":0.02654,"78":0.04246,"79":0.0637,"80":0.11147,"81":0.07431,"83":0.08493,"84":0.22824,"85":7.91954,"86":11.57144,"87":0.02123,"88":0.01592,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00531,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.01062,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00531,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00531,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.02654,"69":0.00531,"70":0.03716,"71":0.07431,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":9.03418,"3.2":0.02164,"4.0-4.1":0.01855,"4.2-4.3":0.00309,"5.0-5.1":0.01546,"6.0-6.1":0.00928,"7.0-7.1":0.02164,"8.1-8.4":0.07111,"9.0-9.2":0.04019,"9.3":0.51324,"10.0-10.2":0.08657,"10.3":0.47613,"11.0-11.2":0.17932,"11.3-11.4":0.30609,"12.0-12.1":0.31227,"12.2-12.4":3.11342,"13.0-13.1":0.25662,"13.2":0.12676,"13.3":0.96464,"13.4-13.7":5.13854},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00531,"11":0.02123,"12":0.03185,"13":0.23355,"14":1.50216,"3.1":0,"3.2":0,"5.1":0.02654,"6.1":0,"7.1":0,"9.1":0,"10.1":0.01062,"11.1":0.07431,"12.1":0.16986,"13.1":1.45439},"edge":{"12":0.00531,"13":0.00531,"14":0.00531,"15":0.00531,"16":0.01062,"17":0.02123,"18":0.2017,"79":0,"80":0,"81":0.00531,"83":0.00531,"84":0.01592,"85":0.5998,"86":0.98729},"android":{"3":0,"4":0.0258,"81":null,"2.1":0,"2.2":0,"2.3":0.00021,"4.1":0.013,"4.2-4.3":0.00578,"4.4":0,"4.4.3-4.4.4":0.04706},"samsung":{"4":0.20264,"5.0-5.4":0.0304,"6.2-6.4":0,"7.2-7.4":0.06079,"8.2":0.02026,"9.2":0.15198,"10.1":0.10132,"11.1-11.2":0.27356,"12.0":3.34356},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00545,"9":0.00545,"10":0,"11":0.19612,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.13607},"and_qq":{"10.4":0.00469},"and_uc":{"0":2.41638},"op_mini":{"0":0.29318},"and_chr":{"0":40.62728}},"total":95.95289}

/***/ },
/* 1174 */
/***/ function(module, exports) {

	module.exports = {"id":"BI","name":"Burundi","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0.00485,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0.00485,"16":0,"17":0.00485,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0.14553,"25":0,"26":0.00485,"27":0,"28":0.00485,"29":0,"30":0,"31":0,"32":0.00485,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00485,"44":0,"45":0.01455,"46":0,"47":0.0097,"48":0.00485,"49":0.00485,"50":0,"51":0.00485,"52":0.03396,"53":0,"54":0,"55":0,"56":0.30076,"57":0.0097,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0.0097,"65":0.00485,"66":0.00485,"67":0,"68":0.02911,"69":0,"70":0,"71":0,"72":0.02426,"73":0,"74":0.0097,"75":0,"76":0.02911,"77":0,"78":0.14068,"79":0.10672,"80":0.10672,"81":2.55648,"82":0.45599,"83":0.12613,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00485,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0.00485,"25":0.00485,"26":0.0097,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.00485,"41":0,"42":0.0097,"43":0.0194,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.08732,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0.00485,"58":0,"59":0,"60":0,"61":0.00485,"62":0,"63":0.02911,"64":0.00485,"65":0.00485,"66":0,"67":0.0097,"68":0.00485,"69":0.16008,"70":0.00485,"71":0.00485,"72":0.0097,"73":0.01455,"74":0.0194,"75":0.01455,"76":0.0097,"77":0.0194,"78":0.00485,"79":0.08247,"80":0.10672,"81":0.05821,"83":0.09217,"84":0.17949,"85":5.40887,"86":7.22314,"87":0.04851,"88":0.01455,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0.00485,"17":0,"18":0,"19":0,"20":0.01455,"21":0,"22":0.00485,"23":0.0194,"24":0.04366,"25":0,"26":0.01455,"27":0.01455,"28":0.04851,"29":0.01455,"30":0.0097,"31":0.00485,"32":0.02426,"33":0.0194,"34":0,"35":0,"36":0.00485,"37":0,"38":0.01455,"39":0,"40":0,"41":0,"42":0.0194,"43":0,"44":0,"45":0.02426,"46":0.08732,"47":0.2571,"48":0,"49":0,"50":0.2571,"51":0.84407,"52":0.03396,"53":0.00485,"54":0.00485,"55":0,"56":0,"57":0,"58":0,"60":0.00485,"62":0,"63":0.00485,"64":0,"65":0,"66":0,"67":0.02911,"68":0.00485,"69":0,"70":0.16493,"71":1.36798,"72":0.04366,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.03396},"ios_saf":{"8":0,"14":1.4134,"3.2":0.00339,"4.0-4.1":0.0029,"4.2-4.3":0.00048,"5.0-5.1":0.00242,"6.0-6.1":0.00145,"7.0-7.1":0.00339,"8.1-8.4":0.01113,"9.0-9.2":0.00629,"9.3":0.0803,"10.0-10.2":0.01354,"10.3":0.07449,"11.0-11.2":0.02806,"11.3-11.4":0.04789,"12.0-12.1":0.04885,"12.2-12.4":0.48709,"13.0-13.1":0.04015,"13.2":0.01983,"13.3":0.15092,"13.4-13.7":0.80392},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0.00485,"10":0,"11":0.05336,"12":0.00485,"13":0.0194,"14":0.02911,"3.1":0,"3.2":0,"5.1":0.39778,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0.07762,"12.1":0.10187,"13.1":0.16493},"edge":{"12":0.02911,"13":0.0097,"14":0.02911,"15":0.01455,"16":0.03881,"17":0.03881,"18":0.19404,"79":0,"80":0,"81":0.00485,"83":0.00485,"84":0.02911,"85":0.2571,"86":0.48025},"android":{"3":0,"4":0.1652,"81":null,"2.1":0,"2.2":0,"2.3":0.00132,"4.1":0.08326,"4.2-4.3":0.03701,"4.4":0,"4.4.3-4.4.4":0.30133},"samsung":{"4":0.16601,"5.0-5.4":0.01038,"6.2-6.4":0.02075,"7.2-7.4":0.03113,"8.2":0,"9.2":0.0415,"10.1":0.083,"11.1-11.2":0.05188,"12.0":0.97529},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.02426,"9":0,"10":0,"11":0.19889,"5.5":0},"bb":{"7":0,"10":0.01545},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.00515},"baidu":{"0":null},"and_ff":{"0":0.07724},"and_qq":{"10.4":0.00515},"and_uc":{"0":0.46341},"op_mini":{"0":12.7182},"and_chr":{"0":51.22785}},"total":93.22343}

/***/ },
/* 1175 */
/***/ function(module, exports) {

	module.exports = {"id":"BJ","name":"Benin","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0.00503,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.01006,"44":0,"45":0,"46":0,"47":0.00503,"48":0.00503,"49":0,"50":0.00503,"51":0.00503,"52":0.02011,"53":0,"54":0,"55":0,"56":0.00503,"57":0.00503,"58":0,"59":0,"60":0.00503,"61":0.01006,"62":0,"63":0.01006,"64":0,"65":0.00503,"66":0.01006,"67":0.00503,"68":0.0352,"69":0.07039,"70":0,"71":0,"72":0.0352,"73":0.00503,"74":0.01006,"75":0.00503,"76":0.00503,"77":0.00503,"78":0.09553,"79":0.02514,"80":0.11062,"81":2.09668,"82":0.22626,"83":0.00503,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00503,"23":0,"24":0.00503,"25":0,"26":0.00503,"27":0,"28":0,"29":0,"30":0.00503,"31":0.02011,"32":0,"33":0.10056,"34":0,"35":0.00503,"36":0.02514,"37":0.30168,"38":0.00503,"39":0,"40":0,"41":0,"42":0,"43":0.00503,"44":0.00503,"45":0,"46":0.00503,"47":0.01006,"48":0,"49":0.08045,"50":0.01508,"51":0,"52":0,"53":0.00503,"54":0,"55":0.00503,"56":0.00503,"57":0.01006,"58":0.07039,"59":0.00503,"60":0.03017,"61":0.00503,"62":0.00503,"63":0.02514,"64":0.00503,"65":0.01006,"66":0.01006,"67":0.00503,"68":0.00503,"69":0.06034,"70":0.02011,"71":0.02011,"72":0.03017,"73":0.01508,"74":0.18101,"75":0.04525,"76":0.05028,"77":0.04022,"78":0.03017,"79":0.13073,"80":0.25643,"81":0.10559,"83":0.17598,"84":0.3419,"85":5.59616,"86":8.59788,"87":0.02011,"88":0.00503,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0.02514,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0.01006,"24":0.02514,"25":0,"26":0.02514,"27":0.02514,"28":0.02011,"29":0.00503,"30":0.03017,"31":0.01006,"32":0.01006,"33":0.01508,"34":0,"35":0.02514,"36":0,"37":0,"38":0.01006,"39":0,"40":0.00503,"41":0,"42":0.02514,"43":0,"44":0,"45":0.01006,"46":0.04022,"47":0.02011,"48":0,"49":0,"50":0.12067,"51":0.70392,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0.01006,"58":0,"60":0.03017,"62":0.00503,"63":0,"64":0,"65":0,"66":0.00503,"67":0,"68":0.02011,"69":0.01006,"70":0.20615,"71":1.23689,"72":0.04022,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.07542},"ios_saf":{"8":0,"14":2.03016,"3.2":0.00486,"4.0-4.1":0.00417,"4.2-4.3":0.00069,"5.0-5.1":0.00347,"6.0-6.1":0.00208,"7.0-7.1":0.00486,"8.1-8.4":0.01598,"9.0-9.2":0.00903,"9.3":0.11533,"10.0-10.2":0.01945,"10.3":0.107,"11.0-11.2":0.0403,"11.3-11.4":0.06878,"12.0-12.1":0.07017,"12.2-12.4":0.69965,"13.0-13.1":0.05767,"13.2":0.02849,"13.3":0.21677,"13.4-13.7":1.15473},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.01006,"12":0.01006,"13":0.05028,"14":0.32179,"3.1":0,"3.2":0,"5.1":0.1257,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0.02011,"12.1":0.07542,"13.1":0.29162},"edge":{"12":0.01508,"13":0.00503,"14":0.00503,"15":0.01006,"16":0.01006,"17":0.01006,"18":0.0905,"79":0,"80":0,"81":0,"83":0.00503,"84":0.01508,"85":0.51286,"86":0.72906},"android":{"3":0,"4":0.04072,"81":null,"2.1":0,"2.2":0,"2.3":0.00033,"4.1":0.02052,"4.2-4.3":0.00912,"4.4":0,"4.4.3-4.4.4":0.07428},"samsung":{"4":0.07355,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.01051,"8.2":0,"9.2":0.02101,"10.1":0.02101,"11.1-11.2":0.03152,"12.0":0.39926},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.06983,"9":0,"10":0,"11":0.18157,"5.5":0},"bb":{"7":0,"10":0.01492},"ie_mob":{"10":0,"11":0.00497},"kaios":{"2.5":0.03978},"baidu":{"0":null},"and_ff":{"0":0.19391},"and_qq":{"10.4":0.1243},"and_uc":{"0":0.52703},"op_mini":{"0":6.75949},"and_chr":{"0":58.34858}},"total":96.09629}

/***/ },
/* 1176 */
/***/ function(module, exports) {

	module.exports = {"id":"BM","name":"Bermuda","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00842,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.01685,"49":0,"50":0,"51":0.00842,"52":0.05897,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0.01685,"66":0,"67":0,"68":0.00842,"69":0,"70":0,"71":0,"72":0.01685,"73":0.01685,"74":0,"75":0.00842,"76":0,"77":0.00842,"78":0.09266,"79":0.01685,"80":0.2106,"81":1.87855,"82":0.0337,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00842,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.13478,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0.02527,"64":0,"65":0.05054,"66":0.05054,"67":0.02527,"68":0.06739,"69":0,"70":0.0337,"71":0.04212,"72":0.01685,"73":0.22745,"74":0.01685,"75":0.0337,"76":0.07582,"77":1.17094,"78":0.05897,"79":0.2106,"80":0.12636,"81":0.07582,"83":0.20218,"84":1.25518,"85":25.01928,"86":6.41066,"87":0.01685,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.00842,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0.00842,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.04212,"71":0.07582,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":8.53157,"3.2":0.02044,"4.0-4.1":0.01752,"4.2-4.3":0.00292,"5.0-5.1":0.0146,"6.0-6.1":0.00876,"7.0-7.1":0.02044,"8.1-8.4":0.06715,"9.0-9.2":0.03796,"9.3":0.48468,"10.0-10.2":0.08175,"10.3":0.44964,"11.0-11.2":0.16935,"11.3-11.4":0.28906,"12.0-12.1":0.2949,"12.2-12.4":2.94021,"13.0-13.1":0.24234,"13.2":0.11971,"13.3":0.91097,"13.4-13.7":4.85266},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0.02527,"10":0.00842,"11":0.0337,"12":0.07582,"13":0.5981,"14":3.62232,"3.1":0,"3.2":0,"5.1":0,"6.1":0.00842,"7.1":0.05054,"9.1":0.04212,"10.1":0.18533,"11.1":0.4212,"12.1":0.51386,"13.1":8.6346},"edge":{"12":0.02527,"13":0.00842,"14":0.01685,"15":0.04212,"16":0.14321,"17":0.2443,"18":2.08073,"79":0.00842,"80":0,"81":0.0337,"83":0.00842,"84":0.00842,"85":6.47806,"86":0.96034},"android":{"3":0,"4":0.14848,"81":null,"2.1":0,"2.2":0,"2.3":0.00119,"4.1":0.07483,"4.2-4.3":0.03326,"4.4":0,"4.4.3-4.4.4":0.27083},"samsung":{"4":0.04335,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.01084,"8.2":0.01084,"9.2":0.02168,"10.1":0.01084,"11.1-11.2":0.06503,"12.0":2.20005},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0.00842,"10":0,"11":4.00982,"5.5":0},"bb":{"7":0,"10":0.00473},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.07565},"and_qq":{"10.4":0},"and_uc":{"0":0.00315},"op_mini":{"0":0.0179},"and_chr":{"0":9.0571}},"total":97.79373}

/***/ },
/* 1177 */
/***/ function(module, exports) {

	module.exports = {"id":"BN","name":"Brunei Darussalam","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00541,"30":0,"31":0,"32":0.01081,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.01081,"46":0,"47":0.00541,"48":0.01622,"49":0,"50":0,"51":0,"52":0.04865,"53":0,"54":0,"55":0,"56":0,"57":0.00541,"58":0,"59":0,"60":0,"61":0.00541,"62":0,"63":0,"64":0,"65":0.01622,"66":0.02162,"67":0,"68":0.01081,"69":0,"70":0.00541,"71":0,"72":0.02162,"73":0,"74":0.00541,"75":0,"76":0.01081,"77":0.00541,"78":0.03784,"79":0.03243,"80":0.08108,"81":1.67015,"82":0.23242,"83":0.02162,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.01622,"35":0,"36":0,"37":0,"38":0.03243,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.01622,"48":0,"49":0.23782,"50":0.00541,"51":0,"52":0.00541,"53":0.01081,"54":0,"55":0.00541,"56":0,"57":0.00541,"58":0.00541,"59":0,"60":0.01081,"61":0.00541,"62":0,"63":0.01081,"64":0.00541,"65":0.01081,"66":0.00541,"67":0.12432,"68":0.00541,"69":0.09189,"70":0.01081,"71":0.04865,"72":0.03784,"73":0.03784,"74":0.04324,"75":0.02703,"76":0.01622,"77":0.01622,"78":0.04324,"79":0.03243,"80":0.09729,"81":0.23782,"83":0.07567,"84":0.22161,"85":7.66429,"86":11.50184,"87":0.04865,"88":0.01081,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00541,"37":0.02703,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.01081,"51":0.08108,"52":0.00541,"53":0,"54":0.01081,"55":0.00541,"56":0,"57":0,"58":0,"60":0.04324,"62":0,"63":0.00541,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.05946,"71":0.37295,"72":0.01081,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00541},"ios_saf":{"8":0,"14":8.16311,"3.2":0.01956,"4.0-4.1":0.01676,"4.2-4.3":0.00279,"5.0-5.1":0.01397,"6.0-6.1":0.00838,"7.0-7.1":0.01956,"8.1-8.4":0.06425,"9.0-9.2":0.03632,"9.3":0.46375,"10.0-10.2":0.07822,"10.3":0.43023,"11.0-11.2":0.16203,"11.3-11.4":0.27657,"12.0-12.1":0.28216,"12.2-12.4":2.81323,"13.0-13.1":0.23187,"13.2":0.11454,"13.3":0.87163,"13.4-13.7":4.64309},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0.00541,"10":0,"11":0.01081,"12":0.03784,"13":0.24323,"14":0.70265,"3.1":0,"3.2":0,"5.1":0.02162,"6.1":0,"7.1":0,"9.1":0.01081,"10.1":0.03243,"11.1":0.05405,"12.1":0.27025,"13.1":1.13505},"edge":{"12":0.00541,"13":0,"14":0,"15":0.00541,"16":0.00541,"17":0.03243,"18":0.06486,"79":0,"80":0,"81":0,"83":0,"84":0.01081,"85":0.3243,"86":0.62158},"android":{"3":0,"4":0.04084,"81":null,"2.1":0,"2.2":0,"2.3":0.00033,"4.1":0.02059,"4.2-4.3":0.00915,"4.4":0,"4.4.3-4.4.4":0.0745},"samsung":{"4":0.4635,"5.0-5.4":0.01053,"6.2-6.4":0.02107,"7.2-7.4":0.0316,"8.2":0.01053,"9.2":0.18961,"10.1":0.11588,"11.1-11.2":0.13694,"12.0":2.11736},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00894,"9":0.00894,"10":0.00894,"11":0.2056,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.21597},"and_qq":{"10.4":0.00919},"and_uc":{"0":1.88395},"op_mini":{"0":1.7923},"and_chr":{"0":42.73536}},"total":96.12455}

/***/ },
/* 1178 */
/***/ function(module, exports) {

	module.exports = {"id":"BO","name":"Bolivia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00603,"44":0,"45":0,"46":0,"47":0.00603,"48":0.01809,"49":0,"50":0,"51":0,"52":0.03618,"53":0,"54":0,"55":0,"56":0.00603,"57":0,"58":0.00603,"59":0,"60":0.00603,"61":0.00603,"62":0.00603,"63":0,"64":0.00603,"65":0.00603,"66":0.00603,"67":0.00603,"68":0.02412,"69":0.01206,"70":0.00603,"71":0.00603,"72":0.01809,"73":0.00603,"74":0.00603,"75":0,"76":0.00603,"77":0.01206,"78":0.22311,"79":0.01809,"80":0.06633,"81":2.39391,"82":0.31356,"83":0.01206,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0.00603,"32":0,"33":0,"34":0.00603,"35":0,"36":0,"37":0,"38":0.00603,"39":0,"40":0.00603,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.00603,"47":0.01809,"48":0,"49":0.1809,"50":0,"51":0.00603,"52":0,"53":0.01206,"54":0,"55":0.00603,"56":0.00603,"57":0,"58":0.00603,"59":0,"60":0,"61":0,"62":0.00603,"63":0.02412,"64":0.01206,"65":0.03015,"66":0.01206,"67":0.02412,"68":0.01206,"69":0.01809,"70":0.03618,"71":0.03618,"72":0.03015,"73":0.04221,"74":0.04824,"75":0.03618,"76":0.04824,"77":0.06633,"78":0.04824,"79":0.15075,"80":0.13869,"81":0.11457,"83":0.16281,"84":0.27135,"85":9.96759,"86":16.41969,"87":0.01206,"88":0.00603,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.01206,"51":0.02412,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00603,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.10854,"71":0.99495,"72":0.01809,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":1.32582,"3.2":0.00318,"4.0-4.1":0.00272,"4.2-4.3":0.00045,"5.0-5.1":0.00227,"6.0-6.1":0.00136,"7.0-7.1":0.00318,"8.1-8.4":0.01044,"9.0-9.2":0.0059,"9.3":0.07532,"10.0-10.2":0.0127,"10.3":0.06988,"11.0-11.2":0.02632,"11.3-11.4":0.04492,"12.0-12.1":0.04583,"12.2-12.4":0.45691,"13.0-13.1":0.03766,"13.2":0.0186,"13.3":0.14157,"13.4-13.7":0.75411},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00603,"11":0.00603,"12":0.03618,"13":0.07236,"14":0.36783,"3.1":0,"3.2":0,"5.1":0.69345,"6.1":0,"7.1":0,"9.1":0.00603,"10.1":0.01809,"11.1":0.07839,"12.1":0.09648,"13.1":0.43416},"edge":{"12":0,"13":0,"14":0.00603,"15":0.00603,"16":0.00603,"17":0.01206,"18":0.05427,"79":0,"80":0.00603,"81":0,"83":0,"84":0.00603,"85":0.41004,"86":0.74169},"android":{"3":0,"4":0.06791,"81":null,"2.1":0,"2.2":0,"2.3":0.00054,"4.1":0.03423,"4.2-4.3":0.01521,"4.4":0,"4.4.3-4.4.4":0.12387},"samsung":{"4":0.55182,"5.0-5.4":0.02007,"6.2-6.4":0.04013,"7.2-7.4":0.28093,"8.2":0.04013,"9.2":0.16053,"10.1":0.1204,"11.1-11.2":0.22073,"12.0":2.06681},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01252,"9":0,"10":0,"11":0.15029,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.10719},"and_qq":{"10.4":0.00794},"and_uc":{"0":0.24614},"op_mini":{"0":0.29317},"and_chr":{"0":54.2388}},"total":97.34917}

/***/ },
/* 1179 */
/***/ function(module, exports) {

	module.exports = {"id":"BR","name":"Brazil","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.02162,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0.00721,"61":0,"62":0,"63":0.00721,"64":0.00721,"65":0.01442,"66":0.00721,"67":0,"68":0.03604,"69":0,"70":0.00721,"71":0,"72":0.00721,"73":0,"74":0,"75":0.00721,"76":0.00721,"77":0.01442,"78":0.05046,"79":0.01442,"80":0.04325,"81":1.7083,"82":0.25228,"83":0.00721,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00721,"37":0,"38":0.00721,"39":0,"40":0,"41":0,"42":0,"43":0.00721,"44":0,"45":0,"46":0,"47":0,"48":0.00721,"49":0.10812,"50":0,"51":0,"52":0,"53":0.01442,"54":0.00721,"55":0.00721,"56":0,"57":0,"58":0.01442,"59":0,"60":0,"61":0.03604,"62":0,"63":0.02162,"64":0,"65":0.01442,"66":0.00721,"67":0.02162,"68":0.00721,"69":0.01442,"70":0.05766,"71":0.07929,"72":0.06487,"73":0.04325,"74":0.03604,"75":0.04325,"76":0.02883,"77":0.03604,"78":0.06487,"79":0.0865,"80":0.14416,"81":0.10091,"83":0.18741,"84":0.35319,"85":15.46837,"86":25.86951,"87":0.07929,"88":0.02883,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.00721,"51":0.01442,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0.00721,"58":0.00721,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00721,"69":0,"70":0.12974,"71":1.90291,"72":0.03604,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":3.03987,"3.2":0.00728,"4.0-4.1":0.00624,"4.2-4.3":0.00104,"5.0-5.1":0.0052,"6.0-6.1":0.00312,"7.0-7.1":0.00728,"8.1-8.4":0.02393,"9.0-9.2":0.01352,"9.3":0.1727,"10.0-10.2":0.02913,"10.3":0.16021,"11.0-11.2":0.06034,"11.3-11.4":0.10299,"12.0-12.1":0.10507,"12.2-12.4":1.04762,"13.0-13.1":0.08635,"13.2":0.04265,"13.3":0.32459,"13.4-13.7":1.72904},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.00721,"13":0.06487,"14":0.49735,"3.1":0,"3.2":0,"5.1":0.00721,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00721,"11.1":0.02883,"12.1":0.05766,"13.1":0.46852},"edge":{"12":0,"13":0,"14":0.00721,"15":0.00721,"16":0.00721,"17":0.01442,"18":0.10091,"79":0,"80":0,"81":0,"83":0,"84":0.01442,"85":0.85775,"86":1.57134},"android":{"3":0,"4":0.02247,"81":null,"2.1":0,"2.2":0,"2.3":0.00018,"4.1":0.01133,"4.2-4.3":0.00503,"4.4":0,"4.4.3-4.4.4":0.04099},"samsung":{"4":0.05129,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.10259,"8.2":0,"9.2":0.05129,"10.1":0.02052,"11.1-11.2":0.08207,"12.0":1.4875},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.0659,"9":0.00824,"10":0.00824,"11":0.14828,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.06701},"and_qq":{"10.4":0.00279},"and_uc":{"0":0.07538},"op_mini":{"0":0.12688},"and_chr":{"0":37.60993}},"total":98.08249}

/***/ },
/* 1180 */
/***/ function(module, exports) {

	module.exports = {"id":"BS","name":"Bahamas","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00428,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0.00428,"42":0,"43":0,"44":0,"45":0.00428,"46":0,"47":0,"48":0.02568,"49":0,"50":0,"51":0,"52":0.00856,"53":0.00428,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0.00428,"67":0,"68":0,"69":0,"70":0,"71":0,"72":0.00428,"73":0,"74":0.01284,"75":0,"76":0,"77":0,"78":0.02568,"79":0.00856,"80":0.01712,"81":0.52216,"82":0.10272,"83":0.00428,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.04708,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0.00428,"59":0,"60":0,"61":0,"62":0,"63":0.00428,"64":0,"65":0.03852,"66":0,"67":0.01712,"68":0,"69":0.00428,"70":0.00856,"71":0.01712,"72":0.00428,"73":0.01284,"74":0.00856,"75":0.02568,"76":0.10272,"77":0.00856,"78":0.02996,"79":0.01712,"80":0.01284,"81":0.02568,"83":0.06848,"84":0.10272,"85":3.53528,"86":5.6068,"87":0.00856,"88":0.00428,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.00856,"71":0.05136,"72":0.00428,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":10.91196,"3.2":0.02614,"4.0-4.1":0.02241,"4.2-4.3":0.00373,"5.0-5.1":0.01867,"6.0-6.1":0.0112,"7.0-7.1":0.02614,"8.1-8.4":0.08589,"9.0-9.2":0.04855,"9.3":0.61991,"10.0-10.2":0.10456,"10.3":0.5751,"11.0-11.2":0.2166,"11.3-11.4":0.36971,"12.0-12.1":0.37718,"12.2-12.4":3.76056,"13.0-13.1":0.30996,"13.2":0.15311,"13.3":1.16514,"13.4-13.7":6.2066},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.01712,"13":0.107,"14":0.79608,"3.1":0,"3.2":0,"5.1":0.00856,"6.1":0,"7.1":0,"9.1":0,"10.1":0.01712,"11.1":0.04708,"12.1":0.05564,"13.1":1.36104},"edge":{"12":0.00428,"13":0.03424,"14":0.00856,"15":0.02996,"16":0.02996,"17":0.06848,"18":0.29104,"79":0,"80":0,"81":0,"83":0,"84":0.00856,"85":0.8346,"86":1.78048},"android":{"3":0,"4":0.18838,"81":null,"2.1":0,"2.2":0,"2.3":0.00151,"4.1":0.09494,"4.2-4.3":0.0422,"4.4":0,"4.4.3-4.4.4":0.34361},"samsung":{"4":0.08372,"5.0-5.4":0,"6.2-6.4":0.02093,"7.2-7.4":0.3558,"8.2":0.02093,"9.2":0.60696,"10.1":0.13604,"11.1-11.2":0.78486,"12.0":7.12656},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.35524,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.10296},"and_qq":{"10.4":0},"and_uc":{"0":0.02288},"op_mini":{"0":0.02708},"and_chr":{"0":44.5126}},"total":95.8732}

/***/ },
/* 1181 */
/***/ function(module, exports) {

	module.exports = {"id":"BT","name":"Bhutan","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00391,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.01174,"69":0.00391,"70":0,"71":0,"72":0.00391,"73":0,"74":0.00391,"75":0,"76":0,"77":0,"78":0.00782,"79":0.00391,"80":0.01565,"81":0.43032,"82":0.11345,"83":0.02347,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.04694,"50":0,"51":0,"52":0,"53":0.00782,"54":0.00391,"55":0,"56":0,"57":0,"58":0,"59":0.00391,"60":0,"61":0,"62":0,"63":0.00782,"64":0,"65":0.00391,"66":0.01174,"67":0.05477,"68":0.01956,"69":0.00391,"70":0.00391,"71":0.00391,"72":0.00391,"73":0.01174,"74":0.01565,"75":0.02347,"76":0.00782,"77":0.02347,"78":0.01174,"79":0.01956,"80":0.12518,"81":0.05477,"83":0.04303,"84":0.1643,"85":3.93547,"86":5.84844,"87":0.04303,"88":0.01174,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.01174,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00391,"52":0,"53":0,"54":0,"55":0.00391,"56":0,"57":0,"58":0,"60":0.01174,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0.00391,"70":0.01565,"71":0.12518,"72":0.00391,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":4.11206,"3.2":0.00985,"4.0-4.1":0.00844,"4.2-4.3":0.00141,"5.0-5.1":0.00704,"6.0-6.1":0.00422,"7.0-7.1":0.00985,"8.1-8.4":0.03237,"9.0-9.2":0.01829,"9.3":0.23361,"10.0-10.2":0.0394,"10.3":0.21672,"11.0-11.2":0.08162,"11.3-11.4":0.13932,"12.0-12.1":0.14213,"12.2-12.4":1.41713,"13.0-13.1":0.1168,"13.2":0.0577,"13.3":0.43907,"13.4-13.7":2.33889},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.01174,"13":0.02738,"14":0.18386,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00391,"11.1":0.00391,"12.1":0.02347,"13.1":0.11736},"edge":{"12":0.01565,"13":0.00782,"14":0.00391,"15":0.02738,"16":0.00391,"17":0.01565,"18":0.08606,"79":0,"80":0,"81":0.00391,"83":0,"84":0.01174,"85":0.29731,"86":0.6181},"android":{"3":0,"4":0.0083,"81":null,"2.1":0,"2.2":0,"2.3":0.00007,"4.1":0.00418,"4.2-4.3":0.00186,"4.4":0,"4.4.3-4.4.4":0.01515},"samsung":{"4":0.67413,"5.0-5.4":0,"6.2-6.4":0.01006,"7.2-7.4":0.31191,"8.2":0.05031,"9.2":0.3924,"10.1":0.11068,"11.1-11.2":0.49302,"12.0":1.30801},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.02738,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.04262},"and_qq":{"10.4":0},"and_uc":{"0":3.37884},"op_mini":{"0":0.25937},"and_chr":{"0":67.83225}},"total":97.12691}

/***/ },
/* 1182 */
/***/ function(module, exports) {

	module.exports = {"id":"BW","name":"Botswana","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0.00622,"5":0.00622,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0.00622,"16":0,"17":0.00622,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.01243,"30":0.00622,"31":0,"32":0.00622,"33":0.00622,"34":0.00622,"35":0.00622,"36":0,"37":0,"38":0,"39":0,"40":0.00622,"41":0.00622,"42":0,"43":0.0373,"44":0.00622,"45":0.00622,"46":0,"47":0.02487,"48":0.01865,"49":0.01243,"50":0.00622,"51":0,"52":0.02487,"53":0,"54":0,"55":0,"56":0.0373,"57":0,"58":0.00622,"59":0.00622,"60":0.01243,"61":0,"62":0.00622,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.0373,"69":0.00622,"70":0.00622,"71":0.00622,"72":0.02487,"73":0.00622,"74":0.01865,"75":0.00622,"76":0,"77":0.00622,"78":0.35437,"79":0.06217,"80":0.13056,"81":2.92821,"82":0.39167,"83":0.05595,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0.01865,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0.00622,"31":0,"32":0,"33":0.00622,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.03109,"41":0,"42":0.00622,"43":0.03109,"44":0,"45":0,"46":0.00622,"47":0,"48":0,"49":0.28598,"50":0.00622,"51":0.00622,"52":0,"53":0.01865,"54":0,"55":0.00622,"56":0,"57":0.00622,"58":0.05595,"59":0,"60":0.00622,"61":0.00622,"62":0.00622,"63":0.04352,"64":0,"65":0.14299,"66":0.00622,"67":0.15543,"68":0.03109,"69":0.01865,"70":0.01865,"71":0.0373,"72":0.01865,"73":0.04974,"74":0.11812,"75":0.03109,"76":0.09326,"77":0.06839,"78":0.0373,"79":0.08082,"80":0.16164,"81":0.32328,"83":0.19273,"84":0.3668,"85":8.06967,"86":14.07529,"87":0.19894,"88":0.04352,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0.00622,"28":0.00622,"29":0,"30":0,"31":0.00622,"32":0,"33":0,"34":0,"35":0.00622,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.00622,"47":0,"48":0,"49":0,"50":0.0373,"51":0.14921,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00622,"62":0,"63":0.00622,"64":0,"65":0,"66":0,"67":0.00622,"68":0.00622,"69":0,"70":0.10569,"71":0.76469,"72":0.00622,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00622},"ios_saf":{"8":0,"14":2.58919,"3.2":0.0062,"4.0-4.1":0.00532,"4.2-4.3":0.00089,"5.0-5.1":0.00443,"6.0-6.1":0.00266,"7.0-7.1":0.0062,"8.1-8.4":0.02038,"9.0-9.2":0.01152,"9.3":0.14709,"10.0-10.2":0.02481,"10.3":0.13646,"11.0-11.2":0.05139,"11.3-11.4":0.08772,"12.0-12.1":0.0895,"12.2-12.4":0.8923,"13.0-13.1":0.07355,"13.2":0.03633,"13.3":0.27646,"13.4-13.7":1.4727},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00622,"11":0.01243,"12":0.0373,"13":0.13677,"14":0.97607,"3.1":0,"3.2":0,"5.1":0.15543,"6.1":0,"7.1":0,"9.1":0.00622,"10.1":0.0373,"11.1":0.13056,"12.1":0.18651,"13.1":0.56575},"edge":{"12":0.06217,"13":0.08082,"14":0.05595,"15":0.03109,"16":0.16164,"17":0.10569,"18":0.49114,"79":0,"80":0,"81":0.00622,"83":0.00622,"84":0.0373,"85":0.70252,"86":1.36152},"android":{"3":0,"4":0.06286,"81":null,"2.1":0,"2.2":0,"2.3":0.0005,"4.1":0.03168,"4.2-4.3":0.01408,"4.4":0,"4.4.3-4.4.4":0.11466},"samsung":{"4":0.21358,"5.0-5.4":0,"6.2-6.4":0.01017,"7.2-7.4":0.24409,"8.2":0.04068,"9.2":0.12205,"10.1":0.04068,"11.1-11.2":0.12205,"12.0":1.85102},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.03125,"9":0,"10":0.01562,"11":1.14057,"5.5":0},"bb":{"7":0,"10":0.03026},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.00378},"baidu":{"0":null},"and_ff":{"0":0.15889},"and_qq":{"10.4":0.14375},"and_uc":{"0":0.86631},"op_mini":{"0":0.74137},"and_chr":{"0":49.11649}},"total":96.74965}

/***/ },
/* 1183 */
/***/ function(module, exports) {

	module.exports = {"id":"BY","name":"Belarus","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0.00768,"28":0.00768,"29":0,"30":0.03072,"31":0.04607,"32":0.0384,"33":0.05375,"34":0.05375,"35":0.0384,"36":0.05375,"37":0.0384,"38":0.06911,"39":0.04607,"40":0.06143,"41":0.06143,"42":0.09215,"43":0.08447,"44":0.07679,"45":0.09983,"46":0.04607,"47":0.09215,"48":0.06911,"49":0.05375,"50":0.06911,"51":0.06143,"52":0.16126,"53":0.06143,"54":0.06143,"55":0.04607,"56":0.07679,"57":0.09215,"58":0.06911,"59":0.06143,"60":0.06143,"61":0.04607,"62":0.04607,"63":0.07679,"64":0.03072,"65":0.07679,"66":0.04607,"67":0.08447,"68":0.06143,"69":0.02304,"70":0.02304,"71":0.02304,"72":0.04607,"73":0.03072,"74":0.01536,"75":0.00768,"76":0.01536,"77":0.00768,"78":0.07679,"79":0.02304,"80":0.12286,"81":2.05797,"82":0.25341,"83":0.00768,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0.02304,"6":0,"7":0,"8":0,"9":0,"10":0.00768,"11":0.01536,"12":0.00768,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0.00768,"21":0.01536,"22":0.00768,"23":0.00768,"24":0.00768,"25":0.00768,"26":0.02304,"27":0,"28":0,"29":0,"30":0,"31":0.04607,"32":0.01536,"33":0.00768,"34":0.03072,"35":0.02304,"36":0.0384,"37":0.02304,"38":0.02304,"39":0.02304,"40":0.01536,"41":0.06143,"42":0.02304,"43":0.01536,"44":0.00768,"45":0.03072,"46":0.09983,"47":0.09983,"48":0.05375,"49":0.4377,"50":0.02304,"51":0.06911,"52":0.0384,"53":0.06143,"54":0.04607,"55":0.06911,"56":0.08447,"57":0.09215,"58":0.06143,"59":0.08447,"60":0.12286,"61":0.08447,"62":0.09983,"63":0.13054,"64":0.09983,"65":0.07679,"66":0.09983,"67":0.12286,"68":0.09983,"69":0.09983,"70":0.23037,"71":0.15358,"72":0.1843,"73":0.13054,"74":0.1459,"75":0.13822,"76":0.08447,"77":0.19965,"78":0.19965,"79":0.27644,"80":0.36091,"81":0.12286,"83":0.23805,"84":0.36859,"85":12.66267,"86":19.44323,"87":0.02304,"88":0.01536,"89":0},"opera":{"9":0,"11":0.00768,"12":0.01536,"15":0.02304,"16":0.00768,"17":0.00768,"18":0,"19":0.01536,"20":0.00768,"21":0.00768,"22":0,"23":0,"24":0,"25":0.00768,"26":0,"27":0.00768,"28":0,"29":0.00768,"30":0,"31":0.00768,"32":0.01536,"33":0.00768,"34":0.01536,"35":0,"36":0.13054,"37":0.01536,"38":0.00768,"39":0.00768,"40":0.01536,"41":0.01536,"42":0.00768,"43":0.01536,"44":0.00768,"45":0.01536,"46":0.00768,"47":0,"48":0,"49":0,"50":0.01536,"51":0.05375,"52":0,"53":0.01536,"54":0.00768,"55":0,"56":0.00768,"57":0.01536,"58":0.00768,"60":0.01536,"62":0.02304,"63":0.00768,"64":0,"65":0.00768,"66":0,"67":0.00768,"68":0.03072,"69":0.01536,"70":0.67575,"71":4.53829,"72":0.06143,"9.5-9.6":0,"10.0-10.1":0.00768,"10.5":0,"10.6":0,"11.1":0,"11.5":0.00768,"11.6":0.01536,"12.1":0.06911},"ios_saf":{"8":0,"14":2.85607,"3.2":0.00684,"4.0-4.1":0.00586,"4.2-4.3":0.00098,"5.0-5.1":0.00489,"6.0-6.1":0.00293,"7.0-7.1":0.00684,"8.1-8.4":0.02248,"9.0-9.2":0.01271,"9.3":0.16225,"10.0-10.2":0.02737,"10.3":0.15053,"11.0-11.2":0.05669,"11.3-11.4":0.09677,"12.0-12.1":0.09872,"12.2-12.4":0.98428,"13.0-13.1":0.08113,"13.2":0.04007,"13.3":0.30496,"13.4-13.7":1.6245},"safari":{"0":null,"4":0.0384,"5":0.05375,"6":0.01536,"7":0.0384,"8":0.04607,"9":0.04607,"10":0.03072,"11":0.03072,"12":0.06143,"13":0.23805,"14":0.95988,"3.1":0.02304,"3.2":0.01536,"5.1":0.46842,"6.1":0.0384,"7.1":0.02304,"9.1":0.06143,"10.1":0.06911,"11.1":0.06911,"12.1":0.13054,"13.1":0.89844},"edge":{"12":0.03072,"13":0.0384,"14":0.07679,"15":0.03072,"16":0.01536,"17":0.0384,"18":0.13054,"79":0,"80":0,"81":0,"83":0,"84":0.00768,"85":0.27644,"86":0.4761},"android":{"3":0,"4":0.04329,"81":null,"2.1":0,"2.2":0,"2.3":0.00035,"4.1":0.02182,"4.2-4.3":0.0097,"4.4":0,"4.4.3-4.4.4":0.07895},"samsung":{"4":0.07122,"5.0-5.4":0,"6.2-6.4":0.02035,"7.2-7.4":0.01017,"8.2":0.01017,"9.2":0.03052,"10.1":0.03052,"11.1-11.2":0.05087,"12.0":0.99702},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0.02432,"8":0.04053,"9":0.08106,"10":0.05674,"11":0.23506,"5.5":0},"bb":{"7":0,"10":0.00464},"ie_mob":{"10":0.01277,"11":0.01277},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.06731},"and_qq":{"10.4":0.00696},"and_uc":{"0":0.1439},"op_mini":{"0":0.57791},"and_chr":{"0":29.76691}},"total":92.53688}

/***/ },
/* 1184 */
/***/ function(module, exports) {

	module.exports = {"id":"BZ","name":"Belize","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00556,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0.00556,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0.01113,"64":0,"65":0,"66":0,"67":0,"68":0.00556,"69":0,"70":0,"71":0,"72":0.02782,"73":0.00556,"74":0,"75":0.00556,"76":0,"77":0.00556,"78":0.05564,"79":0.01669,"80":0.10015,"81":1.77492,"82":0.31158,"83":0.01669,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.26151,"50":0,"51":0,"52":0,"53":0.01113,"54":0,"55":0.05008,"56":0.00556,"57":0,"58":0.01113,"59":0.01113,"60":0.00556,"61":0,"62":0,"63":0.00556,"64":0,"65":0.01669,"66":0.01113,"67":0.00556,"68":0.00556,"69":0.00556,"70":0.09459,"71":0.02226,"72":0.03338,"73":0.00556,"74":0.01113,"75":0.07233,"76":0.10015,"77":0.03895,"78":0.02782,"79":0.02782,"80":0.04451,"81":0.05008,"83":0.1391,"84":0.17805,"85":6.78252,"86":11.11687,"87":0.02226,"88":0.00556,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.00556,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.07233,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0.01669,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.10015,"71":0.90693,"72":0.01113,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":5.84023,"3.2":0.01399,"4.0-4.1":0.01199,"4.2-4.3":0.002,"5.0-5.1":0.00999,"6.0-6.1":0.006,"7.0-7.1":0.01399,"8.1-8.4":0.04597,"9.0-9.2":0.02598,"9.3":0.33179,"10.0-10.2":0.05596,"10.3":0.3078,"11.0-11.2":0.11593,"11.3-11.4":0.19787,"12.0-12.1":0.20187,"12.2-12.4":2.0127,"13.0-13.1":0.16589,"13.2":0.08195,"13.3":0.6236,"13.4-13.7":3.32186},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.02226,"12":0.08902,"13":0.08346,"14":0.57866,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00556,"11.1":0.07233,"12.1":0.03895,"13.1":1.27972},"edge":{"12":0.01113,"13":0.02226,"14":0.00556,"15":0.01113,"16":0.01669,"17":0.03338,"18":0.4173,"79":0,"80":0.00556,"81":0,"83":0.00556,"84":0.01113,"85":0.85686,"86":1.76379},"android":{"3":0,"4":0.49538,"81":null,"2.1":0,"2.2":0,"2.3":0.00396,"4.1":0.24967,"4.2-4.3":0.11097,"4.4":0,"4.4.3-4.4.4":0.90358},"samsung":{"4":0.12778,"5.0-5.4":0,"6.2-6.4":0.01065,"7.2-7.4":0.14908,"8.2":0.01065,"9.2":0.13843,"10.1":0.0213,"11.1-11.2":0.41529,"12.0":3.88666},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00581,"9":0,"10":0,"11":0.2557,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.23067},"and_qq":{"10.4":0.03549},"and_uc":{"0":0.08872},"op_mini":{"0":0.21839},"and_chr":{"0":48.28544}},"total":97.00116}

/***/ },
/* 1185 */
/***/ function(module, exports) {

	module.exports = {"id":"CA","name":"Canada","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.01215,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.01215,"39":0,"40":0,"41":0,"42":0,"43":0.01215,"44":0.03646,"45":0.01215,"46":0,"47":0.00608,"48":0.01215,"49":0,"50":0,"51":0,"52":0.04861,"53":0.00608,"54":0,"55":0,"56":0.01215,"57":0,"58":0,"59":0,"60":0.00608,"61":0,"62":0,"63":0.24304,"64":0.01215,"65":0.01215,"66":0.01215,"67":0.00608,"68":0.04861,"69":0.00608,"70":0.00608,"71":0.00608,"72":0.01215,"73":0.00608,"74":0.00608,"75":0.01215,"76":0.00608,"77":0.01215,"78":0.09722,"79":0.0243,"80":0.10329,"81":1.87748,"82":0.31595,"83":0.00608,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0.01215,"26":0,"27":0,"28":0,"29":0.00608,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00608,"39":0,"40":0.00608,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.01215,"48":0.09722,"49":0.26127,"50":0,"51":0,"52":0.00608,"53":0.01215,"54":0,"55":0.00608,"56":0.00608,"57":0.00608,"58":0.00608,"59":0.00608,"60":0.00608,"61":0.0243,"62":0.00608,"63":0.01215,"64":0.00608,"65":0.0243,"66":0.01823,"67":0.03038,"68":0.1762,"69":0.03646,"70":0.3038,"71":0.09722,"72":0.08506,"73":0.06076,"74":0.03646,"75":0.05468,"76":0.06076,"77":0.03646,"78":0.05468,"79":0.09114,"80":0.15798,"81":0.13367,"83":0.26127,"84":0.41924,"85":7.80766,"86":10.84566,"87":0.01823,"88":0.01215,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00608,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.01215,"52":0.00608,"53":0,"54":0,"55":0,"56":0.00608,"57":0.00608,"58":0.00608,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00608,"69":0,"70":0.04253,"71":0.23089,"72":0.00608,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00608},"ios_saf":{"8":0,"14":14.21346,"3.2":0.03405,"4.0-4.1":0.02919,"4.2-4.3":0.00486,"5.0-5.1":0.02432,"6.0-6.1":0.01459,"7.0-7.1":0.03405,"8.1-8.4":0.11188,"9.0-9.2":0.06324,"9.3":0.80747,"10.0-10.2":0.1362,"10.3":0.7491,"11.0-11.2":0.28213,"11.3-11.4":0.48156,"12.0-12.1":0.49129,"12.2-12.4":4.89834,"13.0-13.1":0.40374,"13.2":0.19944,"13.3":1.51766,"13.4-13.7":8.08445},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0.00608,"9":0.01215,"10":0.00608,"11":0.01823,"12":0.03038,"13":0.21874,"14":1.74989,"3.1":0,"3.2":0,"5.1":0.00608,"6.1":0.00608,"7.1":0,"9.1":0.01823,"10.1":0.06076,"11.1":0.13367,"12.1":0.20051,"13.1":2.49724},"edge":{"12":0.00608,"13":0.00608,"14":0.00608,"15":0.00608,"16":0.01215,"17":0.27342,"18":0.26734,"79":0,"80":0,"81":0.00608,"83":0.00608,"84":0.01215,"85":0.97216,"86":1.95647},"android":{"3":0,"4":0.11208,"81":null,"2.1":0,"2.2":0,"2.3":0.0009,"4.1":0.05649,"4.2-4.3":0.0251,"4.4":0,"4.4.3-4.4.4":0.20443},"samsung":{"4":0.09575,"5.0-5.4":0.01064,"6.2-6.4":0,"7.2-7.4":0.02128,"8.2":0.01064,"9.2":0.04256,"10.1":0.02128,"11.1-11.2":0.07448,"12.0":3.36206},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0.03547,"7":0,"8":0.03547,"9":0.02838,"10":0.01419,"11":1.02877,"5.5":0},"bb":{"7":0,"10":0.02354},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.32962},"and_qq":{"10.4":0.04316},"and_uc":{"0":0.16873},"op_mini":{"0":0.12631},"and_chr":{"0":25.33088}},"total":96.94617}

/***/ },
/* 1186 */
/***/ function(module, exports) {

	module.exports = {"id":"CD","name":"Congo, The Democratic Republic of","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":null,"3":0.02897,"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":0.00263,"30":0.01317,"31":null,"32":0.00527,"33":0.00527,"34":0.00527,"35":null,"36":null,"37":null,"38":null,"39":null,"40":0.00263,"41":0.00527,"42":null,"43":0.01054,"44":0.01317,"45":0.0079,"46":null,"47":0.01054,"48":0.01844,"49":0.00263,"50":null,"51":null,"52":0.05531,"53":null,"54":null,"55":null,"56":0.00527,"57":0.00527,"58":null,"59":null,"60":0.01054,"61":null,"62":null,"63":null,"64":null,"65":null,"66":null,"67":0.00263,"68":0.06058,"69":0.00263,"70":0.00527,"71":null,"72":0.06585,"73":null,"74":0.0079,"75":0.0079,"76":0.02107,"77":0.02371,"78":0.10799,"79":0.06322,"80":0.1475,"81":3.03964,"82":0.31345,"83":0.01317,"84":null,"3.5":null,"3.6":null},"chrome":{"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":0.00263,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":0.00263,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":0.00527,"30":null,"31":null,"32":0.00263,"33":0.03424,"34":null,"35":null,"36":null,"37":null,"38":0.00527,"39":null,"40":0.00527,"41":null,"42":0.00263,"43":0.01844,"44":null,"45":null,"46":null,"47":null,"48":0.0079,"49":0.10799,"50":0.00527,"51":null,"52":null,"53":null,"54":null,"55":0.02371,"56":null,"57":0.00527,"58":0.0079,"59":null,"60":0.01054,"61":0.00263,"62":null,"63":0.03424,"64":0.02634,"65":0.02107,"66":null,"67":0.00527,"68":null,"69":0.04741,"70":0.0158,"71":0.00527,"72":0.00263,"73":0.01054,"74":0.0158,"75":0.02107,"76":0.0079,"77":0.05005,"78":0.01844,"79":0.07902,"80":0.07639,"81":0.03161,"83":0.13697,"84":0.21862,"85":4.89397,"86":6.24521,"87":0.0079,"88":0.00263,"89":null},"opera":{"9":null,"11":null,"12":0.00263,"15":null,"16":null,"17":null,"18":0.03161,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":0.00263,"31":null,"32":null,"33":null,"34":0.01054,"35":null,"36":0.0079,"37":null,"38":null,"39":null,"40":null,"41":null,"42":0.01317,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":null,"51":null,"52":null,"53":null,"54":null,"55":null,"56":null,"57":null,"58":null,"60":0.00527,"62":0.00527,"63":0.02371,"64":null,"65":0.00263,"66":0.04478,"67":0.0079,"68":0.02107,"69":0.0079,"70":0.48202,"71":1.8517,"72":0.04478,"9.5-9.6":null,"10.0-10.1":0,"10.5":null,"10.6":null,"11.1":null,"11.5":null,"11.6":null,"12.1":0.0079},"ios_saf":{"8":0,"14":2.03088,"3.2":0.00487,"4.0-4.1":0.00417,"4.2-4.3":0.0007,"5.0-5.1":0.00348,"6.0-6.1":0.00209,"7.0-7.1":0.00487,"8.1-8.4":0.01599,"9.0-9.2":0.00904,"9.3":0.11538,"10.0-10.2":0.01946,"10.3":0.10703,"11.0-11.2":0.04031,"11.3-11.4":0.06881,"12.0-12.1":0.0702,"12.2-12.4":0.6999,"13.0-13.1":0.05769,"13.2":0.0285,"13.3":0.21685,"13.4-13.7":1.15514},"safari":{"0":null,"4":0,"5":null,"6":null,"7":null,"8":null,"9":null,"10":0.00527,"11":0.04478,"12":0.24233,"13":0.13433,"14":0.33452,"3.1":null,"3.2":null,"5.1":0.06848,"6.1":null,"7.1":0.00263,"9.1":0.0079,"10.1":0.1317,"11.1":0.03688,"12.1":0.21072,"13.1":0.32662},"edge":{"12":0.11326,"13":0.02897,"14":0.02897,"15":0.02371,"16":0.02897,"17":0.10009,"18":0.31345,"79":null,"80":null,"81":0.00263,"83":0.00263,"84":0.02371,"85":0.48729,"86":0.87712},"android":{"3":0,"4":0.10966,"81":null,"2.1":0,"2.2":0,"2.3":0.00088,"4.1":0.05527,"4.2-4.3":0.02456,"4.4":0,"4.4.3-4.4.4":0.20002},"samsung":{"4":0.33026,"5.0-5.4":0.03096,"6.2-6.4":0.01032,"7.2-7.4":0.08256,"8.2":0,"9.2":0.13417,"10.1":0.13417,"11.1-11.2":0.11353,"12.0":1.04237},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":null,"7":null,"8":0.39115,"9":null,"10":null,"11":0.39115,"5.5":null},"bb":{"7":0,"10":0.0442},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.10312},"baidu":{"0":null},"and_ff":{"0":0.3462},"and_qq":{"10.4":0.08103},"and_uc":{"0":1.34798},"op_mini":{"0":30.11223},"and_chr":{"0":35.47105}},"total":97.67754}

/***/ },
/* 1187 */
/***/ function(module, exports) {

	module.exports = {"id":"CF","name":"Central African Republic","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0.00524,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0.00262,"24":0,"25":0.00524,"26":0,"27":0,"28":0,"29":0,"30":0.00262,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0.00787,"40":0,"41":0.00262,"42":0,"43":0,"44":0.00262,"45":0.00524,"46":0,"47":0.00262,"48":0,"49":0,"50":0,"51":0.00262,"52":0.00787,"53":0.00262,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0.00787,"60":0.00524,"61":0.00262,"62":0,"63":0,"64":0.00524,"65":0.00262,"66":0,"67":0,"68":0.07604,"69":0.00262,"70":0,"71":0.00262,"72":0.00262,"73":0,"74":0,"75":0,"76":0,"77":0.00524,"78":0.04195,"79":0.00787,"80":0.03409,"81":0.83117,"82":0.04195,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.01049,"35":0,"36":0,"37":0.00262,"38":0,"39":0,"40":0.00262,"41":0,"42":0,"43":0.00787,"44":0,"45":0,"46":0.00262,"47":0,"48":0,"49":0.00262,"50":0.01311,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0.00524,"57":0.00262,"58":0,"59":0.00262,"60":0,"61":0,"62":0,"63":0.00787,"64":0.00787,"65":0,"66":0,"67":0,"68":0.00787,"69":0,"70":0,"71":0,"72":0.00262,"73":0,"74":0.00787,"75":0.00262,"76":0.00787,"77":0.00524,"78":0,"79":0.02622,"80":0.01573,"81":0.05506,"83":0.0236,"84":0.0472,"85":1.0016,"86":1.67284,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0.00262,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00262,"37":0,"38":0.00262,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00262,"48":0,"49":0.00262,"50":0.00524,"51":0.02098,"52":0,"53":0.00262,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.11799,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0.00524,"68":0.00262,"69":0,"70":0.0236,"71":0.07342,"72":0.01573,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00787},"ios_saf":{"8":0,"14":2.08088,"3.2":0.00499,"4.0-4.1":0.00427,"4.2-4.3":0.00071,"5.0-5.1":0.00356,"6.0-6.1":0.00214,"7.0-7.1":0.00499,"8.1-8.4":0.01638,"9.0-9.2":0.00926,"9.3":0.11822,"10.0-10.2":0.01994,"10.3":0.10967,"11.0-11.2":0.0413,"11.3-11.4":0.0705,"12.0-12.1":0.07193,"12.2-12.4":0.71713,"13.0-13.1":0.05911,"13.2":0.0292,"13.3":0.22219,"13.4-13.7":1.18358},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00262,"12":0,"13":0.00524,"14":0.02098,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0,"12.1":0.00524,"13.1":0.1547},"edge":{"12":0.04195,"13":0.03146,"14":0.03933,"15":0.37495,"16":0,"17":0.0472,"18":0.05244,"79":0,"80":0.00262,"81":0.00262,"83":0,"84":0.07079,"85":0.07342,"86":0.06555},"android":{"3":0,"4":0.80585,"81":null,"2.1":0,"2.2":0,"2.3":0.00645,"4.1":0.40615,"4.2-4.3":0.18051,"4.4":0,"4.4.3-4.4.4":1.46988},"samsung":{"4":0.48993,"5.0-5.4":0.06124,"6.2-6.4":0.11228,"7.2-7.4":0.23476,"8.2":0.11228,"9.2":0.11228,"10.1":3.29682,"11.1-11.2":0.62262,"12.0":0.86758},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01049,"9":0,"10":0,"11":0.07866,"5.5":0},"bb":{"7":0,"10":0.00738},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.10329},"baidu":{"0":null},"and_ff":{"0":0.20658},"and_qq":{"10.4":0.07378},"and_uc":{"0":0.55335},"op_mini":{"0":7.48095},"and_chr":{"0":68.30444}},"total":95.71109}

/***/ },
/* 1188 */
/***/ function(module, exports) {

	module.exports = {"id":"CG","name":"Congo, Republic of the","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":null,"3":0.07655,"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":0.0164,"16":null,"17":0.0164,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":0.0164,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":null,"39":0.03281,"40":0.01094,"41":null,"42":0.01094,"43":0.02187,"44":null,"45":0.00547,"46":0.00547,"47":0.0164,"48":0.06015,"49":null,"50":null,"51":null,"52":0.2898,"53":null,"54":null,"55":null,"56":null,"57":null,"58":null,"59":null,"60":0.02734,"61":null,"62":null,"63":null,"64":null,"65":0.0164,"66":null,"67":null,"68":null,"69":0.10936,"70":0.01094,"71":null,"72":0.07108,"73":null,"74":0.01094,"75":null,"76":0.06562,"77":0.02734,"78":0.3937,"79":0.03281,"80":0.22419,"81":7.28884,"82":0.84754,"83":0.06015,"84":0.02734,"3.5":null,"3.6":null},"chrome":{"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":0.00547,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":0.01094,"34":null,"35":null,"36":null,"37":0.01094,"38":null,"39":null,"40":null,"41":null,"42":null,"43":0.01094,"44":null,"45":null,"46":null,"47":null,"48":null,"49":0.33355,"50":null,"51":null,"52":null,"53":null,"54":null,"55":null,"56":0.0164,"57":null,"58":null,"59":null,"60":0.01094,"61":null,"62":null,"63":0.19138,"64":0.00547,"65":0.02187,"66":null,"67":0.1531,"68":0.04374,"69":0.01094,"70":0.00547,"71":0.00547,"72":null,"73":0.02187,"74":0.05468,"75":0.02187,"76":0.17498,"77":0.06015,"78":0.06562,"79":0.13123,"80":0.19685,"81":0.10936,"83":0.62882,"84":0.34448,"85":10.19782,"86":14.45739,"87":null,"88":null,"89":null},"opera":{"9":null,"11":null,"12":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":0.01094,"37":null,"38":null,"39":null,"40":0.00547,"41":null,"42":0.01094,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":null,"51":null,"52":null,"53":null,"54":null,"55":null,"56":null,"57":null,"58":null,"60":null,"62":null,"63":0.00547,"64":null,"65":null,"66":null,"67":0.01094,"68":0.01094,"69":0.0164,"70":0.77646,"71":3.25346,"72":0.09296,"9.5-9.6":null,"10.0-10.1":0,"10.5":null,"10.6":null,"11.1":null,"11.5":null,"11.6":null,"12.1":0.0164},"ios_saf":{"8":0,"14":1.45316,"3.2":0.00348,"4.0-4.1":0.00298,"4.2-4.3":0.0005,"5.0-5.1":0.00249,"6.0-6.1":0.00149,"7.0-7.1":0.00348,"8.1-8.4":0.01144,"9.0-9.2":0.00647,"9.3":0.08255,"10.0-10.2":0.01392,"10.3":0.07659,"11.0-11.2":0.02884,"11.3-11.4":0.04923,"12.0-12.1":0.05023,"12.2-12.4":0.5008,"13.0-13.1":0.04128,"13.2":0.02039,"13.3":0.15516,"13.4-13.7":0.82654},"safari":{"0":null,"4":0,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":0.06015,"13":0.2898,"14":0.4265,"3.1":null,"3.2":null,"5.1":null,"6.1":null,"7.1":0.00547,"9.1":0.0164,"10.1":0.02734,"11.1":0.03828,"12.1":0.00547,"13.1":0.71631},"edge":{"12":0.06562,"13":0.0164,"14":0.02187,"15":0.02187,"16":0.03281,"17":0.04921,"18":3.10036,"79":null,"80":null,"81":0.01094,"83":0.01094,"84":0.0164,"85":0.88035,"86":1.85365},"android":{"3":0,"4":0.17822,"81":null,"2.1":0,"2.2":0,"2.3":0.00143,"4.1":0.08983,"4.2-4.3":0.03992,"4.4":0,"4.4.3-4.4.4":0.32508},"samsung":{"4":0.36675,"5.0-5.4":0.03144,"6.2-6.4":0.01032,"7.2-7.4":0.13622,"8.2":0,"9.2":0.07335,"10.1":0.31436,"11.1-11.2":0.06287,"12.0":0.82781},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":null,"7":null,"8":0.20167,"9":null,"10":null,"11":0.94114,"5.5":null},"bb":{"7":0,"10":0.05438},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.61182},"baidu":{"0":null},"and_ff":{"0":0.29005},"and_qq":{"10.4":0.05438},"and_uc":{"0":1.45024},"op_mini":{"0":2.25686},"and_chr":{"0":38.28804}},"total":98.90865}

/***/ },
/* 1189 */
/***/ function(module, exports) {

	module.exports = {"id":"CH","name":"Switzerland","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0.00619,"29":0.01857,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.00619,"46":0,"47":0,"48":0.02476,"49":0,"50":0,"51":0,"52":0.03713,"53":0,"54":0.00619,"55":0.00619,"56":0.04332,"57":0.01238,"58":0,"59":0.00619,"60":0.02476,"61":0,"62":0.00619,"63":0.00619,"64":0,"65":0.00619,"66":0.00619,"67":0.00619,"68":0.14235,"69":0.01238,"70":0.01238,"71":0.00619,"72":0.03713,"73":0.01238,"74":0.01238,"75":0.00619,"76":0.01857,"77":0.02476,"78":0.29707,"79":0.04951,"80":0.19805,"81":3.73816,"82":0.55701,"83":0.01238,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0.00619,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0.00619,"29":0,"30":0,"31":0.00619,"32":0.00619,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.01238,"39":0,"40":0,"41":0.00619,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.12378,"50":0,"51":0,"52":0.06189,"53":0.01238,"54":0,"55":0,"56":0,"57":0.00619,"58":0,"59":0.00619,"60":0.0557,"61":0,"62":0.00619,"63":0.01238,"64":0.00619,"65":0.01857,"66":0.03713,"67":0.01857,"68":0.00619,"69":0.01238,"70":0.02476,"71":0.02476,"72":0.02476,"73":0.01857,"74":0.01857,"75":0.03095,"76":0.03095,"77":0.03713,"78":0.03713,"79":0.09902,"80":0.14854,"81":0.07427,"83":0.25375,"84":0.37753,"85":6.8079,"86":9.51868,"87":0.01238,"88":0.00619,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00619,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00619,"52":0,"53":0.00619,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00619,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00619,"69":0,"70":0.09284,"71":0.60652,"72":0.01238,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":14.28819,"3.2":0.03423,"4.0-4.1":0.02934,"4.2-4.3":0.00489,"5.0-5.1":0.02445,"6.0-6.1":0.01467,"7.0-7.1":0.03423,"8.1-8.4":0.11247,"9.0-9.2":0.06357,"9.3":0.81172,"10.0-10.2":0.13692,"10.3":0.75304,"11.0-11.2":0.28361,"11.3-11.4":0.4841,"12.0-12.1":0.49388,"12.2-12.4":4.9241,"13.0-13.1":0.40586,"13.2":0.20048,"13.3":1.52564,"13.4-13.7":8.12696},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0.00619,"9":0.02476,"10":0.02476,"11":0.04332,"12":0.06808,"13":0.34658,"14":2.85932,"3.1":0,"3.2":0,"5.1":0.00619,"6.1":0.00619,"7.1":0,"9.1":0.03095,"10.1":0.08665,"11.1":0.27232,"12.1":0.36515,"13.1":2.89645},"edge":{"12":0,"13":0,"14":0.00619,"15":0.00619,"16":0.03095,"17":0.06808,"18":0.48893,"79":0,"80":0.01238,"81":0.01238,"83":0.01238,"84":0.04332,"85":1.29969,"86":2.56225},"android":{"3":0,"4":0.03999,"81":null,"2.1":0,"2.2":0,"2.3":0.00032,"4.1":0.02016,"4.2-4.3":0.00896,"4.4":0,"4.4.3-4.4.4":0.07295},"samsung":{"4":0.09424,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.02094,"8.2":0.01047,"9.2":0.05235,"10.1":0.06282,"11.1-11.2":0.11518,"12.0":3.82181},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00639,"9":0.00639,"10":0,"11":1.15694,"5.5":0},"bb":{"7":0,"10":0.00381},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.52592},"and_qq":{"10.4":0.02287},"and_uc":{"0":0.08003},"op_mini":{"0":0.18401},"and_chr":{"0":22.05996}},"total":96.77381}

/***/ },
/* 1190 */
/***/ function(module, exports) {

	module.exports = {"id":"CI","name":"Cote d'Ivoire","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.01053,"30":0,"31":0,"32":0.01053,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00527,"44":0,"45":0,"46":0,"47":0.00527,"48":0.01053,"49":0,"50":0.00527,"51":0,"52":0.03686,"53":0,"54":0,"55":0,"56":0.00527,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0.00527,"67":0,"68":0.05266,"69":0,"70":0,"71":0.00527,"72":0.02633,"73":0.00527,"74":0.00527,"75":0,"76":0.00527,"77":0.00527,"78":0.23697,"79":0.0158,"80":0.05793,"81":1.88523,"82":0.27383,"83":0.0316,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0.00527,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.02633,"30":0,"31":0.00527,"32":0.00527,"33":0.0158,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.00527,"41":0,"42":0,"43":0.0158,"44":0,"45":0,"46":0.00527,"47":0,"48":0,"49":0.19484,"50":0.00527,"51":0.00527,"52":0,"53":0.01053,"54":0.00527,"55":0.01053,"56":0.00527,"57":0.01053,"58":0.00527,"59":0,"60":0.00527,"61":0.0158,"62":0,"63":0.02633,"64":0.01053,"65":0.04213,"66":0.00527,"67":0.03686,"68":0.00527,"69":0.06319,"70":0.0316,"71":0.02106,"72":0.03686,"73":0.04739,"74":0.08426,"75":0.06846,"76":0.05793,"77":0.05793,"78":0.06846,"79":0.12638,"80":0.35809,"81":0.13692,"83":0.22644,"84":0.37389,"85":6.94585,"86":10.28976,"87":0.0316,"88":0.04213,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0.00527,"27":0.01053,"28":0.00527,"29":0,"30":0.00527,"31":0,"32":0.00527,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00527,"39":0,"40":0,"41":0,"42":0.01053,"43":0,"44":0,"45":0,"46":0.00527,"47":0.00527,"48":0,"49":0.00527,"50":0.06319,"51":0.18958,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00527,"62":0,"63":0.01053,"64":0,"65":0,"66":0,"67":0.00527,"68":0.00527,"69":0.00527,"70":0.18431,"71":1.10059,"72":0.05793,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00527},"ios_saf":{"8":0,"14":5.21623,"3.2":0.0125,"4.0-4.1":0.01071,"4.2-4.3":0.00179,"5.0-5.1":0.00893,"6.0-6.1":0.00536,"7.0-7.1":0.0125,"8.1-8.4":0.04106,"9.0-9.2":0.02321,"9.3":0.29634,"10.0-10.2":0.04998,"10.3":0.27491,"11.0-11.2":0.10354,"11.3-11.4":0.17673,"12.0-12.1":0.1803,"12.2-12.4":1.79765,"13.0-13.1":0.14817,"13.2":0.07319,"13.3":0.55697,"13.4-13.7":2.96693},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00527,"11":0.0316,"12":0.0316,"13":0.12112,"14":0.42128,"3.1":0,"3.2":0,"5.1":0.04213,"6.1":0,"7.1":0,"9.1":0.01053,"10.1":0.0158,"11.1":0.04213,"12.1":0.11059,"13.1":0.38968},"edge":{"12":0.0158,"13":0.00527,"14":0.0158,"15":0.01053,"16":0.01053,"17":0.0316,"18":0.14218,"79":0,"80":0,"81":0.00527,"83":0.00527,"84":0.0158,"85":0.495,"86":0.7899},"android":{"3":0,"4":0.11309,"81":null,"2.1":0,"2.2":0,"2.3":0.0009,"4.1":0.057,"4.2-4.3":0.02533,"4.4":0,"4.4.3-4.4.4":0.20628},"samsung":{"4":0.07074,"5.0-5.4":0,"6.2-6.4":0.01011,"7.2-7.4":0.10106,"8.2":0.01011,"9.2":0.11117,"10.1":0.06064,"11.1-11.2":0.20212,"12.0":0.859},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.03717,"9":0,"10":0,"11":0.08921,"5.5":0},"bb":{"7":0,"10":0.03314},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.0142},"baidu":{"0":null},"and_ff":{"0":0.2083},"and_qq":{"10.4":0.0142},"and_uc":{"0":0.445},"op_mini":{"0":2.20059},"and_chr":{"0":53.98952}},"total":97.53048}

/***/ },
/* 1191 */
/***/ function(module, exports) {

	module.exports = {"id":"CK","name":"Cook Islands","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0.034,"28":0,"29":0.0085,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0.034,"79":0,"80":0.017,"81":0.646,"82":0.119,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":47.6085,"47":0,"48":0,"49":0.153,"50":0,"51":0,"52":0,"53":0.017,"54":0,"55":0.0425,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0.0085,"66":0,"67":0.034,"68":0,"69":0.0255,"70":0.0085,"71":0,"72":0,"73":0,"74":0.0085,"75":0,"76":0.0085,"77":0,"78":0,"79":0,"80":0,"81":0.0085,"83":0.0085,"84":0.0935,"85":3.0345,"86":17.0085,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0.5695,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":2.98177,"3.2":0.00714,"4.0-4.1":0.00612,"4.2-4.3":0.00102,"5.0-5.1":0.0051,"6.0-6.1":0.00306,"7.0-7.1":0.00714,"8.1-8.4":0.02347,"9.0-9.2":0.01327,"9.3":0.1694,"10.0-10.2":0.02857,"10.3":0.15715,"11.0-11.2":0.05919,"11.3-11.4":0.10102,"12.0-12.1":0.10307,"12.2-12.4":1.0276,"13.0-13.1":0.0847,"13.2":0.04184,"13.3":0.31838,"13.4-13.7":1.69599},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0.068,"14":0.085,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.0255,"11.1":0.0085,"12.1":0.0085,"13.1":0.221},"edge":{"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0.136,"79":0,"80":0.0085,"81":0,"83":0,"84":0.0255,"85":0.255,"86":0.3145},"android":{"3":0,"4":0.00716,"81":null,"2.1":0,"2.2":0,"2.3":0.00006,"4.1":0.00361,"4.2-4.3":0.0016,"4.4":0,"4.4.3-4.4.4":0.01307},"samsung":{"4":0.02011,"5.0-5.4":0,"6.2-6.4":0.02011,"7.2-7.4":0.03016,"8.2":0,"9.2":0.10053,"10.1":0.20107,"11.1-11.2":0.09048,"12.0":1.79955},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.884,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.054},"and_qq":{"10.4":0},"and_uc":{"0":0.117},"op_mini":{"0":0.09515},"and_chr":{"0":16.659}},"total":97.58366}

/***/ },
/* 1192 */
/***/ function(module, exports) {

	module.exports = {"id":"CL","name":"Chile","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00568,"49":0,"50":0,"51":0,"52":0.01705,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0.00568,"59":0,"60":0.00568,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0.01136,"67":0,"68":0.02273,"69":0.00568,"70":0,"71":0,"72":0.00568,"73":0.00568,"74":0,"75":0,"76":0,"77":0.00568,"78":0.09091,"79":0.01136,"80":0.03977,"81":1.18754,"82":0.18182,"83":0.00568,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.01136,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00568,"49":0.11364,"50":0,"51":0,"52":0,"53":0.03409,"54":0,"55":0,"56":0,"57":0,"58":0.00568,"59":0,"60":0,"61":0,"62":0,"63":0.00568,"64":0,"65":0.02273,"66":0.00568,"67":0.03409,"68":0.00568,"69":0.00568,"70":0.02841,"71":0.02273,"72":0.02841,"73":0.02841,"74":0.01705,"75":0.02841,"76":0.02273,"77":0.02273,"78":0.02841,"79":0.04546,"80":0.11932,"81":0.05682,"83":0.10796,"84":0.22728,"85":9.63667,"86":14.9323,"87":0.01136,"88":0.01136,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00568,"69":0.01136,"70":0.10228,"71":1.0739,"72":0.01705,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":4.35421,"3.2":0.01043,"4.0-4.1":0.00894,"4.2-4.3":0.00149,"5.0-5.1":0.00745,"6.0-6.1":0.00447,"7.0-7.1":0.01043,"8.1-8.4":0.03427,"9.0-9.2":0.01937,"9.3":0.24736,"10.0-10.2":0.04172,"10.3":0.22948,"11.0-11.2":0.08643,"11.3-11.4":0.14752,"12.0-12.1":0.1505,"12.2-12.4":1.50058,"13.0-13.1":0.12368,"13.2":0.0611,"13.3":0.46493,"13.4-13.7":2.47663},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.01136,"12":0.02841,"13":0.11364,"14":0.77275,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.01136,"11.1":0.05682,"12.1":0.10796,"13.1":0.74434},"edge":{"12":0,"13":0,"14":0,"15":0,"16":0,"17":0.00568,"18":0.06818,"79":0,"80":0,"81":0,"83":0,"84":0.00568,"85":0.35797,"86":0.68752},"android":{"3":0,"4":0.02126,"81":null,"2.1":0,"2.2":0,"2.3":0.00017,"4.1":0.01071,"4.2-4.3":0.00476,"4.4":0,"4.4.3-4.4.4":0.03878},"samsung":{"4":0.10075,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.05038,"8.2":0.01008,"9.2":0.11083,"10.1":0.0403,"11.1-11.2":0.18136,"12.0":1.41055},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01215,"9":0.00607,"10":0.00607,"11":0.15185,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.10363},"and_qq":{"10.4":0.00432},"and_uc":{"0":0.01727},"op_mini":{"0":0.1022},"and_chr":{"0":54.65484}},"total":98.43505}

/***/ },
/* 1193 */
/***/ function(module, exports) {

	module.exports = {"id":"CM","name":"Cameroon","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0.00415,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0.00415,"31":0,"32":0,"33":0.00415,"34":0.00415,"35":0,"36":0,"37":0,"38":0,"39":0.00415,"40":0,"41":0.00415,"42":0,"43":0.01246,"44":0.00415,"45":0.00415,"46":0,"47":0.01661,"48":0.01661,"49":0.01246,"50":0.00415,"51":0.00415,"52":0.08719,"53":0,"54":0.00415,"55":0,"56":0.0083,"57":0.00415,"58":0,"59":0.00415,"60":0.0083,"61":0.00415,"62":0.00415,"63":0.00415,"64":0.0083,"65":0.00415,"66":0.0083,"67":0.0083,"68":0.09965,"69":0.00415,"70":0.00415,"71":0.0083,"72":0.04567,"73":0.00415,"74":0.0083,"75":0.00415,"76":0.00415,"77":0.02076,"78":0.1993,"79":0.02491,"80":0.11626,"81":2.43722,"82":0.27403,"83":0.01246,"84":0.00415,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00415,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0.00415,"24":0.00415,"25":0.00415,"26":0,"27":0.00415,"28":0,"29":0,"30":0,"31":0.00415,"32":0.00415,"33":0.00415,"34":0,"35":0,"36":0,"37":0,"38":0.00415,"39":0,"40":0.00415,"41":0.00415,"42":0,"43":0.0083,"44":0,"45":0,"46":0,"47":0.00415,"48":0.01246,"49":0.07474,"50":0.00415,"51":0,"52":0,"53":0.00415,"54":0,"55":0.00415,"56":0.01246,"57":0.00415,"58":0.0083,"59":0,"60":0.00415,"61":0.06228,"62":0.00415,"63":0.03737,"64":0.0083,"65":0.0083,"66":0.00415,"67":0.01661,"68":0.0083,"69":0.02076,"70":0.0083,"71":0.01246,"72":0.01661,"73":0.01246,"74":0.04152,"75":0.0083,"76":0.0083,"77":0.02906,"78":0.02906,"79":0.06228,"80":0.14117,"81":0.05398,"83":0.08719,"84":0.15362,"85":3.06418,"86":4.68761,"87":0.0083,"88":0.01246,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0.0083,"25":0,"26":0.0083,"27":0.01246,"28":0.01246,"29":0.00415,"30":0.0083,"31":0.00415,"32":0.0083,"33":0.01246,"34":0,"35":0,"36":0.00415,"37":0.01246,"38":0.01246,"39":0,"40":0,"41":0,"42":0.03737,"43":0.00415,"44":0,"45":0.02076,"46":0.04152,"47":0.02076,"48":0,"49":0,"50":0.16193,"51":0.40274,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.0083,"62":0,"63":0.00415,"64":0,"65":0,"66":0,"67":0.00415,"68":0.00415,"69":0.00415,"70":0.15362,"71":0.99233,"72":0.02076,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.02076},"ios_saf":{"8":0,"14":2.23878,"3.2":0.00536,"4.0-4.1":0.0046,"4.2-4.3":0.00077,"5.0-5.1":0.00383,"6.0-6.1":0.0023,"7.0-7.1":0.00536,"8.1-8.4":0.01762,"9.0-9.2":0.00996,"9.3":0.12719,"10.0-10.2":0.02145,"10.3":0.11799,"11.0-11.2":0.04444,"11.3-11.4":0.07585,"12.0-12.1":0.07738,"12.2-12.4":0.77154,"13.0-13.1":0.06359,"13.2":0.03141,"13.3":0.23905,"13.4-13.7":1.27339},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0.00415,"10":0,"11":0.00415,"12":0,"13":0.03322,"14":0.05813,"3.1":0,"3.2":0,"5.1":0.07058,"6.1":0,"7.1":0,"9.1":0.00415,"10.1":0.00415,"11.1":0.01661,"12.1":0.01246,"13.1":0.0955},"edge":{"12":0.02906,"13":0.01246,"14":0.03737,"15":0.02491,"16":0.01661,"17":0.02491,"18":0.0955,"79":0,"80":0,"81":0.00415,"83":0.0083,"84":0.01661,"85":0.24912,"86":0.36953},"android":{"3":0,"4":0.08422,"81":null,"2.1":0,"2.2":0,"2.3":0.00067,"4.1":0.04245,"4.2-4.3":0.01887,"4.4":0,"4.4.3-4.4.4":0.15362},"samsung":{"4":0.48038,"5.0-5.4":0.14011,"6.2-6.4":0.03002,"7.2-7.4":0.09007,"8.2":0.01001,"9.2":0.15012,"10.1":0.10008,"11.1-11.2":0.19015,"12.0":0.75059},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.05212,"9":0,"10":0,"11":0.22587,"5.5":0},"bb":{"7":0,"10":0.03509},"ie_mob":{"10":0,"11":0.0117},"kaios":{"2.5":0.07018},"baidu":{"0":null},"and_ff":{"0":0.35673},"and_qq":{"10.4":0.03509},"and_uc":{"0":1.14621},"op_mini":{"0":6.25625},"and_chr":{"0":64.81843}},"total":95.9051}

/***/ },
/* 1194 */
/***/ function(module, exports) {

	module.exports = {"id":"CN","name":"China","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0.00393,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0.03537,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00393,"30":0,"31":0,"32":0,"33":0.00786,"34":0,"35":0,"36":0.01965,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.75849,"44":0,"45":0.00393,"46":0,"47":0.00393,"48":0.00393,"49":0,"50":0.00393,"51":0,"52":0.01965,"53":0.00393,"54":0.00786,"55":0.00393,"56":0.00786,"57":0.00393,"58":0.00393,"59":0.00393,"60":0.00393,"61":0.00393,"62":0,"63":0.00393,"64":0.00393,"65":0.00393,"66":0.00393,"67":0.00393,"68":0.04323,"69":0.00393,"70":0.00393,"71":0.00393,"72":0.00393,"73":0.00393,"74":0.00393,"75":0.00393,"76":0.00393,"77":0.00393,"78":0.01572,"79":0.00786,"80":0.01965,"81":0.3144,"82":0.04323,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.01179,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0.00393,"18":0,"19":0.00786,"20":0,"21":0,"22":0,"23":0,"24":0.00393,"25":0,"26":0,"27":0,"28":0,"29":0.00393,"30":0,"31":0.00786,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00393,"39":0.00393,"40":0.03537,"41":0.00393,"42":0.00786,"43":0.00786,"44":0,"45":0.02358,"46":0,"47":0.02358,"48":0.07074,"49":0.11397,"50":0.00786,"51":0.00393,"52":0.00393,"53":0.00393,"54":0.01572,"55":0.05502,"56":0.01572,"57":0.17292,"58":0.01179,"59":0.02751,"60":0.00393,"61":0.01179,"62":0.11004,"63":0.06681,"64":0.00393,"65":0.03537,"66":0.00393,"67":0.05109,"68":0.02358,"69":0.56985,"70":0.0393,"71":0.07074,"72":0.14148,"73":0.06681,"74":0.25938,"75":0.10218,"76":0.05895,"77":0.03537,"78":0.15327,"79":0.08646,"80":0.18471,"81":0.08646,"83":0.16506,"84":0.18078,"85":0.85674,"86":1.39908,"87":0.01572,"88":0.00393,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.00393,"71":0.02358,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00393},"ios_saf":{"8":0,"14":4.32552,"3.2":0.01036,"4.0-4.1":0.00888,"4.2-4.3":0.00148,"5.0-5.1":0.0074,"6.0-6.1":0.00444,"7.0-7.1":0.01036,"8.1-8.4":0.03405,"9.0-9.2":0.01924,"9.3":0.24573,"10.0-10.2":0.04145,"10.3":0.22797,"11.0-11.2":0.08586,"11.3-11.4":0.14655,"12.0-12.1":0.14951,"12.2-12.4":1.49069,"13.0-13.1":0.12287,"13.2":0.06069,"13.3":0.46186,"13.4-13.7":2.46031},"safari":{"0":null,"4":0.00393,"5":0,"6":0.00393,"7":0,"8":0,"9":0.00393,"10":0.00393,"11":0.00393,"12":0.01179,"13":0.0393,"14":0.1572,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.00393,"10.1":0.00786,"11.1":0.01179,"12.1":0.02751,"13.1":0.18864},"edge":{"12":0,"13":0.00393,"14":0.00393,"15":0.00393,"16":0.00786,"17":0.02751,"18":0.51483,"79":0,"80":0.00393,"81":0,"83":0,"84":0.00393,"85":0.13362,"86":0.30654},"android":{"3":0,"4":0.57812,"81":null,"2.1":0,"2.2":0,"2.3":0.00462,"4.1":0.29137,"4.2-4.3":0.1295,"4.4":0,"4.4.3-4.4.4":1.05448},"samsung":{"4":0.02061,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0,"8.2":0,"9.2":0.0103,"10.1":0.0103,"11.1-11.2":0.02061,"12.0":0.38128},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0.03022,"7":0.03022,"8":0.69514,"9":0.45335,"10":0.18134,"11":3.68728,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.1214},"and_qq":{"10.4":7.67248},"and_uc":{"0":14.37376},"op_mini":{"0":0.07471},"and_chr":{"0":41.39448}},"total":89.48597}

/***/ },
/* 1195 */
/***/ function(module, exports) {

	module.exports = {"id":"CO","name":"Colombia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00743,"49":0,"50":0.00743,"51":0,"52":0.00743,"53":0,"54":0,"55":0,"56":0.00743,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0.00743,"64":0,"65":0,"66":0.01487,"67":0,"68":0.00743,"69":0,"70":0,"71":0,"72":0.00743,"73":0.00743,"74":0.00743,"75":0.00743,"76":0.00743,"77":0.00743,"78":0.06691,"79":0.00743,"80":0.03717,"81":1.35299,"82":0.21559,"83":0.00743,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00743,"39":0,"40":0,"41":0,"42":0.00743,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.08177,"50":0,"51":0,"52":0,"53":0.01487,"54":0,"55":0,"56":0,"57":0,"58":0.00743,"59":0,"60":0,"61":0,"62":0.00743,"63":0.01487,"64":0.00743,"65":0.03717,"66":0.01487,"67":0.03717,"68":0.01487,"69":0.0223,"70":0.0446,"71":0.06691,"72":0.05204,"73":0.0446,"74":0.05947,"75":0.05947,"76":0.06691,"77":0.05204,"78":0.06691,"79":0.12638,"80":0.24532,"81":0.13381,"83":0.23789,"84":0.42374,"85":16.52578,"86":28.81418,"87":0.02974,"88":0.00743,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.11151,"71":1.26378,"72":0.0223,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":2.06412,"3.2":0.00494,"4.0-4.1":0.00424,"4.2-4.3":0.00071,"5.0-5.1":0.00353,"6.0-6.1":0.00212,"7.0-7.1":0.00494,"8.1-8.4":0.01625,"9.0-9.2":0.00918,"9.3":0.11726,"10.0-10.2":0.01978,"10.3":0.10879,"11.0-11.2":0.04097,"11.3-11.4":0.06993,"12.0-12.1":0.07135,"12.2-12.4":0.71135,"13.0-13.1":0.05863,"13.2":0.02896,"13.3":0.2204,"13.4-13.7":1.17405},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.01487,"12":0.03717,"13":0.14868,"14":0.92182,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00743,"11.1":0.06691,"12.1":0.16355,"13.1":0.86234},"edge":{"12":0,"13":0,"14":0,"15":0,"16":0,"17":0.00743,"18":0.05947,"79":0,"80":0,"81":0,"83":0,"84":0.00743,"85":0.52781,"86":1.0928},"android":{"3":0,"4":0.04164,"81":null,"2.1":0,"2.2":0,"2.3":0.00033,"4.1":0.02098,"4.2-4.3":0.00933,"4.4":0,"4.4.3-4.4.4":0.07595},"samsung":{"4":0.12069,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.03017,"8.2":0,"9.2":0.02012,"10.1":0.02012,"11.1-11.2":0.04023,"12.0":0.64368},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01487,"9":0,"10":0,"11":0.06691,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.06158},"and_qq":{"10.4":0},"and_uc":{"0":0.03849},"op_mini":{"0":0.05345},"and_chr":{"0":38.56259}},"total":98.99174}

/***/ },
/* 1196 */
/***/ function(module, exports) {

	module.exports = {"id":"CR","name":"Costa Rica","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00666,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00666,"49":0,"50":0,"51":0,"52":0.03331,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0.07994,"67":0.05996,"68":0.01999,"69":0,"70":0,"71":0,"72":0.01332,"73":0.02665,"74":0,"75":0,"76":0.00666,"77":0.00666,"78":0.16655,"79":0.01332,"80":0.07328,"81":2.31838,"82":0.31311,"83":0.01332,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00666,"39":0,"40":0,"41":0,"42":0.00666,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.10659,"50":0,"51":0,"52":0,"53":0.00666,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0.09993,"62":0,"63":0.00666,"64":0,"65":0.03331,"66":0.01332,"67":0.01999,"68":0.01332,"69":0.01999,"70":0.02665,"71":0.02665,"72":0.01999,"73":0.01999,"74":0.02665,"75":0.03997,"76":0.01999,"77":0.04663,"78":0.03997,"79":0.04663,"80":0.11325,"81":0.11325,"83":0.15989,"84":0.24649,"85":11.9916,"86":19.31314,"87":0.01999,"88":0.00666,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00666,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00666,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0.00666,"70":0.0533,"71":0.65954,"72":0.01332,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":4.51153,"3.2":0.01081,"4.0-4.1":0.00926,"4.2-4.3":0.00154,"5.0-5.1":0.00772,"6.0-6.1":0.00463,"7.0-7.1":0.01081,"8.1-8.4":0.03551,"9.0-9.2":0.02007,"9.3":0.2563,"10.0-10.2":0.04323,"10.3":0.23777,"11.0-11.2":0.08955,"11.3-11.4":0.15285,"12.0-12.1":0.15594,"12.2-12.4":1.5548,"13.0-13.1":0.12815,"13.2":0.0633,"13.3":0.48172,"13.4-13.7":2.56611},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00666,"11":0.01999,"12":0.07994,"13":0.25316,"14":1.9986,"3.1":0,"3.2":0,"5.1":0.39306,"6.1":0,"7.1":0,"9.1":0.00666,"10.1":0.02665,"11.1":0.13324,"12.1":0.25316,"13.1":1.85204},"edge":{"12":0,"13":0,"14":0.00666,"15":0,"16":0.00666,"17":0.01999,"18":0.08661,"79":0,"80":0.00666,"81":0,"83":0,"84":0.00666,"85":0.57959,"86":1.09923},"android":{"3":0,"4":0.05618,"81":null,"2.1":0,"2.2":0,"2.3":0.00045,"4.1":0.02831,"4.2-4.3":0.01258,"4.4":0,"4.4.3-4.4.4":0.10246},"samsung":{"4":0.09163,"5.0-5.4":0,"6.2-6.4":0.01018,"7.2-7.4":0.0509,"8.2":0,"9.2":0.08145,"10.1":0.06109,"11.1-11.2":0.15271,"12.0":1.79184},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.02665,"9":0,"10":0,"11":0.1399,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.19027},"and_qq":{"10.4":0.00668},"and_uc":{"0":0.03004},"op_mini":{"0":0.10429},"and_chr":{"0":41.50976}},"total":98.13858}

/***/ },
/* 1197 */
/***/ function(module, exports) {

	module.exports = {"id":"CU","name":"Cuba","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0.0035,"18":0.01051,"19":0,"20":0,"21":0,"22":0,"23":0.00701,"24":0,"25":0.0035,"26":0.01051,"27":0.0035,"28":0.0035,"29":0.00701,"30":0.0035,"31":0.0035,"32":0.0035,"33":0.01752,"34":0.04554,"35":0.00701,"36":0.00701,"37":0.01051,"38":0.01752,"39":0.01401,"40":0.02102,"41":0.01401,"42":0.00701,"43":0.02102,"44":0.00701,"45":0.03153,"46":0.02802,"47":0.04554,"48":0.01752,"49":0.02102,"50":0.06656,"51":0.00701,"52":0.16464,"53":0.03503,"54":0.24171,"55":0.03503,"56":0.05955,"57":0.17165,"58":0.04204,"59":0.04904,"60":0.09458,"61":0.06656,"62":0.04204,"63":0.02102,"64":0.06305,"65":0.08057,"66":0.07356,"67":0.06305,"68":0.31877,"69":0.07356,"70":0.07006,"71":0.05955,"72":0.15413,"73":0.06305,"74":0.04554,"75":0.06656,"76":0.06305,"77":0.03853,"78":0.16464,"79":0.09808,"80":0.22069,"81":3.06513,"82":0.56048,"83":0.02452,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.00701,"41":0,"42":0,"43":0.0035,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.04904,"50":0.0035,"51":0,"52":0.0035,"53":0.0035,"54":0.00701,"55":0.00701,"56":0.0035,"57":0.0035,"58":0.02102,"59":0.0035,"60":0.00701,"61":0.0035,"62":0.01401,"63":0.01051,"64":0.0035,"65":0.0035,"66":0.0035,"67":0.00701,"68":0.01401,"69":0.0035,"70":0.01051,"71":0.02102,"72":0.01752,"73":0.01401,"74":0.03503,"75":0.02102,"76":0.02452,"77":0.04554,"78":0.02802,"79":0.04204,"80":0.38533,"81":0.03503,"83":0.1191,"84":0.1121,"85":0.92129,"86":1.29961,"87":0.0035,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0.01051,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.0035,"30":0,"31":0,"32":0,"33":0.0035,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0.0035,"43":0,"44":0,"45":0.0035,"46":0.0035,"47":0,"48":0.0035,"49":0.0035,"50":0.03153,"51":0.01752,"52":0,"53":0.0035,"54":0.0035,"55":0.00701,"56":0,"57":0.0035,"58":0.0035,"60":0.02452,"62":0.00701,"63":0,"64":0,"65":0,"66":0.0035,"67":0.0035,"68":0.0035,"69":0.00701,"70":0.04204,"71":0.31177,"72":0.00701,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00701},"ios_saf":{"8":0,"14":2.98783,"3.2":0.00716,"4.0-4.1":0.00614,"4.2-4.3":0.00102,"5.0-5.1":0.00511,"6.0-6.1":0.00307,"7.0-7.1":0.00716,"8.1-8.4":0.02352,"9.0-9.2":0.01329,"9.3":0.16974,"10.0-10.2":0.02863,"10.3":0.15747,"11.0-11.2":0.05931,"11.3-11.4":0.10123,"12.0-12.1":0.10328,"12.2-12.4":1.02969,"13.0-13.1":0.08487,"13.2":0.04192,"13.3":0.31903,"13.4-13.7":1.69944},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0.01401,"14":0.01752,"3.1":0,"3.2":0,"5.1":0.57449,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0.00701,"12.1":0.01752,"13.1":0.01401},"edge":{"12":0.0035,"13":0.01401,"14":0.01401,"15":0.01051,"16":0.01051,"17":0.01752,"18":0.08057,"79":0,"80":0,"81":0.00701,"83":0.0035,"84":0.00701,"85":0.08407,"86":0.1156},"android":{"3":0,"4":0.17036,"81":null,"2.1":0,"2.2":0,"2.3":0.00136,"4.1":0.08586,"4.2-4.3":0.03816,"4.4":0,"4.4.3-4.4.4":0.31074},"samsung":{"4":0.58785,"5.0-5.4":0.08108,"6.2-6.4":0.06081,"7.2-7.4":0.27365,"8.2":0.04054,"9.2":0.30406,"10.1":0.22298,"11.1-11.2":0.25338,"12.0":0.95272},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00701,"9":0,"10":0,"11":0.05605,"5.5":0},"bb":{"7":0,"10":0.0065},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":1.17596},"and_qq":{"10.4":0.01949},"and_uc":{"0":0.28587},"op_mini":{"0":1.32245},"and_chr":{"0":73.0463}},"total":97.86263}

/***/ },
/* 1198 */
/***/ function(module, exports) {

	module.exports = {"id":"CV","name":"Cape Verde","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0.00593,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0.00593,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.00593,"51":0,"52":0.01186,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.01186,"69":0.00593,"70":0,"71":0,"72":0.00593,"73":0,"74":0,"75":0,"76":0.01779,"77":0,"78":0.02965,"79":0.01779,"80":0.02965,"81":1.48225,"82":0.17194,"83":0.00593,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.00593,"35":0.00593,"36":0,"37":0,"38":0.01186,"39":0,"40":0.02965,"41":0,"42":0.00593,"43":0.07708,"44":0,"45":0,"46":0.00593,"47":0,"48":0.00593,"49":0.18973,"50":0.00593,"51":0,"52":0,"53":0.00593,"54":0,"55":0.02372,"56":0,"57":0.00593,"58":0,"59":0.00593,"60":0.00593,"61":0,"62":0,"63":0.02965,"64":0.02372,"65":0.03557,"66":0.02965,"67":0.00593,"68":0.01186,"69":0.02965,"70":0.03557,"71":0.01779,"72":0.00593,"73":0.00593,"74":0.10079,"75":0.02372,"76":0.02372,"77":0.23716,"78":0.08301,"79":0.14823,"80":0.21937,"81":0.68184,"83":0.35574,"84":0.48618,"85":7.98636,"86":13.87979,"87":0.01186,"88":0.01186,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.09486,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.00593,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.17787,"71":1.39332,"72":0.02965,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00593},"ios_saf":{"8":0,"14":3.02599,"3.2":0.00725,"4.0-4.1":0.00621,"4.2-4.3":0.00104,"5.0-5.1":0.00518,"6.0-6.1":0.00311,"7.0-7.1":0.00725,"8.1-8.4":0.02382,"9.0-9.2":0.01346,"9.3":0.17191,"10.0-10.2":0.029,"10.3":0.15948,"11.0-11.2":0.06006,"11.3-11.4":0.10252,"12.0-12.1":0.10459,"12.2-12.4":1.04284,"13.0-13.1":0.08595,"13.2":0.04246,"13.3":0.3231,"13.4-13.7":1.72115},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00593,"12":0.00593,"13":0.26681,"14":1.47632,"3.1":0,"3.2":0,"5.1":0.03557,"6.1":0,"7.1":0,"9.1":0.00593,"10.1":0.02965,"11.1":0.03557,"12.1":0.17787,"13.1":0.5514},"edge":{"12":0.02372,"13":0.00593,"14":0.00593,"15":0.01779,"16":0.05929,"17":0.0415,"18":0.1838,"79":0,"80":0,"81":0,"83":0.00593,"84":0.02965,"85":0.66998,"86":1.25695},"android":{"3":0,"4":0.10249,"81":null,"2.1":0,"2.2":0,"2.3":0.00082,"4.1":0.05165,"4.2-4.3":0.02296,"4.4":0,"4.4.3-4.4.4":0.18694},"samsung":{"4":0.40007,"5.0-5.4":0.02052,"6.2-6.4":0.02052,"7.2-7.4":0.19491,"8.2":0.01026,"9.2":0.15387,"10.1":0.16413,"11.1-11.2":0.19491,"12.0":1.16944},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01186,"9":0,"10":0,"11":0.23716,"5.5":0},"bb":{"7":0,"10":0.00407},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.00407},"baidu":{"0":null},"and_ff":{"0":0.06514},"and_qq":{"10.4":0.00407},"and_uc":{"0":0.13027},"op_mini":{"0":0.13104},"and_chr":{"0":54.43621}},"total":97.93335}

/***/ },
/* 1199 */
/***/ function(module, exports) {

	module.exports = {"id":"CX","name":"Christmas Island","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0,"79":0,"80":0,"81":5.26,"82":2.63,"83":7.89,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":2.63,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0,"79":0,"80":10.53,"81":23.68,"83":0,"84":0,"85":36.84,"86":10.53,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":0,"3.2":0,"4.0-4.1":0,"4.2-4.3":0,"5.0-5.1":0,"6.0-6.1":0,"7.0-7.1":0,"8.1-8.4":0,"9.0-9.2":0,"9.3":0,"10.0-10.2":0,"10.3":0,"11.0-11.2":0,"11.3-11.4":0,"12.0-12.1":0,"12.2-12.4":0,"13.0-13.1":0,"13.2":0,"13.3":0,"13.4-13.7":0},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0,"12.1":0,"13.1":0},"edge":{"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"79":0,"80":0,"81":0,"83":0,"84":0,"85":0,"86":0},"android":{"3":0,"4":0,"81":null,"2.1":0,"2.2":0,"2.3":0,"4.1":0,"4.2-4.3":0,"4.4":0,"4.4.3-4.4.4":0},"samsung":{"4":0,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0,"8.2":0,"9.2":0,"10.1":0,"11.1-11.2":0,"12.0":0},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0},"and_qq":{"10.4":0},"and_uc":{"0":0},"op_mini":{"0":0},"and_chr":{"0":0}},"total":99.99}

/***/ },
/* 1200 */
/***/ function(module, exports) {

	module.exports = {"id":"CY","name":"Cyprus","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.0055,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.0055,"44":0,"45":0,"46":0,"47":0.0055,"48":0.011,"49":0,"50":0,"51":0,"52":0.03299,"53":0,"54":0,"55":0,"56":0.0055,"57":0,"58":0,"59":0,"60":0.011,"61":0,"62":0.0055,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.011,"69":0,"70":0.02749,"71":0,"72":0.05498,"73":0,"74":0,"75":0,"76":0.0055,"77":0.0055,"78":0.06048,"79":0.0055,"80":0.02749,"81":1.0996,"82":0.23641,"83":0.011,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0.0055,"34":0,"35":0,"36":0,"37":0,"38":0.011,"39":0,"40":0,"41":0,"42":0.77522,"43":0,"44":0,"45":0,"46":0,"47":0.0055,"48":0,"49":0.17044,"50":0,"51":0,"52":0,"53":0.02199,"54":0.011,"55":0,"56":0.0055,"57":0,"58":0.011,"59":0,"60":0,"61":0,"62":0.0055,"63":0.0055,"64":0,"65":0.02199,"66":0.0055,"67":0.0055,"68":0.0055,"69":0.011,"70":0.73673,"71":0.02199,"72":0.02749,"73":0.0055,"74":0.0055,"75":0.0055,"76":0.0055,"77":0.011,"78":0.02199,"79":0.07697,"80":0.03299,"81":0.03299,"83":0.08797,"84":0.16494,"85":7.58724,"86":12.05711,"87":0.011,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.02199,"52":0.0055,"53":0,"54":0,"55":0,"56":0.0055,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.04948,"71":0.44534,"72":0.02749,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":6.94642,"3.2":0.01664,"4.0-4.1":0.01426,"4.2-4.3":0.00238,"5.0-5.1":0.01189,"6.0-6.1":0.00713,"7.0-7.1":0.01664,"8.1-8.4":0.05468,"9.0-9.2":0.0309,"9.3":0.39463,"10.0-10.2":0.06656,"10.3":0.3661,"11.0-11.2":0.13788,"11.3-11.4":0.23535,"12.0-12.1":0.24011,"12.2-12.4":2.39392,"13.0-13.1":0.19731,"13.2":0.09747,"13.3":0.74171,"13.4-13.7":3.95104},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.0055,"12":0.03299,"13":0.09896,"14":0.75872,"3.1":0,"3.2":0,"5.1":0.0055,"6.1":0,"7.1":0,"9.1":0.0055,"10.1":0.01649,"11.1":0.04398,"12.1":0.2859,"13.1":1.16008},"edge":{"12":0,"13":0.0055,"14":0,"15":0.0055,"16":0.0055,"17":0.02749,"18":0.13745,"79":0,"80":0,"81":0,"83":0,"84":0.011,"85":0.87418,"86":1.28103},"android":{"3":0,"4":0.09185,"81":null,"2.1":0,"2.2":0,"2.3":0.00073,"4.1":0.04629,"4.2-4.3":0.02057,"4.4":0,"4.4.3-4.4.4":0.16753},"samsung":{"4":0.09217,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0,"8.2":0.01024,"9.2":0.03072,"10.1":0.03072,"11.1-11.2":0.07169,"12.0":3.9018},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.0055,"9":0.0055,"10":0,"11":0.38486,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.13056},"and_qq":{"10.4":0.0045},"and_uc":{"0":1.03096},"op_mini":{"0":0.20459},"and_chr":{"0":45.66079}},"total":96.72865}

/***/ },
/* 1201 */
/***/ function(module, exports) {

	module.exports = {"id":"CZ","name":"Czech Republic","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00676,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00676,"48":0.01352,"49":0,"50":0,"51":0,"52":0.10143,"53":0,"54":0,"55":0,"56":0.04057,"57":0.00676,"58":0,"59":0,"60":0.01352,"61":0.00676,"62":0.00676,"63":0.00676,"64":0.00676,"65":0.00676,"66":0.02029,"67":0,"68":0.08791,"69":0.00676,"70":0.00676,"71":0.00676,"72":0.02029,"73":0.00676,"74":0.00676,"75":0.01352,"76":0.01352,"77":0.02029,"78":0.16229,"79":0.03381,"80":0.16229,"81":4.5914,"82":0.71001,"83":0.00676,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00676,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00676,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.25696,"50":0.00676,"51":0,"52":0,"53":0.02705,"54":0,"55":0.00676,"56":0.00676,"57":0,"58":0.00676,"59":0,"60":0.00676,"61":0.12848,"62":0.00676,"63":0.01352,"64":0.00676,"65":0.00676,"66":0.01352,"67":0.02029,"68":0.00676,"69":0.03381,"70":0.06086,"71":0.06762,"72":0.04057,"73":0.04057,"74":0.02029,"75":0.02029,"76":0.02705,"77":0.02705,"78":0.04057,"79":0.0541,"80":0.14876,"81":0.14876,"83":0.23667,"84":0.41924,"85":10.12948,"86":16.83738,"87":0.01352,"88":0.00676,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.01352,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.03381,"52":0.01352,"53":0.00676,"54":0,"55":0,"56":0,"57":0.00676,"58":0,"60":0.00676,"62":0,"63":0.00676,"64":0,"65":0,"66":0,"67":0,"68":0.01352,"69":0.00676,"70":0.25019,"71":1.86631,"72":0.0541,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.03381},"ios_saf":{"8":0,"14":5.39398,"3.2":0.01292,"4.0-4.1":0.01108,"4.2-4.3":0.00185,"5.0-5.1":0.00923,"6.0-6.1":0.00554,"7.0-7.1":0.01292,"8.1-8.4":0.04246,"9.0-9.2":0.024,"9.3":0.30643,"10.0-10.2":0.05169,"10.3":0.28428,"11.0-11.2":0.10707,"11.3-11.4":0.18275,"12.0-12.1":0.18645,"12.2-12.4":1.85891,"13.0-13.1":0.15322,"13.2":0.07569,"13.3":0.57595,"13.4-13.7":3.06804},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00676,"12":0.02029,"13":0.13524,"14":1.23068,"3.1":0,"3.2":0,"5.1":0.02705,"6.1":0,"7.1":0,"9.1":0.00676,"10.1":0.01352,"11.1":0.06762,"12.1":0.10819,"13.1":0.96697},"edge":{"12":0,"13":0.00676,"14":0.01352,"15":0.01352,"16":0.02029,"17":0.04733,"18":0.30429,"79":0,"80":0.00676,"81":0.00676,"83":0.00676,"84":0.01352,"85":1.02782,"86":2.27879},"android":{"3":0,"4":0.07726,"81":null,"2.1":0,"2.2":0,"2.3":0.00062,"4.1":0.03894,"4.2-4.3":0.01731,"4.4":0,"4.4.3-4.4.4":0.14092},"samsung":{"4":0.05102,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.0102,"8.2":0.0102,"9.2":0.04082,"10.1":0.04082,"11.1-11.2":0.06123,"12.0":1.79601},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01385,"9":0.00692,"10":0.12465,"11":1.00412,"5.5":0},"bb":{"7":0,"10":0.00648},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.29142},"and_qq":{"10.4":0.00648},"and_uc":{"0":0.2299},"op_mini":{"0":0.3648},"and_chr":{"0":37.14146}},"total":97.4885}

/***/ },
/* 1202 */
/***/ function(module, exports) {

	module.exports = {"id":"DE","name":"Germany","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0.00613,"25":0,"26":0,"27":0,"28":0,"29":0.01225,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00613,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.01225,"46":0.00613,"47":0.00613,"48":0.01838,"49":0.00613,"50":0.00613,"51":0.01838,"52":0.08576,"53":0.00613,"54":0.00613,"55":0.00613,"56":0.01838,"57":0.00613,"58":0.00613,"59":0.00613,"60":0.03063,"61":0.00613,"62":0.00613,"63":0.01838,"64":0.01838,"65":0.01838,"66":0.01838,"67":0.00613,"68":0.17153,"69":0.01225,"70":0.01225,"71":0.00613,"72":0.03063,"73":0.0245,"74":0.01225,"75":0.01225,"76":0.01838,"77":0.07964,"78":0.31855,"79":0.11639,"80":0.22054,"81":5.39088,"82":0.73512,"83":0.01225,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.01838,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00613,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00613,"39":0,"40":0.00613,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00613,"48":0.00613,"49":0.15928,"50":0.00613,"51":0.01225,"52":0.00613,"53":0.01225,"54":0.00613,"55":0.00613,"56":0.01225,"57":0.00613,"58":0.00613,"59":0.00613,"60":0.03676,"61":0.01838,"62":0.00613,"63":0.01225,"64":0.00613,"65":0.11639,"66":0.0245,"67":0.01225,"68":0.01225,"69":0.04288,"70":0.09802,"71":0.17153,"72":0.12865,"73":0.06739,"74":0.04288,"75":0.04901,"76":0.04288,"77":0.04288,"78":0.06739,"79":0.08576,"80":0.18991,"81":0.12252,"83":0.25117,"84":0.26954,"85":6.904,"86":9.37278,"87":0.01225,"88":0.00613,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00613,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0.00613,"43":0.00613,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.00613,"51":0.01838,"52":0,"53":0.00613,"54":0,"55":0,"56":0.00613,"57":0.00613,"58":0.00613,"60":0.00613,"62":0,"63":0.00613,"64":0,"65":0,"66":0,"67":0,"68":0.01225,"69":0,"70":0.1654,"71":1.61726,"72":0.0245,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00613},"ios_saf":{"8":0,"14":9.55205,"3.2":0.02288,"4.0-4.1":0.01961,"4.2-4.3":0.00327,"5.0-5.1":0.01635,"6.0-6.1":0.00981,"7.0-7.1":0.02288,"8.1-8.4":0.07519,"9.0-9.2":0.0425,"9.3":0.54266,"10.0-10.2":0.09153,"10.3":0.50343,"11.0-11.2":0.1896,"11.3-11.4":0.32363,"12.0-12.1":0.33017,"12.2-12.4":3.29189,"13.0-13.1":0.27133,"13.2":0.13403,"13.3":1.01993,"13.4-13.7":5.43309},"safari":{"0":null,"4":0.00613,"5":0,"6":0,"7":0.00613,"8":0.00613,"9":0.00613,"10":0.01838,"11":0.01838,"12":0.04288,"13":0.20828,"14":1.72753,"3.1":0,"3.2":0,"5.1":0.01838,"6.1":0,"7.1":0,"9.1":0.01225,"10.1":0.0245,"11.1":0.08576,"12.1":0.14702,"13.1":1.49474},"edge":{"12":0.03063,"13":0,"14":0.01838,"15":0.01225,"16":0.01838,"17":0.06126,"18":0.39206,"79":0,"80":0,"81":0.00613,"83":0.00613,"84":0.03063,"85":1.04755,"86":1.87456},"android":{"3":0,"4":0.09042,"81":null,"2.1":0,"2.2":0,"2.3":0.00072,"4.1":0.04557,"4.2-4.3":0.02025,"4.4":0,"4.4.3-4.4.4":0.16492},"samsung":{"4":0.18605,"5.0-5.4":0.01034,"6.2-6.4":0,"7.2-7.4":0.03101,"8.2":0.02067,"9.2":0.06202,"10.1":0.06202,"11.1-11.2":0.12403,"12.0":4.38252},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0.16195,"7":0.03887,"8":0.05182,"9":0.01943,"10":0.02591,"11":0.82919,"5.5":0},"bb":{"7":0,"10":0.00387},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.60822},"and_qq":{"10.4":0.01162},"and_uc":{"0":0.19757},"op_mini":{"0":0.32642},"and_chr":{"0":31.51858}},"total":96.15124}

/***/ },
/* 1203 */
/***/ function(module, exports) {

	module.exports = {"id":"DJ","name":"Djibouti","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.02577,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00322,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.01611,"69":0,"70":0,"71":0,"72":0.00322,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0.02255,"79":0.00966,"80":0.01611,"81":0.79881,"82":0.1385,"83":0.00966,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00322,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.00322,"47":0,"48":0,"49":0.00644,"50":0,"51":0,"52":0,"53":0.00322,"54":0,"55":0,"56":0,"57":0,"58":0.02255,"59":0.08053,"60":0,"61":0.00322,"62":0,"63":0.00644,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0.00322,"70":0,"71":0,"72":0.00322,"73":0,"74":0,"75":0,"76":0.00322,"77":0.01933,"78":0.00322,"79":0.02899,"80":0.04832,"81":0.03221,"83":0.06442,"84":0.18038,"85":2.7604,"86":4.3709,"87":0.00966,"88":0.00322,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00322,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.00644,"47":0,"48":0,"49":0,"50":0.00322,"51":0.04187,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00322,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.01288,"71":0.07408,"72":0.00966,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00322},"ios_saf":{"8":0,"14":3.33881,"3.2":0.008,"4.0-4.1":0.00686,"4.2-4.3":0.00114,"5.0-5.1":0.00571,"6.0-6.1":0.00343,"7.0-7.1":0.008,"8.1-8.4":0.02628,"9.0-9.2":0.01485,"9.3":0.18968,"10.0-10.2":0.03199,"10.3":0.17597,"11.0-11.2":0.06627,"11.3-11.4":0.11312,"12.0-12.1":0.11541,"12.2-12.4":1.15064,"13.0-13.1":0.09484,"13.2":0.04685,"13.3":0.35651,"13.4-13.7":1.89908},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0.00322,"8":0,"9":0,"10":0,"11":0,"12":0.00322,"13":0.0773,"14":0.15139,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0.00644,"12.1":0.00644,"13.1":0.15139},"edge":{"12":0.00322,"13":0.00322,"14":0.00322,"15":0.00966,"16":0,"17":0.02255,"18":0.08697,"79":0,"80":0,"81":0.00322,"83":0.01933,"84":0.22225,"85":0.11274,"86":0.18682},"android":{"3":0,"4":0.15512,"81":null,"2.1":0,"2.2":0,"2.3":0.00124,"4.1":0.07818,"4.2-4.3":0.03475,"4.4":0,"4.4.3-4.4.4":0.28293},"samsung":{"4":0.90417,"5.0-5.4":0.02032,"6.2-6.4":0.07111,"7.2-7.4":0.7721,"8.2":0.01016,"9.2":0.31493,"10.1":0.29462,"11.1-11.2":0.47748,"12.0":4.49036},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.0233,"9":0,"10":0,"11":0.10876,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.19659},"and_qq":{"10.4":1.62018},"and_uc":{"0":0.79992},"op_mini":{"0":0.6803},"and_chr":{"0":67.51042}},"total":96.43395}

/***/ },
/* 1204 */
/***/ function(module, exports) {

	module.exports = {"id":"DK","name":"Denmark","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.0075,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.0075,"49":0,"50":0,"51":0,"52":0.02251,"53":0,"54":0,"55":0,"56":0.04502,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0.0075,"66":0,"67":0,"68":0.01501,"69":0,"70":0.0075,"71":0,"72":0.0075,"73":0,"74":0.0075,"75":0.0075,"76":0.0075,"77":0.0075,"78":0.06754,"79":0.02251,"80":0.06003,"81":1.28318,"82":0.1951,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.0075,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.06003,"50":0,"51":0,"52":0.03002,"53":0.0075,"54":0,"55":0,"56":0,"57":0.0075,"58":0.01501,"59":0.0075,"60":0.0075,"61":0,"62":0.0075,"63":0.0075,"64":0,"65":0.01501,"66":0.01501,"67":0.02251,"68":0.01501,"69":0.12757,"70":0.02251,"71":0.03002,"72":0.03752,"73":0.03002,"74":0.03002,"75":0.03752,"76":0.11256,"77":0.03752,"78":0.04502,"79":0.06754,"80":0.13507,"81":0.15008,"83":0.39021,"84":1.03555,"85":19.27778,"86":18.85005,"87":0.01501,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0.02251,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.0075,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.03752,"71":0.31517,"72":0.0075,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":12.06685,"3.2":0.02891,"4.0-4.1":0.02478,"4.2-4.3":0.00413,"5.0-5.1":0.02065,"6.0-6.1":0.01239,"7.0-7.1":0.02891,"8.1-8.4":0.09498,"9.0-9.2":0.05369,"9.3":0.68552,"10.0-10.2":0.11563,"10.3":0.63597,"11.0-11.2":0.23952,"11.3-11.4":0.40884,"12.0-12.1":0.41709,"12.2-12.4":4.15856,"13.0-13.1":0.34276,"13.2":0.16932,"13.3":1.28845,"13.4-13.7":6.86348},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.0075,"11":0.03752,"12":0.13507,"13":0.59282,"14":3.51938,"3.1":0,"3.2":0,"5.1":0,"6.1":0.01501,"7.1":0,"9.1":0.02251,"10.1":0.06003,"11.1":0.21762,"12.1":0.53278,"13.1":4.04466},"edge":{"12":0,"13":0,"14":0,"15":0.0075,"16":0.0075,"17":0.02251,"18":0.21011,"79":0,"80":0,"81":0,"83":0.0075,"84":0.01501,"85":0.73539,"86":1.33571},"android":{"3":0,"4":0.03018,"81":null,"2.1":0,"2.2":0,"2.3":0.00024,"4.1":0.01521,"4.2-4.3":0.00676,"4.4":0,"4.4.3-4.4.4":0.05506},"samsung":{"4":0.0105,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0,"8.2":0,"9.2":0.02101,"10.1":0.0105,"11.1-11.2":0.04202,"12.0":1.12402},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0.02278,"8":0.00759,"9":0,"10":0.00759,"11":0.60738,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.15475},"and_qq":{"10.4":0.01248},"and_uc":{"0":0.02496},"op_mini":{"0":0.04962},"and_chr":{"0":14.45704}},"total":98.67152}

/***/ },
/* 1205 */
/***/ function(module, exports) {

	module.exports = {"id":"DM","name":"Dominica","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.00608,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0.03042,"59":0,"60":0,"61":0,"62":0.03042,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00608,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0.02434,"79":0.01217,"80":0.05476,"81":1.30806,"82":0.1156,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00608,"30":0,"31":0,"32":0,"33":0,"34":0.01217,"35":0,"36":0,"37":0,"38":0.01825,"39":0,"40":0,"41":0.04867,"42":0.00608,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.16427,"50":0,"51":0,"52":0.02434,"53":0.06692,"54":0,"55":0,"56":0.00608,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0.00608,"63":0.02434,"64":0,"65":0.1886,"66":0,"67":0,"68":0.00608,"69":0.07909,"70":0.06084,"71":0,"72":0.02434,"73":0.29203,"74":0.01825,"75":0.03042,"76":0.26161,"77":0.01825,"78":0.00608,"79":0.03042,"80":0.04259,"81":0.1521,"83":0.15818,"84":0.26161,"85":7.44073,"86":13.00759,"87":0.01825,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.09126,"71":0.19469,"72":0.00608,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":3.22784,"3.2":0.00773,"4.0-4.1":0.00663,"4.2-4.3":0.0011,"5.0-5.1":0.00552,"6.0-6.1":0.00331,"7.0-7.1":0.00773,"8.1-8.4":0.02541,"9.0-9.2":0.01436,"9.3":0.18337,"10.0-10.2":0.03093,"10.3":0.17012,"11.0-11.2":0.06407,"11.3-11.4":0.10936,"12.0-12.1":0.11157,"12.2-12.4":1.1124,"13.0-13.1":0.09169,"13.2":0.04529,"13.3":0.34466,"13.4-13.7":1.83596},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0.17035,"14":2.83514,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0,"12.1":0.04259,"13.1":0.82134},"edge":{"12":0,"13":0.01217,"14":0.03042,"15":0.00608,"16":0.01825,"17":0.0365,"18":0.3042,"79":0,"80":0.00608,"81":0.00608,"83":0,"84":0.1156,"85":0.8761,"86":2.33017},"android":{"3":0,"4":0.53358,"81":null,"2.1":0,"2.2":0,"2.3":0.00427,"4.1":0.26892,"4.2-4.3":0.11952,"4.4":0,"4.4.3-4.4.4":0.97325},"samsung":{"4":0.02158,"5.0-5.4":0,"6.2-6.4":0.01079,"7.2-7.4":0.18344,"8.2":0.01079,"9.2":0.02158,"10.1":0.03237,"11.1-11.2":0.18344,"12.0":3.90625},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.55364,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.14489},"and_qq":{"10.4":0.00392},"and_uc":{"0":0.71271},"op_mini":{"0":0.04078},"and_chr":{"0":49.46375}},"total":96.55989}

/***/ },
/* 1206 */
/***/ function(module, exports) {

	module.exports = {"id":"DO","name":"Dominican Republic","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00621,"49":0,"50":0,"51":0,"52":0.01241,"53":0.01241,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0.00621,"62":0,"63":0.00621,"64":0,"65":0.01862,"66":0.0869,"67":0,"68":0.01862,"69":0,"70":0,"71":0,"72":0.01241,"73":0.02483,"74":0,"75":0,"76":0.00621,"77":0.00621,"78":0.05586,"79":0.01862,"80":0.04345,"81":0.96829,"82":0.11793,"83":0.00621,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00621,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.01241,"39":0,"40":0,"41":0,"42":0,"43":0.00621,"44":0,"45":0.00621,"46":0,"47":0,"48":0.00621,"49":0.16138,"50":0,"51":0,"52":0,"53":0.01241,"54":0,"55":0,"56":0.00621,"57":0,"58":0.00621,"59":0,"60":0.00621,"61":0.01241,"62":0,"63":0.01241,"64":0.00621,"65":0.03104,"66":0.00621,"67":0.03724,"68":0.01241,"69":0.01241,"70":0.06828,"71":0.08069,"72":0.09931,"73":0.05586,"74":0.03724,"75":0.04345,"76":0.04966,"77":0.03104,"78":0.05586,"79":0.08069,"80":0.16759,"81":0.09931,"83":0.19242,"84":0.32276,"85":10.51466,"86":16.78373,"87":0.01241,"88":0.00621,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0.00621,"58":0.00621,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00621,"69":0,"70":0.10552,"71":0.98071,"72":0.01241,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":6.2532,"3.2":0.01498,"4.0-4.1":0.01284,"4.2-4.3":0.00214,"5.0-5.1":0.0107,"6.0-6.1":0.00642,"7.0-7.1":0.01498,"8.1-8.4":0.04922,"9.0-9.2":0.02782,"9.3":0.35525,"10.0-10.2":0.05992,"10.3":0.32957,"11.0-11.2":0.12412,"11.3-11.4":0.21186,"12.0-12.1":0.21614,"12.2-12.4":2.15502,"13.0-13.1":0.17762,"13.2":0.08774,"13.3":0.66769,"13.4-13.7":3.55675},"safari":{"0":null,"4":0.00621,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00621,"12":0.03724,"13":0.16138,"14":1.17312,"3.1":0,"3.2":0,"5.1":0.56484,"6.1":0,"7.1":0,"9.1":0.00621,"10.1":0.01241,"11.1":0.08069,"12.1":0.18621,"13.1":1.1545},"edge":{"12":0.00621,"13":0,"14":0.01862,"15":0.00621,"16":0.00621,"17":0.04345,"18":0.27932,"79":0,"80":0,"81":0,"83":0,"84":0.00621,"85":0.55242,"86":1.01174},"android":{"3":0,"4":0.22375,"81":null,"2.1":0,"2.2":0,"2.3":0.00179,"4.1":0.11277,"4.2-4.3":0.05012,"4.4":0,"4.4.3-4.4.4":0.40813},"samsung":{"4":0.09176,"5.0-5.4":0.0102,"6.2-6.4":0.02039,"7.2-7.4":0.03059,"8.2":0.0102,"9.2":0.09176,"10.1":0.04078,"11.1-11.2":0.11215,"12.0":1.02973},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.06124,"9":0.01531,"10":0.02297,"11":0.13014,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.21241},"and_qq":{"10.4":0},"and_uc":{"0":0.0569},"op_mini":{"0":0.12209},"and_chr":{"0":44.52057}},"total":98.6352}

/***/ },
/* 1207 */
/***/ function(module, exports) {

	module.exports = {"id":"DZ","name":"Algeria","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00557,"39":0,"40":0,"41":0,"42":0,"43":0.00557,"44":0,"45":0,"46":0,"47":0.0167,"48":0.02227,"49":0.00557,"50":0,"51":0,"52":0.15031,"53":0,"54":0,"55":0.00557,"56":0.00557,"57":0,"58":0,"59":0.00557,"60":0.00557,"61":0.00557,"62":0,"63":0.00557,"64":0.00557,"65":0.01113,"66":0.00557,"67":0.00557,"68":0.0334,"69":0.00557,"70":0.00557,"71":0.00557,"72":0.0334,"73":0.00557,"74":0.00557,"75":0.00557,"76":0.00557,"77":0.01113,"78":0.08907,"79":0.02227,"80":0.09464,"81":1.98185,"82":0.33402,"83":0.0167,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0.00557,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00557,"23":0,"24":0,"25":0,"26":0.00557,"27":0,"28":0,"29":0.00557,"30":0.00557,"31":0.01113,"32":0.00557,"33":0.02784,"34":0.00557,"35":0,"36":0,"37":0,"38":0.01113,"39":0.00557,"40":0.03897,"41":0,"42":0.00557,"43":0.20041,"44":0.00557,"45":0.00557,"46":0.00557,"47":0.00557,"48":0.01113,"49":0.31732,"50":0.01113,"51":0.00557,"52":0.00557,"53":0.00557,"54":0.00557,"55":0.00557,"56":0.0167,"57":0.00557,"58":0.0167,"59":0.00557,"60":0.01113,"61":0.07794,"62":0.01113,"63":0.0501,"64":0.01113,"65":0.03897,"66":0.00557,"67":0.0167,"68":0.01113,"69":0.04454,"70":0.0501,"71":0.05567,"72":0.0501,"73":0.05567,"74":0.08351,"75":0.0334,"76":0.04454,"77":0.0501,"78":0.05567,"79":0.13361,"80":0.24495,"81":0.17814,"83":0.19485,"84":0.34515,"85":7.20927,"86":11.76864,"87":0.02227,"88":0.0167,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00557,"37":0.0167,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00557,"48":0,"49":0,"50":0.01113,"51":0.0501,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0.00557,"58":0.00557,"60":0.00557,"62":0,"63":0.00557,"64":0,"65":0,"66":0,"67":0.00557,"68":0.0167,"69":0.00557,"70":0.17814,"71":1.40845,"72":0.03897,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":1.18781,"3.2":0.00285,"4.0-4.1":0.00244,"4.2-4.3":0.00041,"5.0-5.1":0.00203,"6.0-6.1":0.00122,"7.0-7.1":0.00285,"8.1-8.4":0.00935,"9.0-9.2":0.00528,"9.3":0.06748,"10.0-10.2":0.01138,"10.3":0.0626,"11.0-11.2":0.02358,"11.3-11.4":0.04024,"12.0-12.1":0.04106,"12.2-12.4":0.40935,"13.0-13.1":0.03374,"13.2":0.01667,"13.3":0.12683,"13.4-13.7":0.67561},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.01113,"12":0.02784,"13":0.10021,"14":0.15588,"3.1":0,"3.2":0,"5.1":0.07237,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00557,"11.1":0.0334,"12.1":0.05567,"13.1":0.11691},"edge":{"12":0.01113,"13":0.00557,"14":0.00557,"15":0.01113,"16":0.01113,"17":0.0167,"18":0.07237,"79":0,"80":0,"81":0.00557,"83":0.00557,"84":0.01113,"85":0.30619,"86":0.58454},"android":{"3":0,"4":0.10747,"81":null,"2.1":0,"2.2":0,"2.3":0.00086,"4.1":0.05416,"4.2-4.3":0.02407,"4.4":0,"4.4.3-4.4.4":0.19602},"samsung":{"4":0.1828,"5.0-5.4":0.03047,"6.2-6.4":0.02031,"7.2-7.4":0.15233,"8.2":0.03047,"9.2":0.13202,"10.1":0.0914,"11.1-11.2":0.1828,"12.0":1.40147},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.11023,"9":0.02004,"10":0.02004,"11":0.25052,"5.5":0},"bb":{"7":0,"10":0.00443},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.12412},"and_qq":{"10.4":0.03546},"and_uc":{"0":0.50536},"op_mini":{"0":0.61274},"and_chr":{"0":62.57242}},"total":97.54238}

/***/ },
/* 1208 */
/***/ function(module, exports) {

	module.exports = {"id":"EC","name":"Ecuador","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0.00738,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00738,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0.00738,"45":0,"46":0,"47":0.00738,"48":0.01476,"49":0,"50":0,"51":0.00738,"52":0.02952,"53":0,"54":0,"55":0,"56":0.00738,"57":0,"58":0,"59":0.00738,"60":0.00738,"61":0.00738,"62":0,"63":0.00738,"64":0.00738,"65":0.00738,"66":0.02952,"67":0.00738,"68":0.01476,"69":0.00738,"70":0.00738,"71":0.00738,"72":0.01476,"73":0.01476,"74":0.00738,"75":0.00738,"76":0.01476,"77":0.02214,"78":0.22143,"79":0.02952,"80":0.08857,"81":3.39526,"82":0.45762,"83":0.00738,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.01476,"23":0,"24":0,"25":0,"26":0.00738,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.02952,"39":0,"40":0,"41":0,"42":0.00738,"43":0,"44":0,"45":0,"46":0,"47":0.01476,"48":0.01476,"49":0.155,"50":0,"51":0,"52":0,"53":0.03691,"54":0,"55":0,"56":0,"57":0,"58":0.00738,"59":0,"60":0,"61":0.02214,"62":0.00738,"63":0.02952,"64":0.00738,"65":0.05167,"66":0.00738,"67":0.04429,"68":0.00738,"69":0.02952,"70":0.04429,"71":0.05167,"72":0.03691,"73":0.02952,"74":0.05905,"75":0.07381,"76":0.04429,"77":0.04429,"78":0.07381,"79":0.1181,"80":0.18453,"81":0.12548,"83":0.20667,"84":0.36167,"85":14.84319,"86":25.12492,"87":0.02214,"88":0.00738,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0.00738,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0.00738,"70":0.14762,"71":1.39501,"72":0.01476,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":2.31024,"3.2":0.00553,"4.0-4.1":0.00474,"4.2-4.3":0.00079,"5.0-5.1":0.00395,"6.0-6.1":0.00237,"7.0-7.1":0.00553,"8.1-8.4":0.01818,"9.0-9.2":0.01028,"9.3":0.13125,"10.0-10.2":0.02214,"10.3":0.12176,"11.0-11.2":0.04586,"11.3-11.4":0.07827,"12.0-12.1":0.07985,"12.2-12.4":0.79617,"13.0-13.1":0.06562,"13.2":0.03242,"13.3":0.24668,"13.4-13.7":1.31404},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00738,"11":0.02214,"12":0.06643,"13":0.19191,"14":1.27691,"3.1":0,"3.2":0,"5.1":0.72334,"6.1":0,"7.1":0,"9.1":0.00738,"10.1":0.01476,"11.1":0.12548,"12.1":0.24357,"13.1":1.12929},"edge":{"12":0,"13":0,"14":0.00738,"15":0.00738,"16":0,"17":0.00738,"18":0.05167,"79":0,"80":0,"81":0,"83":0.00738,"84":0.00738,"85":0.55358,"86":1.10715},"android":{"3":0,"4":0.05959,"81":null,"2.1":0,"2.2":0,"2.3":0.00048,"4.1":0.03003,"4.2-4.3":0.01335,"4.4":0,"4.4.3-4.4.4":0.10869},"samsung":{"4":0.13135,"5.0-5.4":0,"6.2-6.4":0.0101,"7.2-7.4":0.07073,"8.2":0.0101,"9.2":0.06062,"10.1":0.03031,"11.1-11.2":0.13135,"12.0":1.54587},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01737,"9":0.00868,"10":0,"11":0.12157,"5.5":0},"bb":{"7":0,"10":0.00262},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.08905},"and_qq":{"10.4":0.00262},"and_uc":{"0":0.0419},"op_mini":{"0":0.05951},"and_chr":{"0":36.76377}},"total":98.1692}

/***/ },
/* 1209 */
/***/ function(module, exports) {

	module.exports = {"id":"EE","name":"Estonia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0.0073,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.0073,"49":0,"50":0,"51":0,"52":0.05837,"53":0,"54":0,"55":0.0073,"56":0.06566,"57":0,"58":0.0073,"59":0,"60":0.0073,"61":0,"62":0,"63":0.02189,"64":0,"65":0.04378,"66":0.01459,"67":0.05107,"68":0.08755,"69":0.0073,"70":0.0073,"71":0.01459,"72":0.0073,"73":0,"74":0,"75":0.0073,"76":0.01459,"77":0.01459,"78":0.12403,"79":0.06566,"80":0.15322,"81":3.24672,"82":0.51072,"83":0.0073,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.0073,"35":0,"36":0,"37":0,"38":0.0073,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.01459,"46":0,"47":0,"48":0,"49":0.13133,"50":0,"51":0,"52":0,"53":0.0073,"54":0,"55":0,"56":0,"57":0,"58":0.0073,"59":0,"60":0.01459,"61":0,"62":0,"63":0.0073,"64":0.0073,"65":0.05107,"66":0.0073,"67":0.01459,"68":0.01459,"69":0.7223,"70":0.04378,"71":0.08755,"72":0.10214,"73":0.02918,"74":0.0073,"75":0.02918,"76":0.02918,"77":0.03648,"78":0.10944,"79":0.11674,"80":0.24077,"81":0.07296,"83":0.1751,"84":0.40858,"85":16.99968,"86":19.1593,"87":0.02189,"88":0.0073,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.0073,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.0073,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.0073,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.0073,"69":0.0073,"70":0.29914,"71":2.02099,"72":0.02189,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":6.46366,"3.2":0.01548,"4.0-4.1":0.01327,"4.2-4.3":0.00221,"5.0-5.1":0.01106,"6.0-6.1":0.00664,"7.0-7.1":0.01548,"8.1-8.4":0.05088,"9.0-9.2":0.02876,"9.3":0.3672,"10.0-10.2":0.06194,"10.3":0.34066,"11.0-11.2":0.1283,"11.3-11.4":0.21899,"12.0-12.1":0.22342,"12.2-12.4":2.22755,"13.0-13.1":0.1836,"13.2":0.09069,"13.3":0.69016,"13.4-13.7":3.67645},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.0073,"12":0.05107,"13":0.19699,"14":1.52486,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.01459,"11.1":0.06566,"12.1":0.16051,"13.1":1.32787},"edge":{"12":0,"13":0,"14":0,"15":0.0073,"16":0.01459,"17":0.01459,"18":0.21888,"79":0,"80":0,"81":0,"83":0,"84":0.0073,"85":0.7296,"86":1.29869},"android":{"3":0,"4":0.03872,"81":null,"2.1":0,"2.2":0,"2.3":0.00031,"4.1":0.01952,"4.2-4.3":0.00867,"4.4":0,"4.4.3-4.4.4":0.07063},"samsung":{"4":0.0103,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.02059,"8.2":0.0103,"9.2":0.06177,"10.1":0.04118,"11.1-11.2":0.08236,"12.0":2.27523},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0.00777,"7":0,"8":0.04663,"9":0.00777,"10":0.01554,"11":0.63729,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.17035},"and_qq":{"10.4":0.0027},"and_uc":{"0":0.05949},"op_mini":{"0":0.14592},"and_chr":{"0":27.24909}},"total":97.06759}

/***/ },
/* 1210 */
/***/ function(module, exports) {

	module.exports = {"id":"EG","name":"Egypt","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0.00473,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0.00473,"16":0,"17":0,"18":0.00473,"19":0,"20":0,"21":0.00473,"22":0,"23":0.00473,"24":0,"25":0.00473,"26":0,"27":0,"28":0,"29":0,"30":0.00473,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00473,"44":0,"45":0,"46":0,"47":0.00473,"48":0.01419,"49":0.00473,"50":0,"51":0.00473,"52":0.08989,"53":0,"54":0,"55":0.00473,"56":0.00473,"57":0,"58":0,"59":0,"60":0.00473,"61":0,"62":0.00473,"63":0,"64":0.00473,"65":0.00473,"66":0.00473,"67":0.00473,"68":0.01419,"69":0,"70":0,"71":0,"72":0.01419,"73":0,"74":0.00473,"75":0.00473,"76":0.00473,"77":0.00473,"78":0.08043,"79":0.01419,"80":0.04731,"81":1.49027,"82":0.20816,"83":0.00946,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0.00473,"20":0,"21":0,"22":0,"23":0,"24":0.00946,"25":0,"26":0.01892,"27":0,"28":0,"29":0.00473,"30":0.00473,"31":0.00473,"32":0,"33":0.01892,"34":0.00473,"35":0.00473,"36":0,"37":0,"38":0.00473,"39":0,"40":0.02366,"41":0,"42":0,"43":0.17032,"44":0.00473,"45":0,"46":0.00473,"47":0.00473,"48":0.00473,"49":0.10881,"50":0,"51":0.00473,"52":0,"53":0.01419,"54":0.00473,"55":0.00473,"56":0.01419,"57":0,"58":0.00946,"59":0.00473,"60":0.00473,"61":0.01892,"62":0.00473,"63":0.03312,"64":0.00473,"65":0.00946,"66":0.00473,"67":0.00946,"68":0.00946,"69":0.02366,"70":0.02839,"71":0.04731,"72":0.03312,"73":0.02366,"74":0.06623,"75":0.03312,"76":0.05677,"77":0.04258,"78":0.07097,"79":0.10881,"80":0.16085,"81":0.15612,"83":0.12301,"84":0.25074,"85":5.6772,"86":9.76478,"87":0.01419,"88":0.00946,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.00473,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00473,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00473,"52":0,"53":0,"54":0.01892,"55":0,"56":0.00473,"57":0,"58":0,"60":0.00473,"62":0.00473,"63":0,"64":0.00946,"65":0,"66":0.00473,"67":0.00946,"68":0.04731,"69":0.00946,"70":0.26021,"71":0.22236,"72":0.00473,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":2.94433,"3.2":0.00705,"4.0-4.1":0.00605,"4.2-4.3":0.00101,"5.0-5.1":0.00504,"6.0-6.1":0.00302,"7.0-7.1":0.00705,"8.1-8.4":0.02318,"9.0-9.2":0.0131,"9.3":0.16727,"10.0-10.2":0.02821,"10.3":0.15518,"11.0-11.2":0.05844,"11.3-11.4":0.09976,"12.0-12.1":0.10177,"12.2-12.4":1.0147,"13.0-13.1":0.08363,"13.2":0.04131,"13.3":0.31438,"13.4-13.7":1.6747},"safari":{"0":null,"4":0,"5":0.00473,"6":0,"7":0,"8":0,"9":0,"10":0.00473,"11":0.00473,"12":0.01892,"13":0.04258,"14":0.20343,"3.1":0,"3.2":0,"5.1":0.40214,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00473,"11.1":0.02366,"12.1":0.04731,"13.1":0.19397},"edge":{"12":0.00473,"13":0.00473,"14":0.00473,"15":0.00473,"16":0.00946,"17":0.00946,"18":0.07097,"79":0,"80":0,"81":0,"83":0.00473,"84":0.00946,"85":0.26967,"86":0.52987},"android":{"3":0,"4":0.11236,"81":null,"2.1":0,"2.2":0,"2.3":0.0009,"4.1":0.05663,"4.2-4.3":0.02517,"4.4":0,"4.4.3-4.4.4":0.20494},"samsung":{"4":0.19634,"5.0-5.4":0,"6.2-6.4":0.01033,"7.2-7.4":0.07234,"8.2":0.01033,"9.2":0.11367,"10.1":0.062,"11.1-11.2":0.20667,"12.0":1.72571},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.04021,"9":0.01005,"10":0.01005,"11":0.10053,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.12119},"and_qq":{"10.4":0.00527},"and_uc":{"0":0.35829},"op_mini":{"0":0.60359},"and_chr":{"0":65.48988}},"total":98.11438}

/***/ },
/* 1211 */
/***/ function(module, exports) {

	module.exports = {"id":"ER","name":"Eritrea","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0.00194,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0.00194,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0.00194,"31":0.00194,"32":0,"33":0.00194,"34":0.00194,"35":0.00194,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0.00194,"42":0.00194,"43":0.01749,"44":0.00389,"45":0.00194,"46":0,"47":0.00972,"48":0.00194,"49":0,"50":0,"51":0,"52":0.00389,"53":0,"54":0,"55":0,"56":0.00389,"57":0,"58":0.00389,"59":0.00194,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0.00194,"67":0.00194,"68":0.00583,"69":0,"70":0,"71":0,"72":0.00777,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0.00583,"79":0.00972,"80":0.0272,"81":0.28756,"82":0.09715,"83":0.03109,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.0408,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0.00777,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0.00972,"34":0.00194,"35":0,"36":0,"37":0.00194,"38":0.00194,"39":0,"40":0.01166,"41":0,"42":0,"43":0.0136,"44":0,"45":0,"46":0.00583,"47":0,"48":0,"49":0.00583,"50":0.00583,"51":0.00194,"52":0.00194,"53":0,"54":0.00194,"55":0.00389,"56":0.00194,"57":0.00194,"58":0,"59":0,"60":0,"61":0.00194,"62":0.00194,"63":0.00583,"64":0.00194,"65":0,"66":0.00194,"67":0.00389,"68":0.00777,"69":0.00194,"70":0.00389,"71":0.00194,"72":0.00194,"73":0.00194,"74":0.02137,"75":0.00777,"76":0.00194,"77":0.0136,"78":0.00389,"79":0.02332,"80":0.01943,"81":0.04858,"83":0.00583,"84":0.09909,"85":0.13795,"86":1.43588,"87":0.00194,"88":0.00194,"89":0},"opera":{"9":0,"11":0,"12":0.00194,"15":0.00194,"16":0.00194,"17":0,"18":0.00194,"19":0.00583,"20":0.01166,"21":0,"22":0,"23":0.00389,"24":0,"25":0,"26":0,"27":0,"28":0.00777,"29":0.00583,"30":0.00583,"31":0,"32":0.00194,"33":0.00194,"34":0.00194,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0.00389,"43":0.00194,"44":0,"45":0.01554,"46":0.00389,"47":0.00194,"48":0.00194,"49":0,"50":0.06218,"51":0.0544,"52":0,"53":0.00389,"54":0,"55":0,"56":0.01166,"57":0,"58":0,"60":0.04469,"62":0.00194,"63":0,"64":0,"65":0,"66":0,"67":0.00194,"68":0,"69":0.00194,"70":0.00777,"71":0.17487,"72":0.02137,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.10492},"ios_saf":{"8":0,"14":1.14624,"3.2":0.00275,"4.0-4.1":0.00235,"4.2-4.3":0.00039,"5.0-5.1":0.00196,"6.0-6.1":0.00118,"7.0-7.1":0.00275,"8.1-8.4":0.00902,"9.0-9.2":0.0051,"9.3":0.06512,"10.0-10.2":0.01098,"10.3":0.06041,"11.0-11.2":0.02275,"11.3-11.4":0.03884,"12.0-12.1":0.03962,"12.2-12.4":0.39503,"13.0-13.1":0.03256,"13.2":0.01608,"13.3":0.12239,"13.4-13.7":0.65197},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0.00389,"14":0.01166,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.00194,"10.1":0.00194,"11.1":0.00194,"12.1":0.01943,"13.1":0.01554},"edge":{"12":0.01943,"13":0.00194,"14":0.00389,"15":0,"16":0.00194,"17":0.00972,"18":0.05829,"79":0,"80":0,"81":0.00194,"83":0.00194,"84":0.00389,"85":0.00777,"86":0.18653},"android":{"3":0,"4":0.23549,"81":null,"2.1":0,"2.2":0,"2.3":0.00188,"4.1":0.11869,"4.2-4.3":0.05275,"4.4":0,"4.4.3-4.4.4":0.42953},"samsung":{"4":1.0623,"5.0-5.4":0.08094,"6.2-6.4":0.21246,"7.2-7.4":0.37433,"8.2":0.02023,"9.2":0.40469,"10.1":0.13152,"11.1-11.2":0.16187,"12.0":1.54792},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.02165,"9":0,"10":0,"11":0.05413,"5.5":0},"bb":{"7":0,"10":0.00806},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.07251},"and_qq":{"10.4":1.54694},"and_uc":{"0":1.97397},"op_mini":{"0":28.42136},"and_chr":{"0":48.09138}},"total":91.10277}

/***/ },
/* 1212 */
/***/ function(module, exports) {

	module.exports = {"id":"ES","name":"Spain","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00561,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.00561,"46":0,"47":0.00561,"48":0.01684,"49":0,"50":0,"51":0,"52":0.06736,"53":0,"54":0,"55":0,"56":0.00561,"57":0,"58":0,"59":0.00561,"60":0.01123,"61":0,"62":0.00561,"63":0.00561,"64":0.00561,"65":0.00561,"66":0.01684,"67":0.01684,"68":0.03929,"69":0.01123,"70":0.01123,"71":0,"72":0.01123,"73":0.00561,"74":0.00561,"75":0.00561,"76":0.00561,"77":0.01123,"78":0.15716,"79":0.02807,"80":0.07297,"81":2.00384,"82":0.33678,"83":0.00561,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.01123,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.00561,"47":0,"48":0,"49":0.21891,"50":0,"51":0.00561,"52":0,"53":0.02245,"54":0.01123,"55":0,"56":0.00561,"57":0.00561,"58":0.00561,"59":0,"60":0,"61":0.02245,"62":0.00561,"63":0.01123,"64":0.00561,"65":0.02245,"66":0.01123,"67":0.02245,"68":0.01123,"69":0.01684,"70":0.03368,"71":0.05613,"72":0.03368,"73":0.02807,"74":0.01684,"75":0.0449,"76":0.03368,"77":0.02807,"78":0.03929,"79":0.05613,"80":0.0842,"81":0.07858,"83":0.12349,"84":0.17962,"85":8.1613,"86":12.71345,"87":0.01123,"88":0.00561,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00561,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.01123,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00561,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00561,"69":0,"70":0.06174,"71":0.49956,"72":0.01123,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":6.25128,"3.2":0.01498,"4.0-4.1":0.01284,"4.2-4.3":0.00214,"5.0-5.1":0.0107,"6.0-6.1":0.00642,"7.0-7.1":0.01498,"8.1-8.4":0.04921,"9.0-9.2":0.02781,"9.3":0.35514,"10.0-10.2":0.0599,"10.3":0.32946,"11.0-11.2":0.12408,"11.3-11.4":0.2118,"12.0-12.1":0.21608,"12.2-12.4":2.15436,"13.0-13.1":0.17757,"13.2":0.08771,"13.3":0.66749,"13.4-13.7":3.55565},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.01123,"12":0.02245,"13":0.15155,"14":1.00473,"3.1":0,"3.2":0,"5.1":0.01684,"6.1":0,"7.1":0,"9.1":0.00561,"10.1":0.02245,"11.1":0.07297,"12.1":0.11787,"13.1":1.07208},"edge":{"12":0,"13":0,"14":0,"15":0.00561,"16":0.00561,"17":0.01684,"18":0.11226,"79":0,"80":0,"81":0,"83":0.00561,"84":0.00561,"85":0.52201,"86":1.06647},"android":{"3":0,"4":0.05317,"81":null,"2.1":0,"2.2":0,"2.3":0.00043,"4.1":0.0268,"4.2-4.3":0.01191,"4.4":0,"4.4.3-4.4.4":0.09699},"samsung":{"4":0.11399,"5.0-5.4":0.01036,"6.2-6.4":0,"7.2-7.4":0.01036,"8.2":0.01036,"9.2":0.04145,"10.1":0.04145,"11.1-11.2":0.09327,"12.0":2.31095},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01201,"9":0.01201,"10":0,"11":0.49238,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.26761},"and_qq":{"10.4":0.01316},"and_uc":{"0":0.04826},"op_mini":{"0":0.23259},"and_chr":{"0":49.87612}},"total":97.98322}

/***/ },
/* 1213 */
/***/ function(module, exports) {

	module.exports = {"id":"ET","name":"Ethiopia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0.00511,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0.00511,"20":0.00511,"21":0,"22":0,"23":0,"24":0,"25":0.00511,"26":0,"27":0.00511,"28":0.01023,"29":0.00511,"30":0.01534,"31":0.02045,"32":0.00511,"33":0.00511,"34":0.01534,"35":0.01023,"36":0.00511,"37":0.00511,"38":0.00511,"39":0,"40":0.00511,"41":0.00511,"42":0.01023,"43":0.03068,"44":0.02045,"45":0.00511,"46":0.01023,"47":0.06647,"48":0.02557,"49":0.01023,"50":0.01023,"51":0,"52":0.27099,"53":0,"54":0.00511,"55":0.00511,"56":0.02045,"57":0.02045,"58":0.01023,"59":0.00511,"60":0.00511,"61":0.00511,"62":0.00511,"63":0.00511,"64":0.00511,"65":0.00511,"66":0.03068,"67":0.00511,"68":0.05624,"69":0.01023,"70":0.01023,"71":0.00511,"72":0.04602,"73":0.01023,"74":0.01023,"75":0.01534,"76":0.01023,"77":0.01534,"78":0.15339,"79":0.04602,"80":0.1176,"81":2.40822,"82":0.53687,"83":0.14316,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.01534,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0.00511,"26":0.00511,"27":0,"28":0,"29":0,"30":0,"31":0.00511,"32":0.00511,"33":0.02557,"34":0.00511,"35":0,"36":0.00511,"37":0.00511,"38":0.00511,"39":0.00511,"40":0.05624,"41":0,"42":0.00511,"43":0.3528,"44":0,"45":0.00511,"46":0.00511,"47":0,"48":0,"49":0.02557,"50":0.00511,"51":0.02557,"52":0,"53":0.0409,"54":0,"55":0.01023,"56":0.00511,"57":0.00511,"58":0.01534,"59":0,"60":0.03579,"61":0.01023,"62":0.01023,"63":0.08181,"64":0.01023,"65":0.04602,"66":0.00511,"67":0.03068,"68":0.00511,"69":0.03579,"70":0.02045,"71":0.01534,"72":0.02557,"73":0.02557,"74":0.08181,"75":0.02557,"76":0.02045,"77":0.06136,"78":0.04602,"79":0.17384,"80":0.25054,"81":0.09203,"83":0.13805,"84":0.5522,"85":4.69373,"86":7.2349,"87":0.0409,"88":0.01534,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0.00511,"16":0,"17":0,"18":0.00511,"19":0,"20":0.01534,"21":0.00511,"22":0,"23":0.01023,"24":0.00511,"25":0,"26":0,"27":0.00511,"28":0.01534,"29":0.00511,"30":0.00511,"31":0,"32":0.00511,"33":0,"34":0,"35":0,"36":0.01534,"37":0,"38":0,"39":0,"40":0.00511,"41":0,"42":0.01023,"43":0,"44":0,"45":0.00511,"46":0.01023,"47":0.00511,"48":0,"49":0,"50":0.0409,"51":0.1176,"52":0,"53":0.02045,"54":0,"55":0,"56":0.00511,"57":0.00511,"58":0.00511,"60":0.03068,"62":0.00511,"63":0.00511,"64":0,"65":0.00511,"66":0.00511,"67":0.00511,"68":0.01023,"69":0.00511,"70":0.7465,"71":1.91738,"72":0.06136,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.1176},"ios_saf":{"8":0,"14":1.56747,"3.2":0.00376,"4.0-4.1":0.00322,"4.2-4.3":0.00054,"5.0-5.1":0.00268,"6.0-6.1":0.00161,"7.0-7.1":0.00376,"8.1-8.4":0.01234,"9.0-9.2":0.00697,"9.3":0.08905,"10.0-10.2":0.01502,"10.3":0.08261,"11.0-11.2":0.03111,"11.3-11.4":0.05311,"12.0-12.1":0.05418,"12.2-12.4":0.54019,"13.0-13.1":0.04452,"13.2":0.02199,"13.3":0.16737,"13.4-13.7":0.89156},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0.00511,"8":0,"9":0,"10":0.00511,"11":0.01023,"12":0.01023,"13":0.05113,"14":0.12271,"3.1":0,"3.2":0,"5.1":0.00511,"6.1":0,"7.1":0,"9.1":0.01023,"10.1":0.00511,"11.1":0.01534,"12.1":0.06647,"13.1":0.14316},"edge":{"12":0.14828,"13":0.02557,"14":0.01023,"15":0.01534,"16":0.03068,"17":0.04602,"18":0.78229,"79":0,"80":0,"81":0.00511,"83":0.01023,"84":0.02557,"85":0.44483,"86":0.69537},"android":{"3":0,"4":0.15868,"81":null,"2.1":0,"2.2":0,"2.3":0.00127,"4.1":0.07997,"4.2-4.3":0.03554,"4.4":0,"4.4.3-4.4.4":0.28943},"samsung":{"4":0.54082,"5.0-5.4":0.06123,"6.2-6.4":0.05102,"7.2-7.4":0.20408,"8.2":0.02041,"9.2":0.2551,"10.1":0.09184,"11.1-11.2":0.2449,"12.0":1.41838},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.04243,"9":0.00849,"10":0,"11":0.3479,"5.5":0},"bb":{"7":0,"10":0.00489},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.20037},"and_qq":{"10.4":0.32743},"and_uc":{"0":1.9939},"op_mini":{"0":11.10407},"and_chr":{"0":44.6738}},"total":90.43454}

/***/ },
/* 1214 */
/***/ function(module, exports) {

	module.exports = {"id":"FI","name":"Finland","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0.00595,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00595,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.01786,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00595,"48":0.00595,"49":0,"50":0,"51":0,"52":0.05359,"53":0,"54":0.01191,"55":0.01191,"56":0.01191,"57":0,"58":0,"59":0.01191,"60":0.01191,"61":0.00595,"62":0.00595,"63":0.02382,"64":0.02382,"65":0.01191,"66":0.00595,"67":0.00595,"68":0.10122,"69":0,"70":0,"71":0,"72":0.01191,"73":0,"74":0,"75":0.00595,"76":0.00595,"77":0.01786,"78":0.20839,"79":0.03572,"80":0.13694,"81":3.26875,"82":0.64899,"83":0.00595,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0.00595,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00595,"39":0,"40":0,"41":0,"42":0,"43":0.00595,"44":0,"45":0,"46":0,"47":0,"48":0.00595,"49":0.07145,"50":0,"51":0,"52":0.04763,"53":0.01786,"54":0,"55":0,"56":0.00595,"57":0.01786,"58":0,"59":0.01191,"60":0.08931,"61":0.00595,"62":0,"63":0.01191,"64":0.23816,"65":0.00595,"66":0.04763,"67":0.01786,"68":0.01191,"69":0.1548,"70":0.30961,"71":0.11908,"72":0.36319,"73":0.04168,"74":0.01786,"75":0.02977,"76":0.03572,"77":0.02382,"78":0.02977,"79":0.51204,"80":0.32747,"81":0.16671,"83":0.13694,"84":0.30365,"85":8.31178,"86":11.55671,"87":0.01786,"88":0.00595,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.01786,"52":0,"53":0,"54":0,"55":0,"56":0.01191,"57":0.01191,"58":0,"60":0.00595,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.06549,"71":0.46441,"72":0.02382,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":8.84398,"3.2":0.02119,"4.0-4.1":0.01816,"4.2-4.3":0.00303,"5.0-5.1":0.01513,"6.0-6.1":0.00908,"7.0-7.1":0.02119,"8.1-8.4":0.06961,"9.0-9.2":0.03935,"9.3":0.50243,"10.0-10.2":0.08475,"10.3":0.46611,"11.0-11.2":0.17555,"11.3-11.4":0.29964,"12.0-12.1":0.3057,"12.2-12.4":3.04787,"13.0-13.1":0.25122,"13.2":0.12409,"13.3":0.94433,"13.4-13.7":5.03035},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00595,"11":0.00595,"12":0.02977,"13":0.20244,"14":1.29202,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.00595,"10.1":0.04168,"11.1":0.10717,"12.1":0.14885,"13.1":1.49445},"edge":{"12":0,"13":0,"14":0.01191,"15":0.00595,"16":0.01786,"17":0.05359,"18":0.19648,"79":0,"80":0,"81":0,"83":0.00595,"84":0.01191,"85":0.64303,"86":1.23248},"android":{"3":0,"4":0.05063,"81":null,"2.1":0,"2.2":0,"2.3":0.00041,"4.1":0.02552,"4.2-4.3":0.01134,"4.4":0,"4.4.3-4.4.4":0.09234},"samsung":{"4":0.05231,"5.0-5.4":0.01046,"6.2-6.4":0,"7.2-7.4":0.03138,"8.2":0.02092,"9.2":0.12554,"10.1":0.10461,"11.1-11.2":0.17784,"12.0":2.53166},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0.0061,"7":0,"8":0.02438,"9":0.01219,"10":0.0061,"11":0.46328,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.00405},"baidu":{"0":null},"and_ff":{"0":0.42078},"and_qq":{"10.4":0},"and_uc":{"0":0.12543},"op_mini":{"0":0.30644},"and_chr":{"0":38.61507}},"total":97.38161}

/***/ },
/* 1215 */
/***/ function(module, exports) {

	module.exports = {"id":"FJ","name":"Fiji","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.01087,"48":0.00544,"49":0,"50":0,"51":0,"52":0.03262,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0.02175,"59":0,"60":0,"61":0,"62":0.00544,"63":0,"64":0.00544,"65":0.00544,"66":0,"67":0,"68":0.0435,"69":0.01087,"70":0,"71":0,"72":0.02175,"73":0,"74":0.01087,"75":0,"76":0.00544,"77":0.00544,"78":0.03262,"79":0.01087,"80":0.09243,"81":1.5278,"82":0.22292,"83":0.01087,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.07068,"50":0,"51":0,"52":0,"53":0.00544,"54":0,"55":0.00544,"56":0.00544,"57":0,"58":0.01631,"59":0,"60":0,"61":0.02175,"62":0,"63":0.01087,"64":0,"65":0.07068,"66":0,"67":0,"68":0,"69":0.01087,"70":0,"71":0.00544,"72":0.00544,"73":0.00544,"74":0.01631,"75":0.00544,"76":0.01631,"77":0.0435,"78":0.01087,"79":0.07068,"80":0.12505,"81":0.0435,"83":0.07068,"84":0.07068,"85":4.92592,"86":7.51393,"87":0.00544,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.02175,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00544,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.07612,"71":0.21204,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":2.00199,"3.2":0.0048,"4.0-4.1":0.00411,"4.2-4.3":0.00069,"5.0-5.1":0.00343,"6.0-6.1":0.00206,"7.0-7.1":0.0048,"8.1-8.4":0.01576,"9.0-9.2":0.00891,"9.3":0.11373,"10.0-10.2":0.01918,"10.3":0.10551,"11.0-11.2":0.03974,"11.3-11.4":0.06783,"12.0-12.1":0.0692,"12.2-12.4":0.68994,"13.0-13.1":0.05687,"13.2":0.02809,"13.3":0.21377,"13.4-13.7":1.13871},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.02175,"12":0.04893,"13":0.05981,"14":0.44583,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.01087,"11.1":0.06524,"12.1":0.03262,"13.1":0.38059},"edge":{"12":0.01087,"13":0.00544,"14":0.00544,"15":0.01631,"16":0.02719,"17":0.0435,"18":9.3462,"79":0,"80":0,"81":0,"83":0,"84":0.01631,"85":0.38603,"86":0.96779},"android":{"3":0,"4":0.07254,"81":null,"2.1":0,"2.2":0,"2.3":0.00058,"4.1":0.03656,"4.2-4.3":0.01625,"4.4":0,"4.4.3-4.4.4":0.13232},"samsung":{"4":0.65253,"5.0-5.4":0.03059,"6.2-6.4":0.05098,"7.2-7.4":0.78508,"8.2":0.02039,"9.2":0.44862,"10.1":0.18352,"11.1-11.2":0.64234,"12.0":10.79738},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0.01442,"11":0.64889,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.13233},"and_qq":{"10.4":0.01369},"and_uc":{"0":1.35065},"op_mini":{"0":0.27216},"and_chr":{"0":43.26831}},"total":91.59981}

/***/ },
/* 1216 */
/***/ function(module, exports) {

	module.exports = {"id":"FK","name":"Falkland Islands (Malvinas)","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.07322,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.0169,"69":0,"70":0.01126,"71":0,"72":0.00563,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0.02816,"79":0.01126,"80":0.00563,"81":2.49498,"82":0.36045,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.02816,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0.00563,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0,"72":0,"73":0.23654,"74":0,"75":0,"76":0,"77":0,"78":0,"79":0,"80":0,"81":0.02253,"83":0.00563,"84":0.00563,"85":1.18272,"86":8.97178,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00563,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.0169,"71":0.07885,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":4.23944,"3.2":0.01016,"4.0-4.1":0.00871,"4.2-4.3":0.00145,"5.0-5.1":0.00725,"6.0-6.1":0.00435,"7.0-7.1":0.01016,"8.1-8.4":0.03337,"9.0-9.2":0.01886,"9.3":0.24084,"10.0-10.2":0.04062,"10.3":0.22343,"11.0-11.2":0.08415,"11.3-11.4":0.14364,"12.0-12.1":0.14654,"12.2-12.4":1.46102,"13.0-13.1":0.12042,"13.2":0.05949,"13.3":0.45267,"13.4-13.7":2.41134},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0.4224,"9":0.1577,"10":0,"11":0,"12":0,"13":0.0169,"14":13.42106,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0.0169,"12.1":0.05069,"13.1":0.52378},"edge":{"12":0,"13":0.00563,"14":0,"15":0,"16":0,"17":0.05632,"18":0.77158,"79":0,"80":0,"81":0.00563,"83":0,"84":0.02816,"85":0.39424,"86":0.64768},"android":{"3":0,"4":0.08472,"81":null,"2.1":0,"2.2":0,"2.3":0.00068,"4.1":0.0427,"4.2-4.3":0.01898,"4.4":0,"4.4.3-4.4.4":0.15453},"samsung":{"4":0,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.02044,"8.2":0,"9.2":1.94151,"10.1":0.02044,"11.1-11.2":0.31677,"12.0":2.75899},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.94054,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.07426},"and_qq":{"10.4":0},"and_uc":{"0":0},"op_mini":{"0":0.10752},"and_chr":{"0":50.80619}},"total":97.09234}

/***/ },
/* 1217 */
/***/ function(module, exports) {

	module.exports = {"id":"FM","name":"Micronesia, Federated States of","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":null,"3":null,"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":0.01909,"48":0.06362,"49":null,"50":null,"51":null,"52":0.13996,"53":null,"54":null,"55":null,"56":null,"57":null,"58":null,"59":0.09543,"60":0.17177,"61":null,"62":null,"63":null,"64":null,"65":null,"66":0.01909,"67":null,"68":0.01909,"69":null,"70":null,"71":null,"72":0.03181,"73":null,"74":null,"75":null,"76":0.03181,"77":null,"78":0.0509,"79":0.05726,"80":0.57258,"81":4.1353,"82":0.41353,"83":0.0509,"84":null,"3.5":null,"3.6":null},"chrome":{"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":0.04453,"24":null,"25":null,"26":0.15905,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":0.03817,"50":null,"51":null,"52":null,"53":null,"54":0.01272,"55":null,"56":null,"57":null,"58":null,"59":null,"60":null,"61":null,"62":null,"63":null,"64":null,"65":0.09543,"66":null,"67":0.02545,"68":null,"69":0.06998,"70":null,"71":0.03181,"72":0.01272,"73":null,"74":0.02545,"75":0.01909,"76":null,"77":null,"78":null,"79":0.01909,"80":0.41989,"81":null,"83":0.06998,"84":0.1336,"85":17.69272,"86":22.97954,"87":null,"88":null,"89":null},"opera":{"9":null,"11":null,"12":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":null,"51":null,"52":null,"53":null,"54":null,"55":null,"56":null,"57":null,"58":0.06998,"60":null,"62":null,"63":null,"64":null,"65":null,"66":null,"67":null,"68":null,"69":null,"70":0.03817,"71":0.69346,"72":0.01909,"9.5-9.6":null,"10.0-10.1":0,"10.5":null,"10.6":null,"11.1":null,"11.5":null,"11.6":null,"12.1":null},"ios_saf":{"8":0,"14":1.98915,"3.2":0.00477,"4.0-4.1":0.00408,"4.2-4.3":0.00068,"5.0-5.1":0.0034,"6.0-6.1":0.00204,"7.0-7.1":0.00477,"8.1-8.4":0.01566,"9.0-9.2":0.00885,"9.3":0.113,"10.0-10.2":0.01906,"10.3":0.10484,"11.0-11.2":0.03948,"11.3-11.4":0.06739,"12.0-12.1":0.06876,"12.2-12.4":0.68552,"13.0-13.1":0.0565,"13.2":0.02791,"13.3":0.21239,"13.4-13.7":1.13141},"safari":{"0":null,"4":0,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":0.08271,"14":0.52168,"3.1":null,"3.2":null,"5.1":null,"6.1":null,"7.1":null,"9.1":0.04453,"10.1":0.02545,"11.1":0.01909,"12.1":0.04453,"13.1":0.8207},"edge":{"12":null,"13":0.02545,"14":null,"15":0.13996,"16":0.01909,"17":0.69346,"18":0.78889,"79":null,"80":null,"81":null,"83":null,"84":0.0509,"85":1.9595,"86":4.7715},"android":{"3":0,"4":0.02044,"81":null,"2.1":0,"2.2":0,"2.3":0.00016,"4.1":0.0103,"4.2-4.3":0.00458,"4.4":0,"4.4.3-4.4.4":0.03729},"samsung":{"4":0.08227,"5.0-5.4":0.02135,"6.2-6.4":0,"7.2-7.4":0.11742,"8.2":0.01028,"9.2":0.11742,"10.1":0.02135,"11.1-11.2":0.28821,"12.0":1.03542},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":null,"7":null,"8":null,"9":null,"10":null,"11":1.07518,"5.5":null},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0},"and_qq":{"10.4":0.03639},"and_uc":{"0":0.2802},"op_mini":{"0":0.29973},"and_chr":{"0":32.88766}},"total":99.45481}

/***/ },
/* 1218 */
/***/ function(module, exports) {

	module.exports = {"id":"FO","name":"Faroe Islands","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.01102,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.01102,"49":0,"50":0.01102,"51":0,"52":0.01102,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.04959,"69":0.00551,"70":0.00551,"71":0,"72":0.00551,"73":0,"74":0,"75":0.00551,"76":0,"77":0.00551,"78":0.29203,"79":0.00551,"80":0.03857,"81":1.27832,"82":0.22591,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.00551,"35":0,"36":0,"37":0,"38":0.00551,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.13224,"50":0,"51":0,"52":0,"53":0.02755,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0.00551,"62":0,"63":0,"64":0,"65":0.00551,"66":0.00551,"67":0.03857,"68":0.00551,"69":0,"70":0.00551,"71":0.01102,"72":0.00551,"73":0,"74":0,"75":0.07163,"76":0.01653,"77":0.01102,"78":0.03857,"79":0.02204,"80":0.0551,"81":0.02204,"83":0.13775,"84":0.08265,"85":4.09944,"86":7.91787,"87":0.00551,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.01102,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.00551,"71":0.0551,"72":0.00551,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":19.08838,"3.2":0.04573,"4.0-4.1":0.0392,"4.2-4.3":0.00653,"5.0-5.1":0.03266,"6.0-6.1":0.0196,"7.0-7.1":0.04573,"8.1-8.4":0.15025,"9.0-9.2":0.08492,"9.3":1.08442,"10.0-10.2":0.18291,"10.3":1.00603,"11.0-11.2":0.37889,"11.3-11.4":0.64673,"12.0-12.1":0.6598,"12.2-12.4":6.57837,"13.0-13.1":0.54221,"13.2":0.26784,"13.3":2.03818,"13.4-13.7":10.85725},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0.00551,"9":0,"10":0,"11":0.00551,"12":0.01653,"13":0.28652,"14":1.28934,"3.1":0,"3.2":0,"5.1":0,"6.1":0.01102,"7.1":0,"9.1":0.06612,"10.1":0.08816,"11.1":0.13775,"12.1":0.10469,"13.1":4.65595},"edge":{"12":0.00551,"13":0,"14":0.01653,"15":0.02755,"16":0.00551,"17":0.01653,"18":0.58406,"79":0,"80":0,"81":0,"83":0,"84":0.00551,"85":1.04139,"86":2.71643},"android":{"3":0,"4":0.01559,"81":null,"2.1":0,"2.2":0,"2.3":0.00012,"4.1":0.00786,"4.2-4.3":0.00349,"4.4":0,"4.4.3-4.4.4":0.02844},"samsung":{"4":0.07622,"5.0-5.4":0.01089,"6.2-6.4":0.02178,"7.2-7.4":0.01089,"8.2":0.01089,"9.2":0.14155,"10.1":0.08711,"11.1-11.2":0.098,"12.0":5.8473},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0.00551,"10":0,"11":2.12135,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.20205},"and_qq":{"10.4":0},"and_uc":{"0":0},"op_mini":{"0":0.06801},"and_chr":{"0":18.02645}},"total":96.39756}

/***/ },
/* 1219 */
/***/ function(module, exports) {

	module.exports = {"id":"FR","name":"France","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0.00559,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.01118,"12":0.00559,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00559,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.01118,"46":0,"47":0.00559,"48":0.03355,"49":0,"50":0.00559,"51":0.00559,"52":0.08388,"53":0,"54":0,"55":0.00559,"56":0.02237,"57":0,"58":0,"59":0.01118,"60":0.04474,"61":0.00559,"62":0.00559,"63":0.01678,"64":0.01678,"65":0.02237,"66":0.03914,"67":0.00559,"68":0.12302,"69":0.02237,"70":0.00559,"71":0.00559,"72":0.02237,"73":0.00559,"74":0.01118,"75":0.01678,"76":0.01118,"77":0.02796,"78":0.29078,"79":0.02796,"80":0.12862,"81":3.10356,"82":0.45854,"83":0.00559,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00559,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.00559,"38":0.00559,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.01678,"49":0.27401,"50":0,"51":0.00559,"52":0.02796,"53":0.00559,"54":0.1398,"55":0.00559,"56":0.00559,"57":0.00559,"58":0.01118,"59":0.00559,"60":0.01118,"61":0.02237,"62":0.00559,"63":0.01678,"64":0.01678,"65":0.01678,"66":0.03914,"67":0.02796,"68":0.01678,"69":0.02237,"70":0.11184,"71":0.17894,"72":0.12302,"73":0.0727,"74":0.03914,"75":0.10625,"76":0.03914,"77":0.03355,"78":0.08388,"79":0.08947,"80":0.14539,"81":0.10066,"83":0.13421,"84":0.22927,"85":6.48113,"86":9.65738,"87":0.01118,"88":0.00559,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00559,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.00559,"51":0.01678,"52":0,"53":0.00559,"54":0,"55":0,"56":0.00559,"57":0.00559,"58":0.00559,"60":0.00559,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00559,"69":0,"70":0.05592,"71":0.45854,"72":0.01118,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":9.1663,"3.2":0.02196,"4.0-4.1":0.01882,"4.2-4.3":0.00314,"5.0-5.1":0.01568,"6.0-6.1":0.00941,"7.0-7.1":0.02196,"8.1-8.4":0.07215,"9.0-9.2":0.04078,"9.3":0.52074,"10.0-10.2":0.08784,"10.3":0.4831,"11.0-11.2":0.18195,"11.3-11.4":0.31056,"12.0-12.1":0.31684,"12.2-12.4":3.15896,"13.0-13.1":0.26037,"13.2":0.12862,"13.3":0.97874,"13.4-13.7":5.21369},"safari":{"0":null,"4":0.00559,"5":0,"6":0,"7":0,"8":0,"9":0.00559,"10":0.00559,"11":0.01678,"12":0.05033,"13":0.20131,"14":1.29175,"3.1":0,"3.2":0,"5.1":0.01118,"6.1":0,"7.1":0,"9.1":0.01118,"10.1":0.03914,"11.1":0.12302,"12.1":0.2125,"13.1":1.38682},"edge":{"12":0,"13":0,"14":0.00559,"15":0.01118,"16":0.01118,"17":0.05592,"18":0.20131,"79":0,"80":0,"81":0.00559,"83":0.00559,"84":0.01118,"85":0.6263,"86":1.28057},"android":{"3":0,"4":0.11321,"81":null,"2.1":0,"2.2":0,"2.3":0.00091,"4.1":0.05706,"4.2-4.3":0.02536,"4.4":0,"4.4.3-4.4.4":0.20649},"samsung":{"4":0.07285,"5.0-5.4":0.02081,"6.2-6.4":0,"7.2-7.4":0.03122,"8.2":0.02081,"9.2":0.10407,"10.1":0.07285,"11.1-11.2":0.1457,"12.0":2.67459},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0.05085,"7":0,"8":0.08264,"9":0.02543,"10":0.03178,"11":0.55303,"5.5":0},"bb":{"7":0,"10":0.00441},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.36146},"and_qq":{"10.4":0.01322},"and_uc":{"0":0.44962},"op_mini":{"0":0.27961},"and_chr":{"0":41.82851}},"total":97.39467}

/***/ },
/* 1220 */
/***/ function(module, exports) {

	module.exports = {"id":"GA","name":"Gabon","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0.0098,"28":0,"29":0.0049,"30":0,"31":0.0049,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.0049,"44":0,"45":0,"46":0,"47":0.0049,"48":0.18624,"49":0,"50":0.0049,"51":0,"52":0.06861,"53":0,"54":0.02451,"55":0,"56":0.0098,"57":0.0049,"58":0,"59":0,"60":0.0049,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.04901,"69":0.0147,"70":0,"71":0.0049,"72":0.0098,"73":0,"74":0,"75":0.0049,"76":0,"77":0.0049,"78":0.28426,"79":0.0147,"80":0.04901,"81":2.14174,"82":0.28916,"83":0.0147,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0.05881,"19":0,"20":0,"21":0,"22":0.0147,"23":0.0049,"24":0,"25":0.0049,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.0049,"39":0,"40":0.0049,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.0098,"47":0,"48":0,"49":0.22545,"50":0,"51":0,"52":0,"53":0.03431,"54":0,"55":0.0049,"56":0,"57":0.0049,"58":0.0049,"59":0,"60":0,"61":0,"62":0,"63":0.03921,"64":0,"65":0.0049,"66":0,"67":0.0098,"68":0.0049,"69":0.16663,"70":0.0049,"71":0.0098,"72":0.0049,"73":0.0049,"74":0.02941,"75":0.0196,"76":0.0098,"77":0.0049,"78":0.08332,"79":0.07352,"80":0.38228,"81":0.06371,"83":0.20584,"84":0.29896,"85":4.49912,"86":7.54754,"87":0,"88":0.0196,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0.0098,"25":0,"26":0.0049,"27":0,"28":0.0196,"29":0,"30":0.0098,"31":0,"32":0.0049,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0.03921,"43":0,"44":0,"45":0,"46":0.0147,"47":0.0098,"48":0,"49":0,"50":0.08822,"51":0.76946,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.0049,"62":0,"63":0.0098,"64":0,"65":0,"66":0,"67":0,"68":0.0098,"69":0.0049,"70":0.22055,"71":1.17134,"72":0.02941,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.0196},"ios_saf":{"8":0,"14":2.55759,"3.2":0.00613,"4.0-4.1":0.00525,"4.2-4.3":0.00088,"5.0-5.1":0.00438,"6.0-6.1":0.00263,"7.0-7.1":0.00613,"8.1-8.4":0.02013,"9.0-9.2":0.01138,"9.3":0.1453,"10.0-10.2":0.02451,"10.3":0.13479,"11.0-11.2":0.05077,"11.3-11.4":0.08665,"12.0-12.1":0.0884,"12.2-12.4":0.88141,"13.0-13.1":0.07265,"13.2":0.03589,"13.3":0.27309,"13.4-13.7":1.45473},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0.0049,"8":0,"9":0,"10":0,"11":0.0049,"12":0.0049,"13":0.04901,"14":0.57342,"3.1":0,"3.2":0,"5.1":0.06861,"6.1":0,"7.1":0,"9.1":0,"10.1":0.0147,"11.1":0.0147,"12.1":0.39208,"13.1":0.36267},"edge":{"12":0.02451,"13":0.0098,"14":0.0196,"15":0.02451,"16":0.0147,"17":0.02451,"18":0.14213,"79":0,"80":0,"81":0,"83":0.0049,"84":0.02941,"85":0.55871,"86":1.21545},"android":{"3":0,"4":0.11141,"81":null,"2.1":0,"2.2":0,"2.3":0.00089,"4.1":0.05615,"4.2-4.3":0.02496,"4.4":0,"4.4.3-4.4.4":0.20322},"samsung":{"4":0.35881,"5.0-5.4":0.01025,"6.2-6.4":0.03076,"7.2-7.4":0.84065,"8.2":0,"9.2":0.15378,"10.1":0.08201,"11.1-11.2":0.32806,"12.0":3.05503},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.04635,"9":0,"10":0,"11":0.38004,"5.5":0},"bb":{"7":0,"10":0.04589},"ie_mob":{"10":0,"11":0.0204},"kaios":{"2.5":0.0051},"baidu":{"0":null},"and_ff":{"0":0.09688},"and_qq":{"10.4":0.12238},"and_uc":{"0":0.76485},"op_mini":{"0":2.96885},"and_chr":{"0":57.22551}},"total":95.87368}

/***/ },
/* 1221 */
/***/ function(module, exports) {

	module.exports = {"id":"GB","name":"United Kingdom","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.0053,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.0053,"49":0,"50":0,"51":0,"52":0.0265,"53":0,"54":0,"55":0,"56":0.0106,"57":0,"58":0,"59":0.0053,"60":0,"61":0,"62":0,"63":0.0053,"64":0.0053,"65":0.0053,"66":0.0053,"67":0,"68":0.0265,"69":0,"70":0,"71":0,"72":0.0106,"73":0,"74":0,"75":0.0053,"76":0.0053,"77":0.0106,"78":0.0636,"79":0.0106,"80":0.0583,"81":1.1554,"82":0.1855,"83":0.0053,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.0053,"39":0,"40":0.0424,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.1325,"50":0,"51":0,"52":0,"53":0.0106,"54":0.053,"55":0,"56":0,"57":0,"58":0.0053,"59":0.0053,"60":0.0053,"61":0.0159,"62":0,"63":0.0106,"64":0.0053,"65":0.0159,"66":0.0265,"67":0.0159,"68":0.0053,"69":0.0424,"70":0.0159,"71":0.0318,"72":0.0265,"73":0.0159,"74":0.0159,"75":0.0477,"76":0.0477,"77":0.0265,"78":0.0318,"79":0.0477,"80":0.0901,"81":0.0742,"83":0.1537,"84":0.2544,"85":6.519,"86":8.4641,"87":0.0106,"88":0.0053,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.0106,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.0053,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.0371,"71":0.2756,"72":0.0053,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.0053},"ios_saf":{"8":0,"14":16.55489,"3.2":0.03966,"4.0-4.1":0.03399,"4.2-4.3":0.00567,"5.0-5.1":0.02833,"6.0-6.1":0.017,"7.0-7.1":0.03966,"8.1-8.4":0.13031,"9.0-9.2":0.07365,"9.3":0.94049,"10.0-10.2":0.15864,"10.3":0.8725,"11.0-11.2":0.3286,"11.3-11.4":0.56089,"12.0-12.1":0.57223,"12.2-12.4":5.70526,"13.0-13.1":0.47024,"13.2":0.23229,"13.3":1.76767,"13.4-13.7":9.41623},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0.0053,"9":0,"10":0.0053,"11":0.0106,"12":0.0318,"13":0.2067,"14":1.5317,"3.1":0,"3.2":0,"5.1":0.0053,"6.1":0,"7.1":0,"9.1":0.0106,"10.1":0.0318,"11.1":0.1007,"12.1":0.159,"13.1":2.1677},"edge":{"12":0,"13":0.0053,"14":0.0053,"15":0.0159,"16":0.0159,"17":0.0477,"18":0.4558,"79":0,"80":0.0053,"81":0.0053,"83":0.0053,"84":0.0159,"85":0.8639,"86":1.5953},"android":{"3":0,"4":0.15115,"81":null,"2.1":0,"2.2":0,"2.3":0.00121,"4.1":0.07618,"4.2-4.3":0.03386,"4.4":0,"4.4.3-4.4.4":0.2757},"samsung":{"4":0.06405,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.02135,"8.2":0.01068,"9.2":0.05338,"10.1":0.0427,"11.1-11.2":0.10675,"12.0":3.93921},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0.00559,"7":0,"8":0.01117,"9":0.00559,"10":0,"11":0.59775,"5.5":0},"bb":{"7":0,"10":0.0047},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.2444},"and_qq":{"10.4":0.0094},"and_uc":{"0":0.1175},"op_mini":{"0":0.15574},"and_chr":{"0":27.7414}},"total":97.14776}

/***/ },
/* 1222 */
/***/ function(module, exports) {

	module.exports = {"id":"GD","name":"Grenada","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.00411,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0.14807,"61":0,"62":0,"63":0,"64":0,"65":0.00411,"66":0,"67":0,"68":0.01645,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0.00411,"78":0.02879,"79":0.00411,"80":0.02468,"81":0.46066,"82":0.06992,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.01645,"47":0,"48":0,"49":0.02057,"50":0.00411,"51":0,"52":0,"53":0.00411,"54":0,"55":0,"56":0,"57":0,"58":0.00411,"59":0.00411,"60":0.00411,"61":0,"62":0,"63":0.00411,"64":0,"65":0,"66":0,"67":0.00411,"68":0.00823,"69":0,"70":0.00411,"71":0.00823,"72":0.00823,"73":0,"74":0,"75":0.00823,"76":0.01234,"77":0.02879,"78":0.00411,"79":0.0329,"80":0.06992,"81":0.03702,"83":0.0329,"84":0.04936,"85":3.91558,"86":5.9474,"87":0.02057,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.02468,"71":0.21799,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":4.39105,"3.2":0.01052,"4.0-4.1":0.00902,"4.2-4.3":0.0015,"5.0-5.1":0.00751,"6.0-6.1":0.00451,"7.0-7.1":0.01052,"8.1-8.4":0.03456,"9.0-9.2":0.01954,"9.3":0.24946,"10.0-10.2":0.04208,"10.3":0.23142,"11.0-11.2":0.08716,"11.3-11.4":0.14877,"12.0-12.1":0.15178,"12.2-12.4":1.51327,"13.0-13.1":0.12473,"13.2":0.06161,"13.3":0.46886,"13.4-13.7":2.49758},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.03702,"11":0,"12":0.00411,"13":0.10694,"14":0.56759,"3.1":0,"3.2":0,"5.1":0.25912,"6.1":0,"7.1":0,"9.1":0,"10.1":0.01645,"11.1":0.00823,"12.1":0.01645,"13.1":0.36606},"edge":{"12":0,"13":0.00411,"14":0.00411,"15":0.03702,"16":0.02468,"17":0.01645,"18":0.17686,"79":0,"80":0,"81":0,"83":0,"84":0.00411,"85":0.69098,"86":1.20511},"android":{"3":0,"4":0.51052,"81":null,"2.1":0,"2.2":0,"2.3":0.00408,"4.1":0.2573,"4.2-4.3":0.11436,"4.4":0,"4.4.3-4.4.4":0.93119},"samsung":{"4":0.11895,"5.0-5.4":0.01081,"6.2-6.4":0,"7.2-7.4":0.34604,"8.2":0,"9.2":0.0757,"10.1":0.08651,"11.1-11.2":0.11895,"12.0":3.2874},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0.01032,"10":0.01548,"11":0.27857,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.00589},"baidu":{"0":null},"and_ff":{"0":0.10597},"and_qq":{"10.4":0},"and_uc":{"0":0.09419},"op_mini":{"0":0.06688},"and_chr":{"0":66.62378}},"total":97.93513}

/***/ },
/* 1223 */
/***/ function(module, exports) {

	module.exports = {"id":"GE","name":"Georgia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.01279,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.01279,"69":0,"70":0,"71":0,"72":0.00639,"73":0,"74":0,"75":0,"76":0.00639,"77":0.01918,"78":0.05755,"79":0.00639,"80":0.01918,"81":0.90795,"82":0.15346,"83":0.00639,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00639,"39":0.00639,"40":0,"41":0,"42":0,"43":0.00639,"44":0.00639,"45":0,"46":0,"47":0.00639,"48":0.00639,"49":0.28773,"50":0.00639,"51":0,"52":0,"53":0.01918,"54":0,"55":0,"56":0.01279,"57":0,"58":0.01279,"59":0.01918,"60":0,"61":0.06394,"62":0.00639,"63":0.02558,"64":0.00639,"65":0.02558,"66":0.01279,"67":0.01279,"68":0.04476,"69":0.01918,"70":0.02558,"71":0.03836,"72":0.05115,"73":0.05755,"74":0.05755,"75":0.03836,"76":0.05755,"77":0.03197,"78":0.05115,"79":0.15346,"80":0.22379,"81":0.15985,"83":0.19182,"84":0.40922,"85":10.20482,"86":18.10141,"87":0.03197,"88":0.01918,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0.00639,"36":0.01279,"37":0,"38":0,"39":0,"40":0.00639,"41":0,"42":0,"43":0,"44":0,"45":0.00639,"46":0.01918,"47":0.00639,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0.00639,"54":0,"55":0,"56":0,"57":0.00639,"58":0.00639,"60":0.03836,"62":0,"63":0.00639,"64":0,"65":0.00639,"66":0,"67":0.00639,"68":0.01918,"69":0.01279,"70":0.34528,"71":2.95403,"72":0.09591,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":5.35981,"3.2":0.01284,"4.0-4.1":0.01101,"4.2-4.3":0.00183,"5.0-5.1":0.00917,"6.0-6.1":0.0055,"7.0-7.1":0.01284,"8.1-8.4":0.04219,"9.0-9.2":0.02385,"9.3":0.30449,"10.0-10.2":0.05136,"10.3":0.28248,"11.0-11.2":0.10639,"11.3-11.4":0.1816,"12.0-12.1":0.18526,"12.2-12.4":1.84714,"13.0-13.1":0.15225,"13.2":0.07521,"13.3":0.5723,"13.4-13.7":3.0486},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.02558,"13":0.05115,"14":0.51152,"3.1":0,"3.2":0,"5.1":0.03836,"6.1":0,"7.1":0,"9.1":0.04476,"10.1":0.00639,"11.1":0.04476,"12.1":0.04476,"13.1":0.28134},"edge":{"12":0.01279,"13":0.08312,"14":0.19182,"15":0.01279,"16":0.17903,"17":0.03197,"18":0.51152,"79":0,"80":0,"81":0,"83":0,"84":0.01918,"85":0.44758,"86":1.04862},"android":{"3":0,"4":0.21267,"81":null,"2.1":0,"2.2":0,"2.3":0.0017,"4.1":0.10718,"4.2-4.3":0.04764,"4.4":0,"4.4.3-4.4.4":0.38791},"samsung":{"4":0.39663,"5.0-5.4":0,"6.2-6.4":0.01017,"7.2-7.4":0.05085,"8.2":0.01017,"9.2":0.06102,"10.1":0.04068,"11.1-11.2":0.13221,"12.0":1.49498},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.02984,"9":0.00746,"10":0.00746,"11":0.22379,"5.5":0},"bb":{"7":0,"10":0.00361},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.0577},"and_qq":{"10.4":0},"and_uc":{"0":0.10097},"op_mini":{"0":0.30384},"and_chr":{"0":42.4608}},"total":97.31086}

/***/ },
/* 1224 */
/***/ function(module, exports) {

	module.exports = {"id":"GF","name":"French Guiana","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0.01125,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00563,"48":0.00563,"49":0,"50":0,"51":0.00563,"52":0.0225,"53":0,"54":0,"55":0,"56":0,"57":0.00563,"58":0,"59":0,"60":0.14063,"61":0,"62":0,"63":0,"64":0,"65":0.00563,"66":0,"67":0,"68":0.12375,"69":0,"70":0,"71":0.00563,"72":0.00563,"73":0.00563,"74":0.00563,"75":0,"76":0,"77":0.00563,"78":0.12938,"79":0.06188,"80":0.05625,"81":2.52563,"82":0.30938,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00563,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0.03375,"45":0,"46":0,"47":0,"48":0,"49":0.495,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0.07875,"58":0.00563,"59":0.00563,"60":0,"61":0,"62":0,"63":0.07313,"64":0,"65":0,"66":0,"67":0.135,"68":0,"69":0.03938,"70":0.0225,"71":0.00563,"72":0,"73":0.01125,"74":0.00563,"75":0.00563,"76":0.1575,"77":0.00563,"78":0.05625,"79":0.03375,"80":0.10688,"81":0.01688,"83":1.44563,"84":0.20813,"85":6.77813,"86":8.57813,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.00563,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.00563,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0.00563,"68":0,"69":0,"70":0.01125,"71":0.12938,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":7.80669,"3.2":0.0187,"4.0-4.1":0.01603,"4.2-4.3":0.00267,"5.0-5.1":0.01336,"6.0-6.1":0.00802,"7.0-7.1":0.0187,"8.1-8.4":0.06145,"9.0-9.2":0.03473,"9.3":0.4435,"10.0-10.2":0.07481,"10.3":0.41144,"11.0-11.2":0.15496,"11.3-11.4":0.2645,"12.0-12.1":0.26984,"12.2-12.4":2.69039,"13.0-13.1":0.22175,"13.2":0.10954,"13.3":0.83357,"13.4-13.7":4.44035},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.03375,"13":0.12375,"14":1.62,"3.1":0,"3.2":0,"5.1":0.03375,"6.1":0,"7.1":0,"9.1":0,"10.1":0.1125,"11.1":0.02813,"12.1":0.36563,"13.1":0.75938},"edge":{"12":0.00563,"13":0,"14":0.00563,"15":0.00563,"16":0.0225,"17":0.01688,"18":1.62563,"79":0,"80":0,"81":0,"83":0.00563,"84":0.01688,"85":1.11938,"86":1.62563},"android":{"3":0,"4":0.08848,"81":null,"2.1":0,"2.2":0,"2.3":0.00071,"4.1":0.0446,"4.2-4.3":0.01982,"4.4":0,"4.4.3-4.4.4":0.16139},"samsung":{"4":0.04186,"5.0-5.4":0,"6.2-6.4":0.01046,"7.2-7.4":0.07325,"8.2":0,"9.2":0.05232,"10.1":0.04186,"11.1-11.2":0.1465,"12.0":2.4172},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.6975,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.09625},"and_qq":{"10.4":0.13563},"and_uc":{"0":0.05688},"op_mini":{"0":0.05799},"and_chr":{"0":46.56}},"total":98.02793}

/***/ },
/* 1225 */
/***/ function(module, exports) {

	module.exports = {"id":"GG","name":"Guernsey","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00591,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.02363,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0.00591,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.01182,"69":0,"70":0,"71":0,"72":0,"73":0.00591,"74":0,"75":0,"76":0,"77":0.00591,"78":0.0709,"79":0.00591,"80":0.15361,"81":1.05162,"82":0.13588,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00591,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.08862,"50":0,"51":0,"52":0,"53":0.03545,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0.01772,"66":0,"67":0.02363,"68":0,"69":0,"70":0.01182,"71":0,"72":0,"73":0,"74":0.00591,"75":0,"76":0.02363,"77":0.00591,"78":0,"79":0,"80":0.08862,"81":0.04136,"83":0.08862,"84":0.21269,"85":6.30384,"86":7.4618,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00591,"69":0,"70":0.00591,"71":0.04726,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":19.9567,"3.2":0.04781,"4.0-4.1":0.04098,"4.2-4.3":0.00683,"5.0-5.1":0.03415,"6.0-6.1":0.02049,"7.0-7.1":0.04781,"8.1-8.4":0.15709,"9.0-9.2":0.08879,"9.3":1.13375,"10.0-10.2":0.19123,"10.3":1.05179,"11.0-11.2":0.39613,"11.3-11.4":0.67615,"12.0-12.1":0.68981,"12.2-12.4":6.87762,"13.0-13.1":0.56687,"13.2":0.28002,"13.3":2.1309,"13.4-13.7":11.35114},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.12407,"13":0.73259,"14":2.83584,"3.1":0,"3.2":0,"5.1":0,"6.1":0.03545,"7.1":0,"9.1":0.00591,"10.1":0.10634,"11.1":0.3663,"12.1":0.41947,"13.1":5.45899},"edge":{"12":0,"13":0,"14":0,"15":0.00591,"16":0,"17":0.01182,"18":0.21269,"79":0,"80":0,"81":0,"83":0,"84":0.00591,"85":1.58334,"86":2.15051},"android":{"3":0,"4":0.15766,"81":null,"2.1":0,"2.2":0,"2.3":0.00126,"4.1":0.07946,"4.2-4.3":0.03532,"4.4":0,"4.4.3-4.4.4":0.28757},"samsung":{"4":0.32779,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0,"8.2":0,"9.2":0,"10.1":0.02261,"11.1-11.2":0.03391,"12.0":4.22738},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.90392,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.29872},"and_qq":{"10.4":0},"and_uc":{"0":0},"op_mini":{"0":0.0155},"and_chr":{"0":14.89028}},"total":97.0342}

/***/ },
/* 1226 */
/***/ function(module, exports) {

	module.exports = {"id":"GH","name":"Ghana","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0.00337,"29":0.00337,"30":0.00337,"31":0.00337,"32":0.00337,"33":0.00337,"34":0.00337,"35":0,"36":0.00337,"37":0,"38":0.00337,"39":0.00337,"40":0.00337,"41":0.00675,"42":0.00337,"43":0.00675,"44":0.00675,"45":0.00337,"46":0.00337,"47":0.00675,"48":0.00675,"49":0.00337,"50":0.00337,"51":0.00337,"52":0.01687,"53":0.00337,"54":0.00337,"55":0.00337,"56":0.00675,"57":0.00675,"58":0.00337,"59":0.00337,"60":0.00337,"61":0.00337,"62":0.00337,"63":0.00337,"64":0.00337,"65":0.00675,"66":0.00337,"67":0.00337,"68":0.04722,"69":0.00675,"70":0.00675,"71":0.00337,"72":0.01349,"73":0.00675,"74":0.00675,"75":0.00337,"76":0.00675,"77":0.01012,"78":0.0506,"79":0.02024,"80":0.05734,"81":0.97142,"82":0.19226,"83":0.02698,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00337,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0.00337,"32":0,"33":0.00337,"34":0,"35":0,"36":0,"37":0.00337,"38":0.00337,"39":0.00337,"40":0.00675,"41":0.00337,"42":0.00337,"43":0.00337,"44":0.00337,"45":0.00337,"46":0.00675,"47":0.00337,"48":0.00337,"49":0.01687,"50":0.01349,"51":0.00337,"52":0.00337,"53":0.00337,"54":0.00337,"55":0.00675,"56":0.00337,"57":0.00675,"58":0.00675,"59":0.00675,"60":0.01012,"61":0.00675,"62":0.00337,"63":0.02698,"64":0.01012,"65":0.01012,"66":0.00675,"67":0.00675,"68":0.01012,"69":0.02361,"70":0.02024,"71":0.01012,"72":0.01349,"73":0.00675,"74":0.04722,"75":0.01687,"76":0.01349,"77":0.02024,"78":0.02361,"79":0.06071,"80":0.10794,"81":0.06409,"83":0.09107,"84":0.17202,"85":2.24642,"86":3.39998,"87":0.01687,"88":0.00337,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0.00337,"16":0.00337,"17":0,"18":0,"19":0,"20":0.00337,"21":0,"22":0,"23":0.01012,"24":0.07421,"25":0.00337,"26":0.05734,"27":0.11468,"28":0.0506,"29":0.00675,"30":0.05734,"31":0.02698,"32":0.04722,"33":0.03036,"34":0,"35":0.01012,"36":0.00337,"37":0.00337,"38":0.05397,"39":0,"40":0,"41":0.00337,"42":0.09444,"43":0.00337,"44":0.00337,"45":0.04048,"46":0.18552,"47":0.14504,"48":0.00337,"49":0,"50":0.72182,"51":2.28689,"52":0,"53":0.00337,"54":0.00337,"55":0,"56":0.00337,"57":0,"58":0,"60":0.04048,"62":0,"63":0,"64":0.00337,"65":0,"66":0,"67":0,"68":0.00675,"69":0.00337,"70":0.10456,"71":0.52956,"72":0.01687,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.02698},"ios_saf":{"8":0,"14":4.5514,"3.2":0.0109,"4.0-4.1":0.00935,"4.2-4.3":0.00156,"5.0-5.1":0.00779,"6.0-6.1":0.00467,"7.0-7.1":0.0109,"8.1-8.4":0.03583,"9.0-9.2":0.02025,"9.3":0.25857,"10.0-10.2":0.04361,"10.3":0.23988,"11.0-11.2":0.09034,"11.3-11.4":0.15421,"12.0-12.1":0.15732,"12.2-12.4":1.56854,"13.0-13.1":0.12928,"13.2":0.06386,"13.3":0.48598,"13.4-13.7":2.58878},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00337,"11":0.00675,"12":0.02024,"13":0.04048,"14":0.20575,"3.1":0,"3.2":0,"5.1":0.02698,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00337,"11.1":0.02361,"12.1":0.03373,"13.1":0.14504},"edge":{"12":0.01349,"13":0.01012,"14":0.01349,"15":0.01687,"16":0.00675,"17":0.01349,"18":0.0877,"79":0,"80":0,"81":0.00337,"83":0.00337,"84":0.01687,"85":0.24286,"86":0.38452},"android":{"3":0,"4":0.05726,"81":null,"2.1":0,"2.2":0,"2.3":0.00046,"4.1":0.02886,"4.2-4.3":0.01283,"4.4":0,"4.4.3-4.4.4":0.10444},"samsung":{"4":0.26531,"5.0-5.4":0.03061,"6.2-6.4":0.0102,"7.2-7.4":0.11224,"8.2":0.0102,"9.2":0.10204,"10.1":0.07143,"11.1-11.2":0.18367,"12.0":1},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.0213,"9":0.00426,"10":0.00426,"11":0.05113,"5.5":0},"bb":{"7":0,"10":0.03976},"ie_mob":{"10":0,"11":0.01988},"kaios":{"2.5":0.00663},"baidu":{"0":null},"and_ff":{"0":0.32472},"and_qq":{"10.4":0.01325},"and_uc":{"0":3.15445},"op_mini":{"0":15.85444},"and_chr":{"0":49.23892}},"total":95.44689}

/***/ },
/* 1227 */
/***/ function(module, exports) {

	module.exports = {"id":"GI","name":"Gibraltar","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.01766,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.01177,"53":0,"54":0,"55":0,"56":0.00589,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.11185,"69":0,"70":0,"71":0,"72":0.00589,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0.01766,"79":0.01177,"80":0.10008,"81":0.97724,"82":0.15306,"83":0.00589,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00589,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00589,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.1825,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0.02355,"61":0,"62":0.01177,"63":0,"64":0,"65":0,"66":0,"67":0.01177,"68":0.00589,"69":0.03532,"70":0.00589,"71":0.00589,"72":0,"73":0,"74":0.02355,"75":0.00589,"76":0.00589,"77":0.01766,"78":0.01766,"79":0.01766,"80":0.03532,"81":0.08242,"83":0.10597,"84":0.28258,"85":9.16017,"86":12.59229,"87":0,"88":0.00589,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0.00589,"33":0,"34":0,"35":0,"36":0.01177,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.35322,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.01766,"71":0.09419,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.01177},"ios_saf":{"8":0,"14":15.37897,"3.2":0.03684,"4.0-4.1":0.03158,"4.2-4.3":0.00526,"5.0-5.1":0.02632,"6.0-6.1":0.01579,"7.0-7.1":0.03684,"8.1-8.4":0.12105,"9.0-9.2":0.06842,"9.3":0.87369,"10.0-10.2":0.14737,"10.3":0.81053,"11.0-11.2":0.30526,"11.3-11.4":0.52105,"12.0-12.1":0.53158,"12.2-12.4":5.30001,"13.0-13.1":0.43684,"13.2":0.21579,"13.3":1.64211,"13.4-13.7":8.74738},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.12363,"13":0.22371,"14":2.52552,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.03532,"11.1":0.07064,"12.1":0.36499,"13.1":2.48431},"edge":{"12":0.00589,"13":0.00589,"14":0,"15":0.00589,"16":0,"17":0.02355,"18":0.4533,"79":0,"80":0,"81":0,"83":0,"84":0.05887,"85":0.62402,"86":1.47175},"android":{"3":0,"4":0.04861,"81":null,"2.1":0,"2.2":0,"2.3":0.00039,"4.1":0.0245,"4.2-4.3":0.01089,"4.4":0,"4.4.3-4.4.4":0.08867},"samsung":{"4":0.30174,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0,"8.2":0,"9.2":0.02081,"10.1":0.0104,"11.1-11.2":0.06243,"12.0":5.55613},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.37677,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.36194},"and_qq":{"10.4":0},"and_uc":{"0":0.27557},"op_mini":{"0":0.67754},"and_chr":{"0":19.96486}},"total":96.07178}

/***/ },
/* 1228 */
/***/ function(module, exports) {

	module.exports = {"id":"GL","name":"Greenland","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00643,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00643,"48":0.03856,"49":0,"50":0,"51":0,"52":0.05141,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0.00643,"68":0.00643,"69":0,"70":0,"71":0.00643,"72":0,"73":0,"74":0,"75":0,"76":0.01928,"77":0.01285,"78":0.31487,"79":0.00643,"80":0.04498,"81":1.83141,"82":0.10924,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00643,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.00643,"50":0.00643,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0.0257,"57":0,"58":0,"59":0,"60":0.01285,"61":0,"62":0,"63":0,"64":0,"65":0.01285,"66":0,"67":0.05783,"68":0.01285,"69":0,"70":0.00643,"71":0,"72":0.00643,"73":0.01928,"74":0.00643,"75":0.01928,"76":0.00643,"77":0,"78":0,"79":0.0257,"80":0.20563,"81":0.08996,"83":0.55906,"84":0.35986,"85":9.33698,"86":16.08428,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.01285,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00643,"62":0,"63":0,"64":0,"65":0,"66":0.00643,"67":0,"68":0,"69":0,"70":0.00643,"71":0.16708,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":13.54691,"3.2":0.03245,"4.0-4.1":0.02782,"4.2-4.3":0.00464,"5.0-5.1":0.02318,"6.0-6.1":0.01391,"7.0-7.1":0.03245,"8.1-8.4":0.10663,"9.0-9.2":0.06027,"9.3":0.76961,"10.0-10.2":0.12981,"10.3":0.71397,"11.0-11.2":0.2689,"11.3-11.4":0.45898,"12.0-12.1":0.46825,"12.2-12.4":4.66863,"13.0-13.1":0.3848,"13.2":0.19008,"13.3":1.44649,"13.4-13.7":7.70533},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00643,"11":0,"12":0.00643,"13":0.22491,"14":2.06275,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.04498,"11.1":0.04498,"12.1":0.27632,"13.1":2.30051},"edge":{"12":0.00643,"13":0.00643,"14":0.19921,"15":0.03856,"16":0.00643,"17":0.00643,"18":0.62332,"79":0,"80":0,"81":0,"83":0,"84":0.00643,"85":0.68116,"86":1.42015},"android":{"3":0,"4":0.01224,"81":null,"2.1":0,"2.2":0,"2.3":0.0001,"4.1":0.00617,"4.2-4.3":0.00274,"4.4":0,"4.4.3-4.4.4":0.02233},"samsung":{"4":0.09349,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0,"8.2":0,"9.2":0.03116,"10.1":0.06233,"11.1-11.2":0.09349,"12.0":3.50081},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01285,"9":0.00643,"10":0,"11":1.78643,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.05361},"and_qq":{"10.4":0.00357},"and_uc":{"0":0.11794},"op_mini":{"0":0.11504},"and_chr":{"0":22.48078}},"total":96.944}

/***/ },
/* 1229 */
/***/ function(module, exports) {

	module.exports = {"id":"GM","name":"Gambia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0.00354,"29":0,"30":0,"31":0,"32":0,"33":0.00707,"34":0.00354,"35":0,"36":0,"37":0,"38":0.00707,"39":0,"40":0.00354,"41":0,"42":0.01061,"43":0.00354,"44":0.01061,"45":0.00707,"46":0.00707,"47":0.01414,"48":0.00354,"49":0,"50":0.00354,"51":0,"52":0.00707,"53":0.01061,"54":0.00354,"55":0.00707,"56":0.00354,"57":0,"58":0.01414,"59":0,"60":0.00354,"61":0,"62":0,"63":0.00354,"64":0,"65":0,"66":0,"67":0.00354,"68":0.01768,"69":0,"70":0.00354,"71":0.00354,"72":0.01061,"73":0.00354,"74":0.00354,"75":0,"76":0.00354,"77":0,"78":0.07072,"79":0.01061,"80":0.07072,"81":0.95472,"82":0.20155,"83":0.03182,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0.00354,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00354,"30":0.00354,"31":0.00354,"32":0,"33":0,"34":0.01061,"35":0,"36":0,"37":0,"38":0,"39":0.00354,"40":0.00354,"41":0.00354,"42":0.00354,"43":0.01061,"44":0.00354,"45":0,"46":0.00354,"47":0.00354,"48":0.00354,"49":0.05304,"50":0.00707,"51":0.00707,"52":0.00354,"53":0.00707,"54":0.01061,"55":0.01768,"56":0.00354,"57":0.01061,"58":0.00707,"59":0.00354,"60":0.11315,"61":0.00707,"62":0.00707,"63":0.02475,"64":0.01061,"65":0.01061,"66":0.00707,"67":0.01061,"68":0.00354,"69":0.07426,"70":0.01768,"71":0.00354,"72":0.01061,"73":0,"74":0.01061,"75":0.00707,"76":0.00707,"77":0.00707,"78":0.02122,"79":0.03182,"80":0.04597,"81":0.03182,"83":0.01768,"84":0.05658,"85":2.27365,"86":3.61026,"87":0.01061,"88":0.00354,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0.00354,"16":0,"17":0,"18":0,"19":0,"20":0.04243,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0.00354,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.00707,"41":0,"42":0,"43":0,"44":0,"45":0.00354,"46":0.00354,"47":0,"48":0,"49":0,"50":0.10962,"51":0.08133,"52":0,"53":0.00707,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.01061,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.07072,"71":0.442,"72":0.01414,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.02829},"ios_saf":{"8":0,"14":6.09702,"3.2":0.01461,"4.0-4.1":0.01252,"4.2-4.3":0.00209,"5.0-5.1":0.01043,"6.0-6.1":0.00626,"7.0-7.1":0.01461,"8.1-8.4":0.04799,"9.0-9.2":0.02713,"9.3":0.34637,"10.0-10.2":0.05842,"10.3":0.32133,"11.0-11.2":0.12102,"11.3-11.4":0.20657,"12.0-12.1":0.21075,"12.2-12.4":2.1012,"13.0-13.1":0.17319,"13.2":0.08555,"13.3":0.65102,"13.4-13.7":3.46791},"safari":{"0":null,"4":0,"5":0,"6":0.00354,"7":0,"8":0,"9":0,"10":0.01061,"11":0,"12":0.00707,"13":0.00707,"14":0.14851,"3.1":0,"3.2":0,"5.1":0.31824,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00354,"11.1":0.01414,"12.1":0.01768,"13.1":0.14498},"edge":{"12":0.01061,"13":0.00707,"14":0.01414,"15":0.02475,"16":0.02122,"17":0.02122,"18":1.0997,"79":0,"80":0.00354,"81":0,"83":0,"84":0.01768,"85":0.16266,"86":0.442},"android":{"3":0,"4":0.09341,"81":null,"2.1":0,"2.2":0,"2.3":0.00075,"4.1":0.04708,"4.2-4.3":0.02092,"4.4":0,"4.4.3-4.4.4":0.17038},"samsung":{"4":0.58828,"5.0-5.4":0.09129,"6.2-6.4":0.04057,"7.2-7.4":0.31443,"8.2":0.01014,"9.2":0.15214,"10.1":0.213,"11.1-11.2":0.18257,"12.0":2.80956},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.03874,"9":0.01107,"10":0,"11":0.07748,"5.5":0},"bb":{"7":0,"10":0.01939},"ie_mob":{"10":0,"11":0.01293},"kaios":{"2.5":0.00646},"baidu":{"0":null},"and_ff":{"0":0.18746},"and_qq":{"10.4":0.00646},"and_uc":{"0":1.28634},"op_mini":{"0":3.78197},"and_chr":{"0":60.49184}},"total":96.11574}

/***/ },
/* 1230 */
/***/ function(module, exports) {

	module.exports = {"id":"GN","name":"Guinea","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0.00191,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0.00191,"16":0,"17":0.00191,"18":0,"19":0,"20":0,"21":0.00191,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0.00382,"34":0.00191,"35":0,"36":0,"37":0,"38":0.00191,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.00191,"46":0.00191,"47":0,"48":0.00191,"49":0.00191,"50":0,"51":0.00191,"52":0,"53":0,"54":0,"55":0,"56":0.00191,"57":0,"58":0,"59":0,"60":0,"61":0.02484,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.01147,"69":0.00382,"70":0,"71":0,"72":0.00191,"73":0,"74":0.00382,"75":0,"76":0,"77":0,"78":0.02484,"79":0.00382,"80":0.02293,"81":0.45482,"82":0.04586,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0.00382,"25":0.00191,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0.04395,"34":0,"35":0.00191,"36":0,"37":0,"38":0,"39":0,"40":0.02102,"41":0,"42":0,"43":0.00382,"44":0,"45":0,"46":0,"47":0,"48":0.02484,"49":0.00382,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0.00191,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0.00191,"64":0.00191,"65":0,"66":0,"67":0.00573,"68":0.00191,"69":0.00764,"70":0.00191,"71":0,"72":0.02102,"73":0.00191,"74":0.00573,"75":0.00191,"76":0.00573,"77":0.00382,"78":0.00764,"79":0.00191,"80":0.00573,"81":0.02293,"83":0.01911,"84":0.0688,"85":0.81026,"86":0.67841,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0.00382,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0.01147,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00191,"37":0,"38":0.00191,"39":0,"40":0,"41":0,"42":0.00191,"43":0,"44":0,"45":0.00191,"46":0.00573,"47":0.00764,"48":0,"49":0,"50":0.00764,"51":0.14524,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00764,"62":0.00191,"63":0,"64":0,"65":0,"66":0,"67":0.00191,"68":0.00191,"69":0,"70":0.02484,"71":0.1567,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.02102},"ios_saf":{"8":0,"14":2.83609,"3.2":0.00679,"4.0-4.1":0.00582,"4.2-4.3":0.00097,"5.0-5.1":0.00485,"6.0-6.1":0.00291,"7.0-7.1":0.00679,"8.1-8.4":0.02232,"9.0-9.2":0.01262,"9.3":0.16112,"10.0-10.2":0.02718,"10.3":0.14947,"11.0-11.2":0.05629,"11.3-11.4":0.09609,"12.0-12.1":0.09803,"12.2-12.4":0.97739,"13.0-13.1":0.08056,"13.2":0.03979,"13.3":0.30283,"13.4-13.7":1.61314},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00573,"12":0,"13":0.00191,"14":0.0344,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.00191,"10.1":0.02484,"11.1":0.00764,"12.1":0.00764,"13.1":0.04013},"edge":{"12":0.00956,"13":0.00382,"14":0.00191,"15":0.00191,"16":0.00382,"17":0.00956,"18":0.02484,"79":0,"80":0,"81":0,"83":0,"84":0.00382,"85":0.05351,"86":0.09746},"android":{"3":0,"4":0.13673,"81":null,"2.1":0,"2.2":0,"2.3":0.00109,"4.1":0.06891,"4.2-4.3":0.03063,"4.4":0,"4.4.3-4.4.4":0.24939},"samsung":{"4":0.25256,"5.0-5.4":0.09092,"6.2-6.4":0.06062,"7.2-7.4":0.15154,"8.2":0,"9.2":0.33338,"10.1":0.10103,"11.1-11.2":0.45462,"12.0":0.89913},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01588,"9":0,"10":0.00397,"11":0.08335,"5.5":0},"bb":{"7":0,"10":0.00809},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.04853},"baidu":{"0":null},"and_ff":{"0":0.05662},"and_qq":{"10.4":0.10516},"and_uc":{"0":1.12437},"op_mini":{"0":18.61694},"and_chr":{"0":61.96167}},"total":94.50349}

/***/ },
/* 1231 */
/***/ function(module, exports) {

	module.exports = {"id":"GP","name":"Guadeloupe","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.01078,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00539,"39":0,"40":0.00539,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.02156,"49":0,"50":0.00539,"51":0,"52":0.02695,"53":0,"54":0,"55":0,"56":0.00539,"57":0,"58":0,"59":0,"60":0.02156,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.02695,"69":0.00539,"70":0,"71":0.02695,"72":0.01078,"73":0.00539,"74":0.00539,"75":0,"76":0.00539,"77":0.00539,"78":0.30178,"79":0.01078,"80":0.12395,"81":2.84539,"82":0.26406,"83":0.00539,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00539,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.17784,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0.00539,"59":0,"60":0,"61":0,"62":0,"63":0.01078,"64":0,"65":0.0485,"66":0.00539,"67":0.00539,"68":0,"69":0.00539,"70":0.00539,"71":0,"72":0,"73":0.00539,"74":0.00539,"75":0,"76":0.04311,"77":0.00539,"78":0.00539,"79":0.01078,"80":0.15089,"81":0.08084,"83":0.07006,"84":0.32334,"85":5.89557,"86":8.58468,"87":0.00539,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.02695,"47":0,"48":0,"49":0,"50":0.00539,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.03233,"71":0.27484,"72":0.00539,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":8.33316,"3.2":0.01996,"4.0-4.1":0.01711,"4.2-4.3":0.00285,"5.0-5.1":0.01426,"6.0-6.1":0.00856,"7.0-7.1":0.01996,"8.1-8.4":0.06559,"9.0-9.2":0.03707,"9.3":0.47341,"10.0-10.2":0.07985,"10.3":0.43919,"11.0-11.2":0.16541,"11.3-11.4":0.28233,"12.0-12.1":0.28804,"12.2-12.4":2.87183,"13.0-13.1":0.23671,"13.2":0.11693,"13.3":0.88978,"13.4-13.7":4.73981},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0.00539,"9":0,"10":0,"11":0.02156,"12":0.08084,"13":0.24789,"14":2.09632,"3.1":0,"3.2":0,"5.1":0.01617,"6.1":0.04311,"7.1":0,"9.1":0.02695,"10.1":0.06467,"11.1":0.07545,"12.1":0.48501,"13.1":2.24721},"edge":{"12":0.01078,"13":0.00539,"14":0.00539,"15":0.00539,"16":0.00539,"17":0.03233,"18":0.25328,"79":0,"80":0,"81":0.00539,"83":0,"84":0.01078,"85":0.6844,"86":1.43347},"android":{"3":0,"4":0.06788,"81":null,"2.1":0,"2.2":0,"2.3":0.00054,"4.1":0.03421,"4.2-4.3":0.01521,"4.4":0,"4.4.3-4.4.4":0.12382},"samsung":{"4":0.09279,"5.0-5.4":0.01031,"6.2-6.4":0.01031,"7.2-7.4":0.1031,"8.2":0,"9.2":0.1031,"10.1":0.08248,"11.1-11.2":0.14434,"12.0":3.61889},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.27484,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.2951},"and_qq":{"10.4":0},"and_uc":{"0":0.00461},"op_mini":{"0":0.09167},"and_chr":{"0":45.73101}},"total":97.31455}

/***/ },
/* 1232 */
/***/ function(module, exports) {

	module.exports = {"id":"GQ","name":"Equatorial Guinea","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0.01649,"5":0.01649,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0.01649,"16":0.02198,"17":0.02748,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0.0055,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.03297,"30":0.01099,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0.01649,"43":0.01649,"44":0,"45":0.0055,"46":0,"47":0.0055,"48":0,"49":0.0055,"50":0,"51":0,"52":0.04396,"53":0,"54":0.01099,"55":0.0055,"56":0.01649,"57":0.02748,"58":0,"59":0,"60":0.0055,"61":0,"62":0.01099,"63":0,"64":0.01099,"65":0,"66":0.0055,"67":0.0055,"68":0.02198,"69":0.01649,"70":0,"71":0.0055,"72":0.0055,"73":0,"74":0.0055,"75":0,"76":0,"77":0.01649,"78":0.04946,"79":0.02748,"80":0.26376,"81":2.12657,"82":0.30772,"83":0.02748,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0.01649,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.01649,"35":0.0055,"36":0,"37":0,"38":0.0055,"39":0,"40":0,"41":0,"42":0,"43":0.02748,"44":0,"45":0.41762,"46":0.01649,"47":0,"48":0,"49":0.13188,"50":0,"51":0.01099,"52":0,"53":0.02198,"54":0,"55":0.0055,"56":0,"57":0.79128,"58":0.0055,"59":0,"60":0.19782,"61":0,"62":0.0055,"63":0.03297,"64":0.02748,"65":0.05495,"66":0.0055,"67":0.01649,"68":0.07144,"69":0.01099,"70":0.0055,"71":0.02748,"72":0.03297,"73":0.90668,"74":0.38465,"75":0.08243,"76":0.01649,"77":0.02198,"78":0.0055,"79":0.09342,"80":0.12089,"81":0.06594,"83":0.06594,"84":0.14287,"85":5.37961,"86":8.30844,"87":0.02748,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0.02748,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.0055,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0.0055,"36":0.0055,"37":0,"38":0,"39":0,"40":0.0055,"41":0,"42":0,"43":0,"44":0,"45":0.07144,"46":0.05495,"47":0,"48":0,"49":0,"50":0.01099,"51":0.02198,"52":0,"53":0.04396,"54":0,"55":0,"56":0,"57":0.0055,"58":0,"60":0.0055,"62":0,"63":0.02748,"64":0.08243,"65":0.18134,"66":0,"67":0.0055,"68":0.03847,"69":0.01099,"70":0.01649,"71":0.07693,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":3.68107,"3.2":0.00882,"4.0-4.1":0.00756,"4.2-4.3":0.00126,"5.0-5.1":0.0063,"6.0-6.1":0.00378,"7.0-7.1":0.00882,"8.1-8.4":0.02897,"9.0-9.2":0.01638,"9.3":0.20912,"10.0-10.2":0.03527,"10.3":0.19401,"11.0-11.2":0.07307,"11.3-11.4":0.12472,"12.0-12.1":0.12724,"12.2-12.4":1.2686,"13.0-13.1":0.10456,"13.2":0.05165,"13.3":0.39305,"13.4-13.7":2.09375},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.0055,"12":0.0055,"13":0.14287,"14":0.36817,"3.1":0,"3.2":0,"5.1":0.62094,"6.1":0,"7.1":0,"9.1":0.04396,"10.1":0.03847,"11.1":0.03847,"12.1":0.02748,"13.1":0.25277},"edge":{"12":0.08792,"13":0.02748,"14":0.04396,"15":0.01099,"16":0.02748,"17":0.09342,"18":0.31322,"79":0,"80":0,"81":0.0055,"83":0.01649,"84":0.01099,"85":1.23088,"86":1.82434},"android":{"3":0,"4":0.2279,"81":null,"2.1":0,"2.2":0,"2.3":0.00182,"4.1":0.11486,"4.2-4.3":0.05105,"4.4":0,"4.4.3-4.4.4":0.4157},"samsung":{"4":0.5535,"5.0-5.4":0.041,"6.2-6.4":0.041,"7.2-7.4":0.09225,"8.2":0,"9.2":0.07175,"10.1":0.05125,"11.1-11.2":0.0615,"12.0":2.02951},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.11144,"9":0,"10":0.05143,"11":2.40879,"5.5":0},"bb":{"7":0,"10":0.03604},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.16669},"and_qq":{"10.4":0.0856},"and_uc":{"0":0.51808},"op_mini":{"0":0.87433},"and_chr":{"0":53.86833}},"total":97.05086}

/***/ },
/* 1233 */
/***/ function(module, exports) {

	module.exports = {"id":"GR","name":"Greece","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0.00638,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0.01915,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00638,"44":0,"45":0.00638,"46":0,"47":0.00638,"48":0.01915,"49":0,"50":0,"51":0,"52":0.55523,"53":0,"54":0,"55":0,"56":0.01276,"57":0,"58":0,"59":0.01915,"60":0.00638,"61":0,"62":0,"63":0.00638,"64":0.00638,"65":0.00638,"66":0.00638,"67":0,"68":0.02553,"69":0,"70":0.00638,"71":0,"72":0.01276,"73":0,"74":0.00638,"75":0.00638,"76":0.00638,"77":0.01276,"78":0.07658,"79":0.01276,"80":0.1404,"81":4.77374,"82":0.61905,"83":0.00638,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.22975,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.00638,"35":0,"36":0,"37":0,"38":0.06382,"39":0,"40":0,"41":0,"42":0,"43":0.00638,"44":0,"45":0,"46":0,"47":0.03829,"48":0,"49":1.11047,"50":0,"51":0,"52":0.00638,"53":0.01915,"54":0,"55":0.00638,"56":0.00638,"57":0.00638,"58":0.01276,"59":0,"60":0.00638,"61":0.05106,"62":0,"63":0.00638,"64":0.01915,"65":0.01915,"66":0.00638,"67":0.03191,"68":0.00638,"69":0.01915,"70":0.11488,"71":0.06382,"72":0.27443,"73":0.03829,"74":0.1404,"75":0.02553,"76":0.02553,"77":0.12764,"78":0.03191,"79":0.0702,"80":0.08935,"81":0.15317,"83":0.06382,"84":0.26166,"85":9.6432,"86":15.22745,"87":0.00638,"88":0.00638,"89":0},"opera":{"9":0,"11":0,"12":0.03829,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0.00638,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0.06382,"32":0,"33":0,"34":0,"35":0,"36":0.04467,"37":0,"38":0,"39":0,"40":0.26804,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.01276,"52":0,"53":0.00638,"54":0,"55":0,"56":0,"57":0,"58":0.00638,"60":0,"62":0,"63":0,"64":0,"65":0.01276,"66":0,"67":0,"68":0,"69":0,"70":0.08297,"71":0.65735,"72":0.01276,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":3.72142,"3.2":0.00892,"4.0-4.1":0.00764,"4.2-4.3":0.00127,"5.0-5.1":0.00637,"6.0-6.1":0.00382,"7.0-7.1":0.00892,"8.1-8.4":0.02929,"9.0-9.2":0.01656,"9.3":0.21142,"10.0-10.2":0.03566,"10.3":0.19613,"11.0-11.2":0.07387,"11.3-11.4":0.12609,"12.0-12.1":0.12863,"12.2-12.4":1.2825,"13.0-13.1":0.10571,"13.2":0.05222,"13.3":0.39736,"13.4-13.7":2.1167},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00638,"12":0.01276,"13":0.05744,"14":0.33825,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.01276,"11.1":0.05106,"12.1":0.04467,"13.1":0.37654},"edge":{"12":0,"13":0,"14":0.00638,"15":0.01276,"16":0,"17":0.01276,"18":0.0702,"79":0,"80":0,"81":0,"83":0,"84":0.00638,"85":0.50418,"86":1.08494},"android":{"3":0,"4":0.42173,"81":null,"2.1":0,"2.2":0,"2.3":0.00337,"4.1":0.21255,"4.2-4.3":0.09447,"4.4":0,"4.4.3-4.4.4":0.76923},"samsung":{"4":0.37579,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0,"8.2":0,"9.2":0.03132,"10.1":0.03132,"11.1-11.2":0.07307,"12.0":1.67017},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.07189,"9":0,"10":0,"11":0.47058,"5.5":0},"bb":{"7":0,"10":0.00362},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.1411},"and_qq":{"10.4":0.00724},"and_uc":{"0":0.06874},"op_mini":{"0":0.40076},"and_chr":{"0":45.49267}},"total":97.11098}

/***/ },
/* 1234 */
/***/ function(module, exports) {

	module.exports = {"id":"GT","name":"Guatemala","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.01132,"49":0,"50":0,"51":0,"52":0.01697,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0.00566,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0.02829,"67":0,"68":0.01697,"69":0,"70":0,"71":0,"72":0.00566,"73":0.02829,"74":0,"75":0.01132,"76":0.00566,"77":0.00566,"78":0.07355,"79":0.00566,"80":0.02829,"81":1.55595,"82":0.20369,"83":0.01132,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0.00566,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00566,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.00566,"47":0,"48":0,"49":0.13579,"50":0,"51":0,"52":0,"53":0.01697,"54":0,"55":0.00566,"56":0,"57":0,"58":0.00566,"59":0.00566,"60":0,"61":0.00566,"62":0,"63":0.00566,"64":0.00566,"65":0.01697,"66":0.00566,"67":0.02263,"68":0.00566,"69":0.01697,"70":0.01132,"71":0.01697,"72":0.01697,"73":0.00566,"74":0.02263,"75":0.02829,"76":0.02829,"77":0.02829,"78":0.03395,"79":0.05658,"80":0.08487,"81":0.05658,"83":0.09053,"84":0.22066,"85":8.89438,"86":14.48448,"87":0.01132,"88":0.01132,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00566,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00566,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00566,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00566,"69":0,"70":0.07921,"71":0.72988,"72":0.01132,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":3.43062,"3.2":0.00822,"4.0-4.1":0.00704,"4.2-4.3":0.00117,"5.0-5.1":0.00587,"6.0-6.1":0.00352,"7.0-7.1":0.00822,"8.1-8.4":0.027,"9.0-9.2":0.01526,"9.3":0.19489,"10.0-10.2":0.03287,"10.3":0.18081,"11.0-11.2":0.0681,"11.3-11.4":0.11623,"12.0-12.1":0.11858,"12.2-12.4":1.18228,"13.0-13.1":0.09745,"13.2":0.04814,"13.3":0.36631,"13.4-13.7":1.9513},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.01132,"12":0.05658,"13":0.13013,"14":1.10897,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00566,"11.1":0.08487,"12.1":0.14711,"13.1":0.85436},"edge":{"12":0.00566,"13":0,"14":0,"15":0,"16":0,"17":0.01132,"18":0.04526,"79":0,"80":0,"81":0,"83":0,"84":0.00566,"85":0.42435,"86":0.79778},"android":{"3":0,"4":0.04007,"81":null,"2.1":0,"2.2":0,"2.3":0.00032,"4.1":0.02019,"4.2-4.3":0.00897,"4.4":0,"4.4.3-4.4.4":0.07308},"samsung":{"4":0.1711,"5.0-5.4":0.01006,"6.2-6.4":0.01006,"7.2-7.4":0.13084,"8.2":0.01006,"9.2":0.15097,"10.1":0.06039,"11.1-11.2":0.21136,"12.0":2.08342},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01132,"9":0,"10":0,"11":0.07355,"5.5":0},"bb":{"7":0,"10":0.00434},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.19539},"and_qq":{"10.4":0},"and_uc":{"0":0.08684},"op_mini":{"0":0.18909},"and_chr":{"0":55.63808}},"total":97.9644}

/***/ },
/* 1235 */
/***/ function(module, exports) {

	module.exports = {"id":"GU","name":"Guam","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.0048,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.0048,"49":0,"50":0,"51":0,"52":0.0048,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0.0576,"68":0.0144,"69":0,"70":0,"71":0,"72":0.0048,"73":0,"74":0,"75":0,"76":0,"77":0.0048,"78":0.0864,"79":0.0048,"80":0.0768,"81":0.8688,"82":0.1056,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.0048,"48":0,"49":0.0288,"50":0,"51":0,"52":0,"53":0.0384,"54":0,"55":0.0192,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0.0048,"66":0,"67":0.0048,"68":0.0048,"69":0.0144,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0.0096,"76":0.0768,"77":0.0048,"78":0,"79":0.024,"80":0.216,"81":0.0768,"83":0.0528,"84":0.1536,"85":4.8672,"86":7.3968,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.0048,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.024,"71":0.168,"72":0.0048,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.0048},"ios_saf":{"8":0,"14":16.81463,"3.2":0.04028,"4.0-4.1":0.03453,"4.2-4.3":0.00575,"5.0-5.1":0.02877,"6.0-6.1":0.01726,"7.0-7.1":0.04028,"8.1-8.4":0.13235,"9.0-9.2":0.07481,"9.3":0.95525,"10.0-10.2":0.16113,"10.3":0.88619,"11.0-11.2":0.33376,"11.3-11.4":0.56969,"12.0-12.1":0.5812,"12.2-12.4":5.79478,"13.0-13.1":0.47762,"13.2":0.23593,"13.3":1.7954,"13.4-13.7":9.56397},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.0048,"11":0.0096,"12":0.024,"13":0.4272,"14":1.5504,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.0096,"10.1":0.0336,"11.1":0.0768,"12.1":0.1344,"13.1":2.0064},"edge":{"12":0,"13":0,"14":0,"15":0.0048,"16":0.0288,"17":0.0096,"18":0.2112,"79":0,"80":0,"81":0,"83":0,"84":0.0096,"85":0.6816,"86":1.2336},"android":{"3":0,"4":0.09191,"81":null,"2.1":0,"2.2":0,"2.3":0.00074,"4.1":0.04632,"4.2-4.3":0.02059,"4.4":0,"4.4.3-4.4.4":0.16764},"samsung":{"4":0.31809,"5.0-5.4":0.03181,"6.2-6.4":0,"7.2-7.4":0.03181,"8.2":0.02121,"9.2":0.18025,"10.1":0.02121,"11.1-11.2":0.26507,"12.0":4.80315},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.4128,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.3484},"and_qq":{"10.4":0},"and_uc":{"0":0.026},"op_mini":{"0":0.08369},"and_chr":{"0":30.272}},"total":96.58547}

/***/ },
/* 1236 */
/***/ function(module, exports) {

	module.exports = {"id":"GW","name":"Guinea-Bissau","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00233,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.00233,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0.00233,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00233,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0.00467,"75":0,"76":0,"77":0,"78":0,"79":0,"80":0.00233,"81":0.14704,"82":0.01167,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.03034,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0.00467,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0.014,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.01867,"41":0,"42":0.00233,"43":0.02334,"44":0,"45":0,"46":0,"47":0.00467,"48":0,"49":0.014,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0.00233,"64":0.00934,"65":0,"66":0,"67":0,"68":0,"69":0.007,"70":0.06535,"71":0,"72":0,"73":0,"74":0.04435,"75":0.00467,"76":0.00233,"77":0.00233,"78":0.00233,"79":0.02567,"80":0.02801,"81":0.02334,"83":0.007,"84":0.07702,"85":0.76322,"86":1.62913,"87":0.00467,"88":0.00233,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00233,"69":0,"70":0.02101,"71":0.19606,"72":0.02101,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00467},"ios_saf":{"8":0,"14":2.25962,"3.2":0.00541,"4.0-4.1":0.00464,"4.2-4.3":0.00077,"5.0-5.1":0.00387,"6.0-6.1":0.00232,"7.0-7.1":0.00541,"8.1-8.4":0.01779,"9.0-9.2":0.01005,"9.3":0.12837,"10.0-10.2":0.02165,"10.3":0.11909,"11.0-11.2":0.04485,"11.3-11.4":0.07656,"12.0-12.1":0.0781,"12.2-12.4":0.77872,"13.0-13.1":0.06418,"13.2":0.03171,"13.3":0.24127,"13.4-13.7":1.28524},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00467,"12":0,"13":0.00934,"14":0.74921,"3.1":0,"3.2":0,"5.1":0.00467,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00467,"11.1":0.00467,"12.1":0,"13.1":0.03034},"edge":{"12":0.00934,"13":0.00233,"14":0.007,"15":0.03734,"16":0.00467,"17":0.01867,"18":0.03968,"79":0,"80":0,"81":0,"83":0,"84":0.00467,"85":0.06068,"86":0.23573},"android":{"3":0,"4":0.08896,"81":null,"2.1":0,"2.2":0,"2.3":0.00071,"4.1":0.04483,"4.2-4.3":0.01993,"4.4":0,"4.4.3-4.4.4":0.16225},"samsung":{"4":0.85369,"5.0-5.4":0.03049,"6.2-6.4":0.09147,"7.2-7.4":0.84352,"8.2":0,"9.2":0.34554,"10.1":0.16261,"11.1-11.2":0.30489,"12.0":0.91466},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00934,"9":0.007,"10":0,"11":0.06302,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.01533},"and_qq":{"10.4":0.00767},"and_uc":{"0":0.69761},"op_mini":{"0":8.45519},"and_chr":{"0":73.662}},"total":96.42056}

/***/ },
/* 1237 */
/***/ function(module, exports) {

	module.exports = {"id":"GY","name":"Guyana","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00472,"48":0.00472,"49":0,"50":0,"51":0,"52":0.00472,"53":0,"54":0,"55":0,"56":0.00472,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0.00943,"64":0,"65":0,"66":0,"67":0.00943,"68":0.00472,"69":0,"70":0.00472,"71":0,"72":0.00472,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0.01415,"79":0.00943,"80":0.03773,"81":0.87718,"82":0.16978,"83":0.00472,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00472,"39":0.00943,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.0896,"50":0.00472,"51":0,"52":0,"53":0.01886,"54":0,"55":0.00472,"56":0,"57":0,"58":0.00472,"59":0,"60":0,"61":0.00472,"62":0,"63":0.01415,"64":0.00472,"65":0.01415,"66":0.00472,"67":0.00472,"68":0.00472,"69":0.00943,"70":0.01886,"71":0.00943,"72":0.00943,"73":0.01415,"74":0.02358,"75":0.01886,"76":0.02358,"77":0.01886,"78":0.00472,"79":0.18864,"80":0.09432,"81":0.1462,"83":0.04716,"84":0.4716,"85":5.32436,"86":7.30037,"87":0.00943,"88":0.00472,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0.00472,"18":0,"19":0,"20":0,"21":0,"22":0.00472,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0.00472,"68":0.00943,"69":0,"70":0.04244,"71":0.53762,"72":0.00472,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00472},"ios_saf":{"8":0,"14":4.9555,"3.2":0.01187,"4.0-4.1":0.01018,"4.2-4.3":0.0017,"5.0-5.1":0.00848,"6.0-6.1":0.00509,"7.0-7.1":0.01187,"8.1-8.4":0.03901,"9.0-9.2":0.02205,"9.3":0.28152,"10.0-10.2":0.04749,"10.3":0.26117,"11.0-11.2":0.09836,"11.3-11.4":0.1679,"12.0-12.1":0.17129,"12.2-12.4":1.7078,"13.0-13.1":0.14076,"13.2":0.06953,"13.3":0.52913,"13.4-13.7":2.81863},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.00472,"13":0.08017,"14":0.19807,"3.1":0,"3.2":0,"5.1":0.01415,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0.00472,"12.1":0.00943,"13.1":0.72155},"edge":{"12":0.00472,"13":0.00472,"14":0,"15":0.01415,"16":0.01886,"17":0.0283,"18":0.18864,"79":0,"80":0.00472,"81":0.00472,"83":0.00472,"84":0.02358,"85":0.61308,"86":1.2686},"android":{"3":0,"4":0.7826,"81":null,"2.1":0,"2.2":0,"2.3":0.00626,"4.1":0.39443,"4.2-4.3":0.1753,"4.4":0,"4.4.3-4.4.4":1.42747},"samsung":{"4":0.44962,"5.0-5.4":0.0329,"6.2-6.4":0.02193,"7.2-7.4":0.17546,"8.2":0.01097,"9.2":0.18643,"10.1":0.31803,"11.1-11.2":0.35093,"12.0":4.56204},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0.0136,"11":0.3401,"5.5":0},"bb":{"7":0,"10":0.00528},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.12153},"and_qq":{"10.4":0.06869},"and_uc":{"0":0.99868},"op_mini":{"0":0.32016},"and_chr":{"0":55.4677}},"total":96.50541}

/***/ },
/* 1238 */
/***/ function(module, exports) {

	module.exports = {"id":"HK","name":"Hong Kong","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00566,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00566,"49":0,"50":0,"51":0,"52":0.02264,"53":0,"54":0,"55":0,"56":0.00566,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0.00566,"66":0.00566,"67":0.00566,"68":0.04529,"69":0,"70":0,"71":0.00566,"72":0.01132,"73":0,"74":0.00566,"75":0.00566,"76":0.01132,"77":0.01132,"78":0.05095,"79":0.01132,"80":0.04529,"81":0.95105,"82":0.13586,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.01132,"23":0,"24":0,"25":0,"26":0.01698,"27":0,"28":0,"29":0,"30":0.00566,"31":0,"32":0,"33":0,"34":0.05661,"35":0,"36":0,"37":0,"38":0.12454,"39":0,"40":0.00566,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00566,"48":0.01132,"49":0.12454,"50":0,"51":0,"52":0,"53":0.2038,"54":0.00566,"55":0.02264,"56":0.00566,"57":0.01698,"58":0.00566,"59":0.00566,"60":0.00566,"61":0.01132,"62":0.02264,"63":0.01698,"64":0.01132,"65":0.03397,"66":0.01132,"67":0.03963,"68":0.05661,"69":0.03963,"70":0.04529,"71":0.07359,"72":0.05095,"73":0.06793,"74":0.05095,"75":0.08492,"76":0.07359,"77":0.06227,"78":0.14153,"79":0.09624,"80":0.2038,"81":0.15285,"83":0.26607,"84":0.47552,"85":7.47252,"86":10.60871,"87":0.02831,"88":0.01132,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.02264,"37":0,"38":0,"39":0,"40":0.00566,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.01132,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.01698,"71":0.09624,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":12.74314,"3.2":0.03053,"4.0-4.1":0.02617,"4.2-4.3":0.00436,"5.0-5.1":0.02181,"6.0-6.1":0.01308,"7.0-7.1":0.03053,"8.1-8.4":0.10031,"9.0-9.2":0.05669,"9.3":0.72394,"10.0-10.2":0.12211,"10.3":0.67161,"11.0-11.2":0.25294,"11.3-11.4":0.43175,"12.0-12.1":0.44047,"12.2-12.4":4.39163,"13.0-13.1":0.36197,"13.2":0.17881,"13.3":1.36066,"13.4-13.7":7.24815},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0.01132,"9":0.01132,"10":0.00566,"11":0.01698,"12":0.03963,"13":0.29437,"14":1.27939,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.00566,"10.1":0.03397,"11.1":0.08492,"12.1":0.15851,"13.1":2.43989},"edge":{"12":0.00566,"13":0,"14":0.00566,"15":0,"16":0.00566,"17":0.02264,"18":0.14153,"79":0,"80":0,"81":0,"83":0,"84":0.01132,"85":0.50949,"86":1.04729},"android":{"3":0,"4":0.08437,"81":null,"2.1":0,"2.2":0,"2.3":0.00067,"4.1":0.04252,"4.2-4.3":0.0189,"4.4":0,"4.4.3-4.4.4":0.1539},"samsung":{"4":0.80288,"5.0-5.4":0.01071,"6.2-6.4":0.02141,"7.2-7.4":0.04282,"8.2":0.02141,"9.2":0.11776,"10.1":0.06423,"11.1-11.2":0.13917,"12.0":4.47471},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.03311,"9":0.01104,"10":0.01104,"11":0.81662,"5.5":0},"bb":{"7":0,"10":0.00434},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.1779},"and_qq":{"10.4":0.19959},"and_uc":{"0":0.54671},"op_mini":{"0":0.07394},"and_chr":{"0":30.41306}},"total":95.96827}

/***/ },
/* 1239 */
/***/ function(module, exports) {

	module.exports = {"id":"HN","name":"Honduras","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0.00657,"5":0.00657,"6":0.00657,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0.00657,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.00657,"53":0,"54":0,"55":0.00657,"56":0,"57":0,"58":0,"59":0,"60":0.01971,"61":0,"62":0,"63":0,"64":0.00657,"65":0.00657,"66":0.02628,"67":0,"68":0.01314,"69":0,"70":0,"71":0.00657,"72":0.00657,"73":0.03941,"74":0,"75":0,"76":0.00657,"77":0,"78":0.05912,"79":0.01971,"80":0.03285,"81":1.87873,"82":0.2759,"83":0.02628,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0.00657,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.01314,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00657,"49":0.11167,"50":0,"51":0,"52":0,"53":0.03941,"54":0.00657,"55":0,"56":0,"57":0,"58":0.00657,"59":0.00657,"60":0,"61":0,"62":0.00657,"63":0.01971,"64":0.01314,"65":0.02628,"66":0.00657,"67":0.00657,"68":0.00657,"69":0.11167,"70":0.01971,"71":0.01971,"72":0.02628,"73":0.06569,"74":0.01971,"75":0.05912,"76":0.04598,"77":0.05912,"78":0.05255,"79":0.07883,"80":0.15766,"81":0.1051,"83":0.16423,"84":0.28904,"85":10.53011,"86":20.01574,"87":0.05255,"88":0.00657,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00657,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0.00657,"58":0,"60":0,"62":0,"63":0.01314,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.11167,"71":1.35978,"72":0.01971,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":3.72958,"3.2":0.00893,"4.0-4.1":0.00766,"4.2-4.3":0.00128,"5.0-5.1":0.00638,"6.0-6.1":0.00383,"7.0-7.1":0.00893,"8.1-8.4":0.02936,"9.0-9.2":0.01659,"9.3":0.21188,"10.0-10.2":0.03574,"10.3":0.19656,"11.0-11.2":0.07403,"11.3-11.4":0.12636,"12.0-12.1":0.12891,"12.2-12.4":1.28531,"13.0-13.1":0.10594,"13.2":0.05233,"13.3":0.39823,"13.4-13.7":2.12134},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.01314,"12":0.02628,"13":0.12481,"14":1.09702,"3.1":0,"3.2":0,"5.1":0.52552,"6.1":0,"7.1":0,"9.1":0,"10.1":0.01314,"11.1":0.04598,"12.1":0.13795,"13.1":0.91309},"edge":{"12":0.00657,"13":0.00657,"14":0.00657,"15":0.01314,"16":0.00657,"17":0.02628,"18":0.0854,"79":0,"80":0,"81":0,"83":0.00657,"84":0.01971,"85":0.61749,"86":1.42547},"android":{"3":0,"4":0.10977,"81":null,"2.1":0,"2.2":0,"2.3":0.00088,"4.1":0.05533,"4.2-4.3":0.02459,"4.4":0,"4.4.3-4.4.4":0.20023},"samsung":{"4":0.184,"5.0-5.4":0.02044,"6.2-6.4":0,"7.2-7.4":0.092,"8.2":0.01022,"9.2":0.10222,"10.1":0.06133,"11.1-11.2":0.16355,"12.0":1.83998},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.0268,"9":0.00893,"10":0.0268,"11":0.16081,"5.5":0},"bb":{"7":0,"10":0.00343},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.08921},"and_qq":{"10.4":0.00686},"and_uc":{"0":0.08234},"op_mini":{"0":0.14292},"and_chr":{"0":44.70717}},"total":97.92894}

/***/ },
/* 1240 */
/***/ function(module, exports) {

	module.exports = {"id":"HR","name":"Croatia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0.0101,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0.00505,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00505,"48":0.01515,"49":0,"50":0,"51":0,"52":0.09593,"53":0,"54":0,"55":0,"56":0.00505,"57":0.00505,"58":0,"59":0,"60":0,"61":0.00505,"62":0,"63":0,"64":0,"65":0.00505,"66":0.00505,"67":0.00505,"68":0.04039,"69":0,"70":0.00505,"71":0.00505,"72":0.0202,"73":0,"74":0.00505,"75":0.00505,"76":0.00505,"77":0.00505,"78":0.07069,"79":0.03534,"80":0.09088,"81":2.62043,"82":0.39887,"83":0.00505,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00505,"39":0.00505,"40":0.00505,"41":0,"42":0.00505,"43":0.16157,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.14137,"50":0,"51":0,"52":0,"53":0.01515,"54":0,"55":0,"56":0.00505,"57":0,"58":0.00505,"59":0.00505,"60":0,"61":0.00505,"62":0,"63":0.0101,"64":0.00505,"65":0.00505,"66":0.00505,"67":0.0101,"68":0.00505,"69":0.01515,"70":0.01515,"71":0.02525,"72":0.01515,"73":0.0101,"74":0.01515,"75":0.06564,"76":0.02525,"77":0.09088,"78":0.03534,"79":0.04544,"80":0.07069,"81":0.18681,"83":0.06564,"84":0.14642,"85":6.18503,"86":10.09295,"87":0.0101,"88":0.00505,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0.0101,"33":0.00505,"34":0,"35":0,"36":0.0101,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.03029,"52":0,"53":0.00505,"54":0,"55":0,"56":0,"57":0.00505,"58":0,"60":0.0101,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.09593,"71":0.69676,"72":0.01515,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":4.27874,"3.2":0.01025,"4.0-4.1":0.00879,"4.2-4.3":0.00146,"5.0-5.1":0.00732,"6.0-6.1":0.00439,"7.0-7.1":0.01025,"8.1-8.4":0.03368,"9.0-9.2":0.01904,"9.3":0.24308,"10.0-10.2":0.041,"10.3":0.2255,"11.0-11.2":0.08493,"11.3-11.4":0.14497,"12.0-12.1":0.1479,"12.2-12.4":1.47457,"13.0-13.1":0.12154,"13.2":0.06004,"13.3":0.45687,"13.4-13.7":2.4337},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.0101,"12":0.0101,"13":0.04544,"14":0.36858,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.01515,"11.1":0.02525,"12.1":0.09088,"13.1":0.39887},"edge":{"12":0,"13":0.00505,"14":0.0101,"15":0.0101,"16":0.0101,"17":0.02525,"18":0.13632,"79":0,"80":0,"81":0.00505,"83":0,"84":0.00505,"85":0.33828,"86":0.66142},"android":{"3":0,"4":0.07025,"81":null,"2.1":0,"2.2":0,"2.3":0.00056,"4.1":0.03541,"4.2-4.3":0.01574,"4.4":0,"4.4.3-4.4.4":0.12814},"samsung":{"4":0.1325,"5.0-5.4":0.01019,"6.2-6.4":0.02038,"7.2-7.4":0.03058,"8.2":0.02038,"9.2":0.08154,"10.1":0.10192,"11.1-11.2":0.19365,"12.0":4.09717},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.06617,"9":0,"10":0,"11":0.55991,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.23765},"and_qq":{"10.4":0},"and_uc":{"0":0.05446},"op_mini":{"0":0.34217},"and_chr":{"0":57.06983}},"total":97.1251}

/***/ },
/* 1241 */
/***/ function(module, exports) {

	module.exports = {"id":"HT","name":"Haiti","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0.00284,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00284,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00284,"44":0,"45":0,"46":0,"47":0,"48":0.00284,"49":0,"50":0,"51":0,"52":0.00569,"53":0,"54":0.00284,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0.00569,"64":0,"65":0,"66":0,"67":0,"68":0.01706,"69":0,"70":0,"71":0,"72":0.00569,"73":0,"74":0.00284,"75":0,"76":0,"77":0,"78":0.0455,"79":0.00569,"80":0.01138,"81":0.33559,"82":0.04266,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0.00284,"43":0.01138,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.04835,"50":0.00284,"51":0.00284,"52":0,"53":0,"54":0,"55":0.01991,"56":0.00284,"57":0,"58":0.00853,"59":0,"60":0.00284,"61":0,"62":0,"63":0.01422,"64":0.00284,"65":0.01138,"66":0.01706,"67":0.00284,"68":0.00284,"69":0.00284,"70":0.00284,"71":0.00284,"72":0.00569,"73":0.00284,"74":0.00569,"75":0.00853,"76":0.01706,"77":0.00853,"78":0.00284,"79":0.03128,"80":0.04835,"81":0.01991,"83":0.0455,"84":0.04835,"85":1.71778,"86":2.56529,"87":0.00569,"88":0.00284,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0.01138,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.00284,"46":0,"47":0,"48":0,"49":0,"50":0.00284,"51":0.02844,"52":0,"53":0.00569,"54":0,"55":0,"56":0,"57":0,"58":0.00284,"60":0.00853,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0.00284,"68":0.00569,"69":0,"70":0.06826,"71":0.42091,"72":0.02275,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00284},"ios_saf":{"8":0,"14":4.30643,"3.2":0.01032,"4.0-4.1":0.00884,"4.2-4.3":0.00147,"5.0-5.1":0.00737,"6.0-6.1":0.00442,"7.0-7.1":0.01032,"8.1-8.4":0.0339,"9.0-9.2":0.01916,"9.3":0.24465,"10.0-10.2":0.04127,"10.3":0.22696,"11.0-11.2":0.08548,"11.3-11.4":0.14591,"12.0-12.1":0.14885,"12.2-12.4":1.48411,"13.0-13.1":0.12232,"13.2":0.06043,"13.3":0.45982,"13.4-13.7":2.44945},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00284,"11":0.00853,"12":0.01706,"13":0.08248,"14":0.33559,"3.1":0,"3.2":0,"5.1":0.03697,"6.1":0,"7.1":0,"9.1":0,"10.1":0.03413,"11.1":0.0256,"12.1":0.03697,"13.1":0.22752},"edge":{"12":0.01138,"13":0.0256,"14":0.00853,"15":0.02275,"16":0.00853,"17":0.0256,"18":0.07679,"79":0,"80":0,"81":0.00284,"83":0.00853,"84":0.00853,"85":0.19624,"86":0.38678},"android":{"3":0,"4":0.06726,"81":null,"2.1":0,"2.2":0,"2.3":0.00054,"4.1":0.0339,"4.2-4.3":0.01507,"4.4":0,"4.4.3-4.4.4":0.12268},"samsung":{"4":0.41002,"5.0-5.4":0.18451,"6.2-6.4":0.09225,"7.2-7.4":0.34852,"8.2":0.07175,"9.2":0.26651,"10.1":0.1025,"11.1-11.2":0.37927,"12.0":1.16856},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00569,"9":0,"10":0,"11":0.0967,"5.5":0},"bb":{"7":0,"10":0.05009},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.1145},"and_qq":{"10.4":0.02862},"and_uc":{"0":0.47945},"op_mini":{"0":1.36174},"and_chr":{"0":75.69394}},"total":98.33142}

/***/ },
/* 1242 */
/***/ function(module, exports) {

	module.exports = {"id":"HU","name":"Hungary","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00563,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00563,"48":0.00563,"49":0,"50":0,"51":0.00563,"52":0.11268,"53":0,"54":0,"55":0,"56":0.01127,"57":0.00563,"58":0,"59":0.00563,"60":0.00563,"61":0.00563,"62":0.00563,"63":0.01127,"64":0,"65":0.00563,"66":0.01127,"67":0.00563,"68":0.03944,"69":0.00563,"70":0.00563,"71":0.00563,"72":0.02254,"73":0.00563,"74":0.01127,"75":0.00563,"76":0.01127,"77":0.01127,"78":0.10705,"79":0.03944,"80":0.51833,"81":3.79732,"82":0.59157,"83":0.00563,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00563,"23":0,"24":0,"25":0,"26":0.00563,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.0169,"35":0,"36":0,"37":0,"38":0.03944,"39":0,"40":0,"41":0,"42":0,"43":0.00563,"44":0,"45":0,"46":0,"47":0,"48":0.00563,"49":0.24226,"50":0,"51":0,"52":0,"53":0.07324,"54":0,"55":0,"56":0.00563,"57":0.00563,"58":0.01127,"59":0,"60":0,"61":0.00563,"62":0.00563,"63":0.00563,"64":0.00563,"65":0.00563,"66":0.0338,"67":0.01127,"68":0.0169,"69":0.01127,"70":0.0169,"71":0.02817,"72":0.0169,"73":0.0169,"74":0.0169,"75":0.01127,"76":0.0169,"77":0.02254,"78":0.02817,"79":0.0338,"80":0.05634,"81":0.07324,"83":0.08451,"84":0.16902,"85":7.56646,"86":12.62579,"87":0.01127,"88":0.00563,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.01127,"37":0,"38":0,"39":0,"40":0.00563,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.0338,"52":0,"53":0.00563,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00563,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00563,"69":0,"70":0.12958,"71":1.04229,"72":0.0338,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":5.91068,"3.2":0.01416,"4.0-4.1":0.01214,"4.2-4.3":0.00202,"5.0-5.1":0.01011,"6.0-6.1":0.00607,"7.0-7.1":0.01416,"8.1-8.4":0.04652,"9.0-9.2":0.0263,"9.3":0.33579,"10.0-10.2":0.05664,"10.3":0.31151,"11.0-11.2":0.11732,"11.3-11.4":0.20026,"12.0-12.1":0.2043,"12.2-12.4":2.03698,"13.0-13.1":0.16789,"13.2":0.08294,"13.3":0.63112,"13.4-13.7":3.36192},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00563,"12":0.01127,"13":0.06761,"14":0.5296,"3.1":0,"3.2":0,"5.1":0,"6.1":0.00563,"7.1":0,"9.1":0.00563,"10.1":0.00563,"11.1":0.0338,"12.1":0.04507,"13.1":0.43382},"edge":{"12":0,"13":0,"14":0.00563,"15":0.0169,"16":0.00563,"17":0.0169,"18":0.15775,"79":0,"80":0,"81":0,"83":0,"84":0.00563,"85":0.46762,"86":0.96341},"android":{"3":0,"4":0.05424,"81":null,"2.1":0,"2.2":0,"2.3":0.00043,"4.1":0.02734,"4.2-4.3":0.01215,"4.4":0,"4.4.3-4.4.4":0.09894},"samsung":{"4":0.37001,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.01028,"8.2":0.01028,"9.2":0.04111,"10.1":0.06167,"11.1-11.2":0.11306,"12.0":2.52839},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.0059,"9":0,"10":0,"11":0.24199,"5.5":0},"bb":{"7":0,"10":0.00437},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.29252},"and_qq":{"10.4":0},"and_uc":{"0":0.05676},"op_mini":{"0":0.38441},"and_chr":{"0":48.97187}},"total":97.60166}

/***/ },
/* 1243 */
/***/ function(module, exports) {

	module.exports = {"id":"ID","name":"Indonesia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.02872,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00479,"44":0,"45":0,"46":0,"47":0.00479,"48":0.00479,"49":0,"50":0,"51":0,"52":0.02872,"53":0.00479,"54":0,"55":0.00479,"56":0.00957,"57":0.00479,"58":0.00479,"59":0.00479,"60":0.00479,"61":0.00479,"62":0.00479,"63":0.00479,"64":0.01436,"65":0.00479,"66":0.00957,"67":0.00479,"68":0.01915,"69":0.00957,"70":0.00957,"71":0.00479,"72":0.02872,"73":0.00479,"74":0.00957,"75":0.00957,"76":0.00957,"77":0.01436,"78":0.05744,"79":0.02394,"80":0.06702,"81":2.135,"82":0.33509,"83":0.03351,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00479,"39":0,"40":0,"41":0,"42":0,"43":0.00479,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.06223,"50":0,"51":0.00479,"52":0,"53":0.00479,"54":0.00479,"55":0.00479,"56":0.00479,"57":0,"58":0.02394,"59":0.00479,"60":0.00479,"61":0.04308,"62":0.00479,"63":0.03351,"64":0.00479,"65":0.00957,"66":0.00479,"67":0.01436,"68":0.00479,"69":0.02394,"70":0.03351,"71":0.05744,"72":0.02394,"73":0.0383,"74":0.10531,"75":0.04787,"76":0.04787,"77":0.04787,"78":0.07181,"79":0.09574,"80":0.20584,"81":0.07659,"83":0.12925,"84":0.18191,"85":5.60079,"86":8.82244,"87":0.01436,"88":0.00479,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0.00479,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.06702,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.00479,"46":0.00957,"47":0.00479,"48":0,"49":0,"50":0.05266,"51":0.22499,"52":0.00479,"53":0,"54":0,"55":0.00479,"56":0,"57":0.00957,"58":0,"60":0.00479,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.06223,"71":0.36381,"72":0.00479,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":2.60175,"3.2":0.00623,"4.0-4.1":0.00534,"4.2-4.3":0.00089,"5.0-5.1":0.00445,"6.0-6.1":0.00267,"7.0-7.1":0.00623,"8.1-8.4":0.02048,"9.0-9.2":0.01158,"9.3":0.14781,"10.0-10.2":0.02493,"10.3":0.13712,"11.0-11.2":0.05164,"11.3-11.4":0.08815,"12.0-12.1":0.08993,"12.2-12.4":0.89663,"13.0-13.1":0.0739,"13.2":0.03651,"13.3":0.2778,"13.4-13.7":1.47984},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00479,"12":0.02394,"13":0.05744,"14":0.21063,"3.1":0,"3.2":0,"5.1":0.68933,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00479,"11.1":0.02394,"12.1":0.05266,"13.1":0.23935},"edge":{"12":0,"13":0,"14":0,"15":0,"16":0,"17":0.00479,"18":0.02872,"79":0,"80":0,"81":0,"83":0,"84":0.00479,"85":0.23456,"86":0.45955},"android":{"3":0,"4":0.09793,"81":null,"2.1":0,"2.2":0,"2.3":0.00078,"4.1":0.04936,"4.2-4.3":0.02194,"4.4":0,"4.4.3-4.4.4":0.17862},"samsung":{"4":0.52147,"5.0-5.4":0.02006,"6.2-6.4":0.03008,"7.2-7.4":0.0702,"8.2":0.03008,"9.2":0.15042,"10.1":0.11031,"11.1-11.2":0.23065,"12.0":1.33375},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01044,"9":0,"10":0.00522,"11":0.04178,"5.5":0},"bb":{"7":0,"10":0.00521},"ie_mob":{"10":0,"11":0.01043},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.10426},"and_qq":{"10.4":0.00521},"and_uc":{"0":1.74636},"op_mini":{"0":1.35722},"and_chr":{"0":63.00978}},"total":96.77629}

/***/ },
/* 1244 */
/***/ function(module, exports) {

	module.exports = {"id":"IE","name":"Ireland","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00437,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.01747,"39":0,"40":0,"41":0,"42":0,"43":0.0131,"44":0.06551,"45":0.0131,"46":0,"47":0,"48":0.00437,"49":0,"50":0,"51":0,"52":0.0131,"53":0,"54":0,"55":0,"56":0.00437,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0.00437,"65":0.00437,"66":0,"67":0,"68":0.0393,"69":0,"70":0.00437,"71":0,"72":0.03494,"73":0,"74":0,"75":0,"76":0,"77":0.00873,"78":0.07861,"79":0.00873,"80":0.04367,"81":0.70309,"82":0.11354,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.00437,"35":0,"36":0,"37":0,"38":0.00437,"39":0,"40":0.00873,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.00437,"47":0.01747,"48":0.16595,"49":0.14411,"50":0,"51":0,"52":0,"53":0.00873,"54":0,"55":0.00437,"56":0.0131,"57":0,"58":0,"59":0,"60":0,"61":0.00873,"62":0,"63":0.00437,"64":0,"65":0.0131,"66":0.00437,"67":0.0131,"68":0.00873,"69":0.0262,"70":0.02184,"71":0.0393,"72":0.02184,"73":0.01747,"74":0.0131,"75":0.0393,"76":0.03057,"77":0.0262,"78":0.02184,"79":0.04367,"80":0.0393,"81":0.0524,"83":0.09171,"84":0.15285,"85":4.7513,"86":6.61164,"87":0.00873,"88":0.00437,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00437,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00437,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.02184,"71":0.16595,"72":0.00437,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":15.48932,"3.2":0.03711,"4.0-4.1":0.03181,"4.2-4.3":0.0053,"5.0-5.1":0.0265,"6.0-6.1":0.0159,"7.0-7.1":0.03711,"8.1-8.4":0.12192,"9.0-9.2":0.06891,"9.3":0.87995,"10.0-10.2":0.14843,"10.3":0.81634,"11.0-11.2":0.30745,"11.3-11.4":0.52479,"12.0-12.1":0.53539,"12.2-12.4":5.33804,"13.0-13.1":0.43998,"13.2":0.21734,"13.3":1.65389,"13.4-13.7":8.81015},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0.00873,"9":0.0262,"10":0,"11":0.00437,"12":0.0131,"13":0.24892,"14":0.78606,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.00437,"10.1":0.01747,"11.1":0.04367,"12.1":0.08297,"13.1":1.37997},"edge":{"12":0.00437,"13":0.00437,"14":0.00437,"15":0.00437,"16":0.00873,"17":0.02184,"18":0.18778,"79":0,"80":0.00437,"81":0.00437,"83":0,"84":0.00873,"85":0.3712,"86":0.72492},"android":{"3":0,"4":0.11229,"81":null,"2.1":0,"2.2":0,"2.3":0.0009,"4.1":0.05659,"4.2-4.3":0.02515,"4.4":0,"4.4.3-4.4.4":0.20481},"samsung":{"4":0.05228,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.03137,"8.2":0.01046,"9.2":0.07319,"10.1":0.06273,"11.1-11.2":0.14637,"12.0":3.83709},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.02026,"9":0.03546,"10":0,"11":0.32421,"5.5":0},"bb":{"7":0,"10":0.00563},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.27038},"and_qq":{"10.4":0.0338},"and_uc":{"0":0.0338},"op_mini":{"0":0.12266},"and_chr":{"0":38.98425}},"total":97.73617}

/***/ },
/* 1245 */
/***/ function(module, exports) {

	module.exports = {"id":"IL","name":"Israel","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0.00522,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0.00522,"25":0.00522,"26":0.01566,"27":0.00522,"28":0,"29":0.00522,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00522,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00522,"49":0,"50":0,"51":0,"52":0.01566,"53":0,"54":0.00522,"55":0.01044,"56":0.01566,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0.00522,"64":0,"65":0.00522,"66":0.00522,"67":0,"68":0.01566,"69":0,"70":0,"71":0,"72":0.00522,"73":0,"74":0.00522,"75":0,"76":0,"77":0.00522,"78":0.03131,"79":0.09394,"80":0.04175,"81":0.74632,"82":0.1096,"83":0.00522,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00522,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0.03131,"32":0.01044,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.01566,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.0835,"50":0,"51":0,"52":0,"53":0.0261,"54":0,"55":0,"56":0.00522,"57":0.00522,"58":0,"59":0.00522,"60":0.0261,"61":0.01044,"62":0.00522,"63":0.00522,"64":0.00522,"65":0.01566,"66":0.00522,"67":0.02088,"68":0.01044,"69":0.00522,"70":0.0261,"71":0.04697,"72":0.0261,"73":0.0261,"74":0.02088,"75":0.03653,"76":0.01566,"77":0.02088,"78":0.0261,"79":0.04697,"80":0.1096,"81":0.09916,"83":0.08872,"84":0.18788,"85":8.63745,"86":12.70305,"87":0.01044,"88":0.00522,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0.00522,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.04175,"71":0.26095,"72":0.00522,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00522},"ios_saf":{"8":0,"14":7.33023,"3.2":0.01756,"4.0-4.1":0.01505,"4.2-4.3":0.00251,"5.0-5.1":0.01254,"6.0-6.1":0.00753,"7.0-7.1":0.01756,"8.1-8.4":0.0577,"9.0-9.2":0.03261,"9.3":0.41643,"10.0-10.2":0.07024,"10.3":0.38633,"11.0-11.2":0.1455,"11.3-11.4":0.24835,"12.0-12.1":0.25337,"12.2-12.4":2.52619,"13.0-13.1":0.20822,"13.2":0.10285,"13.3":0.78269,"13.4-13.7":4.16935},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0.00522,"8":0.05219,"9":0,"10":0,"11":0.00522,"12":0.01044,"13":0.04697,"14":0.38099,"3.1":0,"3.2":0,"5.1":0.01044,"6.1":0.00522,"7.1":0,"9.1":0,"10.1":0.01044,"11.1":0.02088,"12.1":0.03131,"13.1":0.38099},"edge":{"12":0,"13":0,"14":0.00522,"15":0,"16":0.00522,"17":0.01566,"18":0.0835,"79":0,"80":0,"81":0,"83":0,"84":0.00522,"85":0.36533,"86":0.68369},"android":{"3":0,"4":0.03982,"81":null,"2.1":0,"2.2":0,"2.3":0.00032,"4.1":0.02007,"4.2-4.3":0.00892,"4.4":0,"4.4.3-4.4.4":0.07263},"samsung":{"4":0.11192,"5.0-5.4":0.01017,"6.2-6.4":0.01017,"7.2-7.4":0.06105,"8.2":0.02035,"9.2":0.25436,"10.1":0.14244,"11.1-11.2":0.29506,"12.0":4.80237},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00528,"9":0.00528,"10":0.00528,"11":0.40689,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.11953},"and_qq":{"10.4":0.00478},"and_uc":{"0":0.04781},"op_mini":{"0":0.14937},"and_chr":{"0":47.06438}},"total":96.50919}

/***/ },
/* 1246 */
/***/ function(module, exports) {

	module.exports = {"id":"IM","name":"Isle of Man","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.01648,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.00549,"46":0,"47":0,"48":0.01648,"49":0,"50":0,"51":0,"52":0.00549,"53":0,"54":0,"55":0,"56":0.13735,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0.01648,"67":0,"68":0.00549,"69":0,"70":0,"71":0,"72":0,"73":0.00549,"74":0,"75":0,"76":0.00549,"77":0.00549,"78":0.04395,"79":0.01648,"80":0.06043,"81":1.20868,"82":0.17031,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.30217,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0.00549,"64":0,"65":0.00549,"66":0,"67":0.12636,"68":0,"69":0,"70":0.00549,"71":0.03846,"72":0.07692,"73":0,"74":0.00549,"75":0.03296,"76":0.01099,"77":0.07692,"78":0.13186,"79":0.06043,"80":0.23624,"81":0.07692,"83":0.16482,"84":0.26921,"85":6.02142,"86":7.6916,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.01648,"69":0,"70":0.05494,"71":0.25822,"72":0.00549,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":19.00921,"3.2":0.04554,"4.0-4.1":0.03903,"4.2-4.3":0.00651,"5.0-5.1":0.03253,"6.0-6.1":0.01952,"7.0-7.1":0.04554,"8.1-8.4":0.14963,"9.0-9.2":0.08457,"9.3":1.07992,"10.0-10.2":0.18216,"10.3":1.00185,"11.0-11.2":0.37732,"11.3-11.4":0.64405,"12.0-12.1":0.65706,"12.2-12.4":6.55109,"13.0-13.1":0.53996,"13.2":0.26673,"13.3":2.02973,"13.4-13.7":10.81222},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0.00549,"10":0.00549,"11":0.01099,"12":0.01099,"13":0.19778,"14":1.63172,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.00549,"10.1":0.05494,"11.1":0.1868,"12.1":0.17031,"13.1":3.52165},"edge":{"12":0.00549,"13":0,"14":0.03846,"15":0.00549,"16":0.01099,"17":0.02198,"18":0.1868,"79":0,"80":0,"81":0.00549,"83":0,"84":0.01099,"85":1.20868,"86":2.03278},"android":{"3":0,"4":0.1455,"81":null,"2.1":0,"2.2":0,"2.3":0.00116,"4.1":0.07333,"4.2-4.3":0.03259,"4.4":0,"4.4.3-4.4.4":0.26539},"samsung":{"4":0.03283,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0,"8.2":0,"9.2":0,"10.1":0.0766,"11.1-11.2":0.08755,"12.0":4.62895},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0.11808,"10":0,"11":0.67306,"5.5":0},"bb":{"7":0,"10":0.00451},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.34246},"and_qq":{"10.4":0},"and_uc":{"0":0.00901},"op_mini":{"0":0.0256},"and_chr":{"0":20.17996}},"total":96.9935}

/***/ },
/* 1247 */
/***/ function(module, exports) {

	module.exports = {"id":"IN","name":"India","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0.00353,"43":0.00353,"44":0,"45":0,"46":0,"47":0.00706,"48":0.00353,"49":0,"50":0,"51":0,"52":0.01412,"53":0,"54":0,"55":0,"56":0.00353,"57":0,"58":0,"59":0,"60":0.00353,"61":0,"62":0,"63":0,"64":0,"65":0.00353,"66":0.00353,"67":0,"68":0.01412,"69":0,"70":0,"71":0,"72":0.00353,"73":0,"74":0.00353,"75":0,"76":0.00353,"77":0.00353,"78":0.01412,"79":0.00706,"80":0.02117,"81":0.50112,"82":0.09881,"83":0.01412,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0.00353,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.03176,"50":0,"51":0.00353,"52":0,"53":0,"54":0,"55":0.00353,"56":0.00353,"57":0,"58":0.00706,"59":0,"60":0,"61":0.01059,"62":0,"63":0.01412,"64":0.00353,"65":0.00353,"66":0.00353,"67":0.00353,"68":0.00353,"69":0.01059,"70":0.01412,"71":0.03882,"72":0.01059,"73":0.01059,"74":0.04941,"75":0.01059,"76":0.01059,"77":0.01412,"78":0.02117,"79":0.03529,"80":0.05294,"81":0.03529,"83":0.05294,"84":0.10234,"85":3.57135,"86":5.50524,"87":0.01765,"88":0.01059,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.01412,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.00353,"46":0.00353,"47":0.00353,"48":0,"49":0,"50":0.03882,"51":0.12704,"52":0.1094,"53":0,"54":0.00353,"55":0.01059,"56":0,"57":0,"58":0,"60":0.02117,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.01765,"71":0.12352,"72":0.00353,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":1.10937,"3.2":0.00266,"4.0-4.1":0.00228,"4.2-4.3":0.00038,"5.0-5.1":0.0019,"6.0-6.1":0.00114,"7.0-7.1":0.00266,"8.1-8.4":0.00873,"9.0-9.2":0.00494,"9.3":0.06302,"10.0-10.2":0.01063,"10.3":0.05847,"11.0-11.2":0.02202,"11.3-11.4":0.03759,"12.0-12.1":0.03835,"12.2-12.4":0.38232,"13.0-13.1":0.03151,"13.2":0.01557,"13.3":0.11845,"13.4-13.7":0.63099},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.00353,"13":0.01412,"14":0.10587,"3.1":0,"3.2":0,"5.1":0.0247,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00353,"11.1":0.00353,"12.1":0.01059,"13.1":0.0847},"edge":{"12":0.00353,"13":0,"14":0.00353,"15":0.00353,"16":0.00353,"17":0.00706,"18":0.02823,"79":0,"80":0,"81":0,"83":0,"84":0.00353,"85":0.11646,"86":0.21527},"android":{"3":0,"4":0.02545,"81":null,"2.1":0,"2.2":0,"2.3":0.0002,"4.1":0.01282,"4.2-4.3":0.0057,"4.4":0,"4.4.3-4.4.4":0.04641},"samsung":{"4":0.33557,"5.0-5.4":0.02034,"6.2-6.4":0.03051,"7.2-7.4":0.11186,"8.2":0.02034,"9.2":0.12202,"10.1":0.06101,"11.1-11.2":0.19321,"12.0":0.8135},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00353,"9":0,"10":0,"11":0.03176,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.31061},"baidu":{"0":null},"and_ff":{"0":0.13589},"and_qq":{"10.4":0},"and_uc":{"0":4.53617},"op_mini":{"0":2.53017},"and_chr":{"0":73.22638}},"total":96.63168}

/***/ },
/* 1248 */
/***/ function(module, exports) {

	module.exports = {"id":"IQ","name":"Iraq","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00306,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00306,"48":0,"49":0,"50":0,"51":0,"52":0.00613,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00613,"69":0.00306,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0.00613,"79":0.00919,"80":0.01532,"81":0.39819,"82":0.06126,"83":0.00613,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0.00306,"34":0,"35":0,"36":0,"37":0,"38":0.00613,"39":0,"40":0.00613,"41":0,"42":0,"43":0.03982,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.00613,"50":0,"51":0,"52":0,"53":0.00613,"54":0,"55":0,"56":0.00306,"57":0.00306,"58":0.00306,"59":0,"60":0.00306,"61":0.01838,"62":0,"63":0.02757,"64":0,"65":0.00306,"66":0,"67":0.00306,"68":0.01838,"69":0.00919,"70":0.00919,"71":0.01225,"72":0.00306,"73":0.00613,"74":0.01532,"75":0.00613,"76":0.00613,"77":0.01532,"78":0.01838,"79":0.04288,"80":0.03982,"81":0.06432,"83":0.06432,"84":0.11333,"85":2.34932,"86":3.8747,"87":0.00306,"88":0.00306,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00306,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.04288,"71":0.30324,"72":0.00613,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":7.20984,"3.2":0.01727,"4.0-4.1":0.0148,"4.2-4.3":0.00247,"5.0-5.1":0.01234,"6.0-6.1":0.0074,"7.0-7.1":0.01727,"8.1-8.4":0.05675,"9.0-9.2":0.03208,"9.3":0.40959,"10.0-10.2":0.06909,"10.3":0.37998,"11.0-11.2":0.14311,"11.3-11.4":0.24428,"12.0-12.1":0.24921,"12.2-12.4":2.48471,"13.0-13.1":0.2048,"13.2":0.10116,"13.3":0.76984,"13.4-13.7":4.10087},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.00306,"13":0.02144,"14":0.34918,"3.1":0,"3.2":0,"5.1":0.07351,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0.00306,"12.1":0.00919,"13.1":0.23279},"edge":{"12":0,"13":0,"14":0,"15":0,"16":0.00306,"17":0.00613,"18":0.04288,"79":0,"80":0,"81":0.00306,"83":0,"84":0.00306,"85":0.14702,"86":0.28792},"android":{"3":0,"4":0.06215,"81":null,"2.1":0,"2.2":0,"2.3":0.0005,"4.1":0.03132,"4.2-4.3":0.01392,"4.4":0,"4.4.3-4.4.4":0.11336},"samsung":{"4":0.13451,"5.0-5.4":0.01035,"6.2-6.4":0.01035,"7.2-7.4":0.13451,"8.2":0.01035,"9.2":0.24832,"10.1":0.11381,"11.1-11.2":0.38283,"12.0":4.43874},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01575,"9":0,"10":0,"11":0.05776,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.06937},"and_qq":{"10.4":0.00694},"and_uc":{"0":0.36766},"op_mini":{"0":0.22986},"and_chr":{"0":66.00078}},"total":97.84433}

/***/ },
/* 1249 */
/***/ function(module, exports) {

	module.exports = {"id":"IR","name":"Iran, Islamic Republic of","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":null,"3":0.00317,"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":0.01585,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":0.00317,"26":null,"27":0.00634,"28":null,"29":0.01585,"30":0.00951,"31":0.00951,"32":0.00634,"33":0.02219,"34":0.00634,"35":0.00634,"36":null,"37":0.00634,"38":0.00634,"39":0.00634,"40":0.00634,"41":0.00951,"42":0.00634,"43":0.02853,"44":0.00634,"45":0.00951,"46":0.00634,"47":0.04755,"48":0.01585,"49":0.01268,"50":0.00951,"51":0.00317,"52":0.26628,"53":0.00634,"54":0.00951,"55":0.00951,"56":0.02219,"57":0.00951,"58":0.00634,"59":0.00634,"60":0.01585,"61":0.00634,"62":0.00951,"63":0.02219,"64":0.02853,"65":0.02219,"66":0.01585,"67":0.00634,"68":0.03487,"69":0.00951,"70":0.00951,"71":0.00951,"72":0.06657,"73":0.00951,"74":0.00951,"75":0.01902,"76":0.01902,"77":0.02219,"78":0.18069,"79":0.04755,"80":0.17752,"81":4.38094,"82":0.64034,"83":0.02219,"84":null,"3.5":null,"3.6":null},"chrome":{"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":0.00317,"12":null,"13":0.80518,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":0.01585,"30":0.00634,"31":0.00634,"32":null,"33":0.00951,"34":0.00634,"35":0.01585,"36":null,"37":null,"38":0.01902,"39":0.00951,"40":0.01268,"41":0.00317,"42":0.00317,"43":0.00634,"44":0.00634,"45":0.00317,"46":0.00634,"47":0.00317,"48":0.01268,"49":0.12363,"50":0.00317,"51":0.00951,"52":0.00317,"53":0.01268,"54":0.00951,"55":0.00634,"56":0.00634,"57":0.00634,"58":0.01268,"59":0.00634,"60":0.01268,"61":0.03487,"62":0.01268,"63":0.04755,"64":0.00634,"65":0.00951,"66":0.00634,"67":0.01902,"68":0.01268,"69":0.02853,"70":0.12046,"71":0.1902,"72":0.13314,"73":0.07608,"74":0.01902,"75":0.19971,"76":0.10778,"77":0.03487,"78":0.05389,"79":0.10778,"80":0.25677,"81":0.10461,"83":0.14899,"84":0.24092,"85":5.59822,"86":9.59242,"87":0.00951,"88":0.00317,"89":null},"opera":{"9":null,"11":null,"12":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":0.00634,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":null,"51":null,"52":null,"53":null,"54":null,"55":null,"56":0.00634,"57":0.00634,"58":0.00634,"60":null,"62":null,"63":null,"64":0.00951,"65":null,"66":null,"67":0.00317,"68":0.00634,"69":0.00317,"70":0.0951,"71":0.54841,"72":0.01585,"9.5-9.6":null,"10.0-10.1":0,"10.5":null,"10.6":null,"11.1":null,"11.5":0.00317,"11.6":0.00634,"12.1":0.01585},"ios_saf":{"8":0,"14":1.54618,"3.2":0.0037,"4.0-4.1":0.00317,"4.2-4.3":0.00053,"5.0-5.1":0.00265,"6.0-6.1":0.00159,"7.0-7.1":0.0037,"8.1-8.4":0.01217,"9.0-9.2":0.00688,"9.3":0.08784,"10.0-10.2":0.01482,"10.3":0.08149,"11.0-11.2":0.03069,"11.3-11.4":0.05239,"12.0-12.1":0.05344,"12.2-12.4":0.53285,"13.0-13.1":0.04392,"13.2":0.0217,"13.3":0.1651,"13.4-13.7":0.87945},"safari":{"0":null,"4":0.00634,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":0.00634,"13":0.0317,"14":0.05389,"3.1":null,"3.2":null,"5.1":0.06974,"6.1":null,"7.1":null,"9.1":null,"10.1":null,"11.1":0.00634,"12.1":0.00634,"13.1":0.05706},"edge":{"12":0.02219,"13":0.02219,"14":0.02536,"15":0.01902,"16":0.02536,"17":0.04438,"18":0.22507,"79":null,"80":null,"81":0.00317,"83":0.00634,"84":0.01585,"85":0.18386,"86":0.37406},"android":{"3":0,"4":0.08057,"81":null,"2.1":0,"2.2":0,"2.3":0.00064,"4.1":0.04061,"4.2-4.3":0.01805,"4.4":0,"4.4.3-4.4.4":0.14695},"samsung":{"4":1.98174,"5.0-5.4":0.27299,"6.2-6.4":0.19211,"7.2-7.4":0.80887,"8.2":0.22244,"9.2":1.37508,"10.1":0.75832,"11.1-11.2":1.45597,"12.0":5.40933},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":null,"7":null,"8":1.01318,"9":0.37311,"10":0.0386,"11":2.74684,"5.5":null},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0.01043},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.77851},"and_qq":{"10.4":0},"and_uc":{"0":0.13658},"op_mini":{"0":0.4461},"and_chr":{"0":51.13958}},"total":99.67592}

/***/ },
/* 1250 */
/***/ function(module, exports) {

	module.exports = {"id":"IS","name":"Iceland","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00694,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.02774,"49":0,"50":0,"51":0,"52":0.01387,"53":0,"54":0.00694,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0.00694,"61":0.00694,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00694,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0.01387,"77":0.05548,"78":0.06935,"79":0.01387,"80":0.13177,"81":2.27468,"82":0.42997,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.18725,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00694,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.09016,"50":0,"51":0,"52":0,"53":0.00694,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0.02081,"62":0,"63":0,"64":0,"65":0.03468,"66":0.00694,"67":0.04855,"68":0,"69":0.01387,"70":0.01387,"71":0.00694,"72":0.02774,"73":0.01387,"74":0.02774,"75":0.02081,"76":0.03468,"77":0.01387,"78":0.02774,"79":0.04855,"80":0.1179,"81":0.12483,"83":0.35369,"84":0.57561,"85":14.01564,"86":17.39992,"87":0.00694,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.07629,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0.00694,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.06935,"71":0.64496,"72":0.01387,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":11.90034,"3.2":0.02851,"4.0-4.1":0.02444,"4.2-4.3":0.00407,"5.0-5.1":0.02036,"6.0-6.1":0.01222,"7.0-7.1":0.02851,"8.1-8.4":0.09367,"9.0-9.2":0.05294,"9.3":0.67606,"10.0-10.2":0.11403,"10.3":0.62719,"11.0-11.2":0.23621,"11.3-11.4":0.40319,"12.0-12.1":0.41134,"12.2-12.4":4.10118,"13.0-13.1":0.33803,"13.2":0.16698,"13.3":1.27067,"13.4-13.7":6.76878},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.01387,"11":0.01387,"12":0.14564,"13":0.47852,"14":2.58676,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.00694,"10.1":0.05548,"11.1":0.33982,"12.1":0.42997,"13.1":3.0306},"edge":{"12":0,"13":0,"14":0,"15":0,"16":0,"17":0.02081,"18":0.22886,"79":0,"80":0,"81":0,"83":0,"84":0.00694,"85":0.70044,"86":1.387},"android":{"3":0,"4":0.04082,"81":null,"2.1":0,"2.2":0,"2.3":0.00033,"4.1":0.02057,"4.2-4.3":0.00914,"4.4":0,"4.4.3-4.4.4":0.07446},"samsung":{"4":0.02038,"5.0-5.4":0,"6.2-6.4":0.01019,"7.2-7.4":0.01019,"8.2":0.01019,"9.2":0.02038,"10.1":0.03058,"11.1-11.2":0.08154,"12.0":2.76201},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.38143,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.17164},"and_qq":{"10.4":0},"and_uc":{"0":0.00613},"op_mini":{"0":0.04062},"and_chr":{"0":20.11531}},"total":97.65334}

/***/ },
/* 1251 */
/***/ function(module, exports) {

	module.exports = {"id":"IT","name":"Italy","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.0058,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.0058,"48":0.04057,"49":0,"50":0,"51":0,"52":0.06375,"53":0,"54":0,"55":0,"56":0.02318,"57":0,"58":0,"59":0.0058,"60":0.01159,"61":0,"62":0,"63":0.0058,"64":0.0058,"65":0.0058,"66":0.0058,"67":0,"68":0.02898,"69":0.0058,"70":0.0058,"71":0,"72":0.01159,"73":0,"74":0.0058,"75":0.0058,"76":0.0058,"77":0.01159,"78":0.19703,"79":0.01739,"80":0.08693,"81":2.27744,"82":0.33611,"83":0.0058,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.01739,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.0058,"49":0.24339,"50":0.06375,"51":0,"52":0.01159,"53":0.02898,"54":0,"55":0,"56":0,"57":0,"58":0.0058,"59":0.0058,"60":0,"61":0.06375,"62":0.0058,"63":0.01159,"64":0.0058,"65":0.02318,"66":0.04636,"67":0.02898,"68":0.0058,"69":0.03477,"70":0.03477,"71":0.04636,"72":0.02898,"73":0.02318,"74":0.02898,"75":0.02318,"76":0.01739,"77":0.03477,"78":0.06954,"79":0.05795,"80":0.08113,"81":0.08693,"83":0.10431,"84":0.17385,"85":8.26367,"86":12.99819,"87":0.01159,"88":0.0058,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0.0058,"33":0,"34":0,"35":0,"36":0.0058,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.0058,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.0058,"69":0,"70":0.05795,"71":0.45781,"72":0.01739,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":7.65664,"3.2":0.01834,"4.0-4.1":0.01572,"4.2-4.3":0.00262,"5.0-5.1":0.0131,"6.0-6.1":0.00786,"7.0-7.1":0.01834,"8.1-8.4":0.06027,"9.0-9.2":0.03406,"9.3":0.43498,"10.0-10.2":0.07337,"10.3":0.40353,"11.0-11.2":0.15198,"11.3-11.4":0.25941,"12.0-12.1":0.26465,"12.2-12.4":2.63869,"13.0-13.1":0.21749,"13.2":0.10743,"13.3":0.81755,"13.4-13.7":4.35501},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0.0058,"10":0.0058,"11":0.01159,"12":0.04636,"13":0.22601,"14":1.55306,"3.1":0,"3.2":0,"5.1":0.0058,"6.1":0,"7.1":0,"9.1":0.01159,"10.1":0.02898,"11.1":0.13329,"12.1":0.19703,"13.1":1.36762},"edge":{"12":0,"13":0,"14":0.0058,"15":0.0058,"16":0.0058,"17":0.01739,"18":0.13908,"79":0,"80":0,"81":0,"83":0.0058,"84":0.01159,"85":0.57371,"86":1.14162},"android":{"3":0,"4":0.05426,"81":null,"2.1":0,"2.2":0,"2.3":0.00043,"4.1":0.02735,"4.2-4.3":0.01216,"4.4":0,"4.4.3-4.4.4":0.09898},"samsung":{"4":0.24634,"5.0-5.4":0.01026,"6.2-6.4":0,"7.2-7.4":0.03079,"8.2":0.02053,"9.2":0.09238,"10.1":0.09238,"11.1-11.2":0.18475,"12.0":2.87394},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01893,"9":0.01262,"10":0.00631,"11":0.53005,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.20184},"and_qq":{"10.4":0.03785},"and_uc":{"0":0.14297},"op_mini":{"0":0.16322},"and_chr":{"0":42.96363}},"total":97.30953}

/***/ },
/* 1252 */
/***/ function(module, exports) {

	module.exports = {"id":"JE","name":"Jersey","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.01055,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00528,"49":0,"50":0,"51":0,"52":0.01055,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0.00528,"66":0,"67":0,"68":0.01055,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0.03694,"79":0.10026,"80":0.04749,"81":1.03429,"82":0.16886,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.03694,"50":0,"51":0,"52":0,"53":0.02639,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0.01583,"66":0.00528,"67":0.01055,"68":0,"69":0.00528,"70":0,"71":0.02111,"72":0.03694,"73":0,"74":0,"75":0.00528,"76":0.00528,"77":0.00528,"78":0.01055,"79":0.00528,"80":0.01055,"81":0.03166,"83":0.14248,"84":0.30079,"85":5.48808,"86":6.52765,"87":0.00528,"88":0.00528,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0.00528,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.03166,"71":0.34828,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":22.15181,"3.2":0.05307,"4.0-4.1":0.04549,"4.2-4.3":0.00758,"5.0-5.1":0.03791,"6.0-6.1":0.02274,"7.0-7.1":0.05307,"8.1-8.4":0.17436,"9.0-9.2":0.09855,"9.3":1.25845,"10.0-10.2":0.21227,"10.3":1.16748,"11.0-11.2":0.4397,"11.3-11.4":0.75052,"12.0-12.1":0.76569,"12.2-12.4":7.63411,"13.0-13.1":0.62923,"13.2":0.31082,"13.3":2.36529,"13.4-13.7":12.5997},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00528,"11":0.00528,"12":0.16359,"13":0.26913,"14":2.33771,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.02111,"10.1":0.04749,"11.1":0.09499,"12.1":0.25857,"13.1":3.85749},"edge":{"12":0,"13":0,"14":0,"15":0.01583,"16":0.00528,"17":0.02111,"18":0.24802,"79":0,"80":0,"81":0.00528,"83":0,"84":0.01583,"85":0.9868,"86":1.82584},"android":{"3":0,"4":0.09276,"81":null,"2.1":0,"2.2":0,"2.3":0.00074,"4.1":0.04675,"4.2-4.3":0.02078,"4.4":0,"4.4.3-4.4.4":0.1692},"samsung":{"4":0.16395,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0,"8.2":0,"9.2":0,"10.1":0.01093,"11.1-11.2":0.03279,"12.0":3.41015},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0.00528,"7":0,"8":0,"9":0,"10":0,"11":0.8021,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.16531},"and_qq":{"10.4":0},"and_uc":{"0":0},"op_mini":{"0":0.04919},"and_chr":{"0":17.38062}},"total":97.83005}

/***/ },
/* 1253 */
/***/ function(module, exports) {

	module.exports = {"id":"JM","name":"Jamaica","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.01044,"53":0,"54":0,"55":0.00522,"56":0.00522,"57":0.01044,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.01565,"69":0,"70":0,"71":0,"72":0.00522,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0.05218,"79":0.01044,"80":0.03653,"81":0.83488,"82":0.15132,"83":0.00522,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00522,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00522,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0.05218,"34":0,"35":0.00522,"36":0,"37":0,"38":0.00522,"39":0,"40":0,"41":0,"42":0.00522,"43":0.00522,"44":0,"45":0,"46":0.00522,"47":0.00522,"48":0,"49":0.06783,"50":0,"51":0,"52":0,"53":0.01044,"54":0,"55":0.00522,"56":0,"57":0,"58":0.00522,"59":0,"60":0.00522,"61":0.00522,"62":0.00522,"63":0.01044,"64":0,"65":0.04174,"66":0,"67":0.01044,"68":0,"69":0.02609,"70":0.03131,"71":0.01044,"72":0.00522,"73":0.00522,"74":0.02087,"75":0.04174,"76":0.05218,"77":0.04696,"78":0.02609,"79":0.04696,"80":0.10958,"81":0.08349,"83":0.09392,"84":0.17219,"85":6.36074,"86":10.12814,"87":0.03653,"88":0.02087,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00522,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.03131,"71":0.38613,"72":0.01565,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":6.7846,"3.2":0.01625,"4.0-4.1":0.01393,"4.2-4.3":0.00232,"5.0-5.1":0.01161,"6.0-6.1":0.00697,"7.0-7.1":0.01625,"8.1-8.4":0.0534,"9.0-9.2":0.03018,"9.3":0.38544,"10.0-10.2":0.06501,"10.3":0.35757,"11.0-11.2":0.13467,"11.3-11.4":0.22987,"12.0-12.1":0.23451,"12.2-12.4":2.33816,"13.0-13.1":0.19272,"13.2":0.0952,"13.3":0.72443,"13.4-13.7":3.859},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.01044,"13":0.10436,"14":0.65225,"3.1":0,"3.2":0,"5.1":0.08871,"6.1":0,"7.1":0,"9.1":0.01044,"10.1":0.01044,"11.1":0.04174,"12.1":0.08871,"13.1":0.69399},"edge":{"12":0.01044,"13":0.01044,"14":0.01565,"15":0.02609,"16":0.03653,"17":0.04174,"18":0.23481,"79":0,"80":0.00522,"81":0.00522,"83":0.00522,"84":0.01565,"85":0.7253,"86":1.47669},"android":{"3":0,"4":0.44252,"81":null,"2.1":0,"2.2":0,"2.3":0.00354,"4.1":0.22303,"4.2-4.3":0.09912,"4.4":0,"4.4.3-4.4.4":0.80716},"samsung":{"4":0.1277,"5.0-5.4":0.01064,"6.2-6.4":0,"7.2-7.4":0.15963,"8.2":0.03193,"9.2":0.13835,"10.1":0.06385,"11.1-11.2":0.22348,"12.0":3.67148},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.04563,"9":0.0057,"10":0.0057,"11":0.18821,"5.5":0},"bb":{"7":0,"10":0.00478},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.00478},"baidu":{"0":null},"and_ff":{"0":0.1339},"and_qq":{"10.4":0.00478},"and_uc":{"0":0.4782},"op_mini":{"0":0.18562},"and_chr":{"0":50.98185}},"total":97.06429}

/***/ },
/* 1254 */
/***/ function(module, exports) {

	module.exports = {"id":"JO","name":"Jordan","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.00451,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00451,"49":0,"50":0,"51":0,"52":0.00901,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0.00451,"60":0,"61":0,"62":0,"63":0.01802,"64":0,"65":0,"66":0,"67":0,"68":0.01352,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0.00451,"78":0.11713,"79":0.00451,"80":0.03604,"81":0.74783,"82":0.09911,"83":0.00451,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0.00451,"33":0.00901,"34":0,"35":0,"36":0,"37":0.00451,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00451,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.06307,"50":0,"51":0,"52":0,"53":0.00451,"54":0.00451,"55":0,"56":0,"57":0.00451,"58":0.00451,"59":0,"60":0,"61":0.00451,"62":0,"63":0.02253,"64":0,"65":0.00901,"66":0.01352,"67":0.03154,"68":0,"69":0.00901,"70":0.01802,"71":0.02703,"72":0.01802,"73":0.00901,"74":0.02253,"75":0.04055,"76":0.02253,"77":0.02253,"78":0.04055,"79":0.09461,"80":0.04956,"81":0.05406,"83":0.0901,"84":0.16218,"85":5.72586,"86":9.03703,"87":0.01352,"88":0.00451,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0.00451,"60":0.00451,"62":0,"63":0.00451,"64":0,"65":0,"66":0,"67":0,"68":0.00451,"69":0,"70":0.10362,"71":0.65323,"72":0.00901,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":5.50315,"3.2":0.01318,"4.0-4.1":0.0113,"4.2-4.3":0.00188,"5.0-5.1":0.00942,"6.0-6.1":0.00565,"7.0-7.1":0.01318,"8.1-8.4":0.04332,"9.0-9.2":0.02448,"9.3":0.31264,"10.0-10.2":0.05273,"10.3":0.29004,"11.0-11.2":0.10923,"11.3-11.4":0.18645,"12.0-12.1":0.19022,"12.2-12.4":1.89653,"13.0-13.1":0.15632,"13.2":0.07722,"13.3":0.58761,"13.4-13.7":3.13013},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.01352,"13":0.06758,"14":0.40545,"3.1":0,"3.2":0,"5.1":0.11263,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00451,"11.1":0.02703,"12.1":0.15768,"13.1":0.38743},"edge":{"12":0,"13":0,"14":0,"15":0.00451,"16":0,"17":0.00901,"18":0.06307,"79":0,"80":0,"81":0,"83":0,"84":0.00901,"85":0.31986,"86":0.72531},"android":{"3":0,"4":0.03034,"81":null,"2.1":0,"2.2":0,"2.3":0.00024,"4.1":0.01529,"4.2-4.3":0.0068,"4.4":0,"4.4.3-4.4.4":0.05535},"samsung":{"4":0.15155,"5.0-5.4":0.02021,"6.2-6.4":0.02021,"7.2-7.4":0.16165,"8.2":0.0101,"9.2":0.17175,"10.1":0.06062,"11.1-11.2":0.28289,"12.0":1.99031},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.03339,"9":0,"10":0,"11":0.0477,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.09891},"and_qq":{"10.4":0},"and_uc":{"0":0.28574},"op_mini":{"0":0.21329},"and_chr":{"0":62.11913}},"total":98.19434}

/***/ },
/* 1255 */
/***/ function(module, exports) {

	module.exports = {"id":"JP","name":"Japan","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.01187,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.00594,"46":0,"47":0.00594,"48":0.02969,"49":0,"50":0,"51":0,"52":0.0475,"53":0.00594,"54":0,"55":0.00594,"56":0.02969,"57":0.00594,"58":0,"59":0,"60":0.01187,"61":0,"62":0.00594,"63":0.01187,"64":0.00594,"65":0.00594,"66":0.01187,"67":0.00594,"68":0.09499,"69":0,"70":0.00594,"71":0,"72":0.01187,"73":0,"74":0.00594,"75":0.00594,"76":0.00594,"77":0.02969,"78":0.10687,"79":0.01781,"80":0.07124,"81":1.65642,"82":0.24342,"83":0.00594,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00594,"44":0,"45":0,"46":0.00594,"47":0.01187,"48":0.00594,"49":0.30279,"50":0.00594,"51":0,"52":0.00594,"53":0.00594,"54":0.00594,"55":0.01187,"56":0.01187,"57":0.01187,"58":0.00594,"59":0.00594,"60":0.00594,"61":0.06531,"62":0.01781,"63":0.00594,"64":0.00594,"65":0.03562,"66":0.01187,"67":0.0475,"68":0.01187,"69":0.07124,"70":0.04156,"71":0.04156,"72":0.03562,"73":0.02969,"74":0.04156,"75":0.03562,"76":0.02375,"77":0.02375,"78":0.0475,"79":0.07124,"80":0.12468,"81":0.14249,"83":0.17217,"84":0.29685,"85":6.691,"86":9.35078,"87":0.01781,"88":0.00594,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00594,"52":0,"53":0,"54":0,"55":0,"56":0.00594,"57":0,"58":0.00594,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.02969,"71":0.13655,"72":0.00594,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":17.7783,"3.2":0.04259,"4.0-4.1":0.03651,"4.2-4.3":0.00608,"5.0-5.1":0.03042,"6.0-6.1":0.01825,"7.0-7.1":0.04259,"8.1-8.4":0.13994,"9.0-9.2":0.0791,"9.3":1.00999,"10.0-10.2":0.17036,"10.3":0.93698,"11.0-11.2":0.35289,"11.3-11.4":0.60234,"12.0-12.1":0.61451,"12.2-12.4":6.12688,"13.0-13.1":0.505,"13.2":0.24946,"13.3":1.8983,"13.4-13.7":10.11209},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0.00594,"9":0.00594,"10":0.00594,"11":0.02375,"12":0.03562,"13":0.1603,"14":1.16959,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.01187,"10.1":0.02969,"11.1":0.1128,"12.1":0.17811,"13.1":1.43675},"edge":{"12":0,"13":0,"14":0.00594,"15":0.00594,"16":0.01187,"17":0.04156,"18":0.30872,"79":0,"80":0,"81":0.00594,"83":0.00594,"84":0.01187,"85":1.30614,"86":2.63009},"android":{"3":0,"4":0.17302,"81":null,"2.1":0,"2.2":0,"2.3":0.00138,"4.1":0.0872,"4.2-4.3":0.03876,"4.4":0,"4.4.3-4.4.4":0.31558},"samsung":{"4":0,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0,"8.2":0,"9.2":0.02174,"10.1":0.02174,"11.1-11.2":0.04348,"12.0":1.15225},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.02642,"9":0.01982,"10":0.00661,"11":2.9394,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.19096},"and_qq":{"10.4":0.10158},"and_uc":{"0":0.30066},"op_mini":{"0":0.12694},"and_chr":{"0":23.89083}},"total":98.25743}

/***/ },
/* 1256 */
/***/ function(module, exports) {

	module.exports = {"id":"KE","name":"Kenya","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0.00357,"33":0,"34":0.00357,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00357,"48":0.00357,"49":0,"50":0.00357,"51":0,"52":0.02144,"53":0,"54":0,"55":0,"56":0,"57":0.00357,"58":0,"59":0,"60":0.00357,"61":0.00357,"62":0,"63":0.00357,"64":0,"65":0,"66":0.00357,"67":0.00715,"68":0.03931,"69":0.00357,"70":0,"71":0.00357,"72":0.00715,"73":0.00357,"74":0.00357,"75":0.00357,"76":0.00357,"77":0.0143,"78":0.04289,"79":0.0143,"80":0.04646,"81":1.04003,"82":0.20372,"83":0.02502,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00357,"39":0.00357,"40":0.00357,"41":0,"42":0.00357,"43":0,"44":0,"45":0,"46":0,"47":0.00357,"48":0,"49":0.03217,"50":0.00357,"51":0.00357,"52":0,"53":0.00715,"54":0,"55":0.00357,"56":0,"57":0.00357,"58":0.00357,"59":0,"60":0,"61":0,"62":0,"63":0.00715,"64":0.00357,"65":0.01072,"66":0.00715,"67":0.01072,"68":0.00715,"69":0.00715,"70":0.00715,"71":0.01072,"72":0.01072,"73":0.01072,"74":0.02144,"75":0.00715,"76":0.0143,"77":0.01072,"78":0.02144,"79":0.02859,"80":0.04646,"81":0.05718,"83":0.06076,"84":0.12509,"85":2.93425,"86":4.74627,"87":0.01072,"88":0.00357,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0.00357,"16":0.00357,"17":0,"18":0,"19":0.00357,"20":0.01072,"21":0.00357,"22":0,"23":0.02502,"24":0.07863,"25":0.00715,"26":0.06076,"27":0.08935,"28":0.05361,"29":0.01072,"30":0.05004,"31":0.03217,"32":0.05718,"33":0.05004,"34":0,"35":0.01072,"36":0.00357,"37":0.0143,"38":0.03931,"39":0.00357,"40":0,"41":0.00357,"42":0.03574,"43":0.00357,"44":0.00357,"45":0.02502,"46":0.16798,"47":0.11794,"48":0,"49":0,"50":0.53253,"51":1.49393,"52":0.00357,"53":0.01072,"54":0.0143,"55":0,"56":0.00357,"57":0,"58":0.00715,"60":0.07505,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.06433,"71":0.41101,"72":0.01072,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.10007},"ios_saf":{"8":0,"14":1.20369,"3.2":0.00288,"4.0-4.1":0.00247,"4.2-4.3":0.00041,"5.0-5.1":0.00206,"6.0-6.1":0.00124,"7.0-7.1":0.00288,"8.1-8.4":0.00947,"9.0-9.2":0.00536,"9.3":0.06838,"10.0-10.2":0.01153,"10.3":0.06344,"11.0-11.2":0.02389,"11.3-11.4":0.04078,"12.0-12.1":0.04161,"12.2-12.4":0.41482,"13.0-13.1":0.03419,"13.2":0.01689,"13.3":0.12853,"13.4-13.7":0.68464},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.00715,"13":0.02144,"14":0.13581,"3.1":0,"3.2":0,"5.1":0.06791,"6.1":0,"7.1":0,"9.1":0.00357,"10.1":0.00357,"11.1":0.0143,"12.1":0.03574,"13.1":0.15726},"edge":{"12":0.00715,"13":0.00357,"14":0.00715,"15":0.02502,"16":0.00357,"17":0.00715,"18":0.07505,"79":0,"80":0,"81":0,"83":0.00357,"84":0.00715,"85":0.18227,"86":0.35025},"android":{"3":0,"4":0.06241,"81":null,"2.1":0,"2.2":0,"2.3":0.0005,"4.1":0.03145,"4.2-4.3":0.01398,"4.4":0,"4.4.3-4.4.4":0.11383},"samsung":{"4":0.21389,"5.0-5.4":0.01019,"6.2-6.4":0.01019,"7.2-7.4":0.05093,"8.2":0,"9.2":0.0713,"10.1":0.0713,"11.1-11.2":0.10185,"12.0":0.96762},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00484,"9":0,"10":0.00484,"11":0.07253,"5.5":0},"bb":{"7":0,"10":0.01928},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.21848},"and_qq":{"10.4":0.00643},"and_uc":{"0":0.41769},"op_mini":{"0":23.1729},"and_chr":{"0":49.18416}},"total":92.16865}

/***/ },
/* 1257 */
/***/ function(module, exports) {

	module.exports = {"id":"KG","name":"Kyrgyzstan","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.02691,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0.02691,"66":0.00673,"67":0,"68":0,"69":0,"70":0,"71":0,"72":0.00673,"73":0,"74":0.00673,"75":0,"76":0,"77":0,"78":0.02018,"79":0.00673,"80":0.03364,"81":0.6727,"82":0.10091,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.11436,"50":0,"51":0.00673,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0.00673,"59":0.01345,"60":0.00673,"61":0,"62":0,"63":0.00673,"64":0.00673,"65":0.01345,"66":0.02018,"67":0.01345,"68":0.01345,"69":0.00673,"70":0.01345,"71":0.06054,"72":0.01345,"73":0.10763,"74":0.02691,"75":0.02691,"76":0.04036,"77":0.03364,"78":0.02018,"79":0.074,"80":0.15472,"81":0.05382,"83":0.1749,"84":0.32962,"85":19.62266,"86":14.22088,"87":0.05382,"88":0.03364,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00673,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0.00673,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0.00673,"68":0.01345,"69":0,"70":0.3229,"71":2.12573,"72":0.04709,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":2.43133,"3.2":0.00582,"4.0-4.1":0.00499,"4.2-4.3":0.00083,"5.0-5.1":0.00416,"6.0-6.1":0.0025,"7.0-7.1":0.00582,"8.1-8.4":0.01914,"9.0-9.2":0.01082,"9.3":0.13812,"10.0-10.2":0.0233,"10.3":0.12814,"11.0-11.2":0.04826,"11.3-11.4":0.08238,"12.0-12.1":0.08404,"12.2-12.4":0.8379,"13.0-13.1":0.06906,"13.2":0.03412,"13.3":0.25961,"13.4-13.7":1.38291},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0.12109,"14":0.64579,"3.1":0,"3.2":0,"5.1":2.15937,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00673,"11.1":0.04709,"12.1":0.04036,"13.1":0.3498},"edge":{"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0.04036,"79":0,"80":0,"81":0,"83":0,"84":0.00673,"85":0.12109,"86":0.18836},"android":{"3":0,"4":0.02911,"81":null,"2.1":0,"2.2":0,"2.3":0.00023,"4.1":0.01467,"4.2-4.3":0.00652,"4.4":0,"4.4.3-4.4.4":0.0531},"samsung":{"4":0.46673,"5.0-5.4":0.03044,"6.2-6.4":0.10146,"7.2-7.4":0.14205,"8.2":0.04059,"9.2":0.14205,"10.1":0.11161,"11.1-11.2":0.24351,"12.0":1.15668},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00942,"9":0,"10":0.00942,"11":0.16952,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.02291},"and_qq":{"10.4":0.00655},"and_uc":{"0":0.46477},"op_mini":{"0":0.24789},"and_chr":{"0":43.83272}},"total":95.32935}

/***/ },
/* 1258 */
/***/ function(module, exports) {

	module.exports = {"id":"KH","name":"Cambodia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0.00706,"5":0.00706,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0.00706,"16":0,"17":0.01411,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.01411,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00706,"44":0,"45":0,"46":0,"47":0.00706,"48":0.01411,"49":0,"50":0.00706,"51":0,"52":0.01411,"53":0,"54":0.00706,"55":0.00706,"56":0.01411,"57":0.00706,"58":0.00706,"59":0,"60":0.00706,"61":0.02822,"62":0.02822,"63":0.04939,"64":0.02822,"65":0.03528,"66":0.01411,"67":0.00706,"68":0.02117,"69":0.04939,"70":0.02117,"71":0.00706,"72":0.03528,"73":0.00706,"74":0.00706,"75":0,"76":0.03528,"77":0.02117,"78":0.05644,"79":0.02822,"80":0.07761,"81":3.1042,"82":0.50796,"83":0.0635,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0.00706,"24":0.01411,"25":0.00706,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00706,"39":0,"40":0,"41":0.00706,"42":0,"43":0.01411,"44":0,"45":0,"46":0,"47":0,"48":0.03528,"49":0.04939,"50":0,"51":0,"52":0.00706,"53":0.02822,"54":0,"55":0.01411,"56":0.01411,"57":0,"58":0.00706,"59":0,"60":0,"61":0.00706,"62":0.00706,"63":0.03528,"64":0.00706,"65":0.01411,"66":0.00706,"67":0.02822,"68":0.02117,"69":0.01411,"70":0.24693,"71":0.23987,"72":0.23282,"73":0.28926,"74":0.11288,"75":0.05644,"76":0.02117,"77":0.03528,"78":0.10583,"79":0.18343,"80":0.2822,"81":0.16932,"83":0.15521,"84":0.2822,"85":13.08703,"86":22.05393,"87":0.07761,"88":0.07055,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00706,"37":0.01411,"38":0,"39":0,"40":0.00706,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0.00706,"55":0.02117,"56":0.01411,"57":0.01411,"58":0.02822,"60":0.00706,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00706,"69":0,"70":0.10583,"71":0.75489,"72":0.01411,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":8.60468,"3.2":0.02061,"4.0-4.1":0.01767,"4.2-4.3":0.00294,"5.0-5.1":0.01472,"6.0-6.1":0.00883,"7.0-7.1":0.02061,"8.1-8.4":0.06773,"9.0-9.2":0.03828,"9.3":0.48884,"10.0-10.2":0.08245,"10.3":0.4535,"11.0-11.2":0.1708,"11.3-11.4":0.29153,"12.0-12.1":0.29742,"12.2-12.4":2.96541,"13.0-13.1":0.24442,"13.2":0.12074,"13.3":0.91878,"13.4-13.7":4.89424},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00706,"12":0.03528,"13":0.23987,"14":0.76194,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00706,"11.1":0.03528,"12.1":0.19754,"13.1":1.1288},"edge":{"12":0.00706,"13":0,"14":0.02117,"15":0.00706,"16":0.01411,"17":0.02117,"18":0.14816,"79":0,"80":0,"81":0,"83":0,"84":0.01411,"85":0.55029,"86":1.15702},"android":{"3":0,"4":0.05587,"81":null,"2.1":0,"2.2":0,"2.3":0.00045,"4.1":0.02816,"4.2-4.3":0.01252,"4.4":0,"4.4.3-4.4.4":0.10191},"samsung":{"4":0.13144,"5.0-5.4":0.03033,"6.2-6.4":0,"7.2-7.4":0.02022,"8.2":0.01011,"9.2":0.05055,"10.1":0.05055,"11.1-11.2":0.05055,"12.0":0.93016},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.10159,"9":0.01129,"10":0.03386,"11":0.30478,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.00295},"baidu":{"0":null},"and_ff":{"0":0.10308},"and_qq":{"10.4":0.13842},"and_uc":{"0":0.59489},"op_mini":{"0":0.47677},"and_chr":{"0":26.89369}},"total":97.64923}

/***/ },
/* 1259 */
/***/ function(module, exports) {

	module.exports = {"id":"KI","name":"Kiribati","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00424,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0.02118,"55":0,"56":0.0593,"57":0.00424,"58":0,"59":0.00424,"60":0.00847,"61":0,"62":0,"63":0,"64":0.00424,"65":0,"66":0.00424,"67":0,"68":0.0466,"69":0.00847,"70":0.00847,"71":0.00847,"72":0.02542,"73":0.00424,"74":0,"75":0,"76":0,"77":0.0466,"78":0.02118,"79":0,"80":0.03389,"81":0.82178,"82":0.09319,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.01271,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0.00424,"58":0,"59":0.01694,"60":0,"61":0,"62":0,"63":0.01694,"64":0.00847,"65":0.06354,"66":0.02542,"67":0.04236,"68":0.00424,"69":0.02542,"70":0,"71":0.00424,"72":0,"73":0.00847,"74":0.00424,"75":0.00424,"76":0.02118,"77":0.01271,"78":0,"79":0.08896,"80":0.13132,"81":0.05083,"83":0.17368,"84":0.81755,"85":3.35068,"86":5.32042,"87":0.02118,"88":0,"89":0},"opera":{"9":0,"11":0.00424,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.0466,"71":0.52526,"72":0.44054,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":2.96291,"3.2":0.0071,"4.0-4.1":0.00608,"4.2-4.3":0.00101,"5.0-5.1":0.00507,"6.0-6.1":0.00304,"7.0-7.1":0.0071,"8.1-8.4":0.02332,"9.0-9.2":0.01318,"9.3":0.16832,"10.0-10.2":0.02839,"10.3":0.15616,"11.0-11.2":0.05881,"11.3-11.4":0.10039,"12.0-12.1":0.10241,"12.2-12.4":1.0211,"13.0-13.1":0.08416,"13.2":0.04157,"13.3":0.31637,"13.4-13.7":1.68527},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0.01694,"14":0.00424,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0,"12.1":0.00424,"13.1":2.3891},"edge":{"12":0.01271,"13":0.03389,"14":0.02965,"15":0.09743,"16":0.34735,"17":0.08896,"18":0.34312,"79":0,"80":0.00847,"81":0,"83":0.01694,"84":0.02965,"85":0.26263,"86":0.29228},"android":{"3":0,"4":0.13711,"81":null,"2.1":0,"2.2":0,"2.3":0.0011,"4.1":0.06911,"4.2-4.3":0.03071,"4.4":0,"4.4.3-4.4.4":0.25009},"samsung":{"4":0.90489,"5.0-5.4":0.08134,"6.2-6.4":0.0305,"7.2-7.4":0.68121,"8.2":0.12201,"9.2":0.15251,"10.1":0.09151,"11.1-11.2":0.48803,"12.0":0.48803},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.11014,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.10375},"and_qq":{"10.4":0},"and_uc":{"0":0.57064},"op_mini":{"0":0.09277},"and_chr":{"0":70.61509}},"total":98.26498}

/***/ },
/* 1260 */
/***/ function(module, exports) {

	module.exports = {"id":"KM","name":"Comoros","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00728,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.01821,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0.00728,"57":0.00364,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00364,"69":0,"70":0,"71":0,"72":0.00364,"73":0,"74":0.01093,"75":0,"76":0,"77":0,"78":0.00728,"79":0.1129,"80":0.28043,"81":1.24192,"82":0.55723,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0.00364,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0.00364,"40":0,"41":0,"42":0,"43":0.01457,"44":0,"45":0,"46":0.00728,"47":0,"48":0,"49":0.00364,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0.00364,"56":0,"57":0,"58":0.01093,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0.00364,"65":0,"66":0,"67":0,"68":0,"69":0.06556,"70":0,"71":0,"72":0,"73":0.01093,"74":0.01093,"75":0.09105,"76":0.02549,"77":0.0437,"78":0.02549,"79":0.03278,"80":0.01457,"81":0.10198,"83":0.01093,"84":0.03642,"85":1.44587,"86":4.53793,"87":0.00728,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0.00364,"22":0,"23":0,"24":0,"25":0,"26":0.01093,"27":0,"28":0.01093,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.00728,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.0437,"44":0,"45":0,"46":0.00364,"47":0,"48":0,"49":0,"50":0.00364,"51":0.00728,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.01457,"62":0,"63":0,"64":0.00364,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.15296,"71":0.99791,"72":0.01457,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00728},"ios_saf":{"8":0,"14":2.8657,"3.2":0.00687,"4.0-4.1":0.00588,"4.2-4.3":0.00098,"5.0-5.1":0.0049,"6.0-6.1":0.00294,"7.0-7.1":0.00687,"8.1-8.4":0.02256,"9.0-9.2":0.01275,"9.3":0.1628,"10.0-10.2":0.02746,"10.3":0.15103,"11.0-11.2":0.05688,"11.3-11.4":0.09709,"12.0-12.1":0.09905,"12.2-12.4":0.9876,"13.0-13.1":0.0814,"13.2":0.04021,"13.3":0.30599,"13.4-13.7":1.62998},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0.00728,"14":0.04006,"3.1":0,"3.2":0,"5.1":0.08741,"6.1":0,"7.1":0,"9.1":0.00728,"10.1":0.00364,"11.1":0,"12.1":0,"13.1":0.08741},"edge":{"12":0.03278,"13":0.02549,"14":0.00728,"15":0.04735,"16":0.00728,"17":0.03278,"18":0.0437,"79":0,"80":0,"81":0,"83":0,"84":0.01457,"85":0.32778,"86":0.32414},"android":{"3":0,"4":0.23524,"81":null,"2.1":0,"2.2":0,"2.3":0.00188,"4.1":0.11856,"4.2-4.3":0.05269,"4.4":0,"4.4.3-4.4.4":0.42909},"samsung":{"4":0.55333,"5.0-5.4":0.14346,"6.2-6.4":0.01025,"7.2-7.4":0.18444,"8.2":0,"9.2":0.20494,"10.1":0.19469,"11.1-11.2":0.08197,"12.0":0.73777},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.05099,"9":0.00364,"10":0.00364,"11":0.05827,"5.5":0},"bb":{"7":0,"10":0.01907},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.02543},"and_qq":{"10.4":0.02543},"and_uc":{"0":0.45142},"op_mini":{"0":0.92698},"and_chr":{"0":75.7111}},"total":97.93769}

/***/ },
/* 1261 */
/***/ function(module, exports) {

	module.exports = {"id":"KN","name":"Saint Kitts and Nevis","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0.00528,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0.00528,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.00528,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00528,"69":0,"70":0,"71":0,"72":0.00528,"73":0.00528,"74":0.00528,"75":0,"76":0,"77":0,"78":0.00528,"79":0,"80":0.01585,"81":0.80302,"82":0.36453,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00528,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00528,"49":0.04755,"50":0.00528,"51":0,"52":0,"53":0.03698,"54":0.00528,"55":0,"56":0.00528,"57":0,"58":0,"59":0,"60":0,"61":0.00528,"62":0,"63":0.01057,"64":0,"65":0,"66":0,"67":0.00528,"68":0,"69":0,"70":0.01057,"71":0,"72":0,"73":0.00528,"74":0,"75":0.19019,"76":0.01057,"77":0,"78":0,"79":0.01057,"80":0.04226,"81":0.02642,"83":0.02113,"84":0.17434,"85":6.36073,"86":10.006,"87":0.01057,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.00528,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.01585,"71":0.15321,"72":0.00528,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":6.10355,"3.2":0.01462,"4.0-4.1":0.01253,"4.2-4.3":0.00209,"5.0-5.1":0.01044,"6.0-6.1":0.00627,"7.0-7.1":0.01462,"8.1-8.4":0.04804,"9.0-9.2":0.02715,"9.3":0.34675,"10.0-10.2":0.05849,"10.3":0.32168,"11.0-11.2":0.12115,"11.3-11.4":0.20679,"12.0-12.1":0.21097,"12.2-12.4":2.10345,"13.0-13.1":0.17337,"13.2":0.08564,"13.3":0.65171,"13.4-13.7":3.47163},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0.01585,"10":0,"11":0,"12":0.01585,"13":0.06868,"14":1.48981,"3.1":0,"3.2":0,"5.1":0.05283,"6.1":0,"7.1":0,"9.1":0,"10.1":0.01057,"11.1":0.02113,"12.1":0.05811,"13.1":0.72377},"edge":{"12":0,"13":0.01057,"14":0.00528,"15":0.01057,"16":0.00528,"17":0.0317,"18":0.36981,"79":0,"80":0,"81":0,"83":0.00528,"84":0.00528,"85":1.37886,"86":1.74339},"android":{"3":0,"4":0.59328,"81":null,"2.1":0,"2.2":0,"2.3":0.00475,"4.1":0.29901,"4.2-4.3":0.13289,"4.4":0,"4.4.3-4.4.4":1.08214},"samsung":{"4":0.03194,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.07454,"8.2":0,"9.2":0.06389,"10.1":0,"11.1-11.2":0.35139,"12.0":5.20697},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00528,"9":0.00528,"10":0,"11":0.59698,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.37264},"and_qq":{"10.4":0},"and_uc":{"0":0.07547},"op_mini":{"0":0.17863},"and_chr":{"0":49.05271}},"total":96.5473}

/***/ },
/* 1262 */
/***/ function(module, exports) {

	module.exports = {"id":"KP","name":"Korea, Democratic People's Republic of","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":null,"3":null,"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":null,"51":0.1771,"52":15.20404,"53":null,"54":null,"55":null,"56":null,"57":null,"58":null,"59":null,"60":null,"61":null,"62":null,"63":null,"64":null,"65":null,"66":null,"67":null,"68":null,"69":null,"70":null,"71":null,"72":null,"73":null,"74":0.54016,"75":null,"76":null,"77":null,"78":2.14291,"79":null,"80":null,"81":15.38114,"82":null,"83":null,"84":null,"3.5":null,"3.6":null},"chrome":{"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":null,"51":null,"52":null,"53":null,"54":null,"55":null,"56":0.1771,"57":null,"58":0.71726,"59":null,"60":null,"61":null,"62":null,"63":null,"64":null,"65":0.3542,"66":null,"67":null,"68":null,"69":null,"70":null,"71":null,"72":null,"73":null,"74":null,"75":null,"76":null,"77":0.3542,"78":null,"79":null,"80":0.1771,"81":0.89436,"83":3.57742,"84":14.13258,"85":8.0492,"86":8.0492,"87":null,"88":null,"89":null},"opera":{"9":null,"11":null,"12":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":null,"51":null,"52":null,"53":null,"54":null,"55":null,"56":0.1771,"57":null,"58":null,"60":null,"62":null,"63":1.61161,"64":null,"65":null,"66":null,"67":null,"68":null,"69":null,"70":2.14291,"71":0.54016,"72":null,"9.5-9.6":null,"10.0-10.1":0,"10.5":null,"10.6":null,"11.1":null,"11.5":null,"11.6":null,"12.1":null},"ios_saf":{"8":0,"14":1.47404,"3.2":0.00353,"4.0-4.1":0.00303,"4.2-4.3":0.0005,"5.0-5.1":0.00252,"6.0-6.1":0.00151,"7.0-7.1":0.00353,"8.1-8.4":0.0116,"9.0-9.2":0.00656,"9.3":0.08374,"10.0-10.2":0.01412,"10.3":0.07769,"11.0-11.2":0.02926,"11.3-11.4":0.04994,"12.0-12.1":0.05095,"12.2-12.4":0.50799,"13.0-13.1":0.04187,"13.2":0.02068,"13.3":0.15739,"13.4-13.7":0.83842},"safari":{"0":null,"4":0,"5":null,"6":null,"7":null,"8":null,"9":null,"10":0.1771,"11":null,"12":null,"13":0.3542,"14":3.40032,"3.1":null,"3.2":null,"5.1":null,"6.1":null,"7.1":null,"9.1":null,"10.1":0.54016,"11.1":null,"12.1":null,"13.1":0.71726},"edge":{"12":null,"13":null,"14":0.3542,"15":null,"16":null,"17":null,"18":1.07146,"79":null,"80":null,"81":null,"83":null,"84":null,"85":null,"86":1.24856},"android":{"3":0,"4":0.10549,"81":null,"2.1":0,"2.2":0,"2.3":0.00084,"4.1":0.05317,"4.2-4.3":0.02363,"4.4":0,"4.4.3-4.4.4":0.19242},"samsung":{"4":0.90489,"5.0-5.4":0.08134,"6.2-6.4":0.0305,"7.2-7.4":0.68121,"8.2":0.12201,"9.2":0.15251,"10.1":0.09151,"11.1-11.2":0.48803,"12.0":0.37556},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"5.5":null},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0},"and_qq":{"10.4":0},"and_uc":{"0":0},"op_mini":{"0":0.17778},"and_chr":{"0":7.82925}},"total":96.95202}

/***/ },
/* 1263 */
/***/ function(module, exports) {

	module.exports = {"id":"KR","name":"Korea, Republic of","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":null,"3":null,"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":null,"51":null,"52":0.01647,"53":null,"54":null,"55":null,"56":null,"57":null,"58":null,"59":null,"60":0.00549,"61":null,"62":null,"63":0.01647,"64":0.01647,"65":0.01098,"66":0.00549,"67":null,"68":null,"69":null,"70":null,"71":null,"72":null,"73":null,"74":null,"75":null,"76":null,"77":null,"78":0.01098,"79":0.00549,"80":0.02196,"81":0.56537,"82":0.0988,"83":0.00549,"84":null,"3.5":null,"3.6":null},"chrome":{"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":0.32934,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":null,"39":null,"40":null,"41":null,"42":0.02745,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":0.07685,"50":null,"51":null,"52":null,"53":0.00549,"54":null,"55":null,"56":0.01098,"57":null,"58":null,"59":0.00549,"60":null,"61":0.01098,"62":0.00549,"63":0.01098,"64":0.01098,"65":0.01647,"66":0.00549,"67":0.01647,"68":0.07136,"69":0.02745,"70":0.10978,"71":0.13723,"72":0.10429,"73":0.06587,"74":0.03293,"75":0.02745,"76":0.02196,"77":0.15369,"78":0.03842,"79":0.05489,"80":0.0988,"81":0.08234,"83":0.11527,"84":0.21407,"85":13.45903,"86":22.74093,"87":0.01098,"88":0.01098,"89":null},"opera":{"9":null,"11":null,"12":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":null,"51":null,"52":null,"53":null,"54":null,"55":null,"56":0.01098,"57":0.00549,"58":0.01098,"60":null,"62":null,"63":null,"64":null,"65":null,"66":null,"67":null,"68":null,"69":null,"70":0.02196,"71":0.13174,"72":null,"9.5-9.6":null,"10.0-10.1":0,"10.5":null,"10.6":null,"11.1":null,"11.5":null,"11.6":null,"12.1":null},"ios_saf":{"8":0,"14":4.16123,"3.2":0.00997,"4.0-4.1":0.00854,"4.2-4.3":0.00142,"5.0-5.1":0.00712,"6.0-6.1":0.00427,"7.0-7.1":0.00997,"8.1-8.4":0.03275,"9.0-9.2":0.01851,"9.3":0.2364,"10.0-10.2":0.03987,"10.3":0.21931,"11.0-11.2":0.0826,"11.3-11.4":0.14099,"12.0-12.1":0.14383,"12.2-12.4":1.43407,"13.0-13.1":0.1182,"13.2":0.05839,"13.3":0.44432,"13.4-13.7":2.36686},"safari":{"0":null,"4":0,"5":null,"6":null,"7":null,"8":0.01098,"9":null,"10":null,"11":0.00549,"12":0.02745,"13":0.10429,"14":0.77395,"3.1":null,"3.2":null,"5.1":null,"6.1":null,"7.1":null,"9.1":null,"10.1":0.01098,"11.1":0.03842,"12.1":0.0988,"13.1":0.52694},"edge":{"12":null,"13":null,"14":0.00549,"15":null,"16":0.01098,"17":0.03293,"18":0.25249,"79":null,"80":null,"81":null,"83":null,"84":0.01647,"85":1.56437,"86":3.37574},"android":{"3":0,"4":0.0076,"81":null,"2.1":0,"2.2":0,"2.3":0.00006,"4.1":0.00383,"4.2-4.3":0.0017,"4.4":0,"4.4.3-4.4.4":0.01386},"samsung":{"4":0.01013,"5.0-5.4":0.04051,"6.2-6.4":0.0305,"7.2-7.4":0.04051,"8.2":0.05064,"9.2":0.14178,"10.1":0.19241,"11.1-11.2":0.32407,"12.0":11.44359},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":null,"7":null,"8":0.02814,"9":0.02814,"10":0.01688,"11":5.04259,"5.5":null},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.12628},"and_qq":{"10.4":0.01804},"and_uc":{"0":0.08569},"op_mini":{"0":0.11528},"and_chr":{"0":18.41078}},"total":91.63819}

/***/ },
/* 1264 */
/***/ function(module, exports) {

	module.exports = {"id":"KW","name":"Kuwait","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.004,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.01199,"49":0,"50":0,"51":0,"52":0.02398,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0.00799,"66":0,"67":0.07193,"68":0.01598,"69":0,"70":0,"71":0,"72":0.00799,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0.0999,"79":0.00799,"80":0.02398,"81":0.60739,"82":0.07992,"83":0.004,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.01199,"39":0,"40":0,"41":0,"42":0,"43":0.00799,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.06394,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0.004,"56":0,"57":0.004,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0.004,"64":0.004,"65":0.01199,"66":0.004,"67":0.004,"68":0.004,"69":0.01598,"70":0.01199,"71":0.01598,"72":0.004,"73":0.00799,"74":0.01598,"75":0.00799,"76":0.01598,"77":0.01199,"78":0.02797,"79":0.03596,"80":0.02797,"81":0.03197,"83":0.03996,"84":0.12787,"85":3.992,"86":5.93006,"87":0.004,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.01199,"52":0,"53":0.004,"54":0,"55":0,"56":0,"57":0,"58":0.004,"60":0.00799,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.03197,"71":0.26374,"72":0.00799,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":13.52321,"3.2":0.0324,"4.0-4.1":0.02777,"4.2-4.3":0.00463,"5.0-5.1":0.02314,"6.0-6.1":0.01388,"7.0-7.1":0.0324,"8.1-8.4":0.10645,"9.0-9.2":0.06016,"9.3":0.76826,"10.0-10.2":0.12959,"10.3":0.71272,"11.0-11.2":0.26843,"11.3-11.4":0.45818,"12.0-12.1":0.46743,"12.2-12.4":4.66046,"13.0-13.1":0.38413,"13.2":0.18975,"13.3":1.44396,"13.4-13.7":7.69185},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.004,"11":0.004,"12":0.03197,"13":0.11588,"14":0.93906,"3.1":0,"3.2":0,"5.1":0.02797,"6.1":0,"7.1":0,"9.1":0.004,"10.1":0.01598,"11.1":0.07592,"12.1":0.1039,"13.1":0.75924},"edge":{"12":0.004,"13":0.004,"14":0.004,"15":0.004,"16":0.00799,"17":0.02398,"18":0.12787,"79":0,"80":0,"81":0,"83":0.00799,"84":0.004,"85":0.31568,"86":0.5994},"android":{"3":0,"4":0.0264,"81":null,"2.1":0,"2.2":0,"2.3":0.00021,"4.1":0.01331,"4.2-4.3":0.00591,"4.4":0,"4.4.3-4.4.4":0.04816},"samsung":{"4":0.17378,"5.0-5.4":0.02044,"6.2-6.4":0.01022,"7.2-7.4":0.092,"8.2":0.06133,"9.2":0.26578,"10.1":0.184,"11.1-11.2":0.35778,"12.0":3.56759},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00417,"9":0,"10":0,"11":0.47935,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.10807},"and_qq":{"10.4":0.01801},"and_uc":{"0":2.43162},"op_mini":{"0":0.77305},"and_chr":{"0":41.82649}},"total":96.39957}

/***/ },
/* 1265 */
/***/ function(module, exports) {

	module.exports = {"id":"KY","name":"Cayman Islands","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.06338,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0.06914,"78":0.01729,"79":0,"80":0.02881,"81":1.08902,"82":0.05762,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.0461,"50":0,"51":0,"52":0,"53":0.00576,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0.00576,"63":0,"64":0,"65":0.00576,"66":0,"67":0.00576,"68":0.00576,"69":0,"70":0.03457,"71":0.09219,"72":0.04033,"73":0,"74":0.00576,"75":0.04033,"76":0.00576,"77":0,"78":0.00576,"79":0.00576,"80":0.05186,"81":0.01152,"83":0.23624,"84":0.11524,"85":7.73837,"86":10.48684,"87":0.01729,"88":0.00576,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.01152,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.02881,"71":0.29386,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":13.45852,"3.2":0.03224,"4.0-4.1":0.02764,"4.2-4.3":0.00461,"5.0-5.1":0.02303,"6.0-6.1":0.01382,"7.0-7.1":0.03224,"8.1-8.4":0.10594,"9.0-9.2":0.05988,"9.3":0.76458,"10.0-10.2":0.12897,"10.3":0.70931,"11.0-11.2":0.26714,"11.3-11.4":0.45599,"12.0-12.1":0.4652,"12.2-12.4":4.63817,"13.0-13.1":0.38229,"13.2":0.18884,"13.3":1.43705,"13.4-13.7":7.65505},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.09795,"13":0.13253,"14":2.11465,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.02881,"11.1":0.09219,"12.1":0.06914,"13.1":3.26129},"edge":{"12":0,"13":0,"14":0,"15":0.01729,"16":0.04033,"17":0.02305,"18":0.38605,"79":0,"80":0,"81":0,"83":0.00576,"84":0.01152,"85":1.33102,"86":2.78881},"android":{"3":0,"4":0.13305,"81":null,"2.1":0,"2.2":0,"2.3":0.00106,"4.1":0.06706,"4.2-4.3":0.0298,"4.4":0,"4.4.3-4.4.4":0.24269},"samsung":{"4":0.06234,"5.0-5.4":0,"6.2-6.4":0.01039,"7.2-7.4":0.01039,"8.2":0,"9.2":0.07274,"10.1":0.03117,"11.1-11.2":0.21821,"12.0":6.17213},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.79516,"5.5":0},"bb":{"7":0,"10":0.02967},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.09747},"and_qq":{"10.4":0},"and_uc":{"0":0.95355},"op_mini":{"0":0.02407},"and_chr":{"0":24.32168}},"total":95.15146}

/***/ },
/* 1266 */
/***/ function(module, exports) {

	module.exports = {"id":"KZ","name":"Kazakhstan","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0.00696,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0.05569,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00696,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00696,"52":0.1253,"53":0.00696,"54":0,"55":0.00696,"56":0.02088,"57":0,"58":0,"59":0.00696,"60":0,"61":0,"62":0,"63":0.00696,"64":0.01392,"65":0,"66":0.00696,"67":0.00696,"68":0.01392,"69":0,"70":0.00696,"71":0.00696,"72":0.00696,"73":0,"74":0.00696,"75":0,"76":0.00696,"77":0,"78":0.05569,"79":0.02088,"80":0.04177,"81":1.42004,"82":0.16706,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00696,"23":0,"24":0.00696,"25":0,"26":0,"27":0,"28":0,"29":0.00696,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.00696,"41":0,"42":0,"43":0,"44":0,"45":0.00696,"46":0,"47":0,"48":0,"49":0.14618,"50":0,"51":0.00696,"52":0,"53":0.00696,"54":0,"55":0.00696,"56":0,"57":0.00696,"58":0,"59":0.00696,"60":0.01392,"61":0.00696,"62":0,"63":0.01392,"64":0.00696,"65":0.00696,"66":0.02088,"67":0.01392,"68":0.01392,"69":0.01392,"70":0.11138,"71":0.09745,"72":0.05569,"73":0.05569,"74":0.06265,"75":0.03481,"76":0.04873,"77":0.04873,"78":0.04177,"79":0.07657,"80":0.18795,"81":0.11138,"83":0.18795,"84":0.37589,"85":11.06799,"86":18.71117,"87":0.02088,"88":0.02784,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0.00696,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.01392,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.03481,"47":0,"48":0,"49":0,"50":0.00696,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0.01392,"57":0,"58":0.00696,"60":0.00696,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0.00696,"68":0.02088,"69":0.00696,"70":0.4107,"71":3.67541,"72":0.05569,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0.21579,"12.1":0},"ios_saf":{"8":0,"14":4.47935,"3.2":0.01073,"4.0-4.1":0.0092,"4.2-4.3":0.00153,"5.0-5.1":0.00766,"6.0-6.1":0.0046,"7.0-7.1":0.01073,"8.1-8.4":0.03526,"9.0-9.2":0.01993,"9.3":0.25447,"10.0-10.2":0.04292,"10.3":0.23608,"11.0-11.2":0.08891,"11.3-11.4":0.15176,"12.0-12.1":0.15483,"12.2-12.4":1.54371,"13.0-13.1":0.12724,"13.2":0.06285,"13.3":0.47829,"13.4-13.7":2.5478},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.01392,"12":0.02088,"13":0.1253,"14":0.63345,"3.1":0,"3.2":0,"5.1":0.80748,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00696,"11.1":0.03481,"12.1":0.09745,"13.1":0.63345},"edge":{"12":0,"13":0,"14":0.00696,"15":0,"16":0.00696,"17":0.02088,"18":0.13922,"79":0,"80":0,"81":0,"83":0,"84":0.01392,"85":0.31325,"86":0.60561},"android":{"3":0,"4":0.03773,"81":null,"2.1":0,"2.2":0,"2.3":0.0003,"4.1":0.01901,"4.2-4.3":0.00845,"4.4":0,"4.4.3-4.4.4":0.06882},"samsung":{"4":0.13169,"5.0-5.4":0.01013,"6.2-6.4":0.02026,"7.2-7.4":0.06078,"8.2":0.01013,"9.2":0.11143,"10.1":0.07091,"11.1-11.2":0.22286,"12.0":1.54989},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.04801,"9":0.012,"10":0.024,"11":0.26404,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.1094},"and_qq":{"10.4":0.03951},"and_uc":{"0":0.33733},"op_mini":{"0":0.21291},"and_chr":{"0":35.46819}},"total":90.75326}

/***/ },
/* 1267 */
/***/ function(module, exports) {

	module.exports = {"id":"LA","name":"Lao People's Democratic Republic","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0.0053,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.0053,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.0053,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.0053,"44":0.0053,"45":0,"46":0,"47":0.0053,"48":0.03181,"49":0,"50":0.0053,"51":0.0053,"52":0.0106,"53":0,"54":0,"55":0.0053,"56":0.0053,"57":0,"58":0.0053,"59":0,"60":0.0106,"61":0.0053,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.0159,"69":0,"70":0.0106,"71":0,"72":0.0053,"73":0,"74":0.0106,"75":0,"76":0.0053,"77":0.0053,"78":0.07421,"79":0.0106,"80":0.03181,"81":1.66982,"82":0.23855,"83":0.0159,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.0053,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0.0106,"34":0,"35":0,"36":0.0053,"37":0.0053,"38":0.0053,"39":0,"40":0.0053,"41":0.0106,"42":0.0053,"43":0.05831,"44":0,"45":0,"46":0,"47":0.0053,"48":0,"49":0.06891,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0.0106,"56":0.0159,"57":0.0106,"58":0.0053,"59":0.0053,"60":0,"61":0,"62":0.0106,"63":0.07952,"64":0.0053,"65":0.0212,"66":0.0053,"67":0.0106,"68":0.0106,"69":0.0106,"70":0.21734,"71":0.03711,"72":0.02651,"73":0.02651,"74":0.05301,"75":0.04771,"76":0.03711,"77":0.07421,"78":0.06361,"79":0.06361,"80":0.14313,"81":0.07421,"83":0.09012,"84":0.5036,"85":6.80118,"86":10.89356,"87":0.0159,"88":0.0106,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.03181,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.0053,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0.0212,"68":0,"69":0,"70":0.08482,"71":0.5195,"72":0.0053,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":6.67796,"3.2":0.016,"4.0-4.1":0.01371,"4.2-4.3":0.00229,"5.0-5.1":0.01143,"6.0-6.1":0.00686,"7.0-7.1":0.016,"8.1-8.4":0.05256,"9.0-9.2":0.02971,"9.3":0.37938,"10.0-10.2":0.06399,"10.3":0.35195,"11.0-11.2":0.13255,"11.3-11.4":0.22626,"12.0-12.1":0.23083,"12.2-12.4":2.30141,"13.0-13.1":0.18969,"13.2":0.0937,"13.3":0.71305,"13.4-13.7":3.79835},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.0053,"11":0.0053,"12":0.0106,"13":0.07421,"14":0.5354,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.0106,"11.1":0.03181,"12.1":0.15373,"13.1":0.43998},"edge":{"12":0.0106,"13":0.0053,"14":0.0053,"15":0.0053,"16":0.0106,"17":0.02651,"18":0.11132,"79":0,"80":0.0053,"81":0.0053,"83":0,"84":0.0159,"85":0.78985,"86":1.34645},"android":{"3":0,"4":0.08556,"81":null,"2.1":0,"2.2":0,"2.3":0.00068,"4.1":0.04312,"4.2-4.3":0.01916,"4.4":0,"4.4.3-4.4.4":0.15606},"samsung":{"4":1.09129,"5.0-5.4":0.02021,"6.2-6.4":0.05052,"7.2-7.4":0.18188,"8.2":0.04042,"9.2":0.26272,"10.1":0.15157,"11.1-11.2":0.39408,"12.0":2.03101},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.10963,"9":0.00843,"10":0,"11":0.253,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.10338},"and_qq":{"10.4":0.20206},"and_uc":{"0":0.84112},"op_mini":{"0":0.37814},"and_chr":{"0":48.78479}},"total":96.56557}

/***/ },
/* 1268 */
/***/ function(module, exports) {

	module.exports = {"id":"LB","name":"Lebanon","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.02278,"49":0,"50":0,"51":0,"52":0.01708,"53":0,"54":0.00569,"55":0,"56":0.00569,"57":0.00569,"58":0.01139,"59":0,"60":0.00569,"61":0,"62":0,"63":0,"64":0,"65":0.00569,"66":0.00569,"67":0.48399,"68":0.03986,"69":0.00569,"70":0,"71":0,"72":0.00569,"73":0,"74":0.00569,"75":0,"76":0.00569,"77":0.01708,"78":0.1879,"79":0.01139,"80":0.05125,"81":1.48044,"82":0.20498,"83":0.00569,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.01139,"37":0,"38":0.00569,"39":0,"40":0.00569,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.14235,"50":0,"51":0,"52":0,"53":0.02278,"54":0,"55":0.01708,"56":0,"57":0,"58":0.01139,"59":0.03986,"60":0,"61":0,"62":0.00569,"63":0.03986,"64":0,"65":0.04555,"66":0.01139,"67":0.03416,"68":0.00569,"69":0.01708,"70":0.03416,"71":0.02847,"72":0.01708,"73":0.06263,"74":0.05694,"75":0.02278,"76":0.02278,"77":0.01708,"78":0.05125,"79":0.07402,"80":0.11957,"81":0.06263,"83":0.24484,"84":0.21637,"85":9.25844,"86":12.65207,"87":0.01708,"88":0.01139,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00569,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0.01139,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.05125,"71":0.35872,"72":0.01139,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":6.10339,"3.2":0.01462,"4.0-4.1":0.01253,"4.2-4.3":0.00209,"5.0-5.1":0.01044,"6.0-6.1":0.00627,"7.0-7.1":0.01462,"8.1-8.4":0.04804,"9.0-9.2":0.02715,"9.3":0.34674,"10.0-10.2":0.05849,"10.3":0.32167,"11.0-11.2":0.12115,"11.3-11.4":0.20679,"12.0-12.1":0.21097,"12.2-12.4":2.10339,"13.0-13.1":0.17337,"13.2":0.08564,"13.3":0.6517,"13.4-13.7":3.47154},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0.00569,"9":0.00569,"10":0.03416,"11":0.04555,"12":0.0968,"13":0.17082,"14":0.70606,"3.1":0,"3.2":0,"5.1":1.34948,"6.1":0,"7.1":0,"9.1":0.00569,"10.1":0.05125,"11.1":0.15943,"12.1":0.30748,"13.1":0.81994},"edge":{"12":0.00569,"13":0.00569,"14":0.00569,"15":0.00569,"16":0.02278,"17":0.05694,"18":0.17651,"79":0,"80":0,"81":0,"83":0.00569,"84":0.01708,"85":0.44413,"86":0.73453},"android":{"3":0,"4":0.03812,"81":null,"2.1":0,"2.2":0,"2.3":0.0003,"4.1":0.01921,"4.2-4.3":0.00854,"4.4":0,"4.4.3-4.4.4":0.06952},"samsung":{"4":0.15304,"5.0-5.4":0.0102,"6.2-6.4":0.02041,"7.2-7.4":0.16324,"8.2":0.04081,"9.2":0.16324,"10.1":0.09183,"11.1-11.2":0.3673,"12.0":4.25457},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.02375,"9":0.01187,"10":0.00594,"11":0.23745,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.09904},"and_qq":{"10.4":0},"and_uc":{"0":0.22822},"op_mini":{"0":0.15084},"and_chr":{"0":44.78767}},"total":96.58857}

/***/ },
/* 1269 */
/***/ function(module, exports) {

	module.exports = {"id":"LC","name":"Saint Lucia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0.00448,"65":0,"66":0.00448,"67":0,"68":0.00896,"69":0,"70":0.00448,"71":0,"72":0.00448,"73":0,"74":0,"75":0.00448,"76":0,"77":0,"78":0.01345,"79":0,"80":0.01793,"81":0.73953,"82":0.10309,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00448,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.01793,"35":0,"36":0,"37":0,"38":0,"39":0.00896,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.02241,"50":0,"51":0.00448,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0.00448,"58":0,"59":0,"60":0,"61":0,"62":0.00448,"63":0.01345,"64":0,"65":0,"66":0.00448,"67":0,"68":0.00448,"69":0.03137,"70":0.01793,"71":0.00448,"72":0.00448,"73":0.00448,"74":0.01793,"75":0.01345,"76":0.08964,"77":0.00896,"78":0.02241,"79":0.00896,"80":0.03586,"81":0.05827,"83":0.04482,"84":0.1255,"85":4.45511,"86":7.18465,"87":0.04482,"88":0.00448,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.00448,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00448,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.01345,"71":0.64093,"72":0.00896,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":5.21472,"3.2":0.01249,"4.0-4.1":0.01071,"4.2-4.3":0.00178,"5.0-5.1":0.00892,"6.0-6.1":0.00535,"7.0-7.1":0.01249,"8.1-8.4":0.04105,"9.0-9.2":0.0232,"9.3":0.29625,"10.0-10.2":0.04997,"10.3":0.27483,"11.0-11.2":0.10351,"11.3-11.4":0.17668,"12.0-12.1":0.18025,"12.2-12.4":1.79713,"13.0-13.1":0.14813,"13.2":0.07317,"13.3":0.55681,"13.4-13.7":2.96607},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0.08068,"14":0.61852,"3.1":0,"3.2":0,"5.1":0.04482,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00448,"11.1":0.00448,"12.1":0.08516,"13.1":0.73057},"edge":{"12":0,"13":0.00896,"14":0.03586,"15":0.00896,"16":0.00448,"17":0.03586,"18":0.16135,"79":0,"80":0,"81":0,"83":0.00448,"84":0.00448,"85":0.58266,"86":1.18773},"android":{"3":0,"4":0.38498,"81":null,"2.1":0,"2.2":0,"2.3":0.00308,"4.1":0.19403,"4.2-4.3":0.08624,"4.4":0,"4.4.3-4.4.4":0.7022},"samsung":{"4":0.06352,"5.0-5.4":0,"6.2-6.4":0.0741,"7.2-7.4":0.88926,"8.2":0.01059,"9.2":0.17997,"10.1":0.09528,"11.1-11.2":0.40228,"12.0":8.28914},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.13894,"5.5":0},"bb":{"7":0,"10":0.00552},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.25383},"and_qq":{"10.4":0},"and_uc":{"0":0.20968},"op_mini":{"0":0.17239},"and_chr":{"0":53.76788}},"total":95.32484}

/***/ },
/* 1270 */
/***/ function(module, exports) {

	module.exports = {"id":"LI","name":"Liechtenstein","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0.04475,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00746,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.01492,"51":0,"52":0.05966,"53":0,"54":0,"55":0,"56":0.00746,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0.04475,"63":0,"64":0.00746,"65":0,"66":0.02237,"67":0,"68":0.07458,"69":0.00746,"70":0.09695,"71":0.02983,"72":0.02237,"73":0,"74":0.00746,"75":0,"76":0.00746,"77":0.13424,"78":0.26103,"79":0.02237,"80":0.11933,"81":4.7582,"82":0.38782,"83":0.00746,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.03729,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.10441,"50":0.06712,"51":0,"52":0,"53":0.00746,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0.03729,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.20137,"71":0.55935,"72":1.14107,"73":0.06712,"74":0,"75":0.00746,"76":0.01492,"77":0.00746,"78":0.56681,"79":0.05966,"80":0.977,"81":0.09695,"83":0.05966,"84":0.30578,"85":10.25475,"86":13.73764,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00746,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.15662,"69":0,"70":0.02237,"71":0.21628,"72":0.02237,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":10.65239,"3.2":0.02552,"4.0-4.1":0.02187,"4.2-4.3":0.00365,"5.0-5.1":0.01823,"6.0-6.1":0.01094,"7.0-7.1":0.02552,"8.1-8.4":0.08385,"9.0-9.2":0.04739,"9.3":0.60517,"10.0-10.2":0.10208,"10.3":0.56142,"11.0-11.2":0.21144,"11.3-11.4":0.36091,"12.0-12.1":0.3682,"12.2-12.4":3.6711,"13.0-13.1":0.30258,"13.2":0.14947,"13.3":1.13742,"13.4-13.7":6.05896},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00746,"11":0.00746,"12":1.80484,"13":0.54443,"14":3.73646,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.02237,"10.1":0.03729,"11.1":0.38782,"12.1":0.20882,"13.1":3.43814},"edge":{"12":0,"13":0,"14":0.00746,"15":0,"16":0.00746,"17":0.02983,"18":0.44748,"79":0,"80":0.00746,"81":0.01492,"83":0,"84":0.09695,"85":2.06587,"86":4.1019},"android":{"3":0,"4":0.04789,"81":null,"2.1":0,"2.2":0,"2.3":0.00038,"4.1":0.02414,"4.2-4.3":0.01073,"4.4":0,"4.4.3-4.4.4":0.08736},"samsung":{"4":0.04124,"5.0-5.4":0.01031,"6.2-6.4":0,"7.2-7.4":0,"8.2":0.01031,"9.2":0.01031,"10.1":0.03093,"11.1-11.2":0.04124,"12.0":2.45359},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":1.87196,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.31521},"and_qq":{"10.4":0},"and_uc":{"0":0.01779},"op_mini":{"0":0.03129},"and_chr":{"0":15.92968}},"total":97.20795}

/***/ },
/* 1271 */
/***/ function(module, exports) {

	module.exports = {"id":"LK","name":"Sri Lanka","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00464,"44":0,"45":0,"46":0,"47":0.00464,"48":0.00464,"49":0,"50":0,"51":0,"52":0.01393,"53":0,"54":0,"55":0,"56":0.00464,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0.00464,"65":0.00464,"66":0.00464,"67":0,"68":0.02321,"69":0.00464,"70":0,"71":0.00464,"72":0.00928,"73":0,"74":0,"75":0,"76":0.00928,"77":0.00928,"78":0.03249,"79":0.01393,"80":0.0557,"81":1.22085,"82":0.20425,"83":0.01857,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0.00464,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0.00464,"32":0,"33":0.00464,"34":0,"35":0,"36":0,"37":0,"38":0.00464,"39":0,"40":0.01393,"41":0,"42":0.00464,"43":0.00464,"44":0,"45":0,"46":0.00464,"47":0,"48":0,"49":0.03249,"50":0.00464,"51":0.00464,"52":0,"53":0.00464,"54":0.00464,"55":0.00464,"56":0,"57":0,"58":0.00928,"59":0,"60":0.00928,"61":0.00464,"62":0.00464,"63":0.01857,"64":0.00928,"65":0.00464,"66":0.00464,"67":0.00928,"68":0.00464,"69":0.01857,"70":0.01857,"71":0.02321,"72":0.01393,"73":0.01857,"74":0.08356,"75":0.00928,"76":0.01857,"77":0.01857,"78":0.02785,"79":0.0557,"80":0.06499,"81":0.09284,"83":0.11141,"84":0.16711,"85":5.51934,"86":9.36756,"87":0.01393,"88":0.00464,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.02321,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.00928,"51":0.02321,"52":0,"53":0.00464,"54":0.00464,"55":0.00928,"56":0,"57":0,"58":0,"60":0.01393,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00464,"69":0,"70":0.09284,"71":0.70558,"72":0.02321,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00464},"ios_saf":{"8":0,"14":2.7762,"3.2":0.00665,"4.0-4.1":0.0057,"4.2-4.3":0.00095,"5.0-5.1":0.00475,"6.0-6.1":0.00285,"7.0-7.1":0.00665,"8.1-8.4":0.02185,"9.0-9.2":0.01235,"9.3":0.15772,"10.0-10.2":0.0266,"10.3":0.14632,"11.0-11.2":0.05511,"11.3-11.4":0.09406,"12.0-12.1":0.09596,"12.2-12.4":0.95675,"13.0-13.1":0.07886,"13.2":0.03895,"13.3":0.29643,"13.4-13.7":1.57907},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.00928,"13":0.03249,"14":0.19032,"3.1":0,"3.2":0,"5.1":0.10212,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00464,"11.1":0.00928,"12.1":0.03249,"13.1":0.13926},"edge":{"12":0.00464,"13":0.00464,"14":0.01393,"15":0.00928,"16":0.00928,"17":0.01393,"18":0.06963,"79":0,"80":0,"81":0,"83":0,"84":0.00928,"85":0.44563,"86":1.08159},"android":{"3":0,"4":0.05488,"81":null,"2.1":0,"2.2":0,"2.3":0.00044,"4.1":0.02766,"4.2-4.3":0.01229,"4.4":0,"4.4.3-4.4.4":0.10009},"samsung":{"4":1.21119,"5.0-5.4":0.07065,"6.2-6.4":0.07065,"7.2-7.4":0.4441,"8.2":0.09084,"9.2":0.36336,"10.1":0.17159,"11.1-11.2":0.57532,"12.0":1.59473},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.0099,"9":0,"10":0,"11":0.28719,"5.5":0},"bb":{"7":0,"10":0.00536},"ie_mob":{"10":0,"11":0.01072},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.11252},"and_qq":{"10.4":0},"and_uc":{"0":2.36288},"op_mini":{"0":1.97832},"and_chr":{"0":58.99152}},"total":95.49251}

/***/ },
/* 1272 */
/***/ function(module, exports) {

	module.exports = {"id":"LR","name":"Liberia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0.00268,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0.00536,"25":0,"26":0.00268,"27":0,"28":0,"29":0,"30":0.00268,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00268,"44":0.00268,"45":0,"46":0,"47":0.00268,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0.06437,"57":0.00268,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.03218,"69":0.00268,"70":0.00268,"71":0,"72":0.00268,"73":0,"74":0,"75":0,"76":0,"77":0.00268,"78":0.00536,"79":0.00268,"80":0.02414,"81":0.35671,"82":0.03755,"83":0.00805,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0.00268,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.00536,"38":0.00268,"39":0,"40":0,"41":0.00268,"42":0,"43":0.00805,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.01877,"50":0.00805,"51":0.00268,"52":0,"53":0.00268,"54":0.00268,"55":0.00268,"56":0,"57":0,"58":0,"59":0.00268,"60":0.00536,"61":0,"62":0,"63":0.01341,"64":0.0295,"65":0.00536,"66":0.00268,"67":0.00536,"68":0,"69":0.01341,"70":0.00268,"71":0.00536,"72":0.01341,"73":0.00268,"74":0.01073,"75":0.01341,"76":0.01877,"77":0.00536,"78":0.00805,"79":0.02146,"80":0.06705,"81":0.01609,"83":0.05364,"84":0.04023,"85":1.13449,"86":1.78353,"87":0.00268,"88":0.00268,"89":0},"opera":{"9":0,"11":0.00268,"12":0,"15":0,"16":0,"17":0.00268,"18":0,"19":0,"20":0.00536,"21":0,"22":0,"23":0.03755,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00268,"30":0.00268,"31":0,"32":0.00268,"33":0.00268,"34":0,"35":0,"36":0,"37":0.01341,"38":0,"39":0,"40":0.00268,"41":0,"42":0.00268,"43":0,"44":0,"45":0,"46":0.10192,"47":0.00268,"48":0,"49":0,"50":0.02414,"51":0.02146,"52":0,"53":0,"54":0,"55":0,"56":0.00268,"57":0,"58":0,"60":0.00268,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.0295,"71":0.13142,"72":0.00268,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.08851},"ios_saf":{"8":0,"14":2.32086,"3.2":0.00556,"4.0-4.1":0.00477,"4.2-4.3":0.00079,"5.0-5.1":0.00397,"6.0-6.1":0.00238,"7.0-7.1":0.00556,"8.1-8.4":0.01827,"9.0-9.2":0.01033,"9.3":0.13185,"10.0-10.2":0.02224,"10.3":0.12232,"11.0-11.2":0.04607,"11.3-11.4":0.07863,"12.0-12.1":0.08022,"12.2-12.4":0.79983,"13.0-13.1":0.06592,"13.2":0.03257,"13.3":0.24781,"13.4-13.7":1.32008},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.00268,"13":0.00805,"14":0.08314,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00268,"11.1":0.04828,"12.1":0.00268,"13.1":0.06169},"edge":{"12":0.03755,"13":0.01341,"14":0.00805,"15":0.01073,"16":0.01073,"17":0.01341,"18":0.09923,"79":0,"80":0,"81":0,"83":0.00268,"84":0.00536,"85":0.23065,"86":0.27625},"android":{"3":0,"4":0.06302,"81":null,"2.1":0,"2.2":0,"2.3":0.0005,"4.1":0.03176,"4.2-4.3":0.01412,"4.4":0,"4.4.3-4.4.4":0.11496},"samsung":{"4":0.48787,"5.0-5.4":0.07115,"6.2-6.4":0.01016,"7.2-7.4":0.10164,"8.2":0.01016,"9.2":0.23377,"10.1":0.20328,"11.1-11.2":0.19311,"12.0":0.70131},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00559,"9":0,"10":0.00279,"11":0.05867,"5.5":0},"bb":{"7":0,"10":0.03659},"ie_mob":{"10":0,"11":0.00732},"kaios":{"2.5":0.15368},"baidu":{"0":null},"and_ff":{"0":0.21954},"and_qq":{"10.4":0.01464},"and_uc":{"0":1.44165},"op_mini":{"0":10.48238},"and_chr":{"0":70.38635}},"total":95.67365}

/***/ },
/* 1273 */
/***/ function(module, exports) {

	module.exports = {"id":"LS","name":"Lesotho","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.00385,"47":0,"48":0,"49":0,"50":0.01154,"51":0.00769,"52":0.00769,"53":0,"54":0,"55":0.00385,"56":0,"57":0,"58":0,"59":0.00385,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.01538,"69":0,"70":0,"71":0,"72":0.00385,"73":0,"74":0,"75":0,"76":0,"77":0.00385,"78":0.00385,"79":0.00385,"80":0.01538,"81":0.42306,"82":0.04615,"83":0.00769,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00385,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.01923,"35":0.00385,"36":0.01154,"37":0,"38":0,"39":0,"40":0.02692,"41":0,"42":0,"43":0.01923,"44":0,"45":0,"46":0.06538,"47":0,"48":0,"49":0.00385,"50":0.00385,"51":0.00385,"52":0,"53":0,"54":0,"55":0.04615,"56":0.00385,"57":0,"58":0.00385,"59":0,"60":0,"61":0,"62":0,"63":0.00385,"64":0.00385,"65":0.00385,"66":0.01923,"67":0,"68":0,"69":0.01923,"70":0.01538,"71":0.00769,"72":0.00385,"73":0,"74":0.01923,"75":0.00385,"76":0.03461,"77":0.00385,"78":0.00769,"79":0.05384,"80":0.1423,"81":0.04231,"83":0.14615,"84":0.05,"85":1.69609,"86":2.71143,"87":0.00769,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0.00385,"18":0,"19":0,"20":0.00385,"21":0.00769,"22":0,"23":0,"24":0,"25":0,"26":0.00769,"27":0,"28":0.00385,"29":0,"30":0.00385,"31":0,"32":0,"33":0,"34":0,"35":0.00769,"36":0,"37":0.00385,"38":0.01154,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.00769,"47":0.00769,"48":0,"49":0,"50":0.03846,"51":0.05,"52":0,"53":0.00385,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00769,"62":0,"63":0.00385,"64":0,"65":0,"66":0,"67":0.00385,"68":0.00385,"69":0,"70":0.03846,"71":0.27691,"72":0.00385,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.23076},"ios_saf":{"8":0,"14":1.10774,"3.2":0.00265,"4.0-4.1":0.00227,"4.2-4.3":0.00038,"5.0-5.1":0.0019,"6.0-6.1":0.00114,"7.0-7.1":0.00265,"8.1-8.4":0.00872,"9.0-9.2":0.00493,"9.3":0.06293,"10.0-10.2":0.01061,"10.3":0.05838,"11.0-11.2":0.02199,"11.3-11.4":0.03753,"12.0-12.1":0.03829,"12.2-12.4":0.38176,"13.0-13.1":0.03147,"13.2":0.01554,"13.3":0.11828,"13.4-13.7":0.63007},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00385,"12":0,"13":0.00385,"14":0.07692,"3.1":0,"3.2":0,"5.1":0.05384,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0.00385,"12.1":0.00385,"13.1":0.07307},"edge":{"12":0.02692,"13":0.01154,"14":0.01538,"15":3.90754,"16":0.01538,"17":0.03846,"18":0.27307,"79":0,"80":0,"81":0.00385,"83":0,"84":0.00769,"85":0.33076,"86":0.35768},"android":{"3":0,"4":0.1398,"81":null,"2.1":0,"2.2":0,"2.3":0.00112,"4.1":0.07046,"4.2-4.3":0.03132,"4.4":0,"4.4.3-4.4.4":0.255},"samsung":{"4":1.12651,"5.0-5.4":0.01015,"6.2-6.4":0.0203,"7.2-7.4":0.50744,"8.2":0.05074,"9.2":0.20297,"10.1":0.12178,"11.1-11.2":0.16238,"12.0":1.26859},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00385,"9":0,"10":0,"11":0.19999,"5.5":0},"bb":{"7":0,"10":0.05539},"ie_mob":{"10":0,"11":0.01231},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.19077},"and_qq":{"10.4":0.10462},"and_uc":{"0":1.61235},"op_mini":{"0":7.43424},"and_chr":{"0":66.98725}},"total":94.81973}

/***/ },
/* 1274 */
/***/ function(module, exports) {

	module.exports = {"id":"LT","name":"Lithuania","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.00665,"13":0,"14":0,"15":0,"16":0.00665,"17":0.00665,"18":0,"19":0.00665,"20":0,"21":0.01329,"22":0.00665,"23":0.00665,"24":0.00665,"25":0.00665,"26":0.00665,"27":0.00665,"28":0.01329,"29":0.01329,"30":0.00665,"31":0.01994,"32":0.01994,"33":0.00665,"34":0.00665,"35":0,"36":0.00665,"37":0.00665,"38":0.00665,"39":0,"40":0.00665,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00665,"48":0.01329,"49":0,"50":0.01994,"51":0.01329,"52":0.12626,"53":0,"54":0,"55":0.00665,"56":0.03987,"57":0,"58":0.00665,"59":0,"60":0.01994,"61":0,"62":0.00665,"63":0.00665,"64":0.00665,"65":0.01994,"66":0.01994,"67":0,"68":0.03987,"69":0.00665,"70":0.00665,"71":0.00665,"72":0.01994,"73":0.00665,"74":0.00665,"75":0.00665,"76":0.02658,"77":0.01994,"78":0.09968,"79":0.02658,"80":0.17277,"81":4.21958,"82":0.61799,"83":0.01329,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.01994,"39":0,"40":0,"41":0.00665,"42":0,"43":0,"44":0,"45":0,"46":0.00665,"47":0,"48":0.01329,"49":0.32561,"50":0,"51":0.04652,"52":0.00665,"53":0.01329,"54":0,"55":0.00665,"56":0.0731,"57":0.00665,"58":0.00665,"59":0,"60":0.01994,"61":0.01329,"62":0.01329,"63":0.01994,"64":0.02658,"65":0.01329,"66":0.01329,"67":0.23258,"68":0.00665,"69":0.17942,"70":0.06645,"71":0.03987,"72":0.05981,"73":0.04652,"74":0.03323,"75":0.03323,"76":0.01994,"77":0.03323,"78":0.05316,"79":0.11961,"80":0.10632,"81":0.08639,"83":0.16613,"84":0.34554,"85":10.24659,"86":17.29694,"87":0.01329,"88":0.00665,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0.00665,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00665,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.00665,"51":0.01329,"52":0,"53":0.00665,"54":0,"55":0,"56":0.00665,"57":0,"58":0,"60":0.00665,"62":0,"63":0,"64":0,"65":0.00665,"66":0,"67":0,"68":0.00665,"69":0,"70":0.27909,"71":1.78086,"72":0.03323,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00665},"ios_saf":{"8":0,"14":6.03982,"3.2":0.01447,"4.0-4.1":0.0124,"4.2-4.3":0.00207,"5.0-5.1":0.01034,"6.0-6.1":0.0062,"7.0-7.1":0.01447,"8.1-8.4":0.04754,"9.0-9.2":0.02687,"9.3":0.34312,"10.0-10.2":0.05788,"10.3":0.31832,"11.0-11.2":0.11989,"11.3-11.4":0.20463,"12.0-12.1":0.20877,"12.2-12.4":2.08149,"13.0-13.1":0.17156,"13.2":0.08475,"13.3":0.64491,"13.4-13.7":3.43538},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00665,"12":0.01994,"13":0.15284,"14":0.99011,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.01994,"11.1":0.05316,"12.1":0.16613,"13.1":1.10307},"edge":{"12":0,"13":0.01329,"14":0.02658,"15":0.01329,"16":0.00665,"17":0.02658,"18":0.21264,"79":0,"80":0,"81":0.00665,"83":0,"84":0.01994,"85":0.69773,"86":1.46855},"android":{"3":0,"4":0.04777,"81":null,"2.1":0,"2.2":0,"2.3":0.00038,"4.1":0.02408,"4.2-4.3":0.0107,"4.4":0,"4.4.3-4.4.4":0.08713},"samsung":{"4":0.07126,"5.0-5.4":0.02036,"6.2-6.4":0,"7.2-7.4":0.03054,"8.2":0.01018,"9.2":0.06108,"10.1":0.06108,"11.1-11.2":0.14253,"12.0":3.14583},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0.00682,"7":0.00682,"8":0.09554,"9":0.0273,"10":0.02047,"11":0.60056,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0.01678},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.22814},"and_qq":{"10.4":0},"and_uc":{"0":0.11072},"op_mini":{"0":0.26363},"and_chr":{"0":35.12256}},"total":96.87131}

/***/ },
/* 1275 */
/***/ function(module, exports) {

	module.exports = {"id":"LU","name":"Luxembourg","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.0425,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00607,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.03036,"46":0,"47":0,"48":0.04857,"49":0,"50":0.00607,"51":0.01214,"52":0.0425,"53":0.00607,"54":0,"55":0,"56":0.00607,"57":0,"58":0,"59":0.00607,"60":0.01821,"61":0.00607,"62":0.01214,"63":0.02428,"64":0,"65":0.03036,"66":0.02428,"67":0,"68":0.23677,"69":0.00607,"70":0.00607,"71":0.00607,"72":0.03036,"73":0.00607,"74":0.02428,"75":0,"76":0.00607,"77":0.01821,"78":0.40069,"79":0.0425,"80":0.33391,"81":3.35726,"82":0.58282,"83":0.00607,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.02428,"39":0,"40":0.00607,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.23677,"50":0,"51":0.01214,"52":0,"53":0.01214,"54":0,"55":0,"56":0,"57":0.00607,"58":0.01214,"59":0.02428,"60":0,"61":0,"62":0.01214,"63":0.00607,"64":0,"65":0.00607,"66":0,"67":0.00607,"68":0.00607,"69":0.03643,"70":0.06678,"71":0.06678,"72":0.20641,"73":0.04857,"74":0.00607,"75":0.0425,"76":0.07892,"77":0.15785,"78":0.09107,"79":0.06071,"80":0.11535,"81":0.1882,"83":0.20641,"84":0.2732,"85":7.36412,"86":9.19757,"87":0.01821,"88":0.00607,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.01214,"52":0,"53":0.01214,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.02428,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00607,"69":0,"70":0.09714,"71":0.58282,"72":0.01214,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":13.85283,"3.2":0.03319,"4.0-4.1":0.02845,"4.2-4.3":0.00474,"5.0-5.1":0.0237,"6.0-6.1":0.01422,"7.0-7.1":0.03319,"8.1-8.4":0.10904,"9.0-9.2":0.06163,"9.3":0.78698,"10.0-10.2":0.13274,"10.3":0.73009,"11.0-11.2":0.27497,"11.3-11.4":0.46935,"12.0-12.1":0.47883,"12.2-12.4":4.77406,"13.0-13.1":0.39349,"13.2":0.19438,"13.3":1.47915,"13.4-13.7":7.87933},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0.00607,"8":0,"9":0,"10":0,"11":0.00607,"12":0.05464,"13":0.30962,"14":3.06586,"3.1":0,"3.2":0,"5.1":0.01821,"6.1":0,"7.1":0,"9.1":0.01214,"10.1":0.04857,"11.1":0.17606,"12.1":0.2307,"13.1":2.8898},"edge":{"12":0,"13":0.00607,"14":0.00607,"15":0.01214,"16":0.04857,"17":0.06071,"18":0.41283,"79":0,"80":0,"81":0,"83":0.09714,"84":0.11535,"85":0.90458,"86":1.62703},"android":{"3":0,"4":0.05016,"81":null,"2.1":0,"2.2":0,"2.3":0.0004,"4.1":0.02528,"4.2-4.3":0.01124,"4.4":0,"4.4.3-4.4.4":0.09149},"samsung":{"4":0.24846,"5.0-5.4":0.02071,"6.2-6.4":0,"7.2-7.4":0.02071,"8.2":0,"9.2":0.07247,"10.1":0.04141,"11.1-11.2":0.07247,"12.0":3.43706},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01279,"9":0.01279,"10":0.0064,"11":0.6844,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.60507},"and_qq":{"10.4":0.00786},"and_uc":{"0":0.18466},"op_mini":{"0":0.20458},"and_chr":{"0":24.55996}},"total":96.9662}

/***/ },
/* 1276 */
/***/ function(module, exports) {

	module.exports = {"id":"LV","name":"Latvia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.01349,"30":0,"31":0,"32":0.00675,"33":0,"34":0,"35":0,"36":0,"37":0.00675,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.00675,"47":0,"48":0.01349,"49":0.00675,"50":0,"51":0,"52":0.1147,"53":0,"54":0,"55":0.00675,"56":0.02024,"57":0.00675,"58":0,"59":0,"60":0.01349,"61":0.00675,"62":0,"63":0,"64":0.00675,"65":0.01349,"66":0.02024,"67":0.00675,"68":0.07422,"69":0.00675,"70":0.00675,"71":0.00675,"72":0.10121,"73":0.01349,"74":0.01349,"75":0.01349,"76":0.00675,"77":0.01349,"78":0.17542,"79":0.04723,"80":0.20916,"81":4.08194,"82":0.60723,"83":0.01349,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00675,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00675,"30":0,"31":0.02024,"32":0,"33":0,"34":0,"35":0,"36":0.00675,"37":0,"38":0.00675,"39":0,"40":0.00675,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.01349,"47":0,"48":0.01349,"49":0.31036,"50":0,"51":0,"52":0,"53":0.04048,"54":0,"55":0,"56":0,"57":0.01349,"58":0.02024,"59":0,"60":0.00675,"61":0.00675,"62":0.00675,"63":0.01349,"64":0.00675,"65":0.03374,"66":0.04723,"67":0.03374,"68":0.01349,"69":0.3441,"70":0.02024,"71":0.03374,"72":0.04048,"73":0.02024,"74":0.05398,"75":0.04723,"76":0.03374,"77":0.03374,"78":0.05398,"79":0.08096,"80":0.1147,"81":0.1147,"83":0.23615,"84":0.47229,"85":11.07857,"86":17.87955,"87":0.02699,"88":0.00675,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0.00675,"33":0,"34":0,"35":0,"36":0.01349,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.00675,"51":0.01349,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00675,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00675,"69":0.00675,"70":0.18217,"71":1.53832,"72":0.03374,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":5.99143,"3.2":0.01435,"4.0-4.1":0.0123,"4.2-4.3":0.00205,"5.0-5.1":0.01025,"6.0-6.1":0.00615,"7.0-7.1":0.01435,"8.1-8.4":0.04716,"9.0-9.2":0.02666,"9.3":0.34038,"10.0-10.2":0.05741,"10.3":0.31577,"11.0-11.2":0.11893,"11.3-11.4":0.203,"12.0-12.1":0.2071,"12.2-12.4":2.06481,"13.0-13.1":0.17019,"13.2":0.08407,"13.3":0.63974,"13.4-13.7":3.40786},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.01349,"12":0.02699,"13":0.18217,"14":1.30217,"3.1":0,"3.2":0,"5.1":0.02699,"6.1":0,"7.1":0,"9.1":0,"10.1":0.02024,"11.1":0.06747,"12.1":0.13494,"13.1":1.20097},"edge":{"12":0,"13":0.00675,"14":0,"15":0.00675,"16":0.00675,"17":0.01349,"18":0.22265,"79":0,"80":0,"81":0,"83":0,"84":0.01349,"85":0.62747,"86":1.34265},"android":{"3":0,"4":0.07256,"81":null,"2.1":0,"2.2":0,"2.3":0.00058,"4.1":0.03657,"4.2-4.3":0.01625,"4.4":0,"4.4.3-4.4.4":0.13235},"samsung":{"4":0.07118,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.02034,"8.2":0.02034,"9.2":0.04068,"10.1":0.08135,"11.1-11.2":0.14237,"12.0":3.25409},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.05038,"9":0.01439,"10":0.01439,"11":0.35264,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.23422},"and_qq":{"10.4":0.00325},"and_uc":{"0":0.08783},"op_mini":{"0":0.33261},"and_chr":{"0":33.86007}},"total":96.5899}

/***/ },
/* 1277 */
/***/ function(module, exports) {

	module.exports = {"id":"LY","name":"Libya","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0.00321,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00321,"48":0,"49":0,"50":0.00321,"51":0,"52":0.00643,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00964,"69":0,"70":0,"71":0.00643,"72":0.0225,"73":0.01286,"74":0.01607,"75":0.01607,"76":0.01286,"77":0.00964,"78":0.01286,"79":0.00964,"80":0.03214,"81":0.50138,"82":0.06428,"83":0.00321,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0.00321,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0.00643,"34":0,"35":0,"36":0,"37":0,"38":0.00321,"39":0,"40":0.01286,"41":0.03535,"42":0,"43":0.01607,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.02893,"50":0.00321,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0.00321,"57":0,"58":0.00964,"59":0,"60":0.00643,"61":0.00321,"62":0,"63":0.01286,"64":0.00321,"65":0.00321,"66":0.00321,"67":0.00964,"68":0.00321,"69":0.01286,"70":0.01928,"71":0.00964,"72":0.01286,"73":0.01286,"74":0.02893,"75":0.01607,"76":0.01607,"77":0.0225,"78":0.03535,"79":0.04178,"80":0.07714,"81":0.06428,"83":0.04821,"84":0.09963,"85":2.46514,"86":4.43532,"87":0.00321,"88":0.00321,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0.00321,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0.00964,"29":0,"30":0.00321,"31":0.00643,"32":0.00321,"33":0.00321,"34":0,"35":0.00321,"36":0,"37":0,"38":0.00321,"39":0,"40":0,"41":0,"42":0.00321,"43":0,"44":0,"45":0.00321,"46":0.00964,"47":0.00964,"48":0,"49":0,"50":0.05785,"51":0.39854,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0.00643,"58":0.00643,"60":0.01286,"62":0.00643,"63":0.00643,"64":0.00643,"65":0.00643,"66":0.00643,"67":0.00964,"68":0.03214,"69":0,"70":0.05785,"71":0.50781,"72":0.01286,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00964},"ios_saf":{"8":0,"14":3.92705,"3.2":0.00941,"4.0-4.1":0.00806,"4.2-4.3":0.00134,"5.0-5.1":0.00672,"6.0-6.1":0.00403,"7.0-7.1":0.00941,"8.1-8.4":0.03091,"9.0-9.2":0.01747,"9.3":0.2231,"10.0-10.2":0.03763,"10.3":0.20697,"11.0-11.2":0.07795,"11.3-11.4":0.13305,"12.0-12.1":0.13574,"12.2-12.4":1.35337,"13.0-13.1":0.11155,"13.2":0.0551,"13.3":0.41932,"13.4-13.7":2.23366},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.00964,"13":0.02893,"14":0.12535,"3.1":0,"3.2":0,"5.1":0.21212,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0.00321,"12.1":0.00964,"13.1":0.06749},"edge":{"12":0.00321,"13":0,"14":0,"15":0.00321,"16":0.00321,"17":0.00964,"18":0.03857,"79":0.00643,"80":0.00643,"81":0.00964,"83":0.00643,"84":0.01286,"85":0.1382,"86":0.2989},"android":{"3":0,"4":0.04655,"81":null,"2.1":0,"2.2":0,"2.3":0.00037,"4.1":0.02346,"4.2-4.3":0.01043,"4.4":0,"4.4.3-4.4.4":0.0849},"samsung":{"4":0.50927,"5.0-5.4":0.03056,"6.2-6.4":0.13241,"7.2-7.4":0.58056,"8.2":0.0713,"9.2":0.38704,"10.1":0.25463,"11.1-11.2":0.52964,"12.0":2.96393},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00643,"9":0,"10":0,"11":0.03535,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.08822},"and_qq":{"10.4":0},"and_uc":{"0":0.40716},"op_mini":{"0":3.21227},"and_chr":{"0":68.16929}},"total":97.08103}

/***/ },
/* 1278 */
/***/ function(module, exports) {

	module.exports = {"id":"MA","name":"Morocco","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.02116,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00529,"44":0,"45":0,"46":0,"47":0.00529,"48":0.01587,"49":0,"50":0.00529,"51":0,"52":0.07407,"53":0.00529,"54":0.01058,"55":0.00529,"56":0.00529,"57":0,"58":0,"59":0,"60":0.01058,"61":0,"62":0,"63":0.01058,"64":0.00529,"65":0.01587,"66":0.01058,"67":0.00529,"68":0.02646,"69":0.00529,"70":0.00529,"71":0.00529,"72":0.02116,"73":0,"74":0.00529,"75":0.00529,"76":0.00529,"77":0.01058,"78":0.12698,"79":0.02116,"80":0.11111,"81":1.61376,"82":0.22751,"83":0.01058,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00529,"30":0,"31":0,"32":0,"33":0.00529,"34":0,"35":0,"36":0,"37":0,"38":0.00529,"39":0.00529,"40":0.00529,"41":0,"42":0,"43":0.01587,"44":0,"45":0,"46":0.00529,"47":0,"48":0.00529,"49":0.34392,"50":0,"51":0,"52":0,"53":0.01058,"54":0,"55":0.00529,"56":0.00529,"57":0,"58":0.01058,"59":0,"60":0,"61":0.03175,"62":0.00529,"63":0.02116,"64":0.00529,"65":0.02646,"66":0.00529,"67":0.04762,"68":0.01058,"69":0.01587,"70":0.06349,"71":0.06878,"72":0.05291,"73":0.04233,"74":0.0582,"75":0.03175,"76":0.02646,"77":0.02646,"78":0.04233,"79":0.08466,"80":0.14286,"81":0.1164,"83":0.16931,"84":0.24339,"85":7.61904,"86":11.3439,"87":0.02116,"88":0.01058,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.00529,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.00529,"51":0.03175,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0.00529,"58":0.00529,"60":0.00529,"62":0,"63":0.00529,"64":0,"65":0,"66":0,"67":0,"68":0.00529,"69":0,"70":0.16402,"71":1.19048,"72":0.02646,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":3.0787,"3.2":0.00738,"4.0-4.1":0.00632,"4.2-4.3":0.00105,"5.0-5.1":0.00527,"6.0-6.1":0.00316,"7.0-7.1":0.00738,"8.1-8.4":0.02423,"9.0-9.2":0.0137,"9.3":0.1749,"10.0-10.2":0.0295,"10.3":0.16226,"11.0-11.2":0.06111,"11.3-11.4":0.10431,"12.0-12.1":0.10642,"12.2-12.4":1.061,"13.0-13.1":0.08745,"13.2":0.0432,"13.3":0.32873,"13.4-13.7":1.75113},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00529,"11":0.01058,"12":0.02646,"13":0.14286,"14":0.25397,"3.1":0,"3.2":0,"5.1":0.19048,"6.1":0,"7.1":0,"9.1":0.00529,"10.1":0.01587,"11.1":0.04762,"12.1":0.09524,"13.1":0.31217},"edge":{"12":0.00529,"13":0.00529,"14":0.00529,"15":0.01058,"16":0.00529,"17":0.01587,"18":0.06878,"79":0,"80":0,"81":0,"83":0.01058,"84":0.01058,"85":0.34921,"86":0.68783},"android":{"3":0,"4":0.06345,"81":null,"2.1":0,"2.2":0,"2.3":0.00051,"4.1":0.03198,"4.2-4.3":0.01421,"4.4":0,"4.4.3-4.4.4":0.11573},"samsung":{"4":0.51667,"5.0-5.4":0.03039,"6.2-6.4":0.05065,"7.2-7.4":0.25327,"8.2":0.03039,"9.2":0.20262,"10.1":0.14183,"11.1-11.2":0.29379,"12.0":2.88729},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.04252,"9":0.00607,"10":0.01215,"11":0.10327,"5.5":0},"bb":{"7":0,"10":0.00471},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.14127},"and_qq":{"10.4":0.00471},"and_uc":{"0":0.11302},"op_mini":{"0":0.43244},"and_chr":{"0":57.27394}},"total":96.72877}

/***/ },
/* 1279 */
/***/ function(module, exports) {

	module.exports = {"id":"MC","name":"Monaco","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0.03961,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0.00792,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00792,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.03169,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.00792,"41":0,"42":0,"43":0.00792,"44":0,"45":0,"46":0,"47":0,"48":0.01584,"49":0,"50":0,"51":0,"52":0.00792,"53":0,"54":0,"55":0,"56":0.00792,"57":0.00792,"58":0,"59":0,"60":0.00792,"61":0,"62":0,"63":0.00792,"64":0.38818,"65":0.00792,"66":0.01584,"67":0,"68":0.04753,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0.00792,"77":0,"78":0.7209,"79":0.03961,"80":0.43571,"81":2.32907,"82":0.51493,"83":0.00792,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.11883,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.15052,"49":0.38818,"50":0,"51":0,"52":0,"53":0.04753,"54":0,"55":0.00792,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0.08714,"64":0,"65":0.00792,"66":0.00792,"67":0.00792,"68":0,"69":0.04753,"70":0.85558,"71":0.66545,"72":1.14077,"73":0.45948,"74":0.00792,"75":0.00792,"76":0.04753,"77":0.16636,"78":0.04753,"79":0.03961,"80":0.07922,"81":0.09506,"83":0.17428,"84":3.27971,"85":10.88483,"86":14.29129,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0.43571,"57":0.40402,"58":0.00792,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.11883,"71":0.34857,"72":0,"9.5-9.6":0.00792,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":10.49213,"3.2":0.02514,"4.0-4.1":0.02154,"4.2-4.3":0.00359,"5.0-5.1":0.01795,"6.0-6.1":0.01077,"7.0-7.1":0.02514,"8.1-8.4":0.08259,"9.0-9.2":0.04668,"9.3":0.59606,"10.0-10.2":0.10054,"10.3":0.55297,"11.0-11.2":0.20826,"11.3-11.4":0.35548,"12.0-12.1":0.36266,"12.2-12.4":3.61587,"13.0-13.1":0.29803,"13.2":0.14722,"13.3":1.12031,"13.4-13.7":5.9678},"safari":{"0":null,"4":0.09506,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.01584,"12":0.02377,"13":1.05363,"14":4.24619,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.12675,"11.1":0.50701,"12.1":1.3309,"13.1":5.30774},"edge":{"12":0,"13":0,"14":0.00792,"15":0,"16":0.00792,"17":0.04753,"18":0.2535,"79":0,"80":0,"81":0,"83":0.01584,"84":0.04753,"85":2.03595,"86":2.76478},"android":{"3":0,"4":0.03312,"81":null,"2.1":0,"2.2":0,"2.3":0.00026,"4.1":0.01669,"4.2-4.3":0.00742,"4.4":0,"4.4.3-4.4.4":0.06042},"samsung":{"4":0.09274,"5.0-5.4":0.05152,"6.2-6.4":0,"7.2-7.4":0.0103,"8.2":0.03091,"9.2":0.0103,"10.1":0.02061,"11.1-11.2":0,"12.0":1.04079},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0.05066,"7":0.06079,"8":1.05365,"9":0.27354,"10":0.49643,"11":1.66152,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0.01039,"11":0},"kaios":{"2.5":0.00208},"baidu":{"0":null},"and_ff":{"0":0.24105},"and_qq":{"10.4":0},"and_uc":{"0":0.04364},"op_mini":{"0":0.11214},"and_chr":{"0":11.74552}},"total":98.17595}

/***/ },
/* 1280 */
/***/ function(module, exports) {

	module.exports = {"id":"MD","name":"Moldova","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":null,"3":null,"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":0.01156,"44":null,"45":0.00578,"46":null,"47":0.00578,"48":0.01734,"49":null,"50":null,"51":null,"52":0.13292,"53":null,"54":null,"55":null,"56":0.01156,"57":0.01156,"58":null,"59":0.02312,"60":0.02312,"61":0.01156,"62":0.01156,"63":0.01734,"64":0.05779,"65":0.06357,"66":0.01734,"67":null,"68":0.02312,"69":null,"70":null,"71":null,"72":0.01734,"73":null,"74":null,"75":null,"76":0.01156,"77":0.00578,"78":0.16181,"79":0.04045,"80":0.19649,"81":1.80305,"82":0.23116,"83":0.00578,"84":null,"3.5":null,"3.6":0.02312},"chrome":{"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":0.00578,"25":null,"26":null,"27":null,"28":null,"29":0.00578,"30":null,"31":null,"32":null,"33":0.03467,"34":null,"35":null,"36":null,"37":null,"38":null,"39":null,"40":null,"41":0.01156,"42":null,"43":null,"44":null,"45":null,"46":0.01156,"47":0.01156,"48":0.00578,"49":0.4392,"50":null,"51":null,"52":null,"53":0.04045,"54":null,"55":0.00578,"56":0.00578,"57":0.00578,"58":0.00578,"59":0.08669,"60":0.00578,"61":0.09824,"62":0.00578,"63":0.05779,"64":0.01156,"65":0.01734,"66":0.01734,"67":0.0289,"68":0.05779,"69":0.03467,"70":0.15603,"71":0.33518,"72":0.20804,"73":0.20804,"74":0.05201,"75":0.10402,"76":0.04623,"77":0.0289,"78":0.08669,"79":0.08669,"80":0.27739,"81":0.11558,"83":0.23116,"84":0.51433,"85":15.93848,"86":24.93639,"87":0.02312,"88":0.04623,"89":null},"opera":{"9":null,"11":null,"12":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":0.01156,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":null,"51":null,"52":null,"53":null,"54":null,"55":null,"56":0.01156,"57":null,"58":0.04045,"60":null,"62":null,"63":null,"64":null,"65":null,"66":null,"67":null,"68":0.01156,"69":null,"70":0.28895,"71":2.46763,"72":0.04623,"9.5-9.6":null,"10.0-10.1":0,"10.5":null,"10.6":null,"11.1":null,"11.5":null,"11.6":null,"12.1":0.01156},"ios_saf":{"8":0,"14":2.66021,"3.2":0.00637,"4.0-4.1":0.00546,"4.2-4.3":0.00091,"5.0-5.1":0.00455,"6.0-6.1":0.00273,"7.0-7.1":0.00637,"8.1-8.4":0.02094,"9.0-9.2":0.01184,"9.3":0.15113,"10.0-10.2":0.02549,"10.3":0.1402,"11.0-11.2":0.0528,"11.3-11.4":0.09013,"12.0-12.1":0.09195,"12.2-12.4":0.91678,"13.0-13.1":0.07556,"13.2":0.03733,"13.3":0.28405,"13.4-13.7":1.51309},"safari":{"0":null,"4":0,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":0.02312,"12":0.03467,"13":0.17915,"14":0.7975,"3.1":null,"3.2":null,"5.1":0.56634,"6.1":null,"7.1":null,"9.1":null,"10.1":0.01156,"11.1":0.04045,"12.1":0.20227,"13.1":0.74549},"edge":{"12":null,"13":null,"14":0.01156,"15":0.00578,"16":0.00578,"17":0.04045,"18":0.11558,"79":null,"80":null,"81":null,"83":null,"84":0.01156,"85":0.36408,"86":0.65881},"android":{"3":0,"4":0.02845,"81":null,"2.1":0,"2.2":0,"2.3":0.00023,"4.1":0.01434,"4.2-4.3":0.00637,"4.4":0,"4.4.3-4.4.4":0.05189},"samsung":{"4":0.11509,"5.0-5.4":0.02135,"6.2-6.4":0,"7.2-7.4":0.11742,"8.2":0.01046,"9.2":0.06277,"10.1":0.09416,"11.1-11.2":0.18832,"12.0":2.30173},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0.03137,"7":null,"8":0.06274,"9":0.01255,"10":0.01882,"11":0.31372,"5.5":null},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.09284},"and_qq":{"10.4":0},"and_uc":{"0":0.17724},"op_mini":{"0":0.21574},"and_chr":{"0":33.41671}},"total":97.50326}

/***/ },
/* 1281 */
/***/ function(module, exports) {

	module.exports = {"id":"ME","name":"Montenegro","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0.00741,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.1259,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0.0037,"66":0.00741,"67":0,"68":0.00741,"69":0,"70":0.01111,"71":0,"72":0.0037,"73":0,"74":0.0037,"75":0,"76":0,"77":0.0037,"78":0.01481,"79":0.0037,"80":0.04444,"81":0.88131,"82":0.11479,"83":0.0037,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.0037,"23":0,"24":0,"25":0,"26":0.0037,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0.0037,"34":0,"35":0,"36":0,"37":0,"38":0.01111,"39":0,"40":0,"41":0,"42":0,"43":0.0037,"44":0,"45":0,"46":0.0037,"47":0,"48":0,"49":0.11109,"50":0.0037,"51":0,"52":0,"53":0.01111,"54":0.0037,"55":0.0037,"56":0,"57":0,"58":0,"59":0,"60":0.0037,"61":0,"62":0.0037,"63":0.0037,"64":0,"65":0,"66":0.01111,"67":0.0037,"68":0.0037,"69":0,"70":0.01111,"71":0.01111,"72":0.01852,"73":0.02962,"74":0.00741,"75":0.00741,"76":0.01481,"77":0.01111,"78":0.01111,"79":0.02592,"80":0.04814,"81":0.04814,"83":0.06295,"84":0.09628,"85":3.16607,"86":5.0583,"87":0.00741,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.0037,"37":0,"38":0,"39":0,"40":0.0037,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.0037,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0.0037,"68":1.96259,"69":0,"70":0.04444,"71":0.35919,"72":0.00741,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":5.91084,"3.2":0.01416,"4.0-4.1":0.01214,"4.2-4.3":0.00202,"5.0-5.1":0.01011,"6.0-6.1":0.00607,"7.0-7.1":0.01416,"8.1-8.4":0.04653,"9.0-9.2":0.0263,"9.3":0.3358,"10.0-10.2":0.05664,"10.3":0.31152,"11.0-11.2":0.11733,"11.3-11.4":0.20026,"12.0-12.1":0.20431,"12.2-12.4":2.03703,"13.0-13.1":0.1679,"13.2":0.08294,"13.3":0.63114,"13.4-13.7":3.36202},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.00741,"13":0.02962,"14":0.12961,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.0037,"10.1":0.0037,"11.1":0.01481,"12.1":0.01111,"13.1":0.17404},"edge":{"12":0,"13":0,"14":0,"15":0.01111,"16":0,"17":0.0037,"18":0.04073,"79":0,"80":0,"81":0.0037,"83":0,"84":0.0037,"85":0.09998,"86":0.18145},"android":{"3":0,"4":0.02694,"81":null,"2.1":0,"2.2":0,"2.3":0.00022,"4.1":0.01358,"4.2-4.3":0.00604,"4.4":0,"4.4.3-4.4.4":0.04915},"samsung":{"4":0.20334,"5.0-5.4":0.01017,"6.2-6.4":0.02033,"7.2-7.4":0.07117,"8.2":0.0305,"9.2":0.17284,"10.1":0.14234,"11.1-11.2":0.26434,"12.0":3.95498},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0.00802,"7":0,"8":0.00802,"9":0,"10":0,"11":0.08023,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.2078},"and_qq":{"10.4":0},"and_uc":{"0":0.0063},"op_mini":{"0":0.20269},"and_chr":{"0":65.58716}},"total":97.78691}

/***/ },
/* 1282 */
/***/ function(module, exports) {

	module.exports = {"id":"MG","name":"Madagascar","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0.02228,"4":0,"5":0.00743,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0.00743,"29":0,"30":0,"31":0,"32":0.00743,"33":0.00743,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0.00743,"40":0.00743,"41":0,"42":0.02228,"43":0.02228,"44":0,"45":0.02228,"46":0.00743,"47":0.03714,"48":0.14113,"49":0.00743,"50":0.01486,"51":0.00743,"52":0.17084,"53":0,"54":0.00743,"55":0,"56":0.04457,"57":0.01486,"58":0.01486,"59":0.02228,"60":0.052,"61":0.02228,"62":0.01486,"63":0.01486,"64":0.02228,"65":0.02228,"66":0.04457,"67":0.01486,"68":0.14113,"69":0.04457,"70":0.052,"71":0.03714,"72":0.15599,"73":0.01486,"74":0.04457,"75":0.02971,"76":0.06685,"77":0.07428,"78":0.41597,"79":0.08914,"80":0.39368,"81":8.43078,"82":1.44846,"83":0.052,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0.00743,"26":0.01486,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0.00743,"33":0.00743,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0.00743,"40":0.00743,"41":0.00743,"42":0.00743,"43":0.052,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.27484,"50":0,"51":0.00743,"52":0.00743,"53":0,"54":0,"55":0.12628,"56":0,"57":0,"58":0.08914,"59":0,"60":0.02971,"61":0,"62":0.01486,"63":0.03714,"64":0.03714,"65":0.07428,"66":0.01486,"67":0.02971,"68":0.01486,"69":0.052,"70":0.04457,"71":0.10399,"72":0.052,"73":0.06685,"74":0.12628,"75":0.02971,"76":0.10399,"77":0.21541,"78":0.09656,"79":0.28969,"80":0.6091,"81":0.21541,"83":0.31198,"84":0.57938,"85":11.06772,"86":17.81234,"87":0.02971,"88":0.02228,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0.00743,"21":0.01486,"22":0,"23":0,"24":0.00743,"25":0.00743,"26":0.02971,"27":0,"28":0.02228,"29":0.00743,"30":0.01486,"31":0.00743,"32":0.01486,"33":0.01486,"34":0,"35":0.00743,"36":0.00743,"37":0.00743,"38":0.02971,"39":0,"40":0,"41":0,"42":0.03714,"43":0,"44":0,"45":0.00743,"46":0.03714,"47":0.06685,"48":0,"49":0,"50":0.08914,"51":0.41597,"52":0.00743,"53":0.05942,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.01486,"62":0,"63":0,"64":0,"65":0.00743,"66":0.00743,"67":0.00743,"68":0.01486,"69":0.00743,"70":0.34912,"71":2.14669,"72":0.06685,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.03714},"ios_saf":{"8":0,"14":1.68356,"3.2":0.00403,"4.0-4.1":0.00346,"4.2-4.3":0.00058,"5.0-5.1":0.00288,"6.0-6.1":0.00173,"7.0-7.1":0.00403,"8.1-8.4":0.01325,"9.0-9.2":0.00749,"9.3":0.09564,"10.0-10.2":0.01613,"10.3":0.08873,"11.0-11.2":0.03342,"11.3-11.4":0.05704,"12.0-12.1":0.05819,"12.2-12.4":0.5802,"13.0-13.1":0.04782,"13.2":0.02362,"13.3":0.17976,"13.4-13.7":0.95759},"safari":{"0":null,"4":0,"5":0,"6":0.01486,"7":0,"8":0,"9":0,"10":0.02228,"11":0.02971,"12":0.02228,"13":0.22284,"14":0.5051,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00743,"11.1":0.08914,"12.1":0.07428,"13.1":0.31198},"edge":{"12":0.00743,"13":0.01486,"14":0.052,"15":0.04457,"16":0.00743,"17":0.052,"18":0.14113,"79":0,"80":0,"81":0.00743,"83":0,"84":0.02228,"85":0.63138,"86":1.35932},"android":{"3":0,"4":0.13018,"81":null,"2.1":0,"2.2":0,"2.3":0.00104,"4.1":0.06561,"4.2-4.3":0.02916,"4.4":0,"4.4.3-4.4.4":0.23746},"samsung":{"4":0.11192,"5.0-5.4":0,"6.2-6.4":0.01017,"7.2-7.4":0.02035,"8.2":0,"9.2":0.03052,"10.1":0.03052,"11.1-11.2":0.0407,"12.0":0.68172},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.08299,"9":0.00922,"10":0.00922,"11":0.16598,"5.5":0},"bb":{"7":0,"10":0.00257},"ie_mob":{"10":0,"11":0.01286},"kaios":{"2.5":0.06687},"baidu":{"0":null},"and_ff":{"0":0.3035},"and_qq":{"10.4":0.02058},"and_uc":{"0":1.59464},"op_mini":{"0":3.43579},"and_chr":{"0":32.1377}},"total":95.33909}

/***/ },
/* 1283 */
/***/ function(module, exports) {

	module.exports = {"id":"MH","name":"Marshall Islands","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00583,"48":0,"49":0,"50":0,"51":0,"52":0.00583,"53":0,"54":0,"55":0,"56":0.00583,"57":0.02913,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0.02913,"64":0,"65":0,"66":0,"67":0,"68":0.06408,"69":0,"70":0,"71":0,"72":0.00583,"73":0,"74":0,"75":0.00583,"76":0,"77":0,"78":0.29708,"79":0.00583,"80":0.08155,"81":1.8873,"82":0.26213,"83":0.04078,"84":0.0233,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00583,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0.01165,"36":0.04078,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.02913,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0.00583,"58":0,"59":0.01165,"60":0,"61":0,"62":0,"63":0.00583,"64":0,"65":0,"66":0,"67":0.01748,"68":0,"69":0,"70":0,"71":0,"72":0.03495,"73":0.19223,"74":0.12815,"75":0.00583,"76":0.00583,"77":0.01165,"78":0,"79":0.13398,"80":0.02913,"81":0.0699,"83":0.27378,"84":0.7922,"85":8.11423,"86":12.12183,"87":0.04078,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00583,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.00583,"71":0.12815,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":8.84793,"3.2":0.0212,"4.0-4.1":0.01817,"4.2-4.3":0.00303,"5.0-5.1":0.01514,"6.0-6.1":0.00908,"7.0-7.1":0.0212,"8.1-8.4":0.06964,"9.0-9.2":0.03936,"9.3":0.50265,"10.0-10.2":0.08479,"10.3":0.46632,"11.0-11.2":0.17563,"11.3-11.4":0.29978,"12.0-12.1":0.30583,"12.2-12.4":3.04923,"13.0-13.1":0.25133,"13.2":0.12415,"13.3":0.94475,"13.4-13.7":5.0326},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00583,"12":0.01165,"13":0.27378,"14":0.23883,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.01165,"11.1":0.02913,"12.1":0.00583,"13.1":1.7475},"edge":{"12":0,"13":0.01748,"14":0.01165,"15":0,"16":0,"17":0.08738,"18":0.13398,"79":0,"80":0,"81":0.01748,"83":0,"84":0.02913,"85":0.46018,"86":0.52425},"android":{"3":0,"4":0.26346,"81":null,"2.1":0,"2.2":0,"2.3":0.00211,"4.1":0.13278,"4.2-4.3":0.05902,"4.4":0,"4.4.3-4.4.4":0.48055},"samsung":{"4":0.02211,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.05527,"8.2":0.01105,"9.2":1.98964,"10.1":0,"11.1-11.2":1.49223,"12.0":2.98446},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.0466,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.01253},"and_qq":{"10.4":0.14195},"and_uc":{"0":0.20875},"op_mini":{"0":0.01976},"and_chr":{"0":37.9507}},"total":94.73243}

/***/ },
/* 1284 */
/***/ function(module, exports) {

	module.exports = {"id":"MK","name":"Macedonia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.00511,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00511,"48":0.00511,"49":0.00511,"50":0.00511,"51":0.01532,"52":0.15324,"53":0,"54":0,"55":0.01022,"56":0.00511,"57":0,"58":0,"59":0,"60":0.01022,"61":0.01022,"62":0.01022,"63":0.01532,"64":0.03576,"65":0.0664,"66":0.02043,"67":0.00511,"68":0.02554,"69":0,"70":0,"71":0.00511,"72":0.00511,"73":0,"74":0,"75":0,"76":0.00511,"77":0.00511,"78":0.08684,"79":0.03576,"80":0.09194,"81":1.44046,"82":0.23497,"83":0.01022,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.00511,"35":0,"36":0,"37":0,"38":0.01022,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.01022,"48":0.01532,"49":0.3831,"50":0,"51":0,"52":0.00511,"53":0.01532,"54":0,"55":0.00511,"56":0.00511,"57":0,"58":0.01532,"59":0.01022,"60":0.00511,"61":0.01022,"62":0.01022,"63":0.01532,"64":0.01022,"65":0.01022,"66":0.01022,"67":0.00511,"68":0.01022,"69":0.05619,"70":0.3167,"71":0.3831,"72":0.37288,"73":0.14813,"74":0.01532,"75":0.01022,"76":0.03576,"77":0.05619,"78":0.02554,"79":0.03065,"80":0.0613,"81":0.07151,"83":0.0664,"84":0.16346,"85":6.94688,"86":11.34487,"87":0.01022,"88":0.00511,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0.01022,"32":0.00511,"33":0,"34":0,"35":0,"36":0.01022,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.01022,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0.00511,"57":0.01022,"58":0.01532,"60":0.00511,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.0613,"71":0.54145,"72":0.01532,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":5.38696,"3.2":0.01291,"4.0-4.1":0.01106,"4.2-4.3":0.00184,"5.0-5.1":0.00922,"6.0-6.1":0.00553,"7.0-7.1":0.01291,"8.1-8.4":0.0424,"9.0-9.2":0.02397,"9.3":0.30604,"10.0-10.2":0.05162,"10.3":0.28391,"11.0-11.2":0.10693,"11.3-11.4":0.18252,"12.0-12.1":0.1862,"12.2-12.4":1.85649,"13.0-13.1":0.15302,"13.2":0.07559,"13.3":0.5752,"13.4-13.7":3.06404},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00511,"12":0.02043,"13":0.03576,"14":0.23497,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0.01532,"12.1":0.03576,"13.1":0.14813},"edge":{"12":0.00511,"13":0.00511,"14":0.02043,"15":0.00511,"16":0.00511,"17":0.02043,"18":0.0664,"79":0,"80":0,"81":0,"83":0.00511,"84":0.00511,"85":0.27583,"86":0.53634},"android":{"3":0,"4":0.03239,"81":null,"2.1":0,"2.2":0,"2.3":0.00026,"4.1":0.01633,"4.2-4.3":0.00726,"4.4":0,"4.4.3-4.4.4":0.05909},"samsung":{"4":0.12102,"5.0-5.4":0.01009,"6.2-6.4":0,"7.2-7.4":0.04034,"8.2":0.01009,"9.2":0.11094,"10.1":0.04034,"11.1-11.2":0.15128,"12.0":2.27928},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.02554,"9":0.00511,"10":0,"11":0.16346,"5.5":0},"bb":{"7":0,"10":0.00978},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.10762},"and_qq":{"10.4":0},"and_uc":{"0":0.03424},"op_mini":{"0":0.12505},"and_chr":{"0":57.3101}},"total":98.15988}

/***/ },
/* 1285 */
/***/ function(module, exports) {

	module.exports = {"id":"ML","name":"Mali","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0.01599,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.0032,"30":0,"31":0,"32":0,"33":0,"34":0.02238,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.0032,"44":0.01279,"45":0,"46":0.0032,"47":0.0032,"48":0.0032,"49":0,"50":0,"51":0,"52":0.0032,"53":0,"54":0,"55":0,"56":0.02558,"57":0.0032,"58":0.0032,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0.00959,"65":0,"66":0,"67":0.0032,"68":0.00639,"69":0.01918,"70":0.03517,"71":0.0032,"72":0.03517,"73":0,"74":0.0032,"75":0.0032,"76":0.0032,"77":0.0032,"78":0.14387,"79":0.01279,"80":0.05755,"81":1.77434,"82":0.19821,"83":0.0032,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.0032,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00959,"44":0,"45":0,"46":0,"47":0,"48":0.0032,"49":0.06074,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0.0032,"56":0,"57":0,"58":0,"59":0,"60":0.00639,"61":0,"62":0,"63":0.07033,"64":0.0032,"65":0.00639,"66":0.0032,"67":0.0032,"68":0.0032,"69":0.01279,"70":0.00639,"71":0.00639,"72":0.0032,"73":0.01599,"74":0.02238,"75":0,"76":0.00959,"77":0.0032,"78":0.0032,"79":0.01599,"80":0.02558,"81":0.02877,"83":0.08632,"84":0.04476,"85":1.68482,"86":2.94763,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00639,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.0032,"51":0.03197,"52":0,"53":0.0032,"54":0,"55":0,"56":0.0032,"57":0,"58":0,"60":0.0032,"62":0,"63":0.00639,"64":0,"65":0,"66":0,"67":0.00639,"68":0,"69":0,"70":0.04156,"71":0.28773,"72":0.0032,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":3.71317,"3.2":0.0089,"4.0-4.1":0.00762,"4.2-4.3":0.00127,"5.0-5.1":0.00635,"6.0-6.1":0.00381,"7.0-7.1":0.0089,"8.1-8.4":0.02923,"9.0-9.2":0.01652,"9.3":0.21095,"10.0-10.2":0.03558,"10.3":0.1957,"11.0-11.2":0.0737,"11.3-11.4":0.12581,"12.0-12.1":0.12835,"12.2-12.4":1.27966,"13.0-13.1":0.10547,"13.2":0.0521,"13.3":0.39648,"13.4-13.7":2.11201},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.0032,"12":0.01279,"13":0.03517,"14":0.16624,"3.1":0,"3.2":0,"5.1":0.11509,"6.1":0,"7.1":0,"9.1":0.00639,"10.1":0.02877,"11.1":0.0032,"12.1":0.07673,"13.1":0.2142},"edge":{"12":0.01599,"13":0.04476,"14":0.0032,"15":0.0032,"16":0.02558,"17":0.07033,"18":0.07673,"79":0,"80":0,"81":0,"83":0,"84":0.01918,"85":0.17903,"86":0.28453},"android":{"3":0,"4":0.1527,"81":null,"2.1":0,"2.2":0,"2.3":0.00122,"4.1":0.07696,"4.2-4.3":0.0342,"4.4":0,"4.4.3-4.4.4":0.27852},"samsung":{"4":0.30233,"5.0-5.4":0.02016,"6.2-6.4":0.02016,"7.2-7.4":0.50389,"8.2":0.02016,"9.2":0.31241,"10.1":0.10078,"11.1-11.2":0.3628,"12.0":1.59228},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00959,"9":0.0032,"10":0,"11":0.15985,"5.5":0},"bb":{"7":0,"10":0.04762},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.12926},"baidu":{"0":null},"and_ff":{"0":0.11565},"and_qq":{"10.4":0.08164},"and_uc":{"0":1.22454},"op_mini":{"0":2.441},"and_chr":{"0":71.5791}},"total":97.37218}

/***/ },
/* 1286 */
/***/ function(module, exports) {

	module.exports = {"id":"MM","name":"Myanmar","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00824,"30":0.00412,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00412,"37":0.00412,"38":0,"39":0.00412,"40":0.00412,"41":0.00412,"42":0.00412,"43":0.00412,"44":0.00412,"45":0,"46":0,"47":0.00824,"48":0.00412,"49":0.00412,"50":0.00412,"51":0,"52":0.00824,"53":0,"54":0.00412,"55":0,"56":0.00824,"57":0.00824,"58":0.00412,"59":0.00412,"60":0.02471,"61":0.00412,"62":0.01236,"63":0.00412,"64":0.00412,"65":0.00824,"66":0.01236,"67":0.01236,"68":0.04943,"69":0.01236,"70":0.00824,"71":0.00824,"72":0.07414,"73":0.00824,"74":0.00824,"75":0.0206,"76":0.02471,"77":0.02883,"78":0.04119,"79":0.03295,"80":0.08238,"81":2.17071,"82":0.43661,"83":0.0865,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00412,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.03295,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0.00412,"32":0.00412,"33":0,"34":0,"35":0,"36":0,"37":0.00412,"38":0.00824,"39":0,"40":0.00824,"41":0,"42":0.00412,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.00824,"50":0,"51":0,"52":0,"53":0.00824,"54":0,"55":0.00412,"56":0,"57":0,"58":0.00824,"59":0,"60":0,"61":0.00412,"62":0,"63":0.03707,"64":0,"65":0.00824,"66":0,"67":0.00412,"68":0.00412,"69":0.00824,"70":0.00824,"71":0.03295,"72":0.00412,"73":0.00824,"74":0.03295,"75":0.00824,"76":0.04943,"77":0.01236,"78":0.02471,"79":0.08238,"80":0.04531,"81":0.07002,"83":0.04119,"84":0.09474,"85":3.63708,"86":6.25264,"87":0.0206,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.0206,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0.00412,"55":0.00412,"56":0,"57":0,"58":0,"60":0.00824,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.02883,"71":0.21007,"72":0.00824,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":4.39437,"3.2":0.01053,"4.0-4.1":0.00902,"4.2-4.3":0.0015,"5.0-5.1":0.00752,"6.0-6.1":0.00451,"7.0-7.1":0.01053,"8.1-8.4":0.03459,"9.0-9.2":0.01955,"9.3":0.24965,"10.0-10.2":0.04211,"10.3":0.2316,"11.0-11.2":0.08723,"11.3-11.4":0.14889,"12.0-12.1":0.15189,"12.2-12.4":1.51442,"13.0-13.1":0.12482,"13.2":0.06166,"13.3":0.46921,"13.4-13.7":2.49947},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.01648,"11":0.00824,"12":0.0206,"13":0.07002,"14":0.45309,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.01648,"11.1":0.02883,"12.1":0.04943,"13.1":0.35423},"edge":{"12":0.00412,"13":0.00412,"14":0.00412,"15":0.00412,"16":0.00412,"17":0.00824,"18":0.08238,"79":0,"80":0,"81":0.00412,"83":0,"84":0.00412,"85":0.28421,"86":0.60549},"android":{"3":0,"4":0.4281,"81":null,"2.1":0,"2.2":0,"2.3":0.00342,"4.1":0.21576,"4.2-4.3":0.0959,"4.4":0,"4.4.3-4.4.4":0.78086},"samsung":{"4":0.20462,"5.0-5.4":0.02046,"6.2-6.4":0.02046,"7.2-7.4":0.04092,"8.2":0.01023,"9.2":0.09208,"10.1":0.07162,"11.1-11.2":0.12277,"12.0":1.13562},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00824,"9":0,"10":0,"11":0.0659,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.24112},"and_qq":{"10.4":0.17643},"and_uc":{"0":1.81723},"op_mini":{"0":0.51223},"and_chr":{"0":65.7227}},"total":98.03926}

/***/ },
/* 1287 */
/***/ function(module, exports) {

	module.exports = {"id":"MN","name":"Mongolia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0.01342,"43":0,"44":0,"45":0,"46":0,"47":0.00671,"48":0,"49":0,"50":0,"51":0,"52":0.00671,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0.00671,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0.00671,"67":0,"68":0.01342,"69":0,"70":0,"71":0,"72":0.00671,"73":0.00671,"74":0.00671,"75":0,"76":0.00671,"77":0.00671,"78":0.03356,"79":0.00671,"80":0.02685,"81":2.0136,"82":0.30875,"83":0.01342,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0.00671,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00671,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.0537,"50":0.00671,"51":0,"52":0,"53":0,"54":0,"55":0.00671,"56":0,"57":0.00671,"58":0.00671,"59":0.00671,"60":0.00671,"61":0,"62":0,"63":0.03356,"64":0,"65":0.01342,"66":0,"67":0.03356,"68":0.00671,"69":0.03356,"70":0.03356,"71":0.04698,"72":0.0537,"73":0.04027,"74":0.17451,"75":0.06041,"76":0.0537,"77":0.08054,"78":0.07383,"79":0.1678,"80":0.27519,"81":0.08054,"83":0.09397,"84":0.36916,"85":13.86028,"86":20.975,"87":0.02014,"88":0.01342,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00671,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0.02014,"68":0,"69":0,"70":0.13424,"71":1.04707,"72":0.02685,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":6.51426,"3.2":0.01561,"4.0-4.1":0.01338,"4.2-4.3":0.00223,"5.0-5.1":0.01115,"6.0-6.1":0.00669,"7.0-7.1":0.01561,"8.1-8.4":0.05128,"9.0-9.2":0.02898,"9.3":0.37008,"10.0-10.2":0.06242,"10.3":0.34332,"11.0-11.2":0.1293,"11.3-11.4":0.22071,"12.0-12.1":0.22517,"12.2-12.4":2.24499,"13.0-13.1":0.18504,"13.2":0.0914,"13.3":0.69557,"13.4-13.7":3.70523},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00671,"12":0.01342,"13":0.08726,"14":0.42286,"3.1":0,"3.2":0,"5.1":0.02014,"6.1":0,"7.1":0,"9.1":0.00671,"10.1":0.00671,"11.1":0.02014,"12.1":0.14095,"13.1":0.35574},"edge":{"12":0.00671,"13":0,"14":0,"15":0,"16":0,"17":0.00671,"18":0.12753,"79":0,"80":0.00671,"81":0.00671,"83":0,"84":0.04027,"85":0.63764,"86":1.22158},"android":{"3":0,"4":0.0496,"81":null,"2.1":0,"2.2":0,"2.3":0.0004,"4.1":0.025,"4.2-4.3":0.01111,"4.4":0,"4.4.3-4.4.4":0.09047},"samsung":{"4":0.30451,"5.0-5.4":0.1015,"6.2-6.4":0.03045,"7.2-7.4":0.24361,"8.2":0.0203,"9.2":0.15225,"10.1":0.13195,"11.1-11.2":0.31466,"12.0":3.01462},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.02506,"9":0,"10":0.01253,"11":0.15035,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.10522},"and_qq":{"10.4":0.06576},"and_uc":{"0":0.23674},"op_mini":{"0":0.09339},"and_chr":{"0":32.66874}},"total":96.34146}

/***/ },
/* 1288 */
/***/ function(module, exports) {

	module.exports = {"id":"MO","name":"Macao","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.02087,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00522,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.01044,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.00522,"53":0,"54":0,"55":0,"56":0.04174,"57":0,"58":0,"59":0,"60":0.00522,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.03653,"69":0,"70":0,"71":0,"72":0.00522,"73":0,"74":0.01044,"75":0,"76":0,"77":0.02087,"78":0.01565,"79":0.01565,"80":0.02609,"81":0.66269,"82":0.09392,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.02087,"23":0,"24":0,"25":0,"26":0.03131,"27":0,"28":0,"29":0,"30":0.00522,"31":0,"32":0,"33":0,"34":0.05218,"35":0,"36":0,"37":0,"38":0.10436,"39":0,"40":0.03653,"41":0,"42":0,"43":0,"44":0,"45":0.00522,"46":0,"47":0,"48":0,"49":0.07827,"50":0,"51":0,"52":0,"53":0.15132,"54":0.00522,"55":0.01565,"56":0.00522,"57":0.00522,"58":0.02087,"59":0.00522,"60":0.00522,"61":0.01565,"62":0.02087,"63":0.01565,"64":0.01044,"65":0.03653,"66":0.0574,"67":0.02087,"68":0.0574,"69":0.06783,"70":0.02609,"71":0.08349,"72":0.05218,"73":0.09392,"74":0.08349,"75":0.0574,"76":0.06262,"77":0.07305,"78":0.15132,"79":0.1148,"80":0.19828,"81":0.17219,"83":0.28177,"84":0.48527,"85":5.68762,"86":8.07746,"87":0.02609,"88":0.00522,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.02087,"37":0,"38":0,"39":0,"40":0.00522,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.00522,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00522,"69":0,"70":0.00522,"71":0.08349,"72":0.00522,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":18.82459,"3.2":0.0451,"4.0-4.1":0.03865,"4.2-4.3":0.00644,"5.0-5.1":0.03221,"6.0-6.1":0.01933,"7.0-7.1":0.0451,"8.1-8.4":0.14817,"9.0-9.2":0.08375,"9.3":1.06943,"10.0-10.2":0.18039,"10.3":0.99212,"11.0-11.2":0.37366,"11.3-11.4":0.63779,"12.0-12.1":0.65068,"12.2-12.4":6.48746,"13.0-13.1":0.53472,"13.2":0.26414,"13.3":2.01002,"13.4-13.7":10.70721},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0.00522,"10":0.01565,"11":0.01565,"12":0.03653,"13":0.33395,"14":1.26797,"3.1":0,"3.2":0,"5.1":0.01565,"6.1":0,"7.1":0,"9.1":0.00522,"10.1":0.03131,"11.1":0.07305,"12.1":0.19307,"13.1":2.90643},"edge":{"12":0.01044,"13":0,"14":0.00522,"15":0.00522,"16":0.02087,"17":0.01044,"18":0.18263,"79":0,"80":0.00522,"81":0,"83":0,"84":0.00522,"85":0.32352,"86":0.64181},"android":{"3":0,"4":0.11541,"81":null,"2.1":0,"2.2":0,"2.3":0.00092,"4.1":0.05817,"4.2-4.3":0.02585,"4.4":0,"4.4.3-4.4.4":0.21051},"samsung":{"4":0.63181,"5.0-5.4":0.03268,"6.2-6.4":0,"7.2-7.4":0,"8.2":0,"9.2":0.04357,"10.1":0.03268,"11.1-11.2":0.03268,"12.0":2.04795},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.0355,"9":0,"10":0,"11":0.8046,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.14824},"and_qq":{"10.4":0.43038},"and_uc":{"0":0.4782},"op_mini":{"0":0.03169},"and_chr":{"0":25.70382}},"total":97.81494}

/***/ },
/* 1289 */
/***/ function(module, exports) {

	module.exports = {"id":"MP","name":"Northern Mariana Islands","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.09834,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.01967,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.01311,"69":0,"70":0.00656,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0.07212,"79":0.00656,"80":0.03934,"81":0.72116,"82":0.059,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0.00656,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00656,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.04589,"50":0,"51":0,"52":0,"53":0.07212,"54":0,"55":0,"56":0.00656,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0.01311,"66":0.00656,"67":0.02622,"68":0.01967,"69":0.02622,"70":0,"71":0.00656,"72":0.00656,"73":0,"74":0,"75":0.11801,"76":0.01311,"77":0.00656,"78":0,"79":0.01967,"80":0.11801,"81":0.1049,"83":0.03934,"84":0.38025,"85":9.86022,"86":16.27199,"87":0.01311,"88":0.02622,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.02622,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00656,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.01967,"71":0.3278,"72":0.00656,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":7.37905,"3.2":0.01768,"4.0-4.1":0.01515,"4.2-4.3":0.00253,"5.0-5.1":0.01263,"6.0-6.1":0.00758,"7.0-7.1":0.01768,"8.1-8.4":0.05808,"9.0-9.2":0.03283,"9.3":0.41921,"10.0-10.2":0.07071,"10.3":0.3889,"11.0-11.2":0.14647,"11.3-11.4":0.25001,"12.0-12.1":0.25506,"12.2-12.4":2.54302,"13.0-13.1":0.2096,"13.2":0.10354,"13.3":0.78791,"13.4-13.7":4.19712},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0.00656,"8":0,"9":0,"10":0,"11":0,"12":0.01311,"13":0.83917,"14":3.20588,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.00656,"10.1":0.01311,"11.1":0.07212,"12.1":0.1049,"13.1":2.19626},"edge":{"12":0,"13":0,"14":0,"15":0,"16":0.00656,"17":0.00656,"18":0.11145,"79":0,"80":0,"81":0,"83":0,"84":0.01311,"85":0.93095,"86":1.72423},"android":{"3":0,"4":0.06464,"81":null,"2.1":0,"2.2":0,"2.3":0.00052,"4.1":0.03258,"4.2-4.3":0.01448,"4.4":0,"4.4.3-4.4.4":0.11791},"samsung":{"4":0.07423,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.02121,"8.2":0,"9.2":0.28632,"10.1":0.0106,"11.1-11.2":0.07423,"12.0":4.75079},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":1.32431,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.03444},"and_qq":{"10.4":0.0551},"and_uc":{"0":0.03444},"op_mini":{"0":0.76623},"and_chr":{"0":33.2362}},"total":95.70017}

/***/ },
/* 1290 */
/***/ function(module, exports) {

	module.exports = {"id":"MQ","name":"Martinique","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.005,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.21513,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0.03002,"61":0,"62":0,"63":0,"64":0.005,"65":0,"66":0.005,"67":0.005,"68":0.01501,"69":0,"70":0,"71":0,"72":0.01501,"73":0,"74":0,"75":0.01501,"76":0,"77":0.03002,"78":0.1701,"79":0.02001,"80":0.04503,"81":1.58595,"82":0.24515,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.14509,"50":0,"51":0,"52":0,"53":0.005,"54":0,"55":0,"56":0,"57":0,"58":0.005,"59":0,"60":0,"61":0.01501,"62":0,"63":0.01001,"64":0,"65":0.02502,"66":0,"67":0,"68":0,"69":0,"70":0.01001,"71":0.01001,"72":0.02001,"73":0,"74":0.01001,"75":0.005,"76":0.01001,"77":0.01501,"78":0.01001,"79":0.06004,"80":0.15009,"81":0.03002,"83":0.05003,"84":0.28517,"85":4.97799,"86":8.19491,"87":0.005,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.005,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0.005,"66":0,"67":0,"68":0,"69":0,"70":0.07004,"71":0.21013,"72":0.01501,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":7.1075,"3.2":0.01703,"4.0-4.1":0.01459,"4.2-4.3":0.00243,"5.0-5.1":0.01216,"6.0-6.1":0.0073,"7.0-7.1":0.01703,"8.1-8.4":0.05595,"9.0-9.2":0.03162,"9.3":0.40378,"10.0-10.2":0.06811,"10.3":0.37459,"11.0-11.2":0.14108,"11.3-11.4":0.24081,"12.0-12.1":0.24567,"12.2-12.4":2.44944,"13.0-13.1":0.20189,"13.2":0.09973,"13.3":0.75891,"13.4-13.7":4.04266},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0.02502,"8":0,"9":0,"10":0,"11":0.01501,"12":0.01501,"13":0.21513,"14":1.4959,"3.1":0,"3.2":0,"5.1":0.03002,"6.1":0,"7.1":0,"9.1":0.005,"10.1":0.02001,"11.1":0.15009,"12.1":0.53532,"13.1":1.27076},"edge":{"12":0,"13":0,"14":0.005,"15":0.005,"16":0.52031,"17":0.04503,"18":0.14509,"79":0,"80":0,"81":0.01001,"83":0.005,"84":0.01001,"85":0.63038,"86":1.40084},"android":{"3":0,"4":0.06041,"81":null,"2.1":0,"2.2":0,"2.3":0.00048,"4.1":0.03045,"4.2-4.3":0.01353,"4.4":0,"4.4.3-4.4.4":0.11019},"samsung":{"4":0.06266,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.0731,"8.2":0,"9.2":0.34463,"10.1":0.05222,"11.1-11.2":0.68926,"12.0":3.64475},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.46028,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.1699},"and_qq":{"10.4":0.09494},"and_uc":{"0":0.04997},"op_mini":{"0":0.16558},"and_chr":{"0":51.35501}},"total":96.98365}

/***/ },
/* 1291 */
/***/ function(module, exports) {

	module.exports = {"id":"MR","name":"Mauritania","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.00224,"35":0,"36":0.00224,"37":0,"38":0,"39":0,"40":0,"41":0.00224,"42":0,"43":0.00224,"44":0,"45":0,"46":0,"47":0.00224,"48":0,"49":0.00224,"50":0,"51":0,"52":0.00895,"53":0,"54":0,"55":0,"56":0.02013,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0.00447,"65":0,"66":0,"67":0,"68":0.01566,"69":0.00224,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0.00224,"78":0.0179,"79":0.00447,"80":0.01119,"81":0.4474,"82":0.02684,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0.00224,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0.00224,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0.00224,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.0179,"41":0,"42":0,"43":0.01119,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.01342,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0.04474,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0.00895,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0.00447,"70":0.00895,"71":0.01342,"72":0.02684,"73":0.00224,"74":0.00895,"75":0.00447,"76":0.00224,"77":0.03132,"78":0.01119,"79":0.01566,"80":0.02684,"81":0.02237,"83":0.02237,"84":0.05145,"85":1.02231,"86":1.62183,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0.00224,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.00895,"51":0.00895,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0.00224,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.00895,"71":0.08948,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00447},"ios_saf":{"8":0,"14":3.88037,"3.2":0.0093,"4.0-4.1":0.00797,"4.2-4.3":0.00133,"5.0-5.1":0.00664,"6.0-6.1":0.00398,"7.0-7.1":0.0093,"8.1-8.4":0.03054,"9.0-9.2":0.01726,"9.3":0.22045,"10.0-10.2":0.03718,"10.3":0.20451,"11.0-11.2":0.07702,"11.3-11.4":0.13147,"12.0-12.1":0.13413,"12.2-12.4":1.33728,"13.0-13.1":0.11022,"13.2":0.05445,"13.3":0.41433,"13.4-13.7":2.20711},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00447,"12":0.00224,"13":0.05816,"14":0.02461,"3.1":0,"3.2":0,"5.1":0.44516,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00895,"11.1":0.00447,"12.1":0.01342,"13.1":0.03579},"edge":{"12":0.00224,"13":0.00224,"14":0,"15":0.00224,"16":0.00447,"17":0.00895,"18":0.04474,"79":0,"80":0,"81":0.00224,"83":0,"84":0.00224,"85":0.04474,"86":0.1029},"android":{"3":0,"4":0.1012,"81":null,"2.1":0,"2.2":0,"2.3":0.00081,"4.1":0.051,"4.2-4.3":0.02267,"4.4":0,"4.4.3-4.4.4":0.18459},"samsung":{"4":1.4436,"5.0-5.4":0.09086,"6.2-6.4":0.15143,"7.2-7.4":1.30227,"8.2":0.06057,"9.2":0.78742,"10.1":0.35333,"11.1-11.2":0.58552,"12.0":2.47331},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.0201,"9":0.00287,"10":0.00287,"11":0.14354,"5.5":0},"bb":{"7":0,"10":0.04658},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.12421},"and_qq":{"10.4":0.00776},"and_uc":{"0":0.38815},"op_mini":{"0":1.20532},"and_chr":{"0":74.81881}},"total":97.77795}

/***/ },
/* 1292 */
/***/ function(module, exports) {

	module.exports = {"id":"MS","name":"Montserrat","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.2783,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0.09567,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0,"79":0,"80":0,"81":2.6091,"82":0.2783,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0.09567,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.2783,"71":0.09567,"72":25.66485,"73":0.2783,"74":0,"75":0,"76":0,"77":0,"78":0,"79":0,"80":0,"81":3.63535,"83":0,"84":0,"85":7.37506,"86":11.38437,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.18264,"71":2.24383,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":4.02313,"3.2":0.00964,"4.0-4.1":0.00826,"4.2-4.3":0.00138,"5.0-5.1":0.00688,"6.0-6.1":0.00413,"7.0-7.1":0.00964,"8.1-8.4":0.03167,"9.0-9.2":0.0179,"9.3":0.22856,"10.0-10.2":0.03855,"10.3":0.21203,"11.0-11.2":0.07986,"11.3-11.4":0.13631,"12.0-12.1":0.13906,"12.2-12.4":1.38648,"13.0-13.1":0.11428,"13.2":0.05645,"13.3":0.42957,"13.4-13.7":2.28831},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0.55661,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.2783,"10.1":0,"11.1":0.09567,"12.1":12.22798,"13.1":0},"edge":{"12":0,"13":1.20888,"14":0,"15":0,"16":0,"17":0,"18":0.18264,"79":0,"80":0,"81":0,"83":0,"84":0,"85":0.55661,"86":2.42646},"android":{"3":0,"4":0.13192,"81":null,"2.1":0,"2.2":0,"2.3":0.00106,"4.1":0.06649,"4.2-4.3":0.02955,"4.4":0,"4.4.3-4.4.4":0.24062},"samsung":{"4":0,"5.0-5.4":0.11198,"6.2-6.4":0,"7.2-7.4":0,"8.2":0.21377,"9.2":0,"10.1":0,"11.1-11.2":0,"12.0":0.32575},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0.18264,"10":0.18264,"11":1.77419,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0.10815,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.32575},"and_qq":{"10.4":0},"and_uc":{"0":0},"op_mini":{"0":0.20601},"and_chr":{"0":12.39417}},"total":97.54534}

/***/ },
/* 1293 */
/***/ function(module, exports) {

	module.exports = {"id":"MT","name":"Malta","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.0068,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.0068,"49":0,"50":0,"51":0,"52":0.0272,"53":0,"54":0,"55":0,"56":0.08159,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0.0068,"66":0.0068,"67":0,"68":0.0068,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0.0136,"76":0,"77":0,"78":0.0204,"79":0.0272,"80":0.14958,"81":1.30541,"82":0.18357,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.0068,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.19037,"50":0,"51":0,"52":0,"53":0.0068,"54":0,"55":0,"56":0.0068,"57":0,"58":0,"59":0.0068,"60":0,"61":0.0204,"62":0,"63":0,"64":0,"65":0.0068,"66":0,"67":0.0068,"68":0.0136,"69":0.32635,"70":0.0204,"71":0.0136,"72":0.0204,"73":0.0068,"74":0.0068,"75":0.06119,"76":0.04079,"77":0.11558,"78":0.04079,"79":0.04759,"80":0.08839,"81":0.10878,"83":0.16998,"84":0.28556,"85":14.15552,"86":18.72445,"87":0.0068,"88":0.0068,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.0068,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.0204,"47":0,"48":0,"49":0,"50":0,"51":0.0136,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.08159,"71":0.61191,"72":0.0204,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":7.27513,"3.2":0.01743,"4.0-4.1":0.01494,"4.2-4.3":0.00249,"5.0-5.1":0.01245,"6.0-6.1":0.00747,"7.0-7.1":0.01743,"8.1-8.4":0.05726,"9.0-9.2":0.03237,"9.3":0.4133,"10.0-10.2":0.06971,"10.3":0.38343,"11.0-11.2":0.14441,"11.3-11.4":0.24649,"12.0-12.1":0.25147,"12.2-12.4":2.50721,"13.0-13.1":0.20665,"13.2":0.10208,"13.3":0.77681,"13.4-13.7":4.13801},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.0068,"11":0.0068,"12":0.034,"13":0.20397,"14":1.50938,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.0204,"10.1":0.04079,"11.1":0.05439,"12.1":0.27876,"13.1":1.81533},"edge":{"12":0,"13":0.0204,"14":0.0068,"15":0.0272,"16":0.0136,"17":0.05439,"18":0.30596,"79":0,"80":0,"81":0.0068,"83":0,"84":0.04079,"85":0.91787,"86":1.83573},"android":{"3":0,"4":0.11,"81":null,"2.1":0,"2.2":0,"2.3":0.00088,"4.1":0.05544,"4.2-4.3":0.02464,"4.4":0,"4.4.3-4.4.4":0.20063},"samsung":{"4":0.10276,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.02055,"8.2":0.01028,"9.2":0.0411,"10.1":0.06166,"11.1-11.2":0.06166,"12.0":2.2916},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.47593,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.16965},"and_qq":{"10.4":0.0032},"and_uc":{"0":0.10883},"op_mini":{"0":0.13334},"and_chr":{"0":32.8638}},"total":97.72164}

/***/ },
/* 1294 */
/***/ function(module, exports) {

	module.exports = {"id":"MU","name":"Mauritius","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.02871,"49":0,"50":0,"51":0,"52":0.03445,"53":0,"54":0,"55":0.00574,"56":0.00574,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0.04594,"63":0,"64":0,"65":0,"66":0.00574,"67":0,"68":0.01148,"69":0.00574,"70":0,"71":0,"72":0.01148,"73":0,"74":0.00574,"75":0,"76":0,"77":0.00574,"78":0.09187,"79":0.01148,"80":0.05742,"81":1.44124,"82":0.17226,"83":0.01723,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0.00574,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.00574,"35":0,"36":0,"37":0,"38":0.01148,"39":0.01148,"40":0.00574,"41":0,"42":0.00574,"43":0.00574,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.06316,"50":0,"51":0,"52":0,"53":0.05168,"54":0,"55":0.01723,"56":0,"57":0,"58":0.00574,"59":0,"60":0,"61":0,"62":0,"63":0.01148,"64":0,"65":0.02297,"66":0.00574,"67":0.01723,"68":0,"69":0.00574,"70":0.00574,"71":0.00574,"72":0.01148,"73":0.00574,"74":0.02871,"75":0.02871,"76":0.04019,"77":0.03445,"78":0.03445,"79":0.03445,"80":0.05168,"81":0.18949,"83":0.07465,"84":0.20097,"85":5.98316,"86":9.82456,"87":0.04019,"88":0.00574,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.00574,"47":0.00574,"48":0,"49":0,"50":0.00574,"51":0.05742,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.02871,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.05742,"71":0.43065,"72":0.01148,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00574},"ios_saf":{"8":0,"14":2.7324,"3.2":0.00655,"4.0-4.1":0.00561,"4.2-4.3":0.00094,"5.0-5.1":0.00468,"6.0-6.1":0.00281,"7.0-7.1":0.00655,"8.1-8.4":0.02151,"9.0-9.2":0.01216,"9.3":0.15523,"10.0-10.2":0.02618,"10.3":0.14401,"11.0-11.2":0.05424,"11.3-11.4":0.09258,"12.0-12.1":0.09445,"12.2-12.4":0.94166,"13.0-13.1":0.07761,"13.2":0.03834,"13.3":0.29176,"13.4-13.7":1.55416},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00574,"12":0.04594,"13":0.15503,"14":0.74072,"3.1":0,"3.2":0,"5.1":0.04019,"6.1":0,"7.1":0,"9.1":0.00574,"10.1":0.02871,"11.1":0.10336,"12.1":0.14929,"13.1":0.68904},"edge":{"12":0.02297,"13":0.00574,"14":0.00574,"15":0.00574,"16":0.01148,"17":0.02871,"18":0.13207,"79":0,"80":0,"81":0,"83":0.00574,"84":0.01723,"85":0.42491,"86":0.98762},"android":{"3":0,"4":0.05379,"81":null,"2.1":0,"2.2":0,"2.3":0.00043,"4.1":0.02711,"4.2-4.3":0.01205,"4.4":0,"4.4.3-4.4.4":0.09811},"samsung":{"4":0.19385,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.16324,"8.2":0.03061,"9.2":0.13263,"10.1":0.06121,"11.1-11.2":0.24486,"12.0":3.82591},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.23542,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.23845},"and_qq":{"10.4":0.00426},"and_uc":{"0":0.67276},"op_mini":{"0":0.5684},"and_chr":{"0":51.28352}},"total":87.14112}

/***/ },
/* 1295 */
/***/ function(module, exports) {

	module.exports = {"id":"MV","name":"Maldives","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0.00432,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00864,"30":0,"31":0,"32":0.00432,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.00432,"51":0,"52":0.00432,"53":0,"54":0,"55":0,"56":0.00432,"57":0,"58":0.00432,"59":0,"60":0,"61":0,"62":0.00432,"63":0,"64":0,"65":0,"66":0,"67":0.00432,"68":0.39726,"69":0.00432,"70":0.00432,"71":0.00432,"72":0.00432,"73":0,"74":0.01295,"75":0.00432,"76":0,"77":0.00432,"78":0.01727,"79":0.00432,"80":0.08204,"81":0.98882,"82":0.18567,"83":0.01295,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00432,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00432,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0.00432,"42":0,"43":0,"44":0,"45":0.00432,"46":0.00432,"47":0.00432,"48":0,"49":0.00864,"50":0,"51":0,"52":0.00432,"53":0,"54":0,"55":0.00432,"56":0.00432,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0.00432,"64":0.00432,"65":0.00432,"66":0.00432,"67":0.00432,"68":0,"69":0.02591,"70":0.01727,"71":0.01295,"72":0.01727,"73":0.00432,"74":0.11659,"75":0.01295,"76":0.02159,"77":0.00432,"78":0.0475,"79":0.05613,"80":0.0475,"81":0.03454,"83":0.08204,"84":0.1684,"85":5.54431,"86":8.11784,"87":0.01295,"88":0.01295,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.00432,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00432,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00432,"69":0,"70":0.01727,"71":0.17704,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":9.39936,"3.2":0.02252,"4.0-4.1":0.0193,"4.2-4.3":0.00322,"5.0-5.1":0.01608,"6.0-6.1":0.00965,"7.0-7.1":0.02252,"8.1-8.4":0.07399,"9.0-9.2":0.04182,"9.3":0.53398,"10.0-10.2":0.09007,"10.3":0.49538,"11.0-11.2":0.18657,"11.3-11.4":0.31846,"12.0-12.1":0.32489,"12.2-12.4":3.23927,"13.0-13.1":0.26699,"13.2":0.13189,"13.3":1.00363,"13.4-13.7":5.34625},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00432,"12":0.01295,"13":0.09931,"14":0.44475,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00432,"11.1":0.00864,"12.1":0.10363,"13.1":0.35839},"edge":{"12":0,"13":0.00432,"14":0.00432,"15":0.00432,"16":0.00432,"17":0.02159,"18":0.07772,"79":0,"80":0.00432,"81":0,"83":0.00432,"84":0.00432,"85":0.22885,"86":0.35839},"android":{"3":0,"4":0.12066,"81":null,"2.1":0,"2.2":0,"2.3":0.00097,"4.1":0.06081,"4.2-4.3":0.02703,"4.4":0,"4.4.3-4.4.4":0.22008},"samsung":{"4":0.08379,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.02095,"8.2":0.01047,"9.2":0.05237,"10.1":0.04189,"11.1-11.2":0.12568,"12.0":1.93764},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01952,"9":0.00488,"10":0.00976,"11":0.0781,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.31251},"and_qq":{"10.4":0.00568},"and_uc":{"0":0.86366},"op_mini":{"0":0.29586},"and_chr":{"0":54.27488}},"total":98.27025}

/***/ },
/* 1296 */
/***/ function(module, exports) {

	module.exports = {"id":"MW","name":"Malawi","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0.00383,"6":0,"7":0,"8":0,"9":0,"10":0.00766,"11":0,"12":0,"13":0,"14":0,"15":0.00383,"16":0,"17":0.00383,"18":0,"19":0,"20":0,"21":0.00383,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0.01149,"28":0,"29":0.00766,"30":0.01532,"31":0,"32":0.00383,"33":0,"34":0,"35":0,"36":0.00383,"37":0.00383,"38":0.00383,"39":0,"40":0.00383,"41":0.00383,"42":0.00383,"43":0.00383,"44":0,"45":0.00383,"46":0.00383,"47":0.01532,"48":0,"49":0.00383,"50":0,"51":0,"52":0.01149,"53":0,"54":0,"55":0,"56":0.01149,"57":0.00383,"58":0,"59":0.03447,"60":0.00383,"61":0.01149,"62":0,"63":0,"64":0.00383,"65":0.00383,"66":0,"67":0.00766,"68":0.0766,"69":0.01149,"70":0,"71":0.00383,"72":0.01532,"73":0.01532,"74":0.00766,"75":0,"76":0.00383,"77":0.00383,"78":0.06128,"79":0.01532,"80":0.08426,"81":1.50519,"82":0.22597,"83":0.04596,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00383,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0.00766,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0.00766,"33":0,"34":0,"35":0,"36":0.00383,"37":0,"38":0.00383,"39":0.00766,"40":0.01915,"41":0,"42":0,"43":0.00383,"44":0,"45":0,"46":0.01532,"47":0.00383,"48":0.00383,"49":0.01149,"50":0.00766,"51":0,"52":0,"53":0.00383,"54":0,"55":0.02298,"56":0,"57":0,"58":0.01915,"59":0.00383,"60":0.00383,"61":0.03447,"62":0.00383,"63":0.01149,"64":0.01149,"65":0.00766,"66":0,"67":0.00766,"68":0.01149,"69":0.01149,"70":0.01149,"71":0.01532,"72":0.00766,"73":0.00766,"74":0.03447,"75":0.00383,"76":0.00766,"77":0.01149,"78":0.01532,"79":0.04213,"80":0.09958,"81":0.07277,"83":0.10724,"84":0.12256,"85":2.57376,"86":3.73425,"87":0.01149,"88":0.00383,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0.01532,"18":0,"19":0,"20":0.01915,"21":0,"22":0,"23":0.00383,"24":0.01149,"25":0.00383,"26":0.07277,"27":0.03064,"28":0.07277,"29":0,"30":0.06894,"31":0.00383,"32":0.08043,"33":0.0383,"34":0.00383,"35":0.04979,"36":0.00383,"37":0.01149,"38":0.06894,"39":0,"40":0,"41":0,"42":0.05745,"43":0,"44":0.00383,"45":0.01532,"46":0.05745,"47":0.04979,"48":0.00383,"49":0,"50":0.2298,"51":0.77366,"52":0,"53":0.01915,"54":0.00383,"55":0,"56":0.00383,"57":0,"58":0,"60":0.05362,"62":0,"63":0,"64":0.00766,"65":0,"66":0,"67":0,"68":0.00383,"69":0.01915,"70":0.09958,"71":0.43279,"72":0.01915,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.10341},"ios_saf":{"8":0,"14":1.64511,"3.2":0.00394,"4.0-4.1":0.00338,"4.2-4.3":0.00056,"5.0-5.1":0.00282,"6.0-6.1":0.00169,"7.0-7.1":0.00394,"8.1-8.4":0.01295,"9.0-9.2":0.00732,"9.3":0.09346,"10.0-10.2":0.01576,"10.3":0.0867,"11.0-11.2":0.03265,"11.3-11.4":0.05574,"12.0-12.1":0.05686,"12.2-12.4":0.56695,"13.0-13.1":0.04673,"13.2":0.02308,"13.3":0.17566,"13.4-13.7":0.93572},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.01149,"11":0.01532,"12":0.01532,"13":0.04979,"14":0.11873,"3.1":0,"3.2":0,"5.1":0.90388,"6.1":0,"7.1":0.00383,"9.1":0,"10.1":0.01915,"11.1":0.00766,"12.1":0.02681,"13.1":0.19916},"edge":{"12":0.05362,"13":0.01532,"14":0.01915,"15":0.04596,"16":0.02681,"17":0.08043,"18":0.4596,"79":0,"80":0,"81":0.00766,"83":0.01149,"84":0.04979,"85":0.36768,"86":0.5362},"android":{"3":0,"4":0.09658,"81":null,"2.1":0,"2.2":0,"2.3":0.00077,"4.1":0.04868,"4.2-4.3":0.02163,"4.4":0,"4.4.3-4.4.4":0.17616},"samsung":{"4":0.76091,"5.0-5.4":0.03044,"6.2-6.4":0.04058,"7.2-7.4":0.1116,"8.2":0.02029,"9.2":0.24349,"10.1":0.18262,"11.1-11.2":0.21306,"12.0":2.33347},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01568,"9":0.00784,"10":0.00392,"11":0.13724,"5.5":0},"bb":{"7":0,"10":0.05553},"ie_mob":{"10":0,"11":0.03085},"kaios":{"2.5":0.01234},"baidu":{"0":null},"and_ff":{"0":0.25914},"and_qq":{"10.4":0.11723},"and_uc":{"0":6.06511},"op_mini":{"0":9.73754},"and_chr":{"0":53.33593}},"total":92.80878}

/***/ },
/* 1297 */
/***/ function(module, exports) {

	module.exports = {"id":"MX","name":"Mexico","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0.19569,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.01186,"49":0,"50":0,"51":0,"52":0.01779,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0.00593,"61":0,"62":0,"63":0,"64":0.00593,"65":0,"66":0.01779,"67":0,"68":0.01186,"69":0,"70":0,"71":0,"72":0.00593,"73":0.00593,"74":0,"75":0,"76":0.00593,"77":0.00593,"78":0.08895,"79":0.01186,"80":0.04151,"81":1.34611,"82":0.18383,"83":0.00593,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00593,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0.00593,"36":0,"37":0,"38":0.00593,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.13639,"50":0,"51":0,"52":0.00593,"53":0.00593,"54":0,"55":0,"56":0,"57":0,"58":0.00593,"59":0,"60":0,"61":0.01779,"62":0.00593,"63":0.01186,"64":0.00593,"65":0.03558,"66":0.00593,"67":0.03558,"68":0.00593,"69":0.00593,"70":0.02372,"71":0.02965,"72":0.02372,"73":0.02372,"74":0.02965,"75":0.03558,"76":0.02965,"77":0.03558,"78":0.04151,"79":0.06523,"80":0.10081,"81":0.07709,"83":0.11267,"84":0.21348,"85":9.86159,"86":15.418,"87":0.01186,"88":0.00593,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00593,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.07709,"71":0.68788,"72":0.01186,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":4.38941,"3.2":0.01052,"4.0-4.1":0.00901,"4.2-4.3":0.0015,"5.0-5.1":0.00751,"6.0-6.1":0.00451,"7.0-7.1":0.01052,"8.1-8.4":0.03455,"9.0-9.2":0.01953,"9.3":0.24936,"10.0-10.2":0.04206,"10.3":0.23134,"11.0-11.2":0.08713,"11.3-11.4":0.14872,"12.0-12.1":0.15172,"12.2-12.4":1.51271,"13.0-13.1":0.12468,"13.2":0.06159,"13.3":0.46868,"13.4-13.7":2.49665},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0.00593,"10":0.00593,"11":0.01186,"12":0.04744,"13":0.14825,"14":1.04368,"3.1":0,"3.2":0,"5.1":0.21348,"6.1":0,"7.1":0,"9.1":0.00593,"10.1":0.01779,"11.1":0.08895,"12.1":0.1779,"13.1":1.03775},"edge":{"12":0,"13":0.00593,"14":0.00593,"15":0.00593,"16":0.00593,"17":0.02372,"18":0.10081,"79":0,"80":0,"81":0,"83":0,"84":0.00593,"85":0.56928,"86":1.07926},"android":{"3":0,"4":0.04651,"81":null,"2.1":0,"2.2":0,"2.3":0.00037,"4.1":0.02344,"4.2-4.3":0.01042,"4.4":0,"4.4.3-4.4.4":0.08484},"samsung":{"4":0.08227,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.02057,"8.2":0.01028,"9.2":0.04114,"10.1":0.02057,"11.1-11.2":0.0617,"12.0":0.91528},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01873,"9":0.00624,"10":0.00624,"11":0.20599,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.10989},"and_qq":{"10.4":0},"and_uc":{"0":0.04477},"op_mini":{"0":0.11174},"and_chr":{"0":53.19169}},"total":98.87538}

/***/ },
/* 1298 */
/***/ function(module, exports) {

	module.exports = {"id":"MY","name":"Malaysia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.00496,"35":0,"36":0,"37":0,"38":0,"39":0.00496,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00496,"48":0.00992,"49":0,"50":0,"51":0,"52":0.01983,"53":0,"54":0,"55":0,"56":0.00496,"57":0,"58":0,"59":0,"60":0.00992,"61":0,"62":0,"63":0,"64":0.00496,"65":0.00496,"66":0.00496,"67":0,"68":0.01487,"69":0,"70":0.00496,"71":0,"72":0.00992,"73":0,"74":0,"75":0,"76":0.00496,"77":0.00496,"78":0.04462,"79":0.00992,"80":0.03471,"81":0.96185,"82":0.14874,"83":0.00992,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00496,"23":0,"24":0,"25":0,"26":0.00496,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.01487,"35":0,"36":0,"37":0,"38":0.05454,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0.00496,"45":0,"46":0,"47":0.00496,"48":0,"49":0.08429,"50":0,"51":0,"52":0,"53":0.10412,"54":0,"55":0.04462,"56":0.00992,"57":0.00496,"58":0.01487,"59":0.01983,"60":0.00496,"61":0.00496,"62":0.00992,"63":0.01487,"64":0.00496,"65":0.02479,"66":0.00992,"67":0.02479,"68":0.01983,"69":0.02479,"70":0.03966,"71":0.04462,"72":0.03966,"73":0.07437,"74":0.06941,"75":0.04462,"76":0.02975,"77":0.03471,"78":0.0942,"79":0.06941,"80":0.11403,"81":0.10908,"83":0.14378,"84":0.23303,"85":6.6338,"86":10.62004,"87":0.02479,"88":0.00992,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.01983,"37":0.02975,"38":0,"39":0,"40":0.00496,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.00496,"47":0,"48":0,"49":0,"50":0,"51":0.00992,"52":0,"53":0,"54":0,"55":0.00496,"56":0,"57":0,"58":0,"60":0.01487,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.01983,"71":0.16857,"72":0.00496,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":7.22623,"3.2":0.01731,"4.0-4.1":0.01484,"4.2-4.3":0.00247,"5.0-5.1":0.01237,"6.0-6.1":0.00742,"7.0-7.1":0.01731,"8.1-8.4":0.05688,"9.0-9.2":0.03215,"9.3":0.41053,"10.0-10.2":0.06925,"10.3":0.38085,"11.0-11.2":0.14344,"11.3-11.4":0.24483,"12.0-12.1":0.24978,"12.2-12.4":2.49035,"13.0-13.1":0.20526,"13.2":0.10139,"13.3":0.77159,"13.4-13.7":4.1102},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0.00496,"9":0,"10":0,"11":0.00496,"12":0.00992,"13":0.08924,"14":0.47101,"3.1":0,"3.2":0,"5.1":0.01983,"6.1":0,"7.1":0,"9.1":0,"10.1":0.01487,"11.1":0.03966,"12.1":0.06941,"13.1":0.67925},"edge":{"12":0,"13":0,"14":0,"15":0,"16":0.00496,"17":0.00992,"18":0.04958,"79":0,"80":0,"81":0,"83":0,"84":0.00992,"85":0.20824,"86":0.44622},"android":{"3":0,"4":0.03085,"81":null,"2.1":0,"2.2":0,"2.3":0.00025,"4.1":0.01555,"4.2-4.3":0.00691,"4.4":0,"4.4.3-4.4.4":0.05627},"samsung":{"4":0.63003,"5.0-5.4":0,"6.2-6.4":0.0105,"7.2-7.4":0.021,"8.2":0.0105,"9.2":0.0735,"10.1":0.063,"11.1-11.2":0.12601,"12.0":1.48057},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01771,"9":0.0059,"10":0.0059,"11":0.21839,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.11597},"and_qq":{"10.4":0.02017},"and_uc":{"0":0.99327},"op_mini":{"0":0.69692},"and_chr":{"0":53.79196}},"total":97.63849}

/***/ },
/* 1299 */
/***/ function(module, exports) {

	module.exports = {"id":"MZ","name":"Mozambique","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.00399,"46":0,"47":0.00399,"48":0.00399,"49":0,"50":0,"51":0,"52":0.01995,"53":0.00399,"54":0,"55":0,"56":0,"57":0.00399,"58":0,"59":0,"60":0.00399,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0.00399,"67":0.00399,"68":0.02393,"69":0,"70":0,"71":0,"72":0.00399,"73":0,"74":0.00399,"75":0.00399,"76":0,"77":0.00399,"78":0.04388,"79":0.01197,"80":0.03989,"81":0.85365,"82":0.11568,"83":0.00798,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0.01596,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0.00399,"34":0,"35":0.00399,"36":0.00399,"37":0,"38":0,"39":0,"40":0.01995,"41":0,"42":0.00399,"43":0.0718,"44":0,"45":0,"46":0.00798,"47":0,"48":0,"49":0.06781,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0.03191,"56":0.00399,"57":0,"58":0.00399,"59":0.00399,"60":0.00798,"61":0,"62":0,"63":0.01995,"64":0.00798,"65":0.01995,"66":0.00399,"67":0.01596,"68":0.00399,"69":0.01197,"70":0.00798,"71":0.01995,"72":0.03989,"73":0.01596,"74":0.03989,"75":0.01197,"76":0.01197,"77":0.00798,"78":0.01596,"79":0.05585,"80":0.12366,"81":0.0718,"83":0.05585,"84":0.09973,"85":3.08749,"86":4.99024,"87":0.01197,"88":0.00798,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0.00399,"21":0,"22":0,"23":0,"24":0.01596,"25":0.00399,"26":0.03191,"27":0.00399,"28":0.0359,"29":0.00399,"30":0.03989,"31":0.00399,"32":0.05984,"33":0.01995,"34":0,"35":0.17951,"36":0.00399,"37":0,"38":0.02792,"39":0.00399,"40":0,"41":0.00399,"42":0.0359,"43":0,"44":0.00399,"45":0.01596,"46":0.12366,"47":0.1077,"48":0,"49":0,"50":0.44278,"51":1.26052,"52":0.00399,"53":0.00798,"54":0.00399,"55":0,"56":0,"57":0,"58":0.00399,"60":0.04388,"62":0,"63":0,"64":0.00399,"65":0,"66":0,"67":0,"68":0.00798,"69":0.00399,"70":0.13563,"71":0.85365,"72":0.01995,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.05984},"ios_saf":{"8":0,"14":2.41506,"3.2":0.00579,"4.0-4.1":0.00496,"4.2-4.3":0.00083,"5.0-5.1":0.00413,"6.0-6.1":0.00248,"7.0-7.1":0.00579,"8.1-8.4":0.01901,"9.0-9.2":0.01074,"9.3":0.1372,"10.0-10.2":0.02314,"10.3":0.12728,"11.0-11.2":0.04794,"11.3-11.4":0.08182,"12.0-12.1":0.08348,"12.2-12.4":0.8323,"13.0-13.1":0.0686,"13.2":0.03389,"13.3":0.25787,"13.4-13.7":1.37366},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.01197,"12":0.02393,"13":0.05186,"14":0.24333,"3.1":0,"3.2":0,"5.1":0.07978,"6.1":0,"7.1":0,"9.1":0,"10.1":0.02792,"11.1":0.01995,"12.1":0.0359,"13.1":0.20743},"edge":{"12":0.01995,"13":0.01197,"14":0.01197,"15":0.02792,"16":0.01197,"17":0.02393,"18":0.1436,"79":0,"80":0,"81":0.00399,"83":0,"84":0.00798,"85":0.27524,"86":0.48666},"android":{"3":0,"4":0.05673,"81":null,"2.1":0,"2.2":0,"2.3":0.00045,"4.1":0.02859,"4.2-4.3":0.01271,"4.4":0,"4.4.3-4.4.4":0.10348},"samsung":{"4":1.2371,"5.0-5.4":0.0409,"6.2-6.4":0.0409,"7.2-7.4":0.24538,"8.2":0.01022,"9.2":0.17381,"10.1":0.10224,"11.1-11.2":0.23515,"12.0":1.40069},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01815,"9":0,"10":0,"11":0.21322,"5.5":0},"bb":{"7":0,"10":0.09017},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.07213},"and_qq":{"10.4":0.06011},"and_uc":{"0":0.73334},"op_mini":{"0":10.64185},"and_chr":{"0":58.73742}},"total":95.27617}

/***/ },
/* 1300 */
/***/ function(module, exports) {

	module.exports = {"id":"NA","name":"Namibia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00412,"30":0,"31":0,"32":0,"33":0,"34":0.00412,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00824,"48":0.00412,"49":0,"50":0,"51":0,"52":0.02885,"53":0,"54":0,"55":0,"56":0.00824,"57":0,"58":0,"59":0,"60":0.00824,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.04534,"69":0.00412,"70":0,"71":0,"72":0.00412,"73":0.00412,"74":0,"75":0,"76":0.00824,"77":0.00412,"78":0.05359,"79":0.00824,"80":0.03298,"81":1.12118,"82":0.18961,"83":0.01649,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00412,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.02885,"50":0.00412,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0.02061,"58":0.00824,"59":0,"60":0,"61":0,"62":0.00412,"63":0.00824,"64":0.00412,"65":0.01649,"66":0.00824,"67":0.00412,"68":0.01237,"69":0.01649,"70":0.01649,"71":0.01237,"72":0.00412,"73":0.00824,"74":0.01649,"75":0.02885,"76":0.01649,"77":0.00412,"78":0.00824,"79":0.04946,"80":0.14427,"81":0.06595,"83":0.0371,"84":0.10717,"85":3.41302,"86":5.7337,"87":0.00824,"88":0.00412,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0.00412,"27":0,"28":0.01649,"29":0,"30":0,"31":0,"32":0.00412,"33":0,"34":0,"35":0.01649,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.00412,"47":0.00412,"48":0,"49":0,"50":0.0371,"51":0.25969,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00412,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00412,"69":0,"70":0.05359,"71":0.36274,"72":0.00824,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00412},"ios_saf":{"8":0,"14":2.84529,"3.2":0.00682,"4.0-4.1":0.00584,"4.2-4.3":0.00097,"5.0-5.1":0.00487,"6.0-6.1":0.00292,"7.0-7.1":0.00682,"8.1-8.4":0.0224,"9.0-9.2":0.01266,"9.3":0.16164,"10.0-10.2":0.02726,"10.3":0.14996,"11.0-11.2":0.05648,"11.3-11.4":0.0964,"12.0-12.1":0.09835,"12.2-12.4":0.98056,"13.0-13.1":0.08082,"13.2":0.03992,"13.3":0.30381,"13.4-13.7":1.61837},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00824,"12":0.01237,"13":0.06595,"14":0.39571,"3.1":0,"3.2":0,"5.1":0.00824,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00412,"11.1":0.02885,"12.1":0.02473,"13.1":0.43693},"edge":{"12":0.01649,"13":0.01237,"14":0.01237,"15":0.01237,"16":0.02061,"17":0.04946,"18":0.23083,"79":0,"80":0,"81":0.00412,"83":0.00412,"84":0.01237,"85":0.46991,"86":0.97691},"android":{"3":0,"4":0.07899,"81":null,"2.1":0,"2.2":0,"2.3":0.00063,"4.1":0.03981,"4.2-4.3":0.01769,"4.4":0,"4.4.3-4.4.4":0.14409},"samsung":{"4":0.60997,"5.0-5.4":0.09149,"6.2-6.4":0.22365,"7.2-7.4":2.15521,"8.2":0.08133,"9.2":0.19316,"10.1":0.23382,"11.1-11.2":0.52864,"12.0":4.94073},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00458,"9":0,"10":0,"11":0.53128,"5.5":0},"bb":{"7":0,"10":0.12932},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.28214},"and_qq":{"10.4":0.01176},"and_uc":{"0":0.51139},"op_mini":{"0":1.21315},"and_chr":{"0":62.02167}},"total":95.53356}

/***/ },
/* 1301 */
/***/ function(module, exports) {

	module.exports = {"id":"NC","name":"New Caledonia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.01165,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.00583,"46":0,"47":0.00583,"48":0.13402,"49":0,"50":0,"51":0,"52":0.06992,"53":0,"54":0.02331,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0.12237,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0.00583,"67":0.01165,"68":0.09906,"69":0.00583,"70":0,"71":0,"72":0.00583,"73":0,"74":0,"75":0,"76":0.00583,"77":0.01165,"78":0.48364,"79":0.00583,"80":0.10489,"81":3.75259,"82":0.75168,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0.00583,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.09906,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.11654,"50":0,"51":0,"52":0,"53":0.00583,"54":0,"55":0,"56":0.01165,"57":0.00583,"58":0,"59":0,"60":0.01748,"61":0,"62":0,"63":0.00583,"64":0,"65":0.20395,"66":0,"67":0.01165,"68":0.00583,"69":0.00583,"70":0.01165,"71":0.00583,"72":0.04662,"73":0.02331,"74":0.00583,"75":0.00583,"76":0.01165,"77":0.05244,"78":0.05244,"79":0.02331,"80":0.04662,"81":0.11071,"83":0.03496,"84":0.15733,"85":6.75932,"86":10.50025,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.05244,"71":0.37876,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":8.07264,"3.2":0.01934,"4.0-4.1":0.01658,"4.2-4.3":0.00276,"5.0-5.1":0.01381,"6.0-6.1":0.00829,"7.0-7.1":0.01934,"8.1-8.4":0.06354,"9.0-9.2":0.03592,"9.3":0.45861,"10.0-10.2":0.07736,"10.3":0.42546,"11.0-11.2":0.16024,"11.3-11.4":0.27351,"12.0-12.1":0.27903,"12.2-12.4":2.78205,"13.0-13.1":0.2293,"13.2":0.11327,"13.3":0.86197,"13.4-13.7":4.59162},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.02331,"13":0.42537,"14":1.32273,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.00583,"10.1":0.03496,"11.1":0.07575,"12.1":0.28552,"13.1":2.40655},"edge":{"12":0,"13":0.00583,"14":0.00583,"15":0.01748,"16":0.01165,"17":0.03496,"18":0.18064,"79":0,"80":0,"81":0,"83":0.01165,"84":0.01165,"85":0.54774,"86":1.24115},"android":{"3":0,"4":0.08142,"81":null,"2.1":0,"2.2":0,"2.3":0.00065,"4.1":0.04103,"4.2-4.3":0.01824,"4.4":0,"4.4.3-4.4.4":0.14851},"samsung":{"4":0.08534,"5.0-5.4":0.01067,"6.2-6.4":0.01067,"7.2-7.4":0.38405,"8.2":0.01067,"9.2":0.27737,"10.1":0.09601,"11.1-11.2":0.22403,"12.0":4.19255},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00593,"9":0,"10":0,"11":0.32038,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.33801},"and_qq":{"10.4":0},"and_uc":{"0":0.02087},"op_mini":{"0":0.03161},"and_chr":{"0":40.48227}},"total":96.32537}

/***/ },
/* 1302 */
/***/ function(module, exports) {

	module.exports = {"id":"NE","name":"Niger","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0.01316,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0.00329,"29":0,"30":0.00329,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.01975,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00658,"44":0,"45":0,"46":0,"47":0.00329,"48":0.01975,"49":0,"50":0,"51":0,"52":0.00329,"53":0,"54":0,"55":0,"56":0.00329,"57":0,"58":0,"59":0,"60":0.00329,"61":0,"62":0,"63":0,"64":0,"65":0.04278,"66":0.02304,"67":0,"68":0.02962,"69":0,"70":0,"71":0,"72":0.02633,"73":0,"74":0.00329,"75":0.00329,"76":0,"77":0,"78":0.06253,"79":0.01316,"80":0.05595,"81":1.34602,"82":0.11848,"83":0.01975,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.06911,"41":0,"42":0,"43":0.00329,"44":0,"45":0.06253,"46":0,"47":0,"48":0,"49":0.05595,"50":0,"51":0,"52":0,"53":0.00658,"54":0,"55":0.00658,"56":0,"57":0,"58":0.20733,"59":0,"60":0,"61":0,"62":0,"63":0.00329,"64":0.00329,"65":0,"66":0.00329,"67":0.00329,"68":0,"69":0,"70":0.00329,"71":0.01975,"72":0.00658,"73":0.00329,"74":0,"75":0.1481,"76":0.06911,"77":0.04278,"78":0.00987,"79":0.08228,"80":0.05595,"81":0.01646,"83":0.04607,"84":0.06911,"85":1.18805,"86":1.88245,"87":0.06911,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0.00329,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0.00329,"24":0.01316,"25":0,"26":0.01975,"27":0.02304,"28":0.02962,"29":0.00329,"30":0.0362,"31":0.04607,"32":0.00987,"33":0.00987,"34":0.00329,"35":0.00329,"36":0,"37":0,"38":0.00329,"39":0,"40":0,"41":0.02633,"42":0.02304,"43":0,"44":0,"45":0.04607,"46":0.02304,"47":0.01975,"48":0.00329,"49":0,"50":0.06911,"51":0.40479,"52":0,"53":0,"54":0.00329,"55":0,"56":0,"57":0,"58":0,"60":0.00329,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0.00329,"70":0.09215,"71":0.30935,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.02304},"ios_saf":{"8":0,"14":1.672,"3.2":0.00401,"4.0-4.1":0.00343,"4.2-4.3":0.00057,"5.0-5.1":0.00286,"6.0-6.1":0.00172,"7.0-7.1":0.00401,"8.1-8.4":0.01316,"9.0-9.2":0.00744,"9.3":0.09499,"10.0-10.2":0.01602,"10.3":0.08812,"11.0-11.2":0.03319,"11.3-11.4":0.05665,"12.0-12.1":0.05779,"12.2-12.4":0.57622,"13.0-13.1":0.04749,"13.2":0.02346,"13.3":0.17853,"13.4-13.7":0.95101},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00329,"11":0.00987,"12":0.01316,"13":0.03291,"14":0.04937,"3.1":0,"3.2":0,"5.1":0.56276,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00329,"11.1":0,"12.1":0.00987,"13.1":0.11848},"edge":{"12":0.00987,"13":0.00329,"14":0.00329,"15":0.00658,"16":0.00658,"17":0.02962,"18":0.13493,"79":0,"80":0,"81":0,"83":0,"84":0.01316,"85":0.08228,"86":0.25341},"android":{"3":0,"4":0.57087,"81":null,"2.1":0,"2.2":0,"2.3":0.00457,"4.1":0.28772,"4.2-4.3":0.12787,"4.4":0,"4.4.3-4.4.4":1.04126},"samsung":{"4":0.15176,"5.0-5.4":0.02024,"6.2-6.4":0.02024,"7.2-7.4":0.05059,"8.2":0,"9.2":0.2327,"10.1":0.04047,"11.1-11.2":0.06071,"12.0":0.67788},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.13164,"9":0,"10":0,"11":1.9746,"5.5":0},"bb":{"7":0,"10":0.04696},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.02013},"baidu":{"0":null},"and_ff":{"0":0.28178},"and_qq":{"10.4":0.36229},"and_uc":{"0":2.3817},"op_mini":{"0":6.50409},"and_chr":{"0":69.11793}},"total":96.50383}

/***/ },
/* 1303 */
/***/ function(module, exports) {

	module.exports = {"id":"NF","name":"Norfolk Island","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.68741,"35":0.61691,"36":0,"37":0,"38":0.68741,"39":0,"40":0,"41":0.14101,"42":0.0705,"43":0.51115,"44":1.81548,"45":0.75792,"46":0.65216,"47":0,"48":0,"49":0,"50":1.13688,"51":0.10576,"52":0.85486,"53":0.58166,"54":0.0705,"55":0,"56":0.72267,"57":0.44946,"58":0.10576,"59":0,"60":0.41421,"61":0.54641,"62":0.51115,"63":0.03525,"64":0,"65":0.51115,"66":0,"67":0,"68":1.37483,"69":0,"70":0.44946,"71":0.23795,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0.03525,"79":0,"80":1.13688,"81":4.52988,"82":0.03525,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0.10576,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.54641,"23":0,"24":0,"25":0.0705,"26":0.34371,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.0705,"35":0,"36":0.75792,"37":0,"38":0,"39":0.0705,"40":0,"41":0,"42":0,"43":0.0705,"44":0,"45":0,"46":0.30846,"47":1.06637,"48":0.0705,"49":2.26494,"50":0,"51":0.10576,"52":0,"53":0,"54":0.2732,"55":0.0705,"56":0.85486,"57":0.72267,"58":0.03525,"59":0.79317,"60":0.61691,"61":0.44946,"62":0.0705,"63":0.72267,"64":1.03112,"65":0.0705,"66":0.54641,"67":1.41008,"68":0.68741,"69":0.81961,"70":2.95236,"71":0.48472,"72":0.44946,"73":0,"74":0.51115,"75":1.26907,"76":0,"77":0.61691,"78":1.23382,"79":1.26907,"80":1.92123,"81":0.16745,"83":0.0705,"84":0.03525,"85":3.56927,"86":10.09089,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0.14101,"15":0.51115,"16":0,"17":0,"18":0,"19":0.58166,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0.2027,"29":0,"30":0,"31":0,"32":0,"33":0.0705,"34":0,"35":0,"36":0.23795,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.0705,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.03525,"71":0.03525,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":3.63869,"3.2":0.00872,"4.0-4.1":0.00747,"4.2-4.3":0.00125,"5.0-5.1":0.00623,"6.0-6.1":0.00374,"7.0-7.1":0.00872,"8.1-8.4":0.02864,"9.0-9.2":0.01619,"9.3":0.20672,"10.0-10.2":0.03487,"10.3":0.19177,"11.0-11.2":0.07223,"11.3-11.4":0.12328,"12.0-12.1":0.12577,"12.2-12.4":1.25399,"13.0-13.1":0.10336,"13.2":0.05106,"13.3":0.38853,"13.4-13.7":2.06965},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0.0705,"10":0.61691,"11":0.75792,"12":5.66676,"13":0,"14":0,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.16745,"11.1":0,"12.1":0,"13.1":0.41421},"edge":{"12":0,"13":0.0705,"14":0.44946,"15":0.68741,"16":0,"17":0.65216,"18":0.89011,"79":0,"80":0,"81":0,"83":0,"84":0,"85":0.14101,"86":0.16745},"android":{"3":0,"4":0.07818,"81":null,"2.1":0,"2.2":0,"2.3":0.00063,"4.1":0.0394,"4.2-4.3":0.01751,"4.4":0,"4.4.3-4.4.4":0.14259},"samsung":{"4":0,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0,"8.2":0,"9.2":0,"10.1":1.0463,"11.1-11.2":0,"12.0":1.15914},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.03525,"9":0.16745,"10":0,"11":0.89011,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0.16048,"11":0.04012},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0},"and_qq":{"10.4":0},"and_uc":{"0":0},"op_mini":{"0":0},"and_chr":{"0":11.3659}},"total":95.57423}

/***/ },
/* 1304 */
/***/ function(module, exports) {

	module.exports = {"id":"NG","name":"Nigeria","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.0024,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.01679,"44":0,"45":0,"46":0,"47":0.00719,"48":0.0048,"49":0.0024,"50":0.0024,"51":0,"52":0.01199,"53":0,"54":0.0024,"55":0,"56":0.0024,"57":0.0024,"58":0,"59":0,"60":0.0024,"61":0.0024,"62":0.0024,"63":0.0024,"64":0.0024,"65":0.0024,"66":0.0024,"67":0.0024,"68":0.04077,"69":0.0024,"70":0.0024,"71":0.0024,"72":0.00719,"73":0.0024,"74":0.0024,"75":0,"76":0,"77":0.0048,"78":0.01679,"79":0.00959,"80":0.03117,"81":0.52516,"82":0.07913,"83":0.00959,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.0024,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.0048,"41":0,"42":0,"43":0.0024,"44":0,"45":0,"46":0,"47":0.01199,"48":0,"49":0.00719,"50":0.0048,"51":0,"52":0,"53":0.0024,"54":0,"55":0.0048,"56":0.0024,"57":0.0024,"58":0.00719,"59":0,"60":0,"61":0.0024,"62":0.0048,"63":0.00959,"64":0.01199,"65":0.0048,"66":0.0024,"67":0.0024,"68":0.0024,"69":0.00719,"70":0.01199,"71":0.01199,"72":0.00959,"73":0.00959,"74":0.02158,"75":0.00719,"76":0.00959,"77":0.01679,"78":0.01199,"79":0.02878,"80":0.05276,"81":0.04316,"83":0.03837,"84":0.07434,"85":1.29492,"86":1.69778,"87":0.0048,"88":0.0024,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0.0024,"17":0,"18":0,"19":0.0024,"20":0.00719,"21":0,"22":0,"23":0.01439,"24":0.12709,"25":0.0048,"26":0.09352,"27":0.19184,"28":0.09592,"29":0.01918,"30":0.11031,"31":0.03597,"32":0.09352,"33":0.04796,"34":0.0024,"35":0.01199,"36":0.00959,"37":0.00959,"38":0.06714,"39":0.0024,"40":0,"41":0.0048,"42":0.09112,"43":0.0024,"44":0.00719,"45":0.04077,"46":0.20623,"47":0.15347,"48":0.0048,"49":0,"50":0.65945,"51":1.39084,"52":0,"53":0.00959,"54":0.0048,"55":0.0024,"56":0.0024,"57":0.0024,"58":0.01199,"60":0.02638,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.0024,"69":0,"70":0.03357,"71":0.16786,"72":0.0048,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.1175},"ios_saf":{"8":0,"14":2.36309,"3.2":0.00566,"4.0-4.1":0.00485,"4.2-4.3":0.00081,"5.0-5.1":0.00404,"6.0-6.1":0.00243,"7.0-7.1":0.00566,"8.1-8.4":0.0186,"9.0-9.2":0.01051,"9.3":0.13425,"10.0-10.2":0.02264,"10.3":0.12454,"11.0-11.2":0.04691,"11.3-11.4":0.08006,"12.0-12.1":0.08168,"12.2-12.4":0.81439,"13.0-13.1":0.06712,"13.2":0.03316,"13.3":0.25232,"13.4-13.7":1.3441},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.0048,"13":0.01199,"14":0.05276,"3.1":0,"3.2":0,"5.1":0.04077,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0.00719,"12.1":0.01199,"13.1":0.03597},"edge":{"12":0.00719,"13":0.0024,"14":0.0024,"15":0.0048,"16":0.0024,"17":0.0048,"18":0.02878,"79":0,"80":0,"81":0,"83":0,"84":0.0024,"85":0.08873,"86":0.13189},"android":{"3":0,"4":0.0391,"81":null,"2.1":0,"2.2":0,"2.3":0.00031,"4.1":0.0197,"4.2-4.3":0.00876,"4.4":0,"4.4.3-4.4.4":0.07131},"samsung":{"4":0.09407,"5.0-5.4":0.02091,"6.2-6.4":0,"7.2-7.4":0.05226,"8.2":0.01045,"9.2":0.09407,"10.1":0.05226,"11.1-11.2":0.10453,"12.0":0.74215},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01363,"9":0.00341,"10":0.00341,"11":0.0443,"5.5":0},"bb":{"7":0,"10":0.05321},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.03041},"baidu":{"0":null},"and_ff":{"0":0.40291},"and_qq":{"10.4":0.02281},"and_uc":{"0":1.8853},"op_mini":{"0":27.29853},"and_chr":{"0":49.09894}},"total":94.18049}

/***/ },
/* 1305 */
/***/ function(module, exports) {

	module.exports = {"id":"NI","name":"Nicaragua","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00674,"44":0,"45":0,"46":0,"47":0,"48":0.01349,"49":0,"50":0,"51":0.00674,"52":0.02023,"53":0.00674,"54":0,"55":0,"56":0.00674,"57":0,"58":0.00674,"59":0,"60":0.00674,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0.02023,"67":0.00674,"68":0.00674,"69":0.00674,"70":0.00674,"71":0,"72":0.02023,"73":0,"74":0,"75":0,"76":0.00674,"77":0.00674,"78":0.05394,"79":0.01349,"80":0.06069,"81":2.15102,"82":0.26298,"83":0.00674,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.02023,"39":0,"40":0,"41":0,"42":0.00674,"43":0.00674,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.12812,"50":0,"51":0,"52":0.00674,"53":0.00674,"54":0,"55":0,"56":0.00674,"57":0,"58":0.02023,"59":0,"60":0,"61":0,"62":0,"63":0.01349,"64":0.00674,"65":0.00674,"66":0.01349,"67":0.01349,"68":0.01349,"69":0.02697,"70":0.02023,"71":0.02697,"72":0.02023,"73":0.01349,"74":0.0944,"75":0.05394,"76":0.04046,"77":0.02697,"78":0.10789,"79":0.08766,"80":0.15509,"81":0.13486,"83":0.10789,"84":1.8341,"85":10.97086,"86":19.87162,"87":0.02023,"88":0.01349,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00674,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0.01349,"64":0,"65":0,"66":0,"67":0,"68":0.00674,"69":1.01819,"70":0.11463,"71":1.28117,"72":0.01349,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":2.06006,"3.2":0.00494,"4.0-4.1":0.00423,"4.2-4.3":0.00071,"5.0-5.1":0.00353,"6.0-6.1":0.00212,"7.0-7.1":0.00494,"8.1-8.4":0.01622,"9.0-9.2":0.00917,"9.3":0.11703,"10.0-10.2":0.01974,"10.3":0.10857,"11.0-11.2":0.04089,"11.3-11.4":0.0698,"12.0-12.1":0.07121,"12.2-12.4":0.70995,"13.0-13.1":0.05852,"13.2":0.02891,"13.3":0.21997,"13.4-13.7":1.17174},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.01349,"12":0.02023,"13":0.10115,"14":0.66081,"3.1":0,"3.2":0,"5.1":0.68104,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0.06743,"12.1":0.06069,"13.1":0.51921},"edge":{"12":0.00674,"13":0.00674,"14":0.01349,"15":0.00674,"16":0.00674,"17":0.01349,"18":0.07417,"79":0,"80":0.00674,"81":0.00674,"83":0,"84":0.01349,"85":0.62036,"86":1.17328},"android":{"3":0,"4":0.08055,"81":null,"2.1":0,"2.2":0,"2.3":0.00064,"4.1":0.0406,"4.2-4.3":0.01804,"4.4":0,"4.4.3-4.4.4":0.14692},"samsung":{"4":0.25339,"5.0-5.4":0.02027,"6.2-6.4":0.04054,"7.2-7.4":0.13176,"8.2":0.01014,"9.2":0.1419,"10.1":0.09122,"11.1-11.2":0.26353,"12.0":1.73319},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.08092,"5.5":0},"bb":{"7":0,"10":0.00326},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.10097},"and_qq":{"10.4":0},"and_uc":{"0":0.17914},"op_mini":{"0":0.18809},"and_chr":{"0":45.48055}},"total":96.85608}

/***/ },
/* 1306 */
/***/ function(module, exports) {

	module.exports = {"id":"NL","name":"Netherlands","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00602,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00602,"49":0,"50":0,"51":0,"52":0.03011,"53":0,"54":0,"55":0.00602,"56":0.01204,"57":0,"58":0,"59":0,"60":0.00602,"61":0,"62":0.02408,"63":0.00602,"64":0.00602,"65":0.00602,"66":0.00602,"67":0,"68":0.04215,"69":0.00602,"70":0,"71":0,"72":0.01204,"73":0,"74":0.00602,"75":0.00602,"76":0.00602,"77":0.01204,"78":0.08429,"79":0.02408,"80":0.08429,"81":1.70394,"82":0.25288,"83":0.00602,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00602,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.03011,"48":0.01806,"49":0.16859,"50":0,"51":0,"52":0.01204,"53":0.00602,"54":0,"55":0.00602,"56":0,"57":0,"58":0.00602,"59":0,"60":0.00602,"61":0.03613,"62":0,"63":0.00602,"64":0.03011,"65":0.00602,"66":0.01204,"67":0.01204,"68":0.00602,"69":0.02408,"70":0.08429,"71":0.05419,"72":0.09032,"73":0.04817,"74":0.01806,"75":0.03011,"76":0.07225,"77":0.03011,"78":0.03613,"79":0.1445,"80":0.15053,"81":0.09634,"83":0.28299,"84":0.33116,"85":9.66973,"86":11.50613,"87":0.01204,"88":0.00602,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.01806,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0.00602,"58":0.00602,"60":0.00602,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0.00602,"68":0.00602,"69":0,"70":0.04215,"71":0.26492,"72":0.00602,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":11.78302,"3.2":0.02823,"4.0-4.1":0.0242,"4.2-4.3":0.00403,"5.0-5.1":0.02016,"6.0-6.1":0.0121,"7.0-7.1":0.02823,"8.1-8.4":0.09275,"9.0-9.2":0.05242,"9.3":0.6694,"10.0-10.2":0.11291,"10.3":0.62101,"11.0-11.2":0.23389,"11.3-11.4":0.39922,"12.0-12.1":0.40728,"12.2-12.4":4.06075,"13.0-13.1":0.3347,"13.2":0.16533,"13.3":1.25815,"13.4-13.7":6.70205},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.01204,"12":0.04215,"13":0.21676,"14":1.96285,"3.1":0,"3.2":0,"5.1":0.01204,"6.1":0,"7.1":0,"9.1":0.00602,"10.1":0.02408,"11.1":0.08429,"12.1":0.16859,"13.1":2.35421},"edge":{"12":0,"13":0,"14":0.00602,"15":0.00602,"16":0.00602,"17":0.03011,"18":0.27095,"79":0,"80":0,"81":0.01204,"83":0.00602,"84":0.01806,"85":1.01755,"86":1.69792},"android":{"3":0,"4":0.05002,"81":null,"2.1":0,"2.2":0,"2.3":0.0004,"4.1":0.02521,"4.2-4.3":0.0112,"4.4":0,"4.4.3-4.4.4":0.09123},"samsung":{"4":0.09276,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.02061,"8.2":0.01031,"9.2":0.05153,"10.1":0.04123,"11.1-11.2":0.09276,"12.0":4.58659},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0.01022,"7":0.01022,"8":0.0613,"9":0.02043,"10":0.03065,"11":0.8787,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.27853},"and_qq":{"10.4":0.02387},"and_uc":{"0":0.3024},"op_mini":{"0":0.20719},"and_chr":{"0":28.30922}},"total":95.94603}

/***/ },
/* 1307 */
/***/ function(module, exports) {

	module.exports = {"id":"NO","name":"Norway","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00629,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00629,"49":0,"50":0,"51":0,"52":0.01258,"53":0,"54":0,"55":0,"56":0.01888,"57":0,"58":0,"59":0.01258,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0.00629,"66":0,"67":0,"68":0.02517,"69":0,"70":0,"71":0,"72":0.00629,"73":0,"74":0.00629,"75":0.00629,"76":0.01258,"77":0.00629,"78":0.0755,"79":0.01888,"80":0.06292,"81":1.21436,"82":0.16359,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00629,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.03775,"50":0,"51":0.00629,"52":0,"53":0.00629,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0.00629,"60":0,"61":0,"62":0.01258,"63":0.00629,"64":0.00629,"65":0.01258,"66":0.06292,"67":0.03146,"68":0.01888,"69":0.09438,"70":0.01888,"71":0.02517,"72":0.01258,"73":0.03146,"74":0.00629,"75":0.03146,"76":0.03775,"77":0.03775,"78":0.03775,"79":0.0755,"80":0.11955,"81":0.19505,"83":0.2328,"84":1.15773,"85":11.74087,"86":12.80422,"87":0.01258,"88":0.00629,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.00629,"51":0.00629,"52":0,"53":0.00629,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00629,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00629,"69":0,"70":0.11326,"71":0.50965,"72":0.00629,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":16.20531,"3.2":0.03882,"4.0-4.1":0.03328,"4.2-4.3":0.00555,"5.0-5.1":0.02773,"6.0-6.1":0.01664,"7.0-7.1":0.03882,"8.1-8.4":0.12756,"9.0-9.2":0.0721,"9.3":0.92063,"10.0-10.2":0.15529,"10.3":0.85408,"11.0-11.2":0.32167,"11.3-11.4":0.54905,"12.0-12.1":0.56014,"12.2-12.4":5.58479,"13.0-13.1":0.46031,"13.2":0.22738,"13.3":1.73034,"13.4-13.7":9.21739},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00629,"11":0.01888,"12":0.06292,"13":0.40269,"14":2.15186,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.01258,"10.1":0.04404,"11.1":0.13213,"12.1":0.27056,"13.1":3.03904},"edge":{"12":0,"13":0,"14":0.00629,"15":0.00629,"16":0.00629,"17":0.03775,"18":0.28943,"79":0,"80":0.02517,"81":0,"83":0.01258,"84":0.01888,"85":0.76762,"86":1.40312},"android":{"3":0,"4":0.02664,"81":null,"2.1":0,"2.2":0,"2.3":0.00021,"4.1":0.01343,"4.2-4.3":0.00597,"4.4":0,"4.4.3-4.4.4":0.04859},"samsung":{"4":0.03134,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0,"8.2":0,"9.2":0.03134,"10.1":0.02089,"11.1-11.2":0.03134,"12.0":2.56969},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.61662,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.1372},"and_qq":{"10.4":0.00371},"and_uc":{"0":0.0445},"op_mini":{"0":0.15797},"and_chr":{"0":19.15018}},"total":97.9646}

/***/ },
/* 1308 */
/***/ function(module, exports) {

	module.exports = {"id":"NP","name":"Nepal","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00309,"48":0,"49":0,"50":0,"51":0,"52":0.00927,"53":0,"54":0,"55":0,"56":0.00309,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00309,"69":0.00309,"70":0,"71":0,"72":0.00309,"73":0,"74":0,"75":0,"76":0.00309,"77":0.00309,"78":0.02162,"79":0.00618,"80":0.01236,"81":0.47571,"82":0.0834,"83":0.00618,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0.00309,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.00309,"41":0,"42":0,"43":0.00309,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.00618,"50":0,"51":0,"52":0,"53":0.00309,"54":0,"55":0,"56":0,"57":0,"58":0.00309,"59":0,"60":0,"61":0.00309,"62":0,"63":0.00618,"64":0.00309,"65":0.00309,"66":0,"67":0.00309,"68":0,"69":0.00309,"70":0.00618,"71":0.01236,"72":0.00309,"73":0.00618,"74":0.01236,"75":0.00618,"76":0.00618,"77":0.00618,"78":0.00927,"79":0.01853,"80":0.0278,"81":0.04016,"83":0.02471,"84":0.06796,"85":2.84188,"86":3.71607,"87":0.01853,"88":0.00618,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.00309,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.00309,"51":0.01545,"52":0,"53":0,"54":0,"55":0.00309,"56":0,"57":0,"58":0,"60":0.00618,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.04325,"71":0.21932,"72":0.00309,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00309},"ios_saf":{"8":0,"14":2.61734,"3.2":0.00627,"4.0-4.1":0.00537,"4.2-4.3":0.0009,"5.0-5.1":0.00448,"6.0-6.1":0.00269,"7.0-7.1":0.00627,"8.1-8.4":0.0206,"9.0-9.2":0.01164,"9.3":0.14869,"10.0-10.2":0.02508,"10.3":0.13794,"11.0-11.2":0.05195,"11.3-11.4":0.08868,"12.0-12.1":0.09047,"12.2-12.4":0.90201,"13.0-13.1":0.07435,"13.2":0.03673,"13.3":0.27947,"13.4-13.7":1.48871},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.00309,"13":0.00927,"14":0.04942,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00309,"11.1":0.00309,"12.1":0.00927,"13.1":0.0556},"edge":{"12":0.00309,"13":0,"14":0.00309,"15":0.00309,"16":0,"17":0.00309,"18":0.01853,"79":0,"80":0,"81":0,"83":0,"84":0.00309,"85":0.3367,"86":0.72283},"android":{"3":0,"4":0.06837,"81":null,"2.1":0,"2.2":0,"2.3":0.00055,"4.1":0.03446,"4.2-4.3":0.01532,"4.4":0,"4.4.3-4.4.4":0.12471},"samsung":{"4":0.25766,"5.0-5.4":0,"6.2-6.4":0.01031,"7.2-7.4":0.09276,"8.2":0.02061,"9.2":0.06184,"10.1":0.05153,"11.1-11.2":0.11337,"12.0":1.17495},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.01545,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.0622},"and_qq":{"10.4":0.00691},"and_uc":{"0":1.94199},"op_mini":{"0":1.41981},"and_chr":{"0":77.67122}},"total":98.17906}

/***/ },
/* 1309 */
/***/ function(module, exports) {

	module.exports = {"id":"NR","name":"Nauru","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.02241,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0,"79":0,"80":0,"81":0.0163,"82":0,"83":0.00204,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0.00611,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0.0163,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0.01222,"77":0.08352,"78":0,"79":0.09981,"80":0,"81":0.02648,"83":0.00815,"84":0.00204,"85":0.74351,"86":1.97996,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.00204,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00815,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0.00611,"72":0.00204,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":2.004,"3.2":0.0048,"4.0-4.1":0.00411,"4.2-4.3":0.00069,"5.0-5.1":0.00343,"6.0-6.1":0.00206,"7.0-7.1":0.0048,"8.1-8.4":0.01577,"9.0-9.2":0.00892,"9.3":0.11385,"10.0-10.2":0.0192,"10.3":0.10562,"11.0-11.2":0.03978,"11.3-11.4":0.0679,"12.0-12.1":0.06927,"12.2-12.4":0.69063,"13.0-13.1":0.05692,"13.2":0.02812,"13.3":0.21398,"13.4-13.7":1.13985},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00204,"11":0,"12":0,"13":0.07333,"14":0.32592,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0,"12.1":0,"13.1":0.11407},"edge":{"12":0,"13":0.00204,"14":0.00204,"15":0,"16":0,"17":0.02241,"18":0.05704,"79":0,"80":0,"81":0,"83":0,"84":0,"85":0.10185,"86":0.17315},"android":{"3":0,"4":0.03178,"81":null,"2.1":0,"2.2":0,"2.3":0.00025,"4.1":0.01602,"4.2-4.3":0.00712,"4.4":0,"4.4.3-4.4.4":0.05797},"samsung":{"4":0,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.20297,"8.2":0.01015,"9.2":0.70024,"10.1":0.2943,"11.1-11.2":0.34505,"12.0":1.66434},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.12833,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.11148},"and_qq":{"10.4":0},"and_uc":{"0":0.34241},"op_mini":{"0":2.41243},"and_chr":{"0":83.68062}},"total":98.51024}

/***/ },
/* 1310 */
/***/ function(module, exports) {

	module.exports = {"id":"NU","name":"Niue","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0,"79":0,"80":21.99158,"81":0.39034,"82":0,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0,"79":0,"80":0,"81":1.3629,"83":0.19186,"84":0,"85":2.52731,"86":8.36924,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":0,"3.2":0,"4.0-4.1":0,"4.2-4.3":0,"5.0-5.1":0,"6.0-6.1":0,"7.0-7.1":0,"8.1-8.4":0,"9.0-9.2":0,"9.3":0,"10.0-10.2":0,"10.3":0,"11.0-11.2":0,"11.3-11.4":0,"12.0-12.1":0,"12.2-12.4":0,"13.0-13.1":0,"13.2":0,"13.3":0,"13.4-13.7":0},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0.19186,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0,"12.1":0,"13.1":0.19186},"edge":{"12":3.89021,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0.39034,"79":0,"80":0,"81":0,"83":0,"84":0,"85":0,"86":0.78069},"android":{"3":0,"4":0,"81":null,"2.1":0,"2.2":0,"2.3":0,"4.1":0,"4.2-4.3":0,"4.4":0,"4.4.3-4.4.4":0},"samsung":{"4":0,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0,"8.2":0,"9.2":0,"10.1":0,"11.1-11.2":0,"12.0":21.45118},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.58221,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0},"and_qq":{"10.4":0},"and_uc":{"0":0},"op_mini":{"0":0},"and_chr":{"0":23.86758}},"total":86.17916}

/***/ },
/* 1311 */
/***/ function(module, exports) {

	module.exports = {"id":"NZ","name":"New Zealand","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0.00556,"28":0,"29":0.01113,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00556,"49":0,"50":0,"51":0,"52":0.02782,"53":0,"54":0.00556,"55":0,"56":0.00556,"57":0,"58":0.00556,"59":0.00556,"60":0.01113,"61":0,"62":0,"63":0,"64":0,"65":0.00556,"66":0,"67":0,"68":0.03894,"69":0,"70":0.00556,"71":0.00556,"72":0.01669,"73":0,"74":0.00556,"75":0.00556,"76":0.00556,"77":0.01113,"78":0.08345,"79":0.02225,"80":0.11682,"81":1.62996,"82":0.22252,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.00556,"35":0,"36":0,"37":0,"38":0.01669,"39":0,"40":0.01669,"41":0,"42":0.00556,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00556,"49":0.13908,"50":0,"51":0,"52":0,"53":0.02782,"54":0.00556,"55":0.00556,"56":0.00556,"57":0.01113,"58":0.00556,"59":0.00556,"60":0,"61":0.00556,"62":0.00556,"63":0.01669,"64":0.00556,"65":0.02225,"66":0.01113,"67":0.03338,"68":0.02225,"69":0.05007,"70":0.03338,"71":0.05563,"72":0.02225,"73":0.07232,"74":0.05007,"75":0.0445,"76":0.06119,"77":0.03894,"78":0.08345,"79":0.10013,"80":0.12239,"81":0.13351,"83":0.20583,"84":0.49511,"85":7.35429,"86":9.70187,"87":0.02225,"88":0.01113,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.01669,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00556,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00556,"69":0,"70":0.02782,"71":0.1502,"72":0.00556,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":12.60466,"3.2":0.0302,"4.0-4.1":0.02588,"4.2-4.3":0.00431,"5.0-5.1":0.02157,"6.0-6.1":0.01294,"7.0-7.1":0.0302,"8.1-8.4":0.09922,"9.0-9.2":0.05608,"9.3":0.71608,"10.0-10.2":0.12078,"10.3":0.66431,"11.0-11.2":0.2502,"11.3-11.4":0.42706,"12.0-12.1":0.43568,"12.2-12.4":4.34391,"13.0-13.1":0.35804,"13.2":0.17686,"13.3":1.34588,"13.4-13.7":7.16939},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00556,"11":0.02225,"12":0.02782,"13":0.20027,"14":1.32956,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.01113,"10.1":0.03894,"11.1":0.07788,"12.1":0.15576,"13.1":2.23633},"edge":{"12":0,"13":0,"14":0.00556,"15":0.01113,"16":0.01113,"17":0.02782,"18":0.21139,"79":0,"80":0,"81":0,"83":0.00556,"84":0.00556,"85":0.64531,"86":1.30174},"android":{"3":0,"4":0.10734,"81":null,"2.1":0,"2.2":0,"2.3":0.00086,"4.1":0.0541,"4.2-4.3":0.02404,"4.4":0,"4.4.3-4.4.4":0.19578},"samsung":{"4":0.11617,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.02112,"8.2":0.01056,"9.2":0.04224,"10.1":0.07393,"11.1-11.2":0.11617,"12.0":2.92537},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01033,"9":0.01033,"10":0,"11":0.9918,"5.5":0},"bb":{"7":0,"10":0.00444},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.35052},"and_qq":{"10.4":0.12867},"and_uc":{"0":0.29284},"op_mini":{"0":0.21423},"and_chr":{"0":34.80352}},"total":97.22484}

/***/ },
/* 1312 */
/***/ function(module, exports) {

	module.exports = {"id":"OM","name":"Oman","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00399,"48":0.00399,"49":0,"50":0.00399,"51":0,"52":0.00399,"53":0,"54":0,"55":0,"56":0,"57":0.00399,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00399,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0.00399,"77":0.00399,"78":0.01994,"79":0.00399,"80":0.01595,"81":0.41076,"82":0.05583,"83":0.00399,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0.01994,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.00399,"35":0,"36":0.00399,"37":0,"38":0.00798,"39":0,"40":0.00399,"41":0,"42":0.00399,"43":0.00399,"44":0,"45":0,"46":0.00399,"47":0,"48":0,"49":0.06381,"50":0,"51":0,"52":0,"53":0.01196,"54":0,"55":0.00399,"56":0.00399,"57":0.00399,"58":0.00399,"59":0.00399,"60":0.00399,"61":0.00399,"62":0.01196,"63":0.01196,"64":0.00399,"65":0.01994,"66":0.00399,"67":0.01196,"68":0.00399,"69":0.00798,"70":0.01595,"71":0.01595,"72":0.01994,"73":0.00798,"74":0.03988,"75":0.02792,"76":0.01595,"77":0.01196,"78":0.05184,"79":0.02792,"80":0.04387,"81":0.05982,"83":0.07577,"84":0.0997,"85":3.6889,"86":6.48449,"87":0.02792,"88":0.00399,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00399,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.01196,"51":0.07178,"52":0.00399,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00798,"62":0,"63":0.00399,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.04387,"71":0.20738,"72":0.00399,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":6.78934,"3.2":0.01626,"4.0-4.1":0.01394,"4.2-4.3":0.00232,"5.0-5.1":0.01162,"6.0-6.1":0.00697,"7.0-7.1":0.01626,"8.1-8.4":0.05344,"9.0-9.2":0.03021,"9.3":0.38571,"10.0-10.2":0.06506,"10.3":0.35782,"11.0-11.2":0.13476,"11.3-11.4":0.23003,"12.0-12.1":0.23468,"12.2-12.4":2.33979,"13.0-13.1":0.19285,"13.2":0.09526,"13.3":0.72494,"13.4-13.7":3.8617},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.02393,"12":0.01994,"13":0.0678,"14":0.6979,"3.1":0,"3.2":0,"5.1":0.03988,"6.1":0,"7.1":0,"9.1":0.00399,"10.1":0.00798,"11.1":0.04387,"12.1":0.08375,"13.1":0.60219},"edge":{"12":0.00798,"13":0.01196,"14":0.01196,"15":0.00798,"16":0.01196,"17":0.02393,"18":0.17547,"79":0,"80":0,"81":0,"83":0,"84":0.01196,"85":0.27517,"86":0.61814},"android":{"3":0,"4":0.03538,"81":null,"2.1":0,"2.2":0,"2.3":0.00028,"4.1":0.01783,"4.2-4.3":0.00793,"4.4":0,"4.4.3-4.4.4":0.06453},"samsung":{"4":0.49827,"5.0-5.4":0.02034,"6.2-6.4":0.02034,"7.2-7.4":0.14236,"8.2":0.05084,"9.2":0.24405,"10.1":0.11186,"11.1-11.2":0.33557,"12.0":3.78277},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00805,"9":0.00403,"10":0,"11":0.85332,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.08417},"and_qq":{"10.4":0.06012},"and_uc":{"0":0.43888},"op_mini":{"0":0.54072},"and_chr":{"0":59.85855}},"total":97.34328}

/***/ },
/* 1313 */
/***/ function(module, exports) {

	module.exports = {"id":"PA","name":"Panama","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00614,"49":0,"50":0,"51":0,"52":0.00614,"53":0,"54":0,"55":0,"56":0,"57":0.00614,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0.03681,"67":0.00614,"68":0.00614,"69":0.01227,"70":0,"71":0,"72":0.00614,"73":0.02454,"74":0,"75":0,"76":0,"77":0.00614,"78":0.07976,"79":0.00614,"80":0.04295,"81":1.38651,"82":0.20859,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.01227,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00614,"49":0.14111,"50":0,"51":0,"52":0,"53":0.01841,"54":0.00614,"55":0,"56":0.00614,"57":0,"58":0.00614,"59":0,"60":0,"61":0,"62":0.00614,"63":0.01227,"64":0.00614,"65":0.03068,"66":0.00614,"67":0.04908,"68":0.01841,"69":0.01841,"70":0.02454,"71":0.01841,"72":0.03681,"73":0.01841,"74":0.01841,"75":0.05522,"76":0.03681,"77":0.03068,"78":0.04908,"79":0.09203,"80":0.09203,"81":0.09203,"83":0.14111,"84":0.28835,"85":10.04913,"86":16.27616,"87":0.01227,"88":0.00614,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.02454,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00614,"69":0,"70":0.06135,"71":0.53988,"72":0.01227,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":3.7231,"3.2":0.00892,"4.0-4.1":0.00764,"4.2-4.3":0.00127,"5.0-5.1":0.00637,"6.0-6.1":0.00382,"7.0-7.1":0.00892,"8.1-8.4":0.02931,"9.0-9.2":0.01656,"9.3":0.21151,"10.0-10.2":0.03568,"10.3":0.19622,"11.0-11.2":0.0739,"11.3-11.4":0.12614,"12.0-12.1":0.12869,"12.2-12.4":1.28308,"13.0-13.1":0.10576,"13.2":0.05224,"13.3":0.39754,"13.4-13.7":2.11766},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0.00614,"9":0,"10":0,"11":0.01227,"12":0.03681,"13":0.18405,"14":1.68713,"3.1":0,"3.2":0,"5.1":0.65645,"6.1":0,"7.1":0,"9.1":0,"10.1":0.01227,"11.1":0.09203,"12.1":0.2454,"13.1":1.53375},"edge":{"12":0,"13":0.01841,"14":0.00614,"15":0.00614,"16":0.03068,"17":0.01227,"18":0.09203,"79":0,"80":0,"81":0,"83":0.00614,"84":0.00614,"85":0.54602,"86":1.13498},"android":{"3":0,"4":0.06652,"81":null,"2.1":0,"2.2":0,"2.3":0.00053,"4.1":0.03353,"4.2-4.3":0.0149,"4.4":0,"4.4.3-4.4.4":0.12133},"samsung":{"4":0.21425,"5.0-5.4":0,"6.2-6.4":0.0102,"7.2-7.4":0.20405,"8.2":0.0204,"9.2":0.14283,"10.1":0.08162,"11.1-11.2":0.28567,"12.0":2.93829},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00723,"9":0.00723,"10":0,"11":0.18799,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.00387},"baidu":{"0":null},"and_ff":{"0":0.18552},"and_qq":{"10.4":0},"and_uc":{"0":0.13141},"op_mini":{"0":0.11709},"and_chr":{"0":47.33219}},"total":97.1322}

/***/ },
/* 1314 */
/***/ function(module, exports) {

	module.exports = {"id":"PE","name":"Peru","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.0152,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.0076,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0.0076,"66":0.02279,"67":0,"68":0.0152,"69":0,"70":0,"71":0,"72":0.0076,"73":0.0076,"74":0,"75":0,"76":0.0076,"77":0,"78":0.03799,"79":0.0076,"80":0.03039,"81":1.1549,"82":0.17475,"83":0.0076,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.0076,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.0076,"35":0,"36":0,"37":0,"38":0.03039,"39":0,"40":0,"41":0,"42":0.0076,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.09877,"50":0,"51":0,"52":0,"53":0.03799,"54":0,"55":0.0076,"56":0.0076,"57":0.0076,"58":0.0076,"59":0.0076,"60":0,"61":0.0152,"62":0,"63":0.0152,"64":0.0076,"65":0.02279,"66":0.0076,"67":0.02279,"68":0.0076,"69":0.0152,"70":0.03799,"71":0.03799,"72":0.03799,"73":0.03799,"74":0.06078,"75":0.03799,"76":0.05319,"77":0.03799,"78":0.06838,"79":0.15196,"80":0.21274,"81":0.12157,"83":0.23554,"84":0.3951,"85":17.95407,"86":30.86308,"87":0.0152,"88":0.0152,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.0076,"69":0,"70":0.09877,"71":1.1397,"72":0.02279,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":1.55195,"3.2":0.00372,"4.0-4.1":0.00319,"4.2-4.3":0.00053,"5.0-5.1":0.00266,"6.0-6.1":0.00159,"7.0-7.1":0.00372,"8.1-8.4":0.01222,"9.0-9.2":0.0069,"9.3":0.08817,"10.0-10.2":0.01487,"10.3":0.08179,"11.0-11.2":0.03081,"11.3-11.4":0.05258,"12.0-12.1":0.05364,"12.2-12.4":0.53484,"13.0-13.1":0.04408,"13.2":0.02178,"13.3":0.16571,"13.4-13.7":0.88273},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.0076,"11":0.0076,"12":0.02279,"13":0.07598,"14":0.60784,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0.03799,"12.1":0.09118,"13.1":0.46348},"edge":{"12":0,"13":0,"14":0,"15":0.0076,"16":0.0076,"17":0.0076,"18":0.05319,"79":0,"80":0,"81":0,"83":0,"84":0.0076,"85":0.63063,"86":1.23847},"android":{"3":0,"4":0.0336,"81":null,"2.1":0,"2.2":0,"2.3":0.00027,"4.1":0.01693,"4.2-4.3":0.00753,"4.4":0,"4.4.3-4.4.4":0.06128},"samsung":{"4":0.11365,"5.0-5.4":0,"6.2-6.4":0.01033,"7.2-7.4":0.02066,"8.2":0,"9.2":0.05166,"10.1":0.02066,"11.1-11.2":0.04133,"12.0":0.49593},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01609,"9":0,"10":0,"11":0.12067,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.06005},"and_qq":{"10.4":0},"and_uc":{"0":0.02162},"op_mini":{"0":0.08187},"and_chr":{"0":37.57252}},"total":99.06124}

/***/ },
/* 1315 */
/***/ function(module, exports) {

	module.exports = {"id":"PF","name":"French Polynesia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.03769,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00538,"30":0,"31":0.00538,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.06999,"39":0,"40":0,"41":0.00538,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.02154,"49":0,"50":0.00538,"51":0,"52":0.02692,"53":0,"54":0,"55":0,"56":0.00538,"57":0.00538,"58":0,"59":0.00538,"60":0.1669,"61":0,"62":0.00538,"63":0.01077,"64":0,"65":0,"66":0.00538,"67":0.01077,"68":0.33381,"69":0.00538,"70":0,"71":0.02154,"72":0.01615,"73":0,"74":0.02692,"75":0.06999,"76":0.00538,"77":0.01077,"78":0.17767,"79":0.08614,"80":0.25843,"81":3.45114,"82":0.44687,"83":0.03769,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.04846,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0.00538,"64":0,"65":0.08076,"66":0,"67":0.01077,"68":0,"69":0,"70":0.01077,"71":0.01077,"72":0,"73":0.0323,"74":0.01077,"75":0.01077,"76":0.01615,"77":0.05384,"78":0.11845,"79":0.1669,"80":0.06999,"81":0.09691,"83":0.06461,"84":0.37688,"85":5.66397,"86":7.96294,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0.01615,"66":0,"67":0,"68":0,"69":0,"70":0.03769,"71":0.21536,"72":0.01077,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":9.06555,"3.2":0.02172,"4.0-4.1":0.01862,"4.2-4.3":0.0031,"5.0-5.1":0.01551,"6.0-6.1":0.00931,"7.0-7.1":0.02172,"8.1-8.4":0.07136,"9.0-9.2":0.04033,"9.3":0.51502,"10.0-10.2":0.08687,"10.3":0.47779,"11.0-11.2":0.17995,"11.3-11.4":0.30715,"12.0-12.1":0.31335,"12.2-12.4":3.12423,"13.0-13.1":0.25751,"13.2":0.1272,"13.3":0.96798,"13.4-13.7":5.15638},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00538,"12":0.05922,"13":0.12922,"14":1.46983,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.00538,"10.1":0.09691,"11.1":0.12922,"12.1":0.17229,"13.1":2.15898},"edge":{"12":0,"13":0,"14":0,"15":0.00538,"16":0.00538,"17":0.01615,"18":0.17229,"79":0,"80":0,"81":0,"83":0,"84":0.00538,"85":0.60839,"86":1.34062},"android":{"3":0,"4":0.11019,"81":null,"2.1":0,"2.2":0,"2.3":0.00088,"4.1":0.05554,"4.2-4.3":0.02468,"4.4":0,"4.4.3-4.4.4":0.20099},"samsung":{"4":0.03175,"5.0-5.4":0,"6.2-6.4":0.01058,"7.2-7.4":0.08466,"8.2":0.01058,"9.2":0.15873,"10.1":0.09524,"11.1-11.2":0.22222,"12.0":3.0688},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00538,"9":0,"10":0,"11":0.19921,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.21695},"and_qq":{"10.4":0},"and_uc":{"0":0.2585},"op_mini":{"0":0.0437},"and_chr":{"0":44.94369}},"total":97.33518}

/***/ },
/* 1316 */
/***/ function(module, exports) {

	module.exports = {"id":"PG","name":"Papua New Guinea","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0.0082,"29":0,"30":0,"31":0,"32":0.0041,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.0041,"44":0.0041,"45":0,"46":0,"47":0.0082,"48":0.0082,"49":0,"50":0.0082,"51":0,"52":0.0082,"53":0,"54":0,"55":0,"56":0.0082,"57":0.0123,"58":0.0082,"59":0.0041,"60":0.0041,"61":0.0164,"62":0.0041,"63":0.0082,"64":0,"65":0.0082,"66":0.0041,"67":0.02051,"68":0.04511,"69":0.0041,"70":0.0123,"71":0.02051,"72":0.03281,"73":0.0082,"74":0.0041,"75":0.02051,"76":0.0164,"77":0.0164,"78":0.04101,"79":0.02871,"80":0.02871,"81":1.06216,"82":0.12713,"83":0.0082,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.0082,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.0041,"38":0.0041,"39":0,"40":0.02461,"41":0,"42":0,"43":0.0041,"44":0.0041,"45":0,"46":0.0123,"47":0,"48":0,"49":0.03691,"50":0,"51":0.0041,"52":0,"53":0,"54":0,"55":0.04511,"56":0,"57":0.0041,"58":0.0082,"59":0.0041,"60":0.0041,"61":0.0082,"62":0.0123,"63":0.02461,"64":0.0082,"65":0.02871,"66":0.0082,"67":0.0082,"68":0.0123,"69":0.02871,"70":0.07792,"71":0.05331,"72":0.0082,"73":0.0164,"74":0.02051,"75":0.0082,"76":0.04101,"77":0.02461,"78":0.08202,"79":0.04921,"80":0.05741,"81":0.04921,"83":0.10663,"84":0.11893,"85":3.19468,"86":4.9212,"87":0.02461,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.10253,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.0041,"48":0,"49":0,"50":0.0041,"51":0.04101,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.0082,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0.0041,"68":0,"69":0,"70":0.04101,"71":0.31578,"72":0.0041,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.0123},"ios_saf":{"8":0,"14":1.61697,"3.2":0.00387,"4.0-4.1":0.00332,"4.2-4.3":0.00055,"5.0-5.1":0.00277,"6.0-6.1":0.00166,"7.0-7.1":0.00387,"8.1-8.4":0.01273,"9.0-9.2":0.00719,"9.3":0.09186,"10.0-10.2":0.01549,"10.3":0.08522,"11.0-11.2":0.0321,"11.3-11.4":0.05478,"12.0-12.1":0.05589,"12.2-12.4":0.55725,"13.0-13.1":0.04593,"13.2":0.02269,"13.3":0.17265,"13.4-13.7":0.91971},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.0164,"12":0.0082,"13":0.07382,"14":0.06562,"3.1":0,"3.2":0,"5.1":0.02051,"6.1":0,"7.1":0,"9.1":0.03281,"10.1":0.0041,"11.1":0.02871,"12.1":0.05741,"13.1":0.17224},"edge":{"12":0.03281,"13":0.04511,"14":0.02461,"15":0.05331,"16":0.08612,"17":0.09432,"18":0.50442,"79":0,"80":0,"81":0.0041,"83":0.0041,"84":0.02461,"85":0.35679,"86":0.63155},"android":{"3":0,"4":0.41429,"81":null,"2.1":0,"2.2":0,"2.3":0.00331,"4.1":0.2088,"4.2-4.3":0.0928,"4.4":0,"4.4.3-4.4.4":0.75567},"samsung":{"4":0.42214,"5.0-5.4":0.02059,"6.2-6.4":0.07207,"7.2-7.4":0.5354,"8.2":0.04118,"9.2":0.60747,"10.1":0.24711,"11.1-11.2":0.58688,"12.0":1.38998},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01875,"9":0.02343,"10":0,"11":0.54836,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.23006},"baidu":{"0":null},"and_ff":{"0":0.29495},"and_qq":{"10.4":0.45422},"and_uc":{"0":2.45398},"op_mini":{"0":1.66427},"and_chr":{"0":67.70579}},"total":96.16659}

/***/ },
/* 1317 */
/***/ function(module, exports) {

	module.exports = {"id":"PH","name":"Philippines","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00556,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.01113,"53":0,"54":0,"55":0,"56":0.02782,"57":0,"58":0,"59":0,"60":0.00556,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0.00556,"67":0,"68":0.01669,"69":0.00556,"70":0,"71":0,"72":0.01113,"73":0.00556,"74":0.00556,"75":0,"76":0.00556,"77":0.00556,"78":0.03338,"79":0.01113,"80":0.02782,"81":0.80107,"82":0.15576,"83":0.01113,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.00556,"35":0,"36":0,"37":0,"38":0.02225,"39":0,"40":0,"41":0,"42":0.00556,"43":0,"44":0,"45":0,"46":0,"47":0.00556,"48":0,"49":0.05007,"50":0,"51":0.00556,"52":0.00556,"53":0.02225,"54":0.00556,"55":0.00556,"56":0.00556,"57":0.00556,"58":0.01113,"59":0.00556,"60":0.00556,"61":0.00556,"62":0.00556,"63":0.01669,"64":0.00556,"65":0.01669,"66":0.01113,"67":0.02225,"68":0.01113,"69":0.02782,"70":0.02782,"71":0.03338,"72":0.02782,"73":0.02782,"74":0.1057,"75":0.06119,"76":0.05007,"77":0.13908,"78":0.1057,"79":0.11126,"80":0.22808,"81":0.25034,"83":0.18914,"84":0.38941,"85":8.57258,"86":13.44021,"87":0.05007,"88":0.01669,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00556,"37":0.02225,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00556,"52":0,"53":0.00556,"54":0,"55":0.00556,"56":0,"57":0,"58":0,"60":0.01669,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.03894,"71":0.42279,"72":0.01113,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00556},"ios_saf":{"8":0,"14":4.21644,"3.2":0.0101,"4.0-4.1":0.00866,"4.2-4.3":0.00144,"5.0-5.1":0.00721,"6.0-6.1":0.00433,"7.0-7.1":0.0101,"8.1-8.4":0.03319,"9.0-9.2":0.01876,"9.3":0.23954,"10.0-10.2":0.0404,"10.3":0.22222,"11.0-11.2":0.08369,"11.3-11.4":0.14286,"12.0-12.1":0.14574,"12.2-12.4":1.4531,"13.0-13.1":0.11977,"13.2":0.05916,"13.3":0.45021,"13.4-13.7":2.39826},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00556,"12":0.01669,"13":0.07232,"14":0.40054,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00556,"11.1":0.02225,"12.1":0.05007,"13.1":0.43391},"edge":{"12":0.00556,"13":0.00556,"14":0.00556,"15":0.00556,"16":0.00556,"17":0.01113,"18":0.07232,"79":0,"80":0,"81":0.00556,"83":0.00556,"84":0.01113,"85":0.57299,"86":1.15154},"android":{"3":0,"4":0.0959,"81":null,"2.1":0,"2.2":0,"2.3":0.00077,"4.1":0.04833,"4.2-4.3":0.02148,"4.4":0,"4.4.3-4.4.4":0.17492},"samsung":{"4":0.19824,"5.0-5.4":0,"6.2-6.4":0.01043,"7.2-7.4":0.02087,"8.2":0.01043,"9.2":0.07304,"10.1":0.05217,"11.1-11.2":0.10434,"12.0":1.25204},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01243,"9":0,"10":0,"11":0.09326,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.0843},"and_qq":{"10.4":0.01331},"and_uc":{"0":0.78979},"op_mini":{"0":0.76872},"and_chr":{"0":55.15401}},"total":97.31564}

/***/ },
/* 1318 */
/***/ function(module, exports) {

	module.exports = {"id":"PK","name":"Pakistan","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0.00935,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00312,"44":0,"45":0.00312,"46":0,"47":0.00312,"48":0.00312,"49":0,"50":0,"51":0,"52":0.01559,"53":0,"54":0,"55":0.00312,"56":0,"57":0,"58":0,"59":0,"60":0.00312,"61":0,"62":0,"63":0.00935,"64":0.00312,"65":0.00312,"66":0.00312,"67":0,"68":0.00624,"69":0,"70":0,"71":0,"72":0.00312,"73":0,"74":0,"75":0,"76":0,"77":0.00312,"78":0.00935,"79":0.00312,"80":0.00935,"81":0.33986,"82":0.06548,"83":0.00624,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00312,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0.00312,"36":0,"37":0,"38":0,"39":0,"40":0.00312,"41":0,"42":0.00312,"43":0.01247,"44":0,"45":0,"46":0,"47":0,"48":0.00312,"49":0.02806,"50":0.00312,"51":0,"52":0,"53":0,"54":0,"55":0.00312,"56":0.00312,"57":0,"58":0.00312,"59":0,"60":0,"61":0.01871,"62":0.00312,"63":0.01247,"64":0.00312,"65":0.00312,"66":0,"67":0.00312,"68":0.00312,"69":0.00935,"70":0.02183,"71":0.02183,"72":0.02183,"73":0.01559,"74":0.0343,"75":0.00935,"76":0.00935,"77":0.01247,"78":0.01559,"79":0.0343,"80":0.04677,"81":0.0343,"83":0.04053,"84":0.08107,"85":2.616,"86":4.51798,"87":0.02183,"88":0.01247,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0.00312,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0.00312,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.01247,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.00624,"47":0.00312,"48":0,"49":0,"50":0.01871,"51":0.23697,"52":0.00312,"53":0,"54":0.00312,"55":0.00312,"56":0,"57":0,"58":0.00312,"60":0.00624,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.03118,"71":0.24009,"72":0.00624,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":1.47007,"3.2":0.00352,"4.0-4.1":0.00302,"4.2-4.3":0.0005,"5.0-5.1":0.00252,"6.0-6.1":0.00151,"7.0-7.1":0.00352,"8.1-8.4":0.01157,"9.0-9.2":0.00654,"9.3":0.08352,"10.0-10.2":0.01409,"10.3":0.07748,"11.0-11.2":0.02918,"11.3-11.4":0.04981,"12.0-12.1":0.05081,"12.2-12.4":0.50663,"13.0-13.1":0.04176,"13.2":0.02063,"13.3":0.15697,"13.4-13.7":0.83616},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.00312,"13":0.00935,"14":0.0343,"3.1":0,"3.2":0,"5.1":0.02806,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0.00312,"12.1":0.00624,"13.1":0.04053},"edge":{"12":0.00624,"13":0.00312,"14":0.00312,"15":0.00312,"16":0.00312,"17":0.00312,"18":0.02806,"79":0,"80":0,"81":0,"83":0,"84":0.00312,"85":0.06548,"86":0.13096},"android":{"3":0,"4":0.15745,"81":null,"2.1":0,"2.2":0,"2.3":0.00126,"4.1":0.07936,"4.2-4.3":0.03527,"4.4":0,"4.4.3-4.4.4":0.28719},"samsung":{"4":0.26398,"5.0-5.4":0.02031,"6.2-6.4":0.03046,"7.2-7.4":0.05077,"8.2":0.02031,"9.2":0.05077,"10.1":0.05077,"11.1-11.2":0.09138,"12.0":1.06607},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.0236,"9":0.00337,"10":0.00337,"11":0.09438,"5.5":0},"bb":{"7":0,"10":0.00688},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.08258},"baidu":{"0":null},"and_ff":{"0":0.04129},"and_qq":{"10.4":0.01376},"and_uc":{"0":5.38861},"op_mini":{"0":1.79174},"and_chr":{"0":74.92778}},"total":97.10706}

/***/ },
/* 1319 */
/***/ function(module, exports) {

	module.exports = {"id":"PL","name":"Poland","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00494,"44":0,"45":0,"46":0,"47":0.00494,"48":0.00494,"49":0,"50":0.00494,"51":0.00494,"52":0.18783,"53":0,"54":0,"55":0.00494,"56":0.00989,"57":0.00494,"58":0.00494,"59":0,"60":0.01483,"61":0.00494,"62":0,"63":0.00494,"64":0.00494,"65":0.00494,"66":0.00989,"67":0.00494,"68":0.08403,"69":0.00494,"70":0.00989,"71":0.00494,"72":0.02966,"73":0.00494,"74":0.00989,"75":0.00989,"76":0.01483,"77":0.01483,"78":0.1038,"79":0.0346,"80":0.11369,"81":3.72208,"82":0.59316,"83":0.00989,"84":0.00494,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.00494,"35":0,"36":0.00494,"37":0,"38":0.00494,"39":0,"40":0.00494,"41":0,"42":0,"43":0.00494,"44":0,"45":0,"46":0.00494,"47":0,"48":0,"49":0.17301,"50":0.00494,"51":0,"52":0,"53":0.00494,"54":0,"55":0.00494,"56":0.00494,"57":0,"58":0.00989,"59":0.00989,"60":0,"61":0.01483,"62":0.00494,"63":0.02472,"64":0.00494,"65":0.00494,"66":0.00494,"67":0.00989,"68":0.00989,"69":0.00494,"70":0.01483,"71":0.02472,"72":0.00989,"73":0.01483,"74":0.05932,"75":0.01977,"76":0.01977,"77":0.01483,"78":0.02472,"79":0.04943,"80":0.05932,"81":0.08897,"83":0.09886,"84":0.17301,"85":4.84414,"86":8.04226,"87":0.00989,"88":0.00494,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.01977,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.00494,"51":0.05932,"52":0,"53":0.01483,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.01483,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0.00494,"68":0.01483,"69":0.00494,"70":0.22738,"71":2.21941,"72":0.03954,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00494},"ios_saf":{"8":0,"14":2.21394,"3.2":0.0053,"4.0-4.1":0.00455,"4.2-4.3":0.00076,"5.0-5.1":0.00379,"6.0-6.1":0.00227,"7.0-7.1":0.0053,"8.1-8.4":0.01743,"9.0-9.2":0.00985,"9.3":0.12577,"10.0-10.2":0.02122,"10.3":0.11668,"11.0-11.2":0.04395,"11.3-11.4":0.07501,"12.0-12.1":0.07653,"12.2-12.4":0.76298,"13.0-13.1":0.06289,"13.2":0.03106,"13.3":0.2364,"13.4-13.7":1.25926},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.00494,"13":0.04449,"14":0.30647,"3.1":0,"3.2":0,"5.1":0.00494,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00494,"11.1":0.01977,"12.1":0.0346,"13.1":0.27681},"edge":{"12":0,"13":0.00494,"14":0.00989,"15":0.02472,"16":0.00494,"17":0.01977,"18":0.12852,"79":0,"80":0,"81":0.00494,"83":0.00494,"84":0.00989,"85":0.4251,"86":0.93917},"android":{"3":0,"4":0.05066,"81":null,"2.1":0,"2.2":0,"2.3":0.00041,"4.1":0.02553,"4.2-4.3":0.01135,"4.4":0,"4.4.3-4.4.4":0.0924},"samsung":{"4":0.21402,"5.0-5.4":0.01019,"6.2-6.4":0.01019,"7.2-7.4":0.06115,"8.2":0.03057,"9.2":0.17326,"10.1":0.10192,"11.1-11.2":0.28536,"12.0":3.08806},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00494,"9":0,"10":0,"11":0.17301,"5.5":0},"bb":{"7":0,"10":0.00506},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.24779},"and_qq":{"10.4":0},"and_uc":{"0":0.02529},"op_mini":{"0":1.02456},"and_chr":{"0":62.585}},"total":97.15549}

/***/ },
/* 1320 */
/***/ function(module, exports) {

	module.exports = {"id":"PM","name":"Saint Pierre and Miquelon","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.02383,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.00596,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0.02383,"64":0,"65":0,"66":0,"67":0,"68":0.09531,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0.00596,"76":0,"77":0.00596,"78":0.0417,"79":1.71562,"80":0.02383,"81":3.93162,"82":0.87568,"83":0.00596,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.04766,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0.00596,"62":0,"63":0.03574,"64":0,"65":0.05361,"66":0,"67":0,"68":0.01787,"69":0,"70":0,"71":0,"72":0,"73":0.01191,"74":0.00596,"75":0.08936,"76":0.01191,"77":0,"78":0.0834,"79":0.00596,"80":0.01191,"81":0.01787,"83":0.04766,"84":0.01191,"85":5.82595,"86":7.13649,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.00596,"71":0.65527,"72":0.01191,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":16.72507,"3.2":0.04007,"4.0-4.1":0.03434,"4.2-4.3":0.00572,"5.0-5.1":0.02862,"6.0-6.1":0.01717,"7.0-7.1":0.04007,"8.1-8.4":0.13165,"9.0-9.2":0.07441,"9.3":0.95016,"10.0-10.2":0.16027,"10.3":0.88147,"11.0-11.2":0.33198,"11.3-11.4":0.56666,"12.0-12.1":0.57811,"12.2-12.4":5.76391,"13.0-13.1":0.47508,"13.2":0.23468,"13.3":1.78584,"13.4-13.7":9.51303},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.01191,"13":0.04766,"14":3.52654,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.02979,"11.1":0.14893,"12.1":0.02979,"13.1":2.22196},"edge":{"12":0,"13":0,"14":0,"15":0,"16":0,"17":0.02979,"18":0.10127,"79":0,"80":0,"81":0,"83":0,"84":0,"85":0.52422,"86":1.53095},"android":{"3":0,"4":0.32104,"81":null,"2.1":0,"2.2":0,"2.3":0.00257,"4.1":0.1618,"4.2-4.3":0.07191,"4.4":0,"4.4.3-4.4.4":0.58558},"samsung":{"4":0.01232,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.01232,"8.2":0,"9.2":0,"10.1":0,"11.1-11.2":0.01232,"12.0":0.72715},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.05361,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.01213},"and_qq":{"10.4":0},"and_uc":{"0":0},"op_mini":{"0":0},"and_chr":{"0":29.46369}},"total":98.82709}

/***/ },
/* 1321 */
/***/ function(module, exports) {

	module.exports = {"id":"PN","name":"Pitcairn","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0,"79":0,"80":0,"81":1.63,"82":0,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0,"79":0,"80":0,"81":96.75,"83":0,"84":0,"85":0.81,"86":0.81,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":0,"3.2":0,"4.0-4.1":0,"4.2-4.3":0,"5.0-5.1":0,"6.0-6.1":0,"7.0-7.1":0,"8.1-8.4":0,"9.0-9.2":0,"9.3":0,"10.0-10.2":0,"10.3":0,"11.0-11.2":0,"11.3-11.4":0,"12.0-12.1":0,"12.2-12.4":0,"13.0-13.1":0,"13.2":0,"13.3":0,"13.4-13.7":0},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0,"12.1":0,"13.1":0},"edge":{"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"79":0,"80":0,"81":0,"83":0,"84":0,"85":0,"86":0},"android":{"3":0,"4":0,"81":null,"2.1":0,"2.2":0,"2.3":0,"4.1":0,"4.2-4.3":0,"4.4":0,"4.4.3-4.4.4":0},"samsung":{"4":0,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0,"8.2":0,"9.2":0,"10.1":0,"11.1-11.2":0,"12.0":0},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0},"and_qq":{"10.4":0},"and_uc":{"0":0},"op_mini":{"0":0},"and_chr":{"0":0}},"total":100}

/***/ },
/* 1322 */
/***/ function(module, exports) {

	module.exports = {"id":"PR","name":"Puerto Rico","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00567,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.01702,"49":0.00567,"50":0,"51":0,"52":0.02837,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0.01702,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0.0624,"67":0,"68":0.01702,"69":0,"70":0,"71":0,"72":0,"73":0.03404,"74":0,"75":0,"76":0.00567,"77":0.00567,"78":0.09644,"79":0.01702,"80":0.03971,"81":1.37287,"82":0.19856,"83":0.00567,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0.00567,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.10779,"50":0,"51":0,"52":0,"53":0.01135,"54":0,"55":0,"56":0.01135,"57":0,"58":0.01135,"59":0,"60":0,"61":0,"62":0,"63":0.00567,"64":0,"65":0.01702,"66":0.00567,"67":0.01135,"68":0.01135,"69":0.01135,"70":0.00567,"71":0.00567,"72":0.01135,"73":0.00567,"74":0.00567,"75":0.01135,"76":0.05106,"77":0.01135,"78":0.01135,"79":0.02837,"80":0.05673,"81":0.03971,"83":0.10779,"84":0.15317,"85":6.8927,"86":10.74466,"87":0.01135,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00567,"69":0,"70":0.04538,"71":0.33471,"72":0.00567,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":12.54892,"3.2":0.03006,"4.0-4.1":0.02577,"4.2-4.3":0.00429,"5.0-5.1":0.02147,"6.0-6.1":0.01288,"7.0-7.1":0.03006,"8.1-8.4":0.09878,"9.0-9.2":0.05583,"9.3":0.71291,"10.0-10.2":0.12025,"10.3":0.66137,"11.0-11.2":0.24909,"11.3-11.4":0.42517,"12.0-12.1":0.43376,"12.2-12.4":4.3247,"13.0-13.1":0.35645,"13.2":0.17608,"13.3":1.33993,"13.4-13.7":7.13768},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00567,"11":0.02269,"12":0.05673,"13":0.31202,"14":2.56987,"3.1":0,"3.2":0,"5.1":0.01135,"6.1":0,"7.1":0,"9.1":0.00567,"10.1":0.05106,"11.1":0.11913,"12.1":0.2099,"13.1":2.14439},"edge":{"12":0.01135,"13":0,"14":0.01135,"15":0.00567,"16":0.01702,"17":0.03404,"18":0.27798,"79":0,"80":0.00567,"81":0,"83":0.00567,"84":0.01135,"85":1.197,"86":2.35997},"android":{"3":0,"4":0.10982,"81":null,"2.1":0,"2.2":0,"2.3":0.00088,"4.1":0.05535,"4.2-4.3":0.0246,"4.4":0,"4.4.3-4.4.4":0.20031},"samsung":{"4":0.09286,"5.0-5.4":0,"6.2-6.4":0.01032,"7.2-7.4":0.07223,"8.2":0.01032,"9.2":0.17541,"10.1":0.03095,"11.1-11.2":0.20636,"12.0":2.8891},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0.00567,"10":0,"11":0.38576,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.23799},"and_qq":{"10.4":0.00865},"and_uc":{"0":0.23799},"op_mini":{"0":0.09832},"and_chr":{"0":33.65281}},"total":97.40049}

/***/ },
/* 1323 */
/***/ function(module, exports) {

	module.exports = {"id":"PS","name":"Palestinian Territory","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0.00639,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.01278,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0.01278,"65":0.00639,"66":0,"67":0.00639,"68":0.00639,"69":0,"70":0.00639,"71":0,"72":0,"73":0.00639,"74":0,"75":0,"76":0,"77":0,"78":0.03833,"79":0.01278,"80":0.03195,"81":1.75059,"82":0.19167,"83":0.00639,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00639,"39":0,"40":0,"41":0.00639,"42":0,"43":0.00639,"44":0,"45":0,"46":0.00639,"47":0,"48":0,"49":0.14695,"50":0,"51":0,"52":0,"53":0.01278,"54":0,"55":0,"56":0,"57":0,"58":0.00639,"59":0.00639,"60":0,"61":0.00639,"62":0,"63":0.04472,"64":0,"65":0,"66":0,"67":0.01917,"68":0,"69":0.01917,"70":0.02556,"71":0.08945,"72":0.0575,"73":0.01278,"74":0.07667,"75":0.02556,"76":0.03195,"77":0.12139,"78":0.12778,"79":0.115,"80":0.18528,"81":0.15334,"83":0.12778,"84":0.37695,"85":11.23825,"86":19.69729,"87":0.01278,"88":0.00639,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00639,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0.00639,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.01278,"69":0,"70":0.19167,"71":1.3928,"72":0.03195,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":3.38345,"3.2":0.00811,"4.0-4.1":0.00695,"4.2-4.3":0.00116,"5.0-5.1":0.00579,"6.0-6.1":0.00347,"7.0-7.1":0.00811,"8.1-8.4":0.02663,"9.0-9.2":0.01505,"9.3":0.19221,"10.0-10.2":0.03242,"10.3":0.17832,"11.0-11.2":0.06716,"11.3-11.4":0.11463,"12.0-12.1":0.11695,"12.2-12.4":1.16603,"13.0-13.1":0.09611,"13.2":0.04747,"13.3":0.36127,"13.4-13.7":1.92447},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0.15973,"10":0.00639,"11":0.00639,"12":0.03833,"13":0.17889,"14":0.65807,"3.1":0,"3.2":0,"5.1":0.04472,"6.1":0,"7.1":0,"9.1":0,"10.1":0.01917,"11.1":0.03195,"12.1":0.16611,"13.1":0.55584},"edge":{"12":0.00639,"13":0.00639,"14":0.00639,"15":0.00639,"16":0.00639,"17":0.00639,"18":0.10222,"79":0,"80":0,"81":0,"83":0,"84":0.01278,"85":0.48556,"86":1.13724},"android":{"3":0,"4":0.07881,"81":null,"2.1":0,"2.2":0,"2.3":0.00063,"4.1":0.03972,"4.2-4.3":0.01765,"4.4":0,"4.4.3-4.4.4":0.14374},"samsung":{"4":0.07098,"5.0-5.4":0.01014,"6.2-6.4":0.01014,"7.2-7.4":0.07098,"8.2":0.02028,"9.2":0.09126,"10.1":0.07098,"11.1-11.2":0.15211,"12.0":1.71374},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.02556,"9":0,"10":0,"11":0.07028,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.06139},"and_qq":{"10.4":0.00361},"and_uc":{"0":0.05778},"op_mini":{"0":0.15726},"and_chr":{"0":47.38276}},"total":98.1541}

/***/ },
/* 1324 */
/***/ function(module, exports) {

	module.exports = {"id":"PT","name":"Portugal","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00726,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.01452,"49":0,"50":0,"51":0,"52":0.04357,"53":0,"54":0,"55":0,"56":0.00726,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0.00726,"64":0.00726,"65":0.00726,"66":0.00726,"67":0,"68":0.02178,"69":0.00726,"70":0,"71":0,"72":0.01452,"73":0.00726,"74":0,"75":0.00726,"76":0.00726,"77":0.01452,"78":0.11618,"79":0.01452,"80":0.07987,"81":2.59218,"82":0.42114,"83":0.00726,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0.00726,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00726,"39":0,"40":0,"41":0,"42":0,"43":0.1307,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.23235,"50":0,"51":0,"52":0,"53":0.01452,"54":0,"55":0,"56":0,"57":0.01452,"58":0.00726,"59":0,"60":0,"61":0.01452,"62":0.00726,"63":0.01452,"64":0,"65":0.02178,"66":0.00726,"67":0.02178,"68":0.00726,"69":0.02178,"70":0.03631,"71":0.05809,"72":0.03631,"73":0.07261,"74":0.02178,"75":0.03631,"76":0.06535,"77":0.03631,"78":0.04357,"79":0.07261,"80":0.1307,"81":0.08713,"83":0.14522,"84":0.2614,"85":14.32595,"86":23.43125,"87":0.02904,"88":0.00726,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.01452,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00726,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00726,"69":0,"70":0.12344,"71":1.2852,"72":0.02178,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":5.4039,"3.2":0.01295,"4.0-4.1":0.0111,"4.2-4.3":0.00185,"5.0-5.1":0.00925,"6.0-6.1":0.00555,"7.0-7.1":0.01295,"8.1-8.4":0.04254,"9.0-9.2":0.02404,"9.3":0.307,"10.0-10.2":0.05178,"10.3":0.28481,"11.0-11.2":0.10726,"11.3-11.4":0.18309,"12.0-12.1":0.18679,"12.2-12.4":1.86233,"13.0-13.1":0.1535,"13.2":0.07582,"13.3":0.57701,"13.4-13.7":3.07368},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0.01452,"10":0,"11":0.01452,"12":0.05083,"13":0.17426,"14":1.55385,"3.1":0,"3.2":0,"5.1":0.06535,"6.1":0,"7.1":0,"9.1":0.00726,"10.1":0.02904,"11.1":0.09439,"12.1":0.15974,"13.1":1.32876},"edge":{"12":0,"13":0,"14":0.00726,"15":0.00726,"16":0.00726,"17":0.02178,"18":0.18153,"79":0.00726,"80":0,"81":0.00726,"83":0.00726,"84":0.02178,"85":0.90036,"86":1.85156},"android":{"3":0,"4":0.06745,"81":null,"2.1":0,"2.2":0,"2.3":0.00054,"4.1":0.034,"4.2-4.3":0.01511,"4.4":0,"4.4.3-4.4.4":0.12303},"samsung":{"4":0.04181,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.01045,"8.2":0,"9.2":0.01045,"10.1":0.01045,"11.1-11.2":0.03136,"12.0":1.31702},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00752,"9":0.00752,"10":0,"11":0.62393,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.15338},"and_qq":{"10.4":0.01643},"and_uc":{"0":0.18077},"op_mini":{"0":0.11669},"and_chr":{"0":32.47792}},"total":98.44547}

/***/ },
/* 1325 */
/***/ function(module, exports) {

	module.exports = {"id":"PW","name":"Palau","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.00507,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00507,"69":0,"70":0,"71":0,"72":0,"73":0.01015,"74":0,"75":0,"76":0,"77":0,"78":0,"79":0.01015,"80":0.01015,"81":0.38562,"82":0.06596,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0.01015,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.19281,"49":0.01015,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0.01015,"58":0.00507,"59":0,"60":0.01015,"61":0,"62":0,"63":0.00507,"64":0,"65":0.07611,"66":0,"67":0.00507,"68":0.00507,"69":0,"70":0.00507,"71":0.01015,"72":0.01015,"73":0.03552,"74":0.01015,"75":0.00507,"76":0.00507,"77":0.01015,"78":0.01015,"79":0.01015,"80":0.08626,"81":0.03044,"83":0.40592,"84":1.12135,"85":6.63172,"86":7.474,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00507,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0.07104,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":5.81887,"3.2":0.01394,"4.0-4.1":0.01195,"4.2-4.3":0.00199,"5.0-5.1":0.00996,"6.0-6.1":0.00597,"7.0-7.1":0.01394,"8.1-8.4":0.0458,"9.0-9.2":0.02589,"9.3":0.33057,"10.0-10.2":0.05576,"10.3":0.30668,"11.0-11.2":0.1155,"11.3-11.4":0.19715,"12.0-12.1":0.20113,"12.2-12.4":2.00534,"13.0-13.1":0.16529,"13.2":0.08165,"13.3":0.62132,"13.4-13.7":3.30971},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0.05074,"14":0.29429,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00507,"11.1":0.03044,"12.1":0.19281,"13.1":0.58858},"edge":{"12":0,"13":0,"14":0,"15":0.00507,"16":0,"17":0.274,"18":0.04059,"79":0,"80":0,"81":0,"83":0,"84":0,"85":1.61861,"86":2.21226},"android":{"3":0,"4":0.24373,"81":null,"2.1":0,"2.2":0,"2.3":0.00195,"4.1":0.12284,"4.2-4.3":0.0546,"4.4":0,"4.4.3-4.4.4":0.44457},"samsung":{"4":0.28313,"5.0-5.4":0,"6.2-6.4":0.3775,"7.2-7.4":2.00285,"8.2":0,"9.2":0.03146,"10.1":0.02097,"11.1-11.2":0.41944,"12.0":3.54431},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.95899,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.17734},"and_qq":{"10.4":0.19211},"and_uc":{"0":0.76353},"op_mini":{"0":0.07928},"and_chr":{"0":50.94667}},"total":96.07554}

/***/ },
/* 1326 */
/***/ function(module, exports) {

	module.exports = {"id":"PY","name":"Paraguay","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0.06378,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0.01595,"36":0,"37":0,"38":0.01063,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00532,"48":0,"49":0,"50":0,"51":0,"52":0.07441,"53":0,"54":0,"55":0,"56":0,"57":0.00532,"58":0,"59":0,"60":0.00532,"61":0,"62":0,"63":0,"64":0,"65":0.00532,"66":0.00532,"67":0,"68":0.01063,"69":0,"70":0,"71":0.00532,"72":0.00532,"73":0.01063,"74":0,"75":0.01595,"76":0.00532,"77":0.00532,"78":0.02658,"79":0.01063,"80":0.03189,"81":1.05237,"82":0.15414,"83":0.00532,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.04784,"50":0,"51":0,"52":0,"53":0.00532,"54":0.01063,"55":0.00532,"56":0,"57":0,"58":0.00532,"59":0,"60":0,"61":0.00532,"62":0,"63":0.01595,"64":0.00532,"65":0.01063,"66":0.01063,"67":0.01063,"68":0.00532,"69":0.01063,"70":0.02126,"71":0.03721,"72":0.00532,"73":0.01063,"74":0.02126,"75":0.03189,"76":0.04784,"77":0.01595,"78":0.06378,"79":0.05315,"80":0.07973,"81":0.05847,"83":0.09567,"84":0.21792,"85":8.26483,"86":13.59046,"87":0.01595,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00532,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0.00532,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.06378,"71":0.6378,"72":0.00532,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":2.12776,"3.2":0.0051,"4.0-4.1":0.00437,"4.2-4.3":0.00073,"5.0-5.1":0.00364,"6.0-6.1":0.00218,"7.0-7.1":0.0051,"8.1-8.4":0.01675,"9.0-9.2":0.00947,"9.3":0.12088,"10.0-10.2":0.02039,"10.3":0.11214,"11.0-11.2":0.04223,"11.3-11.4":0.07209,"12.0-12.1":0.07355,"12.2-12.4":0.73328,"13.0-13.1":0.06044,"13.2":0.02986,"13.3":0.22719,"13.4-13.7":1.21025},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.01063,"12":0.01063,"13":0.05847,"14":0.38268,"3.1":0,"3.2":0,"5.1":0.88229,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0.02658,"12.1":0.04784,"13.1":0.29764},"edge":{"12":0.00532,"13":0.00532,"14":0.00532,"15":0.00532,"16":0,"17":0.00532,"18":0.05315,"79":0,"80":0,"81":0,"83":0,"84":0.00532,"85":0.34548,"86":0.64843},"android":{"3":0,"4":0.05671,"81":null,"2.1":0,"2.2":0,"2.3":0.00045,"4.1":0.02858,"4.2-4.3":0.0127,"4.4":0,"4.4.3-4.4.4":0.10344},"samsung":{"4":0.50563,"5.0-5.4":0.04045,"6.2-6.4":0.05056,"7.2-7.4":0.30338,"8.2":0.04045,"9.2":0.25282,"10.1":0.15169,"11.1-11.2":0.29327,"12.0":2.70007},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.02658,"9":0,"10":0,"11":0.05315,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.05154},"and_qq":{"10.4":0},"and_uc":{"0":0.04685},"op_mini":{"0":0.14193},"and_chr":{"0":59.78888}},"total":97.35078}

/***/ },
/* 1327 */
/***/ function(module, exports) {

	module.exports = {"id":"QA","name":"Qatar","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00408,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.01633,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.00408,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0.00408,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0.00816,"66":0,"67":0,"68":0.00408,"69":0,"70":0,"71":0.00408,"72":0.00408,"73":0.00816,"74":0,"75":0,"76":0,"77":0,"78":0.02041,"79":0.00408,"80":0.02041,"81":0.4531,"82":0.06531,"83":0.00408,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.00408,"35":0,"36":0,"37":0,"38":0.01225,"39":0,"40":0,"41":0.00408,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.03674,"50":0,"51":0,"52":0.00408,"53":0.01225,"54":0,"55":0,"56":0.00408,"57":0,"58":0.00408,"59":0,"60":0,"61":0.04082,"62":0,"63":0.00408,"64":0,"65":0.01225,"66":0,"67":0.00816,"68":0.00408,"69":0.00816,"70":0.01633,"71":0.02449,"72":0.00816,"73":0.00816,"74":0.02857,"75":0.00816,"76":0.01225,"77":0.00408,"78":0.0449,"79":0.02041,"80":0.07756,"81":0.03266,"83":0.05715,"84":0.12246,"85":4.51061,"86":6.52304,"87":0.00816,"88":0.00408,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.00408,"47":0,"48":0,"49":0,"50":0.00408,"51":0.03266,"52":0,"53":0,"54":0.00408,"55":0,"56":0,"57":0,"58":0,"60":0.01225,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.02449,"71":0.16328,"72":0.00408,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":7.05371,"3.2":0.0169,"4.0-4.1":0.01448,"4.2-4.3":0.00241,"5.0-5.1":0.01207,"6.0-6.1":0.00724,"7.0-7.1":0.0169,"8.1-8.4":0.05552,"9.0-9.2":0.03138,"9.3":0.40072,"10.0-10.2":0.06759,"10.3":0.37176,"11.0-11.2":0.14001,"11.3-11.4":0.23899,"12.0-12.1":0.24381,"12.2-12.4":2.4309,"13.0-13.1":0.20036,"13.2":0.09897,"13.3":0.75317,"13.4-13.7":4.01207},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00408,"12":0.01225,"13":0.07348,"14":0.58373,"3.1":0,"3.2":0,"5.1":0.00816,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00408,"11.1":0.03266,"12.1":0.07756,"13.1":0.5225},"edge":{"12":0,"13":0.00408,"14":0.00408,"15":0.00408,"16":0.00408,"17":0.03674,"18":0.10613,"79":0,"80":0,"81":0,"83":0,"84":0.00816,"85":0.31023,"86":0.57964},"android":{"3":0,"4":0.02477,"81":null,"2.1":0,"2.2":0,"2.3":0.0002,"4.1":0.01248,"4.2-4.3":0.00555,"4.4":0,"4.4.3-4.4.4":0.04517},"samsung":{"4":0.11275,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.041,"8.2":0.01025,"9.2":0.1025,"10.1":0.0615,"11.1-11.2":0.22549,"12.0":2.83912},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00412,"9":0,"10":0,"11":1.17557,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.08285},"and_qq":{"10.4":0.01184},"and_uc":{"0":5.40905},"op_mini":{"0":0.82921},"and_chr":{"0":53.74921}},"total":95.83125}

/***/ },
/* 1328 */
/***/ function(module, exports) {

	module.exports = {"id":"RE","name":"Reunion","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00984,"48":0.00984,"49":0.0246,"50":0,"51":0.00492,"52":0.03935,"53":0,"54":0.00492,"55":0.02951,"56":0.00984,"57":0.00492,"58":0,"59":0.00984,"60":0.01968,"61":0.00492,"62":0,"63":0.00492,"64":0,"65":0,"66":0.00492,"67":0.02951,"68":0.1033,"69":0.00492,"70":0,"71":0,"72":0.00984,"73":0.00492,"74":0.00492,"75":0.0246,"76":0.00492,"77":0.00984,"78":0.39844,"79":0.04919,"80":0.09838,"81":2.3808,"82":0.36893,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.19184,"50":0,"51":0,"52":0,"53":0.00492,"54":0.01968,"55":0,"56":0.00492,"57":0,"58":0.00492,"59":0,"60":0,"61":0.01968,"62":0.00492,"63":0.00984,"64":0,"65":0.04427,"66":0.00984,"67":0.01968,"68":0.00984,"69":0,"70":0.01968,"71":0.01968,"72":0,"73":0,"74":0.00984,"75":0.00984,"76":0.01476,"77":0.01968,"78":0.00984,"79":0.06395,"80":0.18692,"81":0.07379,"83":0.06887,"84":0.14757,"85":5.50436,"86":7.67364,"87":0.01476,"88":0.00984,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0.00492,"32":0,"33":0,"34":0,"35":0,"36":0.00492,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.05411,"71":0.44271,"72":0.00984,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":6.54714,"3.2":0.01568,"4.0-4.1":0.01344,"4.2-4.3":0.00224,"5.0-5.1":0.0112,"6.0-6.1":0.00672,"7.0-7.1":0.01568,"8.1-8.4":0.05153,"9.0-9.2":0.02913,"9.3":0.37195,"10.0-10.2":0.06274,"10.3":0.34506,"11.0-11.2":0.12996,"11.3-11.4":0.22182,"12.0-12.1":0.2263,"12.2-12.4":2.25632,"13.0-13.1":0.18597,"13.2":0.09187,"13.3":0.69908,"13.4-13.7":3.72394},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00492,"11":0.00492,"12":0.03443,"13":0.12298,"14":1.14121,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.01968,"10.1":0.0246,"11.1":0.14757,"12.1":0.12789,"13.1":1.21007},"edge":{"12":0,"13":0.00492,"14":0.00492,"15":0.00984,"16":0.01476,"17":0.0246,"18":0.182,"79":0,"80":0,"81":0,"83":0,"84":0.00984,"85":0.53617,"86":0.89526},"android":{"3":0,"4":0.03615,"81":null,"2.1":0,"2.2":0,"2.3":0.00029,"4.1":0.01822,"4.2-4.3":0.0081,"4.4":0,"4.4.3-4.4.4":0.06594},"samsung":{"4":0.05165,"5.0-5.4":0,"6.2-6.4":0.01033,"7.2-7.4":0.04132,"8.2":0,"9.2":0.16529,"10.1":0.07231,"11.1-11.2":0.15496,"12.0":2.93382},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0.00492,"10":0,"11":0.182,"5.5":0},"bb":{"7":0,"10":0.00508},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.16767},"and_qq":{"10.4":0},"and_uc":{"0":0.06097},"op_mini":{"0":0.15874},"and_chr":{"0":55.81409}},"total":97.8626}

/***/ },
/* 1329 */
/***/ function(module, exports) {

	module.exports = {"id":"RO","name":"Romania","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00945,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0.00945,"45":0.00473,"46":0,"47":0,"48":0.00473,"49":0,"50":0,"51":0,"52":0.07089,"53":0,"54":0,"55":0,"56":0.00473,"57":0,"58":0.00473,"59":0,"60":0.00473,"61":0,"62":0.00473,"63":0.00473,"64":0.00473,"65":0.00945,"66":0.00945,"67":0.00473,"68":0.0189,"69":0.00473,"70":0.00473,"71":0,"72":0.00945,"73":0,"74":0.00473,"75":0.00945,"76":0.00473,"77":0.00945,"78":0.04726,"79":0.01418,"80":0.05199,"81":1.72972,"82":0.26466,"83":0.00473,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00473,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00473,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00473,"49":0.20794,"50":0,"51":0,"52":0,"53":0.01418,"54":0,"55":0.00473,"56":0.00473,"57":0,"58":0.01418,"59":0,"60":0.12288,"61":0.04253,"62":0,"63":0.00945,"64":0.00473,"65":0.00473,"66":0.00473,"67":0.02363,"68":0.0189,"69":0.03781,"70":0.03781,"71":0.02836,"72":0.02363,"73":0.0189,"74":0.01418,"75":0.01418,"76":0.0189,"77":0.0189,"78":0.0189,"79":0.03308,"80":0.05671,"81":0.06144,"83":0.06144,"84":0.1276,"85":5.51524,"86":9.82535,"87":0.01418,"88":0.00473,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00473,"37":0,"38":0,"39":0,"40":0.00473,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00473,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00473,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00473,"69":0,"70":0.1087,"71":0.95465,"72":0.02363,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":6.38315,"3.2":0.01529,"4.0-4.1":0.01311,"4.2-4.3":0.00218,"5.0-5.1":0.01092,"6.0-6.1":0.00655,"7.0-7.1":0.01529,"8.1-8.4":0.05024,"9.0-9.2":0.0284,"9.3":0.36263,"10.0-10.2":0.06117,"10.3":0.33642,"11.0-11.2":0.1267,"11.3-11.4":0.21627,"12.0-12.1":0.22064,"12.2-12.4":2.1998,"13.0-13.1":0.18131,"13.2":0.08957,"13.3":0.68157,"13.4-13.7":3.63066},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.00473,"13":0.03781,"14":0.25993,"3.1":0,"3.2":0,"5.1":0.00473,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00473,"11.1":0.01418,"12.1":0.02363,"13.1":0.20794},"edge":{"12":0,"13":0.00473,"14":0.00473,"15":0.00945,"16":0.00473,"17":0.01418,"18":0.08979,"79":0,"80":0,"81":0,"83":0,"84":0.00473,"85":0.27411,"86":0.60965},"android":{"3":0,"4":0.06757,"81":null,"2.1":0,"2.2":0,"2.3":0.00054,"4.1":0.03406,"4.2-4.3":0.01514,"4.4":0,"4.4.3-4.4.4":0.12325},"samsung":{"4":0.18253,"5.0-5.4":0.01014,"6.2-6.4":0.03042,"7.2-7.4":0.03042,"8.2":0.02028,"9.2":0.13183,"10.1":0.10141,"11.1-11.2":0.25352,"12.0":4.47207},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.02521,"9":0.01008,"10":0.01008,"11":0.33271,"5.5":0},"bb":{"7":0,"10":0.00527},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.2637},"and_qq":{"10.4":0.00527},"and_uc":{"0":0.05274},"op_mini":{"0":0.26963},"and_chr":{"0":54.55023}},"total":97.06722}

/***/ },
/* 1330 */
/***/ function(module, exports) {

	module.exports = {"id":"RS","name":"Serbia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00472,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00943,"44":0,"45":0.00472,"46":0,"47":0.00943,"48":0.00943,"49":0.00472,"50":0.02829,"51":0.00472,"52":0.1556,"53":0,"54":0.00472,"55":0.00472,"56":0.00943,"57":0.00472,"58":0.00472,"59":0.00472,"60":0.00943,"61":0.00472,"62":0.00472,"63":0.00472,"64":0.00472,"65":0.00943,"66":0.00943,"67":0.00472,"68":0.02829,"69":0.00472,"70":0.00943,"71":0.00472,"72":0.02358,"73":0.00472,"74":0.01415,"75":0.00472,"76":0.00943,"77":0.00472,"78":0.05658,"79":0.01886,"80":0.07544,"81":2.49424,"82":0.40549,"83":0.01415,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00472,"23":0,"24":0,"25":0,"26":0.00472,"27":0,"28":0,"29":0.00472,"30":0,"31":0,"32":0,"33":0,"34":0.00472,"35":0,"36":0,"37":0,"38":0.01415,"39":0,"40":0,"41":0,"42":0,"43":0.00472,"44":0,"45":0,"46":0,"47":0.00472,"48":0,"49":0.27819,"50":0.00472,"51":0,"52":0,"53":0.01415,"54":0,"55":0,"56":0.00472,"57":0,"58":0.00472,"59":0.00472,"60":0.00472,"61":0.04715,"62":0.00472,"63":0.00472,"64":0.00472,"65":0.00943,"66":0.00472,"67":0.01415,"68":0.00943,"69":0.01415,"70":0.04244,"71":0.05187,"72":0.02829,"73":0.02358,"74":0.02829,"75":0.01415,"76":0.01886,"77":0.01886,"78":0.02358,"79":0.04244,"80":0.07544,"81":0.07544,"83":0.08487,"84":0.1556,"85":5.19593,"86":8.84063,"87":0.00943,"88":0.00472,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.01886,"37":0,"38":0,"39":0,"40":0.00472,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00472,"52":0,"53":0.00472,"54":0,"55":0,"56":0,"57":0.00943,"58":0,"60":0.00943,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00472,"69":0,"70":0.13202,"71":0.95243,"72":0.02829,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00472},"ios_saf":{"8":0,"14":3.44127,"3.2":0.00824,"4.0-4.1":0.00707,"4.2-4.3":0.00118,"5.0-5.1":0.00589,"6.0-6.1":0.00353,"7.0-7.1":0.00824,"8.1-8.4":0.02709,"9.0-9.2":0.01531,"9.3":0.1955,"10.0-10.2":0.03298,"10.3":0.18137,"11.0-11.2":0.06831,"11.3-11.4":0.11659,"12.0-12.1":0.11895,"12.2-12.4":1.18595,"13.0-13.1":0.09775,"13.2":0.04829,"13.3":0.36745,"13.4-13.7":1.95735},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.00943,"13":0.02829,"14":0.19803,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.00472,"10.1":0.00472,"11.1":0.01886,"12.1":0.02829,"13.1":0.17917},"edge":{"12":0,"13":0.00472,"14":0.01415,"15":0.02829,"16":0.00472,"17":0.01415,"18":0.07073,"79":0,"80":0,"81":0,"83":0,"84":0.00472,"85":0.1886,"86":0.44321},"android":{"3":0,"4":0.05024,"81":null,"2.1":0,"2.2":0,"2.3":0.0004,"4.1":0.02532,"4.2-4.3":0.01125,"4.4":0,"4.4.3-4.4.4":0.09164},"samsung":{"4":0.10274,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.03082,"8.2":0.01027,"9.2":0.09247,"10.1":0.08219,"11.1-11.2":0.18493,"12.0":3.33906},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.03565,"9":0.00509,"10":0.01018,"11":0.33099,"5.5":0},"bb":{"7":0,"10":0.01057},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.25897},"and_qq":{"10.4":0.00529},"and_uc":{"0":0.037},"op_mini":{"0":0.44031},"and_chr":{"0":63.21689}},"total":97.37468}

/***/ },
/* 1331 */
/***/ function(module, exports) {

	module.exports = {"id":"RU","name":"Russian Federation","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0.03807,"3":0.03807,"4":0.00761,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0.02284,"31":0.03046,"32":0.03046,"33":0.03807,"34":0.03807,"35":0.02284,"36":0.03807,"37":0.02284,"38":0.04568,"39":0.03046,"40":0.03807,"41":0.03807,"42":0.06091,"43":0.06091,"44":0.04568,"45":0.09898,"46":0.04568,"47":0.07614,"48":0.07614,"49":0.0533,"50":0.08375,"51":0.06091,"52":0.23603,"53":0.06091,"54":0.06853,"55":0.0533,"56":0.12944,"57":0.06091,"58":0.0533,"59":0.04568,"60":0.06091,"61":0.03807,"62":0.03807,"63":0.06091,"64":0.03046,"65":0.0533,"66":0.03807,"67":0.03046,"68":0.0533,"69":0.01523,"70":0.02284,"71":0.01523,"72":0.04568,"73":0.02284,"74":0.02284,"75":0.00761,"76":0.01523,"77":0.02284,"78":0.09898,"79":0.03046,"80":0.1066,"81":1.81213,"82":0.28933,"83":0.00761,"84":0,"3.5":0.01523,"3.6":0.00761},"chrome":{"4":0.00761,"5":0.01523,"6":0,"7":0,"8":0,"9":0,"10":0.00761,"11":0.00761,"12":0.00761,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0.00761,"22":0.00761,"23":0.00761,"24":0.00761,"25":0.00761,"26":0.02284,"27":0.00761,"28":0.00761,"29":0.00761,"30":0.00761,"31":0.03046,"32":0.01523,"33":0.00761,"34":0.02284,"35":0.01523,"36":0.02284,"37":0.01523,"38":0.02284,"39":0.02284,"40":0.00761,"41":0.04568,"42":0.01523,"43":0.01523,"44":0.00761,"45":0.01523,"46":0.07614,"47":0.06853,"48":0.06091,"49":0.36547,"50":0.01523,"51":0.1066,"52":0.03046,"53":0.03807,"54":0.03046,"55":0.0533,"56":0.06091,"57":0.06091,"58":0.0533,"59":0.08375,"60":0.08375,"61":0.1066,"62":0.06853,"63":0.09137,"64":0.08375,"65":0.06091,"66":0.08375,"67":0.12182,"68":0.06091,"69":0.73094,"70":0.25888,"71":0.22842,"72":0.22842,"73":0.15228,"74":0.2741,"75":0.07614,"76":0.12944,"77":0.09137,"78":0.24365,"79":0.40354,"80":0.434,"81":0.22081,"83":0.3274,"84":0.57866,"85":10.07332,"86":15.57824,"87":0.03046,"88":0.02284,"89":0},"opera":{"9":0,"11":0.01523,"12":0.01523,"15":0.01523,"16":0,"17":0.00761,"18":0,"19":0.00761,"20":0,"21":0.00761,"22":0,"23":0,"24":0,"25":0,"26":0.00761,"27":0.00761,"28":0.00761,"29":0.00761,"30":0.00761,"31":0.00761,"32":0.01523,"33":0.00761,"34":0.00761,"35":0,"36":0.0533,"37":0.00761,"38":0.00761,"39":0,"40":0.00761,"41":0.00761,"42":0.00761,"43":0.00761,"44":0.00761,"45":0.00761,"46":0.00761,"47":0,"48":0,"49":0,"50":0.00761,"51":0.02284,"52":0,"53":0.00761,"54":0.00761,"55":0,"56":0.00761,"57":0.01523,"58":0.01523,"60":0.01523,"62":0,"63":0.00761,"64":0,"65":0.00761,"66":0.00761,"67":0.01523,"68":0.03046,"69":0.01523,"70":0.44923,"71":3.51005,"72":0.07614,"9.5-9.6":0.00761,"10.0-10.1":0.00761,"10.5":0,"10.6":0,"11.1":0.00761,"11.5":0.00761,"11.6":0.00761,"12.1":0.06091},"ios_saf":{"8":0,"14":4.78004,"3.2":0.01145,"4.0-4.1":0.00982,"4.2-4.3":0.00164,"5.0-5.1":0.00818,"6.0-6.1":0.00491,"7.0-7.1":0.01145,"8.1-8.4":0.03763,"9.0-9.2":0.02127,"9.3":0.27156,"10.0-10.2":0.0458,"10.3":0.25193,"11.0-11.2":0.09488,"11.3-11.4":0.16195,"12.0-12.1":0.16522,"12.2-12.4":1.64733,"13.0-13.1":0.13578,"13.2":0.06707,"13.3":0.51039,"13.4-13.7":2.71883},"safari":{"0":null,"4":0.04568,"5":0.04568,"6":0.01523,"7":0.02284,"8":0.03046,"9":0.03046,"10":0.02284,"11":0.03046,"12":0.0533,"13":0.23603,"14":1.04312,"3.1":0.02284,"3.2":0.01523,"5.1":0.39593,"6.1":0.03046,"7.1":0.01523,"9.1":0.04568,"10.1":0.03807,"11.1":0.06091,"12.1":0.15228,"13.1":0.95175},"edge":{"12":0.01523,"13":0.03046,"14":0.0533,"15":0.02284,"16":0.02284,"17":0.04568,"18":0.18274,"79":0,"80":0.00761,"81":0,"83":0.00761,"84":0.01523,"85":0.31217,"86":0.58628},"android":{"3":0,"4":0.09263,"81":null,"2.1":0,"2.2":0,"2.3":0.00074,"4.1":0.04668,"4.2-4.3":0.02075,"4.4":0,"4.4.3-4.4.4":0.16895},"samsung":{"4":0.21758,"5.0-5.4":0.01036,"6.2-6.4":0.02072,"7.2-7.4":0.0518,"8.2":0.01036,"9.2":0.03108,"10.1":0.08289,"11.1-11.2":0.06216,"12.0":0.66309},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0.00841,"7":0.02523,"8":0.09252,"9":0.08411,"10":0.06729,"11":0.42895,"5.5":0.00841},"bb":{"7":0,"10":0.01193},"ie_mob":{"10":0.02757,"11":0.0965},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.08828},"and_qq":{"10.4":0.0167},"and_uc":{"0":0.22906},"op_mini":{"0":0.37272},"and_chr":{"0":24.83601}},"total":85.19967}

/***/ },
/* 1332 */
/***/ function(module, exports) {

	module.exports = {"id":"RW","name":"Rwanda","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0.00476,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0.00476,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.00476,"41":0,"42":0,"43":0.00953,"44":0.00476,"45":0.00476,"46":0,"47":0.00476,"48":0.00953,"49":0.00953,"50":0.00953,"51":0,"52":0.00953,"53":0,"54":0,"55":0,"56":0.00476,"57":0.00476,"58":0.00476,"59":0.00476,"60":0.00476,"61":0.00476,"62":0,"63":0,"64":0,"65":0,"66":0.00953,"67":0.00476,"68":0.05717,"69":0.00476,"70":0.00476,"71":0,"72":0.01429,"73":0.00476,"74":0.00476,"75":0.00476,"76":0.00476,"77":0.01429,"78":0.10957,"79":0.01429,"80":0.0524,"81":1.86749,"82":0.27155,"83":0.02858,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.00476,"41":0.00476,"42":0,"43":0.01906,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.0524,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0.00476,"56":0,"57":0,"58":0.00476,"59":0,"60":0,"61":0.00476,"62":0,"63":0.03335,"64":0.00953,"65":0.02382,"66":0,"67":0.00476,"68":0,"69":0.00953,"70":0.01429,"71":0.02382,"72":0.01429,"73":0.01906,"74":0.03335,"75":0.01429,"76":0.01906,"77":0.01429,"78":0.02382,"79":0.09052,"80":0.09528,"81":0.04288,"83":0.13339,"84":0.16674,"85":5.4262,"86":8.12262,"87":0.02382,"88":0.00476,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0.00476,"17":0,"18":0,"19":0.00476,"20":0.00476,"21":0,"22":0,"23":0.01429,"24":0,"25":0,"26":0,"27":0.00476,"28":0.00476,"29":0,"30":0.00953,"31":0,"32":0.00953,"33":0.00476,"34":0,"35":0,"36":0,"37":0.24296,"38":0.00476,"39":0,"40":0,"41":0,"42":0.00476,"43":0,"44":0,"45":0.00953,"46":0.00476,"47":0.01429,"48":0,"49":0,"50":0.0667,"51":0.16674,"52":0,"53":0.00953,"54":0.00476,"55":0.00476,"56":0.00953,"57":0,"58":0,"60":0.04288,"62":0,"63":0.00476,"64":0,"65":0,"66":0,"67":0,"68":0.00476,"69":0,"70":0.12386,"71":0.58121,"72":0.03811,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.06193},"ios_saf":{"8":0,"14":2.69392,"3.2":0.00645,"4.0-4.1":0.00553,"4.2-4.3":0.00092,"5.0-5.1":0.00461,"6.0-6.1":0.00277,"7.0-7.1":0.00645,"8.1-8.4":0.0212,"9.0-9.2":0.01199,"9.3":0.15304,"10.0-10.2":0.02581,"10.3":0.14198,"11.0-11.2":0.05347,"11.3-11.4":0.09127,"12.0-12.1":0.09312,"12.2-12.4":0.9284,"13.0-13.1":0.07652,"13.2":0.0378,"13.3":0.28765,"13.4-13.7":1.53227},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.01429,"12":0.0667,"13":0.0667,"14":0.32395,"3.1":0,"3.2":0,"5.1":0.10957,"6.1":0.00476,"7.1":0,"9.1":0.01429,"10.1":0.00953,"11.1":0.04764,"12.1":0.12863,"13.1":0.33824},"edge":{"12":0.03811,"13":0.02858,"14":0.01429,"15":0.01429,"16":0.00953,"17":0.02858,"18":0.1715,"79":0,"80":0,"81":0.00476,"83":0.01429,"84":0.01429,"85":0.9004,"86":0.83846},"android":{"3":0,"4":0.06072,"81":null,"2.1":0,"2.2":0,"2.3":0.00049,"4.1":0.03061,"4.2-4.3":0.0136,"4.4":0,"4.4.3-4.4.4":0.11076},"samsung":{"4":0.29945,"5.0-5.4":0.02065,"6.2-6.4":0,"7.2-7.4":0.07228,"8.2":0.11358,"9.2":0.15489,"10.1":0.05163,"11.1-11.2":0.10326,"12.0":0.99127},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01616,"9":0,"10":0,"11":0.23157,"5.5":0},"bb":{"7":0,"10":0.03665},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.1885},"baidu":{"0":null},"and_ff":{"0":0.1885},"and_qq":{"10.4":0.09425},"and_uc":{"0":0.466},"op_mini":{"0":15.0349},"and_chr":{"0":44.44373}},"total":90.59848}

/***/ },
/* 1333 */
/***/ function(module, exports) {

	module.exports = {"id":"SA","name":"Saudi Arabia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.004,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.004,"49":0,"50":0,"51":0,"52":0.004,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00801,"69":0,"70":0,"71":0,"72":0.004,"73":0,"74":0,"75":0,"76":0,"77":0.004,"78":0.02002,"79":0.004,"80":0.03603,"81":0.57643,"82":0.08807,"83":0.004,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.004,"35":0,"36":0,"37":0,"38":0.004,"39":0,"40":0,"41":0,"42":0,"43":0.004,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.02802,"50":0,"51":0,"52":0,"53":0.01201,"54":0,"55":0,"56":0.004,"57":0,"58":0.004,"59":0,"60":0,"61":0.00801,"62":0.004,"63":0.00801,"64":0.004,"65":0.004,"66":0.004,"67":0.00801,"68":0.004,"69":0.00801,"70":0.01201,"71":0.01601,"72":0.00801,"73":0.01201,"74":0.01601,"75":0.00801,"76":0.01201,"77":0.02002,"78":0.07205,"79":0.02802,"80":0.05204,"81":0.04003,"83":0.06005,"84":0.11208,"85":4.54341,"86":6.78909,"87":0.01201,"88":0.004,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.004,"52":0,"53":0.004,"54":0,"55":0.004,"56":0,"57":0,"58":0,"60":0.004,"62":0.004,"63":0,"64":0.004,"65":0.004,"66":0.004,"67":0,"68":0.01601,"69":0,"70":0.01601,"71":0.04003,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":14.33952,"3.2":0.03435,"4.0-4.1":0.02944,"4.2-4.3":0.00491,"5.0-5.1":0.02454,"6.0-6.1":0.01472,"7.0-7.1":0.03435,"8.1-8.4":0.11287,"9.0-9.2":0.0638,"9.3":0.81463,"10.0-10.2":0.13741,"10.3":0.75574,"11.0-11.2":0.28463,"11.3-11.4":0.48584,"12.0-12.1":0.49565,"12.2-12.4":4.94179,"13.0-13.1":0.40732,"13.2":0.2012,"13.3":1.53112,"13.4-13.7":8.15616},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.004,"12":0.01601,"13":0.09207,"14":0.6685,"3.1":0,"3.2":0,"5.1":0.03603,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00801,"11.1":0.02802,"12.1":0.05604,"13.1":0.59645},"edge":{"12":0.004,"13":0.004,"14":0.004,"15":0.00801,"16":0.00801,"17":0.01601,"18":0.09207,"79":0,"80":0,"81":0,"83":0,"84":0.00801,"85":0.30423,"86":0.61246},"android":{"3":0,"4":0.02865,"81":null,"2.1":0,"2.2":0,"2.3":0.00023,"4.1":0.01444,"4.2-4.3":0.00642,"4.4":0,"4.4.3-4.4.4":0.05227},"samsung":{"4":0.13293,"5.0-5.4":0.02045,"6.2-6.4":0.01023,"7.2-7.4":0.09203,"8.2":0.02045,"9.2":0.17383,"10.1":0.09203,"11.1-11.2":0.23518,"12.0":2.22914},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00429,"9":0,"10":0,"11":0.17585,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.10195},"and_qq":{"10.4":0.006},"and_uc":{"0":1.55322},"op_mini":{"0":0.10787},"and_chr":{"0":44.44324}},"total":97.72617}

/***/ },
/* 1334 */
/***/ function(module, exports) {

	module.exports = {"id":"SB","name":"Solomon Islands","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0.00461,"26":0,"27":0,"28":0,"29":0.00922,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.00461,"41":0,"42":0,"43":0.00922,"44":0,"45":0.00461,"46":0,"47":0.00922,"48":0.00461,"49":0.00461,"50":0,"51":0,"52":0.00461,"53":0,"54":0,"55":0,"56":0.00922,"57":0,"58":0.00461,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.01844,"69":0,"70":0,"71":0,"72":0.00461,"73":0.00922,"74":0.00461,"75":0,"76":0,"77":0.01844,"78":0,"79":0.06917,"80":0.04611,"81":1.33719,"82":0.11989,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0.00922,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.00461,"38":0.00461,"39":0.00922,"40":0.02306,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00461,"48":0,"49":0.12911,"50":0,"51":0.00922,"52":0,"53":0,"54":0,"55":0.00461,"56":0.00461,"57":0,"58":0.00922,"59":0,"60":0,"61":0,"62":0,"63":0.00922,"64":0.01383,"65":0.01844,"66":0.00461,"67":0,"68":0,"69":0.06917,"70":0,"71":0.00461,"72":0.00461,"73":0.00461,"74":0,"75":0.11989,"76":0.00922,"77":0.01383,"78":0.00922,"79":0.02767,"80":0.03689,"81":0.14294,"83":0.06455,"84":0.27666,"85":3.12165,"86":5.11821,"87":0.00461,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0.00461,"22":0.00461,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.01844,"38":0.00461,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.01383,"46":0,"47":0,"48":0,"49":0,"50":0.04611,"51":0.03228,"52":0.00461,"53":0.05533,"54":0,"55":0,"56":0,"57":0,"58":0.00461,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.01844,"71":0.12911,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.03228},"ios_saf":{"8":0,"14":2.8244,"3.2":0.00677,"4.0-4.1":0.0058,"4.2-4.3":0.00097,"5.0-5.1":0.00483,"6.0-6.1":0.0029,"7.0-7.1":0.00677,"8.1-8.4":0.02223,"9.0-9.2":0.01257,"9.3":0.16046,"10.0-10.2":0.02706,"10.3":0.14886,"11.0-11.2":0.05606,"11.3-11.4":0.09569,"12.0-12.1":0.09763,"12.2-12.4":0.97336,"13.0-13.1":0.08023,"13.2":0.03963,"13.3":0.30158,"13.4-13.7":1.60648},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0.00461,"9":0.04611,"10":0,"11":0.00461,"12":0.00922,"13":0.07378,"14":0.04611,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.00461,"10.1":0,"11.1":0.083,"12.1":0.01844,"13.1":0.16139},"edge":{"12":0.02767,"13":0.07378,"14":0.03689,"15":0.20288,"16":0.1245,"17":0.18444,"18":2.75738,"79":0,"80":0,"81":0,"83":0.01383,"84":0.02306,"85":0.64093,"86":1.35563},"android":{"3":0,"4":0.17392,"81":null,"2.1":0,"2.2":0,"2.3":0.00139,"4.1":0.08766,"4.2-4.3":0.03896,"4.4":0,"4.4.3-4.4.4":0.31724},"samsung":{"4":0.61463,"5.0-5.4":0.03023,"6.2-6.4":0.11084,"7.2-7.4":0.44334,"8.2":0.05038,"9.2":0.21159,"10.1":0.07053,"11.1-11.2":0.34258,"12.0":0.97736},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0.03689,"10":0,"11":1.36025,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.13473},"and_qq":{"10.4":0.08622},"and_uc":{"0":3.01245},"op_mini":{"0":1.89283},"and_chr":{"0":62.156}},"total":95.86941}

/***/ },
/* 1335 */
/***/ function(module, exports) {

	module.exports = {"id":"SC","name":"Seychelles","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0.03251,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0.00542,"45":0.01084,"46":0.03251,"47":0.01084,"48":0,"49":0.01084,"50":0,"51":0,"52":0.01084,"53":0,"54":0,"55":0,"56":0.00542,"57":0,"58":0,"59":0.01626,"60":0.06503,"61":0.03251,"62":0.05961,"63":0.09212,"64":0,"65":0.00542,"66":0.01084,"67":0,"68":0.05961,"69":0.00542,"70":0.01626,"71":0,"72":0.03251,"73":0.00542,"74":0,"75":0,"76":0.01626,"77":0.00542,"78":0.28179,"79":0.01626,"80":0.04877,"81":2.00503,"82":0.36307,"83":0.01084,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0.00542,"28":0,"29":0.00542,"30":0,"31":0,"32":0.00542,"33":0,"34":0,"35":0,"36":0.00542,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.01084,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.02168,"50":0.00542,"51":0.00542,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0.00542,"59":0,"60":0,"61":0,"62":0.00542,"63":0.02168,"64":0,"65":0.00542,"66":0.02168,"67":0.01084,"68":0.03793,"69":0.04877,"70":0.02168,"71":0.04877,"72":2.04296,"73":0.08129,"74":0.01084,"75":0.00542,"76":0.00542,"77":0.01084,"78":0.01626,"79":0.02168,"80":0.03793,"81":0.17883,"83":0.06503,"84":0.16257,"85":10.78923,"86":7.38068,"87":0.02168,"88":0.01084,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.00542,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.04877,"52":0,"53":0.03251,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00542,"69":0.02168,"70":0.06503,"71":0.28721,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":3.453,"3.2":0.00827,"4.0-4.1":0.00709,"4.2-4.3":0.00118,"5.0-5.1":0.00591,"6.0-6.1":0.00355,"7.0-7.1":0.00827,"8.1-8.4":0.02718,"9.0-9.2":0.01536,"9.3":0.19617,"10.0-10.2":0.03309,"10.3":0.18199,"11.0-11.2":0.06854,"11.3-11.4":0.11699,"12.0-12.1":0.11935,"12.2-12.4":1.19,"13.0-13.1":0.09808,"13.2":0.04845,"13.3":0.3687,"13.4-13.7":1.96403},"safari":{"0":null,"4":0,"5":0.00542,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00542,"12":0.03793,"13":0.08129,"14":0.31972,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00542,"11.1":0.03251,"12.1":0.20592,"13.1":0.34682},"edge":{"12":0.01626,"13":0.04877,"14":0.06503,"15":0.01084,"16":0.02168,"17":0.10296,"18":0.32514,"79":0,"80":0,"81":0,"83":0,"84":0.02168,"85":0.47687,"86":1.13799},"android":{"3":0,"4":0.04623,"81":null,"2.1":0,"2.2":0,"2.3":0.00037,"4.1":0.0233,"4.2-4.3":0.01036,"4.4":0,"4.4.3-4.4.4":0.08432},"samsung":{"4":0.16285,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.4682,"8.2":0.02036,"9.2":0.13232,"10.1":0.28499,"11.1-11.2":0.22392,"12.0":4.47841},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.02168,"9":0,"10":0,"11":0.33056,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.17866},"and_qq":{"10.4":0.00458},"and_uc":{"0":2.55162},"op_mini":{"0":0.54212},"and_chr":{"0":49.31087}},"total":94.92645}

/***/ },
/* 1336 */
/***/ function(module, exports) {

	module.exports = {"id":"SD","name":"Sudan","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0.00251,"31":0,"32":0,"33":0.00251,"34":0.00251,"35":0.00251,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0.00251,"42":0.00251,"43":0.00754,"44":0.00251,"45":0.00251,"46":0,"47":0.01006,"48":0.00503,"49":0.00251,"50":0,"51":0,"52":0.02011,"53":0,"54":0.00251,"55":0,"56":0.00503,"57":0.00503,"58":0,"59":0,"60":0.00251,"61":0.00251,"62":0,"63":0,"64":0.00251,"65":0.00251,"66":0.00503,"67":0.00251,"68":0.02263,"69":0.00503,"70":0.00251,"71":0,"72":0.0176,"73":0.00503,"74":0.00251,"75":0.00754,"76":0.00251,"77":0.00503,"78":0.06034,"79":0.02011,"80":0.03771,"81":0.87236,"82":0.10056,"83":0.00754,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00251,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00251,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00251,"30":0,"31":0,"32":0,"33":0.00251,"34":0.00251,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.01257,"41":0,"42":0.00503,"43":0.03268,"44":0,"45":0,"46":0.00251,"47":0.00251,"48":0.00251,"49":0.00754,"50":0.00251,"51":0.00251,"52":0,"53":0,"54":0.00251,"55":0.00251,"56":0.00251,"57":0.00754,"58":0.00503,"59":0.00251,"60":0.00251,"61":0.00754,"62":0.00251,"63":0.01257,"64":0.00503,"65":0.00251,"66":0.00251,"67":0.00251,"68":0.00503,"69":0.0176,"70":0.01006,"71":0.00503,"72":0.00754,"73":0.00503,"74":0.00754,"75":0.01508,"76":0.01006,"77":0.01006,"78":0.03268,"79":0.03771,"80":0.04274,"81":0.02263,"83":0.03268,"84":0.04525,"85":0.91258,"86":1.41287,"87":0.00251,"88":0.00251,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0.00251,"16":0.00251,"17":0,"18":0,"19":0.00251,"20":0.00251,"21":0,"22":0,"23":0.00251,"24":0.02263,"25":0.00251,"26":0.0176,"27":0.00251,"28":0.03017,"29":0.00251,"30":0.01257,"31":0.00251,"32":0.01257,"33":0.01006,"34":0,"35":0.00503,"36":0,"37":0.00251,"38":0.0176,"39":0,"40":0,"41":0.00754,"42":0.00251,"43":0,"44":0,"45":0.00754,"46":0.01257,"47":0.0176,"48":0.00251,"49":0,"50":0.04274,"51":0.05531,"52":0,"53":0.02011,"54":0.00503,"55":0.00251,"56":0.00503,"57":0.00251,"58":0.00251,"60":0.06788,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00251,"69":0,"70":0.06788,"71":0.3771,"72":0.00503,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0.00503,"11.6":0,"12.1":0.01257},"ios_saf":{"8":0,"14":2.68656,"3.2":0.00644,"4.0-4.1":0.00552,"4.2-4.3":0.00092,"5.0-5.1":0.0046,"6.0-6.1":0.00276,"7.0-7.1":0.00644,"8.1-8.4":0.02115,"9.0-9.2":0.01195,"9.3":0.15262,"10.0-10.2":0.02574,"10.3":0.14159,"11.0-11.2":0.05333,"11.3-11.4":0.09102,"12.0-12.1":0.09286,"12.2-12.4":0.92586,"13.0-13.1":0.07631,"13.2":0.0377,"13.3":0.28686,"13.4-13.7":1.52809},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00503,"11":0.00754,"12":0.00251,"13":0.02011,"14":0.04274,"3.1":0,"3.2":0,"5.1":0.70643,"6.1":0,"7.1":0,"9.1":0.01006,"10.1":0.00503,"11.1":0.03268,"12.1":0.05531,"13.1":0.08799},"edge":{"12":0.00503,"13":0.00754,"14":0.0176,"15":0.00503,"16":0.01006,"17":0.05782,"18":0.07542,"79":0,"80":0,"81":0.00503,"83":0,"84":0.00503,"85":0.09553,"86":0.17095},"android":{"3":0,"4":0.08499,"81":null,"2.1":0,"2.2":0,"2.3":0.00068,"4.1":0.04284,"4.2-4.3":0.01904,"4.4":0,"4.4.3-4.4.4":0.15502},"samsung":{"4":1.59065,"5.0-5.4":0.11074,"6.2-6.4":0.13088,"7.2-7.4":0.4027,"8.2":0.07047,"9.2":0.35236,"10.1":0.17115,"11.1-11.2":0.44296,"12.0":1.39937},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.02757,"9":0.00459,"10":0,"11":0.10108,"5.5":0},"bb":{"7":0,"10":0.00749},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.01497},"baidu":{"0":null},"and_ff":{"0":0.19464},"and_qq":{"10.4":0.07486},"and_uc":{"0":1.93139},"op_mini":{"0":10.04265},"and_chr":{"0":65.36039}},"total":95.24452}

/***/ },
/* 1337 */
/***/ function(module, exports) {

	module.exports = {"id":"SE","name":"Sweden","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0.00566,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.01132,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00566,"49":0,"50":0,"51":0,"52":0.02264,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0.00566,"60":0.00566,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.02831,"69":0,"70":0,"71":0,"72":0.00566,"73":0,"74":0,"75":0,"76":0.00566,"77":0.01132,"78":0.06793,"79":0.01698,"80":0.06793,"81":1.27939,"82":0.19247,"83":0.00566,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0.00566,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.01132,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.00566,"47":0,"48":0,"49":0.04529,"50":0,"51":0,"52":0.00566,"53":0.01132,"54":0,"55":0,"56":0,"57":0,"58":0.00566,"59":0.00566,"60":0,"61":0.00566,"62":0,"63":0.00566,"64":0.00566,"65":0.01698,"66":0.02264,"67":0.02264,"68":0.00566,"69":0.03963,"70":0.01132,"71":0.16417,"72":0.01132,"73":0.02264,"74":0.01132,"75":0.02831,"76":0.05095,"77":0.06793,"78":0.03397,"79":0.07359,"80":0.09624,"81":0.16417,"83":0.19247,"84":0.45854,"85":10.13319,"86":9.47085,"87":0.01698,"88":0.00566,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.00566,"51":0.00566,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0.01132,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.03963,"71":0.23776,"72":0.00566,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":16.05936,"3.2":0.03847,"4.0-4.1":0.03298,"4.2-4.3":0.0055,"5.0-5.1":0.02748,"6.0-6.1":0.01649,"7.0-7.1":0.03847,"8.1-8.4":0.12641,"9.0-9.2":0.07145,"9.3":0.91234,"10.0-10.2":0.15389,"10.3":0.84639,"11.0-11.2":0.31877,"11.3-11.4":0.54411,"12.0-12.1":0.5551,"12.2-12.4":5.53449,"13.0-13.1":0.45617,"13.2":0.22534,"13.3":1.71476,"13.4-13.7":9.13438},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00566,"11":0.01132,"12":0.02831,"13":0.27739,"14":1.51149,"3.1":0,"3.2":0,"5.1":0.00566,"6.1":0,"7.1":0,"9.1":0.00566,"10.1":0.03963,"11.1":0.09058,"12.1":0.16983,"13.1":2.28138},"edge":{"12":0,"13":0,"14":0.00566,"15":0.00566,"16":0.03397,"17":0.03963,"18":0.41325,"79":0,"80":0.01132,"81":0.01132,"83":0.01132,"84":0.01698,"85":0.75857,"86":1.3643},"android":{"3":0,"4":0.02809,"81":null,"2.1":0,"2.2":0,"2.3":0.00022,"4.1":0.01416,"4.2-4.3":0.00629,"4.4":0,"4.4.3-4.4.4":0.05124},"samsung":{"4":0.06255,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.02085,"8.2":0.01043,"9.2":0.0417,"10.1":0.06255,"11.1-11.2":0.10425,"12.0":3.65918},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01155,"9":0.00577,"10":0,"11":0.5601,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.29505},"and_qq":{"10.4":0},"and_uc":{"0":0.02603},"op_mini":{"0":0.13967},"and_chr":{"0":25.11428}},"total":97.40318}

/***/ },
/* 1338 */
/***/ function(module, exports) {

	module.exports = {"id":"SG","name":"Singapore","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.01804,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00451,"49":0,"50":0,"51":0,"52":0.00451,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0.01353,"64":0.00451,"65":0.00451,"66":0.00451,"67":0.00451,"68":0.02255,"69":0,"70":0,"71":0,"72":0.00902,"73":0,"74":0.00451,"75":0.00451,"76":0.00451,"77":0.00451,"78":0.03607,"79":0.00902,"80":0.03607,"81":0.84769,"82":0.12174,"83":0.00451,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00451,"23":0,"24":0,"25":0,"26":0.00451,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.0496,"35":0,"36":0,"37":0,"38":0.10822,"39":0,"40":0.00451,"41":0.00451,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.01353,"48":0,"49":0.31563,"50":0.00451,"51":0,"52":0,"53":0.11723,"54":0.00451,"55":0.00451,"56":0.00451,"57":0.00451,"58":0.00451,"59":0,"60":0,"61":0.00902,"62":0.01804,"63":0.00451,"64":0.00902,"65":0.02255,"66":0.00451,"67":0.02255,"68":0.01804,"69":0.01804,"70":0.04058,"71":0.05862,"72":0.04509,"73":0.04058,"74":0.01804,"75":0.02255,"76":0.02255,"77":0.03607,"78":0.03156,"79":0.05411,"80":0.11723,"81":0.08567,"83":0.13076,"84":0.27505,"85":4.79758,"86":7.10618,"87":0.00902,"88":0.00451,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00902,"37":0.02255,"38":0,"39":0,"40":0.00451,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.00451,"47":0,"48":0,"49":0,"50":0.00451,"51":0.05862,"52":0.00451,"53":0,"54":0.00451,"55":0,"56":0.00451,"57":0.00451,"58":0.00451,"60":0.00451,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.01804,"71":0.12174,"72":0.00451,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":11.31545,"3.2":0.02711,"4.0-4.1":0.02324,"4.2-4.3":0.00387,"5.0-5.1":0.01936,"6.0-6.1":0.01162,"7.0-7.1":0.02711,"8.1-8.4":0.08907,"9.0-9.2":0.05034,"9.3":0.64284,"10.0-10.2":0.10843,"10.3":0.59637,"11.0-11.2":0.22461,"11.3-11.4":0.38338,"12.0-12.1":0.39112,"12.2-12.4":3.89961,"13.0-13.1":0.32142,"13.2":0.15877,"13.3":1.20822,"13.4-13.7":6.4361},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0.00451,"9":0,"10":0.00451,"11":0.00902,"12":0.01804,"13":0.12625,"14":0.80711,"3.1":0,"3.2":0,"5.1":0.00902,"6.1":0,"7.1":0,"9.1":0.00451,"10.1":0.01804,"11.1":0.03607,"12.1":0.07665,"13.1":1.17234},"edge":{"12":0,"13":0,"14":0,"15":0,"16":0.00451,"17":0.01804,"18":0.07665,"79":0,"80":0,"81":0,"83":0,"84":0.00902,"85":0.29309,"86":0.58166},"android":{"3":0,"4":0.2141,"81":null,"2.1":0,"2.2":0,"2.3":0.00171,"4.1":0.1079,"4.2-4.3":0.04796,"4.4":0,"4.4.3-4.4.4":0.39051},"samsung":{"4":0.51327,"5.0-5.4":0.01047,"6.2-6.4":0.02095,"7.2-7.4":0.01047,"8.2":0.01047,"9.2":0.03142,"10.1":0.03142,"11.1-11.2":0.06285,"12.0":3.94906},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01612,"9":0.00537,"10":0.00537,"11":0.7577,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.39535},"and_qq":{"10.4":0.08786},"and_uc":{"0":0.75776},"op_mini":{"0":0.63422},"and_chr":{"0":35.74333}},"total":88.12247}

/***/ },
/* 1339 */
/***/ function(module, exports) {

	module.exports = {"id":"SH","name":"Saint Helena","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0,"79":0,"80":0,"81":6.84487,"82":0,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0,"79":0,"80":0,"81":13.68974,"83":0,"84":0,"85":3.91644,"86":22.49283,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":9.06186,"3.2":0.02171,"4.0-4.1":0.01861,"4.2-4.3":0.0031,"5.0-5.1":0.01551,"6.0-6.1":0.0093,"7.0-7.1":0.02171,"8.1-8.4":0.07133,"9.0-9.2":0.04032,"9.3":0.51481,"10.0-10.2":0.08684,"10.3":0.47759,"11.0-11.2":0.17987,"11.3-11.4":0.30702,"12.0-12.1":0.31323,"12.2-12.4":3.12296,"13.0-13.1":0.2574,"13.2":0.12715,"13.3":0.96759,"13.4-13.7":5.15428},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":30.32571,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0,"12.1":0,"13.1":0},"edge":{"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"79":0,"80":0,"81":0,"83":0,"84":0,"85":0,"86":0},"android":{"3":0,"4":0,"81":null,"2.1":0,"2.2":0,"2.3":0,"4.1":0,"4.2-4.3":0,"4.4":0,"4.4.3-4.4.4":0},"samsung":{"4":0,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0,"8.2":0,"9.2":0,"10.1":0,"11.1-11.2":0,"12.0":0},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0},"and_qq":{"10.4":0},"and_uc":{"0":0},"op_mini":{"0":0},"and_chr":{"0":0}},"total":98.04178}

/***/ },
/* 1340 */
/***/ function(module, exports) {

	module.exports = {"id":"SI","name":"Slovenia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.00632,"46":0,"47":0,"48":0.00632,"49":0,"50":0.00632,"51":0,"52":0.12636,"53":0.00632,"54":0,"55":0,"56":0.00632,"57":0.00632,"58":0.00632,"59":0,"60":0.03791,"61":0,"62":0.00632,"63":0.01895,"64":0.01264,"65":0.00632,"66":0.00632,"67":0.01264,"68":0.05054,"69":0.00632,"70":0.00632,"71":0.01264,"72":0.01895,"73":0.00632,"74":0.01264,"75":0.02527,"76":0.01895,"77":0.01895,"78":0.22745,"79":0.03159,"80":0.1769,"81":4.65005,"82":0.81502,"83":0.01264,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00632,"30":0,"31":0,"32":0,"33":0,"34":0.00632,"35":0,"36":0,"37":0,"38":0.00632,"39":0,"40":0,"41":0,"42":0,"43":0.00632,"44":0,"45":0,"46":0.06318,"47":0,"48":0,"49":0.12636,"50":0,"51":0,"52":0,"53":0.01264,"54":0,"55":0,"56":0.00632,"57":0,"58":0.01895,"59":0,"60":0,"61":0.08213,"62":0.01895,"63":0.00632,"64":0,"65":0.01264,"66":0,"67":0.01264,"68":0.00632,"69":0.02527,"70":0.02527,"71":0.01895,"72":0.03159,"73":0.02527,"74":0.01895,"75":0.04423,"76":0.03159,"77":0.02527,"78":0.02527,"79":0.02527,"80":0.139,"81":0.05686,"83":0.13268,"84":0.1769,"85":9.31273,"86":15.19479,"87":0.01264,"88":0.00632,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00632,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0.00632,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00632,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.10741,"71":0.68234,"72":0.01264,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":4.69979,"3.2":0.01126,"4.0-4.1":0.00965,"4.2-4.3":0.00161,"5.0-5.1":0.00804,"6.0-6.1":0.00483,"7.0-7.1":0.01126,"8.1-8.4":0.03699,"9.0-9.2":0.02091,"9.3":0.267,"10.0-10.2":0.04504,"10.3":0.2477,"11.0-11.2":0.09329,"11.3-11.4":0.15923,"12.0-12.1":0.16245,"12.2-12.4":1.61968,"13.0-13.1":0.1335,"13.2":0.06595,"13.3":0.50183,"13.4-13.7":2.67319},"safari":{"0":null,"4":0,"5":0.00632,"6":0,"7":0,"8":0,"9":0,"10":0.00632,"11":0.00632,"12":0.02527,"13":0.12004,"14":0.91611,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.00632,"10.1":0.01895,"11.1":0.06318,"12.1":0.10741,"13.1":0.8087},"edge":{"12":0,"13":0,"14":0.00632,"15":0.01264,"16":0.01264,"17":0.01264,"18":0.1769,"79":0,"80":0,"81":0,"83":0,"84":0.01264,"85":0.73921,"86":1.61741},"android":{"3":0,"4":0.04879,"81":null,"2.1":0,"2.2":0,"2.3":0.00039,"4.1":0.02459,"4.2-4.3":0.01093,"4.4":0,"4.4.3-4.4.4":0.08899},"samsung":{"4":0.08248,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.02062,"8.2":0.01031,"9.2":0.07217,"10.1":0.06186,"11.1-11.2":0.1031,"12.0":2.897},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00635,"9":0,"10":0,"11":1.3078,"5.5":0},"bb":{"7":0,"10":0.00368},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.27247},"and_qq":{"10.4":0},"and_uc":{"0":0.00368},"op_mini":{"0":0.21961},"and_chr":{"0":43.77519}},"total":97.36273}

/***/ },
/* 1341 */
/***/ function(module, exports) {

	module.exports = {"id":"SK","name":"Slovakia (Slovak Republic)","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":null,"3":null,"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":0.00603,"48":0.01207,"49":null,"50":null,"51":null,"52":0.21116,"53":null,"54":null,"55":null,"56":0.04826,"57":0.00603,"58":null,"59":0.03017,"60":0.01207,"61":null,"62":0.00603,"63":null,"64":null,"65":0.01207,"66":0.0181,"67":0.01207,"68":0.0905,"69":null,"70":0.01207,"71":0.01207,"72":0.04223,"73":0.0181,"74":0.01207,"75":0.01207,"76":0.0181,"77":0.02413,"78":0.25339,"79":0.11463,"80":0.21116,"81":6.31655,"82":1.06181,"83":0.01207,"84":null,"3.5":null,"3.6":null},"chrome":{"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":0.00603,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":0.01207,"35":null,"36":null,"37":null,"38":0.0362,"39":null,"40":null,"41":null,"42":null,"43":0.02413,"44":null,"45":null,"46":null,"47":0.00603,"48":0.03017,"49":0.34388,"50":null,"51":null,"52":null,"53":0.06033,"54":null,"55":null,"56":null,"57":0.00603,"58":0.00603,"59":0.01207,"60":null,"61":null,"62":null,"63":0.07843,"64":null,"65":0.01207,"66":0.00603,"67":0.03017,"68":null,"69":0.04826,"70":0.04826,"71":0.07843,"72":0.02413,"73":0.0724,"74":0.0181,"75":0.03017,"76":0.0181,"77":0.02413,"78":0.0905,"79":0.06033,"80":0.12669,"81":0.14479,"83":0.14479,"84":0.36198,"85":13.57425,"86":23.4744,"87":0.02413,"88":0.01207,"89":null},"opera":{"9":null,"11":null,"12":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":0.0181,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":null,"51":null,"52":null,"53":null,"54":null,"55":null,"56":null,"57":null,"58":0.0181,"60":null,"62":null,"63":null,"64":null,"65":null,"66":null,"67":null,"68":0.01207,"69":null,"70":0.39818,"71":2.77518,"72":0.0543,"9.5-9.6":null,"10.0-10.1":0,"10.5":null,"10.6":null,"11.1":null,"11.5":null,"11.6":null,"12.1":0.02413},"ios_saf":{"8":0,"14":3.32449,"3.2":0.00796,"4.0-4.1":0.00683,"4.2-4.3":0.00114,"5.0-5.1":0.00569,"6.0-6.1":0.00341,"7.0-7.1":0.00796,"8.1-8.4":0.02617,"9.0-9.2":0.01479,"9.3":0.18887,"10.0-10.2":0.03186,"10.3":0.17521,"11.0-11.2":0.06599,"11.3-11.4":0.11264,"12.0-12.1":0.11491,"12.2-12.4":1.14571,"13.0-13.1":0.09443,"13.2":0.04665,"13.3":0.35498,"13.4-13.7":1.89093},"safari":{"0":null,"4":0,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":0.00603,"12":0.04826,"13":0.19306,"14":1.81593,"3.1":null,"3.2":null,"5.1":0.01207,"6.1":null,"7.1":null,"9.1":null,"10.1":0.0362,"11.1":0.09653,"12.1":0.15686,"13.1":1.32726},"edge":{"12":null,"13":null,"14":0.00603,"15":0.02413,"16":0.0181,"17":0.04826,"18":0.31975,"79":null,"80":null,"81":0.00603,"83":null,"84":0.0181,"85":0.92305,"86":2.24428},"android":{"3":0,"4":0.039,"81":null,"2.1":0,"2.2":0,"2.3":0.00031,"4.1":0.01966,"4.2-4.3":0.00874,"4.4":0,"4.4.3-4.4.4":0.07114},"samsung":{"4":0.24245,"5.0-5.4":0.01054,"6.2-6.4":0.02095,"7.2-7.4":0.01047,"8.2":0.01047,"9.2":0.01054,"10.1":0.04217,"11.1-11.2":0.08433,"12.0":2.22422},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":null,"7":null,"8":0.00607,"9":0.01214,"10":0.00607,"11":1.0134,"5.5":null},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.21025},"and_qq":{"10.4":0},"and_uc":{"0":0.05157},"op_mini":{"0":0.34552},"and_chr":{"0":29.17744}},"total":99.46865}

/***/ },
/* 1342 */
/***/ function(module, exports) {

	module.exports = {"id":"SL","name":"Sierra Leone","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0.00649,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0.00973,"14":0,"15":0.00324,"16":0,"17":0.00324,"18":0,"19":0,"20":0.00324,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00649,"30":0.00324,"31":0,"32":0,"33":0,"34":0,"35":0.00324,"36":0.00324,"37":0,"38":0.00324,"39":0.00324,"40":0.00324,"41":0,"42":0,"43":0.01297,"44":0.00324,"45":0.00324,"46":0,"47":0.00324,"48":0.00324,"49":0,"50":0,"51":0,"52":0.00324,"53":0,"54":0,"55":0,"56":0.00324,"57":0,"58":0,"59":0,"60":0.00324,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.01297,"69":0,"70":0,"71":0,"72":0.0227,"73":0,"74":0,"75":0.0227,"76":0,"77":0.00324,"78":0.01946,"79":0.02919,"80":0.04216,"81":0.52537,"82":0.10702,"83":0.01946,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00649,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0.00973,"25":0.00324,"26":0,"27":0,"28":0,"29":0,"30":0.00324,"31":0,"32":0,"33":0.02594,"34":0.00324,"35":0,"36":0,"37":0,"38":0.00324,"39":0,"40":0.00324,"41":0,"42":0,"43":0.00324,"44":0,"45":0,"46":0.00324,"47":0,"48":0,"49":0.00973,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0.00649,"59":0,"60":0.00649,"61":0,"62":0,"63":0.01297,"64":0.01297,"65":0.00973,"66":0,"67":0.0227,"68":0,"69":0.01622,"70":0.00649,"71":0,"72":0.00649,"73":0.00973,"74":0.05837,"75":0.00973,"76":0.00649,"77":0.01946,"78":0.00324,"79":0.03567,"80":0.01946,"81":0.0454,"83":0.02919,"84":0.07783,"85":1.76744,"86":3.20408,"87":0.00973,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0.00324,"16":0.00973,"17":0,"18":0.00649,"19":0.00324,"20":0.04216,"21":0,"22":0,"23":0.03243,"24":0.00324,"25":0,"26":0.00324,"27":0,"28":0.00649,"29":0,"30":0,"31":0,"32":0.00324,"33":0,"34":0,"35":0,"36":0,"37":0.00649,"38":0.00973,"39":0,"40":0,"41":0,"42":0.00649,"43":0,"44":0,"45":0.00649,"46":0.00649,"47":0.00649,"48":0,"49":0,"50":0.16864,"51":0.07783,"52":0,"53":0.00324,"54":0,"55":0.00324,"56":0.00324,"57":0.00324,"58":0.02594,"60":0.0227,"62":0,"63":0,"64":0,"65":0.00324,"66":0.00324,"67":0.00324,"68":0.00973,"69":0.00324,"70":0.06486,"71":0.46051,"72":0.01946,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.54807},"ios_saf":{"8":0,"14":2.08575,"3.2":0.005,"4.0-4.1":0.00428,"4.2-4.3":0.00071,"5.0-5.1":0.00357,"6.0-6.1":0.00214,"7.0-7.1":0.005,"8.1-8.4":0.01642,"9.0-9.2":0.00928,"9.3":0.11849,"10.0-10.2":0.01999,"10.3":0.10993,"11.0-11.2":0.0414,"11.3-11.4":0.07067,"12.0-12.1":0.07209,"12.2-12.4":0.71881,"13.0-13.1":0.05925,"13.2":0.02927,"13.3":0.22271,"13.4-13.7":1.18635},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00324,"11":0,"12":0.00324,"13":0.00973,"14":0.17512,"3.1":0,"3.2":0,"5.1":0.14918,"6.1":0,"7.1":0,"9.1":0.00324,"10.1":0.00324,"11.1":0.00649,"12.1":0.01946,"13.1":0.21404},"edge":{"12":0.03892,"13":0.01946,"14":0.00973,"15":0.01622,"16":0.01297,"17":0.02919,"18":0.28863,"79":0,"80":0,"81":0.00324,"83":0.00649,"84":0.02594,"85":0.25295,"86":0.35997},"android":{"3":0,"4":0.12337,"81":null,"2.1":0,"2.2":0,"2.3":0.00099,"4.1":0.06218,"4.2-4.3":0.02763,"4.4":0,"4.4.3-4.4.4":0.22502},"samsung":{"4":0.15403,"5.0-5.4":0.05134,"6.2-6.4":0.01027,"7.2-7.4":0.12323,"8.2":0.02054,"9.2":0.08215,"10.1":0.06161,"11.1-11.2":0.35941,"12.0":0.69828},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.02351,"9":0,"10":0.00588,"11":0.1587,"5.5":0},"bb":{"7":0,"10":0.02027},"ie_mob":{"10":0.06081,"11":0},"kaios":{"2.5":0.01351},"baidu":{"0":null},"and_ff":{"0":0.1419},"and_qq":{"10.4":0.02703},"and_uc":{"0":2.19603},"op_mini":{"0":21.9868},"and_chr":{"0":49.58629}},"total":90.59465}

/***/ },
/* 1343 */
/***/ function(module, exports) {

	module.exports = {"id":"SM","name":"San Marino","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.03195,"49":0,"50":0,"51":0,"52":0.03195,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0.00799,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0.00799,"67":0,"68":0.01598,"69":0,"70":0,"71":0,"72":0.01598,"73":0,"74":0.00799,"75":0,"76":0.00799,"77":0.00799,"78":0.50324,"79":0.01598,"80":0.11183,"81":4.04193,"82":0.61508,"83":0.0639,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.00799,"35":0,"36":0,"37":0,"38":0.00799,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.49526,"50":0,"51":0,"52":0,"53":0.01598,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0.00799,"64":0.01598,"65":0.00799,"66":0.00799,"67":0.11183,"68":0,"69":0,"70":0,"71":0.00799,"72":0.03195,"73":0.01598,"74":0.00799,"75":0.00799,"76":0.11982,"77":0.0639,"78":0.00799,"79":0.00799,"80":0,"81":0.04793,"83":0.07189,"84":0.18372,"85":15.81624,"86":27.63848,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.00799,"71":0.39141,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":5.86488,"3.2":0.01405,"4.0-4.1":0.01204,"4.2-4.3":0.00201,"5.0-5.1":0.01004,"6.0-6.1":0.00602,"7.0-7.1":0.01405,"8.1-8.4":0.04616,"9.0-9.2":0.02609,"9.3":0.33319,"10.0-10.2":0.0562,"10.3":0.3091,"11.0-11.2":0.11641,"11.3-11.4":0.19871,"12.0-12.1":0.20272,"12.2-12.4":2.0212,"13.0-13.1":0.16659,"13.2":0.08229,"13.3":0.62623,"13.4-13.7":3.33588},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00799,"11":0,"12":0.08787,"13":0.67898,"14":2.67598,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.00799,"10.1":0.12781,"11.1":0.25562,"12.1":0.72691,"13.1":2.50024},"edge":{"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0.50324,"79":0,"80":0,"81":0,"83":0,"84":0,"85":1.31003,"86":2.29256},"android":{"3":0,"4":0.02362,"81":null,"2.1":0,"2.2":0,"2.3":0.00019,"4.1":0.0119,"4.2-4.3":0.00529,"4.4":0,"4.4.3-4.4.4":0.04308},"samsung":{"4":0.02075,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0,"8.2":0,"9.2":0,"10.1":0,"11.1-11.2":0.01037,"12.0":2.10563},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.44733,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.0664},"and_qq":{"10.4":0},"and_uc":{"0":0},"op_mini":{"0":0.00571},"and_chr":{"0":20.18905}},"total":98.14443}

/***/ },
/* 1344 */
/***/ function(module, exports) {

	module.exports = {"id":"SN","name":"Senegal","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.0029,"30":0,"31":0,"32":0.00579,"33":0,"34":0.0029,"35":0.0029,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0.0029,"43":0.0029,"44":0,"45":0.0029,"46":0,"47":0.02316,"48":0.0029,"49":0,"50":0,"51":0.0029,"52":0.00869,"53":0.0029,"54":0,"55":0,"56":0.0029,"57":0,"58":0,"59":0,"60":0.00579,"61":0,"62":0,"63":0.0029,"64":0.0029,"65":0.0029,"66":0.0029,"67":0.01448,"68":0.02027,"69":0,"70":0.00869,"71":0,"72":0.00869,"73":0,"74":0.0029,"75":0.0029,"76":0.0029,"77":0,"78":0.05501,"79":0.00579,"80":0.02895,"81":0.71507,"82":0.08396,"83":0.0029,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0.00579,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.0029,"39":0,"40":0.0029,"41":0,"42":0,"43":0.0029,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.04632,"50":0,"51":0,"52":0,"53":0.0029,"54":0,"55":0.0029,"56":0.0029,"57":0,"58":0.0029,"59":0.0029,"60":0,"61":0.00579,"62":0.0029,"63":0.01448,"64":0.00579,"65":0.02316,"66":0.00579,"67":0.01448,"68":0,"69":0.02606,"70":0.00869,"71":0.00579,"72":0.00579,"73":0.00579,"74":0.0579,"75":0.01448,"76":0.02027,"77":0.00869,"78":0.00869,"79":0.01448,"80":0.04922,"81":0.04343,"83":0.02316,"84":0.06659,"85":1.60094,"86":2.90948,"87":0.00579,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.00579,"51":0.04343,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.0029,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.03764,"71":0.22871,"72":0.00579,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":5.21442,"3.2":0.01249,"4.0-4.1":0.01071,"4.2-4.3":0.00178,"5.0-5.1":0.00892,"6.0-6.1":0.00535,"7.0-7.1":0.01249,"8.1-8.4":0.04104,"9.0-9.2":0.0232,"9.3":0.29623,"10.0-10.2":0.04997,"10.3":0.27482,"11.0-11.2":0.1035,"11.3-11.4":0.17667,"12.0-12.1":0.18024,"12.2-12.4":1.79703,"13.0-13.1":0.14812,"13.2":0.07317,"13.3":0.55678,"13.4-13.7":2.9659},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00579,"11":0.00579,"12":0.00579,"13":0.01448,"14":0.13896,"3.1":0,"3.2":0,"5.1":0.01448,"6.1":0,"7.1":0,"9.1":0.00579,"10.1":0.01158,"11.1":0.03474,"12.1":0.04053,"13.1":0.15344},"edge":{"12":0.00869,"13":0.0029,"14":0.0029,"15":0.01448,"16":0.00869,"17":0.01737,"18":0.06369,"79":0,"80":0,"81":0,"83":0,"84":0.00579,"85":0.13028,"86":0.25187},"android":{"3":0,"4":0.05071,"81":null,"2.1":0,"2.2":0,"2.3":0.00041,"4.1":0.02556,"4.2-4.3":0.01136,"4.4":0,"4.4.3-4.4.4":0.0925},"samsung":{"4":0.41315,"5.0-5.4":0.02015,"6.2-6.4":0.06046,"7.2-7.4":0.38292,"8.2":0.03023,"9.2":0.33253,"10.1":0.15115,"11.1-11.2":0.48369,"12.0":2.31766},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00655,"9":0,"10":0.00327,"11":0.14072,"5.5":0},"bb":{"7":0,"10":0.02132},"ie_mob":{"10":0,"11":0.02842},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.15631},"and_qq":{"10.4":0.00711},"and_uc":{"0":0.09947},"op_mini":{"0":0.53812},"and_chr":{"0":73.76734}},"total":98.41571}

/***/ },
/* 1345 */
/***/ function(module, exports) {

	module.exports = {"id":"SO","name":"Somalia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.00412,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0.00412,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00824,"69":0,"70":0,"71":0,"72":0.00412,"73":0,"74":0.00824,"75":0,"76":0.00412,"77":0,"78":0.00824,"79":0.00824,"80":0.00824,"81":0.51899,"82":0.0865,"83":0.00412,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00412,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0.00412,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0.04943,"34":0,"35":0,"36":0,"37":0.14005,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.02883,"44":0,"45":0.00824,"46":0,"47":0.00824,"48":0,"49":0.00412,"50":0,"51":0.00412,"52":0,"53":0.00412,"54":0,"55":0.00824,"56":0,"57":0.00412,"58":0,"59":0,"60":0,"61":0.00412,"62":0.00412,"63":0.04943,"64":0.01236,"65":0,"66":0,"67":0,"68":0.00824,"69":0.00824,"70":0.01236,"71":0.00412,"72":0.00412,"73":0.00824,"74":0.02471,"75":0.00412,"76":0.02471,"77":0.02883,"78":0.03295,"79":0.06179,"80":0.08238,"81":0.03295,"83":0.03707,"84":0.14417,"85":4.95928,"86":7.80551,"87":0.02883,"88":0.02471,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0.00412,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.03707,"51":0.07414,"52":0,"53":0.00412,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.0206,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.07414,"71":0.35835,"72":0.00824,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00824},"ios_saf":{"8":0,"14":2.06724,"3.2":0.00495,"4.0-4.1":0.00424,"4.2-4.3":0.00071,"5.0-5.1":0.00354,"6.0-6.1":0.00212,"7.0-7.1":0.00495,"8.1-8.4":0.01627,"9.0-9.2":0.0092,"9.3":0.11744,"10.0-10.2":0.01981,"10.3":0.10895,"11.0-11.2":0.04103,"11.3-11.4":0.07004,"12.0-12.1":0.07146,"12.2-12.4":0.71243,"13.0-13.1":0.05872,"13.2":0.02901,"13.3":0.22073,"13.4-13.7":1.17582},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0.00412,"8":0,"9":0,"10":0,"11":0,"12":0.00412,"13":0.0206,"14":0.04531,"3.1":0,"3.2":0,"5.1":0.32128,"6.1":0,"7.1":0,"9.1":0,"10.1":0.0865,"11.1":0,"12.1":0.07002,"13.1":0.16064},"edge":{"12":0.01236,"13":0.00824,"14":0.00412,"15":0.00412,"16":0.01236,"17":0.02883,"18":0.16064,"79":0,"80":0,"81":0.00412,"83":0,"84":0.00412,"85":0.35012,"86":0.55195},"android":{"3":0,"4":0.05783,"81":null,"2.1":0,"2.2":0,"2.3":0.00046,"4.1":0.02915,"4.2-4.3":0.01295,"4.4":0,"4.4.3-4.4.4":0.10549},"samsung":{"4":0.35414,"5.0-5.4":0.05059,"6.2-6.4":0.10118,"7.2-7.4":0.54639,"8.2":0.02024,"9.2":0.23272,"10.1":0.21248,"11.1-11.2":0.57674,"12.0":2.79263},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00824,"9":0,"10":0,"11":0.03295,"5.5":0},"bb":{"7":0,"10":0.01176},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.06469},"and_qq":{"10.4":0.00588},"and_uc":{"0":3.76384},"op_mini":{"0":3.7805},"and_chr":{"0":60.04822}},"total":94.33272}

/***/ },
/* 1346 */
/***/ function(module, exports) {

	module.exports = {"id":"SR","name":"Suriname","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0.00462,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.00462,"53":0.00462,"54":0,"55":0,"56":0.00462,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0.00924,"64":0,"65":0.00462,"66":0,"67":0,"68":0.00924,"69":0.00462,"70":0,"71":0,"72":0.00924,"73":0.00462,"74":0.00462,"75":0,"76":0,"77":0,"78":0.01849,"79":0.00924,"80":0.03235,"81":0.95675,"82":0.12479,"83":0.00462,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0.00462,"40":0.00462,"41":0.00462,"42":0,"43":0,"44":0,"45":0,"46":0.00462,"47":0,"48":0,"49":0.18488,"50":0,"51":0.01387,"52":0,"53":0.00462,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0.00462,"63":0.01849,"64":0.00462,"65":0.00462,"66":0.05084,"67":0.00462,"68":0,"69":0.00924,"70":0.01387,"71":0.02311,"72":0.00462,"73":0.00924,"74":0.01849,"75":0.05084,"76":0.00924,"77":0.00462,"78":0.06009,"79":0.0416,"80":0.12017,"81":0.12942,"83":0.06471,"84":0.17564,"85":5.1674,"86":8.3196,"87":0.00924,"88":0.00462,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00462,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.01387,"52":0,"53":0,"54":0,"55":0,"56":0.00462,"57":0,"58":0,"60":0.00462,"62":0,"63":0.00924,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.10168,"71":0.33741,"72":0.00462,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":5.99653,"3.2":0.01437,"4.0-4.1":0.01231,"4.2-4.3":0.00205,"5.0-5.1":0.01026,"6.0-6.1":0.00616,"7.0-7.1":0.01437,"8.1-8.4":0.0472,"9.0-9.2":0.02668,"9.3":0.34067,"10.0-10.2":0.05746,"10.3":0.31604,"11.0-11.2":0.11903,"11.3-11.4":0.20317,"12.0-12.1":0.20727,"12.2-12.4":2.06656,"13.0-13.1":0.17033,"13.2":0.08414,"13.3":0.64029,"13.4-13.7":3.41076},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0.02311,"9":0,"10":0,"11":0.00462,"12":0.0416,"13":0.02773,"14":0.32354,"3.1":0,"3.2":0,"5.1":0.2311,"6.1":0,"7.1":0,"9.1":0,"10.1":0.02311,"11.1":0.00924,"12.1":0.06471,"13.1":0.38363},"edge":{"12":0.00462,"13":0.00924,"14":0,"15":0.00462,"16":0.01849,"17":0.01849,"18":0.1479,"79":0,"80":0,"81":0,"83":0,"84":0.01387,"85":0.61473,"86":1.20172},"android":{"3":0,"4":0.16309,"81":null,"2.1":0,"2.2":0,"2.3":0.0013,"4.1":0.0822,"4.2-4.3":0.03653,"4.4":0,"4.4.3-4.4.4":0.29748},"samsung":{"4":0.46739,"5.0-5.4":0.02077,"6.2-6.4":0.05193,"7.2-7.4":0.46739,"8.2":0.03116,"9.2":0.27005,"10.1":0.18696,"11.1-11.2":0.58164,"12.0":6.64731},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.61935,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.10756},"and_qq":{"10.4":0.05916},"and_uc":{"0":0.48402},"op_mini":{"0":0.25967},"and_chr":{"0":51.46156}},"total":95.44526}

/***/ },
/* 1347 */
/***/ function(module, exports) {

	module.exports = {"id":"ST","name":"Sao Tome and Principe","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.02414,"50":0,"51":0,"52":0.01448,"53":0,"54":0,"55":0,"56":0.01448,"57":0,"58":0,"59":0,"60":0,"61":0.00483,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00483,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0.00483,"78":0.12553,"79":0,"80":0.04345,"81":0.32348,"82":0.05311,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0.01448,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.02414,"41":0,"42":0.01931,"43":0.35244,"44":0,"45":0,"46":0.02414,"47":0,"48":0,"49":0.02414,"50":0,"51":0.01931,"52":0,"53":0.01448,"54":0,"55":0,"56":0.00483,"57":0,"58":0.02897,"59":0,"60":0,"61":0.00483,"62":0.00483,"63":0.03862,"64":0,"65":0,"66":0.02897,"67":0,"68":0,"69":0.02897,"70":0.01448,"71":0,"72":0.02897,"73":0,"74":0.00483,"75":0,"76":0.04345,"77":0,"78":0.02414,"79":0.05794,"80":0.02897,"81":0.0338,"83":0.28968,"84":0.14484,"85":5.55703,"86":10.5347,"87":0,"88":0.00966,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0.00483,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.26071,"51":0.05794,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0.00483,"70":0.05311,"71":0.52142,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.02897},"ios_saf":{"8":0,"14":5.19132,"3.2":0.01244,"4.0-4.1":0.01066,"4.2-4.3":0.00178,"5.0-5.1":0.00888,"6.0-6.1":0.00533,"7.0-7.1":0.01244,"8.1-8.4":0.04086,"9.0-9.2":0.0231,"9.3":0.29492,"10.0-10.2":0.04975,"10.3":0.2736,"11.0-11.2":0.10304,"11.3-11.4":0.17589,"12.0-12.1":0.17944,"12.2-12.4":1.78907,"13.0-13.1":0.14746,"13.2":0.07284,"13.3":0.55431,"13.4-13.7":2.95276},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00483,"11":0.14967,"12":0,"13":0.02897,"14":0.18829,"3.1":0,"3.2":0,"5.1":0.16898,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00483,"11.1":0.09173,"12.1":0.02897,"13.1":0.30416},"edge":{"12":0.00483,"13":0,"14":0.00483,"15":0.00966,"16":0,"17":0,"18":0.13518,"79":0,"80":0,"81":0.01448,"83":0,"84":0.01931,"85":0.2414,"86":0.73868},"android":{"3":0,"4":0.1205,"81":null,"2.1":0,"2.2":0,"2.3":0.00096,"4.1":0.06073,"4.2-4.3":0.02699,"4.4":0,"4.4.3-4.4.4":0.21979},"samsung":{"4":0.12461,"5.0-5.4":0.01038,"6.2-6.4":0.01038,"7.2-7.4":0.08307,"8.2":0,"9.2":0.14538,"10.1":0.01038,"11.1-11.2":0.04154,"12.0":0.90342},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.03038,"9":0,"10":0,"11":0.38483,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.01034},"and_qq":{"10.4":0.01552},"and_uc":{"0":3.89452},"op_mini":{"0":0.99889},"and_chr":{"0":56.53298}},"total":96.6142}

/***/ },
/* 1348 */
/***/ function(module, exports) {

	module.exports = {"id":"SV","name":"El Salvador","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.00712,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0.00712,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.02847,"49":0,"50":0,"51":0,"52":0.03559,"53":0,"54":0,"55":0,"56":0,"57":0.00712,"58":0,"59":0,"60":0.00712,"61":0,"62":0,"63":0.00712,"64":0.00712,"65":0.00712,"66":0.17795,"67":0,"68":0.02847,"69":0.00712,"70":0.05694,"71":0,"72":0.01424,"73":0.04271,"74":0.00712,"75":0.00712,"76":0,"77":0.01424,"78":0.10677,"79":0.01424,"80":0.05694,"81":2.52689,"82":0.28472,"83":0.01424,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00712,"39":0,"40":0,"41":0,"42":0,"43":0.00712,"44":0,"45":0,"46":0,"47":0,"48":0.00712,"49":0.1993,"50":0,"51":0,"52":0,"53":0.02135,"54":0,"55":0,"56":0.00712,"57":0,"58":0.00712,"59":0,"60":0,"61":0,"62":0,"63":0.01424,"64":0,"65":0.02135,"66":0.01424,"67":0.04983,"68":0.01424,"69":0.00712,"70":0.06406,"71":0.03559,"72":0.07118,"73":0.04271,"74":0.03559,"75":0.05694,"76":0.04983,"77":0.09965,"78":0.06406,"79":0.09965,"80":0.1566,"81":0.12101,"83":0.17795,"84":0.29184,"85":13.92993,"86":22.99114,"87":0.02135,"88":0.00712,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00712,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00712,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0.01424,"58":0,"60":0.00712,"62":0.00712,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.14236,"71":1.33107,"72":0.02135,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":2.43802,"3.2":0.00584,"4.0-4.1":0.00501,"4.2-4.3":0.00083,"5.0-5.1":0.00417,"6.0-6.1":0.0025,"7.0-7.1":0.00584,"8.1-8.4":0.01919,"9.0-9.2":0.01085,"9.3":0.1385,"10.0-10.2":0.02336,"10.3":0.12849,"11.0-11.2":0.04839,"11.3-11.4":0.0826,"12.0-12.1":0.08427,"12.2-12.4":0.84021,"13.0-13.1":0.06925,"13.2":0.03421,"13.3":0.26032,"13.4-13.7":1.38672},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00712,"12":0.03559,"13":0.24913,"14":0.90399,"3.1":0,"3.2":0,"5.1":0.76874,"6.1":0,"7.1":0,"9.1":0,"10.1":0.01424,"11.1":0.05694,"12.1":0.16371,"13.1":0.85416},"edge":{"12":0,"13":0,"14":0,"15":0.01424,"16":0.00712,"17":0.02847,"18":0.08542,"79":0,"80":0.00712,"81":0,"83":0.00712,"84":0.00712,"85":0.61927,"86":1.18871},"android":{"3":0,"4":0.06175,"81":null,"2.1":0,"2.2":0,"2.3":0.00049,"4.1":0.03112,"4.2-4.3":0.01383,"4.4":0,"4.4.3-4.4.4":0.11263},"samsung":{"4":0.1139,"5.0-5.4":0.01035,"6.2-6.4":0,"7.2-7.4":0.08284,"8.2":0.01035,"9.2":0.08284,"10.1":0.07248,"11.1-11.2":0.1139,"12.0":1.24254},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00754,"9":0,"10":0,"11":0.12059,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.26226},"and_qq":{"10.4":0},"and_uc":{"0":0.10375},"op_mini":{"0":0.1146},"and_chr":{"0":41.3009}},"total":98.17002}

/***/ },
/* 1349 */
/***/ function(module, exports) {

	module.exports = {"id":"SY","name":"Syrian Arab Republic","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.00219,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00219,"37":0,"38":0.00219,"39":0,"40":0,"41":0,"42":0,"43":0.00219,"44":0,"45":0,"46":0,"47":0.00219,"48":0,"49":0,"50":0.00219,"51":0,"52":0.01752,"53":0,"54":0,"55":0,"56":0.00438,"57":0,"58":0.00219,"59":0.00219,"60":0,"61":0,"62":0.00219,"63":0,"64":0,"65":0,"66":0.00219,"67":0.00219,"68":0.02409,"69":0,"70":0,"71":0,"72":0.00657,"73":0,"74":0.00219,"75":0.00219,"76":0.00219,"77":0.00219,"78":0.00657,"79":0.00438,"80":0.01533,"81":0.37887,"82":0.05694,"83":0.00219,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0.00219,"33":0.00219,"34":0,"35":0,"36":0.00219,"37":0,"38":0.00219,"39":0,"40":0.00657,"41":0,"42":0.00219,"43":0.00876,"44":0,"45":0.00219,"46":0.00219,"47":0.00219,"48":0,"49":0.01095,"50":0,"51":0,"52":0,"53":0.00438,"54":0.00219,"55":0.00438,"56":0.00219,"57":0,"58":0.00438,"59":0,"60":0.00438,"61":0,"62":0.00219,"63":0.00876,"64":0.00219,"65":0.00219,"66":0.00219,"67":0.00219,"68":0.00219,"69":0.00438,"70":0.0876,"71":0.01314,"72":0.00438,"73":0.00657,"74":0.00876,"75":0.01971,"76":0.01095,"77":0.00438,"78":0.01752,"79":0.04161,"80":0.03285,"81":0.04818,"83":0.02847,"84":0.04818,"85":0.84096,"86":1.29429,"87":0.00219,"88":0.00219,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.00219,"51":0.01314,"52":0,"53":0,"54":0,"55":0,"56":0.00219,"57":0,"58":0,"60":0.00219,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0.00219,"70":0.01314,"71":0.10512,"72":0.00438,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00219},"ios_saf":{"8":0,"14":1.43863,"3.2":0.00345,"4.0-4.1":0.00295,"4.2-4.3":0.00049,"5.0-5.1":0.00246,"6.0-6.1":0.00148,"7.0-7.1":0.00345,"8.1-8.4":0.01132,"9.0-9.2":0.0064,"9.3":0.08173,"10.0-10.2":0.01379,"10.3":0.07582,"11.0-11.2":0.02856,"11.3-11.4":0.04874,"12.0-12.1":0.04973,"12.2-12.4":0.49579,"13.0-13.1":0.04086,"13.2":0.02019,"13.3":0.15361,"13.4-13.7":0.81828},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0.00219,"14":0.01095,"3.1":0,"3.2":0,"5.1":1.20888,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0,"12.1":0.00219,"13.1":0.01533},"edge":{"12":0,"13":0,"14":0.00219,"15":0.00219,"16":0.00219,"17":0.00876,"18":0.01752,"79":0,"80":0,"81":0,"83":0,"84":0.00438,"85":0.05694,"86":0.06789},"android":{"3":0,"4":0.11308,"81":null,"2.1":0,"2.2":0,"2.3":0.0009,"4.1":0.05699,"4.2-4.3":0.02533,"4.4":0,"4.4.3-4.4.4":0.20626},"samsung":{"4":1.90333,"5.0-5.4":0.10124,"6.2-6.4":0.19236,"7.2-7.4":0.40496,"8.2":0.10124,"9.2":0.63782,"10.1":0.63782,"11.1-11.2":0.85042,"12.0":4.18124},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00694,"9":0,"10":0,"11":0.03468,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.17963},"and_qq":{"10.4":0},"and_uc":{"0":1.21055},"op_mini":{"0":1.41225},"and_chr":{"0":76.97515}},"total":97.23185}

/***/ },
/* 1350 */
/***/ function(module, exports) {

	module.exports = {"id":"SZ","name":"Swaziland","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.00353,"46":0.00353,"47":0.00353,"48":0,"49":0,"50":0,"51":0,"52":0.00706,"53":0.00353,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0.03179,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0.00353,"67":0,"68":0.02119,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0.00353,"75":0.00353,"76":0,"77":0.00706,"78":0.01413,"79":0.00353,"80":0.04238,"81":0.64989,"82":0.06711,"83":0.0106,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00353,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00353,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.01413,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.00706,"47":0.00353,"48":0,"49":0.03532,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0.00706,"56":0,"57":0,"58":0.00353,"59":0.00353,"60":0,"61":0,"62":0,"63":0.00353,"64":0.00353,"65":0.00353,"66":0.00353,"67":0.00353,"68":0.02119,"69":0.01413,"70":0.03885,"71":0.0106,"72":0.01413,"73":0.00353,"74":0.03179,"75":0.00353,"76":0.00353,"77":0.00706,"78":0.0106,"79":0.00353,"80":0.166,"81":0.15894,"83":0.02472,"84":0.07417,"85":2.44061,"86":3.94171,"87":0.02119,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0.00353,"17":0.00706,"18":0.00353,"19":0.00353,"20":0.00353,"21":0,"22":0,"23":0,"24":0,"25":0.00353,"26":0.01413,"27":0,"28":0.0106,"29":0,"30":0,"31":0,"32":0.00353,"33":0.00706,"34":0,"35":0.01766,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0.00353,"43":0,"44":0,"45":0.00353,"46":0.00706,"47":0.00353,"48":0,"49":0,"50":0.02826,"51":0.31435,"52":0,"53":0.00706,"54":0.00353,"55":0,"56":0,"57":0,"58":0.0106,"60":0.02119,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0.00706,"68":0.00353,"69":0,"70":0.12715,"71":0.53333,"72":0.00706,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.38146},"ios_saf":{"8":0,"14":2.27863,"3.2":0.00546,"4.0-4.1":0.00468,"4.2-4.3":0.00078,"5.0-5.1":0.0039,"6.0-6.1":0.00234,"7.0-7.1":0.00546,"8.1-8.4":0.01794,"9.0-9.2":0.01014,"9.3":0.12945,"10.0-10.2":0.02183,"10.3":0.12009,"11.0-11.2":0.04523,"11.3-11.4":0.0772,"12.0-12.1":0.07876,"12.2-12.4":0.78528,"13.0-13.1":0.06472,"13.2":0.03197,"13.3":0.2433,"13.4-13.7":1.29606},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0.37792,"10":0,"11":0,"12":0.00353,"13":0.0106,"14":0.04592,"3.1":0,"3.2":0,"5.1":0.05298,"6.1":0.00353,"7.1":0,"9.1":0,"10.1":0,"11.1":0.02119,"12.1":0.0106,"13.1":0.0989},"edge":{"12":0.02826,"13":0.0106,"14":0.02826,"15":0.03885,"16":0.01766,"17":0.01766,"18":0.14834,"79":0,"80":0.00353,"81":0,"83":0,"84":0.01413,"85":0.30728,"86":0.59338},"android":{"3":0,"4":0.10146,"81":null,"2.1":0,"2.2":0,"2.3":0.00081,"4.1":0.05114,"4.2-4.3":0.02273,"4.4":0,"4.4.3-4.4.4":0.18506},"samsung":{"4":0.53183,"5.0-5.4":0,"6.2-6.4":0.02045,"7.2-7.4":0.5216,"8.2":0.01023,"9.2":0.14318,"10.1":0.1125,"11.1-11.2":0.2966,"12.0":2.833},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01181,"9":0.01181,"10":0,"11":0.31898,"5.5":0},"bb":{"7":0,"10":0.05174},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.27166},"baidu":{"0":null},"and_ff":{"0":0.23932},"and_qq":{"10.4":0},"and_uc":{"0":1.06722},"op_mini":{"0":15.4618},"and_chr":{"0":53.08322}},"total":91.91254}

/***/ },
/* 1351 */
/***/ function(module, exports) {

	module.exports = {"id":"TC","name":"Turks and Caicos Islands","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.02291,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.05727,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0.01718,"79":0,"80":0,"81":1.4432,"82":0.08018,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.00573,"50":0,"51":0,"52":0,"53":0.18326,"54":0,"55":0,"56":0,"57":0,"58":0.00573,"59":0,"60":0,"61":0,"62":0,"63":0.02291,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.00573,"71":0,"72":0,"73":0,"74":0,"75":0.00573,"76":0.02864,"77":0.08591,"78":0.01145,"79":0.02864,"80":0,"81":0.32071,"83":0.01145,"84":0.09736,"85":6.62041,"86":9.82753,"87":0.01145,"88":0.01145,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.04582,"71":0.10309,"72":0.00573,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":11.97304,"3.2":0.02868,"4.0-4.1":0.02459,"4.2-4.3":0.0041,"5.0-5.1":0.02049,"6.0-6.1":0.01229,"7.0-7.1":0.02868,"8.1-8.4":0.09424,"9.0-9.2":0.05327,"9.3":0.68019,"10.0-10.2":0.11473,"10.3":0.63102,"11.0-11.2":0.23766,"11.3-11.4":0.40566,"12.0-12.1":0.41385,"12.2-12.4":4.12623,"13.0-13.1":0.3401,"13.2":0.168,"13.3":1.27843,"13.4-13.7":6.81012},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.10309,"13":0.09163,"14":1.40312,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.09163,"11.1":0.04009,"12.1":0.10309,"13.1":2.81196},"edge":{"12":0.01145,"13":0.01145,"14":0,"15":0.00573,"16":0.01718,"17":0.07445,"18":0.50398,"79":0,"80":0.01145,"81":0,"83":0,"84":0.01718,"85":1.87273,"86":3.27012},"android":{"3":0,"4":0.51956,"81":null,"2.1":0,"2.2":0,"2.3":0.00416,"4.1":0.26186,"4.2-4.3":0.11638,"4.4":0,"4.4.3-4.4.4":0.94768},"samsung":{"4":0.01068,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.05341,"8.2":0,"9.2":0.08546,"10.1":0,"11.1-11.2":0.05341,"12.0":3.04451},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.28635,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.16665},"and_qq":{"10.4":0},"and_uc":{"0":0.00427},"op_mini":{"0":0.01214},"and_chr":{"0":35.55491}},"total":98.0666}

/***/ },
/* 1352 */
/***/ function(module, exports) {

	module.exports = {"id":"TD","name":"Chad","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0.02047,"4":0.00341,"5":0.03412,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00341,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0.00341,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0.00341,"36":0,"37":0,"38":0,"39":0,"40":0.00682,"41":0,"42":0,"43":0.00682,"44":0,"45":0,"46":0,"47":0.01024,"48":0.00341,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0.00341,"57":0,"58":0,"59":0,"60":0.01024,"61":0.00341,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.03753,"69":0.00341,"70":0,"71":0.00682,"72":0.00682,"73":0,"74":0,"75":0,"76":0.00682,"77":0,"78":0.01024,"79":0.00341,"80":0.06483,"81":1.51152,"82":0.12966,"83":0.00341,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0.00341,"28":0,"29":0.01365,"30":0,"31":0,"32":0,"33":0.00341,"34":0,"35":0,"36":0,"37":0.00341,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00341,"44":0,"45":0,"46":0,"47":0,"48":0.00341,"49":0.0273,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0.00341,"56":0,"57":0.00682,"58":0,"59":0.00341,"60":0.00341,"61":0,"62":0,"63":0.00682,"64":0,"65":0.60734,"66":0,"67":0.02388,"68":0,"69":0.03071,"70":0,"71":0,"72":0,"73":0.00682,"74":0.00682,"75":0.08871,"76":0.52886,"77":0.01365,"78":0.00682,"79":0.05459,"80":0.01706,"81":0.01024,"83":0.3992,"84":0.13648,"85":1.34774,"86":2.1598,"87":0.02047,"88":0,"89":0},"opera":{"9":0,"11":0.00682,"12":0,"15":0,"16":0.00341,"17":0,"18":0,"19":0.00341,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0.01024,"29":0.00341,"30":0.02047,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.01024,"38":0.00341,"39":0,"40":0.00682,"41":0,"42":0.00682,"43":0.00682,"44":0,"45":0.00341,"46":0.01024,"47":0.00341,"48":0,"49":0,"50":0.00682,"51":0.05118,"52":0,"53":0.00341,"54":0,"55":0,"56":0.00682,"57":0,"58":0.00341,"60":0.00341,"62":0,"63":0,"64":0.00682,"65":0.01706,"66":0,"67":0.00682,"68":0.00682,"69":0,"70":0.33096,"71":0.21837,"72":0.00682,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00341},"ios_saf":{"8":0,"14":2.50858,"3.2":0.00601,"4.0-4.1":0.00515,"4.2-4.3":0.00086,"5.0-5.1":0.00429,"6.0-6.1":0.00258,"7.0-7.1":0.00601,"8.1-8.4":0.01975,"9.0-9.2":0.01116,"9.3":0.14251,"10.0-10.2":0.02404,"10.3":0.13221,"11.0-11.2":0.04979,"11.3-11.4":0.08499,"12.0-12.1":0.08671,"12.2-12.4":0.86452,"13.0-13.1":0.07126,"13.2":0.0352,"13.3":0.26786,"13.4-13.7":1.42685},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.10577,"12":0,"13":0.0273,"14":0.0273,"3.1":0,"3.2":0,"5.1":0.05459,"6.1":0.00341,"7.1":0,"9.1":0.00682,"10.1":0.00682,"11.1":0.03071,"12.1":0.13989,"13.1":0.18425},"edge":{"12":0.01365,"13":0.01706,"14":0.01024,"15":0.01024,"16":0.02388,"17":0.01706,"18":0.1433,"79":0,"80":0.00341,"81":0.00341,"83":0,"84":0.01706,"85":0.23202,"86":0.2286},"android":{"3":0,"4":0.87825,"81":null,"2.1":0,"2.2":0,"2.3":0.00703,"4.1":0.44264,"4.2-4.3":0.19673,"4.4":0,"4.4.3-4.4.4":1.60193},"samsung":{"4":0.61431,"5.0-5.4":0.09064,"6.2-6.4":0.07049,"7.2-7.4":0.11078,"8.2":0,"9.2":0.2417,"10.1":0.11078,"11.1-11.2":0.27191,"12.0":0.76537},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.07093,"9":0.00887,"10":0.00887,"11":1.21472,"5.5":0},"bb":{"7":0,"10":0.02635},"ie_mob":{"10":0.01318,"11":0},"kaios":{"2.5":0.04612},"baidu":{"0":null},"and_ff":{"0":0.08564},"and_qq":{"10.4":4.30196},"and_uc":{"0":2.87896},"op_mini":{"0":2.65076},"and_chr":{"0":63.63216}},"total":95.60737}

/***/ },
/* 1353 */
/***/ function(module, exports) {

	module.exports = {"id":"TG","name":"Togo","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0.00627,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0.00627,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.01882,"39":0.00627,"40":0,"41":0.00627,"42":0,"43":0.01254,"44":0.00627,"45":0.01882,"46":0,"47":0.01254,"48":0,"49":0.01254,"50":0.00627,"51":0,"52":0.05645,"53":0,"54":0,"55":0.00627,"56":0.02509,"57":0.00627,"58":0,"59":0.00627,"60":0.00627,"61":0,"62":0,"63":0.00627,"64":0.01254,"65":0.00627,"66":0.01254,"67":0.01882,"68":0.05645,"69":0.01254,"70":0.00627,"71":0.01254,"72":0.07526,"73":0.01254,"74":0.01254,"75":0.01882,"76":0.01254,"77":0.03136,"78":0.2007,"79":0.06899,"80":0.23834,"81":6.26573,"82":1.00352,"83":0.0439,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0.00627,"19":0,"20":0,"21":0,"22":0,"23":0.01254,"24":0,"25":0,"26":0.01882,"27":0,"28":0,"29":0.03763,"30":0,"31":0.01254,"32":0,"33":0.03136,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.01254,"41":0,"42":0,"43":0.03763,"44":0,"45":0,"46":0.00627,"47":0,"48":0.00627,"49":0.10662,"50":0.00627,"51":0,"52":0,"53":0,"54":0,"55":0.00627,"56":0,"57":0.00627,"58":0.01882,"59":0,"60":0,"61":0,"62":0.0439,"63":0.07526,"64":0.00627,"65":0.03763,"66":0.00627,"67":0.00627,"68":0.01254,"69":0.00627,"70":0.01882,"71":0.03763,"72":0.08781,"73":0.05018,"74":0.06272,"75":0.05645,"76":0.0439,"77":0.05645,"78":0.08154,"79":0.48922,"80":0.52685,"81":0.10662,"83":0.19443,"84":0.41395,"85":7.46995,"86":10.64986,"87":0.05018,"88":0.01254,"89":0},"opera":{"9":0,"11":0,"12":0.00627,"15":0,"16":0,"17":0.00627,"18":0.00627,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0.00627,"25":0,"26":0.01254,"27":0.00627,"28":0.01254,"29":0,"30":0.01882,"31":0.00627,"32":0.00627,"33":0.00627,"34":0,"35":0,"36":0,"37":0,"38":0.00627,"39":0,"40":0,"41":0,"42":0.01254,"43":0,"44":0.03136,"45":0,"46":0.01254,"47":0.00627,"48":0,"49":0,"50":0.07526,"51":0.85926,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.0439,"62":0,"63":0,"64":0,"65":0.00627,"66":0.01254,"67":0.01254,"68":0.01254,"69":0,"70":0.44531,"71":2.89766,"72":0.0439,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.03136},"ios_saf":{"8":0,"14":2.16334,"3.2":0.00518,"4.0-4.1":0.00444,"4.2-4.3":0.00074,"5.0-5.1":0.0037,"6.0-6.1":0.00222,"7.0-7.1":0.00518,"8.1-8.4":0.01703,"9.0-9.2":0.00962,"9.3":0.1229,"10.0-10.2":0.02073,"10.3":0.11402,"11.0-11.2":0.04294,"11.3-11.4":0.0733,"12.0-12.1":0.07478,"12.2-12.4":0.74555,"13.0-13.1":0.06145,"13.2":0.03035,"13.3":0.23099,"13.4-13.7":1.23049},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00627,"11":0,"12":0,"13":0.03136,"14":0.29478,"3.1":0,"3.2":0,"5.1":0.55821,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0.07526,"12.1":0.05645,"13.1":0.18816},"edge":{"12":0.02509,"13":0.08154,"14":0.00627,"15":0.03763,"16":0.01254,"17":0.02509,"18":0.29478,"79":0,"80":0,"81":0,"83":0.01254,"84":0.03136,"85":0.87181,"86":1.64326},"android":{"3":0,"4":0.13412,"81":null,"2.1":0,"2.2":0,"2.3":0.00107,"4.1":0.06759,"4.2-4.3":0.03004,"4.4":0,"4.4.3-4.4.4":0.24463},"samsung":{"4":0.06107,"5.0-5.4":0.01018,"6.2-6.4":0.02036,"7.2-7.4":0.01018,"8.2":0.01018,"9.2":0.01018,"10.1":0.07125,"11.1-11.2":0.07125,"12.0":0.64126},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0.01223,"7":0,"8":0.13453,"9":0.02446,"10":0.04892,"11":0.26907,"5.5":0},"bb":{"7":0,"10":0.01118},"ie_mob":{"10":0,"11":0.03355},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.14539},"and_qq":{"10.4":0.01864},"and_uc":{"0":0.8127},"op_mini":{"0":3.62472},"and_chr":{"0":47.15336}},"total":96.76465}

/***/ },
/* 1354 */
/***/ function(module, exports) {

	module.exports = {"id":"TH","name":"Thailand","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0.02033,"16":0,"17":0.00508,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00508,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00508,"49":0,"50":0,"51":0,"52":0.02033,"53":0.00508,"54":0.00508,"55":0.02541,"56":0.08131,"57":0,"58":0.00508,"59":0,"60":0,"61":0,"62":0,"63":0.00508,"64":0.00508,"65":0.00508,"66":0.00508,"67":0,"68":0.01016,"69":0,"70":0,"71":0,"72":0.00508,"73":0,"74":0,"75":0,"76":0,"77":0.00508,"78":0.02541,"79":0.00508,"80":0.01525,"81":0.71656,"82":0.10164,"83":0.00508,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.01016,"39":0,"40":0,"41":0,"42":0,"43":0.01016,"44":0,"45":0,"46":0.00508,"47":0.00508,"48":0.00508,"49":0.10164,"50":0,"51":0.00508,"52":0,"53":0.02033,"54":0.00508,"55":0,"56":0.00508,"57":0.00508,"58":0.01016,"59":0.00508,"60":0.00508,"61":0.01016,"62":0.00508,"63":0.01525,"64":0.00508,"65":0.01016,"66":0.01016,"67":0.01525,"68":0.00508,"69":0.01016,"70":0.04066,"71":0.03557,"72":0.03049,"73":0.03049,"74":0.04574,"75":0.04574,"76":0.03557,"77":0.03049,"78":0.04066,"79":0.04574,"80":0.06607,"81":0.06098,"83":0.1118,"84":0.14738,"85":7.18087,"86":11.16007,"87":0.03557,"88":0.01016,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.02541,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.01016,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.02033,"71":0.16771,"72":0.00508,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":8.03621,"3.2":0.01925,"4.0-4.1":0.0165,"4.2-4.3":0.00275,"5.0-5.1":0.01375,"6.0-6.1":0.00825,"7.0-7.1":0.01925,"8.1-8.4":0.06326,"9.0-9.2":0.03575,"9.3":0.45654,"10.0-10.2":0.07701,"10.3":0.42354,"11.0-11.2":0.15951,"11.3-11.4":0.27227,"12.0-12.1":0.27777,"12.2-12.4":2.76949,"13.0-13.1":0.22827,"13.2":0.11276,"13.3":0.85808,"13.4-13.7":4.5709},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00508,"12":0.02033,"13":0.10164,"14":0.78771,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.01016,"11.1":0.03049,"12.1":0.08639,"13.1":0.77246},"edge":{"12":0,"13":0,"14":0.00508,"15":0.00508,"16":0.00508,"17":0.01016,"18":0.05082,"79":0,"80":0,"81":0.00508,"83":0.00508,"84":0.00508,"85":0.43705,"86":0.80804},"android":{"3":0,"4":0.02114,"81":null,"2.1":0,"2.2":0,"2.3":0.00017,"4.1":0.01065,"4.2-4.3":0.00473,"4.4":0,"4.4.3-4.4.4":0.03855},"samsung":{"4":0.14401,"5.0-5.4":0,"6.2-6.4":0.01029,"7.2-7.4":0.06172,"8.2":0.03086,"9.2":0.12343,"10.1":0.08229,"11.1-11.2":0.16458,"12.0":2.29383},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01601,"9":0.00534,"10":0.00534,"11":0.18676,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.10328},"and_qq":{"10.4":0.00492},"and_uc":{"0":0.21639},"op_mini":{"0":0.26074},"and_chr":{"0":51.9248}},"total":98.03656}

/***/ },
/* 1355 */
/***/ function(module, exports) {

	module.exports = {"id":"TJ","name":"Tajikistan","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0.00569,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00569,"48":0,"49":0,"50":0,"51":0,"52":0.02277,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0.27322,"65":0,"66":0,"67":0.00569,"68":0.01138,"69":0,"70":0,"71":0.01708,"72":0.01138,"73":0,"74":0,"75":0,"76":0,"77":0.00569,"78":0.03415,"79":0.00569,"80":0.07969,"81":0.79688,"82":0.04554,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0.00569,"24":0.00569,"25":0,"26":0,"27":0,"28":0.00569,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0.01138,"36":0,"37":0,"38":0.00569,"39":0,"40":0.01708,"41":0,"42":0,"43":0,"44":0.074,"45":0,"46":0,"47":0.00569,"48":0,"49":0.15938,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0.00569,"56":0,"57":0,"58":0,"59":0.00569,"60":0.00569,"61":0,"62":0.01138,"63":0.06261,"64":0.00569,"65":0,"66":0,"67":0.01138,"68":0.02846,"69":0.03415,"70":0.23906,"71":0.27891,"72":0.27891,"73":0.01708,"74":0.02846,"75":0.01708,"76":0.02277,"77":0.03984,"78":0.06261,"79":0.15938,"80":0.04554,"81":0.074,"83":0.15368,"84":0.23906,"85":5.9026,"86":10.73511,"87":0,"88":0.00569,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0.00569,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0.00569,"27":0,"28":0.00569,"29":0,"30":0,"31":0,"32":0,"33":0.00569,"34":0,"35":0,"36":0.00569,"37":0,"38":0.00569,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.00569,"47":0.00569,"48":0,"49":0,"50":0.01708,"51":0.02846,"52":0,"53":0.0683,"54":0,"55":0,"56":0,"57":0.00569,"58":0,"60":0.02277,"62":0,"63":0.01708,"64":0.00569,"65":0,"66":0,"67":0.01138,"68":0.11384,"69":0,"70":0.29598,"71":2.1345,"72":0.01708,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.03415},"ios_saf":{"8":0,"14":2.48748,"3.2":0.00596,"4.0-4.1":0.00511,"4.2-4.3":0.00085,"5.0-5.1":0.00426,"6.0-6.1":0.00255,"7.0-7.1":0.00596,"8.1-8.4":0.01958,"9.0-9.2":0.01107,"9.3":0.14131,"10.0-10.2":0.02384,"10.3":0.1311,"11.0-11.2":0.04938,"11.3-11.4":0.08428,"12.0-12.1":0.08598,"12.2-12.4":0.85725,"13.0-13.1":0.07066,"13.2":0.0349,"13.3":0.2656,"13.4-13.7":1.41485},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0.01138,"9":0,"10":0,"11":0,"12":0.02846,"13":0.01138,"14":0.18784,"3.1":0,"3.2":0,"5.1":2.85738,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0.13661,"12.1":0.01138,"13.1":0.25045},"edge":{"12":0,"13":0,"14":0.00569,"15":0.05123,"16":0.01708,"17":0.10246,"18":0.07969,"79":0,"80":0,"81":0,"83":0,"84":0.00569,"85":0.17645,"86":0.13661},"android":{"3":0,"4":0.03976,"81":null,"2.1":0,"2.2":0,"2.3":0.00032,"4.1":0.02004,"4.2-4.3":0.00891,"4.4":0,"4.4.3-4.4.4":0.07252},"samsung":{"4":1.1976,"5.0-5.4":0.14209,"6.2-6.4":0.14209,"7.2-7.4":0.27403,"8.2":0.0609,"9.2":0.38567,"10.1":0.26388,"11.1-11.2":0.41612,"12.0":1.16715},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.03936,"9":0.00787,"10":0.00787,"11":0.31488,"5.5":0},"bb":{"7":0,"10":0.00862},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.03016},"and_qq":{"10.4":0.20248},"and_uc":{"0":1.68874},"op_mini":{"0":3.71555},"and_chr":{"0":45.90254}},"total":88.77977}

/***/ },
/* 1356 */
/***/ function(module, exports) {

	module.exports = {"id":"TK","name":"Tokelau","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":null,"3":null,"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":null,"51":null,"52":null,"53":null,"54":null,"55":null,"56":null,"57":null,"58":null,"59":null,"60":null,"61":null,"62":null,"63":null,"64":null,"65":null,"66":null,"67":null,"68":null,"69":null,"70":null,"71":null,"72":null,"73":null,"74":null,"75":null,"76":null,"77":null,"78":null,"79":null,"80":null,"81":3.66738,"82":null,"83":null,"84":null,"3.5":null,"3.6":null},"chrome":{"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":null,"51":null,"52":null,"53":null,"54":null,"55":null,"56":null,"57":1.83695,"58":null,"59":null,"60":null,"61":null,"62":null,"63":null,"64":null,"65":null,"66":null,"67":null,"68":null,"69":null,"70":null,"71":null,"72":null,"73":null,"74":null,"75":null,"76":null,"77":null,"78":null,"79":null,"80":null,"81":7.34128,"83":null,"84":null,"85":11.00866,"86":27.52165,"87":null,"88":null,"89":null},"opera":{"9":null,"11":null,"12":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":null,"51":null,"52":null,"53":null,"54":null,"55":null,"56":null,"57":null,"58":null,"60":null,"62":null,"63":null,"64":null,"65":null,"66":null,"67":null,"68":null,"69":null,"70":null,"71":null,"72":null,"9.5-9.6":null,"10.0-10.1":0,"10.5":null,"10.6":null,"11.1":null,"11.5":null,"11.6":null,"12.1":null},"ios_saf":{"8":0,"14":0,"3.2":0,"4.0-4.1":0,"4.2-4.3":0,"5.0-5.1":0,"6.0-6.1":0,"7.0-7.1":0,"8.1-8.4":0,"9.0-9.2":0,"9.3":0,"10.0-10.2":0,"10.3":0,"11.0-11.2":0,"11.3-11.4":0,"12.0-12.1":0,"12.2-12.4":0,"13.0-13.1":0,"13.2":0,"13.3":0,"13.4-13.7":0},"safari":{"0":null,"4":0,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"3.1":null,"3.2":null,"5.1":null,"6.1":null,"7.1":null,"9.1":null,"10.1":null,"11.1":null,"12.1":null,"13.1":null},"edge":{"12":null,"13":null,"14":null,"15":null,"16":null,"17":0.91847,"18":null,"79":null,"80":null,"81":null,"83":null,"84":null,"85":0.91847,"86":5.50433},"android":{"3":0,"4":0,"81":null,"2.1":0,"2.2":0,"2.3":0,"4.1":0,"4.2-4.3":0,"4.4":0,"4.4.3-4.4.4":0},"samsung":{"4":0.06107,"5.0-5.4":0.01018,"6.2-6.4":0.02036,"7.2-7.4":0.01018,"8.2":0.01018,"9.2":0.91682,"10.1":0.07125,"11.1-11.2":0.91682,"12.0":0.64126},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"5.5":null},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0.03355},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0},"and_qq":{"10.4":0},"and_uc":{"0":0},"op_mini":{"0":0},"and_chr":{"0":39.44917}},"total":100.85803}

/***/ },
/* 1357 */
/***/ function(module, exports) {

	module.exports = {"id":"TL","name":"Timor-Leste","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0.00359,"5":0.00359,"6":0,"7":0,"8":0.00359,"9":0,"10":0,"11":0,"12":0.00718,"13":0,"14":0,"15":0.01436,"16":0,"17":0.01077,"18":0.00359,"19":0.00359,"20":0.00718,"21":0.01436,"22":0,"23":0.00359,"24":0.00359,"25":0.00718,"26":0,"27":0,"28":0,"29":0.00359,"30":0.00359,"31":0.04667,"32":0.00359,"33":0,"34":0.00359,"35":0.02513,"36":0.00359,"37":0.01436,"38":0,"39":0,"40":0.00359,"41":0.03231,"42":0.00718,"43":0.0359,"44":0.01436,"45":0.00359,"46":0.00359,"47":0.05026,"48":0.01436,"49":0.00359,"50":0.00359,"51":0,"52":0.01795,"53":0,"54":0.00359,"55":0.00359,"56":0.01795,"57":0.01077,"58":0.00718,"59":0.00718,"60":0.00718,"61":0.02872,"62":0.00359,"63":0.00359,"64":0,"65":0.00359,"66":0.04308,"67":0.03231,"68":0.02154,"69":0.01436,"70":0.01077,"71":0.01436,"72":0.02154,"73":0.00359,"74":0.00718,"75":0.00359,"76":0.00359,"77":0.02872,"78":0.06103,"79":0.14001,"80":0.15078,"81":1.72679,"82":0.47029,"83":0.07898,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0.00359,"24":0.00359,"25":0.00718,"26":0.00359,"27":0,"28":0,"29":0.00359,"30":0,"31":0.01795,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.01436,"41":0,"42":0.05744,"43":0.04667,"44":0,"45":0,"46":0.00359,"47":0.00359,"48":0,"49":0.05026,"50":0,"51":0.00359,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0.00359,"59":0.00718,"60":0,"61":0,"62":0.00359,"63":0.05026,"64":0.00359,"65":0.01436,"66":0.01436,"67":0.01077,"68":0,"69":0.00359,"70":0.00718,"71":0.01795,"72":0.00359,"73":0.00359,"74":0.03231,"75":0.03949,"76":0.01077,"77":0.00359,"78":0.00718,"79":0.01077,"80":0.02154,"81":0.01795,"83":0.01436,"84":0.16155,"85":2.45556,"86":3.64385,"87":0.01077,"88":0.00359,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0.00718,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.20104,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.01077,"52":0,"53":0,"54":0.02872,"55":0.04667,"56":0,"57":0,"58":0,"60":0.01077,"62":0,"63":0.00718,"64":0,"65":0,"66":0,"67":0,"68":0.00359,"69":0,"70":0.05385,"71":0.13283,"72":0.00359,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.01795},"ios_saf":{"8":0,"14":1.87586,"3.2":0.00449,"4.0-4.1":0.00385,"4.2-4.3":0.00064,"5.0-5.1":0.00321,"6.0-6.1":0.00193,"7.0-7.1":0.00449,"8.1-8.4":0.01477,"9.0-9.2":0.00835,"9.3":0.10657,"10.0-10.2":0.01798,"10.3":0.09886,"11.0-11.2":0.03723,"11.3-11.4":0.06356,"12.0-12.1":0.06484,"12.2-12.4":0.64647,"13.0-13.1":0.05328,"13.2":0.02632,"13.3":0.2003,"13.4-13.7":1.06697},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0.01436,"9":0.00718,"10":0.00359,"11":0.00359,"12":0.00359,"13":0.03949,"14":0.06103,"3.1":0,"3.2":0,"5.1":0.01795,"6.1":0,"7.1":0,"9.1":0.00718,"10.1":0.01077,"11.1":0.00718,"12.1":0.08616,"13.1":0.06821},"edge":{"12":0.0359,"13":0.01436,"14":0.00718,"15":0.01077,"16":0.01436,"17":0.02872,"18":0.13283,"79":0,"80":0,"81":0.00359,"83":0,"84":0.04308,"85":0.22258,"86":0.25848},"android":{"3":0,"4":0.17006,"81":null,"2.1":0,"2.2":0,"2.3":0.00136,"4.1":0.08571,"4.2-4.3":0.03809,"4.4":0,"4.4.3-4.4.4":0.31018},"samsung":{"4":1.49553,"5.0-5.4":0.06063,"6.2-6.4":0.06063,"7.2-7.4":0.33346,"8.2":0.05052,"9.2":0.2021,"10.1":0.27283,"11.1-11.2":0.22231,"12.0":0.46483},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.04242,"9":0,"10":0.00386,"11":0.26606,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.03205},"and_qq":{"10.4":0.01282},"and_uc":{"0":0.66023},"op_mini":{"0":3.04642},"and_chr":{"0":73.47543}},"total":97.33962}

/***/ },
/* 1358 */
/***/ function(module, exports) {

	module.exports = {"id":"TM","name":"Turkmenistan","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0.00299,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0.0015,"42":0,"43":0.0015,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00897,"52":0.0015,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0.0015,"60":0,"61":0.0015,"62":0.0015,"63":0,"64":0.0015,"65":0.0015,"66":0,"67":0,"68":0.00449,"69":0,"70":0.00449,"71":0,"72":0,"73":0.0015,"74":0,"75":0,"76":0,"77":0.0015,"78":0,"79":0,"80":0.0015,"81":0.00598,"82":0.0015,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00299,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0.00299,"21":0,"22":0.0015,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00299,"30":0.00449,"31":0.0015,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.0015,"38":0.00449,"39":0.0015,"40":0.00598,"41":0,"42":0.0015,"43":0,"44":0.0015,"45":0,"46":0,"47":0.0015,"48":0.00449,"49":0.02841,"50":0,"51":0.00299,"52":0.00897,"53":0,"54":0.0015,"55":0.0015,"56":0.0015,"57":0.0015,"58":0.0015,"59":0,"60":0.00299,"61":0.0015,"62":0,"63":0.0015,"64":0.0015,"65":0.01047,"66":0.00299,"67":0.00598,"68":0.0015,"69":0.00299,"70":0.00449,"71":0.00897,"72":0.00449,"73":0.00598,"74":0.00299,"75":0.00449,"76":0.00299,"77":0.00299,"78":0.00748,"79":0.00598,"80":0.01196,"81":0.02542,"83":0.01047,"84":0.02691,"85":0.33937,"86":0.89252,"87":0.0015,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0.02392,"15":0,"16":0,"17":0,"18":0.00598,"19":0,"20":0,"21":0.0015,"22":0.0015,"23":0.0015,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00598,"30":0,"31":0,"32":0,"33":0.00449,"34":0.0015,"35":0,"36":0.00299,"37":0.00299,"38":0,"39":0,"40":0.0015,"41":0,"42":0,"43":0.00299,"44":0,"45":0,"46":0,"47":0.0015,"48":0,"49":0.0015,"50":0,"51":0.00748,"52":0,"53":0.0015,"54":0.00299,"55":0.0015,"56":0,"57":0,"58":0,"60":0.0015,"62":0,"63":0,"64":0.00299,"65":0,"66":0,"67":0.0015,"68":0.00299,"69":0,"70":0.0015,"71":0.00449,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00748},"ios_saf":{"8":0,"14":2.47672,"3.2":0.00593,"4.0-4.1":0.00509,"4.2-4.3":0.00085,"5.0-5.1":0.00424,"6.0-6.1":0.00254,"7.0-7.1":0.00593,"8.1-8.4":0.0195,"9.0-9.2":0.01102,"9.3":0.1407,"10.0-10.2":0.02373,"10.3":0.13053,"11.0-11.2":0.04916,"11.3-11.4":0.08391,"12.0-12.1":0.08561,"12.2-12.4":0.85355,"13.0-13.1":0.07035,"13.2":0.03475,"13.3":0.26446,"13.4-13.7":1.40873},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0.00449,"14":0.0015,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0.0015,"9.1":0,"10.1":0,"11.1":0,"12.1":0.0015,"13.1":0.00299},"edge":{"12":0,"13":0,"14":0,"15":0.00598,"16":0,"17":0,"18":0.00449,"79":0,"80":0,"81":0,"83":0,"84":0,"85":0.0015,"86":0.01346},"android":{"3":0,"4":0.12121,"81":null,"2.1":0,"2.2":0,"2.3":0.00097,"4.1":0.06109,"4.2-4.3":0.02715,"4.4":0,"4.4.3-4.4.4":0.22108},"samsung":{"4":9.57239,"5.0-5.4":0.42589,"6.2-6.4":0.33463,"7.2-7.4":1.33851,"8.2":0.0507,"9.2":1.19655,"10.1":0.49687,"11.1-11.2":1.28781,"12.0":5.47573},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00748,"9":0.00449,"10":0,"11":0.13156,"5.5":0},"bb":{"7":0,"10":0.05954},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.01701},"and_qq":{"10.4":0.01701},"and_uc":{"0":2.41542},"op_mini":{"0":0.32208},"and_chr":{"0":64.94869}},"total":95.86646}

/***/ },
/* 1359 */
/***/ function(module, exports) {

	module.exports = {"id":"TN","name":"Tunisia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00649,"48":0.01947,"49":0,"50":0,"51":0,"52":0.03895,"53":0,"54":0,"55":0,"56":0.00649,"57":0,"58":0,"59":0,"60":0,"61":0.00649,"62":0,"63":0.01947,"64":0.00649,"65":0.00649,"66":0.00649,"67":0,"68":0.01298,"69":0,"70":0,"71":0,"72":0.00649,"73":0,"74":0,"75":0.00649,"76":0.00649,"77":0.00649,"78":0.12982,"79":0.01298,"80":0.04544,"81":1.34364,"82":0.20771,"83":0.01298,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00649,"30":0,"31":0,"32":0.00649,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00649,"39":0,"40":0.00649,"41":0.01298,"42":0,"43":0.01947,"44":0,"45":0,"46":0,"47":0.01298,"48":0.00649,"49":0.47384,"50":0.00649,"51":0,"52":0.00649,"53":0,"54":0,"55":0,"56":0.00649,"57":0,"58":0.02596,"59":0,"60":0.01298,"61":0.05193,"62":0.01298,"63":0.03895,"64":0.00649,"65":0.05193,"66":0.01298,"67":0.08438,"68":0.01298,"69":0.02596,"70":0.10386,"71":0.08438,"72":0.09737,"73":0.03895,"74":0.09087,"75":0.01947,"76":0.05193,"77":0.04544,"78":0.07789,"79":0.13631,"80":0.22719,"81":0.17526,"83":0.2142,"84":0.32455,"85":12.13817,"86":19.7651,"87":0.08438,"88":0.01298,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00649,"48":0,"49":0,"50":0.00649,"51":0.02596,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0.00649,"58":0.00649,"60":0.00649,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00649,"69":0,"70":0.20122,"71":1.85643,"72":0.03246,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":1.71143,"3.2":0.0041,"4.0-4.1":0.00351,"4.2-4.3":0.00059,"5.0-5.1":0.00293,"6.0-6.1":0.00176,"7.0-7.1":0.0041,"8.1-8.4":0.01347,"9.0-9.2":0.00761,"9.3":0.09723,"10.0-10.2":0.0164,"10.3":0.0902,"11.0-11.2":0.03397,"11.3-11.4":0.05798,"12.0-12.1":0.05916,"12.2-12.4":0.58981,"13.0-13.1":0.04861,"13.2":0.02401,"13.3":0.18274,"13.4-13.7":0.97344},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00649,"11":0.01298,"12":0.05193,"13":0.07789,"14":0.17526,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.04544,"11.1":0.05842,"12.1":0.10386,"13.1":0.22069},"edge":{"12":0.00649,"13":0.00649,"14":0.01298,"15":0.00649,"16":0.00649,"17":0.03246,"18":0.07789,"79":0,"80":0,"81":0,"83":0.00649,"84":0.00649,"85":0.40893,"86":0.7919},"android":{"3":0,"4":0.0958,"81":null,"2.1":0,"2.2":0,"2.3":0.00077,"4.1":0.04828,"4.2-4.3":0.02146,"4.4":0,"4.4.3-4.4.4":0.17474},"samsung":{"4":0.13066,"5.0-5.4":0.01005,"6.2-6.4":0.01005,"7.2-7.4":0.08041,"8.2":0.01005,"9.2":0.10051,"10.1":0.07036,"11.1-11.2":0.15076,"12.0":1.42723},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.04939,"9":0.00706,"10":0.00706,"11":0.09878,"5.5":0},"bb":{"7":0,"10":0.00351},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.06316},"and_qq":{"10.4":0},"and_uc":{"0":0.09123},"op_mini":{"0":0.22258},"and_chr":{"0":50.56179}},"total":98.13516}

/***/ },
/* 1360 */
/***/ function(module, exports) {

	module.exports = {"id":"TO","name":"Tonga","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0.00575,"33":0,"34":0.01149,"35":0,"36":0,"37":0,"38":0.00575,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.01149,"48":0,"49":0,"50":0,"51":0,"52":0.64366,"53":0,"54":0,"55":0,"56":0.01724,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.01149,"69":0,"70":0.00575,"71":0,"72":0.00575,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0.0977,"79":0.01149,"80":0.11494,"81":1.12067,"82":0.21264,"83":0.01724,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.02874,"38":0,"39":0,"40":0.01149,"41":0,"42":0,"43":0.00575,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.01149,"50":0.00575,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0.11494,"57":0,"58":0.01149,"59":0,"60":0,"61":0,"62":0,"63":0.06896,"64":0,"65":0.00575,"66":0,"67":0.04598,"68":0.01724,"69":0,"70":0.00575,"71":0,"72":0.01149,"73":0.04598,"74":0.00575,"75":0,"76":0.00575,"77":0.02299,"78":0.01149,"79":0.04023,"80":0.01724,"81":0.11494,"83":0.06322,"84":0.12643,"85":5.41367,"86":8.25269,"87":0.00575,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00575,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.01149,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0.02299,"70":0.05172,"71":0.24712,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":3.03802,"3.2":0.00728,"4.0-4.1":0.00624,"4.2-4.3":0.00104,"5.0-5.1":0.0052,"6.0-6.1":0.00312,"7.0-7.1":0.00728,"8.1-8.4":0.02391,"9.0-9.2":0.01352,"9.3":0.17259,"10.0-10.2":0.02911,"10.3":0.16011,"11.0-11.2":0.0603,"11.3-11.4":0.10293,"12.0-12.1":0.10501,"12.2-12.4":1.04699,"13.0-13.1":0.0863,"13.2":0.04263,"13.3":0.32439,"13.4-13.7":1.72799},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0.04023,"8":0,"9":0,"10":0.00575,"11":0,"12":0.01724,"13":0.14368,"14":0.98848,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.02874,"11.1":0.02299,"12.1":0.02299,"13.1":0.2816},"edge":{"12":0.02874,"13":0.03448,"14":0.08621,"15":0,"16":0.05747,"17":0.12069,"18":2.35052,"79":0,"80":0.00575,"81":0,"83":0,"84":0,"85":0.42528,"86":0.99423},"android":{"3":0,"4":1.66852,"81":null,"2.1":0,"2.2":0,"2.3":0.01335,"4.1":0.84093,"4.2-4.3":0.37375,"4.4":0,"4.4.3-4.4.4":3.04338},"samsung":{"4":0.18305,"5.0-5.4":0.10169,"6.2-6.4":0.12203,"7.2-7.4":0.18305,"8.2":0,"9.2":0.24406,"10.1":0.21355,"11.1-11.2":0.62032,"12.0":1.97282},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":1.93099,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.03402},"and_qq":{"10.4":0.22966},"and_uc":{"0":0.2084},"op_mini":{"0":0.0765},"and_chr":{"0":55.33728}},"total":97.11945}

/***/ },
/* 1361 */
/***/ function(module, exports) {

	module.exports = {"id":"TR","name":"Turkey","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.00218,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0.00218,"64":0.00218,"65":0.00218,"66":0,"67":0,"68":0.02618,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0.00436,"79":0.00218,"80":0.00436,"81":0.09601,"82":0.01309,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0.00218,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.01091,"23":0,"24":0,"25":0,"26":0.00218,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.00436,"35":0,"36":0,"37":0,"38":0.00655,"39":0,"40":0,"41":0,"42":0.00218,"43":0.00218,"44":0,"45":0,"46":0,"47":0.00218,"48":0,"49":0.05019,"50":0,"51":0,"52":0,"53":0.00655,"54":0,"55":0.00218,"56":0.00218,"57":0,"58":0.00218,"59":0.00218,"60":0.00218,"61":0.00436,"62":0.00218,"63":0.00436,"64":0.00218,"65":0.00218,"66":0.00218,"67":0.00218,"68":0.00436,"69":0.00436,"70":0.01309,"71":0.01964,"72":0.01091,"73":0.01091,"74":0.00655,"75":0.01091,"76":0.00873,"77":0.00873,"78":0.01091,"79":0.01746,"80":0.024,"81":0.01964,"83":0.024,"84":0.03928,"85":1.27429,"86":2.16018,"87":0.00218,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0.00218,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.00218,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.00218,"52":0,"53":0,"54":0.00218,"55":0,"56":0,"57":0,"58":0,"60":0.00218,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.01746,"71":0.18329,"72":0.00436,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0.00218,"12.1":0},"ios_saf":{"8":0,"14":5.72176,"3.2":0.01371,"4.0-4.1":0.01175,"4.2-4.3":0.00196,"5.0-5.1":0.00979,"6.0-6.1":0.00587,"7.0-7.1":0.01371,"8.1-8.4":0.04504,"9.0-9.2":0.02546,"9.3":0.32506,"10.0-10.2":0.05483,"10.3":0.30156,"11.0-11.2":0.11357,"11.3-11.4":0.19386,"12.0-12.1":0.19777,"12.2-12.4":1.97187,"13.0-13.1":0.16253,"13.2":0.08028,"13.3":0.61095,"13.4-13.7":3.25447},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.00218,"13":0.01091,"14":0.0611,"3.1":0,"3.2":0,"5.1":0.03491,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00218,"11.1":0.00436,"12.1":0.00873,"13.1":0.05673},"edge":{"12":0,"13":0,"14":0.00218,"15":0,"16":0,"17":0.00218,"18":0.01309,"79":0,"80":0,"81":0,"83":0,"84":0.00218,"85":0.048,"86":0.07855},"android":{"3":0,"4":0.01772,"81":null,"2.1":0,"2.2":0,"2.3":0.00014,"4.1":0.00893,"4.2-4.3":0.00397,"4.4":0,"4.4.3-4.4.4":0.03233},"samsung":{"4":0.64987,"5.0-5.4":0.07108,"6.2-6.4":0.05077,"7.2-7.4":0.30463,"8.2":0.05077,"9.2":0.27417,"10.1":0.19293,"11.1-11.2":0.45694,"12.0":4.89436},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00225,"9":0.00225,"10":0,"11":0.06751,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.19545},"and_qq":{"10.4":0},"and_uc":{"0":0.14854},"op_mini":{"0":0.54032},"and_chr":{"0":72.07205}},"total":97.64326}

/***/ },
/* 1362 */
/***/ function(module, exports) {

	module.exports = {"id":"TT","name":"Trinidad and Tobago","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.02158,"49":0,"50":0,"51":0,"52":0.07552,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0.00539,"64":0,"65":0,"66":0,"67":0,"68":0.01618,"69":0.02158,"70":0,"71":0,"72":0.00539,"73":0,"74":0.02158,"75":0.00539,"76":0,"77":0.01618,"78":0.04315,"79":0.00539,"80":0.04855,"81":1.15432,"82":0.17261,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00539,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.01618,"39":0,"40":0,"41":0,"42":0.00539,"43":0.00539,"44":0,"45":0,"46":0,"47":0.00539,"48":0,"49":0.15103,"50":0,"51":0,"52":0,"53":0.01618,"54":0,"55":0,"56":0,"57":0,"58":0.01079,"59":0,"60":0,"61":0,"62":0.00539,"63":0.00539,"64":0.00539,"65":0.00539,"66":0,"67":0.01618,"68":0.00539,"69":0.0863,"70":0.00539,"71":0.01079,"72":0.03236,"73":0.00539,"74":0.01079,"75":0.02158,"76":0.04855,"77":0.01618,"78":0.01079,"79":0.02697,"80":0.05394,"81":0.0917,"83":0.07012,"84":0.15103,"85":6.94747,"86":11.08467,"87":0.01079,"88":0.00539,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0.00539,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00539,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.00539,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.04855,"71":0.39376,"72":0.02158,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":5.64362,"3.2":0.01352,"4.0-4.1":0.01159,"4.2-4.3":0.00193,"5.0-5.1":0.00966,"6.0-6.1":0.00579,"7.0-7.1":0.01352,"8.1-8.4":0.04442,"9.0-9.2":0.02511,"9.3":0.32062,"10.0-10.2":0.05408,"10.3":0.29744,"11.0-11.2":0.11202,"11.3-11.4":0.19121,"12.0-12.1":0.19507,"12.2-12.4":1.94495,"13.0-13.1":0.16031,"13.2":0.07919,"13.3":0.6026,"13.4-13.7":3.21003},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00539,"12":0.01618,"13":0.12946,"14":0.92777,"3.1":0,"3.2":0,"5.1":0.05933,"6.1":0,"7.1":0,"9.1":0,"10.1":0.01618,"11.1":0.11327,"12.1":0.12406,"13.1":0.93316},"edge":{"12":0,"13":0.00539,"14":0.00539,"15":0.00539,"16":0.01618,"17":0.03236,"18":0.30206,"79":0,"80":0,"81":0,"83":0.00539,"84":0.01079,"85":0.73358,"86":1.56426},"android":{"3":0,"4":0.42396,"81":null,"2.1":0,"2.2":0,"2.3":0.00339,"4.1":0.21367,"4.2-4.3":0.09497,"4.4":0,"4.4.3-4.4.4":0.7733},"samsung":{"4":0.18145,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.24549,"8.2":0,"9.2":0.3202,"10.1":0.06404,"11.1-11.2":0.26683,"12.0":4.65355},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.02862,"9":0.00572,"10":0.00572,"11":0.24042,"5.5":0},"bb":{"7":0,"10":0.00461},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.16121},"and_qq":{"10.4":0.00921},"and_uc":{"0":0.06909},"op_mini":{"0":0.33141},"and_chr":{"0":49.22747}},"total":96.30854}

/***/ },
/* 1363 */
/***/ function(module, exports) {

	module.exports = {"id":"TV","name":"Tuvalu","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.01887,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0,"79":0,"80":0,"81":0.01092,"82":0.00199,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0.01092,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.00794,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0,"79":0,"80":0.00199,"81":0.00298,"83":0.00497,"84":0.04568,"85":0.22343,"86":0.46373,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.02284,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0.00894,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":0.1784,"3.2":0.00043,"4.0-4.1":0.00037,"4.2-4.3":0.00006,"5.0-5.1":0.00031,"6.0-6.1":0.00018,"7.0-7.1":0.00043,"8.1-8.4":0.0014,"9.0-9.2":0.00079,"9.3":0.01013,"10.0-10.2":0.00171,"10.3":0.0094,"11.0-11.2":0.00354,"11.3-11.4":0.00604,"12.0-12.1":0.00617,"12.2-12.4":0.06148,"13.0-13.1":0.00507,"13.2":0.0025,"13.3":0.01905,"13.4-13.7":0.10147},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0.00497,"14":0.00199,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0,"12.1":0,"13.1":0.0278},"edge":{"12":0.00894,"13":0,"14":0,"15":0,"16":0.01986,"17":0.00497,"18":0.02185,"79":0,"80":0,"81":0,"83":0,"84":0,"85":0.02284,"86":0.07646},"android":{"3":0,"4":0.02668,"81":null,"2.1":0,"2.2":0,"2.3":0.00021,"4.1":0.01344,"4.2-4.3":0.00598,"4.4":0,"4.4.3-4.4.4":0.04866},"samsung":{"4":0.01947,"5.0-5.4":0.13627,"6.2-6.4":0,"7.2-7.4":0.04867,"8.2":0,"9.2":0.01947,"10.1":0.30173,"11.1-11.2":0.0584,"12.0":0.01947},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.18915},"and_qq":{"10.4":0},"and_uc":{"0":0.55843},"op_mini":{"0":0.26434},"and_chr":{"0":96.75183}},"total":99.88601}

/***/ },
/* 1364 */
/***/ function(module, exports) {

	module.exports = {"id":"TW","name":"Taiwan","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.0048,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.01919,"53":0,"54":0,"55":0.0048,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.0096,"69":0,"70":0,"71":0,"72":0.0048,"73":0,"74":0,"75":0,"76":0.0048,"77":0.0048,"78":0.01439,"79":0.0096,"80":0.02879,"81":0.56137,"82":0.09116,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.0048,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.0048,"23":0,"24":0,"25":0,"26":0.0048,"27":0,"28":0,"29":0,"30":0.0048,"31":0,"32":0,"33":0,"34":0.01439,"35":0,"36":0,"37":0,"38":0.06717,"39":0.0048,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.01439,"46":0,"47":0.0048,"48":0.0048,"49":0.10556,"50":0.0048,"51":0,"52":0,"53":0.16793,"54":0,"55":0.0096,"56":0.0048,"57":0.0048,"58":0.0096,"59":0.0048,"60":0.0048,"61":0.02399,"62":0.0096,"63":0.0096,"64":0.01919,"65":0.01439,"66":0.0096,"67":0.02399,"68":0.02879,"69":0.01919,"70":0.01439,"71":0.02879,"72":0.01919,"73":0.03838,"74":0.02879,"75":0.02879,"76":0.02399,"77":0.02399,"78":0.02879,"79":0.03838,"80":0.08157,"81":0.11035,"83":0.10556,"84":0.19672,"85":5.92553,"86":9.54802,"87":0.0096,"88":0.0048,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.0048,"37":0.03359,"38":0,"39":0,"40":0.0048,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.0096,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.0048,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.0096,"71":0.05758,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":14.51849,"3.2":0.03478,"4.0-4.1":0.02981,"4.2-4.3":0.00497,"5.0-5.1":0.02484,"6.0-6.1":0.01491,"7.0-7.1":0.03478,"8.1-8.4":0.11428,"9.0-9.2":0.06459,"9.3":0.8248,"10.0-10.2":0.13912,"10.3":0.76518,"11.0-11.2":0.28818,"11.3-11.4":0.4919,"12.0-12.1":0.50184,"12.2-12.4":5.00346,"13.0-13.1":0.4124,"13.2":0.20372,"13.3":1.55023,"13.4-13.7":8.25795},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0.0048,"9":0,"10":0.0048,"11":0.0048,"12":0.01439,"13":0.17273,"14":0.40783,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0.0048,"10.1":0.01919,"11.1":0.02879,"12.1":0.06717,"13.1":1.16112},"edge":{"12":0,"13":0,"14":0.0048,"15":0.0048,"16":0.0048,"17":0.01439,"18":0.07197,"79":0,"80":0,"81":0,"83":0,"84":0.0048,"85":0.30707,"86":0.65253},"android":{"3":0,"4":0.04145,"81":null,"2.1":0,"2.2":0,"2.3":0.00033,"4.1":0.02089,"4.2-4.3":0.00929,"4.4":0,"4.4.3-4.4.4":0.07561},"samsung":{"4":0.46147,"5.0-5.4":0.01073,"6.2-6.4":0.02146,"7.2-7.4":0.05366,"8.2":0.04293,"9.2":0.21464,"10.1":0.12878,"11.1-11.2":0.30049,"12.0":2.51127},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01137,"9":0.00569,"10":0,"11":0.29001,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.08843},"and_qq":{"10.4":0.0104},"and_uc":{"0":0.07283},"op_mini":{"0":0.51219},"and_chr":{"0":38.96409}},"total":97.8269}

/***/ },
/* 1365 */
/***/ function(module, exports) {

	module.exports = {"id":"TZ","name":"Tanzania","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":null,"3":null,"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":0.00352,"18":null,"19":null,"20":null,"21":0.00352,"22":null,"23":0.00705,"24":null,"25":0.00352,"26":null,"27":null,"28":null,"29":0.00705,"30":0.00705,"31":0.00705,"32":0.01057,"33":null,"34":0.00352,"35":null,"36":null,"37":null,"38":0.01057,"39":0.00352,"40":0.01057,"41":0.00352,"42":0.00705,"43":0.04229,"44":0.0141,"45":0.02467,"46":0.00705,"47":0.02819,"48":0.02467,"49":0.02819,"50":null,"51":0.00352,"52":0.02114,"53":null,"54":null,"55":null,"56":0.00705,"57":null,"58":0.00352,"59":0.00705,"60":0.01762,"61":0.00352,"62":0.00352,"63":null,"64":0.00352,"65":null,"66":0.00352,"67":0.00705,"68":0.02819,"69":0.00705,"70":0.01057,"71":0.01057,"72":0.03172,"73":0.00352,"74":0.0141,"75":0.01057,"76":0.00705,"77":0.06696,"78":0.20439,"79":0.03172,"80":0.18325,"81":3.34428,"82":0.49336,"83":0.06343,"84":null,"3.5":null,"3.6":null},"chrome":{"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":0.00705,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":0.00705,"30":null,"31":null,"32":0.00705,"33":0.00705,"34":null,"35":null,"36":null,"37":0.00352,"38":null,"39":null,"40":0.00352,"41":null,"42":0.00352,"43":0.0141,"44":null,"45":null,"46":null,"47":null,"48":null,"49":0.13744,"50":0.03524,"51":null,"52":null,"53":0.00352,"54":null,"55":0.01057,"56":null,"57":null,"58":0.0141,"59":null,"60":0.00352,"61":0.00705,"62":0.0141,"63":0.04934,"64":0.00705,"65":0.03172,"66":0.00705,"67":0.01762,"68":0.01057,"69":0.03172,"70":0.0141,"71":0.01762,"72":0.04581,"73":0.04229,"74":0.16915,"75":0.03524,"76":0.03172,"77":0.02819,"78":0.03172,"79":0.13039,"80":0.1762,"81":0.08458,"83":0.17972,"84":0.39469,"85":8.21092,"86":10.73763,"87":0.03524,"88":0.01762,"89":null},"opera":{"9":null,"11":null,"12":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":0.00352,"32":null,"33":null,"34":null,"35":null,"36":0.00352,"37":null,"38":null,"39":null,"40":null,"41":null,"42":0.00352,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":null,"51":null,"52":null,"53":null,"54":null,"55":null,"56":null,"57":null,"58":null,"60":0.01762,"62":null,"63":0.02114,"64":null,"65":0.00705,"66":null,"67":0.00352,"68":0.01057,"69":0.00705,"70":0.29249,"71":1.57523,"72":0.05638,"9.5-9.6":null,"10.0-10.1":0,"10.5":null,"10.6":null,"11.1":null,"11.5":null,"11.6":null,"12.1":null},"ios_saf":{"8":0,"14":1.96066,"3.2":0.0047,"4.0-4.1":0.00403,"4.2-4.3":0.00067,"5.0-5.1":0.00335,"6.0-6.1":0.00201,"7.0-7.1":0.0047,"8.1-8.4":0.01543,"9.0-9.2":0.00872,"9.3":0.11139,"10.0-10.2":0.01879,"10.3":0.10333,"11.0-11.2":0.03892,"11.3-11.4":0.06643,"12.0-12.1":0.06777,"12.2-12.4":0.67569,"13.0-13.1":0.05569,"13.2":0.02751,"13.3":0.20935,"13.4-13.7":1.1152},"safari":{"0":null,"4":0,"5":null,"6":null,"7":null,"8":null,"9":0.01762,"10":0.0141,"11":0.03876,"12":0.03524,"13":0.18677,"14":0.43345,"3.1":null,"3.2":null,"5.1":null,"6.1":0.00705,"7.1":null,"9.1":0.00705,"10.1":0.03876,"11.1":0.11277,"12.1":0.22201,"13.1":0.71537},"edge":{"12":0.04581,"13":0.02819,"14":0.01057,"15":0.0141,"16":0.05991,"17":0.03172,"18":0.3524,"79":null,"80":null,"81":0.00705,"83":0.00705,"84":0.04229,"85":0.63784,"86":0.90919},"android":{"3":0,"4":0.05457,"81":null,"2.1":0,"2.2":0,"2.3":0.00044,"4.1":0.0275,"4.2-4.3":0.01222,"4.4":0,"4.4.3-4.4.4":0.09954},"samsung":{"4":0.35909,"5.0-5.4":0.03078,"6.2-6.4":0.02052,"7.2-7.4":0.16416,"8.2":0.01026,"9.2":0.29753,"10.1":0.12312,"11.1-11.2":0.35909,"12.0":1.3748},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":null,"7":null,"8":0.06603,"9":null,"10":null,"11":0.24761,"5.5":null},"bb":{"7":0,"10":0.00648},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.31732},"baidu":{"0":null},"and_ff":{"0":0.23961},"and_qq":{"10.4":0.0259},"and_uc":{"0":1.81328},"op_mini":{"0":11.44056},"and_chr":{"0":44.90886}},"total":98.13559}

/***/ },
/* 1366 */
/***/ function(module, exports) {

	module.exports = {"id":"UA","name":"Ukraine","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0.03139,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0.00785,"27":0,"28":0,"29":0,"30":0,"31":0.00785,"32":0.00785,"33":0.00785,"34":0.00785,"35":0,"36":0.00785,"37":0,"38":0.00785,"39":0.00785,"40":0.00785,"41":0.00785,"42":0.00785,"43":0.00785,"44":0.00785,"45":0.02354,"46":0.0157,"47":0.02354,"48":0.02354,"49":0.0157,"50":0.0157,"51":0.0157,"52":0.21974,"53":0.0157,"54":0.0157,"55":0.0157,"56":0.03924,"57":0.03139,"58":0.0157,"59":0.00785,"60":0.06278,"61":0.00785,"62":0.00785,"63":0.0157,"64":0.0157,"65":0.02354,"66":0.02354,"67":0.00785,"68":0.11772,"69":0.00785,"70":0.00785,"71":0.00785,"72":0.03139,"73":0.00785,"74":0.00785,"75":0.0157,"76":0.0157,"77":0.0157,"78":0.12557,"79":0.02354,"80":0.10202,"81":2.10326,"82":0.32962,"83":0.00785,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0.00785,"23":0,"24":0.00785,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0.00785,"32":0,"33":0,"34":0.00785,"35":0,"36":0,"37":0.00785,"38":0,"39":0.00785,"40":0,"41":0.00785,"42":0.00785,"43":0,"44":0,"45":0.00785,"46":0.00785,"47":0.00785,"48":0.0157,"49":0.5886,"50":0.00785,"51":0.02354,"52":0.00785,"53":0.0157,"54":0.00785,"55":0.00785,"56":0.03139,"57":0.0157,"58":0.0157,"59":0.03139,"60":0.02354,"61":0.1962,"62":0.0157,"63":0.03139,"64":0.0157,"65":0.02354,"66":0.02354,"67":0.03139,"68":0.02354,"69":0.05494,"70":0.15696,"71":0.1805,"72":0.16481,"73":0.14911,"74":0.07848,"75":0.05494,"76":0.07848,"77":0.07848,"78":0.09418,"79":0.14126,"80":0.3924,"81":0.1805,"83":0.32962,"84":0.56506,"85":14.85626,"86":22.93186,"87":0.03924,"88":0.03139,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0.00785,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.06278,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00785,"49":0,"50":0,"51":0.00785,"52":0,"53":0.00785,"54":0.00785,"55":0.00785,"56":0.0157,"57":0.00785,"58":0.02354,"60":0.04709,"62":0,"63":0.00785,"64":0.00785,"65":0.00785,"66":0.00785,"67":0.0157,"68":0.05494,"69":0.0157,"70":0.87113,"71":5.91739,"72":0.17266,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.03139},"ios_saf":{"8":0,"14":3.58581,"3.2":0.00859,"4.0-4.1":0.00736,"4.2-4.3":0.00123,"5.0-5.1":0.00614,"6.0-6.1":0.00368,"7.0-7.1":0.00859,"8.1-8.4":0.02823,"9.0-9.2":0.01595,"9.3":0.20371,"10.0-10.2":0.03436,"10.3":0.18899,"11.0-11.2":0.07118,"11.3-11.4":0.12149,"12.0-12.1":0.12395,"12.2-12.4":1.23577,"13.0-13.1":0.10186,"13.2":0.05031,"13.3":0.38288,"13.4-13.7":2.03957},"safari":{"0":null,"4":0.00785,"5":0.00785,"6":0,"7":0,"8":0.00785,"9":0.00785,"10":0.00785,"11":0.00785,"12":0.04709,"13":0.21974,"14":1.02809,"3.1":0,"3.2":0,"5.1":0.67493,"6.1":0,"7.1":0,"9.1":0.00785,"10.1":0.00785,"11.1":0.03924,"12.1":0.14911,"13.1":0.91822},"edge":{"12":0,"13":0.00785,"14":0.0157,"15":0.00785,"16":0.00785,"17":0.0157,"18":0.06278,"79":0,"80":0,"81":0,"83":0,"84":0.00785,"85":0.22759,"86":0.47088},"android":{"3":0,"4":0.03915,"81":null,"2.1":0,"2.2":0,"2.3":0.00031,"4.1":0.01973,"4.2-4.3":0.00877,"4.4":0,"4.4.3-4.4.4":0.07141},"samsung":{"4":0.05237,"5.0-5.4":0.01047,"6.2-6.4":0,"7.2-7.4":0.01047,"8.2":0.01047,"9.2":0.03142,"10.1":0.03142,"11.1-11.2":0.05237,"12.0":0.67039},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.03956,"9":0.01583,"10":0.01583,"11":1.85155,"5.5":0},"bb":{"7":0,"10":0.00215},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.08823},"and_qq":{"10.4":0.01291},"and_uc":{"0":0.25824},"op_mini":{"0":1.07981},"and_chr":{"0":26.05712}},"total":95.44576}

/***/ },
/* 1367 */
/***/ function(module, exports) {

	module.exports = {"id":"UG","name":"Uganda","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0.00416,"14":0,"15":0.00416,"16":0,"17":0.00416,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0.00416,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0.00416,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.00416,"38":0.00416,"39":0.00416,"40":0.00416,"41":0,"42":0,"43":0.00831,"44":0.00416,"45":0.00831,"46":0.00416,"47":0.01247,"48":0.02078,"49":0.00831,"50":0.00831,"51":0,"52":0.07479,"53":0.00416,"54":0,"55":0.00831,"56":0.00831,"57":0.01662,"58":0.00831,"59":0.00416,"60":0.00416,"61":0,"62":0,"63":0.00416,"64":0.00416,"65":0.00831,"66":0.00831,"67":0,"68":0.04571,"69":0.00416,"70":0.00831,"71":0.00831,"72":0.04571,"73":0.00416,"74":0.00416,"75":0.00416,"76":0.00831,"77":0.00831,"78":0.07479,"79":0.02078,"80":0.09972,"81":2.05673,"82":0.49029,"83":0.08726,"84":0.00416,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0.00416,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0.00831,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00831,"39":0,"40":0.00416,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00831,"48":0,"49":0.03324,"50":0.00831,"51":0,"52":0,"53":0.00416,"54":0,"55":0.00416,"56":0.00416,"57":0.00416,"58":0.00416,"59":0.00416,"60":0.00416,"61":0,"62":0.00416,"63":0.02493,"64":0.03324,"65":0.01247,"66":0.00416,"67":0.00416,"68":0.00416,"69":0.00831,"70":0.01247,"71":0.01662,"72":0.01662,"73":0.00831,"74":0.03324,"75":0.00831,"76":0.02909,"77":0.01247,"78":0.03324,"79":0.09972,"80":0.12881,"81":0.05402,"83":0.06233,"84":0.24099,"85":3.58577,"86":5.42228,"87":0.01662,"88":0.00831,"89":0},"opera":{"9":0,"11":0,"12":0.00831,"15":0,"16":0.00831,"17":0,"18":0,"19":0,"20":0.00416,"21":0,"22":0,"23":0.00831,"24":0.02493,"25":0,"26":0.01247,"27":0.01247,"28":0.02078,"29":0,"30":0.06233,"31":0.00416,"32":0.02909,"33":0.01662,"34":0,"35":0.00416,"36":0,"37":0.00416,"38":0.02909,"39":0,"40":0,"41":0,"42":0.02493,"43":0,"44":0.00416,"45":0.02909,"46":0.11634,"47":0.12465,"48":0,"49":0,"50":0.39888,"51":1.15094,"52":0,"53":0.00831,"54":0.00416,"55":0,"56":0.01247,"57":0.01247,"58":0,"60":0.02909,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00416,"69":0.00416,"70":0.11634,"71":0.67727,"72":0.02078,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.06233},"ios_saf":{"8":0,"14":2.0574,"3.2":0.00493,"4.0-4.1":0.00422,"4.2-4.3":0.0007,"5.0-5.1":0.00352,"6.0-6.1":0.00211,"7.0-7.1":0.00493,"8.1-8.4":0.01619,"9.0-9.2":0.00915,"9.3":0.11688,"10.0-10.2":0.01972,"10.3":0.10843,"11.0-11.2":0.04084,"11.3-11.4":0.06971,"12.0-12.1":0.07111,"12.2-12.4":0.70904,"13.0-13.1":0.05844,"13.2":0.02887,"13.3":0.21968,"13.4-13.7":1.17023},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0.01247,"10":0.00416,"11":0.0374,"12":0.02909,"13":0.05402,"14":0.17451,"3.1":0,"3.2":0,"5.1":0.02078,"6.1":0,"7.1":0,"9.1":0.00831,"10.1":0.00416,"11.1":0.01247,"12.1":0.05402,"13.1":0.17867},"edge":{"12":0.02078,"13":0.00831,"14":0.01247,"15":0.01247,"16":0.18698,"17":0.01247,"18":0.13712,"79":0,"80":0,"81":0.00416,"83":0.00416,"84":0.02493,"85":0.24099,"86":0.3698},"android":{"3":0,"4":0.08332,"81":null,"2.1":0,"2.2":0,"2.3":0.00067,"4.1":0.04199,"4.2-4.3":0.01866,"4.4":0,"4.4.3-4.4.4":0.15198},"samsung":{"4":0.19254,"5.0-5.4":0.05067,"6.2-6.4":0.01013,"7.2-7.4":0.07093,"8.2":0.01013,"9.2":0.17227,"10.1":0.1216,"11.1-11.2":0.20267,"12.0":1.02348},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.03823,"9":0.00765,"10":0.00765,"11":0.13761,"5.5":0},"bb":{"7":0,"10":0.02923},"ie_mob":{"10":0,"11":0.01169},"kaios":{"2.5":0.1812},"baidu":{"0":null},"and_ff":{"0":0.15782},"and_qq":{"10.4":0.01754},"and_uc":{"0":1.01703},"op_mini":{"0":15.4334},"and_chr":{"0":51.23491}},"total":93.04545}

/***/ },
/* 1368 */
/***/ function(module, exports) {

	module.exports = {"id":"US","name":"United States","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0.01629,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00543,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.01629,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00543,"44":0.01086,"45":0.00543,"46":0,"47":0.00543,"48":0.01086,"49":0,"50":0,"51":0,"52":0.03258,"53":0,"54":0.00543,"55":0,"56":0.00543,"57":0,"58":0,"59":0.00543,"60":0.00543,"61":0,"62":0,"63":0.01086,"64":0.00543,"65":0.00543,"66":0.00543,"67":0.00543,"68":0.03801,"69":0,"70":0.00543,"71":0.00543,"72":0.01086,"73":0.00543,"74":0.00543,"75":0.00543,"76":0.00543,"77":0.01086,"78":0.09231,"79":0.01629,"80":0.08145,"81":1.33578,"82":0.2172,"83":0.00543,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00543,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0.00543,"36":0,"37":0,"38":0.00543,"39":0,"40":0.01629,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.00543,"47":0.00543,"48":0.02715,"49":0.11946,"50":0,"51":0.00543,"52":0.00543,"53":0.00543,"54":0.00543,"55":0.00543,"56":0.0543,"57":0.00543,"58":0.00543,"59":0.00543,"60":0.00543,"61":0.01629,"62":0.00543,"63":0.02172,"64":0.01629,"65":0.01629,"66":0.02715,"67":0.02715,"68":0.00543,"69":0.02715,"70":0.0543,"71":0.04887,"72":0.05973,"73":0.03258,"74":0.03258,"75":0.07602,"76":0.13032,"77":0.0543,"78":0.09774,"79":0.17376,"80":0.13575,"81":0.11946,"83":0.34752,"84":0.52128,"85":6.41826,"86":7.74318,"87":0.01629,"88":0.02172,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.01086,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0.00543,"60":0.00543,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.03258,"71":0.19548,"72":0.00543,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":18.05066,"3.2":0.04324,"4.0-4.1":0.03707,"4.2-4.3":0.00618,"5.0-5.1":0.03089,"6.0-6.1":0.01853,"7.0-7.1":0.04324,"8.1-8.4":0.14208,"9.0-9.2":0.08031,"9.3":1.02547,"10.0-10.2":0.17297,"10.3":0.95134,"11.0-11.2":0.3583,"11.3-11.4":0.61157,"12.0-12.1":0.62393,"12.2-12.4":6.22074,"13.0-13.1":0.51273,"13.2":0.25328,"13.3":1.92738,"13.4-13.7":10.26701},"safari":{"0":null,"4":0.00543,"5":0,"6":0,"7":0,"8":0.00543,"9":0.00543,"10":0.00543,"11":0.01086,"12":0.02715,"13":0.19005,"14":1.53669,"3.1":0,"3.2":0,"5.1":0.00543,"6.1":0,"7.1":0,"9.1":0.08145,"10.1":0.04344,"11.1":0.1086,"12.1":0.1629,"13.1":2.5521},"edge":{"12":0.00543,"13":0,"14":0.00543,"15":0.00543,"16":0.01086,"17":0.03258,"18":0.22263,"79":0,"80":0.01629,"81":0.00543,"83":0.00543,"84":0.01086,"85":0.97197,"86":1.68873},"android":{"3":0,"4":0.16118,"81":null,"2.1":0,"2.2":0,"2.3":0.00129,"4.1":0.08124,"4.2-4.3":0.0361,"4.4":0,"4.4.3-4.4.4":0.294},"samsung":{"4":0.04233,"5.0-5.4":0.01058,"6.2-6.4":0,"7.2-7.4":0.01058,"8.2":0.01058,"9.2":0.05292,"10.1":0.02117,"11.1-11.2":0.08467,"12.0":1.97905},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0.00574,"8":0.03441,"9":0.50473,"10":0.01147,"11":0.76857,"5.5":0},"bb":{"7":0,"10":0.00457},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.00457},"baidu":{"0":null},"and_ff":{"0":0.37474},"and_qq":{"10.4":0.01371},"and_uc":{"0":0.10968},"op_mini":{"0":0.15576},"and_chr":{"0":25.36501}},"total":98.03569}

/***/ },
/* 1369 */
/***/ function(module, exports) {

	module.exports = {"id":"UY","name":"Uruguay","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00586,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.01758,"46":0,"47":0,"48":0.00586,"49":0.00586,"50":0.00586,"51":0.00586,"52":0.09376,"53":0,"54":0.00586,"55":0,"56":0.00586,"57":0.01172,"58":0,"59":0,"60":0.00586,"61":0.00586,"62":0.00586,"63":0,"64":0,"65":0,"66":0.03516,"67":0,"68":0.03516,"69":0,"70":0,"71":0,"72":0.01172,"73":0.02344,"74":0,"75":0.00586,"76":0.00586,"77":0.00586,"78":0.06446,"79":0.02344,"80":0.0586,"81":1.51774,"82":0.24026,"83":0.00586,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00586,"44":0,"45":0,"46":0.00586,"47":0,"48":0.00586,"49":0.1465,"50":0,"51":0,"52":0.00586,"53":0.01758,"54":0,"55":0.00586,"56":0.00586,"57":0,"58":0.00586,"59":0.00586,"60":0,"61":0,"62":0.0293,"63":0.01758,"64":0.00586,"65":0.01172,"66":0.01172,"67":0.01172,"68":0.01172,"69":0.01172,"70":0.0293,"71":0.03516,"72":0.01758,"73":0.01758,"74":0.03516,"75":0.01758,"76":0.03516,"77":0.05274,"78":0.04102,"79":0.06446,"80":0.2344,"81":0.08204,"83":0.92002,"84":0.25198,"85":10.44252,"86":15.23014,"87":0.01172,"88":0.00586,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00586,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.06446,"71":0.72078,"72":0.01172,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":4.73148,"3.2":0.01133,"4.0-4.1":0.00972,"4.2-4.3":0.00162,"5.0-5.1":0.0081,"6.0-6.1":0.00486,"7.0-7.1":0.01133,"8.1-8.4":0.03724,"9.0-9.2":0.02105,"9.3":0.2688,"10.0-10.2":0.04534,"10.3":0.24937,"11.0-11.2":0.09392,"11.3-11.4":0.16031,"12.0-12.1":0.16355,"12.2-12.4":1.6306,"13.0-13.1":0.1344,"13.2":0.06639,"13.3":0.50521,"13.4-13.7":2.69121},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00586,"11":0,"12":0.02344,"13":0.07618,"14":0.42778,"3.1":0,"3.2":0,"5.1":0.46294,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0.03516,"12.1":0.0879,"13.1":0.53326},"edge":{"12":0,"13":0,"14":0.00586,"15":0.00586,"16":0.00586,"17":0.00586,"18":0.07032,"79":0,"80":0,"81":0,"83":0,"84":0.00586,"85":0.3223,"86":0.59186},"android":{"3":0,"4":0.09851,"81":null,"2.1":0,"2.2":0,"2.3":0.00079,"4.1":0.04965,"4.2-4.3":0.02207,"4.4":0,"4.4.3-4.4.4":0.17968},"samsung":{"4":0.07106,"5.0-5.4":0,"6.2-6.4":0.01015,"7.2-7.4":0.12181,"8.2":0.01015,"9.2":0.10151,"10.1":0.0609,"11.1-11.2":0.14211,"12.0":1.90835},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00586,"9":0,"10":0,"11":0.19338,"5.5":0},"bb":{"7":0,"10":0.00414},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.1863},"and_qq":{"10.4":0},"and_uc":{"0":0.0207},"op_mini":{"0":0.09407},"and_chr":{"0":50.60286}},"total":98.2608}

/***/ },
/* 1370 */
/***/ function(module, exports) {

	module.exports = {"id":"UZ","name":"Uzbekistan","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0.00605,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00605,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0.00605,"45":0.00605,"46":0.00605,"47":0.00605,"48":0.00605,"49":0.00605,"50":0.00605,"51":0.00605,"52":0.04236,"53":0,"54":0.00605,"55":0.00605,"56":0.00605,"57":0,"58":0.00605,"59":0.00605,"60":0.00605,"61":0,"62":0,"63":0,"64":0.00605,"65":0.01816,"66":0.00605,"67":0,"68":0.03026,"69":0,"70":0,"71":0,"72":0.03026,"73":0,"74":0.0121,"75":0,"76":0.00605,"77":0.00605,"78":0.05447,"79":0.26024,"80":0.01816,"81":0.95016,"82":0.14525,"83":0.00605,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0.08473,"33":0,"34":0,"35":0.00605,"36":0,"37":0,"38":0,"39":0.00605,"40":0.00605,"41":0.00605,"42":0,"43":0,"44":0,"45":0,"46":0.00605,"47":0.00605,"48":0.01816,"49":0.16946,"50":0,"51":0.00605,"52":0,"53":0.00605,"54":0,"55":0.00605,"56":0.01816,"57":0.00605,"58":0.0121,"59":0.00605,"60":0.0121,"61":0.0121,"62":0.0121,"63":0.01816,"64":0.00605,"65":0.00605,"66":0.00605,"67":0.01816,"68":0.01816,"69":0.00605,"70":0.07868,"71":0.08473,"72":0.04842,"73":0.02421,"74":0.02421,"75":0.0121,"76":0.01816,"77":0.02421,"78":0.04236,"79":0.10894,"80":0.15735,"81":0.1513,"83":0.16946,"84":0.22392,"85":8.79961,"86":15.68073,"87":0.03026,"88":0.01816,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.0121,"37":0.00605,"38":0.01816,"39":0,"40":0,"41":0,"42":0.00605,"43":0,"44":0,"45":0.03026,"46":0,"47":0.00605,"48":0.00605,"49":0.0121,"50":0.00605,"51":0.03631,"52":0.02421,"53":0.08473,"54":0.01816,"55":0.04236,"56":0.04236,"57":0.10288,"58":0.0121,"60":0.06052,"62":0.08473,"63":0.04842,"64":0.06052,"65":0.04236,"66":0.06052,"67":0.05447,"68":0.09078,"69":0.03631,"70":0.07868,"71":0.16946,"72":0.00605,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.0121},"ios_saf":{"8":0,"14":2.08779,"3.2":0.005,"4.0-4.1":0.00429,"4.2-4.3":0.00071,"5.0-5.1":0.00357,"6.0-6.1":0.00214,"7.0-7.1":0.005,"8.1-8.4":0.01643,"9.0-9.2":0.00929,"9.3":0.11861,"10.0-10.2":0.02001,"10.3":0.11003,"11.0-11.2":0.04144,"11.3-11.4":0.07074,"12.0-12.1":0.07217,"12.2-12.4":0.71951,"13.0-13.1":0.0593,"13.2":0.02929,"13.3":0.22293,"13.4-13.7":1.18751},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.03026,"12":0.00605,"13":0.03026,"14":0.19972,"3.1":0,"3.2":0,"5.1":1.5009,"6.1":0,"7.1":0,"9.1":0.00605,"10.1":0.00605,"11.1":0.0121,"12.1":0.05447,"13.1":0.19972},"edge":{"12":0,"13":0,"14":0.00605,"15":0.02421,"16":0.00605,"17":0.01816,"18":0.10288,"79":0,"80":0.00605,"81":0,"83":0,"84":0.00605,"85":0.1392,"86":0.26024},"android":{"3":0,"4":0.05322,"81":null,"2.1":0,"2.2":0,"2.3":0.00043,"4.1":0.02683,"4.2-4.3":0.01192,"4.4":0,"4.4.3-4.4.4":0.09708},"samsung":{"4":0.98263,"5.0-5.4":0.11143,"6.2-6.4":0.2026,"7.2-7.4":0.35456,"8.2":0.05065,"9.2":0.35456,"10.1":0.14182,"11.1-11.2":0.42547,"12.0":1.82344},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.02324,"9":0.02324,"10":0.02324,"11":0.22078,"5.5":0},"bb":{"7":0,"10":0.00395},"ie_mob":{"10":0,"11":0.01184},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.05132},"and_qq":{"10.4":0.01579},"and_uc":{"0":3.28079},"op_mini":{"0":0.26164},"and_chr":{"0":44.97687}},"total":90.06989}

/***/ },
/* 1371 */
/***/ function(module, exports) {

	module.exports = {"id":"VA","name":"Holy See (Vatican City State)","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0.01944,"56":0,"57":0,"58":0,"59":0,"60":0.00972,"61":0,"62":0.00972,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.01944,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0.01944,"77":0,"78":0.16527,"79":0.04861,"80":0.0875,"81":12.83304,"82":1.83746,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.03889,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0.00972,"67":0.45693,"68":0,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0.01944,"76":0,"77":0.09722,"78":0,"79":0,"80":0.01944,"81":0.02917,"83":0,"84":0.93331,"85":21.02869,"86":36.27278,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.15555,"71":0.37916,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":1.76716,"3.2":0.00423,"4.0-4.1":0.00363,"4.2-4.3":0.0006,"5.0-5.1":0.00302,"6.0-6.1":0.00181,"7.0-7.1":0.00423,"8.1-8.4":0.01391,"9.0-9.2":0.00786,"9.3":0.10039,"10.0-10.2":0.01693,"10.3":0.09314,"11.0-11.2":0.03508,"11.3-11.4":0.05987,"12.0-12.1":0.06108,"12.2-12.4":0.60901,"13.0-13.1":0.0502,"13.2":0.0248,"13.3":0.18869,"13.4-13.7":1.00514},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.00972,"13":0.00972,"14":1.22497,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.26249,"11.1":0.26249,"12.1":0.49582,"13.1":1.31247},"edge":{"12":0,"13":0,"14":0,"15":0.03889,"16":0.04861,"17":0.11666,"18":1.06942,"79":0,"80":0,"81":0,"83":0,"84":0,"85":2.16801,"86":4.57906},"android":{"3":0,"4":0.0039,"81":null,"2.1":0,"2.2":0,"2.3":0.00003,"4.1":0.00197,"4.2-4.3":0.00087,"4.4":0,"4.4.3-4.4.4":0.00712},"samsung":{"4":0,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0,"8.2":0,"9.2":0,"10.1":0,"11.1-11.2":0,"12.0":0.16958},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":6.92206,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.03225},"and_qq":{"10.4":0},"and_uc":{"0":0},"op_mini":{"0":0},"and_chr":{"0":2.42756}},"total":99.70439}

/***/ },
/* 1372 */
/***/ function(module, exports) {

	module.exports = {"id":"VC","name":"Saint Vincent and the Grenadines","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0.0233,"31":0.01165,"32":0.03496,"33":0.04078,"34":0.02913,"35":0.00583,"36":0.0233,"37":0,"38":0.05243,"39":0.01748,"40":0.0233,"41":0.0233,"42":0.06409,"43":0.02913,"44":0.01748,"45":0.01165,"46":0.0233,"47":0.03496,"48":0.03496,"49":0.02913,"50":0.01748,"51":0.04661,"52":0.0233,"53":0.05243,"54":0.01165,"55":0.01748,"56":0.04661,"57":0.06409,"58":0.02913,"59":0.0233,"60":0.0233,"61":0,"62":0.04078,"63":0.00583,"64":0.00583,"65":0.01165,"66":0.00583,"67":0.00583,"68":0.02913,"69":0,"70":0.00583,"71":0.01165,"72":0.01165,"73":0,"74":0.01165,"75":0,"76":0,"77":0.01165,"78":0.03496,"79":0.01748,"80":0.08156,"81":1.42154,"82":0.12817,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0.03496,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0.01165,"21":0.00583,"22":0.00583,"23":0.01165,"24":0,"25":0,"26":0.00583,"27":0,"28":0,"29":0,"30":0,"31":0.00583,"32":0.01748,"33":0,"34":0.01165,"35":0,"36":0.01165,"37":0.00583,"38":0,"39":0.01165,"40":0.01165,"41":0.05243,"42":0.00583,"43":0,"44":0.01165,"45":0.0233,"46":0.04661,"47":0.05826,"48":0.01165,"49":0.66416,"50":0,"51":0.02913,"52":0.01748,"53":0.01748,"54":0.00583,"55":0.01748,"56":0.0233,"57":0.03496,"58":0.06409,"59":0.0233,"60":0.05243,"61":0.04661,"62":0.07574,"63":0.07574,"64":0.03496,"65":0.0233,"66":0.06991,"67":0.05243,"68":0.02913,"69":0.02913,"70":0.06991,"71":0.01748,"72":0.02913,"73":0.01165,"74":0.04661,"75":0.85642,"76":0.06409,"77":0.04078,"78":0.06991,"79":0.09322,"80":0.11652,"81":0.05243,"83":0.05826,"84":0.80399,"85":7.02616,"86":9.51386,"87":0.00583,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0.01165,"17":0,"18":0,"19":0.01165,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0.00583,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.134,"71":1.17685,"72":0.00583,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00583},"ios_saf":{"8":0,"14":3.44828,"3.2":0.00826,"4.0-4.1":0.00708,"4.2-4.3":0.00118,"5.0-5.1":0.0059,"6.0-6.1":0.00354,"7.0-7.1":0.00826,"8.1-8.4":0.02714,"9.0-9.2":0.01534,"9.3":0.1959,"10.0-10.2":0.03304,"10.3":0.18174,"11.0-11.2":0.06845,"11.3-11.4":0.11683,"12.0-12.1":0.11919,"12.2-12.4":1.18837,"13.0-13.1":0.09795,"13.2":0.04838,"13.3":0.36819,"13.4-13.7":1.96134},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.01748,"11":0.01748,"12":0.01165,"13":0.16895,"14":1.52059,"3.1":0,"3.2":0,"5.1":0.06991,"6.1":0.00583,"7.1":0,"9.1":0,"10.1":0.03496,"11.1":0.04078,"12.1":0.01165,"13.1":0.65251},"edge":{"12":0,"13":0.0233,"14":0.05826,"15":0.04078,"16":0,"17":0.06991,"18":0.14565,"79":0,"80":0,"81":0,"83":0,"84":0.01748,"85":0.78651,"86":1.62545},"android":{"3":0,"4":0.31751,"81":null,"2.1":0,"2.2":0,"2.3":0.00254,"4.1":0.16002,"4.2-4.3":0.07112,"4.4":0,"4.4.3-4.4.4":0.57914},"samsung":{"4":0.1607,"5.0-5.4":0,"6.2-6.4":0.02143,"7.2-7.4":0.10713,"8.2":0,"9.2":0.03214,"10.1":0.07499,"11.1-11.2":0.08571,"12.0":2.08909},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0.00583,"11":0.25052,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.096},"and_qq":{"10.4":0},"and_uc":{"0":0.05009},"op_mini":{"0":0.07113},"and_chr":{"0":55.70145}},"total":97.80229}

/***/ },
/* 1373 */
/***/ function(module, exports) {

	module.exports = {"id":"VE","name":"Venezuela","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0.01482,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0.00741,"24":0,"25":0,"26":0,"27":0.03704,"28":0.00741,"29":0.00741,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.00741,"41":0,"42":0,"43":0.00741,"44":0.00741,"45":0.01482,"46":0,"47":0.01482,"48":0.02963,"49":0.00741,"50":0.00741,"51":0,"52":0.3704,"53":0,"54":0,"55":0.00741,"56":0.00741,"57":0.00741,"58":0.00741,"59":0.00741,"60":0.02222,"61":0.01482,"62":0.01482,"63":0.00741,"64":0.01482,"65":0.03704,"66":0.02963,"67":0.00741,"68":0.07408,"69":0.01482,"70":0.01482,"71":0.02222,"72":0.03704,"73":0.00741,"74":0.00741,"75":0.00741,"76":0.00741,"77":0.01482,"78":0.1852,"79":0.02963,"80":0.10371,"81":2.81504,"82":0.43707,"83":0.01482,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0.00741,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.00741,"38":0,"39":0.00741,"40":0,"41":0,"42":0.02222,"43":0.00741,"44":0,"45":0.00741,"46":0.00741,"47":0.00741,"48":0.00741,"49":0.66672,"50":0.00741,"51":0.00741,"52":0.00741,"53":0.01482,"54":0,"55":0.00741,"56":0.00741,"57":0.00741,"58":0.02963,"59":0.00741,"60":0.00741,"61":0.00741,"62":0.00741,"63":0.04445,"64":0.01482,"65":0.04445,"66":0.01482,"67":0.05186,"68":0.04445,"69":0.10371,"70":0.07408,"71":0.14075,"72":0.0889,"73":0.07408,"74":0.10371,"75":0.11853,"76":0.11112,"77":0.10371,"78":0.10371,"79":0.17779,"80":0.49634,"81":0.24446,"83":0.34818,"84":0.71117,"85":13.68998,"86":23.63152,"87":0.02963,"88":0.01482,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00741,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0.01482,"52":0,"53":0,"54":0,"55":0,"56":0.00741,"57":0.00741,"58":0.00741,"60":0.01482,"62":0,"63":0.00741,"64":0,"65":0,"66":0,"67":0,"68":0.00741,"69":0,"70":0.19261,"71":1.7631,"72":0.03704,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":1.64323,"3.2":0.00394,"4.0-4.1":0.00337,"4.2-4.3":0.00056,"5.0-5.1":0.00281,"6.0-6.1":0.00169,"7.0-7.1":0.00394,"8.1-8.4":0.01293,"9.0-9.2":0.00731,"9.3":0.09335,"10.0-10.2":0.01575,"10.3":0.0866,"11.0-11.2":0.03262,"11.3-11.4":0.05567,"12.0-12.1":0.0568,"12.2-12.4":0.5663,"13.0-13.1":0.04668,"13.2":0.02306,"13.3":0.17546,"13.4-13.7":0.93465},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0.00741,"10":0,"11":0.00741,"12":0.02222,"13":0.05926,"14":0.2815,"3.1":0,"3.2":0,"5.1":0.51115,"6.1":0,"7.1":0,"9.1":0.00741,"10.1":0.00741,"11.1":0.07408,"12.1":0.0889,"13.1":0.39262},"edge":{"12":0.00741,"13":0.00741,"14":0.00741,"15":0.00741,"16":0.00741,"17":0.01482,"18":0.04445,"79":0,"80":0,"81":0,"83":0.00741,"84":0.01482,"85":0.42226,"86":0.90378},"android":{"3":0,"4":0.21703,"81":null,"2.1":0,"2.2":0,"2.3":0.00174,"4.1":0.10938,"4.2-4.3":0.04862,"4.4":0,"4.4.3-4.4.4":0.39587},"samsung":{"4":0.07208,"5.0-5.4":0.0103,"6.2-6.4":0.0103,"7.2-7.4":0.05149,"8.2":0.0103,"9.2":0.05149,"10.1":0.03089,"11.1-11.2":0.06178,"12.0":0.83408},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.1147,"9":0.02294,"10":0,"11":0.33647,"5.5":0},"bb":{"7":0,"10":0.04925},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.13219},"and_qq":{"10.4":0.00778},"and_uc":{"0":0.04406},"op_mini":{"0":0.4368},"and_chr":{"0":40.55314}},"total":98.30696}

/***/ },
/* 1374 */
/***/ function(module, exports) {

	module.exports = {"id":"VG","name":"Virgin Islands, British","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":null,"3":null,"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":0.1084,"51":null,"52":null,"53":null,"54":null,"55":null,"56":0.01712,"57":null,"58":null,"59":null,"60":null,"61":null,"62":null,"63":null,"64":null,"65":null,"66":null,"67":null,"68":null,"69":null,"70":null,"71":null,"72":0.13692,"73":null,"74":null,"75":null,"76":null,"77":null,"78":0.00571,"79":null,"80":0.43929,"81":1.91118,"82":0.07987,"83":null,"84":null,"3.5":null,"3.6":null},"chrome":{"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":0.00571,"51":null,"52":null,"53":null,"54":null,"55":null,"56":null,"57":null,"58":null,"59":null,"60":0.00571,"61":null,"62":null,"63":0.02853,"64":null,"65":0.01712,"66":null,"67":null,"68":0.01141,"69":null,"70":null,"71":null,"72":null,"73":null,"74":0.34801,"75":null,"76":0.01712,"77":0.02282,"78":0.35942,"79":null,"80":0.1084,"81":0.02282,"83":0.1141,"84":0.1141,"85":19.41982,"86":17.61134,"87":0.01712,"88":null,"89":null},"opera":{"9":null,"11":null,"12":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":null,"51":null,"52":null,"53":0.04564,"54":null,"55":null,"56":null,"57":null,"58":0.01141,"60":null,"62":null,"63":null,"64":null,"65":null,"66":null,"67":null,"68":null,"69":null,"70":0.01712,"71":0.49063,"72":null,"9.5-9.6":null,"10.0-10.1":0,"10.5":null,"10.6":null,"11.1":null,"11.5":null,"11.6":null,"12.1":null},"ios_saf":{"8":0,"14":5.16202,"3.2":0.01237,"4.0-4.1":0.0106,"4.2-4.3":0.00177,"5.0-5.1":0.00883,"6.0-6.1":0.0053,"7.0-7.1":0.01237,"8.1-8.4":0.04063,"9.0-9.2":0.02297,"9.3":0.29326,"10.0-10.2":0.04946,"10.3":0.27206,"11.0-11.2":0.10246,"11.3-11.4":0.17489,"12.0-12.1":0.17843,"12.2-12.4":1.77897,"13.0-13.1":0.14663,"13.2":0.07243,"13.3":0.55118,"13.4-13.7":2.9361},"safari":{"0":null,"4":0,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":0.01712,"12":0.06846,"13":0.10269,"14":2.78404,"3.1":null,"3.2":null,"5.1":0.26243,"6.1":null,"7.1":null,"9.1":null,"10.1":0.07987,"11.1":0.03994,"12.1":0.13692,"13.1":4.48984},"edge":{"12":null,"13":0.01141,"14":0.00571,"15":0.03994,"16":0.03423,"17":0.03423,"18":1.0269,"79":null,"80":null,"81":null,"83":null,"84":null,"85":1.54035,"86":2.89814},"android":{"3":0,"4":0.00965,"81":null,"2.1":0,"2.2":0,"2.3":0.00008,"4.1":0.00486,"4.2-4.3":0.00216,"4.4":0,"4.4.3-4.4.4":0.0176},"samsung":{"4":0.01057,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0.04227,"8.2":0,"9.2":0.06341,"10.1":0.01057,"11.1-11.2":0.2325,"12.0":5.67515},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":null,"7":null,"8":null,"9":null,"10":0.02282,"11":1.16953,"5.5":null},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.03436},"and_qq":{"10.4":0},"and_uc":{"0":0.01289},"op_mini":{"0":0.21958},"and_chr":{"0":25.23983}},"total":99.65962}

/***/ },
/* 1375 */
/***/ function(module, exports) {

	module.exports = {"id":"VI","name":"Virgin Island, U.S.","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":null,"3":null,"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":0.00549,"36":null,"37":null,"38":null,"39":null,"40":0.00549,"41":0.01098,"42":0.01098,"43":0.01647,"44":null,"45":0.02196,"46":null,"47":0.00549,"48":null,"49":0.02196,"50":0.08235,"51":null,"52":null,"53":null,"54":null,"55":0.01098,"56":null,"57":0.01098,"58":0.02196,"59":null,"60":0.01098,"61":0.00549,"62":0.01098,"63":0.01647,"64":null,"65":0.01098,"66":null,"67":0.00549,"68":0.02196,"69":0.01098,"70":null,"71":null,"72":0.11529,"73":null,"74":null,"75":0.01098,"76":null,"77":null,"78":0.09333,"79":null,"80":0.10431,"81":2.27835,"82":0.549,"83":null,"84":null,"3.5":null,"3.6":null},"chrome":{"4":null,"5":0.00549,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":0.01098,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":0.01647,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":0.01647,"39":null,"40":null,"41":0.01098,"42":null,"43":0.00549,"44":null,"45":null,"46":0.01647,"47":0.01098,"48":0.01098,"49":0.03294,"50":0.01647,"51":0.02745,"52":null,"53":0.02196,"54":0.01098,"55":0.01098,"56":null,"57":0.01098,"58":0.01098,"59":null,"60":null,"61":0.00549,"62":null,"63":0.02745,"64":null,"65":0.03843,"66":0.01647,"67":0.01647,"68":0.02745,"69":0.10431,"70":0.03294,"71":0.01098,"72":0.01098,"73":0.01647,"74":0.02196,"75":0.40077,"76":0.08235,"77":0.12627,"78":0.04392,"79":0.03294,"80":0.53253,"81":0.01098,"83":0.1647,"84":0.33489,"85":11.65527,"86":15.28965,"87":null,"88":null,"89":null},"opera":{"9":null,"11":null,"12":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":0.01098,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":null,"51":null,"52":null,"53":null,"54":null,"55":null,"56":null,"57":null,"58":null,"60":null,"62":null,"63":null,"64":null,"65":null,"66":null,"67":null,"68":null,"69":null,"70":0.02196,"71":0.12078,"72":0.01098,"9.5-9.6":null,"10.0-10.1":0,"10.5":null,"10.6":null,"11.1":null,"11.5":null,"11.6":null,"12.1":null},"ios_saf":{"8":0,"14":9.6033,"3.2":0.02301,"4.0-4.1":0.01972,"4.2-4.3":0.00329,"5.0-5.1":0.01643,"6.0-6.1":0.00986,"7.0-7.1":0.02301,"8.1-8.4":0.07559,"9.0-9.2":0.04273,"9.3":0.54557,"10.0-10.2":0.09202,"10.3":0.50613,"11.0-11.2":0.19062,"11.3-11.4":0.32537,"12.0-12.1":0.33194,"12.2-12.4":3.30956,"13.0-13.1":0.27278,"13.2":0.13475,"13.3":1.0254,"13.4-13.7":5.46225},"safari":{"0":null,"4":0,"5":null,"6":null,"7":null,"8":0.00549,"9":null,"10":0.00549,"11":0.02745,"12":0.13176,"13":0.4392,"14":2.90421,"3.1":null,"3.2":null,"5.1":0.02196,"6.1":null,"7.1":null,"9.1":0.01098,"10.1":0.02745,"11.1":0.09333,"12.1":0.38979,"13.1":4.58415},"edge":{"12":0.00549,"13":0.00549,"14":0.02196,"15":0.01098,"16":0.15921,"17":0.07686,"18":0.63135,"79":null,"80":0.00549,"81":0.1098,"83":null,"84":0.03294,"85":3.42576,"86":6.81309},"android":{"3":0,"4":0.00507,"81":null,"2.1":0,"2.2":0,"2.3":0.00004,"4.1":0.00255,"4.2-4.3":0.00114,"4.4":0,"4.4.3-4.4.4":0.00924},"samsung":{"4":0.07208,"5.0-5.4":0.0103,"6.2-6.4":0.0103,"7.2-7.4":0.05149,"8.2":0.06413,"9.2":0.03207,"10.1":0.01069,"11.1-11.2":0.17102,"12.0":7.1185},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":null,"7":null,"8":null,"9":null,"10":null,"11":0.88389,"5.5":null},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.32923},"and_qq":{"10.4":0},"and_uc":{"0":0.00902},"op_mini":{"0":0.01708},"and_chr":{"0":15.88358}},"total":99.51953}

/***/ },
/* 1376 */
/***/ function(module, exports) {

	module.exports = {"id":"VN","name":"Vietnam","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00804,"37":0,"38":0.00804,"39":0,"40":0.00804,"41":0.00804,"42":0.00804,"43":0.00804,"44":0.00804,"45":0.00804,"46":0,"47":0.00804,"48":0.00804,"49":0.00804,"50":0.00804,"51":0.00804,"52":0.06435,"53":0.00804,"54":0.00804,"55":0.00804,"56":0.02413,"57":0.00804,"58":0.00804,"59":0.00804,"60":0.01609,"61":0.00804,"62":0.00804,"63":0.04022,"64":0.04022,"65":0.03218,"66":0.02413,"67":0.00804,"68":0.01609,"69":0,"70":0.00804,"71":0.00804,"72":0.00804,"73":0.00804,"74":0.01609,"75":0,"76":0,"77":0.00804,"78":0.04826,"79":0.01609,"80":0.04826,"81":1.1342,"82":0.16088,"83":0.00804,"84":null,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00804,"37":0,"38":0.00804,"39":0,"40":0,"41":0.00804,"42":0,"43":0,"44":0,"45":0,"46":0.00804,"47":0.00804,"48":0.01609,"49":0.13675,"50":0,"51":0.00804,"52":0.00804,"53":0.01609,"54":0.01609,"55":0.00804,"56":0.01609,"57":0.12066,"58":0.00804,"59":0.00804,"60":0.00804,"61":0.15284,"62":0.01609,"63":0.04022,"64":0.01609,"65":0.01609,"66":0.01609,"67":0.04022,"68":0.01609,"69":0.03218,"70":0.25741,"71":0.32176,"72":0.25741,"73":0.12066,"74":0.04022,"75":0.05631,"76":0.04022,"77":0.06435,"78":0.0724,"79":0.09653,"80":0.31372,"81":0.09653,"83":0.24936,"84":0.4022,"85":16.80392,"86":25.43513,"87":0.02413,"88":0.01609,"89":null},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.00804,"37":0.01609,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.06435,"44":0,"45":0,"46":0,"47":0,"48":0.00804,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0.00804,"57":0.03218,"58":0.01609,"60":0.00804,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0.00804,"68":0,"69":0,"70":0.06435,"71":0.64352,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.00804,"11":0.00804,"12":0.04826,"13":0.16088,"14":0.72396,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.01609,"11.1":0.04826,"12.1":0.21719,"13.1":0.82049},"ios_saf":{"8":0,"14":5.08644,"3.2":0.01219,"4.0-4.1":0.01044,"4.2-4.3":0.00174,"5.0-5.1":0.0087,"6.0-6.1":0.00522,"7.0-7.1":0.01219,"8.1-8.4":0.04004,"9.0-9.2":0.02263,"9.3":0.28896,"10.0-10.2":0.04874,"10.3":0.26807,"11.0-11.2":0.10096,"11.3-11.4":0.17233,"12.0-12.1":0.17581,"12.2-12.4":1.75292,"13.0-13.1":0.14448,"13.2":0.07137,"13.3":0.54311,"13.4-13.7":2.89311},"edge":{"12":0,"13":0,"14":0.03218,"15":0.00804,"16":0.02413,"17":0.02413,"18":0.08848,"79":0,"80":0,"81":0.00804,"83":0,"84":0.00804,"85":0.77222,"86":null},"android":{"3":0,"4":0.04134,"81":null,"2.1":0,"2.2":0,"2.3":0.00033,"4.1":0.02083,"4.2-4.3":0.00926,"4.4":0,"4.4.3-4.4.4":0.0754},"samsung":{"4":0.1016,"5.0-5.4":0.02032,"6.2-6.4":0,"7.2-7.4":0.02032,"8.2":0.02032,"9.2":0.08128,"10.1":0.04064,"11.1-11.2":0.14224,"12.0":0.98551},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.06757,"9":0.01931,"10":0.00965,"11":0.19306,"5.5":0},"bb":{"7":0,"10":0.00782},"ie_mob":{"10":0,"11":0},"op_mini":{"0":0.14074},"and_chr":{"0":20.30352},"kaios":{"2.5":0.00196},"baidu":{"0":null},"and_ff":{"0":0.03716},"and_qq":{"10.4":0.01174},"and_uc":{"0":0.34426}},"total":85.57966}

/***/ },
/* 1377 */
/***/ function(module, exports) {

	module.exports = {"id":"VU","name":"Vanuatu","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0.0048,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0.01441,"35":0.0048,"36":0,"37":0,"38":0.01441,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.0048,"48":0,"49":0,"50":0,"51":0,"52":0.0048,"53":0,"54":0,"55":0,"56":0.0048,"57":0,"58":0,"59":0,"60":0,"61":0.0048,"62":0,"63":0,"64":0.01441,"65":0,"66":0.0048,"67":0.0048,"68":0.01921,"69":0,"70":0.0048,"71":0,"72":0.10084,"73":0,"74":0,"75":0,"76":0.0048,"77":0,"78":0.0096,"79":0.01921,"80":0.02881,"81":1.02763,"82":0.10084,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.0048,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.45619,"41":0.0048,"42":0,"43":0,"44":0,"45":0.0048,"46":0,"47":0,"48":0,"49":0.0096,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0.0048,"57":0.29772,"58":0.0048,"59":0.0048,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0.0048,"68":0,"69":0.2305,"70":0,"71":0.0048,"72":0.0048,"73":0.0048,"74":0.0096,"75":0,"76":0.02881,"77":0.0048,"78":0.0048,"79":0.02401,"80":0.05282,"81":0.36015,"83":0.07683,"84":0.07203,"85":4.10571,"86":6.75161,"87":0.02401,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.0096,"71":0.03842,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":4.59198,"3.2":0.011,"4.0-4.1":0.00943,"4.2-4.3":0.00157,"5.0-5.1":0.00786,"6.0-6.1":0.00471,"7.0-7.1":0.011,"8.1-8.4":0.03614,"9.0-9.2":0.02043,"9.3":0.26087,"10.0-10.2":0.044,"10.3":0.24201,"11.0-11.2":0.09115,"11.3-11.4":0.15558,"12.0-12.1":0.15872,"12.2-12.4":1.58252,"13.0-13.1":0.13044,"13.2":0.06443,"13.3":0.49031,"13.4-13.7":2.61186},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.0096,"12":0,"13":0.05282,"14":0.46579,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0.01441,"11.1":0.05282,"12.1":0.0048,"13.1":0.37456},"edge":{"12":0.0096,"13":0.02401,"14":0.0048,"15":0.02401,"16":0.02401,"17":0.13446,"18":0.20168,"79":0,"80":0,"81":0.0048,"83":0,"84":0.0096,"85":1.49822,"86":3.31338},"android":{"3":0,"4":0.18747,"81":null,"2.1":0,"2.2":0,"2.3":0.0015,"4.1":0.09448,"4.2-4.3":0.04199,"4.4":0,"4.4.3-4.4.4":0.34194},"samsung":{"4":0.21832,"5.0-5.4":0.06238,"6.2-6.4":0.02079,"7.2-7.4":0.22871,"8.2":0,"9.2":0.12475,"10.1":0.06238,"11.1-11.2":0.13515,"12.0":0.81089},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0.01137,"10":0,"11":0.76175,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.10916},"and_qq":{"10.4":0.04678},"and_uc":{"0":1.32549},"op_mini":{"0":0.08366},"and_chr":{"0":62.96285}},"total":98.38377}

/***/ },
/* 1378 */
/***/ function(module, exports) {

	module.exports = {"id":"WF","name":"Wallis and Futuna","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.04181,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":1.86265,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.20903,"69":0,"70":0.52024,"71":0,"72":0.47844,"73":0,"74":0,"75":0,"76":0.01858,"77":0.06039,"78":0.31122,"79":0,"80":0.3716,"81":2.40147,"82":0.20903,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0.22761,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.01858,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.08361,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0.66424,"58":0,"59":0.04181,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0.45521,"68":0,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0.28799,"79":0,"80":0,"81":0,"83":0,"84":0.04181,"85":4.04115,"86":1.61646,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.01858,"71":0.53882,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":3.06916,"3.2":0.00735,"4.0-4.1":0.0063,"4.2-4.3":0.00105,"5.0-5.1":0.00525,"6.0-6.1":0.00315,"7.0-7.1":0.00735,"8.1-8.4":0.02416,"9.0-9.2":0.01365,"9.3":0.17436,"10.0-10.2":0.02941,"10.3":0.16176,"11.0-11.2":0.06092,"11.3-11.4":0.10399,"12.0-12.1":0.10609,"12.2-12.4":1.05771,"13.0-13.1":0.08718,"13.2":0.04306,"13.3":0.32771,"13.4-13.7":1.7457},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0.01858,"11":0,"12":0,"13":0.04181,"14":0.39483,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0,"12.1":0.16722,"13.1":2.11348},"edge":{"12":0,"13":0,"14":0,"15":0,"16":0,"17":0.04181,"18":0,"79":0,"80":0,"81":0,"83":0,"84":0,"85":0.59921,"86":2.19709},"android":{"3":0,"4":0.12001,"81":null,"2.1":0,"2.2":0,"2.3":0.00096,"4.1":0.06048,"4.2-4.3":0.02688,"4.4":0,"4.4.3-4.4.4":0.21889},"samsung":{"4":0,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0,"8.2":0,"9.2":0,"10.1":0.04215,"11.1-11.2":0.47413,"12.0":7.2806},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0.144,"10":0,"11":0.12542,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.0482},"and_qq":{"10.4":0},"and_uc":{"0":0},"op_mini":{"0":0.40051},"and_chr":{"0":59.9696}},"total":96.0415}

/***/ },
/* 1379 */
/***/ function(module, exports) {

	module.exports = {"id":"WS","name":"Samoa","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0.02806,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.00351,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00351,"69":0.00351,"70":0,"71":0,"72":0.00351,"73":0,"74":0,"75":0.00701,"76":0,"77":0.00351,"78":0.02455,"79":0.00351,"80":0.02455,"81":0.4524,"82":0.03507,"83":0.00351,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0.00351,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0.01052,"48":0,"49":0.01052,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0.00351,"57":0,"58":0.00351,"59":0,"60":0.01052,"61":0,"62":0.05611,"63":0.00351,"64":0,"65":0.00351,"66":0,"67":0,"68":0,"69":0.01052,"70":0.00701,"71":0.01052,"72":0.00351,"73":0,"74":0.01403,"75":0,"76":0,"77":0.00351,"78":0.01403,"79":0.00701,"80":0.00701,"81":0.00701,"83":0.02806,"84":0.04559,"85":3.06863,"86":3.78756,"87":0.11222,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.02455,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.00351,"47":0.00351,"48":0,"49":0,"50":0.01754,"51":0,"52":0,"53":0.00351,"54":0.00351,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.01403,"71":0.08066,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":1.9359,"3.2":0.00464,"4.0-4.1":0.00398,"4.2-4.3":0.00066,"5.0-5.1":0.00331,"6.0-6.1":0.00199,"7.0-7.1":0.00464,"8.1-8.4":0.01524,"9.0-9.2":0.00861,"9.3":0.10998,"10.0-10.2":0.01855,"10.3":0.10203,"11.0-11.2":0.03843,"11.3-11.4":0.06559,"12.0-12.1":0.06692,"12.2-12.4":0.66716,"13.0-13.1":0.05499,"13.2":0.02716,"13.3":0.20671,"13.4-13.7":1.10112},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00351,"12":0.00351,"13":0.01403,"14":0.07715,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0.00701,"12.1":0.00701,"13.1":0.04559},"edge":{"12":0.00351,"13":0.00701,"14":0.01052,"15":0.03156,"16":0.02806,"17":0.07365,"18":0.20691,"79":0,"80":0,"81":0.00351,"83":0.00351,"84":0.02104,"85":0.22094,"86":0.34719},"android":{"3":0,"4":0.05312,"81":null,"2.1":0,"2.2":0,"2.3":0.00042,"4.1":0.02677,"4.2-4.3":0.0119,"4.4":0,"4.4.3-4.4.4":0.09689},"samsung":{"4":0.29639,"5.0-5.4":0.02044,"6.2-6.4":0.06132,"7.2-7.4":0.64389,"8.2":0.03066,"9.2":0.27595,"10.1":1.22646,"11.1-11.2":0.33728,"12.0":2.62666},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00805,"9":0.00805,"10":0,"11":0.20133,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.10389},"and_qq":{"10.4":0.04545},"and_uc":{"0":3.3374},"op_mini":{"0":0.84216},"and_chr":{"0":72.82173}},"total":96.60751}

/***/ },
/* 1380 */
/***/ function(module, exports) {

	module.exports = {"id":"YE","name":"Yemen","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0.01621,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.0054,"44":0.0027,"45":0,"46":0,"47":0.0027,"48":0.0027,"49":0.0027,"50":0,"51":0,"52":0.0081,"53":0,"54":0.0027,"55":0.0027,"56":0.0054,"57":0.0054,"58":0,"59":0,"60":0.0027,"61":0.0027,"62":0.0054,"63":0,"64":0.0027,"65":0.0027,"66":0.0027,"67":0.0027,"68":0.03511,"69":0.0027,"70":0.0108,"71":0.0027,"72":0.01891,"73":0.0027,"74":0.0081,"75":0.0027,"76":0.0027,"77":0.0027,"78":0.0081,"79":0.0081,"80":0.02161,"81":0.41595,"82":0.04862,"83":0.0027,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0.0027,"32":0.0108,"33":0.01351,"34":0,"35":0,"36":0.0027,"37":0,"38":0,"39":0.0027,"40":0.0054,"41":0,"42":0.0027,"43":0.0081,"44":0,"45":0,"46":0.0027,"47":0,"48":0.0027,"49":0.0108,"50":0.0027,"51":0,"52":0,"53":0.0054,"54":0.0027,"55":0.0054,"56":0.0027,"57":0.0027,"58":0.0027,"59":0.0027,"60":0.0027,"61":0,"62":0.0027,"63":0.02161,"64":0.0027,"65":0.0027,"66":0.0054,"67":0.0027,"68":0.01621,"69":0.01351,"70":0.0108,"71":0.01891,"72":0.01891,"73":0.0081,"74":0.02701,"75":0.01891,"76":0.02701,"77":0.01621,"78":0.03511,"79":0.03241,"80":0.04862,"81":0.03781,"83":0.07293,"84":0.09724,"85":1.32079,"86":1.97713,"87":0.0027,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.0027,"30":0.0027,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0.0027,"37":0,"38":0.0054,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0.0027,"51":0.02161,"52":0,"53":0.0027,"54":0,"55":0,"56":0,"57":0,"58":0.0027,"60":0.0054,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.0081,"71":0.04052,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.0108},"ios_saf":{"8":0,"14":1.14313,"3.2":0.00274,"4.0-4.1":0.00235,"4.2-4.3":0.00039,"5.0-5.1":0.00196,"6.0-6.1":0.00117,"7.0-7.1":0.00274,"8.1-8.4":0.009,"9.0-9.2":0.00509,"9.3":0.06494,"10.0-10.2":0.01095,"10.3":0.06025,"11.0-11.2":0.02269,"11.3-11.4":0.03873,"12.0-12.1":0.03951,"12.2-12.4":0.39395,"13.0-13.1":0.03247,"13.2":0.01604,"13.3":0.12206,"13.4-13.7":0.6502},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.0054,"13":0.0027,"14":0.0108,"3.1":0,"3.2":0,"5.1":0.62393,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0,"12.1":0.0054,"13.1":0.03781},"edge":{"12":0,"13":0.0027,"14":0.0108,"15":0,"16":0.0054,"17":0.0108,"18":0.03781,"79":0,"80":0,"81":0,"83":0.0027,"84":0.0054,"85":0.05132,"86":0.07293},"android":{"3":0,"4":0.38955,"81":null,"2.1":0,"2.2":0,"2.3":0.00312,"4.1":0.19633,"4.2-4.3":0.08726,"4.4":0,"4.4.3-4.4.4":0.71053},"samsung":{"4":0.68745,"5.0-5.4":0.14153,"6.2-6.4":0.04044,"7.2-7.4":0.18197,"8.2":0.03033,"9.2":0.35383,"10.1":0.22241,"11.1-11.2":0.29318,"12.0":1.54676},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.0027,"9":0,"10":0,"11":0.01621,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.27736},"and_qq":{"10.4":0.0073},"and_uc":{"0":3.53272},"op_mini":{"0":1.84503},"and_chr":{"0":78.55956}},"total":97.34501}

/***/ },
/* 1381 */
/***/ function(module, exports) {

	module.exports = {"id":"YT","name":"Mayotte","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.00606,"41":0,"42":0.00606,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0.01817,"53":0,"54":0,"55":0.01817,"56":0.02422,"57":0,"58":0,"59":0,"60":0.03028,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0.01211,"67":0,"68":0.04845,"69":0.00606,"70":0.00606,"71":0,"72":0.02422,"73":0,"74":0,"75":0,"76":0.00606,"77":0.02422,"78":0.08478,"79":0.00606,"80":0.3028,"81":3.785,"82":0.27858,"83":0.00606,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00606,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0.01817,"50":0,"51":0.00606,"52":0,"53":0.00606,"54":0,"55":0,"56":0.01211,"57":0,"58":0.03028,"59":0,"60":0,"61":0,"62":0,"63":0.00606,"64":0.00606,"65":0.02422,"66":0,"67":0.07873,"68":0,"69":0.00606,"70":0.00606,"71":0,"72":0,"73":0,"74":0.03028,"75":0,"76":0.04239,"77":0.02422,"78":0.01211,"79":0.19985,"80":0,"81":0.06662,"83":0.04845,"84":0.07873,"85":9.31413,"86":12.32396,"87":0.03028,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.00606,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0.00606,"58":0,"60":0,"62":0,"63":0.01817,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.0545,"71":0.43603,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":5.16059,"3.2":0.01236,"4.0-4.1":0.0106,"4.2-4.3":0.00177,"5.0-5.1":0.00883,"6.0-6.1":0.0053,"7.0-7.1":0.01236,"8.1-8.4":0.04062,"9.0-9.2":0.02296,"9.3":0.29318,"10.0-10.2":0.04945,"10.3":0.27198,"11.0-11.2":0.10243,"11.3-11.4":0.17485,"12.0-12.1":0.17838,"12.2-12.4":1.77848,"13.0-13.1":0.14659,"13.2":0.07241,"13.3":0.55103,"13.4-13.7":2.93529},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0.00606,"9":0,"10":0.00606,"11":0,"12":0.01211,"13":0.06056,"14":1.28993,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0.00606,"9.1":0,"10.1":0.00606,"11.1":0.0545,"12.1":0.15746,"13.1":0.78728},"edge":{"12":0.10295,"13":0.06056,"14":0.01817,"15":0.01211,"16":0.03028,"17":0.10295,"18":0.9629,"79":0,"80":0.01817,"81":0.00606,"83":0.01211,"84":0.02422,"85":0.88418,"86":2.31945},"android":{"3":0,"4":0.04324,"81":null,"2.1":0,"2.2":0,"2.3":0.00035,"4.1":0.02179,"4.2-4.3":0.00969,"4.4":0,"4.4.3-4.4.4":0.07887},"samsung":{"4":0.33984,"5.0-5.4":0,"6.2-6.4":0.0103,"7.2-7.4":0.07209,"8.2":0,"9.2":0.05149,"10.1":0.0103,"11.1-11.2":0.06179,"12.0":2.04935},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0.01817,"10":0,"11":0.19985,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.21692},"and_qq":{"10.4":0},"and_uc":{"0":0.00789},"op_mini":{"0":0.48168},"and_chr":{"0":47.94274}},"total":97.97719}

/***/ },
/* 1382 */
/***/ function(module, exports) {

	module.exports = {"id":"ZA","name":"South Africa","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0.00571,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0.00286,"49":0,"50":0,"51":0,"52":0.00857,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0.00571,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0.00286,"67":0,"68":0.01143,"69":0,"70":0,"71":0,"72":0.00286,"73":0,"74":0,"75":0,"76":0,"77":0.00286,"78":0.01714,"79":0.00857,"80":0.03714,"81":0.40855,"82":0.06571,"83":0.00286,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00857,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0.00286,"27":0,"28":0.00286,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.00571,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0.00286,"47":0,"48":0,"49":0.03143,"50":0.00286,"51":0,"52":0,"53":0.00286,"54":0,"55":0.00857,"56":0.00286,"57":0,"58":0.00571,"59":0,"60":0,"61":0.00286,"62":0.00286,"63":0.00286,"64":0.00286,"65":0.00286,"66":0.00571,"67":0.00571,"68":0.00286,"69":0.00571,"70":0.00857,"71":0.00571,"72":0.00857,"73":0.00571,"74":0.00857,"75":0.00857,"76":0.00571,"77":0.00857,"78":0.01714,"79":0.02571,"80":0.03143,"81":0.04857,"83":0.03428,"84":0.05428,"85":1.7742,"86":2.89414,"87":0.00857,"88":0.00286,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0.00286,"25":0.00286,"26":0.01714,"27":0,"28":0.00857,"29":0,"30":0.00286,"31":0.00286,"32":0.00571,"33":0.00286,"34":0,"35":0.03428,"36":0,"37":0,"38":0.00571,"39":0,"40":0,"41":0,"42":0.00286,"43":0,"44":0,"45":0.00286,"46":0.01714,"47":0.01429,"48":0,"49":0,"50":0.05714,"51":0.22856,"52":0,"53":0.00571,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0.01143,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0.01714,"71":0.11428,"72":0.00286,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.00857},"ios_saf":{"8":0,"14":5.60021,"3.2":0.01342,"4.0-4.1":0.0115,"4.2-4.3":0.00192,"5.0-5.1":0.00958,"6.0-6.1":0.00575,"7.0-7.1":0.01342,"8.1-8.4":0.04408,"9.0-9.2":0.02492,"9.3":0.31815,"10.0-10.2":0.05366,"10.3":0.29515,"11.0-11.2":0.11116,"11.3-11.4":0.18974,"12.0-12.1":0.19357,"12.2-12.4":1.92998,"13.0-13.1":0.15908,"13.2":0.07858,"13.3":0.59797,"13.4-13.7":3.18534},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00286,"12":0.00571,"13":0.02857,"14":0.21713,"3.1":0,"3.2":0,"5.1":0.00571,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00571,"11.1":0.01714,"12.1":0.02857,"13.1":0.2457},"edge":{"12":0.00571,"13":0.00286,"14":0.00571,"15":0.00571,"16":0.00857,"17":0.02,"18":0.07714,"79":0,"80":0,"81":0,"83":0,"84":0.00286,"85":0.16856,"86":0.31998},"android":{"3":0,"4":0.0301,"81":null,"2.1":0,"2.2":0,"2.3":0.00024,"4.1":0.01517,"4.2-4.3":0.00674,"4.4":0,"4.4.3-4.4.4":0.0549},"samsung":{"4":0.63944,"5.0-5.4":0.03045,"6.2-6.4":0.0609,"7.2-7.4":0.47704,"8.2":0.05075,"9.2":0.28419,"10.1":0.27404,"11.1-11.2":0.55824,"12.0":7.10484},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.00577,"9":0.00288,"10":0,"11":0.29133,"5.5":0},"bb":{"7":0,"10":0.02143},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.01429},"baidu":{"0":null},"and_ff":{"0":0.35715},"and_qq":{"10.4":0.00714},"and_uc":{"0":0.52858},"op_mini":{"0":3.44889},"and_chr":{"0":61.64168}},"total":96.13154}

/***/ },
/* 1383 */
/***/ function(module, exports) {

	module.exports = {"id":"ZM","name":"Zambia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0.00319,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0.00319,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00319,"44":0,"45":0.00319,"46":0,"47":0.01278,"48":0.01597,"49":0,"50":0,"51":0,"52":0.00319,"53":0,"54":0,"55":0,"56":0.00319,"57":0,"58":0,"59":0,"60":0.00319,"61":0,"62":0,"63":0.01278,"64":0,"65":0.00319,"66":0,"67":0,"68":0.02875,"69":0,"70":0.00319,"71":0.00319,"72":0.00639,"73":0,"74":0,"75":0,"76":0.00958,"77":0.00319,"78":0.02555,"79":0.00958,"80":0.02236,"81":0.62922,"82":0.08304,"83":0.00958,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0.02555,"41":0,"42":0.00319,"43":0.00319,"44":0,"45":0,"46":0.00319,"47":0,"48":0,"49":0.01278,"50":0.00319,"51":0.00319,"52":0,"53":0,"54":0.00319,"55":0.00319,"56":0,"57":0,"58":0.00958,"59":0,"60":0,"61":0.00319,"62":0.00319,"63":0.01597,"64":0.00958,"65":0.00319,"66":0.00319,"67":0.00319,"68":0.00319,"69":0.00958,"70":0.00319,"71":0.02236,"72":0.00319,"73":0.00319,"74":0.01597,"75":0.01278,"76":0.02555,"77":0.00639,"78":0.01597,"79":0.04472,"80":0.07985,"81":0.0543,"83":0.0511,"84":0.07346,"85":1.74392,"86":2.61908,"87":0.00958,"88":0.01916,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0.00319,"17":0,"18":0,"19":0.00319,"20":0.00639,"21":0,"22":0,"23":0.00639,"24":0.0543,"25":0.00319,"26":0.03833,"27":0.02555,"28":0.03833,"29":0.00319,"30":0.04791,"31":0.00639,"32":0.07027,"33":0.0543,"34":0.00319,"35":0.22039,"36":0.00319,"37":0.00639,"38":0.04472,"39":0,"40":0.00319,"41":0.00319,"42":0.09263,"43":0.00319,"44":0.00639,"45":0.13415,"46":0.17567,"47":0.16289,"48":0.00319,"49":0,"50":0.7985,"51":2.35078,"52":0.00319,"53":0.00958,"54":0.00319,"55":0,"56":0.00319,"57":0.00319,"58":0.00319,"60":0.07027,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0.00319,"69":0.00319,"70":0.11498,"71":0.68032,"72":0.02236,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.25871},"ios_saf":{"8":0,"14":2.19878,"3.2":0.00527,"4.0-4.1":0.00451,"4.2-4.3":0.00075,"5.0-5.1":0.00376,"6.0-6.1":0.00226,"7.0-7.1":0.00527,"8.1-8.4":0.01731,"9.0-9.2":0.00978,"9.3":0.12491,"10.0-10.2":0.02107,"10.3":0.11588,"11.0-11.2":0.04364,"11.3-11.4":0.0745,"12.0-12.1":0.076,"12.2-12.4":0.75776,"13.0-13.1":0.06246,"13.2":0.03085,"13.3":0.23478,"13.4-13.7":1.25064},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.01597,"12":0.01278,"13":0.00639,"14":0.13415,"3.1":0,"3.2":0,"5.1":0.04472,"6.1":0,"7.1":0,"9.1":0,"10.1":0.01278,"11.1":0.02236,"12.1":0.05749,"13.1":0.13734},"edge":{"12":0.04152,"13":0.02236,"14":0.01916,"15":0.02555,"16":0.04152,"17":0.04791,"18":0.15331,"79":0,"80":0,"81":0.00319,"83":0.00319,"84":0.01597,"85":0.25552,"86":0.3737},"android":{"3":0,"4":0.17685,"81":null,"2.1":0,"2.2":0,"2.3":0.00141,"4.1":0.08913,"4.2-4.3":0.03961,"4.4":0,"4.4.3-4.4.4":0.32257},"samsung":{"4":0.34049,"5.0-5.4":0.03095,"6.2-6.4":0.04127,"7.2-7.4":0.12381,"8.2":0.02064,"9.2":0.24763,"10.1":0.07223,"11.1-11.2":0.35081,"12.0":1.34133},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.03528,"9":0,"10":0.00504,"11":0.18646,"5.5":0},"bb":{"7":0,"10":0.05445},"ie_mob":{"10":0,"11":0.04764},"kaios":{"2.5":0.04764},"baidu":{"0":null},"and_ff":{"0":0.21099},"and_qq":{"10.4":0.12931},"and_uc":{"0":2.43655},"op_mini":{"0":21.87562},"and_chr":{"0":47.71723}},"total":93.81206}

/***/ },
/* 1384 */
/***/ function(module, exports) {

	module.exports = {"id":"ZW","name":"Zimbabwe","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0.00497,"18":0.01986,"19":0,"20":0,"21":0,"22":0,"23":0.00497,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0.00497,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0.00497,"44":0,"45":0.00497,"46":0,"47":0.00497,"48":0.00497,"49":0,"50":0.00497,"51":0.00993,"52":0.02979,"53":0,"54":0,"55":0,"56":0.00497,"57":0.00993,"58":0,"59":0,"60":0.00497,"61":0,"62":0.00497,"63":0,"64":0,"65":0.00497,"66":0.00497,"67":0.00497,"68":0.03476,"69":0.00497,"70":0.00497,"71":0,"72":0.01986,"73":0,"74":0.00497,"75":0.00497,"76":0.00497,"77":0.0149,"78":0.08937,"79":0.02483,"80":0.08441,"81":1.91649,"82":0.3128,"83":0.03476,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0.00497,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0.00497,"25":0,"26":0,"27":0,"28":0,"29":0.00497,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0.00497,"39":0,"40":0.02979,"41":0,"42":0.00497,"43":0.00497,"44":0,"45":0,"46":0.01986,"47":0.00993,"48":0,"49":0.03972,"50":0.00497,"51":0,"52":0,"53":0.00993,"54":0,"55":0.03972,"56":0,"57":0.00497,"58":0.01986,"59":0,"60":0.00993,"61":0.00497,"62":0.00497,"63":0.04469,"64":0.00497,"65":0.00993,"66":0.00497,"67":0.00993,"68":0.00993,"69":0.02979,"70":0.02483,"71":0.00993,"72":0.00993,"73":0.01986,"74":0.04469,"75":0.01986,"76":0.03476,"77":0.02483,"78":0.03476,"79":0.10427,"80":0.13406,"81":0.13902,"83":0.12413,"84":0.20357,"85":4.53305,"86":7.62128,"87":0.0149,"88":0.00497,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0.00497,"20":0.00497,"21":0,"22":0,"23":0,"24":0.00993,"25":0.00497,"26":0.04469,"27":0.00497,"28":0.08937,"29":0.0149,"30":0.02979,"31":0.00497,"32":0.06951,"33":0.06455,"34":0.00497,"35":0.13406,"36":0.00993,"37":0.00497,"38":0.20357,"39":0.00497,"40":0,"41":0.00497,"42":0.1142,"43":0,"44":0.00993,"45":0.02483,"46":0.12413,"47":0.08937,"48":0.00497,"49":0,"50":0.38231,"51":1.36041,"52":0,"53":0.00497,"54":0.00993,"55":0.00497,"56":0,"57":0,"58":0.00497,"60":0.06455,"62":0,"63":0.00497,"64":0.00497,"65":0.00497,"66":0.00497,"67":0.00497,"68":0.00993,"69":0.00993,"70":0.22343,"71":1.32069,"72":0.04469,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0.37734},"ios_saf":{"8":0,"14":3.05314,"3.2":0.00731,"4.0-4.1":0.00627,"4.2-4.3":0.00104,"5.0-5.1":0.00522,"6.0-6.1":0.00313,"7.0-7.1":0.00731,"8.1-8.4":0.02403,"9.0-9.2":0.01358,"9.3":0.17345,"10.0-10.2":0.02926,"10.3":0.16091,"11.0-11.2":0.0606,"11.3-11.4":0.10344,"12.0-12.1":0.10553,"12.2-12.4":1.05219,"13.0-13.1":0.08673,"13.2":0.04284,"13.3":0.326,"13.4-13.7":1.73659},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0.00497,"10":0,"11":0.0149,"12":0.03476,"13":0.08937,"14":0.38231,"3.1":0,"3.2":0,"5.1":0.28301,"6.1":0,"7.1":0,"9.1":0,"10.1":0.00993,"11.1":0.04965,"12.1":0.04965,"13.1":0.39224},"edge":{"12":0.06951,"13":0.07944,"14":0.05958,"15":0.04965,"16":0.05462,"17":0.06951,"18":0.32769,"79":0,"80":0,"81":0.00497,"83":0.00497,"84":0.02979,"85":0.57594,"86":0.97314},"android":{"3":0,"4":0.1686,"81":null,"2.1":0,"2.2":0,"2.3":0.00135,"4.1":0.08497,"4.2-4.3":0.03777,"4.4":0,"4.4.3-4.4.4":0.30752},"samsung":{"4":0.63775,"5.0-5.4":0.01045,"6.2-6.4":0.02091,"7.2-7.4":0.2091,"8.2":0.02091,"9.2":0.10455,"10.1":0.115,"11.1-11.2":0.15682,"12.0":1.99687},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0.01032,"9":0,"10":0.01032,"11":0.24251,"5.5":0},"bb":{"7":0,"10":0.01511},"ie_mob":{"10":0,"11":0.02014},"kaios":{"2.5":0.00504},"baidu":{"0":null},"and_ff":{"0":0.18126},"and_qq":{"10.4":0.03021},"and_uc":{"0":1.25875},"op_mini":{"0":11.36885},"and_chr":{"0":45.08303}},"total":93.77318}

/***/ },
/* 1385 */
/***/ function(module, exports) {

	module.exports = {"id":"af","name":"Africa","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":null,"3":null,"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":0.00386,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":0.01546,"44":null,"45":0.00386,"46":null,"47":0.01546,"48":0.02318,"49":0.00386,"50":0.00386,"51":null,"52":0.0966,"53":null,"54":null,"55":null,"56":0.00773,"57":0.00386,"58":null,"59":null,"60":0.01159,"61":null,"62":0.00386,"63":0.00773,"64":0.00386,"65":0.01159,"66":0.00773,"67":0.00773,"68":0.01546,"69":0.00773,"70":0.00773,"71":0.00773,"72":0.02705,"73":0.00386,"74":0.00773,"75":0.00773,"76":0.00773,"77":0.01546,"78":0.14683,"79":0.02705,"80":0.12751,"81":2.51546,"82":0.3864,"83":0.03091,"84":null,"3.5":null,"3.6":null},"chrome":{"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":0.00386,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":0.00386,"25":null,"26":0.01159,"27":null,"28":0.00386,"29":0.00386,"30":null,"31":0.00773,"32":null,"33":0.01546,"34":null,"35":null,"36":null,"37":0.00386,"38":0.00773,"39":0.00386,"40":0.01546,"41":null,"42":null,"43":0.11206,"44":null,"45":null,"46":0.00386,"47":0.01159,"48":0.00386,"49":0.21638,"50":0.00773,"51":0.00386,"52":null,"53":0.01546,"54":null,"55":0.00773,"56":0.01159,"57":0.00773,"58":0.01932,"59":0.00386,"60":0.00773,"61":0.02705,"62":0.01159,"63":0.04637,"64":0.01159,"65":0.03091,"66":0.01159,"67":0.03091,"68":0.01159,"69":0.03864,"70":0.05023,"71":0.05796,"72":0.0541,"73":0.0425,"74":0.08887,"75":0.0425,"76":0.05796,"77":0.0541,"78":0.07728,"79":0.1507,"80":0.23957,"81":0.13138,"83":0.20093,"84":0.37094,"85":9.14995,"86":14.70638,"87":0.03478,"88":0.01546,"89":null},"opera":{"9":null,"11":null,"12":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":0.00773,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":null,"51":null,"52":null,"53":null,"54":null,"55":null,"56":null,"57":null,"58":null,"60":0.00773,"62":null,"63":0.00386,"64":0.00773,"65":null,"66":null,"67":0.00773,"68":0.03091,"69":0.00773,"70":0.27434,"71":1.08192,"72":0.02705,"9.5-9.6":null,"10.0-10.1":0,"10.5":null,"10.6":null,"11.1":null,"11.5":null,"11.6":null,"12.1":0.00386},"ios_saf":{"8":0,"14":2.48182,"3.2":0.00595,"4.0-4.1":0.0051,"4.2-4.3":0.00085,"5.0-5.1":0.00425,"6.0-6.1":0.00255,"7.0-7.1":0.00595,"8.1-8.4":0.01954,"9.0-9.2":0.01104,"9.3":0.14099,"10.0-10.2":0.02378,"10.3":0.1308,"11.0-11.2":0.04926,"11.3-11.4":0.08409,"12.0-12.1":0.08579,"12.2-12.4":0.8553,"13.0-13.1":0.0705,"13.2":0.03482,"13.3":0.265,"13.4-13.7":1.41163},"safari":{"0":null,"4":0,"5":null,"6":null,"7":null,"8":null,"9":null,"10":0.00386,"11":0.01546,"12":0.03478,"13":0.11592,"14":0.51778,"3.1":null,"3.2":null,"5.1":0.30912,"6.1":null,"7.1":null,"9.1":0.00773,"10.1":0.02318,"11.1":0.06182,"12.1":0.11206,"13.1":0.54096},"edge":{"12":0.02318,"13":0.01159,"14":0.01546,"15":0.02705,"16":0.02705,"17":0.04637,"18":0.2357,"79":null,"80":null,"81":0.00386,"83":0.00773,"84":0.01932,"85":0.59892,"86":1.10124},"android":{"3":0,"4":0.03793,"81":null,"2.1":0,"2.2":0,"2.3":0.0003,"4.1":0.01911,"4.2-4.3":0.0085,"4.4":0,"4.4.3-4.4.4":0.06918},"samsung":{"4":0.36771,"5.0-5.4":0.01021,"6.2-6.4":0.02043,"7.2-7.4":0.24514,"8.2":0.03064,"9.2":0.18386,"10.1":0.143,"11.1-11.2":0.30643,"12.0":3.13577},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":null,"7":null,"8":0.05757,"9":0.01329,"10":0.00886,"11":0.49602,"5.5":null},"bb":{"7":0,"10":0.01841},"ie_mob":{"10":0,"11":0.02014},"kaios":{"2.5":0.01841},"baidu":{"0":null},"and_ff":{"0":0.23934},"and_qq":{"10.4":0.02455},"and_uc":{"0":0.77326},"op_mini":{"0":6.92566},"and_chr":{"0":44.84031}},"total":98.85768}

/***/ },
/* 1386 */
/***/ function(module, exports) {

	module.exports = {"id":"an","name":"Antarctica","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0,"79":0,"80":0,"81":4.59821,"82":0,"83":0,"84":0,"3.5":0,"3.6":0},"chrome":{"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0.30779,"72":0,"73":0,"74":0,"75":0,"76":0,"77":0,"78":0,"79":0,"80":0,"81":0,"83":0,"84":4.29975,"85":12.27433,"86":33.13883,"87":0,"88":0,"89":0},"opera":{"9":0,"11":0,"12":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"60":0,"62":0,"63":0,"64":0,"65":0,"66":0,"67":0,"68":0,"69":0,"70":0,"71":0,"72":0,"9.5-9.6":0,"10.0-10.1":0,"10.5":0,"10.6":0,"11.1":0,"11.5":0,"11.6":0,"12.1":0},"ios_saf":{"8":0,"14":3.7425,"3.2":0.00897,"4.0-4.1":0.00768,"4.2-4.3":0.00128,"5.0-5.1":0.0064,"6.0-6.1":0.00384,"7.0-7.1":0.00897,"8.1-8.4":0.02946,"9.0-9.2":0.01665,"9.3":0.21261,"10.0-10.2":0.03586,"10.3":0.19724,"11.0-11.2":0.07429,"11.3-11.4":0.1268,"12.0-12.1":0.12936,"12.2-12.4":1.28976,"13.0-13.1":0.10631,"13.2":0.05251,"13.3":0.39961,"13.4-13.7":2.12869},"safari":{"0":null,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0.30779,"13":0.30779,"14":3.06858,"3.1":0,"3.2":0,"5.1":0,"6.1":0,"7.1":0,"9.1":0,"10.1":0,"11.1":0,"12.1":0,"13.1":0.61558},"edge":{"12":0,"13":0,"14":1.52963,"15":0,"16":0,"17":0,"18":4.906,"79":0,"80":0,"81":0,"83":0,"84":0,"85":0,"86":0},"android":{"3":0,"4":0,"81":null,"2.1":0,"2.2":0,"2.3":0,"4.1":0,"4.2-4.3":0,"4.4":0,"4.4.3-4.4.4":0},"samsung":{"4":0,"5.0-5.4":0,"6.2-6.4":0,"7.2-7.4":0,"8.2":0,"9.2":0,"10.1":0,"11.1-11.2":0,"12.0":0},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0,"7":0,"8":0,"9":0,"10":0,"11":18.71929,"5.5":0},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0},"and_qq":{"10.4":0},"and_uc":{"0":0},"op_mini":{"0":0},"and_chr":{"0":7.04917}},"total":99.70153}

/***/ },
/* 1387 */
/***/ function(module, exports) {

	module.exports = {"id":"as","name":"Asia","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":null,"3":null,"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":0.00401,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":0.00802,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":0.10824,"44":null,"45":null,"46":null,"47":0.00802,"48":0.00802,"49":null,"50":null,"51":null,"52":0.07617,"53":null,"54":null,"55":0.00401,"56":0.01604,"57":null,"58":null,"59":null,"60":0.00802,"61":null,"62":null,"63":0.00802,"64":0.00802,"65":0.00802,"66":0.00802,"67":0.00401,"68":0.01203,"69":0.00401,"70":0.00401,"71":null,"72":0.01604,"73":null,"74":0.00802,"75":0.00401,"76":0.00802,"77":0.01203,"78":0.05613,"79":0.02005,"80":0.05613,"81":1.56351,"82":0.2686,"83":0.02405,"84":null,"3.5":null,"3.6":null},"chrome":{"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":0.01604,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":0.01203,"23":null,"24":null,"25":null,"26":0.00401,"27":null,"28":null,"29":null,"30":null,"31":0.01604,"32":null,"33":null,"34":0.01203,"35":null,"36":null,"37":null,"38":0.03608,"39":null,"40":0.00802,"41":null,"42":0.00401,"43":0.00802,"44":null,"45":0.00802,"46":null,"47":0.00802,"48":0.01604,"49":0.17239,"50":0.00401,"51":0.00401,"52":null,"53":0.06414,"54":0.00401,"55":0.02005,"56":0.00802,"57":0.03207,"58":0.01604,"59":0.00802,"60":0.00802,"61":0.03608,"62":0.02405,"63":0.04009,"64":0.00802,"65":0.02405,"66":0.01203,"67":0.03207,"68":0.02405,"69":0.10824,"70":0.06414,"71":0.10423,"72":0.07216,"73":0.06414,"74":0.12829,"75":0.06815,"76":0.05613,"77":0.06014,"78":0.09622,"79":0.11626,"80":0.20446,"81":0.1323,"83":0.20045,"84":0.34077,"85":10.247,"86":16.18834,"87":0.03608,"88":0.02005,"89":null},"opera":{"9":null,"11":null,"12":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":0.00802,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":null,"51":null,"52":null,"53":null,"54":null,"55":null,"56":null,"57":null,"58":null,"60":null,"62":null,"63":null,"64":null,"65":null,"66":null,"67":null,"68":0.00802,"69":null,"70":0.06815,"71":0.47707,"72":0.01203,"9.5-9.6":null,"10.0-10.1":0,"10.5":null,"10.6":null,"11.1":null,"11.5":null,"11.6":null,"12.1":null},"ios_saf":{"8":0,"14":3.65177,"3.2":0.00875,"4.0-4.1":0.0075,"4.2-4.3":0.00125,"5.0-5.1":0.00625,"6.0-6.1":0.00375,"7.0-7.1":0.00875,"8.1-8.4":0.02874,"9.0-9.2":0.01625,"9.3":0.20746,"10.0-10.2":0.03499,"10.3":0.19246,"11.0-11.2":0.07249,"11.3-11.4":0.12373,"12.0-12.1":0.12622,"12.2-12.4":1.2585,"13.0-13.1":0.10373,"13.2":0.05124,"13.3":0.38992,"13.4-13.7":2.07708},"safari":{"0":null,"4":0,"5":null,"6":null,"7":null,"8":0.00401,"9":null,"10":null,"11":0.00802,"12":0.02405,"13":0.12829,"14":0.64946,"3.1":null,"3.2":null,"5.1":0.18842,"6.1":null,"7.1":null,"9.1":null,"10.1":0.01604,"11.1":0.04009,"12.1":0.09622,"13.1":0.85392},"edge":{"12":0.00802,"13":0.00401,"14":0.00802,"15":0.00401,"16":0.01203,"17":0.02806,"18":0.18842,"79":null,"80":null,"81":null,"83":null,"84":0.01203,"85":0.54522,"86":1.08644},"android":{"3":0,"4":0.05049,"81":null,"2.1":0,"2.2":0,"2.3":0.0004,"4.1":0.02545,"4.2-4.3":0.01131,"4.4":0,"4.4.3-4.4.4":0.0921},"samsung":{"4":0.42115,"5.0-5.4":0.02054,"6.2-6.4":0.02054,"7.2-7.4":0.12326,"8.2":0.02054,"9.2":0.17462,"10.1":0.11299,"11.1-11.2":0.26707,"12.0":2.57827},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":null,"7":null,"8":0.09891,"9":0.04565,"10":0.01522,"11":1.2554,"5.5":null},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0.0779},"baidu":{"0":null},"and_ff":{"0":0.1498},"and_qq":{"10.4":0.43742},"and_uc":{"0":2.59454},"op_mini":{"0":1.14591},"and_chr":{"0":44.49326}},"total":98.41205}

/***/ },
/* 1388 */
/***/ function(module, exports) {

	module.exports = {"id":"eu","name":"Europe","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":null,"3":null,"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":0.00561,"39":null,"40":null,"41":null,"42":null,"43":0.00561,"44":0.00561,"45":0.01682,"46":null,"47":0.01121,"48":0.02803,"49":0.00561,"50":0.01121,"51":0.01121,"52":0.16255,"53":0.00561,"54":0.00561,"55":0.00561,"56":0.03363,"57":0.01121,"58":0.00561,"59":0.01121,"60":0.02803,"61":0.00561,"62":0.01121,"63":0.01682,"64":0.01682,"65":0.01682,"66":0.02242,"67":0.01121,"68":0.07847,"69":0.01121,"70":0.01121,"71":0.00561,"72":0.03363,"73":0.01121,"74":0.01121,"75":0.01121,"76":0.01682,"77":0.03363,"78":0.25223,"79":0.05045,"80":0.18497,"81":4.35509,"82":0.65579,"83":0.01121,"84":null,"3.5":null,"3.6":null},"chrome":{"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":0.01682,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":0.00561,"35":null,"36":null,"37":null,"38":0.01682,"39":null,"40":0.01682,"41":null,"42":null,"43":0.00561,"44":null,"45":null,"46":0.00561,"47":0.01121,"48":0.01682,"49":0.37554,"50":0.01121,"51":0.01121,"52":0.01682,"53":0.02803,"54":0.03924,"55":0.00561,"56":0.01121,"57":0.01121,"58":0.01682,"59":0.01121,"60":0.02803,"61":0.05045,"62":0.01121,"63":0.02803,"64":0.02242,"65":0.04484,"66":0.03924,"67":0.03924,"68":0.02242,"69":0.10089,"70":0.10089,"71":0.13452,"72":0.11771,"73":0.06726,"74":0.06726,"75":0.07287,"76":0.07287,"77":0.06166,"78":0.08968,"79":0.14573,"80":0.2242,"81":0.14573,"83":0.27465,"84":0.46522,"85":13.25583,"86":18.98974,"87":0.02242,"88":0.01121,"89":null},"opera":{"9":null,"11":null,"12":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":0.01682,"37":null,"38":null,"39":null,"40":0.00561,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":null,"51":null,"52":null,"53":null,"54":null,"55":null,"56":null,"57":null,"58":0.00561,"60":null,"62":null,"63":null,"64":null,"65":null,"66":null,"67":null,"68":0.01682,"69":null,"70":0.20739,"71":1.68711,"72":0.03363,"9.5-9.6":null,"10.0-10.1":0,"10.5":null,"10.6":null,"11.1":null,"11.5":null,"11.6":null,"12.1":0.01121},"ios_saf":{"8":0,"14":5.72127,"3.2":0.01371,"4.0-4.1":0.01175,"4.2-4.3":0.00196,"5.0-5.1":0.00979,"6.0-6.1":0.00587,"7.0-7.1":0.01371,"8.1-8.4":0.04503,"9.0-9.2":0.02545,"9.3":0.32503,"10.0-10.2":0.05482,"10.3":0.30153,"11.0-11.2":0.11356,"11.3-11.4":0.19384,"12.0-12.1":0.19776,"12.2-12.4":1.97171,"13.0-13.1":0.16251,"13.2":0.08028,"13.3":0.6109,"13.4-13.7":3.2542},"safari":{"0":null,"4":0,"5":null,"6":null,"7":null,"8":0.00561,"9":0.00561,"10":0.01121,"11":0.02242,"12":0.05605,"13":0.31388,"14":2.15793,"3.1":null,"3.2":null,"5.1":0.05605,"6.1":null,"7.1":null,"9.1":0.01682,"10.1":0.04484,"11.1":0.14573,"12.1":0.24662,"13.1":2.43257},"edge":{"12":0.01121,"13":0.00561,"14":0.01121,"15":0.01121,"16":0.02242,"17":0.06166,"18":0.43159,"79":null,"80":null,"81":0.00561,"83":0.00561,"84":0.02242,"85":1.17705,"86":2.25882},"android":{"3":0,"4":0.02963,"81":null,"2.1":0,"2.2":0,"2.3":0.00024,"4.1":0.01493,"4.2-4.3":0.00664,"4.4":0,"4.4.3-4.4.4":0.05404},"samsung":{"4":0.12714,"5.0-5.4":0.02054,"6.2-6.4":0.02054,"7.2-7.4":0.0106,"8.2":0.0106,"9.2":0.07417,"10.1":0.05298,"11.1-11.2":0.13774,"12.0":3.32693},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0.03652,"7":0.01217,"8":0.0487,"9":0.02435,"10":0.01826,"11":0.99221,"5.5":null},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.29447},"and_qq":{"10.4":0.01319},"and_uc":{"0":0.14504},"op_mini":{"0":0.32871},"and_chr":{"0":26.54463}},"total":98.52811}

/***/ },
/* 1389 */
/***/ function(module, exports) {

	module.exports = {"id":"na","name":"North America","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":null,"3":null,"4":0.05361,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":0.01072,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":0.00536,"44":0.01608,"45":0.00536,"46":null,"47":0.00536,"48":0.01608,"49":null,"50":null,"51":null,"52":0.05361,"53":null,"54":0.00536,"55":null,"56":0.00536,"57":null,"58":null,"59":0.00536,"60":0.01072,"61":null,"62":null,"63":0.05361,"64":0.01072,"65":0.01072,"66":0.01072,"67":null,"68":0.03217,"69":null,"70":0.00536,"71":0.00536,"72":0.02144,"73":0.01072,"74":0.00536,"75":0.01072,"76":0.01072,"77":0.02144,"78":0.16619,"79":0.03217,"80":0.13403,"81":2.35884,"82":0.37527,"83":0.00536,"84":null,"3.5":null,"3.6":null},"chrome":{"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":0.01072,"30":null,"31":null,"32":null,"33":null,"34":null,"35":0.00536,"36":null,"37":null,"38":0.00536,"39":null,"40":0.02144,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":0.00536,"48":0.05361,"49":0.24125,"50":null,"51":null,"52":0.00536,"53":0.01608,"54":null,"55":null,"56":0.08042,"57":0.00536,"58":0.01072,"59":0.01072,"60":0.01072,"61":0.03217,"62":0.01072,"63":0.03753,"64":0.02681,"65":0.03753,"66":0.04289,"67":0.04825,"68":0.04289,"69":0.04825,"70":0.13403,"71":0.09114,"72":0.10186,"73":0.05897,"74":0.05897,"75":0.1233,"76":0.20372,"77":0.09114,"78":0.15547,"79":0.27341,"80":0.23588,"81":0.19836,"83":0.55218,"84":0.8524,"85":12.51257,"86":16.1795,"87":0.02681,"88":0.03753,"89":null},"opera":{"9":null,"11":null,"12":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":null,"51":null,"52":null,"53":null,"54":null,"55":null,"56":null,"57":null,"58":null,"60":null,"62":null,"63":null,"64":null,"65":null,"66":null,"67":null,"68":null,"69":null,"70":0.06969,"71":0.47713,"72":0.01608,"9.5-9.6":null,"10.0-10.1":0,"10.5":null,"10.6":null,"11.1":null,"11.5":null,"11.6":null,"12.1":null},"ios_saf":{"8":0,"14":10.16131,"3.2":0.02434,"4.0-4.1":0.02087,"4.2-4.3":0.00348,"5.0-5.1":0.01739,"6.0-6.1":0.01043,"7.0-7.1":0.02434,"8.1-8.4":0.07998,"9.0-9.2":0.04521,"9.3":0.57727,"10.0-10.2":0.09737,"10.3":0.53554,"11.0-11.2":0.2017,"11.3-11.4":0.34427,"12.0-12.1":0.35123,"12.2-12.4":3.50186,"13.0-13.1":0.28863,"13.2":0.14258,"13.3":1.08499,"13.4-13.7":5.77964},"safari":{"0":null,"4":0,"5":null,"6":null,"7":null,"8":0.01072,"9":0.01072,"10":0.00536,"11":0.02144,"12":0.05361,"13":0.33774,"14":2.70194,"3.1":null,"3.2":null,"5.1":0.06433,"6.1":null,"7.1":null,"9.1":0.11794,"10.1":0.07505,"11.1":0.193,"12.1":0.30022,"13.1":4.23519},"edge":{"12":0.00536,"13":0.00536,"14":0.01072,"15":0.01072,"16":0.01608,"17":0.0965,"18":0.38063,"79":null,"80":0.02681,"81":0.00536,"83":0.00536,"84":0.02144,"85":1.66191,"86":2.94855},"android":{"3":0,"4":0.02736,"81":null,"2.1":0,"2.2":0,"2.3":0.00022,"4.1":0.01379,"4.2-4.3":0.00613,"4.4":0,"4.4.3-4.4.4":0.04991},"samsung":{"4":0.0219,"5.0-5.4":0.02054,"6.2-6.4":0.02054,"7.2-7.4":0.01095,"8.2":0.0106,"9.2":0.04381,"10.1":0.0219,"11.1-11.2":0.09856,"12.0":2.20124},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0.00571,"7":0.00571,"8":0.05713,"9":0.71978,"10":0.01714,"11":1.28532,"5.5":null},"bb":{"7":0,"10":0.00464},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.35256},"and_qq":{"10.4":0.01392},"and_uc":{"0":0.11134},"op_mini":{"0":0.15372},"and_chr":{"0":20.54268}},"total":99.16515}

/***/ },
/* 1390 */
/***/ function(module, exports) {

	module.exports = {"id":"oc","name":"Oceania","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":null,"3":null,"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":0.01087,"49":null,"50":null,"51":null,"52":0.04892,"53":null,"54":null,"55":null,"56":0.01087,"57":null,"58":null,"59":null,"60":0.01087,"61":null,"62":null,"63":0.00544,"64":0.00544,"65":0.00544,"66":0.01631,"67":null,"68":0.02718,"69":null,"70":0.00544,"71":null,"72":0.01631,"73":0.00544,"74":0.00544,"75":0.00544,"76":0.01087,"77":0.01631,"78":0.13046,"79":0.03262,"80":0.14677,"81":2.22332,"82":0.34247,"83":0.00544,"84":null,"3.5":null,"3.6":null},"chrome":{"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":0.01087,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":0.01631,"35":null,"36":null,"37":null,"38":0.04349,"39":null,"40":0.01631,"41":null,"42":null,"43":null,"44":null,"45":null,"46":0.03805,"47":null,"48":0.00544,"49":0.28267,"50":null,"51":null,"52":null,"53":0.04892,"54":0.00544,"55":0.01087,"56":0.01087,"57":0.01631,"58":0.01087,"59":0.01631,"60":0.00544,"61":0.01087,"62":0.00544,"63":0.02174,"64":0.02174,"65":0.05436,"66":0.02174,"67":0.05436,"68":0.03805,"69":0.06523,"70":0.07067,"71":0.0761,"72":0.0761,"73":0.11416,"74":0.10328,"75":0.08698,"76":0.08154,"77":0.09241,"78":0.12503,"79":0.17939,"80":0.32616,"81":0.23918,"83":0.57622,"84":1.00022,"85":13.74764,"86":17.29192,"87":0.02718,"88":0.01087,"89":null},"opera":{"9":null,"11":null,"12":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":null,"51":null,"52":null,"53":null,"54":null,"55":null,"56":null,"57":null,"58":null,"60":null,"62":null,"63":null,"64":null,"65":null,"66":null,"67":null,"68":null,"69":null,"70":0.04892,"71":0.28811,"72":0.01087,"9.5-9.6":null,"10.0-10.1":0,"10.5":null,"10.6":null,"11.1":null,"11.5":null,"11.6":null,"12.1":null},"ios_saf":{"8":0,"14":9.38379,"3.2":0.02248,"4.0-4.1":0.01927,"4.2-4.3":0.00321,"5.0-5.1":0.01606,"6.0-6.1":0.00963,"7.0-7.1":0.02248,"8.1-8.4":0.07386,"9.0-9.2":0.04175,"9.3":0.5331,"10.0-10.2":0.08992,"10.3":0.49456,"11.0-11.2":0.18626,"11.3-11.4":0.31793,"12.0-12.1":0.32435,"12.2-12.4":3.23391,"13.0-13.1":0.26655,"13.2":0.13167,"13.3":1.00196,"13.4-13.7":5.33739},"safari":{"0":null,"4":0,"5":null,"6":null,"7":null,"8":0.00544,"9":null,"10":0.01087,"11":0.03805,"12":0.0761,"13":0.44032,"14":2.74518,"3.1":null,"3.2":null,"5.1":null,"6.1":null,"7.1":null,"9.1":0.02718,"10.1":0.08698,"11.1":0.19026,"12.1":0.35878,"13.1":4.59886},"edge":{"12":null,"13":null,"14":0.00544,"15":0.01087,"16":0.02174,"17":0.05436,"18":0.51098,"79":null,"80":0.00544,"81":0.00544,"83":0.00544,"84":0.02718,"85":1.27202,"86":2.40815},"android":{"3":0,"4":0.03718,"81":null,"2.1":0,"2.2":0,"2.3":0.0003,"4.1":0.01874,"4.2-4.3":0.00833,"4.4":0,"4.4.3-4.4.4":0.06781},"samsung":{"4":0.14316,"5.0-5.4":0.02054,"6.2-6.4":0.02054,"7.2-7.4":0.01095,"8.2":0.01101,"9.2":0.06607,"10.1":0.06607,"11.1-11.2":0.12113,"12.0":3.19354},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":null,"7":null,"8":null,"9":0.0088,"10":null,"11":1.58395,"5.5":null},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.33774},"and_qq":{"10.4":0.11866},"and_uc":{"0":0.21907},"op_mini":{"0":0.23765},"and_chr":{"0":20.0224}},"total":99.22117}

/***/ },
/* 1391 */
/***/ function(module, exports) {

	module.exports = {"id":"sa","name":"South America","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":null,"3":null,"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":0.00672,"49":null,"50":null,"51":null,"52":0.05378,"53":null,"54":null,"55":null,"56":null,"57":null,"58":null,"59":null,"60":0.00672,"61":null,"62":null,"63":0.00672,"64":0.00672,"65":0.01344,"66":0.01344,"67":null,"68":0.02689,"69":null,"70":null,"71":null,"72":0.01344,"73":null,"74":null,"75":null,"76":0.00672,"77":0.01344,"78":0.10083,"79":0.02017,"80":0.0605,"81":2.21154,"82":0.32938,"83":0.00672,"84":null,"3.5":null,"3.6":null},"chrome":{"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":0.01344,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":0.24199,"50":null,"51":null,"52":null,"53":0.02689,"54":null,"55":null,"56":0.02017,"57":null,"58":0.01344,"59":null,"60":null,"61":0.02689,"62":null,"63":0.02689,"64":null,"65":0.03361,"66":0.02017,"67":0.03361,"68":0.01344,"69":0.02689,"70":0.0605,"71":0.08066,"72":0.06722,"73":0.05378,"74":0.05378,"75":0.0605,"76":0.05378,"77":0.05378,"78":0.08739,"79":0.14116,"80":0.23527,"81":0.14788,"83":0.2756,"84":0.49071,"85":20.05845,"86":33.40834,"87":0.0605,"88":0.02689,"89":null},"opera":{"9":null,"11":null,"12":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":null,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":null,"51":null,"52":null,"53":null,"54":null,"55":null,"56":null,"57":null,"58":null,"60":null,"62":null,"63":null,"64":null,"65":null,"66":null,"67":null,"68":null,"69":null,"70":0.16133,"71":1.96282,"72":0.03361,"9.5-9.6":null,"10.0-10.1":0,"10.5":null,"10.6":null,"11.1":null,"11.5":null,"11.6":null,"12.1":null},"ios_saf":{"8":0,"14":1.52584,"3.2":0.00366,"4.0-4.1":0.00313,"4.2-4.3":0.00052,"5.0-5.1":0.00261,"6.0-6.1":0.00157,"7.0-7.1":0.00366,"8.1-8.4":0.01201,"9.0-9.2":0.00679,"9.3":0.08668,"10.0-10.2":0.01462,"10.3":0.08042,"11.0-11.2":0.03029,"11.3-11.4":0.0517,"12.0-12.1":0.05274,"12.2-12.4":0.52584,"13.0-13.1":0.04334,"13.2":0.02141,"13.3":0.16292,"13.4-13.7":0.86788},"safari":{"0":null,"4":0,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":0.00672,"12":0.02689,"13":0.121,"14":0.82681,"3.1":null,"3.2":null,"5.1":0.2756,"6.1":null,"7.1":null,"9.1":null,"10.1":0.01344,"11.1":0.06722,"12.1":0.12772,"13.1":0.77303},"edge":{"12":null,"13":null,"14":null,"15":null,"16":null,"17":0.02017,"18":0.10755,"79":null,"80":null,"81":null,"83":null,"84":0.01344,"85":0.87386,"86":1.65361},"android":{"3":0,"4":0.01105,"81":null,"2.1":0,"2.2":0,"2.3":0.00009,"4.1":0.00557,"4.2-4.3":0.00248,"4.4":0,"4.4.3-4.4.4":0.02015},"samsung":{"4":0.08546,"5.0-5.4":0.02054,"6.2-6.4":0.02054,"7.2-7.4":0.08546,"8.2":0.01101,"9.2":0.05341,"10.1":0.03205,"11.1-11.2":0.09614,"12.0":1.46349},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":null,"7":null,"8":0.05878,"9":0.00735,"10":0.00735,"11":0.24246,"5.5":null},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0},"kaios":{"2.5":0},"baidu":{"0":null},"and_ff":{"0":0.07867},"and_qq":{"10.4":0.00328},"and_uc":{"0":0.05573},"op_mini":{"0":0.12724},"and_chr":{"0":27.63109}},"total":99.49263}

/***/ },
/* 1392 */
/***/ function(module, exports) {

	module.exports = {"id":"ww","name":"Worldwide","month":"2020-10","access_date":"2020-11-03","data":{"firefox":{"2":null,"3":null,"4":0.01467,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":null,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":0.00489,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":0.04891,"44":0.00489,"45":0.00489,"46":null,"47":0.00978,"48":0.01467,"49":null,"50":null,"51":null,"52":0.09293,"53":null,"54":0.00489,"55":0.00489,"56":0.01956,"57":0.00489,"58":null,"59":0.00489,"60":0.01467,"61":null,"62":0.00489,"63":0.01956,"64":0.00978,"65":0.00978,"66":0.01467,"67":0.00489,"68":0.03913,"69":0.00489,"70":0.00489,"71":0.00489,"72":0.01956,"73":0.00489,"74":0.00978,"75":0.00978,"76":0.00978,"77":0.01956,"78":0.16629,"79":0.02935,"80":0.1076,"81":2.50908,"82":0.39617,"83":0.01467,"84":null,"3.5":null,"3.6":null},"chrome":{"4":null,"5":null,"6":null,"7":null,"8":null,"9":null,"10":null,"11":null,"12":null,"13":0.00978,"14":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":0.00978,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":0.00978,"32":null,"33":null,"34":0.00978,"35":null,"36":null,"37":null,"38":0.02446,"39":null,"40":0.00978,"41":null,"42":null,"43":0.00978,"44":null,"45":null,"46":0.00489,"47":0.00978,"48":0.01956,"49":0.24455,"50":0.00489,"51":0.00489,"52":0.00489,"53":0.03913,"54":0.01467,"55":0.00978,"56":0.02935,"57":0.01956,"58":0.01467,"59":0.00978,"60":0.01467,"61":0.03913,"62":0.01467,"63":0.03424,"64":0.01467,"65":0.03424,"66":0.02446,"67":0.03913,"68":0.02935,"69":0.08804,"70":0.08804,"71":0.1076,"72":0.08804,"73":0.06358,"74":0.09293,"75":0.07826,"76":0.09293,"77":0.06847,"78":0.1076,"79":0.1614,"80":0.22499,"81":0.15162,"83":0.30324,"84":0.50377,"85":12.1199,"86":17.92552,"87":0.03424,"88":0.01956,"89":null},"opera":{"9":null,"11":null,"12":null,"15":null,"16":null,"17":null,"18":null,"19":null,"20":null,"21":null,"22":null,"23":null,"24":null,"25":null,"26":null,"27":null,"28":null,"29":null,"30":null,"31":null,"32":null,"33":null,"34":null,"35":null,"36":0.00978,"37":null,"38":null,"39":null,"40":null,"41":null,"42":null,"43":null,"44":null,"45":null,"46":null,"47":null,"48":null,"49":null,"50":null,"51":null,"52":null,"53":null,"54":null,"55":null,"56":null,"57":null,"58":null,"60":null,"62":null,"63":null,"64":null,"65":null,"66":null,"67":null,"68":0.00978,"69":null,"70":0.12228,"71":0.92929,"72":0.01956,"9.5-9.6":null,"10.0-10.1":0,"10.5":null,"10.6":null,"11.1":null,"11.5":null,"11.6":null,"12.1":null},"ios_saf":{"8":0,"14":5.38701,"3.2":0.01291,"4.0-4.1":0.01106,"4.2-4.3":0.00184,"5.0-5.1":0.00922,"6.0-6.1":0.00553,"7.0-7.1":0.01291,"8.1-8.4":0.0424,"9.0-9.2":0.02397,"9.3":0.30604,"10.0-10.2":0.05162,"10.3":0.28391,"11.0-11.2":0.10693,"11.3-11.4":0.18252,"12.0-12.1":0.1862,"12.2-12.4":1.85651,"13.0-13.1":0.15302,"13.2":0.07559,"13.3":0.5752,"13.4-13.7":3.06407},"safari":{"0":null,"4":0,"5":null,"6":null,"7":null,"8":0.00489,"9":0.00489,"10":0.00489,"11":0.01467,"12":0.03913,"13":0.22499,"14":1.50154,"3.1":null,"3.2":null,"5.1":0.13695,"6.1":null,"7.1":null,"9.1":0.02935,"10.1":0.03913,"11.1":0.10271,"12.1":0.18097,"13.1":2.0102},"edge":{"12":0.00978,"13":0.00489,"14":0.00978,"15":0.00978,"16":0.01467,"17":0.04891,"18":0.29346,"79":null,"80":0.00978,"81":null,"83":0.00489,"84":0.01956,"85":0.97331,"86":1.82923},"android":{"3":0,"4":0.03731,"81":null,"2.1":0,"2.2":0,"2.3":0.0003,"4.1":0.01881,"4.2-4.3":0.00836,"4.4":0,"4.4.3-4.4.4":0.06806},"samsung":{"4":0.25177,"5.0-5.4":0.01049,"6.2-6.4":0.02091,"7.2-7.4":0.06294,"8.2":0.02098,"9.2":0.11539,"10.1":0.07343,"11.1-11.2":0.17833,"12.0":2.63306},"op_mob":{"0":null,"10":null,"11":null,"12":null,"11.1":null,"11.5":null,"12.1":null},"ie":{"6":0.01309,"7":null,"8":0.06544,"9":0.20942,"10":0.01963,"11":1.08635,"5.5":null},"bb":{"7":0,"10":0},"ie_mob":{"10":0,"11":0.02014},"kaios":{"2.5":0.03576},"baidu":{"0":null},"and_ff":{"0":0.22991},"and_qq":{"10.4":0.19925},"and_uc":{"0":1.21083},"op_mini":{"0":0.87547},"and_chr":{"0":33.5525}},"total":98.72055}

/***/ },
/* 1393 */
/***/ function(module, exports) {

	'use strict';
	var styles = module.exports;
	
	var codes = {
		reset: [0, 0],
	
		bold: [1, 22], // 21 isn't widely supported and 22 does the same thing
		dim: [2, 22],
		italic: [3, 23],
		underline: [4, 24],
		inverse: [7, 27],
		hidden: [8, 28],
		strikethrough: [9, 29],
	
		black: [30, 39],
		red: [31, 39],
		green: [32, 39],
		yellow: [33, 39],
		blue: [34, 39],
		magenta: [35, 39],
		cyan: [36, 39],
		white: [37, 39],
		gray: [90, 39],
	
		bgBlack: [40, 49],
		bgRed: [41, 49],
		bgGreen: [42, 49],
		bgYellow: [43, 49],
		bgBlue: [44, 49],
		bgMagenta: [45, 49],
		bgCyan: [46, 49],
		bgWhite: [47, 49]
	};
	
	Object.keys(codes).forEach(function (key) {
		var val = codes[key];
		var style = styles[key] = {};
		style.open = '\u001b[' + val[0] + 'm';
		style.close = '\u001b[' + val[1] + 'm';
	});


/***/ },
/* 1394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var escapeStringRegexp = __webpack_require__(422);
	var ansiStyles = __webpack_require__(1393);
	var stripAnsi = __webpack_require__(1396);
	var hasAnsi = __webpack_require__(1395);
	var supportsColor = __webpack_require__(1397);
	var defineProps = Object.defineProperties;
	var chalk = module.exports;
	
	function build(_styles) {
		var builder = function builder() {
			return applyStyle.apply(builder, arguments);
		};
		builder._styles = _styles;
		// __proto__ is used because we must return a function, but there is
		// no way to create a function with a different prototype.
		builder.__proto__ = proto;
		return builder;
	}
	
	var styles = (function () {
		var ret = {};
	
		ansiStyles.grey = ansiStyles.gray;
	
		Object.keys(ansiStyles).forEach(function (key) {
			ansiStyles[key].closeRe = new RegExp(escapeStringRegexp(ansiStyles[key].close), 'g');
	
			ret[key] = {
				get: function () {
					return build(this._styles.concat(key));
				}
			};
		});
	
		return ret;
	})();
	
	var proto = defineProps(function chalk() {}, styles);
	
	function applyStyle() {
		// support varags, but simply cast to string in case there's only one arg
		var args = arguments;
		var argsLen = args.length;
		var str = argsLen !== 0 && String(arguments[0]);
		if (argsLen > 1) {
			// don't slice `arguments`, it prevents v8 optimizations
			for (var a = 1; a < argsLen; a++) {
				str += ' ' + args[a];
			}
		}
	
		if (!chalk.enabled || !str) {
			return str;
		}
	
		/*jshint validthis: true*/
		var nestedStyles = this._styles;
	
		for (var i = 0; i < nestedStyles.length; i++) {
			var code = ansiStyles[nestedStyles[i]];
			// Replace any instances already present with a re-opening code
			// otherwise only the part of the string until said closing code
			// will be colored, and the rest will simply be 'plain'.
			str = code.open + str.replace(code.closeRe, code.open) + code.close;
		}
	
		return str;
	}
	
	function init() {
		var ret = {};
	
		Object.keys(styles).forEach(function (name) {
			ret[name] = {
				get: function () {
					return build([name]);
				}
			};
		});
	
		return ret;
	}
	
	defineProps(chalk, init());
	
	chalk.styles = ansiStyles;
	chalk.hasColor = hasAnsi;
	chalk.stripColor = stripAnsi;
	chalk.supportsColor = supportsColor;
	
	// detect mode if not set manually
	if (chalk.enabled === undefined) {
		chalk.enabled = chalk.supportsColor;
	}


/***/ },
/* 1395 */
[1783, 435],
/* 1396 */
[1784, 435],
/* 1397 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	module.exports = (function () {
		if (process.argv.indexOf('--no-color') !== -1) {
			return false;
		}
	
		if (process.argv.indexOf('--color') !== -1) {
			return true;
		}
	
		if (process.stdout && !process.stdout.isTTY) {
			return false;
		}
	
		if (process.platform === 'win32') {
			return true;
		}
	
		if ('COLORTERM' in process.env) {
			return true;
		}
	
		if (process.env.TERM === 'dumb') {
			return false;
		}
	
		if (/^screen|^xterm|^vt100|color|ansi|cygwin|linux/i.test(process.env.TERM)) {
			return true;
		}
	
		return false;
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(111)))

/***/ },
/* 1398 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./diff_match_patch_uncompressed": 293,
		"./diff_match_patch_uncompressed.js": 293
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1398;


/***/ },
/* 1399 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./annotated": 159,
		"./annotated.js": 159,
		"./base": 77,
		"./base.js": 77,
		"./console": 207,
		"./console.js": 207,
		"./html": 160,
		"./html.js": 160,
		"./index": 161,
		"./index.js": 161,
		"./jsonpatch": 162,
		"./jsonpatch.js": 162
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1399;


/***/ },
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1426),
	    hashDelete = __webpack_require__(1427),
	    hashGet = __webpack_require__(1428),
	    hashHas = __webpack_require__(1429),
	    hashSet = __webpack_require__(1430);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 1401 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1436),
	    listCacheDelete = __webpack_require__(1437),
	    listCacheGet = __webpack_require__(1438),
	    listCacheHas = __webpack_require__(1439),
	    listCacheSet = __webpack_require__(1440);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 1402 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(212),
	    root = __webpack_require__(165);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 1403 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(212),
	    root = __webpack_require__(165);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 1404 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 1405 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1417),
	    isArguments = __webpack_require__(447),
	    isArray = __webpack_require__(110),
	    isBuffer = __webpack_require__(1460),
	    isIndex = __webpack_require__(444),
	    isTypedArray = __webpack_require__(1461);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 1407 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 1408 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(1408),
	    baseIsNaN = __webpack_require__(1412),
	    strictIndexOf = __webpack_require__(1455);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 1410 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(303),
	    arrayIncludes = __webpack_require__(305),
	    arrayIncludesWith = __webpack_require__(306),
	    arrayMap = __webpack_require__(307),
	    baseUnary = __webpack_require__(308),
	    cacheHas = __webpack_require__(309);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * The base implementation of methods like `_.intersection`, without support
	 * for iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 */
	function baseIntersection(arrays, iteratee, comparator) {
	  var includes = comparator ? arrayIncludesWith : arrayIncludes,
	      length = arrays[0].length,
	      othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(othLength),
	      maxLength = Infinity,
	      result = [];
	
	  while (othIndex--) {
	    var array = arrays[othIndex];
	    if (othIndex && iteratee) {
	      array = arrayMap(array, baseUnary(iteratee));
	    }
	    maxLength = nativeMin(array.length, maxLength);
	    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	      ? new SetCache(othIndex && array)
	      : undefined;
	  }
	  array = arrays[0];
	
	  var index = -1,
	      seen = caches[0];
	
	  outer:
	  while (++index < length && result.length < maxLength) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (!(seen
	          ? cacheHas(seen, computed)
	          : includes(result, computed, comparator)
	        )) {
	      othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if (!(cache
	              ? cacheHas(cache, computed)
	              : includes(arrays[othIndex], computed, comparator))
	            ) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseIntersection;


/***/ },
/* 1411 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(210),
	    isObjectLike = __webpack_require__(167);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 1412 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ },
/* 1413 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(448),
	    isMasked = __webpack_require__(1434),
	    isObject = __webpack_require__(166),
	    toSource = __webpack_require__(1456);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 1414 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(210),
	    isLength = __webpack_require__(449),
	    isObjectLike = __webpack_require__(167);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 1415 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(166),
	    isPrototype = __webpack_require__(1435),
	    nativeKeysIn = __webpack_require__(1446);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 1416 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(1457),
	    defineProperty = __webpack_require__(1422),
	    identity = __webpack_require__(446);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 1417 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 1418 */
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(440),
	    baseFlatten = __webpack_require__(441),
	    baseUniq = __webpack_require__(442);
	
	/**
	 * The base implementation of methods like `_.xor`, without support for
	 * iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of values.
	 */
	function baseXor(arrays, iteratee, comparator) {
	  var length = arrays.length;
	  if (length < 2) {
	    return length ? baseUniq(arrays[0]) : [];
	  }
	  var index = -1,
	      result = Array(length);
	
	  while (++index < length) {
	    var array = arrays[index],
	        othIndex = -1;
	
	    while (++othIndex < length) {
	      if (othIndex != index) {
	        result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	      }
	    }
	  }
	  return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	}
	
	module.exports = baseXor;


/***/ },
/* 1419 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(214);
	
	/**
	 * Casts `value` to an empty array if it's not an array like object.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array|Object} Returns the cast array-like object.
	 */
	function castArrayLikeObject(value) {
	  return isArrayLikeObject(value) ? value : [];
	}
	
	module.exports = castArrayLikeObject;


/***/ },
/* 1420 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(165);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 1421 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(1403),
	    noop = __webpack_require__(450),
	    setToArray = __webpack_require__(445);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ },
/* 1422 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(212);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 1423 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(1449);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 1424 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(304);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 1425 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 1426 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(213);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 1427 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 1428 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(213);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 1429 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(213);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 1430 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(213);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 1431 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(304),
	    isArguments = __webpack_require__(447),
	    isArray = __webpack_require__(110);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 1432 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(310),
	    isArrayLike = __webpack_require__(311),
	    isIndex = __webpack_require__(444),
	    isObject = __webpack_require__(166);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 1433 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 1434 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1420);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 1435 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 1436 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 1437 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(209);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 1438 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(209);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 1439 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(209);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 1440 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(209);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 1441 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1400),
	    ListCache = __webpack_require__(1401),
	    Map = __webpack_require__(1402);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 1442 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(211);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 1443 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(211);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 1444 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(211);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 1445 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(211);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 1446 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 1447 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(443);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(138)(module)))

/***/ },
/* 1448 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 1449 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 1450 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(1404);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 1451 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 1452 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 1453 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(1416),
	    shortOut = __webpack_require__(1454);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 1454 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 1455 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ },
/* 1456 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 1457 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 1458 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(164),
	    eq = __webpack_require__(310),
	    isIterateeCall = __webpack_require__(1432),
	    keysIn = __webpack_require__(1462);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own and inherited enumerable string keyed properties of source
	 * objects to the destination object for all destination properties that
	 * resolve to `undefined`. Source objects are applied from left to right.
	 * Once a property is set, additional values of the same property are ignored.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.defaultsDeep
	 * @example
	 *
	 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var defaults = baseRest(function(object, sources) {
	  object = Object(object);
	
	  var index = -1;
	  var length = sources.length;
	  var guard = length > 2 ? sources[2] : undefined;
	
	  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	    length = 1;
	  }
	
	  while (++index < length) {
	    var source = sources[index];
	    var props = keysIn(source);
	    var propsIndex = -1;
	    var propsLength = props.length;
	
	    while (++propsIndex < propsLength) {
	      var key = props[propsIndex];
	      var value = object[key];
	
	      if (value === undefined ||
	          (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        object[key] = source[key];
	      }
	    }
	  }
	
	  return object;
	});
	
	module.exports = defaults;


/***/ },
/* 1459 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(307),
	    baseIntersection = __webpack_require__(1410),
	    baseRest = __webpack_require__(164),
	    castArrayLikeObject = __webpack_require__(1419);
	
	/**
	 * Creates an array of unique values that are included in all given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of intersecting values.
	 * @example
	 *
	 * _.intersection([2, 1], [2, 3]);
	 * // => [2]
	 */
	var intersection = baseRest(function(arrays) {
	  var mapped = arrayMap(arrays, castArrayLikeObject);
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped)
	    : [];
	});
	
	module.exports = intersection;


/***/ },
/* 1460 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(165),
	    stubFalse = __webpack_require__(1464);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(138)(module)))

/***/ },
/* 1461 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1414),
	    baseUnary = __webpack_require__(308),
	    nodeUtil = __webpack_require__(1447);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 1462 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(1406),
	    baseKeysIn = __webpack_require__(1415),
	    isArrayLike = __webpack_require__(311);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 1463 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(439);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 1464 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 1465 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(441),
	    baseRest = __webpack_require__(164),
	    baseUniq = __webpack_require__(442),
	    isArrayLikeObject = __webpack_require__(214);
	
	/**
	 * Creates an array of unique values, in order, from all given arrays using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * _.union([2], [1, 2]);
	 * // => [2, 1]
	 */
	var union = baseRest(function(arrays) {
	  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	});
	
	module.exports = union;


/***/ },
/* 1466 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(1405),
	    baseRest = __webpack_require__(164),
	    baseXor = __webpack_require__(1418),
	    isArrayLikeObject = __webpack_require__(214);
	
	/**
	 * Creates an array of unique values that is the
	 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	 * of the given arrays. The order of result values is determined by the order
	 * they occur in the arrays.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.difference, _.without
	 * @example
	 *
	 * _.xor([2, 1], [2, 3]);
	 * // => [1, 3]
	 */
	var xor = baseRest(function(arrays) {
	  return baseXor(arrayFilter(arrays, isArrayLikeObject));
	});
	
	module.exports = xor;


/***/ },
/* 1467 */
731,
/* 1468 */
/***/ function(module, exports) {

	'use strict';
	module.exports = {
	  wrap: wrapRange,
	  limit: limitRange,
	  validate: validateRange,
	  test: testRange,
	  curry: curry,
	  name: name
	};
	
	function wrapRange(min, max, value) {
	  var maxLessMin = max - min;
	  return ((value - min) % maxLessMin + maxLessMin) % maxLessMin + min;
	}
	
	function limitRange(min, max, value) {
	  return Math.max(min, Math.min(max, value));
	}
	
	function validateRange(min, max, value, minExclusive, maxExclusive) {
	  if (!testRange(min, max, value, minExclusive, maxExclusive)) {
	    throw new Error(value + ' is outside of range [' + min + ',' + max + ')');
	  }
	  return value;
	}
	
	function testRange(min, max, value, minExclusive, maxExclusive) {
	  return !(
	       value < min ||
	       value > max ||
	       (maxExclusive && (value === max)) ||
	       (minExclusive && (value === min))
	  );
	}
	
	function name(min, max, minExcl, maxExcl) {
	  return (minExcl ? '(' : '[') + min + ',' + max + (maxExcl ? ')' : ']');
	}
	
	function curry(min, max, minExclusive, maxExclusive) {
	  var boundNameFn = name.bind(null, min, max, minExclusive, maxExclusive);
	  return {
	    wrap: wrapRange.bind(null, min, max),
	    limit: limitRange.bind(null, min, max),
	    validate: function(value) {
	      return validateRange(min, max, value, minExclusive, maxExclusive);
	    },
	    test: function(value) {
	      return testRange(min, max, value, minExclusive, maxExclusive);
	    },
	    toString: boundNameFn,
	    name: boundNameFn
	  };
	}


/***/ },
/* 1469 */
/***/ function(module, exports) {

	'use strict'
	
	var abs = Math.abs
	var round = Math.round
	
	function almostEq(a, b) {
	  return abs(a - b) <= 9.5367432e-7
	}
	
	//最大公约数 Greatest Common Divisor
	function GCD(a, b) {
	  if (almostEq(b, 0)) return a
	  return GCD(b, a % b)
	}
	
	function findPrecision(n) {
	  var e = 1
	
	  while (!almostEq(round(n * e) / e, n)) {
	    e *= 10
	  }
	
	  return e
	}
	
	function num2fraction(num) {
	  if (num === 0 || num === '0') return '0'
	
	  if (typeof num === 'string') {
	    num = parseFloat(num)
	  }
	
	
	  var precision = findPrecision(num) //精确度
	  var number = num * precision
	  var gcd = abs(GCD(number, precision))
	
	  //分子
	  var numerator = number / gcd
	  //分母
	  var denominator = precision / gcd
	
	  //分数
	  return round(numerator) + '/' + round(denominator)
	}
	
	module.exports = num2fraction
	


/***/ },
/* 1470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(152);
	var callBind = __webpack_require__(688);
	
	var implementation = __webpack_require__(452);
	var getPolyfill = __webpack_require__(453);
	var shim = __webpack_require__(1471);
	
	var polyfill = callBind(getPolyfill(), Object);
	
	define(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = polyfill;


/***/ },
/* 1471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getPolyfill = __webpack_require__(453);
	var define = __webpack_require__(152);
	
	module.exports = function shimObjectIs() {
		var polyfill = getPolyfill();
		define(Object, { is: polyfill }, {
			is: function testObjectIs() {
				return Object.is !== polyfill;
			}
		});
		return polyfill;
	};


/***/ },
/* 1472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(455); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ },
/* 1473 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*!
	 * Platform.js v1.3.6
	 * Copyright 2014-2020 Benjamin Tan
	 * Copyright 2011-2013 John-David Dalton
	 * Available under MIT license
	 */
	;(function() {
	  'use strict';
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used as a reference to the global object. */
	  var root = (objectTypes[typeof window] && window) || this;
	
	  /** Backup possible global object. */
	  var oldRoot = root;
	
	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect free variable `global` from Node.js or Browserified code and use it as `root`. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global;
	  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) {
	    root = freeGlobal;
	  }
	
	  /**
	   * Used as the maximum length of an array-like object.
	   * See the [ES6 spec](http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
	   * for more details.
	   */
	  var maxSafeInteger = Math.pow(2, 53) - 1;
	
	  /** Regular expression to detect Opera. */
	  var reOpera = /\bOpera/;
	
	  /** Possible global object. */
	  var thisBinding = this;
	
	  /** Used for native method references. */
	  var objectProto = Object.prototype;
	
	  /** Used to check for own properties of an object. */
	  var hasOwnProperty = objectProto.hasOwnProperty;
	
	  /** Used to resolve the internal `[[Class]]` of values. */
	  var toString = objectProto.toString;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Capitalizes a string value.
	   *
	   * @private
	   * @param {string} string The string to capitalize.
	   * @returns {string} The capitalized string.
	   */
	  function capitalize(string) {
	    string = String(string);
	    return string.charAt(0).toUpperCase() + string.slice(1);
	  }
	
	  /**
	   * A utility function to clean up the OS name.
	   *
	   * @private
	   * @param {string} os The OS name to clean up.
	   * @param {string} [pattern] A `RegExp` pattern matching the OS name.
	   * @param {string} [label] A label for the OS.
	   */
	  function cleanupOS(os, pattern, label) {
	    // Platform tokens are defined at:
	    // http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
	    // http://web.archive.org/web/20081122053950/http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
	    var data = {
	      '10.0': '10',
	      '6.4':  '10 Technical Preview',
	      '6.3':  '8.1',
	      '6.2':  '8',
	      '6.1':  'Server 2008 R2 / 7',
	      '6.0':  'Server 2008 / Vista',
	      '5.2':  'Server 2003 / XP 64-bit',
	      '5.1':  'XP',
	      '5.01': '2000 SP1',
	      '5.0':  '2000',
	      '4.0':  'NT',
	      '4.90': 'ME'
	    };
	    // Detect Windows version from platform tokens.
	    if (pattern && label && /^Win/i.test(os) && !/^Windows Phone /i.test(os) &&
	        (data = data[/[\d.]+$/.exec(os)])) {
	      os = 'Windows ' + data;
	    }
	    // Correct character case and cleanup string.
	    os = String(os);
	
	    if (pattern && label) {
	      os = os.replace(RegExp(pattern, 'i'), label);
	    }
	
	    os = format(
	      os.replace(/ ce$/i, ' CE')
	        .replace(/\bhpw/i, 'web')
	        .replace(/\bMacintosh\b/, 'Mac OS')
	        .replace(/_PowerPC\b/i, ' OS')
	        .replace(/\b(OS X) [^ \d]+/i, '$1')
	        .replace(/\bMac (OS X)\b/, '$1')
	        .replace(/\/(\d)/, ' $1')
	        .replace(/_/g, '.')
	        .replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, '')
	        .replace(/\bx86\.64\b/gi, 'x86_64')
	        .replace(/\b(Windows Phone) OS\b/, '$1')
	        .replace(/\b(Chrome OS \w+) [\d.]+\b/, '$1')
	        .split(' on ')[0]
	    );
	
	    return os;
	  }
	
	  /**
	   * An iteration utility for arrays and objects.
	   *
	   * @private
	   * @param {Array|Object} object The object to iterate over.
	   * @param {Function} callback The function called per iteration.
	   */
	  function each(object, callback) {
	    var index = -1,
	        length = object ? object.length : 0;
	
	    if (typeof length == 'number' && length > -1 && length <= maxSafeInteger) {
	      while (++index < length) {
	        callback(object[index], index, object);
	      }
	    } else {
	      forOwn(object, callback);
	    }
	  }
	
	  /**
	   * Trim and conditionally capitalize string values.
	   *
	   * @private
	   * @param {string} string The string to format.
	   * @returns {string} The formatted string.
	   */
	  function format(string) {
	    string = trim(string);
	    return /^(?:webOS|i(?:OS|P))/.test(string)
	      ? string
	      : capitalize(string);
	  }
	
	  /**
	   * Iterates over an object's own properties, executing the `callback` for each.
	   *
	   * @private
	   * @param {Object} object The object to iterate over.
	   * @param {Function} callback The function executed per own property.
	   */
	  function forOwn(object, callback) {
	    for (var key in object) {
	      if (hasOwnProperty.call(object, key)) {
	        callback(object[key], key, object);
	      }
	    }
	  }
	
	  /**
	   * Gets the internal `[[Class]]` of a value.
	   *
	   * @private
	   * @param {*} value The value.
	   * @returns {string} The `[[Class]]`.
	   */
	  function getClassOf(value) {
	    return value == null
	      ? capitalize(value)
	      : toString.call(value).slice(8, -1);
	  }
	
	  /**
	   * Host objects can return type values that are different from their actual
	   * data type. The objects we are concerned with usually return non-primitive
	   * types of "object", "function", or "unknown".
	   *
	   * @private
	   * @param {*} object The owner of the property.
	   * @param {string} property The property to check.
	   * @returns {boolean} Returns `true` if the property value is a non-primitive, else `false`.
	   */
	  function isHostType(object, property) {
	    var type = object != null ? typeof object[property] : 'number';
	    return !/^(?:boolean|number|string|undefined)$/.test(type) &&
	      (type == 'object' ? !!object[property] : true);
	  }
	
	  /**
	   * Prepares a string for use in a `RegExp` by making hyphens and spaces optional.
	   *
	   * @private
	   * @param {string} string The string to qualify.
	   * @returns {string} The qualified string.
	   */
	  function qualify(string) {
	    return String(string).replace(/([ -])(?!$)/g, '$1?');
	  }
	
	  /**
	   * A bare-bones `Array#reduce` like utility function.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} callback The function called per iteration.
	   * @returns {*} The accumulated result.
	   */
	  function reduce(array, callback) {
	    var accumulator = null;
	    each(array, function(value, index) {
	      accumulator = callback(accumulator, value, index, array);
	    });
	    return accumulator;
	  }
	
	  /**
	   * Removes leading and trailing whitespace from a string.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} The trimmed string.
	   */
	  function trim(string) {
	    return String(string).replace(/^ +| +$/g, '');
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Creates a new platform object.
	   *
	   * @memberOf platform
	   * @param {Object|string} [ua=navigator.userAgent] The user agent string or
	   *  context object.
	   * @returns {Object} A platform object.
	   */
	  function parse(ua) {
	
	    /** The environment context object. */
	    var context = root;
	
	    /** Used to flag when a custom context is provided. */
	    var isCustomContext = ua && typeof ua == 'object' && getClassOf(ua) != 'String';
	
	    // Juggle arguments.
	    if (isCustomContext) {
	      context = ua;
	      ua = null;
	    }
	
	    /** Browser navigator object. */
	    var nav = context.navigator || {};
	
	    /** Browser user agent string. */
	    var userAgent = nav.userAgent || '';
	
	    ua || (ua = userAgent);
	
	    /** Used to flag when `thisBinding` is the [ModuleScope]. */
	    var isModuleScope = isCustomContext || thisBinding == oldRoot;
	
	    /** Used to detect if browser is like Chrome. */
	    var likeChrome = isCustomContext
	      ? !!nav.likeChrome
	      : /\bChrome\b/.test(ua) && !/internal|\n/i.test(toString.toString());
	
	    /** Internal `[[Class]]` value shortcuts. */
	    var objectClass = 'Object',
	        airRuntimeClass = isCustomContext ? objectClass : 'ScriptBridgingProxyObject',
	        enviroClass = isCustomContext ? objectClass : 'Environment',
	        javaClass = (isCustomContext && context.java) ? 'JavaPackage' : getClassOf(context.java),
	        phantomClass = isCustomContext ? objectClass : 'RuntimeObject';
	
	    /** Detect Java environments. */
	    var java = /\bJava/.test(javaClass) && context.java;
	
	    /** Detect Rhino. */
	    var rhino = java && getClassOf(context.environment) == enviroClass;
	
	    /** A character to represent alpha. */
	    var alpha = java ? 'a' : '\u03b1';
	
	    /** A character to represent beta. */
	    var beta = java ? 'b' : '\u03b2';
	
	    /** Browser document object. */
	    var doc = context.document || {};
	
	    /**
	     * Detect Opera browser (Presto-based).
	     * http://www.howtocreate.co.uk/operaStuff/operaObject.html
	     * http://dev.opera.com/articles/view/opera-mini-web-content-authoring-guidelines/#operamini
	     */
	    var opera = context.operamini || context.opera;
	
	    /** Opera `[[Class]]`. */
	    var operaClass = reOpera.test(operaClass = (isCustomContext && opera) ? opera['[[Class]]'] : getClassOf(opera))
	      ? operaClass
	      : (opera = null);
	
	    /*------------------------------------------------------------------------*/
	
	    /** Temporary variable used over the script's lifetime. */
	    var data;
	
	    /** The CPU architecture. */
	    var arch = ua;
	
	    /** Platform description array. */
	    var description = [];
	
	    /** Platform alpha/beta indicator. */
	    var prerelease = null;
	
	    /** A flag to indicate that environment features should be used to resolve the platform. */
	    var useFeatures = ua == userAgent;
	
	    /** The browser/environment version. */
	    var version = useFeatures && opera && typeof opera.version == 'function' && opera.version();
	
	    /** A flag to indicate if the OS ends with "/ Version" */
	    var isSpecialCasedOS;
	
	    /* Detectable layout engines (order is important). */
	    var layout = getLayout([
	      { 'label': 'EdgeHTML', 'pattern': 'Edge' },
	      'Trident',
	      { 'label': 'WebKit', 'pattern': 'AppleWebKit' },
	      'iCab',
	      'Presto',
	      'NetFront',
	      'Tasman',
	      'KHTML',
	      'Gecko'
	    ]);
	
	    /* Detectable browser names (order is important). */
	    var name = getName([
	      'Adobe AIR',
	      'Arora',
	      'Avant Browser',
	      'Breach',
	      'Camino',
	      'Electron',
	      'Epiphany',
	      'Fennec',
	      'Flock',
	      'Galeon',
	      'GreenBrowser',
	      'iCab',
	      'Iceweasel',
	      'K-Meleon',
	      'Konqueror',
	      'Lunascape',
	      'Maxthon',
	      { 'label': 'Microsoft Edge', 'pattern': '(?:Edge|Edg|EdgA|EdgiOS)' },
	      'Midori',
	      'Nook Browser',
	      'PaleMoon',
	      'PhantomJS',
	      'Raven',
	      'Rekonq',
	      'RockMelt',
	      { 'label': 'Samsung Internet', 'pattern': 'SamsungBrowser' },
	      'SeaMonkey',
	      { 'label': 'Silk', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
	      'Sleipnir',
	      'SlimBrowser',
	      { 'label': 'SRWare Iron', 'pattern': 'Iron' },
	      'Sunrise',
	      'Swiftfox',
	      'Vivaldi',
	      'Waterfox',
	      'WebPositive',
	      { 'label': 'Yandex Browser', 'pattern': 'YaBrowser' },
	      { 'label': 'UC Browser', 'pattern': 'UCBrowser' },
	      'Opera Mini',
	      { 'label': 'Opera Mini', 'pattern': 'OPiOS' },
	      'Opera',
	      { 'label': 'Opera', 'pattern': 'OPR' },
	      'Chromium',
	      'Chrome',
	      { 'label': 'Chrome', 'pattern': '(?:HeadlessChrome)' },
	      { 'label': 'Chrome Mobile', 'pattern': '(?:CriOS|CrMo)' },
	      { 'label': 'Firefox', 'pattern': '(?:Firefox|Minefield)' },
	      { 'label': 'Firefox for iOS', 'pattern': 'FxiOS' },
	      { 'label': 'IE', 'pattern': 'IEMobile' },
	      { 'label': 'IE', 'pattern': 'MSIE' },
	      'Safari'
	    ]);
	
	    /* Detectable products (order is important). */
	    var product = getProduct([
	      { 'label': 'BlackBerry', 'pattern': 'BB10' },
	      'BlackBerry',
	      { 'label': 'Galaxy S', 'pattern': 'GT-I9000' },
	      { 'label': 'Galaxy S2', 'pattern': 'GT-I9100' },
	      { 'label': 'Galaxy S3', 'pattern': 'GT-I9300' },
	      { 'label': 'Galaxy S4', 'pattern': 'GT-I9500' },
	      { 'label': 'Galaxy S5', 'pattern': 'SM-G900' },
	      { 'label': 'Galaxy S6', 'pattern': 'SM-G920' },
	      { 'label': 'Galaxy S6 Edge', 'pattern': 'SM-G925' },
	      { 'label': 'Galaxy S7', 'pattern': 'SM-G930' },
	      { 'label': 'Galaxy S7 Edge', 'pattern': 'SM-G935' },
	      'Google TV',
	      'Lumia',
	      'iPad',
	      'iPod',
	      'iPhone',
	      'Kindle',
	      { 'label': 'Kindle Fire', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
	      'Nexus',
	      'Nook',
	      'PlayBook',
	      'PlayStation Vita',
	      'PlayStation',
	      'TouchPad',
	      'Transformer',
	      { 'label': 'Wii U', 'pattern': 'WiiU' },
	      'Wii',
	      'Xbox One',
	      { 'label': 'Xbox 360', 'pattern': 'Xbox' },
	      'Xoom'
	    ]);
	
	    /* Detectable manufacturers. */
	    var manufacturer = getManufacturer({
	      'Apple': { 'iPad': 1, 'iPhone': 1, 'iPod': 1 },
	      'Alcatel': {},
	      'Archos': {},
	      'Amazon': { 'Kindle': 1, 'Kindle Fire': 1 },
	      'Asus': { 'Transformer': 1 },
	      'Barnes & Noble': { 'Nook': 1 },
	      'BlackBerry': { 'PlayBook': 1 },
	      'Google': { 'Google TV': 1, 'Nexus': 1 },
	      'HP': { 'TouchPad': 1 },
	      'HTC': {},
	      'Huawei': {},
	      'Lenovo': {},
	      'LG': {},
	      'Microsoft': { 'Xbox': 1, 'Xbox One': 1 },
	      'Motorola': { 'Xoom': 1 },
	      'Nintendo': { 'Wii U': 1,  'Wii': 1 },
	      'Nokia': { 'Lumia': 1 },
	      'Oppo': {},
	      'Samsung': { 'Galaxy S': 1, 'Galaxy S2': 1, 'Galaxy S3': 1, 'Galaxy S4': 1 },
	      'Sony': { 'PlayStation': 1, 'PlayStation Vita': 1 },
	      'Xiaomi': { 'Mi': 1, 'Redmi': 1 }
	    });
	
	    /* Detectable operating systems (order is important). */
	    var os = getOS([
	      'Windows Phone',
	      'KaiOS',
	      'Android',
	      'CentOS',
	      { 'label': 'Chrome OS', 'pattern': 'CrOS' },
	      'Debian',
	      { 'label': 'DragonFly BSD', 'pattern': 'DragonFly' },
	      'Fedora',
	      'FreeBSD',
	      'Gentoo',
	      'Haiku',
	      'Kubuntu',
	      'Linux Mint',
	      'OpenBSD',
	      'Red Hat',
	      'SuSE',
	      'Ubuntu',
	      'Xubuntu',
	      'Cygwin',
	      'Symbian OS',
	      'hpwOS',
	      'webOS ',
	      'webOS',
	      'Tablet OS',
	      'Tizen',
	      'Linux',
	      'Mac OS X',
	      'Macintosh',
	      'Mac',
	      'Windows 98;',
	      'Windows '
	    ]);
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Picks the layout engine from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected layout engine.
	     */
	    function getLayout(guesses) {
	      return reduce(guesses, function(result, guess) {
	        return result || RegExp('\\b' + (
	          guess.pattern || qualify(guess)
	        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
	      });
	    }
	
	    /**
	     * Picks the manufacturer from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An object of guesses.
	     * @returns {null|string} The detected manufacturer.
	     */
	    function getManufacturer(guesses) {
	      return reduce(guesses, function(result, value, key) {
	        // Lookup the manufacturer by product or scan the UA for the manufacturer.
	        return result || (
	          value[product] ||
	          value[/^[a-z]+(?: +[a-z]+\b)*/i.exec(product)] ||
	          RegExp('\\b' + qualify(key) + '(?:\\b|\\w*\\d)', 'i').exec(ua)
	        ) && key;
	      });
	    }
	
	    /**
	     * Picks the browser name from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected browser name.
	     */
	    function getName(guesses) {
	      return reduce(guesses, function(result, guess) {
	        return result || RegExp('\\b' + (
	          guess.pattern || qualify(guess)
	        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
	      });
	    }
	
	    /**
	     * Picks the OS name from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected OS name.
	     */
	    function getOS(guesses) {
	      return reduce(guesses, function(result, guess) {
	        var pattern = guess.pattern || qualify(guess);
	        if (!result && (result =
	              RegExp('\\b' + pattern + '(?:/[\\d.]+|[ \\w.]*)', 'i').exec(ua)
	            )) {
	          result = cleanupOS(result, pattern, guess.label || guess);
	        }
	        return result;
	      });
	    }
	
	    /**
	     * Picks the product name from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected product name.
	     */
	    function getProduct(guesses) {
	      return reduce(guesses, function(result, guess) {
	        var pattern = guess.pattern || qualify(guess);
	        if (!result && (result =
	              RegExp('\\b' + pattern + ' *\\d+[.\\w_]*', 'i').exec(ua) ||
	              RegExp('\\b' + pattern + ' *\\w+-[\\w]*', 'i').exec(ua) ||
	              RegExp('\\b' + pattern + '(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)', 'i').exec(ua)
	            )) {
	          // Split by forward slash and append product version if needed.
	          if ((result = String((guess.label && !RegExp(pattern, 'i').test(guess.label)) ? guess.label : result).split('/'))[1] && !/[\d.]+/.test(result[0])) {
	            result[0] += ' ' + result[1];
	          }
	          // Correct character case and cleanup string.
	          guess = guess.label || guess;
	          result = format(result[0]
	            .replace(RegExp(pattern, 'i'), guess)
	            .replace(RegExp('; *(?:' + guess + '[_-])?', 'i'), ' ')
	            .replace(RegExp('(' + guess + ')[-_.]?(\\w)', 'i'), '$1 $2'));
	        }
	        return result;
	      });
	    }
	
	    /**
	     * Resolves the version using an array of UA patterns.
	     *
	     * @private
	     * @param {Array} patterns An array of UA patterns.
	     * @returns {null|string} The detected version.
	     */
	    function getVersion(patterns) {
	      return reduce(patterns, function(result, pattern) {
	        return result || (RegExp(pattern +
	          '(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)', 'i').exec(ua) || 0)[1] || null;
	      });
	    }
	
	    /**
	     * Returns `platform.description` when the platform object is coerced to a string.
	     *
	     * @name toString
	     * @memberOf platform
	     * @returns {string} Returns `platform.description` if available, else an empty string.
	     */
	    function toStringPlatform() {
	      return this.description || '';
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Convert layout to an array so we can add extra details.
	    layout && (layout = [layout]);
	
	    // Detect Android products.
	    // Browsers on Android devices typically provide their product IDS after "Android;"
	    // up to "Build" or ") AppleWebKit".
	    // Example:
	    // "Mozilla/5.0 (Linux; Android 8.1.0; Moto G (5) Plus) AppleWebKit/537.36
	    // (KHTML, like Gecko) Chrome/70.0.3538.80 Mobile Safari/537.36"
	    if (/\bAndroid\b/.test(os) && !product &&
	        (data = /\bAndroid[^;]*;(.*?)(?:Build|\) AppleWebKit)\b/i.exec(ua))) {
	      product = trim(data[1])
	        // Replace any language codes (eg. "en-US").
	        .replace(/^[a-z]{2}-[a-z]{2};\s*/i, '')
	        || null;
	    }
	    // Detect product names that contain their manufacturer's name.
	    if (manufacturer && !product) {
	      product = getProduct([manufacturer]);
	    } else if (manufacturer && product) {
	      product = product
	        .replace(RegExp('^(' + qualify(manufacturer) + ')[-_.\\s]', 'i'), manufacturer + ' ')
	        .replace(RegExp('^(' + qualify(manufacturer) + ')[-_.]?(\\w)', 'i'), manufacturer + ' $2');
	    }
	    // Clean up Google TV.
	    if ((data = /\bGoogle TV\b/.exec(product))) {
	      product = data[0];
	    }
	    // Detect simulators.
	    if (/\bSimulator\b/i.test(ua)) {
	      product = (product ? product + ' ' : '') + 'Simulator';
	    }
	    // Detect Opera Mini 8+ running in Turbo/Uncompressed mode on iOS.
	    if (name == 'Opera Mini' && /\bOPiOS\b/.test(ua)) {
	      description.push('running in Turbo/Uncompressed mode');
	    }
	    // Detect IE Mobile 11.
	    if (name == 'IE' && /\blike iPhone OS\b/.test(ua)) {
	      data = parse(ua.replace(/like iPhone OS/, ''));
	      manufacturer = data.manufacturer;
	      product = data.product;
	    }
	    // Detect iOS.
	    else if (/^iP/.test(product)) {
	      name || (name = 'Safari');
	      os = 'iOS' + ((data = / OS ([\d_]+)/i.exec(ua))
	        ? ' ' + data[1].replace(/_/g, '.')
	        : '');
	    }
	    // Detect Kubuntu.
	    else if (name == 'Konqueror' && /^Linux\b/i.test(os)) {
	      os = 'Kubuntu';
	    }
	    // Detect Android browsers.
	    else if ((manufacturer && manufacturer != 'Google' &&
	        ((/Chrome/.test(name) && !/\bMobile Safari\b/i.test(ua)) || /\bVita\b/.test(product))) ||
	        (/\bAndroid\b/.test(os) && /^Chrome/.test(name) && /\bVersion\//i.test(ua))) {
	      name = 'Android Browser';
	      os = /\bAndroid\b/.test(os) ? os : 'Android';
	    }
	    // Detect Silk desktop/accelerated modes.
	    else if (name == 'Silk') {
	      if (!/\bMobi/i.test(ua)) {
	        os = 'Android';
	        description.unshift('desktop mode');
	      }
	      if (/Accelerated *= *true/i.test(ua)) {
	        description.unshift('accelerated');
	      }
	    }
	    // Detect UC Browser speed mode.
	    else if (name == 'UC Browser' && /\bUCWEB\b/.test(ua)) {
	      description.push('speed mode');
	    }
	    // Detect PaleMoon identifying as Firefox.
	    else if (name == 'PaleMoon' && (data = /\bFirefox\/([\d.]+)\b/.exec(ua))) {
	      description.push('identifying as Firefox ' + data[1]);
	    }
	    // Detect Firefox OS and products running Firefox.
	    else if (name == 'Firefox' && (data = /\b(Mobile|Tablet|TV)\b/i.exec(ua))) {
	      os || (os = 'Firefox OS');
	      product || (product = data[1]);
	    }
	    // Detect false positives for Firefox/Safari.
	    else if (!name || (data = !/\bMinefield\b/i.test(ua) && /\b(?:Firefox|Safari)\b/.exec(name))) {
	      // Escape the `/` for Firefox 1.
	      if (name && !product && /[\/,]|^[^(]+?\)/.test(ua.slice(ua.indexOf(data + '/') + 8))) {
	        // Clear name of false positives.
	        name = null;
	      }
	      // Reassign a generic name.
	      if ((data = product || manufacturer || os) &&
	          (product || manufacturer || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(os))) {
	        name = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(os) ? os : data) + ' Browser';
	      }
	    }
	    // Add Chrome version to description for Electron.
	    else if (name == 'Electron' && (data = (/\bChrome\/([\d.]+)\b/.exec(ua) || 0)[1])) {
	      description.push('Chromium ' + data);
	    }
	    // Detect non-Opera (Presto-based) versions (order is important).
	    if (!version) {
	      version = getVersion([
	        '(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)',
	        'Version',
	        qualify(name),
	        '(?:Firefox|Minefield|NetFront)'
	      ]);
	    }
	    // Detect stubborn layout engines.
	    if ((data =
	          layout == 'iCab' && parseFloat(version) > 3 && 'WebKit' ||
	          /\bOpera\b/.test(name) && (/\bOPR\b/.test(ua) ? 'Blink' : 'Presto') ||
	          /\b(?:Midori|Nook|Safari)\b/i.test(ua) && !/^(?:Trident|EdgeHTML)$/.test(layout) && 'WebKit' ||
	          !layout && /\bMSIE\b/i.test(ua) && (os == 'Mac OS' ? 'Tasman' : 'Trident') ||
	          layout == 'WebKit' && /\bPlayStation\b(?! Vita\b)/i.test(name) && 'NetFront'
	        )) {
	      layout = [data];
	    }
	    // Detect Windows Phone 7 desktop mode.
	    if (name == 'IE' && (data = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(ua) || 0)[1])) {
	      name += ' Mobile';
	      os = 'Windows Phone ' + (/\+$/.test(data) ? data : data + '.x');
	      description.unshift('desktop mode');
	    }
	    // Detect Windows Phone 8.x desktop mode.
	    else if (/\bWPDesktop\b/i.test(ua)) {
	      name = 'IE Mobile';
	      os = 'Windows Phone 8.x';
	      description.unshift('desktop mode');
	      version || (version = (/\brv:([\d.]+)/.exec(ua) || 0)[1]);
	    }
	    // Detect IE 11 identifying as other browsers.
	    else if (name != 'IE' && layout == 'Trident' && (data = /\brv:([\d.]+)/.exec(ua))) {
	      if (name) {
	        description.push('identifying as ' + name + (version ? ' ' + version : ''));
	      }
	      name = 'IE';
	      version = data[1];
	    }
	    // Leverage environment features.
	    if (useFeatures) {
	      // Detect server-side environments.
	      // Rhino has a global function while others have a global object.
	      if (isHostType(context, 'global')) {
	        if (java) {
	          data = java.lang.System;
	          arch = data.getProperty('os.arch');
	          os = os || data.getProperty('os.name') + ' ' + data.getProperty('os.version');
	        }
	        if (rhino) {
	          try {
	            version = context.require('ringo/engine').version.join('.');
	            name = 'RingoJS';
	          } catch(e) {
	            if ((data = context.system) && data.global.system == context.system) {
	              name = 'Narwhal';
	              os || (os = data[0].os || null);
	            }
	          }
	          if (!name) {
	            name = 'Rhino';
	          }
	        }
	        else if (
	          typeof context.process == 'object' && !context.process.browser &&
	          (data = context.process)
	        ) {
	          if (typeof data.versions == 'object') {
	            if (typeof data.versions.electron == 'string') {
	              description.push('Node ' + data.versions.node);
	              name = 'Electron';
	              version = data.versions.electron;
	            } else if (typeof data.versions.nw == 'string') {
	              description.push('Chromium ' + version, 'Node ' + data.versions.node);
	              name = 'NW.js';
	              version = data.versions.nw;
	            }
	          }
	          if (!name) {
	            name = 'Node.js';
	            arch = data.arch;
	            os = data.platform;
	            version = /[\d.]+/.exec(data.version);
	            version = version ? version[0] : null;
	          }
	        }
	      }
	      // Detect Adobe AIR.
	      else if (getClassOf((data = context.runtime)) == airRuntimeClass) {
	        name = 'Adobe AIR';
	        os = data.flash.system.Capabilities.os;
	      }
	      // Detect PhantomJS.
	      else if (getClassOf((data = context.phantom)) == phantomClass) {
	        name = 'PhantomJS';
	        version = (data = data.version || null) && (data.major + '.' + data.minor + '.' + data.patch);
	      }
	      // Detect IE compatibility modes.
	      else if (typeof doc.documentMode == 'number' && (data = /\bTrident\/(\d+)/i.exec(ua))) {
	        // We're in compatibility mode when the Trident version + 4 doesn't
	        // equal the document mode.
	        version = [version, doc.documentMode];
	        if ((data = +data[1] + 4) != version[1]) {
	          description.push('IE ' + version[1] + ' mode');
	          layout && (layout[1] = '');
	          version[1] = data;
	        }
	        version = name == 'IE' ? String(version[1].toFixed(1)) : version[0];
	      }
	      // Detect IE 11 masking as other browsers.
	      else if (typeof doc.documentMode == 'number' && /^(?:Chrome|Firefox)\b/.test(name)) {
	        description.push('masking as ' + name + ' ' + version);
	        name = 'IE';
	        version = '11.0';
	        layout = ['Trident'];
	        os = 'Windows';
	      }
	      os = os && format(os);
	    }
	    // Detect prerelease phases.
	    if (version && (data =
	          /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(version) ||
	          /(?:alpha|beta)(?: ?\d)?/i.exec(ua + ';' + (useFeatures && nav.appMinorVersion)) ||
	          /\bMinefield\b/i.test(ua) && 'a'
	        )) {
	      prerelease = /b/i.test(data) ? 'beta' : 'alpha';
	      version = version.replace(RegExp(data + '\\+?$'), '') +
	        (prerelease == 'beta' ? beta : alpha) + (/\d+\+?/.exec(data) || '');
	    }
	    // Detect Firefox Mobile.
	    if (name == 'Fennec' || name == 'Firefox' && /\b(?:Android|Firefox OS|KaiOS)\b/.test(os)) {
	      name = 'Firefox Mobile';
	    }
	    // Obscure Maxthon's unreliable version.
	    else if (name == 'Maxthon' && version) {
	      version = version.replace(/\.[\d.]+/, '.x');
	    }
	    // Detect Xbox 360 and Xbox One.
	    else if (/\bXbox\b/i.test(product)) {
	      if (product == 'Xbox 360') {
	        os = null;
	      }
	      if (product == 'Xbox 360' && /\bIEMobile\b/.test(ua)) {
	        description.unshift('mobile mode');
	      }
	    }
	    // Add mobile postfix.
	    else if ((/^(?:Chrome|IE|Opera)$/.test(name) || name && !product && !/Browser|Mobi/.test(name)) &&
	        (os == 'Windows CE' || /Mobi/i.test(ua))) {
	      name += ' Mobile';
	    }
	    // Detect IE platform preview.
	    else if (name == 'IE' && useFeatures) {
	      try {
	        if (context.external === null) {
	          description.unshift('platform preview');
	        }
	      } catch(e) {
	        description.unshift('embedded');
	      }
	    }
	    // Detect BlackBerry OS version.
	    // http://docs.blackberry.com/en/developers/deliverables/18169/HTTP_headers_sent_by_BB_Browser_1234911_11.jsp
	    else if ((/\bBlackBerry\b/.test(product) || /\bBB10\b/.test(ua)) && (data =
	          (RegExp(product.replace(/ +/g, ' *') + '/([.\\d]+)', 'i').exec(ua) || 0)[1] ||
	          version
	        )) {
	      data = [data, /BB10/.test(ua)];
	      os = (data[1] ? (product = null, manufacturer = 'BlackBerry') : 'Device Software') + ' ' + data[0];
	      version = null;
	    }
	    // Detect Opera identifying/masking itself as another browser.
	    // http://www.opera.com/support/kb/view/843/
	    else if (this != forOwn && product != 'Wii' && (
	          (useFeatures && opera) ||
	          (/Opera/.test(name) && /\b(?:MSIE|Firefox)\b/i.test(ua)) ||
	          (name == 'Firefox' && /\bOS X (?:\d+\.){2,}/.test(os)) ||
	          (name == 'IE' && (
	            (os && !/^Win/.test(os) && version > 5.5) ||
	            /\bWindows XP\b/.test(os) && version > 8 ||
	            version == 8 && !/\bTrident\b/.test(ua)
	          ))
	        ) && !reOpera.test((data = parse.call(forOwn, ua.replace(reOpera, '') + ';'))) && data.name) {
	      // When "identifying", the UA contains both Opera and the other browser's name.
	      data = 'ing as ' + data.name + ((data = data.version) ? ' ' + data : '');
	      if (reOpera.test(name)) {
	        if (/\bIE\b/.test(data) && os == 'Mac OS') {
	          os = null;
	        }
	        data = 'identify' + data;
	      }
	      // When "masking", the UA contains only the other browser's name.
	      else {
	        data = 'mask' + data;
	        if (operaClass) {
	          name = format(operaClass.replace(/([a-z])([A-Z])/g, '$1 $2'));
	        } else {
	          name = 'Opera';
	        }
	        if (/\bIE\b/.test(data)) {
	          os = null;
	        }
	        if (!useFeatures) {
	          version = null;
	        }
	      }
	      layout = ['Presto'];
	      description.push(data);
	    }
	    // Detect WebKit Nightly and approximate Chrome/Safari versions.
	    if ((data = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
	      // Correct build number for numeric comparison.
	      // (e.g. "532.5" becomes "532.05")
	      data = [parseFloat(data.replace(/\.(\d)$/, '.0$1')), data];
	      // Nightly builds are postfixed with a "+".
	      if (name == 'Safari' && data[1].slice(-1) == '+') {
	        name = 'WebKit Nightly';
	        prerelease = 'alpha';
	        version = data[1].slice(0, -1);
	      }
	      // Clear incorrect browser versions.
	      else if (version == data[1] ||
	          version == (data[2] = (/\bSafari\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
	        version = null;
	      }
	      // Use the full Chrome version when available.
	      data[1] = (/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(ua) || 0)[1];
	      // Detect Blink layout engine.
	      if (data[0] == 537.36 && data[2] == 537.36 && parseFloat(data[1]) >= 28 && layout == 'WebKit') {
	        layout = ['Blink'];
	      }
	      // Detect JavaScriptCore.
	      // http://stackoverflow.com/questions/6768474/how-can-i-detect-which-javascript-engine-v8-or-jsc-is-used-at-runtime-in-androi
	      if (!useFeatures || (!likeChrome && !data[1])) {
	        layout && (layout[1] = 'like Safari');
	        data = (data = data[0], data < 400 ? 1 : data < 500 ? 2 : data < 526 ? 3 : data < 533 ? 4 : data < 534 ? '4+' : data < 535 ? 5 : data < 537 ? 6 : data < 538 ? 7 : data < 601 ? 8 : data < 602 ? 9 : data < 604 ? 10 : data < 606 ? 11 : data < 608 ? 12 : '12');
	      } else {
	        layout && (layout[1] = 'like Chrome');
	        data = data[1] || (data = data[0], data < 530 ? 1 : data < 532 ? 2 : data < 532.05 ? 3 : data < 533 ? 4 : data < 534.03 ? 5 : data < 534.07 ? 6 : data < 534.10 ? 7 : data < 534.13 ? 8 : data < 534.16 ? 9 : data < 534.24 ? 10 : data < 534.30 ? 11 : data < 535.01 ? 12 : data < 535.02 ? '13+' : data < 535.07 ? 15 : data < 535.11 ? 16 : data < 535.19 ? 17 : data < 536.05 ? 18 : data < 536.10 ? 19 : data < 537.01 ? 20 : data < 537.11 ? '21+' : data < 537.13 ? 23 : data < 537.18 ? 24 : data < 537.24 ? 25 : data < 537.36 ? 26 : layout != 'Blink' ? '27' : '28');
	      }
	      // Add the postfix of ".x" or "+" for approximate versions.
	      layout && (layout[1] += ' ' + (data += typeof data == 'number' ? '.x' : /[.+]/.test(data) ? '' : '+'));
	      // Obscure version for some Safari 1-2 releases.
	      if (name == 'Safari' && (!version || parseInt(version) > 45)) {
	        version = data;
	      } else if (name == 'Chrome' && /\bHeadlessChrome/i.test(ua)) {
	        description.unshift('headless');
	      }
	    }
	    // Detect Opera desktop modes.
	    if (name == 'Opera' &&  (data = /\bzbov|zvav$/.exec(os))) {
	      name += ' ';
	      description.unshift('desktop mode');
	      if (data == 'zvav') {
	        name += 'Mini';
	        version = null;
	      } else {
	        name += 'Mobile';
	      }
	      os = os.replace(RegExp(' *' + data + '$'), '');
	    }
	    // Detect Chrome desktop mode.
	    else if (name == 'Safari' && /\bChrome\b/.exec(layout && layout[1])) {
	      description.unshift('desktop mode');
	      name = 'Chrome Mobile';
	      version = null;
	
	      if (/\bOS X\b/.test(os)) {
	        manufacturer = 'Apple';
	        os = 'iOS 4.3+';
	      } else {
	        os = null;
	      }
	    }
	    // Newer versions of SRWare Iron uses the Chrome tag to indicate its version number.
	    else if (/\bSRWare Iron\b/.test(name) && !version) {
	      version = getVersion('Chrome');
	    }
	    // Strip incorrect OS versions.
	    if (version && version.indexOf((data = /[\d.]+$/.exec(os))) == 0 &&
	        ua.indexOf('/' + data + '-') > -1) {
	      os = trim(os.replace(data, ''));
	    }
	    // Ensure OS does not include the browser name.
	    if (os && os.indexOf(name) != -1 && !RegExp(name + ' OS').test(os)) {
	      os = os.replace(RegExp(' *' + qualify(name) + ' *'), '');
	    }
	    // Add layout engine.
	    if (layout && !/\b(?:Avant|Nook)\b/.test(name) && (
	        /Browser|Lunascape|Maxthon/.test(name) ||
	        name != 'Safari' && /^iOS/.test(os) && /\bSafari\b/.test(layout[1]) ||
	        /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|SRWare Iron|Vivaldi|Web)/.test(name) && layout[1])) {
	      // Don't add layout details to description if they are falsey.
	      (data = layout[layout.length - 1]) && description.push(data);
	    }
	    // Combine contextual information.
	    if (description.length) {
	      description = ['(' + description.join('; ') + ')'];
	    }
	    // Append manufacturer to description.
	    if (manufacturer && product && product.indexOf(manufacturer) < 0) {
	      description.push('on ' + manufacturer);
	    }
	    // Append product to description.
	    if (product) {
	      description.push((/^on /.test(description[description.length - 1]) ? '' : 'on ') + product);
	    }
	    // Parse the OS into an object.
	    if (os) {
	      data = / ([\d.+]+)$/.exec(os);
	      isSpecialCasedOS = data && os.charAt(os.length - data[0].length - 1) == '/';
	      os = {
	        'architecture': 32,
	        'family': (data && !isSpecialCasedOS) ? os.replace(data[0], '') : os,
	        'version': data ? data[1] : null,
	        'toString': function() {
	          var version = this.version;
	          return this.family + ((version && !isSpecialCasedOS) ? ' ' + version : '') + (this.architecture == 64 ? ' 64-bit' : '');
	        }
	      };
	    }
	    // Add browser/OS architecture.
	    if ((data = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(arch)) && !/\bi686\b/i.test(arch)) {
	      if (os) {
	        os.architecture = 64;
	        os.family = os.family.replace(RegExp(' *' + data), '');
	      }
	      if (
	          name && (/\bWOW64\b/i.test(ua) ||
	          (useFeatures && /\w(?:86|32)$/.test(nav.cpuClass || nav.platform) && !/\bWin64; x64\b/i.test(ua)))
	      ) {
	        description.unshift('32-bit');
	      }
	    }
	    // Chrome 39 and above on OS X is always 64-bit.
	    else if (
	        os && /^OS X/.test(os.family) &&
	        name == 'Chrome' && parseFloat(version) >= 39
	    ) {
	      os.architecture = 64;
	    }
	
	    ua || (ua = null);
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The platform object.
	     *
	     * @name platform
	     * @type Object
	     */
	    var platform = {};
	
	    /**
	     * The platform description.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.description = ua;
	
	    /**
	     * The name of the browser's layout engine.
	     *
	     * The list of common layout engines include:
	     * "Blink", "EdgeHTML", "Gecko", "Trident" and "WebKit"
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.layout = layout && layout[0];
	
	    /**
	     * The name of the product's manufacturer.
	     *
	     * The list of manufacturers include:
	     * "Apple", "Archos", "Amazon", "Asus", "Barnes & Noble", "BlackBerry",
	     * "Google", "HP", "HTC", "LG", "Microsoft", "Motorola", "Nintendo",
	     * "Nokia", "Samsung" and "Sony"
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.manufacturer = manufacturer;
	
	    /**
	     * The name of the browser/environment.
	     *
	     * The list of common browser names include:
	     * "Chrome", "Electron", "Firefox", "Firefox for iOS", "IE",
	     * "Microsoft Edge", "PhantomJS", "Safari", "SeaMonkey", "Silk",
	     * "Opera Mini" and "Opera"
	     *
	     * Mobile versions of some browsers have "Mobile" appended to their name:
	     * eg. "Chrome Mobile", "Firefox Mobile", "IE Mobile" and "Opera Mobile"
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.name = name;
	
	    /**
	     * The alpha/beta release indicator.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.prerelease = prerelease;
	
	    /**
	     * The name of the product hosting the browser.
	     *
	     * The list of common products include:
	     *
	     * "BlackBerry", "Galaxy S4", "Lumia", "iPad", "iPod", "iPhone", "Kindle",
	     * "Kindle Fire", "Nexus", "Nook", "PlayBook", "TouchPad" and "Transformer"
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.product = product;
	
	    /**
	     * The browser's user agent string.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.ua = ua;
	
	    /**
	     * The browser/environment version.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.version = name && version;
	
	    /**
	     * The name of the operating system.
	     *
	     * @memberOf platform
	     * @type Object
	     */
	    platform.os = os || {
	
	      /**
	       * The CPU architecture the OS is built for.
	       *
	       * @memberOf platform.os
	       * @type number|null
	       */
	      'architecture': null,
	
	      /**
	       * The family of the OS.
	       *
	       * Common values include:
	       * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
	       * "Windows XP", "OS X", "Linux", "Ubuntu", "Debian", "Fedora", "Red Hat",
	       * "SuSE", "Android", "iOS" and "Windows Phone"
	       *
	       * @memberOf platform.os
	       * @type string|null
	       */
	      'family': null,
	
	      /**
	       * The version of the OS.
	       *
	       * @memberOf platform.os
	       * @type string|null
	       */
	      'version': null,
	
	      /**
	       * Returns the OS string.
	       *
	       * @memberOf platform.os
	       * @returns {string} The OS string.
	       */
	      'toString': function() { return 'null'; }
	    };
	
	    platform.parse = parse;
	    platform.toString = toStringPlatform;
	
	    if (platform.version) {
	      description.unshift(version);
	    }
	    if (platform.name) {
	      description.unshift(name);
	    }
	    if (os && name && !(os == String(os).split(' ')[0] && (os == name.split(' ')[0] || product))) {
	      description.push(product ? '(' + os + ')' : 'on ' + os);
	    }
	    if (description.length) {
	      platform.description = description.join(' ');
	    }
	    return platform;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export platform.
	  var platform = parse();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like the following:
	  if (true) {
	    // Expose platform on the global object to prevent errors when platform is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    root.platform = platform;
	
	    // Define as an anonymous module so platform can be aliased through path mapping.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return platform;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for CommonJS support.
	    forOwn(platform, function(value, key) {
	      freeExports[key] = value;
	    });
	  }
	  else {
	    // Export to the global object.
	    root.platform = platform;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(138)(module), (function() { return this; }())))

/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	/* global define */
	
	(function (root, pluralize) {
	  /* istanbul ignore else */
	  if (true) {
	    // Node.
	    module.exports = pluralize();
	  } else if (typeof define === 'function' && define.amd) {
	    // AMD, registers as an anonymous module.
	    define(function () {
	      return pluralize();
	    });
	  } else {
	    // Browser global.
	    root.pluralize = pluralize();
	  }
	})(this, function () {
	  // Rule storage - pluralize and singularize need to be run sequentially,
	  // while other rules can be optimized using an object for instant lookups.
	  var pluralRules = [];
	  var singularRules = [];
	  var uncountables = {};
	  var irregularPlurals = {};
	  var irregularSingles = {};
	
	  /**
	   * Title case a string.
	   *
	   * @param  {string} str
	   * @return {string}
	   */
	  function toTitleCase (str) {
	    return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase();
	  }
	
	  /**
	   * Sanitize a pluralization rule to a usable regular expression.
	   *
	   * @param  {(RegExp|string)} rule
	   * @return {RegExp}
	   */
	  function sanitizeRule (rule) {
	    if (typeof rule === 'string') {
	      return new RegExp('^' + rule + '$', 'i');
	    }
	
	    return rule;
	  }
	
	  /**
	   * Pass in a word token to produce a function that can replicate the case on
	   * another word.
	   *
	   * @param  {string}   word
	   * @param  {string}   token
	   * @return {Function}
	   */
	  function restoreCase (word, token) {
	    // Upper cased words. E.g. "HELLO".
	    if (word === word.toUpperCase()) {
	      return token.toUpperCase();
	    }
	
	    // Title cased words. E.g. "Title".
	    if (word[0] === word[0].toUpperCase()) {
	      return toTitleCase(token);
	    }
	
	    // Lower cased words. E.g. "test".
	    return token.toLowerCase();
	  }
	
	  /**
	   * Interpolate a regexp string.
	   *
	   * @param  {string} str
	   * @param  {Array}  args
	   * @return {string}
	   */
	  function interpolate (str, args) {
	    return str.replace(/\$(\d{1,2})/g, function (match, index) {
	      return args[index] || '';
	    });
	  }
	
	  /**
	   * Sanitize a word by passing in the word and sanitization rules.
	   *
	   * @param  {String}   token
	   * @param  {String}   word
	   * @param  {Array}    collection
	   * @return {String}
	   */
	  function sanitizeWord (token, word, collection) {
	    // Empty string or doesn't need fixing.
	    if (!token.length || uncountables.hasOwnProperty(token)) {
	      return word;
	    }
	
	    var len = collection.length;
	
	    // Iterate over the sanitization rules and use the first one to match.
	    while (len--) {
	      var rule = collection[len];
	
	      // If the rule passes, return the replacement.
	      if (rule[0].test(word)) {
	        return word.replace(rule[0], function (match, index, word) {
	          var result = interpolate(rule[1], arguments);
	
	          if (match === '') {
	            return restoreCase(word[index - 1], result);
	          }
	
	          return restoreCase(match, result);
	        });
	      }
	    }
	
	    return word;
	  }
	
	  /**
	   * Replace a word with the updated word.
	   *
	   * @param  {Object}   replaceMap
	   * @param  {Object}   keepMap
	   * @param  {Array}    rules
	   * @return {Function}
	   */
	  function replaceWord (replaceMap, keepMap, rules) {
	    return function (word) {
	      // Get the correct token and case restoration functions.
	      var token = word.toLowerCase();
	
	      // Check against the keep object map.
	      if (keepMap.hasOwnProperty(token)) {
	        return restoreCase(word, token);
	      }
	
	      // Check against the replacement map for a direct word replacement.
	      if (replaceMap.hasOwnProperty(token)) {
	        return restoreCase(word, replaceMap[token]);
	      }
	
	      // Run all the rules against the word.
	      return sanitizeWord(token, word, rules);
	    };
	  }
	
	  /**
	   * Pluralize or singularize a word based on the passed in count.
	   *
	   * @param  {String}  word
	   * @param  {Number}  count
	   * @param  {Boolean} inclusive
	   * @return {String}
	   */
	  function pluralize (word, count, inclusive) {
	    var pluralized = count === 1
	      ? pluralize.singular(word) : pluralize.plural(word);
	
	    return (inclusive ? count + ' ' : '') + pluralized;
	  }
	
	  /**
	   * Pluralize a word.
	   *
	   * @type {Function}
	   */
	  pluralize.plural = replaceWord(
	    irregularSingles, irregularPlurals, pluralRules
	  );
	
	  /**
	   * Singularize a word.
	   *
	   * @type {Function}
	   */
	  pluralize.singular = replaceWord(
	    irregularPlurals, irregularSingles, singularRules
	  );
	
	  /**
	   * Add a pluralization rule to the collection.
	   *
	   * @param {(string|RegExp)} rule
	   * @param {string}          replacement
	   */
	  pluralize.addPluralRule = function (rule, replacement) {
	    pluralRules.push([sanitizeRule(rule), replacement]);
	  };
	
	  /**
	   * Add a singularization rule to the collection.
	   *
	   * @param {(string|RegExp)} rule
	   * @param {string}          replacement
	   */
	  pluralize.addSingularRule = function (rule, replacement) {
	    singularRules.push([sanitizeRule(rule), replacement]);
	  };
	
	  /**
	   * Add an uncountable word rule.
	   *
	   * @param {(string|RegExp)} word
	   */
	  pluralize.addUncountableRule = function (word) {
	    if (typeof word === 'string') {
	      uncountables[word.toLowerCase()] = true;
	      return;
	    }
	
	    // Set singular and plural references for the word.
	    pluralize.addPluralRule(word, '$0');
	    pluralize.addSingularRule(word, '$0');
	  };
	
	  /**
	   * Add an irregular word definition.
	   *
	   * @param {String} single
	   * @param {String} plural
	   */
	  pluralize.addIrregularRule = function (single, plural) {
	    plural = plural.toLowerCase();
	    single = single.toLowerCase();
	
	    irregularSingles[single] = plural;
	    irregularPlurals[plural] = single;
	  };
	
	  /**
	   * Irregular rules.
	   */
	  [
	    // Pronouns.
	    ['I', 'we'],
	    ['me', 'us'],
	    ['he', 'they'],
	    ['she', 'they'],
	    ['them', 'them'],
	    ['myself', 'ourselves'],
	    ['yourself', 'yourselves'],
	    ['itself', 'themselves'],
	    ['herself', 'themselves'],
	    ['himself', 'themselves'],
	    ['themself', 'themselves'],
	    ['is', 'are'],
	    ['was', 'were'],
	    ['this', 'these'],
	    ['that', 'those'],
	    // Words ending in with a consonant and `o`.
	    ['echo', 'echoes'],
	    ['dingo', 'dingoes'],
	    ['volcano', 'volcanoes'],
	    ['tornado', 'tornadoes'],
	    ['torpedo', 'torpedoes'],
	    // Ends with `us`.
	    ['genus', 'genera'],
	    ['viscus', 'viscera'],
	    // Ends with `ma`.
	    ['stigma', 'stigmata'],
	    ['stoma', 'stomata'],
	    ['dogma', 'dogmata'],
	    ['lemma', 'lemmata'],
	    ['schema', 'schemata'],
	    ['anathema', 'anathemata'],
	    // Other irregular rules.
	    ['ox', 'oxen'],
	    ['axe', 'axes'],
	    ['die', 'dice'],
	    ['yes', 'yeses'],
	    ['foot', 'feet'],
	    ['eave', 'eaves'],
	    ['goose', 'geese'],
	    ['tooth', 'teeth'],
	    ['quiz', 'quizzes'],
	    ['human', 'humans'],
	    ['proof', 'proofs'],
	    ['carve', 'carves'],
	    ['valve', 'valves'],
	    ['thief', 'thieves'],
	    ['genie', 'genies'],
	    ['groove', 'grooves'],
	    ['pickaxe', 'pickaxes'],
	    ['whiskey', 'whiskies']
	  ].forEach(function (rule) {
	    return pluralize.addIrregularRule(rule[0], rule[1]);
	  });
	
	  /**
	   * Pluralization rules.
	   */
	  [
	    [/s?$/i, 's'],
	    [/([^aeiou]ese)$/i, '$1'],
	    [/(ax|test)is$/i, '$1es'],
	    [/(alias|[^aou]us|tlas|gas|ris)$/i, '$1es'],
	    [/(e[mn]u)s?$/i, '$1s'],
	    [/([^l]ias|[aeiou]las|[emjzr]as|[iu]am)$/i, '$1'],
	    [/(alumn|syllab|octop|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1i'],
	    [/(alumn|alg|vertebr)(?:a|ae)$/i, '$1ae'],
	    [/(seraph|cherub)(?:im)?$/i, '$1im'],
	    [/(her|at|gr)o$/i, '$1oes'],
	    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, '$1a'],
	    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, '$1a'],
	    [/sis$/i, 'ses'],
	    [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, '$1$2ves'],
	    [/([^aeiouy]|qu)y$/i, '$1ies'],
	    [/([^ch][ieo][ln])ey$/i, '$1ies'],
	    [/(x|ch|ss|sh|zz)$/i, '$1es'],
	    [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, '$1ices'],
	    [/(m|l)(?:ice|ouse)$/i, '$1ice'],
	    [/(pe)(?:rson|ople)$/i, '$1ople'],
	    [/(child)(?:ren)?$/i, '$1ren'],
	    [/eaux$/i, '$0'],
	    [/m[ae]n$/i, 'men'],
	    ['thou', 'you']
	  ].forEach(function (rule) {
	    return pluralize.addPluralRule(rule[0], rule[1]);
	  });
	
	  /**
	   * Singularization rules.
	   */
	  [
	    [/s$/i, ''],
	    [/(ss)$/i, '$1'],
	    [/((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)(?:sis|ses)$/i, '$1sis'],
	    [/(^analy)(?:sis|ses)$/i, '$1sis'],
	    [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, '$1fe'],
	    [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, '$1f'],
	    [/([^aeiouy]|qu)ies$/i, '$1y'],
	    [/(^[pl]|zomb|^(?:neck)?t|[aeo][lt]|cut)ies$/i, '$1ie'],
	    [/(\b(?:mon|smil))ies$/i, '$1ey'],
	    [/(m|l)ice$/i, '$1ouse'],
	    [/(seraph|cherub)im$/i, '$1'],
	    [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|tlas|gas|(?:her|at|gr)o|ris)(?:es)?$/i, '$1'],
	    [/(e[mn]u)s?$/i, '$1'],
	    [/(movie|twelve)s$/i, '$1'],
	    [/(cris|test|diagnos)(?:is|es)$/i, '$1is'],
	    [/(alumn|syllab|octop|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1us'],
	    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, '$1um'],
	    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, '$1on'],
	    [/(alumn|alg|vertebr)ae$/i, '$1a'],
	    [/(cod|mur|sil|vert|ind)ices$/i, '$1ex'],
	    [/(matr|append)ices$/i, '$1ix'],
	    [/(pe)(rson|ople)$/i, '$1rson'],
	    [/(child)ren$/i, '$1'],
	    [/(eau)x?$/i, '$1'],
	    [/men$/i, 'man']
	  ].forEach(function (rule) {
	    return pluralize.addSingularRule(rule[0], rule[1]);
	  });
	
	  /**
	   * Uncountable rules.
	   */
	  [
	    // Singular words with no plurals.
	    'advice',
	    'adulthood',
	    'agenda',
	    'aid',
	    'alcohol',
	    'ammo',
	    'athletics',
	    'bison',
	    'blood',
	    'bream',
	    'buffalo',
	    'butter',
	    'carp',
	    'cash',
	    'chassis',
	    'chess',
	    'clothing',
	    'commerce',
	    'cod',
	    'cooperation',
	    'corps',
	    'digestion',
	    'debris',
	    'diabetes',
	    'energy',
	    'equipment',
	    'elk',
	    'excretion',
	    'expertise',
	    'flounder',
	    'fun',
	    'gallows',
	    'garbage',
	    'graffiti',
	    'headquarters',
	    'health',
	    'herpes',
	    'highjinks',
	    'homework',
	    'housework',
	    'information',
	    'jeans',
	    'justice',
	    'kudos',
	    'labour',
	    'literature',
	    'machinery',
	    'mackerel',
	    'mail',
	    'media',
	    'mews',
	    'moose',
	    'music',
	    'news',
	    'pike',
	    'plankton',
	    'pliers',
	    'pollution',
	    'premises',
	    'rain',
	    'research',
	    'rice',
	    'salmon',
	    'scissors',
	    'series',
	    'sewage',
	    'shambles',
	    'shrimp',
	    'species',
	    'staff',
	    'swine',
	    'trout',
	    'traffic',
	    'transporation',
	    'tuna',
	    'wealth',
	    'welfare',
	    'whiting',
	    'wildebeest',
	    'wildlife',
	    'you',
	    // Regexes.
	    /pox$/i, // "chickpox", "smallpox"
	    /ois$/i,
	    /deer$/i, // "deer", "reindeer"
	    /fish$/i, // "fish", "blowfish", "angelfish"
	    /sheep$/i,
	    /measles$/i,
	    /[^aeiou]ese$/i // "chinese", "japanese"
	  ].forEach(pluralize.addUncountableRule);
	
	  return pluralize;
	});


/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	var postcss = __webpack_require__(169);
	
	var processResult = __webpack_require__(458);
	var parse         = __webpack_require__(312);
	
	module.exports = function (plugins) {
	    var processor = postcss(plugins);
	    return function (input) {
	        return processor.process(input, { parser: parse }).then(processResult);
	    };
	};


/***/ },
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	var postcss = __webpack_require__(169);
	
	var processResult = __webpack_require__(458);
	var parse         = __webpack_require__(312);
	
	module.exports = function (plugins) {
	    var processor = postcss(plugins);
	    return function (input) {
	        var result = processor.process(input, { parser: parse });
	        return processResult(result);
	    };
	};


/***/ },
/* 1477 */
/***/ function(module, exports) {

	var openParentheses = "(".charCodeAt(0);
	var closeParentheses = ")".charCodeAt(0);
	var singleQuote = "'".charCodeAt(0);
	var doubleQuote = '"'.charCodeAt(0);
	var backslash = "\\".charCodeAt(0);
	var slash = "/".charCodeAt(0);
	var comma = ",".charCodeAt(0);
	var colon = ":".charCodeAt(0);
	var star = "*".charCodeAt(0);
	
	module.exports = function(input) {
	  var tokens = [];
	  var value = input;
	
	  var next, quote, prev, token, escape, escapePos, whitespacePos;
	  var pos = 0;
	  var code = value.charCodeAt(pos);
	  var max = value.length;
	  var stack = [{ nodes: tokens }];
	  var balanced = 0;
	  var parent;
	
	  var name = "";
	  var before = "";
	  var after = "";
	
	  while (pos < max) {
	    // Whitespaces
	    if (code <= 32) {
	      next = pos;
	      do {
	        next += 1;
	        code = value.charCodeAt(next);
	      } while (code <= 32);
	      token = value.slice(pos, next);
	
	      prev = tokens[tokens.length - 1];
	      if (code === closeParentheses && balanced) {
	        after = token;
	      } else if (prev && prev.type === "div") {
	        prev.after = token;
	      } else if (
	        code === comma ||
	        code === colon ||
	        (code === slash && value.charCodeAt(next + 1) !== star)
	      ) {
	        before = token;
	      } else {
	        tokens.push({
	          type: "space",
	          sourceIndex: pos,
	          value: token
	        });
	      }
	
	      pos = next;
	
	      // Quotes
	    } else if (code === singleQuote || code === doubleQuote) {
	      next = pos;
	      quote = code === singleQuote ? "'" : '"';
	      token = {
	        type: "string",
	        sourceIndex: pos,
	        quote: quote
	      };
	      do {
	        escape = false;
	        next = value.indexOf(quote, next + 1);
	        if (~next) {
	          escapePos = next;
	          while (value.charCodeAt(escapePos - 1) === backslash) {
	            escapePos -= 1;
	            escape = !escape;
	          }
	        } else {
	          value += quote;
	          next = value.length - 1;
	          token.unclosed = true;
	        }
	      } while (escape);
	      token.value = value.slice(pos + 1, next);
	
	      tokens.push(token);
	      pos = next + 1;
	      code = value.charCodeAt(pos);
	
	      // Comments
	    } else if (code === slash && value.charCodeAt(pos + 1) === star) {
	      token = {
	        type: "comment",
	        sourceIndex: pos
	      };
	
	      next = value.indexOf("*/", pos);
	      if (next === -1) {
	        token.unclosed = true;
	        next = value.length;
	      }
	
	      token.value = value.slice(pos + 2, next);
	      tokens.push(token);
	
	      pos = next + 2;
	      code = value.charCodeAt(pos);
	
	      // Dividers
	    } else if (code === slash || code === comma || code === colon) {
	      token = value[pos];
	
	      tokens.push({
	        type: "div",
	        sourceIndex: pos - before.length,
	        value: token,
	        before: before,
	        after: ""
	      });
	      before = "";
	
	      pos += 1;
	      code = value.charCodeAt(pos);
	
	      // Open parentheses
	    } else if (openParentheses === code) {
	      // Whitespaces after open parentheses
	      next = pos;
	      do {
	        next += 1;
	        code = value.charCodeAt(next);
	      } while (code <= 32);
	      token = {
	        type: "function",
	        sourceIndex: pos - name.length,
	        value: name,
	        before: value.slice(pos + 1, next)
	      };
	      pos = next;
	
	      if (name === "url" && code !== singleQuote && code !== doubleQuote) {
	        next -= 1;
	        do {
	          escape = false;
	          next = value.indexOf(")", next + 1);
	          if (~next) {
	            escapePos = next;
	            while (value.charCodeAt(escapePos - 1) === backslash) {
	              escapePos -= 1;
	              escape = !escape;
	            }
	          } else {
	            value += ")";
	            next = value.length - 1;
	            token.unclosed = true;
	          }
	        } while (escape);
	        // Whitespaces before closed
	        whitespacePos = next;
	        do {
	          whitespacePos -= 1;
	          code = value.charCodeAt(whitespacePos);
	        } while (code <= 32);
	        if (pos !== whitespacePos + 1) {
	          token.nodes = [
	            {
	              type: "word",
	              sourceIndex: pos,
	              value: value.slice(pos, whitespacePos + 1)
	            }
	          ];
	        } else {
	          token.nodes = [];
	        }
	        if (token.unclosed && whitespacePos + 1 !== next) {
	          token.after = "";
	          token.nodes.push({
	            type: "space",
	            sourceIndex: whitespacePos + 1,
	            value: value.slice(whitespacePos + 1, next)
	          });
	        } else {
	          token.after = value.slice(whitespacePos + 1, next);
	        }
	        pos = next + 1;
	        code = value.charCodeAt(pos);
	        tokens.push(token);
	      } else {
	        balanced += 1;
	        token.after = "";
	        tokens.push(token);
	        stack.push(token);
	        tokens = token.nodes = [];
	        parent = token;
	      }
	      name = "";
	
	      // Close parentheses
	    } else if (closeParentheses === code && balanced) {
	      pos += 1;
	      code = value.charCodeAt(pos);
	
	      parent.after = after;
	      after = "";
	      balanced -= 1;
	      stack.pop();
	      parent = stack[balanced];
	      tokens = parent.nodes;
	
	      // Words
	    } else {
	      next = pos;
	      do {
	        if (code === backslash) {
	          next += 1;
	        }
	        next += 1;
	        code = value.charCodeAt(next);
	      } while (
	        next < max &&
	        !(
	          code <= 32 ||
	          code === singleQuote ||
	          code === doubleQuote ||
	          code === comma ||
	          code === colon ||
	          code === slash ||
	          code === openParentheses ||
	          (code === closeParentheses && balanced)
	        )
	      );
	      token = value.slice(pos, next);
	
	      if (openParentheses === code) {
	        name = token;
	      } else {
	        tokens.push({
	          type: "word",
	          sourceIndex: pos,
	          value: token
	        });
	      }
	
	      pos = next;
	    }
	  }
	
	  for (pos = stack.length - 1; pos; pos -= 1) {
	    stack[pos].unclosed = true;
	  }
	
	  return stack[0].nodes;
	};


/***/ },
/* 1478 */
/***/ function(module, exports) {

	function stringifyNode(node, custom) {
	  var type = node.type;
	  var value = node.value;
	  var buf;
	  var customResult;
	
	  if (custom && (customResult = custom(node)) !== undefined) {
	    return customResult;
	  } else if (type === "word" || type === "space") {
	    return value;
	  } else if (type === "string") {
	    buf = node.quote || "";
	    return buf + value + (node.unclosed ? "" : buf);
	  } else if (type === "comment") {
	    return "/*" + value + (node.unclosed ? "" : "*/");
	  } else if (type === "div") {
	    return (node.before || "") + value + (node.after || "");
	  } else if (Array.isArray(node.nodes)) {
	    buf = stringify(node.nodes);
	    if (type !== "function") {
	      return buf;
	    }
	    return (
	      value +
	      "(" +
	      (node.before || "") +
	      buf +
	      (node.after || "") +
	      (node.unclosed ? "" : ")")
	    );
	  }
	  return value;
	}
	
	function stringify(nodes, custom) {
	  var result, i;
	
	  if (Array.isArray(nodes)) {
	    result = "";
	    for (i = nodes.length - 1; ~i; i -= 1) {
	      result = stringifyNode(nodes[i], custom) + result;
	    }
	    return result;
	  }
	  return stringifyNode(nodes, custom);
	}
	
	module.exports = stringify;


/***/ },
/* 1479 */
/***/ function(module, exports) {

	var minus = "-".charCodeAt(0);
	var plus = "+".charCodeAt(0);
	var dot = ".".charCodeAt(0);
	var exp = "e".charCodeAt(0);
	var EXP = "E".charCodeAt(0);
	
	module.exports = function(value) {
	  var pos = 0;
	  var length = value.length;
	  var dotted = false;
	  var sciPos = -1;
	  var containsNumber = false;
	  var code;
	
	  while (pos < length) {
	    code = value.charCodeAt(pos);
	
	    if (code >= 48 && code <= 57) {
	      containsNumber = true;
	    } else if (code === exp || code === EXP) {
	      if (sciPos > -1) {
	        break;
	      }
	      sciPos = pos;
	    } else if (code === dot) {
	      if (dotted) {
	        break;
	      }
	      dotted = true;
	    } else if (code === plus || code === minus) {
	      if (pos !== 0) {
	        break;
	      }
	    } else {
	      break;
	    }
	
	    pos += 1;
	  }
	
	  if (sciPos + 1 === pos) pos--;
	
	  return containsNumber
	    ? {
	        number: value.slice(0, pos),
	        unit: value.slice(pos)
	      }
	    : false;
	};


/***/ },
/* 1480 */
/***/ function(module, exports) {

	module.exports = function walk(nodes, cb, bubble) {
	  var i, max, node, result;
	
	  for (i = 0, max = nodes.length; i < max; i += 1) {
	    node = nodes[i];
	    if (!bubble) {
	      result = cb(node, i, nodes);
	    }
	
	    if (
	      result !== false &&
	      node.type === "function" &&
	      Array.isArray(node.nodes)
	    ) {
	      walk(node.nodes, cb, bubble);
	    }
	
	    if (bubble) {
	      cb(node, i, nodes);
	    }
	  }
	};


/***/ },
/* 1481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jsBase = __webpack_require__(434);
	
	var _sourceMap = __webpack_require__(552);
	
	var _sourceMap2 = _interopRequireDefault(_sourceMap);
	
	var _path = __webpack_require__(168);
	
	var _path2 = _interopRequireDefault(_path);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MapGenerator = function () {
	    function MapGenerator(stringify, root, opts) {
	        _classCallCheck(this, MapGenerator);
	
	        this.stringify = stringify;
	        this.mapOpts = opts.map || {};
	        this.root = root;
	        this.opts = opts;
	    }
	
	    MapGenerator.prototype.isMap = function isMap() {
	        if (typeof this.opts.map !== 'undefined') {
	            return !!this.opts.map;
	        } else {
	            return this.previous().length > 0;
	        }
	    };
	
	    MapGenerator.prototype.previous = function previous() {
	        var _this = this;
	
	        if (!this.previousMaps) {
	            this.previousMaps = [];
	            this.root.walk(function (node) {
	                if (node.source && node.source.input.map) {
	                    var map = node.source.input.map;
	                    if (_this.previousMaps.indexOf(map) === -1) {
	                        _this.previousMaps.push(map);
	                    }
	                }
	            });
	        }
	
	        return this.previousMaps;
	    };
	
	    MapGenerator.prototype.isInline = function isInline() {
	        if (typeof this.mapOpts.inline !== 'undefined') {
	            return this.mapOpts.inline;
	        }
	
	        var annotation = this.mapOpts.annotation;
	        if (typeof annotation !== 'undefined' && annotation !== true) {
	            return false;
	        }
	
	        if (this.previous().length) {
	            return this.previous().some(function (i) {
	                return i.inline;
	            });
	        } else {
	            return true;
	        }
	    };
	
	    MapGenerator.prototype.isSourcesContent = function isSourcesContent() {
	        if (typeof this.mapOpts.sourcesContent !== 'undefined') {
	            return this.mapOpts.sourcesContent;
	        }
	        if (this.previous().length) {
	            return this.previous().some(function (i) {
	                return i.withContent();
	            });
	        } else {
	            return true;
	        }
	    };
	
	    MapGenerator.prototype.clearAnnotation = function clearAnnotation() {
	        if (this.mapOpts.annotation === false) return;
	
	        var node = void 0;
	        for (var i = this.root.nodes.length - 1; i >= 0; i--) {
	            node = this.root.nodes[i];
	            if (node.type !== 'comment') continue;
	            if (node.text.indexOf('# sourceMappingURL=') === 0) {
	                this.root.removeChild(i);
	            }
	        }
	    };
	
	    MapGenerator.prototype.setSourcesContent = function setSourcesContent() {
	        var _this2 = this;
	
	        var already = {};
	        this.root.walk(function (node) {
	            if (node.source) {
	                var from = node.source.input.from;
	                if (from && !already[from]) {
	                    already[from] = true;
	                    var relative = _this2.relative(from);
	                    _this2.map.setSourceContent(relative, node.source.input.css);
	                }
	            }
	        });
	    };
	
	    MapGenerator.prototype.applyPrevMaps = function applyPrevMaps() {
	        for (var _iterator = this.previous(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	            }
	
	            var prev = _ref;
	
	            var from = this.relative(prev.file);
	            var root = prev.root || _path2.default.dirname(prev.file);
	            var map = void 0;
	
	            if (this.mapOpts.sourcesContent === false) {
	                map = new _sourceMap2.default.SourceMapConsumer(prev.text);
	                if (map.sourcesContent) {
	                    map.sourcesContent = map.sourcesContent.map(function () {
	                        return null;
	                    });
	                }
	            } else {
	                map = prev.consumer();
	            }
	
	            this.map.applySourceMap(map, from, this.relative(root));
	        }
	    };
	
	    MapGenerator.prototype.isAnnotation = function isAnnotation() {
	        if (this.isInline()) {
	            return true;
	        } else if (typeof this.mapOpts.annotation !== 'undefined') {
	            return this.mapOpts.annotation;
	        } else if (this.previous().length) {
	            return this.previous().some(function (i) {
	                return i.annotation;
	            });
	        } else {
	            return true;
	        }
	    };
	
	    MapGenerator.prototype.addAnnotation = function addAnnotation() {
	        var content = void 0;
	
	        if (this.isInline()) {
	            content = 'data:application/json;base64,' + _jsBase.Base64.encode(this.map.toString());
	        } else if (typeof this.mapOpts.annotation === 'string') {
	            content = this.mapOpts.annotation;
	        } else {
	            content = this.outputFile() + '.map';
	        }
	
	        var eol = '\n';
	        if (this.css.indexOf('\r\n') !== -1) eol = '\r\n';
	
	        this.css += eol + '/*# sourceMappingURL=' + content + ' */';
	    };
	
	    MapGenerator.prototype.outputFile = function outputFile() {
	        if (this.opts.to) {
	            return this.relative(this.opts.to);
	        } else if (this.opts.from) {
	            return this.relative(this.opts.from);
	        } else {
	            return 'to.css';
	        }
	    };
	
	    MapGenerator.prototype.generateMap = function generateMap() {
	        this.generateString();
	        if (this.isSourcesContent()) this.setSourcesContent();
	        if (this.previous().length > 0) this.applyPrevMaps();
	        if (this.isAnnotation()) this.addAnnotation();
	
	        if (this.isInline()) {
	            return [this.css];
	        } else {
	            return [this.css, this.map];
	        }
	    };
	
	    MapGenerator.prototype.relative = function relative(file) {
	        if (file.indexOf('<') === 0) return file;
	        if (/^\w+:\/\//.test(file)) return file;
	
	        var from = this.opts.to ? _path2.default.dirname(this.opts.to) : '.';
	
	        if (typeof this.mapOpts.annotation === 'string') {
	            from = _path2.default.dirname(_path2.default.resolve(from, this.mapOpts.annotation));
	        }
	
	        file = _path2.default.relative(from, file);
	        if (_path2.default.sep === '\\') {
	            return file.replace(/\\/g, '/');
	        } else {
	            return file;
	        }
	    };
	
	    MapGenerator.prototype.sourcePath = function sourcePath(node) {
	        if (this.mapOpts.from) {
	            return this.mapOpts.from;
	        } else {
	            return this.relative(node.source.input.from);
	        }
	    };
	
	    MapGenerator.prototype.generateString = function generateString() {
	        var _this3 = this;
	
	        this.css = '';
	        this.map = new _sourceMap2.default.SourceMapGenerator({ file: this.outputFile() });
	
	        var line = 1;
	        var column = 1;
	
	        var lines = void 0,
	            last = void 0;
	        this.stringify(this.root, function (str, node, type) {
	            _this3.css += str;
	
	            if (node && type !== 'end') {
	                if (node.source && node.source.start) {
	                    _this3.map.addMapping({
	                        source: _this3.sourcePath(node),
	                        generated: { line: line, column: column - 1 },
	                        original: {
	                            line: node.source.start.line,
	                            column: node.source.start.column - 1
	                        }
	                    });
	                } else {
	                    _this3.map.addMapping({
	                        source: '<no source>',
	                        original: { line: 1, column: 0 },
	                        generated: { line: line, column: column - 1 }
	                    });
	                }
	            }
	
	            lines = str.match(/\n/g);
	            if (lines) {
	                line += lines.length;
	                last = str.lastIndexOf('\n');
	                column = str.length - last;
	            } else {
	                column += str.length;
	            }
	
	            if (node && type !== 'start') {
	                if (node.source && node.source.end) {
	                    _this3.map.addMapping({
	                        source: _this3.sourcePath(node),
	                        generated: { line: line, column: column - 1 },
	                        original: {
	                            line: node.source.end.line,
	                            column: node.source.end.column
	                        }
	                    });
	                } else {
	                    _this3.map.addMapping({
	                        source: '<no source>',
	                        original: { line: 1, column: 0 },
	                        generated: { line: line, column: column - 1 }
	                    });
	                }
	            }
	        });
	    };
	
	    MapGenerator.prototype.generate = function generate() {
	        this.clearAnnotation();
	
	        if (this.isMap()) {
	            return this.generateMap();
	        } else {
	            var result = '';
	            this.stringify(this.root, function (i) {
	                result += i;
	            });
	            return [result];
	        }
	    };
	
	    return MapGenerator;
	}();
	
	exports.default = MapGenerator;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 1482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _declaration = __webpack_require__(316);
	
	var _declaration2 = _interopRequireDefault(_declaration);
	
	var _tokenize = __webpack_require__(464);
	
	var _tokenize2 = _interopRequireDefault(_tokenize);
	
	var _comment = __webpack_require__(314);
	
	var _comment2 = _interopRequireDefault(_comment);
	
	var _atRule = __webpack_require__(215);
	
	var _atRule2 = _interopRequireDefault(_atRule);
	
	var _root = __webpack_require__(319);
	
	var _root2 = _interopRequireDefault(_root);
	
	var _rule = __webpack_require__(216);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Parser = function () {
	    function Parser(input) {
	        _classCallCheck(this, Parser);
	
	        this.input = input;
	
	        this.pos = 0;
	        this.root = new _root2.default();
	        this.current = this.root;
	        this.spaces = '';
	        this.semicolon = false;
	
	        this.root.source = { input: input, start: { line: 1, column: 1 } };
	    }
	
	    Parser.prototype.tokenize = function tokenize() {
	        this.tokens = (0, _tokenize2.default)(this.input);
	    };
	
	    Parser.prototype.loop = function loop() {
	        var token = void 0;
	        while (this.pos < this.tokens.length) {
	            token = this.tokens[this.pos];
	
	            switch (token[0]) {
	
	                case 'space':
	                case ';':
	                    this.spaces += token[1];
	                    break;
	
	                case '}':
	                    this.end(token);
	                    break;
	
	                case 'comment':
	                    this.comment(token);
	                    break;
	
	                case 'at-word':
	                    this.atrule(token);
	                    break;
	
	                case '{':
	                    this.emptyRule(token);
	                    break;
	
	                default:
	                    this.other();
	                    break;
	            }
	
	            this.pos += 1;
	        }
	        this.endFile();
	    };
	
	    Parser.prototype.comment = function comment(token) {
	        var node = new _comment2.default();
	        this.init(node, token[2], token[3]);
	        node.source.end = { line: token[4], column: token[5] };
	
	        var text = token[1].slice(2, -2);
	        if (/^\s*$/.test(text)) {
	            node.text = '';
	            node.raws.left = text;
	            node.raws.right = '';
	        } else {
	            var match = text.match(/^(\s*)([^]*[^\s])(\s*)$/);
	            node.text = match[2];
	            node.raws.left = match[1];
	            node.raws.right = match[3];
	        }
	    };
	
	    Parser.prototype.emptyRule = function emptyRule(token) {
	        var node = new _rule2.default();
	        this.init(node, token[2], token[3]);
	        node.selector = '';
	        node.raws.between = '';
	        this.current = node;
	    };
	
	    Parser.prototype.other = function other() {
	        var token = void 0;
	        var end = false;
	        var type = null;
	        var colon = false;
	        var bracket = null;
	        var brackets = [];
	
	        var start = this.pos;
	        while (this.pos < this.tokens.length) {
	            token = this.tokens[this.pos];
	            type = token[0];
	
	            if (type === '(' || type === '[') {
	                if (!bracket) bracket = token;
	                brackets.push(type === '(' ? ')' : ']');
	            } else if (brackets.length === 0) {
	                if (type === ';') {
	                    if (colon) {
	                        this.decl(this.tokens.slice(start, this.pos + 1));
	                        return;
	                    } else {
	                        break;
	                    }
	                } else if (type === '{') {
	                    this.rule(this.tokens.slice(start, this.pos + 1));
	                    return;
	                } else if (type === '}') {
	                    this.pos -= 1;
	                    end = true;
	                    break;
	                } else if (type === ':') {
	                    colon = true;
	                }
	            } else if (type === brackets[brackets.length - 1]) {
	                brackets.pop();
	                if (brackets.length === 0) bracket = null;
	            }
	
	            this.pos += 1;
	        }
	        if (this.pos === this.tokens.length) {
	            this.pos -= 1;
	            end = true;
	        }
	
	        if (brackets.length > 0) this.unclosedBracket(bracket);
	
	        if (end && colon) {
	            while (this.pos > start) {
	                token = this.tokens[this.pos][0];
	                if (token !== 'space' && token !== 'comment') break;
	                this.pos -= 1;
	            }
	            this.decl(this.tokens.slice(start, this.pos + 1));
	            return;
	        }
	
	        this.unknownWord(start);
	    };
	
	    Parser.prototype.rule = function rule(tokens) {
	        tokens.pop();
	
	        var node = new _rule2.default();
	        this.init(node, tokens[0][2], tokens[0][3]);
	
	        node.raws.between = this.spacesAndCommentsFromEnd(tokens);
	        this.raw(node, 'selector', tokens);
	        this.current = node;
	    };
	
	    Parser.prototype.decl = function decl(tokens) {
	        var node = new _declaration2.default();
	        this.init(node);
	
	        var last = tokens[tokens.length - 1];
	        if (last[0] === ';') {
	            this.semicolon = true;
	            tokens.pop();
	        }
	        if (last[4]) {
	            node.source.end = { line: last[4], column: last[5] };
	        } else {
	            node.source.end = { line: last[2], column: last[3] };
	        }
	
	        while (tokens[0][0] !== 'word') {
	            node.raws.before += tokens.shift()[1];
	        }
	        node.source.start = { line: tokens[0][2], column: tokens[0][3] };
	
	        node.prop = '';
	        while (tokens.length) {
	            var type = tokens[0][0];
	            if (type === ':' || type === 'space' || type === 'comment') {
	                break;
	            }
	            node.prop += tokens.shift()[1];
	        }
	
	        node.raws.between = '';
	
	        var token = void 0;
	        while (tokens.length) {
	            token = tokens.shift();
	
	            if (token[0] === ':') {
	                node.raws.between += token[1];
	                break;
	            } else {
	                node.raws.between += token[1];
	            }
	        }
	
	        if (node.prop[0] === '_' || node.prop[0] === '*') {
	            node.raws.before += node.prop[0];
	            node.prop = node.prop.slice(1);
	        }
	        node.raws.between += this.spacesAndCommentsFromStart(tokens);
	        this.precheckMissedSemicolon(tokens);
	
	        for (var i = tokens.length - 1; i > 0; i--) {
	            token = tokens[i];
	            if (token[1] === '!important') {
	                node.important = true;
	                var string = this.stringFrom(tokens, i);
	                string = this.spacesFromEnd(tokens) + string;
	                if (string !== ' !important') node.raws.important = string;
	                break;
	            } else if (token[1] === 'important') {
	                var cache = tokens.slice(0);
	                var str = '';
	                for (var j = i; j > 0; j--) {
	                    var _type = cache[j][0];
	                    if (str.trim().indexOf('!') === 0 && _type !== 'space') {
	                        break;
	                    }
	                    str = cache.pop()[1] + str;
	                }
	                if (str.trim().indexOf('!') === 0) {
	                    node.important = true;
	                    node.raws.important = str;
	                    tokens = cache;
	                }
	            }
	
	            if (token[0] !== 'space' && token[0] !== 'comment') {
	                break;
	            }
	        }
	
	        this.raw(node, 'value', tokens);
	
	        if (node.value.indexOf(':') !== -1) this.checkMissedSemicolon(tokens);
	    };
	
	    Parser.prototype.atrule = function atrule(token) {
	        var node = new _atRule2.default();
	        node.name = token[1].slice(1);
	        if (node.name === '') {
	            this.unnamedAtrule(node, token);
	        }
	        this.init(node, token[2], token[3]);
	
	        var last = false;
	        var open = false;
	        var params = [];
	
	        this.pos += 1;
	        while (this.pos < this.tokens.length) {
	            token = this.tokens[this.pos];
	
	            if (token[0] === ';') {
	                node.source.end = { line: token[2], column: token[3] };
	                this.semicolon = true;
	                break;
	            } else if (token[0] === '{') {
	                open = true;
	                break;
	            } else if (token[0] === '}') {
	                this.end(token);
	                break;
	            } else {
	                params.push(token);
	            }
	
	            this.pos += 1;
	        }
	        if (this.pos === this.tokens.length) {
	            last = true;
	        }
	
	        node.raws.between = this.spacesAndCommentsFromEnd(params);
	        if (params.length) {
	            node.raws.afterName = this.spacesAndCommentsFromStart(params);
	            this.raw(node, 'params', params);
	            if (last) {
	                token = params[params.length - 1];
	                node.source.end = { line: token[4], column: token[5] };
	                this.spaces = node.raws.between;
	                node.raws.between = '';
	            }
	        } else {
	            node.raws.afterName = '';
	            node.params = '';
	        }
	
	        if (open) {
	            node.nodes = [];
	            this.current = node;
	        }
	    };
	
	    Parser.prototype.end = function end(token) {
	        if (this.current.nodes && this.current.nodes.length) {
	            this.current.raws.semicolon = this.semicolon;
	        }
	        this.semicolon = false;
	
	        this.current.raws.after = (this.current.raws.after || '') + this.spaces;
	        this.spaces = '';
	
	        if (this.current.parent) {
	            this.current.source.end = { line: token[2], column: token[3] };
	            this.current = this.current.parent;
	        } else {
	            this.unexpectedClose(token);
	        }
	    };
	
	    Parser.prototype.endFile = function endFile() {
	        if (this.current.parent) this.unclosedBlock();
	        if (this.current.nodes && this.current.nodes.length) {
	            this.current.raws.semicolon = this.semicolon;
	        }
	        this.current.raws.after = (this.current.raws.after || '') + this.spaces;
	    };
	
	    // Helpers
	
	    Parser.prototype.init = function init(node, line, column) {
	        this.current.push(node);
	
	        node.source = { start: { line: line, column: column }, input: this.input };
	        node.raws.before = this.spaces;
	        this.spaces = '';
	        if (node.type !== 'comment') this.semicolon = false;
	    };
	
	    Parser.prototype.raw = function raw(node, prop, tokens) {
	        var token = void 0,
	            type = void 0;
	        var length = tokens.length;
	        var value = '';
	        var clean = true;
	        for (var i = 0; i < length; i += 1) {
	            token = tokens[i];
	            type = token[0];
	            if (type === 'comment' || type === 'space' && i === length - 1) {
	                clean = false;
	            } else {
	                value += token[1];
	            }
	        }
	        if (!clean) {
	            var raw = tokens.reduce(function (all, i) {
	                return all + i[1];
	            }, '');
	            node.raws[prop] = { value: value, raw: raw };
	        }
	        node[prop] = value;
	    };
	
	    Parser.prototype.spacesAndCommentsFromEnd = function spacesAndCommentsFromEnd(tokens) {
	        var lastTokenType = void 0;
	        var spaces = '';
	        while (tokens.length) {
	            lastTokenType = tokens[tokens.length - 1][0];
	            if (lastTokenType !== 'space' && lastTokenType !== 'comment') break;
	            spaces = tokens.pop()[1] + spaces;
	        }
	        return spaces;
	    };
	
	    Parser.prototype.spacesAndCommentsFromStart = function spacesAndCommentsFromStart(tokens) {
	        var next = void 0;
	        var spaces = '';
	        while (tokens.length) {
	            next = tokens[0][0];
	            if (next !== 'space' && next !== 'comment') break;
	            spaces += tokens.shift()[1];
	        }
	        return spaces;
	    };
	
	    Parser.prototype.spacesFromEnd = function spacesFromEnd(tokens) {
	        var lastTokenType = void 0;
	        var spaces = '';
	        while (tokens.length) {
	            lastTokenType = tokens[tokens.length - 1][0];
	            if (lastTokenType !== 'space') break;
	            spaces = tokens.pop()[1] + spaces;
	        }
	        return spaces;
	    };
	
	    Parser.prototype.stringFrom = function stringFrom(tokens, from) {
	        var result = '';
	        for (var i = from; i < tokens.length; i++) {
	            result += tokens[i][1];
	        }
	        tokens.splice(from, tokens.length - from);
	        return result;
	    };
	
	    Parser.prototype.colon = function colon(tokens) {
	        var brackets = 0;
	        var token = void 0,
	            type = void 0,
	            prev = void 0;
	        for (var i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            type = token[0];
	
	            if (type === '(') {
	                brackets += 1;
	            } else if (type === ')') {
	                brackets -= 1;
	            } else if (brackets === 0 && type === ':') {
	                if (!prev) {
	                    this.doubleColon(token);
	                } else if (prev[0] === 'word' && prev[1] === 'progid') {
	                    continue;
	                } else {
	                    return i;
	                }
	            }
	
	            prev = token;
	        }
	        return false;
	    };
	
	    // Errors
	
	    Parser.prototype.unclosedBracket = function unclosedBracket(bracket) {
	        throw this.input.error('Unclosed bracket', bracket[2], bracket[3]);
	    };
	
	    Parser.prototype.unknownWord = function unknownWord(start) {
	        var token = this.tokens[start];
	        throw this.input.error('Unknown word', token[2], token[3]);
	    };
	
	    Parser.prototype.unexpectedClose = function unexpectedClose(token) {
	        throw this.input.error('Unexpected }', token[2], token[3]);
	    };
	
	    Parser.prototype.unclosedBlock = function unclosedBlock() {
	        var pos = this.current.source.start;
	        throw this.input.error('Unclosed block', pos.line, pos.column);
	    };
	
	    Parser.prototype.doubleColon = function doubleColon(token) {
	        throw this.input.error('Double colon', token[2], token[3]);
	    };
	
	    Parser.prototype.unnamedAtrule = function unnamedAtrule(node, token) {
	        throw this.input.error('At-rule without name', token[2], token[3]);
	    };
	
	    Parser.prototype.precheckMissedSemicolon = function precheckMissedSemicolon(tokens) {
	        // Hook for Safe Parser
	        tokens;
	    };
	
	    Parser.prototype.checkMissedSemicolon = function checkMissedSemicolon(tokens) {
	        var colon = this.colon(tokens);
	        if (colon === false) return;
	
	        var founded = 0;
	        var token = void 0;
	        for (var j = colon - 1; j >= 0; j--) {
	            token = tokens[j];
	            if (token[0] !== 'space') {
	                founded += 1;
	                if (founded === 2) break;
	            }
	        }
	        throw this.input.error('Missed semicolon', token[2], token[3]);
	    };
	
	    return Parser;
	}();
	
	exports.default = Parser;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _jsBase = __webpack_require__(434);
	
	var _sourceMap = __webpack_require__(552);
	
	var _sourceMap2 = _interopRequireDefault(_sourceMap);
	
	var _path = __webpack_require__(168);
	
	var _path2 = _interopRequireDefault(_path);
	
	var _fs = __webpack_require__(1727);
	
	var _fs2 = _interopRequireDefault(_fs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Source map information from input CSS.
	 * For example, source map after Sass compiler.
	 *
	 * This class will automatically find source map in input CSS or in file system
	 * near input file (according `from` option).
	 *
	 * @example
	 * const root = postcss.parse(css, { from: 'a.sass.css' });
	 * root.input.map //=> PreviousMap
	 */
	var PreviousMap = function () {
	
	    /**
	     * @param {string}         css    - input CSS source
	     * @param {processOptions} [opts] - {@link Processor#process} options
	     */
	    function PreviousMap(css, opts) {
	        _classCallCheck(this, PreviousMap);
	
	        this.loadAnnotation(css);
	        /**
	         * @member {boolean} - Was source map inlined by data-uri to input CSS.
	         */
	        this.inline = this.startWith(this.annotation, 'data:');
	
	        var prev = opts.map ? opts.map.prev : undefined;
	        var text = this.loadMap(opts.from, prev);
	        if (text) this.text = text;
	    }
	
	    /**
	     * Create a instance of `SourceMapGenerator` class
	     * from the `source-map` library to work with source map information.
	     *
	     * It is lazy method, so it will create object only on first call
	     * and then it will use cache.
	     *
	     * @return {SourceMapGenerator} object with source map information
	     */
	
	
	    PreviousMap.prototype.consumer = function consumer() {
	        if (!this.consumerCache) {
	            this.consumerCache = new _sourceMap2.default.SourceMapConsumer(this.text);
	        }
	        return this.consumerCache;
	    };
	
	    /**
	     * Does source map contains `sourcesContent` with input source text.
	     *
	     * @return {boolean} Is `sourcesContent` present
	     */
	
	
	    PreviousMap.prototype.withContent = function withContent() {
	        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
	    };
	
	    PreviousMap.prototype.startWith = function startWith(string, start) {
	        if (!string) return false;
	        return string.substr(0, start.length) === start;
	    };
	
	    PreviousMap.prototype.loadAnnotation = function loadAnnotation(css) {
	        var match = css.match(/\/\*\s*# sourceMappingURL=(.*)\s*\*\//);
	        if (match) this.annotation = match[1].trim();
	    };
	
	    PreviousMap.prototype.decodeInline = function decodeInline(text) {
	        var utfd64 = 'data:application/json;charset=utf-8;base64,';
	        var utf64 = 'data:application/json;charset=utf8;base64,';
	        var b64 = 'data:application/json;base64,';
	        var uri = 'data:application/json,';
	
	        if (this.startWith(text, uri)) {
	            return decodeURIComponent(text.substr(uri.length));
	        } else if (this.startWith(text, b64)) {
	            return _jsBase.Base64.decode(text.substr(b64.length));
	        } else if (this.startWith(text, utf64)) {
	            return _jsBase.Base64.decode(text.substr(utf64.length));
	        } else if (this.startWith(text, utfd64)) {
	            return _jsBase.Base64.decode(text.substr(utfd64.length));
	        } else {
	            var encoding = text.match(/data:application\/json;([^,]+),/)[1];
	            throw new Error('Unsupported source map encoding ' + encoding);
	        }
	    };
	
	    PreviousMap.prototype.loadMap = function loadMap(file, prev) {
	        if (prev === false) return false;
	
	        if (prev) {
	            if (typeof prev === 'string') {
	                return prev;
	            } else if (typeof prev === 'function') {
	                var prevPath = prev(file);
	                if (prevPath && _fs2.default.existsSync && _fs2.default.existsSync(prevPath)) {
	                    return _fs2.default.readFileSync(prevPath, 'utf-8').toString().trim();
	                } else {
	                    throw new Error('Unable to load previous source map: ' + prevPath.toString());
	                }
	            } else if (prev instanceof _sourceMap2.default.SourceMapConsumer) {
	                return _sourceMap2.default.SourceMapGenerator.fromSourceMap(prev).toString();
	            } else if (prev instanceof _sourceMap2.default.SourceMapGenerator) {
	                return prev.toString();
	            } else if (this.isMap(prev)) {
	                return JSON.stringify(prev);
	            } else {
	                throw new Error('Unsupported previous source map format: ' + prev.toString());
	            }
	        } else if (this.inline) {
	            return this.decodeInline(this.annotation);
	        } else if (this.annotation) {
	            var map = this.annotation;
	            if (file) map = _path2.default.join(_path2.default.dirname(file), map);
	
	            this.root = _path2.default.dirname(map);
	            if (_fs2.default.existsSync && _fs2.default.existsSync(map)) {
	                return _fs2.default.readFileSync(map, 'utf-8').toString().trim();
	            } else {
	                return false;
	            }
	        }
	    };
	
	    PreviousMap.prototype.isMap = function isMap(map) {
	        if ((typeof map === 'undefined' ? 'undefined' : _typeof(map)) !== 'object') return false;
	        return typeof map.mappings === 'string' || typeof map._mappings === 'string';
	    };
	
	    return PreviousMap;
	}();
	
	exports.default = PreviousMap;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 1484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _warning = __webpack_require__(1486);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Provides the result of the PostCSS transformations.
	 *
	 * A Result instance is returned by {@link LazyResult#then}
	 * or {@link Root#toResult} methods.
	 *
	 * @example
	 * postcss([cssnext]).process(css).then(function (result) {
	 *    console.log(result.css);
	 * });
	 *
	 * @example
	 * var result2 = postcss.parse(css).toResult();
	 */
	var Result = function () {
	
	  /**
	   * @param {Processor} processor - processor used for this transformation.
	   * @param {Root}      root      - Root node after all transformations.
	   * @param {processOptions} opts - options from the {@link Processor#process}
	   *                                or {@link Root#toResult}
	   */
	  function Result(processor, root, opts) {
	    _classCallCheck(this, Result);
	
	    /**
	     * @member {Processor} - The Processor instance used
	     *                       for this transformation.
	     *
	     * @example
	     * for ( let plugin of result.processor.plugins) {
	     *   if ( plugin.postcssPlugin === 'postcss-bad' ) {
	     *     throw 'postcss-good is incompatible with postcss-bad';
	     *   }
	     * });
	     */
	    this.processor = processor;
	    /**
	     * @member {Message[]} - Contains messages from plugins
	     *                       (e.g., warnings or custom messages).
	     *                       Each message should have type
	     *                       and plugin properties.
	     *
	     * @example
	     * postcss.plugin('postcss-min-browser', () => {
	     *   return (root, result) => {
	     *     var browsers = detectMinBrowsersByCanIUse(root);
	     *     result.messages.push({
	     *       type:    'min-browser',
	     *       plugin:  'postcss-min-browser',
	     *       browsers: browsers
	     *     });
	     *   };
	     * });
	     */
	    this.messages = [];
	    /**
	     * @member {Root} - Root node after all transformations.
	     *
	     * @example
	     * root.toResult().root == root;
	     */
	    this.root = root;
	    /**
	     * @member {processOptions} - Options from the {@link Processor#process}
	     *                            or {@link Root#toResult} call
	     *                            that produced this Result instance.
	     *
	     * @example
	     * root.toResult(opts).opts == opts;
	     */
	    this.opts = opts;
	    /**
	     * @member {string} - A CSS string representing of {@link Result#root}.
	     *
	     * @example
	     * postcss.parse('a{}').toResult().css //=> "a{}"
	     */
	    this.css = undefined;
	    /**
	     * @member {SourceMapGenerator} - An instance of `SourceMapGenerator`
	     *                                class from the `source-map` library,
	     *                                representing changes
	     *                                to the {@link Result#root} instance.
	     *
	     * @example
	     * result.map.toJSON() //=> { version: 3, file: 'a.css', … }
	     *
	     * @example
	     * if ( result.map ) {
	     *   fs.writeFileSync(result.opts.to + '.map', result.map.toString());
	     * }
	     */
	    this.map = undefined;
	  }
	
	  /**
	   * Returns for @{link Result#css} content.
	   *
	   * @example
	   * result + '' === result.css
	   *
	   * @return {string} string representing of {@link Result#root}
	   */
	
	
	  Result.prototype.toString = function toString() {
	    return this.css;
	  };
	
	  /**
	   * Creates an instance of {@link Warning} and adds it
	   * to {@link Result#messages}.
	   *
	   * @param {string} text        - warning message
	   * @param {Object} [opts]      - warning options
	   * @param {Node}   opts.node   - CSS node that caused the warning
	   * @param {string} opts.word   - word in CSS source that caused the warning
	   * @param {number} opts.index  - index in CSS node string that caused
	   *                               the warning
	   * @param {string} opts.plugin - name of the plugin that created
	   *                               this warning. {@link Result#warn} fills
	   *                               this property automatically.
	   *
	   * @return {Warning} created warning
	   */
	
	
	  Result.prototype.warn = function warn(text) {
	    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (!opts.plugin) {
	      if (this.lastPlugin && this.lastPlugin.postcssPlugin) {
	        opts.plugin = this.lastPlugin.postcssPlugin;
	      }
	    }
	
	    var warning = new _warning2.default(text, opts);
	    this.messages.push(warning);
	
	    return warning;
	  };
	
	  /**
	   * Returns warnings from plugins. Filters {@link Warning} instances
	   * from {@link Result#messages}.
	   *
	   * @example
	   * result.warnings().forEach(warn => {
	   *   console.warn(warn.toString());
	   * });
	   *
	   * @return {Warning[]} warnings from plugins
	   */
	
	
	  Result.prototype.warnings = function warnings() {
	    return this.messages.filter(function (i) {
	      return i.type === 'warning';
	    });
	  };
	
	  /**
	   * An alias for the {@link Result#css} property.
	   * Use it with syntaxes that generate non-CSS output.
	   * @type {string}
	   *
	   * @example
	   * result.css === result.content;
	   */
	
	
	  _createClass(Result, [{
	    key: 'content',
	    get: function get() {
	      return this.css;
	    }
	  }]);
	
	  return Result;
	}();
	
	exports.default = Result;
	
	/**
	 * @typedef  {object} Message
	 * @property {string} type   - message type
	 * @property {string} plugin - source PostCSS plugin name
	 */
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 1485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _chalk = __webpack_require__(363);
	
	var _chalk2 = _interopRequireDefault(_chalk);
	
	var _tokenize = __webpack_require__(464);
	
	var _tokenize2 = _interopRequireDefault(_tokenize);
	
	var _input = __webpack_require__(460);
	
	var _input2 = _interopRequireDefault(_input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var colors = new _chalk2.default.constructor({ enabled: true });
	
	var HIGHLIGHT_THEME = {
	    'brackets': colors.cyan,
	    'at-word': colors.cyan,
	    'call': colors.cyan,
	    'comment': colors.gray,
	    'string': colors.green,
	    'class': colors.yellow,
	    'hash': colors.magenta,
	    '(': colors.cyan,
	    ')': colors.cyan,
	    '{': colors.yellow,
	    '}': colors.yellow,
	    '[': colors.yellow,
	    ']': colors.yellow,
	    ':': colors.yellow,
	    ';': colors.yellow
	};
	
	function getTokenType(_ref, index, tokens) {
	    var type = _ref[0],
	        value = _ref[1];
	
	    if (type === 'word') {
	        if (value[0] === '.') {
	            return 'class';
	        }
	        if (value[0] === '#') {
	            return 'hash';
	        }
	    }
	
	    var nextToken = tokens[index + 1];
	    if (nextToken && (nextToken[0] === 'brackets' || nextToken[0] === '(')) {
	        return 'call';
	    }
	
	    return type;
	}
	
	function terminalHighlight(css) {
	    var tokens = (0, _tokenize2.default)(new _input2.default(css), { ignoreErrors: true });
	    return tokens.map(function (token, index) {
	        var color = HIGHLIGHT_THEME[getTokenType(token, index, tokens)];
	        if (color) {
	            return token[1].split(/\r?\n/).map(function (i) {
	                return color(i);
	            }).join('\n');
	        } else {
	            return token[1];
	        }
	    }).join('');
	}
	
	exports.default = terminalHighlight;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 1486 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Represents a plugin’s warning. It can be created using {@link Node#warn}.
	 *
	 * @example
	 * if ( decl.important ) {
	 *     decl.warn(result, 'Avoid !important', { word: '!important' });
	 * }
	 */
	var Warning = function () {
	
	  /**
	   * @param {string} text        - warning message
	   * @param {Object} [opts]      - warning options
	   * @param {Node}   opts.node   - CSS node that caused the warning
	   * @param {string} opts.word   - word in CSS source that caused the warning
	   * @param {number} opts.index  - index in CSS node string that caused
	   *                               the warning
	   * @param {string} opts.plugin - name of the plugin that created
	   *                               this warning. {@link Result#warn} fills
	   *                               this property automatically.
	   */
	  function Warning(text) {
	    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Warning);
	
	    /**
	     * @member {string} - Type to filter warnings from
	     *                    {@link Result#messages}. Always equal
	     *                    to `"warning"`.
	     *
	     * @example
	     * const nonWarning = result.messages.filter(i => i.type !== 'warning')
	     */
	    this.type = 'warning';
	    /**
	     * @member {string} - The warning message.
	     *
	     * @example
	     * warning.text //=> 'Try to avoid !important'
	     */
	    this.text = text;
	
	    if (opts.node && opts.node.source) {
	      var pos = opts.node.positionBy(opts);
	      /**
	       * @member {number} - Line in the input file
	       *                    with this warning’s source
	       *
	       * @example
	       * warning.line //=> 5
	       */
	      this.line = pos.line;
	      /**
	       * @member {number} - Column in the input file
	       *                    with this warning’s source.
	       *
	       * @example
	       * warning.column //=> 6
	       */
	      this.column = pos.column;
	    }
	
	    for (var opt in opts) {
	      this[opt] = opts[opt];
	    }
	  }
	
	  /**
	   * Returns a warning position and message.
	   *
	   * @example
	   * warning.toString() //=> 'postcss-lint:a.css:10:14: Avoid !important'
	   *
	   * @return {string} warning position and message
	   */
	
	
	  Warning.prototype.toString = function toString() {
	    if (this.node) {
	      return this.node.error(this.text, {
	        plugin: this.plugin,
	        index: this.index,
	        word: this.word
	      }).message;
	    } else if (this.plugin) {
	      return this.plugin + ': ' + this.text;
	    } else {
	      return this.text;
	    }
	  };
	
	  /**
	   * @memberof Warning#
	   * @member {string} plugin - The name of the plugin that created
	   *                           it will fill this property automatically.
	   *                           this warning. When you call {@link Node#warn}
	   *
	   * @example
	   * warning.plugin //=> 'postcss-important'
	   */
	
	  /**
	   * @memberof Warning#
	   * @member {Node} node - Contains the CSS node that caused the warning.
	   *
	   * @example
	   * warning.node.toString() //=> 'color: white !important'
	   */
	
	  return Warning;
	}();
	
	exports.default = Warning;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 1487 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	  var has = Function.call.bind(Object.prototype.hasOwnProperty);
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (false) {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 1488 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(466);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1489 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(517);
	var assign = __webpack_require__(1490);
	
	var ReactPropTypesSecret = __webpack_require__(466);
	var checkPropTypes = __webpack_require__(1487);
	
	var has = Function.call.bind(Object.prototype.hasOwnProperty);
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (false) {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1490 */
938,
/* 1491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(1717);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelGroup = __webpack_require__(484);
	
	var _PanelGroup2 = _interopRequireDefault(_PanelGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Accordion = function (_React$Component) {
	  (0, _inherits3['default'])(Accordion, _React$Component);
	
	  function Accordion() {
	    (0, _classCallCheck3['default'])(this, Accordion);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Accordion.prototype.render = function render() {
	    return _react2['default'].createElement(
	      _PanelGroup2['default'],
	      (0, _extends3['default'])({}, this.props, { accordion: true }),
	      this.props.children
	    );
	  };
	
	  return Accordion;
	}(_react2['default'].Component);
	
	exports['default'] = Accordion;
	module.exports = exports['default'];

/***/ },
/* 1493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(119);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onDismiss: _propTypes2['default'].func,
	  closeLabel: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  closeLabel: 'Close alert'
	};
	
	var Alert = function (_React$Component) {
	  (0, _inherits3['default'])(Alert, _React$Component);
	
	  function Alert() {
	    (0, _classCallCheck3['default'])(this, Alert);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Alert.prototype.renderDismissButton = function renderDismissButton(onDismiss) {
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close',
	        onClick: onDismiss,
	        'aria-hidden': 'true',
	        tabIndex: '-1'
	      },
	      _react2['default'].createElement(
	        'span',
	        null,
	        '\xD7'
	      )
	    );
	  };
	
	  Alert.prototype.renderSrOnlyDismissButton = function renderSrOnlyDismissButton(onDismiss, closeLabel) {
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close sr-only',
	        onClick: onDismiss
	      },
	      closeLabel
	    );
	  };
	
	  Alert.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        onDismiss = _props.onDismiss,
	        closeLabel = _props.closeLabel,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onDismiss', 'closeLabel', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var dismissable = !!onDismiss;
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dismissable')] = dismissable, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'alert',
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      dismissable && this.renderDismissButton(onDismiss),
	      children,
	      dismissable && this.renderSrOnlyDismissButton(onDismiss, closeLabel)
	    );
	  };
	
	  return Alert;
	}(_react2['default'].Component);
	
	Alert.propTypes = propTypes;
	Alert.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), _StyleConfig.State.INFO, (0, _bootstrapUtils.bsClass)('alert', Alert));
	module.exports = exports['default'];

/***/ },
/* 1494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `pullRight` doesn't belong here. There's no special handling here.
	
	var propTypes = {
	  pullRight: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  pullRight: false
	};
	
	var Badge = function (_React$Component) {
	  (0, _inherits3['default'])(Badge, _React$Component);
	
	  function Badge() {
	    (0, _classCallCheck3['default'])(this, Badge);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Badge.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2['default'].Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Badge.prototype.render = function render() {
	    var _props = this.props,
	        pullRight = _props.pullRight,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['pullRight', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'pull-right': pullRight,
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Badge;
	}(_react2['default'].Component);
	
	Badge.propTypes = propTypes;
	Badge.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('badge', Badge);
	module.exports = exports['default'];

/***/ },
/* 1495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BreadcrumbItem = __webpack_require__(468);
	
	var _BreadcrumbItem2 = _interopRequireDefault(_BreadcrumbItem);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Breadcrumb = function (_React$Component) {
	  (0, _inherits3['default'])(Breadcrumb, _React$Component);
	
	  function Breadcrumb() {
	    (0, _classCallCheck3['default'])(this, Breadcrumb);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Breadcrumb.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('ol', (0, _extends3['default'])({}, elementProps, {
	      role: 'navigation',
	      'aria-label': 'breadcrumbs',
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Breadcrumb;
	}(_react2['default'].Component);
	
	Breadcrumb.Item = _BreadcrumbItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('breadcrumb', Breadcrumb);
	module.exports = exports['default'];

/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(170);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ButtonToolbar = function (_React$Component) {
	  (0, _inherits3['default'])(ButtonToolbar, _React$Component);
	
	  function ButtonToolbar() {
	    (0, _classCallCheck3['default'])(this, ButtonToolbar);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonToolbar.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      role: 'toolbar',
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ButtonToolbar;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn-toolbar', (0, _bootstrapUtils.bsSizes)(_Button2['default'].SIZES, ButtonToolbar));
	module.exports = exports['default'];

/***/ },
/* 1497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CarouselCaption = __webpack_require__(1498);
	
	var _CarouselCaption2 = _interopRequireDefault(_CarouselCaption);
	
	var _CarouselItem = __webpack_require__(470);
	
	var _CarouselItem2 = _interopRequireDefault(_CarouselItem);
	
	var _Glyphicon = __webpack_require__(322);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _SafeAnchor = __webpack_require__(69);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _ValidComponentChildren = __webpack_require__(45);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `slide` should be `animate`.
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  slide: _propTypes2['default'].bool,
	  indicators: _propTypes2['default'].bool,
	  interval: _propTypes2['default'].number,
	  controls: _propTypes2['default'].bool,
	  pauseOnHover: _propTypes2['default'].bool,
	  wrap: _propTypes2['default'].bool,
	  /**
	   * Callback fired when the active item changes.
	   *
	   * ```js
	   * (eventKey: any) => any | (eventKey: any, event: Object) => any
	   * ```
	   *
	   * If this callback takes two or more arguments, the second argument will
	   * be a persisted event object with `direction` set to the direction of the
	   * transition.
	   */
	  onSelect: _propTypes2['default'].func,
	  onSlideEnd: _propTypes2['default'].func,
	  activeIndex: _propTypes2['default'].number,
	  defaultActiveIndex: _propTypes2['default'].number,
	  direction: _propTypes2['default'].oneOf(['prev', 'next']),
	  prevIcon: _propTypes2['default'].node,
	  /**
	   * Label shown to screen readers only, can be used to show the previous element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  prevLabel: _propTypes2['default'].string,
	  nextIcon: _propTypes2['default'].node,
	  /**
	   * Label shown to screen readers only, can be used to show the next element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  nextLabel: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  slide: true,
	  interval: 5000,
	  pauseOnHover: true,
	  wrap: true,
	  indicators: true,
	  controls: true,
	  prevIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-left' }),
	  prevLabel: 'Previous',
	  nextIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-right' }),
	  nextLabel: 'Next'
	};
	
	var Carousel = function (_React$Component) {
	  (0, _inherits3['default'])(Carousel, _React$Component);
	
	  function Carousel(props, context) {
	    (0, _classCallCheck3['default'])(this, Carousel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    _this.handlePrev = _this.handlePrev.bind(_this);
	    _this.handleNext = _this.handleNext.bind(_this);
	    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(_this);
	
	    var defaultActiveIndex = props.defaultActiveIndex;
	
	
	    _this.state = {
	      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
	      previousActiveIndex: null,
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  Carousel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var activeIndex = this.getActiveIndex();
	
	    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
	      clearTimeout(this.timeout);
	
	      this.setState({
	        previousActiveIndex: activeIndex,
	        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
	      });
	    }
	  };
	
	  Carousel.prototype.componentDidMount = function componentDidMount() {
	    this.waitForNext();
	  };
	
	  Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearTimeout(this.timeout);
	    this.isUnmounted = true;
	  };
	
	  Carousel.prototype.handleMouseOver = function handleMouseOver() {
	    if (this.props.pauseOnHover) {
	      this.pause();
	    }
	  };
	
	  Carousel.prototype.handleMouseOut = function handleMouseOut() {
	    if (this.isPaused) {
	      this.play();
	    }
	  };
	
	  Carousel.prototype.handlePrev = function handlePrev(e) {
	    var index = this.getActiveIndex() - 1;
	
	    if (index < 0) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = _ValidComponentChildren2['default'].count(this.props.children) - 1;
	    }
	
	    this.select(index, e, 'prev');
	  };
	
	  Carousel.prototype.handleNext = function handleNext(e) {
	    var index = this.getActiveIndex() + 1;
	    var count = _ValidComponentChildren2['default'].count(this.props.children);
	
	    if (index > count - 1) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = 0;
	    }
	
	    this.select(index, e, 'next');
	  };
	
	  Carousel.prototype.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
	    var _this2 = this;
	
	    this.setState({
	      previousActiveIndex: null,
	      direction: null
	    }, function () {
	      _this2.waitForNext();
	
	      if (_this2.props.onSlideEnd) {
	        _this2.props.onSlideEnd();
	      }
	    });
	  };
	
	  Carousel.prototype.getActiveIndex = function getActiveIndex() {
	    var activeIndexProp = this.props.activeIndex;
	    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
	  };
	
	  Carousel.prototype.getDirection = function getDirection(prevIndex, index) {
	    if (prevIndex === index) {
	      return null;
	    }
	
	    return prevIndex > index ? 'prev' : 'next';
	  };
	
	  Carousel.prototype.select = function select(index, e, direction) {
	    clearTimeout(this.timeout);
	
	    // TODO: Is this necessary? Seems like the only risk is if the component
	    // unmounts while handleItemAnimateOutEnd fires.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
	    direction = direction || this.getDirection(previousActiveIndex, index);
	
	    var onSelect = this.props.onSelect;
	
	
	    if (onSelect) {
	      if (onSelect.length > 1) {
	        // React SyntheticEvents are pooled, so we need to remove this event
	        // from the pool to add a custom property. To avoid unnecessarily
	        // removing objects from the pool, only do this when the listener
	        // actually wants the event.
	        if (e) {
	          e.persist();
	          e.direction = direction;
	        } else {
	          e = { direction: direction };
	        }
	
	        onSelect(index, e);
	      } else {
	        onSelect(index);
	      }
	    }
	
	    if (this.props.activeIndex == null && index !== previousActiveIndex) {
	      if (this.state.previousActiveIndex != null) {
	        // If currently animating don't activate the new index.
	        // TODO: look into queueing this canceled call and
	        // animating after the current animation has ended.
	        return;
	      }
	
	      this.setState({
	        activeIndex: index,
	        previousActiveIndex: previousActiveIndex,
	        direction: direction
	      });
	    }
	  };
	
	  Carousel.prototype.waitForNext = function waitForNext() {
	    var _props = this.props,
	        slide = _props.slide,
	        interval = _props.interval,
	        activeIndexProp = _props.activeIndex;
	
	
	    if (!this.isPaused && slide && interval && activeIndexProp == null) {
	      this.timeout = setTimeout(this.handleNext, interval);
	    }
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.pause = function pause() {
	    this.isPaused = true;
	    clearTimeout(this.timeout);
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.play = function play() {
	    this.isPaused = false;
	    this.waitForNext();
	  };
	
	  Carousel.prototype.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
	    var _this3 = this;
	
	    var indicators = [];
	
	    _ValidComponentChildren2['default'].forEach(children, function (child, index) {
	      indicators.push(_react2['default'].createElement('li', {
	        key: index,
	        className: index === activeIndex ? 'active' : null,
	        onClick: function onClick(e) {
	          return _this3.select(index, e);
	        }
	      }),
	
	      // Force whitespace between indicator elements. Bootstrap requires
	      // this for correct spacing of elements.
	      ' ');
	    });
	
	    return _react2['default'].createElement(
	      'ol',
	      { className: (0, _bootstrapUtils.prefix)(bsProps, 'indicators') },
	      indicators
	    );
	  };
	
	  Carousel.prototype.renderControls = function renderControls(properties) {
	    var wrap = properties.wrap,
	        children = properties.children,
	        activeIndex = properties.activeIndex,
	        prevIcon = properties.prevIcon,
	        nextIcon = properties.nextIcon,
	        bsProps = properties.bsProps,
	        prevLabel = properties.prevLabel,
	        nextLabel = properties.nextLabel;
	
	    var controlClassName = (0, _bootstrapUtils.prefix)(bsProps, 'control');
	    var count = _ValidComponentChildren2['default'].count(children);
	
	    return [(wrap || activeIndex !== 0) && _react2['default'].createElement(
	      _SafeAnchor2['default'],
	      {
	        key: 'prev',
	        className: (0, _classnames2['default'])(controlClassName, 'left'),
	        onClick: this.handlePrev
	      },
	      prevIcon,
	      prevLabel && _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        prevLabel
	      )
	    ), (wrap || activeIndex !== count - 1) && _react2['default'].createElement(
	      _SafeAnchor2['default'],
	      {
	        key: 'next',
	        className: (0, _classnames2['default'])(controlClassName, 'right'),
	        onClick: this.handleNext
	      },
	      nextIcon,
	      nextLabel && _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        nextLabel
	      )
	    )];
	  };
	
	  Carousel.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props2 = this.props,
	        slide = _props2.slide,
	        indicators = _props2.indicators,
	        controls = _props2.controls,
	        wrap = _props2.wrap,
	        prevIcon = _props2.prevIcon,
	        prevLabel = _props2.prevLabel,
	        nextIcon = _props2.nextIcon,
	        nextLabel = _props2.nextLabel,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['slide', 'indicators', 'controls', 'wrap', 'prevIcon', 'prevLabel', 'nextIcon', 'nextLabel', 'className', 'children']);
	    var _state = this.state,
	        previousActiveIndex = _state.previousActiveIndex,
	        direction = _state.direction;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
	    'defaultActiveIndex', 'direction']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeIndex = this.getActiveIndex();
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      slide: slide
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes),
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut
	      }),
	      indicators && this.renderIndicators(children, activeIndex, bsProps),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        _ValidComponentChildren2['default'].map(children, function (child, index) {
	          var active = index === activeIndex;
	          var previousActive = slide && index === previousActiveIndex;
	
	          return (0, _react.cloneElement)(child, {
	            active: active,
	            index: index,
	            animateOut: previousActive,
	            animateIn: active && previousActiveIndex != null && slide,
	            direction: direction,
	            onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
	          });
	        })
	      ),
	      controls && this.renderControls({
	        wrap: wrap,
	        children: children,
	        activeIndex: activeIndex,
	        prevIcon: prevIcon,
	        prevLabel: prevLabel,
	        nextIcon: nextIcon,
	        nextLabel: nextLabel,
	        bsProps: bsProps
	      })
	    );
	  };
	
	  return Carousel;
	}(_react2['default'].Component);
	
	Carousel.propTypes = propTypes;
	Carousel.defaultProps = defaultProps;
	
	Carousel.Caption = _CarouselCaption2['default'];
	Carousel.Item = _CarouselItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('carousel', Carousel);
	module.exports = exports['default'];

/***/ },
/* 1498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var CarouselCaption = function (_React$Component) {
	  (0, _inherits3['default'])(CarouselCaption, _React$Component);
	
	  function CarouselCaption() {
	    (0, _classCallCheck3['default'])(this, CarouselCaption);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  CarouselCaption.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return CarouselCaption;
	}(_react2['default'].Component);
	
	CarouselCaption.propTypes = propTypes;
	CarouselCaption.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('carousel-caption', CarouselCaption);
	module.exports = exports['default'];

/***/ },
/* 1499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  inline: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes2['default'].oneOf(['success', 'warning', 'error', null]),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Checkbox inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  inline: false,
	  disabled: false
	};
	
	var Checkbox = function (_React$Component) {
	  (0, _inherits3['default'])(Checkbox, _React$Component);
	
	  function Checkbox() {
	    (0, _classCallCheck3['default'])(this, Checkbox);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Checkbox.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2['default'].createElement('input', (0, _extends3['default'])({}, elementProps, {
	      ref: inputRef,
	      type: 'checkbox',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2['default'])(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2['default'].createElement(
	        'label',
	        { className: (0, _classnames2['default'])(className, _classes), style: style },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(className, classes), style: style },
	      _react2['default'].createElement(
	        'label',
	        null,
	        input,
	        children
	      )
	    );
	  };
	
	  return Checkbox;
	}(_react2['default'].Component);
	
	Checkbox.propTypes = propTypes;
	Checkbox.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('checkbox', Checkbox);
	module.exports = exports['default'];

/***/ },
/* 1500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _capitalize = __webpack_require__(486);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _StyleConfig = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * Apply clearfix
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `visible-xs-block`
	   */
	  visibleXsBlock: _propTypes2['default'].bool,
	  /**
	   * Apply clearfix
	   *
	   * on Small devices Tablets
	   *
	   * adds class `visible-sm-block`
	   */
	  visibleSmBlock: _propTypes2['default'].bool,
	  /**
	   * Apply clearfix
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `visible-md-block`
	   */
	  visibleMdBlock: _propTypes2['default'].bool,
	  /**
	   * Apply clearfix
	   *
	   * on Large devices Desktops
	   *
	   * adds class `visible-lg-block`
	   */
	  visibleLgBlock: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Clearfix = function (_React$Component) {
	  (0, _inherits3['default'])(Clearfix, _React$Component);
	
	  function Clearfix() {
	    (0, _classCallCheck3['default'])(this, Clearfix);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Clearfix.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      var propName = 'visible' + (0, _capitalize2['default'])(size) + 'Block';
	      if (elementProps[propName]) {
	        classes['visible-' + size + '-block'] = true;
	      }
	
	      delete elementProps[propName];
	    });
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Clearfix;
	}(_react2['default'].Component);
	
	Clearfix.propTypes = propTypes;
	Clearfix.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('clearfix', Clearfix);
	module.exports = exports['default'];

/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Extra small devices Phones (<768px)
	   *
	   * class-prefix `col-xs-`
	   */
	  xs: _propTypes2['default'].number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Small devices Tablets (≥768px)
	   *
	   * class-prefix `col-sm-`
	   */
	  sm: _propTypes2['default'].number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Medium devices Desktops (≥992px)
	   *
	   * class-prefix `col-md-`
	   */
	  md: _propTypes2['default'].number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Large devices Desktops (≥1200px)
	   *
	   * class-prefix `col-lg-`
	   */
	  lg: _propTypes2['default'].number,
	  /**
	   * Hide column
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `hidden-xs`
	   */
	  xsHidden: _propTypes2['default'].bool,
	  /**
	   * Hide column
	   *
	   * on Small devices Tablets
	   *
	   * adds class `hidden-sm`
	   */
	  smHidden: _propTypes2['default'].bool,
	  /**
	   * Hide column
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `hidden-md`
	   */
	  mdHidden: _propTypes2['default'].bool,
	  /**
	   * Hide column
	   *
	   * on Large devices Desktops
	   *
	   * adds class `hidden-lg`
	   */
	  lgHidden: _propTypes2['default'].bool,
	  /**
	   * Move columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-offset-`
	   */
	  xsOffset: _propTypes2['default'].number,
	  /**
	   * Move columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-offset-`
	   */
	  smOffset: _propTypes2['default'].number,
	  /**
	   * Move columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-offset-`
	   */
	  mdOffset: _propTypes2['default'].number,
	  /**
	   * Move columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-offset-`
	   */
	  lgOffset: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-push-`
	   */
	  xsPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-push-`
	   */
	  smPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-push-`
	   */
	  mdPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-push-`
	   */
	  lgPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-pull-`
	   */
	  xsPull: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-pull-`
	   */
	  smPull: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-pull-`
	   */
	  mdPull: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-pull-`
	   */
	  lgPull: _propTypes2['default'].number
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Col = function (_React$Component) {
	  (0, _inherits3['default'])(Col, _React$Component);
	
	  function Col() {
	    (0, _classCallCheck3['default'])(this, Col);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Col.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      function popProp(propSuffix, modifier) {
	        var propName = '' + size + propSuffix;
	        var propValue = elementProps[propName];
	
	        if (propValue != null) {
	          classes.push((0, _bootstrapUtils.prefix)(bsProps, '' + size + modifier + '-' + propValue));
	        }
	
	        delete elementProps[propName];
	      }
	
	      popProp('', '');
	      popProp('Offset', '-offset');
	      popProp('Push', '-push');
	      popProp('Pull', '-pull');
	
	      var hiddenPropName = size + 'Hidden';
	      if (elementProps[hiddenPropName]) {
	        classes.push('hidden-' + size);
	      }
	      delete elementProps[hiddenPropName];
	    });
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Col;
	}(_react2['default'].Component);
	
	Col.propTypes = propTypes;
	Col.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('col', Col);
	module.exports = exports['default'];

/***/ },
/* 1502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  htmlFor: _propTypes2['default'].string,
	  srOnly: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  srOnly: false
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2['default'].object
	};
	
	var ControlLabel = function (_React$Component) {
	  (0, _inherits3['default'])(ControlLabel, _React$Component);
	
	  function ControlLabel() {
	    (0, _classCallCheck3['default'])(this, ControlLabel);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ControlLabel.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        _props$htmlFor = _props.htmlFor,
	        htmlFor = _props$htmlFor === undefined ? controlId : _props$htmlFor,
	        srOnly = _props.srOnly,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['htmlFor', 'srOnly', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'sr-only': srOnly
	    });
	
	    return _react2['default'].createElement('label', (0, _extends3['default'])({}, elementProps, {
	      htmlFor: htmlFor,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ControlLabel;
	}(_react2['default'].Component);
	
	ControlLabel.propTypes = propTypes;
	ControlLabel.defaultProps = defaultProps;
	ControlLabel.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('control-label', ControlLabel);
	module.exports = exports['default'];

/***/ },
/* 1503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Dropdown = __webpack_require__(217);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(219);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  bsStyle: _propTypes2['default'].string,
	  bsSize: _propTypes2['default'].string,
	  title: _propTypes2['default'].node.isRequired,
	  noCaret: _propTypes2['default'].bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2['default'].node
	});
	
	var DropdownButton = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownButton, _React$Component);
	
	  function DropdownButton() {
	    (0, _classCallCheck3['default'])(this, DropdownButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['bsSize', 'bsStyle', 'title', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        (0, _extends3['default'])({}, toggleProps, {
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return DropdownButton;
	}(_react2['default'].Component);
	
	DropdownButton.propTypes = propTypes;
	
	exports['default'] = DropdownButton;
	module.exports = exports['default'];

/***/ },
/* 1504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _from = __webpack_require__(683);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(302);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _RootCloseWrapper = __webpack_require__(519);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _createChainedFunction = __webpack_require__(34);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(45);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  open: _propTypes2['default'].bool,
	  pullRight: _propTypes2['default'].bool,
	  onClose: _propTypes2['default'].func,
	  labelledBy: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
	  onSelect: _propTypes2['default'].func,
	  rootCloseEvent: _propTypes2['default'].oneOf(['click', 'mousedown'])
	};
	
	var defaultProps = {
	  bsRole: 'menu',
	  pullRight: false
	};
	
	var DropdownMenu = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownMenu, _React$Component);
	
	  function DropdownMenu(props) {
	    (0, _classCallCheck3['default'])(this, DropdownMenu);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.handleRootClose = _this.handleRootClose.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    return _this;
	  }
	
	  DropdownMenu.prototype.handleRootClose = function handleRootClose(event) {
	    this.props.onClose(event, { source: 'rootClose' });
	  };
	
	  DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        this.focusNext();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.up:
	        this.focusPrevious();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.props.onClose(event, { source: 'keydown' });
	        break;
	      default:
	    }
	  };
	
	  DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
	    var items = this.getFocusableMenuItems();
	    var activeIndex = items.indexOf(document.activeElement);
	
	    return { items: items, activeIndex: activeIndex };
	  };
	
	  DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
	    var node = _reactDom2['default'].findDOMNode(this);
	    if (!node) {
	      return [];
	    }
	
	    return (0, _from2['default'])(node.querySelectorAll('[tabIndex="-1"]'));
	  };
	
	  DropdownMenu.prototype.focusNext = function focusNext() {
	    var _getItemsAndActiveInd = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd.items,
	        activeIndex = _getItemsAndActiveInd.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
	    items[nextIndex].focus();
	  };
	
	  DropdownMenu.prototype.focusPrevious = function focusPrevious() {
	    var _getItemsAndActiveInd2 = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd2.items,
	        activeIndex = _getItemsAndActiveInd2.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
	    items[prevIndex].focus();
	  };
	
	  DropdownMenu.prototype.render = function render() {
	    var _extends2,
	        _this2 = this;
	
	    var _props = this.props,
	        open = _props.open,
	        pullRight = _props.pullRight,
	        labelledBy = _props.labelledBy,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['open', 'pullRight', 'labelledBy', 'onSelect', 'className', 'rootCloseEvent', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['onClose']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'right')] = pullRight, _extends2));
	
	    return _react2['default'].createElement(
	      _RootCloseWrapper2['default'],
	      {
	        disabled: !open,
	        onRootClose: this.handleRootClose,
	        event: rootCloseEvent
	      },
	      _react2['default'].createElement(
	        'ul',
	        (0, _extends4['default'])({}, elementProps, {
	          role: 'menu',
	          className: (0, _classnames2['default'])(className, classes),
	          'aria-labelledby': labelledBy
	        }),
	        _ValidComponentChildren2['default'].map(children, function (child) {
	          return _react2['default'].cloneElement(child, {
	            onKeyDown: (0, _createChainedFunction2['default'])(child.props.onKeyDown, _this2.handleKeyDown),
	            onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect)
	          });
	        })
	      )
	    );
	  };
	
	  return DropdownMenu;
	}(_react2['default'].Component);
	
	DropdownMenu.propTypes = propTypes;
	DropdownMenu.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown-menu', DropdownMenu);
	module.exports = exports['default'];

/***/ },
/* 1505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  horizontal: _propTypes2['default'].bool,
	  inline: _propTypes2['default'].bool,
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  horizontal: false,
	  inline: false,
	  componentClass: 'form'
	};
	
	var Form = function (_React$Component) {
	  (0, _inherits3['default'])(Form, _React$Component);
	
	  function Form() {
	    (0, _classCallCheck3['default'])(this, Form);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Form.prototype.render = function render() {
	    var _props = this.props,
	        horizontal = _props.horizontal,
	        inline = _props.inline,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['horizontal', 'inline', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	    if (horizontal) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'horizontal'));
	    }
	    if (inline) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'inline'));
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Form;
	}(_react2['default'].Component);
	
	Form.propTypes = propTypes;
	Form.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form', Form);
	module.exports = exports['default'];

/***/ },
/* 1506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _FormControlFeedback = __webpack_require__(1507);
	
	var _FormControlFeedback2 = _interopRequireDefault(_FormControlFeedback);
	
	var _FormControlStatic = __webpack_require__(1508);
	
	var _FormControlStatic2 = _interopRequireDefault(_FormControlStatic);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	  /**
	   * Only relevant if `componentClass` is `'input'`.
	   */
	  type: _propTypes2['default'].string,
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  id: _propTypes2['default'].string,
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <FormControl inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  componentClass: 'input'
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2['default'].object
	};
	
	var FormControl = function (_React$Component) {
	  (0, _inherits3['default'])(FormControl, _React$Component);
	
	  function FormControl() {
	    (0, _classCallCheck3['default'])(this, FormControl);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControl.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        type = _props.type,
	        _props$id = _props.id,
	        id = _props$id === undefined ? controlId : _props$id,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        bsSize = _props.bsSize,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'type', 'id', 'inputRef', 'className', 'bsSize']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;
	
	    // input[type="file"] should not have .form-control.
	    var classes = void 0;
	    if (type !== 'file') {
	      classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    }
	
	    // If user provides a size, make sure to append it to classes as input-
	    // e.g. if bsSize is small, it will append input-sm
	    if (bsSize) {
	      var size = _StyleConfig.SIZE_MAP[bsSize] || bsSize;
	      classes[(0, _bootstrapUtils.prefix)({ bsClass: 'input' }, size)] = true;
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      type: type,
	      id: id,
	      ref: inputRef,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return FormControl;
	}(_react2['default'].Component);
	
	FormControl.propTypes = propTypes;
	FormControl.defaultProps = defaultProps;
	FormControl.contextTypes = contextTypes;
	
	FormControl.Feedback = _FormControlFeedback2['default'];
	FormControl.Static = _FormControlStatic2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.SMALL, _StyleConfig.Size.LARGE], FormControl));
	module.exports = exports['default'];

/***/ },
/* 1507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Glyphicon = __webpack_require__(322);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultProps = {
	  bsRole: 'feedback'
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2['default'].object
	};
	
	var FormControlFeedback = function (_React$Component) {
	  (0, _inherits3['default'])(FormControlFeedback, _React$Component);
	
	  function FormControlFeedback() {
	    (0, _classCallCheck3['default'])(this, FormControlFeedback);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlFeedback.prototype.getGlyph = function getGlyph(validationState) {
	    switch (validationState) {
	      case 'success':
	        return 'ok';
	      case 'warning':
	        return 'warning-sign';
	      case 'error':
	        return 'remove';
	      default:
	        return null;
	    }
	  };
	
	  FormControlFeedback.prototype.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
	    var glyph = this.getGlyph(formGroup && formGroup.validationState);
	    if (!glyph) {
	      return null;
	    }
	
	    return _react2['default'].createElement(_Glyphicon2['default'], (0, _extends3['default'])({}, elementProps, {
	      glyph: glyph,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  FormControlFeedback.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (!children) {
	      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
	    }
	
	    var child = _react2['default'].Children.only(children);
	    return _react2['default'].cloneElement(child, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(child.props.className, className, classes)
	    }));
	  };
	
	  return FormControlFeedback;
	}(_react2['default'].Component);
	
	FormControlFeedback.defaultProps = defaultProps;
	FormControlFeedback.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control-feedback', FormControlFeedback);
	module.exports = exports['default'];

/***/ },
/* 1508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'p'
	};
	
	var FormControlStatic = function (_React$Component) {
	  (0, _inherits3['default'])(FormControlStatic, _React$Component);
	
	  function FormControlStatic() {
	    (0, _classCallCheck3['default'])(this, FormControlStatic);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlStatic.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return FormControlStatic;
	}(_react2['default'].Component);
	
	FormControlStatic.propTypes = propTypes;
	FormControlStatic.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control-static', FormControlStatic);
	module.exports = exports['default'];

/***/ },
/* 1509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(36);
	
	var _ValidComponentChildren = __webpack_require__(45);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
	   */
	  controlId: _propTypes2['default'].string,
	  validationState: _propTypes2['default'].oneOf(['success', 'warning', 'error', null])
	};
	
	var childContextTypes = {
	  $bs_formGroup: _propTypes2['default'].object.isRequired
	};
	
	var FormGroup = function (_React$Component) {
	  (0, _inherits3['default'])(FormGroup, _React$Component);
	
	  function FormGroup() {
	    (0, _classCallCheck3['default'])(this, FormGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormGroup.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        controlId = _props.controlId,
	        validationState = _props.validationState;
	
	
	    return {
	      $bs_formGroup: {
	        controlId: controlId,
	        validationState: validationState
	      }
	    };
	  };
	
	  FormGroup.prototype.hasFeedback = function hasFeedback(children) {
	    var _this2 = this;
	
	    return _ValidComponentChildren2['default'].some(children, function (child) {
	      return child.props.bsRole === 'feedback' || child.props.children && _this2.hasFeedback(child.props.children);
	    });
	  };
	
	  FormGroup.prototype.render = function render() {
	    var _props2 = this.props,
	        validationState = _props2.validationState,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['validationState', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['controlId']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'has-feedback': this.hasFeedback(children)
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return FormGroup;
	}(_react2['default'].Component);
	
	FormGroup.propTypes = propTypes;
	FormGroup.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], FormGroup));
	module.exports = exports['default'];

/***/ },
/* 1510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var HelpBlock = function (_React$Component) {
	  (0, _inherits3['default'])(HelpBlock, _React$Component);
	
	  function HelpBlock() {
	    (0, _classCallCheck3['default'])(this, HelpBlock);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  HelpBlock.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return HelpBlock;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('help-block', HelpBlock);
	module.exports = exports['default'];

/***/ },
/* 1511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Sets image as responsive image
	   */
	  responsive: _propTypes2['default'].bool,
	
	  /**
	   * Sets image shape as rounded
	   */
	  rounded: _propTypes2['default'].bool,
	
	  /**
	   * Sets image shape as circle
	   */
	  circle: _propTypes2['default'].bool,
	
	  /**
	   * Sets image shape as thumbnail
	   */
	  thumbnail: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  responsive: false,
	  rounded: false,
	  circle: false,
	  thumbnail: false
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3['default'])(Image, _React$Component);
	
	  function Image() {
	    (0, _classCallCheck3['default'])(this, Image);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Image.prototype.render = function render() {
	    var _classes;
	
	    var _props = this.props,
	        responsive = _props.responsive,
	        rounded = _props.rounded,
	        circle = _props.circle,
	        thumbnail = _props.thumbnail,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['responsive', 'rounded', 'circle', 'thumbnail', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (_classes = {}, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'responsive')] = responsive, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'rounded')] = rounded, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'circle')] = circle, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'thumbnail')] = thumbnail, _classes);
	
	    return _react2['default'].createElement('img', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Image;
	}(_react2['default'].Component);
	
	Image.propTypes = propTypes;
	Image.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('img', Image);
	module.exports = exports['default'];

/***/ },
/* 1512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputGroupAddon = __webpack_require__(1513);
	
	var _InputGroupAddon2 = _interopRequireDefault(_InputGroupAddon);
	
	var _InputGroupButton = __webpack_require__(1514);
	
	var _InputGroupButton2 = _interopRequireDefault(_InputGroupButton);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroup = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroup, _React$Component);
	
	  function InputGroup() {
	    (0, _classCallCheck3['default'])(this, InputGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroup.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroup;
	}(_react2['default'].Component);
	
	InputGroup.Addon = _InputGroupAddon2['default'];
	InputGroup.Button = _InputGroupButton2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], InputGroup));
	module.exports = exports['default'];

/***/ },
/* 1513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroupAddon = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroupAddon, _React$Component);
	
	  function InputGroupAddon() {
	    (0, _classCallCheck3['default'])(this, InputGroupAddon);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupAddon.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroupAddon;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group-addon', InputGroupAddon);
	module.exports = exports['default'];

/***/ },
/* 1514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroupButton = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroupButton, _React$Component);
	
	  function InputGroupButton() {
	    (0, _classCallCheck3['default'])(this, InputGroupButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupButton.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroupButton;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group-btn', InputGroupButton);
	module.exports = exports['default'];

/***/ },
/* 1515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Jumbotron = function (_React$Component) {
	  (0, _inherits3['default'])(Jumbotron, _React$Component);
	
	  function Jumbotron() {
	    (0, _classCallCheck3['default'])(this, Jumbotron);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Jumbotron.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Jumbotron;
	}(_react2['default'].Component);
	
	Jumbotron.propTypes = propTypes;
	Jumbotron.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('jumbotron', Jumbotron);
	module.exports = exports['default'];

/***/ },
/* 1516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(119);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Label = function (_React$Component) {
	  (0, _inherits3['default'])(Label, _React$Component);
	
	  function Label() {
	    (0, _classCallCheck3['default'])(this, Label);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Label.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2['default'].Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Label.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Label;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('label', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Label));
	module.exports = exports['default'];

/***/ },
/* 1517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _ListGroupItem = __webpack_require__(473);
	
	var _ListGroupItem2 = _interopRequireDefault(_ListGroupItem);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _ValidComponentChildren = __webpack_require__(45);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * You can use a custom element type for this component.
	   *
	   * If not specified, it will be treated as `'li'` if every child is a
	   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
	   */
	  componentClass: _elementType2['default']
	};
	
	function getDefaultComponent(children) {
	  if (!children) {
	    // FIXME: This is the old behavior. Is this right?
	    return 'div';
	  }
	
	  if (_ValidComponentChildren2['default'].some(children, function (child) {
	    return child.type !== _ListGroupItem2['default'] || child.props.href || child.props.onClick;
	  })) {
	    return 'div';
	  }
	
	  return 'ul';
	}
	
	var ListGroup = function (_React$Component) {
	  (0, _inherits3['default'])(ListGroup, _React$Component);
	
	  function ListGroup() {
	    (0, _classCallCheck3['default'])(this, ListGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroup.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        _props$componentClass = _props.componentClass,
	        Component = _props$componentClass === undefined ? getDefaultComponent(children) : _props$componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['children', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var useListItem = Component === 'ul' && _ValidComponentChildren2['default'].every(children, function (child) {
	      return child.type === _ListGroupItem2['default'];
	    });
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      useListItem ? _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, { listItem: true });
	      }) : children
	    );
	  };
	
	  return ListGroup;
	}(_react2['default'].Component);
	
	ListGroup.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('list-group', ListGroup);
	module.exports = exports['default'];

/***/ },
/* 1518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var MediaBody = function (_React$Component) {
	  (0, _inherits3['default'])(MediaBody, _React$Component);
	
	  function MediaBody() {
	    (0, _classCallCheck3['default'])(this, MediaBody);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaBody;
	}(_react2['default'].Component);
	
	MediaBody.propTypes = propTypes;
	MediaBody.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-body', MediaBody);
	module.exports = exports['default'];

/***/ },
/* 1519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var MediaHeading = function (_React$Component) {
	  (0, _inherits3['default'])(MediaHeading, _React$Component);
	
	  function MediaHeading() {
	    (0, _classCallCheck3['default'])(this, MediaHeading);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaHeading.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaHeading;
	}(_react2['default'].Component);
	
	MediaHeading.propTypes = propTypes;
	MediaHeading.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-heading', MediaHeading);
	module.exports = exports['default'];

/***/ },
/* 1520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__(323);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2['default'].oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaLeft = function (_React$Component) {
	  (0, _inherits3['default'])(MediaLeft, _React$Component);
	
	  function MediaLeft() {
	    (0, _classCallCheck3['default'])(this, MediaLeft);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaLeft.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-left-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2['default'].defaultProps, align)] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaLeft;
	}(_react2['default'].Component);
	
	MediaLeft.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-left', MediaLeft);
	module.exports = exports['default'];

/***/ },
/* 1521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MediaList = function (_React$Component) {
	  (0, _inherits3['default'])(MediaList, _React$Component);
	
	  function MediaList() {
	    (0, _classCallCheck3['default'])(this, MediaList);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaList.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('ul', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaList;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-list', MediaList);
	module.exports = exports['default'];

/***/ },
/* 1522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MediaListItem = function (_React$Component) {
	  (0, _inherits3['default'])(MediaListItem, _React$Component);
	
	  function MediaListItem() {
	    (0, _classCallCheck3['default'])(this, MediaListItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaListItem.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaListItem;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media', MediaListItem);
	module.exports = exports['default'];

/***/ },
/* 1523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__(323);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2['default'].oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaRight = function (_React$Component) {
	  (0, _inherits3['default'])(MediaRight, _React$Component);
	
	  function MediaRight() {
	    (0, _classCallCheck3['default'])(this, MediaRight);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaRight.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-right-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2['default'].defaultProps, align)] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaRight;
	}(_react2['default'].Component);
	
	MediaRight.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-right', MediaRight);
	module.exports = exports['default'];

/***/ },
/* 1524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _all = __webpack_require__(226);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _SafeAnchor = __webpack_require__(69);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _createChainedFunction = __webpack_require__(34);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Highlight the menu item as active.
	   */
	  active: _propTypes2['default'].bool,
	
	  /**
	   * Disable the menu item, making it unselectable.
	   */
	  disabled: _propTypes2['default'].bool,
	
	  /**
	   * Styles the menu item as a horizontal rule, providing visual separation between
	   * groups of menu items.
	   */
	  divider: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
	    var divider = _ref.divider,
	        children = _ref.children;
	    return divider && children ? new Error('Children will not be rendered for dividers') : null;
	  }),
	
	  /**
	   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
	   */
	  eventKey: _propTypes2['default'].any,
	
	  /**
	   * Styles the menu item as a header label, useful for describing a group of menu items.
	   */
	  header: _propTypes2['default'].bool,
	
	  /**
	   * HTML `href` attribute corresponding to `a.href`.
	   */
	  href: _propTypes2['default'].string,
	
	  /**
	   * Callback fired when the menu item is clicked.
	   */
	  onClick: _propTypes2['default'].func,
	
	  /**
	   * Callback fired when the menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  divider: false,
	  disabled: false,
	  header: false
	};
	
	var MenuItem = function (_React$Component) {
	  (0, _inherits3['default'])(MenuItem, _React$Component);
	
	  function MenuItem(props, context) {
	    (0, _classCallCheck3['default'])(this, MenuItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  MenuItem.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        href = _props.href,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (!href || disabled) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  MenuItem.prototype.render = function render() {
	    var _props2 = this.props,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        divider = _props2.divider,
	        header = _props2.header,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['active', 'disabled', 'divider', 'header', 'onClick', 'className', 'style']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    if (divider) {
	      // Forcibly blank out the children; separators shouldn't render any.
	      elementProps.children = undefined;
	
	      return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	        role: 'separator',
	        className: (0, _classnames2['default'])(className, 'divider'),
	        style: style
	      }));
	    }
	
	    if (header) {
	      return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	        role: 'heading',
	        className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'header')),
	        style: style
	      }));
	    }
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, elementProps, {
	        role: 'menuitem',
	        tabIndex: '-1',
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return MenuItem;
	}(_react2['default'].Component);
	
	MenuItem.propTypes = propTypes;
	MenuItem.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown', MenuItem);
	module.exports = exports['default'];

/***/ },
/* 1525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _events = __webpack_require__(960);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _ownerDocument = __webpack_require__(127);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _inDOM = __webpack_require__(76);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _scrollbarSize = __webpack_require__(421);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Modal = __webpack_require__(1641);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _isOverflowing = __webpack_require__(522);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(218);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _ModalBody = __webpack_require__(474);
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _ModalDialog = __webpack_require__(1526);
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	var _ModalFooter = __webpack_require__(475);
	
	var _ModalFooter2 = _interopRequireDefault(_ModalFooter);
	
	var _ModalHeader = __webpack_require__(476);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _ModalTitle = __webpack_require__(477);
	
	var _ModalTitle2 = _interopRequireDefault(_ModalTitle);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _createChainedFunction = __webpack_require__(34);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _splitComponentProps2 = __webpack_require__(219);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _StyleConfig = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Modal2['default'].propTypes, _ModalDialog2['default'].propTypes, {
	
	  /**
	   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
	   * trigger an "onHide" when clicked.
	   */
	  backdrop: _propTypes2['default'].oneOf(['static', true, false]),
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes2['default'].bool,
	
	  /**
	   * Open and close the Modal with a slide and fade animation.
	   */
	  animation: _propTypes2['default'].bool,
	
	  /**
	   * A Component type that provides the modal content Markup. This is a useful
	   * prop when you want to use your own styles and markup to create a custom
	   * modal component.
	   */
	  dialogComponentClass: _elementType2['default'],
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it
	   * opens, and replace it to the last focused element when it closes.
	   * Generally this should never be set to false as it makes the Modal less
	   * accessible to assistive technologies, like screen-readers.
	   */
	  autoFocus: _propTypes2['default'].bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while
	   * open. Consider leaving the default value here, as it is necessary to make
	   * the Modal work well with assistive technologies, such as screen readers.
	   */
	  enforceFocus: _propTypes2['default'].bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes2['default'].bool,
	
	  /**
	   * When `true` The modal will show itself.
	   */
	  show: _propTypes2['default'].bool,
	
	  /**
	   * A callback fired when the header closeButton or non-static backdrop is
	   * clicked. Required if either are specified.
	   */
	  onHide: _propTypes2['default'].func,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes2['default'].func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * @private
	   */
	  container: _Modal2['default'].propTypes.container
	});
	
	var defaultProps = (0, _extends3['default'])({}, _Modal2['default'].defaultProps, {
	  animation: true,
	  dialogComponentClass: _ModalDialog2['default']
	});
	
	var childContextTypes = {
	  $bs_modal: _propTypes2['default'].shape({
	    onHide: _propTypes2['default'].func
	  })
	};
	
	var Modal = function (_React$Component) {
	  (0, _inherits3['default'])(Modal, _React$Component);
	
	  function Modal(props, context) {
	    (0, _classCallCheck3['default'])(this, Modal);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
	    _this.handleDialogClick = _this.handleDialogClick.bind(_this);
	
	    _this.state = {
	      style: {}
	    };
	    return _this;
	  }
	
	  Modal.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_modal: {
	        onHide: this.props.onHide
	      }
	    };
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    // Clean up the listener if we need to.
	    this.handleExited();
	  };
	
	  Modal.prototype.handleEntering = function handleEntering() {
	    // FIXME: This should work even when animation is disabled.
	    _events2['default'].on(window, 'resize', this.handleWindowResize);
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleExited = function handleExited() {
	    // FIXME: This should work even when animation is disabled.
	    _events2['default'].off(window, 'resize', this.handleWindowResize);
	  };
	
	  Modal.prototype.handleWindowResize = function handleWindowResize() {
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleDialogClick = function handleDialogClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    this.props.onHide();
	  };
	
	  Modal.prototype.updateStyle = function updateStyle() {
	    if (!_inDOM2['default']) {
	      return;
	    }
	
	    var dialogNode = this._modal.getDialogElement();
	    var dialogHeight = dialogNode.scrollHeight;
	
	    var document = (0, _ownerDocument2['default'])(dialogNode);
	    var bodyIsOverflowing = (0, _isOverflowing2['default'])(_reactDom2['default'].findDOMNode(this.props.container || document.body));
	    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
	
	    this.setState({
	      style: {
	        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSize2['default'])() : undefined,
	        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? (0, _scrollbarSize2['default'])() : undefined
	      }
	    });
	  };
	
	  Modal.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        backdrop = _props.backdrop,
	        animation = _props.animation,
	        show = _props.show,
	        Dialog = _props.dialogComponentClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        onEntering = _props.onEntering,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['backdrop', 'animation', 'show', 'dialogComponentClass', 'className', 'style', 'children', 'onEntering', 'onExited']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Modal2['default']),
	        baseModalProps = _splitComponentProps[0],
	        dialogProps = _splitComponentProps[1];
	
	    var inClassName = show && !animation && 'in';
	
	    return _react2['default'].createElement(
	      _Modal2['default'],
	      (0, _extends3['default'])({}, baseModalProps, {
	        ref: function ref(c) {
	          _this2._modal = c;
	        },
	        show: show,
	        onEntering: (0, _createChainedFunction2['default'])(onEntering, this.handleEntering),
	        onExited: (0, _createChainedFunction2['default'])(onExited, this.handleExited),
	        backdrop: backdrop,
	        backdropClassName: (0, _classnames2['default'])((0, _bootstrapUtils.prefix)(props, 'backdrop'), inClassName),
	        containerClassName: (0, _bootstrapUtils.prefix)(props, 'open'),
	        transition: animation ? _Fade2['default'] : undefined,
	        dialogTransitionTimeout: Modal.TRANSITION_DURATION,
	        backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION
	      }),
	      _react2['default'].createElement(
	        Dialog,
	        (0, _extends3['default'])({}, dialogProps, {
	          style: (0, _extends3['default'])({}, this.state.style, style),
	          className: (0, _classnames2['default'])(className, inClassName),
	          onClick: backdrop === true ? this.handleDialogClick : null
	        }),
	        children
	      )
	    );
	  };
	
	  return Modal;
	}(_react2['default'].Component);
	
	Modal.propTypes = propTypes;
	Modal.defaultProps = defaultProps;
	Modal.childContextTypes = childContextTypes;
	
	Modal.Body = _ModalBody2['default'];
	Modal.Header = _ModalHeader2['default'];
	Modal.Title = _ModalTitle2['default'];
	Modal.Footer = _ModalFooter2['default'];
	
	Modal.Dialog = _ModalDialog2['default'];
	
	Modal.TRANSITION_DURATION = 300;
	Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Modal));
	module.exports = exports['default'];

/***/ },
/* 1526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * A css class to apply to the Modal dialog DOM node.
	   */
	  dialogClassName: _propTypes2['default'].string
	};
	
	var ModalDialog = function (_React$Component) {
	  (0, _inherits3['default'])(ModalDialog, _React$Component);
	
	  function ModalDialog() {
	    (0, _classCallCheck3['default'])(this, ModalDialog);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalDialog.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        dialogClassName = _props.dialogClassName,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['dialogClassName', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(bsProps);
	
	    var modalStyle = (0, _extends4['default'])({ display: 'block' }, style);
	
	    var dialogClasses = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dialog')] = true, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        tabIndex: '-1',
	        role: 'dialog',
	        style: modalStyle,
	        className: (0, _classnames2['default'])(className, bsClassName)
	      }),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _classnames2['default'])(dialogClassName, dialogClasses) },
	        _react2['default'].createElement(
	          'div',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'content'), role: 'document' },
	          children
	        )
	      )
	    );
	  };
	
	  return ModalDialog;
	}(_react2['default'].Component);
	
	ModalDialog.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], ModalDialog));
	module.exports = exports['default'];

/***/ },
/* 1527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Dropdown = __webpack_require__(217);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(219);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _ValidComponentChildren = __webpack_require__(45);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  title: _propTypes2['default'].node.isRequired,
	  noCaret: _propTypes2['default'].bool,
	  active: _propTypes2['default'].bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2['default'].node
	});
	
	var NavDropdown = function (_React$Component) {
	  (0, _inherits3['default'])(NavDropdown, _React$Component);
	
	  function NavDropdown() {
	    (0, _classCallCheck3['default'])(this, NavDropdown);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavDropdown.prototype.isActive = function isActive(_ref, activeKey, activeHref) {
	    var props = _ref.props;
	
	    var _this2 = this;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    if (_ValidComponentChildren2['default'].some(props.children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    })) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  NavDropdown.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        title = _props.title,
	        activeKey = _props.activeKey,
	        activeHref = _props.activeHref,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['title', 'activeKey', 'activeHref', 'className', 'style', 'children']);
	
	
	    var active = this.isActive(this, activeKey, activeHref);
	    delete props.active; // Accessed via this.isActive().
	    delete props.eventKey; // Accessed via this.isActive().
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
	    // rather than the `<Dropdown.Toggle>`.
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        componentClass: 'li',
	        className: (0, _classnames2['default'])(className, { active: active }),
	        style: style
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        (0, _extends3['default'])({}, toggleProps, { useAnchor: true }),
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        _ValidComponentChildren2['default'].map(children, function (child) {
	          return _react2['default'].cloneElement(child, {
	            active: _this3.isActive(child, activeKey, activeHref)
	          });
	        })
	      )
	    );
	  };
	
	  return NavDropdown;
	}(_react2['default'].Component);
	
	NavDropdown.propTypes = propTypes;
	
	exports['default'] = NavDropdown;
	module.exports = exports['default'];

/***/ },
/* 1528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _uncontrollable = __webpack_require__(233);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Grid = __webpack_require__(472);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _NavbarBrand = __webpack_require__(480);
	
	var _NavbarBrand2 = _interopRequireDefault(_NavbarBrand);
	
	var _NavbarCollapse = __webpack_require__(1529);
	
	var _NavbarCollapse2 = _interopRequireDefault(_NavbarCollapse);
	
	var _NavbarHeader = __webpack_require__(1530);
	
	var _NavbarHeader2 = _interopRequireDefault(_NavbarHeader);
	
	var _NavbarToggle = __webpack_require__(1531);
	
	var _NavbarToggle2 = _interopRequireDefault(_NavbarToggle);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(36);
	
	var _createChainedFunction = __webpack_require__(34);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Create a fixed navbar along the top of the screen, that scrolls with the
	   * page
	   */
	  fixedTop: _propTypes2['default'].bool,
	  /**
	   * Create a fixed navbar along the bottom of the screen, that scrolls with
	   * the page
	   */
	  fixedBottom: _propTypes2['default'].bool,
	  /**
	   * Create a full-width navbar that scrolls away with the page
	   */
	  staticTop: _propTypes2['default'].bool,
	  /**
	   * An alternative dark visual style for the Navbar
	   */
	  inverse: _propTypes2['default'].bool,
	  /**
	   * Allow the Navbar to fluidly adjust to the page or container width, instead
	   * of at the predefined screen breakpoints
	   */
	  fluid: _propTypes2['default'].bool,
	
	  /**
	   * Set a custom element for this component.
	   */
	  componentClass: _elementType2['default'],
	  /**
	   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
	   * a `<Navbar.Toggle>` is clicked and called with the new `navExpanded`
	   * boolean value.
	   *
	   * @controllable navExpanded
	   */
	  onToggle: _propTypes2['default'].func,
	  /**
	   * A callback fired when a descendant of a child `<Nav>` is selected. Should
	   * be used to execute complex closing or other miscellaneous actions desired
	   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
	   * descendants exist. The callback is called with an eventKey, which is a
	   * prop from the selected `<Nav>` descendant, and an event.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   *
	   * For basic closing behavior after all `<Nav>` descendant onSelect events in
	   * mobile viewports, try using collapseOnSelect.
	   *
	   * Note: If you are manually closing the navbar using this `OnSelect` prop,
	   * ensure that you are setting `expanded` to false and not *toggling* between
	   * true and false.
	   */
	  onSelect: _propTypes2['default'].func,
	  /**
	   * Sets `expanded` to `false` after the onSelect event of a descendant of a
	   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
	   *
	   * The onSelect callback should be used instead for more complex operations
	   * that need to be executed after the `select` event of `<Nav>` descendants.
	   */
	  collapseOnSelect: _propTypes2['default'].bool,
	  /**
	   * Explicitly set the visiblity of the navbar body
	   *
	   * @controllable onToggle
	   */
	  expanded: _propTypes2['default'].bool,
	
	  role: _propTypes2['default'].string
	}; // TODO: Remove this pragma once we upgrade eslint-config-airbnb.
	/* eslint-disable react/no-multi-comp */
	
	var defaultProps = {
	  componentClass: 'nav',
	  fixedTop: false,
	  fixedBottom: false,
	  staticTop: false,
	  inverse: false,
	  fluid: false,
	  collapseOnSelect: false
	};
	
	var childContextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    expanded: _propTypes2['default'].bool,
	    onToggle: _propTypes2['default'].func.isRequired,
	    onSelect: _propTypes2['default'].func
	  })
	};
	
	var Navbar = function (_React$Component) {
	  (0, _inherits3['default'])(Navbar, _React$Component);
	
	  function Navbar(props, context) {
	    (0, _classCallCheck3['default'])(this, Navbar);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleCollapse = _this.handleCollapse.bind(_this);
	    return _this;
	  }
	
	  Navbar.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        expanded = _props.expanded,
	        onSelect = _props.onSelect,
	        collapseOnSelect = _props.collapseOnSelect;
	
	
	    return {
	      $bs_navbar: {
	        bsClass: bsClass,
	        expanded: expanded,
	        onToggle: this.handleToggle,
	        onSelect: (0, _createChainedFunction2['default'])(onSelect, collapseOnSelect ? this.handleCollapse : null)
	      }
	    };
	  };
	
	  Navbar.prototype.handleCollapse = function handleCollapse() {
	    var _props2 = this.props,
	        onToggle = _props2.onToggle,
	        expanded = _props2.expanded;
	
	
	    if (expanded) {
	      onToggle(false);
	    }
	  };
	
	  Navbar.prototype.handleToggle = function handleToggle() {
	    var _props3 = this.props,
	        onToggle = _props3.onToggle,
	        expanded = _props3.expanded;
	
	
	    onToggle(!expanded);
	  };
	
	  Navbar.prototype.render = function render() {
	    var _extends2;
	
	    var _props4 = this.props,
	        Component = _props4.componentClass,
	        fixedTop = _props4.fixedTop,
	        fixedBottom = _props4.fixedBottom,
	        staticTop = _props4.staticTop,
	        inverse = _props4.inverse,
	        fluid = _props4.fluid,
	        className = _props4.className,
	        children = _props4.children,
	        props = (0, _objectWithoutProperties3['default'])(_props4, ['componentClass', 'fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'fluid', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    // will result in some false positives but that seems better
	    // than false negatives. strict `undefined` check allows explicit
	    // "nulling" of the role if the user really doesn't want one
	
	
	    if (elementProps.role === undefined && Component !== 'nav') {
	      elementProps.role = 'navigation';
	    }
	
	    if (inverse) {
	      bsProps.bsStyle = _StyleConfig.Style.INVERSE;
	    }
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-top')] = fixedTop, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'static-top')] = staticTop, _extends2));
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends4['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement(
	        _Grid2['default'],
	        { fluid: fluid },
	        children
	      )
	    );
	  };
	
	  return Navbar;
	}(_react2['default'].Component);
	
	Navbar.propTypes = propTypes;
	Navbar.defaultProps = defaultProps;
	Navbar.childContextTypes = childContextTypes;
	
	(0, _bootstrapUtils.bsClass)('navbar', Navbar);
	
	var UncontrollableNavbar = (0, _uncontrollable2['default'])(Navbar, { expanded: 'onToggle' });
	
	function createSimpleWrapper(tag, suffix, displayName) {
	  var Wrapper = function Wrapper(_ref, _ref2) {
	    var _ref2$$bs_navbar = _ref2.$bs_navbar,
	        navbarProps = _ref2$$bs_navbar === undefined ? { bsClass: 'navbar' } : _ref2$$bs_navbar;
	    var Component = _ref.componentClass,
	        className = _ref.className,
	        pullRight = _ref.pullRight,
	        pullLeft = _ref.pullLeft,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['componentClass', 'className', 'pullRight', 'pullLeft']);
	    return _react2['default'].createElement(Component, (0, _extends4['default'])({}, props, {
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(navbarProps, suffix), pullRight && (0, _bootstrapUtils.prefix)(navbarProps, 'right'), pullLeft && (0, _bootstrapUtils.prefix)(navbarProps, 'left'))
	    }));
	  };
	
	  Wrapper.displayName = displayName;
	
	  Wrapper.propTypes = {
	    componentClass: _elementType2['default'],
	    pullRight: _propTypes2['default'].bool,
	    pullLeft: _propTypes2['default'].bool
	  };
	
	  Wrapper.defaultProps = {
	    componentClass: tag,
	    pullRight: false,
	    pullLeft: false
	  };
	
	  Wrapper.contextTypes = {
	    $bs_navbar: _propTypes2['default'].shape({
	      bsClass: _propTypes2['default'].string
	    })
	  };
	
	  return Wrapper;
	}
	
	UncontrollableNavbar.Brand = _NavbarBrand2['default'];
	UncontrollableNavbar.Header = _NavbarHeader2['default'];
	UncontrollableNavbar.Toggle = _NavbarToggle2['default'];
	UncontrollableNavbar.Collapse = _NavbarCollapse2['default'];
	
	UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
	UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
	UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink');
	
	// Set bsStyles here so they can be overridden.
	exports['default'] = (0, _bootstrapUtils.bsStyles)([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.INVERSE], _StyleConfig.Style.DEFAULT, UncontrollableNavbar);
	module.exports = exports['default'];

/***/ },
/* 1529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(321);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    expanded: _propTypes2['default'].bool
	  })
	};
	
	var NavbarCollapse = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarCollapse, _React$Component);
	
	  function NavbarCollapse() {
	    (0, _classCallCheck3['default'])(this, NavbarCollapse);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarCollapse.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'collapse');
	
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      (0, _extends3['default'])({ 'in': navbarProps.expanded }, props),
	      _react2['default'].createElement(
	        'div',
	        { className: bsClassName },
	        children
	      )
	    );
	  };
	
	  return NavbarCollapse;
	}(_react2['default'].Component);
	
	NavbarCollapse.contextTypes = contextTypes;
	
	exports['default'] = NavbarCollapse;
	module.exports = exports['default'];

/***/ },
/* 1530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string
	  })
	};
	
	var NavbarHeader = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarHeader, _React$Component);
	
	  function NavbarHeader() {
	    (0, _classCallCheck3['default'])(this, NavbarHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'header');
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, props, { className: (0, _classnames2['default'])(className, bsClassName) }));
	  };
	
	  return NavbarHeader;
	}(_react2['default'].Component);
	
	NavbarHeader.contextTypes = contextTypes;
	
	exports['default'] = NavbarHeader;
	module.exports = exports['default'];

/***/ },
/* 1531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _createChainedFunction = __webpack_require__(34);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onClick: _propTypes2['default'].func,
	  /**
	   * The toggle content, if left empty it will render the default toggle (seen above).
	   */
	  children: _propTypes2['default'].node
	};
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    expanded: _propTypes2['default'].bool,
	    onToggle: _propTypes2['default'].func.isRequired
	  })
	};
	
	var NavbarToggle = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarToggle, _React$Component);
	
	  function NavbarToggle() {
	    (0, _classCallCheck3['default'])(this, NavbarToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarToggle.prototype.render = function render() {
	    var _props = this.props,
	        onClick = _props.onClick,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onClick', 'className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var buttonProps = (0, _extends3['default'])({
	      type: 'button'
	    }, props, {
	      onClick: (0, _createChainedFunction2['default'])(onClick, navbarProps.onToggle),
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
	    });
	
	    if (children) {
	      return _react2['default'].createElement(
	        'button',
	        buttonProps,
	        children
	      );
	    }
	
	    return _react2['default'].createElement(
	      'button',
	      buttonProps,
	      _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        'Toggle navigation'
	      ),
	      _react2['default'].createElement('span', { className: 'icon-bar' }),
	      _react2['default'].createElement('span', { className: 'icon-bar' }),
	      _react2['default'].createElement('span', { className: 'icon-bar' })
	    );
	  };
	
	  return NavbarToggle;
	}(_react2['default'].Component);
	
	NavbarToggle.propTypes = propTypes;
	NavbarToggle.contextTypes = contextTypes;
	
	exports['default'] = NavbarToggle;
	module.exports = exports['default'];

/***/ },
/* 1532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _contains = __webpack_require__(128);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Overlay = __webpack_require__(481);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _createChainedFunction = __webpack_require__(34);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Check if value one is inside or equal to the of value
	 *
	 * @param {string} one
	 * @param {string|array} of
	 * @returns {boolean}
	 */
	function isOneOf(one, of) {
	  if (Array.isArray(of)) {
	    return of.indexOf(one) >= 0;
	  }
	  return one === of;
	}
	
	var triggerType = _propTypes2['default'].oneOf(['click', 'hover', 'focus']);
	
	var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {
	
	  /**
	  * Specify which action or actions trigger Overlay visibility
	  */
	  trigger: _propTypes2['default'].oneOfType([triggerType, _propTypes2['default'].arrayOf(triggerType)]),
	
	  /**
	   * A millisecond delay amount to show and hide the Overlay once triggered
	   */
	  delay: _propTypes2['default'].number,
	  /**
	   * A millisecond delay amount before showing the Overlay once triggered.
	   */
	  delayShow: _propTypes2['default'].number,
	  /**
	   * A millisecond delay amount before hiding the Overlay once triggered.
	   */
	  delayHide: _propTypes2['default'].number,
	
	  // FIXME: This should be `defaultShow`.
	  /**
	   * The initial visibility state of the Overlay. For more nuanced visibility
	   * control, consider using the Overlay component directly.
	   */
	  defaultOverlayShown: _propTypes2['default'].bool,
	
	  /**
	   * An element or text to overlay next to the target.
	   */
	  overlay: _propTypes2['default'].node.isRequired,
	
	  /**
	   * @private
	   */
	  onBlur: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onClick: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onFocus: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onMouseOut: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onMouseOver: _propTypes2['default'].func,
	
	  // Overridden props from `<Overlay>`.
	  /**
	   * @private
	   */
	  target: _propTypes2['default'].oneOf([null]),
	  /**
	  * @private
	  */
	  onHide: _propTypes2['default'].oneOf([null]),
	  /**
	   * @private
	   */
	  show: _propTypes2['default'].oneOf([null])
	});
	
	var defaultProps = {
	  defaultOverlayShown: false,
	  trigger: ['hover', 'focus']
	};
	
	var OverlayTrigger = function (_React$Component) {
	  (0, _inherits3['default'])(OverlayTrigger, _React$Component);
	
	  function OverlayTrigger(props, context) {
	    (0, _classCallCheck3['default'])(this, OverlayTrigger);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleDelayedShow = _this.handleDelayedShow.bind(_this);
	    _this.handleDelayedHide = _this.handleDelayedHide.bind(_this);
	    _this.handleHide = _this.handleHide.bind(_this);
	
	    _this.handleMouseOver = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedShow, e);
	    };
	    _this.handleMouseOut = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedHide, e);
	    };
	
	    _this._mountNode = null;
	
	    _this.state = {
	      show: props.defaultOverlayShown
	    };
	    return _this;
	  }
	
	  OverlayTrigger.prototype.componentDidMount = function componentDidMount() {
	    this._mountNode = document.createElement('div');
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
	    _reactDom2['default'].unmountComponentAtNode(this._mountNode);
	    this._mountNode = null;
	
	    clearTimeout(this._hoverShowDelay);
	    clearTimeout(this._hoverHideDelay);
	  };
	
	  OverlayTrigger.prototype.handleToggle = function handleToggle() {
	    if (this.state.show) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  };
	
	  OverlayTrigger.prototype.handleDelayedShow = function handleDelayedShow() {
	    var _this2 = this;
	
	    if (this._hoverHideDelay != null) {
	      clearTimeout(this._hoverHideDelay);
	      this._hoverHideDelay = null;
	      return;
	    }
	
	    if (this.state.show || this._hoverShowDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;
	
	    if (!delay) {
	      this.show();
	      return;
	    }
	
	    this._hoverShowDelay = setTimeout(function () {
	      _this2._hoverShowDelay = null;
	      _this2.show();
	    }, delay);
	  };
	
	  OverlayTrigger.prototype.handleDelayedHide = function handleDelayedHide() {
	    var _this3 = this;
	
	    if (this._hoverShowDelay != null) {
	      clearTimeout(this._hoverShowDelay);
	      this._hoverShowDelay = null;
	      return;
	    }
	
	    if (!this.state.show || this._hoverHideDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;
	
	    if (!delay) {
	      this.hide();
	      return;
	    }
	
	    this._hoverHideDelay = setTimeout(function () {
	      _this3._hoverHideDelay = null;
	      _this3.hide();
	    }, delay);
	  };
	
	  // Simple implementation of mouseEnter and mouseLeave.
	  // React's built version is broken: https://github.com/facebook/react/issues/4251
	  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
	  // moving from one child element to another.
	
	
	  OverlayTrigger.prototype.handleMouseOverOut = function handleMouseOverOut(handler, e) {
	    var target = e.currentTarget;
	    var related = e.relatedTarget || e.nativeEvent.toElement;
	
	    if (!related || related !== target && !(0, _contains2['default'])(target, related)) {
	      handler(e);
	    }
	  };
	
	  OverlayTrigger.prototype.handleHide = function handleHide() {
	    this.hide();
	  };
	
	  OverlayTrigger.prototype.show = function show() {
	    this.setState({ show: true });
	  };
	
	  OverlayTrigger.prototype.hide = function hide() {
	    this.setState({ show: false });
	  };
	
	  OverlayTrigger.prototype.makeOverlay = function makeOverlay(overlay, props) {
	    return _react2['default'].createElement(
	      _Overlay2['default'],
	      (0, _extends3['default'])({}, props, {
	        show: this.state.show,
	        onHide: this.handleHide,
	        target: this
	      }),
	      overlay
	    );
	  };
	
	  OverlayTrigger.prototype.renderOverlay = function renderOverlay() {
	    _reactDom2['default'].unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
	  };
	
	  OverlayTrigger.prototype.render = function render() {
	    var _props = this.props,
	        trigger = _props.trigger,
	        overlay = _props.overlay,
	        children = _props.children,
	        onBlur = _props.onBlur,
	        onClick = _props.onClick,
	        onFocus = _props.onFocus,
	        onMouseOut = _props.onMouseOut,
	        onMouseOver = _props.onMouseOver,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['trigger', 'overlay', 'children', 'onBlur', 'onClick', 'onFocus', 'onMouseOut', 'onMouseOver']);
	
	
	    delete props.delay;
	    delete props.delayShow;
	    delete props.delayHide;
	    delete props.defaultOverlayShown;
	
	    var child = _react2['default'].Children.only(children);
	    var childProps = child.props;
	    var triggerProps = {};
	
	    if (this.state.show) {
	      triggerProps['aria-describedby'] = overlay.props.id;
	    }
	
	    // FIXME: The logic here for passing through handlers on this component is
	    // inconsistent. We shouldn't be passing any of these props through.
	
	    triggerProps.onClick = (0, _createChainedFunction2['default'])(childProps.onClick, onClick);
	
	    if (isOneOf('click', trigger)) {
	      triggerProps.onClick = (0, _createChainedFunction2['default'])(triggerProps.onClick, this.handleToggle);
	    }
	
	    if (isOneOf('hover', trigger)) {
	       false ? (0, _warning2['default'])(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;
	
	      triggerProps.onMouseOver = (0, _createChainedFunction2['default'])(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
	      triggerProps.onMouseOut = (0, _createChainedFunction2['default'])(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
	    }
	
	    if (isOneOf('focus', trigger)) {
	      triggerProps.onFocus = (0, _createChainedFunction2['default'])(childProps.onFocus, onFocus, this.handleDelayedShow);
	      triggerProps.onBlur = (0, _createChainedFunction2['default'])(childProps.onBlur, onBlur, this.handleDelayedHide);
	    }
	
	    this._overlay = this.makeOverlay(overlay, props);
	
	    return (0, _react.cloneElement)(child, triggerProps);
	  };
	
	  return OverlayTrigger;
	}(_react2['default'].Component);
	
	OverlayTrigger.propTypes = propTypes;
	OverlayTrigger.defaultProps = defaultProps;
	
	exports['default'] = OverlayTrigger;
	module.exports = exports['default'];

/***/ },
/* 1533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PageHeader = function (_React$Component) {
	  (0, _inherits3['default'])(PageHeader, _React$Component);
	
	  function PageHeader() {
	    (0, _classCallCheck3['default'])(this, PageHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  PageHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement(
	        'h1',
	        null,
	        children
	      )
	    );
	  };
	
	  return PageHeader;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('page-header', PageHeader);
	module.exports = exports['default'];

/***/ },
/* 1534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PagerItem = __webpack_require__(482);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _deprecationWarning = __webpack_require__(1553);
	
	var _deprecationWarning2 = _interopRequireDefault(_deprecationWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _deprecationWarning2['default'].wrapper(_PagerItem2['default'], '`<PageItem>`', '`<Pager.Item>`');
	module.exports = exports['default'];

/***/ },
/* 1535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PagerItem = __webpack_require__(482);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _createChainedFunction = __webpack_require__(34);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(45);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onSelect: _propTypes2['default'].func
	};
	
	var Pager = function (_React$Component) {
	  (0, _inherits3['default'])(Pager, _React$Component);
	
	  function Pager() {
	    (0, _classCallCheck3['default'])(this, Pager);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Pager.prototype.render = function render() {
	    var _props = this.props,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onSelect', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, {
	          onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect)
	        });
	      })
	    );
	  };
	
	  return Pager;
	}(_react2['default'].Component);
	
	Pager.propTypes = propTypes;
	
	Pager.Item = _PagerItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('pager', Pager);
	module.exports = exports['default'];

/***/ },
/* 1536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _PaginationButton = __webpack_require__(483);
	
	var _PaginationButton2 = _interopRequireDefault(_PaginationButton);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  activePage: _propTypes2['default'].number,
	  items: _propTypes2['default'].number,
	  maxButtons: _propTypes2['default'].number,
	
	  /**
	   * When `true`, will display the first and the last button page when
	   * displaying ellipsis.
	   */
	  boundaryLinks: _propTypes2['default'].bool,
	
	  /**
	   * When `true`, will display the default node value ('&hellip;').
	   * Otherwise, will display provided node (when specified).
	   */
	  ellipsis: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&laquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  first: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&raquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  last: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&lsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  prev: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&rsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  next: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * You can use a custom element for the buttons
	   */
	  buttonComponentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  activePage: 1,
	  items: 1,
	  maxButtons: 0,
	  first: false,
	  last: false,
	  prev: false,
	  next: false,
	  ellipsis: true,
	  boundaryLinks: false
	};
	
	var Pagination = function (_React$Component) {
	  (0, _inherits3['default'])(Pagination, _React$Component);
	
	  function Pagination() {
	    (0, _classCallCheck3['default'])(this, Pagination);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Pagination.prototype.renderPageButtons = function renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps) {
	    var pageButtons = [];
	
	    var startPage = void 0;
	    var endPage = void 0;
	
	    if (maxButtons && maxButtons < items) {
	      startPage = Math.max(Math.min(activePage - Math.floor(maxButtons / 2, 10), items - maxButtons + 1), 1);
	      endPage = startPage + maxButtons - 1;
	    } else {
	      startPage = 1;
	      endPage = items;
	    }
	
	    for (var page = startPage; page <= endPage; ++page) {
	      pageButtons.push(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          key: page,
	          eventKey: page,
	          active: page === activePage
	        }),
	        page
	      ));
	    }
	
	    if (ellipsis && boundaryLinks && startPage > 1) {
	      if (startPage > 2) {
	        pageButtons.unshift(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          {
	            key: 'ellipsisFirst',
	            disabled: true,
	            componentClass: buttonProps.componentClass
	          },
	          _react2['default'].createElement(
	            'span',
	            { 'aria-label': 'More' },
	            ellipsis === true ? '\u2026' : ellipsis
	          )
	        ));
	      }
	
	      pageButtons.unshift(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          key: 1,
	          eventKey: 1,
	          active: false
	        }),
	        '1'
	      ));
	    }
	
	    if (ellipsis && endPage < items) {
	      if (!boundaryLinks || endPage < items - 1) {
	        pageButtons.push(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          {
	            key: 'ellipsis',
	            disabled: true,
	            componentClass: buttonProps.componentClass
	          },
	          _react2['default'].createElement(
	            'span',
	            { 'aria-label': 'More' },
	            ellipsis === true ? '\u2026' : ellipsis
	          )
	        ));
	      }
	
	      if (boundaryLinks) {
	        pageButtons.push(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          (0, _extends3['default'])({}, buttonProps, {
	            key: items,
	            eventKey: items,
	            active: false
	          }),
	          items
	        ));
	      }
	    }
	
	    return pageButtons;
	  };
	
	  Pagination.prototype.render = function render() {
	    var _props = this.props,
	        activePage = _props.activePage,
	        items = _props.items,
	        maxButtons = _props.maxButtons,
	        boundaryLinks = _props.boundaryLinks,
	        ellipsis = _props.ellipsis,
	        first = _props.first,
	        last = _props.last,
	        prev = _props.prev,
	        next = _props.next,
	        onSelect = _props.onSelect,
	        buttonComponentClass = _props.buttonComponentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['activePage', 'items', 'maxButtons', 'boundaryLinks', 'ellipsis', 'first', 'last', 'prev', 'next', 'onSelect', 'buttonComponentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var buttonProps = {
	      onSelect: onSelect,
	      componentClass: buttonComponentClass
	    };
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      first && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: 1,
	          disabled: activePage === 1
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'First' },
	          first === true ? '\xAB' : first
	        )
	      ),
	      prev && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: activePage - 1,
	          disabled: activePage === 1
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Previous' },
	          prev === true ? '\u2039' : prev
	        )
	      ),
	      this.renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps),
	      next && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: activePage + 1,
	          disabled: activePage >= items
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Next' },
	          next === true ? '\u203A' : next
	        )
	      ),
	      last && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: items,
	          disabled: activePage >= items
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Last' },
	          last === true ? '\xBB' : last
	        )
	      )
	    );
	  };
	
	  return Pagination;
	}(_react2['default'].Component);
	
	Pagination.propTypes = propTypes;
	Pagination.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('pagination', Pagination);
	module.exports = exports['default'];

/***/ },
/* 1537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(119);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(321);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  collapsible: _propTypes2['default'].bool,
	  onSelect: _propTypes2['default'].func,
	  header: _propTypes2['default'].node,
	  id: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
	  footer: _propTypes2['default'].node,
	  defaultExpanded: _propTypes2['default'].bool,
	  expanded: _propTypes2['default'].bool,
	  eventKey: _propTypes2['default'].any,
	  headerRole: _propTypes2['default'].string,
	  panelRole: _propTypes2['default'].string,
	
	  // From Collapse.
	  onEnter: _propTypes2['default'].func,
	  onEntering: _propTypes2['default'].func,
	  onEntered: _propTypes2['default'].func,
	  onExit: _propTypes2['default'].func,
	  onExiting: _propTypes2['default'].func,
	  onExited: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  defaultExpanded: false
	};
	
	var Panel = function (_React$Component) {
	  (0, _inherits3['default'])(Panel, _React$Component);
	
	  function Panel(props, context) {
	    (0, _classCallCheck3['default'])(this, Panel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClickTitle = _this.handleClickTitle.bind(_this);
	
	    _this.state = {
	      expanded: _this.props.defaultExpanded
	    };
	    return _this;
	  }
	
	  Panel.prototype.handleClickTitle = function handleClickTitle(e) {
	    // FIXME: What the heck? This API is horrible. This needs to go away!
	    e.persist();
	    e.selected = true;
	
	    if (this.props.onSelect) {
	      this.props.onSelect(this.props.eventKey, e);
	    } else {
	      e.preventDefault();
	    }
	
	    if (e.selected) {
	      this.setState({ expanded: !this.state.expanded });
	    }
	  };
	
	  Panel.prototype.renderHeader = function renderHeader(collapsible, header, id, role, expanded, bsProps) {
	    var titleClassName = (0, _bootstrapUtils.prefix)(bsProps, 'title');
	
	    if (!collapsible) {
	      if (!_react2['default'].isValidElement(header)) {
	        return header;
	      }
	
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2['default'])(header.props.className, titleClassName)
	      });
	    }
	
	    if (!_react2['default'].isValidElement(header)) {
	      return _react2['default'].createElement(
	        'h4',
	        { role: 'presentation', className: titleClassName },
	        this.renderAnchor(header, id, role, expanded)
	      );
	    }
	
	    return (0, _react.cloneElement)(header, {
	      className: (0, _classnames2['default'])(header.props.className, titleClassName),
	      children: this.renderAnchor(header.props.children, id, role, expanded)
	    });
	  };
	
	  Panel.prototype.renderAnchor = function renderAnchor(header, id, role, expanded) {
	    return _react2['default'].createElement(
	      'a',
	      {
	        role: role,
	        href: id && '#' + id,
	        onClick: this.handleClickTitle,
	        'aria-controls': id,
	        'aria-expanded': expanded,
	        'aria-selected': expanded,
	        className: expanded ? null : 'collapsed'
	      },
	      header
	    );
	  };
	
	  Panel.prototype.renderCollapsibleBody = function renderCollapsibleBody(id, expanded, role, children, bsProps, animationHooks) {
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      (0, _extends3['default'])({ 'in': expanded }, animationHooks),
	      _react2['default'].createElement(
	        'div',
	        {
	          id: id,
	          role: role,
	          className: (0, _bootstrapUtils.prefix)(bsProps, 'collapse'),
	          'aria-hidden': !expanded
	        },
	        this.renderBody(children, bsProps)
	      )
	    );
	  };
	
	  Panel.prototype.renderBody = function renderBody(rawChildren, bsProps) {
	    var children = [];
	    var bodyChildren = [];
	
	    var bodyClassName = (0, _bootstrapUtils.prefix)(bsProps, 'body');
	
	    function maybeAddBody() {
	      if (!bodyChildren.length) {
	        return;
	      }
	
	      // Derive the key from the index here, since we need to make one up.
	      children.push(_react2['default'].createElement(
	        'div',
	        { key: children.length, className: bodyClassName },
	        bodyChildren
	      ));
	
	      bodyChildren = [];
	    }
	
	    // Convert to array so we can re-use keys.
	    _react2['default'].Children.toArray(rawChildren).forEach(function (child) {
	      if (_react2['default'].isValidElement(child) && child.props.fill) {
	        maybeAddBody();
	
	        // Remove the child's unknown `fill` prop.
	        children.push((0, _react.cloneElement)(child, { fill: undefined }));
	
	        return;
	      }
	
	      bodyChildren.push(child);
	    });
	
	    maybeAddBody();
	
	    return children;
	  };
	
	  Panel.prototype.render = function render() {
	    var _props = this.props,
	        collapsible = _props.collapsible,
	        header = _props.header,
	        id = _props.id,
	        footer = _props.footer,
	        propsExpanded = _props.expanded,
	        headerRole = _props.headerRole,
	        panelRole = _props.panelRole,
	        className = _props.className,
	        children = _props.children,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['collapsible', 'header', 'id', 'footer', 'expanded', 'headerRole', 'panelRole', 'className', 'children', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultExpanded', 'eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var expanded = propsExpanded != null ? propsExpanded : this.state.expanded;
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes),
	        id: collapsible ? null : id
	      }),
	      header && _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'heading') },
	        this.renderHeader(collapsible, header, id, headerRole, expanded, bsProps)
	      ),
	      collapsible ? this.renderCollapsibleBody(id, expanded, panelRole, children, bsProps, { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited }) : this.renderBody(children, bsProps),
	      footer && _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'footer') },
	        footer
	      )
	    );
	  };
	
	  return Panel;
	}(_react2['default'].Component);
	
	Panel.propTypes = propTypes;
	Panel.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('panel', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Panel));
	module.exports = exports['default'];

/***/ },
/* 1538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(227);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  /**
	   * Sets the direction the Popover is positioned towards.
	   */
	  placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Popover.
	   */
	  positionTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Popover.
	   */
	  positionLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	
	  /**
	   * The "top" position value for the Popover arrow.
	   */
	  arrowOffsetTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Popover arrow.
	   */
	  arrowOffsetLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	
	  /**
	   * Title content
	   */
	  title: _propTypes2['default'].node
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Popover = function (_React$Component) {
	  (0, _inherits3['default'])(Popover, _React$Component);
	
	  function Popover() {
	    (0, _classCallCheck3['default'])(this, Popover);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Popover.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        title = _props.title,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'title', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4['default'])({
	      display: 'block',
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2['default'])(className, classes),
	        style: outerStyle
	      }),
	      _react2['default'].createElement('div', { className: 'arrow', style: arrowStyle }),
	      title && _react2['default'].createElement(
	        'h3',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'title') },
	        title
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'content') },
	        children
	      )
	    );
	  };
	
	  return Popover;
	}(_react2['default'].Component);
	
	Popover.propTypes = propTypes;
	Popover.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('popover', Popover);
	module.exports = exports['default'];

/***/ },
/* 1539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(119);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(36);
	
	var _ValidComponentChildren = __webpack_require__(45);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ROUND_PRECISION = 1000;
	
	/**
	 * Validate that children, if any, are instances of `<ProgressBar>`.
	 */
	function onlyProgressBar(props, propName, componentName) {
	  var children = props[propName];
	  if (!children) {
	    return null;
	  }
	
	  var error = null;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (error) {
	      return;
	    }
	
	    if (child.type === ProgressBar) {
	      // eslint-disable-line no-use-before-define
	      return;
	    }
	
	    var childIdentifier = _react2['default'].isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
	    error = new Error('Children of ' + componentName + ' can contain only ProgressBar ' + ('components. Found ' + childIdentifier + '.'));
	  });
	
	  return error;
	}
	
	var propTypes = {
	  min: _propTypes2['default'].number,
	  now: _propTypes2['default'].number,
	  max: _propTypes2['default'].number,
	  label: _propTypes2['default'].node,
	  srOnly: _propTypes2['default'].bool,
	  striped: _propTypes2['default'].bool,
	  active: _propTypes2['default'].bool,
	  children: onlyProgressBar,
	
	  /**
	   * @private
	   */
	  isChild: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  min: 0,
	  max: 100,
	  active: false,
	  isChild: false,
	  srOnly: false,
	  striped: false
	};
	
	function getPercentage(now, min, max) {
	  var percentage = (now - min) / (max - min) * 100;
	  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
	}
	
	var ProgressBar = function (_React$Component) {
	  (0, _inherits3['default'])(ProgressBar, _React$Component);
	
	  function ProgressBar() {
	    (0, _classCallCheck3['default'])(this, ProgressBar);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ProgressBar.prototype.renderProgressBar = function renderProgressBar(_ref) {
	    var _extends2;
	
	    var min = _ref.min,
	        now = _ref.now,
	        max = _ref.max,
	        label = _ref.label,
	        srOnly = _ref.srOnly,
	        striped = _ref.striped,
	        active = _ref.active,
	        className = _ref.className,
	        style = _ref.style,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'className', 'style']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = active || striped, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'progressbar',
	        className: (0, _classnames2['default'])(className, classes),
	        style: (0, _extends4['default'])({ width: getPercentage(now, min, max) + '%' }, style),
	        'aria-valuenow': now,
	        'aria-valuemin': min,
	        'aria-valuemax': max
	      }),
	      srOnly ? _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        label
	      ) : label
	    );
	  };
	
	  ProgressBar.prototype.render = function render() {
	    var _props = this.props,
	        isChild = _props.isChild,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['isChild']);
	
	
	    if (isChild) {
	      return this.renderProgressBar(props);
	    }
	
	    var min = props.min,
	        now = props.now,
	        max = props.max,
	        label = props.label,
	        srOnly = props.srOnly,
	        striped = props.striped,
	        active = props.active,
	        bsClass = props.bsClass,
	        bsStyle = props.bsStyle,
	        className = props.className,
	        children = props.children,
	        wrapperProps = (0, _objectWithoutProperties3['default'])(props, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'bsClass', 'bsStyle', 'className', 'children']);
	
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, wrapperProps, {
	        className: (0, _classnames2['default'])(className, 'progress')
	      }),
	      children ? _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, { isChild: true });
	      }) : this.renderProgressBar({
	        min: min, now: now, max: max, label: label, srOnly: srOnly, striped: striped, active: active, bsClass: bsClass, bsStyle: bsStyle
	      })
	    );
	  };
	
	  return ProgressBar;
	}(_react2['default'].Component);
	
	ProgressBar.propTypes = propTypes;
	ProgressBar.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('progress-bar', (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), ProgressBar));
	module.exports = exports['default'];

/***/ },
/* 1540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  inline: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes2['default'].oneOf(['success', 'warning', 'error', null]),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Radio inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  inline: false,
	  disabled: false
	};
	
	var Radio = function (_React$Component) {
	  (0, _inherits3['default'])(Radio, _React$Component);
	
	  function Radio() {
	    (0, _classCallCheck3['default'])(this, Radio);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Radio.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2['default'].createElement('input', (0, _extends3['default'])({}, elementProps, {
	      ref: inputRef,
	      type: 'radio',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2['default'])(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2['default'].createElement(
	        'label',
	        { className: (0, _classnames2['default'])(className, _classes), style: style },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(className, classes), style: style },
	      _react2['default'].createElement(
	        'label',
	        null,
	        input,
	        children
	      )
	    );
	  };
	
	  return Radio;
	}(_react2['default'].Component);
	
	Radio.propTypes = propTypes;
	Radio.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('radio', Radio);
	module.exports = exports['default'];

/***/ },
/* 1541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should probably take a single `aspectRatio` prop.
	
	var propTypes = {
	  /**
	   * This component requires a single child element
	   */
	  children: _propTypes2['default'].element.isRequired,
	  /**
	   * 16by9 aspect ratio
	   */
	  a16by9: _propTypes2['default'].bool,
	  /**
	   * 4by3 aspect ratio
	   */
	  a4by3: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  a16by9: false,
	  a4by3: false
	};
	
	var ResponsiveEmbed = function (_React$Component) {
	  (0, _inherits3['default'])(ResponsiveEmbed, _React$Component);
	
	  function ResponsiveEmbed() {
	    (0, _classCallCheck3['default'])(this, ResponsiveEmbed);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ResponsiveEmbed.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        a16by9 = _props.a16by9,
	        a4by3 = _props.a4by3,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['a16by9', 'a4by3', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
	     false ? (0, _warning2['default'])(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '16by9')] = a16by9, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '4by3')] = a4by3, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(classes) },
	      (0, _react.cloneElement)(children, (0, _extends4['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'item'))
	      }))
	    );
	  };
	
	  return ResponsiveEmbed;
	}(_react2['default'].Component);
	
	ResponsiveEmbed.propTypes = propTypes;
	ResponsiveEmbed.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('embed-responsive', ResponsiveEmbed);
	module.exports = exports['default'];

/***/ },
/* 1542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Row = function (_React$Component) {
	  (0, _inherits3['default'])(Row, _React$Component);
	
	  function Row() {
	    (0, _classCallCheck3['default'])(this, Row);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Row.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Row;
	}(_react2['default'].Component);
	
	Row.propTypes = propTypes;
	Row.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('row', Row);
	module.exports = exports['default'];

/***/ },
/* 1543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(170);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Dropdown = __webpack_require__(217);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _SplitToggle = __webpack_require__(1544);
	
	var _SplitToggle2 = _interopRequireDefault(_SplitToggle);
	
	var _splitComponentProps2 = __webpack_require__(219);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  bsStyle: _propTypes2['default'].string,
	  bsSize: _propTypes2['default'].string,
	  href: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  /**
	   * The content of the split button.
	   */
	  title: _propTypes2['default'].node.isRequired,
	  /**
	   * Accessible label for the toggle; the value of `title` if not specified.
	   */
	  toggleLabel: _propTypes2['default'].string,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2['default'].node
	});
	
	var SplitButton = function (_React$Component) {
	  (0, _inherits3['default'])(SplitButton, _React$Component);
	
	  function SplitButton() {
	    (0, _classCallCheck3['default'])(this, SplitButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        toggleLabel = _props.toggleLabel,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['bsSize', 'bsStyle', 'title', 'toggleLabel', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        buttonProps = _splitComponentProps[1];
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Button2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          disabled: props.disabled,
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2['default'].createElement(_SplitToggle2['default'], {
	        'aria-label': toggleLabel || title,
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return SplitButton;
	}(_react2['default'].Component);
	
	SplitButton.propTypes = propTypes;
	
	SplitButton.Toggle = _SplitToggle2['default'];
	
	exports['default'] = SplitButton;
	module.exports = exports['default'];

/***/ },
/* 1544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DropdownToggle = __webpack_require__(471);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var SplitToggle = function (_React$Component) {
	  (0, _inherits3['default'])(SplitToggle, _React$Component);
	
	  function SplitToggle() {
	    (0, _classCallCheck3['default'])(this, SplitToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitToggle.prototype.render = function render() {
	    return _react2['default'].createElement(_DropdownToggle2['default'], (0, _extends3['default'])({}, this.props, {
	      useAnchor: false,
	      noCaret: false
	    }));
	  };
	
	  return SplitToggle;
	}(_react2['default'].Component);
	
	SplitToggle.defaultProps = _DropdownToggle2['default'].defaultProps;
	
	exports['default'] = SplitToggle;
	module.exports = exports['default'];

/***/ },
/* 1545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TabContainer = __webpack_require__(324);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(325);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _TabPane = __webpack_require__(485);
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _TabPane2['default'].propTypes, {
	
	  disabled: _propTypes2['default'].bool,
	
	  title: _propTypes2['default'].node,
	
	  /**
	   * tabClassName is used as className for the associated NavItem
	   */
	  tabClassName: _propTypes2['default'].string
	});
	
	var Tab = function (_React$Component) {
	  (0, _inherits3['default'])(Tab, _React$Component);
	
	  function Tab() {
	    (0, _classCallCheck3['default'])(this, Tab);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tab.prototype.render = function render() {
	    var props = (0, _extends3['default'])({}, this.props);
	
	    // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
	    delete props.title;
	    delete props.disabled;
	    delete props.tabClassName;
	
	    return _react2['default'].createElement(_TabPane2['default'], props);
	  };
	
	  return Tab;
	}(_react2['default'].Component);
	
	Tab.propTypes = propTypes;
	
	Tab.Container = _TabContainer2['default'];
	Tab.Content = _TabContent2['default'];
	Tab.Pane = _TabPane2['default'];
	
	exports['default'] = Tab;
	module.exports = exports['default'];

/***/ },
/* 1546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  striped: _propTypes2['default'].bool,
	  bordered: _propTypes2['default'].bool,
	  condensed: _propTypes2['default'].bool,
	  hover: _propTypes2['default'].bool,
	  responsive: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  bordered: false,
	  condensed: false,
	  hover: false,
	  responsive: false,
	  striped: false
	};
	
	var Table = function (_React$Component) {
	  (0, _inherits3['default'])(Table, _React$Component);
	
	  function Table() {
	    (0, _classCallCheck3['default'])(this, Table);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Table.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        striped = _props.striped,
	        bordered = _props.bordered,
	        condensed = _props.condensed,
	        hover = _props.hover,
	        responsive = _props.responsive,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['striped', 'bordered', 'condensed', 'hover', 'responsive', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = striped, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'bordered')] = bordered, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'condensed')] = condensed, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'hover')] = hover, _extends2));
	
	    var table = _react2['default'].createElement('table', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	
	    if (responsive) {
	      return _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'responsive') },
	        table
	      );
	    }
	
	    return table;
	  };
	
	  return Table;
	}(_react2['default'].Component);
	
	Table.propTypes = propTypes;
	Table.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('table', Table);
	module.exports = exports['default'];

/***/ },
/* 1547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(227);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(233);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Nav = __webpack_require__(478);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _NavItem = __webpack_require__(479);
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	var _TabContainer = __webpack_require__(324);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(325);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _ValidComponentChildren = __webpack_require__(45);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TabContainer = _TabContainer2['default'].ControlledComponent;
	
	var propTypes = {
	  /**
	   * Mark the Tab with a matching `eventKey` as active.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2['default'].any,
	
	  /**
	   * Navigation style
	   */
	  bsStyle: _propTypes2['default'].oneOf(['tabs', 'pills']),
	
	  animation: _propTypes2['default'].bool,
	
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  /**
	   * Callback fired when a Tab is selected.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  bsStyle: 'tabs',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	function getDefaultActiveKey(children) {
	  var defaultActiveKey = void 0;
	  _ValidComponentChildren2['default'].forEach(children, function (child) {
	    if (defaultActiveKey == null) {
	      defaultActiveKey = child.props.eventKey;
	    }
	  });
	
	  return defaultActiveKey;
	}
	
	var Tabs = function (_React$Component) {
	  (0, _inherits3['default'])(Tabs, _React$Component);
	
	  function Tabs() {
	    (0, _classCallCheck3['default'])(this, Tabs);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tabs.prototype.renderTab = function renderTab(child) {
	    var _child$props = child.props,
	        title = _child$props.title,
	        eventKey = _child$props.eventKey,
	        disabled = _child$props.disabled,
	        tabClassName = _child$props.tabClassName;
	
	    if (title == null) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      _NavItem2['default'],
	      {
	        eventKey: eventKey,
	        disabled: disabled,
	        className: tabClassName
	      },
	      title
	    );
	  };
	
	  Tabs.prototype.render = function render() {
	    var _props = this.props,
	        id = _props.id,
	        onSelect = _props.onSelect,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        _props$activeKey = _props.activeKey,
	        activeKey = _props$activeKey === undefined ? getDefaultActiveKey(children) : _props$activeKey,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['id', 'onSelect', 'animation', 'mountOnEnter', 'unmountOnExit', 'bsClass', 'className', 'style', 'children', 'activeKey']);
	
	
	    return _react2['default'].createElement(
	      TabContainer,
	      {
	        id: id,
	        activeKey: activeKey,
	        onSelect: onSelect,
	        className: className,
	        style: style
	      },
	      _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          _Nav2['default'],
	          (0, _extends3['default'])({}, props, {
	            role: 'tablist'
	          }),
	          _ValidComponentChildren2['default'].map(children, this.renderTab)
	        ),
	        _react2['default'].createElement(
	          _TabContent2['default'],
	          {
	            bsClass: bsClass,
	            animation: animation,
	            mountOnEnter: mountOnEnter,
	            unmountOnExit: unmountOnExit
	          },
	          children
	        )
	      )
	    );
	  };
	
	  return Tabs;
	}(_react2['default'].Component);
	
	Tabs.propTypes = propTypes;
	Tabs.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('tab', Tabs);
	
	exports['default'] = (0, _uncontrollable2['default'])(Tabs, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ },
/* 1548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(69);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  src: _propTypes2['default'].string,
	  alt: _propTypes2['default'].string,
	  href: _propTypes2['default'].string
	};
	
	var Thumbnail = function (_React$Component) {
	  (0, _inherits3['default'])(Thumbnail, _React$Component);
	
	  function Thumbnail() {
	    (0, _classCallCheck3['default'])(this, Thumbnail);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Thumbnail.prototype.render = function render() {
	    var _props = this.props,
	        src = _props.src,
	        alt = _props.alt,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['src', 'alt', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var Component = elementProps.href ? _SafeAnchor2['default'] : 'div';
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement('img', { src: src, alt: alt }),
	      children && _react2['default'].createElement(
	        'div',
	        { className: 'caption' },
	        children
	      )
	    );
	  };
	
	  return Thumbnail;
	}(_react2['default'].Component);
	
	Thumbnail.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('thumbnail', Thumbnail);
	module.exports = exports['default'];

/***/ },
/* 1549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(227);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  /**
	   * Sets the direction the Tooltip is positioned towards.
	   */
	  placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Tooltip.
	   */
	  positionTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Tooltip.
	   */
	  positionLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	
	  /**
	   * The "top" position value for the Tooltip arrow.
	   */
	  arrowOffsetTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Tooltip arrow.
	   */
	  arrowOffsetLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Tooltip = function (_React$Component) {
	  (0, _inherits3['default'])(Tooltip, _React$Component);
	
	  function Tooltip() {
	    (0, _classCallCheck3['default'])(this, Tooltip);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tooltip.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4['default'])({
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2['default'])(className, classes),
	        style: outerStyle
	      }),
	      _react2['default'].createElement('div', { className: (0, _bootstrapUtils.prefix)(bsProps, 'arrow'), style: arrowStyle }),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        children
	      )
	    );
	  };
	
	  return Tooltip;
	}(_react2['default'].Component);
	
	Tooltip.propTypes = propTypes;
	Tooltip.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tooltip', Tooltip);
	module.exports = exports['default'];

/***/ },
/* 1550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(10);
	
	var _StyleConfig = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Well = function (_React$Component) {
	  (0, _inherits3['default'])(Well, _React$Component);
	
	  function Well() {
	    (0, _classCallCheck3['default'])(this, Well);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Well.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Well;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('well', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Well));
	module.exports = exports['default'];

/***/ },
/* 1551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.requiredRoles = requiredRoles;
	exports.exclusiveRoles = exclusiveRoles;
	
	var _createChainableTypeChecker = __webpack_require__(228);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	var _ValidComponentChildren = __webpack_require__(45);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function requiredRoles() {
	  for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
	    roles[_key] = arguments[_key];
	  }
	
	  return (0, _createChainableTypeChecker2['default'])(function (props, propName, component) {
	    var missing = void 0;
	
	    roles.every(function (role) {
	      if (!_ValidComponentChildren2['default'].some(props.children, function (child) {
	        return child.props.bsRole === role;
	      })) {
	        missing = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (missing) {
	      return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + (missing + '. ' + component + ' must have at least one child of each of ') + ('the following bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}
	
	function exclusiveRoles() {
	  for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    roles[_key2] = arguments[_key2];
	  }
	
	  return (0, _createChainableTypeChecker2['default'])(function (props, propName, component) {
	    var duplicate = void 0;
	
	    roles.every(function (role) {
	      var childrenWithRole = _ValidComponentChildren2['default'].filter(props.children, function (child) {
	        return child.props.bsRole === role;
	      });
	
	      if (childrenWithRole.length > 1) {
	        duplicate = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (duplicate) {
	      return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + (duplicate + '. Only one child each allowed with the following ') + ('bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}

/***/ },
/* 1552 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This file contains a modified version of:
	 * https://github.com/facebook/react/blob/v0.12.0/src/addons/transitions/ReactTransitionEvents.js
	 *
	 * This source code is licensed under the BSD-style license found here:
	 * https://github.com/facebook/react/blob/v0.12.0/LICENSE
	 * An additional grant of patent rights can be found here:
	 * https://github.com/facebook/react/blob/v0.12.0/PATENTS
	 */
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    'transition': 'transitionend',
	    'WebkitTransition': 'webkitTransitionEnd',
	    'MozTransition': 'mozTransitionEnd',
	    'OTransition': 'oTransitionEnd',
	    'msTransition': 'MSTransitionEnd'
	  },
	
	  animationend: {
	    'animation': 'animationend',
	    'WebkitAnimation': 'webkitAnimationEnd',
	    'MozAnimation': 'mozAnimationEnd',
	    'OAnimation': 'oAnimationEnd',
	    'msAnimation': 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    // eslint-disable-line guard-for-in
	    var baseEvents = EVENT_NAME_MAP[baseEventName];
	    for (var styleName in baseEvents) {
	      if (styleName in style) {
	        endEvents.push(baseEvents[styleName]);
	        break;
	      }
	    }
	  }
	}
	
	if (canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports['default'] = ReactTransitionEvents;
	module.exports = exports['default'];

/***/ },
/* 1553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(239);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var warned = {};
	
	function deprecationWarning(oldname, newname, link) {
	  var message = void 0;
	
	  if ((typeof oldname === 'undefined' ? 'undefined' : (0, _typeof3['default'])(oldname)) === 'object') {
	    message = oldname.message;
	  } else {
	    message = oldname + ' is deprecated. Use ' + newname + ' instead.';
	
	    if (link) {
	      message += '\nYou can read more about it at ' + link;
	    }
	  }
	
	  if (warned[message]) {
	    return;
	  }
	
	   false ? (0, _warning2['default'])(false, message) : void 0;
	  warned[message] = true;
	}
	
	deprecationWarning.wrapper = function (Component) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return function (_Component) {
	    (0, _inherits3['default'])(DeprecatedComponent, _Component);
	
	    function DeprecatedComponent() {
	      (0, _classCallCheck3['default'])(this, DeprecatedComponent);
	      return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	    }
	
	    DeprecatedComponent.prototype.componentWillMount = function componentWillMount() {
	      deprecationWarning.apply(undefined, args);
	
	      if (_Component.prototype.componentWillMount) {
	        var _Component$prototype$;
	
	        for (var _len2 = arguments.length, methodArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          methodArgs[_key2] = arguments[_key2];
	        }
	
	        (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
	      }
	    };
	
	    return DeprecatedComponent;
	  }(Component);
	};
	
	exports['default'] = deprecationWarning;
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 1554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ValidComponentChildren = exports.createChainedFunction = exports.bootstrapUtils = undefined;
	
	var _bootstrapUtils2 = __webpack_require__(10);
	
	var _bootstrapUtils = _interopRequireWildcard(_bootstrapUtils2);
	
	var _createChainedFunction2 = __webpack_require__(34);
	
	var _createChainedFunction3 = _interopRequireDefault(_createChainedFunction2);
	
	var _ValidComponentChildren2 = __webpack_require__(45);
	
	var _ValidComponentChildren3 = _interopRequireDefault(_ValidComponentChildren2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	exports.bootstrapUtils = _bootstrapUtils;
	exports.createChainedFunction = _createChainedFunction3['default'];
	exports.ValidComponentChildren = _ValidComponentChildren3['default'];

/***/ },
/* 1555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _union = __webpack_require__(1465);
	
	var _union2 = _interopRequireDefault(_union);
	
	var _without = __webpack_require__(451);
	
	var _without2 = _interopRequireDefault(_without);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EnterLeaveCounter = function () {
		function EnterLeaveCounter() {
			_classCallCheck(this, EnterLeaveCounter);
	
			this.entered = [];
		}
	
		_createClass(EnterLeaveCounter, [{
			key: 'enter',
			value: function enter(enteringNode) {
				var previousLength = this.entered.length;
	
				var isNodeEntered = function isNodeEntered(node) {
					return document.documentElement.contains(node) && (!node.contains || node.contains(enteringNode));
				};
	
				this.entered = (0, _union2.default)(this.entered.filter(isNodeEntered), [enteringNode]);
	
				return previousLength === 0 && this.entered.length > 0;
			}
		}, {
			key: 'leave',
			value: function leave(leavingNode) {
				var previousLength = this.entered.length;
	
				this.entered = (0, _without2.default)(this.entered.filter(function (node) {
					return document.documentElement.contains(node);
				}), leavingNode);
	
				return previousLength > 0 && this.entered.length === 0;
			}
		}, {
			key: 'reset',
			value: function reset() {
				this.entered = [];
			}
		}]);
	
		return EnterLeaveCounter;
	}();
	
	exports.default = EnterLeaveCounter;

/***/ },
/* 1556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable no-underscore-dangle */
	
	
	var _defaults = __webpack_require__(1458);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	var _shallowEqual = __webpack_require__(1562);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _EnterLeaveCounter = __webpack_require__(1555);
	
	var _EnterLeaveCounter2 = _interopRequireDefault(_EnterLeaveCounter);
	
	var _BrowserDetector = __webpack_require__(487);
	
	var _OffsetUtils = __webpack_require__(1559);
	
	var _NativeDragSources = __webpack_require__(1558);
	
	var _NativeTypes = __webpack_require__(326);
	
	var NativeTypes = _interopRequireWildcard(_NativeTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HTML5Backend = function () {
		function HTML5Backend(manager) {
			_classCallCheck(this, HTML5Backend);
	
			this.actions = manager.getActions();
			this.monitor = manager.getMonitor();
			this.registry = manager.getRegistry();
			this.context = manager.getContext();
	
			this.sourcePreviewNodes = {};
			this.sourcePreviewNodeOptions = {};
			this.sourceNodes = {};
			this.sourceNodeOptions = {};
			this.enterLeaveCounter = new _EnterLeaveCounter2.default();
	
			this.dragStartSourceIds = [];
			this.dropTargetIds = [];
			this.dragEnterTargetIds = [];
			this.currentNativeSource = null;
			this.currentNativeHandle = null;
			this.currentDragSourceNode = null;
			this.currentDragSourceNodeOffset = null;
			this.currentDragSourceNodeOffsetChanged = false;
			this.altKeyPressed = false;
			this.mouseMoveTimeoutTimer = null;
	
			this.getSourceClientOffset = this.getSourceClientOffset.bind(this);
			this.handleTopDragStart = this.handleTopDragStart.bind(this);
			this.handleTopDragStartCapture = this.handleTopDragStartCapture.bind(this);
			this.handleTopDragEndCapture = this.handleTopDragEndCapture.bind(this);
			this.handleTopDragEnter = this.handleTopDragEnter.bind(this);
			this.handleTopDragEnterCapture = this.handleTopDragEnterCapture.bind(this);
			this.handleTopDragLeaveCapture = this.handleTopDragLeaveCapture.bind(this);
			this.handleTopDragOver = this.handleTopDragOver.bind(this);
			this.handleTopDragOverCapture = this.handleTopDragOverCapture.bind(this);
			this.handleTopDrop = this.handleTopDrop.bind(this);
			this.handleTopDropCapture = this.handleTopDropCapture.bind(this);
			this.handleSelectStart = this.handleSelectStart.bind(this);
			this.endDragIfSourceWasRemovedFromDOM = this.endDragIfSourceWasRemovedFromDOM.bind(this);
			this.endDragNativeItem = this.endDragNativeItem.bind(this);
			this.asyncEndDragNativeItem = this.asyncEndDragNativeItem.bind(this);
			this.isNodeInDocument = this.isNodeInDocument.bind(this);
		}
	
		_createClass(HTML5Backend, [{
			key: 'setup',
			value: function setup() {
				if (this.window === undefined) {
					return;
				}
	
				if (this.window.__isReactDndBackendSetUp) {
					throw new Error('Cannot have two HTML5 backends at the same time.');
				}
				this.window.__isReactDndBackendSetUp = true;
				this.addEventListeners(this.window);
			}
		}, {
			key: 'teardown',
			value: function teardown() {
				if (this.window === undefined) {
					return;
				}
	
				this.window.__isReactDndBackendSetUp = false;
				this.removeEventListeners(this.window);
				this.clearCurrentDragSourceNode();
				if (this.asyncEndDragFrameId) {
					this.window.cancelAnimationFrame(this.asyncEndDragFrameId);
				}
			}
		}, {
			key: 'addEventListeners',
			value: function addEventListeners(target) {
				// SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
				if (!target.addEventListener) {
					return;
				}
				target.addEventListener('dragstart', this.handleTopDragStart);
				target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
				target.addEventListener('dragend', this.handleTopDragEndCapture, true);
				target.addEventListener('dragenter', this.handleTopDragEnter);
				target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
				target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
				target.addEventListener('dragover', this.handleTopDragOver);
				target.addEventListener('dragover', this.handleTopDragOverCapture, true);
				target.addEventListener('drop', this.handleTopDrop);
				target.addEventListener('drop', this.handleTopDropCapture, true);
			}
		}, {
			key: 'removeEventListeners',
			value: function removeEventListeners(target) {
				// SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
				if (!target.removeEventListener) {
					return;
				}
				target.removeEventListener('dragstart', this.handleTopDragStart);
				target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
				target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
				target.removeEventListener('dragenter', this.handleTopDragEnter);
				target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
				target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
				target.removeEventListener('dragover', this.handleTopDragOver);
				target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
				target.removeEventListener('drop', this.handleTopDrop);
				target.removeEventListener('drop', this.handleTopDropCapture, true);
			}
		}, {
			key: 'connectDragPreview',
			value: function connectDragPreview(sourceId, node, options) {
				var _this = this;
	
				this.sourcePreviewNodeOptions[sourceId] = options;
				this.sourcePreviewNodes[sourceId] = node;
	
				return function () {
					delete _this.sourcePreviewNodes[sourceId];
					delete _this.sourcePreviewNodeOptions[sourceId];
				};
			}
		}, {
			key: 'connectDragSource',
			value: function connectDragSource(sourceId, node, options) {
				var _this2 = this;
	
				this.sourceNodes[sourceId] = node;
				this.sourceNodeOptions[sourceId] = options;
	
				var handleDragStart = function handleDragStart(e) {
					return _this2.handleDragStart(e, sourceId);
				};
				var handleSelectStart = function handleSelectStart(e) {
					return _this2.handleSelectStart(e, sourceId);
				};
	
				node.setAttribute('draggable', true);
				node.addEventListener('dragstart', handleDragStart);
				node.addEventListener('selectstart', handleSelectStart);
	
				return function () {
					delete _this2.sourceNodes[sourceId];
					delete _this2.sourceNodeOptions[sourceId];
	
					node.removeEventListener('dragstart', handleDragStart);
					node.removeEventListener('selectstart', handleSelectStart);
					node.setAttribute('draggable', false);
				};
			}
		}, {
			key: 'connectDropTarget',
			value: function connectDropTarget(targetId, node) {
				var _this3 = this;
	
				var handleDragEnter = function handleDragEnter(e) {
					return _this3.handleDragEnter(e, targetId);
				};
				var handleDragOver = function handleDragOver(e) {
					return _this3.handleDragOver(e, targetId);
				};
				var handleDrop = function handleDrop(e) {
					return _this3.handleDrop(e, targetId);
				};
	
				node.addEventListener('dragenter', handleDragEnter);
				node.addEventListener('dragover', handleDragOver);
				node.addEventListener('drop', handleDrop);
	
				return function () {
					node.removeEventListener('dragenter', handleDragEnter);
					node.removeEventListener('dragover', handleDragOver);
					node.removeEventListener('drop', handleDrop);
				};
			}
		}, {
			key: 'getCurrentSourceNodeOptions',
			value: function getCurrentSourceNodeOptions() {
				var sourceId = this.monitor.getSourceId();
				var sourceNodeOptions = this.sourceNodeOptions[sourceId];
	
				return (0, _defaults2.default)(sourceNodeOptions || {}, {
					dropEffect: this.altKeyPressed ? 'copy' : 'move'
				});
			}
		}, {
			key: 'getCurrentDropEffect',
			value: function getCurrentDropEffect() {
				if (this.isDraggingNativeItem()) {
					// It makes more sense to default to 'copy' for native resources
					return 'copy';
				}
	
				return this.getCurrentSourceNodeOptions().dropEffect;
			}
		}, {
			key: 'getCurrentSourcePreviewNodeOptions',
			value: function getCurrentSourcePreviewNodeOptions() {
				var sourceId = this.monitor.getSourceId();
				var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions[sourceId];
	
				return (0, _defaults2.default)(sourcePreviewNodeOptions || {}, {
					anchorX: 0.5,
					anchorY: 0.5,
					captureDraggingState: false
				});
			}
		}, {
			key: 'getSourceClientOffset',
			value: function getSourceClientOffset(sourceId) {
				return (0, _OffsetUtils.getNodeClientOffset)(this.sourceNodes[sourceId]);
			}
		}, {
			key: 'isDraggingNativeItem',
			value: function isDraggingNativeItem() {
				var itemType = this.monitor.getItemType();
				return Object.keys(NativeTypes).some(function (key) {
					return NativeTypes[key] === itemType;
				});
			}
		}, {
			key: 'beginDragNativeItem',
			value: function beginDragNativeItem(type) {
				this.clearCurrentDragSourceNode();
	
				var SourceType = (0, _NativeDragSources.createNativeDragSource)(type);
				this.currentNativeSource = new SourceType();
				this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
				this.actions.beginDrag([this.currentNativeHandle]);
			}
		}, {
			key: 'asyncEndDragNativeItem',
			value: function asyncEndDragNativeItem() {
				this.asyncEndDragFrameId = this.window.requestAnimationFrame(this.endDragNativeItem);
			}
		}, {
			key: 'endDragNativeItem',
			value: function endDragNativeItem() {
				if (!this.isDraggingNativeItem()) {
					return;
				}
	
				this.actions.endDrag();
				this.registry.removeSource(this.currentNativeHandle);
				this.currentNativeHandle = null;
				this.currentNativeSource = null;
			}
		}, {
			key: 'isNodeInDocument',
			value: function isNodeInDocument(node) {
				// Check the node either in the main document or in the current context
				return document.body.contains(node) || this.window ? this.window.document.body.contains(node) : false;
			}
		}, {
			key: 'endDragIfSourceWasRemovedFromDOM',
			value: function endDragIfSourceWasRemovedFromDOM() {
				var node = this.currentDragSourceNode;
				if (this.isNodeInDocument(node)) {
					return;
				}
	
				if (this.clearCurrentDragSourceNode()) {
					this.actions.endDrag();
				}
			}
		}, {
			key: 'setCurrentDragSourceNode',
			value: function setCurrentDragSourceNode(node) {
				var _this4 = this;
	
				this.clearCurrentDragSourceNode();
				this.currentDragSourceNode = node;
				this.currentDragSourceNodeOffset = (0, _OffsetUtils.getNodeClientOffset)(node);
				this.currentDragSourceNodeOffsetChanged = false;
	
				// A timeout of > 0 is necessary to resolve Firefox issue referenced
				// See:
				//   * https://github.com/react-dnd/react-dnd/pull/928
				//   * https://github.com/react-dnd/react-dnd/issues/869
				var MOUSE_MOVE_TIMEOUT = 1000;
	
				// Receiving a mouse event in the middle of a dragging operation
				// means it has ended and the drag source node disappeared from DOM,
				// so the browser didn't dispatch the dragend event.
				//
				// We need to wait before we start listening for mousemove events.
				// This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
				// immediately in some browsers.
				//
				// See:
				//   * https://github.com/react-dnd/react-dnd/pull/928
				//   * https://github.com/react-dnd/react-dnd/issues/869
				//
				this.mouseMoveTimeoutTimer = setTimeout(function () {
					_this4.mouseMoveTimeoutId = null;
					return _this4.window.addEventListener('mousemove', _this4.endDragIfSourceWasRemovedFromDOM, true);
				}, MOUSE_MOVE_TIMEOUT);
			}
		}, {
			key: 'clearCurrentDragSourceNode',
			value: function clearCurrentDragSourceNode() {
				if (this.currentDragSourceNode) {
					this.currentDragSourceNode = null;
					this.currentDragSourceNodeOffset = null;
					this.currentDragSourceNodeOffsetChanged = false;
					this.window.clearTimeout(this.mouseMoveTimeoutTimer);
					this.window.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
					this.mouseMoveTimeoutTimer = null;
					return true;
				}
	
				return false;
			}
		}, {
			key: 'checkIfCurrentDragSourceRectChanged',
			value: function checkIfCurrentDragSourceRectChanged() {
				var node = this.currentDragSourceNode;
				if (!node) {
					return false;
				}
	
				if (this.currentDragSourceNodeOffsetChanged) {
					return true;
				}
	
				this.currentDragSourceNodeOffsetChanged = !(0, _shallowEqual2.default)((0, _OffsetUtils.getNodeClientOffset)(node), this.currentDragSourceNodeOffset);
	
				return this.currentDragSourceNodeOffsetChanged;
			}
		}, {
			key: 'handleTopDragStartCapture',
			value: function handleTopDragStartCapture() {
				this.clearCurrentDragSourceNode();
				this.dragStartSourceIds = [];
			}
		}, {
			key: 'handleDragStart',
			value: function handleDragStart(e, sourceId) {
				this.dragStartSourceIds.unshift(sourceId);
			}
		}, {
			key: 'handleTopDragStart',
			value: function handleTopDragStart(e) {
				var _this5 = this;
	
				var dragStartSourceIds = this.dragStartSourceIds;
	
				this.dragStartSourceIds = null;
	
				var clientOffset = (0, _OffsetUtils.getEventClientOffset)(e);
	
				// Avoid crashing if we missed a drop event or our previous drag died
				if (this.monitor.isDragging()) {
					this.actions.endDrag();
				}
	
				// Don't publish the source just yet (see why below)
				this.actions.beginDrag(dragStartSourceIds, {
					publishSource: false,
					getSourceClientOffset: this.getSourceClientOffset,
					clientOffset: clientOffset
				});
	
				var dataTransfer = e.dataTransfer;
	
				var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);
	
				if (this.monitor.isDragging()) {
					if (typeof dataTransfer.setDragImage === 'function') {
						// Use custom drag image if user specifies it.
						// If child drag source refuses drag but parent agrees,
						// use parent's node as drag image. Neither works in IE though.
						var sourceId = this.monitor.getSourceId();
						var sourceNode = this.sourceNodes[sourceId];
						var dragPreview = this.sourcePreviewNodes[sourceId] || sourceNode;
	
						var _getCurrentSourcePrev = this.getCurrentSourcePreviewNodeOptions(),
						    anchorX = _getCurrentSourcePrev.anchorX,
						    anchorY = _getCurrentSourcePrev.anchorY,
						    offsetX = _getCurrentSourcePrev.offsetX,
						    offsetY = _getCurrentSourcePrev.offsetY;
	
						var anchorPoint = { anchorX: anchorX, anchorY: anchorY };
						var offsetPoint = { offsetX: offsetX, offsetY: offsetY };
						var dragPreviewOffset = (0, _OffsetUtils.getDragPreviewOffset)(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
	
						dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
					}
	
					try {
						// Firefox won't drag without setting data
						dataTransfer.setData('application/json', {});
					} catch (err) {}
					// IE doesn't support MIME types in setData
	
	
					// Store drag source node so we can check whether
					// it is removed from DOM and trigger endDrag manually.
					this.setCurrentDragSourceNode(e.target);
	
					// Now we are ready to publish the drag source.. or are we not?
	
					var _getCurrentSourcePrev2 = this.getCurrentSourcePreviewNodeOptions(),
					    captureDraggingState = _getCurrentSourcePrev2.captureDraggingState;
	
					if (!captureDraggingState) {
						// Usually we want to publish it in the next tick so that browser
						// is able to screenshot the current (not yet dragging) state.
						//
						// It also neatly avoids a situation where render() returns null
						// in the same tick for the source element, and browser freaks out.
						setTimeout(function () {
							return _this5.actions.publishDragSource();
						});
					} else {
						// In some cases the user may want to override this behavior, e.g.
						// to work around IE not supporting custom drag previews.
						//
						// When using a custom drag layer, the only way to prevent
						// the default drag preview from drawing in IE is to screenshot
						// the dragging state in which the node itself has zero opacity
						// and height. In this case, though, returning null from render()
						// will abruptly end the dragging, which is not obvious.
						//
						// This is the reason such behavior is strictly opt-in.
						this.actions.publishDragSource();
					}
				} else if (nativeType) {
					// A native item (such as URL) dragged from inside the document
					this.beginDragNativeItem(nativeType);
				} else if (!dataTransfer.types && (!e.target.hasAttribute || !e.target.hasAttribute('draggable'))) {
					// Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
					// Just let it drag. It's a native type (URL or text) and will be picked up in
					// dragenter handler.
					return; // eslint-disable-line no-useless-return
				} else {
					// If by this time no drag source reacted, tell browser not to drag.
					e.preventDefault();
				}
			}
		}, {
			key: 'handleTopDragEndCapture',
			value: function handleTopDragEndCapture() {
				if (this.clearCurrentDragSourceNode()) {
					// Firefox can dispatch this event in an infinite loop
					// if dragend handler does something like showing an alert.
					// Only proceed if we have not handled it already.
					this.actions.endDrag();
				}
			}
		}, {
			key: 'handleTopDragEnterCapture',
			value: function handleTopDragEnterCapture(e) {
				this.dragEnterTargetIds = [];
	
				var isFirstEnter = this.enterLeaveCounter.enter(e.target);
				if (!isFirstEnter || this.monitor.isDragging()) {
					return;
				}
	
				var dataTransfer = e.dataTransfer;
	
				var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);
	
				if (nativeType) {
					// A native item (such as file or URL) dragged from outside the document
					this.beginDragNativeItem(nativeType);
				}
			}
		}, {
			key: 'handleDragEnter',
			value: function handleDragEnter(e, targetId) {
				this.dragEnterTargetIds.unshift(targetId);
			}
		}, {
			key: 'handleTopDragEnter',
			value: function handleTopDragEnter(e) {
				var _this6 = this;
	
				var dragEnterTargetIds = this.dragEnterTargetIds;
	
				this.dragEnterTargetIds = [];
	
				if (!this.monitor.isDragging()) {
					// This is probably a native item type we don't understand.
					return;
				}
	
				this.altKeyPressed = e.altKey;
	
				if (!(0, _BrowserDetector.isFirefox)()) {
					// Don't emit hover in `dragenter` on Firefox due to an edge case.
					// If the target changes position as the result of `dragenter`, Firefox
					// will still happily dispatch `dragover` despite target being no longer
					// there. The easy solution is to only fire `hover` in `dragover` on FF.
					this.actions.hover(dragEnterTargetIds, {
						clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
					});
				}
	
				var canDrop = dragEnterTargetIds.some(function (targetId) {
					return _this6.monitor.canDropOnTarget(targetId);
				});
	
				if (canDrop) {
					// IE requires this to fire dragover events
					e.preventDefault();
					e.dataTransfer.dropEffect = this.getCurrentDropEffect();
				}
			}
		}, {
			key: 'handleTopDragOverCapture',
			value: function handleTopDragOverCapture() {
				this.dragOverTargetIds = [];
			}
		}, {
			key: 'handleDragOver',
			value: function handleDragOver(e, targetId) {
				this.dragOverTargetIds.unshift(targetId);
			}
		}, {
			key: 'handleTopDragOver',
			value: function handleTopDragOver(e) {
				var _this7 = this;
	
				var dragOverTargetIds = this.dragOverTargetIds;
	
				this.dragOverTargetIds = [];
	
				if (!this.monitor.isDragging()) {
					// This is probably a native item type we don't understand.
					// Prevent default "drop and blow away the whole document" action.
					e.preventDefault();
					e.dataTransfer.dropEffect = 'none';
					return;
				}
	
				this.altKeyPressed = e.altKey;
	
				this.actions.hover(dragOverTargetIds, {
					clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
				});
	
				var canDrop = dragOverTargetIds.some(function (targetId) {
					return _this7.monitor.canDropOnTarget(targetId);
				});
	
				if (canDrop) {
					// Show user-specified drop effect.
					e.preventDefault();
					e.dataTransfer.dropEffect = this.getCurrentDropEffect();
				} else if (this.isDraggingNativeItem()) {
					// Don't show a nice cursor but still prevent default
					// "drop and blow away the whole document" action.
					e.preventDefault();
					e.dataTransfer.dropEffect = 'none';
				} else if (this.checkIfCurrentDragSourceRectChanged()) {
					// Prevent animating to incorrect position.
					// Drop effect must be other than 'none' to prevent animation.
					e.preventDefault();
					e.dataTransfer.dropEffect = 'move';
				}
			}
		}, {
			key: 'handleTopDragLeaveCapture',
			value: function handleTopDragLeaveCapture(e) {
				if (this.isDraggingNativeItem()) {
					e.preventDefault();
				}
	
				var isLastLeave = this.enterLeaveCounter.leave(e.target);
				if (!isLastLeave) {
					return;
				}
	
				if (this.isDraggingNativeItem()) {
					this.endDragNativeItem();
				}
			}
		}, {
			key: 'handleTopDropCapture',
			value: function handleTopDropCapture(e) {
				this.dropTargetIds = [];
				e.preventDefault();
	
				if (this.isDraggingNativeItem()) {
					this.currentNativeSource.mutateItemByReadingDataTransfer(e.dataTransfer);
				}
	
				this.enterLeaveCounter.reset();
			}
		}, {
			key: 'handleDrop',
			value: function handleDrop(e, targetId) {
				this.dropTargetIds.unshift(targetId);
			}
		}, {
			key: 'handleTopDrop',
			value: function handleTopDrop(e) {
				var dropTargetIds = this.dropTargetIds;
	
				this.dropTargetIds = [];
	
				this.actions.hover(dropTargetIds, {
					clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
				});
				this.actions.drop({ dropEffect: this.getCurrentDropEffect() });
	
				if (this.isDraggingNativeItem()) {
					this.endDragNativeItem();
				} else {
					this.endDragIfSourceWasRemovedFromDOM();
				}
			}
		}, {
			key: 'handleSelectStart',
			value: function handleSelectStart(e) {
				var target = e.target;
	
				// Only IE requires us to explicitly say
				// we want drag drop operation to start
	
				if (typeof target.dragDrop !== 'function') {
					return;
				}
	
				// Inputs and textareas should be selectable
				if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
					return;
				}
	
				// For other targets, ask IE
				// to enable drag and drop
				e.preventDefault();
				target.dragDrop();
			}
		}, {
			key: 'window',
			get: function get() {
				if (this.context && this.context.window) {
					return this.context.window;
				} else if (typeof window !== 'undefined') {
					return window;
				}
				return undefined;
			}
		}]);
	
		return HTML5Backend;
	}();
	
	exports.default = HTML5Backend;

/***/ },
/* 1557 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint
	   no-plusplus: off,
	   no-mixed-operators: off
	*/
	var MonotonicInterpolant = function () {
		function MonotonicInterpolant(xs, ys) {
			_classCallCheck(this, MonotonicInterpolant);
	
			var length = xs.length;
	
			// Rearrange xs and ys so that xs is sorted
			var indexes = [];
			for (var i = 0; i < length; i++) {
				indexes.push(i);
			}
			indexes.sort(function (a, b) {
				return xs[a] < xs[b] ? -1 : 1;
			});
	
			// Get consecutive differences and slopes
			var dys = [];
			var dxs = [];
			var ms = [];
			var dx = void 0;
			var dy = void 0;
			for (var _i = 0; _i < length - 1; _i++) {
				dx = xs[_i + 1] - xs[_i];
				dy = ys[_i + 1] - ys[_i];
				dxs.push(dx);
				dys.push(dy);
				ms.push(dy / dx);
			}
	
			// Get degree-1 coefficients
			var c1s = [ms[0]];
			for (var _i2 = 0; _i2 < dxs.length - 1; _i2++) {
				var _m = ms[_i2];
				var mNext = ms[_i2 + 1];
				if (_m * mNext <= 0) {
					c1s.push(0);
				} else {
					dx = dxs[_i2];
					var dxNext = dxs[_i2 + 1];
					var common = dx + dxNext;
					c1s.push(3 * common / ((common + dxNext) / _m + (common + dx) / mNext));
				}
			}
			c1s.push(ms[ms.length - 1]);
	
			// Get degree-2 and degree-3 coefficients
			var c2s = [];
			var c3s = [];
			var m = void 0;
			for (var _i3 = 0; _i3 < c1s.length - 1; _i3++) {
				m = ms[_i3];
				var c1 = c1s[_i3];
				var invDx = 1 / dxs[_i3];
				var _common = c1 + c1s[_i3 + 1] - m - m;
				c2s.push((m - c1 - _common) * invDx);
				c3s.push(_common * invDx * invDx);
			}
	
			this.xs = xs;
			this.ys = ys;
			this.c1s = c1s;
			this.c2s = c2s;
			this.c3s = c3s;
		}
	
		_createClass(MonotonicInterpolant, [{
			key: "interpolate",
			value: function interpolate(x) {
				var xs = this.xs,
				    ys = this.ys,
				    c1s = this.c1s,
				    c2s = this.c2s,
				    c3s = this.c3s;
	
				// The rightmost point in the dataset should give an exact result
	
				var i = xs.length - 1;
				if (x === xs[i]) {
					return ys[i];
				}
	
				// Search for the interval x is in, returning the corresponding y if x is one of the original xs
				var low = 0;
				var high = c3s.length - 1;
				var mid = void 0;
				while (low <= high) {
					mid = Math.floor(0.5 * (low + high));
					var xHere = xs[mid];
					if (xHere < x) {
						low = mid + 1;
					} else if (xHere > x) {
						high = mid - 1;
					} else {
						return ys[mid];
					}
				}
				i = Math.max(0, high);
	
				// Interpolate
				var diff = x - xs[i];
				var diffSq = diff * diff;
				return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
			}
		}]);
	
		return MonotonicInterpolant;
	}();
	
	exports.default = MonotonicInterpolant;

/***/ },
/* 1558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _nativeTypesConfig;
	
	exports.createNativeDragSource = createNativeDragSource;
	exports.matchNativeItemType = matchNativeItemType;
	
	var _NativeTypes = __webpack_require__(326);
	
	var NativeTypes = _interopRequireWildcard(_NativeTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
		var result = typesToTry.reduce(function (resultSoFar, typeToTry) {
			return resultSoFar || dataTransfer.getData(typeToTry);
		}, null);
	
		return result != null // eslint-disable-line eqeqeq
		? result : defaultValue;
	}
	
	var nativeTypesConfig = (_nativeTypesConfig = {}, _defineProperty(_nativeTypesConfig, NativeTypes.FILE, {
		exposeProperty: 'files',
		matchesTypes: ['Files'],
		getData: function getData(dataTransfer) {
			return Array.prototype.slice.call(dataTransfer.files);
		}
	}), _defineProperty(_nativeTypesConfig, NativeTypes.URL, {
		exposeProperty: 'urls',
		matchesTypes: ['Url', 'text/uri-list'],
		getData: function getData(dataTransfer, matchesTypes) {
			return getDataFromDataTransfer(dataTransfer, matchesTypes, '').split('\n');
		}
	}), _defineProperty(_nativeTypesConfig, NativeTypes.TEXT, {
		exposeProperty: 'text',
		matchesTypes: ['Text', 'text/plain'],
		getData: function getData(dataTransfer, matchesTypes) {
			return getDataFromDataTransfer(dataTransfer, matchesTypes, '');
		}
	}), _nativeTypesConfig);
	
	function createNativeDragSource(type) {
		var _nativeTypesConfig$ty = nativeTypesConfig[type],
		    exposeProperty = _nativeTypesConfig$ty.exposeProperty,
		    matchesTypes = _nativeTypesConfig$ty.matchesTypes,
		    getData = _nativeTypesConfig$ty.getData;
	
	
		return function () {
			function NativeDragSource() {
				var _item, _mutatorMap;
	
				_classCallCheck(this, NativeDragSource);
	
				this.item = (_item = {}, _mutatorMap = {}, _mutatorMap[exposeProperty] = _mutatorMap[exposeProperty] || {}, _mutatorMap[exposeProperty].get = function () {
					// eslint-disable-next-line no-console
					console.warn('Browser doesn\'t allow reading "' + exposeProperty + '" until the drop event.');
					return null;
				}, _defineEnumerableProperties(_item, _mutatorMap), _item);
			}
	
			_createClass(NativeDragSource, [{
				key: 'mutateItemByReadingDataTransfer',
				value: function mutateItemByReadingDataTransfer(dataTransfer) {
					delete this.item[exposeProperty];
					this.item[exposeProperty] = getData(dataTransfer, matchesTypes);
				}
			}, {
				key: 'canDrag',
				value: function canDrag() {
					return true;
				}
			}, {
				key: 'beginDrag',
				value: function beginDrag() {
					return this.item;
				}
			}, {
				key: 'isDragging',
				value: function isDragging(monitor, handle) {
					return handle === monitor.getSourceId();
				}
			}, {
				key: 'endDrag',
				value: function endDrag() {}
			}]);
	
			return NativeDragSource;
		}();
	}
	
	function matchNativeItemType(dataTransfer) {
		var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
	
		return Object.keys(nativeTypesConfig).filter(function (nativeItemType) {
			var matchesTypes = nativeTypesConfig[nativeItemType].matchesTypes;
	
			return matchesTypes.some(function (t) {
				return dataTransferTypes.indexOf(t) > -1;
			});
		})[0] || null;
	}

/***/ },
/* 1559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getNodeClientOffset = getNodeClientOffset;
	exports.getEventClientOffset = getEventClientOffset;
	exports.getDragPreviewOffset = getDragPreviewOffset;
	
	var _BrowserDetector = __webpack_require__(487);
	
	var _MonotonicInterpolant = __webpack_require__(1557);
	
	var _MonotonicInterpolant2 = _interopRequireDefault(_MonotonicInterpolant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint
	   no-mixed-operators: off
	*/
	var ELEMENT_NODE = 1;
	
	function getNodeClientOffset(node) {
		var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;
	
		if (!el) {
			return null;
		}
	
		var _el$getBoundingClient = el.getBoundingClientRect(),
		    top = _el$getBoundingClient.top,
		    left = _el$getBoundingClient.left;
	
		return { x: left, y: top };
	}
	
	function getEventClientOffset(e) {
		return {
			x: e.clientX,
			y: e.clientY
		};
	}
	
	function isImageNode(node) {
		return node.nodeName === 'IMG' && ((0, _BrowserDetector.isFirefox)() || !document.documentElement.contains(node));
	}
	
	function getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
		var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
		var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;
	
		// Work around @2x coordinate discrepancies in browsers
		if ((0, _BrowserDetector.isSafari)() && isImage) {
			dragPreviewHeight /= window.devicePixelRatio;
			dragPreviewWidth /= window.devicePixelRatio;
		}
		return { dragPreviewWidth: dragPreviewWidth, dragPreviewHeight: dragPreviewHeight };
	}
	
	function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
		// The browsers will use the image intrinsic size under different conditions.
		// Firefox only cares if it's an image, but WebKit also wants it to be detached.
		var isImage = isImageNode(dragPreview);
		var dragPreviewNode = isImage ? sourceNode : dragPreview;
		var dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
		var offsetFromDragPreview = {
			x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
			y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
		};
		var sourceWidth = sourceNode.offsetWidth,
		    sourceHeight = sourceNode.offsetHeight;
		var anchorX = anchorPoint.anchorX,
		    anchorY = anchorPoint.anchorY;
	
		var _getDragPreviewSize = getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight),
		    dragPreviewWidth = _getDragPreviewSize.dragPreviewWidth,
		    dragPreviewHeight = _getDragPreviewSize.dragPreviewHeight;
	
		var calculateYOffset = function calculateYOffset() {
			var interpolantY = new _MonotonicInterpolant2.default([0, 0.5, 1], [
			// Dock to the top
			offsetFromDragPreview.y,
			// Align at the center
			offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
			// Dock to the bottom
			offsetFromDragPreview.y + dragPreviewHeight - sourceHeight]);
			var y = interpolantY.interpolate(anchorY);
			// Work around Safari 8 positioning bug
			if ((0, _BrowserDetector.isSafari)() && isImage) {
				// We'll have to wait for @3x to see if this is entirely correct
				y += (window.devicePixelRatio - 1) * dragPreviewHeight;
			}
			return y;
		};
	
		var calculateXOffset = function calculateXOffset() {
			// Interpolate coordinates depending on anchor point
			// If you know a simpler way to do this, let me know
			var interpolantX = new _MonotonicInterpolant2.default([0, 0.5, 1], [
			// Dock to the left
			offsetFromDragPreview.x,
			// Align at the center
			offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
			// Dock to the right
			offsetFromDragPreview.x + dragPreviewWidth - sourceWidth]);
			return interpolantX.interpolate(anchorX);
		};
	
		// Force offsets if specified in the options.
		var offsetX = offsetPoint.offsetX,
		    offsetY = offsetPoint.offsetY;
	
		var isManualOffsetX = offsetX === 0 || offsetX;
		var isManualOffsetY = offsetY === 0 || offsetY;
		return {
			x: isManualOffsetX ? offsetX : calculateXOffset(),
			y: isManualOffsetY ? offsetY : calculateYOffset()
		};
	}

/***/ },
/* 1560 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = getEmptyImage;
	var emptyImage = void 0;
	function getEmptyImage() {
		if (!emptyImage) {
			emptyImage = new Image();
			emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
		}
	
		return emptyImage;
	}

/***/ },
/* 1561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getEmptyImage = exports.NativeTypes = undefined;
	exports.default = createHTML5Backend;
	
	var _HTML5Backend = __webpack_require__(1556);
	
	var _HTML5Backend2 = _interopRequireDefault(_HTML5Backend);
	
	var _getEmptyImage = __webpack_require__(1560);
	
	var _getEmptyImage2 = _interopRequireDefault(_getEmptyImage);
	
	var _NativeTypes = __webpack_require__(326);
	
	var NativeTypes = _interopRequireWildcard(_NativeTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.NativeTypes = NativeTypes;
	exports.getEmptyImage = _getEmptyImage2.default;
	function createHTML5Backend(manager) {
		return new _HTML5Backend2.default(manager);
	}

/***/ },
/* 1562 */
327,
/* 1563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DragDropContext = __webpack_require__(488);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This class is a React-Component based version of the DragDropContext.
	 * This is an alternative to decorating an application component with an ES7 decorator.
	 */
	var DragDropContextProvider = (_temp = _class = function (_Component) {
		_inherits(DragDropContextProvider, _Component);
	
		function DragDropContextProvider(props, context) {
			_classCallCheck(this, DragDropContextProvider);
	
			/**
	   * This property determines which window global to use for creating the DragDropManager.
	   * If a window has been injected explicitly via props, that is used first. If it is available
	   * as a context value, then use that, otherwise use the browser global.
	   */
			var _this = _possibleConstructorReturn(this, (DragDropContextProvider.__proto__ || Object.getPrototypeOf(DragDropContextProvider)).call(this, props, context));
	
			var getWindow = function getWindow() {
				if (props && props.window) {
					return props.window;
				} else if (context && context.window) {
					return context.window;
				} else if (typeof window !== 'undefined') {
					return window;
				}
				return undefined;
			};
	
			_this.backend = (0, _DragDropContext.unpackBackendForEs5Users)(props.backend);
			_this.childContext = (0, _DragDropContext.createChildContext)(_this.backend, {
				window: getWindow()
			});
			return _this;
		}
	
		_createClass(DragDropContextProvider, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.backend !== this.props.backend || nextProps.window !== this.props.window) {
					throw new Error('DragDropContextProvider backend and window props must not change.');
				}
			}
		}, {
			key: 'getChildContext',
			value: function getChildContext() {
				return this.childContext;
			}
		}, {
			key: 'render',
			value: function render() {
				return _react.Children.only(this.props.children);
			}
		}]);
	
		return DragDropContextProvider;
	}(_react.Component), _class.propTypes = {
		backend: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]).isRequired,
		children: _propTypes2.default.element.isRequired,
		window: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
	}, _class.defaultProps = {
		window: undefined
	}, _class.childContextTypes = _DragDropContext.CHILD_CONTEXT_TYPES, _class.displayName = 'DragDropContextProvider', _class.contextTypes = {
		window: _propTypes2.default.object
	}, _temp);
	exports.default = DragDropContextProvider;

/***/ },
/* 1564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = DragLayer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(291);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _isPlainObject = __webpack_require__(78);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _shallowEqual = __webpack_require__(327);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _shallowEqualScalar = __webpack_require__(493);
	
	var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);
	
	var _checkDecoratorArguments = __webpack_require__(220);
	
	var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function DragLayer(collect) {
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		_checkDecoratorArguments2.default.apply(undefined, ['DragLayer', 'collect[, options]'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
		(0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the first argument to DragLayer to be a function that collects props to inject into the component. ', 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', collect);
		(0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the second argument to DragLayer to be a plain object when specified. ' + 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', options);
	
		return function decorateLayer(DecoratedComponent) {
			var _class, _temp;
	
			var _options$arePropsEqua = options.arePropsEqual,
			    arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;
	
			var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
			var DragLayerContainer = (_temp = _class = function (_Component) {
				_inherits(DragLayerContainer, _Component);
	
				_createClass(DragLayerContainer, [{
					key: 'getDecoratedComponentInstance',
					value: function getDecoratedComponentInstance() {
						(0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can not be a stateless component.');
						return this.child;
					}
				}, {
					key: 'shouldComponentUpdate',
					value: function shouldComponentUpdate(nextProps, nextState) {
						return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
					}
				}]);
	
				function DragLayerContainer(props, context) {
					_classCallCheck(this, DragLayerContainer);
	
					var _this = _possibleConstructorReturn(this, (DragLayerContainer.__proto__ || Object.getPrototypeOf(DragLayerContainer)).call(this, props));
	
					_this.handleChange = _this.handleChange.bind(_this);
	
					_this.manager = context.dragDropManager;
					(0, _invariant2.default)(_typeof(_this.manager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
	
					_this.state = _this.getCurrentState();
					return _this;
				}
	
				_createClass(DragLayerContainer, [{
					key: 'componentDidMount',
					value: function componentDidMount() {
						this.isCurrentlyMounted = true;
	
						var monitor = this.manager.getMonitor();
						this.unsubscribeFromOffsetChange = monitor.subscribeToOffsetChange(this.handleChange);
						this.unsubscribeFromStateChange = monitor.subscribeToStateChange(this.handleChange);
	
						this.handleChange();
					}
				}, {
					key: 'componentWillUnmount',
					value: function componentWillUnmount() {
						this.isCurrentlyMounted = false;
	
						this.unsubscribeFromOffsetChange();
						this.unsubscribeFromStateChange();
					}
				}, {
					key: 'handleChange',
					value: function handleChange() {
						if (!this.isCurrentlyMounted) {
							return;
						}
	
						var nextState = this.getCurrentState();
						if (!(0, _shallowEqual2.default)(nextState, this.state)) {
							this.setState(nextState);
						}
					}
				}, {
					key: 'getCurrentState',
					value: function getCurrentState() {
						var monitor = this.manager.getMonitor();
						return collect(monitor, this.props);
					}
				}, {
					key: 'render',
					value: function render() {
						var _this2 = this;
	
						return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
							ref: function ref(child) {
								_this2.child = child;
							}
						}));
					}
				}]);
	
				return DragLayerContainer;
			}(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragLayer(' + displayName + ')', _class.contextTypes = {
				dragDropManager: _propTypes2.default.object.isRequired
			}, _temp);
	
	
			return (0, _hoistNonReactStatics2.default)(DragLayerContainer, DecoratedComponent);
		};
	}

/***/ },
/* 1565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = DragSource;
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isPlainObject = __webpack_require__(78);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _checkDecoratorArguments = __webpack_require__(220);
	
	var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
	var _decorateHandler = __webpack_require__(490);
	
	var _decorateHandler2 = _interopRequireDefault(_decorateHandler);
	
	var _registerSource = __webpack_require__(1573);
	
	var _registerSource2 = _interopRequireDefault(_registerSource);
	
	var _createSourceFactory = __webpack_require__(1568);
	
	var _createSourceFactory2 = _interopRequireDefault(_createSourceFactory);
	
	var _createSourceMonitor = __webpack_require__(1569);
	
	var _createSourceMonitor2 = _interopRequireDefault(_createSourceMonitor);
	
	var _createSourceConnector = __webpack_require__(1567);
	
	var _createSourceConnector2 = _interopRequireDefault(_createSourceConnector);
	
	var _isValidType = __webpack_require__(492);
	
	var _isValidType2 = _interopRequireDefault(_isValidType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DragSource(type, spec, collect) {
		var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
		_checkDecoratorArguments2.default.apply(undefined, ['DragSource', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments)));
		var getType = type;
		if (typeof type !== 'function') {
			(0, _invariant2.default)((0, _isValidType2.default)(type), 'Expected "type" provided as the first argument to DragSource to be ' + 'a string, or a function that returns a string given the current props. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', type);
			getType = function getType() {
				return type;
			};
		}
		(0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DragSource to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', spec);
		var createSource = (0, _createSourceFactory2.default)(spec);
		(0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DragSource to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
		(0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DragSource to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
	
		return function decorateSource(DecoratedComponent) {
			return (0, _decorateHandler2.default)({
				connectBackend: function connectBackend(backend, sourceId) {
					return backend.connectDragSource(sourceId);
				},
				containerDisplayName: 'DragSource',
				createHandler: createSource,
				registerHandler: _registerSource2.default,
				createMonitor: _createSourceMonitor2.default,
				createConnector: _createSourceConnector2.default,
				DecoratedComponent: DecoratedComponent,
				getType: getType,
				collect: collect,
				options: options
			});
		};
	}

/***/ },
/* 1566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = DropTarget;
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isPlainObject = __webpack_require__(78);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _checkDecoratorArguments = __webpack_require__(220);
	
	var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
	var _decorateHandler = __webpack_require__(490);
	
	var _decorateHandler2 = _interopRequireDefault(_decorateHandler);
	
	var _registerTarget = __webpack_require__(1574);
	
	var _registerTarget2 = _interopRequireDefault(_registerTarget);
	
	var _createTargetFactory = __webpack_require__(1571);
	
	var _createTargetFactory2 = _interopRequireDefault(_createTargetFactory);
	
	var _createTargetMonitor = __webpack_require__(1572);
	
	var _createTargetMonitor2 = _interopRequireDefault(_createTargetMonitor);
	
	var _createTargetConnector = __webpack_require__(1570);
	
	var _createTargetConnector2 = _interopRequireDefault(_createTargetConnector);
	
	var _isValidType = __webpack_require__(492);
	
	var _isValidType2 = _interopRequireDefault(_isValidType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DropTarget(type, spec, collect) {
		var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
		_checkDecoratorArguments2.default.apply(undefined, ['DropTarget', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments)));
		var getType = type;
		if (typeof type !== 'function') {
			(0, _invariant2.default)((0, _isValidType2.default)(type, true), 'Expected "type" provided as the first argument to DropTarget to be ' + 'a string, an array of strings, or a function that returns either given ' + 'the current props. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', type);
			getType = function getType() {
				return type;
			};
		}
		(0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DropTarget to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', spec);
		var createTarget = (0, _createTargetFactory2.default)(spec);
		(0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DropTarget to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
		(0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DropTarget to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
	
		return function decorateTarget(DecoratedComponent) {
			return (0, _decorateHandler2.default)({
				connectBackend: function connectBackend(backend, targetId) {
					return backend.connectDropTarget(targetId);
				},
				containerDisplayName: 'DropTarget',
				createHandler: createTarget,
				registerHandler: _registerTarget2.default,
				createMonitor: _createTargetMonitor2.default,
				createConnector: _createTargetConnector2.default,
				DecoratedComponent: DecoratedComponent,
				getType: getType,
				collect: collect,
				options: options
			});
		};
	}

/***/ },
/* 1567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = createSourceConnector;
	
	var _wrapConnectorHooks = __webpack_require__(494);
	
	var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);
	
	var _areOptionsEqual = __webpack_require__(489);
	
	var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createSourceConnector(backend) {
		var currentHandlerId = void 0;
	
		var currentDragSourceNode = void 0;
		var currentDragSourceOptions = void 0;
		var disconnectCurrentDragSource = void 0;
	
		var currentDragPreviewNode = void 0;
		var currentDragPreviewOptions = void 0;
		var disconnectCurrentDragPreview = void 0;
	
		function reconnectDragSource() {
			if (disconnectCurrentDragSource) {
				disconnectCurrentDragSource();
				disconnectCurrentDragSource = null;
			}
	
			if (currentHandlerId && currentDragSourceNode) {
				disconnectCurrentDragSource = backend.connectDragSource(currentHandlerId, currentDragSourceNode, currentDragSourceOptions);
			}
		}
	
		function reconnectDragPreview() {
			if (disconnectCurrentDragPreview) {
				disconnectCurrentDragPreview();
				disconnectCurrentDragPreview = null;
			}
	
			if (currentHandlerId && currentDragPreviewNode) {
				disconnectCurrentDragPreview = backend.connectDragPreview(currentHandlerId, currentDragPreviewNode, currentDragPreviewOptions);
			}
		}
	
		function receiveHandlerId(handlerId) {
			if (handlerId === currentHandlerId) {
				return;
			}
	
			currentHandlerId = handlerId;
			reconnectDragSource();
			reconnectDragPreview();
		}
	
		var hooks = (0, _wrapConnectorHooks2.default)({
			dragSource: function connectDragSource(node, options) {
				if (node === currentDragSourceNode && (0, _areOptionsEqual2.default)(options, currentDragSourceOptions)) {
					return;
				}
	
				currentDragSourceNode = node;
				currentDragSourceOptions = options;
	
				reconnectDragSource();
			},
	
			dragPreview: function connectDragPreview(node, options) {
				if (node === currentDragPreviewNode && (0, _areOptionsEqual2.default)(options, currentDragPreviewOptions)) {
					return;
				}
	
				currentDragPreviewNode = node;
				currentDragPreviewOptions = options;
	
				reconnectDragPreview();
			}
		});
	
		return {
			receiveHandlerId: receiveHandlerId,
			hooks: hooks
		};
	}

/***/ },
/* 1568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createSourceFactory;
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isPlainObject = __webpack_require__(78);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ALLOWED_SPEC_METHODS = ['canDrag', 'beginDrag', 'isDragging', 'endDrag'];
	var REQUIRED_SPEC_METHODS = ['beginDrag'];
	
	function createSourceFactory(spec) {
		Object.keys(spec).forEach(function (key) {
			(0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drag source specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', ALLOWED_SPEC_METHODS.join(', '), key);
			(0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
		});
		REQUIRED_SPEC_METHODS.forEach(function (key) {
			(0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
		});
	
		var Source = function () {
			function Source(monitor) {
				_classCallCheck(this, Source);
	
				this.monitor = monitor;
				this.props = null;
				this.component = null;
			}
	
			_createClass(Source, [{
				key: 'receiveProps',
				value: function receiveProps(props) {
					this.props = props;
				}
			}, {
				key: 'receiveComponent',
				value: function receiveComponent(component) {
					this.component = component;
				}
			}, {
				key: 'canDrag',
				value: function canDrag() {
					if (!spec.canDrag) {
						return true;
					}
	
					return spec.canDrag(this.props, this.monitor);
				}
			}, {
				key: 'isDragging',
				value: function isDragging(globalMonitor, sourceId) {
					if (!spec.isDragging) {
						return sourceId === globalMonitor.getSourceId();
					}
	
					return spec.isDragging(this.props, this.monitor);
				}
			}, {
				key: 'beginDrag',
				value: function beginDrag() {
					var item = spec.beginDrag(this.props, this.monitor, this.component);
					if (false) {
						(0, _invariant2.default)((0, _isPlainObject2.default)(item), 'beginDrag() must return a plain object that represents the dragged item. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', item);
					}
					return item;
				}
			}, {
				key: 'endDrag',
				value: function endDrag() {
					if (!spec.endDrag) {
						return;
					}
	
					spec.endDrag(this.props, this.monitor, this.component);
				}
			}]);
	
			return Source;
		}();
	
		return function createSource(monitor) {
			return new Source(monitor);
		};
	}

/***/ },
/* 1569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createSourceMonitor;
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var isCallingCanDrag = false;
	var isCallingIsDragging = false;
	
	var SourceMonitor = function () {
		function SourceMonitor(manager) {
			_classCallCheck(this, SourceMonitor);
	
			this.internalMonitor = manager.getMonitor();
		}
	
		_createClass(SourceMonitor, [{
			key: 'receiveHandlerId',
			value: function receiveHandlerId(sourceId) {
				this.sourceId = sourceId;
			}
		}, {
			key: 'canDrag',
			value: function canDrag() {
				(0, _invariant2.default)(!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');
	
				try {
					isCallingCanDrag = true;
					return this.internalMonitor.canDragSource(this.sourceId);
				} finally {
					isCallingCanDrag = false;
				}
			}
		}, {
			key: 'isDragging',
			value: function isDragging() {
				(0, _invariant2.default)(!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');
	
				try {
					isCallingIsDragging = true;
					return this.internalMonitor.isDraggingSource(this.sourceId);
				} finally {
					isCallingIsDragging = false;
				}
			}
		}, {
			key: 'getItemType',
			value: function getItemType() {
				return this.internalMonitor.getItemType();
			}
		}, {
			key: 'getItem',
			value: function getItem() {
				return this.internalMonitor.getItem();
			}
		}, {
			key: 'getDropResult',
			value: function getDropResult() {
				return this.internalMonitor.getDropResult();
			}
		}, {
			key: 'didDrop',
			value: function didDrop() {
				return this.internalMonitor.didDrop();
			}
		}, {
			key: 'getInitialClientOffset',
			value: function getInitialClientOffset() {
				return this.internalMonitor.getInitialClientOffset();
			}
		}, {
			key: 'getInitialSourceClientOffset',
			value: function getInitialSourceClientOffset() {
				return this.internalMonitor.getInitialSourceClientOffset();
			}
		}, {
			key: 'getSourceClientOffset',
			value: function getSourceClientOffset() {
				return this.internalMonitor.getSourceClientOffset();
			}
		}, {
			key: 'getClientOffset',
			value: function getClientOffset() {
				return this.internalMonitor.getClientOffset();
			}
		}, {
			key: 'getDifferenceFromInitialOffset',
			value: function getDifferenceFromInitialOffset() {
				return this.internalMonitor.getDifferenceFromInitialOffset();
			}
		}]);
	
		return SourceMonitor;
	}();
	
	function createSourceMonitor(manager) {
		return new SourceMonitor(manager);
	}

/***/ },
/* 1570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = createTargetConnector;
	
	var _wrapConnectorHooks = __webpack_require__(494);
	
	var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);
	
	var _areOptionsEqual = __webpack_require__(489);
	
	var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTargetConnector(backend) {
		var currentHandlerId = void 0;
	
		var currentDropTargetNode = void 0;
		var currentDropTargetOptions = void 0;
		var disconnectCurrentDropTarget = void 0;
	
		function reconnectDropTarget() {
			if (disconnectCurrentDropTarget) {
				disconnectCurrentDropTarget();
				disconnectCurrentDropTarget = null;
			}
	
			if (currentHandlerId && currentDropTargetNode) {
				disconnectCurrentDropTarget = backend.connectDropTarget(currentHandlerId, currentDropTargetNode, currentDropTargetOptions);
			}
		}
	
		function receiveHandlerId(handlerId) {
			if (handlerId === currentHandlerId) {
				return;
			}
	
			currentHandlerId = handlerId;
			reconnectDropTarget();
		}
	
		var hooks = (0, _wrapConnectorHooks2.default)({
			dropTarget: function connectDropTarget(node, options) {
				if (node === currentDropTargetNode && (0, _areOptionsEqual2.default)(options, currentDropTargetOptions)) {
					return;
				}
	
				currentDropTargetNode = node;
				currentDropTargetOptions = options;
	
				reconnectDropTarget();
			}
		});
	
		return {
			receiveHandlerId: receiveHandlerId,
			hooks: hooks
		};
	}

/***/ },
/* 1571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createTargetFactory;
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isPlainObject = __webpack_require__(78);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ALLOWED_SPEC_METHODS = ['canDrop', 'hover', 'drop'];
	
	function createTargetFactory(spec) {
		Object.keys(spec).forEach(function (key) {
			(0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drop target specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', ALLOWED_SPEC_METHODS.join(', '), key);
			(0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drop target specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', key, key, spec[key]);
		});
	
		var Target = function () {
			function Target(monitor) {
				_classCallCheck(this, Target);
	
				this.monitor = monitor;
				this.props = null;
				this.component = null;
			}
	
			_createClass(Target, [{
				key: 'receiveProps',
				value: function receiveProps(props) {
					this.props = props;
				}
			}, {
				key: 'receiveMonitor',
				value: function receiveMonitor(monitor) {
					this.monitor = monitor;
				}
			}, {
				key: 'receiveComponent',
				value: function receiveComponent(component) {
					this.component = component;
				}
			}, {
				key: 'canDrop',
				value: function canDrop() {
					if (!spec.canDrop) {
						return true;
					}
	
					return spec.canDrop(this.props, this.monitor);
				}
			}, {
				key: 'hover',
				value: function hover() {
					if (!spec.hover) {
						return;
					}
	
					spec.hover(this.props, this.monitor, this.component);
				}
			}, {
				key: 'drop',
				value: function drop() {
					if (!spec.drop) {
						return undefined;
					}
	
					var dropResult = spec.drop(this.props, this.monitor, this.component);
					if (false) {
						(0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isPlainObject2.default)(dropResult), 'drop() must either return undefined, or an object that represents the drop result. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', dropResult);
					}
					return dropResult;
				}
			}]);
	
			return Target;
		}();
	
		return function createTarget(monitor) {
			return new Target(monitor);
		};
	}

/***/ },
/* 1572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createTargetMonitor;
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var isCallingCanDrop = false;
	
	var TargetMonitor = function () {
		function TargetMonitor(manager) {
			_classCallCheck(this, TargetMonitor);
	
			this.internalMonitor = manager.getMonitor();
		}
	
		_createClass(TargetMonitor, [{
			key: 'receiveHandlerId',
			value: function receiveHandlerId(targetId) {
				this.targetId = targetId;
			}
		}, {
			key: 'canDrop',
			value: function canDrop() {
				(0, _invariant2.default)(!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target-monitor.html');
	
				try {
					isCallingCanDrop = true;
					return this.internalMonitor.canDropOnTarget(this.targetId);
				} finally {
					isCallingCanDrop = false;
				}
			}
		}, {
			key: 'isOver',
			value: function isOver(options) {
				return this.internalMonitor.isOverTarget(this.targetId, options);
			}
		}, {
			key: 'getItemType',
			value: function getItemType() {
				return this.internalMonitor.getItemType();
			}
		}, {
			key: 'getItem',
			value: function getItem() {
				return this.internalMonitor.getItem();
			}
		}, {
			key: 'getDropResult',
			value: function getDropResult() {
				return this.internalMonitor.getDropResult();
			}
		}, {
			key: 'didDrop',
			value: function didDrop() {
				return this.internalMonitor.didDrop();
			}
		}, {
			key: 'getInitialClientOffset',
			value: function getInitialClientOffset() {
				return this.internalMonitor.getInitialClientOffset();
			}
		}, {
			key: 'getInitialSourceClientOffset',
			value: function getInitialSourceClientOffset() {
				return this.internalMonitor.getInitialSourceClientOffset();
			}
		}, {
			key: 'getSourceClientOffset',
			value: function getSourceClientOffset() {
				return this.internalMonitor.getSourceClientOffset();
			}
		}, {
			key: 'getClientOffset',
			value: function getClientOffset() {
				return this.internalMonitor.getClientOffset();
			}
		}, {
			key: 'getDifferenceFromInitialOffset',
			value: function getDifferenceFromInitialOffset() {
				return this.internalMonitor.getDifferenceFromInitialOffset();
			}
		}]);
	
		return TargetMonitor;
	}();
	
	function createTargetMonitor(manager) {
		return new TargetMonitor(manager);
	}

/***/ },
/* 1573 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = registerSource;
	function registerSource(type, source, manager) {
		var registry = manager.getRegistry();
		var sourceId = registry.addSource(type, source);
	
		function unregisterSource() {
			registry.removeSource(sourceId);
		}
	
		return {
			handlerId: sourceId,
			unregister: unregisterSource
		};
	}

/***/ },
/* 1574 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = registerTarget;
	function registerTarget(type, target, manager) {
		var registry = manager.getRegistry();
		var targetId = registry.addTarget(type, target);
	
		function unregisterTarget() {
			registry.removeTarget(targetId);
		}
	
		return {
			handlerId: targetId,
			unregister: unregisterTarget
		};
	}

/***/ },
/* 1575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = cloneWithRef;
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function cloneWithRef(element, newRef) {
		var previousRef = element.ref;
		(0, _invariant2.default)(typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' + 'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' + 'Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute');
	
		if (!previousRef) {
			// When there is no ref on the element, use the new ref directly
			return (0, _react.cloneElement)(element, {
				ref: newRef
			});
		}
	
		return (0, _react.cloneElement)(element, {
			ref: function ref(node) {
				newRef(node);
	
				if (previousRef) {
					previousRef(node);
				}
			}
		});
	}

/***/ },
/* 1576 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 1577 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(32);
	
	var focusNode = __webpack_require__(424);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 1578 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(172);
	var ExecutionEnvironment = __webpack_require__(40);
	var FallbackCompositionState = __webpack_require__(1584);
	var SyntheticCompositionEvent = __webpack_require__(1621);
	var SyntheticInputEvent = __webpack_require__(1624);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 1579 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(495);
	var ExecutionEnvironment = __webpack_require__(40);
	var ReactInstrumentation = __webpack_require__(59);
	
	var camelizeStyleName = __webpack_require__(983);
	var dangerousStyleValue = __webpack_require__(1630);
	var hyphenateStyleName = __webpack_require__(990);
	var memoizeStringOnly = __webpack_require__(993);
	var warning = __webpack_require__(20);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 1580 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(171);
	var EventPropagators = __webpack_require__(172);
	var ExecutionEnvironment = __webpack_require__(40);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactUpdates = __webpack_require__(70);
	var SyntheticEvent = __webpack_require__(80);
	
	var inputValueTracking = __webpack_require__(511);
	var getEventTarget = __webpack_require__(340);
	var isEventSupported = __webpack_require__(341);
	var isTextInputElement = __webpack_require__(513);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 1581 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var DOMLazyTree = __webpack_require__(131);
	var ExecutionEnvironment = __webpack_require__(40);
	
	var createNodesFromMarkup = __webpack_require__(986);
	var emptyFunction = __webpack_require__(66);
	var invariant = __webpack_require__(12);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 1582 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 1583 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(172);
	var ReactDOMComponentTree = __webpack_require__(32);
	var SyntheticMouseEvent = __webpack_require__(222);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 1584 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(31);
	
	var PooledClass = __webpack_require__(112);
	
	var getTextContentAccessor = __webpack_require__(510);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 1585 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(132);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 1586 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(133);
	
	var instantiateReactComponent = __webpack_require__(512);
	var KeyEscapeUtils = __webpack_require__(332);
	var shouldUpdateReactComponent = __webpack_require__(342);
	var traverseAllChildren = __webpack_require__(515);
	var warning = __webpack_require__(20);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(538);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(111)))

/***/ },
/* 1587 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(328);
	var ReactDOMIDOperations = __webpack_require__(1594);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 1588 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19),
	    _assign = __webpack_require__(31);
	
	var React = __webpack_require__(135);
	var ReactComponentEnvironment = __webpack_require__(334);
	var ReactCurrentOwner = __webpack_require__(81);
	var ReactErrorUtils = __webpack_require__(335);
	var ReactInstanceMap = __webpack_require__(173);
	var ReactInstrumentation = __webpack_require__(59);
	var ReactNodeTypes = __webpack_require__(505);
	var ReactReconciler = __webpack_require__(133);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(284);
	var invariant = __webpack_require__(12);
	var shallowEqual = __webpack_require__(285);
	var shouldUpdateReactComponent = __webpack_require__(342);
	var warning = __webpack_require__(20);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 1589 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactDefaultInjection = __webpack_require__(1602);
	var ReactMount = __webpack_require__(504);
	var ReactReconciler = __webpack_require__(133);
	var ReactUpdates = __webpack_require__(70);
	var ReactVersion = __webpack_require__(1615);
	
	var findDOMNode = __webpack_require__(1631);
	var getHostComponentFromComposite = __webpack_require__(509);
	var renderSubtreeIntoContainer = __webpack_require__(1638);
	var warning = __webpack_require__(20);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 1590 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19),
	    _assign = __webpack_require__(31);
	
	var AutoFocusUtils = __webpack_require__(1577);
	var CSSPropertyOperations = __webpack_require__(1579);
	var DOMLazyTree = __webpack_require__(131);
	var DOMNamespaces = __webpack_require__(329);
	var DOMProperty = __webpack_require__(132);
	var DOMPropertyOperations = __webpack_require__(497);
	var EventPluginHub = __webpack_require__(171);
	var EventPluginRegistry = __webpack_require__(330);
	var ReactBrowserEventEmitter = __webpack_require__(221);
	var ReactDOMComponentFlags = __webpack_require__(498);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactDOMInput = __webpack_require__(1595);
	var ReactDOMOption = __webpack_require__(1596);
	var ReactDOMSelect = __webpack_require__(499);
	var ReactDOMTextarea = __webpack_require__(1599);
	var ReactInstrumentation = __webpack_require__(59);
	var ReactMultiChild = __webpack_require__(1608);
	var ReactServerRenderingTransaction = __webpack_require__(1613);
	
	var emptyFunction = __webpack_require__(66);
	var escapeTextContentForBrowser = __webpack_require__(224);
	var invariant = __webpack_require__(12);
	var isEventSupported = __webpack_require__(341);
	var shallowEqual = __webpack_require__(285);
	var inputValueTracking = __webpack_require__(511);
	var validateDOMNesting = __webpack_require__(343);
	var warning = __webpack_require__(20);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 1591 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(343);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 1592 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(31);
	
	var DOMLazyTree = __webpack_require__(131);
	var ReactDOMComponentTree = __webpack_require__(32);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 1593 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 1594 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(328);
	var ReactDOMComponentTree = __webpack_require__(32);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 1595 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19),
	    _assign = __webpack_require__(31);
	
	var DOMPropertyOperations = __webpack_require__(497);
	var LinkedValueUtils = __webpack_require__(333);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactUpdates = __webpack_require__(70);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(20);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 1596 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(31);
	
	var React = __webpack_require__(135);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactDOMSelect = __webpack_require__(499);
	
	var warning = __webpack_require__(20);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 1597 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(40);
	
	var getNodeForCharacterOffset = __webpack_require__(1635);
	var getTextContentAccessor = __webpack_require__(510);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 1598 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19),
	    _assign = __webpack_require__(31);
	
	var DOMChildrenOperations = __webpack_require__(328);
	var DOMLazyTree = __webpack_require__(131);
	var ReactDOMComponentTree = __webpack_require__(32);
	
	var escapeTextContentForBrowser = __webpack_require__(224);
	var invariant = __webpack_require__(12);
	var validateDOMNesting = __webpack_require__(343);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 1599 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19),
	    _assign = __webpack_require__(31);
	
	var LinkedValueUtils = __webpack_require__(333);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactUpdates = __webpack_require__(70);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(20);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 1600 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 1601 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(31);
	
	var ReactUpdates = __webpack_require__(70);
	var Transaction = __webpack_require__(223);
	
	var emptyFunction = __webpack_require__(66);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 1602 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(1576);
	var BeforeInputEventPlugin = __webpack_require__(1578);
	var ChangeEventPlugin = __webpack_require__(1580);
	var DefaultEventPluginOrder = __webpack_require__(1582);
	var EnterLeaveEventPlugin = __webpack_require__(1583);
	var HTMLDOMPropertyConfig = __webpack_require__(1585);
	var ReactComponentBrowserEnvironment = __webpack_require__(1587);
	var ReactDOMComponent = __webpack_require__(1590);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactDOMEmptyComponent = __webpack_require__(1592);
	var ReactDOMTreeTraversal = __webpack_require__(1600);
	var ReactDOMTextComponent = __webpack_require__(1598);
	var ReactDefaultBatchingStrategy = __webpack_require__(1601);
	var ReactEventListener = __webpack_require__(1605);
	var ReactInjection = __webpack_require__(1606);
	var ReactReconcileTransaction = __webpack_require__(1611);
	var SVGDOMPropertyConfig = __webpack_require__(1616);
	var SelectEventPlugin = __webpack_require__(1617);
	var SimpleEventPlugin = __webpack_require__(1618);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 1603 */
539,
/* 1604 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(171);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 1605 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(31);
	
	var EventListener = __webpack_require__(423);
	var ExecutionEnvironment = __webpack_require__(40);
	var PooledClass = __webpack_require__(112);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactUpdates = __webpack_require__(70);
	
	var getEventTarget = __webpack_require__(340);
	var getUnboundedScrollPosition = __webpack_require__(988);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 1606 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(132);
	var EventPluginHub = __webpack_require__(171);
	var EventPluginUtils = __webpack_require__(331);
	var ReactComponentEnvironment = __webpack_require__(334);
	var ReactEmptyComponent = __webpack_require__(500);
	var ReactBrowserEventEmitter = __webpack_require__(221);
	var ReactHostComponent = __webpack_require__(502);
	var ReactUpdates = __webpack_require__(70);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 1607 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1629);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 1608 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var ReactComponentEnvironment = __webpack_require__(334);
	var ReactInstanceMap = __webpack_require__(173);
	var ReactInstrumentation = __webpack_require__(59);
	
	var ReactCurrentOwner = __webpack_require__(81);
	var ReactReconciler = __webpack_require__(133);
	var ReactChildReconciler = __webpack_require__(1586);
	
	var emptyFunction = __webpack_require__(66);
	var flattenChildren = __webpack_require__(1632);
	var invariant = __webpack_require__(12);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 1609 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 1610 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 1611 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(31);
	
	var CallbackQueue = __webpack_require__(496);
	var PooledClass = __webpack_require__(112);
	var ReactBrowserEventEmitter = __webpack_require__(221);
	var ReactInputSelection = __webpack_require__(503);
	var ReactInstrumentation = __webpack_require__(59);
	var Transaction = __webpack_require__(223);
	var ReactUpdateQueue = __webpack_require__(336);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 1612 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(1609);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 1613 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(31);
	
	var PooledClass = __webpack_require__(112);
	var Transaction = __webpack_require__(223);
	var ReactInstrumentation = __webpack_require__(59);
	var ReactServerUpdateQueue = __webpack_require__(1614);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 1614 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(336);
	
	var warning = __webpack_require__(20);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 1615 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 1616 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 1617 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(172);
	var ExecutionEnvironment = __webpack_require__(40);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactInputSelection = __webpack_require__(503);
	var SyntheticEvent = __webpack_require__(80);
	
	var getActiveElement = __webpack_require__(425);
	var isTextInputElement = __webpack_require__(513);
	var shallowEqual = __webpack_require__(285);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 1618 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var EventListener = __webpack_require__(423);
	var EventPropagators = __webpack_require__(172);
	var ReactDOMComponentTree = __webpack_require__(32);
	var SyntheticAnimationEvent = __webpack_require__(1619);
	var SyntheticClipboardEvent = __webpack_require__(1620);
	var SyntheticEvent = __webpack_require__(80);
	var SyntheticFocusEvent = __webpack_require__(1623);
	var SyntheticKeyboardEvent = __webpack_require__(1625);
	var SyntheticMouseEvent = __webpack_require__(222);
	var SyntheticDragEvent = __webpack_require__(1622);
	var SyntheticTouchEvent = __webpack_require__(1626);
	var SyntheticTransitionEvent = __webpack_require__(1627);
	var SyntheticUIEvent = __webpack_require__(174);
	var SyntheticWheelEvent = __webpack_require__(1628);
	
	var emptyFunction = __webpack_require__(66);
	var getEventCharCode = __webpack_require__(338);
	var invariant = __webpack_require__(12);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 1619 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(80);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 1620 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(80);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 1621 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(80);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 1622 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(222);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 1623 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(174);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 1624 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(80);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 1625 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(174);
	
	var getEventCharCode = __webpack_require__(338);
	var getEventKey = __webpack_require__(1633);
	var getEventModifierState = __webpack_require__(339);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 1626 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(174);
	
	var getEventModifierState = __webpack_require__(339);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 1627 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(80);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 1628 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(222);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 1629 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 1630 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(495);
	var warning = __webpack_require__(20);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 1631 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var ReactCurrentOwner = __webpack_require__(81);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactInstanceMap = __webpack_require__(173);
	
	var getHostComponentFromComposite = __webpack_require__(509);
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(20);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 1632 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(332);
	var traverseAllChildren = __webpack_require__(515);
	var warning = __webpack_require__(20);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(538);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(111)))

/***/ },
/* 1633 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(338);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 1634 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 1635 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 1636 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(40);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 1637 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(224);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 1638 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(504);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 1639 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1), __webpack_require__(9));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types"], factory);
		else if(typeof exports === 'object')
			exports["Dropzone"] = factory(require("react"), require("prop-types"));
		else
			root["Dropzone"] = factory(root["react"], root["prop-types"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
		
		var _react = __webpack_require__(2);
		
		var _react2 = _interopRequireDefault(_react);
		
		var _propTypes = __webpack_require__(3);
		
		var _propTypes2 = _interopRequireDefault(_propTypes);
		
		var _attrAccept = __webpack_require__(4);
		
		var _attrAccept2 = _interopRequireDefault(_attrAccept);
		
		var _getDataTransferItems = __webpack_require__(5);
		
		var _getDataTransferItems2 = _interopRequireDefault(_getDataTransferItems);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
		
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint prefer-template: 0 */
		
		var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;
		
		function fileAccepted(file, accept) {
		  // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
		  // that MIME type will always be accepted
		  return file.type === 'application/x-moz-file' || (0, _attrAccept2.default)(file, accept);
		}
		
		var Dropzone = function (_React$Component) {
		  _inherits(Dropzone, _React$Component);
		
		  _createClass(Dropzone, null, [{
		    key: 'onDocumentDragOver',
		    value: function onDocumentDragOver(evt) {
		      // allow the entire document to be a drag target
		      evt.preventDefault();
		    }
		  }]);
		
		  function Dropzone(props, context) {
		    _classCallCheck(this, Dropzone);
		
		    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));
		
		    _this.renderChildren = function (children, isDragActive, isDragReject) {
		      if (typeof children === 'function') {
		        return children(_extends({}, _this.state, { isDragActive: isDragActive, isDragReject: isDragReject }));
		      }
		      return children;
		    };
		
		    _this.onClick = _this.onClick.bind(_this);
		    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
		    _this.onDragStart = _this.onDragStart.bind(_this);
		    _this.onDragEnter = _this.onDragEnter.bind(_this);
		    _this.onDragLeave = _this.onDragLeave.bind(_this);
		    _this.onDragOver = _this.onDragOver.bind(_this);
		    _this.onDrop = _this.onDrop.bind(_this);
		    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
		    _this.setRef = _this.setRef.bind(_this);
		    _this.setRefs = _this.setRefs.bind(_this);
		    _this.onInputElementClick = _this.onInputElementClick.bind(_this);
		    _this.isFileDialogActive = false;
		    _this.state = {
		      draggedFiles: [],
		      acceptedFiles: [],
		      rejectedFiles: []
		    };
		    return _this;
		  }
		
		  _createClass(Dropzone, [{
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      var preventDropOnDocument = this.props.preventDropOnDocument;
		
		      this.dragTargets = [];
		
		      if (preventDropOnDocument) {
		        document.addEventListener('dragover', Dropzone.onDocumentDragOver, false);
		        document.addEventListener('drop', this.onDocumentDrop, false);
		      }
		      this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
		      // Tried implementing addEventListener, but didn't work out
		      document.body.onfocus = this.onFileDialogCancel;
		    }
		  }, {
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      var preventDropOnDocument = this.props.preventDropOnDocument;
		
		      if (preventDropOnDocument) {
		        document.removeEventListener('dragover', Dropzone.onDocumentDragOver);
		        document.removeEventListener('drop', this.onDocumentDrop);
		      }
		      this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
		      // Can be replaced with removeEventListener, if addEventListener works
		      document.body.onfocus = null;
		    }
		  }, {
		    key: 'onDocumentDrop',
		    value: function onDocumentDrop(evt) {
		      if (this.node.contains(evt.target)) {
		        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
		        return;
		      }
		      evt.preventDefault();
		      this.dragTargets = [];
		    }
		  }, {
		    key: 'onDragStart',
		    value: function onDragStart(evt) {
		      if (this.props.onDragStart) {
		        this.props.onDragStart.call(this, evt);
		      }
		    }
		  }, {
		    key: 'onDragEnter',
		    value: function onDragEnter(evt) {
		      evt.preventDefault();
		
		      // Count the dropzone and any children that are entered.
		      if (this.dragTargets.indexOf(evt.target) === -1) {
		        this.dragTargets.push(evt.target);
		      }
		
		      this.setState({ draggedFiles: (0, _getDataTransferItems2.default)(evt) });
		
		      if (this.props.onDragEnter) {
		        this.props.onDragEnter.call(this, evt);
		      }
		    }
		  }, {
		    key: 'onDragOver',
		    value: function onDragOver(evt) {
		      // eslint-disable-line class-methods-use-this
		      evt.preventDefault();
		      evt.stopPropagation();
		      try {
		        evt.dataTransfer.dropEffect = 'copy'; // eslint-disable-line no-param-reassign
		      } catch (err) {
		        // continue regardless of error
		      }
		
		      if (this.props.onDragOver) {
		        this.props.onDragOver.call(this, evt);
		      }
		      return false;
		    }
		  }, {
		    key: 'onDragLeave',
		    value: function onDragLeave(evt) {
		      var _this2 = this;
		
		      evt.preventDefault();
		
		      // Only deactivate once the dropzone and all children have been left.
		      this.dragTargets = this.dragTargets.filter(function (el) {
		        return el !== evt.target && _this2.node.contains(el);
		      });
		      if (this.dragTargets.length > 0) {
		        return;
		      }
		
		      // Clear dragging files state
		      this.setState({ draggedFiles: [] });
		
		      if (this.props.onDragLeave) {
		        this.props.onDragLeave.call(this, evt);
		      }
		    }
		  }, {
		    key: 'onDrop',
		    value: function onDrop(evt) {
		      var _this3 = this;
		
		      var _props = this.props,
		          onDrop = _props.onDrop,
		          onDropAccepted = _props.onDropAccepted,
		          onDropRejected = _props.onDropRejected,
		          multiple = _props.multiple,
		          disablePreview = _props.disablePreview,
		          accept = _props.accept;
		
		      var fileList = (0, _getDataTransferItems2.default)(evt);
		      var acceptedFiles = [];
		      var rejectedFiles = [];
		
		      // Stop default browser behavior
		      evt.preventDefault();
		
		      // Reset the counter along with the drag on a drop.
		      this.dragTargets = [];
		      this.isFileDialogActive = false;
		
		      fileList.forEach(function (file) {
		        if (!disablePreview) {
		          try {
		            file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
		          } catch (err) {
		            if (process.env.NODE_ENV !== 'production') {
		              console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
		            }
		          }
		        }
		
		        if (fileAccepted(file, accept) && _this3.fileMatchSize(file)) {
		          acceptedFiles.push(file);
		        } else {
		          rejectedFiles.push(file);
		        }
		      });
		
		      if (!multiple) {
		        // if not in multi mode add any extra accepted files to rejected.
		        // This will allow end users to easily ignore a multi file drop in "single" mode.
		        rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
		      }
		
		      if (onDrop) {
		        onDrop.call(this, acceptedFiles, rejectedFiles, evt);
		      }
		
		      if (rejectedFiles.length > 0 && onDropRejected) {
		        onDropRejected.call(this, rejectedFiles, evt);
		      }
		
		      if (acceptedFiles.length > 0 && onDropAccepted) {
		        onDropAccepted.call(this, acceptedFiles, evt);
		      }
		
		      // Clear files value
		      this.draggedFiles = null;
		
		      // Reset drag state
		      this.setState({
		        draggedFiles: [],
		        acceptedFiles: acceptedFiles,
		        rejectedFiles: rejectedFiles
		      });
		    }
		  }, {
		    key: 'onClick',
		    value: function onClick(evt) {
		      var _props2 = this.props,
		          onClick = _props2.onClick,
		          disableClick = _props2.disableClick;
		
		      if (!disableClick) {
		        evt.stopPropagation();
		
		        if (onClick) {
		          onClick.call(this, evt);
		        }
		
		        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
		        // this is so react can handle state changes in the onClick prop above above
		        // see: https://github.com/okonet/react-dropzone/issues/450
		        setTimeout(this.open.bind(this), 0);
		      }
		    }
		  }, {
		    key: 'onInputElementClick',
		    value: function onInputElementClick(evt) {
		      evt.stopPropagation();
		      if (this.props.inputProps && this.props.inputProps.onClick) {
		        this.props.inputProps.onClick();
		      }
		    }
		  }, {
		    key: 'onFileDialogCancel',
		    value: function onFileDialogCancel() {
		      // timeout will not recognize context of this method
		      var onFileDialogCancel = this.props.onFileDialogCancel;
		      var fileInputEl = this.fileInputEl;
		      var isFileDialogActive = this.isFileDialogActive;
		      // execute the timeout only if the onFileDialogCancel is defined and FileDialog
		      // is opened in the browser
		
		      if (onFileDialogCancel && isFileDialogActive) {
		        setTimeout(function () {
		          // Returns an object as FileList
		          var FileList = fileInputEl.files;
		          if (!FileList.length) {
		            isFileDialogActive = false;
		            onFileDialogCancel();
		          }
		        }, 300);
		      }
		    }
		  }, {
		    key: 'setRef',
		    value: function setRef(ref) {
		      this.node = ref;
		    }
		  }, {
		    key: 'setRefs',
		    value: function setRefs(ref) {
		      this.fileInputEl = ref;
		    }
		  }, {
		    key: 'fileMatchSize',
		    value: function fileMatchSize(file) {
		      return file.size <= this.props.maxSize && file.size >= this.props.minSize;
		    }
		  }, {
		    key: 'allFilesAccepted',
		    value: function allFilesAccepted(files) {
		      var _this4 = this;
		
		      return files.every(function (file) {
		        return fileAccepted(file, _this4.props.accept);
		      });
		    }
		
		    /**
		     * Open system file upload dialog.
		     *
		     * @public
		     */
		
		  }, {
		    key: 'open',
		    value: function open() {
		      this.isFileDialogActive = true;
		      this.fileInputEl.value = null;
		      this.fileInputEl.click();
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      var _props3 = this.props,
		          accept = _props3.accept,
		          activeClassName = _props3.activeClassName,
		          inputProps = _props3.inputProps,
		          multiple = _props3.multiple,
		          name = _props3.name,
		          rejectClassName = _props3.rejectClassName,
		          children = _props3.children,
		          rest = _objectWithoutProperties(_props3, ['accept', 'activeClassName', 'inputProps', 'multiple', 'name', 'rejectClassName', 'children']);
		
		      var activeStyle = rest.activeStyle,
		          className = rest.className,
		          rejectStyle = rest.rejectStyle,
		          style = rest.style,
		          props = _objectWithoutProperties(rest, ['activeStyle', 'className', 'rejectStyle', 'style']);
		
		      var draggedFiles = this.state.draggedFiles;
		
		      var filesCount = draggedFiles.length;
		      var isMultipleAllowed = multiple || filesCount <= 1;
		      var isDragActive = filesCount > 0 && this.allFilesAccepted(draggedFiles);
		      var isDragReject = filesCount > 0 && (!isDragActive || !isMultipleAllowed);
		
		      className = className || '';
		
		      if (isDragActive && activeClassName) {
		        className += ' ' + activeClassName;
		      }
		      if (isDragReject && rejectClassName) {
		        className += ' ' + rejectClassName;
		      }
		
		      if (!className && !style && !activeStyle && !rejectStyle) {
		        style = {
		          width: 200,
		          height: 200,
		          borderWidth: 2,
		          borderColor: '#666',
		          borderStyle: 'dashed',
		          borderRadius: 5
		        };
		        activeStyle = {
		          borderStyle: 'solid',
		          borderColor: '#6c6',
		          backgroundColor: '#eee'
		        };
		        rejectStyle = {
		          borderStyle: 'solid',
		          borderColor: '#c66',
		          backgroundColor: '#eee'
		        };
		      }
		
		      var appliedStyle = void 0;
		      if (activeStyle && isDragActive) {
		        appliedStyle = _extends({}, style, activeStyle);
		      } else if (rejectStyle && isDragReject) {
		        appliedStyle = _extends({}, style, rejectStyle);
		      } else {
		        appliedStyle = _extends({}, style);
		      }
		
		      var inputAttributes = {
		        accept: accept,
		        type: 'file',
		        style: { display: 'none' },
		        multiple: supportMultiple && multiple,
		        ref: this.setRefs,
		        onChange: this.onDrop
		      };
		
		      if (name && name.length) {
		        inputAttributes.name = name;
		      }
		
		      // Remove custom properties before passing them to the wrapper div element
		      var customProps = ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize'];
		      var divProps = _extends({}, props);
		      customProps.forEach(function (prop) {
		        return delete divProps[prop];
		      });
		
		      return _react2.default.createElement(
		        'div',
		        _extends({
		          className: className,
		          style: appliedStyle
		        }, divProps /* expand user provided props first so event handlers are never overridden */, {
		          onClick: this.onClick,
		          onDragStart: this.onDragStart,
		          onDragEnter: this.onDragEnter,
		          onDragOver: this.onDragOver,
		          onDragLeave: this.onDragLeave,
		          onDrop: this.onDrop,
		          ref: this.setRef
		        }),
		        this.renderChildren(children, isDragActive, isDragReject),
		        _react2.default.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
		      );
		    }
		  }]);
		
		  return Dropzone;
		}(_react2.default.Component);
		
		Dropzone.propTypes = {
		  /**
		   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
		   * Keep in mind that mime type determination is not reliable accross platforms. CSV files,
		   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
		   * Windows. In some cases there might not be a mime type set at all.
		   * See: https://github.com/okonet/react-dropzone/issues/276
		   */
		  accept: _propTypes2.default.string,
		
		  /**
		   * Contents of the dropzone
		   */
		  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
		
		  /**
		   * Disallow clicking on the dropzone container to open file dialog
		   */
		  disableClick: _propTypes2.default.bool,
		
		  /**
		   * Enable/disable preview generation
		   */
		  disablePreview: _propTypes2.default.bool,
		
		  /**
		   * If false, allow dropped items to take over the current browser window
		   */
		  preventDropOnDocument: _propTypes2.default.bool,
		
		  /**
		   * Pass additional attributes to the `<input type="file"/>` tag
		   */
		  inputProps: _propTypes2.default.object,
		
		  /**
		   * Allow dropping multiple files
		   */
		  multiple: _propTypes2.default.bool,
		
		  /**
		   * `name` attribute for the input tag
		   */
		  name: _propTypes2.default.string,
		
		  /**
		   * Maximum file size
		   */
		  maxSize: _propTypes2.default.number,
		
		  /**
		   * Minimum file size
		   */
		  minSize: _propTypes2.default.number,
		
		  /**
		   * className
		   */
		  className: _propTypes2.default.string,
		
		  /**
		   * className for accepted state
		   */
		  activeClassName: _propTypes2.default.string,
		
		  /**
		   * className for rejected state
		   */
		  rejectClassName: _propTypes2.default.string,
		
		  /**
		   * CSS styles to apply
		   */
		  style: _propTypes2.default.object,
		
		  /**
		   * CSS styles to apply when drop will be accepted
		   */
		  activeStyle: _propTypes2.default.object,
		
		  /**
		   * CSS styles to apply when drop will be rejected
		   */
		  rejectStyle: _propTypes2.default.object,
		
		  /**
		   * onClick callback
		   * @param {Event} event
		   */
		  onClick: _propTypes2.default.func,
		
		  /**
		   * onDrop callback
		   */
		  onDrop: _propTypes2.default.func,
		
		  /**
		   * onDropAccepted callback
		   */
		  onDropAccepted: _propTypes2.default.func,
		
		  /**
		   * onDropRejected callback
		   */
		  onDropRejected: _propTypes2.default.func,
		
		  /**
		   * onDragStart callback
		   */
		  onDragStart: _propTypes2.default.func,
		
		  /**
		   * onDragEnter callback
		   */
		  onDragEnter: _propTypes2.default.func,
		
		  /**
		   * onDragOver callback
		   */
		  onDragOver: _propTypes2.default.func,
		
		  /**
		   * onDragLeave callback
		   */
		  onDragLeave: _propTypes2.default.func,
		
		  /**
		   * Provide a callback on clicking the cancel button of the file dialog
		   */
		  onFileDialogCancel: _propTypes2.default.func
		};
		
		Dropzone.defaultProps = {
		  preventDropOnDocument: true,
		  disablePreview: false,
		  disableClick: false,
		  multiple: true,
		  maxSize: Infinity,
		  minSize: 0
		};
		
		exports.default = Dropzone;
		module.exports = exports['default'];
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
		// shim for using process in browser
		var process = module.exports = {};
		
		// cached from whatever global is present so that test runners that stub it
		// don't break things.  But we need to wrap it in a try catch in case it is
		// wrapped in strict mode code which doesn't define any globals.  It's inside a
		// function because try/catches deoptimize in certain engines.
		
		var cachedSetTimeout;
		var cachedClearTimeout;
		
		function defaultSetTimout() {
		    throw new Error('setTimeout has not been defined');
		}
		function defaultClearTimeout () {
		    throw new Error('clearTimeout has not been defined');
		}
		(function () {
		    try {
		        if (typeof setTimeout === 'function') {
		            cachedSetTimeout = setTimeout;
		        } else {
		            cachedSetTimeout = defaultSetTimout;
		        }
		    } catch (e) {
		        cachedSetTimeout = defaultSetTimout;
		    }
		    try {
		        if (typeof clearTimeout === 'function') {
		            cachedClearTimeout = clearTimeout;
		        } else {
		            cachedClearTimeout = defaultClearTimeout;
		        }
		    } catch (e) {
		        cachedClearTimeout = defaultClearTimeout;
		    }
		} ())
		function runTimeout(fun) {
		    if (cachedSetTimeout === setTimeout) {
		        //normal enviroments in sane situations
		        return setTimeout(fun, 0);
		    }
		    // if setTimeout wasn't available but was latter defined
		    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
		        cachedSetTimeout = setTimeout;
		        return setTimeout(fun, 0);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedSetTimeout(fun, 0);
		    } catch(e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
		            return cachedSetTimeout.call(null, fun, 0);
		        } catch(e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
		            return cachedSetTimeout.call(this, fun, 0);
		        }
		    }
		
		
		}
		function runClearTimeout(marker) {
		    if (cachedClearTimeout === clearTimeout) {
		        //normal enviroments in sane situations
		        return clearTimeout(marker);
		    }
		    // if clearTimeout wasn't available but was latter defined
		    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
		        cachedClearTimeout = clearTimeout;
		        return clearTimeout(marker);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedClearTimeout(marker);
		    } catch (e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
		            return cachedClearTimeout.call(null, marker);
		        } catch (e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
		            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
		            return cachedClearTimeout.call(this, marker);
		        }
		    }
		
		
		
		}
		var queue = [];
		var draining = false;
		var currentQueue;
		var queueIndex = -1;
		
		function cleanUpNextTick() {
		    if (!draining || !currentQueue) {
		        return;
		    }
		    draining = false;
		    if (currentQueue.length) {
		        queue = currentQueue.concat(queue);
		    } else {
		        queueIndex = -1;
		    }
		    if (queue.length) {
		        drainQueue();
		    }
		}
		
		function drainQueue() {
		    if (draining) {
		        return;
		    }
		    var timeout = runTimeout(cleanUpNextTick);
		    draining = true;
		
		    var len = queue.length;
		    while(len) {
		        currentQueue = queue;
		        queue = [];
		        while (++queueIndex < len) {
		            if (currentQueue) {
		                currentQueue[queueIndex].run();
		            }
		        }
		        queueIndex = -1;
		        len = queue.length;
		    }
		    currentQueue = null;
		    draining = false;
		    runClearTimeout(timeout);
		}
		
		process.nextTick = function (fun) {
		    var args = new Array(arguments.length - 1);
		    if (arguments.length > 1) {
		        for (var i = 1; i < arguments.length; i++) {
		            args[i - 1] = arguments[i];
		        }
		    }
		    queue.push(new Item(fun, args));
		    if (queue.length === 1 && !draining) {
		        runTimeout(drainQueue);
		    }
		};
		
		// v8 likes predictible objects
		function Item(fun, array) {
		    this.fun = fun;
		    this.array = array;
		}
		Item.prototype.run = function () {
		    this.fun.apply(null, this.array);
		};
		process.title = 'browser';
		process.browser = true;
		process.env = {};
		process.argv = [];
		process.version = ''; // empty string to avoid regexp issues
		process.versions = {};
		
		function noop() {}
		
		process.on = noop;
		process.addListener = noop;
		process.once = noop;
		process.off = noop;
		process.removeListener = noop;
		process.removeAllListeners = noop;
		process.emit = noop;
		process.prependListener = noop;
		process.prependOnceListener = noop;
		
		process.listeners = function (name) { return [] }
		
		process.binding = function (name) {
		    throw new Error('process.binding is not supported');
		};
		
		process.cwd = function () { return '/' };
		process.chdir = function (dir) {
		    throw new Error('process.chdir is not supported');
		};
		process.umask = function() { return 0; };
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
		module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={exports:{},id:e,loaded:!1};return t[e].call(o.exports,o,o.exports,n),o.loaded=!0,o.exports}var r={};return n.m=t,n.c=r,n.p="",n(0)}([function(t,n,r){"use strict";n.__esModule=!0,r(8),r(9),n["default"]=function(t,n){if(t&&n){var r=function(){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return{v:r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):/\/\*$/.test(n)?i===n.replace(/\/.*$/,""):o===n})}}();if("object"==typeof r)return r.v}return!0},t.exports=n["default"]},function(t,n){var r=t.exports={version:"1.2.2"};"number"==typeof __e&&(__e=r)},function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n,r){var e=r(2),o=r(1),i=r(4),u=r(19),c="prototype",f=function(t,n){return function(){return t.apply(n,arguments)}},s=function(t,n,r){var a,p,l,y,d=t&s.G,h=t&s.P,v=d?e:t&s.S?e[n]||(e[n]={}):(e[n]||{})[c],x=d?o:o[n]||(o[n]={});d&&(r=n);for(a in r)p=!(t&s.F)&&v&&a in v,l=(p?v:r)[a],y=t&s.B&&p?f(l,e):h&&"function"==typeof l?f(Function.call,l):l,v&&!p&&u(v,a,l),x[a]!=l&&i(x,a,y),h&&((x[c]||(x[c]={}))[a]=l)};e.core=o,s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,t.exports=s},function(t,n,r){var e=r(5),o=r(18);t.exports=r(22)?function(t,n,r){return e.setDesc(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=Object;t.exports={create:r.create,getProto:r.getPrototypeOf,isEnum:{}.propertyIsEnumerable,getDesc:r.getOwnPropertyDescriptor,setDesc:r.defineProperty,setDescs:r.defineProperties,getKeys:r.keys,getNames:r.getOwnPropertyNames,getSymbols:r.getOwnPropertySymbols,each:[].forEach}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(20)("wks"),o=r(2).Symbol;t.exports=function(t){return e[t]||(e[t]=o&&o[t]||(o||r(6))("Symbol."+t))}},function(t,n,r){r(26),t.exports=r(1).Array.some},function(t,n,r){r(25),t.exports=r(1).String.endsWith},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(10);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(e){try{return n[r(7)("match")]=!1,!"/./"[t](n)}catch(o){}}return!0}},function(t,n){t.exports=function(t){try{return!!t()}catch(n){return!0}}},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n,r){var e=r(16),o=r(11),i=r(7)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(2),o=r(4),i=r(6)("src"),u="toString",c=Function[u],f=(""+c).split(u);r(1).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,u){"function"==typeof r&&(o(r,i,t[n]?""+t[n]:f.join(String(n))),"name"in r||(r.name=n)),t===e?t[n]=r:(u||delete t[n],o(t,n,r))})(Function.prototype,u,function(){return"function"==typeof this&&this[i]||c.call(this)})},function(t,n,r){var e=r(2),o="__core-js_shared__",i=e[o]||(e[o]={});t.exports=function(t){return i[t]||(i[t]={})}},function(t,n,r){var e=r(17),o=r(13);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){t.exports=!r(15)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(23),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";var e=r(3),o=r(24),i=r(21),u="endsWith",c=""[u];e(e.P+e.F*r(14)(u),"String",{endsWith:function(t){var n=i(this,t,u),r=arguments,e=r.length>1?r[1]:void 0,f=o(n.length),s=void 0===e?f:Math.min(o(e),f),a=String(t);return c?c.call(n,a,s):n.slice(s-a.length,s)===a}})},function(t,n,r){var e=r(5),o=r(3),i=r(1).Array||Array,u={},c=function(t,n){e.each.call(t.split(","),function(t){void 0==n&&t in i?u[t]=i[t]:t in[]&&(u[t]=r(12)(Function.call,[][t],n))})};c("pop,reverse,shift,keys,values,entries",1),c("indexOf,every,some,forEach,map,filter,find,findIndex,includes",3),c("join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill"),o(o.S,"Array",u)}]);
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
		"use strict";
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = getDataTransferFiles;
		function getDataTransferFiles(event) {
		  var dataTransferItemsList = [];
		  if (event.dataTransfer) {
		    var dt = event.dataTransfer;
		    if (dt.files && dt.files.length) {
		      dataTransferItemsList = dt.files;
		    } else if (dt.items && dt.items.length) {
		      // During the drag even the dataTransfer.files is null
		      // but Chrome implements some drag store, which is accesible via dataTransfer.items
		      dataTransferItemsList = dt.items;
		    }
		  } else if (event.target && event.target.files) {
		    dataTransferItemsList = event.target.files;
		  }
		  // Convert from DataTransferItemsList to the native Array
		  return Array.prototype.slice.call(dataTransferItemsList);
		}
		module.exports = exports["default"];
	
	/***/ })
	/******/ ])
	});
	;
	//# sourceMappingURL=index.js.map

/***/ },
/* 1640 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 1641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*eslint-disable react/prop-types */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _componentOrElement = __webpack_require__(345);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Portal = __webpack_require__(518);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _ModalManager = __webpack_require__(1642);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _ownerDocument = __webpack_require__(175);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _addEventListener = __webpack_require__(521);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _addFocusListener = __webpack_require__(1645);
	
	var _addFocusListener2 = _interopRequireDefault(_addFocusListener);
	
	var _inDOM = __webpack_require__(76);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _activeElement = __webpack_require__(414);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(128);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _getContainer = __webpack_require__(344);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalManager = new _ModalManager2.default();
	
	/**
	 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
	 * The Modal component renders its `children` node in front of a backdrop component.
	 *
	 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
	 *
	 * - Manages dialog stacking when one-at-a-time just isn't enough.
	 * - Creates a backdrop, for disabling interaction below the modal.
	 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
	 * - It disables scrolling of the page content while open.
	 * - Adds the appropriate ARIA roles are automatically.
	 * - Easily pluggable animations via a `<Transition/>` component.
	 *
	 * Note that, in the same way the backdrop element prevents users from clicking or interacting
	 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
	 * interact with page content while the Modal is open. To do this, we use a common technique of applying
	 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
	 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
	 * React hierarchy (such as the default: document.body).
	 */
	var Modal = _react2.default.createClass({
	  displayName: 'Modal',
	
	
	  propTypes: _extends({}, _Portal2.default.propTypes, {
	
	    /**
	     * Set the visibility of the Modal
	     */
	    show: _react2.default.PropTypes.bool,
	
	    /**
	     * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
	     *
	     * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	     * page content can be placed behind a virtual backdrop as well as a visual one.
	     */
	    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
	    /**
	     * A callback fired when the Modal is opening.
	     */
	    onShow: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	     *
	     * The `onHide` callback only signals intent from the Modal,
	     * you must actually set the `show` prop to `false` for the Modal to close.
	     */
	    onHide: _react2.default.PropTypes.func,
	
	    /**
	     * Include a backdrop component.
	     */
	    backdrop: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.bool, _react2.default.PropTypes.oneOf(['static'])]),
	
	    /**
	     * A function that returns a backdrop component. Useful for custom
	     * backdrop rendering.
	     *
	     * ```js
	     *  renderBackdrop={props => <MyBackdrop {...props} />}
	     * ```
	     */
	    renderBackdrop: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	     */
	    onEscapeKeyUp: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when the backdrop, if specified, is clicked.
	     */
	    onBackdropClick: _react2.default.PropTypes.func,
	
	    /**
	     * A style object for the backdrop component.
	     */
	    backdropStyle: _react2.default.PropTypes.object,
	
	    /**
	     * A css class or classes for the backdrop component.
	     */
	    backdropClassName: _react2.default.PropTypes.string,
	
	    /**
	     * A css class or set of classes applied to the modal container when the modal is open,
	     * and removed when it is closed.
	     */
	    containerClassName: _react2.default.PropTypes.string,
	
	    /**
	     * Close the modal when escape key is pressed
	     */
	    keyboard: _react2.default.PropTypes.bool,
	
	    /**
	     * A `<Transition/>` component to use for the dialog and backdrop components.
	     */
	    transition: _elementType2.default,
	
	    /**
	     * The `timeout` of the dialog transition if specified. This number is used to ensure that
	     * transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    dialogTransitionTimeout: _react2.default.PropTypes.number,
	
	    /**
	     * The `timeout` of the backdrop transition if specified. This number is used to
	     * ensure that transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    backdropTransitionTimeout: _react2.default.PropTypes.number,
	
	    /**
	     * When `true` The modal will automatically shift focus to itself when it opens, and
	     * replace it to the last focused element when it closes. This also
	     * works correctly with any Modal children that have the `autoFocus` prop.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    autoFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * When `true` The modal will prevent focus from leaving the Modal while open.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    enforceFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * When `true` The modal will restore focus to previously focused element once
	     * modal is hidden
	     */
	    restoreFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * Callback fired before the Modal transitions in
	     */
	    onEnter: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition in
	     */
	    onEntering: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning in
	     */
	    onEntered: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired right before the Modal transitions out
	     */
	    onExit: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition out
	     */
	    onExiting: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning out
	     */
	    onExited: _react2.default.PropTypes.func,
	
	    /**
	     * A ModalManager instance used to track and manage the state of open
	     * Modals. Useful when customizing how modals interact within a container
	     */
	    manager: _react2.default.PropTypes.object.isRequired
	  }),
	
	  getDefaultProps: function getDefaultProps() {
	    var noop = function noop() {};
	
	    return {
	      show: false,
	      backdrop: true,
	      keyboard: true,
	      autoFocus: true,
	      enforceFocus: true,
	      restoreFocus: true,
	      onHide: noop,
	      manager: modalManager,
	      renderBackdrop: function renderBackdrop(props) {
	        return _react2.default.createElement('div', props);
	      }
	    };
	  },
	  omitProps: function omitProps(props, propTypes) {
	
	    var keys = Object.keys(props);
	    var newProps = {};
	    keys.map(function (prop) {
	      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
	        newProps[prop] = props[prop];
	      }
	    });
	
	    return newProps;
	  },
	  getInitialState: function getInitialState() {
	    return { exited: !this.props.show };
	  },
	  render: function render() {
	    var _props = this.props,
	        show = _props.show,
	        container = _props.container,
	        children = _props.children,
	        Transition = _props.transition,
	        backdrop = _props.backdrop,
	        dialogTransitionTimeout = _props.dialogTransitionTimeout,
	        className = _props.className,
	        style = _props.style,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered;
	
	
	    var dialog = _react2.default.Children.only(children);
	    var filteredProps = this.omitProps(this.props, Modal.propTypes);
	
	    var mountModal = show || Transition && !this.state.exited;
	    if (!mountModal) {
	      return null;
	    }
	
	    var _dialog$props = dialog.props,
	        role = _dialog$props.role,
	        tabIndex = _dialog$props.tabIndex;
	
	
	    if (role === undefined || tabIndex === undefined) {
	      dialog = (0, _react.cloneElement)(dialog, {
	        role: role === undefined ? 'document' : role,
	        tabIndex: tabIndex == null ? '-1' : tabIndex
	      });
	    }
	
	    if (Transition) {
	      dialog = _react2.default.createElement(
	        Transition,
	        {
	          transitionAppear: true,
	          unmountOnExit: true,
	          'in': show,
	          timeout: dialogTransitionTimeout,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.handleHidden,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        dialog
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      {
	        ref: this.setMountNode,
	        container: container
	      },
	      _react2.default.createElement(
	        'div',
	        _extends({
	          ref: 'modal',
	          role: role || 'dialog'
	        }, filteredProps, {
	          style: style,
	          className: className
	        }),
	        backdrop && this.renderBackdrop(),
	        dialog
	      )
	    );
	  },
	  renderBackdrop: function renderBackdrop() {
	    var _this = this;
	
	    var _props2 = this.props,
	        backdropStyle = _props2.backdropStyle,
	        backdropClassName = _props2.backdropClassName,
	        renderBackdrop = _props2.renderBackdrop,
	        Transition = _props2.transition,
	        backdropTransitionTimeout = _props2.backdropTransitionTimeout;
	
	
	    var backdropRef = function backdropRef(ref) {
	      return _this.backdrop = ref;
	    };
	
	    var backdrop = _react2.default.createElement('div', {
	      ref: backdropRef,
	      style: this.props.backdropStyle,
	      className: this.props.backdropClassName,
	      onClick: this.handleBackdropClick
	    });
	
	    if (Transition) {
	      backdrop = _react2.default.createElement(
	        Transition,
	        { transitionAppear: true,
	          'in': this.props.show,
	          timeout: backdropTransitionTimeout
	        },
	        renderBackdrop({
	          ref: backdropRef,
	          style: backdropStyle,
	          className: backdropClassName,
	          onClick: this.handleBackdropClick
	        })
	      );
	    }
	
	    return backdrop;
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  },
	  componentWillUpdate: function componentWillUpdate(nextProps) {
	    if (!this.props.show && nextProps.show) {
	      this.checkForFocus();
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    if (this.props.show) {
	      this.onShow();
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    var transition = this.props.transition;
	
	
	    if (prevProps.show && !this.props.show && !transition) {
	      // Otherwise handleHidden will call this.
	      this.onHide();
	    } else if (!prevProps.show && this.props.show) {
	      this.onShow();
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var _props3 = this.props,
	        show = _props3.show,
	        transition = _props3.transition;
	
	
	    if (show || transition && !this.state.exited) {
	      this.onHide();
	    }
	  },
	  onShow: function onShow() {
	    var doc = (0, _ownerDocument2.default)(this);
	    var container = (0, _getContainer2.default)(this.props.container, doc.body);
	
	    this.props.manager.add(this, container, this.props.containerClassName);
	
	    this._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleDocumentKeyUp);
	
	    this._onFocusinListener = (0, _addFocusListener2.default)(this.enforceFocus);
	
	    this.focus();
	
	    if (this.props.onShow) {
	      this.props.onShow();
	    }
	  },
	  onHide: function onHide() {
	    this.props.manager.remove(this);
	
	    this._onDocumentKeyupListener.remove();
	
	    this._onFocusinListener.remove();
	
	    if (this.props.restoreFocus) {
	      this.restoreLastFocus();
	    }
	  },
	  setMountNode: function setMountNode(ref) {
	    this.mountNode = ref ? ref.getMountNode() : ref;
	  },
	  handleHidden: function handleHidden() {
	    this.setState({ exited: true });
	    this.onHide();
	
	    if (this.props.onExited) {
	      var _props4;
	
	      (_props4 = this.props).onExited.apply(_props4, arguments);
	    }
	  },
	  handleBackdropClick: function handleBackdropClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    if (this.props.onBackdropClick) {
	      this.props.onBackdropClick(e);
	    }
	
	    if (this.props.backdrop === true) {
	      this.props.onHide();
	    }
	  },
	  handleDocumentKeyUp: function handleDocumentKeyUp(e) {
	    if (this.props.keyboard && e.keyCode === 27 && this.isTopModal()) {
	      if (this.props.onEscapeKeyUp) {
	        this.props.onEscapeKeyUp(e);
	      }
	      this.props.onHide();
	    }
	  },
	  checkForFocus: function checkForFocus() {
	    if (_inDOM2.default) {
	      this.lastFocus = (0, _activeElement2.default)();
	    }
	  },
	  focus: function focus() {
	    var autoFocus = this.props.autoFocus;
	    var modalContent = this.getDialogElement();
	    var current = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	    var focusInModal = current && (0, _contains2.default)(modalContent, current);
	
	    if (modalContent && autoFocus && !focusInModal) {
	      this.lastFocus = current;
	
	      if (!modalContent.hasAttribute('tabIndex')) {
	        modalContent.setAttribute('tabIndex', -1);
	        (0, _warning2.default)(false, 'The modal content node does not accept focus. ' + 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".');
	      }
	
	      modalContent.focus();
	    }
	  },
	  restoreLastFocus: function restoreLastFocus() {
	    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	    if (this.lastFocus && this.lastFocus.focus) {
	      this.lastFocus.focus();
	      this.lastFocus = null;
	    }
	  },
	  enforceFocus: function enforceFocus() {
	    var enforceFocus = this.props.enforceFocus;
	
	
	    if (!enforceFocus || !this.isMounted() || !this.isTopModal()) {
	      return;
	    }
	
	    var active = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	    var modal = this.getDialogElement();
	
	    if (modal && modal !== active && !(0, _contains2.default)(modal, active)) {
	      modal.focus();
	    }
	  },
	
	
	  //instead of a ref, which might conflict with one the parent applied.
	  getDialogElement: function getDialogElement() {
	    var node = this.refs.modal;
	    return node && node.lastChild;
	  },
	  isTopModal: function isTopModal() {
	    return this.props.manager.isTopModal(this);
	  }
	});
	
	Modal.Manager = _ModalManager2.default;
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ },
/* 1642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _style = __webpack_require__(203);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _class = __webpack_require__(958);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _scrollbarSize = __webpack_require__(421);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _isOverflowing = __webpack_require__(522);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _manageAriaHidden = __webpack_require__(1647);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	  });
	  return idx;
	}
	
	function findContainer(data, modal) {
	  return findIndexOf(data, function (d) {
	    return d.modals.indexOf(modal) !== -1;
	  });
	}
	
	function setContainerStyle(state, container) {
	  var style = { overflow: 'hidden' };
	
	  // we are only interested in the actual `style` here
	  // becasue we will override it
	  state.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (state.overflowing) {
	    // use computed style, here to get the real padding
	    // to add our scrollbar width
	    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
	  }
	
	  (0, _style2.default)(container, style);
	}
	
	function removeContainerStyle(_ref, container) {
	  var style = _ref.style;
	
	
	  Object.keys(style).forEach(function (key) {
	    return container.style[key] = style[key];
	  });
	}
	/**
	 * Proper state managment for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	
	var ModalManager = function () {
	  function ModalManager() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
	        hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
	        _ref2$handleContainer = _ref2.handleContainerOverflow,
	        handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;
	
	    _classCallCheck(this, ModalManager);
	
	    this.hideSiblingNodes = hideSiblingNodes;
	    this.handleContainerOverflow = handleContainerOverflow;
	    this.modals = [];
	    this.containers = [];
	    this.data = [];
	  }
	
	  _createClass(ModalManager, [{
	    key: 'add',
	    value: function add(modal, container, className) {
	      var modalIdx = this.modals.indexOf(modal);
	      var containerIdx = this.containers.indexOf(container);
	
	      if (modalIdx !== -1) {
	        return modalIdx;
	      }
	
	      modalIdx = this.modals.length;
	      this.modals.push(modal);
	
	      if (this.hideSiblingNodes) {
	        (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	      }
	
	      if (containerIdx !== -1) {
	        this.data[containerIdx].modals.push(modal);
	        return modalIdx;
	      }
	
	      var data = {
	        modals: [modal],
	        //right now only the first modal of a container will have its classes applied
	        classes: className ? className.split(/\s+/) : [],
	
	        overflowing: (0, _isOverflowing2.default)(container)
	      };
	
	      if (this.handleContainerOverflow) {
	        setContainerStyle(data, container);
	      }
	
	      data.classes.forEach(_class2.default.addClass.bind(null, container));
	
	      this.containers.push(container);
	      this.data.push(data);
	
	      return modalIdx;
	    }
	  }, {
	    key: 'remove',
	    value: function remove(modal) {
	      var modalIdx = this.modals.indexOf(modal);
	
	      if (modalIdx === -1) {
	        return;
	      }
	
	      var containerIdx = findContainer(this.data, modal);
	      var data = this.data[containerIdx];
	      var container = this.containers[containerIdx];
	
	      data.modals.splice(data.modals.indexOf(modal), 1);
	
	      this.modals.splice(modalIdx, 1);
	
	      // if that was the last modal in a container,
	      // clean up the container
	      if (data.modals.length === 0) {
	        data.classes.forEach(_class2.default.removeClass.bind(null, container));
	
	        if (this.handleContainerOverflow) {
	          removeContainerStyle(data, container);
	        }
	
	        if (this.hideSiblingNodes) {
	          (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	        }
	        this.containers.splice(containerIdx, 1);
	        this.data.splice(containerIdx, 1);
	      } else if (this.hideSiblingNodes) {
	        //otherwise make sure the next top modal is visible to a SR
	        (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
	      }
	    }
	  }, {
	    key: 'isTopModal',
	    value: function isTopModal(modal) {
	      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
	    }
	  }]);
	
	  return ModalManager;
	}();
	
	exports.default = ModalManager;
	module.exports = exports['default'];

/***/ },
/* 1643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(518);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Position = __webpack_require__(1644);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _RootCloseWrapper = __webpack_require__(519);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _elementType = __webpack_require__(22);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
	 */
	var Overlay = function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay(props, context) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props, context));
	
	    _this.state = { exited: !props.show };
	    _this.onHiddenListener = _this.handleHidden.bind(_this);
	    return _this;
	  }
	
	  _createClass(Overlay, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.show) {
	        this.setState({ exited: false });
	      } else if (!nextProps.transition) {
	        // Otherwise let handleHidden take care of marking exited.
	        this.setState({ exited: true });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          container = _props.container,
	          containerPadding = _props.containerPadding,
	          target = _props.target,
	          placement = _props.placement,
	          shouldUpdatePosition = _props.shouldUpdatePosition,
	          rootClose = _props.rootClose,
	          children = _props.children,
	          Transition = _props.transition,
	          props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);
	
	      // Don't un-render the overlay while it's transitioning out.
	
	
	      var mountOverlay = props.show || Transition && !this.state.exited;
	      if (!mountOverlay) {
	        // Don't bother showing anything if we don't have to.
	        return null;
	      }
	
	      var child = children;
	
	      // Position is be inner-most because it adds inline styles into the child,
	      // which the other wrappers don't forward correctly.
	      child = _react2.default.createElement(
	        _Position2.default,
	        { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
	        child
	      );
	
	      if (Transition) {
	        var onExit = props.onExit,
	            onExiting = props.onExiting,
	            onEnter = props.onEnter,
	            onEntering = props.onEntering,
	            onEntered = props.onEntered;
	
	        // This animates the child node by injecting props, so it must precede
	        // anything that adds a wrapping div.
	
	        child = _react2.default.createElement(
	          Transition,
	          {
	            'in': props.show,
	            transitionAppear: true,
	            onExit: onExit,
	            onExiting: onExiting,
	            onExited: this.onHiddenListener,
	            onEnter: onEnter,
	            onEntering: onEntering,
	            onEntered: onEntered
	          },
	          child
	        );
	      }
	
	      // This goes after everything else because it adds a wrapping div.
	      if (rootClose) {
	        child = _react2.default.createElement(
	          _RootCloseWrapper2.default,
	          { onRootClose: props.onHide },
	          child
	        );
	      }
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { container: container },
	        child
	      );
	    }
	  }, {
	    key: 'handleHidden',
	    value: function handleHidden() {
	      this.setState({ exited: true });
	
	      if (this.props.onExited) {
	        var _props2;
	
	        (_props2 = this.props).onExited.apply(_props2, arguments);
	      }
	    }
	  }]);
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _react2.default.PropTypes.bool,
	
	  /**
	   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
	   */
	  rootClose: _react2.default.PropTypes.bool,
	
	  /**
	   * A Callback fired by the Overlay when it wishes to be hidden.
	   *
	   * __required__ when `rootClose` is `true`.
	   *
	   * @type func
	   */
	  onHide: function onHide(props) {
	    var propType = _react2.default.PropTypes.func;
	    if (props.rootClose) {
	      propType = propType.isRequired;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return propType.apply(undefined, [props].concat(args));
	  },
	
	
	  /**
	   * A `<Transition/>` component used to animate the overlay changes visibility.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _react2.default.PropTypes.func
	});
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ },
/* 1644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentOrElement = __webpack_require__(345);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _calculatePosition = __webpack_require__(1646);
	
	var _calculatePosition2 = _interopRequireDefault(_calculatePosition);
	
	var _getContainer = __webpack_require__(344);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(175);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Position component calculates the coordinates for its child, to position
	 * it relative to a `target` component or node. Useful for creating callouts
	 * and tooltips, the Position component injects a `style` props with `left` and
	 * `top` values for positioning your component.
	 *
	 * It also injects "arrow" `left`, and `top` values for styling callout arrows
	 * for giving your components a sense of directionality.
	 */
	var Position = function (_React$Component) {
	  _inherits(Position, _React$Component);
	
	  function Position(props, context) {
	    _classCallCheck(this, Position);
	
	    var _this = _possibleConstructorReturn(this, (Position.__proto__ || Object.getPrototypeOf(Position)).call(this, props, context));
	
	    _this.state = {
	      positionLeft: 0,
	      positionTop: 0,
	      arrowOffsetLeft: null,
	      arrowOffsetTop: null
	    };
	
	    _this._needsFlush = false;
	    _this._lastTarget = null;
	    return _this;
	  }
	
	  _createClass(Position, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updatePosition(this.getTarget());
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this._needsFlush = true;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this._needsFlush) {
	        this._needsFlush = false;
	        this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['children', 'className']);
	
	      var _state = this.state,
	          positionLeft = _state.positionLeft,
	          positionTop = _state.positionTop,
	          arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);
	
	      // These should not be forwarded to the child.
	
	
	      delete props.target;
	      delete props.container;
	      delete props.containerPadding;
	      delete props.shouldUpdatePosition;
	
	      var child = _react2.default.Children.only(children);
	      return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
	        // FIXME: Don't forward `positionLeft` and `positionTop` via both props
	        // and `props.style`.
	        positionLeft: positionLeft,
	        positionTop: positionTop,
	        className: (0, _classnames2.default)(className, child.props.className),
	        style: _extends({}, child.props.style, {
	          left: positionLeft,
	          top: positionTop
	        })
	      }));
	    }
	  }, {
	    key: 'getTarget',
	    value: function getTarget() {
	      var target = this.props.target;
	
	      var targetElement = typeof target === 'function' ? target() : target;
	      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
	    }
	  }, {
	    key: 'maybeUpdatePosition',
	    value: function maybeUpdatePosition(placementChanged) {
	      var target = this.getTarget();
	
	      if (!this.props.shouldUpdatePosition && target === this._lastTarget && !placementChanged) {
	        return;
	      }
	
	      this.updatePosition(target);
	    }
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition(target) {
	      this._lastTarget = target;
	
	      if (!target) {
	        this.setState({
	          positionLeft: 0,
	          positionTop: 0,
	          arrowOffsetLeft: null,
	          arrowOffsetTop: null
	        });
	
	        return;
	      }
	
	      var overlay = _reactDom2.default.findDOMNode(this);
	      var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	
	      this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
	    }
	  }]);
	
	  return Position;
	}(_react2.default.Component);
	
	Position.propTypes = {
	  /**
	   * A node, element, or function that returns either. The child will be
	   * be positioned next to the `target` specified.
	   */
	  target: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
	  /**
	   * "offsetParent" of the component
	   */
	  container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	  /**
	   * Minimum spacing in pixels between container border and component border
	   */
	  containerPadding: _react2.default.PropTypes.number,
	  /**
	   * How to position the component relative to the target
	   */
	  placement: _react2.default.PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	  /**
	   * Whether the position should be changed on each update
	   */
	  shouldUpdatePosition: _react2.default.PropTypes.bool
	};
	
	Position.displayName = 'Position';
	
	Position.defaultProps = {
	  containerPadding: 0,
	  placement: 'right',
	  shouldUpdatePosition: false
	};
	
	exports.default = Position;
	module.exports = exports['default'];

/***/ },
/* 1645 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addFocusListener;
	/**
	 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
	 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
	 *
	 * We only allow one Listener at a time to avoid stack overflows
	 */
	function addFocusListener(handler) {
	  var useFocusin = !document.addEventListener;
	  var remove = void 0;
	
	  if (useFocusin) {
	    document.attachEvent('onfocusin', handler);
	    remove = function remove() {
	      return document.detachEvent('onfocusin', handler);
	    };
	  } else {
	    document.addEventListener('focus', handler, true);
	    remove = function remove() {
	      return document.removeEventListener('focus', handler, true);
	    };
	  }
	
	  return { remove: remove };
	}
	module.exports = exports['default'];

/***/ },
/* 1646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculatePosition;
	
	var _offset = __webpack_require__(418);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _position = __webpack_require__(963);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _scrollTop = __webpack_require__(419);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _ownerDocument = __webpack_require__(175);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainerDimensions(containerNode) {
	  var width = void 0,
	      height = void 0,
	      scroll = void 0;
	
	  if (containerNode.tagName === 'BODY') {
	    width = window.innerWidth;
	    height = window.innerHeight;
	
	    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
	  } else {
	    var _getOffset = (0, _offset2.default)(containerNode);
	
	    width = _getOffset.width;
	    height = _getOffset.height;
	
	    scroll = (0, _scrollTop2.default)(containerNode);
	  }
	
	  return { width: width, height: height, scroll: scroll };
	}
	
	function getTopDelta(top, overlayHeight, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerScroll = containerDimensions.scroll;
	  var containerHeight = containerDimensions.height;
	
	  var topEdgeOffset = top - padding - containerScroll;
	  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;
	
	  if (topEdgeOffset < 0) {
	    return -topEdgeOffset;
	  } else if (bottomEdgeOffset > containerHeight) {
	    return containerHeight - bottomEdgeOffset;
	  } else {
	    return 0;
	  }
	}
	
	function getLeftDelta(left, overlayWidth, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerWidth = containerDimensions.width;
	
	  var leftEdgeOffset = left - padding;
	  var rightEdgeOffset = left + padding + overlayWidth;
	
	  if (leftEdgeOffset < 0) {
	    return -leftEdgeOffset;
	  } else if (rightEdgeOffset > containerWidth) {
	    return containerWidth - rightEdgeOffset;
	  }
	
	  return 0;
	}
	
	function calculatePosition(placement, overlayNode, target, container, padding) {
	  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);
	
	  var _getOffset2 = (0, _offset2.default)(overlayNode),
	      overlayHeight = _getOffset2.height,
	      overlayWidth = _getOffset2.width;
	
	  var positionLeft = void 0,
	      positionTop = void 0,
	      arrowOffsetLeft = void 0,
	      arrowOffsetTop = void 0;
	
	  if (placement === 'left' || placement === 'right') {
	    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
	
	    if (placement === 'left') {
	      positionLeft = childOffset.left - overlayWidth;
	    } else {
	      positionLeft = childOffset.left + childOffset.width;
	    }
	
	    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
	
	    positionTop += topDelta;
	    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
	    arrowOffsetLeft = void 0;
	  } else if (placement === 'top' || placement === 'bottom') {
	    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;
	
	    if (placement === 'top') {
	      positionTop = childOffset.top - overlayHeight;
	    } else {
	      positionTop = childOffset.top + childOffset.height;
	    }
	
	    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
	
	    positionLeft += leftDelta;
	    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
	    arrowOffsetTop = void 0;
	  } else {
	    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
	  }
	
	  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
	}
	module.exports = exports['default'];

/***/ },
/* 1647 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType,
	      tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, mount, cb) {
	  mount = [].concat(mount);
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ },
/* 1648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ImageHelper = __webpack_require__(524);
	
	var _ImageHelper2 = _interopRequireDefault(_ImageHelper);
	
	var propTypes = {
	    // Rendered on success
	    children: _react.PropTypes.node.isRequired,
	
	    // Rendered during load
	    loadingIndicator: _react.PropTypes.node.isRequired,
	
	    // Array of image urls to be preloaded
	    images: _react.PropTypes.array,
	
	    // If set, the preloader will automatically show
	    // the children content after this amount of time
	    autoResolveDelay: _react.PropTypes.number,
	
	    // Error callback. Is passed the error
	    onError: _react.PropTypes.func,
	
	    // Success callback
	    onSuccess: _react.PropTypes.func,
	
	    // Whether or not we should still show the content
	    // even if there is a preloading error
	    resolveOnError: _react.PropTypes.bool,
	
	    // Whether or not we should mount the child content after
	    // images have finished loading (or after autoResolveDelay)
	    mountChildren: _react.PropTypes.bool
	};
	
	var defaultProps = {
	    images: [],
	    resolveOnError: true,
	    mountChildren: true
	};
	
	var Preload = (function (_Component) {
	    _inherits(Preload, _Component);
	
	    function Preload(props) {
	        _classCallCheck(this, Preload);
	
	        _get(Object.getPrototypeOf(Preload.prototype), 'constructor', this).call(this, props);
	
	        this.state = {
	            ready: false
	        };
	
	        this._handleSuccess = this._handleSuccess.bind(this);
	        this._handleError = this._handleError.bind(this);
	    }
	
	    _createClass(Preload, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            if (!this.props.images || this.props.images.length === 0) {
	                this._handleSuccess();
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (!this.state.ready) {
	                _ImageHelper2['default'].loadImages(this.props.images).then(this._handleSuccess, this._handleError);
	
	                if (this.props.autoResolveDelay && this.props.autoResolveDelay > 0) {
	                    this.autoResolveTimeout = setTimeout(this._handleSuccess, this.props.autoResolveDelay);
	                }
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.autoResolveTimeout) {
	                clearTimeout(this.autoResolveTimeout);
	            }
	        }
	    }, {
	        key: '_handleSuccess',
	        value: function _handleSuccess() {
	            if (this.autoResolveTimeout) {
	                clearTimeout(this.autoResolveTimeout);
	                console.warn('images failed to preload, auto resolving');
	            }
	
	            if (this.state.ready) {
	                return;
	            }
	
	            this.setState({
	                ready: true
	            });
	
	            if (this.props.onSuccess) {
	                this.props.onSuccess();
	            }
	        }
	    }, {
	        key: '_handleError',
	        value: function _handleError(err) {
	            if (this.props.resolveOnError) {
	                this._handleSuccess();
	            }
	
	            if (this.props.onError) {
	                this.props.onError(err);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return this.state.ready && this.props.mountChildren ? this.props.children : this.props.loadingIndicator;
	        }
	    }]);
	
	    return Preload;
	})(_react.Component);
	
	Preload.propTypes = propTypes;
	Preload.defaultProps = defaultProps;
	
	exports['default'] = Preload;
	module.exports = exports['default'];

/***/ },
/* 1649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Preload2 = __webpack_require__(1648);
	
	var _Preload3 = _interopRequireDefault(_Preload2);
	
	var _ImageCache = __webpack_require__(523);
	
	exports.ImageCache = _interopRequire(_ImageCache);
	
	var _ImageHelper = __webpack_require__(524);
	
	exports.ImageHelper = _interopRequire(_ImageHelper);
	var Preload = _Preload3['default'];
	
	exports.Preload = Preload;
	exports['default'] = Preload;

/***/ },
/* 1650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _storeShape = __webpack_require__(525);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(526);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _propTypes2["default"].element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ },
/* 1651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = connect;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(525);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(1652);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(1653);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(526);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(78);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(1654);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = void 0;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure,
	      pure = _options$pure === undefined ? true : _options$pure,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged,
	            hasStoreStateChanged = this.hasStoreStateChanged,
	            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
	            statePropsPrecalculationError = this.statePropsPrecalculationError,
	            renderedElement = this.renderedElement;
	
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 1652 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 1653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(115);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ },
/* 1654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(517);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 1655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = routerMiddleware;
	
	var _actions = __webpack_require__(527);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	}

/***/ },
/* 1656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = syncHistoryWithStore;
	
	var _reducer = __webpack_require__(528);
	
	var defaultSelectLocationState = function defaultSelectLocationState(state) {
	  return state.routing;
	};
	
	/**
	 * This function synchronizes your history state with the Redux store.
	 * Location changes flow from history to the store. An enhanced history is
	 * returned with a listen method that responds to store updates for location.
	 *
	 * When this history is provided to the router, this means the location data
	 * will flow like this:
	 * history.push -> store.dispatch -> enhancedHistory.listen -> router
	 * This ensures that when the store state changes due to a replay or other
	 * event, the router will be updated appropriately and can transition to the
	 * correct router state.
	 */
	function syncHistoryWithStore(history, store) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref$selectLocationSt = _ref.selectLocationState,
	      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
	      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
	      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;
	
	  // Ensure that the reducer is mounted on the store and functioning properly.
	  if (typeof selectLocationState(store.getState()) === 'undefined') {
	    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
	  }
	
	  var initialLocation = void 0;
	  var isTimeTraveling = void 0;
	  var unsubscribeFromStore = void 0;
	  var unsubscribeFromHistory = void 0;
	  var currentLocation = void 0;
	
	  // What does the store say about current location?
	  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
	    var locationState = selectLocationState(store.getState());
	    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
	  };
	
	  // Init initialLocation with potential location in store
	  initialLocation = getLocationInStore();
	
	  // If the store is replayed, update the URL in the browser to match.
	  if (adjustUrlOnReplay) {
	    var handleStoreChange = function handleStoreChange() {
	      var locationInStore = getLocationInStore(true);
	      if (currentLocation === locationInStore || initialLocation === locationInStore) {
	        return;
	      }
	
	      // Update address bar to reflect store state
	      isTimeTraveling = true;
	      currentLocation = locationInStore;
	      history.transitionTo(_extends({}, locationInStore, {
	        action: 'PUSH'
	      }));
	      isTimeTraveling = false;
	    };
	
	    unsubscribeFromStore = store.subscribe(handleStoreChange);
	    handleStoreChange();
	  }
	
	  // Whenever location changes, dispatch an action to get it in the store
	  var handleLocationChange = function handleLocationChange(location) {
	    // ... unless we just caused that location change
	    if (isTimeTraveling) {
	      return;
	    }
	
	    // Remember where we are
	    currentLocation = location;
	
	    // Are we being called for the first time?
	    if (!initialLocation) {
	      // Remember as a fallback in case state is reset
	      initialLocation = location;
	
	      // Respect persisted location, if any
	      if (getLocationInStore()) {
	        return;
	      }
	    }
	
	    // Tell the store to update by dispatching an action
	    store.dispatch({
	      type: _reducer.LOCATION_CHANGE,
	      payload: location
	    });
	  };
	  unsubscribeFromHistory = history.listen(handleLocationChange);
	
	  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
	  if (history.getCurrentLocation) {
	    handleLocationChange(history.getCurrentLocation());
	  }
	
	  // The enhanced history uses store as source of truth
	  return _extends({}, history, {
	    // The listeners are subscribed to the store instead of history
	    listen: function listen(listener) {
	      // Copy of last location.
	      var lastPublishedLocation = getLocationInStore(true);
	
	      // Keep track of whether we unsubscribed, as Redux store
	      // only applies changes in subscriptions on next dispatch
	      var unsubscribed = false;
	      var unsubscribeFromStore = store.subscribe(function () {
	        var currentLocation = getLocationInStore(true);
	        if (currentLocation === lastPublishedLocation) {
	          return;
	        }
	        lastPublishedLocation = currentLocation;
	        if (!unsubscribed) {
	          listener(lastPublishedLocation);
	        }
	      });
	
	      // History 2.x listeners expect a synchronous call. Make the first call to the
	      // listener after subscribing to the store, in case the listener causes a
	      // location change (e.g. when it redirects)
	      if (!history.getCurrentLocation) {
	        listener(lastPublishedLocation);
	      }
	
	      // Let user unsubscribe later
	      return function () {
	        unsubscribed = true;
	        unsubscribeFromStore();
	      };
	    },
	
	
	    // It also provides a way to destroy internal listeners
	    unsubscribe: function unsubscribe() {
	      if (adjustUrlOnReplay) {
	        unsubscribeFromStore();
	      }
	      unsubscribeFromHistory();
	    }
	  });
	}

/***/ },
/* 1657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(35);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _InternalPropTypes = __webpack_require__(113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _InternalPropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
	    this.history = this.context.history;
	  }
	};
	
	exports.default = History;
	module.exports = exports['default'];

/***/ },
/* 1658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(529);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 1659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(35);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(530);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 1660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(35);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(91);
	
	var _InternalPropTypes = __webpack_require__(113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 1661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(35);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
	    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	};
	
	exports.default = Lifecycle;
	module.exports = exports['default'];

/***/ },
/* 1662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(91);
	
	var _InternalPropTypes = __webpack_require__(113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 1663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(35);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
	  }
	};
	
	exports.default = RouteContext;
	module.exports = exports['default'];

/***/ },
/* 1664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHashHistory = __webpack_require__(431);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _useQueries = __webpack_require__(205);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(349);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _InternalPropTypes = __webpack_require__(113);
	
	var _RouterContext = __webpack_require__(229);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(91);
	
	var _RouterUtils = __webpack_require__(531);
	
	var _routerWarning = __webpack_require__(35);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	/* istanbul ignore next: sanity check */
	function isUnsupportedHistory(history) {
	  // v3 histories expose getCurrentLocation, but aren't currently supported.
	  return history && history.getCurrentLocation;
	}
	
	var _React$PropTypes = _react2.default.PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // Deprecated:
	    parseQueryString: func,
	    stringifyQuery: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	
	    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	
	    var createHistory = void 0;
	    if (history) {
	       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
	      createHistory = function createHistory() {
	        return history;
	      };
	    } else {
	       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
	      createHistory = _createHashHistory2.default;
	    }
	
	    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 1665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(229);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(35);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutingContext = _react2.default.createClass({
	  displayName: 'RoutingContext',
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
	  },
	  render: function render() {
	    return _react2.default.createElement(_RouterContext2.default, this.props);
	  }
	});
	
	exports.default = RoutingContext;
	module.exports = exports['default'];

/***/ },
/* 1666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(347);
	
	var _routerWarning = __webpack_require__(35);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTransitionHook(hook, route, asyncArity) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (hook.length < asyncArity) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));
	
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](state, nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ },
/* 1667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(229);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(35);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 1668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(1091);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(533);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 1669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(134);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 1670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(347);
	
	var _makeStateWithLocation = __webpack_require__(534);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (!getComponent) {
	    callback();
	    return;
	  }
	
	  var location = nextState.location;
	
	  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);
	
	  getComponent.call(route, nextStateWithLocation, callback);
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 1671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(134);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 1672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(431);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(533);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 1673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(134);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 1674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(129);
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(532);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(349);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(91);
	
	var _RouterUtils = __webpack_require__(531);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  var unlisten = void 0;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation && router.createLocation(redirectLocation, _Actions.REPLACE), nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 1675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(347);
	
	var _makeStateWithLocation = __webpack_require__(534);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	var _PatternUtils = __webpack_require__(134);
	
	var _routerWarning = __webpack_require__(35);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(91);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 1676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _useQueries = __webpack_require__(205);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _createTransitionManager = __webpack_require__(349);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(35);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = (0, _useQueries2.default)(createHistory)(options);
	    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports.default = useRoutes;
	module.exports = exports['default'];

/***/ },
/* 1677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(1678);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _PropTypes = __webpack_require__(348);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      var props = _extends({}, this.props, { router: router });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 1678 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 1679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(1681);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransitionGroupChild = __webpack_require__(1680);
	
	var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);
	
	var _PropTypes = __webpack_require__(536);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  transitionName: _PropTypes.nameShape.isRequired,
	
	  transitionAppear: _propTypes2.default.bool,
	  transitionEnter: _propTypes2.default.bool,
	  transitionLeave: _propTypes2.default.bool,
	  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
	  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
	  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
	};
	
	var defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	var CSSTransitionGroup = function (_React$Component) {
	  _inherits(CSSTransitionGroup, _React$Component);
	
	  function CSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // We need to provide this childFactory so that
	  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	  // leave while it is leaving.
	
	
	  CSSTransitionGroup.prototype.render = function render() {
	    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return CSSTransitionGroup;
	}(_react2.default.Component);
	
	CSSTransitionGroup.displayName = 'CSSTransitionGroup';
	
	
	CSSTransitionGroup.propTypes =  false ? propTypes : {};
	CSSTransitionGroup.defaultProps = defaultProps;
	
	exports.default = CSSTransitionGroup;
	module.exports = exports['default'];

/***/ },
/* 1680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _addClass = __webpack_require__(415);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(417);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _requestAnimationFrame = __webpack_require__(972);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _properties = __webpack_require__(283);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(28);
	
	var _PropTypes = __webpack_require__(536);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var events = [];
	if (_properties.transitionEnd) events.push(_properties.transitionEnd);
	if (_properties.animationEnd) events.push(_properties.animationEnd);
	
	function addEndListener(node, listener) {
	  if (events.length) {
	    events.forEach(function (e) {
	      return node.addEventListener(e, listener, false);
	    });
	  } else {
	    setTimeout(listener, 0);
	  }
	
	  return function () {
	    if (!events.length) return;
	    events.forEach(function (e) {
	      return node.removeEventListener(e, listener, false);
	    });
	  };
	}
	
	var propTypes = {
	  children: _propTypes2.default.node,
	  name: _PropTypes.nameShape.isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: _propTypes2.default.bool,
	  enter: _propTypes2.default.bool,
	  leave: _propTypes2.default.bool,
	  appearTimeout: _propTypes2.default.number,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};
	
	var CSSTransitionGroupChild = function (_React$Component) {
	  _inherits(CSSTransitionGroupChild, _React$Component);
	
	  function CSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounted = true;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
	    var node = (0, _reactDom.findDOMNode)(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timer = null;
	    var removeListeners = void 0;
	
	    (0, _addClass2.default)(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // Clean-up the animation after the specified delay
	    var finish = function finish(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timer);
	      if (removeListeners) removeListeners();
	
	      (0, _removeClass2.default)(node, className);
	      (0, _removeClass2.default)(node, activeClassName);
	
	      if (removeListeners) removeListeners();
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    if (timeout) {
	      timer = setTimeout(finish, timeout);
	      this.transitionTimeouts.push(timer);
	    } else if (_properties.transitionEnd) {
	      removeListeners = addEndListener(node, finish);
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
	    var _this2 = this;
	
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.rafHandle) {
	      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
	        return _this2.flushClassNameAndNodeQueue();
	      });
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
	    if (!this.unmounted) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        // This is for to force a repaint,
	        // which is necessary in order to transition styles when adding a class name.
	        /* eslint-disable no-unused-expressions */
	        obj.node.scrollTop;
	        /* eslint-enable no-unused-expressions */
	        (0, _addClass2.default)(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.rafHandle = null;
	  };
	
	  CSSTransitionGroupChild.prototype.render = function render() {
	    var props = _extends({}, this.props);
	    delete props.name;
	    delete props.appear;
	    delete props.enter;
	    delete props.leave;
	    delete props.appearTimeout;
	    delete props.enterTimeout;
	    delete props.leaveTimeout;
	    delete props.children;
	    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
	  };
	
	  return CSSTransitionGroupChild;
	}(_react2.default.Component);
	
	CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';
	
	
	CSSTransitionGroupChild.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransitionGroupChild;
	module.exports = exports['default'];

/***/ },
/* 1681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(691);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(1682);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ },
/* 1682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ },
/* 1683 */
332,
/* 1684 */
[1785, 176],
/* 1685 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(1684);
	var ReactElement = __webpack_require__(136);
	
	var emptyFunction = __webpack_require__(66);
	var traverseAllChildren = __webpack_require__(1694);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 1686 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(136);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 1687 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(136),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(465);
	
	module.exports = factory(isValidElement);

/***/ },
/* 1688 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.7.0';


/***/ },
/* 1689 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(537),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(136),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(540);
	var factory = __webpack_require__(937);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 1690 */
1634,
/* 1691 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 1692 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 1693 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(176);
	
	var ReactElement = __webpack_require__(136);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 1694 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(176);
	
	var ReactCurrentOwner = __webpack_require__(81);
	var REACT_ELEMENT_TYPE = __webpack_require__(539);
	
	var getIteratorFn = __webpack_require__(1690);
	var invariant = __webpack_require__(12);
	var KeyEscapeUtils = __webpack_require__(1683);
	var warning = __webpack_require__(20);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 1695 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = asap;
	var queue = [];
	var isSuspended = false;
	
	function asap(task) {
	  if (!isSuspended) {
	    isSuspended = true;
	    queue.push(task);
	    asap.flush();
	  } else {
	    queue.push(task);
	  }
	}
	
	asap.suspend = function () {
	  return isSuspended = true;
	};
	asap.flush = function () {
	  var nextTask = void 0;
	  while (nextTask = queue.shift()) {
	    nextTask();
	  }
	  isSuspended = false;
	};

/***/ },
/* 1696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sagaMiddlewareFactory;
	
	var _utils = __webpack_require__(82);
	
	var _proc = __webpack_require__(543);
	
	var _proc2 = _interopRequireDefault(_proc);
	
	var _channel = __webpack_require__(231);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function sagaMiddlewareFactory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  var runSagaDynamically = void 0;
	
	  if (_utils.is.func(options)) {
	    if (true) {
	      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
	    } else {
	      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
	    }
	  }
	
	  function sagaMiddleware(_ref) {
	    var getState = _ref.getState;
	    var dispatch = _ref.dispatch;
	
	    runSagaDynamically = runSaga;
	    var sagaEmitter = (0, _channel.emitter)();
	
	    function runSaga(saga) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return (0, _proc2.default)(saga.apply(undefined, args), sagaEmitter.subscribe, dispatch, getState, options.sagaMonitor, 0, saga.name);
	    }
	
	    return function (next) {
	      return function (action) {
	        var result = next(action); // hit reducers
	        sagaEmitter.emit(action);
	        return result;
	      };
	    };
	  }
	
	  sagaMiddleware.run = function (saga) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      args[_key2 - 1] = arguments[_key2];
	    }
	
	    (0, _utils.check)(runSagaDynamically, _utils.is.notUndef, 'Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
	    (0, _utils.check)(saga, _utils.is.func, 'sagaMiddleware.run(saga, ...args): saga argument must be a Generator function!');
	    return runSagaDynamically.apply(undefined, [saga].concat(args));
	  };
	
	  return sagaMiddleware;
	}

/***/ },
/* 1697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.runSaga = runSaga;
	
	var _utils = __webpack_require__(82);
	
	var _proc = __webpack_require__(543);
	
	var _proc2 = _interopRequireDefault(_proc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function runSaga(iterator, _ref, monitor) {
	  var subscribe = _ref.subscribe;
	  var dispatch = _ref.dispatch;
	  var getState = _ref.getState;
	
	
	  (0, _utils.check)(iterator, _utils.is.iterator, "runSaga must be called on an iterator");
	
	  return (0, _proc2.default)(iterator, subscribe, dispatch, getState, monitor);
	}

/***/ },
/* 1698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.takeEvery = takeEvery;
	exports.takeLatest = takeLatest;
	
	var _channel = __webpack_require__(231);
	
	var _utils = __webpack_require__(82);
	
	var _io = __webpack_require__(232);
	
	var done = { done: true, value: undefined };
	var qEnd = {};
	
	function fsmIterator(fsm, q0) {
	  var name = arguments.length <= 2 || arguments[2] === undefined ? 'iterator' : arguments[2];
	
	  var updateState = void 0,
	      qNext = q0;
	
	  function next(arg, error) {
	    if (qNext === qEnd) {
	      return done;
	    }
	
	    if (error) {
	      qNext = qEnd;
	      throw error;
	    } else {
	      updateState && updateState(arg);
	
	      var _fsm$qNext = fsm[qNext]();
	
	      var _fsm$qNext2 = _slicedToArray(_fsm$qNext, 3);
	
	      var q = _fsm$qNext2[0];
	      var output = _fsm$qNext2[1];
	      var _updateState = _fsm$qNext2[2];
	
	      qNext = q;
	      updateState = _updateState;
	      return qNext === qEnd ? done : output;
	    }
	  }
	
	  return (0, _utils.makeIterator)(next, function (error) {
	    return next(null, error);
	  }, name);
	}
	
	function safeName(pattern) {
	  if (Array.isArray(pattern)) {
	    return String(pattern.map(function (entry) {
	      return String(entry);
	    }));
	  } else {
	    return String(pattern);
	  }
	}
	
	function takeEvery(pattern, worker) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var yTake = { done: false, value: (0, _io.take)(pattern) };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	
	  var action = void 0,
	      setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return fsmIterator({
	    q1: function q1() {
	      return ['q2', yTake, setAction];
	    },
	    q2: function q2() {
	      return action === _channel.END ? [qEnd] : ['q1', yFork(action)];
	    }
	  }, 'q1', 'takeEvery(' + safeName(pattern) + ', ' + worker.name + ')');
	}
	
	function takeLatest(pattern, worker) {
	  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	    args[_key2 - 2] = arguments[_key2];
	  }
	
	  var yTake = { done: false, value: (0, _io.take)(pattern) };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	  var yCancel = function yCancel(task) {
	    return { done: false, value: (0, _io.cancel)(task) };
	  };
	
	  var task = void 0,
	      action = void 0;
	  var setTask = function setTask(t) {
	    return task = t;
	  };
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return fsmIterator({
	    q1: function q1() {
	      return ['q2', yTake, setAction];
	    },
	    q2: function q2() {
	      return action === _channel.END ? [qEnd] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
	    },
	    q3: function q3() {
	      return ['q1', yFork(action), setTask];
	    }
	  }, 'q1', 'takeLatest(' + safeName(pattern) + ', ' + worker.name + ')');
	}

/***/ },
/* 1699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(82);
	
	Object.defineProperty(exports, 'TASK', {
	  enumerable: true,
	  get: function get() {
	    return _utils.TASK;
	  }
	});
	Object.defineProperty(exports, 'noop', {
	  enumerable: true,
	  get: function get() {
	    return _utils.noop;
	  }
	});
	Object.defineProperty(exports, 'is', {
	  enumerable: true,
	  get: function get() {
	    return _utils.is;
	  }
	});
	Object.defineProperty(exports, 'deferred', {
	  enumerable: true,
	  get: function get() {
	    return _utils.deferred;
	  }
	});
	Object.defineProperty(exports, 'arrayOfDeffered', {
	  enumerable: true,
	  get: function get() {
	    return _utils.arrayOfDeffered;
	  }
	});
	Object.defineProperty(exports, 'createMockTask', {
	  enumerable: true,
	  get: function get() {
	    return _utils.createMockTask;
	  }
	});
	
	var _io = __webpack_require__(232);
	
	Object.defineProperty(exports, 'asEffect', {
	  enumerable: true,
	  get: function get() {
	    return _io.asEffect;
	  }
	});

/***/ },
/* 1700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var react_redux_1 = __webpack_require__(60);
	var Actions = __webpack_require__(544);
	var Dropzone = __webpack_require__(1639);
	;
	function selectState(state) {
	    return state;
	}
	;
	
	var Component = (function (_React$Component) {
	    _inherits(Component, _React$Component);
	
	    function Component() {
	        var _this = this;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        _get(Object.getPrototypeOf(Component.prototype), 'constructor', this).apply(this, args);
	        this.playback = {
	            setTimeoutReference: null,
	            isPlaying: false
	        };
	        this.timeFromStart = function (pos1) {
	            return Math.floor((_this.props.stateHistory.timestamps[pos1] - _this.props.stateHistory.timestamps[0 + 1]) / 1000);
	        };
	        this.currentTime = function () {
	            return _this.timeFromStart(_this.props.stateHistory.current);
	        };
	        this.totalTime = function () {
	            return _this.timeFromStart(_this.props.stateHistory.timestamps.length - 1);
	        };
	        this.playUntilEnd = function () {
	            if (_this.props.stateHistory.current >= _this.props.stateHistory.timestamps.length - 1) {
	                return _this.stopPlackback();
	            } else {
	                var nextActionInMiliseconds = _this.props.stateHistory.timestamps[_this.props.stateHistory.current + 1] - _this.props.stateHistory.timestamps[_this.props.stateHistory.current];
	                // Dispatch action after gap and call self
	                setTimeout(function () {
	                    _this.props.dispatch(Actions.selectHistory(_this.props.stateHistory.current + 1));
	                    _this.playUntilEnd();
	                }, nextActionInMiliseconds);
	            }
	        };
	        this.stopPlackback = function () {
	            clearTimeout(_this.playback.setTimeoutReference);
	            _this.playback.isPlaying = false;
	            _this.forceUpdate(); // refresh immediately to show new play button status, needed becuase we are cheating and not modifying props
	        };
	        this.startPlayback = function () {
	            _this.playback.isPlaying = true;
	            _this.playUntilEnd();
	            _this.forceUpdate();
	        };
	        this.selectHistory = function (e) {
	            console.log(e);
	            console.log('here');
	            _this.props.dispatch(Actions.selectHistory(parseInt(e.target.value, 10)));
	        };
	        this.changeHistory = function (step) {
	            var selected = _this.props.stateHistory.current + step;
	            // Upper & lower bound
	            if (selected > _this.props.stateHistory.history.length - 1) {
	                selected = _this.props.stateHistory.history.length - 1;
	            } else if (selected < 1) {
	                selected = 1;
	            }
	            _this.props.dispatch(Actions.selectHistory(selected));
	        };
	        /**
	         * Read uploaded json file and dispatch action
	         */
	        this.uploadHistory = function (files) {
	            var blob = files[0].slice(0);
	            var reader = new FileReader();
	            reader.onloadend = function () {
	                var json = JSON.parse(reader.result);
	                _this.props.dispatch(Actions.uploadHistory(json));
	            };
	            reader.readAsText(blob);
	        };
	    }
	
	    _createClass(Component, [{
	        key: 'downloadHistory',
	        value: function downloadHistory(e) {
	            e.target.href = 'data:text/json;charset=utf-8, ' + encodeURIComponent(JSON.stringify(this.props.stateHistory));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            console.log('everything fine here?');
	            return React.createElement("div", { "style": Component.styles.container }, React.createElement("div", null, React.createElement("div", { "style": { float: 'right' } }, React.createElement("span", { "style": this.playback.isPlaying ? { marginRight: '10px', display: 'inline-block' } : {} }, this.playback.isPlaying && this.currentTime() + 's|' + this.totalTime() + 's'), this.props.stateHistory.current, " / ", this.props.stateHistory.history.length - 1, "     ", React.createElement("button", { "onClick": this.changeHistory.bind(this, -1), "title": 'Previous state', "style": this.playback.isPlaying || this.props.stateHistory.current <= 1 ? Object.assign({}, Component.styles.button, Component.styles.disabled) : Component.styles.button }, '<'), "  ", React.createElement("button", { "onClick": this.changeHistory.bind(this, 1), "title": 'Next state', "style": this.playback.isPlaying || this.props.stateHistory.current >= this.props.stateHistory.history.length - 1 ? Object.assign({}, Component.styles.button, Component.styles.disabled) : Component.styles.button }, '>'), "  ", React.createElement("button", { "onClick": this.playback.isPlaying ? this.stopPlackback : this.startPlayback, "title": 'Realtime Playblack', "style": this.props.stateHistory.current >= this.props.stateHistory.history.length - 1 ? Object.assign({}, Component.styles.button, Component.styles.disabled) : Component.styles.button }, this.playback.isPlaying ? '■' : '▸'), "  ", React.createElement("a", { "href": '#', "onClick": this.downloadHistory.bind(this), "download": 'state.json', "title": 'Download state', "style": Object.assign({}, Component.styles.button, Component.styles.blueBg, Component.styles.links) }, "⇓"), "  ", React.createElement(Dropzone, { "multiple": false, "title": 'Upload state', "onDrop": this.uploadHistory, "style": Object.assign({ float: 'right' }, Component.styles.button, Component.styles.clipboard) }, "⇧")), React.createElement("div", { "style": { width: 'auto', overflow: 'hidden', paddingRight: '19px' } }, React.createElement("input", { "type": 'range', "step": 1, "min": 1, "style": Component.styles.input, "max": this.props.stateHistory.history.length - 1, "value": '' + this.props.stateHistory.current, "onChange": this.selectHistory.bind(this) })), React.createElement("div", { "style": Component.styles.actions }, this.props.stateHistory.actions[this.props.stateHistory.current])));
	        }
	    }]);
	
	    return Component;
	})(React.Component);
	
	Component.styles = {
	    button: {
	        backgroundColor: '#518D21',
	        borderRadius: '3px',
	        border: '1px solid rgba(255, 255, 255, 0.2)',
	        fontSize: '20px',
	        width: '26px',
	        height: '22px',
	        lineHeight: '20px',
	        fontWeight: 'bold',
	        padding: '0px 1px',
	        boxSizing: 'content-box',
	        color: 'white',
	        textAlign: 'center',
	        cursor: 'pointer'
	    },
	    disabled: {
	        backgroundColor: 'rgb(102, 102, 102)',
	        cursor: 'default'
	    },
	    input: {
	        margin: '4px 0px',
	        outline: 'none',
	        border: 'none',
	        overflow: 'hidden',
	        width: '100%',
	        height: '16px'
	    },
	    blueBg: {
	        backgroundColor: 'rgb(33, 122, 141)'
	    },
	    clipboard: {
	        backgroundColor: 'transparent',
	        // color: 'rgb(33, 122, 141)',
	        color: '#6FB3D2',
	        borderColor: '#6FB3D2',
	        borderStyle: 'dashed'
	    },
	    container: {
	        width: '100%',
	        position: 'fixed',
	        bottom: 0,
	        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.3)',
	        backgroundColor: '#2A2F3A',
	        // maxWidth: '1000px',
	        color: 'white',
	        padding: '12px 12px 8px',
	        left: 0,
	        boxSizing: 'border-box',
	        zIndex: 1000
	    },
	    links: {
	        padding: '0px 6px'
	    },
	    actions: {
	        fontSize: 'smaller',
	        float: 'right',
	        marginTop: '6px'
	    }
	};
	exports['default'] = react_redux_1.connect(selectState)(Component);

/***/ },
/* 1701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var jsonDiffPatch = __webpack_require__(163);
	var initialState = {
	    stateHistory: {
	        history: [],
	        timestamps: [],
	        actions: [],
	        current: -1
	    }
	};
	function calculateDiff(lhs, rhs) {
	    var removeKeys = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];
	
	    var lhsClone = Object.assign({}, lhs);
	    var rhsClone = Object.assign({}, rhs);
	    removeKeys.forEach(function (key) {
	        delete lhsClone[key];delete rhsClone[key];
	    });
	    return jsonDiffPatch.diff(lhsClone, rhsClone);
	}
	/**
	 * Store enhancer that adds state history (stored within the state)
	 */
	var trackHistoryStoreEnhancer = function trackHistoryStoreEnhancer() {
	    var hydratingState = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	    return function (createStore) {
	        return function (reducer) {
	            var state = arguments.length <= 1 || arguments[1] === undefined ? hydratingState : arguments[1];
	            return createStore(trackReducerChanges(reducer, state));
	        };
	    };
	};
	/**
	 * Higher-order reducer-wrapper to log all state changes generated by said reducer
	 *
	 * TODO: When hydrateState is passed, we replace the history state by the given one after the first reducer has run
	 */
	function trackReducerChanges(reducer) {
	    var hydrateState = arguments.length <= 1 || arguments[1] === undefined ? initialState : arguments[1];
	
	    return function (state, action) {
	        if (state === undefined) state = hydrateState;
	
	        // Compute new state after applying reducer
	        var newAppState = reducer(state, action);
	        // Nothing to do if the two states match (by reference)
	        if (state === newAppState) {
	            return newAppState;
	        }
	        // Do nothing if the action has special flagged (used by debug tools)
	        // Instead of this we could compare to see if the state is unchanged on the non-tracking part, but this might be too expensive
	        if (action.meta === 'SKIP_HISTORY_TRACKING') {
	            return newAppState;
	        }
	        // Calculate the delta of the state (ignoring the stateHistory key)
	        var delta = calculateDiff(state, newAppState, ['stateHistory']);
	        // Do nothing if delta is null
	        if (typeof delta === 'undefined') {
	            return newAppState;
	        }
	        // Update the newAppState
	        // Note: The only way to do this properly is to use an immutable library like ImmutableJS that will do a complete recursive deep
	        //       cloning of the history field. However, for our purposes as long as we shallow clone history we are fine because nothing
	        //       will write to its subproperties
	        var clonedState = Object.assign({}, newAppState, {
	            stateHistory: Object.assign({}, newAppState.stateHistory, {
	                history: Object.assign([], newAppState.stateHistory.history),
	                timestamps: Object.assign([], newAppState.stateHistory.timestamps),
	                actions: Object.assign([], newAppState.stateHistory.actions),
	                current: newAppState.stateHistory.current
	            })
	        });
	        clonedState.stateHistory.history.push(delta);
	        clonedState.stateHistory.timestamps.push(Date.now());
	        clonedState.stateHistory.actions.push(action.type);
	        clonedState.stateHistory.current++;
	        return clonedState;
	    };
	}
	exports['default'] = trackHistoryStoreEnhancer;

/***/ },
/* 1702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Actions = __webpack_require__(544);
	var jsonDiffPatch = __webpack_require__(163);
	var extend = __webpack_require__(976);
	var initialState = {
	    stateHistory: {
	        history: [],
	        timestamps: [],
	        actions: [],
	        current: -1
	    }
	};
	function mergeDiff(target, diff) {
	    jsonDiffPatch.patch(target, diff);
	    return target;
	}
	function rebuildState(history, position) {
	    return history.slice(0, position + 1).map(function (hydratingState) {
	        return extend(true, {}, hydratingState);
	    }).reduce(function (hydratingState, diff) {
	        return mergeDiff(hydratingState, diff);
	    }, {});
	}
	function selectHistory(state, action) {
	    if (state === undefined) state = initialState;
	
	    switch (action.type) {
	        case Actions.SELECT_HISTORY:
	            // Do nothing if the payload is 0 or less
	            if (action.payload <= 0) {
	                return state;
	            }
	            // We need to rebuild the regular state and append the updated history control
	            var newState = rebuildState(state.stateHistory.history, action.payload);
	            return extend(true, {}, newState, { stateHistory: state.stateHistory }, { stateHistory: { current: action.payload } });
	        default:
	            return state;
	    }
	}
	exports.selectHistory = selectHistory;
	;
	function uploadHistory(state, action) {
	    if (state === undefined) state = initialState;
	
	    switch (action.type) {
	        case Actions.UPLOAD_HISTORY:
	            var newState = rebuildState(action.payload.history, action.payload.history.length);
	            return Object.assign({}, newState, {
	                stateHistory: action.payload
	            });
	        default:
	            return state;
	    }
	}
	var reducerReducer = function reducerReducer(reducers, state, action) {
	    return reducers.reduce(function (previousState, reducer) {
	        return reducer(previousState, action);
	    }, state);
	};
	/**
	 * Add history module reducers to the root reducer
	 */
	function addExtraReducers(reducer) {
	    return function (state, action) {
	        return reducerReducer([uploadHistory, selectHistory, reducer], state, action);
	    };
	}
	exports.addExtraReducers = addExtraReducers;
	/**
	 * Store enhancer that adds state history (stored within the state)
	 */
	var debugStateHistory = function debugStateHistory(createStore) {
	    return function (reducer, state) {
	        return createStore(addExtraReducers(reducer), state);
	    };
	}; // Return an IReduxCreateStore
	exports['default'] = debugStateHistory;

/***/ },
/* 1703 */
/***/ function(module, exports, __webpack_require__) {

	/// <reference path="../typings/tsd.d.ts" />
	'use strict';
	
	var Reducer_1 = __webpack_require__(1702);
	exports.Devtool = Reducer_1['default'];
	var Component_1 = __webpack_require__(1700);
	exports.Component = Component_1['default'];
	var Middleware_1 = __webpack_require__(1701);
	exports.stateHistoryTracker = Middleware_1['default'];

/***/ },
/* 1704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(545);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 1705 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 1706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(351);
	
	var _isPlainObject = __webpack_require__(78);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(546);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 1707 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(152);
	var callBind = __webpack_require__(975);
	
	var implementation = __webpack_require__(547);
	var getPolyfill = __webpack_require__(548);
	var shim = __webpack_require__(1709);
	
	var flagsBound = callBind(implementation);
	
	define(flagsBound, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = flagsBound;


/***/ },
/* 1709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var supportsDescriptors = __webpack_require__(152).supportsDescriptors;
	var getPolyfill = __webpack_require__(548);
	var gOPD = Object.getOwnPropertyDescriptor;
	var defineProperty = Object.defineProperty;
	var TypeErr = TypeError;
	var getProto = Object.getPrototypeOf;
	var regex = /a/;
	
	module.exports = function shimFlags() {
		if (!supportsDescriptors || !getProto) {
			throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		var polyfill = getPolyfill();
		var proto = getProto(regex);
		var descriptor = gOPD(proto, 'flags');
		if (!descriptor || descriptor.get !== polyfill) {
			defineProperty(proto, 'flags', {
				configurable: true,
				enumerable: false,
				get: polyfill
			});
		}
		return polyfill;
	};


/***/ },
/* 1710 */
/***/ function(module, exports) {

	function select(element) {
	    var selectedText;
	
	    if (element.nodeName === 'SELECT') {
	        element.focus();
	
	        selectedText = element.value;
	    }
	    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
	        var isReadOnly = element.hasAttribute('readonly');
	
	        if (!isReadOnly) {
	            element.setAttribute('readonly', '');
	        }
	
	        element.select();
	        element.setSelectionRange(0, element.value.length);
	
	        if (!isReadOnly) {
	            element.removeAttribute('readonly');
	        }
	
	        selectedText = element.value;
	    }
	    else {
	        if (element.hasAttribute('contenteditable')) {
	            element.focus();
	        }
	
	        var selection = window.getSelection();
	        var range = document.createRange();
	
	        range.selectNodeContents(element);
	        selection.removeAllRanges();
	        selection.addRange(range);
	
	        selectedText = selection.toString();
	    }
	
	    return selectedText;
	}
	
	module.exports = select;


/***/ },
/* 1711 */
/***/ function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var intToCharMap = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');
	
	/**
	 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
	 */
	exports.encode = function (number) {
	  if (0 <= number && number < intToCharMap.length) {
	    return intToCharMap[number];
	  }
	  throw new TypeError("Must be between 0 and 63: " + number);
	};
	
	/**
	 * Decode a single base 64 character code digit to an integer. Returns -1 on
	 * failure.
	 */
	exports.decode = function (charCode) {
	  var bigA = 65;     // 'A'
	  var bigZ = 90;     // 'Z'
	
	  var littleA = 97;  // 'a'
	  var littleZ = 122; // 'z'
	
	  var zero = 48;     // '0'
	  var nine = 57;     // '9'
	
	  var plus = 43;     // '+'
	  var slash = 47;    // '/'
	
	  var littleOffset = 26;
	  var numberOffset = 52;
	
	  // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
	  if (bigA <= charCode && charCode <= bigZ) {
	    return (charCode - bigA);
	  }
	
	  // 26 - 51: abcdefghijklmnopqrstuvwxyz
	  if (littleA <= charCode && charCode <= littleZ) {
	    return (charCode - littleA + littleOffset);
	  }
	
	  // 52 - 61: 0123456789
	  if (zero <= charCode && charCode <= nine) {
	    return (charCode - zero + numberOffset);
	  }
	
	  // 62: +
	  if (charCode == plus) {
	    return 62;
	  }
	
	  // 63: /
	  if (charCode == slash) {
	    return 63;
	  }
	
	  // Invalid base64 digit.
	  return -1;
	};


/***/ },
/* 1712 */
/***/ function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	exports.GREATEST_LOWER_BOUND = 1;
	exports.LEAST_UPPER_BOUND = 2;
	
	/**
	 * Recursive implementation of binary search.
	 *
	 * @param aLow Indices here and lower do not contain the needle.
	 * @param aHigh Indices here and higher do not contain the needle.
	 * @param aNeedle The element being searched for.
	 * @param aHaystack The non-empty array being searched.
	 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
	 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
	 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 */
	function recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
	  // This function terminates when one of the following is true:
	  //
	  //   1. We find the exact element we are looking for.
	  //
	  //   2. We did not find the exact element, but we can return the index of
	  //      the next-closest element.
	  //
	  //   3. We did not find the exact element, and there is no next-closest
	  //      element than the one we are searching for, so we return -1.
	  var mid = Math.floor((aHigh - aLow) / 2) + aLow;
	  var cmp = aCompare(aNeedle, aHaystack[mid], true);
	  if (cmp === 0) {
	    // Found the element we are looking for.
	    return mid;
	  }
	  else if (cmp > 0) {
	    // Our needle is greater than aHaystack[mid].
	    if (aHigh - mid > 1) {
	      // The element is in the upper half.
	      return recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
	    }
	
	    // The exact needle element was not found in this haystack. Determine if
	    // we are in termination case (3) or (2) and return the appropriate thing.
	    if (aBias == exports.LEAST_UPPER_BOUND) {
	      return aHigh < aHaystack.length ? aHigh : -1;
	    } else {
	      return mid;
	    }
	  }
	  else {
	    // Our needle is less than aHaystack[mid].
	    if (mid - aLow > 1) {
	      // The element is in the lower half.
	      return recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
	    }
	
	    // we are in termination case (3) or (2) and return the appropriate thing.
	    if (aBias == exports.LEAST_UPPER_BOUND) {
	      return mid;
	    } else {
	      return aLow < 0 ? -1 : aLow;
	    }
	  }
	}
	
	/**
	 * This is an implementation of binary search which will always try and return
	 * the index of the closest element if there is no exact hit. This is because
	 * mappings between original and generated line/col pairs are single points,
	 * and there is an implicit region between each of them, so a miss just means
	 * that you aren't on the very start of a region.
	 *
	 * @param aNeedle The element you are looking for.
	 * @param aHaystack The array that is being searched.
	 * @param aCompare A function which takes the needle and an element in the
	 *     array and returns -1, 0, or 1 depending on whether the needle is less
	 *     than, equal to, or greater than the element, respectively.
	 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
	 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
	 */
	exports.search = function search(aNeedle, aHaystack, aCompare, aBias) {
	  if (aHaystack.length === 0) {
	    return -1;
	  }
	
	  var index = recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack,
	                              aCompare, aBias || exports.GREATEST_LOWER_BOUND);
	  if (index < 0) {
	    return -1;
	  }
	
	  // We have found either the exact element, or the next-closest element than
	  // the one we are searching for. However, there may be more than one such
	  // element. Make sure we always return the smallest of these.
	  while (index - 1 >= 0) {
	    if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) {
	      break;
	    }
	    --index;
	  }
	
	  return index;
	};


/***/ },
/* 1713 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2014 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var util = __webpack_require__(178);
	
	/**
	 * Determine whether mappingB is after mappingA with respect to generated
	 * position.
	 */
	function generatedPositionAfter(mappingA, mappingB) {
	  // Optimized for most common case
	  var lineA = mappingA.generatedLine;
	  var lineB = mappingB.generatedLine;
	  var columnA = mappingA.generatedColumn;
	  var columnB = mappingB.generatedColumn;
	  return lineB > lineA || lineB == lineA && columnB >= columnA ||
	         util.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
	}
	
	/**
	 * A data structure to provide a sorted view of accumulated mappings in a
	 * performance conscious manner. It trades a neglibable overhead in general
	 * case for a large speedup in case of mappings being added in order.
	 */
	function MappingList() {
	  this._array = [];
	  this._sorted = true;
	  // Serves as infimum
	  this._last = {generatedLine: -1, generatedColumn: 0};
	}
	
	/**
	 * Iterate through internal items. This method takes the same arguments that
	 * `Array.prototype.forEach` takes.
	 *
	 * NOTE: The order of the mappings is NOT guaranteed.
	 */
	MappingList.prototype.unsortedForEach =
	  function MappingList_forEach(aCallback, aThisArg) {
	    this._array.forEach(aCallback, aThisArg);
	  };
	
	/**
	 * Add the given source mapping.
	 *
	 * @param Object aMapping
	 */
	MappingList.prototype.add = function MappingList_add(aMapping) {
	  if (generatedPositionAfter(this._last, aMapping)) {
	    this._last = aMapping;
	    this._array.push(aMapping);
	  } else {
	    this._sorted = false;
	    this._array.push(aMapping);
	  }
	};
	
	/**
	 * Returns the flat, sorted array of mappings. The mappings are sorted by
	 * generated position.
	 *
	 * WARNING: This method returns internal data without copying, for
	 * performance. The return value must NOT be mutated, and should be treated as
	 * an immutable borrow. If you want to take ownership, you must make your own
	 * copy.
	 */
	MappingList.prototype.toArray = function MappingList_toArray() {
	  if (!this._sorted) {
	    this._array.sort(util.compareByGeneratedPositionsInflated);
	    this._sorted = true;
	  }
	  return this._array;
	};
	
	exports.MappingList = MappingList;


/***/ },
/* 1714 */
/***/ function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	// It turns out that some (most?) JavaScript engines don't self-host
	// `Array.prototype.sort`. This makes sense because C++ will likely remain
	// faster than JS when doing raw CPU-intensive sorting. However, when using a
	// custom comparator function, calling back and forth between the VM's C++ and
	// JIT'd JS is rather slow *and* loses JIT type information, resulting in
	// worse generated code for the comparator function than would be optimal. In
	// fact, when sorting with a comparator, these costs outweigh the benefits of
	// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
	// a ~3500ms mean speed-up in `bench/bench.html`.
	
	/**
	 * Swap the elements indexed by `x` and `y` in the array `ary`.
	 *
	 * @param {Array} ary
	 *        The array.
	 * @param {Number} x
	 *        The index of the first item.
	 * @param {Number} y
	 *        The index of the second item.
	 */
	function swap(ary, x, y) {
	  var temp = ary[x];
	  ary[x] = ary[y];
	  ary[y] = temp;
	}
	
	/**
	 * Returns a random integer within the range `low .. high` inclusive.
	 *
	 * @param {Number} low
	 *        The lower bound on the range.
	 * @param {Number} high
	 *        The upper bound on the range.
	 */
	function randomIntInRange(low, high) {
	  return Math.round(low + (Math.random() * (high - low)));
	}
	
	/**
	 * The Quick Sort algorithm.
	 *
	 * @param {Array} ary
	 *        An array to sort.
	 * @param {function} comparator
	 *        Function to use to compare two items.
	 * @param {Number} p
	 *        Start index of the array
	 * @param {Number} r
	 *        End index of the array
	 */
	function doQuickSort(ary, comparator, p, r) {
	  // If our lower bound is less than our upper bound, we (1) partition the
	  // array into two pieces and (2) recurse on each half. If it is not, this is
	  // the empty array and our base case.
	
	  if (p < r) {
	    // (1) Partitioning.
	    //
	    // The partitioning chooses a pivot between `p` and `r` and moves all
	    // elements that are less than or equal to the pivot to the before it, and
	    // all the elements that are greater than it after it. The effect is that
	    // once partition is done, the pivot is in the exact place it will be when
	    // the array is put in sorted order, and it will not need to be moved
	    // again. This runs in O(n) time.
	
	    // Always choose a random pivot so that an input array which is reverse
	    // sorted does not cause O(n^2) running time.
	    var pivotIndex = randomIntInRange(p, r);
	    var i = p - 1;
	
	    swap(ary, pivotIndex, r);
	    var pivot = ary[r];
	
	    // Immediately after `j` is incremented in this loop, the following hold
	    // true:
	    //
	    //   * Every element in `ary[p .. i]` is less than or equal to the pivot.
	    //
	    //   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
	    for (var j = p; j < r; j++) {
	      if (comparator(ary[j], pivot) <= 0) {
	        i += 1;
	        swap(ary, i, j);
	      }
	    }
	
	    swap(ary, i + 1, j);
	    var q = i + 1;
	
	    // (2) Recurse on each half.
	
	    doQuickSort(ary, comparator, p, q - 1);
	    doQuickSort(ary, comparator, q + 1, r);
	  }
	}
	
	/**
	 * Sort the given array in-place with the given comparator function.
	 *
	 * @param {Array} ary
	 *        An array to sort.
	 * @param {function} comparator
	 *        Function to use to compare two items.
	 */
	exports.quickSort = function (ary, comparator) {
	  doQuickSort(ary, comparator, 0, ary.length - 1);
	};


/***/ },
/* 1715 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var util = __webpack_require__(178);
	var binarySearch = __webpack_require__(1712);
	var ArraySet = __webpack_require__(549).ArraySet;
	var base64VLQ = __webpack_require__(550);
	var quickSort = __webpack_require__(1714).quickSort;
	
	function SourceMapConsumer(aSourceMap) {
	  var sourceMap = aSourceMap;
	  if (typeof aSourceMap === 'string') {
	    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
	  }
	
	  return sourceMap.sections != null
	    ? new IndexedSourceMapConsumer(sourceMap)
	    : new BasicSourceMapConsumer(sourceMap);
	}
	
	SourceMapConsumer.fromSourceMap = function(aSourceMap) {
	  return BasicSourceMapConsumer.fromSourceMap(aSourceMap);
	}
	
	/**
	 * The version of the source mapping spec that we are consuming.
	 */
	SourceMapConsumer.prototype._version = 3;
	
	// `__generatedMappings` and `__originalMappings` are arrays that hold the
	// parsed mapping coordinates from the source map's "mappings" attribute. They
	// are lazily instantiated, accessed via the `_generatedMappings` and
	// `_originalMappings` getters respectively, and we only parse the mappings
	// and create these arrays once queried for a source location. We jump through
	// these hoops because there can be many thousands of mappings, and parsing
	// them is expensive, so we only want to do it if we must.
	//
	// Each object in the arrays is of the form:
	//
	//     {
	//       generatedLine: The line number in the generated code,
	//       generatedColumn: The column number in the generated code,
	//       source: The path to the original source file that generated this
	//               chunk of code,
	//       originalLine: The line number in the original source that
	//                     corresponds to this chunk of generated code,
	//       originalColumn: The column number in the original source that
	//                       corresponds to this chunk of generated code,
	//       name: The name of the original symbol which generated this chunk of
	//             code.
	//     }
	//
	// All properties except for `generatedLine` and `generatedColumn` can be
	// `null`.
	//
	// `_generatedMappings` is ordered by the generated positions.
	//
	// `_originalMappings` is ordered by the original positions.
	
	SourceMapConsumer.prototype.__generatedMappings = null;
	Object.defineProperty(SourceMapConsumer.prototype, '_generatedMappings', {
	  get: function () {
	    if (!this.__generatedMappings) {
	      this._parseMappings(this._mappings, this.sourceRoot);
	    }
	
	    return this.__generatedMappings;
	  }
	});
	
	SourceMapConsumer.prototype.__originalMappings = null;
	Object.defineProperty(SourceMapConsumer.prototype, '_originalMappings', {
	  get: function () {
	    if (!this.__originalMappings) {
	      this._parseMappings(this._mappings, this.sourceRoot);
	    }
	
	    return this.__originalMappings;
	  }
	});
	
	SourceMapConsumer.prototype._charIsMappingSeparator =
	  function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
	    var c = aStr.charAt(index);
	    return c === ";" || c === ",";
	  };
	
	/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */
	SourceMapConsumer.prototype._parseMappings =
	  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
	    throw new Error("Subclasses must implement _parseMappings");
	  };
	
	SourceMapConsumer.GENERATED_ORDER = 1;
	SourceMapConsumer.ORIGINAL_ORDER = 2;
	
	SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
	SourceMapConsumer.LEAST_UPPER_BOUND = 2;
	
	/**
	 * Iterate over each mapping between an original source/line/column and a
	 * generated line/column in this source map.
	 *
	 * @param Function aCallback
	 *        The function that is called with each mapping.
	 * @param Object aContext
	 *        Optional. If specified, this object will be the value of `this` every
	 *        time that `aCallback` is called.
	 * @param aOrder
	 *        Either `SourceMapConsumer.GENERATED_ORDER` or
	 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
	 *        iterate over the mappings sorted by the generated file's line/column
	 *        order or the original's source/line/column order, respectively. Defaults to
	 *        `SourceMapConsumer.GENERATED_ORDER`.
	 */
	SourceMapConsumer.prototype.eachMapping =
	  function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
	    var context = aContext || null;
	    var order = aOrder || SourceMapConsumer.GENERATED_ORDER;
	
	    var mappings;
	    switch (order) {
	    case SourceMapConsumer.GENERATED_ORDER:
	      mappings = this._generatedMappings;
	      break;
	    case SourceMapConsumer.ORIGINAL_ORDER:
	      mappings = this._originalMappings;
	      break;
	    default:
	      throw new Error("Unknown order of iteration.");
	    }
	
	    var sourceRoot = this.sourceRoot;
	    mappings.map(function (mapping) {
	      var source = mapping.source === null ? null : this._sources.at(mapping.source);
	      if (source != null && sourceRoot != null) {
	        source = util.join(sourceRoot, source);
	      }
	      return {
	        source: source,
	        generatedLine: mapping.generatedLine,
	        generatedColumn: mapping.generatedColumn,
	        originalLine: mapping.originalLine,
	        originalColumn: mapping.originalColumn,
	        name: mapping.name === null ? null : this._names.at(mapping.name)
	      };
	    }, this).forEach(aCallback, context);
	  };
	
	/**
	 * Returns all generated line and column information for the original source,
	 * line, and column provided. If no column is provided, returns all mappings
	 * corresponding to a either the line we are searching for or the next
	 * closest line that has any mappings. Otherwise, returns all mappings
	 * corresponding to the given line and either the column we are searching for
	 * or the next closest column that has any offsets.
	 *
	 * The only argument is an object with the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.
	 *   - column: Optional. the column number in the original source.
	 *
	 * and an array of objects is returned, each with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.
	 *   - column: The column number in the generated source, or null.
	 */
	SourceMapConsumer.prototype.allGeneratedPositionsFor =
	  function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
	    var line = util.getArg(aArgs, 'line');
	
	    // When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
	    // returns the index of the closest mapping less than the needle. By
	    // setting needle.originalColumn to 0, we thus find the last mapping for
	    // the given line, provided such a mapping exists.
	    var needle = {
	      source: util.getArg(aArgs, 'source'),
	      originalLine: line,
	      originalColumn: util.getArg(aArgs, 'column', 0)
	    };
	
	    if (this.sourceRoot != null) {
	      needle.source = util.relative(this.sourceRoot, needle.source);
	    }
	    if (!this._sources.has(needle.source)) {
	      return [];
	    }
	    needle.source = this._sources.indexOf(needle.source);
	
	    var mappings = [];
	
	    var index = this._findMapping(needle,
	                                  this._originalMappings,
	                                  "originalLine",
	                                  "originalColumn",
	                                  util.compareByOriginalPositions,
	                                  binarySearch.LEAST_UPPER_BOUND);
	    if (index >= 0) {
	      var mapping = this._originalMappings[index];
	
	      if (aArgs.column === undefined) {
	        var originalLine = mapping.originalLine;
	
	        // Iterate until either we run out of mappings, or we run into
	        // a mapping for a different line than the one we found. Since
	        // mappings are sorted, this is guaranteed to find all mappings for
	        // the line we found.
	        while (mapping && mapping.originalLine === originalLine) {
	          mappings.push({
	            line: util.getArg(mapping, 'generatedLine', null),
	            column: util.getArg(mapping, 'generatedColumn', null),
	            lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
	          });
	
	          mapping = this._originalMappings[++index];
	        }
	      } else {
	        var originalColumn = mapping.originalColumn;
	
	        // Iterate until either we run out of mappings, or we run into
	        // a mapping for a different line than the one we were searching for.
	        // Since mappings are sorted, this is guaranteed to find all mappings for
	        // the line we are searching for.
	        while (mapping &&
	               mapping.originalLine === line &&
	               mapping.originalColumn == originalColumn) {
	          mappings.push({
	            line: util.getArg(mapping, 'generatedLine', null),
	            column: util.getArg(mapping, 'generatedColumn', null),
	            lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
	          });
	
	          mapping = this._originalMappings[++index];
	        }
	      }
	    }
	
	    return mappings;
	  };
	
	exports.SourceMapConsumer = SourceMapConsumer;
	
	/**
	 * A BasicSourceMapConsumer instance represents a parsed source map which we can
	 * query for information about the original file positions by giving it a file
	 * position in the generated source.
	 *
	 * The only parameter is the raw source map (either as a JSON string, or
	 * already parsed to an object). According to the spec, source maps have the
	 * following attributes:
	 *
	 *   - version: Which version of the source map spec this map is following.
	 *   - sources: An array of URLs to the original source files.
	 *   - names: An array of identifiers which can be referrenced by individual mappings.
	 *   - sourceRoot: Optional. The URL root from which all sources are relative.
	 *   - sourcesContent: Optional. An array of contents of the original source files.
	 *   - mappings: A string of base64 VLQs which contain the actual mappings.
	 *   - file: Optional. The generated file this source map is associated with.
	 *
	 * Here is an example source map, taken from the source map spec[0]:
	 *
	 *     {
	 *       version : 3,
	 *       file: "out.js",
	 *       sourceRoot : "",
	 *       sources: ["foo.js", "bar.js"],
	 *       names: ["src", "maps", "are", "fun"],
	 *       mappings: "AA,AB;;ABCDE;"
	 *     }
	 *
	 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
	 */
	function BasicSourceMapConsumer(aSourceMap) {
	  var sourceMap = aSourceMap;
	  if (typeof aSourceMap === 'string') {
	    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
	  }
	
	  var version = util.getArg(sourceMap, 'version');
	  var sources = util.getArg(sourceMap, 'sources');
	  // Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
	  // requires the array) to play nice here.
	  var names = util.getArg(sourceMap, 'names', []);
	  var sourceRoot = util.getArg(sourceMap, 'sourceRoot', null);
	  var sourcesContent = util.getArg(sourceMap, 'sourcesContent', null);
	  var mappings = util.getArg(sourceMap, 'mappings');
	  var file = util.getArg(sourceMap, 'file', null);
	
	  // Once again, Sass deviates from the spec and supplies the version as a
	  // string rather than a number, so we use loose equality checking here.
	  if (version != this._version) {
	    throw new Error('Unsupported version: ' + version);
	  }
	
	  sources = sources
	    .map(String)
	    // Some source maps produce relative source paths like "./foo.js" instead of
	    // "foo.js".  Normalize these first so that future comparisons will succeed.
	    // See bugzil.la/1090768.
	    .map(util.normalize)
	    // Always ensure that absolute sources are internally stored relative to
	    // the source root, if the source root is absolute. Not doing this would
	    // be particularly problematic when the source root is a prefix of the
	    // source (valid, but why??). See github issue #199 and bugzil.la/1188982.
	    .map(function (source) {
	      return sourceRoot && util.isAbsolute(sourceRoot) && util.isAbsolute(source)
	        ? util.relative(sourceRoot, source)
	        : source;
	    });
	
	  // Pass `true` below to allow duplicate names and sources. While source maps
	  // are intended to be compressed and deduplicated, the TypeScript compiler
	  // sometimes generates source maps with duplicates in them. See Github issue
	  // #72 and bugzil.la/889492.
	  this._names = ArraySet.fromArray(names.map(String), true);
	  this._sources = ArraySet.fromArray(sources, true);
	
	  this.sourceRoot = sourceRoot;
	  this.sourcesContent = sourcesContent;
	  this._mappings = mappings;
	  this.file = file;
	}
	
	BasicSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
	BasicSourceMapConsumer.prototype.consumer = SourceMapConsumer;
	
	/**
	 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
	 *
	 * @param SourceMapGenerator aSourceMap
	 *        The source map that will be consumed.
	 * @returns BasicSourceMapConsumer
	 */
	BasicSourceMapConsumer.fromSourceMap =
	  function SourceMapConsumer_fromSourceMap(aSourceMap) {
	    var smc = Object.create(BasicSourceMapConsumer.prototype);
	
	    var names = smc._names = ArraySet.fromArray(aSourceMap._names.toArray(), true);
	    var sources = smc._sources = ArraySet.fromArray(aSourceMap._sources.toArray(), true);
	    smc.sourceRoot = aSourceMap._sourceRoot;
	    smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(),
	                                                            smc.sourceRoot);
	    smc.file = aSourceMap._file;
	
	    // Because we are modifying the entries (by converting string sources and
	    // names to indices into the sources and names ArraySets), we have to make
	    // a copy of the entry or else bad things happen. Shared mutable state
	    // strikes again! See github issue #191.
	
	    var generatedMappings = aSourceMap._mappings.toArray().slice();
	    var destGeneratedMappings = smc.__generatedMappings = [];
	    var destOriginalMappings = smc.__originalMappings = [];
	
	    for (var i = 0, length = generatedMappings.length; i < length; i++) {
	      var srcMapping = generatedMappings[i];
	      var destMapping = new Mapping;
	      destMapping.generatedLine = srcMapping.generatedLine;
	      destMapping.generatedColumn = srcMapping.generatedColumn;
	
	      if (srcMapping.source) {
	        destMapping.source = sources.indexOf(srcMapping.source);
	        destMapping.originalLine = srcMapping.originalLine;
	        destMapping.originalColumn = srcMapping.originalColumn;
	
	        if (srcMapping.name) {
	          destMapping.name = names.indexOf(srcMapping.name);
	        }
	
	        destOriginalMappings.push(destMapping);
	      }
	
	      destGeneratedMappings.push(destMapping);
	    }
	
	    quickSort(smc.__originalMappings, util.compareByOriginalPositions);
	
	    return smc;
	  };
	
	/**
	 * The version of the source mapping spec that we are consuming.
	 */
	BasicSourceMapConsumer.prototype._version = 3;
	
	/**
	 * The list of original sources.
	 */
	Object.defineProperty(BasicSourceMapConsumer.prototype, 'sources', {
	  get: function () {
	    return this._sources.toArray().map(function (s) {
	      return this.sourceRoot != null ? util.join(this.sourceRoot, s) : s;
	    }, this);
	  }
	});
	
	/**
	 * Provide the JIT with a nice shape / hidden class.
	 */
	function Mapping() {
	  this.generatedLine = 0;
	  this.generatedColumn = 0;
	  this.source = null;
	  this.originalLine = null;
	  this.originalColumn = null;
	  this.name = null;
	}
	
	/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */
	BasicSourceMapConsumer.prototype._parseMappings =
	  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
	    var generatedLine = 1;
	    var previousGeneratedColumn = 0;
	    var previousOriginalLine = 0;
	    var previousOriginalColumn = 0;
	    var previousSource = 0;
	    var previousName = 0;
	    var length = aStr.length;
	    var index = 0;
	    var cachedSegments = {};
	    var temp = {};
	    var originalMappings = [];
	    var generatedMappings = [];
	    var mapping, str, segment, end, value;
	
	    while (index < length) {
	      if (aStr.charAt(index) === ';') {
	        generatedLine++;
	        index++;
	        previousGeneratedColumn = 0;
	      }
	      else if (aStr.charAt(index) === ',') {
	        index++;
	      }
	      else {
	        mapping = new Mapping();
	        mapping.generatedLine = generatedLine;
	
	        // Because each offset is encoded relative to the previous one,
	        // many segments often have the same encoding. We can exploit this
	        // fact by caching the parsed variable length fields of each segment,
	        // allowing us to avoid a second parse if we encounter the same
	        // segment again.
	        for (end = index; end < length; end++) {
	          if (this._charIsMappingSeparator(aStr, end)) {
	            break;
	          }
	        }
	        str = aStr.slice(index, end);
	
	        segment = cachedSegments[str];
	        if (segment) {
	          index += str.length;
	        } else {
	          segment = [];
	          while (index < end) {
	            base64VLQ.decode(aStr, index, temp);
	            value = temp.value;
	            index = temp.rest;
	            segment.push(value);
	          }
	
	          if (segment.length === 2) {
	            throw new Error('Found a source, but no line and column');
	          }
	
	          if (segment.length === 3) {
	            throw new Error('Found a source and line, but no column');
	          }
	
	          cachedSegments[str] = segment;
	        }
	
	        // Generated column.
	        mapping.generatedColumn = previousGeneratedColumn + segment[0];
	        previousGeneratedColumn = mapping.generatedColumn;
	
	        if (segment.length > 1) {
	          // Original source.
	          mapping.source = previousSource + segment[1];
	          previousSource += segment[1];
	
	          // Original line.
	          mapping.originalLine = previousOriginalLine + segment[2];
	          previousOriginalLine = mapping.originalLine;
	          // Lines are stored 0-based
	          mapping.originalLine += 1;
	
	          // Original column.
	          mapping.originalColumn = previousOriginalColumn + segment[3];
	          previousOriginalColumn = mapping.originalColumn;
	
	          if (segment.length > 4) {
	            // Original name.
	            mapping.name = previousName + segment[4];
	            previousName += segment[4];
	          }
	        }
	
	        generatedMappings.push(mapping);
	        if (typeof mapping.originalLine === 'number') {
	          originalMappings.push(mapping);
	        }
	      }
	    }
	
	    quickSort(generatedMappings, util.compareByGeneratedPositionsDeflated);
	    this.__generatedMappings = generatedMappings;
	
	    quickSort(originalMappings, util.compareByOriginalPositions);
	    this.__originalMappings = originalMappings;
	  };
	
	/**
	 * Find the mapping that best matches the hypothetical "needle" mapping that
	 * we are searching for in the given "haystack" of mappings.
	 */
	BasicSourceMapConsumer.prototype._findMapping =
	  function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName,
	                                         aColumnName, aComparator, aBias) {
	    // To return the position we are searching for, we must first find the
	    // mapping for the given position and then return the opposite position it
	    // points to. Because the mappings are sorted, we can use binary search to
	    // find the best mapping.
	
	    if (aNeedle[aLineName] <= 0) {
	      throw new TypeError('Line must be greater than or equal to 1, got '
	                          + aNeedle[aLineName]);
	    }
	    if (aNeedle[aColumnName] < 0) {
	      throw new TypeError('Column must be greater than or equal to 0, got '
	                          + aNeedle[aColumnName]);
	    }
	
	    return binarySearch.search(aNeedle, aMappings, aComparator, aBias);
	  };
	
	/**
	 * Compute the last column for each generated mapping. The last column is
	 * inclusive.
	 */
	BasicSourceMapConsumer.prototype.computeColumnSpans =
	  function SourceMapConsumer_computeColumnSpans() {
	    for (var index = 0; index < this._generatedMappings.length; ++index) {
	      var mapping = this._generatedMappings[index];
	
	      // Mappings do not contain a field for the last generated columnt. We
	      // can come up with an optimistic estimate, however, by assuming that
	      // mappings are contiguous (i.e. given two consecutive mappings, the
	      // first mapping ends where the second one starts).
	      if (index + 1 < this._generatedMappings.length) {
	        var nextMapping = this._generatedMappings[index + 1];
	
	        if (mapping.generatedLine === nextMapping.generatedLine) {
	          mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
	          continue;
	        }
	      }
	
	      // The last mapping for each line spans the entire line.
	      mapping.lastGeneratedColumn = Infinity;
	    }
	  };
	
	/**
	 * Returns the original source, line, and column information for the generated
	 * source's line and column positions provided. The only argument is an object
	 * with the following properties:
	 *
	 *   - line: The line number in the generated source.
	 *   - column: The column number in the generated source.
	 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
	 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - source: The original source file, or null.
	 *   - line: The line number in the original source, or null.
	 *   - column: The column number in the original source, or null.
	 *   - name: The original identifier, or null.
	 */
	BasicSourceMapConsumer.prototype.originalPositionFor =
	  function SourceMapConsumer_originalPositionFor(aArgs) {
	    var needle = {
	      generatedLine: util.getArg(aArgs, 'line'),
	      generatedColumn: util.getArg(aArgs, 'column')
	    };
	
	    var index = this._findMapping(
	      needle,
	      this._generatedMappings,
	      "generatedLine",
	      "generatedColumn",
	      util.compareByGeneratedPositionsDeflated,
	      util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
	    );
	
	    if (index >= 0) {
	      var mapping = this._generatedMappings[index];
	
	      if (mapping.generatedLine === needle.generatedLine) {
	        var source = util.getArg(mapping, 'source', null);
	        if (source !== null) {
	          source = this._sources.at(source);
	          if (this.sourceRoot != null) {
	            source = util.join(this.sourceRoot, source);
	          }
	        }
	        var name = util.getArg(mapping, 'name', null);
	        if (name !== null) {
	          name = this._names.at(name);
	        }
	        return {
	          source: source,
	          line: util.getArg(mapping, 'originalLine', null),
	          column: util.getArg(mapping, 'originalColumn', null),
	          name: name
	        };
	      }
	    }
	
	    return {
	      source: null,
	      line: null,
	      column: null,
	      name: null
	    };
	  };
	
	/**
	 * Return true if we have the source content for every source in the source
	 * map, false otherwise.
	 */
	BasicSourceMapConsumer.prototype.hasContentsOfAllSources =
	  function BasicSourceMapConsumer_hasContentsOfAllSources() {
	    if (!this.sourcesContent) {
	      return false;
	    }
	    return this.sourcesContent.length >= this._sources.size() &&
	      !this.sourcesContent.some(function (sc) { return sc == null; });
	  };
	
	/**
	 * Returns the original source content. The only argument is the url of the
	 * original source file. Returns null if no original source content is
	 * available.
	 */
	BasicSourceMapConsumer.prototype.sourceContentFor =
	  function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
	    if (!this.sourcesContent) {
	      return null;
	    }
	
	    if (this.sourceRoot != null) {
	      aSource = util.relative(this.sourceRoot, aSource);
	    }
	
	    if (this._sources.has(aSource)) {
	      return this.sourcesContent[this._sources.indexOf(aSource)];
	    }
	
	    var url;
	    if (this.sourceRoot != null
	        && (url = util.urlParse(this.sourceRoot))) {
	      // XXX: file:// URIs and absolute paths lead to unexpected behavior for
	      // many users. We can help them out when they expect file:// URIs to
	      // behave like it would if they were running a local HTTP server. See
	      // https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
	      var fileUriAbsPath = aSource.replace(/^file:\/\//, "");
	      if (url.scheme == "file"
	          && this._sources.has(fileUriAbsPath)) {
	        return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)]
	      }
	
	      if ((!url.path || url.path == "/")
	          && this._sources.has("/" + aSource)) {
	        return this.sourcesContent[this._sources.indexOf("/" + aSource)];
	      }
	    }
	
	    // This function is used recursively from
	    // IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
	    // don't want to throw if we can't find the source - we just want to
	    // return null, so we provide a flag to exit gracefully.
	    if (nullOnMissing) {
	      return null;
	    }
	    else {
	      throw new Error('"' + aSource + '" is not in the SourceMap.');
	    }
	  };
	
	/**
	 * Returns the generated line and column information for the original source,
	 * line, and column positions provided. The only argument is an object with
	 * the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.
	 *   - column: The column number in the original source.
	 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
	 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.
	 *   - column: The column number in the generated source, or null.
	 */
	BasicSourceMapConsumer.prototype.generatedPositionFor =
	  function SourceMapConsumer_generatedPositionFor(aArgs) {
	    var source = util.getArg(aArgs, 'source');
	    if (this.sourceRoot != null) {
	      source = util.relative(this.sourceRoot, source);
	    }
	    if (!this._sources.has(source)) {
	      return {
	        line: null,
	        column: null,
	        lastColumn: null
	      };
	    }
	    source = this._sources.indexOf(source);
	
	    var needle = {
	      source: source,
	      originalLine: util.getArg(aArgs, 'line'),
	      originalColumn: util.getArg(aArgs, 'column')
	    };
	
	    var index = this._findMapping(
	      needle,
	      this._originalMappings,
	      "originalLine",
	      "originalColumn",
	      util.compareByOriginalPositions,
	      util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
	    );
	
	    if (index >= 0) {
	      var mapping = this._originalMappings[index];
	
	      if (mapping.source === needle.source) {
	        return {
	          line: util.getArg(mapping, 'generatedLine', null),
	          column: util.getArg(mapping, 'generatedColumn', null),
	          lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
	        };
	      }
	    }
	
	    return {
	      line: null,
	      column: null,
	      lastColumn: null
	    };
	  };
	
	exports.BasicSourceMapConsumer = BasicSourceMapConsumer;
	
	/**
	 * An IndexedSourceMapConsumer instance represents a parsed source map which
	 * we can query for information. It differs from BasicSourceMapConsumer in
	 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
	 * input.
	 *
	 * The only parameter is a raw source map (either as a JSON string, or already
	 * parsed to an object). According to the spec for indexed source maps, they
	 * have the following attributes:
	 *
	 *   - version: Which version of the source map spec this map is following.
	 *   - file: Optional. The generated file this source map is associated with.
	 *   - sections: A list of section definitions.
	 *
	 * Each value under the "sections" field has two fields:
	 *   - offset: The offset into the original specified at which this section
	 *       begins to apply, defined as an object with a "line" and "column"
	 *       field.
	 *   - map: A source map definition. This source map could also be indexed,
	 *       but doesn't have to be.
	 *
	 * Instead of the "map" field, it's also possible to have a "url" field
	 * specifying a URL to retrieve a source map from, but that's currently
	 * unsupported.
	 *
	 * Here's an example source map, taken from the source map spec[0], but
	 * modified to omit a section which uses the "url" field.
	 *
	 *  {
	 *    version : 3,
	 *    file: "app.js",
	 *    sections: [{
	 *      offset: {line:100, column:10},
	 *      map: {
	 *        version : 3,
	 *        file: "section.js",
	 *        sources: ["foo.js", "bar.js"],
	 *        names: ["src", "maps", "are", "fun"],
	 *        mappings: "AAAA,E;;ABCDE;"
	 *      }
	 *    }],
	 *  }
	 *
	 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
	 */
	function IndexedSourceMapConsumer(aSourceMap) {
	  var sourceMap = aSourceMap;
	  if (typeof aSourceMap === 'string') {
	    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
	  }
	
	  var version = util.getArg(sourceMap, 'version');
	  var sections = util.getArg(sourceMap, 'sections');
	
	  if (version != this._version) {
	    throw new Error('Unsupported version: ' + version);
	  }
	
	  this._sources = new ArraySet();
	  this._names = new ArraySet();
	
	  var lastOffset = {
	    line: -1,
	    column: 0
	  };
	  this._sections = sections.map(function (s) {
	    if (s.url) {
	      // The url field will require support for asynchronicity.
	      // See https://github.com/mozilla/source-map/issues/16
	      throw new Error('Support for url field in sections not implemented.');
	    }
	    var offset = util.getArg(s, 'offset');
	    var offsetLine = util.getArg(offset, 'line');
	    var offsetColumn = util.getArg(offset, 'column');
	
	    if (offsetLine < lastOffset.line ||
	        (offsetLine === lastOffset.line && offsetColumn < lastOffset.column)) {
	      throw new Error('Section offsets must be ordered and non-overlapping.');
	    }
	    lastOffset = offset;
	
	    return {
	      generatedOffset: {
	        // The offset fields are 0-based, but we use 1-based indices when
	        // encoding/decoding from VLQ.
	        generatedLine: offsetLine + 1,
	        generatedColumn: offsetColumn + 1
	      },
	      consumer: new SourceMapConsumer(util.getArg(s, 'map'))
	    }
	  });
	}
	
	IndexedSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
	IndexedSourceMapConsumer.prototype.constructor = SourceMapConsumer;
	
	/**
	 * The version of the source mapping spec that we are consuming.
	 */
	IndexedSourceMapConsumer.prototype._version = 3;
	
	/**
	 * The list of original sources.
	 */
	Object.defineProperty(IndexedSourceMapConsumer.prototype, 'sources', {
	  get: function () {
	    var sources = [];
	    for (var i = 0; i < this._sections.length; i++) {
	      for (var j = 0; j < this._sections[i].consumer.sources.length; j++) {
	        sources.push(this._sections[i].consumer.sources[j]);
	      }
	    }
	    return sources;
	  }
	});
	
	/**
	 * Returns the original source, line, and column information for the generated
	 * source's line and column positions provided. The only argument is an object
	 * with the following properties:
	 *
	 *   - line: The line number in the generated source.
	 *   - column: The column number in the generated source.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - source: The original source file, or null.
	 *   - line: The line number in the original source, or null.
	 *   - column: The column number in the original source, or null.
	 *   - name: The original identifier, or null.
	 */
	IndexedSourceMapConsumer.prototype.originalPositionFor =
	  function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
	    var needle = {
	      generatedLine: util.getArg(aArgs, 'line'),
	      generatedColumn: util.getArg(aArgs, 'column')
	    };
	
	    // Find the section containing the generated position we're trying to map
	    // to an original position.
	    var sectionIndex = binarySearch.search(needle, this._sections,
	      function(needle, section) {
	        var cmp = needle.generatedLine - section.generatedOffset.generatedLine;
	        if (cmp) {
	          return cmp;
	        }
	
	        return (needle.generatedColumn -
	                section.generatedOffset.generatedColumn);
	      });
	    var section = this._sections[sectionIndex];
	
	    if (!section) {
	      return {
	        source: null,
	        line: null,
	        column: null,
	        name: null
	      };
	    }
	
	    return section.consumer.originalPositionFor({
	      line: needle.generatedLine -
	        (section.generatedOffset.generatedLine - 1),
	      column: needle.generatedColumn -
	        (section.generatedOffset.generatedLine === needle.generatedLine
	         ? section.generatedOffset.generatedColumn - 1
	         : 0),
	      bias: aArgs.bias
	    });
	  };
	
	/**
	 * Return true if we have the source content for every source in the source
	 * map, false otherwise.
	 */
	IndexedSourceMapConsumer.prototype.hasContentsOfAllSources =
	  function IndexedSourceMapConsumer_hasContentsOfAllSources() {
	    return this._sections.every(function (s) {
	      return s.consumer.hasContentsOfAllSources();
	    });
	  };
	
	/**
	 * Returns the original source content. The only argument is the url of the
	 * original source file. Returns null if no original source content is
	 * available.
	 */
	IndexedSourceMapConsumer.prototype.sourceContentFor =
	  function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
	    for (var i = 0; i < this._sections.length; i++) {
	      var section = this._sections[i];
	
	      var content = section.consumer.sourceContentFor(aSource, true);
	      if (content) {
	        return content;
	      }
	    }
	    if (nullOnMissing) {
	      return null;
	    }
	    else {
	      throw new Error('"' + aSource + '" is not in the SourceMap.');
	    }
	  };
	
	/**
	 * Returns the generated line and column information for the original source,
	 * line, and column positions provided. The only argument is an object with
	 * the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.
	 *   - column: The column number in the original source.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.
	 *   - column: The column number in the generated source, or null.
	 */
	IndexedSourceMapConsumer.prototype.generatedPositionFor =
	  function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
	    for (var i = 0; i < this._sections.length; i++) {
	      var section = this._sections[i];
	
	      // Only consider this section if the requested source is in the list of
	      // sources of the consumer.
	      if (section.consumer.sources.indexOf(util.getArg(aArgs, 'source')) === -1) {
	        continue;
	      }
	      var generatedPosition = section.consumer.generatedPositionFor(aArgs);
	      if (generatedPosition) {
	        var ret = {
	          line: generatedPosition.line +
	            (section.generatedOffset.generatedLine - 1),
	          column: generatedPosition.column +
	            (section.generatedOffset.generatedLine === generatedPosition.line
	             ? section.generatedOffset.generatedColumn - 1
	             : 0)
	        };
	        return ret;
	      }
	    }
	
	    return {
	      line: null,
	      column: null
	    };
	  };
	
	/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */
	IndexedSourceMapConsumer.prototype._parseMappings =
	  function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
	    this.__generatedMappings = [];
	    this.__originalMappings = [];
	    for (var i = 0; i < this._sections.length; i++) {
	      var section = this._sections[i];
	      var sectionMappings = section.consumer._generatedMappings;
	      for (var j = 0; j < sectionMappings.length; j++) {
	        var mapping = sectionMappings[j];
	
	        var source = section.consumer._sources.at(mapping.source);
	        if (section.consumer.sourceRoot !== null) {
	          source = util.join(section.consumer.sourceRoot, source);
	        }
	        this._sources.add(source);
	        source = this._sources.indexOf(source);
	
	        var name = section.consumer._names.at(mapping.name);
	        this._names.add(name);
	        name = this._names.indexOf(name);
	
	        // The mappings coming from the consumer for the section have
	        // generated positions relative to the start of the section, so we
	        // need to offset them to be relative to the start of the concatenated
	        // generated file.
	        var adjustedMapping = {
	          source: source,
	          generatedLine: mapping.generatedLine +
	            (section.generatedOffset.generatedLine - 1),
	          generatedColumn: mapping.generatedColumn +
	            (section.generatedOffset.generatedLine === mapping.generatedLine
	            ? section.generatedOffset.generatedColumn - 1
	            : 0),
	          originalLine: mapping.originalLine,
	          originalColumn: mapping.originalColumn,
	          name: name
	        };
	
	        this.__generatedMappings.push(adjustedMapping);
	        if (typeof adjustedMapping.originalLine === 'number') {
	          this.__originalMappings.push(adjustedMapping);
	        }
	      }
	    }
	
	    quickSort(this.__generatedMappings, util.compareByGeneratedPositionsDeflated);
	    quickSort(this.__originalMappings, util.compareByOriginalPositions);
	  };
	
	exports.IndexedSourceMapConsumer = IndexedSourceMapConsumer;


/***/ },
/* 1716 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var SourceMapGenerator = __webpack_require__(551).SourceMapGenerator;
	var util = __webpack_require__(178);
	
	// Matches a Windows-style `\r\n` newline or a `\n` newline used by all other
	// operating systems these days (capturing the result).
	var REGEX_NEWLINE = /(\r?\n)/;
	
	// Newline character code for charCodeAt() comparisons
	var NEWLINE_CODE = 10;
	
	// Private symbol for identifying `SourceNode`s when multiple versions of
	// the source-map library are loaded. This MUST NOT CHANGE across
	// versions!
	var isSourceNode = "$$$isSourceNode$$$";
	
	/**
	 * SourceNodes provide a way to abstract over interpolating/concatenating
	 * snippets of generated JavaScript source code while maintaining the line and
	 * column information associated with the original source code.
	 *
	 * @param aLine The original line number.
	 * @param aColumn The original column number.
	 * @param aSource The original source's filename.
	 * @param aChunks Optional. An array of strings which are snippets of
	 *        generated JS, or other SourceNodes.
	 * @param aName The original identifier.
	 */
	function SourceNode(aLine, aColumn, aSource, aChunks, aName) {
	  this.children = [];
	  this.sourceContents = {};
	  this.line = aLine == null ? null : aLine;
	  this.column = aColumn == null ? null : aColumn;
	  this.source = aSource == null ? null : aSource;
	  this.name = aName == null ? null : aName;
	  this[isSourceNode] = true;
	  if (aChunks != null) this.add(aChunks);
	}
	
	/**
	 * Creates a SourceNode from generated code and a SourceMapConsumer.
	 *
	 * @param aGeneratedCode The generated code
	 * @param aSourceMapConsumer The SourceMap for the generated code
	 * @param aRelativePath Optional. The path that relative sources in the
	 *        SourceMapConsumer should be relative to.
	 */
	SourceNode.fromStringWithSourceMap =
	  function SourceNode_fromStringWithSourceMap(aGeneratedCode, aSourceMapConsumer, aRelativePath) {
	    // The SourceNode we want to fill with the generated code
	    // and the SourceMap
	    var node = new SourceNode();
	
	    // All even indices of this array are one line of the generated code,
	    // while all odd indices are the newlines between two adjacent lines
	    // (since `REGEX_NEWLINE` captures its match).
	    // Processed fragments are accessed by calling `shiftNextLine`.
	    var remainingLines = aGeneratedCode.split(REGEX_NEWLINE);
	    var remainingLinesIndex = 0;
	    var shiftNextLine = function() {
	      var lineContents = getNextLine();
	      // The last line of a file might not have a newline.
	      var newLine = getNextLine() || "";
	      return lineContents + newLine;
	
	      function getNextLine() {
	        return remainingLinesIndex < remainingLines.length ?
	            remainingLines[remainingLinesIndex++] : undefined;
	      }
	    };
	
	    // We need to remember the position of "remainingLines"
	    var lastGeneratedLine = 1, lastGeneratedColumn = 0;
	
	    // The generate SourceNodes we need a code range.
	    // To extract it current and last mapping is used.
	    // Here we store the last mapping.
	    var lastMapping = null;
	
	    aSourceMapConsumer.eachMapping(function (mapping) {
	      if (lastMapping !== null) {
	        // We add the code from "lastMapping" to "mapping":
	        // First check if there is a new line in between.
	        if (lastGeneratedLine < mapping.generatedLine) {
	          // Associate first line with "lastMapping"
	          addMappingWithCode(lastMapping, shiftNextLine());
	          lastGeneratedLine++;
	          lastGeneratedColumn = 0;
	          // The remaining code is added without mapping
	        } else {
	          // There is no new line in between.
	          // Associate the code between "lastGeneratedColumn" and
	          // "mapping.generatedColumn" with "lastMapping"
	          var nextLine = remainingLines[remainingLinesIndex];
	          var code = nextLine.substr(0, mapping.generatedColumn -
	                                        lastGeneratedColumn);
	          remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn -
	                                              lastGeneratedColumn);
	          lastGeneratedColumn = mapping.generatedColumn;
	          addMappingWithCode(lastMapping, code);
	          // No more remaining code, continue
	          lastMapping = mapping;
	          return;
	        }
	      }
	      // We add the generated code until the first mapping
	      // to the SourceNode without any mapping.
	      // Each line is added as separate string.
	      while (lastGeneratedLine < mapping.generatedLine) {
	        node.add(shiftNextLine());
	        lastGeneratedLine++;
	      }
	      if (lastGeneratedColumn < mapping.generatedColumn) {
	        var nextLine = remainingLines[remainingLinesIndex];
	        node.add(nextLine.substr(0, mapping.generatedColumn));
	        remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn);
	        lastGeneratedColumn = mapping.generatedColumn;
	      }
	      lastMapping = mapping;
	    }, this);
	    // We have processed all mappings.
	    if (remainingLinesIndex < remainingLines.length) {
	      if (lastMapping) {
	        // Associate the remaining code in the current line with "lastMapping"
	        addMappingWithCode(lastMapping, shiftNextLine());
	      }
	      // and add the remaining lines without any mapping
	      node.add(remainingLines.splice(remainingLinesIndex).join(""));
	    }
	
	    // Copy sourcesContent into SourceNode
	    aSourceMapConsumer.sources.forEach(function (sourceFile) {
	      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
	      if (content != null) {
	        if (aRelativePath != null) {
	          sourceFile = util.join(aRelativePath, sourceFile);
	        }
	        node.setSourceContent(sourceFile, content);
	      }
	    });
	
	    return node;
	
	    function addMappingWithCode(mapping, code) {
	      if (mapping === null || mapping.source === undefined) {
	        node.add(code);
	      } else {
	        var source = aRelativePath
	          ? util.join(aRelativePath, mapping.source)
	          : mapping.source;
	        node.add(new SourceNode(mapping.originalLine,
	                                mapping.originalColumn,
	                                source,
	                                code,
	                                mapping.name));
	      }
	    }
	  };
	
	/**
	 * Add a chunk of generated JS to this source node.
	 *
	 * @param aChunk A string snippet of generated JS code, another instance of
	 *        SourceNode, or an array where each member is one of those things.
	 */
	SourceNode.prototype.add = function SourceNode_add(aChunk) {
	  if (Array.isArray(aChunk)) {
	    aChunk.forEach(function (chunk) {
	      this.add(chunk);
	    }, this);
	  }
	  else if (aChunk[isSourceNode] || typeof aChunk === "string") {
	    if (aChunk) {
	      this.children.push(aChunk);
	    }
	  }
	  else {
	    throw new TypeError(
	      "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
	    );
	  }
	  return this;
	};
	
	/**
	 * Add a chunk of generated JS to the beginning of this source node.
	 *
	 * @param aChunk A string snippet of generated JS code, another instance of
	 *        SourceNode, or an array where each member is one of those things.
	 */
	SourceNode.prototype.prepend = function SourceNode_prepend(aChunk) {
	  if (Array.isArray(aChunk)) {
	    for (var i = aChunk.length-1; i >= 0; i--) {
	      this.prepend(aChunk[i]);
	    }
	  }
	  else if (aChunk[isSourceNode] || typeof aChunk === "string") {
	    this.children.unshift(aChunk);
	  }
	  else {
	    throw new TypeError(
	      "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
	    );
	  }
	  return this;
	};
	
	/**
	 * Walk over the tree of JS snippets in this node and its children. The
	 * walking function is called once for each snippet of JS and is passed that
	 * snippet and the its original associated source's line/column location.
	 *
	 * @param aFn The traversal function.
	 */
	SourceNode.prototype.walk = function SourceNode_walk(aFn) {
	  var chunk;
	  for (var i = 0, len = this.children.length; i < len; i++) {
	    chunk = this.children[i];
	    if (chunk[isSourceNode]) {
	      chunk.walk(aFn);
	    }
	    else {
	      if (chunk !== '') {
	        aFn(chunk, { source: this.source,
	                     line: this.line,
	                     column: this.column,
	                     name: this.name });
	      }
	    }
	  }
	};
	
	/**
	 * Like `String.prototype.join` except for SourceNodes. Inserts `aStr` between
	 * each of `this.children`.
	 *
	 * @param aSep The separator.
	 */
	SourceNode.prototype.join = function SourceNode_join(aSep) {
	  var newChildren;
	  var i;
	  var len = this.children.length;
	  if (len > 0) {
	    newChildren = [];
	    for (i = 0; i < len-1; i++) {
	      newChildren.push(this.children[i]);
	      newChildren.push(aSep);
	    }
	    newChildren.push(this.children[i]);
	    this.children = newChildren;
	  }
	  return this;
	};
	
	/**
	 * Call String.prototype.replace on the very right-most source snippet. Useful
	 * for trimming whitespace from the end of a source node, etc.
	 *
	 * @param aPattern The pattern to replace.
	 * @param aReplacement The thing to replace the pattern with.
	 */
	SourceNode.prototype.replaceRight = function SourceNode_replaceRight(aPattern, aReplacement) {
	  var lastChild = this.children[this.children.length - 1];
	  if (lastChild[isSourceNode]) {
	    lastChild.replaceRight(aPattern, aReplacement);
	  }
	  else if (typeof lastChild === 'string') {
	    this.children[this.children.length - 1] = lastChild.replace(aPattern, aReplacement);
	  }
	  else {
	    this.children.push(''.replace(aPattern, aReplacement));
	  }
	  return this;
	};
	
	/**
	 * Set the source content for a source file. This will be added to the SourceMapGenerator
	 * in the sourcesContent field.
	 *
	 * @param aSourceFile The filename of the source file
	 * @param aSourceContent The content of the source file
	 */
	SourceNode.prototype.setSourceContent =
	  function SourceNode_setSourceContent(aSourceFile, aSourceContent) {
	    this.sourceContents[util.toSetString(aSourceFile)] = aSourceContent;
	  };
	
	/**
	 * Walk over the tree of SourceNodes. The walking function is called for each
	 * source file content and is passed the filename and source content.
	 *
	 * @param aFn The traversal function.
	 */
	SourceNode.prototype.walkSourceContents =
	  function SourceNode_walkSourceContents(aFn) {
	    for (var i = 0, len = this.children.length; i < len; i++) {
	      if (this.children[i][isSourceNode]) {
	        this.children[i].walkSourceContents(aFn);
	      }
	    }
	
	    var sources = Object.keys(this.sourceContents);
	    for (var i = 0, len = sources.length; i < len; i++) {
	      aFn(util.fromSetString(sources[i]), this.sourceContents[sources[i]]);
	    }
	  };
	
	/**
	 * Return the string representation of this source node. Walks over the tree
	 * and concatenates all the various snippets together to one string.
	 */
	SourceNode.prototype.toString = function SourceNode_toString() {
	  var str = "";
	  this.walk(function (chunk) {
	    str += chunk;
	  });
	  return str;
	};
	
	/**
	 * Returns the string representation of this source node along with a source
	 * map.
	 */
	SourceNode.prototype.toStringWithSourceMap = function SourceNode_toStringWithSourceMap(aArgs) {
	  var generated = {
	    code: "",
	    line: 1,
	    column: 0
	  };
	  var map = new SourceMapGenerator(aArgs);
	  var sourceMappingActive = false;
	  var lastOriginalSource = null;
	  var lastOriginalLine = null;
	  var lastOriginalColumn = null;
	  var lastOriginalName = null;
	  this.walk(function (chunk, original) {
	    generated.code += chunk;
	    if (original.source !== null
	        && original.line !== null
	        && original.column !== null) {
	      if(lastOriginalSource !== original.source
	         || lastOriginalLine !== original.line
	         || lastOriginalColumn !== original.column
	         || lastOriginalName !== original.name) {
	        map.addMapping({
	          source: original.source,
	          original: {
	            line: original.line,
	            column: original.column
	          },
	          generated: {
	            line: generated.line,
	            column: generated.column
	          },
	          name: original.name
	        });
	      }
	      lastOriginalSource = original.source;
	      lastOriginalLine = original.line;
	      lastOriginalColumn = original.column;
	      lastOriginalName = original.name;
	      sourceMappingActive = true;
	    } else if (sourceMappingActive) {
	      map.addMapping({
	        generated: {
	          line: generated.line,
	          column: generated.column
	        }
	      });
	      lastOriginalSource = null;
	      sourceMappingActive = false;
	    }
	    for (var idx = 0, length = chunk.length; idx < length; idx++) {
	      if (chunk.charCodeAt(idx) === NEWLINE_CODE) {
	        generated.line++;
	        generated.column = 0;
	        // Mappings end at eol
	        if (idx + 1 === length) {
	          lastOriginalSource = null;
	          sourceMappingActive = false;
	        } else if (sourceMappingActive) {
	          map.addMapping({
	            source: original.source,
	            original: {
	              line: original.line,
	              column: original.column
	            },
	            generated: {
	              line: generated.line,
	              column: generated.column
	            },
	            name: original.name
	          });
	        }
	      } else {
	        generated.column++;
	      }
	    }
	  });
	  this.walkSourceContents(function (sourceFile, sourceContent) {
	    map.setSourceContent(sourceFile, sourceContent);
	  });
	
	  return { code: generated.code, map: map };
	};
	
	exports.SourceNode = SourceNode;


/***/ },
/* 1717 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 1718 */
[1784, 352],
/* 1719 */
/***/ function(module, exports) {

	'use strict';
	module.exports = false;


/***/ },
/* 1720 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(1721);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(138)(module)))

/***/ },
/* 1721 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 1722 */
/***/ function(module, exports) {

	function E () {
	  // Keep this empty so it's easier to inherit from
	  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
	}
	
	E.prototype = {
	  on: function (name, callback, ctx) {
	    var e = this.e || (this.e = {});
	
	    (e[name] || (e[name] = [])).push({
	      fn: callback,
	      ctx: ctx
	    });
	
	    return this;
	  },
	
	  once: function (name, callback, ctx) {
	    var self = this;
	    function listener () {
	      self.off(name, listener);
	      callback.apply(ctx, arguments);
	    };
	
	    listener._ = callback
	    return this.on(name, listener, ctx);
	  },
	
	  emit: function (name) {
	    var data = [].slice.call(arguments, 1);
	    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
	    var i = 0;
	    var len = evtArr.length;
	
	    for (i; i < len; i++) {
	      evtArr[i].fn.apply(evtArr[i].ctx, data);
	    }
	
	    return this;
	  },
	
	  off: function (name, callback) {
	    var e = this.e || (this.e = {});
	    var evts = e[name];
	    var liveEvents = [];
	
	    if (evts && callback) {
	      for (var i = 0, len = evts.length; i < len; i++) {
	        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
	          liveEvents.push(evts[i]);
	      }
	    }
	
	    // Remove event from queue to prevent memory leak
	    // Suggested by https://github.com/lazd
	    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
	
	    (liveEvents.length)
	      ? e[name] = liveEvents
	      : delete e[name];
	
	    return this;
	  }
	};
	
	module.exports = E;
	module.exports.TinyEmitter = E;


/***/ },
/* 1723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createUncontrollable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(1724);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function createUncontrollable(mixin, set) {
	
	  return uncontrollable;
	
	  function uncontrollable(Component, controlledValues) {
	    var _class, _temp;
	
	    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    var displayName = Component.displayName || Component.name || 'Component',
	        basePropTypes = utils.getType(Component).propTypes,
	        isCompositeComponent = utils.isReactComponent(Component),
	        controlledProps = Object.keys(controlledValues),
	        propTypes;
	
	    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));
	
	    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);
	
	    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));
	
	    methods = utils.transform(methods, function (obj, method) {
	      obj[method] = function () {
	        var _refs$inner;
	
	        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
	      };
	    }, {});
	
	    var component = (_temp = _class = function (_React$Component) {
	      _inherits(component, _React$Component);
	
	      function component() {
	        _classCallCheck(this, component);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	      }
	
	      component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
	      };
	
	      component.prototype.componentWillMount = function componentWillMount() {
	        var _this2 = this;
	
	        var props = this.props;
	
	        this._values = {};
	
	        controlledProps.forEach(function (key) {
	          _this2._values[key] = props[utils.defaultKey(key)];
	        });
	      };
	
	      /**
	       * If a prop switches from controlled to Uncontrolled
	       * reset its value to the defaultValue
	       */
	
	
	      component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        var _this3 = this;
	
	        var props = this.props;
	
	        if (mixin.componentWillReceiveProps) {
	          mixin.componentWillReceiveProps.call(this, nextProps);
	        }
	
	        controlledProps.forEach(function (key) {
	          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
	            _this3._values[key] = nextProps[utils.defaultKey(key)];
	          }
	        });
	      };
	
	      component.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.unmounted = true;
	      };
	
	      component.prototype.getControlledInstance = function getControlledInstance() {
	        return this.refs.inner;
	      };
	
	      component.prototype.render = function render() {
	        var _this4 = this;
	
	        var newProps = {},
	            props = omitProps(this.props);
	
	        utils.each(controlledValues, function (handle, propName) {
	          var linkPropName = utils.getLinkName(propName),
	              prop = _this4.props[propName];
	
	          if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
	            prop = _this4.props[linkPropName].value;
	          }
	
	          newProps[propName] = prop !== undefined ? prop : _this4._values[propName];
	
	          newProps[handle] = setAndNotify.bind(_this4, propName);
	        });
	
	        newProps = _extends({}, props, newProps, {
	          ref: isCompositeComponent ? 'inner' : null
	        });
	
	        return _react2.default.createElement(Component, newProps);
	      };
	
	      return component;
	    }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);
	
	    _extends(component.prototype, methods);
	
	    component.ControlledComponent = Component;
	
	    /**
	     * useful when wrapping a Component and you want to control
	     * everything
	     */
	    component.deferControlTo = function (newComponent) {
	      var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var nextMethods = arguments[2];
	
	      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
	    };
	
	    return component;
	
	    function setAndNotify(propName, value) {
	      var linkName = utils.getLinkName(propName),
	          handler = this.props[controlledValues[propName]];
	
	      if (linkName && isProp(this.props, linkName) && !handler) {
	        handler = this.props[linkName].requestChange;
	      }
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      set(this, propName, handler, value, args);
	    }
	
	    function isProp(props, prop) {
	      return props[prop] !== undefined;
	    }
	
	    function omitProps(props) {
	      var result = {};
	
	      utils.each(props, function (value, key) {
	        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
	      });
	
	      return result;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.version = undefined;
	exports.uncontrolledPropTypes = uncontrolledPropTypes;
	exports.getType = getType;
	exports.getValue = getValue;
	exports.getLinkName = getLinkName;
	exports.defaultKey = defaultKey;
	exports.chain = chain;
	exports.transform = transform;
	exports.each = each;
	exports.has = has;
	exports.isReactComponent = isReactComponent;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function readOnlyPropType(handler, name) {
	  return function (props, propName) {
	    if (props[propName] !== undefined) {
	      if (!props[handler]) {
	        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
	      }
	    }
	  };
	}
	
	function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
	  var propTypes = {};
	
	  if (false) {
	    transform(controlledValues, function (obj, handler, prop) {
	      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);
	
	      obj[prop] = readOnlyPropType(handler, displayName);
	    }, propTypes);
	  }
	
	  return propTypes;
	}
	
	var version = exports.version = _react2.default.version.split('.').map(parseFloat);
	
	function getType(component) {
	  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;
	
	  return component.type;
	}
	
	function getValue(props, name) {
	  var linkPropName = getLinkName(name);
	
	  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;
	
	  return props[name];
	}
	
	function isProp(props, prop) {
	  return props[prop] !== undefined;
	}
	
	function getLinkName(name) {
	  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
	}
	
	function defaultKey(key) {
	  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
	}
	
	function chain(thisArg, a, b) {
	  return function chainedFunction() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    a && a.call.apply(a, [thisArg].concat(args));
	    b && b.call.apply(b, [thisArg].concat(args));
	  };
	}
	
	function transform(obj, cb, seed) {
	  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
	  return seed;
	}
	
	function each(obj, cb, thisArg) {
	  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
	
	  for (var key in obj) {
	    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
	  }
	}
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	function isReactComponent(component) {
	  return !!(component && component.prototype && component.prototype.isReactComponent);
	}

/***/ },
/* 1725 */
/***/ function(module, exports) {

	// Copyright 2014 Google Inc. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	//     You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	//     See the License for the specific language governing permissions and
	// limitations under the License.
	
	!function(){var a={},b={};!function(a,b){function c(a){if("number"==typeof a)return a;var b={};for(var c in a)b[c]=a[c];return b}function d(){this._delay=0,this._endDelay=0,this._fill="none",this._iterationStart=0,this._iterations=1,this._duration=0,this._playbackRate=1,this._direction="normal",this._easing="linear",this._easingFunction=x}function e(){return a.isDeprecated("Invalid timing inputs","2016-03-02","TypeError exceptions will be thrown instead.",!0)}function f(b,c,e){var f=new d;return c&&(f.fill="both",f.duration="auto"),"number"!=typeof b||isNaN(b)?void 0!==b&&Object.getOwnPropertyNames(b).forEach(function(c){if("auto"!=b[c]){if(("number"==typeof f[c]||"duration"==c)&&("number"!=typeof b[c]||isNaN(b[c])))return;if("fill"==c&&-1==v.indexOf(b[c]))return;if("direction"==c&&-1==w.indexOf(b[c]))return;if("playbackRate"==c&&1!==b[c]&&a.isDeprecated("AnimationEffectTiming.playbackRate","2014-11-28","Use Animation.playbackRate instead."))return;f[c]=b[c]}}):f.duration=b,f}function g(a){return"number"==typeof a&&(a=isNaN(a)?{duration:0}:{duration:a}),a}function h(b,c){return b=a.numericTimingToObject(b),f(b,c)}function i(a,b,c,d){return a<0||a>1||c<0||c>1?x:function(e){function f(a,b,c){return 3*a*(1-c)*(1-c)*c+3*b*(1-c)*c*c+c*c*c}if(e<=0){var g=0;return a>0?g=b/a:!b&&c>0&&(g=d/c),g*e}if(e>=1){var h=0;return c<1?h=(d-1)/(c-1):1==c&&a<1&&(h=(b-1)/(a-1)),1+h*(e-1)}for(var i=0,j=1;i<j;){var k=(i+j)/2,l=f(a,c,k);if(Math.abs(e-l)<1e-5)return f(b,d,k);l<e?i=k:j=k}return f(b,d,k)}}function j(a,b){return function(c){if(c>=1)return 1;var d=1/a;return(c+=b*d)-c%d}}function k(a){C||(C=document.createElement("div").style),C.animationTimingFunction="",C.animationTimingFunction=a;var b=C.animationTimingFunction;if(""==b&&e())throw new TypeError(a+" is not a valid value for easing");return b}function l(a){if("linear"==a)return x;var b=E.exec(a);if(b)return i.apply(this,b.slice(1).map(Number));var c=F.exec(a);if(c)return j(Number(c[1]),A);var d=G.exec(a);return d?j(Number(d[1]),{start:y,middle:z,end:A}[d[2]]):B[a]||x}function m(a){return Math.abs(n(a)/a.playbackRate)}function n(a){return 0===a.duration||0===a.iterations?0:a.duration*a.iterations}function o(a,b,c){if(null==b)return H;var d=c.delay+a+c.endDelay;return b<Math.min(c.delay,d)?I:b>=Math.min(c.delay+a,d)?J:K}function p(a,b,c,d,e){switch(d){case I:return"backwards"==b||"both"==b?0:null;case K:return c-e;case J:return"forwards"==b||"both"==b?a:null;case H:return null}}function q(a,b,c,d,e){var f=e;return 0===a?b!==I&&(f+=c):f+=d/a,f}function r(a,b,c,d,e,f){var g=a===1/0?b%1:a%1;return 0!==g||c!==J||0===d||0===e&&0!==f||(g=1),g}function s(a,b,c,d){return a===J&&b===1/0?1/0:1===c?Math.floor(d)-1:Math.floor(d)}function t(a,b,c){var d=a;if("normal"!==a&&"reverse"!==a){var e=b;"alternate-reverse"===a&&(e+=1),d="normal",e!==1/0&&e%2!=0&&(d="reverse")}return"normal"===d?c:1-c}function u(a,b,c){var d=o(a,b,c),e=p(a,c.fill,b,d,c.delay);if(null===e)return null;var f=q(c.duration,d,c.iterations,e,c.iterationStart),g=r(f,c.iterationStart,d,c.iterations,e,c.duration),h=s(d,c.iterations,g,f),i=t(c.direction,h,g);return c._easingFunction(i)}var v="backwards|forwards|both|none".split("|"),w="reverse|alternate|alternate-reverse".split("|"),x=function(a){return a};d.prototype={_setMember:function(b,c){this["_"+b]=c,this._effect&&(this._effect._timingInput[b]=c,this._effect._timing=a.normalizeTimingInput(this._effect._timingInput),this._effect.activeDuration=a.calculateActiveDuration(this._effect._timing),this._effect._animation&&this._effect._animation._rebuildUnderlyingAnimation())},get playbackRate(){return this._playbackRate},set delay(a){this._setMember("delay",a)},get delay(){return this._delay},set endDelay(a){this._setMember("endDelay",a)},get endDelay(){return this._endDelay},set fill(a){this._setMember("fill",a)},get fill(){return this._fill},set iterationStart(a){if((isNaN(a)||a<0)&&e())throw new TypeError("iterationStart must be a non-negative number, received: "+a);this._setMember("iterationStart",a)},get iterationStart(){return this._iterationStart},set duration(a){if("auto"!=a&&(isNaN(a)||a<0)&&e())throw new TypeError("duration must be non-negative or auto, received: "+a);this._setMember("duration",a)},get duration(){return this._duration},set direction(a){this._setMember("direction",a)},get direction(){return this._direction},set easing(a){this._easingFunction=l(k(a)),this._setMember("easing",a)},get easing(){return this._easing},set iterations(a){if((isNaN(a)||a<0)&&e())throw new TypeError("iterations must be non-negative, received: "+a);this._setMember("iterations",a)},get iterations(){return this._iterations}};var y=1,z=.5,A=0,B={ease:i(.25,.1,.25,1),"ease-in":i(.42,0,1,1),"ease-out":i(0,0,.58,1),"ease-in-out":i(.42,0,.58,1),"step-start":j(1,y),"step-middle":j(1,z),"step-end":j(1,A)},C=null,D="\\s*(-?\\d+\\.?\\d*|-?\\.\\d+)\\s*",E=new RegExp("cubic-bezier\\("+D+","+D+","+D+","+D+"\\)"),F=/steps\(\s*(\d+)\s*\)/,G=/steps\(\s*(\d+)\s*,\s*(start|middle|end)\s*\)/,H=0,I=1,J=2,K=3;a.cloneTimingInput=c,a.makeTiming=f,a.numericTimingToObject=g,a.normalizeTimingInput=h,a.calculateActiveDuration=m,a.calculateIterationProgress=u,a.calculatePhase=o,a.normalizeEasing=k,a.parseEasingFunction=l}(a),function(a,b){function c(a,b){return a in k?k[a][b]||b:b}function d(a){return"display"===a||0===a.lastIndexOf("animation",0)||0===a.lastIndexOf("transition",0)}function e(a,b,e){if(!d(a)){var f=h[a];if(f){i.style[a]=b;for(var g in f){var j=f[g],k=i.style[j];e[j]=c(j,k)}}else e[a]=c(a,b)}}function f(a){var b=[];for(var c in a)if(!(c in["easing","offset","composite"])){var d=a[c];Array.isArray(d)||(d=[d]);for(var e,f=d.length,g=0;g<f;g++)e={},e.offset="offset"in a?a.offset:1==f?1:g/(f-1),"easing"in a&&(e.easing=a.easing),"composite"in a&&(e.composite=a.composite),e[c]=d[g],b.push(e)}return b.sort(function(a,b){return a.offset-b.offset}),b}function g(b){function c(){var a=d.length;null==d[a-1].offset&&(d[a-1].offset=1),a>1&&null==d[0].offset&&(d[0].offset=0);for(var b=0,c=d[0].offset,e=1;e<a;e++){var f=d[e].offset;if(null!=f){for(var g=1;g<e-b;g++)d[b+g].offset=c+(f-c)*g/(e-b);b=e,c=f}}}if(null==b)return[];window.Symbol&&Symbol.iterator&&Array.prototype.from&&b[Symbol.iterator]&&(b=Array.from(b)),Array.isArray(b)||(b=f(b));for(var d=b.map(function(b){var c={};for(var d in b){var f=b[d];if("offset"==d){if(null!=f){if(f=Number(f),!isFinite(f))throw new TypeError("Keyframe offsets must be numbers.");if(f<0||f>1)throw new TypeError("Keyframe offsets must be between 0 and 1.")}}else if("composite"==d){if("add"==f||"accumulate"==f)throw{type:DOMException.NOT_SUPPORTED_ERR,name:"NotSupportedError",message:"add compositing is not supported"};if("replace"!=f)throw new TypeError("Invalid composite mode "+f+".")}else f="easing"==d?a.normalizeEasing(f):""+f;e(d,f,c)}return void 0==c.offset&&(c.offset=null),void 0==c.easing&&(c.easing="linear"),c}),g=!0,h=-1/0,i=0;i<d.length;i++){var j=d[i].offset;if(null!=j){if(j<h)throw new TypeError("Keyframes are not loosely sorted by offset. Sort or specify offsets.");h=j}else g=!1}return d=d.filter(function(a){return a.offset>=0&&a.offset<=1}),g||c(),d}var h={background:["backgroundImage","backgroundPosition","backgroundSize","backgroundRepeat","backgroundAttachment","backgroundOrigin","backgroundClip","backgroundColor"],border:["borderTopColor","borderTopStyle","borderTopWidth","borderRightColor","borderRightStyle","borderRightWidth","borderBottomColor","borderBottomStyle","borderBottomWidth","borderLeftColor","borderLeftStyle","borderLeftWidth"],borderBottom:["borderBottomWidth","borderBottomStyle","borderBottomColor"],borderColor:["borderTopColor","borderRightColor","borderBottomColor","borderLeftColor"],borderLeft:["borderLeftWidth","borderLeftStyle","borderLeftColor"],borderRadius:["borderTopLeftRadius","borderTopRightRadius","borderBottomRightRadius","borderBottomLeftRadius"],borderRight:["borderRightWidth","borderRightStyle","borderRightColor"],borderTop:["borderTopWidth","borderTopStyle","borderTopColor"],borderWidth:["borderTopWidth","borderRightWidth","borderBottomWidth","borderLeftWidth"],flex:["flexGrow","flexShrink","flexBasis"],font:["fontFamily","fontSize","fontStyle","fontVariant","fontWeight","lineHeight"],margin:["marginTop","marginRight","marginBottom","marginLeft"],outline:["outlineColor","outlineStyle","outlineWidth"],padding:["paddingTop","paddingRight","paddingBottom","paddingLeft"]},i=document.createElementNS("http://www.w3.org/1999/xhtml","div"),j={thin:"1px",medium:"3px",thick:"5px"},k={borderBottomWidth:j,borderLeftWidth:j,borderRightWidth:j,borderTopWidth:j,fontSize:{"xx-small":"60%","x-small":"75%",small:"89%",medium:"100%",large:"120%","x-large":"150%","xx-large":"200%"},fontWeight:{normal:"400",bold:"700"},outlineWidth:j,textShadow:{none:"0px 0px 0px transparent"},boxShadow:{none:"0px 0px 0px 0px transparent"}};a.convertToArrayForm=f,a.normalizeKeyframes=g}(a),function(a){var b={};a.isDeprecated=function(a,c,d,e){var f=e?"are":"is",g=new Date,h=new Date(c);return h.setMonth(h.getMonth()+3),!(g<h&&(a in b||console.warn("Web Animations: "+a+" "+f+" deprecated and will stop working on "+h.toDateString()+". "+d),b[a]=!0,1))},a.deprecated=function(b,c,d,e){var f=e?"are":"is";if(a.isDeprecated(b,c,d,e))throw new Error(b+" "+f+" no longer supported. "+d)}}(a),function(){if(document.documentElement.animate){var c=document.documentElement.animate([],0),d=!0;if(c&&(d=!1,"play|currentTime|pause|reverse|playbackRate|cancel|finish|startTime|playState".split("|").forEach(function(a){void 0===c[a]&&(d=!0)})),!d)return}!function(a,b,c){function d(a){for(var b={},c=0;c<a.length;c++)for(var d in a[c])if("offset"!=d&&"easing"!=d&&"composite"!=d){var e={offset:a[c].offset,easing:a[c].easing,value:a[c][d]};b[d]=b[d]||[],b[d].push(e)}for(var f in b){var g=b[f];if(0!=g[0].offset||1!=g[g.length-1].offset)throw{type:DOMException.NOT_SUPPORTED_ERR,name:"NotSupportedError",message:"Partial keyframes are not supported"}}return b}function e(c){var d=[];for(var e in c)for(var f=c[e],g=0;g<f.length-1;g++){var h=g,i=g+1,j=f[h].offset,k=f[i].offset,l=j,m=k;0==g&&(l=-1/0,0==k&&(i=h)),g==f.length-2&&(m=1/0,1==j&&(h=i)),d.push({applyFrom:l,applyTo:m,startOffset:f[h].offset,endOffset:f[i].offset,easingFunction:a.parseEasingFunction(f[h].easing),property:e,interpolation:b.propertyInterpolation(e,f[h].value,f[i].value)})}return d.sort(function(a,b){return a.startOffset-b.startOffset}),d}b.convertEffectInput=function(c){var f=a.normalizeKeyframes(c),g=d(f),h=e(g);return function(a,c){if(null!=c)h.filter(function(a){return c>=a.applyFrom&&c<a.applyTo}).forEach(function(d){var e=c-d.startOffset,f=d.endOffset-d.startOffset,g=0==f?0:d.easingFunction(e/f);b.apply(a,d.property,d.interpolation(g))});else for(var d in g)"offset"!=d&&"easing"!=d&&"composite"!=d&&b.clear(a,d)}}}(a,b),function(a,b,c){function d(a){return a.replace(/-(.)/g,function(a,b){return b.toUpperCase()})}function e(a,b,c){h[c]=h[c]||[],h[c].push([a,b])}function f(a,b,c){for(var f=0;f<c.length;f++){e(a,b,d(c[f]))}}function g(c,e,f){var g=c;/-/.test(c)&&!a.isDeprecated("Hyphenated property names","2016-03-22","Use camelCase instead.",!0)&&(g=d(c)),"initial"!=e&&"initial"!=f||("initial"==e&&(e=i[g]),"initial"==f&&(f=i[g]));for(var j=e==f?[]:h[g],k=0;j&&k<j.length;k++){var l=j[k][0](e),m=j[k][0](f);if(void 0!==l&&void 0!==m){var n=j[k][1](l,m);if(n){var o=b.Interpolation.apply(null,n);return function(a){return 0==a?e:1==a?f:o(a)}}}}return b.Interpolation(!1,!0,function(a){return a?f:e})}var h={};b.addPropertiesHandler=f;var i={backgroundColor:"transparent",backgroundPosition:"0% 0%",borderBottomColor:"currentColor",borderBottomLeftRadius:"0px",borderBottomRightRadius:"0px",borderBottomWidth:"3px",borderLeftColor:"currentColor",borderLeftWidth:"3px",borderRightColor:"currentColor",borderRightWidth:"3px",borderSpacing:"2px",borderTopColor:"currentColor",borderTopLeftRadius:"0px",borderTopRightRadius:"0px",borderTopWidth:"3px",bottom:"auto",clip:"rect(0px, 0px, 0px, 0px)",color:"black",fontSize:"100%",fontWeight:"400",height:"auto",left:"auto",letterSpacing:"normal",lineHeight:"120%",marginBottom:"0px",marginLeft:"0px",marginRight:"0px",marginTop:"0px",maxHeight:"none",maxWidth:"none",minHeight:"0px",minWidth:"0px",opacity:"1.0",outlineColor:"invert",outlineOffset:"0px",outlineWidth:"3px",paddingBottom:"0px",paddingLeft:"0px",paddingRight:"0px",paddingTop:"0px",right:"auto",strokeDasharray:"none",strokeDashoffset:"0px",textIndent:"0px",textShadow:"0px 0px 0px transparent",top:"auto",transform:"",verticalAlign:"0px",visibility:"visible",width:"auto",wordSpacing:"normal",zIndex:"auto"};b.propertyInterpolation=g}(a,b),function(a,b,c){function d(b){var c=a.calculateActiveDuration(b),d=function(d){return a.calculateIterationProgress(c,d,b)};return d._totalDuration=b.delay+c+b.endDelay,d}b.KeyframeEffect=function(c,e,f,g){var h,i=d(a.normalizeTimingInput(f)),j=b.convertEffectInput(e),k=function(){j(c,h)};return k._update=function(a){return null!==(h=i(a))},k._clear=function(){j(c,null)},k._hasSameTarget=function(a){return c===a},k._target=c,k._totalDuration=i._totalDuration,k._id=g,k}}(a,b),function(a,b){function c(a,b){return!(!b.namespaceURI||-1==b.namespaceURI.indexOf("/svg"))&&(g in a||(a[g]=/Trident|MSIE|IEMobile|Edge|Android 4/i.test(a.navigator.userAgent)),a[g])}function d(a,b,c){c.enumerable=!0,c.configurable=!0,Object.defineProperty(a,b,c)}function e(a){this._element=a,this._surrogateStyle=document.createElementNS("http://www.w3.org/1999/xhtml","div").style,this._style=a.style,this._length=0,this._isAnimatedProperty={},this._updateSvgTransformAttr=c(window,a),this._savedTransformAttr=null;for(var b=0;b<this._style.length;b++){var d=this._style[b];this._surrogateStyle[d]=this._style[d]}this._updateIndices()}function f(a){if(!a._webAnimationsPatchedStyle){var b=new e(a);try{d(a,"style",{get:function(){return b}})}catch(b){a.style._set=function(b,c){a.style[b]=c},a.style._clear=function(b){a.style[b]=""}}a._webAnimationsPatchedStyle=a.style}}var g="_webAnimationsUpdateSvgTransformAttr",h={cssText:1,length:1,parentRule:1},i={getPropertyCSSValue:1,getPropertyPriority:1,getPropertyValue:1,item:1,removeProperty:1,setProperty:1},j={removeProperty:1,setProperty:1};e.prototype={get cssText(){return this._surrogateStyle.cssText},set cssText(a){for(var b={},c=0;c<this._surrogateStyle.length;c++)b[this._surrogateStyle[c]]=!0;this._surrogateStyle.cssText=a,this._updateIndices();for(var c=0;c<this._surrogateStyle.length;c++)b[this._surrogateStyle[c]]=!0;for(var d in b)this._isAnimatedProperty[d]||this._style.setProperty(d,this._surrogateStyle.getPropertyValue(d))},get length(){return this._surrogateStyle.length},get parentRule(){return this._style.parentRule},_updateIndices:function(){for(;this._length<this._surrogateStyle.length;)Object.defineProperty(this,this._length,{configurable:!0,enumerable:!1,get:function(a){return function(){return this._surrogateStyle[a]}}(this._length)}),this._length++;for(;this._length>this._surrogateStyle.length;)this._length--,Object.defineProperty(this,this._length,{configurable:!0,enumerable:!1,value:void 0})},_set:function(b,c){this._style[b]=c,this._isAnimatedProperty[b]=!0,this._updateSvgTransformAttr&&"transform"==a.unprefixedPropertyName(b)&&(null==this._savedTransformAttr&&(this._savedTransformAttr=this._element.getAttribute("transform")),this._element.setAttribute("transform",a.transformToSvgMatrix(c)))},_clear:function(b){this._style[b]=this._surrogateStyle[b],this._updateSvgTransformAttr&&"transform"==a.unprefixedPropertyName(b)&&(this._savedTransformAttr?this._element.setAttribute("transform",this._savedTransformAttr):this._element.removeAttribute("transform"),this._savedTransformAttr=null),delete this._isAnimatedProperty[b]}};for(var k in i)e.prototype[k]=function(a,b){return function(){var c=this._surrogateStyle[a].apply(this._surrogateStyle,arguments);return b&&(this._isAnimatedProperty[arguments[0]]||this._style[a].apply(this._style,arguments),this._updateIndices()),c}}(k,k in j);for(var l in document.documentElement.style)l in h||l in i||function(a){d(e.prototype,a,{get:function(){return this._surrogateStyle[a]},set:function(b){this._surrogateStyle[a]=b,this._updateIndices(),this._isAnimatedProperty[a]||(this._style[a]=b)}})}(l);a.apply=function(b,c,d){f(b),b.style._set(a.propertyName(c),d)},a.clear=function(b,c){b._webAnimationsPatchedStyle&&b.style._clear(a.propertyName(c))}}(b),function(a){window.Element.prototype.animate=function(b,c){var d="";return c&&c.id&&(d=c.id),a.timeline._play(a.KeyframeEffect(this,b,c,d))}}(b),function(a,b){function c(a,b,d){if("number"==typeof a&&"number"==typeof b)return a*(1-d)+b*d;if("boolean"==typeof a&&"boolean"==typeof b)return d<.5?a:b;if(a.length==b.length){for(var e=[],f=0;f<a.length;f++)e.push(c(a[f],b[f],d));return e}throw"Mismatched interpolation arguments "+a+":"+b}a.Interpolation=function(a,b,d){return function(e){return d(c(a,b,e))}}}(b),function(a,b){function c(a,b,c){return Math.max(Math.min(a,c),b)}function d(b,d,e){var f=a.dot(b,d);f=c(f,-1,1);var g=[];if(1===f)g=b;else for(var h=Math.acos(f),i=1*Math.sin(e*h)/Math.sqrt(1-f*f),j=0;j<4;j++)g.push(b[j]*(Math.cos(e*h)-f*i)+d[j]*i);return g}var e=function(){function a(a,b){for(var c=[[0,0,0,0],[0,0,0,0],[0,0,0,0],[0,0,0,0]],d=0;d<4;d++)for(var e=0;e<4;e++)for(var f=0;f<4;f++)c[d][e]+=b[d][f]*a[f][e];return c}function b(a){return 0==a[0][2]&&0==a[0][3]&&0==a[1][2]&&0==a[1][3]&&0==a[2][0]&&0==a[2][1]&&1==a[2][2]&&0==a[2][3]&&0==a[3][2]&&1==a[3][3]}function c(c,d,e,f,g){for(var h=[[1,0,0,0],[0,1,0,0],[0,0,1,0],[0,0,0,1]],i=0;i<4;i++)h[i][3]=g[i];for(var i=0;i<3;i++)for(var j=0;j<3;j++)h[3][i]+=c[j]*h[j][i];var k=f[0],l=f[1],m=f[2],n=f[3],o=[[1,0,0,0],[0,1,0,0],[0,0,1,0],[0,0,0,1]];o[0][0]=1-2*(l*l+m*m),o[0][1]=2*(k*l-m*n),o[0][2]=2*(k*m+l*n),o[1][0]=2*(k*l+m*n),o[1][1]=1-2*(k*k+m*m),o[1][2]=2*(l*m-k*n),o[2][0]=2*(k*m-l*n),o[2][1]=2*(l*m+k*n),o[2][2]=1-2*(k*k+l*l),h=a(h,o);var p=[[1,0,0,0],[0,1,0,0],[0,0,1,0],[0,0,0,1]];e[2]&&(p[2][1]=e[2],h=a(h,p)),e[1]&&(p[2][1]=0,p[2][0]=e[0],h=a(h,p)),e[0]&&(p[2][0]=0,p[1][0]=e[0],h=a(h,p));for(var i=0;i<3;i++)for(var j=0;j<3;j++)h[i][j]*=d[i];return b(h)?[h[0][0],h[0][1],h[1][0],h[1][1],h[3][0],h[3][1]]:h[0].concat(h[1],h[2],h[3])}return c}();a.composeMatrix=e,a.quat=d}(b),function(a,b,c){a.sequenceNumber=0;var d=function(a,b,c){this.target=a,this.currentTime=b,this.timelineTime=c,this.type="finish",this.bubbles=!1,this.cancelable=!1,this.currentTarget=a,this.defaultPrevented=!1,this.eventPhase=Event.AT_TARGET,this.timeStamp=Date.now()};b.Animation=function(b){this.id="",b&&b._id&&(this.id=b._id),this._sequenceNumber=a.sequenceNumber++,this._currentTime=0,this._startTime=null,this._paused=!1,this._playbackRate=1,this._inTimeline=!0,this._finishedFlag=!0,this.onfinish=null,this._finishHandlers=[],this._effect=b,this._inEffect=this._effect._update(0),this._idle=!0,this._currentTimePending=!1},b.Animation.prototype={_ensureAlive:function(){this.playbackRate<0&&0===this.currentTime?this._inEffect=this._effect._update(-1):this._inEffect=this._effect._update(this.currentTime),this._inTimeline||!this._inEffect&&this._finishedFlag||(this._inTimeline=!0,b.timeline._animations.push(this))},_tickCurrentTime:function(a,b){a!=this._currentTime&&(this._currentTime=a,this._isFinished&&!b&&(this._currentTime=this._playbackRate>0?this._totalDuration:0),this._ensureAlive())},get currentTime(){return this._idle||this._currentTimePending?null:this._currentTime},set currentTime(a){a=+a,isNaN(a)||(b.restart(),this._paused||null==this._startTime||(this._startTime=this._timeline.currentTime-a/this._playbackRate),this._currentTimePending=!1,this._currentTime!=a&&(this._idle&&(this._idle=!1,this._paused=!0),this._tickCurrentTime(a,!0),b.applyDirtiedAnimation(this)))},get startTime(){return this._startTime},set startTime(a){a=+a,isNaN(a)||this._paused||this._idle||(this._startTime=a,this._tickCurrentTime((this._timeline.currentTime-this._startTime)*this.playbackRate),b.applyDirtiedAnimation(this))},get playbackRate(){return this._playbackRate},set playbackRate(a){if(a!=this._playbackRate){var c=this.currentTime;this._playbackRate=a,this._startTime=null,"paused"!=this.playState&&"idle"!=this.playState&&(this._finishedFlag=!1,this._idle=!1,this._ensureAlive(),b.applyDirtiedAnimation(this)),null!=c&&(this.currentTime=c)}},get _isFinished(){return!this._idle&&(this._playbackRate>0&&this._currentTime>=this._totalDuration||this._playbackRate<0&&this._currentTime<=0)},get _totalDuration(){return this._effect._totalDuration},get playState(){return this._idle?"idle":null==this._startTime&&!this._paused&&0!=this.playbackRate||this._currentTimePending?"pending":this._paused?"paused":this._isFinished?"finished":"running"},_rewind:function(){if(this._playbackRate>=0)this._currentTime=0;else{if(!(this._totalDuration<1/0))throw new DOMException("Unable to rewind negative playback rate animation with infinite duration","InvalidStateError");this._currentTime=this._totalDuration}},play:function(){this._paused=!1,(this._isFinished||this._idle)&&(this._rewind(),this._startTime=null),this._finishedFlag=!1,this._idle=!1,this._ensureAlive(),b.applyDirtiedAnimation(this)},pause:function(){this._isFinished||this._paused||this._idle?this._idle&&(this._rewind(),this._idle=!1):this._currentTimePending=!0,this._startTime=null,this._paused=!0},finish:function(){this._idle||(this.currentTime=this._playbackRate>0?this._totalDuration:0,this._startTime=this._totalDuration-this.currentTime,this._currentTimePending=!1,b.applyDirtiedAnimation(this))},cancel:function(){this._inEffect&&(this._inEffect=!1,this._idle=!0,this._paused=!1,this._finishedFlag=!0,this._currentTime=0,this._startTime=null,this._effect._update(null),b.applyDirtiedAnimation(this))},reverse:function(){this.playbackRate*=-1,this.play()},addEventListener:function(a,b){"function"==typeof b&&"finish"==a&&this._finishHandlers.push(b)},removeEventListener:function(a,b){if("finish"==a){var c=this._finishHandlers.indexOf(b);c>=0&&this._finishHandlers.splice(c,1)}},_fireEvents:function(a){if(this._isFinished){if(!this._finishedFlag){var b=new d(this,this._currentTime,a),c=this._finishHandlers.concat(this.onfinish?[this.onfinish]:[]);setTimeout(function(){c.forEach(function(a){a.call(b.target,b)})},0),this._finishedFlag=!0}}else this._finishedFlag=!1},_tick:function(a,b){this._idle||this._paused||(null==this._startTime?b&&(this.startTime=a-this._currentTime/this.playbackRate):this._isFinished||this._tickCurrentTime((a-this._startTime)*this.playbackRate)),b&&(this._currentTimePending=!1,this._fireEvents(a))},get _needsTick(){return this.playState in{pending:1,running:1}||!this._finishedFlag},_targetAnimations:function(){var a=this._effect._target;return a._activeAnimations||(a._activeAnimations=[]),a._activeAnimations},_markTarget:function(){var a=this._targetAnimations();-1===a.indexOf(this)&&a.push(this)},_unmarkTarget:function(){var a=this._targetAnimations(),b=a.indexOf(this);-1!==b&&a.splice(b,1)}}}(a,b),function(a,b,c){function d(a){var b=j;j=[],a<q.currentTime&&(a=q.currentTime),q._animations.sort(e),q._animations=h(a,!0,q._animations)[0],b.forEach(function(b){b[1](a)}),g(),l=void 0}function e(a,b){return a._sequenceNumber-b._sequenceNumber}function f(){this._animations=[],this.currentTime=window.performance&&performance.now?performance.now():0}function g(){o.forEach(function(a){a()}),o.length=0}function h(a,c,d){p=!0,n=!1,b.timeline.currentTime=a,m=!1;var e=[],f=[],g=[],h=[];return d.forEach(function(b){b._tick(a,c),b._inEffect?(f.push(b._effect),b._markTarget()):(e.push(b._effect),b._unmarkTarget()),b._needsTick&&(m=!0);var d=b._inEffect||b._needsTick;b._inTimeline=d,d?g.push(b):h.push(b)}),o.push.apply(o,e),o.push.apply(o,f),m&&requestAnimationFrame(function(){}),p=!1,[g,h]}var i=window.requestAnimationFrame,j=[],k=0;window.requestAnimationFrame=function(a){var b=k++;return 0==j.length&&i(d),j.push([b,a]),b},window.cancelAnimationFrame=function(a){j.forEach(function(b){b[0]==a&&(b[1]=function(){})})},f.prototype={_play:function(c){c._timing=a.normalizeTimingInput(c.timing);var d=new b.Animation(c);return d._idle=!1,d._timeline=this,this._animations.push(d),b.restart(),b.applyDirtiedAnimation(d),d}};var l=void 0,m=!1,n=!1;b.restart=function(){return m||(m=!0,requestAnimationFrame(function(){}),n=!0),n},b.applyDirtiedAnimation=function(a){if(!p){a._markTarget();var c=a._targetAnimations();c.sort(e),h(b.timeline.currentTime,!1,c.slice())[1].forEach(function(a){var b=q._animations.indexOf(a);-1!==b&&q._animations.splice(b,1)}),g()}};var o=[],p=!1,q=new f;b.timeline=q}(a,b),function(a,b){function c(a,b){for(var c=0,d=0;d<a.length;d++)c+=a[d]*b[d];return c}function d(a,b){return[a[0]*b[0]+a[4]*b[1]+a[8]*b[2]+a[12]*b[3],a[1]*b[0]+a[5]*b[1]+a[9]*b[2]+a[13]*b[3],a[2]*b[0]+a[6]*b[1]+a[10]*b[2]+a[14]*b[3],a[3]*b[0]+a[7]*b[1]+a[11]*b[2]+a[15]*b[3],a[0]*b[4]+a[4]*b[5]+a[8]*b[6]+a[12]*b[7],a[1]*b[4]+a[5]*b[5]+a[9]*b[6]+a[13]*b[7],a[2]*b[4]+a[6]*b[5]+a[10]*b[6]+a[14]*b[7],a[3]*b[4]+a[7]*b[5]+a[11]*b[6]+a[15]*b[7],a[0]*b[8]+a[4]*b[9]+a[8]*b[10]+a[12]*b[11],a[1]*b[8]+a[5]*b[9]+a[9]*b[10]+a[13]*b[11],a[2]*b[8]+a[6]*b[9]+a[10]*b[10]+a[14]*b[11],a[3]*b[8]+a[7]*b[9]+a[11]*b[10]+a[15]*b[11],a[0]*b[12]+a[4]*b[13]+a[8]*b[14]+a[12]*b[15],a[1]*b[12]+a[5]*b[13]+a[9]*b[14]+a[13]*b[15],a[2]*b[12]+a[6]*b[13]+a[10]*b[14]+a[14]*b[15],a[3]*b[12]+a[7]*b[13]+a[11]*b[14]+a[15]*b[15]]}function e(a){var b=a.rad||0;return((a.deg||0)/360+(a.grad||0)/400+(a.turn||0))*(2*Math.PI)+b}function f(a){switch(a.t){case"rotatex":var b=e(a.d[0]);return[1,0,0,0,0,Math.cos(b),Math.sin(b),0,0,-Math.sin(b),Math.cos(b),0,0,0,0,1];case"rotatey":var b=e(a.d[0]);return[Math.cos(b),0,-Math.sin(b),0,0,1,0,0,Math.sin(b),0,Math.cos(b),0,0,0,0,1];case"rotate":case"rotatez":var b=e(a.d[0]);return[Math.cos(b),Math.sin(b),0,0,-Math.sin(b),Math.cos(b),0,0,0,0,1,0,0,0,0,1];case"rotate3d":var c=a.d[0],d=a.d[1],f=a.d[2],b=e(a.d[3]),g=c*c+d*d+f*f;if(0===g)c=1,d=0,f=0;else if(1!==g){var h=Math.sqrt(g);c/=h,d/=h,f/=h}var i=Math.sin(b/2),j=i*Math.cos(b/2),k=i*i;return[1-2*(d*d+f*f)*k,2*(c*d*k+f*j),2*(c*f*k-d*j),0,2*(c*d*k-f*j),1-2*(c*c+f*f)*k,2*(d*f*k+c*j),0,2*(c*f*k+d*j),2*(d*f*k-c*j),1-2*(c*c+d*d)*k,0,0,0,0,1];case"scale":return[a.d[0],0,0,0,0,a.d[1],0,0,0,0,1,0,0,0,0,1];case"scalex":return[a.d[0],0,0,0,0,1,0,0,0,0,1,0,0,0,0,1];case"scaley":return[1,0,0,0,0,a.d[0],0,0,0,0,1,0,0,0,0,1];case"scalez":return[1,0,0,0,0,1,0,0,0,0,a.d[0],0,0,0,0,1];case"scale3d":return[a.d[0],0,0,0,0,a.d[1],0,0,0,0,a.d[2],0,0,0,0,1];case"skew":var l=e(a.d[0]),m=e(a.d[1]);return[1,Math.tan(m),0,0,Math.tan(l),1,0,0,0,0,1,0,0,0,0,1];case"skewx":var b=e(a.d[0]);return[1,0,0,0,Math.tan(b),1,0,0,0,0,1,0,0,0,0,1];case"skewy":var b=e(a.d[0]);return[1,Math.tan(b),0,0,0,1,0,0,0,0,1,0,0,0,0,1];case"translate":var c=a.d[0].px||0,d=a.d[1].px||0;return[1,0,0,0,0,1,0,0,0,0,1,0,c,d,0,1];case"translatex":var c=a.d[0].px||0;return[1,0,0,0,0,1,0,0,0,0,1,0,c,0,0,1];case"translatey":var d=a.d[0].px||0;return[1,0,0,0,0,1,0,0,0,0,1,0,0,d,0,1];case"translatez":var f=a.d[0].px||0;return[1,0,0,0,0,1,0,0,0,0,1,0,0,0,f,1];case"translate3d":var c=a.d[0].px||0,d=a.d[1].px||0,f=a.d[2].px||0;return[1,0,0,0,0,1,0,0,0,0,1,0,c,d,f,1];case"perspective":return[1,0,0,0,0,1,0,0,0,0,1,a.d[0].px?-1/a.d[0].px:0,0,0,0,1];case"matrix":return[a.d[0],a.d[1],0,0,a.d[2],a.d[3],0,0,0,0,1,0,a.d[4],a.d[5],0,1];case"matrix3d":return a.d}}function g(a){return 0===a.length?[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1]:a.map(f).reduce(d)}function h(a){return[i(g(a))]}var i=function(){function a(a){return a[0][0]*a[1][1]*a[2][2]+a[1][0]*a[2][1]*a[0][2]+a[2][0]*a[0][1]*a[1][2]-a[0][2]*a[1][1]*a[2][0]-a[1][2]*a[2][1]*a[0][0]-a[2][2]*a[0][1]*a[1][0]}function b(b){for(var c=1/a(b),d=b[0][0],e=b[0][1],f=b[0][2],g=b[1][0],h=b[1][1],i=b[1][2],j=b[2][0],k=b[2][1],l=b[2][2],m=[[(h*l-i*k)*c,(f*k-e*l)*c,(e*i-f*h)*c,0],[(i*j-g*l)*c,(d*l-f*j)*c,(f*g-d*i)*c,0],[(g*k-h*j)*c,(j*e-d*k)*c,(d*h-e*g)*c,0]],n=[],o=0;o<3;o++){for(var p=0,q=0;q<3;q++)p+=b[3][q]*m[q][o];n.push(p)}return n.push(1),m.push(n),m}function d(a){return[[a[0][0],a[1][0],a[2][0],a[3][0]],[a[0][1],a[1][1],a[2][1],a[3][1]],[a[0][2],a[1][2],a[2][2],a[3][2]],[a[0][3],a[1][3],a[2][3],a[3][3]]]}function e(a,b){for(var c=[],d=0;d<4;d++){for(var e=0,f=0;f<4;f++)e+=a[f]*b[f][d];c.push(e)}return c}function f(a){var b=g(a);return[a[0]/b,a[1]/b,a[2]/b]}function g(a){return Math.sqrt(a[0]*a[0]+a[1]*a[1]+a[2]*a[2])}function h(a,b,c,d){return[c*a[0]+d*b[0],c*a[1]+d*b[1],c*a[2]+d*b[2]]}function i(a,b){return[a[1]*b[2]-a[2]*b[1],a[2]*b[0]-a[0]*b[2],a[0]*b[1]-a[1]*b[0]]}function j(j){var k=[j.slice(0,4),j.slice(4,8),j.slice(8,12),j.slice(12,16)];if(1!==k[3][3])return null;for(var l=[],m=0;m<4;m++)l.push(k[m].slice());for(var m=0;m<3;m++)l[m][3]=0;if(0===a(l))return null;var n,o=[];k[0][3]||k[1][3]||k[2][3]?(o.push(k[0][3]),o.push(k[1][3]),o.push(k[2][3]),o.push(k[3][3]),n=e(o,d(b(l)))):n=[0,0,0,1];var p=k[3].slice(0,3),q=[];q.push(k[0].slice(0,3));var r=[];r.push(g(q[0])),q[0]=f(q[0]);var s=[];q.push(k[1].slice(0,3)),s.push(c(q[0],q[1])),q[1]=h(q[1],q[0],1,-s[0]),r.push(g(q[1])),q[1]=f(q[1]),s[0]/=r[1],q.push(k[2].slice(0,3)),s.push(c(q[0],q[2])),q[2]=h(q[2],q[0],1,-s[1]),s.push(c(q[1],q[2])),q[2]=h(q[2],q[1],1,-s[2]),r.push(g(q[2])),q[2]=f(q[2]),s[1]/=r[2],s[2]/=r[2];var t=i(q[1],q[2]);if(c(q[0],t)<0)for(var m=0;m<3;m++)r[m]*=-1,q[m][0]*=-1,q[m][1]*=-1,q[m][2]*=-1;var u,v,w=q[0][0]+q[1][1]+q[2][2]+1;return w>1e-4?(u=.5/Math.sqrt(w),v=[(q[2][1]-q[1][2])*u,(q[0][2]-q[2][0])*u,(q[1][0]-q[0][1])*u,.25/u]):q[0][0]>q[1][1]&&q[0][0]>q[2][2]?(u=2*Math.sqrt(1+q[0][0]-q[1][1]-q[2][2]),v=[.25*u,(q[0][1]+q[1][0])/u,(q[0][2]+q[2][0])/u,(q[2][1]-q[1][2])/u]):q[1][1]>q[2][2]?(u=2*Math.sqrt(1+q[1][1]-q[0][0]-q[2][2]),v=[(q[0][1]+q[1][0])/u,.25*u,(q[1][2]+q[2][1])/u,(q[0][2]-q[2][0])/u]):(u=2*Math.sqrt(1+q[2][2]-q[0][0]-q[1][1]),v=[(q[0][2]+q[2][0])/u,(q[1][2]+q[2][1])/u,.25*u,(q[1][0]-q[0][1])/u]),[p,r,s,v,n]}return j}();a.dot=c,a.makeMatrixDecomposition=h,a.transformListToMatrix=g}(b),function(a){function b(a,b){var c=a.exec(b);if(c)return c=a.ignoreCase?c[0].toLowerCase():c[0],[c,b.substr(c.length)]}function c(a,b){b=b.replace(/^\s*/,"");var c=a(b);if(c)return[c[0],c[1].replace(/^\s*/,"")]}function d(a,d,e){a=c.bind(null,a);for(var f=[];;){var g=a(e);if(!g)return[f,e];if(f.push(g[0]),e=g[1],!(g=b(d,e))||""==g[1])return[f,e];e=g[1]}}function e(a,b){for(var c=0,d=0;d<b.length&&(!/\s|,/.test(b[d])||0!=c);d++)if("("==b[d])c++;else if(")"==b[d]&&(c--,0==c&&d++,c<=0))break;var e=a(b.substr(0,d));return void 0==e?void 0:[e,b.substr(d)]}function f(a,b){for(var c=a,d=b;c&&d;)c>d?c%=d:d%=c;return c=a*b/(c+d)}function g(a){return function(b){var c=a(b);return c&&(c[0]=void 0),c}}function h(a,b){return function(c){return a(c)||[b,c]}}function i(b,c){for(var d=[],e=0;e<b.length;e++){var f=a.consumeTrimmed(b[e],c);if(!f||""==f[0])return;void 0!==f[0]&&d.push(f[0]),c=f[1]}if(""==c)return d}function j(a,b,c,d,e){for(var g=[],h=[],i=[],j=f(d.length,e.length),k=0;k<j;k++){var l=b(d[k%d.length],e[k%e.length]);if(!l)return;g.push(l[0]),h.push(l[1]),i.push(l[2])}return[g,h,function(b){var d=b.map(function(a,b){return i[b](a)}).join(c);return a?a(d):d}]}function k(a,b,c){for(var d=[],e=[],f=[],g=0,h=0;h<c.length;h++)if("function"==typeof c[h]){var i=c[h](a[g],b[g++]);d.push(i[0]),e.push(i[1]),f.push(i[2])}else!function(a){d.push(!1),e.push(!1),f.push(function(){return c[a]})}(h);return[d,e,function(a){for(var b="",c=0;c<a.length;c++)b+=f[c](a[c]);return b}]}a.consumeToken=b,a.consumeTrimmed=c,a.consumeRepeated=d,a.consumeParenthesised=e,a.ignore=g,a.optional=h,a.consumeList=i,a.mergeNestedRepeated=j.bind(null,null),a.mergeWrappedNestedRepeated=j,a.mergeList=k}(b),function(a){function b(b){function c(b){var c=a.consumeToken(/^inset/i,b);return c?(d.inset=!0,c):(c=a.consumeLengthOrPercent(b))?(d.lengths.push(c[0]),c):(c=a.consumeColor(b),c?(d.color=c[0],c):void 0)}var d={inset:!1,lengths:[],color:null},e=a.consumeRepeated(c,/^/,b);if(e&&e[0].length)return[d,e[1]]}function c(c){var d=a.consumeRepeated(b,/^,/,c);if(d&&""==d[1])return d[0]}function d(b,c){for(;b.lengths.length<Math.max(b.lengths.length,c.lengths.length);)b.lengths.push({px:0});for(;c.lengths.length<Math.max(b.lengths.length,c.lengths.length);)c.lengths.push({px:0});if(b.inset==c.inset&&!!b.color==!!c.color){for(var d,e=[],f=[[],0],g=[[],0],h=0;h<b.lengths.length;h++){var i=a.mergeDimensions(b.lengths[h],c.lengths[h],2==h);f[0].push(i[0]),g[0].push(i[1]),e.push(i[2])}if(b.color&&c.color){var j=a.mergeColors(b.color,c.color);f[1]=j[0],g[1]=j[1],d=j[2]}return[f,g,function(a){for(var c=b.inset?"inset ":" ",f=0;f<e.length;f++)c+=e[f](a[0][f])+" ";return d&&(c+=d(a[1])),c}]}}function e(b,c,d,e){function f(a){return{inset:a,color:[0,0,0,0],lengths:[{px:0},{px:0},{px:0},{px:0}]}}for(var g=[],h=[],i=0;i<d.length||i<e.length;i++){var j=d[i]||f(e[i].inset),k=e[i]||f(d[i].inset);g.push(j),h.push(k)}return a.mergeNestedRepeated(b,c,g,h)}var f=e.bind(null,d,", ");a.addPropertiesHandler(c,f,["box-shadow","text-shadow"])}(b),function(a,b){function c(a){return a.toFixed(3).replace(/0+$/,"").replace(/\.$/,"")}function d(a,b,c){return Math.min(b,Math.max(a,c))}function e(a){if(/^\s*[-+]?(\d*\.)?\d+\s*$/.test(a))return Number(a)}function f(a,b){return[a,b,c]}function g(a,b){if(0!=a)return i(0,1/0)(a,b)}function h(a,b){return[a,b,function(a){return Math.round(d(1,1/0,a))}]}function i(a,b){return function(e,f){return[e,f,function(e){return c(d(a,b,e))}]}}function j(a){var b=a.trim().split(/\s*[\s,]\s*/);if(0!==b.length){for(var c=[],d=0;d<b.length;d++){var f=e(b[d]);if(void 0===f)return;c.push(f)}return c}}function k(a,b){if(a.length==b.length)return[a,b,function(a){return a.map(c).join(" ")}]}function l(a,b){return[a,b,Math.round]}a.clamp=d,a.addPropertiesHandler(j,k,["stroke-dasharray"]),a.addPropertiesHandler(e,i(0,1/0),["border-image-width","line-height"]),a.addPropertiesHandler(e,i(0,1),["opacity","shape-image-threshold"]),a.addPropertiesHandler(e,g,["flex-grow","flex-shrink"]),a.addPropertiesHandler(e,h,["orphans","widows"]),a.addPropertiesHandler(e,l,["z-index"]),a.parseNumber=e,a.parseNumberList=j,a.mergeNumbers=f,a.numberToString=c}(b),function(a,b){function c(a,b){if("visible"==a||"visible"==b)return[0,1,function(c){return c<=0?a:c>=1?b:"visible"}]}a.addPropertiesHandler(String,c,["visibility"])}(b),function(a,b){function c(a){a=a.trim(),f.fillStyle="#000",f.fillStyle=a;var b=f.fillStyle;if(f.fillStyle="#fff",f.fillStyle=a,b==f.fillStyle){f.fillRect(0,0,1,1);var c=f.getImageData(0,0,1,1).data;f.clearRect(0,0,1,1);var d=c[3]/255;return[c[0]*d,c[1]*d,c[2]*d,d]}}function d(b,c){return[b,c,function(b){function c(a){return Math.max(0,Math.min(255,a))}if(b[3])for(var d=0;d<3;d++)b[d]=Math.round(c(b[d]/b[3]));return b[3]=a.numberToString(a.clamp(0,1,b[3])),"rgba("+b.join(",")+")"}]}var e=document.createElementNS("http://www.w3.org/1999/xhtml","canvas");e.width=e.height=1;var f=e.getContext("2d");a.addPropertiesHandler(c,d,["background-color","border-bottom-color","border-left-color","border-right-color","border-top-color","color","fill","flood-color","lighting-color","outline-color","stop-color","stroke","text-decoration-color"]),a.consumeColor=a.consumeParenthesised.bind(null,c),a.mergeColors=d}(b),function(a,b){function c(a){function b(){var b=h.exec(a);g=b?b[0]:void 0}function c(){var a=Number(g);return b(),a}function d(){if("("!==g)return c();b();var a=f();return")"!==g?NaN:(b(),a)}function e(){for(var a=d();"*"===g||"/"===g;){var c=g;b();var e=d();"*"===c?a*=e:a/=e}return a}function f(){for(var a=e();"+"===g||"-"===g;){var c=g;b();var d=e();"+"===c?a+=d:a-=d}return a}var g,h=/([\+\-\w\.]+|[\(\)\*\/])/g;return b(),f()}function d(a,b){if("0"==(b=b.trim().toLowerCase())&&"px".search(a)>=0)return{px:0};if(/^[^(]*$|^calc/.test(b)){b=b.replace(/calc\(/g,"(");var d={};b=b.replace(a,function(a){return d[a]=null,"U"+a});for(var e="U("+a.source+")",f=b.replace(/[-+]?(\d*\.)?\d+([Ee][-+]?\d+)?/g,"N").replace(new RegExp("N"+e,"g"),"D").replace(/\s[+-]\s/g,"O").replace(/\s/g,""),g=[/N\*(D)/g,/(N|D)[*\/]N/g,/(N|D)O\1/g,/\((N|D)\)/g],h=0;h<g.length;)g[h].test(f)?(f=f.replace(g[h],"$1"),h=0):h++;if("D"==f){for(var i in d){var j=c(b.replace(new RegExp("U"+i,"g"),"").replace(new RegExp(e,"g"),"*0"));if(!isFinite(j))return;d[i]=j}return d}}}function e(a,b){return f(a,b,!0)}function f(b,c,d){var e,f=[];for(e in b)f.push(e);for(e in c)f.indexOf(e)<0&&f.push(e);return b=f.map(function(a){return b[a]||0}),c=f.map(function(a){return c[a]||0}),[b,c,function(b){var c=b.map(function(c,e){return 1==b.length&&d&&(c=Math.max(c,0)),a.numberToString(c)+f[e]}).join(" + ");return b.length>1?"calc("+c+")":c}]}var g="px|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc",h=d.bind(null,new RegExp(g,"g")),i=d.bind(null,new RegExp(g+"|%","g")),j=d.bind(null,/deg|rad|grad|turn/g);a.parseLength=h,a.parseLengthOrPercent=i,a.consumeLengthOrPercent=a.consumeParenthesised.bind(null,i),a.parseAngle=j,a.mergeDimensions=f;var k=a.consumeParenthesised.bind(null,h),l=a.consumeRepeated.bind(void 0,k,/^/),m=a.consumeRepeated.bind(void 0,l,/^,/);a.consumeSizePairList=m;var n=function(a){var b=m(a);if(b&&""==b[1])return b[0]},o=a.mergeNestedRepeated.bind(void 0,e," "),p=a.mergeNestedRepeated.bind(void 0,o,",");a.mergeNonNegativeSizePair=o,a.addPropertiesHandler(n,p,["background-size"]),a.addPropertiesHandler(i,e,["border-bottom-width","border-image-width","border-left-width","border-right-width","border-top-width","flex-basis","font-size","height","line-height","max-height","max-width","outline-width","width"]),a.addPropertiesHandler(i,f,["border-bottom-left-radius","border-bottom-right-radius","border-top-left-radius","border-top-right-radius","bottom","left","letter-spacing","margin-bottom","margin-left","margin-right","margin-top","min-height","min-width","outline-offset","padding-bottom","padding-left","padding-right","padding-top","perspective","right","shape-margin","stroke-dashoffset","text-indent","top","vertical-align","word-spacing"])}(b),function(a,b){function c(b){return a.consumeLengthOrPercent(b)||a.consumeToken(/^auto/,b)}function d(b){var d=a.consumeList([a.ignore(a.consumeToken.bind(null,/^rect/)),a.ignore(a.consumeToken.bind(null,/^\(/)),a.consumeRepeated.bind(null,c,/^,/),a.ignore(a.consumeToken.bind(null,/^\)/))],b);if(d&&4==d[0].length)return d[0]}function e(b,c){return"auto"==b||"auto"==c?[!0,!1,function(d){var e=d?b:c;if("auto"==e)return"auto";var f=a.mergeDimensions(e,e);return f[2](f[0])}]:a.mergeDimensions(b,c)}function f(a){return"rect("+a+")"}var g=a.mergeWrappedNestedRepeated.bind(null,f,e,", ");a.parseBox=d,a.mergeBoxes=g,a.addPropertiesHandler(d,g,["clip"])}(b),function(a,b){function c(a){return function(b){var c=0;return a.map(function(a){return a===k?b[c++]:a})}}function d(a){return a}function e(b){if("none"==(b=b.toLowerCase().trim()))return[];for(var c,d=/\s*(\w+)\(([^)]*)\)/g,e=[],f=0;c=d.exec(b);){if(c.index!=f)return;f=c.index+c[0].length;var g=c[1],h=n[g];if(!h)return;var i=c[2].split(","),j=h[0];if(j.length<i.length)return;for(var k=[],o=0;o<j.length;o++){var p,q=i[o],r=j[o];if(void 0===(p=q?{A:function(b){return"0"==b.trim()?m:a.parseAngle(b)},N:a.parseNumber,T:a.parseLengthOrPercent,L:a.parseLength}[r.toUpperCase()](q):{a:m,n:k[0],t:l}[r]))return;k.push(p)}if(e.push({t:g,d:k}),d.lastIndex==b.length)return e}}function f(a){return a.toFixed(6).replace(".000000","")}function g(b,c){if(b.decompositionPair!==c){b.decompositionPair=c;var d=a.makeMatrixDecomposition(b)}if(c.decompositionPair!==b){c.decompositionPair=b;var e=a.makeMatrixDecomposition(c)}return null==d[0]||null==e[0]?[[!1],[!0],function(a){return a?c[0].d:b[0].d}]:(d[0].push(0),e[0].push(1),[d,e,function(b){var c=a.quat(d[0][3],e[0][3],b[5]);return a.composeMatrix(b[0],b[1],b[2],c,b[4]).map(f).join(",")}])}function h(a){return a.replace(/[xy]/,"")}function i(a){return a.replace(/(x|y|z|3d)?$/,"3d")}function j(b,c){var d=a.makeMatrixDecomposition&&!0,e=!1;if(!b.length||!c.length){b.length||(e=!0,b=c,c=[]);for(var f=0;f<b.length;f++){var j=b[f].t,k=b[f].d,l="scale"==j.substr(0,5)?1:0;c.push({t:j,d:k.map(function(a){if("number"==typeof a)return l;var b={};for(var c in a)b[c]=l;return b})})}}var m=function(a,b){return"perspective"==a&&"perspective"==b||("matrix"==a||"matrix3d"==a)&&("matrix"==b||"matrix3d"==b)},o=[],p=[],q=[];if(b.length!=c.length){if(!d)return;var r=g(b,c);o=[r[0]],p=[r[1]],q=[["matrix",[r[2]]]]}else for(var f=0;f<b.length;f++){var j,s=b[f].t,t=c[f].t,u=b[f].d,v=c[f].d,w=n[s],x=n[t];if(m(s,t)){if(!d)return;var r=g([b[f]],[c[f]]);o.push(r[0]),p.push(r[1]),q.push(["matrix",[r[2]]])}else{if(s==t)j=s;else if(w[2]&&x[2]&&h(s)==h(t))j=h(s),u=w[2](u),v=x[2](v);else{if(!w[1]||!x[1]||i(s)!=i(t)){if(!d)return;var r=g(b,c);o=[r[0]],p=[r[1]],q=[["matrix",[r[2]]]];break}j=i(s),u=w[1](u),v=x[1](v)}for(var y=[],z=[],A=[],B=0;B<u.length;B++){var C="number"==typeof u[B]?a.mergeNumbers:a.mergeDimensions,r=C(u[B],v[B]);y[B]=r[0],z[B]=r[1],A.push(r[2])}o.push(y),p.push(z),q.push([j,A])}}if(e){var D=o;o=p,p=D}return[o,p,function(a){return a.map(function(a,b){var c=a.map(function(a,c){return q[b][1][c](a)}).join(",");return"matrix"==q[b][0]&&16==c.split(",").length&&(q[b][0]="matrix3d"),q[b][0]+"("+c+")"}).join(" ")}]}var k=null,l={px:0},m={deg:0},n={matrix:["NNNNNN",[k,k,0,0,k,k,0,0,0,0,1,0,k,k,0,1],d],matrix3d:["NNNNNNNNNNNNNNNN",d],rotate:["A"],rotatex:["A"],rotatey:["A"],rotatez:["A"],rotate3d:["NNNA"],perspective:["L"],scale:["Nn",c([k,k,1]),d],scalex:["N",c([k,1,1]),c([k,1])],scaley:["N",c([1,k,1]),c([1,k])],scalez:["N",c([1,1,k])],scale3d:["NNN",d],skew:["Aa",null,d],skewx:["A",null,c([k,m])],skewy:["A",null,c([m,k])],translate:["Tt",c([k,k,l]),d],translatex:["T",c([k,l,l]),c([k,l])],translatey:["T",c([l,k,l]),c([l,k])],translatez:["L",c([l,l,k])],translate3d:["TTL",d]};a.addPropertiesHandler(e,j,["transform"]),a.transformToSvgMatrix=function(b){var c=a.transformListToMatrix(e(b));return"matrix("+f(c[0])+" "+f(c[1])+" "+f(c[4])+" "+f(c[5])+" "+f(c[12])+" "+f(c[13])+")"}}(b),function(a){function b(a){var b=Number(a);if(!(isNaN(b)||b<100||b>900||b%100!=0))return b}function c(b){return b=100*Math.round(b/100),b=a.clamp(100,900,b),400===b?"normal":700===b?"bold":String(b)}function d(a,b){return[a,b,c]}a.addPropertiesHandler(b,d,["font-weight"])}(b),function(a){function b(a){var b={};for(var c in a)b[c]=-a[c];return b}function c(b){return a.consumeToken(/^(left|center|right|top|bottom)\b/i,b)||a.consumeLengthOrPercent(b)}function d(b,d){var e=a.consumeRepeated(c,/^/,d);if(e&&""==e[1]){var f=e[0];if(f[0]=f[0]||"center",f[1]=f[1]||"center",3==b&&(f[2]=f[2]||{px:0}),f.length==b){if(/top|bottom/.test(f[0])||/left|right/.test(f[1])){var h=f[0];f[0]=f[1],f[1]=h}if(/left|right|center|Object/.test(f[0])&&/top|bottom|center|Object/.test(f[1]))return f.map(function(a){return"object"==typeof a?a:g[a]})}}}function e(d){var e=a.consumeRepeated(c,/^/,d);if(e){for(var f=e[0],h=[{"%":50},{"%":50}],i=0,j=!1,k=0;k<f.length;k++){var l=f[k];"string"==typeof l?(j=/bottom|right/.test(l),i={left:0,right:0,center:i,top:1,bottom:1}[l],h[i]=g[l],"center"==l&&i++):(j&&(l=b(l),l["%"]=(l["%"]||0)+100),h[i]=l,i++,j=!1)}return[h,e[1]]}}function f(b){var c=a.consumeRepeated(e,/^,/,b);if(c&&""==c[1])return c[0]}var g={left:{"%":0},center:{"%":50},right:{"%":100},top:{"%":0},bottom:{"%":100}},h=a.mergeNestedRepeated.bind(null,a.mergeDimensions," ");a.addPropertiesHandler(d.bind(null,3),h,["transform-origin"]),a.addPropertiesHandler(d.bind(null,2),h,["perspective-origin"]),a.consumePosition=e,a.mergeOffsetList=h;var i=a.mergeNestedRepeated.bind(null,h,", ");a.addPropertiesHandler(f,i,["background-position","object-position"])}(b),function(a){function b(b){var c=a.consumeToken(/^circle/,b);if(c&&c[0])return["circle"].concat(a.consumeList([a.ignore(a.consumeToken.bind(void 0,/^\(/)),d,a.ignore(a.consumeToken.bind(void 0,/^at/)),a.consumePosition,a.ignore(a.consumeToken.bind(void 0,/^\)/))],c[1]));var f=a.consumeToken(/^ellipse/,b);if(f&&f[0])return["ellipse"].concat(a.consumeList([a.ignore(a.consumeToken.bind(void 0,/^\(/)),e,a.ignore(a.consumeToken.bind(void 0,/^at/)),a.consumePosition,a.ignore(a.consumeToken.bind(void 0,/^\)/))],f[1]));var g=a.consumeToken(/^polygon/,b);return g&&g[0]?["polygon"].concat(a.consumeList([a.ignore(a.consumeToken.bind(void 0,/^\(/)),a.optional(a.consumeToken.bind(void 0,/^nonzero\s*,|^evenodd\s*,/),"nonzero,"),a.consumeSizePairList,a.ignore(a.consumeToken.bind(void 0,/^\)/))],g[1])):void 0}function c(b,c){if(b[0]===c[0])return"circle"==b[0]?a.mergeList(b.slice(1),c.slice(1),["circle(",a.mergeDimensions," at ",a.mergeOffsetList,")"]):"ellipse"==b[0]?a.mergeList(b.slice(1),c.slice(1),["ellipse(",a.mergeNonNegativeSizePair," at ",a.mergeOffsetList,")"]):"polygon"==b[0]&&b[1]==c[1]?a.mergeList(b.slice(2),c.slice(2),["polygon(",b[1],g,")"]):void 0}var d=a.consumeParenthesised.bind(null,a.parseLengthOrPercent),e=a.consumeRepeated.bind(void 0,d,/^/),f=a.mergeNestedRepeated.bind(void 0,a.mergeDimensions," "),g=a.mergeNestedRepeated.bind(void 0,f,",");a.addPropertiesHandler(b,c,["shape-outside"])}(b),function(a,b){function c(a,b){b.concat([a]).forEach(function(b){b in document.documentElement.style&&(d[a]=b),e[b]=a})}var d={},e={};c("transform",["webkitTransform","msTransform"]),c("transformOrigin",["webkitTransformOrigin"]),c("perspective",["webkitPerspective"]),c("perspectiveOrigin",["webkitPerspectiveOrigin"]),a.propertyName=function(a){return d[a]||a},a.unprefixedPropertyName=function(a){return e[a]||a}}(b)}(),function(){if(void 0===document.createElement("div").animate([]).oncancel){var a;if(window.performance&&performance.now)var a=function(){return performance.now()};else var a=function(){return Date.now()};var b=function(a,b,c){this.target=a,this.currentTime=b,this.timelineTime=c,this.type="cancel",this.bubbles=!1,this.cancelable=!1,this.currentTarget=a,this.defaultPrevented=!1,this.eventPhase=Event.AT_TARGET,this.timeStamp=Date.now()},c=window.Element.prototype.animate;window.Element.prototype.animate=function(d,e){var f=c.call(this,d,e);f._cancelHandlers=[],f.oncancel=null;var g=f.cancel;f.cancel=function(){g.call(this);var c=new b(this,null,a()),d=this._cancelHandlers.concat(this.oncancel?[this.oncancel]:[]);setTimeout(function(){d.forEach(function(a){a.call(c.target,c)})},0)};var h=f.addEventListener;f.addEventListener=function(a,b){"function"==typeof b&&"cancel"==a?this._cancelHandlers.push(b):h.call(this,a,b)};var i=f.removeEventListener;return f.removeEventListener=function(a,b){if("cancel"==a){var c=this._cancelHandlers.indexOf(b);c>=0&&this._cancelHandlers.splice(c,1)}else i.call(this,a,b)},f}}}(),function(a){var b=document.documentElement,c=null,d=!1;try{var e=getComputedStyle(b).getPropertyValue("opacity"),f="0"==e?"1":"0";c=b.animate({opacity:[f,f]},{duration:1}),c.currentTime=0,d=getComputedStyle(b).getPropertyValue("opacity")==f}catch(a){}finally{c&&c.cancel()}if(!d){var g=window.Element.prototype.animate;window.Element.prototype.animate=function(b,c){return window.Symbol&&Symbol.iterator&&Array.prototype.from&&b[Symbol.iterator]&&(b=Array.from(b)),Array.isArray(b)||null===b||(b=a.convertToArrayForm(b)),g.call(this,b,c)}}}(a)}();
	//# sourceMappingURL=web-animations.min.js.map

/***/ },
/* 1726 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./black_cured.png": 994,
		"./black_eradicated.png": 995,
		"./blue_cured.png": 996,
		"./blue_eradicated.png": 997,
		"./city-0.png": 998,
		"./city-1.png": 999,
		"./city-10.png": 1000,
		"./city-11.png": 1001,
		"./city-12.png": 1002,
		"./city-13.png": 1003,
		"./city-14.png": 1004,
		"./city-15.png": 1005,
		"./city-16.png": 1006,
		"./city-17.png": 1007,
		"./city-18.png": 1008,
		"./city-19.png": 1009,
		"./city-2.png": 1010,
		"./city-20.png": 1011,
		"./city-21.png": 1012,
		"./city-22.png": 1013,
		"./city-23.png": 1014,
		"./city-24.png": 1015,
		"./city-25.png": 1016,
		"./city-26.png": 1017,
		"./city-27.png": 1018,
		"./city-28.png": 1019,
		"./city-29.png": 1020,
		"./city-3.png": 1021,
		"./city-30.png": 1022,
		"./city-31.png": 1023,
		"./city-32.png": 1024,
		"./city-33.png": 1025,
		"./city-34.png": 1026,
		"./city-35.png": 1027,
		"./city-36.png": 1028,
		"./city-37.png": 1029,
		"./city-38.png": 1030,
		"./city-39.png": 1031,
		"./city-4.png": 1032,
		"./city-40.png": 1033,
		"./city-41.png": 1034,
		"./city-42.png": 1035,
		"./city-43.png": 1036,
		"./city-44.png": 1037,
		"./city-45.png": 1038,
		"./city-46.png": 1039,
		"./city-47.png": 1040,
		"./city-5.png": 1041,
		"./city-6.png": 1042,
		"./city-7.png": 1043,
		"./city-8.png": 1044,
		"./city-9.png": 1045,
		"./city_sel.png": 1046,
		"./cont_planner.png": 1047,
		"./crosshair.png": 1048,
		"./cube_black.png": 1049,
		"./cube_blue.png": 1050,
		"./cube_red.png": 1051,
		"./cube_yellow.png": 1052,
		"./disease_large_black.png": 1053,
		"./disease_large_blue.png": 1054,
		"./disease_large_red.png": 1055,
		"./disease_large_yellow.png": 1056,
		"./dispatcher.png": 1057,
		"./epidemic.png": 1058,
		"./event-airlift.png": 1059,
		"./event-forecast.png": 1060,
		"./event-gov_grant.png": 1061,
		"./event-one_quiet_night.png": 1062,
		"./event-res_pop.png": 1063,
		"./event.png": 1064,
		"./github.png": 426,
		"./infection_card.png": 1065,
		"./infection_rate.png": 286,
		"./linkedin.png": 427,
		"./map.png": 1066,
		"./map_epidemic.png": 1067,
		"./medic.png": 1068,
		"./ops_expert.png": 1069,
		"./outbreaks.png": 1070,
		"./outbreaks_filled.png": 1071,
		"./outbreaks_shape.png": 1072,
		"./player_card.png": 1073,
		"./quar_spec.png": 1074,
		"./red_cured.png": 1075,
		"./red_eradicated.png": 1076,
		"./researcher.png": 1077,
		"./scientist.png": 1078,
		"./station.png": 1079,
		"./twitter.png": 428,
		"./yellow_cured.png": 1080,
		"./yellow_eradicated.png": 1081
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1726;


/***/ },
/* 1727 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 1728 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 1729 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var toLength = __webpack_require__(__webpack_module_template_argument_1__);
	var toAbsoluteIndex = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 1730 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	var TAG = __webpack_require__(__webpack_module_template_argument_1__)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 1731 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $defineProperty = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 1732 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 1733 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(__webpack_module_template_argument_0__)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 1734 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var document = __webpack_require__(__webpack_module_template_argument_1__).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 1735 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPS = __webpack_require__(__webpack_module_template_argument_1__);
	var pIE = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 1736 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = __webpack_require__(__webpack_module_template_argument_2__) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 1737 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var document = __webpack_require__(__webpack_module_template_argument_0__).document;
	module.exports = document && document.documentElement;


/***/ },
/* 1738 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	module.exports = !__webpack_require__(__webpack_module_template_argument_0__) && !__webpack_require__(__webpack_module_template_argument_1__)(function () {
	  return Object.defineProperty(__webpack_require__(__webpack_module_template_argument_2__)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 1739 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 1740 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 1741 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 1742 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 1743 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var create = __webpack_require__(__webpack_module_template_argument_0__);
	var descriptor = __webpack_require__(__webpack_module_template_argument_1__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_2__);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_3__)(IteratorPrototype, __webpack_require__(__webpack_module_template_argument_4__)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 1744 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var redefine = __webpack_require__(__webpack_module_template_argument_2__);
	var hide = __webpack_require__(__webpack_module_template_argument_3__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_4__);
	var $iterCreate = __webpack_require__(__webpack_module_template_argument_5__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_6__);
	var getPrototypeOf = __webpack_require__(__webpack_module_template_argument_7__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_8__)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 1745 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var ITERATOR = __webpack_require__(__webpack_module_template_argument_0__)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 1746 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var META = __webpack_require__(__webpack_module_template_argument_0__)('meta');
	var isObject = __webpack_require__(__webpack_module_template_argument_1__);
	var has = __webpack_require__(__webpack_module_template_argument_2__);
	var setDesc = __webpack_require__(__webpack_module_template_argument_3__).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(__webpack_module_template_argument_4__)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 1747 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_0__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_1__);
	var gOPS = __webpack_require__(__webpack_module_template_argument_2__);
	var pIE = __webpack_require__(__webpack_module_template_argument_3__);
	var toObject = __webpack_require__(__webpack_module_template_argument_4__);
	var IObject = __webpack_require__(__webpack_module_template_argument_5__);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(__webpack_module_template_argument_6__)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },
/* 1748 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var dPs = __webpack_require__(__webpack_module_template_argument_1__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_2__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(__webpack_module_template_argument_4__)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(__webpack_module_template_argument_5__).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 1749 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_1__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_2__);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 1750 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 1751 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var pIE = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_2__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_3__);
	var has = __webpack_require__(__webpack_module_template_argument_4__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_5__);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_6__) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 1752 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPN = __webpack_require__(__webpack_module_template_argument_1__).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 1753 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var hiddenKeys = __webpack_require__(__webpack_module_template_argument_1__).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 1754 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toObject = __webpack_require__(__webpack_module_template_argument_1__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_2__)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 1755 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_1__);
	var arrayIndexOf = __webpack_require__(__webpack_module_template_argument_2__)(false);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 1756 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 1757 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_0__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_1__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_2__);
	var isEnum = __webpack_require__(__webpack_module_template_argument_3__).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ },
/* 1758 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(__webpack_module_template_argument_2__)(Function.call, __webpack_require__(__webpack_module_template_argument_3__).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 1759 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var def = __webpack_require__(__webpack_module_template_argument_0__).f;
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var TAG = __webpack_require__(__webpack_module_template_argument_2__)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 1760 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var shared = __webpack_require__(__webpack_module_template_argument_0__)('keys');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 1761 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var core = __webpack_require__(__webpack_module_template_argument_0__);
	var global = __webpack_require__(__webpack_module_template_argument_1__);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(__webpack_module_template_argument_2__) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 1762 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 1763 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 1764 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 1765 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 1766 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 1767 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 1768 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var core = __webpack_require__(__webpack_module_template_argument_1__);
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_2__);
	var wksExt = __webpack_require__(__webpack_module_template_argument_3__);
	var defineProperty = __webpack_require__(__webpack_module_template_argument_4__).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 1769 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	exports.f = __webpack_require__(__webpack_module_template_argument_0__);


/***/ },
/* 1770 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var store = __webpack_require__(__webpack_module_template_argument_0__)('wks');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	var Symbol = __webpack_require__(__webpack_module_template_argument_2__).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 1771 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var classof = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = __webpack_require__(__webpack_module_template_argument_3__).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 1772 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var toObject = __webpack_require__(__webpack_module_template_argument_2__);
	var call = __webpack_require__(__webpack_module_template_argument_3__);
	var isArrayIter = __webpack_require__(__webpack_module_template_argument_4__);
	var toLength = __webpack_require__(__webpack_module_template_argument_5__);
	var createProperty = __webpack_require__(__webpack_module_template_argument_6__);
	var getIterFn = __webpack_require__(__webpack_module_template_argument_7__);
	
	$export($export.S + $export.F * !__webpack_require__(__webpack_module_template_argument_8__)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 1773 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var addToUnscopables = __webpack_require__(__webpack_module_template_argument_0__);
	var step = __webpack_require__(__webpack_module_template_argument_1__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_3__);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(__webpack_module_template_argument_4__)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 1774 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(__webpack_module_template_argument_1__) });


/***/ },
/* 1775 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(__webpack_module_template_argument_1__) });


/***/ },
/* 1776 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(__webpack_module_template_argument_1__).set });


/***/ },
/* 1777 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $at = __webpack_require__(__webpack_module_template_argument_0__)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_1__)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 1778 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__, __webpack_module_template_argument_13__, __webpack_module_template_argument_14__, __webpack_module_template_argument_15__, __webpack_module_template_argument_16__, __webpack_module_template_argument_17__, __webpack_module_template_argument_18__, __webpack_module_template_argument_19__, __webpack_module_template_argument_20__, __webpack_module_template_argument_21__, __webpack_module_template_argument_22__, __webpack_module_template_argument_23__, __webpack_module_template_argument_24__, __webpack_module_template_argument_25__, __webpack_module_template_argument_26__, __webpack_module_template_argument_27__, __webpack_module_template_argument_28__, __webpack_module_template_argument_29__, __webpack_module_template_argument_30__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_2__);
	var $export = __webpack_require__(__webpack_module_template_argument_3__);
	var redefine = __webpack_require__(__webpack_module_template_argument_4__);
	var META = __webpack_require__(__webpack_module_template_argument_5__).KEY;
	var $fails = __webpack_require__(__webpack_module_template_argument_6__);
	var shared = __webpack_require__(__webpack_module_template_argument_7__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_8__);
	var uid = __webpack_require__(__webpack_module_template_argument_9__);
	var wks = __webpack_require__(__webpack_module_template_argument_10__);
	var wksExt = __webpack_require__(__webpack_module_template_argument_11__);
	var wksDefine = __webpack_require__(__webpack_module_template_argument_12__);
	var enumKeys = __webpack_require__(__webpack_module_template_argument_13__);
	var isArray = __webpack_require__(__webpack_module_template_argument_14__);
	var anObject = __webpack_require__(__webpack_module_template_argument_15__);
	var isObject = __webpack_require__(__webpack_module_template_argument_16__);
	var toObject = __webpack_require__(__webpack_module_template_argument_17__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_18__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_19__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_20__);
	var _create = __webpack_require__(__webpack_module_template_argument_21__);
	var gOPNExt = __webpack_require__(__webpack_module_template_argument_22__);
	var $GOPD = __webpack_require__(__webpack_module_template_argument_23__);
	var $GOPS = __webpack_require__(__webpack_module_template_argument_24__);
	var $DP = __webpack_require__(__webpack_module_template_argument_25__);
	var $keys = __webpack_require__(__webpack_module_template_argument_26__);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(__webpack_module_template_argument_27__).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(__webpack_module_template_argument_28__).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(__webpack_module_template_argument_29__)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(__webpack_module_template_argument_30__)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 1779 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var $entries = __webpack_require__(__webpack_module_template_argument_1__)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },
/* 1780 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var $values = __webpack_require__(__webpack_module_template_argument_1__)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },
/* 1781 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(__webpack_module_template_argument_0__)('asyncIterator');


/***/ },
/* 1782 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(__webpack_module_template_argument_0__)('observable');


/***/ },
/* 1783 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	var ansiRegex = __webpack_require__(__webpack_module_template_argument_0__);
	var re = new RegExp(ansiRegex().source); // remove the `g` flag
	module.exports = re.test.bind(re);


/***/ },
/* 1784 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	var ansiRegex = __webpack_require__(__webpack_module_template_argument_0__)();
	
	module.exports = function (str) {
		return typeof str === 'string' ? str.replace(ansiRegex, '') : str;
	};


/***/ },
/* 1785 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** bundle.js
 **/